webpackJsonp([0,3],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__("./src/styles/main.scss");
	
	__webpack_require__("./node_modules/meteor-imports-webpack-plugin/meteor-imports.js");
	
	__webpack_require__("./src/universal/collections/simpleSchema.config.js");
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHotLoader = __webpack_require__("./node_modules/react-hot-loader/index.js");
	
	var _immutable = __webpack_require__("./node_modules/immutable/dist/immutable.js");
	
	var _makeStore = __webpack_require__("./src/client/makeStore.js");
	
	var _makeStore2 = _interopRequireDefault(_makeStore);
	
	var _Root = __webpack_require__("./src/client/Root.js");
	
	var _Root2 = _interopRequireDefault(_Root);
	
	__webpack_require__("./src/universal/collections/users/users.js");
	
	__webpack_require__("./src/universal/collections/users/roles/god.js");
	
	__webpack_require__("./src/universal/collections/users/roles/organizer.js");
	
	__webpack_require__("./src/universal/collections/users/roles/partner.js");
	
	__webpack_require__("./src/universal/collections/users/roles/pilot.js");
	
	__webpack_require__("./src/client/userback.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor; /* import main stylesheet */
	
	var Tracker = Package.tracker.Tracker;
	
	
	window.jQuery = __webpack_require__("./node_modules/jquery/dist/jquery.js");
	jQuery("html").addClass("default");
	__webpack_require__("./node_modules/messenger/build/js/messenger.min.js");
	__webpack_require__("./node_modules/messenger/build/js/messenger-theme-future.js");
	__webpack_require__("./node_modules/jquery.kinetic/jquery.kinetic.js");
	__webpack_require__("./node_modules/moment-locale-fr/fr.js");
	__webpack_require__("./node_modules/moment/moment.js").locale('fr');
	
	Messenger.options = {
		'extraClasses': 'messenger-fixed messenger-on-center messenger-on-bottom'
	};
	
	if (false) require('es6-promise').polyfill();
	
	Meteor.startup(function () {
		var router = window.__INITIAL_STATE__.router;
	
		// routing is currently a regualr JS object. This may change in the future
	
		var initialState = (0, _immutable.Map)({
			router: router
		});
	
		var store = (0, _makeStore2.default)(initialState);
		(0, _reactDom.render)(_react2.default.createElement(
			_reactHotLoader.AppContainer,
			{ key: 0 },
			_react2.default.createElement(_Root2.default, { store: store })
		), document.getElementById('root'));
	
		var reloads = 0;
	
		// Hot Module Replacement API
		if (false) {
			module.hot.accept('./Root', function () {
				var Root = require('./Root').default;
				(0, _reactDom.render)(_react2.default.createElement(
					_reactHotLoader.AppContainer,
					{ key: ++reloads },
					_react2.default.createElement(Root, { store: store })
				), document.getElementById('root'));
			});
		}
	});

/***/ },

/***/ "./node_modules/moment-locale-fr/fr.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : french (fr)
	//! author : John Fischer : https://github.com/jfroffice
	
	(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'une année',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : '');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	}));


/***/ },

/***/ "./node_modules/css-loader/index.js!./node_modules/resolve-url-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/styles/main.scss":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	exports.i(__webpack_require__("./node_modules/css-loader/index.js!./node_modules/messenger/build/css/messenger.css"), "");
	exports.i(__webpack_require__("./node_modules/css-loader/index.js!./node_modules/messenger/build/css/messenger-theme-future.css"), "");
	exports.i(__webpack_require__("./node_modules/css-loader/index.js!./node_modules/react-big-calendar/lib/css/react-big-calendar.css"), "");
	
	// module
	exports.push([module.id, "/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}\n\n/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}*,:after,:before{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:transparent}body{font-family:Lato,sans-serif;font-size:14px;line-height:1.78571;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a,a:focus,a:hover{text-decoration:none}a:focus,a:hover{color:#2e6b5e}a:focus{outline:thin dotted;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.img-responsive{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.78571;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:25px;margin-bottom:25px;border:0;border-top:1px solid #eee}.bootstrap-datetimepicker-widget .btn[data-action=clear]:after,.bootstrap-datetimepicker-widget .btn[data-action=decrementHours]:after,.bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]:after,.bootstrap-datetimepicker-widget .btn[data-action=incrementHours]:after,.bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]:after,.bootstrap-datetimepicker-widget .btn[data-action=showHours]:after,.bootstrap-datetimepicker-widget .btn[data-action=showMinutes]:after,.bootstrap-datetimepicker-widget .btn[data-action=today]:after,.bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]:after,.bootstrap-datetimepicker-widget .picker-switch:after,.bootstrap-datetimepicker-widget table th.next:after,.bootstrap-datetimepicker-widget table th.prev:after,.sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:Lato,sans-serif;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:25px;margin-bottom:12.5px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:12.5px;margin-bottom:12.5px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 12.5px}.lead{margin-bottom:25px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:990px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{background-color:#fcf8e3;padding:.2em}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.initialism,.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#428bca}a.text-primary:focus,a.text-primary:hover{color:#3071a9}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#428bca}a.bg-primary:focus,a.bg-primary:hover{background-color:#3071a9}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:11.5px;margin:50px 0 25px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:12.5px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-left:5px;padding-right:5px}dl{margin-top:0;margin-bottom:25px}dd,dt{line-height:1.78571}dt{font-weight:700}dd{margin-left:0}.dl-horizontal dd:after,.dl-horizontal dd:before{content:\" \";display:table}.dl-horizontal dd:after{clear:both}@media (min-width:990px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%}blockquote{padding:12.5px 25px;margin:0 0 25px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.78571;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;border-right:5px solid #eee;border-left:0;text-align:right}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:25px;font-style:normal;line-height:1.78571}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{padding:2px 4px;font-size:90%;color:#c7254e;background-color:#f9f2f4;border-radius:4px;box-shadow:1px 1px rgba(0,0,0,.2)}code[class*=language-],pre[class*=language-]{box-shadow:none}kbd{padding:2px 4px;font-size:90%;color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:12px;margin:0 0 12.5px;font-size:13px;line-height:1.78571;word-break:break-all;word-wrap:break-word;color:#333;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{margin-right:auto;margin-left:auto;padding-left:25px;padding-right:25px}.container:after,.container:before{content:\" \";display:table}.container:after{clear:both}@media (min-width:990px){.container{width:990px}}@media (min-width:1152px){.container{width:990px}}@media (min-width:1366px){.container{width:990px}}.container-fluid{margin-right:auto;margin-left:auto;padding-left:25px;padding-right:25px}.container-fluid:after,.container-fluid:before{content:\" \";display:table}.container-fluid:after{clear:both}.row{margin-left:-25px;margin-right:-25px}.row:after,.row:before{content:\" \";display:table}.row:after{clear:both}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-left:25px;padding-right:25px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-1{width:8.33333%}.col-xs-2{width:16.66667%}.col-xs-3{width:25%}.col-xs-4{width:33.33333%}.col-xs-5{width:41.66667%}.col-xs-6{width:50%}.col-xs-7{width:58.33333%}.col-xs-8{width:66.66667%}.col-xs-9{width:75%}.col-xs-10{width:83.33333%}.col-xs-11{width:91.66667%}.col-xs-12{width:100%}.col-xs-pull-0{right:auto}.col-xs-pull-1{right:8.33333%}.col-xs-pull-2{right:16.66667%}.col-xs-pull-3{right:25%}.col-xs-pull-4{right:33.33333%}.col-xs-pull-5{right:41.66667%}.col-xs-pull-6{right:50%}.col-xs-pull-7{right:58.33333%}.col-xs-pull-8{right:66.66667%}.col-xs-pull-9{right:75%}.col-xs-pull-10{right:83.33333%}.col-xs-pull-11{right:91.66667%}.col-xs-pull-12{right:100%}.col-xs-push-0{left:auto}.col-xs-push-1{left:8.33333%}.col-xs-push-2{left:16.66667%}.col-xs-push-3{left:25%}.col-xs-push-4{left:33.33333%}.col-xs-push-5{left:41.66667%}.col-xs-push-6{left:50%}.col-xs-push-7{left:58.33333%}.col-xs-push-8{left:66.66667%}.col-xs-push-9{left:75%}.col-xs-push-10{left:83.33333%}.col-xs-push-11{left:91.66667%}.col-xs-push-12{left:100%}.col-xs-offset-0{margin-left:0}.col-xs-offset-1{margin-left:8.33333%}.col-xs-offset-2{margin-left:16.66667%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-4{margin-left:33.33333%}.col-xs-offset-5{margin-left:41.66667%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-7{margin-left:58.33333%}.col-xs-offset-8{margin-left:66.66667%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-10{margin-left:83.33333%}.col-xs-offset-11{margin-left:91.66667%}.col-xs-offset-12{margin-left:100%}@media (min-width:990px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-1{width:8.33333%}.col-sm-2{width:16.66667%}.col-sm-3{width:25%}.col-sm-4{width:33.33333%}.col-sm-5{width:41.66667%}.col-sm-6{width:50%}.col-sm-7{width:58.33333%}.col-sm-8{width:66.66667%}.col-sm-9{width:75%}.col-sm-10{width:83.33333%}.col-sm-11{width:91.66667%}.col-sm-12{width:100%}.col-sm-pull-0{right:auto}.col-sm-pull-1{right:8.33333%}.col-sm-pull-2{right:16.66667%}.col-sm-pull-3{right:25%}.col-sm-pull-4{right:33.33333%}.col-sm-pull-5{right:41.66667%}.col-sm-pull-6{right:50%}.col-sm-pull-7{right:58.33333%}.col-sm-pull-8{right:66.66667%}.col-sm-pull-9{right:75%}.col-sm-pull-10{right:83.33333%}.col-sm-pull-11{right:91.66667%}.col-sm-pull-12{right:100%}.col-sm-push-0{left:auto}.col-sm-push-1{left:8.33333%}.col-sm-push-2{left:16.66667%}.col-sm-push-3{left:25%}.col-sm-push-4{left:33.33333%}.col-sm-push-5{left:41.66667%}.col-sm-push-6{left:50%}.col-sm-push-7{left:58.33333%}.col-sm-push-8{left:66.66667%}.col-sm-push-9{left:75%}.col-sm-push-10{left:83.33333%}.col-sm-push-11{left:91.66667%}.col-sm-push-12{left:100%}.col-sm-offset-0{margin-left:0}.col-sm-offset-1{margin-left:8.33333%}.col-sm-offset-2{margin-left:16.66667%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.33333%}.col-sm-offset-5{margin-left:41.66667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-7{margin-left:58.33333%}.col-sm-offset-8{margin-left:66.66667%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.33333%}.col-sm-offset-11{margin-left:91.66667%}.col-sm-offset-12{margin-left:100%}}@media (min-width:1152px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-1{width:8.33333%}.col-md-2{width:16.66667%}.col-md-3{width:25%}.col-md-4{width:33.33333%}.col-md-5{width:41.66667%}.col-md-6{width:50%}.col-md-7{width:58.33333%}.col-md-8{width:66.66667%}.col-md-9{width:75%}.col-md-10{width:83.33333%}.col-md-11{width:91.66667%}.col-md-12{width:100%}.col-md-pull-0{right:auto}.col-md-pull-1{right:8.33333%}.col-md-pull-2{right:16.66667%}.col-md-pull-3{right:25%}.col-md-pull-4{right:33.33333%}.col-md-pull-5{right:41.66667%}.col-md-pull-6{right:50%}.col-md-pull-7{right:58.33333%}.col-md-pull-8{right:66.66667%}.col-md-pull-9{right:75%}.col-md-pull-10{right:83.33333%}.col-md-pull-11{right:91.66667%}.col-md-pull-12{right:100%}.col-md-push-0{left:auto}.col-md-push-1{left:8.33333%}.col-md-push-2{left:16.66667%}.col-md-push-3{left:25%}.col-md-push-4{left:33.33333%}.col-md-push-5{left:41.66667%}.col-md-push-6{left:50%}.col-md-push-7{left:58.33333%}.col-md-push-8{left:66.66667%}.col-md-push-9{left:75%}.col-md-push-10{left:83.33333%}.col-md-push-11{left:91.66667%}.col-md-push-12{left:100%}.col-md-offset-0{margin-left:0}.col-md-offset-1{margin-left:8.33333%}.col-md-offset-2{margin-left:16.66667%}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.33333%}.col-md-offset-5{margin-left:41.66667%}.col-md-offset-6{margin-left:50%}.col-md-offset-7{margin-left:58.33333%}.col-md-offset-8{margin-left:66.66667%}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.33333%}.col-md-offset-11{margin-left:91.66667%}.col-md-offset-12{margin-left:100%}}@media (min-width:1366px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-1{width:8.33333%}.col-lg-2{width:16.66667%}.col-lg-3{width:25%}.col-lg-4{width:33.33333%}.col-lg-5{width:41.66667%}.col-lg-6{width:50%}.col-lg-7{width:58.33333%}.col-lg-8{width:66.66667%}.col-lg-9{width:75%}.col-lg-10{width:83.33333%}.col-lg-11{width:91.66667%}.col-lg-12{width:100%}.col-lg-pull-0{right:auto}.col-lg-pull-1{right:8.33333%}.col-lg-pull-2{right:16.66667%}.col-lg-pull-3{right:25%}.col-lg-pull-4{right:33.33333%}.col-lg-pull-5{right:41.66667%}.col-lg-pull-6{right:50%}.col-lg-pull-7{right:58.33333%}.col-lg-pull-8{right:66.66667%}.col-lg-pull-9{right:75%}.col-lg-pull-10{right:83.33333%}.col-lg-pull-11{right:91.66667%}.col-lg-pull-12{right:100%}.col-lg-push-0{left:auto}.col-lg-push-1{left:8.33333%}.col-lg-push-2{left:16.66667%}.col-lg-push-3{left:25%}.col-lg-push-4{left:33.33333%}.col-lg-push-5{left:41.66667%}.col-lg-push-6{left:50%}.col-lg-push-7{left:58.33333%}.col-lg-push-8{left:66.66667%}.col-lg-push-9{left:75%}.col-lg-push-10{left:83.33333%}.col-lg-push-11{left:91.66667%}.col-lg-push-12{left:100%}.col-lg-offset-0{margin-left:0}.col-lg-offset-1{margin-left:8.33333%}.col-lg-offset-2{margin-left:16.66667%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-4{margin-left:33.33333%}.col-lg-offset-5{margin-left:41.66667%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-7{margin-left:58.33333%}.col-lg-offset-8{margin-left:66.66667%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.33333%}.col-lg-offset-11{margin-left:91.66667%}.col-lg-offset-12{margin-left:100%}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:25px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.78571;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;float:none;display:table-column}table td[class*=col-],table th[class*=col-]{position:static;float:none;display:table-cell}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{overflow-x:auto;min-height:.01%}@media screen and (max-width:989px){.table-responsive{width:100%;margin-bottom:18.75px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}.table-top-align td,.table-top-align th{vertical-align:top!important}.table-middle-align td,.table-middle-align th{vertical-align:middle!important}.table-bottom-align td,.table-bottom-align th{vertical-align:bottom!important}.table-collapsed{margin:0}fieldset{margin:0;min-width:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:25px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:thin dotted;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.78571;color:#555}.form-control{width:100%;height:38px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{border:0;background-color:transparent}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:38px}.input-group-sm>.input-group-btn>input[type=date].btn,.input-group-sm>.input-group-btn>input[type=datetime-local].btn,.input-group-sm>.input-group-btn>input[type=month].btn,.input-group-sm>.input-group-btn>input[type=time].btn,.input-group-sm>input[type=date].form-control,.input-group-sm>input[type=date].input-group-addon,.input-group-sm>input[type=datetime-local].form-control,.input-group-sm>input[type=datetime-local].input-group-addon,.input-group-sm>input[type=month].form-control,.input-group-sm>input[type=month].input-group-addon,.input-group-sm>input[type=time].form-control,.input-group-sm>input[type=time].input-group-addon,.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg>.input-group-btn>input[type=date].btn,.input-group-lg>.input-group-btn>input[type=datetime-local].btn,.input-group-lg>.input-group-btn>input[type=month].btn,.input-group-lg>.input-group-btn>input[type=time].btn,.input-group-lg>input[type=date].form-control,.input-group-lg>input[type=date].input-group-addon,.input-group-lg>input[type=datetime-local].form-control,.input-group-lg>input[type=datetime-local].input-group-addon,.input-group-lg>input[type=month].form-control,.input-group-lg>input[type=month].input-group-addon,.input-group-lg>input[type=time].form-control,.input-group-lg>input[type=time].input-group-addon,.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:25px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-left:-20px;margin-top:4px\\9}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{padding-top:7px;padding-bottom:7px;margin-bottom:0;min-height:39px}.form-control-static.input-lg,.form-control-static.input-sm,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn{padding-left:0;padding-right:0}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn,.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.input-group-sm>.input-group-btn>select.btn,.input-group-sm>select.form-control,.input-group-sm>select.input-group-addon,select.input-sm{height:30px;line-height:30px}.input-group-sm>.input-group-btn>select[multiple].btn,.input-group-sm>.input-group-btn>textarea.btn,.input-group-sm>select[multiple].form-control,.input-group-sm>select[multiple].input-group-addon,.input-group-sm>textarea.form-control,.input-group-sm>textarea.input-group-addon,select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:37px;padding:6px 10px;font-size:12px;line-height:1.5}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.33333;border-radius:6px}.input-group-lg>.input-group-btn>select.btn,.input-group-lg>select.form-control,.input-group-lg>select.input-group-addon,select.input-lg{height:46px;line-height:46px}.input-group-lg>.input-group-btn>select[multiple].btn,.input-group-lg>.input-group-btn>textarea.btn,.input-group-lg>select[multiple].form-control,.input-group-lg>select[multiple].input-group-addon,.input-group-lg>textarea.form-control,.input-group-lg>textarea.input-group-addon,select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.33333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:43px;padding:11px 16px;font-size:18px;line-height:1.33333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:47.5px}.form-control-feedback{position:absolute!important;top:0;right:0;z-index:2;display:block;width:38px;height:38px;line-height:38px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-group-lg>.form-control+.form-control-feedback,.input-group-lg>.input-group-addon+.form-control-feedback,.input-group-lg>.input-group-btn>.btn+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-group-sm>.form-control+.form-control-feedback,.input-group-sm>.input-group-addon+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d!important}.has-success .form-control:focus{border-color:#2b542c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;border-color:#3c763d;background-color:#dff0d8}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b!important}.has-warning .form-control:focus{border-color:#66512c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;border-color:#8a6d3b;background-color:#fcf8e3}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442!important}.has-error .form-control:focus{border-color:#843534;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;border-color:#a94442;background-color:#f2dede}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:30px}.bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=clear]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=decrementHours]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=decrementMinutes]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=incrementHours]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=incrementMinutes]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=showHours]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=showMinutes]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=today]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=togglePeriod]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .has-feedback label.picker-switch:after~.form-control-feedback,.has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=clear]:after~.form-control-feedback,.has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=decrementHours]:after~.form-control-feedback,.has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=decrementMinutes]:after~.form-control-feedback,.has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=incrementHours]:after~.form-control-feedback,.has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=incrementMinutes]:after~.form-control-feedback,.has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=showHours]:after~.form-control-feedback,.has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=showMinutes]:after~.form-control-feedback,.has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=today]:after~.form-control-feedback,.has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=togglePeriod]:after~.form-control-feedback,.has-feedback .bootstrap-datetimepicker-widget label.picker-switch:after~.form-control-feedback,.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:990px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{margin-top:0;margin-bottom:0;padding-top:7px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:32px}.form-horizontal .form-group{margin-left:-25px;margin-right:-25px}.form-horizontal .form-group:after,.form-horizontal .form-group:before{content:\" \";display:table}.form-horizontal .form-group:after{clear:both}@media (min-width:990px){.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px}}.form-horizontal .has-feedback .form-control-feedback{right:25px}@media (min-width:990px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:990px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{height:30px;display:inline-block;margin-bottom:0;font-weight:700;font-family:Lato,sans-serif;text-align:center;vertical-align:middle;letter-spacing:1px;text-transform:uppercase;touch-action:manipulation;cursor:pointer;transition:all .2s;background-image:none;border:2px solid transparent;white-space:nowrap;padding:2px 15px;font-size:12px;line-height:1.78571;border-radius:20px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding-top:3px}.btn.btn-rounded{height:auto;line-height:1;border-radius:100px;padding:15px!important}.btn.btn-onlyOnHover{border-color:#eee}.btn .caret{margin-top:-2px}.btn .rubix-icon{line-height:1;font-size:18px}.btn .rubix-icon~span{vertical-align:top}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:thin dotted;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#b4b7b9;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65)}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-link{color:#89949b;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#2e6b5e;text-decoration:none;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{height:auto;padding:10px 25px;font-size:12px;line-height:normal;border-radius:20px;line-height:21.4285px;padding:10px 25px!important}.btn-group-lg>.btn-rounded.btn,.btn-lg.btn-rounded{line-height:1;padding:25px}.btn-group-sm>.btn,.btn-sm{font-size:10px}.btn-group-sm>.btn,.btn-group-xs>.btn,.btn-sm,.btn-xs{height:auto;padding:2px 15px;line-height:1.5;border-radius:20px}.btn-group-xs>.btn,.btn-xs{font-size:8px}.btn-group-sm>.btn-rounded.btn,.btn-group-xs>.btn-rounded.btn,.btn-rounded.btn.btn-sm,.btn-rounded.btn.btn-xs{padding:15px;line-height:1}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.btn.btn-outlined{outline:none;background:none;padding:3px 15px 2px}.btn.btn-outlined:focus,.btn.btn-outlined:hover{outline:none}.btn.btn-icon{line-height:0;font-size:30px;min-width:45px;min-height:45px;border-radius:100px;width:auto!important;height:auto!important;padding:5px 10px!important}.fade{opacity:0;-webkit-transition:opacity .15s linear;-o-transition:opacity .15s linear;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;-webkit-transition-property:height,visibility;transition-property:height,visibility;-webkit-transition-duration:.35s;transition-duration:.35s;-webkit-transition-timing-function:ease;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:200px;padding:10px 0;overflow:hidden;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175);box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:11.5px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu li>a{display:block;padding:4px 25px;clear:both;border:none;font-weight:400;line-height:1.78571;color:#89949b;white-space:pre-line}.dropdown-menu li>a:focus,.dropdown-menu li>a:hover{text-decoration:none;color:#262626;background-color:hsla(204,3%,72%,.05)}.dropdown-menu .active>a,.dropdown-menu .active>a:focus,.dropdown-menu .active>a:hover{color:#fff;text-decoration:none;outline:0;background-color:#428bca}.dropdown-menu .disabled>a,.dropdown-menu .disabled>a:focus,.dropdown-menu .disabled>a:hover{color:#777}.dropdown-menu .disabled>a:focus,.dropdown-menu .disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:not-allowed}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.dropdown-header{display:block;padding:6px 25px;font-size:10px;text-transform:uppercase;font-weight:700;color:#98a0a3;line-height:1.78571;color:#777;white-space:nowrap;background-color:#f9fafb;border-bottom:1px solid #f2f2f2}.dropdown-header:first-child{margin-top:-10px}.dropdown-backdrop{position:fixed;left:0;right:0;bottom:0;top:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9;content:\"\"}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:990px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{left:0;right:auto}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group-vertical>rubix-button>.btn,.btn-group>.btn,.btn-group>rubix-button>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group-vertical>rubix-button>.btn.active,.btn-group-vertical>rubix-button>.btn:active,.btn-group-vertical>rubix-button>.btn:focus,.btn-group-vertical>rubix-button>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover,.btn-group>rubix-button>.btn.active,.btn-group>rubix-button>.btn:active,.btn-group>rubix-button>.btn:focus,.btn-group>rubix-button>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{position:relative;margin-left:-12.5px}.btn-toolbar:after,.btn-toolbar:before{content:\" \";display:table}.btn-toolbar:after{clear:both}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group,.btn-toolbar>rubix-button-group,.btn-toolbar>rubix-button>.btn,.btn-toolbar>rubix-menu{float:left;margin-left:12.5px}.btn-group>rubix-button{float:left}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle),.btn-group>rubix-button:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>rubix-button:first-child:not(:last-child)>.btn{margin-left:0;border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child),.btn-group>rubix-button:last-child:not(:first-child)>.btn{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group,.btn-group>rubix-menu{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn,.btn-group>rubix-menu:not(:first-child):not(:last-child) .btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle,.btn-group>rubix-menu:first-child:not(:last-child)>.btn:last-child,.btn-group>rubix-menu:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child,.btn-group>rubix-menu:last-child:not(:first-child) .btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px}.btn-group-lg.btn-group>.btn+.dropdown-toggle,.btn-group>.btn-lg+.dropdown-toggle{padding-left:12px;padding-right:12px}.btn-group.open .dropdown-toggle{-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{-webkit-box-shadow:none;box-shadow:none}.dropdown>.btn:after,.dropdown>.dropdown-toggle:after{content:\" \";left:0;width:100%;height:10px;bottom:-10px;position:absolute}.dropup>.btn:after,.dropup>.dropdown-toggle:after{content:\" \";left:0;top:-10px;width:100%;height:10px;bottom:auto;position:absolute}.btn .caret{margin-left:0}.btn-group-lg>.btn .caret,.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-group-lg>.btn .caret,.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn,.btn-group-vertical>rubix-button>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-group-vertical>rubix-menu:after,.btn-group-vertical>rubix-menu:before{content:\" \";display:table}.btn-group-vertical>.btn-group:after,.btn-group-vertical>rubix-menu:after{clear:both}.btn-group-vertical>.btn-group>.btn,.btn-group-vertical>rubix-menu>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group,.btn-group-vertical>rubix-button+rubix-button,.btn-group-vertical>rubix-button+rubix-menu,.btn-group-vertical>rubix-menu+rubix-button,.btn-group-vertical>rubix-menu+rubix-menu{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:20px;border-top-left-radius:20px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:20px;border-bottom-left-radius:20px}.btn-group-vertical>rubix-button:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>rubix-button:first-child:not(:last-child)>.btn{border-top-right-radius:20px;border-top-left-radius:20px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>rubix-button:last-child:not(:first-child)>.btn{border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:20px;border-bottom-left-radius:20px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn,.btn-group-vertical>rubix-menu:not(:first-child):not(:last-child) .btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child) .btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child) .dropdown-toggle,.btn-group-vertical>rubix-menu:first-child:not(:last-child) .btn:last-child,.btn-group-vertical>rubix-menu:first-child:not(:last-child) .dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child,.btn-group-vertical>rubix-menu:last-child:not(:first-child) .btn:first-child{border-top-right-radius:0;border-top-left-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group,.btn-group-justified>rubix-button,.btn-group-justified>rubix-menu{float:none;display:table-cell;width:1%}.btn-group-justified>.btn-group .btn,.btn-group-justified>rubix-button .btn,.btn-group-justified>rubix-menu .btn,.btn-group-justified>rubix-menu .dropdown{width:100%}.btn-group-justified>.btn-group .dropdown-menu,.btn-group-justified>rubix-menu .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-left:0;padding-right:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-btn+.form-control,.input-group-btn .btn-group>.btn{margin-left:-2px}.input-group-addon:first-child,.input-group-btn:first-child .btn,.input-group-btn:first-child .btn-group>.btn,.input-group-btn:first-child .dropdown-toggle,.input-group-btn:first-child rubix-menu>.btn-group>.btn,.input-group-btn:last-child .btn-group:not(:last-child)>.btn,.input-group-btn:last-child .btn:not(:last-child):not(.dropdown-toggle),.input-group-btn:last-child rubix-button:not(:last-child) .btn:not(.dropdown-toggle),.input-group .form-control:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child .btn-group:not(:first-child)>.btn,.input-group-btn:first-child .btn:not(:first-child),.input-group-btn:first-child rubix-button:not(:first-child) .btn,.input-group-btn:last-child .btn,.input-group-btn:last-child .btn-group>.btn,.input-group-btn:last-child .dropdown-toggle,.input-group-btn:last-child rubix-menu>.btn-group>.btn,.input-group .form-control:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn>rubix-button>.btn{position:relative}.input-group-btn>rubix-button>.btn:active,.input-group-btn>rubix-button>.btn:focus,.input-group-btn>rubix-button>.btn:hover{z-index:2}.input-group-btn>rubix-button+rubix-button>.btn{margin-left:-1px}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{margin-bottom:0;padding-left:0;list-style:none}.nav:after,.nav:before{content:\" \";display:table}.nav:after{clear:both}.nav>li,.nav>rubix-menu>li,.nav>rubix-nav-item>li{position:relative;display:block}.nav>li>a,.nav>rubix-menu>li>a,.nav>rubix-nav-item>li>a{position:relative;display:block;padding:4px 25px;color:#aaa}.nav>li>a:focus,.nav>li>a:hover,.nav>rubix-menu>li>a:focus,.nav>rubix-menu>li>a:hover,.nav>rubix-nav-item>li>a:focus,.nav>rubix-nav-item>li>a:hover{text-decoration:none;background-color:#f5f5f5}.nav>li.disabled>a,.nav>rubix-menu>li.disabled>a,.nav>rubix-nav-item>li.disabled>a{color:hsla(0,0%,47%,.3);border-top:none;border-left:none;border-right:none}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover,.nav>rubix-menu>li.disabled>a:focus,.nav>rubix-menu>li.disabled>a:hover,.nav>rubix-nav-item>li.disabled>a:focus,.nav>rubix-nav-item>li.disabled>a:hover{color:hsla(0,0%,47%,.3);text-decoration:none;background-color:transparent;cursor:not-allowed}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{color:#333;background-color:#f5f5f5}.nav .nav-divider{height:1px;margin:11.5px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img,.nav>rubix-menu>a>img,.nav>rubix-nav-item>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li,.nav-tabs>rubix-menu>li,.nav-tabs>rubix-nav-item>li{float:left;margin-bottom:-1px}.nav-tabs>li>a,.nav-tabs>rubix-menu>li>a,.nav-tabs>rubix-nav-item>li>a{margin-right:2px;text-align:center;line-height:1.78571;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover,.nav-tabs>rubix-menu>li>a:hover,.nav-tabs>rubix-nav-item>li>a:hover{border-color:#f5f5f5 #f5f5f5 #ddd}.nav-tabs>li.disabled>a:hover,.nav-tabs>rubix-menu>li.disabled>a:hover,.nav-tabs>rubix-nav-item>li.disabled>a:hover{border-bottom-width:0}.nav-tabs>li.active>a,.nav-tabs>rubix-menu>li.active>a,.nav-tabs>rubix-nav-item>li.active>a{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.nav-pills>li,.nav-pills>rubix-menu>li,.nav-pills>rubix-nav-item>li{float:left}.nav-pills>li>a,.nav-pills>rubix-menu>li>a,.nav-pills>rubix-nav-item>li>a{border-radius:4px}.nav-pills>li+li,.nav-pills>rubix-menu>li+li,.nav-pills>rubix-nav-item>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>rubix-menu>li.active>a,.nav-pills>rubix-nav-item>li.active>a{color:#fff;background-color:#428bca}.nav-stacked>li,.nav-stacked>rubix-menu>li,.nav-stacked>rubix-nav-item>li{float:none}.nav-stacked>li+li,.nav-stacked>rubix-menu>li+li,.nav-stacked>rubix-nav-item>li+li{margin-top:2px;margin-left:0}.nav-justified,.nav-tabs.nav-justified{width:100%}.nav-justified>li,.nav-tabs.nav-justified>li{float:none}.nav-justified>li>a,.nav-justified>li>li>a,.nav-justified>rubix-menu>a,.nav-justified>rubix-menu>li>a,.nav-justified>rubix-nav-item>a,.nav-justified>rubix-nav-item>li>a,.nav-tabs.nav-justified>li>a,.nav-tabs.nav-justified>li>li>a,.nav-tabs.nav-justified>rubix-menu>a,.nav-tabs.nav-justified>rubix-menu>li>a,.nav-tabs.nav-justified>rubix-nav-item>a,.nav-tabs.nav-justified>rubix-nav-item>li>a{text-align:center;margin-bottom:5px;border-bottom-width:0}.nav-justified>rubix-menu,.nav-justified>rubix-nav-item,.nav-tabs.nav-justified>rubix-menu,.nav-tabs.nav-justified>rubix-nav-item{display:block;width:auto}.nav-justified>rubix-menu>li,.nav-justified>rubix-nav-item>li,.nav-tabs.nav-justified>rubix-menu>li,.nav-tabs.nav-justified>rubix-nav-item>li{width:100%}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:990px){.nav-justified>rubix-menu,.nav-justified>rubix-nav-item,.nav-tabs.nav-justified>rubix-menu,.nav-tabs.nav-justified>rubix-nav-item{display:table-cell;width:1%}.nav-justified>rubix-menu>li,.nav-justified>rubix-nav-item>li,.nav-tabs.nav-justified>rubix-menu>li,.nav-tabs.nav-justified>rubix-nav-item>li{width:100%}.nav-justified>li.disabled>a:hover,.nav-justified>li a:hover,.nav-justified>rubix-menu>li.disabled>a:hover,.nav-justified>rubix-nav-item>li.disabled>a:hover{border-bottom-width:1px}.nav-justified>li,.nav-justified>rubix-menu,.nav-justified>rubix-nav-item,.nav-tabs.nav-justified>li,.nav-tabs.nav-justified>rubix-menu,.nav-tabs.nav-justified>rubix-nav-item{display:table-cell;width:1%}.nav-justified>li>a,.nav-justified>li>li>a,.nav-justified>rubix-menu>a,.nav-justified>rubix-menu>li>a,.nav-justified>rubix-nav-item>a,.nav-justified>rubix-nav-item>li>a,.nav-tabs.nav-justified>li>a,.nav-tabs.nav-justified>li>li>a,.nav-tabs.nav-justified>rubix-menu>a,.nav-tabs.nav-justified>rubix-menu>li>a,.nav-tabs.nav-justified>rubix-nav-item>a,.nav-tabs.nav-justified>rubix-nav-item>li>a{margin-bottom:0}}.nav-tabs-justified,.nav-tabs.nav-justified{border-bottom:0}.nav-tabs-justified>li>a,.nav-tabs-justified>rubix-menu>li>a,.nav-tabs-justified>rubix-nav-item>li>a,.nav-tabs.nav-justified>li>a,.nav-tabs.nav-justified>rubix-menu>li>a,.nav-tabs.nav-justified>rubix-nav-item>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs-justified>rubix-menu .active>a,.nav-tabs-justified>rubix-menu .active>a:focus,.nav-tabs-justified>rubix-menu .active>a:hover,.nav-tabs-justified>rubix-nav-item .active>a,.nav-tabs-justified>rubix-nav-item .active>a:focus,.nav-tabs-justified>rubix-nav-item .active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover,.nav-tabs.nav-justified>rubix-menu .active>a,.nav-tabs.nav-justified>rubix-menu .active>a:focus,.nav-tabs.nav-justified>rubix-menu .active>a:hover,.nav-tabs.nav-justified>rubix-nav-item .active>a,.nav-tabs.nav-justified>rubix-nav-item .active>a:focus,.nav-tabs.nav-justified>rubix-nav-item .active>a:hover{border:1px solid #ddd}@media (min-width:990px){.nav-tabs-justified>li>a,.nav-tabs-justified>rubix-menu>li>a,.nav-tabs-justified>rubix-nav-item>li>a,.nav-tabs.nav-justified>li>a,.nav-tabs.nav-justified>rubix-menu>li>a,.nav-tabs.nav-justified>rubix-nav-item>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>rubix-menu .active>a,.nav-tabs-justified>rubix-menu .active>a:focus,.nav-tabs-justified>rubix-menu .active>a:hover,.nav-tabs-justified>rubix-nav-item .active>a,.nav-tabs-justified>rubix-nav-item .active>a:focus,.nav-tabs-justified>rubix-nav-item .active>a:hover,.nav-tabs.nav-justified>rubix-menu .active>a,.nav-tabs.nav-justified>rubix-menu .active>a:focus,.nav-tabs.nav-justified>rubix-menu .active>a:hover,.nav-tabs.nav-justified>rubix-nav-item .active>a,.nav-tabs.nav-justified>rubix-nav-item .active>a:focus,.nav-tabs.nav-justified>rubix-nav-item .active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane,.tab-content rubix-tab-pane>.tab-pane{display:none}.tab-content>.active,.tab-content rubix-tab-pane>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.navbar{position:relative;min-height:75px;margin-bottom:25px;border:1px solid transparent}.navbar:after,.navbar:before{content:\" \";display:table}.navbar:after{clear:both}@media (min-width:990px){.navbar{border-radius:4px}}.navbar-header:after,.navbar-header:before{content:\" \";display:table}.navbar-header:after{clear:both}@media (min-width:990px){.navbar-header{float:left}}.navbar-collapse{overflow-x:visible;padding-right:25px;padding-left:25px;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse:after,.navbar-collapse:before{content:\" \";display:table}.navbar-collapse:after{clear:both}.navbar-collapse.in{overflow-y:auto}@media (min-width:990px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-left:0;padding-right:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid .navbar-collapse,.container-fluid .navbar-header,.container .navbar-collapse,.container .navbar-header{margin-right:-25px;margin-left:-25px}@media (min-width:990px){.container-fluid .navbar-collapse,.container-fluid .navbar-header,.container .navbar-collapse,.container .navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:990px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:990px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;padding:25px;font-size:18px;line-height:25px;height:75px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:990px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-25px}}.navbar-toggle{position:relative;float:right;margin-right:25px;padding:9px 10px;margin-top:20.5px;margin-bottom:20.5px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:990px){.navbar-toggle{display:none}}.navbar-nav{margin:12.5px -25px}.navbar-nav>li>a,.navbar-nav>rubix-menu>li>a,.navbar-nav>rubix-nav-item>li>a{padding-top:10px;padding-bottom:10px;line-height:25px}@media (max-width:989px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:25px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:990px){.navbar-nav{float:left;margin:0}.navbar-nav>li,.navbar-nav>rubix-menu,.navbar-nav>rubix-nav-item{float:left}.navbar-nav>li>a,.navbar-nav>li>li>a,.navbar-nav>rubix-menu>a,.navbar-nav>rubix-menu>li>a,.navbar-nav>rubix-nav-item>a,.navbar-nav>rubix-nav-item>li>a{padding-top:25px;padding-bottom:25px}}.navbar-form{margin:23px -25px;padding:10px 25px;border-top:1px solid transparent;border-bottom:1px solid transparent;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:990px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:989px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:990px){.navbar-form{width:auto;border:0;margin-left:0;margin-right:0;padding-top:0;padding-bottom:0;-webkit-box-shadow:none;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-right-radius:0;border-top-left-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:23px}.btn-group-sm>.navbar-btn.btn,.navbar-btn.btn-sm{margin-top:27px}.btn-group-xs>.navbar-btn.btn,.navbar-btn.btn-xs{margin-top:29px}.navbar-text{margin-top:25px;margin-bottom:25px}@media (min-width:990px){.navbar-text{float:left;margin-left:25px;margin-right:25px}}@media (min-width:990px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-25px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#fff;border-color:#eee}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-nav>rubix-menu>li>a,.navbar-default .navbar-nav>rubix-nav-item>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover,.navbar-default .navbar-nav>rubix-menu>li>a:focus,.navbar-default .navbar-nav>rubix-menu>li>a:hover,.navbar-default .navbar-nav>rubix-nav-item>li>a:focus,.navbar-default .navbar-nav>rubix-nav-item>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover,.navbar-default .navbar-nav>rubix-menu>.active>a,.navbar-default .navbar-nav>rubix-menu>.active>a:focus,.navbar-default .navbar-nav>rubix-menu>.active>a:hover,.navbar-default .navbar-nav>rubix-nav-item>.active>a,.navbar-default .navbar-nav>rubix-nav-item>.active>a:focus,.navbar-default .navbar-nav>rubix-nav-item>.active>a:hover{color:#555;background-color:#eee}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover,.navbar-default .navbar-nav>rubix-menu>.disabled>a,.navbar-default .navbar-nav>rubix-menu>.disabled>a:focus,.navbar-default .navbar-nav>rubix-menu>.disabled>a:hover,.navbar-default .navbar-nav>rubix-nav-item>.disabled>a,.navbar-default .navbar-nav>rubix-nav-item>.disabled>a:focus,.navbar-default .navbar-nav>rubix-nav-item>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#eee}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover,.navbar-default .navbar-nav>rubix-menu>.open>a,.navbar-default .navbar-nav>rubix-menu>.open>a:focus,.navbar-default .navbar-nav>rubix-menu>.open>a:hover{background-color:#eee;color:#555}@media (max-width:989px){.navbar-default .navbar-nav .open .dropdown-menu>li>a,.navbar-default .navbar-nav .open .dropdown-menu>rubix-menu-item>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover,.navbar-default .navbar-nav .open .dropdown-menu>rubix-menu-item>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>rubix-menu-item>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover,.navbar-default .navbar-nav .open .dropdown-menu>rubix-menu-item>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>rubix-menu-item>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>rubix-menu-item>.active>a:hover{color:#555;background-color:#eee}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover,.navbar-default .navbar-nav .open .dropdown-menu>rubix-menu-item>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>rubix-menu-item>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>rubix-menu-item>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#090909}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-nav>rubix-menu>li>a,.navbar-inverse .navbar-nav>rubix-nav-item>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover,.navbar-inverse .navbar-nav>rubix-menu>li>a:focus,.navbar-inverse .navbar-nav>rubix-menu>li>a:hover,.navbar-inverse .navbar-nav>rubix-nav-item>li>a:focus,.navbar-inverse .navbar-nav>rubix-nav-item>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover,.navbar-inverse .navbar-nav>rubix-menu>.active>a,.navbar-inverse .navbar-nav>rubix-menu>.active>a:focus,.navbar-inverse .navbar-nav>rubix-menu>.active>a:hover,.navbar-inverse .navbar-nav>rubix-nav-item>.active>a,.navbar-inverse .navbar-nav>rubix-nav-item>.active>a:focus,.navbar-inverse .navbar-nav>rubix-nav-item>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover,.navbar-inverse .navbar-nav>rubix-menu>.disabled>a,.navbar-inverse .navbar-nav>rubix-menu>.disabled>a:focus,.navbar-inverse .navbar-nav>rubix-menu>.disabled>a:hover,.navbar-inverse .navbar-nav>rubix-nav-item>.disabled>a,.navbar-inverse .navbar-nav>rubix-nav-item>.disabled>a:focus,.navbar-inverse .navbar-nav>rubix-nav-item>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{background-color:#090909;color:#fff}@media (max-width:989px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:25px;list-style:none;background-color:#fff;border-radius:4px}.breadcrumb>li,.breadcrumb>rubix-breadcrumb-item,.breadcrumb>rubix-breadcrumb-item>li{display:inline-block}.breadcrumb>li+li:before,.breadcrumb>li+rubix-breadcrumb-item:before,.breadcrumb>rubix-breadcrumb-item+li:before,.breadcrumb>rubix-breadcrumb-item+rubix-breadcrumb-item:before,.breadcrumb>rubix-breadcrumb-item>li+li:before,.breadcrumb>rubix-breadcrumb-item>li+rubix-breadcrumb-item:before{content:\"/\\A0\";padding:0 5px;padding-left:10px;color:#ccc}.breadcrumb>.active,.breadcrumb>rubix-breadcrumb-item>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:25px 0;border-radius:4px}.pagination>li,.pagination>rubix-page-item>li{display:inline}.pagination>li>a,.pagination>li>span,.pagination>rubix-page-item>li>a,.pagination>rubix-page-item>li>span{position:relative;float:left;padding:6px 12px;line-height:1.78571;text-decoration:none;color:#2eb398;background-color:#fff;border:1px solid #ddd;margin-left:-1px}.pagination>li:first-child>a,.pagination>li:first-child>li>a,.pagination>li:first-child>li>span,.pagination>li:first-child>span,.pagination>rubix-page-item:first-child>a,.pagination>rubix-page-item:first-child>li>a,.pagination>rubix-page-item:first-child>li>span,.pagination>rubix-page-item:first-child>span{margin-left:0;border-bottom-left-radius:4px;border-top-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>li>a,.pagination>li:last-child>li>span,.pagination>li:last-child>span,.pagination>rubix-page-item:last-child>a,.pagination>rubix-page-item:last-child>li>a,.pagination>rubix-page-item:last-child>li>span,.pagination>rubix-page-item:last-child>span{border-bottom-right-radius:4px;border-top-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover,.pagination>rubix-page-item>li>a:focus,.pagination>rubix-page-item>li>a:hover,.pagination>rubix-page-item>li>span:focus,.pagination>rubix-page-item>li>span:hover{z-index:2;color:#2e6b5e;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover,.pagination>rubix-page-item>.active>a,.pagination>rubix-page-item>.active>a:focus,.pagination>rubix-page-item>.active>a:hover,.pagination>rubix-page-item>.active>span,.pagination>rubix-page-item>.active>span:focus,.pagination>rubix-page-item>.active>span:hover{z-index:3;color:#fff;background-color:#428bca;border-color:#428bca;cursor:default}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover,.pagination>rubix-page-item .disabled>a,.pagination>rubix-page-item .disabled>a:focus,.pagination>rubix-page-item .disabled>a:hover,.pagination>rubix-page-item .disabled>span,.pagination>rubix-page-item .disabled>span:focus,.pagination>rubix-page-item .disabled>span:hover{pointer-events:none;color:#777;background-color:#fff;border-color:#ddd;cursor:not-allowed}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.33333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-bottom-left-radius:6px;border-top-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-bottom-right-radius:6px;border-top-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-bottom-left-radius:3px;border-top-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-bottom-right-radius:3px;border-top-right-radius:3px}.pager{padding-left:0;margin:25px 0;list-style:none;text-align:center}.pager:after,.pager:before{content:\" \";display:table}.pager:after{clear:both}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;background-color:#fff;cursor:not-allowed}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}.label:empty{display:none}.btn .label{position:relative;top:-1px}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#428bca}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#3071a9}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;color:#fff;line-height:1;vertical-align:middle;white-space:nowrap;text-align:center;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}.list-group-item.active .badge,.nav-pills>.active>a .badge{color:#2eb398;background-color:#fff}.list-group-item .badge{top:3px;float:right;position:relative}.list-group-item .badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{border-radius:6px;padding-left:25px;padding-right:25px}.jumbotron .container{max-width:100%}@media screen and (min-width:990px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-left:60px;padding-right:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:25px;line-height:1.78571;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:border .2s ease-in-out;-o-transition:border .2s ease-in-out;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto;margin-left:auto;margin-right:auto}.thumbnail .caption{padding:9px;color:#333}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#2eb398}.alert{padding:15px;margin-bottom:25px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#3c763d}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#31708f}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faebcc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebccd1;color:#a94442}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@-webkit-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{overflow:hidden;height:25px;margin-bottom:25px;background-color:#f5f5f5;border-radius:4px;-webkit-box-shadow:inset 0 1px 2px rgba(0,0,0,.1);box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:25px;color:#fff;text-align:center;background-color:#428bca;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-transition:width .6s ease;-o-transition:width .6s ease;transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:progress-bar-stripes 2s linear infinite;-o-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-collapse-bottom{margin-bottom:0}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{zoom:1;overflow:hidden}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{margin-bottom:20px;padding-left:0}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group>.list-group-item:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.list-group>.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.list-group>rubix-list-group-item:first-child>.list-group-item{border-top-right-radius:4px;border-top-left-radius:4px}.list-group>rubix-list-group-item:last-child>.list-group-item{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{text-decoration:none;color:#555;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{background-color:#eee;color:#777;cursor:not-allowed}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#428bca;border-color:#428bca}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#e1edf7}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:25px;background-color:#fff;border:1px solid transparent;border-radius:4px;-webkit-box-shadow:0 1px 1px rgba(0,0,0,.05);box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:25px}.panel-body:after,.panel-body:before{content:\" \";display:table}.panel-body:after{clear:both}.panel-heading{padding:12.5px 25px;border-bottom:1px solid transparent;border-top-right-radius:3px;border-top-left-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:12.5px 25px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group,.panel>rubix-list-group>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item,.panel>rubix-list-group>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>rubix-list-group>.list-group:first-child rubix-list-group-item:first-child .list-group-item{border-top-right-radius:0;border-top-left-radius:0}.panel>rubix-list-group>.list-group:last-child rubix-list-group-item:last-child .list-group-item{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-right-radius:3px;border-top-left-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel .panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-right-radius:0;border-top-left-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-left:25px;padding-right:25px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-right-radius:3px;border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table+rubix-bpanel-body,.panel>.table-responsive+.panel-body,.panel>.table-responsive+rubix-bpanel-body,.panel>rubix-bpanel-body+.table,.panel>rubix-bpanel-body+.table-responsive{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{border:0;margin-bottom:0}.panel-group{margin-bottom:25px}.panel-group .collapse-link{height:42px;display:block;line-height:42px;margin-top:-12.5px;margin-bottom:-12.5px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group rubix-bpanel{margin-bottom:0;border-radius:4px}.panel-group rubix-bpanel+rubix-bpanel>.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#428bca}.panel-primary>.panel-heading{color:#fff;background-color:#428bca;border-color:#428bca}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#428bca}.panel-primary>.panel-heading .badge{color:#428bca;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#428bca}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.panel-title>a{height:42px;display:block;line-height:42px;margin-top:-12.5px;margin-bottom:-12.5px}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;left:0;bottom:0;height:100%;width:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.05);box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;filter:alpha(opacity=20)}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5;filter:alpha(opacity=50)}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{-webkit-transform:translateY(-25%);-ms-transform:translateY(-25%);-o-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;-moz-transition:-moz-transform .3s ease-out;-o-transition:-o-transform .3s ease-out;transition:transform .3s ease-out}.modal.in .modal-dialog{-webkit-transform:translate(0);-ms-transform:translate(0);-o-transform:translate(0);transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;-webkit-box-shadow:0 3px 9px rgba(0,0,0,.5);box-shadow:0 3px 9px rgba(0,0,0,.5);background-clip:padding-box;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0;filter:alpha(opacity=0)}.modal-backdrop.in{opacity:.5;filter:alpha(opacity=50)}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header:after,.modal-header:before{content:\" \";display:table}.modal-header:after{clear:both}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.78571}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer:after,.modal-footer:before{content:\" \";display:table}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:990px){.modal-dialog{width:600px;margin:30px auto}.modal-content{-webkit-box-shadow:0 5px 15px rgba(0,0,0,.5);box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:1152px){.modal-lg{width:900px}}body>.modal-backdrop{z-index:-1}.static-modal .modal{top:auto;left:auto;right:auto;bottom:auto;z-index:1;position:relative}.modal-container{position:relative}.modal-container .modal,.modal-container .modal-backdrop,.tooltip{position:absolute}.tooltip{z-index:1e+27;display:block;font-family:Lato,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.78571;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:12px;opacity:0;filter:alpha(opacity=0)}.tooltip.in{opacity:.9;filter:alpha(opacity=90)}.tooltip.top{margin-top:-3px;padding:5px 0}.tooltip.right{margin-left:3px;padding:0 5px}.tooltip.bottom{margin-top:3px;padding:5px 0}.tooltip.left{margin-left:-3px;padding:0 5px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Lato,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.78571;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;-webkit-box-shadow:0 5px 10px rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{margin:0;padding:8px 14px;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{border-width:10px;content:\"\"}.popover.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}.popover.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}.popover.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}.popover.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}.popover.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}.carousel,.carousel-inner{position:relative}.carousel-inner{overflow:hidden;width:100%}.carousel-inner>.item{display:none;position:relative;-webkit-transition:left .6s ease-in-out;-o-transition:.6s ease-in-out left;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{display:block;max-width:100%;height:auto;line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{-webkit-transition:-webkit-transform .6s ease-in-out;-moz-transition:-moz-transform .6s ease-in-out;-o-transition:-o-transform .6s ease-in-out;transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;-moz-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;-moz-perspective:1000px;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{-webkit-transform:translateZ(0);transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;left:0;bottom:0;width:15%;opacity:.5;filter:alpha(opacity=50);font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent}.carousel-control.left{background-image:-webkit-linear-gradient(left,rgba(0,0,0,.5),rgba(0,0,0,.0001));background-image:-o-linear-gradient(left,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001) 100%);background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1)}.carousel-control.right{left:auto;right:0;background-image:-webkit-linear-gradient(left,rgba(0,0,0,.0001),rgba(0,0,0,.5));background-image:-o-linear-gradient(left,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5) 100%);background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1)}.carousel-control:focus,.carousel-control:hover{outline:0;color:#fff;text-decoration:none;opacity:.9;filter:alpha(opacity=90)}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;margin-top:-10px;z-index:5;display:inline-block}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;line-height:1;font-family:serif}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;margin-left:-30%;padding-left:0;list-style:none;text-align:center}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;border:1px solid #fff;border-radius:10px;cursor:pointer;background-color:#000\\9;background-color:transparent}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#fff}.carousel-caption{position:absolute;left:15%;right:15%;bottom:20px;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:990px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{left:20%;right:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.clearfix:after,.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both}.center-block{display:block;margin-left:auto;margin-right:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:989px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:989px){.visible-xs-block{display:block!important}}@media (max-width:989px){.visible-xs-inline{display:inline!important}}@media (max-width:989px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:990px) and (max-width:1151px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:990px) and (max-width:1151px){.visible-sm-block{display:block!important}}@media (min-width:990px) and (max-width:1151px){.visible-sm-inline{display:inline!important}}@media (min-width:990px) and (max-width:1151px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:1152px) and (max-width:1365px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:1152px) and (max-width:1365px){.visible-md-block{display:block!important}}@media (min-width:1152px) and (max-width:1365px){.visible-md-inline{display:inline!important}}@media (min-width:1152px) and (max-width:1365px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1366px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1366px){.visible-lg-block{display:block!important}}@media (min-width:1366px){.visible-lg-inline{display:inline!important}}@media (min-width:1366px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:989px){.hidden-xs{display:none!important}}@media (min-width:990px) and (max-width:1151px){.hidden-sm{display:none!important}}@media (min-width:1152px) and (max-width:1365px){.hidden-md{display:none!important}}@media (min-width:1366px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}.form-group{position:relative}.form-group .control-label~.form-control-feedback{top:30px}.bootstrap-datetimepicker-widget .form-group .control-label.btn[data-action=clear]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .form-group .control-label.btn[data-action=decrementHours]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .form-group .control-label.btn[data-action=decrementMinutes]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .form-group .control-label.btn[data-action=incrementHours]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .form-group .control-label.btn[data-action=incrementMinutes]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .form-group .control-label.btn[data-action=showHours]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .form-group .control-label.btn[data-action=showMinutes]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .form-group .control-label.btn[data-action=today]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .form-group .control-label.btn[data-action=togglePeriod]:after~.form-control-feedback,.bootstrap-datetimepicker-widget .form-group .control-label.picker-switch:after~.form-control-feedback,.bootstrap-datetimepicker-widget table .form-group th.control-label.next:after~.form-control-feedback,.bootstrap-datetimepicker-widget table .form-group th.control-label.prev:after~.form-control-feedback,.form-group .bootstrap-datetimepicker-widget .control-label.btn[data-action=clear]:after~.form-control-feedback,.form-group .bootstrap-datetimepicker-widget .control-label.btn[data-action=decrementHours]:after~.form-control-feedback,.form-group .bootstrap-datetimepicker-widget .control-label.btn[data-action=decrementMinutes]:after~.form-control-feedback,.form-group .bootstrap-datetimepicker-widget .control-label.btn[data-action=incrementHours]:after~.form-control-feedback,.form-group .bootstrap-datetimepicker-widget .control-label.btn[data-action=incrementMinutes]:after~.form-control-feedback,.form-group .bootstrap-datetimepicker-widget .control-label.btn[data-action=showHours]:after~.form-control-feedback,.form-group .bootstrap-datetimepicker-widget .control-label.btn[data-action=showMinutes]:after~.form-control-feedback,.form-group .bootstrap-datetimepicker-widget .control-label.btn[data-action=today]:after~.form-control-feedback,.form-group .bootstrap-datetimepicker-widget .control-label.btn[data-action=togglePeriod]:after~.form-control-feedback,.form-group .bootstrap-datetimepicker-widget .control-label.picker-switch:after~.form-control-feedback,.form-group .bootstrap-datetimepicker-widget table th.control-label.next:after~.form-control-feedback,.form-group .bootstrap-datetimepicker-widget table th.control-label.prev:after~.form-control-feedback,.form-group .control-label.sr-only~.form-control-feedback{top:0}.form-group [class^=col-] .form-control-feedback{right:25px}.form-inline .form-group .form-control-feedback{top:30px}@media (min-width:990px){.form-inline .form-group .form-control-feedback{top:0}}.form-horizontal .form-group .form-control-feedback{top:0}.form-control{color:#444;height:30px;padding:0 12px;box-shadow:none!important;border-width:2px;letter-spacing:.5px;border-radius:0!important}.form-control:focus{box-shadow:none}.form-control.plain{border-top:none;border-left:none;border-right:none}.input-group-addon{border:none;color:#89949b;border-radius:0!important}.form-control-feedback{width:30px;height:30px;line-height:30px!important}.input-group>.form-control-feedback{top:0}select[multiple],select[size]{padding:12px}input[type=file]{display:block;line-height:0}.help-block{color:#bbb}.form-control.inline,.help-block.inline{margin:0;width:auto;margin-right:5px;display:inline-block}@media (min-width:990px){.form-horizontal .control-label{padding:0;line-height:30px}}.input-group-addon.plain{padding:0;border:none;background:none}.input-group-addon.plain>button{height:30px;border-radius:0}.form-control-static{padding:0;line-height:30px}.form-horizontal .form-group-lg .form-control,.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{height:46px;padding:10px 16px}.form-horizontal .form-group-sm .form-control,.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn,.input-sm{height:25px!important;padding-top:2px;margin-top:8px}.form-horizontal .form-group-lg .form-control,.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{height:50px!important;padding-top:0!important;padding-bottom:0!important}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:3px;padding-bottom:3px}.list-group-item:focus,.list-group-item:hover{padding:10px 15px;color:#555!important;border:1px solid #ddd!important;background-color:#f5f5f5!important}.form-inline .control-label,rubix-input-group{display:inline-block}rubix-input-group{position:relative}.panel-xs-1{width:8.33333%}.panel-xs-2{width:16.66667%}.panel-xs-3{width:25%}.panel-xs-4{width:33.33333%}.panel-xs-5{width:41.66667%}.panel-xs-6{width:50%}.panel-xs-7{width:58.33333%}.panel-xs-8{width:66.66667%}.panel-xs-9{width:75%}.panel-xs-10{width:83.33333%}.panel-xs-11{width:91.66667%}.panel-xs-12{width:100%}@media (min-width:990px){.panel-sm-1{width:8.33333%}.panel-sm-2{width:16.66667%}.panel-sm-3{width:25%}.panel-sm-4{width:33.33333%}.panel-sm-5{width:41.66667%}.panel-sm-6{width:50%}.panel-sm-7{width:58.33333%}.panel-sm-8{width:66.66667%}.panel-sm-9{width:75%}.panel-sm-10{width:83.33333%}.panel-sm-11{width:91.66667%}.panel-sm-12{width:100%}}@media (min-width:1152px){.panel-md-1{width:8.33333%}.panel-md-2{width:16.66667%}.panel-md-3{width:25%}.panel-md-4{width:33.33333%}.panel-md-5{width:41.66667%}.panel-md-6{width:50%}.panel-md-7{width:58.33333%}.panel-md-8{width:66.66667%}.panel-md-9{width:75%}.panel-md-10{width:83.33333%}.panel-md-11{width:91.66667%}.panel-md-12{width:100%}}@media (min-width:1366px){.panel-lg-1{width:8.33333%}.panel-lg-2{width:16.66667%}.panel-lg-3{width:25%}.panel-lg-4{width:33.33333%}.panel-lg-5{width:41.66667%}.panel-lg-6{width:50%}.panel-lg-7{width:58.33333%}.panel-lg-8{width:66.66667%}.panel-lg-9{width:75%}.panel-lg-10{width:83.33333%}.panel-lg-11{width:91.66667%}.panel-lg-12{width:100%}}.panel-collapse-bottom{margin-bottom:0!important}.panel-gutter-bottom{margin-bottom:50px!important}.rubix-panel-container-with-controls{position:relative}.rubix-panel-container{overflow:hidden;position:relative;border-radius:8px;margin-bottom:25px}.rubix-panel-container.noOverflow{overflow:auto}html.no-touchevents .rubix-panel-container-with-controls.active>.rubix-panel-controls,html.no-touchevents .rubix-panel-container-with-controls:focus>.rubix-panel-controls,html.no-touchevents .rubix-panel-container-with-controls:hover>.rubix-panel-controls{top:-20px}.rubix-panel-controls{-webkit-transition:all .2s ease;-o-transition:all .2s ease;transition:all .2s ease;top:0;z-index:0;background:#fff;position:absolute;right:12.5px;border-top-left-radius:4px;border-top-right-radius:4px;padding:0 12.5px 5px}.rubix-panel-controls button{top:-2px;padding:0;border:none;opacity:.5;color:inherit;background:none;position:relative}.rubix-panel-controls button:active,.rubix-panel-controls button:active:focus,.rubix-panel-controls button:focus,.rubix-panel-controls button:hover{-webkit-box-shadow:none;box-shadow:none;opacity:1;border:none;outline:none;color:inherit;background:none}.rubix-panel-controls button .rubix-icon{font-size:14px}.rubix-panel-controls>button~button,.rubix-panel-controls>rubix-button~rubix-button{padding-left:10px}.rubix-panel{position:relative}.rubix-panel-header,rubix-panel-header{border-top-left-radius:8px;border-top-right-radius:8px}.rubix-panel-header[class*=bg-],rubix-panel-header[class*=bg-]{margin-bottom:12.5px}.rubix-panel-header~.rubix-panel-body,.rubix-panel-header~rubix-panel-body>.rubix-panel-body,rubix-panel-header~.rubix-panel-body,rubix-panel-header~rubix-panel-body>.rubix-panel-body{padding-top:0}.rubix-panel-body{min-height:35px;padding-top:25px}.rubix-panel-footer,rubix-panel-footer{border-bottom-left-radius:8px;border-bottom-right-radius:8px}.rubix-panel-footer[class*=bg-],rubix-panel-footer[class*=bg-]{margin-top:12.5px}.rubix-panel-footer div.tab-container,.rubix-panel-footer rubix-nav,.rubix-panel-header div.tab-container,.rubix-panel-header rubix-nav,.rubix-panel-left div.tab-container,.rubix-panel-left rubix-nav,.rubix-panel-right div.tab-container,.rubix-panel-right rubix-nav{width:100%;display:table}.rubix-panel-footer .nav,.rubix-panel-header .nav,.rubix-panel-left .nav,.rubix-panel-right .nav{border:none;display:table-row}.rubix-panel-footer .nav:after,.rubix-panel-footer .nav:before,.rubix-panel-header .nav:after,.rubix-panel-header .nav:before,.rubix-panel-left .nav:after,.rubix-panel-left .nav:before,.rubix-panel-right .nav:after,.rubix-panel-right .nav:before{display:none}.rubix-panel-footer .nav>li,.rubix-panel-footer .nav rubix-menu,.rubix-panel-footer .nav rubix-nav-item,.rubix-panel-header .nav>li,.rubix-panel-header .nav rubix-menu,.rubix-panel-header .nav rubix-nav-item,.rubix-panel-left .nav>li,.rubix-panel-left .nav rubix-menu,.rubix-panel-left .nav rubix-nav-item,.rubix-panel-right .nav>li,.rubix-panel-right .nav rubix-menu,.rubix-panel-right .nav rubix-nav-item{display:table-cell;float:none;margin:0;vertical-align:middle}.rubix-panel-footer .nav>li,.rubix-panel-header .nav>li,.rubix-panel-left .nav>li,.rubix-panel-right .nav>li{width:1%}.rubix-panel-footer .nav rubix-menu>li,.rubix-panel-footer .nav rubix-nav-item>li,.rubix-panel-header .nav rubix-menu>li,.rubix-panel-header .nav rubix-nav-item>li,.rubix-panel-left .nav rubix-menu>li,.rubix-panel-left .nav rubix-nav-item>li,.rubix-panel-right .nav rubix-menu>li,.rubix-panel-right .nav rubix-nav-item>li{width:100%}.rubix-panel-footer .nav>li>a,.rubix-panel-footer .nav rubix-menu>li>a,.rubix-panel-footer .nav rubix-nav-item>li>a,.rubix-panel-header .nav>li>a,.rubix-panel-header .nav rubix-menu>li>a,.rubix-panel-header .nav rubix-nav-item>li>a,.rubix-panel-left .nav>li>a,.rubix-panel-left .nav rubix-menu>li>a,.rubix-panel-left .nav rubix-nav-item>li>a,.rubix-panel-right .nav>li>a,.rubix-panel-right .nav rubix-menu>li>a,.rubix-panel-right .nav rubix-nav-item>li>a{margin:0;width:100.1%;color:inherit;opacity:.8;line-height:3;border-color:transparent;outline:1px solid inherit;border-right:1px solid rgba(0,0,0,.07)}.rubix-panel-footer .nav>li>a,.rubix-panel-header .nav>li>a,.rubix-panel-left .nav>li>a,.rubix-panel-right .nav>li>a{outline:none}.rubix-panel-footer .nav>li:not(:first-child):not(:last-child)>a,.rubix-panel-footer .nav rubix-menu:not(:first-child):not(:last-child)>li>a,.rubix-panel-footer .nav rubix-nav-item:not(:first-child):not(:last-child)>li>a,.rubix-panel-header .nav>li:not(:first-child):not(:last-child)>a,.rubix-panel-header .nav rubix-menu:not(:first-child):not(:last-child)>li>a,.rubix-panel-header .nav rubix-nav-item:not(:first-child):not(:last-child)>li>a,.rubix-panel-left .nav>li:not(:first-child):not(:last-child)>a,.rubix-panel-left .nav rubix-menu:not(:first-child):not(:last-child)>li>a,.rubix-panel-left .nav rubix-nav-item:not(:first-child):not(:last-child)>li>a,.rubix-panel-right .nav>li:not(:first-child):not(:last-child)>a,.rubix-panel-right .nav rubix-menu:not(:first-child):not(:last-child)>li>a,.rubix-panel-right .nav rubix-nav-item:not(:first-child):not(:last-child)>li>a{border-radius:0}.rubix-panel-footer .nav rubix-menu:last-child,.rubix-panel-footer .nav rubix-nav-item:last-child,.rubix-panel-header .nav rubix-menu:last-child,.rubix-panel-header .nav rubix-nav-item:last-child,.rubix-panel-left .nav rubix-menu:last-child,.rubix-panel-left .nav rubix-nav-item:last-child,.rubix-panel-right .nav rubix-menu:last-child,.rubix-panel-right .nav rubix-nav-item:last-child{border-color:transparent}.rubix-panel-footer .nav>li>a:focus,.rubix-panel-footer .nav>li>a:hover,.rubix-panel-footer .nav rubix-menu>li>a:focus,.rubix-panel-footer .nav rubix-menu>li>a:hover,.rubix-panel-footer .nav rubix-nav-item>li>a:focus,.rubix-panel-footer .nav rubix-nav-item>li>a:hover,.rubix-panel-header .nav>li>a:focus,.rubix-panel-header .nav>li>a:hover,.rubix-panel-header .nav rubix-menu>li>a:focus,.rubix-panel-header .nav rubix-menu>li>a:hover,.rubix-panel-header .nav rubix-nav-item>li>a:focus,.rubix-panel-header .nav rubix-nav-item>li>a:hover,.rubix-panel-left .nav>li>a:focus,.rubix-panel-left .nav>li>a:hover,.rubix-panel-left .nav rubix-menu>li>a:focus,.rubix-panel-left .nav rubix-menu>li>a:hover,.rubix-panel-left .nav rubix-nav-item>li>a:focus,.rubix-panel-left .nav rubix-nav-item>li>a:hover,.rubix-panel-right .nav>li>a:focus,.rubix-panel-right .nav>li>a:hover,.rubix-panel-right .nav rubix-menu>li>a:focus,.rubix-panel-right .nav rubix-menu>li>a:hover,.rubix-panel-right .nav rubix-nav-item>li>a:focus,.rubix-panel-right .nav rubix-nav-item>li>a:hover{opacity:1;background:transparent}.rubix-panel-footer .nav>li.active>a,.rubix-panel-footer .nav rubix-menu>li.active>a,.rubix-panel-footer .nav rubix-nav-item>li.active>a,.rubix-panel-header .nav>li.active>a,.rubix-panel-header .nav rubix-menu>li.active>a,.rubix-panel-header .nav rubix-nav-item>li.active>a,.rubix-panel-left .nav>li.active>a,.rubix-panel-left .nav rubix-menu>li.active>a,.rubix-panel-left .nav rubix-nav-item>li.active>a,.rubix-panel-right .nav>li.active>a,.rubix-panel-right .nav rubix-menu>li.active>a,.rubix-panel-right .nav rubix-nav-item>li.active>a{opacity:1;background:#fff;color:#89949b}.rubix-panel-footer .plain.nav>li>a,.rubix-panel-footer .plain.nav rubix-menu>li>a,.rubix-panel-footer .plain.nav rubix-nav-item>li>a,.rubix-panel-header .plain.nav>li>a,.rubix-panel-header .plain.nav rubix-menu>li>a,.rubix-panel-header .plain.nav rubix-nav-item>li>a,.rubix-panel-left .plain.nav>li>a,.rubix-panel-left .plain.nav rubix-menu>li>a,.rubix-panel-left .plain.nav rubix-nav-item>li>a,.rubix-panel-right .plain.nav>li>a,.rubix-panel-right .plain.nav rubix-menu>li>a,.rubix-panel-right .plain.nav rubix-nav-item>li>a{border-color:transparent}.rubix-panel-footer .plain.nav>li>a,.rubix-panel-header .plain.nav>li>a,.rubix-panel-left .plain.nav>li>a,.rubix-panel-right .plain.nav>li>a{margin-top:-2px;margin-bottom:-2px}.rubix-panel-footer .plain.nav>li>a,.rubix-panel-footer .plain.nav rubix-menu>li>a,.rubix-panel-footer .plain.nav rubix-nav-item>li>a,.rubix-panel-header .plain.nav>li>a,.rubix-panel-header .plain.nav rubix-menu>li>a,.rubix-panel-header .plain.nav rubix-nav-item>li>a,.rubix-panel-left .plain.nav>li>a,.rubix-panel-left .plain.nav rubix-menu>li>a,.rubix-panel-left .plain.nav rubix-nav-item>li>a,.rubix-panel-right .plain.nav>li>a,.rubix-panel-right .plain.nav rubix-menu>li>a,.rubix-panel-right .plain.nav rubix-nav-item>li>a{background-color:transparent}.rubix-panel-footer .plain.nav>li.active>a,.rubix-panel-footer .plain.nav>li>a:focus,.rubix-panel-footer .plain.nav>li>a:hover,.rubix-panel-footer .plain.nav rubix-menu>li.active>a,.rubix-panel-footer .plain.nav rubix-menu>li>a:focus,.rubix-panel-footer .plain.nav rubix-menu>li>a:hover,.rubix-panel-footer .plain.nav rubix-nav-item>li.active>a,.rubix-panel-footer .plain.nav rubix-nav-item>li>a:focus,.rubix-panel-footer .plain.nav rubix-nav-item>li>a:hover,.rubix-panel-header .plain.nav>li.active>a,.rubix-panel-header .plain.nav>li>a:focus,.rubix-panel-header .plain.nav>li>a:hover,.rubix-panel-header .plain.nav rubix-menu>li.active>a,.rubix-panel-header .plain.nav rubix-menu>li>a:focus,.rubix-panel-header .plain.nav rubix-menu>li>a:hover,.rubix-panel-header .plain.nav rubix-nav-item>li.active>a,.rubix-panel-header .plain.nav rubix-nav-item>li>a:focus,.rubix-panel-header .plain.nav rubix-nav-item>li>a:hover,.rubix-panel-left .plain.nav>li.active>a,.rubix-panel-left .plain.nav>li>a:focus,.rubix-panel-left .plain.nav>li>a:hover,.rubix-panel-left .plain.nav rubix-menu>li.active>a,.rubix-panel-left .plain.nav rubix-menu>li>a:focus,.rubix-panel-left .plain.nav rubix-menu>li>a:hover,.rubix-panel-left .plain.nav rubix-nav-item>li.active>a,.rubix-panel-left .plain.nav rubix-nav-item>li>a:focus,.rubix-panel-left .plain.nav rubix-nav-item>li>a:hover,.rubix-panel-right .plain.nav>li.active>a,.rubix-panel-right .plain.nav>li>a:focus,.rubix-panel-right .plain.nav>li>a:hover,.rubix-panel-right .plain.nav rubix-menu>li.active>a,.rubix-panel-right .plain.nav rubix-menu>li>a:focus,.rubix-panel-right .plain.nav rubix-menu>li>a:hover,.rubix-panel-right .plain.nav rubix-nav-item>li.active>a,.rubix-panel-right .plain.nav rubix-nav-item>li>a:focus,.rubix-panel-right .plain.nav rubix-nav-item>li>a:hover{background-color:transparent;border-color:transparent;color:#fff}.rubix-panel-footer .plain.nav>li.active>a:before,.rubix-panel-footer .plain.nav rubix-menu>li.active>a:before,.rubix-panel-footer .plain.nav rubix-nav-item>li.active>a:before,.rubix-panel-header .plain.nav>li.active>a:before,.rubix-panel-header .plain.nav rubix-menu>li.active>a:before,.rubix-panel-header .plain.nav rubix-nav-item>li.active>a:before,.rubix-panel-left .plain.nav>li.active>a:before,.rubix-panel-left .plain.nav rubix-menu>li.active>a:before,.rubix-panel-left .plain.nav rubix-nav-item>li.active>a:before,.rubix-panel-right .plain.nav>li.active>a:before,.rubix-panel-right .plain.nav rubix-menu>li.active>a:before,.rubix-panel-right .plain.nav rubix-nav-item>li.active>a:before{content:\" \";left:50%;bottom:0;width:6px;display:block;margin-left:-7px;position:absolute;border-bottom:6px solid #fff;border-left:6px solid transparent;border-right:6px solid transparent}.rubix-panel-header .nav>li:first-child>a,.rubix-panel-header .nav rubix-menu:first-child>li>a,.rubix-panel-header .nav rubix-nav-item:first-child>li>a,.rubix-panel-left .nav>li:first-child>a,.rubix-panel-left .nav rubix-menu:first-child>li>a,.rubix-panel-left .nav rubix-nav-item:first-child>li>a{border-radius:0;border-top-left-radius:8px}.rubix-panel-header .nav>li:last-child>a,.rubix-panel-header .nav rubix-menu:last-child>li>a,.rubix-panel-header .nav rubix-nav-item:last-child>li>a,.rubix-panel-left .nav>li:last-child>a,.rubix-panel-left .nav rubix-menu:last-child>li>a,.rubix-panel-left .nav rubix-nav-item:last-child>li>a{border-radius:0;border-right:none;border-top-right-radius:8px}.rubix-panel-footer .plain.nav rubix-menu>li,.rubix-panel-footer .plain.nav rubix-nav-item>li,.rubix-panel-right .plain.nav rubix-menu>li,.rubix-panel-right .plain.nav rubix-nav-item>li{margin-bottom:0;margin-top:-1px}.rubix-panel-footer .plain.nav>li.active>a:before,.rubix-panel-footer .plain.nav rubix-menu>li.active>a:before,.rubix-panel-footer .plain.nav rubix-nav-item>li.active>a:before,.rubix-panel-right .plain.nav>li.active>a:before,.rubix-panel-right .plain.nav rubix-menu>li.active>a:before,.rubix-panel-right .plain.nav rubix-nav-item>li.active>a:before{top:0;bottom:auto;border-bottom:none;border-top:6px solid #fff}.rubix-panel-footer .nav>li:first-child>a,.rubix-panel-footer .nav rubix-menu:first-child>li>a,.rubix-panel-footer .nav rubix-nav-item:first-child>li>a,.rubix-panel-right .nav>li:first-child>a,.rubix-panel-right .nav rubix-menu:first-child>li>a,.rubix-panel-right .nav rubix-nav-item:first-child>li>a{border-radius:0;border-bottom-left-radius:8px}.rubix-panel-footer .nav>li:last-child>a,.rubix-panel-footer .nav rubix-menu:last-child>li>a,.rubix-panel-footer .nav rubix-nav-item:last-child>li>a,.rubix-panel-right .nav>li:last-child>a,.rubix-panel-right .nav rubix-menu:last-child>li>a,.rubix-panel-right .nav rubix-nav-item:last-child>li>a{border-radius:0;border-right:none;border-bottom-right-radius:8px}.rubix-panel.horizontal{overflow:hidden;border-radius:8px}.rubix-panel.horizontal .rubix-panel-left li>a,.rubix-panel.horizontal .rubix-panel-right li>a,.rubix-panel.horizontal rubix-panel-left li>a,.rubix-panel.horizontal rubix-panel-right li>a{border-radius:0!important}.rubix-panel.horizontal .rubix-panel-left li>a:after,.rubix-panel.horizontal .rubix-panel-right li>a:after,.rubix-panel.horizontal rubix-panel-left li>a:after,.rubix-panel.horizontal rubix-panel-right li>a:after{display:none}.rubix-panel+.rubix-panel.horizontal{border-top-left-radius:0;border-top-right-radius:0}@media (min-width:990px){.panel-tab-container .rubix-panel-footer,.panel-tab-container .rubix-panel-header,.rubix-panel.horizontal{width:100.1%;display:table}.rubix-panel.horizontal{table-layout:fixed}.rubix-panel.horizontal .rubix-panel-left li>a,.rubix-panel.horizontal .rubix-panel-right li>a,.rubix-panel.horizontal rubix-panel-left li>a,.rubix-panel.horizontal rubix-panel-right li>a{border:none}.rubix-panel.horizontal>div{display:table-row}.rubix-panel.horizontal .rubix-panel-body,.rubix-panel.horizontal .rubix-panel-left,.rubix-panel.horizontal .rubix-panel-right,.rubix-panel.horizontal rubix-panel-body,.rubix-panel.horizontal rubix-panel-left,.rubix-panel.horizontal rubix-panel-right{display:table-cell;vertical-align:top}.rubix-panel.horizontal .rubix-panel-left>ul,.rubix-panel.horizontal .rubix-panel-left>ul>li,.rubix-panel.horizontal .rubix-panel-right>ul,.rubix-panel.horizontal .rubix-panel-right>ul>li,.rubix-panel.horizontal rubix-panel-left rubix-nav-item,.rubix-panel.horizontal rubix-panel-right rubix-nav-item{display:block}.rubix-panel.horizontal .rubix-panel-left>ul>li,.rubix-panel.horizontal .rubix-panel-right>ul>li{width:100%}.rubix-panel.horizontal rubix-panel-left rubix-nav-item>li,.rubix-panel.horizontal rubix-panel-right rubix-nav-item>li{margin:0}.rubix-panel.horizontal .rubix-panel-left .nav-tabs.plain li.active>a:before{left:auto;right:-3px;bottom:45%;transform:rotate(-90deg)}.rubix-panel.horizontal .rubix-panel-right .nav-tabs.plain li.active>a:before{top:45%;left:3px;transform:rotate(-90deg)}.rubix-panel-body ul[role=tablist].nav{padding-left:25px;margin-left:-25px;margin-right:-50px}.rubix-panel-body ul[role=tablist].nav.nav-stacked{margin-right:-25px}}.rubix-panel-container.panel-plain{background:none!important}.rubix-panel-header.nav-inline .nav-tabs>li>a{padding:2px 25px!important;height:auto!important;line-height:2;display:block;border-bottom:0;border:none;margin-bottom:-1px}.rubix-panel-header.nav-inline .nav-tabs>li.active>a{border-top-left-radius:4px;border-top-right-radius:4px}.left-tag,.right-tag{position:relative;display:inline-block;text-decoration:none;border:none!important}.left-tag:before,.right-tag:before{top:0;width:0;height:0;content:\"\";position:absolute;border-style:solid;border-color:transparent}.left-tag{margin-left:12px;border-top-right-radius:4px;border-bottom-right-radius:4px;padding:0 10px 0 8px!important;margin-bottom:12.5px}.left-tag:before{left:-12px;float:left;border-right-color:inherit;border-width:12px 12px 12px 0}.right-tag{margin-right:12px;border-top-left-radius:4px;border-bottom-left-radius:4px;padding:0 8px 0 10px!important;margin-bottom:12.5px}.right-tag:before{right:-12px;float:right;border-left-color:inherit;border-width:12px 0 12px 12px}.terms{height:200px;overflow:auto;background:#fff;padding:25px}.rubix-timeline-view{padding:25px;padding-right:0;margin-left:37.5px;border-left:2px solid #eee;margin-bottom:-25px}.rubix-panel-body>.rubix-timeline-view{margin-top:-25px}.rubix-panel-header~.rubix-panel-body>.rubix-timeline-view{margin-top:0}.rubix-timeline-item{position:relative}.rubix-timeline-title{font-size:12px;background:#eee;padding:4px 15px;font-weight:700;display:inline-block;border-radius:8px}.rubix-timeline-icon{width:30px;height:30px;left:-41.5px;font-size:16px;padding:0 7px;background:#eee;line-height:28px;position:absolute;border-radius:100px;display:inline-block}.rubix-timeline-avatar{left:-41.5px}.rubix-timeline-body>ul{padding:0;list-style-type:none;border-bottom:2px solid #eee;margin-bottom:25px;margin-top:12.5px}.rubix-timeline-body>ul>li{padding-right:25px;padding-bottom:25px}.rubix-timeline-body>ul>li:before{left:-30px;content:\" \";margin-top:8px;position:absolute;border-radius:100px;border:4px solid #eee;box-shadow:0 0 0 6px #fff}.rubix-timeline-view~.rubix-timeline-view{margin-top:0;padding-top:0}.rubix-timeline-view.rubix-timeline-with-header{padding-top:0}.rubix-timeline-view.rubix-timeline-with-header>.rubix-timeline-item{position:relative}.rubix-timeline-view.rubix-timeline-with-header>.rubix-timeline-item>.rubix-timeline-header{height:50px;padding-top:10px;position:relative;padding-left:23px;margin-left:-64.5px}.rubix-timeline-view.rubix-timeline-with-header>.rubix-timeline-item>.rubix-timeline-header>.rubix-timeline-icon,.rubix-timeline-view.rubix-timeline-with-header>.rubix-timeline-item>.rubix-timeline-header>.rubix-timeline-title{left:0;position:relative}.rubix-timeline-view.rubix-timeline-with-header>.rubix-timeline-item>.rubix-timeline-header[class*=\" bg-\"]>.rubix-timeline-title,.rubix-timeline-view.rubix-timeline-with-header>.rubix-timeline-item>.rubix-timeline-header[class^=bg-]>.rubix-timeline-title{padding:0 10px;background:none!important}.rubix-timeline-view.rubix-timeline-with-header>.rubix-timeline-item>.rubix-timeline-body>ul{border:none;margin-bottom:0}.rubix-timeline-view.rubix-timeline-centered{margin-left:45%}.rubix-timeline-view.rubix-timeline-centered .rubix-timeline-body>ul{border:none;margin-bottom:0}.rubix-timeline-view.rubix-timeline-centered .rubix-timeline-body>ul>li{float:right;display:block}.rubix-timeline-view.rubix-timeline-centered .rubix-timeline-body>ul>li:after,.rubix-timeline-view.rubix-timeline-centered .rubix-timeline-body>ul>li:before{clear:both;content:\" \";display:table}.rubix-timeline-view.rubix-timeline-centered .rubix-timeline-body>ul>li:nth-child(odd){width:100%;float:left;margin-left:-100%;padding-left:25px;padding-right:50px}.alternate .rubix-timeline-view{margin:0;padding:0;border:none;margin-top:-25px}.alternate .rubix-timeline-view:before{left:50%;height:100%;content:\" \";position:absolute;padding-right:0;border-left:2px solid #eee}.alternate .rubix-timeline-view .rubix-timeline-item{padding-top:25px}.alternate .rubix-timeline-view.rubix-timeline-with-header .rubix-timeline-item{padding-top:0}.alternate .rubix-timeline-view .rubix-timeline-item:nth-child(odd){padding-bottom:25px}.alternate .rubix-timeline-view .rubix-timeline-header{margin:0;left:auto;padding-left:0;text-align:center}.alternate .rubix-timeline-view .rubix-timeline-header>.rubix-timeline-icon{top:1px;left:auto;padding-right:0;position:relative;border-radius:8px;border-top-right-radius:0;border-bottom-right-radius:0}.alternate .rubix-timeline-view .rubix-timeline-header>.rubix-timeline-title{height:30px;border-top-left-radius:0;border-bottom-left-radius:0}.alternate .rubix-timeline-view .rubix-timeline-header[class*=\" bg-\"]>.rubix-timeline-icon,.alternate .rubix-timeline-view .rubix-timeline-header[class^=bg-]>.rubix-timeline-icon{background:none}.alternate .rubix-timeline-view .rubix-timeline-body>ul{border:none}.alternate .rubix-timeline-view .rubix-timeline-body>ul>li{width:100%;position:relative;display:inline-block}.alternate .rubix-timeline-view .rubix-timeline-body>ul>li:before{left:50%;position:absolute}.alternate .rubix-timeline-view .rubix-timeline-body>ul>li:nth-child(odd){padding-right:50%;right:25px;padding-left:50px}.alternate .rubix-timeline-view .rubix-timeline-body>ul>li:nth-child(odd):before{margin-left:22px}.alternate .rubix-timeline-view .rubix-timeline-body>ul>li.left{padding-right:50%!important;right:25px!important;padding-left:50px!important}.alternate .rubix-timeline-view .rubix-timeline-body>ul>li.left:before{margin-left:22px!important}.alternate .rubix-timeline-view .rubix-timeline-body>ul>li:nth-child(2n){padding-left:50%;right:-25px;padding-right:50px}.alternate .rubix-timeline-view .rubix-timeline-body>ul>li:nth-child(2n):before{margin-left:-28px}.alternate .rubix-timeline-view .rubix-timeline-body>ul>li.right{padding-left:50%!important;right:-25px!important;padding-right:50px!important}.alternate .rubix-timeline-view .rubix-timeline-body>ul>li.right:before{margin-left:-28px!important}.pricing-table{padding:0;background:#fff;margin-bottom:25px}.pricing-table.preferred{z-index:1;left:-1px;border:1px solid gray}@media (min-width:990px){.pricing-table{border-right:1px solid #e9f0f5}.pricing-table:last-child{border:none}}.pricing-table.preferred~.pricing-table{left:-1px}.pricing-table-header{color:#8ba0af;background:#d2e0eb}.pricing-table-header>h3{margin:0;font-size:18px;font-weight:300;padding-top:25px;padding-bottom:25px}.pricing-table-price{color:inherit;background:#d2e0eb;margin-top:25px}.pricing-table-price h2{left:50%;width:85px;margin:auto;height:85px;font-size:24px;line-height:75px;position:absolute;background:inherit;margin-left:-42.5px;border-radius:100px;border:5px solid #fff;margin-top:-12.5px}.pricing-table-body{margin-bottom:25px;margin-top:50px}.pricing-table-feature{margin:0 25px;padding:12.5px}.pricing-btn-container{padding:25px;padding-bottom:0;padding-top:12.5px}.pricing-btn-container>button{width:100%;border-radius:8px}.pricing-btn-container>button.btn-lightblue50:focus,.pricing-btn-container>button.btn-lightblue50:hover{background:#8ba0af;border-color:#8ba0af}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{margin-top:6px}.popover{z-index:999999999}.badge,.label{font-size:75%}label{display:block}label.inline{display:inline-block}#app-container{display:block}#container{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;height:100%;overflow:auto;overflow-x:hidden;min-height:100vh}div#__bs_notify__{z-index:10000000000000000!important;background-color:#6788ff!important}.ps-container .ps-scrollbar-x-rail{position:absolute;bottom:3px;height:6px;opacity:0;filter:alpha(opacity=0);-o-transition:background-color .2s ease,opacity .2s ease;-webkit-transition:background-color .2s ease,opacity .2s ease;-moz-transition:background-color .2s ease,opacity .2s ease;transition:background-color .2s ease,opacity .2s ease}.ps-container.hover .ps-scrollbar-x-rail,.ps-container:hover .ps-scrollbar-x-rail{opacity:.6;filter:alpha(opacity=60)}.ps-container .ps-scrollbar-x-rail.hover,.ps-container .ps-scrollbar-x-rail.in-scrolling,.ps-container .ps-scrollbar-x-rail:hover{background-color:#fff;opacity:.9;filter:alpha(opacity=90)}.ps-container .ps-scrollbar-y-rail{position:absolute;right:3px;width:6px;opacity:0;filter:alpha(opacity=0);-o-transition:background-color .2s ease,opacity .2s ease;-webkit-transition:background-color .2s ease,opacity .2s ease;-moz-transition:background-color .2s ease,opacity .2s ease;transition:background-color .2s ease,opacity .2s ease}.ps-container.hover .ps-scrollbar-y-rail,.ps-container:hover .ps-scrollbar-y-rail{opacity:.6;filter:alpha(opacity=60)}.ps-container .ps-scrollbar-y-rail.hover,.ps-container .ps-scrollbar-y-rail.in-scrolling,.ps-container .ps-scrollbar-y-rail:hover{background-color:#fff;opacity:.9;filter:alpha(opacity=90)}.ps-container .ps-scrollbar-x{position:absolute;bottom:0;height:6px;background-color:#aaa;-o-transition:background-color .2s ease;-webkit-transition:background-color .2s ease;-moz-transition:background-color .2s ease;transition:background-color .2s ease}.ps-container.ie6 .ps-scrollbar-x{font-size:0}.ps-container .ps-scrollbar-x-rail.hover .ps-scrollbar-x,.ps-container .ps-scrollbar-x-rail:hover .ps-scrollbar-x{background-color:#999}.ps-container .ps-scrollbar-y{position:absolute;right:0;width:6px;background-color:#aaa;-o-transition:background-color .2s ease;-webkit-transition:background-color .2s ease;-moz-transition:background-color .2s ease;transition:background-color .2s ease}.ps-container.ie6 .ps-scrollbar-y{font-size:0}.ps-container .ps-scrollbar-y-rail.hover .ps-scrollbar-y,.ps-container .ps-scrollbar-y-rail:hover .ps-scrollbar-y{background-color:#999}.ps-container.ie .ps-scrollbar-x,.ps-container.ie .ps-scrollbar-y{visibility:hidden}.ps-container.ie.hover .ps-scrollbar-x,.ps-container.ie.hover .ps-scrollbar-y,.ps-container.ie:hover .ps-scrollbar-x,.ps-container.ie:hover .ps-scrollbar-y{visibility:visible}.doc-sidebar{padding:25px;overflow:auto!important}.doc-sidebar-link{display:block;margin-left:-25px;margin-right:-25px;border:none!important;padding:5px 12.5px 5px 25px}.doc-sidebar-group-links a{padding-left:37.5px}.doc-sidebar-group-name{font-size:12px;cursor:pointer;max-width:250px;font-weight:700;user-select:none;position:relative;margin-top:12.5px;margin-left:-25px;padding-left:25px;padding-right:25px;padding-bottom:5px;margin-right:-25px;word-wrap:break-word;text-transform:uppercase;color:hsla(203,8%,57%,.6)}.doc-sidebar-group-name.minus,.doc-sidebar-group-name:hover{color:#89949b}.doc-sidebar-group-name:before{top:-4px;left:10px;content:\"+\";font-size:16px;position:absolute}.doc-sidebar-group-name.minus:before{top:-8px;left:12px;content:\"-\";font-size:20px}.doc-sidebar-link:hover{color:#fff;background:#28514e}.doc-sidebar-link.active{background:#2eb398;color:#fff}.bs-example{background:#fff;position:relative;margin-bottom:-8px;border:1px solid #ddd;padding:45px 15px 15px;border-radius:4px 4px 0 0}.bs-example:after{top:15px;left:15px;color:#959595;font-size:12px;font-weight:700;content:\"Example\";position:absolute;letter-spacing:1px;text-transform:uppercase}.bs-example+pre{font-size:14px;border-color:#ddd;border-radius:0 0 4px 4px!important}.upgrade-guide-item{padding-left:12.5px;list-style-type:disc}.bs-example .dropdown-menu.open{position:static;display:block;margin-bottom:5px;clear:left}.bs-example.tooltip-static .tooltip{margin:5px 10px;position:relative;display:inline-block}.bs-example.bs-example-popover-contained{height:200px}.bs-example.bs-example-popover-scroll{height:200px;overflow:scroll}.show-grid [class^=col-]{background:#eee;padding-top:10px;padding-bottom:10px;border:1px solid #ddd}.bs-example .container{width:auto;max-width:900px}a[role=menuitem]>.container-fluid{margin:-4px -25px;padding:4px 25px}.icon-1-and-quarter-x{font-size:125%}.icon-1-and-half-x{font-size:150%}.icon-1x{font-size:100%}.icon-2-and-quarter-x{font-size:250%}.icon-2-and-half-x{font-size:300%}.icon-2x{font-size:200%}.icon-3-and-quarter-x{font-size:375%}.icon-3-and-half-x{font-size:450%}.icon-3x{font-size:300%}.icon-4-and-quarter-x{font-size:500%}.icon-4-and-half-x{font-size:600%}.icon-4x{font-size:400%}.icon-rotate-45{transform:rotate(45deg)}.icon-rotate-90{transform:rotate(90deg)}.icon-rotate-135{transform:rotate(135deg)}.icon-rotate-180{transform:rotate(180deg)}.icon-rotate-225{transform:rotate(225deg)}.icon-rotate-270{transform:rotate(270deg)}.icon-rotate-315{transform:rotate(315deg)}.icon-rotate-360{transform:rotate(1turn)}@media (max-width:989px){.col-xs-only-gutter-top{margin-top:25px}.col-xs-only-gutter-left{margin-left:25px}.col-xs-only-gutter-right{margin-right:25px}.col-xs-only-gutter-bottom{margin-bottom:25px}.col-xs-only-collapse-top{padding-top:0}.col-xs-only-collapse-left{padding-left:0}.col-xs-only-collapse-right{padding-right:0}.col-xs-only-collapse-bottom{padding-bottom:0}}@media (min-width:990px) and (max-width:1151px){.col-sm-only-gutter-top{margin-top:25px}.col-sm-only-gutter-left{margin-left:25px}.col-sm-only-gutter-right{margin-right:25px}.col-sm-only-gutter-bottom{margin-bottom:25px}.col-sm-only-collapse-top{padding-top:0}.col-sm-only-collapse-left{padding-left:0}.col-sm-only-collapse-right{padding-right:0}.col-sm-only-collapse-bottom{padding-bottom:0}}@media (min-width:1152px) and (max-width:1365px){.col-md-only-gutter-top{margin-top:25px}.col-md-only-gutter-left{margin-left:25px}.col-md-only-gutter-right{margin-right:25px}.col-md-only-gutter-bottom{margin-bottom:25px}.col-md-only-collapse-top{padding-top:0}.col-md-only-collapse-left{padding-left:0}.col-md-only-collapse-right{padding-right:0}.col-md-only-collapse-bottom{padding-bottom:0}}@media (min-width:1366px){.col-lg-only-gutter-top{margin-top:25px}.col-lg-only-gutter-left{margin-left:25px}.col-lg-only-gutter-right{margin-right:25px}.col-lg-only-gutter-bottom{margin-bottom:25px}.col-lg-only-collapse-top{padding-top:0}.col-lg-only-collapse-left{padding-left:0}.col-lg-only-collapse-right{padding-right:0}.col-lg-only-collapse-bottom{padding-bottom:0}}.col-xs-gutter-top{margin-top:25px}.col-xs-gutter-left{margin-left:25px}.col-xs-gutter-right{margin-right:25px}.col-xs-gutter-bottom{margin-bottom:25px}.col-xs-collapse-top{padding-top:0}.col-xs-collapse-left{padding-left:0}.col-xs-collapse-right{padding-right:0}.col-xs-collapse-bottom{padding-bottom:0}@media (min-width:990px){.col-sm-gutter-top{margin-top:25px}.col-sm-gutter-left{margin-left:25px}.col-sm-gutter-right{margin-right:25px}.col-sm-gutter-bottom{margin-bottom:25px}.col-sm-collapse-top{padding-top:0}.col-sm-collapse-left{padding-left:0}.col-sm-collapse-right{padding-right:0}.col-sm-collapse-bottom{padding-bottom:0}}@media (min-width:1152px){.col-md-gutter-top{margin-top:25px}.col-md-gutter-left{margin-left:25px}.col-md-gutter-right{margin-right:25px}.col-md-gutter-bottom{margin-bottom:25px}.col-md-collapse-top{padding-top:0}.col-md-collapse-left{padding-left:0}.col-md-collapse-right{padding-right:0}.col-md-collapse-bottom{padding-bottom:0}}@media (min-width:1366px){.col-lg-gutter-top{margin-top:25px}.col-lg-gutter-left{margin-left:25px}.col-lg-gutter-right{margin-right:25px}.col-lg-gutter-bottom{margin-bottom:25px}.col-lg-collapse-top{padding-top:0}.col-lg-collapse-left{padding-left:0}.col-lg-collapse-right{padding-right:0}.col-lg-collapse-bottom{padding-bottom:0}}.container-xs-height{width:100.1%;display:table;table-layout:fixed;padding-left:0;padding-right:0}.container-xs-height:after,.container-xs-height:before{clear:none;content:none;display:none}.row-xs-height{display:table-row}.row-xs-height:after,.row-xs-height:before{clear:none;content:none;display:none}.col-xs-height{vertical-align:top;display:table-cell;float:none}@media (min-width:990px){.container-sm-height{width:100.1%;display:table;table-layout:fixed;padding-left:0;padding-right:0}.container-sm-height:after,.container-sm-height:before{clear:none;content:none;display:none}.row-sm-height{display:table-row}.row-sm-height:after,.row-sm-height:before{clear:none;content:none;display:none}.col-sm-height{vertical-align:top;display:table-cell;float:none}}@media (min-width:1152px){.container-md-height{width:100.1%;display:table;table-layout:fixed;padding-left:0;padding-right:0}.container-md-height:after,.container-md-height:before{clear:none;content:none;display:none}.row-md-height{display:table-row}.row-md-height:after,.row-md-height:before{clear:none;content:none;display:none}.col-md-height{vertical-align:top;display:table-cell;float:none}}@media (min-width:1366px){.container-lg-height{width:100.1%;display:table;table-layout:fixed;padding-left:0;padding-right:0}.container-lg-height:after,.container-lg-height:before{clear:none;content:none;display:none}.row-lg-height{display:table-row}.row-lg-height:after,.row-lg-height:before{clear:none;content:none;display:none}.col-lg-height{vertical-align:top;display:table-cell;float:none}}.col-top{vertical-align:top}.col-middle{vertical-align:middle}.col-bottom{vertical-align:bottom}.img-responsive{width:100%}.grid-collapse{padding:0}.grid-collapse .row,.grid-collapse>rubix-row>.row{margin:0}.grid-collapse .row>[class^=col-],.grid-collapse .row>rubix-col>[class^=col-],.grid-collapse>rubix-row>.row>[class^=col-],.grid-collapse>rubix-row>.row>rubix-col>[class^=col-]{padding:0}.grid-gutter{margin:25px}.grid-gutter-top{margin-top:25px}.grid-gutter-left{margin-left:25px}.grid-gutter-right{margin-right:25px}.grid-gutter-bottom{margin-bottom:25px}.trumbowyg-box,.trumbowyg-editor{border:none!important}.trumbowyg-box{color:#333!important;border-top:1px solid #d7e0e2!important}.trumbowyg-editor{border-bottom:1px solid #d7e0e2!important}.trumbowyg-button-pane{background:#fff!important}.trumbowyg-button-group button{margin-bottom:0!important}.trumbowyg-button-group button.trumbowyg-active,.trumbowyg-button-group button:focus,.trumbowyg-button-group button:hover{background:#d7e0e2!important}body.flash{display:none}.slider-handle,.slider-selection,.slider-track,.slider.slider-disabled .slider-handle,.slider.slider-disabled .slider-track{filter:none;box-shadow:none;border-radius:0;background-image:none;background-repeat:none}.slider-track{background:#f0f0f0}.slider-handle{background:#3a94a5}.slider.slider-disabled .slider-track{background:#e5e5e5}.bootstrap-datetimepicker-widget a[data-action]{border:none;display:inline}.bootstrap-datetimepicker-widget button[data-action]{padding:2px 15px}.bootstrap-datetimepicker-widget td a[data-action=togglePicker]{border:0;display:block;cursor:pointer;border-radius:20px;padding:12px!important}.bootstrap-datetimepicker-widget td a[data-action=togglePicker] span{margin:0;padding:5px;font-size:180%;background:none;width:54px!important;height:auto!important;line-height:1!important}.bootstrap-datetimepicker-widget th.picker-switch{background:#eee}.bootstrap-datetimepicker-widget .picker-switch.accordion-toggle{background:#f5f5f5!important}.bootstrap-datetimepicker-widget table td.today:before{border-left:7px solid transparent;border-bottom:7px solid #428bca}.datetimepicker-inline{width:100%;padding:25px;display:table}html[dir=rtl] [class*=\" icon-\"].float-right-rtl,html[dir=rtl] [class^=icon-].float-right-rtl{position:relative;float:right}body{opacity:1;transition:all .7s ease}body.fade-out{transition:all .25s ease;opacity:0}#app-preloader>.preloader{top:0;left:0;right:0;bottom:0;position:fixed;background:#e9edf2;z-index:99999999999}#app-preloader>.preloader>img{margin:auto;display:block;margin-top:150px;position:relative}@keyframes vex-flipin-horizontal{0%{opacity:0;transform:rotateY(-90deg);-webkit-transform:rotateY(-90deg);-moz-transform:rotateY(-90deg);-ms-transform:rotateY(-90deg);-o-transform:rotateY(-90deg)}to{opacity:1;transform:rotateY(0deg);-webkit-transform:rotateY(0deg);-moz-transform:rotateY(0deg);-ms-transform:rotateY(0deg);-o-transform:rotateY(0deg)}}@-webkit-keyframes vex-flipin-horizontal{0%{opacity:0;transform:rotateY(-90deg);-webkit-transform:rotateY(-90deg);-moz-transform:rotateY(-90deg);-ms-transform:rotateY(-90deg);-o-transform:rotateY(-90deg)}to{opacity:1;transform:rotateY(0deg);-webkit-transform:rotateY(0deg);-moz-transform:rotateY(0deg);-ms-transform:rotateY(0deg);-o-transform:rotateY(0deg)}}@-moz-keyframes vex-flipin-horizontal{0%{opacity:0;transform:rotateY(-90deg);-webkit-transform:rotateY(-90deg);-moz-transform:rotateY(-90deg);-ms-transform:rotateY(-90deg);-o-transform:rotateY(-90deg)}to{opacity:1;transform:rotateY(0deg);-webkit-transform:rotateY(0deg);-moz-transform:rotateY(0deg);-ms-transform:rotateY(0deg);-o-transform:rotateY(0deg)}}@-ms-keyframes vex-flipin-horizontal{0%{opacity:0;transform:rotateY(-90deg);-webkit-transform:rotateY(-90deg);-moz-transform:rotateY(-90deg);-ms-transform:rotateY(-90deg);-o-transform:rotateY(-90deg)}to{opacity:1;transform:rotateY(0deg);-webkit-transform:rotateY(0deg);-moz-transform:rotateY(0deg);-ms-transform:rotateY(0deg);-o-transform:rotateY(0deg)}}@-o-keyframes vex-flipin-horizontal{0%{opacity:0;transform:rotateY(-90deg);-webkit-transform:rotateY(-90deg);-moz-transform:rotateY(-90deg);-ms-transform:rotateY(-90deg);-o-transform:rotateY(-90deg)}to{opacity:1;transform:rotateY(0deg);-webkit-transform:rotateY(0deg);-moz-transform:rotateY(0deg);-ms-transform:rotateY(0deg);-o-transform:rotateY(0deg)}}@keyframes vex-flipout-horizontal{0%{opacity:1;transform:rotateY(0deg);-webkit-transform:rotateY(0deg);-moz-transform:rotateY(0deg);-ms-transform:rotateY(0deg);-o-transform:rotateY(0deg)}to{opacity:0;transform:rotateY(90deg);-webkit-transform:rotateY(90deg);-moz-transform:rotateY(90deg);-ms-transform:rotateY(90deg);-o-transform:rotateY(90deg)}}@-webkit-keyframes vex-flipout-horizontal{0%{opacity:1;transform:rotateY(0deg);-webkit-transform:rotateY(0deg);-moz-transform:rotateY(0deg);-ms-transform:rotateY(0deg);-o-transform:rotateY(0deg)}to{opacity:0;transform:rotateY(90deg);-webkit-transform:rotateY(90deg);-moz-transform:rotateY(90deg);-ms-transform:rotateY(90deg);-o-transform:rotateY(90deg)}}@-moz-keyframes vex-flipout-horizontal{0%{opacity:1;transform:rotateY(0deg);-webkit-transform:rotateY(0deg);-moz-transform:rotateY(0deg);-ms-transform:rotateY(0deg);-o-transform:rotateY(0deg)}to{opacity:0;transform:rotateY(90deg);-webkit-transform:rotateY(90deg);-moz-transform:rotateY(90deg);-ms-transform:rotateY(90deg);-o-transform:rotateY(90deg)}}@-ms-keyframes vex-flipout-horizontal{0%{opacity:1;transform:rotateY(0deg);-webkit-transform:rotateY(0deg);-moz-transform:rotateY(0deg);-ms-transform:rotateY(0deg);-o-transform:rotateY(0deg)}to{opacity:0;transform:rotateY(90deg);-webkit-transform:rotateY(90deg);-moz-transform:rotateY(90deg);-ms-transform:rotateY(90deg);-o-transform:rotateY(90deg)}}@-o-keyframes vex-flipout-horizontal{0%{opacity:1;transform:rotateY(0deg);-webkit-transform:rotateY(0deg);-moz-transform:rotateY(0deg);-ms-transform:rotateY(0deg);-o-transform:rotateY(0deg)}to{opacity:0;transform:rotateY(90deg);-webkit-transform:rotateY(90deg);-moz-transform:rotateY(90deg);-ms-transform:rotateY(90deg);-o-transform:rotateY(90deg)}}.vex.vex-theme-flat-attack{-webkit-perspective:1300px;-moz-perspective:1300px;-ms-perspective:1300px;-o-perspective:1300px;perspective:1300px;-webkit-perspective-origin:50% 150px;-moz-perspective-origin:50% 150px;-ms-perspective-origin:50% 150px;-o-perspective-origin:50% 150px;perspective-origin:50% 150px;padding-top:100px;padding-bottom:100px;font-size:1.5em}.vex.vex-theme-flat-attack.vex-closing .vex-content{animation:vex-flipout-horizontal .5s;-webkit-animation:vex-flipout-horizontal .5s;-moz-animation:vex-flipout-horizontal .5s;-ms-animation:vex-flipout-horizontal .5s;-o-animation:vex-flipout-horizontal .5s;-webkit-backface-visibility:hidden}.vex.vex-theme-flat-attack .vex-content{-webkit-transform-style:preserve-3d;-moz-transform-style:preserve-3d;transform-style:preserve-3d;animation:vex-flipin-horizontal .5s;-webkit-animation:vex-flipin-horizontal .5s;-moz-animation:vex-flipin-horizontal .5s;-ms-animation:vex-flipin-horizontal .5s;-o-animation:vex-flipin-horizontal .5s;-webkit-backface-visibility:hidden;font-family:Lato,sans-serif;font-weight:200;background:#fff;color:#444;padding:2em 2em 3em;line-height:1.5em;position:relative;margin:0 auto;max-width:100%;width:600px}.vex.vex-theme-flat-attack .vex-content h1,.vex.vex-theme-flat-attack .vex-content h2,.vex.vex-theme-flat-attack .vex-content h3,.vex.vex-theme-flat-attack .vex-content h4,.vex.vex-theme-flat-attack .vex-content h5,.vex.vex-theme-flat-attack .vex-content h6,.vex.vex-theme-flat-attack .vex-content li,.vex.vex-theme-flat-attack .vex-content p,.vex.vex-theme-flat-attack .vex-content ul{color:inherit}.vex.vex-theme-flat-attack .vex-close{position:absolute;top:0;right:0;cursor:pointer}.vex.vex-theme-flat-attack .vex-close:before{font-family:Lato,sans-serif;font-weight:100;line-height:1px;padding-top:.5em;display:block;font-size:2em;text-indent:1px;overflow:hidden;height:1.25em;width:1.25em;text-align:center;top:0;right:0;color:#fff;background:#666}.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input,.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-message{margin-bottom:.5em}.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=date],.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=datetime-local],.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=datetime],.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=email],.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=month],.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=number],.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=password],.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=search],.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=tel],.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=text],.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=time],.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=url],.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=week],.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input textarea{-webkit-border-radius:3px;-moz-border-radius:3px;-ms-border-radius:3px;-o-border-radius:3px;border-radius:3px;background:#f0f0f0;width:100%;padding:.25em .67em;border:0;font-family:inherit;font-weight:inherit;font-size:inherit;min-height:2.5em;margin:0 0 .25em}.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=date]:focus,.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=datetime-local]:focus,.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=datetime]:focus,.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=email]:focus,.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=month]:focus,.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=number]:focus,.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=password]:focus,.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=search]:focus,.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=tel]:focus,.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=text]:focus,.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=time]:focus,.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=url]:focus,.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type=week]:focus,.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input textarea:focus{-webkit-box-shadow:inset 0 0 0 2px #666;-moz-box-shadow:inset 0 0 0 2px #666;box-shadow:inset 0 0 0 2px #666;outline:none}.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-buttons{*zoom:1;padding-top:1em;margin-bottom:-3em;margin-left:-2em;margin-right:-2em}.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-buttons:after{content:\"\";display:table;clear:both}.vex.vex-theme-flat-attack .vex-dialog-button{-webkit-border-radius:0;-moz-border-radius:0;-ms-border-radius:0;-o-border-radius:0;border-radius:0;border:0;margin:0;float:right;padding:.5em 1em;font-size:1.13em;text-transform:uppercase;font-weight:200;letter-spacing:.1em;line-height:1em;font-family:inherit}.vex.vex-theme-flat-attack .vex-dialog-button.vex-last{margin-left:0}.vex.vex-theme-flat-attack .vex-dialog-button:focus{outline:none}.vex.vex-theme-flat-attack .vex-dialog-button.vex-dialog-button-primary{background:#666;color:#fff}.vex.vex-theme-flat-attack .vex-dialog-button.vex-dialog-button-primary:focus{-webkit-box-shadow:inset 0 3px rgba(0,0,0,.2);-moz-box-shadow:inset 0 3px rgba(0,0,0,.2);box-shadow:inset 0 3px rgba(0,0,0,.2)}.vex.vex-theme-flat-attack .vex-dialog-button.vex-dialog-button-secondary{background:#fff;color:#ccc}.vex.vex-theme-flat-attack .vex-dialog-button.vex-dialog-button-secondary:focus{-webkit-box-shadow:inset 0 3px #aaa;-moz-box-shadow:inset 0 3px #aaa;box-shadow:inset 0 3px #aaa;background:#eee;color:#777}.vex.vex-theme-flat-attack .vex-dialog-button.vex-dialog-button-secondary:active,.vex.vex-theme-flat-attack .vex-dialog-button.vex-dialog-button-secondary:hover{color:#777}.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink .vex-close:before{background:#ff7ea7}.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink .vex-dialog-form .vex-dialog-input input[type=date]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink .vex-dialog-form .vex-dialog-input input[type=datetime-local]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink .vex-dialog-form .vex-dialog-input input[type=datetime]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink .vex-dialog-form .vex-dialog-input input[type=email]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink .vex-dialog-form .vex-dialog-input input[type=month]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink .vex-dialog-form .vex-dialog-input input[type=number]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink .vex-dialog-form .vex-dialog-input input[type=password]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink .vex-dialog-form .vex-dialog-input input[type=search]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink .vex-dialog-form .vex-dialog-input input[type=tel]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink .vex-dialog-form .vex-dialog-input input[type=text]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink .vex-dialog-form .vex-dialog-input input[type=time]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink .vex-dialog-form .vex-dialog-input input[type=url]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink .vex-dialog-form .vex-dialog-input input[type=week]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink .vex-dialog-form .vex-dialog-input textarea:focus{-webkit-box-shadow:inset 0 0 0 2px #ff7ea7;-moz-box-shadow:inset 0 0 0 2px #ff7ea7;box-shadow:inset 0 0 0 2px #ff7ea7}.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink .vex-dialog-form .vex-dialog-buttons .vex-dialog-button.vex-dialog-button-primary{background:#ff7ea7}.vex.vex-theme-flat-attack.vex-theme-flat-attack-red .vex-close:before{background:#ce4a55}.vex.vex-theme-flat-attack.vex-theme-flat-attack-red .vex-dialog-form .vex-dialog-input input[type=date]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-red .vex-dialog-form .vex-dialog-input input[type=datetime-local]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-red .vex-dialog-form .vex-dialog-input input[type=datetime]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-red .vex-dialog-form .vex-dialog-input input[type=email]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-red .vex-dialog-form .vex-dialog-input input[type=month]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-red .vex-dialog-form .vex-dialog-input input[type=number]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-red .vex-dialog-form .vex-dialog-input input[type=password]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-red .vex-dialog-form .vex-dialog-input input[type=search]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-red .vex-dialog-form .vex-dialog-input input[type=tel]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-red .vex-dialog-form .vex-dialog-input input[type=text]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-red .vex-dialog-form .vex-dialog-input input[type=time]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-red .vex-dialog-form .vex-dialog-input input[type=url]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-red .vex-dialog-form .vex-dialog-input input[type=week]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-red .vex-dialog-form .vex-dialog-input textarea:focus{-webkit-box-shadow:inset 0 0 0 2px #ce4a55;-moz-box-shadow:inset 0 0 0 2px #ce4a55;box-shadow:inset 0 0 0 2px #ce4a55}.vex.vex-theme-flat-attack.vex-theme-flat-attack-red .vex-dialog-form .vex-dialog-buttons .vex-dialog-button.vex-dialog-button-primary{background:#ce4a55}.vex.vex-theme-flat-attack.vex-theme-flat-attack-green .vex-close:before{background:#34b989}.vex.vex-theme-flat-attack.vex-theme-flat-attack-green .vex-dialog-form .vex-dialog-input input[type=date]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-green .vex-dialog-form .vex-dialog-input input[type=datetime-local]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-green .vex-dialog-form .vex-dialog-input input[type=datetime]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-green .vex-dialog-form .vex-dialog-input input[type=email]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-green .vex-dialog-form .vex-dialog-input input[type=month]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-green .vex-dialog-form .vex-dialog-input input[type=number]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-green .vex-dialog-form .vex-dialog-input input[type=password]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-green .vex-dialog-form .vex-dialog-input input[type=search]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-green .vex-dialog-form .vex-dialog-input input[type=tel]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-green .vex-dialog-form .vex-dialog-input input[type=text]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-green .vex-dialog-form .vex-dialog-input input[type=time]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-green .vex-dialog-form .vex-dialog-input input[type=url]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-green .vex-dialog-form .vex-dialog-input input[type=week]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-green .vex-dialog-form .vex-dialog-input textarea:focus{-webkit-box-shadow:inset 0 0 0 2px #34b989;-moz-box-shadow:inset 0 0 0 2px #34b989;box-shadow:inset 0 0 0 2px #34b989}.vex.vex-theme-flat-attack.vex-theme-flat-attack-green .vex-dialog-form .vex-dialog-buttons .vex-dialog-button.vex-dialog-button-primary{background:#34b989}.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue .vex-close:before{background:#477fa5}.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue .vex-dialog-form .vex-dialog-input input[type=date]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue .vex-dialog-form .vex-dialog-input input[type=datetime-local]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue .vex-dialog-form .vex-dialog-input input[type=datetime]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue .vex-dialog-form .vex-dialog-input input[type=email]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue .vex-dialog-form .vex-dialog-input input[type=month]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue .vex-dialog-form .vex-dialog-input input[type=number]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue .vex-dialog-form .vex-dialog-input input[type=password]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue .vex-dialog-form .vex-dialog-input input[type=search]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue .vex-dialog-form .vex-dialog-input input[type=tel]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue .vex-dialog-form .vex-dialog-input input[type=text]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue .vex-dialog-form .vex-dialog-input input[type=time]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue .vex-dialog-form .vex-dialog-input input[type=url]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue .vex-dialog-form .vex-dialog-input input[type=week]:focus,.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue .vex-dialog-form .vex-dialog-input textarea:focus{-webkit-box-shadow:inset 0 0 0 2px #477fa5;-moz-box-shadow:inset 0 0 0 2px #477fa5;box-shadow:inset 0 0 0 2px #477fa5}.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue .vex-dialog-form .vex-dialog-buttons .vex-dialog-button.vex-dialog-button-primary{background:#477fa5}.vex-loading-spinner.vex-theme-flat-attack{height:4em;width:4em}ul.messenger-theme-flat{-webkit-border-radius:4px;-moz-border-radius:4px;-ms-border-radius:4px;-o-border-radius:4px;border-radius:4px;-moz-user-select:none;-webkit-user-select:none;-o-user-select:none;user-select:none;background:#404040}ul.messenger-theme-flat.messenger-empty{display:none}ul.messenger-theme-flat .messenger-message{-webkit-box-shadow:inset 0 1px hsla(0,0%,100%,.13),inset 48px 0 0 #292929;-moz-box-shadow:inset 0 1px hsla(0,0%,100%,.13),inset 48px 0 0 #292929;box-shadow:inset 0 1px hsla(0,0%,100%,.13),inset 48px 0 0 #292929;-webkit-border-radius:0;-moz-border-radius:0;-ms-border-radius:0;-o-border-radius:0;border-radius:0;position:relative;border:0;margin-bottom:0;font-size:13px;background:transparent;color:#f0f0f0;font-weight:500;padding:10px 30px 13px 65px}ul.messenger-theme-flat .messenger-message .messenger-close{position:absolute;top:0;right:0;color:#888;opacity:1;font-weight:700;display:block;font-size:20px;line-height:20px;padding:8px 10px 7px 7px;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}ul.messenger-theme-flat .messenger-message .messenger-close:hover{color:#bbb}ul.messenger-theme-flat .messenger-message .messenger-close:active{color:#777}ul.messenger-theme-flat .messenger-message .messenger-actions{float:none;margin-top:10px}ul.messenger-theme-flat .messenger-message .messenger-actions a{-webkit-border-radius:4px;-moz-border-radius:4px;-ms-border-radius:4px;-o-border-radius:4px;border-radius:4px;text-decoration:none;color:#aaa;background:#2e2e2e;display:inline-block;padding:10px;margin-right:10px;padding:4px 11px 6px;text-transform:capitalize}ul.messenger-theme-flat .messenger-message .messenger-actions a:hover{color:#f0f0f0;background:#2e2e2e}ul.messenger-theme-flat .messenger-message .messenger-actions a:active{background:#292929;color:#aaa}ul.messenger-theme-flat .messenger-message .messenger-actions .messenger-phrase{display:none}ul.messenger-theme-flat .messenger-message .messenger-message-inner:before{-webkit-border-radius:50%;-moz-border-radius:50%;-ms-border-radius:50%;-o-border-radius:50%;border-radius:50%;position:absolute;left:17px;display:block;content:\" \";top:50%;margin-top:-8px;height:13px;width:13px;z-index:20}ul.messenger-theme-flat .messenger-message.alert-success .messenger-message-inner:before{background:#5fca4a}ul.messenger-theme-flat .messenger-message.alert-info .messenger-message-inner:before{background:#61c4b8}ul.messenger-theme-flat .messenger-message.alert-error .messenger-message-inner:before{background:#dd6a45}ul.messenger-theme-flat .messenger-message.alert-error.messenger-retry-soon .messenger-spinner{width:32px;height:32px;background:transparent}ul.messenger-theme-flat .messenger-message.alert-error.messenger-retry-soon .messenger-spinner .messenger-spinner-side .messenger-spinner-fill{background:#dd6a45;-webkit-animation-duration:20s;-moz-animation-duration:20s;-ms-animation-duration:20s;-o-animation-duration:20s;animation-duration:20s;opacity:1}ul.messenger-theme-flat .messenger-message.alert-error.messenger-retry-soon .messenger-spinner:after{content:\"\";background:#292929;position:absolute;width:26px;height:26px;border-radius:50%;top:3px;left:3px;display:block}ul.messenger-theme-flat .messenger-message.alert-error.messenger-retry-later .messenger-spinner{width:32px;height:32px;background:transparent}ul.messenger-theme-flat .messenger-message.alert-error.messenger-retry-later .messenger-spinner .messenger-spinner-side .messenger-spinner-fill{background:#dd6a45;-webkit-animation-duration:600s;-moz-animation-duration:600s;-ms-animation-duration:600s;-o-animation-duration:600s;animation-duration:600s;opacity:1}ul.messenger-theme-flat .messenger-message.alert-error.messenger-retry-later .messenger-spinner:after{content:\"\";background:#292929;position:absolute;width:26px;height:26px;border-radius:50%;top:3px;left:3px;display:block}ul.messenger-theme-flat .messenger-message-slot.messenger-last .messenger-message{-webkit-border-radius:4px 4px 0 0;-moz-border-radius:4px 4px 0 0;-ms-border-radius:4px 4px 0 0;-o-border-radius:4px 4px 0 0;border-radius:4px 4px 0 0;-webkit-box-shadow:inset 48px 0 0 #292929;-moz-box-shadow:inset 48px 0 0 #292929;box-shadow:inset 48px 0 0 #292929}ul.messenger-theme-flat .messenger-message-slot.messenger-first .messenger-message{-webkit-border-radius:0 0 4px 4px;-moz-border-radius:0 0 4px 4px;-ms-border-radius:0 0 4px 4px;-o-border-radius:0 0 4px 4px;border-radius:0 0 4px 4px;-webkit-box-shadow:inset 0 1px hsla(0,0%,100%,.13),inset 48px 0 0 #292929;-moz-box-shadow:inset 0 1px hsla(0,0%,100%,.13),inset 48px 0 0 #292929;box-shadow:inset 0 1px hsla(0,0%,100%,.13),inset 48px 0 0 #292929}ul.messenger-theme-flat .messenger-message-slot.messenger-first.messenger-last .messenger-message{-webkit-border-radius:4px;-moz-border-radius:4px;-ms-border-radius:4px;-o-border-radius:4px;border-radius:4px;-webkit-box-shadow:inset 48px 0 0 #292929;-moz-box-shadow:inset 48px 0 0 #292929;box-shadow:inset 48px 0 0 #292929}ul.messenger-theme-flat .messenger-spinner{display:block;position:absolute;left:7px;top:50%;margin-top:-18px;z-index:999;height:32px;width:32px;z-index:10}.irs-diapason,.irs-line-left,.irs-line-mid,.irs-line-right,.irs-slider{background:url(\"/imgs/common/sprite-skin-flat.png\") repeat-x}.irs{height:40px}.irs-with-grid{height:60px}.irs-line{height:12px;top:25px}.irs-line-left{height:12px;background-position:0 -30px}.irs-line-mid{height:12px;background-position:0 0}.irs-line-right{height:12px;background-position:100% -30px}.irs-diapason{height:12px;top:25px;background-position:0 -60px}.irs-slider{width:16px;height:18px;top:22px;background-position:0 -90px}#irs-active-slider,.irs-slider:hover{background-position:0 -120px}.irs-max,.irs-min{color:#999;top:0;padding:1px 3px;background:#e1e4e9}.irs-from,.irs-max,.irs-min,.irs-single,.irs-to{font-size:10px;line-height:1.333;text-shadow:none;border-radius:4px}.irs-from,.irs-single,.irs-to{color:#fff;padding:1px 5px;background:#ed5565}.irs-from:after,.irs-single:after,.irs-to:after{position:absolute;display:block;content:\"\";bottom:-6px;left:50%;width:0;height:0;margin-left:-3px;overflow:hidden;border:3px solid transparent;border-top-color:#ed5565}.irs-grid-pol{background:#e1e4e9}.irs-grid-text{color:#999}.bs-example>.dropdown>.dropdown-toggle{float:left}.bs-example>.dropdown>.dropdown-menu{clear:left;display:block;position:static;margin-bottom:5px}.btn-default{background:#b4b7b9;color:#fff;border-color:#b4b7b9}.btn-default.btn-outlined{color:#b4b7b9;background:none}.btn-default.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-default.btn-outlined.btn-onlyOnHover.active,.btn-default.btn-outlined.btn-onlyOnHover:focus,.btn-default.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-default.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-default.btn-outlined.btn-inverse.active,.btn-default.btn-outlined.btn-inverse:focus,.btn-default.btn-outlined.btn-inverse:hover{color:#b4b7b9;background:#fff}.btn-default.btn-outlined.btn-inverse.active.btn-retainBg,.btn-default.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-default.btn-outlined.btn-inverse:hover.btn-retainBg{background:#b4b7b9;color:#fff;border-color:#b4b7b9}.btn-default.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-default.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-default.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#85898d;border-color:#666b6e}.btn-default.active,.btn-default.focus,.btn-default:focus,.btn-default:hover{color:#fff;background:#ced0d2;border-color:#ced0d2}.btn-default.active,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active,.btn-default[aria-expanded=true],.btn-default[aria-expanded=true]:focus,.btn-default[aria-expanded=true]:hover,.open>.btn-default.dropdown-toggle{color:#fff;background:#85898d;border-color:#666b6e;background-image:none}.btn-default.dropdown-toggle+ul li.active a{color:#fff;background:#b4b7b9}.btn-default.disabled,.btn-default[disabled],fieldset[disabled] .btn-default{pointer-events:none}.btn-default .badge{color:#b4b7b9;background-color:#b4b7b9}.btn-text{background:#89949b;color:#fff;border-color:#89949b}.btn-text.btn-outlined{color:#89949b;background:none}.btn-text.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-text.btn-outlined.btn-onlyOnHover.active,.btn-text.btn-outlined.btn-onlyOnHover:focus,.btn-text.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-text.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-text.btn-outlined.btn-inverse.active,.btn-text.btn-outlined.btn-inverse:focus,.btn-text.btn-outlined.btn-inverse:hover{color:#89949b;background:#fff}.btn-text.btn-outlined.btn-inverse.active.btn-retainBg,.btn-text.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-text.btn-outlined.btn-inverse:hover.btn-retainBg{background:#89949b;color:#fff;border-color:#89949b}.btn-text.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-text.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-text.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#5c666c;border-color:#40474b}.btn-text.active,.btn-text.focus,.btn-text:focus,.btn-text:hover{color:#fff;background:#a5adb2;border-color:#a5adb2}.btn-text.active,.btn-text.active:focus,.btn-text.active:hover,.btn-text:active,.btn-text[aria-expanded=true],.btn-text[aria-expanded=true]:focus,.btn-text[aria-expanded=true]:hover,.open>.btn-text.dropdown-toggle{color:#fff;background:#5c666c;border-color:#40474b;background-image:none}.btn-text.dropdown-toggle+ul li.active a{color:#fff;background:#89949b}.btn-text.disabled,.btn-text[disabled],fieldset[disabled] .btn-text{pointer-events:none}.btn-text .badge{color:#89949b;background-color:#89949b}.menu-text ul li.active a,.menu-text ul li.active a:hover{color:#fff;background:#89949b!important}.nav-text>li.active>a,.nav-text>rubix-menu>li.active>a,.nav-text>rubix-nav-item>li.active>a{color:#fff;background:#89949b;border-color:#89949b}.tab-text{border-color:#89949b}.tab-text>li.active>a{border-color:#89949b;border-bottom-color:transparent}.tab-text.nav-pills>li.active>a{background:#89949b;color:#fff}.rubix-panel-header.nav-inline .nav-text>li.active>a{border:1px solid #89949b;border-bottom:none}.rubix-panel-header.nav-inline .nav-text>li.open>.dropdown-toggle{color:#fff;background:none}.bg-text{background:#89949b!important}.bg-text table td,.bg-text th{border-color:rgba(0,0,0,.05)!important}.bg-focus-text:focus,.bg-hover-text:hover{background:#89949b!important}.fg-text,.fg-text .nav-tabs>li.active>a{color:#89949b}.fg-tab-active-text .nav-tabs>li.active>a{color:#89949b!important}.fg-focus-text:focus,.fg-hover-text:hover{color:#89949b}.border-text{border-color:#89949b!important}.border-text .rubix-timeline-body>ul,.border-text.rubix-timeline-view:before{border-color:#89949b}.border-focus-text:focus,.border-hover-text:hover{border-color:#89949b!important}.tl-text .rubix-timeline-body>ul>li:before{border-color:#89949b}.list-bg-text>.list-group-item.active{background:#89949b!important;color:#fff!important}.list-fg-text>.list-group-item{color:#89949b}@media print{#navbar,#sidebar{display:none!important}#body{background:#fff;left:0!important;width:100%!important;margin-top:0!important;margin-left:0!important}.rubix-panel-controls{display:none!important}}@keyframes vex-fadein{0%{opacity:0}to{opacity:1}}@-webkit-keyframes vex-fadein{0%{opacity:0}to{opacity:1}}@-moz-keyframes vex-fadein{0%{opacity:0}to{opacity:1}}@-ms-keyframes vex-fadein{0%{opacity:0}to{opacity:1}}@-o-keyframes vex-fadein{0%{opacity:0}to{opacity:1}}@keyframes vex-fadeout{0%{opacity:1}to{opacity:0}}@-webkit-keyframes vex-fadeout{0%{opacity:1}to{opacity:0}}@-moz-keyframes vex-fadeout{0%{opacity:1}to{opacity:0}}@-ms-keyframes vex-fadeout{0%{opacity:1}to{opacity:0}}@-o-keyframes vex-fadeout{0%{opacity:1}to{opacity:0}}@keyframes vex-rotation{0%{transform:rotate(0deg);-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg)}to{transform:rotate(359deg);-webkit-transform:rotate(359deg);-moz-transform:rotate(359deg);-ms-transform:rotate(359deg);-o-transform:rotate(359deg)}}@-webkit-keyframes vex-rotation{0%{transform:rotate(0deg);-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg)}to{transform:rotate(359deg);-webkit-transform:rotate(359deg);-moz-transform:rotate(359deg);-ms-transform:rotate(359deg);-o-transform:rotate(359deg)}}@-moz-keyframes vex-rotation{0%{transform:rotate(0deg);-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg)}to{transform:rotate(359deg);-webkit-transform:rotate(359deg);-moz-transform:rotate(359deg);-ms-transform:rotate(359deg);-o-transform:rotate(359deg)}}@-ms-keyframes vex-rotation{0%{transform:rotate(0deg);-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg)}to{transform:rotate(359deg);-webkit-transform:rotate(359deg);-moz-transform:rotate(359deg);-ms-transform:rotate(359deg);-o-transform:rotate(359deg)}}@-o-keyframes vex-rotation{0%{transform:rotate(0deg);-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg)}to{transform:rotate(359deg);-webkit-transform:rotate(359deg);-moz-transform:rotate(359deg);-ms-transform:rotate(359deg);-o-transform:rotate(359deg)}}.vex,.vex *,.vex :after,.vex :before{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.vex{position:fixed;overflow:auto;-webkit-overflow-scrolling:touch;z-index:9999999999999;top:0;right:0;bottom:0;left:0}.vex-overlay{background:#000;filter:alpha(opacity=40);-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";animation:vex-fadein .5s;-webkit-animation:vex-fadein .5s;-moz-animation:vex-fadein .5s;-ms-animation:vex-fadein .5s;-o-animation:vex-fadein .5s;-webkit-backface-visibility:hidden;position:fixed;background:rgba(0,0,0,.4);top:0;right:0;bottom:0;left:0}.vex.vex-closing .vex-overlay{animation:vex-fadeout .5s;-webkit-animation:vex-fadeout .5s;-moz-animation:vex-fadeout .5s;-ms-animation:vex-fadeout .5s;-o-animation:vex-fadeout .5s;-webkit-backface-visibility:hidden}.vex-content{animation:vex-fadein .5s;-webkit-animation:vex-fadein .5s;-moz-animation:vex-fadein .5s;-ms-animation:vex-fadein .5s;-o-animation:vex-fadein .5s;-webkit-backface-visibility:hidden;background:#fff}.vex.vex-closing .vex-content{animation:vex-fadeout .5s;-webkit-animation:vex-fadeout .5s;-moz-animation:vex-fadeout .5s;-ms-animation:vex-fadeout .5s;-o-animation:vex-fadeout .5s;-webkit-backface-visibility:hidden}.vex-close:before{font-family:Arial,sans-serif;content:\"\\D7\"}.vex-dialog-form{margin:0}.vex-dialog-button{-webkit-appearance:none;cursor:pointer}.vex-loading-spinner{animation:vex-rotation .7s linear infinite;-webkit-animation:vex-rotation .7s linear infinite;-moz-animation:vex-rotation .7s linear infinite;-ms-animation:vex-rotation .7s linear infinite;-o-animation:vex-rotation .7s linear infinite;-webkit-backface-visibility:hidden;-webkit-box-shadow:0 0 1em rgba(0,0,0,.1);-moz-box-shadow:0 0 1em rgba(0,0,0,.1);box-shadow:0 0 1em rgba(0,0,0,.1);position:fixed;z-index:1112;margin:auto;top:0;right:0;bottom:0;left:0;height:2em;width:2em;background:#fff}body.vex-open{overflow:hidden}.c3 svg{font:10px sans-serif}.c3 line,.c3 path{fill:none;stroke:#000}.c3 text{user-select:none}.c3-bars path,.c3-event-rect,.c3-legend-item-tile,.c3-xgrid-focus,.c3-ygrid{shape-rendering:crispEdges}.c3-chart-arc path{stroke:#fff}.c3-chart-arc text{fill:#fff;font-size:13px}.c3-grid line{stroke:#aaa}.c3-grid text{fill:#aaa}.c3-xgrid,.c3-ygrid{stroke-dasharray:3 3}.c3-text.c3-empty{fill:gray;font-size:2em}.c3-line{stroke-width:1px}.c3-circle._expanded_{stroke-width:1px;stroke:#fff}.c3-selected-circle{fill:#fff;stroke-width:2px}.c3-bar{stroke-width:0}.c3-bar._expanded_{fill-opacity:.75}.c3-chart-arcs-title{font-size:1.3em}.c3-target.c3-focused path.c3-line,.c3-target.c3-focused path.c3-step{stroke-width:2px}.c3-region{fill:#4682b4;fill-opacity:.1}.c3-brush .extent{fill-opacity:.1}.c3-legend-item{font-size:12px}.c3-legend-background{opacity:.75;fill:#fff;stroke:#d3d3d3;stroke-width:1}.c3-tooltip{border-collapse:collapse;border-spacing:0;background-color:#fff;empty-cells:show;box-shadow:7px 7px 12px -9px #777;opacity:.9}.c3-tooltip tr{border:1px solid #ccc}.c3-tooltip th{background-color:#242424;font-size:14px;padding:2px 5px;text-align:left;color:#fff}.c3-tooltip td{font-size:13px;padding:3px 6px;background-color:#fff;border-left:1px dotted #999}.c3-tooltip td>span{display:inline-block;width:10px;height:10px;margin-right:6px}.c3-tooltip td.value{text-align:right}.c3-area{stroke-width:0;opacity:.2}.c3-chart-arcs .c3-chart-arcs-background{fill:#e0e0e0;stroke:none}.c3-chart-arcs .c3-chart-arcs-gauge-unit{fill:#000;font-size:16px}.c3-chart-arcs .c3-chart-arcs-gauge-max,.c3-chart-arcs .c3-chart-arcs-gauge-min{fill:#777}.c3-chart-arc .c3-gauge-value{fill:#000;font-size:28px}code[class*=language-],pre[class*=language-]{-moz-tab-size:4;-o-tab-size:4;tab-size:4;-webkit-hyphens:none;-moz-hyphens:none;-ms-hyphens:none;hyphens:none;white-space:pre;white-space:pre-wrap;word-break:break-all;word-wrap:break-word;font-family:Menlo,Monaco,Courier New,monospace;font-size:15px;line-height:1.5;color:#dccf8f;text-shadow:0;margin-bottom:25px}:not(pre)>code[class*=language-],pre[class*=language-]{border-radius:5px;border:1px solid #000;color:#dccf8f;background:#181914}pre[class*=language-]{padding:12px}:not(pre)>code[class*=language-]{padding:2px 6px}code[class*=language-] .namespace,pre[class*=language-] .namespace{opacity:.7}code[class*=language-] .token.cdata,code[class*=language-] .token.comment,code[class*=language-] .token.doctype,code[class*=language-] .token.prolog,pre[class*=language-] .token.cdata,pre[class*=language-] .token.comment,pre[class*=language-] .token.doctype,pre[class*=language-] .token.prolog{color:#586e75;font-style:italic}code[class*=language-] .token.boolean,code[class*=language-] .token.null,code[class*=language-] .token.operator,pre[class*=language-] .token.boolean,pre[class*=language-] .token.null,pre[class*=language-] .token.operator{color:#dccf8f}code[class*=language-] .token.number,code[class*=language-] .token.string,pre[class*=language-] .token.number,pre[class*=language-] .token.string{color:#468966}code[class*=language-] .token.attr-name,pre[class*=language-] .token.attr-name{color:#b89859}.language-css code[class*=language-] .token.string,.language-css pre[class*=language-] .token.string,.style code[class*=language-] .token.string,.style pre[class*=language-] .token.string,code[class*=language-] .token.entity,code[class*=language-] .token.url,pre[class*=language-] .token.entity,pre[class*=language-] .token.url{color:#dccf8f}code[class*=language-] .token.selector,pre[class*=language-] .token.selector{color:#859900}code[class*=language-] .token.atrule,code[class*=language-] .token.control,code[class*=language-] .token.directive,code[class*=language-] .token.important,code[class*=language-] .token.unit,code[class*=language-] code[class*=language-] .token.keyword,pre[class*=language-] .token.atrule,pre[class*=language-] .token.control,pre[class*=language-] .token.directive,pre[class*=language-] .token.important,pre[class*=language-] .token.keyword,pre[class*=language-] .token.unit{color:#cb4b16}.token.attr-value,pre[class*=language-] .token.attr-value{color:#468966}code[class*=language-] .token.placeholder,code[class*=language-] .token.variable,pre[class*=language-] .token.placeholder,pre[class*=language-] .token.variable{color:#b58900}.token.boolean,.token.number,.token.property,.token.tag,code[class*=language-] .token.property,pre[class*=language-] .token.property{color:#b89859}code[class*=language-] .token.tag,pre[class*=language-] .token.tag{color:#ffb03b}code[class*=language-] .token.important,code[class*=language-] .token.statement,pre[class*=language-] .token.important,pre[class*=language-] .token.statement{color:#dc322f}code[class*=language-] .token.punctuation,pre[class*=language-] .token.punctuation{color:#dccf8f}code[class*=language-] .token.entity,pre[class*=language-] .token.entity{cursor:help}code[class*=language-] .token.debug,pre[class*=language-] .token.debug{color:red}.pojoaque-colors{color:#586e75;color:#b64926;color:#468966;color:#ffb03b;color:#b58900;color:#b89859;color:#dccf8f;color:#d3a60c;color:#cb4b16;color:#dc322f;color:#073642;color:#181914}.jcrop-holder{direction:ltr;text-align:left}.jcrop-hline,.jcrop-vline{background:#fff url(\"/imgs/common/jcrop/Jcrop.gif\");font-size:0;position:absolute}.jcrop-vline{height:100%;width:1px!important}.jcrop-vline.right{right:0}.jcrop-hline{height:1px!important;width:100%}.jcrop-hline.bottom{bottom:0}.jcrop-tracker{height:100%;width:100%;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none}.jcrop-handle{background-color:#333;border:1px solid #eee;width:7px;height:7px;font-size:1px}.jcrop-handle.ord-n{left:50%;margin-left:-4px;margin-top:-4px;top:0}.jcrop-handle.ord-s{bottom:0;left:50%;margin-bottom:-4px;margin-left:-4px}.jcrop-handle.ord-e{margin-right:-4px;margin-top:-4px;right:0;top:50%}.jcrop-handle.ord-w{left:0;margin-left:-4px;margin-top:-4px;top:50%}.jcrop-handle.ord-nw{left:0;margin-left:-4px;margin-top:-4px;top:0}.jcrop-handle.ord-ne{margin-right:-4px;margin-top:-4px;right:0;top:0}.jcrop-handle.ord-se{bottom:0;margin-bottom:-4px;margin-right:-4px;right:0}.jcrop-handle.ord-sw{bottom:0;left:0;margin-bottom:-4px;margin-left:-4px}.jcrop-dragbar.ord-n,.jcrop-dragbar.ord-s{height:7px;width:100%}.jcrop-dragbar.ord-e,.jcrop-dragbar.ord-w{height:100%;width:7px}.jcrop-dragbar.ord-n{margin-top:-4px}.jcrop-dragbar.ord-s{bottom:0;margin-bottom:-4px}.jcrop-dragbar.ord-e{margin-right:-4px;right:0}.jcrop-dragbar.ord-w{margin-left:-4px}.jcrop-light .jcrop-hline,.jcrop-light .jcrop-vline{background:#fff;filter:alpha(opacity=70)!important;opacity:.7!important}.jcrop-light .jcrop-handle{-moz-border-radius:3px;-webkit-border-radius:3px;background-color:#000;border-color:#fff;border-radius:3px}.jcrop-dark .jcrop-hline,.jcrop-dark .jcrop-vline{background:#000;filter:alpha(opacity=70)!important;opacity:.7!important}.jcrop-dark .jcrop-handle{-moz-border-radius:3px;-webkit-border-radius:3px;background-color:#fff;border-color:#000;border-radius:3px}.solid-line .jcrop-hline,.solid-line .jcrop-vline{background:#fff}.jcrop-holder img,img.jcrop-preview{max-width:none}.morris-hover{position:absolute;z-index:1000}.morris-hover.morris-default-style{border-radius:10px;padding:6px;color:#666;background:hsla(0,0%,100%,.8);border:2px solid hsla(0,0%,90%,.8);font-family:sans-serif;font-size:12px;text-align:center}.morris-hover.morris-default-style .morris-hover-row-label{font-weight:700;margin:.25em 0}.morris-hover.morris-default-style .morris-hover-point{white-space:nowrap;margin:.1em 0}.leaflet-image-layer,.leaflet-layer,.leaflet-map-pane,.leaflet-marker-icon,.leaflet-marker-pane,.leaflet-marker-shadow,.leaflet-overlay-pane,.leaflet-overlay-pane svg,.leaflet-popup-pane,.leaflet-shadow-pane,.leaflet-tile,.leaflet-tile-container,.leaflet-tile-pane,.leaflet-zoom-box{position:absolute;left:0;top:0}.leaflet-container{overflow:hidden;-ms-touch-action:none}.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-tile{-webkit-user-select:none;-moz-user-select:none;user-select:none;-webkit-user-drag:none}.leaflet-marker-icon,.leaflet-marker-shadow{display:block}.leaflet-container img{max-width:none!important}.leaflet-container img.leaflet-image-layer{max-width:15000px!important}.leaflet-tile{filter:inherit;visibility:hidden}.leaflet-tile-loaded{visibility:inherit}.leaflet-zoom-box{width:0;height:0}.leaflet-overlay-pane svg{-moz-user-select:none}.leaflet-tile-pane{z-index:2}.leaflet-objects-pane{z-index:3}.leaflet-overlay-pane{z-index:4}.leaflet-shadow-pane{z-index:5}.leaflet-marker-pane{z-index:6}.leaflet-popup-pane{z-index:7}.leaflet-vml-shape{width:1px;height:1px}.lvml{behavior:url(#default#VML);display:inline-block;position:absolute}.leaflet-control{position:relative;z-index:7;pointer-events:auto}.leaflet-bottom,.leaflet-top{position:absolute;z-index:1000;pointer-events:none}.leaflet-top{top:0}.leaflet-right{right:0}.leaflet-bottom{bottom:0}.leaflet-left{left:0}.leaflet-control{float:left;clear:both}.leaflet-right .leaflet-control{float:right}.leaflet-top .leaflet-control{margin-top:10px}.leaflet-bottom .leaflet-control{margin-bottom:10px}.leaflet-left .leaflet-control{margin-left:10px}.leaflet-right .leaflet-control{margin-right:10px}.leaflet-fade-anim .leaflet-popup,.leaflet-fade-anim .leaflet-tile{opacity:0;-webkit-transition:opacity .2s linear;-moz-transition:opacity .2s linear;-o-transition:opacity .2s linear;transition:opacity .2s linear}.leaflet-fade-anim .leaflet-map-pane .leaflet-popup,.leaflet-fade-anim .leaflet-tile-loaded{opacity:1}.leaflet-zoom-anim .leaflet-zoom-animated{-webkit-transition:-webkit-transform .25s cubic-bezier(0,0,.25,1);-moz-transition:-moz-transform .25s cubic-bezier(0,0,.25,1);-o-transition:-o-transform .25s cubic-bezier(0,0,.25,1);transition:transform .25s cubic-bezier(0,0,.25,1)}.leaflet-pan-anim .leaflet-tile,.leaflet-touching .leaflet-zoom-animated,.leaflet-zoom-anim .leaflet-tile{-webkit-transition:none;-moz-transition:none;-o-transition:none;transition:none}.leaflet-zoom-anim .leaflet-zoom-hide{visibility:hidden}.leaflet-clickable{cursor:pointer}.leaflet-container{cursor:-webkit-grab;cursor:-moz-grab}.leaflet-control,.leaflet-popup-pane{cursor:auto}.leaflet-dragging .leaflet-clickable,.leaflet-dragging .leaflet-container{cursor:move;cursor:-webkit-grabbing;cursor:-moz-grabbing}.leaflet-container{background:#ddd;outline:0}.leaflet-container a{color:#0078a8}.leaflet-container a.leaflet-active{outline:2px solid orange}.leaflet-zoom-box{border:2px dotted #38f;background:hsla(0,0%,100%,.5)}.leaflet-container{font:12px/1.5 Helvetica Neue,Arial,Helvetica,sans-serif}.leaflet-bar{box-shadow:0 1px 5px rgba(0,0,0,.65);border-radius:4px}.leaflet-bar a,.leaflet-bar a:hover{background-color:#fff;border-bottom:1px solid #ccc;width:26px;height:26px;line-height:26px;display:block;text-align:center;text-decoration:none;color:#000}.leaflet-bar a,.leaflet-control-layers-toggle{background-position:50% 50%;background-repeat:no-repeat;display:block}.leaflet-bar a:hover{background-color:#f4f4f4}.leaflet-bar a:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.leaflet-bar a:last-child{border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-bottom:none}.leaflet-bar a.leaflet-disabled{cursor:default;background-color:#f4f4f4;color:#bbb}.leaflet-touch .leaflet-bar a{width:30px;height:30px;line-height:30px}.leaflet-control-zoom-in,.leaflet-control-zoom-out{font:700 18px Lucida Console,Monaco,monospace;text-indent:1px}.leaflet-control-zoom-out{font-size:20px}.leaflet-touch .leaflet-control-zoom-in{font-size:22px}.leaflet-touch .leaflet-control-zoom-out{font-size:24px}.leaflet-control-layers{box-shadow:0 1px 5px rgba(0,0,0,.4);background:#fff;border-radius:5px}.leaflet-control-layers-toggle{background-image:url(\"/imgs/common/leaflet/layers.png\");width:36px;height:36px}.leaflet-retina .leaflet-control-layers-toggle{background-image:url(\"/imgs/common/leaflet/layers-2x.png\");background-size:26px 26px}.leaflet-touch .leaflet-control-layers-toggle{width:44px;height:44px}.leaflet-control-layers-expanded .leaflet-control-layers-toggle,.leaflet-control-layers .leaflet-control-layers-list{display:none}.leaflet-control-layers-expanded .leaflet-control-layers-list{display:block;position:relative}.leaflet-control-layers-expanded{padding:6px 10px 6px 6px;color:#333;background:#fff}.leaflet-control-layers-selector{margin-top:2px;position:relative;top:1px}.leaflet-control-layers label{display:block}.leaflet-control-layers-separator{height:0;border-top:1px solid #ddd;margin:5px -10px 5px -6px}.leaflet-container .leaflet-control-attribution{background:#fff;background:hsla(0,0%,100%,.7);margin:0}.leaflet-control-attribution,.leaflet-control-scale-line{padding:0 5px;color:#333}.leaflet-control-attribution a{text-decoration:none}.leaflet-control-attribution a:hover{text-decoration:underline}.leaflet-container .leaflet-control-attribution,.leaflet-container .leaflet-control-scale{font-size:11px}.leaflet-left .leaflet-control-scale{margin-left:5px}.leaflet-bottom .leaflet-control-scale{margin-bottom:5px}.leaflet-control-scale-line{border:2px solid #777;border-top:none;line-height:1.1;padding:2px 5px 1px;font-size:11px;white-space:nowrap;overflow:hidden;-moz-box-sizing:content-box;box-sizing:content-box;background:#fff;background:hsla(0,0%,100%,.5)}.leaflet-control-scale-line:not(:first-child){border-top:2px solid #777;border-bottom:none;margin-top:-2px}.leaflet-control-scale-line:not(:first-child):not(:last-child){border-bottom:2px solid #777}.leaflet-touch .leaflet-bar,.leaflet-touch .leaflet-control-attribution,.leaflet-touch .leaflet-control-layers{box-shadow:none}.leaflet-touch .leaflet-bar,.leaflet-touch .leaflet-control-layers{border:2px solid rgba(0,0,0,.2);background-clip:padding-box}.leaflet-popup{position:absolute;text-align:center}.leaflet-popup-content-wrapper{padding:1px;text-align:left;border-radius:12px}.leaflet-popup-content{margin:13px 19px;line-height:1.4}.leaflet-popup-content p{margin:18px 0}.leaflet-popup-tip-container{margin:0 auto;width:40px;height:20px;position:relative;overflow:hidden}.leaflet-popup-tip{width:17px;height:17px;padding:1px;margin:-10px auto 0;-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);-ms-transform:rotate(45deg);-o-transform:rotate(45deg);transform:rotate(45deg)}.leaflet-popup-content-wrapper,.leaflet-popup-tip{background:#fff;box-shadow:0 3px 14px rgba(0,0,0,.4)}.leaflet-container a.leaflet-popup-close-button{position:absolute;top:0;right:0;padding:4px 4px 0 0;text-align:center;width:18px;height:14px;font:16px/14px Tahoma,Verdana,sans-serif;color:#c3c3c3;text-decoration:none;font-weight:700;background:transparent}.leaflet-container a.leaflet-popup-close-button:hover{color:#999}.leaflet-popup-scrolled{overflow:auto;border-bottom:1px solid #ddd;border-top:1px solid #ddd}.leaflet-oldie .leaflet-popup-content-wrapper{zoom:1}.leaflet-oldie .leaflet-popup-tip{width:24px;margin:0 auto;-ms-filter:\"progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)\";filter:progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678,M12=0.70710678,M21=-0.70710678,M22=0.70710678)}.leaflet-oldie .leaflet-popup-tip-container{margin-top:-1px}.leaflet-oldie .leaflet-control-layers,.leaflet-oldie .leaflet-control-zoom,.leaflet-oldie .leaflet-popup-content-wrapper,.leaflet-oldie .leaflet-popup-tip{border:1px solid #999}.leaflet-div-icon{background:#fff;border:1px solid #666}.select2-container{margin:0;position:relative;display:inline-block;vertical-align:middle}.select2-container,.select2-drop,.select2-search,.select2-search input{box-sizing:border-box}.select2-container .select2-choice{display:block;height:25px;padding:0 0 0 8px;overflow:hidden;position:relative;border:1px solid #aaa;white-space:nowrap;line-height:20px;color:#444;text-decoration:none;border-radius:4px;background-clip:padding-box;-webkit-touch-callout:none;user-select:none;background-color:#fff}.select2-container.select2-drop-above .select2-choice{border-bottom-color:#aaa;border-radius:0 0 4px 4px}.select2-container.select2-allowclear .select2-choice .select2-chosen{margin-right:42px}.select2-container .select2-choice>.select2-chosen{margin-right:26px;display:block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;float:none;width:auto}.select2-container .select2-choice abbr{display:none;width:12px;height:12px;position:absolute;right:24px;top:4px;font-size:1px;text-decoration:none;border:0;background:url(\"/imgs/common/select2/select2.png\") 100% 0 no-repeat;cursor:pointer;outline:0}.select2-container.select2-allowclear .select2-choice abbr{display:inline-block}.select2-container .select2-choice abbr:hover{background-position:right -11px;cursor:pointer}.select2-drop-mask{border:0;margin:0;padding:0;position:fixed;left:0;top:0;min-height:100%;min-width:100%;height:auto;width:auto;opacity:0;z-index:9998;background-color:#fff}.select2-drop{width:100%;margin-top:-1px;position:absolute;z-index:9999;top:100%;background:#fff;color:#000;border:1px solid #aaa;border-top:0;border-radius:0 0 4px 4px}.select2-drop.select2-drop-above{margin-top:1px;border-top:1px solid #aaa;border-bottom:0;border-radius:4px 4px 0 0}.select2-drop-active{border:1px solid #5897fb;border-top:none}.select2-drop.select2-drop-above.select2-drop-active{border-top:1px solid #5897fb}.select2-drop-auto-width{border-top:1px solid #aaa;width:auto}.select2-drop-auto-width .select2-search{padding-top:4px}.select2-container .select2-choice .select2-arrow{display:inline-block;width:18px;height:100%;position:absolute;right:0;top:0;border-left:1px solid #aaa;border-radius:0 4px 4px 0;background-clip:padding-box;background:#ccc}.select2-container .select2-choice .select2-arrow b{top:-3px;width:100%;height:100%;display:block;position:relative;background:url(\"/imgs/common/select2/select2.png\") no-repeat 0 1px}.select2-search{display:inline-block;width:100%;min-height:26px;margin:0;padding-left:4px;padding-right:4px;position:relative;z-index:10000;white-space:nowrap}.select2-search input{width:100%;height:25px;padding:4px 20px 4px 5px;margin:0;outline:0;font-family:sans-serif;font-size:1em;border:1px solid #aaa;border-radius:0;background:#fff url(\"/imgs/common/select2/select2.png\") no-repeat 100% -22px}.select2-drop.select2-drop-above .select2-search input{margin-top:4px}.select2-search input.select2-active{background:#fff url(\"/imgs/common/select2/select2-spinner.gif\") no-repeat 100%}.select2-container-active .select2-choice,.select2-container-active .select2-choices{border:1px solid #5897fb;outline:none}.select2-dropdown-open .select2-choice{border-bottom-color:transparent;border-bottom-left-radius:0;border-bottom-right-radius:0;background-color:#eee}.select2-dropdown-open.select2-drop-above .select2-choice,.select2-dropdown-open.select2-drop-above .select2-choices{border:1px solid #5897fb;border-top-color:transparent}.select2-dropdown-open .select2-choice .select2-arrow{background:transparent;border-left:none}.select2-dropdown-open .select2-choice .select2-arrow b{background-position:-18px 1px}.select2-hidden-accessible{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.select2-results{max-height:200px;padding:0 0 0 4px;margin:4px 4px 4px 0;position:relative;overflow-x:hidden;overflow-y:auto;-webkit-tap-highlight-color:transparent}.select2-results ul.select2-result-sub{margin:0;padding-left:0}.select2-results li{list-style:none;display:list-item;background-image:none}.select2-results li.select2-result-with-children>.select2-result-label{font-weight:700}.select2-results .select2-result-label{padding:3px 7px 4px;margin:0;cursor:pointer;min-height:1em;-webkit-touch-callout:none;user-select:none}.select2-results-dept-1 .select2-result-label{padding-left:20px}.select2-results-dept-2 .select2-result-label{padding-left:40px}.select2-results-dept-3 .select2-result-label{padding-left:60px}.select2-results-dept-4 .select2-result-label{padding-left:80px}.select2-results-dept-5 .select2-result-label{padding-left:100px}.select2-results-dept-6 .select2-result-label{padding-left:110px}.select2-results-dept-7 .select2-result-label{padding-left:120px}.select2-results .select2-highlighted{background:#3875d7;color:#fff}.select2-results li em{background:#feffde;font-style:normal}.select2-results .select2-highlighted em{background:transparent}.select2-results .select2-highlighted ul{background:#fff;color:#000}.select2-results .select2-ajax-error,.select2-results .select2-no-results,.select2-results .select2-searching,.select2-results .select2-selection-limit{background:#f4f4f4;display:list-item;padding-left:5px}.select2-results .select2-disabled.select2-highlighted{color:#666;background:#f4f4f4;display:list-item;cursor:default}.select2-results .select2-disabled{background:#f4f4f4;display:list-item;cursor:default}.select2-results .select2-selected{display:none}.select2-more-results.select2-active{background:#f4f4f4 url(\"/imgs/common/select2/select2-spinner.gif\") no-repeat 100%}.select2-results .select2-ajax-error{background:rgba(255,50,50,.2)}.select2-more-results{background:#f4f4f4;display:list-item}.select2-container.select2-container-disabled .select2-choice{background-color:#f4f4f4;background-image:none;border:1px solid #ddd;cursor:default}.select2-container.select2-container-disabled .select2-choice .select2-arrow{background-color:#f4f4f4;background-image:none;border-left:0}.select2-container.select2-container-disabled .select2-choice abbr{display:none}.select2-container-multi .select2-choices{margin:0;padding:0 5px 0 0;position:relative;border:1px solid #aaa;cursor:text;overflow:hidden;background-color:#fff}.select2-locked{padding:3px 5px!important}.select2-container-multi.select2-container-active .select2-choices{border:1px solid #5897fb;outline:none}.select2-container-multi .select2-choices li{float:left;list-style:none}.select2-container-multi .select2-choices .select2-search-field{margin:0;padding:0;white-space:nowrap}.select2-container-multi .select2-choices .select2-search-field input{padding:0 0 0 5px;margin:1px 0;font-family:sans-serif;font-size:100%;color:#666;outline:0;border:0;background:transparent!important}.select2-container-multi .select2-choices .select2-search-field input.select2-active{background:#fff url(\"/imgs/common/select2/select2-spinner.gif\") no-repeat 100%!important}.select2-default{color:#999!important}.select2-container-multi .select2-choices .select2-search-choice{font-size:12px;padding:1px 5px 3px 18px;margin:2px 0 3px 5px;position:relative;line-height:11px;color:#333;cursor:default;border:1px solid #aaa;border-radius:3px;background-clip:padding-box;-webkit-touch-callout:none;user-select:none;background-color:#e4e4e4}.select2-container-multi .select2-choices .select2-search-choice .select2-chosen{cursor:default}.select2-container-multi .select2-choices .select2-search-choice-focus{background:#d4d4d4}.select2-search-choice-close{display:block;width:12px;height:13px;position:absolute;right:3px;top:1px;font-size:1px;outline:none;background:url(\"/imgs/common/select2/select2.png\") 100% 0 no-repeat}.select2-container-multi .select2-search-choice-close{left:3px}.select2-container-multi .select2-choices .select2-search-choice-focus .select2-search-choice-close,.select2-container-multi .select2-choices .select2-search-choice .select2-search-choice-close:hover{background-position:right -11px}.select2-container-multi.select2-container-disabled .select2-choices{background-color:#f4f4f4;background-image:none;border:1px solid #ddd;cursor:default}.select2-container-multi.select2-container-disabled .select2-choices .select2-search-choice{padding:3px 5px;border:1px solid #ddd;background-image:none;background-color:#f4f4f4}.select2-container-multi.select2-container-disabled .select2-choices .select2-search-choice .select2-search-choice-close{display:none;background:none}.select2-result-selectable .select2-match,.select2-result-unselectable .select2-match{text-decoration:underline}.select2-offscreen,.select2-offscreen:focus{clip:rect(0 0 0 0)!important;width:1px!important;height:1px!important;border:0!important;margin:0!important;padding:0!important;overflow:hidden!important;position:absolute!important;outline:0!important;left:0!important;top:0!important}.select2-display-none{display:none}.select2-measure-scrollbar{position:absolute;top:-10000px;left:-10000px;width:100px;height:100px;overflow:scroll}@media only screen and (-webkit-min-device-pixel-ratio:1.5),only screen and (min-resolution:2dppx){.select2-container .select2-choice .select2-arrow b,.select2-container .select2-choice abbr,.select2-search-choice-close,.select2-search input{background-image:url(\"/imgs/common/select2/select2x2.png\")!important;background-repeat:no-repeat!important;background-size:60px 40px!important}.select2-search input{background-position:100% -21px!important}}.form-control .select2-choice{border:0;border-radius:2px}.form-control .select2-choice .select2-arrow{border-radius:0 2px 2px 0}.form-control.select2-container{height:auto!important;padding:0}.form-control.select2-container.select2-dropdown-open{border-color:#5897fb;border-radius:3px 3px 0 0}.form-control .select2-container.select2-dropdown-open .select2-choices{border-radius:3px 3px 0 0}.form-control.select2-container .select2-choices{border:0!important;border-radius:3px}.control-group.warning .select2-container-active .select2-choice,.control-group.warning .select2-container-active .select2-choices,.control-group.warning .select2-container-multi.select2-container-active .select2-choices,.control-group.warning .select2-container .select2-choice,.control-group.warning .select2-container .select2-choices,.control-group.warning .select2-dropdown-open.select2-drop-above .select2-choice,.control-group.warning .select2-dropdown-open.select2-drop-above .select2-choices{border:1px solid #c09853!important}.control-group.warning .select2-container .select2-choice div{border-left:1px solid #c09853!important;background:#fcf8e3!important}.control-group.error .select2-container-active .select2-choice,.control-group.error .select2-container-active .select2-choices,.control-group.error .select2-container-multi.select2-container-active .select2-choices,.control-group.error .select2-container .select2-choice,.control-group.error .select2-container .select2-choices,.control-group.error .select2-dropdown-open.select2-drop-above .select2-choice,.control-group.error .select2-dropdown-open.select2-drop-above .select2-choices{border:1px solid #b94a48!important}.control-group.error .select2-container .select2-choice div{border-left:1px solid #b94a48!important;background:#f2dede!important}.control-group.info .select2-container-active .select2-choice,.control-group.info .select2-container-active .select2-choices,.control-group.info .select2-container-multi.select2-container-active .select2-choices,.control-group.info .select2-container .select2-choice,.control-group.info .select2-container .select2-choices,.control-group.info .select2-dropdown-open.select2-drop-above .select2-choice,.control-group.info .select2-dropdown-open.select2-drop-above .select2-choices{border:1px solid #3a87ad!important}.control-group.info .select2-container .select2-choice div{border-left:1px solid #3a87ad!important;background:#d9edf7!important}.control-group.success .select2-container-active .select2-choice,.control-group.success .select2-container-active .select2-choices,.control-group.success .select2-container-multi.select2-container-active .select2-choices,.control-group.success .select2-container .select2-choice,.control-group.success .select2-container .select2-choices,.control-group.success .select2-dropdown-open.select2-drop-above .select2-choice,.control-group.success .select2-dropdown-open.select2-drop-above .select2-choices{border:1px solid #468847!important}.control-group.success .select2-container .select2-choice div{border-left:1px solid #468847!important;background:#dff0d8!important}.dropzone,.dropzone *,.dropzone-previews,.dropzone-previews *{box-sizing:border-box;margin-top:25px;margin-bottom:25px}.dropzone{position:relative;border:1px solid rgba(0,0,0,.08);background:rgba(0,0,0,.02);padding:1em}.dropzone.dz-clickable,.dropzone.dz-clickable .dz-message,.dropzone.dz-clickable .dz-message span{cursor:pointer}.dropzone.dz-clickable *{cursor:default}.dropzone .dz-message{opacity:1}.dropzone.dz-drag-hover{border-color:rgba(0,0,0,.15);background:rgba(0,0,0,.04)}.dropzone.dz-started .dz-message{display:none}.dropzone-previews .dz-preview,.dropzone .dz-preview{background:hsla(0,0%,100%,.8);position:relative;display:inline-block;margin:17px;vertical-align:top;border:1px solid #acacac;padding:6px}.dropzone-previews .dz-preview.dz-file-preview [data-dz-thumbnail],.dropzone .dz-preview.dz-file-preview [data-dz-thumbnail]{display:none}.dropzone-previews .dz-preview .dz-details,.dropzone .dz-preview .dz-details{width:100px;height:100px;position:relative;background:#ebebeb;padding:5px;margin-bottom:22px}.dropzone-previews .dz-preview .dz-details .dz-filename,.dropzone .dz-preview .dz-details .dz-filename{overflow:hidden;height:100%}.dropzone-previews .dz-preview .dz-details img,.dropzone .dz-preview .dz-details img{position:absolute;top:0;left:0;width:100px;height:100px}.dropzone-previews .dz-preview .dz-details .dz-size,.dropzone .dz-preview .dz-details .dz-size{position:absolute;bottom:-28px;left:3px;height:28px;line-height:28px}.dropzone-previews .dz-preview.dz-error .dz-error-mark,.dropzone-previews .dz-preview.dz-success .dz-success-mark,.dropzone .dz-preview.dz-error .dz-error-mark,.dropzone .dz-preview.dz-success .dz-success-mark{display:block}.dropzone-previews .dz-preview:hover .dz-details img,.dropzone .dz-preview:hover .dz-details img{display:none}.dropzone-previews .dz-preview .dz-error-mark,.dropzone-previews .dz-preview .dz-success-mark,.dropzone .dz-preview .dz-error-mark,.dropzone .dz-preview .dz-success-mark{display:none;position:absolute;width:40px;height:40px;font-size:30px;text-align:center;right:-10px;top:-10px}.dropzone-previews .dz-preview .dz-success-mark,.dropzone .dz-preview .dz-success-mark{color:#8cc657}.dropzone-previews .dz-preview .dz-error-mark,.dropzone .dz-preview .dz-error-mark{color:#ee162d}.dropzone-previews .dz-preview .dz-progress,.dropzone .dz-preview .dz-progress{position:absolute;top:100px;left:6px;right:6px;height:6px;background:#d7d7d7;display:none}.dropzone-previews .dz-preview .dz-progress .dz-upload,.dropzone .dz-preview .dz-progress .dz-upload{display:block;bottom:0;background-color:#8cc657}.dropzone-previews .dz-preview.dz-processing .dz-progress,.dropzone .dz-preview.dz-processing .dz-progress{display:block}.dropzone-previews .dz-preview .dz-error-message,.dropzone .dz-preview .dz-error-message{display:none;position:absolute;top:-5px;left:-20px;background:hsla(0,0%,96%,.8);padding:8px 10px;color:#800;min-width:140px;max-width:500px;z-index:500}.dropzone-previews .dz-preview:hover.dz-error .dz-error-message,.dropzone .dz-preview:hover.dz-error .dz-error-message{display:block}.dropzone{border:1px solid rgba(0,0,0,.03);min-height:360px;border-radius:3px;background:rgba(0,0,0,.03);padding:23px}.dropzone .dz-default.dz-message{opacity:1;transition:opacity .3s ease-in-out;background-image:url(\"/imgs/common/dropzone/spritemap.png\");background-repeat:no-repeat;background-position:0 0;position:absolute;width:428px;height:123px;margin-left:-214px;margin-top:-61.5px;top:50%;left:50%}@media (-o-min-device-pixel-ratio:1.5/1),(-webkit-min-device-pixel-ratio:1.5),(min--moz-device-pixel-ratio:1.5),(min-device-pixel-ratio:1.5),(min-resolution:1.5dppx),(min-resolution:138dpi){.dropzone .dz-default.dz-message{background-image:url(\"/imgs/common/dropzone/spritemap@2x.png\");background-size:428px 406px}}.dropzone .dz-default.dz-message span{display:none}.dropzone.dz-square .dz-default.dz-message{background-position:0 -123px;width:268px;margin-left:-134px;height:174px;margin-top:-87px}.dropzone.dz-drag-hover .dz-message{opacity:.15}.dropzone.dz-started .dz-message{display:block;opacity:0}.dropzone-previews .dz-preview,.dropzone .dz-preview{box-shadow:1px 1px 4px rgba(0,0,0,.16);font-size:14px}.dropzone-previews .dz-preview.dz-image-preview:hover .dz-details img,.dropzone .dz-preview.dz-image-preview:hover .dz-details img{display:block;opacity:.1}.dropzone-previews .dz-preview.dz-error .dz-error-mark,.dropzone-previews .dz-preview.dz-success .dz-success-mark,.dropzone .dz-preview.dz-error .dz-error-mark,.dropzone .dz-preview.dz-success .dz-success-mark{opacity:1}.dropzone-previews .dz-preview.dz-error .dz-progress .dz-upload,.dropzone .dz-preview.dz-error .dz-progress .dz-upload{background:#ee1e2d}.dropzone-previews .dz-preview .dz-error-mark,.dropzone-previews .dz-preview .dz-success-mark,.dropzone .dz-preview .dz-error-mark,.dropzone .dz-preview .dz-success-mark{display:block;opacity:0;transition:opacity .4s ease-in-out;background-image:url(\"/imgs/common/dropzone/spritemap.png\");background-repeat:no-repeat}@media (-o-min-device-pixel-ratio:1.5/1),(-webkit-min-device-pixel-ratio:1.5),(min--moz-device-pixel-ratio:1.5),(min-device-pixel-ratio:1.5),(min-resolution:1.5dppx),(min-resolution:138dpi){.dropzone-previews .dz-preview .dz-error-mark,.dropzone-previews .dz-preview .dz-success-mark,.dropzone .dz-preview .dz-error-mark,.dropzone .dz-preview .dz-success-mark{background-image:url(\"/imgs/common/dropzone/spritemap@2x.png\");background-size:428px 406px}}.dropzone-previews .dz-preview .dz-error-mark span,.dropzone-previews .dz-preview .dz-success-mark span,.dropzone .dz-preview .dz-error-mark span,.dropzone .dz-preview .dz-success-mark span{display:none}.dropzone-previews .dz-preview .dz-error-mark,.dropzone .dz-preview .dz-error-mark{background-position:-268px -123px}.dropzone-previews .dz-preview .dz-success-mark,.dropzone .dz-preview .dz-success-mark{background-position:-268px -163px}.dropzone-previews .dz-preview .dz-progress .dz-upload,.dropzone .dz-preview .dz-progress .dz-upload{animation:loading .4s linear infinite;transition:width .3s ease-in-out;border-radius:2px;position:absolute;top:0;left:0;width:0;height:100%;background-image:url(\"/imgs/common/dropzone/spritemap.png\");background-repeat:repeat-x;background-position:0 -400px}@media (-o-min-device-pixel-ratio:1.5/1),(-webkit-min-device-pixel-ratio:1.5),(min--moz-device-pixel-ratio:1.5),(min-device-pixel-ratio:1.5),(min-resolution:1.5dppx),(min-resolution:138dpi){.dropzone-previews .dz-preview .dz-progress .dz-upload,.dropzone .dz-preview .dz-progress .dz-upload{background-image:url(\"/imgs/common/dropzone/spritemap@2x.png\");background-size:428px 406px}}.dropzone-previews .dz-preview.dz-success .dz-progress,.dropzone .dz-preview.dz-success .dz-progress{display:block;opacity:0;transition:opacity .4s ease-in-out}.dropzone-previews .dz-preview .dz-error-message,.dropzone .dz-preview .dz-error-message{display:block;opacity:0;transition:opacity .3s ease-in-out}.dropzone-previews .dz-preview:hover.dz-error .dz-error-message,.dropzone .dz-preview:hover.dz-error .dz-error-message{opacity:1}.dropzone-previews a.dz-remove,.dropzone a.dz-remove{background-image:linear-gradient(180deg,#fafafa,#eee);border-radius:2px;border:1px solid #eee;text-decoration:none;display:block;padding:4px 5px;text-align:center;color:#aaa;margin-top:26px}.dropzone-previews a.dz-remove:hover,.dropzone a.dz-remove:hover{color:#666}@-moz-keyframes loading{0%{background-position:0 -400px}to{background-position:-7px -400px}}@-webkit-keyframes loading{0%{background-position:0 -400px}to{background-position:-7px -400px}}@-o-keyframes loading{0%{background-position:0 -400px}to{background-position:-7px -400px}}@keyframes loading{0%{background-position:0 -400px}to{background-position:-7px -400px}}.vco-storyjs div *{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}.vco-storyjs .active,.vco-storyjs .caption,.vco-storyjs .content-container,.vco-storyjs .credit,.vco-storyjs .date,.vco-storyjs .dot,.vco-storyjs .era,.vco-storyjs .flag,.vco-storyjs .line,.vco-storyjs .major,.vco-storyjs .map,.vco-storyjs .marker,.vco-storyjs .media,.vco-storyjs .messege,.vco-storyjs .minor,.vco-storyjs .slider,.vco-storyjs .start,.vco-storyjs .text,.vco-storyjs .time,.vco-storyjs .title,.vco-storyjs .toolbar,.vco-storyjs .vco-container,.vco-storyjs .vco-feature,.vco-storyjs .vco-feedback,.vco-storyjs .vco-navigation,.vco-storyjs .vco-slider,.vco-storyjs a,.vco-storyjs abbr,.vco-storyjs acronym,.vco-storyjs address,.vco-storyjs blockquote,.vco-storyjs button,.vco-storyjs caption,.vco-storyjs cite,.vco-storyjs code,.vco-storyjs dd,.vco-storyjs del,.vco-storyjs dfn,.vco-storyjs dl,.vco-storyjs dt,.vco-storyjs em,.vco-storyjs fieldset,.vco-storyjs form,.vco-storyjs h1,.vco-storyjs h2,.vco-storyjs h3,.vco-storyjs h4,.vco-storyjs h5,.vco-storyjs h6,.vco-storyjs img,.vco-storyjs label,.vco-storyjs legend,.vco-storyjs li,.vco-storyjs ol,.vco-storyjs p,.vco-storyjs pre,.vco-storyjs q,.vco-storyjs s,.vco-storyjs samp,.vco-storyjs small,.vco-storyjs strike,.vco-storyjs strong,.vco-storyjs sub,.vco-storyjs sup,.vco-storyjs table,.vco-storyjs tbody,.vco-storyjs td,.vco-storyjs tfoot,.vco-storyjs th,.vco-storyjs thead,.vco-storyjs tr,.vco-storyjs tt,.vco-storyjs ul,.vco-storyjs var{margin:0;padding:0;border:0;font-weight:400;font-style:normal;font-size:100%;line-height:1;font-family:inherit;width:auto;float:none}.vco-storyjs h1,.vco-storyjs h2,.vco-storyjs h3,.vco-storyjs h4,.vco-storyjs h5,.vco-storyjs h6{clear:none}.vco-storyjs table{border-collapse:collapse;border-spacing:0}.vco-storyjs ol,.vco-storyjs ul{list-style:none}.vco-storyjs blockquote:after,.vco-storyjs blockquote:before,.vco-storyjs q:after,.vco-storyjs q:before{content:\"\"}.vco-storyjs a:focus{outline:thin dotted}.vco-storyjs a:active,.vco-storyjs a:hover{outline:0}.vco-storyjs article,.vco-storyjs aside,.vco-storyjs details,.vco-storyjs figcaption,.vco-storyjs figure,.vco-storyjs footer,.vco-storyjs header,.vco-storyjs hgroup,.vco-storyjs nav,.vco-storyjs section{display:block}.vco-storyjs audio,.vco-storyjs canvas,.vco-storyjs video{display:inline-block;*display:inline;*zoom:1}.vco-storyjs audio:not([controls]){display:none}.vco-storyjs div{max-width:none}.vco-storyjs sub,.vco-storyjs sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}.vco-storyjs sup{top:-.5em}.vco-storyjs sub{bottom:-.25em}.vco-storyjs img{border:0;-ms-interpolation-mode:bicubic}.vco-storyjs button,.vco-storyjs input,.vco-storyjs select,.vco-storyjs textarea{font-size:100%;margin:0;vertical-align:baseline;*vertical-align:middle}.vco-storyjs button,.vco-storyjs input{line-height:normal;*overflow:visible}.vco-storyjs button::-moz-focus-inner,.vco-storyjs input::-moz-focus-inner{border:0;padding:0}.vco-storyjs button,.vco-storyjs input[type=button],.vco-storyjs input[type=reset],.vco-storyjs input[type=submit]{cursor:pointer;-webkit-appearance:button}.vco-storyjs input[type=search]{-webkit-appearance:textfield;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}.vco-storyjs input[type=search]::-webkit-search-decoration{-webkit-appearance:none}.vco-storyjs textarea{overflow:auto;vertical-align:top}.vco-storyjs{font-family:Lato,sans-serif}.vco-storyjs .back-home,.vco-storyjs .caption,.vco-storyjs .credit,.vco-storyjs .era h1,.vco-storyjs .era h2,.vco-storyjs .era h3,.vco-storyjs .era h4,.vco-storyjs .era h5,.vco-storyjs .era h6,.vco-storyjs .flag-content h1,.vco-storyjs .flag-content h2,.vco-storyjs .flag-content h3,.vco-storyjs .flag-content h4,.vco-storyjs .flag-content h5,.vco-storyjs .flag-content h6,.vco-storyjs .messege,.vco-storyjs .nav-container,.vco-storyjs .time-interval-major div,.vco-storyjs .time-interval div,.vco-storyjs .timenav h1,.vco-storyjs .timenav h2,.vco-storyjs .timenav h3,.vco-storyjs .timenav h4,.vco-storyjs .timenav h5,.vco-storyjs .timenav h6,.vco-storyjs .twitter,.vco-storyjs .twitter blockquote p,.vco-storyjs .vcard,.vco-storyjs .zoom-in,.vco-storyjs .zoom-out,.vco-storyjs blockquote,.vco-storyjs blockquote p,.vco-storyjs h1.date,.vco-storyjs h2.date,.vco-storyjs h3.date,.vco-storyjs h4.date,.vco-storyjs h5.date,.vco-storyjs h6.date,.vco-storyjs p{font-family:Lato,sans-serif!important}.timeline-tooltip,.vco-storyjs .vco-feature h1,.vco-storyjs .vco-feature h2,.vco-storyjs .vco-feature h3,.vco-storyjs .vco-feature h4,.vco-storyjs .vco-feature h5,.vco-storyjs .vco-feature h6{font-family:Lato,sans-serif}.vco-storyjs{-webkit-font-smoothing:antialiased;-webkit-text-size-adjust:100%}.vco-storyjs,.vco-storyjs p{font-size:15px;font-weight:400;line-height:20px}.vco-storyjs p{margin-bottom:20px;color:#666}.vco-storyjs p small{font-size:12px;line-height:17px}.vco-storyjs p:first-child{margin-top:20px}.vco-storyjs .vco-navigation p{color:#999}.vco-storyjs .vco-feature h3,.vco-storyjs .vco-feature h4,.vco-storyjs .vco-feature h5,.vco-storyjs .vco-feature h6{margin-bottom:15px}.vco-storyjs .vco-feature p{color:#666}.vco-storyjs .vco-feature blockquote,.vco-storyjs .vco-feature blockquote p{color:#000}.vco-storyjs .date a,.vco-storyjs .title a{color:#999}.vco-storyjs .hyphenate{-webkit-hyphens:auto;-moz-hyphens:auto;-ms-hyphens:auto;hyphens:auto;word-wrap:break-word}.vco-storyjs h1,.vco-storyjs h2,.vco-storyjs h3,.vco-storyjs h4,.vco-storyjs h5,.vco-storyjs h6{font-weight:400;color:#000;text-transform:none}.vco-storyjs h1 a,.vco-storyjs h1 small,.vco-storyjs h2 a,.vco-storyjs h2 small,.vco-storyjs h3 a,.vco-storyjs h3 small,.vco-storyjs h4 a,.vco-storyjs h4 small,.vco-storyjs h5 a,.vco-storyjs h5 small,.vco-storyjs h6 a,.vco-storyjs h6 small{color:#999}.vco-storyjs h1.date,.vco-storyjs h2.date,.vco-storyjs h3.date,.vco-storyjs h4.date,.vco-storyjs h5.date,.vco-storyjs h6.date{font-weight:700}.vco-storyjs h2.start{font-size:36px;line-height:38px;margin-bottom:15px}.vco-storyjs h1{margin-bottom:15px;font-size:32px;line-height:34px}.vco-storyjs h1 small{font-size:18px}.vco-storyjs h2{margin-bottom:15px;font-size:28px;line-height:30px}.vco-storyjs h2 small{font-size:14px;line-height:16px}.vco-storyjs h2.date{font-size:16px;line-height:18px;margin-bottom:3.75px;color:#999}.vco-storyjs h3,.vco-storyjs h4,.vco-storyjs h5,.vco-storyjs h6{line-height:40px}.vco-storyjs h3 .active,.vco-storyjs h4 .active,.vco-storyjs h5 .active,.vco-storyjs h6 .active{color:#08c}.vco-storyjs h3{font-size:28px;line-height:30px}.vco-storyjs h3 small{font-size:14px}.vco-storyjs h4{font-size:20px;line-height:22px}.vco-storyjs h4 small{font-size:12px}.vco-storyjs h5{font-size:16px;line-height:18px}.vco-storyjs h6{font-size:13px;line-height:14px;text-transform:uppercase}.vco-storyjs strong{font-weight:700;font-style:inherit}.vco-storyjs em{font-style:italic;font-weight:inherit}.vco-storyjs Q{quotes:\"\\E2\\20AC\\17E\" \"\\E2\\20AC\\153\";font-style:italic}.vco-storyjs blockquote,.vco-storyjs blockquote p{font-size:24px;line-height:32px;text-align:left;margin-bottom:6px;padding-top:10px;background-color:#fff;color:#000}.vco-storyjs .credit{color:#999;text-align:right;font-size:10px;line-height:10px;display:block;margin:0 auto;clear:both}.vco-storyjs .caption{text-align:left;margin-top:5px;color:#666;font-size:11px;line-height:14px;clear:both}.vco-storyjs.vco-right-to-left a,.vco-storyjs.vco-right-to-left abbr,.vco-storyjs.vco-right-to-left acronym,.vco-storyjs.vco-right-to-left address,.vco-storyjs.vco-right-to-left blockquote,.vco-storyjs.vco-right-to-left button,.vco-storyjs.vco-right-to-left caption,.vco-storyjs.vco-right-to-left cite,.vco-storyjs.vco-right-to-left code,.vco-storyjs.vco-right-to-left dd,.vco-storyjs.vco-right-to-left del,.vco-storyjs.vco-right-to-left dfn,.vco-storyjs.vco-right-to-left dl,.vco-storyjs.vco-right-to-left dt,.vco-storyjs.vco-right-to-left em,.vco-storyjs.vco-right-to-left fieldset,.vco-storyjs.vco-right-to-left form,.vco-storyjs.vco-right-to-left h1,.vco-storyjs.vco-right-to-left h2,.vco-storyjs.vco-right-to-left h3,.vco-storyjs.vco-right-to-left h4,.vco-storyjs.vco-right-to-left h5,.vco-storyjs.vco-right-to-left h6,.vco-storyjs.vco-right-to-left img,.vco-storyjs.vco-right-to-left label,.vco-storyjs.vco-right-to-left legend,.vco-storyjs.vco-right-to-left li,.vco-storyjs.vco-right-to-left ol,.vco-storyjs.vco-right-to-left p,.vco-storyjs.vco-right-to-left pre,.vco-storyjs.vco-right-to-left q,.vco-storyjs.vco-right-to-left s,.vco-storyjs.vco-right-to-left samp,.vco-storyjs.vco-right-to-left small,.vco-storyjs.vco-right-to-left strike,.vco-storyjs.vco-right-to-left strong,.vco-storyjs.vco-right-to-left sub,.vco-storyjs.vco-right-to-left sup,.vco-storyjs.vco-right-to-left table,.vco-storyjs.vco-right-to-left tbody,.vco-storyjs.vco-right-to-left td,.vco-storyjs.vco-right-to-left tfoot,.vco-storyjs.vco-right-to-left th,.vco-storyjs.vco-right-to-left thead,.vco-storyjs.vco-right-to-left tr,.vco-storyjs.vco-right-to-left tt,.vco-storyjs.vco-right-to-left ul,.vco-storyjs.vco-right-to-left var{direction:rtl}.timeline-tooltip{position:absolute;z-index:1e+27;display:block;visibility:visible;padding:5px;opacity:0;filter:alpha(opacity=0);font-size:15px;font-weight:700;line-height:20px;font-size:12px;line-height:12px}.timeline-tooltip.in{opacity:.8;filter:alpha(opacity=80)}.timeline-tooltip.top{margin-top:-2px}.timeline-tooltip.right{margin-left:2px}.timeline-tooltip.bottom{margin-top:2px}.timeline-tooltip.left{margin-left:-2px}.timeline-tooltip.top .timeline-tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid #000}.timeline-tooltip.left .timeline-tooltip-arrow{top:50%;right:0;margin-top:-5px;border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:5px solid #000}.timeline-tooltip.bottom .timeline-tooltip-arrow{top:0;left:50%;margin-left:-5px;border-left:5px solid transparent;border-right:5px solid transparent;border-bottom:5px solid #000}.timeline-tooltip.right .timeline-tooltip-arrow{top:50%;left:0;margin-top:-5px;border-top:5px solid transparent;border-bottom:5px solid transparent;border-right:5px solid #000}.timeline-tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;text-decoration:none;background-color:#000;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px}.timeline-tooltip-arrow{position:absolute;width:0;height:0}.fancybox-image,.fancybox-inner,.fancybox-nav,.fancybox-nav span,.fancybox-outer,.fancybox-skin,.fancybox-tmp,.fancybox-wrap,.fancybox-wrap iframe,.fancybox-wrap object{padding:0;margin:0;border:0;outline:none;vertical-align:top}.fancybox-wrap{position:absolute;top:0;left:0;z-index:8020}.fancybox-skin{position:relative;background:#fff;color:#444;text-shadow:none}.fancybox-opened{z-index:8030}.fancybox-opened .fancybox-skin{-webkit-box-shadow:1px 1px 10px rgba(0,0,0,.5);-moz-box-shadow:1px 1px 10px rgba(0,0,0,.5);box-shadow:1px 1px 10px rgba(0,0,0,.5)}.fancybox-inner,.fancybox-outer{position:relative}.fancybox-inner{overflow:hidden}.fancybox-type-iframe .fancybox-inner{-webkit-overflow-scrolling:touch}.fancybox-error{color:#444;font:14px/20px Lato,sans-serif;margin:0;padding:15px;white-space:nowrap}.fancybox-iframe,.fancybox-image{display:block;width:100%;height:100%}.fancybox-image{max-width:100%;max-height:100%}.fancybox-close,.fancybox-next span,.fancybox-prev span{background-image:url(\"/imgs/common/timeline/fancybox_sprite.png\")}#fancybox-loading{position:fixed;top:50%;left:50%;margin-top:-14px;margin-left:-14px;background-position:0 -108px;opacity:.8;cursor:pointer;z-index:8060}#fancybox-loading div{width:28px;height:28px;background:url(\"/imgs/common/timeline/loading.gif\") 50% no-repeat}.fancybox-close{top:-18px;right:-18px;width:36px;height:36px}.fancybox-close,.fancybox-nav{position:absolute;cursor:pointer;z-index:8040}.fancybox-nav{top:0;width:40%;height:100%;text-decoration:none;background:transparent url(\"/imgs/common/timeline/blank.gif\");-webkit-tap-highlight-color:transparent}.fancybox-prev{left:0}.fancybox-next{right:0}.fancybox-nav span{position:absolute;top:50%;width:36px;height:34px;margin-top:-18px;cursor:pointer;z-index:8040;visibility:hidden}.fancybox-prev span{left:10px;background-position:0 -36px}.fancybox-next span{right:10px;background-position:0 -72px}.fancybox-nav:hover span{visibility:visible}.fancybox-tmp{position:absolute;top:-99999px;left:-99999px;visibility:hidden;max-width:99999px;max-height:99999px;overflow:visible!important}.fancybox-lock{width:auto}.fancybox-lock,.fancybox-lock body{overflow:hidden!important}.fancybox-lock-test{overflow-y:hidden!important}.fancybox-overlay{position:absolute;top:0;left:0;overflow:hidden;display:none;z-index:8010;background:url(\"/imgs/common/timeline/overlay.png\")}.fancybox-overlay-fixed{position:fixed;bottom:0;right:0}.fancybox-lock .fancybox-overlay{overflow:auto;overflow-y:scroll}.fancybox-title{visibility:hidden;font:normal 13px/20px Lato,sans-serif;position:relative;text-shadow:none;z-index:8050}.fancybox-opened .fancybox-title{visibility:visible}.fancybox-title-float-wrap{position:absolute;bottom:0;right:50%;margin-bottom:-35px;z-index:8050;text-align:center}.fancybox-title-float-wrap .child{display:inline-block;margin-right:-100%;padding:2px 20px;background:transparent;background:rgba(0,0,0,.8);-webkit-border-radius:15px;-moz-border-radius:15px;border-radius:15px;text-shadow:0 1px 2px #222;color:#fff;font-weight:700;line-height:24px;white-space:nowrap}.fancybox-title-outside-wrap{position:relative;margin-top:10px;color:#fff}.fancybox-title-inside-wrap{padding-top:10px}.fancybox-title-over-wrap{position:absolute;bottom:0;left:0;color:#fff;padding:10px;background:#000;background:rgba(0,0,0,.8)}@media only screen and (-webkit-min-device-pixel-ratio:1.5),only screen and (min--moz-device-pixel-ratio:1.5),only screen and (min-device-pixel-ratio:1.5){#fancybox-loading,.fancybox-close,.fancybox-next span,.fancybox-prev span{background-image:url(\"/imgs/common/timeline/fancybox_sprite@2x.png\");background-size:44px 152px}#fancybox-loading div{background-image:url(\"/imgs/common/timeline/loading@2x.gif\");background-size:24px 24px}}@media only screen and (max-device-width:480px),only screen and (max-width:480px){.vco-slider .nav-next,.vco-slider .nav-previous{display:none}}.vco-skinny .vco-slider .slider-item .content .layout-text-media .text .container{text-align:center!important}.vco-skinny .vco-slider .slider-item .content .layout-text-media h2,.vco-skinny .vco-slider .slider-item .content .layout-text-media h3{display:block!important;width:100%!important;text-align:center!important}.vco-skinny .vco-slider .slider-item .content .content-container{display:block}.vco-skinny .vco-slider .slider-item .content .content-container .text{width:100%;max-width:100%;min-width:120px;display:block}.vco-skinny .vco-slider .slider-item .content .content-container .text .container{display:block;-webkit-hyphens:auto;-moz-hyphens:auto;-ms-hyphens:auto;hyphens:auto;word-wrap:break-word}.vco-skinny .vco-slider .slider-item .content .content-container .media{width:100%;min-width:50%;float:none}.vco-skinny .vco-slider .slider-item .content .content-container .media .media-wrapper{margin-left:0;margin-right:0;width:100%;display:block}.vco-skinny.vco-notouch .vco-slider .nav-next,.vco-skinny.vco-notouch .vco-slider .nav-previous{z-index:203}.vco-skinny.vco-notouch .vco-slider .nav-next .nav-container .date,.vco-skinny.vco-notouch .vco-slider .nav-next .nav-container .title,.vco-skinny.vco-notouch .vco-slider .nav-previous .nav-container .date,.vco-skinny.vco-notouch .vco-slider .nav-previous .nav-container .title{filter:alpha(opacity=1);-khtml-opacity:.01;-moz-opacity:.01;opacity:.01}.vco-skinny.vco-notouch .vco-slider .nav-next .nav-container .icon,.vco-skinny.vco-notouch .vco-slider .nav-previous .nav-container .icon{filter:alpha(opacity=15);-khtml-opacity:.15;-moz-opacity:.15;opacity:.15}.vco-skinny.vco-notouch .vco-slider .nav-previous .icon{background-position:-208px 0;margin-left:10px}.vco-skinny.vco-notouch .vco-slider .nav-next .icon,.vco-skinny.vco-notouch .vco-slider .nav-previous .icon{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;width:24px;height:24px;overflow:hidden}.vco-skinny.vco-notouch .vco-slider .nav-next .icon{background-position:-232px 0;margin-left:66px}.vco-skinny.vco-notouch .vco-slider .nav-next:hover,.vco-skinny.vco-notouch .vco-slider .nav-previous:hover{color:#aaa!important;background-color:#333;background-color:rgba(0,0,0,.65);-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px}.vco-skinny.vco-notouch .vco-slider .nav-next:hover .nav-container .date,.vco-skinny.vco-notouch .vco-slider .nav-next:hover .nav-container .icon,.vco-skinny.vco-notouch .vco-slider .nav-next:hover .nav-container .title,.vco-skinny.vco-notouch .vco-slider .nav-previous:hover .nav-container .date,.vco-skinny.vco-notouch .vco-slider .nav-previous:hover .nav-container .icon,.vco-skinny.vco-notouch .vco-slider .nav-previous:hover .nav-container .title{-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;font-weight:700;filter:alpha(opacity=100);-khtml-opacity:1;-moz-opacity:1;opacity:1}.vco-skinny.vco-notouch .vco-slider .nav-next:hover .nav-container .title,.vco-skinny.vco-notouch .vco-slider .nav-previous:hover .nav-container .title{padding-bottom:5px}.vco-skinny.vco-notouch .vco-slider .nav-next:hover .nav-container .date,.vco-skinny.vco-notouch .vco-slider .nav-next:hover .nav-container .title,.vco-skinny.vco-notouch .vco-slider .nav-previous:hover .nav-container .date,.vco-skinny.vco-notouch .vco-slider .nav-previous:hover .nav-container .title{padding-left:5px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.vco-skinny.vco-notouch .vco-slider .nav-previous .icon{background-position:-208px 0}.vco-skinny.vco-notouch .vco-slider .nav-next .icon,.vco-skinny.vco-notouch .vco-slider .nav-previous .icon{background-image:url(\"/imgs/common/timeline/timeline@2x.png\");background-size:352px 260px;background-repeat:no-repeat;width:24px;height:24px;overflow:hidden}.vco-skinny.vco-notouch .vco-slider .nav-next .icon{background-position:-232px 0}}.vco-slider,.vco-slider .slider-container-mask{width:100%;height:100%;overflow:hidden}.vco-slider .slider-container-mask{text-align:center}.vco-slider .slider-container-mask .slider-container{position:absolute;top:0;left:-2160px;width:100%;height:100%;text-align:center;display:block}.vco-slider .slider-container-mask .slider-container .slider-item-container{display:table-cell;vertical-align:middle}.vco-notouch .vco-slider .nav-next:hover,.vco-notouch .vco-slider .nav-previous:hover{color:#333;cursor:pointer}.vco-notouch .vco-slider .nav-previous:hover .icon{margin-left:10px}.vco-notouch .vco-slider .nav-next:hover .icon{margin-left:66px}.vco-notouch .vco-slider .slider-item .content .content-container .media .media-container .wikipedia h4 a:hover{color:#08c;text-decoration:none}.vco-notouch .vco-slider .slider-item .content .content-container .created-at:hover{filter:alpha(opacity=100);-khtml-opacity:1;-moz-opacity:1;opacity:1}.vco-notouch .vco-slider .slider-item .content .content-container .googleplus .googleplus-content .googleplus-attachments a:hover{text-decoration:none}.vco-notouch .vco-slider .slider-item .content .content-container .googleplus .googleplus-content .googleplus-attachments a:hover h5{text-decoration:underline}.vco-slider embed,.vco-slider iframe,.vco-slider img,.vco-slider object,.vco-slider video{max-width:100%}.vco-slider .nav-next,.vco-slider .nav-previous{position:absolute;top:0;width:100px;color:#dbdbdb;font-size:11px}.vco-slider .nav-next .nav-container,.vco-slider .nav-previous .nav-container{height:100px;width:100px;position:absolute}.vco-slider .nav-next .icon,.vco-slider .nav-previous .icon{margin-top:12px;margin-bottom:15px}.vco-slider .nav-next .date,.vco-slider .nav-next .title,.vco-slider .nav-previous .date,.vco-slider .nav-previous .title{line-height:14px}.vco-slider .nav-next .date a,.vco-slider .nav-next .title a,.vco-slider .nav-previous .date a,.vco-slider .nav-previous .title a{color:#999}.vco-slider .nav-next .date small,.vco-slider .nav-next .title small,.vco-slider .nav-previous .date small,.vco-slider .nav-previous .title small{display:none}.vco-slider .nav-next .date,.vco-slider .nav-previous .date{font-size:13px;line-height:13px;font-weight:700;text-transform:uppercase;margin-bottom:5px}.vco-slider .nav-next .title,.vco-slider .nav-previous .title{font-size:11px;line-height:13px}.vco-slider .nav-previous{float:left;text-align:left}.vco-slider .nav-previous .icon{margin-left:15px;background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-160px 0;width:24px;height:24px;overflow:hidden}.vco-slider .nav-previous .date,.vco-slider .nav-previous .title{text-align:left;padding-left:15px}.vco-slider .nav-next{float:right;text-align:right}.vco-slider .nav-next .icon{margin-left:61px;background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-184px 0;width:24px;height:24px;overflow:hidden}.vco-slider .nav-next .date,.vco-slider .nav-next .title{text-align:right;padding-right:15px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.vco-slider .nav-previous .icon{background-position:-160px 0}.vco-slider .nav-next .icon,.vco-slider .nav-previous .icon{background-image:url(\"/imgs/common/timeline/timeline@2x.png\");background-size:352px 260px;background-repeat:no-repeat;width:24px;height:24px;overflow:hidden}.vco-slider .nav-next .icon{background-position:-184px 0}}.vco-slider .slider-item{position:absolute;width:700px;height:100%;padding:0;margin:0;display:table;overflow-y:auto}.vco-slider .slider-item .content{display:table-cell;vertical-align:middle}.vco-slider .slider-item .content .pad-top .text .container{padding-top:15px}.vco-slider .slider-item .content .pad-right .text .container{padding-right:15px}.vco-slider .slider-item .content .pad-left .text .container{padding-left:30px}.vco-slider .slider-item .content .pad-left .media.text-media .media-wrapper .media-container{border:none;background-color:#fff}.vco-slider .slider-item .content .content-container{display:table;vertical-align:middle}.vco-slider .slider-item .content .content-container .text{width:40%;max-width:50%;min-width:120px;display:table-cell;vertical-align:middle}.vco-slider .slider-item .content .content-container .text .container{display:table-cell;vertical-align:middle;text-align:left}.vco-slider .slider-item .content .content-container .text .container p{-webkit-hyphens:auto;-moz-hyphens:auto;-ms-hyphens:auto;hyphens:auto;word-wrap:break-word}.vco-slider .slider-item .content .content-container .text .container h2.date{font-size:15px;line-height:15px;font-weight:400}.vco-slider .slider-item .content .content-container .text .container .slide-tag{font-size:11px;font-weight:700;color:#fff;background-color:#ccc;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;vertical-align:baseline;white-space:nowrap;line-height:11px;padding:1px 3px;margin-left:7.5px;margin-bottom:7.5px}.vco-slider .slider-item .content .content-container .media{width:100%;min-width:50%;float:left}.vco-slider .slider-item .content .content-container .media .media-wrapper{display:inline-block;margin-left:auto;margin-right:auto}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container{display:inline-block;line-height:0;padding:0;max-height:100%}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .media-frame,.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .media-image img{border:1px solid;border-color:#ccc #999 #999 #ccc;background-color:#fff}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .media-frame iframe{background-color:#fff}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .soundcloud{border:0}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .media-image{display:inline-block}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .media-shadow{position:relative;z-index:1;background:#fff}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .media-shadow:after,.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .media-shadow:before{z-index:-1;position:absolute;content:\"\";bottom:15px;left:10px;width:50%;top:80%;max-width:300px;background:#999;-webkit-box-shadow:0 15px 10px #999;-moz-box-shadow:0 15px 10px #999;box-shadow:0 15px 10px #999;-webkit-transform:rotate(-2deg);-moz-transform:rotate(-2deg);-ms-transform:rotate(-2deg);-o-transform:rotate(-2deg);transform:rotate(-2deg)}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .media-shadow:after{-webkit-transform:rotate(2deg);-moz-transform:rotate(2deg);-ms-transform:rotate(2deg);-o-transform:rotate(2deg);transform:rotate(2deg);right:10px;left:auto}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .plain-text{display:table}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .plain-text .container{display:table-cell;vertical-align:middle;font-size:15px;line-height:20px;color:#666}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .plain-text .container p{margin-bottom:20px}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .wikipedia{font-size:15px;line-height:20px;text-align:left;margin-left:auto;margin-right:auto;margin-bottom:15px;clear:both}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .wikipedia .wiki-source{margin-bottom:15px;font-size:13px;line-height:19px;font-style:italic}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .wikipedia h4{border-bottom:1px solid #ccc;margin-bottom:5px}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .wikipedia h4 a{color:#000}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .wikipedia p{font-size:13px;line-height:19px}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .map{line-height:normal;z-index:200;text-align:left;background-color:#fff}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .map img{max-height:none!important;max-width:none!important;border:0;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .map .google-map{height:100%;width:100%}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .map .map-attribution{position:absolute;z-index:201;bottom:0;width:100%;overflow:hidden}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .map .map-attribution .attribution-text{height:19px;overflow:hidden;-webkit-user-select:none;line-height:19px;margin-right:60px;padding-left:65px;font-family:Lato,sans-serif;font-size:10px;color:#444;white-space:nowrap;color:#fff;text-shadow:1px 1px 1px #333;text-align:center}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .map .map-attribution .attribution-text a{color:#fff!important}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .credit{color:#999;text-align:right;display:block;margin:0 auto;margin-top:6px;font-size:10px;line-height:13px}.vco-slider .slider-item .content .content-container .media .media-wrapper .media-container .caption{text-align:left;margin-top:10px;color:#666;font-size:11px;line-height:14px;text-rendering:optimizeLegibility;word-wrap:break-word}.vco-slider .slider-item .content .content-container .media.text-media .media-wrapper .media-container{border:none;background-color:#fff}.vco-slider .slider-item .content .content-container .created-at{width:24px;height:24px;overflow:hidden;margin-left:7.5px;margin-top:2px;display:inline-block;float:right;filter:alpha(opacity=25);-khtml-opacity:.25;-moz-opacity:.25;opacity:.25}.vco-slider .slider-item .content .content-container .storify .created-at{background-repeat:no-repeat;background-position:-328px -96px}.vco-slider .slider-item .content .content-container .twitter .created-at{background-repeat:no-repeat;background-position:-256px -24px}.vco-slider .slider-item .content .content-container .googleplus .googleplus-content{font-size:13px;line-height:19px;margin-bottom:6px;padding-top:10px;background-color:#fff;color:#666}.vco-slider .slider-item .content .content-container .googleplus .googleplus-content p{font-size:13px;line-height:19px}.vco-slider .slider-item .content .content-container .googleplus .googleplus-content .googleplus-title{font-size:24px;line-height:32px;margin-bottom:6px;padding-top:10px;background-color:#fff;color:#000}.vco-slider .slider-item .content .content-container .googleplus .googleplus-content .googleplus-annotation{font-size:15px;line-height:20px;color:#000;border-bottom:1px solid #e3e3e3;padding-bottom:7.5px;margin-bottom:7.5px}.vco-slider .slider-item .content .content-container .googleplus .googleplus-content .googleplus-attachments{border-top:1px solid #e3e3e3;padding-top:15px;margin-top:15px;border-bottom:1px solid #e3e3e3;padding-bottom:15px;margin-bottom:15px;*zoom:1}.vco-slider .slider-item .content .content-container .googleplus .googleplus-content .googleplus-attachments:after,.vco-slider .slider-item .content .content-container .googleplus .googleplus-content .googleplus-attachments:before{display:table;content:\"\"}.vco-slider .slider-item .content .content-container .googleplus .googleplus-content .googleplus-attachments:after{clear:both}.vco-slider .slider-item .content .content-container .googleplus .googleplus-content .googleplus-attachments h5{margin-bottom:5px}.vco-slider .slider-item .content .content-container .googleplus .googleplus-content .googleplus-attachments div{width:50%;padding-left:15px;display:inline-block}.vco-slider .slider-item .content .content-container .googleplus .googleplus-content .googleplus-attachments p{font-size:11px;line-height:14px;margin-bottom:5px}.vco-slider .slider-item .content .content-container .googleplus .googleplus-content .googleplus-attachments img{float:left;display:block;bottom:0;left:0;margin:auto;position:relative;right:0;top:0;width:40%}.vco-slider .slider-item .content .content-container .googleplus .proflinkPrefix{color:#08c}.vco-slider .slider-item .content .content-container .googleplus .created-at{background-repeat:no-repeat;background-position:-208px -72px}.vco-slider .slider-item .content .content-container .googleplus,.vco-slider .slider-item .content .content-container .plain-text-quote,.vco-slider .slider-item .content .content-container .storify,.vco-slider .slider-item .content .content-container .twitter{text-align:left;margin-left:auto;margin-right:auto;margin-bottom:15px;clear:both}.vco-slider .slider-item .content .content-container .googleplus blockquote,.vco-slider .slider-item .content .content-container .plain-text-quote blockquote,.vco-slider .slider-item .content .content-container .storify blockquote,.vco-slider .slider-item .content .content-container .twitter blockquote{color:#666}.vco-slider .slider-item .content .content-container .googleplus blockquote p,.vco-slider .slider-item .content .content-container .plain-text-quote blockquote p,.vco-slider .slider-item .content .content-container .storify blockquote p,.vco-slider .slider-item .content .content-container .twitter blockquote p{font-size:24px;line-height:32px;margin-bottom:6px;padding-top:10px;background-color:#fff;color:#000}.vco-slider .slider-item .content .content-container .googleplus blockquote .quote-mark,.vco-slider .slider-item .content .content-container .plain-text-quote blockquote .quote-mark,.vco-slider .slider-item .content .content-container .storify blockquote .quote-mark,.vco-slider .slider-item .content .content-container .twitter blockquote .quote-mark{color:#666}.vco-slider .slider-item .content .content-container .twitter blockquote{font-size:15px}.vco-slider .slider-item .content .content-container .twitter blockquote p{font-size:24px}.vco-slider .slider-item .content .content-container.layout-text-media .text-media{border-top:1px solid #e3e3e3;padding-top:15px;padding-right:0}.vco-slider .slider-item .content .content-container.layout-text-media.pad-left .text-media{padding-right:15px;padding-top:0;border-right:1px solid #e3e3e3;border-top:0 solid #e3e3e3}.vco-slider .slider-item .content .content-container.layout-text{width:100%}.vco-slider .slider-item .content .content-container.layout-text .text{width:100%;max-width:100%}.vco-slider .slider-item .content .content-container.layout-text .text .container{display:block;vertical-align:middle;padding:0;width:90%;text-align:left;margin-left:auto;margin-right:auto}.vco-slider .slider-item .content .content-container.layout-media{width:100%}.vco-slider .slider-item .content .content-container.layout-media .text{width:100%;height:100%;max-width:100%;display:block;text-align:center}.vco-slider .slider-item .content .content-container.layout-media .text .container{display:block;text-align:center;width:100%;margin-left:none;margin-right:none}.vco-slider .slider-item .content .content-container.layout-media .media{width:100%;min-width:50%;float:none}.vco-slider .slider-item .content .content-container.layout-media .media .media-wrapper .media-container{margin-left:auto;margin-right:auto;line-height:0;padding:0}.vco-slider .slider-item .content .content-container.layout-media .googleplus,.vco-slider .slider-item .content .content-container.layout-media .twitter,.vco-slider .slider-item .content .content-container.layout-media .wikipedia{max-width:70%}.storyjs-embed{background-color:#fff;margin-bottom:20px;border:1px solid #ccc;padding-top:20px;padding-bottom:20px;clear:both;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;-webkit-box-shadow:1px 1px 3px rgba(0,0,0,.35);-moz-box-shadow:1px 1px 3px rgba(0,0,0,.35);box-shadow:1px 1px 3px rgba(0,0,0,.35)}.storyjs-embed.full-embed{border:0!important;padding:0!important;-webkit-border-radius:0!important;-moz-border-radius:0!important;border-radius:0!important}.storyjs-embed.full-embed,.storyjs-embed.sized-embed{overflow:hidden;margin:0!important;clear:both;-webkit-box-shadow:0 0 0 rgba(0,0,0,.25)!important;-moz-box-shadow:0 0 0 rgba(0,0,0,.25)!important;box-shadow:0 0 0 rgba(0,0,0,.25)!important}.storyjs-embed.sized-embed{border:1px solid #ccc;padding-top:7px;padding-bottom:7px}.vco-storyjs{width:100%;height:100%;padding:0;margin:0;background-color:#fff;position:absolute;z-index:100;clear:both;overflow:hidden}.vco-storyjs .vmm-clear:after,.vco-storyjs .vmm-clear:before{content:\"\";display:table}.vco-storyjs .vmm-clear:after{clear:both}.vco-storyjs .vmm-clear{*zoom:1}.vco-storyjs .vco-feature{width:100%}.vco-storyjs .vco-feature .slider,.vco-storyjs .vco-feature .vco-slider{width:100%;float:left;position:relative;z-index:10;padding-top:15px;-webkit-box-shadow:1px 1px 7px rgba(0,0,0,.3);-moz-box-shadow:1px 1px 7px rgba(0,0,0,.3);box-shadow:1px 1px 7px rgba(0,0,0,.3)}.vco-storyjs .vco-feedback{position:absolute;display:table;overflow:hidden;top:0;left:0;z-index:1e+27;width:100%;height:100%}.vco-storyjs div.vco-explainer,.vco-storyjs div.vco-loading{display:table;text-align:center;min-width:100px;margin-top:15px;height:100%;width:100%;background-color:#fff}.vco-storyjs div.vco-explainer .vco-explainer-container,.vco-storyjs div.vco-explainer .vco-loading-container,.vco-storyjs div.vco-loading .vco-explainer-container,.vco-storyjs div.vco-loading .vco-loading-container{display:table-cell;vertical-align:middle}.vco-storyjs div.vco-explainer .vco-explainer-container .vco-loading-icon,.vco-storyjs div.vco-explainer .vco-loading-container .vco-loading-icon,.vco-storyjs div.vco-loading .vco-explainer-container .vco-loading-icon,.vco-storyjs div.vco-loading .vco-loading-container .vco-loading-icon{display:block;background-repeat:no-repeat;vertical-align:middle;margin-left:auto;margin-right:auto;text-align:center;background-image:url(\"/imgs/common/timeline/loading.gif\");width:28px;height:28px}.vco-storyjs div.vco-explainer .vco-explainer-container .vco-gesture-icon,.vco-storyjs div.vco-explainer .vco-loading-container .vco-gesture-icon,.vco-storyjs div.vco-loading .vco-explainer-container .vco-gesture-icon,.vco-storyjs div.vco-loading .vco-loading-container .vco-gesture-icon{display:block;vertical-align:middle;margin-left:auto;margin-right:auto;text-align:center;background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-160px -160px;width:48px;height:48px}.vco-storyjs div.vco-explainer .vco-explainer-container .vco-message,.vco-storyjs div.vco-explainer .vco-loading-container .vco-message,.vco-storyjs div.vco-loading .vco-explainer-container .vco-message,.vco-storyjs div.vco-loading .vco-loading-container .vco-message{display:block}.vco-storyjs div.vco-explainer .vco-explainer-container .vco-message,.vco-storyjs div.vco-explainer .vco-explainer-container .vco-message p,.vco-storyjs div.vco-explainer .vco-loading-container .vco-message,.vco-storyjs div.vco-explainer .vco-loading-container .vco-message p,.vco-storyjs div.vco-loading .vco-explainer-container .vco-message,.vco-storyjs div.vco-loading .vco-explainer-container .vco-message p,.vco-storyjs div.vco-loading .vco-loading-container .vco-message,.vco-storyjs div.vco-loading .vco-loading-container .vco-message p{text-align:center;font-size:11px;line-height:13px;text-transform:uppercase;margin-top:7.5px;margin-bottom:7.5px}.vco-storyjs div.vco-explainer{background-color:transparent}.vco-storyjs .vco-bezel{background-color:#333;background-color:rgba(0,0,0,.8);width:80px;height:50px;padding:50px;padding-top:25px;padding:25px 20px 50px;margin:auto;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px}.vco-storyjs .vco-bezel .vco-message,.vco-storyjs .vco-bezel .vco-message p{color:#fff;font-weight:700}.vco-storyjs .vco-container.vco-main{position:absolute;top:0;left:0;padding-bottom:3px;width:auto;height:auto;margin:0;clear:both}.vco-storyjs embed,.vco-storyjs iframe,.vco-storyjs img,.vco-storyjs object,.vco-storyjs video{max-width:100%}.vco-storyjs img{max-height:100%;border:1px solid #999}.vco-storyjs a{color:#08c;text-decoration:none}.vco-storyjs a:hover{color:#005580;text-decoration:underline}.vco-storyjs .vcard{float:right;margin-bottom:15px}.vco-storyjs .vcard a{color:#333}.vco-storyjs .vcard a:hover{text-decoration:none}.vco-storyjs .vcard a:hover .fn{text-decoration:underline}.vco-storyjs .vcard .fn,.vco-storyjs .vcard .nickname{padding-left:42px}.vco-storyjs .vcard .fn{display:block;font-weight:700}.vco-storyjs .vcard .nickname{margin-top:1px;display:block;color:#666}.vco-storyjs .vcard .avatar{float:left;display:block;width:32px;height:32px}.vco-storyjs .vcard .avatar img{-moz-border-radius:5px;-webkit-border-radius:5px;border-radius:5px}.vco-storyjs .thumbnail{width:24px;height:24px;overflow:hidden;float:left;margin:0;margin-right:1px;margin-top:6px;border:0;padding:0;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0}.vco-storyjs .thumbnail,.vco-storyjs a.thumbnail:hover{-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.vco-storyjs .thumbnail.thumb-plaintext{background-repeat:no-repeat;background-position:-280px -48px}.vco-storyjs .thumbnail.thumb-quote{background-repeat:no-repeat;background-position:-232px -48px}.vco-storyjs .thumbnail.thumb-document{background-repeat:no-repeat;background-position:-256px -48px}.vco-storyjs .thumbnail.thumb-photo{background-repeat:no-repeat;background-position:-280px -24px;border:0}.vco-storyjs .thumbnail.thumb-photo img{border:0 none #ccc!important}.vco-storyjs .thumbnail.thumb-twitter{background-repeat:no-repeat;background-position:-256px -24px}.vco-storyjs .thumbnail.thumb-vimeo{background-repeat:no-repeat;background-position:-328px -48px}.vco-storyjs .thumbnail.thumb-vine{background-repeat:no-repeat;background-position:-232px -72px}.vco-storyjs .thumbnail.thumb-youtube{background-repeat:no-repeat;background-position:-328px -72px}.vco-storyjs .thumbnail.thumb-video{background-repeat:no-repeat;background-position:-328px -24px}.vco-storyjs .thumbnail.thumb-audio{background-repeat:no-repeat;background-position:-304px -24px}.vco-storyjs .thumbnail.thumb-map{background-repeat:no-repeat;background-position:-208px -48px}.vco-storyjs .thumbnail.thumb-website{background-repeat:no-repeat;background-position:-232px -24px}.vco-storyjs .thumbnail.thumb-link{background-repeat:no-repeat;background-position:-184px -72px}.vco-storyjs .thumbnail.thumb-wikipedia{background-repeat:no-repeat;background-position:-184px -48px}.vco-storyjs .thumbnail.thumb-storify{background-repeat:no-repeat;background-position:-328px -96px}.vco-storyjs .thumbnail.thumb-googleplus{background-repeat:no-repeat;background-position:-208px -72px}.vco-storyjs thumbnail.thumb-instagram{background-repeat:no-repeat;background-position:-208px -96px}.vco-storyjs thumbnail.thumb-instagram-full{background-position:-232px -96px;height:24px}.vco-storyjs .thumb-storify-full,.vco-storyjs thumbnail.thumb-instagram-full{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;width:48px}.vco-storyjs .thumb-storify-full{height:12px;background-position:-280px -96px}.vco-storyjs .thumbnail-inline{width:16px;height:14px;overflow:hidden;display:inline-block;margin-right:1px;margin-left:3px;margin-top:2px;filter:alpha(opacity=50);-khtml-opacity:.5;-moz-opacity:.5;opacity:.5}.vco-storyjs .twitter .thumbnail-inline{background-position:-160px -96px}.vco-storyjs .storify .thumbnail-inline,.vco-storyjs .twitter .thumbnail-inline{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat}.vco-storyjs .storify .thumbnail-inline{background-position:-184px -96px}.vco-storyjs .googleplus .thumbnail-inline{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-208px -96px}.vco-storyjs .zFront{z-index:204}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.vco-storyjs div.vco-explainer .vco-explainer-container .vco-loading-icon,.vco-storyjs div.vco-explainer .vco-loading-container .vco-loading-icon,.vco-storyjs div.vco-loading .vco-explainer-container .vco-loading-icon,.vco-storyjs div.vco-loading .vco-loading-container .vco-loading-icon{background-image:url(\"/imgs/common/timeline/loading@2x.gif\")}.vco-storyjs div.vco-explainer .vco-explainer-container .vco-gesture-icon,.vco-storyjs div.vco-explainer .vco-loading-container .vco-gesture-icon,.vco-storyjs div.vco-loading .vco-explainer-container .vco-gesture-icon,.vco-storyjs div.vco-loading .vco-loading-container .vco-gesture-icon{background-image:url(\"/imgs/common/timeline/timeline@2x.png\");background-size:352px 260px;background-repeat:no-repeat;background-position:-160px -160px;width:48px;height:48px}}.vco-notouch .vco-navigation .vco-toolbar .back-home:hover,.vco-notouch .vco-navigation .vco-toolbar .zoom-in:hover,.vco-notouch .vco-navigation .vco-toolbar .zoom-out:hover{color:#08c;cursor:pointer;filter:alpha(opacity=100);-khtml-opacity:1;-moz-opacity:1;opacity:1}.vco-notouch .vco-navigation .timenav .content .marker.active:hover{cursor:default}.vco-notouch .vco-navigation .timenav .content .marker.active:hover .flag-small .flag-content h3,.vco-notouch .vco-navigation .timenav .content .marker.active:hover .flag .flag-content h3{color:#08c}.vco-notouch .vco-navigation .timenav .content .marker.active:hover .flag-small .flag-content h4,.vco-notouch .vco-navigation .timenav .content .marker.active:hover .flag .flag-content h4{color:#999}.vco-notouch .vco-navigation .timenav .content .marker:hover .line{z-index:24;background:#999}.vco-notouch .vco-navigation .timenav .content .marker .flag-small:hover,.vco-notouch .vco-navigation .timenav .content .marker .flag:hover{cursor:pointer}.vco-notouch .vco-navigation .timenav .content .marker .flag-small:hover .flag-content h3,.vco-notouch .vco-navigation .timenav .content .marker .flag:hover .flag-content h3{color:#333}.vco-notouch .vco-navigation .timenav .content .marker .flag-small:hover .flag-content h4,.vco-notouch .vco-navigation .timenav .content .marker .flag:hover .flag-content h4{color:#aaa}.vco-notouch .vco-navigation .timenav .content .marker .flag-small:hover .flag-content .thumbnail,.vco-notouch .vco-navigation .timenav .content .marker .flag:hover .flag-content .thumbnail{filter:alpha(opacity=100);-khtml-opacity:1;-moz-opacity:1;opacity:1}.vco-notouch .vco-navigation .timenav .content .marker .flag:hover{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:0 -53px;width:153px;height:53px}.vco-notouch .vco-navigation .timenav .content .marker .flag-small:hover{height:56px;background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:0 -53px;width:153px;height:53px}.vco-notouch .vco-navigation .timenav .content .marker .flag-small:hover .flag-content{height:36px}.vco-notouch .vco-navigation .timenav .content .marker .flag-small:hover .flag-content h3{margin-top:5px}.vco-notouch .vco-navigation .timenav .content .marker .flag-small.flag-small-last:hover{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:0 -109px;width:153px;height:26px}.vco-notouch .vco-navigation .timenav .content .marker .flag-small.flag-small-last:hover .flag-content{height:14px}.vco-notouch .vco-navigation .timenav .content .marker .flag-small.flag-small-last:hover .flag-content h3{margin-top:4px}.vco-timeline .vco-navigation{clear:both;cursor:move;width:100%;height:200px;border-top:1px solid #e3e3e3;position:relative}.vco-timeline .vco-navigation .vco-toolbar{position:absolute;top:45px;left:0;z-index:202;background-color:#fff;border:1px solid #ccc;-webkit-box-shadow:1px 1px 0 rgba(0,0,0,.2);-moz-box-shadow:1px 1px 0 rgba(0,0,0,.2);box-shadow:1px 1px 0 rgba(0,0,0,.2)}.vco-timeline .vco-navigation .vco-toolbar .back-home,.vco-timeline .vco-navigation .vco-toolbar .zoom-in,.vco-timeline .vco-navigation .vco-toolbar .zoom-out{font-weight:400;font-size:10px;line-height:20px;top:0;z-index:202;width:18px;height:18px;color:#333;text-align:center;font-weight:700;border:1px solid #fff;padding:5px;filter:alpha(opacity=50);-khtml-opacity:.5;-moz-opacity:.5;opacity:.5}.vco-timeline .vco-navigation .vco-toolbar .zoom-in .icon{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-256px 0;width:24px;height:24px}.vco-timeline .vco-navigation .vco-toolbar .zoom-out .icon{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-280px 0;width:24px;height:24px}.vco-timeline .vco-navigation .vco-toolbar .back-home .icon{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-328px 0;width:24px;height:24px}.vco-timeline .vco-navigation .vco-toolbar.touch{-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;background-color:transparent;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.vco-timeline .vco-navigation .vco-toolbar.touch .back-home,.vco-timeline .vco-navigation .vco-toolbar.touch .zoom-in,.vco-timeline .vco-navigation .vco-toolbar.touch .zoom-out{width:40px;height:40px;padding:5px;background-color:#fff;border:1px solid #ccc;-webkit-box-shadow:1px 1px 0 rgba(0,0,0,.2);-moz-box-shadow:1px 1px 0 rgba(0,0,0,.2);box-shadow:1px 1px 0 rgba(0,0,0,.2);-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;filter:alpha(opacity=100);-khtml-opacity:1;-moz-opacity:1;opacity:1}.vco-timeline .vco-navigation .vco-toolbar.touch .zoom-in .icon{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-208px -160px;width:40px;height:40px}.vco-timeline .vco-navigation .vco-toolbar.touch .zoom-out .icon{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-256px -160px;width:40px;height:40px}.vco-timeline .vco-navigation .vco-toolbar.touch .back-home .icon{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-304px -160px;width:40px;height:40px}.vco-timeline .vco-navigation .timenav-background{position:absolute;cursor:move;top:0;left:0;height:150px;width:100%;background-color:#e9e9e9}.vco-timeline .vco-navigation .timenav-background .timenav-interval-background{position:absolute;top:151px;left:0;background:#fff;width:100%;height:49px;-webkit-box-shadow:-1px -1px 7px rgba(0,0,0,.1);-moz-box-shadow:-1px -1px 7px rgba(0,0,0,.1);box-shadow:-1px -1px 7px rgba(0,0,0,.1)}.vco-timeline .vco-navigation .timenav-background .timenav-interval-background .top-highlight{position:absolute;top:-1px;left:0;z-index:30;width:100%;height:1px;background:#fff;filter:alpha(opacity=50);-khtml-opacity:.5;-moz-opacity:.5;opacity:.5;-webkit-box-shadow:1px 1px 5px rgba(0,0,0,.2);-moz-box-shadow:1px 1px 5px rgba(0,0,0,.2);box-shadow:1px 1px 5px rgba(0,0,0,.2)}.vco-timeline .vco-navigation .timenav-background .timenav-line{position:absolute;top:0;left:50%;width:3px;height:150px;background-color:#08c;z-index:1;-webkit-box-shadow:1px 1px 7px rgba(0,0,0,.3);-moz-box-shadow:1px 1px 7px rgba(0,0,0,.3);box-shadow:1px 1px 7px rgba(0,0,0,.3)}.vco-timeline .vco-navigation .timenav-background .timenav-indicator{position:absolute;top:-1px;left:50%;z-index:202;background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-160px -48px;width:24px;height:24px}.vco-timeline .vco-navigation .timenav-background .timenav-tag div{height:50px;display:table}.vco-timeline .vco-navigation .timenav-background .timenav-tag div h3{display:table-cell;vertical-align:middle;padding-left:65px;font-size:15px;color:#d0d0d0;font-weight:700;text-shadow:0 1px 1px #fff}.vco-timeline .vco-navigation .timenav-background .timenav-tag-size-half,.vco-timeline .vco-navigation .timenav-background .timenav-tag-size-half div{height:25px}.vco-timeline .vco-navigation .timenav-background .timenav-tag-size-full,.vco-timeline .vco-navigation .timenav-background .timenav-tag-size-full div{height:50px}.vco-timeline .vco-navigation .timenav-background .timenav-tag-row-2,.vco-timeline .vco-navigation .timenav-background .timenav-tag-row-4,.vco-timeline .vco-navigation .timenav-background .timenav-tag-row-6{background:#f1f1f1}.vco-timeline .vco-navigation .timenav-background .timenav-tag-row-1,.vco-timeline .vco-navigation .timenav-background .timenav-tag-row-3,.vco-timeline .vco-navigation .timenav-background .timenav-tag-row-5{background:#e9e9e9}.vco-timeline .vco-navigation .timenav{position:absolute;top:0;left:-250px;z-index:1}.vco-timeline .vco-navigation .timenav .content{position:relative}.vco-timeline .vco-navigation .timenav .content .marker.start{display:none}.vco-timeline .vco-navigation .timenav .content .marker.active .dot{background:#08c;z-index:200}.vco-timeline .vco-navigation .timenav .content .marker.active .line{z-index:199;background:#08c;width:1px}.vco-timeline .vco-navigation .timenav .content .marker.active .line .event-line{background:#08c;filter:alpha(opacity=75);-khtml-opacity:.75;-moz-opacity:.75;opacity:.75}.vco-timeline .vco-navigation .timenav .content .marker.active .flag,.vco-timeline .vco-navigation .timenav .content .marker.active .flag-small{z-index:200}.vco-timeline .vco-navigation .timenav .content .marker.active .flag-small .flag-content,.vco-timeline .vco-navigation .timenav .content .marker.active .flag .flag-content{height:36px}.vco-timeline .vco-navigation .timenav .content .marker.active .flag-small .flag-content h3,.vco-timeline .vco-navigation .timenav .content .marker.active .flag .flag-content h3{color:#08c;margin-top:5px}.vco-timeline .vco-navigation .timenav .content .marker.active .flag-small .flag-content .thumbnail,.vco-timeline .vco-navigation .timenav .content .marker.active .flag .flag-content .thumbnail{filter:alpha(opacity=100);-khtml-opacity:1;-moz-opacity:1;opacity:1}.vco-timeline .vco-navigation .timenav .content .marker.active .flag-small.row1,.vco-timeline .vco-navigation .timenav .content .marker.active .flag-small.row2,.vco-timeline .vco-navigation .timenav .content .marker.active .flag-small.row3,.vco-timeline .vco-navigation .timenav .content .marker.active .flag.row1,.vco-timeline .vco-navigation .timenav .content .marker.active .flag.row2,.vco-timeline .vco-navigation .timenav .content .marker.active .flag.row3{z-index:200}.vco-timeline .vco-navigation .timenav .content .marker.active .flag{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:0 -53px;width:153px;height:53px}.vco-timeline .vco-navigation .timenav .content .marker.active .flag-small{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:0 -109px;width:153px;height:26px}.vco-timeline .vco-navigation .timenav .content .marker.active .flag-small .flag-content{height:14px}.vco-timeline .vco-navigation .timenav .content .marker.active .flag-small .flag-content h3{margin-top:4px}.vco-timeline .vco-navigation .timenav .content .marker{position:absolute;top:0;left:150px;display:block}.vco-timeline .vco-navigation .timenav .content .marker .dot{position:absolute;top:150px;left:0;display:block;width:6px;height:6px;background:#333;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;z-index:21}.vco-timeline .vco-navigation .timenav .content .marker .line{position:absolute;top:0;left:3px;width:1px;height:150px;background-color:#ccc;background-color:hsla(0,0%,80%,.5);-webkit-box-shadow:1px 0 0 hsla(0,0%,100%,.5);-moz-box-shadow:1px 0 0 hsla(0,0%,100%,.5);box-shadow:1px 0 0 hsla(0,0%,100%,.5);z-index:22}.vco-timeline .vco-navigation .timenav .content .marker .line .event-line{position:absolute;z-index:22;left:0;height:1px;width:1px;background:#08c;filter:alpha(opacity=15);-khtml-opacity:.15;-moz-opacity:.15;opacity:.15}.vco-timeline .vco-navigation .timenav .content .marker .flag,.vco-timeline .vco-navigation .timenav .content .marker .flag-small{position:absolute;top:15px;left:3px;padding:0;display:block;z-index:23;width:153px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content,.vco-timeline .vco-navigation .timenav .content .marker .flag .flag-content{padding:0 7px 2px 6px;overflow:hidden}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content h3,.vco-timeline .vco-navigation .timenav .content .marker .flag .flag-content h3{font-weight:700;font-size:15px;line-height:20px;font-size:11px;line-height:11px;color:#999;margin-bottom:2px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content h3 small,.vco-timeline .vco-navigation .timenav .content .marker .flag .flag-content h3 small{display:none}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content h4,.vco-timeline .vco-navigation .timenav .content .marker .flag .flag-content h4{display:none;font-weight:400;font-size:15px;line-height:20px;margin-top:5px;font-size:10px;line-height:10px;color:#aaa}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content h4 small,.vco-timeline .vco-navigation .timenav .content .marker .flag .flag-content h4 small{display:none}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail,.vco-timeline .vco-navigation .timenav .content .marker .flag .flag-content .thumbnail{margin-bottom:15px;margin-right:3px;filter:alpha(opacity=50);-khtml-opacity:.5;-moz-opacity:.5;opacity:.5}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail img,.vco-timeline .vco-navigation .timenav .content .marker .flag .flag-content .thumbnail img{width:22px;height:22px;max-height:none;max-width:none;border:0;border:1px solid #999;padding:0;margin:0}.vco-timeline .vco-navigation .timenav .content .marker .flag{height:56px;background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:0 0;width:153px;height:53px}.vco-timeline .vco-navigation .timenav .content .marker .flag .flag-content{height:36px}.vco-timeline .vco-navigation .timenav .content .marker .flag .flag-content h3{margin-top:5px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:0 -135px;width:153px;height:26px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content{height:14px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content h3{margin-top:4px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail{width:16px;height:10px;margin-right:1px;margin-top:6px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail.thumb-plaintext{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-280px -130px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail.thumb-quote{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-232px -130px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail.thumb-document{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-256px -130px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail.thumb-photo{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-280px -120px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail.thumb-twitter{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-256px -120px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail.thumb-vimeo{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-328px -130px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail.thumb-vine{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-160px -120px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail.thumb-youtube{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-304px -130px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail.thumb-video{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-328px -120px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail.thumb-audio{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-304px -120px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail.thumb-map{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-208px -120px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail.thumb-link,.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail.thumb-website{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-232px -120px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail.thumb-wikipedia{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-184px -120px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail.thumb-storify{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-184px -130px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content .thumbnail.thumb-googleplus{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-208px -130px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small .flag-content thumbnail.thumb-instagram{background-image:url(\"/imgs/common/timeline/timeline.png\");background-repeat:no-repeat;background-position:-208px -96px}.vco-timeline .vco-navigation .timenav .content .marker .flag.row1{z-index:25;top:48px}.vco-timeline .vco-navigation .timenav .content .marker .flag.row2{z-index:24;top:96px}.vco-timeline .vco-navigation .timenav .content .marker .flag.row3{z-index:23;top:1px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small.row1{z-index:28;top:24px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small.row2{z-index:27;top:48px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small.row3{z-index:26;top:72px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small.row4{z-index:25;top:96px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small.row5{z-index:24;top:120px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small.row6{z-index:23;top:1px}.vco-timeline .vco-navigation .timenav .content .marker .flag-small.zFront,.vco-timeline .vco-navigation .timenav .content .marker .flag.zFront{z-index:201}.vco-timeline .vco-navigation .timenav .content .era{position:absolute;top:138px;left:150px;height:12px;display:block;overflow:hidden}.vco-timeline .vco-navigation .timenav .content .era div{height:50px;width:100%;height:100%;line-height:0;background:#e9e9e9;background:hsla(0,0%,91%,.33)}.vco-timeline .vco-navigation .timenav .content .era div h3,.vco-timeline .vco-navigation .timenav .content .era div h4{position:absolute;bottom:1px;padding-left:15px;font-size:15px;font-weight:700;color:rgba(0,136,204,.35);text-shadow:0 1px 1px #fff}.vco-timeline .vco-navigation .timenav .content .era1 div{background:#c40;filter:alpha(opacity=10);-khtml-opacity:.1;-moz-opacity:.1;opacity:.1;border-left:1px solid rgba(204,68,0,.1);border-right:1px solid rgba(255,85,0,.05)}.vco-timeline .vco-navigation .timenav .content .era1 div h3,.vco-timeline .vco-navigation .timenav .content .era1 div h4{color:rgba(204,68,0,.35);text-shadow:0 1px 1px #fff}.vco-timeline .vco-navigation .timenav .content .era2 div{background:#c02;filter:alpha(opacity=10);-khtml-opacity:.1;-moz-opacity:.1;opacity:.1;border-left:1px solid rgba(204,0,34,.1);border-right:1px solid rgba(255,0,43,.05)}.vco-timeline .vco-navigation .timenav .content .era2 div h3,.vco-timeline .vco-navigation .timenav .content .era2 div h4{color:rgba(204,0,34,.35);text-shadow:0 1px 1px #fff}.vco-timeline .vco-navigation .timenav .content .era3 div{background:#02c;filter:alpha(opacity=10);-khtml-opacity:.1;-moz-opacity:.1;opacity:.1;border-left:1px solid rgba(0,34,204,.1);border-right:1px solid rgba(0,43,255,.05)}.vco-timeline .vco-navigation .timenav .content .era3 div h3,.vco-timeline .vco-navigation .timenav .content .era3 div h4{color:rgba(0,34,204,.35);text-shadow:0 1px 1px #fff}.vco-timeline .vco-navigation .timenav .content .era4 div{background:#ca0;filter:alpha(opacity=10);-khtml-opacity:.1;-moz-opacity:.1;opacity:.1;border-left:1px solid rgba(204,170,0,.1);border-right:1px solid rgba(255,213,0,.05)}.vco-timeline .vco-navigation .timenav .content .era4 div h3,.vco-timeline .vco-navigation .timenav .content .era4 div h4{color:rgba(204,170,0,.35);text-shadow:0 1px 1px #fff}.vco-timeline .vco-navigation .timenav .content .era5 div{background:#0ca;filter:alpha(opacity=10);-khtml-opacity:.1;-moz-opacity:.1;opacity:.1;border-left:1px solid rgba(0,204,170,.1);border-right:1px solid rgba(0,255,213,.05)}.vco-timeline .vco-navigation .timenav .content .era5 div h3,.vco-timeline .vco-navigation .timenav .content .era5 div h4{color:rgba(0,204,170,.35);text-shadow:0 1px 1px #fff}.vco-timeline .vco-navigation .timenav .content .era6 div{background:#08c;filter:alpha(opacity=10);-khtml-opacity:.1;-moz-opacity:.1;opacity:.1;border-left:1px solid rgba(0,136,204,.1);border-right:1px solid rgba(0,170,255,.05)}.vco-timeline .vco-navigation .timenav .content .era6 div h3,.vco-timeline .vco-navigation .timenav .content .era6 div h4{color:rgba(0,136,204,.35);text-shadow:0 1px 1px #fff}.vco-timeline .vco-navigation .timenav .time{position:absolute;left:0;top:150px;height:50px;background-color:#fff;line-height:0}.vco-timeline .vco-navigation .timenav .time .time-interval-minor{max-width:none;height:6px;white-space:nowrap;position:absolute;top:-2px;left:8px;z-index:10}.vco-timeline .vco-navigation .timenav .time .time-interval-minor .minor{position:relative;top:2px;display:inline-block;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAMCAMAAACdvocfAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRFzMzM////040VdgAAAAJ0Uk5T/wDltzBKAAAAEklEQVR42mJgYAQCBopJgAADAAbwADHy2qHzAAAAAElFTkSuQmCC);width:100px;height:6px;background-position:top;white-space:nowrap;color:#666;margin-top:0;padding-top:0}.vco-timeline .vco-navigation .timenav .time .time-interval{white-space:nowrap;position:absolute;top:5px;left:0}.vco-timeline .vco-navigation .timenav .time .time-interval div{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAMCAMAAACdvocfAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRFzMzM////040VdgAAAAJ0Uk5T/wDltzBKAAAAEklEQVR42mJgYAQCBopJgAADAAbwADHy2qHzAAAAAElFTkSuQmCC);background-position:0 0;background-repeat:no-repeat;padding-top:6px;position:absolute;height:3px;left:0;display:block;font-weight:400;font-size:10px;line-height:20px;text-transform:uppercase;text-align:left;text-indent:0;white-space:nowrap;color:#666;margin-left:0;margin-right:0;margin-top:0;z-index:2}.vco-timeline .vco-navigation .timenav .time .time-interval div strong{font-weight:700;color:#000}.vco-timeline .vco-navigation .timenav .time .time-interval div.era{font-weight:700;padding-top:0;margin-top:-3px;margin-left:2px;background-image:none}.vco-timeline .vco-navigation .timenav .time .time-interval .era1{color:#c40;filter:alpha(opacity=50);-khtml-opacity:.5;-moz-opacity:.5;opacity:.5}.vco-timeline .vco-navigation .timenav .time .time-interval .era2{color:#c02;filter:alpha(opacity=50);-khtml-opacity:.5;-moz-opacity:.5;opacity:.5}.vco-timeline .vco-navigation .timenav .time .time-interval .era3{color:#02c;filter:alpha(opacity=50);-khtml-opacity:.5;-moz-opacity:.5;opacity:.5}.vco-timeline .vco-navigation .timenav .time .time-interval .era4{color:#ca0;filter:alpha(opacity=50);-khtml-opacity:.5;-moz-opacity:.5;opacity:.5}.vco-timeline .vco-navigation .timenav .time .time-interval .era5{color:#0ca;filter:alpha(opacity=50);-khtml-opacity:.5;-moz-opacity:.5;opacity:.5}.vco-timeline .vco-navigation .timenav .time .time-interval .era6{color:#08c;filter:alpha(opacity=50);-khtml-opacity:.5;-moz-opacity:.5;opacity:.5}.vco-timeline .vco-navigation .timenav .time .time-interval-major{white-space:nowrap;position:absolute;top:5px;left:0}.vco-timeline .vco-navigation .timenav .time .time-interval-major div{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAQAQMAAADtUYf0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyOTAzRjI3REIzNDcxMUUxQUQ3QUZCOThEODQ1NDhCNyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyOTAzRjI3RUIzNDcxMUUxQUQ3QUZCOThEODQ1NDhCNyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjI5MDNGMjdCQjM0NzExRTFBRDdBRkI5OEQ4NDU0OEI3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjI5MDNGMjdDQjM0NzExRTFBRDdBRkI5OEQ4NDU0OEI3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+DPWNfQAAAANQTFRFzMzMylJEJwAAAAtJREFUCB1jYMAPAAAgAAHDvpOtAAAAAElFTkSuQmCC);background-position:0 0;background-repeat:no-repeat;padding-top:15px;position:absolute;height:15px;left:0;display:block;font-weight:700;font-size:12px;line-height:20px;text-transform:uppercase;text-align:left;text-indent:0;white-space:nowrap;color:#333;margin-left:0;margin-right:0;margin-top:1px;z-index:5}.vco-timeline .vco-navigation .timenav .time .time-interval-major div strong{font-weight:700;color:#000}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.vco-notouch .vco-navigation .vco-toolbar .zoom-in .icon{background-position:-256px 0}.vco-notouch .vco-navigation .vco-toolbar .zoom-in .icon,.vco-notouch .vco-navigation .vco-toolbar .zoom-out .icon{background-image:url(\"/imgs/common/timeline/timeline@2x.png\");background-size:352px 260px;background-repeat:no-repeat;width:24px;height:24px}.vco-notouch .vco-navigation .vco-toolbar .zoom-out .icon{background-position:-280px 0}.vco-notouch .vco-navigation .vco-toolbar .back-home .icon{background-image:url(\"/imgs/common/timeline/timeline@2x.png\");background-size:352px 260px;background-repeat:no-repeat;background-position:-328px 0;width:24px;height:24px}.vco-notouch .vco-navigation .vco-toolbar.touch .zoom-in .icon{background-position:-208px -160px}.vco-notouch .vco-navigation .vco-toolbar.touch .zoom-in .icon,.vco-notouch .vco-navigation .vco-toolbar.touch .zoom-out .icon{background-image:url(\"/imgs/common/timeline/timeline@2x.png\");background-size:352px 260px;background-repeat:no-repeat;width:40px;height:40px}.vco-notouch .vco-navigation .vco-toolbar.touch .zoom-out .icon{background-position:-256px -160px}.vco-notouch .vco-navigation .vco-toolbar.touch .back-home .icon{background-image:url(\"/imgs/common/timeline/timeline@2x.png\");background-size:352px 260px;background-repeat:no-repeat;background-position:-304px -160px;width:40px;height:40px}.vco-notouch .vco-navigation .timenav .content .marker .flag-small:hover,.vco-notouch .vco-navigation .timenav .content .marker .flag:hover{background-image:url(\"/imgs/common/timeline/timeline@2x.png\");background-size:352px 260px;background-repeat:no-repeat;background-position:0 -53px;width:153px;height:53px}.vco-notouch .vco-navigation .timenav .content .marker .flag-small.flag-small-last:hover{background-image:url(\"/imgs/common/timeline/timeline@2x.png\");background-size:352px 260px;background-repeat:no-repeat;background-position:0 -109px;width:153px;height:26px}.vco-notouch .vco-navigation .timenav-background .timenav-indicator{background-image:url(\"/imgs/common/timeline/timeline@2x.png\");background-size:352px 260px;background-repeat:no-repeat;background-position:-160px -48px;width:24px;height:24px}}@media screen and (max-device-width:480px) and (orientation:portrait){.storyjs-embed.full-embed{height:557px!important;width:320px!important}.storyjs-embed.full-embed .vco-feature{height:356px!important}}@media screen and (max-device-width:480px) and (orientation:landscape){.storyjs-embed.full-embed{height:409px!important;width:480px!important}.storyjs-embed.full-embed .vco-feature{height:208px!important}}.dd{max-width:600px;font-size:13px;line-height:20px}.dd,.dd-list{position:relative;display:block;margin:0;padding:0;list-style:none}.dd-list .dd-list{padding-left:30px}.dd-empty,.dd-item,.dd-placeholder{display:block;position:relative;margin:0;padding:0;min-height:20px;font-size:13px;line-height:20px}.dd-handle{display:block;height:30px;margin:5px 0;padding:5px 10px;color:#333;text-decoration:none;font-weight:700;border:1px solid #ccc;background:#fafafa;border-radius:3px;box-sizing:border-box}.dd-handle:hover{color:#2ea8e5;background:#fff}.dd-item>button{position:relative;cursor:pointer;float:left;width:25px;height:20px;margin:5px 0;padding:0;text-indent:100%;white-space:nowrap;overflow:hidden;border:0;background:transparent;font-size:12px;line-height:1;text-align:center;font-weight:700}.dd-item>button:before{display:block;position:absolute;width:100%;text-align:center;text-indent:0}.dd-item>button.dd-expand:before{content:\"+\"}.dd-item>button.dd-collapse:before{content:\"-\"}.dd-collapsed .dd-collapse,.dd-collapsed .dd-list,.dd-expand{display:none}.dd-collapsed .dd-expand{display:block}.dd-empty,.dd-placeholder{margin:5px 0;padding:0;min-height:30px;background:#f2fbff;border:1px dashed #b6bcbf;box-sizing:border-box;-moz-box-sizing:border-box}.dd-empty{border:1px dashed #bbb;min-height:100px;background-color:#e5e5e5;background-size:60px 60px;background-position:0 0,30px 30px}.dd-dragel{position:absolute;pointer-events:none;z-index:9999}.dd-dragel>.dd-item .dd-handle{margin-top:0}.dd-dragel .dd-handle{box-shadow:2px 4px 6px 0 rgba(0,0,0,.1)}.nestable{padding:25px;padding-left:0}.nestable>.dd-list:first-child,.nestable>.dd-list:last-child{margin:0}.dd{max-width:100%}.dd-list{padding-left:25px}\n\n/*! Tablesaw - v2.0.2 - 2015-10-27\n* https://github.com/filamentgroup/tablesaw\n* Copyright (c) 2015 Filament Group; Licensed MIT */table.tablesaw{empty-cells:show;max-width:100%;width:100%}.tablesaw{border-collapse:collapse;width:100%;border:0;padding:0}.tablesaw td,.tablesaw th{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;padding:.5em .7em}.tablesaw thead tr:first-child th{padding-top:.9em;padding-bottom:.7em}.tablesaw-enhanced .tablesaw-bar .btn{border:1px solid #ccc;background:none;background-color:#fafafa;-webkit-box-shadow:0 1px 0 #fff;box-shadow:0 1px 0 #fff;color:#4a4a4a;clear:both;cursor:pointer;display:block;font:700 20px/1 sans-serif;margin:0;padding:.5em .85em .4em;position:relative;text-align:center;text-decoration:none;text-transform:capitalize;text-shadow:0 1px 0 #fff;width:100%;-webkit-appearance:none!important;-moz-appearance:none!important;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;-webkit-font-smoothing:antialiased;border-radius:.25em}.tablesaw-enhanced .tablesaw-bar a.btn{color:#1c95d4}.tablesaw-enhanced .tablesaw-bar .btn:hover{text-decoration:none}.tablesaw-enhanced .tablesaw-bar .btn:active{background-color:#ddd}.tablesaw-enhanced .tablesaw-bar .btn:focus,.tablesaw-enhanced .tablesaw-bar .btn:hover{color:#208de3;background-color:#fff;outline:none}.tablesaw-bar .btn:focus{-webkit-box-shadow:0 0 .35em #4faeef!important;box-shadow:0 0 .35em #4faeef!important}.tablesaw-bar .btn-select select{background:none;border:none;display:block;position:absolute;font-weight:inherit;left:0;top:0;margin:0;width:100%;height:100%;z-index:2;min-height:1em;opacity:0;filter:alpha(opacity=0);display:inline-block;color:transparent}.tablesaw-bar .btn select option{background:#fff;color:#000;font-family:sans-serif}.tablesaw-enhanced .tablesaw-bar .btn.btn-select{color:#4d4d4d;padding-right:2.5em;min-width:7.25em;text-align:left;text-indent:0}.tablesaw-bar .btn.btn-micro,.tablesaw-bar .btn.btn-small{display:inline-block;width:auto;height:auto;position:relative;top:0}.tablesaw-bar .btn.btn-small{font-size:1.0625em;line-height:19px;padding:.3em 1em}.tablesaw-bar .btn.btn-micro{font-size:.8125em;padding:.4em .7em .25em}.tablesaw-enhanced .tablesaw-bar .btn-select{text-align:left}.tablesaw-bar .btn-select:after{background:#e5e5e5;background:rgba(0,0,0,.1);-webkit-box-shadow:0 2px 2px hsla(0,0%,100%,.25);box-shadow:0 2px 2px hsla(0,0%,100%,.25);content:\" \";display:block;position:absolute}.tablesaw-bar .btn-select.btn-micro,.tablesaw-bar .btn-select.btn-small{padding-right:1.5em}.tablesaw-bar .btn-select:after{background:none;background-repeat:no-repeat;background-position:.25em .45em;content:\"\\25BC\";font-size:.55em;padding-top:1.2em;padding-left:1em;left:auto;right:0;margin:0;top:0;bottom:0;width:1.8em}.tablesaw-bar .btn-select.btn-micro:after,.tablesaw-bar .btn-select.btn-small:after{width:1.2em;font-size:.5em;padding-top:1em;padding-right:.5em;line-height:1.65;background:none;-webkit-box-shadow:none;box-shadow:none;border-left-width:0}.tablesaw-advance .btn{-webkit-appearance:none;-moz-appearance:none;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;text-shadow:0 1px 0 #fff;border-radius:.25em}.tablesaw-advance .btn.btn-micro{font-size:.8125em;padding:.3em .7em .25em}.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn{display:inline-block;overflow:hidden;width:1.8em;height:1.8em;background-position:50% 50%;margin-left:.5em;position:relative}.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.down:before,.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.left:before,.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.right:before,.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.up:before{content:\" \";overflow:hidden;width:0;height:0;position:absolute}.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.down:before{left:.5em;top:.65em;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid gray}.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.up:before{left:.5em;top:.65em;border-left:5px solid transparent;border-right:5px solid transparent;border-bottom:5px solid gray}.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.left:before,.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.right:before{top:.45em;border-top:5px solid transparent;border-bottom:5px solid transparent}.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.left:before{left:.6em;border-right:5px solid gray}.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.right:before{left:.7em;border-left:5px solid gray}.tablesaw-advance a.tablesaw-nav-btn.disabled{opacity:.25;filter:alpha(opacity=25);cursor:default;pointer-events:none}.tablesaw-bar{clear:both;font-family:sans-serif}.tablesaw-toolbar{font-size:.875em;float:left}.tablesaw-toolbar label{padding:.5em 0;clear:both;display:block;color:#888;margin-right:.5em;text-transform:uppercase}.tablesaw-bar .btn,.tablesaw-enhanced .tablesaw-bar .btn{margin-top:.5em;margin-bottom:.5em}.tablesaw-bar .btn-select,.tablesaw-enhanced .tablesaw-bar .btn-select{margin-bottom:0}.tablesaw-bar .tablesaw-toolbar .btn{margin-left:.4em;margin-top:0;text-transform:uppercase;border:none;-webkit-box-shadow:none;box-shadow:none;background:transparent;font-family:sans-serif;font-size:1em;padding-left:.3em}.tablesaw-bar .tablesaw-toolbar .btn-select{min-width:0}.tablesaw-bar .tablesaw-toolbar .btn-select:after{padding-top:.9em}.tablesaw-bar .tablesaw-toolbar select{color:#888;text-transform:none;background:transparent}.tablesaw-toolbar~table{clear:both}.tablesaw-toolbar .a11y-sm{clip:rect(0 0 0 0);height:1px;overflow:hidden;position:absolute;width:1px}@media (min-width:24em){.tablesaw-toolbar .a11y-sm{clip:none;height:auto;width:auto;position:static;overflow:visible}}table.tablesaw tbody th{font-weight:700}table.tablesaw thead td,table.tablesaw thead th{color:#444;font-size:.9em}.tablesaw td,.tablesaw th{line-height:1em;text-align:left;vertical-align:middle}.tablesaw tbody th,.tablesaw td{vertical-align:middle;font-size:1.17em}.tablesaw tbody th .btn,.tablesaw td .btn{margin:0}.tablesaw thead{border:1px solid #e5e5e4;background:#e2dfdc;background-image:-webkit-gradient(linear,left top,left bottom,from(#fff),to(#e2dfdc));background-image:-webkit-linear-gradient(top,#fff,#e2dfdc);background-image:linear-gradient(180deg,#fff,#e2dfdc)}.tablesaw thead th{font-weight:100;color:#777;text-transform:uppercase;text-shadow:0 1px 0 #fff;text-align:left}.tablesaw thead tr:first-child th{font-weight:400;font-family:sans-serif;border-right:1px solid #e4e1de}.tablesaw tbody tr{border-bottom:1px solid #dfdfdf}.tablesaw caption{text-align:left;margin-bottom:0;opacity:.5;filter:alpha(opacity=50);line-height:2.4}@media (min-width:25em){.tablesaw caption{margin-bottom:.6em;line-height:1.2}}.tablesaw-cell-label-top{text-transform:uppercase;font-size:.9em;font-weight:400}.tablesaw-cell-label{font-size:.65em;text-transform:uppercase;color:#888;font-family:sans-serif}@media (min-width:40em){.tablesaw td{line-height:2em}}@media only all{.tablesaw-swipe .tablesaw-cell-persist{border-right:1px solid #e4e1de;-webkit-box-shadow:3px 0 4px -1px #e4e1de;box-shadow:3px 0 4px -1px #e4e1de}}.tablesaw-stack tbody tr{border-bottom:1px solid #dfdfdf}.tablesaw-stack td .tablesaw-cell-label,.tablesaw-stack th .tablesaw-cell-label{display:none}@media only all{.tablesaw-stack td,.tablesaw-stack th{text-align:left;display:block}.tablesaw-stack tr{clear:both;display:table-row}.tablesaw-stack td .tablesaw-cell-label,.tablesaw-stack th .tablesaw-cell-label{display:block;padding:0 .6em 0 0;width:30%;display:inline-block}.tablesaw-stack td .tablesaw-cell-label-top,.tablesaw-stack th .tablesaw-cell-label-top{display:block;padding:.4em 0;margin:.4em 0}.tablesaw-cell-label{display:block}.tablesaw-stack tbody th.group{margin-top:-1px}.tablesaw-stack th.group b.tablesaw-cell-label{display:none!important}}@media (max-width:39.9375em){.tablesaw-stack thead td,.tablesaw-stack thead th{display:none}.tablesaw-stack tbody td,.tablesaw-stack tbody th{clear:left;float:left;width:100%}.tablesaw-cell-label{vertical-align:top}.tablesaw-cell-content{max-width:67%;display:inline-block}.tablesaw-stack td:empty,.tablesaw-stack th:empty{display:none}}@media (min-width:40em){.tablesaw-stack tr{display:table-row}.tablesaw-stack td,.tablesaw-stack th,.tablesaw-stack thead td,.tablesaw-stack thead th{display:table-cell;margin:0}.tablesaw-stack td .tablesaw-cell-label,.tablesaw-stack th .tablesaw-cell-label{display:none!important}}.tablesaw-fix-persist{table-layout:fixed}@media only all{.tablesaw-swipe td.tablesaw-cell-hidden,.tablesaw-swipe th.tablesaw-cell-hidden{display:none}}.btn.tablesaw-columntoggle-btn span{text-indent:-9999px;display:inline-block}.tablesaw-columntoggle-btnwrap{position:relative}.tablesaw-columntoggle-btnwrap .dialog-content{padding:.5em}.tablesaw-columntoggle tbody td{line-height:1.5}.tablesaw-columntoggle-popup{display:none}.tablesaw-columntoggle-btnwrap.visible .tablesaw-columntoggle-popup{display:block;position:absolute;top:2em;right:0;background-color:#fff;padding:.5em .8em;border:1px solid #ccc;-webkit-box-shadow:0 1px 2px #ccc;box-shadow:0 1px 2px #ccc;border-radius:.2em;z-index:1}.tablesaw-columntoggle-popup fieldset{margin:0}@media only all{.tablesaw-columntoggle td.tablesaw-priority-1,.tablesaw-columntoggle td.tablesaw-priority-2,.tablesaw-columntoggle td.tablesaw-priority-3,.tablesaw-columntoggle td.tablesaw-priority-4,.tablesaw-columntoggle td.tablesaw-priority-5,.tablesaw-columntoggle td.tablesaw-priority-6,.tablesaw-columntoggle th.tablesaw-priority-1,.tablesaw-columntoggle th.tablesaw-priority-2,.tablesaw-columntoggle th.tablesaw-priority-3,.tablesaw-columntoggle th.tablesaw-priority-4,.tablesaw-columntoggle th.tablesaw-priority-5,.tablesaw-columntoggle th.tablesaw-priority-6{display:none}}.tablesaw-columntoggle-btnwrap .dialog-content{top:0!important;right:1em;left:auto!important;width:12em;max-width:18em;margin:-.5em auto 0}.tablesaw-columntoggle-btnwrap .dialog-content:focus{outline-style:none}@media (min-width:20em){.tablesaw-columntoggle td.tablesaw-priority-1,.tablesaw-columntoggle th.tablesaw-priority-1{display:table-cell}}@media (min-width:30em){.tablesaw-columntoggle td.tablesaw-priority-2,.tablesaw-columntoggle th.tablesaw-priority-2{display:table-cell}}@media (min-width:40em){.tablesaw-columntoggle td.tablesaw-priority-3,.tablesaw-columntoggle th.tablesaw-priority-3{display:table-cell}.tablesaw-columntoggle tbody td{line-height:2}}@media (min-width:50em){.tablesaw-columntoggle td.tablesaw-priority-4,.tablesaw-columntoggle th.tablesaw-priority-4{display:table-cell}}@media (min-width:60em){.tablesaw-columntoggle td.tablesaw-priority-5,.tablesaw-columntoggle th.tablesaw-priority-5{display:table-cell}}@media (min-width:70em){.tablesaw-columntoggle td.tablesaw-priority-6,.tablesaw-columntoggle th.tablesaw-priority-6{display:table-cell}}@media only all{.tablesaw-columntoggle td.tablesaw-cell-hidden,.tablesaw-columntoggle th.tablesaw-cell-hidden{display:none}.tablesaw-columntoggle td.tablesaw-cell-visible,.tablesaw-columntoggle th.tablesaw-cell-visible{display:table-cell}}.tablesaw-columntoggle-popup .btn-group>label{display:block;padding:.2em 0;white-space:nowrap}.tablesaw-columntoggle-popup .btn-group>label input{margin-right:.8em}.tablesaw-sortable,.tablesaw-sortable thead,.tablesaw-sortable thead tr,.tablesaw-sortable thead tr th{position:relative}.tablesaw-sortable thead tr th{padding-right:1.6em;vertical-align:top}.tablesaw-sortable th.tablesaw-sortable-head,.tablesaw-sortable tr:first-child th.tablesaw-sortable-head{padding:0}.tablesaw-sortable th.tablesaw-sortable-head button{padding:.9em 1.6em .7em .6em}.tablesaw-sortable .tablesaw-sortable-head button{min-width:100%;color:inherit;background:transparent;border:0;padding:0;text-align:left;font:inherit;text-transform:inherit;position:relative}.tablesaw-sortable .tablesaw-sortable-head.tablesaw-sortable-ascending button:after,.tablesaw-sortable .tablesaw-sortable-head.tablesaw-sortable-descending button:after{width:7px;height:10px;content:\" \";position:absolute;right:.5em}.tablesaw-sortable .tablesaw-sortable-head.tablesaw-sortable-ascending button:after{content:\"\\2191\"}.tablesaw-sortable .tablesaw-sortable-head.tablesaw-sortable-descending button:after{content:\"\\2193\"}.tablesaw-sortable .not-applicable:after{content:\"--\";display:block}.tablesaw-sortable .not-applicable span{display:none}.tablesaw-advance{float:right}.tablesaw-advance.minimap{margin-right:.4em}.tablesaw-advance-dots{float:left;margin:0;padding:0;list-style:none}.tablesaw-advance-dots li{display:table-cell;margin:0;padding:.4em .2em}.tablesaw-advance-dots li i{width:.25em;height:.25em;background:#555;border-radius:100%;display:inline-block}.tablesaw-advance-dots-hide{opacity:.25;filter:alpha(opacity=25);cursor:default;pointer-events:none}.tablesaw th{background:#fff}\n\n/*! X-editable - v1.5.0\n* In-place editing with Twitter Bootstrap, jQuery UI or pure jQuery\n* http://github.com/vitalets/x-editable\n* Copyright (c) 2013 Vitaliy Potapov; Licensed MIT */.editableform{margin-bottom:0}.editableform .control-group{margin-bottom:0;white-space:nowrap;line-height:20px}.editable-buttons{display:inline-block;vertical-align:top;margin-left:7px;zoom:1;*display:inline}.editable-buttons.editable-buttons-bottom{display:block;margin-top:7px;margin-left:0}.editable-input{vertical-align:top;display:inline-block;width:auto;white-space:normal;zoom:1;*display:inline}.editable-input input,.editable-input select{margin-top:0}.editable-buttons .editable-cancel{margin-left:7px}.editable-buttons button.ui-button-icon-only{height:24px;width:30px}.editableform-loading{background:url(\"/imgs/common/xeditable/loading.gif\") 50% no-repeat;height:25px;width:auto;min-width:25px}.editable-inline .editableform-loading{background-position:left 5px}.editable-error-block{max-width:300px;margin:5px 0 0;width:auto;white-space:normal}.editable-error-block.ui-state-error{padding:3px}.editable-error{color:red}.editableform .editable-date{padding:0;margin:0;float:left}.editable-inline .add-on .icon-th{margin-top:3px;margin-left:1px}.editable-checklist label input[type=checkbox],.editable-checklist label span{vertical-align:middle;margin:0}.editable-checklist label{white-space:nowrap}.editable-wysihtml5{width:566px;height:250px}.editable-clear{clear:both;font-size:.9em;text-decoration:none;text-align:right}.editable-clear-x{background:url(\"/imgs/common/xeditable/clear.png\") 50% no-repeat;display:block;width:13px;height:13px;position:absolute;opacity:.6;z-index:100;top:50%;right:6px;margin-top:-6px}.editable-clear-x:hover{opacity:1}.editable-pre-wrapped{white-space:pre-wrap}.editable-container.editable-popup{max-width:none!important}.editable-container.popover{width:auto}.editable-container.editable-inline{display:inline-block;vertical-align:middle;width:auto;zoom:1;*display:inline}.editable-container.ui-widget{font-size:inherit;z-index:9990}.editable-click,a.editable-click,a.editable-click:hover{text-decoration:none;border-bottom:1px dashed #08c}.editable-click.editable-disabled,a.editable-click.editable-disabled,a.editable-click.editable-disabled:hover{color:#585858;cursor:default;border-bottom:none}.editable-empty,.editable-empty:focus,.editable-empty:hover{font-style:italic;color:#d14;text-decoration:none}.editable-unsaved{font-weight:700}.editable-bg-transition{transition:background-color 1.4s ease-out}.form-horizontal .editable{padding-top:5px;display:inline-block}\n\n/*!\n * Datepicker for Bootstrap\n *\n * Copyright 2012 Stefan Petre\n * Improvements by Andrew Rowls\n * Licensed under the Apache License v2.0\n * http://www.apache.org/licenses/LICENSE-2.0\n *\n */.datepicker{padding:4px;border-radius:4px;direction:ltr}.datepicker-inline{width:220px}.datepicker.datepicker-rtl{direction:rtl}.datepicker.datepicker-rtl table tr td span{float:right}.datepicker-dropdown{top:0;left:0}.datepicker-dropdown:before{content:\"\";display:inline-block;border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid #ccc;border-bottom-color:rgba(0,0,0,.2);position:absolute;top:-7px;left:6px}.datepicker-dropdown:after{content:\"\";display:inline-block;border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #fff;position:absolute;top:-6px;left:7px}.datepicker>div{display:none}.datepicker.days div.datepicker-days,.datepicker.months div.datepicker-months,.datepicker.years div.datepicker-years{display:block}.datepicker table{margin:0}.datepicker td,.datepicker th{text-align:center;width:20px;height:20px;border-radius:4px;border:none}.table-striped .datepicker table tr td,.table-striped .datepicker table tr th{background-color:transparent}.datepicker table tr td.day:hover{background:#eee;cursor:pointer}.datepicker table tr td.new,.datepicker table tr td.old{color:#999}.datepicker table tr td.disabled,.datepicker table tr td.disabled:hover{background:none;color:#999;cursor:default}.datepicker table tr td.today,.datepicker table tr td.today.disabled,.datepicker table tr td.today.disabled:hover,.datepicker table tr td.today:hover{background-color:#fde19a;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);color:#000}.datepicker table tr td.today.active,.datepicker table tr td.today.disabled,.datepicker table tr td.today.disabled.active,.datepicker table tr td.today.disabled.disabled,.datepicker table tr td.today.disabled:active,.datepicker table tr td.today.disabled:hover,.datepicker table tr td.today.disabled:hover.active,.datepicker table tr td.today.disabled:hover.disabled,.datepicker table tr td.today.disabled:hover:active,.datepicker table tr td.today.disabled:hover:hover,.datepicker table tr td.today.disabled:hover[disabled],.datepicker table tr td.today.disabled[disabled],.datepicker table tr td.today:active,.datepicker table tr td.today:hover,.datepicker table tr td.today:hover.active,.datepicker table tr td.today:hover.disabled,.datepicker table tr td.today:hover:active,.datepicker table tr td.today:hover:hover,.datepicker table tr td.today:hover[disabled],.datepicker table tr td.today[disabled]{background-color:#fdf59a}.datepicker table tr td.today.active,.datepicker table tr td.today.disabled.active,.datepicker table tr td.today.disabled:active,.datepicker table tr td.today.disabled:hover.active,.datepicker table tr td.today.disabled:hover:active,.datepicker table tr td.today:active,.datepicker table tr td.today:hover.active,.datepicker table tr td.today:hover:active{background-color:#fbf069\\9}.datepicker table tr td.today:hover:hover{color:#000}.datepicker table tr td.today.active:hover{color:#fff}.datepicker table tr td.range,.datepicker table tr td.range.disabled,.datepicker table tr td.range.disabled:hover,.datepicker table tr td.range:hover{background:#eee;border-radius:0}.datepicker table tr td.range.today,.datepicker table tr td.range.today.disabled,.datepicker table tr td.range.today.disabled:hover,.datepicker table tr td.range.today:hover{background-color:#f3d17a;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);border-radius:0}.datepicker table tr td.range.today.active,.datepicker table tr td.range.today.disabled,.datepicker table tr td.range.today.disabled.active,.datepicker table tr td.range.today.disabled.disabled,.datepicker table tr td.range.today.disabled:active,.datepicker table tr td.range.today.disabled:hover,.datepicker table tr td.range.today.disabled:hover.active,.datepicker table tr td.range.today.disabled:hover.disabled,.datepicker table tr td.range.today.disabled:hover:active,.datepicker table tr td.range.today.disabled:hover:hover,.datepicker table tr td.range.today.disabled:hover[disabled],.datepicker table tr td.range.today.disabled[disabled],.datepicker table tr td.range.today:active,.datepicker table tr td.range.today:hover,.datepicker table tr td.range.today:hover.active,.datepicker table tr td.range.today:hover.disabled,.datepicker table tr td.range.today:hover:active,.datepicker table tr td.range.today:hover:hover,.datepicker table tr td.range.today:hover[disabled],.datepicker table tr td.range.today[disabled]{background-color:#f3e97a}.datepicker table tr td.range.today.active,.datepicker table tr td.range.today.disabled.active,.datepicker table tr td.range.today.disabled:active,.datepicker table tr td.range.today.disabled:hover.active,.datepicker table tr td.range.today.disabled:hover:active,.datepicker table tr td.range.today:active,.datepicker table tr td.range.today:hover.active,.datepicker table tr td.range.today:hover:active{background-color:#efe24b\\9}.datepicker table tr td.selected,.datepicker table tr td.selected.disabled,.datepicker table tr td.selected.disabled:hover,.datepicker table tr td.selected:hover{background-color:#9e9e9e;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);color:#fff}.datepicker table tr td.selected.active,.datepicker table tr td.selected.disabled,.datepicker table tr td.selected.disabled.active,.datepicker table tr td.selected.disabled.disabled,.datepicker table tr td.selected.disabled:active,.datepicker table tr td.selected.disabled:hover,.datepicker table tr td.selected.disabled:hover.active,.datepicker table tr td.selected.disabled:hover.disabled,.datepicker table tr td.selected.disabled:hover:active,.datepicker table tr td.selected.disabled:hover:hover,.datepicker table tr td.selected.disabled:hover[disabled],.datepicker table tr td.selected.disabled[disabled],.datepicker table tr td.selected:active,.datepicker table tr td.selected:hover,.datepicker table tr td.selected:hover.active,.datepicker table tr td.selected:hover.disabled,.datepicker table tr td.selected:hover:active,.datepicker table tr td.selected:hover:hover,.datepicker table tr td.selected:hover[disabled],.datepicker table tr td.selected[disabled]{background-color:gray}.datepicker table tr td.selected.active,.datepicker table tr td.selected.disabled.active,.datepicker table tr td.selected.disabled:active,.datepicker table tr td.selected.disabled:hover.active,.datepicker table tr td.selected.disabled:hover:active,.datepicker table tr td.selected:active,.datepicker table tr td.selected:hover.active,.datepicker table tr td.selected:hover:active{background-color:#666\\9}.datepicker table tr td.active,.datepicker table tr td.active.disabled,.datepicker table tr td.active.disabled:hover,.datepicker table tr td.active:hover{background-color:#006dcc;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);color:#fff}.datepicker table tr td.active.active,.datepicker table tr td.active.disabled,.datepicker table tr td.active.disabled.active,.datepicker table tr td.active.disabled.disabled,.datepicker table tr td.active.disabled:active,.datepicker table tr td.active.disabled:hover,.datepicker table tr td.active.disabled:hover.active,.datepicker table tr td.active.disabled:hover.disabled,.datepicker table tr td.active.disabled:hover:active,.datepicker table tr td.active.disabled:hover:hover,.datepicker table tr td.active.disabled:hover[disabled],.datepicker table tr td.active.disabled[disabled],.datepicker table tr td.active:active,.datepicker table tr td.active:hover,.datepicker table tr td.active:hover.active,.datepicker table tr td.active:hover.disabled,.datepicker table tr td.active:hover:active,.datepicker table tr td.active:hover:hover,.datepicker table tr td.active:hover[disabled],.datepicker table tr td.active[disabled]{background-color:#04c}.datepicker table tr td.active.active,.datepicker table tr td.active.disabled.active,.datepicker table tr td.active.disabled:active,.datepicker table tr td.active.disabled:hover.active,.datepicker table tr td.active.disabled:hover:active,.datepicker table tr td.active:active,.datepicker table tr td.active:hover.active,.datepicker table tr td.active:hover:active{background-color:#039\\9}.datepicker table tr td span{display:block;width:23%;height:54px;line-height:54px;float:left;margin:1%;cursor:pointer;border-radius:4px}.datepicker table tr td span:hover{background:#eee}.datepicker table tr td span.disabled,.datepicker table tr td span.disabled:hover{background:none;color:#999;cursor:default}.datepicker table tr td span.active,.datepicker table tr td span.active.disabled,.datepicker table tr td span.active.disabled:hover,.datepicker table tr td span.active:hover{background-color:#006dcc;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);color:#fff}.datepicker table tr td span.active.active,.datepicker table tr td span.active.disabled,.datepicker table tr td span.active.disabled.active,.datepicker table tr td span.active.disabled.disabled,.datepicker table tr td span.active.disabled:active,.datepicker table tr td span.active.disabled:hover,.datepicker table tr td span.active.disabled:hover.active,.datepicker table tr td span.active.disabled:hover.disabled,.datepicker table tr td span.active.disabled:hover:active,.datepicker table tr td span.active.disabled:hover:hover,.datepicker table tr td span.active.disabled:hover[disabled],.datepicker table tr td span.active.disabled[disabled],.datepicker table tr td span.active:active,.datepicker table tr td span.active:hover,.datepicker table tr td span.active:hover.active,.datepicker table tr td span.active:hover.disabled,.datepicker table tr td span.active:hover:active,.datepicker table tr td span.active:hover:hover,.datepicker table tr td span.active:hover[disabled],.datepicker table tr td span.active[disabled]{background-color:#04c}.datepicker table tr td span.active.active,.datepicker table tr td span.active.disabled.active,.datepicker table tr td span.active.disabled:active,.datepicker table tr td span.active.disabled:hover.active,.datepicker table tr td span.active.disabled:hover:active,.datepicker table tr td span.active:active,.datepicker table tr td span.active:hover.active,.datepicker table tr td span.active:hover:active{background-color:#039\\9}.datepicker table tr td span.new,.datepicker table tr td span.old{color:#999}.datepicker th.datepicker-switch{width:145px}.datepicker tfoot tr th,.datepicker thead tr:first-child th{cursor:pointer}.datepicker tfoot tr th:hover,.datepicker thead tr:first-child th:hover{background:#eee}.datepicker .cw{font-size:10px;width:12px;padding:0 2px 0 5px;vertical-align:middle}.datepicker thead tr:first-child th.cw{cursor:default;background-color:transparent}.input-append.date .add-on i,.input-prepend.date .add-on i{display:block;cursor:pointer;width:16px;height:16px}.input-daterange input{text-align:center}.input-daterange input:first-child{border-radius:3px 0 0 3px}.input-daterange input:last-child{border-radius:0 3px 3px 0}.input-daterange .add-on{display:inline-block;width:auto;min-width:16px;height:18px;padding:4px 5px;font-weight:400;line-height:18px;text-align:center;vertical-align:middle;background-color:#eee;border:1px solid #ccc;margin-left:-5px;margin-right:-5px}.editable-address{display:block;margin-bottom:5px}.editable-address span{width:70px;display:inline-block}.twitter-typeahead .tt-hint,.twitter-typeahead .tt-query{margin-bottom:0}.tt-dropdown-menu{min-width:160px;margin-top:2px;padding:5px 0;border-radius:6px;background-color:#fff;background-clip:padding-box;box-shadow:0 5px 10px rgba(0,0,0,.2)}.tt-suggestion{display:block;padding:3px 20px}.tt-suggestion.tt-is-under-cursor{color:#fff;background-color:#0081c2}.tt-suggestion.tt-is-under-cursor a{color:#fff}.tt-suggestion p{margin:0}.switchery{background-color:#fff;border:1px solid #dfdfdf;border-radius:20px;cursor:pointer;display:inline-block;height:30px;position:relative;vertical-align:middle;width:50px;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}.switchery>small{background:#fff;border-radius:100%;box-shadow:0 1px 3px rgba(0,0,0,.4);height:30px;position:absolute;top:0;width:30px}ul.messenger,ul.messenger>li{margin:0;padding:0}ul.messenger>li{list-style:none}ul.messenger.messenger-empty{display:none}ul.messenger .messenger-message{overflow:hidden;*zoom:1}ul.messenger .messenger-message.messenger-hidden{display:none}ul.messenger .messenger-message .messenger-actions a,ul.messenger .messenger-message .messenger-phrase{border:none;padding-right:5px}ul.messenger .messenger-message .messenger-actions{float:right}ul.messenger .messenger-message .messenger-actions a{cursor:pointer;padding-bottom:3px;text-decoration:none;padding-right:12.5px}ul.messenger .messenger-message ol,ul.messenger .messenger-message ul{margin:10px 18px 0}ul.messenger.messenger-fixed{position:fixed;z-index:1e+31}ul.messenger.messenger-fixed .messenger-message{min-width:0;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}ul.messenger.messenger-fixed .message .messenger-actions{float:left}ul.messenger.messenger-fixed.messenger-on-top{top:20px}ul.messenger.messenger-fixed.messenger-on-bottom{bottom:20px}ul.messenger.messenger-fixed.messenger-on-bottom,ul.messenger.messenger-fixed.messenger-on-top{left:50%;width:800px;margin-left:-400px}@media (max-width:960px){ul.messenger.messenger-fixed.messenger-on-bottom,ul.messenger.messenger-fixed.messenger-on-top{left:10%;width:80%;margin-left:0}}ul.messenger.messenger-fixed.messenger-on-bottom.messenger-on-right,ul.messenger.messenger-fixed.messenger-on-top.messenger-on-right{right:20px;left:auto}ul.messenger.messenger-fixed.messenger-on-bottom.messenger-on-left,ul.messenger.messenger-fixed.messenger-on-top.messenger-on-left{left:20px;margin-left:0}ul.messenger.messenger-fixed.messenger-on-left,ul.messenger.messenger-fixed.messenger-on-right{width:350px}ul.messenger.messenger-fixed.messenger-on-left .messenger-actions,ul.messenger.messenger-fixed.messenger-on-right .messenger-actions{float:left}ul.messenger .messenger-spinner{display:none}@-webkit-keyframes ui-spinner-rotate-right{0%{-webkit-transform:rotate(0deg)}25%{-webkit-transform:rotate(180deg)}50%{-webkit-transform:rotate(180deg)}75%{-webkit-transform:rotate(1turn)}to{-webkit-transform:rotate(1turn)}}@-webkit-keyframes ui-spinner-rotate-left{0%{-webkit-transform:rotate(0deg)}25%{-webkit-transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg)}75%{-webkit-transform:rotate(180deg)}to{-webkit-transform:rotate(1turn)}}@-moz-keyframes ui-spinner-rotate-right{0%{-moz-transform:rotate(0deg)}25%{-moz-transform:rotate(180deg)}50%{-moz-transform:rotate(180deg)}75%{-moz-transform:rotate(1turn)}to{-moz-transform:rotate(1turn)}}@-moz-keyframes ui-spinner-rotate-left{0%{-moz-transform:rotate(0deg)}25%{-moz-transform:rotate(0deg)}50%{-moz-transform:rotate(180deg)}75%{-moz-transform:rotate(180deg)}to{-moz-transform:rotate(1turn)}}@keyframes ui-spinner-rotate-right{0%{transform:rotate(0deg)}25%{transform:rotate(180deg)}50%{transform:rotate(180deg)}75%{transform:rotate(1turn)}to{transform:rotate(1turn)}}@keyframes ui-spinner-rotate-left{0%{transform:rotate(0deg)}25%{transform:rotate(0deg)}50%{transform:rotate(180deg)}75%{transform:rotate(180deg)}to{transform:rotate(1turn)}}.messenger-spinner{position:relative;border-radius:100%}ul.messenger.messenger-spinner-active .messenger-spinner .messenger-spinner{display:block}.messenger-spinner .messenger-spinner-side{width:50%;height:100%;overflow:hidden;position:absolute}.messenger-spinner .messenger-spinner-side .messenger-spinner-fill{border-radius:999px;position:absolute;width:100%;height:100%;-webkit-animation-iteration-count:infinite;-moz-animation-iteration-count:infinite;-ms-animation-iteration-count:infinite;-o-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:linear;-moz-animation-timing-function:linear;-ms-animation-timing-function:linear;-o-animation-timing-function:linear;animation-timing-function:linear}.messenger-spinner .messenger-spinner-side-left{left:0}.messenger-spinner .messenger-spinner-side-left .messenger-spinner-fill{left:100%;border-top-left-radius:0;border-bottom-left-radius:0;-webkit-animation-name:ui-spinner-rotate-left;-moz-animation-name:ui-spinner-rotate-left;-ms-animation-name:ui-spinner-rotate-left;-o-animation-name:ui-spinner-rotate-left;animation-name:ui-spinner-rotate-left;-webkit-transform-origin:0 50%;-moz-transform-origin:0 50%;-ms-transform-origin:0 50%;-o-transform-origin:0 50%;transform-origin:0 50%}.messenger-spinner .messenger-spinner-side-right{left:50%}.messenger-spinner .messenger-spinner-side-right .messenger-spinner-fill{left:-100%;border-top-right-radius:0;border-bottom-right-radius:0;-webkit-animation-name:ui-spinner-rotate-right;-moz-animation-name:ui-spinner-rotate-right;-ms-animation-name:ui-spinner-rotate-right;-o-animation-name:ui-spinner-rotate-right;animation-name:ui-spinner-rotate-right;-webkit-transform-origin:100% 50%;-moz-transform-origin:100% 50%;-ms-transform-origin:100% 50%;-o-transform-origin:100% 50%;transform-origin:100% 50%}#trumbowyg-icons{overflow:hidden;visibility:hidden;height:0;width:0}#trumbowyg-icons svg{height:0;width:0}.trumbowyg-box *,.trumbowyg-box :after,.trumbowyg-box :before{box-sizing:border-box}.trumbowyg-box svg{width:17px;height:100%;fill:#222}.trumbowyg-box,.trumbowyg-editor{display:block;position:relative;border:1px solid #ddd;width:100%;min-height:300px;margin:17px auto}.trumbowyg-box .trumbowyg-editor{margin:0 auto}.trumbowyg-box.trumbowyg-fullscreen{background:#fefefe;border:none!important}.trumbowyg-editor,.trumbowyg-textarea{position:relative;box-sizing:border-box;padding:20px;min-height:300px;width:100%;border-style:none;resize:none;outline:none;overflow:auto}.trumbowyg-box-blur .trumbowyg-editor *,.trumbowyg-box-blur .trumbowyg-editor:before{color:transparent!important;text-shadow:0 0 7px #333}@media screen and (min-width:0 \\0){.trumbowyg-box-blur .trumbowyg-editor *,.trumbowyg-box-blur .trumbowyg-editor:before{color:hsla(0,0%,78%,.6)!important}}@supports (-ms-accelerator:true){.trumbowyg-box-blur .trumbowyg-editor *,.trumbowyg-box-blur .trumbowyg-editor:before{color:hsla(0,0%,78%,.6)!important}}.trumbowyg-box-blur .trumbowyg-editor hr,.trumbowyg-box-blur .trumbowyg-editor img{opacity:.2}.trumbowyg-textarea{position:relative;display:block;overflow:auto;border:none;white-space:normal;font-size:14px;font-family:Inconsolata,Consolas,Courier,Courier New,sans-serif;line-height:18px}.trumbowyg-box.trumbowyg-editor-visible .trumbowyg-textarea{height:1px!important;width:25%;min-height:0!important;padding:0!important;background:none;opacity:0!important}.trumbowyg-box.trumbowyg-editor-hidden .trumbowyg-textarea{display:block}.trumbowyg-box.trumbowyg-editor-hidden .trumbowyg-editor{display:none}.trumbowyg-box.trumbowyg-disabled .trumbowyg-textarea{opacity:.8;background:none}.trumbowyg-editor[contenteditable=true]:empty:before{content:attr(placeholder);color:#999;pointer-events:none}.trumbowyg-button-pane{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-flow:row wrap;-ms-flex-flow:row wrap;flex-flow:row wrap;width:100%;min-height:36px;background:#ecf0f1;border-bottom:1px solid #d7e0e2;margin:0;padding:0 5px;list-style-type:none;line-height:10px;-webkit-backface-visibility:hidden;backface-visibility:hidden}.trumbowyg-button-pane:after{content:\" \";display:block;position:absolute;top:36px;left:0;right:0;width:100%;height:1px;background:#d7e0e2}.trumbowyg-button-pane .trumbowyg-button-group{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-flow:row wrap;-ms-flex-flow:row wrap;flex-flow:row wrap}.trumbowyg-button-pane .trumbowyg-button-group .trumbowyg-fullscreen-button svg{color:transparent}.trumbowyg-button-pane .trumbowyg-button-group:not(:empty)+.trumbowyg-button-group:before{content:\" \";display:block;width:1px;background:#d7e0e2;margin:0 5px;height:35px}.trumbowyg-button-pane button{display:block;position:relative;width:35px;height:35px;padding:1px 6px!important;margin-bottom:1px;overflow:hidden;border:none;cursor:pointer;background:none;-webkit-transition:background-color .15s,opacity .15s;transition:background-color .15s,opacity .15s}.trumbowyg-button-pane.trumbowyg-disable button:not(.trumbowyg-not-disable):not(.trumbowyg-active),.trumbowyg-disabled .trumbowyg-button-pane button:not(.trumbowyg-not-disable):not(.trumbowyg-viewHTML-button){opacity:.2;cursor:default}.trumbowyg-button-pane.trumbowyg-disable .trumbowyg-button-group:before,.trumbowyg-disabled .trumbowyg-button-pane .trumbowyg-button-group:before{background:#e3e9eb}.trumbowyg-button-pane button.trumbowyg-active,.trumbowyg-button-pane button:not(.trumbowyg-disable):focus,.trumbowyg-button-pane button:not(.trumbowyg-disable):hover{background-color:#fff;outline:none}.trumbowyg-button-pane .trumbowyg-open-dropdown:after{display:block;content:\" \";position:absolute;top:25px;right:3px;height:0;width:0;border:3px solid transparent;border-top-color:#555}.trumbowyg-button-pane .trumbowyg-right{margin-left:auto}.trumbowyg-button-pane .trumbowyg-right:before{display:none!important}.trumbowyg-dropdown{width:200px;border:1px solid #ecf0f1;padding:5px 0;border-top:none;background:#fff;margin-left:-1px;box-shadow:0 2px 3px rgba(0,0,0,.1)}.trumbowyg-dropdown button{display:block;width:100%;height:35px;line-height:35px;text-decoration:none;background:#fff;padding:0 10px;color:#333!important;border:none;cursor:pointer;text-align:left;font-size:15px;-webkit-transition:all .15s;transition:all .15s}.trumbowyg-dropdown button:focus,.trumbowyg-dropdown button:hover{background:#ecf0f1}.trumbowyg-dropdown button svg{float:left;margin-right:14px}.trumbowyg-modal{max-width:520px;width:100%;height:350px;z-index:11;overflow:hidden}.trumbowyg-modal,.trumbowyg-modal-box{position:absolute;top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);-webkit-backface-visibility:hidden;backface-visibility:hidden}.trumbowyg-modal-box{max-width:500px;width:calc(100% - 20px);padding-bottom:45px;z-index:1;background-color:#fff;text-align:center;font-size:14px;box-shadow:0 2px 3px rgba(0,0,0,.2)}.trumbowyg-modal-box .trumbowyg-modal-title{font-size:24px;font-weight:700;margin:0 0 20px;padding:15px 0 13px;display:block;border-bottom:1px solid #eee;color:#333;background:#fbfcfc}.trumbowyg-modal-box .trumbowyg-progress{width:100%;height:3px;position:absolute;top:58px}.trumbowyg-modal-box .trumbowyg-progress .trumbowyg-progress-bar{background:#2bc06a;height:100%;-webkit-transition:width .15s linear;transition:width .15s linear}.trumbowyg-modal-box label{display:block;position:relative;margin:15px 12px;height:27px;line-height:27px;overflow:hidden}.trumbowyg-modal-box label .trumbowyg-input-infos{display:block;text-align:left;height:25px;line-height:25px;-webkit-transition:all .15s;transition:all .15s}.trumbowyg-modal-box label .trumbowyg-input-infos span{display:block;color:#69878f;background-color:#fbfcfc;border:1px solid #dedede;padding:0 7px;width:150px}.trumbowyg-modal-box label .trumbowyg-input-infos span.trumbowyg-msg-error{color:#e74c3c}.trumbowyg-modal-box label.trumbowyg-input-error input,.trumbowyg-modal-box label.trumbowyg-input-error textarea{border:1px solid #e74c3c}.trumbowyg-modal-box label.trumbowyg-input-error .trumbowyg-input-infos{margin-top:-27px}.trumbowyg-modal-box label input{position:absolute;top:0;right:0;height:27px;line-height:27px;border:1px solid #dedede;background:#fff;font-size:14px;max-width:330px;width:70%;padding:0 7px;-webkit-transition:all .15s;transition:all .15s}.trumbowyg-modal-box label input:focus,.trumbowyg-modal-box label input:hover{outline:none;border:1px solid #95a5a6}.trumbowyg-modal-box label input:focus{background:#fbfcfc}.trumbowyg-modal-box .error{margin-top:25px;display:block;color:red}.trumbowyg-modal-box .trumbowyg-modal-button{position:absolute;bottom:10px;right:0;text-decoration:none;color:#fff;display:block;width:100px;height:35px;line-height:33px;margin:0 10px;background-color:#333;border:none;cursor:pointer;font-family:Trebuchet MS,Helvetica,Verdana,sans-serif;font-size:16px;-webkit-transition:all .15s;transition:all .15s}.trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-submit{right:110px;background:#2bc06a}.trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-submit:focus,.trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-submit:hover{background:#40d47e;outline:none}.trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-submit:active{background:#25a25a}.trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-reset{color:#555;background:#e6e6e6}.trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-reset:focus,.trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-reset:hover{background:#fbfbfb;outline:none}.trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-reset:active{background:#d5d5d5}.trumbowyg-overlay{position:absolute;background-color:hsla(0,0%,100%,.5);width:100%;left:0;display:none;z-index:10}body.trumbowyg-body-fullscreen{overflow:hidden}.trumbowyg-fullscreen{position:fixed;top:0;left:0;width:100%;height:100%;margin:0;padding:0;z-index:99999}.trumbowyg-fullscreen.trumbowyg-box,.trumbowyg-fullscreen .trumbowyg-editor{border:none}.trumbowyg-fullscreen .trumbowyg-editor,.trumbowyg-fullscreen .trumbowyg-textarea{height:calc(100% - 37px)!important;overflow:auto}.trumbowyg-fullscreen .trumbowyg-overlay{height:100%!important}.trumbowyg-fullscreen .trumbowyg-button-group .trumbowyg-fullscreen-button svg{color:#222;fill:transparent}.trumbowyg-editor embed,.trumbowyg-editor img,.trumbowyg-editor object,.trumbowyg-editor video{max-width:100%}.trumbowyg-editor img,.trumbowyg-editor video{height:auto}.trumbowyg-editor img{cursor:move}.trumbowyg-editor.trumbowyg-reset-css{background:#fefefe!important;font-family:Trebuchet MS,Helvetica,Verdana,sans-serif!important;font-size:14px!important;line-height:1.45em!important;white-space:normal!important;color:#333}.trumbowyg-editor.trumbowyg-reset-css a{color:#15c!important;text-decoration:underline!important}.trumbowyg-editor.trumbowyg-reset-css blockquote,.trumbowyg-editor.trumbowyg-reset-css div,.trumbowyg-editor.trumbowyg-reset-css ol,.trumbowyg-editor.trumbowyg-reset-css p,.trumbowyg-editor.trumbowyg-reset-css ul{box-shadow:none!important;background:none!important;margin:0!important;margin-bottom:15px!important;line-height:1.4em!important;font-family:Trebuchet MS,Helvetica,Verdana,sans-serif!important;font-size:14px!important;border:none}.trumbowyg-editor.trumbowyg-reset-css hr,.trumbowyg-editor.trumbowyg-reset-css iframe,.trumbowyg-editor.trumbowyg-reset-css object{margin-bottom:15px!important}.trumbowyg-editor.trumbowyg-reset-css blockquote{margin-left:32px!important;font-style:italic!important;color:#555}.trumbowyg-editor.trumbowyg-reset-css ol,.trumbowyg-editor.trumbowyg-reset-css ul{padding-left:20px!important}.trumbowyg-editor.trumbowyg-reset-css ol ol,.trumbowyg-editor.trumbowyg-reset-css ol ul,.trumbowyg-editor.trumbowyg-reset-css ul ol,.trumbowyg-editor.trumbowyg-reset-css ul ul{border:none;margin:2px!important;padding:0!important;padding-left:24px!important}.trumbowyg-editor.trumbowyg-reset-css hr{display:block;height:1px;border:none;border-top:1px solid #ccc}.trumbowyg-editor.trumbowyg-reset-css h1,.trumbowyg-editor.trumbowyg-reset-css h2,.trumbowyg-editor.trumbowyg-reset-css h3,.trumbowyg-editor.trumbowyg-reset-css h4{color:#111;background:none;margin:0!important;padding:0!important;font-weight:700}.trumbowyg-editor.trumbowyg-reset-css h1{font-size:32px!important;line-height:38px!important;margin-bottom:20px!important}.trumbowyg-editor.trumbowyg-reset-css h2{font-size:26px!important;line-height:34px!important;margin-bottom:15px!important}.trumbowyg-editor.trumbowyg-reset-css h3{font-size:22px!important;line-height:28px!important;margin-bottom:7px!important}.trumbowyg-editor.trumbowyg-reset-css h4{font-size:16px!important;line-height:22px!important;margin-bottom:7px!important}.trumbowyg-dark .trumbowyg-textarea{background:#111;color:#ddd}.trumbowyg-dark .trumbowyg-box{border:1px solid #343434}.trumbowyg-dark .trumbowyg-box.trumbowyg-fullscreen{background:#111}.trumbowyg-dark .trumbowyg-box.trumbowyg-box-blur .trumbowyg-editor *,.trumbowyg-dark .trumbowyg-box.trumbowyg-box-blur .trumbowyg-editor:before{text-shadow:0 0 7px #ccc}@media screen and (min-width:0 \\0){.trumbowyg-dark .trumbowyg-box.trumbowyg-box-blur .trumbowyg-editor *,.trumbowyg-dark .trumbowyg-box.trumbowyg-box-blur .trumbowyg-editor:before{color:hsla(0,0%,8%,.6)!important}}@supports (-ms-accelerator:true){.trumbowyg-dark .trumbowyg-box.trumbowyg-box-blur .trumbowyg-editor *,.trumbowyg-dark .trumbowyg-box.trumbowyg-box-blur .trumbowyg-editor:before{color:hsla(0,0%,8%,.6)!important}}.trumbowyg-dark .trumbowyg-box svg{fill:#ecf0f1;color:#ecf0f1}.trumbowyg-dark .trumbowyg-button-pane{background-color:#222;border-bottom-color:#343434}.trumbowyg-dark .trumbowyg-button-pane:after{background:#343434}.trumbowyg-dark .trumbowyg-button-pane .trumbowyg-button-group:not(:empty):before{background-color:#343434}.trumbowyg-dark .trumbowyg-button-pane .trumbowyg-button-group:not(:empty) .trumbowyg-fullscreen-button svg{color:transparent}.trumbowyg-dark .trumbowyg-button-pane.trumbowyg-disable .trumbowyg-button-group:before{background-color:#2a2a2a}.trumbowyg-dark .trumbowyg-button-pane button.trumbowyg-active,.trumbowyg-dark .trumbowyg-button-pane button:not(.trumbowyg-disable):focus,.trumbowyg-dark .trumbowyg-button-pane button:not(.trumbowyg-disable):hover{background-color:#333}.trumbowyg-dark .trumbowyg-button-pane .trumbowyg-open-dropdown:after{border-top-color:#fff}.trumbowyg-dark .trumbowyg-fullscreen .trumbowyg-button-group .trumbowyg-fullscreen-button svg{color:#ecf0f1;fill:transparent}.trumbowyg-dark .trumbowyg-dropdown{border-color:#222;background:#333;box-shadow:0 2px 3px rgba(0,0,0,.3)}.trumbowyg-dark .trumbowyg-dropdown button{background:#333;color:#fff!important}.trumbowyg-dark .trumbowyg-dropdown button:focus,.trumbowyg-dark .trumbowyg-dropdown button:hover{background:#222}.trumbowyg-dark .trumbowyg-modal-box{background-color:#222}.trumbowyg-dark .trumbowyg-modal-box .trumbowyg-modal-title{border-bottom:1px solid #555;color:#fff;background:#3c3c3c}.trumbowyg-dark .trumbowyg-modal-box label{display:block;position:relative;margin:15px 12px;height:27px;line-height:27px;overflow:hidden}.trumbowyg-dark .trumbowyg-modal-box label .trumbowyg-input-infos span{color:#eee;background-color:#2f2f2f;border-color:#222}.trumbowyg-dark .trumbowyg-modal-box label .trumbowyg-input-infos span.trumbowyg-msg-error{color:#e74c3c}.trumbowyg-dark .trumbowyg-modal-box label.trumbowyg-input-error input,.trumbowyg-dark .trumbowyg-modal-box label.trumbowyg-input-error textarea{border-color:#e74c3c}.trumbowyg-dark .trumbowyg-modal-box label input{border-color:#222;color:#eee;background:#333}.trumbowyg-dark .trumbowyg-modal-box label input:focus,.trumbowyg-dark .trumbowyg-modal-box label input:hover{border-color:#626262}.trumbowyg-dark .trumbowyg-modal-box label input:focus{background-color:#2f2f2f}.trumbowyg-dark .trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-submit{background:#1b7943}.trumbowyg-dark .trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-submit:focus,.trumbowyg-dark .trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-submit:hover{background:#25a25a}.trumbowyg-dark .trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-submit:active{background:#176437}.trumbowyg-dark .trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-reset{background:#333;color:#ccc}.trumbowyg-dark .trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-reset:focus,.trumbowyg-dark .trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-reset:hover{background:#444}.trumbowyg-dark .trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-reset:active{background:#111}.trumbowyg-dark .trumbowyg-overlay{background-color:hsla(0,0%,6%,.6)}.CodeMirror{font-family:monospace;height:300px;color:#000}.CodeMirror-lines{padding:4px 0}.CodeMirror pre{padding:0 4px}.CodeMirror-gutter-filler,.CodeMirror-scrollbar-filler{background-color:#fff}.CodeMirror-gutters{border-right:1px solid #ddd;background-color:#f7f7f7;white-space:nowrap}.CodeMirror-linenumber{padding:0 3px 0 5px;min-width:20px;text-align:right;color:#999;white-space:nowrap}.CodeMirror-guttermarker{color:#000}.CodeMirror-guttermarker-subtle{color:#999}.CodeMirror-cursor{border-left:1px solid #000;border-right:none;width:0}.CodeMirror div.CodeMirror-secondarycursor{border-left:1px solid silver}.cm-fat-cursor .CodeMirror-cursor{width:auto;border:0!important;background:#7e7}.cm-fat-cursor div.CodeMirror-cursors{z-index:1}.cm-animate-fat-cursor{width:auto;border:0;-webkit-animation:blink 1.06s steps(1) infinite;-moz-animation:blink 1.06s steps(1) infinite;animation:blink 1.06s steps(1) infinite;background-color:#7e7}@-moz-keyframes blink{50%{background-color:transparent}}@-webkit-keyframes blink{50%{background-color:transparent}}@keyframes blink{50%{background-color:transparent}}.cm-tab{display:inline-block;text-decoration:inherit}.CodeMirror-rulers{position:absolute;left:0;right:0;top:-50px;bottom:-20px;overflow:hidden}.CodeMirror-ruler{border-left:1px solid #ccc;top:0;bottom:0;position:absolute}.cm-s-default .cm-header{color:blue}.cm-s-default .cm-quote{color:#090}.cm-negative{color:#d44}.cm-positive{color:#292}.cm-header,.cm-strong{font-weight:700}.cm-em{font-style:italic}.cm-link{text-decoration:underline}.cm-strikethrough{text-decoration:line-through}.cm-s-default .cm-keyword{color:#708}.cm-s-default .cm-atom{color:#219}.cm-s-default .cm-number{color:#164}.cm-s-default .cm-def{color:#00f}.cm-s-default .cm-variable-2{color:#05a}.cm-s-default .cm-variable-3{color:#085}.cm-s-default .cm-comment{color:#a50}.cm-s-default .cm-string{color:#a11}.cm-s-default .cm-string-2{color:#f50}.cm-s-default .cm-meta,.cm-s-default .cm-qualifier{color:#555}.cm-s-default .cm-builtin{color:#30a}.cm-s-default .cm-bracket{color:#997}.cm-s-default .cm-tag{color:#170}.cm-s-default .cm-attribute{color:#00c}.cm-s-default .cm-hr{color:#999}.cm-s-default .cm-link{color:#00c}.cm-invalidchar,.cm-s-default .cm-error{color:red}.CodeMirror-composing{border-bottom:2px solid}div.CodeMirror span.CodeMirror-matchingbracket{color:#0f0}div.CodeMirror span.CodeMirror-nonmatchingbracket{color:#f22}.CodeMirror-matchingtag{background:rgba(255,150,0,.3)}.CodeMirror-activeline-background{background:#e8f2ff}.CodeMirror{position:relative;overflow:hidden;background:#fff}.CodeMirror-scroll{overflow:scroll!important;margin-bottom:-30px;margin-right:-30px;padding-bottom:30px;height:100%;outline:none;position:relative}.CodeMirror-sizer{position:relative;border-right:30px solid transparent}.CodeMirror-gutter-filler,.CodeMirror-hscrollbar,.CodeMirror-scrollbar-filler,.CodeMirror-vscrollbar{position:absolute;z-index:6;display:none}.CodeMirror-vscrollbar{right:0;top:0;overflow-x:hidden;overflow-y:scroll}.CodeMirror-hscrollbar{bottom:0;left:0;overflow-y:hidden;overflow-x:scroll}.CodeMirror-scrollbar-filler{right:0;bottom:0}.CodeMirror-gutter-filler{left:0;bottom:0}.CodeMirror-gutters{position:absolute;left:0;top:0;min-height:100%;z-index:3}.CodeMirror-gutter{white-space:normal;height:100%;display:inline-block;vertical-align:top;margin-bottom:-30px;*zoom:1;*display:inline}.CodeMirror-gutter-wrapper{position:absolute;z-index:4;background:none!important;border:none!important}.CodeMirror-gutter-background{position:absolute;top:0;bottom:0;z-index:4}.CodeMirror-gutter-elt{position:absolute;cursor:default;z-index:4}.CodeMirror-gutter-wrapper{-webkit-user-select:none;-moz-user-select:none;user-select:none}.CodeMirror-lines{cursor:text;min-height:1px}.CodeMirror pre{-moz-border-radius:0;-webkit-border-radius:0;border-radius:0;border-width:0;background:transparent;font-family:inherit;font-size:inherit;margin:0;white-space:pre;word-wrap:normal;line-height:inherit;color:inherit;z-index:2;position:relative;overflow:visible;-webkit-tap-highlight-color:transparent;-webkit-font-variant-ligatures:none;font-variant-ligatures:none}.CodeMirror-wrap pre{word-wrap:break-word;white-space:pre-wrap;word-break:normal}.CodeMirror-linebackground{position:absolute;left:0;right:0;top:0;bottom:0;z-index:0}.CodeMirror-linewidget{position:relative;z-index:2;overflow:auto}.CodeMirror-code{outline:none}.CodeMirror-gutter,.CodeMirror-gutters,.CodeMirror-linenumber,.CodeMirror-scroll,.CodeMirror-sizer{-moz-box-sizing:content-box;box-sizing:content-box}.CodeMirror-measure{position:absolute;width:100%;height:0;overflow:hidden;visibility:hidden}.CodeMirror-cursor{position:absolute;pointer-events:none}.CodeMirror-measure pre{position:static}div.CodeMirror-cursors{visibility:hidden;position:relative;z-index:3}.CodeMirror-focused div.CodeMirror-cursors,div.CodeMirror-dragcursors{visibility:visible}.CodeMirror-selected{background:#d9d9d9}.CodeMirror-focused .CodeMirror-selected{background:#d7d4f0}.CodeMirror-crosshair{cursor:crosshair}.CodeMirror-line::selection,.CodeMirror-line>span::selection,.CodeMirror-line>span>span::selection{background:#d7d4f0}.CodeMirror-line::-moz-selection,.CodeMirror-line>span::-moz-selection,.CodeMirror-line>span>span::-moz-selection{background:#d7d4f0}.cm-searching{background:#ffa;background:rgba(255,255,0,.4)}.CodeMirror span{*vertical-align:text-bottom}.cm-force-border{padding-right:.1px}@media print{.CodeMirror div.CodeMirror-cursors{visibility:hidden}}.cm-tab-wrap-hack:after{content:\"\"}span.CodeMirror-selectedtext{background:none}table.dataTable{width:100%;margin:0 auto;clear:both;border-collapse:separate;border-spacing:0;margin-bottom:25px}table.dataTable tfoot th,table.dataTable thead th{font-weight:700}table.dataTable thead td,table.dataTable thead th{padding:10px 18px;border-bottom:1px solid #111}table.dataTable thead td:active,table.dataTable thead th:active{outline:none}table.dataTable tfoot td,table.dataTable tfoot th{padding:10px 18px 6px;border-top:1px solid #111}table.dataTable thead .sorting,table.dataTable thead .sorting_asc,table.dataTable thead .sorting_desc{cursor:pointer;*cursor:hand}table.dataTable thead .sorting{background:url(\"/imgs/common/datatables/sort_both.png\") no-repeat 100%}table.dataTable thead .sorting_asc{background:url(\"/imgs/common/datatables/sort_asc.png\") no-repeat 100%}table.dataTable thead .sorting_desc{background:url(\"/imgs/common/datatables/sort_desc.png\") no-repeat 100%}table.dataTable thead .sorting_asc_disabled{background:url(\"/imgs/common/datatables/sort_asc_disabled.png\") no-repeat 100%}table.dataTable thead .sorting_desc_disabled{background:url(\"/imgs/common/datatables/sort_desc_disabled.png\") no-repeat 100%}table.dataTable tbody tr{background-color:#fff}table.dataTable tbody tr.selected{background-color:#b0bed9}table.dataTable tbody td,table.dataTable tbody th{padding:8px 10px}table.dataTable.display tbody td,table.dataTable.display tbody th,table.dataTable.row-border tbody td,table.dataTable.row-border tbody th{border-top:1px solid #ddd}table.dataTable.display tbody tr:first-child td,table.dataTable.display tbody tr:first-child th,table.dataTable.row-border tbody tr:first-child td,table.dataTable.row-border tbody tr:first-child th{border-top:none}table.dataTable.cell-border tbody td,table.dataTable.cell-border tbody th{border-top:1px solid #ddd;border-right:1px solid #ddd}table.dataTable.cell-border tbody tr td:first-child,table.dataTable.cell-border tbody tr th:first-child{border-left:1px solid #ddd}table.dataTable.cell-border tbody tr:first-child td,table.dataTable.cell-border tbody tr:first-child th{border-top:none}table.dataTable.display tbody tr.odd,table.dataTable.stripe tbody tr.odd{background-color:#f9f9f9}table.dataTable.display tbody tr.odd.selected,table.dataTable.stripe tbody tr.odd.selected{background-color:#abb9d3}table.dataTable.display tbody tr.even:hover,table.dataTable.display tbody tr.odd:hover,table.dataTable.display tbody tr:hover,table.dataTable.hover tbody tr.even:hover,table.dataTable.hover tbody tr.odd:hover,table.dataTable.hover tbody tr:hover{background-color:#f5f5f5}table.dataTable.display tbody tr.even:hover.selected,table.dataTable.display tbody tr.odd:hover.selected,table.dataTable.display tbody tr:hover.selected,table.dataTable.hover tbody tr.even:hover.selected,table.dataTable.hover tbody tr.odd:hover.selected,table.dataTable.hover tbody tr:hover.selected{background-color:#a9b7d1}table.dataTable.display tbody tr>.sorting_1,table.dataTable.display tbody tr>.sorting_2,table.dataTable.display tbody tr>.sorting_3,table.dataTable.order-column tbody tr>.sorting_1,table.dataTable.order-column tbody tr>.sorting_2,table.dataTable.order-column tbody tr>.sorting_3{background-color:#f9f9f9}table.dataTable.display tbody tr.selected>.sorting_1,table.dataTable.display tbody tr.selected>.sorting_2,table.dataTable.display tbody tr.selected>.sorting_3,table.dataTable.order-column tbody tr.selected>.sorting_1,table.dataTable.order-column tbody tr.selected>.sorting_2,table.dataTable.order-column tbody tr.selected>.sorting_3{background-color:#acbad4}table.dataTable.display tbody tr.odd>.sorting_1,table.dataTable.order-column.stripe tbody tr.odd>.sorting_1{background-color:#f1f1f1}table.dataTable.display tbody tr.odd>.sorting_2,table.dataTable.order-column.stripe tbody tr.odd>.sorting_2{background-color:#f3f3f3}table.dataTable.display tbody tr.odd>.sorting_3,table.dataTable.order-column.stripe tbody tr.odd>.sorting_3{background-color:#f5f5f5}table.dataTable.display tbody tr.odd.selected>.sorting_1,table.dataTable.order-column.stripe tbody tr.odd.selected>.sorting_1{background-color:#a6b3cd}table.dataTable.display tbody tr.odd.selected>.sorting_2,table.dataTable.order-column.stripe tbody tr.odd.selected>.sorting_2{background-color:#a7b5ce}table.dataTable.display tbody tr.odd.selected>.sorting_3,table.dataTable.order-column.stripe tbody tr.odd.selected>.sorting_3{background-color:#a9b6d0}table.dataTable.display tbody tr.even>.sorting_1,table.dataTable.order-column.stripe tbody tr.even>.sorting_1{background-color:#f9f9f9}table.dataTable.display tbody tr.even>.sorting_2,table.dataTable.order-column.stripe tbody tr.even>.sorting_2{background-color:#fbfbfb}table.dataTable.display tbody tr.even>.sorting_3,table.dataTable.order-column.stripe tbody tr.even>.sorting_3{background-color:#fdfdfd}table.dataTable.display tbody tr.even.selected>.sorting_1,table.dataTable.order-column.stripe tbody tr.even.selected>.sorting_1{background-color:#acbad4}table.dataTable.display tbody tr.even.selected>.sorting_2,table.dataTable.order-column.stripe tbody tr.even.selected>.sorting_2{background-color:#adbbd6}table.dataTable.display tbody tr.even.selected>.sorting_3,table.dataTable.order-column.stripe tbody tr.even.selected>.sorting_3{background-color:#afbdd8}table.dataTable.display tbody tr.even:hover>.sorting_1,table.dataTable.display tbody tr.odd:hover>.sorting_1,table.dataTable.display tbody tr:hover>.sorting_1,table.dataTable.order-column.hover tbody tr.even:hover>.sorting_1,table.dataTable.order-column.hover tbody tr.odd:hover>.sorting_1,table.dataTable.order-column.hover tbody tr:hover>.sorting_1{background-color:#eaeaea}table.dataTable.display tbody tr.even:hover>.sorting_2,table.dataTable.display tbody tr.odd:hover>.sorting_2,table.dataTable.display tbody tr:hover>.sorting_2,table.dataTable.order-column.hover tbody tr.even:hover>.sorting_2,table.dataTable.order-column.hover tbody tr.odd:hover>.sorting_2,table.dataTable.order-column.hover tbody tr:hover>.sorting_2{background-color:#ebebeb}table.dataTable.display tbody tr.even:hover>.sorting_3,table.dataTable.display tbody tr.odd:hover>.sorting_3,table.dataTable.display tbody tr:hover>.sorting_3,table.dataTable.order-column.hover tbody tr.even:hover>.sorting_3,table.dataTable.order-column.hover tbody tr.odd:hover>.sorting_3,table.dataTable.order-column.hover tbody tr:hover>.sorting_3{background-color:#eee}table.dataTable.display tbody tr.even:hover.selected>.sorting_1,table.dataTable.display tbody tr.odd:hover.selected>.sorting_1,table.dataTable.display tbody tr:hover.selected>.sorting_1,table.dataTable.order-column.hover tbody tr.even:hover.selected>.sorting_1,table.dataTable.order-column.hover tbody tr.odd:hover.selected>.sorting_1,table.dataTable.order-column.hover tbody tr:hover.selected>.sorting_1{background-color:#a1aec7}table.dataTable.display tbody tr.even:hover.selected>.sorting_2,table.dataTable.display tbody tr.odd:hover.selected>.sorting_2,table.dataTable.display tbody tr:hover.selected>.sorting_2,table.dataTable.order-column.hover tbody tr.even:hover.selected>.sorting_2,table.dataTable.order-column.hover tbody tr.odd:hover.selected>.sorting_2,table.dataTable.order-column.hover tbody tr:hover.selected>.sorting_2{background-color:#a2afc8}table.dataTable.display tbody tr.even:hover.selected>.sorting_3,table.dataTable.display tbody tr.odd:hover.selected>.sorting_3,table.dataTable.display tbody tr:hover.selected>.sorting_3,table.dataTable.order-column.hover tbody tr.even:hover.selected>.sorting_3,table.dataTable.order-column.hover tbody tr.odd:hover.selected>.sorting_3,table.dataTable.order-column.hover tbody tr:hover.selected>.sorting_3{background-color:#a4b2cb}table.dataTable.no-footer{border-bottom:1px solid #111}table.dataTable.nowrap td,table.dataTable.nowrap th{white-space:nowrap}table.dataTable.compact thead td,table.dataTable.compact thead th{padding:5px 9px}table.dataTable.compact tfoot td,table.dataTable.compact tfoot th{padding:5px 9px 3px}table.dataTable.compact tbody td,table.dataTable.compact tbody th{padding:4px 5px}table.dataTable td.dt-left,table.dataTable th.dt-left{text-align:left}table.dataTable td.dataTables_empty,table.dataTable td.dt-center,table.dataTable th.dt-center{text-align:center}table.dataTable td.dt-right,table.dataTable th.dt-right{text-align:right}table.dataTable td.dt-justify,table.dataTable th.dt-justify{text-align:justify}table.dataTable td.dt-nowrap,table.dataTable th.dt-nowrap{white-space:nowrap}table.dataTable tfoot td.dt-head-left,table.dataTable tfoot th.dt-head-left,table.dataTable thead td.dt-head-left,table.dataTable thead th.dt-head-left{text-align:left}table.dataTable tfoot td.dt-head-center,table.dataTable tfoot th.dt-head-center,table.dataTable thead td.dt-head-center,table.dataTable thead th.dt-head-center{text-align:center}table.dataTable tfoot td.dt-head-right,table.dataTable tfoot th.dt-head-right,table.dataTable thead td.dt-head-right,table.dataTable thead th.dt-head-right{text-align:right}table.dataTable tfoot td.dt-head-justify,table.dataTable tfoot th.dt-head-justify,table.dataTable thead td.dt-head-justify,table.dataTable thead th.dt-head-justify{text-align:justify}table.dataTable tfoot td.dt-head-nowrap,table.dataTable tfoot th.dt-head-nowrap,table.dataTable thead td.dt-head-nowrap,table.dataTable thead th.dt-head-nowrap{white-space:nowrap}table.dataTable tbody td.dt-body-left,table.dataTable tbody th.dt-body-left{text-align:left}table.dataTable tbody td.dt-body-center,table.dataTable tbody th.dt-body-center{text-align:center}table.dataTable tbody td.dt-body-right,table.dataTable tbody th.dt-body-right{text-align:right}table.dataTable tbody td.dt-body-justify,table.dataTable tbody th.dt-body-justify{text-align:justify}table.dataTable tbody td.dt-body-nowrap,table.dataTable tbody th.dt-body-nowrap{white-space:nowrap}table.dataTable,table.dataTable td,table.dataTable th{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}.dataTables_wrapper{position:relative;clear:both;*zoom:1;zoom:1}.dataTables_wrapper .dataTables_length{float:left}.dataTables_wrapper .dataTables_length select{width:auto;display:inline-block}.dataTables_wrapper .dataTables_filter{float:right;text-align:right}.dataTables_wrapper .dataTables_filter input{width:auto;margin-left:.5em;display:inline-block}.dataTables_wrapper .dataTables_info{clear:both;float:left;padding-top:5px}.dataTables_wrapper .dataTables_paginate{float:right;text-align:right;padding-top:.25em}.dataTables_wrapper .dataTables_paginate .paginate_button{box-sizing:border-box;display:inline-block;min-width:1.5em;padding:.25em 1em .5em;margin-left:2px;text-align:center;cursor:pointer;*cursor:hand;border-color:transparent}.dataTables_wrapper .dataTables_paginate .paginate_button.current,.dataTables_wrapper .dataTables_paginate .paginate_button.current:hover{background-color:#fff}.dataTables_wrapper .dataTables_paginate .paginate_button.disabled,.dataTables_wrapper .dataTables_paginate .paginate_button.disabled:active,.dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover{cursor:default;color:#666!important;border:1px solid transparent;background:transparent;box-shadow:none}.dataTables_wrapper .dataTables_processing{position:absolute;top:50%;left:50%;width:100%;height:40px;margin-left:-50%;margin-top:-25px;padding-top:20px;text-align:center;font-size:1.2em;background-color:#fff;background:linear-gradient(270deg,hsla(0,0%,100%,0) 0,hsla(0,0%,100%,.9) 25%,hsla(0,0%,100%,.9) 75%,hsla(0,0%,100%,0))}.dataTables_wrapper .dataTables_filter,.dataTables_wrapper .dataTables_info,.dataTables_wrapper .dataTables_length,.dataTables_wrapper .dataTables_paginate,.dataTables_wrapper .dataTables_processing{color:#333}.dataTables_wrapper .dataTables_scroll{clear:both}.dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody{*margin-top:-1px;-webkit-overflow-scrolling:touch}.dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody td>div.dataTables_sizing,.dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody th>div.dataTables_sizing{height:0;overflow:hidden;margin:0!important;padding:0!important}.dataTables_wrapper.no-footer .dataTables_scrollBody{border-bottom:1px solid #111}.dataTables_wrapper.no-footer div.dataTables_scrollBody table,.dataTables_wrapper.no-footer div.dataTables_scrollHead table{border-bottom:none}.dataTables_wrapper:after{visibility:hidden;display:block;content:\"\";clear:both;height:0}@media screen and (max-width:767px){.dataTables_wrapper .dataTables_info,.dataTables_wrapper .dataTables_paginate{float:none;text-align:center}.dataTables_wrapper .dataTables_paginate{margin-top:.5em}}@media screen and (max-width:640px){.dataTables_wrapper .dataTables_filter,.dataTables_wrapper .dataTables_length{float:none;text-align:center}.dataTables_wrapper .dataTables_filter{margin-top:.5em}}table.dataTable.dtr-inline.collapsed tbody td:first-child,table.dataTable.dtr-inline.collapsed tbody th:first-child{position:relative;padding-left:30px;cursor:pointer}table.dataTable.dtr-inline.collapsed tbody td:first-child:before,table.dataTable.dtr-inline.collapsed tbody th:first-child:before{top:8px;left:4px;height:16px;width:16px;display:block;position:absolute;color:#fff;border:2px solid #fff;border-radius:16px;text-align:center;line-height:14px;box-shadow:0 0 3px #444;box-sizing:content-box;content:\"+\";background-color:#31b131}table.dataTable.dtr-inline.collapsed tbody tr.parent td:first-child:before,table.dataTable.dtr-inline.collapsed tbody tr.parent th:first-child:before{content:\"-\";background-color:#d33333}table.dataTable.dtr-inline.collapsed tbody tr.child td:before{display:none}table.dataTable.dtr-column tbody td.control,table.dataTable.dtr-column tbody th.control{position:relative;cursor:pointer}table.dataTable.dtr-column tbody td.control:before,table.dataTable.dtr-column tbody th.control:before{top:50%;left:50%;height:16px;width:16px;margin-top:-10px;margin-left:-10px;display:block;position:absolute;color:#fff;border:2px solid #fff;border-radius:16px;text-align:center;line-height:14px;box-shadow:0 0 3px #444;box-sizing:content-box;content:\"+\";background-color:#31b131}table.dataTable.dtr-column tbody tr.parent td.control:before,table.dataTable.dtr-column tbody tr.parent th.control:before{content:\"-\";background-color:#d33333}table.dataTable tr.child{padding:.5em 1em}table.dataTable tr.child:hover{background:transparent!important}table.dataTable tr.child ul{display:inline-block;list-style-type:none;margin:0;padding:0}table.dataTable tr.child ul li{border-bottom:1px solid #efefef;padding:.5em 0}table.dataTable tr.child ul li:first-child{padding-top:0}table.dataTable tr.child ul li:last-child{border-bottom:none}table.dataTable tr.child span.dtr-title{display:inline-block;min-width:75px;font-weight:700}.irs,.irs-line{position:relative;display:block}.irs-line{overflow:hidden}.irs-line-left,.irs-line-mid,.irs-line-right{position:absolute;display:block;top:0}.irs-line-left{left:0;width:10%}.irs-line-mid{left:9%;width:82%}.irs-line-right{right:0;width:10%}.irs-diapason{left:0;width:100%}.irs-diapason,.irs-slider{position:absolute;display:block}.irs-slider{cursor:default;z-index:1}.irs-slider.single{left:10px}.irs-slider.single:before{position:absolute;display:block;content:\"\";top:-30%;left:-30%;width:160%;height:160%;background:transparent}.irs-slider.from{left:100px}.irs-slider.from:before{position:absolute;display:block;content:\"\";top:-30%;left:-30%;width:130%;height:160%;background:transparent}.irs-slider.to{left:300px}.irs-slider.to:before{position:absolute;display:block;content:\"\";top:-30%;left:0;width:130%;height:160%;background:transparent}.irs-slider.last{z-index:2}.irs-min{left:0}.irs-max,.irs-min{position:absolute;display:block;cursor:default}.irs-max{right:0}.irs-from,.irs-single,.irs-to{position:absolute;display:block;top:0;left:0;cursor:default;white-space:nowrap}.irs-grid{position:absolute;display:none;bottom:0;left:0;width:100%;height:20px}.irs-with-grid .irs-grid{display:block}.irs-grid-pol{position:absolute;top:0;left:0;width:1px;height:8px;background:#000}.irs-grid-pol.small{height:4px}.irs-grid-text{position:absolute;bottom:0;left:0;width:100px;white-space:nowrap;text-align:center;font-size:9px;line-height:9px;color:#000}.irs-disable-mask{position:absolute;display:block;top:0;left:0;width:100%;height:100%;cursor:default;background:transparent;z-index:2}.irs-disabled{opacity:.4}\n\n/*!\n * FullCalendar v2.1.0-beta2 Stylesheet\n * Docs & License: http://arshaw.com/fullcalendar/\n * (c) 2013 Adam Shaw\n */.fc{direction:ltr;text-align:left}.fc-rtl{text-align:right}body .fc{font-size:1em}.fc-unthemed .fc-popover,.fc-unthemed .fc-row,.fc-unthemed hr,.fc-unthemed tbody,.fc-unthemed td,.fc-unthemed th,.fc-unthemed thead{border-color:#ddd}.fc-unthemed .fc-popover{background-color:#fff}.fc-unthemed .fc-popover .fc-header,.fc-unthemed hr{background:#eee}.fc-unthemed .fc-popover .fc-header .fc-close{color:#666}.fc-unthemed .fc-today{background:#fcf8e3}.fc-highlight{background:#bce8f1;opacity:.3;filter:alpha(opacity=30)}.fc-icon{display:inline-block;font-size:2em;line-height:.5em;height:.5em;font-family:Courier New,Courier,monospace}.fc-icon-left-single-arrow:after{content:\"\\2039\";font-weight:700}.fc-icon-right-single-arrow:after{content:\"\\203A\";font-weight:700}.fc-icon-left-double-arrow:after{content:\"\\AB\"}.fc-icon-right-double-arrow:after{content:\"\\BB\"}.fc-icon-x:after{content:\"\\D7\"}.fc button{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;margin:0;height:2.1em;padding:0 .6em;font-size:1em;white-space:nowrap;cursor:pointer}.fc button::-moz-focus-inner{margin:0;padding:0}.fc-state-default{border:1px solid}.fc-state-default.fc-corner-left{border-top-left-radius:4px;border-bottom-left-radius:4px}.fc-state-default.fc-corner-right{border-top-right-radius:4px;border-bottom-right-radius:4px}.fc button .fc-icon{position:relative;top:.05em;margin:0 .1em}.fc-state-default{background-color:#f5f5f5;border-color:#e6e6e6 #e6e6e6 #bfbfbf;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);color:#333}.fc-state-active,.fc-state-disabled,.fc-state-down,.fc-state-hover{color:#333;background-color:#e6e6e6}.fc-state-hover{color:#333;text-decoration:none;background-position:0 -15px;-webkit-transition:background-position .1s linear;-moz-transition:background-position .1s linear;-o-transition:background-position .1s linear;transition:background-position .1s linear}.fc-state-active,.fc-state-down{background-color:#ccc}.fc-state-disabled{cursor:default;opacity:.65}.fc-button-group{display:inline-block}.fc .fc-button-group>*{float:left;margin:0 0 0 -1px}.fc .fc-button-group>:first-child{margin-left:0}.fc-popover{position:absolute}.fc-popover .fc-header{padding:2px 4px}.fc-popover .fc-header .fc-title{margin:0 2px}.fc-popover .fc-header .fc-close{cursor:pointer}.fc-ltr .fc-popover .fc-header .fc-title,.fc-rtl .fc-popover .fc-header .fc-close{float:left}.fc-ltr .fc-popover .fc-header .fc-close,.fc-rtl .fc-popover .fc-header .fc-title{float:right}.fc-unthemed .fc-popover{border-width:1px;border-style:solid}.fc-unthemed .fc-popover .fc-header .fc-close{font-size:25px;margin-top:4px}.fc-popover>.ui-widget-header+.ui-widget-content{border-top:0}.fc hr{height:0;margin:0;padding:0 0 2px;border-style:solid;border-width:1px 0}.fc-clear{clear:both}.fc-bg,.fc-helper-skeleton,.fc-highlight-skeleton{position:absolute;top:0;left:0;right:0}.fc-bg{bottom:0}.fc-bg table{height:100%}.fc table{width:100%;table-layout:fixed;border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{border-style:solid;border-width:1px;padding:0;vertical-align:top}.fc td.fc-today{border-style:double}.fc .fc-row{border-style:solid;border-width:0}.fc-row table{border-left:0 hidden transparent;border-right:0 hidden transparent;border-bottom:0 hidden transparent}.fc-row:first-child table{border-top:0 hidden transparent}.fc-row{position:relative}.fc-row .fc-bg{z-index:1}.fc-row .fc-highlight-skeleton{z-index:2;bottom:0}.fc-row .fc-highlight-skeleton table{height:100%}.fc-row .fc-highlight-skeleton td{border-color:transparent}.fc-row .fc-content-skeleton{position:relative;z-index:3;padding-bottom:1px}.fc-row .fc-helper-skeleton{z-index:4}.fc-row .fc-content-skeleton td,.fc-row .fc-helper-skeleton td{background:none;border-color:transparent;border-bottom:0}.fc-row .fc-content-skeleton tbody td,.fc-row .fc-helper-skeleton tbody td{border-top:0}.fc-scroller{overflow-y:scroll;overflow-x:hidden}.fc-scroller>*{position:relative;width:100%;overflow:hidden}.fc-event{position:relative;display:block;border:1px solid #3a87ad;background-color:#3a87ad;color:#fff;font-size:.85em;line-height:1.3;border-radius:3px;text-decoration:none}.fc-event:focus,.fc-event:hover{color:#fff;padding:0!important;border-color:#3a87ad}.ui-widget .fc-event{color:#fff;font-weight:400}.fc-event.fc-draggable,.fc-event[href]{cursor:pointer}.fc-day-grid-event{margin:1px 1px 0}.fc-ltr .fc-day-grid-event.fc-not-start,.fc-rtl .fc-day-grid-event.fc-not-end{margin-left:0;border-left-width:0;padding-left:1px;border-top-left-radius:0;border-bottom-left-radius:0}.fc-ltr .fc-day-grid-event.fc-not-end,.fc-rtl .fc-day-grid-event.fc-not-start{margin-right:0;border-right-width:0;padding-right:1px;border-top-right-radius:0;border-bottom-right-radius:0}.fc-day-grid-event>.fc-content{white-space:nowrap;overflow:hidden}.fc-day-grid-event .fc-time{font-weight:700}.fc-day-grid-event .fc-resizer{position:absolute;top:0;bottom:0;width:7px}.fc-ltr .fc-day-grid-event .fc-resizer{right:-3px;cursor:e-resize}.fc-rtl .fc-day-grid-event .fc-resizer{left:-3px;cursor:w-resize}.fc-toolbar{text-align:center;margin-bottom:1em}.fc-toolbar .fc-left{float:left}.fc-toolbar .fc-right{float:right}.fc-toolbar .fc-center{display:inline-block}.fc .fc-toolbar>*>*{float:left;margin-left:.75em}.fc .fc-toolbar>*>:first-child{margin-left:0}.fc-toolbar h2{margin:0}.fc-toolbar button{position:relative}.fc-toolbar .fc-state-hover,.fc-toolbar .ui-state-hover{z-index:2}.fc-toolbar .fc-state-down{z-index:3}.fc-toolbar .fc-state-active,.fc-toolbar .ui-state-active{z-index:4}.fc-toolbar button:focus{z-index:5}.fc-view-container,.fc-view>table{position:relative;z-index:1}.fc-basicDay-view .fc-content-skeleton,.fc-basicWeek-view .fc-content-skeleton{padding-bottom:1em}.fc-basic-view tbody .fc-row{min-height:4em}.fc-row.fc-rigid{overflow:hidden}.fc-row.fc-rigid .fc-content-skeleton{position:absolute;top:0;left:0;right:0}.fc-basic-view .fc-day-number,.fc-basic-view .fc-week-number{padding:0 2px}.fc-basic-view td.fc-day-number,.fc-basic-view td.fc-week-number span{padding-top:2px;padding-bottom:2px}.fc-basic-view .fc-week-number{text-align:center}.fc-basic-view .fc-week-number span{display:inline-block;min-width:1.25em}.fc-ltr .fc-basic-view .fc-day-number{text-align:right}.fc-rtl .fc-basic-view .fc-day-number{text-align:left}a.fc-more{margin:1px 2px;font-size:.85em;cursor:pointer;text-decoration:none}a.fc-more:hover{text-decoration:underline}.fc-limited{display:none}.fc-day-grid .fc-row{z-index:1}.fc-more-popover{z-index:2;width:220px}.fc-more-popover .fc-event-container{padding:10px}.fc-agenda-view .fc-day-grid .fc-row{min-height:3em}.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton{padding-bottom:1em}.fc .fc-axis{vertical-align:middle;padding:0 4px;white-space:nowrap}.fc-ltr .fc-axis{text-align:right}.fc-rtl .fc-axis{text-align:left}.ui-widget td.fc-axis{font-weight:400}.fc-time-grid{position:relative;min-height:100%}.fc-time-grid table{border:0 hidden transparent}.fc-time-grid>.fc-bg{z-index:1}.fc-time-grid .fc-slats,.fc-time-grid>hr{position:relative;z-index:2}.fc-time-grid .fc-highlight-skeleton{z-index:3}.fc-time-grid .fc-content-skeleton{position:absolute;z-index:4;top:0;left:0;right:0}.fc-time-grid>.fc-helper-skeleton{z-index:5}.fc-slats td{height:1.5em;border-bottom:0}.fc-slats .fc-minor td{border-top-style:dotted}.fc-slats .ui-widget-content{background:none}.fc-time-grid .fc-highlight-container{position:relative}.fc-time-grid .fc-highlight{position:absolute;left:0;right:0}.fc-time-grid .fc-event-container{position:relative}.fc-ltr .fc-time-grid .fc-event-container{margin:0 2.5% 0 2px}.fc-rtl .fc-time-grid .fc-event-container{margin:0 2px 0 2.5%}.fc-time-grid .fc-event{position:absolute;z-index:1}.fc-time-grid-event.fc-not-start{border-top-width:0;padding-top:1px;border-top-left-radius:0;border-top-right-radius:0}.fc-time-grid-event.fc-not-end{border-bottom-width:0;padding-bottom:1px;border-bottom-left-radius:0;border-bottom-right-radius:0}.fc-time-grid-event{overflow:hidden}.fc-time-grid-event>.fc-content{position:relative;z-index:2}.fc-time-grid-event .fc-time{font-size:.85em;white-space:nowrap}.fc-time-grid-event .fc-bg{z-index:1;background:#fff;opacity:.25;filter:alpha(opacity=25)}.fc-time-grid-event .fc-resizer{position:absolute;z-index:3;left:0;right:0;bottom:0;height:8px;overflow:hidden;line-height:8px;font-size:11px;font-family:monospace;text-align:center;cursor:s-resize}.fc-time-grid-event .fc-resizer:after{content:\"=\"}.tabcontrol,.wizard{display:block;width:100%;overflow:hidden;padding:25px}.tabcontrol a,.wizard a{outline:0}.tabcontrol ul,.wizard ul{list-style:none!important;padding:0;margin:0}.tabcontrol ul>li,.wizard ul>li{display:block;padding:0}.tabcontrol>.content>.title,.tabcontrol>.steps .current-info,.wizard>.content>.title,.wizard>.steps .current-info{position:absolute;left:-999em}.wizard>.steps{position:relative;display:block;width:100%}.wizard.vertical>.steps{display:inline;float:left;width:30%}.wizard>.steps .number{font-size:1.429em}.wizard>.steps>ul>li{width:25%}.wizard>.actions>ul>li,.wizard>.steps>ul>li{float:left;margin-bottom:25px}.wizard.vertical>.steps>ul>li{float:none;width:100%}.wizard>.steps a,.wizard>.steps a:active,.wizard>.steps a:hover{display:block;width:auto;margin-right:10px;padding:1em;text-decoration:none;border-radius:5px}.wizard>.actions a,.wizard>.steps a{border:none}.wizard>.steps .disabled a,.wizard>.steps .disabled a:active,.wizard>.steps .disabled a:hover{background:#eee;color:#aaa;cursor:default;border:none}.wizard>.steps .current a,.wizard>.steps .current a:active,.wizard>.steps .current a:hover{background:#2184be;color:#fff;cursor:default}.wizard>.steps .done a,.wizard>.steps .done a:active,.wizard>.steps .done a:hover{background:#9dc8e2;color:#fff}.wizard>.steps .error a,.wizard>.steps .error a:active,.wizard>.steps .error a:hover{background:#ff3111;color:#fff}.wizard>.content{display:block;overflow:hidden;position:relative;width:auto;border-top:1px solid #eee;border-bottom:1px solid #eee;background:#f8f8f8}.wizard.vertical>.content{display:inline;float:left;margin:0 2.5% .5em;width:65%}.wizard>.content>.body{position:relative;padding:25px}.wizard>.content>.body ul{list-style:disc!important}.wizard>.content>.body ul>li{display:list-item}.wizard>.content>.body>iframe{border:0 none;width:100%;height:100%}.wizard>.content>.body input.error,.wizard>.content>.body textarea.error{background:#fbe3e4;border-color:#fbc2c4;color:#8a1f11}.wizard>.content>.body label.error{color:#8a1f11}input[type=checkbox]~label.error,input[type=radio]~label.error{padding:0;display:block}.wizard>.actions{position:relative;display:block;text-align:right;width:100%;margin-top:25px}.wizard.vertical>.actions{display:inline;float:right;margin:0 2.5%;width:95%}.wizard>.actions>ul{display:inline-block;text-align:right}.wizard>.actions>ul>li{margin:0 .5em}.wizard.vertical>.actions>ul>li{margin:0 0 0 1em}.wizard>.actions a,.wizard>.actions a:active,.wizard>.actions a:hover{background:#2184be;color:#fff;display:block;padding:.5em 1em;text-decoration:none;border-radius:5px}.wizard>.actions .disabled a,.wizard>.actions .disabled a:active,.wizard>.actions .disabled a:hover{background:#eee;color:#aaa}.tabcontrol>.steps{position:relative;display:block;width:100%}.tabcontrol>.steps>ul{position:relative;margin:6px 0 0;top:1px;z-index:1}.tabcontrol>.steps>ul>li{float:left;margin:5px 2px 0 0;padding:1px;border-top-left-radius:5px;border-top-right-radius:5px}.tabcontrol>.steps>ul>li:hover{background:#edecec;border:1px solid #bbb;padding:0}.tabcontrol>.steps>ul>li.current{background:#fff;border:1px solid #bbb;border-bottom:0 none;padding:0 0 1px;margin-top:0}.tabcontrol>.steps>ul>li>a{color:#5f5f5f;display:inline-block;border:0 none;margin:0;padding:10px 30px;text-decoration:none}.tabcontrol>.steps>ul>li>a:hover{text-decoration:none}.tabcontrol>.steps>ul>li.current>a{padding:15px 30px 10px}.tabcontrol>.content{position:relative;display:inline-block;width:100%;height:35em;overflow:hidden;border-top:1px solid #bbb;padding-top:20px}.tabcontrol>.content>.body{float:left;position:absolute;width:95%;height:95%;padding:2.5%}.tabcontrol>.content>.body ul{list-style:disc!important}.tabcontrol>.content>.body ul>li{display:list-item}.wizard>.actions a[href=\"#finish\"],.wizard>.actions a[href=\"#finish\"]:active,.wizard>.actions a[href=\"#finish\"]:hover{background:#2eb398!important}.blueimp-gallery>.indicator{position:absolute;top:auto;right:15px;bottom:15px;left:15px;margin:0 40px;padding:0;list-style:none;text-align:center;line-height:10px;display:none}.blueimp-gallery>.indicator>li{display:inline-block;width:9px;height:9px;margin:6px 3px 0;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;border:1px solid transparent;background:#ccc;background:hsla(0,0%,100%,.25) 50% no-repeat;border-radius:5px;box-shadow:0 0 2px #000;opacity:.5;cursor:pointer}.blueimp-gallery>.indicator>.active,.blueimp-gallery>.indicator>li:hover{background-color:#fff;border-color:#fff;opacity:1}.blueimp-gallery-controls>.indicator{display:block;-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0);-o-transform:translateZ(0);transform:translateZ(0)}.blueimp-gallery-single>.indicator{display:none}.blueimp-gallery>.indicator{-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}*+html .blueimp-gallery>.indicator>li{display:inline}.blueimp-gallery>.slides>.slide>.video-content>img{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;width:auto;height:auto;max-width:100%;max-height:100%;-moz-backface-visibility:hidden}.blueimp-gallery>.slides>.slide>.video-content>video{position:absolute;top:0;left:0;width:100%;height:100%}.blueimp-gallery>.slides>.slide>.video-content>iframe{position:absolute;top:100%;left:0;width:100%;height:100%;border:none}.blueimp-gallery>.slides>.slide>.video-playing>iframe{top:0}.blueimp-gallery>.slides>.slide>.video-content>a{position:absolute;top:50%;right:0;left:0;margin:-64px auto 0;width:128px;height:128px;background:url(\"/imgs/common/blueimp-gallery/video-play.png\") 50% no-repeat;opacity:.8;cursor:pointer}.blueimp-gallery>.slides>.slide>.video-content>a:hover{opacity:1}.blueimp-gallery>.slides>.slide>.video-content>video,.blueimp-gallery>.slides>.slide>.video-playing>a,.blueimp-gallery>.slides>.slide>.video-playing>img{display:none}.blueimp-gallery>.slides>.slide>.video-playing>video{display:block}.blueimp-gallery>.slides>.slide>.video-loading>a{background:url(\"/imgs/common/blueimp-gallery/loading.gif\") 50% no-repeat;background-size:64px 64px}body:last-child .blueimp-gallery>.slides>.slide>.video-content:not(.video-loading)>a{background-image:url(\"/imgs/common/blueimp-gallery/video-play.svg\")}*+html .blueimp-gallery>.slides>.slide>.video-content{height:100%}*+html .blueimp-gallery>.slides>.slide>.video-content>a{left:50%;margin-left:-64px}.blueimp-gallery,.blueimp-gallery>.slides>.slide>.slide-content{position:absolute;top:0;right:0;bottom:0;left:0;-moz-backface-visibility:hidden}.blueimp-gallery>.slides>.slide>.slide-content{margin:auto;width:auto;height:auto;max-width:100%;max-height:100%;opacity:1}.blueimp-gallery{position:fixed;z-index:9999999999;overflow:hidden;background:#000;background:rgba(0,0,0,.9);opacity:0;display:none;direction:ltr;-ms-touch-action:none;touch-action:none}.blueimp-gallery-carousel{position:relative;z-index:auto;margin:1em auto;padding-bottom:56.25%;box-shadow:0 0 10px #000;-ms-touch-action:pan-y;touch-action:pan-y}.blueimp-gallery-display{display:block;opacity:1}.blueimp-gallery>.slides{position:relative;height:100%;overflow:hidden}.blueimp-gallery-carousel>.slides{position:absolute}.blueimp-gallery>.slides>.slide{position:relative;float:left;height:100%;text-align:center;-webkit-transition-timing-function:cubic-bezier(.645,.045,.355,1);-moz-transition-timing-function:cubic-bezier(.645,.045,.355,1);-ms-transition-timing-function:cubic-bezier(.645,.045,.355,1);-o-transition-timing-function:cubic-bezier(.645,.045,.355,1);transition-timing-function:cubic-bezier(.645,.045,.355,1)}.blueimp-gallery,.blueimp-gallery>.slides>.slide>.slide-content{-webkit-transition:opacity .5s linear;-moz-transition:opacity .5s linear;-ms-transition:opacity .5s linear;-o-transition:opacity .5s linear;transition:opacity .5s linear}.blueimp-gallery>.slides>.slide-loading{background:url(\"/imgs/common/blueimp-gallery/loading.gif\") 50% no-repeat;background-size:64px 64px}.blueimp-gallery>.slides>.slide-loading>.slide-content{opacity:0}.blueimp-gallery>.slides>.slide-error{background:url(\"/imgs/common/blueimp-gallery/error.png\") 50% no-repeat}.blueimp-gallery>.slides>.slide-error>.slide-content{display:none}.blueimp-gallery>.next,.blueimp-gallery>.prev{position:absolute;top:50%;left:15px;width:40px;height:40px;margin-top:-23px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:60px;font-weight:100;line-height:30px;color:#fff;text-decoration:none;text-shadow:0 0 2px #000;text-align:center;background:#222;background:rgba(0,0,0,.5);-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;border:3px solid #fff;-webkit-border-radius:23px;-moz-border-radius:23px;border-radius:23px;opacity:.5;cursor:pointer;display:none}.blueimp-gallery>.next{left:auto;right:15px}.blueimp-gallery>.close,.blueimp-gallery>.title{position:absolute;top:15px;left:15px;margin:0 40px 0 0;font-size:20px;line-height:30px;color:#fff;text-shadow:0 0 2px #000;opacity:.8;display:none}.blueimp-gallery>.close{padding:15px!important;right:15px;left:auto;margin:-15px;font-size:30px;text-decoration:none;cursor:pointer;border:none}.blueimp-gallery>.play-pause{border:none;position:absolute;right:15px;bottom:15px;width:15px;height:15px;background:url(\"/imgs/common/blueimp-gallery/play-pause.png\") 0 0 no-repeat;cursor:pointer;opacity:.5;display:none}.blueimp-gallery-playing>.play-pause{background-position:-15px 0}.blueimp-gallery>.close:hover,.blueimp-gallery>.next:hover,.blueimp-gallery>.play-pause:hover,.blueimp-gallery>.prev:hover,.blueimp-gallery>.title:hover{color:#fff;opacity:1;padding:0}.blueimp-gallery-controls>.close,.blueimp-gallery-controls>.next,.blueimp-gallery-controls>.play-pause,.blueimp-gallery-controls>.prev,.blueimp-gallery-controls>.title{display:block;-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0);-o-transform:translateZ(0);transform:translateZ(0)}.blueimp-gallery-left>.prev,.blueimp-gallery-right>.next,.blueimp-gallery-single>.next,.blueimp-gallery-single>.play-pause,.blueimp-gallery-single>.prev{display:none}.blueimp-gallery>.close,.blueimp-gallery>.next,.blueimp-gallery>.play-pause,.blueimp-gallery>.prev,.blueimp-gallery>.slides>.slide>.slide-content{-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}body:last-child .blueimp-gallery>.slides>.slide-error{background-image:url(\"/imgs/common/blueimp-gallery/error.svg\")}body:last-child .blueimp-gallery>.play-pause{width:20px;height:20px;background-size:40px 20px;background-image:url(\"/imgs/common/blueimp-gallery/play-pause.svg\")}body:last-child .blueimp-gallery-playing>.play-pause{background-position:-20px 0}*+html .blueimp-gallery>.slides>.slide{min-height:300px}\n\n/*! =======================================================\n                      VERSION  6.0.4\n========================================================= */\n\n/*! =========================================================\n * bootstrap-slider.js\n *\n * Maintainers:\n *    Kyle Kemp\n *      - Twitter: @seiyria\n *      - Github:  seiyria\n *    Rohit Kalkur\n *      - Twitter: @Rovolutionary\n *      - Github:  rovolution\n *\n * =========================================================\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n * http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n * ========================================================= */*+html .blueimp-gallery>.slides>.slide>.slide-content,.slider{position:relative}.slider{display:inline-block;vertical-align:middle}.slider.slider-horizontal{width:210px;height:20px}.slider.slider-horizontal .slider-track{height:10px;width:100%;margin-top:-5px;top:50%;left:0}.slider.slider-horizontal .slider-selection,.slider.slider-horizontal .slider-track-high,.slider.slider-horizontal .slider-track-low{height:100%;top:0;bottom:0}.slider.slider-horizontal .slider-handle,.slider.slider-horizontal .slider-tick{margin-left:-10px;margin-top:0}.slider.slider-horizontal .slider-handle.triangle,.slider.slider-horizontal .slider-tick.triangle{border-width:0 10px 10px;width:0;height:0;border-bottom-color:#0480be;margin-top:5px}.slider.slider-horizontal .slider-tick-label-container{white-space:nowrap;margin-top:20px}.slider.slider-horizontal .slider-tick-label-container .slider-tick-label{padding-top:4px;display:inline-block;text-align:center}.slider.slider-vertical{height:210px;width:20px}.slider.slider-vertical .slider-track{width:10px;height:100%;margin-left:-5px;left:50%;top:0}.slider.slider-vertical .slider-selection{width:100%;left:0;top:0;bottom:0}.slider.slider-vertical .slider-track-high,.slider.slider-vertical .slider-track-low{width:100%;left:0;right:0}.slider.slider-vertical .slider-handle,.slider.slider-vertical .slider-tick{margin-left:0;margin-top:-10px}.slider.slider-vertical .slider-handle.triangle,.slider.slider-vertical .slider-tick.triangle{border-width:10px 0 10px 10px;width:1px;height:1px;border-left-color:#0480be;margin-left:0}.slider.slider-vertical .slider-tick-label-container{white-space:nowrap}.slider.slider-vertical .slider-tick-label-container .slider-tick-label{padding-left:4px}.slider.slider-disabled .slider-handle{background-image:linear-gradient(180deg,#dfdfdf 0,#bebebe);background-repeat:repeat-x}.slider.slider-disabled .slider-track{background-image:linear-gradient(180deg,#e5e5e5 0,#e9e9e9);background-repeat:repeat-x;cursor:not-allowed}.slider input{display:none}.slider .tooltip.top{margin-top:-36px}.slider .tooltip-inner{white-space:nowrap}.slider .hide{display:none}.slider-track{cursor:pointer;background-image:-webkit-linear-gradient(top,#f5f5f5,#f9f9f9);background-image:-o-linear-gradient(top,#f5f5f5 0,#f9f9f9 100%);background-image:linear-gradient(180deg,#f5f5f5 0,#f9f9f9);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#fff5f5f5\",endColorstr=\"#fff9f9f9\",GradientType=0);-webkit-box-shadow:inset 0 1px 2px rgba(0,0,0,.1);box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.slider-selection,.slider-track{position:absolute;background-repeat:repeat-x;border-radius:4px}.slider-selection{background-image:-webkit-linear-gradient(top,#f9f9f9,#f5f5f5);background-image:-o-linear-gradient(top,#f9f9f9 0,#f5f5f5 100%);background-image:linear-gradient(180deg,#f9f9f9 0,#f5f5f5);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#fff9f9f9\",endColorstr=\"#fff5f5f5\",GradientType=0);-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.slider-selection.tick-slider-selection{background-image:-webkit-linear-gradient(top,#89cdef,#81bfde);background-image:-o-linear-gradient(top,#89cdef 0,#81bfde 100%);background-image:linear-gradient(180deg,#89cdef 0,#81bfde);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ff89cdef\",endColorstr=\"#ff81bfde\",GradientType=0)}.slider-track-high,.slider-track-low{position:absolute;background:transparent;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;border-radius:4px}.slider-handle{position:absolute;width:20px;height:20px;background-color:#337ab7;background-image:-webkit-linear-gradient(top,#149bdf,#0480be);background-image:-o-linear-gradient(top,#149bdf 0,#0480be 100%);background-image:linear-gradient(180deg,#149bdf 0,#0480be);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ff149bdf\",endColorstr=\"#ff0480be\",GradientType=0);filter:none;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.2),0 1px 2px rgba(0,0,0,.05);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.2),0 1px 2px rgba(0,0,0,.05);border:0 solid transparent}.slider-handle.round{border-radius:50%}.slider-handle.custom,.slider-handle.triangle{background:transparent none}.slider-handle.custom:before{line-height:20px;font-size:20px;content:\"\\2605\";color:#726204}.slider-tick{position:absolute;width:20px;height:20px;background-image:-webkit-linear-gradient(top,#f9f9f9,#f5f5f5);background-image:-o-linear-gradient(top,#f9f9f9 0,#f5f5f5 100%);background-image:linear-gradient(180deg,#f9f9f9 0,#f5f5f5);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#fff9f9f9\",endColorstr=\"#fff5f5f5\",GradientType=0);-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;filter:none;opacity:.8;border:0 solid transparent}.slider-tick.round{border-radius:50%}.slider-tick.custom,.slider-tick.triangle{background:transparent none}.slider-tick.custom:before{line-height:20px;font-size:20px;content:\"\\2605\";color:#726204}.slider-tick.in-selection{background-image:-webkit-linear-gradient(top,#89cdef,#81bfde);background-image:-o-linear-gradient(top,#89cdef 0,#81bfde 100%);background-image:linear-gradient(180deg,#89cdef 0,#81bfde);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ff89cdef\",endColorstr=\"#ff81bfde\",GradientType=0);opacity:1}@media print{\n  /*!\n   * FullCalendar v2.1.0-beta2 Print Stylesheet\n   * Docs & License: http://arshaw.com/fullcalendar/\n   * (c) 2013 Adam Shaw\n   */.fc{max-width:100%!important}.fc-event{background:#fff!important;color:#000!important;page-break-inside:avoid}.fc-event .fc-resizer{display:none}.fc-row,hr,tbody,td,th,thead{border-color:#ccc!important;background:#fff!important}.fc-bg,.fc-helper-skeleton,.fc-highlight-skeleton{display:none}.fc tbody .fc-row{height:auto!important;min-height:0!important}.fc tbody .fc-row .fc-content-skeleton{position:static;padding-bottom:0!important}.fc tbody .fc-row .fc-content-skeleton table tr:last-child td{padding-bottom:1px}.fc tbody .fc-row .fc-content-skeleton table{height:2em}.fc tbody .fc-row .fc-content-skeleton table:last-child{height:4em}.fc-more,.fc-more-cell{display:none!important}.fc tr.fc-limited{display:table-row!important}.fc td.fc-limited{display:table-cell!important}.fc-time-grid{min-height:0!important}.fc-agenda-view .fc-axis{display:none}.fc-slats,.fc-time-grid hr{display:none!important}.fc-time-grid .fc-content-skeleton{position:static}.fc-time-grid .fc-content-skeleton table{height:4em}.fc-time-grid .fc-event-container{margin:0!important}.fc-time-grid .fc-event{position:static!important;margin:3px 2px!important}.fc-time-grid .fc-event.fc-not-end{border-bottom-width:1px!important}.fc-time-grid .fc-event.fc-not-end:after{content:\"...\"}.fc-time-grid .fc-event.fc-not-start{border-top-width:1px!important}.fc-time-grid .fc-event.fc-not-start:before{content:\"...\"}.fc-time-grid .fc-event .fc-time{white-space:normal!important}.fc-time-grid .fc-event .fc-time span{display:none}.fc-time-grid .fc-event .fc-time:after{content:attr(data-full)}.fc-day-grid-container,.fc-scroller,.fc-time-grid-container{overflow:visible!important;height:auto!important}.fc-row{border:0!important;margin:0!important}.fc-button-group,.fc button{display:none}}table.dataTable.dtr-inline.collapsed>tbody>tr>td.child,table.dataTable.dtr-inline.collapsed>tbody>tr>td.dataTables_empty,table.dataTable.dtr-inline.collapsed>tbody>tr>th.child{cursor:default!important}table.dataTable.dtr-inline.collapsed>tbody>tr>td.child:before,table.dataTable.dtr-inline.collapsed>tbody>tr>td.dataTables_empty:before,table.dataTable.dtr-inline.collapsed>tbody>tr>th.child:before{display:none!important}table.dataTable.dtr-inline.collapsed>tbody>tr>td:first-child,table.dataTable.dtr-inline.collapsed>tbody>tr>th:first-child{position:relative;padding-left:30px;cursor:pointer}table.dataTable.dtr-inline.collapsed>tbody>tr>td:first-child:before,table.dataTable.dtr-inline.collapsed>tbody>tr>th:first-child:before{top:8px;left:4px;height:16px;width:16px;display:block;position:absolute;color:#fff;border:2px solid #fff;border-radius:16px;box-shadow:0 0 3px #444;box-sizing:content-box;text-align:left;font-family:Courier New,Courier,monospace;text-indent:4px;line-height:16px;content:\"+\";background-color:#31b131}table.dataTable.dtr-inline.collapsed>tbody>tr.parent>td:first-child:before,table.dataTable.dtr-inline.collapsed>tbody>tr.parent>th:first-child:before{content:\"-\";background-color:#d33333}table.dataTable.dtr-inline.collapsed>tbody>tr.child td:before{display:none}table.dataTable.dtr-inline.collapsed.compact>tbody>tr>td:first-child,table.dataTable.dtr-inline.collapsed.compact>tbody>tr>th:first-child{padding-left:27px}table.dataTable.dtr-inline.collapsed.compact>tbody>tr>td:first-child:before,table.dataTable.dtr-inline.collapsed.compact>tbody>tr>th:first-child:before{top:5px;left:4px;height:14px;width:14px;border-radius:14px;line-height:14px;text-indent:3px}table.dataTable.dtr-column>tbody>tr>td.control,table.dataTable.dtr-column>tbody>tr>th.control{position:relative;cursor:pointer}table.dataTable.dtr-column>tbody>tr>td.control:before,table.dataTable.dtr-column>tbody>tr>th.control:before{top:50%;left:50%;height:16px;width:16px;margin-top:-10px;margin-left:-10px;display:block;position:absolute;color:#fff;border:2px solid #fff;border-radius:16px;box-shadow:0 0 3px #444;box-sizing:content-box;text-align:left;font-family:Courier New,Courier,monospace;text-indent:4px;line-height:16px;content:\"+\";background-color:#31b131}table.dataTable.dtr-column>tbody>tr.parent td.control:before,table.dataTable.dtr-column>tbody>tr.parent th.control:before{content:\"-\";background-color:#d33333}table.dataTable>tbody>tr.child{padding:.5em 1em}table.dataTable>tbody>tr.child:hover{background:transparent!important}table.dataTable>tbody>tr.child ul{display:inline-block;list-style-type:none;margin:0;padding:0}table.dataTable>tbody>tr.child ul li{border-bottom:1px solid #efefef;padding:.5em 0}table.dataTable>tbody>tr.child ul li:first-child{padding-top:0}table.dataTable>tbody>tr.child ul li:last-child{border-bottom:none}table.dataTable>tbody>tr.child span.dtr-title{display:inline-block;min-width:75px;font-weight:700}div.dtr-modal{position:fixed;box-sizing:border-box;top:0;left:0;height:100%;width:100%;z-index:100;padding:10em 1em}div.dtr-modal div.dtr-modal-display{position:absolute;top:0;left:0;bottom:0;right:0;width:50%;height:50%;margin:auto;z-index:102;overflow:auto;background-color:#f5f5f7;border:1px solid #000;border-radius:.5em;box-shadow:0 12px 30px rgba(0,0,0,.6)}div.dtr-modal div.dtr-modal-content{position:relative;padding:1em}div.dtr-modal div.dtr-modal-close{position:absolute;top:6px;right:6px;width:22px;height:22px;border:1px solid #eaeaea;background-color:#f9f9f9;text-align:center;border-radius:3px;cursor:pointer;z-index:12}div.dtr-modal div.dtr-modal-close:hover{background-color:#eaeaea}div.dtr-modal div.dtr-modal-background{position:fixed;top:0;left:0;right:0;bottom:0;z-index:101;background:rgba(0,0,0,.6)}@media screen and (max-width:767px){div.dtr-modal div.dtr-modal-display{width:95%}}\n\n/*!\n * Datetimepicker for Bootstrap 3\n * ! version : 4.7.14\n * https://github.com/Eonasdan/bootstrap-datetimepicker/\n */.bootstrap-datetimepicker-widget{list-style:none}.bootstrap-datetimepicker-widget.dropdown-menu{margin:2px 0;padding:4px;width:19em}@media (min-width:990px){.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs{width:38em}}@media (min-width:1152px){.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs{width:38em}}@media (min-width:1366px){.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs{width:38em}}.bootstrap-datetimepicker-widget.dropdown-menu:after,.bootstrap-datetimepicker-widget.dropdown-menu:before{content:\"\";display:inline-block;position:absolute}.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before{border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid #ccc;border-bottom-color:rgba(0,0,0,.2);top:-7px;left:7px}.bootstrap-datetimepicker-widget.dropdown-menu.bottom:after{border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #fff;top:-6px;left:8px}.bootstrap-datetimepicker-widget.dropdown-menu.top:before{border-left:7px solid transparent;border-right:7px solid transparent;border-top:7px solid #ccc;border-top-color:rgba(0,0,0,.2);bottom:-7px;left:6px}.bootstrap-datetimepicker-widget.dropdown-menu.top:after{border-left:6px solid transparent;border-right:6px solid transparent;border-top:6px solid #fff;bottom:-6px;left:7px}.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before{left:auto;right:6px}.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after{left:auto;right:7px}.bootstrap-datetimepicker-widget .list-unstyled{margin:0}.bootstrap-datetimepicker-widget a[data-action]{padding:6px 0}.bootstrap-datetimepicker-widget a[data-action]:active{box-shadow:none}.bootstrap-datetimepicker-widget .timepicker-hour,.bootstrap-datetimepicker-widget .timepicker-minute,.bootstrap-datetimepicker-widget .timepicker-second{width:54px;font-weight:700;font-size:1.2em;margin:0}.bootstrap-datetimepicker-widget button[data-action]{padding:6px;height:36px}.bootstrap-datetimepicker-widget .btn[data-action=incrementHours]:after{content:\"Increment Hours\"}.bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]:after{content:\"Increment Minutes\"}.bootstrap-datetimepicker-widget .btn[data-action=decrementHours]:after{content:\"Decrement Hours\"}.bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]:after{content:\"Decrement Minutes\"}.bootstrap-datetimepicker-widget .btn[data-action=showHours]:after{content:\"Show Hours\"}.bootstrap-datetimepicker-widget .btn[data-action=showMinutes]:after{content:\"Show Minutes\"}.bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]:after{content:\"Toggle AM/PM\"}.bootstrap-datetimepicker-widget .btn[data-action=clear]:after{content:\"Clear the picker\"}.bootstrap-datetimepicker-widget .btn[data-action=today]:after{content:\"Set the date to today\"}.bootstrap-datetimepicker-widget .picker-switch{text-align:center}.bootstrap-datetimepicker-widget .picker-switch:after{content:\"Toggle Date and Time Screens\"}.bootstrap-datetimepicker-widget .picker-switch td{padding:0;margin:0;height:auto;width:auto;line-height:inherit}.bootstrap-datetimepicker-widget .picker-switch td span{line-height:2.5;height:2.5em;width:100%}.bootstrap-datetimepicker-widget table{width:100%;margin:0}.bootstrap-datetimepicker-widget table td,.bootstrap-datetimepicker-widget table th{text-align:center;border-radius:4px}.bootstrap-datetimepicker-widget table th{height:20px;line-height:20px;width:20px}.bootstrap-datetimepicker-widget table th.picker-switch{width:145px}.bootstrap-datetimepicker-widget table th.disabled,.bootstrap-datetimepicker-widget table th.disabled:hover{background:none;color:#777;cursor:not-allowed}.bootstrap-datetimepicker-widget table th.prev:after{content:\"Previous Month\"}.bootstrap-datetimepicker-widget table th.next:after{content:\"Next Month\"}.bootstrap-datetimepicker-widget table thead tr:first-child th{cursor:pointer}.bootstrap-datetimepicker-widget table thead tr:first-child th:hover{background:#eee}.bootstrap-datetimepicker-widget table td{height:54px;line-height:54px;width:54px}.bootstrap-datetimepicker-widget table td.cw{font-size:.8em;height:20px;line-height:20px;color:#777}.bootstrap-datetimepicker-widget table td.day{height:20px;line-height:20px;width:20px}.bootstrap-datetimepicker-widget table td.day:hover,.bootstrap-datetimepicker-widget table td.hour:hover,.bootstrap-datetimepicker-widget table td.minute:hover,.bootstrap-datetimepicker-widget table td.second:hover{background:#eee;cursor:pointer}.bootstrap-datetimepicker-widget table td.new,.bootstrap-datetimepicker-widget table td.old{color:#777}.bootstrap-datetimepicker-widget table td.today{position:relative}.bootstrap-datetimepicker-widget table td.today:before{content:\"\";display:inline-block;border:7px solid transparent;border-bottom-color:#428bca;border-top-color:rgba(0,0,0,.2);position:absolute;bottom:4px;right:4px}.bootstrap-datetimepicker-widget table td.active,.bootstrap-datetimepicker-widget table td.active:hover{background-color:#428bca;color:#428bca;text-shadow:0 -1px 0 rgba(0,0,0,.25)}.bootstrap-datetimepicker-widget table td.active.today:before{border-bottom-color:#fff}.bootstrap-datetimepicker-widget table td.disabled,.bootstrap-datetimepicker-widget table td.disabled:hover{background:none;color:#777;cursor:not-allowed}.bootstrap-datetimepicker-widget table td span{display:inline-block;width:54px;height:54px;line-height:54px;margin:2px 1.5px;cursor:pointer;border-radius:4px}.bootstrap-datetimepicker-widget table td span:hover{background:#eee}.bootstrap-datetimepicker-widget table td span.active{background-color:#428bca;color:#428bca;text-shadow:0 -1px 0 rgba(0,0,0,.25)}.bootstrap-datetimepicker-widget table td span.old{color:#777}.bootstrap-datetimepicker-widget table td span.disabled,.bootstrap-datetimepicker-widget table td span.disabled:hover{background:none;color:#777;cursor:not-allowed}.bootstrap-datetimepicker-widget.usetwentyfour td.hour{height:27px;line-height:27px}.input-group.date .input-group-addon{cursor:pointer}.btn-primary{background:#428bca;color:#fff;border-color:#428bca}.btn-primary.btn-outlined{color:#428bca;background:none}.btn-primary.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-primary.btn-outlined.btn-onlyOnHover.active,.btn-primary.btn-outlined.btn-onlyOnHover:focus,.btn-primary.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-primary.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-primary.btn-outlined.btn-inverse.active,.btn-primary.btn-outlined.btn-inverse:focus,.btn-primary.btn-outlined.btn-inverse:hover{color:#428bca;background:#fff}.btn-primary.btn-outlined.btn-inverse.active.btn-retainBg,.btn-primary.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-primary.btn-outlined.btn-inverse:hover.btn-retainBg{background:#428bca;color:#fff;border-color:#428bca}.btn-primary.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-primary.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-primary.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#275c8a;border-color:#193c5a}.btn-primary.active,.btn-primary.focus,.btn-primary:focus,.btn-primary:hover{color:#fff;background:#6aa3d5;border-color:#6aa3d5}.btn-primary.active,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active,.btn-primary[aria-expanded=true],.btn-primary[aria-expanded=true]:focus,.btn-primary[aria-expanded=true]:hover,.open>.btn-primary.dropdown-toggle{color:#fff;background:#275c8a;border-color:#193c5a;background-image:none}.btn-primary.dropdown-toggle+ul li.active a{color:#fff;background:#428bca}.btn-primary.disabled,.btn-primary[disabled],fieldset[disabled] .btn-primary{pointer-events:none}.btn-primary .badge{color:#428bca;background-color:#428bca}.menu-primary ul li.active a,.menu-primary ul li.active a:hover{color:#fff;background:#428bca!important}.nav-primary>li.active>a,.nav-primary>rubix-menu>li.active>a,.nav-primary>rubix-nav-item>li.active>a{color:#fff;background:#428bca;border-color:#428bca}.tab-primary{border-color:#428bca}.tab-primary>li.active>a{border-color:#428bca;border-bottom-color:transparent}.tab-primary.nav-pills>li.active>a{background:#428bca;color:#fff}.rubix-panel-header.nav-inline .nav-primary>li.active>a{border:1px solid #428bca;border-bottom:none}.rubix-panel-header.nav-inline .nav-primary>li.open>.dropdown-toggle{color:#fff;background:none}.bg-primary{background:#428bca!important}.bg-primary table td,.bg-primary th{border-color:rgba(0,0,0,.05)!important}.bg-focus-primary:focus,.bg-hover-primary:hover{background:#428bca!important}.fg-primary,.fg-primary .nav-tabs>li.active>a{color:#428bca}.fg-tab-active-primary .nav-tabs>li.active>a{color:#428bca!important}.fg-focus-primary:focus,.fg-hover-primary:hover{color:#428bca}.border-primary{border-color:#428bca!important}.border-primary .rubix-timeline-body>ul,.border-primary.rubix-timeline-view:before{border-color:#428bca}.border-focus-primary:focus,.border-hover-primary:hover{border-color:#428bca!important}.tl-primary .rubix-timeline-body>ul>li:before{border-color:#428bca}.list-bg-primary>.list-group-item.active{background:#428bca!important;color:#fff!important}.list-fg-primary>.list-group-item{color:#428bca}.btn-success{background:#5cb85c;color:#fff;border-color:#5cb85c}.btn-success.btn-outlined{color:#5cb85c;background:none}.btn-success.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-success.btn-outlined.btn-onlyOnHover.active,.btn-success.btn-outlined.btn-onlyOnHover:focus,.btn-success.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-success.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-success.btn-outlined.btn-inverse.active,.btn-success.btn-outlined.btn-inverse:focus,.btn-success.btn-outlined.btn-inverse:hover{color:#5cb85c;background:#fff}.btn-success.btn-outlined.btn-inverse.active.btn-retainBg,.btn-success.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-success.btn-outlined.btn-inverse:hover.btn-retainBg{background:#5cb85c;color:#fff;border-color:#5cb85c}.btn-success.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-success.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-success.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#388038;border-color:#255625}.btn-success.active,.btn-success.focus,.btn-success:focus,.btn-success:hover{color:#fff;background:#80c780;border-color:#80c780}.btn-success.active,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active,.btn-success[aria-expanded=true],.btn-success[aria-expanded=true]:focus,.btn-success[aria-expanded=true]:hover,.open>.btn-success.dropdown-toggle{color:#fff;background:#388038;border-color:#255625;background-image:none}.btn-success.dropdown-toggle+ul li.active a{color:#fff;background:#5cb85c}.btn-success.disabled,.btn-success[disabled],fieldset[disabled] .btn-success{pointer-events:none}.btn-success .badge{color:#5cb85c;background-color:#5cb85c}.menu-success ul li.active a,.menu-success ul li.active a:hover{color:#fff;background:#5cb85c!important}.nav-success>li.active>a,.nav-success>rubix-menu>li.active>a,.nav-success>rubix-nav-item>li.active>a{color:#fff;background:#5cb85c;border-color:#5cb85c}.tab-success{border-color:#5cb85c}.tab-success>li.active>a{border-color:#5cb85c;border-bottom-color:transparent}.tab-success.nav-pills>li.active>a{background:#5cb85c;color:#fff}.rubix-panel-header.nav-inline .nav-success>li.active>a{border:1px solid #5cb85c;border-bottom:none}.rubix-panel-header.nav-inline .nav-success>li.open>.dropdown-toggle{color:#fff;background:none}.bg-success{background:#5cb85c!important}.bg-success table td,.bg-success th{border-color:rgba(0,0,0,.05)!important}.bg-focus-success:focus,.bg-hover-success:hover{background:#5cb85c!important}.fg-success,.fg-success .nav-tabs>li.active>a{color:#5cb85c}.fg-tab-active-success .nav-tabs>li.active>a{color:#5cb85c!important}.fg-focus-success:focus,.fg-hover-success:hover{color:#5cb85c}.border-success{border-color:#5cb85c!important}.border-success .rubix-timeline-body>ul,.border-success.rubix-timeline-view:before{border-color:#5cb85c}.border-focus-success:focus,.border-hover-success:hover{border-color:#5cb85c!important}.tl-success .rubix-timeline-body>ul>li:before{border-color:#5cb85c}.list-bg-success>.list-group-item.active{background:#5cb85c!important;color:#fff!important}.list-fg-success>.list-group-item{color:#5cb85c}.btn-info{background:#5bc0de;color:#fff;border-color:#5bc0de}.btn-info.btn-outlined{color:#5bc0de;background:none}.btn-info.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-info.btn-outlined.btn-onlyOnHover.active,.btn-info.btn-outlined.btn-onlyOnHover:focus,.btn-info.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-info.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-info.btn-outlined.btn-inverse.active,.btn-info.btn-outlined.btn-inverse:focus,.btn-info.btn-outlined.btn-inverse:hover{color:#5bc0de;background:#fff}.btn-info.btn-outlined.btn-inverse.active.btn-retainBg,.btn-info.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-info.btn-outlined.btn-inverse:hover.btn-retainBg{background:#5bc0de;color:#fff;border-color:#5bc0de}.btn-info.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-info.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-info.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#2596b8;border-color:#1b6d85}.btn-info.active,.btn-info.focus,.btn-info:focus,.btn-info:hover{color:#fff;background:#85d0e7;border-color:#85d0e7}.btn-info.active,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active,.btn-info[aria-expanded=true],.btn-info[aria-expanded=true]:focus,.btn-info[aria-expanded=true]:hover,.open>.btn-info.dropdown-toggle{color:#fff;background:#2596b8;border-color:#1b6d85;background-image:none}.btn-info.dropdown-toggle+ul li.active a{color:#fff;background:#5bc0de}.btn-info.disabled,.btn-info[disabled],fieldset[disabled] .btn-info{pointer-events:none}.btn-info .badge{color:#5bc0de;background-color:#5bc0de}.menu-info ul li.active a,.menu-info ul li.active a:hover{color:#fff;background:#5bc0de!important}.nav-info>li.active>a,.nav-info>rubix-menu>li.active>a,.nav-info>rubix-nav-item>li.active>a{color:#fff;background:#5bc0de;border-color:#5bc0de}.tab-info{border-color:#5bc0de}.tab-info>li.active>a{border-color:#5bc0de;border-bottom-color:transparent}.tab-info.nav-pills>li.active>a{background:#5bc0de;color:#fff}.rubix-panel-header.nav-inline .nav-info>li.active>a{border:1px solid #5bc0de;border-bottom:none}.rubix-panel-header.nav-inline .nav-info>li.open>.dropdown-toggle{color:#fff;background:none}.bg-info{background:#5bc0de!important}.bg-info table td,.bg-info th{border-color:rgba(0,0,0,.05)!important}.bg-focus-info:focus,.bg-hover-info:hover{background:#5bc0de!important}.fg-info,.fg-info .nav-tabs>li.active>a{color:#5bc0de}.fg-tab-active-info .nav-tabs>li.active>a{color:#5bc0de!important}.fg-focus-info:focus,.fg-hover-info:hover{color:#5bc0de}.border-info{border-color:#5bc0de!important}.border-info .rubix-timeline-body>ul,.border-info.rubix-timeline-view:before{border-color:#5bc0de}.border-focus-info:focus,.border-hover-info:hover{border-color:#5bc0de!important}.tl-info .rubix-timeline-body>ul>li:before{border-color:#5bc0de}.list-bg-info>.list-group-item.active{background:#5bc0de!important;color:#fff!important}.list-fg-info>.list-group-item{color:#5bc0de}.btn-warning{background:#f0ad4e;color:#fff;border-color:#f0ad4e}.btn-warning.btn-outlined{color:#f0ad4e;background:none}.btn-warning.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-warning.btn-outlined.btn-onlyOnHover.active,.btn-warning.btn-outlined.btn-onlyOnHover:focus,.btn-warning.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-warning.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-warning.btn-outlined.btn-inverse.active,.btn-warning.btn-outlined.btn-inverse:focus,.btn-warning.btn-outlined.btn-inverse:hover{color:#f0ad4e;background:#fff}.btn-warning.btn-outlined.btn-inverse.active.btn-retainBg,.btn-warning.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-warning.btn-outlined.btn-inverse:hover.btn-retainBg{background:#f0ad4e;color:#fff;border-color:#f0ad4e}.btn-warning.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-warning.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-warning.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#d18212;border-color:#985f0d}.btn-warning.active,.btn-warning.focus,.btn-warning:focus,.btn-warning:hover{color:#fff;background:#f4c37d;border-color:#f4c37d}.btn-warning.active,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active,.btn-warning[aria-expanded=true],.btn-warning[aria-expanded=true]:focus,.btn-warning[aria-expanded=true]:hover,.open>.btn-warning.dropdown-toggle{color:#fff;background:#d18212;border-color:#985f0d;background-image:none}.btn-warning.dropdown-toggle+ul li.active a{color:#fff;background:#f0ad4e}.btn-warning.disabled,.btn-warning[disabled],fieldset[disabled] .btn-warning{pointer-events:none}.btn-warning .badge{color:#f0ad4e;background-color:#f0ad4e}.menu-warning ul li.active a,.menu-warning ul li.active a:hover{color:#fff;background:#f0ad4e!important}.nav-warning>li.active>a,.nav-warning>rubix-menu>li.active>a,.nav-warning>rubix-nav-item>li.active>a{color:#fff;background:#f0ad4e;border-color:#f0ad4e}.tab-warning{border-color:#f0ad4e}.tab-warning>li.active>a{border-color:#f0ad4e;border-bottom-color:transparent}.tab-warning.nav-pills>li.active>a{background:#f0ad4e;color:#fff}.rubix-panel-header.nav-inline .nav-warning>li.active>a{border:1px solid #f0ad4e;border-bottom:none}.rubix-panel-header.nav-inline .nav-warning>li.open>.dropdown-toggle{color:#fff;background:none}.bg-warning{background:#f0ad4e!important}.bg-warning table td,.bg-warning th{border-color:rgba(0,0,0,.05)!important}.bg-focus-warning:focus,.bg-hover-warning:hover{background:#f0ad4e!important}.fg-warning,.fg-warning .nav-tabs>li.active>a{color:#f0ad4e}.fg-tab-active-warning .nav-tabs>li.active>a{color:#f0ad4e!important}.fg-focus-warning:focus,.fg-hover-warning:hover{color:#f0ad4e}.border-warning{border-color:#f0ad4e!important}.border-warning .rubix-timeline-body>ul,.border-warning.rubix-timeline-view:before{border-color:#f0ad4e}.border-focus-warning:focus,.border-hover-warning:hover{border-color:#f0ad4e!important}.tl-warning .rubix-timeline-body>ul>li:before{border-color:#f0ad4e}.list-bg-warning>.list-group-item.active{background:#f0ad4e!important;color:#fff!important}.list-fg-warning>.list-group-item{color:#f0ad4e}.btn-danger{background:#d9534f;color:#fff;border-color:#d9534f}.btn-danger.btn-outlined{color:#d9534f;background:none}.btn-danger.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-danger.btn-outlined.btn-onlyOnHover.active,.btn-danger.btn-outlined.btn-onlyOnHover:focus,.btn-danger.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-danger.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-danger.btn-outlined.btn-inverse.active,.btn-danger.btn-outlined.btn-inverse:focus,.btn-danger.btn-outlined.btn-inverse:hover{color:#d9534f;background:#fff}.btn-danger.btn-outlined.btn-inverse.active.btn-retainBg,.btn-danger.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-danger.btn-outlined.btn-inverse:hover.btn-retainBg{background:#d9534f;color:#fff;border-color:#d9534f}.btn-danger.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-danger.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-danger.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#a82824;border-color:#761c19}.btn-danger.active,.btn-danger.focus,.btn-danger:focus,.btn-danger:hover{color:#fff;background:#e27c79;border-color:#e27c79}.btn-danger.active,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active,.btn-danger[aria-expanded=true],.btn-danger[aria-expanded=true]:focus,.btn-danger[aria-expanded=true]:hover,.open>.btn-danger.dropdown-toggle{color:#fff;background:#a82824;border-color:#761c19;background-image:none}.btn-danger.dropdown-toggle+ul li.active a{color:#fff;background:#d9534f}.btn-danger.disabled,.btn-danger[disabled],fieldset[disabled] .btn-danger{pointer-events:none}.btn-danger .badge{color:#d9534f;background-color:#d9534f}.menu-danger ul li.active a,.menu-danger ul li.active a:hover{color:#fff;background:#d9534f!important}.nav-danger>li.active>a,.nav-danger>rubix-menu>li.active>a,.nav-danger>rubix-nav-item>li.active>a{color:#fff;background:#d9534f;border-color:#d9534f}.tab-danger{border-color:#d9534f}.tab-danger>li.active>a{border-color:#d9534f;border-bottom-color:transparent}.tab-danger.nav-pills>li.active>a{background:#d9534f;color:#fff}.rubix-panel-header.nav-inline .nav-danger>li.active>a{border:1px solid #d9534f;border-bottom:none}.rubix-panel-header.nav-inline .nav-danger>li.open>.dropdown-toggle{color:#fff;background:none}.bg-danger{background:#d9534f!important}.bg-danger table td,.bg-danger th{border-color:rgba(0,0,0,.05)!important}.bg-focus-danger:focus,.bg-hover-danger:hover{background:#d9534f!important}.fg-danger,.fg-danger .nav-tabs>li.active>a{color:#d9534f}.fg-tab-active-danger .nav-tabs>li.active>a{color:#d9534f!important}.fg-focus-danger:focus,.fg-hover-danger:hover{color:#d9534f}.border-danger{border-color:#d9534f!important}.border-danger .rubix-timeline-body>ul,.border-danger.rubix-timeline-view:before{border-color:#d9534f}.border-focus-danger:focus,.border-hover-danger:hover{border-color:#d9534f!important}.tl-danger .rubix-timeline-body>ul>li:before{border-color:#d9534f}.list-bg-danger>.list-group-item.active{background:#d9534f!important;color:#fff!important}.list-fg-danger>.list-group-item{color:#d9534f}.btn-white{background:#fff;color:#fff;border-color:#fff}.btn-white.btn-outlined{color:#fff;background:none}.btn-white.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-white.btn-outlined.btn-onlyOnHover.active,.btn-white.btn-outlined.btn-onlyOnHover:focus,.btn-white.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-white.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-white.btn-outlined.btn-inverse.active,.btn-white.btn-outlined.btn-inverse:focus,.btn-white.btn-outlined.btn-inverse:hover{color:#fff;background:#fff}.btn-white.btn-outlined.btn-inverse.active.btn-retainBg,.btn-white.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-white.btn-outlined.btn-inverse:hover.btn-retainBg{background:#fff;color:#fff;border-color:#fff}.btn-white.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-white.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-white.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#d1d1d1;border-color:#b3b3b3}.btn-white.active,.btn-white.focus,.btn-white:focus,.btn-white:hover{color:#fff;background:#fff;border-color:#fff}.btn-white.active,.btn-white.active:focus,.btn-white.active:hover,.btn-white:active,.btn-white[aria-expanded=true],.btn-white[aria-expanded=true]:focus,.btn-white[aria-expanded=true]:hover,.open>.btn-white.dropdown-toggle{color:#fff;background:#d1d1d1;border-color:#b3b3b3;background-image:none}.btn-white.dropdown-toggle+ul li.active a{color:#fff;background:#fff}.btn-white.disabled,.btn-white[disabled],fieldset[disabled] .btn-white{pointer-events:none}.btn-white .badge{color:#fff;background-color:#fff}.menu-white ul li.active a,.menu-white ul li.active a:hover{color:#fff;background:#fff!important}.nav-white>li.active>a,.nav-white>rubix-menu>li.active>a,.nav-white>rubix-nav-item>li.active>a{color:#fff;background:#fff;border-color:#fff}.tab-white{border-color:#fff}.tab-white>li.active>a{border-color:#fff;border-bottom-color:transparent}.tab-white.nav-pills>li.active>a{background:#fff;color:#fff}.rubix-panel-header.nav-inline .nav-white>li.active>a{border:1px solid #fff;border-bottom:none}.rubix-panel-header.nav-inline .nav-white>li.open>.dropdown-toggle{color:#fff;background:none}.bg-white{background:#fff!important}.bg-white table td,.bg-white th{border-color:rgba(0,0,0,.05)!important}.bg-focus-white:focus,.bg-hover-white:hover{background:#fff!important}.fg-white{color:#fff}.fg-white .nav-tabs>li.active>a{color:#89949b}.fg-tab-active-white .nav-tabs>li.active>a{color:#fff!important}.fg-focus-white:focus,.fg-hover-white:hover{color:#fff}.border-white{border-color:#fff!important}.border-white .rubix-timeline-body>ul,.border-white.rubix-timeline-view:before{border-color:#fff}.border-focus-white:focus,.border-hover-white:hover{border-color:#fff!important}.tl-white .rubix-timeline-body>ul>li:before{border-color:#fff}.list-bg-white>.list-group-item.active{background:#fff!important;color:#fff!important}.list-fg-white>.list-group-item{color:#fff}.btn-black{background:#000;color:#fff;border-color:#000}.btn-black.btn-outlined{color:#000;background:none}.btn-black.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-black.btn-outlined.btn-onlyOnHover.active,.btn-black.btn-outlined.btn-onlyOnHover:focus,.btn-black.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-black.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-black.btn-outlined.btn-inverse.active,.btn-black.btn-outlined.btn-inverse:focus,.btn-black.btn-outlined.btn-inverse:hover{color:#000;background:#fff}.btn-black.btn-outlined.btn-inverse.active.btn-retainBg,.btn-black.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-black.btn-outlined.btn-inverse:hover.btn-retainBg{background:#000;color:#fff;border-color:#000}.btn-black.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-black.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-black.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#000;border-color:#000}.btn-black.active,.btn-black.focus,.btn-black:focus,.btn-black:hover{color:#fff;background:#1a1a1a;border-color:#1a1a1a}.btn-black.active,.btn-black.active:focus,.btn-black.active:hover,.btn-black:active,.btn-black[aria-expanded=true],.btn-black[aria-expanded=true]:focus,.btn-black[aria-expanded=true]:hover,.open>.btn-black.dropdown-toggle{color:#fff;background:#000;border-color:#000;background-image:none}.btn-black.dropdown-toggle+ul li.active a{color:#fff;background:#000}.btn-black.disabled,.btn-black[disabled],fieldset[disabled] .btn-black{pointer-events:none}.btn-black .badge{color:#000;background-color:#000}.menu-black ul li.active a,.menu-black ul li.active a:hover{color:#fff;background:#000!important}.nav-black>li.active>a,.nav-black>rubix-menu>li.active>a,.nav-black>rubix-nav-item>li.active>a{color:#fff;background:#000;border-color:#000}.tab-black{border-color:#000}.tab-black>li.active>a{border-color:#000;border-bottom-color:transparent}.tab-black.nav-pills>li.active>a{background:#000;color:#fff}.rubix-panel-header.nav-inline .nav-black>li.active>a{border:1px solid #000;border-bottom:none}.rubix-panel-header.nav-inline .nav-black>li.open>.dropdown-toggle{color:#fff;background:none}.bg-black{background:#000!important}.bg-black table td,.bg-black th{border-color:rgba(0,0,0,.05)!important}.bg-focus-black:focus,.bg-hover-black:hover{background:#000!important}.fg-black,.fg-black .nav-tabs>li.active>a{color:#000}.fg-tab-active-black .nav-tabs>li.active>a{color:#000!important}.fg-focus-black:focus,.fg-hover-black:hover{color:#000}.border-black{border-color:#000!important}.border-black .rubix-timeline-body>ul,.border-black.rubix-timeline-view:before{border-color:#000}.border-focus-black:focus,.border-hover-black:hover{border-color:#000!important}.tl-black .rubix-timeline-body>ul>li:before{border-color:#000}.list-bg-black>.list-group-item.active{background:#000!important;color:#fff!important}.list-fg-black>.list-group-item{color:#000}.btn-deepred{background:#d71f4b;color:#fff;border-color:#d71f4b}.btn-deepred.btn-outlined{color:#d71f4b;background:none}.btn-deepred.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-deepred.btn-outlined.btn-onlyOnHover.active,.btn-deepred.btn-outlined.btn-onlyOnHover:focus,.btn-deepred.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-deepred.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-deepred.btn-outlined.btn-inverse.active,.btn-deepred.btn-outlined.btn-inverse:focus,.btn-deepred.btn-outlined.btn-inverse:hover{color:#d71f4b;background:#fff}.btn-deepred.btn-outlined.btn-inverse.active.btn-retainBg,.btn-deepred.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-deepred.btn-outlined.btn-inverse:hover.btn-retainBg{background:#d71f4b;color:#fff;border-color:#d71f4b}.btn-deepred.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-deepred.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-deepred.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#87132f;border-color:#510c1c}.btn-deepred.active,.btn-deepred.focus,.btn-deepred:focus,.btn-deepred:hover{color:#fff;background:#e4456b;border-color:#e4456b}.btn-deepred.active,.btn-deepred.active:focus,.btn-deepred.active:hover,.btn-deepred:active,.btn-deepred[aria-expanded=true],.btn-deepred[aria-expanded=true]:focus,.btn-deepred[aria-expanded=true]:hover,.open>.btn-deepred.dropdown-toggle{color:#fff;background:#87132f;border-color:#510c1c;background-image:none}.btn-deepred.dropdown-toggle+ul li.active a{color:#fff;background:#d71f4b}.btn-deepred.disabled,.btn-deepred[disabled],fieldset[disabled] .btn-deepred{pointer-events:none}.btn-deepred .badge{color:#d71f4b;background-color:#d71f4b}.menu-deepred ul li.active a,.menu-deepred ul li.active a:hover{color:#fff;background:#d71f4b!important}.nav-deepred>li.active>a,.nav-deepred>rubix-menu>li.active>a,.nav-deepred>rubix-nav-item>li.active>a{color:#fff;background:#d71f4b;border-color:#d71f4b}.tab-deepred{border-color:#d71f4b}.tab-deepred>li.active>a{border-color:#d71f4b;border-bottom-color:transparent}.tab-deepred.nav-pills>li.active>a{background:#d71f4b;color:#fff}.rubix-panel-header.nav-inline .nav-deepred>li.active>a{border:1px solid #d71f4b;border-bottom:none}.rubix-panel-header.nav-inline .nav-deepred>li.open>.dropdown-toggle{color:#fff;background:none}.bg-deepred{background:#d71f4b!important}.bg-deepred table td,.bg-deepred th{border-color:rgba(0,0,0,.05)!important}.bg-focus-deepred:focus,.bg-hover-deepred:hover{background:#d71f4b!important}.fg-deepred,.fg-deepred .nav-tabs>li.active>a{color:#d71f4b}.fg-tab-active-deepred .nav-tabs>li.active>a{color:#d71f4b!important}.fg-focus-deepred:focus,.fg-hover-deepred:hover{color:#d71f4b}.border-deepred{border-color:#d71f4b!important}.border-deepred .rubix-timeline-body>ul,.border-deepred.rubix-timeline-view:before{border-color:#d71f4b}.border-focus-deepred:focus,.border-hover-deepred:hover{border-color:#d71f4b!important}.tl-deepred .rubix-timeline-body>ul>li:before{border-color:#d71f4b}.list-bg-deepred>.list-group-item.active{background:#d71f4b!important;color:#fff!important}.list-fg-deepred>.list-group-item{color:#d71f4b}.btn-red{background:#ea7882;color:#fff;border-color:#ea7882}.btn-red.btn-outlined{color:#ea7882;background:none}.btn-red.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-red.btn-outlined.btn-onlyOnHover.active,.btn-red.btn-outlined.btn-onlyOnHover:focus,.btn-red.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-red.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-red.btn-outlined.btn-inverse.active,.btn-red.btn-outlined.btn-inverse:focus,.btn-red.btn-outlined.btn-inverse:hover{color:#ea7882;background:#fff}.btn-red.btn-outlined.btn-inverse.active.btn-retainBg,.btn-red.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-red.btn-outlined.btn-inverse:hover.btn-retainBg{background:#ea7882;color:#fff;border-color:#ea7882}.btn-red.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-red.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-red.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#de2938;border-color:#ae1b28}.btn-red.active,.btn-red.focus,.btn-red:focus,.btn-red:hover{color:#fff;background:#f1a4ab;border-color:#f1a4ab}.btn-red.active,.btn-red.active:focus,.btn-red.active:hover,.btn-red:active,.btn-red[aria-expanded=true],.btn-red[aria-expanded=true]:focus,.btn-red[aria-expanded=true]:hover,.open>.btn-red.dropdown-toggle{color:#fff;background:#de2938;border-color:#ae1b28;background-image:none}.btn-red.dropdown-toggle+ul li.active a{color:#fff;background:#ea7882}.btn-red.disabled,.btn-red[disabled],fieldset[disabled] .btn-red{pointer-events:none}.btn-red .badge{color:#ea7882;background-color:#ea7882}.menu-red ul li.active a,.menu-red ul li.active a:hover{color:#fff;background:#ea7882!important}.nav-red>li.active>a,.nav-red>rubix-menu>li.active>a,.nav-red>rubix-nav-item>li.active>a{color:#fff;background:#ea7882;border-color:#ea7882}.tab-red{border-color:#ea7882}.tab-red>li.active>a{border-color:#ea7882;border-bottom-color:transparent}.tab-red.nav-pills>li.active>a{background:#ea7882;color:#fff}.rubix-panel-header.nav-inline .nav-red>li.active>a{border:1px solid #ea7882;border-bottom:none}.rubix-panel-header.nav-inline .nav-red>li.open>.dropdown-toggle{color:#fff;background:none}.bg-red{background:#ea7882!important}.bg-red table td,.bg-red th{border-color:rgba(0,0,0,.05)!important}.bg-focus-red:focus,.bg-hover-red:hover{background:#ea7882!important}.fg-red,.fg-red .nav-tabs>li.active>a{color:#ea7882}.fg-tab-active-red .nav-tabs>li.active>a{color:#ea7882!important}.fg-focus-red:focus,.fg-hover-red:hover{color:#ea7882}.border-red{border-color:#ea7882!important}.border-red .rubix-timeline-body>ul,.border-red.rubix-timeline-view:before{border-color:#ea7882}.border-focus-red:focus,.border-hover-red:hover{border-color:#ea7882!important}.tl-red .rubix-timeline-body>ul>li:before{border-color:#ea7882}.list-bg-red>.list-group-item.active{background:#ea7882!important;color:#fff!important}.list-fg-red>.list-group-item{color:#ea7882}.btn-lightred{background:#f09fa6;color:#fff;border-color:#f09fa6}.btn-lightred.btn-outlined{color:#f09fa6;background:none}.btn-lightred.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-lightred.btn-outlined.btn-onlyOnHover.active,.btn-lightred.btn-outlined.btn-onlyOnHover:focus,.btn-lightred.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-lightred.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-lightred.btn-outlined.btn-inverse.active,.btn-lightred.btn-outlined.btn-inverse:focus,.btn-lightred.btn-outlined.btn-inverse:hover{color:#f09fa6;background:#fff}.btn-lightred.btn-outlined.btn-inverse.active.btn-retainBg,.btn-lightred.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-lightred.btn-outlined.btn-inverse:hover.btn-retainBg{background:#f09fa6;color:#fff;border-color:#f09fa6}.btn-lightred.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-lightred.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-lightred.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#e4505c;border-color:#d52131}.btn-lightred.active,.btn-lightred.focus,.btn-lightred:focus,.btn-lightred:hover{color:#fff;background:#f7cbcf;border-color:#f7cbcf}.btn-lightred.active,.btn-lightred.active:focus,.btn-lightred.active:hover,.btn-lightred:active,.btn-lightred[aria-expanded=true],.btn-lightred[aria-expanded=true]:focus,.btn-lightred[aria-expanded=true]:hover,.open>.btn-lightred.dropdown-toggle{color:#fff;background:#e4505c;border-color:#d52131;background-image:none}.btn-lightred.dropdown-toggle+ul li.active a{color:#fff;background:#f09fa6}.btn-lightred.disabled,.btn-lightred[disabled],fieldset[disabled] .btn-lightred{pointer-events:none}.btn-lightred .badge{color:#f09fa6;background-color:#f09fa6}.menu-lightred ul li.active a,.menu-lightred ul li.active a:hover{color:#fff;background:#f09fa6!important}.nav-lightred>li.active>a,.nav-lightred>rubix-menu>li.active>a,.nav-lightred>rubix-nav-item>li.active>a{color:#fff;background:#f09fa6;border-color:#f09fa6}.tab-lightred{border-color:#f09fa6}.tab-lightred>li.active>a{border-color:#f09fa6;border-bottom-color:transparent}.tab-lightred.nav-pills>li.active>a{background:#f09fa6;color:#fff}.rubix-panel-header.nav-inline .nav-lightred>li.active>a{border:1px solid #f09fa6;border-bottom:none}.rubix-panel-header.nav-inline .nav-lightred>li.open>.dropdown-toggle{color:#fff;background:none}.bg-lightred{background:#f09fa6!important}.bg-lightred table td,.bg-lightred th{border-color:rgba(0,0,0,.05)!important}.bg-focus-lightred:focus,.bg-hover-lightred:hover{background:#f09fa6!important}.fg-lightred,.fg-lightred .nav-tabs>li.active>a{color:#f09fa6}.fg-tab-active-lightred .nav-tabs>li.active>a{color:#f09fa6!important}.fg-focus-lightred:focus,.fg-hover-lightred:hover{color:#f09fa6}.border-lightred{border-color:#f09fa6!important}.border-lightred .rubix-timeline-body>ul,.border-lightred.rubix-timeline-view:before{border-color:#f09fa6}.border-focus-lightred:focus,.border-hover-lightred:hover{border-color:#f09fa6!important}.tl-lightred .rubix-timeline-body>ul>li:before{border-color:#f09fa6}.list-bg-lightred>.list-group-item.active{background:#f09fa6!important;color:#fff!important}.list-fg-lightred>.list-group-item{color:#f09fa6}.btn-brightblue{background:#003bff;color:#fff;border-color:#003bff}.btn-brightblue.btn-outlined{color:#003bff;background:none}.btn-brightblue.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-brightblue.btn-outlined.btn-onlyOnHover.active,.btn-brightblue.btn-outlined.btn-onlyOnHover:focus,.btn-brightblue.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-brightblue.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-brightblue.btn-outlined.btn-inverse.active,.btn-brightblue.btn-outlined.btn-inverse:focus,.btn-brightblue.btn-outlined.btn-inverse:hover{color:#003bff;background:#fff}.btn-brightblue.btn-outlined.btn-inverse.active.btn-retainBg,.btn-brightblue.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-brightblue.btn-outlined.btn-inverse:hover.btn-retainBg{background:#003bff;color:#fff;border-color:#003bff}.btn-brightblue.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-brightblue.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-brightblue.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#0026a3;border-color:#001866}.btn-brightblue.active,.btn-brightblue.focus,.btn-brightblue:focus,.btn-brightblue:hover{color:#fff;background:#3362ff;border-color:#3362ff}.btn-brightblue.active,.btn-brightblue.active:focus,.btn-brightblue.active:hover,.btn-brightblue:active,.btn-brightblue[aria-expanded=true],.btn-brightblue[aria-expanded=true]:focus,.btn-brightblue[aria-expanded=true]:hover,.open>.btn-brightblue.dropdown-toggle{color:#fff;background:#0026a3;border-color:#001866;background-image:none}.btn-brightblue.dropdown-toggle+ul li.active a{color:#fff;background:#003bff}.btn-brightblue.disabled,.btn-brightblue[disabled],fieldset[disabled] .btn-brightblue{pointer-events:none}.btn-brightblue .badge{color:#003bff;background-color:#003bff}.menu-brightblue ul li.active a,.menu-brightblue ul li.active a:hover{color:#fff;background:#003bff!important}.nav-brightblue>li.active>a,.nav-brightblue>rubix-menu>li.active>a,.nav-brightblue>rubix-nav-item>li.active>a{color:#fff;background:#003bff;border-color:#003bff}.tab-brightblue{border-color:#003bff}.tab-brightblue>li.active>a{border-color:#003bff;border-bottom-color:transparent}.tab-brightblue.nav-pills>li.active>a{background:#003bff;color:#fff}.rubix-panel-header.nav-inline .nav-brightblue>li.active>a{border:1px solid #003bff;border-bottom:none}.rubix-panel-header.nav-inline .nav-brightblue>li.open>.dropdown-toggle{color:#fff;background:none}.bg-brightblue{background:#003bff!important}.bg-brightblue table td,.bg-brightblue th{border-color:rgba(0,0,0,.05)!important}.bg-focus-brightblue:focus,.bg-hover-brightblue:hover{background:#003bff!important}.fg-brightblue,.fg-brightblue .nav-tabs>li.active>a{color:#003bff}.fg-tab-active-brightblue .nav-tabs>li.active>a{color:#003bff!important}.fg-focus-brightblue:focus,.fg-hover-brightblue:hover{color:#003bff}.border-brightblue{border-color:#003bff!important}.border-brightblue .rubix-timeline-body>ul,.border-brightblue.rubix-timeline-view:before{border-color:#003bff}.border-focus-brightblue:focus,.border-hover-brightblue:hover{border-color:#003bff!important}.tl-brightblue .rubix-timeline-body>ul>li:before{border-color:#003bff}.list-bg-brightblue>.list-group-item.active{background:#003bff!important;color:#fff!important}.list-fg-brightblue>.list-group-item{color:#003bff}.btn-darkblue{background:#4a90e2;color:#fff;border-color:#4a90e2}.btn-darkblue.btn-outlined{color:#4a90e2;background:none}.btn-darkblue.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkblue.btn-outlined.btn-onlyOnHover.active,.btn-darkblue.btn-outlined.btn-onlyOnHover:focus,.btn-darkblue.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkblue.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkblue.btn-outlined.btn-inverse.active,.btn-darkblue.btn-outlined.btn-inverse:focus,.btn-darkblue.btn-outlined.btn-inverse:hover{color:#4a90e2;background:#fff}.btn-darkblue.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkblue.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkblue.btn-outlined.btn-inverse:hover.btn-retainBg{background:#4a90e2;color:#fff;border-color:#4a90e2}.btn-darkblue.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkblue.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkblue.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#1d62b3;border-color:#14457f}.btn-darkblue.active,.btn-darkblue.focus,.btn-darkblue:focus,.btn-darkblue:hover{color:#fff;background:#76abe9;border-color:#76abe9}.btn-darkblue.active,.btn-darkblue.active:focus,.btn-darkblue.active:hover,.btn-darkblue:active,.btn-darkblue[aria-expanded=true],.btn-darkblue[aria-expanded=true]:focus,.btn-darkblue[aria-expanded=true]:hover,.open>.btn-darkblue.dropdown-toggle{color:#fff;background:#1d62b3;border-color:#14457f;background-image:none}.btn-darkblue.dropdown-toggle+ul li.active a{color:#fff;background:#4a90e2}.btn-darkblue.disabled,.btn-darkblue[disabled],fieldset[disabled] .btn-darkblue{pointer-events:none}.btn-darkblue .badge{color:#4a90e2;background-color:#4a90e2}.menu-darkblue ul li.active a,.menu-darkblue ul li.active a:hover{color:#fff;background:#4a90e2!important}.nav-darkblue>li.active>a,.nav-darkblue>rubix-menu>li.active>a,.nav-darkblue>rubix-nav-item>li.active>a{color:#fff;background:#4a90e2;border-color:#4a90e2}.tab-darkblue{border-color:#4a90e2}.tab-darkblue>li.active>a{border-color:#4a90e2;border-bottom-color:transparent}.tab-darkblue.nav-pills>li.active>a{background:#4a90e2;color:#fff}.rubix-panel-header.nav-inline .nav-darkblue>li.active>a{border:1px solid #4a90e2;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkblue>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkblue{background:#4a90e2!important}.bg-darkblue table td,.bg-darkblue th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkblue:focus,.bg-hover-darkblue:hover{background:#4a90e2!important}.fg-darkblue,.fg-darkblue .nav-tabs>li.active>a{color:#4a90e2}.fg-tab-active-darkblue .nav-tabs>li.active>a{color:#4a90e2!important}.fg-focus-darkblue:focus,.fg-hover-darkblue:hover{color:#4a90e2}.border-darkblue{border-color:#4a90e2!important}.border-darkblue .rubix-timeline-body>ul,.border-darkblue.rubix-timeline-view:before{border-color:#4a90e2}.border-focus-darkblue:focus,.border-hover-darkblue:hover{border-color:#4a90e2!important}.tl-darkblue .rubix-timeline-body>ul>li:before{border-color:#4a90e2}.list-bg-darkblue>.list-group-item.active{background:#4a90e2!important;color:#fff!important}.list-fg-darkblue>.list-group-item{color:#4a90e2}.btn-blue{background:#79b0ec;color:#fff;border-color:#79b0ec}.btn-blue.btn-outlined{color:#79b0ec;background:none}.btn-blue.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-blue.btn-outlined.btn-onlyOnHover.active,.btn-blue.btn-outlined.btn-onlyOnHover:focus,.btn-blue.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-blue.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-blue.btn-outlined.btn-inverse.active,.btn-blue.btn-outlined.btn-inverse:focus,.btn-blue.btn-outlined.btn-inverse:hover{color:#79b0ec;background:#fff}.btn-blue.btn-outlined.btn-inverse.active.btn-retainBg,.btn-blue.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-blue.btn-outlined.btn-inverse:hover.btn-retainBg{background:#79b0ec;color:#fff;border-color:#79b0ec}.btn-blue.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-blue.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-blue.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#2981e1;border-color:#1963b3}.btn-blue.active,.btn-blue.focus,.btn-blue:focus,.btn-blue:hover{color:#fff;background:#a6caf2;border-color:#a6caf2}.btn-blue.active,.btn-blue.active:focus,.btn-blue.active:hover,.btn-blue:active,.btn-blue[aria-expanded=true],.btn-blue[aria-expanded=true]:focus,.btn-blue[aria-expanded=true]:hover,.open>.btn-blue.dropdown-toggle{color:#fff;background:#2981e1;border-color:#1963b3;background-image:none}.btn-blue.dropdown-toggle+ul li.active a{color:#fff;background:#79b0ec}.btn-blue.disabled,.btn-blue[disabled],fieldset[disabled] .btn-blue{pointer-events:none}.btn-blue .badge{color:#79b0ec;background-color:#79b0ec}.menu-blue ul li.active a,.menu-blue ul li.active a:hover{color:#fff;background:#79b0ec!important}.nav-blue>li.active>a,.nav-blue>rubix-menu>li.active>a,.nav-blue>rubix-nav-item>li.active>a{color:#fff;background:#79b0ec;border-color:#79b0ec}.tab-blue{border-color:#79b0ec}.tab-blue>li.active>a{border-color:#79b0ec;border-bottom-color:transparent}.tab-blue.nav-pills>li.active>a{background:#79b0ec;color:#fff}.rubix-panel-header.nav-inline .nav-blue>li.active>a{border:1px solid #79b0ec;border-bottom:none}.rubix-panel-header.nav-inline .nav-blue>li.open>.dropdown-toggle{color:#fff;background:none}.bg-blue{background:#79b0ec!important}.bg-blue table td,.bg-blue th{border-color:rgba(0,0,0,.05)!important}.bg-focus-blue:focus,.bg-hover-blue:hover{background:#79b0ec!important}.fg-blue,.fg-blue .nav-tabs>li.active>a{color:#79b0ec}.fg-tab-active-blue .nav-tabs>li.active>a{color:#79b0ec!important}.fg-focus-blue:focus,.fg-hover-blue:hover{color:#79b0ec}.border-blue{border-color:#79b0ec!important}.border-blue .rubix-timeline-body>ul,.border-blue.rubix-timeline-view:before{border-color:#79b0ec}.border-focus-blue:focus,.border-hover-blue:hover{border-color:#79b0ec!important}.tl-blue .rubix-timeline-body>ul>li:before{border-color:#79b0ec}.list-bg-blue>.list-group-item.active{background:#79b0ec!important;color:#fff!important}.list-fg-blue>.list-group-item{color:#79b0ec}.btn-lightblue50{background:#d2e0eb;color:#fff;border-color:#d2e0eb}.btn-lightblue50.btn-outlined{color:#d2e0eb;background:none}.btn-lightblue50.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-lightblue50.btn-outlined.btn-onlyOnHover.active,.btn-lightblue50.btn-outlined.btn-onlyOnHover:focus,.btn-lightblue50.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-lightblue50.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-lightblue50.btn-outlined.btn-inverse.active,.btn-lightblue50.btn-outlined.btn-inverse:focus,.btn-lightblue50.btn-outlined.btn-inverse:hover{color:#d2e0eb;background:#fff}.btn-lightblue50.btn-outlined.btn-inverse.active.btn-retainBg,.btn-lightblue50.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-lightblue50.btn-outlined.btn-inverse:hover.btn-retainBg{background:#d2e0eb;color:#fff;border-color:#d2e0eb}.btn-lightblue50.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-lightblue50.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-lightblue50.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#92b4cf;border-color:#6897bc}.btn-lightblue50.active,.btn-lightblue50.focus,.btn-lightblue50:focus,.btn-lightblue50:hover{color:#fff;background:#f5f8fb;border-color:#f5f8fb}.btn-lightblue50.active,.btn-lightblue50.active:focus,.btn-lightblue50.active:hover,.btn-lightblue50:active,.btn-lightblue50[aria-expanded=true],.btn-lightblue50[aria-expanded=true]:focus,.btn-lightblue50[aria-expanded=true]:hover,.open>.btn-lightblue50.dropdown-toggle{color:#fff;background:#92b4cf;border-color:#6897bc;background-image:none}.btn-lightblue50.dropdown-toggle+ul li.active a{color:#fff;background:#d2e0eb}.btn-lightblue50.disabled,.btn-lightblue50[disabled],fieldset[disabled] .btn-lightblue50{pointer-events:none}.btn-lightblue50 .badge{color:#d2e0eb;background-color:#d2e0eb}.menu-lightblue50 ul li.active a,.menu-lightblue50 ul li.active a:hover{color:#fff;background:#d2e0eb!important}.nav-lightblue50>li.active>a,.nav-lightblue50>rubix-menu>li.active>a,.nav-lightblue50>rubix-nav-item>li.active>a{color:#fff;background:#d2e0eb;border-color:#d2e0eb}.tab-lightblue50{border-color:#d2e0eb}.tab-lightblue50>li.active>a{border-color:#d2e0eb;border-bottom-color:transparent}.tab-lightblue50.nav-pills>li.active>a{background:#d2e0eb;color:#fff}.rubix-panel-header.nav-inline .nav-lightblue50>li.active>a{border:1px solid #d2e0eb;border-bottom:none}.rubix-panel-header.nav-inline .nav-lightblue50>li.open>.dropdown-toggle{color:#fff;background:none}.bg-lightblue50{background:#d2e0eb!important}.bg-lightblue50 table td,.bg-lightblue50 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-lightblue50:focus,.bg-hover-lightblue50:hover{background:#d2e0eb!important}.fg-lightblue50,.fg-lightblue50 .nav-tabs>li.active>a{color:#d2e0eb}.fg-tab-active-lightblue50 .nav-tabs>li.active>a{color:#d2e0eb!important}.fg-focus-lightblue50:focus,.fg-hover-lightblue50:hover{color:#d2e0eb}.border-lightblue50{border-color:#d2e0eb!important}.border-lightblue50 .rubix-timeline-body>ul,.border-lightblue50.rubix-timeline-view:before{border-color:#d2e0eb}.border-focus-lightblue50:focus,.border-hover-lightblue50:hover{border-color:#d2e0eb!important}.tl-lightblue50 .rubix-timeline-body>ul>li:before{border-color:#d2e0eb}.list-bg-lightblue50>.list-group-item.active{background:#d2e0eb!important;color:#fff!important}.list-fg-lightblue50>.list-group-item{color:#d2e0eb}.btn-lightblue{background:#a0c7f2;color:#fff;border-color:#a0c7f2}.btn-lightblue.btn-outlined{color:#a0c7f2;background:none}.btn-lightblue.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-lightblue.btn-outlined.btn-onlyOnHover.active,.btn-lightblue.btn-outlined.btn-onlyOnHover:focus,.btn-lightblue.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-lightblue.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-lightblue.btn-outlined.btn-inverse.active,.btn-lightblue.btn-outlined.btn-inverse:focus,.btn-lightblue.btn-outlined.btn-inverse:hover{color:#a0c7f2;background:#fff}.btn-lightblue.btn-outlined.btn-inverse.active.btn-retainBg,.btn-lightblue.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-lightblue.btn-outlined.btn-inverse:hover.btn-retainBg{background:#a0c7f2;color:#fff;border-color:#a0c7f2}.btn-lightblue.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-lightblue.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-lightblue.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#4f97e7;border-color:#1e78db}.btn-lightblue.active,.btn-lightblue.focus,.btn-lightblue:focus,.btn-lightblue:hover{color:#fff;background:#cde1f8;border-color:#cde1f8}.btn-lightblue.active,.btn-lightblue.active:focus,.btn-lightblue.active:hover,.btn-lightblue:active,.btn-lightblue[aria-expanded=true],.btn-lightblue[aria-expanded=true]:focus,.btn-lightblue[aria-expanded=true]:hover,.open>.btn-lightblue.dropdown-toggle{color:#fff;background:#4f97e7;border-color:#1e78db;background-image:none}.btn-lightblue.dropdown-toggle+ul li.active a{color:#fff;background:#a0c7f2}.btn-lightblue.disabled,.btn-lightblue[disabled],fieldset[disabled] .btn-lightblue{pointer-events:none}.btn-lightblue .badge{color:#a0c7f2;background-color:#a0c7f2}.menu-lightblue ul li.active a,.menu-lightblue ul li.active a:hover{color:#fff;background:#a0c7f2!important}.nav-lightblue>li.active>a,.nav-lightblue>rubix-menu>li.active>a,.nav-lightblue>rubix-nav-item>li.active>a{color:#fff;background:#a0c7f2;border-color:#a0c7f2}.tab-lightblue{border-color:#a0c7f2}.tab-lightblue>li.active>a{border-color:#a0c7f2;border-bottom-color:transparent}.tab-lightblue.nav-pills>li.active>a{background:#a0c7f2;color:#fff}.rubix-panel-header.nav-inline .nav-lightblue>li.active>a{border:1px solid #a0c7f2;border-bottom:none}.rubix-panel-header.nav-inline .nav-lightblue>li.open>.dropdown-toggle{color:#fff;background:none}.bg-lightblue{background:#a0c7f2!important}.bg-lightblue table td,.bg-lightblue th{border-color:rgba(0,0,0,.05)!important}.bg-focus-lightblue:focus,.bg-hover-lightblue:hover{background:#a0c7f2!important}.fg-lightblue,.fg-lightblue .nav-tabs>li.active>a{color:#a0c7f2}.fg-tab-active-lightblue .nav-tabs>li.active>a{color:#a0c7f2!important}.fg-focus-lightblue:focus,.fg-hover-lightblue:hover{color:#a0c7f2}.border-lightblue{border-color:#a0c7f2!important}.border-lightblue .rubix-timeline-body>ul,.border-lightblue.rubix-timeline-view:before{border-color:#a0c7f2}.border-focus-lightblue:focus,.border-hover-lightblue:hover{border-color:#a0c7f2!important}.tl-lightblue .rubix-timeline-body>ul>li:before{border-color:#a0c7f2}.list-bg-lightblue>.list-group-item.active{background:#a0c7f2!important;color:#fff!important}.list-fg-lightblue>.list-group-item{color:#a0c7f2}.btn-hoverblue{background:#e5effb;color:#fff;border-color:#e5effb}.btn-hoverblue.btn-outlined{color:#e5effb;background:none}.btn-hoverblue.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-hoverblue.btn-outlined.btn-onlyOnHover.active,.btn-hoverblue.btn-outlined.btn-onlyOnHover:focus,.btn-hoverblue.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-hoverblue.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-hoverblue.btn-outlined.btn-inverse.active,.btn-hoverblue.btn-outlined.btn-inverse:focus,.btn-hoverblue.btn-outlined.btn-inverse:hover{color:#e5effb;background:#fff}.btn-hoverblue.btn-outlined.btn-inverse.active.btn-retainBg,.btn-hoverblue.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-hoverblue.btn-outlined.btn-inverse:hover.btn-retainBg{background:#e5effb;color:#fff;border-color:#e5effb}.btn-hoverblue.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-hoverblue.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-hoverblue.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#95beef;border-color:#609de7}.btn-hoverblue.active,.btn-hoverblue.focus,.btn-hoverblue:focus,.btn-hoverblue:hover{color:#fff;background:#fff;border-color:#fff}.btn-hoverblue.active,.btn-hoverblue.active:focus,.btn-hoverblue.active:hover,.btn-hoverblue:active,.btn-hoverblue[aria-expanded=true],.btn-hoverblue[aria-expanded=true]:focus,.btn-hoverblue[aria-expanded=true]:hover,.open>.btn-hoverblue.dropdown-toggle{color:#fff;background:#95beef;border-color:#609de7;background-image:none}.btn-hoverblue.dropdown-toggle+ul li.active a{color:#fff;background:#e5effb}.btn-hoverblue.disabled,.btn-hoverblue[disabled],fieldset[disabled] .btn-hoverblue{pointer-events:none}.btn-hoverblue .badge{color:#e5effb;background-color:#e5effb}.menu-hoverblue ul li.active a,.menu-hoverblue ul li.active a:hover{color:#fff;background:#e5effb!important}.nav-hoverblue>li.active>a,.nav-hoverblue>rubix-menu>li.active>a,.nav-hoverblue>rubix-nav-item>li.active>a{color:#fff;background:#e5effb;border-color:#e5effb}.tab-hoverblue{border-color:#e5effb}.tab-hoverblue>li.active>a{border-color:#e5effb;border-bottom-color:transparent}.tab-hoverblue.nav-pills>li.active>a{background:#e5effb;color:#fff}.rubix-panel-header.nav-inline .nav-hoverblue>li.active>a{border:1px solid #e5effb;border-bottom:none}.rubix-panel-header.nav-inline .nav-hoverblue>li.open>.dropdown-toggle{color:#fff;background:none}.bg-hoverblue{background:#e5effb!important}.bg-hoverblue table td,.bg-hoverblue th{border-color:rgba(0,0,0,.05)!important}.bg-focus-hoverblue:focus,.bg-hover-hoverblue:hover{background:#e5effb!important}.fg-hoverblue,.fg-hoverblue .nav-tabs>li.active>a{color:#e5effb}.fg-tab-active-hoverblue .nav-tabs>li.active>a{color:#e5effb!important}.fg-focus-hoverblue:focus,.fg-hover-hoverblue:hover{color:#e5effb}.border-hoverblue{border-color:#e5effb!important}.border-hoverblue .rubix-timeline-body>ul,.border-hoverblue.rubix-timeline-view:before{border-color:#e5effb}.border-focus-hoverblue:focus,.border-hover-hoverblue:hover{border-color:#e5effb!important}.tl-hoverblue .rubix-timeline-body>ul>li:before{border-color:#e5effb}.list-bg-hoverblue>.list-group-item.active{background:#e5effb!important;color:#fff!important}.list-fg-hoverblue>.list-group-item{color:#e5effb}.btn-purple{background:#b4a1dd;color:#fff;border-color:#b4a1dd}.btn-purple.btn-outlined{color:#b4a1dd;background:none}.btn-purple.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-purple.btn-outlined.btn-onlyOnHover.active,.btn-purple.btn-outlined.btn-onlyOnHover:focus,.btn-purple.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-purple.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-purple.btn-outlined.btn-inverse.active,.btn-purple.btn-outlined.btn-inverse:focus,.btn-purple.btn-outlined.btn-inverse:hover{color:#b4a1dd;background:#fff}.btn-purple.btn-outlined.btn-inverse.active.btn-retainBg,.btn-purple.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-purple.btn-outlined.btn-inverse:hover.btn-retainBg{background:#b4a1dd;color:#fff;border-color:#b4a1dd}.btn-purple.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-purple.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-purple.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#7e5ec5;border-color:#5f3da8}.btn-purple.active,.btn-purple.focus,.btn-purple:focus,.btn-purple:hover{color:#fff;background:#d2c6eb;border-color:#d2c6eb}.btn-purple.active,.btn-purple.active:focus,.btn-purple.active:hover,.btn-purple:active,.btn-purple[aria-expanded=true],.btn-purple[aria-expanded=true]:focus,.btn-purple[aria-expanded=true]:hover,.open>.btn-purple.dropdown-toggle{color:#fff;background:#7e5ec5;border-color:#5f3da8;background-image:none}.btn-purple.dropdown-toggle+ul li.active a{color:#fff;background:#b4a1dd}.btn-purple.disabled,.btn-purple[disabled],fieldset[disabled] .btn-purple{pointer-events:none}.btn-purple .badge{color:#b4a1dd;background-color:#b4a1dd}.menu-purple ul li.active a,.menu-purple ul li.active a:hover{color:#fff;background:#b4a1dd!important}.nav-purple>li.active>a,.nav-purple>rubix-menu>li.active>a,.nav-purple>rubix-nav-item>li.active>a{color:#fff;background:#b4a1dd;border-color:#b4a1dd}.tab-purple{border-color:#b4a1dd}.tab-purple>li.active>a{border-color:#b4a1dd;border-bottom-color:transparent}.tab-purple.nav-pills>li.active>a{background:#b4a1dd;color:#fff}.rubix-panel-header.nav-inline .nav-purple>li.active>a{border:1px solid #b4a1dd;border-bottom:none}.rubix-panel-header.nav-inline .nav-purple>li.open>.dropdown-toggle{color:#fff;background:none}.bg-purple{background:#b4a1dd!important}.bg-purple table td,.bg-purple th{border-color:rgba(0,0,0,.05)!important}.bg-focus-purple:focus,.bg-hover-purple:hover{background:#b4a1dd!important}.fg-purple,.fg-purple .nav-tabs>li.active>a{color:#b4a1dd}.fg-tab-active-purple .nav-tabs>li.active>a{color:#b4a1dd!important}.fg-focus-purple:focus,.fg-hover-purple:hover{color:#b4a1dd}.border-purple{border-color:#b4a1dd!important}.border-purple .rubix-timeline-body>ul,.border-purple.rubix-timeline-view:before{border-color:#b4a1dd}.border-focus-purple:focus,.border-hover-purple:hover{border-color:#b4a1dd!important}.tl-purple .rubix-timeline-body>ul>li:before{border-color:#b4a1dd}.list-bg-purple>.list-group-item.active{background:#b4a1dd!important;color:#fff!important}.list-fg-purple>.list-group-item{color:#b4a1dd}.btn-lightpurple50{background:#c1b2e3;color:#fff;border-color:#c1b2e3}.btn-lightpurple50.btn-outlined{color:#c1b2e3;background:none}.btn-lightpurple50.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-lightpurple50.btn-outlined.btn-onlyOnHover.active,.btn-lightpurple50.btn-outlined.btn-onlyOnHover:focus,.btn-lightpurple50.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-lightpurple50.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-lightpurple50.btn-outlined.btn-inverse.active,.btn-lightpurple50.btn-outlined.btn-inverse:focus,.btn-lightpurple50.btn-outlined.btn-inverse:hover{color:#c1b2e3;background:#fff}.btn-lightpurple50.btn-outlined.btn-inverse.active.btn-retainBg,.btn-lightpurple50.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-lightpurple50.btn-outlined.btn-inverse:hover.btn-retainBg{background:#c1b2e3;color:#fff;border-color:#c1b2e3}.btn-lightpurple50.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-lightpurple50.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-lightpurple50.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#8b6fcb;border-color:#6743b9}.btn-lightpurple50.active,.btn-lightpurple50.focus,.btn-lightpurple50:focus,.btn-lightpurple50:hover{color:#fff;background:#dfd7f1;border-color:#dfd7f1}.btn-lightpurple50.active,.btn-lightpurple50.active:focus,.btn-lightpurple50.active:hover,.btn-lightpurple50:active,.btn-lightpurple50[aria-expanded=true],.btn-lightpurple50[aria-expanded=true]:focus,.btn-lightpurple50[aria-expanded=true]:hover,.open>.btn-lightpurple50.dropdown-toggle{color:#fff;background:#8b6fcb;border-color:#6743b9;background-image:none}.btn-lightpurple50.dropdown-toggle+ul li.active a{color:#fff;background:#c1b2e3}.btn-lightpurple50.disabled,.btn-lightpurple50[disabled],fieldset[disabled] .btn-lightpurple50{pointer-events:none}.btn-lightpurple50 .badge{color:#c1b2e3;background-color:#c1b2e3}.menu-lightpurple50 ul li.active a,.menu-lightpurple50 ul li.active a:hover{color:#fff;background:#c1b2e3!important}.nav-lightpurple50>li.active>a,.nav-lightpurple50>rubix-menu>li.active>a,.nav-lightpurple50>rubix-nav-item>li.active>a{color:#fff;background:#c1b2e3;border-color:#c1b2e3}.tab-lightpurple50{border-color:#c1b2e3}.tab-lightpurple50>li.active>a{border-color:#c1b2e3;border-bottom-color:transparent}.tab-lightpurple50.nav-pills>li.active>a{background:#c1b2e3;color:#fff}.rubix-panel-header.nav-inline .nav-lightpurple50>li.active>a{border:1px solid #c1b2e3;border-bottom:none}.rubix-panel-header.nav-inline .nav-lightpurple50>li.open>.dropdown-toggle{color:#fff;background:none}.bg-lightpurple50{background:#c1b2e3!important}.bg-lightpurple50 table td,.bg-lightpurple50 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-lightpurple50:focus,.bg-hover-lightpurple50:hover{background:#c1b2e3!important}.fg-lightpurple50,.fg-lightpurple50 .nav-tabs>li.active>a{color:#c1b2e3}.fg-tab-active-lightpurple50 .nav-tabs>li.active>a{color:#c1b2e3!important}.fg-focus-lightpurple50:focus,.fg-hover-lightpurple50:hover{color:#c1b2e3}.border-lightpurple50{border-color:#c1b2e3!important}.border-lightpurple50 .rubix-timeline-body>ul,.border-lightpurple50.rubix-timeline-view:before{border-color:#c1b2e3}.border-focus-lightpurple50:focus,.border-hover-lightpurple50:hover{border-color:#c1b2e3!important}.tl-lightpurple50 .rubix-timeline-body>ul>li:before{border-color:#c1b2e3}.list-bg-lightpurple50>.list-group-item.active{background:#c1b2e3!important;color:#fff!important}.list-fg-lightpurple50>.list-group-item{color:#c1b2e3}.btn-lightpurple{background:#d3c9eb;color:#fff;border-color:#d3c9eb}.btn-lightpurple.btn-outlined{color:#d3c9eb;background:none}.btn-lightpurple.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-lightpurple.btn-outlined.btn-onlyOnHover.active,.btn-lightpurple.btn-outlined.btn-onlyOnHover:focus,.btn-lightpurple.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-lightpurple.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-lightpurple.btn-outlined.btn-inverse.active,.btn-lightpurple.btn-outlined.btn-inverse:focus,.btn-lightpurple.btn-outlined.btn-inverse:hover{color:#d3c9eb;background:#fff}.btn-lightpurple.btn-outlined.btn-inverse.active.btn-retainBg,.btn-lightpurple.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-lightpurple.btn-outlined.btn-inverse:hover.btn-retainBg{background:#d3c9eb;color:#fff;border-color:#d3c9eb}.btn-lightpurple.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-lightpurple.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-lightpurple.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#9c86d2;border-color:#7859c2}.btn-lightpurple.active,.btn-lightpurple.focus,.btn-lightpurple:focus,.btn-lightpurple:hover{color:#fff;background:#f1eef9;border-color:#f1eef9}.btn-lightpurple.active,.btn-lightpurple.active:focus,.btn-lightpurple.active:hover,.btn-lightpurple:active,.btn-lightpurple[aria-expanded=true],.btn-lightpurple[aria-expanded=true]:focus,.btn-lightpurple[aria-expanded=true]:hover,.open>.btn-lightpurple.dropdown-toggle{color:#fff;background:#9c86d2;border-color:#7859c2;background-image:none}.btn-lightpurple.dropdown-toggle+ul li.active a{color:#fff;background:#d3c9eb}.btn-lightpurple.disabled,.btn-lightpurple[disabled],fieldset[disabled] .btn-lightpurple{pointer-events:none}.btn-lightpurple .badge{color:#d3c9eb;background-color:#d3c9eb}.menu-lightpurple ul li.active a,.menu-lightpurple ul li.active a:hover{color:#fff;background:#d3c9eb!important}.nav-lightpurple>li.active>a,.nav-lightpurple>rubix-menu>li.active>a,.nav-lightpurple>rubix-nav-item>li.active>a{color:#fff;background:#d3c9eb;border-color:#d3c9eb}.tab-lightpurple{border-color:#d3c9eb}.tab-lightpurple>li.active>a{border-color:#d3c9eb;border-bottom-color:transparent}.tab-lightpurple.nav-pills>li.active>a{background:#d3c9eb;color:#fff}.rubix-panel-header.nav-inline .nav-lightpurple>li.active>a{border:1px solid #d3c9eb;border-bottom:none}.rubix-panel-header.nav-inline .nav-lightpurple>li.open>.dropdown-toggle{color:#fff;background:none}.bg-lightpurple{background:#d3c9eb!important}.bg-lightpurple table td,.bg-lightpurple th{border-color:rgba(0,0,0,.05)!important}.bg-focus-lightpurple:focus,.bg-hover-lightpurple:hover{background:#d3c9eb!important}.fg-lightpurple,.fg-lightpurple .nav-tabs>li.active>a{color:#d3c9eb}.fg-tab-active-lightpurple .nav-tabs>li.active>a{color:#d3c9eb!important}.fg-focus-lightpurple:focus,.fg-hover-lightpurple:hover{color:#d3c9eb}.border-lightpurple{border-color:#d3c9eb!important}.border-lightpurple .rubix-timeline-body>ul,.border-lightpurple.rubix-timeline-view:before{border-color:#d3c9eb}.border-focus-lightpurple:focus,.border-hover-lightpurple:hover{border-color:#d3c9eb!important}.tl-lightpurple .rubix-timeline-body>ul>li:before{border-color:#d3c9eb}.list-bg-lightpurple>.list-group-item.active{background:#d3c9eb!important;color:#fff!important}.list-fg-lightpurple>.list-group-item{color:#d3c9eb}.btn-darkbrown{background:#ab4f45;color:#fff;border-color:#ab4f45}.btn-darkbrown.btn-outlined{color:#ab4f45;background:none}.btn-darkbrown.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkbrown.btn-outlined.btn-onlyOnHover.active,.btn-darkbrown.btn-outlined.btn-onlyOnHover:focus,.btn-darkbrown.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkbrown.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkbrown.btn-outlined.btn-inverse.active,.btn-darkbrown.btn-outlined.btn-inverse:focus,.btn-darkbrown.btn-outlined.btn-inverse:hover{color:#ab4f45;background:#fff}.btn-darkbrown.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkbrown.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkbrown.btn-outlined.btn-inverse:hover.btn-retainBg{background:#ab4f45;color:#fff;border-color:#ab4f45}.btn-darkbrown.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkbrown.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkbrown.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#6a312b;border-color:#3e1d19}.btn-darkbrown.active,.btn-darkbrown.focus,.btn-darkbrown:focus,.btn-darkbrown:hover{color:#fff;background:#c06c63;border-color:#c06c63}.btn-darkbrown.active,.btn-darkbrown.active:focus,.btn-darkbrown.active:hover,.btn-darkbrown:active,.btn-darkbrown[aria-expanded=true],.btn-darkbrown[aria-expanded=true]:focus,.btn-darkbrown[aria-expanded=true]:hover,.open>.btn-darkbrown.dropdown-toggle{color:#fff;background:#6a312b;border-color:#3e1d19;background-image:none}.btn-darkbrown.dropdown-toggle+ul li.active a{color:#fff;background:#ab4f45}.btn-darkbrown.disabled,.btn-darkbrown[disabled],fieldset[disabled] .btn-darkbrown{pointer-events:none}.btn-darkbrown .badge{color:#ab4f45;background-color:#ab4f45}.menu-darkbrown ul li.active a,.menu-darkbrown ul li.active a:hover{color:#fff;background:#ab4f45!important}.nav-darkbrown>li.active>a,.nav-darkbrown>rubix-menu>li.active>a,.nav-darkbrown>rubix-nav-item>li.active>a{color:#fff;background:#ab4f45;border-color:#ab4f45}.tab-darkbrown{border-color:#ab4f45}.tab-darkbrown>li.active>a{border-color:#ab4f45;border-bottom-color:transparent}.tab-darkbrown.nav-pills>li.active>a{background:#ab4f45;color:#fff}.rubix-panel-header.nav-inline .nav-darkbrown>li.active>a{border:1px solid #ab4f45;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkbrown>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkbrown{background:#ab4f45!important}.bg-darkbrown table td,.bg-darkbrown th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkbrown:focus,.bg-hover-darkbrown:hover{background:#ab4f45!important}.fg-darkbrown,.fg-darkbrown .nav-tabs>li.active>a{color:#ab4f45}.fg-tab-active-darkbrown .nav-tabs>li.active>a{color:#ab4f45!important}.fg-focus-darkbrown:focus,.fg-hover-darkbrown:hover{color:#ab4f45}.border-darkbrown{border-color:#ab4f45!important}.border-darkbrown .rubix-timeline-body>ul,.border-darkbrown.rubix-timeline-view:before{border-color:#ab4f45}.border-focus-darkbrown:focus,.border-hover-darkbrown:hover{border-color:#ab4f45!important}.tl-darkbrown .rubix-timeline-body>ul>li:before{border-color:#ab4f45}.list-bg-darkbrown>.list-group-item.active{background:#ab4f45!important;color:#fff!important}.list-fg-darkbrown>.list-group-item{color:#ab4f45}.btn-brown{background:#a8553a;color:#fff;border-color:#a8553a}.btn-brown.btn-outlined{color:#a8553a;background:none}.btn-brown.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-brown.btn-outlined.btn-onlyOnHover.active,.btn-brown.btn-outlined.btn-onlyOnHover:focus,.btn-brown.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-brown.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-brown.btn-outlined.btn-inverse.active,.btn-brown.btn-outlined.btn-inverse:focus,.btn-brown.btn-outlined.btn-inverse:hover{color:#a8553a;background:#fff}.btn-brown.btn-outlined.btn-inverse.active.btn-retainBg,.btn-brown.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-brown.btn-outlined.btn-inverse:hover.btn-retainBg{background:#a8553a;color:#fff;border-color:#a8553a}.btn-brown.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-brown.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-brown.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#643222;border-color:#361b13}.btn-brown.active,.btn-brown.focus,.btn-brown:focus,.btn-brown:hover{color:#fff;background:#c36e52;border-color:#c36e52}.btn-brown.active,.btn-brown.active:focus,.btn-brown.active:hover,.btn-brown:active,.btn-brown[aria-expanded=true],.btn-brown[aria-expanded=true]:focus,.btn-brown[aria-expanded=true]:hover,.open>.btn-brown.dropdown-toggle{color:#fff;background:#643222;border-color:#361b13;background-image:none}.btn-brown.dropdown-toggle+ul li.active a{color:#fff;background:#a8553a}.btn-brown.disabled,.btn-brown[disabled],fieldset[disabled] .btn-brown{pointer-events:none}.btn-brown .badge{color:#a8553a;background-color:#a8553a}.menu-brown ul li.active a,.menu-brown ul li.active a:hover{color:#fff;background:#a8553a!important}.nav-brown>li.active>a,.nav-brown>rubix-menu>li.active>a,.nav-brown>rubix-nav-item>li.active>a{color:#fff;background:#a8553a;border-color:#a8553a}.tab-brown{border-color:#a8553a}.tab-brown>li.active>a{border-color:#a8553a;border-bottom-color:transparent}.tab-brown.nav-pills>li.active>a{background:#a8553a;color:#fff}.rubix-panel-header.nav-inline .nav-brown>li.active>a{border:1px solid #a8553a;border-bottom:none}.rubix-panel-header.nav-inline .nav-brown>li.open>.dropdown-toggle{color:#fff;background:none}.bg-brown{background:#a8553a!important}.bg-brown table td,.bg-brown th{border-color:rgba(0,0,0,.05)!important}.bg-focus-brown:focus,.bg-hover-brown:hover{background:#a8553a!important}.fg-brown,.fg-brown .nav-tabs>li.active>a{color:#a8553a}.fg-tab-active-brown .nav-tabs>li.active>a{color:#a8553a!important}.fg-focus-brown:focus,.fg-hover-brown:hover{color:#a8553a}.border-brown{border-color:#a8553a!important}.border-brown .rubix-timeline-body>ul,.border-brown.rubix-timeline-view:before{border-color:#a8553a}.border-focus-brown:focus,.border-hover-brown:hover{border-color:#a8553a!important}.tl-brown .rubix-timeline-body>ul>li:before{border-color:#a8553a}.list-bg-brown>.list-group-item.active{background:#a8553a!important;color:#fff!important}.list-fg-brown>.list-group-item{color:#a8553a}.btn-brown75{background:#c36849;color:#fff;border-color:#c36849}.btn-brown75.btn-outlined{color:#c36849;background:none}.btn-brown75.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-brown75.btn-outlined.btn-onlyOnHover.active,.btn-brown75.btn-outlined.btn-onlyOnHover:focus,.btn-brown75.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-brown75.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-brown75.btn-outlined.btn-inverse.active,.btn-brown75.btn-outlined.btn-inverse:focus,.btn-brown75.btn-outlined.btn-inverse:hover{color:#c36849;background:#fff}.btn-brown75.btn-outlined.btn-inverse.active.btn-retainBg,.btn-brown75.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-brown75.btn-outlined.btn-inverse:hover.btn-retainBg{background:#c36849;color:#fff;border-color:#c36849}.btn-brown75.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-brown75.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-brown75.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#85422c;border-color:#562b1d}.btn-brown75.active,.btn-brown75.focus,.btn-brown75:focus,.btn-brown75:hover{color:#fff;background:#d0886f;border-color:#d0886f}.btn-brown75.active,.btn-brown75.active:focus,.btn-brown75.active:hover,.btn-brown75:active,.btn-brown75[aria-expanded=true],.btn-brown75[aria-expanded=true]:focus,.btn-brown75[aria-expanded=true]:hover,.open>.btn-brown75.dropdown-toggle{color:#fff;background:#85422c;border-color:#562b1d;background-image:none}.btn-brown75.dropdown-toggle+ul li.active a{color:#fff;background:#c36849}.btn-brown75.disabled,.btn-brown75[disabled],fieldset[disabled] .btn-brown75{pointer-events:none}.btn-brown75 .badge{color:#c36849;background-color:#c36849}.menu-brown75 ul li.active a,.menu-brown75 ul li.active a:hover{color:#fff;background:#c36849!important}.nav-brown75>li.active>a,.nav-brown75>rubix-menu>li.active>a,.nav-brown75>rubix-nav-item>li.active>a{color:#fff;background:#c36849;border-color:#c36849}.tab-brown75{border-color:#c36849}.tab-brown75>li.active>a{border-color:#c36849;border-bottom-color:transparent}.tab-brown75.nav-pills>li.active>a{background:#c36849;color:#fff}.rubix-panel-header.nav-inline .nav-brown75>li.active>a{border:1px solid #c36849;border-bottom:none}.rubix-panel-header.nav-inline .nav-brown75>li.open>.dropdown-toggle{color:#fff;background:none}.bg-brown75{background:#c36849!important}.bg-brown75 table td,.bg-brown75 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-brown75:focus,.bg-hover-brown75:hover{background:#c36849!important}.fg-brown75,.fg-brown75 .nav-tabs>li.active>a{color:#c36849}.fg-tab-active-brown75 .nav-tabs>li.active>a{color:#c36849!important}.fg-focus-brown75:focus,.fg-hover-brown75:hover{color:#c36849}.border-brown75{border-color:#c36849!important}.border-brown75 .rubix-timeline-body>ul,.border-brown75.rubix-timeline-view:before{border-color:#c36849}.border-focus-brown75:focus,.border-hover-brown75:hover{border-color:#c36849!important}.tl-brown75 .rubix-timeline-body>ul>li:before{border-color:#c36849}.list-bg-brown75>.list-group-item.active{background:#c36849!important;color:#fff!important}.list-fg-brown75>.list-group-item{color:#c36849}.btn-brown60{background:#c67055;color:#fff;border-color:#c67055}.btn-brown60.btn-outlined{color:#c67055;background:none}.btn-brown60.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-brown60.btn-outlined.btn-onlyOnHover.active,.btn-brown60.btn-outlined.btn-onlyOnHover:focus,.btn-brown60.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-brown60.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-brown60.btn-outlined.btn-inverse.active,.btn-brown60.btn-outlined.btn-inverse:focus,.btn-brown60.btn-outlined.btn-inverse:hover{color:#c67055;background:#fff}.btn-brown60.btn-outlined.btn-inverse.active.btn-retainBg,.btn-brown60.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-brown60.btn-outlined.btn-inverse:hover.btn-retainBg{background:#c67055;color:#fff;border-color:#c67055}.btn-brown60.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-brown60.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-brown60.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#8f4730;border-color:#613021}.btn-brown60.active,.btn-brown60.focus,.btn-brown60:focus,.btn-brown60:hover{color:#fff;background:#d3907b;border-color:#d3907b}.btn-brown60.active,.btn-brown60.active:focus,.btn-brown60.active:hover,.btn-brown60:active,.btn-brown60[aria-expanded=true],.btn-brown60[aria-expanded=true]:focus,.btn-brown60[aria-expanded=true]:hover,.open>.btn-brown60.dropdown-toggle{color:#fff;background:#8f4730;border-color:#613021;background-image:none}.btn-brown60.dropdown-toggle+ul li.active a{color:#fff;background:#c67055}.btn-brown60.disabled,.btn-brown60[disabled],fieldset[disabled] .btn-brown60{pointer-events:none}.btn-brown60 .badge{color:#c67055;background-color:#c67055}.menu-brown60 ul li.active a,.menu-brown60 ul li.active a:hover{color:#fff;background:#c67055!important}.nav-brown60>li.active>a,.nav-brown60>rubix-menu>li.active>a,.nav-brown60>rubix-nav-item>li.active>a{color:#fff;background:#c67055;border-color:#c67055}.tab-brown60{border-color:#c67055}.tab-brown60>li.active>a{border-color:#c67055;border-bottom-color:transparent}.tab-brown60.nav-pills>li.active>a{background:#c67055;color:#fff}.rubix-panel-header.nav-inline .nav-brown60>li.active>a{border:1px solid #c67055;border-bottom:none}.rubix-panel-header.nav-inline .nav-brown60>li.open>.dropdown-toggle{color:#fff;background:none}.bg-brown60{background:#c67055!important}.bg-brown60 table td,.bg-brown60 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-brown60:focus,.bg-hover-brown60:hover{background:#c67055!important}.fg-brown60,.fg-brown60 .nav-tabs>li.active>a{color:#c67055}.fg-tab-active-brown60 .nav-tabs>li.active>a{color:#c67055!important}.fg-focus-brown60:focus,.fg-hover-brown60:hover{color:#c67055}.border-brown60{border-color:#c67055!important}.border-brown60 .rubix-timeline-body>ul,.border-brown60.rubix-timeline-view:before{border-color:#c67055}.border-focus-brown60:focus,.border-hover-brown60:hover{border-color:#c67055!important}.tl-brown60 .rubix-timeline-body>ul>li:before{border-color:#c67055}.list-bg-brown60>.list-group-item.active{background:#c67055!important;color:#fff!important}.list-fg-brown60>.list-group-item{color:#c67055}.btn-brown50{background:#d67f6b;color:#fff;border-color:#d67f6b}.btn-brown50.btn-outlined{color:#d67f6b;background:none}.btn-brown50.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-brown50.btn-outlined.btn-onlyOnHover.active,.btn-brown50.btn-outlined.btn-onlyOnHover:focus,.btn-brown50.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-brown50.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-brown50.btn-outlined.btn-inverse.active,.btn-brown50.btn-outlined.btn-inverse:focus,.btn-brown50.btn-outlined.btn-inverse:hover{color:#d67f6b;background:#fff}.btn-brown50.btn-outlined.btn-inverse.active.btn-retainBg,.btn-brown50.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-brown50.btn-outlined.btn-inverse:hover.btn-retainBg{background:#d67f6b;color:#fff;border-color:#d67f6b}.btn-brown50.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-brown50.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-brown50.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#b34a32;border-color:#843624}.btn-brown50.active,.btn-brown50.focus,.btn-brown50:focus,.btn-brown50:hover{color:#fff;background:#e1a293;border-color:#e1a293}.btn-brown50.active,.btn-brown50.active:focus,.btn-brown50.active:hover,.btn-brown50:active,.btn-brown50[aria-expanded=true],.btn-brown50[aria-expanded=true]:focus,.btn-brown50[aria-expanded=true]:hover,.open>.btn-brown50.dropdown-toggle{color:#fff;background:#b34a32;border-color:#843624;background-image:none}.btn-brown50.dropdown-toggle+ul li.active a{color:#fff;background:#d67f6b}.btn-brown50.disabled,.btn-brown50[disabled],fieldset[disabled] .btn-brown50{pointer-events:none}.btn-brown50 .badge{color:#d67f6b;background-color:#d67f6b}.menu-brown50 ul li.active a,.menu-brown50 ul li.active a:hover{color:#fff;background:#d67f6b!important}.nav-brown50>li.active>a,.nav-brown50>rubix-menu>li.active>a,.nav-brown50>rubix-nav-item>li.active>a{color:#fff;background:#d67f6b;border-color:#d67f6b}.tab-brown50{border-color:#d67f6b}.tab-brown50>li.active>a{border-color:#d67f6b;border-bottom-color:transparent}.tab-brown50.nav-pills>li.active>a{background:#d67f6b;color:#fff}.rubix-panel-header.nav-inline .nav-brown50>li.active>a{border:1px solid #d67f6b;border-bottom:none}.rubix-panel-header.nav-inline .nav-brown50>li.open>.dropdown-toggle{color:#fff;background:none}.bg-brown50{background:#d67f6b!important}.bg-brown50 table td,.bg-brown50 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-brown50:focus,.bg-hover-brown50:hover{background:#d67f6b!important}.fg-brown50,.fg-brown50 .nav-tabs>li.active>a{color:#d67f6b}.fg-tab-active-brown50 .nav-tabs>li.active>a{color:#d67f6b!important}.fg-focus-brown50:focus,.fg-hover-brown50:hover{color:#d67f6b}.border-brown50{border-color:#d67f6b!important}.border-brown50 .rubix-timeline-body>ul,.border-brown50.rubix-timeline-view:before{border-color:#d67f6b}.border-focus-brown50:focus,.border-hover-brown50:hover{border-color:#d67f6b!important}.tl-brown50 .rubix-timeline-body>ul>li:before{border-color:#d67f6b}.list-bg-brown50>.list-group-item.active{background:#d67f6b!important;color:#fff!important}.list-fg-brown50>.list-group-item{color:#d67f6b}.btn-brownishgreen{background:#948266;color:#fff;border-color:#948266}.btn-brownishgreen.btn-outlined{color:#948266;background:none}.btn-brownishgreen.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-brownishgreen.btn-outlined.btn-onlyOnHover.active,.btn-brownishgreen.btn-outlined.btn-onlyOnHover:focus,.btn-brownishgreen.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-brownishgreen.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-brownishgreen.btn-outlined.btn-inverse.active,.btn-brownishgreen.btn-outlined.btn-inverse:focus,.btn-brownishgreen.btn-outlined.btn-inverse:hover{color:#948266;background:#fff}.btn-brownishgreen.btn-outlined.btn-inverse.active.btn-retainBg,.btn-brownishgreen.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-brownishgreen.btn-outlined.btn-inverse:hover.btn-retainBg{background:#948266;color:#fff;border-color:#948266}.btn-brownishgreen.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-brownishgreen.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-brownishgreen.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#5e5241;border-color:#393228}.btn-brownishgreen.active,.btn-brownishgreen.focus,.btn-brownishgreen:focus,.btn-brownishgreen:hover{color:#fff;background:#aa9b83;border-color:#aa9b83}.btn-brownishgreen.active,.btn-brownishgreen.active:focus,.btn-brownishgreen.active:hover,.btn-brownishgreen:active,.btn-brownishgreen[aria-expanded=true],.btn-brownishgreen[aria-expanded=true]:focus,.btn-brownishgreen[aria-expanded=true]:hover,.open>.btn-brownishgreen.dropdown-toggle{color:#fff;background:#5e5241;border-color:#393228;background-image:none}.btn-brownishgreen.dropdown-toggle+ul li.active a{color:#fff;background:#948266}.btn-brownishgreen.disabled,.btn-brownishgreen[disabled],fieldset[disabled] .btn-brownishgreen{pointer-events:none}.btn-brownishgreen .badge{color:#948266;background-color:#948266}.menu-brownishgreen ul li.active a,.menu-brownishgreen ul li.active a:hover{color:#fff;background:#948266!important}.nav-brownishgreen>li.active>a,.nav-brownishgreen>rubix-menu>li.active>a,.nav-brownishgreen>rubix-nav-item>li.active>a{color:#fff;background:#948266;border-color:#948266}.tab-brownishgreen{border-color:#948266}.tab-brownishgreen>li.active>a{border-color:#948266;border-bottom-color:transparent}.tab-brownishgreen.nav-pills>li.active>a{background:#948266;color:#fff}.rubix-panel-header.nav-inline .nav-brownishgreen>li.active>a{border:1px solid #948266;border-bottom:none}.rubix-panel-header.nav-inline .nav-brownishgreen>li.open>.dropdown-toggle{color:#fff;background:none}.bg-brownishgreen{background:#948266!important}.bg-brownishgreen table td,.bg-brownishgreen th{border-color:rgba(0,0,0,.05)!important}.bg-focus-brownishgreen:focus,.bg-hover-brownishgreen:hover{background:#948266!important}.fg-brownishgreen,.fg-brownishgreen .nav-tabs>li.active>a{color:#948266}.fg-tab-active-brownishgreen .nav-tabs>li.active>a{color:#948266!important}.fg-focus-brownishgreen:focus,.fg-hover-brownishgreen:hover{color:#948266}.border-brownishgreen{border-color:#948266!important}.border-brownishgreen .rubix-timeline-body>ul,.border-brownishgreen.rubix-timeline-view:before{border-color:#948266}.border-focus-brownishgreen:focus,.border-hover-brownishgreen:hover{border-color:#948266!important}.tl-brownishgreen .rubix-timeline-body>ul>li:before{border-color:#948266}.list-bg-brownishgreen>.list-group-item.active{background:#948266!important;color:#fff!important}.list-fg-brownishgreen>.list-group-item{color:#948266}.btn-orange{background:#ffc497;color:#fff;border-color:#ffc497}.btn-orange.btn-outlined{color:#ffc497;background:none}.btn-orange.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-orange.btn-outlined.btn-onlyOnHover.active,.btn-orange.btn-outlined.btn-onlyOnHover:focus,.btn-orange.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-orange.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-orange.btn-outlined.btn-inverse.active,.btn-orange.btn-outlined.btn-inverse:focus,.btn-orange.btn-outlined.btn-inverse:hover{color:#ffc497;background:#fff}.btn-orange.btn-outlined.btn-inverse.active.btn-retainBg,.btn-orange.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-orange.btn-outlined.btn-inverse:hover.btn-retainBg{background:#ffc497;color:#fff;border-color:#ffc497}.btn-orange.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-orange.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-orange.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#ff903b;border-color:#fd6d00}.btn-orange.active,.btn-orange.focus,.btn-orange:focus,.btn-orange:hover{color:#fff;background:#ffe1ca;border-color:#ffe1ca}.btn-orange.active,.btn-orange.active:focus,.btn-orange.active:hover,.btn-orange:active,.btn-orange[aria-expanded=true],.btn-orange[aria-expanded=true]:focus,.btn-orange[aria-expanded=true]:hover,.open>.btn-orange.dropdown-toggle{color:#fff;background:#ff903b;border-color:#fd6d00;background-image:none}.btn-orange.dropdown-toggle+ul li.active a{color:#fff;background:#ffc497}.btn-orange.disabled,.btn-orange[disabled],fieldset[disabled] .btn-orange{pointer-events:none}.btn-orange .badge{color:#ffc497;background-color:#ffc497}.menu-orange ul li.active a,.menu-orange ul li.active a:hover{color:#fff;background:#ffc497!important}.nav-orange>li.active>a,.nav-orange>rubix-menu>li.active>a,.nav-orange>rubix-nav-item>li.active>a{color:#fff;background:#ffc497;border-color:#ffc497}.tab-orange{border-color:#ffc497}.tab-orange>li.active>a{border-color:#ffc497;border-bottom-color:transparent}.tab-orange.nav-pills>li.active>a{background:#ffc497;color:#fff}.rubix-panel-header.nav-inline .nav-orange>li.active>a{border:1px solid #ffc497;border-bottom:none}.rubix-panel-header.nav-inline .nav-orange>li.open>.dropdown-toggle{color:#fff;background:none}.bg-orange{background:#ffc497!important}.bg-orange table td,.bg-orange th{border-color:rgba(0,0,0,.05)!important}.bg-focus-orange:focus,.bg-hover-orange:hover{background:#ffc497!important}.fg-orange,.fg-orange .nav-tabs>li.active>a{color:#ffc497}.fg-tab-active-orange .nav-tabs>li.active>a{color:#ffc497!important}.fg-focus-orange:focus,.fg-hover-orange:hover{color:#ffc497}.border-orange{border-color:#ffc497!important}.border-orange .rubix-timeline-body>ul,.border-orange.rubix-timeline-view:before{border-color:#ffc497}.border-focus-orange:focus,.border-hover-orange:hover{border-color:#ffc497!important}.tl-orange .rubix-timeline-body>ul>li:before{border-color:#ffc497}.list-bg-orange>.list-group-item.active{background:#ffc497!important;color:#fff!important}.list-fg-orange>.list-group-item{color:#ffc497}.btn-paleorange{background:#ea8564;color:#fff;border-color:#ea8564}.btn-paleorange.btn-outlined{color:#ea8564;background:none}.btn-paleorange.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-paleorange.btn-outlined.btn-onlyOnHover.active,.btn-paleorange.btn-outlined.btn-onlyOnHover:focus,.btn-paleorange.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-paleorange.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-paleorange.btn-outlined.btn-inverse.active,.btn-paleorange.btn-outlined.btn-inverse:focus,.btn-paleorange.btn-outlined.btn-inverse:hover{color:#ea8564;background:#fff}.btn-paleorange.btn-outlined.btn-inverse.active.btn-retainBg,.btn-paleorange.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-paleorange.btn-outlined.btn-inverse:hover.btn-retainBg{background:#ea8564;color:#fff;border-color:#ea8564}.btn-paleorange.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-paleorange.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-paleorange.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#d54a1d;border-color:#9f3816}.btn-paleorange.active,.btn-paleorange.focus,.btn-paleorange:focus,.btn-paleorange:hover{color:#fff;background:#f0a891;border-color:#f0a891}.btn-paleorange.active,.btn-paleorange.active:focus,.btn-paleorange.active:hover,.btn-paleorange:active,.btn-paleorange[aria-expanded=true],.btn-paleorange[aria-expanded=true]:focus,.btn-paleorange[aria-expanded=true]:hover,.open>.btn-paleorange.dropdown-toggle{color:#fff;background:#d54a1d;border-color:#9f3816;background-image:none}.btn-paleorange.dropdown-toggle+ul li.active a{color:#fff;background:#ea8564}.btn-paleorange.disabled,.btn-paleorange[disabled],fieldset[disabled] .btn-paleorange{pointer-events:none}.btn-paleorange .badge{color:#ea8564;background-color:#ea8564}.menu-paleorange ul li.active a,.menu-paleorange ul li.active a:hover{color:#fff;background:#ea8564!important}.nav-paleorange>li.active>a,.nav-paleorange>rubix-menu>li.active>a,.nav-paleorange>rubix-nav-item>li.active>a{color:#fff;background:#ea8564;border-color:#ea8564}.tab-paleorange{border-color:#ea8564}.tab-paleorange>li.active>a{border-color:#ea8564;border-bottom-color:transparent}.tab-paleorange.nav-pills>li.active>a{background:#ea8564;color:#fff}.rubix-panel-header.nav-inline .nav-paleorange>li.active>a{border:1px solid #ea8564;border-bottom:none}.rubix-panel-header.nav-inline .nav-paleorange>li.open>.dropdown-toggle{color:#fff;background:none}.bg-paleorange{background:#ea8564!important}.bg-paleorange table td,.bg-paleorange th{border-color:rgba(0,0,0,.05)!important}.bg-focus-paleorange:focus,.bg-hover-paleorange:hover{background:#ea8564!important}.fg-paleorange,.fg-paleorange .nav-tabs>li.active>a{color:#ea8564}.fg-tab-active-paleorange .nav-tabs>li.active>a{color:#ea8564!important}.fg-focus-paleorange:focus,.fg-hover-paleorange:hover{color:#ea8564}.border-paleorange{border-color:#ea8564!important}.border-paleorange .rubix-timeline-body>ul,.border-paleorange.rubix-timeline-view:before{border-color:#ea8564}.border-focus-paleorange:focus,.border-hover-paleorange:hover{border-color:#ea8564!important}.tl-paleorange .rubix-timeline-body>ul>li:before{border-color:#ea8564}.list-bg-paleorange>.list-group-item.active{background:#ea8564!important;color:#fff!important}.list-fg-paleorange>.list-group-item{color:#ea8564}.btn-pinkishred{background:#ef6b5d;color:#fff;border-color:#ef6b5d}.btn-pinkishred.btn-outlined{color:#ef6b5d;background:none}.btn-pinkishred.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-pinkishred.btn-outlined.btn-onlyOnHover.active,.btn-pinkishred.btn-outlined.btn-onlyOnHover:focus,.btn-pinkishred.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-pinkishred.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-pinkishred.btn-outlined.btn-inverse.active,.btn-pinkishred.btn-outlined.btn-inverse:focus,.btn-pinkishred.btn-outlined.btn-inverse:hover{color:#ef6b5d;background:#fff}.btn-pinkishred.btn-outlined.btn-inverse.active.btn-retainBg,.btn-pinkishred.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-pinkishred.btn-outlined.btn-inverse:hover.btn-retainBg{background:#ef6b5d;color:#fff;border-color:#ef6b5d}.btn-pinkishred.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-pinkishred.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-pinkishred.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#db2816;border-color:#a31e10}.btn-pinkishred.active,.btn-pinkishred.focus,.btn-pinkishred:focus,.btn-pinkishred:hover{color:#fff;background:#f4958b;border-color:#f4958b}.btn-pinkishred.active,.btn-pinkishred.active:focus,.btn-pinkishred.active:hover,.btn-pinkishred:active,.btn-pinkishred[aria-expanded=true],.btn-pinkishred[aria-expanded=true]:focus,.btn-pinkishred[aria-expanded=true]:hover,.open>.btn-pinkishred.dropdown-toggle{color:#fff;background:#db2816;border-color:#a31e10;background-image:none}.btn-pinkishred.dropdown-toggle+ul li.active a{color:#fff;background:#ef6b5d}.btn-pinkishred.disabled,.btn-pinkishred[disabled],fieldset[disabled] .btn-pinkishred{pointer-events:none}.btn-pinkishred .badge{color:#ef6b5d;background-color:#ef6b5d}.menu-pinkishred ul li.active a,.menu-pinkishred ul li.active a:hover{color:#fff;background:#ef6b5d!important}.nav-pinkishred>li.active>a,.nav-pinkishred>rubix-menu>li.active>a,.nav-pinkishred>rubix-nav-item>li.active>a{color:#fff;background:#ef6b5d;border-color:#ef6b5d}.tab-pinkishred{border-color:#ef6b5d}.tab-pinkishred>li.active>a{border-color:#ef6b5d;border-bottom-color:transparent}.tab-pinkishred.nav-pills>li.active>a{background:#ef6b5d;color:#fff}.rubix-panel-header.nav-inline .nav-pinkishred>li.active>a{border:1px solid #ef6b5d;border-bottom:none}.rubix-panel-header.nav-inline .nav-pinkishred>li.open>.dropdown-toggle{color:#fff;background:none}.bg-pinkishred{background:#ef6b5d!important}.bg-pinkishred table td,.bg-pinkishred th{border-color:rgba(0,0,0,.05)!important}.bg-focus-pinkishred:focus,.bg-hover-pinkishred:hover{background:#ef6b5d!important}.fg-pinkishred,.fg-pinkishred .nav-tabs>li.active>a{color:#ef6b5d}.fg-tab-active-pinkishred .nav-tabs>li.active>a{color:#ef6b5d!important}.fg-focus-pinkishred:focus,.fg-hover-pinkishred:hover{color:#ef6b5d}.border-pinkishred{border-color:#ef6b5d!important}.border-pinkishred .rubix-timeline-body>ul,.border-pinkishred.rubix-timeline-view:before{border-color:#ef6b5d}.border-focus-pinkishred:focus,.border-hover-pinkishred:hover{border-color:#ef6b5d!important}.tl-pinkishred .rubix-timeline-body>ul>li:before{border-color:#ef6b5d}.list-bg-pinkishred>.list-group-item.active{background:#ef6b5d!important;color:#fff!important}.list-fg-pinkishred>.list-group-item{color:#ef6b5d}.btn-orange75{background:#ee682f;color:#fff;border-color:#ee682f}.btn-orange75.btn-outlined{color:#ee682f;background:none}.btn-orange75.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-orange75.btn-outlined.btn-onlyOnHover.active,.btn-orange75.btn-outlined.btn-onlyOnHover:focus,.btn-orange75.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-orange75.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-orange75.btn-outlined.btn-inverse.active,.btn-orange75.btn-outlined.btn-inverse:focus,.btn-orange75.btn-outlined.btn-inverse:hover{color:#ee682f;background:#fff}.btn-orange75.btn-outlined.btn-inverse.active.btn-retainBg,.btn-orange75.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-orange75.btn-outlined.btn-inverse:hover.btn-retainBg{background:#ee682f;color:#fff;border-color:#ee682f}.btn-orange75.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-orange75.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-orange75.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#b3400f;border-color:#7a2b0a}.btn-orange75.active,.btn-orange75.focus,.btn-orange75:focus,.btn-orange75:hover{color:#fff;background:#f28a5e;border-color:#f28a5e}.btn-orange75.active,.btn-orange75.active:focus,.btn-orange75.active:hover,.btn-orange75:active,.btn-orange75[aria-expanded=true],.btn-orange75[aria-expanded=true]:focus,.btn-orange75[aria-expanded=true]:hover,.open>.btn-orange75.dropdown-toggle{color:#fff;background:#b3400f;border-color:#7a2b0a;background-image:none}.btn-orange75.dropdown-toggle+ul li.active a{color:#fff;background:#ee682f}.btn-orange75.disabled,.btn-orange75[disabled],fieldset[disabled] .btn-orange75{pointer-events:none}.btn-orange75 .badge{color:#ee682f;background-color:#ee682f}.menu-orange75 ul li.active a,.menu-orange75 ul li.active a:hover{color:#fff;background:#ee682f!important}.nav-orange75>li.active>a,.nav-orange75>rubix-menu>li.active>a,.nav-orange75>rubix-nav-item>li.active>a{color:#fff;background:#ee682f;border-color:#ee682f}.tab-orange75{border-color:#ee682f}.tab-orange75>li.active>a{border-color:#ee682f;border-bottom-color:transparent}.tab-orange75.nav-pills>li.active>a{background:#ee682f;color:#fff}.rubix-panel-header.nav-inline .nav-orange75>li.active>a{border:1px solid #ee682f;border-bottom:none}.rubix-panel-header.nav-inline .nav-orange75>li.open>.dropdown-toggle{color:#fff;background:none}.bg-orange75{background:#ee682f!important}.bg-orange75 table td,.bg-orange75 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-orange75:focus,.bg-hover-orange75:hover{background:#ee682f!important}.fg-orange75,.fg-orange75 .nav-tabs>li.active>a{color:#ee682f}.fg-tab-active-orange75 .nav-tabs>li.active>a{color:#ee682f!important}.fg-focus-orange75:focus,.fg-hover-orange75:hover{color:#ee682f}.border-orange75{border-color:#ee682f!important}.border-orange75 .rubix-timeline-body>ul,.border-orange75.rubix-timeline-view:before{border-color:#ee682f}.border-focus-orange75:focus,.border-hover-orange75:hover{border-color:#ee682f!important}.tl-orange75 .rubix-timeline-body>ul>li:before{border-color:#ee682f}.list-bg-orange75>.list-group-item.active{background:#ee682f!important;color:#fff!important}.list-fg-orange75>.list-group-item{color:#ee682f}.btn-orange65{background:#fa824f;color:#fff;border-color:#fa824f}.btn-orange65.btn-outlined{color:#fa824f;background:none}.btn-orange65.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-orange65.btn-outlined.btn-onlyOnHover.active,.btn-orange65.btn-outlined.btn-onlyOnHover:focus,.btn-orange65.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-orange65.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-orange65.btn-outlined.btn-inverse.active,.btn-orange65.btn-outlined.btn-inverse:focus,.btn-orange65.btn-outlined.btn-inverse:hover{color:#fa824f;background:#fff}.btn-orange65.btn-outlined.btn-inverse.active.btn-retainBg,.btn-orange65.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-orange65.btn-outlined.btn-inverse:hover.btn-retainBg{background:#fa824f;color:#fff;border-color:#fa824f}.btn-orange65.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-orange65.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-orange65.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#e74907;border-color:#ab3605}.btn-orange65.active,.btn-orange65.focus,.btn-orange65:focus,.btn-orange65:hover{color:#fff;background:#fba581;border-color:#fba581}.btn-orange65.active,.btn-orange65.active:focus,.btn-orange65.active:hover,.btn-orange65:active,.btn-orange65[aria-expanded=true],.btn-orange65[aria-expanded=true]:focus,.btn-orange65[aria-expanded=true]:hover,.open>.btn-orange65.dropdown-toggle{color:#fff;background:#e74907;border-color:#ab3605;background-image:none}.btn-orange65.dropdown-toggle+ul li.active a{color:#fff;background:#fa824f}.btn-orange65.disabled,.btn-orange65[disabled],fieldset[disabled] .btn-orange65{pointer-events:none}.btn-orange65 .badge{color:#fa824f;background-color:#fa824f}.menu-orange65 ul li.active a,.menu-orange65 ul li.active a:hover{color:#fff;background:#fa824f!important}.nav-orange65>li.active>a,.nav-orange65>rubix-menu>li.active>a,.nav-orange65>rubix-nav-item>li.active>a{color:#fff;background:#fa824f;border-color:#fa824f}.tab-orange65{border-color:#fa824f}.tab-orange65>li.active>a{border-color:#fa824f;border-bottom-color:transparent}.tab-orange65.nav-pills>li.active>a{background:#fa824f;color:#fff}.rubix-panel-header.nav-inline .nav-orange65>li.active>a{border:1px solid #fa824f;border-bottom:none}.rubix-panel-header.nav-inline .nav-orange65>li.open>.dropdown-toggle{color:#fff;background:none}.bg-orange65{background:#fa824f!important}.bg-orange65 table td,.bg-orange65 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-orange65:focus,.bg-hover-orange65:hover{background:#fa824f!important}.fg-orange65,.fg-orange65 .nav-tabs>li.active>a{color:#fa824f}.fg-tab-active-orange65 .nav-tabs>li.active>a{color:#fa824f!important}.fg-focus-orange65:focus,.fg-hover-orange65:hover{color:#fa824f}.border-orange65{border-color:#fa824f!important}.border-orange65 .rubix-timeline-body>ul,.border-orange65.rubix-timeline-view:before{border-color:#fa824f}.border-focus-orange65:focus,.border-hover-orange65:hover{border-color:#fa824f!important}.tl-orange65 .rubix-timeline-body>ul>li:before{border-color:#fa824f}.list-bg-orange65>.list-group-item.active{background:#fa824f!important;color:#fff!important}.list-fg-orange65>.list-group-item{color:#fa824f}.btn-orange45{background:#ffc9a0;color:#fff;border-color:#ffc9a0}.btn-orange45.btn-outlined{color:#ffc9a0;background:none}.btn-orange45.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-orange45.btn-outlined.btn-onlyOnHover.active,.btn-orange45.btn-outlined.btn-onlyOnHover:focus,.btn-orange45.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-orange45.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-orange45.btn-outlined.btn-inverse.active,.btn-orange45.btn-outlined.btn-inverse:focus,.btn-orange45.btn-outlined.btn-inverse:hover{color:#ffc9a0;background:#fff}.btn-orange45.btn-outlined.btn-inverse.active.btn-retainBg,.btn-orange45.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-orange45.btn-outlined.btn-inverse:hover.btn-retainBg{background:#ffc9a0;color:#fff;border-color:#ffc9a0}.btn-orange45.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-orange45.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-orange45.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#ff9544;border-color:#ff7207}.btn-orange45.active,.btn-orange45.focus,.btn-orange45:focus,.btn-orange45:hover{color:#fff;background:#ffe6d3;border-color:#ffe6d3}.btn-orange45.active,.btn-orange45.active:focus,.btn-orange45.active:hover,.btn-orange45:active,.btn-orange45[aria-expanded=true],.btn-orange45[aria-expanded=true]:focus,.btn-orange45[aria-expanded=true]:hover,.open>.btn-orange45.dropdown-toggle{color:#fff;background:#ff9544;border-color:#ff7207;background-image:none}.btn-orange45.dropdown-toggle+ul li.active a{color:#fff;background:#ffc9a0}.btn-orange45.disabled,.btn-orange45[disabled],fieldset[disabled] .btn-orange45{pointer-events:none}.btn-orange45 .badge{color:#ffc9a0;background-color:#ffc9a0}.menu-orange45 ul li.active a,.menu-orange45 ul li.active a:hover{color:#fff;background:#ffc9a0!important}.nav-orange45>li.active>a,.nav-orange45>rubix-menu>li.active>a,.nav-orange45>rubix-nav-item>li.active>a{color:#fff;background:#ffc9a0;border-color:#ffc9a0}.tab-orange45{border-color:#ffc9a0}.tab-orange45>li.active>a{border-color:#ffc9a0;border-bottom-color:transparent}.tab-orange45.nav-pills>li.active>a{background:#ffc9a0;color:#fff}.rubix-panel-header.nav-inline .nav-orange45>li.active>a{border:1px solid #ffc9a0;border-bottom:none}.rubix-panel-header.nav-inline .nav-orange45>li.open>.dropdown-toggle{color:#fff;background:none}.bg-orange45{background:#ffc9a0!important}.bg-orange45 table td,.bg-orange45 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-orange45:focus,.bg-hover-orange45:hover{background:#ffc9a0!important}.fg-orange45,.fg-orange45 .nav-tabs>li.active>a{color:#ffc9a0}.fg-tab-active-orange45 .nav-tabs>li.active>a{color:#ffc9a0!important}.fg-focus-orange45:focus,.fg-hover-orange45:hover{color:#ffc9a0}.border-orange45{border-color:#ffc9a0!important}.border-orange45 .rubix-timeline-body>ul,.border-orange45.rubix-timeline-view:before{border-color:#ffc9a0}.border-focus-orange45:focus,.border-hover-orange45:hover{border-color:#ffc9a0!important}.tl-orange45 .rubix-timeline-body>ul>li:before{border-color:#ffc9a0}.list-bg-orange45>.list-group-item.active{background:#ffc9a0!important;color:#fff!important}.list-fg-orange45>.list-group-item{color:#ffc9a0}.btn-darkorange{background:#eba068;color:#fff;border-color:#eba068}.btn-darkorange.btn-outlined{color:#eba068;background:none}.btn-darkorange.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkorange.btn-outlined.btn-onlyOnHover.active,.btn-darkorange.btn-outlined.btn-onlyOnHover:focus,.btn-darkorange.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkorange.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkorange.btn-outlined.btn-inverse.active,.btn-darkorange.btn-outlined.btn-inverse:focus,.btn-darkorange.btn-outlined.btn-inverse:hover{color:#eba068;background:#fff}.btn-darkorange.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkorange.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkorange.btn-outlined.btn-inverse:hover.btn-retainBg{background:#eba068;color:#fff;border-color:#eba068}.btn-darkorange.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkorange.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkorange.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#da6e1d;border-color:#a45316}.btn-darkorange.active,.btn-darkorange.focus,.btn-darkorange:focus,.btn-darkorange:hover{color:#fff;background:#f1bc95;border-color:#f1bc95}.btn-darkorange.active,.btn-darkorange.active:focus,.btn-darkorange.active:hover,.btn-darkorange:active,.btn-darkorange[aria-expanded=true],.btn-darkorange[aria-expanded=true]:focus,.btn-darkorange[aria-expanded=true]:hover,.open>.btn-darkorange.dropdown-toggle{color:#fff;background:#da6e1d;border-color:#a45316;background-image:none}.btn-darkorange.dropdown-toggle+ul li.active a{color:#fff;background:#eba068}.btn-darkorange.disabled,.btn-darkorange[disabled],fieldset[disabled] .btn-darkorange{pointer-events:none}.btn-darkorange .badge{color:#eba068;background-color:#eba068}.menu-darkorange ul li.active a,.menu-darkorange ul li.active a:hover{color:#fff;background:#eba068!important}.nav-darkorange>li.active>a,.nav-darkorange>rubix-menu>li.active>a,.nav-darkorange>rubix-nav-item>li.active>a{color:#fff;background:#eba068;border-color:#eba068}.tab-darkorange{border-color:#eba068}.tab-darkorange>li.active>a{border-color:#eba068;border-bottom-color:transparent}.tab-darkorange.nav-pills>li.active>a{background:#eba068;color:#fff}.rubix-panel-header.nav-inline .nav-darkorange>li.active>a{border:1px solid #eba068;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkorange>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkorange{background:#eba068!important}.bg-darkorange table td,.bg-darkorange th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkorange:focus,.bg-hover-darkorange:hover{background:#eba068!important}.fg-darkorange,.fg-darkorange .nav-tabs>li.active>a{color:#eba068}.fg-tab-active-darkorange .nav-tabs>li.active>a{color:#eba068!important}.fg-focus-darkorange:focus,.fg-hover-darkorange:hover{color:#eba068}.border-darkorange{border-color:#eba068!important}.border-darkorange .rubix-timeline-body>ul,.border-darkorange.rubix-timeline-view:before{border-color:#eba068}.border-focus-darkorange:focus,.border-hover-darkorange:hover{border-color:#eba068!important}.tl-darkorange .rubix-timeline-body>ul>li:before{border-color:#eba068}.list-bg-darkorange>.list-group-item.active{background:#eba068!important;color:#fff!important}.list-fg-darkorange>.list-group-item{color:#eba068}.btn-lightorange{background:#ffd3b1;color:#fff;border-color:#ffd3b1}.btn-lightorange.btn-outlined{color:#ffd3b1;background:none}.btn-lightorange.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-lightorange.btn-outlined.btn-onlyOnHover.active,.btn-lightorange.btn-outlined.btn-onlyOnHover:focus,.btn-lightorange.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-lightorange.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-lightorange.btn-outlined.btn-inverse.active,.btn-lightorange.btn-outlined.btn-inverse:focus,.btn-lightorange.btn-outlined.btn-inverse:hover{color:#ffd3b1;background:#fff}.btn-lightorange.btn-outlined.btn-inverse.active.btn-retainBg,.btn-lightorange.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-lightorange.btn-outlined.btn-inverse:hover.btn-retainBg{background:#ffd3b1;color:#fff;border-color:#ffd3b1}.btn-lightorange.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-lightorange.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-lightorange.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#ff9f55;border-color:#ff7d18}.btn-lightorange.active,.btn-lightorange.focus,.btn-lightorange:focus,.btn-lightorange:hover{color:#fff;background:#fff0e4;border-color:#fff0e4}.btn-lightorange.active,.btn-lightorange.active:focus,.btn-lightorange.active:hover,.btn-lightorange:active,.btn-lightorange[aria-expanded=true],.btn-lightorange[aria-expanded=true]:focus,.btn-lightorange[aria-expanded=true]:hover,.open>.btn-lightorange.dropdown-toggle{color:#fff;background:#ff9f55;border-color:#ff7d18;background-image:none}.btn-lightorange.dropdown-toggle+ul li.active a{color:#fff;background:#ffd3b1}.btn-lightorange.disabled,.btn-lightorange[disabled],fieldset[disabled] .btn-lightorange{pointer-events:none}.btn-lightorange .badge{color:#ffd3b1;background-color:#ffd3b1}.menu-lightorange ul li.active a,.menu-lightorange ul li.active a:hover{color:#fff;background:#ffd3b1!important}.nav-lightorange>li.active>a,.nav-lightorange>rubix-menu>li.active>a,.nav-lightorange>rubix-nav-item>li.active>a{color:#fff;background:#ffd3b1;border-color:#ffd3b1}.tab-lightorange{border-color:#ffd3b1}.tab-lightorange>li.active>a{border-color:#ffd3b1;border-bottom-color:transparent}.tab-lightorange.nav-pills>li.active>a{background:#ffd3b1;color:#fff}.rubix-panel-header.nav-inline .nav-lightorange>li.active>a{border:1px solid #ffd3b1;border-bottom:none}.rubix-panel-header.nav-inline .nav-lightorange>li.open>.dropdown-toggle{color:#fff;background:none}.bg-lightorange{background:#ffd3b1!important}.bg-lightorange table td,.bg-lightorange th{border-color:rgba(0,0,0,.05)!important}.bg-focus-lightorange:focus,.bg-hover-lightorange:hover{background:#ffd3b1!important}.fg-lightorange,.fg-lightorange .nav-tabs>li.active>a{color:#ffd3b1}.fg-tab-active-lightorange .nav-tabs>li.active>a{color:#ffd3b1!important}.fg-focus-lightorange:focus,.fg-hover-lightorange:hover{color:#ffd3b1}.border-lightorange{border-color:#ffd3b1!important}.border-lightorange .rubix-timeline-body>ul,.border-lightorange.rubix-timeline-view:before{border-color:#ffd3b1}.border-focus-lightorange:focus,.border-hover-lightorange:hover{border-color:#ffd3b1!important}.tl-lightorange .rubix-timeline-body>ul>li:before{border-color:#ffd3b1}.list-bg-lightorange>.list-group-item.active{background:#ffd3b1!important;color:#fff!important}.list-fg-lightorange>.list-group-item{color:#ffd3b1}.btn-darkgreen{background:#306c67;color:#fff;border-color:#306c67}.btn-darkgreen.btn-outlined{color:#306c67;background:none}.btn-darkgreen.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkgreen.btn-outlined.btn-onlyOnHover.active,.btn-darkgreen.btn-outlined.btn-onlyOnHover:focus,.btn-darkgreen.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkgreen.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkgreen.btn-outlined.btn-inverse.active,.btn-darkgreen.btn-outlined.btn-inverse:focus,.btn-darkgreen.btn-outlined.btn-inverse:hover{color:#306c67;background:#fff}.btn-darkgreen.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkgreen.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkgreen.btn-outlined.btn-inverse:hover.btn-retainBg{background:#306c67;color:#fff;border-color:#306c67}.btn-darkgreen.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkgreen.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkgreen.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#142c2a;border-color:#010202}.btn-darkgreen.active,.btn-darkgreen.focus,.btn-darkgreen:focus,.btn-darkgreen:hover{color:#fff;background:#408f89;border-color:#408f89}.btn-darkgreen.active,.btn-darkgreen.active:focus,.btn-darkgreen.active:hover,.btn-darkgreen:active,.btn-darkgreen[aria-expanded=true],.btn-darkgreen[aria-expanded=true]:focus,.btn-darkgreen[aria-expanded=true]:hover,.open>.btn-darkgreen.dropdown-toggle{color:#fff;background:#142c2a;border-color:#010202;background-image:none}.btn-darkgreen.dropdown-toggle+ul li.active a{color:#fff;background:#306c67}.btn-darkgreen.disabled,.btn-darkgreen[disabled],fieldset[disabled] .btn-darkgreen{pointer-events:none}.btn-darkgreen .badge{color:#306c67;background-color:#306c67}.menu-darkgreen ul li.active a,.menu-darkgreen ul li.active a:hover{color:#fff;background:#306c67!important}.nav-darkgreen>li.active>a,.nav-darkgreen>rubix-menu>li.active>a,.nav-darkgreen>rubix-nav-item>li.active>a{color:#fff;background:#306c67;border-color:#306c67}.tab-darkgreen{border-color:#306c67}.tab-darkgreen>li.active>a{border-color:#306c67;border-bottom-color:transparent}.tab-darkgreen.nav-pills>li.active>a{background:#306c67;color:#fff}.rubix-panel-header.nav-inline .nav-darkgreen>li.active>a{border:1px solid #306c67;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkgreen>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkgreen{background:#306c67!important}.bg-darkgreen table td,.bg-darkgreen th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkgreen:focus,.bg-hover-darkgreen:hover{background:#306c67!important}.fg-darkgreen,.fg-darkgreen .nav-tabs>li.active>a{color:#306c67}.fg-tab-active-darkgreen .nav-tabs>li.active>a{color:#306c67!important}.fg-focus-darkgreen:focus,.fg-hover-darkgreen:hover{color:#306c67}.border-darkgreen{border-color:#306c67!important}.border-darkgreen .rubix-timeline-body>ul,.border-darkgreen.rubix-timeline-view:before{border-color:#306c67}.border-focus-darkgreen:focus,.border-hover-darkgreen:hover{border-color:#306c67!important}.tl-darkgreen .rubix-timeline-body>ul>li:before{border-color:#306c67}.list-bg-darkgreen>.list-group-item.active{background:#306c67!important;color:#fff!important}.list-fg-darkgreen>.list-group-item{color:#306c67}.btn-darkgreen85{background:#36845e;color:#fff;border-color:#36845e}.btn-darkgreen85.btn-outlined{color:#36845e;background:none}.btn-darkgreen85.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkgreen85.btn-outlined.btn-onlyOnHover.active,.btn-darkgreen85.btn-outlined.btn-onlyOnHover:focus,.btn-darkgreen85.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkgreen85.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkgreen85.btn-outlined.btn-inverse.active,.btn-darkgreen85.btn-outlined.btn-inverse:focus,.btn-darkgreen85.btn-outlined.btn-inverse:hover{color:#36845e;background:#fff}.btn-darkgreen85.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkgreen85.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkgreen85.btn-outlined.btn-inverse:hover.btn-retainBg{background:#36845e;color:#fff;border-color:#36845e}.btn-darkgreen85.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkgreen85.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkgreen85.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#1b4330;border-color:#0a1711}.btn-darkgreen85.active,.btn-darkgreen85.focus,.btn-darkgreen85:focus,.btn-darkgreen85:hover{color:#fff;background:#45a878;border-color:#45a878}.btn-darkgreen85.active,.btn-darkgreen85.active:focus,.btn-darkgreen85.active:hover,.btn-darkgreen85:active,.btn-darkgreen85[aria-expanded=true],.btn-darkgreen85[aria-expanded=true]:focus,.btn-darkgreen85[aria-expanded=true]:hover,.open>.btn-darkgreen85.dropdown-toggle{color:#fff;background:#1b4330;border-color:#0a1711;background-image:none}.btn-darkgreen85.dropdown-toggle+ul li.active a{color:#fff;background:#36845e}.btn-darkgreen85.disabled,.btn-darkgreen85[disabled],fieldset[disabled] .btn-darkgreen85{pointer-events:none}.btn-darkgreen85 .badge{color:#36845e;background-color:#36845e}.menu-darkgreen85 ul li.active a,.menu-darkgreen85 ul li.active a:hover{color:#fff;background:#36845e!important}.nav-darkgreen85>li.active>a,.nav-darkgreen85>rubix-menu>li.active>a,.nav-darkgreen85>rubix-nav-item>li.active>a{color:#fff;background:#36845e;border-color:#36845e}.tab-darkgreen85{border-color:#36845e}.tab-darkgreen85>li.active>a{border-color:#36845e;border-bottom-color:transparent}.tab-darkgreen85.nav-pills>li.active>a{background:#36845e;color:#fff}.rubix-panel-header.nav-inline .nav-darkgreen85>li.active>a{border:1px solid #36845e;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkgreen85>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkgreen85{background:#36845e!important}.bg-darkgreen85 table td,.bg-darkgreen85 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkgreen85:focus,.bg-hover-darkgreen85:hover{background:#36845e!important}.fg-darkgreen85,.fg-darkgreen85 .nav-tabs>li.active>a{color:#36845e}.fg-tab-active-darkgreen85 .nav-tabs>li.active>a{color:#36845e!important}.fg-focus-darkgreen85:focus,.fg-hover-darkgreen85:hover{color:#36845e}.border-darkgreen85{border-color:#36845e!important}.border-darkgreen85 .rubix-timeline-body>ul,.border-darkgreen85.rubix-timeline-view:before{border-color:#36845e}.border-focus-darkgreen85:focus,.border-hover-darkgreen85:hover{border-color:#36845e!important}.tl-darkgreen85 .rubix-timeline-body>ul>li:before{border-color:#36845e}.list-bg-darkgreen85>.list-group-item.active{background:#36845e!important;color:#fff!important}.list-fg-darkgreen85>.list-group-item{color:#36845e}.btn-darkgreen75{background:#518f41;color:#fff;border-color:#518f41}.btn-darkgreen75.btn-outlined{color:#518f41;background:none}.btn-darkgreen75.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkgreen75.btn-outlined.btn-onlyOnHover.active,.btn-darkgreen75.btn-outlined.btn-onlyOnHover:focus,.btn-darkgreen75.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkgreen75.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkgreen75.btn-outlined.btn-inverse.active,.btn-darkgreen75.btn-outlined.btn-inverse:focus,.btn-darkgreen75.btn-outlined.btn-inverse:hover{color:#518f41;background:#fff}.btn-darkgreen75.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkgreen75.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkgreen75.btn-outlined.btn-inverse:hover.btn-retainBg{background:#518f41;color:#fff;border-color:#518f41}.btn-darkgreen75.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkgreen75.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkgreen75.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#2d5024;border-color:#152611}.btn-darkgreen75.active,.btn-darkgreen75.focus,.btn-darkgreen75:focus,.btn-darkgreen75:hover{color:#fff;background:#66b152;border-color:#66b152}.btn-darkgreen75.active,.btn-darkgreen75.active:focus,.btn-darkgreen75.active:hover,.btn-darkgreen75:active,.btn-darkgreen75[aria-expanded=true],.btn-darkgreen75[aria-expanded=true]:focus,.btn-darkgreen75[aria-expanded=true]:hover,.open>.btn-darkgreen75.dropdown-toggle{color:#fff;background:#2d5024;border-color:#152611;background-image:none}.btn-darkgreen75.dropdown-toggle+ul li.active a{color:#fff;background:#518f41}.btn-darkgreen75.disabled,.btn-darkgreen75[disabled],fieldset[disabled] .btn-darkgreen75{pointer-events:none}.btn-darkgreen75 .badge{color:#518f41;background-color:#518f41}.menu-darkgreen75 ul li.active a,.menu-darkgreen75 ul li.active a:hover{color:#fff;background:#518f41!important}.nav-darkgreen75>li.active>a,.nav-darkgreen75>rubix-menu>li.active>a,.nav-darkgreen75>rubix-nav-item>li.active>a{color:#fff;background:#518f41;border-color:#518f41}.tab-darkgreen75{border-color:#518f41}.tab-darkgreen75>li.active>a{border-color:#518f41;border-bottom-color:transparent}.tab-darkgreen75.nav-pills>li.active>a{background:#518f41;color:#fff}.rubix-panel-header.nav-inline .nav-darkgreen75>li.active>a{border:1px solid #518f41;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkgreen75>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkgreen75{background:#518f41!important}.bg-darkgreen75 table td,.bg-darkgreen75 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkgreen75:focus,.bg-hover-darkgreen75:hover{background:#518f41!important}.fg-darkgreen75,.fg-darkgreen75 .nav-tabs>li.active>a{color:#518f41}.fg-tab-active-darkgreen75 .nav-tabs>li.active>a{color:#518f41!important}.fg-focus-darkgreen75:focus,.fg-hover-darkgreen75:hover{color:#518f41}.border-darkgreen75{border-color:#518f41!important}.border-darkgreen75 .rubix-timeline-body>ul,.border-darkgreen75.rubix-timeline-view:before{border-color:#518f41}.border-focus-darkgreen75:focus,.border-hover-darkgreen75:hover{border-color:#518f41!important}.tl-darkgreen75 .rubix-timeline-body>ul>li:before{border-color:#518f41}.list-bg-darkgreen75>.list-group-item.active{background:#518f41!important;color:#fff!important}.list-fg-darkgreen75>.list-group-item{color:#518f41}.btn-darkgreen65{background:#66a655;color:#fff;border-color:#66a655}.btn-darkgreen65.btn-outlined{color:#66a655;background:none}.btn-darkgreen65.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkgreen65.btn-outlined.btn-onlyOnHover.active,.btn-darkgreen65.btn-outlined.btn-onlyOnHover:focus,.btn-darkgreen65.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkgreen65.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkgreen65.btn-outlined.btn-inverse.active,.btn-darkgreen65.btn-outlined.btn-inverse:focus,.btn-darkgreen65.btn-outlined.btn-inverse:hover{color:#66a655;background:#fff}.btn-darkgreen65.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkgreen65.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkgreen65.btn-outlined.btn-inverse:hover.btn-retainBg{background:#66a655;color:#fff;border-color:#66a655}.btn-darkgreen65.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkgreen65.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkgreen65.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#416936;border-color:#284121}.btn-darkgreen65.active,.btn-darkgreen65.focus,.btn-darkgreen65:focus,.btn-darkgreen65:hover{color:#fff;background:#84b975;border-color:#84b975}.btn-darkgreen65.active,.btn-darkgreen65.active:focus,.btn-darkgreen65.active:hover,.btn-darkgreen65:active,.btn-darkgreen65[aria-expanded=true],.btn-darkgreen65[aria-expanded=true]:focus,.btn-darkgreen65[aria-expanded=true]:hover,.open>.btn-darkgreen65.dropdown-toggle{color:#fff;background:#416936;border-color:#284121;background-image:none}.btn-darkgreen65.dropdown-toggle+ul li.active a{color:#fff;background:#66a655}.btn-darkgreen65.disabled,.btn-darkgreen65[disabled],fieldset[disabled] .btn-darkgreen65{pointer-events:none}.btn-darkgreen65 .badge{color:#66a655;background-color:#66a655}.menu-darkgreen65 ul li.active a,.menu-darkgreen65 ul li.active a:hover{color:#fff;background:#66a655!important}.nav-darkgreen65>li.active>a,.nav-darkgreen65>rubix-menu>li.active>a,.nav-darkgreen65>rubix-nav-item>li.active>a{color:#fff;background:#66a655;border-color:#66a655}.tab-darkgreen65{border-color:#66a655}.tab-darkgreen65>li.active>a{border-color:#66a655;border-bottom-color:transparent}.tab-darkgreen65.nav-pills>li.active>a{background:#66a655;color:#fff}.rubix-panel-header.nav-inline .nav-darkgreen65>li.active>a{border:1px solid #66a655;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkgreen65>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkgreen65{background:#66a655!important}.bg-darkgreen65 table td,.bg-darkgreen65 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkgreen65:focus,.bg-hover-darkgreen65:hover{background:#66a655!important}.fg-darkgreen65,.fg-darkgreen65 .nav-tabs>li.active>a{color:#66a655}.fg-tab-active-darkgreen65 .nav-tabs>li.active>a{color:#66a655!important}.fg-focus-darkgreen65:focus,.fg-hover-darkgreen65:hover{color:#66a655}.border-darkgreen65{border-color:#66a655!important}.border-darkgreen65 .rubix-timeline-body>ul,.border-darkgreen65.rubix-timeline-view:before{border-color:#66a655}.border-focus-darkgreen65:focus,.border-hover-darkgreen65:hover{border-color:#66a655!important}.tl-darkgreen65 .rubix-timeline-body>ul>li:before{border-color:#66a655}.list-bg-darkgreen65>.list-group-item.active{background:#66a655!important;color:#fff!important}.list-fg-darkgreen65>.list-group-item{color:#66a655}.btn-darkgreen55{background:#68bd80;color:#fff;border-color:#68bd80}.btn-darkgreen55.btn-outlined{color:#68bd80;background:none}.btn-darkgreen55.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkgreen55.btn-outlined.btn-onlyOnHover.active,.btn-darkgreen55.btn-outlined.btn-onlyOnHover:focus,.btn-darkgreen55.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkgreen55.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkgreen55.btn-outlined.btn-inverse.active,.btn-darkgreen55.btn-outlined.btn-inverse:focus,.btn-darkgreen55.btn-outlined.btn-inverse:hover{color:#68bd80;background:#fff}.btn-darkgreen55.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkgreen55.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkgreen55.btn-outlined.btn-inverse:hover.btn-retainBg{background:#68bd80;color:#fff;border-color:#68bd80}.btn-darkgreen55.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkgreen55.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkgreen55.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#3d8c53;border-color:#2b613a}.btn-darkgreen55.active,.btn-darkgreen55.focus,.btn-darkgreen55:focus,.btn-darkgreen55:hover{color:#fff;background:#8bcd9e;border-color:#8bcd9e}.btn-darkgreen55.active,.btn-darkgreen55.active:focus,.btn-darkgreen55.active:hover,.btn-darkgreen55:active,.btn-darkgreen55[aria-expanded=true],.btn-darkgreen55[aria-expanded=true]:focus,.btn-darkgreen55[aria-expanded=true]:hover,.open>.btn-darkgreen55.dropdown-toggle{color:#fff;background:#3d8c53;border-color:#2b613a;background-image:none}.btn-darkgreen55.dropdown-toggle+ul li.active a{color:#fff;background:#68bd80}.btn-darkgreen55.disabled,.btn-darkgreen55[disabled],fieldset[disabled] .btn-darkgreen55{pointer-events:none}.btn-darkgreen55 .badge{color:#68bd80;background-color:#68bd80}.menu-darkgreen55 ul li.active a,.menu-darkgreen55 ul li.active a:hover{color:#fff;background:#68bd80!important}.nav-darkgreen55>li.active>a,.nav-darkgreen55>rubix-menu>li.active>a,.nav-darkgreen55>rubix-nav-item>li.active>a{color:#fff;background:#68bd80;border-color:#68bd80}.tab-darkgreen55{border-color:#68bd80}.tab-darkgreen55>li.active>a{border-color:#68bd80;border-bottom-color:transparent}.tab-darkgreen55.nav-pills>li.active>a{background:#68bd80;color:#fff}.rubix-panel-header.nav-inline .nav-darkgreen55>li.active>a{border:1px solid #68bd80;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkgreen55>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkgreen55{background:#68bd80!important}.bg-darkgreen55 table td,.bg-darkgreen55 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkgreen55:focus,.bg-hover-darkgreen55:hover{background:#68bd80!important}.fg-darkgreen55,.fg-darkgreen55 .nav-tabs>li.active>a{color:#68bd80}.fg-tab-active-darkgreen55 .nav-tabs>li.active>a{color:#68bd80!important}.fg-focus-darkgreen55:focus,.fg-hover-darkgreen55:hover{color:#68bd80}.border-darkgreen55{border-color:#68bd80!important}.border-darkgreen55 .rubix-timeline-body>ul,.border-darkgreen55.rubix-timeline-view:before{border-color:#68bd80}.border-focus-darkgreen55:focus,.border-hover-darkgreen55:hover{border-color:#68bd80!important}.tl-darkgreen55 .rubix-timeline-body>ul>li:before{border-color:#68bd80}.list-bg-darkgreen55>.list-group-item.active{background:#68bd80!important;color:#fff!important}.list-fg-darkgreen55>.list-group-item{color:#68bd80}.btn-darkgreen50{background:#55a69f;color:#fff;border-color:#55a69f}.btn-darkgreen50.btn-outlined{color:#55a69f;background:none}.btn-darkgreen50.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkgreen50.btn-outlined.btn-onlyOnHover.active,.btn-darkgreen50.btn-outlined.btn-onlyOnHover:focus,.btn-darkgreen50.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkgreen50.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkgreen50.btn-outlined.btn-inverse.active,.btn-darkgreen50.btn-outlined.btn-inverse:focus,.btn-darkgreen50.btn-outlined.btn-inverse:hover{color:#55a69f;background:#fff}.btn-darkgreen50.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkgreen50.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkgreen50.btn-outlined.btn-inverse:hover.btn-retainBg{background:#55a69f;color:#fff;border-color:#55a69f}.btn-darkgreen50.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkgreen50.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkgreen50.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#366965;border-color:#21413e}.btn-darkgreen50.active,.btn-darkgreen50.focus,.btn-darkgreen50:focus,.btn-darkgreen50:hover{color:#fff;background:#75b9b3;border-color:#75b9b3}.btn-darkgreen50.active,.btn-darkgreen50.active:focus,.btn-darkgreen50.active:hover,.btn-darkgreen50:active,.btn-darkgreen50[aria-expanded=true],.btn-darkgreen50[aria-expanded=true]:focus,.btn-darkgreen50[aria-expanded=true]:hover,.open>.btn-darkgreen50.dropdown-toggle{color:#fff;background:#366965;border-color:#21413e;background-image:none}.btn-darkgreen50.dropdown-toggle+ul li.active a{color:#fff;background:#55a69f}.btn-darkgreen50.disabled,.btn-darkgreen50[disabled],fieldset[disabled] .btn-darkgreen50{pointer-events:none}.btn-darkgreen50 .badge{color:#55a69f;background-color:#55a69f}.menu-darkgreen50 ul li.active a,.menu-darkgreen50 ul li.active a:hover{color:#fff;background:#55a69f!important}.nav-darkgreen50>li.active>a,.nav-darkgreen50>rubix-menu>li.active>a,.nav-darkgreen50>rubix-nav-item>li.active>a{color:#fff;background:#55a69f;border-color:#55a69f}.tab-darkgreen50{border-color:#55a69f}.tab-darkgreen50>li.active>a{border-color:#55a69f;border-bottom-color:transparent}.tab-darkgreen50.nav-pills>li.active>a{background:#55a69f;color:#fff}.rubix-panel-header.nav-inline .nav-darkgreen50>li.active>a{border:1px solid #55a69f;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkgreen50>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkgreen50{background:#55a69f!important}.bg-darkgreen50 table td,.bg-darkgreen50 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkgreen50:focus,.bg-hover-darkgreen50:hover{background:#55a69f!important}.fg-darkgreen50,.fg-darkgreen50 .nav-tabs>li.active>a{color:#55a69f}.fg-tab-active-darkgreen50 .nav-tabs>li.active>a{color:#55a69f!important}.fg-focus-darkgreen50:focus,.fg-hover-darkgreen50:hover{color:#55a69f}.border-darkgreen50{border-color:#55a69f!important}.border-darkgreen50 .rubix-timeline-body>ul,.border-darkgreen50.rubix-timeline-view:before{border-color:#55a69f}.border-focus-darkgreen50:focus,.border-hover-darkgreen50:hover{border-color:#55a69f!important}.tl-darkgreen50 .rubix-timeline-body>ul>li:before{border-color:#55a69f}.list-bg-darkgreen50>.list-group-item.active{background:#55a69f!important;color:#fff!important}.list-fg-darkgreen50>.list-group-item{color:#55a69f}.btn-darkgreen45{background:#2eb398;color:#fff;border-color:#2eb398}.btn-darkgreen45.btn-outlined{color:#2eb398;background:none}.btn-darkgreen45.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkgreen45.btn-outlined.btn-onlyOnHover.active,.btn-darkgreen45.btn-outlined.btn-onlyOnHover:focus,.btn-darkgreen45.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkgreen45.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkgreen45.btn-outlined.btn-inverse.active,.btn-darkgreen45.btn-outlined.btn-inverse:focus,.btn-darkgreen45.btn-outlined.btn-inverse:hover{color:#2eb398;background:#fff}.btn-darkgreen45.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkgreen45.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkgreen45.btn-outlined.btn-inverse:hover.btn-retainBg{background:#2eb398;color:#fff;border-color:#2eb398}.btn-darkgreen45.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkgreen45.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkgreen45.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#1b6a5a;border-color:#0f3931}.btn-darkgreen45.active,.btn-darkgreen45.focus,.btn-darkgreen45:focus,.btn-darkgreen45:hover{color:#fff;background:#45cfb3;border-color:#45cfb3}.btn-darkgreen45.active,.btn-darkgreen45.active:focus,.btn-darkgreen45.active:hover,.btn-darkgreen45:active,.btn-darkgreen45[aria-expanded=true],.btn-darkgreen45[aria-expanded=true]:focus,.btn-darkgreen45[aria-expanded=true]:hover,.open>.btn-darkgreen45.dropdown-toggle{color:#fff;background:#1b6a5a;border-color:#0f3931;background-image:none}.btn-darkgreen45.dropdown-toggle+ul li.active a{color:#fff;background:#2eb398}.btn-darkgreen45.disabled,.btn-darkgreen45[disabled],fieldset[disabled] .btn-darkgreen45{pointer-events:none}.btn-darkgreen45 .badge{color:#2eb398;background-color:#2eb398}.menu-darkgreen45 ul li.active a,.menu-darkgreen45 ul li.active a:hover{color:#fff;background:#2eb398!important}.nav-darkgreen45>li.active>a,.nav-darkgreen45>rubix-menu>li.active>a,.nav-darkgreen45>rubix-nav-item>li.active>a{color:#fff;background:#2eb398;border-color:#2eb398}.tab-darkgreen45{border-color:#2eb398}.tab-darkgreen45>li.active>a{border-color:#2eb398;border-bottom-color:transparent}.tab-darkgreen45.nav-pills>li.active>a{background:#2eb398;color:#fff}.rubix-panel-header.nav-inline .nav-darkgreen45>li.active>a{border:1px solid #2eb398;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkgreen45>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkgreen45{background:#2eb398!important}.bg-darkgreen45 table td,.bg-darkgreen45 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkgreen45:focus,.bg-hover-darkgreen45:hover{background:#2eb398!important}.fg-darkgreen45,.fg-darkgreen45 .nav-tabs>li.active>a{color:#2eb398}.fg-tab-active-darkgreen45 .nav-tabs>li.active>a{color:#2eb398!important}.fg-focus-darkgreen45:focus,.fg-hover-darkgreen45:hover{color:#2eb398}.border-darkgreen45{border-color:#2eb398!important}.border-darkgreen45 .rubix-timeline-body>ul,.border-darkgreen45.rubix-timeline-view:before{border-color:#2eb398}.border-focus-darkgreen45:focus,.border-hover-darkgreen45:hover{border-color:#2eb398!important}.tl-darkgreen45 .rubix-timeline-body>ul>li:before{border-color:#2eb398}.list-bg-darkgreen45>.list-group-item.active{background:#2eb398!important;color:#fff!important}.list-fg-darkgreen45>.list-group-item{color:#2eb398}.btn-darkgreen40{background:#44c1ac;color:#fff;border-color:#44c1ac}.btn-darkgreen40.btn-outlined{color:#44c1ac;background:none}.btn-darkgreen40.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkgreen40.btn-outlined.btn-onlyOnHover.active,.btn-darkgreen40.btn-outlined.btn-onlyOnHover:focus,.btn-darkgreen40.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkgreen40.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkgreen40.btn-outlined.btn-inverse.active,.btn-darkgreen40.btn-outlined.btn-inverse:focus,.btn-darkgreen40.btn-outlined.btn-inverse:hover{color:#44c1ac;background:#fff}.btn-darkgreen40.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkgreen40.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkgreen40.btn-outlined.btn-inverse:hover.btn-retainBg{background:#44c1ac;color:#fff;border-color:#44c1ac}.btn-darkgreen40.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkgreen40.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkgreen40.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#2a7f71;border-color:#1b5148}.btn-darkgreen40.active,.btn-darkgreen40.focus,.btn-darkgreen40:focus,.btn-darkgreen40:hover{color:#fff;background:#6acebd;border-color:#6acebd}.btn-darkgreen40.active,.btn-darkgreen40.active:focus,.btn-darkgreen40.active:hover,.btn-darkgreen40:active,.btn-darkgreen40[aria-expanded=true],.btn-darkgreen40[aria-expanded=true]:focus,.btn-darkgreen40[aria-expanded=true]:hover,.open>.btn-darkgreen40.dropdown-toggle{color:#fff;background:#2a7f71;border-color:#1b5148;background-image:none}.btn-darkgreen40.dropdown-toggle+ul li.active a{color:#fff;background:#44c1ac}.btn-darkgreen40.disabled,.btn-darkgreen40[disabled],fieldset[disabled] .btn-darkgreen40{pointer-events:none}.btn-darkgreen40 .badge{color:#44c1ac;background-color:#44c1ac}.menu-darkgreen40 ul li.active a,.menu-darkgreen40 ul li.active a:hover{color:#fff;background:#44c1ac!important}.nav-darkgreen40>li.active>a,.nav-darkgreen40>rubix-menu>li.active>a,.nav-darkgreen40>rubix-nav-item>li.active>a{color:#fff;background:#44c1ac;border-color:#44c1ac}.tab-darkgreen40{border-color:#44c1ac}.tab-darkgreen40>li.active>a{border-color:#44c1ac;border-bottom-color:transparent}.tab-darkgreen40.nav-pills>li.active>a{background:#44c1ac;color:#fff}.rubix-panel-header.nav-inline .nav-darkgreen40>li.active>a{border:1px solid #44c1ac;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkgreen40>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkgreen40{background:#44c1ac!important}.bg-darkgreen40 table td,.bg-darkgreen40 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkgreen40:focus,.bg-hover-darkgreen40:hover{background:#44c1ac!important}.fg-darkgreen40,.fg-darkgreen40 .nav-tabs>li.active>a{color:#44c1ac}.fg-tab-active-darkgreen40 .nav-tabs>li.active>a{color:#44c1ac!important}.fg-focus-darkgreen40:focus,.fg-hover-darkgreen40:hover{color:#44c1ac}.border-darkgreen40{border-color:#44c1ac!important}.border-darkgreen40 .rubix-timeline-body>ul,.border-darkgreen40.rubix-timeline-view:before{border-color:#44c1ac}.border-focus-darkgreen40:focus,.border-hover-darkgreen40:hover{border-color:#44c1ac!important}.tl-darkgreen40 .rubix-timeline-body>ul>li:before{border-color:#44c1ac}.list-bg-darkgreen40>.list-group-item.active{background:#44c1ac!important;color:#fff!important}.list-fg-darkgreen40>.list-group-item{color:#44c1ac}.btn-green{background:#55c9a6;color:#fff;border-color:#55c9a6}.btn-green.btn-outlined{color:#55c9a6;background:none}.btn-green.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-green.btn-outlined.btn-onlyOnHover.active,.btn-green.btn-outlined.btn-onlyOnHover:focus,.btn-green.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-green.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-green.btn-outlined.btn-inverse.active,.btn-green.btn-outlined.btn-inverse:focus,.btn-green.btn-outlined.btn-inverse:hover{color:#55c9a6;background:#fff}.btn-green.btn-outlined.btn-inverse.active.btn-retainBg,.btn-green.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-green.btn-outlined.btn-inverse:hover.btn-retainBg{background:#55c9a6;color:#fff;border-color:#55c9a6}.btn-green.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-green.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-green.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#2f9375;border-color:#206550}.btn-green.active,.btn-green.focus,.btn-green:focus,.btn-green:hover{color:#fff;background:#7cd5ba;border-color:#7cd5ba}.btn-green.active,.btn-green.active:focus,.btn-green.active:hover,.btn-green:active,.btn-green[aria-expanded=true],.btn-green[aria-expanded=true]:focus,.btn-green[aria-expanded=true]:hover,.open>.btn-green.dropdown-toggle{color:#fff;background:#2f9375;border-color:#206550;background-image:none}.btn-green.dropdown-toggle+ul li.active a{color:#fff;background:#55c9a6}.btn-green.disabled,.btn-green[disabled],fieldset[disabled] .btn-green{pointer-events:none}.btn-green .badge{color:#55c9a6;background-color:#55c9a6}.menu-green ul li.active a,.menu-green ul li.active a:hover{color:#fff;background:#55c9a6!important}.nav-green>li.active>a,.nav-green>rubix-menu>li.active>a,.nav-green>rubix-nav-item>li.active>a{color:#fff;background:#55c9a6;border-color:#55c9a6}.tab-green{border-color:#55c9a6}.tab-green>li.active>a{border-color:#55c9a6;border-bottom-color:transparent}.tab-green.nav-pills>li.active>a{background:#55c9a6;color:#fff}.rubix-panel-header.nav-inline .nav-green>li.active>a{border:1px solid #55c9a6;border-bottom:none}.rubix-panel-header.nav-inline .nav-green>li.open>.dropdown-toggle{color:#fff;background:none}.bg-green{background:#55c9a6!important}.bg-green table td,.bg-green th{border-color:rgba(0,0,0,.05)!important}.bg-focus-green:focus,.bg-hover-green:hover{background:#55c9a6!important}.fg-green,.fg-green .nav-tabs>li.active>a{color:#55c9a6}.fg-tab-active-green .nav-tabs>li.active>a{color:#55c9a6!important}.fg-focus-green:focus,.fg-hover-green:hover{color:#55c9a6}.border-green{border-color:#55c9a6!important}.border-green .rubix-timeline-body>ul,.border-green.rubix-timeline-view:before{border-color:#55c9a6}.border-focus-green:focus,.border-hover-green:hover{border-color:#55c9a6!important}.tl-green .rubix-timeline-body>ul>li:before{border-color:#55c9a6}.list-bg-green>.list-group-item.active{background:#55c9a6!important;color:#fff!important}.list-fg-green>.list-group-item{color:#55c9a6}.btn-lightgreen{background:#7cd5ba;color:#fff;border-color:#7cd5ba}.btn-lightgreen.btn-outlined{color:#7cd5ba;background:none}.btn-lightgreen.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-lightgreen.btn-outlined.btn-onlyOnHover.active,.btn-lightgreen.btn-outlined.btn-onlyOnHover:focus,.btn-lightgreen.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-lightgreen.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-lightgreen.btn-outlined.btn-inverse.active,.btn-lightgreen.btn-outlined.btn-inverse:focus,.btn-lightgreen.btn-outlined.btn-inverse:hover{color:#7cd5ba;background:#fff}.btn-lightgreen.btn-outlined.btn-inverse.active.btn-retainBg,.btn-lightgreen.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-lightgreen.btn-outlined.btn-inverse:hover.btn-retainBg{background:#7cd5ba;color:#fff;border-color:#7cd5ba}.btn-lightgreen.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-lightgreen.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-lightgreen.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#3cba93;border-color:#2d8b6f}.btn-lightgreen.active,.btn-lightgreen.focus,.btn-lightgreen:focus,.btn-lightgreen:hover{color:#fff;background:#a3e1ce;border-color:#a3e1ce}.btn-lightgreen.active,.btn-lightgreen.active:focus,.btn-lightgreen.active:hover,.btn-lightgreen:active,.btn-lightgreen[aria-expanded=true],.btn-lightgreen[aria-expanded=true]:focus,.btn-lightgreen[aria-expanded=true]:hover,.open>.btn-lightgreen.dropdown-toggle{color:#fff;background:#3cba93;border-color:#2d8b6f;background-image:none}.btn-lightgreen.dropdown-toggle+ul li.active a{color:#fff;background:#7cd5ba}.btn-lightgreen.disabled,.btn-lightgreen[disabled],fieldset[disabled] .btn-lightgreen{pointer-events:none}.btn-lightgreen .badge{color:#7cd5ba;background-color:#7cd5ba}.menu-lightgreen ul li.active a,.menu-lightgreen ul li.active a:hover{color:#fff;background:#7cd5ba!important}.nav-lightgreen>li.active>a,.nav-lightgreen>rubix-menu>li.active>a,.nav-lightgreen>rubix-nav-item>li.active>a{color:#fff;background:#7cd5ba;border-color:#7cd5ba}.tab-lightgreen{border-color:#7cd5ba}.tab-lightgreen>li.active>a{border-color:#7cd5ba;border-bottom-color:transparent}.tab-lightgreen.nav-pills>li.active>a{background:#7cd5ba;color:#fff}.rubix-panel-header.nav-inline .nav-lightgreen>li.active>a{border:1px solid #7cd5ba;border-bottom:none}.rubix-panel-header.nav-inline .nav-lightgreen>li.open>.dropdown-toggle{color:#fff;background:none}.bg-lightgreen{background:#7cd5ba!important}.bg-lightgreen table td,.bg-lightgreen th{border-color:rgba(0,0,0,.05)!important}.bg-focus-lightgreen:focus,.bg-hover-lightgreen:hover{background:#7cd5ba!important}.fg-lightgreen,.fg-lightgreen .nav-tabs>li.active>a{color:#7cd5ba}.fg-tab-active-lightgreen .nav-tabs>li.active>a{color:#7cd5ba!important}.fg-focus-lightgreen:focus,.fg-hover-lightgreen:hover{color:#7cd5ba}.border-lightgreen{border-color:#7cd5ba!important}.border-lightgreen .rubix-timeline-body>ul,.border-lightgreen.rubix-timeline-view:before{border-color:#7cd5ba}.border-focus-lightgreen:focus,.border-hover-lightgreen:hover{border-color:#7cd5ba!important}.tl-lightgreen .rubix-timeline-body>ul>li:before{border-color:#7cd5ba}.list-bg-lightgreen>.list-group-item.active{background:#7cd5ba!important;color:#fff!important}.list-fg-lightgreen>.list-group-item{color:#7cd5ba}.btn-hovergreen{background:#e5f7f1;color:#fff;border-color:#e5f7f1}.btn-hovergreen.btn-outlined{color:#e5f7f1;background:none}.btn-hovergreen.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-hovergreen.btn-outlined.btn-onlyOnHover.active,.btn-hovergreen.btn-outlined.btn-onlyOnHover:focus,.btn-hovergreen.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-hovergreen.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-hovergreen.btn-outlined.btn-inverse.active,.btn-hovergreen.btn-outlined.btn-inverse:focus,.btn-hovergreen.btn-outlined.btn-inverse:hover{color:#e5f7f1;background:#fff}.btn-hovergreen.btn-outlined.btn-inverse.active.btn-retainBg,.btn-hovergreen.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-hovergreen.btn-outlined.btn-inverse:hover.btn-retainBg{background:#e5f7f1;color:#fff;border-color:#e5f7f1}.btn-hovergreen.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-hovergreen.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-hovergreen.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#9fe1cb;border-color:#70d3b2}.btn-hovergreen.active,.btn-hovergreen.focus,.btn-hovergreen:focus,.btn-hovergreen:hover{color:#fff;background:#fff;border-color:#fff}.btn-hovergreen.active,.btn-hovergreen.active:focus,.btn-hovergreen.active:hover,.btn-hovergreen:active,.btn-hovergreen[aria-expanded=true],.btn-hovergreen[aria-expanded=true]:focus,.btn-hovergreen[aria-expanded=true]:hover,.open>.btn-hovergreen.dropdown-toggle{color:#fff;background:#9fe1cb;border-color:#70d3b2;background-image:none}.btn-hovergreen.dropdown-toggle+ul li.active a{color:#fff;background:#e5f7f1}.btn-hovergreen.disabled,.btn-hovergreen[disabled],fieldset[disabled] .btn-hovergreen{pointer-events:none}.btn-hovergreen .badge{color:#e5f7f1;background-color:#e5f7f1}.menu-hovergreen ul li.active a,.menu-hovergreen ul li.active a:hover{color:#fff;background:#e5f7f1!important}.nav-hovergreen>li.active>a,.nav-hovergreen>rubix-menu>li.active>a,.nav-hovergreen>rubix-nav-item>li.active>a{color:#fff;background:#e5f7f1;border-color:#e5f7f1}.tab-hovergreen{border-color:#e5f7f1}.tab-hovergreen>li.active>a{border-color:#e5f7f1;border-bottom-color:transparent}.tab-hovergreen.nav-pills>li.active>a{background:#e5f7f1;color:#fff}.rubix-panel-header.nav-inline .nav-hovergreen>li.active>a{border:1px solid #e5f7f1;border-bottom:none}.rubix-panel-header.nav-inline .nav-hovergreen>li.open>.dropdown-toggle{color:#fff;background:none}.bg-hovergreen{background:#e5f7f1!important}.bg-hovergreen table td,.bg-hovergreen th{border-color:rgba(0,0,0,.05)!important}.bg-focus-hovergreen:focus,.bg-hover-hovergreen:hover{background:#e5f7f1!important}.fg-hovergreen,.fg-hovergreen .nav-tabs>li.active>a{color:#e5f7f1}.fg-tab-active-hovergreen .nav-tabs>li.active>a{color:#e5f7f1!important}.fg-focus-hovergreen:focus,.fg-hover-hovergreen:hover{color:#e5f7f1}.border-hovergreen{border-color:#e5f7f1!important}.border-hovergreen .rubix-timeline-body>ul,.border-hovergreen.rubix-timeline-view:before{border-color:#e5f7f1}.border-focus-hovergreen:focus,.border-hover-hovergreen:hover{border-color:#e5f7f1!important}.tl-hovergreen .rubix-timeline-body>ul>li:before{border-color:#e5f7f1}.list-bg-hovergreen>.list-group-item.active{background:#e5f7f1!important;color:#fff!important}.list-fg-hovergreen>.list-group-item{color:#e5f7f1}.btn-brightyellow{background:#fcb621;color:#fff;border-color:#fcb621}.btn-brightyellow.btn-outlined{color:#fcb621;background:none}.btn-brightyellow.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-brightyellow.btn-outlined.btn-onlyOnHover.active,.btn-brightyellow.btn-outlined.btn-onlyOnHover:focus,.btn-brightyellow.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-brightyellow.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-brightyellow.btn-outlined.btn-inverse.active,.btn-brightyellow.btn-outlined.btn-inverse:focus,.btn-brightyellow.btn-outlined.btn-inverse:hover{color:#fcb621;background:#fff}.btn-brightyellow.btn-outlined.btn-inverse.active.btn-retainBg,.btn-brightyellow.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-brightyellow.btn-outlined.btn-inverse:hover.btn-retainBg{background:#fcb621;color:#fff;border-color:#fcb621}.btn-brightyellow.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-brightyellow.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-brightyellow.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#bf8303;border-color:#825902}.btn-brightyellow.active,.btn-brightyellow.focus,.btn-brightyellow:focus,.btn-brightyellow:hover{color:#fff;background:#fdc753;border-color:#fdc753}.btn-brightyellow.active,.btn-brightyellow.active:focus,.btn-brightyellow.active:hover,.btn-brightyellow:active,.btn-brightyellow[aria-expanded=true],.btn-brightyellow[aria-expanded=true]:focus,.btn-brightyellow[aria-expanded=true]:hover,.open>.btn-brightyellow.dropdown-toggle{color:#fff;background:#bf8303;border-color:#825902;background-image:none}.btn-brightyellow.dropdown-toggle+ul li.active a{color:#fff;background:#fcb621}.btn-brightyellow.disabled,.btn-brightyellow[disabled],fieldset[disabled] .btn-brightyellow{pointer-events:none}.btn-brightyellow .badge{color:#fcb621;background-color:#fcb621}.menu-brightyellow ul li.active a,.menu-brightyellow ul li.active a:hover{color:#fff;background:#fcb621!important}.nav-brightyellow>li.active>a,.nav-brightyellow>rubix-menu>li.active>a,.nav-brightyellow>rubix-nav-item>li.active>a{color:#fff;background:#fcb621;border-color:#fcb621}.tab-brightyellow{border-color:#fcb621}.tab-brightyellow>li.active>a{border-color:#fcb621;border-bottom-color:transparent}.tab-brightyellow.nav-pills>li.active>a{background:#fcb621;color:#fff}.rubix-panel-header.nav-inline .nav-brightyellow>li.active>a{border:1px solid #fcb621;border-bottom:none}.rubix-panel-header.nav-inline .nav-brightyellow>li.open>.dropdown-toggle{color:#fff;background:none}.bg-brightyellow{background:#fcb621!important}.bg-brightyellow table td,.bg-brightyellow th{border-color:rgba(0,0,0,.05)!important}.bg-focus-brightyellow:focus,.bg-hover-brightyellow:hover{background:#fcb621!important}.fg-brightyellow,.fg-brightyellow .nav-tabs>li.active>a{color:#fcb621}.fg-tab-active-brightyellow .nav-tabs>li.active>a{color:#fcb621!important}.fg-focus-brightyellow:focus,.fg-hover-brightyellow:hover{color:#fcb621}.border-brightyellow{border-color:#fcb621!important}.border-brightyellow .rubix-timeline-body>ul,.border-brightyellow.rubix-timeline-view:before{border-color:#fcb621}.border-focus-brightyellow:focus,.border-hover-brightyellow:hover{border-color:#fcb621!important}.tl-brightyellow .rubix-timeline-body>ul>li:before{border-color:#fcb621}.list-bg-brightyellow>.list-group-item.active{background:#fcb621!important;color:#fff!important}.list-fg-brightyellow>.list-group-item{color:#fcb621}.btn-brightyellow75{background:#f3c557;color:#fff;border-color:#f3c557}.btn-brightyellow75.btn-outlined{color:#f3c557;background:none}.btn-brightyellow75.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-brightyellow75.btn-outlined.btn-onlyOnHover.active,.btn-brightyellow75.btn-outlined.btn-onlyOnHover:focus,.btn-brightyellow75.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-brightyellow75.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-brightyellow75.btn-outlined.btn-inverse.active,.btn-brightyellow75.btn-outlined.btn-inverse:focus,.btn-brightyellow75.btn-outlined.btn-inverse:hover{color:#f3c557;background:#fff}.btn-brightyellow75.btn-outlined.btn-inverse.active.btn-retainBg,.btn-brightyellow75.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-brightyellow75.btn-outlined.btn-inverse:hover.btn-retainBg{background:#f3c557;color:#fff;border-color:#f3c557}.btn-brightyellow75.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-brightyellow75.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-brightyellow75.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#dea110;border-color:#a5780c}.btn-brightyellow75.active,.btn-brightyellow75.focus,.btn-brightyellow75:focus,.btn-brightyellow75:hover{color:#fff;background:#f6d587;border-color:#f6d587}.btn-brightyellow75.active,.btn-brightyellow75.active:focus,.btn-brightyellow75.active:hover,.btn-brightyellow75:active,.btn-brightyellow75[aria-expanded=true],.btn-brightyellow75[aria-expanded=true]:focus,.btn-brightyellow75[aria-expanded=true]:hover,.open>.btn-brightyellow75.dropdown-toggle{color:#fff;background:#dea110;border-color:#a5780c;background-image:none}.btn-brightyellow75.dropdown-toggle+ul li.active a{color:#fff;background:#f3c557}.btn-brightyellow75.disabled,.btn-brightyellow75[disabled],fieldset[disabled] .btn-brightyellow75{pointer-events:none}.btn-brightyellow75 .badge{color:#f3c557;background-color:#f3c557}.menu-brightyellow75 ul li.active a,.menu-brightyellow75 ul li.active a:hover{color:#fff;background:#f3c557!important}.nav-brightyellow75>li.active>a,.nav-brightyellow75>rubix-menu>li.active>a,.nav-brightyellow75>rubix-nav-item>li.active>a{color:#fff;background:#f3c557;border-color:#f3c557}.tab-brightyellow75{border-color:#f3c557}.tab-brightyellow75>li.active>a{border-color:#f3c557;border-bottom-color:transparent}.tab-brightyellow75.nav-pills>li.active>a{background:#f3c557;color:#fff}.rubix-panel-header.nav-inline .nav-brightyellow75>li.active>a{border:1px solid #f3c557;border-bottom:none}.rubix-panel-header.nav-inline .nav-brightyellow75>li.open>.dropdown-toggle{color:#fff;background:none}.bg-brightyellow75{background:#f3c557!important}.bg-brightyellow75 table td,.bg-brightyellow75 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-brightyellow75:focus,.bg-hover-brightyellow75:hover{background:#f3c557!important}.fg-brightyellow75,.fg-brightyellow75 .nav-tabs>li.active>a{color:#f3c557}.fg-tab-active-brightyellow75 .nav-tabs>li.active>a{color:#f3c557!important}.fg-focus-brightyellow75:focus,.fg-hover-brightyellow75:hover{color:#f3c557}.border-brightyellow75{border-color:#f3c557!important}.border-brightyellow75 .rubix-timeline-body>ul,.border-brightyellow75.rubix-timeline-view:before{border-color:#f3c557}.border-focus-brightyellow75:focus,.border-hover-brightyellow75:hover{border-color:#f3c557!important}.tl-brightyellow75 .rubix-timeline-body>ul>li:before{border-color:#f3c557}.list-bg-brightyellow75>.list-group-item.active{background:#f3c557!important;color:#fff!important}.list-fg-brightyellow75>.list-group-item{color:#f3c557}.btn-brightyellow65{background:#edbc6c;color:#fff;border-color:#edbc6c}.btn-brightyellow65.btn-outlined{color:#edbc6c;background:none}.btn-brightyellow65.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-brightyellow65.btn-outlined.btn-onlyOnHover.active,.btn-brightyellow65.btn-outlined.btn-onlyOnHover:focus,.btn-brightyellow65.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-brightyellow65.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-brightyellow65.btn-outlined.btn-inverse.active,.btn-brightyellow65.btn-outlined.btn-inverse:focus,.btn-brightyellow65.btn-outlined.btn-inverse:hover{color:#edbc6c;background:#fff}.btn-brightyellow65.btn-outlined.btn-inverse.active.btn-retainBg,.btn-brightyellow65.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-brightyellow65.btn-outlined.btn-inverse:hover.btn-retainBg{background:#edbc6c;color:#fff;border-color:#edbc6c}.btn-brightyellow65.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-brightyellow65.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-brightyellow65.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#e2961c;border-color:#ab7215}.btn-brightyellow65.active,.btn-brightyellow65.focus,.btn-brightyellow65:focus,.btn-brightyellow65:hover{color:#fff;background:#f3d199;border-color:#f3d199}.btn-brightyellow65.active,.btn-brightyellow65.active:focus,.btn-brightyellow65.active:hover,.btn-brightyellow65:active,.btn-brightyellow65[aria-expanded=true],.btn-brightyellow65[aria-expanded=true]:focus,.btn-brightyellow65[aria-expanded=true]:hover,.open>.btn-brightyellow65.dropdown-toggle{color:#fff;background:#e2961c;border-color:#ab7215;background-image:none}.btn-brightyellow65.dropdown-toggle+ul li.active a{color:#fff;background:#edbc6c}.btn-brightyellow65.disabled,.btn-brightyellow65[disabled],fieldset[disabled] .btn-brightyellow65{pointer-events:none}.btn-brightyellow65 .badge{color:#edbc6c;background-color:#edbc6c}.menu-brightyellow65 ul li.active a,.menu-brightyellow65 ul li.active a:hover{color:#fff;background:#edbc6c!important}.nav-brightyellow65>li.active>a,.nav-brightyellow65>rubix-menu>li.active>a,.nav-brightyellow65>rubix-nav-item>li.active>a{color:#fff;background:#edbc6c;border-color:#edbc6c}.tab-brightyellow65{border-color:#edbc6c}.tab-brightyellow65>li.active>a{border-color:#edbc6c;border-bottom-color:transparent}.tab-brightyellow65.nav-pills>li.active>a{background:#edbc6c;color:#fff}.rubix-panel-header.nav-inline .nav-brightyellow65>li.active>a{border:1px solid #edbc6c;border-bottom:none}.rubix-panel-header.nav-inline .nav-brightyellow65>li.open>.dropdown-toggle{color:#fff;background:none}.bg-brightyellow65{background:#edbc6c!important}.bg-brightyellow65 table td,.bg-brightyellow65 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-brightyellow65:focus,.bg-hover-brightyellow65:hover{background:#edbc6c!important}.fg-brightyellow65,.fg-brightyellow65 .nav-tabs>li.active>a{color:#edbc6c}.fg-tab-active-brightyellow65 .nav-tabs>li.active>a{color:#edbc6c!important}.fg-focus-brightyellow65:focus,.fg-hover-brightyellow65:hover{color:#edbc6c}.border-brightyellow65{border-color:#edbc6c!important}.border-brightyellow65 .rubix-timeline-body>ul,.border-brightyellow65.rubix-timeline-view:before{border-color:#edbc6c}.border-focus-brightyellow65:focus,.border-hover-brightyellow65:hover{border-color:#edbc6c!important}.tl-brightyellow65 .rubix-timeline-body>ul>li:before{border-color:#edbc6c}.list-bg-brightyellow65>.list-group-item.active{background:#edbc6c!important;color:#fff!important}.list-fg-brightyellow65>.list-group-item{color:#edbc6c}.btn-yellow{background:#fadd7f;color:#fff;border-color:#fadd7f}.btn-yellow.btn-outlined{color:#fadd7f;background:none}.btn-yellow.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-yellow.btn-outlined.btn-onlyOnHover.active,.btn-yellow.btn-outlined.btn-onlyOnHover:focus,.btn-yellow.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-yellow.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-yellow.btn-outlined.btn-inverse.active,.btn-yellow.btn-outlined.btn-inverse:focus,.btn-yellow.btn-outlined.btn-inverse:hover{color:#fadd7f;background:#fff}.btn-yellow.btn-outlined.btn-inverse.active.btn-retainBg,.btn-yellow.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-yellow.btn-outlined.btn-inverse:hover.btn-retainBg{background:#fadd7f;color:#fff;border-color:#fadd7f}.btn-yellow.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-yellow.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-yellow.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#f7c627;border-color:#d8a708}.btn-yellow.active,.btn-yellow.focus,.btn-yellow:focus,.btn-yellow:hover{color:#fff;background:#fceab0;border-color:#fceab0}.btn-yellow.active,.btn-yellow.active:focus,.btn-yellow.active:hover,.btn-yellow:active,.btn-yellow[aria-expanded=true],.btn-yellow[aria-expanded=true]:focus,.btn-yellow[aria-expanded=true]:hover,.open>.btn-yellow.dropdown-toggle{color:#fff;background:#f7c627;border-color:#d8a708;background-image:none}.btn-yellow.dropdown-toggle+ul li.active a{color:#fff;background:#fadd7f}.btn-yellow.disabled,.btn-yellow[disabled],fieldset[disabled] .btn-yellow{pointer-events:none}.btn-yellow .badge{color:#fadd7f;background-color:#fadd7f}.menu-yellow ul li.active a,.menu-yellow ul li.active a:hover{color:#fff;background:#fadd7f!important}.nav-yellow>li.active>a,.nav-yellow>rubix-menu>li.active>a,.nav-yellow>rubix-nav-item>li.active>a{color:#fff;background:#fadd7f;border-color:#fadd7f}.tab-yellow{border-color:#fadd7f}.tab-yellow>li.active>a{border-color:#fadd7f;border-bottom-color:transparent}.tab-yellow.nav-pills>li.active>a{background:#fadd7f;color:#fff}.rubix-panel-header.nav-inline .nav-yellow>li.active>a{border:1px solid #fadd7f;border-bottom:none}.rubix-panel-header.nav-inline .nav-yellow>li.open>.dropdown-toggle{color:#fff;background:none}.bg-yellow{background:#fadd7f!important}.bg-yellow table td,.bg-yellow th{border-color:rgba(0,0,0,.05)!important}.bg-focus-yellow:focus,.bg-hover-yellow:hover{background:#fadd7f!important}.fg-yellow,.fg-yellow .nav-tabs>li.active>a{color:#fadd7f}.fg-tab-active-yellow .nav-tabs>li.active>a{color:#fadd7f!important}.fg-focus-yellow:focus,.fg-hover-yellow:hover{color:#fadd7f}.border-yellow{border-color:#fadd7f!important}.border-yellow .rubix-timeline-body>ul,.border-yellow.rubix-timeline-view:before{border-color:#fadd7f}.border-focus-yellow:focus,.border-hover-yellow:hover{border-color:#fadd7f!important}.tl-yellow .rubix-timeline-body>ul>li:before{border-color:#fadd7f}.list-bg-yellow>.list-group-item.active{background:#fadd7f!important;color:#fff!important}.list-fg-yellow>.list-group-item{color:#fadd7f}.btn-paleyellow{background:#debc85;color:#fff;border-color:#debc85}.btn-paleyellow.btn-outlined{color:#debc85;background:none}.btn-paleyellow.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-paleyellow.btn-outlined.btn-onlyOnHover.active,.btn-paleyellow.btn-outlined.btn-onlyOnHover:focus,.btn-paleyellow.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-paleyellow.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-paleyellow.btn-outlined.btn-inverse.active,.btn-paleyellow.btn-outlined.btn-inverse:focus,.btn-paleyellow.btn-outlined.btn-inverse:hover{color:#debc85;background:#fff}.btn-paleyellow.btn-outlined.btn-inverse.active.btn-retainBg,.btn-paleyellow.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-paleyellow.btn-outlined.btn-inverse:hover.btn-retainBg{background:#debc85;color:#fff;border-color:#debc85}.btn-paleyellow.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-paleyellow.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-paleyellow.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#ca943d;border-color:#9f732b}.btn-paleyellow.active,.btn-paleyellow.focus,.btn-paleyellow:focus,.btn-paleyellow:hover{color:#fff;background:#e9d2ad;border-color:#e9d2ad}.btn-paleyellow.active,.btn-paleyellow.active:focus,.btn-paleyellow.active:hover,.btn-paleyellow:active,.btn-paleyellow[aria-expanded=true],.btn-paleyellow[aria-expanded=true]:focus,.btn-paleyellow[aria-expanded=true]:hover,.open>.btn-paleyellow.dropdown-toggle{color:#fff;background:#ca943d;border-color:#9f732b;background-image:none}.btn-paleyellow.dropdown-toggle+ul li.active a{color:#fff;background:#debc85}.btn-paleyellow.disabled,.btn-paleyellow[disabled],fieldset[disabled] .btn-paleyellow{pointer-events:none}.btn-paleyellow .badge{color:#debc85;background-color:#debc85}.menu-paleyellow ul li.active a,.menu-paleyellow ul li.active a:hover{color:#fff;background:#debc85!important}.nav-paleyellow>li.active>a,.nav-paleyellow>rubix-menu>li.active>a,.nav-paleyellow>rubix-nav-item>li.active>a{color:#fff;background:#debc85;border-color:#debc85}.tab-paleyellow{border-color:#debc85}.tab-paleyellow>li.active>a{border-color:#debc85;border-bottom-color:transparent}.tab-paleyellow.nav-pills>li.active>a{background:#debc85;color:#fff}.rubix-panel-header.nav-inline .nav-paleyellow>li.active>a{border:1px solid #debc85;border-bottom:none}.rubix-panel-header.nav-inline .nav-paleyellow>li.open>.dropdown-toggle{color:#fff;background:none}.bg-paleyellow{background:#debc85!important}.bg-paleyellow table td,.bg-paleyellow th{border-color:rgba(0,0,0,.05)!important}.bg-focus-paleyellow:focus,.bg-hover-paleyellow:hover{background:#debc85!important}.fg-paleyellow,.fg-paleyellow .nav-tabs>li.active>a{color:#debc85}.fg-tab-active-paleyellow .nav-tabs>li.active>a{color:#debc85!important}.fg-focus-paleyellow:focus,.fg-hover-paleyellow:hover{color:#debc85}.border-paleyellow{border-color:#debc85!important}.border-paleyellow .rubix-timeline-body>ul,.border-paleyellow.rubix-timeline-view:before{border-color:#debc85}.border-focus-paleyellow:focus,.border-hover-paleyellow:hover{border-color:#debc85!important}.tl-paleyellow .rubix-timeline-body>ul>li:before{border-color:#debc85}.list-bg-paleyellow>.list-group-item.active{background:#debc85!important;color:#fff!important}.list-fg-paleyellow>.list-group-item{color:#debc85}.btn-lightyellow{background:#fbe499;color:#fff;border-color:#fbe499}.btn-lightyellow.btn-outlined{color:#fbe499;background:none}.btn-lightyellow.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-lightyellow.btn-outlined.btn-onlyOnHover.active,.btn-lightyellow.btn-outlined.btn-onlyOnHover:focus,.btn-lightyellow.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-lightyellow.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-lightyellow.btn-outlined.btn-inverse.active,.btn-lightyellow.btn-outlined.btn-inverse:focus,.btn-lightyellow.btn-outlined.btn-inverse:hover{color:#fbe499;background:#fff}.btn-lightyellow.btn-outlined.btn-inverse.active.btn-retainBg,.btn-lightyellow.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-lightyellow.btn-outlined.btn-inverse:hover.btn-retainBg{background:#fbe499;color:#fff;border-color:#fbe499}.btn-lightyellow.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-lightyellow.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-lightyellow.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#f8cd41;border-color:#f2bb09}.btn-lightyellow.active,.btn-lightyellow.focus,.btn-lightyellow:focus,.btn-lightyellow:hover{color:#fff;background:#fdf1ca;border-color:#fdf1ca}.btn-lightyellow.active,.btn-lightyellow.active:focus,.btn-lightyellow.active:hover,.btn-lightyellow:active,.btn-lightyellow[aria-expanded=true],.btn-lightyellow[aria-expanded=true]:focus,.btn-lightyellow[aria-expanded=true]:hover,.open>.btn-lightyellow.dropdown-toggle{color:#fff;background:#f8cd41;border-color:#f2bb09;background-image:none}.btn-lightyellow.dropdown-toggle+ul li.active a{color:#fff;background:#fbe499}.btn-lightyellow.disabled,.btn-lightyellow[disabled],fieldset[disabled] .btn-lightyellow{pointer-events:none}.btn-lightyellow .badge{color:#fbe499;background-color:#fbe499}.menu-lightyellow ul li.active a,.menu-lightyellow ul li.active a:hover{color:#fff;background:#fbe499!important}.nav-lightyellow>li.active>a,.nav-lightyellow>rubix-menu>li.active>a,.nav-lightyellow>rubix-nav-item>li.active>a{color:#fff;background:#fbe499;border-color:#fbe499}.tab-lightyellow{border-color:#fbe499}.tab-lightyellow>li.active>a{border-color:#fbe499;border-bottom-color:transparent}.tab-lightyellow.nav-pills>li.active>a{background:#fbe499;color:#fff}.rubix-panel-header.nav-inline .nav-lightyellow>li.active>a{border:1px solid #fbe499;border-bottom:none}.rubix-panel-header.nav-inline .nav-lightyellow>li.open>.dropdown-toggle{color:#fff;background:none}.bg-lightyellow{background:#fbe499!important}.bg-lightyellow table td,.bg-lightyellow th{border-color:rgba(0,0,0,.05)!important}.bg-focus-lightyellow:focus,.bg-hover-lightyellow:hover{background:#fbe499!important}.fg-lightyellow,.fg-lightyellow .nav-tabs>li.active>a{color:#fbe499}.fg-tab-active-lightyellow .nav-tabs>li.active>a{color:#fbe499!important}.fg-focus-lightyellow:focus,.fg-hover-lightyellow:hover{color:#fbe499}.border-lightyellow{border-color:#fbe499!important}.border-lightyellow .rubix-timeline-body>ul,.border-lightyellow.rubix-timeline-view:before{border-color:#fbe499}.border-focus-lightyellow:focus,.border-hover-lightyellow:hover{border-color:#fbe499!important}.tl-lightyellow .rubix-timeline-body>ul>li:before{border-color:#fbe499}.list-bg-lightyellow>.list-group-item.active{background:#fbe499!important;color:#fff!important}.list-fg-lightyellow>.list-group-item{color:#fbe499}.btn-hoveryellow{background:#fff1e7;color:#fff;border-color:#fff1e7}.btn-hoveryellow.btn-outlined{color:#fff1e7;background:none}.btn-hoveryellow.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-hoveryellow.btn-outlined.btn-onlyOnHover.active,.btn-hoveryellow.btn-outlined.btn-onlyOnHover:focus,.btn-hoveryellow.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-hoveryellow.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-hoveryellow.btn-outlined.btn-inverse.active,.btn-hoveryellow.btn-outlined.btn-inverse:focus,.btn-hoveryellow.btn-outlined.btn-inverse:hover{color:#fff1e7;background:#fff}.btn-hoveryellow.btn-outlined.btn-inverse.active.btn-retainBg,.btn-hoveryellow.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-hoveryellow.btn-outlined.btn-inverse:hover.btn-retainBg{background:#fff1e7;color:#fff;border-color:#fff1e7}.btn-hoveryellow.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-hoveryellow.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-hoveryellow.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#ffbb8b;border-color:#ff984e}.btn-hoveryellow.active,.btn-hoveryellow.focus,.btn-hoveryellow:focus,.btn-hoveryellow:hover{color:#fff;background:#fff;border-color:#fff}.btn-hoveryellow.active,.btn-hoveryellow.active:focus,.btn-hoveryellow.active:hover,.btn-hoveryellow:active,.btn-hoveryellow[aria-expanded=true],.btn-hoveryellow[aria-expanded=true]:focus,.btn-hoveryellow[aria-expanded=true]:hover,.open>.btn-hoveryellow.dropdown-toggle{color:#fff;background:#ffbb8b;border-color:#ff984e;background-image:none}.btn-hoveryellow.dropdown-toggle+ul li.active a{color:#fff;background:#fff1e7}.btn-hoveryellow.disabled,.btn-hoveryellow[disabled],fieldset[disabled] .btn-hoveryellow{pointer-events:none}.btn-hoveryellow .badge{color:#fff1e7;background-color:#fff1e7}.menu-hoveryellow ul li.active a,.menu-hoveryellow ul li.active a:hover{color:#fff;background:#fff1e7!important}.nav-hoveryellow>li.active>a,.nav-hoveryellow>rubix-menu>li.active>a,.nav-hoveryellow>rubix-nav-item>li.active>a{color:#fff;background:#fff1e7;border-color:#fff1e7}.tab-hoveryellow{border-color:#fff1e7}.tab-hoveryellow>li.active>a{border-color:#fff1e7;border-bottom-color:transparent}.tab-hoveryellow.nav-pills>li.active>a{background:#fff1e7;color:#fff}.rubix-panel-header.nav-inline .nav-hoveryellow>li.active>a{border:1px solid #fff1e7;border-bottom:none}.rubix-panel-header.nav-inline .nav-hoveryellow>li.open>.dropdown-toggle{color:#fff;background:none}.bg-hoveryellow{background:#fff1e7!important}.bg-hoveryellow table td,.bg-hoveryellow th{border-color:rgba(0,0,0,.05)!important}.bg-focus-hoveryellow:focus,.bg-hover-hoveryellow:hover{background:#fff1e7!important}.fg-hoveryellow,.fg-hoveryellow .nav-tabs>li.active>a{color:#fff1e7}.fg-tab-active-hoveryellow .nav-tabs>li.active>a{color:#fff1e7!important}.fg-focus-hoveryellow:focus,.fg-hover-hoveryellow:hover{color:#fff1e7}.border-hoveryellow{border-color:#fff1e7!important}.border-hoveryellow .rubix-timeline-body>ul,.border-hoveryellow.rubix-timeline-view:before{border-color:#fff1e7}.border-focus-hoveryellow:focus,.border-hover-hoveryellow:hover{border-color:#fff1e7!important}.tl-hoveryellow .rubix-timeline-body>ul>li:before{border-color:#fff1e7}.list-bg-hoveryellow>.list-group-item.active{background:#fff1e7!important;color:#fff!important}.list-fg-hoveryellow>.list-group-item{color:#fff1e7}.btn-pink{background:#e299b7;color:#fff;border-color:#e299b7}.btn-pink.btn-outlined{color:#e299b7;background:none}.btn-pink.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-pink.btn-outlined.btn-onlyOnHover.active,.btn-pink.btn-outlined.btn-onlyOnHover:focus,.btn-pink.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-pink.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-pink.btn-outlined.btn-inverse.active,.btn-pink.btn-outlined.btn-inverse:focus,.btn-pink.btn-outlined.btn-inverse:hover{color:#e299b7;background:#fff}.btn-pink.btn-outlined.btn-inverse.active.btn-retainBg,.btn-pink.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-pink.btn-outlined.btn-inverse:hover.btn-retainBg{background:#e299b7;color:#fff;border-color:#e299b7}.btn-pink.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-pink.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-pink.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#ce5285;border-color:#b03266}.btn-pink.active,.btn-pink.focus,.btn-pink:focus,.btn-pink:hover{color:#fff;background:#edc1d3;border-color:#edc1d3}.btn-pink.active,.btn-pink.active:focus,.btn-pink.active:hover,.btn-pink:active,.btn-pink[aria-expanded=true],.btn-pink[aria-expanded=true]:focus,.btn-pink[aria-expanded=true]:hover,.open>.btn-pink.dropdown-toggle{color:#fff;background:#ce5285;border-color:#b03266;background-image:none}.btn-pink.dropdown-toggle+ul li.active a{color:#fff;background:#e299b7}.btn-pink.disabled,.btn-pink[disabled],fieldset[disabled] .btn-pink{pointer-events:none}.btn-pink .badge{color:#e299b7;background-color:#e299b7}.menu-pink ul li.active a,.menu-pink ul li.active a:hover{color:#fff;background:#e299b7!important}.nav-pink>li.active>a,.nav-pink>rubix-menu>li.active>a,.nav-pink>rubix-nav-item>li.active>a{color:#fff;background:#e299b7;border-color:#e299b7}.tab-pink{border-color:#e299b7}.tab-pink>li.active>a{border-color:#e299b7;border-bottom-color:transparent}.tab-pink.nav-pills>li.active>a{background:#e299b7;color:#fff}.rubix-panel-header.nav-inline .nav-pink>li.active>a{border:1px solid #e299b7;border-bottom:none}.rubix-panel-header.nav-inline .nav-pink>li.open>.dropdown-toggle{color:#fff;background:none}.bg-pink{background:#e299b7!important}.bg-pink table td,.bg-pink th{border-color:rgba(0,0,0,.05)!important}.bg-focus-pink:focus,.bg-hover-pink:hover{background:#e299b7!important}.fg-pink,.fg-pink .nav-tabs>li.active>a{color:#e299b7}.fg-tab-active-pink .nav-tabs>li.active>a{color:#e299b7!important}.fg-focus-pink:focus,.fg-hover-pink:hover{color:#e299b7}.border-pink{border-color:#e299b7!important}.border-pink .rubix-timeline-body>ul,.border-pink.rubix-timeline-view:before{border-color:#e299b7}.border-focus-pink:focus,.border-hover-pink:hover{border-color:#e299b7!important}.tl-pink .rubix-timeline-body>ul>li:before{border-color:#e299b7}.list-bg-pink>.list-group-item.active{background:#e299b7!important;color:#fff!important}.list-fg-pink>.list-group-item{color:#e299b7}.btn-lightpink{background:#ecbcd0;color:#fff;border-color:#ecbcd0}.btn-lightpink.btn-outlined{color:#ecbcd0;background:none}.btn-lightpink.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-lightpink.btn-outlined.btn-onlyOnHover.active,.btn-lightpink.btn-outlined.btn-onlyOnHover:focus,.btn-lightpink.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-lightpink.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-lightpink.btn-outlined.btn-inverse.active,.btn-lightpink.btn-outlined.btn-inverse:focus,.btn-lightpink.btn-outlined.btn-inverse:hover{color:#ecbcd0;background:#fff}.btn-lightpink.btn-outlined.btn-inverse.active.btn-retainBg,.btn-lightpink.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-lightpink.btn-outlined.btn-inverse:hover.btn-retainBg{background:#ecbcd0;color:#fff;border-color:#ecbcd0}.btn-lightpink.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-lightpink.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-lightpink.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#d8749e;border-color:#ca457c}.btn-lightpink.active,.btn-lightpink.focus,.btn-lightpink:focus,.btn-lightpink:hover{color:#fff;background:#f7e4ec;border-color:#f7e4ec}.btn-lightpink.active,.btn-lightpink.active:focus,.btn-lightpink.active:hover,.btn-lightpink:active,.btn-lightpink[aria-expanded=true],.btn-lightpink[aria-expanded=true]:focus,.btn-lightpink[aria-expanded=true]:hover,.open>.btn-lightpink.dropdown-toggle{color:#fff;background:#d8749e;border-color:#ca457c;background-image:none}.btn-lightpink.dropdown-toggle+ul li.active a{color:#fff;background:#ecbcd0}.btn-lightpink.disabled,.btn-lightpink[disabled],fieldset[disabled] .btn-lightpink{pointer-events:none}.btn-lightpink .badge{color:#ecbcd0;background-color:#ecbcd0}.menu-lightpink ul li.active a,.menu-lightpink ul li.active a:hover{color:#fff;background:#ecbcd0!important}.nav-lightpink>li.active>a,.nav-lightpink>rubix-menu>li.active>a,.nav-lightpink>rubix-nav-item>li.active>a{color:#fff;background:#ecbcd0;border-color:#ecbcd0}.tab-lightpink{border-color:#ecbcd0}.tab-lightpink>li.active>a{border-color:#ecbcd0;border-bottom-color:transparent}.tab-lightpink.nav-pills>li.active>a{background:#ecbcd0;color:#fff}.rubix-panel-header.nav-inline .nav-lightpink>li.active>a{border:1px solid #ecbcd0;border-bottom:none}.rubix-panel-header.nav-inline .nav-lightpink>li.open>.dropdown-toggle{color:#fff;background:none}.bg-lightpink{background:#ecbcd0!important}.bg-lightpink table td,.bg-lightpink th{border-color:rgba(0,0,0,.05)!important}.bg-focus-lightpink:focus,.bg-hover-lightpink:hover{background:#ecbcd0!important}.fg-lightpink,.fg-lightpink .nav-tabs>li.active>a{color:#ecbcd0}.fg-tab-active-lightpink .nav-tabs>li.active>a{color:#ecbcd0!important}.fg-focus-lightpink:focus,.fg-hover-lightpink:hover{color:#ecbcd0}.border-lightpink{border-color:#ecbcd0!important}.border-lightpink .rubix-timeline-body>ul,.border-lightpink.rubix-timeline-view:before{border-color:#ecbcd0}.border-focus-lightpink:focus,.border-hover-lightpink:hover{border-color:#ecbcd0!important}.tl-lightpink .rubix-timeline-body>ul>li:before{border-color:#ecbcd0}.list-bg-lightpink>.list-group-item.active{background:#ecbcd0!important;color:#fff!important}.list-fg-lightpink>.list-group-item{color:#ecbcd0}.btn-paleblue{background:#a5c7ec;color:#fff;border-color:#a5c7ec}.btn-paleblue.btn-outlined{color:#a5c7ec;background:none}.btn-paleblue.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-paleblue.btn-outlined.btn-onlyOnHover.active,.btn-paleblue.btn-outlined.btn-onlyOnHover:focus,.btn-paleblue.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-paleblue.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-paleblue.btn-outlined.btn-inverse.active,.btn-paleblue.btn-outlined.btn-inverse:focus,.btn-paleblue.btn-outlined.btn-inverse:hover{color:#a5c7ec;background:#fff}.btn-paleblue.btn-outlined.btn-inverse.active.btn-retainBg,.btn-paleblue.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-paleblue.btn-outlined.btn-inverse:hover.btn-retainBg{background:#a5c7ec;color:#fff;border-color:#a5c7ec}.btn-paleblue.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-paleblue.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-paleblue.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#5998dc;border-color:#2b79cd}.btn-paleblue.active,.btn-paleblue.focus,.btn-paleblue:focus,.btn-paleblue:hover{color:#fff;background:#cfe1f5;border-color:#cfe1f5}.btn-paleblue.active,.btn-paleblue.active:focus,.btn-paleblue.active:hover,.btn-paleblue:active,.btn-paleblue[aria-expanded=true],.btn-paleblue[aria-expanded=true]:focus,.btn-paleblue[aria-expanded=true]:hover,.open>.btn-paleblue.dropdown-toggle{color:#fff;background:#5998dc;border-color:#2b79cd;background-image:none}.btn-paleblue.dropdown-toggle+ul li.active a{color:#fff;background:#a5c7ec}.btn-paleblue.disabled,.btn-paleblue[disabled],fieldset[disabled] .btn-paleblue{pointer-events:none}.btn-paleblue .badge{color:#a5c7ec;background-color:#a5c7ec}.menu-paleblue ul li.active a,.menu-paleblue ul li.active a:hover{color:#fff;background:#a5c7ec!important}.nav-paleblue>li.active>a,.nav-paleblue>rubix-menu>li.active>a,.nav-paleblue>rubix-nav-item>li.active>a{color:#fff;background:#a5c7ec;border-color:#a5c7ec}.tab-paleblue{border-color:#a5c7ec}.tab-paleblue>li.active>a{border-color:#a5c7ec;border-bottom-color:transparent}.tab-paleblue.nav-pills>li.active>a{background:#a5c7ec;color:#fff}.rubix-panel-header.nav-inline .nav-paleblue>li.active>a{border:1px solid #a5c7ec;border-bottom:none}.rubix-panel-header.nav-inline .nav-paleblue>li.open>.dropdown-toggle{color:#fff;background:none}.bg-paleblue{background:#a5c7ec!important}.bg-paleblue table td,.bg-paleblue th{border-color:rgba(0,0,0,.05)!important}.bg-focus-paleblue:focus,.bg-hover-paleblue:hover{background:#a5c7ec!important}.fg-paleblue,.fg-paleblue .nav-tabs>li.active>a{color:#a5c7ec}.fg-tab-active-paleblue .nav-tabs>li.active>a{color:#a5c7ec!important}.fg-focus-paleblue:focus,.fg-hover-paleblue:hover{color:#a5c7ec}.border-paleblue{border-color:#a5c7ec!important}.border-paleblue .rubix-timeline-body>ul,.border-paleblue.rubix-timeline-view:before{border-color:#a5c7ec}.border-focus-paleblue:focus,.border-hover-paleblue:hover{border-color:#a5c7ec!important}.tl-paleblue .rubix-timeline-body>ul>li:before{border-color:#a5c7ec}.list-bg-paleblue>.list-group-item.active{background:#a5c7ec!important;color:#fff!important}.list-fg-paleblue>.list-group-item{color:#a5c7ec}.btn-palegreen{background:#a0dfcc;color:#fff;border-color:#a0dfcc}.btn-palegreen.btn-outlined{color:#a0dfcc;background:none}.btn-palegreen.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-palegreen.btn-outlined.btn-onlyOnHover.active,.btn-palegreen.btn-outlined.btn-onlyOnHover:focus,.btn-palegreen.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-palegreen.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-palegreen.btn-outlined.btn-inverse.active,.btn-palegreen.btn-outlined.btn-inverse:focus,.btn-palegreen.btn-outlined.btn-inverse:hover{color:#a0dfcc;background:#fff}.btn-palegreen.btn-outlined.btn-inverse.active.btn-retainBg,.btn-palegreen.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-palegreen.btn-outlined.btn-inverse:hover.btn-retainBg{background:#a0dfcc;color:#fff;border-color:#a0dfcc}.btn-palegreen.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-palegreen.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-palegreen.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#5bc8a7;border-color:#3aac8a}.btn-palegreen.active,.btn-palegreen.focus,.btn-palegreen:focus,.btn-palegreen:hover{color:#fff;background:#c6ece0;border-color:#c6ece0}.btn-palegreen.active,.btn-palegreen.active:focus,.btn-palegreen.active:hover,.btn-palegreen:active,.btn-palegreen[aria-expanded=true],.btn-palegreen[aria-expanded=true]:focus,.btn-palegreen[aria-expanded=true]:hover,.open>.btn-palegreen.dropdown-toggle{color:#fff;background:#5bc8a7;border-color:#3aac8a;background-image:none}.btn-palegreen.dropdown-toggle+ul li.active a{color:#fff;background:#a0dfcc}.btn-palegreen.disabled,.btn-palegreen[disabled],fieldset[disabled] .btn-palegreen{pointer-events:none}.btn-palegreen .badge{color:#a0dfcc;background-color:#a0dfcc}.menu-palegreen ul li.active a,.menu-palegreen ul li.active a:hover{color:#fff;background:#a0dfcc!important}.nav-palegreen>li.active>a,.nav-palegreen>rubix-menu>li.active>a,.nav-palegreen>rubix-nav-item>li.active>a{color:#fff;background:#a0dfcc;border-color:#a0dfcc}.tab-palegreen{border-color:#a0dfcc}.tab-palegreen>li.active>a{border-color:#a0dfcc;border-bottom-color:transparent}.tab-palegreen.nav-pills>li.active>a{background:#a0dfcc;color:#fff}.rubix-panel-header.nav-inline .nav-palegreen>li.active>a{border:1px solid #a0dfcc;border-bottom:none}.rubix-panel-header.nav-inline .nav-palegreen>li.open>.dropdown-toggle{color:#fff;background:none}.bg-palegreen{background:#a0dfcc!important}.bg-palegreen table td,.bg-palegreen th{border-color:rgba(0,0,0,.05)!important}.bg-focus-palegreen:focus,.bg-hover-palegreen:hover{background:#a0dfcc!important}.fg-palegreen,.fg-palegreen .nav-tabs>li.active>a{color:#a0dfcc}.fg-tab-active-palegreen .nav-tabs>li.active>a{color:#a0dfcc!important}.fg-focus-palegreen:focus,.fg-hover-palegreen:hover{color:#a0dfcc}.border-palegreen{border-color:#a0dfcc!important}.border-palegreen .rubix-timeline-body>ul,.border-palegreen.rubix-timeline-view:before{border-color:#a0dfcc}.border-focus-palegreen:focus,.border-hover-palegreen:hover{border-color:#a0dfcc!important}.tl-palegreen .rubix-timeline-body>ul>li:before{border-color:#a0dfcc}.list-bg-palegreen>.list-group-item.active{background:#a0dfcc!important;color:#fff!important}.list-fg-palegreen>.list-group-item{color:#a0dfcc}.btn-palepink{background:#e394b3;color:#fff;border-color:#e394b3}.btn-palepink.btn-outlined{color:#e394b3;background:none}.btn-palepink.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-palepink.btn-outlined.btn-onlyOnHover.active,.btn-palepink.btn-outlined.btn-onlyOnHover:focus,.btn-palepink.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-palepink.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-palepink.btn-outlined.btn-inverse.active,.btn-palepink.btn-outlined.btn-inverse:focus,.btn-palepink.btn-outlined.btn-inverse:hover{color:#e394b3;background:#fff}.btn-palepink.btn-outlined.btn-inverse.active.btn-retainBg,.btn-palepink.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-palepink.btn-outlined.btn-inverse:hover.btn-retainBg{background:#e394b3;color:#fff;border-color:#e394b3}.btn-palepink.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-palepink.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-palepink.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#d04b7f;border-color:#b02e61}.btn-palepink.active,.btn-palepink.focus,.btn-palepink:focus,.btn-palepink:hover{color:#fff;background:#eebcd0;border-color:#eebcd0}.btn-palepink.active,.btn-palepink.active:focus,.btn-palepink.active:hover,.btn-palepink:active,.btn-palepink[aria-expanded=true],.btn-palepink[aria-expanded=true]:focus,.btn-palepink[aria-expanded=true]:hover,.open>.btn-palepink.dropdown-toggle{color:#fff;background:#d04b7f;border-color:#b02e61;background-image:none}.btn-palepink.dropdown-toggle+ul li.active a{color:#fff;background:#e394b3}.btn-palepink.disabled,.btn-palepink[disabled],fieldset[disabled] .btn-palepink{pointer-events:none}.btn-palepink .badge{color:#e394b3;background-color:#e394b3}.menu-palepink ul li.active a,.menu-palepink ul li.active a:hover{color:#fff;background:#e394b3!important}.nav-palepink>li.active>a,.nav-palepink>rubix-menu>li.active>a,.nav-palepink>rubix-nav-item>li.active>a{color:#fff;background:#e394b3;border-color:#e394b3}.tab-palepink{border-color:#e394b3}.tab-palepink>li.active>a{border-color:#e394b3;border-bottom-color:transparent}.tab-palepink.nav-pills>li.active>a{background:#e394b3;color:#fff}.rubix-panel-header.nav-inline .nav-palepink>li.active>a{border:1px solid #e394b3;border-bottom:none}.rubix-panel-header.nav-inline .nav-palepink>li.open>.dropdown-toggle{color:#fff;background:none}.bg-palepink{background:#e394b3!important}.bg-palepink table td,.bg-palepink th{border-color:rgba(0,0,0,.05)!important}.bg-focus-palepink:focus,.bg-hover-palepink:hover{background:#e394b3!important}.fg-palepink,.fg-palepink .nav-tabs>li.active>a{color:#e394b3}.fg-tab-active-palepink .nav-tabs>li.active>a{color:#e394b3!important}.fg-focus-palepink:focus,.fg-hover-palepink:hover{color:#e394b3}.border-palepink{border-color:#e394b3!important}.border-palepink .rubix-timeline-body>ul,.border-palepink.rubix-timeline-view:before{border-color:#e394b3}.border-focus-palepink:focus,.border-hover-palepink:hover{border-color:#e394b3!important}.tl-palepink .rubix-timeline-body>ul>li:before{border-color:#e394b3}.list-bg-palepink>.list-group-item.active{background:#e394b3!important;color:#fff!important}.list-fg-palepink>.list-group-item{color:#e394b3}.btn-brownishgray{background:#64584c;color:#fff;border-color:#64584c}.btn-brownishgray.btn-outlined{color:#64584c;background:none}.btn-brownishgray.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-brownishgray.btn-outlined.btn-onlyOnHover.active,.btn-brownishgray.btn-outlined.btn-onlyOnHover:focus,.btn-brownishgray.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-brownishgray.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-brownishgray.btn-outlined.btn-inverse.active,.btn-brownishgray.btn-outlined.btn-inverse:focus,.btn-brownishgray.btn-outlined.btn-inverse:hover{color:#64584c;background:#fff}.btn-brownishgray.btn-outlined.btn-inverse.active.btn-retainBg,.btn-brownishgray.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-brownishgray.btn-outlined.btn-inverse:hover.btn-retainBg{background:#64584c;color:#fff;border-color:#64584c}.btn-brownishgray.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-brownishgray.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-brownishgray.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#302a24;border-color:#0d0c0a}.btn-brownishgray.active,.btn-brownishgray.focus,.btn-brownishgray:focus,.btn-brownishgray:hover{color:#fff;background:#817262;border-color:#817262}.btn-brownishgray.active,.btn-brownishgray.active:focus,.btn-brownishgray.active:hover,.btn-brownishgray:active,.btn-brownishgray[aria-expanded=true],.btn-brownishgray[aria-expanded=true]:focus,.btn-brownishgray[aria-expanded=true]:hover,.open>.btn-brownishgray.dropdown-toggle{color:#fff;background:#302a24;border-color:#0d0c0a;background-image:none}.btn-brownishgray.dropdown-toggle+ul li.active a{color:#fff;background:#64584c}.btn-brownishgray.disabled,.btn-brownishgray[disabled],fieldset[disabled] .btn-brownishgray{pointer-events:none}.btn-brownishgray .badge{color:#64584c;background-color:#64584c}.menu-brownishgray ul li.active a,.menu-brownishgray ul li.active a:hover{color:#fff;background:#64584c!important}.nav-brownishgray>li.active>a,.nav-brownishgray>rubix-menu>li.active>a,.nav-brownishgray>rubix-nav-item>li.active>a{color:#fff;background:#64584c;border-color:#64584c}.tab-brownishgray{border-color:#64584c}.tab-brownishgray>li.active>a{border-color:#64584c;border-bottom-color:transparent}.tab-brownishgray.nav-pills>li.active>a{background:#64584c;color:#fff}.rubix-panel-header.nav-inline .nav-brownishgray>li.active>a{border:1px solid #64584c;border-bottom:none}.rubix-panel-header.nav-inline .nav-brownishgray>li.open>.dropdown-toggle{color:#fff;background:none}.bg-brownishgray{background:#64584c!important}.bg-brownishgray table td,.bg-brownishgray th{border-color:rgba(0,0,0,.05)!important}.bg-focus-brownishgray:focus,.bg-hover-brownishgray:hover{background:#64584c!important}.fg-brownishgray,.fg-brownishgray .nav-tabs>li.active>a{color:#64584c}.fg-tab-active-brownishgray .nav-tabs>li.active>a{color:#64584c!important}.fg-focus-brownishgray:focus,.fg-hover-brownishgray:hover{color:#64584c}.border-brownishgray{border-color:#64584c!important}.border-brownishgray .rubix-timeline-body>ul,.border-brownishgray.rubix-timeline-view:before{border-color:#64584c}.border-focus-brownishgray:focus,.border-hover-brownishgray:hover{border-color:#64584c!important}.tl-brownishgray .rubix-timeline-body>ul>li:before{border-color:#64584c}.list-bg-brownishgray>.list-group-item.active{background:#64584c!important;color:#fff!important}.list-fg-brownishgray>.list-group-item{color:#64584c}.btn-brownishgray75{background:#776b5f;color:#fff;border-color:#776b5f}.btn-brownishgray75.btn-outlined{color:#776b5f;background:none}.btn-brownishgray75.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-brownishgray75.btn-outlined.btn-onlyOnHover.active,.btn-brownishgray75.btn-outlined.btn-onlyOnHover:focus,.btn-brownishgray75.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-brownishgray75.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-brownishgray75.btn-outlined.btn-inverse.active,.btn-brownishgray75.btn-outlined.btn-inverse:focus,.btn-brownishgray75.btn-outlined.btn-inverse:hover{color:#776b5f;background:#fff}.btn-brownishgray75.btn-outlined.btn-inverse.active.btn-retainBg,.btn-brownishgray75.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-brownishgray75.btn-outlined.btn-inverse:hover.btn-retainBg{background:#776b5f;color:#fff;border-color:#776b5f}.btn-brownishgray75.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-brownishgray75.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-brownishgray75.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#443d36;border-color:#221f1b}.btn-brownishgray75.active,.btn-brownishgray75.focus,.btn-brownishgray75:focus,.btn-brownishgray75:hover{color:#fff;background:#928577;border-color:#928577}.btn-brownishgray75.active,.btn-brownishgray75.active:focus,.btn-brownishgray75.active:hover,.btn-brownishgray75:active,.btn-brownishgray75[aria-expanded=true],.btn-brownishgray75[aria-expanded=true]:focus,.btn-brownishgray75[aria-expanded=true]:hover,.open>.btn-brownishgray75.dropdown-toggle{color:#fff;background:#443d36;border-color:#221f1b;background-image:none}.btn-brownishgray75.dropdown-toggle+ul li.active a{color:#fff;background:#776b5f}.btn-brownishgray75.disabled,.btn-brownishgray75[disabled],fieldset[disabled] .btn-brownishgray75{pointer-events:none}.btn-brownishgray75 .badge{color:#776b5f;background-color:#776b5f}.menu-brownishgray75 ul li.active a,.menu-brownishgray75 ul li.active a:hover{color:#fff;background:#776b5f!important}.nav-brownishgray75>li.active>a,.nav-brownishgray75>rubix-menu>li.active>a,.nav-brownishgray75>rubix-nav-item>li.active>a{color:#fff;background:#776b5f;border-color:#776b5f}.tab-brownishgray75{border-color:#776b5f}.tab-brownishgray75>li.active>a{border-color:#776b5f;border-bottom-color:transparent}.tab-brownishgray75.nav-pills>li.active>a{background:#776b5f;color:#fff}.rubix-panel-header.nav-inline .nav-brownishgray75>li.active>a{border:1px solid #776b5f;border-bottom:none}.rubix-panel-header.nav-inline .nav-brownishgray75>li.open>.dropdown-toggle{color:#fff;background:none}.bg-brownishgray75{background:#776b5f!important}.bg-brownishgray75 table td,.bg-brownishgray75 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-brownishgray75:focus,.bg-hover-brownishgray75:hover{background:#776b5f!important}.fg-brownishgray75,.fg-brownishgray75 .nav-tabs>li.active>a{color:#776b5f}.fg-tab-active-brownishgray75 .nav-tabs>li.active>a{color:#776b5f!important}.fg-focus-brownishgray75:focus,.fg-hover-brownishgray75:hover{color:#776b5f}.border-brownishgray75{border-color:#776b5f!important}.border-brownishgray75 .rubix-timeline-body>ul,.border-brownishgray75.rubix-timeline-view:before{border-color:#776b5f}.border-focus-brownishgray75:focus,.border-hover-brownishgray75:hover{border-color:#776b5f!important}.tl-brownishgray75 .rubix-timeline-body>ul>li:before{border-color:#776b5f}.list-bg-brownishgray75>.list-group-item.active{background:#776b5f!important;color:#fff!important}.list-fg-brownishgray75>.list-group-item{color:#776b5f}.btn-gray{background:#eaedf1;color:#fff;border-color:#eaedf1}.btn-gray.btn-outlined{color:#eaedf1;background:none}.btn-gray.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-gray.btn-outlined.btn-onlyOnHover.active,.btn-gray.btn-outlined.btn-onlyOnHover:focus,.btn-gray.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-gray.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-gray.btn-outlined.btn-inverse.active,.btn-gray.btn-outlined.btn-inverse:focus,.btn-gray.btn-outlined.btn-inverse:hover{color:#eaedf1;background:#fff}.btn-gray.btn-outlined.btn-inverse.active.btn-retainBg,.btn-gray.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-gray.btn-outlined.btn-inverse:hover.btn-retainBg{background:#eaedf1;color:#fff;border-color:#eaedf1}.btn-gray.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-gray.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-gray.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#b3becc;border-color:#8e9eb4}.btn-gray.active,.btn-gray.focus,.btn-gray:focus,.btn-gray:hover{color:#fff;background:#fff;border-color:#fff}.btn-gray.active,.btn-gray.active:focus,.btn-gray.active:hover,.btn-gray:active,.btn-gray[aria-expanded=true],.btn-gray[aria-expanded=true]:focus,.btn-gray[aria-expanded=true]:hover,.open>.btn-gray.dropdown-toggle{color:#fff;background:#b3becc;border-color:#8e9eb4;background-image:none}.btn-gray.dropdown-toggle+ul li.active a{color:#fff;background:#eaedf1}.btn-gray.disabled,.btn-gray[disabled],fieldset[disabled] .btn-gray{pointer-events:none}.btn-gray .badge{color:#eaedf1;background-color:#eaedf1}.menu-gray ul li.active a,.menu-gray ul li.active a:hover{color:#fff;background:#eaedf1!important}.nav-gray>li.active>a,.nav-gray>rubix-menu>li.active>a,.nav-gray>rubix-nav-item>li.active>a{color:#fff;background:#eaedf1;border-color:#eaedf1}.tab-gray{border-color:#eaedf1}.tab-gray>li.active>a{border-color:#eaedf1;border-bottom-color:transparent}.tab-gray.nav-pills>li.active>a{background:#eaedf1;color:#fff}.rubix-panel-header.nav-inline .nav-gray>li.active>a{border:1px solid #eaedf1;border-bottom:none}.rubix-panel-header.nav-inline .nav-gray>li.open>.dropdown-toggle{color:#fff;background:none}.bg-gray{background:#eaedf1!important}.bg-gray table td,.bg-gray th{border-color:rgba(0,0,0,.05)!important}.bg-focus-gray:focus,.bg-hover-gray:hover{background:#eaedf1!important}.fg-gray,.fg-gray .nav-tabs>li.active>a{color:#eaedf1}.fg-tab-active-gray .nav-tabs>li.active>a{color:#eaedf1!important}.fg-focus-gray:focus,.fg-hover-gray:hover{color:#eaedf1}.border-gray{border-color:#eaedf1!important}.border-gray .rubix-timeline-body>ul,.border-gray.rubix-timeline-view:before{border-color:#eaedf1}.border-focus-gray:focus,.border-hover-gray:hover{border-color:#eaedf1!important}.tl-gray .rubix-timeline-body>ul>li:before{border-color:#eaedf1}.list-bg-gray>.list-group-item.active{background:#eaedf1!important;color:#fff!important}.list-fg-gray>.list-group-item{color:#eaedf1}.btn-darkgray{background:#999895;color:#fff;border-color:#999895}.btn-darkgray.btn-outlined{color:#999895;background:none}.btn-darkgray.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkgray.btn-outlined.btn-onlyOnHover.active,.btn-darkgray.btn-outlined.btn-onlyOnHover:focus,.btn-darkgray.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkgray.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkgray.btn-outlined.btn-inverse.active,.btn-darkgray.btn-outlined.btn-inverse:focus,.btn-darkgray.btn-outlined.btn-inverse:hover{color:#999895;background:#fff}.btn-darkgray.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkgray.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkgray.btn-outlined.btn-inverse:hover.btn-retainBg{background:#999895;color:#fff;border-color:#999895}.btn-darkgray.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkgray.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkgray.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#6b6a67;border-color:#4c4b49}.btn-darkgray.active,.btn-darkgray.focus,.btn-darkgray:focus,.btn-darkgray:hover{color:#fff;background:#b2b1af;border-color:#b2b1af}.btn-darkgray.active,.btn-darkgray.active:focus,.btn-darkgray.active:hover,.btn-darkgray:active,.btn-darkgray[aria-expanded=true],.btn-darkgray[aria-expanded=true]:focus,.btn-darkgray[aria-expanded=true]:hover,.open>.btn-darkgray.dropdown-toggle{color:#fff;background:#6b6a67;border-color:#4c4b49;background-image:none}.btn-darkgray.dropdown-toggle+ul li.active a{color:#fff;background:#999895}.btn-darkgray.disabled,.btn-darkgray[disabled],fieldset[disabled] .btn-darkgray{pointer-events:none}.btn-darkgray .badge{color:#999895;background-color:#999895}.menu-darkgray ul li.active a,.menu-darkgray ul li.active a:hover{color:#fff;background:#999895!important}.nav-darkgray>li.active>a,.nav-darkgray>rubix-menu>li.active>a,.nav-darkgray>rubix-nav-item>li.active>a{color:#fff;background:#999895;border-color:#999895}.tab-darkgray{border-color:#999895}.tab-darkgray>li.active>a{border-color:#999895;border-bottom-color:transparent}.tab-darkgray.nav-pills>li.active>a{background:#999895;color:#fff}.rubix-panel-header.nav-inline .nav-darkgray>li.active>a{border:1px solid #999895;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkgray>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkgray{background:#999895!important}.bg-darkgray table td,.bg-darkgray th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkgray:focus,.bg-hover-darkgray:hover{background:#999895!important}.fg-darkgray,.fg-darkgray .nav-tabs>li.active>a{color:#999895}.fg-tab-active-darkgray .nav-tabs>li.active>a{color:#999895!important}.fg-focus-darkgray:focus,.fg-hover-darkgray:hover{color:#999895}.border-darkgray{border-color:#999895!important}.border-darkgray .rubix-timeline-body>ul,.border-darkgray.rubix-timeline-view:before{border-color:#999895}.border-focus-darkgray:focus,.border-hover-darkgray:hover{border-color:#999895!important}.tl-darkgray .rubix-timeline-body>ul>li:before{border-color:#999895}.list-bg-darkgray>.list-group-item.active{background:#999895!important;color:#fff!important}.list-fg-darkgray>.list-group-item{color:#999895}.btn-darkgray75{background:#b8b6b0;color:#fff;border-color:#b8b6b0}.btn-darkgray75.btn-outlined{color:#b8b6b0;background:none}.btn-darkgray75.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkgray75.btn-outlined.btn-onlyOnHover.active,.btn-darkgray75.btn-outlined.btn-onlyOnHover:focus,.btn-darkgray75.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkgray75.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkgray75.btn-outlined.btn-inverse.active,.btn-darkgray75.btn-outlined.btn-inverse:focus,.btn-darkgray75.btn-outlined.btn-inverse:hover{color:#b8b6b0;background:#fff}.btn-darkgray75.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkgray75.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkgray75.btn-outlined.btn-inverse:hover.btn-retainBg{background:#b8b6b0;color:#fff;border-color:#b8b6b0}.btn-darkgray75.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkgray75.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkgray75.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#8d8980;border-color:#6d6a62}.btn-darkgray75.active,.btn-darkgray75.focus,.btn-darkgray75:focus,.btn-darkgray75:hover{color:#fff;background:#d0cfcb;border-color:#d0cfcb}.btn-darkgray75.active,.btn-darkgray75.active:focus,.btn-darkgray75.active:hover,.btn-darkgray75:active,.btn-darkgray75[aria-expanded=true],.btn-darkgray75[aria-expanded=true]:focus,.btn-darkgray75[aria-expanded=true]:hover,.open>.btn-darkgray75.dropdown-toggle{color:#fff;background:#8d8980;border-color:#6d6a62;background-image:none}.btn-darkgray75.dropdown-toggle+ul li.active a{color:#fff;background:#b8b6b0}.btn-darkgray75.disabled,.btn-darkgray75[disabled],fieldset[disabled] .btn-darkgray75{pointer-events:none}.btn-darkgray75 .badge{color:#b8b6b0;background-color:#b8b6b0}.menu-darkgray75 ul li.active a,.menu-darkgray75 ul li.active a:hover{color:#fff;background:#b8b6b0!important}.nav-darkgray75>li.active>a,.nav-darkgray75>rubix-menu>li.active>a,.nav-darkgray75>rubix-nav-item>li.active>a{color:#fff;background:#b8b6b0;border-color:#b8b6b0}.tab-darkgray75{border-color:#b8b6b0}.tab-darkgray75>li.active>a{border-color:#b8b6b0;border-bottom-color:transparent}.tab-darkgray75.nav-pills>li.active>a{background:#b8b6b0;color:#fff}.rubix-panel-header.nav-inline .nav-darkgray75>li.active>a{border:1px solid #b8b6b0;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkgray75>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkgray75{background:#b8b6b0!important}.bg-darkgray75 table td,.bg-darkgray75 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkgray75:focus,.bg-hover-darkgray75:hover{background:#b8b6b0!important}.fg-darkgray75,.fg-darkgray75 .nav-tabs>li.active>a{color:#b8b6b0}.fg-tab-active-darkgray75 .nav-tabs>li.active>a{color:#b8b6b0!important}.fg-focus-darkgray75:focus,.fg-hover-darkgray75:hover{color:#b8b6b0}.border-darkgray75{border-color:#b8b6b0!important}.border-darkgray75 .rubix-timeline-body>ul,.border-darkgray75.rubix-timeline-view:before{border-color:#b8b6b0}.border-focus-darkgray75:focus,.border-hover-darkgray75:hover{border-color:#b8b6b0!important}.tl-darkgray75 .rubix-timeline-body>ul>li:before{border-color:#b8b6b0}.list-bg-darkgray75>.list-group-item.active{background:#b8b6b0!important;color:#fff!important}.list-fg-darkgray75>.list-group-item{color:#b8b6b0}.btn-darkgray50{background:#b8c3c8;color:#fff;border-color:#b8c3c8}.btn-darkgray50.btn-outlined{color:#b8c3c8;background:none}.btn-darkgray50.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkgray50.btn-outlined.btn-onlyOnHover.active,.btn-darkgray50.btn-outlined.btn-onlyOnHover:focus,.btn-darkgray50.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkgray50.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkgray50.btn-outlined.btn-inverse.active,.btn-darkgray50.btn-outlined.btn-inverse:focus,.btn-darkgray50.btn-outlined.btn-inverse:hover{color:#b8c3c8;background:#fff}.btn-darkgray50.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkgray50.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkgray50.btn-outlined.btn-inverse:hover.btn-retainBg{background:#b8c3c8;color:#fff;border-color:#b8c3c8}.btn-darkgray50.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkgray50.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkgray50.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#8497a0;border-color:#657982}.btn-darkgray50.active,.btn-darkgray50.focus,.btn-darkgray50:focus,.btn-darkgray50:hover{color:#fff;background:#d5dbde;border-color:#d5dbde}.btn-darkgray50.active,.btn-darkgray50.active:focus,.btn-darkgray50.active:hover,.btn-darkgray50:active,.btn-darkgray50[aria-expanded=true],.btn-darkgray50[aria-expanded=true]:focus,.btn-darkgray50[aria-expanded=true]:hover,.open>.btn-darkgray50.dropdown-toggle{color:#fff;background:#8497a0;border-color:#657982;background-image:none}.btn-darkgray50.dropdown-toggle+ul li.active a{color:#fff;background:#b8c3c8}.btn-darkgray50.disabled,.btn-darkgray50[disabled],fieldset[disabled] .btn-darkgray50{pointer-events:none}.btn-darkgray50 .badge{color:#b8c3c8;background-color:#b8c3c8}.menu-darkgray50 ul li.active a,.menu-darkgray50 ul li.active a:hover{color:#fff;background:#b8c3c8!important}.nav-darkgray50>li.active>a,.nav-darkgray50>rubix-menu>li.active>a,.nav-darkgray50>rubix-nav-item>li.active>a{color:#fff;background:#b8c3c8;border-color:#b8c3c8}.tab-darkgray50{border-color:#b8c3c8}.tab-darkgray50>li.active>a{border-color:#b8c3c8;border-bottom-color:transparent}.tab-darkgray50.nav-pills>li.active>a{background:#b8c3c8;color:#fff}.rubix-panel-header.nav-inline .nav-darkgray50>li.active>a{border:1px solid #b8c3c8;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkgray50>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkgray50{background:#b8c3c8!important}.bg-darkgray50 table td,.bg-darkgray50 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkgray50:focus,.bg-hover-darkgray50:hover{background:#b8c3c8!important}.fg-darkgray50,.fg-darkgray50 .nav-tabs>li.active>a{color:#b8c3c8}.fg-tab-active-darkgray50 .nav-tabs>li.active>a{color:#b8c3c8!important}.fg-focus-darkgray50:focus,.fg-hover-darkgray50:hover{color:#b8c3c8}.border-darkgray50{border-color:#b8c3c8!important}.border-darkgray50 .rubix-timeline-body>ul,.border-darkgray50.rubix-timeline-view:before{border-color:#b8c3c8}.border-focus-darkgray50:focus,.border-hover-darkgray50:hover{border-color:#b8c3c8!important}.tl-darkgray50 .rubix-timeline-body>ul>li:before{border-color:#b8c3c8}.list-bg-darkgray50>.list-group-item.active{background:#b8c3c8!important;color:#fff!important}.list-fg-darkgray50>.list-group-item{color:#b8c3c8}.btn-darkgray40{background:#cdccc8;color:#fff;border-color:#cdccc8}.btn-darkgray40.btn-outlined{color:#cdccc8;background:none}.btn-darkgray40.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkgray40.btn-outlined.btn-onlyOnHover.active,.btn-darkgray40.btn-outlined.btn-onlyOnHover:focus,.btn-darkgray40.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkgray40.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkgray40.btn-outlined.btn-inverse.active,.btn-darkgray40.btn-outlined.btn-inverse:focus,.btn-darkgray40.btn-outlined.btn-inverse:hover{color:#cdccc8;background:#fff}.btn-darkgray40.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkgray40.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkgray40.btn-outlined.btn-inverse:hover.btn-retainBg{background:#cdccc8;color:#fff;border-color:#cdccc8}.btn-darkgray40.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkgray40.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkgray40.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#a19f98;border-color:#848278}.btn-darkgray40.active,.btn-darkgray40.focus,.btn-darkgray40:focus,.btn-darkgray40:hover{color:#fff;background:#e5e5e3;border-color:#e5e5e3}.btn-darkgray40.active,.btn-darkgray40.active:focus,.btn-darkgray40.active:hover,.btn-darkgray40:active,.btn-darkgray40[aria-expanded=true],.btn-darkgray40[aria-expanded=true]:focus,.btn-darkgray40[aria-expanded=true]:hover,.open>.btn-darkgray40.dropdown-toggle{color:#fff;background:#a19f98;border-color:#848278;background-image:none}.btn-darkgray40.dropdown-toggle+ul li.active a{color:#fff;background:#cdccc8}.btn-darkgray40.disabled,.btn-darkgray40[disabled],fieldset[disabled] .btn-darkgray40{pointer-events:none}.btn-darkgray40 .badge{color:#cdccc8;background-color:#cdccc8}.menu-darkgray40 ul li.active a,.menu-darkgray40 ul li.active a:hover{color:#fff;background:#cdccc8!important}.nav-darkgray40>li.active>a,.nav-darkgray40>rubix-menu>li.active>a,.nav-darkgray40>rubix-nav-item>li.active>a{color:#fff;background:#cdccc8;border-color:#cdccc8}.tab-darkgray40{border-color:#cdccc8}.tab-darkgray40>li.active>a{border-color:#cdccc8;border-bottom-color:transparent}.tab-darkgray40.nav-pills>li.active>a{background:#cdccc8;color:#fff}.rubix-panel-header.nav-inline .nav-darkgray40>li.active>a{border:1px solid #cdccc8;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkgray40>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkgray40{background:#cdccc8!important}.bg-darkgray40 table td,.bg-darkgray40 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkgray40:focus,.bg-hover-darkgray40:hover{background:#cdccc8!important}.fg-darkgray40,.fg-darkgray40 .nav-tabs>li.active>a{color:#cdccc8}.fg-tab-active-darkgray40 .nav-tabs>li.active>a{color:#cdccc8!important}.fg-focus-darkgray40:focus,.fg-hover-darkgray40:hover{color:#cdccc8}.border-darkgray40{border-color:#cdccc8!important}.border-darkgray40 .rubix-timeline-body>ul,.border-darkgray40.rubix-timeline-view:before{border-color:#cdccc8}.border-focus-darkgray40:focus,.border-hover-darkgray40:hover{border-color:#cdccc8!important}.tl-darkgray40 .rubix-timeline-body>ul>li:before{border-color:#cdccc8}.list-bg-darkgray40>.list-group-item.active{background:#cdccc8!important;color:#fff!important}.list-fg-darkgray40>.list-group-item{color:#cdccc8}.btn-darkgray25{background:#dcdbd8;color:#fff;border-color:#dcdbd8}.btn-darkgray25.btn-outlined{color:#dcdbd8;background:none}.btn-darkgray25.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkgray25.btn-outlined.btn-onlyOnHover.active,.btn-darkgray25.btn-outlined.btn-onlyOnHover:focus,.btn-darkgray25.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkgray25.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkgray25.btn-outlined.btn-inverse.active,.btn-darkgray25.btn-outlined.btn-inverse:focus,.btn-darkgray25.btn-outlined.btn-inverse:hover{color:#dcdbd8;background:#fff}.btn-darkgray25.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkgray25.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkgray25.btn-outlined.btn-inverse:hover.btn-retainBg{background:#dcdbd8;color:#fff;border-color:#dcdbd8}.btn-darkgray25.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkgray25.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkgray25.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#b1aea8;border-color:#949187}.btn-darkgray25.active,.btn-darkgray25.focus,.btn-darkgray25:focus,.btn-darkgray25:hover{color:#fff;background:#f4f4f3;border-color:#f4f4f3}.btn-darkgray25.active,.btn-darkgray25.active:focus,.btn-darkgray25.active:hover,.btn-darkgray25:active,.btn-darkgray25[aria-expanded=true],.btn-darkgray25[aria-expanded=true]:focus,.btn-darkgray25[aria-expanded=true]:hover,.open>.btn-darkgray25.dropdown-toggle{color:#fff;background:#b1aea8;border-color:#949187;background-image:none}.btn-darkgray25.dropdown-toggle+ul li.active a{color:#fff;background:#dcdbd8}.btn-darkgray25.disabled,.btn-darkgray25[disabled],fieldset[disabled] .btn-darkgray25{pointer-events:none}.btn-darkgray25 .badge{color:#dcdbd8;background-color:#dcdbd8}.menu-darkgray25 ul li.active a,.menu-darkgray25 ul li.active a:hover{color:#fff;background:#dcdbd8!important}.nav-darkgray25>li.active>a,.nav-darkgray25>rubix-menu>li.active>a,.nav-darkgray25>rubix-nav-item>li.active>a{color:#fff;background:#dcdbd8;border-color:#dcdbd8}.tab-darkgray25{border-color:#dcdbd8}.tab-darkgray25>li.active>a{border-color:#dcdbd8;border-bottom-color:transparent}.tab-darkgray25.nav-pills>li.active>a{background:#dcdbd8;color:#fff}.rubix-panel-header.nav-inline .nav-darkgray25>li.active>a{border:1px solid #dcdbd8;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkgray25>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkgray25{background:#dcdbd8!important}.bg-darkgray25 table td,.bg-darkgray25 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkgray25:focus,.bg-hover-darkgray25:hover{background:#dcdbd8!important}.fg-darkgray25,.fg-darkgray25 .nav-tabs>li.active>a{color:#dcdbd8}.fg-tab-active-darkgray25 .nav-tabs>li.active>a{color:#dcdbd8!important}.fg-focus-darkgray25:focus,.fg-hover-darkgray25:hover{color:#dcdbd8}.border-darkgray25{border-color:#dcdbd8!important}.border-darkgray25 .rubix-timeline-body>ul,.border-darkgray25.rubix-timeline-view:before{border-color:#dcdbd8}.border-focus-darkgray25:focus,.border-hover-darkgray25:hover{border-color:#dcdbd8!important}.tl-darkgray25 .rubix-timeline-body>ul>li:before{border-color:#dcdbd8}.list-bg-darkgray25>.list-group-item.active{background:#dcdbd8!important;color:#fff!important}.list-fg-darkgray25>.list-group-item{color:#dcdbd8}.btn-lightgray{background:#eeedeb;color:#fff;border-color:#eeedeb}.btn-lightgray.btn-outlined{color:#eeedeb;background:none}.btn-lightgray.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-lightgray.btn-outlined.btn-onlyOnHover.active,.btn-lightgray.btn-outlined.btn-onlyOnHover:focus,.btn-lightgray.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-lightgray.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-lightgray.btn-outlined.btn-inverse.active,.btn-lightgray.btn-outlined.btn-inverse:focus,.btn-lightgray.btn-outlined.btn-inverse:hover{color:#eeedeb;background:#fff}.btn-lightgray.btn-outlined.btn-inverse.active.btn-retainBg,.btn-lightgray.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-lightgray.btn-outlined.btn-inverse:hover.btn-retainBg{background:#eeedeb;color:#fff;border-color:#eeedeb}.btn-lightgray.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-lightgray.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-lightgray.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#c4c0b9;border-color:#a8a398}.btn-lightgray.active,.btn-lightgray.focus,.btn-lightgray:focus,.btn-lightgray:hover{color:#fff;background:#fff;border-color:#fff}.btn-lightgray.active,.btn-lightgray.active:focus,.btn-lightgray.active:hover,.btn-lightgray:active,.btn-lightgray[aria-expanded=true],.btn-lightgray[aria-expanded=true]:focus,.btn-lightgray[aria-expanded=true]:hover,.open>.btn-lightgray.dropdown-toggle{color:#fff;background:#c4c0b9;border-color:#a8a398;background-image:none}.btn-lightgray.dropdown-toggle+ul li.active a{color:#fff;background:#eeedeb}.btn-lightgray.disabled,.btn-lightgray[disabled],fieldset[disabled] .btn-lightgray{pointer-events:none}.btn-lightgray .badge{color:#eeedeb;background-color:#eeedeb}.menu-lightgray ul li.active a,.menu-lightgray ul li.active a:hover{color:#fff;background:#eeedeb!important}.nav-lightgray>li.active>a,.nav-lightgray>rubix-menu>li.active>a,.nav-lightgray>rubix-nav-item>li.active>a{color:#fff;background:#eeedeb;border-color:#eeedeb}.tab-lightgray{border-color:#eeedeb}.tab-lightgray>li.active>a{border-color:#eeedeb;border-bottom-color:transparent}.tab-lightgray.nav-pills>li.active>a{background:#eeedeb;color:#fff}.rubix-panel-header.nav-inline .nav-lightgray>li.active>a{border:1px solid #eeedeb;border-bottom:none}.rubix-panel-header.nav-inline .nav-lightgray>li.open>.dropdown-toggle{color:#fff;background:none}.bg-lightgray{background:#eeedeb!important}.bg-lightgray table td,.bg-lightgray th{border-color:rgba(0,0,0,.05)!important}.bg-focus-lightgray:focus,.bg-hover-lightgray:hover{background:#eeedeb!important}.fg-lightgray,.fg-lightgray .nav-tabs>li.active>a{color:#eeedeb}.fg-tab-active-lightgray .nav-tabs>li.active>a{color:#eeedeb!important}.fg-focus-lightgray:focus,.fg-hover-lightgray:hover{color:#eeedeb}.border-lightgray{border-color:#eeedeb!important}.border-lightgray .rubix-timeline-body>ul,.border-lightgray.rubix-timeline-view:before{border-color:#eeedeb}.border-focus-lightgray:focus,.border-hover-lightgray:hover{border-color:#eeedeb!important}.tl-lightgray .rubix-timeline-body>ul>li:before{border-color:#eeedeb}.list-bg-lightgray>.list-group-item.active{background:#eeedeb!important;color:#fff!important}.list-fg-lightgray>.list-group-item{color:#eeedeb}.btn-lightgray50{background:#f1f0ee;color:#fff;border-color:#f1f0ee}.btn-lightgray50.btn-outlined{color:#f1f0ee;background:none}.btn-lightgray50.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-lightgray50.btn-outlined.btn-onlyOnHover.active,.btn-lightgray50.btn-outlined.btn-onlyOnHover:focus,.btn-lightgray50.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-lightgray50.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-lightgray50.btn-outlined.btn-inverse.active,.btn-lightgray50.btn-outlined.btn-inverse:focus,.btn-lightgray50.btn-outlined.btn-inverse:hover{color:#f1f0ee;background:#fff}.btn-lightgray50.btn-outlined.btn-inverse.active.btn-retainBg,.btn-lightgray50.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-lightgray50.btn-outlined.btn-inverse:hover.btn-retainBg{background:#f1f0ee;color:#fff;border-color:#f1f0ee}.btn-lightgray50.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-lightgray50.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-lightgray50.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#c8c4bc;border-color:#aca69a}.btn-lightgray50.active,.btn-lightgray50.focus,.btn-lightgray50:focus,.btn-lightgray50:hover{color:#fff;background:#fff;border-color:#fff}.btn-lightgray50.active,.btn-lightgray50.active:focus,.btn-lightgray50.active:hover,.btn-lightgray50:active,.btn-lightgray50[aria-expanded=true],.btn-lightgray50[aria-expanded=true]:focus,.btn-lightgray50[aria-expanded=true]:hover,.open>.btn-lightgray50.dropdown-toggle{color:#fff;background:#c8c4bc;border-color:#aca69a;background-image:none}.btn-lightgray50.dropdown-toggle+ul li.active a{color:#fff;background:#f1f0ee}.btn-lightgray50.disabled,.btn-lightgray50[disabled],fieldset[disabled] .btn-lightgray50{pointer-events:none}.btn-lightgray50 .badge{color:#f1f0ee;background-color:#f1f0ee}.menu-lightgray50 ul li.active a,.menu-lightgray50 ul li.active a:hover{color:#fff;background:#f1f0ee!important}.nav-lightgray50>li.active>a,.nav-lightgray50>rubix-menu>li.active>a,.nav-lightgray50>rubix-nav-item>li.active>a{color:#fff;background:#f1f0ee;border-color:#f1f0ee}.tab-lightgray50{border-color:#f1f0ee}.tab-lightgray50>li.active>a{border-color:#f1f0ee;border-bottom-color:transparent}.tab-lightgray50.nav-pills>li.active>a{background:#f1f0ee;color:#fff}.rubix-panel-header.nav-inline .nav-lightgray50>li.active>a{border:1px solid #f1f0ee;border-bottom:none}.rubix-panel-header.nav-inline .nav-lightgray50>li.open>.dropdown-toggle{color:#fff;background:none}.bg-lightgray50{background:#f1f0ee!important}.bg-lightgray50 table td,.bg-lightgray50 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-lightgray50:focus,.bg-hover-lightgray50:hover{background:#f1f0ee!important}.fg-lightgray50,.fg-lightgray50 .nav-tabs>li.active>a{color:#f1f0ee}.fg-tab-active-lightgray50 .nav-tabs>li.active>a{color:#f1f0ee!important}.fg-focus-lightgray50:focus,.fg-hover-lightgray50:hover{color:#f1f0ee}.border-lightgray50{border-color:#f1f0ee!important}.border-lightgray50 .rubix-timeline-body>ul,.border-lightgray50.rubix-timeline-view:before{border-color:#f1f0ee}.border-focus-lightgray50:focus,.border-hover-lightgray50:hover{border-color:#f1f0ee!important}.tl-lightgray50 .rubix-timeline-body>ul>li:before{border-color:#f1f0ee}.list-bg-lightgray50>.list-group-item.active{background:#f1f0ee!important;color:#fff!important}.list-fg-lightgray50>.list-group-item{color:#f1f0ee}.btn-black75{background:#3f3f3b;color:#fff;border-color:#3f3f3b}.btn-black75.btn-outlined{color:#3f3f3b;background:none}.btn-black75.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-black75.btn-outlined.btn-onlyOnHover.active,.btn-black75.btn-outlined.btn-onlyOnHover:focus,.btn-black75.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-black75.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-black75.btn-outlined.btn-inverse.active,.btn-black75.btn-outlined.btn-inverse:focus,.btn-black75.btn-outlined.btn-inverse:hover{color:#3f3f3b;background:#fff}.btn-black75.btn-outlined.btn-inverse.active.btn-retainBg,.btn-black75.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-black75.btn-outlined.btn-inverse:hover.btn-retainBg{background:#3f3f3b;color:#fff;border-color:#3f3f3b}.btn-black75.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-black75.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-black75.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#10100f;border-color:#000}.btn-black75.active,.btn-black75.focus,.btn-black75:focus,.btn-black75:hover{color:#fff;background:#595954;border-color:#595954}.btn-black75.active,.btn-black75.active:focus,.btn-black75.active:hover,.btn-black75:active,.btn-black75[aria-expanded=true],.btn-black75[aria-expanded=true]:focus,.btn-black75[aria-expanded=true]:hover,.open>.btn-black75.dropdown-toggle{color:#fff;background:#10100f;border-color:#000;background-image:none}.btn-black75.dropdown-toggle+ul li.active a{color:#fff;background:#3f3f3b}.btn-black75.disabled,.btn-black75[disabled],fieldset[disabled] .btn-black75{pointer-events:none}.btn-black75 .badge{color:#3f3f3b;background-color:#3f3f3b}.menu-black75 ul li.active a,.menu-black75 ul li.active a:hover{color:#fff;background:#3f3f3b!important}.nav-black75>li.active>a,.nav-black75>rubix-menu>li.active>a,.nav-black75>rubix-nav-item>li.active>a{color:#fff;background:#3f3f3b;border-color:#3f3f3b}.tab-black75{border-color:#3f3f3b}.tab-black75>li.active>a{border-color:#3f3f3b;border-bottom-color:transparent}.tab-black75.nav-pills>li.active>a{background:#3f3f3b;color:#fff}.rubix-panel-header.nav-inline .nav-black75>li.active>a{border:1px solid #3f3f3b;border-bottom:none}.rubix-panel-header.nav-inline .nav-black75>li.open>.dropdown-toggle{color:#fff;background:none}.bg-black75{background:#3f3f3b!important}.bg-black75 table td,.bg-black75 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-black75:focus,.bg-hover-black75:hover{background:#3f3f3b!important}.fg-black75,.fg-black75 .nav-tabs>li.active>a{color:#3f3f3b}.fg-tab-active-black75 .nav-tabs>li.active>a{color:#3f3f3b!important}.fg-focus-black75:focus,.fg-hover-black75:hover{color:#3f3f3b}.border-black75{border-color:#3f3f3b!important}.border-black75 .rubix-timeline-body>ul,.border-black75.rubix-timeline-view:before{border-color:#3f3f3b}.border-focus-black75:focus,.border-hover-black75:hover{border-color:#3f3f3b!important}.tl-black75 .rubix-timeline-body>ul>li:before{border-color:#3f3f3b}.list-bg-black75>.list-group-item.active{background:#3f3f3b!important;color:#fff!important}.list-fg-black75>.list-group-item{color:#3f3f3b}.btn-black50{background:#3b4648;color:#fff;border-color:#3b4648}.btn-black50.btn-outlined{color:#3b4648;background:none}.btn-black50.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-black50.btn-outlined.btn-onlyOnHover.active,.btn-black50.btn-outlined.btn-onlyOnHover:focus,.btn-black50.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-black50.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-black50.btn-outlined.btn-inverse.active,.btn-black50.btn-outlined.btn-inverse:focus,.btn-black50.btn-outlined.btn-inverse:hover{color:#3b4648;background:#fff}.btn-black50.btn-outlined.btn-inverse.active.btn-retainBg,.btn-black50.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-black50.btn-outlined.btn-inverse:hover.btn-retainBg{background:#3b4648;color:#fff;border-color:#3b4648}.btn-black50.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-black50.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-black50.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#121516;border-color:#000}.btn-black50.active,.btn-black50.focus,.btn-black50:focus,.btn-black50:hover{color:#fff;background:#526164;border-color:#526164}.btn-black50.active,.btn-black50.active:focus,.btn-black50.active:hover,.btn-black50:active,.btn-black50[aria-expanded=true],.btn-black50[aria-expanded=true]:focus,.btn-black50[aria-expanded=true]:hover,.open>.btn-black50.dropdown-toggle{color:#fff;background:#121516;border-color:#000;background-image:none}.btn-black50.dropdown-toggle+ul li.active a{color:#fff;background:#3b4648}.btn-black50.disabled,.btn-black50[disabled],fieldset[disabled] .btn-black50{pointer-events:none}.btn-black50 .badge{color:#3b4648;background-color:#3b4648}.menu-black50 ul li.active a,.menu-black50 ul li.active a:hover{color:#fff;background:#3b4648!important}.nav-black50>li.active>a,.nav-black50>rubix-menu>li.active>a,.nav-black50>rubix-nav-item>li.active>a{color:#fff;background:#3b4648;border-color:#3b4648}.tab-black50{border-color:#3b4648}.tab-black50>li.active>a{border-color:#3b4648;border-bottom-color:transparent}.tab-black50.nav-pills>li.active>a{background:#3b4648;color:#fff}.rubix-panel-header.nav-inline .nav-black50>li.active>a{border:1px solid #3b4648;border-bottom:none}.rubix-panel-header.nav-inline .nav-black50>li.open>.dropdown-toggle{color:#fff;background:none}.bg-black50{background:#3b4648!important}.bg-black50 table td,.bg-black50 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-black50:focus,.bg-hover-black50:hover{background:#3b4648!important}.fg-black50,.fg-black50 .nav-tabs>li.active>a{color:#3b4648}.fg-tab-active-black50 .nav-tabs>li.active>a{color:#3b4648!important}.fg-focus-black50:focus,.fg-hover-black50:hover{color:#3b4648}.border-black50{border-color:#3b4648!important}.border-black50 .rubix-timeline-body>ul,.border-black50.rubix-timeline-view:before{border-color:#3b4648}.border-focus-black50:focus,.border-hover-black50:hover{border-color:#3b4648!important}.tl-black50 .rubix-timeline-body>ul>li:before{border-color:#3b4648}.list-bg-black50>.list-group-item.active{background:#3b4648!important;color:#fff!important}.list-fg-black50>.list-group-item{color:#3b4648}.btn-davygray{background:#555;color:#fff;border-color:#555}.btn-davygray.btn-outlined{color:#555;background:none}.btn-davygray.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-davygray.btn-outlined.btn-onlyOnHover.active,.btn-davygray.btn-outlined.btn-onlyOnHover:focus,.btn-davygray.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-davygray.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-davygray.btn-outlined.btn-inverse.active,.btn-davygray.btn-outlined.btn-inverse:focus,.btn-davygray.btn-outlined.btn-inverse:hover{color:#555;background:#fff}.btn-davygray.btn-outlined.btn-inverse.active.btn-retainBg,.btn-davygray.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-davygray.btn-outlined.btn-inverse:hover.btn-retainBg{background:#555;color:#fff;border-color:#555}.btn-davygray.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-davygray.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-davygray.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#272727;border-color:#090909}.btn-davygray.active,.btn-davygray.focus,.btn-davygray:focus,.btn-davygray:hover{color:#fff;background:#6f6f6f;border-color:#6f6f6f}.btn-davygray.active,.btn-davygray.active:focus,.btn-davygray.active:hover,.btn-davygray:active,.btn-davygray[aria-expanded=true],.btn-davygray[aria-expanded=true]:focus,.btn-davygray[aria-expanded=true]:hover,.open>.btn-davygray.dropdown-toggle{color:#fff;background:#272727;border-color:#090909;background-image:none}.btn-davygray.dropdown-toggle+ul li.active a{color:#fff;background:#555}.btn-davygray.disabled,.btn-davygray[disabled],fieldset[disabled] .btn-davygray{pointer-events:none}.btn-davygray .badge{color:#555;background-color:#555}.menu-davygray ul li.active a,.menu-davygray ul li.active a:hover{color:#fff;background:#555!important}.nav-davygray>li.active>a,.nav-davygray>rubix-menu>li.active>a,.nav-davygray>rubix-nav-item>li.active>a{color:#fff;background:#555;border-color:#555}.tab-davygray{border-color:#555}.tab-davygray>li.active>a{border-color:#555;border-bottom-color:transparent}.tab-davygray.nav-pills>li.active>a{background:#555;color:#fff}.rubix-panel-header.nav-inline .nav-davygray>li.active>a{border:1px solid #555;border-bottom:none}.rubix-panel-header.nav-inline .nav-davygray>li.open>.dropdown-toggle{color:#fff;background:none}.bg-davygray{background:#555!important}.bg-davygray table td,.bg-davygray th{border-color:rgba(0,0,0,.05)!important}.bg-focus-davygray:focus,.bg-hover-davygray:hover{background:#555!important}.fg-davygray,.fg-davygray .nav-tabs>li.active>a{color:#555}.fg-tab-active-davygray .nav-tabs>li.active>a{color:#555!important}.fg-focus-davygray:focus,.fg-hover-davygray:hover{color:#555}.border-davygray{border-color:#555!important}.border-davygray .rubix-timeline-body>ul,.border-davygray.rubix-timeline-view:before{border-color:#555}.border-focus-davygray:focus,.border-hover-davygray:hover{border-color:#555!important}.tl-davygray .rubix-timeline-body>ul>li:before{border-color:#555}.list-bg-davygray>.list-group-item.active{background:#555!important;color:#fff!important}.list-fg-davygray>.list-group-item{color:#555}.btn-darkgrayishblue75{background:#43525a;color:#fff;border-color:#43525a}.btn-darkgrayishblue75.btn-outlined{color:#43525a;background:none}.btn-darkgrayishblue75.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkgrayishblue75.btn-outlined.btn-onlyOnHover.active,.btn-darkgrayishblue75.btn-outlined.btn-onlyOnHover:focus,.btn-darkgrayishblue75.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkgrayishblue75.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkgrayishblue75.btn-outlined.btn-inverse.active,.btn-darkgrayishblue75.btn-outlined.btn-inverse:focus,.btn-darkgrayishblue75.btn-outlined.btn-inverse:hover{color:#43525a;background:#fff}.btn-darkgrayishblue75.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkgrayishblue75.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkgrayishblue75.btn-outlined.btn-inverse:hover.btn-retainBg{background:#43525a;color:#fff;border-color:#43525a}.btn-darkgrayishblue75.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkgrayishblue75.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkgrayishblue75.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#1c2225;border-color:#020202}.btn-darkgrayishblue75.active,.btn-darkgrayishblue75.focus,.btn-darkgrayishblue75:focus,.btn-darkgrayishblue75:hover{color:#fff;background:#596d77;border-color:#596d77}.btn-darkgrayishblue75.active,.btn-darkgrayishblue75.active:focus,.btn-darkgrayishblue75.active:hover,.btn-darkgrayishblue75:active,.btn-darkgrayishblue75[aria-expanded=true],.btn-darkgrayishblue75[aria-expanded=true]:focus,.btn-darkgrayishblue75[aria-expanded=true]:hover,.open>.btn-darkgrayishblue75.dropdown-toggle{color:#fff;background:#1c2225;border-color:#020202;background-image:none}.btn-darkgrayishblue75.dropdown-toggle+ul li.active a{color:#fff;background:#43525a}.btn-darkgrayishblue75.disabled,.btn-darkgrayishblue75[disabled],fieldset[disabled] .btn-darkgrayishblue75{pointer-events:none}.btn-darkgrayishblue75 .badge{color:#43525a;background-color:#43525a}.menu-darkgrayishblue75 ul li.active a,.menu-darkgrayishblue75 ul li.active a:hover{color:#fff;background:#43525a!important}.nav-darkgrayishblue75>li.active>a,.nav-darkgrayishblue75>rubix-menu>li.active>a,.nav-darkgrayishblue75>rubix-nav-item>li.active>a{color:#fff;background:#43525a;border-color:#43525a}.tab-darkgrayishblue75{border-color:#43525a}.tab-darkgrayishblue75>li.active>a{border-color:#43525a;border-bottom-color:transparent}.tab-darkgrayishblue75.nav-pills>li.active>a{background:#43525a;color:#fff}.rubix-panel-header.nav-inline .nav-darkgrayishblue75>li.active>a{border:1px solid #43525a;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkgrayishblue75>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkgrayishblue75{background:#43525a!important}.bg-darkgrayishblue75 table td,.bg-darkgrayishblue75 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkgrayishblue75:focus,.bg-hover-darkgrayishblue75:hover{background:#43525a!important}.fg-darkgrayishblue75,.fg-darkgrayishblue75 .nav-tabs>li.active>a{color:#43525a}.fg-tab-active-darkgrayishblue75 .nav-tabs>li.active>a{color:#43525a!important}.fg-focus-darkgrayishblue75:focus,.fg-hover-darkgrayishblue75:hover{color:#43525a}.border-darkgrayishblue75{border-color:#43525a!important}.border-darkgrayishblue75 .rubix-timeline-body>ul,.border-darkgrayishblue75.rubix-timeline-view:before{border-color:#43525a}.border-focus-darkgrayishblue75:focus,.border-hover-darkgrayishblue75:hover{border-color:#43525a!important}.tl-darkgrayishblue75 .rubix-timeline-body>ul>li:before{border-color:#43525a}.list-bg-darkgrayishblue75>.list-group-item.active{background:#43525a!important;color:#fff!important}.list-fg-darkgrayishblue75>.list-group-item{color:#43525a}.btn-darkgrayishblue{background:#4c5d67;color:#fff;border-color:#4c5d67}.btn-darkgrayishblue.btn-outlined{color:#4c5d67;background:none}.btn-darkgrayishblue.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkgrayishblue.btn-outlined.btn-onlyOnHover.active,.btn-darkgrayishblue.btn-outlined.btn-onlyOnHover:focus,.btn-darkgrayishblue.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkgrayishblue.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkgrayishblue.btn-outlined.btn-inverse.active,.btn-darkgrayishblue.btn-outlined.btn-inverse:focus,.btn-darkgrayishblue.btn-outlined.btn-inverse:hover{color:#4c5d67;background:#fff}.btn-darkgrayishblue.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkgrayishblue.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkgrayishblue.btn-outlined.btn-inverse:hover.btn-retainBg{background:#4c5d67;color:#fff;border-color:#4c5d67}.btn-darkgrayishblue.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkgrayishblue.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkgrayishblue.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#252d32;border-color:#0b0e0f}.btn-darkgrayishblue.active,.btn-darkgrayishblue.focus,.btn-darkgrayishblue:focus,.btn-darkgrayishblue:hover{color:#fff;background:#627784;border-color:#627784}.btn-darkgrayishblue.active,.btn-darkgrayishblue.active:focus,.btn-darkgrayishblue.active:hover,.btn-darkgrayishblue:active,.btn-darkgrayishblue[aria-expanded=true],.btn-darkgrayishblue[aria-expanded=true]:focus,.btn-darkgrayishblue[aria-expanded=true]:hover,.open>.btn-darkgrayishblue.dropdown-toggle{color:#fff;background:#252d32;border-color:#0b0e0f;background-image:none}.btn-darkgrayishblue.dropdown-toggle+ul li.active a{color:#fff;background:#4c5d67}.btn-darkgrayishblue.disabled,.btn-darkgrayishblue[disabled],fieldset[disabled] .btn-darkgrayishblue{pointer-events:none}.btn-darkgrayishblue .badge{color:#4c5d67;background-color:#4c5d67}.menu-darkgrayishblue ul li.active a,.menu-darkgrayishblue ul li.active a:hover{color:#fff;background:#4c5d67!important}.nav-darkgrayishblue>li.active>a,.nav-darkgrayishblue>rubix-menu>li.active>a,.nav-darkgrayishblue>rubix-nav-item>li.active>a{color:#fff;background:#4c5d67;border-color:#4c5d67}.tab-darkgrayishblue{border-color:#4c5d67}.tab-darkgrayishblue>li.active>a{border-color:#4c5d67;border-bottom-color:transparent}.tab-darkgrayishblue.nav-pills>li.active>a{background:#4c5d67;color:#fff}.rubix-panel-header.nav-inline .nav-darkgrayishblue>li.active>a{border:1px solid #4c5d67;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkgrayishblue>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkgrayishblue{background:#4c5d67!important}.bg-darkgrayishblue table td,.bg-darkgrayishblue th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkgrayishblue:focus,.bg-hover-darkgrayishblue:hover{background:#4c5d67!important}.fg-darkgrayishblue,.fg-darkgrayishblue .nav-tabs>li.active>a{color:#4c5d67}.fg-tab-active-darkgrayishblue .nav-tabs>li.active>a{color:#4c5d67!important}.fg-focus-darkgrayishblue:focus,.fg-hover-darkgrayishblue:hover{color:#4c5d67}.border-darkgrayishblue{border-color:#4c5d67!important}.border-darkgrayishblue .rubix-timeline-body>ul,.border-darkgrayishblue.rubix-timeline-view:before{border-color:#4c5d67}.border-focus-darkgrayishblue:focus,.border-hover-darkgrayishblue:hover{border-color:#4c5d67!important}.tl-darkgrayishblue .rubix-timeline-body>ul>li:before{border-color:#4c5d67}.list-bg-darkgrayishblue>.list-group-item.active{background:#4c5d67!important;color:#fff!important}.list-fg-darkgrayishblue>.list-group-item{color:#4c5d67}.btn-desaturateddarkblue{background:#515e78;color:#fff;border-color:#515e78}.btn-desaturateddarkblue.btn-outlined{color:#515e78;background:none}.btn-desaturateddarkblue.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-desaturateddarkblue.btn-outlined.btn-onlyOnHover.active,.btn-desaturateddarkblue.btn-outlined.btn-onlyOnHover:focus,.btn-desaturateddarkblue.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-desaturateddarkblue.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-desaturateddarkblue.btn-outlined.btn-inverse.active,.btn-desaturateddarkblue.btn-outlined.btn-inverse:focus,.btn-desaturateddarkblue.btn-outlined.btn-inverse:hover{color:#515e78;background:#fff}.btn-desaturateddarkblue.btn-outlined.btn-inverse.active.btn-retainBg,.btn-desaturateddarkblue.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-desaturateddarkblue.btn-outlined.btn-inverse:hover.btn-retainBg{background:#515e78;color:#fff;border-color:#515e78}.btn-desaturateddarkblue.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-desaturateddarkblue.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-desaturateddarkblue.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#2c3341;border-color:#13161d}.btn-desaturateddarkblue.active,.btn-desaturateddarkblue.focus,.btn-desaturateddarkblue:focus,.btn-desaturateddarkblue:hover{color:#fff;background:#667696;border-color:#667696}.btn-desaturateddarkblue.active,.btn-desaturateddarkblue.active:focus,.btn-desaturateddarkblue.active:hover,.btn-desaturateddarkblue:active,.btn-desaturateddarkblue[aria-expanded=true],.btn-desaturateddarkblue[aria-expanded=true]:focus,.btn-desaturateddarkblue[aria-expanded=true]:hover,.open>.btn-desaturateddarkblue.dropdown-toggle{color:#fff;background:#2c3341;border-color:#13161d;background-image:none}.btn-desaturateddarkblue.dropdown-toggle+ul li.active a{color:#fff;background:#515e78}.btn-desaturateddarkblue.disabled,.btn-desaturateddarkblue[disabled],fieldset[disabled] .btn-desaturateddarkblue{pointer-events:none}.btn-desaturateddarkblue .badge{color:#515e78;background-color:#515e78}.menu-desaturateddarkblue ul li.active a,.menu-desaturateddarkblue ul li.active a:hover{color:#fff;background:#515e78!important}.nav-desaturateddarkblue>li.active>a,.nav-desaturateddarkblue>rubix-menu>li.active>a,.nav-desaturateddarkblue>rubix-nav-item>li.active>a{color:#fff;background:#515e78;border-color:#515e78}.tab-desaturateddarkblue{border-color:#515e78}.tab-desaturateddarkblue>li.active>a{border-color:#515e78;border-bottom-color:transparent}.tab-desaturateddarkblue.nav-pills>li.active>a{background:#515e78;color:#fff}.rubix-panel-header.nav-inline .nav-desaturateddarkblue>li.active>a{border:1px solid #515e78;border-bottom:none}.rubix-panel-header.nav-inline .nav-desaturateddarkblue>li.open>.dropdown-toggle{color:#fff;background:none}.bg-desaturateddarkblue{background:#515e78!important}.bg-desaturateddarkblue table td,.bg-desaturateddarkblue th{border-color:rgba(0,0,0,.05)!important}.bg-focus-desaturateddarkblue:focus,.bg-hover-desaturateddarkblue:hover{background:#515e78!important}.fg-desaturateddarkblue,.fg-desaturateddarkblue .nav-tabs>li.active>a{color:#515e78}.fg-tab-active-desaturateddarkblue .nav-tabs>li.active>a{color:#515e78!important}.fg-focus-desaturateddarkblue:focus,.fg-hover-desaturateddarkblue:hover{color:#515e78}.border-desaturateddarkblue{border-color:#515e78!important}.border-desaturateddarkblue .rubix-timeline-body>ul,.border-desaturateddarkblue.rubix-timeline-view:before{border-color:#515e78}.border-focus-desaturateddarkblue:focus,.border-hover-desaturateddarkblue:hover{border-color:#515e78!important}.tl-desaturateddarkblue .rubix-timeline-body>ul>li:before{border-color:#515e78}.list-bg-desaturateddarkblue>.list-group-item.active{background:#515e78!important;color:#fff!important}.list-fg-desaturateddarkblue>.list-group-item{color:#515e78}.btn-desaturateddarkblue75{background:#3b465c;color:#fff;border-color:#3b465c}.btn-desaturateddarkblue75.btn-outlined{color:#3b465c;background:none}.btn-desaturateddarkblue75.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-desaturateddarkblue75.btn-outlined.btn-onlyOnHover.active,.btn-desaturateddarkblue75.btn-outlined.btn-onlyOnHover:focus,.btn-desaturateddarkblue75.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-desaturateddarkblue75.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-desaturateddarkblue75.btn-outlined.btn-inverse.active,.btn-desaturateddarkblue75.btn-outlined.btn-inverse:focus,.btn-desaturateddarkblue75.btn-outlined.btn-inverse:hover{color:#3b465c;background:#fff}.btn-desaturateddarkblue75.btn-outlined.btn-inverse.active.btn-retainBg,.btn-desaturateddarkblue75.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-desaturateddarkblue75.btn-outlined.btn-inverse:hover.btn-retainBg{background:#3b465c;color:#fff;border-color:#3b465c}.btn-desaturateddarkblue75.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-desaturateddarkblue75.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-desaturateddarkblue75.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#171b24;border-color:#000}.btn-desaturateddarkblue75.active,.btn-desaturateddarkblue75.focus,.btn-desaturateddarkblue75:focus,.btn-desaturateddarkblue75:hover{color:#fff;background:#4f5e7b;border-color:#4f5e7b}.btn-desaturateddarkblue75.active,.btn-desaturateddarkblue75.active:focus,.btn-desaturateddarkblue75.active:hover,.btn-desaturateddarkblue75:active,.btn-desaturateddarkblue75[aria-expanded=true],.btn-desaturateddarkblue75[aria-expanded=true]:focus,.btn-desaturateddarkblue75[aria-expanded=true]:hover,.open>.btn-desaturateddarkblue75.dropdown-toggle{color:#fff;background:#171b24;border-color:#000;background-image:none}.btn-desaturateddarkblue75.dropdown-toggle+ul li.active a{color:#fff;background:#3b465c}.btn-desaturateddarkblue75.disabled,.btn-desaturateddarkblue75[disabled],fieldset[disabled] .btn-desaturateddarkblue75{pointer-events:none}.btn-desaturateddarkblue75 .badge{color:#3b465c;background-color:#3b465c}.menu-desaturateddarkblue75 ul li.active a,.menu-desaturateddarkblue75 ul li.active a:hover{color:#fff;background:#3b465c!important}.nav-desaturateddarkblue75>li.active>a,.nav-desaturateddarkblue75>rubix-menu>li.active>a,.nav-desaturateddarkblue75>rubix-nav-item>li.active>a{color:#fff;background:#3b465c;border-color:#3b465c}.tab-desaturateddarkblue75{border-color:#3b465c}.tab-desaturateddarkblue75>li.active>a{border-color:#3b465c;border-bottom-color:transparent}.tab-desaturateddarkblue75.nav-pills>li.active>a{background:#3b465c;color:#fff}.rubix-panel-header.nav-inline .nav-desaturateddarkblue75>li.active>a{border:1px solid #3b465c;border-bottom:none}.rubix-panel-header.nav-inline .nav-desaturateddarkblue75>li.open>.dropdown-toggle{color:#fff;background:none}.bg-desaturateddarkblue75{background:#3b465c!important}.bg-desaturateddarkblue75 table td,.bg-desaturateddarkblue75 th{border-color:rgba(0,0,0,.05)!important}.bg-focus-desaturateddarkblue75:focus,.bg-hover-desaturateddarkblue75:hover{background:#3b465c!important}.fg-desaturateddarkblue75,.fg-desaturateddarkblue75 .nav-tabs>li.active>a{color:#3b465c}.fg-tab-active-desaturateddarkblue75 .nav-tabs>li.active>a{color:#3b465c!important}.fg-focus-desaturateddarkblue75:focus,.fg-hover-desaturateddarkblue75:hover{color:#3b465c}.border-desaturateddarkblue75{border-color:#3b465c!important}.border-desaturateddarkblue75 .rubix-timeline-body>ul,.border-desaturateddarkblue75.rubix-timeline-view:before{border-color:#3b465c}.border-focus-desaturateddarkblue75:focus,.border-hover-desaturateddarkblue75:hover{border-color:#3b465c!important}.tl-desaturateddarkblue75 .rubix-timeline-body>ul>li:before{border-color:#3b465c}.list-bg-desaturateddarkblue75>.list-group-item.active{background:#3b465c!important;color:#fff!important}.list-fg-desaturateddarkblue75>.list-group-item{color:#3b465c}.btn-darkcyan{background:#68a0a5;color:#fff;border-color:#68a0a5}.btn-darkcyan.btn-outlined{color:#68a0a5;background:none}.btn-darkcyan.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-darkcyan.btn-outlined.btn-onlyOnHover.active,.btn-darkcyan.btn-outlined.btn-onlyOnHover:focus,.btn-darkcyan.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-darkcyan.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-darkcyan.btn-outlined.btn-inverse.active,.btn-darkcyan.btn-outlined.btn-inverse:focus,.btn-darkcyan.btn-outlined.btn-inverse:hover{color:#68a0a5;background:#fff}.btn-darkcyan.btn-outlined.btn-inverse.active.btn-retainBg,.btn-darkcyan.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-darkcyan.btn-outlined.btn-inverse:hover.btn-retainBg{background:#68a0a5;color:#fff;border-color:#68a0a5}.btn-darkcyan.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-darkcyan.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-darkcyan.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#426b6f;border-color:#2b4649}.btn-darkcyan.active,.btn-darkcyan.focus,.btn-darkcyan:focus,.btn-darkcyan:hover{color:#fff;background:#88b4b8;border-color:#88b4b8}.btn-darkcyan.active,.btn-darkcyan.active:focus,.btn-darkcyan.active:hover,.btn-darkcyan:active,.btn-darkcyan[aria-expanded=true],.btn-darkcyan[aria-expanded=true]:focus,.btn-darkcyan[aria-expanded=true]:hover,.open>.btn-darkcyan.dropdown-toggle{color:#fff;background:#426b6f;border-color:#2b4649;background-image:none}.btn-darkcyan.dropdown-toggle+ul li.active a{color:#fff;background:#68a0a5}.btn-darkcyan.disabled,.btn-darkcyan[disabled],fieldset[disabled] .btn-darkcyan{pointer-events:none}.btn-darkcyan .badge{color:#68a0a5;background-color:#68a0a5}.menu-darkcyan ul li.active a,.menu-darkcyan ul li.active a:hover{color:#fff;background:#68a0a5!important}.nav-darkcyan>li.active>a,.nav-darkcyan>rubix-menu>li.active>a,.nav-darkcyan>rubix-nav-item>li.active>a{color:#fff;background:#68a0a5;border-color:#68a0a5}.tab-darkcyan{border-color:#68a0a5}.tab-darkcyan>li.active>a{border-color:#68a0a5;border-bottom-color:transparent}.tab-darkcyan.nav-pills>li.active>a{background:#68a0a5;color:#fff}.rubix-panel-header.nav-inline .nav-darkcyan>li.active>a{border:1px solid #68a0a5;border-bottom:none}.rubix-panel-header.nav-inline .nav-darkcyan>li.open>.dropdown-toggle{color:#fff;background:none}.bg-darkcyan{background:#68a0a5!important}.bg-darkcyan table td,.bg-darkcyan th{border-color:rgba(0,0,0,.05)!important}.bg-focus-darkcyan:focus,.bg-hover-darkcyan:hover{background:#68a0a5!important}.fg-darkcyan,.fg-darkcyan .nav-tabs>li.active>a{color:#68a0a5}.fg-tab-active-darkcyan .nav-tabs>li.active>a{color:#68a0a5!important}.fg-focus-darkcyan:focus,.fg-hover-darkcyan:hover{color:#68a0a5}.border-darkcyan{border-color:#68a0a5!important}.border-darkcyan .rubix-timeline-body>ul,.border-darkcyan.rubix-timeline-view:before{border-color:#68a0a5}.border-focus-darkcyan:focus,.border-hover-darkcyan:hover{border-color:#68a0a5!important}.tl-darkcyan .rubix-timeline-body>ul>li:before{border-color:#68a0a5}.list-bg-darkcyan>.list-group-item.active{background:#68a0a5!important;color:#fff!important}.list-fg-darkcyan>.list-group-item{color:#68a0a5}.btn-grayishcyan{background:#92bdc1;color:#fff;border-color:#92bdc1}.btn-grayishcyan.btn-outlined{color:#92bdc1;background:none}.btn-grayishcyan.btn-outlined.btn-onlyOnHover{color:#89949b}.btn-grayishcyan.btn-outlined.btn-onlyOnHover.active,.btn-grayishcyan.btn-outlined.btn-onlyOnHover:focus,.btn-grayishcyan.btn-outlined.btn-onlyOnHover:hover{color:#fff}.btn-grayishcyan.btn-outlined.btn-inverse{color:#fff;border-color:#fff}.btn-grayishcyan.btn-outlined.btn-inverse.active,.btn-grayishcyan.btn-outlined.btn-inverse:focus,.btn-grayishcyan.btn-outlined.btn-inverse:hover{color:#92bdc1;background:#fff}.btn-grayishcyan.btn-outlined.btn-inverse.active.btn-retainBg,.btn-grayishcyan.btn-outlined.btn-inverse:focus.btn-retainBg,.btn-grayishcyan.btn-outlined.btn-inverse:hover.btn-retainBg{background:#92bdc1;color:#fff;border-color:#92bdc1}.btn-grayishcyan.btn-outlined.btn-inverse.active.btn-retainBg:active,.btn-grayishcyan.btn-outlined.btn-inverse:focus.btn-retainBg:active,.btn-grayishcyan.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#5a989e;border-color:#437277}.btn-grayishcyan.active,.btn-grayishcyan.focus,.btn-grayishcyan:focus,.btn-grayishcyan:hover{color:#fff;background:#b3d1d3;border-color:#b3d1d3}.btn-grayishcyan.active,.btn-grayishcyan.active:focus,.btn-grayishcyan.active:hover,.btn-grayishcyan:active,.btn-grayishcyan[aria-expanded=true],.btn-grayishcyan[aria-expanded=true]:focus,.btn-grayishcyan[aria-expanded=true]:hover,.open>.btn-grayishcyan.dropdown-toggle{color:#fff;background:#5a989e;border-color:#437277;background-image:none}.btn-grayishcyan.dropdown-toggle+ul li.active a{color:#fff;background:#92bdc1}.btn-grayishcyan.disabled,.btn-grayishcyan[disabled],fieldset[disabled] .btn-grayishcyan{pointer-events:none}.btn-grayishcyan .badge{color:#92bdc1;background-color:#92bdc1}.menu-grayishcyan ul li.active a,.menu-grayishcyan ul li.active a:hover{color:#fff;background:#92bdc1!important}.nav-grayishcyan>li.active>a,.nav-grayishcyan>rubix-menu>li.active>a,.nav-grayishcyan>rubix-nav-item>li.active>a{color:#fff;background:#92bdc1;border-color:#92bdc1}.tab-grayishcyan{border-color:#92bdc1}.tab-grayishcyan>li.active>a{border-color:#92bdc1;border-bottom-color:transparent}.tab-grayishcyan.nav-pills>li.active>a{background:#92bdc1;color:#fff}.rubix-panel-header.nav-inline .nav-grayishcyan>li.active>a{border:1px solid #92bdc1;border-bottom:none}.rubix-panel-header.nav-inline .nav-grayishcyan>li.open>.dropdown-toggle{color:#fff;background:none}.bg-grayishcyan{background:#92bdc1!important}.bg-grayishcyan table td,.bg-grayishcyan th{border-color:rgba(0,0,0,.05)!important}.bg-focus-grayishcyan:focus,.bg-hover-grayishcyan:hover{background:#92bdc1!important}.fg-grayishcyan,.fg-grayishcyan .nav-tabs>li.active>a{color:#92bdc1}.fg-tab-active-grayishcyan .nav-tabs>li.active>a{color:#92bdc1!important}.fg-focus-grayishcyan:focus,.fg-hover-grayishcyan:hover{color:#92bdc1}.border-grayishcyan{border-color:#92bdc1!important}.border-grayishcyan .rubix-timeline-body>ul,.border-grayishcyan.rubix-timeline-view:before{border-color:#92bdc1}.border-focus-grayishcyan:focus,.border-hover-grayishcyan:hover{border-color:#92bdc1!important}.tl-grayishcyan .rubix-timeline-body>ul>li:before{border-color:#92bdc1}.list-bg-grayishcyan>.list-group-item.active{background:#92bdc1!important;color:#fff!important}.list-fg-grayishcyan>.list-group-item{color:#92bdc1}html{letter-spacing:.5px}a{color:#2eb398}a:focus,a:hover{color:#248a76}.rubix-panel-container{background:#fff}.rubix-panel-container.bordered{border:1px solid rgba(206,219,236,.75);box-shadow:0 2px 0 0 rgba(206,219,236,.5)}.rubix-panel-container.noOverflow{overflow:visible}.rubix-panel-controls{color:#89949b}html.default .form-control{border-color:#ddd}html.default .form-control:focus{box-shadow:none!important;border-color:#2eb398}html.default .dropdown-menu .active>a,html.default .dropdown-menu .active>a:focus,html.default .dropdown-menu .active>a:hover{background-color:#e76049}html.default .select2-container-multi .select2-choices{border-radius:0;height:25px}html.default .select2-container-multi .select2-choices,html.default .select2-container .select2-choice{border-width:2px}html.default .select2-container .select2-choice .select2-arrow{color:#fff;border-radius:0}html.default .form-control.select2-container.select2-dropdown-open,html.default .select2-container-active .select2-choice,html.default .select2-container-active .select2-choices,html.default .select2-container-multi.select2-container-active .select2-choices,html.default .select2-drop-active,html.default .select2-drop.select2-drop-above.select2-drop-active,html.default .select2-dropdown-open.select2-drop-above .select2-choice,html.default .select2-dropdown-open.select2-drop-above .select2-choices{border-width:2px}html.default .pagination{margin:0 0 25px}html.default .pagination .disabled>a{color:#ccc}html.default .pagination>.active>a,html.default .pagination>.active>a:focus,html.default .pagination>.active>a:hover,html.default .pagination>.active>span,html.default .pagination>.active>span:focus,html.default .pagination>.active>span:hover{color:#fff;background:#e76049;border-color:#e76049}html.default .pagination>li>a,html.default .pagination>li>span{color:inherit}html.default .rubix-panel .pagination>li>a{border:1px solid #ddd}html.default .datepicker table tr td.active,html.default .datepicker table tr td.active.disabled,html.default .datepicker table tr td.active.disabled:hover,html.default .datepicker table tr td.active:hover,html.default .datepicker table tr td span.active,html.default .datepicker table tr td span.active.disabled,html.default .datepicker table tr td span.active.disabled:hover,html.default .datepicker table tr td span.active:hover{background:#e76049!important}html.default .breadcrumb>li>a{color:#e76049}html.default .breadcrumb>li>a:focus,html.default .breadcrumb>li>a:hover{color:#c9341b}html.default .btn-theme{background:#e76049;color:#fff;border-color:#e76049}html.default .btn-theme.btn-outlined{color:#e76049;background:none}html.default .btn-theme.btn-outlined.btn-onlyOnHover{color:#89949b}html.default .btn-theme.btn-outlined.btn-onlyOnHover.active,html.default .btn-theme.btn-outlined.btn-onlyOnHover:focus,html.default .btn-theme.btn-outlined.btn-onlyOnHover:hover{color:#fff}html.default .btn-theme.btn-outlined.btn-inverse{color:#fff;border-color:#fff}html.default .btn-theme.btn-outlined.btn-inverse.active,html.default .btn-theme.btn-outlined.btn-inverse:focus,html.default .btn-theme.btn-outlined.btn-inverse:hover{color:#e76049;background:#fff}html.default .btn-theme.btn-outlined.btn-inverse.active.btn-retainBg,html.default .btn-theme.btn-outlined.btn-inverse:focus.btn-retainBg,html.default .btn-theme.btn-outlined.btn-inverse:hover.btn-retainBg{background:#e76049;color:#fff;border-color:#e76049}html.default .btn-theme.btn-outlined.btn-inverse.active.btn-retainBg:active,html.default .btn-theme.btn-outlined.btn-inverse:focus.btn-retainBg:active,html.default .btn-theme.btn-outlined.btn-inverse:hover.btn-retainBg:active{background:#bb3019;border-color:#852212}html.default .btn-theme.active,html.default .btn-theme.focus,html.default .btn-theme:focus,html.default .btn-theme:hover{color:#fff;background:#ed8776;border-color:#ed8776}.open>html.default .btn-theme.dropdown-toggle,html.default .btn-theme.active,html.default .btn-theme.active:focus,html.default .btn-theme.active:hover,html.default .btn-theme:active,html.default .btn-theme[aria-expanded=true],html.default .btn-theme[aria-expanded=true]:focus,html.default .btn-theme[aria-expanded=true]:hover{color:#fff;background:#bb3019;border-color:#852212;background-image:none}html.default .btn-theme.dropdown-toggle+ul li.active a{color:#fff;background:#e76049}fieldset[disabled] html.default .btn-theme,html.default .btn-theme.disabled,html.default .btn-theme[disabled]{pointer-events:none}html.default .btn-theme .badge{color:#e76049;background-color:#e76049}html.default .menu-theme ul li.active a,html.default .menu-theme ul li.active a:hover{color:#fff;background:#e76049!important}html.default .nav-theme>li.active>a,html.default .nav-theme>rubix-menu>li.active>a,html.default .nav-theme>rubix-nav-item>li.active>a{color:#fff;background:#e76049;border-color:#e76049}html.default .tab-theme{border-color:#e76049}html.default .tab-theme>li.active>a{border-color:#e76049;border-bottom-color:transparent}html.default .tab-theme.nav-pills>li.active>a{background:#e76049;color:#fff}html.default .rubix-panel-header.nav-inline .nav-theme>li.active>a{border:1px solid #e76049;border-bottom:none}html.default .rubix-panel-header.nav-inline .nav-theme>li.open>.dropdown-toggle{color:#fff;background:none}html.default .bg-theme{background:#e76049!important}html.default .bg-theme table td,html.default .bg-theme th{border-color:rgba(0,0,0,.05)!important}html.default .bg-focus-theme:focus,html.default .bg-hover-theme:hover{background:#e76049!important}html.default .fg-theme,html.default .fg-theme .nav-tabs>li.active>a{color:#e76049}html.default .fg-tab-active-theme .nav-tabs>li.active>a{color:#e76049!important}html.default .fg-focus-theme:focus,html.default .fg-hover-theme:hover{color:#e76049}html.default .border-theme{border-color:#e76049!important}html.default .border-theme .rubix-timeline-body>ul,html.default .border-theme.rubix-timeline-view:before{border-color:#e76049}html.default .border-focus-theme:focus,html.default .border-hover-theme:hover{border-color:#e76049!important}html.default .tl-theme .rubix-timeline-body>ul>li:before{border-color:#e76049}html.default .list-bg-theme>.list-group-item.active{background:#e76049!important;color:#fff!important}html.default .list-fg-theme>.list-group-item{color:#e76049}html.default,html.default body{background:#fff;overflow-x:hidden;color:#89949b}html.default body #app-container{overflow:hidden}html.default body #container>div:first-child#navbar #rubix-nav-header{margin:0}html.default body #container>div:first-child#body{margin-top:0;padding-top:25px}html.default body #container.container-open>#sidebar{left:0}html.default body #container.container-open #rubix-nav-header,html.default body #container.container-open>#body,html.default body #container.container-open>#footer-container{margin-left:250px;margin-right:-250px}@media (min-width:990px){html.default body #container.container-open #rubix-nav-header,html.default body #container.container-open>#body,html.default body #container.container-open>#footer-container{margin-right:0}}html.default body #container.force-close>#sidebar{left:-250px}html.default body #container.force-close #rubix-nav-header,html.default body #container.force-close>#body,html.default body #container.force-close>#footer-container{margin-left:0;margin-right:0}html.default body #navbar{width:100%}html.default body #rubix-nav-header{border:none;margin-left:0;display:block;height:75px;transition:all .3s ease;background:#273135}html.default body #rubix-nav-header .navbar-brand{width:100%;text-align:center;color:#89949b}html.default body #rubix-nav-header .navbar-brand>img{top:-3px;margin:auto;position:relative}@media (max-width:320px){html.default body #rubix-nav-header .navbar-brand>img{width:80px;left:-10px}}html.default body #rubix-nav-header .navbar-content{height:75px}html.default body #rubix-nav-header .navbar-right{margin-right:-25px}html.default body #rubix-nav-header .navbar-nav{margin:0;display:inline-block}html.default body #rubix-nav-header .navbar-nav:first-child{margin-left:-25px}html.default body #rubix-nav-header .navbar-nav>li>a{border:none;padding:25px;display:block;line-height:1}html.default body #rubix-nav-header .navbar-nav>li>a>.rubix-icon{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}html.default body #rubix-nav-header .navbar-nav>li.divider{height:75px;border:1px solid rgba(59,70,72,.45)}html.default body #rubix-nav-header .navbar-nav>li.dropdown.open>a{color:#fff;background:none}html.default body #rubix-nav-header .navbar-nav>li.active>a,html.default body #rubix-nav-header .navbar-nav>li>a{height:75px;font-size:26px;background:none;text-align:center;color:#89949b}html.default body #rubix-nav-header .navbar-nav>li.active>a:hover,html.default body #rubix-nav-header .navbar-nav>li.pressed>a,html.default body #rubix-nav-header .navbar-nav>li>a:hover{color:#fff}html.default body #rubix-nav-header .navbar-nav>li.logout>a,html.default body #rubix-nav-header .navbar-nav>li.sidebar-btn>a{width:80px;font-size:30px;padding-left:0;padding-right:0}html.default body #rubix-nav-header .navbar-nav>li.logout>a{color:#fff;background:#e76049}html.default body #rubix-nav-header .navbar-nav>li.logout>a:hover{background:#f4654d}html.default body #rubix-nav-header .navbar-nav>li.sidebar-btn>a{color:#fff;background:#2aa38b}html.default body #rubix-nav-header .navbar-nav>li.sidebar-btn>a:hover{background:#2eb398}html.default body #rubix-nav-header .navbar-nav>li.collapse-left>a{padding-left:0}html.default body #rubix-nav-header .navbar-nav>li.collapse-right>a{padding-right:0}html.default body #rubix-nav-header .navbar-nav>li.small-font>a{font-size:20px}html.default body #rubix-nav-header .navbar-nav>li .notification-badge{font-size:10px;padding:3px 5px;margin-left:-5px;line-height:10px;margin-top:-10px;position:absolute}@media (min-width:990px){html.default body #rubix-nav-header{margin-left:250px}}html.default body #flag-menu-btn>img{top:-2px;position:relative}html.default body .lang-menu-text{line-height:32px}html.default body .header-menu>.dropdown-menu{border:none;margin-top:0;overflow:visible;box-shadow:0 1px 3px 0 rgba(0,0,0,.2);border-top:5px solid #e76049!important}html.default body .header-menu>.dropdown-menu:after{top:-14px;right:25px;content:\"\";position:absolute;display:inline-block;border-left:12px solid transparent;border-right:12px solid transparent;border-bottom:12px solid #e76049}html.default body #flag-menu-btn+.dropdown-menu{width:325px}html.default body #flag-menu-btn+.dropdown-menu .container-fluid{margin-left:-25px;margin-right:-25px}html.default body #settings-menu+.dropdown-menu{width:375px}html.default body #notifications-menu+.dropdown-menu,html.default body #rss-menu+.dropdown-menu{width:325px}html.default body #notifications-menu+.dropdown-menu>li,html.default body #rss-menu+.dropdown-menu>li{border-bottom:1px solid #f2f2f2}html.default body #notifications-menu+.dropdown-menu>li:last-child,html.default body #rss-menu+.dropdown-menu>li:last-child{border-bottom:none}html.default body #notifications-menu+.dropdown-menu>li>a>.container-fluid,html.default body #rss-menu+.dropdown-menu>li>a>.container-fluid{padding-top:10px;padding-bottom:10px}html.default body #notifications-menu+.dropdown-menu>li>a>.container-fluid>.row>.avatar-container,html.default body #rss-menu+.dropdown-menu>li>a>.container-fluid>.row>.avatar-container{width:75px;padding-right:10px}html.default body #notifications-menu+.dropdown-menu>li>a>.container-fluid>.row>.avatar-container .label,html.default body #rss-menu+.dropdown-menu>li>a>.container-fluid>.row>.avatar-container .label{font-size:8px}html.default body #notifications-menu+.dropdown-menu>li>a>.container-fluid>.row>.notification-container,html.default body #rss-menu+.dropdown-menu>li>a>.container-fluid>.row>.notification-container{width:225px}html.default body #notifications-menu+.dropdown-menu>li>a>.container-fluid>.row>.notification-container>.time,html.default body #rss-menu+.dropdown-menu>li>a>.container-fluid>.row>.notification-container>.time{line-height:1;font-size:10px;padding-bottom:5px}html.default body #notifications-menu+.dropdown-menu>li>a>.container-fluid>.row>.notification-container>.time>strong>.rubix-icon,html.default body #rss-menu+.dropdown-menu>li>a>.container-fluid>.row>.notification-container>.time>strong>.rubix-icon{margin-right:5px}html.default body #notifications-menu+.dropdown-menu>li>a>.container-fluid>.row>.notification-container>.message-header,html.default body #rss-menu+.dropdown-menu>li>a>.container-fluid>.row>.notification-container>.message-header{line-height:1;font-size:12px;padding-bottom:5px}html.default body #notifications-menu+.dropdown-menu>li>a>.container-fluid>.row>.notification-container>.message-details,html.default body #rss-menu+.dropdown-menu>li>a>.container-fluid>.row>.notification-container>.message-details{line-height:1;font-size:10px;padding-bottom:5px}html.default body #notifications-menu+.dropdown-menu .notification-footer-btn,html.default body #rss-menu+.dropdown-menu .notification-footer-btn{margin:0;height:100%;font-size:12px;border-radius:0;font-weight:700;padding:6px 12px;border:none!important;color:#98a0a3!important;background:#f9fafb!important}html.default body #notifications-menu+.dropdown-menu .notification-footer-btn:focus,html.default body #notifications-menu+.dropdown-menu .notification-footer-btn:hover,html.default body #rss-menu+.dropdown-menu .notification-footer-btn:focus,html.default body #rss-menu+.dropdown-menu .notification-footer-btn:hover{border:none!important;background:#eaedf1!important}html.default body #notifications-menu+.dropdown-menu .notification-footer-btn.left-btn,html.default body #rss-menu+.dropdown-menu .notification-footer-btn.left-btn{border-right:1px solid #dde1e6!important}html.default body #sidebar{top:0;bottom:0;z-index:1;position:fixed;overflow:hidden;transition:all .3s ease;left:-250px;width:250px;background:#273135}@media (min-width:990px){html.default body #sidebar{left:0}}html.default body #sidebar #avatar{height:75px;background:#fa7252}html.default body #sidebar #avatar img{top:17px;position:relative}html.default body #sidebar #avatar-col,html.default body #sidebar #avatar-desc{margin-left:-5px}html.default body #sidebar #demo-progress{margin:0;top:30px;height:4px;width:115px;border-radius:0;position:relative;background:#de5939}html.default body #sidebar #demo-icon{top:3px;float:right;font-size:18px;position:relative;color:#de5939}html.default body #sidebar .sidebar-controls-container{width:250px;height:35px;display:table;visibility:visible;background:#de5939}html.default body #sidebar .sidebar-controls-container>.sidebar-controls{display:table-row}html.default body #sidebar .sidebar-controls-container>.sidebar-controls>.sidebar-control-btn{border:none;outline:none;font-size:16px;cursor:pointer;background:none;text-align:center;display:table-cell;vertical-align:middle;border-right:1px solid #cf4d2e}html.default body #sidebar .sidebar-controls-container>.sidebar-controls>.sidebar-control-btn>a{outline:none;color:#993f31}html.default body #sidebar .sidebar-controls-container>.sidebar-controls>.sidebar-control-btn>a:focus,html.default body #sidebar .sidebar-controls-container>.sidebar-controls>.sidebar-control-btn>a:hover{border:none}html.default body #sidebar .sidebar-controls-container>.sidebar-controls>.sidebar-control-btn.active{background:#ba4e3b!important}html.default body #sidebar .sidebar-controls-container>.sidebar-controls>.sidebar-control-btn.active>a{color:#fa7252}html.default body #sidebar .sidebar-controls-container>.sidebar-controls>.sidebar-control-btn:hover{background:rgba(0,0,0,.04)}html.default body #sidebar .sidebar-item{height:35px;background:#1f282d}html.default body #sidebar #sidebar-container{bottom:0;width:250px;overflow:hidden;position:absolute;top:110px}html.default body #sidebar #sidebar-container .sidebar{top:0;bottom:0;width:250px;overflow:hidden;position:absolute;transition:all .3s ease}html.default body .sidebar-header{line-height:1;font-size:12px;padding-top:25px;font-weight:700;padding-bottom:12px;text-transform:uppercase;color:hsla(203,8%,57%,.4)}html.default body .sidebar-nav>.sidebar-header{padding-left:25px}html.default body .sidebar-nav{padding:0;list-style:none;margin-left:25px;border-left:2px solid rgba(59,70,72,.5)}html.default body .sidebar-nav>li{height:45px;outline:none;cursor:pointer;overflow:hidden;position:relative}html.default body .sidebar-nav>li>a{height:45px;border:none;outline:none;color:#89949b;display:block;font-size:14px;line-height:14px;text-decoration:none;padding:15px 0 15px 25px}html.default body .sidebar-nav>li>a>.rubix-icon,html.default body .sidebar-nav>li>a>rubix-icon>.rubix-icon{width:16px;height:17px;vertical-align:top;display:inline-block}html.default body .sidebar-nav>li>a>.name{line-height:16px;vertical-align:top}html.default body .sidebar-nav>li>a>.name>.label,html.default body .sidebar-nav>li>a>.name>span>.label{float:right;margin-top:-3px;padding:5px 10px;margin-right:30px}html.default body .sidebar-nav>li>a>.rubix-icon~.name,html.default body .sidebar-nav>li>a>rubix-icon~.name{margin-left:10px}html.default body .sidebar-nav>li>a:focus,html.default body .sidebar-nav>li>a:hover{border:none;background:rgba(0,0,0,.2)}html.default body .sidebar-nav>li.open:before,html.default body .sidebar-nav>li:hover:before{display:none}html.default body .sidebar-nav>li.open{height:100%}html.default body .sidebar-nav>li.open>a{background:rgba(0,0,0,.2)}html.default body .sidebar-nav>li:before{left:0;top:22px;width:15px;content:\" \";position:absolute;display:inline-block;border:1px solid rgba(59,70,72,.5)}html.default body .sidebar-nav>li.active{border-left:5px solid #e76049}html.default body .sidebar-nav>li.active>a{background:rgba(0,0,0,.4);padding-left:20px}html.default body .sidebar-nav>li.active>a:hover{background:rgba(0,0,0,.4)}html.default body .sidebar-nav>li.active:before{display:none}html.default body .sidebar-nav>li.active:after{top:11px;right:0;content:\"\";position:absolute;display:inline-block;border-top:12px solid transparent;border-bottom:12px solid transparent;border-right:10px solid #e9f0f5}html.default body .sidebar-nav-container>.sidebar-nav{border:none;margin-left:-25px;margin-right:-25px}html.default body .sidebar-nav-container>.sidebar-nav>li:before{display:none}html.default body .sidebar-nav-container>.sidebar-nav>li>a{font-size:16px;line-height:16px;padding:15px 25px}html.default body .sidebar-nav-container>.sidebar-nav>li>a>.name{line-height:18px;margin-left:15px}html.default body .sidebar-nav-container>.sidebar-nav>li>a>.rubix-icon,html.default body .sidebar-nav-container>.sidebar-nav>li>a>rubix-icon>.rubix-icon{width:18px;height:19px;display:inline-block}html.default body .sidebar-nav-container>.sidebar-nav>li.active>a{padding-left:20px}html.default body #navbar~#sidebar{top:75px}html.default body #body{left:0;-webkit-box-flex:1;-webkit-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;z-index:100;margin-left:0;position:relative;transition:all .3s ease;background:#e9f0f5;margin-top:25px;padding-bottom:25px}html.default body #navbar~#body{margin-top:74px;padding-top:25px}@media (min-width:990px){html.default body #sidebar~#body{margin-left:250px}}html.default body #sidebar+#body{margin-top:0;padding-top:25px}html.default body .external-event{background:#e76049}html.default body #footer{padding:10px;position:relative;color:#ccd6df;background:#89949b;-webkit-box-flex:0;-webkit-flex:none;-ms-flex:none;flex:none}html.default body #footer-container{transition:all .3s ease}@media (min-width:990px){html.default body #sidebar~#footer-container{margin-left:250px}}html .sidebar-nav>li>a>.toggle-button{top:14px;right:15px;position:absolute}.toggle-button{transform-origin:4px;transition:all .125s ease}.toggle-button.open{transform:rotate(-90deg)}.toggle-button.opposite{transform-origin:12px}.toggle-button.opposite.open{transform:rotate(90deg)}html.touchevents,html.touchevents #app-container,html.touchevents #app-container>#container,html.touchevents>body{position:relative}html.touchevents #body{top:0;bottom:0;left:0!important;right:0!important;padding:0!important;position:fixed!important;margin-bottom:0!important;min-height:100%!important;margin-top:-100px!important}html.touchevents #body>div{position:absolute;top:0;left:0;right:0;bottom:0;overflow-x:hidden!important;overflow-y:scroll!important;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar;padding-top:200px;padding-bottom:25px}html.touchevents #body>div>div{overflow-x:hidden}html.touchevents #sidebar{overflow:hidden!important}html.touchevents #sidebar #sidebar-container .sidebar{overflow-x:hidden!important;overflow-y:scroll!important;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}html.touchevents #footer,html.touchevents #footer-container{display:none!important;position:relative!important}html.static,html.static #app-container,html.static body{background:#273135}html.static #body{margin-top:-35px!important}html.static #rubix-nav-header,html.static #sidebar{position:relative!important}html.static #rubix-nav-header{position:static;margin-top:-110px;margin-bottom:-110px;margin-left:-25px!important;margin-right:-25px}html.static #sidebar,html.static #sidebar #sidebar-container,html.static #sidebar .sidebar{overflow:visible!important}@media (min-width:990px){html.static #rubix-nav-header{margin-left:225px!important}}html.static #container.container-open #rubix-nav-header{margin-left:225px!important}@media (min-width:990px){html.static #container.container-open #rubix-nav-header{margin-right:-25px!important}}html.boxed{background:#333 url(\"/imgs/common/congruent_outline.png\")}html.boxed,html.boxed body{height:100%;overflow:hidden}html.boxed body{margin:0;width:100%;background:none;transition:all .5s ease}html.boxed body #navbar{padding:0}html.boxed body #rubix-nav-header{margin:0;position:absolute}html.boxed body #sidebar{top:75px}html.boxed body #container.container-open>#sidebar{left:0}html.boxed body #container.container-open #rubix-nav-header{margin-left:0;margin-right:0}html.boxed body #container.container-open>#body,html.boxed body #container.container-open>#footer-container{margin-left:250px;margin-right:-250px}@media (min-width:990px){html.boxed body #container.container-open>#body,html.boxed body #container.container-open>#footer-container{margin-right:0;margin-left:250px}}html.boxed body>#app-container{height:100%;overflow:hidden;position:relative}html.boxed body>#app-container #rubix-nav-header{position:relative}html.boxed body>#app-container #sidebar{margin:0;position:absolute}html.boxed body>#app-container #body{left:0;right:0;bottom:0;margin-top:0;overflow:auto;margin-left:0;position:absolute;padding-bottom:25px;padding-top:200px;margin-top:-175px!important;overflow-y:auto;overflow-x:hidden}html.boxed body>#app-container #footer,html.boxed body>#app-container #footer-container{display:none}html.boxed body>#app-container #navbar~#body{margin-top:0;top:69px}@media (min-width:990px){html.boxed body{width:990px;margin:auto;box-shadow:0 0 15px rgba(0,0,0,.5)}html.boxed body>#app-container{margin:auto}html.boxed body>#app-container #sidebar{margin-left:0}html.boxed body>#app-container #sidebar~#body,html.boxed body>#app-container #sidebar~#body~#footer-container{right:0;margin-left:250px}}html.static.boxed{height:auto;overflow:auto;overflow-x:hidden}html.static.boxed body{height:auto;overflow:visible;overflow-x:hidden}html.static.boxed body #app-container{overflow:hidden}html.static.boxed body #container.container-open #rubix-nav-header{margin-left:0!important;margin-right:0!important}html.static.boxed body #navbar{width:100%}html.static.boxed body #rubix-nav-header{margin-right:0;margin-top:-110px;margin-left:0!important}html.static.boxed body #body{overflow:hidden!important;padding-top:95px!important;position:relative!important;padding-bottom:95px!important}html.static.boxed body #footer,html.static.boxed body #footer-container{display:block!important}html.static.boxed body #footer-container{margin-top:25px}@font-face{font-family:Lato;src:url(" + __webpack_require__("./src/styles/fonts/lato/lato-bold-webfont.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/lato/lato-bold-webfont.woff") + ") format(\"woff\");font-weight:700;font-style:normal}@font-face{font-family:Lato;src:url(" + __webpack_require__("./src/styles/fonts/lato/lato-bolditalic-webfont.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/lato/lato-bolditalic-webfont.woff") + ") format(\"woff\");font-weight:700;font-style:italic}@font-face{font-family:Lato;src:url(" + __webpack_require__("./src/styles/fonts/lato/lato-italic-webfont.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/lato/lato-italic-webfont.woff") + ") format(\"woff\");font-weight:400;font-style:italic}@font-face{font-family:Lato;src:url(" + __webpack_require__("./src/styles/fonts/lato/lato-light-webfont.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/lato/lato-light-webfont.woff") + ") format(\"woff\");font-weight:300;font-style:normal}@font-face{font-family:Lato;src:url(" + __webpack_require__("./src/styles/fonts/lato/lato-regular-webfont.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/lato/lato-regular-webfont.woff") + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:fontello;src:url(" + __webpack_require__("./src/styles/fonts/fontello/fontello-webfont.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/fontello/fontello-webfont.woff") + ") format(\"woff\");font-weight:400;font-style:normal}[class*=\" icon-fontello-\"]:before,[class^=icon-fontello-]:before{font-family:fontello;font-style:normal;font-weight:400;speak:none;line-height:1;display:inline-block;text-decoration:inherit;text-align:center;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-fontello-emo-happy:before{content:\"\\E804\"}.icon-fontello-odnoklassniki-rect-1:before{content:\"\\EFFF\"}.icon-fontello-emo-wink2:before{content:\"\\E806\"}.icon-fontello-emo-unhappy:before{content:\"\\E807\"}.icon-fontello-emo-sleep:before{content:\"\\E808\"}.icon-fontello-emo-thumbsup:before{content:\"\\E809\"}.icon-fontello-emo-devil:before{content:\"\\E80A\"}.icon-fontello-emo-surprised:before{content:\"\\E80B\"}.icon-fontello-emo-tongue:before{content:\"\\E80C\"}.icon-fontello-emo-coffee:before{content:\"\\E80D\"}.icon-fontello-emo-sunglasses:before{content:\"\\E80E\"}.icon-fontello-emo-displeased:before{content:\"\\E80F\"}.icon-fontello-emo-beer:before{content:\"\\E810\"}.icon-fontello-emo-grin:before{content:\"\\E811\"}.icon-fontello-emo-angry:before{content:\"\\E812\"}.icon-fontello-emo-saint:before{content:\"\\E813\"}.icon-fontello-emo-cry:before{content:\"\\E800\"}.icon-fontello-emo-shoot:before{content:\"\\E801\"}.icon-fontello-emo-squint:before{content:\"\\E802\"}.icon-fontello-emo-laugh:before{content:\"\\E803\"}.icon-fontello-spin1:before{content:\"\\E814\"}.icon-fontello-spin2:before{content:\"\\E815\"}.icon-fontello-spin3:before{content:\"\\E816\"}.icon-fontello-spin4:before{content:\"\\E817\"}.icon-fontello-spin5:before{content:\"\\E818\"}.icon-fontello-spin6:before{content:\"\\E819\"}.icon-fontello-firefox:before{content:\"\\E81A\"}.icon-fontello-chrome:before{content:\"\\E81B\"}.icon-fontello-opera:before{content:\"\\E81C\"}.icon-fontello-ie:before{content:\"\\E81D\"}.icon-fontello-crown:before{content:\"\\E81E\"}.icon-fontello-crown-plus:before{content:\"\\E81F\"}.icon-fontello-crown-minus:before{content:\"\\E820\"}.icon-fontello-marquee:before{content:\"\\E821\"}.icon-fontello-glass:before{content:\"\\E822\"}.icon-fontello-music-1:before{content:\"\\E823\"}.icon-fontello-search-1:before{content:\"\\E824\"}.icon-fontello-mail-1:before{content:\"\\E825\"}.icon-fontello-mail-alt:before{content:\"\\E826\"}.icon-fontello-heart-1:before{content:\"\\E827\"}.icon-fontello-heart-empty-1:before{content:\"\\E828\"}.icon-fontello-star-1:before{content:\"\\E829\"}.icon-fontello-star-empty-1:before{content:\"\\E82A\"}.icon-fontello-star-half:before{content:\"\\E82B\"}.icon-fontello-star-half-alt:before{content:\"\\E82C\"}.icon-fontello-user-1:before{content:\"\\E82D\"}.icon-fontello-users-1:before{content:\"\\E82E\"}.icon-fontello-male:before{content:\"\\E82F\"}.icon-fontello-female:before{content:\"\\E830\"}.icon-fontello-video-1:before{content:\"\\E831\"}.icon-fontello-videocam:before{content:\"\\E832\"}.icon-fontello-picture-1:before{content:\"\\E833\"}.icon-fontello-camera-1:before{content:\"\\E834\"}.icon-fontello-camera-alt:before{content:\"\\E835\"}.icon-fontello-th-large:before{content:\"\\E836\"}.icon-fontello-th:before{content:\"\\E837\"}.icon-fontello-th-list:before{content:\"\\E838\"}.icon-fontello-ok:before{content:\"\\E839\"}.icon-fontello-ok-circle:before{content:\"\\E83A\"}.icon-fontello-ok-circle2:before{content:\"\\E83B\"}.icon-fontello-ok-squared:before{content:\"\\E83C\"}.icon-fontello-cancel-1:before{content:\"\\E83D\"}.icon-fontello-cancel-circle:before{content:\"\\E83E\"}.icon-fontello-cancel-circle2:before{content:\"\\E83F\"}.icon-fontello-plus-1:before{content:\"\\E840\"}.icon-fontello-plus-circle:before{content:\"\\E841\"}.icon-fontello-plus-squared-1:before{content:\"\\E842\"}.icon-fontello-plus-squared-alt:before{content:\"\\E843\"}.icon-fontello-minus-1:before{content:\"\\E844\"}.icon-fontello-minus-circle:before{content:\"\\E845\"}.icon-fontello-minus-squared:before{content:\"\\E846\"}.icon-fontello-minus-squared-alt:before{content:\"\\E847\"}.icon-fontello-help:before{content:\"\\E848\"}.icon-fontello-help-circle:before{content:\"\\E849\"}.icon-fontello-info-circle:before{content:\"\\E84A\"}.icon-fontello-info:before{content:\"\\E84B\"}.icon-fontello-home-1:before{content:\"\\E84C\"}.icon-fontello-link-1:before{content:\"\\E84D\"}.icon-fontello-unlink:before{content:\"\\E84E\"}.icon-fontello-link-ext:before{content:\"\\E84F\"}.icon-fontello-link-ext-alt:before{content:\"\\E850\"}.icon-fontello-attach-1:before{content:\"\\E851\"}.icon-fontello-lock-1:before{content:\"\\E852\"}.icon-fontello-lock-open-1:before{content:\"\\E853\"}.icon-fontello-lock-open-alt:before{content:\"\\E854\"}.icon-fontello-pin:before{content:\"\\E855\"}.icon-fontello-eye-1:before{content:\"\\E856\"}.icon-fontello-eye-off:before{content:\"\\E857\"}.icon-fontello-tag-1:before{content:\"\\E858\"}.icon-fontello-tags:before{content:\"\\E859\"}.icon-fontello-bookmark-1:before{content:\"\\E85A\"}.icon-fontello-bookmark-empty:before{content:\"\\E85B\"}.icon-fontello-flag-1:before{content:\"\\E85C\"}.icon-fontello-flag-empty:before{content:\"\\E85D\"}.icon-fontello-flag-checkered:before{content:\"\\E85E\"}.icon-fontello-thumbs-up-1:before{content:\"\\E85F\"}.icon-fontello-thumbs-down-1:before{content:\"\\E860\"}.icon-fontello-thumbs-up-alt:before{content:\"\\E861\"}.icon-fontello-thumbs-down-alt:before{content:\"\\E862\"}.icon-fontello-download-1:before{content:\"\\E863\"}.icon-fontello-upload-1:before{content:\"\\E864\"}.icon-fontello-download-cloud:before{content:\"\\E865\"}.icon-fontello-upload-cloud-1:before{content:\"\\E866\"}.icon-fontello-reply-1:before{content:\"\\E867\"}.icon-fontello-reply-all:before{content:\"\\E868\"}.icon-fontello-forward-1:before{content:\"\\E869\"}.icon-fontello-quote-left:before{content:\"\\E86A\"}.icon-fontello-quote-right:before{content:\"\\E86B\"}.icon-fontello-code:before{content:\"\\E86C\"}.icon-fontello-export-1:before{content:\"\\E86D\"}.icon-fontello-export-alt:before{content:\"\\E86E\"}.icon-fontello-pencil-1:before{content:\"\\E86F\"}.icon-fontello-pencil-squared:before{content:\"\\E870\"}.icon-fontello-edit:before{content:\"\\E871\"}.icon-fontello-print-1:before{content:\"\\E872\"}.icon-fontello-retweet-1:before{content:\"\\E873\"}.icon-fontello-keyboard:before{content:\"\\E874\"}.icon-fontello-gamepad:before{content:\"\\E875\"}.icon-fontello-comment-1:before{content:\"\\E876\"}.icon-fontello-chat-1:before{content:\"\\E877\"}.icon-fontello-comment-empty:before{content:\"\\E878\"}.icon-fontello-chat-empty:before{content:\"\\E879\"}.icon-fontello-bell-1:before{content:\"\\E87A\"}.icon-fontello-bell-alt:before{content:\"\\E87B\"}.icon-fontello-attention-alt:before{content:\"\\E87C\";padding-left:5px;padding-right:1px;top:1px;position:relative}.icon-fontello-attention-1:before{content:\"\\E87D\"}.icon-fontello-attention-circle:before{content:\"\\E87E\"}.icon-fontello-location-1:before{content:\"\\E87F\"}.icon-fontello-direction:before{content:\"\\E880\"}.icon-fontello-compass:before{content:\"\\E881\"}.icon-fontello-trash-1:before{content:\"\\E882\"}.icon-fontello-doc-1:before{content:\"\\E883\"}.icon-fontello-docs-1:before{content:\"\\E884\"}.icon-fontello-doc-text:before{content:\"\\E885\"}.icon-fontello-doc-inv:before{content:\"\\E886\"}.icon-fontello-doc-text-inv:before{content:\"\\E887\"}.icon-fontello-folder-1:before{content:\"\\E888\"}.icon-fontello-folder-open:before{content:\"\\E889\"}.icon-fontello-folder-empty:before{content:\"\\E88A\"}.icon-fontello-folder-open-empty:before{content:\"\\E88B\"}.icon-fontello-box:before{content:\"\\E88C\"}.icon-fontello-rss-1:before{content:\"\\E88D\"}.icon-fontello-rss-squared:before{content:\"\\E88E\"}.icon-fontello-phone-1:before{content:\"\\E88F\"}.icon-fontello-phone-squared:before{content:\"\\E890\"}.icon-fontello-menu-1:before{content:\"\\E891\"}.icon-fontello-cog-1:before{content:\"\\E892\"}.icon-fontello-cog-alt:before{content:\"\\E893\"}.icon-fontello-wrench:before{content:\"\\E894\"}.icon-fontello-basket-1:before{content:\"\\E895\"}.icon-fontello-calendar-1:before{content:\"\\E896\"}.icon-fontello-calendar-empty:before{content:\"\\E897\"}.icon-fontello-login-1:before{content:\"\\E898\"}.icon-fontello-logout-1:before{content:\"\\E899\"}.icon-fontello-mic:before{content:\"\\E89A\"}.icon-fontello-mute:before{content:\"\\E89B\"}.icon-fontello-volume-off:before{content:\"\\E89C\"}.icon-fontello-volume-down:before{content:\"\\E89D\"}.icon-fontello-volume-up:before{content:\"\\E89E\"}.icon-fontello-headphones:before{content:\"\\E89F\"}.icon-fontello-clock-1:before{content:\"\\E8A0\"}.icon-fontello-lightbulb:before{content:\"\\E8A1\"}.icon-fontello-block-1:before{content:\"\\E8A2\"}.icon-fontello-resize-full-1:before{content:\"\\E8A3\"}.icon-fontello-resize-full-alt:before{content:\"\\E8A4\"}.icon-fontello-resize-small-1:before{content:\"\\E8A5\"}.icon-fontello-resize-vertical:before{content:\"\\E8A6\"}.icon-fontello-resize-horizontal:before{content:\"\\E8A7\"}.icon-fontello-move:before{content:\"\\E8A8\"}.icon-fontello-zoom-in:before{content:\"\\E8A9\"}.icon-fontello-zoom-out:before{content:\"\\E8AA\"}.icon-fontello-down-circle2:before{content:\"\\E8AB\"}.icon-fontello-up-circle2:before{content:\"\\E8AC\"}.icon-fontello-left-circled2:before{content:\"\\E8AD\"}.icon-fontello-right-circled2:before{content:\"\\E8AE\"}.icon-fontello-down-dir-1:before{content:\"\\E8AF\"}.icon-fontello-up-dir-1:before{content:\"\\E8B0\"}.icon-fontello-left-dir-1:before{content:\"\\E8B1\"}.icon-fontello-right-dir-1:before{content:\"\\E8B2\"}.icon-fontello-down-open-1:before{content:\"\\E8B3\"}.icon-fontello-left-open-1:before{content:\"\\E8B4\"}.icon-fontello-right-open-1:before{content:\"\\E8B5\"}.icon-fontello-up-open-1:before{content:\"\\E8B6\"}.icon-fontello-angle-left:before{content:\"\\E8B7\"}.icon-fontello-angle-right:before{content:\"\\E8B8\"}.icon-fontello-angle-up:before{content:\"\\E8B9\"}.icon-fontello-angle-down:before{content:\"\\E8BA\"}.icon-fontello-angle-circled-left:before{content:\"\\E8BB\"}.icon-fontello-angle-circled-right:before{content:\"\\E8BC\"}.icon-fontello-angle-circled-up:before{content:\"\\E8BD\"}.icon-fontello-angle-circled-down:before{content:\"\\E8BE\"}.icon-fontello-angle-double-left:before{content:\"\\E8BF\"}.icon-fontello-angle-double-right:before{content:\"\\E8C0\"}.icon-fontello-angle-double-up:before{content:\"\\E8C1\"}.icon-fontello-angle-double-down:before{content:\"\\E8C2\"}.icon-fontello-down:before{content:\"\\E8C3\"}.icon-fontello-right:before{content:\"\\E8C4\"}.icon-fontello-left:before{content:\"\\E8C5\"}.icon-fontello-up:before{content:\"\\E8C6\"}.icon-fontello-down-1:before{content:\"\\E8C7\"}.icon-fontello-left-1:before{content:\"\\E8C8\"}.icon-fontello-emo-wink:before{content:\"\\E805\"}.icon-fontello-up-1:before{content:\"\\E8CA\"}.icon-fontello-right-hand:before{content:\"\\E8CB\"}.icon-fontello-left-hand:before{content:\"\\E8CC\"}.icon-fontello-up-hand:before{content:\"\\E8CD\"}.icon-fontello-down-hand:before{content:\"\\E8CE\"}.icon-fontello-left-circled-1:before{content:\"\\E8CF\"}.icon-fontello-right-circled-1:before{content:\"\\E8D0\"}.icon-fontello-up-circled-1:before{content:\"\\E8D1\"}.icon-fontello-down-circled-1:before{content:\"\\E8D2\"}.icon-fontello-cw-1:before{content:\"\\E8D3\"}.icon-fontello-ccw-1:before{content:\"\\E8D4\"}.icon-fontello-arrows-cw:before{content:\"\\E8D5\"}.icon-fontello-level-up:before{content:\"\\E8D6\"}.icon-fontello-level-down:before{content:\"\\E8D7\"}.icon-fontello-shuffle-1:before{content:\"\\E8D8\"}.icon-fontello-exchange:before{content:\"\\E8D9\"}.icon-fontello-collapse:before{content:\"\\E8DA\"}.icon-fontello-collapse-top:before{content:\"\\E8DB\"}.icon-fontello-expand:before{content:\"\\E8DC\"}.icon-fontello-collapse-left:before{content:\"\\E8DD\"}.icon-fontello-play-1:before{content:\"\\E8DE\"}.icon-fontello-play-circled:before{content:\"\\E8DF\"}.icon-fontello-play-circle2:before{content:\"\\E8E0\"}.icon-fontello-stop-1:before{content:\"\\E8E1\"}.icon-fontello-pause-1:before{content:\"\\E8E2\"}.icon-fontello-to-end-1:before{content:\"\\E8E3\"}.icon-fontello-to-end-alt:before{content:\"\\E8E4\"}.icon-fontello-to-start-1:before{content:\"\\E8E5\"}.icon-fontello-to-start-alt:before{content:\"\\E8E6\"}.icon-fontello-fast-fw:before{content:\"\\E8E7\"}.icon-fontello-fast-bw:before{content:\"\\E8E8\"}.icon-fontello-eject:before{content:\"\\E8E9\"}.icon-fontello-target-1:before{content:\"\\E8EA\"}.icon-fontello-signal-1:before{content:\"\\E8EB\"}.icon-fontello-award:before{content:\"\\E8EC\"}.icon-fontello-desktop:before{content:\"\\E8ED\"}.icon-fontello-laptop:before{content:\"\\E8EE\"}.icon-fontello-tablet:before{content:\"\\E8EF\"}.icon-fontello-mobile-1:before{content:\"\\E8F0\"}.icon-fontello-inbox-1:before{content:\"\\E8F1\"}.icon-fontello-globe-1:before{content:\"\\E8F2\"}.icon-fontello-sun:before{content:\"\\E8F3\"}.icon-fontello-cloud-1:before{content:\"\\E8F4\"}.icon-fontello-flash-1:before{content:\"\\E8F5\"}.icon-fontello-moon:before{content:\"\\E8F6\"}.icon-fontello-umbrella:before{content:\"\\E8F7\"}.icon-fontello-flight-1:before{content:\"\\E8F8\"}.icon-fontello-fighter-jet:before{content:\"\\E8F9\"}.icon-fontello-leaf-1:before{content:\"\\E8FA\"}.icon-fontello-font:before{content:\"\\E8FB\"}.icon-fontello-bold:before{content:\"\\E8FC\"}.icon-fontello-italic:before{content:\"\\E8FD\"}.icon-fontello-text-height:before{content:\"\\E8FE\"}.icon-fontello-text-width:before{content:\"\\E8FF\"}.icon-fontello-align-left:before{content:\"\\E900\"}.icon-fontello-align-center:before{content:\"\\E901\"}.icon-fontello-align-right:before{content:\"\\E902\"}.icon-fontello-align-justify:before{content:\"\\E903\"}.icon-fontello-list-1:before{content:\"\\E904\"}.icon-fontello-indent-left:before{content:\"\\E905\"}.icon-fontello-indent-right:before{content:\"\\E906\"}.icon-fontello-list-bullet:before{content:\"\\E907\"}.icon-fontello-list-numbered:before{content:\"\\E908\"}.icon-fontello-strike:before{content:\"\\E909\"}.icon-fontello-underline:before{content:\"\\E90A\"}.icon-fontello-superscript:before{content:\"\\E90B\"}.icon-fontello-subscript:before{content:\"\\E90C\"}.icon-fontello-table:before{content:\"\\E90D\"}.icon-fontello-columns:before{content:\"\\E90E\"}.icon-fontello-crop:before{content:\"\\E90F\"}.icon-fontello-scissors:before{content:\"\\E910\"}.icon-fontello-paste:before{content:\"\\E911\"}.icon-fontello-briefcase-1:before{content:\"\\E912\"}.icon-fontello-suitcase-1:before{content:\"\\E913\"}.icon-fontello-ellipsis:before{content:\"\\E914\"}.icon-fontello-ellipsis-vert:before{content:\"\\E915\"}.icon-fontello-off:before{content:\"\\E916\"}.icon-fontello-road:before{content:\"\\E917\"}.icon-fontello-list-alt:before{content:\"\\E918\"}.icon-fontello-qrcode:before{content:\"\\E919\"}.icon-fontello-barcode:before{content:\"\\E91A\"}.icon-fontello-book-1:before{content:\"\\E91B\"}.icon-fontello-ajust:before{content:\"\\E91C\"}.icon-fontello-tint:before{content:\"\\E91D\"}.icon-fontello-check-1:before{content:\"\\E91E\"}.icon-fontello-check-empty:before{content:\"\\E91F\"}.icon-fontello-circle:before{content:\"\\E920\"}.icon-fontello-circle-empty:before{content:\"\\E921\"}.icon-fontello-dot-circled:before{content:\"\\E922\"}.icon-fontello-asterisk:before{content:\"\\E923\"}.icon-fontello-gift:before{content:\"\\E924\"}.icon-fontello-fire:before{content:\"\\E925\"}.icon-fontello-magnet-1:before{content:\"\\E926\"}.icon-fontello-chart-bar-1:before{content:\"\\E927\"}.icon-fontello-ticket:before{content:\"\\E928\"}.icon-fontello-credit-card-1:before{content:\"\\E929\"}.icon-fontello-floppy-1:before{content:\"\\E92A\"}.icon-fontello-megaphone-1:before{content:\"\\E92B\"}.icon-fontello-hdd:before{content:\"\\E92C\"}.icon-fontello-key-1:before{content:\"\\E92D\"}.icon-fontello-fork:before{content:\"\\E92E\"}.icon-fontello-rocket:before{content:\"\\E92F\"}.icon-fontello-bug:before{content:\"\\E930\"}.icon-fontello-certificate:before{content:\"\\E931\"}.icon-fontello-tasks:before{content:\"\\E932\"}.icon-fontello-filter:before{content:\"\\E933\"}.icon-fontello-beaker:before{content:\"\\E934\"}.icon-fontello-magic:before{content:\"\\E935\"}.icon-fontello-truck:before{content:\"\\E936\"}.icon-fontello-money:before{content:\"\\E937\"}.icon-fontello-euro:before{content:\"\\E938\"}.icon-fontello-pound:before{content:\"\\E939\"}.icon-fontello-dollar:before{content:\"\\E93A\"}.icon-fontello-rupee:before{content:\"\\E93B\"}.icon-fontello-yen:before{content:\"\\E93C\"}.icon-fontello-renminbi:before{content:\"\\E93D\"}.icon-fontello-try:before{content:\"\\E93E\"}.icon-fontello-won:before{content:\"\\E93F\"}.icon-fontello-bitcoin:before{content:\"\\E940\"}.icon-fontello-sort:before{content:\"\\E941\"}.icon-fontello-sort-down:before{content:\"\\E942\"}.icon-fontello-sort-up:before{content:\"\\E943\"}.icon-fontello-sort-alt-up:before{content:\"\\E944\"}.icon-fontello-sort-alt-down:before{content:\"\\E945\"}.icon-fontello-sort-name-up:before{content:\"\\E946\"}.icon-fontello-sort-name-down:before{content:\"\\E947\"}.icon-fontello-sort-number-up:before{content:\"\\E948\"}.icon-fontello-sort-number-down:before{content:\"\\E949\"}.icon-fontello-hammer:before{content:\"\\E94A\"}.icon-fontello-gauge-1:before{content:\"\\E94B\"}.icon-fontello-sitemap:before{content:\"\\E94C\"}.icon-fontello-spinner:before{content:\"\\E94D\"}.icon-fontello-coffee:before{content:\"\\E94E\"}.icon-fontello-food:before{content:\"\\E94F\"}.icon-fontello-beer:before{content:\"\\E950\"}.icon-fontello-user-md:before{content:\"\\E951\"}.icon-fontello-stethoscope:before{content:\"\\E952\"}.icon-fontello-ambulance:before{content:\"\\E953\"}.icon-fontello-medkit:before{content:\"\\E954\"}.icon-fontello-h-sigh:before{content:\"\\E955\"}.icon-fontello-hospital:before{content:\"\\E956\"}.icon-fontello-building:before{content:\"\\E957\"}.icon-fontello-smile:before{content:\"\\E958\"}.icon-fontello-frown:before{content:\"\\E959\"}.icon-fontello-meh:before{content:\"\\E95A\"}.icon-fontello-anchor:before{content:\"\\E95B\"}.icon-fontello-terminal:before{content:\"\\E95C\"}.icon-fontello-eraser:before{content:\"\\E95D\"}.icon-fontello-puzzle:before{content:\"\\E95E\"}.icon-fontello-shield:before{content:\"\\E95F\"}.icon-fontello-extinguisher:before{content:\"\\E960\"}.icon-fontello-bullseye:before{content:\"\\E961\"}.icon-fontello-wheelchair:before{content:\"\\E962\"}.icon-fontello-adn:before{content:\"\\E963\"}.icon-fontello-android:before{content:\"\\E964\"}.icon-fontello-apple:before{content:\"\\E965\"}.icon-fontello-bitbucket:before{content:\"\\E966\"}.icon-fontello-bitbucket-squared:before{content:\"\\E967\"}.icon-fontello-css3:before{content:\"\\E968\"}.icon-fontello-dribbble:before{content:\"\\E969\"}.icon-fontello-dropbox:before{content:\"\\E96A\"}.icon-fontello-facebook:before{content:\"\\E96B\"}.icon-fontello-facebook-squared:before{content:\"\\E96C\"}.icon-fontello-flickr:before{content:\"\\E96D\"}.icon-fontello-foursquare:before{content:\"\\E96E\"}.icon-fontello-github:before{content:\"\\E96F\"}.icon-fontello-github-squared:before{content:\"\\E970\"}.icon-fontello-github-circled-1:before{content:\"\\E971\"}.icon-fontello-gittip:before{content:\"\\E972\"}.icon-fontello-gplus-squared:before{content:\"\\E973\"}.icon-fontello-gplus:before{content:\"\\E974\"}.icon-fontello-html5:before{content:\"\\E975\"}.icon-fontello-instagramm:before{content:\"\\E976\"}.icon-fontello-linkedin-squared:before{content:\"\\E977\"}.icon-fontello-linux:before{content:\"\\E978\"}.icon-fontello-linkedin:before{content:\"\\E979\"}.icon-fontello-maxcdn:before{content:\"\\E97A\"}.icon-fontello-pagelines:before{content:\"\\E97B\"}.icon-fontello-pinterest-circled:before{content:\"\\E97C\"}.icon-fontello-pinterest-squared:before{content:\"\\E97D\"}.icon-fontello-renren:before{content:\"\\E97E\"}.icon-fontello-skype:before{content:\"\\E97F\"}.icon-fontello-stackexchange:before{content:\"\\E980\"}.icon-fontello-stackoverflow:before{content:\"\\E981\"}.icon-fontello-trello:before{content:\"\\E982\"}.icon-fontello-tumblr:before{content:\"\\E983\"}.icon-fontello-tumblr-squared:before{content:\"\\E984\"}.icon-fontello-twitter-squared:before{content:\"\\E985\"}.icon-fontello-twitter:before{content:\"\\E986\"}.icon-fontello-vimeo-squared:before{content:\"\\E987\"}.icon-fontello-vkontakte:before{content:\"\\E988\"}.icon-fontello-weibo:before{content:\"\\E989\"}.icon-fontello-windows:before{content:\"\\E98A\"}.icon-fontello-xing:before{content:\"\\E98B\"}.icon-fontello-xing-squared:before{content:\"\\E98C\"}.icon-fontello-youtube:before{content:\"\\E98D\"}.icon-fontello-youtube-squared:before{content:\"\\E98E\"}.icon-fontello-youtube-play:before{content:\"\\E98F\"}.icon-fontello-blank:before{content:\"\\E990\"}.icon-fontello-lemon:before{content:\"\\E991\"}.icon-fontello-note:before{content:\"\\E992\"}.icon-fontello-note-beamed:before{content:\"\\E993\"}.icon-fontello-music:before{content:\"\\E994\"}.icon-fontello-search:before{content:\"\\E995\"}.icon-fontello-flashlight:before{content:\"\\E996\"}.icon-fontello-mail:before{content:\"\\E997\"}.icon-fontello-heart:before{content:\"\\E998\"}.icon-fontello-heart-empty:before{content:\"\\E999\"}.icon-fontello-star:before{content:\"\\E99A\"}.icon-fontello-star-empty:before{content:\"\\E99B\"}.icon-fontello-user:before{content:\"\\E99C\"}.icon-fontello-users:before{content:\"\\E99D\"}.icon-fontello-user-add:before{content:\"\\E99E\"}.icon-fontello-video:before{content:\"\\E99F\"}.icon-fontello-picture:before{content:\"\\E9A0\"}.icon-fontello-camera:before{content:\"\\E9A1\"}.icon-fontello-layout:before{content:\"\\E9A2\"}.icon-fontello-menu:before{content:\"\\E9A3\"}.icon-fontello-check:before{content:\"\\E9A4\"}.icon-fontello-cancel:before{content:\"\\E9A5\"}.icon-fontello-cancel-circled:before{content:\"\\E9A6\"}.icon-fontello-cancel-squared:before{content:\"\\E9A7\"}.icon-fontello-plus:before{content:\"\\E9A8\"}.icon-fontello-plus-circled:before{content:\"\\E9A9\"}.icon-fontello-plus-squared:before{content:\"\\E9AA\"}.icon-fontello-minus:before{content:\"\\E9AB\"}.icon-fontello-minus-circled:before{content:\"\\E9AC\"}.icon-fontello-minus-squared-1:before{content:\"\\E9AD\"}.icon-fontello-help-1:before{content:\"\\E9AE\"}.icon-fontello-help-circled:before{content:\"\\E9AF\"}.icon-fontello-info-1:before{content:\"\\E9B0\"}.icon-fontello-info-circled:before{content:\"\\E9B1\"}.icon-fontello-back:before{content:\"\\E9B2\"}.icon-fontello-home:before{content:\"\\E9B3\"}.icon-fontello-link:before{content:\"\\E9B4\"}.icon-fontello-attach:before{content:\"\\E9B5\"}.icon-fontello-lock:before{content:\"\\E9B6\"}.icon-fontello-lock-open:before{content:\"\\E9B7\"}.icon-fontello-eye:before{content:\"\\E9B8\"}.icon-fontello-tag:before{content:\"\\E9B9\"}.icon-fontello-bookmark:before{content:\"\\E9BA\"}.icon-fontello-bookmarks:before{content:\"\\E9BB\"}.icon-fontello-flag:before{content:\"\\E9BC\"}.icon-fontello-thumbs-up:before{content:\"\\E9BD\"}.icon-fontello-thumbs-down:before{content:\"\\E9BE\"}.icon-fontello-download:before{content:\"\\E9BF\"}.icon-fontello-upload:before{content:\"\\E9C0\"}.icon-fontello-upload-cloud:before{content:\"\\E9C1\"}.icon-fontello-reply:before{content:\"\\E9C2\"}.icon-fontello-reply-all-1:before{content:\"\\E9C3\"}.icon-fontello-forward:before{content:\"\\E9C4\"}.icon-fontello-quote:before{content:\"\\E9C5\"}.icon-fontello-code-1:before{content:\"\\E9C6\"}.icon-fontello-export:before{content:\"\\E9C7\"}.icon-fontello-pencil:before{content:\"\\E9C8\"}.icon-fontello-feather:before{content:\"\\E9C9\"}.icon-fontello-print:before{content:\"\\E9CA\"}.icon-fontello-retweet:before{content:\"\\E9CB\"}.icon-fontello-keyboard-1:before{content:\"\\E9CC\"}.icon-fontello-comment:before{content:\"\\E9CD\"}.icon-fontello-chat:before{content:\"\\E9CE\"}.icon-fontello-bell:before{content:\"\\E9CF\"}.icon-fontello-attention:before{content:\"\\E9D0\"}.icon-fontello-alert:before{content:\"\\E9D1\"}.icon-fontello-vcard:before{content:\"\\E9D2\"}.icon-fontello-address:before{content:\"\\E9D3\"}.icon-fontello-location:before{content:\"\\E9D4\"}.icon-fontello-map:before{content:\"\\E9D5\"}.icon-fontello-direction-1:before{content:\"\\E9D6\"}.icon-fontello-compass-1:before{content:\"\\E9D7\"}.icon-fontello-cup:before{content:\"\\E9D8\"}.icon-fontello-trash:before{content:\"\\E9D9\"}.icon-fontello-doc:before{content:\"\\E9DA\"}.icon-fontello-docs:before{content:\"\\E9DB\"}.icon-fontello-doc-landscape:before{content:\"\\E9DC\"}.icon-fontello-doc-text-1:before{content:\"\\E9DD\"}.icon-fontello-doc-text-inv-1:before{content:\"\\E9DE\"}.icon-fontello-newspaper:before{content:\"\\E9DF\"}.icon-fontello-book-open:before{content:\"\\E9E0\"}.icon-fontello-book:before{content:\"\\E9E1\"}.icon-fontello-folder:before{content:\"\\E9E2\"}.icon-fontello-archive:before{content:\"\\E9E3\"}.icon-fontello-box-1:before{content:\"\\E9E4\"}.icon-fontello-rss:before{content:\"\\E9E5\"}.icon-fontello-phone:before{content:\"\\E9E6\"}.icon-fontello-cog:before{content:\"\\E9E7\"}.icon-fontello-tools:before{content:\"\\E9E8\"}.icon-fontello-share:before{content:\"\\E9E9\"}.icon-fontello-shareable:before{content:\"\\E9EA\"}.icon-fontello-basket:before{content:\"\\E9EB\"}.icon-fontello-bag:before{content:\"\\E9EC\"}.icon-fontello-calendar:before{content:\"\\E9ED\"}.icon-fontello-login:before{content:\"\\E9EE\"}.icon-fontello-logout:before{content:\"\\E9EF\"}.icon-fontello-mic-1:before{content:\"\\E9F0\"}.icon-fontello-mute-1:before{content:\"\\E9F1\"}.icon-fontello-sound:before{content:\"\\E9F2\"}.icon-fontello-volume:before{content:\"\\E9F3\"}.icon-fontello-clock:before{content:\"\\E9F4\"}.icon-fontello-hourglass:before{content:\"\\E9F5\"}.icon-fontello-lamp:before{content:\"\\E9F6\"}.icon-fontello-light-down:before{content:\"\\E9F7\"}.icon-fontello-light-up:before{content:\"\\E9F8\"}.icon-fontello-adjust:before{content:\"\\E9F9\"}.icon-fontello-block:before{content:\"\\E9FA\"}.icon-fontello-resize-full:before{content:\"\\E9FB\"}.icon-fontello-resize-small:before{content:\"\\E9FC\"}.icon-fontello-popup:before{content:\"\\E9FD\"}.icon-fontello-publish:before{content:\"\\E9FE\"}.icon-fontello-window:before{content:\"\\E9FF\"}.icon-fontello-arrow-combo:before{content:\"\\EA00\"}.icon-fontello-down-circled:before{content:\"\\EA01\"}.icon-fontello-left-circled:before{content:\"\\EA02\"}.icon-fontello-right-circled:before{content:\"\\EA03\"}.icon-fontello-up-circled:before{content:\"\\EA04\"}.icon-fontello-down-open:before{content:\"\\EA05\"}.icon-fontello-left-open:before{content:\"\\EA06\"}.icon-fontello-right-open:before{content:\"\\EA07\"}.icon-fontello-up-open:before{content:\"\\EA08\"}.icon-fontello-down-open-mini:before{content:\"\\EA09\"}.icon-fontello-left-open-mini:before{content:\"\\EA0A\"}.icon-fontello-right-open-mini:before{content:\"\\EA0B\"}.icon-fontello-up-open-mini:before{content:\"\\EA0C\"}.icon-fontello-down-open-big:before{content:\"\\EA0D\"}.icon-fontello-left-open-big:before{content:\"\\EA0E\"}.icon-fontello-right-open-big:before{content:\"\\EA0F\"}.icon-fontello-up-open-big:before{content:\"\\EA10\"}.icon-fontello-down-2:before{content:\"\\EA11\"}.icon-fontello-left-2:before{content:\"\\EA12\"}.icon-fontello-right-2:before{content:\"\\EA13\"}.icon-fontello-up-2:before{content:\"\\EA14\"}.icon-fontello-down-dir:before{content:\"\\EA15\"}.icon-fontello-left-dir:before{content:\"\\EA16\"}.icon-fontello-right-dir:before{content:\"\\EA17\"}.icon-fontello-up-dir:before{content:\"\\EA18\"}.icon-fontello-down-bold:before{content:\"\\EA19\"}.icon-fontello-left-bold:before{content:\"\\EA1A\"}.icon-fontello-right-bold:before{content:\"\\EA1B\"}.icon-fontello-up-bold:before{content:\"\\EA1C\"}.icon-fontello-down-thin:before{content:\"\\EA1D\"}.icon-fontello-left-thin:before{content:\"\\EA1E\"}.icon-fontello-right-thin:before{content:\"\\EA1F\"}.icon-fontello-up-thin:before{content:\"\\EA20\"}.icon-fontello-ccw:before{content:\"\\EA21\"}.icon-fontello-cw:before{content:\"\\EA22\"}.icon-fontello-arrows-ccw:before{content:\"\\EA23\"}.icon-fontello-level-down-1:before{content:\"\\EA24\"}.icon-fontello-level-up-1:before{content:\"\\EA25\"}.icon-fontello-shuffle:before{content:\"\\EA26\"}.icon-fontello-loop:before{content:\"\\EA27\"}.icon-fontello-switch:before{content:\"\\EA28\"}.icon-fontello-play:before{content:\"\\EA29\"}.icon-fontello-stop:before{content:\"\\EA2A\"}.icon-fontello-pause:before{content:\"\\EA2B\"}.icon-fontello-record:before{content:\"\\EA2C\"}.icon-fontello-to-end:before{content:\"\\EA2D\"}.icon-fontello-to-start:before{content:\"\\EA2E\"}.icon-fontello-fast-forward:before{content:\"\\EA2F\"}.icon-fontello-fast-backward:before{content:\"\\EA30\"}.icon-fontello-progress-0:before{content:\"\\EA31\"}.icon-fontello-progress-1:before{content:\"\\EA32\"}.icon-fontello-progress-2:before{content:\"\\EA33\"}.icon-fontello-progress-3:before{content:\"\\EA34\"}.icon-fontello-target:before{content:\"\\EA35\"}.icon-fontello-palette:before{content:\"\\EA36\"}.icon-fontello-list:before{content:\"\\EA37\"}.icon-fontello-list-add:before{content:\"\\EA38\"}.icon-fontello-signal:before{content:\"\\EA39\"}.icon-fontello-trophy:before{content:\"\\EA3A\"}.icon-fontello-battery:before{content:\"\\EA3B\"}.icon-fontello-back-in-time:before{content:\"\\EA3C\"}.icon-fontello-monitor:before{content:\"\\EA3D\"}.icon-fontello-mobile:before{content:\"\\EA3E\"}.icon-fontello-network:before{content:\"\\EA3F\"}.icon-fontello-cd:before{content:\"\\EA40\"}.icon-fontello-inbox:before{content:\"\\EA41\"}.icon-fontello-install:before{content:\"\\EA42\"}.icon-fontello-globe:before{content:\"\\EA43\"}.icon-fontello-cloud:before{content:\"\\EA44\"}.icon-fontello-cloud-thunder:before{content:\"\\EA45\"}.icon-fontello-flash:before{content:\"\\EA46\"}.icon-fontello-moon-1:before{content:\"\\EA47\"}.icon-fontello-flight:before{content:\"\\EA48\"}.icon-fontello-paper-plane:before{content:\"\\EA49\"}.icon-fontello-leaf:before{content:\"\\EA4A\"}.icon-fontello-lifebuoy:before{content:\"\\EA4B\"}.icon-fontello-mouse:before{content:\"\\EA4C\"}.icon-fontello-briefcase:before{content:\"\\EA4D\"}.icon-fontello-suitcase:before{content:\"\\EA4E\"}.icon-fontello-dot:before{content:\"\\EA4F\"}.icon-fontello-dot-2:before{content:\"\\EA50\"}.icon-fontello-dot-3:before{content:\"\\EA51\"}.icon-fontello-brush:before{content:\"\\EA52\"}.icon-fontello-magnet:before{content:\"\\EA53\"}.icon-fontello-infinity:before{content:\"\\EA54\"}.icon-fontello-erase:before{content:\"\\EA55\"}.icon-fontello-chart-pie:before{content:\"\\EA56\"}.icon-fontello-chart-line:before{content:\"\\EA57\"}.icon-fontello-chart-bar:before{content:\"\\EA58\"}.icon-fontello-chart-area:before{content:\"\\EA59\"}.icon-fontello-tape:before{content:\"\\EA5A\"}.icon-fontello-graduation-cap:before{content:\"\\EA5B\"}.icon-fontello-language:before{content:\"\\EA5C\"}.icon-fontello-ticket-1:before{content:\"\\EA5D\"}.icon-fontello-water:before{content:\"\\EA5E\"}.icon-fontello-droplet:before{content:\"\\EA5F\"}.icon-fontello-air:before{content:\"\\EA60\"}.icon-fontello-credit-card:before{content:\"\\EA61\"}.icon-fontello-floppy:before{content:\"\\EA62\"}.icon-fontello-clipboard:before{content:\"\\EA63\"}.icon-fontello-megaphone:before{content:\"\\EA64\"}.icon-fontello-database:before{content:\"\\EA65\"}.icon-fontello-drive:before{content:\"\\EA66\"}.icon-fontello-bucket:before{content:\"\\EA67\"}.icon-fontello-thermometer:before{content:\"\\EA68\"}.icon-fontello-key:before{content:\"\\EA69\"}.icon-fontello-flow-cascade:before{content:\"\\EA6A\"}.icon-fontello-flow-branch:before{content:\"\\EA6B\"}.icon-fontello-flow-tree:before{content:\"\\EA6C\"}.icon-fontello-flow-line:before{content:\"\\EA6D\"}.icon-fontello-flow-parallel:before{content:\"\\EA6E\"}.icon-fontello-rocket-1:before{content:\"\\EA6F\"}.icon-fontello-gauge:before{content:\"\\EA70\"}.icon-fontello-traffic-cone:before{content:\"\\EA71\"}.icon-fontello-cc:before{content:\"\\EA72\"}.icon-fontello-cc-by:before{content:\"\\EA73\"}.icon-fontello-cc-nc:before{content:\"\\EA74\"}.icon-fontello-cc-nc-eu:before{content:\"\\EA75\"}.icon-fontello-cc-nc-jp:before{content:\"\\EA76\"}.icon-fontello-cc-sa:before{content:\"\\EA77\"}.icon-fontello-cc-nd:before{content:\"\\EA78\"}.icon-fontello-cc-pd:before{content:\"\\EA79\"}.icon-fontello-cc-zero:before{content:\"\\EA7A\"}.icon-fontello-cc-share:before{content:\"\\EA7B\"}.icon-fontello-cc-remix:before{content:\"\\EA7C\"}.icon-fontello-github-1:before{content:\"\\EA7D\"}.icon-fontello-github-circled:before{content:\"\\EA7E\"}.icon-fontello-flickr-1:before{content:\"\\EA7F\"}.icon-fontello-flickr-circled:before{content:\"\\EA80\"}.icon-fontello-vimeo:before{content:\"\\EA81\"}.icon-fontello-vimeo-circled:before{content:\"\\EA82\"}.icon-fontello-twitter-1:before{content:\"\\EA83\"}.icon-fontello-twitter-circled:before{content:\"\\EA84\"}.icon-fontello-facebook-1:before{content:\"\\EA85\"}.icon-fontello-facebook-circled:before{content:\"\\EA86\"}.icon-fontello-facebook-squared-1:before{content:\"\\EA87\"}.icon-fontello-gplus-1:before{content:\"\\EA88\"}.icon-fontello-gplus-circled:before{content:\"\\EA89\"}.icon-fontello-pinterest:before{content:\"\\EA8A\"}.icon-fontello-pinterest-circled-1:before{content:\"\\EA8B\"}.icon-fontello-tumblr-1:before{content:\"\\EA8C\"}.icon-fontello-tumblr-circled:before{content:\"\\EA8D\"}.icon-fontello-linkedin-1:before{content:\"\\EA8E\"}.icon-fontello-linkedin-circled:before{content:\"\\EA8F\"}.icon-fontello-dribbble-1:before{content:\"\\EA90\"}.icon-fontello-dribbble-circled:before{content:\"\\EA91\"}.icon-fontello-stumbleupon:before{content:\"\\EA92\"}.icon-fontello-stumbleupon-circled:before{content:\"\\EA93\"}.icon-fontello-lastfm:before{content:\"\\EA94\"}.icon-fontello-lastfm-circled:before{content:\"\\EA95\"}.icon-fontello-rdio:before{content:\"\\EA96\"}.icon-fontello-rdio-circled:before{content:\"\\EA97\"}.icon-fontello-spotify:before{content:\"\\EA98\"}.icon-fontello-spotify-circled:before{content:\"\\EA99\"}.icon-fontello-qq:before{content:\"\\EA9A\"}.icon-fontello-instagram:before{content:\"\\EA9B\"}.icon-fontello-dropbox-1:before{content:\"\\EA9C\"}.icon-fontello-evernote:before{content:\"\\EA9D\"}.icon-fontello-flattr:before{content:\"\\EA9E\"}.icon-fontello-skype-1:before{content:\"\\EA9F\"}.icon-fontello-skype-circled:before{content:\"\\EAA0\"}.icon-fontello-renren-1:before{content:\"\\EAA1\"}.icon-fontello-sina-weibo:before{content:\"\\EAA2\"}.icon-fontello-paypal:before{content:\"\\EAA3\"}.icon-fontello-picasa:before{content:\"\\EAA4\"}.icon-fontello-soundcloud:before{content:\"\\EAA5\"}.icon-fontello-mixi:before{content:\"\\EAA6\"}.icon-fontello-behance:before{content:\"\\EAA7\"}.icon-fontello-google-circles:before{content:\"\\EAA8\"}.icon-fontello-vkontakte-1:before{content:\"\\EAA9\"}.icon-fontello-smashing:before{content:\"\\EAAA\"}.icon-fontello-sweden:before{content:\"\\EAAB\"}.icon-fontello-db-shape:before{content:\"\\EAAC\"}.icon-fontello-logo-db:before{content:\"\\EAAD\"}.icon-fontello-music-outline:before{content:\"\\EAAE\"}.icon-fontello-music-2:before{content:\"\\EAAF\"}.icon-fontello-search-outline:before{content:\"\\EAB0\"}.icon-fontello-search-2:before{content:\"\\EAB1\"}.icon-fontello-mail-2:before{content:\"\\EAB2\"}.icon-fontello-heart-2:before{content:\"\\EAB3\"}.icon-fontello-heart-filled:before{content:\"\\EAB4\"}.icon-fontello-star-2:before{content:\"\\EAB5\"}.icon-fontello-star-filled:before{content:\"\\EAB6\"}.icon-fontello-user-outline:before{content:\"\\EAB7\"}.icon-fontello-user-2:before{content:\"\\EAB8\"}.icon-fontello-users-outline:before{content:\"\\EAB9\"}.icon-fontello-users-2:before{content:\"\\EABA\"}.icon-fontello-user-add-outline:before{content:\"\\EABB\"}.icon-fontello-user-add-1:before{content:\"\\EABC\"}.icon-fontello-user-delete-outline:before{content:\"\\EABD\"}.icon-fontello-user-delete:before{content:\"\\EABE\"}.icon-fontello-video-2:before{content:\"\\EABF\"}.icon-fontello-videocam-outline:before{content:\"\\EAC0\"}.icon-fontello-videocam-1:before{content:\"\\EAC1\"}.icon-fontello-picture-outline:before{content:\"\\EAC2\"}.icon-fontello-picture-2:before{content:\"\\EAC3\"}.icon-fontello-camera-outline:before{content:\"\\EAC4\"}.icon-fontello-camera-2:before{content:\"\\EAC5\"}.icon-fontello-th-outline:before{content:\"\\EAC6\"}.icon-fontello-th-1:before{content:\"\\EAC7\"}.icon-fontello-th-large-outline:before{content:\"\\EAC8\"}.icon-fontello-th-large-1:before{content:\"\\EAC9\"}.icon-fontello-th-list-outline:before{content:\"\\EACA\"}.icon-fontello-th-list-1:before{content:\"\\EACB\"}.icon-fontello-ok-outline:before{content:\"\\EACC\"}.icon-fontello-ok-1:before{content:\"\\EACD\"}.icon-fontello-cancel-outline:before{content:\"\\EACE\"}.icon-fontello-cancel-2:before{content:\"\\EACF\"}.icon-fontello-cancel-alt:before{content:\"\\EAD0\"}.icon-fontello-cancel-alt-filled:before{content:\"\\EAD1\"}.icon-fontello-cancel-circled-outline:before{content:\"\\EAD2\"}.icon-fontello-cancel-circled-1:before{content:\"\\EAD3\"}.icon-fontello-plus-outline:before{content:\"\\EAD4\"}.icon-fontello-plus-2:before{content:\"\\EAD5\"}.icon-fontello-minus-outline:before{content:\"\\EAD6\"}.icon-fontello-minus-2:before{content:\"\\EAD7\"}.icon-fontello-divide-outline:before{content:\"\\EAD8\"}.icon-fontello-divide:before{content:\"\\EAD9\"}.icon-fontello-eq-outline:before{content:\"\\EADA\"}.icon-fontello-eq:before{content:\"\\EADB\"}.icon-fontello-info-outline:before{content:\"\\EADC\"}.icon-fontello-info-2:before{content:\"\\EADD\"}.icon-fontello-home-outline:before{content:\"\\EADE\"}.icon-fontello-home-2:before{content:\"\\EADF\"}.icon-fontello-link-outline:before{content:\"\\EAE0\"}.icon-fontello-link-2:before{content:\"\\EAE1\"}.icon-fontello-attach-outline:before{content:\"\\EAE2\"}.icon-fontello-attach-2:before{content:\"\\EAE3\"}.icon-fontello-lock-2:before{content:\"\\EAE4\"}.icon-fontello-lock-filled:before{content:\"\\EAE5\"}.icon-fontello-lock-open-2:before{content:\"\\EAE6\"}.icon-fontello-lock-open-filled:before{content:\"\\EAE7\"}.icon-fontello-pin-outline:before{content:\"\\EAE8\"}.icon-fontello-pin-1:before{content:\"\\EAE9\"}.icon-fontello-eye-outline:before{content:\"\\EAEA\"}.icon-fontello-eye-2:before{content:\"\\EAEB\"}.icon-fontello-tag-2:before{content:\"\\EAEC\"}.icon-fontello-tags-1:before{content:\"\\EAED\"}.icon-fontello-bookmark-2:before{content:\"\\EAEE\"}.icon-fontello-flag-2:before{content:\"\\EAEF\"}.icon-fontello-flag-filled:before{content:\"\\EAF0\"}.icon-fontello-thumbs-up-2:before{content:\"\\EAF1\"}.icon-fontello-thumbs-down-2:before{content:\"\\EAF2\"}.icon-fontello-download-outline:before{content:\"\\EAF3\"}.icon-fontello-download-2:before{content:\"\\EAF4\"}.icon-fontello-upload-outline:before{content:\"\\EAF5\"}.icon-fontello-upload-2:before{content:\"\\EAF6\"}.icon-fontello-upload-cloud-outline:before{content:\"\\EAF7\"}.icon-fontello-upload-cloud-2:before{content:\"\\EAF8\"}.icon-fontello-reply-outline:before{content:\"\\EAF9\"}.icon-fontello-reply-2:before{content:\"\\EAFA\"}.icon-fontello-forward-outline:before{content:\"\\EAFB\"}.icon-fontello-forward-2:before{content:\"\\EAFC\"}.icon-fontello-code-outline:before{content:\"\\EAFD\"}.icon-fontello-code-2:before{content:\"\\EAFE\"}.icon-fontello-export-outline:before{content:\"\\EAFF\"}.icon-fontello-export-2:before{content:\"\\EB00\"}.icon-fontello-pencil-2:before{content:\"\\EB01\"}.icon-fontello-pen:before{content:\"\\EB02\"}.icon-fontello-feather-1:before{content:\"\\EB03\"}.icon-fontello-edit-1:before{content:\"\\EB04\";position:relative;top:-1px;left:2px}.icon-fontello-print-2:before{content:\"\\EB05\"}.icon-fontello-comment-2:before{content:\"\\EB06\"}.icon-fontello-chat-2:before{content:\"\\EB07\"}.icon-fontello-chat-alt:before{content:\"\\EB08\"}.icon-fontello-bell-2:before{content:\"\\EB09\"}.icon-fontello-attention-2:before{content:\"\\EB0A\"}.icon-fontello-attention-filled:before{content:\"\\EB0B\"}.icon-fontello-warning-empty:before{content:\"\\EB0C\"}.icon-fontello-warning:before{content:\"\\EB0D\"}.icon-fontello-contacts:before{content:\"\\EB0E\"}.icon-fontello-vcard-1:before{content:\"\\EB0F\"}.icon-fontello-address-1:before{content:\"\\EB10\"}.icon-fontello-location-outline:before{content:\"\\EB11\"}.icon-fontello-location-2:before{content:\"\\EB12\"}.icon-fontello-map-1:before{content:\"\\EB13\"}.icon-fontello-direction-outline:before{content:\"\\EB14\"}.icon-fontello-direction-2:before{content:\"\\EB15\"}.icon-fontello-compass-2:before{content:\"\\EB16\"}.icon-fontello-trash-2:before{content:\"\\EB17\"}.icon-fontello-doc-2:before{content:\"\\EB18\"}.icon-fontello-doc-text-2:before{content:\"\\EB19\"}.icon-fontello-doc-add:before{content:\"\\EB1A\"}.icon-fontello-doc-remove:before{content:\"\\EB1B\"}.icon-fontello-news:before{content:\"\\EB1C\"}.icon-fontello-folder-2:before{content:\"\\EB1D\"}.icon-fontello-folder-add:before{content:\"\\EB1E\"}.icon-fontello-folder-delete:before{content:\"\\EB1F\"}.icon-fontello-archive-1:before{content:\"\\EB20\"}.icon-fontello-box-2:before{content:\"\\EB21\"}.icon-fontello-rss-outline:before{content:\"\\EB22\"}.icon-fontello-rss-2:before{content:\"\\EB23\"}.icon-fontello-phone-outline:before{content:\"\\EB24\"}.icon-fontello-phone-2:before{content:\"\\EB25\"}.icon-fontello-menu-outline:before{content:\"\\EB26\"}.icon-fontello-menu-2:before{content:\"\\EB27\"}.icon-fontello-cog-outline:before{content:\"\\EB28\"}.icon-fontello-cog-2:before{content:\"\\EB29\"}.icon-fontello-wrench-outline:before{content:\"\\EB2A\"}.icon-fontello-wrench-1:before{content:\"\\EB2B\"}.icon-fontello-basket-2:before{content:\"\\EB2C\"}.icon-fontello-calendar-outlilne:before{content:\"\\EB2D\"}.icon-fontello-calendar-2:before{content:\"\\EB2E\"}.icon-fontello-mic-outline:before{content:\"\\EB2F\"}.icon-fontello-mic-2:before{content:\"\\EB30\"}.icon-fontello-volume-off-1:before{content:\"\\EB31\"}.icon-fontello-volume-low:before{content:\"\\EB32\"}.icon-fontello-volume-middle:before{content:\"\\EB33\"}.icon-fontello-volume-high:before{content:\"\\EB34\"}.icon-fontello-headphones-1:before{content:\"\\EB35\"}.icon-fontello-clock-2:before{content:\"\\EB36\"}.icon-fontello-wristwatch:before{content:\"\\EB37\"}.icon-fontello-stopwatch:before{content:\"\\EB38\"}.icon-fontello-lightbulb-1:before{content:\"\\EB39\"}.icon-fontello-block-outline:before{content:\"\\EB3A\"}.icon-fontello-block-2:before{content:\"\\EB3B\"}.icon-fontello-resize-full-outline:before{content:\"\\EB3C\"}.icon-fontello-resize-full-2:before{content:\"\\EB3D\"}.icon-fontello-resize-normal-outline:before{content:\"\\EB3E\"}.icon-fontello-resize-normal:before{content:\"\\EB3F\"}.icon-fontello-move-outline:before{content:\"\\EB40\"}.icon-fontello-move-1:before{content:\"\\EB41\"}.icon-fontello-popup-1:before{content:\"\\EB42\"}.icon-fontello-zoom-in-outline:before{content:\"\\EB43\"}.icon-fontello-zoom-in-1:before{content:\"\\EB44\"}.icon-fontello-zoom-out-outline:before{content:\"\\EB45\"}.icon-fontello-zoom-out-1:before{content:\"\\EB46\"}.icon-fontello-popup-2:before{content:\"\\EB47\"}.icon-fontello-left-open-outline:before{content:\"\\EB48\"}.icon-fontello-left-open-2:before{content:\"\\EB49\"}.icon-fontello-right-open-outline:before{content:\"\\EB4A\"}.icon-fontello-right-open-2:before{content:\"\\EB4B\"}.icon-fontello-down-3:before{content:\"\\EB4C\"}.icon-fontello-left-3:before{content:\"\\EB4D\"}.icon-fontello-right-3:before{content:\"\\EB4E\"}.icon-fontello-up-3:before{content:\"\\EB4F\"}.icon-fontello-down-outline:before{content:\"\\EB50\"}.icon-fontello-left-outline:before{content:\"\\EB51\"}.icon-fontello-right-outline:before{content:\"\\EB52\"}.icon-fontello-up-outline:before{content:\"\\EB53\"}.icon-fontello-down-small:before{content:\"\\EB54\"}.icon-fontello-left-small:before{content:\"\\EB55\"}.icon-fontello-right-small:before{content:\"\\EB56\"}.icon-fontello-up-small:before{content:\"\\EB57\"}.icon-fontello-cw-outline:before{content:\"\\EB58\"}.icon-fontello-cw-2:before{content:\"\\EB59\"}.icon-fontello-arrows-cw-outline:before{content:\"\\EB5A\"}.icon-fontello-arrows-cw-1:before{content:\"\\EB5B\"}.icon-fontello-loop-outline:before{content:\"\\EB5C\"}.icon-fontello-loop-1:before{content:\"\\EB5D\"}.icon-fontello-loop-alt-outline:before{content:\"\\EB5E\"}.icon-fontello-loop-alt:before{content:\"\\EB5F\"}.icon-fontello-shuffle-2:before{content:\"\\EB60\"}.icon-fontello-play-outline:before{content:\"\\EB61\"}.icon-fontello-play-2:before{content:\"\\EB62\"}.icon-fontello-stop-outline:before{content:\"\\EB63\"}.icon-fontello-stop-2:before{content:\"\\EB64\"}.icon-fontello-pause-outline:before{content:\"\\EB65\"}.icon-fontello-pause-2:before{content:\"\\EB66\"}.icon-fontello-fast-fw-outline:before{content:\"\\EB67\"}.icon-fontello-fast-fw-1:before{content:\"\\EB68\"}.icon-fontello-rewind-outline:before{content:\"\\EB69\"}.icon-fontello-rewind:before{content:\"\\EB6A\"}.icon-fontello-record-outline:before{content:\"\\EB6B\"}.icon-fontello-record-1:before{content:\"\\EB6C\"}.icon-fontello-eject-outline:before{content:\"\\EB6D\"}.icon-fontello-eject-1:before{content:\"\\EB6E\"}.icon-fontello-eject-alt-outline:before{content:\"\\EB6F\"}.icon-fontello-eject-alt:before{content:\"\\EB70\"}.icon-fontello-bat1:before{content:\"\\EB71\"}.icon-fontello-bat2:before{content:\"\\EB72\"}.icon-fontello-bat3:before{content:\"\\EB73\"}.icon-fontello-bat4:before{content:\"\\EB74\"}.icon-fontello-bat-charge:before{content:\"\\EB75\"}.icon-fontello-plug:before{content:\"\\EB76\"}.icon-fontello-target-outline:before{content:\"\\EB77\"}.icon-fontello-target-2:before{content:\"\\EB78\"}.icon-fontello-wifi-outline:before{content:\"\\EB79\"}.icon-fontello-wifi:before{content:\"\\EB7A\"}.icon-fontello-desktop-1:before{content:\"\\EB7B\"}.icon-fontello-laptop-1:before{content:\"\\EB7C\"}.icon-fontello-tablet-1:before{content:\"\\EB7D\"}.icon-fontello-mobile-2:before{content:\"\\EB7E\"}.icon-fontello-contrast:before{content:\"\\EB7F\"}.icon-fontello-globe-outline:before{content:\"\\EB80\"}.icon-fontello-globe-2:before{content:\"\\EB81\"}.icon-fontello-globe-alt-outline:before{content:\"\\EB82\"}.icon-fontello-globe-alt:before{content:\"\\EB83\"}.icon-fontello-sun-1:before{content:\"\\EB84\"}.icon-fontello-sun-filled:before{content:\"\\EB85\"}.icon-fontello-cloud-2:before{content:\"\\EB86\"}.icon-fontello-flash-outline:before{content:\"\\EB87\"}.icon-fontello-flash-2:before{content:\"\\EB88\"}.icon-fontello-moon-2:before{content:\"\\EB89\"}.icon-fontello-waves-outline:before{content:\"\\EB8A\"}.icon-fontello-waves:before{content:\"\\EB8B\"}.icon-fontello-rain:before{content:\"\\EB8C\"}.icon-fontello-cloud-sun:before{content:\"\\EB8D\"}.icon-fontello-drizzle:before{content:\"\\EB8E\"}.icon-fontello-snow:before{content:\"\\EB8F\"}.icon-fontello-cloud-flash:before{content:\"\\EB90\"}.icon-fontello-cloud-wind:before{content:\"\\EB91\"}.icon-fontello-wind:before{content:\"\\EB92\"}.icon-fontello-plane-outline:before{content:\"\\EB93\"}.icon-fontello-plane:before{content:\"\\EB94\"}.icon-fontello-leaf-2:before{content:\"\\EB95\"}.icon-fontello-lifebuoy-1:before{content:\"\\EB96\"}.icon-fontello-briefcase-2:before{content:\"\\EB97\"}.icon-fontello-brush-1:before{content:\"\\EB98\"}.icon-fontello-pipette:before{content:\"\\EB99\"}.icon-fontello-power-outline:before{content:\"\\EB9A\"}.icon-fontello-power:before{content:\"\\EB9B\"}.icon-fontello-check-outline:before{content:\"\\EB9C\"}.icon-fontello-check-2:before{content:\"\\EB9D\"}.icon-fontello-gift-1:before{content:\"\\EB9E\"}.icon-fontello-temperatire:before{content:\"\\EB9F\"}.icon-fontello-chart-outline:before{content:\"\\EBA0\"}.icon-fontello-chart:before{content:\"\\EBA1\"}.icon-fontello-chart-alt-outline:before{content:\"\\EBA2\"}.icon-fontello-chart-alt:before{content:\"\\EBA3\"}.icon-fontello-chart-bar-outline:before{content:\"\\EBA4\"}.icon-fontello-chart-bar-2:before{content:\"\\EBA5\"}.icon-fontello-chart-pie-outline:before{content:\"\\EBA6\"}.icon-fontello-chart-pie-1:before{content:\"\\EBA7\"}.icon-fontello-ticket-2:before{content:\"\\EBA8\"}.icon-fontello-credit-card-2:before{content:\"\\EBA9\"}.icon-fontello-clipboard-1:before{content:\"\\EBAA\"}.icon-fontello-database-1:before{content:\"\\EBAB\"}.icon-fontello-key-outline:before{content:\"\\EBAC\"}.icon-fontello-key-2:before{content:\"\\EBAD\"}.icon-fontello-flow-split:before{content:\"\\EBAE\"}.icon-fontello-flow-merge:before{content:\"\\EBAF\"}.icon-fontello-flow-parallel-1:before{content:\"\\EBB0\"}.icon-fontello-flow-cross:before{content:\"\\EBB1\"}.icon-fontello-certificate-outline:before{content:\"\\EBB2\"}.icon-fontello-certificate-1:before{content:\"\\EBB3\"}.icon-fontello-scissors-outline:before{content:\"\\EBB4\"}.icon-fontello-scissors-1:before{content:\"\\EBB5\"}.icon-fontello-flask:before{content:\"\\EBB6\"}.icon-fontello-wine:before{content:\"\\EBB7\"}.icon-fontello-coffee-1:before{content:\"\\EBB8\"}.icon-fontello-beer-1:before{content:\"\\EBB9\"}.icon-fontello-anchor-outline:before{content:\"\\EBBA\"}.icon-fontello-anchor-1:before{content:\"\\EBBB\"}.icon-fontello-puzzle-outline:before{content:\"\\EBBC\"}.icon-fontello-puzzle-1:before{content:\"\\EBBD\"}.icon-fontello-tree:before{content:\"\\EBBE\"}.icon-fontello-calculator:before{content:\"\\EBBF\"}.icon-fontello-infinity-outline:before{content:\"\\EBC0\"}.icon-fontello-infinity-1:before{content:\"\\EBC1\"}.icon-fontello-pi-outline:before{content:\"\\EBC2\"}.icon-fontello-pi:before{content:\"\\EBC3\"}.icon-fontello-at:before{content:\"\\EBC4\"}.icon-fontello-at-circled:before{content:\"\\EBC5\"}.icon-fontello-looped-square-outline:before{content:\"\\EBC6\"}.icon-fontello-looped-square-interest:before{content:\"\\EBC7\"}.icon-fontello-sort-alphabet-outline:before{content:\"\\EBC8\"}.icon-fontello-sort-alphabet:before{content:\"\\EBC9\"}.icon-fontello-sort-numeric-outline:before{content:\"\\EBCA\"}.icon-fontello-sort-numeric:before{content:\"\\EBCB\"}.icon-fontello-dribbble-circled-1:before{content:\"\\EBCC\"}.icon-fontello-dribbble-2:before{content:\"\\EBCD\"}.icon-fontello-facebook-circled-1:before{content:\"\\EBCE\"}.icon-fontello-facebook-2:before{content:\"\\EBCF\"}.icon-fontello-flickr-circled-1:before{content:\"\\EBD0\"}.icon-fontello-flickr-2:before{content:\"\\EBD1\"}.icon-fontello-github-circled-2:before{content:\"\\EBD2\"}.icon-fontello-github-2:before{content:\"\\EBD3\"}.icon-fontello-lastfm-circled-1:before{content:\"\\EBD4\"}.icon-fontello-lastfm-1:before{content:\"\\EBD5\"}.icon-fontello-linkedin-circled-1:before{content:\"\\EBD6\"}.icon-fontello-linkedin-2:before{content:\"\\EBD7\"}.icon-fontello-pinterest-circled-2:before{content:\"\\EBD8\"}.icon-fontello-pinterest-1:before{content:\"\\EBD9\"}.icon-fontello-skype-outline:before{content:\"\\EBDA\"}.icon-fontello-skype-2:before{content:\"\\EBDB\"}.icon-fontello-tumbler-circled:before{content:\"\\EBDC\"}.icon-fontello-tumbler:before{content:\"\\EBDD\"}.icon-fontello-twitter-circled-1:before{content:\"\\EBDE\"}.icon-fontello-twitter-2:before{content:\"\\EBDF\"}.icon-fontello-vimeo-circled-1:before{content:\"\\EBE0\"}.icon-fontello-vimeo-1:before{content:\"\\EBE1\"}.icon-fontello-search-3:before{content:\"\\EBE2\"}.icon-fontello-mail-3:before{content:\"\\EBE3\"}.icon-fontello-heart-3:before{content:\"\\EBE4\"}.icon-fontello-heart-empty-2:before{content:\"\\EBE5\"}.icon-fontello-star-3:before{content:\"\\EBE6\"}.icon-fontello-user-3:before{content:\"\\EBE7\"}.icon-fontello-video-3:before{content:\"\\EBE8\"}.icon-fontello-picture-3:before{content:\"\\EBE9\"}.icon-fontello-camera-3:before{content:\"\\EBEA\"}.icon-fontello-ok-2:before{content:\"\\EBEB\"}.icon-fontello-ok-circle-1:before{content:\"\\EBEC\"}.icon-fontello-cancel-3:before{content:\"\\EBED\"}.icon-fontello-cancel-circle-1:before{content:\"\\EBEE\"}.icon-fontello-plus-3:before{content:\"\\EBEF\"}.icon-fontello-plus-circle-1:before{content:\"\\EBF0\"}.icon-fontello-minus-3:before{content:\"\\EBF1\"}.icon-fontello-minus-circle-1:before{content:\"\\EBF2\"}.icon-fontello-help-2:before{content:\"\\EBF3\"}.icon-fontello-info-3:before{content:\"\\EBF4\"}.icon-fontello-home-3:before{content:\"\\EBF5\"}.icon-fontello-link-3:before{content:\"\\EBF6\"}.icon-fontello-attach-3:before{content:\"\\EBF7\"}.icon-fontello-lock-3:before{content:\"\\EBF8\"}.icon-fontello-lock-empty:before{content:\"\\EBF9\"}.icon-fontello-lock-open-3:before{content:\"\\EBFA\"}.icon-fontello-lock-open-empty:before{content:\"\\EBFB\"}.icon-fontello-pin-2:before{content:\"\\EBFC\"}.icon-fontello-eye-3:before{content:\"\\EBFD\"}.icon-fontello-tag-3:before{content:\"\\EBFE\"}.icon-fontello-tag-empty:before{content:\"\\EBFF\"}.icon-fontello-download-3:before{content:\"\\EC00\"}.icon-fontello-upload-3:before{content:\"\\EC01\"}.icon-fontello-download-cloud-1:before{content:\"\\EC02\"}.icon-fontello-upload-cloud-3:before{content:\"\\EC03\"}.icon-fontello-quote-left-1:before{content:\"\\EC04\"}.icon-fontello-quote-right-1:before{content:\"\\EC05\"}.icon-fontello-quote-left-alt:before{content:\"\\EC06\"}.icon-fontello-quote-right-alt:before{content:\"\\EC07\"}.icon-fontello-pencil-3:before{content:\"\\EC08\"}.icon-fontello-pencil-neg:before{content:\"\\EC09\"}.icon-fontello-pencil-alt:before{content:\"\\EC0A\"}.icon-fontello-undo:before{content:\"\\EC0B\"}.icon-fontello-comment-3:before{content:\"\\EC0C\"}.icon-fontello-comment-inv:before{content:\"\\EC0D\"}.icon-fontello-comment-alt:before{content:\"\\EC0E\"}.icon-fontello-comment-inv-alt:before{content:\"\\EC0F\"}.icon-fontello-comment-alt2:before{content:\"\\EC10\"}.icon-fontello-comment-inv-alt2:before{content:\"\\EC11\"}.icon-fontello-chat-3:before{content:\"\\EC12\"}.icon-fontello-chat-inv:before{content:\"\\EC13\"}.icon-fontello-location-3:before{content:\"\\EC14\"}.icon-fontello-location-inv:before{content:\"\\EC15\"}.icon-fontello-location-alt:before{content:\"\\EC16\"}.icon-fontello-compass-3:before{content:\"\\EC17\"}.icon-fontello-trash-3:before{content:\"\\EC18\"}.icon-fontello-trash-empty:before{content:\"\\EC19\"}.icon-fontello-doc-3:before{content:\"\\EC1A\"}.icon-fontello-doc-inv-1:before{content:\"\\EC1B\"}.icon-fontello-doc-alt:before{content:\"\\EC1C\"}.icon-fontello-doc-inv-alt:before{content:\"\\EC1D\"}.icon-fontello-article:before{content:\"\\EC1E\"}.icon-fontello-article-alt:before{content:\"\\EC1F\"}.icon-fontello-book-open-1:before{content:\"\\EC20\"}.icon-fontello-folder-3:before{content:\"\\EC21\"}.icon-fontello-folder-empty-1:before{content:\"\\EC22\"}.icon-fontello-box-3:before{content:\"\\EC23\"}.icon-fontello-rss-3:before{content:\"\\EC24\"}.icon-fontello-rss-alt:before{content:\"\\EC25\"}.icon-fontello-cog-3:before{content:\"\\EC26\"}.icon-fontello-wrench-2:before{content:\"\\EC27\"}.icon-fontello-share-1:before{content:\"\\EC28\"}.icon-fontello-calendar-3:before{content:\"\\EC29\"}.icon-fontello-calendar-inv:before{content:\"\\EC2A\"}.icon-fontello-calendar-alt:before{content:\"\\EC2B\"}.icon-fontello-mic-3:before{content:\"\\EC2C\"}.icon-fontello-volume-off-2:before{content:\"\\EC2D\"}.icon-fontello-volume-up-1:before{content:\"\\EC2E\"}.icon-fontello-headphones-2:before{content:\"\\EC2F\"}.icon-fontello-clock-3:before{content:\"\\EC30\"}.icon-fontello-lamp-1:before{content:\"\\EC31\"}.icon-fontello-block-3:before{content:\"\\EC32\"}.icon-fontello-resize-full-3:before{content:\"\\EC33\"}.icon-fontello-resize-full-alt-1:before{content:\"\\EC34\"}.icon-fontello-resize-small-2:before{content:\"\\EC35\"}.icon-fontello-resize-small-alt:before{content:\"\\EC36\"}.icon-fontello-resize-vertical-1:before{content:\"\\EC37\"}.icon-fontello-resize-horizontal-1:before{content:\"\\EC38\"}.icon-fontello-move-2:before{content:\"\\EC39\"}.icon-fontello-popup-3:before{content:\"\\EC3A\"}.icon-fontello-down-4:before{content:\"\\EC3B\"}.icon-fontello-left-4:before{content:\"\\EC3C\"}.icon-fontello-right-4:before{content:\"\\EC3D\"}.icon-fontello-up-4:before{content:\"\\EC3E\"}.icon-fontello-down-circle:before{content:\"\\EC3F\"}.icon-fontello-left-circle:before{content:\"\\EC40\"}.icon-fontello-right-circle:before{content:\"\\EC41\"}.icon-fontello-up-circle:before{content:\"\\EC42\"}.icon-fontello-cw-3:before{content:\"\\EC43\"}.icon-fontello-loop-2:before{content:\"\\EC44\"}.icon-fontello-loop-alt-1:before{content:\"\\EC45\"}.icon-fontello-exchange-1:before{content:\"\\EC46\"}.icon-fontello-split:before{content:\"\\EC47\"}.icon-fontello-arrow-curved:before{content:\"\\EC48\"}.icon-fontello-play-3:before{content:\"\\EC49\"}.icon-fontello-play-circle2-1:before{content:\"\\EC4A\"}.icon-fontello-stop-3:before{content:\"\\EC4B\"}.icon-fontello-pause-3:before{content:\"\\EC4C\"}.icon-fontello-to-start-2:before{content:\"\\EC4D\"}.icon-fontello-to-end-2:before{content:\"\\EC4E\"}.icon-fontello-eject-2:before{content:\"\\EC4F\"}.icon-fontello-target-3:before{content:\"\\EC50\"}.icon-fontello-signal-2:before{content:\"\\EC51\"}.icon-fontello-award-1:before{content:\"\\EC52\"}.icon-fontello-award-empty:before{content:\"\\EC53\"}.icon-fontello-list-2:before{content:\"\\EC54\"}.icon-fontello-list-nested:before{content:\"\\EC55\"}.icon-fontello-bat-empty:before{content:\"\\EC56\"}.icon-fontello-bat-half:before{content:\"\\EC57\"}.icon-fontello-bat-full:before{content:\"\\EC58\"}.icon-fontello-bat-charge-1:before{content:\"\\EC59\"}.icon-fontello-mobile-3:before{content:\"\\EC5A\"}.icon-fontello-cd-1:before{content:\"\\EC5B\"}.icon-fontello-equalizer:before{content:\"\\EC5C\"}.icon-fontello-cursor:before{content:\"\\EC5D\"}.icon-fontello-aperture:before{content:\"\\EC5E\"}.icon-fontello-aperture-alt:before{content:\"\\EC5F\"}.icon-fontello-steering-wheel:before{content:\"\\EC60\"}.icon-fontello-book-2:before{content:\"\\EC61\"}.icon-fontello-book-alt:before{content:\"\\EC62\"}.icon-fontello-brush-2:before{content:\"\\EC63\"}.icon-fontello-brush-alt:before{content:\"\\EC64\"}.icon-fontello-eyedropper:before{content:\"\\EC65\"}.icon-fontello-layers:before{content:\"\\EC66\"}.icon-fontello-layers-alt:before{content:\"\\EC67\"}.icon-fontello-sun-2:before{content:\"\\EC68\"}.icon-fontello-sun-inv:before{content:\"\\EC69\"}.icon-fontello-cloud-3:before{content:\"\\EC6A\"}.icon-fontello-rain-1:before{content:\"\\EC6B\"}.icon-fontello-flash-3:before{content:\"\\EC6C\"}.icon-fontello-moon-3:before{content:\"\\EC6D\"}.icon-fontello-moon-inv:before{content:\"\\EC6E\"}.icon-fontello-umbrella-1:before{content:\"\\EC6F\"}.icon-fontello-chart-bar-3:before{content:\"\\EC70\"}.icon-fontello-chart-pie-2:before{content:\"\\EC71\"}.icon-fontello-chart-pie-alt:before{content:\"\\EC72\"}.icon-fontello-key-3:before{content:\"\\EC73\"}.icon-fontello-key-inv:before{content:\"\\EC74\"}.icon-fontello-hash:before{content:\"\\EC75\"}.icon-fontello-at-1:before{content:\"\\EC76\"}.icon-fontello-pilcrow:before{content:\"\\EC77\"}.icon-fontello-dial:before{content:\"\\EC78\"}.icon-fontello-search-4:before{content:\"\\EC79\"}.icon-fontello-mail-4:before{content:\"\\EC7A\"}.icon-fontello-heart-4:before{content:\"\\EC7B\"}.icon-fontello-star-4:before{content:\"\\EC7C\"}.icon-fontello-user-4:before{content:\"\\EC7D\"}.icon-fontello-user-woman:before{content:\"\\EC7E\"}.icon-fontello-user-pair:before{content:\"\\EC7F\"}.icon-fontello-video-alt:before{content:\"\\EC80\"}.icon-fontello-videocam-2:before{content:\"\\EC81\"}.icon-fontello-videocam-alt:before{content:\"\\EC82\"}.icon-fontello-camera-4:before{content:\"\\EC83\"}.icon-fontello-th-2:before{content:\"\\EC84\"}.icon-fontello-th-list-2:before{content:\"\\EC85\"}.icon-fontello-ok-3:before{content:\"\\EC86\"}.icon-fontello-cancel-4:before{content:\"\\EC87\"}.icon-fontello-cancel-circle-2:before{content:\"\\EC88\"}.icon-fontello-plus-4:before{content:\"\\EC89\"}.icon-fontello-home-4:before{content:\"\\EC8A\"}.icon-fontello-lock-4:before{content:\"\\EC8B\"}.icon-fontello-lock-open-4:before{content:\"\\EC8C\"}.icon-fontello-eye-4:before{content:\"\\EC8D\"}.icon-fontello-tag-4:before{content:\"\\EC8E\"}.icon-fontello-thumbs-up-3:before{content:\"\\EC8F\"}.icon-fontello-thumbs-down-3:before{content:\"\\EC90\"}.icon-fontello-download-4:before{content:\"\\EC91\"}.icon-fontello-export-3:before{content:\"\\EC92\"}.icon-fontello-pencil-4:before{content:\"\\EC93\"}.icon-fontello-pencil-alt-1:before{content:\"\\EC94\"}.icon-fontello-edit-2:before{content:\"\\EC95\"}.icon-fontello-chat-4:before{content:\"\\EC96\"}.icon-fontello-print-3:before{content:\"\\EC97\"}.icon-fontello-bell-3:before{content:\"\\EC98\"}.icon-fontello-attention-3:before{content:\"\\EC99\"}.icon-fontello-info-4:before{content:\"\\EC9A\"}.icon-fontello-question:before{content:\"\\EC9B\"}.icon-fontello-location-4:before{content:\"\\EC9C\"}.icon-fontello-trash-4:before{content:\"\\EC9D\"}.icon-fontello-doc-4:before{content:\"\\EC9E\"}.icon-fontello-article-1:before{content:\"\\EC9F\"}.icon-fontello-article-alt-1:before{content:\"\\ECA0\"}.icon-fontello-rss-4:before{content:\"\\ECA1\"}.icon-fontello-wrench-3:before{content:\"\\ECA2\"}.icon-fontello-basket-3:before{content:\"\\ECA3\"}.icon-fontello-basket-alt:before{content:\"\\ECA4\"}.icon-fontello-calendar-4:before{content:\"\\ECA5\"}.icon-fontello-calendar-alt-1:before{content:\"\\ECA6\"}.icon-fontello-volume-off-3:before{content:\"\\ECA7\"}.icon-fontello-volume-down-1:before{content:\"\\ECA8\"}.icon-fontello-volume-up-2:before{content:\"\\ECA9\"}.icon-fontello-bullhorn:before{content:\"\\ECAA\"}.icon-fontello-clock-4:before{content:\"\\ECAB\"}.icon-fontello-clock-alt:before{content:\"\\ECAC\"}.icon-fontello-stop-4:before{content:\"\\ECAD\"}.icon-fontello-resize-full-4:before{content:\"\\ECAE\"}.icon-fontello-resize-small-3:before{content:\"\\ECAF\"}.icon-fontello-zoom-in-2:before{content:\"\\ECB0\"}.icon-fontello-zoom-out-2:before{content:\"\\ECB1\"}.icon-fontello-popup-4:before{content:\"\\ECB2\"}.icon-fontello-down-dir-2:before{content:\"\\ECB3\"}.icon-fontello-left-dir-2:before{content:\"\\ECB4\"}.icon-fontello-right-dir-2:before{content:\"\\ECB5\"}.icon-fontello-up-dir-2:before{content:\"\\ECB6\"}.icon-fontello-down-5:before{content:\"\\ECB7\"}.icon-fontello-up-5:before{content:\"\\ECB8\"}.icon-fontello-cw-4:before{content:\"\\ECB9\"}.icon-fontello-signal-3:before{content:\"\\ECBA\"}.icon-fontello-award-2:before{content:\"\\ECBB\"}.icon-fontello-mobile-4:before{content:\"\\ECBC\"}.icon-fontello-mobile-alt:before{content:\"\\ECBD\"}.icon-fontello-tablet-2:before{content:\"\\ECBE\"}.icon-fontello-ipod:before{content:\"\\ECBF\"}.icon-fontello-cd-2:before{content:\"\\ECC0\"}.icon-fontello-grid:before{content:\"\\ECC1\"}.icon-fontello-book-3:before{content:\"\\ECC2\"}.icon-fontello-easel:before{content:\"\\ECC3\"}.icon-fontello-globe-3:before{content:\"\\ECC4\"}.icon-fontello-chart-1:before{content:\"\\ECC5\"}.icon-fontello-chart-bar-4:before{content:\"\\ECC6\"}.icon-fontello-chart-pie-3:before{content:\"\\ECC7\"}.icon-fontello-dollar-1:before{content:\"\\ECC8\"}.icon-fontello-at-2:before{content:\"\\ECC9\"}.icon-fontello-colon:before{content:\"\\ECCA\"}.icon-fontello-semicolon:before{content:\"\\ECCB\"}.icon-fontello-squares:before{content:\"\\ECCC\"}.icon-fontello-money-1:before{content:\"\\ECCD\"}.icon-fontello-facebook-3:before{content:\"\\ECCE\"}.icon-fontello-facebook-rect:before{content:\"\\ECCF\"}.icon-fontello-twitter-3:before{content:\"\\ECD0\"}.icon-fontello-twitter-bird:before{content:\"\\ECD1\"}.icon-fontello-twitter-rect:before{content:\"\\ECD2\"}.icon-fontello-youtube-1:before{content:\"\\ECD3\"}.icon-fontello-windy-rain-inv:before{content:\"\\ECD4\"}.icon-fontello-snow-inv:before{content:\"\\ECD5\"}.icon-fontello-snow-heavy-inv:before{content:\"\\ECD6\"}.icon-fontello-hail-inv:before{content:\"\\ECD7\"}.icon-fontello-clouds-inv:before{content:\"\\ECD8\"}.icon-fontello-clouds-flash-inv:before{content:\"\\ECD9\"}.icon-fontello-temperature:before{content:\"\\ECDA\"}.icon-fontello-compass-4:before{content:\"\\ECDB\"}.icon-fontello-na:before{content:\"\\ECDC\"}.icon-fontello-celcius:before{content:\"\\ECDD\"}.icon-fontello-fahrenheit:before{content:\"\\ECDE\"}.icon-fontello-clouds-flash-alt:before{content:\"\\ECDF\"}.icon-fontello-sun-inv-1:before{content:\"\\ECE0\"}.icon-fontello-moon-inv-1:before{content:\"\\ECE1\"}.icon-fontello-cloud-sun-inv:before{content:\"\\ECE2\"}.icon-fontello-cloud-moon-inv:before{content:\"\\ECE3\"}.icon-fontello-cloud-inv:before{content:\"\\ECE4\"}.icon-fontello-cloud-flash-inv:before{content:\"\\ECE5\"}.icon-fontello-drizzle-inv:before{content:\"\\ECE6\"}.icon-fontello-rain-inv:before{content:\"\\ECE7\"}.icon-fontello-windy-inv:before{content:\"\\ECE8\"}.icon-fontello-sunrise:before{content:\"\\ECE9\"}.icon-fontello-sun-3:before{content:\"\\ECEA\"}.icon-fontello-moon-4:before{content:\"\\ECEB\"}.icon-fontello-eclipse:before{content:\"\\ECEC\"}.icon-fontello-mist:before{content:\"\\ECED\"}.icon-fontello-wind-1:before{content:\"\\ECEE\"}.icon-fontello-snowflake:before{content:\"\\ECEF\"}.icon-fontello-cloud-sun-1:before{content:\"\\ECF0\"}.icon-fontello-cloud-moon:before{content:\"\\ECF1\"}.icon-fontello-fog-sun:before{content:\"\\ECF2\"}.icon-fontello-fog-moon:before{content:\"\\ECF3\"}.icon-fontello-fog-cloud:before{content:\"\\ECF4\"}.icon-fontello-fog:before{content:\"\\ECF5\"}.icon-fontello-cloud-4:before{content:\"\\ECF6\"}.icon-fontello-cloud-flash-1:before{content:\"\\ECF7\"}.icon-fontello-cloud-flash-alt:before{content:\"\\ECF8\"}.icon-fontello-drizzle-1:before{content:\"\\ECF9\"}.icon-fontello-rain-2:before{content:\"\\ECFA\"}.icon-fontello-windy:before{content:\"\\ECFB\"}.icon-fontello-windy-rain:before{content:\"\\ECFC\"}.icon-fontello-snow-1:before{content:\"\\ECFD\"}.icon-fontello-snow-alt:before{content:\"\\ECFE\"}.icon-fontello-snow-heavy:before{content:\"\\ECFF\"}.icon-fontello-hail:before{content:\"\\ED00\"}.icon-fontello-clouds:before{content:\"\\ED01\"}.icon-fontello-clouds-flash:before{content:\"\\ED02\"}.icon-fontello-search-5:before{content:\"\\ED03\"}.icon-fontello-mail-5:before{content:\"\\ED04\"}.icon-fontello-heart-5:before{content:\"\\ED05\"}.icon-fontello-heart-broken:before{content:\"\\ED06\"}.icon-fontello-star-5:before{content:\"\\ED07\"}.icon-fontello-star-empty-2:before{content:\"\\ED08\"}.icon-fontello-star-half-1:before{content:\"\\ED09\"}.icon-fontello-star-half_empty:before{content:\"\\ED0A\"}.icon-fontello-user-5:before{content:\"\\ED0B\"}.icon-fontello-user-male:before{content:\"\\ED0C\"}.icon-fontello-user-female:before{content:\"\\ED0D\"}.icon-fontello-users-3:before{content:\"\\ED0E\"}.icon-fontello-movie:before{content:\"\\ED0F\"}.icon-fontello-videocam-3:before{content:\"\\ED10\"}.icon-fontello-isight:before{content:\"\\ED11\"}.icon-fontello-camera-5:before{content:\"\\ED12\"}.icon-fontello-menu-3:before{content:\"\\ED13\"}.icon-fontello-th-thumb:before{content:\"\\ED14\"}.icon-fontello-th-thumb-empty:before{content:\"\\ED15\"}.icon-fontello-th-list-3:before{content:\"\\ED16\"}.icon-fontello-ok-4:before{content:\"\\ED17\"}.icon-fontello-ok-circled:before{content:\"\\ED18\"}.icon-fontello-cancel-5:before{content:\"\\ED19\"}.icon-fontello-cancel-circled-2:before{content:\"\\ED1A\"}.icon-fontello-plus-5:before{content:\"\\ED1B\"}.icon-fontello-help-circled-1:before{content:\"\\ED1C\"}.icon-fontello-help-circled-alt:before{content:\"\\ED1D\"}.icon-fontello-info-circled-1:before{content:\"\\ED1E\"}.icon-fontello-info-circled-alt:before{content:\"\\ED1F\"}.icon-fontello-home-5:before{content:\"\\ED20\"}.icon-fontello-link-4:before{content:\"\\ED21\"}.icon-fontello-attach-4:before{content:\"\\ED22\"}.icon-fontello-lock-5:before{content:\"\\ED23\"}.icon-fontello-lock-alt:before{content:\"\\ED24\"}.icon-fontello-lock-open-5:before{content:\"\\ED25\"}.icon-fontello-lock-open-alt-1:before{content:\"\\ED26\"}.icon-fontello-eye-5:before{content:\"\\ED27\"}.icon-fontello-download-5:before{content:\"\\ED28\"}.icon-fontello-upload-4:before{content:\"\\ED29\"}.icon-fontello-download-cloud-2:before{content:\"\\ED2A\"}.icon-fontello-upload-cloud-4:before{content:\"\\ED2B\"}.icon-fontello-reply-3:before{content:\"\\ED2C\"}.icon-fontello-pencil-5:before{content:\"\\ED2D\"}.icon-fontello-export-4:before{content:\"\\ED2E\"}.icon-fontello-print-4:before{content:\"\\ED2F\"}.icon-fontello-retweet-2:before{content:\"\\ED30\"}.icon-fontello-comment-4:before{content:\"\\ED31\"}.icon-fontello-chat-5:before{content:\"\\ED32\"}.icon-fontello-bell-4:before{content:\"\\ED33\"}.icon-fontello-attention-4:before{content:\"\\ED34\"}.icon-fontello-attention-alt-1:before{content:\"\\ED35\"}.icon-fontello-location-5:before{content:\"\\ED36\"}.icon-fontello-trash-5:before{content:\"\\ED37\"}.icon-fontello-doc-5:before{content:\"\\ED38\"}.icon-fontello-newspaper-1:before{content:\"\\ED39\"}.icon-fontello-folder-4:before{content:\"\\ED3A\"}.icon-fontello-folder-open-1:before{content:\"\\ED3B\"}.icon-fontello-folder-empty-2:before{content:\"\\ED3C\"}.icon-fontello-folder-open-empty-1:before{content:\"\\ED3D\"}.icon-fontello-cog-4:before{content:\"\\ED3E\"}.icon-fontello-calendar-5:before{content:\"\\ED3F\"}.icon-fontello-login-2:before{content:\"\\ED40\"}.icon-fontello-logout-2:before{content:\"\\ED41\"}.icon-fontello-mic-4:before{content:\"\\ED42\"}.icon-fontello-mic-off:before{content:\"\\ED43\"}.icon-fontello-clock-5:before{content:\"\\ED44\"}.icon-fontello-stopwatch-1:before{content:\"\\ED45\"}.icon-fontello-hourglass-1:before{content:\"\\ED46\"}.icon-fontello-zoom-in-3:before{content:\"\\ED47\"}.icon-fontello-zoom-out-3:before{content:\"\\ED48\"}.icon-fontello-down-open-2:before{content:\"\\ED49\"}.icon-fontello-left-open-3:before{content:\"\\ED4A\"}.icon-fontello-right-open-3:before{content:\"\\ED4B\"}.icon-fontello-up-open-2:before{content:\"\\ED4C\"}.icon-fontello-down-6:before{content:\"\\ED4D\"}.icon-fontello-left-5:before{content:\"\\ED4E\"}.icon-fontello-right-5:before{content:\"\\ED4F\"}.icon-fontello-up-6:before{content:\"\\ED50\"}.icon-fontello-down-bold-1:before{content:\"\\ED51\"}.icon-fontello-left-bold-1:before{content:\"\\ED52\"}.icon-fontello-right-bold-1:before{content:\"\\ED53\"}.icon-fontello-up-bold-1:before{content:\"\\ED54\"}.icon-fontello-down-fat:before{content:\"\\ED55\"}.icon-fontello-left-fat:before{content:\"\\ED56\"}.icon-fontello-right-fat:before{content:\"\\ED57\"}.icon-fontello-up-fat:before{content:\"\\ED58\"}.icon-fontello-ccw-2:before{content:\"\\ED59\"}.icon-fontello-shuffle-3:before{content:\"\\ED5A\"}.icon-fontello-play-4:before{content:\"\\ED5B\"}.icon-fontello-pause-4:before{content:\"\\ED5C\"}.icon-fontello-stop-5:before{content:\"\\ED5D\"}.icon-fontello-to-end-3:before{content:\"\\ED5E\"}.icon-fontello-to-start-3:before{content:\"\\ED5F\"}.icon-fontello-fast-forward-1:before{content:\"\\ED60\"}.icon-fontello-fast-backward-1:before{content:\"\\ED61\"}.icon-fontello-trophy-1:before{content:\"\\ED62\"}.icon-fontello-monitor-1:before{content:\"\\ED63\"}.icon-fontello-tablet-3:before{content:\"\\ED64\"}.icon-fontello-mobile-5:before{content:\"\\ED65\"}.icon-fontello-data-science:before{content:\"\\ED66\"}.icon-fontello-data-science-inv:before{content:\"\\ED67\"}.icon-fontello-inbox-2:before{content:\"\\ED68\"}.icon-fontello-globe-4:before{content:\"\\ED69\"}.icon-fontello-globe-inv:before{content:\"\\ED6A\"}.icon-fontello-flash-4:before{content:\"\\ED6B\"}.icon-fontello-cloud-5:before{content:\"\\ED6C\"}.icon-fontello-coverflow:before{content:\"\\ED6D\"}.icon-fontello-coverflow-empty:before{content:\"\\ED6E\"}.icon-fontello-math:before{content:\"\\ED6F\"}.icon-fontello-math-circled:before{content:\"\\ED70\"}.icon-fontello-math-circled-empty:before{content:\"\\ED71\"}.icon-fontello-paper-plane-1:before{content:\"\\ED72\"}.icon-fontello-paper-plane-alt:before{content:\"\\ED73\"}.icon-fontello-paper-plane-alt2:before{content:\"\\ED74\"}.icon-fontello-fontsize:before{content:\"\\ED75\"}.icon-fontello-color-adjust:before{content:\"\\ED76\"}.icon-fontello-fire-1:before{content:\"\\ED77\"}.icon-fontello-chart-bar-5:before{content:\"\\ED78\"}.icon-fontello-hdd-1:before{content:\"\\ED79\"}.icon-fontello-connected-object:before{content:\"\\ED7A\"}.icon-fontello-ruler:before{content:\"\\ED7B\"}.icon-fontello-vector:before{content:\"\\ED7C\"}.icon-fontello-vector-pencil:before{content:\"\\ED7D\"}.icon-fontello-at-3:before{content:\"\\ED7E\"}.icon-fontello-hash-1:before{content:\"\\ED7F\"}.icon-fontello-female-1:before{content:\"\\ED80\"}.icon-fontello-male-1:before{content:\"\\ED81\"}.icon-fontello-spread:before{content:\"\\ED82\"}.icon-fontello-king:before{content:\"\\ED83\"}.icon-fontello-anchor-2:before{content:\"\\ED84\"}.icon-fontello-joystick:before{content:\"\\ED85\"}.icon-fontello-spinner1:before{content:\"\\ED86\"}.icon-fontello-spinner2:before{content:\"\\ED87\"}.icon-fontello-github-3:before{content:\"\\ED88\"}.icon-fontello-github-circled-3:before{content:\"\\ED89\"}.icon-fontello-github-circled-alt:before{content:\"\\ED8A\"}.icon-fontello-github-circled-alt2:before{content:\"\\ED8B\"}.icon-fontello-twitter-4:before{content:\"\\ED8C\"}.icon-fontello-twitter-circled-2:before{content:\"\\ED8D\"}.icon-fontello-facebook-4:before{content:\"\\ED8E\"}.icon-fontello-facebook-circled-2:before{content:\"\\ED8F\"}.icon-fontello-gplus-2:before{content:\"\\ED90\"}.icon-fontello-gplus-circled-1:before{content:\"\\ED91\"}.icon-fontello-linkedin-3:before{content:\"\\ED92\"}.icon-fontello-linkedin-circled-2:before{content:\"\\ED93\"}.icon-fontello-dribbble-3:before{content:\"\\ED94\"}.icon-fontello-dribbble-circled-2:before{content:\"\\ED95\"}.icon-fontello-instagram-1:before{content:\"\\ED96\"}.icon-fontello-instagram-circled:before{content:\"\\ED97\"}.icon-fontello-soundcloud-1:before{content:\"\\ED98\"}.icon-fontello-soundcloud-circled:before{content:\"\\ED99\"}.icon-fontello-mfg-logo:before{content:\"\\ED9A\"}.icon-fontello-mfg-logo-circled:before{content:\"\\ED9B\"}.icon-fontello-aboveground-rail:before{content:\"\\ED9C\"}.icon-fontello-airfield:before{content:\"\\ED9D\"}.icon-fontello-airport:before{content:\"\\ED9E\"}.icon-fontello-art-gallery:before{content:\"\\ED9F\"}.icon-fontello-bar:before{content:\"\\EDA0\"}.icon-fontello-baseball:before{content:\"\\EDA1\"}.icon-fontello-basketball:before{content:\"\\EDA2\"}.icon-fontello-beer-2:before{content:\"\\EDA3\"}.icon-fontello-belowground-rail:before{content:\"\\EDA4\"}.icon-fontello-bicycle:before{content:\"\\EDA5\"}.icon-fontello-bus:before{content:\"\\EDA6\"}.icon-fontello-cafe:before{content:\"\\EDA7\"}.icon-fontello-campsite:before{content:\"\\EDA8\"}.icon-fontello-cemetery:before{content:\"\\EDA9\"}.icon-fontello-cinema:before{content:\"\\EDAA\"}.icon-fontello-college:before{content:\"\\EDAB\"}.icon-fontello-commerical-building:before{content:\"\\EDAC\"}.icon-fontello-credit-card-3:before{content:\"\\EDAD\"}.icon-fontello-cricket:before{content:\"\\EDAE\"}.icon-fontello-embassy:before{content:\"\\EDAF\"}.icon-fontello-fast-food:before{content:\"\\EDB0\"}.icon-fontello-ferry:before{content:\"\\EDB1\"}.icon-fontello-fire-station:before{content:\"\\EDB2\"}.icon-fontello-football:before{content:\"\\EDB3\"}.icon-fontello-fuel:before{content:\"\\EDB4\"}.icon-fontello-garden:before{content:\"\\EDB5\"}.icon-fontello-giraffe:before{content:\"\\EDB6\"}.icon-fontello-golf:before{content:\"\\EDB7\"}.icon-fontello-grocery-store:before{content:\"\\EDB8\"}.icon-fontello-harbor:before{content:\"\\EDB9\"}.icon-fontello-heliport:before{content:\"\\EDBA\"}.icon-fontello-hospital-1:before{content:\"\\EDBB\"}.icon-fontello-industrial-building:before{content:\"\\EDBC\"}.icon-fontello-library:before{content:\"\\EDBD\"}.icon-fontello-lodging:before{content:\"\\EDBE\"}.icon-fontello-london-underground:before{content:\"\\EDBF\"}.icon-fontello-minefield:before{content:\"\\EDC0\"}.icon-fontello-monument:before{content:\"\\EDC1\"}.icon-fontello-museum:before{content:\"\\EDC2\"}.icon-fontello-pharmacy:before{content:\"\\EDC3\"}.icon-fontello-pitch:before{content:\"\\EDC4\"}.icon-fontello-police:before{content:\"\\EDC5\"}.icon-fontello-post:before{content:\"\\EDC6\"}.icon-fontello-prison:before{content:\"\\EDC7\"}.icon-fontello-rail:before{content:\"\\EDC8\"}.icon-fontello-religious-christian:before{content:\"\\EDC9\"}.icon-fontello-religious-islam:before{content:\"\\EDCA\"}.icon-fontello-religious-jewish:before{content:\"\\EDCB\"}.icon-fontello-restaurant:before{content:\"\\EDCC\"}.icon-fontello-roadblock:before{content:\"\\EDCD\"}.icon-fontello-school:before{content:\"\\EDCE\"}.icon-fontello-shop:before{content:\"\\EDCF\"}.icon-fontello-skiing:before{content:\"\\EDD0\"}.icon-fontello-soccer:before{content:\"\\EDD1\"}.icon-fontello-swimming:before{content:\"\\EDD2\"}.icon-fontello-tennis:before{content:\"\\EDD3\"}.icon-fontello-theatre:before{content:\"\\EDD4\"}.icon-fontello-toilet:before{content:\"\\EDD5\"}.icon-fontello-town-hall:before{content:\"\\EDD6\"}.icon-fontello-trash-6:before{content:\"\\EDD7\"}.icon-fontello-tree-1:before{content:\"\\EDD8\"}.icon-fontello-tree-2:before{content:\"\\EDD9\"}.icon-fontello-warehouse:before{content:\"\\EDDA\"}.icon-fontello-duckduckgo:before{content:\"\\EDDB\"}.icon-fontello-aim:before{content:\"\\EDDC\"}.icon-fontello-delicious:before{content:\"\\EDDD\"}.icon-fontello-paypal-1:before{content:\"\\EDDE\"}.icon-fontello-flattr-1:before{content:\"\\EDDF\"}.icon-fontello-android-1:before{content:\"\\EDE0\"}.icon-fontello-eventful:before{content:\"\\EDE1\"}.icon-fontello-smashmag:before{content:\"\\EDE2\"}.icon-fontello-gplus-3:before{content:\"\\EDE3\"}.icon-fontello-wikipedia:before{content:\"\\EDE4\"}.icon-fontello-lanyrd:before{content:\"\\EDE5\"}.icon-fontello-calendar-6:before{content:\"\\EDE6\"}.icon-fontello-stumbleupon-1:before{content:\"\\EDE7\"}.icon-fontello-fivehundredpx:before{content:\"\\EDE8\"}.icon-fontello-pinterest-2:before{content:\"\\EDE9\"}.icon-fontello-bitcoin-1:before{content:\"\\EDEA\"}.icon-fontello-w3c:before{content:\"\\EDEB\"}.icon-fontello-foursquare-1:before{content:\"\\EDEC\"}.icon-fontello-html5-1:before{content:\"\\EDED\"}.icon-fontello-ie-1:before{content:\"\\EDEE\"}.icon-fontello-call:before{content:\"\\EDEF\"}.icon-fontello-grooveshark:before{content:\"\\EDF0\"}.icon-fontello-ninetyninedesigns:before{content:\"\\EDF1\"}.icon-fontello-forrst:before{content:\"\\EDF2\"}.icon-fontello-digg:before{content:\"\\EDF3\"}.icon-fontello-spotify-1:before{content:\"\\EDF4\"}.icon-fontello-reddit:before{content:\"\\EDF5\"}.icon-fontello-guest:before{content:\"\\EDF6\"}.icon-fontello-gowalla:before{content:\"\\EDF7\"}.icon-fontello-appstore:before{content:\"\\EDF8\"}.icon-fontello-blogger:before{content:\"\\EDF9\"}.icon-fontello-cc-1:before{content:\"\\EDFA\"}.icon-fontello-dribbble-4:before{content:\"\\EDFB\"}.icon-fontello-evernote-1:before{content:\"\\EDFC\"}.icon-fontello-flickr-3:before{content:\"\\EDFD\"}.icon-fontello-google:before{content:\"\\EDFE\"}.icon-fontello-viadeo:before{content:\"\\EDFF\"}.icon-fontello-instapaper:before{content:\"\\EE00\"}.icon-fontello-weibo-1:before{content:\"\\EE01\"}.icon-fontello-klout:before{content:\"\\EE02\"}.icon-fontello-linkedin-4:before{content:\"\\EE03\"}.icon-fontello-meetup:before{content:\"\\EE04\"}.icon-fontello-vk:before{content:\"\\EE05\"}.icon-fontello-plancast:before{content:\"\\EE06\"}.icon-fontello-disqus:before{content:\"\\EE07\"}.icon-fontello-rss-5:before{content:\"\\EE08\"}.icon-fontello-skype-3:before{content:\"\\EE09\"}.icon-fontello-twitter-5:before{content:\"\\EE0A\"}.icon-fontello-youtube-2:before{content:\"\\EE0B\"}.icon-fontello-vimeo-2:before{content:\"\\EE0C\"}.icon-fontello-windows-1:before{content:\"\\EE0D\"}.icon-fontello-xing-1:before{content:\"\\EE0E\"}.icon-fontello-yahoo:before{content:\"\\EE0F\"}.icon-fontello-chrome-1:before{content:\"\\EE10\"}.icon-fontello-email:before{content:\"\\EE11\"}.icon-fontello-macstore:before{content:\"\\EE12\"}.icon-fontello-myspace:before{content:\"\\EE13\"}.icon-fontello-podcast:before{content:\"\\EE14\"}.icon-fontello-amazon:before{content:\"\\EE15\"}.icon-fontello-steam:before{content:\"\\EE16\"}.icon-fontello-cloudapp:before{content:\"\\EE17\"}.icon-fontello-dropbox-2:before{content:\"\\EE18\"}.icon-fontello-ebay:before{content:\"\\EE19\"}.icon-fontello-facebook-5:before{content:\"\\EE1A\"}.icon-fontello-github-4:before{content:\"\\EE1B\"}.icon-fontello-github-circled-4:before{content:\"\\EE1C\"}.icon-fontello-googleplay:before{content:\"\\EE1D\"}.icon-fontello-itunes:before{content:\"\\EE1E\"}.icon-fontello-plurk:before{content:\"\\EE1F\"}.icon-fontello-songkick:before{content:\"\\EE20\"}.icon-fontello-lastfm-2:before{content:\"\\EE21\"}.icon-fontello-gmail:before{content:\"\\EE22\"}.icon-fontello-pinboard:before{content:\"\\EE23\"}.icon-fontello-openid:before{content:\"\\EE24\"}.icon-fontello-quora:before{content:\"\\EE25\"}.icon-fontello-soundcloud-2:before{content:\"\\EE26\"}.icon-fontello-tumblr-2:before{content:\"\\EE27\"}.icon-fontello-eventasaurus:before{content:\"\\EE28\"}.icon-fontello-wordpress:before{content:\"\\EE29\"}.icon-fontello-yelp:before{content:\"\\EE2A\"}.icon-fontello-intensedebate:before{content:\"\\EE2B\"}.icon-fontello-eventbrite:before{content:\"\\EE2C\"}.icon-fontello-scribd:before{content:\"\\EE2D\"}.icon-fontello-posterous:before{content:\"\\EE2E\"}.icon-fontello-stripe:before{content:\"\\EE2F\"}.icon-fontello-opentable:before{content:\"\\EE30\"}.icon-fontello-cart:before{content:\"\\EE31\"}.icon-fontello-print-5:before{content:\"\\EE32\"}.icon-fontello-angellist:before{content:\"\\EE33\"}.icon-fontello-instagram-2:before{content:\"\\EE34\"}.icon-fontello-dwolla:before{content:\"\\EE35\"}.icon-fontello-appnet:before{content:\"\\EE36\"}.icon-fontello-statusnet:before{content:\"\\EE37\"}.icon-fontello-acrobat:before{content:\"\\EE38\"}.icon-fontello-drupal:before{content:\"\\EE39\"}.icon-fontello-buffer:before{content:\"\\EE3A\"}.icon-fontello-pocket:before{content:\"\\EE3B\"}.icon-fontello-bitbucket-1:before{content:\"\\EE3C\"}.icon-fontello-lego:before{content:\"\\EE3D\"}.icon-fontello-login-3:before{content:\"\\EE3E\"}.icon-fontello-stackoverflow-1:before{content:\"\\EE3F\"}.icon-fontello-hackernews:before{content:\"\\EE40\"}.icon-fontello-lkdto:before{content:\"\\EE41\"}.icon-fontello-facebook-6:before{content:\"\\EE42\"}.icon-fontello-facebook-rect-1:before{content:\"\\EE43\"}.icon-fontello-twitter-6:before{content:\"\\EE44\"}.icon-fontello-twitter-bird-1:before{content:\"\\EE45\"}.icon-fontello-vimeo-3:before{content:\"\\EE46\"}.icon-fontello-vimeo-rect:before{content:\"\\EE47\"}.icon-fontello-tumblr-3:before{content:\"\\EE48\"}.icon-fontello-tumblr-rect:before{content:\"\\EE49\"}.icon-fontello-googleplus-rect:before{content:\"\\EE4A\"}.icon-fontello-github-text:before{content:\"\\EE4B\"}.icon-fontello-github-5:before{content:\"\\EE4C\"}.icon-fontello-skype-4:before{content:\"\\EE4D\"}.icon-fontello-icq:before{content:\"\\EE4E\"}.icon-fontello-yandex:before{content:\"\\EE4F\"}.icon-fontello-yandex-rect:before{content:\"\\EE50\"}.icon-fontello-vkontakte-rect:before{content:\"\\EE51\"}.icon-fontello-odnoklassniki:before{content:\"\\EE52\"}.icon-fontello-odnoklassniki-rect:before{content:\"\\EE53\"}.icon-fontello-friendfeed:before{content:\"\\EE54\"}.icon-fontello-friendfeed-rect:before{content:\"\\EE55\"}.icon-fontello-blogger-1:before{content:\"\\EE56\"}.icon-fontello-blogger-rect:before{content:\"\\EE57\"}.icon-fontello-deviantart:before{content:\"\\EE58\"}.icon-fontello-jabber:before{content:\"\\EE59\"}.icon-fontello-lastfm-3:before{content:\"\\EE5A\"}.icon-fontello-lastfm-rect:before{content:\"\\EE5B\"}.icon-fontello-linkedin-5:before{content:\"\\EE5C\"}.icon-fontello-linkedin-rect:before{content:\"\\EE5D\"}.icon-fontello-picasa-1:before{content:\"\\EE5E\"}.icon-fontello-wordpress-1:before{content:\"\\EE5F\"}.icon-fontello-instagram-3:before{content:\"\\EE60\"}.icon-fontello-instagram-filled:before{content:\"\\EE61\"}.icon-fontello-diigo:before{content:\"\\EE62\"}.icon-fontello-box-4:before{content:\"\\EE63\"}.icon-fontello-box-rect:before{content:\"\\EE64\"}.icon-fontello-tudou:before{content:\"\\EE65\"}.icon-fontello-youku:before{content:\"\\EE66\"}.icon-fontello-win8:before{content:\"\\EE67\"}.icon-fontello-amex:before{content:\"\\EE68\"}.icon-fontello-discover:before{content:\"\\EE69\"}.icon-fontello-visa:before{content:\"\\EE6A\"}.icon-fontello-mastercard:before{content:\"\\EE6B\"}.icon-fontello-glass-1:before{content:\"\\EE6C\"}.icon-fontello-music-3:before{content:\"\\EE6D\"}.icon-fontello-search-6:before{content:\"\\EE6E\"}.icon-fontello-search-circled:before{content:\"\\EE6F\"}.icon-fontello-mail-6:before{content:\"\\EE70\"}.icon-fontello-mail-circled:before{content:\"\\EE71\"}.icon-fontello-heart-6:before{content:\"\\EE72\"}.icon-fontello-heart-circled:before{content:\"\\EE73\"}.icon-fontello-heart-empty-3:before{content:\"\\EE74\"}.icon-fontello-star-6:before{content:\"\\EE75\"}.icon-fontello-star-circled:before{content:\"\\EE76\"}.icon-fontello-star-empty-3:before{content:\"\\EE77\"}.icon-fontello-user-6:before{content:\"\\EE78\"}.icon-fontello-group:before{content:\"\\EE79\"}.icon-fontello-group-circled:before{content:\"\\EE7A\"}.icon-fontello-torso:before{content:\"\\EE7B\"}.icon-fontello-video-4:before{content:\"\\EE7C\"}.icon-fontello-video-circled:before{content:\"\\EE7D\"}.icon-fontello-video-alt-1:before{content:\"\\EE7E\"}.icon-fontello-videocam-4:before{content:\"\\EE7F\"}.icon-fontello-video-chat:before{content:\"\\EE80\"}.icon-fontello-picture-4:before{content:\"\\EE81\"}.icon-fontello-camera-6:before{content:\"\\EE82\"}.icon-fontello-photo:before{content:\"\\EE83\"}.icon-fontello-photo-circled:before{content:\"\\EE84\"}.icon-fontello-th-large-2:before{content:\"\\EE85\"}.icon-fontello-th-3:before{content:\"\\EE86\"}.icon-fontello-th-list-4:before{content:\"\\EE87\"}.icon-fontello-view-mode:before{content:\"\\EE88\"}.icon-fontello-ok-5:before{content:\"\\EE89\"}.icon-fontello-ok-circled-1:before{content:\"\\EE8A\"}.icon-fontello-ok-circled2:before{content:\"\\EE8B\"}.icon-fontello-cancel-6:before{content:\"\\EE8C\"}.icon-fontello-cancel-circled-3:before{content:\"\\EE8D\"}.icon-fontello-cancel-circled2:before{content:\"\\EE8E\"}.icon-fontello-plus-6:before{content:\"\\EE8F\"}.icon-fontello-plus-circled-1:before{content:\"\\EE90\"}.icon-fontello-minus-4:before{content:\"\\EE91\"}.icon-fontello-minus-circled-1:before{content:\"\\EE92\"}.icon-fontello-help-3:before{content:\"\\EE93\"}.icon-fontello-help-circled-2:before{content:\"\\EE94\"}.icon-fontello-info-circled-2:before{content:\"\\EE95\"}.icon-fontello-home-6:before{content:\"\\EE96\"}.icon-fontello-home-circled:before{content:\"\\EE97\"}.icon-fontello-website:before{content:\"\\EE98\"}.icon-fontello-website-circled:before{content:\"\\EE99\"}.icon-fontello-attach-5:before{content:\"\\EE9A\"}.icon-fontello-attach-circled:before{content:\"\\EE9B\"}.icon-fontello-lock-6:before{content:\"\\EE9C\"}.icon-fontello-lock-circled:before{content:\"\\EE9D\"}.icon-fontello-lock-open-6:before{content:\"\\EE9E\"}.icon-fontello-lock-open-alt-2:before{content:\"\\EE9F\"}.icon-fontello-eye-6:before{content:\"\\EEA0\"}.icon-fontello-eye-off-1:before{content:\"\\EEA1\"}.icon-fontello-tag-5:before{content:\"\\EEA2\"}.icon-fontello-tags-2:before{content:\"\\EEA3\"}.icon-fontello-bookmark-3:before{content:\"\\EEA4\"}.icon-fontello-bookmark-empty-1:before{content:\"\\EEA5\"}.icon-fontello-flag-3:before{content:\"\\EEA6\"}.icon-fontello-flag-circled:before{content:\"\\EEA7\"}.icon-fontello-thumbs-up-4:before{content:\"\\EEA8\"}.icon-fontello-thumbs-down-4:before{content:\"\\EEA9\"}.icon-fontello-download-6:before{content:\"\\EEAA\"}.icon-fontello-download-alt:before{content:\"\\EEAB\"}.icon-fontello-upload-5:before{content:\"\\EEAC\"}.icon-fontello-share-2:before{content:\"\\EEAD\"}.icon-fontello-quote-1:before{content:\"\\EEAE\"}.icon-fontello-quote-circled:before{content:\"\\EEAF\"}.icon-fontello-export-5:before{content:\"\\EEB0\"}.icon-fontello-pencil-6:before{content:\"\\EEB1\"}.icon-fontello-pencil-circled:before{content:\"\\EEB2\"}.icon-fontello-edit-3:before{content:\"\\EEB3\"}.icon-fontello-edit-circled:before{content:\"\\EEB4\"}.icon-fontello-edit-alt:before{content:\"\\EEB5\"}.icon-fontello-print-6:before{content:\"\\EEB6\"}.icon-fontello-retweet-3:before{content:\"\\EEB7\"}.icon-fontello-comment-5:before{content:\"\\EEB8\"}.icon-fontello-comment-alt-1:before{content:\"\\EEB9\"}.icon-fontello-bell-5:before{content:\"\\EEBA\"}.icon-fontello-warning-1:before{content:\"\\EEBB\"}.icon-fontello-exclamation:before{content:\"\\EEBC\"}.icon-fontello-error:before{content:\"\\EEBD\"}.icon-fontello-error-alt:before{content:\"\\EEBE\"}.icon-fontello-location-6:before{content:\"\\EEBF\"}.icon-fontello-location-circled:before{content:\"\\EEC0\"}.icon-fontello-compass-5:before{content:\"\\EEC1\"}.icon-fontello-compass-circled:before{content:\"\\EEC2\"}.icon-fontello-trash-7:before{content:\"\\EEC3\"}.icon-fontello-trash-circled:before{content:\"\\EEC4\"}.icon-fontello-doc-6:before{content:\"\\EEC5\"}.icon-fontello-doc-circled:before{content:\"\\EEC6\"}.icon-fontello-doc-new:before{content:\"\\EEC7\"}.icon-fontello-doc-new-circled:before{content:\"\\EEC8\"}.icon-fontello-folder-5:before{content:\"\\EEC9\"}.icon-fontello-folder-circled:before{content:\"\\EECA\"}.icon-fontello-folder-close:before{content:\"\\EECB\"}.icon-fontello-folder-open-2:before{content:\"\\EECC\"}.icon-fontello-rss-6:before{content:\"\\EECD\"}.icon-fontello-phone-3:before{content:\"\\EECE\"}.icon-fontello-phone-circled:before{content:\"\\EECF\"}.icon-fontello-cog-5:before{content:\"\\EED0\"}.icon-fontello-cog-circled:before{content:\"\\EED1\"}.icon-fontello-cogs:before{content:\"\\EED2\"}.icon-fontello-wrench-4:before{content:\"\\EED3\"}.icon-fontello-wrench-circled:before{content:\"\\EED4\"}.icon-fontello-basket-4:before{content:\"\\EED5\"}.icon-fontello-basket-circled:before{content:\"\\EED6\"}.icon-fontello-calendar-7:before{content:\"\\EED7\"}.icon-fontello-calendar-circled:before{content:\"\\EED8\"}.icon-fontello-mic-5:before{content:\"\\EED9\"}.icon-fontello-mic-circled:before{content:\"\\EEDA\"}.icon-fontello-volume-off-4:before{content:\"\\EEDB\"}.icon-fontello-volume-down-2:before{content:\"\\EEDC\"}.icon-fontello-volume-1:before{content:\"\\EEDD\"}.icon-fontello-volume-up-3:before{content:\"\\EEDE\"}.icon-fontello-headphones-3:before{content:\"\\EEDF\"}.icon-fontello-clock-6:before{content:\"\\EEE0\"}.icon-fontello-clock-circled:before{content:\"\\EEE1\"}.icon-fontello-lightbulb-2:before{content:\"\\EEE2\"}.icon-fontello-lightbulb-alt:before{content:\"\\EEE3\"}.icon-fontello-block-4:before{content:\"\\EEE4\"}.icon-fontello-resize-full-5:before{content:\"\\EEE5\"}.icon-fontello-resize-full-alt-2:before{content:\"\\EEE6\"}.icon-fontello-resize-small-4:before{content:\"\\EEE7\"}.icon-fontello-resize-vertical-2:before{content:\"\\EEE8\"}.icon-fontello-resize-horizontal-2:before{content:\"\\EEE9\"}.icon-fontello-move-3:before{content:\"\\EEEA\"}.icon-fontello-zoom-in-4:before{content:\"\\EEEB\"}.icon-fontello-zoom-out-4:before{content:\"\\EEEC\"}.icon-fontello-down-open-3:before{content:\"\\EEED\"}.icon-fontello-left-open-4:before{content:\"\\EEEE\"}.icon-fontello-right-open-4:before{content:\"\\EEEF\"}.icon-fontello-up-open-3:before{content:\"\\EEF0\"}.icon-fontello-down-7:before{content:\"\\EEF1\"}.icon-fontello-left-6:before{content:\"\\EEF2\"}.icon-fontello-right-6:before{content:\"\\EEF3\"}.icon-fontello-up-7:before{content:\"\\EEF4\"}.icon-fontello-down-circled-2:before{content:\"\\EEF5\"}.icon-fontello-left-circled-2:before{content:\"\\EEF6\"}.icon-fontello-right-circled-2:before{content:\"\\EEF7\"}.icon-fontello-up-circled-2:before{content:\"\\EEF8\"}.icon-fontello-down-hand-1:before{content:\"\\EEF9\"}.icon-fontello-left-hand-1:before{content:\"\\EEFA\"}.icon-fontello-right-hand-1:before{content:\"\\EEFB\"}.icon-fontello-up-hand-1:before{content:\"\\EEFC\"}.icon-fontello-cw-5:before{content:\"\\EEFD\"}.icon-fontello-cw-circled:before{content:\"\\EEFE\"}.icon-fontello-arrows-cw-2:before{content:\"\\EEFF\"}.icon-fontello-shuffle-4:before{content:\"\\EF00\"}.icon-fontello-play-5:before{content:\"\\EF01\"}.icon-fontello-play-circled-1:before{content:\"\\EF02\"}.icon-fontello-play-circled2:before{content:\"\\EF03\"}.icon-fontello-stop-6:before{content:\"\\EF04\"}.icon-fontello-stop-circled:before{content:\"\\EF05\"}.icon-fontello-pause-5:before{content:\"\\EF06\"}.icon-fontello-pause-circled:before{content:\"\\EF07\"}.icon-fontello-record-2:before{content:\"\\EF08\"}.icon-fontello-eject-3:before{content:\"\\EF09\"}.icon-fontello-backward:before{content:\"\\EF0A\"}.icon-fontello-backward-circled:before{content:\"\\EF0B\"}.icon-fontello-fast-backward-2:before{content:\"\\EF0C\"}.icon-fontello-fast-forward-2:before{content:\"\\EF0D\"}.icon-fontello-forward-3:before{content:\"\\EF0E\"}.icon-fontello-forward-circled:before{content:\"\\EF0F\"}.icon-fontello-step-backward:before{content:\"\\EF10\"}.icon-fontello-step-forward:before{content:\"\\EF11\"}.icon-fontello-target-4:before{content:\"\\EF12\"}.icon-fontello-signal-4:before{content:\"\\EF13\"}.icon-fontello-desktop-2:before{content:\"\\EF14\"}.icon-fontello-desktop-circled:before{content:\"\\EF15\"}.icon-fontello-laptop-2:before{content:\"\\EF16\"}.icon-fontello-laptop-circled:before{content:\"\\EF17\"}.icon-fontello-network-1:before{content:\"\\EF18\"}.icon-fontello-inbox-3:before{content:\"\\EF19\"}.icon-fontello-inbox-circled:before{content:\"\\EF1A\"}.icon-fontello-inbox-alt:before{content:\"\\EF1B\"}.icon-fontello-globe-5:before{content:\"\\EF1C\"}.icon-fontello-globe-alt-1:before{content:\"\\EF1D\"}.icon-fontello-cloud-6:before{content:\"\\EF1E\"}.icon-fontello-cloud-circled:before{content:\"\\EF1F\"}.icon-fontello-flight-2:before{content:\"\\EF20\"}.icon-fontello-leaf-3:before{content:\"\\EF21\"}.icon-fontello-font-1:before{content:\"\\EF22\"}.icon-fontello-fontsize-1:before{content:\"\\EF23\"}.icon-fontello-bold-1:before{content:\"\\EF24\"}.icon-fontello-italic-1:before{content:\"\\EF25\"}.icon-fontello-text-height-1:before{content:\"\\EF26\"}.icon-fontello-text-width-1:before{content:\"\\EF27\"}.icon-fontello-align-left-1:before{content:\"\\EF28\"}.icon-fontello-align-center-1:before{content:\"\\EF29\"}.icon-fontello-align-right-1:before{content:\"\\EF2A\"}.icon-fontello-align-justify-1:before{content:\"\\EF2B\"}.icon-fontello-list-3:before{content:\"\\EF2C\"}.icon-fontello-indent-left-1:before{content:\"\\EF2D\"}.icon-fontello-indent-right-1:before{content:\"\\EF2E\"}.icon-fontello-briefcase-3:before{content:\"\\EF2F\"}.icon-fontello-off-1:before{content:\"\\EF30\"}.icon-fontello-road-1:before{content:\"\\EF31\"}.icon-fontello-qrcode-1:before{content:\"\\EF32\"}.icon-fontello-barcode-1:before{content:\"\\EF33\"}.icon-fontello-braille:before{content:\"\\EF34\"}.icon-fontello-book-4:before{content:\"\\EF35\"}.icon-fontello-adjust-1:before{content:\"\\EF36\"}.icon-fontello-tint-1:before{content:\"\\EF37\"}.icon-fontello-check-3:before{content:\"\\EF38\"}.icon-fontello-check-empty-1:before{content:\"\\EF39\"}.icon-fontello-asterisk-1:before{content:\"\\EF3A\"}.icon-fontello-gift-2:before{content:\"\\EF3B\"}.icon-fontello-fire-2:before{content:\"\\EF3C\"}.icon-fontello-magnet-2:before{content:\"\\EF3D\"}.icon-fontello-chart-2:before{content:\"\\EF3E\"}.icon-fontello-chart-circled:before{content:\"\\EF3F\"}.icon-fontello-credit-card-4:before{content:\"\\EF40\"}.icon-fontello-megaphone-2:before{content:\"\\EF41\"}.icon-fontello-clipboard-2:before{content:\"\\EF42\"}.icon-fontello-hdd-2:before{content:\"\\EF43\"}.icon-fontello-key-4:before{content:\"\\EF44\"}.icon-fontello-certificate-2:before{content:\"\\EF45\"}.icon-fontello-tasks-1:before{content:\"\\EF46\"}.icon-fontello-filter-1:before{content:\"\\EF47\"}.icon-fontello-gauge-2:before{content:\"\\EF48\"}.icon-fontello-smiley:before{content:\"\\EF49\"}.icon-fontello-smiley-circled:before{content:\"\\EF4A\"}.icon-fontello-address-book:before{content:\"\\EF4B\"}.icon-fontello-address-book-alt:before{content:\"\\EF4C\"}.icon-fontello-asl:before{content:\"\\EF4D\"}.icon-fontello-glasses:before{content:\"\\EF4E\"}.icon-fontello-hearing-impaired:before{content:\"\\EF4F\"}.icon-fontello-iphone-home:before{content:\"\\EF50\"}.icon-fontello-person:before{content:\"\\EF51\"}.icon-fontello-adult:before{content:\"\\EF52\"}.icon-fontello-child:before{content:\"\\EF53\"}.icon-fontello-blind:before{content:\"\\EF54\"}.icon-fontello-guidedog:before{content:\"\\EF55\"}.icon-fontello-accessibility:before{content:\"\\EF56\"}.icon-fontello-universal-access:before{content:\"\\EF57\"}.icon-fontello-male-2:before{content:\"\\EF58\"}.icon-fontello-female-2:before{content:\"\\EF59\"}.icon-fontello-behance-1:before{content:\"\\EF5A\"}.icon-fontello-blogger-2:before{content:\"\\EF5B\"}.icon-fontello-cc-2:before{content:\"\\EF5C\"}.icon-fontello-css:before{content:\"\\EF5D\"}.icon-fontello-delicious-1:before{content:\"\\EF5E\"}.icon-fontello-deviantart-1:before{content:\"\\EF5F\"}.icon-fontello-digg-1:before{content:\"\\EF60\"}.icon-fontello-dribbble-5:before{content:\"\\EF61\"}.icon-fontello-facebook-7:before{content:\"\\EF62\"}.icon-fontello-flickr-4:before{content:\"\\EF63\"}.icon-fontello-foursquare-2:before{content:\"\\EF64\"}.icon-fontello-friendfeed-1:before{content:\"\\EF65\"}.icon-fontello-friendfeed-rect-1:before{content:\"\\EF66\"}.icon-fontello-github-6:before{content:\"\\EF67\"}.icon-fontello-github-text-1:before{content:\"\\EF68\"}.icon-fontello-googleplus:before{content:\"\\EF69\"}.icon-fontello-instagram-4:before{content:\"\\EF6A\"}.icon-fontello-linkedin-6:before{content:\"\\EF6B\"}.icon-fontello-path:before{content:\"\\EF6C\"}.icon-fontello-picasa-2:before{content:\"\\EF6D\"}.icon-fontello-pinterest-3:before{content:\"\\EF6E\"}.icon-fontello-reddit-1:before{content:\"\\EF6F\"}.icon-fontello-skype-5:before{content:\"\\EF70\"}.icon-fontello-slideshare:before{content:\"\\EF71\"}.icon-fontello-stackoverflow-2:before{content:\"\\EF72\"}.icon-fontello-stumbleupon-2:before{content:\"\\EF73\"}.icon-fontello-twitter-7:before{content:\"\\EF74\"}.icon-fontello-tumblr-4:before{content:\"\\EF75\"}.icon-fontello-vimeo-4:before{content:\"\\EF76\"}.icon-fontello-vkontakte-2:before{content:\"\\EF77\"}.icon-fontello-w3c-1:before{content:\"\\EF78\"}.icon-fontello-wordpress-2:before{content:\"\\EF79\"}.icon-fontello-youtube-3:before{content:\"\\EF7A\"}.icon-fontello-music-4:before{content:\"\\EF7B\"}.icon-fontello-search-7:before{content:\"\\EF7C\"}.icon-fontello-mail-7:before{content:\"\\EF7D\"}.icon-fontello-heart-7:before{content:\"\\EF7E\"}.icon-fontello-star-7:before{content:\"\\EF7F\"}.icon-fontello-user-7:before{content:\"\\EF80\"}.icon-fontello-videocam-5:before{content:\"\\EF81\"}.icon-fontello-camera-7:before{content:\"\\EF82\"}.icon-fontello-photo-1:before{content:\"\\EF83\"}.icon-fontello-attach-6:before{content:\"\\EF84\"}.icon-fontello-lock-7:before{content:\"\\EF85\"}.icon-fontello-eye-7:before{content:\"\\EF86\"}.icon-fontello-tag-6:before{content:\"\\EF87\"}.icon-fontello-thumbs-up-5:before{content:\"\\EF88\"}.icon-fontello-pencil-7:before{content:\"\\EF89\"}.icon-fontello-comment-6:before{content:\"\\EF8A\"}.icon-fontello-location-7:before{content:\"\\EF8B\"}.icon-fontello-cup-1:before{content:\"\\EF8C\"}.icon-fontello-trash-8:before{content:\"\\EF8D\"}.icon-fontello-doc-7:before{content:\"\\EF8E\"}.icon-fontello-note-1:before{content:\"\\EF8F\"}.icon-fontello-cog-6:before{content:\"\\EF90\"}.icon-fontello-params:before{content:\"\\EF91\"}.icon-fontello-calendar-8:before{content:\"\\EF92\"}.icon-fontello-sound-1:before{content:\"\\EF93\"}.icon-fontello-clock-7:before{content:\"\\EF94\"}.icon-fontello-lightbulb-3:before{content:\"\\EF95\"}.icon-fontello-tv:before{content:\"\\EF96\"}.icon-fontello-desktop-3:before{content:\"\\EF97\"}.icon-fontello-mobile-6:before{content:\"\\EF98\"}.icon-fontello-cd-3:before{content:\"\\EF99\"}.icon-fontello-inbox-4:before{content:\"\\EF9A\"}.icon-fontello-globe-6:before{content:\"\\EF9B\"}.icon-fontello-cloud-7:before{content:\"\\EF9C\"}.icon-fontello-paper-plane-2:before{content:\"\\EF9D\"}.icon-fontello-fire-3:before{content:\"\\EF9E\"}.icon-fontello-graduation-cap-1:before{content:\"\\EF9F\"}.icon-fontello-megaphone-3:before{content:\"\\EFA0\"}.icon-fontello-database-2:before{content:\"\\EFA1\"}.icon-fontello-key-5:before{content:\"\\EFA2\"}.icon-fontello-beaker-1:before{content:\"\\EFA3\"}.icon-fontello-truck-1:before{content:\"\\EFA4\"}.icon-fontello-money-2:before{content:\"\\EFA5\"}.icon-fontello-food-1:before{content:\"\\EFA6\"}.icon-fontello-shop-1:before{content:\"\\EFA7\"}.icon-fontello-diamond:before{content:\"\\EFA8\"}.icon-fontello-t-shirt:before{content:\"\\EFA9\"}.icon-fontello-wallet:before{content:\"\\EFAA\"}.icon-fontello-search-8:before{content:\"\\EFAB\"}.icon-fontello-mail-8:before{content:\"\\EFAC\"}.icon-fontello-heart-8:before{content:\"\\EFAD\"}.icon-fontello-heart-empty-4:before{content:\"\\EFAE\"}.icon-fontello-star-8:before{content:\"\\EFAF\"}.icon-fontello-user-8:before{content:\"\\EFB0\"}.icon-fontello-video-5:before{content:\"\\EFB1\"}.icon-fontello-picture-5:before{content:\"\\EFB2\"}.icon-fontello-th-large-3:before{content:\"\\EFB3\"}.icon-fontello-th-4:before{content:\"\\EFB4\"}.icon-fontello-th-list-5:before{content:\"\\EFB5\"}.icon-fontello-ok-6:before{content:\"\\EFB6\"}.icon-fontello-ok-circle-2:before{content:\"\\EFB7\"}.icon-fontello-cancel-7:before{content:\"\\EFB8\"}.icon-fontello-cancel-circle-3:before{content:\"\\EFB9\"}.icon-fontello-plus-circle-2:before{content:\"\\EFBA\"}.icon-fontello-minus-circle-2:before{content:\"\\EFBB\"}.icon-fontello-link-5:before{content:\"\\EFBC\"}.icon-fontello-attach-7:before{content:\"\\EFBD\"}.icon-fontello-lock-8:before{content:\"\\EFBE\"}.icon-fontello-lock-open-7:before{content:\"\\EFBF\"}.icon-fontello-tag-7:before{content:\"\\EFC0\"}.icon-fontello-reply-4:before{content:\"\\EFC1\"}.icon-fontello-reply-all-2:before{content:\"\\EFC2\"}.icon-fontello-forward-4:before{content:\"\\EFC3\"}.icon-fontello-code-3:before{content:\"\\EFC4\"}.icon-fontello-retweet-4:before{content:\"\\EFC5\"}.icon-fontello-comment-7:before{content:\"\\EFC6\"}.icon-fontello-comment-alt-2:before{content:\"\\EFC7\"}.icon-fontello-chat-6:before{content:\"\\EFC8\"}.icon-fontello-attention-5:before{content:\"\\EFC9\"}.icon-fontello-location-8:before{content:\"\\EFCA\"}.icon-fontello-doc-8:before{content:\"\\EFCB\"}.icon-fontello-docs-landscape:before{content:\"\\EFCC\"}.icon-fontello-folder-6:before{content:\"\\EFCD\"}.icon-fontello-archive-2:before{content:\"\\EFCE\"}.icon-fontello-rss-7:before{content:\"\\EFCF\"}.icon-fontello-rss-alt-1:before{content:\"\\EFD0\"}.icon-fontello-cog-7:before{content:\"\\EFD1\"}.icon-fontello-logout-3:before{content:\"\\EFD2\"}.icon-fontello-clock-8:before{content:\"\\EFD3\"}.icon-fontello-block-5:before{content:\"\\EFD4\"}.icon-fontello-resize-full-6:before{content:\"\\EFD5\"}.icon-fontello-resize-full-circle:before{content:\"\\EFD6\"}.icon-fontello-popup-5:before{content:\"\\EFD7\"}.icon-fontello-left-open-5:before{content:\"\\EFD8\"}.icon-fontello-right-open-5:before{content:\"\\EFD9\"}.icon-fontello-down-circle-1:before{content:\"\\EFDA\"}.icon-fontello-left-circle-1:before{content:\"\\EFDB\"}.icon-fontello-right-circle-1:before{content:\"\\EFDC\"}.icon-fontello-up-circle-1:before{content:\"\\EFDD\"}.icon-fontello-down-dir-3:before{content:\"\\EFDE\"}.icon-fontello-right-dir-3:before{content:\"\\EFDF\"}.icon-fontello-down-micro:before{content:\"\\EFE0\"}.icon-fontello-up-micro:before{content:\"\\EFE1\"}.icon-fontello-cw-circle:before{content:\"\\EFE2\"}.icon-fontello-arrows-cw-3:before{content:\"\\EFE3\"}.icon-fontello-updown-circle:before{content:\"\\EFE4\"}.icon-fontello-target-5:before{content:\"\\EFE5\"}.icon-fontello-signal-5:before{content:\"\\EFE6\"}.icon-fontello-progress-4:before{content:\"\\EFE7\"}.icon-fontello-progress-5:before{content:\"\\EFE8\"}.icon-fontello-progress-6:before{content:\"\\EFE9\"}.icon-fontello-progress-7:before{content:\"\\EFEA\"}.icon-fontello-progress-8:before{content:\"\\EFEB\"}.icon-fontello-progress-9:before{content:\"\\EFEC\"}.icon-fontello-progress-10:before{content:\"\\EFED\"}.icon-fontello-progress-11:before{content:\"\\EFEE\"}.icon-fontello-font-2:before{content:\"\\EFEF\"}.icon-fontello-list-4:before{content:\"\\EFF0\"}.icon-fontello-list-numbered-1:before{content:\"\\EFF1\"}.icon-fontello-indent-left-2:before{content:\"\\EFF2\"}.icon-fontello-indent-right-2:before{content:\"\\EFF3\"}.icon-fontello-cloud-8:before{content:\"\\EFF4\"}.icon-fontello-terminal-1:before{content:\"\\EFF5\"}.icon-fontello-facebook-rect-2:before{content:\"\\EFF6\"}.icon-fontello-twitter-bird-2:before{content:\"\\EFF7\"}.icon-fontello-vimeo-rect-1:before{content:\"\\EFF8\"}.icon-fontello-tumblr-rect-1:before{content:\"\\EFF9\"}.icon-fontello-googleplus-rect-1:before{content:\"\\EFFA\"}.icon-fontello-linkedin-rect-1:before{content:\"\\EFFB\"}.icon-fontello-skype-6:before{content:\"\\EFFC\"}.icon-fontello-vkontakte-rect-1:before{content:\"\\EFFD\"}.icon-fontello-youtube-4:before{content:\"\\EFFE\"}.icon-fontello-right-1:before{content:\"\\E8C9\"}@font-face{font-family:Climacons-Font;src:url(" + __webpack_require__("./src/styles/fonts/climacons/Climacons-Font.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/climacons/Climacons-Font.woff") + ") format(\"woff\");font-weight:400;font-style:normal}.climacon:before{font-family:Climacons-Font;speak:none;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased}.climacon.cloud:before{content:\"\\E000\"}.climacon.cloud.sun:before{content:\"\\E001\"}.climacon.cloud.moon:before{content:\"\\E002\"}.climacon.rain.cloud:before,.climacon.rain:before{content:\"\\E003\"}.climacon.rain.cloud.sun:before,.climacon.rain.sun:before{content:\"\\E004\"}.climacon.rain.cloud.moon:before,.climacon.rain.moon:before{content:\"\\E005\"}.climacon.showers.cloud:before,.climacon.showers:before{content:\"\\E006\"}.climacon.showers.cloud.sun:before,.climacon.showers.sun:before{content:\"\\E007\"}.climacon.showers.cloud.moon:before,.climacon.showers.moon:before{content:\"\\E008\"}.climacon.downpour.cloud:before,.climacon.downpour:before{content:\"\\E009\"}.climacon.downpour.cloud.sun:before,.climacon.downpour.sun:before{content:\"\\E00A\"}.climacon.downpour.cloud.moon:before,.climacon.downpour.moon:before{content:\"\\E00B\"}.climacon.drizzle.cloud:before,.climacon.drizzle:before{content:\"\\E00C\"}.climacon.drizzle.cloud.sun:before,.climacon.drizzle.sun:before{content:\"\\E00D\"}.climacon.drizzle.cloud.moon:before,.climacon.drizzle.moon:before{content:\"\\E00E\"}.climacon.sleet.cloud:before,.climacon.sleet:before{content:\"\\E00F\"}.climacon.sleet.cloud.sun:before,.climacon.sleet.sun:before{content:\"\\E010\"}.climacon.sleet.cloud.moon:before,.climacon.sleet.moon:before{content:\"\\E011\"}.climacon.hail.cloud:before,.climacon.hail:before{content:\"\\E012\"}.climacon.hail.cloud.sun:before,.climacon.hail.sun:before{content:\"\\E013\"}.climacon.hail.cloud.moon:before,.climacon.hail.moon:before{content:\"\\E014\"}.climacon.flurries.cloud:before,.climacon.flurries:before{content:\"\\E015\"}.climacon.flurries.cloud.sun:before,.climacon.flurries.sun:before{content:\"\\E016\"}.climacon.flurries.cloud.moon:before,.climacon.flurries.moon:before{content:\"\\E017\"}.climacon.snow.cloud:before,.climacon.snow:before{content:\"\\E018\"}.climacon.snow.cloud.sun:before,.climacon.snow.sun:before{content:\"\\E019\"}.climacon.snow.cloud.moon:before,.climacon.snow.moon:before{content:\"\\E01A\"}.climacon.fog.cloud:before,.climacon.fog:before{content:\"\\E01B\"}.climacon.fog.cloud.sun:before,.climacon.fog.sun:before{content:\"\\E01C\"}.climacon.fog.cloud.moon:before,.climacon.fog.moon:before{content:\"\\E01D\"}.climacon.haze:before{content:\"\\E01E\"}.climacon.haze.sun:before{content:\"\\E01F\"}.climacon.haze.moon:before{content:\"\\E020\"}.climacon.wind:before{content:\"\\E021\"}.climacon.wind.cloud:before{content:\"\\E022\"}.climacon.wind.cloud.sun:before,.climacon.wind.sun:before{content:\"\\E023\"}.climacon.wind.cloud.moon:before,.climacon.wind.moon:before{content:\"\\E024\"}.climacon.lightning.cloud:before,.climacon.lightning:before{content:\"\\E025\"}.climacon.lightning.cloud.sun:before,.climacon.lightning.sun:before{content:\"\\E026\"}.climacon.lightning.cloud.moon:before,.climacon.lightning.moon:before{content:\"\\E027\"}.climacon.sun:before{content:\"\\E028\"}.climacon.sun.set:before,.climacon.sunset:before{content:\"\\E029\"}.climacon.sun.rise:before,.climacon.sunrise:before{content:\"\\E02A\"}.climacon.low-sun:before,.climacon.sun-low:before,.climacon.sun.low:before{content:\"\\E02B\"}.climacon.lower-sun:before,.climacon.sun-lower:before,.climacon.sun.lower:before{content:\"\\E02C\"}.climacon.moon:before{content:\"\\E02D\"}.climacon.moon.new:before{content:\"\\E02E\"}.climacon.moon.first-crescent:before,.climacon.moon.waxing.crescent:before{content:\"\\E02F\"}.climacon.moon.first-half:before,.climacon.moon.first-quarter:before,.climacon.moon.waxing.half:before,.climacon.moon.waxing.quarter:before{content:\"\\E030\"}.climacon.moon.first-gibbous:before,.climacon.moon.first-three-quarter:before,.climacon.moon.waxing.gibbous:before,.climacon.moon.waxing.three-quarter:before{content:\"\\E031\"}.climacon.moon.full:before{content:\"\\E032\"}.climacon.moon.last-gibbous:before,.climacon.moon.last-three-quarter:before,.climacon.moon.waning.gibbous:before,.climacon.moon.waning.three-quarter:before{content:\"\\E033\"}.climacon.moon.last-half:before,.climacon.moon.last-quarter:before,.climacon.moon.waning.half:before,.climacon.moon.waning.quarter:before{content:\"\\E034\"}.climacon.moon.last-crescent:before,.climacon.moon.waning.crescent:before{content:\"\\E035\"}.climacon.snowflake:before{content:\"\\E036\"}.climacon.tornado:before{content:\"\\E037\"}.climacon.thermometer.empty:before,.climacon.thermometer:before{content:\"\\E038\"}.climacon.thermometer.low:before{content:\"\\E039\"}.climacon.thermometer.medium-low:before{content:\"\\E03A\"}.climacon.thermometer.medium-high:before{content:\"\\E03B\"}.climacon.thermometer.high:before{content:\"\\E03C\"}.climacon.thermometer.full:before{content:\"\\E03D\"}.climacon.celcius:before{content:\"\\E03E\"}.climacon.farenheit:before{content:\"\\E03F\"}.climacon.compass:before{content:\"\\E040\"}.climacon.compass.north:before{content:\"\\E041\"}.climacon.compass.east:before{content:\"\\E042\"}.climacon.compass.south:before{content:\"\\E043\"}.climacon.compass.west:before{content:\"\\E044\"}.climacon.umbrella:before{content:\"\\E045\"}.climacon.sunglasses:before{content:\"\\E046\"}.climacon.cloud.cycle:before,.climacon.cloud.refresh:before{content:\"\\E047\"}.climacon.cloud.down:before,.climacon.cloud.download:before{content:\"\\E048\"}.climacon.cloud.up:before,.climacon.cloud.upload:before{content:\"\\E049\"}@font-face{font-family:devicon;src:url(" + __webpack_require__("./src/styles/fonts/devicon/devicon.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/devicon/devicon.woff") + ") format(\"woff\");font-weight:400;font-style:normal}[class*=\" devicon-\"],[class^=devicon-]{font-family:devicon;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.devicon-postgresql-plain:before{content:\"\\E648\"}.devicon-postgresql-plain-wordmark:before{content:\"\\E649\"}.devicon-postgresql-plain-wordmark.colored,.devicon-postgresql-plain.colored{color:#336791}.devicon-nodejs-plain:before{content:\"\\E64A\"}.devicon-nodejs-plain-wordmark:before{content:\"\\E64B\"}.devicon-nodejs-plain-wordmark.colored,.devicon-nodejs-plain.colored{color:#83cd29}.devicon-mongodb-plain:before{content:\"\\E64C\"}.devicon-mongodb-plain-wordmark:before{content:\"\\E64D\"}.devicon-mongodb-plain-wordmark.colored,.devicon-mongodb-plain.colored{color:#4faa41}.devicon-krakenjs-plain:before{content:\"\\E64E\"}.devicon-krakenjs-plain-wordmark:before{content:\"\\E64F\"}.devicon-krakenjs-plain-wordmark.colored,.devicon-krakenjs-plain.colored{color:#0081c2}.devicon-travis-plain-wordmark:before{content:\"\\E641\"}.devicon-travis-plain:before{content:\"\\E642\"}.devicon-travis-plain-wordmark.colored,.devicon-travis-plain.colored{color:#bb2031}.devicon-linux-plain:before{content:\"\\E647\"}.devicon-linux-plain.colored{color:#000}.devicon-ubuntu-plain-wordmark:before{content:\"\\E645\"}.devicon-ubuntu-plain:before{content:\"\\E646\"}.devicon-ubuntu-plain-wordmark.colored,.devicon-ubuntu-plain.colored{color:#dd4814}.devicon-debian-plain-wordmark:before{content:\"\\E643\"}.devicon-debian-plain:before{content:\"\\E644\"}.devicon-debian-plain-wordmark.colored,.devicon-debian-plain.colored{color:#a80030}.devicon-firefox-plain-wordmark:before{content:\"\\E63F\"}.devicon-firefox-plain:before{content:\"\\E640\"}.devicon-firefox-plain-wordmark.colored,.devicon-firefox-plain.colored{color:#dd732a}.devicon-chrome-plain-wordmark:before{content:\"\\E63D\"}.devicon-chrome-plain:before{content:\"\\E63E\"}.devicon-chrome-plain-wordmark.colored,.devicon-chrome-plain.colored{color:#ce4e4e}.devicon-backbone-line-wordmark:before{content:\"\\E639\"}.devicon-backbone-line:before{content:\"\\E63A\"}.devicon-backbone-plain-wordmark:before{content:\"\\E63B\"}.devicon-backbone-plain:before{content:\"\\E63C\"}.devicon-backbone-line-wordmark.colored,.devicon-backbone-line.colored,.devicon-backbone-plain-wordmark.colored,.devicon-backbone-plain.colored{color:#002a41}.devicon-rails-plain-wordmark:before{content:\"\\E637\"}.devicon-rails-plain:before{content:\"\\E638\"}.devicon-rails-plain-wordmark.colored,.devicon-rails-plain.colored{color:#a62c46}.devicon-ruby-plain-wordmark:before{content:\"\\E635\"}.devicon-ruby-plain:before{content:\"\\E636\"}.devicon-ruby-plain-wordmark.colored,.devicon-ruby-plain.colored{color:#d91404}.devicon-dot-net-plain-wordmark:before{content:\"\\E633\"}.devicon-dot-net-plain:before{content:\"\\E634\"}.devicon-dot-net-plain-wordmark.colored,.devicon-dot-net-plain.colored{color:#1384c8}.devicon-gulp-plain:before{content:\"\\E632\"}.devicon-gulp-plain.colored{color:#eb4a4b}.devicon-zend-plain-wordmark:before{content:\"\\E600\"}.devicon-zend-plain:before{content:\"\\E601\"}.devicon-zend-plain-wordmark.colored,.devicon-zend-plain.colored{color:#68b604}.devicon-yii-plain-wordmark:before{content:\"\\E602\"}.devicon-yii-plain:before{content:\"\\E603\"}.devicon-yii-plain-wordmark.colored,.devicon-yii-plain.colored{color:#0073bb}.devicon-wordpress-plain-wordmark:before{content:\"\\E604\"}.devicon-wordpress-plain:before{content:\"\\E605\"}.devicon-wordpress-plain-wordmark.colored,.devicon-wordpress-plain.colored{color:#494949}.devicon-sass-plain:before{content:\"\\E606\"}.devicon-sass-plain.colored{color:#c69}.devicon-python-plain-wordmark:before{content:\"\\E607\"}.devicon-python-plain:before{content:\"\\E608\"}.devicon-python-plain-wordmark.colored,.devicon-python-plain.colored{color:#ffd845}.devicon-php-plain:before{content:\"\\E609\"}.devicon-php-plain.colored{color:#6181b6}.devicon-photoshop-line:before{content:\"\\E60A\"}.devicon-photoshop-plain:before{content:\"\\E60B\"}.devicon-photoshop-line.colored,.devicon-photoshop-plain.colored{color:#80b5e2}.devicon-mysql-line:before{content:\"\\E60D\"}.devicon-mysql-line-wordmark:before{content:\"\\E60C\"}.devicon-mysql-line-wordmark.colored,.devicon-mysql-line.colored{color:#00618a}.devicon-less-plain:before{content:\"\\E60E\"}.devicon-less-plain.colored{color:#2a4d80}.devicon-laravel-plain-wordmark:before{content:\"\\E60F\"}.devicon-laravel-plain:before{content:\"\\E610\"}.devicon-laravel-plain-wordmark.colored,.devicon-laravel-plain.colored{color:#fd4f31}.devicon-jquery-plain-wordmark:before{content:\"\\E611\"}.devicon-jquery-plain:before{content:\"\\E612\"}.devicon-jquery-plain-wordmark.colored,.devicon-jquery-plain.colored{color:#0769ad}.devicon-javascript-plain:before{content:\"\\E613\"}.devicon-javascript-plain.colored{color:#f0db4f}.devicon-java-line-wordmark:before{content:\"\\E614\"}.devicon-java-line:before{content:\"\\E615\"}.devicon-java-line-wordmark.colored,.devicon-java-line.colored{color:#ea2d2e}.devicon-illustrator-line:before{content:\"\\E616\"}.devicon-illustrator-plain:before{content:\"\\E617\"}.devicon-illustrator-line.colored,.devicon-illustrator-plain.colored{color:#faa625}.devicon-html5-plain-wordmark:before{content:\"\\E618\"}.devicon-html5-plain:before{content:\"\\E619\"}.devicon-html5-plain-wordmark.colored,.devicon-html5-plain.colored{color:#e54d26}.devicon-grunt-line-wordmark:before{content:\"\\E61A\"}.devicon-grunt-line:before{content:\"\\E61B\"}.devicon-grunt-plain-wordmark:before{content:\"\\E61C\"}.devicon-grunt-plain:before{content:\"\\E61D\"}.devicon-grunt-line-wordmark.colored,.devicon-grunt-line.colored,.devicon-grunt-plain-wordmark.colored,.devicon-grunt-plain.colored{color:#fcaa1a}.devicon-git-plain-wordmark:before{content:\"\\E61E\"}.devicon-git-plain:before{content:\"\\E61F\"}.devicon-git-plain-wordmark.colored,.devicon-git-plain.colored{color:#f34f29}.devicon-foundation-plain-wordmark:before{content:\"\\E620\"}.devicon-foundation-plain:before{content:\"\\E621\"}.devicon-foundation-plain-wordmark.colored,.devicon-foundation-plain.colored{color:#008cba}.devicon-devicon-line:before{content:\"\\E622\"}.devicon-devicon-plain:before{content:\"\\E623\"}.devicon-devicon-line.colored,.devicon-devicon-plain.colored{color:#60be86}.devicon-css3-plain-wordmark:before{content:\"\\E624\"}.devicon-css3-plain:before{content:\"\\E625\"}.devicon-css3-plain-wordmark.colored,.devicon-css3-plain.colored{color:#3d8fc6}.devicon-codeigniter-plain-wordmark:before{content:\"\\E626\"}.devicon-codeigniter-plain:before{content:\"\\E627\"}.devicon-codeigniter-plain-wordmark.colored,.devicon-codeigniter-plain.colored{color:#ee4323}.devicon-bower-line-wordmark:before{content:\"\\E628\"}.devicon-bower-line:before{content:\"\\E629\"}.devicon-bower-plain-wordmark:before{content:\"\\E62A\"}.devicon-bower-plain:before{content:\"\\E62B\"}.devicon-bower-line-wordmark.colored,.devicon-bower-line.colored,.devicon-bower-plain-wordmark.colored,.devicon-bower-plain.colored{color:#ef5734}.devicon-bootstrap-line-wordmark:before{content:\"\\E62C\"}.devicon-bootstrap-line:before{content:\"\\E62D\"}.devicon-bootstrap-plain-wordmark:before{content:\"\\E62E\"}.devicon-bootstrap-plain:before{content:\"\\E62F\"}.devicon-bootstrap-line-wordmark.colored,.devicon-bootstrap-line.colored,.devicon-bootstrap-plain-wordmark.colored,.devicon-bootstrap-plain.colored{color:#59407f}.devicon-angularjs-plain-wordmark:before{content:\"\\E630\"}.devicon-angularjs-plain:before{content:\"\\E631\"}.devicon-angularjs-plain-wordmark.colored,.devicon-angularjs-plain.colored{color:#c4473a}@font-face{font-family:dripicons;src:url(" + __webpack_require__("./src/styles/fonts/dripicons/dripicons.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/dripicons/dripicons.woff") + ") format(\"woff\");font-weight:400;font-style:normal}[class*=\" icon-dripicons-\"]:before,[class^=icon-dripicons-]:before{font-family:dripicons;font-style:normal;font-weight:400;font-variant:normal;text-transform:none!important;speak:none;display:inline-block;text-decoration:none;width:1em;line-height:1em;-webkit-font-smoothing:antialiased}.icon-dripicons-align-center:before{content:\"\\E000\"}.icon-dripicons-align-justify:before{content:\"\\E001\"}.icon-dripicons-align-left:before{content:\"\\E002\"}.icon-dripicons-align-right:before{content:\"\\E003\"}.icon-dripicons-arrow-down:before{content:\"\\E004\"}.icon-dripicons-arrow-left:before{content:\"\\E005\"}.icon-dripicons-arrow-thin-down:before{content:\"\\E006\"}.icon-dripicons-arrow-right:before{content:\"\\E007\"}.icon-dripicons-arrow-thin-left:before{content:\"\\E008\"}.icon-dripicons-arrow-thin-up:before{content:\"\\E009\"}.icon-dripicons-arrow-up:before{content:\"\\E010\"}.icon-dripicons-attachment:before{content:\"\\E011\"}.icon-dripicons-arrow-thin-right:before{content:\"\\E012\"}.icon-dripicons-code:before{content:\"\\E013\"}.icon-dripicons-cloud:before{content:\"\\E014\"}.icon-dripicons-chevron-right:before{content:\"\\E015\"}.icon-dripicons-chevron-up:before{content:\"\\E016\"}.icon-dripicons-chevron-down:before{content:\"\\E017\"}.icon-dripicons-chevron-left:before{content:\"\\E018\"}.icon-dripicons-camera:before{content:\"\\E019\"}.icon-dripicons-checkmark:before{content:\"\\E020\"}.icon-dripicons-calendar:before{content:\"\\E021\"}.icon-dripicons-clockwise:before{content:\"\\E022\"}.icon-dripicons-conversation:before{content:\"\\E023\"}.icon-dripicons-direction:before{content:\"\\E024\"}.icon-dripicons-cross:before{content:\"\\E025\"}.icon-dripicons-graph-line:before{content:\"\\E026\"}.icon-dripicons-gear:before{content:\"\\E027\"}.icon-dripicons-graph-bar:before{content:\"\\E028\"}.icon-dripicons-export:before{content:\"\\E029\"}.icon-dripicons-feed:before{content:\"\\E030\"}.icon-dripicons-folder:before{content:\"\\E031\"}.icon-dripicons-forward:before{content:\"\\E032\"}.icon-dripicons-folder-open:before{content:\"\\E033\"}.icon-dripicons-download:before{content:\"\\E034\"}.icon-dripicons-document-new:before{content:\"\\E035\"}.icon-dripicons-document-edit:before{content:\"\\E036\"}.icon-dripicons-document:before{content:\"\\E037\"}.icon-dripicons-gaming:before{content:\"\\E038\"}.icon-dripicons-graph-pie:before{content:\"\\E039\"}.icon-dripicons-heart:before{content:\"\\E040\"}.icon-dripicons-headset:before{content:\"\\E041\"}.icon-dripicons-help:before{content:\"\\E042\"}.icon-dripicons-information:before{content:\"\\E043\"}.icon-dripicons-loading:before{content:\"\\E044\"}.icon-dripicons-lock:before{content:\"\\E045\"}.icon-dripicons-location:before{content:\"\\E046\"}.icon-dripicons-lock-open:before{content:\"\\E047\"}.icon-dripicons-mail:before{content:\"\\E048\"}.icon-dripicons-map:before{content:\"\\E049\"}.icon-dripicons-media-loop:before{content:\"\\E050\"}.icon-dripicons-mobile-portrait:before{content:\"\\E051\"}.icon-dripicons-mobile-landscape:before{content:\"\\E052\"}.icon-dripicons-microphone:before{content:\"\\E053\"}.icon-dripicons-minus:before{content:\"\\E054\"}.icon-dripicons-message:before{content:\"\\E055\"}.icon-dripicons-menu:before{content:\"\\E056\"}.icon-dripicons-media-stop:before{content:\"\\E057\"}.icon-dripicons-media-shuffle:before{content:\"\\E058\"}.icon-dripicons-media-previous:before{content:\"\\E059\"}.icon-dripicons-media-play:before{content:\"\\E060\"}.icon-dripicons-media-next:before{content:\"\\E061\"}.icon-dripicons-media-pause:before{content:\"\\E062\"}.icon-dripicons-monitor:before{content:\"\\E063\"}.icon-dripicons-move:before{content:\"\\E064\"}.icon-dripicons-plus:before{content:\"\\E065\"}.icon-dripicons-phone:before{content:\"\\E066\"}.icon-dripicons-preview:before{content:\"\\E067\"}.icon-dripicons-print:before{content:\"\\E068\"}.icon-dripicons-media-record:before{content:\"\\E069\"}.icon-dripicons-music:before{content:\"\\E070\"}.icon-dripicons-home:before{content:\"\\E071\"}.icon-dripicons-question:before{content:\"\\E072\"}.icon-dripicons-reply:before{content:\"\\E073\"}.icon-dripicons-reply-all:before{content:\"\\E074\"}.icon-dripicons-return:before{content:\"\\E075\"}.icon-dripicons-retweet:before{content:\"\\E076\"}.icon-dripicons-search:before{content:\"\\E077\"}.icon-dripicons-view-thumb:before{content:\"\\E078\"}.icon-dripicons-view-list-large:before{content:\"\\E079\"}.icon-dripicons-view-list:before{content:\"\\E080\"}.icon-dripicons-upload:before{content:\"\\E081\"}.icon-dripicons-user-group:before{content:\"\\E082\"}.icon-dripicons-trash:before{content:\"\\E083\"}.icon-dripicons-user:before{content:\"\\E084\"}.icon-dripicons-thumbs-up:before{content:\"\\E085\"}.icon-dripicons-thumbs-down:before{content:\"\\E086\"}.icon-dripicons-tablet-portrait:before{content:\"\\E087\"}.icon-dripicons-tablet-landscape:before{content:\"\\E088\"}.icon-dripicons-tag:before{content:\"\\E089\"}.icon-dripicons-star:before{content:\"\\E090\"}.icon-dripicons-volume-full:before{content:\"\\E091\"}.icon-dripicons-volume-off:before{content:\"\\E092\"}.icon-dripicons-warning:before{content:\"\\E093\"}.icon-dripicons-window:before{content:\"\\E094\"}@font-face{font-family:feather;src:url(" + __webpack_require__("./src/styles/fonts/feather/feather.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/feather/feather.woff") + ") format(\"woff\");font-weight:400;font-style:normal}[class*=\" icon-feather-\"],[class^=icon-feather-]{display:inline-block;font-family:feather;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-feather-eye:before{content:\"\\E000\"}.icon-feather-paper-clip:before{content:\"\\E001\"}.icon-feather-mail:before{content:\"\\E002\"}.icon-feather-toggle:before{content:\"\\E003\"}.icon-feather-layout:before{content:\"\\E004\"}.icon-feather-link:before{content:\"\\E005\"}.icon-feather-bell:before{content:\"\\E006\"}.icon-feather-lock:before{content:\"\\E007\"}.icon-feather-unlock:before{content:\"\\E008\"}.icon-feather-ribbon:before{content:\"\\E009\"}.icon-feather-image:before{content:\"\\E010\"}.icon-feather-signal:before{content:\"\\E011\"}.icon-feather-target:before{content:\"\\E012\"}.icon-feather-clipboard:before{content:\"\\E013\"}.icon-feather-clock:before{content:\"\\E014\"}.icon-feather-watch:before{content:\"\\E015\"}.icon-feather-air-play:before{content:\"\\E016\"}.icon-feather-camera:before{content:\"\\E017\"}.icon-feather-video:before{content:\"\\E018\"}.icon-feather-disc:before{content:\"\\E019\"}.icon-feather-printer:before{content:\"\\E020\"}.icon-feather-monitor:before{content:\"\\E021\"}.icon-feather-server:before{content:\"\\E022\"}.icon-feather-cog:before{content:\"\\E023\"}.icon-feather-heart:before{content:\"\\E024\"}.icon-feather-paragraph:before{content:\"\\E025\"}.icon-feather-align-justify:before{content:\"\\E026\"}.icon-feather-align-left:before{content:\"\\E027\"}.icon-feather-align-center:before{content:\"\\E028\"}.icon-feather-align-right:before{content:\"\\E029\"}.icon-feather-book:before{content:\"\\E030\"}.icon-feather-layers:before{content:\"\\E031\"}.icon-feather-stack:before{content:\"\\E032\"}.icon-feather-stack-2:before{content:\"\\E033\"}.icon-feather-paper:before{content:\"\\E034\"}.icon-feather-paper-stack:before{content:\"\\E035\"}.icon-feather-search:before{content:\"\\E036\"}.icon-feather-zoom-in:before{content:\"\\E037\"}.icon-feather-zoom-out:before{content:\"\\E038\"}.icon-feather-reply:before{content:\"\\E039\"}.icon-feather-circle-plus:before{content:\"\\E040\"}.icon-feather-circle-minus:before{content:\"\\E041\"}.icon-feather-circle-check:before{content:\"\\E042\"}.icon-feather-circle-cross:before{content:\"\\E043\"}.icon-feather-square-plus:before{content:\"\\E044\"}.icon-feather-square-minus:before{content:\"\\E045\"}.icon-feather-square-check:before{content:\"\\E046\"}.icon-feather-square-cross:before{content:\"\\E047\"}.icon-feather-microphone:before{content:\"\\E048\"}.icon-feather-record:before{content:\"\\E049\"}.icon-feather-skip-back:before{content:\"\\E050\"}.icon-feather-rewind:before{content:\"\\E051\"}.icon-feather-play:before{content:\"\\E052\"}.icon-feather-pause:before{content:\"\\E053\"}.icon-feather-stop:before{content:\"\\E054\"}.icon-feather-fast-forward:before{content:\"\\E055\"}.icon-feather-skip-forward:before{content:\"\\E056\"}.icon-feather-shuffle:before{content:\"\\E057\"}.icon-feather-repeat:before{content:\"\\E058\"}.icon-feather-folder:before{content:\"\\E059\"}.icon-feather-umbrella:before{content:\"\\E060\"}.icon-feather-moon:before{content:\"\\E061\"}.icon-feather-thermometer:before{content:\"\\E062\"}.icon-feather-drop:before{content:\"\\E063\"}.icon-feather-sun:before{content:\"\\E064\"}.icon-feather-cloud:before{content:\"\\E065\"}.icon-feather-cloud-upload:before{content:\"\\E066\"}.icon-feather-cloud-download:before{content:\"\\E067\"}.icon-feather-upload:before{content:\"\\E068\"}.icon-feather-download:before{content:\"\\E069\"}.icon-feather-location:before{content:\"\\E070\"}.icon-feather-location-2:before{content:\"\\E071\"}.icon-feather-map:before{content:\"\\E072\"}.icon-feather-battery:before{content:\"\\E073\"}.icon-feather-head:before{content:\"\\E074\"}.icon-feather-briefcase:before{content:\"\\E075\"}.icon-feather-speech-bubble:before{content:\"\\E076\"}.icon-feather-anchor:before{content:\"\\E077\"}.icon-feather-globe:before{content:\"\\E078\"}.icon-feather-box:before{content:\"\\E079\"}.icon-feather-reload:before{content:\"\\E080\"}.icon-feather-share:before{content:\"\\E081\"}.icon-feather-marquee:before{content:\"\\E082\"}.icon-feather-marquee-plus:before{content:\"\\E083\"}.icon-feather-marquee-minus:before{content:\"\\E084\"}.icon-feather-tag:before{content:\"\\E085\"}.icon-feather-power:before{content:\"\\E086\"}.icon-feather-command:before{content:\"\\E087\"}.icon-feather-alt:before{content:\"\\E088\"}.icon-feather-esc:before{content:\"\\E089\"}.icon-feather-bar-graph:before{content:\"\\E090\"}.icon-feather-bar-graph-2:before{content:\"\\E091\"}.icon-feather-pie-graph:before{content:\"\\E092\"}.icon-feather-star:before{content:\"\\E093\"}.icon-feather-arrow-left:before{content:\"\\E094\"}.icon-feather-arrow-right:before{content:\"\\E095\"}.icon-feather-arrow-up:before{content:\"\\E096\"}.icon-feather-arrow-down:before{content:\"\\E097\"}.icon-feather-volume:before{content:\"\\E098\"}.icon-feather-mute:before{content:\"\\E099\"}.icon-feather-content-right:before{content:\"\\E100\"}.icon-feather-content-left:before{content:\"\\E101\"}.icon-feather-grid:before{content:\"\\E102\"}.icon-feather-grid-2:before{content:\"\\E103\"}.icon-feather-columns:before{content:\"\\E104\"}.icon-feather-loader:before{content:\"\\E105\"}.icon-feather-bag:before{content:\"\\E106\"}.icon-feather-ban:before{content:\"\\E107\"}.icon-feather-flag:before{content:\"\\E108\"}.icon-feather-trash:before{content:\"\\E109\"}.icon-feather-expand:before{content:\"\\E110\"}.icon-feather-contract:before{content:\"\\E111\"}.icon-feather-maximize:before{content:\"\\E112\"}.icon-feather-minimize:before{content:\"\\E113\"}.icon-feather-plus:before{content:\"\\E114\"}.icon-feather-minus:before{content:\"\\E115\"}.icon-feather-check:before{content:\"\\E116\"}.icon-feather-cross:before{content:\"\\E117\"}.icon-feather-move:before{content:\"\\E118\"}.icon-feather-delete:before{content:\"\\E119\"}.icon-feather-menu:before{content:\"\\E120\"}.icon-feather-archive:before{content:\"\\E121\"}.icon-feather-inbox:before{content:\"\\E122\"}.icon-feather-outbox:before{content:\"\\E123\"}.icon-feather-file:before{content:\"\\E124\"}.icon-feather-file-add:before{content:\"\\E125\"}.icon-feather-file-subtract:before{content:\"\\E126\"}.icon-feather-help:before{content:\"\\E127\"}.icon-feather-open:before{content:\"\\E128\"}.icon-feather-ellipsis:before{content:\"\\E129\"}@font-face{font-family:flatline;src:url(" + __webpack_require__("./src/styles/fonts/flatline/flatline.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/flatline/flatline.woff") + ") format(\"woff\");font-weight:400;font-style:normal}[class*=\" icon-flatline-\"],[class^=icon-flatline-]{font-family:flatline;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-flatline-download-alt:before{content:\"\\E631\"}.icon-flatline-tags:before{content:\"\\E600\"}.icon-flatline-tag:before{content:\"\\E601\"}.icon-flatline-book:before{content:\"\\E602\"}.icon-flatline-volume-up:before{content:\"\\E603\"}.icon-flatline-volume-off:before{content:\"\\E604\"}.icon-flatline-volume-down:before{content:\"\\E605\"}.icon-flatline-qrcode:before{content:\"\\E606\"}.icon-flatline-lock:before{content:\"\\E607\"}.icon-flatline-list-alt:before{content:\"\\E608\"}.icon-flatline-headphones:before{content:\"\\E609\"}.icon-flatline-flag:before{content:\"\\E60A\"}.icon-flatline-barcode:before{content:\"\\E60B\"}.icon-flatline-repeat:before{content:\"\\E60C\"}.icon-flatline-refresh:before{content:\"\\E60D\"}.icon-flatline-play-circle:before{content:\"\\E60E\"}.icon-flatline-inbox:before{content:\"\\E60F\"}.icon-flatline-zoom-out:before{content:\"\\E610\"}.icon-flatline-zoom-in:before{content:\"\\E611\"}.icon-flatline-user:before{content:\"\\E612\"}.icon-flatline-upload:before{content:\"\\E613\"}.icon-flatline-trash:before{content:\"\\E614\"}.icon-flatline-time:before{content:\"\\E615\"}.icon-flatline-th:before{content:\"\\E616\"}.icon-flatline-th-list:before{content:\"\\E617\"}.icon-flatline-th-large:before{content:\"\\E618\"}.icon-flatline-star:before{content:\"\\E619\"}.icon-flatline-star-empty:before{content:\"\\E61A\"}.icon-flatline-signal:before{content:\"\\E61B\"}.icon-flatline-search:before{content:\"\\E61C\"}.icon-flatline-road:before{content:\"\\E61D\"}.icon-flatline-remove:before{content:\"\\E61E\"}.icon-flatline-plus:before{content:\"\\E61F\"}.icon-flatline-pencil:before{content:\"\\E620\"}.icon-flatline-ok:before{content:\"\\E621\"}.icon-flatline-off:before{content:\"\\E622\"}.icon-flatline-music:before{content:\"\\E623\"}.icon-flatline-minus:before{content:\"\\E624\"}.icon-flatline-home:before{content:\"\\E625\"}.icon-flatline-heart:before{content:\"\\E626\"}.icon-flatline-heart-empty:before{content:\"\\E627\"}.icon-flatline-glass:before{content:\"\\E628\"}.icon-flatline-film:before{content:\"\\E629\"}.icon-flatline-file:before{content:\"\\E62A\"}.icon-flatline-euro:before{content:\"\\E62B\"}.icon-flatline-envelope:before{content:\"\\E62C\"}.icon-flatline-download:before{content:\"\\E62D\"}.icon-flatline-cog:before{content:\"\\E62E\"}.icon-flatline-cloud:before{content:\"\\E62F\"}.icon-flatline-asterisk:before{content:\"\\E630\"}@font-face{font-family:mfizz;src:url(" + __webpack_require__("./src/styles/fonts/mfizz/mfizz.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/mfizz/mfizz.woff") + ") format(\"woff\");font-weight:400;font-style:normal}[class*=\" icon-mfizz-\"]:before,[class^=icon-mfizz-]:before{font-family:mfizz!important;font-style:normal!important;font-weight:400!important;font-variant:normal!important;text-transform:none!important;speak:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-mfizz-microscope:before{content:\"\\F100\"}.icon-mfizz-cplusplus:before{content:\"\\F101\"}.icon-mfizz-wireless:before{content:\"\\F102\"}.icon-mfizz-fire-alt:before{content:\"\\F103\"}.icon-mfizz-mobile-device:before{content:\"\\F104\"}.icon-mfizz-objc:before{content:\"\\F105\"}.icon-mfizz-redhat:before{content:\"\\F106\"}.icon-mfizz-freebsd:before{content:\"\\F107\"}.icon-mfizz-heroku:before{content:\"\\F108\"}.icon-mfizz-python:before{content:\"\\F109\"}.icon-mfizz-java:before{content:\"\\F10A\"}.icon-mfizz-satellite:before{content:\"\\F10B\"}.icon-mfizz-debian:before{content:\"\\F10C\"}.icon-mfizz-grails:before{content:\"\\F10D\"}.icon-mfizz-c:before{content:\"\\F10E\"}.icon-mfizz-postgres:before{content:\"\\F10F\"}.icon-mfizz-database-alt2:before{content:\"\\F110\"}.icon-mfizz-raspberrypi:before{content:\"\\F111\"}.icon-mfizz-nginx:before{content:\"\\F112\"}.icon-mfizz-ruby-on-rails:before{content:\"\\F113\"}.icon-mfizz-redis:before{content:\"\\F114\"}.icon-mfizz-scala:before{content:\"\\F115\"}.icon-mfizz-gnome:before{content:\"\\F116\"}.icon-mfizz-perl:before{content:\"\\F117\"}.icon-mfizz-mysql:before{content:\"\\F118\"}.icon-mfizz-fedora:before{content:\"\\F119\"}.icon-mfizz-ghost:before{content:\"\\F11A\"}.icon-mfizz-google:before{content:\"\\F11B\"}.icon-mfizz-netbsd:before{content:\"\\F11C\"}.icon-mfizz-aws:before{content:\"\\F11D\"}.icon-mfizz-bomb:before{content:\"\\F11E\"}.icon-mfizz-looking:before{content:\"\\F11F\"}.icon-mfizz-ruby:before{content:\"\\F120\"}.icon-mfizz-mysql-alt:before{content:\"\\F121\"}.icon-mfizz-playframework-alt:before{content:\"\\F122\"}.icon-mfizz-osx:before{content:\"\\F123\"}.icon-mfizz-database:before{content:\"\\F124\"}.icon-mfizz-database-alt:before{content:\"\\F125\"}.icon-mfizz-shell:before{content:\"\\F126\"}.icon-mfizz-script:before{content:\"\\F127\"}.icon-mfizz-antenna:before{content:\"\\F128\"}.icon-mfizz-coffee-bean:before{content:\"\\F129\"}.icon-mfizz-scala-alt:before{content:\"\\F12A\"}.icon-mfizz-platter:before{content:\"\\F12B\"}.icon-mfizz-java-duke:before{content:\"\\F12C\"}.icon-mfizz-iphone:before{content:\"\\F12D\"}.icon-mfizz-script-alt:before{content:\"\\F12E\"}.icon-mfizz-google-alt:before{content:\"\\F12F\"}.icon-mfizz-haskell:before{content:\"\\F130\"}.icon-mfizz-mariadb:before{content:\"\\F131\"}.icon-mfizz-phone-retro:before{content:\"\\F132\"}.icon-mfizz-phone-alt:before{content:\"\\F133\"}.icon-mfizz-csharp:before{content:\"\\F134\"}.icon-mfizz-php:before{content:\"\\F135\"}.icon-mfizz-postgres-alt:before{content:\"\\F136\"}.icon-mfizz-html:before{content:\"\\F137\"}.icon-mfizz-mfizz:before{content:\"\\F138\"}.icon-mfizz-apache:before{content:\"\\F139\"}.icon-mfizz-hadoop:before{content:\"\\F13A\"}.icon-mfizz-ruby-on-rails-alt:before{content:\"\\F13B\"}.icon-mfizz-mobile-phone-broadcast:before{content:\"\\F13C\"}.icon-mfizz-css:before{content:\"\\F13D\"}.icon-mfizz-playframework:before{content:\"\\F13E\"}.icon-mfizz-clojure:before{content:\"\\F13F\"}.icon-mfizz-mobile-phone-alt:before{content:\"\\F140\"}.icon-mfizz-suse:before{content:\"\\F141\"}.icon-mfizz-java-bold:before{content:\"\\F142\"}.icon-mfizz-nginx-alt:before{content:\"\\F143\"}.icon-mfizz-nginx-alt2:before{content:\"\\F144\"}.icon-mfizz-linux-mint:before{content:\"\\F145\"}.icon-mfizz-dreamhost:before{content:\"\\F146\"}.icon-mfizz-blackberry:before{content:\"\\F147\"}.icon-mfizz-javascript:before{content:\"\\F148\"}.icon-mfizz-ubuntu:before{content:\"\\F149\"}.icon-mfizz-php-alt:before{content:\"\\F14A\"}.icon-mfizz-centos:before{content:\"\\F14B\"}.icon-mfizz-nodejs:before{content:\"\\F14C\"}.icon-mfizz-splatter:before{content:\"\\F14D\"}.icon-mfizz-3dprint:before{content:\"\\F14E\"}.icon-mfizz-line-graph:before{content:\"\\F14F\"}.icon-mfizz-cassandra:before{content:\"\\F150\"}.icon-mfizz-solaris:before{content:\"\\F151\"}.icon-mfizz-jetty:before{content:\"\\F152\"}.icon-mfizz-tomcat:before{content:\"\\F153\"}.icon-mfizz-oracle:before{content:\"\\F154\"}.icon-mfizz-oracle-alt:before{content:\"\\F155\"}.icon-mfizz-mssql:before{content:\"\\F156\"}.icon-mfizz-google-developers:before{content:\"\\F157\"}.icon-mfizz-google-code:before{content:\"\\F158\"}.icon-mfizz-kde:before{content:\"\\F159\"}.icon-mfizz-grails-alt:before{content:\"\\F15A\"}@font-face{font-family:icon-nargela;src:url(" + __webpack_require__("./src/styles/fonts/nargela/nargela.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/nargela/nargela.woff") + ") format(\"woff\");font-weight:400;font-style:normal}[class*=\" icon-nargela-\"]:before,[class^=icon-nargela-]:before{font-family:icon-nargela!important;font-style:normal!important;font-weight:400!important;font-variant:normal!important;text-transform:none!important;speak:none;line-height:1;display:inline-block;transform:scale(1.2);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-nargela-align-left:before{content:\"a\"}.icon-nargela-align-middle:before{content:\"b\"}.icon-nargela-align-right:before{content:\"c\"}.icon-nargela-arrow:before{content:\"d\"}.icon-nargela-battery:before{content:\"e\"}.icon-nargela-bell:before{content:\"f\"}.icon-nargela-blank:before{content:\"g\"}.icon-nargela-bluetooth:before{content:\"h\"}.icon-nargela-browser:before{content:\"i\"}.icon-nargela-camera:before{content:\"j\"}.icon-nargela-cart:before{content:\"k\"}.icon-nargela-chat:before{content:\"l\"}.icon-nargela-check-mark:before{content:\"m\"}.icon-nargela-clock:before{content:\"n\"}.icon-nargela-close:before{content:\"o\"}.icon-nargela-cocktail:before{content:\"p\"}.icon-nargela-compass:before{content:\"q\"}.icon-nargela-connection:before{content:\"r\"}.icon-nargela-cursor:before{content:\"s\"}.icon-nargela-display:before{content:\"t\"}.icon-nargela-download:before{content:\"u\"}.icon-nargela-drop:before{content:\"v\"}.icon-nargela-empty-blank:before{content:\"w\"}.icon-nargela-flag:before{content:\"x\"}.icon-nargela-forward:before{content:\"y\"}.icon-nargela-forward-2:before{content:\"z\"}.icon-nargela-gift:before{content:\"A\"}.icon-nargela-graphic:before{content:\"B\"}.icon-nargela-grid:before{content:\"C\"}.icon-nargela-hamburger-menu:before{content:\"D\"}.icon-nargela-headphones:before{content:\"E\"}.icon-nargela-heart:before{content:\"F\"}.icon-nargela-home:before{content:\"G\"}.icon-nargela-hyperlink:before{content:\"H\"}.icon-nargela-justify-all:before{content:\"I\"}.icon-nargela-key:before{content:\"J\"}.icon-nargela-label:before{content:\"K\"}.icon-nargela-launch:before{content:\"L\"}.icon-nargela-lock-closed:before{content:\"M\"}.icon-nargela-lock-open:before{content:\"N\"}.icon-nargela-magnet:before{content:\"O\"}.icon-nargela-magnifying-glass:before{content:\"P\"}.icon-nargela-magnifying-glass-2:before{content:\"Q\"}.icon-nargela-magnifying-glass-minus:before{content:\"R\"}.icon-nargela-magnifying-glass-plus:before{content:\"S\"}.icon-nargela-mail:before{content:\"T\"}.icon-nargela-map:before{content:\"U\"}.icon-nargela-map-pin:before{content:\"V\"}.icon-nargela-maximize:before{content:\"W\"}.icon-nargela-microphone:before{content:\"X\"}.icon-nargela-minimize:before{content:\"Y\"}.icon-nargela-minus:before{content:\"Z\"}.icon-nargela-mouse:before{content:\"0\"}.icon-nargela-music:before{content:\"1\"}.icon-nargela-navigation:before{content:\"2\"}.icon-nargela-notifications:before{content:\"3\"}.icon-nargela-pause:before{content:\"4\"}.icon-nargela-pencil:before{content:\"5\"}.icon-nargela-play:before{content:\"6\"}.icon-nargela-plus:before{content:\"7\"}.icon-nargela-power:before{content:\"8\"}.icon-nargela-print:before{content:\"9\"}.icon-nargela-repeat:before{content:\"!\"}.icon-nargela-rule:before{content:'\"'}.icon-nargela-selection:before{content:\"#\"}.icon-nargela-settings:before{content:\"$\"}.icon-nargela-share:before{content:\"%\"}.icon-nargela-shuffle:before{content:\"&\"}.icon-nargela-sound-minus:before{content:\"'\"}.icon-nargela-sound-plus:before{content:\"(\"}.icon-nargela-speaker:before{content:\")\"}.icon-nargela-star:before{content:\"*\"}.icon-nargela-statistics:before{content:\"+\"}.icon-nargela-stop:before{content:\",\"}.icon-nargela-sun:before{content:\"-\"}.icon-nargela-trash-bin:before{content:\".\"}.icon-nargela-umbrella:before{content:\"/\"}.icon-nargela-upload:before{content:\":\"}.icon-nargela-video-camera:before{content:\";\"}.icon-nargela-wifi:before{content:\"<\"}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__("./src/styles/fonts/glyphicons/glyphicons-webfont.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/glyphicons/glyphicons-webfont.woff") + ") format(\"woff\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}@font-face{font-family:ikons;src:url(" + __webpack_require__("./src/styles/fonts/ikons/ikons.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/ikons/ikons.woff") + ") format(\"woff\");font-weight:400;font-style:normal}[class*=\" icon-ikons-\"]:before,[class^=icon-ikons-]:before{font-family:ikons!important;font-style:normal!important;font-weight:400!important;font-variant:normal!important;text-transform:none!important;speak:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-ikons-alarm:before{content:\"a\"}.icon-ikons-alt:before{content:\"b\"}.icon-ikons-android:before{content:\"c\"}.icon-ikons-apple:before{content:\"d\"}.icon-ikons-appstore:before{content:\"e\"}.icon-ikons-arrow-1:before{content:\"f\"}.icon-ikons-arrow-2:before{content:\"g\"}.icon-ikons-arrow-down:before{content:\"h\"}.icon-ikons-arrow-left:before{content:\"i\"}.icon-ikons-arrow-right:before{content:\"j\"}.icon-ikons-arrow-up:before{content:\"k\"}.icon-ikons-arrows:before{content:\"l\"}.icon-ikons-arrows-horizontal:before{content:\"m\"}.icon-ikons-arrows-horizontal-2:before{content:\"n\"}.icon-ikons-arrows-vertical:before{content:\"o\"}.icon-ikons-arrows-vertical-2:before{content:\"p\"}.icon-ikons-bar-chart-1:before{content:\"q\"}.icon-ikons-bar-chart-2:before{content:\"r\"}.icon-ikons-bar-chart-3:before{content:\"s\"}.icon-ikons-bar-graph:before{content:\"t\"}.icon-ikons-basket:before{content:\"u\"}.icon-ikons-basket-add:before{content:\"v\"}.icon-ikons-basket-delete:before{content:\"w\"}.icon-ikons-basket-ok:before{content:\"x\"}.icon-ikons-basket-remove:before{content:\"y\"}.icon-ikons-battery-1-3:before{content:\"z\"}.icon-ikons-battery-2-3:before{content:\"A\"}.icon-ikons-battery-empty:before{content:\"B\"}.icon-ikons-battery-full:before{content:\"C\"}.icon-ikons-behance:before{content:\"D\"}.icon-ikons-bell:before{content:\"E\"}.icon-ikons-bin:before{content:\"F\"}.icon-ikons-block:before{content:\"G\"}.icon-ikons-bluetooth:before{content:\"H\"}.icon-ikons-book:before{content:\"I\"}.icon-ikons-book-1:before{content:\"J\"}.icon-ikons-book-2:before{content:\"K\"}.icon-ikons-bookmark:before{content:\"L\"}.icon-ikons-brightness-high:before{content:\"M\"}.icon-ikons-brightness-low:before{content:\"N\"}.icon-ikons-browser:before{content:\"O\"}.icon-ikons-browser-add:before{content:\"P\"}.icon-ikons-browser-delete:before{content:\"Q\"}.icon-ikons-browser-layout-1:before{content:\"R\"}.icon-ikons-browser-layout-2:before{content:\"S\"}.icon-ikons-browser-layout-3:before{content:\"T\"}.icon-ikons-browser-ok:before{content:\"U\"}.icon-ikons-browser-remove:before{content:\"V\"}.icon-ikons-bullseye:before{content:\"W\"}.icon-ikons-calendar:before{content:\"X\"}.icon-ikons-calendar-add:before{content:\"Y\"}.icon-ikons-calendar-ok:before{content:\"Z\"}.icon-ikons-camera:before{content:\"0\"}.icon-ikons-cassette:before{content:\"1\"}.icon-ikons-chart:before{content:\"2\"}.icon-ikons-chart-1-2:before{content:\"3\"}.icon-ikons-chart-1-4:before{content:\"4\"}.icon-ikons-chart-1-8:before{content:\"5\"}.icon-ikons-chart-3-4:before{content:\"6\"}.icon-ikons-chart-3-8:before{content:\"7\"}.icon-ikons-chart-5-8:before{content:\"8\"}.icon-ikons-chart-7-8:before{content:\"9\"}.icon-ikons-circle:before{content:\"!\"}.icon-ikons-circle-delete:before{content:'\"'}.icon-ikons-circle-down:before{content:\"#\"}.icon-ikons-circle-fast-forward:before{content:\"$\"}.icon-ikons-circle-left:before{content:\"%\"}.icon-ikons-circle-minus:before{content:\"&\"}.icon-ikons-circle-ok:before{content:\"'\"}.icon-ikons-circle-pause:before{content:\"(\"}.icon-ikons-circle-play:before{content:\")\"}.icon-ikons-circle-plus:before{content:\"*\"}.icon-ikons-circle-rewind:before{content:\"+\"}.icon-ikons-circle-right:before{content:\",\"}.icon-ikons-circle-skip-next:before{content:\"-\"}.icon-ikons-circle-skip-previous:before{content:\".\"}.icon-ikons-circle-stop:before{content:\"/\"}.icon-ikons-circle-up:before{content:\":\"}.icon-ikons-clip:before{content:\";\"}.icon-ikons-close:before{content:\"<\"}.icon-ikons-cloud:before{content:\"=\"}.icon-ikons-cloud-download:before{content:\">\"}.icon-ikons-cloud-fail:before{content:\"?\"}.icon-ikons-cloud-ok:before{content:\"@\"}.icon-ikons-cloud-upload:before{content:\"[\"}.icon-ikons-code:before{content:\"]\"}.icon-ikons-cog:before{content:\"^\"}.icon-ikons-columns:before{content:\"_\"}.icon-ikons-command:before{content:\"`\"}.icon-ikons-compass:before{content:\"{\"}.icon-ikons-computer-add:before{content:\"|\"}.icon-ikons-computer-delete:before{content:\"}\"}.icon-ikons-computer-download:before{content:\"~\"}.icon-ikons-computer-ok:before{content:\"\\\\\"}.icon-ikons-computer-remove:before{content:\"\\E000\"}.icon-ikons-computer-upload:before{content:\"\\E001\"}.icon-ikons-copy-1:before{content:\"\\E002\"}.icon-ikons-copy-2:before{content:\"\\E003\"}.icon-ikons-credit-card:before{content:\"\\E004\"}.icon-ikons-crop:before{content:\"\\E005\"}.icon-ikons-diskette:before{content:\"\\E006\"}.icon-ikons-document:before{content:\"\\E007\"}.icon-ikons-document-add:before{content:\"\\E008\"}.icon-ikons-document-delete:before{content:\"\\E009\"}.icon-ikons-document-download:before{content:\"\\E00A\"}.icon-ikons-document-ok:before{content:\"\\E00B\"}.icon-ikons-document-remove:before{content:\"\\E00C\"}.icon-ikons-document-upload:before{content:\"\\E00D\"}.icon-ikons-documents:before{content:\"\\E00E\"}.icon-ikons-download:before{content:\"\\E00F\"}.icon-ikons-dribbble:before{content:\"\\E010\"}.icon-ikons-drop:before{content:\"\\E011\"}.icon-ikons-dropbox:before{content:\"\\E012\"}.icon-ikons-eject:before{content:\"\\E013\"}.icon-ikons-equalizer:before{content:\"\\E014\"}.icon-ikons-facebook-1:before{content:\"\\E015\"}.icon-ikons-facebook-2:before{content:\"\\E016\"}.icon-ikons-fast-forward:before{content:\"\\E017\"}.icon-ikons-first-aid:before{content:\"\\E018\"}.icon-ikons-folder:before{content:\"\\E019\"}.icon-ikons-folder-add:before{content:\"\\E01A\"}.icon-ikons-folder-delete:before{content:\"\\E01B\"}.icon-ikons-folder-ok:before{content:\"\\E01C\"}.icon-ikons-folder-remove:before{content:\"\\E01D\"}.icon-ikons-followers:before{content:\"\\E01E\"}.icon-ikons-following:before{content:\"\\E01F\"}.icon-ikons-font-size-down:before{content:\"\\E020\"}.icon-ikons-font-size-up:before{content:\"\\E021\"}.icon-ikons-forrst:before{content:\"\\E022\"}.icon-ikons-foursquare:before{content:\"\\E023\"}.icon-ikons-frame:before{content:\"\\E024\"}.icon-ikons-globe:before{content:\"\\E025\"}.icon-ikons-google-plus:before{content:\"\\E026\"}.icon-ikons-graph-fall:before{content:\"\\E027\"}.icon-ikons-graph-rise:before{content:\"\\E028\"}.icon-ikons-grid-1:before{content:\"\\E029\"}.icon-ikons-grid-2:before{content:\"\\E02A\"}.icon-ikons-hashtag:before{content:\"\\E02B\"}.icon-ikons-heart:before{content:\"\\E02C\"}.icon-ikons-home:before{content:\"\\E02D\"}.icon-ikons-imac:before{content:\"\\E02E\"}.icon-ikons-image:before{content:\"\\E02F\"}.icon-ikons-inbox:before{content:\"\\E030\"}.icon-ikons-inbox-in:before{content:\"\\E031\"}.icon-ikons-inbox-out:before{content:\"\\E032\"}.icon-ikons-instagram:before{content:\"\\E033\"}.icon-ikons-ipad:before{content:\"\\E034\"}.icon-ikons-iphone:before{content:\"\\E035\"}.icon-ikons-layers:before{content:\"\\E036\"}.icon-ikons-line-graph:before{content:\"\\E037\"}.icon-ikons-line-graph-square:before{content:\"\\E038\"}.icon-ikons-link:before{content:\"\\E039\"}.icon-ikons-linkedin:before{content:\"\\E03A\"}.icon-ikons-list:before{content:\"\\E03B\"}.icon-ikons-list-2:before{content:\"\\E03C\"}.icon-ikons-loading:before{content:\"\\E03D\"}.icon-ikons-location:before{content:\"\\E03E\"}.icon-ikons-lock:before{content:\"\\E03F\"}.icon-ikons-login:before{content:\"\\E040\"}.icon-ikons-logout:before{content:\"\\E041\"}.icon-ikons-macbook:before{content:\"\\E042\"}.icon-ikons-magnifying-glass:before{content:\"\\E043\"}.icon-ikons-magnifying-glass-add:before{content:\"\\E044\"}.icon-ikons-magnifying-glass-remove:before{content:\"\\E045\"}.icon-ikons-mail:before{content:\"\\E046\"}.icon-ikons-mail-incoming:before{content:\"\\E047\"}.icon-ikons-mail-outgoing:before{content:\"\\E048\"}.icon-ikons-map:before{content:\"\\E049\"}.icon-ikons-map-add:before{content:\"\\E04A\"}.icon-ikons-map-delete:before{content:\"\\E04B\"}.icon-ikons-map-ok:before{content:\"\\E04C\"}.icon-ikons-map-remove:before{content:\"\\E04D\"}.icon-ikons-microphone:before{content:\"\\E04E\"}.icon-ikons-microphone-off:before{content:\"\\E04F\"}.icon-ikons-microsoft:before{content:\"\\E050\"}.icon-ikons-minus:before{content:\"\\E051\"}.icon-ikons-more:before{content:\"\\E052\"}.icon-ikons-more-2:before{content:\"\\E053\"}.icon-ikons-moustache:before{content:\"\\E054\"}.icon-ikons-music:before{content:\"\\E055\"}.icon-ikons-notepad:before{content:\"\\E056\"}.icon-ikons-notepad-add:before{content:\"\\E057\"}.icon-ikons-notepad-delete:before{content:\"\\E058\"}.icon-ikons-notepad-ok:before{content:\"\\E059\"}.icon-ikons-notepad-remove:before{content:\"\\E05A\"}.icon-ikons-pause:before{content:\"\\E05B\"}.icon-ikons-paypal:before{content:\"\\E05C\"}.icon-ikons-pen-1:before{content:\"\\E05D\"}.icon-ikons-pen-2:before{content:\"\\E05E\"}.icon-ikons-pen-3:before{content:\"\\E05F\"}.icon-ikons-picture:before{content:\"\\E060\"}.icon-ikons-pie-chart:before{content:\"\\E061\"}.icon-ikons-pill:before{content:\"\\E062\"}.icon-ikons-pin-1:before{content:\"\\E063\"}.icon-ikons-pin-2:before{content:\"\\E064\"}.icon-ikons-pin-zoom-in:before{content:\"\\E065\"}.icon-ikons-pin-zoom-out:before{content:\"\\E066\"}.icon-ikons-pinterest-1:before{content:\"\\E067\"}.icon-ikons-pinterest-2:before{content:\"\\E068\"}.icon-ikons-play:before{content:\"\\E069\"}.icon-ikons-plug:before{content:\"\\E06A\"}.icon-ikons-plus:before{content:\"\\E06B\"}.icon-ikons-polaroid:before{content:\"\\E06C\"}.icon-ikons-polaroids:before{content:\"\\E06D\"}.icon-ikons-power:before{content:\"\\E06E\"}.icon-ikons-presentation:before{content:\"\\E06F\"}.icon-ikons-printer:before{content:\"\\E070\"}.icon-ikons-progress:before{content:\"\\E071\"}.icon-ikons-record:before{content:\"\\E072\"}.icon-ikons-repeat:before{content:\"\\E073\"}.icon-ikons-repeat-1:before{content:\"\\E074\"}.icon-ikons-repeat-2:before{content:\"\\E075\"}.icon-ikons-resize-1:before{content:\"\\E076\"}.icon-ikons-resize-2:before{content:\"\\E077\"}.icon-ikons-resize-3:before{content:\"\\E078\"}.icon-ikons-resize-4:before{content:\"\\E079\"}.icon-ikons-resize-5:before{content:\"\\E07A\"}.icon-ikons-resize-6:before{content:\"\\E07B\"}.icon-ikons-rewind:before{content:\"\\E07C\"}.icon-ikons-rss:before{content:\"\\E07D\"}.icon-ikons-screen-expand-1:before{content:\"\\E07E\"}.icon-ikons-screen-expand-2:before{content:\"\\E07F\"}.icon-ikons-screen-expand-3:before{content:\"\\E080\"}.icon-ikons-share:before{content:\"\\E081\"}.icon-ikons-share-2:before{content:\"\\E082\"}.icon-ikons-shop:before{content:\"\\E083\"}.icon-ikons-shopping-bag:before{content:\"\\E084\"}.icon-ikons-shopping-cart:before{content:\"\\E085\"}.icon-ikons-shopping-cart-add:before{content:\"\\E086\"}.icon-ikons-shopping-cart-delete:before{content:\"\\E087\"}.icon-ikons-shopping-cart-ok:before{content:\"\\E088\"}.icon-ikons-shopping-cart-remove:before{content:\"\\E089\"}.icon-ikons-shuffle:before{content:\"\\E08A\"}.icon-ikons-skip-next:before{content:\"\\E08B\"}.icon-ikons-skip-previous:before{content:\"\\E08C\"}.icon-ikons-skype:before{content:\"\\E08D\"}.icon-ikons-slideshow:before{content:\"\\E08E\"}.icon-ikons-speech-1:before{content:\"\\E08F\"}.icon-ikons-speech-2:before{content:\"\\E090\"}.icon-ikons-speech-3:before{content:\"\\E091\"}.icon-ikons-speech-4:before{content:\"\\E092\"}.icon-ikons-speech-bubble-1:before{content:\"\\E093\"}.icon-ikons-speech-bubble-2:before{content:\"\\E094\"}.icon-ikons-speech-bubbles:before{content:\"\\E095\"}.icon-ikons-spotify:before{content:\"\\E096\"}.icon-ikons-square:before{content:\"\\E097\"}.icon-ikons-square-add:before{content:\"\\E098\"}.icon-ikons-square-dashed:before{content:\"\\E099\"}.icon-ikons-square-delete:before{content:\"\\E09A\"}.icon-ikons-square-down:before{content:\"\\E09B\"}.icon-ikons-square-left:before{content:\"\\E09C\"}.icon-ikons-square-ok:before{content:\"\\E09D\"}.icon-ikons-square-remove:before{content:\"\\E09E\"}.icon-ikons-square-right:before{content:\"\\E09F\"}.icon-ikons-square-up:before{content:\"\\E0A0\"}.icon-ikons-star:before{content:\"\\E0A1\"}.icon-ikons-stop:before{content:\"\\E0A2\"}.icon-ikons-suitcase:before{content:\"\\E0A3\"}.icon-ikons-tag:before{content:\"\\E0A4\"}.icon-ikons-tags:before{content:\"\\E0A5\"}.icon-ikons-target:before{content:\"\\E0A6\"}.icon-ikons-terminal:before{content:\"\\E0A7\"}.icon-ikons-text-center:before{content:\"\\E0A8\"}.icon-ikons-text-justify:before{content:\"\\E0A9\"}.icon-ikons-text-left:before{content:\"\\E0AA\"}.icon-ikons-text-right:before{content:\"\\E0AB\"}.icon-ikons-tick:before{content:\"\\E0AC\"}.icon-ikons-time:before{content:\"\\E0AD\"}.icon-ikons-timer:before{content:\"\\E0AE\"}.icon-ikons-tumblr:before{content:\"\\E0AF\"}.icon-ikons-twitter:before{content:\"\\E0B0\"}.icon-ikons-unlock:before{content:\"\\E0B1\"}.icon-ikons-upload:before{content:\"\\E0B2\"}.icon-ikons-user:before{content:\"\\E0B3\"}.icon-ikons-user-add:before{content:\"\\E0B4\"}.icon-ikons-user-circle:before{content:\"\\E0B5\"}.icon-ikons-user-delete:before{content:\"\\E0B6\"}.icon-ikons-user-ok:before{content:\"\\E0B7\"}.icon-ikons-user-remove:before{content:\"\\E0B8\"}.icon-ikons-user-square:before{content:\"\\E0B9\"}.icon-ikons-users:before{content:\"\\E0BA\"}.icon-ikons-view:before{content:\"\\E0BB\"}.icon-ikons-view-off:before{content:\"\\E0BC\"}.icon-ikons-vimeo:before{content:\"\\E0BD\"}.icon-ikons-voicemail:before{content:\"\\E0BE\"}.icon-ikons-volume-1:before{content:\"\\E0BF\"}.icon-ikons-volume-2:before{content:\"\\E0C0\"}.icon-ikons-volume-3:before{content:\"\\E0C1\"}.icon-ikons-volume-down:before{content:\"\\E0C2\"}.icon-ikons-volume-mute:before{content:\"\\E0C3\"}.icon-ikons-volume-off:before{content:\"\\E0C4\"}.icon-ikons-volume-up:before{content:\"\\E0C5\"}.icon-ikons-warning:before{content:\"\\E0C6\"}.icon-ikons-wifi-1:before{content:\"\\E0C7\"}.icon-ikons-wifi-2:before{content:\"\\E0C8\"}.icon-ikons-wifi-3:before{content:\"\\E0C9\"}.icon-ikons-windows:before{content:\"\\E0CA\"}.icon-ikons-youtube:before{content:\"\\E0CB\"}.icon-ikons-zoom-in:before{content:\"\\E0CC\"}.icon-ikons-zoom-out:before{content:\"\\E0CD\"}@font-face{font-family:outlined-iconset;src:url(" + __webpack_require__("./src/styles/fonts/outlined/outlined.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/outlined/outlined.woff") + ") format(\"woff\");font-weight:400;font-style:normal}[class*=\" icon-outlined-\"]:before,[class^=icon-outlined-]:before{font-family:outlined-iconset!important;font-style:normal!important;font-weight:400!important;font-variant:normal!important;text-transform:none!important;speak:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-outlined-boat:before{content:\"\\E000\"}.icon-outlined-booknote:before{content:\"\\E001\"}.icon-outlined-booknote-add:before{content:\"\\E002\"}.icon-outlined-booknote-remove:before{content:\"\\E003\"}.icon-outlined-camera-1:before{content:\"\\E004\"}.icon-outlined-camera-2:before{content:\"\\E005\"}.icon-outlined-cloud-check:before{content:\"\\E006\"}.icon-outlined-cloud-delete:before{content:\"\\E007\"}.icon-outlined-cloud-download:before{content:\"\\E008\"}.icon-outlined-cloud-upload:before{content:\"\\E009\"}.icon-outlined-cloudy:before{content:\"\\E00A\"}.icon-outlined-cocktail:before{content:\"\\E00B\"}.icon-outlined-coffee:before{content:\"\\E00C\"}.icon-outlined-compass:before{content:\"\\E00D\"}.icon-outlined-compress:before{content:\"\\E00E\"}.icon-outlined-cutlery:before{content:\"\\E00F\"}.icon-outlined-delete:before{content:\"\\E010\"}.icon-outlined-delete-folder:before{content:\"\\E011\"}.icon-outlined-dialogue-add:before{content:\"\\E012\"}.icon-outlined-dialogue-delete:before{content:\"\\E013\"}.icon-outlined-dialogue-happy:before{content:\"\\E014\"}.icon-outlined-dialogue-sad:before{content:\"\\E015\"}.icon-outlined-dialogue-text:before{content:\"\\E016\"}.icon-outlined-dialogue-think:before{content:\"\\E017\"}.icon-outlined-diamond:before{content:\"\\E018\"}.icon-outlined-dish-fork:before{content:\"\\E019\"}.icon-outlined-dish-spoon:before{content:\"\\E01A\"}.icon-outlined-download:before{content:\"\\E01B\"}.icon-outlined-download-folder:before{content:\"\\E01C\"}.icon-outlined-expand:before{content:\"\\E01D\"}.icon-outlined-eye:before{content:\"\\E01E\"}.icon-outlined-fast-food:before{content:\"\\E01F\"}.icon-outlined-flag:before{content:\"\\E020\"}.icon-outlined-folder:before{content:\"\\E021\"}.icon-outlined-geolocalizator:before{content:\"\\E022\"}.icon-outlined-globe:before{content:\"\\E023\"}.icon-outlined-graph:before{content:\"\\E024\"}.icon-outlined-graph-descending:before{content:\"\\E025\"}.icon-outlined-graph-rising:before{content:\"\\E026\"}.icon-outlined-hammer:before{content:\"\\E027\"}.icon-outlined-happy-drop:before{content:\"\\E028\"}.icon-outlined-headphones:before{content:\"\\E029\"}.icon-outlined-heart:before{content:\"\\E02A\"}.icon-outlined-heart-broken:before{content:\"\\E02B\"}.icon-outlined-home:before{content:\"\\E02C\"}.icon-outlined-hourglass:before{content:\"\\E02D\"}.icon-outlined-image:before{content:\"\\E02E\"}.icon-outlined-key:before{content:\"\\E02F\"}.icon-outlined-life-buoy:before{content:\"\\E030\"}.icon-outlined-list:before{content:\"\\E031\"}.icon-outlined-lock-closed:before{content:\"\\E032\"}.icon-outlined-lock-open:before{content:\"\\E033\"}.icon-outlined-loudspeaker:before{content:\"\\E034\"}.icon-outlined-magnifier:before{content:\"\\E035\"}.icon-outlined-magnifier-minus:before{content:\"\\E036\"}.icon-outlined-magnifier-plus:before{content:\"\\E037\"}.icon-outlined-mail:before{content:\"\\E038\"}.icon-outlined-mail-open:before{content:\"\\E039\"}.icon-outlined-map:before{content:\"\\E03A\"}.icon-outlined-medical-case:before{content:\"\\E03B\"}.icon-outlined-microphone-1:before{content:\"\\E03C\"}.icon-outlined-microphone-2:before{content:\"\\E03D\"}.icon-outlined-minus:before{content:\"\\E03E\"}.icon-outlined-multiple-image:before{content:\"\\E03F\"}.icon-outlined-music-back:before{content:\"\\E040\"}.icon-outlined-music-backtoend:before{content:\"\\E041\"}.icon-outlined-music-eject:before{content:\"\\E042\"}.icon-outlined-music-forward:before{content:\"\\E043\"}.icon-outlined-music-forwardtoend:before{content:\"\\E044\"}.icon-outlined-music-pause:before{content:\"\\E045\"}.icon-outlined-music-play:before{content:\"\\E046\"}.icon-outlined-music-random:before{content:\"\\E047\"}.icon-outlined-music-repeat:before{content:\"\\E048\"}.icon-outlined-music-stop:before{content:\"\\E049\"}.icon-outlined-musical-note:before{content:\"\\E04A\"}.icon-outlined-musical-note-2:before{content:\"\\E04B\"}.icon-outlined-old-video-cam:before{content:\"\\E04C\"}.icon-outlined-paper-pen:before{content:\"\\E04D\"}.icon-outlined-paper-pencil:before{content:\"\\E04E\"}.icon-outlined-paper-sheet:before{content:\"\\E04F\"}.icon-outlined-pen-pencil-ruler:before{content:\"\\E050\"}.icon-outlined-pencil:before{content:\"\\E051\"}.icon-outlined-pencil-ruler:before{content:\"\\E052\"}.icon-outlined-plus:before{content:\"\\E053\"}.icon-outlined-portable-pc:before{content:\"\\E054\"}.icon-outlined-pricetag:before{content:\"\\E055\"}.icon-outlined-printer:before{content:\"\\E056\"}.icon-outlined-profile:before{content:\"\\E057\"}.icon-outlined-profile-add:before{content:\"\\E058\"}.icon-outlined-profile-remove:before{content:\"\\E059\"}.icon-outlined-rainy:before{content:\"\\E05A\"}.icon-outlined-rotate:before{content:\"\\E05B\"}.icon-outlined-setting-1:before{content:\"\\E05C\"}.icon-outlined-setting-2:before{content:\"\\E05D\"}.icon-outlined-share:before{content:\"\\E05E\"}.icon-outlined-shield-down:before{content:\"\\E05F\"}.icon-outlined-shield-left:before{content:\"\\E060\"}.icon-outlined-shield-right:before{content:\"\\E061\"}.icon-outlined-shield-up:before{content:\"\\E062\"}.icon-outlined-shopping-cart:before{content:\"\\E063\"}.icon-outlined-shopping-cart-content:before{content:\"\\E064\"}.icon-outlined-sinth:before{content:\"\\E065\"}.icon-outlined-smartphone:before{content:\"\\E066\"}.icon-outlined-spread:before{content:\"\\E067\"}.icon-outlined-squares:before{content:\"\\E068\"}.icon-outlined-stormy:before{content:\"\\E069\"}.icon-outlined-sunny:before{content:\"\\E06A\"}.icon-outlined-tablet:before{content:\"\\E06B\"}.icon-outlined-three-stripes-horiz:before{content:\"\\E06C\"}.icon-outlined-three-stripes-vert:before{content:\"\\E06D\"}.icon-outlined-ticket:before{content:\"\\E06E\"}.icon-outlined-todolist:before{content:\"\\E06F\"}.icon-outlined-todolist-add:before{content:\"\\E070\"}.icon-outlined-todolist-check:before{content:\"\\E071\"}.icon-outlined-trash-bin:before{content:\"\\E072\"}.icon-outlined-tshirt:before{content:\"\\E073\"}.icon-outlined-tv-monitor:before{content:\"\\E074\"}.icon-outlined-umbrella:before{content:\"\\E075\"}.icon-outlined-upload:before{content:\"\\E076\"}.icon-outlined-upload-folder:before{content:\"\\E077\"}.icon-outlined-variable:before{content:\"\\E078\"}.icon-outlined-video-cam:before{content:\"\\E079\"}.icon-outlined-volume-higher:before{content:\"\\E07A\"}.icon-outlined-volume-lower:before{content:\"\\E07B\"}.icon-outlined-volume-off:before{content:\"\\E07C\"}.icon-outlined-watch:before{content:\"\\E07D\"}.icon-outlined-waterfall:before{content:\"\\E07E\"}.icon-outlined-website-1:before{content:\"\\E07F\"}.icon-outlined-website-2:before{content:\"\\E080\"}.icon-outlined-wine:before{content:\"\\E081\"}.icon-outlined-calendar:before{content:\"\\E082\"}.icon-outlined-alarm-clock:before{content:\"\\E083\"}.icon-outlined-add-folder:before{content:\"\\E084\"}.icon-outlined-accelerator:before{content:\"\\E085\"}.icon-outlined-agenda:before{content:\"\\E086\"}.icon-outlined-arrow-left:before{content:\"\\E087\"}.icon-outlined-arrow-down:before{content:\"\\E088\"}.icon-outlined-battery-1:before{content:\"\\E089\"}.icon-outlined-case:before{content:\"\\E08A\"}.icon-outlined-arrow-up:before{content:\"\\E08B\"}.icon-outlined-arrow-right:before{content:\"\\E08C\"}.icon-outlined-case-2:before{content:\"\\E08D\"}.icon-outlined-cd:before{content:\"\\E08E\"}.icon-outlined-battery-2:before{content:\"\\E08F\"}.icon-outlined-battery-3:before{content:\"\\E090\"}.icon-outlined-check:before{content:\"\\E091\"}.icon-outlined-battery-4:before{content:\"\\E092\"}.icon-outlined-chronometer:before{content:\"\\E093\"}.icon-outlined-clock:before{content:\"\\E094\"}.icon-outlined-blackboard-graph:before{content:\"\\E095\"}@font-face{font-family:pixelvicon;src:url(" + __webpack_require__("./src/styles/fonts/pixelvicon/pixelvicon.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/pixelvicon/pixelvicon.woff") + ") format(\"woff\");font-weight:400;font-style:normal}[class*=\" icon-pixelvicon-\"]:before,[class^=icon-pixelvicon-]:before{font-family:pixelvicon!important;font-style:normal!important;font-weight:400!important;font-variant:normal!important;text-transform:none!important;speak:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-pixelvicon-browser-1:before{content:\"a\"}.icon-pixelvicon-browser-2:before{content:\"b\"}.icon-pixelvicon-browser-3:before{content:\"c\"}.icon-pixelvicon-browser-4:before{content:\"d\"}.icon-pixelvicon-browser-5:before{content:\"e\"}.icon-pixelvicon-browser-6:before{content:\"f\"}.icon-pixelvicon-imac:before{content:\"g\"}.icon-pixelvicon-laptop:before{content:\"h\"}.icon-pixelvicon-monitor:before{content:\"i\"}.icon-pixelvicon-pc-case:before{content:\"j\"}.icon-pixelvicon-tablet-1:before{content:\"k\"}.icon-pixelvicon-tablet-2:before{content:\"l\"}.icon-pixelvicon-tablet-3:before{content:\"m\"}.icon-pixelvicon-tablet-4:before{content:\"n\"}.icon-pixelvicon-smart-phone-1:before{content:\"o\"}.icon-pixelvicon-smart-phone-2:before{content:\"p\"}.icon-pixelvicon-smart-phone-3:before{content:\"q\"}.icon-pixelvicon-smart-phone-4:before{content:\"r\"}.icon-pixelvicon-printer:before{content:\"s\"}.icon-pixelvicon-calculator:before{content:\"t\"}.icon-pixelvicon-keyboard:before{content:\"u\"}.icon-pixelvicon-mouse:before{content:\"v\"}.icon-pixelvicon-video-game-controller:before{content:\"w\"}.icon-pixelvicon-floppy-disk:before{content:\"x\"}.icon-pixelvicon-coffee:before{content:\"y\"}.icon-pixelvicon-mug:before{content:\"z\"}.icon-pixelvicon-briefcase-1:before{content:\"A\"}.icon-pixelvicon-briefcase-2:before{content:\"B\"}.icon-pixelvicon-briefcase-3:before{content:\"C\"}.icon-pixelvicon-first-aid:before{content:\"D\"}.icon-pixelvicon-shopping-bag:before{content:\"E\"}.icon-pixelvicon-gift:before{content:\"F\"}.icon-pixelvicon-notepad-1:before{content:\"G\"}.icon-pixelvicon-notepad-2:before{content:\"H\"}.icon-pixelvicon-list-1:before{content:\"I\"}.icon-pixelvicon-list-2:before{content:\"J\"}.icon-pixelvicon-list-3:before{content:\"K\"}.icon-pixelvicon-book:before{content:\"L\"}.icon-pixelvicon-calendar-1:before{content:\"M\"}.icon-pixelvicon-calendar-2:before{content:\"N\"}.icon-pixelvicon-notebook:before{content:\"O\"}.icon-pixelvicon-ruler:before{content:\"P\"}.icon-pixelvicon-pen-1:before{content:\"Q\"}.icon-pixelvicon-pen-2:before{content:\"R\"}.icon-pixelvicon-document-1:before{content:\"S\"}.icon-pixelvicon-document-2:before{content:\"T\"}.icon-pixelvicon-document-3:before{content:\"U\"}.icon-pixelvicon-film:before{content:\"V\"}.icon-pixelvicon-photo-gallery:before{content:\"W\"}.icon-pixelvicon-clock:before{content:\"X\"}.icon-pixelvicon-cupboard:before{content:\"Y\"}.icon-pixelvicon-drawer:before{content:\"Z\"}.icon-pixelvicon-dresser:before{content:\"0\"}.icon-pixelvicon-chair:before{content:\"1\"}.icon-pixelvicon-sofa:before{content:\"2\"}.icon-pixelvicon-desk:before{content:\"3\"}.icon-pixelvicon-table:before{content:\"4\"}.icon-pixelvicon-door:before{content:\"5\"}.icon-pixelvicon-window:before{content:\"6\"}.icon-pixelvicon-brick-wall:before{content:\"7\"}.icon-pixelvicon-trash-1:before{content:\"8\"}.icon-pixelvicon-trash-2:before{content:\"9\"}.icon-pixelvicon-lock:before{content:\"!\"}.icon-pixelvicon-unlock:before{content:'\"'}.icon-pixelvicon-plus:before{content:\"#\"}.icon-pixelvicon-minus:before{content:\"$\"}.icon-pixelvicon-battery-1:before{content:\"%\"}.icon-pixelvicon-battery-2:before{content:\"&\"}.icon-pixelvicon-battery-3:before{content:\"'\"}.icon-pixelvicon-battery-4:before{content:\"(\"}.icon-pixelvicon-transform:before{content:\")\"}.icon-pixelvicon-resize:before{content:\"*\"}.icon-pixelvicon-grid:before{content:\"+\"}.icon-pixelvicon-menu:before{content:\",\"}.icon-pixelvicon-fullscreen:before{content:\"-\"}.icon-pixelvicon-outline:before{content:\".\"}.icon-pixelvicon-align-left:before{content:\"/\"}.icon-pixelvicon-align-center:before{content:\":\"}.icon-pixelvicon-align-right:before{content:\";\"}.icon-pixelvicon-align-justify:before{content:\"<\"}@font-face{font-family:Simple-Line-Icons;src:url(" + __webpack_require__("./src/styles/fonts/Simple-Line-Icons/Simple-Line-Icons.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/Simple-Line-Icons/Simple-Line-Icons.woff") + ") format(\"woff\");font-weight:400;font-style:normal}[class*=\" icon-simple-line-icons-\"]:before,[class^=icon-simple-line-icons-]:before{font-family:Simple-Line-Icons;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased}.icon-simple-line-icons-user-female:before{content:\"\\E000\"}.icon-simple-line-icons-user-follow:before{content:\"\\E002\"}.icon-simple-line-icons-user-following:before{content:\"\\E003\"}.icon-simple-line-icons-user-unfollow:before{content:\"\\E004\"}.icon-simple-line-icons-trophy:before{content:\"\\E006\"}.icon-simple-line-icons-screen-smartphone:before{content:\"\\E010\"}.icon-simple-line-icons-screen-desktop:before{content:\"\\E011\"}.icon-simple-line-icons-plane:before{content:\"\\E012\"}.icon-simple-line-icons-notebook:before{content:\"\\E013\"}.icon-simple-line-icons-moustache:before{content:\"\\E014\"}.icon-simple-line-icons-mouse:before{content:\"\\E015\"}.icon-simple-line-icons-magnet:before{content:\"\\E016\"}.icon-simple-line-icons-energy:before{content:\"\\E020\"}.icon-simple-line-icons-emoticon-smile:before{content:\"\\E021\"}.icon-simple-line-icons-disc:before{content:\"\\E022\"}.icon-simple-line-icons-cursor-move:before{content:\"\\E023\"}.icon-simple-line-icons-crop:before{content:\"\\E024\"}.icon-simple-line-icons-credit-card:before{content:\"\\E025\"}.icon-simple-line-icons-chemistry:before{content:\"\\E026\"}.icon-simple-line-icons-user:before{content:\"\\E005\"}.icon-simple-line-icons-speedometer:before{content:\"\\E007\"}.icon-simple-line-icons-social-youtube:before{content:\"\\E008\"}.icon-simple-line-icons-social-twitter:before{content:\"\\E009\"}.icon-simple-line-icons-social-tumblr:before{content:\"\\E00A\"}.icon-simple-line-icons-social-facebook:before{content:\"\\E00B\"}.icon-simple-line-icons-social-dropbox:before{content:\"\\E00C\"}.icon-simple-line-icons-social-dribbble:before{content:\"\\E00D\"}.icon-simple-line-icons-shield:before{content:\"\\E00E\"}.icon-simple-line-icons-screen-tablet:before{content:\"\\E00F\"}.icon-simple-line-icons-magic-wand:before{content:\"\\E017\"}.icon-simple-line-icons-hourglass:before{content:\"\\E018\"}.icon-simple-line-icons-graduation:before{content:\"\\E019\"}.icon-simple-line-icons-ghost:before{content:\"\\E01A\"}.icon-simple-line-icons-game-controller:before{content:\"\\E01B\"}.icon-simple-line-icons-fire:before{content:\"\\E01C\"}.icon-simple-line-icons-eyeglasses:before{content:\"\\E01D\"}.icon-simple-line-icons-envelope-open:before{content:\"\\E01E\"}.icon-simple-line-icons-envelope-letter:before{content:\"\\E01F\"}.icon-simple-line-icons-bell:before{content:\"\\E027\"}.icon-simple-line-icons-badge:before{content:\"\\E028\"}.icon-simple-line-icons-anchor:before{content:\"\\E029\"}.icon-simple-line-icons-wallet:before{content:\"\\E02A\"}.icon-simple-line-icons-vector:before{content:\"\\E02B\"}.icon-simple-line-icons-speech:before{content:\"\\E02C\"}.icon-simple-line-icons-puzzle:before{content:\"\\E02D\"}.icon-simple-line-icons-printer:before{content:\"\\E02E\"}.icon-simple-line-icons-present:before{content:\"\\E02F\"}.icon-simple-line-icons-playlist:before{content:\"\\E030\"}.icon-simple-line-icons-pin:before{content:\"\\E031\"}.icon-simple-line-icons-picture:before{content:\"\\E032\"}.icon-simple-line-icons-map:before{content:\"\\E033\"}.icon-simple-line-icons-layers:before{content:\"\\E034\"}.icon-simple-line-icons-handbag:before{content:\"\\E035\"}.icon-simple-line-icons-globe-alt:before{content:\"\\E036\"}.icon-simple-line-icons-globe:before{content:\"\\E037\"}.icon-simple-line-icons-frame:before{content:\"\\E038\"}.icon-simple-line-icons-folder-alt:before{content:\"\\E039\"}.icon-simple-line-icons-film:before{content:\"\\E03A\"}.icon-simple-line-icons-feed:before{content:\"\\E03B\"}.icon-simple-line-icons-earphones-alt:before{content:\"\\E03C\"}.icon-simple-line-icons-earphones:before{content:\"\\E03D\"}.icon-simple-line-icons-drop:before{content:\"\\E03E\"}.icon-simple-line-icons-drawer:before{content:\"\\E03F\"}.icon-simple-line-icons-docs:before{content:\"\\E040\"}.icon-simple-line-icons-directions:before{content:\"\\E041\"}.icon-simple-line-icons-direction:before{content:\"\\E042\"}.icon-simple-line-icons-diamond:before{content:\"\\E043\"}.icon-simple-line-icons-cup:before{content:\"\\E044\"}.icon-simple-line-icons-compass:before{content:\"\\E045\"}.icon-simple-line-icons-call-out:before{content:\"\\E046\"}.icon-simple-line-icons-call-in:before{content:\"\\E047\"}.icon-simple-line-icons-call-end:before{content:\"\\E048\"}.icon-simple-line-icons-calculator:before{content:\"\\E049\"}.icon-simple-line-icons-bubbles:before{content:\"\\E04A\"}.icon-simple-line-icons-briefcase:before{content:\"\\E04B\"}.icon-simple-line-icons-book-open:before{content:\"\\E04C\"}.icon-simple-line-icons-basket-loaded:before{content:\"\\E04D\"}.icon-simple-line-icons-basket:before{content:\"\\E04E\"}.icon-simple-line-icons-bag:before{content:\"\\E04F\"}.icon-simple-line-icons-action-undo:before{content:\"\\E050\"}.icon-simple-line-icons-action-redo:before{content:\"\\E051\"}.icon-simple-line-icons-wrench:before{content:\"\\E052\"}.icon-simple-line-icons-umbrella:before{content:\"\\E053\"}.icon-simple-line-icons-trash:before{content:\"\\E054\"}.icon-simple-line-icons-tag:before{content:\"\\E055\"}.icon-simple-line-icons-support:before{content:\"\\E056\"}.icon-simple-line-icons-size-fullscreen:before{content:\"\\E057\"}.icon-simple-line-icons-size-actual:before{content:\"\\E058\"}.icon-simple-line-icons-shuffle:before{content:\"\\E059\"}.icon-simple-line-icons-share-alt:before{content:\"\\E05A\"}.icon-simple-line-icons-share:before{content:\"\\E05B\"}.icon-simple-line-icons-rocket:before{content:\"\\E05C\"}.icon-simple-line-icons-question:before{content:\"\\E05D\"}.icon-simple-line-icons-pie-chart:before{content:\"\\E05E\"}.icon-simple-line-icons-pencil:before{content:\"\\E05F\"}.icon-simple-line-icons-note:before{content:\"\\E060\"}.icon-simple-line-icons-music-tone-alt:before{content:\"\\E061\"}.icon-simple-line-icons-music-tone:before{content:\"\\E062\"}.icon-simple-line-icons-microphone:before{content:\"\\E063\"}.icon-simple-line-icons-loop:before{content:\"\\E064\"}.icon-simple-line-icons-logout:before{content:\"\\E065\"}.icon-simple-line-icons-login:before{content:\"\\E066\"}.icon-simple-line-icons-list:before{content:\"\\E067\"}.icon-simple-line-icons-like:before{content:\"\\E068\"}.icon-simple-line-icons-home:before{content:\"\\E069\"}.icon-simple-line-icons-grid:before{content:\"\\E06A\"}.icon-simple-line-icons-graph:before{content:\"\\E06B\"}.icon-simple-line-icons-equalizer:before{content:\"\\E06C\"}.icon-simple-line-icons-dislike:before{content:\"\\E06D\"}.icon-simple-line-icons-cursor:before{content:\"\\E06E\"}.icon-simple-line-icons-control-start:before{content:\"\\E06F\"}.icon-simple-line-icons-control-rewind:before{content:\"\\E070\"}.icon-simple-line-icons-control-play:before{content:\"\\E071\"}.icon-simple-line-icons-control-pause:before{content:\"\\E072\"}.icon-simple-line-icons-control-forward:before{content:\"\\E073\"}.icon-simple-line-icons-control-end:before{content:\"\\E074\"}.icon-simple-line-icons-calendar:before{content:\"\\E075\"}.icon-simple-line-icons-bulb:before{content:\"\\E076\"}.icon-simple-line-icons-bar-chart:before{content:\"\\E077\"}.icon-simple-line-icons-arrow-up:before{content:\"\\E078\"}.icon-simple-line-icons-arrow-right:before{content:\"\\E079\"}.icon-simple-line-icons-arrow-left:before{content:\"\\E07A\"}.icon-simple-line-icons-arrow-down:before{content:\"\\E07B\"}.icon-simple-line-icons-ban:before{content:\"\\E07C\"}.icon-simple-line-icons-bubble:before{content:\"\\E07D\"}.icon-simple-line-icons-camcorder:before{content:\"\\E07E\"}.icon-simple-line-icons-camera:before{content:\"\\E07F\"}.icon-simple-line-icons-check:before{content:\"\\E080\"}.icon-simple-line-icons-clock:before{content:\"\\E081\"}.icon-simple-line-icons-close:before{content:\"\\E082\"}.icon-simple-line-icons-cloud-download:before{content:\"\\E083\"}.icon-simple-line-icons-cloud-upload:before{content:\"\\E084\"}.icon-simple-line-icons-doc:before{content:\"\\E085\"}.icon-simple-line-icons-envelope:before{content:\"\\E086\"}.icon-simple-line-icons-eye:before{content:\"\\E087\"}.icon-simple-line-icons-flag:before{content:\"\\E088\"}.icon-simple-line-icons-folder:before{content:\"\\E089\"}.icon-simple-line-icons-heart:before{content:\"\\E08A\"}.icon-simple-line-icons-info:before{content:\"\\E08B\"}.icon-simple-line-icons-key:before{content:\"\\E08C\"}.icon-simple-line-icons-link:before{content:\"\\E08D\"}.icon-simple-line-icons-lock:before{content:\"\\E08E\"}.icon-simple-line-icons-lock-open:before{content:\"\\E08F\"}.icon-simple-line-icons-magnifier:before{content:\"\\E090\"}.icon-simple-line-icons-magnifier-add:before{content:\"\\E091\"}.icon-simple-line-icons-magnifier-remove:before{content:\"\\E092\"}.icon-simple-line-icons-paper-clip:before{content:\"\\E093\"}.icon-simple-line-icons-paper-plane:before{content:\"\\E094\"}.icon-simple-line-icons-plus:before{content:\"\\E095\"}.icon-simple-line-icons-pointer:before{content:\"\\E096\"}.icon-simple-line-icons-power:before{content:\"\\E097\"}.icon-simple-line-icons-refresh:before{content:\"\\E098\"}.icon-simple-line-icons-reload:before{content:\"\\E099\"}.icon-simple-line-icons-settings:before{content:\"\\E09A\"}.icon-simple-line-icons-star:before{content:\"\\E09B\"}.icon-simple-line-icons-symbol-female:before{content:\"\\E09C\"}.icon-simple-line-icons-symbol-male:before{content:\"\\E09D\"}.icon-simple-line-icons-target:before{content:\"\\E09E\"}.icon-simple-line-icons-volume-1:before{content:\"\\E09F\"}.icon-simple-line-icons-volume-2:before{content:\"\\E0A0\"}.icon-simple-line-icons-volume-off:before{content:\"\\E0A1\"}.icon-simple-line-icons-users:before{content:\"\\E001\"}@font-face{font-family:Stroke-Gap-Icons;src:url(" + __webpack_require__("./src/styles/fonts/Stroke-Gap-Icons/Stroke-Gap-Icons.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./src/styles/fonts/Stroke-Gap-Icons/Stroke-Gap-Icons.woff") + ") format(\"woff\");font-weight:400;font-style:normal}[class*=\" icon-stroke-gap-icons-\"]:before,[class^=icon-stroke-gap-icons-]:before{font-family:Stroke-Gap-Icons;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-stroke-gap-icons-WorldWide:before{content:\"\\E600\"}.icon-stroke-gap-icons-WorldGlobe:before{content:\"\\E601\"}.icon-stroke-gap-icons-Underpants:before{content:\"\\E602\"}.icon-stroke-gap-icons-Tshirt:before{content:\"\\E603\"}.icon-stroke-gap-icons-Trousers:before{content:\"\\E604\"}.icon-stroke-gap-icons-Tie:before{content:\"\\E605\"}.icon-stroke-gap-icons-TennisBall:before{content:\"\\E606\"}.icon-stroke-gap-icons-Telesocpe:before{content:\"\\E607\"}.icon-stroke-gap-icons-Stop:before{content:\"\\E608\"}.icon-stroke-gap-icons-Starship:before{content:\"\\E609\"}.icon-stroke-gap-icons-Starship2:before{content:\"\\E60A\"}.icon-stroke-gap-icons-Speaker:before{content:\"\\E60B\"}.icon-stroke-gap-icons-Speaker2:before{content:\"\\E60C\"}.icon-stroke-gap-icons-Soccer:before{content:\"\\E60D\"}.icon-stroke-gap-icons-Snikers:before{content:\"\\E60E\"}.icon-stroke-gap-icons-Scisors:before{content:\"\\E60F\"}.icon-stroke-gap-icons-Puzzle:before{content:\"\\E610\"}.icon-stroke-gap-icons-Printer:before{content:\"\\E611\"}.icon-stroke-gap-icons-Pool:before{content:\"\\E612\"}.icon-stroke-gap-icons-Podium:before{content:\"\\E613\"}.icon-stroke-gap-icons-Play:before{content:\"\\E614\"}.icon-stroke-gap-icons-Planet:before{content:\"\\E615\"}.icon-stroke-gap-icons-Pause:before{content:\"\\E616\"}.icon-stroke-gap-icons-Next:before{content:\"\\E617\"}.icon-stroke-gap-icons-MusicNote2:before{content:\"\\E618\"}.icon-stroke-gap-icons-MusicNote:before{content:\"\\E619\"}.icon-stroke-gap-icons-MusicMixer:before{content:\"\\E61A\"}.icon-stroke-gap-icons-Microphone:before{content:\"\\E61B\"}.icon-stroke-gap-icons-Medal:before{content:\"\\E61C\"}.icon-stroke-gap-icons-ManFigure:before{content:\"\\E61D\"}.icon-stroke-gap-icons-Magnet:before{content:\"\\E61E\"}.icon-stroke-gap-icons-Like:before{content:\"\\E61F\"}.icon-stroke-gap-icons-Hanger:before{content:\"\\E620\"}.icon-stroke-gap-icons-Handicap:before{content:\"\\E621\"}.icon-stroke-gap-icons-Forward:before{content:\"\\E622\"}.icon-stroke-gap-icons-Footbal:before{content:\"\\E623\"}.icon-stroke-gap-icons-Flag:before{content:\"\\E624\"}.icon-stroke-gap-icons-FemaleFigure:before{content:\"\\E625\"}.icon-stroke-gap-icons-Dislike:before{content:\"\\E626\"}.icon-stroke-gap-icons-DiamondRing:before{content:\"\\E627\"}.icon-stroke-gap-icons-Cup:before{content:\"\\E628\"}.icon-stroke-gap-icons-Crown:before{content:\"\\E629\"}.icon-stroke-gap-icons-Column:before{content:\"\\E62A\"}.icon-stroke-gap-icons-Click:before{content:\"\\E62B\"}.icon-stroke-gap-icons-Cassette:before{content:\"\\E62C\"}.icon-stroke-gap-icons-Bomb:before{content:\"\\E62D\"}.icon-stroke-gap-icons-BatteryLow:before{content:\"\\E62E\"}.icon-stroke-gap-icons-BatteryFull:before{content:\"\\E62F\"}.icon-stroke-gap-icons-Bascketball:before{content:\"\\E630\"}.icon-stroke-gap-icons-Astronaut:before{content:\"\\E631\"}.icon-stroke-gap-icons-WineGlass:before{content:\"\\E632\"}.icon-stroke-gap-icons-Water:before{content:\"\\E633\"}.icon-stroke-gap-icons-Wallet:before{content:\"\\E634\"}.icon-stroke-gap-icons-Umbrella:before{content:\"\\E635\"}.icon-stroke-gap-icons-TV:before{content:\"\\E636\"}.icon-stroke-gap-icons-TeaMug:before{content:\"\\E637\"}.icon-stroke-gap-icons-Tablet:before{content:\"\\E638\"}.icon-stroke-gap-icons-Soda:before{content:\"\\E639\"}.icon-stroke-gap-icons-SodaCan:before{content:\"\\E63A\"}.icon-stroke-gap-icons-SimCard:before{content:\"\\E63B\"}.icon-stroke-gap-icons-Signal:before{content:\"\\E63C\"}.icon-stroke-gap-icons-Shaker:before{content:\"\\E63D\"}.icon-stroke-gap-icons-Radio:before{content:\"\\E63E\"}.icon-stroke-gap-icons-Pizza:before{content:\"\\E63F\"}.icon-stroke-gap-icons-Phone:before{content:\"\\E640\"}.icon-stroke-gap-icons-Notebook:before{content:\"\\E641\"}.icon-stroke-gap-icons-Mug:before{content:\"\\E642\"}.icon-stroke-gap-icons-Mastercard:before{content:\"\\E643\"}.icon-stroke-gap-icons-Ipod:before{content:\"\\E644\"}.icon-stroke-gap-icons-Info:before{content:\"\\E645\"}.icon-stroke-gap-icons-Icecream2:before{content:\"\\E646\"}.icon-stroke-gap-icons-Icecream1:before{content:\"\\E647\"}.icon-stroke-gap-icons-Hourglass:before{content:\"\\E648\"}.icon-stroke-gap-icons-Help:before{content:\"\\E649\"}.icon-stroke-gap-icons-Goto:before{content:\"\\E64A\"}.icon-stroke-gap-icons-Glasses:before{content:\"\\E64B\"}.icon-stroke-gap-icons-Gameboy:before{content:\"\\E64C\"}.icon-stroke-gap-icons-ForkandKnife:before{content:\"\\E64D\"}.icon-stroke-gap-icons-Export:before{content:\"\\E64E\"}.icon-stroke-gap-icons-Exit:before{content:\"\\E64F\"}.icon-stroke-gap-icons-Espresso:before{content:\"\\E650\"}.icon-stroke-gap-icons-Drop:before{content:\"\\E651\"}.icon-stroke-gap-icons-Download:before{content:\"\\E652\"}.icon-stroke-gap-icons-Dollars:before{content:\"\\E653\"}.icon-stroke-gap-icons-Dollar:before{content:\"\\E654\"}.icon-stroke-gap-icons-DesktopMonitor:before{content:\"\\E655\"}.icon-stroke-gap-icons-Corkscrew:before{content:\"\\E656\"}.icon-stroke-gap-icons-CoffeeToGo:before{content:\"\\E657\"}.icon-stroke-gap-icons-Chart:before{content:\"\\E658\"}.icon-stroke-gap-icons-ChartUp:before{content:\"\\E659\"}.icon-stroke-gap-icons-ChartDown:before{content:\"\\E65A\"}.icon-stroke-gap-icons-Calculator:before{content:\"\\E65B\"}.icon-stroke-gap-icons-Bread:before{content:\"\\E65C\"}.icon-stroke-gap-icons-Bourbon:before{content:\"\\E65D\"}.icon-stroke-gap-icons-BottleofWIne:before{content:\"\\E65E\"}.icon-stroke-gap-icons-Bag:before{content:\"\\E65F\"}.icon-stroke-gap-icons-Arrow:before{content:\"\\E660\"}.icon-stroke-gap-icons-Antenna2:before{content:\"\\E661\"}.icon-stroke-gap-icons-Antenna1:before{content:\"\\E662\"}.icon-stroke-gap-icons-Anchor:before{content:\"\\E663\"}.icon-stroke-gap-icons-Wheelbarrow:before{content:\"\\E664\"}.icon-stroke-gap-icons-Webcam:before{content:\"\\E665\"}.icon-stroke-gap-icons-Unlinked:before{content:\"\\E666\"}.icon-stroke-gap-icons-Truck:before{content:\"\\E667\"}.icon-stroke-gap-icons-Timer:before{content:\"\\E668\"}.icon-stroke-gap-icons-Time:before{content:\"\\E669\"}.icon-stroke-gap-icons-StorageBox:before{content:\"\\E66A\"}.icon-stroke-gap-icons-Star:before{content:\"\\E66B\"}.icon-stroke-gap-icons-ShoppingCart:before{content:\"\\E66C\"}.icon-stroke-gap-icons-Shield:before{content:\"\\E66D\"}.icon-stroke-gap-icons-Seringe:before{content:\"\\E66E\"}.icon-stroke-gap-icons-Pulse:before{content:\"\\E66F\"}.icon-stroke-gap-icons-Plaster:before{content:\"\\E670\"}.icon-stroke-gap-icons-Plaine:before{content:\"\\E671\"}.icon-stroke-gap-icons-Pill:before{content:\"\\E672\"}.icon-stroke-gap-icons-PicnicBasket:before{content:\"\\E673\"}.icon-stroke-gap-icons-Phone2:before{content:\"\\E674\"}.icon-stroke-gap-icons-Pencil:before{content:\"\\E675\"}.icon-stroke-gap-icons-Pen:before{content:\"\\E676\"}.icon-stroke-gap-icons-PaperClip:before{content:\"\\E677\"}.icon-stroke-gap-icons-On-Off:before{content:\"\\E678\"}.icon-stroke-gap-icons-Mouse:before{content:\"\\E679\"}.icon-stroke-gap-icons-Megaphone:before{content:\"\\E67A\"}.icon-stroke-gap-icons-Linked:before{content:\"\\E67B\"}.icon-stroke-gap-icons-Keyboard:before{content:\"\\E67C\"}.icon-stroke-gap-icons-House:before{content:\"\\E67D\"}.icon-stroke-gap-icons-Heart:before{content:\"\\E67E\"}.icon-stroke-gap-icons-Headset:before{content:\"\\E67F\"}.icon-stroke-gap-icons-FullShoppingCart:before{content:\"\\E680\"}.icon-stroke-gap-icons-FullScreen:before{content:\"\\E681\"}.icon-stroke-gap-icons-Folder:before{content:\"\\E682\"}.icon-stroke-gap-icons-Floppy:before{content:\"\\E683\"}.icon-stroke-gap-icons-Files:before{content:\"\\E684\"}.icon-stroke-gap-icons-File:before{content:\"\\E685\"}.icon-stroke-gap-icons-FileBox:before{content:\"\\E686\"}.icon-stroke-gap-icons-ExitFullScreen:before{content:\"\\E687\"}.icon-stroke-gap-icons-EmptyBox:before{content:\"\\E688\"}.icon-stroke-gap-icons-Delete:before{content:\"\\E689\"}.icon-stroke-gap-icons-Controller:before{content:\"\\E68A\"}.icon-stroke-gap-icons-Compass:before{content:\"\\E68B\"}.icon-stroke-gap-icons-CompassTool:before{content:\"\\E68C\"}.icon-stroke-gap-icons-ClipboardText:before{content:\"\\E68D\"}.icon-stroke-gap-icons-ClipboardChart:before{content:\"\\E68E\"}.icon-stroke-gap-icons-ChemicalGlass:before{content:\"\\E68F\"}.icon-stroke-gap-icons-CD:before{content:\"\\E690\"}.icon-stroke-gap-icons-Carioca:before{content:\"\\E691\"}.icon-stroke-gap-icons-Car:before{content:\"\\E692\"}.icon-stroke-gap-icons-Book:before{content:\"\\E693\"}.icon-stroke-gap-icons-BigTruck:before{content:\"\\E694\"}.icon-stroke-gap-icons-Bicycle:before{content:\"\\E695\"}.icon-stroke-gap-icons-Wrench:before{content:\"\\E696\"}.icon-stroke-gap-icons-Web:before{content:\"\\E697\"}.icon-stroke-gap-icons-Watch:before{content:\"\\E698\"}.icon-stroke-gap-icons-Volume:before{content:\"\\E699\"}.icon-stroke-gap-icons-Video:before{content:\"\\E69A\"}.icon-stroke-gap-icons-Users:before{content:\"\\E69B\"}.icon-stroke-gap-icons-User:before{content:\"\\E69C\"}.icon-stroke-gap-icons-UploadCLoud:before{content:\"\\E69D\"}.icon-stroke-gap-icons-Typing:before{content:\"\\E69E\"}.icon-stroke-gap-icons-Tools:before{content:\"\\E69F\"}.icon-stroke-gap-icons-Tag:before{content:\"\\E6A0\"}.icon-stroke-gap-icons-Speedometter:before{content:\"\\E6A1\"}.icon-stroke-gap-icons-Share:before{content:\"\\E6A2\"}.icon-stroke-gap-icons-Settings:before{content:\"\\E6A3\"}.icon-stroke-gap-icons-Search:before{content:\"\\E6A4\"}.icon-stroke-gap-icons-Screwdriver:before{content:\"\\E6A5\"}.icon-stroke-gap-icons-Rolodex:before{content:\"\\E6A6\"}.icon-stroke-gap-icons-Ringer:before{content:\"\\E6A7\"}.icon-stroke-gap-icons-Resume:before{content:\"\\E6A8\"}.icon-stroke-gap-icons-Restart:before{content:\"\\E6A9\"}.icon-stroke-gap-icons-PowerOff:before{content:\"\\E6AA\"}.icon-stroke-gap-icons-Pointer:before{content:\"\\E6AB\"}.icon-stroke-gap-icons-Picture:before{content:\"\\E6AC\"}.icon-stroke-gap-icons-OpenedLock:before{content:\"\\E6AD\"}.icon-stroke-gap-icons-Notes:before{content:\"\\E6AE\"}.icon-stroke-gap-icons-Mute:before{content:\"\\E6AF\"}.icon-stroke-gap-icons-Movie:before{content:\"\\E6B0\"}.icon-stroke-gap-icons-Microphone2:before{content:\"\\E6B1\"}.icon-stroke-gap-icons-Message:before{content:\"\\E6B2\"}.icon-stroke-gap-icons-MessageRight:before{content:\"\\E6B3\"}.icon-stroke-gap-icons-MessageLeft:before{content:\"\\E6B4\"}.icon-stroke-gap-icons-Menu:before{content:\"\\E6B5\"}.icon-stroke-gap-icons-Media:before{content:\"\\E6B6\"}.icon-stroke-gap-icons-Mail:before{content:\"\\E6B7\"}.icon-stroke-gap-icons-List:before{content:\"\\E6B8\"}.icon-stroke-gap-icons-Layers:before{content:\"\\E6B9\"}.icon-stroke-gap-icons-Key:before{content:\"\\E6BA\"}.icon-stroke-gap-icons-Imbox:before{content:\"\\E6BB\"}.icon-stroke-gap-icons-Eye:before{content:\"\\E6BC\"}.icon-stroke-gap-icons-Edit:before{content:\"\\E6BD\"}.icon-stroke-gap-icons-DSLRCamera:before{content:\"\\E6BE\"}.icon-stroke-gap-icons-DownloadCloud:before{content:\"\\E6BF\"}.icon-stroke-gap-icons-CompactCamera:before{content:\"\\E6C0\"}.icon-stroke-gap-icons-Cloud:before{content:\"\\E6C1\"}.icon-stroke-gap-icons-ClosedLock:before{content:\"\\E6C2\"}.icon-stroke-gap-icons-Chart2:before{content:\"\\E6C3\"}.icon-stroke-gap-icons-Bulb:before{content:\"\\E6C4\"}.icon-stroke-gap-icons-Briefcase:before{content:\"\\E6C5\"}.icon-stroke-gap-icons-Blog:before{content:\"\\E6C6\"}.icon-stroke-gap-icons-Agenda:before{content:\"\\E6C7\"}.todo-item{border-bottom:1px solid #eee}.todo-item button{display:none;margin-top:8px}.todo-item:hover{background:#fefef4}.todo-item:hover button{display:inline-block}@media (max-width:989px){.todo-item .text-right{display:none}.todo-item:hover .text-right{display:block;text-align:center;margin-bottom:12.5px}}body{opacity:1!important}.list-group-item,body{color:#000!important;font-weight:700}.fc-day>div p{font-size:12px!important}.placesSuggest_suggestLabel{font-size:13px!important}.placesSuggest_suggest{padding:10px!important}.placesSuggest_suggests{width:100%;left:0!important;top:59px!important}.input-fullwidth{width:100%!important;margin-bottom:10px}.alerts-viewer{max-height:600px;overflow-y:scroll}.custom-list-field .table>tbody>tr>td{border:none}.kinetic-active{cursor:grab}#body .container-fluid.kinetic-active{padding-top:200px}@media only screen and (min-width:1224px){#body .container-fluid.kinetic-active{height:calc(100vh - 75px - 44px)}}@media only screen and (max-width:1224px){#body .container-fluid.kinetic-active{padding-top:200px!important;padding-left:0;padding-right:0}.planning-container .col-sm-4,.planning-container .col-sm-6,.planning-container .col-sm-12,.planning-programme .col-sm-4,.planning-programme .col-sm-5,.planning-programme .col-sm-6,.planning-programme .col-sm-12{padding:0}.planning-programme{margin-top:200px}}.weather-container{width:765px;height:700px;overflow:hidden;position:relative}.weather-container .weather-iframe{width:100%;height:1600px;position:absolute;top:-420px;left:-2px}.col-weather{margin-top:25px;border-radius:50%;width:765px;border-radius:5px}.col-welcome{width:calc(98% - 765px);margin-left:2%}#calendar{height:calc(100vh - 220px)}.fc-sat,.fc-sun{background-color:#d9edf7}.fc-week{overflow:scroll!important}.calendar-day{padding:10px;display:flex;flex-direction:column;justify-content:center}.calendar-day .panel-body{padding:0!important}.calendar-day .form-group,.calendar-day .progress{margin:0}.calendar-day .progress:first-child{margin-bottom:12px}.planning-period .panel-body .btn{display:block;margin:0 auto;margin-bottom:12px}.flight-type-color{width:20px;height:20px;display:inline-block;background-color:red;border-radius:50%;margin-left:8px;border:1px solid #000}.planning-period .list-group-item{display:flex;align-items:center}.list-group-item-primary{background:#428bca;color:#fff}.list-group-item a{color:inherit}.notify-sms{position:absolute;right:15px;margin-top:2px}.availability-progress-container p{margin-bottom:0;text-transform:uppercase;font-size:12px}.fc-day>div{position:relative;top:-4px}.fc-day>div p{margin-bottom:-1px;margin-top:5px;text-transform:uppercase;font-size:9px;text-align:center}.calendar .col-sm-6{padding-left:5px;padding-right:5px}.sidebar{height:100%!important;overflow-y:scroll!important}.list-group-item-warning{background-color:#faab33}.list-group-item-info{background-color:#29c2e2}td{vertical-align:inherit!important}.fa-spin-custom,.glyphicon-spin{-webkit-animation:spin 1s infinite linear;animation:spin 1s infinite linear}@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.planning-container .container-fluid{overflow:scroll}@media only screen and (min-width:1224px){.planning-container{width:7200px}.planning-container .col-sm-4{width:900px}.planning-container .col-sm-4:first-child{width:450px}}.planning-container .col-sm-6{padding-right:10px;padding-left:10px}.planning-container .panel-body{text-align:center}.planning-container .list-group{text-align:left}", ""]);
	
	// exports


/***/ },

/***/ "./node_modules/css-loader/lib/css-base.js":
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },

/***/ "./node_modules/css-loader/index.js!./node_modules/messenger/build/css/messenger.css":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "ul.messenger,ul.messenger>li{margin:0;padding:0}ul.messenger>li{list-style:none}ul.messenger.messenger-empty{display:none}ul.messenger .messenger-message{overflow:hidden;*zoom:1}ul.messenger .messenger-message.messenger-hidden{display:none}ul.messenger .messenger-message .messenger-actions a,ul.messenger .messenger-message .messenger-phrase{padding-right:5px}ul.messenger .messenger-message .messenger-actions{float:right}ul.messenger .messenger-message .messenger-actions a{cursor:pointer;text-decoration:underline}ul.messenger .messenger-message ol,ul.messenger .messenger-message ul{margin:10px 18px 0}ul.messenger.messenger-fixed{position:fixed;z-index:10000}ul.messenger.messenger-fixed .messenger-message{min-width:0;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box}ul.messenger.messenger-fixed .message .messenger-actions{float:left}ul.messenger.messenger-fixed.messenger-on-top{top:20px}ul.messenger.messenger-fixed.messenger-on-bottom{bottom:20px}ul.messenger.messenger-fixed.messenger-on-bottom,ul.messenger.messenger-fixed.messenger-on-top{left:50%;width:800px;margin-left:-400px}@media (max-width:960px){ul.messenger.messenger-fixed.messenger-on-bottom,ul.messenger.messenger-fixed.messenger-on-top{left:10%;width:80%;margin-left:0}}ul.messenger.messenger-fixed.messenger-on-bottom.messenger-on-right,ul.messenger.messenger-fixed.messenger-on-top.messenger-on-right{right:20px;left:auto}ul.messenger.messenger-fixed.messenger-on-bottom.messenger-on-left,ul.messenger.messenger-fixed.messenger-on-top.messenger-on-left{left:20px;margin-left:0}ul.messenger.messenger-fixed.messenger-on-left,ul.messenger.messenger-fixed.messenger-on-right{width:350px}ul.messenger.messenger-fixed.messenger-on-left .messenger-actions,ul.messenger.messenger-fixed.messenger-on-right .messenger-actions{float:left}ul.messenger .messenger-spinner{display:none}ul.messenger .messenger-clickable{cursor:pointer}", ""]);
	
	// exports


/***/ },

/***/ "./node_modules/css-loader/index.js!./node_modules/messenger/build/css/messenger-theme-future.css":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "@-webkit-keyframes ui-spinner-rotate-right{0%{-webkit-transform:rotate(0deg)}25%{-webkit-transform:rotate(180deg)}50%{-webkit-transform:rotate(180deg)}75%{-webkit-transform:rotate(1turn)}to{-webkit-transform:rotate(1turn)}}@-webkit-keyframes ui-spinner-rotate-left{0%{-webkit-transform:rotate(0deg)}25%{-webkit-transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg)}75%{-webkit-transform:rotate(180deg)}to{-webkit-transform:rotate(1turn)}}@-moz-keyframes ui-spinner-rotate-right{0%{-moz-transform:rotate(0deg)}25%{-moz-transform:rotate(180deg)}50%{-moz-transform:rotate(180deg)}75%{-moz-transform:rotate(1turn)}to{-moz-transform:rotate(1turn)}}@-moz-keyframes ui-spinner-rotate-left{0%{-moz-transform:rotate(0deg)}25%{-moz-transform:rotate(0deg)}50%{-moz-transform:rotate(180deg)}75%{-moz-transform:rotate(180deg)}to{-moz-transform:rotate(1turn)}}@keyframes ui-spinner-rotate-right{0%{transform:rotate(0deg)}25%{transform:rotate(180deg)}50%{transform:rotate(180deg)}75%{transform:rotate(1turn)}to{transform:rotate(1turn)}}@keyframes ui-spinner-rotate-left{0%{transform:rotate(0deg)}25%{transform:rotate(0deg)}50%{transform:rotate(180deg)}75%{transform:rotate(180deg)}to{transform:rotate(1turn)}}.messenger-spinner{position:relative;border-radius:100%}ul.messenger.messenger-spinner-active .messenger-spinner .messenger-spinner{display:block}.messenger-spinner .messenger-spinner-side{width:50%;height:100%;overflow:hidden;position:absolute}.messenger-spinner .messenger-spinner-side .messenger-spinner-fill{border-radius:999px;position:absolute;width:100%;height:100%;-moz-animation-iteration-count:infinite;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-moz-animation-timing-function:linear;-webkit-animation-timing-function:linear;animation-timing-function:linear}.messenger-spinner .messenger-spinner-side-left{left:0}.messenger-spinner .messenger-spinner-side-left .messenger-spinner-fill{left:100%;border-top-left-radius:0;border-bottom-left-radius:0;-moz-animation-name:ui-spinner-rotate-left;-webkit-animation-name:ui-spinner-rotate-left;animation-name:ui-spinner-rotate-left;-moz-transform-origin:0 50% 50%;-ms-transform-origin:0 50% 50%;-webkit-transform-origin:0 50% 50%;transform-origin:0 50% 50%}.messenger-spinner .messenger-spinner-side-right{left:50%}.messenger-spinner .messenger-spinner-side-right .messenger-spinner-fill{left:-100%;border-top-right-radius:0;border-bottom-right-radius:0;-moz-animation-name:ui-spinner-rotate-right;-webkit-animation-name:ui-spinner-rotate-right;animation-name:ui-spinner-rotate-right;-moz-transform-origin:100% 50% 50%;-ms-transform-origin:100% 50% 50%;-webkit-transform-origin:100% 50% 50%;transform-origin:100% 50% 50%}ul.messenger-theme-future{-moz-box-shadow:inset 0 1px hsla(0,0%,100%,.24),0 1px 5px rgba(0,0,0,.6);-webkit-box-shadow:inset 0 1px hsla(0,0%,100%,.24),0 1px 5px rgba(0,0,0,.6);box-shadow:inset 0 1px hsla(0,0%,100%,.24),0 1px 5px rgba(0,0,0,.6);-moz-border-radius:4px;-webkit-border-radius:4px;border-radius:4px;-moz-user-select:none;-webkit-user-select:none;-o-user-select:none;user-select:none;background-image:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4gPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJncmFkIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgeDE9IjAuNSIgeTE9IjAuMCIgeDI9IjAuNSIgeTI9IjEuMCI+PHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzVjNWI1YiIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iIzM1MzUzNSIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JhZCkiIC8+PC9zdmc+IA==\");background-size:100%;background-image:-webkit-gradient(linear,50% 0,50% 100%,color-stop(0,#5c5b5b),color-stop(100%,#353535));background-image:-moz-linear-gradient(#5c5b5b,#353535);background-image:-webkit-linear-gradient(#5c5b5b,#353535);background-image:linear-gradient(#5c5b5b,#353535);background-color:#5c5b5b;border:1px solid rgba(0,0,0,.5)}ul.messenger-theme-future .messenger-message{-moz-box-shadow:inset 0 1px hsla(0,0%,100%,.13),inset 0 -1px rgba(0,0,0,.23),inset 48px 0 0 rgba(0,0,0,.3),inset 46px 0 0 hsla(0,0%,100%,.07);-webkit-box-shadow:inset 0 1px hsla(0,0%,100%,.13),inset 0 -1px rgba(0,0,0,.23),inset 48px 0 0 rgba(0,0,0,.3),inset 46px 0 0 hsla(0,0%,100%,.07);box-shadow:inset 0 1px hsla(0,0%,100%,.13),inset 0 -1px rgba(0,0,0,.23),inset 48px 0 0 rgba(0,0,0,.3),inset 46px 0 0 hsla(0,0%,100%,.07);-moz-border-radius:0;-webkit-border-radius:0;border-radius:0;position:relative;border:0;margin-bottom:0;font-size:13px;background:transparent;color:#f0f0f0;text-shadow:0 1px #111;font-weight:500;padding:10px 30px 13px 65px}ul.messenger-theme-future .messenger-message a{color:#59f}ul.messenger-theme-future .messenger-message .messenger-close{position:absolute;top:0;right:0;color:#888;text-shadow:0 1px #000;opacity:1;font-weight:700;display:block;font-size:20px;line-height:20px;padding:8px 10px 7px 7px;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}ul.messenger-theme-future .messenger-message .messenger-close:hover{color:#bbb}ul.messenger-theme-future .messenger-message .messenger-close:active{color:#777}ul.messenger-theme-future .messenger-message .messenger-actions{float:none;margin-top:10px}ul.messenger-theme-future .messenger-message .messenger-actions a{-moz-box-shadow:0 0 0 1px rgba(0,0,0,.2),inset 0 1px hsla(0,0%,100%,.1);-webkit-box-shadow:0 0 0 1px rgba(0,0,0,.2),inset 0 1px hsla(0,0%,100%,.1);box-shadow:0 0 0 1px rgba(0,0,0,.2),inset 0 1px hsla(0,0%,100%,.1);-moz-border-radius:4px;-webkit-border-radius:4px;border-radius:4px;text-decoration:none;display:inline-block;padding:10px;color:#aaa;text-shadow:0 1px #222;margin-right:10px;padding:3px 10px 5px;text-transform:capitalize}ul.messenger-theme-future .messenger-message .messenger-actions a:hover{-moz-box-shadow:0 0 0 1px rgba(0,0,0,.2),inset 0 1px hsla(0,0%,100%,.2);-webkit-box-shadow:0 0 0 1px rgba(0,0,0,.2),inset 0 1px hsla(0,0%,100%,.2);box-shadow:0 0 0 1px rgba(0,0,0,.2),inset 0 1px hsla(0,0%,100%,.2);color:#f0f0f0}ul.messenger-theme-future .messenger-message .messenger-actions a:active{-moz-box-shadow:0 0 0 1px rgba(0,0,0,.28),inset 0 1px rgba(0,0,0,.1);-webkit-box-shadow:0 0 0 1px rgba(0,0,0,.28),inset 0 1px rgba(0,0,0,.1);box-shadow:0 0 0 1px rgba(0,0,0,.28),inset 0 1px rgba(0,0,0,.1);background:rgba(0,0,0,.04);color:#aaa}ul.messenger-theme-future .messenger-message .messenger-actions .messenger-phrase{display:none}ul.messenger-theme-future .messenger-message .messenger-message-inner:before{-moz-box-shadow:inset 0 1px 3px rgba(0,0,0,.6),0 0 0 1px rgba(0,0,0,.2);-webkit-box-shadow:inset 0 1px 3px rgba(0,0,0,.6),0 0 0 1px rgba(0,0,0,.2);box-shadow:inset 0 1px 3px rgba(0,0,0,.6),0 0 0 1px rgba(0,0,0,.2);-moz-border-radius:50%;-webkit-border-radius:50%;border-radius:50%;position:absolute;left:17px;display:block;content:\" \";top:50%;margin-top:-8px;height:13px;width:13px;z-index:20}ul.messenger-theme-future .messenger-message.alert-success .messenger-message-inner:before{background-image:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4gPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJncmFkIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgeDE9IjAuNSIgeTE9IjAuMCIgeDI9IjAuNSIgeTI9IjEuMCI+PHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzVmY2E0YSIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iIzA5OGQzOCIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JhZCkiIC8+PC9zdmc+IA==\");background-size:100%;background-image:-webkit-gradient(linear,50% 0,50% 100%,color-stop(0,#5fca4a),color-stop(100%,#098d38));background-image:-moz-linear-gradient(top,#5fca4a,#098d38);background-image:-webkit-linear-gradient(top,#5fca4a,#098d38);background-image:linear-gradient(180deg,#5fca4a,#098d38);background-color:#5fca4a}ul.messenger-theme-future .messenger-message.alert-info .messenger-message-inner:before{background-image:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4gPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJncmFkIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgeDE9IjAuNSIgeTE9IjAuMCIgeDI9IjAuNSIgeTI9IjEuMCI+PHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzYxYzRiOCIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iIzE5OTJhMyIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JhZCkiIC8+PC9zdmc+IA==\");background-size:100%;background-image:-webkit-gradient(linear,50% 0,50% 100%,color-stop(0,#61c4b8),color-stop(100%,#1992a3));background-image:-moz-linear-gradient(top,#61c4b8,#1992a3);background-image:-webkit-linear-gradient(top,#61c4b8,#1992a3);background-image:linear-gradient(180deg,#61c4b8,#1992a3);background-color:#61c4b8}ul.messenger-theme-future .messenger-message.alert-error .messenger-message-inner:before{background-image:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4gPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJncmFkIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgeDE9IjAuNSIgeTE9IjAuMCIgeDI9IjAuNSIgeTI9IjEuMCI+PHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2RkNmE0NSIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iIzkxMzYxYSIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JhZCkiIC8+PC9zdmc+IA==\");background-size:100%;background-image:-webkit-gradient(linear,50% 0,50% 100%,color-stop(0,#dd6a45),color-stop(100%,#91361a));background-image:-moz-linear-gradient(top,#dd6a45,#91361a);background-image:-webkit-linear-gradient(top,#dd6a45,#91361a);background-image:linear-gradient(180deg,#dd6a45,#91361a);background-color:#dd6a45}ul.messenger-theme-future .messenger-message.alert-error.messenger-retry-soon .messenger-spinner{width:32px;height:32px;background:transparent}ul.messenger-theme-future .messenger-message.alert-error.messenger-retry-soon .messenger-spinner .messenger-spinner-side .messenger-spinner-fill{background:#dd6a45;-moz-animation-duration:20s;-webkit-animation-duration:20s;animation-duration:20s;opacity:1}ul.messenger-theme-future .messenger-message.alert-error.messenger-retry-soon .messenger-spinner:after{content:\"\";background:#333;position:absolute;width:26px;height:26px;border-radius:50%;top:3px;left:3px;display:block}ul.messenger-theme-future .messenger-message.alert-error.messenger-retry-later .messenger-spinner{width:32px;height:32px;background:transparent}ul.messenger-theme-future .messenger-message.alert-error.messenger-retry-later .messenger-spinner .messenger-spinner-side .messenger-spinner-fill{background:#dd6a45;-moz-animation-duration:600s;-webkit-animation-duration:600s;animation-duration:600s;opacity:1}ul.messenger-theme-future .messenger-message.alert-error.messenger-retry-later .messenger-spinner:after{content:\"\";background:#333;position:absolute;width:26px;height:26px;border-radius:50%;top:3px;left:3px;display:block}ul.messenger-theme-future .messenger-message-slot.messenger-last .messenger-message{-moz-border-radius:4px 4px 0 0;-webkit-border-radius:4px;border-radius:4px 4px 0 0}ul.messenger-theme-future .messenger-message-slot.messenger-first .messenger-message{-moz-border-radius:0 0 4px 4px;-webkit-border-radius:0;border-radius:0 0 4px 4px;-moz-box-shadow:inset 0 1px hsla(0,0%,100%,.13),inset 48px 0 0 rgba(0,0,0,.3),inset 46px 0 0 hsla(0,0%,100%,.07);-webkit-box-shadow:inset 0 1px hsla(0,0%,100%,.13),inset 48px 0 0 rgba(0,0,0,.3),inset 46px 0 0 hsla(0,0%,100%,.07);box-shadow:inset 0 1px hsla(0,0%,100%,.13),inset 48px 0 0 rgba(0,0,0,.3),inset 46px 0 0 hsla(0,0%,100%,.07)}ul.messenger-theme-future .messenger-message-slot.messenger-first.messenger-last .messenger-message{-moz-border-radius:4px;-webkit-border-radius:4px;border-radius:4px;-moz-box-shadow:inset 48px 0 0 rgba(0,0,0,.3),inset 46px 0 0 hsla(0,0%,100%,.07);-webkit-box-shadow:inset 48px 0 0 rgba(0,0,0,.3),inset 46px 0 0 hsla(0,0%,100%,.07);box-shadow:inset 48px 0 0 rgba(0,0,0,.3),inset 46px 0 0 hsla(0,0%,100%,.07)}ul.messenger-theme-future .messenger-spinner{display:block;position:absolute;left:7px;top:50%;margin-top:-18px;z-index:999;height:32px;width:32px;z-index:10}", ""]);
	
	// exports


/***/ },

/***/ "./node_modules/css-loader/index.js!./node_modules/react-big-calendar/lib/css/react-big-calendar.css":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".rbc-btn{color:inherit;font:inherit;margin:0}button.rbc-btn{overflow:visible;text-transform:none;-webkit-appearance:button;cursor:pointer}button[disabled].rbc-btn{cursor:not-allowed}button.rbc-input::-moz-focus-inner{border:0;padding:0}.rbc-calendar{box-sizing:border-box;height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:stretch;align-items:stretch}.rbc-calendar *,.rbc-calendar :after,.rbc-calendar :before{box-sizing:inherit}.rbc-abs-full,.rbc-row-bg{overflow:hidden;position:absolute;top:0;left:0;right:0;bottom:0}.rbc-ellipsis,.rbc-event-label,.rbc-row-segment .rbc-event-content,.rbc-show-more{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.rbc-rtl{direction:rtl}.rbc-off-range{color:#b3b3b3}.rbc-header{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding:0 3px;text-align:center;vertical-align:middle;font-weight:700;font-size:90%;min-height:0}.rbc-header>a,.rbc-header>a:active,.rbc-header>a:visited{color:inherit;text-decoration:none}.rbc-toolbar{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;margin-bottom:10px;font-size:16px}.rbc-toolbar .rbc-toolbar-label{width:100%;padding:0 10px;text-align:center}.rbc-toolbar button{color:#373a3c;display:inline-block;margin:0;text-align:center;vertical-align:middle;background:none;background-image:none;border:1px solid #ccc;padding:.375rem 1rem;border-radius:4px;line-height:normal;white-space:nowrap}.rbc-toolbar button.rbc-active,.rbc-toolbar button:active{background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125);background-color:#e6e6e6;border-color:#adadad}.rbc-toolbar button.rbc-active:focus,.rbc-toolbar button.rbc-active:hover,.rbc-toolbar button:active:focus,.rbc-toolbar button:active:hover{color:#373a3c;background-color:#d4d4d4;border-color:#8c8c8c}.rbc-toolbar button:focus,.rbc-toolbar button:hover{color:#373a3c;background-color:#e6e6e6;border-color:#adadad}.rbc-btn-group{display:inline-block;white-space:nowrap}.rbc-btn-group>button:first-child:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.rbc-btn-group>button:last-child:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.rbc-rtl .rbc-btn-group>button:first-child:not(:last-child){border-radius:4px;border-top-left-radius:0;border-bottom-left-radius:0}.rbc-rtl .rbc-btn-group>button:last-child:not(:first-child){border-radius:4px;border-top-right-radius:0;border-bottom-right-radius:0}.rbc-btn-group>button:not(:first-child):not(:last-child){border-radius:0}.rbc-btn-group button+button{margin-left:-1px}.rbc-rtl .rbc-btn-group button+button{margin-left:0;margin-right:-1px}.rbc-btn-group+.rbc-btn-group,.rbc-btn-group+button{margin-left:10px}.rbc-event{cursor:pointer;padding:2px 5px;background-color:#3174ad;border-radius:5px;color:#fff}.rbc-event.rbc-selected{background-color:#265985}.rbc-event-label{font-size:80%}.rbc-event-overlaps{box-shadow:-1px 1px 5px 0 rgba(51,51,51,.5)}.rbc-event-continues-after{border-top-right-radius:0;border-bottom-right-radius:0}.rbc-event-continues-prior{border-top-left-radius:0;border-bottom-left-radius:0}.rbc-row{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.rbc-row-segment{padding:0 1px 1px}.rbc-selected-cell{background-color:#000;color:#fff;opacity:.05}.rbc-show-more{background-color:hsla(0,0%,100%,.3);z-index:4;font-weight:700;font-size:85%;height:auto;line-height:normal;white-space:nowrap}.rbc-month-view{position:relative;border:1px solid #ddd;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex:1 0 0;flex:1 0 0;width:100%;height:100%}.rbc-month-view .rbc-header{border-bottom:1px solid #ddd}.rbc-month-view .rbc-header+.rbc-header{border-left:1px solid #ddd}.rbc-rtl .rbc-month-view .rbc-header+.rbc-header{border-left-width:0;border-right:1px solid #ddd}.rbc-month-header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.rbc-month-row{display:-ms-flexbox;display:flex;position:relative;-ms-flex-direction:column;flex-direction:column;-ms-flex:1 0 0;flex:1 0 0;overflow:hidden;height:100%}.rbc-month-row+.rbc-month-row{border-top:1px solid #ddd}.rbc-date-cell{padding-right:5px;text-align:right}.rbc-date-cell.rbc-now{font-weight:700}.rbc-date-cell>a,.rbc-date-cell>a:active,.rbc-date-cell>a:visited{color:inherit;text-decoration:none}.rbc-row-content{position:relative;z-index:4}.rbc-row-bg{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex:1 0 0;flex:1 0 0;overflow:hidden}.rbc-day-bg+.rbc-day-bg{border-left:1px solid #ddd}.rbc-rtl .rbc-day-bg+.rbc-day-bg{border-left-width:0;border-right:1px solid #ddd}.rbc-overlay{position:absolute;z-index:5;border:1px solid #e5e5e5;background-color:#fff;box-shadow:0 5px 15px rgba(0,0,0,.25);padding:10px}.rbc-overlay>*+*{margin-top:1px}.rbc-overlay-header{border-bottom:1px solid #e5e5e5;margin:-10px -10px 5px;padding:2px 10px}.rbc-agenda-view{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex:1 0 0;flex:1 0 0;overflow:auto}.rbc-agenda-view table{width:100%;border:1px solid #ddd}.rbc-agenda-view table tbody>tr>td{padding:5px 10px;vertical-align:top}.rbc-agenda-view table .rbc-agenda-time-cell{padding-left:15px;padding-right:15px;text-transform:lowercase}.rbc-agenda-view table tbody>tr>td+td{border-left:1px solid #ddd}.rbc-rtl .rbc-agenda-view table tbody>tr>td+td{border-left-width:0;border-right:1px solid #ddd}.rbc-agenda-view table tbody>tr+tr{border-top:1px solid #ddd}.rbc-agenda-view table thead>tr>th{padding:3px 5px;text-align:left;border-bottom:1px solid #ddd}.rbc-rtl .rbc-agenda-view table thead>tr>th{text-align:right}.rbc-agenda-time-cell{text-transform:lowercase}.rbc-agenda-time-cell .rbc-continues-after:after{content:\" \\BB\"}.rbc-agenda-time-cell .rbc-continues-prior:before{content:\"\\AB   \"}.rbc-agenda-date-cell,.rbc-agenda-time-cell{white-space:nowrap}.rbc-agenda-event-cell{width:100%}.rbc-time-column{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;min-height:100%}.rbc-time-column .rbc-timeslot-group{-ms-flex:1;flex:1}.rbc-timeslot-group{border-bottom:1px solid #ddd;min-height:40px;display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap}.rbc-header-gutter,.rbc-time-gutter{-ms-flex:none;flex:none}.rbc-label{padding:0 5px}.rbc-day-slot{position:relative}.rbc-day-slot .rbc-event{border:1px solid #265985;display:-ms-flexbox;display:flex;max-height:100%;-ms-flex-flow:column wrap;flex-flow:column wrap;-ms-flex-align:start;align-items:flex-start;overflow:hidden}.rbc-day-slot .rbc-event-label{-ms-flex:none;flex:none;padding-right:5px;width:auto}.rbc-day-slot .rbc-event-content{width:100%;-ms-flex:1 1 0;flex:1 1 0;word-wrap:break-word;line-height:1;height:100%;min-height:1em}.rbc-day-slot .rbc-time-slot{border-top:1px solid #f7f7f7}.rbc-time-slot{-ms-flex:1 0 0;flex:1 0 0}.rbc-time-slot.rbc-now{font-weight:700}.rbc-day-header{text-align:center}.rbc-day-slot .rbc-event{position:absolute;z-index:2}.rbc-day-slot.rbc-today,.rbc-header.rbc-today{background-color:#eaf6ff}.rbc-slot-selection{z-index:10;position:absolute;cursor:default;background-color:#000;color:#fff;opacity:.5;font-size:75%;padding:3px}.rbc-time-view{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex:1;flex:1;width:100%;border:1px solid #ddd;min-height:0}.rbc-time-view .rbc-time-gutter{white-space:nowrap}.rbc-time-view .rbc-allday-cell{width:100%;position:relative}.rbc-time-view .rbc-row{min-height:20px}.rbc-time-header{display:-ms-flexbox;display:flex;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-direction:column;flex-direction:column}.rbc-time-header.rbc-overflowing{border-right:1px solid #ddd}.rbc-rtl .rbc-time-header.rbc-overflowing{border-right-width:0;border-left:1px solid #ddd}.rbc-time-header>.rbc-row>*+*{border-left:1px solid #ddd}.rbc-rtl .rbc-time-header>.rbc-row>*+*{border-left-width:0;border-right:1px solid #ddd}.rbc-time-header>.rbc-row:first-child{border-bottom:1px solid #ddd}.rbc-time-header .rbc-gutter-cell{-ms-flex:none;flex:none}.rbc-time-header>.rbc-gutter-cell+*{width:100%}.rbc-time-content{display:-ms-flexbox;display:flex;-ms-flex:1 0 0%;flex:1 0 0%;-ms-flex-align:start;align-items:flex-start;width:100%;border-top:2px solid #ddd;overflow-y:auto;position:relative}.rbc-time-content>.rbc-time-gutter{-ms-flex:none;flex:none}.rbc-time-content>*+*>*{border-left:1px solid #ddd}.rbc-rtl .rbc-time-content>*+*>*{border-left-width:0;border-right:1px solid #ddd}.rbc-time-content>.rbc-day-slot{width:100%}.rbc-current-time-indicator{position:absolute;z-index:1;right:0;height:1px;background-color:#74ad31;pointer-events:none}.rbc-current-time-indicator:before{display:block;position:absolute;left:-3px;top:-3px;content:\" \";background-color:#74ad31;border-radius:50%;width:8px;height:8px}", ""]);
	
	// exports


/***/ },

/***/ "./src/styles/fonts/lato/lato-bold-webfont.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "646474e48f4c1ea783f43ac5e41fd111.woff2";

/***/ },

/***/ "./src/styles/fonts/lato/lato-bold-webfont.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "374df2a818582454b6e6832804e52f86.woff";

/***/ },

/***/ "./src/styles/fonts/lato/lato-bolditalic-webfont.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5fa6d7ddc0a0d53311752343d7176d70.woff2";

/***/ },

/***/ "./src/styles/fonts/lato/lato-bolditalic-webfont.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c53136193516ed2d4fac337d1dc6965a.woff";

/***/ },

/***/ "./src/styles/fonts/lato/lato-italic-webfont.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9bcf055a732c0b22d2279ba79e20c577.woff2";

/***/ },

/***/ "./src/styles/fonts/lato/lato-italic-webfont.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c8eef482ac448a91ecca9d008634c044.woff";

/***/ },

/***/ "./src/styles/fonts/lato/lato-light-webfont.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7a6991e6fb01d99917e1bdda8115ca44.woff2";

/***/ },

/***/ "./src/styles/fonts/lato/lato-light-webfont.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0afdb5b95c4e761e9a02702dbdbd33d3.woff";

/***/ },

/***/ "./src/styles/fonts/lato/lato-regular-webfont.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a96eacf834096e2ffe6b44eff64d0b73.woff2";

/***/ },

/***/ "./src/styles/fonts/lato/lato-regular-webfont.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d25caacd637ab56a657f9d7b565d9207.woff";

/***/ },

/***/ "./src/styles/fonts/fontello/fontello-webfont.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "32194e02049a53df82b262c7294c6a3b.woff2";

/***/ },

/***/ "./src/styles/fonts/fontello/fontello-webfont.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c810fb1e81981ca125bbe59a5dd306b4.woff";

/***/ },

/***/ "./src/styles/fonts/climacons/Climacons-Font.woff2":
/***/ function(module, exports) {

	module.exports = "data:application/font-woff2;base64,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"

/***/ },

/***/ "./src/styles/fonts/climacons/Climacons-Font.woff":
/***/ function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ },

/***/ "./src/styles/fonts/devicon/devicon.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8081474e67ebc8daf921bb3b4a572917.woff2";

/***/ },

/***/ "./src/styles/fonts/devicon/devicon.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d5e752960891608625d013a9ca88435f.woff";

/***/ },

/***/ "./src/styles/fonts/dripicons/dripicons.woff2":
/***/ function(module, exports) {

	module.exports = "data:application/font-woff2;base64,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"

/***/ },

/***/ "./src/styles/fonts/dripicons/dripicons.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f9cbd8a7132af2cf208c1c6ff96c0392.woff";

/***/ },

/***/ "./src/styles/fonts/feather/feather.woff2":
/***/ function(module, exports) {

	module.exports = "data:application/font-woff2;base64,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"

/***/ },

/***/ "./src/styles/fonts/feather/feather.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8831b6b9f9146e82781d5ce352920d32.woff";

/***/ },

/***/ "./src/styles/fonts/flatline/flatline.woff2":
/***/ function(module, exports) {

	module.exports = "data:application/font-woff2;base64,d09GMgABAAAAABfsAA0AAAAANvwAABeXAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP0ZGVE0cGiAGYACCXhEICt1syiUBNgIkA3oLcAAEIAWDFQeELxveK7MRFWwcgGLGTiT7vyQ37kbdBiiVZbbhhulsNPCgwxkbCJc3K4VRBwxX2wIRioxiKL63/zVxc6Xz0h91yFDKn0fd/s8dSUtZSZqAyHhJmhbdKSlWd9MhDxylZe2i4ASVJwXnxoET3wDXf4Jvj6Xv/QU80F/t7Ukn0c07foOXJRKliTcZBtx84DK3tU9tsVjC8IcMxh2cGlzUlXaySbmNCszjE0rW9V1+yDKU4tVe6XlqeXE/+8a2lkbyPgqjWpvYNBke0BvQEVuyNG6OEZqIHSsxvwMADCCjChcwqQ3Ij3QE2VTOWUi58g5UOPR0gnZB35XNMt29Uz+g/t+w5icTBhFR5izagdVrdkS7e7TaI53uQXcmHeGufOXfB8DoHSIIjmSWjDqbM8AgA87OlTt2FDhPDO9v7T+lY7AtlaLq0DE226EukkWqM1ExEgzQ/35PAIAAwEvz2aMAXr37//2tA4AUAKMAAAxBpohQ0zsBINF/HAPQbiuDAngUl7U94LtDTb18vuBG/8hRnlVwJhMK4rIpSM7BLGdWiTha5ErNBGyscKY6ysE98iMj4SoC6PGR7zGG2GXLwhgIQDkASt6CcUEc2EBy+N8FTARVD09F5d6x2xhcAHwBQHjPXFMrgzQ9I0cZztxZ0lOkCYyBrkHq5Ts32FgcqQdWsBlf8RY3G08GSlMGWf2JGtumIGmJZDB4x/Hp8mAz7iEG+W0kXKk5o9KhpYBhxtJH2vSGecWSlEud+Vp6JLckZTZO5hiGakdGIHfGLTpr1th1Y76WlcU0zHCPpcyYmvTa0WPTU2bMmGlY9zgFSUxSewdHqckZ0rp6XHD5ZKfDqvFsSV4XtF+SokXiUL/eyOMiJrMULXn2hq7GknAfdp+NrSWeQKO4SQpshOkc6Vhe60UHF/llQq3VrHvE5xdd1pILlK0YmfOTgR90rtsqWd31MmtC7daGbaJJ3qyxAoQr23okaksmYt0ov72CcKla09lUV5AOOtQrRS+MnoxDwUjaOw6ixKXa56B6Sv4DM5qdIqGyGROEW7NNWgRwaB5jf+XatT/7yLmGq1e0aKgUXqDtrl/VSWUZ164rD1mC189lKVXmaZF+zCJqUIIKND+RqqMBZqGdJtCojGUG+YlqJFD1pX8L/nja9wxMI1Ka6jA0qsmUynAaTRnOTy0VjJxwmnMQGKbEzLbmEQl1Rpi4cs83uk9q9ASe8tBSxhXWcoRdJXyyzZVdtfiyaXAYtF+Xhb2Llw+Ftzxrg3v6w/Pnd/xrbHv6I6Cr5sLbZqgwroYn4uzZE5Ll2EWZ0TTVllDJxPF2laju17rdc6NEQp03Yy2CzQC7eyR89AWzoD2Xdq6FhHOabvv4in+vc3DFRooWLqx5diNNlDvNFtUS72UR9PbG0UwVlUAf0509vUk88Mt+kGqxnwJ+N7jgNAW1VuIwOkc6lC2F1uXjrTWMTn2tUSKg11vAbV4eXKA5TfuWd1mbZus/59N0X/vlws//gPu+b1vlFtU0LYG4yYINV8uGUxCgXkygVRz0CNHwuekp3rl+j9oFzFDT5lN5rT++ho/Tfj/EgTdQJHlLQ86RKkg6wetC0yv9vzg8/0+RVLM+VE3Mw+aNZaSl4qa54KtjSKvxeMd0vHBkSxa3+4uVXtdBUSj2TAj9+aYTstvSPckkj33cc8Dtx6gYajuNnWkDKLCLtqW3bgDAgwSKR52l4rjFCKDPt4kBkxTS77O4ceFqNjCGF9X6/t7629tlrZVbWhR78R0pvpdTJRWHQ2yFNSjQ59aVnmp0P+iSWGwxu2qwgYvXelGOcFQC3hwfuG06qkO6DSSNCliBHnC5GMmT9Lsh1duqrHFbz9XjFIGR1nYZG0YGQSQwctfZmFSyMoZdgIhTmoqwULUlFGzZnlPWoz6xalGsZTkGaRLuKBMUdFbRjlJUBTKH4+v6CI2bKx0HNl5QbGAGA4lTkbgysiGt8BSHS20ln1211N6OKnDV4CZpbpfxGxdZSGBrSnsh9Z6qy9xkK2k9kBa33E+jGXBV1jq4T6FUYswO4opITLXYVQQRFqHCTQEvQtwkSOzOjmmgi3WyNozcaLP4hjaeAStbVVq1JgGjq23UqTS5K2aclE222/KS7DKtSDvOdxkLlSbUglScm3PbbUjosB3iSQWRwbKP6SaDWUizJjn9plkgHI0Z3ZWEHmsNf8/y9m/ls6LsNHG3VMq8OSiRJ0KjlORJyIqwBGHHvbWZak1U1mTqSjMaxYCEThcpDt4kx1We80YuWjbksRO3HhU9Zbq1gXSUo5ukah8KbuOcEoFNbYg5UAe2nhF7RLzeHZBJy4+/ep0uGmG+LIPrRrw8Ru0KFuBYO0OoIkp0cEJl67chCBHmnAB+rsBVTEsv0IwbXIMgpFqpA1KfYWC6PrMXVnJym51N617AK03k503c9HHqDfaD2T7iSTh9G07hibnZOsATcOrZdBpP0pMv9ogYVLGyT2Q6jonZR5Ovl6QDxF9bWXGCJTosCBkF7Wircwv66tVPmOm/RTX1evjwTRe2p7eX1l/frzt5SXJSCjjsbFPRvc2DmOtwt2rj7noMucOyVRqsw8ycN6xldP/O6u5N/bncA0i1yUmRZ1CMEkqxIpLURwsisgo0V6RoaC5SAZ8175BqwsSsy0VJZMzQKchamUt+dzhec8CjqxrbI7MuGom43CSJ5B2EWp1j4En56ZDYc5kgpJo0bExPFcj0oS8Ntvtcw9VBqu5t0mBnwEcto+4onejC9U4y7Ix+N/VayOnv4d5IJV4bgkc+9sPdoYK1pf1WP5+OZeFK5Dpo938cDxCLTn7di2sanR6QrDhKrB14PFgE0OR5yAdtv6J/ciAKKOQ5wfshK4YP+ocAIM8jPkQVo1PUs+l1j8x2dz2/LrwxbbGfrRpcWDrNCvzp8MabyXC7ECpp4o1oGS1k0rrZxLhsZSRC3DZSpl7VgqLM17ipJkspxIiDhx0iZUQ1bGferWHrX6Gz+eOJtQc3VxzgT/IfDRRZxkiXeWhp4Z2sUwDEcQDDgj4XjfzjDPQjRSe4IYFEPRIhzkBEL7ceOmQAAoT27weXS8pcg1U2jcnZGkSwAAMDm/49bTl0aOHCIz2dG5rA5JatYeiaMu/I6y3roExHWS6Fta/s2wdc6vJErdh02AkTRhjzYPOD4GWMEeEUqKgQNEYTmhZuWL/gyuf1geCMXuoKxiiNlroodZVGKY0FXRSCh+qJy4jSMI0G0kg9lYIRvUfE46T8/Flp9s7mZ0kTZ34w6/3A/2ubPBGQIx47XUlFT7EcgaZ84IGDvF+OR0ixI/IBwXYFYbdMecvL4bEIcxhCEKnpBY7ncHjs4MviIZyWF5XlaF4afrV/s5Xag6ZMubw1j+wLivTjediV55d1v/vo84iUF9DlQJ6TAM7GItPjOF3z+JA6cpiF5soJIvhUHtsvFPui3KVLXNRXLHBpNI27NCiIrCggFcscyFhFP1ifAxzZGoOXfO0B6InP5/mlPI8VXWRvCCLKUHZA9udJeD6Wcmh/NcLrS5dYSg9Pm7pdR3hjfhheovFiaCye/NflLjleu+lmqatrbihPd8XSy2cqCzMLGwon3jAJq7svJYLUr6dWqfFkCFisf+1ZmQBD1oWDb9vusjH/3mQ1vJ8D99NVEEi+UdibXOO3hh/6xqbbvvmowQqB3Zns7qUwRMo7zpB7aJPDRehJGb+PvQshzJsjR/whskpjOzrHUMJ6PO4qrcq9CmMJHdPZYYFwST2NGk5KnJ4ofV0iKBEqBfS6cuZKItTpiVBoCkqUsNxmRO2EqvLobCM6Nxr481EKC/6qI4ZEhohkREhAz+vM3NKsZWdpHavGO4hpOOFAp2G6T0r4D398zuF478cXFSgZdPXYKzt7ioX2GdiO8+DxCuSTdeAElSB4DuFvDvqwxxHB1F1CMRy+fznkETt6tBxO9vp7S+HT7X5LUfy8hb0rXmTxs0Vdd7GW811F7CdFJR1OCDaXEFdQS5DaVOLussVUY1F1E+JWRVxN7A43eS/mg5KqJBgFgxbZcRKOUlMJ+jLhe1n74ZNbHAmpk8MubER8smKIjCDNnJBsyW4uz8/Jzm8pyc4pWTwlm1m1aoueKxsii5HdreO6yw2LZUNjcTc2TFa2/0yHIrc/fpvF8cMvN2uOW375wQHDNezAQK+5QTYYFglGpJizKgZlcS9SIygeMOZAMSQGrTDPHB5glFNDexVryqTZKTEYmXJJzvHjEy2jw+qXmf1brFdNbshFquLGiEMYyaE07ExpRjZzTt6XmcTSWEzftolRATsUzF4GOHyYIRRM3ywu2Ip2+c4OJPImTiswPDAmlO3JDo4Zkx0yQtkrEcwOZIdM/qBkPs9mdfDB06py7YMXVeW+B/cr6r4H71fEbzid6sCpAsGwEtuxygGGZHpyGOqmINWOW4lEUKHea2myTcyC+bcS0xDJaiIaftJM/IamJ2mGSUjEzoyFYov/HRECxzr7Nnc/ncwdH2wY3MvuXZaSWLD4qaUbNioS48Ecp2AClNfRpo2dNRUdSannT9c/4ChljaB4x+6sAiPJ1pw7oXXX2e0emy1/+5ndreNzF9mSPAWZu3+12r5LTa9aRiKaBxOPFiHLcJPmIdijNWHwayDzBCOiyLBx4655rc3JKXftaxsygt6AZ7B9790pqRf62vv6rvRVpyZ5197VvXEj72Q14foZ8UxvaWJi0Ds+PvLb/4zEjzeQmFjizYp33tERrAJCHbfHM5ucTiIF/IT6AxJB14p4NEo0T0SiYsB/lj8g0mJMj0ao5jEpzC1LfcDzQCo3dHlzDxiXuNQHjQe4eEL7g1cSEq482J5gu4TLwuW8trmvtuS08J92JglCUuen/Op3fFRG6pmMjDOpGaNqtXeShTdZU6mprey3JCnAywQhIvNgmjuIaERJo5W02+fjI0yE50VW4isrYb2bG+Zy/nD/kPPD+PO6cX+s9OZYWuxekXMQGJbjTJEeVyxeW1re98I/FMcRhInCgyAyGh/xLSKa4SckaohkOVY/gasIws0D9eKVil3cQzIX4CGv8fOfaxdbWiSHF0uvbZhXqy9X9MZdSlEt/sLpDyP9vhCepxX9fImF/1gIv38aEB4gTR4ngTrMlviZOsYfSMNQR/K1JtLAHSmCmvlZuvwNqHntEq8rb8DC15b+sQAL58eLCn8uehjLFtqd8AaE5dTw+l44TT1JC0Rp6i0He2zeeqAHmwdu6TGgC0Lp4LasFd5u0mHtIKvHCiL7BR7bKZ4PF6pbMKEGcG5GljtD3SFEEAEsSjOAQYmgbAkX8kT9CRL8MoGH7ff1SedLbitCKiX86JYGLwYCGMlIhiZvVgsmdqwcDxPFFPjxiyYtwnmKiSJ3Q8fheiqGimW9OCTS11kRXY7EqqJJOM+mrEcrUksiaLYuH0fu7F9Oev3lt5t/v0xNur+ETCX+dAwLVURkpXXO3120dNATnBKc07Zv1uk26e9TNSlLOu/q6u3kQeEI7p3TQYWSssAV/uuf3+Ljr5AZj9/eEfqU4LYKhDjAXJBKSuX3gqNJ1/mAyAhV3/F2t0KXAAYO6cuI8Aau+Y6wmsPNNboDpOZ7zGqaftf1jDtACUSx5ogSmhegGKJEc0Rw0qH3eZiZhZ0JQt0BRo9C0Dlp7YGxLLuhf6Arppy6AmqaJU3pH+jvfyTUqCWmrjP1qzFLVFVcFpc64wOQD+a/ceECsRsmJqZhJ6vr+FWREFE1W0TDJHjIRZDdVDVCNNVPYIGK8JvrUpHM8+jLL3mnxcmXlfFRNsbvJYGCBKR2YYbYOSQrBMUF8xdT+H3yxy+/fCoYzqz7NalkLY4VN/JuSUrDjbtQHu9DqCRA4OPceMRgJyu50WomhuCpubJHZDGWd98TZc27771Q9sD4hxt4rvjhcQ9euv3DKzzHfnjmwa4Dvp542cX7nokpbMTAAisZcvT4iZOG4c53G3vbus8npxzbW9/X9/aNRdeohRff7gte/Nc9TQXaqjEInowYq2jflCZqiBTWKVimyex78tgJLVA4zUYRgtlUv/zEC09Ee29LbLx9w2trx1kf/TGUiAmV8e3LX+sYjfBU/o8ErCJO1rH839m6YlAEz5m9tw80Ft9Jp7iiwiRm7CHblGRSXPz5sTgRC5e8XdwuCiHM2WvKqVjV+nRTTopqrIkyYFMkWHp3zLVjRhM43OxfQzAQhFmivlikeQiKX6kbyy2lJC0YidFI0KXiEVnhM18NctD3GzywYX3XVrjrMej9tfmRF+C6JcKlY2lSYjA3a/fP77F4Zm7wi+Z/LQqy4vEnOkJJiaFrHo9v36mWxBoJbYyVCDt2xm/fkZ+YlL/9jjjM2xeKJBiZecv3K0cykfntOxf31OvWBL2+Z3HZ+19ja8IXbz9XdhPwsoywLPPo2rLn3vndmvDH5fe5rKdNTrDKbT1l8MsHN3jkfzsiGSbZOZ4k24TRf+NFXtJ8trxisiY/9ON63s+aCi8yIn/2piWdcBN+CSrr7oTwDSTmcWKox0ypOTBHzaBkkBFik+q3ZkEO3J6FctDrT0LP48k6YiADzmSiDDR60Ys9bkWOhX2h5EAWZN+YY82yOsZYM60Zo+wZNy1nzFs8B8I54mQw+QURrMLfp/7nIIvD2IZ/OfHmDaPpL05PnjXtox/l8BON1BmIkmUvzZoF2d4s7vrvu65ac5DdkJa2Mf1w8wzizhMJFg038WOGYTEmRzXgIGEi5k1hdtmOcbekp/ekH2nO6f7wsDs7u+TMpzU6MdUgcdUkE4j7YpZh8ERiOgApOYylP96gZMECb0wecg9z05Pv3xkU8Bt2IssQQs0AEPNBWy2BEDKuIguAC5nHESCP+O/xMXNqB8icDLqkgZM7mNCoNHFv3IeGRz6T74rs3+WjZ0cbpyy81WfumARae3wmC5CxR0NFJbcwamv5Q+DTR3gYPp16Ou9iaspg3ulP2aTBlNSLk6a0J1wZarMmrLx0OcF6+dLK8YW3DV2x7quduvqa8U7lUoBFem/6laOxo1URmksjVTuajn7j6tWRZSRL4zu2THNdfUKiLiodv9o5bfU145zqkP8L6FHXN7Oqt0tf5/bSsuHZW6eKzkKcJwpcK+Xt586bkdecYuG0qcKwaSrn/JEklzhteq49jUwtnC46k6Lm+aPb5WFhzGzpaxHz3LmwFGZO0dQHbDt/zowm0276tDFCGoabSP7ebFMk2Px7RXUdS66X2iX++3NFxRzRCeYeKn+E5x8pf4j7I3kZfyol5RS/LHnNH3j1Z7uSk3d+VpiIqU/nkIw5QBxSQQv/+TiYIgx3vyECAoQwwph3M4kMn+Qz+kjCNze122ztN32TIGWs3paWNlkFXMPv19J6VPD4j76SQOY4jC4cfO3X0tIri6zellabdbzJmPzt6pVM2BErlBwhm5zSRgaibZXIO6Y52cRfG2DALHE2JpyC3rnAL5ZpviELjEOWBa82uLNVMtxY80f2D7GlACAg6hYAOAIOtAqdAx840WOoH+bcxUdNH1Sa2RIQ/YO3wGxQ0SNooBtlhTePtUBD6szL1kS8fBi8eWrNdegs9BQ6V2EFN4ZO6K9tIcYNn/p7G1bCLFL+bGUgIMxfBusgBDPAB20wG+Iw58iOnK3Z0KCz2YjtffJmE0bMB8GWO/aSYZGrNQdmkYWvJvEBr9YlnjbeCEIyfBdYXYpbMnsvYiXoF2IW4y8krEIihcYLGYm2Xsiy6n8lG9FHDaUJgHChMVyIpci8kOBMIoXzQkaa24UszjOzzRgvLVo41zwFkrUsTheeLGq0luvKBI9363bI/I/UnpUjU/aWESW7Qavf/srTLsLdk/SgYgF+53LtnX7u6l2TFxONM460lxWEVJyPM7+C2PPCyUGijhxKsV5QDDgiQCKKGMQiC7KihL8NTQEloWSUglIRB8EIiuEEKS2/BwzL8YIoyYqq6Ybps2zH9UxPpnPLY/DIX2t3r1ri/tZiqS5yPy80JSWfGUBAgQoNOgyYsGDDgQvP81fmBJABBBSo0KDDgAkLNhy48JSkAQAAAAAAAAAAACD0yA=="

/***/ },

/***/ "./src/styles/fonts/flatline/flatline.woff":
/***/ function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ },

/***/ "./src/styles/fonts/mfizz/mfizz.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "184b328192ac4fd8351bcbdfd102c8f3.woff2";

/***/ },

/***/ "./src/styles/fonts/mfizz/mfizz.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "021e07f954ddecdb17da26e9bc7ef284.woff";

/***/ },

/***/ "./src/styles/fonts/nargela/nargela.woff2":
/***/ function(module, exports) {

	module.exports = "data:application/font-woff2;base64,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"

/***/ },

/***/ "./src/styles/fonts/nargela/nargela.woff":
/***/ function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ },

/***/ "./src/styles/fonts/glyphicons/glyphicons-webfont.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "448c34a56d699c29117adc64c43affeb.woff2";

/***/ },

/***/ "./src/styles/fonts/glyphicons/glyphicons-webfont.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fa2772327f55d8198301fdb8bcfc8158.woff";

/***/ },

/***/ "./src/styles/fonts/ikons/ikons.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "14f4a6dd897ffb8e31ab9eb047836933.woff2";

/***/ },

/***/ "./src/styles/fonts/ikons/ikons.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "93f7c2590937d12e4681296ba12b06e3.woff";

/***/ },

/***/ "./src/styles/fonts/outlined/outlined.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bffb005d16c1267ab0021961c6afa35c.woff2";

/***/ },

/***/ "./src/styles/fonts/outlined/outlined.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "87ad218bc1096cbc21ca760a95aedabf.woff";

/***/ },

/***/ "./src/styles/fonts/pixelvicon/pixelvicon.woff2":
/***/ function(module, exports) {

	module.exports = "data:application/font-woff2;base64,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"

/***/ },

/***/ "./src/styles/fonts/pixelvicon/pixelvicon.woff":
/***/ function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ },

/***/ "./src/styles/fonts/Simple-Line-Icons/Simple-Line-Icons.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4ea348178a31c0f2f1e3e755160d9874.woff2";

/***/ },

/***/ "./src/styles/fonts/Simple-Line-Icons/Simple-Line-Icons.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b26af4c101ccfdc230d3c6436249c0f4.woff";

/***/ },

/***/ "./src/styles/fonts/Stroke-Gap-Icons/Stroke-Gap-Icons.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7f0993c06ad663e76ee3421c403d05cf.woff2";

/***/ },

/***/ "./src/styles/fonts/Stroke-Gap-Icons/Stroke-Gap-Icons.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f92e81f2f55f2172246aaa6e91926323.woff";

/***/ },

/***/ "./node_modules/style-loader/addStyles.js":
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },

/***/ "./node_modules/meteor-imports-webpack-plugin/meteor-imports.js":
/***/ function(module, exports, __webpack_require__) {

	/* eslint-env browser */
	
	var manifest = __webpack_require__("./node_modules/json-loader/index.js!./build/meteor/bundle/programs/web.browser/program.json").manifest;
	var config = __webpack_require__("./node_modules/meteor-imports-webpack-plugin/meteor-config.json");
	
	if (config.injectMeteorRuntimeConfig !== false) window.__meteor_runtime_config__ = config;
	
	// Create context to create a chunk for each Meteor package.
	var req = __webpack_require__(1);
	
	// Create regexp to exclude the packages we don't want.
	var excluded = new RegExp(config.exclude
	  .map(function(exclude){ return '^packages/' + exclude + '.js$'; })
	  .concat('^app\/.+.js$')
	  .join('|'));
	
	// Require the Meteor packages.
	manifest.forEach(function(pckge){
	  if (pckge.type === 'js' && !excluded.test(pckge.path))
	    req('./' + pckge.path.replace('packages/', ''));
	});
	
	if (false) module.hot.accept();


/***/ },

/***/ "./node_modules/json-loader/index.js!./build/meteor/bundle/programs/web.browser/program.json":
/***/ function(module, exports) {

	module.exports = {"format":"web-program-pre1","manifest":[{"path":"packages/underscore.js","where":"client","type":"js","cacheable":true,"url":"/packages/underscore.js?hash=cde485f60699ff9aced3305f70189e39c665183c","size":150249,"hash":"cde485f60699ff9aced3305f70189e39c665183c"},{"path":"packages/meteor.js","where":"client","type":"js","cacheable":true,"url":"/packages/meteor.js?hash=e3f53db3be730057fed1a5f709ecd5fc7cae1229","size":121106,"hash":"e3f53db3be730057fed1a5f709ecd5fc7cae1229"},{"path":"packages/modules-runtime.js","where":"client","type":"js","cacheable":true,"url":"/packages/modules-runtime.js?hash=637cb12b6fd3acf3ffbfcf0f2ee1cf3988a7f1fe","size":40108,"hash":"637cb12b6fd3acf3ffbfcf0f2ee1cf3988a7f1fe"},{"path":"packages/modules.js","where":"client","type":"js","cacheable":true,"url":"/packages/modules.js?hash=70304d38817ec2d3f658dfaef884ef6e0fe7c9a7","size":393191,"hash":"70304d38817ec2d3f658dfaef884ef6e0fe7c9a7"},{"path":"packages/promise.js","where":"client","type":"js","cacheable":true,"url":"/packages/promise.js?hash=d33dfe2c4ba20393154f419ebfceeaf610499291","size":65658,"hash":"d33dfe2c4ba20393154f419ebfceeaf610499291"},{"path":"packages/ecmascript-runtime.js","where":"client","type":"js","cacheable":true,"url":"/packages/ecmascript-runtime.js?hash=f7e181e2f8dad8ea7cdf1faaf8f3c1b47de11272","size":519496,"hash":"f7e181e2f8dad8ea7cdf1faaf8f3c1b47de11272"},{"path":"packages/babel-compiler.js","where":"client","type":"js","cacheable":true,"url":"/packages/babel-compiler.js?hash=a9546d4e245cfe40b406e08d40bf106241f01683","size":723,"hash":"a9546d4e245cfe40b406e08d40bf106241f01683"},{"path":"packages/ecmascript.js","where":"client","type":"js","cacheable":true,"url":"/packages/ecmascript.js?hash=370a8752194bcf73be7fffa3635715d0fbf7853d","size":716,"hash":"370a8752194bcf73be7fffa3635715d0fbf7853d"},{"path":"packages/base64.js","where":"client","type":"js","cacheable":true,"url":"/packages/base64.js?hash=0053489bb30bb5c0e3545df151f83e41150344b0","size":15332,"hash":"0053489bb30bb5c0e3545df151f83e41150344b0"},{"path":"packages/ejson.js","where":"client","type":"js","cacheable":true,"url":"/packages/ejson.js?hash=0f17ced99d522d48cd8f8b2139167fd06babd969","size":81952,"hash":"0f17ced99d522d48cd8f8b2139167fd06babd969"},{"path":"packages/id-map.js","where":"client","type":"js","cacheable":true,"url":"/packages/id-map.js?hash=c7aea8dfa2bf46ff2ae0aa6c6cf09e36abc61d07","size":8189,"hash":"c7aea8dfa2bf46ff2ae0aa6c6cf09e36abc61d07"},{"path":"packages/ordered-dict.js","where":"client","type":"js","cacheable":true,"url":"/packages/ordered-dict.js?hash=bacdd1852075630a01f7de783e5e8e8aa8541cdc","size":20041,"hash":"bacdd1852075630a01f7de783e5e8e8aa8541cdc"},{"path":"packages/tracker.js","where":"client","type":"js","cacheable":true,"url":"/packages/tracker.js?hash=9f8a0cec09c662aad5a5e224447b2d4e88d011ef","size":85367,"hash":"9f8a0cec09c662aad5a5e224447b2d4e88d011ef"},{"path":"packages/babel-runtime.js","where":"client","type":"js","cacheable":true,"url":"/packages/babel-runtime.js?hash=1db3784a7268156b770997413c0a7a82d866994a","size":11132,"hash":"1db3784a7268156b770997413c0a7a82d866994a"},{"path":"packages/random.js","where":"client","type":"js","cacheable":true,"url":"/packages/random.js?hash=31dadb9d3427506dd30dc50f5c898837e69e739b","sourceMap":"packages/random.js.map","sourceMapUrl":"/packages/31dadb9d3427506dd30dc50f5c898837e69e739b.map","size":40073,"hash":"31dadb9d3427506dd30dc50f5c898837e69e739b"},{"path":"packages/mongo-id.js","where":"client","type":"js","cacheable":true,"url":"/packages/mongo-id.js?hash=345d169d517353f8146292b4abd24061721f8b26","size":12235,"hash":"345d169d517353f8146292b4abd24061721f8b26"},{"path":"packages/diff-sequence.js","where":"client","type":"js","cacheable":true,"url":"/packages/diff-sequence.js?hash=15014d7b1e11c05111a386992e684ab1d3cc4158","size":24291,"hash":"15014d7b1e11c05111a386992e684ab1d3cc4158"},{"path":"packages/geojson-utils.js","where":"client","type":"js","cacheable":true,"url":"/packages/geojson-utils.js?hash=b204c7d4caf119e6883522fb87c6cce060724bf0","size":46635,"hash":"b204c7d4caf119e6883522fb87c6cce060724bf0"},{"path":"packages/minimongo.js","where":"client","type":"js","cacheable":true,"url":"/packages/minimongo.js?hash=66cc6ab213289f154f49d61566dba8ff9dfc33b2","size":449841,"hash":"66cc6ab213289f154f49d61566dba8ff9dfc33b2"},{"path":"packages/check.js","where":"client","type":"js","cacheable":true,"url":"/packages/check.js?hash=63d7478b74cadc04d378bc2266ea8bd1bf6849d8","size":71681,"hash":"63d7478b74cadc04d378bc2266ea8bd1bf6849d8"},{"path":"packages/retry.js","where":"client","type":"js","cacheable":true,"url":"/packages/retry.js?hash=1e409617b538ff3e2b0238b15e45b3380c51a224","size":6891,"hash":"1e409617b538ff3e2b0238b15e45b3380c51a224"},{"path":"packages/ddp-common.js","where":"client","type":"js","cacheable":true,"url":"/packages/ddp-common.js?hash=d42359bcace6c66ac90e2782193494253ee68155","size":45313,"hash":"d42359bcace6c66ac90e2782193494253ee68155"},{"path":"packages/ddp-client.js","where":"client","type":"js","cacheable":true,"url":"/packages/ddp-client.js?hash=bc32a166cd269e06a394f9418e0024d805bab379","size":594795,"hash":"bc32a166cd269e06a394f9418e0024d805bab379"},{"path":"packages/ddp.js","where":"client","type":"js","cacheable":true,"url":"/packages/ddp.js?hash=25dc3f428447c81620c91c4245dbc6e4f7d32fb7","size":874,"hash":"25dc3f428447c81620c91c4245dbc6e4f7d32fb7"},{"path":"packages/ddp-server.js","where":"client","type":"js","cacheable":true,"url":"/packages/ddp-server.js?hash=1beefbc7bd033ea687e7ab8fbd5694df072662af","size":719,"hash":"1beefbc7bd033ea687e7ab8fbd5694df072662af"},{"path":"packages/allow-deny.js","where":"client","type":"js","cacheable":true,"url":"/packages/allow-deny.js?hash=c9344ef36901e05cbb58a8485e17433dac946bdc","sourceMap":"packages/allow-deny.js.map","sourceMapUrl":"/packages/c9344ef36901e05cbb58a8485e17433dac946bdc.map","size":60486,"hash":"c9344ef36901e05cbb58a8485e17433dac946bdc"},{"path":"packages/mongo.js","where":"client","type":"js","cacheable":true,"url":"/packages/mongo.js?hash=c4281c0ff989ebee020f59f5a7b0735053cea5f7","sourceMap":"packages/mongo.js.map","sourceMapUrl":"/packages/c4281c0ff989ebee020f59f5a7b0735053cea5f7.map","size":109350,"hash":"c4281c0ff989ebee020f59f5a7b0735053cea5f7"},{"path":"packages/webapp.js","where":"client","type":"js","cacheable":true,"url":"/packages/webapp.js?hash=3026d4501b6e3076a0aea1f7628466ebbe004a29","sourceMap":"packages/webapp.js.map","sourceMapUrl":"/packages/3026d4501b6e3076a0aea1f7628466ebbe004a29.map","size":3458,"hash":"3026d4501b6e3076a0aea1f7628466ebbe004a29"},{"path":"packages/autoupdate.js","where":"client","type":"js","cacheable":true,"url":"/packages/autoupdate.js?hash=1fd9cf3472adaa6887170d88ab5ea1ddabf695fa","size":17200,"hash":"1fd9cf3472adaa6887170d88ab5ea1ddabf695fa"},{"path":"packages/dburles_collection-helpers.js","where":"client","type":"js","cacheable":true,"url":"/packages/dburles_collection-helpers.js?hash=3ef2eff277fdbdf9dc43ba883d1e1c774bfa77f9","size":3054,"hash":"3ef2eff277fdbdf9dc43ba883d1e1c774bfa77f9"},{"path":"packages/ddp-rate-limiter.js","where":"client","type":"js","cacheable":true,"url":"/packages/ddp-rate-limiter.js?hash=457af847f89d207a6ca630c56f06d2a3af3a414c","size":725,"hash":"457af847f89d207a6ca630c56f06d2a3af3a414c"},{"path":"packages/localstorage.js","where":"client","type":"js","cacheable":true,"url":"/packages/localstorage.js?hash=0e2106503b232ac80073b6e8ef206e988c5aca5b","size":6638,"hash":"0e2106503b232ac80073b6e8ef206e988c5aca5b"},{"path":"packages/callback-hook.js","where":"client","type":"js","cacheable":true,"url":"/packages/callback-hook.js?hash=e15ed8aa52e7c647efd9f4854e8a0fe4e40808fc","size":14275,"hash":"e15ed8aa52e7c647efd9f4854e8a0fe4e40808fc"},{"path":"packages/accounts-base.js","where":"client","type":"js","cacheable":true,"url":"/packages/accounts-base.js?hash=dfba72beacc01e72b0f8fb3d7770c95ac774f2b8","sourceMap":"packages/accounts-base.js.map","sourceMapUrl":"/packages/dfba72beacc01e72b0f8fb3d7770c95ac774f2b8.map","size":154328,"hash":"dfba72beacc01e72b0f8fb3d7770c95ac774f2b8"},{"path":"packages/sha.js","where":"client","type":"js","cacheable":true,"url":"/packages/sha.js?hash=04013281f0c21857cac3458d88a0dd86b20109ba","size":19230,"hash":"04013281f0c21857cac3458d88a0dd86b20109ba"},{"path":"packages/srp.js","where":"client","type":"js","cacheable":true,"url":"/packages/srp.js?hash=85fa5b3bc1440273f8fa5125df5443c09f337567","size":173114,"hash":"85fa5b3bc1440273f8fa5125df5443c09f337567"},{"path":"packages/accounts-password.js","where":"client","type":"js","cacheable":true,"url":"/packages/accounts-password.js?hash=6d4e41828e1dfcc45ff74267779a4e5ecdcd9eda","sourceMap":"packages/accounts-password.js.map","sourceMapUrl":"/packages/6d4e41828e1dfcc45ff74267779a4e5ecdcd9eda.map","size":33911,"hash":"6d4e41828e1dfcc45ff74267779a4e5ecdcd9eda"},{"path":"packages/deps.js","where":"client","type":"js","cacheable":true,"url":"/packages/deps.js?hash=7313f5a2685c6c2c673c78c15c8ce86ff59ab0c9","size":932,"hash":"7313f5a2685c6c2c673c78c15c8ce86ff59ab0c9"},{"path":"packages/aldeed_simple-schema.js","where":"client","type":"js","cacheable":true,"url":"/packages/aldeed_simple-schema.js?hash=13e803ef04b6685a7577083e5871767a498b6351","size":383353,"hash":"13e803ef04b6685a7577083e5871767a498b6351"},{"path":"packages/raix_eventemitter.js","where":"client","type":"js","cacheable":true,"url":"/packages/raix_eventemitter.js?hash=b009bf66474c7942360d5e2bba2398ec847d81dc","size":26336,"hash":"b009bf66474c7942360d5e2bba2398ec847d81dc"},{"path":"packages/aldeed_collection2-core.js","where":"client","type":"js","cacheable":true,"url":"/packages/aldeed_collection2-core.js?hash=cd76f0a8f289f873c33e0896e9a86201e64a47d1","size":85078,"hash":"cd76f0a8f289f873c33e0896e9a86201e64a47d1"},{"path":"packages/aldeed_schema-index.js","where":"client","type":"js","cacheable":true,"url":"/packages/aldeed_schema-index.js?hash=1a8e1f4b09d74c1c99b0cb86b0f6e8495e6591e5","sourceMap":"packages/aldeed_schema-index.js.map","sourceMapUrl":"/packages/1a8e1f4b09d74c1c99b0cb86b0f6e8495e6591e5.map","size":9551,"hash":"1a8e1f4b09d74c1c99b0cb86b0f6e8495e6591e5"},{"path":"packages/aldeed_schema-deny.js","where":"client","type":"js","cacheable":true,"url":"/packages/aldeed_schema-deny.js?hash=c46f0998a459ed45c0c557fcb85c31b85c40e7d4","size":4902,"hash":"c46f0998a459ed45c0c557fcb85c31b85c40e7d4"},{"path":"packages/aldeed_collection2.js","where":"client","type":"js","cacheable":true,"url":"/packages/aldeed_collection2.js?hash=2a40052f92753d39451338b55e6d318a4bf46a3b","size":727,"hash":"2a40052f92753d39451338b55e6d318a4bf46a3b"},{"path":"packages/reactive-dict.js","where":"client","type":"js","cacheable":true,"url":"/packages/reactive-dict.js?hash=6e313616fd3cbca06ed28d63ffd0164d2a78d804","sourceMap":"packages/reactive-dict.js.map","sourceMapUrl":"/packages/6e313616fd3cbca06ed28d63ffd0164d2a78d804.map","size":40666,"hash":"6e313616fd3cbca06ed28d63ffd0164d2a78d804"},{"path":"packages/session.js","where":"client","type":"js","cacheable":true,"url":"/packages/session.js?hash=821b0746e602b3be69538d299d6866e222121b54","size":6138,"hash":"821b0746e602b3be69538d299d6866e222121b54"},{"path":"packages/email.js","where":"client","type":"js","cacheable":true,"url":"/packages/email.js?hash=ffec1d26147328d1230a496251100a98dd10ec34","size":711,"hash":"ffec1d26147328d1230a496251100a98dd10ec34"},{"path":"packages/matb33_collection-hooks.js","where":"client","type":"js","cacheable":true,"url":"/packages/matb33_collection-hooks.js?hash=d44fd0eb02806747e1bb0bdc3938463e415c63ec","size":96236,"hash":"d44fd0eb02806747e1bb0bdc3938463e415c63ec"},{"path":"packages/mdg_validated-method.js","where":"client","type":"js","cacheable":true,"url":"/packages/mdg_validated-method.js?hash=c04aadc8d2c4f51e251ce89a391b396e22757975","sourceMap":"packages/mdg_validated-method.js.map","sourceMapUrl":"/packages/c04aadc8d2c4f51e251ce89a391b396e22757975.map","size":19210,"hash":"c04aadc8d2c4f51e251ce89a391b396e22757975"},{"path":"packages/url.js","where":"client","type":"js","cacheable":true,"url":"/packages/url.js?hash=7eb918ff381bb4bb1470d8fb1c3b9dcfe3dc97e4","size":6287,"hash":"7eb918ff381bb4bb1470d8fb1c3b9dcfe3dc97e4"},{"path":"packages/http.js","where":"client","type":"js","cacheable":true,"url":"/packages/http.js?hash=c5adc9c96baa2fe4d0b14eaee51d32ed0e4d4097","sourceMap":"packages/http.js.map","sourceMapUrl":"/packages/c5adc9c96baa2fe4d0b14eaee51d32ed0e4d4097.map","size":38346,"hash":"c5adc9c96baa2fe4d0b14eaee51d32ed0e4d4097"},{"path":"packages/meteorhacks_picker.js","where":"client","type":"js","cacheable":true,"url":"/packages/meteorhacks_picker.js?hash=56585121bc9cb10cb03f03abc33aef5266599360","size":1626,"hash":"56585121bc9cb10cb03f03abc33aef5266599360"},{"path":"packages/meteorhacks_cluster.js","where":"client","type":"js","cacheable":true,"url":"/packages/meteorhacks_cluster.js?hash=b46e3a9933fa09c4212d47912ca45c4f54e3a09e","size":11900,"hash":"b46e3a9933fa09c4212d47912ca45c4f54e3a09e"},{"path":"packages/global-imports.js","where":"client","type":"js","cacheable":true,"url":"/packages/global-imports.js?hash=1c7d92ea79392c67a82c7361119d41d05654dbb0","size":821,"hash":"1c7d92ea79392c67a82c7361119d41d05654dbb0"},{"path":"packages/service-configuration.js","where":"client","type":"js","cacheable":true,"url":"/packages/service-configuration.js?hash=42ac9ae8eb44f3e73762f9cb0003410397021984","size":4728,"hash":"42ac9ae8eb44f3e73762f9cb0003410397021984"},{"path":"packages/mdg_validation-error.js","where":"client","type":"js","cacheable":true,"url":"/packages/mdg_validation-error.js?hash=fb4d5a92e8804a44e6302c6472d9236557d2b8b2","sourceMap":"packages/mdg_validation-error.js.map","sourceMapUrl":"/packages/fb4d5a92e8804a44e6302c6472d9236557d2b8b2.map","size":7428,"hash":"fb4d5a92e8804a44e6302c6472d9236557d2b8b2"}]}

/***/ },

/***/ "./node_modules/meteor-imports-webpack-plugin/meteor-config.json":
/***/ function(module, exports) {

	module.exports = {"meteorProgramsFolder":"/usr/app/build/meteor/bundle/programs","injectMeteorRuntimeConfig":false,"exclude":["autoupdate","global-imports","hot-code-push","reload","ecmascript"]}

/***/ },

/***/ 1:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./accounts-base.js": "./build/meteor/bundle/programs/web.browser/packages/accounts-base.js",
		"./accounts-password.js": "./build/meteor/bundle/programs/web.browser/packages/accounts-password.js",
		"./aldeed_collection2-core.js": "./build/meteor/bundle/programs/web.browser/packages/aldeed_collection2-core.js",
		"./aldeed_collection2.js": "./build/meteor/bundle/programs/web.browser/packages/aldeed_collection2.js",
		"./aldeed_schema-deny.js": "./build/meteor/bundle/programs/web.browser/packages/aldeed_schema-deny.js",
		"./aldeed_schema-index.js": "./build/meteor/bundle/programs/web.browser/packages/aldeed_schema-index.js",
		"./aldeed_simple-schema.js": "./build/meteor/bundle/programs/web.browser/packages/aldeed_simple-schema.js",
		"./allow-deny.js": "./build/meteor/bundle/programs/web.browser/packages/allow-deny.js",
		"./babel-compiler.js": "./build/meteor/bundle/programs/web.browser/packages/babel-compiler.js",
		"./babel-runtime.js": "./build/meteor/bundle/programs/web.browser/packages/babel-runtime.js",
		"./base64.js": "./build/meteor/bundle/programs/web.browser/packages/base64.js",
		"./callback-hook.js": "./build/meteor/bundle/programs/web.browser/packages/callback-hook.js",
		"./check.js": "./build/meteor/bundle/programs/web.browser/packages/check.js",
		"./dburles_collection-helpers.js": "./build/meteor/bundle/programs/web.browser/packages/dburles_collection-helpers.js",
		"./ddp-client.js": "./build/meteor/bundle/programs/web.browser/packages/ddp-client.js",
		"./ddp-common.js": "./build/meteor/bundle/programs/web.browser/packages/ddp-common.js",
		"./ddp-rate-limiter.js": "./build/meteor/bundle/programs/web.browser/packages/ddp-rate-limiter.js",
		"./ddp-server.js": "./build/meteor/bundle/programs/web.browser/packages/ddp-server.js",
		"./ddp.js": "./build/meteor/bundle/programs/web.browser/packages/ddp.js",
		"./deps.js": "./build/meteor/bundle/programs/web.browser/packages/deps.js",
		"./diff-sequence.js": "./build/meteor/bundle/programs/web.browser/packages/diff-sequence.js",
		"./ecmascript-runtime.js": "./build/meteor/bundle/programs/web.browser/packages/ecmascript-runtime.js",
		"./ejson.js": "./build/meteor/bundle/programs/web.browser/packages/ejson.js",
		"./email.js": "./build/meteor/bundle/programs/web.browser/packages/email.js",
		"./geojson-utils.js": "./build/meteor/bundle/programs/web.browser/packages/geojson-utils.js",
		"./http.js": "./build/meteor/bundle/programs/web.browser/packages/http.js",
		"./id-map.js": "./build/meteor/bundle/programs/web.browser/packages/id-map.js",
		"./localstorage.js": "./build/meteor/bundle/programs/web.browser/packages/localstorage.js",
		"./matb33_collection-hooks.js": "./build/meteor/bundle/programs/web.browser/packages/matb33_collection-hooks.js",
		"./mdg_validated-method.js": "./build/meteor/bundle/programs/web.browser/packages/mdg_validated-method.js",
		"./mdg_validation-error.js": "./build/meteor/bundle/programs/web.browser/packages/mdg_validation-error.js",
		"./meteor.js": "./build/meteor/bundle/programs/web.browser/packages/meteor.js",
		"./meteorhacks_cluster.js": "./build/meteor/bundle/programs/web.browser/packages/meteorhacks_cluster.js",
		"./meteorhacks_picker.js": "./build/meteor/bundle/programs/web.browser/packages/meteorhacks_picker.js",
		"./minimongo.js": "./build/meteor/bundle/programs/web.browser/packages/minimongo.js",
		"./modules-runtime.js": "./build/meteor/bundle/programs/web.browser/packages/modules-runtime.js",
		"./modules.js": "./build/meteor/bundle/programs/web.browser/packages/modules.js",
		"./mongo-id.js": "./build/meteor/bundle/programs/web.browser/packages/mongo-id.js",
		"./mongo.js": "./build/meteor/bundle/programs/web.browser/packages/mongo.js",
		"./ordered-dict.js": "./build/meteor/bundle/programs/web.browser/packages/ordered-dict.js",
		"./promise.js": "./build/meteor/bundle/programs/web.browser/packages/promise.js",
		"./raix_eventemitter.js": "./build/meteor/bundle/programs/web.browser/packages/raix_eventemitter.js",
		"./random.js": "./build/meteor/bundle/programs/web.browser/packages/random.js",
		"./reactive-dict.js": "./build/meteor/bundle/programs/web.browser/packages/reactive-dict.js",
		"./retry.js": "./build/meteor/bundle/programs/web.browser/packages/retry.js",
		"./service-configuration.js": "./build/meteor/bundle/programs/web.browser/packages/service-configuration.js",
		"./session.js": "./build/meteor/bundle/programs/web.browser/packages/session.js",
		"./sha.js": "./build/meteor/bundle/programs/web.browser/packages/sha.js",
		"./srp.js": "./build/meteor/bundle/programs/web.browser/packages/srp.js",
		"./tracker.js": "./build/meteor/bundle/programs/web.browser/packages/tracker.js",
		"./underscore.js": "./build/meteor/bundle/programs/web.browser/packages/underscore.js",
		"./url.js": "./build/meteor/bundle/programs/web.browser/packages/url.js",
		"./webapp.js": "./build/meteor/bundle/programs/web.browser/packages/webapp.js"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1;


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/accounts-base.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	var Tracker = Package.tracker.Tracker;
	var Deps = Package.tracker.Deps;
	var Random = Package.random.Random;
	var Hook = Package['callback-hook'].Hook;
	var DDP = Package['ddp-client'].DDP;
	var Mongo = Package.mongo.Mongo;
	var meteorInstall = Package.modules.meteorInstall;
	var Buffer = Package.modules.Buffer;
	var process = Package.modules.process;
	var Symbol = Package['ecmascript-runtime'].Symbol;
	var Map = Package['ecmascript-runtime'].Map;
	var Set = Package['ecmascript-runtime'].Set;
	var meteorBabelHelpers = Package['babel-runtime'].meteorBabelHelpers;
	var Promise = Package.promise.Promise;
	
	/* Package-scope variables */
	var Accounts, EXPIRE_TOKENS_INTERVAL_MS, CONNECTION_CLOSE_DELAY_MS;
	
	var require = meteorInstall({"node_modules":{"meteor":{"accounts-base":{"client_main.js":["./accounts_client.js","./url_client.js","./localstorage_token.js",function(require,exports,module){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                   //
	// packages/accounts-base/client_main.js                                                                             //
	//                                                                                                                   //
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                     //
	module.export({AccountsClient:function(){return AccountsClient},AccountsTest:function(){return AccountsTest}});var AccountsClient;module.import("./accounts_client.js",{"AccountsClient":function(v){AccountsClient=v}});var AccountsTest;module.import("./url_client.js",{"AccountsTest":function(v){AccountsTest=v}});module.import("./localstorage_token.js");
	                                                                                                                     // 2
	                                                                                                                     // 3
	                                                                                                                     //
	/**                                                                                                                  // 5
	 * @namespace Accounts                                                                                               //
	 * @summary The namespace for all client-side accounts-related methods.                                              //
	 */                                                                                                                  //
	Accounts = new AccountsClient();                                                                                     // 9
	                                                                                                                     //
	/**                                                                                                                  // 11
	 * @summary A [Mongo.Collection](#collections) containing user documents.                                            //
	 * @locus Anywhere                                                                                                   //
	 * @type {Mongo.Collection}                                                                                          //
	 * @importFromPackage meteor                                                                                         //
	 */                                                                                                                  //
	Meteor.users = Accounts.users;                                                                                       // 17
	                                                                                                                     //
	                                                                                                                     // 19
	                                                                                                                     // 20
	                                                                                                                     // 21
	                                                                                                                     // 22
	                                                                                                                     // 23
	                                                                                                                     // 24
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"accounts_client.js":["babel-runtime/helpers/classCallCheck","babel-runtime/helpers/possibleConstructorReturn","babel-runtime/helpers/inherits","./accounts_common.js",function(require,exports,module){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                   //
	// packages/accounts-base/accounts_client.js                                                                         //
	//                                                                                                                   //
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                     //
	module.export({AccountsClient:function(){return AccountsClient}});var _classCallCheck;module.import("babel-runtime/helpers/classCallCheck",{"default":function(v){_classCallCheck=v}});var _possibleConstructorReturn;module.import("babel-runtime/helpers/possibleConstructorReturn",{"default":function(v){_possibleConstructorReturn=v}});var _inherits;module.import("babel-runtime/helpers/inherits",{"default":function(v){_inherits=v}});var AccountsCommon;module.import("./accounts_common.js",{"AccountsCommon":function(v){AccountsCommon=v}});
	                                                                                                                     //
	                                                                                                                     //
	                                                                                                                     // 1
	                                                                                                                     //
	/**                                                                                                                  // 3
	 * @summary Constructor for the `Accounts` object on the client.                                                     //
	 * @locus Client                                                                                                     //
	 * @class AccountsClient                                                                                             //
	 * @extends AccountsCommon                                                                                           //
	 * @instancename accountsClient                                                                                      //
	 * @param {Object} options an object with fields:                                                                    //
	 * @param {Object} options.connection Optional DDP connection to reuse.                                              //
	 * @param {String} options.ddpUrl Optional URL for creating a new DDP connection.                                    //
	 */                                                                                                                  //
	var AccountsClient = function (_AccountsCommon) {                                                                    // 13
	  _inherits(AccountsClient, _AccountsCommon);                                                                        // 13
	                                                                                                                     //
	  function AccountsClient(options) {                                                                                 // 14
	    _classCallCheck(this, AccountsClient);                                                                           // 14
	                                                                                                                     //
	    var _this = _possibleConstructorReturn(this, _AccountsCommon.call(this, options));                               // 14
	                                                                                                                     //
	    _this._loggingIn = false;                                                                                        // 17
	    _this._loggingInDeps = new Tracker.Dependency();                                                                 // 18
	                                                                                                                     //
	    _this._loginServicesHandle = _this.connection.subscribe("meteor.loginServiceConfiguration");                     // 20
	                                                                                                                     //
	    _this._pageLoadLoginCallbacks = [];                                                                              // 23
	    _this._pageLoadLoginAttemptInfo = null;                                                                          // 24
	                                                                                                                     //
	    // Defined in url_client.js.                                                                                     // 26
	    _this._initUrlMatching();                                                                                        // 27
	                                                                                                                     //
	    // Defined in localstorage_token.js.                                                                             // 29
	    _this._initLocalStorage();                                                                                       // 30
	    return _this;                                                                                                    // 14
	  }                                                                                                                  // 31
	                                                                                                                     //
	  ///                                                                                                                // 33
	  /// CURRENT USER                                                                                                   // 34
	  ///                                                                                                                // 35
	                                                                                                                     //
	  // @override                                                                                                       // 37
	                                                                                                                     //
	                                                                                                                     //
	  AccountsClient.prototype.userId = function () {                                                                    // 13
	    function userId() {                                                                                              // 13
	      return this.connection.userId();                                                                               // 39
	    }                                                                                                                // 40
	                                                                                                                     //
	    return userId;                                                                                                   // 13
	  }();                                                                                                               // 13
	                                                                                                                     //
	  // This is mostly just called within this file, but Meteor.loginWithPassword                                       // 42
	  // also uses it to make loggingIn() be true during the beginPasswordExchange                                       // 43
	  // method call too.                                                                                                // 44
	                                                                                                                     //
	                                                                                                                     //
	  AccountsClient.prototype._setLoggingIn = function () {                                                             // 13
	    function _setLoggingIn(x) {                                                                                      // 13
	      if (this._loggingIn !== x) {                                                                                   // 46
	        this._loggingIn = x;                                                                                         // 47
	        this._loggingInDeps.changed();                                                                               // 48
	      }                                                                                                              // 49
	    }                                                                                                                // 50
	                                                                                                                     //
	    return _setLoggingIn;                                                                                            // 13
	  }();                                                                                                               // 13
	                                                                                                                     //
	  /**                                                                                                                // 52
	   * @summary True if a login method (such as `Meteor.loginWithPassword`, `Meteor.loginWithFacebook`, or `Accounts.createUser`) is currently in progress. A reactive data source.
	   * @locus Client                                                                                                   //
	   */                                                                                                                //
	                                                                                                                     //
	                                                                                                                     //
	  AccountsClient.prototype.loggingIn = function () {                                                                 // 13
	    function loggingIn() {                                                                                           // 13
	      this._loggingInDeps.depend();                                                                                  // 57
	      return this._loggingIn;                                                                                        // 58
	    }                                                                                                                // 59
	                                                                                                                     //
	    return loggingIn;                                                                                                // 13
	  }();                                                                                                               // 13
	                                                                                                                     //
	  /**                                                                                                                // 61
	   * @summary Log the user out.                                                                                      //
	   * @locus Client                                                                                                   //
	   * @param {Function} [callback] Optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
	   */                                                                                                                //
	                                                                                                                     //
	                                                                                                                     //
	  AccountsClient.prototype.logout = function () {                                                                    // 13
	    function logout(callback) {                                                                                      // 13
	      var self = this;                                                                                               // 67
	      self.connection.apply('logout', [], {                                                                          // 68
	        wait: true                                                                                                   // 69
	      }, function (error, result) {                                                                                  // 68
	        if (error) {                                                                                                 // 71
	          callback && callback(error);                                                                               // 72
	        } else {                                                                                                     // 73
	          self.makeClientLoggedOut();                                                                                // 74
	          callback && callback();                                                                                    // 75
	        }                                                                                                            // 76
	      });                                                                                                            // 77
	    }                                                                                                                // 78
	                                                                                                                     //
	    return logout;                                                                                                   // 13
	  }();                                                                                                               // 13
	                                                                                                                     //
	  /**                                                                                                                // 80
	   * @summary Log out other clients logged in as the current user, but does not log out the client that calls this function.
	   * @locus Client                                                                                                   //
	   * @param {Function} [callback] Optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
	   */                                                                                                                //
	                                                                                                                     //
	                                                                                                                     //
	  AccountsClient.prototype.logoutOtherClients = function () {                                                        // 13
	    function logoutOtherClients(callback) {                                                                          // 13
	      var self = this;                                                                                               // 86
	                                                                                                                     //
	      // We need to make two method calls: one to replace our current token,                                         // 88
	      // and another to remove all tokens except the current one. We want to                                         // 89
	      // call these two methods one after the other, without any other                                               // 90
	      // methods running between them. For example, we don't want `logout`                                           // 91
	      // to be called in between our two method calls (otherwise the second                                          // 92
	      // method call would return an error). Another example: we don't want                                          // 93
	      // logout to be called before the callback for `getNewToken`;                                                  // 94
	      // otherwise we would momentarily log the user out and then write a                                            // 95
	      // new token to localStorage.                                                                                  // 96
	      //                                                                                                             // 97
	      // To accomplish this, we make both calls as wait methods, and queue                                           // 98
	      // them one after the other, without spinning off the event loop in                                            // 99
	      // between. Even though we queue `removeOtherTokens` before                                                    // 100
	      // `getNewToken`, we won't actually send the `removeOtherTokens` call                                          // 101
	      // until the `getNewToken` callback has finished running, because they                                         // 102
	      // are both wait methods.                                                                                      // 103
	      self.connection.apply('getNewToken', [], { wait: true }, function (err, result) {                              // 104
	        if (!err) {                                                                                                  // 109
	          self._storeLoginToken(self.userId(), result.token, result.tokenExpires);                                   // 110
	        }                                                                                                            // 115
	      });                                                                                                            // 116
	                                                                                                                     //
	      self.connection.apply('removeOtherTokens', [], { wait: true }, function (err) {                                // 119
	        callback && callback(err);                                                                                   // 124
	      });                                                                                                            // 125
	    }                                                                                                                // 127
	                                                                                                                     //
	    return logoutOtherClients;                                                                                       // 13
	  }();                                                                                                               // 13
	                                                                                                                     //
	  return AccountsClient;                                                                                             // 13
	}(AccountsCommon);;                                                                                                  // 13
	                                                                                                                     //
	var Ap = AccountsClient.prototype;                                                                                   // 130
	                                                                                                                     //
	/**                                                                                                                  // 132
	 * @summary True if a login method (such as `Meteor.loginWithPassword`, `Meteor.loginWithFacebook`, or `Accounts.createUser`) is currently in progress. A reactive data source.
	 * @locus Client                                                                                                     //
	 * @importFromPackage meteor                                                                                         //
	 */                                                                                                                  //
	Meteor.loggingIn = function () {                                                                                     // 137
	  return Accounts.loggingIn();                                                                                       // 138
	};                                                                                                                   // 139
	                                                                                                                     //
	///                                                                                                                  // 141
	/// LOGIN METHODS                                                                                                    // 142
	///                                                                                                                  // 143
	                                                                                                                     //
	// Call a login method on the server.                                                                                // 145
	//                                                                                                                   // 146
	// A login method is a method which on success calls `this.setUserId(id)` and                                        // 147
	// `Accounts._setLoginToken` on the server and returns an object with fields                                         // 148
	// 'id' (containing the user id), 'token' (containing a resume token), and                                           // 149
	// optionally `tokenExpires`.                                                                                        // 150
	//                                                                                                                   // 151
	// This function takes care of:                                                                                      // 152
	//   - Updating the Meteor.loggingIn() reactive data source                                                          // 153
	//   - Calling the method in 'wait' mode                                                                             // 154
	//   - On success, saving the resume token to localStorage                                                           // 155
	//   - On success, calling Accounts.connection.setUserId()                                                           // 156
	//   - Setting up an onReconnect handler which logs in with                                                          // 157
	//     the resume token                                                                                              // 158
	//                                                                                                                   // 159
	// Options:                                                                                                          // 160
	// - methodName: The method to call (default 'login')                                                                // 161
	// - methodArguments: The arguments for the method                                                                   // 162
	// - validateResult: If provided, will be called with the result of the                                              // 163
	//                 method. If it throws, the client will not be logged in (and                                       // 164
	//                 its error will be passed to the callback).                                                        // 165
	// - userCallback: Will be called with no arguments once the user is fully                                           // 166
	//                 logged in, or with the error on error.                                                            // 167
	//                                                                                                                   // 168
	Ap.callLoginMethod = function (options) {                                                                            // 169
	  var self = this;                                                                                                   // 170
	                                                                                                                     //
	  options = _.extend({                                                                                               // 172
	    methodName: 'login',                                                                                             // 173
	    methodArguments: [{}],                                                                                           // 174
	    _suppressLoggingIn: false                                                                                        // 175
	  }, options);                                                                                                       // 172
	                                                                                                                     //
	  // Set defaults for callback arguments to no-op functions; make sure we                                            // 178
	  // override falsey values too.                                                                                     // 179
	  _.each(['validateResult', 'userCallback'], function (f) {                                                          // 180
	    if (!options[f]) options[f] = function () {};                                                                    // 181
	  });                                                                                                                // 183
	                                                                                                                     //
	  // Prepare callbacks: user provided and onLogin/onLoginFailure hooks.                                              // 185
	  var loginCallbacks = _.once(function (error) {                                                                     // 186
	    if (!error) {                                                                                                    // 187
	      self._onLoginHook.each(function (callback) {                                                                   // 188
	        callback();                                                                                                  // 189
	        return true;                                                                                                 // 190
	      });                                                                                                            // 191
	    } else {                                                                                                         // 192
	      self._onLoginFailureHook.each(function (callback) {                                                            // 193
	        callback({ error: error });                                                                                  // 194
	        return true;                                                                                                 // 195
	      });                                                                                                            // 196
	    }                                                                                                                // 197
	    options.userCallback.apply(this, arguments);                                                                     // 198
	  });                                                                                                                // 199
	                                                                                                                     //
	  var reconnected = false;                                                                                           // 201
	                                                                                                                     //
	  // We want to set up onReconnect as soon as we get a result token back from                                        // 203
	  // the server, without having to wait for subscriptions to rerun. This is                                          // 204
	  // because if we disconnect and reconnect between getting the result and                                           // 205
	  // getting the results of subscription rerun, we WILL NOT re-send this                                             // 206
	  // method (because we never re-send methods whose results we've received)                                          // 207
	  // but we WILL call loggedInAndDataReadyCallback at "reconnect quiesce"                                            // 208
	  // time. This will lead to makeClientLoggedIn(result.id) even though we                                            // 209
	  // haven't actually sent a login method!                                                                           // 210
	  //                                                                                                                 // 211
	  // But by making sure that we send this "resume" login in that case (and                                           // 212
	  // calling makeClientLoggedOut if it fails), we'll end up with an accurate                                         // 213
	  // client-side userId. (It's important that livedata_connection guarantees                                         // 214
	  // that the "reconnect quiesce"-time call to loggedInAndDataReadyCallback                                          // 215
	  // will occur before the callback from the resume login call.)                                                     // 216
	  var onResultReceived = function onResultReceived(err, result) {                                                    // 217
	    if (err || !result || !result.token) {                                                                           // 218
	      // Leave onReconnect alone if there was an error, so that if the user was                                      // 219
	      // already logged in they will still get logged in on reconnect.                                               // 220
	      // See issue #4970.                                                                                            // 221
	    } else {                                                                                                         // 222
	      self.connection.onReconnect = function () {                                                                    // 223
	        reconnected = true;                                                                                          // 224
	        // If our token was updated in storage, use the latest one.                                                  // 225
	        var storedToken = self._storedLoginToken();                                                                  // 226
	        if (storedToken) {                                                                                           // 227
	          result = {                                                                                                 // 228
	            token: storedToken,                                                                                      // 229
	            tokenExpires: self._storedLoginTokenExpires()                                                            // 230
	          };                                                                                                         // 228
	        }                                                                                                            // 232
	        if (!result.tokenExpires) result.tokenExpires = self._tokenExpiration(new Date());                           // 233
	        if (self._tokenExpiresSoon(result.tokenExpires)) {                                                           // 235
	          self.makeClientLoggedOut();                                                                                // 236
	        } else {                                                                                                     // 237
	          self.callLoginMethod({                                                                                     // 238
	            methodArguments: [{ resume: result.token }],                                                             // 239
	            // Reconnect quiescence ensures that the user doesn't see an                                             // 240
	            // intermediate state before the login method finishes. So we don't                                      // 241
	            // need to show a logging-in animation.                                                                  // 242
	            _suppressLoggingIn: true,                                                                                // 243
	            userCallback: function () {                                                                              // 244
	              function userCallback(error) {                                                                         // 244
	                var storedTokenNow = self._storedLoginToken();                                                       // 245
	                if (error) {                                                                                         // 246
	                  // If we had a login error AND the current stored token is the                                     // 247
	                  // one that we tried to log in with, then declare ourselves                                        // 248
	                  // logged out. If there's a token in storage but it's not the                                      // 249
	                  // token that we tried to log in with, we don't know anything                                      // 250
	                  // about whether that token is valid or not, so do nothing. The                                    // 251
	                  // periodic localStorage poll will decide if we are logged in or                                   // 252
	                  // out with this token, if it hasn't already. Of course, even                                      // 253
	                  // with this check, another tab could insert a new valid token                                     // 254
	                  // immediately before we clear localStorage here, which would                                      // 255
	                  // lead to both tabs being logged out, but by checking the token                                   // 256
	                  // in storage right now we hope to make that unlikely to happen.                                   // 257
	                  //                                                                                                 // 258
	                  // If there is no token in storage right now, we don't have to                                     // 259
	                  // do anything; whatever code removed the token from storage was                                   // 260
	                  // responsible for calling `makeClientLoggedOut()`, or the                                         // 261
	                  // periodic localStorage poll will call `makeClientLoggedOut`                                      // 262
	                  // eventually if another tab wiped the token from storage.                                         // 263
	                  if (storedTokenNow && storedTokenNow === result.token) {                                           // 264
	                    self.makeClientLoggedOut();                                                                      // 265
	                  }                                                                                                  // 266
	                }                                                                                                    // 267
	                // Possibly a weird callback to call, but better than nothing if                                     // 268
	                // there is a reconnect between "login result received" and "data                                    // 269
	                // ready".                                                                                           // 270
	                loginCallbacks(error);                                                                               // 271
	              }                                                                                                      // 272
	                                                                                                                     //
	              return userCallback;                                                                                   // 244
	            }() });                                                                                                  // 244
	        }                                                                                                            // 273
	      };                                                                                                             // 274
	    }                                                                                                                // 275
	  };                                                                                                                 // 276
	                                                                                                                     //
	  // This callback is called once the local cache of the current-user                                                // 278
	  // subscription (and all subscriptions, in fact) are guaranteed to be up to                                        // 279
	  // date.                                                                                                           // 280
	  var loggedInAndDataReadyCallback = function loggedInAndDataReadyCallback(error, result) {                          // 281
	    // If the login method returns its result but the connection is lost                                             // 282
	    // before the data is in the local cache, it'll set an onReconnect (see                                          // 283
	    // above). The onReconnect will try to log in using the token, and *it*                                          // 284
	    // will call userCallback via its own version of this                                                            // 285
	    // loggedInAndDataReadyCallback. So we don't have to do anything here.                                           // 286
	    if (reconnected) return;                                                                                         // 287
	                                                                                                                     //
	    // Note that we need to call this even if _suppressLoggingIn is true,                                            // 290
	    // because it could be matching a _setLoggingIn(true) from a                                                     // 291
	    // half-completed pre-reconnect login method.                                                                    // 292
	    self._setLoggingIn(false);                                                                                       // 293
	    if (error || !result) {                                                                                          // 294
	      error = error || new Error("No result from call to " + options.methodName);                                    // 295
	      loginCallbacks(error);                                                                                         // 297
	      return;                                                                                                        // 298
	    }                                                                                                                // 299
	    try {                                                                                                            // 300
	      options.validateResult(result);                                                                                // 301
	    } catch (e) {                                                                                                    // 302
	      loginCallbacks(e);                                                                                             // 303
	      return;                                                                                                        // 304
	    }                                                                                                                // 305
	                                                                                                                     //
	    // Make the client logged in. (The user data should already be loaded!)                                          // 307
	    self.makeClientLoggedIn(result.id, result.token, result.tokenExpires);                                           // 308
	    loginCallbacks();                                                                                                // 309
	  };                                                                                                                 // 310
	                                                                                                                     //
	  if (!options._suppressLoggingIn) self._setLoggingIn(true);                                                         // 312
	  self.connection.apply(options.methodName, options.methodArguments, { wait: true, onResultReceived: onResultReceived }, loggedInAndDataReadyCallback);
	};                                                                                                                   // 319
	                                                                                                                     //
	Ap.makeClientLoggedOut = function () {                                                                               // 321
	  // Ensure client was successfully logged in before running logout hooks.                                           // 322
	  if (this.connection._userId) {                                                                                     // 323
	    this._onLogoutHook.each(function (callback) {                                                                    // 324
	      callback();                                                                                                    // 325
	      return true;                                                                                                   // 326
	    });                                                                                                              // 327
	  }                                                                                                                  // 328
	  this._unstoreLoginToken();                                                                                         // 329
	  this.connection.setUserId(null);                                                                                   // 330
	  this.connection.onReconnect = null;                                                                                // 331
	};                                                                                                                   // 332
	                                                                                                                     //
	Ap.makeClientLoggedIn = function (userId, token, tokenExpires) {                                                     // 334
	  this._storeLoginToken(userId, token, tokenExpires);                                                                // 335
	  this.connection.setUserId(userId);                                                                                 // 336
	};                                                                                                                   // 337
	                                                                                                                     //
	/**                                                                                                                  // 339
	 * @summary Log the user out.                                                                                        //
	 * @locus Client                                                                                                     //
	 * @param {Function} [callback] Optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
	 * @importFromPackage meteor                                                                                         //
	 */                                                                                                                  //
	Meteor.logout = function (callback) {                                                                                // 345
	  return Accounts.logout(callback);                                                                                  // 346
	};                                                                                                                   // 347
	                                                                                                                     //
	/**                                                                                                                  // 349
	 * @summary Log out other clients logged in as the current user, but does not log out the client that calls this function.
	 * @locus Client                                                                                                     //
	 * @param {Function} [callback] Optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
	 * @importFromPackage meteor                                                                                         //
	 */                                                                                                                  //
	Meteor.logoutOtherClients = function (callback) {                                                                    // 355
	  return Accounts.logoutOtherClients(callback);                                                                      // 356
	};                                                                                                                   // 357
	                                                                                                                     //
	///                                                                                                                  // 360
	/// LOGIN SERVICES                                                                                                   // 361
	///                                                                                                                  // 362
	                                                                                                                     //
	// A reactive function returning whether the loginServiceConfiguration                                               // 364
	// subscription is ready. Used by accounts-ui to hide the login button                                               // 365
	// until we have all the configuration loaded                                                                        // 366
	//                                                                                                                   // 367
	Ap.loginServicesConfigured = function () {                                                                           // 368
	  return this._loginServicesHandle.ready();                                                                          // 369
	};                                                                                                                   // 370
	                                                                                                                     //
	// Some login services such as the redirect login flow or the resume                                                 // 373
	// login handler can log the user in at page load time.  The                                                         // 374
	// Meteor.loginWithX functions have a callback argument, but the                                                     // 375
	// callback function instance won't be in memory any longer if the                                                   // 376
	// page was reloaded.  The `onPageLoadLogin` function allows a                                                       // 377
	// callback to be registered for the case where the login was                                                        // 378
	// initiated in a previous VM, and we now have the result of the login                                               // 379
	// attempt in a new VM.                                                                                              // 380
	                                                                                                                     //
	// Register a callback to be called if we have information about a                                                   // 382
	// login attempt at page load time.  Call the callback immediately if                                                // 383
	// we already have the page load login attempt info, otherwise stash                                                 // 384
	// the callback to be called if and when we do get the attempt info.                                                 // 385
	//                                                                                                                   // 386
	Ap.onPageLoadLogin = function (f) {                                                                                  // 387
	  if (this._pageLoadLoginAttemptInfo) {                                                                              // 388
	    f(this._pageLoadLoginAttemptInfo);                                                                               // 389
	  } else {                                                                                                           // 390
	    this._pageLoadLoginCallbacks.push(f);                                                                            // 391
	  }                                                                                                                  // 392
	};                                                                                                                   // 393
	                                                                                                                     //
	// Receive the information about the login attempt at page load time.                                                // 396
	// Call registered callbacks, and also record the info in case                                                       // 397
	// someone's callback hasn't been registered yet.                                                                    // 398
	//                                                                                                                   // 399
	Ap._pageLoadLogin = function (attemptInfo) {                                                                         // 400
	  if (this._pageLoadLoginAttemptInfo) {                                                                              // 401
	    Meteor._debug("Ignoring unexpected duplicate page load login attempt info");                                     // 402
	    return;                                                                                                          // 403
	  }                                                                                                                  // 404
	                                                                                                                     //
	  _.each(this._pageLoadLoginCallbacks, function (callback) {                                                         // 406
	    callback(attemptInfo);                                                                                           // 407
	  });                                                                                                                // 408
	                                                                                                                     //
	  this._pageLoadLoginCallbacks = [];                                                                                 // 410
	  this._pageLoadLoginAttemptInfo = attemptInfo;                                                                      // 411
	};                                                                                                                   // 412
	                                                                                                                     //
	///                                                                                                                  // 415
	/// HANDLEBARS HELPERS                                                                                               // 416
	///                                                                                                                  // 417
	                                                                                                                     //
	// If our app has a Blaze, register the {{currentUser}} and {{loggingIn}}                                            // 419
	// global helpers.                                                                                                   // 420
	if (Package.blaze) {                                                                                                 // 421
	  /**                                                                                                                // 422
	   * @global                                                                                                         //
	   * @name  currentUser                                                                                              //
	   * @isHelper true                                                                                                  //
	   * @summary Calls [Meteor.user()](#meteor_user). Use `{{#if currentUser}}` to check whether the user is logged in.
	   */                                                                                                                //
	  Package.blaze.Blaze.Template.registerHelper('currentUser', function () {                                           // 428
	    return Meteor.user();                                                                                            // 429
	  });                                                                                                                // 430
	                                                                                                                     //
	  /**                                                                                                                // 432
	   * @global                                                                                                         //
	   * @name  loggingIn                                                                                                //
	   * @isHelper true                                                                                                  //
	   * @summary Calls [Meteor.loggingIn()](#meteor_loggingin).                                                         //
	   */                                                                                                                //
	  Package.blaze.Blaze.Template.registerHelper('loggingIn', function () {                                             // 438
	    return Meteor.loggingIn();                                                                                       // 439
	  });                                                                                                                // 440
	}                                                                                                                    // 441
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"accounts_common.js":["babel-runtime/helpers/classCallCheck",function(require,exports,module){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                   //
	// packages/accounts-base/accounts_common.js                                                                         //
	//                                                                                                                   //
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                     //
	module.export({AccountsCommon:function(){return AccountsCommon}});var _classCallCheck;module.import("babel-runtime/helpers/classCallCheck",{"default":function(v){_classCallCheck=v}});
	/**                                                                                                                  // 1
	 * @summary Super-constructor for AccountsClient and AccountsServer.                                                 //
	 * @locus Anywhere                                                                                                   //
	 * @class AccountsCommon                                                                                             //
	 * @instancename accountsClientOrServer                                                                              //
	 * @param options {Object} an object with fields:                                                                    //
	 * - connection {Object} Optional DDP connection to reuse.                                                           //
	 * - ddpUrl {String} Optional URL for creating a new DDP connection.                                                 //
	 */                                                                                                                  //
	var AccountsCommon = function () {                                                                                   // 10
	  function AccountsCommon(options) {                                                                                 // 11
	    _classCallCheck(this, AccountsCommon);                                                                           // 11
	                                                                                                                     //
	    // Currently this is read directly by packages like accounts-password                                            // 12
	    // and accounts-ui-unstyled.                                                                                     // 13
	    this._options = {};                                                                                              // 14
	                                                                                                                     //
	    // Note that setting this.connection = null causes this.users to be a                                            // 16
	    // LocalCollection, which is not what we want.                                                                   // 17
	    this.connection = undefined;                                                                                     // 18
	    this._initConnection(options || {});                                                                             // 19
	                                                                                                                     //
	    // There is an allow call in accounts_server.js that restricts writes to                                         // 21
	    // this collection.                                                                                              // 22
	    this.users = new Mongo.Collection("users", {                                                                     // 23
	      _preventAutopublish: true,                                                                                     // 24
	      connection: this.connection                                                                                    // 25
	    });                                                                                                              // 23
	                                                                                                                     //
	    // Callback exceptions are printed with Meteor._debug and ignored.                                               // 28
	    this._onLoginHook = new Hook({                                                                                   // 29
	      bindEnvironment: false,                                                                                        // 30
	      debugPrintExceptions: "onLogin callback"                                                                       // 31
	    });                                                                                                              // 29
	                                                                                                                     //
	    this._onLoginFailureHook = new Hook({                                                                            // 34
	      bindEnvironment: false,                                                                                        // 35
	      debugPrintExceptions: "onLoginFailure callback"                                                                // 36
	    });                                                                                                              // 34
	                                                                                                                     //
	    this._onLogoutHook = new Hook({                                                                                  // 39
	      bindEnvironment: false,                                                                                        // 40
	      debugPrintExceptions: "onLogout callback"                                                                      // 41
	    });                                                                                                              // 39
	  }                                                                                                                  // 43
	                                                                                                                     //
	  /**                                                                                                                // 45
	   * @summary Get the current user id, or `null` if no user is logged in. A reactive data source.                    //
	   * @locus Anywhere but publish functions                                                                           //
	   */                                                                                                                //
	                                                                                                                     //
	                                                                                                                     //
	  AccountsCommon.prototype.userId = function () {                                                                    // 10
	    function userId() {                                                                                              // 10
	      throw new Error("userId method not implemented");                                                              // 50
	    }                                                                                                                // 51
	                                                                                                                     //
	    return userId;                                                                                                   // 10
	  }();                                                                                                               // 10
	                                                                                                                     //
	  /**                                                                                                                // 53
	   * @summary Get the current user record, or `null` if no user is logged in. A reactive data source.                //
	   * @locus Anywhere but publish functions                                                                           //
	   */                                                                                                                //
	                                                                                                                     //
	                                                                                                                     //
	  AccountsCommon.prototype.user = function () {                                                                      // 10
	    function user() {                                                                                                // 10
	      var userId = this.userId();                                                                                    // 58
	      return userId ? this.users.findOne(userId) : null;                                                             // 59
	    }                                                                                                                // 60
	                                                                                                                     //
	    return user;                                                                                                     // 10
	  }();                                                                                                               // 10
	                                                                                                                     //
	  // Set up config for the accounts system. Call this on both the client                                             // 62
	  // and the server.                                                                                                 // 63
	  //                                                                                                                 // 64
	  // Note that this method gets overridden on AccountsServer.prototype, but                                          // 65
	  // the overriding method calls the overridden method.                                                              // 66
	  //                                                                                                                 // 67
	  // XXX we should add some enforcement that this is called on both the                                              // 68
	  // client and the server. Otherwise, a user can                                                                    // 69
	  // 'forbidClientAccountCreation' only on the client and while it looks                                             // 70
	  // like their app is secure, the server will still accept createUser                                               // 71
	  // calls. https://github.com/meteor/meteor/issues/828                                                              // 72
	  //                                                                                                                 // 73
	  // @param options {Object} an object with fields:                                                                  // 74
	  // - sendVerificationEmail {Boolean}                                                                               // 75
	  //     Send email address verification emails to new users created from                                            // 76
	  //     client signups.                                                                                             // 77
	  // - forbidClientAccountCreation {Boolean}                                                                         // 78
	  //     Do not allow clients to create accounts directly.                                                           // 79
	  // - restrictCreationByEmailDomain {Function or String}                                                            // 80
	  //     Require created users to have an email matching the function or                                             // 81
	  //     having the string as domain.                                                                                // 82
	  // - loginExpirationInDays {Number}                                                                                // 83
	  //     Number of days since login until a user is logged out (login token                                          // 84
	  //     expires).                                                                                                   // 85
	  // - passwordResetTokenExpirationInDays {Number}                                                                   // 86
	  //     Number of days since password reset token creation until the                                                // 87
	  //     token cannt be used any longer (password reset token expires).                                              // 88
	                                                                                                                     //
	  /**                                                                                                                // 90
	   * @summary Set global accounts options.                                                                           //
	   * @locus Anywhere                                                                                                 //
	   * @param {Object} options                                                                                         //
	   * @param {Boolean} options.sendVerificationEmail New users with an email address will receive an address verification email.
	   * @param {Boolean} options.forbidClientAccountCreation Calls to [`createUser`](#accounts_createuser) from the client will be rejected. In addition, if you are using [accounts-ui](#accountsui), the "Create account" link will not be available.
	   * @param {String | Function} options.restrictCreationByEmailDomain If set to a string, only allows new users if the domain part of their email address matches the string. If set to a function, only allows new users if the function returns true.  The function is passed the full email address of the proposed new user.  Works with password-based sign-in and external services that expose email addresses (Google, Facebook, GitHub). All existing users still can log in after enabling this option. Example: `Accounts.config({ restrictCreationByEmailDomain: 'school.edu' })`.
	   * @param {Number} options.loginExpirationInDays The number of days from when a user logs in until their token expires and they are logged out. Defaults to 90. Set to `null` to disable login expiration.
	   * @param {String} options.oauthSecretKey When using the `oauth-encryption` package, the 16 byte key using to encrypt sensitive account credentials in the database, encoded in base64.  This option may only be specifed on the server.  See packages/oauth-encryption/README.md for details.
	   * @param {Number} options.passwordResetTokenExpirationInDays The number of days from when a link to reset password is sent until token expires and user can't reset password with the link anymore. Defaults to 3.
	   * @param {Number} options.passwordEnrollTokenExpirationInDays The number of days from when a link to set inital password is sent until token expires and user can't set password with the link anymore. Defaults to 30.
	   */                                                                                                                //
	                                                                                                                     //
	                                                                                                                     //
	  AccountsCommon.prototype.config = function () {                                                                    // 10
	    function config(options) {                                                                                       // 10
	      var self = this;                                                                                               // 103
	                                                                                                                     //
	      // We don't want users to accidentally only call Accounts.config on the                                        // 105
	      // client, where some of the options will have partial effects (eg removing                                    // 106
	      // the "create account" button from accounts-ui if forbidClientAccountCreation                                 // 107
	      // is set, or redirecting Google login to a specific-domain page) without                                      // 108
	      // having their full effects.                                                                                  // 109
	      if (Meteor.isServer) {                                                                                         // 110
	        __meteor_runtime_config__.accountsConfigCalled = true;                                                       // 111
	      } else if (!__meteor_runtime_config__.accountsConfigCalled) {                                                  // 112
	        // XXX would be nice to "crash" the client and replace the UI with an error                                  // 113
	        // message, but there's no trivial way to do this.                                                           // 114
	        Meteor._debug("Accounts.config was called on the client but not on the " + "server; some configuration options may not take effect.");
	      }                                                                                                              // 117
	                                                                                                                     //
	      // We need to validate the oauthSecretKey option at the time                                                   // 119
	      // Accounts.config is called. We also deliberately don't store the                                             // 120
	      // oauthSecretKey in Accounts._options.                                                                        // 121
	      if (_.has(options, "oauthSecretKey")) {                                                                        // 122
	        if (Meteor.isClient) throw new Error("The oauthSecretKey option may only be specified on the server");       // 123
	        if (!Package["oauth-encryption"]) throw new Error("The oauth-encryption package must be loaded to set oauthSecretKey");
	        Package["oauth-encryption"].OAuthEncryption.loadKey(options.oauthSecretKey);                                 // 127
	        options = _.omit(options, "oauthSecretKey");                                                                 // 128
	      }                                                                                                              // 129
	                                                                                                                     //
	      // validate option keys                                                                                        // 131
	      var VALID_KEYS = ["sendVerificationEmail", "forbidClientAccountCreation", "passwordEnrollTokenExpirationInDays", "restrictCreationByEmailDomain", "loginExpirationInDays", "passwordResetTokenExpirationInDays"];
	      _.each(_.keys(options), function (key) {                                                                       // 134
	        if (!_.contains(VALID_KEYS, key)) {                                                                          // 135
	          throw new Error("Accounts.config: Invalid key: " + key);                                                   // 136
	        }                                                                                                            // 137
	      });                                                                                                            // 138
	                                                                                                                     //
	      // set values in Accounts._options                                                                             // 140
	      _.each(VALID_KEYS, function (key) {                                                                            // 141
	        if (key in options) {                                                                                        // 142
	          if (key in self._options) {                                                                                // 143
	            throw new Error("Can't set `" + key + "` more than once");                                               // 144
	          }                                                                                                          // 145
	          self._options[key] = options[key];                                                                         // 146
	        }                                                                                                            // 147
	      });                                                                                                            // 148
	    }                                                                                                                // 149
	                                                                                                                     //
	    return config;                                                                                                   // 10
	  }();                                                                                                               // 10
	                                                                                                                     //
	  /**                                                                                                                // 151
	   * @summary Register a callback to be called after a login attempt succeeds.                                       //
	   * @locus Anywhere                                                                                                 //
	   * @param {Function} func The callback to be called when login is successful.                                      //
	   */                                                                                                                //
	                                                                                                                     //
	                                                                                                                     //
	  AccountsCommon.prototype.onLogin = function () {                                                                   // 10
	    function onLogin(func) {                                                                                         // 10
	      return this._onLoginHook.register(func);                                                                       // 157
	    }                                                                                                                // 158
	                                                                                                                     //
	    return onLogin;                                                                                                  // 10
	  }();                                                                                                               // 10
	                                                                                                                     //
	  /**                                                                                                                // 160
	   * @summary Register a callback to be called after a login attempt fails.                                          //
	   * @locus Anywhere                                                                                                 //
	   * @param {Function} func The callback to be called after the login has failed.                                    //
	   */                                                                                                                //
	                                                                                                                     //
	                                                                                                                     //
	  AccountsCommon.prototype.onLoginFailure = function () {                                                            // 10
	    function onLoginFailure(func) {                                                                                  // 10
	      return this._onLoginFailureHook.register(func);                                                                // 166
	    }                                                                                                                // 167
	                                                                                                                     //
	    return onLoginFailure;                                                                                           // 10
	  }();                                                                                                               // 10
	                                                                                                                     //
	  /**                                                                                                                // 169
	   * @summary Register a callback to be called after a logout attempt succeeds.                                      //
	   * @locus Anywhere                                                                                                 //
	   * @param {Function} func The callback to be called when logout is successful.                                     //
	   */                                                                                                                //
	                                                                                                                     //
	                                                                                                                     //
	  AccountsCommon.prototype.onLogout = function () {                                                                  // 10
	    function onLogout(func) {                                                                                        // 10
	      return this._onLogoutHook.register(func);                                                                      // 175
	    }                                                                                                                // 176
	                                                                                                                     //
	    return onLogout;                                                                                                 // 10
	  }();                                                                                                               // 10
	                                                                                                                     //
	  AccountsCommon.prototype._initConnection = function () {                                                           // 10
	    function _initConnection(options) {                                                                              // 10
	      if (!Meteor.isClient) {                                                                                        // 179
	        return;                                                                                                      // 180
	      }                                                                                                              // 181
	                                                                                                                     //
	      // The connection used by the Accounts system. This is the connection                                          // 183
	      // that will get logged in by Meteor.login(), and this is the                                                  // 184
	      // connection whose login state will be reflected by Meteor.userId().                                          // 185
	      //                                                                                                             // 186
	      // It would be much preferable for this to be in accounts_client.js,                                           // 187
	      // but it has to be here because it's needed to create the                                                     // 188
	      // Meteor.users collection.                                                                                    // 189
	                                                                                                                     //
	      if (options.connection) {                                                                                      // 191
	        this.connection = options.connection;                                                                        // 192
	      } else if (options.ddpUrl) {                                                                                   // 193
	        this.connection = DDP.connect(options.ddpUrl);                                                               // 194
	      } else if (typeof __meteor_runtime_config__ !== "undefined" && __meteor_runtime_config__.ACCOUNTS_CONNECTION_URL) {
	        // Temporary, internal hook to allow the server to point the client                                          // 197
	        // to a different authentication server. This is for a very                                                  // 198
	        // particular use case that comes up when implementing a oauth                                               // 199
	        // server. Unsupported and may go away at any point in time.                                                 // 200
	        //                                                                                                           // 201
	        // We will eventually provide a general way to use account-base                                              // 202
	        // against any DDP connection, not just one special one.                                                     // 203
	        this.connection = DDP.connect(__meteor_runtime_config__.ACCOUNTS_CONNECTION_URL);                            // 204
	      } else {                                                                                                       // 206
	        this.connection = Meteor.connection;                                                                         // 207
	      }                                                                                                              // 208
	    }                                                                                                                // 209
	                                                                                                                     //
	    return _initConnection;                                                                                          // 10
	  }();                                                                                                               // 10
	                                                                                                                     //
	  AccountsCommon.prototype._getTokenLifetimeMs = function () {                                                       // 10
	    function _getTokenLifetimeMs() {                                                                                 // 10
	      return (this._options.loginExpirationInDays || DEFAULT_LOGIN_EXPIRATION_DAYS) * 24 * 60 * 60 * 1000;           // 212
	    }                                                                                                                // 214
	                                                                                                                     //
	    return _getTokenLifetimeMs;                                                                                      // 10
	  }();                                                                                                               // 10
	                                                                                                                     //
	  AccountsCommon.prototype._getPasswordResetTokenLifetimeMs = function () {                                          // 10
	    function _getPasswordResetTokenLifetimeMs() {                                                                    // 10
	      return (this._options.passwordResetTokenExpirationInDays || DEFAULT_PASSWORD_RESET_TOKEN_EXPIRATION_DAYS) * 24 * 60 * 60 * 1000;
	    }                                                                                                                // 219
	                                                                                                                     //
	    return _getPasswordResetTokenLifetimeMs;                                                                         // 10
	  }();                                                                                                               // 10
	                                                                                                                     //
	  AccountsCommon.prototype._getPasswordEnrollTokenLifetimeMs = function () {                                         // 10
	    function _getPasswordEnrollTokenLifetimeMs() {                                                                   // 10
	      return (this._options.passwordEnrollTokenExpirationInDays || DEFAULT_PASSWORD_ENROLL_TOKEN_EXPIRATION_DAYS) * 24 * 60 * 60 * 1000;
	    }                                                                                                                // 224
	                                                                                                                     //
	    return _getPasswordEnrollTokenLifetimeMs;                                                                        // 10
	  }();                                                                                                               // 10
	                                                                                                                     //
	  AccountsCommon.prototype._tokenExpiration = function () {                                                          // 10
	    function _tokenExpiration(when) {                                                                                // 10
	      // We pass when through the Date constructor for backwards compatibility;                                      // 227
	      // `when` used to be a number.                                                                                 // 228
	      return new Date(new Date(when).getTime() + this._getTokenLifetimeMs());                                        // 229
	    }                                                                                                                // 230
	                                                                                                                     //
	    return _tokenExpiration;                                                                                         // 10
	  }();                                                                                                               // 10
	                                                                                                                     //
	  AccountsCommon.prototype._tokenExpiresSoon = function () {                                                         // 10
	    function _tokenExpiresSoon(when) {                                                                               // 10
	      var minLifetimeMs = .1 * this._getTokenLifetimeMs();                                                           // 233
	      var minLifetimeCapMs = MIN_TOKEN_LIFETIME_CAP_SECS * 1000;                                                     // 234
	      if (minLifetimeMs > minLifetimeCapMs) minLifetimeMs = minLifetimeCapMs;                                        // 235
	      return new Date() > new Date(when) - minLifetimeMs;                                                            // 237
	    }                                                                                                                // 238
	                                                                                                                     //
	    return _tokenExpiresSoon;                                                                                        // 10
	  }();                                                                                                               // 10
	                                                                                                                     //
	  return AccountsCommon;                                                                                             // 10
	}();                                                                                                                 // 10
	                                                                                                                     //
	var Ap = AccountsCommon.prototype;                                                                                   // 241
	                                                                                                                     //
	// Note that Accounts is defined separately in accounts_client.js and                                                // 243
	// accounts_server.js.                                                                                               // 244
	                                                                                                                     //
	/**                                                                                                                  // 246
	 * @summary Get the current user id, or `null` if no user is logged in. A reactive data source.                      //
	 * @locus Anywhere but publish functions                                                                             //
	 * @importFromPackage meteor                                                                                         //
	 */                                                                                                                  //
	Meteor.userId = function () {                                                                                        // 251
	  return Accounts.userId();                                                                                          // 252
	};                                                                                                                   // 253
	                                                                                                                     //
	/**                                                                                                                  // 255
	 * @summary Get the current user record, or `null` if no user is logged in. A reactive data source.                  //
	 * @locus Anywhere but publish functions                                                                             //
	 * @importFromPackage meteor                                                                                         //
	 */                                                                                                                  //
	Meteor.user = function () {                                                                                          // 260
	  return Accounts.user();                                                                                            // 261
	};                                                                                                                   // 262
	                                                                                                                     //
	// how long (in days) until a login token expires                                                                    // 264
	var DEFAULT_LOGIN_EXPIRATION_DAYS = 90;                                                                              // 265
	// how long (in days) until reset password token expires                                                             // 266
	var DEFAULT_PASSWORD_RESET_TOKEN_EXPIRATION_DAYS = 3;                                                                // 267
	// how long (in days) until enrol password token expires                                                             // 268
	var DEFAULT_PASSWORD_ENROLL_TOKEN_EXPIRATION_DAYS = 30;                                                              // 269
	// Clients don't try to auto-login with a token that is going to expire within                                       // 270
	// .1 * DEFAULT_LOGIN_EXPIRATION_DAYS, capped at MIN_TOKEN_LIFETIME_CAP_SECS.                                        // 271
	// Tries to avoid abrupt disconnects from expiring tokens.                                                           // 272
	var MIN_TOKEN_LIFETIME_CAP_SECS = 3600; // one hour                                                                  // 273
	// how often (in milliseconds) we check for expired tokens                                                           // 274
	EXPIRE_TOKENS_INTERVAL_MS = 600 * 1000; // 10 minutes                                                                // 275
	// how long we wait before logging out clients when Meteor.logoutOtherClients is                                     // 276
	// called                                                                                                            // 277
	CONNECTION_CLOSE_DELAY_MS = 10 * 1000;                                                                               // 278
	                                                                                                                     //
	// loginServiceConfiguration and ConfigError are maintained for backwards compatibility                              // 280
	Meteor.startup(function () {                                                                                         // 281
	  var ServiceConfiguration = Package['service-configuration'].ServiceConfiguration;                                  // 282
	  Ap.loginServiceConfiguration = ServiceConfiguration.configurations;                                                // 284
	  Ap.ConfigError = ServiceConfiguration.ConfigError;                                                                 // 285
	});                                                                                                                  // 286
	                                                                                                                     //
	// Thrown when the user cancels the login process (eg, closes an oauth                                               // 288
	// popup, declines retina scan, etc)                                                                                 // 289
	var lceName = 'Accounts.LoginCancelledError';                                                                        // 290
	Ap.LoginCancelledError = Meteor.makeErrorType(lceName, function (description) {                                      // 291
	  this.message = description;                                                                                        // 294
	});                                                                                                                  // 295
	Ap.LoginCancelledError.prototype.name = lceName;                                                                     // 297
	                                                                                                                     //
	// This is used to transmit specific subclass errors over the wire. We should                                        // 299
	// come up with a more generic way to do this (eg, with some sort of symbolic                                        // 300
	// error code rather than a number).                                                                                 // 301
	Ap.LoginCancelledError.numericError = 0x8acdc2f;                                                                     // 302
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"localstorage_token.js":["./accounts_client.js",function(require,exports,module){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                   //
	// packages/accounts-base/localstorage_token.js                                                                      //
	//                                                                                                                   //
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                     //
	var AccountsClient;module.import("./accounts_client.js",{"AccountsClient":function(v){AccountsClient=v}});           // 1
	var Ap = AccountsClient.prototype;                                                                                   // 2
	                                                                                                                     //
	// This file deals with storing a login token and user id in the                                                     // 4
	// browser's localStorage facility. It polls local storage every few                                                 // 5
	// seconds to synchronize login state between multiple tabs in the same                                              // 6
	// browser.                                                                                                          // 7
	                                                                                                                     //
	// Login with a Meteor access token. This is the only public function                                                // 9
	// here.                                                                                                             // 10
	Meteor.loginWithToken = function (token, callback) {                                                                 // 11
	  return Accounts.loginWithToken(token, callback);                                                                   // 12
	};                                                                                                                   // 13
	                                                                                                                     //
	Ap.loginWithToken = function (token, callback) {                                                                     // 15
	  this.callLoginMethod({                                                                                             // 16
	    methodArguments: [{                                                                                              // 17
	      resume: token                                                                                                  // 18
	    }],                                                                                                              // 17
	    userCallback: callback                                                                                           // 20
	  });                                                                                                                // 16
	};                                                                                                                   // 22
	                                                                                                                     //
	// Semi-internal API. Call this function to re-enable auto login after                                               // 24
	// if it was disabled at startup.                                                                                    // 25
	Ap._enableAutoLogin = function () {                                                                                  // 26
	  this._autoLoginEnabled = true;                                                                                     // 27
	  this._pollStoredLoginToken();                                                                                      // 28
	};                                                                                                                   // 29
	                                                                                                                     //
	///                                                                                                                  // 32
	/// STORING                                                                                                          // 33
	///                                                                                                                  // 34
	                                                                                                                     //
	// Call this from the top level of the test file for any test that does                                              // 36
	// logging in and out, to protect multiple tabs running the same tests                                               // 37
	// simultaneously from interfering with each others' localStorage.                                                   // 38
	Ap._isolateLoginTokenForTest = function () {                                                                         // 39
	  this.LOGIN_TOKEN_KEY = this.LOGIN_TOKEN_KEY + Random.id();                                                         // 40
	  this.USER_ID_KEY = this.USER_ID_KEY + Random.id();                                                                 // 41
	};                                                                                                                   // 42
	                                                                                                                     //
	Ap._storeLoginToken = function (userId, token, tokenExpires) {                                                       // 44
	  Meteor._localStorage.setItem(this.USER_ID_KEY, userId);                                                            // 45
	  Meteor._localStorage.setItem(this.LOGIN_TOKEN_KEY, token);                                                         // 46
	  if (!tokenExpires) tokenExpires = this._tokenExpiration(new Date());                                               // 47
	  Meteor._localStorage.setItem(this.LOGIN_TOKEN_EXPIRES_KEY, tokenExpires);                                          // 49
	                                                                                                                     //
	  // to ensure that the localstorage poller doesn't end up trying to                                                 // 51
	  // connect a second time                                                                                           // 52
	  this._lastLoginTokenWhenPolled = token;                                                                            // 53
	};                                                                                                                   // 54
	                                                                                                                     //
	Ap._unstoreLoginToken = function () {                                                                                // 56
	  Meteor._localStorage.removeItem(this.USER_ID_KEY);                                                                 // 57
	  Meteor._localStorage.removeItem(this.LOGIN_TOKEN_KEY);                                                             // 58
	  Meteor._localStorage.removeItem(this.LOGIN_TOKEN_EXPIRES_KEY);                                                     // 59
	                                                                                                                     //
	  // to ensure that the localstorage poller doesn't end up trying to                                                 // 61
	  // connect a second time                                                                                           // 62
	  this._lastLoginTokenWhenPolled = null;                                                                             // 63
	};                                                                                                                   // 64
	                                                                                                                     //
	// This is private, but it is exported for now because it is used by a                                               // 66
	// test in accounts-password.                                                                                        // 67
	//                                                                                                                   // 68
	Ap._storedLoginToken = function () {                                                                                 // 69
	  return Meteor._localStorage.getItem(this.LOGIN_TOKEN_KEY);                                                         // 70
	};                                                                                                                   // 71
	                                                                                                                     //
	Ap._storedLoginTokenExpires = function () {                                                                          // 73
	  return Meteor._localStorage.getItem(this.LOGIN_TOKEN_EXPIRES_KEY);                                                 // 74
	};                                                                                                                   // 75
	                                                                                                                     //
	Ap._storedUserId = function () {                                                                                     // 77
	  return Meteor._localStorage.getItem(this.USER_ID_KEY);                                                             // 78
	};                                                                                                                   // 79
	                                                                                                                     //
	Ap._unstoreLoginTokenIfExpiresSoon = function () {                                                                   // 81
	  var tokenExpires = this._storedLoginTokenExpires();                                                                // 82
	  if (tokenExpires && this._tokenExpiresSoon(new Date(tokenExpires))) {                                              // 83
	    this._unstoreLoginToken();                                                                                       // 84
	  }                                                                                                                  // 85
	};                                                                                                                   // 86
	                                                                                                                     //
	///                                                                                                                  // 88
	/// AUTO-LOGIN                                                                                                       // 89
	///                                                                                                                  // 90
	                                                                                                                     //
	Ap._initLocalStorage = function () {                                                                                 // 92
	  var self = this;                                                                                                   // 93
	                                                                                                                     //
	  // Key names to use in localStorage                                                                                // 95
	  self.LOGIN_TOKEN_KEY = "Meteor.loginToken";                                                                        // 96
	  self.LOGIN_TOKEN_EXPIRES_KEY = "Meteor.loginTokenExpires";                                                         // 97
	  self.USER_ID_KEY = "Meteor.userId";                                                                                // 98
	                                                                                                                     //
	  var rootUrlPathPrefix = __meteor_runtime_config__.ROOT_URL_PATH_PREFIX;                                            // 100
	  if (rootUrlPathPrefix || this.connection !== Meteor.connection) {                                                  // 101
	    // We want to keep using the same keys for existing apps that do not                                             // 102
	    // set a custom ROOT_URL_PATH_PREFIX, so that most users will not have                                           // 103
	    // to log in again after an app updates to a version of Meteor that                                              // 104
	    // contains this code, but it's generally preferable to namespace the                                            // 105
	    // keys so that connections from distinct apps to distinct DDP URLs                                              // 106
	    // will be distinct in Meteor._localStorage.                                                                     // 107
	    var namespace = ":" + this.connection._stream.rawUrl;                                                            // 108
	    if (rootUrlPathPrefix) {                                                                                         // 109
	      namespace += ":" + rootUrlPathPrefix;                                                                          // 110
	    }                                                                                                                // 111
	    self.LOGIN_TOKEN_KEY += namespace;                                                                               // 112
	    self.LOGIN_TOKEN_EXPIRES_KEY += namespace;                                                                       // 113
	    self.USER_ID_KEY += namespace;                                                                                   // 114
	  }                                                                                                                  // 115
	                                                                                                                     //
	  if (self._autoLoginEnabled) {                                                                                      // 117
	    // Immediately try to log in via local storage, so that any DDP                                                  // 118
	    // messages are sent after we have established our user account                                                  // 119
	    self._unstoreLoginTokenIfExpiresSoon();                                                                          // 120
	    var token = self._storedLoginToken();                                                                            // 121
	    if (token) {                                                                                                     // 122
	      // On startup, optimistically present us as logged in while the                                                // 123
	      // request is in flight. This reduces page flicker on startup.                                                 // 124
	      var userId = self._storedUserId();                                                                             // 125
	      userId && self.connection.setUserId(userId);                                                                   // 126
	      self.loginWithToken(token, function (err) {                                                                    // 127
	        if (err) {                                                                                                   // 128
	          Meteor._debug("Error logging in with token: " + err);                                                      // 129
	          self.makeClientLoggedOut();                                                                                // 130
	        }                                                                                                            // 131
	                                                                                                                     //
	        self._pageLoadLogin({                                                                                        // 133
	          type: "resume",                                                                                            // 134
	          allowed: !err,                                                                                             // 135
	          error: err,                                                                                                // 136
	          methodName: "login",                                                                                       // 137
	          // XXX This is duplicate code with loginWithToken, but                                                     // 138
	          // loginWithToken can also be called at other times besides                                                // 139
	          // page load.                                                                                              // 140
	          methodArguments: [{ resume: token }]                                                                       // 141
	        });                                                                                                          // 133
	      });                                                                                                            // 143
	    }                                                                                                                // 144
	  }                                                                                                                  // 145
	                                                                                                                     //
	  // Poll local storage every 3 seconds to login if someone logged in in                                             // 147
	  // another tab                                                                                                     // 148
	  self._lastLoginTokenWhenPolled = token;                                                                            // 149
	                                                                                                                     //
	  if (self._pollIntervalTimer) {                                                                                     // 151
	    // Unlikely that _initLocalStorage will be called more than once for                                             // 152
	    // the same AccountsClient instance, but just in case...                                                         // 153
	    clearInterval(self._pollIntervalTimer);                                                                          // 154
	  }                                                                                                                  // 155
	                                                                                                                     //
	  self._pollIntervalTimer = setInterval(function () {                                                                // 157
	    self._pollStoredLoginToken();                                                                                    // 158
	  }, 3000);                                                                                                          // 159
	};                                                                                                                   // 160
	                                                                                                                     //
	Ap._pollStoredLoginToken = function () {                                                                             // 162
	  var self = this;                                                                                                   // 163
	                                                                                                                     //
	  if (!self._autoLoginEnabled) {                                                                                     // 165
	    return;                                                                                                          // 166
	  }                                                                                                                  // 167
	                                                                                                                     //
	  var currentLoginToken = self._storedLoginToken();                                                                  // 169
	                                                                                                                     //
	  // != instead of !== just to make sure undefined and null are treated the same                                     // 171
	  if (self._lastLoginTokenWhenPolled != currentLoginToken) {                                                         // 172
	    if (currentLoginToken) {                                                                                         // 173
	      self.loginWithToken(currentLoginToken, function (err) {                                                        // 174
	        if (err) {                                                                                                   // 175
	          self.makeClientLoggedOut();                                                                                // 176
	        }                                                                                                            // 177
	      });                                                                                                            // 178
	    } else {                                                                                                         // 179
	      self.logout();                                                                                                 // 180
	    }                                                                                                                // 181
	  }                                                                                                                  // 182
	                                                                                                                     //
	  self._lastLoginTokenWhenPolled = currentLoginToken;                                                                // 184
	};                                                                                                                   // 185
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"url_client.js":["./accounts_client.js",function(require,exports,module){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                   //
	// packages/accounts-base/url_client.js                                                                              //
	//                                                                                                                   //
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                     //
	module.export({AccountsTest:function(){return AccountsTest}});var AccountsClient;module.import("./accounts_client.js",{"AccountsClient":function(v){AccountsClient=v}});
	                                                                                                                     //
	var Ap = AccountsClient.prototype;                                                                                   // 3
	                                                                                                                     //
	// All of the special hash URLs we support for accounts interactions                                                 // 5
	var accountsPaths = ["reset-password", "verify-email", "enroll-account"];                                            // 6
	                                                                                                                     //
	var savedHash = window.location.hash;                                                                                // 8
	                                                                                                                     //
	Ap._initUrlMatching = function () {                                                                                  // 10
	  // By default, allow the autologin process to happen.                                                              // 11
	  this._autoLoginEnabled = true;                                                                                     // 12
	                                                                                                                     //
	  // We only support one callback per URL.                                                                           // 14
	  this._accountsCallbacks = {};                                                                                      // 15
	                                                                                                                     //
	  // Try to match the saved value of window.location.hash.                                                           // 17
	  this._attemptToMatchHash();                                                                                        // 18
	};                                                                                                                   // 19
	                                                                                                                     //
	// Separate out this functionality for testing                                                                       // 21
	                                                                                                                     //
	Ap._attemptToMatchHash = function () {                                                                               // 23
	  _attemptToMatchHash(this, savedHash, defaultSuccessHandler);                                                       // 24
	};                                                                                                                   // 25
	                                                                                                                     //
	// Note that both arguments are optional and are currently only passed by                                            // 27
	// accounts_url_tests.js.                                                                                            // 28
	function _attemptToMatchHash(accounts, hash, success) {                                                              // 29
	  _.each(accountsPaths, function (urlPart) {                                                                         // 30
	    var token;                                                                                                       // 31
	                                                                                                                     //
	    var tokenRegex = new RegExp("^\\#\\/" + urlPart + "\\/(.*)$");                                                   // 33
	    var match = hash.match(tokenRegex);                                                                              // 34
	                                                                                                                     //
	    if (match) {                                                                                                     // 36
	      token = match[1];                                                                                              // 37
	                                                                                                                     //
	      // XXX COMPAT WITH 0.9.3                                                                                       // 39
	      if (urlPart === "reset-password") {                                                                            // 40
	        accounts._resetPasswordToken = token;                                                                        // 41
	      } else if (urlPart === "verify-email") {                                                                       // 42
	        accounts._verifyEmailToken = token;                                                                          // 43
	      } else if (urlPart === "enroll-account") {                                                                     // 44
	        accounts._enrollAccountToken = token;                                                                        // 45
	      }                                                                                                              // 46
	    } else {                                                                                                         // 47
	      return;                                                                                                        // 48
	    }                                                                                                                // 49
	                                                                                                                     //
	    // If no handlers match the hash, then maybe it's meant to be consumed                                           // 51
	    // by some entirely different code, so we only clear it the first time                                           // 52
	    // a handler successfully matches. Note that later handlers reuse the                                            // 53
	    // savedHash, so clearing window.location.hash here will not interfere                                           // 54
	    // with their needs.                                                                                             // 55
	    window.location.hash = "";                                                                                       // 56
	                                                                                                                     //
	    // Do some stuff with the token we matched                                                                       // 58
	    success.call(accounts, token, urlPart);                                                                          // 59
	  });                                                                                                                // 60
	}                                                                                                                    // 61
	                                                                                                                     //
	function defaultSuccessHandler(token, urlPart) {                                                                     // 63
	  var self = this;                                                                                                   // 64
	                                                                                                                     //
	  // put login in a suspended state to wait for the interaction to finish                                            // 66
	  self._autoLoginEnabled = false;                                                                                    // 67
	                                                                                                                     //
	  // wait for other packages to register callbacks                                                                   // 69
	  Meteor.startup(function () {                                                                                       // 70
	    // if a callback has been registered for this kind of token, call it                                             // 71
	    if (self._accountsCallbacks[urlPart]) {                                                                          // 72
	      self._accountsCallbacks[urlPart](token, function () {                                                          // 73
	        self._enableAutoLogin();                                                                                     // 74
	      });                                                                                                            // 75
	    }                                                                                                                // 76
	  });                                                                                                                // 77
	}                                                                                                                    // 78
	                                                                                                                     //
	// Export for testing                                                                                                // 80
	var AccountsTest = {                                                                                                 // 81
	  attemptToMatchHash: function () {                                                                                  // 82
	    function attemptToMatchHash(hash, success) {                                                                     // 82
	      return _attemptToMatchHash(Accounts, hash, success);                                                           // 83
	    }                                                                                                                // 84
	                                                                                                                     //
	    return attemptToMatchHash;                                                                                       // 82
	  }()                                                                                                                // 82
	};                                                                                                                   // 81
	                                                                                                                     //
	// XXX these should be moved to accounts-password eventually. Right now                                              // 87
	// this is prevented by the need to set autoLoginEnabled=false, but in                                               // 88
	// some bright future we won't need to do that anymore.                                                              // 89
	                                                                                                                     //
	/**                                                                                                                  // 91
	 * @summary Register a function to call when a reset password link is clicked                                        //
	 * in an email sent by                                                                                               //
	 * [`Accounts.sendResetPasswordEmail`](#accounts_sendresetpasswordemail).                                            //
	 * This function should be called in top-level code, not inside                                                      //
	 * `Meteor.startup()`.                                                                                               //
	 * @memberof! Accounts                                                                                               //
	 * @name onResetPasswordLink                                                                                         //
	 * @param  {Function} callback The function to call. It is given two arguments:                                      //
	 *                                                                                                                   //
	 * 1. `token`: A password reset token that can be passed to                                                          //
	 * [`Accounts.resetPassword`](#accounts_resetpassword).                                                              //
	 * 2. `done`: A function to call when the password reset UI flow is complete. The normal                             //
	 * login process is suspended until this function is called, so that the                                             //
	 * password for user A can be reset even if user B was logged in.                                                    //
	 * @locus Client                                                                                                     //
	 */                                                                                                                  //
	Ap.onResetPasswordLink = function (callback) {                                                                       // 108
	  if (this._accountsCallbacks["reset-password"]) {                                                                   // 109
	    Meteor._debug("Accounts.onResetPasswordLink was called more than once. " + "Only one callback added will be executed.");
	  }                                                                                                                  // 112
	                                                                                                                     //
	  this._accountsCallbacks["reset-password"] = callback;                                                              // 114
	};                                                                                                                   // 115
	                                                                                                                     //
	/**                                                                                                                  // 117
	 * @summary Register a function to call when an email verification link is                                           //
	 * clicked in an email sent by                                                                                       //
	 * [`Accounts.sendVerificationEmail`](#accounts_sendverificationemail).                                              //
	 * This function should be called in top-level code, not inside                                                      //
	 * `Meteor.startup()`.                                                                                               //
	 * @memberof! Accounts                                                                                               //
	 * @name onEmailVerificationLink                                                                                     //
	 * @param  {Function} callback The function to call. It is given two arguments:                                      //
	 *                                                                                                                   //
	 * 1. `token`: An email verification token that can be passed to                                                     //
	 * [`Accounts.verifyEmail`](#accounts_verifyemail).                                                                  //
	 * 2. `done`: A function to call when the email verification UI flow is complete.                                    //
	 * The normal login process is suspended until this function is called, so                                           //
	 * that the user can be notified that they are verifying their email before                                          //
	 * being logged in.                                                                                                  //
	 * @locus Client                                                                                                     //
	 */                                                                                                                  //
	Ap.onEmailVerificationLink = function (callback) {                                                                   // 135
	  if (this._accountsCallbacks["verify-email"]) {                                                                     // 136
	    Meteor._debug("Accounts.onEmailVerificationLink was called more than once. " + "Only one callback added will be executed.");
	  }                                                                                                                  // 139
	                                                                                                                     //
	  this._accountsCallbacks["verify-email"] = callback;                                                                // 141
	};                                                                                                                   // 142
	                                                                                                                     //
	/**                                                                                                                  // 144
	 * @summary Register a function to call when an account enrollment link is                                           //
	 * clicked in an email sent by                                                                                       //
	 * [`Accounts.sendEnrollmentEmail`](#accounts_sendenrollmentemail).                                                  //
	 * This function should be called in top-level code, not inside                                                      //
	 * `Meteor.startup()`.                                                                                               //
	 * @memberof! Accounts                                                                                               //
	 * @name onEnrollmentLink                                                                                            //
	 * @param  {Function} callback The function to call. It is given two arguments:                                      //
	 *                                                                                                                   //
	 * 1. `token`: A password reset token that can be passed to                                                          //
	 * [`Accounts.resetPassword`](#accounts_resetpassword) to give the newly                                             //
	 * enrolled account a password.                                                                                      //
	 * 2. `done`: A function to call when the enrollment UI flow is complete.                                            //
	 * The normal login process is suspended until this function is called, so that                                      //
	 * user A can be enrolled even if user B was logged in.                                                              //
	 * @locus Client                                                                                                     //
	 */                                                                                                                  //
	Ap.onEnrollmentLink = function (callback) {                                                                          // 162
	  if (this._accountsCallbacks["enroll-account"]) {                                                                   // 163
	    Meteor._debug("Accounts.onEnrollmentLink was called more than once. " + "Only one callback added will be executed.");
	  }                                                                                                                  // 166
	                                                                                                                     //
	  this._accountsCallbacks["enroll-account"] = callback;                                                              // 168
	};                                                                                                                   // 169
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]}}}},{"extensions":[".js",".json"]});
	var exports = require("./node_modules/meteor/accounts-base/client_main.js");
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['accounts-base'] = exports, {
	  Accounts: Accounts
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/accounts-password.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var Accounts = Package['accounts-base'].Accounts;
	var SRP = Package.srp.SRP;
	var SHA256 = Package.sha.SHA256;
	var EJSON = Package.ejson.EJSON;
	var DDP = Package['ddp-client'].DDP;
	var check = Package.check.check;
	var Match = Package.check.Match;
	var _ = Package.underscore._;
	var meteorInstall = Package.modules.meteorInstall;
	var Buffer = Package.modules.Buffer;
	var process = Package.modules.process;
	var Symbol = Package['ecmascript-runtime'].Symbol;
	var Map = Package['ecmascript-runtime'].Map;
	var Set = Package['ecmascript-runtime'].Set;
	var meteorBabelHelpers = Package['babel-runtime'].meteorBabelHelpers;
	var Promise = Package.promise.Promise;
	
	var require = meteorInstall({"node_modules":{"meteor":{"accounts-password":{"password_client.js":function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                            //
	// packages/accounts-password/password_client.js                                                              //
	//                                                                                                            //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                              //
	// Used in the various functions below to handle errors consistently                                          // 1
	function reportError(error, callback) {                                                                       // 2
	  if (callback) {                                                                                             // 3
	    callback(error);                                                                                          // 4
	  } else {                                                                                                    // 5
	    throw error;                                                                                              // 6
	  }                                                                                                           // 7
	};                                                                                                            // 8
	                                                                                                              //
	// Attempt to log in with a password.                                                                         // 10
	//                                                                                                            // 11
	// @param selector {String|Object} One of the following:                                                      // 12
	//   - {username: (username)}                                                                                 // 13
	//   - {email: (email)}                                                                                       // 14
	//   - a string which may be a username or email, depending on whether                                        // 15
	//     it contains "@".                                                                                       // 16
	// @param password {String}                                                                                   // 17
	// @param callback {Function(error|undefined)}                                                                // 18
	                                                                                                              //
	/**                                                                                                           // 20
	 * @summary Log the user in with a password.                                                                  //
	 * @locus Client                                                                                              //
	 * @param {Object | String} user                                                                              //
	 *   Either a string interpreted as a username or an email; or an object with a                               //
	 *   single key: `email`, `username` or `id`. Username or email match in a case                               //
	 *   insensitive manner.                                                                                      //
	 * @param {String} password The user's password.                                                              //
	 * @param {Function} [callback] Optional callback.                                                            //
	 *   Called with no arguments on success, or with a single `Error` argument                                   //
	 *   on failure.                                                                                              //
	 * @importFromPackage meteor                                                                                  //
	 */                                                                                                           //
	Meteor.loginWithPassword = function (selector, password, callback) {                                          // 33
	  if (typeof selector === 'string') if (selector.indexOf('@') === -1) selector = { username: selector };else selector = { email: selector };
	                                                                                                              //
	  Accounts.callLoginMethod({                                                                                  // 40
	    methodArguments: [{                                                                                       // 41
	      user: selector,                                                                                         // 42
	      password: Accounts._hashPassword(password)                                                              // 43
	    }],                                                                                                       // 41
	    userCallback: function () {                                                                               // 45
	      function userCallback(error, result) {                                                                  // 45
	        if (error && error.error === 400 && error.reason === 'old password format') {                         // 46
	          // The "reason" string should match the error thrown in the                                         // 48
	          // password login handler in password_server.js.                                                    // 49
	                                                                                                              //
	          // XXX COMPAT WITH 0.8.1.3                                                                          // 51
	          // If this user's last login was with a previous version of                                         // 52
	          // Meteor that used SRP, then the server throws this error to                                       // 53
	          // indicate that we should try again. The error includes the                                        // 54
	          // user's SRP identity. We provide a value derived from the                                         // 55
	          // identity and the password to prove to the server that we know                                    // 56
	          // the password without requiring a full SRP flow, as well as                                       // 57
	          // SHA256(password), which the server bcrypts and stores in                                         // 58
	          // place of the old SRP information for this user.                                                  // 59
	          srpUpgradePath({                                                                                    // 60
	            upgradeError: error,                                                                              // 61
	            userSelector: selector,                                                                           // 62
	            plaintextPassword: password                                                                       // 63
	          }, callback);                                                                                       // 60
	        } else if (error) {                                                                                   // 65
	          reportError(error, callback);                                                                       // 67
	        } else {                                                                                              // 68
	          callback && callback();                                                                             // 69
	        }                                                                                                     // 70
	      }                                                                                                       // 71
	                                                                                                              //
	      return userCallback;                                                                                    // 45
	    }()                                                                                                       // 45
	  });                                                                                                         // 40
	};                                                                                                            // 73
	                                                                                                              //
	Accounts._hashPassword = function (password) {                                                                // 75
	  return {                                                                                                    // 76
	    digest: SHA256(password),                                                                                 // 77
	    algorithm: "sha-256"                                                                                      // 78
	  };                                                                                                          // 76
	};                                                                                                            // 80
	                                                                                                              //
	// XXX COMPAT WITH 0.8.1.3                                                                                    // 82
	// The server requested an upgrade from the old SRP password format,                                          // 83
	// so supply the needed SRP identity to login. Options:                                                       // 84
	//   - upgradeError: the error object that the server returned to tell                                        // 85
	//     us to upgrade from SRP to bcrypt.                                                                      // 86
	//   - userSelector: selector to retrieve the user object                                                     // 87
	//   - plaintextPassword: the password as a string                                                            // 88
	var srpUpgradePath = function srpUpgradePath(options, callback) {                                             // 89
	  var details;                                                                                                // 90
	  try {                                                                                                       // 91
	    details = EJSON.parse(options.upgradeError.details);                                                      // 92
	  } catch (e) {}                                                                                              // 93
	  if (!(details && details.format === 'srp')) {                                                               // 94
	    reportError(new Meteor.Error(400, "Password is old. Please reset your " + "password."), callback);        // 95
	  } else {                                                                                                    // 98
	    Accounts.callLoginMethod({                                                                                // 99
	      methodArguments: [{                                                                                     // 100
	        user: options.userSelector,                                                                           // 101
	        srp: SHA256(details.identity + ":" + options.plaintextPassword),                                      // 102
	        password: Accounts._hashPassword(options.plaintextPassword)                                           // 103
	      }],                                                                                                     // 100
	      userCallback: callback                                                                                  // 105
	    });                                                                                                       // 99
	  }                                                                                                           // 107
	};                                                                                                            // 108
	                                                                                                              //
	// Attempt to log in as a new user.                                                                           // 110
	                                                                                                              //
	/**                                                                                                           // 112
	 * @summary Create a new user.                                                                                //
	 * @locus Anywhere                                                                                            //
	 * @param {Object} options                                                                                    //
	 * @param {String} options.username A unique name for this user.                                              //
	 * @param {String} options.email The user's email address.                                                    //
	 * @param {String} options.password The user's password. This is __not__ sent in plain text over the wire.    //
	 * @param {Object} options.profile The user's profile, typically including the `name` field.                  //
	 * @param {Function} [callback] Client only, optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
	 * @importFromPackage accounts-base                                                                           //
	 */                                                                                                           //
	Accounts.createUser = function (options, callback) {                                                          // 123
	  options = _.clone(options); // we'll be modifying options                                                   // 124
	                                                                                                              //
	  if (typeof options.password !== 'string') throw new Error("options.password must be a string");             // 126
	  if (!options.password) {                                                                                    // 128
	    return reportError(new Meteor.Error(400, "Password may not be empty"), callback);                         // 129
	  }                                                                                                           // 130
	                                                                                                              //
	  // Replace password with the hashed password.                                                               // 132
	  options.password = Accounts._hashPassword(options.password);                                                // 133
	                                                                                                              //
	  Accounts.callLoginMethod({                                                                                  // 135
	    methodName: 'createUser',                                                                                 // 136
	    methodArguments: [options],                                                                               // 137
	    userCallback: callback                                                                                    // 138
	  });                                                                                                         // 135
	};                                                                                                            // 140
	                                                                                                              //
	// Change password. Must be logged in.                                                                        // 142
	//                                                                                                            // 143
	// @param oldPassword {String|null} By default servers no longer allow                                        // 144
	//   changing password without the old password, but they could so we                                         // 145
	//   support passing no password to the server and letting it decide.                                         // 146
	// @param newPassword {String}                                                                                // 147
	// @param callback {Function(error|undefined)}                                                                // 148
	                                                                                                              //
	/**                                                                                                           // 150
	 * @summary Change the current user's password. Must be logged in.                                            //
	 * @locus Client                                                                                              //
	 * @param {String} oldPassword The user's current password. This is __not__ sent in plain text over the wire.
	 * @param {String} newPassword A new password for the user. This is __not__ sent in plain text over the wire.
	 * @param {Function} [callback] Optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
	 * @importFromPackage accounts-base                                                                           //
	 */                                                                                                           //
	Accounts.changePassword = function (oldPassword, newPassword, callback) {                                     // 158
	  if (!Meteor.user()) {                                                                                       // 159
	    return reportError(new Error("Must be logged in to change password."), callback);                         // 160
	  }                                                                                                           // 161
	                                                                                                              //
	  check(newPassword, String);                                                                                 // 163
	  if (!newPassword) {                                                                                         // 164
	    return reportError(new Meteor.Error(400, "Password may not be empty"), callback);                         // 165
	  }                                                                                                           // 166
	                                                                                                              //
	  Accounts.connection.apply('changePassword', [oldPassword ? Accounts._hashPassword(oldPassword) : null, Accounts._hashPassword(newPassword)], function (error, result) {
	    if (error || !result) {                                                                                   // 173
	      if (error && error.error === 400 && error.reason === 'old password format') {                           // 174
	        // XXX COMPAT WITH 0.8.1.3                                                                            // 176
	        // The server is telling us to upgrade from SRP to bcrypt, as                                         // 177
	        // in Meteor.loginWithPassword.                                                                       // 178
	        srpUpgradePath({                                                                                      // 179
	          upgradeError: error,                                                                                // 180
	          userSelector: { id: Meteor.userId() },                                                              // 181
	          plaintextPassword: oldPassword                                                                      // 182
	        }, function (err) {                                                                                   // 179
	          if (err) {                                                                                          // 184
	            reportError(err, callback);                                                                       // 185
	          } else {                                                                                            // 186
	            // Now that we've successfully migrated from srp to                                               // 187
	            // bcrypt, try changing the password again.                                                       // 188
	            Accounts.changePassword(oldPassword, newPassword, callback);                                      // 189
	          }                                                                                                   // 190
	        });                                                                                                   // 191
	      } else {                                                                                                // 192
	        // A normal error, not an error telling us to upgrade to bcrypt                                       // 193
	        reportError(error || new Error("No result from changePassword."), callback);                          // 194
	      }                                                                                                       // 196
	    } else {                                                                                                  // 197
	      callback && callback();                                                                                 // 198
	    }                                                                                                         // 199
	  });                                                                                                         // 200
	};                                                                                                            // 202
	                                                                                                              //
	// Sends an email to a user with a link that can be used to reset                                             // 204
	// their password                                                                                             // 205
	//                                                                                                            // 206
	// @param options {Object}                                                                                    // 207
	//   - email: (email)                                                                                         // 208
	// @param callback (optional) {Function(error|undefined)}                                                     // 209
	                                                                                                              //
	/**                                                                                                           // 211
	 * @summary Request a forgot password email.                                                                  //
	 * @locus Client                                                                                              //
	 * @param {Object} options                                                                                    //
	 * @param {String} options.email The email address to send a password reset link.                             //
	 * @param {Function} [callback] Optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
	 * @importFromPackage accounts-base                                                                           //
	 */                                                                                                           //
	Accounts.forgotPassword = function (options, callback) {                                                      // 219
	  if (!options.email) {                                                                                       // 220
	    return reportError(new Meteor.Error(400, "Must pass options.email"), callback);                           // 221
	  }                                                                                                           // 222
	                                                                                                              //
	  if (callback) {                                                                                             // 224
	    Accounts.connection.call("forgotPassword", options, callback);                                            // 225
	  } else {                                                                                                    // 226
	    Accounts.connection.call("forgotPassword", options);                                                      // 227
	  }                                                                                                           // 228
	};                                                                                                            // 229
	                                                                                                              //
	// Resets a password based on a token originally created by                                                   // 231
	// Accounts.forgotPassword, and then logs in the matching user.                                               // 232
	//                                                                                                            // 233
	// @param token {String}                                                                                      // 234
	// @param newPassword {String}                                                                                // 235
	// @param callback (optional) {Function(error|undefined)}                                                     // 236
	                                                                                                              //
	/**                                                                                                           // 238
	 * @summary Reset the password for a user using a token received in email. Logs the user in afterwards.       //
	 * @locus Client                                                                                              //
	 * @param {String} token The token retrieved from the reset password URL.                                     //
	 * @param {String} newPassword A new password for the user. This is __not__ sent in plain text over the wire.
	 * @param {Function} [callback] Optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
	 * @importFromPackage accounts-base                                                                           //
	 */                                                                                                           //
	Accounts.resetPassword = function (token, newPassword, callback) {                                            // 246
	  check(token, String);                                                                                       // 247
	  check(newPassword, String);                                                                                 // 248
	                                                                                                              //
	  if (!newPassword) {                                                                                         // 250
	    return reportError(new Meteor.Error(400, "Password may not be empty"), callback);                         // 251
	  }                                                                                                           // 252
	                                                                                                              //
	  Accounts.callLoginMethod({                                                                                  // 254
	    methodName: 'resetPassword',                                                                              // 255
	    methodArguments: [token, Accounts._hashPassword(newPassword)],                                            // 256
	    userCallback: callback });                                                                                // 257
	};                                                                                                            // 258
	                                                                                                              //
	// Verifies a user's email address based on a token originally                                                // 260
	// created by Accounts.sendVerificationEmail                                                                  // 261
	//                                                                                                            // 262
	// @param token {String}                                                                                      // 263
	// @param callback (optional) {Function(error|undefined)}                                                     // 264
	                                                                                                              //
	/**                                                                                                           // 266
	 * @summary Marks the user's email address as verified. Logs the user in afterwards.                          //
	 * @locus Client                                                                                              //
	 * @param {String} token The token retrieved from the verification URL.                                       //
	 * @param {Function} [callback] Optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
	 * @importFromPackage accounts-base                                                                           //
	 */                                                                                                           //
	Accounts.verifyEmail = function (token, callback) {                                                           // 273
	  if (!token) {                                                                                               // 274
	    return reportError(new Meteor.Error(400, "Need to pass token"), callback);                                // 275
	  }                                                                                                           // 276
	                                                                                                              //
	  Accounts.callLoginMethod({                                                                                  // 278
	    methodName: 'verifyEmail',                                                                                // 279
	    methodArguments: [token],                                                                                 // 280
	    userCallback: callback });                                                                                // 281
	};                                                                                                            // 282
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}}}}},{"extensions":[".js",".json"]});
	require("./node_modules/meteor/accounts-password/password_client.js");
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	Package['accounts-password'] = {};
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/aldeed_collection2-core.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var MongoObject = Package['aldeed:simple-schema'].MongoObject;
	var _ = Package.underscore._;
	var check = Package.check.check;
	var Match = Package.check.Match;
	var Mongo = Package.mongo.Mongo;
	var LocalCollection = Package.minimongo.LocalCollection;
	var Minimongo = Package.minimongo.Minimongo;
	var EJSON = Package.ejson.EJSON;
	var EventEmitter = Package['raix:eventemitter'].EventEmitter;
	
	/* Package-scope variables */
	var Collection2;
	
	(function(){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                   //
	// packages/aldeed_collection2-core/lib/collection2.js                                                               //
	//                                                                                                                   //
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                     //
	// Exported only for listening to events                                                                             // 1
	Collection2 = new EventEmitter();                                                                                    // 2
	                                                                                                                     // 3
	// backwards compatibility                                                                                           // 4
	if (typeof Mongo === "undefined") {                                                                                  // 5
	  Mongo = {};                                                                                                        // 6
	  Mongo.Collection = Meteor.Collection;                                                                              // 7
	}                                                                                                                    // 8
	                                                                                                                     // 9
	var addValidationErrorsPropName = SimpleSchema.version >= 2 ? 'addValidationErrors' : 'addInvalidKeys';              // 10
	                                                                                                                     // 11
	/**                                                                                                                  // 12
	 * Mongo.Collection.prototype.attachSchema                                                                           // 13
	 * @param {SimpleSchema|Object} ss - SimpleSchema instance or a schema definition object                             // 14
	 *    from which to create a new SimpleSchema instance                                                               // 15
	 * @param {Object} [options]                                                                                         // 16
	 * @param {Boolean} [options.transform=false] Set to `true` if your document must be passed                          // 17
	 *    through the collection's transform to properly validate.                                                       // 18
	 * @param {Boolean} [options.replace=false] Set to `true` to replace any existing schema instead of combining        // 19
	 * @return {undefined}                                                                                               // 20
	 *                                                                                                                   // 21
	 * Use this method to attach a schema to a collection created by another package,                                    // 22
	 * such as Meteor.users. It is most likely unsafe to call this method more than                                      // 23
	 * once for a single collection, or to call this for a collection that had a                                         // 24
	 * schema object passed to its constructor.                                                                          // 25
	 */                                                                                                                  // 26
	Mongo.Collection.prototype.attachSchema = function c2AttachSchema(ss, options) {                                     // 27
	  var self = this;                                                                                                   // 28
	  options = options || {};                                                                                           // 29
	                                                                                                                     // 30
	  // Allow passing just the schema object                                                                            // 31
	  if (!(ss instanceof SimpleSchema)) {                                                                               // 32
	    ss = new SimpleSchema(ss);                                                                                       // 33
	  }                                                                                                                  // 34
	                                                                                                                     // 35
	  self._c2 = self._c2 || {};                                                                                         // 36
	                                                                                                                     // 37
	  // If we've already attached one schema, we combine both into a new schema unless options.replace is `true`        // 38
	  if (self._c2._simpleSchema && options.replace !== true) {                                                          // 39
	    if (ss.version >= 2) {                                                                                           // 40
	      var newSS = new SimpleSchema(self._c2._simpleSchema);                                                          // 41
	      newSS.extend(ss);                                                                                              // 42
	      ss = newSS;                                                                                                    // 43
	    } else {                                                                                                         // 44
	      ss = new SimpleSchema([self._c2._simpleSchema, ss]);                                                           // 45
	    }                                                                                                                // 46
	  }                                                                                                                  // 47
	                                                                                                                     // 48
	  var selector = options.selector;                                                                                   // 49
	                                                                                                                     // 50
	  function attachTo(obj) {                                                                                           // 51
	    if (typeof selector === "object") {                                                                              // 52
	      // Index of existing schema with identical selector                                                            // 53
	      var schemaIndex = -1;                                                                                          // 54
	                                                                                                                     // 55
	      // we need an array to hold multiple schemas                                                                   // 56
	      obj._c2._simpleSchemas = obj._c2._simpleSchemas || [];                                                         // 57
	                                                                                                                     // 58
	      // Loop through existing schemas with selectors                                                                // 59
	      obj._c2._simpleSchemas.forEach(function (schema, index) {                                                      // 60
	        // if we find a schema with an identical selector, save it's index                                           // 61
	        if(_.isEqual(schema.selector, selector)) {                                                                   // 62
	          schemaIndex = index;                                                                                       // 63
	        }                                                                                                            // 64
	      });                                                                                                            // 65
	      if (schemaIndex === -1) {                                                                                      // 66
	        // We didn't find the schema in our array - push it into the array                                           // 67
	        obj._c2._simpleSchemas.push({                                                                                // 68
	          schema: new SimpleSchema(ss),                                                                              // 69
	          selector: selector,                                                                                        // 70
	        });                                                                                                          // 71
	      } else {                                                                                                       // 72
	        // We found a schema with an identical selector in our array,                                                // 73
	        if (options.replace !== true) {                                                                              // 74
	          // Merge with existing schema unless options.replace is `true`                                             // 75
	          if (obj._c2._simpleSchemas[schemaIndex].schema.version >= 2) {                                             // 76
	            obj._c2._simpleSchemas[schemaIndex].schema.extend(ss);                                                   // 77
	          } else {                                                                                                   // 78
	            obj._c2._simpleSchemas[schemaIndex].schema = new SimpleSchema([obj._c2._simpleSchemas[schemaIndex].schema, ss]);
	          }                                                                                                          // 80
	        } else {                                                                                                     // 81
	          // If options.repalce is `true` replace existing schema with new schema                                    // 82
	          obj._c2._simpleSchemas[schemaIndex].schema = ss;                                                           // 83
	        }                                                                                                            // 84
	                                                                                                                     // 85
	      }                                                                                                              // 86
	                                                                                                                     // 87
	      // Remove existing schemas without selector                                                                    // 88
	      delete obj._c2._simpleSchema;                                                                                  // 89
	    } else {                                                                                                         // 90
	      // Track the schema in the collection                                                                          // 91
	      obj._c2._simpleSchema = ss;                                                                                    // 92
	                                                                                                                     // 93
	      // Remove existing schemas with selector                                                                       // 94
	      delete obj._c2._simpleSchemas;                                                                                 // 95
	    }                                                                                                                // 96
	  }                                                                                                                  // 97
	                                                                                                                     // 98
	  attachTo(self);                                                                                                    // 99
	  // Attach the schema to the underlying LocalCollection, too                                                        // 100
	  if (self._collection instanceof LocalCollection) {                                                                 // 101
	    self._collection._c2 = self._collection._c2 || {};                                                               // 102
	    attachTo(self._collection);                                                                                      // 103
	  }                                                                                                                  // 104
	                                                                                                                     // 105
	  defineDeny(self, options);                                                                                         // 106
	  keepInsecure(self);                                                                                                // 107
	                                                                                                                     // 108
	  Collection2.emit('schema.attached', self, ss, options);                                                            // 109
	};                                                                                                                   // 110
	                                                                                                                     // 111
	_.each([Mongo.Collection, LocalCollection], function (obj) {                                                         // 112
	  /**                                                                                                                // 113
	   * simpleSchema                                                                                                    // 114
	   * @description function detect the correct schema by given params. If it                                          // 115
	   * detect multi-schema presence in `self`, then it made an attempt to find a                                       // 116
	   * `selector` in args                                                                                              // 117
	   * @param {Object} doc - It could be <update> on update/upsert or document                                         // 118
	   * itself on insert/remove                                                                                         // 119
	   * @param {Object} [options] - It could be <update> on update/upsert etc                                           // 120
	   * @param {Object} [query] - it could be <query> on update/upsert                                                  // 121
	   * @return {Object} Schema                                                                                         // 122
	   */                                                                                                                // 123
	  obj.prototype.simpleSchema = function (doc, options, query) {                                                      // 124
	    if (!this._c2) return null;                                                                                      // 125
	    if (this._c2._simpleSchema) return this._c2._simpleSchema;                                                       // 126
	                                                                                                                     // 127
	    var schemas = this._c2._simpleSchemas;                                                                           // 128
	    if (schemas && schemas.length > 0) {                                                                             // 129
	      if (!doc) throw new Error('collection.simpleSchema() requires doc argument when there are multiple schemas');  // 130
	                                                                                                                     // 131
	      var schema, selector, target;                                                                                  // 132
	      for (var i = 0; i < schemas.length; i++) {                                                                     // 133
	        schema = schemas[i];                                                                                         // 134
	        selector = Object.keys(schema.selector)[0];                                                                  // 135
	                                                                                                                     // 136
	        // We will set this to undefined because in theory you might want to select                                  // 137
	        // on a null value.                                                                                          // 138
	        target = undefined;                                                                                          // 139
	                                                                                                                     // 140
	        // here we are looking for selector in different places                                                      // 141
	        // $set should have more priority here                                                                       // 142
	        if (doc.$set && typeof doc.$set[selector] !== 'undefined') {                                                 // 143
	          target = doc.$set[selector];                                                                               // 144
	        } else if (typeof doc[selector] !== 'undefined') {                                                           // 145
	          target = doc[selector];                                                                                    // 146
	        } else if (options && options.selector) {                                                                    // 147
	          target = options.selector[selector];                                                                       // 148
	        } else if (query && query[selector]) { // on upsert/update operations                                        // 149
	          target = query[selector];                                                                                  // 150
	        }                                                                                                            // 151
	                                                                                                                     // 152
	        // we need to compare given selector with doc property or option to                                          // 153
	        // find right schema                                                                                         // 154
	        if (target !== undefined && target === schema.selector[selector]) {                                          // 155
	          return schema.schema;                                                                                      // 156
	        }                                                                                                            // 157
	      }                                                                                                              // 158
	    }                                                                                                                // 159
	                                                                                                                     // 160
	    return null;                                                                                                     // 161
	  };                                                                                                                 // 162
	});                                                                                                                  // 163
	                                                                                                                     // 164
	// Wrap DB write operation methods                                                                                   // 165
	_.each(['insert', 'update'], function(methodName) {                                                                  // 166
	  var _super = Mongo.Collection.prototype[methodName];                                                               // 167
	  Mongo.Collection.prototype[methodName] = function() {                                                              // 168
	    var self = this, options,                                                                                        // 169
	        args = _.toArray(arguments);                                                                                 // 170
	                                                                                                                     // 171
	    options = (methodName === "insert") ? args[1] : args[2];                                                         // 172
	                                                                                                                     // 173
	    // Support missing options arg                                                                                   // 174
	    if (!options || typeof options === "function") {                                                                 // 175
	      options = {};                                                                                                  // 176
	    }                                                                                                                // 177
	                                                                                                                     // 178
	    if (self._c2 && options.bypassCollection2 !== true) {                                                            // 179
	      var userId = null;                                                                                             // 180
	      try { // https://github.com/aldeed/meteor-collection2/issues/175                                               // 181
	        userId = Meteor.userId();                                                                                    // 182
	      } catch (err) {}                                                                                               // 183
	                                                                                                                     // 184
	      args = doValidate.call(                                                                                        // 185
	        self,                                                                                                        // 186
	        methodName,                                                                                                  // 187
	        args,                                                                                                        // 188
	        true, // getAutoValues                                                                                       // 189
	        userId,                                                                                                      // 190
	        Meteor.isServer // isFromTrustedCode                                                                         // 191
	      );                                                                                                             // 192
	      if (!args) {                                                                                                   // 193
	        // doValidate already called the callback or threw the error so we're done.                                  // 194
	        // But insert should always return an ID to match core behavior.                                             // 195
	        return methodName === "insert" ? self._makeNewID() : undefined;                                              // 196
	      }                                                                                                              // 197
	    } else {                                                                                                         // 198
	      // We still need to adjust args because insert does not take options                                           // 199
	      if (methodName === "insert" && typeof args[1] !== 'function') args.splice(1, 1);                               // 200
	    }                                                                                                                // 201
	                                                                                                                     // 202
	    return _super.apply(self, args);                                                                                 // 203
	  };                                                                                                                 // 204
	});                                                                                                                  // 205
	                                                                                                                     // 206
	/*                                                                                                                   // 207
	 * Private                                                                                                           // 208
	 */                                                                                                                  // 209
	                                                                                                                     // 210
	function doValidate(type, args, getAutoValues, userId, isFromTrustedCode) {                                          // 211
	  var self = this, doc, callback, error, options, isUpsert, selector, last, hasCallback;                             // 212
	                                                                                                                     // 213
	  if (!args.length) {                                                                                                // 214
	    throw new Error(type + " requires an argument");                                                                 // 215
	  }                                                                                                                  // 216
	                                                                                                                     // 217
	  // Gather arguments and cache the selector                                                                         // 218
	  if (type === "insert") {                                                                                           // 219
	    doc = args[0];                                                                                                   // 220
	    options = args[1];                                                                                               // 221
	    callback = args[2];                                                                                              // 222
	                                                                                                                     // 223
	    // The real insert doesn't take options                                                                          // 224
	    if (typeof options === "function") {                                                                             // 225
	      args = [doc, options];                                                                                         // 226
	    } else if (typeof callback === "function") {                                                                     // 227
	      args = [doc, callback];                                                                                        // 228
	    } else {                                                                                                         // 229
	      args = [doc];                                                                                                  // 230
	    }                                                                                                                // 231
	  } else if (type === "update") {                                                                                    // 232
	    selector = args[0];                                                                                              // 233
	    doc = args[1];                                                                                                   // 234
	    options = args[2];                                                                                               // 235
	    callback = args[3];                                                                                              // 236
	  } else {                                                                                                           // 237
	    throw new Error("invalid type argument");                                                                        // 238
	  }                                                                                                                  // 239
	                                                                                                                     // 240
	  var validatedObjectWasInitiallyEmpty = _.isEmpty(doc);                                                             // 241
	                                                                                                                     // 242
	  // Support missing options arg                                                                                     // 243
	  if (!callback && typeof options === "function") {                                                                  // 244
	    callback = options;                                                                                              // 245
	    options = {};                                                                                                    // 246
	  }                                                                                                                  // 247
	  options = options || {};                                                                                           // 248
	                                                                                                                     // 249
	  last = args.length - 1;                                                                                            // 250
	                                                                                                                     // 251
	  hasCallback = (typeof args[last] === 'function');                                                                  // 252
	                                                                                                                     // 253
	  // If update was called with upsert:true, flag as an upsert                                                        // 254
	  isUpsert = (type === "update" && options.upsert === true);                                                         // 255
	                                                                                                                     // 256
	  // we need to pass `doc` and `options` to `simpleSchema` method, that's why                                        // 257
	  // schema declaration moved here                                                                                   // 258
	  var schema = self.simpleSchema(doc, options, selector);                                                            // 259
	  var isLocalCollection = (self._connection === null);                                                               // 260
	                                                                                                                     // 261
	  // On the server and for local collections, we allow passing `getAutoValues: false` to disable autoValue functions
	  if ((Meteor.isServer || isLocalCollection) && options.getAutoValues === false) {                                   // 263
	    getAutoValues = false;                                                                                           // 264
	  }                                                                                                                  // 265
	                                                                                                                     // 266
	  // Determine validation context                                                                                    // 267
	  var validationContext = options.validationContext;                                                                 // 268
	  if (validationContext) {                                                                                           // 269
	    if (typeof validationContext === 'string') {                                                                     // 270
	      validationContext = schema.namedContext(validationContext);                                                    // 271
	    }                                                                                                                // 272
	  } else {                                                                                                           // 273
	    validationContext = schema.namedContext();                                                                       // 274
	  }                                                                                                                  // 275
	                                                                                                                     // 276
	  // Add a default callback function if we're on the client and no callback was given                                // 277
	  if (Meteor.isClient && !callback) {                                                                                // 278
	    // Client can't block, so it can't report errors by exception,                                                   // 279
	    // only by callback. If they forget the callback, give them a                                                    // 280
	    // default one that logs the error, so they aren't totally                                                       // 281
	    // baffled if their writes don't work because their database is                                                  // 282
	    // down.                                                                                                         // 283
	    callback = function(err) {                                                                                       // 284
	      if (err) {                                                                                                     // 285
	        Meteor._debug(type + " failed: " + (err.reason || err.stack));                                               // 286
	      }                                                                                                              // 287
	    };                                                                                                               // 288
	  }                                                                                                                  // 289
	                                                                                                                     // 290
	  // If client validation is fine or is skipped but then something                                                   // 291
	  // is found to be invalid on the server, we get that error back                                                    // 292
	  // as a special Meteor.Error that we need to parse.                                                                // 293
	  if (Meteor.isClient && hasCallback) {                                                                              // 294
	    callback = args[last] = wrapCallbackForParsingServerErrors(validationContext, callback);                         // 295
	  }                                                                                                                  // 296
	                                                                                                                     // 297
	  var schemaAllowsId = schema.allowsKey("_id");                                                                      // 298
	  if (type === "insert" && !doc._id && schemaAllowsId) {                                                             // 299
	    doc._id = self._makeNewID();                                                                                     // 300
	  }                                                                                                                  // 301
	                                                                                                                     // 302
	  // Get the docId for passing in the autoValue/custom context                                                       // 303
	  var docId;                                                                                                         // 304
	  if (type === 'insert') {                                                                                           // 305
	    docId = doc._id; // might be undefined                                                                           // 306
	  } else if (type === "update" && selector) {                                                                        // 307
	    docId = typeof selector === 'string' || selector instanceof Mongo.ObjectID ? selector : selector._id;            // 308
	  }                                                                                                                  // 309
	                                                                                                                     // 310
	  // If _id has already been added, remove it temporarily if it's                                                    // 311
	  // not explicitly defined in the schema.                                                                           // 312
	  var cachedId;                                                                                                      // 313
	  if (doc._id && !schemaAllowsId) {                                                                                  // 314
	    cachedId = doc._id;                                                                                              // 315
	    delete doc._id;                                                                                                  // 316
	  }                                                                                                                  // 317
	                                                                                                                     // 318
	  function doClean(docToClean, getAutoValues, filter, autoConvert, removeEmptyStrings, trimStrings) {                // 319
	    // Clean the doc/modifier in place                                                                               // 320
	    schema.clean(docToClean, {                                                                                       // 321
	      mutate: true,                                                                                                  // 322
	      filter: filter,                                                                                                // 323
	      autoConvert: autoConvert,                                                                                      // 324
	      getAutoValues: getAutoValues,                                                                                  // 325
	      isModifier: (type !== "insert"),                                                                               // 326
	      removeEmptyStrings: removeEmptyStrings,                                                                        // 327
	      trimStrings: trimStrings,                                                                                      // 328
	      extendAutoValueContext: _.extend({                                                                             // 329
	        isInsert: (type === "insert"),                                                                               // 330
	        isUpdate: (type === "update" && options.upsert !== true),                                                    // 331
	        isUpsert: isUpsert,                                                                                          // 332
	        userId: userId,                                                                                              // 333
	        isFromTrustedCode: isFromTrustedCode,                                                                        // 334
	        docId: docId,                                                                                                // 335
	        isLocalCollection: isLocalCollection                                                                         // 336
	      }, options.extendAutoValueContext || {})                                                                       // 337
	    });                                                                                                              // 338
	  }                                                                                                                  // 339
	                                                                                                                     // 340
	  // Preliminary cleaning on both client and server. On the server and for local                                     // 341
	  // collections, automatic values will also be set at this point.                                                   // 342
	  doClean(                                                                                                           // 343
	    doc,                                                                                                             // 344
	    getAutoValues,                                                                                                   // 345
	    options.filter !== false,                                                                                        // 346
	    options.autoConvert !== false,                                                                                   // 347
	    options.removeEmptyStrings !== false,                                                                            // 348
	    options.trimStrings !== false                                                                                    // 349
	  );                                                                                                                 // 350
	                                                                                                                     // 351
	  // We clone before validating because in some cases we need to adjust the                                          // 352
	  // object a bit before validating it. If we adjusted `doc` itself, our                                             // 353
	  // changes would persist into the database.                                                                        // 354
	  var docToValidate = {};                                                                                            // 355
	  for (var prop in doc) {                                                                                            // 356
	    // We omit prototype properties when cloning because they will not be valid                                      // 357
	    // and mongo omits them when saving to the database anyway.                                                      // 358
	    if (doc.hasOwnProperty(prop)) {                                                                                  // 359
	      docToValidate[prop] = doc[prop];                                                                               // 360
	    }                                                                                                                // 361
	  }                                                                                                                  // 362
	                                                                                                                     // 363
	  // On the server, upserts are possible; SimpleSchema handles upserts pretty                                        // 364
	  // well by default, but it will not know about the fields in the selector,                                         // 365
	  // which are also stored in the database if an insert is performed. So we                                          // 366
	  // will allow these fields to be considered for validation by adding them                                          // 367
	  // to the $set in the modifier. This is no doubt prone to errors, but there                                        // 368
	  // probably isn't any better way right now.                                                                        // 369
	  if (Meteor.isServer && isUpsert && _.isObject(selector)) {                                                         // 370
	    var set = docToValidate.$set || {};                                                                              // 371
	    docToValidate.$set = _.clone(selector);                                                                          // 372
	    if (!schemaAllowsId) delete docToValidate.$set._id;                                                              // 373
	    _.extend(docToValidate.$set, set);                                                                               // 374
	  }                                                                                                                  // 375
	                                                                                                                     // 376
	  // Set automatic values for validation on the client.                                                              // 377
	  // On the server, we already updated doc with auto values, but on the client,                                      // 378
	  // we will add them to docToValidate for validation purposes only.                                                 // 379
	  // This is because we want all actual values generated on the server.                                              // 380
	  if (Meteor.isClient && !isLocalCollection) {                                                                       // 381
	    doClean(docToValidate, true, false, false, false, false);                                                        // 382
	  }                                                                                                                  // 383
	                                                                                                                     // 384
	  // XXX Maybe move this into SimpleSchema                                                                           // 385
	  if (!validatedObjectWasInitiallyEmpty && _.isEmpty(docToValidate)) {                                               // 386
	    throw new Error('After filtering out keys not in the schema, your ' +                                            // 387
	      (type === 'update' ? 'modifier' : 'object') +                                                                  // 388
	      ' is now empty');                                                                                              // 389
	  }                                                                                                                  // 390
	                                                                                                                     // 391
	  // Validate doc                                                                                                    // 392
	  var isValid;                                                                                                       // 393
	  if (options.validate === false) {                                                                                  // 394
	    isValid = true;                                                                                                  // 395
	  } else {                                                                                                           // 396
	    isValid = validationContext.validate(docToValidate, {                                                            // 397
	      modifier: (type === "update" || type === "upsert"),                                                            // 398
	      upsert: isUpsert,                                                                                              // 399
	      extendedCustomContext: _.extend({                                                                              // 400
	        isInsert: (type === "insert"),                                                                               // 401
	        isUpdate: (type === "update" && options.upsert !== true),                                                    // 402
	        isUpsert: isUpsert,                                                                                          // 403
	        userId: userId,                                                                                              // 404
	        isFromTrustedCode: isFromTrustedCode,                                                                        // 405
	        docId: docId,                                                                                                // 406
	        isLocalCollection: isLocalCollection                                                                         // 407
	      }, options.extendedCustomContext || {})                                                                        // 408
	    });                                                                                                              // 409
	  }                                                                                                                  // 410
	                                                                                                                     // 411
	  if (isValid) {                                                                                                     // 412
	    // Add the ID back                                                                                               // 413
	    if (cachedId) {                                                                                                  // 414
	      doc._id = cachedId;                                                                                            // 415
	    }                                                                                                                // 416
	                                                                                                                     // 417
	    // Update the args to reflect the cleaned doc                                                                    // 418
	    // XXX not sure this is necessary since we mutate                                                                // 419
	    if (type === "insert") {                                                                                         // 420
	      args[0] = doc;                                                                                                 // 421
	    } else {                                                                                                         // 422
	      args[1] = doc;                                                                                                 // 423
	    }                                                                                                                // 424
	                                                                                                                     // 425
	    // If callback, set invalidKey when we get a mongo unique error                                                  // 426
	    if (Meteor.isServer && hasCallback) {                                                                            // 427
	      args[last] = wrapCallbackForParsingMongoValidationErrors(validationContext, args[last]);                       // 428
	    }                                                                                                                // 429
	                                                                                                                     // 430
	    return args;                                                                                                     // 431
	  } else {                                                                                                           // 432
	    error = getErrorObject(validationContext);                                                                       // 433
	    if (callback) {                                                                                                  // 434
	      // insert/update/upsert pass `false` when there's an error, so we do that                                      // 435
	      callback(error, false);                                                                                        // 436
	    } else {                                                                                                         // 437
	      throw error;                                                                                                   // 438
	    }                                                                                                                // 439
	  }                                                                                                                  // 440
	}                                                                                                                    // 441
	                                                                                                                     // 442
	function getErrorObject(context) {                                                                                   // 443
	  var message;                                                                                                       // 444
	  var invalidKeys = SimpleSchema.version >= 2 ? context.validationErrors() : context.invalidKeys();                  // 445
	  if (invalidKeys.length) {                                                                                          // 446
	    message = context.keyErrorMessage(invalidKeys[0].name);                                                          // 447
	  } else {                                                                                                           // 448
	    message = "Failed validation";                                                                                   // 449
	  }                                                                                                                  // 450
	  var error = new Error(message);                                                                                    // 451
	  error.invalidKeys = invalidKeys;                                                                                   // 452
	  error.validationContext = context;                                                                                 // 453
	  // If on the server, we add a sanitized error, too, in case we're                                                  // 454
	  // called from a method.                                                                                           // 455
	  if (Meteor.isServer) {                                                                                             // 456
	    error.sanitizedError = new Meteor.Error(400, message, EJSON.stringify(error.invalidKeys));                       // 457
	  }                                                                                                                  // 458
	  return error;                                                                                                      // 459
	}                                                                                                                    // 460
	                                                                                                                     // 461
	function addUniqueError(context, errorMessage) {                                                                     // 462
	  var name = errorMessage.split('c2_')[1].split(' ')[0];                                                             // 463
	  var val = errorMessage.split('dup key:')[1].split('"')[1];                                                         // 464
	                                                                                                                     // 465
	  context[addValidationErrorsPropName]([{                                                                            // 466
	    name: name,                                                                                                      // 467
	    type: 'notUnique',                                                                                               // 468
	    value: val                                                                                                       // 469
	  }]);                                                                                                               // 470
	}                                                                                                                    // 471
	                                                                                                                     // 472
	function wrapCallbackForParsingMongoValidationErrors(validationContext, cb) {                                        // 473
	  return function wrappedCallbackForParsingMongoValidationErrors(error) {                                            // 474
	    var args = _.toArray(arguments);                                                                                 // 475
	    if (error &&                                                                                                     // 476
	        ((error.name === "MongoError" && error.code === 11001) || error.message.indexOf('MongoError: E11000' !== -1)) &&
	        error.message.indexOf('c2_') !== -1) {                                                                       // 478
	      addUniqueError(validationContext, error.message);                                                              // 479
	      args[0] = getErrorObject(validationContext);                                                                   // 480
	    }                                                                                                                // 481
	    return cb.apply(this, args);                                                                                     // 482
	  };                                                                                                                 // 483
	}                                                                                                                    // 484
	                                                                                                                     // 485
	function wrapCallbackForParsingServerErrors(validationContext, cb) {                                                 // 486
	  return function wrappedCallbackForParsingServerErrors(error) {                                                     // 487
	    var args = _.toArray(arguments);                                                                                 // 488
	    // Handle our own validation errors                                                                              // 489
	    if (error instanceof Meteor.Error &&                                                                             // 490
	        error.error === 400 &&                                                                                       // 491
	        error.reason === "INVALID" &&                                                                                // 492
	        typeof error.details === "string") {                                                                         // 493
	      var invalidKeysFromServer = EJSON.parse(error.details);                                                        // 494
	      validationContext[addValidationErrorsPropName](invalidKeysFromServer);                                         // 495
	      args[0] = getErrorObject(validationContext);                                                                   // 496
	    }                                                                                                                // 497
	    // Handle Mongo unique index errors, which are forwarded to the client as 409 errors                             // 498
	    else if (error instanceof Meteor.Error &&                                                                        // 499
	             error.error === 409 &&                                                                                  // 500
	             error.reason &&                                                                                         // 501
	             error.reason.indexOf('E11000') !== -1 &&                                                                // 502
	             error.reason.indexOf('c2_') !== -1) {                                                                   // 503
	      addUniqueError(validationContext, error.reason);                                                               // 504
	      args[0] = getErrorObject(validationContext);                                                                   // 505
	    }                                                                                                                // 506
	    return cb.apply(this, args);                                                                                     // 507
	  };                                                                                                                 // 508
	}                                                                                                                    // 509
	                                                                                                                     // 510
	var alreadyInsecured = {};                                                                                           // 511
	function keepInsecure(c) {                                                                                           // 512
	  // If insecure package is in use, we need to add allow rules that return                                           // 513
	  // true. Otherwise, it would seemingly turn off insecure mode.                                                     // 514
	  if (Package && Package.insecure && !alreadyInsecured[c._name]) {                                                   // 515
	    c.allow({                                                                                                        // 516
	      insert: function() {                                                                                           // 517
	        return true;                                                                                                 // 518
	      },                                                                                                             // 519
	      update: function() {                                                                                           // 520
	        return true;                                                                                                 // 521
	      },                                                                                                             // 522
	      remove: function () {                                                                                          // 523
	        return true;                                                                                                 // 524
	      },                                                                                                             // 525
	      fetch: [],                                                                                                     // 526
	      transform: null                                                                                                // 527
	    });                                                                                                              // 528
	    alreadyInsecured[c._name] = true;                                                                                // 529
	  }                                                                                                                  // 530
	  // If insecure package is NOT in use, then adding the two deny functions                                           // 531
	  // does not have any effect on the main app's security paradigm. The                                               // 532
	  // user will still be required to add at least one allow function of her                                           // 533
	  // own for each operation for this collection. And the user may still add                                          // 534
	  // additional deny functions, but does not have to.                                                                // 535
	}                                                                                                                    // 536
	                                                                                                                     // 537
	var alreadyDefined = {};                                                                                             // 538
	function defineDeny(c, options) {                                                                                    // 539
	  if (!alreadyDefined[c._name]) {                                                                                    // 540
	                                                                                                                     // 541
	    var isLocalCollection = (c._connection === null);                                                                // 542
	                                                                                                                     // 543
	    // First define deny functions to extend doc with the results of clean                                           // 544
	    // and autovalues. This must be done with "transform: null" or we would be                                       // 545
	    // extending a clone of doc and therefore have no effect.                                                        // 546
	    c.deny({                                                                                                         // 547
	      insert: function(userId, doc) {                                                                                // 548
	        // Referenced doc is cleaned in place                                                                        // 549
	        c.simpleSchema(doc).clean(doc, {                                                                             // 550
	          mutate: true,                                                                                              // 551
	          isModifier: false,                                                                                         // 552
	          // We don't do these here because they are done on the client if desired                                   // 553
	          filter: false,                                                                                             // 554
	          autoConvert: false,                                                                                        // 555
	          removeEmptyStrings: false,                                                                                 // 556
	          trimStrings: false,                                                                                        // 557
	          extendAutoValueContext: {                                                                                  // 558
	            isInsert: true,                                                                                          // 559
	            isUpdate: false,                                                                                         // 560
	            isUpsert: false,                                                                                         // 561
	            userId: userId,                                                                                          // 562
	            isFromTrustedCode: false,                                                                                // 563
	            docId: doc._id,                                                                                          // 564
	            isLocalCollection: isLocalCollection                                                                     // 565
	          }                                                                                                          // 566
	        });                                                                                                          // 567
	                                                                                                                     // 568
	        return false;                                                                                                // 569
	      },                                                                                                             // 570
	      update: function(userId, doc, fields, modifier) {                                                              // 571
	        // Referenced modifier is cleaned in place                                                                   // 572
	        c.simpleSchema(modifier).clean(modifier, {                                                                   // 573
	          mutate: true,                                                                                              // 574
	          isModifier: true,                                                                                          // 575
	          // We don't do these here because they are done on the client if desired                                   // 576
	          filter: false,                                                                                             // 577
	          autoConvert: false,                                                                                        // 578
	          removeEmptyStrings: false,                                                                                 // 579
	          trimStrings: false,                                                                                        // 580
	          extendAutoValueContext: {                                                                                  // 581
	            isInsert: false,                                                                                         // 582
	            isUpdate: true,                                                                                          // 583
	            isUpsert: false,                                                                                         // 584
	            userId: userId,                                                                                          // 585
	            isFromTrustedCode: false,                                                                                // 586
	            docId: doc && doc._id,                                                                                   // 587
	            isLocalCollection: isLocalCollection                                                                     // 588
	          }                                                                                                          // 589
	        });                                                                                                          // 590
	                                                                                                                     // 591
	        return false;                                                                                                // 592
	      },                                                                                                             // 593
	      fetch: ['_id'],                                                                                                // 594
	      transform: null                                                                                                // 595
	    });                                                                                                              // 596
	                                                                                                                     // 597
	    // Second define deny functions to validate again on the server                                                  // 598
	    // for client-initiated inserts and updates. These should be                                                     // 599
	    // called after the clean/autovalue functions since we're adding                                                 // 600
	    // them after. These must *not* have "transform: null" if options.transform is true because                      // 601
	    // we need to pass the doc through any transforms to be sure                                                     // 602
	    // that custom types are properly recognized for type validation.                                                // 603
	    c.deny(_.extend({                                                                                                // 604
	      insert: function(userId, doc) {                                                                                // 605
	        // We pass the false options because we will have done them on client if desired                             // 606
	        doValidate.call(                                                                                             // 607
	          c,                                                                                                         // 608
	          "insert",                                                                                                  // 609
	          [                                                                                                          // 610
	            doc,                                                                                                     // 611
	            {                                                                                                        // 612
	              trimStrings: false,                                                                                    // 613
	              removeEmptyStrings: false,                                                                             // 614
	              filter: false,                                                                                         // 615
	              autoConvert: false                                                                                     // 616
	            },                                                                                                       // 617
	            function(error) {                                                                                        // 618
	              if (error) {                                                                                           // 619
	                throw new Meteor.Error(400, 'INVALID', EJSON.stringify(error.invalidKeys));                          // 620
	              }                                                                                                      // 621
	            }                                                                                                        // 622
	          ],                                                                                                         // 623
	          false, // getAutoValues                                                                                    // 624
	          userId,                                                                                                    // 625
	          false // isFromTrustedCode                                                                                 // 626
	        );                                                                                                           // 627
	                                                                                                                     // 628
	        return false;                                                                                                // 629
	      },                                                                                                             // 630
	      update: function(userId, doc, fields, modifier) {                                                              // 631
	        // NOTE: This will never be an upsert because client-side upserts                                            // 632
	        // are not allowed once you define allow/deny functions.                                                     // 633
	        // We pass the false options because we will have done them on client if desired                             // 634
	        doValidate.call(                                                                                             // 635
	          c,                                                                                                         // 636
	          "update",                                                                                                  // 637
	          [                                                                                                          // 638
	            {_id: doc && doc._id},                                                                                   // 639
	            modifier,                                                                                                // 640
	            {                                                                                                        // 641
	              trimStrings: false,                                                                                    // 642
	              removeEmptyStrings: false,                                                                             // 643
	              filter: false,                                                                                         // 644
	              autoConvert: false                                                                                     // 645
	            },                                                                                                       // 646
	            function(error) {                                                                                        // 647
	              if (error) {                                                                                           // 648
	                throw new Meteor.Error(400, 'INVALID', EJSON.stringify(error.invalidKeys));                          // 649
	              }                                                                                                      // 650
	            }                                                                                                        // 651
	          ],                                                                                                         // 652
	          false, // getAutoValues                                                                                    // 653
	          userId,                                                                                                    // 654
	          false // isFromTrustedCode                                                                                 // 655
	        );                                                                                                           // 656
	                                                                                                                     // 657
	        return false;                                                                                                // 658
	      },                                                                                                             // 659
	      fetch: ['_id']                                                                                                 // 660
	    }, options.transform === true ? {} : {transform: null}));                                                        // 661
	                                                                                                                     // 662
	    // note that we've already done this collection so that we don't do it again                                     // 663
	    // if attachSchema is called again                                                                               // 664
	    alreadyDefined[c._name] = true;                                                                                  // 665
	  }                                                                                                                  // 666
	}                                                                                                                    // 667
	                                                                                                                     // 668
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['aldeed:collection2-core'] = {}, {
	  Collection2: Collection2
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/aldeed_collection2.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	Package['aldeed:collection2'] = {};
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/aldeed_schema-deny.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var Collection2 = Package['aldeed:collection2-core'].Collection2;
	var _ = Package.underscore._;
	var LocalCollection = Package.minimongo.LocalCollection;
	var Minimongo = Package.minimongo.Minimongo;
	var check = Package.check.check;
	var Match = Package.check.Match;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var MongoObject = Package['aldeed:simple-schema'].MongoObject;
	var Mongo = Package.mongo.Mongo;
	
	(function(){
	
	/////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                     //
	// packages/aldeed_schema-deny/lib/deny.js                                             //
	//                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////
	                                                                                       //
	// Extend the schema options allowed by SimpleSchema                                   // 1
	SimpleSchema.extendOptions({                                                           // 2
	  denyInsert: Match.Optional(Boolean),                                                 // 3
	  denyUpdate: Match.Optional(Boolean),                                                 // 4
	});                                                                                    // 5
	                                                                                       // 6
	// Define validation error messages                                                    // 7
	if (!SimpleSchema.version || SimpleSchema.version < 2) {                               // 8
	  SimpleSchema.messages({                                                              // 9
	    insertNotAllowed: '[label] cannot be set during an insert',                        // 10
	    updateNotAllowed: '[label] cannot be set during an update'                         // 11
	  });                                                                                  // 12
	}                                                                                      // 13
	                                                                                       // 14
	Collection2.on('schema.attached', function (collection, ss) {                          // 15
	  if (ss.version >= 2) {                                                               // 16
	    ss.messageBox.messages({                                                           // 17
	      insertNotAllowed: '{{label}} cannot be set during an insert',                    // 18
	      updateNotAllowed: '{{label}} cannot be set during an update'                     // 19
	    });                                                                                // 20
	  }                                                                                    // 21
	                                                                                       // 22
	  ss.addValidator(function() {                                                         // 23
	    if (!this.isSet) return;                                                           // 24
	                                                                                       // 25
	    var def = this.definition;                                                         // 26
	                                                                                       // 27
	    if (def.denyInsert && this.isInsert) return 'insertNotAllowed';                    // 28
	    if (def.denyUpdate && (this.isUpdate || this.isUpsert)) return 'updateNotAllowed';
	  });                                                                                  // 30
	});                                                                                    // 31
	                                                                                       // 32
	/////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	Package['aldeed:schema-deny'] = {};
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/aldeed_schema-index.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var Collection2 = Package['aldeed:collection2-core'].Collection2;
	var _ = Package.underscore._;
	var LocalCollection = Package.minimongo.LocalCollection;
	var Minimongo = Package.minimongo.Minimongo;
	var check = Package.check.check;
	var Match = Package.check.Match;
	var meteorInstall = Package.modules.meteorInstall;
	var Buffer = Package.modules.Buffer;
	var process = Package.modules.process;
	var Symbol = Package['ecmascript-runtime'].Symbol;
	var Map = Package['ecmascript-runtime'].Map;
	var Set = Package['ecmascript-runtime'].Set;
	var meteorBabelHelpers = Package['babel-runtime'].meteorBabelHelpers;
	var Promise = Package.promise.Promise;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var MongoObject = Package['aldeed:simple-schema'].MongoObject;
	var Mongo = Package.mongo.Mongo;
	
	var require = meteorInstall({"node_modules":{"meteor":{"aldeed:schema-index":{"lib":{"indexing.js":function(){
	
	///////////////////////////////////////////////////////////////////////////////////////
	//                                                                                   //
	// packages/aldeed_schema-index/lib/indexing.js                                      //
	//                                                                                   //
	///////////////////////////////////////////////////////////////////////////////////////
	                                                                                     //
	// Extend the schema options allowed by SimpleSchema                                 // 1
	SimpleSchema.extendOptions({                                                         // 2
	  index: Match.Optional(Match.OneOf(Number, String, Boolean)),                       // 3
	  unique: Match.Optional(Boolean),                                                   // 4
	  sparse: Match.Optional(Boolean)                                                    // 5
	});                                                                                  // 2
	                                                                                     //
	// Define validation error messages (legacy)                                         // 8
	if (!SimpleSchema.version || SimpleSchema.version < 2) {                             // 9
	  SimpleSchema.messages({                                                            // 10
	    notUnique: '[label] must be unique'                                              // 11
	  });                                                                                // 10
	}                                                                                    // 13
	                                                                                     //
	if (Meteor.isServer) {                                                               // 15
	  Collection2.on('schema.attached', function (collection, ss) {                      // 16
	    // Define validation error messages                                              // 17
	    if (ss.version >= 2) {                                                           // 18
	      ss.messageBox.messages({                                                       // 19
	        notUnique: '{{label}} must be unique'                                        // 20
	      });                                                                            // 19
	    }                                                                                // 22
	                                                                                     //
	    function ensureIndex(index, indexName, unique, sparse) {                         // 24
	      Meteor.startup(function () {                                                   // 25
	        collection._collection._ensureIndex(index, {                                 // 26
	          background: true,                                                          // 27
	          name: indexName,                                                           // 28
	          unique: unique,                                                            // 29
	          sparse: sparse                                                             // 30
	        });                                                                          // 26
	      });                                                                            // 32
	    }                                                                                // 33
	                                                                                     //
	    function dropIndex(indexName) {                                                  // 35
	      Meteor.startup(function () {                                                   // 36
	        try {                                                                        // 37
	          collection._collection._dropIndex(indexName);                              // 38
	        } catch (err) {                                                              // 39
	          // no index with that name, which is what we want                          // 40
	        }                                                                            // 41
	      });                                                                            // 42
	    }                                                                                // 43
	                                                                                     //
	    var propName = ss.version === 2 ? 'mergedSchema' : 'schema';                     // 45
	                                                                                     //
	    // Loop over fields definitions and ensure collection indexes (server side only)
	    _.each(ss[propName](), function (definition, fieldName) {                        // 48
	      if ('index' in definition || definition.unique === true) {                     // 49
	        var index = {},                                                              // 50
	            indexValue;                                                              // 50
	        // If they specified `unique: true` but not `index`,                         // 51
	        // we assume `index: 1` to set up the unique index in mongo                  // 52
	        if ('index' in definition) {                                                 // 53
	          indexValue = definition.index;                                             // 54
	          if (indexValue === true) indexValue = 1;                                   // 55
	        } else {                                                                     // 56
	          indexValue = 1;                                                            // 57
	        }                                                                            // 58
	        var indexName = 'c2_' + fieldName;                                           // 59
	        // In the index object, we want object array keys without the ".$" piece     // 60
	        var idxFieldName = fieldName.replace(/\.\$\./g, ".");                        // 61
	        index[idxFieldName] = indexValue;                                            // 62
	        var unique = !!definition.unique && (indexValue === 1 || indexValue === -1);
	        var sparse = definition.sparse || false;                                     // 64
	                                                                                     //
	        // If unique and optional, force sparse to prevent errors                    // 66
	        if (!sparse && unique && definition.optional) sparse = true;                 // 67
	                                                                                     //
	        if (indexValue === false) {                                                  // 69
	          dropIndex(indexName);                                                      // 70
	        } else {                                                                     // 71
	          ensureIndex(index, indexName, unique, sparse);                             // 72
	        }                                                                            // 73
	      }                                                                              // 74
	    });                                                                              // 75
	  });                                                                                // 76
	}                                                                                    // 77
	///////////////////////////////////////////////////////////////////////////////////////
	
	}}}}}},{"extensions":[".js",".json"]});
	require("./node_modules/meteor/aldeed:schema-index/lib/indexing.js");
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	Package['aldeed:schema-index'] = {};
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/aldeed_simple-schema.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var Tracker = Package.tracker.Tracker;
	var Deps = Package.tracker.Deps;
	var _ = Package.underscore._;
	var check = Package.check.check;
	var Match = Package.check.Match;
	var Random = Package.random.Random;
	
	/* Package-scope variables */
	var humanize, MongoObject, Utility, SimpleSchema, doValidation1, doValidation2, SimpleSchemaValidationContext;
	
	(function(){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// packages/aldeed_simple-schema/string-polyfills.js                                                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	if (!String.prototype.startsWith) {                                                                                    // 1
	  String.prototype.startsWith = function(searchString, position) {                                                     // 2
	    position = position || 0;                                                                                          // 3
	    return this.indexOf(searchString, position) === position;                                                          // 4
	  };                                                                                                                   // 5
	}                                                                                                                      // 6
	                                                                                                                       // 7
	if (!String.prototype.trim) {                                                                                          // 8
	  String.prototype.trim = function () {                                                                                // 9
	    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');                                                     // 10
	  };                                                                                                                   // 11
	}                                                                                                                      // 12
	                                                                                                                       // 13
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// packages/aldeed_simple-schema/string-humanize.js                                                                    //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	/*                                                                                                                     // 1
	  Code source:                                                                                                         // 2
	    https://github.com/jxson/string-humanize                                                                           // 3
	    https://github.com/jxson/string-capitalize                                                                         // 4
	 */                                                                                                                    // 5
	                                                                                                                       // 6
	function capitalize(string){                                                                                           // 7
	  string = string || '';                                                                                               // 8
	  string = string.trim();                                                                                              // 9
	                                                                                                                       // 10
	  if (string[0]) {                                                                                                     // 11
	    string = string[0].toUpperCase() + string.substr(1).toLowerCase();                                                 // 12
	  }                                                                                                                    // 13
	                                                                                                                       // 14
	  return string;                                                                                                       // 15
	}                                                                                                                      // 16
	                                                                                                                       // 17
	humanize = function humanize(string){                                                                                  // 18
	  string = string || '';                                                                                               // 19
	  string = string.toString(); // might be a number                                                                     // 20
	  string = string.trim();                                                                                              // 21
	  string = string.replace(extname(string), '');                                                                        // 22
	  string = underscore(string);                                                                                         // 23
	  string = string.replace(/[\W_]+/g, ' ');                                                                             // 24
	                                                                                                                       // 25
	  return capitalize(string);                                                                                           // 26
	}                                                                                                                      // 27
	                                                                                                                       // 28
	                                                                                                                       // 29
	function underscore(string){                                                                                           // 30
	  string = string || '';                                                                                               // 31
	  string = string.toString(); // might be a number                                                                     // 32
	  string = string.trim();                                                                                              // 33
	  string = string.replace(/([a-z\d])([A-Z]+)/g, '$1_$2');                                                              // 34
	  string = string.replace(/[-\s]+/g, '_').toLowerCase();                                                               // 35
	                                                                                                                       // 36
	  return string;                                                                                                       // 37
	}                                                                                                                      // 38
	                                                                                                                       // 39
	function extname(string){                                                                                              // 40
	  var index = string.lastIndexOf('.');                                                                                 // 41
	  var ext = string.substring(index, string.length);                                                                    // 42
	                                                                                                                       // 43
	  return (index === -1) ? '' : ext;                                                                                    // 44
	}                                                                                                                      // 45
	                                                                                                                       // 46
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// packages/aldeed_simple-schema/mongo-object.js                                                                       //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	/* global MongoObject:true */                                                                                          // 1
	                                                                                                                       // 2
	                                                                                                                       // 3
	var isObject = function(obj) {                                                                                         // 4
	  return obj === Object(obj);                                                                                          // 5
	};                                                                                                                     // 6
	                                                                                                                       // 7
	// getPrototypeOf polyfill                                                                                             // 8
	if (typeof Object.getPrototypeOf !== "function") {                                                                     // 9
	  if (typeof "".__proto__ === "object") {                                                                              // 10
	    Object.getPrototypeOf = function(object) {                                                                         // 11
	      return object.__proto__;                                                                                         // 12
	    };                                                                                                                 // 13
	  } else {                                                                                                             // 14
	    Object.getPrototypeOf = function(object) {                                                                         // 15
	      // May break if the constructor has been tampered with                                                           // 16
	      return object.constructor.prototype;                                                                             // 17
	    };                                                                                                                 // 18
	  }                                                                                                                    // 19
	}                                                                                                                      // 20
	                                                                                                                       // 21
	/* Tests whether "obj" is an Object as opposed to                                                                      // 22
	 * something that inherits from Object                                                                                 // 23
	 *                                                                                                                     // 24
	 * @param {any} obj                                                                                                    // 25
	 * @returns {Boolean}                                                                                                  // 26
	 */                                                                                                                    // 27
	var isBasicObject = function(obj) {                                                                                    // 28
	  return isObject(obj) && Object.getPrototypeOf(obj) === Object.prototype;                                             // 29
	};                                                                                                                     // 30
	                                                                                                                       // 31
	/* Takes a specific string that uses mongo-style dot notation                                                          // 32
	 * and returns a generic string equivalent. Replaces all numeric                                                       // 33
	 * "pieces" with a dollar sign ($).                                                                                    // 34
	 *                                                                                                                     // 35
	 * @param {type} name                                                                                                  // 36
	 * @returns {unresolved}                                                                                               // 37
	 */                                                                                                                    // 38
	var makeGeneric = function makeGeneric(name) {                                                                         // 39
	  if (typeof name !== "string") {                                                                                      // 40
	    return null;                                                                                                       // 41
	  }                                                                                                                    // 42
	  return name.replace(/\.[0-9]+\./g, '.$.').replace(/\.[0-9]+$/g, '.$');                                               // 43
	};                                                                                                                     // 44
	                                                                                                                       // 45
	var appendAffectedKey = function appendAffectedKey(affectedKey, key) {                                                 // 46
	  if (key === "$each") {                                                                                               // 47
	    return affectedKey;                                                                                                // 48
	  } else {                                                                                                             // 49
	    return (affectedKey ? affectedKey + "." + key : key);                                                              // 50
	  }                                                                                                                    // 51
	};                                                                                                                     // 52
	                                                                                                                       // 53
	// Extracts operator piece, if present, from position string                                                           // 54
	var extractOp = function extractOp(position) {                                                                         // 55
	  var firstPositionPiece = position.slice(0, position.indexOf("["));                                                   // 56
	  return (firstPositionPiece.substring(0, 1) === "$") ? firstPositionPiece : null;                                     // 57
	};                                                                                                                     // 58
	                                                                                                                       // 59
	/*                                                                                                                     // 60
	 * @constructor                                                                                                        // 61
	 * @param {Object} objOrModifier                                                                                       // 62
	 * @param {string[]} blackBoxKeys - A list of the names of keys that shouldn't be traversed                            // 63
	 * @returns {undefined}                                                                                                // 64
	 *                                                                                                                     // 65
	 * Creates a new MongoObject instance. The object passed as the first argument                                         // 66
	 * will be modified in place by calls to instance methods. Also, immediately                                           // 67
	 * upon creation of the instance, the object will have any `undefined` keys                                            // 68
	 * removed recursively.                                                                                                // 69
	 */                                                                                                                    // 70
	MongoObject = function(objOrModifier, blackBoxKeys) {                                                                  // 71
	  var self = this;                                                                                                     // 72
	  self._obj = objOrModifier;                                                                                           // 73
	  self._affectedKeys = {};                                                                                             // 74
	  self._genericAffectedKeys = {};                                                                                      // 75
	  self._parentPositions = [];                                                                                          // 76
	  self._positionsInsideArrays = [];                                                                                    // 77
	  self._objectPositions = [];                                                                                          // 78
	                                                                                                                       // 79
	  function parseObj(val, currentPosition, affectedKey, operator, adjusted, isWithinArray) {                            // 80
	                                                                                                                       // 81
	    // Adjust for first-level modifier operators                                                                       // 82
	    if (!operator && affectedKey && affectedKey.substring(0, 1) === "$") {                                             // 83
	      operator = affectedKey;                                                                                          // 84
	      affectedKey = null;                                                                                              // 85
	    }                                                                                                                  // 86
	                                                                                                                       // 87
	    var affectedKeyIsBlackBox = false;                                                                                 // 88
	    var affectedKeyGeneric;                                                                                            // 89
	    var stop = false;                                                                                                  // 90
	    if (affectedKey) {                                                                                                 // 91
	                                                                                                                       // 92
	      // Adjust for $push and $addToSet and $pull and $pop                                                             // 93
	      if (!adjusted) {                                                                                                 // 94
	        if (operator === "$push" || operator === "$addToSet" || operator === "$pop") {                                 // 95
	          // Adjust for $each                                                                                          // 96
	          // We can simply jump forward and pretend like the $each array                                               // 97
	          // is the array for the field. This has the added benefit of                                                 // 98
	          // skipping past any $slice, which we also don't care about.                                                 // 99
	          if (isBasicObject(val) && "$each" in val) {                                                                  // 100
	            val = val.$each;                                                                                           // 101
	            currentPosition = currentPosition + "[$each]";                                                             // 102
	          } else {                                                                                                     // 103
	            affectedKey = affectedKey + ".0";                                                                          // 104
	          }                                                                                                            // 105
	          adjusted = true;                                                                                             // 106
	        } else if (operator === "$pull") {                                                                             // 107
	          affectedKey = affectedKey + ".0";                                                                            // 108
	          if (isBasicObject(val)) {                                                                                    // 109
	            stop = true;                                                                                               // 110
	          }                                                                                                            // 111
	          adjusted = true;                                                                                             // 112
	        }                                                                                                              // 113
	      }                                                                                                                // 114
	                                                                                                                       // 115
	      // Make generic key                                                                                              // 116
	      affectedKeyGeneric = makeGeneric(affectedKey);                                                                   // 117
	                                                                                                                       // 118
	      // Determine whether affected key should be treated as a black box                                               // 119
	      affectedKeyIsBlackBox = _.contains(blackBoxKeys, affectedKeyGeneric);                                            // 120
	                                                                                                                       // 121
	      // Mark that this position affects this generic and non-generic key                                              // 122
	      if (currentPosition) {                                                                                           // 123
	        self._affectedKeys[currentPosition] = affectedKey;                                                             // 124
	        self._genericAffectedKeys[currentPosition] = affectedKeyGeneric;                                               // 125
	                                                                                                                       // 126
	        // If we're within an array, mark this position so we can omit it from flat docs                               // 127
	        isWithinArray && self._positionsInsideArrays.push(currentPosition);                                            // 128
	      }                                                                                                                // 129
	    }                                                                                                                  // 130
	                                                                                                                       // 131
	    if (stop) {                                                                                                        // 132
	      return;                                                                                                          // 133
	    }                                                                                                                  // 134
	                                                                                                                       // 135
	    // Loop through arrays                                                                                             // 136
	    if (_.isArray(val) && !_.isEmpty(val)) {                                                                           // 137
	      if (currentPosition) {                                                                                           // 138
	        // Mark positions with arrays that should be ignored when we want endpoints only                               // 139
	        self._parentPositions.push(currentPosition);                                                                   // 140
	      }                                                                                                                // 141
	                                                                                                                       // 142
	      // Loop                                                                                                          // 143
	      _.each(val, function(v, i) {                                                                                     // 144
	        parseObj(v, (currentPosition ? currentPosition + "[" + i + "]" : i), affectedKey + '.' + i, operator, adjusted, true);
	      });                                                                                                              // 146
	    }                                                                                                                  // 147
	                                                                                                                       // 148
	    // Loop through object keys, only for basic objects,                                                               // 149
	    // but always for the passed-in object, even if it                                                                 // 150
	    // is a custom object.                                                                                             // 151
	    else if ((isBasicObject(val) && !affectedKeyIsBlackBox) || !currentPosition) {                                     // 152
	      if (currentPosition && !_.isEmpty(val)) {                                                                        // 153
	        // Mark positions with objects that should be ignored when we want endpoints only                              // 154
	        self._parentPositions.push(currentPosition);                                                                   // 155
	        // Mark positions with objects that should be left out of flat docs.                                           // 156
	        self._objectPositions.push(currentPosition);                                                                   // 157
	      }                                                                                                                // 158
	      // Loop                                                                                                          // 159
	      _.each(val, function(v, k) {                                                                                     // 160
	        if (v === void 0) {                                                                                            // 161
	          delete val[k];                                                                                               // 162
	        } else if (k !== "$slice") {                                                                                   // 163
	          parseObj(v, (currentPosition ? currentPosition + "[" + k + "]" : k), appendAffectedKey(affectedKey, k), operator, adjusted, isWithinArray);
	        }                                                                                                              // 165
	      });                                                                                                              // 166
	    }                                                                                                                  // 167
	                                                                                                                       // 168
	  }                                                                                                                    // 169
	  parseObj(self._obj);                                                                                                 // 170
	                                                                                                                       // 171
	  function reParseObj() {                                                                                              // 172
	    self._affectedKeys = {};                                                                                           // 173
	    self._genericAffectedKeys = {};                                                                                    // 174
	    self._parentPositions = [];                                                                                        // 175
	    self._positionsInsideArrays = [];                                                                                  // 176
	    self._objectPositions = [];                                                                                        // 177
	    parseObj(self._obj);                                                                                               // 178
	  }                                                                                                                    // 179
	                                                                                                                       // 180
	  /**                                                                                                                  // 181
	   * @method MongoObject.forEachNode                                                                                   // 182
	   * @param {Function} func                                                                                            // 183
	   * @param {Object} [options]                                                                                         // 184
	   * @param {Boolean} [options.endPointsOnly=true] - Only call function for endpoints and not for nodes that contain other nodes
	   * @returns {undefined}                                                                                              // 186
	   *                                                                                                                   // 187
	   * Runs a function for each endpoint node in the object tree, including all items in every array.                    // 188
	   * The function arguments are                                                                                        // 189
	   * (1) the value at this node                                                                                        // 190
	   * (2) a string representing the node position                                                                       // 191
	   * (3) the representation of what would be changed in mongo, using mongo dot notation                                // 192
	   * (4) the generic equivalent of argument 3, with "$" instead of numeric pieces                                      // 193
	   */                                                                                                                  // 194
	  self.forEachNode = function(func, options) {                                                                         // 195
	    if (typeof func !== "function") {                                                                                  // 196
	      throw new Error("filter requires a loop function");                                                              // 197
	    }                                                                                                                  // 198
	                                                                                                                       // 199
	    options = _.extend({                                                                                               // 200
	      endPointsOnly: true                                                                                              // 201
	    }, options);                                                                                                       // 202
	                                                                                                                       // 203
	    var updatedValues = {};                                                                                            // 204
	    _.each(self._affectedKeys, function(affectedKey, position) {                                                       // 205
	      if (options.endPointsOnly && _.contains(self._parentPositions, position)) {                                      // 206
	        return; //only endpoints                                                                                       // 207
	      }                                                                                                                // 208
	      func.call({                                                                                                      // 209
	        value: self.getValueForPosition(position),                                                                     // 210
	        operator: extractOp(position),                                                                                 // 211
	        position: position,                                                                                            // 212
	        key: affectedKey,                                                                                              // 213
	        genericKey: self._genericAffectedKeys[position],                                                               // 214
	        updateValue: function(newVal) {                                                                                // 215
	          updatedValues[position] = newVal;                                                                            // 216
	        },                                                                                                             // 217
	        remove: function() {                                                                                           // 218
	          updatedValues[position] = void 0;                                                                            // 219
	        }                                                                                                              // 220
	      });                                                                                                              // 221
	    });                                                                                                                // 222
	                                                                                                                       // 223
	    // Actually update/remove values as instructed                                                                     // 224
	    _.each(updatedValues, function(newVal, position) {                                                                 // 225
	      self.setValueForPosition(position, newVal);                                                                      // 226
	    });                                                                                                                // 227
	                                                                                                                       // 228
	  };                                                                                                                   // 229
	                                                                                                                       // 230
	  self.getValueForPosition = function(position) {                                                                      // 231
	    var subkey, subkeys = position.split("["), current = self._obj;                                                    // 232
	    for (var i = 0, ln = subkeys.length; i < ln; i++) {                                                                // 233
	      subkey = subkeys[i];                                                                                             // 234
	      // If the subkey ends in "]", remove the ending                                                                  // 235
	      if (subkey.slice(-1) === "]") {                                                                                  // 236
	        subkey = subkey.slice(0, -1);                                                                                  // 237
	      }                                                                                                                // 238
	      current = current[subkey];                                                                                       // 239
	      if (!_.isArray(current) && !isBasicObject(current) && i < ln - 1) {                                              // 240
	        return;                                                                                                        // 241
	      }                                                                                                                // 242
	    }                                                                                                                  // 243
	    return current;                                                                                                    // 244
	  };                                                                                                                   // 245
	                                                                                                                       // 246
	  /**                                                                                                                  // 247
	   * @method MongoObject.prototype.setValueForPosition                                                                 // 248
	   * @param {String} position                                                                                          // 249
	   * @param {Any} value                                                                                                // 250
	   * @returns {undefined}                                                                                              // 251
	   */                                                                                                                  // 252
	  self.setValueForPosition = function(position, value) {                                                               // 253
	    var nextPiece, subkey, subkeys = position.split("["), current = self._obj;                                         // 254
	                                                                                                                       // 255
	    for (var i = 0, ln = subkeys.length; i < ln; i++) {                                                                // 256
	      subkey = subkeys[i];                                                                                             // 257
	      // If the subkey ends in "]", remove the ending                                                                  // 258
	      if (subkey.slice(-1) === "]") {                                                                                  // 259
	        subkey = subkey.slice(0, -1);                                                                                  // 260
	      }                                                                                                                // 261
	      // If we've reached the key in the object tree that needs setting or                                             // 262
	      // deleting, do it.                                                                                              // 263
	      if (i === ln - 1) {                                                                                              // 264
	        current[subkey] = value;                                                                                       // 265
	        //if value is undefined, delete the property                                                                   // 266
	        if (value === void 0) {                                                                                        // 267
	          delete current[subkey];                                                                                      // 268
	        }                                                                                                              // 269
	      }                                                                                                                // 270
	      // Otherwise attempt to keep moving deeper into the object.                                                      // 271
	      else {                                                                                                           // 272
	        // If we're setting (as opposed to deleting) a key and we hit a place                                          // 273
	        // in the ancestor chain where the keys are not yet created, create them.                                      // 274
	        if (current[subkey] === void 0 && value !== void 0) {                                                          // 275
	          //see if the next piece is a number                                                                          // 276
	          nextPiece = subkeys[i + 1];                                                                                  // 277
	          nextPiece = parseInt(nextPiece, 10);                                                                         // 278
	          current[subkey] = isNaN(nextPiece) ? {} : [];                                                                // 279
	        }                                                                                                              // 280
	                                                                                                                       // 281
	        // Move deeper into the object                                                                                 // 282
	        current = current[subkey];                                                                                     // 283
	                                                                                                                       // 284
	        // If we can go no further, then quit                                                                          // 285
	        if (!_.isArray(current) && !isBasicObject(current) && i < ln - 1) {                                            // 286
	          return;                                                                                                      // 287
	        }                                                                                                              // 288
	      }                                                                                                                // 289
	    }                                                                                                                  // 290
	                                                                                                                       // 291
	    reParseObj();                                                                                                      // 292
	  };                                                                                                                   // 293
	                                                                                                                       // 294
	  /**                                                                                                                  // 295
	   * @method MongoObject.prototype.removeValueForPosition                                                              // 296
	   * @param {String} position                                                                                          // 297
	   * @returns {undefined}                                                                                              // 298
	   */                                                                                                                  // 299
	  self.removeValueForPosition = function(position) {                                                                   // 300
	    self.setValueForPosition(position, void 0);                                                                        // 301
	  };                                                                                                                   // 302
	                                                                                                                       // 303
	  /**                                                                                                                  // 304
	   * @method MongoObject.prototype.getKeyForPosition                                                                   // 305
	   * @param {String} position                                                                                          // 306
	   * @returns {undefined}                                                                                              // 307
	   */                                                                                                                  // 308
	  self.getKeyForPosition = function(position) {                                                                        // 309
	    return self._affectedKeys[position];                                                                               // 310
	  };                                                                                                                   // 311
	                                                                                                                       // 312
	  /**                                                                                                                  // 313
	   * @method MongoObject.prototype.getGenericKeyForPosition                                                            // 314
	   * @param {String} position                                                                                          // 315
	   * @returns {undefined}                                                                                              // 316
	   */                                                                                                                  // 317
	  self.getGenericKeyForPosition = function(position) {                                                                 // 318
	    return self._genericAffectedKeys[position];                                                                        // 319
	  };                                                                                                                   // 320
	                                                                                                                       // 321
	  /**                                                                                                                  // 322
	   * @method MongoObject.getInfoForKey                                                                                 // 323
	   * @param {String} key - Non-generic key                                                                             // 324
	   * @returns {undefined|Object}                                                                                       // 325
	   *                                                                                                                   // 326
	   * Returns the value and operator of the requested non-generic key.                                                  // 327
	   * Example: {value: 1, operator: "$pull"}                                                                            // 328
	   */                                                                                                                  // 329
	  self.getInfoForKey = function(key) {                                                                                 // 330
	    // Get the info                                                                                                    // 331
	    var position = self.getPositionForKey(key);                                                                        // 332
	    if (position) {                                                                                                    // 333
	      return {                                                                                                         // 334
	        value: self.getValueForPosition(position),                                                                     // 335
	        operator: extractOp(position)                                                                                  // 336
	      };                                                                                                               // 337
	    }                                                                                                                  // 338
	                                                                                                                       // 339
	    // If we haven't returned yet, check to see if there is an array value                                             // 340
	    // corresponding to this key                                                                                       // 341
	    // We find the first item within the array, strip the last piece off the                                           // 342
	    // position string, and then return whatever is at that new position in                                            // 343
	    // the original object.                                                                                            // 344
	    var positions = self.getPositionsForGenericKey(key + ".$"), p, v;                                                  // 345
	    for (var i = 0, ln = positions.length; i < ln; i++) {                                                              // 346
	      p = positions[i];                                                                                                // 347
	      v = self.getValueForPosition(p) || self.getValueForPosition(p.slice(0, p.lastIndexOf("[")));                     // 348
	      if (v) {                                                                                                         // 349
	        return {                                                                                                       // 350
	          value: v,                                                                                                    // 351
	          operator: extractOp(p)                                                                                       // 352
	        };                                                                                                             // 353
	      }                                                                                                                // 354
	    }                                                                                                                  // 355
	  };                                                                                                                   // 356
	                                                                                                                       // 357
	  /**                                                                                                                  // 358
	   * @method MongoObject.getPositionForKey                                                                             // 359
	   * @param {String} key - Non-generic key                                                                             // 360
	   * @returns {undefined|String} Position string                                                                       // 361
	   *                                                                                                                   // 362
	   * Returns the position string for the place in the object that                                                      // 363
	   * affects the requested non-generic key.                                                                            // 364
	   * Example: 'foo[bar][0]'                                                                                            // 365
	   */                                                                                                                  // 366
	  self.getPositionForKey = function(key) {                                                                             // 367
	    // Get the info                                                                                                    // 368
	    for (var position in self._affectedKeys) {                                                                         // 369
	      if (self._affectedKeys.hasOwnProperty(position)) {                                                               // 370
	        if (self._affectedKeys[position] === key) {                                                                    // 371
	          // We return the first one we find. While it's                                                               // 372
	          // possible that multiple update operators could                                                             // 373
	          // affect the same non-generic key, we'll assume that's not the case.                                        // 374
	          return position;                                                                                             // 375
	        }                                                                                                              // 376
	      }                                                                                                                // 377
	    }                                                                                                                  // 378
	                                                                                                                       // 379
	    // If we haven't returned yet, we need to check for affected keys                                                  // 380
	  };                                                                                                                   // 381
	                                                                                                                       // 382
	  /**                                                                                                                  // 383
	   * @method MongoObject.getPositionsForGenericKey                                                                     // 384
	   * @param {String} key - Generic key                                                                                 // 385
	   * @returns {String[]} Array of position strings                                                                     // 386
	   *                                                                                                                   // 387
	   * Returns an array of position strings for the places in the object that                                            // 388
	   * affect the requested generic key.                                                                                 // 389
	   * Example: ['foo[bar][0]']                                                                                          // 390
	   */                                                                                                                  // 391
	  self.getPositionsForGenericKey = function(key) {                                                                     // 392
	    // Get the info                                                                                                    // 393
	    var list = [];                                                                                                     // 394
	    for (var position in self._genericAffectedKeys) {                                                                  // 395
	      if (self._genericAffectedKeys.hasOwnProperty(position)) {                                                        // 396
	        if (self._genericAffectedKeys[position] === key) {                                                             // 397
	          list.push(position);                                                                                         // 398
	        }                                                                                                              // 399
	      }                                                                                                                // 400
	    }                                                                                                                  // 401
	                                                                                                                       // 402
	    return list;                                                                                                       // 403
	  };                                                                                                                   // 404
	                                                                                                                       // 405
	  /**                                                                                                                  // 406
	   * @deprecated Use getInfoForKey                                                                                     // 407
	   * @method MongoObject.getValueForKey                                                                                // 408
	   * @param {String} key - Non-generic key                                                                             // 409
	   * @returns {undefined|Any}                                                                                          // 410
	   *                                                                                                                   // 411
	   * Returns the value of the requested non-generic key                                                                // 412
	   */                                                                                                                  // 413
	  self.getValueForKey = function(key) {                                                                                // 414
	    var position = self.getPositionForKey(key);                                                                        // 415
	    if (position) {                                                                                                    // 416
	      return self.getValueForPosition(position);                                                                       // 417
	    }                                                                                                                  // 418
	  };                                                                                                                   // 419
	                                                                                                                       // 420
	  /**                                                                                                                  // 421
	   * @method MongoObject.prototype.addKey                                                                              // 422
	   * @param {String} key - Key to set                                                                                  // 423
	   * @param {Any} val - Value to give this key                                                                         // 424
	   * @param {String} op - Operator under which to set it, or `null` for a non-modifier object                          // 425
	   * @returns {undefined}                                                                                              // 426
	   *                                                                                                                   // 427
	   * Adds `key` with value `val` under operator `op` to the source object.                                             // 428
	   */                                                                                                                  // 429
	  self.addKey = function(key, val, op) {                                                                               // 430
	    var position = op ? op + "[" + key + "]" : MongoObject._keyToPosition(key);                                        // 431
	    self.setValueForPosition(position, val);                                                                           // 432
	  };                                                                                                                   // 433
	                                                                                                                       // 434
	  /**                                                                                                                  // 435
	   * @method MongoObject.prototype.removeGenericKeys                                                                   // 436
	   * @param {String[]} keys                                                                                            // 437
	   * @returns {undefined}                                                                                              // 438
	   *                                                                                                                   // 439
	   * Removes anything that affects any of the generic keys in the list                                                 // 440
	   */                                                                                                                  // 441
	  self.removeGenericKeys = function(keys) {                                                                            // 442
	    for (var position in self._genericAffectedKeys) {                                                                  // 443
	      if (self._genericAffectedKeys.hasOwnProperty(position)) {                                                        // 444
	        if (_.contains(keys, self._genericAffectedKeys[position])) {                                                   // 445
	          self.removeValueForPosition(position);                                                                       // 446
	        }                                                                                                              // 447
	      }                                                                                                                // 448
	    }                                                                                                                  // 449
	  };                                                                                                                   // 450
	                                                                                                                       // 451
	  /**                                                                                                                  // 452
	   * @method MongoObject.removeGenericKey                                                                              // 453
	   * @param {String} key                                                                                               // 454
	   * @returns {undefined}                                                                                              // 455
	   *                                                                                                                   // 456
	   * Removes anything that affects the requested generic key                                                           // 457
	   */                                                                                                                  // 458
	  self.removeGenericKey = function(key) {                                                                              // 459
	    for (var position in self._genericAffectedKeys) {                                                                  // 460
	      if (self._genericAffectedKeys.hasOwnProperty(position)) {                                                        // 461
	        if (self._genericAffectedKeys[position] === key) {                                                             // 462
	          self.removeValueForPosition(position);                                                                       // 463
	        }                                                                                                              // 464
	      }                                                                                                                // 465
	    }                                                                                                                  // 466
	  };                                                                                                                   // 467
	                                                                                                                       // 468
	  /**                                                                                                                  // 469
	   * @method MongoObject.removeKey                                                                                     // 470
	   * @param {String} key                                                                                               // 471
	   * @returns {undefined}                                                                                              // 472
	   *                                                                                                                   // 473
	   * Removes anything that affects the requested non-generic key                                                       // 474
	   */                                                                                                                  // 475
	  self.removeKey = function(key) {                                                                                     // 476
	    // We don't use getPositionForKey here because we want to be sure to                                               // 477
	    // remove for all positions if there are multiple.                                                                 // 478
	    for (var position in self._affectedKeys) {                                                                         // 479
	      if (self._affectedKeys.hasOwnProperty(position)) {                                                               // 480
	        if (self._affectedKeys[position] === key) {                                                                    // 481
	          self.removeValueForPosition(position);                                                                       // 482
	        }                                                                                                              // 483
	      }                                                                                                                // 484
	    }                                                                                                                  // 485
	  };                                                                                                                   // 486
	                                                                                                                       // 487
	  /**                                                                                                                  // 488
	   * @method MongoObject.removeKeys                                                                                    // 489
	   * @param {String[]} keys                                                                                            // 490
	   * @returns {undefined}                                                                                              // 491
	   *                                                                                                                   // 492
	   * Removes anything that affects any of the non-generic keys in the list                                             // 493
	   */                                                                                                                  // 494
	  self.removeKeys = function(keys) {                                                                                   // 495
	    for (var i = 0, ln = keys.length; i < ln; i++) {                                                                   // 496
	      self.removeKey(keys[i]);                                                                                         // 497
	    }                                                                                                                  // 498
	  };                                                                                                                   // 499
	                                                                                                                       // 500
	  /**                                                                                                                  // 501
	   * @method MongoObject.filterGenericKeys                                                                             // 502
	   * @param {Function} test - Test function                                                                            // 503
	   * @returns {undefined}                                                                                              // 504
	   *                                                                                                                   // 505
	   * Passes all affected keys to a test function, which                                                                // 506
	   * should return false to remove whatever is affecting that key                                                      // 507
	   */                                                                                                                  // 508
	  self.filterGenericKeys = function(test) {                                                                            // 509
	    var gk, checkedKeys = [], keysToRemove = [];                                                                       // 510
	    for (var position in self._genericAffectedKeys) {                                                                  // 511
	      if (self._genericAffectedKeys.hasOwnProperty(position)) {                                                        // 512
	        gk = self._genericAffectedKeys[position];                                                                      // 513
	        if (!_.contains(checkedKeys, gk)) {                                                                            // 514
	          checkedKeys.push(gk);                                                                                        // 515
	          if (gk && !test(gk)) {                                                                                       // 516
	            keysToRemove.push(gk);                                                                                     // 517
	          }                                                                                                            // 518
	        }                                                                                                              // 519
	      }                                                                                                                // 520
	    }                                                                                                                  // 521
	                                                                                                                       // 522
	    _.each(keysToRemove, function(key) {                                                                               // 523
	      self.removeGenericKey(key);                                                                                      // 524
	    });                                                                                                                // 525
	  };                                                                                                                   // 526
	                                                                                                                       // 527
	  /**                                                                                                                  // 528
	   * @method MongoObject.setValueForKey                                                                                // 529
	   * @param {String} key                                                                                               // 530
	   * @param {Any} val                                                                                                  // 531
	   * @returns {undefined}                                                                                              // 532
	   *                                                                                                                   // 533
	   * Sets the value for every place in the object that affects                                                         // 534
	   * the requested non-generic key                                                                                     // 535
	   */                                                                                                                  // 536
	  self.setValueForKey = function(key, val) {                                                                           // 537
	    // We don't use getPositionForKey here because we want to be sure to                                               // 538
	    // set the value for all positions if there are multiple.                                                          // 539
	    for (var position in self._affectedKeys) {                                                                         // 540
	      if (self._affectedKeys.hasOwnProperty(position)) {                                                               // 541
	        if (self._affectedKeys[position] === key) {                                                                    // 542
	          self.setValueForPosition(position, val);                                                                     // 543
	        }                                                                                                              // 544
	      }                                                                                                                // 545
	    }                                                                                                                  // 546
	  };                                                                                                                   // 547
	                                                                                                                       // 548
	  /**                                                                                                                  // 549
	   * @method MongoObject.setValueForGenericKey                                                                         // 550
	   * @param {String} key                                                                                               // 551
	   * @param {Any} val                                                                                                  // 552
	   * @returns {undefined}                                                                                              // 553
	   *                                                                                                                   // 554
	   * Sets the value for every place in the object that affects                                                         // 555
	   * the requested generic key                                                                                         // 556
	   */                                                                                                                  // 557
	  self.setValueForGenericKey = function(key, val) {                                                                    // 558
	    // We don't use getPositionForKey here because we want to be sure to                                               // 559
	    // set the value for all positions if there are multiple.                                                          // 560
	    for (var position in self._genericAffectedKeys) {                                                                  // 561
	      if (self._genericAffectedKeys.hasOwnProperty(position)) {                                                        // 562
	        if (self._genericAffectedKeys[position] === key) {                                                             // 563
	          self.setValueForPosition(position, val);                                                                     // 564
	        }                                                                                                              // 565
	      }                                                                                                                // 566
	    }                                                                                                                  // 567
	  };                                                                                                                   // 568
	                                                                                                                       // 569
	  /**                                                                                                                  // 570
	   * @method MongoObject.getObject                                                                                     // 571
	   * @returns {Object}                                                                                                 // 572
	   *                                                                                                                   // 573
	   * Get the source object, potentially modified by other method calls on this                                         // 574
	   * MongoObject instance.                                                                                             // 575
	   */                                                                                                                  // 576
	  self.getObject = function() {                                                                                        // 577
	    return self._obj;                                                                                                  // 578
	  };                                                                                                                   // 579
	                                                                                                                       // 580
	  /**                                                                                                                  // 581
	   * @method MongoObject.getFlatObject                                                                                 // 582
	   * @returns {Object}                                                                                                 // 583
	   *                                                                                                                   // 584
	   * Gets a flat object based on the MongoObject instance.                                                             // 585
	   * In a flat object, the key is the name of the non-generic affectedKey,                                             // 586
	   * with mongo dot notation if necessary, and the value is the value for                                              // 587
	   * that key.                                                                                                         // 588
	   *                                                                                                                   // 589
	   * With `keepArrays: true`, we don't flatten within arrays. Currently                                                // 590
	   * MongoDB does not see a key such as `a.0.b` and automatically assume                                               // 591
	   * an array. Instead it would create an object with key "0" if there                                                 // 592
	   * wasn't already an array saved as the value of `a`, which is rarely                                                // 593
	   * if ever what we actually want. To avoid this confusion, we                                                        // 594
	   * set entire arrays.                                                                                                // 595
	   */                                                                                                                  // 596
	  self.getFlatObject = function(options) {                                                                             // 597
	    options = options || {};                                                                                           // 598
	    var newObj = {};                                                                                                   // 599
	    _.each(self._affectedKeys, function(affectedKey, position) {                                                       // 600
	      if (typeof affectedKey === "string" &&                                                                           // 601
	        (options.keepArrays === true && !_.contains(self._positionsInsideArrays, position) && !_.contains(self._objectPositions, position)) ||
	        (!options.keepArrays && !_.contains(self._parentPositions, position))                                          // 603
	        ) {                                                                                                            // 604
	        newObj[affectedKey] = self.getValueForPosition(position);                                                      // 605
	      }                                                                                                                // 606
	    });                                                                                                                // 607
	    return newObj;                                                                                                     // 608
	  };                                                                                                                   // 609
	                                                                                                                       // 610
	  /**                                                                                                                  // 611
	   * @method MongoObject.affectsKey                                                                                    // 612
	   * @param {String} key                                                                                               // 613
	   * @returns {Object}                                                                                                 // 614
	   *                                                                                                                   // 615
	   * Returns true if the non-generic key is affected by this object                                                    // 616
	   */                                                                                                                  // 617
	  self.affectsKey = function(key) {                                                                                    // 618
	    return !!self.getPositionForKey(key);                                                                              // 619
	  };                                                                                                                   // 620
	                                                                                                                       // 621
	  /**                                                                                                                  // 622
	   * @method MongoObject.affectsGenericKey                                                                             // 623
	   * @param {String} key                                                                                               // 624
	   * @returns {Object}                                                                                                 // 625
	   *                                                                                                                   // 626
	   * Returns true if the generic key is affected by this object                                                        // 627
	   */                                                                                                                  // 628
	  self.affectsGenericKey = function(key) {                                                                             // 629
	    for (var position in self._genericAffectedKeys) {                                                                  // 630
	      if (self._genericAffectedKeys.hasOwnProperty(position)) {                                                        // 631
	        if (self._genericAffectedKeys[position] === key) {                                                             // 632
	          return true;                                                                                                 // 633
	        }                                                                                                              // 634
	      }                                                                                                                // 635
	    }                                                                                                                  // 636
	    return false;                                                                                                      // 637
	  };                                                                                                                   // 638
	                                                                                                                       // 639
	  /**                                                                                                                  // 640
	   * @method MongoObject.affectsGenericKeyImplicit                                                                     // 641
	   * @param {String} key                                                                                               // 642
	   * @returns {Object}                                                                                                 // 643
	   *                                                                                                                   // 644
	   * Like affectsGenericKey, but will return true if a child key is affected                                           // 645
	   */                                                                                                                  // 646
	  self.affectsGenericKeyImplicit = function(key) {                                                                     // 647
	    for (var position in self._genericAffectedKeys) {                                                                  // 648
	      if (self._genericAffectedKeys.hasOwnProperty(position)) {                                                        // 649
	        var affectedKey = self._genericAffectedKeys[position];                                                         // 650
	                                                                                                                       // 651
	        // If the affected key is the test key                                                                         // 652
	        if (affectedKey === key) {                                                                                     // 653
	          return true;                                                                                                 // 654
	        }                                                                                                              // 655
	                                                                                                                       // 656
	        // If the affected key implies the test key because the affected key                                           // 657
	        // starts with the test key followed by a period                                                               // 658
	        if (affectedKey.substring(0, key.length + 1) === key + ".") {                                                  // 659
	          return true;                                                                                                 // 660
	        }                                                                                                              // 661
	                                                                                                                       // 662
	        // If the affected key implies the test key because the affected key                                           // 663
	        // starts with the test key and the test key ends with ".$"                                                    // 664
	        var lastTwo = key.slice(-2);                                                                                   // 665
	        if (lastTwo === ".$" && key.slice(0, -2) === affectedKey) {                                                    // 666
	          return true;                                                                                                 // 667
	        }                                                                                                              // 668
	      }                                                                                                                // 669
	    }                                                                                                                  // 670
	    return false;                                                                                                      // 671
	  };                                                                                                                   // 672
	};                                                                                                                     // 673
	                                                                                                                       // 674
	/** Takes a string representation of an object key and its value                                                       // 675
	 *  and updates "obj" to contain that key with that value.                                                             // 676
	 *                                                                                                                     // 677
	 *  Example keys and results if val is 1:                                                                              // 678
	 *    "a" -> {a: 1}                                                                                                    // 679
	 *    "a[b]" -> {a: {b: 1}}                                                                                            // 680
	 *    "a[b][0]" -> {a: {b: [1]}}                                                                                       // 681
	 *    "a[b.0.c]" -> {a: {'b.0.c': 1}}                                                                                  // 682
	 */                                                                                                                    // 683
	                                                                                                                       // 684
	/** Takes a string representation of an object key and its value                                                       // 685
	 *  and updates "obj" to contain that key with that value.                                                             // 686
	 *                                                                                                                     // 687
	 *  Example keys and results if val is 1:                                                                              // 688
	 *    "a" -> {a: 1}                                                                                                    // 689
	 *    "a[b]" -> {a: {b: 1}}                                                                                            // 690
	 *    "a[b][0]" -> {a: {b: [1]}}                                                                                       // 691
	 *    "a[b.0.c]" -> {a: {'b.0.c': 1}}                                                                                  // 692
	 *                                                                                                                     // 693
	 * @param {any} val                                                                                                    // 694
	 * @param {String} key                                                                                                 // 695
	 * @param {Object} obj                                                                                                 // 696
	 * @returns {undefined}                                                                                                // 697
	 */                                                                                                                    // 698
	MongoObject.expandKey = function(val, key, obj) {                                                                      // 699
	  var nextPiece, subkey, subkeys = key.split("["), current = obj;                                                      // 700
	  for (var i = 0, ln = subkeys.length; i < ln; i++) {                                                                  // 701
	    subkey = subkeys[i];                                                                                               // 702
	    if (subkey.slice(-1) === "]") {                                                                                    // 703
	      subkey = subkey.slice(0, -1);                                                                                    // 704
	    }                                                                                                                  // 705
	    if (i === ln - 1) {                                                                                                // 706
	      //last iteration; time to set the value; always overwrite                                                        // 707
	      current[subkey] = val;                                                                                           // 708
	      //if val is undefined, delete the property                                                                       // 709
	      if (val === void 0) {                                                                                            // 710
	        delete current[subkey];                                                                                        // 711
	      }                                                                                                                // 712
	    } else {                                                                                                           // 713
	      //see if the next piece is a number                                                                              // 714
	      nextPiece = subkeys[i + 1];                                                                                      // 715
	      nextPiece = parseInt(nextPiece, 10);                                                                             // 716
	      if (!current[subkey]) {                                                                                          // 717
	        current[subkey] = isNaN(nextPiece) ? {} : [];                                                                  // 718
	      }                                                                                                                // 719
	    }                                                                                                                  // 720
	    current = current[subkey];                                                                                         // 721
	  }                                                                                                                    // 722
	};                                                                                                                     // 723
	                                                                                                                       // 724
	MongoObject._keyToPosition = function keyToPosition(key, wrapAll) {                                                    // 725
	  var position = '';                                                                                                   // 726
	  _.each(key.split("."), function (piece, i) {                                                                         // 727
	    if (i === 0 && !wrapAll) {                                                                                         // 728
	      position += piece;                                                                                               // 729
	    } else {                                                                                                           // 730
	      position += "[" + piece + "]";                                                                                   // 731
	    }                                                                                                                  // 732
	  });                                                                                                                  // 733
	  return position;                                                                                                     // 734
	};                                                                                                                     // 735
	                                                                                                                       // 736
	/**                                                                                                                    // 737
	 * @method MongoObject._positionToKey                                                                                  // 738
	 * @param {String} position                                                                                            // 739
	 * @returns {String} The key that this position in an object would affect.                                             // 740
	 *                                                                                                                     // 741
	 * This is different from MongoObject.prototype.getKeyForPosition in that                                              // 742
	 * this method does not depend on the requested position actually being                                                // 743
	 * present in any particular MongoObject.                                                                              // 744
	 */                                                                                                                    // 745
	MongoObject._positionToKey = function positionToKey(position) {                                                        // 746
	  //XXX Probably a better way to do this, but this is                                                                  // 747
	  //foolproof for now.                                                                                                 // 748
	  var mDoc = new MongoObject({});                                                                                      // 749
	  mDoc.setValueForPosition(position, 1); //value doesn't matter                                                        // 750
	  var key = mDoc.getKeyForPosition(position);                                                                          // 751
	  mDoc = null;                                                                                                         // 752
	  return key;                                                                                                          // 753
	};                                                                                                                     // 754
	                                                                                                                       // 755
	                                                                                                                       // 756
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// packages/aldeed_simple-schema/simple-schema-utility.js                                                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	/* global Utility:true */                                                                                              // 1
	                                                                                                                       // 2
	Utility = {                                                                                                            // 3
	  appendAffectedKey: function appendAffectedKey(affectedKey, key) {                                                    // 4
	    if (key === "$each") {                                                                                             // 5
	      return affectedKey;                                                                                              // 6
	    } else {                                                                                                           // 7
	      return (affectedKey ? affectedKey + "." + key : key);                                                            // 8
	    }                                                                                                                  // 9
	  },                                                                                                                   // 10
	  shouldCheck: function shouldCheck(key) {                                                                             // 11
	    if (key === "$pushAll") {                                                                                          // 12
	      throw new Error("$pushAll is not supported; use $push + $each");                                                 // 13
	    }                                                                                                                  // 14
	    return !_.contains(["$pull", "$pullAll", "$pop", "$slice"], key);                                                  // 15
	  },                                                                                                                   // 16
	  errorObject: function errorObject(errorType, keyName, keyValue) {                                                    // 17
	    return {name: keyName, type: errorType, value: keyValue};                                                          // 18
	  },                                                                                                                   // 19
	  // Tests whether it's an Object as opposed to something that inherits from Object                                    // 20
	  isBasicObject: function isBasicObject(obj) {                                                                         // 21
	    return _.isObject(obj) && Object.getPrototypeOf(obj) === Object.prototype;                                         // 22
	  },                                                                                                                   // 23
	  // The latest Safari returns false for Uint8Array, etc. instanceof Function                                          // 24
	  // unlike other browsers.                                                                                            // 25
	  safariBugFix: function safariBugFix(type) {                                                                          // 26
	    return (typeof Uint8Array !== "undefined" && type === Uint8Array) ||                                               // 27
	      (typeof Uint16Array !== "undefined" && type === Uint16Array) ||                                                  // 28
	      (typeof Uint32Array !== "undefined" && type === Uint32Array) ||                                                  // 29
	      (typeof Uint8ClampedArray !== "undefined" && type === Uint8ClampedArray);                                        // 30
	  },                                                                                                                   // 31
	  isNotNullOrUndefined: function isNotNullOrUndefined(val) {                                                           // 32
	    return val !== void 0 && val !== null;                                                                             // 33
	  },                                                                                                                   // 34
	  // Extracts operator piece, if present, from position string                                                         // 35
	  extractOp: function extractOp(position) {                                                                            // 36
	    var firstPositionPiece = position.slice(0, position.indexOf("["));                                                 // 37
	    return (firstPositionPiece.substring(0, 1) === "$") ? firstPositionPiece : null;                                   // 38
	  },                                                                                                                   // 39
	  deleteIfPresent: function deleteIfPresent(obj, key) {                                                                // 40
	    if (key in obj) {                                                                                                  // 41
	      delete obj[key];                                                                                                 // 42
	    }                                                                                                                  // 43
	  },                                                                                                                   // 44
	  looksLikeModifier: function looksLikeModifier(obj) {                                                                 // 45
	    for (var key in obj) {                                                                                             // 46
	      if (obj.hasOwnProperty(key) && key.substring(0, 1) === "$") {                                                    // 47
	        return true;                                                                                                   // 48
	      }                                                                                                                // 49
	    }                                                                                                                  // 50
	    return false;                                                                                                      // 51
	  },                                                                                                                   // 52
	  dateToDateString: function dateToDateString(date) {                                                                  // 53
	    var m = (date.getUTCMonth() + 1);                                                                                  // 54
	    if (m < 10) {                                                                                                      // 55
	      m = "0" + m;                                                                                                     // 56
	    }                                                                                                                  // 57
	    var d = date.getUTCDate();                                                                                         // 58
	    if (d < 10) {                                                                                                      // 59
	      d = "0" + d;                                                                                                     // 60
	    }                                                                                                                  // 61
	    return date.getUTCFullYear() + '-' + m + '-' + d;                                                                  // 62
	  }                                                                                                                    // 63
	};                                                                                                                     // 64
	                                                                                                                       // 65
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// packages/aldeed_simple-schema/simple-schema.js                                                                      //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	/* global SimpleSchema:true */                                                                                         // 1
	/* global SimpleSchemaValidationContext */                                                                             // 2
	/* global MongoObject */                                                                                               // 3
	/* global Utility */                                                                                                   // 4
	                                                                                                                       // 5
	var schemaDefinition = {                                                                                               // 6
	  type: Match.Any,                                                                                                     // 7
	  label: Match.Optional(Match.OneOf(String, Function)),                                                                // 8
	  optional: Match.Optional(Match.OneOf(Boolean, Function)),                                                            // 9
	  min: Match.Optional(Match.OneOf(Number, Date, Function)),                                                            // 10
	  max: Match.Optional(Match.OneOf(Number, Date, Function)),                                                            // 11
	  minCount: Match.Optional(Match.OneOf(Number, Function)),                                                             // 12
	  maxCount: Match.Optional(Match.OneOf(Number, Function)),                                                             // 13
	  allowedValues: Match.Optional(Match.OneOf([Match.Any], Function)),                                                   // 14
	  decimal: Match.Optional(Boolean),                                                                                    // 15
	  exclusiveMax: Match.Optional(Boolean),                                                                               // 16
	  exclusiveMin: Match.Optional(Boolean),                                                                               // 17
	  regEx: Match.Optional(Match.OneOf(RegExp, [RegExp])),                                                                // 18
	  custom: Match.Optional(Function),                                                                                    // 19
	  blackbox: Match.Optional(Boolean),                                                                                   // 20
	  autoValue: Match.Optional(Function),                                                                                 // 21
	  defaultValue: Match.Optional(Match.Any),                                                                             // 22
	  trim: Match.Optional(Boolean)                                                                                        // 23
	};                                                                                                                     // 24
	                                                                                                                       // 25
	/*                                                                                                                     // 26
	 * PRIVATE FUNCTIONS                                                                                                   // 27
	 */                                                                                                                    // 28
	                                                                                                                       // 29
	//called by clean()                                                                                                    // 30
	var typeconvert = function(value, type) {                                                                              // 31
	  var parsedDate;                                                                                                      // 32
	                                                                                                                       // 33
	  if (_.isArray(value) || (_.isObject(value) && !(value instanceof Date))) {                                           // 34
	    return value; //can't and shouldn't convert arrays or objects                                                      // 35
	  }                                                                                                                    // 36
	  if (type === String) {                                                                                               // 37
	    if (typeof value !== "undefined" && value !== null && typeof value !== "string") {                                 // 38
	      return value.toString();                                                                                         // 39
	    }                                                                                                                  // 40
	    return value;                                                                                                      // 41
	  }                                                                                                                    // 42
	  if (type === Number) {                                                                                               // 43
	    if (typeof value === "string" && !_.isEmpty(value)) {                                                              // 44
	      //try to convert numeric strings to numbers                                                                      // 45
	      var numberVal = Number(value);                                                                                   // 46
	      if (!isNaN(numberVal)) {                                                                                         // 47
	        return numberVal;                                                                                              // 48
	      } else {                                                                                                         // 49
	        return value; //leave string; will fail validation                                                             // 50
	      }                                                                                                                // 51
	    }                                                                                                                  // 52
	    return value;                                                                                                      // 53
	  }                                                                                                                    // 54
	  //                                                                                                                   // 55
	  // If target type is a Date we can safely convert from either a                                                      // 56
	  // number (Integer value representing the number of milliseconds                                                     // 57
	  // since 1 January 1970 00:00:00 UTC) or a string that can be parsed                                                 // 58
	  // by Date.                                                                                                          // 59
	  //                                                                                                                   // 60
	  if (type === Date) {                                                                                                 // 61
	    if (typeof value === "string") {                                                                                   // 62
	      parsedDate = Date.parse(value);                                                                                  // 63
	      if (isNaN(parsedDate) === false) {                                                                               // 64
	        return new Date(parsedDate);                                                                                   // 65
	      }                                                                                                                // 66
	    }                                                                                                                  // 67
	    if (typeof value === "number") {                                                                                   // 68
	      return new Date(value);                                                                                          // 69
	    }                                                                                                                  // 70
	  }                                                                                                                    // 71
	  return value;                                                                                                        // 72
	};                                                                                                                     // 73
	                                                                                                                       // 74
	var expandSchema = function(schema) {                                                                                  // 75
	  // Flatten schema by inserting nested definitions                                                                    // 76
	  _.each(schema, function(val, key) {                                                                                  // 77
	    var dot, type;                                                                                                     // 78
	    if (!val) {                                                                                                        // 79
	      return;                                                                                                          // 80
	    }                                                                                                                  // 81
	    if (Match.test(val.type, SimpleSchema)) {                                                                          // 82
	      dot = '.';                                                                                                       // 83
	      type = val.type;                                                                                                 // 84
	      val.type = Object;                                                                                               // 85
	    } else if (Match.test(val.type, [SimpleSchema])) {                                                                 // 86
	      dot = '.$.';                                                                                                     // 87
	      type = val.type[0];                                                                                              // 88
	      val.type = [Object];                                                                                             // 89
	    } else {                                                                                                           // 90
	      return;                                                                                                          // 91
	    }                                                                                                                  // 92
	    //add child schema definitions to parent schema                                                                    // 93
	    _.each(type._schema, function(subVal, subKey) {                                                                    // 94
	      var newKey = key + dot + subKey;                                                                                 // 95
	      if (!(newKey in schema)) {                                                                                       // 96
	        schema[newKey] = subVal;                                                                                       // 97
	      }                                                                                                                // 98
	    });                                                                                                                // 99
	  });                                                                                                                  // 100
	  return schema;                                                                                                       // 101
	};                                                                                                                     // 102
	                                                                                                                       // 103
	var adjustArrayFields = function(schema) {                                                                             // 104
	  _.each(schema, function(def, existingKey) {                                                                          // 105
	    if (_.isArray(def.type) || def.type === Array) {                                                                   // 106
	      // Copy some options to array-item definition                                                                    // 107
	      var itemKey = existingKey + ".$";                                                                                // 108
	      if (!(itemKey in schema)) {                                                                                      // 109
	        schema[itemKey] = {};                                                                                          // 110
	      }                                                                                                                // 111
	      if (_.isArray(def.type)) {                                                                                       // 112
	        schema[itemKey].type = def.type[0];                                                                            // 113
	      }                                                                                                                // 114
	      if (def.label) {                                                                                                 // 115
	        schema[itemKey].label = def.label;                                                                             // 116
	      }                                                                                                                // 117
	      schema[itemKey].optional = true;                                                                                 // 118
	      if (typeof def.min !== "undefined") {                                                                            // 119
	        schema[itemKey].min = def.min;                                                                                 // 120
	      }                                                                                                                // 121
	      if (typeof def.max !== "undefined") {                                                                            // 122
	        schema[itemKey].max = def.max;                                                                                 // 123
	      }                                                                                                                // 124
	      if (typeof def.allowedValues !== "undefined") {                                                                  // 125
	        schema[itemKey].allowedValues = def.allowedValues;                                                             // 126
	      }                                                                                                                // 127
	      if (typeof def.decimal !== "undefined") {                                                                        // 128
	        schema[itemKey].decimal = def.decimal;                                                                         // 129
	      }                                                                                                                // 130
	      if (typeof def.exclusiveMax !== "undefined") {                                                                   // 131
	        schema[itemKey].exclusiveMax = def.exclusiveMax;                                                               // 132
	      }                                                                                                                // 133
	      if (typeof def.exclusiveMin !== "undefined") {                                                                   // 134
	        schema[itemKey].exclusiveMin = def.exclusiveMin;                                                               // 135
	      }                                                                                                                // 136
	      if (typeof def.regEx !== "undefined") {                                                                          // 137
	        schema[itemKey].regEx = def.regEx;                                                                             // 138
	      }                                                                                                                // 139
	      if (typeof def.blackbox !== "undefined") {                                                                       // 140
	        schema[itemKey].blackbox = def.blackbox;                                                                       // 141
	      }                                                                                                                // 142
	      // Remove copied options and adjust type                                                                         // 143
	      def.type = Array;                                                                                                // 144
	      _.each(['min', 'max', 'allowedValues', 'decimal', 'exclusiveMax', 'exclusiveMin', 'regEx', 'blackbox'], function(k) {
	        Utility.deleteIfPresent(def, k);                                                                               // 146
	      });                                                                                                              // 147
	    }                                                                                                                  // 148
	  });                                                                                                                  // 149
	};                                                                                                                     // 150
	                                                                                                                       // 151
	/**                                                                                                                    // 152
	 * Adds implied keys.                                                                                                  // 153
	 * * If schema contains a key like "foo.$.bar" but not "foo", adds "foo".                                              // 154
	 * * If schema contains a key like "foo" with an array type, adds "foo.$".                                             // 155
	 * @param {Object} schema                                                                                              // 156
	 * @returns {Object} modified schema                                                                                   // 157
	 */                                                                                                                    // 158
	var addImplicitKeys = function(schema) {                                                                               // 159
	  var arrayKeysToAdd = [], objectKeysToAdd = [], newKey, key, i, ln;                                                   // 160
	                                                                                                                       // 161
	  // Pass 1 (objects)                                                                                                  // 162
	  _.each(schema, function(def, existingKey) {                                                                          // 163
	    var pos = existingKey.indexOf(".");                                                                                // 164
	    while (pos !== -1) {                                                                                               // 165
	      newKey = existingKey.substring(0, pos);                                                                          // 166
	                                                                                                                       // 167
	      // It's an array item; nothing to add                                                                            // 168
	      if (newKey.substring(newKey.length - 2) === ".$") {                                                              // 169
	        pos = -1;                                                                                                      // 170
	      }                                                                                                                // 171
	      // It's an array of objects; add it with type [Object] if not already in the schema                              // 172
	      else if (existingKey.substring(pos, pos + 3) === ".$.") {                                                        // 173
	        arrayKeysToAdd.push(newKey); // add later, since we are iterating over schema right now                        // 174
	        pos = existingKey.indexOf(".", pos + 3); // skip over next dot, find the one after                             // 175
	      }                                                                                                                // 176
	      // It's an object; add it with type Object if not already in the schema                                          // 177
	      else {                                                                                                           // 178
	        objectKeysToAdd.push(newKey); // add later, since we are iterating over schema right now                       // 179
	        pos = existingKey.indexOf(".", pos + 1); // find next dot                                                      // 180
	      }                                                                                                                // 181
	    }                                                                                                                  // 182
	  });                                                                                                                  // 183
	                                                                                                                       // 184
	  for (i = 0, ln = arrayKeysToAdd.length; i < ln; i++) {                                                               // 185
	    key = arrayKeysToAdd[i];                                                                                           // 186
	    if (!(key in schema)) {                                                                                            // 187
	      schema[key] = {type: [Object], optional: true};                                                                  // 188
	    }                                                                                                                  // 189
	  }                                                                                                                    // 190
	                                                                                                                       // 191
	  for (i = 0, ln = objectKeysToAdd.length; i < ln; i++) {                                                              // 192
	    key = objectKeysToAdd[i];                                                                                          // 193
	    if (!(key in schema)) {                                                                                            // 194
	      schema[key] = {type: Object, optional: true};                                                                    // 195
	    }                                                                                                                  // 196
	  }                                                                                                                    // 197
	                                                                                                                       // 198
	  // Pass 2 (arrays)                                                                                                   // 199
	  adjustArrayFields(schema);                                                                                           // 200
	                                                                                                                       // 201
	  return schema;                                                                                                       // 202
	};                                                                                                                     // 203
	                                                                                                                       // 204
	var mergeSchemas = function(schemas) {                                                                                 // 205
	                                                                                                                       // 206
	  // Merge all provided schema definitions.                                                                            // 207
	  // This is effectively a shallow clone of each object, too,                                                          // 208
	  // which is what we want since we are going to manipulate it.                                                        // 209
	  var mergedSchema = {};                                                                                               // 210
	  _.each(schemas, function(schema) {                                                                                   // 211
	                                                                                                                       // 212
	    // Create a temporary SS instance so that the internal object                                                      // 213
	    // we use for merging/extending will be fully expanded                                                             // 214
	    if (Match.test(schema, SimpleSchema)) {                                                                            // 215
	      schema = schema._schema;                                                                                         // 216
	    } else {                                                                                                           // 217
	      schema = addImplicitKeys(expandSchema(schema));                                                                  // 218
	    }                                                                                                                  // 219
	                                                                                                                       // 220
	    // Loop through and extend each individual field                                                                   // 221
	    // definition. That way you can extend and overwrite                                                               // 222
	    // base field definitions.                                                                                         // 223
	    _.each(schema, function(def, field) {                                                                              // 224
	      mergedSchema[field] = mergedSchema[field] || {};                                                                 // 225
	      _.extend(mergedSchema[field], def);                                                                              // 226
	    });                                                                                                                // 227
	                                                                                                                       // 228
	  });                                                                                                                  // 229
	                                                                                                                       // 230
	  // If we merged some schemas, do this again to make sure                                                             // 231
	  // extended definitions are pushed into array item field                                                             // 232
	  // definitions properly.                                                                                             // 233
	  schemas.length && adjustArrayFields(mergedSchema);                                                                   // 234
	                                                                                                                       // 235
	  return mergedSchema;                                                                                                 // 236
	};                                                                                                                     // 237
	                                                                                                                       // 238
	// Returns an object relating the keys in the list                                                                     // 239
	// to their parent object.                                                                                             // 240
	var getObjectKeys = function(schema, schemaKeyList) {                                                                  // 241
	  var keyPrefix, remainingText, rKeys = {}, loopArray;                                                                 // 242
	  _.each(schema, function(definition, fieldName) {                                                                     // 243
	    if (definition.type === Object) {                                                                                  // 244
	      //object                                                                                                         // 245
	      keyPrefix = fieldName + ".";                                                                                     // 246
	    } else {                                                                                                           // 247
	      return;                                                                                                          // 248
	    }                                                                                                                  // 249
	                                                                                                                       // 250
	    loopArray = [];                                                                                                    // 251
	    _.each(schemaKeyList, function(fieldName2) {                                                                       // 252
	      if (fieldName2.startsWith(keyPrefix)) {                                                                          // 253
	        remainingText = fieldName2.substring(keyPrefix.length);                                                        // 254
	        if (remainingText.indexOf(".") === -1) {                                                                       // 255
	          loopArray.push(remainingText);                                                                               // 256
	        }                                                                                                              // 257
	      }                                                                                                                // 258
	    });                                                                                                                // 259
	    rKeys[keyPrefix] = loopArray;                                                                                      // 260
	  });                                                                                                                  // 261
	  return rKeys;                                                                                                        // 262
	};                                                                                                                     // 263
	                                                                                                                       // 264
	// returns an inflected version of fieldName to use as the label                                                       // 265
	var inflectedLabel = function(fieldName) {                                                                             // 266
	  var label = fieldName, lastPeriod = label.lastIndexOf(".");                                                          // 267
	  if (lastPeriod !== -1) {                                                                                             // 268
	    label = label.substring(lastPeriod + 1);                                                                           // 269
	    if (label === "$") {                                                                                               // 270
	      var pcs = fieldName.split(".");                                                                                  // 271
	      label = pcs[pcs.length - 2];                                                                                     // 272
	    }                                                                                                                  // 273
	  }                                                                                                                    // 274
	  if (label === "_id") {                                                                                               // 275
	    return "ID";                                                                                                       // 276
	  }                                                                                                                    // 277
	  return humanize(label);                                                                                              // 278
	};                                                                                                                     // 279
	                                                                                                                       // 280
	/**                                                                                                                    // 281
	 * @method getAutoValues                                                                                               // 282
	 * @private                                                                                                            // 283
	 * @param {MongoObject} mDoc                                                                                           // 284
	 * @param {Boolean} [isModifier=false] - Is it a modifier doc?                                                         // 285
	 * @param {Object} [extendedAutoValueContext] - Object that will be added to the context when calling each autoValue function
	 * @returns {undefined}                                                                                                // 287
	 *                                                                                                                     // 288
	 * Updates doc with automatic values from autoValue functions or default                                               // 289
	 * values from defaultValue. Modifies the referenced object in place.                                                  // 290
	 */                                                                                                                    // 291
	function getAutoValues(mDoc, isModifier, extendedAutoValueContext) {                                                   // 292
	  var self = this;                                                                                                     // 293
	  var doneKeys = [];                                                                                                   // 294
	                                                                                                                       // 295
	  //on the client we can add the userId if not already in the custom context                                           // 296
	  if (Meteor.isClient && extendedAutoValueContext.userId === void 0) {                                                 // 297
	    extendedAutoValueContext.userId = (Meteor.userId && Meteor.userId()) || null;                                      // 298
	  }                                                                                                                    // 299
	                                                                                                                       // 300
	  function runAV(func) {                                                                                               // 301
	    var affectedKey = this.key;                                                                                        // 302
	    // If already called for this key, skip it                                                                         // 303
	    if (_.contains(doneKeys, affectedKey)) {                                                                           // 304
	      return;                                                                                                          // 305
	    }                                                                                                                  // 306
	    var lastDot = affectedKey.lastIndexOf('.');                                                                        // 307
	    var fieldParentName = lastDot === -1 ? '' : affectedKey.slice(0, lastDot + 1);                                     // 308
	    var doUnset = false;                                                                                               // 309
	    var autoValue = func.call(_.extend({                                                                               // 310
	      isSet: (this.value !== void 0),                                                                                  // 311
	      unset: function() {                                                                                              // 312
	        doUnset = true;                                                                                                // 313
	      },                                                                                                               // 314
	      value: this.value,                                                                                               // 315
	      operator: this.operator,                                                                                         // 316
	      field: function(fName) {                                                                                         // 317
	        var keyInfo = mDoc.getInfoForKey(fName) || {};                                                                 // 318
	        return {                                                                                                       // 319
	          isSet: (keyInfo.value !== void 0),                                                                           // 320
	          value: keyInfo.value,                                                                                        // 321
	          operator: keyInfo.operator || null                                                                           // 322
	        };                                                                                                             // 323
	      },                                                                                                               // 324
	      siblingField: function(fName) {                                                                                  // 325
	        var keyInfo = mDoc.getInfoForKey(fieldParentName + fName) || {};                                               // 326
	        return {                                                                                                       // 327
	          isSet: (keyInfo.value !== void 0),                                                                           // 328
	          value: keyInfo.value,                                                                                        // 329
	          operator: keyInfo.operator || null                                                                           // 330
	        };                                                                                                             // 331
	      }                                                                                                                // 332
	    }, extendedAutoValueContext || {}), mDoc.getObject());                                                             // 333
	                                                                                                                       // 334
	    // Update tracking of which keys we've run autovalue for                                                           // 335
	    doneKeys.push(affectedKey);                                                                                        // 336
	                                                                                                                       // 337
	    if (autoValue === void 0) {                                                                                        // 338
	      if (doUnset) {                                                                                                   // 339
	        mDoc.removeValueForPosition(this.position);                                                                    // 340
	      }                                                                                                                // 341
	      return;                                                                                                          // 342
	    }                                                                                                                  // 343
	                                                                                                                       // 344
	    // If the user's auto value is of the pseudo-modifier format, parse it                                             // 345
	    // into operator and value.                                                                                        // 346
	    var op, newValue;                                                                                                  // 347
	    if (_.isObject(autoValue)) {                                                                                       // 348
	      for (var key in autoValue) {                                                                                     // 349
	        if (autoValue.hasOwnProperty(key) && key.substring(0, 1) === "$") {                                            // 350
	          op = key;                                                                                                    // 351
	          newValue = autoValue[key];                                                                                   // 352
	          break;                                                                                                       // 353
	        }                                                                                                              // 354
	      }                                                                                                                // 355
	    }                                                                                                                  // 356
	                                                                                                                       // 357
	    // Add $set for updates and upserts if necessary                                                                   // 358
	    if (!op && isModifier && this.position.slice(0, 1) !== '$') {                                                      // 359
	      op = "$set";                                                                                                     // 360
	      newValue = autoValue;                                                                                            // 361
	    }                                                                                                                  // 362
	                                                                                                                       // 363
	    // Update/change value                                                                                             // 364
	    if (op) {                                                                                                          // 365
	      mDoc.removeValueForPosition(this.position);                                                                      // 366
	      mDoc.setValueForPosition(op + '[' + affectedKey + ']', newValue);                                                // 367
	    } else {                                                                                                           // 368
	      mDoc.setValueForPosition(this.position, autoValue);                                                              // 369
	    }                                                                                                                  // 370
	  }                                                                                                                    // 371
	                                                                                                                       // 372
	  _.each(self._autoValues, function(func, fieldName) {                                                                 // 373
	    var positionSuffix, key, keySuffix, positions;                                                                     // 374
	                                                                                                                       // 375
	    // If we're under an array, run autovalue for all the properties of                                                // 376
	    // any objects that are present in the nearest ancestor array.                                                     // 377
	    if (fieldName.indexOf("$") !== -1) {                                                                               // 378
	      var testField = fieldName.slice(0, fieldName.lastIndexOf("$") + 1);                                              // 379
	      keySuffix = fieldName.slice(testField.length + 1);                                                               // 380
	      positionSuffix = MongoObject._keyToPosition(keySuffix, true);                                                    // 381
	      keySuffix = '.' + keySuffix;                                                                                     // 382
	      positions = mDoc.getPositionsForGenericKey(testField);                                                           // 383
	    } else {                                                                                                           // 384
	                                                                                                                       // 385
	      // See if anything in the object affects this key                                                                // 386
	      positions = mDoc.getPositionsForGenericKey(fieldName);                                                           // 387
	                                                                                                                       // 388
	      // Run autovalue for properties that are set in the object                                                       // 389
	      if (positions.length) {                                                                                          // 390
	        key = fieldName;                                                                                               // 391
	        keySuffix = '';                                                                                                // 392
	        positionSuffix = '';                                                                                           // 393
	      }                                                                                                                // 394
	                                                                                                                       // 395
	      // Run autovalue for properties that are NOT set in the object                                                   // 396
	      else {                                                                                                           // 397
	        key = fieldName;                                                                                               // 398
	        keySuffix = '';                                                                                                // 399
	        positionSuffix = '';                                                                                           // 400
	        if (isModifier) {                                                                                              // 401
	          positions = ["$set[" + fieldName + "]"];                                                                     // 402
	        } else {                                                                                                       // 403
	          positions = [MongoObject._keyToPosition(fieldName)];                                                         // 404
	        }                                                                                                              // 405
	      }                                                                                                                // 406
	                                                                                                                       // 407
	    }                                                                                                                  // 408
	                                                                                                                       // 409
	    _.each(positions, function(position) {                                                                             // 410
	      runAV.call({                                                                                                     // 411
	        key: (key || MongoObject._positionToKey(position)) + keySuffix,                                                // 412
	        value: mDoc.getValueForPosition(position + positionSuffix),                                                    // 413
	        operator: Utility.extractOp(position),                                                                         // 414
	        position: position + positionSuffix                                                                            // 415
	      }, func);                                                                                                        // 416
	    });                                                                                                                // 417
	  });                                                                                                                  // 418
	}                                                                                                                      // 419
	                                                                                                                       // 420
	//exported                                                                                                             // 421
	SimpleSchema = function(schemas, options) {                                                                            // 422
	  var self = this;                                                                                                     // 423
	  var firstLevelSchemaKeys = [];                                                                                       // 424
	  var fieldNameRoot;                                                                                                   // 425
	  options = options || {};                                                                                             // 426
	  schemas = schemas || {};                                                                                             // 427
	                                                                                                                       // 428
	  if (!_.isArray(schemas)) {                                                                                           // 429
	    schemas = [schemas];                                                                                               // 430
	  }                                                                                                                    // 431
	                                                                                                                       // 432
	  // adjust and store a copy of the schema definitions                                                                 // 433
	  self._schema = mergeSchemas(schemas);                                                                                // 434
	                                                                                                                       // 435
	  // store the list of defined keys for speedier checking                                                              // 436
	  self._schemaKeys = [];                                                                                               // 437
	                                                                                                                       // 438
	  // store autoValue functions by key                                                                                  // 439
	  self._autoValues = {};                                                                                               // 440
	                                                                                                                       // 441
	  // store the list of blackbox keys for passing to MongoObject constructor                                            // 442
	  self._blackboxKeys = [];                                                                                             // 443
	                                                                                                                       // 444
	  // a place to store custom validators for this instance                                                              // 445
	  self._validators = [];                                                                                               // 446
	                                                                                                                       // 447
	  // a place to store custom error messages for this schema                                                            // 448
	  self._messages = {};                                                                                                 // 449
	                                                                                                                       // 450
	  self._depsMessages = new Deps.Dependency();                                                                          // 451
	  self._depsLabels = {};                                                                                               // 452
	                                                                                                                       // 453
	  _.each(self._schema, function(definition, fieldName) {                                                               // 454
	    // Validate the field definition                                                                                   // 455
	    if (!Match.test(definition, schemaDefinition)) {                                                                   // 456
	      throw new Error('Invalid definition for ' + fieldName + ' field.');                                              // 457
	    }                                                                                                                  // 458
	                                                                                                                       // 459
	    fieldNameRoot = fieldName.split(".")[0];                                                                           // 460
	                                                                                                                       // 461
	    self._schemaKeys.push(fieldName);                                                                                  // 462
	                                                                                                                       // 463
	    // We support defaultValue shortcut by converting it immediately into an                                           // 464
	    // autoValue.                                                                                                      // 465
	    if ('defaultValue' in definition) {                                                                                // 466
	      if ('autoValue' in definition) {                                                                                 // 467
	        console.warn('SimpleSchema: Found both autoValue and defaultValue options for "' + fieldName + '". Ignoring defaultValue.');
	      } else {                                                                                                         // 469
	        if (fieldName.slice(-2) === ".$") {                                                                            // 470
	          throw new Error('An array item field (one that ends with ".$") cannot have defaultValue.');                  // 471
	        }                                                                                                              // 472
	        self._autoValues[fieldName] = (function defineAutoValue(v) {                                                   // 473
	          return function() {                                                                                          // 474
	            if (this.operator === null && !this.isSet) {                                                               // 475
	              return v;                                                                                                // 476
	            }                                                                                                          // 477
	          };                                                                                                           // 478
	        })(definition.defaultValue);                                                                                   // 479
	      }                                                                                                                // 480
	    }                                                                                                                  // 481
	                                                                                                                       // 482
	    if ('autoValue' in definition) {                                                                                   // 483
	      if (fieldName.slice(-2) === ".$") {                                                                              // 484
	        throw new Error('An array item field (one that ends with ".$") cannot have autoValue.');                       // 485
	      }                                                                                                                // 486
	      self._autoValues[fieldName] = definition.autoValue;                                                              // 487
	    }                                                                                                                  // 488
	                                                                                                                       // 489
	    self._depsLabels[fieldName] = new Deps.Dependency();                                                               // 490
	                                                                                                                       // 491
	    if (definition.blackbox === true) {                                                                                // 492
	      self._blackboxKeys.push(fieldName);                                                                              // 493
	    }                                                                                                                  // 494
	                                                                                                                       // 495
	    if (!_.contains(firstLevelSchemaKeys, fieldNameRoot)) {                                                            // 496
	      firstLevelSchemaKeys.push(fieldNameRoot);                                                                        // 497
	    }                                                                                                                  // 498
	  });                                                                                                                  // 499
	                                                                                                                       // 500
	                                                                                                                       // 501
	  // Cache these lists                                                                                                 // 502
	  self._firstLevelSchemaKeys = firstLevelSchemaKeys;                                                                   // 503
	  self._objectKeys = getObjectKeys(self._schema, self._schemaKeys);                                                    // 504
	                                                                                                                       // 505
	  // We will store named validation contexts here                                                                      // 506
	  self._validationContexts = {};                                                                                       // 507
	};                                                                                                                     // 508
	                                                                                                                       // 509
	// This allows other packages or users to extend the schema                                                            // 510
	// definition options that are supported.                                                                              // 511
	SimpleSchema.extendOptions = function(options) {                                                                       // 512
	  _.extend(schemaDefinition, options);                                                                                 // 513
	};                                                                                                                     // 514
	                                                                                                                       // 515
	// this domain regex matches all domains that have at least one .                                                      // 516
	// sadly IPv4 Adresses will be caught too but technically those are valid domains                                      // 517
	// this expression is extracted from the original RFC 5322 mail expression                                             // 518
	// a modification enforces that the tld consists only of characters                                                    // 519
	var RX_DOMAIN = '(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z](?:[a-z-]*[a-z])?';                                       // 520
	// this domain regex matches everythign that could be a domain in intranet                                             // 521
	// that means "localhost" is a valid domain                                                                            // 522
	var RX_NAME_DOMAIN = '(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\\.|$))+';                                                  // 523
	// strict IPv4 expression which allows 0-255 per oktett                                                                // 524
	var RX_IPv4 = '(?:(?:[0-1]?\\d{1,2}|2[0-4]\\d|25[0-5])(?:\\.|$)){4}';                                                  // 525
	// strict IPv6 expression which allows (and validates) all shortcuts                                                   // 526
	var RX_IPv6 = '(?:(?:[\\dA-Fa-f]{1,4}(?::|$)){8}' // full adress                                                       // 527
	  + '|(?=(?:[^:\\s]|:[^:\\s])*::(?:[^:\\s]|:[^:\\s])*$)' // or min/max one '::'                                        // 528
	  + '[\\dA-Fa-f]{0,4}(?:::?(?:[\\dA-Fa-f]{1,4}|$)){1,6})'; // and short adress                                         // 529
	// this allows domains (also localhost etc) and ip adresses                                                            // 530
	var RX_WEAK_DOMAIN = '(?:' + [RX_NAME_DOMAIN,RX_IPv4,RX_IPv6].join('|') + ')';                                         // 531
	                                                                                                                       // 532
	SimpleSchema.RegEx = {                                                                                                 // 533
	  // We use the RegExp suggested by W3C in http://www.w3.org/TR/html5/forms.html#valid-e-mail-address                  // 534
	  // This is probably the same logic used by most browsers when type=email, which is our goal. It is                   // 535
	  // a very permissive expression. Some apps may wish to be more strict and can write their own RegExp.                // 536
	  Email: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
	                                                                                                                       // 538
	  Domain: new RegExp('^' + RX_DOMAIN + '$'),                                                                           // 539
	  WeakDomain: new RegExp('^' + RX_WEAK_DOMAIN + '$'),                                                                  // 540
	                                                                                                                       // 541
	  IP: new RegExp('^(?:' + RX_IPv4 + '|' + RX_IPv6 + ')$'),                                                             // 542
	  IPv4: new RegExp('^' + RX_IPv4 + '$'),                                                                               // 543
	  IPv6: new RegExp('^' + RX_IPv6 + '$'),                                                                               // 544
	  // URL RegEx from https://gist.github.com/dperini/729294                                                             // 545
	  // http://mathiasbynens.be/demo/url-regex                                                                            // 546
	  Url: /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i,
	  // unique id from the random package also used by minimongo                                                          // 548
	  // character list: https://github.com/meteor/meteor/blob/release/0.8.0/packages/random/random.js#L88                 // 549
	  // string length: https://github.com/meteor/meteor/blob/release/0.8.0/packages/random/random.js#L143                 // 550
	  Id: /^[23456789ABCDEFGHJKLMNPQRSTWXYZabcdefghijkmnopqrstuvwxyz]{17}$/,                                               // 551
	  // allows for a 5 digit zip code followed by a whitespace or dash and then 4 more digits                             // 552
	  // matches 11111 and 11111-1111 and 11111 1111                                                                       // 553
	  ZipCode: /^\d{5}(?:[-\s]\d{4})?$/,                                                                                   // 554
	  // taken from google's libphonenumber library                                                                        // 555
	  // https://github.com/googlei18n/libphonenumber/blob/master/javascript/i18n/phonenumbers/phonenumberutil.js          // 556
	  // reference the VALID_PHONE_NUMBER_PATTERN key                                                                      // 557
	  // allows for common phone number symbols including + () and -                                                       // 558
	  Phone: /^[0-9０-９٠-٩۰-۹]{2}$|^[+＋]*(?:[-x‐-―−ー－-／  ­​⁠　()（）［］.\[\]/~⁓∼～*]*[0-9０-９٠-٩۰-۹]){3,}[-x‐-―−ー－-／  ­​⁠　()（）［］.\[\]/~⁓∼～0-9０-９٠-٩۰-۹]*(?:;ext=([0-9０-９٠-٩۰-۹]{1,7})|[  \t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|[,xｘ#＃~～]|int|anexo|ｉｎｔ)[:\.．]?[  \t,-]*([0-9０-９٠-٩۰-۹]{1,7})#?|[- ]+([0-9０-９٠-٩۰-۹]{1,5})#)?$/i
	};                                                                                                                     // 560
	                                                                                                                       // 561
	SimpleSchema._makeGeneric = function(name) {                                                                           // 562
	  if (typeof name !== "string") {                                                                                      // 563
	    return null;                                                                                                       // 564
	  }                                                                                                                    // 565
	                                                                                                                       // 566
	  return name.replace(/\.[0-9]+(?=\.|$)/g, '.$');                                                                      // 567
	};                                                                                                                     // 568
	                                                                                                                       // 569
	SimpleSchema._depsGlobalMessages = new Deps.Dependency();                                                              // 570
	                                                                                                                       // 571
	// Inherit from Match.Where                                                                                            // 572
	// This allow SimpleSchema instance to be recognized as a Match.Where instance as well                                 // 573
	// as a SimpleSchema instance                                                                                          // 574
	SimpleSchema.prototype = new Match.Where();                                                                            // 575
	                                                                                                                       // 576
	// If an object is an instance of Match.Where, Meteor built-in check API will look at                                  // 577
	// the function named `condition` and will pass it the document to validate                                            // 578
	SimpleSchema.prototype.condition = function(obj) {                                                                     // 579
	  var self = this;                                                                                                     // 580
	                                                                                                                       // 581
	  //determine whether obj is a modifier                                                                                // 582
	  var isModifier, isNotModifier;                                                                                       // 583
	  _.each(obj, function(val, key) {                                                                                     // 584
	    if (key.substring(0, 1) === "$") {                                                                                 // 585
	      isModifier = true;                                                                                               // 586
	    } else {                                                                                                           // 587
	      isNotModifier = true;                                                                                            // 588
	    }                                                                                                                  // 589
	  });                                                                                                                  // 590
	                                                                                                                       // 591
	  if (isModifier && isNotModifier) {                                                                                   // 592
	    throw new Match.Error("Object cannot contain modifier operators alongside other keys");                            // 593
	  }                                                                                                                    // 594
	                                                                                                                       // 595
	  var ctx = self.newContext();                                                                                         // 596
	  if (!ctx.validate(obj, {modifier: isModifier, filter: false, autoConvert: false})) {                                 // 597
	    var error = ctx.getErrorObject();                                                                                  // 598
	    var matchError = new Match.Error(error.message);                                                                   // 599
	    matchError.invalidKeys = error.invalidKeys;                                                                        // 600
	    if (Meteor.isServer) {                                                                                             // 601
	      matchError.sanitizedError = error.sanitizedError;                                                                // 602
	    }                                                                                                                  // 603
	    throw matchError;                                                                                                  // 604
	  }                                                                                                                    // 605
	                                                                                                                       // 606
	  return true;                                                                                                         // 607
	};                                                                                                                     // 608
	                                                                                                                       // 609
	function logInvalidKeysForContext(context, name) {                                                                     // 610
	  Meteor.startup(function() {                                                                                          // 611
	    Deps.autorun(function() {                                                                                          // 612
	      if (!context.isValid()) {                                                                                        // 613
	        console.log('SimpleSchema invalid keys for "' + name + '" context:', context.invalidKeys());                   // 614
	      }                                                                                                                // 615
	    });                                                                                                                // 616
	  });                                                                                                                  // 617
	}                                                                                                                      // 618
	                                                                                                                       // 619
	SimpleSchema.prototype.namedContext = function(name) {                                                                 // 620
	  var self = this;                                                                                                     // 621
	  if (typeof name !== "string") {                                                                                      // 622
	    name = "default";                                                                                                  // 623
	  }                                                                                                                    // 624
	  if (!self._validationContexts[name]) {                                                                               // 625
	    self._validationContexts[name] = new SimpleSchemaValidationContext(self);                                          // 626
	                                                                                                                       // 627
	    // In debug mode, log all invalid key errors to the browser console                                                // 628
	    if (SimpleSchema.debug && Meteor.isClient) {                                                                       // 629
	      Deps.nonreactive(function() {                                                                                    // 630
	        logInvalidKeysForContext(self._validationContexts[name], name);                                                // 631
	      });                                                                                                              // 632
	    }                                                                                                                  // 633
	  }                                                                                                                    // 634
	  return self._validationContexts[name];                                                                               // 635
	};                                                                                                                     // 636
	                                                                                                                       // 637
	// Global custom validators                                                                                            // 638
	SimpleSchema._validators = [];                                                                                         // 639
	SimpleSchema.addValidator = function(func) {                                                                           // 640
	  SimpleSchema._validators.push(func);                                                                                 // 641
	};                                                                                                                     // 642
	                                                                                                                       // 643
	// Instance custom validators                                                                                          // 644
	SimpleSchema.prototype.addValidator = function(func) {                                                                 // 645
	  this._validators.push(func);                                                                                         // 646
	};                                                                                                                     // 647
	                                                                                                                       // 648
	/**                                                                                                                    // 649
	 * @method SimpleSchema.prototype.pick                                                                                 // 650
	 * @param {[fields]} The list of fields to pick to instantiate the subschema                                           // 651
	 * @returns {SimpleSchema} The subschema                                                                               // 652
	 */                                                                                                                    // 653
	SimpleSchema.prototype.pick = function(/* arguments */) {                                                              // 654
	  var self = this;                                                                                                     // 655
	  var args = _.toArray(arguments);                                                                                     // 656
	  args.unshift(self._schema);                                                                                          // 657
	                                                                                                                       // 658
	  var newSchema = _.pick.apply(null, args);                                                                            // 659
	  return new SimpleSchema(newSchema);                                                                                  // 660
	};                                                                                                                     // 661
	                                                                                                                       // 662
	SimpleSchema.prototype.omit = function() {                                                                             // 663
	  var self = this;                                                                                                     // 664
	  var args = _.toArray(arguments);                                                                                     // 665
	  args.unshift(self._schema);                                                                                          // 666
	                                                                                                                       // 667
	  var newSchema = _.omit.apply(null, args);                                                                            // 668
	  return new SimpleSchema(newSchema);                                                                                  // 669
	};                                                                                                                     // 670
	                                                                                                                       // 671
	                                                                                                                       // 672
	/**                                                                                                                    // 673
	 * @method SimpleSchema.prototype.clean                                                                                // 674
	 * @param {Object} doc - Document or modifier to clean. Referenced object will be modified in place.                   // 675
	 * @param {Object} [options]                                                                                           // 676
	 * @param {Boolean} [options.filter=true] - Do filtering?                                                              // 677
	 * @param {Boolean} [options.autoConvert=true] - Do automatic type converting?                                         // 678
	 * @param {Boolean} [options.removeEmptyStrings=true] - Remove keys in normal object or $set where the value is an empty string?
	 * @param {Boolean} [options.trimStrings=true] - Trim string values?                                                   // 680
	 * @param {Boolean} [options.getAutoValues=true] - Inject automatic and default values?                                // 681
	 * @param {Boolean} [options.isModifier=false] - Is doc a modifier object?                                             // 682
	 * @param {Object} [options.extendAutoValueContext] - This object will be added to the `this` context of autoValue functions.
	 * @returns {Object} The modified doc.                                                                                 // 684
	 *                                                                                                                     // 685
	 * Cleans a document or modifier object. By default, will filter, automatically                                        // 686
	 * type convert where possible, and inject automatic/default values. Use the options                                   // 687
	 * to skip one or more of these.                                                                                       // 688
	 */                                                                                                                    // 689
	SimpleSchema.prototype.clean = function(doc, options) {                                                                // 690
	  var self = this;                                                                                                     // 691
	                                                                                                                       // 692
	  // By default, doc will be filtered and autoconverted                                                                // 693
	  options = _.extend({                                                                                                 // 694
	    filter: true,                                                                                                      // 695
	    autoConvert: true,                                                                                                 // 696
	    removeEmptyStrings: true,                                                                                          // 697
	    trimStrings: true,                                                                                                 // 698
	    getAutoValues: true,                                                                                               // 699
	    isModifier: false,                                                                                                 // 700
	    extendAutoValueContext: {}                                                                                         // 701
	  }, options || {});                                                                                                   // 702
	                                                                                                                       // 703
	  // Convert $pushAll (deprecated) to $push with $each                                                                 // 704
	  if ("$pushAll" in doc) {                                                                                             // 705
	    console.warn("SimpleSchema.clean: $pushAll is deprecated; converting to $push with $each");                        // 706
	    doc.$push = doc.$push || {};                                                                                       // 707
	    for (var field in doc.$pushAll) {                                                                                  // 708
	      doc.$push[field] = doc.$push[field] || {};                                                                       // 709
	      doc.$push[field].$each = doc.$push[field].$each || [];                                                           // 710
	      for (var i = 0, ln = doc.$pushAll[field].length; i < ln; i++) {                                                  // 711
	        doc.$push[field].$each.push(doc.$pushAll[field][i]);                                                           // 712
	      }                                                                                                                // 713
	      delete doc.$pushAll;                                                                                             // 714
	    }                                                                                                                  // 715
	  }                                                                                                                    // 716
	                                                                                                                       // 717
	  var mDoc = new MongoObject(doc, self._blackboxKeys);                                                                 // 718
	                                                                                                                       // 719
	  // Clean loop                                                                                                        // 720
	  if (options.filter || options.autoConvert || options.removeEmptyStrings || options.trimStrings) {                    // 721
	    mDoc.forEachNode(function() {                                                                                      // 722
	      var gKey = this.genericKey, p, def, val;                                                                         // 723
	      if (gKey) {                                                                                                      // 724
	        def = self._schema[gKey];                                                                                      // 725
	        val = this.value;                                                                                              // 726
	        // Filter out props if necessary; any property is OK for $unset because we want to                             // 727
	        // allow conversions to remove props that have been removed from the schema.                                   // 728
	        if (options.filter && this.operator !== "$unset" && !self.allowsKey(gKey)) {                                   // 729
	          // XXX Special handling for $each; maybe this could be made nicer                                            // 730
	          if (this.position.slice(-7) === "[$each]") {                                                                 // 731
	            mDoc.removeValueForPosition(this.position.slice(0, -7));                                                   // 732
	          } else {                                                                                                     // 733
	            this.remove();                                                                                             // 734
	          }                                                                                                            // 735
	          if (SimpleSchema.debug) {                                                                                    // 736
	            console.info('SimpleSchema.clean: filtered out value that would have affected key "' + gKey + '", which is not allowed by the schema');
	          }                                                                                                            // 738
	          return; // no reason to do more                                                                              // 739
	        }                                                                                                              // 740
	        if (val !== void 0) {                                                                                          // 741
	          // Autoconvert values if requested and if possible                                                           // 742
	          var wasAutoConverted = false;                                                                                // 743
	          if (options.autoConvert && this.operator !== "$unset" && def) {                                              // 744
	            var newVal = typeconvert(val, def.type);                                                                   // 745
	            // trim strings                                                                                            // 746
	            if (options.trimStrings && typeof newVal === "string") {                                                   // 747
	              newVal = newVal.trim();                                                                                  // 748
	            }                                                                                                          // 749
	            if (newVal !== void 0 && newVal !== val) {                                                                 // 750
	              // remove empty strings                                                                                  // 751
	              if (options.removeEmptyStrings && (!this.operator || this.operator === "$set") && typeof newVal === "string" && !newVal.length) {
	                // For a document, we remove any fields that are being set to an empty string                          // 753
	                newVal = void 0;                                                                                       // 754
	                // For a modifier, we $unset any fields that are being set to an empty string                          // 755
	                if (this.operator === "$set" && this.position.match(/\[.+?\]/g).length < 2) {                          // 756
	                                                                                                                       // 757
	                  p = this.position.replace("$set", "$unset");                                                         // 758
	                  mDoc.setValueForPosition(p, "");                                                                     // 759
	                }                                                                                                      // 760
	              }                                                                                                        // 761
	                                                                                                                       // 762
	              // Change value; if undefined, will remove it                                                            // 763
	              SimpleSchema.debug && console.info('SimpleSchema.clean: autoconverted value ' + val + ' from ' + typeof val + ' to ' + typeof newVal + ' for ' + gKey);
	              this.updateValue(newVal);                                                                                // 765
	              wasAutoConverted = true;                                                                                 // 766
	            }                                                                                                          // 767
	          }                                                                                                            // 768
	          if (!wasAutoConverted) {                                                                                     // 769
	            // trim strings                                                                                            // 770
	            if (options.trimStrings && typeof val === "string" && (!def || (def && def.trim !== false))) {             // 771
	              this.updateValue(val.trim());                                                                            // 772
	            }                                                                                                          // 773
	            // remove empty strings                                                                                    // 774
	            if (options.removeEmptyStrings && (!this.operator || this.operator === "$set") && typeof val === "string" && !val.length) {
	              // For a document, we remove any fields that are being set to an empty string                            // 776
	              this.remove();                                                                                           // 777
	              // For a modifier, we $unset any fields that are being set to an empty string. But only if we're not already within an entire object that is being set.
	              if (this.operator === "$set" && this.position.match(/\[.+?\]/g).length < 2) {                            // 779
	                p = this.position.replace("$set", "$unset");                                                           // 780
	                mDoc.setValueForPosition(p, "");                                                                       // 781
	              }                                                                                                        // 782
	            }                                                                                                          // 783
	          }                                                                                                            // 784
	        }                                                                                                              // 785
	      }                                                                                                                // 786
	    }, {endPointsOnly: false});                                                                                        // 787
	  }                                                                                                                    // 788
	                                                                                                                       // 789
	  // Set automatic values                                                                                              // 790
	  options.getAutoValues && getAutoValues.call(self, mDoc, options.isModifier, options.extendAutoValueContext);         // 791
	                                                                                                                       // 792
	  // Ensure we don't have any operators set to an empty object                                                         // 793
	  // since MongoDB 2.6+ will throw errors.                                                                             // 794
	  if (options.isModifier) {                                                                                            // 795
	    for (var op in doc) {                                                                                              // 796
	      if (doc.hasOwnProperty(op) && _.isEmpty(doc[op])) {                                                              // 797
	        delete doc[op];                                                                                                // 798
	      }                                                                                                                // 799
	    }                                                                                                                  // 800
	  }                                                                                                                    // 801
	                                                                                                                       // 802
	  return doc;                                                                                                          // 803
	};                                                                                                                     // 804
	                                                                                                                       // 805
	// Returns the entire schema object or just the definition for one key                                                 // 806
	// in the schema.                                                                                                      // 807
	SimpleSchema.prototype.schema = function(key) {                                                                        // 808
	  var self = this;                                                                                                     // 809
	  // if not null or undefined (more specific)                                                                          // 810
	  if (key !== null && key !== void 0) {                                                                                // 811
	    return self._schema[SimpleSchema._makeGeneric(key)];                                                               // 812
	  } else {                                                                                                             // 813
	    return self._schema;                                                                                               // 814
	  }                                                                                                                    // 815
	};                                                                                                                     // 816
	                                                                                                                       // 817
	// Returns the evaluated definition for one key in the schema                                                          // 818
	// key = non-generic key                                                                                               // 819
	// [propList] = props to include in the result, for performance                                                        // 820
	// [functionContext] = used for evaluating schema options that are functions                                           // 821
	SimpleSchema.prototype.getDefinition = function(key, propList, functionContext) {                                      // 822
	  var self = this;                                                                                                     // 823
	  var defs = self.schema(key);                                                                                         // 824
	  if (!defs) {                                                                                                         // 825
	    return;                                                                                                            // 826
	  }                                                                                                                    // 827
	                                                                                                                       // 828
	  if (_.isArray(propList)) {                                                                                           // 829
	    defs = _.pick(defs, propList);                                                                                     // 830
	  } else {                                                                                                             // 831
	    defs = _.clone(defs);                                                                                              // 832
	  }                                                                                                                    // 833
	                                                                                                                       // 834
	  // For any options that support specifying a function,                                                               // 835
	  // evaluate the functions.                                                                                           // 836
	  _.each(['min', 'max', 'minCount', 'maxCount', 'allowedValues', 'optional', 'label'], function (prop) {               // 837
	    if (_.isFunction(defs[prop])) {                                                                                    // 838
	      defs[prop] = defs[prop].call(functionContext || {});                                                             // 839
	    }                                                                                                                  // 840
	  });                                                                                                                  // 841
	                                                                                                                       // 842
	  // Inflect label if not defined                                                                                      // 843
	  defs.label = defs.label || inflectedLabel(key);                                                                      // 844
	                                                                                                                       // 845
	  return defs;                                                                                                         // 846
	};                                                                                                                     // 847
	                                                                                                                       // 848
	// Check if the key is a nested dot-syntax key inside of a blackbox object                                             // 849
	SimpleSchema.prototype.keyIsInBlackBox = function(key) {                                                               // 850
	  var self = this;                                                                                                     // 851
	  var parentPath = SimpleSchema._makeGeneric(key), lastDot, def;                                                       // 852
	                                                                                                                       // 853
	  // Iterate the dot-syntax hierarchy until we find a key in our schema                                                // 854
	  do {                                                                                                                 // 855
	    lastDot = parentPath.lastIndexOf('.');                                                                             // 856
	    if (lastDot !== -1) {                                                                                              // 857
	      parentPath = parentPath.slice(0, lastDot); // Remove last path component                                         // 858
	      def = self.getDefinition(parentPath);                                                                            // 859
	    }                                                                                                                  // 860
	  } while (lastDot !== -1 && !def);                                                                                    // 861
	                                                                                                                       // 862
	  return !!(def && def.blackbox);                                                                                      // 863
	};                                                                                                                     // 864
	                                                                                                                       // 865
	// Use to dynamically change the schema labels.                                                                        // 866
	SimpleSchema.prototype.labels = function(labels) {                                                                     // 867
	  var self = this;                                                                                                     // 868
	  _.each(labels, function(label, fieldName) {                                                                          // 869
	    if (!_.isString(label) && !_.isFunction(label)) {                                                                  // 870
	      return;                                                                                                          // 871
	    }                                                                                                                  // 872
	                                                                                                                       // 873
	    if (!(fieldName in self._schema)) {                                                                                // 874
	      return;                                                                                                          // 875
	    }                                                                                                                  // 876
	                                                                                                                       // 877
	    self._schema[fieldName].label = label;                                                                             // 878
	    self._depsLabels[fieldName] && self._depsLabels[fieldName].changed();                                              // 879
	  });                                                                                                                  // 880
	};                                                                                                                     // 881
	                                                                                                                       // 882
	// should be used to safely get a label as string                                                                      // 883
	SimpleSchema.prototype.label = function(key) {                                                                         // 884
	  var self = this;                                                                                                     // 885
	                                                                                                                       // 886
	  // Get all labels                                                                                                    // 887
	  if (key === null || key === void 0) {                                                                                // 888
	    var result = {};                                                                                                   // 889
	    _.each(self.schema(), function(def, fieldName) {                                                                   // 890
	      result[fieldName] = self.label(fieldName);                                                                       // 891
	    });                                                                                                                // 892
	    return result;                                                                                                     // 893
	  }                                                                                                                    // 894
	                                                                                                                       // 895
	  // Get label for one field                                                                                           // 896
	  var def = self.getDefinition(key);                                                                                   // 897
	  if (def) {                                                                                                           // 898
	    var genericKey = SimpleSchema._makeGeneric(key);                                                                   // 899
	    self._depsLabels[genericKey] && self._depsLabels[genericKey].depend();                                             // 900
	    return def.label;                                                                                                  // 901
	  }                                                                                                                    // 902
	                                                                                                                       // 903
	  return null;                                                                                                         // 904
	};                                                                                                                     // 905
	                                                                                                                       // 906
	// Global messages                                                                                                     // 907
	                                                                                                                       // 908
	SimpleSchema._globalMessages = {                                                                                       // 909
	  required: "[label] is required",                                                                                     // 910
	  minString: "[label] must be at least [min] characters",                                                              // 911
	  maxString: "[label] cannot exceed [max] characters",                                                                 // 912
	  minNumber: "[label] must be at least [min]",                                                                         // 913
	  maxNumber: "[label] cannot exceed [max]",                                                                            // 914
	  minNumberExclusive: "[label] must be greater than [min]",                                                            // 915
	  maxNumberExclusive: "[label] must be less than [max]",                                                               // 916
	  minDate: "[label] must be on or after [min]",                                                                        // 917
	  maxDate: "[label] cannot be after [max]",                                                                            // 918
	  badDate: "[label] is not a valid date",                                                                              // 919
	  minCount: "You must specify at least [minCount] values",                                                             // 920
	  maxCount: "You cannot specify more than [maxCount] values",                                                          // 921
	  noDecimal: "[label] must be an integer",                                                                             // 922
	  notAllowed: "[value] is not an allowed value",                                                                       // 923
	  expectedString: "[label] must be a string",                                                                          // 924
	  expectedNumber: "[label] must be a number",                                                                          // 925
	  expectedBoolean: "[label] must be a boolean",                                                                        // 926
	  expectedArray: "[label] must be an array",                                                                           // 927
	  expectedObject: "[label] must be an object",                                                                         // 928
	  expectedConstructor: "[label] must be a [type]",                                                                     // 929
	  regEx: [                                                                                                             // 930
	    {msg: "[label] failed regular expression validation"},                                                             // 931
	    {exp: SimpleSchema.RegEx.Email, msg: "[label] must be a valid e-mail address"},                                    // 932
	    {exp: SimpleSchema.RegEx.WeakEmail, msg: "[label] must be a valid e-mail address"},                                // 933
	    {exp: SimpleSchema.RegEx.Domain, msg: "[label] must be a valid domain"},                                           // 934
	    {exp: SimpleSchema.RegEx.WeakDomain, msg: "[label] must be a valid domain"},                                       // 935
	    {exp: SimpleSchema.RegEx.IP, msg: "[label] must be a valid IPv4 or IPv6 address"},                                 // 936
	    {exp: SimpleSchema.RegEx.IPv4, msg: "[label] must be a valid IPv4 address"},                                       // 937
	    {exp: SimpleSchema.RegEx.IPv6, msg: "[label] must be a valid IPv6 address"},                                       // 938
	    {exp: SimpleSchema.RegEx.Url, msg: "[label] must be a valid URL"},                                                 // 939
	    {exp: SimpleSchema.RegEx.Id, msg: "[label] must be a valid alphanumeric ID"}                                       // 940
	  ],                                                                                                                   // 941
	  keyNotInSchema: "[key] is not allowed by the schema"                                                                 // 942
	};                                                                                                                     // 943
	                                                                                                                       // 944
	SimpleSchema.messages = function(messages) {                                                                           // 945
	  _.extend(SimpleSchema._globalMessages, messages);                                                                    // 946
	  SimpleSchema._depsGlobalMessages.changed();                                                                          // 947
	};                                                                                                                     // 948
	                                                                                                                       // 949
	// Schema-specific messages                                                                                            // 950
	                                                                                                                       // 951
	SimpleSchema.prototype.messages = function(messages) {                                                                 // 952
	  var self = this;                                                                                                     // 953
	  _.extend(self._messages, messages);                                                                                  // 954
	  self._depsMessages.changed();                                                                                        // 955
	};                                                                                                                     // 956
	                                                                                                                       // 957
	// Returns a string message for the given error type and key. Uses the                                                 // 958
	// def and value arguments to fill in placeholders in the error messages.                                              // 959
	SimpleSchema.prototype.messageForError = function(type, key, def, value) {                                             // 960
	  var self = this;                                                                                                     // 961
	                                                                                                                       // 962
	  // We proceed even if we can't get a definition because it might be a keyNotInSchema error                           // 963
	  def = def || self.getDefinition(key, ['regEx', 'label', 'minCount', 'maxCount', 'min', 'max', 'type']) || {};        // 964
	                                                                                                                       // 965
	  // Adjust for complex types, currently only regEx,                                                                   // 966
	  // where we might have regEx.1 meaning the second                                                                    // 967
	  // expression in the array.                                                                                          // 968
	  var firstTypePeriod = type.indexOf("."), index = null;                                                               // 969
	  if (firstTypePeriod !== -1) {                                                                                        // 970
	    index = type.substring(firstTypePeriod + 1);                                                                       // 971
	    index = parseInt(index, 10);                                                                                       // 972
	    type = type.substring(0, firstTypePeriod);                                                                         // 973
	  }                                                                                                                    // 974
	                                                                                                                       // 975
	  // Which regExp is it?                                                                                               // 976
	  var regExpMatch;                                                                                                     // 977
	  if (type === "regEx") {                                                                                              // 978
	    if (index !== null && index !== void 0 && !isNaN(index)) {                                                         // 979
	      regExpMatch = def.regEx[index];                                                                                  // 980
	    } else {                                                                                                           // 981
	      regExpMatch = def.regEx;                                                                                         // 982
	    }                                                                                                                  // 983
	    if (regExpMatch) {                                                                                                 // 984
	      regExpMatch = regExpMatch.toString();                                                                            // 985
	    }                                                                                                                  // 986
	  }                                                                                                                    // 987
	                                                                                                                       // 988
	  // Prep some strings to be used when finding the correct message for this error                                      // 989
	  var typePlusKey = type + " " + key;                                                                                  // 990
	  var genericKey = SimpleSchema._makeGeneric(key);                                                                     // 991
	  var typePlusGenKey = type + " " + genericKey;                                                                        // 992
	                                                                                                                       // 993
	  // reactively update when message templates are changed                                                              // 994
	  SimpleSchema._depsGlobalMessages.depend();                                                                           // 995
	  self._depsMessages.depend();                                                                                         // 996
	                                                                                                                       // 997
	  // Prep a function that finds the correct message for regEx errors                                                   // 998
	  function findRegExError(message) {                                                                                   // 999
	    if (type !== "regEx" || !_.isArray(message)) {                                                                     // 1000
	      return message;                                                                                                  // 1001
	    }                                                                                                                  // 1002
	    // Parse regEx messages, which are provided in a special object array format                                       // 1003
	    // [{exp: RegExp, msg: "Foo"}]                                                                                     // 1004
	    // Where `exp` is optional                                                                                         // 1005
	                                                                                                                       // 1006
	    var msgObj;                                                                                                        // 1007
	    // First see if there's one where exp matches this expression                                                      // 1008
	    if (regExpMatch) {                                                                                                 // 1009
	      msgObj = _.find(message, function (o) {                                                                          // 1010
	        return o.exp && o.exp.toString() === regExpMatch;                                                              // 1011
	      });                                                                                                              // 1012
	    }                                                                                                                  // 1013
	                                                                                                                       // 1014
	    // If not, see if there's a default message defined                                                                // 1015
	    if (!msgObj) {                                                                                                     // 1016
	      msgObj = _.findWhere(message, {exp: null});                                                                      // 1017
	      if (!msgObj) {                                                                                                   // 1018
	        msgObj = _.findWhere(message, {exp: void 0});                                                                  // 1019
	      }                                                                                                                // 1020
	    }                                                                                                                  // 1021
	                                                                                                                       // 1022
	    return msgObj ? msgObj.msg : null;                                                                                 // 1023
	  }                                                                                                                    // 1024
	                                                                                                                       // 1025
	  // Try finding the correct message to use at various levels, from most                                               // 1026
	  // specific to least specific.                                                                                       // 1027
	  var message = self._messages[typePlusKey] ||                  // (1) Use schema-specific message for specific key    // 1028
	                self._messages[typePlusGenKey] ||               // (2) Use schema-specific message for generic key     // 1029
	                self._messages[type];                           // (3) Use schema-specific message for type            // 1030
	  message = findRegExError(message);                                                                                   // 1031
	                                                                                                                       // 1032
	  if (!message) {                                                                                                      // 1033
	    message = SimpleSchema._globalMessages[typePlusKey] ||      // (4) Use global message for specific key             // 1034
	              SimpleSchema._globalMessages[typePlusGenKey] ||   // (5) Use global message for generic key              // 1035
	              SimpleSchema._globalMessages[type];               // (6) Use global message for type                     // 1036
	    message = findRegExError(message);                                                                                 // 1037
	  }                                                                                                                    // 1038
	                                                                                                                       // 1039
	  if (!message) {                                                                                                      // 1040
	    return "Unknown validation error";                                                                                 // 1041
	  }                                                                                                                    // 1042
	                                                                                                                       // 1043
	  // Now replace all placeholders in the message with the correct values                                               // 1044
	                                                                                                                       // 1045
	  // [key]                                                                                                             // 1046
	  message = message.replace("[key]", key);                                                                             // 1047
	                                                                                                                       // 1048
	  // [label]                                                                                                           // 1049
	  // The call to self.label() establishes a reactive dependency, too                                                   // 1050
	  message = message.replace("[label]", self.label(key));                                                               // 1051
	                                                                                                                       // 1052
	  // [minCount]                                                                                                        // 1053
	  if (typeof def.minCount !== "undefined") {                                                                           // 1054
	    message = message.replace("[minCount]", def.minCount);                                                             // 1055
	  }                                                                                                                    // 1056
	                                                                                                                       // 1057
	  // [maxCount]                                                                                                        // 1058
	  if (typeof def.maxCount !== "undefined") {                                                                           // 1059
	    message = message.replace("[maxCount]", def.maxCount);                                                             // 1060
	  }                                                                                                                    // 1061
	                                                                                                                       // 1062
	  // [value]                                                                                                           // 1063
	  if (value !== void 0 && value !== null) {                                                                            // 1064
	    message = message.replace("[value]", value.toString());                                                            // 1065
	  } else {                                                                                                             // 1066
	    message = message.replace("[value]", 'null');                                                                      // 1067
	  }                                                                                                                    // 1068
	                                                                                                                       // 1069
	  // [min] and [max]                                                                                                   // 1070
	  var min = def.min;                                                                                                   // 1071
	  var max = def.max;                                                                                                   // 1072
	  if (def.type === Date || def.type === [Date]) {                                                                      // 1073
	    if (typeof min !== "undefined") {                                                                                  // 1074
	      message = message.replace("[min]", Utility.dateToDateString(min));                                               // 1075
	    }                                                                                                                  // 1076
	    if (typeof max !== "undefined") {                                                                                  // 1077
	      message = message.replace("[max]", Utility.dateToDateString(max));                                               // 1078
	    }                                                                                                                  // 1079
	  } else {                                                                                                             // 1080
	    if (typeof min !== "undefined") {                                                                                  // 1081
	      message = message.replace("[min]", min);                                                                         // 1082
	    }                                                                                                                  // 1083
	    if (typeof max !== "undefined") {                                                                                  // 1084
	      message = message.replace("[max]", max);                                                                         // 1085
	    }                                                                                                                  // 1086
	  }                                                                                                                    // 1087
	                                                                                                                       // 1088
	  // [type]                                                                                                            // 1089
	  if (def.type instanceof Function) {                                                                                  // 1090
	    message = message.replace("[type]", def.type.name);                                                                // 1091
	  }                                                                                                                    // 1092
	                                                                                                                       // 1093
	  // Now return the message                                                                                            // 1094
	  return message;                                                                                                      // 1095
	};                                                                                                                     // 1096
	                                                                                                                       // 1097
	// Returns true if key is explicitly allowed by the schema or implied                                                  // 1098
	// by other explicitly allowed keys.                                                                                   // 1099
	// The key string should have $ in place of any numeric array positions.                                               // 1100
	SimpleSchema.prototype.allowsKey = function(key) {                                                                     // 1101
	  var self = this;                                                                                                     // 1102
	                                                                                                                       // 1103
	  // Loop through all keys in the schema                                                                               // 1104
	  return _.any(self._schemaKeys, function(schemaKey) {                                                                 // 1105
	                                                                                                                       // 1106
	    // If the schema key is the test key, it's allowed.                                                                // 1107
	    if (schemaKey === key) {                                                                                           // 1108
	      return true;                                                                                                     // 1109
	    }                                                                                                                  // 1110
	                                                                                                                       // 1111
	    // Black box handling                                                                                              // 1112
	    if (self.schema(schemaKey).blackbox === true) {                                                                    // 1113
	      var kl = schemaKey.length;                                                                                       // 1114
	      var compare1 = key.slice(0, kl + 2);                                                                             // 1115
	      var compare2 = compare1.slice(0, -1);                                                                            // 1116
	                                                                                                                       // 1117
	      // If the test key is the black box key + ".$", then the test                                                    // 1118
	      // key is NOT allowed because black box keys are by definition                                                   // 1119
	      // only for objects, and not for arrays.                                                                         // 1120
	      if (compare1 === schemaKey + '.$') {                                                                             // 1121
	        return false;                                                                                                  // 1122
	      }                                                                                                                // 1123
	                                                                                                                       // 1124
	      // Otherwise                                                                                                     // 1125
	      if (compare2 === schemaKey + '.') {                                                                              // 1126
	        return true;                                                                                                   // 1127
	      }                                                                                                                // 1128
	    }                                                                                                                  // 1129
	                                                                                                                       // 1130
	    return false;                                                                                                      // 1131
	  });                                                                                                                  // 1132
	};                                                                                                                     // 1133
	                                                                                                                       // 1134
	SimpleSchema.prototype.newContext = function() {                                                                       // 1135
	  return new SimpleSchemaValidationContext(this);                                                                      // 1136
	};                                                                                                                     // 1137
	                                                                                                                       // 1138
	// Returns all the child keys for the object identified by the generic prefix,                                         // 1139
	// or all the top level keys if no prefix is supplied.                                                                 // 1140
	SimpleSchema.prototype.objectKeys = function(keyPrefix) {                                                              // 1141
	  var self = this;                                                                                                     // 1142
	  if (!keyPrefix) {                                                                                                    // 1143
	    return self._firstLevelSchemaKeys;                                                                                 // 1144
	  }                                                                                                                    // 1145
	  return self._objectKeys[keyPrefix + "."] || [];                                                                      // 1146
	};                                                                                                                     // 1147
	                                                                                                                       // 1148
	SimpleSchema.prototype.validate = function (obj, options) {                                                            // 1149
	  if (Package.check && Package['audit-argument-checks']) {                                                             // 1150
	    // Call check but ignore the error to silence audit-argument-checks                                                // 1151
	    try { check(obj); } catch (e) { /* ignore error */ }                                                               // 1152
	  }                                                                                                                    // 1153
	                                                                                                                       // 1154
	  var validationContext = this.newContext();                                                                           // 1155
	  var isValid = validationContext.validate(obj, options);                                                              // 1156
	                                                                                                                       // 1157
	  if (isValid) return;                                                                                                 // 1158
	                                                                                                                       // 1159
	  var errors = validationContext.invalidKeys().map(function (error) {                                                  // 1160
	    return {                                                                                                           // 1161
	      name: error.name,                                                                                                // 1162
	      type: error.type,                                                                                                // 1163
	      details: {                                                                                                       // 1164
	        value: error.value                                                                                             // 1165
	      }                                                                                                                // 1166
	    };                                                                                                                 // 1167
	  });                                                                                                                  // 1168
	                                                                                                                       // 1169
	  // In order for the message at the top of the stack trace to be useful,                                              // 1170
	  // we set it to the first validation error message.                                                                  // 1171
	  var message = validationContext.keyErrorMessage(errors[0].name);                                                     // 1172
	                                                                                                                       // 1173
	  throw new Package['mdg:validation-error'].ValidationError(errors, message);                                          // 1174
	};                                                                                                                     // 1175
	                                                                                                                       // 1176
	SimpleSchema.prototype.validator = function (options) {                                                                // 1177
	  var self = this;                                                                                                     // 1178
	  options = options || {};                                                                                             // 1179
	  return function (obj) {                                                                                              // 1180
	    if (options.clean === true) self.clean(obj, options);                                                              // 1181
	    self.validate(obj);                                                                                                // 1182
	  };                                                                                                                   // 1183
	};                                                                                                                     // 1184
	                                                                                                                       // 1185
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// packages/aldeed_simple-schema/simple-schema-validation.js                                                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	/* global Utility */                                                                                                   // 1
	/* global _ */                                                                                                         // 2
	/* global SimpleSchema */                                                                                              // 3
	/* global MongoObject */                                                                                               // 4
	/* global doValidation1:true */                                                                                        // 5
	                                                                                                                       // 6
	function doTypeChecks(def, keyValue, op) {                                                                             // 7
	  var expectedType = def.type;                                                                                         // 8
	                                                                                                                       // 9
	  // String checks                                                                                                     // 10
	  if (expectedType === String) {                                                                                       // 11
	    if (typeof keyValue !== "string") {                                                                                // 12
	      return "expectedString";                                                                                         // 13
	    } else if (def.max !== null && def.max < keyValue.length) {                                                        // 14
	      return "maxString";                                                                                              // 15
	    } else if (def.min !== null && def.min > keyValue.length) {                                                        // 16
	      return "minString";                                                                                              // 17
	    } else if (def.regEx instanceof RegExp && !def.regEx.test(keyValue)) {                                             // 18
	      return "regEx";                                                                                                  // 19
	    } else if (_.isArray(def.regEx)) {                                                                                 // 20
	      var regExError;                                                                                                  // 21
	      _.every(def.regEx, function(re, i) {                                                                             // 22
	        if (!re.test(keyValue)) {                                                                                      // 23
	          regExError = "regEx." + i;                                                                                   // 24
	          return false;                                                                                                // 25
	        }                                                                                                              // 26
	        return true;                                                                                                   // 27
	      });                                                                                                              // 28
	      if (regExError) {                                                                                                // 29
	        return regExError;                                                                                             // 30
	      }                                                                                                                // 31
	    }                                                                                                                  // 32
	  }                                                                                                                    // 33
	                                                                                                                       // 34
	  // Number checks                                                                                                     // 35
	  else if (expectedType === Number) {                                                                                  // 36
	    if (typeof keyValue !== "number" || isNaN(keyValue)) {                                                             // 37
	      return "expectedNumber";                                                                                         // 38
	    } else if (op !== "$inc" && def.max !== null && (!!def.exclusiveMax ? def.max <= keyValue : def.max < keyValue)) {
	       return !!def.exclusiveMax ? "maxNumberExclusive" : "maxNumber";                                                 // 40
	    } else if (op !== "$inc" && def.min !== null && (!!def.exclusiveMin ? def.min >= keyValue : def.min > keyValue)) {
	       return !!def.exclusiveMin ? "minNumberExclusive" : "minNumber";                                                 // 42
	    } else if (!def.decimal && keyValue.toString().indexOf(".") > -1) {                                                // 43
	      return "noDecimal";                                                                                              // 44
	    }                                                                                                                  // 45
	  }                                                                                                                    // 46
	                                                                                                                       // 47
	  // Boolean checks                                                                                                    // 48
	  else if (expectedType === Boolean) {                                                                                 // 49
	    if (typeof keyValue !== "boolean") {                                                                               // 50
	      return "expectedBoolean";                                                                                        // 51
	    }                                                                                                                  // 52
	  }                                                                                                                    // 53
	                                                                                                                       // 54
	  // Object checks                                                                                                     // 55
	  else if (expectedType === Object) {                                                                                  // 56
	    if (!Utility.isBasicObject(keyValue)) {                                                                            // 57
	      return "expectedObject";                                                                                         // 58
	    }                                                                                                                  // 59
	  }                                                                                                                    // 60
	                                                                                                                       // 61
	  // Array checks                                                                                                      // 62
	  else if (expectedType === Array) {                                                                                   // 63
	    if (!_.isArray(keyValue)) {                                                                                        // 64
	      return "expectedArray";                                                                                          // 65
	    } else if (def.minCount !== null && keyValue.length < def.minCount) {                                              // 66
	      return "minCount";                                                                                               // 67
	    } else if (def.maxCount !== null && keyValue.length > def.maxCount) {                                              // 68
	      return "maxCount";                                                                                               // 69
	    }                                                                                                                  // 70
	  }                                                                                                                    // 71
	                                                                                                                       // 72
	  // Constructor function checks                                                                                       // 73
	  else if (expectedType instanceof Function || Utility.safariBugFix(expectedType)) {                                   // 74
	                                                                                                                       // 75
	    // Generic constructor checks                                                                                      // 76
	    if (!(keyValue instanceof expectedType)) {                                                                         // 77
	      return "expectedConstructor";                                                                                    // 78
	    }                                                                                                                  // 79
	                                                                                                                       // 80
	    // Date checks                                                                                                     // 81
	    else if (expectedType === Date) {                                                                                  // 82
	      if (isNaN(keyValue.getTime())) {                                                                                 // 83
	        return "badDate";                                                                                              // 84
	      }                                                                                                                // 85
	                                                                                                                       // 86
	      if (_.isDate(def.min) && def.min.getTime() > keyValue.getTime()) {                                               // 87
	        return "minDate";                                                                                              // 88
	      } else if (_.isDate(def.max) && def.max.getTime() < keyValue.getTime()) {                                        // 89
	        return "maxDate";                                                                                              // 90
	      }                                                                                                                // 91
	    }                                                                                                                  // 92
	  }                                                                                                                    // 93
	                                                                                                                       // 94
	}                                                                                                                      // 95
	                                                                                                                       // 96
	doValidation1 = function doValidation1(obj, isModifier, isUpsert, keyToValidate, ss, extendedCustomContext) {          // 97
	  // First do some basic checks of the object, and throw errors if necessary                                           // 98
	  if (!_.isObject(obj)) {                                                                                              // 99
	    throw new Error("The first argument of validate() or validateOne() must be an object");                            // 100
	  }                                                                                                                    // 101
	                                                                                                                       // 102
	  if (!isModifier && Utility.looksLikeModifier(obj)) {                                                                 // 103
	    throw new Error("When the validation object contains mongo operators, you must set the modifier option to true");  // 104
	  }                                                                                                                    // 105
	                                                                                                                       // 106
	  var invalidKeys = [];                                                                                                // 107
	  var mDoc; // for caching the MongoObject if necessary                                                                // 108
	                                                                                                                       // 109
	  // Validation function called for each affected key                                                                  // 110
	  function validate(val, affectedKey, affectedKeyGeneric, def, op, skipRequiredCheck, isInArrayItemObject, isInSubObject) {
	                                                                                                                       // 112
	    // Get the schema for this key, marking invalid if there isn't one.                                                // 113
	    if (!def) {                                                                                                        // 114
	      invalidKeys.push(Utility.errorObject("keyNotInSchema", affectedKey, val, def, ss));                              // 115
	      return;                                                                                                          // 116
	    }                                                                                                                  // 117
	                                                                                                                       // 118
	    // Check for missing required values. The general logic is this:                                                   // 119
	    // * If the operator is $unset or $rename, it's invalid.                                                           // 120
	    // * If the value is null, it's invalid.                                                                           // 121
	    // * If the value is undefined and one of the following are true, it's invalid:                                    // 122
	    //     * We're validating a key of a sub-object.                                                                   // 123
	    //     * We're validating a key of an object that is an array item.                                                // 124
	    //     * We're validating a document (as opposed to a modifier).                                                   // 125
	    //     * We're validating a key under the $set operator in a modifier, and it's an upsert.                         // 126
	    if (!skipRequiredCheck && !def.optional) {                                                                         // 127
	      if (                                                                                                             // 128
	        val === null ||                                                                                                // 129
	        op === "$unset" ||                                                                                             // 130
	        op === "$rename" ||                                                                                            // 131
	        (val === void 0 && (isInArrayItemObject || isInSubObject || !op || op === "$set"))                             // 132
	        ) {                                                                                                            // 133
	        invalidKeys.push(Utility.errorObject("required", affectedKey, null, def, ss));                                 // 134
	        return;                                                                                                        // 135
	      }                                                                                                                // 136
	    }                                                                                                                  // 137
	                                                                                                                       // 138
	    // For $rename, make sure that the new name is allowed by the schema                                               // 139
	    if (op === "$rename" && typeof val === "string" && !ss.allowsKey(val)) {                                           // 140
	      invalidKeys.push(Utility.errorObject("keyNotInSchema", val, null, null, ss));                                    // 141
	      return;                                                                                                          // 142
	    }                                                                                                                  // 143
	                                                                                                                       // 144
	    // Value checks are not necessary for null or undefined values                                                     // 145
	    // or for $unset or $rename values                                                                                 // 146
	    if (op !== "$unset" && op !== "$rename" && Utility.isNotNullOrUndefined(val)) {                                    // 147
	                                                                                                                       // 148
	      // Check that value is of the correct type                                                                       // 149
	      var typeError = doTypeChecks(def, val, op);                                                                      // 150
	      if (typeError) {                                                                                                 // 151
	        invalidKeys.push(Utility.errorObject(typeError, affectedKey, val, def, ss));                                   // 152
	        return;                                                                                                        // 153
	      }                                                                                                                // 154
	                                                                                                                       // 155
	      // Check value against allowedValues array                                                                       // 156
	      if (def.allowedValues && !_.contains(def.allowedValues, val)) {                                                  // 157
	        invalidKeys.push(Utility.errorObject("notAllowed", affectedKey, val, def, ss));                                // 158
	        return;                                                                                                        // 159
	      }                                                                                                                // 160
	                                                                                                                       // 161
	    }                                                                                                                  // 162
	                                                                                                                       // 163
	    // Perform custom validation                                                                                       // 164
	    var lastDot = affectedKey.lastIndexOf('.');                                                                        // 165
	    var fieldParentName = lastDot === -1 ? '' : affectedKey.slice(0, lastDot + 1);                                     // 166
	    var validators = def.custom ? [def.custom] : [];                                                                   // 167
	    validators = validators.concat(ss._validators).concat(SimpleSchema._validators);                                   // 168
	    _.every(validators, function(validator) {                                                                          // 169
	      var errorType = validator.call(_.extend({                                                                        // 170
	        key: affectedKey,                                                                                              // 171
	        genericKey: affectedKeyGeneric,                                                                                // 172
	        definition: def,                                                                                               // 173
	        isSet: (val !== void 0),                                                                                       // 174
	        value: val,                                                                                                    // 175
	        operator: op,                                                                                                  // 176
	        field: function(fName) {                                                                                       // 177
	          mDoc = mDoc || new MongoObject(obj, ss._blackboxKeys); //create if necessary, cache for speed                // 178
	          var keyInfo = mDoc.getInfoForKey(fName) || {};                                                               // 179
	          return {                                                                                                     // 180
	            isSet: (keyInfo.value !== void 0),                                                                         // 181
	            value: keyInfo.value,                                                                                      // 182
	            operator: keyInfo.operator                                                                                 // 183
	          };                                                                                                           // 184
	        },                                                                                                             // 185
	        siblingField: function(fName) {                                                                                // 186
	          mDoc = mDoc || new MongoObject(obj, ss._blackboxKeys); //create if necessary, cache for speed                // 187
	          var keyInfo = mDoc.getInfoForKey(fieldParentName + fName) || {};                                             // 188
	          return {                                                                                                     // 189
	            isSet: (keyInfo.value !== void 0),                                                                         // 190
	            value: keyInfo.value,                                                                                      // 191
	            operator: keyInfo.operator                                                                                 // 192
	          };                                                                                                           // 193
	        }                                                                                                              // 194
	      }, extendedCustomContext || {}));                                                                                // 195
	      if (typeof errorType === "string") {                                                                             // 196
	        invalidKeys.push(Utility.errorObject(errorType, affectedKey, val, def, ss));                                   // 197
	        return false;                                                                                                  // 198
	      }                                                                                                                // 199
	      return true;                                                                                                     // 200
	    });                                                                                                                // 201
	  }                                                                                                                    // 202
	                                                                                                                       // 203
	  // The recursive function                                                                                            // 204
	  function checkObj(val, affectedKey, operator, setKeys, isInArrayItemObject, isInSubObject) {                         // 205
	    var affectedKeyGeneric, def;                                                                                       // 206
	                                                                                                                       // 207
	    if (affectedKey) {                                                                                                 // 208
	      // When we hit a blackbox key, we don't progress any further                                                     // 209
	      if (ss.keyIsInBlackBox(affectedKey)) {                                                                           // 210
	        return;                                                                                                        // 211
	      }                                                                                                                // 212
	                                                                                                                       // 213
	      // Make a generic version of the affected key, and use that                                                      // 214
	      // to get the schema for this key.                                                                               // 215
	      affectedKeyGeneric = SimpleSchema._makeGeneric(affectedKey);                                                     // 216
	      def = ss.getDefinition(affectedKey);                                                                             // 217
	                                                                                                                       // 218
	      // Perform validation for this key                                                                               // 219
	      if (!keyToValidate || keyToValidate === affectedKey || keyToValidate === affectedKeyGeneric) {                   // 220
	        // We can skip the required check for keys that are ancestors                                                  // 221
	        // of those in $set or $setOnInsert because they will be created                                               // 222
	        // by MongoDB while setting.                                                                                   // 223
	        var skipRequiredCheck = _.some(setKeys, function(sk) {                                                         // 224
	          return (sk.slice(0, affectedKey.length + 1) === affectedKey + ".");                                          // 225
	        });                                                                                                            // 226
	        validate(val, affectedKey, affectedKeyGeneric, def, operator, skipRequiredCheck, isInArrayItemObject, isInSubObject);
	      }                                                                                                                // 228
	    }                                                                                                                  // 229
	                                                                                                                       // 230
	    // Temporarily convert missing objects to empty objects                                                            // 231
	    // so that the looping code will be called and required                                                            // 232
	    // descendent keys can be validated.                                                                               // 233
	    if ((val === void 0 || val === null) && (!def || (def.type === Object && !def.optional))) {                        // 234
	      val = {};                                                                                                        // 235
	    }                                                                                                                  // 236
	                                                                                                                       // 237
	    // Loop through arrays                                                                                             // 238
	    if (_.isArray(val)) {                                                                                              // 239
	      _.each(val, function(v, i) {                                                                                     // 240
	        checkObj(v, affectedKey + '.' + i, operator, setKeys);                                                         // 241
	      });                                                                                                              // 242
	    }                                                                                                                  // 243
	                                                                                                                       // 244
	    // Loop through object keys                                                                                        // 245
	    else if (Utility.isBasicObject(val) && (!def || !def.blackbox)) {                                                  // 246
	                                                                                                                       // 247
	      // Get list of present keys                                                                                      // 248
	      var presentKeys = _.keys(val);                                                                                   // 249
	                                                                                                                       // 250
	      // Check all present keys plus all keys defined by the schema.                                                   // 251
	      // This allows us to detect extra keys not allowed by the schema plus                                            // 252
	      // any missing required keys, and to run any custom functions for other keys.                                    // 253
	      var keysToCheck = _.union(presentKeys, ss.objectKeys(affectedKeyGeneric));                                       // 254
	                                                                                                                       // 255
	      // If this object is within an array, make sure we check for                                                     // 256
	      // required as if it's not a modifier                                                                            // 257
	      isInArrayItemObject = (affectedKeyGeneric && affectedKeyGeneric.slice(-2) === ".$");                             // 258
	                                                                                                                       // 259
	      // Check all keys in the merged list                                                                             // 260
	      _.each(keysToCheck, function(key) {                                                                              // 261
	        checkObj(val[key], Utility.appendAffectedKey(affectedKey, key), operator, setKeys, isInArrayItemObject, true);
	      });                                                                                                              // 263
	    }                                                                                                                  // 264
	                                                                                                                       // 265
	  }                                                                                                                    // 266
	                                                                                                                       // 267
	  function checkModifier(mod) {                                                                                        // 268
	    // Check for empty modifier                                                                                        // 269
	    if (_.isEmpty(mod)) {                                                                                              // 270
	      throw new Error("When the modifier option is true, validation object must have at least one operator");          // 271
	    }                                                                                                                  // 272
	                                                                                                                       // 273
	    // Get a list of all keys in $set and $setOnInsert combined, for use later                                         // 274
	    var setKeys = _.keys(mod.$set || {}).concat(_.keys(mod.$setOnInsert || {}));                                       // 275
	                                                                                                                       // 276
	    // If this is an upsert, add all the $setOnInsert keys to $set;                                                    // 277
	    // since we don't know whether it will be an insert or update, we'll                                               // 278
	    // validate upserts as if they will be an insert.                                                                  // 279
	    if ("$setOnInsert" in mod) {                                                                                       // 280
	      if (isUpsert) {                                                                                                  // 281
	        mod.$set = mod.$set || {};                                                                                     // 282
	        mod.$set = _.extend(mod.$set, mod.$setOnInsert);                                                               // 283
	      }                                                                                                                // 284
	      delete mod.$setOnInsert;                                                                                         // 285
	    }                                                                                                                  // 286
	                                                                                                                       // 287
	    // Loop through operators                                                                                          // 288
	    _.each(mod, function (opObj, op) {                                                                                 // 289
	      // If non-operators are mixed in, throw error                                                                    // 290
	      if (op.slice(0, 1) !== "$") {                                                                                    // 291
	        throw new Error("When the modifier option is true, all validation object keys must be operators. Did you forget `$set`?");
	      }                                                                                                                // 293
	      if (Utility.shouldCheck(op)) {                                                                                   // 294
	        // For an upsert, missing props would not be set if an insert is performed,                                    // 295
	        // so we add null keys to the modifier to force any "required" checks to fail                                  // 296
	        if (isUpsert && op === "$set") {                                                                               // 297
	          var presentKeys = _.keys(opObj);                                                                             // 298
	          _.each(ss.objectKeys(), function (schemaKey) {                                                               // 299
	            if (!_.contains(presentKeys, schemaKey)) {                                                                 // 300
	              checkObj(void 0, schemaKey, op, setKeys);                                                                // 301
	            }                                                                                                          // 302
	          });                                                                                                          // 303
	        }                                                                                                              // 304
	        _.each(opObj, function (v, k) {                                                                                // 305
	          if (op === "$push" || op === "$addToSet") {                                                                  // 306
	            if (Utility.isBasicObject(v) && "$each" in v) {                                                            // 307
	              v = v.$each;                                                                                             // 308
	            } else {                                                                                                   // 309
	              k = k + ".0";                                                                                            // 310
	            }                                                                                                          // 311
	          }                                                                                                            // 312
	          checkObj(v, k, op, setKeys);                                                                                 // 313
	        });                                                                                                            // 314
	      }                                                                                                                // 315
	    });                                                                                                                // 316
	  }                                                                                                                    // 317
	                                                                                                                       // 318
	  // Kick off the validation                                                                                           // 319
	  if (isModifier) {                                                                                                    // 320
	    checkModifier(obj);                                                                                                // 321
	  } else {                                                                                                             // 322
	    checkObj(obj);                                                                                                     // 323
	  }                                                                                                                    // 324
	                                                                                                                       // 325
	  // Make sure there is only one error per fieldName                                                                   // 326
	  var addedFieldNames = [];                                                                                            // 327
	  invalidKeys = _.filter(invalidKeys, function(errObj) {                                                               // 328
	    if (!_.contains(addedFieldNames, errObj.name)) {                                                                   // 329
	      addedFieldNames.push(errObj.name);                                                                               // 330
	      return true;                                                                                                     // 331
	    }                                                                                                                  // 332
	    return false;                                                                                                      // 333
	  });                                                                                                                  // 334
	                                                                                                                       // 335
	  return invalidKeys;                                                                                                  // 336
	};                                                                                                                     // 337
	                                                                                                                       // 338
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// packages/aldeed_simple-schema/simple-schema-validation-new.js                                                       //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	/* global Utility */                                                                                                   // 1
	/* global _ */                                                                                                         // 2
	/* global SimpleSchema */                                                                                              // 3
	/* global MongoObject */                                                                                               // 4
	/* global Meteor */                                                                                                    // 5
	/* global Random */                                                                                                    // 6
	/* global doValidation2:true */                                                                                        // 7
	                                                                                                                       // 8
	function doTypeChecks(def, keyValue, op) {                                                                             // 9
	  var expectedType = def.type;                                                                                         // 10
	                                                                                                                       // 11
	  // String checks                                                                                                     // 12
	  if (expectedType === String) {                                                                                       // 13
	    if (typeof keyValue !== "string") {                                                                                // 14
	      return "expectedString";                                                                                         // 15
	    } else if (def.max !== null && def.max < keyValue.length) {                                                        // 16
	      return "maxString";                                                                                              // 17
	    } else if (def.min !== null && def.min > keyValue.length) {                                                        // 18
	      return "minString";                                                                                              // 19
	    } else if (def.regEx instanceof RegExp && !def.regEx.test(keyValue)) {                                             // 20
	      return "regEx";                                                                                                  // 21
	    } else if (_.isArray(def.regEx)) {                                                                                 // 22
	      var regExError;                                                                                                  // 23
	      _.every(def.regEx, function(re, i) {                                                                             // 24
	        if (!re.test(keyValue)) {                                                                                      // 25
	          regExError = "regEx." + i;                                                                                   // 26
	          return false;                                                                                                // 27
	        }                                                                                                              // 28
	        return true;                                                                                                   // 29
	      });                                                                                                              // 30
	      if (regExError) {                                                                                                // 31
	        return regExError;                                                                                             // 32
	      }                                                                                                                // 33
	    }                                                                                                                  // 34
	  }                                                                                                                    // 35
	                                                                                                                       // 36
	  // Number checks                                                                                                     // 37
	  else if (expectedType === Number) {                                                                                  // 38
	    if (typeof keyValue !== "number" || isNaN(keyValue)) {                                                             // 39
	      return "expectedNumber";                                                                                         // 40
	    } else if (op !== "$inc" && def.max !== null && (!!def.exclusiveMax ? def.max <= keyValue : def.max < keyValue)) {
	       return !!def.exclusiveMax ? "maxNumberExclusive" : "maxNumber";                                                 // 42
	    } else if (op !== "$inc" && def.min !== null && (!!def.exclusiveMin ? def.min >= keyValue : def.min > keyValue)) {
	       return !!def.exclusiveMin ? "minNumberExclusive" : "minNumber";                                                 // 44
	    } else if (!def.decimal && keyValue.toString().indexOf(".") > -1) {                                                // 45
	      return "noDecimal";                                                                                              // 46
	    }                                                                                                                  // 47
	  }                                                                                                                    // 48
	                                                                                                                       // 49
	  // Boolean checks                                                                                                    // 50
	  else if (expectedType === Boolean) {                                                                                 // 51
	    if (typeof keyValue !== "boolean") {                                                                               // 52
	      return "expectedBoolean";                                                                                        // 53
	    }                                                                                                                  // 54
	  }                                                                                                                    // 55
	                                                                                                                       // 56
	  // Object checks                                                                                                     // 57
	  else if (expectedType === Object) {                                                                                  // 58
	    if (!Utility.isBasicObject(keyValue)) {                                                                            // 59
	      return "expectedObject";                                                                                         // 60
	    }                                                                                                                  // 61
	  }                                                                                                                    // 62
	                                                                                                                       // 63
	  // Array checks                                                                                                      // 64
	  else if (expectedType === Array) {                                                                                   // 65
	    if (!_.isArray(keyValue)) {                                                                                        // 66
	      return "expectedArray";                                                                                          // 67
	    } else if (def.minCount !== null && keyValue.length < def.minCount) {                                              // 68
	      return "minCount";                                                                                               // 69
	    } else if (def.maxCount !== null && keyValue.length > def.maxCount) {                                              // 70
	      return "maxCount";                                                                                               // 71
	    }                                                                                                                  // 72
	  }                                                                                                                    // 73
	                                                                                                                       // 74
	  // Constructor function checks                                                                                       // 75
	  else if (expectedType instanceof Function || Utility.safariBugFix(expectedType)) {                                   // 76
	                                                                                                                       // 77
	    // Generic constructor checks                                                                                      // 78
	    if (!(keyValue instanceof expectedType)) {                                                                         // 79
	      return "expectedConstructor";                                                                                    // 80
	    }                                                                                                                  // 81
	                                                                                                                       // 82
	    // Date checks                                                                                                     // 83
	    else if (expectedType === Date) {                                                                                  // 84
	      if (isNaN(keyValue.getTime())) {                                                                                 // 85
	        return "badDate";                                                                                              // 86
	      }                                                                                                                // 87
	                                                                                                                       // 88
	      if (_.isDate(def.min) && def.min.getTime() > keyValue.getTime()) {                                               // 89
	        return "minDate";                                                                                              // 90
	      } else if (_.isDate(def.max) && def.max.getTime() < keyValue.getTime()) {                                        // 91
	        return "maxDate";                                                                                              // 92
	      }                                                                                                                // 93
	    }                                                                                                                  // 94
	  }                                                                                                                    // 95
	                                                                                                                       // 96
	}                                                                                                                      // 97
	                                                                                                                       // 98
	doValidation2 = function doValidation2(obj, isModifier, isUpsert, keyToValidate, ss, extendedCustomContext) {          // 99
	                                                                                                                       // 100
	  // First do some basic checks of the object, and throw errors if necessary                                           // 101
	  if (!_.isObject(obj)) {                                                                                              // 102
	    throw new Error("The first argument of validate() or validateOne() must be an object");                            // 103
	  }                                                                                                                    // 104
	                                                                                                                       // 105
	  if (isModifier) {                                                                                                    // 106
	    if (_.isEmpty(obj)) {                                                                                              // 107
	      throw new Error("When the modifier option is true, validation object must have at least one operator");          // 108
	    } else {                                                                                                           // 109
	      var allKeysAreOperators = _.every(obj, function(v, k) {                                                          // 110
	        return (k.substring(0, 1) === "$");                                                                            // 111
	      });                                                                                                              // 112
	      if (!allKeysAreOperators) {                                                                                      // 113
	        throw new Error("When the modifier option is true, all validation object keys must be operators");             // 114
	      }                                                                                                                // 115
	                                                                                                                       // 116
	      // We use a LocalCollection to figure out what the resulting doc                                                 // 117
	      // would be in a worst case scenario. Then we validate that doc                                                  // 118
	      // so that we don't have to validate the modifier object directly.                                               // 119
	      obj = convertModifierToDoc(obj, ss.schema(), isUpsert);                                                          // 120
	    }                                                                                                                  // 121
	  } else if (Utility.looksLikeModifier(obj)) {                                                                         // 122
	    throw new Error("When the validation object contains mongo operators, you must set the modifier option to true");  // 123
	  }                                                                                                                    // 124
	                                                                                                                       // 125
	  var invalidKeys = [];                                                                                                // 126
	  var mDoc; // for caching the MongoObject if necessary                                                                // 127
	                                                                                                                       // 128
	  // Validation function called for each affected key                                                                  // 129
	  function validate(val, affectedKey, affectedKeyGeneric, def, op, skipRequiredCheck, strictRequiredCheck) {           // 130
	                                                                                                                       // 131
	    // Get the schema for this key, marking invalid if there isn't one.                                                // 132
	    if (!def) {                                                                                                        // 133
	      invalidKeys.push(Utility.errorObject("keyNotInSchema", affectedKey, val, def, ss));                              // 134
	      return;                                                                                                          // 135
	    }                                                                                                                  // 136
	                                                                                                                       // 137
	    // Check for missing required values. The general logic is this:                                                   // 138
	    // * If the operator is $unset or $rename, it's invalid.                                                           // 139
	    // * If the value is null, it's invalid.                                                                           // 140
	    // * If the value is undefined and one of the following are true, it's invalid:                                    // 141
	    //     * We're validating a key of a sub-object.                                                                   // 142
	    //     * We're validating a key of an object that is an array item.                                                // 143
	    //     * We're validating a document (as opposed to a modifier).                                                   // 144
	    //     * We're validating a key under the $set operator in a modifier, and it's an upsert.                         // 145
	    if (!skipRequiredCheck && !def.optional) {                                                                         // 146
	      if (val === null || val === void 0) {                                                                            // 147
	        invalidKeys.push(Utility.errorObject("required", affectedKey, null, def, ss));                                 // 148
	        return;                                                                                                        // 149
	      }                                                                                                                // 150
	    }                                                                                                                  // 151
	                                                                                                                       // 152
	    // Value checks are not necessary for null or undefined values                                                     // 153
	    if (Utility.isNotNullOrUndefined(val)) {                                                                           // 154
	                                                                                                                       // 155
	      // Check that value is of the correct type                                                                       // 156
	      var typeError = doTypeChecks(def, val, op);                                                                      // 157
	      if (typeError) {                                                                                                 // 158
	        invalidKeys.push(Utility.errorObject(typeError, affectedKey, val, def, ss));                                   // 159
	        return;                                                                                                        // 160
	      }                                                                                                                // 161
	                                                                                                                       // 162
	      // Check value against allowedValues array                                                                       // 163
	      if (def.allowedValues && !_.contains(def.allowedValues, val)) {                                                  // 164
	        invalidKeys.push(Utility.errorObject("notAllowed", affectedKey, val, def, ss));                                // 165
	        return;                                                                                                        // 166
	      }                                                                                                                // 167
	                                                                                                                       // 168
	    }                                                                                                                  // 169
	                                                                                                                       // 170
	    // Perform custom validation                                                                                       // 171
	    var lastDot = affectedKey.lastIndexOf('.');                                                                        // 172
	    var fieldParentName = lastDot === -1 ? '' : affectedKey.slice(0, lastDot + 1);                                     // 173
	    var validators = def.custom ? [def.custom] : [];                                                                   // 174
	    validators = validators.concat(ss._validators).concat(SimpleSchema._validators);                                   // 175
	    _.every(validators, function(validator) {                                                                          // 176
	      var errorType = validator.call(_.extend({                                                                        // 177
	        key: affectedKey,                                                                                              // 178
	        genericKey: affectedKeyGeneric,                                                                                // 179
	        definition: def,                                                                                               // 180
	        isSet: (val !== void 0),                                                                                       // 181
	        value: val,                                                                                                    // 182
	        operator: op,                                                                                                  // 183
	        field: function(fName) {                                                                                       // 184
	          mDoc = mDoc || new MongoObject(obj, ss._blackboxKeys); //create if necessary, cache for speed                // 185
	          var keyInfo = mDoc.getInfoForKey(fName) || {};                                                               // 186
	          return {                                                                                                     // 187
	            isSet: (keyInfo.value !== void 0),                                                                         // 188
	            value: keyInfo.value,                                                                                      // 189
	            operator: keyInfo.operator                                                                                 // 190
	          };                                                                                                           // 191
	        },                                                                                                             // 192
	        siblingField: function(fName) {                                                                                // 193
	          mDoc = mDoc || new MongoObject(obj, ss._blackboxKeys); //create if necessary, cache for speed                // 194
	          var keyInfo = mDoc.getInfoForKey(fieldParentName + fName) || {};                                             // 195
	          return {                                                                                                     // 196
	            isSet: (keyInfo.value !== void 0),                                                                         // 197
	            value: keyInfo.value,                                                                                      // 198
	            operator: keyInfo.operator                                                                                 // 199
	          };                                                                                                           // 200
	        }                                                                                                              // 201
	      }, extendedCustomContext || {}));                                                                                // 202
	      if (typeof errorType === "string") {                                                                             // 203
	        invalidKeys.push(Utility.errorObject(errorType, affectedKey, val, def, ss));                                   // 204
	        return false;                                                                                                  // 205
	      }                                                                                                                // 206
	      return true;                                                                                                     // 207
	    });                                                                                                                // 208
	  }                                                                                                                    // 209
	                                                                                                                       // 210
	  // The recursive function                                                                                            // 211
	  function checkObj(val, affectedKey, skipRequiredCheck, strictRequiredCheck) {                                        // 212
	    var affectedKeyGeneric, def;                                                                                       // 213
	                                                                                                                       // 214
	    if (affectedKey) {                                                                                                 // 215
	                                                                                                                       // 216
	      // When we hit a blackbox key, we don't progress any further                                                     // 217
	      if (ss.keyIsInBlackBox(affectedKey)) {                                                                           // 218
	        return;                                                                                                        // 219
	      }                                                                                                                // 220
	                                                                                                                       // 221
	      // Make a generic version of the affected key, and use that                                                      // 222
	      // to get the schema for this key.                                                                               // 223
	      affectedKeyGeneric = SimpleSchema._makeGeneric(affectedKey);                                                     // 224
	      def = ss.getDefinition(affectedKey);                                                                             // 225
	                                                                                                                       // 226
	      // Perform validation for this key                                                                               // 227
	      if (!keyToValidate || keyToValidate === affectedKey || keyToValidate === affectedKeyGeneric) {                   // 228
	        validate(val, affectedKey, affectedKeyGeneric, def, null, skipRequiredCheck, strictRequiredCheck);             // 229
	      }                                                                                                                // 230
	    }                                                                                                                  // 231
	                                                                                                                       // 232
	    // Temporarily convert missing objects to empty objects                                                            // 233
	    // so that the looping code will be called and required                                                            // 234
	    // descendent keys can be validated.                                                                               // 235
	    if ((val === void 0 || val === null) && (!def || (def.type === Object && !def.optional))) {                        // 236
	      val = {};                                                                                                        // 237
	    }                                                                                                                  // 238
	                                                                                                                       // 239
	    // Loop through arrays                                                                                             // 240
	    if (_.isArray(val)) {                                                                                              // 241
	      _.each(val, function(v, i) {                                                                                     // 242
	        checkObj(v, affectedKey + '.' + i);                                                                            // 243
	      });                                                                                                              // 244
	    }                                                                                                                  // 245
	                                                                                                                       // 246
	    // Loop through object keys                                                                                        // 247
	    else if (Utility.isBasicObject(val) && (!def || !def.blackbox)) {                                                  // 248
	                                                                                                                       // 249
	      // Get list of present keys                                                                                      // 250
	      var presentKeys = _.keys(val);                                                                                   // 251
	                                                                                                                       // 252
	      // Check all present keys plus all keys defined by the schema.                                                   // 253
	      // This allows us to detect extra keys not allowed by the schema plus                                            // 254
	      // any missing required keys, and to run any custom functions for other keys.                                    // 255
	      var keysToCheck = _.union(presentKeys, ss._schemaKeys);                                                          // 256
	                                                                                                                       // 257
	      // If this object is within an array, make sure we check for                                                     // 258
	      // required as if it's not a modifier                                                                            // 259
	      strictRequiredCheck = (affectedKeyGeneric && affectedKeyGeneric.slice(-2) === ".$");                             // 260
	                                                                                                                       // 261
	      // Check all keys in the merged list                                                                             // 262
	      _.each(keysToCheck, function(key) {                                                                              // 263
	        if (Utility.shouldCheck(key)) {                                                                                // 264
	          checkObj(val[key], Utility.appendAffectedKey(affectedKey, key), skipRequiredCheck, strictRequiredCheck);     // 265
	        }                                                                                                              // 266
	      });                                                                                                              // 267
	    }                                                                                                                  // 268
	                                                                                                                       // 269
	  }                                                                                                                    // 270
	                                                                                                                       // 271
	  // Kick off the validation                                                                                           // 272
	  checkObj(obj);                                                                                                       // 273
	                                                                                                                       // 274
	  // Make sure there is only one error per fieldName                                                                   // 275
	  var addedFieldNames = [];                                                                                            // 276
	  invalidKeys = _.filter(invalidKeys, function(errObj) {                                                               // 277
	    if (!_.contains(addedFieldNames, errObj.name)) {                                                                   // 278
	      addedFieldNames.push(errObj.name);                                                                               // 279
	      return true;                                                                                                     // 280
	    }                                                                                                                  // 281
	    return false;                                                                                                      // 282
	  });                                                                                                                  // 283
	                                                                                                                       // 284
	  return invalidKeys;                                                                                                  // 285
	};                                                                                                                     // 286
	                                                                                                                       // 287
	function convertModifierToDoc(mod, schema, isUpsert) {                                                                 // 288
	  // Create unmanaged LocalCollection as scratchpad                                                                    // 289
	  var t = new Meteor.Collection(null);                                                                                 // 290
	                                                                                                                       // 291
	  // LocalCollections are in memory, and it seems                                                                      // 292
	  // that it's fine to use them synchronously on                                                                       // 293
	  // either client or server                                                                                           // 294
	  var id;                                                                                                              // 295
	  if (isUpsert) {                                                                                                      // 296
	    // We assume upserts will be inserts (conservative                                                                 // 297
	    // validation of requiredness)                                                                                     // 298
	    id = Random.id();                                                                                                  // 299
	    t.upsert({_id: id}, mod);                                                                                          // 300
	  } else {                                                                                                             // 301
	    var mDoc = new MongoObject(mod);                                                                                   // 302
	    // Create a ficticious existing document                                                                           // 303
	    var fakeDoc = new MongoObject({});                                                                                 // 304
	    _.each(schema, function (def, fieldName) {                                                                         // 305
	      var setVal;                                                                                                      // 306
	      // Prefill doc with empty arrays to avoid the                                                                    // 307
	      // mongodb issue where it does not understand                                                                    // 308
	      // that numeric pieces should create arrays.                                                                     // 309
	      if (def.type === Array && mDoc.affectsGenericKey(fieldName)) {                                                   // 310
	        setVal = [];                                                                                                   // 311
	      }                                                                                                                // 312
	      // Set dummy values for required fields because                                                                  // 313
	      // we assume any existing data would be valid.                                                                   // 314
	      else if (!def.optional) {                                                                                        // 315
	        // TODO correct value type based on schema type                                                                // 316
	        if (def.type === Boolean) {                                                                                    // 317
	          setVal = true;                                                                                               // 318
	        } else if (def.type === Number) {                                                                              // 319
	          setVal = def.min || 0;                                                                                       // 320
	        } else if (def.type === Date) {                                                                                // 321
	          setVal = def.min || new Date();                                                                              // 322
	        } else if (def.type === Array) {                                                                               // 323
	          setVal = [];                                                                                                 // 324
	        } else if (def.type === Object) {                                                                              // 325
	          setVal = {};                                                                                                 // 326
	        } else {                                                                                                       // 327
	          setVal = "0";                                                                                                // 328
	        }                                                                                                              // 329
	      }                                                                                                                // 330
	                                                                                                                       // 331
	      if (setVal !== void 0) {                                                                                         // 332
	        var key = fieldName.replace(/\.\$/g, ".0");                                                                    // 333
	        var pos = MongoObject._keyToPosition(key, false);                                                              // 334
	        fakeDoc.setValueForPosition(pos, setVal);                                                                      // 335
	      }                                                                                                                // 336
	    });                                                                                                                // 337
	    fakeDoc = fakeDoc.getObject();                                                                                     // 338
	    // Insert fake doc into local scratch collection                                                                   // 339
	    id = t.insert(fakeDoc);                                                                                            // 340
	    // Now update it with the modifier                                                                                 // 341
	    t.update(id, mod);                                                                                                 // 342
	  }                                                                                                                    // 343
	                                                                                                                       // 344
	  var doc = t.findOne(id);                                                                                             // 345
	  // We're done with it                                                                                                // 346
	  t.remove(id);                                                                                                        // 347
	  // Currently we don't validate _id unless it is                                                                      // 348
	  // explicitly added to the schema                                                                                    // 349
	  if (!schema._id) {                                                                                                   // 350
	    delete doc._id;                                                                                                    // 351
	  }                                                                                                                    // 352
	  return doc;                                                                                                          // 353
	}                                                                                                                      // 354
	                                                                                                                       // 355
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// packages/aldeed_simple-schema/simple-schema-context.js                                                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	/* global SimpleSchema */                                                                                              // 1
	/* global SimpleSchemaValidationContext:true */                                                                        // 2
	/* global doValidation1 */                                                                                             // 3
	/* global doValidation2 */                                                                                             // 4
	                                                                                                                       // 5
	function doValidation(obj, isModifier, isUpsert, keyToValidate, ss, extendedCustomContext) {                           // 6
	  var useOld = true; //for now this can be manually changed to try the experimental method, which doesn't yet work properly
	  var func = useOld ? doValidation1 : doValidation2;                                                                   // 8
	  return func(obj, isModifier, isUpsert, keyToValidate, ss, extendedCustomContext);                                    // 9
	}                                                                                                                      // 10
	                                                                                                                       // 11
	/*                                                                                                                     // 12
	 * PUBLIC API                                                                                                          // 13
	 */                                                                                                                    // 14
	                                                                                                                       // 15
	SimpleSchemaValidationContext = function SimpleSchemaValidationContext(ss) {                                           // 16
	  var self = this;                                                                                                     // 17
	  self._simpleSchema = ss;                                                                                             // 18
	  self._schema = ss.schema();                                                                                          // 19
	  self._schemaKeys = _.keys(self._schema);                                                                             // 20
	  self._invalidKeys = [];                                                                                              // 21
	  //set up validation dependencies                                                                                     // 22
	  self._deps = {};                                                                                                     // 23
	  self._depsAny = new Deps.Dependency();                                                                               // 24
	  _.each(self._schemaKeys, function(name) {                                                                            // 25
	    self._deps[name] = new Deps.Dependency();                                                                          // 26
	  });                                                                                                                  // 27
	};                                                                                                                     // 28
	                                                                                                                       // 29
	//validates the object against the simple schema and sets a reactive array of error objects                            // 30
	SimpleSchemaValidationContext.prototype.validate = function simpleSchemaValidationContextValidate(doc, options) {      // 31
	  var self = this;                                                                                                     // 32
	  options = _.extend({                                                                                                 // 33
	    modifier: false,                                                                                                   // 34
	    upsert: false,                                                                                                     // 35
	    extendedCustomContext: {}                                                                                          // 36
	  }, options || {});                                                                                                   // 37
	                                                                                                                       // 38
	  //on the client we can add the userId if not already in the custom context                                           // 39
	  if (Meteor.isClient && options.extendedCustomContext.userId === void 0) {                                            // 40
	    options.extendedCustomContext.userId = (Meteor.userId && Meteor.userId()) || null;                                 // 41
	  }                                                                                                                    // 42
	                                                                                                                       // 43
	  var invalidKeys = doValidation(doc, options.modifier, options.upsert, null, self._simpleSchema, options.extendedCustomContext);
	                                                                                                                       // 45
	  //now update self._invalidKeys and dependencies                                                                      // 46
	                                                                                                                       // 47
	  //note any currently invalid keys so that we can mark them as changed                                                // 48
	  //due to new validation (they may be valid now, or invalid in a different way)                                       // 49
	  var removedKeys = _.pluck(self._invalidKeys, "name");                                                                // 50
	                                                                                                                       // 51
	  //update                                                                                                             // 52
	  self._invalidKeys = invalidKeys;                                                                                     // 53
	                                                                                                                       // 54
	  //add newly invalid keys to changedKeys                                                                              // 55
	  var addedKeys = _.pluck(self._invalidKeys, "name");                                                                  // 56
	                                                                                                                       // 57
	  //mark all changed keys as changed                                                                                   // 58
	  var changedKeys = _.union(addedKeys, removedKeys);                                                                   // 59
	  self._markKeysChanged(changedKeys);                                                                                  // 60
	                                                                                                                       // 61
	  // Return true if it was valid; otherwise, return false                                                              // 62
	  return self._invalidKeys.length === 0;                                                                               // 63
	};                                                                                                                     // 64
	                                                                                                                       // 65
	//validates doc against self._schema for one key and sets a reactive array of error objects                            // 66
	SimpleSchemaValidationContext.prototype.validateOne = function simpleSchemaValidationContextValidateOne(doc, keyName, options) {
	  var self = this, i, ln, k;                                                                                           // 68
	  options = _.extend({                                                                                                 // 69
	    modifier: false,                                                                                                   // 70
	    upsert: false,                                                                                                     // 71
	    extendedCustomContext: {}                                                                                          // 72
	  }, options || {});                                                                                                   // 73
	                                                                                                                       // 74
	  //on the client we can add the userId if not already in the custom context                                           // 75
	  if (Meteor.isClient && options.extendedCustomContext.userId === void 0) {                                            // 76
	    options.extendedCustomContext.userId = (Meteor.userId && Meteor.userId()) || null;                                 // 77
	  }                                                                                                                    // 78
	                                                                                                                       // 79
	  var invalidKeys = doValidation(doc, options.modifier, options.upsert, keyName, self._simpleSchema, options.extendedCustomContext);
	                                                                                                                       // 81
	  //now update self._invalidKeys and dependencies                                                                      // 82
	                                                                                                                       // 83
	  //remove objects from self._invalidKeys where name = keyName                                                         // 84
	  var newInvalidKeys = [];                                                                                             // 85
	  for (i = 0, ln = self._invalidKeys.length; i < ln; i++) {                                                            // 86
	    k = self._invalidKeys[i];                                                                                          // 87
	    if (k.name !== keyName) {                                                                                          // 88
	      newInvalidKeys.push(k);                                                                                          // 89
	    }                                                                                                                  // 90
	  }                                                                                                                    // 91
	  self._invalidKeys = newInvalidKeys;                                                                                  // 92
	                                                                                                                       // 93
	  //merge invalidKeys into self._invalidKeys                                                                           // 94
	  for (i = 0, ln = invalidKeys.length; i < ln; i++) {                                                                  // 95
	    k = invalidKeys[i];                                                                                                // 96
	    self._invalidKeys.push(k);                                                                                         // 97
	  }                                                                                                                    // 98
	                                                                                                                       // 99
	  //mark key as changed due to new validation (they may be valid now, or invalid in a different way)                   // 100
	  self._markKeysChanged([keyName]);                                                                                    // 101
	                                                                                                                       // 102
	  // Return true if it was valid; otherwise, return false                                                              // 103
	  return !self._keyIsInvalid(keyName);                                                                                 // 104
	};                                                                                                                     // 105
	                                                                                                                       // 106
	//reset the invalidKeys array                                                                                          // 107
	SimpleSchemaValidationContext.prototype.resetValidation = function simpleSchemaValidationContextResetValidation() {    // 108
	  var self = this;                                                                                                     // 109
	  var removedKeys = _.pluck(self._invalidKeys, "name");                                                                // 110
	  self._invalidKeys = [];                                                                                              // 111
	  self._markKeysChanged(removedKeys);                                                                                  // 112
	};                                                                                                                     // 113
	                                                                                                                       // 114
	SimpleSchemaValidationContext.prototype.isValid = function simpleSchemaValidationContextIsValid() {                    // 115
	  var self = this;                                                                                                     // 116
	  self._depsAny.depend();                                                                                              // 117
	  return !self._invalidKeys.length;                                                                                    // 118
	};                                                                                                                     // 119
	                                                                                                                       // 120
	SimpleSchemaValidationContext.prototype.invalidKeys = function simpleSchemaValidationContextInvalidKeys() {            // 121
	  var self = this;                                                                                                     // 122
	  self._depsAny.depend();                                                                                              // 123
	  return self._invalidKeys;                                                                                            // 124
	};                                                                                                                     // 125
	                                                                                                                       // 126
	SimpleSchemaValidationContext.prototype.addInvalidKeys = function simpleSchemaValidationContextAddInvalidKeys(errors) {
	  var self = this;                                                                                                     // 128
	                                                                                                                       // 129
	  if (!errors || !errors.length) {                                                                                     // 130
	    return;                                                                                                            // 131
	  }                                                                                                                    // 132
	                                                                                                                       // 133
	  var changedKeys = [];                                                                                                // 134
	  _.each(errors, function (errorObject) {                                                                              // 135
	    changedKeys.push(errorObject.name);                                                                                // 136
	    self._invalidKeys.push(errorObject);                                                                               // 137
	  });                                                                                                                  // 138
	                                                                                                                       // 139
	  self._markKeysChanged(changedKeys);                                                                                  // 140
	};                                                                                                                     // 141
	                                                                                                                       // 142
	SimpleSchemaValidationContext.prototype._markKeysChanged = function simpleSchemaValidationContextMarkKeysChanged(keys) {
	  var self = this;                                                                                                     // 144
	                                                                                                                       // 145
	  if (!keys || !keys.length) {                                                                                         // 146
	    return;                                                                                                            // 147
	  }                                                                                                                    // 148
	                                                                                                                       // 149
	  _.each(keys, function(name) {                                                                                        // 150
	    var genericName = SimpleSchema._makeGeneric(name);                                                                 // 151
	    if (genericName in self._deps) {                                                                                   // 152
	      self._deps[genericName].changed();                                                                               // 153
	    }                                                                                                                  // 154
	  });                                                                                                                  // 155
	  self._depsAny.changed();                                                                                             // 156
	};                                                                                                                     // 157
	                                                                                                                       // 158
	SimpleSchemaValidationContext.prototype._getInvalidKeyObject = function simpleSchemaValidationContextGetInvalidKeyObject(name, genericName) {
	  var self = this;                                                                                                     // 160
	  genericName = genericName || SimpleSchema._makeGeneric(name);                                                        // 161
	                                                                                                                       // 162
	  var errorObj = _.findWhere(self._invalidKeys, {name: name});                                                         // 163
	  if (!errorObj) {                                                                                                     // 164
	    errorObj = _.findWhere(self._invalidKeys, {name: genericName});                                                    // 165
	  }                                                                                                                    // 166
	  return errorObj;                                                                                                     // 167
	};                                                                                                                     // 168
	                                                                                                                       // 169
	SimpleSchemaValidationContext.prototype._keyIsInvalid = function simpleSchemaValidationContextKeyIsInvalid(name, genericName) {
	  return !!this._getInvalidKeyObject(name, genericName);                                                               // 171
	};                                                                                                                     // 172
	                                                                                                                       // 173
	// Like the internal one, but with deps                                                                                // 174
	SimpleSchemaValidationContext.prototype.keyIsInvalid = function simpleSchemaValidationContextKeyIsInvalid(name) {      // 175
	  var self = this, genericName = SimpleSchema._makeGeneric(name);                                                      // 176
	  self._deps[genericName] && self._deps[genericName].depend();                                                         // 177
	                                                                                                                       // 178
	  return self._keyIsInvalid(name, genericName);                                                                        // 179
	};                                                                                                                     // 180
	                                                                                                                       // 181
	SimpleSchemaValidationContext.prototype.keyErrorMessage = function simpleSchemaValidationContextKeyErrorMessage(name) {
	  var self = this, genericName = SimpleSchema._makeGeneric(name);                                                      // 183
	  self._deps[genericName] && self._deps[genericName].depend();                                                         // 184
	                                                                                                                       // 185
	  var errorObj = self._getInvalidKeyObject(name, genericName);                                                         // 186
	  if (!errorObj) {                                                                                                     // 187
	    return "";                                                                                                         // 188
	  }                                                                                                                    // 189
	                                                                                                                       // 190
	  return self._simpleSchema.messageForError(errorObj.type, errorObj.name, null, errorObj.value);                       // 191
	};                                                                                                                     // 192
	                                                                                                                       // 193
	SimpleSchemaValidationContext.prototype.getErrorObject = function simpleSchemaValidationContextGetErrorObject() {      // 194
	  var self = this, message, invalidKeys = this._invalidKeys;                                                           // 195
	  if (invalidKeys.length) {                                                                                            // 196
	    message = self.keyErrorMessage(invalidKeys[0].name);                                                               // 197
	    // We add `message` prop to the invalidKeys.                                                                       // 198
	    invalidKeys = _.map(invalidKeys, function (o) {                                                                    // 199
	      return _.extend({message: self.keyErrorMessage(o.name)}, o);                                                     // 200
	    });                                                                                                                // 201
	  } else {                                                                                                             // 202
	    message = "Failed validation";                                                                                     // 203
	  }                                                                                                                    // 204
	  var error = new Error(message);                                                                                      // 205
	  error.invalidKeys = invalidKeys;                                                                                     // 206
	  // If on the server, we add a sanitized error, too, in case we're                                                    // 207
	  // called from a method.                                                                                             // 208
	  if (Meteor.isServer) {                                                                                               // 209
	    error.sanitizedError = new Meteor.Error(400, message);                                                             // 210
	  }                                                                                                                    // 211
	  return error;                                                                                                        // 212
	};                                                                                                                     // 213
	                                                                                                                       // 214
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['aldeed:simple-schema'] = {}, {
	  SimpleSchema: SimpleSchema,
	  MongoObject: MongoObject,
	  humanize: humanize
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/allow-deny.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	var LocalCollection = Package.minimongo.LocalCollection;
	var Minimongo = Package.minimongo.Minimongo;
	var check = Package.check.check;
	var Match = Package.check.Match;
	var EJSON = Package.ejson.EJSON;
	var DDP = Package['ddp-client'].DDP;
	var meteorInstall = Package.modules.meteorInstall;
	var Buffer = Package.modules.Buffer;
	var process = Package.modules.process;
	var Symbol = Package['ecmascript-runtime'].Symbol;
	var Map = Package['ecmascript-runtime'].Map;
	var Set = Package['ecmascript-runtime'].Set;
	var meteorBabelHelpers = Package['babel-runtime'].meteorBabelHelpers;
	var Promise = Package.promise.Promise;
	
	/* Package-scope variables */
	var AllowDeny;
	
	var require = meteorInstall({"node_modules":{"meteor":{"allow-deny":{"allow-deny.js":function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                //
	// packages/allow-deny/allow-deny.js                                                                              //
	//                                                                                                                //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                  //
	///                                                                                                               // 1
	/// Remote methods and access control.                                                                            // 2
	///                                                                                                               // 3
	                                                                                                                  //
	// Restrict default mutators on collection. allow() and deny() take the                                           // 5
	// same options:                                                                                                  // 6
	//                                                                                                                // 7
	// options.insert {Function(userId, doc)}                                                                         // 8
	//   return true to allow/deny adding this document                                                               // 9
	//                                                                                                                // 10
	// options.update {Function(userId, docs, fields, modifier)}                                                      // 11
	//   return true to allow/deny updating these documents.                                                          // 12
	//   `fields` is passed as an array of fields that are to be modified                                             // 13
	//                                                                                                                // 14
	// options.remove {Function(userId, docs)}                                                                        // 15
	//   return true to allow/deny removing these documents                                                           // 16
	//                                                                                                                // 17
	// options.fetch {Array}                                                                                          // 18
	//   Fields to fetch for these validators. If any call to allow or deny                                           // 19
	//   does not have this option then all fields are loaded.                                                        // 20
	//                                                                                                                // 21
	// allow and deny can be called multiple times. The validators are                                                // 22
	// evaluated as follows:                                                                                          // 23
	// - If neither deny() nor allow() has been called on the collection,                                             // 24
	//   then the request is allowed if and only if the "insecure" smart                                              // 25
	//   package is in use.                                                                                           // 26
	// - Otherwise, if any deny() function returns true, the request is denied.                                       // 27
	// - Otherwise, if any allow() function returns true, the request is allowed.                                     // 28
	// - Otherwise, the request is denied.                                                                            // 29
	//                                                                                                                // 30
	// Meteor may call your deny() and allow() functions in any order, and may not                                    // 31
	// call all of them if it is able to make a decision without calling them all                                     // 32
	// (so don't include side effects).                                                                               // 33
	                                                                                                                  //
	AllowDeny = {                                                                                                     // 35
	  CollectionPrototype: {}                                                                                         // 36
	};                                                                                                                // 35
	                                                                                                                  //
	// In the `mongo` package, we will extend Mongo.Collection.prototype with these                                   // 39
	// methods                                                                                                        // 40
	var CollectionPrototype = AllowDeny.CollectionPrototype;                                                          // 41
	                                                                                                                  //
	/**                                                                                                               // 43
	 * @summary Allow users to write directly to this collection from client code, subject to limitations you define.
	 * @locus Server                                                                                                  //
	 * @method allow                                                                                                  //
	 * @memberOf Mongo.Collection                                                                                     //
	 * @instance                                                                                                      //
	 * @param {Object} options                                                                                        //
	 * @param {Function} options.insert,update,remove Functions that look at a proposed modification to the database and return true if it should be allowed.
	 * @param {String[]} options.fetch Optional performance enhancement. Limits the fields that will be fetched from the database for inspection by your `update` and `remove` functions.
	 * @param {Function} options.transform Overrides `transform` on the  [`Collection`](#collections).  Pass `null` to disable transformation.
	 */                                                                                                               //
	CollectionPrototype.allow = function (options) {                                                                  // 54
	  addValidator(this, 'allow', options);                                                                           // 55
	};                                                                                                                // 56
	                                                                                                                  //
	/**                                                                                                               // 58
	 * @summary Override `allow` rules.                                                                               //
	 * @locus Server                                                                                                  //
	 * @method deny                                                                                                   //
	 * @memberOf Mongo.Collection                                                                                     //
	 * @instance                                                                                                      //
	 * @param {Object} options                                                                                        //
	 * @param {Function} options.insert,update,remove Functions that look at a proposed modification to the database and return true if it should be denied, even if an [allow](#allow) rule says otherwise.
	 * @param {String[]} options.fetch Optional performance enhancement. Limits the fields that will be fetched from the database for inspection by your `update` and `remove` functions.
	 * @param {Function} options.transform Overrides `transform` on the  [`Collection`](#collections).  Pass `null` to disable transformation.
	 */                                                                                                               //
	CollectionPrototype.deny = function (options) {                                                                   // 69
	  addValidator(this, 'deny', options);                                                                            // 70
	};                                                                                                                // 71
	                                                                                                                  //
	CollectionPrototype._defineMutationMethods = function (options) {                                                 // 73
	  var self = this;                                                                                                // 74
	  options = options || {};                                                                                        // 75
	                                                                                                                  //
	  // set to true once we call any allow or deny methods. If true, use                                             // 77
	  // allow/deny semantics. If false, use insecure mode semantics.                                                 // 78
	  self._restricted = false;                                                                                       // 79
	                                                                                                                  //
	  // Insecure mode (default to allowing writes). Defaults to 'undefined' which                                    // 81
	  // means insecure iff the insecure package is loaded. This property can be                                      // 82
	  // overriden by tests or packages wishing to change insecure mode behavior of                                   // 83
	  // their collections.                                                                                           // 84
	  self._insecure = undefined;                                                                                     // 85
	                                                                                                                  //
	  self._validators = {                                                                                            // 87
	    insert: { allow: [], deny: [] },                                                                              // 88
	    update: { allow: [], deny: [] },                                                                              // 89
	    remove: { allow: [], deny: [] },                                                                              // 90
	    upsert: { allow: [], deny: [] }, // dummy arrays; can't set these!                                            // 91
	    fetch: [],                                                                                                    // 92
	    fetchAllFields: false                                                                                         // 93
	  };                                                                                                              // 87
	                                                                                                                  //
	  if (!self._name) return; // anonymous collection                                                                // 96
	                                                                                                                  //
	  // XXX Think about method namespacing. Maybe methods should be                                                  // 99
	  // "Meteor:Mongo:insert/NAME"?                                                                                  // 100
	  self._prefix = '/' + self._name + '/';                                                                          // 101
	                                                                                                                  //
	  // Mutation Methods                                                                                             // 103
	  // Minimongo on the server gets no stubs; instead, by default                                                   // 104
	  // it wait()s until its result is ready, yielding.                                                              // 105
	  // This matches the behavior of macromongo on the server better.                                                // 106
	  // XXX see #MeteorServerNull                                                                                    // 107
	  if (self._connection && (self._connection === Meteor.server || Meteor.isClient)) {                              // 108
	    (function () {                                                                                                // 108
	      var m = {};                                                                                                 // 109
	                                                                                                                  //
	      _.each(['insert', 'update', 'remove'], function (method) {                                                  // 111
	        var methodName = self._prefix + method;                                                                   // 112
	                                                                                                                  //
	        if (options.useExisting) {                                                                                // 114
	          var handlerPropName = Meteor.isClient ? '_methodHandlers' : 'method_handlers';                          // 115
	          // Do not try to create additional methods if this has already been called.                             // 116
	          // (Otherwise the .methods() call below will throw an error.)                                           // 117
	          if (self._connection[handlerPropName] && typeof self._connection[handlerPropName][methodName] === 'function') return;
	        }                                                                                                         // 120
	                                                                                                                  //
	        m[methodName] = function () /* ... */{                                                                    // 122
	          // All the methods do their own validation, instead of using check().                                   // 123
	          check(arguments, [Match.Any]);                                                                          // 124
	          var args = _.toArray(arguments);                                                                        // 125
	          try {                                                                                                   // 126
	            // For an insert, if the client didn't specify an _id, generate one                                   // 127
	            // now; because this uses DDP.randomStream, it will be consistent with                                // 128
	            // what the client generated. We generate it now rather than later so                                 // 129
	            // that if (eg) an allow/deny rule does an insert to the same                                         // 130
	            // collection (not that it really should), the generated _id will                                     // 131
	            // still be the first use of the stream and will be consistent.                                       // 132
	            //                                                                                                    // 133
	            // However, we don't actually stick the _id onto the document yet,                                    // 134
	            // because we want allow/deny rules to be able to differentiate                                       // 135
	            // between arbitrary client-specified _id fields and merely                                           // 136
	            // client-controlled-via-randomSeed fields.                                                           // 137
	            var generatedId = null;                                                                               // 138
	            if (method === "insert" && !_.has(args[0], '_id')) {                                                  // 139
	              generatedId = self._makeNewID();                                                                    // 140
	            }                                                                                                     // 141
	                                                                                                                  //
	            if (this.isSimulation) {                                                                              // 143
	              // In a client simulation, you can do any mutation (even with a                                     // 144
	              // complex selector).                                                                               // 145
	              if (generatedId !== null) args[0]._id = generatedId;                                                // 146
	              return self._collection[method].apply(self._collection, args);                                      // 148
	            }                                                                                                     // 150
	                                                                                                                  //
	            // This is the server receiving a method call from the client.                                        // 152
	                                                                                                                  //
	            // We don't allow arbitrary selectors in mutations from the client: only                              // 154
	            // single-ID selectors.                                                                               // 155
	            if (method !== 'insert') throwIfSelectorIsNotId(args[0], method);                                     // 156
	                                                                                                                  //
	            if (self._restricted) {                                                                               // 159
	              // short circuit if there is no way it will pass.                                                   // 160
	              if (self._validators[method].allow.length === 0) {                                                  // 161
	                throw new Meteor.Error(403, "Access denied. No allow validators set on restricted " + "collection for method '" + method + "'.");
	              }                                                                                                   // 165
	                                                                                                                  //
	              var validatedMethodName = '_validated' + method.charAt(0).toUpperCase() + method.slice(1);          // 167
	              args.unshift(this.userId);                                                                          // 169
	              method === 'insert' && args.push(generatedId);                                                      // 170
	              return self[validatedMethodName].apply(self, args);                                                 // 171
	            } else if (self._isInsecure()) {                                                                      // 172
	              if (generatedId !== null) args[0]._id = generatedId;                                                // 173
	              // In insecure mode, allow any mutation (with a simple selector).                                   // 175
	              // XXX This is kind of bogus.  Instead of blindly passing whatever                                  // 176
	              //     we get from the network to this function, we should actually                                 // 177
	              //     know the correct arguments for the function and pass just                                    // 178
	              //     them.  For example, if you have an extraneous extra null                                     // 179
	              //     argument and this is Mongo on the server, the .wrapAsync'd                                   // 180
	              //     functions like update will get confused and pass the                                         // 181
	              //     "fut.resolver()" in the wrong slot, where _update will never                                 // 182
	              //     invoke it. Bam, broken DDP connection.  Probably should just                                 // 183
	              //     take this whole method and write it three times, invoking                                    // 184
	              //     helpers for the common code.                                                                 // 185
	              return self._collection[method].apply(self._collection, args);                                      // 186
	            } else {                                                                                              // 187
	              // In secure mode, if we haven't called allow or deny, then nothing                                 // 188
	              // is permitted.                                                                                    // 189
	              throw new Meteor.Error(403, "Access denied");                                                       // 190
	            }                                                                                                     // 191
	          } catch (e) {                                                                                           // 192
	            if (e.name === 'MongoError' || e.name === 'MinimongoError') {                                         // 193
	              throw new Meteor.Error(409, e.toString());                                                          // 194
	            } else {                                                                                              // 195
	              throw e;                                                                                            // 196
	            }                                                                                                     // 197
	          }                                                                                                       // 198
	        };                                                                                                        // 199
	      });                                                                                                         // 200
	                                                                                                                  //
	      self._connection.methods(m);                                                                                // 202
	    })();                                                                                                         // 108
	  }                                                                                                               // 203
	};                                                                                                                // 204
	                                                                                                                  //
	CollectionPrototype._updateFetch = function (fields) {                                                            // 206
	  var self = this;                                                                                                // 207
	                                                                                                                  //
	  if (!self._validators.fetchAllFields) {                                                                         // 209
	    if (fields) {                                                                                                 // 210
	      self._validators.fetch = _.union(self._validators.fetch, fields);                                           // 211
	    } else {                                                                                                      // 212
	      self._validators.fetchAllFields = true;                                                                     // 213
	      // clear fetch just to make sure we don't accidentally read it                                              // 214
	      self._validators.fetch = null;                                                                              // 215
	    }                                                                                                             // 216
	  }                                                                                                               // 217
	};                                                                                                                // 218
	                                                                                                                  //
	CollectionPrototype._isInsecure = function () {                                                                   // 220
	  var self = this;                                                                                                // 221
	  if (self._insecure === undefined) return !!Package.insecure;                                                    // 222
	  return self._insecure;                                                                                          // 224
	};                                                                                                                // 225
	                                                                                                                  //
	CollectionPrototype._validatedInsert = function (userId, doc, generatedId) {                                      // 227
	  var self = this;                                                                                                // 229
	                                                                                                                  //
	  // call user validators.                                                                                        // 231
	  // Any deny returns true means denied.                                                                          // 232
	  if (_.any(self._validators.insert.deny, function (validator) {                                                  // 233
	    return validator(userId, docToValidate(validator, doc, generatedId));                                         // 234
	  })) {                                                                                                           // 235
	    throw new Meteor.Error(403, "Access denied");                                                                 // 236
	  }                                                                                                               // 237
	  // Any allow returns true means proceed. Throw error if they all fail.                                          // 238
	  if (_.all(self._validators.insert.allow, function (validator) {                                                 // 239
	    return !validator(userId, docToValidate(validator, doc, generatedId));                                        // 240
	  })) {                                                                                                           // 241
	    throw new Meteor.Error(403, "Access denied");                                                                 // 242
	  }                                                                                                               // 243
	                                                                                                                  //
	  // If we generated an ID above, insert it now: after the validation, but                                        // 245
	  // before actually inserting.                                                                                   // 246
	  if (generatedId !== null) doc._id = generatedId;                                                                // 247
	                                                                                                                  //
	  self._collection.insert.call(self._collection, doc);                                                            // 250
	};                                                                                                                // 251
	                                                                                                                  //
	// Simulate a mongo `update` operation while validating that the access                                           // 253
	// control rules set by calls to `allow/deny` are satisfied. If all                                               // 254
	// pass, rewrite the mongo operation to use $in to set the list of                                                // 255
	// document ids to change ##ValidatedChange                                                                       // 256
	CollectionPrototype._validatedUpdate = function (userId, selector, mutator, options) {                            // 257
	  var self = this;                                                                                                // 259
	                                                                                                                  //
	  check(mutator, Object);                                                                                         // 261
	                                                                                                                  //
	  options = _.clone(options) || {};                                                                               // 263
	                                                                                                                  //
	  if (!LocalCollection._selectorIsIdPerhapsAsObject(selector)) throw new Error("validated update should be of a single ID");
	                                                                                                                  //
	  // We don't support upserts because they don't fit nicely into allow/deny                                       // 268
	  // rules.                                                                                                       // 269
	  if (options.upsert) throw new Meteor.Error(403, "Access denied. Upserts not " + "allowed in a restricted collection.");
	                                                                                                                  //
	  var noReplaceError = "Access denied. In a restricted collection you can only" + " update documents, not replace them. Use a Mongo update operator, such " + "as '$set'.";
	                                                                                                                  //
	  // compute modified fields                                                                                      // 278
	  var fields = [];                                                                                                // 279
	  if (_.isEmpty(mutator)) {                                                                                       // 280
	    throw new Meteor.Error(403, noReplaceError);                                                                  // 281
	  }                                                                                                               // 282
	  _.each(mutator, function (params, op) {                                                                         // 283
	    if (op.charAt(0) !== '$') {                                                                                   // 284
	      throw new Meteor.Error(403, noReplaceError);                                                                // 285
	    } else if (!_.has(ALLOWED_UPDATE_OPERATIONS, op)) {                                                           // 286
	      throw new Meteor.Error(403, "Access denied. Operator " + op + " not allowed in a restricted collection.");  // 287
	    } else {                                                                                                      // 289
	      _.each(_.keys(params), function (field) {                                                                   // 290
	        // treat dotted fields as if they are replacing their                                                     // 291
	        // top-level part                                                                                         // 292
	        if (field.indexOf('.') !== -1) field = field.substring(0, field.indexOf('.'));                            // 293
	                                                                                                                  //
	        // record the field we are trying to change                                                               // 296
	        if (!_.contains(fields, field)) fields.push(field);                                                       // 297
	      });                                                                                                         // 299
	    }                                                                                                             // 300
	  });                                                                                                             // 301
	                                                                                                                  //
	  var findOptions = { transform: null };                                                                          // 303
	  if (!self._validators.fetchAllFields) {                                                                         // 304
	    findOptions.fields = {};                                                                                      // 305
	    _.each(self._validators.fetch, function (fieldName) {                                                         // 306
	      findOptions.fields[fieldName] = 1;                                                                          // 307
	    });                                                                                                           // 308
	  }                                                                                                               // 309
	                                                                                                                  //
	  var doc = self._collection.findOne(selector, findOptions);                                                      // 311
	  if (!doc) // none satisfied!                                                                                    // 312
	    return 0;                                                                                                     // 313
	                                                                                                                  //
	  // call user validators.                                                                                        // 315
	  // Any deny returns true means denied.                                                                          // 316
	  if (_.any(self._validators.update.deny, function (validator) {                                                  // 317
	    var factoriedDoc = transformDoc(validator, doc);                                                              // 318
	    return validator(userId, factoriedDoc, fields, mutator);                                                      // 319
	  })) {                                                                                                           // 323
	    throw new Meteor.Error(403, "Access denied");                                                                 // 324
	  }                                                                                                               // 325
	  // Any allow returns true means proceed. Throw error if they all fail.                                          // 326
	  if (_.all(self._validators.update.allow, function (validator) {                                                 // 327
	    var factoriedDoc = transformDoc(validator, doc);                                                              // 328
	    return !validator(userId, factoriedDoc, fields, mutator);                                                     // 329
	  })) {                                                                                                           // 333
	    throw new Meteor.Error(403, "Access denied");                                                                 // 334
	  }                                                                                                               // 335
	                                                                                                                  //
	  options._forbidReplace = true;                                                                                  // 337
	                                                                                                                  //
	  // Back when we supported arbitrary client-provided selectors, we actually                                      // 339
	  // rewrote the selector to include an _id clause before passing to Mongo to                                     // 340
	  // avoid races, but since selector is guaranteed to already just be an ID, we                                   // 341
	  // don't have to any more.                                                                                      // 342
	                                                                                                                  //
	  return self._collection.update.call(self._collection, selector, mutator, options);                              // 344
	};                                                                                                                // 346
	                                                                                                                  //
	// Only allow these operations in validated updates. Specifically                                                 // 348
	// whitelist operations, rather than blacklist, so new complex                                                    // 349
	// operations that are added aren't automatically allowed. A complex                                              // 350
	// operation is one that does more than just modify its target                                                    // 351
	// field. For now this contains all update operations except '$rename'.                                           // 352
	// http://docs.mongodb.org/manual/reference/operators/#update                                                     // 353
	var ALLOWED_UPDATE_OPERATIONS = {                                                                                 // 354
	  $inc: 1, $set: 1, $unset: 1, $addToSet: 1, $pop: 1, $pullAll: 1, $pull: 1,                                      // 355
	  $pushAll: 1, $push: 1, $bit: 1                                                                                  // 356
	};                                                                                                                // 354
	                                                                                                                  //
	// Simulate a mongo `remove` operation while validating access control                                            // 359
	// rules. See #ValidatedChange                                                                                    // 360
	CollectionPrototype._validatedRemove = function (userId, selector) {                                              // 361
	  var self = this;                                                                                                // 362
	                                                                                                                  //
	  var findOptions = { transform: null };                                                                          // 364
	  if (!self._validators.fetchAllFields) {                                                                         // 365
	    findOptions.fields = {};                                                                                      // 366
	    _.each(self._validators.fetch, function (fieldName) {                                                         // 367
	      findOptions.fields[fieldName] = 1;                                                                          // 368
	    });                                                                                                           // 369
	  }                                                                                                               // 370
	                                                                                                                  //
	  var doc = self._collection.findOne(selector, findOptions);                                                      // 372
	  if (!doc) return 0;                                                                                             // 373
	                                                                                                                  //
	  // call user validators.                                                                                        // 376
	  // Any deny returns true means denied.                                                                          // 377
	  if (_.any(self._validators.remove.deny, function (validator) {                                                  // 378
	    return validator(userId, transformDoc(validator, doc));                                                       // 379
	  })) {                                                                                                           // 380
	    throw new Meteor.Error(403, "Access denied");                                                                 // 381
	  }                                                                                                               // 382
	  // Any allow returns true means proceed. Throw error if they all fail.                                          // 383
	  if (_.all(self._validators.remove.allow, function (validator) {                                                 // 384
	    return !validator(userId, transformDoc(validator, doc));                                                      // 385
	  })) {                                                                                                           // 386
	    throw new Meteor.Error(403, "Access denied");                                                                 // 387
	  }                                                                                                               // 388
	                                                                                                                  //
	  // Back when we supported arbitrary client-provided selectors, we actually                                      // 390
	  // rewrote the selector to {_id: {$in: [ids that we found]}} before passing to                                  // 391
	  // Mongo to avoid races, but since selector is guaranteed to already just be                                    // 392
	  // an ID, we don't have to any more.                                                                            // 393
	                                                                                                                  //
	  return self._collection.remove.call(self._collection, selector);                                                // 395
	};                                                                                                                // 396
	                                                                                                                  //
	CollectionPrototype._callMutatorMethod = function () {                                                            // 398
	  function _callMutatorMethod(name, args, callback) {                                                             // 398
	    if (Meteor.isClient && !callback && !alreadyInSimulation()) {                                                 // 399
	      // Client can't block, so it can't report errors by exception,                                              // 400
	      // only by callback. If they forget the callback, give them a                                               // 401
	      // default one that logs the error, so they aren't totally                                                  // 402
	      // baffled if their writes don't work because their database is                                             // 403
	      // down.                                                                                                    // 404
	      // Don't give a default callback in simulation, because inside stubs we                                     // 405
	      // want to return the results from the local collection immediately and                                     // 406
	      // not force a callback.                                                                                    // 407
	      callback = function () {                                                                                    // 408
	        function callback(err) {                                                                                  // 408
	          if (err) Meteor._debug(name + " failed: " + (err.reason || err.stack));                                 // 409
	        }                                                                                                         // 411
	                                                                                                                  //
	        return callback;                                                                                          // 408
	      }();                                                                                                        // 408
	    }                                                                                                             // 412
	                                                                                                                  //
	    // For two out of three mutator methods, the first argument is a selector                                     // 414
	    var firstArgIsSelector = name === "update" || name === "remove";                                              // 415
	    if (firstArgIsSelector && !alreadyInSimulation()) {                                                           // 416
	      // If we're about to actually send an RPC, we should throw an error if                                      // 417
	      // this is a non-ID selector, because the mutation methods only allow                                       // 418
	      // single-ID selectors. (If we don't throw here, we'll see flicker.)                                        // 419
	      throwIfSelectorIsNotId(args[0], name);                                                                      // 420
	    }                                                                                                             // 421
	                                                                                                                  //
	    var mutatorMethodName = this._prefix + name;                                                                  // 423
	    return this._connection.apply(mutatorMethodName, args, { returnStubValue: true }, callback);                  // 424
	  }                                                                                                               // 426
	                                                                                                                  //
	  return _callMutatorMethod;                                                                                      // 398
	}();                                                                                                              // 398
	                                                                                                                  //
	function transformDoc(validator, doc) {                                                                           // 428
	  if (validator.transform) return validator.transform(doc);                                                       // 429
	  return doc;                                                                                                     // 431
	}                                                                                                                 // 432
	                                                                                                                  //
	function docToValidate(validator, doc, generatedId) {                                                             // 434
	  var ret = doc;                                                                                                  // 435
	  if (validator.transform) {                                                                                      // 436
	    ret = EJSON.clone(doc);                                                                                       // 437
	    // If you set a server-side transform on your collection, then you don't get                                  // 438
	    // to tell the difference between "client specified the ID" and "server                                       // 439
	    // generated the ID", because transforms expect to get _id.  If you want to                                   // 440
	    // do that check, you can do it with a specific                                                               // 441
	    // `C.allow({insert: f, transform: null})` validator.                                                         // 442
	    if (generatedId !== null) {                                                                                   // 443
	      ret._id = generatedId;                                                                                      // 444
	    }                                                                                                             // 445
	    ret = validator.transform(ret);                                                                               // 446
	  }                                                                                                               // 447
	  return ret;                                                                                                     // 448
	}                                                                                                                 // 449
	                                                                                                                  //
	function addValidator(collection, allowOrDeny, options) {                                                         // 451
	  // validate keys                                                                                                // 452
	  var VALID_KEYS = ['insert', 'update', 'remove', 'fetch', 'transform'];                                          // 453
	  _.each(_.keys(options), function (key) {                                                                        // 454
	    if (!_.contains(VALID_KEYS, key)) throw new Error(allowOrDeny + ": Invalid key: " + key);                     // 455
	  });                                                                                                             // 457
	                                                                                                                  //
	  collection._restricted = true;                                                                                  // 459
	                                                                                                                  //
	  _.each(['insert', 'update', 'remove'], function (name) {                                                        // 461
	    if (options.hasOwnProperty(name)) {                                                                           // 462
	      if (!(options[name] instanceof Function)) {                                                                 // 463
	        throw new Error(allowOrDeny + ": Value for `" + name + "` must be a function");                           // 464
	      }                                                                                                           // 465
	                                                                                                                  //
	      // If the transform is specified at all (including as 'null') in this                                       // 467
	      // call, then take that; otherwise, take the transform from the                                             // 468
	      // collection.                                                                                              // 469
	      if (options.transform === undefined) {                                                                      // 470
	        options[name].transform = collection._transform; // already wrapped                                       // 471
	      } else {                                                                                                    // 472
	        options[name].transform = LocalCollection.wrapTransform(options.transform);                               // 473
	      }                                                                                                           // 475
	                                                                                                                  //
	      collection._validators[name][allowOrDeny].push(options[name]);                                              // 477
	    }                                                                                                             // 478
	  });                                                                                                             // 479
	                                                                                                                  //
	  // Only update the fetch fields if we're passed things that affect                                              // 481
	  // fetching. This way allow({}) and allow({insert: f}) don't result in                                          // 482
	  // setting fetchAllFields                                                                                       // 483
	  if (options.update || options.remove || options.fetch) {                                                        // 484
	    if (options.fetch && !(options.fetch instanceof Array)) {                                                     // 485
	      throw new Error(allowOrDeny + ": Value for `fetch` must be an array");                                      // 486
	    }                                                                                                             // 487
	    collection._updateFetch(options.fetch);                                                                       // 488
	  }                                                                                                               // 489
	}                                                                                                                 // 490
	                                                                                                                  //
	function throwIfSelectorIsNotId(selector, methodName) {                                                           // 492
	  if (!LocalCollection._selectorIsIdPerhapsAsObject(selector)) {                                                  // 493
	    throw new Meteor.Error(403, "Not permitted. Untrusted code may only " + methodName + " documents by ID.");    // 494
	  }                                                                                                               // 497
	};                                                                                                                // 498
	                                                                                                                  //
	// Determine if we are in a DDP method simulation                                                                 // 500
	function alreadyInSimulation() {                                                                                  // 501
	  var enclosing = DDP._CurrentInvocation.get();                                                                   // 502
	  return enclosing && enclosing.isSimulation;                                                                     // 503
	}                                                                                                                 // 504
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}}}}},{"extensions":[".js",".json"]});
	require("./node_modules/meteor/allow-deny/allow-deny.js");
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['allow-deny'] = {}, {
	  AllowDeny: AllowDeny
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/babel-compiler.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	Package['babel-compiler'] = {};
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/babel-runtime.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var meteorInstall = Package.modules.meteorInstall;
	var Buffer = Package.modules.Buffer;
	var process = Package.modules.process;
	var Promise = Package.promise.Promise;
	
	/* Package-scope variables */
	var meteorBabelHelpers;
	
	var require = meteorInstall({"node_modules":{"meteor":{"babel-runtime":{"babel-runtime.js":["meteor-babel-helpers","babel-runtime/regenerator",function(require,exports){
	
	////////////////////////////////////////////////////////////////////////////////
	//                                                                            //
	// packages/babel-runtime/babel-runtime.js                                    //
	//                                                                            //
	////////////////////////////////////////////////////////////////////////////////
	                                                                              //
	exports.meteorBabelHelpers = require("meteor-babel-helpers");                 // 1
	                                                                              // 2
	// Returns true if a given absolute identifier will be provided at runtime    // 3
	// by the babel-runtime package.                                              // 4
	exports.checkHelper = function checkHelper(id) {                              // 5
	  // There used to be more complicated logic here, when the babel-runtime     // 6
	  // package provided helper implementations of its own, but now this         // 7
	  // function exists just for backwards compatibility.                        // 8
	  return false;                                                               // 9
	};                                                                            // 10
	                                                                              // 11
	try {                                                                         // 12
	  var regeneratorRuntime = require("babel-runtime/regenerator");              // 13
	} catch (e) {                                                                 // 14
	  throw new Error([                                                           // 15
	    "The babel-runtime npm package could not be found in your node_modules ",
	    "directory. Please run the following command to install it:",             // 17
	    "",                                                                       // 18
	    "  meteor npm install --save babel-runtime",                              // 19
	    ""                                                                        // 20
	  ].join("\n"));                                                              // 21
	}                                                                             // 22
	                                                                              // 23
	if (regeneratorRuntime &&                                                     // 24
	    typeof Promise === "function" &&                                          // 25
	    typeof Promise.asyncApply === "function") {                               // 26
	  // If Promise.asyncApply is defined, use it to wrap calls to                // 27
	  // runtime.async so that the entire async function will run in its own      // 28
	  // Fiber, not just the code that comes after the first await.               // 29
	  var realAsync = regeneratorRuntime.async;                                   // 30
	  regeneratorRuntime.async = function () {                                    // 31
	    return Promise.asyncApply(realAsync, regeneratorRuntime, arguments);      // 32
	  };                                                                          // 33
	}                                                                             // 34
	                                                                              // 35
	////////////////////////////////////////////////////////////////////////////////
	
	}],"node_modules":{"meteor-babel-helpers":{"package.json":function(require,exports){
	
	////////////////////////////////////////////////////////////////////////////////
	//                                                                            //
	// ../../.1.0.1.9s0oar++os+web.browser+web.cordova/npm/node_modules/meteor-ba //
	//                                                                            //
	////////////////////////////////////////////////////////////////////////////////
	                                                                              //
	exports.name = "meteor-babel-helpers";                                        // 1
	exports.version = "0.0.3";                                                    // 2
	exports.main = "index.js";                                                    // 3
	                                                                              // 4
	////////////////////////////////////////////////////////////////////////////////
	
	},"index.js":function(require,exports,module){
	
	////////////////////////////////////////////////////////////////////////////////
	//                                                                            //
	// node_modules/meteor/babel-runtime/node_modules/meteor-babel-helpers/index. //
	//                                                                            //
	////////////////////////////////////////////////////////////////////////////////
	                                                                              //
	function canDefineNonEnumerableProperties() {                                 // 1
	  var testObj = {};                                                           // 2
	  var testPropName = "t";                                                     // 3
	                                                                              // 4
	  try {                                                                       // 5
	    Object.defineProperty(testObj, testPropName, {                            // 6
	      enumerable: false,                                                      // 7
	      value: testObj                                                          // 8
	    });                                                                       // 9
	                                                                              // 10
	    for (var k in testObj) {                                                  // 11
	      if (k === testPropName) {                                               // 12
	        return false;                                                         // 13
	      }                                                                       // 14
	    }                                                                         // 15
	  } catch (e) {                                                               // 16
	    return false;                                                             // 17
	  }                                                                           // 18
	                                                                              // 19
	  return testObj[testPropName] === testObj;                                   // 20
	}                                                                             // 21
	                                                                              // 22
	function sanitizeEasy(value) {                                                // 23
	  return value;                                                               // 24
	}                                                                             // 25
	                                                                              // 26
	function sanitizeHard(obj) {                                                  // 27
	  if (Array.isArray(obj)) {                                                   // 28
	    var newObj = {};                                                          // 29
	    var keys = Object.keys(obj);                                              // 30
	    var keyCount = keys.length;                                               // 31
	    for (var i = 0; i < keyCount; ++i) {                                      // 32
	      var key = keys[i];                                                      // 33
	      newObj[key] = obj[key];                                                 // 34
	    }                                                                         // 35
	    return newObj;                                                            // 36
	  }                                                                           // 37
	                                                                              // 38
	  return obj;                                                                 // 39
	}                                                                             // 40
	                                                                              // 41
	meteorBabelHelpers = module.exports = {                                       // 42
	  // Meteor-specific runtime helper for wrapping the object of for-in         // 43
	  // loops, so that inherited Array methods defined by es5-shim can be        // 44
	  // ignored in browsers where they cannot be defined as non-enumerable.      // 45
	  sanitizeForInObject: canDefineNonEnumerableProperties()                     // 46
	    ? sanitizeEasy                                                            // 47
	    : sanitizeHard,                                                           // 48
	                                                                              // 49
	  // Exposed so that we can test sanitizeForInObject in environments that     // 50
	  // support defining non-enumerable properties.                              // 51
	  _sanitizeForInObjectHard: sanitizeHard                                      // 52
	};                                                                            // 53
	                                                                              // 54
	////////////////////////////////////////////////////////////////////////////////
	
	}}}}}}},{"extensions":[".js",".json"]});
	var exports = require("./node_modules/meteor/babel-runtime/babel-runtime.js");
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['babel-runtime'] = exports, {
	  meteorBabelHelpers: meteorBabelHelpers
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/base64.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	
	/* Package-scope variables */
	var Base64;
	
	(function(){
	
	//////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                      //
	// packages/base64/base64.js                                                            //
	//                                                                                      //
	//////////////////////////////////////////////////////////////////////////////////////////
	                                                                                        //
	// Base 64 encoding                                                                     // 1
	                                                                                        // 2
	var BASE_64_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	                                                                                        // 4
	var BASE_64_VALS = {};                                                                  // 5
	                                                                                        // 6
	for (var i = 0; i < BASE_64_CHARS.length; i++) {                                        // 7
	  BASE_64_VALS[BASE_64_CHARS.charAt(i)] = i;                                            // 8
	};                                                                                      // 9
	                                                                                        // 10
	Base64 = {};                                                                            // 11
	                                                                                        // 12
	Base64.encode = function (array) {                                                      // 13
	                                                                                        // 14
	  if (typeof array === "string") {                                                      // 15
	    var str = array;                                                                    // 16
	    array = Base64.newBinary(str.length);                                               // 17
	    for (var i = 0; i < str.length; i++) {                                              // 18
	      var ch = str.charCodeAt(i);                                                       // 19
	      if (ch > 0xFF) {                                                                  // 20
	        throw new Error(                                                                // 21
	          "Not ascii. Base64.encode can only take ascii strings.");                     // 22
	      }                                                                                 // 23
	      array[i] = ch;                                                                    // 24
	    }                                                                                   // 25
	  }                                                                                     // 26
	                                                                                        // 27
	  var answer = [];                                                                      // 28
	  var a = null;                                                                         // 29
	  var b = null;                                                                         // 30
	  var c = null;                                                                         // 31
	  var d = null;                                                                         // 32
	  for (var i = 0; i < array.length; i++) {                                              // 33
	    switch (i % 3) {                                                                    // 34
	    case 0:                                                                             // 35
	      a = (array[i] >> 2) & 0x3F;                                                       // 36
	      b = (array[i] & 0x03) << 4;                                                       // 37
	      break;                                                                            // 38
	    case 1:                                                                             // 39
	      b = b | (array[i] >> 4) & 0xF;                                                    // 40
	      c = (array[i] & 0xF) << 2;                                                        // 41
	      break;                                                                            // 42
	    case 2:                                                                             // 43
	      c = c | (array[i] >> 6) & 0x03;                                                   // 44
	      d = array[i] & 0x3F;                                                              // 45
	      answer.push(getChar(a));                                                          // 46
	      answer.push(getChar(b));                                                          // 47
	      answer.push(getChar(c));                                                          // 48
	      answer.push(getChar(d));                                                          // 49
	      a = null;                                                                         // 50
	      b = null;                                                                         // 51
	      c = null;                                                                         // 52
	      d = null;                                                                         // 53
	      break;                                                                            // 54
	    }                                                                                   // 55
	  }                                                                                     // 56
	  if (a != null) {                                                                      // 57
	    answer.push(getChar(a));                                                            // 58
	    answer.push(getChar(b));                                                            // 59
	    if (c == null)                                                                      // 60
	      answer.push('=');                                                                 // 61
	    else                                                                                // 62
	      answer.push(getChar(c));                                                          // 63
	    if (d == null)                                                                      // 64
	      answer.push('=');                                                                 // 65
	  }                                                                                     // 66
	  return answer.join("");                                                               // 67
	};                                                                                      // 68
	                                                                                        // 69
	var getChar = function (val) {                                                          // 70
	  return BASE_64_CHARS.charAt(val);                                                     // 71
	};                                                                                      // 72
	                                                                                        // 73
	var getVal = function (ch) {                                                            // 74
	  if (ch === '=') {                                                                     // 75
	    return -1;                                                                          // 76
	  }                                                                                     // 77
	  return BASE_64_VALS[ch];                                                              // 78
	};                                                                                      // 79
	                                                                                        // 80
	// XXX This is a weird place for this to live, but it's used both by                    // 81
	// this package and 'ejson', and we can't put it in 'ejson' without                     // 82
	// introducing a circular dependency. It should probably be in its own                  // 83
	// package or as a helper in a package that both 'base64' and 'ejson'                   // 84
	// use.                                                                                 // 85
	Base64.newBinary = function (len) {                                                     // 86
	  if (typeof Uint8Array === 'undefined' || typeof ArrayBuffer === 'undefined') {        // 87
	    var ret = [];                                                                       // 88
	    for (var i = 0; i < len; i++) {                                                     // 89
	      ret.push(0);                                                                      // 90
	    }                                                                                   // 91
	    ret.$Uint8ArrayPolyfill = true;                                                     // 92
	    return ret;                                                                         // 93
	  }                                                                                     // 94
	  return new Uint8Array(new ArrayBuffer(len));                                          // 95
	};                                                                                      // 96
	                                                                                        // 97
	Base64.decode = function (str) {                                                        // 98
	  var len = Math.floor((str.length*3)/4);                                               // 99
	  if (str.charAt(str.length - 1) == '=') {                                              // 100
	    len--;                                                                              // 101
	    if (str.charAt(str.length - 2) == '=')                                              // 102
	      len--;                                                                            // 103
	  }                                                                                     // 104
	  var arr = Base64.newBinary(len);                                                      // 105
	                                                                                        // 106
	  var one = null;                                                                       // 107
	  var two = null;                                                                       // 108
	  var three = null;                                                                     // 109
	                                                                                        // 110
	  var j = 0;                                                                            // 111
	                                                                                        // 112
	  for (var i = 0; i < str.length; i++) {                                                // 113
	    var c = str.charAt(i);                                                              // 114
	    var v = getVal(c);                                                                  // 115
	    switch (i % 4) {                                                                    // 116
	    case 0:                                                                             // 117
	      if (v < 0)                                                                        // 118
	        throw new Error('invalid base64 string');                                       // 119
	      one = v << 2;                                                                     // 120
	      break;                                                                            // 121
	    case 1:                                                                             // 122
	      if (v < 0)                                                                        // 123
	        throw new Error('invalid base64 string');                                       // 124
	      one = one | (v >> 4);                                                             // 125
	      arr[j++] = one;                                                                   // 126
	      two = (v & 0x0F) << 4;                                                            // 127
	      break;                                                                            // 128
	    case 2:                                                                             // 129
	      if (v >= 0) {                                                                     // 130
	        two = two | (v >> 2);                                                           // 131
	        arr[j++] = two;                                                                 // 132
	        three = (v & 0x03) << 6;                                                        // 133
	      }                                                                                 // 134
	      break;                                                                            // 135
	    case 3:                                                                             // 136
	      if (v >= 0) {                                                                     // 137
	        arr[j++] = three | v;                                                           // 138
	      }                                                                                 // 139
	      break;                                                                            // 140
	    }                                                                                   // 141
	  }                                                                                     // 142
	  return arr;                                                                           // 143
	};                                                                                      // 144
	                                                                                        // 145
	//////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.base64 = {}, {
	  Base64: Base64
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/callback-hook.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	
	/* Package-scope variables */
	var Hook;
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////
	//                                                                                //
	// packages/callback-hook/hook.js                                                 //
	//                                                                                //
	////////////////////////////////////////////////////////////////////////////////////
	                                                                                  //
	// XXX This pattern is under development. Do not add more callsites               // 1
	// using this package for now. See:                                               // 2
	// https://meteor.hackpad.com/Design-proposal-Hooks-YxvgEW06q6f                   // 3
	//                                                                                // 4
	// Encapsulates the pattern of registering callbacks on a hook.                   // 5
	//                                                                                // 6
	// The `each` method of the hook calls its iterator function argument             // 7
	// with each registered callback.  This allows the hook to                        // 8
	// conditionally decide not to call the callback (if, for example, the            // 9
	// observed object has been closed or terminated).                                // 10
	//                                                                                // 11
	// By default, callbacks are bound with `Meteor.bindEnvironment`, so they will be
	// called with the Meteor environment of the calling code that                    // 13
	// registered the callback. Override by passing { bindEnvironment: false }        // 14
	// to the constructor.                                                            // 15
	//                                                                                // 16
	// Registering a callback returns an object with a single `stop`                  // 17
	// method which unregisters the callback.                                         // 18
	//                                                                                // 19
	// The code is careful to allow a callback to be safely unregistered              // 20
	// while the callbacks are being iterated over.                                   // 21
	//                                                                                // 22
	// If the hook is configured with the `exceptionHandler` option, the              // 23
	// handler will be called if a called callback throws an exception.               // 24
	// By default (if the exception handler doesn't itself throw an                   // 25
	// exception, or if the iterator function doesn't return a falsy value            // 26
	// to terminate the calling of callbacks), the remaining callbacks                // 27
	// will still be called.                                                          // 28
	//                                                                                // 29
	// Alternatively, the `debugPrintExceptions` option can be specified              // 30
	// as string describing the callback.  On an exception the string and             // 31
	// the exception will be printed to the console log with                          // 32
	// `Meteor._debug`, and the exception otherwise ignored.                          // 33
	//                                                                                // 34
	// If an exception handler isn't specified, exceptions thrown in the              // 35
	// callback will propagate up to the iterator function, and will                  // 36
	// terminate calling the remaining callbacks if not caught.                       // 37
	                                                                                  // 38
	Hook = function (options) {                                                       // 39
	  var self = this;                                                                // 40
	  options = options || {};                                                        // 41
	  self.nextCallbackId = 0;                                                        // 42
	  self.callbacks = {};                                                            // 43
	  // Whether to wrap callbacks with Meteor.bindEnvironment                        // 44
	  self.bindEnvironment = true;                                                    // 45
	  if (options.bindEnvironment === false)                                          // 46
	    self.bindEnvironment = false;                                                 // 47
	                                                                                  // 48
	  if (options.exceptionHandler)                                                   // 49
	    self.exceptionHandler = options.exceptionHandler;                             // 50
	  else if (options.debugPrintExceptions) {                                        // 51
	    if (! _.isString(options.debugPrintExceptions))                               // 52
	      throw new Error("Hook option debugPrintExceptions should be a string");     // 53
	    self.exceptionHandler = options.debugPrintExceptions;                         // 54
	  }                                                                               // 55
	};                                                                                // 56
	                                                                                  // 57
	_.extend(Hook.prototype, {                                                        // 58
	  register: function (callback) {                                                 // 59
	    var self = this;                                                              // 60
	    var exceptionHandler =  self.exceptionHandler || function (exception) {       // 61
	      // Note: this relies on the undocumented fact that if bindEnvironment's     // 62
	      // onException throws, and you are invoking the callback either in the      // 63
	      // browser or from within a Fiber in Node, the exception is propagated.     // 64
	      throw exception;                                                            // 65
	    };                                                                            // 66
	                                                                                  // 67
	    if (self.bindEnvironment) {                                                   // 68
	      callback = Meteor.bindEnvironment(callback, exceptionHandler);              // 69
	    } else {                                                                      // 70
	      callback = dontBindEnvironment(callback, exceptionHandler);                 // 71
	    }                                                                             // 72
	                                                                                  // 73
	    var id = self.nextCallbackId++;                                               // 74
	    self.callbacks[id] = callback;                                                // 75
	                                                                                  // 76
	    return {                                                                      // 77
	      stop: function () {                                                         // 78
	        delete self.callbacks[id];                                                // 79
	      }                                                                           // 80
	    };                                                                            // 81
	  },                                                                              // 82
	                                                                                  // 83
	  // For each registered callback, call the passed iterator function              // 84
	  // with the callback.                                                           // 85
	  //                                                                              // 86
	  // The iterator function can choose whether or not to call the                  // 87
	  // callback.  (For example, it might not call the callback if the               // 88
	  // observed object has been closed or terminated).                              // 89
	  //                                                                              // 90
	  // The iteration is stopped if the iterator function returns a falsy            // 91
	  // value or throws an exception.                                                // 92
	  //                                                                              // 93
	  each: function (iterator) {                                                     // 94
	    var self = this;                                                              // 95
	                                                                                  // 96
	    // Invoking bindEnvironment'd callbacks outside of a Fiber in Node doesn't    // 97
	    // run them to completion (and exceptions thrown from onException are not     // 98
	    // propagated), so we need to be in a Fiber.                                  // 99
	    Meteor._nodeCodeMustBeInFiber();                                              // 100
	                                                                                  // 101
	    var ids = _.keys(self.callbacks);                                             // 102
	    for (var i = 0;  i < ids.length;  ++i) {                                      // 103
	      var id = ids[i];                                                            // 104
	      // check to see if the callback was removed during iteration                // 105
	      if (_.has(self.callbacks, id)) {                                            // 106
	        var callback = self.callbacks[id];                                        // 107
	                                                                                  // 108
	        if (! iterator(callback))                                                 // 109
	          break;                                                                  // 110
	      }                                                                           // 111
	    }                                                                             // 112
	  }                                                                               // 113
	});                                                                               // 114
	                                                                                  // 115
	// Copied from Meteor.bindEnvironment and removed all the env stuff.              // 116
	var dontBindEnvironment = function (func, onException, _this) {                   // 117
	  if (!onException || typeof(onException) === 'string') {                         // 118
	    var description = onException || "callback of async function";                // 119
	    onException = function (error) {                                              // 120
	      Meteor._debug(                                                              // 121
	        "Exception in " + description + ":",                                      // 122
	        error && error.stack || error                                             // 123
	      );                                                                          // 124
	    };                                                                            // 125
	  }                                                                               // 126
	                                                                                  // 127
	  return function (/* arguments */) {                                             // 128
	    var args = _.toArray(arguments);                                              // 129
	                                                                                  // 130
	    var runAndHandleExceptions = function () {                                    // 131
	      try {                                                                       // 132
	        var ret = func.apply(_this, args);                                        // 133
	      } catch (e) {                                                               // 134
	        onException(e);                                                           // 135
	      }                                                                           // 136
	      return ret;                                                                 // 137
	    };                                                                            // 138
	                                                                                  // 139
	    return runAndHandleExceptions();                                              // 140
	  };                                                                              // 141
	};                                                                                // 142
	                                                                                  // 143
	////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['callback-hook'] = {}, {
	  Hook: Hook
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/check.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var meteorInstall = Package.modules.meteorInstall;
	var Buffer = Package.modules.Buffer;
	var process = Package.modules.process;
	var _ = Package.underscore._;
	var EJSON = Package.ejson.EJSON;
	
	/* Package-scope variables */
	var check, Match;
	
	var require = meteorInstall({"node_modules":{"meteor":{"check":{"match.js":["./isPlainObject.js",function(require,exports){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                   //
	// packages/check/match.js                                                                                           //
	//                                                                                                                   //
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                     //
	// XXX docs                                                                                                          // 1
	                                                                                                                     // 2
	// Things we explicitly do NOT support:                                                                              // 3
	//    - heterogenous arrays                                                                                          // 4
	                                                                                                                     // 5
	var currentArgumentChecker = new Meteor.EnvironmentVariable;                                                         // 6
	var isPlainObject = require("./isPlainObject.js").isPlainObject;                                                     // 7
	                                                                                                                     // 8
	/**                                                                                                                  // 9
	 * @summary Check that a value matches a [pattern](#matchpatterns).                                                  // 10
	 * If the value does not match the pattern, throw a `Match.Error`.                                                   // 11
	 *                                                                                                                   // 12
	 * Particularly useful to assert that arguments to a function have the right                                         // 13
	 * types and structure.                                                                                              // 14
	 * @locus Anywhere                                                                                                   // 15
	 * @param {Any} value The value to check                                                                             // 16
	 * @param {MatchPattern} pattern The pattern to match                                                                // 17
	 * `value` against                                                                                                   // 18
	 */                                                                                                                  // 19
	var check = exports.check = function (value, pattern) {                                                              // 20
	  // Record that check got called, if somebody cared.                                                                // 21
	  //                                                                                                                 // 22
	  // We use getOrNullIfOutsideFiber so that it's OK to call check()                                                  // 23
	  // from non-Fiber server contexts; the downside is that if you forget to                                           // 24
	  // bindEnvironment on some random callback in your method/publisher,                                               // 25
	  // it might not find the argumentChecker and you'll get an error about                                             // 26
	  // not checking an argument that it looks like you're checking (instead                                            // 27
	  // of just getting a "Node code must run in a Fiber" error).                                                       // 28
	  var argChecker = currentArgumentChecker.getOrNullIfOutsideFiber();                                                 // 29
	  if (argChecker)                                                                                                    // 30
	    argChecker.checking(value);                                                                                      // 31
	  var result = testSubtree(value, pattern);                                                                          // 32
	  if (result) {                                                                                                      // 33
	    var err = new Match.Error(result.message);                                                                       // 34
	    if (result.path) {                                                                                               // 35
	      err.message += " in field " + result.path;                                                                     // 36
	      err.path = result.path;                                                                                        // 37
	    }                                                                                                                // 38
	    throw err;                                                                                                       // 39
	  }                                                                                                                  // 40
	};                                                                                                                   // 41
	                                                                                                                     // 42
	/**                                                                                                                  // 43
	 * @namespace Match                                                                                                  // 44
	 * @summary The namespace for all Match types and methods.                                                           // 45
	 */                                                                                                                  // 46
	var Match = exports.Match = {                                                                                        // 47
	  Optional: function (pattern) {                                                                                     // 48
	    return new Optional(pattern);                                                                                    // 49
	  },                                                                                                                 // 50
	  Maybe: function (pattern) {                                                                                        // 51
	    return new Maybe(pattern);                                                                                       // 52
	  },                                                                                                                 // 53
	  OneOf: function (/*arguments*/) {                                                                                  // 54
	    return new OneOf(_.toArray(arguments));                                                                          // 55
	  },                                                                                                                 // 56
	  Any: ['__any__'],                                                                                                  // 57
	  Where: function (condition) {                                                                                      // 58
	    return new Where(condition);                                                                                     // 59
	  },                                                                                                                 // 60
	  ObjectIncluding: function (pattern) {                                                                              // 61
	    return new ObjectIncluding(pattern);                                                                             // 62
	  },                                                                                                                 // 63
	  ObjectWithValues: function (pattern) {                                                                             // 64
	    return new ObjectWithValues(pattern);                                                                            // 65
	  },                                                                                                                 // 66
	  // Matches only signed 32-bit integers                                                                             // 67
	  Integer: ['__integer__'],                                                                                          // 68
	                                                                                                                     // 69
	  // XXX matchers should know how to describe themselves for errors                                                  // 70
	  Error: Meteor.makeErrorType("Match.Error", function (msg) {                                                        // 71
	    this.message = "Match error: " + msg;                                                                            // 72
	    // The path of the value that failed to match. Initially empty, this gets                                        // 73
	    // populated by catching and rethrowing the exception as it goes back up the                                     // 74
	    // stack.                                                                                                        // 75
	    // E.g.: "vals[3].entity.created"                                                                                // 76
	    this.path = "";                                                                                                  // 77
	    // If this gets sent over DDP, don't give full internal details but at least                                     // 78
	    // provide something better than 500 Internal server error.                                                      // 79
	    this.sanitizedError = new Meteor.Error(400, "Match failed");                                                     // 80
	  }),                                                                                                                // 81
	                                                                                                                     // 82
	  // Tests to see if value matches pattern. Unlike check, it merely returns true                                     // 83
	  // or false (unless an error other than Match.Error was thrown). It does not                                       // 84
	  // interact with _failIfArgumentsAreNotAllChecked.                                                                 // 85
	  // XXX maybe also implement a Match.match which returns more information about                                     // 86
	  //     failures but without using exception handling or doing what check()                                         // 87
	  //     does with _failIfArgumentsAreNotAllChecked and Meteor.Error conversion                                      // 88
	                                                                                                                     // 89
	  /**                                                                                                                // 90
	   * @summary Returns true if the value matches the pattern.                                                         // 91
	   * @locus Anywhere                                                                                                 // 92
	   * @param {Any} value The value to check                                                                           // 93
	   * @param {MatchPattern} pattern The pattern to match `value` against                                              // 94
	   */                                                                                                                // 95
	  test: function (value, pattern) {                                                                                  // 96
	    return !testSubtree(value, pattern);                                                                             // 97
	  },                                                                                                                 // 98
	                                                                                                                     // 99
	  // Runs `f.apply(context, args)`. If check() is not called on every element of                                     // 100
	  // `args` (either directly or in the first level of an array), throws an error                                     // 101
	  // (using `description` in the message).                                                                           // 102
	  //                                                                                                                 // 103
	  _failIfArgumentsAreNotAllChecked: function (f, context, args, description) {                                       // 104
	    var argChecker = new ArgumentChecker(args, description);                                                         // 105
	    var result = currentArgumentChecker.withValue(argChecker, function () {                                          // 106
	      return f.apply(context, args);                                                                                 // 107
	    });                                                                                                              // 108
	    // If f didn't itself throw, make sure it checked all of its arguments.                                          // 109
	    argChecker.throwUnlessAllArgumentsHaveBeenChecked();                                                             // 110
	    return result;                                                                                                   // 111
	  }                                                                                                                  // 112
	};                                                                                                                   // 113
	                                                                                                                     // 114
	var Optional = function (pattern) {                                                                                  // 115
	  this.pattern = pattern;                                                                                            // 116
	};                                                                                                                   // 117
	                                                                                                                     // 118
	var Maybe = function (pattern) {                                                                                     // 119
	  this.pattern = pattern;                                                                                            // 120
	};                                                                                                                   // 121
	                                                                                                                     // 122
	var OneOf = function (choices) {                                                                                     // 123
	  if (_.isEmpty(choices))                                                                                            // 124
	    throw new Error("Must provide at least one choice to Match.OneOf");                                              // 125
	  this.choices = choices;                                                                                            // 126
	};                                                                                                                   // 127
	                                                                                                                     // 128
	var Where = function (condition) {                                                                                   // 129
	  this.condition = condition;                                                                                        // 130
	};                                                                                                                   // 131
	                                                                                                                     // 132
	var ObjectIncluding = function (pattern) {                                                                           // 133
	  this.pattern = pattern;                                                                                            // 134
	};                                                                                                                   // 135
	                                                                                                                     // 136
	var ObjectWithValues = function (pattern) {                                                                          // 137
	  this.pattern = pattern;                                                                                            // 138
	};                                                                                                                   // 139
	                                                                                                                     // 140
	var stringForErrorMessage = function (value, options) {                                                              // 141
	  options = options || {};                                                                                           // 142
	                                                                                                                     // 143
	  if ( value === null ) return "null";                                                                               // 144
	                                                                                                                     // 145
	  if ( options.onlyShowType ) {                                                                                      // 146
	    return typeof value;                                                                                             // 147
	  }                                                                                                                  // 148
	                                                                                                                     // 149
	  // Your average non-object things.  Saves from doing the try/catch below for.                                      // 150
	  if ( typeof value !== "object" ) {                                                                                 // 151
	    return EJSON.stringify(value)                                                                                    // 152
	  }                                                                                                                  // 153
	                                                                                                                     // 154
	  try {                                                                                                              // 155
	    // Find objects with circular references since EJSON doesn't support them yet (Issue #4778 + Unaccepted PR)      // 156
	    // If the native stringify is going to choke, EJSON.stringify is going to choke too.                             // 157
	    JSON.stringify(value);                                                                                           // 158
	  } catch (stringifyError) {                                                                                         // 159
	    if ( stringifyError.name === "TypeError" ) {                                                                     // 160
	      return typeof value;                                                                                           // 161
	    }                                                                                                                // 162
	  }                                                                                                                  // 163
	                                                                                                                     // 164
	  return EJSON.stringify(value);                                                                                     // 165
	};                                                                                                                   // 166
	                                                                                                                     // 167
	var typeofChecks = [                                                                                                 // 168
	  [String, "string"],                                                                                                // 169
	  [Number, "number"],                                                                                                // 170
	  [Boolean, "boolean"],                                                                                              // 171
	  // While we don't allow undefined/function in EJSON, this is good for optional                                     // 172
	  // arguments with OneOf.                                                                                           // 173
	  [Function, "function"],                                                                                            // 174
	  [undefined, "undefined"]                                                                                           // 175
	];                                                                                                                   // 176
	                                                                                                                     // 177
	// Return `false` if it matches. Otherwise, return an object with a `message` and a `path` field.                    // 178
	var testSubtree = function (value, pattern) {                                                                        // 179
	  // Match anything!                                                                                                 // 180
	  if (pattern === Match.Any)                                                                                         // 181
	    return false;                                                                                                    // 182
	                                                                                                                     // 183
	  // Basic atomic types.                                                                                             // 184
	  // Do not match boxed objects (e.g. String, Boolean)                                                               // 185
	  for (var i = 0; i < typeofChecks.length; ++i) {                                                                    // 186
	    if (pattern === typeofChecks[i][0]) {                                                                            // 187
	      if (typeof value === typeofChecks[i][1])                                                                       // 188
	        return false;                                                                                                // 189
	      return {                                                                                                       // 190
	        message: "Expected " + typeofChecks[i][1] + ", got " + stringForErrorMessage(value, { onlyShowType: true }),
	        path: ""                                                                                                     // 192
	      };                                                                                                             // 193
	    }                                                                                                                // 194
	  }                                                                                                                  // 195
	                                                                                                                     // 196
	  if (pattern === null) {                                                                                            // 197
	    if (value === null) {                                                                                            // 198
	      return false;                                                                                                  // 199
	    }                                                                                                                // 200
	    return {                                                                                                         // 201
	      message: "Expected null, got " + stringForErrorMessage(value),                                                 // 202
	      path: ""                                                                                                       // 203
	    };                                                                                                               // 204
	  }                                                                                                                  // 205
	                                                                                                                     // 206
	  // Strings, numbers, and booleans match literally. Goes well with Match.OneOf.                                     // 207
	  if (typeof pattern === "string" || typeof pattern === "number" || typeof pattern === "boolean") {                  // 208
	    if (value === pattern)                                                                                           // 209
	      return false;                                                                                                  // 210
	    return {                                                                                                         // 211
	      message: "Expected " + pattern + ", got " + stringForErrorMessage(value),                                      // 212
	      path: ""                                                                                                       // 213
	    };                                                                                                               // 214
	  }                                                                                                                  // 215
	                                                                                                                     // 216
	  // Match.Integer is special type encoded with array                                                                // 217
	  if (pattern === Match.Integer) {                                                                                   // 218
	    // There is no consistent and reliable way to check if variable is a 64-bit                                      // 219
	    // integer. One of the popular solutions is to get reminder of division by 1                                     // 220
	    // but this method fails on really large floats with big precision.                                              // 221
	    // E.g.: 1.348192308491824e+23 % 1 === 0 in V8                                                                   // 222
	    // Bitwise operators work consistantly but always cast variable to 32-bit                                        // 223
	    // signed integer according to JavaScript specs.                                                                 // 224
	    if (typeof value === "number" && (value | 0) === value)                                                          // 225
	      return false;                                                                                                  // 226
	    return {                                                                                                         // 227
	      message: "Expected Integer, got " + stringForErrorMessage(value),                                              // 228
	      path: ""                                                                                                       // 229
	    };                                                                                                               // 230
	  }                                                                                                                  // 231
	                                                                                                                     // 232
	  // "Object" is shorthand for Match.ObjectIncluding({});                                                            // 233
	  if (pattern === Object)                                                                                            // 234
	    pattern = Match.ObjectIncluding({});                                                                             // 235
	                                                                                                                     // 236
	  // Array (checked AFTER Any, which is implemented as an Array).                                                    // 237
	  if (pattern instanceof Array) {                                                                                    // 238
	    if (pattern.length !== 1) {                                                                                      // 239
	      return {                                                                                                       // 240
	        message: "Bad pattern: arrays must have one type element" + stringForErrorMessage(pattern),                  // 241
	        path: ""                                                                                                     // 242
	      };                                                                                                             // 243
	    }                                                                                                                // 244
	    if (!_.isArray(value) && !_.isArguments(value)) {                                                                // 245
	      return {                                                                                                       // 246
	        message: "Expected array, got " + stringForErrorMessage(value),                                              // 247
	        path: ""                                                                                                     // 248
	      };                                                                                                             // 249
	    }                                                                                                                // 250
	                                                                                                                     // 251
	    for (var i = 0, length = value.length; i < length; i++) {                                                        // 252
	      var result = testSubtree(value[i], pattern[0]);                                                                // 253
	      if (result) {                                                                                                  // 254
	        result.path = _prependPath(i, result.path);                                                                  // 255
	        return result;                                                                                               // 256
	      }                                                                                                              // 257
	    }                                                                                                                // 258
	    return false;                                                                                                    // 259
	  }                                                                                                                  // 260
	                                                                                                                     // 261
	  // Arbitrary validation checks. The condition can return false or throw a                                          // 262
	  // Match.Error (ie, it can internally use check()) to fail.                                                        // 263
	  if (pattern instanceof Where) {                                                                                    // 264
	    var result;                                                                                                      // 265
	    try {                                                                                                            // 266
	      result = pattern.condition(value);                                                                             // 267
	    } catch (err) {                                                                                                  // 268
	      if (!(err instanceof Match.Error))                                                                             // 269
	        throw err;                                                                                                   // 270
	      return {                                                                                                       // 271
	        message: err.message,                                                                                        // 272
	        path: err.path                                                                                               // 273
	      };                                                                                                             // 274
	    }                                                                                                                // 275
	    if (result)                                                                                                      // 276
	      return false;                                                                                                  // 277
	    // XXX this error is terrible                                                                                    // 278
	    return {                                                                                                         // 279
	      message: "Failed Match.Where validation",                                                                      // 280
	      path: ""                                                                                                       // 281
	    };                                                                                                               // 282
	  }                                                                                                                  // 283
	                                                                                                                     // 284
	                                                                                                                     // 285
	  if (pattern instanceof Maybe) {                                                                                    // 286
	    pattern = Match.OneOf(undefined, null, pattern.pattern);                                                         // 287
	  }                                                                                                                  // 288
	  else if (pattern instanceof Optional) {                                                                            // 289
	    pattern = Match.OneOf(undefined, pattern.pattern);                                                               // 290
	  }                                                                                                                  // 291
	                                                                                                                     // 292
	  if (pattern instanceof OneOf) {                                                                                    // 293
	    for (var i = 0; i < pattern.choices.length; ++i) {                                                               // 294
	      var result = testSubtree(value, pattern.choices[i]);                                                           // 295
	      if (!result) {                                                                                                 // 296
	        // No error? Yay, return.                                                                                    // 297
	        return false;                                                                                                // 298
	      }                                                                                                              // 299
	      // Match errors just mean try another choice.                                                                  // 300
	    }                                                                                                                // 301
	    // XXX this error is terrible                                                                                    // 302
	    return {                                                                                                         // 303
	      message: "Failed Match.OneOf, Match.Maybe or Match.Optional validation",                                       // 304
	      path: ""                                                                                                       // 305
	    };                                                                                                               // 306
	  }                                                                                                                  // 307
	                                                                                                                     // 308
	  // A function that isn't something we special-case is assumed to be a                                              // 309
	  // constructor.                                                                                                    // 310
	  if (pattern instanceof Function) {                                                                                 // 311
	    if (value instanceof pattern)                                                                                    // 312
	      return false;                                                                                                  // 313
	    return {                                                                                                         // 314
	      message: "Expected " + (pattern.name ||"particular constructor"),                                              // 315
	      path: ""                                                                                                       // 316
	    };                                                                                                               // 317
	  }                                                                                                                  // 318
	                                                                                                                     // 319
	  var unknownKeysAllowed = false;                                                                                    // 320
	  var unknownKeyPattern;                                                                                             // 321
	  if (pattern instanceof ObjectIncluding) {                                                                          // 322
	    unknownKeysAllowed = true;                                                                                       // 323
	    pattern = pattern.pattern;                                                                                       // 324
	  }                                                                                                                  // 325
	  if (pattern instanceof ObjectWithValues) {                                                                         // 326
	    unknownKeysAllowed = true;                                                                                       // 327
	    unknownKeyPattern = [pattern.pattern];                                                                           // 328
	    pattern = {};  // no required keys                                                                               // 329
	  }                                                                                                                  // 330
	                                                                                                                     // 331
	  if (typeof pattern !== "object") {                                                                                 // 332
	    return {                                                                                                         // 333
	      message: "Bad pattern: unknown pattern type",                                                                  // 334
	      path: ""                                                                                                       // 335
	    };                                                                                                               // 336
	  }                                                                                                                  // 337
	                                                                                                                     // 338
	  // An object, with required and optional keys. Note that this does NOT do                                          // 339
	  // structural matches against objects of special types that happen to match                                        // 340
	  // the pattern: this really needs to be a plain old {Object}!                                                      // 341
	  if (typeof value !== 'object') {                                                                                   // 342
	    return {                                                                                                         // 343
	      message: "Expected object, got " + typeof value,                                                               // 344
	      path: ""                                                                                                       // 345
	    };                                                                                                               // 346
	  }                                                                                                                  // 347
	  if (value === null) {                                                                                              // 348
	    return {                                                                                                         // 349
	      message: "Expected object, got null",                                                                          // 350
	      path: ""                                                                                                       // 351
	    };                                                                                                               // 352
	  }                                                                                                                  // 353
	  if (! isPlainObject(value)) {                                                                                      // 354
	    return {                                                                                                         // 355
	      message: "Expected plain object",                                                                              // 356
	      path: ""                                                                                                       // 357
	    };                                                                                                               // 358
	  }                                                                                                                  // 359
	                                                                                                                     // 360
	  var requiredPatterns = {};                                                                                         // 361
	  var optionalPatterns = {};                                                                                         // 362
	  _.each(pattern, function (subPattern, key) {                                                                       // 363
	    if (subPattern instanceof Optional || subPattern instanceof Maybe)                                               // 364
	      optionalPatterns[key] = subPattern.pattern;                                                                    // 365
	    else                                                                                                             // 366
	      requiredPatterns[key] = subPattern;                                                                            // 367
	  });                                                                                                                // 368
	                                                                                                                     // 369
	  //XXX: replace with underscore's _.allKeys if Meteor updates underscore to 1.8+ (or lodash)                        // 370
	  var allKeys = function(obj){                                                                                       // 371
	    var keys = [];                                                                                                   // 372
	    if (_.isObject(obj)){                                                                                            // 373
	      for (var key in obj) keys.push(key);                                                                           // 374
	    }                                                                                                                // 375
	    return keys;                                                                                                     // 376
	  }                                                                                                                  // 377
	                                                                                                                     // 378
	  for (var keys = allKeys(value), i = 0, length = keys.length; i < length; i++) {                                    // 379
	    var key = keys[i];                                                                                               // 380
	    var subValue = value[key];                                                                                       // 381
	    if (_.has(requiredPatterns, key)) {                                                                              // 382
	      var result = testSubtree(subValue, requiredPatterns[key]);                                                     // 383
	      if (result) {                                                                                                  // 384
	        result.path = _prependPath(key, result.path);                                                                // 385
	        return result;                                                                                               // 386
	      }                                                                                                              // 387
	      delete requiredPatterns[key];                                                                                  // 388
	    } else if (_.has(optionalPatterns, key)) {                                                                       // 389
	      var result = testSubtree(subValue, optionalPatterns[key]);                                                     // 390
	      if (result) {                                                                                                  // 391
	        result.path = _prependPath(key, result.path);                                                                // 392
	        return result;                                                                                               // 393
	      }                                                                                                              // 394
	    } else {                                                                                                         // 395
	      if (!unknownKeysAllowed) {                                                                                     // 396
	        return {                                                                                                     // 397
	          message: "Unknown key",                                                                                    // 398
	          path: key                                                                                                  // 399
	        };                                                                                                           // 400
	      }                                                                                                              // 401
	      if (unknownKeyPattern) {                                                                                       // 402
	        var result = testSubtree(subValue, unknownKeyPattern[0]);                                                    // 403
	        if (result) {                                                                                                // 404
	          result.path = _prependPath(key, result.path);                                                              // 405
	          return result;                                                                                             // 406
	        }                                                                                                            // 407
	      }                                                                                                              // 408
	    }                                                                                                                // 409
	  }                                                                                                                  // 410
	                                                                                                                     // 411
	  var keys = _.keys(requiredPatterns);                                                                               // 412
	  if (keys.length) {                                                                                                 // 413
	    return {                                                                                                         // 414
	      message: "Missing key '" + keys[0] + "'",                                                                      // 415
	      path: ""                                                                                                       // 416
	    };                                                                                                               // 417
	  }                                                                                                                  // 418
	};                                                                                                                   // 419
	                                                                                                                     // 420
	var ArgumentChecker = function (args, description) {                                                                 // 421
	  var self = this;                                                                                                   // 422
	  // Make a SHALLOW copy of the arguments. (We'll be doing identity checks                                           // 423
	  // against its contents.)                                                                                          // 424
	  self.args = _.clone(args);                                                                                         // 425
	  // Since the common case will be to check arguments in order, and we splice                                        // 426
	  // out arguments when we check them, make it so we splice out from the end                                         // 427
	  // rather than the beginning.                                                                                      // 428
	  self.args.reverse();                                                                                               // 429
	  self.description = description;                                                                                    // 430
	};                                                                                                                   // 431
	                                                                                                                     // 432
	_.extend(ArgumentChecker.prototype, {                                                                                // 433
	  checking: function (value) {                                                                                       // 434
	    var self = this;                                                                                                 // 435
	    if (self._checkingOneValue(value))                                                                               // 436
	      return;                                                                                                        // 437
	    // Allow check(arguments, [String]) or check(arguments.slice(1), [String])                                       // 438
	    // or check([foo, bar], [String]) to count... but only if value wasn't                                           // 439
	    // itself an argument.                                                                                           // 440
	    if (_.isArray(value) || _.isArguments(value)) {                                                                  // 441
	      _.each(value, _.bind(self._checkingOneValue, self));                                                           // 442
	    }                                                                                                                // 443
	  },                                                                                                                 // 444
	  _checkingOneValue: function (value) {                                                                              // 445
	    var self = this;                                                                                                 // 446
	    for (var i = 0; i < self.args.length; ++i) {                                                                     // 447
	      // Is this value one of the arguments? (This can have a false positive if                                      // 448
	      // the argument is an interned primitive, but it's still a good enough                                         // 449
	      // check.)                                                                                                     // 450
	      // (NaN is not === to itself, so we have to check specially.)                                                  // 451
	      if (value === self.args[i] || (_.isNaN(value) && _.isNaN(self.args[i]))) {                                     // 452
	        self.args.splice(i, 1);                                                                                      // 453
	        return true;                                                                                                 // 454
	      }                                                                                                              // 455
	    }                                                                                                                // 456
	    return false;                                                                                                    // 457
	  },                                                                                                                 // 458
	  throwUnlessAllArgumentsHaveBeenChecked: function () {                                                              // 459
	    var self = this;                                                                                                 // 460
	    if (!_.isEmpty(self.args))                                                                                       // 461
	      throw new Error("Did not check() all arguments during " +                                                      // 462
	                      self.description);                                                                             // 463
	  }                                                                                                                  // 464
	});                                                                                                                  // 465
	                                                                                                                     // 466
	var _jsKeywords = ["do", "if", "in", "for", "let", "new", "try", "var", "case",                                      // 467
	  "else", "enum", "eval", "false", "null", "this", "true", "void", "with",                                           // 468
	  "break", "catch", "class", "const", "super", "throw", "while", "yield",                                            // 469
	  "delete", "export", "import", "public", "return", "static", "switch",                                              // 470
	  "typeof", "default", "extends", "finally", "package", "private", "continue",                                       // 471
	  "debugger", "function", "arguments", "interface", "protected", "implements",                                       // 472
	  "instanceof"];                                                                                                     // 473
	                                                                                                                     // 474
	// Assumes the base of path is already escaped properly                                                              // 475
	// returns key + base                                                                                                // 476
	var _prependPath = function (key, base) {                                                                            // 477
	  if ((typeof key) === "number" || key.match(/^[0-9]+$/))                                                            // 478
	    key = "[" + key + "]";                                                                                           // 479
	  else if (!key.match(/^[a-z_$][0-9a-z_$]*$/i) || _.contains(_jsKeywords, key))                                      // 480
	    key = JSON.stringify([key]);                                                                                     // 481
	                                                                                                                     // 482
	  if (base && base[0] !== "[")                                                                                       // 483
	    return key + '.' + base;                                                                                         // 484
	  return key + base;                                                                                                 // 485
	};                                                                                                                   // 486
	                                                                                                                     // 487
	                                                                                                                     // 488
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"isPlainObject.js":function(require,exports){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                   //
	// packages/check/isPlainObject.js                                                                                   //
	//                                                                                                                   //
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                     //
	// Copy of jQuery.isPlainObject for the server side from jQuery v1.11.2.                                             // 1
	                                                                                                                     // 2
	var class2type = {};                                                                                                 // 3
	                                                                                                                     // 4
	var toString = class2type.toString;                                                                                  // 5
	                                                                                                                     // 6
	var hasOwn = class2type.hasOwnProperty;                                                                              // 7
	                                                                                                                     // 8
	var support = {};                                                                                                    // 9
	                                                                                                                     // 10
	// Populate the class2type map                                                                                       // 11
	_.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(name, i) {               // 12
	  class2type[ "[object " + name + "]" ] = name.toLowerCase();                                                        // 13
	});                                                                                                                  // 14
	                                                                                                                     // 15
	function type( obj ) {                                                                                               // 16
	  if ( obj == null ) {                                                                                               // 17
	    return obj + "";                                                                                                 // 18
	  }                                                                                                                  // 19
	  return typeof obj === "object" || typeof obj === "function" ?                                                      // 20
	    class2type[ toString.call(obj) ] || "object" :                                                                   // 21
	    typeof obj;                                                                                                      // 22
	}                                                                                                                    // 23
	                                                                                                                     // 24
	function isWindow( obj ) {                                                                                           // 25
	  /* jshint eqeqeq: false */                                                                                         // 26
	  return obj != null && obj == obj.window;                                                                           // 27
	}                                                                                                                    // 28
	                                                                                                                     // 29
	exports.isPlainObject = function( obj ) {                                                                            // 30
	  var key;                                                                                                           // 31
	                                                                                                                     // 32
	  // Must be an Object.                                                                                              // 33
	  // Because of IE, we also have to check the presence of the constructor property.                                  // 34
	  // Make sure that DOM nodes and window objects don't pass through, as well                                         // 35
	  if ( !obj || type(obj) !== "object" || obj.nodeType || isWindow( obj ) ) {                                         // 36
	    return false;                                                                                                    // 37
	  }                                                                                                                  // 38
	                                                                                                                     // 39
	  try {                                                                                                              // 40
	    // Not own constructor property must be Object                                                                   // 41
	    if ( obj.constructor &&                                                                                          // 42
	         !hasOwn.call(obj, "constructor") &&                                                                         // 43
	         !hasOwn.call(obj.constructor.prototype, "isPrototypeOf") ) {                                                // 44
	      return false;                                                                                                  // 45
	    }                                                                                                                // 46
	  } catch ( e ) {                                                                                                    // 47
	    // IE8,9 Will throw exceptions on certain host objects #9897                                                     // 48
	    return false;                                                                                                    // 49
	  }                                                                                                                  // 50
	                                                                                                                     // 51
	  // Support: IE<9                                                                                                   // 52
	  // Handle iteration over inherited properties before own properties.                                               // 53
	  if ( support.ownLast ) {                                                                                           // 54
	    for ( key in obj ) {                                                                                             // 55
	      return hasOwn.call( obj, key );                                                                                // 56
	    }                                                                                                                // 57
	  }                                                                                                                  // 58
	                                                                                                                     // 59
	  // Own properties are enumerated firstly, so to speed up,                                                          // 60
	  // if last one is own, then all properties are own.                                                                // 61
	  for ( key in obj ) {}                                                                                              // 62
	                                                                                                                     // 63
	  return key === undefined || hasOwn.call( obj, key );                                                               // 64
	};                                                                                                                   // 65
	                                                                                                                     // 66
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}}}}},{"extensions":[".js",".json"]});
	var exports = require("./node_modules/meteor/check/match.js");
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.check = exports, {
	  check: check,
	  Match: Match
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/dburles_collection-helpers.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	var Mongo = Package.mongo.Mongo;
	
	(function(){
	
	//////////////////////////////////////////////////////////////////////////////
	//                                                                          //
	// packages/dburles_collection-helpers/collection-helpers.js                //
	//                                                                          //
	//////////////////////////////////////////////////////////////////////////////
	                                                                            //
	Mongo.Collection.prototype.helpers = function(helpers) {                    // 1
	  var self = this;                                                          // 2
	                                                                            // 3
	  if (self._transform && ! self._helpers)                                   // 4
	    throw new Meteor.Error("Can't apply helpers to '" +                     // 5
	      self._name + "' a transform function already exists!");               // 6
	                                                                            // 7
	  if (! self._helpers) {                                                    // 8
	    self._helpers = function Document(doc) { return _.extend(this, doc); };
	    self._transform = function(doc) {                                       // 10
	      return new self._helpers(doc);                                        // 11
	    };                                                                      // 12
	  }                                                                         // 13
	                                                                            // 14
	  _.each(helpers, function(helper, key) {                                   // 15
	    self._helpers.prototype[key] = helper;                                  // 16
	  });                                                                       // 17
	};                                                                          // 18
	                                                                            // 19
	//////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	Package['dburles:collection-helpers'] = {};
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/ddp-client.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var check = Package.check.check;
	var Match = Package.check.Match;
	var Random = Package.random.Random;
	var EJSON = Package.ejson.EJSON;
	var _ = Package.underscore._;
	var Tracker = Package.tracker.Tracker;
	var Deps = Package.tracker.Deps;
	var Retry = Package.retry.Retry;
	var IdMap = Package['id-map'].IdMap;
	var DDPCommon = Package['ddp-common'].DDPCommon;
	var DiffSequence = Package['diff-sequence'].DiffSequence;
	var MongoID = Package['mongo-id'].MongoID;
	
	/* Package-scope variables */
	var DDP, LivedataTest, MongoIDMap, SockJS, toSockjsUrl, toWebsocketUrl, allConnections;
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                //
	// packages/ddp-client/namespace.js                                                                               //
	//                                                                                                                //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                  //
	/**                                                                                                               // 1
	 * @namespace DDP                                                                                                 // 2
	 * @summary Namespace for DDP-related methods/classes.                                                            // 3
	 */                                                                                                               // 4
	DDP          = {};                                                                                                // 5
	LivedataTest = {};                                                                                                // 6
	                                                                                                                  // 7
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                //
	// packages/ddp-client/id_map.js                                                                                  //
	//                                                                                                                //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                  //
	MongoIDMap = function () {                                                                                        // 1
	  var self = this;                                                                                                // 2
	  IdMap.call(self, MongoID.idStringify, MongoID.idParse);                                                         // 3
	};                                                                                                                // 4
	                                                                                                                  // 5
	Meteor._inherits(MongoIDMap, IdMap);                                                                              // 6
	                                                                                                                  // 7
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                //
	// packages/ddp-client/sockjs-0.3.4.js                                                                            //
	//                                                                                                                //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                  //
	// XXX METEOR changes in <METEOR>                                                                                 // 1
	                                                                                                                  // 2
	/* SockJS client, version 0.3.4, http://sockjs.org, MIT License                                                   // 3
	                                                                                                                  // 4
	Copyright (c) 2011-2012 VMware, Inc.                                                                              // 5
	                                                                                                                  // 6
	Permission is hereby granted, free of charge, to any person obtaining a copy                                      // 7
	of this software and associated documentation files (the "Software"), to deal                                     // 8
	in the Software without restriction, including without limitation the rights                                      // 9
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell                                         // 10
	copies of the Software, and to permit persons to whom the Software is                                             // 11
	furnished to do so, subject to the following conditions:                                                          // 12
	                                                                                                                  // 13
	The above copyright notice and this permission notice shall be included in                                        // 14
	all copies or substantial portions of the Software.                                                               // 15
	                                                                                                                  // 16
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR                                        // 17
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,                                          // 18
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE                                       // 19
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER                                            // 20
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,                                     // 21
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN                                         // 22
	THE SOFTWARE.                                                                                                     // 23
	*/                                                                                                                // 24
	                                                                                                                  // 25
	// <METEOR> Commented out JSO implementation (use json package instead).                                          // 26
	// JSON2 by Douglas Crockford (minified).                                                                         // 27
	// var JSON;JSON||(JSON={}),function(){function str(a,b){var c,d,e,f,g=gap,h,i=b[a];i&&typeof i=="object"&&typeof i.toJSON=="function"&&(i=i.toJSON(a)),typeof rep=="function"&&(i=rep.call(b,a,i));switch(typeof i){case"string":return quote(i);case"number":return isFinite(i)?String(i):"null";case"boolean":case"null":return String(i);case"object":if(!i)return"null";gap+=indent,h=[];if(Object.prototype.toString.apply(i)==="[object Array]"){f=i.length;for(c=0;c<f;c+=1)h[c]=str(c,i)||"null";e=h.length===0?"[]":gap?"[\n"+gap+h.join(",\n"+gap)+"\n"+g+"]":"["+h.join(",")+"]",gap=g;return e}if(rep&&typeof rep=="object"){f=rep.length;for(c=0;c<f;c+=1)typeof rep[c]=="string"&&(d=rep[c],e=str(d,i),e&&h.push(quote(d)+(gap?": ":":")+e))}else for(d in i)Object.prototype.hasOwnProperty.call(i,d)&&(e=str(d,i),e&&h.push(quote(d)+(gap?": ":":")+e));e=h.length===0?"{}":gap?"{\n"+gap+h.join(",\n"+gap)+"\n"+g+"}":"{"+h.join(",")+"}",gap=g;return e}}function quote(a){escapable.lastIndex=0;return escapable.test(a)?'"'+a.replace(escapable,function(a){var b=meta[a];return typeof b=="string"?b:"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+a+'"'}function f(a){return a<10?"0"+a:a}"use strict",typeof Date.prototype.toJSON!="function"&&(Date.prototype.toJSON=function(a){return isFinite(this.valueOf())?this.getUTCFullYear()+"-"+f(this.getUTCMonth()+1)+"-"+f(this.getUTCDate())+"T"+f(this.getUTCHours())+":"+f(this.getUTCMinutes())+":"+f(this.getUTCSeconds())+"Z":null},String.prototype.toJSON=Number.prototype.toJSON=Boolean.prototype.toJSON=function(a){return this.valueOf()});var cx=/[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,escapable=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,gap,indent,meta={"\b":"\\b","\t":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},rep;typeof JSON.stringify!="function"&&(JSON.stringify=function(a,b,c){var d;gap="",indent="";if(typeof c=="number")for(d=0;d<c;d+=1)indent+=" ";else typeof c=="string"&&(indent=c);rep=b;if(!b||typeof b=="function"||typeof b=="object"&&typeof b.length=="number")return str("",{"":a});throw new Error("JSON.stringify")}),typeof JSON.parse!="function"&&(JSON.parse=function(text,reviver){function walk(a,b){var c,d,e=a[b];if(e&&typeof e=="object")for(c in e)Object.prototype.hasOwnProperty.call(e,c)&&(d=walk(e,c),d!==undefined?e[c]=d:delete e[c]);return reviver.call(a,b,e)}var j;text=String(text),cx.lastIndex=0,cx.test(text)&&(text=text.replace(cx,function(a){return"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4)}));if(/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,"@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:\s*\[)+/g,""))){j=eval("("+text+")");return typeof reviver=="function"?walk({"":j},""):j}throw new SyntaxError("JSON.parse")})}()
	// </METEOR>                                                                                                      // 29
	                                                                                                                  // 30
	//     [*] Including lib/index.js                                                                                 // 31
	// Public object                                                                                                  // 32
	SockJS = (function(){                                                                                             // 33
	              var _document = document;                                                                           // 34
	              var _window = window;                                                                               // 35
	              var utils = {};                                                                                     // 36
	                                                                                                                  // 37
	                                                                                                                  // 38
	//         [*] Including lib/reventtarget.js                                                                      // 39
	/*                                                                                                                // 40
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 41
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 42
	 *                                                                                                                // 43
	 * For the license see COPYING.                                                                                   // 44
	 * ***** END LICENSE BLOCK *****                                                                                  // 45
	 */                                                                                                               // 46
	                                                                                                                  // 47
	/* Simplified implementation of DOM2 EventTarget.                                                                 // 48
	 *   http://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-EventTarget                                       // 49
	 */                                                                                                               // 50
	var REventTarget = function() {};                                                                                 // 51
	REventTarget.prototype.addEventListener = function (eventType, listener) {                                        // 52
	    if(!this._listeners) {                                                                                        // 53
	         this._listeners = {};                                                                                    // 54
	    }                                                                                                             // 55
	    if(!(eventType in this._listeners)) {                                                                         // 56
	        this._listeners[eventType] = [];                                                                          // 57
	    }                                                                                                             // 58
	    var arr = this._listeners[eventType];                                                                         // 59
	    if(utils.arrIndexOf(arr, listener) === -1) {                                                                  // 60
	        arr.push(listener);                                                                                       // 61
	    }                                                                                                             // 62
	    return;                                                                                                       // 63
	};                                                                                                                // 64
	                                                                                                                  // 65
	REventTarget.prototype.removeEventListener = function (eventType, listener) {                                     // 66
	    if(!(this._listeners && (eventType in this._listeners))) {                                                    // 67
	        return;                                                                                                   // 68
	    }                                                                                                             // 69
	    var arr = this._listeners[eventType];                                                                         // 70
	    var idx = utils.arrIndexOf(arr, listener);                                                                    // 71
	    if (idx !== -1) {                                                                                             // 72
	        if(arr.length > 1) {                                                                                      // 73
	            this._listeners[eventType] = arr.slice(0, idx).concat( arr.slice(idx+1) );                            // 74
	        } else {                                                                                                  // 75
	            delete this._listeners[eventType];                                                                    // 76
	        }                                                                                                         // 77
	        return;                                                                                                   // 78
	    }                                                                                                             // 79
	    return;                                                                                                       // 80
	};                                                                                                                // 81
	                                                                                                                  // 82
	REventTarget.prototype.dispatchEvent = function (event) {                                                         // 83
	    var t = event.type;                                                                                           // 84
	    var args = Array.prototype.slice.call(arguments, 0);                                                          // 85
	    if (this['on'+t]) {                                                                                           // 86
	        this['on'+t].apply(this, args);                                                                           // 87
	    }                                                                                                             // 88
	    if (this._listeners && t in this._listeners) {                                                                // 89
	        for(var i=0; i < this._listeners[t].length; i++) {                                                        // 90
	            this._listeners[t][i].apply(this, args);                                                              // 91
	        }                                                                                                         // 92
	    }                                                                                                             // 93
	};                                                                                                                // 94
	//         [*] End of lib/reventtarget.js                                                                         // 95
	                                                                                                                  // 96
	                                                                                                                  // 97
	//         [*] Including lib/simpleevent.js                                                                       // 98
	/*                                                                                                                // 99
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 100
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 101
	 *                                                                                                                // 102
	 * For the license see COPYING.                                                                                   // 103
	 * ***** END LICENSE BLOCK *****                                                                                  // 104
	 */                                                                                                               // 105
	                                                                                                                  // 106
	var SimpleEvent = function(type, obj) {                                                                           // 107
	    this.type = type;                                                                                             // 108
	    if (typeof obj !== 'undefined') {                                                                             // 109
	        for(var k in obj) {                                                                                       // 110
	            if (!obj.hasOwnProperty(k)) continue;                                                                 // 111
	            this[k] = obj[k];                                                                                     // 112
	        }                                                                                                         // 113
	    }                                                                                                             // 114
	};                                                                                                                // 115
	                                                                                                                  // 116
	SimpleEvent.prototype.toString = function() {                                                                     // 117
	    var r = [];                                                                                                   // 118
	    for(var k in this) {                                                                                          // 119
	        if (!this.hasOwnProperty(k)) continue;                                                                    // 120
	        var v = this[k];                                                                                          // 121
	        if (typeof v === 'function') v = '[function]';                                                            // 122
	        r.push(k + '=' + v);                                                                                      // 123
	    }                                                                                                             // 124
	    return 'SimpleEvent(' + r.join(', ') + ')';                                                                   // 125
	};                                                                                                                // 126
	//         [*] End of lib/simpleevent.js                                                                          // 127
	                                                                                                                  // 128
	                                                                                                                  // 129
	//         [*] Including lib/eventemitter.js                                                                      // 130
	/*                                                                                                                // 131
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 132
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 133
	 *                                                                                                                // 134
	 * For the license see COPYING.                                                                                   // 135
	 * ***** END LICENSE BLOCK *****                                                                                  // 136
	 */                                                                                                               // 137
	                                                                                                                  // 138
	var EventEmitter = function(events) {                                                                             // 139
	    var that = this;                                                                                              // 140
	    that._events = events || [];                                                                                  // 141
	    that._listeners = {};                                                                                         // 142
	};                                                                                                                // 143
	EventEmitter.prototype.emit = function(type) {                                                                    // 144
	    var that = this;                                                                                              // 145
	    that._verifyType(type);                                                                                       // 146
	    if (that._nuked) return;                                                                                      // 147
	                                                                                                                  // 148
	    var args = Array.prototype.slice.call(arguments, 1);                                                          // 149
	    if (that['on'+type]) {                                                                                        // 150
	        that['on'+type].apply(that, args);                                                                        // 151
	    }                                                                                                             // 152
	    if (type in that._listeners) {                                                                                // 153
	        for(var i = 0; i < that._listeners[type].length; i++) {                                                   // 154
	            that._listeners[type][i].apply(that, args);                                                           // 155
	        }                                                                                                         // 156
	    }                                                                                                             // 157
	};                                                                                                                // 158
	                                                                                                                  // 159
	EventEmitter.prototype.on = function(type, callback) {                                                            // 160
	    var that = this;                                                                                              // 161
	    that._verifyType(type);                                                                                       // 162
	    if (that._nuked) return;                                                                                      // 163
	                                                                                                                  // 164
	    if (!(type in that._listeners)) {                                                                             // 165
	        that._listeners[type] = [];                                                                               // 166
	    }                                                                                                             // 167
	    that._listeners[type].push(callback);                                                                         // 168
	};                                                                                                                // 169
	                                                                                                                  // 170
	EventEmitter.prototype._verifyType = function(type) {                                                             // 171
	    var that = this;                                                                                              // 172
	    if (utils.arrIndexOf(that._events, type) === -1) {                                                            // 173
	        utils.log('Event ' + JSON.stringify(type) +                                                               // 174
	                  ' not listed ' + JSON.stringify(that._events) +                                                 // 175
	                  ' in ' + that);                                                                                 // 176
	    }                                                                                                             // 177
	};                                                                                                                // 178
	                                                                                                                  // 179
	EventEmitter.prototype.nuke = function() {                                                                        // 180
	    var that = this;                                                                                              // 181
	    that._nuked = true;                                                                                           // 182
	    for(var i=0; i<that._events.length; i++) {                                                                    // 183
	        delete that[that._events[i]];                                                                             // 184
	    }                                                                                                             // 185
	    that._listeners = {};                                                                                         // 186
	};                                                                                                                // 187
	//         [*] End of lib/eventemitter.js                                                                         // 188
	                                                                                                                  // 189
	                                                                                                                  // 190
	//         [*] Including lib/utils.js                                                                             // 191
	/*                                                                                                                // 192
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 193
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 194
	 *                                                                                                                // 195
	 * For the license see COPYING.                                                                                   // 196
	 * ***** END LICENSE BLOCK *****                                                                                  // 197
	 */                                                                                                               // 198
	                                                                                                                  // 199
	var random_string_chars = 'abcdefghijklmnopqrstuvwxyz0123456789_';                                                // 200
	utils.random_string = function(length, max) {                                                                     // 201
	    max = max || random_string_chars.length;                                                                      // 202
	    var i, ret = [];                                                                                              // 203
	    for(i=0; i < length; i++) {                                                                                   // 204
	        ret.push( random_string_chars.substr(Math.floor(Math.random() * max),1) );                                // 205
	    }                                                                                                             // 206
	    return ret.join('');                                                                                          // 207
	};                                                                                                                // 208
	utils.random_number = function(max) {                                                                             // 209
	    return Math.floor(Math.random() * max);                                                                       // 210
	};                                                                                                                // 211
	utils.random_number_string = function(max) {                                                                      // 212
	    var t = (''+(max - 1)).length;                                                                                // 213
	    var p = Array(t+1).join('0');                                                                                 // 214
	    return (p + utils.random_number(max)).slice(-t);                                                              // 215
	};                                                                                                                // 216
	                                                                                                                  // 217
	// Assuming that url looks like: http://asdasd:111/asd                                                            // 218
	utils.getOrigin = function(url) {                                                                                 // 219
	    url += '/';                                                                                                   // 220
	    var parts = url.split('/').slice(0, 3);                                                                       // 221
	    return parts.join('/');                                                                                       // 222
	};                                                                                                                // 223
	                                                                                                                  // 224
	utils.isSameOriginUrl = function(url_a, url_b) {                                                                  // 225
	    // location.origin would do, but it's not always available.                                                   // 226
	    if (!url_b) url_b = _window.location.href;                                                                    // 227
	                                                                                                                  // 228
	    return (url_a.split('/').slice(0,3).join('/')                                                                 // 229
	                ===                                                                                               // 230
	            url_b.split('/').slice(0,3).join('/'));                                                               // 231
	};                                                                                                                // 232
	                                                                                                                  // 233
	// <METEOR>                                                                                                       // 234
	// https://github.com/sockjs/sockjs-client/issues/79                                                              // 235
	utils.isSameOriginScheme = function(url_a, url_b) {                                                               // 236
	    if (!url_b) url_b = _window.location.href;                                                                    // 237
	                                                                                                                  // 238
	    return (url_a.split(':')[0]                                                                                   // 239
	                ===                                                                                               // 240
	            url_b.split(':')[0]);                                                                                 // 241
	};                                                                                                                // 242
	// </METEOR>                                                                                                      // 243
	                                                                                                                  // 244
	                                                                                                                  // 245
	utils.getParentDomain = function(url) {                                                                           // 246
	    // ipv4 ip address                                                                                            // 247
	    if (/^[0-9.]*$/.test(url)) return url;                                                                        // 248
	    // ipv6 ip address                                                                                            // 249
	    if (/^\[/.test(url)) return url;                                                                              // 250
	    // no dots                                                                                                    // 251
	    if (!(/[.]/.test(url))) return url;                                                                           // 252
	                                                                                                                  // 253
	    var parts = url.split('.').slice(1);                                                                          // 254
	    return parts.join('.');                                                                                       // 255
	};                                                                                                                // 256
	                                                                                                                  // 257
	utils.objectExtend = function(dst, src) {                                                                         // 258
	    for(var k in src) {                                                                                           // 259
	        if (src.hasOwnProperty(k)) {                                                                              // 260
	            dst[k] = src[k];                                                                                      // 261
	        }                                                                                                         // 262
	    }                                                                                                             // 263
	    return dst;                                                                                                   // 264
	};                                                                                                                // 265
	                                                                                                                  // 266
	var WPrefix = '_jp';                                                                                              // 267
	                                                                                                                  // 268
	utils.polluteGlobalNamespace = function() {                                                                       // 269
	    if (!(WPrefix in _window)) {                                                                                  // 270
	        _window[WPrefix] = {};                                                                                    // 271
	    }                                                                                                             // 272
	};                                                                                                                // 273
	                                                                                                                  // 274
	utils.closeFrame = function (code, reason) {                                                                      // 275
	    return 'c'+JSON.stringify([code, reason]);                                                                    // 276
	};                                                                                                                // 277
	                                                                                                                  // 278
	utils.userSetCode = function (code) {                                                                             // 279
	    return code === 1000 || (code >= 3000 && code <= 4999);                                                       // 280
	};                                                                                                                // 281
	                                                                                                                  // 282
	// See: http://www.erg.abdn.ac.uk/~gerrit/dccp/notes/ccid2/rto_estimator/                                         // 283
	// and RFC 2988.                                                                                                  // 284
	utils.countRTO = function (rtt) {                                                                                 // 285
	    var rto;                                                                                                      // 286
	    if (rtt > 100) {                                                                                              // 287
	        rto = 3 * rtt; // rto > 300msec                                                                           // 288
	    } else {                                                                                                      // 289
	        rto = rtt + 200; // 200msec < rto <= 300msec                                                              // 290
	    }                                                                                                             // 291
	    return rto;                                                                                                   // 292
	}                                                                                                                 // 293
	                                                                                                                  // 294
	utils.log = function() {                                                                                          // 295
	    if (_window.console && console.log && console.log.apply) {                                                    // 296
	        console.log.apply(console, arguments);                                                                    // 297
	    }                                                                                                             // 298
	};                                                                                                                // 299
	                                                                                                                  // 300
	utils.bind = function(fun, that) {                                                                                // 301
	    if (fun.bind) {                                                                                               // 302
	        return fun.bind(that);                                                                                    // 303
	    } else {                                                                                                      // 304
	        return function() {                                                                                       // 305
	            return fun.apply(that, arguments);                                                                    // 306
	        };                                                                                                        // 307
	    }                                                                                                             // 308
	};                                                                                                                // 309
	                                                                                                                  // 310
	utils.flatUrl = function(url) {                                                                                   // 311
	    return url.indexOf('?') === -1 && url.indexOf('#') === -1;                                                    // 312
	};                                                                                                                // 313
	                                                                                                                  // 314
	// `relativeTo` is an optional absolute URL. If provided, `url` will be                                           // 315
	// interpreted relative to `relativeTo`. Defaults to `document.location`.                                         // 316
	// <METEOR>                                                                                                       // 317
	utils.amendUrl = function(url, relativeTo) {                                                                      // 318
	    var baseUrl;                                                                                                  // 319
	    if (relativeTo === undefined) {                                                                               // 320
	      baseUrl = _document.location;                                                                               // 321
	    } else {                                                                                                      // 322
	      var protocolMatch = /^([a-z0-9.+-]+:)/i.exec(relativeTo);                                                   // 323
	      if (protocolMatch) {                                                                                        // 324
	        var protocol = protocolMatch[0].toLowerCase();                                                            // 325
	        var rest = relativeTo.substring(protocol.length);                                                         // 326
	        var hostMatch = /[a-z0-9\.-]+(:[0-9]+)?/.exec(rest);                                                      // 327
	        if (hostMatch)                                                                                            // 328
	          var host = hostMatch[0];                                                                                // 329
	      }                                                                                                           // 330
	      if (! protocol || ! host)                                                                                   // 331
	        throw new Error("relativeTo must be an absolute url");                                                    // 332
	      baseUrl = {                                                                                                 // 333
	        protocol: protocol,                                                                                       // 334
	        host: host                                                                                                // 335
	      };                                                                                                          // 336
	    }                                                                                                             // 337
	    if (!url) {                                                                                                   // 338
	        throw new Error('Wrong url for SockJS');                                                                  // 339
	    }                                                                                                             // 340
	    if (!utils.flatUrl(url)) {                                                                                    // 341
	        throw new Error('Only basic urls are supported in SockJS');                                               // 342
	    }                                                                                                             // 343
	                                                                                                                  // 344
	    //  '//abc' --> 'http://abc'                                                                                  // 345
	    if (url.indexOf('//') === 0) {                                                                                // 346
	        url = baseUrl.protocol + url;                                                                             // 347
	    }                                                                                                             // 348
	    // '/abc' --> 'http://localhost:1234/abc'                                                                     // 349
	    if (url.indexOf('/') === 0) {                                                                                 // 350
	        url = baseUrl.protocol + '//' + baseUrl.host + url;                                                       // 351
	    }                                                                                                             // 352
	    // </METEOR>                                                                                                  // 353
	    // strip trailing slashes                                                                                     // 354
	    url = url.replace(/[/]+$/,'');                                                                                // 355
	                                                                                                                  // 356
	    // We have a full url here, with proto and host. For some browsers                                            // 357
	    // http://localhost:80/ is not in the same origin as http://localhost/                                        // 358
		// Remove explicit :80 or :443 in such cases. See #74                                                            // 359
	    var parts = url.split("/");                                                                                   // 360
	    if ((parts[0] === "http:" && /:80$/.test(parts[2])) ||                                                        // 361
		    (parts[0] === "https:" && /:443$/.test(parts[2]))) {                                                         // 362
			parts[2] = parts[2].replace(/:(80|443)$/, "");                                                                  // 363
		}                                                                                                                // 364
	    url = parts.join("/");                                                                                        // 365
	    return url;                                                                                                   // 366
	};                                                                                                                // 367
	                                                                                                                  // 368
	// IE doesn't support [].indexOf.                                                                                 // 369
	utils.arrIndexOf = function(arr, obj){                                                                            // 370
	    for(var i=0; i < arr.length; i++){                                                                            // 371
	        if(arr[i] === obj){                                                                                       // 372
	            return i;                                                                                             // 373
	        }                                                                                                         // 374
	    }                                                                                                             // 375
	    return -1;                                                                                                    // 376
	};                                                                                                                // 377
	                                                                                                                  // 378
	utils.arrSkip = function(arr, obj) {                                                                              // 379
	    var idx = utils.arrIndexOf(arr, obj);                                                                         // 380
	    if (idx === -1) {                                                                                             // 381
	        return arr.slice();                                                                                       // 382
	    } else {                                                                                                      // 383
	        var dst = arr.slice(0, idx);                                                                              // 384
	        return dst.concat(arr.slice(idx+1));                                                                      // 385
	    }                                                                                                             // 386
	};                                                                                                                // 387
	                                                                                                                  // 388
	// Via: https://gist.github.com/1133122/2121c601c5549155483f50be3da5305e83b8c5df                                  // 389
	utils.isArray = Array.isArray || function(value) {                                                                // 390
	    return {}.toString.call(value).indexOf('Array') >= 0                                                          // 391
	};                                                                                                                // 392
	                                                                                                                  // 393
	utils.delay = function(t, fun) {                                                                                  // 394
	    if(typeof t === 'function') {                                                                                 // 395
	        fun = t;                                                                                                  // 396
	        t = 0;                                                                                                    // 397
	    }                                                                                                             // 398
	    return setTimeout(fun, t);                                                                                    // 399
	};                                                                                                                // 400
	                                                                                                                  // 401
	                                                                                                                  // 402
	// Chars worth escaping, as defined by Douglas Crockford:                                                         // 403
	//   https://github.com/douglascrockford/JSON-js/blob/47a9882cddeb1e8529e07af9736218075372b8ac/json2.js#L196      // 404
	var json_escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
	    json_lookup = {                                                                                               // 406
	"\u0000":"\\u0000","\u0001":"\\u0001","\u0002":"\\u0002","\u0003":"\\u0003",                                      // 407
	"\u0004":"\\u0004","\u0005":"\\u0005","\u0006":"\\u0006","\u0007":"\\u0007",                                      // 408
	"\b":"\\b","\t":"\\t","\n":"\\n","\u000b":"\\u000b","\f":"\\f","\r":"\\r",                                        // 409
	"\u000e":"\\u000e","\u000f":"\\u000f","\u0010":"\\u0010","\u0011":"\\u0011",                                      // 410
	"\u0012":"\\u0012","\u0013":"\\u0013","\u0014":"\\u0014","\u0015":"\\u0015",                                      // 411
	"\u0016":"\\u0016","\u0017":"\\u0017","\u0018":"\\u0018","\u0019":"\\u0019",                                      // 412
	"\u001a":"\\u001a","\u001b":"\\u001b","\u001c":"\\u001c","\u001d":"\\u001d",                                      // 413
	"\u001e":"\\u001e","\u001f":"\\u001f","\"":"\\\"","\\":"\\\\",                                                    // 414
	"\u007f":"\\u007f","\u0080":"\\u0080","\u0081":"\\u0081","\u0082":"\\u0082",                                      // 415
	"\u0083":"\\u0083","\u0084":"\\u0084","\u0085":"\\u0085","\u0086":"\\u0086",                                      // 416
	"\u0087":"\\u0087","\u0088":"\\u0088","\u0089":"\\u0089","\u008a":"\\u008a",                                      // 417
	"\u008b":"\\u008b","\u008c":"\\u008c","\u008d":"\\u008d","\u008e":"\\u008e",                                      // 418
	"\u008f":"\\u008f","\u0090":"\\u0090","\u0091":"\\u0091","\u0092":"\\u0092",                                      // 419
	"\u0093":"\\u0093","\u0094":"\\u0094","\u0095":"\\u0095","\u0096":"\\u0096",                                      // 420
	"\u0097":"\\u0097","\u0098":"\\u0098","\u0099":"\\u0099","\u009a":"\\u009a",                                      // 421
	"\u009b":"\\u009b","\u009c":"\\u009c","\u009d":"\\u009d","\u009e":"\\u009e",                                      // 422
	"\u009f":"\\u009f","\u00ad":"\\u00ad","\u0600":"\\u0600","\u0601":"\\u0601",                                      // 423
	"\u0602":"\\u0602","\u0603":"\\u0603","\u0604":"\\u0604","\u070f":"\\u070f",                                      // 424
	"\u17b4":"\\u17b4","\u17b5":"\\u17b5","\u200c":"\\u200c","\u200d":"\\u200d",                                      // 425
	"\u200e":"\\u200e","\u200f":"\\u200f","\u2028":"\\u2028","\u2029":"\\u2029",                                      // 426
	"\u202a":"\\u202a","\u202b":"\\u202b","\u202c":"\\u202c","\u202d":"\\u202d",                                      // 427
	"\u202e":"\\u202e","\u202f":"\\u202f","\u2060":"\\u2060","\u2061":"\\u2061",                                      // 428
	"\u2062":"\\u2062","\u2063":"\\u2063","\u2064":"\\u2064","\u2065":"\\u2065",                                      // 429
	"\u2066":"\\u2066","\u2067":"\\u2067","\u2068":"\\u2068","\u2069":"\\u2069",                                      // 430
	"\u206a":"\\u206a","\u206b":"\\u206b","\u206c":"\\u206c","\u206d":"\\u206d",                                      // 431
	"\u206e":"\\u206e","\u206f":"\\u206f","\ufeff":"\\ufeff","\ufff0":"\\ufff0",                                      // 432
	"\ufff1":"\\ufff1","\ufff2":"\\ufff2","\ufff3":"\\ufff3","\ufff4":"\\ufff4",                                      // 433
	"\ufff5":"\\ufff5","\ufff6":"\\ufff6","\ufff7":"\\ufff7","\ufff8":"\\ufff8",                                      // 434
	"\ufff9":"\\ufff9","\ufffa":"\\ufffa","\ufffb":"\\ufffb","\ufffc":"\\ufffc",                                      // 435
	"\ufffd":"\\ufffd","\ufffe":"\\ufffe","\uffff":"\\uffff"};                                                        // 436
	                                                                                                                  // 437
	// Some extra characters that Chrome gets wrong, and substitutes with                                             // 438
	// something else on the wire.                                                                                    // 439
	var extra_escapable = /[\x00-\x1f\ud800-\udfff\ufffe\uffff\u0300-\u0333\u033d-\u0346\u034a-\u034c\u0350-\u0352\u0357-\u0358\u035c-\u0362\u0374\u037e\u0387\u0591-\u05af\u05c4\u0610-\u0617\u0653-\u0654\u0657-\u065b\u065d-\u065e\u06df-\u06e2\u06eb-\u06ec\u0730\u0732-\u0733\u0735-\u0736\u073a\u073d\u073f-\u0741\u0743\u0745\u0747\u07eb-\u07f1\u0951\u0958-\u095f\u09dc-\u09dd\u09df\u0a33\u0a36\u0a59-\u0a5b\u0a5e\u0b5c-\u0b5d\u0e38-\u0e39\u0f43\u0f4d\u0f52\u0f57\u0f5c\u0f69\u0f72-\u0f76\u0f78\u0f80-\u0f83\u0f93\u0f9d\u0fa2\u0fa7\u0fac\u0fb9\u1939-\u193a\u1a17\u1b6b\u1cda-\u1cdb\u1dc0-\u1dcf\u1dfc\u1dfe\u1f71\u1f73\u1f75\u1f77\u1f79\u1f7b\u1f7d\u1fbb\u1fbe\u1fc9\u1fcb\u1fd3\u1fdb\u1fe3\u1feb\u1fee-\u1fef\u1ff9\u1ffb\u1ffd\u2000-\u2001\u20d0-\u20d1\u20d4-\u20d7\u20e7-\u20e9\u2126\u212a-\u212b\u2329-\u232a\u2adc\u302b-\u302c\uaab2-\uaab3\uf900-\ufa0d\ufa10\ufa12\ufa15-\ufa1e\ufa20\ufa22\ufa25-\ufa26\ufa2a-\ufa2d\ufa30-\ufa6d\ufa70-\ufad9\ufb1d\ufb1f\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufb4e\ufff0-\uffff]/g,
	    extra_lookup;                                                                                                 // 441
	                                                                                                                  // 442
	// JSON Quote string. Use native implementation when possible.                                                    // 443
	var JSONQuote = (JSON && JSON.stringify) || function(string) {                                                    // 444
	    json_escapable.lastIndex = 0;                                                                                 // 445
	    if (json_escapable.test(string)) {                                                                            // 446
	        string = string.replace(json_escapable, function(a) {                                                     // 447
	            return json_lookup[a];                                                                                // 448
	        });                                                                                                       // 449
	    }                                                                                                             // 450
	    return '"' + string + '"';                                                                                    // 451
	};                                                                                                                // 452
	                                                                                                                  // 453
	// This may be quite slow, so let's delay until user actually uses bad                                            // 454
	// characters.                                                                                                    // 455
	var unroll_lookup = function(escapable) {                                                                         // 456
	    var i;                                                                                                        // 457
	    var unrolled = {}                                                                                             // 458
	    var c = []                                                                                                    // 459
	    for(i=0; i<65536; i++) {                                                                                      // 460
	        c.push( String.fromCharCode(i) );                                                                         // 461
	    }                                                                                                             // 462
	    escapable.lastIndex = 0;                                                                                      // 463
	    c.join('').replace(escapable, function (a) {                                                                  // 464
	        unrolled[ a ] = '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);                                // 465
	        return '';                                                                                                // 466
	    });                                                                                                           // 467
	    escapable.lastIndex = 0;                                                                                      // 468
	    return unrolled;                                                                                              // 469
	};                                                                                                                // 470
	                                                                                                                  // 471
	// Quote string, also taking care of unicode characters that browsers                                             // 472
	// often break. Especially, take care of unicode surrogates:                                                      // 473
	//    http://en.wikipedia.org/wiki/Mapping_of_Unicode_characters#Surrogates                                       // 474
	utils.quote = function(string) {                                                                                  // 475
	    var quoted = JSONQuote(string);                                                                               // 476
	                                                                                                                  // 477
	    // In most cases this should be very fast and good enough.                                                    // 478
	    extra_escapable.lastIndex = 0;                                                                                // 479
	    if(!extra_escapable.test(quoted)) {                                                                           // 480
	        return quoted;                                                                                            // 481
	    }                                                                                                             // 482
	                                                                                                                  // 483
	    if(!extra_lookup) extra_lookup = unroll_lookup(extra_escapable);                                              // 484
	                                                                                                                  // 485
	    return quoted.replace(extra_escapable, function(a) {                                                          // 486
	        return extra_lookup[a];                                                                                   // 487
	    });                                                                                                           // 488
	}                                                                                                                 // 489
	                                                                                                                  // 490
	var _all_protocols = ['websocket',                                                                                // 491
	                      'xdr-streaming',                                                                            // 492
	                      'xhr-streaming',                                                                            // 493
	                      'iframe-eventsource',                                                                       // 494
	                      'iframe-htmlfile',                                                                          // 495
	                      'xdr-polling',                                                                              // 496
	                      'xhr-polling',                                                                              // 497
	                      'iframe-xhr-polling',                                                                       // 498
	                      'jsonp-polling'];                                                                           // 499
	                                                                                                                  // 500
	utils.probeProtocols = function() {                                                                               // 501
	    var probed = {};                                                                                              // 502
	    for(var i=0; i<_all_protocols.length; i++) {                                                                  // 503
	        var protocol = _all_protocols[i];                                                                         // 504
	        // User can have a typo in protocol name.                                                                 // 505
	        probed[protocol] = SockJS[protocol] &&                                                                    // 506
	                           SockJS[protocol].enabled();                                                            // 507
	    }                                                                                                             // 508
	    return probed;                                                                                                // 509
	};                                                                                                                // 510
	                                                                                                                  // 511
	utils.detectProtocols = function(probed, protocols_whitelist, info) {                                             // 512
	    var pe = {},                                                                                                  // 513
	        protocols = [];                                                                                           // 514
	    if (!protocols_whitelist) protocols_whitelist = _all_protocols;                                               // 515
	    for(var i=0; i<protocols_whitelist.length; i++) {                                                             // 516
	        var protocol = protocols_whitelist[i];                                                                    // 517
	        pe[protocol] = probed[protocol];                                                                          // 518
	    }                                                                                                             // 519
	    var maybe_push = function(protos) {                                                                           // 520
	        var proto = protos.shift();                                                                               // 521
	        if (pe[proto]) {                                                                                          // 522
	            protocols.push(proto);                                                                                // 523
	        } else {                                                                                                  // 524
	            if (protos.length > 0) {                                                                              // 525
	                maybe_push(protos);                                                                               // 526
	            }                                                                                                     // 527
	        }                                                                                                         // 528
	    }                                                                                                             // 529
	                                                                                                                  // 530
	    // 1. Websocket                                                                                               // 531
	    if (info.websocket !== false) {                                                                               // 532
	        maybe_push(['websocket']);                                                                                // 533
	    }                                                                                                             // 534
	                                                                                                                  // 535
	    // 2. Streaming                                                                                               // 536
	    if (pe['xhr-streaming'] && !info.null_origin) {                                                               // 537
	        protocols.push('xhr-streaming');                                                                          // 538
	    } else {                                                                                                      // 539
	        if (pe['xdr-streaming'] && !info.cookie_needed && !info.null_origin) {                                    // 540
	            protocols.push('xdr-streaming');                                                                      // 541
	        } else {                                                                                                  // 542
	            maybe_push(['iframe-eventsource',                                                                     // 543
	                        'iframe-htmlfile']);                                                                      // 544
	        }                                                                                                         // 545
	    }                                                                                                             // 546
	                                                                                                                  // 547
	    // 3. Polling                                                                                                 // 548
	    if (pe['xhr-polling'] && !info.null_origin) {                                                                 // 549
	        protocols.push('xhr-polling');                                                                            // 550
	    } else {                                                                                                      // 551
	        if (pe['xdr-polling'] && !info.cookie_needed && !info.null_origin) {                                      // 552
	            protocols.push('xdr-polling');                                                                        // 553
	        } else {                                                                                                  // 554
	            maybe_push(['iframe-xhr-polling',                                                                     // 555
	                        'jsonp-polling']);                                                                        // 556
	        }                                                                                                         // 557
	    }                                                                                                             // 558
	    return protocols;                                                                                             // 559
	}                                                                                                                 // 560
	//         [*] End of lib/utils.js                                                                                // 561
	                                                                                                                  // 562
	                                                                                                                  // 563
	//         [*] Including lib/dom.js                                                                               // 564
	/*                                                                                                                // 565
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 566
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 567
	 *                                                                                                                // 568
	 * For the license see COPYING.                                                                                   // 569
	 * ***** END LICENSE BLOCK *****                                                                                  // 570
	 */                                                                                                               // 571
	                                                                                                                  // 572
	// May be used by htmlfile jsonp and transports.                                                                  // 573
	var MPrefix = '_sockjs_global';                                                                                   // 574
	utils.createHook = function() {                                                                                   // 575
	    var window_id = 'a' + utils.random_string(8);                                                                 // 576
	    if (!(MPrefix in _window)) {                                                                                  // 577
	        var map = {};                                                                                             // 578
	        _window[MPrefix] = function(window_id) {                                                                  // 579
	            if (!(window_id in map)) {                                                                            // 580
	                map[window_id] = {                                                                                // 581
	                    id: window_id,                                                                                // 582
	                    del: function() {delete map[window_id];}                                                      // 583
	                };                                                                                                // 584
	            }                                                                                                     // 585
	            return map[window_id];                                                                                // 586
	        }                                                                                                         // 587
	    }                                                                                                             // 588
	    return _window[MPrefix](window_id);                                                                           // 589
	};                                                                                                                // 590
	                                                                                                                  // 591
	                                                                                                                  // 592
	                                                                                                                  // 593
	utils.attachMessage = function(listener) {                                                                        // 594
	    utils.attachEvent('message', listener);                                                                       // 595
	};                                                                                                                // 596
	utils.attachEvent = function(event, listener) {                                                                   // 597
	    if (typeof _window.addEventListener !== 'undefined') {                                                        // 598
	        _window.addEventListener(event, listener, false);                                                         // 599
	    } else {                                                                                                      // 600
	        // IE quirks.                                                                                             // 601
	        // According to: http://stevesouders.com/misc/test-postmessage.php                                        // 602
	        // the message gets delivered only to 'document', not 'window'.                                           // 603
	        _document.attachEvent("on" + event, listener);                                                            // 604
	        // I get 'window' for ie8.                                                                                // 605
	        _window.attachEvent("on" + event, listener);                                                              // 606
	    }                                                                                                             // 607
	};                                                                                                                // 608
	                                                                                                                  // 609
	utils.detachMessage = function(listener) {                                                                        // 610
	    utils.detachEvent('message', listener);                                                                       // 611
	};                                                                                                                // 612
	utils.detachEvent = function(event, listener) {                                                                   // 613
	    if (typeof _window.addEventListener !== 'undefined') {                                                        // 614
	        _window.removeEventListener(event, listener, false);                                                      // 615
	    } else {                                                                                                      // 616
	        _document.detachEvent("on" + event, listener);                                                            // 617
	        _window.detachEvent("on" + event, listener);                                                              // 618
	    }                                                                                                             // 619
	};                                                                                                                // 620
	                                                                                                                  // 621
	                                                                                                                  // 622
	var on_unload = {};                                                                                               // 623
	// Things registered after beforeunload are to be called immediately.                                             // 624
	var after_unload = false;                                                                                         // 625
	                                                                                                                  // 626
	var trigger_unload_callbacks = function() {                                                                       // 627
	    for(var ref in on_unload) {                                                                                   // 628
	        on_unload[ref]();                                                                                         // 629
	        delete on_unload[ref];                                                                                    // 630
	    };                                                                                                            // 631
	};                                                                                                                // 632
	                                                                                                                  // 633
	var unload_triggered = function() {                                                                               // 634
	    if(after_unload) return;                                                                                      // 635
	    after_unload = true;                                                                                          // 636
	    trigger_unload_callbacks();                                                                                   // 637
	};                                                                                                                // 638
	                                                                                                                  // 639
	// 'unload' alone is not reliable in opera within an iframe, but we                                               // 640
	// can't use `beforeunload` as IE fires it on javascript: links.                                                  // 641
	utils.attachEvent('unload', unload_triggered);                                                                    // 642
	                                                                                                                  // 643
	utils.unload_add = function(listener) {                                                                           // 644
	    var ref = utils.random_string(8);                                                                             // 645
	    on_unload[ref] = listener;                                                                                    // 646
	    if (after_unload) {                                                                                           // 647
	        utils.delay(trigger_unload_callbacks);                                                                    // 648
	    }                                                                                                             // 649
	    return ref;                                                                                                   // 650
	};                                                                                                                // 651
	utils.unload_del = function(ref) {                                                                                // 652
	    if (ref in on_unload)                                                                                         // 653
	        delete on_unload[ref];                                                                                    // 654
	};                                                                                                                // 655
	                                                                                                                  // 656
	                                                                                                                  // 657
	utils.createIframe = function (iframe_url, error_callback) {                                                      // 658
	    var iframe = _document.createElement('iframe');                                                               // 659
	    var tref, unload_ref;                                                                                         // 660
	    var unattach = function() {                                                                                   // 661
	        clearTimeout(tref);                                                                                       // 662
	        // Explorer had problems with that.                                                                       // 663
	        try {iframe.onload = null;} catch (x) {}                                                                  // 664
	        iframe.onerror = null;                                                                                    // 665
	    };                                                                                                            // 666
	    var cleanup = function() {                                                                                    // 667
	        if (iframe) {                                                                                             // 668
	            unattach();                                                                                           // 669
	            // This timeout makes chrome fire onbeforeunload event                                                // 670
	            // within iframe. Without the timeout it goes straight to                                             // 671
	            // onunload.                                                                                          // 672
	            setTimeout(function() {                                                                               // 673
	                if(iframe) {                                                                                      // 674
	                    iframe.parentNode.removeChild(iframe);                                                        // 675
	                }                                                                                                 // 676
	                iframe = null;                                                                                    // 677
	            }, 0);                                                                                                // 678
	            utils.unload_del(unload_ref);                                                                         // 679
	        }                                                                                                         // 680
	    };                                                                                                            // 681
	    var onerror = function(r) {                                                                                   // 682
	        if (iframe) {                                                                                             // 683
	            cleanup();                                                                                            // 684
	            error_callback(r);                                                                                    // 685
	        }                                                                                                         // 686
	    };                                                                                                            // 687
	    var post = function(msg, origin) {                                                                            // 688
	        try {                                                                                                     // 689
	            // When the iframe is not loaded, IE raises an exception                                              // 690
	            // on 'contentWindow'.                                                                                // 691
	            if (iframe && iframe.contentWindow) {                                                                 // 692
	                iframe.contentWindow.postMessage(msg, origin);                                                    // 693
	            }                                                                                                     // 694
	        } catch (x) {};                                                                                           // 695
	    };                                                                                                            // 696
	                                                                                                                  // 697
	    iframe.src = iframe_url;                                                                                      // 698
	    iframe.style.display = 'none';                                                                                // 699
	    iframe.style.position = 'absolute';                                                                           // 700
	    iframe.onerror = function(){onerror('onerror');};                                                             // 701
	    iframe.onload = function() {                                                                                  // 702
	        // `onload` is triggered before scripts on the iframe are                                                 // 703
	        // executed. Give it few seconds to actually load stuff.                                                  // 704
	        clearTimeout(tref);                                                                                       // 705
	        tref = setTimeout(function(){onerror('onload timeout');}, 2000);                                          // 706
	    };                                                                                                            // 707
	    _document.body.appendChild(iframe);                                                                           // 708
	    tref = setTimeout(function(){onerror('timeout');}, 15000);                                                    // 709
	    unload_ref = utils.unload_add(cleanup);                                                                       // 710
	    return {                                                                                                      // 711
	        post: post,                                                                                               // 712
	        cleanup: cleanup,                                                                                         // 713
	        loaded: unattach                                                                                          // 714
	    };                                                                                                            // 715
	};                                                                                                                // 716
	                                                                                                                  // 717
	utils.createHtmlfile = function (iframe_url, error_callback) {                                                    // 718
	    var doc = new ActiveXObject('htmlfile');                                                                      // 719
	    var tref, unload_ref;                                                                                         // 720
	    var iframe;                                                                                                   // 721
	    var unattach = function() {                                                                                   // 722
	        clearTimeout(tref);                                                                                       // 723
	    };                                                                                                            // 724
	    var cleanup = function() {                                                                                    // 725
	        if (doc) {                                                                                                // 726
	            unattach();                                                                                           // 727
	            utils.unload_del(unload_ref);                                                                         // 728
	            iframe.parentNode.removeChild(iframe);                                                                // 729
	            iframe = doc = null;                                                                                  // 730
	            CollectGarbage();                                                                                     // 731
	        }                                                                                                         // 732
	    };                                                                                                            // 733
	    var onerror = function(r)  {                                                                                  // 734
	        if (doc) {                                                                                                // 735
	            cleanup();                                                                                            // 736
	            error_callback(r);                                                                                    // 737
	        }                                                                                                         // 738
	    };                                                                                                            // 739
	    var post = function(msg, origin) {                                                                            // 740
	        try {                                                                                                     // 741
	            // When the iframe is not loaded, IE raises an exception                                              // 742
	            // on 'contentWindow'.                                                                                // 743
	            if (iframe && iframe.contentWindow) {                                                                 // 744
	                iframe.contentWindow.postMessage(msg, origin);                                                    // 745
	            }                                                                                                     // 746
	        } catch (x) {};                                                                                           // 747
	    };                                                                                                            // 748
	                                                                                                                  // 749
	    doc.open();                                                                                                   // 750
	    doc.write('<html><s' + 'cript>' +                                                                             // 751
	              'document.domain="' + document.domain + '";' +                                                      // 752
	              '</s' + 'cript></html>');                                                                           // 753
	    doc.close();                                                                                                  // 754
	    doc.parentWindow[WPrefix] = _window[WPrefix];                                                                 // 755
	    var c = doc.createElement('div');                                                                             // 756
	    doc.body.appendChild(c);                                                                                      // 757
	    iframe = doc.createElement('iframe');                                                                         // 758
	    c.appendChild(iframe);                                                                                        // 759
	    iframe.src = iframe_url;                                                                                      // 760
	    tref = setTimeout(function(){onerror('timeout');}, 15000);                                                    // 761
	    unload_ref = utils.unload_add(cleanup);                                                                       // 762
	    return {                                                                                                      // 763
	        post: post,                                                                                               // 764
	        cleanup: cleanup,                                                                                         // 765
	        loaded: unattach                                                                                          // 766
	    };                                                                                                            // 767
	};                                                                                                                // 768
	//         [*] End of lib/dom.js                                                                                  // 769
	                                                                                                                  // 770
	                                                                                                                  // 771
	//         [*] Including lib/dom2.js                                                                              // 772
	/*                                                                                                                // 773
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 774
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 775
	 *                                                                                                                // 776
	 * For the license see COPYING.                                                                                   // 777
	 * ***** END LICENSE BLOCK *****                                                                                  // 778
	 */                                                                                                               // 779
	                                                                                                                  // 780
	var AbstractXHRObject = function(){};                                                                             // 781
	AbstractXHRObject.prototype = new EventEmitter(['chunk', 'finish']);                                              // 782
	                                                                                                                  // 783
	AbstractXHRObject.prototype._start = function(method, url, payload, opts) {                                       // 784
	    var that = this;                                                                                              // 785
	                                                                                                                  // 786
	    try {                                                                                                         // 787
	        that.xhr = new XMLHttpRequest();                                                                          // 788
	    } catch(x) {};                                                                                                // 789
	                                                                                                                  // 790
	    if (!that.xhr) {                                                                                              // 791
	        try {                                                                                                     // 792
	            that.xhr = new _window.ActiveXObject('Microsoft.XMLHTTP');                                            // 793
	        } catch(x) {};                                                                                            // 794
	    }                                                                                                             // 795
	    if (_window.ActiveXObject || _window.XDomainRequest) {                                                        // 796
	        // IE8 caches even POSTs                                                                                  // 797
	        url += ((url.indexOf('?') === -1) ? '?' : '&') + 't='+(+new Date);                                        // 798
	    }                                                                                                             // 799
	                                                                                                                  // 800
	    // Explorer tends to keep connection open, even after the                                                     // 801
	    // tab gets closed: http://bugs.jquery.com/ticket/5280                                                        // 802
	    that.unload_ref = utils.unload_add(function(){that._cleanup(true);});                                         // 803
	    try {                                                                                                         // 804
	        that.xhr.open(method, url, true);                                                                         // 805
	    } catch(e) {                                                                                                  // 806
	        // IE raises an exception on wrong port.                                                                  // 807
	        that.emit('finish', 0, '');                                                                               // 808
	        that._cleanup();                                                                                          // 809
	        return;                                                                                                   // 810
	    };                                                                                                            // 811
	                                                                                                                  // 812
	    if (!opts || !opts.no_credentials) {                                                                          // 813
	        // Mozilla docs says https://developer.mozilla.org/en/XMLHttpRequest :                                    // 814
	        // "This never affects same-site requests."                                                               // 815
	        that.xhr.withCredentials = 'true';                                                                        // 816
	    }                                                                                                             // 817
	    if (opts && opts.headers) {                                                                                   // 818
	        for(var key in opts.headers) {                                                                            // 819
	            that.xhr.setRequestHeader(key, opts.headers[key]);                                                    // 820
	        }                                                                                                         // 821
	    }                                                                                                             // 822
	                                                                                                                  // 823
	    that.xhr.onreadystatechange = function() {                                                                    // 824
	        if (that.xhr) {                                                                                           // 825
	            var x = that.xhr;                                                                                     // 826
	            switch (x.readyState) {                                                                               // 827
	            case 3:                                                                                               // 828
	                // IE doesn't like peeking into responseText or status                                            // 829
	                // on Microsoft.XMLHTTP and readystate=3                                                          // 830
	                try {                                                                                             // 831
	                    var status = x.status;                                                                        // 832
	                    var text = x.responseText;                                                                    // 833
	                } catch (x) {};                                                                                   // 834
	                // IE returns 1223 for 204: http://bugs.jquery.com/ticket/1450                                    // 835
	                if (status === 1223) status = 204;                                                                // 836
	                                                                                                                  // 837
	                // IE does return readystate == 3 for 404 answers.                                                // 838
	                if (text && text.length > 0) {                                                                    // 839
	                    that.emit('chunk', status, text);                                                             // 840
	                }                                                                                                 // 841
	                break;                                                                                            // 842
	            case 4:                                                                                               // 843
	                var status = x.status;                                                                            // 844
	                // IE returns 1223 for 204: http://bugs.jquery.com/ticket/1450                                    // 845
	                if (status === 1223) status = 204;                                                                // 846
	                                                                                                                  // 847
	                that.emit('finish', status, x.responseText);                                                      // 848
	                that._cleanup(false);                                                                             // 849
	                break;                                                                                            // 850
	            }                                                                                                     // 851
	        }                                                                                                         // 852
	    };                                                                                                            // 853
	    that.xhr.send(payload);                                                                                       // 854
	};                                                                                                                // 855
	                                                                                                                  // 856
	AbstractXHRObject.prototype._cleanup = function(abort) {                                                          // 857
	    var that = this;                                                                                              // 858
	    if (!that.xhr) return;                                                                                        // 859
	    utils.unload_del(that.unload_ref);                                                                            // 860
	                                                                                                                  // 861
	    // IE needs this field to be a function                                                                       // 862
	    that.xhr.onreadystatechange = function(){};                                                                   // 863
	                                                                                                                  // 864
	    if (abort) {                                                                                                  // 865
	        try {                                                                                                     // 866
	            that.xhr.abort();                                                                                     // 867
	        } catch(x) {};                                                                                            // 868
	    }                                                                                                             // 869
	    that.unload_ref = that.xhr = null;                                                                            // 870
	};                                                                                                                // 871
	                                                                                                                  // 872
	AbstractXHRObject.prototype.close = function() {                                                                  // 873
	    var that = this;                                                                                              // 874
	    that.nuke();                                                                                                  // 875
	    that._cleanup(true);                                                                                          // 876
	};                                                                                                                // 877
	                                                                                                                  // 878
	var XHRCorsObject = utils.XHRCorsObject = function() {                                                            // 879
	    var that = this, args = arguments;                                                                            // 880
	    utils.delay(function(){that._start.apply(that, args);});                                                      // 881
	};                                                                                                                // 882
	XHRCorsObject.prototype = new AbstractXHRObject();                                                                // 883
	                                                                                                                  // 884
	var XHRLocalObject = utils.XHRLocalObject = function(method, url, payload) {                                      // 885
	    var that = this;                                                                                              // 886
	    utils.delay(function(){                                                                                       // 887
	        that._start(method, url, payload, {                                                                       // 888
	            no_credentials: true                                                                                  // 889
	        });                                                                                                       // 890
	    });                                                                                                           // 891
	};                                                                                                                // 892
	XHRLocalObject.prototype = new AbstractXHRObject();                                                               // 893
	                                                                                                                  // 894
	                                                                                                                  // 895
	                                                                                                                  // 896
	// References:                                                                                                    // 897
	//   http://ajaxian.com/archives/100-line-ajax-wrapper                                                            // 898
	//   http://msdn.microsoft.com/en-us/library/cc288060(v=VS.85).aspx                                               // 899
	var XDRObject = utils.XDRObject = function(method, url, payload) {                                                // 900
	    var that = this;                                                                                              // 901
	    utils.delay(function(){that._start(method, url, payload);});                                                  // 902
	};                                                                                                                // 903
	XDRObject.prototype = new EventEmitter(['chunk', 'finish']);                                                      // 904
	XDRObject.prototype._start = function(method, url, payload) {                                                     // 905
	    var that = this;                                                                                              // 906
	    var xdr = new XDomainRequest();                                                                               // 907
	    // IE caches even POSTs                                                                                       // 908
	    url += ((url.indexOf('?') === -1) ? '?' : '&') + 't='+(+new Date);                                            // 909
	                                                                                                                  // 910
	    var onerror = xdr.ontimeout = xdr.onerror = function() {                                                      // 911
	        that.emit('finish', 0, '');                                                                               // 912
	        that._cleanup(false);                                                                                     // 913
	    };                                                                                                            // 914
	    xdr.onprogress = function() {                                                                                 // 915
	        that.emit('chunk', 200, xdr.responseText);                                                                // 916
	    };                                                                                                            // 917
	    xdr.onload = function() {                                                                                     // 918
	        that.emit('finish', 200, xdr.responseText);                                                               // 919
	        that._cleanup(false);                                                                                     // 920
	    };                                                                                                            // 921
	    that.xdr = xdr;                                                                                               // 922
	    that.unload_ref = utils.unload_add(function(){that._cleanup(true);});                                         // 923
	    try {                                                                                                         // 924
	        // Fails with AccessDenied if port number is bogus                                                        // 925
	        that.xdr.open(method, url);                                                                               // 926
	        that.xdr.send(payload);                                                                                   // 927
	    } catch(x) {                                                                                                  // 928
	        onerror();                                                                                                // 929
	    }                                                                                                             // 930
	};                                                                                                                // 931
	                                                                                                                  // 932
	XDRObject.prototype._cleanup = function(abort) {                                                                  // 933
	    var that = this;                                                                                              // 934
	    if (!that.xdr) return;                                                                                        // 935
	    utils.unload_del(that.unload_ref);                                                                            // 936
	                                                                                                                  // 937
	    that.xdr.ontimeout = that.xdr.onerror = that.xdr.onprogress =                                                 // 938
	        that.xdr.onload = null;                                                                                   // 939
	    if (abort) {                                                                                                  // 940
	        try {                                                                                                     // 941
	            that.xdr.abort();                                                                                     // 942
	        } catch(x) {};                                                                                            // 943
	    }                                                                                                             // 944
	    that.unload_ref = that.xdr = null;                                                                            // 945
	};                                                                                                                // 946
	                                                                                                                  // 947
	XDRObject.prototype.close = function() {                                                                          // 948
	    var that = this;                                                                                              // 949
	    that.nuke();                                                                                                  // 950
	    that._cleanup(true);                                                                                          // 951
	};                                                                                                                // 952
	                                                                                                                  // 953
	// 1. Is natively via XHR                                                                                         // 954
	// 2. Is natively via XDR                                                                                         // 955
	// 3. Nope, but postMessage is there so it should work via the Iframe.                                            // 956
	// 4. Nope, sorry.                                                                                                // 957
	utils.isXHRCorsCapable = function() {                                                                             // 958
	    if (_window.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest()) {                                    // 959
	        return 1;                                                                                                 // 960
	    }                                                                                                             // 961
	    // XDomainRequest doesn't work if page is served from file://                                                 // 962
	    if (_window.XDomainRequest && _document.domain) {                                                             // 963
	        return 2;                                                                                                 // 964
	    }                                                                                                             // 965
	    if (IframeTransport.enabled()) {                                                                              // 966
	        return 3;                                                                                                 // 967
	    }                                                                                                             // 968
	    return 4;                                                                                                     // 969
	};                                                                                                                // 970
	//         [*] End of lib/dom2.js                                                                                 // 971
	                                                                                                                  // 972
	                                                                                                                  // 973
	//         [*] Including lib/sockjs.js                                                                            // 974
	/*                                                                                                                // 975
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 976
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 977
	 *                                                                                                                // 978
	 * For the license see COPYING.                                                                                   // 979
	 * ***** END LICENSE BLOCK *****                                                                                  // 980
	 */                                                                                                               // 981
	                                                                                                                  // 982
	var SockJS = function(url, dep_protocols_whitelist, options) {                                                    // 983
	    if (!(this instanceof SockJS)) {                                                                              // 984
	        // makes `new` optional                                                                                   // 985
	        return new SockJS(url, dep_protocols_whitelist, options);                                                 // 986
	    }                                                                                                             // 987
	                                                                                                                  // 988
	    var that = this, protocols_whitelist;                                                                         // 989
	    that._options = {devel: false, debug: false, protocols_whitelist: [],                                         // 990
	                     info: undefined, rtt: undefined};                                                            // 991
	    if (options) {                                                                                                // 992
	        utils.objectExtend(that._options, options);                                                               // 993
	    }                                                                                                             // 994
	    that._base_url = utils.amendUrl(url);                                                                         // 995
	    that._server = that._options.server || utils.random_number_string(1000);                                      // 996
	    if (that._options.protocols_whitelist &&                                                                      // 997
	        that._options.protocols_whitelist.length) {                                                               // 998
	        protocols_whitelist = that._options.protocols_whitelist;                                                  // 999
	    } else {                                                                                                      // 1000
	        // Deprecated API                                                                                         // 1001
	        if (typeof dep_protocols_whitelist === 'string' &&                                                        // 1002
	            dep_protocols_whitelist.length > 0) {                                                                 // 1003
	            protocols_whitelist = [dep_protocols_whitelist];                                                      // 1004
	        } else if (utils.isArray(dep_protocols_whitelist)) {                                                      // 1005
	            protocols_whitelist = dep_protocols_whitelist                                                         // 1006
	        } else {                                                                                                  // 1007
	            protocols_whitelist = null;                                                                           // 1008
	        }                                                                                                         // 1009
	        if (protocols_whitelist) {                                                                                // 1010
	            that._debug('Deprecated API: Use "protocols_whitelist" option ' +                                     // 1011
	                        'instead of supplying protocol list as a second ' +                                       // 1012
	                        'parameter to SockJS constructor.');                                                      // 1013
	        }                                                                                                         // 1014
	    }                                                                                                             // 1015
	    that._protocols = [];                                                                                         // 1016
	    that.protocol = null;                                                                                         // 1017
	    that.readyState = SockJS.CONNECTING;                                                                          // 1018
	    that._ir = createInfoReceiver(that._base_url);                                                                // 1019
	    that._ir.onfinish = function(info, rtt) {                                                                     // 1020
	        that._ir = null;                                                                                          // 1021
	        if (info) {                                                                                               // 1022
	            if (that._options.info) {                                                                             // 1023
	                // Override if user supplies the option                                                           // 1024
	                info = utils.objectExtend(info, that._options.info);                                              // 1025
	            }                                                                                                     // 1026
	            if (that._options.rtt) {                                                                              // 1027
	                rtt = that._options.rtt;                                                                          // 1028
	            }                                                                                                     // 1029
	            that._applyInfo(info, rtt, protocols_whitelist);                                                      // 1030
	            that._didClose();                                                                                     // 1031
	        } else {                                                                                                  // 1032
	            that._didClose(1002, 'Can\'t connect to server', true);                                               // 1033
	        }                                                                                                         // 1034
	    };                                                                                                            // 1035
	};                                                                                                                // 1036
	// Inheritance                                                                                                    // 1037
	SockJS.prototype = new REventTarget();                                                                            // 1038
	                                                                                                                  // 1039
	SockJS.version = "0.3.4";                                                                                         // 1040
	                                                                                                                  // 1041
	SockJS.CONNECTING = 0;                                                                                            // 1042
	SockJS.OPEN = 1;                                                                                                  // 1043
	SockJS.CLOSING = 2;                                                                                               // 1044
	SockJS.CLOSED = 3;                                                                                                // 1045
	                                                                                                                  // 1046
	SockJS.prototype._debug = function() {                                                                            // 1047
	    if (this._options.debug)                                                                                      // 1048
	        utils.log.apply(utils, arguments);                                                                        // 1049
	};                                                                                                                // 1050
	                                                                                                                  // 1051
	SockJS.prototype._dispatchOpen = function() {                                                                     // 1052
	    var that = this;                                                                                              // 1053
	    if (that.readyState === SockJS.CONNECTING) {                                                                  // 1054
	        if (that._transport_tref) {                                                                               // 1055
	            clearTimeout(that._transport_tref);                                                                   // 1056
	            that._transport_tref = null;                                                                          // 1057
	        }                                                                                                         // 1058
	        that.readyState = SockJS.OPEN;                                                                            // 1059
	        that.dispatchEvent(new SimpleEvent("open"));                                                              // 1060
	    } else {                                                                                                      // 1061
	        // The server might have been restarted, and lost track of our                                            // 1062
	        // connection.                                                                                            // 1063
	        that._didClose(1006, "Server lost session");                                                              // 1064
	    }                                                                                                             // 1065
	};                                                                                                                // 1066
	                                                                                                                  // 1067
	SockJS.prototype._dispatchMessage = function(data) {                                                              // 1068
	    var that = this;                                                                                              // 1069
	    if (that.readyState !== SockJS.OPEN)                                                                          // 1070
	            return;                                                                                               // 1071
	    that.dispatchEvent(new SimpleEvent("message", {data: data}));                                                 // 1072
	};                                                                                                                // 1073
	                                                                                                                  // 1074
	SockJS.prototype._dispatchHeartbeat = function(data) {                                                            // 1075
	    var that = this;                                                                                              // 1076
	    if (that.readyState !== SockJS.OPEN)                                                                          // 1077
	        return;                                                                                                   // 1078
	    that.dispatchEvent(new SimpleEvent('heartbeat', {}));                                                         // 1079
	};                                                                                                                // 1080
	                                                                                                                  // 1081
	SockJS.prototype._didClose = function(code, reason, force) {                                                      // 1082
	    var that = this;                                                                                              // 1083
	    if (that.readyState !== SockJS.CONNECTING &&                                                                  // 1084
	        that.readyState !== SockJS.OPEN &&                                                                        // 1085
	        that.readyState !== SockJS.CLOSING)                                                                       // 1086
	            throw new Error('INVALID_STATE_ERR');                                                                 // 1087
	    if (that._ir) {                                                                                               // 1088
	        that._ir.nuke();                                                                                          // 1089
	        that._ir = null;                                                                                          // 1090
	    }                                                                                                             // 1091
	                                                                                                                  // 1092
	    if (that._transport) {                                                                                        // 1093
	        that._transport.doCleanup();                                                                              // 1094
	        that._transport = null;                                                                                   // 1095
	    }                                                                                                             // 1096
	                                                                                                                  // 1097
	    var close_event = new SimpleEvent("close", {                                                                  // 1098
	        code: code,                                                                                               // 1099
	        reason: reason,                                                                                           // 1100
	        wasClean: utils.userSetCode(code)});                                                                      // 1101
	                                                                                                                  // 1102
	    if (!utils.userSetCode(code) &&                                                                               // 1103
	        that.readyState === SockJS.CONNECTING && !force) {                                                        // 1104
	        if (that._try_next_protocol(close_event)) {                                                               // 1105
	            return;                                                                                               // 1106
	        }                                                                                                         // 1107
	        close_event = new SimpleEvent("close", {code: 2000,                                                       // 1108
	                                                reason: "All transports failed",                                  // 1109
	                                                wasClean: false,                                                  // 1110
	                                                last_event: close_event});                                        // 1111
	    }                                                                                                             // 1112
	    that.readyState = SockJS.CLOSED;                                                                              // 1113
	                                                                                                                  // 1114
	    utils.delay(function() {                                                                                      // 1115
	                   that.dispatchEvent(close_event);                                                               // 1116
	                });                                                                                               // 1117
	};                                                                                                                // 1118
	                                                                                                                  // 1119
	SockJS.prototype._didMessage = function(data) {                                                                   // 1120
	    var that = this;                                                                                              // 1121
	    var type = data.slice(0, 1);                                                                                  // 1122
	    switch(type) {                                                                                                // 1123
	    case 'o':                                                                                                     // 1124
	        that._dispatchOpen();                                                                                     // 1125
	        break;                                                                                                    // 1126
	    case 'a':                                                                                                     // 1127
	        var payload = JSON.parse(data.slice(1) || '[]');                                                          // 1128
	        for(var i=0; i < payload.length; i++){                                                                    // 1129
	            that._dispatchMessage(payload[i]);                                                                    // 1130
	        }                                                                                                         // 1131
	        break;                                                                                                    // 1132
	    case 'm':                                                                                                     // 1133
	        var payload = JSON.parse(data.slice(1) || 'null');                                                        // 1134
	        that._dispatchMessage(payload);                                                                           // 1135
	        break;                                                                                                    // 1136
	    case 'c':                                                                                                     // 1137
	        var payload = JSON.parse(data.slice(1) || '[]');                                                          // 1138
	        that._didClose(payload[0], payload[1]);                                                                   // 1139
	        break;                                                                                                    // 1140
	    case 'h':                                                                                                     // 1141
	        that._dispatchHeartbeat();                                                                                // 1142
	        break;                                                                                                    // 1143
	    }                                                                                                             // 1144
	};                                                                                                                // 1145
	                                                                                                                  // 1146
	SockJS.prototype._try_next_protocol = function(close_event) {                                                     // 1147
	    var that = this;                                                                                              // 1148
	    if (that.protocol) {                                                                                          // 1149
	        that._debug('Closed transport:', that.protocol, ''+close_event);                                          // 1150
	        that.protocol = null;                                                                                     // 1151
	    }                                                                                                             // 1152
	    if (that._transport_tref) {                                                                                   // 1153
	        clearTimeout(that._transport_tref);                                                                       // 1154
	        that._transport_tref = null;                                                                              // 1155
	    }                                                                                                             // 1156
	                                                                                                                  // 1157
	    while(1) {                                                                                                    // 1158
	        var protocol = that.protocol = that._protocols.shift();                                                   // 1159
	        if (!protocol) {                                                                                          // 1160
	            return false;                                                                                         // 1161
	        }                                                                                                         // 1162
	        // Some protocols require access to `body`, what if were in                                               // 1163
	        // the `head`?                                                                                            // 1164
	        if (SockJS[protocol] &&                                                                                   // 1165
	            SockJS[protocol].need_body === true &&                                                                // 1166
	            (!_document.body ||                                                                                   // 1167
	             (typeof _document.readyState !== 'undefined'                                                         // 1168
	              && _document.readyState !== 'complete'))) {                                                         // 1169
	            that._protocols.unshift(protocol);                                                                    // 1170
	            that.protocol = 'waiting-for-load';                                                                   // 1171
	            utils.attachEvent('load', function(){                                                                 // 1172
	                that._try_next_protocol();                                                                        // 1173
	            });                                                                                                   // 1174
	            return true;                                                                                          // 1175
	        }                                                                                                         // 1176
	                                                                                                                  // 1177
	        if (!SockJS[protocol] ||                                                                                  // 1178
	              !SockJS[protocol].enabled(that._options)) {                                                         // 1179
	            that._debug('Skipping transport:', protocol);                                                         // 1180
	        } else {                                                                                                  // 1181
	            var roundTrips = SockJS[protocol].roundTrips || 1;                                                    // 1182
	            var to = ((that._options.rto || 0) * roundTrips) || 5000;                                             // 1183
	            that._transport_tref = utils.delay(to, function() {                                                   // 1184
	                if (that.readyState === SockJS.CONNECTING) {                                                      // 1185
	                    // I can't understand how it is possible to run                                               // 1186
	                    // this timer, when the state is CLOSED, but                                                  // 1187
	                    // apparently in IE everythin is possible.                                                    // 1188
	                    that._didClose(2007, "Transport timeouted");                                                  // 1189
	                }                                                                                                 // 1190
	            });                                                                                                   // 1191
	                                                                                                                  // 1192
	            var connid = utils.random_string(8);                                                                  // 1193
	            var trans_url = that._base_url + '/' + that._server + '/' + connid;                                   // 1194
	            that._debug('Opening transport:', protocol, ' url:'+trans_url,                                        // 1195
	                        ' RTO:'+that._options.rto);                                                               // 1196
	            that._transport = new SockJS[protocol](that, trans_url,                                               // 1197
	                                                   that._base_url);                                               // 1198
	            return true;                                                                                          // 1199
	        }                                                                                                         // 1200
	    }                                                                                                             // 1201
	};                                                                                                                // 1202
	                                                                                                                  // 1203
	SockJS.prototype.close = function(code, reason) {                                                                 // 1204
	    var that = this;                                                                                              // 1205
	    if (code && !utils.userSetCode(code))                                                                         // 1206
	        throw new Error("INVALID_ACCESS_ERR");                                                                    // 1207
	    if(that.readyState !== SockJS.CONNECTING &&                                                                   // 1208
	       that.readyState !== SockJS.OPEN) {                                                                         // 1209
	        return false;                                                                                             // 1210
	    }                                                                                                             // 1211
	    that.readyState = SockJS.CLOSING;                                                                             // 1212
	    that._didClose(code || 1000, reason || "Normal closure");                                                     // 1213
	    return true;                                                                                                  // 1214
	};                                                                                                                // 1215
	                                                                                                                  // 1216
	SockJS.prototype.send = function(data) {                                                                          // 1217
	    var that = this;                                                                                              // 1218
	    if (that.readyState === SockJS.CONNECTING)                                                                    // 1219
	        throw new Error('INVALID_STATE_ERR');                                                                     // 1220
	    if (that.readyState === SockJS.OPEN) {                                                                        // 1221
	        that._transport.doSend(utils.quote('' + data));                                                           // 1222
	    }                                                                                                             // 1223
	    return true;                                                                                                  // 1224
	};                                                                                                                // 1225
	                                                                                                                  // 1226
	SockJS.prototype._applyInfo = function(info, rtt, protocols_whitelist) {                                          // 1227
	    var that = this;                                                                                              // 1228
	    that._options.info = info;                                                                                    // 1229
	    that._options.rtt = rtt;                                                                                      // 1230
	    that._options.rto = utils.countRTO(rtt);                                                                      // 1231
	    that._options.info.null_origin = !_document.domain;                                                           // 1232
	    // Servers can override base_url, eg to provide a randomized domain name and                                  // 1233
	    // avoid browser per-domain connection limits.                                                                // 1234
	    if (info.base_url)                                                                                            // 1235
	      // <METEOR>                                                                                                 // 1236
	      that._base_url = utils.amendUrl(info.base_url, that._base_url);                                             // 1237
	      // </METEOR>                                                                                                // 1238
	    var probed = utils.probeProtocols();                                                                          // 1239
	    that._protocols = utils.detectProtocols(probed, protocols_whitelist, info);                                   // 1240
	// <METEOR>                                                                                                       // 1241
	// https://github.com/sockjs/sockjs-client/issues/79                                                              // 1242
	    // Hack to avoid XDR when using different protocols                                                           // 1243
	    // We're on IE trying to do cross-protocol. jsonp only.                                                       // 1244
	    if (!utils.isSameOriginScheme(that._base_url) &&                                                              // 1245
	        2 === utils.isXHRCorsCapable()) {                                                                         // 1246
	        that._protocols = ['jsonp-polling'];                                                                      // 1247
	    }                                                                                                             // 1248
	// </METEOR>                                                                                                      // 1249
	};                                                                                                                // 1250
	//         [*] End of lib/sockjs.js                                                                               // 1251
	                                                                                                                  // 1252
	                                                                                                                  // 1253
	//         [*] Including lib/trans-websocket.js                                                                   // 1254
	/*                                                                                                                // 1255
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 1256
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 1257
	 *                                                                                                                // 1258
	 * For the license see COPYING.                                                                                   // 1259
	 * ***** END LICENSE BLOCK *****                                                                                  // 1260
	 */                                                                                                               // 1261
	                                                                                                                  // 1262
	var WebSocketTransport = SockJS.websocket = function(ri, trans_url) {                                             // 1263
	    var that = this;                                                                                              // 1264
	    var url = trans_url + '/websocket';                                                                           // 1265
	    if (url.slice(0, 5) === 'https') {                                                                            // 1266
	        url = 'wss' + url.slice(5);                                                                               // 1267
	    } else {                                                                                                      // 1268
	        url = 'ws' + url.slice(4);                                                                                // 1269
	    }                                                                                                             // 1270
	    that.ri = ri;                                                                                                 // 1271
	    that.url = url;                                                                                               // 1272
	    var Constructor = _window.WebSocket || _window.MozWebSocket;                                                  // 1273
	                                                                                                                  // 1274
	    that.ws = new Constructor(that.url);                                                                          // 1275
	    that.ws.onmessage = function(e) {                                                                             // 1276
	        that.ri._didMessage(e.data);                                                                              // 1277
	    };                                                                                                            // 1278
	    // Firefox has an interesting bug. If a websocket connection is                                               // 1279
	    // created after onunload, it stays alive even when user                                                      // 1280
	    // navigates away from the page. In such situation let's lie -                                                // 1281
	    // let's not open the ws connection at all. See:                                                              // 1282
	    // https://github.com/sockjs/sockjs-client/issues/28                                                          // 1283
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=696085                                                        // 1284
	    that.unload_ref = utils.unload_add(function(){that.ws.close()});                                              // 1285
	    that.ws.onclose = function() {                                                                                // 1286
	        that.ri._didMessage(utils.closeFrame(1006, "WebSocket connection broken"));                               // 1287
	    };                                                                                                            // 1288
	};                                                                                                                // 1289
	                                                                                                                  // 1290
	WebSocketTransport.prototype.doSend = function(data) {                                                            // 1291
	    this.ws.send('[' + data + ']');                                                                               // 1292
	};                                                                                                                // 1293
	                                                                                                                  // 1294
	WebSocketTransport.prototype.doCleanup = function() {                                                             // 1295
	    var that = this;                                                                                              // 1296
	    var ws = that.ws;                                                                                             // 1297
	    if (ws) {                                                                                                     // 1298
	        ws.onmessage = ws.onclose = null;                                                                         // 1299
	        ws.close();                                                                                               // 1300
	        utils.unload_del(that.unload_ref);                                                                        // 1301
	        that.unload_ref = that.ri = that.ws = null;                                                               // 1302
	    }                                                                                                             // 1303
	};                                                                                                                // 1304
	                                                                                                                  // 1305
	WebSocketTransport.enabled = function() {                                                                         // 1306
	    return !!(_window.WebSocket || _window.MozWebSocket);                                                         // 1307
	};                                                                                                                // 1308
	                                                                                                                  // 1309
	// In theory, ws should require 1 round trip. But in chrome, this is                                              // 1310
	// not very stable over SSL. Most likely a ws connection requires a                                               // 1311
	// separate SSL connection, in which case 2 round trips are an                                                    // 1312
	// absolute minumum.                                                                                              // 1313
	WebSocketTransport.roundTrips = 2;                                                                                // 1314
	//         [*] End of lib/trans-websocket.js                                                                      // 1315
	                                                                                                                  // 1316
	                                                                                                                  // 1317
	//         [*] Including lib/trans-sender.js                                                                      // 1318
	/*                                                                                                                // 1319
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 1320
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 1321
	 *                                                                                                                // 1322
	 * For the license see COPYING.                                                                                   // 1323
	 * ***** END LICENSE BLOCK *****                                                                                  // 1324
	 */                                                                                                               // 1325
	                                                                                                                  // 1326
	var BufferedSender = function() {};                                                                               // 1327
	BufferedSender.prototype.send_constructor = function(sender) {                                                    // 1328
	    var that = this;                                                                                              // 1329
	    that.send_buffer = [];                                                                                        // 1330
	    that.sender = sender;                                                                                         // 1331
	};                                                                                                                // 1332
	BufferedSender.prototype.doSend = function(message) {                                                             // 1333
	    var that = this;                                                                                              // 1334
	    that.send_buffer.push(message);                                                                               // 1335
	    if (!that.send_stop) {                                                                                        // 1336
	        that.send_schedule();                                                                                     // 1337
	    }                                                                                                             // 1338
	};                                                                                                                // 1339
	                                                                                                                  // 1340
	// For polling transports in a situation when in the message callback,                                            // 1341
	// new message is being send. If the sending connection was started                                               // 1342
	// before receiving one, it is possible to saturate the network and                                               // 1343
	// timeout due to the lack of receiving socket. To avoid that we delay                                            // 1344
	// sending messages by some small time, in order to let receiving                                                 // 1345
	// connection be started beforehand. This is only a halfmeasure and                                               // 1346
	// does not fix the big problem, but it does make the tests go more                                               // 1347
	// stable on slow networks.                                                                                       // 1348
	BufferedSender.prototype.send_schedule_wait = function() {                                                        // 1349
	    var that = this;                                                                                              // 1350
	    var tref;                                                                                                     // 1351
	    that.send_stop = function() {                                                                                 // 1352
	        that.send_stop = null;                                                                                    // 1353
	        clearTimeout(tref);                                                                                       // 1354
	    };                                                                                                            // 1355
	    tref = utils.delay(25, function() {                                                                           // 1356
	        that.send_stop = null;                                                                                    // 1357
	        that.send_schedule();                                                                                     // 1358
	    });                                                                                                           // 1359
	};                                                                                                                // 1360
	                                                                                                                  // 1361
	BufferedSender.prototype.send_schedule = function() {                                                             // 1362
	    var that = this;                                                                                              // 1363
	    if (that.send_buffer.length > 0) {                                                                            // 1364
	        var payload = '[' + that.send_buffer.join(',') + ']';                                                     // 1365
	        that.send_stop = that.sender(that.trans_url, payload, function(success, abort_reason) {                   // 1366
	            that.send_stop = null;                                                                                // 1367
	            if (success === false) {                                                                              // 1368
	                that.ri._didClose(1006, 'Sending error ' + abort_reason);                                         // 1369
	            } else {                                                                                              // 1370
	                that.send_schedule_wait();                                                                        // 1371
	            }                                                                                                     // 1372
	        });                                                                                                       // 1373
	        that.send_buffer = [];                                                                                    // 1374
	    }                                                                                                             // 1375
	};                                                                                                                // 1376
	                                                                                                                  // 1377
	BufferedSender.prototype.send_destructor = function() {                                                           // 1378
	    var that = this;                                                                                              // 1379
	    if (that._send_stop) {                                                                                        // 1380
	        that._send_stop();                                                                                        // 1381
	    }                                                                                                             // 1382
	    that._send_stop = null;                                                                                       // 1383
	};                                                                                                                // 1384
	                                                                                                                  // 1385
	var jsonPGenericSender = function(url, payload, callback) {                                                       // 1386
	    var that = this;                                                                                              // 1387
	                                                                                                                  // 1388
	    if (!('_send_form' in that)) {                                                                                // 1389
	        var form = that._send_form = _document.createElement('form');                                             // 1390
	        var area = that._send_area = _document.createElement('textarea');                                         // 1391
	        area.name = 'd';                                                                                          // 1392
	        form.style.display = 'none';                                                                              // 1393
	        form.style.position = 'absolute';                                                                         // 1394
	        form.method = 'POST';                                                                                     // 1395
	        form.enctype = 'application/x-www-form-urlencoded';                                                       // 1396
	        form.acceptCharset = "UTF-8";                                                                             // 1397
	        form.appendChild(area);                                                                                   // 1398
	        _document.body.appendChild(form);                                                                         // 1399
	    }                                                                                                             // 1400
	    var form = that._send_form;                                                                                   // 1401
	    var area = that._send_area;                                                                                   // 1402
	    var id = 'a' + utils.random_string(8);                                                                        // 1403
	    form.target = id;                                                                                             // 1404
	    form.action = url + '/jsonp_send?i=' + id;                                                                    // 1405
	                                                                                                                  // 1406
	    var iframe;                                                                                                   // 1407
	    try {                                                                                                         // 1408
	        // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)                                    // 1409
	        iframe = _document.createElement('<iframe name="'+ id +'">');                                             // 1410
	    } catch(x) {                                                                                                  // 1411
	        iframe = _document.createElement('iframe');                                                               // 1412
	        iframe.name = id;                                                                                         // 1413
	    }                                                                                                             // 1414
	    iframe.id = id;                                                                                               // 1415
	    form.appendChild(iframe);                                                                                     // 1416
	    iframe.style.display = 'none';                                                                                // 1417
	                                                                                                                  // 1418
	    try {                                                                                                         // 1419
	        area.value = payload;                                                                                     // 1420
	    } catch(e) {                                                                                                  // 1421
	        utils.log('Your browser is seriously broken. Go home! ' + e.message);                                     // 1422
	    }                                                                                                             // 1423
	    form.submit();                                                                                                // 1424
	                                                                                                                  // 1425
	    var completed = function(e) {                                                                                 // 1426
	        if (!iframe.onerror) return;                                                                              // 1427
	        iframe.onreadystatechange = iframe.onerror = iframe.onload = null;                                        // 1428
	        // Opera mini doesn't like if we GC iframe                                                                // 1429
	        // immediately, thus this timeout.                                                                        // 1430
	        utils.delay(500, function() {                                                                             // 1431
	                       iframe.parentNode.removeChild(iframe);                                                     // 1432
	                       iframe = null;                                                                             // 1433
	                   });                                                                                            // 1434
	        area.value = '';                                                                                          // 1435
	        // It is not possible to detect if the iframe succeeded or                                                // 1436
	        // failed to submit our form.                                                                             // 1437
	        callback(true);                                                                                           // 1438
	    };                                                                                                            // 1439
	    iframe.onerror = iframe.onload = completed;                                                                   // 1440
	    iframe.onreadystatechange = function(e) {                                                                     // 1441
	        if (iframe.readyState == 'complete') completed();                                                         // 1442
	    };                                                                                                            // 1443
	    return completed;                                                                                             // 1444
	};                                                                                                                // 1445
	                                                                                                                  // 1446
	var createAjaxSender = function(AjaxObject) {                                                                     // 1447
	    return function(url, payload, callback) {                                                                     // 1448
	        var xo = new AjaxObject('POST', url + '/xhr_send', payload);                                              // 1449
	        xo.onfinish = function(status, text) {                                                                    // 1450
	            callback(status === 200 || status === 204,                                                            // 1451
	                     'http status ' + status);                                                                    // 1452
	        };                                                                                                        // 1453
	        return function(abort_reason) {                                                                           // 1454
	            callback(false, abort_reason);                                                                        // 1455
	        };                                                                                                        // 1456
	    };                                                                                                            // 1457
	};                                                                                                                // 1458
	//         [*] End of lib/trans-sender.js                                                                         // 1459
	                                                                                                                  // 1460
	                                                                                                                  // 1461
	//         [*] Including lib/trans-jsonp-receiver.js                                                              // 1462
	/*                                                                                                                // 1463
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 1464
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 1465
	 *                                                                                                                // 1466
	 * For the license see COPYING.                                                                                   // 1467
	 * ***** END LICENSE BLOCK *****                                                                                  // 1468
	 */                                                                                                               // 1469
	                                                                                                                  // 1470
	// Parts derived from Socket.io:                                                                                  // 1471
	//    https://github.com/LearnBoost/socket.io/blob/0.6.17/lib/socket.io/transports/jsonp-polling.js               // 1472
	// and jQuery-JSONP:                                                                                              // 1473
	//    https://code.google.com/p/jquery-jsonp/source/browse/trunk/core/jquery.jsonp.js                             // 1474
	var jsonPGenericReceiver = function(url, callback) {                                                              // 1475
	    var tref;                                                                                                     // 1476
	    var script = _document.createElement('script');                                                               // 1477
	    var script2;  // Opera synchronous load trick.                                                                // 1478
	    var close_script = function(frame) {                                                                          // 1479
	        if (script2) {                                                                                            // 1480
	            script2.parentNode.removeChild(script2);                                                              // 1481
	            script2 = null;                                                                                       // 1482
	        }                                                                                                         // 1483
	        if (script) {                                                                                             // 1484
	            clearTimeout(tref);                                                                                   // 1485
	            // Unfortunately, you can't really abort script loading of                                            // 1486
	            // the script.                                                                                        // 1487
	            script.parentNode.removeChild(script);                                                                // 1488
	            script.onreadystatechange = script.onerror =                                                          // 1489
	                script.onload = script.onclick = null;                                                            // 1490
	            script = null;                                                                                        // 1491
	            callback(frame);                                                                                      // 1492
	            callback = null;                                                                                      // 1493
	        }                                                                                                         // 1494
	    };                                                                                                            // 1495
	                                                                                                                  // 1496
	    // IE9 fires 'error' event after orsc or before, in random order.                                             // 1497
	    var loaded_okay = false;                                                                                      // 1498
	    var error_timer = null;                                                                                       // 1499
	                                                                                                                  // 1500
	    script.id = 'a' + utils.random_string(8);                                                                     // 1501
	    script.src = url;                                                                                             // 1502
	    script.type = 'text/javascript';                                                                              // 1503
	    script.charset = 'UTF-8';                                                                                     // 1504
	    script.onerror = function(e) {                                                                                // 1505
	        if (!error_timer) {                                                                                       // 1506
	            // Delay firing close_script.                                                                         // 1507
	            error_timer = setTimeout(function() {                                                                 // 1508
	                if (!loaded_okay) {                                                                               // 1509
	                    close_script(utils.closeFrame(                                                                // 1510
	                        1006,                                                                                     // 1511
	                        "JSONP script loaded abnormally (onerror)"));                                             // 1512
	                }                                                                                                 // 1513
	            }, 1000);                                                                                             // 1514
	        }                                                                                                         // 1515
	    };                                                                                                            // 1516
	    script.onload = function(e) {                                                                                 // 1517
	        close_script(utils.closeFrame(1006, "JSONP script loaded abnormally (onload)"));                          // 1518
	    };                                                                                                            // 1519
	                                                                                                                  // 1520
	    script.onreadystatechange = function(e) {                                                                     // 1521
	        if (/loaded|closed/.test(script.readyState)) {                                                            // 1522
	            if (script && script.htmlFor && script.onclick) {                                                     // 1523
	                loaded_okay = true;                                                                               // 1524
	                try {                                                                                             // 1525
	                    // In IE, actually execute the script.                                                        // 1526
	                    script.onclick();                                                                             // 1527
	                } catch (x) {}                                                                                    // 1528
	            }                                                                                                     // 1529
	            if (script) {                                                                                         // 1530
	                close_script(utils.closeFrame(1006, "JSONP script loaded abnormally (onreadystatechange)"));      // 1531
	            }                                                                                                     // 1532
	        }                                                                                                         // 1533
	    };                                                                                                            // 1534
	    // IE: event/htmlFor/onclick trick.                                                                           // 1535
	    // One can't rely on proper order for onreadystatechange. In order to                                         // 1536
	    // make sure, set a 'htmlFor' and 'event' properties, so that                                                 // 1537
	    // script code will be installed as 'onclick' handler for the                                                 // 1538
	    // script object. Later, onreadystatechange, manually execute this                                            // 1539
	    // code. FF and Chrome doesn't work with 'event' and 'htmlFor'                                                // 1540
	    // set. For reference see:                                                                                    // 1541
	    //   http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html                                    // 1542
	    // Also, read on that about script ordering:                                                                  // 1543
	    //   http://wiki.whatwg.org/wiki/Dynamic_Script_Execution_Order                                               // 1544
	    if (typeof script.async === 'undefined' && _document.attachEvent) {                                           // 1545
	        // According to mozilla docs, in recent browsers script.async defaults                                    // 1546
	        // to 'true', so we may use it to detect a good browser:                                                  // 1547
	        // https://developer.mozilla.org/en/HTML/Element/script                                                   // 1548
	        if (!/opera/i.test(navigator.userAgent)) {                                                                // 1549
	            // Naively assume we're in IE                                                                         // 1550
	            try {                                                                                                 // 1551
	                script.htmlFor = script.id;                                                                       // 1552
	                script.event = "onclick";                                                                         // 1553
	            } catch (x) {}                                                                                        // 1554
	            script.async = true;                                                                                  // 1555
	        } else {                                                                                                  // 1556
	            // Opera, second sync script hack                                                                     // 1557
	            script2 = _document.createElement('script');                                                          // 1558
	            script2.text = "try{var a = document.getElementById('"+script.id+"'); if(a)a.onerror();}catch(x){};";
	            script.async = script2.async = false;                                                                 // 1560
	        }                                                                                                         // 1561
	    }                                                                                                             // 1562
	    if (typeof script.async !== 'undefined') {                                                                    // 1563
	        script.async = true;                                                                                      // 1564
	    }                                                                                                             // 1565
	                                                                                                                  // 1566
	    // Fallback mostly for Konqueror - stupid timer, 35 seconds shall be plenty.                                  // 1567
	    tref = setTimeout(function() {                                                                                // 1568
	                          close_script(utils.closeFrame(1006, "JSONP script loaded abnormally (timeout)"));       // 1569
	                      }, 35000);                                                                                  // 1570
	                                                                                                                  // 1571
	    var head = _document.getElementsByTagName('head')[0];                                                         // 1572
	    head.insertBefore(script, head.firstChild);                                                                   // 1573
	    if (script2) {                                                                                                // 1574
	        head.insertBefore(script2, head.firstChild);                                                              // 1575
	    }                                                                                                             // 1576
	    return close_script;                                                                                          // 1577
	};                                                                                                                // 1578
	//         [*] End of lib/trans-jsonp-receiver.js                                                                 // 1579
	                                                                                                                  // 1580
	                                                                                                                  // 1581
	//         [*] Including lib/trans-jsonp-polling.js                                                               // 1582
	/*                                                                                                                // 1583
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 1584
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 1585
	 *                                                                                                                // 1586
	 * For the license see COPYING.                                                                                   // 1587
	 * ***** END LICENSE BLOCK *****                                                                                  // 1588
	 */                                                                                                               // 1589
	                                                                                                                  // 1590
	// The simplest and most robust transport, using the well-know cross                                              // 1591
	// domain hack - JSONP. This transport is quite inefficient - one                                                 // 1592
	// mssage could use up to one http request. But at least it works almost                                          // 1593
	// everywhere.                                                                                                    // 1594
	// Known limitations:                                                                                             // 1595
	//   o you will get a spinning cursor                                                                             // 1596
	//   o for Konqueror a dumb timer is needed to detect errors                                                      // 1597
	                                                                                                                  // 1598
	                                                                                                                  // 1599
	var JsonPTransport = SockJS['jsonp-polling'] = function(ri, trans_url) {                                          // 1600
	    utils.polluteGlobalNamespace();                                                                               // 1601
	    var that = this;                                                                                              // 1602
	    that.ri = ri;                                                                                                 // 1603
	    that.trans_url = trans_url;                                                                                   // 1604
	    that.send_constructor(jsonPGenericSender);                                                                    // 1605
	    that._schedule_recv();                                                                                        // 1606
	};                                                                                                                // 1607
	                                                                                                                  // 1608
	// Inheritnace                                                                                                    // 1609
	JsonPTransport.prototype = new BufferedSender();                                                                  // 1610
	                                                                                                                  // 1611
	JsonPTransport.prototype._schedule_recv = function() {                                                            // 1612
	    var that = this;                                                                                              // 1613
	    var callback = function(data) {                                                                               // 1614
	        that._recv_stop = null;                                                                                   // 1615
	        if (data) {                                                                                               // 1616
	            // no data - heartbeat;                                                                               // 1617
	            if (!that._is_closing) {                                                                              // 1618
	                that.ri._didMessage(data);                                                                        // 1619
	            }                                                                                                     // 1620
	        }                                                                                                         // 1621
	        // The message can be a close message, and change is_closing state.                                       // 1622
	        if (!that._is_closing) {                                                                                  // 1623
	            that._schedule_recv();                                                                                // 1624
	        }                                                                                                         // 1625
	    };                                                                                                            // 1626
	    that._recv_stop = jsonPReceiverWrapper(that.trans_url + '/jsonp',                                             // 1627
	                                           jsonPGenericReceiver, callback);                                       // 1628
	};                                                                                                                // 1629
	                                                                                                                  // 1630
	JsonPTransport.enabled = function() {                                                                             // 1631
	    return true;                                                                                                  // 1632
	};                                                                                                                // 1633
	                                                                                                                  // 1634
	JsonPTransport.need_body = true;                                                                                  // 1635
	                                                                                                                  // 1636
	                                                                                                                  // 1637
	JsonPTransport.prototype.doCleanup = function() {                                                                 // 1638
	    var that = this;                                                                                              // 1639
	    that._is_closing = true;                                                                                      // 1640
	    if (that._recv_stop) {                                                                                        // 1641
	        that._recv_stop();                                                                                        // 1642
	    }                                                                                                             // 1643
	    that.ri = that._recv_stop = null;                                                                             // 1644
	    that.send_destructor();                                                                                       // 1645
	};                                                                                                                // 1646
	                                                                                                                  // 1647
	                                                                                                                  // 1648
	// Abstract away code that handles global namespace pollution.                                                    // 1649
	var jsonPReceiverWrapper = function(url, constructReceiver, user_callback) {                                      // 1650
	    var id = 'a' + utils.random_string(6);                                                                        // 1651
	    var url_id = url + '?c=' + escape(WPrefix + '.' + id);                                                        // 1652
	                                                                                                                  // 1653
	    // Unfortunately it is not possible to abort loading of the                                                   // 1654
	    // script. We need to keep track of frake close frames.                                                       // 1655
	    var aborting = 0;                                                                                             // 1656
	                                                                                                                  // 1657
	    // Callback will be called exactly once.                                                                      // 1658
	    var callback = function(frame) {                                                                              // 1659
	        switch(aborting) {                                                                                        // 1660
	        case 0:                                                                                                   // 1661
	            // Normal behaviour - delete hook _and_ emit message.                                                 // 1662
	            delete _window[WPrefix][id];                                                                          // 1663
	            user_callback(frame);                                                                                 // 1664
	            break;                                                                                                // 1665
	        case 1:                                                                                                   // 1666
	            // Fake close frame - emit but don't delete hook.                                                     // 1667
	            user_callback(frame);                                                                                 // 1668
	            aborting = 2;                                                                                         // 1669
	            break;                                                                                                // 1670
	        case 2:                                                                                                   // 1671
	            // Got frame after connection was closed, delete hook, don't emit.                                    // 1672
	            delete _window[WPrefix][id];                                                                          // 1673
	            break;                                                                                                // 1674
	        }                                                                                                         // 1675
	    };                                                                                                            // 1676
	                                                                                                                  // 1677
	    var close_script = constructReceiver(url_id, callback);                                                       // 1678
	    _window[WPrefix][id] = close_script;                                                                          // 1679
	    var stop = function() {                                                                                       // 1680
	        if (_window[WPrefix][id]) {                                                                               // 1681
	            aborting = 1;                                                                                         // 1682
	            _window[WPrefix][id](utils.closeFrame(1000, "JSONP user aborted read"));                              // 1683
	        }                                                                                                         // 1684
	    };                                                                                                            // 1685
	    return stop;                                                                                                  // 1686
	};                                                                                                                // 1687
	//         [*] End of lib/trans-jsonp-polling.js                                                                  // 1688
	                                                                                                                  // 1689
	                                                                                                                  // 1690
	//         [*] Including lib/trans-xhr.js                                                                         // 1691
	/*                                                                                                                // 1692
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 1693
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 1694
	 *                                                                                                                // 1695
	 * For the license see COPYING.                                                                                   // 1696
	 * ***** END LICENSE BLOCK *****                                                                                  // 1697
	 */                                                                                                               // 1698
	                                                                                                                  // 1699
	var AjaxBasedTransport = function() {};                                                                           // 1700
	AjaxBasedTransport.prototype = new BufferedSender();                                                              // 1701
	                                                                                                                  // 1702
	AjaxBasedTransport.prototype.run = function(ri, trans_url,                                                        // 1703
	                                            url_suffix, Receiver, AjaxObject) {                                   // 1704
	    var that = this;                                                                                              // 1705
	    that.ri = ri;                                                                                                 // 1706
	    that.trans_url = trans_url;                                                                                   // 1707
	    that.send_constructor(createAjaxSender(AjaxObject));                                                          // 1708
	    that.poll = new Polling(ri, Receiver,                                                                         // 1709
	                            trans_url + url_suffix, AjaxObject);                                                  // 1710
	};                                                                                                                // 1711
	                                                                                                                  // 1712
	AjaxBasedTransport.prototype.doCleanup = function() {                                                             // 1713
	    var that = this;                                                                                              // 1714
	    if (that.poll) {                                                                                              // 1715
	        that.poll.abort();                                                                                        // 1716
	        that.poll = null;                                                                                         // 1717
	    }                                                                                                             // 1718
	};                                                                                                                // 1719
	                                                                                                                  // 1720
	// xhr-streaming                                                                                                  // 1721
	var XhrStreamingTransport = SockJS['xhr-streaming'] = function(ri, trans_url) {                                   // 1722
	    this.run(ri, trans_url, '/xhr_streaming', XhrReceiver, utils.XHRCorsObject);                                  // 1723
	};                                                                                                                // 1724
	                                                                                                                  // 1725
	XhrStreamingTransport.prototype = new AjaxBasedTransport();                                                       // 1726
	                                                                                                                  // 1727
	XhrStreamingTransport.enabled = function() {                                                                      // 1728
	    // Support for CORS Ajax aka Ajax2? Opera 12 claims CORS but                                                  // 1729
	    // doesn't do streaming.                                                                                      // 1730
	    return (_window.XMLHttpRequest &&                                                                             // 1731
	            'withCredentials' in new XMLHttpRequest() &&                                                          // 1732
	            (!/opera/i.test(navigator.userAgent)));                                                               // 1733
	};                                                                                                                // 1734
	XhrStreamingTransport.roundTrips = 2; // preflight, ajax                                                          // 1735
	                                                                                                                  // 1736
	// Safari gets confused when a streaming ajax request is started                                                  // 1737
	// before onload. This causes the load indicator to spin indefinetely.                                            // 1738
	XhrStreamingTransport.need_body = true;                                                                           // 1739
	                                                                                                                  // 1740
	                                                                                                                  // 1741
	// According to:                                                                                                  // 1742
	//   http://stackoverflow.com/questions/1641507/detect-browser-support-for-cross-domain-xmlhttprequests           // 1743
	//   http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/                                        // 1744
	                                                                                                                  // 1745
	                                                                                                                  // 1746
	// xdr-streaming                                                                                                  // 1747
	var XdrStreamingTransport = SockJS['xdr-streaming'] = function(ri, trans_url) {                                   // 1748
	    this.run(ri, trans_url, '/xhr_streaming', XhrReceiver, utils.XDRObject);                                      // 1749
	};                                                                                                                // 1750
	                                                                                                                  // 1751
	XdrStreamingTransport.prototype = new AjaxBasedTransport();                                                       // 1752
	                                                                                                                  // 1753
	XdrStreamingTransport.enabled = function() {                                                                      // 1754
	    return !!_window.XDomainRequest;                                                                              // 1755
	};                                                                                                                // 1756
	XdrStreamingTransport.roundTrips = 2; // preflight, ajax                                                          // 1757
	                                                                                                                  // 1758
	                                                                                                                  // 1759
	                                                                                                                  // 1760
	// xhr-polling                                                                                                    // 1761
	var XhrPollingTransport = SockJS['xhr-polling'] = function(ri, trans_url) {                                       // 1762
	    this.run(ri, trans_url, '/xhr', XhrReceiver, utils.XHRCorsObject);                                            // 1763
	};                                                                                                                // 1764
	                                                                                                                  // 1765
	XhrPollingTransport.prototype = new AjaxBasedTransport();                                                         // 1766
	                                                                                                                  // 1767
	XhrPollingTransport.enabled = XhrStreamingTransport.enabled;                                                      // 1768
	XhrPollingTransport.roundTrips = 2; // preflight, ajax                                                            // 1769
	                                                                                                                  // 1770
	                                                                                                                  // 1771
	// xdr-polling                                                                                                    // 1772
	var XdrPollingTransport = SockJS['xdr-polling'] = function(ri, trans_url) {                                       // 1773
	    this.run(ri, trans_url, '/xhr', XhrReceiver, utils.XDRObject);                                                // 1774
	};                                                                                                                // 1775
	                                                                                                                  // 1776
	XdrPollingTransport.prototype = new AjaxBasedTransport();                                                         // 1777
	                                                                                                                  // 1778
	XdrPollingTransport.enabled = XdrStreamingTransport.enabled;                                                      // 1779
	XdrPollingTransport.roundTrips = 2; // preflight, ajax                                                            // 1780
	//         [*] End of lib/trans-xhr.js                                                                            // 1781
	                                                                                                                  // 1782
	                                                                                                                  // 1783
	//         [*] Including lib/trans-iframe.js                                                                      // 1784
	/*                                                                                                                // 1785
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 1786
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 1787
	 *                                                                                                                // 1788
	 * For the license see COPYING.                                                                                   // 1789
	 * ***** END LICENSE BLOCK *****                                                                                  // 1790
	 */                                                                                                               // 1791
	                                                                                                                  // 1792
	// Few cool transports do work only for same-origin. In order to make                                             // 1793
	// them working cross-domain we shall use iframe, served form the                                                 // 1794
	// remote domain. New browsers, have capabilities to communicate with                                             // 1795
	// cross domain iframe, using postMessage(). In IE it was implemented                                             // 1796
	// from IE 8+, but of course, IE got some details wrong:                                                          // 1797
	//    http://msdn.microsoft.com/en-us/library/cc197015(v=VS.85).aspx                                              // 1798
	//    http://stevesouders.com/misc/test-postmessage.php                                                           // 1799
	                                                                                                                  // 1800
	var IframeTransport = function() {};                                                                              // 1801
	                                                                                                                  // 1802
	IframeTransport.prototype.i_constructor = function(ri, trans_url, base_url) {                                     // 1803
	    var that = this;                                                                                              // 1804
	    that.ri = ri;                                                                                                 // 1805
	    that.origin = utils.getOrigin(base_url);                                                                      // 1806
	    that.base_url = base_url;                                                                                     // 1807
	    that.trans_url = trans_url;                                                                                   // 1808
	                                                                                                                  // 1809
	    var iframe_url = base_url + '/iframe.html';                                                                   // 1810
	    if (that.ri._options.devel) {                                                                                 // 1811
	        iframe_url += '?t=' + (+new Date);                                                                        // 1812
	    }                                                                                                             // 1813
	    that.window_id = utils.random_string(8);                                                                      // 1814
	    iframe_url += '#' + that.window_id;                                                                           // 1815
	                                                                                                                  // 1816
	    that.iframeObj = utils.createIframe(iframe_url, function(r) {                                                 // 1817
	                                            that.ri._didClose(1006, "Unable to load an iframe (" + r + ")");      // 1818
	                                        });                                                                       // 1819
	                                                                                                                  // 1820
	    that.onmessage_cb = utils.bind(that.onmessage, that);                                                         // 1821
	    utils.attachMessage(that.onmessage_cb);                                                                       // 1822
	};                                                                                                                // 1823
	                                                                                                                  // 1824
	IframeTransport.prototype.doCleanup = function() {                                                                // 1825
	    var that = this;                                                                                              // 1826
	    if (that.iframeObj) {                                                                                         // 1827
	        utils.detachMessage(that.onmessage_cb);                                                                   // 1828
	        try {                                                                                                     // 1829
	            // When the iframe is not loaded, IE raises an exception                                              // 1830
	            // on 'contentWindow'.                                                                                // 1831
	            if (that.iframeObj.iframe.contentWindow) {                                                            // 1832
	                that.postMessage('c');                                                                            // 1833
	            }                                                                                                     // 1834
	        } catch (x) {}                                                                                            // 1835
	        that.iframeObj.cleanup();                                                                                 // 1836
	        that.iframeObj = null;                                                                                    // 1837
	        that.onmessage_cb = that.iframeObj = null;                                                                // 1838
	    }                                                                                                             // 1839
	};                                                                                                                // 1840
	                                                                                                                  // 1841
	IframeTransport.prototype.onmessage = function(e) {                                                               // 1842
	    var that = this;                                                                                              // 1843
	    if (e.origin !== that.origin) return;                                                                         // 1844
	    var window_id = e.data.slice(0, 8);                                                                           // 1845
	    var type = e.data.slice(8, 9);                                                                                // 1846
	    var data = e.data.slice(9);                                                                                   // 1847
	                                                                                                                  // 1848
	    if (window_id !== that.window_id) return;                                                                     // 1849
	                                                                                                                  // 1850
	    switch(type) {                                                                                                // 1851
	    case 's':                                                                                                     // 1852
	        that.iframeObj.loaded();                                                                                  // 1853
	        that.postMessage('s', JSON.stringify([SockJS.version, that.protocol, that.trans_url, that.base_url]));    // 1854
	        break;                                                                                                    // 1855
	    case 't':                                                                                                     // 1856
	        that.ri._didMessage(data);                                                                                // 1857
	        break;                                                                                                    // 1858
	    }                                                                                                             // 1859
	};                                                                                                                // 1860
	                                                                                                                  // 1861
	IframeTransport.prototype.postMessage = function(type, data) {                                                    // 1862
	    var that = this;                                                                                              // 1863
	    that.iframeObj.post(that.window_id + type + (data || ''), that.origin);                                       // 1864
	};                                                                                                                // 1865
	                                                                                                                  // 1866
	IframeTransport.prototype.doSend = function (message) {                                                           // 1867
	    this.postMessage('m', message);                                                                               // 1868
	};                                                                                                                // 1869
	                                                                                                                  // 1870
	IframeTransport.enabled = function() {                                                                            // 1871
	    // postMessage misbehaves in konqueror 4.6.5 - the messages are delivered with                                // 1872
	    // huge delay, or not at all.                                                                                 // 1873
	    var konqueror = navigator && navigator.userAgent && navigator.userAgent.indexOf('Konqueror') !== -1;          // 1874
	    return ((typeof _window.postMessage === 'function' ||                                                         // 1875
	            typeof _window.postMessage === 'object') && (!konqueror));                                            // 1876
	};                                                                                                                // 1877
	//         [*] End of lib/trans-iframe.js                                                                         // 1878
	                                                                                                                  // 1879
	                                                                                                                  // 1880
	//         [*] Including lib/trans-iframe-within.js                                                               // 1881
	/*                                                                                                                // 1882
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 1883
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 1884
	 *                                                                                                                // 1885
	 * For the license see COPYING.                                                                                   // 1886
	 * ***** END LICENSE BLOCK *****                                                                                  // 1887
	 */                                                                                                               // 1888
	                                                                                                                  // 1889
	var curr_window_id;                                                                                               // 1890
	                                                                                                                  // 1891
	var postMessage = function (type, data) {                                                                         // 1892
	    if(parent !== _window) {                                                                                      // 1893
	        parent.postMessage(curr_window_id + type + (data || ''), '*');                                            // 1894
	    } else {                                                                                                      // 1895
	        utils.log("Can't postMessage, no parent window.", type, data);                                            // 1896
	    }                                                                                                             // 1897
	};                                                                                                                // 1898
	                                                                                                                  // 1899
	var FacadeJS = function() {};                                                                                     // 1900
	FacadeJS.prototype._didClose = function (code, reason) {                                                          // 1901
	    postMessage('t', utils.closeFrame(code, reason));                                                             // 1902
	};                                                                                                                // 1903
	FacadeJS.prototype._didMessage = function (frame) {                                                               // 1904
	    postMessage('t', frame);                                                                                      // 1905
	};                                                                                                                // 1906
	FacadeJS.prototype._doSend = function (data) {                                                                    // 1907
	    this._transport.doSend(data);                                                                                 // 1908
	};                                                                                                                // 1909
	FacadeJS.prototype._doCleanup = function () {                                                                     // 1910
	    this._transport.doCleanup();                                                                                  // 1911
	};                                                                                                                // 1912
	                                                                                                                  // 1913
	utils.parent_origin = undefined;                                                                                  // 1914
	                                                                                                                  // 1915
	SockJS.bootstrap_iframe = function() {                                                                            // 1916
	    var facade;                                                                                                   // 1917
	    curr_window_id = _document.location.hash.slice(1);                                                            // 1918
	    var onMessage = function(e) {                                                                                 // 1919
	        if(e.source !== parent) return;                                                                           // 1920
	        if(typeof utils.parent_origin === 'undefined')                                                            // 1921
	            utils.parent_origin = e.origin;                                                                       // 1922
	        if (e.origin !== utils.parent_origin) return;                                                             // 1923
	                                                                                                                  // 1924
	        var window_id = e.data.slice(0, 8);                                                                       // 1925
	        var type = e.data.slice(8, 9);                                                                            // 1926
	        var data = e.data.slice(9);                                                                               // 1927
	        if (window_id !== curr_window_id) return;                                                                 // 1928
	        switch(type) {                                                                                            // 1929
	        case 's':                                                                                                 // 1930
	            var p = JSON.parse(data);                                                                             // 1931
	            var version = p[0];                                                                                   // 1932
	            var protocol = p[1];                                                                                  // 1933
	            var trans_url = p[2];                                                                                 // 1934
	            var base_url = p[3];                                                                                  // 1935
	            if (version !== SockJS.version) {                                                                     // 1936
	                utils.log("Incompatibile SockJS! Main site uses:" +                                               // 1937
	                          " \"" + version + "\", the iframe:" +                                                   // 1938
	                          " \"" + SockJS.version + "\".");                                                        // 1939
	            }                                                                                                     // 1940
	            if (!utils.flatUrl(trans_url) || !utils.flatUrl(base_url)) {                                          // 1941
	                utils.log("Only basic urls are supported in SockJS");                                             // 1942
	                return;                                                                                           // 1943
	            }                                                                                                     // 1944
	                                                                                                                  // 1945
	            if (!utils.isSameOriginUrl(trans_url) ||                                                              // 1946
	                !utils.isSameOriginUrl(base_url)) {                                                               // 1947
	                utils.log("Can't connect to different domain from within an " +                                   // 1948
	                          "iframe. (" + JSON.stringify([_window.location.href, trans_url, base_url]) +            // 1949
	                          ")");                                                                                   // 1950
	                return;                                                                                           // 1951
	            }                                                                                                     // 1952
	            facade = new FacadeJS();                                                                              // 1953
	            facade._transport = new FacadeJS[protocol](facade, trans_url, base_url);                              // 1954
	            break;                                                                                                // 1955
	        case 'm':                                                                                                 // 1956
	            facade._doSend(data);                                                                                 // 1957
	            break;                                                                                                // 1958
	        case 'c':                                                                                                 // 1959
	            if (facade)                                                                                           // 1960
	                facade._doCleanup();                                                                              // 1961
	            facade = null;                                                                                        // 1962
	            break;                                                                                                // 1963
	        }                                                                                                         // 1964
	    };                                                                                                            // 1965
	                                                                                                                  // 1966
	    // alert('test ticker');                                                                                      // 1967
	    // facade = new FacadeJS();                                                                                   // 1968
	    // facade._transport = new FacadeJS['w-iframe-xhr-polling'](facade, 'http://host.com:9999/ticker/12/basd');   // 1969
	                                                                                                                  // 1970
	    utils.attachMessage(onMessage);                                                                               // 1971
	                                                                                                                  // 1972
	    // Start                                                                                                      // 1973
	    postMessage('s');                                                                                             // 1974
	};                                                                                                                // 1975
	//         [*] End of lib/trans-iframe-within.js                                                                  // 1976
	                                                                                                                  // 1977
	                                                                                                                  // 1978
	//         [*] Including lib/info.js                                                                              // 1979
	/*                                                                                                                // 1980
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 1981
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 1982
	 *                                                                                                                // 1983
	 * For the license see COPYING.                                                                                   // 1984
	 * ***** END LICENSE BLOCK *****                                                                                  // 1985
	 */                                                                                                               // 1986
	                                                                                                                  // 1987
	var InfoReceiver = function(base_url, AjaxObject) {                                                               // 1988
	    var that = this;                                                                                              // 1989
	    utils.delay(function(){that.doXhr(base_url, AjaxObject);});                                                   // 1990
	};                                                                                                                // 1991
	                                                                                                                  // 1992
	InfoReceiver.prototype = new EventEmitter(['finish']);                                                            // 1993
	                                                                                                                  // 1994
	InfoReceiver.prototype.doXhr = function(base_url, AjaxObject) {                                                   // 1995
	    var that = this;                                                                                              // 1996
	    var t0 = (new Date()).getTime();                                                                              // 1997
	                                                                                                                  // 1998
	// <METEOR>                                                                                                       // 1999
	  // https://github.com/sockjs/sockjs-client/pull/129                                                             // 2000
	  // var xo = new AjaxObject('GET', base_url + '/info');                                                          // 2001
	                                                                                                                  // 2002
	    var xo = new AjaxObject(                                                                                      // 2003
	      // add cachebusting parameter to url to work around a chrome bug:                                           // 2004
	      // https://code.google.com/p/chromium/issues/detail?id=263981                                               // 2005
	      // or misbehaving proxies.                                                                                  // 2006
	      'GET', base_url + '/info?cb=' + utils.random_string(10))                                                    // 2007
	// </METEOR>                                                                                                      // 2008
	                                                                                                                  // 2009
	    var tref = utils.delay(8000,                                                                                  // 2010
	                           function(){xo.ontimeout();});                                                          // 2011
	                                                                                                                  // 2012
	    xo.onfinish = function(status, text) {                                                                        // 2013
	        clearTimeout(tref);                                                                                       // 2014
	        tref = null;                                                                                              // 2015
	        if (status === 200) {                                                                                     // 2016
	            var rtt = (new Date()).getTime() - t0;                                                                // 2017
	            var info = JSON.parse(text);                                                                          // 2018
	            if (typeof info !== 'object') info = {};                                                              // 2019
	            that.emit('finish', info, rtt);                                                                       // 2020
	        } else {                                                                                                  // 2021
	            that.emit('finish');                                                                                  // 2022
	        }                                                                                                         // 2023
	    };                                                                                                            // 2024
	    xo.ontimeout = function() {                                                                                   // 2025
	        xo.close();                                                                                               // 2026
	        that.emit('finish');                                                                                      // 2027
	    };                                                                                                            // 2028
	};                                                                                                                // 2029
	                                                                                                                  // 2030
	var InfoReceiverIframe = function(base_url) {                                                                     // 2031
	    var that = this;                                                                                              // 2032
	    var go = function() {                                                                                         // 2033
	        var ifr = new IframeTransport();                                                                          // 2034
	        ifr.protocol = 'w-iframe-info-receiver';                                                                  // 2035
	        var fun = function(r) {                                                                                   // 2036
	            if (typeof r === 'string' && r.substr(0,1) === 'm') {                                                 // 2037
	                var d = JSON.parse(r.substr(1));                                                                  // 2038
	                var info = d[0], rtt = d[1];                                                                      // 2039
	                that.emit('finish', info, rtt);                                                                   // 2040
	            } else {                                                                                              // 2041
	                that.emit('finish');                                                                              // 2042
	            }                                                                                                     // 2043
	            ifr.doCleanup();                                                                                      // 2044
	            ifr = null;                                                                                           // 2045
	        };                                                                                                        // 2046
	        var mock_ri = {                                                                                           // 2047
	            _options: {},                                                                                         // 2048
	            _didClose: fun,                                                                                       // 2049
	            _didMessage: fun                                                                                      // 2050
	        };                                                                                                        // 2051
	        ifr.i_constructor(mock_ri, base_url, base_url);                                                           // 2052
	    }                                                                                                             // 2053
	    if(!_document.body) {                                                                                         // 2054
	        utils.attachEvent('load', go);                                                                            // 2055
	    } else {                                                                                                      // 2056
	        go();                                                                                                     // 2057
	    }                                                                                                             // 2058
	};                                                                                                                // 2059
	InfoReceiverIframe.prototype = new EventEmitter(['finish']);                                                      // 2060
	                                                                                                                  // 2061
	                                                                                                                  // 2062
	var InfoReceiverFake = function() {                                                                               // 2063
	    // It may not be possible to do cross domain AJAX to get the info                                             // 2064
	    // data, for example for IE7. But we want to run JSONP, so let's                                              // 2065
	    // fake the response, with rtt=2s (rto=6s).                                                                   // 2066
	    var that = this;                                                                                              // 2067
	    utils.delay(function() {                                                                                      // 2068
	        that.emit('finish', {}, 2000);                                                                            // 2069
	    });                                                                                                           // 2070
	};                                                                                                                // 2071
	InfoReceiverFake.prototype = new EventEmitter(['finish']);                                                        // 2072
	                                                                                                                  // 2073
	var createInfoReceiver = function(base_url) {                                                                     // 2074
	    if (utils.isSameOriginUrl(base_url)) {                                                                        // 2075
	        // If, for some reason, we have SockJS locally - there's no                                               // 2076
	        // need to start up the complex machinery. Just use ajax.                                                 // 2077
	        return new InfoReceiver(base_url, utils.XHRLocalObject);                                                  // 2078
	    }                                                                                                             // 2079
	    switch (utils.isXHRCorsCapable()) {                                                                           // 2080
	    case 1:                                                                                                       // 2081
	        // XHRLocalObject -> no_credentials=true                                                                  // 2082
	        return new InfoReceiver(base_url, utils.XHRLocalObject);                                                  // 2083
	    case 2:                                                                                                       // 2084
	// <METEOR>                                                                                                       // 2085
	// https://github.com/sockjs/sockjs-client/issues/79                                                              // 2086
	        // XDR doesn't work across different schemes                                                              // 2087
	        // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	        if (utils.isSameOriginScheme(base_url))                                                                   // 2089
	            return new InfoReceiver(base_url, utils.XDRObject);                                                   // 2090
	        else                                                                                                      // 2091
	            return new InfoReceiverFake();                                                                        // 2092
	// </METEOR>                                                                                                      // 2093
	    case 3:                                                                                                       // 2094
	        // Opera                                                                                                  // 2095
	        return new InfoReceiverIframe(base_url);                                                                  // 2096
	    default:                                                                                                      // 2097
	        // IE 7                                                                                                   // 2098
	        return new InfoReceiverFake();                                                                            // 2099
	    };                                                                                                            // 2100
	};                                                                                                                // 2101
	                                                                                                                  // 2102
	                                                                                                                  // 2103
	var WInfoReceiverIframe = FacadeJS['w-iframe-info-receiver'] = function(ri, _trans_url, base_url) {               // 2104
	    var ir = new InfoReceiver(base_url, utils.XHRLocalObject);                                                    // 2105
	    ir.onfinish = function(info, rtt) {                                                                           // 2106
	        ri._didMessage('m'+JSON.stringify([info, rtt]));                                                          // 2107
	        ri._didClose();                                                                                           // 2108
	    }                                                                                                             // 2109
	};                                                                                                                // 2110
	WInfoReceiverIframe.prototype.doCleanup = function() {};                                                          // 2111
	//         [*] End of lib/info.js                                                                                 // 2112
	                                                                                                                  // 2113
	                                                                                                                  // 2114
	//         [*] Including lib/trans-iframe-eventsource.js                                                          // 2115
	/*                                                                                                                // 2116
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 2117
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 2118
	 *                                                                                                                // 2119
	 * For the license see COPYING.                                                                                   // 2120
	 * ***** END LICENSE BLOCK *****                                                                                  // 2121
	 */                                                                                                               // 2122
	                                                                                                                  // 2123
	var EventSourceIframeTransport = SockJS['iframe-eventsource'] = function () {                                     // 2124
	    var that = this;                                                                                              // 2125
	    that.protocol = 'w-iframe-eventsource';                                                                       // 2126
	    that.i_constructor.apply(that, arguments);                                                                    // 2127
	};                                                                                                                // 2128
	                                                                                                                  // 2129
	EventSourceIframeTransport.prototype = new IframeTransport();                                                     // 2130
	                                                                                                                  // 2131
	EventSourceIframeTransport.enabled = function () {                                                                // 2132
	    return ('EventSource' in _window) && IframeTransport.enabled();                                               // 2133
	};                                                                                                                // 2134
	                                                                                                                  // 2135
	EventSourceIframeTransport.need_body = true;                                                                      // 2136
	EventSourceIframeTransport.roundTrips = 3; // html, javascript, eventsource                                       // 2137
	                                                                                                                  // 2138
	                                                                                                                  // 2139
	// w-iframe-eventsource                                                                                           // 2140
	var EventSourceTransport = FacadeJS['w-iframe-eventsource'] = function(ri, trans_url) {                           // 2141
	    this.run(ri, trans_url, '/eventsource', EventSourceReceiver, utils.XHRLocalObject);                           // 2142
	}                                                                                                                 // 2143
	EventSourceTransport.prototype = new AjaxBasedTransport();                                                        // 2144
	//         [*] End of lib/trans-iframe-eventsource.js                                                             // 2145
	                                                                                                                  // 2146
	                                                                                                                  // 2147
	//         [*] Including lib/trans-iframe-xhr-polling.js                                                          // 2148
	/*                                                                                                                // 2149
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 2150
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 2151
	 *                                                                                                                // 2152
	 * For the license see COPYING.                                                                                   // 2153
	 * ***** END LICENSE BLOCK *****                                                                                  // 2154
	 */                                                                                                               // 2155
	                                                                                                                  // 2156
	var XhrPollingIframeTransport = SockJS['iframe-xhr-polling'] = function () {                                      // 2157
	    var that = this;                                                                                              // 2158
	    that.protocol = 'w-iframe-xhr-polling';                                                                       // 2159
	    that.i_constructor.apply(that, arguments);                                                                    // 2160
	};                                                                                                                // 2161
	                                                                                                                  // 2162
	XhrPollingIframeTransport.prototype = new IframeTransport();                                                      // 2163
	                                                                                                                  // 2164
	XhrPollingIframeTransport.enabled = function () {                                                                 // 2165
	    return _window.XMLHttpRequest && IframeTransport.enabled();                                                   // 2166
	};                                                                                                                // 2167
	                                                                                                                  // 2168
	XhrPollingIframeTransport.need_body = true;                                                                       // 2169
	XhrPollingIframeTransport.roundTrips = 3; // html, javascript, xhr                                                // 2170
	                                                                                                                  // 2171
	                                                                                                                  // 2172
	// w-iframe-xhr-polling                                                                                           // 2173
	var XhrPollingITransport = FacadeJS['w-iframe-xhr-polling'] = function(ri, trans_url) {                           // 2174
	    this.run(ri, trans_url, '/xhr', XhrReceiver, utils.XHRLocalObject);                                           // 2175
	};                                                                                                                // 2176
	                                                                                                                  // 2177
	XhrPollingITransport.prototype = new AjaxBasedTransport();                                                        // 2178
	//         [*] End of lib/trans-iframe-xhr-polling.js                                                             // 2179
	                                                                                                                  // 2180
	                                                                                                                  // 2181
	//         [*] Including lib/trans-iframe-htmlfile.js                                                             // 2182
	/*                                                                                                                // 2183
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 2184
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 2185
	 *                                                                                                                // 2186
	 * For the license see COPYING.                                                                                   // 2187
	 * ***** END LICENSE BLOCK *****                                                                                  // 2188
	 */                                                                                                               // 2189
	                                                                                                                  // 2190
	// This transport generally works in any browser, but will cause a                                                // 2191
	// spinning cursor to appear in any browser other than IE.                                                        // 2192
	// We may test this transport in all browsers - why not, but in                                                   // 2193
	// production it should be only run in IE.                                                                        // 2194
	                                                                                                                  // 2195
	var HtmlFileIframeTransport = SockJS['iframe-htmlfile'] = function () {                                           // 2196
	    var that = this;                                                                                              // 2197
	    that.protocol = 'w-iframe-htmlfile';                                                                          // 2198
	    that.i_constructor.apply(that, arguments);                                                                    // 2199
	};                                                                                                                // 2200
	                                                                                                                  // 2201
	// Inheritance.                                                                                                   // 2202
	HtmlFileIframeTransport.prototype = new IframeTransport();                                                        // 2203
	                                                                                                                  // 2204
	HtmlFileIframeTransport.enabled = function() {                                                                    // 2205
	    return IframeTransport.enabled();                                                                             // 2206
	};                                                                                                                // 2207
	                                                                                                                  // 2208
	HtmlFileIframeTransport.need_body = true;                                                                         // 2209
	HtmlFileIframeTransport.roundTrips = 3; // html, javascript, htmlfile                                             // 2210
	                                                                                                                  // 2211
	                                                                                                                  // 2212
	// w-iframe-htmlfile                                                                                              // 2213
	var HtmlFileTransport = FacadeJS['w-iframe-htmlfile'] = function(ri, trans_url) {                                 // 2214
	    this.run(ri, trans_url, '/htmlfile', HtmlfileReceiver, utils.XHRLocalObject);                                 // 2215
	};                                                                                                                // 2216
	HtmlFileTransport.prototype = new AjaxBasedTransport();                                                           // 2217
	//         [*] End of lib/trans-iframe-htmlfile.js                                                                // 2218
	                                                                                                                  // 2219
	                                                                                                                  // 2220
	//         [*] Including lib/trans-polling.js                                                                     // 2221
	/*                                                                                                                // 2222
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 2223
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 2224
	 *                                                                                                                // 2225
	 * For the license see COPYING.                                                                                   // 2226
	 * ***** END LICENSE BLOCK *****                                                                                  // 2227
	 */                                                                                                               // 2228
	                                                                                                                  // 2229
	var Polling = function(ri, Receiver, recv_url, AjaxObject) {                                                      // 2230
	    var that = this;                                                                                              // 2231
	    that.ri = ri;                                                                                                 // 2232
	    that.Receiver = Receiver;                                                                                     // 2233
	    that.recv_url = recv_url;                                                                                     // 2234
	    that.AjaxObject = AjaxObject;                                                                                 // 2235
	    that._scheduleRecv();                                                                                         // 2236
	};                                                                                                                // 2237
	                                                                                                                  // 2238
	Polling.prototype._scheduleRecv = function() {                                                                    // 2239
	    var that = this;                                                                                              // 2240
	    var poll = that.poll = new that.Receiver(that.recv_url, that.AjaxObject);                                     // 2241
	    var msg_counter = 0;                                                                                          // 2242
	    poll.onmessage = function(e) {                                                                                // 2243
	        msg_counter += 1;                                                                                         // 2244
	        that.ri._didMessage(e.data);                                                                              // 2245
	    };                                                                                                            // 2246
	    poll.onclose = function(e) {                                                                                  // 2247
	        that.poll = poll = poll.onmessage = poll.onclose = null;                                                  // 2248
	        if (!that.poll_is_closing) {                                                                              // 2249
	            if (e.reason === 'permanent') {                                                                       // 2250
	                that.ri._didClose(1006, 'Polling error (' + e.reason + ')');                                      // 2251
	            } else {                                                                                              // 2252
	                that._scheduleRecv();                                                                             // 2253
	            }                                                                                                     // 2254
	        }                                                                                                         // 2255
	    };                                                                                                            // 2256
	};                                                                                                                // 2257
	                                                                                                                  // 2258
	Polling.prototype.abort = function() {                                                                            // 2259
	    var that = this;                                                                                              // 2260
	    that.poll_is_closing = true;                                                                                  // 2261
	    if (that.poll) {                                                                                              // 2262
	        that.poll.abort();                                                                                        // 2263
	    }                                                                                                             // 2264
	};                                                                                                                // 2265
	//         [*] End of lib/trans-polling.js                                                                        // 2266
	                                                                                                                  // 2267
	                                                                                                                  // 2268
	//         [*] Including lib/trans-receiver-eventsource.js                                                        // 2269
	/*                                                                                                                // 2270
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 2271
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 2272
	 *                                                                                                                // 2273
	 * For the license see COPYING.                                                                                   // 2274
	 * ***** END LICENSE BLOCK *****                                                                                  // 2275
	 */                                                                                                               // 2276
	                                                                                                                  // 2277
	var EventSourceReceiver = function(url) {                                                                         // 2278
	    var that = this;                                                                                              // 2279
	    var es = new EventSource(url);                                                                                // 2280
	    es.onmessage = function(e) {                                                                                  // 2281
	        that.dispatchEvent(new SimpleEvent('message',                                                             // 2282
	                                           {'data': unescape(e.data)}));                                          // 2283
	    };                                                                                                            // 2284
	    that.es_close = es.onerror = function(e, abort_reason) {                                                      // 2285
	        // ES on reconnection has readyState = 0 or 1.                                                            // 2286
	        // on network error it's CLOSED = 2                                                                       // 2287
	        var reason = abort_reason ? 'user' :                                                                      // 2288
	            (es.readyState !== 2 ? 'network' : 'permanent');                                                      // 2289
	        that.es_close = es.onmessage = es.onerror = null;                                                         // 2290
	        // EventSource reconnects automatically.                                                                  // 2291
	        es.close();                                                                                               // 2292
	        es = null;                                                                                                // 2293
	        // Safari and chrome < 15 crash if we close window before                                                 // 2294
	        // waiting for ES cleanup. See:                                                                           // 2295
	        //   https://code.google.com/p/chromium/issues/detail?id=89155                                            // 2296
	        utils.delay(200, function() {                                                                             // 2297
	                        that.dispatchEvent(new SimpleEvent('close', {reason: reason}));                           // 2298
	                    });                                                                                           // 2299
	    };                                                                                                            // 2300
	};                                                                                                                // 2301
	                                                                                                                  // 2302
	EventSourceReceiver.prototype = new REventTarget();                                                               // 2303
	                                                                                                                  // 2304
	EventSourceReceiver.prototype.abort = function() {                                                                // 2305
	    var that = this;                                                                                              // 2306
	    if (that.es_close) {                                                                                          // 2307
	        that.es_close({}, true);                                                                                  // 2308
	    }                                                                                                             // 2309
	};                                                                                                                // 2310
	//         [*] End of lib/trans-receiver-eventsource.js                                                           // 2311
	                                                                                                                  // 2312
	                                                                                                                  // 2313
	//         [*] Including lib/trans-receiver-htmlfile.js                                                           // 2314
	/*                                                                                                                // 2315
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 2316
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 2317
	 *                                                                                                                // 2318
	 * For the license see COPYING.                                                                                   // 2319
	 * ***** END LICENSE BLOCK *****                                                                                  // 2320
	 */                                                                                                               // 2321
	                                                                                                                  // 2322
	var _is_ie_htmlfile_capable;                                                                                      // 2323
	var isIeHtmlfileCapable = function() {                                                                            // 2324
	    if (_is_ie_htmlfile_capable === undefined) {                                                                  // 2325
	        if ('ActiveXObject' in _window) {                                                                         // 2326
	            try {                                                                                                 // 2327
	                _is_ie_htmlfile_capable = !!new ActiveXObject('htmlfile');                                        // 2328
	            } catch (x) {}                                                                                        // 2329
	        } else {                                                                                                  // 2330
	            _is_ie_htmlfile_capable = false;                                                                      // 2331
	        }                                                                                                         // 2332
	    }                                                                                                             // 2333
	    return _is_ie_htmlfile_capable;                                                                               // 2334
	};                                                                                                                // 2335
	                                                                                                                  // 2336
	                                                                                                                  // 2337
	var HtmlfileReceiver = function(url) {                                                                            // 2338
	    var that = this;                                                                                              // 2339
	    utils.polluteGlobalNamespace();                                                                               // 2340
	                                                                                                                  // 2341
	    that.id = 'a' + utils.random_string(6, 26);                                                                   // 2342
	    url += ((url.indexOf('?') === -1) ? '?' : '&') +                                                              // 2343
	        'c=' + escape(WPrefix + '.' + that.id);                                                                   // 2344
	                                                                                                                  // 2345
	    var constructor = isIeHtmlfileCapable() ?                                                                     // 2346
	        utils.createHtmlfile : utils.createIframe;                                                                // 2347
	                                                                                                                  // 2348
	    var iframeObj;                                                                                                // 2349
	    _window[WPrefix][that.id] = {                                                                                 // 2350
	        start: function () {                                                                                      // 2351
	            iframeObj.loaded();                                                                                   // 2352
	        },                                                                                                        // 2353
	        message: function (data) {                                                                                // 2354
	            that.dispatchEvent(new SimpleEvent('message', {'data': data}));                                       // 2355
	        },                                                                                                        // 2356
	        stop: function () {                                                                                       // 2357
	            that.iframe_close({}, 'network');                                                                     // 2358
	        }                                                                                                         // 2359
	    };                                                                                                            // 2360
	    that.iframe_close = function(e, abort_reason) {                                                               // 2361
	        iframeObj.cleanup();                                                                                      // 2362
	        that.iframe_close = iframeObj = null;                                                                     // 2363
	        delete _window[WPrefix][that.id];                                                                         // 2364
	        that.dispatchEvent(new SimpleEvent('close', {reason: abort_reason}));                                     // 2365
	    };                                                                                                            // 2366
	    iframeObj = constructor(url, function(e) {                                                                    // 2367
	                                that.iframe_close({}, 'permanent');                                               // 2368
	                            });                                                                                   // 2369
	};                                                                                                                // 2370
	                                                                                                                  // 2371
	HtmlfileReceiver.prototype = new REventTarget();                                                                  // 2372
	                                                                                                                  // 2373
	HtmlfileReceiver.prototype.abort = function() {                                                                   // 2374
	    var that = this;                                                                                              // 2375
	    if (that.iframe_close) {                                                                                      // 2376
	        that.iframe_close({}, 'user');                                                                            // 2377
	    }                                                                                                             // 2378
	};                                                                                                                // 2379
	//         [*] End of lib/trans-receiver-htmlfile.js                                                              // 2380
	                                                                                                                  // 2381
	                                                                                                                  // 2382
	//         [*] Including lib/trans-receiver-xhr.js                                                                // 2383
	/*                                                                                                                // 2384
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 2385
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 2386
	 *                                                                                                                // 2387
	 * For the license see COPYING.                                                                                   // 2388
	 * ***** END LICENSE BLOCK *****                                                                                  // 2389
	 */                                                                                                               // 2390
	                                                                                                                  // 2391
	var XhrReceiver = function(url, AjaxObject) {                                                                     // 2392
	    var that = this;                                                                                              // 2393
	    var buf_pos = 0;                                                                                              // 2394
	                                                                                                                  // 2395
	    that.xo = new AjaxObject('POST', url, null);                                                                  // 2396
	    that.xo.onchunk = function(status, text) {                                                                    // 2397
	        if (status !== 200) return;                                                                               // 2398
	        while (1) {                                                                                               // 2399
	            var buf = text.slice(buf_pos);                                                                        // 2400
	            var p = buf.indexOf('\n');                                                                            // 2401
	            if (p === -1) break;                                                                                  // 2402
	            buf_pos += p+1;                                                                                       // 2403
	            var msg = buf.slice(0, p);                                                                            // 2404
	            that.dispatchEvent(new SimpleEvent('message', {data: msg}));                                          // 2405
	        }                                                                                                         // 2406
	    };                                                                                                            // 2407
	    that.xo.onfinish = function(status, text) {                                                                   // 2408
	        that.xo.onchunk(status, text);                                                                            // 2409
	        that.xo = null;                                                                                           // 2410
	        var reason = status === 200 ? 'network' : 'permanent';                                                    // 2411
	        that.dispatchEvent(new SimpleEvent('close', {reason: reason}));                                           // 2412
	    }                                                                                                             // 2413
	};                                                                                                                // 2414
	                                                                                                                  // 2415
	XhrReceiver.prototype = new REventTarget();                                                                       // 2416
	                                                                                                                  // 2417
	XhrReceiver.prototype.abort = function() {                                                                        // 2418
	    var that = this;                                                                                              // 2419
	    if (that.xo) {                                                                                                // 2420
	        that.xo.close();                                                                                          // 2421
	        that.dispatchEvent(new SimpleEvent('close', {reason: 'user'}));                                           // 2422
	        that.xo = null;                                                                                           // 2423
	    }                                                                                                             // 2424
	};                                                                                                                // 2425
	//         [*] End of lib/trans-receiver-xhr.js                                                                   // 2426
	                                                                                                                  // 2427
	                                                                                                                  // 2428
	//         [*] Including lib/test-hooks.js                                                                        // 2429
	/*                                                                                                                // 2430
	 * ***** BEGIN LICENSE BLOCK *****                                                                                // 2431
	 * Copyright (c) 2011-2012 VMware, Inc.                                                                           // 2432
	 *                                                                                                                // 2433
	 * For the license see COPYING.                                                                                   // 2434
	 * ***** END LICENSE BLOCK *****                                                                                  // 2435
	 */                                                                                                               // 2436
	                                                                                                                  // 2437
	// For testing                                                                                                    // 2438
	SockJS.getUtils = function(){                                                                                     // 2439
	    return utils;                                                                                                 // 2440
	};                                                                                                                // 2441
	                                                                                                                  // 2442
	SockJS.getIframeTransport = function(){                                                                           // 2443
	    return IframeTransport;                                                                                       // 2444
	};                                                                                                                // 2445
	//         [*] End of lib/test-hooks.js                                                                           // 2446
	                                                                                                                  // 2447
	                  return SockJS;                                                                                  // 2448
	          })();                                                                                                   // 2449
	if ('_sockjs_onload' in window) setTimeout(_sockjs_onload, 1);                                                    // 2450
	                                                                                                                  // 2451
	// AMD compliance                                                                                                 // 2452
	if (true) {                                                                 // 2453
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return SockJS;}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                                                             // 2454
	}                                                                                                                 // 2455
	//     [*] End of lib/index.js                                                                                    // 2456
	                                                                                                                  // 2457
	// [*] End of lib/all.js                                                                                          // 2458
	                                                                                                                  // 2459
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                //
	// packages/ddp-client/stream_client_sockjs.js                                                                    //
	//                                                                                                                //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                  //
	// @param url {String} URL to Meteor app                                                                          // 1
	//   "http://subdomain.meteor.com/" or "/" or                                                                     // 2
	//   "ddp+sockjs://foo-**.meteor.com/sockjs"                                                                      // 3
	LivedataTest.ClientStream = function (url, options) {                                                             // 4
	  var self = this;                                                                                                // 5
	  self.options = _.extend({                                                                                       // 6
	    retry: true                                                                                                   // 7
	  }, options);                                                                                                    // 8
	  self._initCommon(self.options);                                                                                 // 9
	                                                                                                                  // 10
	  //// Constants                                                                                                  // 11
	                                                                                                                  // 12
	                                                                                                                  // 13
	  // how long between hearing heartbeat from the server until we declare                                          // 14
	  // the connection dead. heartbeats come every 45s (stream_server.js)                                            // 15
	  //                                                                                                              // 16
	  // NOTE: this is a older timeout mechanism. We now send heartbeats at                                           // 17
	  // the DDP level (https://github.com/meteor/meteor/pull/1865), and                                              // 18
	  // expect those timeouts to kill a non-responsive connection before                                             // 19
	  // this timeout fires. This is kept around for compatibility (when                                              // 20
	  // talking to a server that doesn't support DDP heartbeats) and can be                                          // 21
	  // removed later.                                                                                               // 22
	  self.HEARTBEAT_TIMEOUT = 100*1000;                                                                              // 23
	                                                                                                                  // 24
	  self.rawUrl = url;                                                                                              // 25
	  self.socket = null;                                                                                             // 26
	                                                                                                                  // 27
	  self.heartbeatTimer = null;                                                                                     // 28
	                                                                                                                  // 29
	  // Listen to global 'online' event if we are running in a browser.                                              // 30
	  // (IE8 does not support addEventListener)                                                                      // 31
	  if (typeof window !== 'undefined' && window.addEventListener)                                                   // 32
	    window.addEventListener("online", _.bind(self._online, self),                                                 // 33
	                            false /* useCapture. make FF3.6 happy. */);                                           // 34
	                                                                                                                  // 35
	  //// Kickoff!                                                                                                   // 36
	  self._launchConnection();                                                                                       // 37
	};                                                                                                                // 38
	                                                                                                                  // 39
	_.extend(LivedataTest.ClientStream.prototype, {                                                                   // 40
	                                                                                                                  // 41
	  // data is a utf8 string. Data sent while not connected is dropped on                                           // 42
	  // the floor, and it is up the user of this API to retransmit lost                                              // 43
	  // messages on 'reset'                                                                                          // 44
	  send: function (data) {                                                                                         // 45
	    var self = this;                                                                                              // 46
	    if (self.currentStatus.connected) {                                                                           // 47
	      self.socket.send(data);                                                                                     // 48
	    }                                                                                                             // 49
	  },                                                                                                              // 50
	                                                                                                                  // 51
	  // Changes where this connection points                                                                         // 52
	  _changeUrl: function (url) {                                                                                    // 53
	    var self = this;                                                                                              // 54
	    self.rawUrl = url;                                                                                            // 55
	  },                                                                                                              // 56
	                                                                                                                  // 57
	  _connected: function () {                                                                                       // 58
	    var self = this;                                                                                              // 59
	                                                                                                                  // 60
	    if (self.connectionTimer) {                                                                                   // 61
	      clearTimeout(self.connectionTimer);                                                                         // 62
	      self.connectionTimer = null;                                                                                // 63
	    }                                                                                                             // 64
	                                                                                                                  // 65
	    if (self.currentStatus.connected) {                                                                           // 66
	      // already connected. do nothing. this probably shouldn't happen.                                           // 67
	      return;                                                                                                     // 68
	    }                                                                                                             // 69
	                                                                                                                  // 70
	    // update status                                                                                              // 71
	    self.currentStatus.status = "connected";                                                                      // 72
	    self.currentStatus.connected = true;                                                                          // 73
	    self.currentStatus.retryCount = 0;                                                                            // 74
	    self.statusChanged();                                                                                         // 75
	                                                                                                                  // 76
	    // fire resets. This must come after status change so that clients                                            // 77
	    // can call send from within a reset callback.                                                                // 78
	    _.each(self.eventCallbacks.reset, function (callback) { callback(); });                                       // 79
	                                                                                                                  // 80
	  },                                                                                                              // 81
	                                                                                                                  // 82
	  _cleanup: function (maybeError) {                                                                               // 83
	    var self = this;                                                                                              // 84
	                                                                                                                  // 85
	    self._clearConnectionAndHeartbeatTimers();                                                                    // 86
	    if (self.socket) {                                                                                            // 87
	      self.socket.onmessage = self.socket.onclose                                                                 // 88
	        = self.socket.onerror = self.socket.onheartbeat = function () {};                                         // 89
	      self.socket.close();                                                                                        // 90
	      self.socket = null;                                                                                         // 91
	    }                                                                                                             // 92
	                                                                                                                  // 93
	    _.each(self.eventCallbacks.disconnect, function (callback) {                                                  // 94
	      callback(maybeError);                                                                                       // 95
	    });                                                                                                           // 96
	  },                                                                                                              // 97
	                                                                                                                  // 98
	  _clearConnectionAndHeartbeatTimers: function () {                                                               // 99
	    var self = this;                                                                                              // 100
	    if (self.connectionTimer) {                                                                                   // 101
	      clearTimeout(self.connectionTimer);                                                                         // 102
	      self.connectionTimer = null;                                                                                // 103
	    }                                                                                                             // 104
	    if (self.heartbeatTimer) {                                                                                    // 105
	      clearTimeout(self.heartbeatTimer);                                                                          // 106
	      self.heartbeatTimer = null;                                                                                 // 107
	    }                                                                                                             // 108
	  },                                                                                                              // 109
	                                                                                                                  // 110
	  _heartbeat_timeout: function () {                                                                               // 111
	    var self = this;                                                                                              // 112
	    Meteor._debug("Connection timeout. No sockjs heartbeat received.");                                           // 113
	    self._lostConnection(new DDP.ConnectionError("Heartbeat timed out"));                                         // 114
	  },                                                                                                              // 115
	                                                                                                                  // 116
	  _heartbeat_received: function () {                                                                              // 117
	    var self = this;                                                                                              // 118
	    // If we've already permanently shut down this stream, the timeout is                                         // 119
	    // already cleared, and we don't need to set it again.                                                        // 120
	    if (self._forcedToDisconnect)                                                                                 // 121
	      return;                                                                                                     // 122
	    if (self.heartbeatTimer)                                                                                      // 123
	      clearTimeout(self.heartbeatTimer);                                                                          // 124
	    self.heartbeatTimer = setTimeout(                                                                             // 125
	      _.bind(self._heartbeat_timeout, self),                                                                      // 126
	      self.HEARTBEAT_TIMEOUT);                                                                                    // 127
	  },                                                                                                              // 128
	                                                                                                                  // 129
	  _sockjsProtocolsWhitelist: function () {                                                                        // 130
	    // only allow polling protocols. no streaming.  streaming                                                     // 131
	    // makes safari spin.                                                                                         // 132
	    var protocolsWhitelist = [                                                                                    // 133
	      'xdr-polling', 'xhr-polling', 'iframe-xhr-polling', 'jsonp-polling'];                                       // 134
	                                                                                                                  // 135
	    // iOS 4 and 5 and below crash when using websockets over certain                                             // 136
	    // proxies. this seems to be resolved with iOS 6. eg                                                          // 137
	    // https://github.com/LearnBoost/socket.io/issues/193#issuecomment-7308865.                                   // 138
	    //                                                                                                            // 139
	    // iOS <4 doesn't support websockets at all so sockjs will just                                               // 140
	    // immediately fall back to http                                                                              // 141
	    var noWebsockets = navigator &&                                                                               // 142
	          /iPhone|iPad|iPod/.test(navigator.userAgent) &&                                                         // 143
	          /OS 4_|OS 5_/.test(navigator.userAgent);                                                                // 144
	                                                                                                                  // 145
	    if (!noWebsockets)                                                                                            // 146
	      protocolsWhitelist = ['websocket'].concat(protocolsWhitelist);                                              // 147
	                                                                                                                  // 148
	    return protocolsWhitelist;                                                                                    // 149
	  },                                                                                                              // 150
	                                                                                                                  // 151
	  _launchConnection: function () {                                                                                // 152
	    var self = this;                                                                                              // 153
	    self._cleanup(); // cleanup the old socket, if there was one.                                                 // 154
	                                                                                                                  // 155
	    var options = _.extend({                                                                                      // 156
	      protocols_whitelist:self._sockjsProtocolsWhitelist()                                                        // 157
	    }, self.options._sockjsOptions);                                                                              // 158
	                                                                                                                  // 159
	    // Convert raw URL to SockJS URL each time we open a connection, so that we                                   // 160
	    // can connect to random hostnames and get around browser per-host                                            // 161
	    // connection limits.                                                                                         // 162
	    self.socket = new SockJS(toSockjsUrl(self.rawUrl), undefined, options);                                       // 163
	    self.socket.onopen = function (data) {                                                                        // 164
	      self._connected();                                                                                          // 165
	    };                                                                                                            // 166
	    self.socket.onmessage = function (data) {                                                                     // 167
	      self._heartbeat_received();                                                                                 // 168
	                                                                                                                  // 169
	      if (self.currentStatus.connected)                                                                           // 170
	        _.each(self.eventCallbacks.message, function (callback) {                                                 // 171
	          callback(data.data);                                                                                    // 172
	        });                                                                                                       // 173
	    };                                                                                                            // 174
	    self.socket.onclose = function () {                                                                           // 175
	      self._lostConnection();                                                                                     // 176
	    };                                                                                                            // 177
	    self.socket.onerror = function () {                                                                           // 178
	      // XXX is this ever called?                                                                                 // 179
	      Meteor._debug("stream error", _.toArray(arguments), (new Date()).toDateString());                           // 180
	    };                                                                                                            // 181
	                                                                                                                  // 182
	    self.socket.onheartbeat =  function () {                                                                      // 183
	      self._heartbeat_received();                                                                                 // 184
	    };                                                                                                            // 185
	                                                                                                                  // 186
	    if (self.connectionTimer)                                                                                     // 187
	      clearTimeout(self.connectionTimer);                                                                         // 188
	    self.connectionTimer = setTimeout(function () {                                                               // 189
	      self._lostConnection(                                                                                       // 190
	        new DDP.ConnectionError("DDP connection timed out"));                                                     // 191
	    }, self.CONNECT_TIMEOUT);                                                                                     // 192
	  }                                                                                                               // 193
	});                                                                                                               // 194
	                                                                                                                  // 195
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                //
	// packages/ddp-client/stream_client_common.js                                                                    //
	//                                                                                                                //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                  //
	// XXX from Underscore.String (http://epeli.github.com/underscore.string/)                                        // 1
	var startsWith = function(str, starts) {                                                                          // 2
	  return str.length >= starts.length &&                                                                           // 3
	    str.substring(0, starts.length) === starts;                                                                   // 4
	};                                                                                                                // 5
	var endsWith = function(str, ends) {                                                                              // 6
	  return str.length >= ends.length &&                                                                             // 7
	    str.substring(str.length - ends.length) === ends;                                                             // 8
	};                                                                                                                // 9
	                                                                                                                  // 10
	// @param url {String} URL to Meteor app, eg:                                                                     // 11
	//   "/" or "madewith.meteor.com" or "https://foo.meteor.com"                                                     // 12
	//   or "ddp+sockjs://ddp--****-foo.meteor.com/sockjs"                                                            // 13
	// @returns {String} URL to the endpoint with the specific scheme and subPath, e.g.                               // 14
	// for scheme "http" and subPath "sockjs"                                                                         // 15
	//   "http://subdomain.meteor.com/sockjs" or "/sockjs"                                                            // 16
	//   or "https://ddp--1234-foo.meteor.com/sockjs"                                                                 // 17
	var translateUrl =  function(url, newSchemeBase, subPath) {                                                       // 18
	  if (! newSchemeBase) {                                                                                          // 19
	    newSchemeBase = "http";                                                                                       // 20
	  }                                                                                                               // 21
	                                                                                                                  // 22
	  var ddpUrlMatch = url.match(/^ddp(i?)\+sockjs:\/\//);                                                           // 23
	  var httpUrlMatch = url.match(/^http(s?):\/\//);                                                                 // 24
	  var newScheme;                                                                                                  // 25
	  if (ddpUrlMatch) {                                                                                              // 26
	    // Remove scheme and split off the host.                                                                      // 27
	    var urlAfterDDP = url.substr(ddpUrlMatch[0].length);                                                          // 28
	    newScheme = ddpUrlMatch[1] === "i" ? newSchemeBase : newSchemeBase + "s";                                     // 29
	    var slashPos = urlAfterDDP.indexOf('/');                                                                      // 30
	    var host =                                                                                                    // 31
	          slashPos === -1 ? urlAfterDDP : urlAfterDDP.substr(0, slashPos);                                        // 32
	    var rest = slashPos === -1 ? '' : urlAfterDDP.substr(slashPos);                                               // 33
	                                                                                                                  // 34
	    // In the host (ONLY!), change '*' characters into random digits. This                                        // 35
	    // allows different stream connections to connect to different hostnames                                      // 36
	    // and avoid browser per-hostname connection limits.                                                          // 37
	    host = host.replace(/\*/g, function () {                                                                      // 38
	      return Math.floor(Random.fraction()*10);                                                                    // 39
	    });                                                                                                           // 40
	                                                                                                                  // 41
	    return newScheme + '://' + host + rest;                                                                       // 42
	  } else if (httpUrlMatch) {                                                                                      // 43
	    newScheme = !httpUrlMatch[1] ? newSchemeBase : newSchemeBase + "s";                                           // 44
	    var urlAfterHttp = url.substr(httpUrlMatch[0].length);                                                        // 45
	    url = newScheme + "://" + urlAfterHttp;                                                                       // 46
	  }                                                                                                               // 47
	                                                                                                                  // 48
	  // Prefix FQDNs but not relative URLs                                                                           // 49
	  if (url.indexOf("://") === -1 && !startsWith(url, "/")) {                                                       // 50
	    url = newSchemeBase + "://" + url;                                                                            // 51
	  }                                                                                                               // 52
	                                                                                                                  // 53
	  // XXX This is not what we should be doing: if I have a site                                                    // 54
	  // deployed at "/foo", then DDP.connect("/") should actually connect                                            // 55
	  // to "/", not to "/foo". "/" is an absolute path. (Contrast: if                                                // 56
	  // deployed at "/foo", it would be reasonable for DDP.connect("bar")                                            // 57
	  // to connect to "/foo/bar").                                                                                   // 58
	  //                                                                                                              // 59
	  // We should make this properly honor absolute paths rather than                                                // 60
	  // forcing the path to be relative to the site root. Simultaneously,                                            // 61
	  // we should set DDP_DEFAULT_CONNECTION_URL to include the site                                                 // 62
	  // root. See also client_convenience.js #RationalizingRelativeDDPURLs                                           // 63
	  url = Meteor._relativeToSiteRootUrl(url);                                                                       // 64
	                                                                                                                  // 65
	  if (endsWith(url, "/"))                                                                                         // 66
	    return url + subPath;                                                                                         // 67
	  else                                                                                                            // 68
	    return url + "/" + subPath;                                                                                   // 69
	};                                                                                                                // 70
	                                                                                                                  // 71
	toSockjsUrl = function (url) {                                                                                    // 72
	  return translateUrl(url, "http", "sockjs");                                                                     // 73
	};                                                                                                                // 74
	                                                                                                                  // 75
	toWebsocketUrl = function (url) {                                                                                 // 76
	  var ret = translateUrl(url, "ws", "websocket");                                                                 // 77
	  return ret;                                                                                                     // 78
	};                                                                                                                // 79
	                                                                                                                  // 80
	LivedataTest.toSockjsUrl = toSockjsUrl;                                                                           // 81
	                                                                                                                  // 82
	                                                                                                                  // 83
	_.extend(LivedataTest.ClientStream.prototype, {                                                                   // 84
	                                                                                                                  // 85
	  // Register for callbacks.                                                                                      // 86
	  on: function (name, callback) {                                                                                 // 87
	    var self = this;                                                                                              // 88
	                                                                                                                  // 89
	    if (name !== 'message' && name !== 'reset' && name !== 'disconnect')                                          // 90
	      throw new Error("unknown event type: " + name);                                                             // 91
	                                                                                                                  // 92
	    if (!self.eventCallbacks[name])                                                                               // 93
	      self.eventCallbacks[name] = [];                                                                             // 94
	    self.eventCallbacks[name].push(callback);                                                                     // 95
	  },                                                                                                              // 96
	                                                                                                                  // 97
	                                                                                                                  // 98
	  _initCommon: function (options) {                                                                               // 99
	    var self = this;                                                                                              // 100
	    options = options || {};                                                                                      // 101
	                                                                                                                  // 102
	    //// Constants                                                                                                // 103
	                                                                                                                  // 104
	    // how long to wait until we declare the connection attempt                                                   // 105
	    // failed.                                                                                                    // 106
	    self.CONNECT_TIMEOUT = options.connectTimeoutMs || 10000;                                                     // 107
	                                                                                                                  // 108
	    self.eventCallbacks = {}; // name -> [callback]                                                               // 109
	                                                                                                                  // 110
	    self._forcedToDisconnect = false;                                                                             // 111
	                                                                                                                  // 112
	    //// Reactive status                                                                                          // 113
	    self.currentStatus = {                                                                                        // 114
	      status: "connecting",                                                                                       // 115
	      connected: false,                                                                                           // 116
	      retryCount: 0                                                                                               // 117
	    };                                                                                                            // 118
	                                                                                                                  // 119
	                                                                                                                  // 120
	    self.statusListeners = typeof Tracker !== 'undefined' && new Tracker.Dependency;                              // 121
	    self.statusChanged = function () {                                                                            // 122
	      if (self.statusListeners)                                                                                   // 123
	        self.statusListeners.changed();                                                                           // 124
	    };                                                                                                            // 125
	                                                                                                                  // 126
	    //// Retry logic                                                                                              // 127
	    self._retry = new Retry;                                                                                      // 128
	    self.connectionTimer = null;                                                                                  // 129
	                                                                                                                  // 130
	  },                                                                                                              // 131
	                                                                                                                  // 132
	  // Trigger a reconnect.                                                                                         // 133
	  reconnect: function (options) {                                                                                 // 134
	    var self = this;                                                                                              // 135
	    options = options || {};                                                                                      // 136
	                                                                                                                  // 137
	    if (options.url) {                                                                                            // 138
	      self._changeUrl(options.url);                                                                               // 139
	    }                                                                                                             // 140
	                                                                                                                  // 141
	    if (options._sockjsOptions) {                                                                                 // 142
	      self.options._sockjsOptions = options._sockjsOptions;                                                       // 143
	    }                                                                                                             // 144
	                                                                                                                  // 145
	    if (self.currentStatus.connected) {                                                                           // 146
	      if (options._force || options.url) {                                                                        // 147
	        // force reconnect.                                                                                       // 148
	        self._lostConnection(new DDP.ForcedReconnectError);                                                       // 149
	      } // else, noop.                                                                                            // 150
	      return;                                                                                                     // 151
	    }                                                                                                             // 152
	                                                                                                                  // 153
	    // if we're mid-connection, stop it.                                                                          // 154
	    if (self.currentStatus.status === "connecting") {                                                             // 155
	      // Pretend it's a clean close.                                                                              // 156
	      self._lostConnection();                                                                                     // 157
	    }                                                                                                             // 158
	                                                                                                                  // 159
	    self._retry.clear();                                                                                          // 160
	    self.currentStatus.retryCount -= 1; // don't count manual retries                                             // 161
	    self._retryNow();                                                                                             // 162
	  },                                                                                                              // 163
	                                                                                                                  // 164
	  disconnect: function (options) {                                                                                // 165
	    var self = this;                                                                                              // 166
	    options = options || {};                                                                                      // 167
	                                                                                                                  // 168
	    // Failed is permanent. If we're failed, don't let people go back                                             // 169
	    // online by calling 'disconnect' then 'reconnect'.                                                           // 170
	    if (self._forcedToDisconnect)                                                                                 // 171
	      return;                                                                                                     // 172
	                                                                                                                  // 173
	    // If _permanent is set, permanently disconnect a stream. Once a stream                                       // 174
	    // is forced to disconnect, it can never reconnect. This is for                                               // 175
	    // error cases such as ddp version mismatch, where trying again                                               // 176
	    // won't fix the problem.                                                                                     // 177
	    if (options._permanent) {                                                                                     // 178
	      self._forcedToDisconnect = true;                                                                            // 179
	    }                                                                                                             // 180
	                                                                                                                  // 181
	    self._cleanup();                                                                                              // 182
	    self._retry.clear();                                                                                          // 183
	                                                                                                                  // 184
	    self.currentStatus = {                                                                                        // 185
	      status: (options._permanent ? "failed" : "offline"),                                                        // 186
	      connected: false,                                                                                           // 187
	      retryCount: 0                                                                                               // 188
	    };                                                                                                            // 189
	                                                                                                                  // 190
	    if (options._permanent && options._error)                                                                     // 191
	      self.currentStatus.reason = options._error;                                                                 // 192
	                                                                                                                  // 193
	    self.statusChanged();                                                                                         // 194
	  },                                                                                                              // 195
	                                                                                                                  // 196
	  // maybeError is set unless it's a clean protocol-level close.                                                  // 197
	  _lostConnection: function (maybeError) {                                                                        // 198
	    var self = this;                                                                                              // 199
	                                                                                                                  // 200
	    self._cleanup(maybeError);                                                                                    // 201
	    self._retryLater(maybeError); // sets status. no need to do it here.                                          // 202
	  },                                                                                                              // 203
	                                                                                                                  // 204
	  // fired when we detect that we've gone online. try to reconnect                                                // 205
	  // immediately.                                                                                                 // 206
	  _online: function () {                                                                                          // 207
	    // if we've requested to be offline by disconnecting, don't reconnect.                                        // 208
	    if (this.currentStatus.status != "offline")                                                                   // 209
	      this.reconnect();                                                                                           // 210
	  },                                                                                                              // 211
	                                                                                                                  // 212
	  _retryLater: function (maybeError) {                                                                            // 213
	    var self = this;                                                                                              // 214
	                                                                                                                  // 215
	    var timeout = 0;                                                                                              // 216
	    if (self.options.retry ||                                                                                     // 217
	        (maybeError && maybeError.errorType === "DDP.ForcedReconnectError")) {                                    // 218
	      timeout = self._retry.retryLater(                                                                           // 219
	        self.currentStatus.retryCount,                                                                            // 220
	        _.bind(self._retryNow, self)                                                                              // 221
	      );                                                                                                          // 222
	      self.currentStatus.status = "waiting";                                                                      // 223
	      self.currentStatus.retryTime = (new Date()).getTime() + timeout;                                            // 224
	    } else {                                                                                                      // 225
	      self.currentStatus.status = "failed";                                                                       // 226
	      delete self.currentStatus.retryTime;                                                                        // 227
	    }                                                                                                             // 228
	                                                                                                                  // 229
	    self.currentStatus.connected = false;                                                                         // 230
	    self.statusChanged();                                                                                         // 231
	  },                                                                                                              // 232
	                                                                                                                  // 233
	  _retryNow: function () {                                                                                        // 234
	    var self = this;                                                                                              // 235
	                                                                                                                  // 236
	    if (self._forcedToDisconnect)                                                                                 // 237
	      return;                                                                                                     // 238
	                                                                                                                  // 239
	    self.currentStatus.retryCount += 1;                                                                           // 240
	    self.currentStatus.status = "connecting";                                                                     // 241
	    self.currentStatus.connected = false;                                                                         // 242
	    delete self.currentStatus.retryTime;                                                                          // 243
	    self.statusChanged();                                                                                         // 244
	                                                                                                                  // 245
	    self._launchConnection();                                                                                     // 246
	  },                                                                                                              // 247
	                                                                                                                  // 248
	                                                                                                                  // 249
	  // Get current status. Reactive.                                                                                // 250
	  status: function () {                                                                                           // 251
	    var self = this;                                                                                              // 252
	    if (self.statusListeners)                                                                                     // 253
	      self.statusListeners.depend();                                                                              // 254
	    return self.currentStatus;                                                                                    // 255
	  }                                                                                                               // 256
	});                                                                                                               // 257
	                                                                                                                  // 258
	DDP.ConnectionError = Meteor.makeErrorType(                                                                       // 259
	  "DDP.ConnectionError", function (message) {                                                                     // 260
	    var self = this;                                                                                              // 261
	    self.message = message;                                                                                       // 262
	});                                                                                                               // 263
	                                                                                                                  // 264
	DDP.ForcedReconnectError = Meteor.makeErrorType(                                                                  // 265
	  "DDP.ForcedReconnectError", function () {});                                                                    // 266
	                                                                                                                  // 267
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                //
	// packages/ddp-client/livedata_common.js                                                                         //
	//                                                                                                                //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                  //
	LivedataTest.SUPPORTED_DDP_VERSIONS = DDPCommon.SUPPORTED_DDP_VERSIONS;                                           // 1
	                                                                                                                  // 2
	// This is private but it's used in a few places. accounts-base uses                                              // 3
	// it to get the current user. Meteor.setTimeout and friends clear                                                // 4
	// it. We can probably find a better way to factor this.                                                          // 5
	DDP._CurrentInvocation = new Meteor.EnvironmentVariable;                                                          // 6
	                                                                                                                  // 7
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                //
	// packages/ddp-client/random_stream.js                                                                           //
	//                                                                                                                //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                  //
	// Returns the named sequence of pseudo-random values.                                                            // 1
	// The scope will be DDP._CurrentInvocation.get(), so the stream will produce                                     // 2
	// consistent values for method calls on the client and server.                                                   // 3
	DDP.randomStream = function (name) {                                                                              // 4
	  var scope = DDP._CurrentInvocation.get();                                                                       // 5
	  return DDPCommon.RandomStream.get(scope, name);                                                                 // 6
	};                                                                                                                // 7
	                                                                                                                  // 8
	                                                                                                                  // 9
	                                                                                                                  // 10
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                //
	// packages/ddp-client/livedata_connection.js                                                                     //
	//                                                                                                                //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                  //
	if (Meteor.isServer) {                                                                                            // 1
	  var path = Npm.require('path');                                                                                 // 2
	  var Fiber = Npm.require('fibers');                                                                              // 3
	  var Future = Npm.require(path.join('fibers', 'future'));                                                        // 4
	}                                                                                                                 // 5
	                                                                                                                  // 6
	// @param url {String|Object} URL to Meteor app,                                                                  // 7
	//   or an object as a test hook (see code)                                                                       // 8
	// Options:                                                                                                       // 9
	//   reloadWithOutstanding: is it OK to reload if there are outstanding methods?                                  // 10
	//   headers: extra headers to send on the websockets connection, for                                             // 11
	//     server-to-server DDP only                                                                                  // 12
	//   _sockjsOptions: Specifies options to pass through to the sockjs client                                       // 13
	//   onDDPNegotiationVersionFailure: callback when version negotiation fails.                                     // 14
	//                                                                                                                // 15
	// XXX There should be a way to destroy a DDP connection, causing all                                             // 16
	// outstanding method calls to fail.                                                                              // 17
	//                                                                                                                // 18
	// XXX Our current way of handling failure and reconnection is great                                              // 19
	// for an app (where we want to tolerate being disconnected as an                                                 // 20
	// expect state, and keep trying forever to reconnect) but cumbersome                                             // 21
	// for something like a command line tool that wants to make a                                                    // 22
	// connection, call a method, and print an error if connection                                                    // 23
	// fails. We should have better usability in the latter case (while                                               // 24
	// still transparently reconnecting if it's just a transient failure                                              // 25
	// or the server migrating us).                                                                                   // 26
	var Connection = function (url, options) {                                                                        // 27
	  var self = this;                                                                                                // 28
	  options = _.extend({                                                                                            // 29
	    onConnected: function () {},                                                                                  // 30
	    onDDPVersionNegotiationFailure: function (description) {                                                      // 31
	      Meteor._debug(description);                                                                                 // 32
	    },                                                                                                            // 33
	    heartbeatInterval: 17500,                                                                                     // 34
	    heartbeatTimeout: 15000,                                                                                      // 35
	    npmFayeOptions: {},                                                                                           // 36
	    // These options are only for testing.                                                                        // 37
	    reloadWithOutstanding: false,                                                                                 // 38
	    supportedDDPVersions: DDPCommon.SUPPORTED_DDP_VERSIONS,                                                       // 39
	    retry: true,                                                                                                  // 40
	    respondToPings: true,                                                                                         // 41
	    // When updates are coming within this ms interval, batch them together.                                      // 42
	    bufferedWritesInterval: 5,                                                                                    // 43
	    // Flush buffers immediately if writes are happening continuously for more than this many ms.                 // 44
	    bufferedWritesMaxAge: 500                                                                                     // 45
	  }, options);                                                                                                    // 46
	                                                                                                                  // 47
	  // If set, called when we reconnect, queuing method calls _before_ the                                          // 48
	  // existing outstanding ones. This is the only data member that is part of the                                  // 49
	  // public API!                                                                                                  // 50
	  self.onReconnect = null;                                                                                        // 51
	                                                                                                                  // 52
	  // as a test hook, allow passing a stream instead of a url.                                                     // 53
	  if (typeof url === "object") {                                                                                  // 54
	    self._stream = url;                                                                                           // 55
	  } else {                                                                                                        // 56
	    self._stream = new LivedataTest.ClientStream(url, {                                                           // 57
	      retry: options.retry,                                                                                       // 58
	      headers: options.headers,                                                                                   // 59
	      _sockjsOptions: options._sockjsOptions,                                                                     // 60
	      // Used to keep some tests quiet, or for other cases in which                                               // 61
	      // the right thing to do with connection errors is to silently                                              // 62
	      // fail (e.g. sending package usage stats). At some point we                                                // 63
	      // should have a real API for handling client-stream-level                                                  // 64
	      // errors.                                                                                                  // 65
	      _dontPrintErrors: options._dontPrintErrors,                                                                 // 66
	      connectTimeoutMs: options.connectTimeoutMs,                                                                 // 67
	      npmFayeOptions: options.npmFayeOptions                                                                      // 68
	    });                                                                                                           // 69
	  }                                                                                                               // 70
	                                                                                                                  // 71
	  self._lastSessionId = null;                                                                                     // 72
	  self._versionSuggestion = null;  // The last proposed DDP version.                                              // 73
	  self._version = null;   // The DDP version agreed on by client and server.                                      // 74
	  self._stores = {}; // name -> object with methods                                                               // 75
	  self._methodHandlers = {}; // name -> func                                                                      // 76
	  self._nextMethodId = 1;                                                                                         // 77
	  self._supportedDDPVersions = options.supportedDDPVersions;                                                      // 78
	                                                                                                                  // 79
	  self._heartbeatInterval = options.heartbeatInterval;                                                            // 80
	  self._heartbeatTimeout = options.heartbeatTimeout;                                                              // 81
	                                                                                                                  // 82
	  // Tracks methods which the user has tried to call but which have not yet                                       // 83
	  // called their user callback (ie, they are waiting on their result or for all                                  // 84
	  // of their writes to be written to the local cache). Map from method ID to                                     // 85
	  // MethodInvoker object.                                                                                        // 86
	  self._methodInvokers = {};                                                                                      // 87
	                                                                                                                  // 88
	  // Tracks methods which the user has called but whose result messages have not                                  // 89
	  // arrived yet.                                                                                                 // 90
	  //                                                                                                              // 91
	  // _outstandingMethodBlocks is an array of blocks of methods. Each block                                        // 92
	  // represents a set of methods that can run at the same time. The first block                                   // 93
	  // represents the methods which are currently in flight; subsequent blocks                                      // 94
	  // must wait for previous blocks to be fully finished before they can be sent                                   // 95
	  // to the server.                                                                                               // 96
	  //                                                                                                              // 97
	  // Each block is an object with the following fields:                                                           // 98
	  // - methods: a list of MethodInvoker objects                                                                   // 99
	  // - wait: a boolean; if true, this block had a single method invoked with                                      // 100
	  //         the "wait" option                                                                                    // 101
	  //                                                                                                              // 102
	  // There will never be adjacent blocks with wait=false, because the only thing                                  // 103
	  // that makes methods need to be serialized is a wait method.                                                   // 104
	  //                                                                                                              // 105
	  // Methods are removed from the first block when their "result" is                                              // 106
	  // received. The entire first block is only removed when all of the in-flight                                   // 107
	  // methods have received their results (so the "methods" list is empty) *AND*                                   // 108
	  // all of the data written by those methods are visible in the local cache. So                                  // 109
	  // it is possible for the first block's methods list to be empty, if we are                                     // 110
	  // still waiting for some objects to quiesce.                                                                   // 111
	  //                                                                                                              // 112
	  // Example:                                                                                                     // 113
	  //  _outstandingMethodBlocks = [                                                                                // 114
	  //    {wait: false, methods: []},                                                                               // 115
	  //    {wait: true, methods: [<MethodInvoker for 'login'>]},                                                     // 116
	  //    {wait: false, methods: [<MethodInvoker for 'foo'>,                                                        // 117
	  //                            <MethodInvoker for 'bar'>]}]                                                      // 118
	  // This means that there were some methods which were sent to the server and                                    // 119
	  // which have returned their results, but some of the data written by                                           // 120
	  // the methods may not be visible in the local cache. Once all that data is                                     // 121
	  // visible, we will send a 'login' method. Once the login method has returned                                   // 122
	  // and all the data is visible (including re-running subs if userId changes),                                   // 123
	  // we will send the 'foo' and 'bar' methods in parallel.                                                        // 124
	  self._outstandingMethodBlocks = [];                                                                             // 125
	                                                                                                                  // 126
	  // method ID -> array of objects with keys 'collection' and 'id', listing                                       // 127
	  // documents written by a given method's stub. keys are associated with                                         // 128
	  // methods whose stub wrote at least one document, and whose data-done message                                  // 129
	  // has not yet been received.                                                                                   // 130
	  self._documentsWrittenByStub = {};                                                                              // 131
	  // collection -> IdMap of "server document" object. A "server document" has:                                    // 132
	  // - "document": the version of the document according the                                                      // 133
	  //   server (ie, the snapshot before a stub wrote it, amended by any changes                                    // 134
	  //   received from the server)                                                                                  // 135
	  //   It is undefined if we think the document does not exist                                                    // 136
	  // - "writtenByStubs": a set of method IDs whose stubs wrote to the document                                    // 137
	  //   whose "data done" messages have not yet been processed                                                     // 138
	  self._serverDocuments = {};                                                                                     // 139
	                                                                                                                  // 140
	  // Array of callbacks to be called after the next update of the local                                           // 141
	  // cache. Used for:                                                                                             // 142
	  //  - Calling methodInvoker.dataVisible and sub ready callbacks after                                           // 143
	  //    the relevant data is flushed.                                                                             // 144
	  //  - Invoking the callbacks of "half-finished" methods after reconnect                                         // 145
	  //    quiescence. Specifically, methods whose result was received over the old                                  // 146
	  //    connection (so we don't re-send it) but whose data had not been made                                      // 147
	  //    visible.                                                                                                  // 148
	  self._afterUpdateCallbacks = [];                                                                                // 149
	                                                                                                                  // 150
	  // In two contexts, we buffer all incoming data messages and then process them                                  // 151
	  // all at once in a single update:                                                                              // 152
	  //   - During reconnect, we buffer all data messages until all subs that had                                    // 153
	  //     been ready before reconnect are ready again, and all methods that are                                    // 154
	  //     active have returned their "data done message"; then                                                     // 155
	  //   - During the execution of a "wait" method, we buffer all data messages                                     // 156
	  //     until the wait method gets its "data done" message. (If the wait method                                  // 157
	  //     occurs during reconnect, it doesn't get any special handling.)                                           // 158
	  // all data messages are processed in one update.                                                               // 159
	  //                                                                                                              // 160
	  // The following fields are used for this "quiescence" process.                                                 // 161
	                                                                                                                  // 162
	  // This buffers the messages that aren't being processed yet.                                                   // 163
	  self._messagesBufferedUntilQuiescence = [];                                                                     // 164
	  // Map from method ID -> true. Methods are removed from this when their                                         // 165
	  // "data done" message is received, and we will not quiesce until it is                                         // 166
	  // empty.                                                                                                       // 167
	  self._methodsBlockingQuiescence = {};                                                                           // 168
	  // map from sub ID -> true for subs that were ready (ie, called the sub                                         // 169
	  // ready callback) before reconnect but haven't become ready again yet                                          // 170
	  self._subsBeingRevived = {}; // map from sub._id -> true                                                        // 171
	  // if true, the next data update should reset all stores. (set during                                           // 172
	  // reconnect.)                                                                                                  // 173
	  self._resetStores = false;                                                                                      // 174
	                                                                                                                  // 175
	  // name -> array of updates for (yet to be created) collections                                                 // 176
	  self._updatesForUnknownStores = {};                                                                             // 177
	  // if we're blocking a migration, the retry func                                                                // 178
	  self._retryMigrate = null;                                                                                      // 179
	                                                                                                                  // 180
	  self.__flushBufferedWrites = Meteor.bindEnvironment(                                                            // 181
	    self._flushBufferedWrites, "flushing DDP buffered writes", self);                                             // 182
	  // Collection name -> array of messages.                                                                        // 183
	  self._bufferedWrites = {};                                                                                      // 184
	  // When current buffer of updates must be flushed at, in ms timestamp.                                          // 185
	  self._bufferedWritesFlushAt = null;                                                                             // 186
	  // Timeout handle for the next processing of all pending writes                                                 // 187
	  self._bufferedWritesFlushHandle = null;                                                                         // 188
	                                                                                                                  // 189
	  self._bufferedWritesInterval = options.bufferedWritesInterval;                                                  // 190
	  self._bufferedWritesMaxAge = options.bufferedWritesMaxAge;                                                      // 191
	                                                                                                                  // 192
	  // metadata for subscriptions.  Map from sub ID to object with keys:                                            // 193
	  //   - id                                                                                                       // 194
	  //   - name                                                                                                     // 195
	  //   - params                                                                                                   // 196
	  //   - inactive (if true, will be cleaned up if not reused in re-run)                                           // 197
	  //   - ready (has the 'ready' message been received?)                                                           // 198
	  //   - readyCallback (an optional callback to call when ready)                                                  // 199
	  //   - errorCallback (an optional callback to call if the sub terminates with                                   // 200
	  //                    an error, XXX COMPAT WITH 1.0.3.1)                                                        // 201
	  //   - stopCallback (an optional callback to call when the sub terminates                                       // 202
	  //     for any reason, with an error argument if an error triggered the stop)                                   // 203
	  self._subscriptions = {};                                                                                       // 204
	                                                                                                                  // 205
	  // Reactive userId.                                                                                             // 206
	  self._userId = null;                                                                                            // 207
	  self._userIdDeps = new Tracker.Dependency;                                                                      // 208
	                                                                                                                  // 209
	  // Block auto-reload while we're waiting for method responses.                                                  // 210
	  if (Meteor.isClient && Package.reload && !options.reloadWithOutstanding) {                                      // 211
	    Package.reload.Reload._onMigrate(function (retry) {                                                           // 212
	      if (!self._readyToMigrate()) {                                                                              // 213
	        if (self._retryMigrate)                                                                                   // 214
	          throw new Error("Two migrations in progress?");                                                         // 215
	        self._retryMigrate = retry;                                                                               // 216
	        return false;                                                                                             // 217
	      } else {                                                                                                    // 218
	        return [true];                                                                                            // 219
	      }                                                                                                           // 220
	    });                                                                                                           // 221
	  }                                                                                                               // 222
	                                                                                                                  // 223
	  var onMessage = function (raw_msg) {                                                                            // 224
	    try {                                                                                                         // 225
	      var msg = DDPCommon.parseDDP(raw_msg);                                                                      // 226
	    } catch (e) {                                                                                                 // 227
	      Meteor._debug("Exception while parsing DDP", e);                                                            // 228
	      return;                                                                                                     // 229
	    }                                                                                                             // 230
	                                                                                                                  // 231
	    // Any message counts as receiving a pong, as it demonstrates that                                            // 232
	    // the server is still alive.                                                                                 // 233
	    if (self._heartbeat) {                                                                                        // 234
	      self._heartbeat.messageReceived();                                                                          // 235
	    }                                                                                                             // 236
	                                                                                                                  // 237
	    if (msg === null || !msg.msg) {                                                                               // 238
	      // XXX COMPAT WITH 0.6.6. ignore the old welcome message for back                                           // 239
	      // compat.  Remove this 'if' once the server stops sending welcome                                          // 240
	      // messages (stream_server.js).                                                                             // 241
	      if (! (msg && msg.server_id))                                                                               // 242
	        Meteor._debug("discarding invalid livedata message", msg);                                                // 243
	      return;                                                                                                     // 244
	    }                                                                                                             // 245
	                                                                                                                  // 246
	    if (msg.msg === 'connected') {                                                                                // 247
	      self._version = self._versionSuggestion;                                                                    // 248
	      self._livedata_connected(msg);                                                                              // 249
	      options.onConnected();                                                                                      // 250
	    }                                                                                                             // 251
	    else if (msg.msg === 'failed') {                                                                              // 252
	      if (_.contains(self._supportedDDPVersions, msg.version)) {                                                  // 253
	        self._versionSuggestion = msg.version;                                                                    // 254
	        self._stream.reconnect({_force: true});                                                                   // 255
	      } else {                                                                                                    // 256
	        var description =                                                                                         // 257
	              "DDP version negotiation failed; server requested version " + msg.version;                          // 258
	        self._stream.disconnect({_permanent: true, _error: description});                                         // 259
	        options.onDDPVersionNegotiationFailure(description);                                                      // 260
	      }                                                                                                           // 261
	    }                                                                                                             // 262
	    else if (msg.msg === 'ping' && options.respondToPings) {                                                      // 263
	      self._send({msg: "pong", id: msg.id});                                                                      // 264
	    }                                                                                                             // 265
	    else if (msg.msg === 'pong') {                                                                                // 266
	      // noop, as we assume everything's a pong                                                                   // 267
	    }                                                                                                             // 268
	    else if (_.include(['added', 'changed', 'removed', 'ready', 'updated'], msg.msg))                             // 269
	      self._livedata_data(msg);                                                                                   // 270
	    else if (msg.msg === 'nosub')                                                                                 // 271
	      self._livedata_nosub(msg);                                                                                  // 272
	    else if (msg.msg === 'result')                                                                                // 273
	      self._livedata_result(msg);                                                                                 // 274
	    else if (msg.msg === 'error')                                                                                 // 275
	      self._livedata_error(msg);                                                                                  // 276
	    else                                                                                                          // 277
	      Meteor._debug("discarding unknown livedata message type", msg);                                             // 278
	  };                                                                                                              // 279
	                                                                                                                  // 280
	  var onReset = function () {                                                                                     // 281
	    // Send a connect message at the beginning of the stream.                                                     // 282
	    // NOTE: reset is called even on the first connection, so this is                                             // 283
	    // the only place we send this message.                                                                       // 284
	    var msg = {msg: 'connect'};                                                                                   // 285
	    if (self._lastSessionId)                                                                                      // 286
	      msg.session = self._lastSessionId;                                                                          // 287
	    msg.version = self._versionSuggestion || self._supportedDDPVersions[0];                                       // 288
	    self._versionSuggestion = msg.version;                                                                        // 289
	    msg.support = self._supportedDDPVersions;                                                                     // 290
	    self._send(msg);                                                                                              // 291
	                                                                                                                  // 292
	    // Mark non-retry calls as failed. This has to be done early as getting these methods out of the              // 293
	    // current block is pretty important to making sure that quiescence is properly calculated, as                // 294
	    // well as possibly moving on to another useful block.                                                        // 295
	                                                                                                                  // 296
	    // Only bother testing if there is an outstandingMethodBlock (there might not be, especially if               // 297
	    // we are connecting for the first time.                                                                      // 298
	    if (self._outstandingMethodBlocks.length > 0) {                                                               // 299
	      // If there is an outstanding method block, we only care about the first one as that is the                 // 300
	      // one that could have already sent messages with no response, that are not allowed to retry.               // 301
	      _.each(self._outstandingMethodBlocks[0].methods, function(methodInvoker) {                                  // 302
	        // If the message wasn't sent or it's allowed to retry, do nothing.                                       // 303
	        if (methodInvoker.sentMessage && methodInvoker.noRetry) {                                                 // 304
	          // The next loop serves to get the index in the current method block of this method.                    // 305
	          var currentMethodBlock = self._outstandingMethodBlocks[0].methods;                                      // 306
	          var loopMethod;                                                                                         // 307
	          for (var i = 0; i < currentMethodBlock.length; i++) {                                                   // 308
	            loopMethod = currentMethodBlock[i];                                                                   // 309
	            if (loopMethod.methodId === methodInvoker.methodId) {                                                 // 310
	              break;                                                                                              // 311
	            }                                                                                                     // 312
	          }                                                                                                       // 313
	                                                                                                                  // 314
	          // Remove from current method block. This may leave the block empty, but we                             // 315
	          // don't move on to the next block until the callback has been delivered, in                            // 316
	          // _outstandingMethodFinished.                                                                          // 317
	          currentMethodBlock.splice(i, 1);                                                                        // 318
	                                                                                                                  // 319
	          // Make sure that the method is told that it failed.                                                    // 320
	          methodInvoker.receiveResult(new Meteor.Error('invocation-failed',                                       // 321
	            'Method invocation might have failed due to dropped connection. ' +                                   // 322
	            'Failing because `noRetry` option was passed to Meteor.apply.'));                                     // 323
	        }                                                                                                         // 324
	      });                                                                                                         // 325
	    }                                                                                                             // 326
	                                                                                                                  // 327
	    // Now, to minimize setup latency, go ahead and blast out all of                                              // 328
	    // our pending methods ands subscriptions before we've even taken                                             // 329
	    // the necessary RTT to know if we successfully reconnected. (1)                                              // 330
	    // They're supposed to be idempotent, and where they are not,                                                 // 331
	    // they can block retry in apply; (2) even if we did reconnect,                                               // 332
	    // we're not sure what messages might have gotten lost                                                        // 333
	    // (in either direction) since we were disconnected (TCP being                                                // 334
	    // sloppy about that.)                                                                                        // 335
	                                                                                                                  // 336
	    // If the current block of methods all got their results (but didn't all get                                  // 337
	    // their data visible), discard the empty block now.                                                          // 338
	    if (! _.isEmpty(self._outstandingMethodBlocks) &&                                                             // 339
	        _.isEmpty(self._outstandingMethodBlocks[0].methods)) {                                                    // 340
	      self._outstandingMethodBlocks.shift();                                                                      // 341
	    }                                                                                                             // 342
	                                                                                                                  // 343
	    // Mark all messages as unsent, they have not yet been sent on this                                           // 344
	    // connection.                                                                                                // 345
	    _.each(self._methodInvokers, function (m) {                                                                   // 346
	      m.sentMessage = false;                                                                                      // 347
	    });                                                                                                           // 348
	                                                                                                                  // 349
	    // If an `onReconnect` handler is set, call it first. Go through                                              // 350
	    // some hoops to ensure that methods that are called from within                                              // 351
	    // `onReconnect` get executed _before_ ones that were originally                                              // 352
	    // outstanding (since `onReconnect` is used to re-establish auth                                              // 353
	    // certificates)                                                                                              // 354
	    if (self.onReconnect)                                                                                         // 355
	      self._callOnReconnectAndSendAppropriateOutstandingMethods();                                                // 356
	    else                                                                                                          // 357
	      self._sendOutstandingMethods();                                                                             // 358
	                                                                                                                  // 359
	    // add new subscriptions at the end. this way they take effect after                                          // 360
	    // the handlers and we don't see flicker.                                                                     // 361
	    _.each(self._subscriptions, function (sub, id) {                                                              // 362
	      self._send({                                                                                                // 363
	        msg: 'sub',                                                                                               // 364
	        id: id,                                                                                                   // 365
	        name: sub.name,                                                                                           // 366
	        params: sub.params                                                                                        // 367
	      });                                                                                                         // 368
	    });                                                                                                           // 369
	  };                                                                                                              // 370
	                                                                                                                  // 371
	  var onDisconnect = function () {                                                                                // 372
	    if (self._heartbeat) {                                                                                        // 373
	      self._heartbeat.stop();                                                                                     // 374
	      self._heartbeat = null;                                                                                     // 375
	    }                                                                                                             // 376
	  };                                                                                                              // 377
	                                                                                                                  // 378
	  if (Meteor.isServer) {                                                                                          // 379
	    self._stream.on('message', Meteor.bindEnvironment(onMessage, "handling DDP message"));                        // 380
	    self._stream.on('reset', Meteor.bindEnvironment(onReset, "handling DDP reset"));                              // 381
	    self._stream.on('disconnect', Meteor.bindEnvironment(onDisconnect, "handling DDP disconnect"));               // 382
	  } else {                                                                                                        // 383
	    self._stream.on('message', onMessage);                                                                        // 384
	    self._stream.on('reset', onReset);                                                                            // 385
	    self._stream.on('disconnect', onDisconnect);                                                                  // 386
	  }                                                                                                               // 387
	};                                                                                                                // 388
	                                                                                                                  // 389
	// A MethodInvoker manages sending a method to the server and calling the user's                                  // 390
	// callbacks. On construction, it registers itself in the connection's                                            // 391
	// _methodInvokers map; it removes itself once the method is fully finished and                                   // 392
	// the callback is invoked. This occurs when it has both received a result,                                       // 393
	// and the data written by it is fully visible.                                                                   // 394
	var MethodInvoker = function (options) {                                                                          // 395
	  var self = this;                                                                                                // 396
	                                                                                                                  // 397
	  // Public (within this file) fields.                                                                            // 398
	  self.methodId = options.methodId;                                                                               // 399
	  self.sentMessage = false;                                                                                       // 400
	                                                                                                                  // 401
	  self._callback = options.callback;                                                                              // 402
	  self._connection = options.connection;                                                                          // 403
	  self._message = options.message;                                                                                // 404
	  self._onResultReceived = options.onResultReceived || function () {};                                            // 405
	  self._wait = options.wait;                                                                                      // 406
	  self.noRetry = options.noRetry;                                                                                 // 407
	  self._methodResult = null;                                                                                      // 408
	  self._dataVisible = false;                                                                                      // 409
	                                                                                                                  // 410
	  // Register with the connection.                                                                                // 411
	  self._connection._methodInvokers[self.methodId] = self;                                                         // 412
	};                                                                                                                // 413
	_.extend(MethodInvoker.prototype, {                                                                               // 414
	  // Sends the method message to the server. May be called additional times if                                    // 415
	  // we lose the connection and reconnect before receiving a result.                                              // 416
	  sendMessage: function () {                                                                                      // 417
	    var self = this;                                                                                              // 418
	    // This function is called before sending a method (including resending on                                    // 419
	    // reconnect). We should only (re)send methods where we don't already have a                                  // 420
	    // result!                                                                                                    // 421
	    if (self.gotResult())                                                                                         // 422
	      throw new Error("sendingMethod is called on method with result");                                           // 423
	                                                                                                                  // 424
	                                                                                                                  // 425
	    // If we're re-sending it, it doesn't matter if data was written the first                                    // 426
	    // time.                                                                                                      // 427
	    self._dataVisible = false;                                                                                    // 428
	    self.sentMessage = true;                                                                                      // 429
	                                                                                                                  // 430
	    // If this is a wait method, make all data messages be buffered until it is                                   // 431
	    // done.                                                                                                      // 432
	    if (self._wait)                                                                                               // 433
	      self._connection._methodsBlockingQuiescence[self.methodId] = true;                                          // 434
	                                                                                                                  // 435
	    // Actually send the message.                                                                                 // 436
	    self._connection._send(self._message);                                                                        // 437
	  },                                                                                                              // 438
	  // Invoke the callback, if we have both a result and know that all data has                                     // 439
	  // been written to the local cache.                                                                             // 440
	  _maybeInvokeCallback: function () {                                                                             // 441
	    var self = this;                                                                                              // 442
	    if (self._methodResult && self._dataVisible) {                                                                // 443
	      // Call the callback. (This won't throw: the callback was wrapped with                                      // 444
	      // bindEnvironment.)                                                                                        // 445
	      self._callback(self._methodResult[0], self._methodResult[1]);                                               // 446
	                                                                                                                  // 447
	      // Forget about this method.                                                                                // 448
	      delete self._connection._methodInvokers[self.methodId];                                                     // 449
	                                                                                                                  // 450
	      // Let the connection know that this method is finished, so it can try to                                   // 451
	      // move on to the next block of methods.                                                                    // 452
	      self._connection._outstandingMethodFinished();                                                              // 453
	    }                                                                                                             // 454
	  },                                                                                                              // 455
	  // Call with the result of the method from the server. Only may be called                                       // 456
	  // once; once it is called, you should not call sendMessage again.                                              // 457
	  // If the user provided an onResultReceived callback, call it immediately.                                      // 458
	  // Then invoke the main callback if data is also visible.                                                       // 459
	  receiveResult: function (err, result) {                                                                         // 460
	    var self = this;                                                                                              // 461
	    if (self.gotResult())                                                                                         // 462
	      throw new Error("Methods should only receive results once");                                                // 463
	    self._methodResult = [err, result];                                                                           // 464
	    self._onResultReceived(err, result);                                                                          // 465
	    self._maybeInvokeCallback();                                                                                  // 466
	  },                                                                                                              // 467
	  // Call this when all data written by the method is visible. This means that                                    // 468
	  // the method has returns its "data is done" message *AND* all server                                           // 469
	  // documents that are buffered at that time have been written to the local                                      // 470
	  // cache. Invokes the main callback if the result has been received.                                            // 471
	  dataVisible: function () {                                                                                      // 472
	    var self = this;                                                                                              // 473
	    self._dataVisible = true;                                                                                     // 474
	    self._maybeInvokeCallback();                                                                                  // 475
	  },                                                                                                              // 476
	  // True if receiveResult has been called.                                                                       // 477
	  gotResult: function () {                                                                                        // 478
	    var self = this;                                                                                              // 479
	    return !!self._methodResult;                                                                                  // 480
	  }                                                                                                               // 481
	});                                                                                                               // 482
	                                                                                                                  // 483
	_.extend(Connection.prototype, {                                                                                  // 484
	  // 'name' is the name of the data on the wire that should go in the                                             // 485
	  // store. 'wrappedStore' should be an object with methods beginUpdate, update,                                  // 486
	  // endUpdate, saveOriginals, retrieveOriginals. see Collection for an example.                                  // 487
	  registerStore: function (name, wrappedStore) {                                                                  // 488
	    var self = this;                                                                                              // 489
	                                                                                                                  // 490
	    if (name in self._stores)                                                                                     // 491
	      return false;                                                                                               // 492
	                                                                                                                  // 493
	    // Wrap the input object in an object which makes any store method not                                        // 494
	    // implemented by 'store' into a no-op.                                                                       // 495
	    var store = {};                                                                                               // 496
	    _.each(['update', 'beginUpdate', 'endUpdate', 'saveOriginals',                                                // 497
	            'retrieveOriginals', 'getDoc',                                                                        // 498
				'_getCollection'], function (method) {                                                                         // 499
	              store[method] = function () {                                                                       // 500
	                return (wrappedStore[method]                                                                      // 501
	                        ? wrappedStore[method].apply(wrappedStore, arguments)                                     // 502
	                        : undefined);                                                                             // 503
	              };                                                                                                  // 504
	            });                                                                                                   // 505
	                                                                                                                  // 506
	    self._stores[name] = store;                                                                                   // 507
	                                                                                                                  // 508
	    var queued = self._updatesForUnknownStores[name];                                                             // 509
	    if (queued) {                                                                                                 // 510
	      store.beginUpdate(queued.length, false);                                                                    // 511
	      _.each(queued, function (msg) {                                                                             // 512
	        store.update(msg);                                                                                        // 513
	      });                                                                                                         // 514
	      store.endUpdate();                                                                                          // 515
	      delete self._updatesForUnknownStores[name];                                                                 // 516
	    }                                                                                                             // 517
	                                                                                                                  // 518
	    return true;                                                                                                  // 519
	  },                                                                                                              // 520
	                                                                                                                  // 521
	  /**                                                                                                             // 522
	   * @memberOf Meteor                                                                                             // 523
	   * @importFromPackage meteor                                                                                    // 524
	   * @summary Subscribe to a record set.  Returns a handle that provides                                          // 525
	   * `stop()` and `ready()` methods.                                                                              // 526
	   * @locus Client                                                                                                // 527
	   * @param {String} name Name of the subscription.  Matches the name of the                                      // 528
	   * server's `publish()` call.                                                                                   // 529
	   * @param {EJSONable} [arg1,arg2...] Optional arguments passed to publisher                                     // 530
	   * function on server.                                                                                          // 531
	   * @param {Function|Object} [callbacks] Optional. May include `onStop`                                          // 532
	   * and `onReady` callbacks. If there is an error, it is passed as an                                            // 533
	   * argument to `onStop`. If a function is passed instead of an object, it                                       // 534
	   * is interpreted as an `onReady` callback.                                                                     // 535
	   */                                                                                                             // 536
	  subscribe: function (name /* .. [arguments] .. (callback|callbacks) */) {                                       // 537
	    var self = this;                                                                                              // 538
	                                                                                                                  // 539
	    var params = Array.prototype.slice.call(arguments, 1);                                                        // 540
	    var callbacks = {};                                                                                           // 541
	    if (params.length) {                                                                                          // 542
	      var lastParam = params[params.length - 1];                                                                  // 543
	      if (_.isFunction(lastParam)) {                                                                              // 544
	        callbacks.onReady = params.pop();                                                                         // 545
	      } else if (lastParam &&                                                                                     // 546
	        // XXX COMPAT WITH 1.0.3.1 onError used to exist, but now we use                                          // 547
	        // onStop with an error callback instead.                                                                 // 548
	        _.any([lastParam.onReady, lastParam.onError, lastParam.onStop],                                           // 549
	          _.isFunction)) {                                                                                        // 550
	        callbacks = params.pop();                                                                                 // 551
	      }                                                                                                           // 552
	    }                                                                                                             // 553
	                                                                                                                  // 554
	    // Is there an existing sub with the same name and param, run in an                                           // 555
	    // invalidated Computation? This will happen if we are rerunning an                                           // 556
	    // existing computation.                                                                                      // 557
	    //                                                                                                            // 558
	    // For example, consider a rerun of:                                                                          // 559
	    //                                                                                                            // 560
	    //     Tracker.autorun(function () {                                                                          // 561
	    //       Meteor.subscribe("foo", Session.get("foo"));                                                         // 562
	    //       Meteor.subscribe("bar", Session.get("bar"));                                                         // 563
	    //     });                                                                                                    // 564
	    //                                                                                                            // 565
	    // If "foo" has changed but "bar" has not, we will match the "bar"                                            // 566
	    // subcribe to an existing inactive subscription in order to not                                              // 567
	    // unsub and resub the subscription unnecessarily.                                                            // 568
	    //                                                                                                            // 569
	    // We only look for one such sub; if there are N apparently-identical subs                                    // 570
	    // being invalidated, we will require N matching subscribe calls to keep                                      // 571
	    // them all active.                                                                                           // 572
	    var existing = _.find(self._subscriptions, function (sub) {                                                   // 573
	      return sub.inactive && sub.name === name &&                                                                 // 574
	        EJSON.equals(sub.params, params);                                                                         // 575
	    });                                                                                                           // 576
	                                                                                                                  // 577
	    var id;                                                                                                       // 578
	    if (existing) {                                                                                               // 579
	      id = existing.id;                                                                                           // 580
	      existing.inactive = false; // reactivate                                                                    // 581
	                                                                                                                  // 582
	      if (callbacks.onReady) {                                                                                    // 583
	        // If the sub is not already ready, replace any ready callback with the                                   // 584
	        // one provided now. (It's not really clear what users would expect for                                   // 585
	        // an onReady callback inside an autorun; the semantics we provide is                                     // 586
	        // that at the time the sub first becomes ready, we call the last                                         // 587
	        // onReady callback provided, if any.)                                                                    // 588
	        if (!existing.ready)                                                                                      // 589
	          existing.readyCallback = callbacks.onReady;                                                             // 590
	      }                                                                                                           // 591
	                                                                                                                  // 592
	      // XXX COMPAT WITH 1.0.3.1 we used to have onError but now we call                                          // 593
	      // onStop with an optional error argument                                                                   // 594
	      if (callbacks.onError) {                                                                                    // 595
	        // Replace existing callback if any, so that errors aren't                                                // 596
	        // double-reported.                                                                                       // 597
	        existing.errorCallback = callbacks.onError;                                                               // 598
	      }                                                                                                           // 599
	                                                                                                                  // 600
	      if (callbacks.onStop) {                                                                                     // 601
	        existing.stopCallback = callbacks.onStop;                                                                 // 602
	      }                                                                                                           // 603
	    } else {                                                                                                      // 604
	      // New sub! Generate an id, save it locally, and send message.                                              // 605
	      id = Random.id();                                                                                           // 606
	      self._subscriptions[id] = {                                                                                 // 607
	        id: id,                                                                                                   // 608
	        name: name,                                                                                               // 609
	        params: EJSON.clone(params),                                                                              // 610
	        inactive: false,                                                                                          // 611
	        ready: false,                                                                                             // 612
	        readyDeps: new Tracker.Dependency,                                                                        // 613
	        readyCallback: callbacks.onReady,                                                                         // 614
	        // XXX COMPAT WITH 1.0.3.1 #errorCallback                                                                 // 615
	        errorCallback: callbacks.onError,                                                                         // 616
	        stopCallback: callbacks.onStop,                                                                           // 617
	        connection: self,                                                                                         // 618
	        remove: function() {                                                                                      // 619
	          delete this.connection._subscriptions[this.id];                                                         // 620
	          this.ready && this.readyDeps.changed();                                                                 // 621
	        },                                                                                                        // 622
	        stop: function() {                                                                                        // 623
	          this.connection._send({msg: 'unsub', id: id});                                                          // 624
	          this.remove();                                                                                          // 625
	                                                                                                                  // 626
	          if (callbacks.onStop) {                                                                                 // 627
	            callbacks.onStop();                                                                                   // 628
	          }                                                                                                       // 629
	        }                                                                                                         // 630
	      };                                                                                                          // 631
	      self._send({msg: 'sub', id: id, name: name, params: params});                                               // 632
	    }                                                                                                             // 633
	                                                                                                                  // 634
	    // return a handle to the application.                                                                        // 635
	    var handle = {                                                                                                // 636
	      stop: function () {                                                                                         // 637
	        if (!_.has(self._subscriptions, id))                                                                      // 638
	          return;                                                                                                 // 639
	                                                                                                                  // 640
	        self._subscriptions[id].stop();                                                                           // 641
	      },                                                                                                          // 642
	      ready: function () {                                                                                        // 643
	        // return false if we've unsubscribed.                                                                    // 644
	        if (!_.has(self._subscriptions, id))                                                                      // 645
	          return false;                                                                                           // 646
	        var record = self._subscriptions[id];                                                                     // 647
	        record.readyDeps.depend();                                                                                // 648
	        return record.ready;                                                                                      // 649
	      },                                                                                                          // 650
	      subscriptionId: id                                                                                          // 651
	    };                                                                                                            // 652
	                                                                                                                  // 653
	    if (Tracker.active) {                                                                                         // 654
	      // We're in a reactive computation, so we'd like to unsubscribe when the                                    // 655
	      // computation is invalidated... but not if the rerun just re-subscribes                                    // 656
	      // to the same subscription!  When a rerun happens, we use onInvalidate                                     // 657
	      // as a change to mark the subscription "inactive" so that it can                                           // 658
	      // be reused from the rerun.  If it isn't reused, it's killed from                                          // 659
	      // an afterFlush.                                                                                           // 660
	      Tracker.onInvalidate(function (c) {                                                                         // 661
	        if (_.has(self._subscriptions, id))                                                                       // 662
	          self._subscriptions[id].inactive = true;                                                                // 663
	                                                                                                                  // 664
	        Tracker.afterFlush(function () {                                                                          // 665
	          if (_.has(self._subscriptions, id) &&                                                                   // 666
	              self._subscriptions[id].inactive)                                                                   // 667
	            handle.stop();                                                                                        // 668
	        });                                                                                                       // 669
	      });                                                                                                         // 670
	    }                                                                                                             // 671
	                                                                                                                  // 672
	    return handle;                                                                                                // 673
	  },                                                                                                              // 674
	                                                                                                                  // 675
	  // options:                                                                                                     // 676
	  // - onLateError {Function(error)} called if an error was received after the ready event.                       // 677
	  //     (errors received before ready cause an error to be thrown)                                               // 678
	  _subscribeAndWait: function (name, args, options) {                                                             // 679
	    var self = this;                                                                                              // 680
	    var f = new Future();                                                                                         // 681
	    var ready = false;                                                                                            // 682
	    var handle;                                                                                                   // 683
	    args = args || [];                                                                                            // 684
	    args.push({                                                                                                   // 685
	      onReady: function () {                                                                                      // 686
	        ready = true;                                                                                             // 687
	        f['return']();                                                                                            // 688
	      },                                                                                                          // 689
	      onError: function (e) {                                                                                     // 690
	        if (!ready)                                                                                               // 691
	          f['throw'](e);                                                                                          // 692
	        else                                                                                                      // 693
	          options && options.onLateError && options.onLateError(e);                                               // 694
	      }                                                                                                           // 695
	    });                                                                                                           // 696
	                                                                                                                  // 697
	    handle = self.subscribe.apply(self, [name].concat(args));                                                     // 698
	    f.wait();                                                                                                     // 699
	    return handle;                                                                                                // 700
	  },                                                                                                              // 701
	                                                                                                                  // 702
	  methods: function (methods) {                                                                                   // 703
	    var self = this;                                                                                              // 704
	    _.each(methods, function (func, name) {                                                                       // 705
	      if (typeof func !== 'function')                                                                             // 706
	        throw new Error("Method '" + name + "' must be a function");                                              // 707
	      if (self._methodHandlers[name])                                                                             // 708
	        throw new Error("A method named '" + name + "' is already defined");                                      // 709
	      self._methodHandlers[name] = func;                                                                          // 710
	    });                                                                                                           // 711
	  },                                                                                                              // 712
	                                                                                                                  // 713
	  /**                                                                                                             // 714
	   * @memberOf Meteor                                                                                             // 715
	   * @importFromPackage meteor                                                                                    // 716
	   * @summary Invokes a method passing any number of arguments.                                                   // 717
	   * @locus Anywhere                                                                                              // 718
	   * @param {String} name Name of method to invoke                                                                // 719
	   * @param {EJSONable} [arg1,arg2...] Optional method arguments                                                  // 720
	   * @param {Function} [asyncCallback] Optional callback, which is called asynchronously with the error or result after the method is complete. If not provided, the method runs synchronously if possible (see below).
	   */                                                                                                             // 722
	  call: function (name /* .. [arguments] .. callback */) {                                                        // 723
	    // if it's a function, the last argument is the result callback,                                              // 724
	    // not a parameter to the remote method.                                                                      // 725
	    var args = Array.prototype.slice.call(arguments, 1);                                                          // 726
	    if (args.length && typeof args[args.length - 1] === "function")                                               // 727
	      var callback = args.pop();                                                                                  // 728
	    return this.apply(name, args, callback);                                                                      // 729
	  },                                                                                                              // 730
	                                                                                                                  // 731
	  // @param options {Optional Object}                                                                             // 732
	  //   wait: Boolean - Should we wait to call this until all current methods                                      // 733
	  //                   are fully finished, and block subsequent method calls                                      // 734
	  //                   until this method is fully finished?                                                       // 735
	  //                   (does not affect methods called from within this method)                                   // 736
	  //   onResultReceived: Function - a callback to call as soon as the method                                      // 737
	  //                                result is received. the data written by                                       // 738
	  //                                the method may not yet be in the cache!                                       // 739
	  //   returnStubValue: Boolean - If true then in cases where we would have                                       // 740
	  //                              otherwise discarded the stub's return value                                     // 741
	  //                              and returned undefined, instead we go ahead                                     // 742
	  //                              and return it.  Specifically, this is any                                       // 743
	  //                              time other than when (a) we are already                                         // 744
	  //                              inside a stub or (b) we are in Node and no                                      // 745
	  //                              callback was provided.  Currently we require                                    // 746
	  //                              this flag to be explicitly passed to reduce                                     // 747
	  //                              the likelihood that stub return values will                                     // 748
	  //                              be confused with server return values; we                                       // 749
	  //                              may improve this in future.                                                     // 750
	  // @param callback {Optional Function}                                                                          // 751
	                                                                                                                  // 752
	  /**                                                                                                             // 753
	   * @memberOf Meteor                                                                                             // 754
	   * @importFromPackage meteor                                                                                    // 755
	   * @summary Invoke a method passing an array of arguments.                                                      // 756
	   * @locus Anywhere                                                                                              // 757
	   * @param {String} name Name of method to invoke                                                                // 758
	   * @param {EJSONable[]} args Method arguments                                                                   // 759
	   * @param {Object} [options]                                                                                    // 760
	   * @param {Boolean} options.wait (Client only) If true, don't send this method until all previous method calls have completed, and don't send any subsequent method calls until this one is completed.
	   * @param {Function} options.onResultReceived (Client only) This callback is invoked with the error or result of the method (just like `asyncCallback`) as soon as the error or result is available. The local cache may not yet reflect the writes performed by the method.
	   * @param {Boolean} options.noRetry (Client only) if true, don't send this method again on reload, simply call the callback an error with the error code 'invocation-failed'.
	   * @param {Function} [asyncCallback] Optional callback; same semantics as in [`Meteor.call`](#meteor_call).     // 764
	   */                                                                                                             // 765
	  apply: function (name, args, options, callback) {                                                               // 766
	    var self = this;                                                                                              // 767
	                                                                                                                  // 768
	    // We were passed 3 arguments. They may be either (name, args, options)                                       // 769
	    // or (name, args, callback)                                                                                  // 770
	    if (!callback && typeof options === 'function') {                                                             // 771
	      callback = options;                                                                                         // 772
	      options = {};                                                                                               // 773
	    }                                                                                                             // 774
	    options = options || {};                                                                                      // 775
	                                                                                                                  // 776
	    if (callback) {                                                                                               // 777
	      // XXX would it be better form to do the binding in stream.on,                                              // 778
	      // or caller, instead of here?                                                                              // 779
	      // XXX improve error message (and how we report it)                                                         // 780
	      callback = Meteor.bindEnvironment(                                                                          // 781
	        callback,                                                                                                 // 782
	        "delivering result of invoking '" + name + "'"                                                            // 783
	      );                                                                                                          // 784
	    }                                                                                                             // 785
	                                                                                                                  // 786
	    // Keep our args safe from mutation (eg if we don't send the message for a                                    // 787
	    // while because of a wait method).                                                                           // 788
	    args = EJSON.clone(args);                                                                                     // 789
	                                                                                                                  // 790
	    // Lazily allocate method ID once we know that it'll be needed.                                               // 791
	    var methodId = (function () {                                                                                 // 792
	      var id;                                                                                                     // 793
	      return function () {                                                                                        // 794
	        if (id === undefined)                                                                                     // 795
	          id = '' + (self._nextMethodId++);                                                                       // 796
	        return id;                                                                                                // 797
	      };                                                                                                          // 798
	    })();                                                                                                         // 799
	                                                                                                                  // 800
	    var enclosing = DDP._CurrentInvocation.get();                                                                 // 801
	    var alreadyInSimulation = enclosing && enclosing.isSimulation;                                                // 802
	                                                                                                                  // 803
	    // Lazily generate a randomSeed, only if it is requested by the stub.                                         // 804
	    // The random streams only have utility if they're used on both the client                                    // 805
	    // and the server; if the client doesn't generate any 'random' values                                         // 806
	    // then we don't expect the server to generate any either.                                                    // 807
	    // Less commonly, the server may perform different actions from the client,                                   // 808
	    // and may in fact generate values where the client did not, but we don't                                     // 809
	    // have any client-side values to match, so even here we may as well just                                     // 810
	    // use a random seed on the server.  In that case, we don't pass the                                          // 811
	    // randomSeed to save bandwidth, and we don't even generate it to save a                                      // 812
	    // bit of CPU and to avoid consuming entropy.                                                                 // 813
	    var randomSeed = null;                                                                                        // 814
	    var randomSeedGenerator = function () {                                                                       // 815
	      if (randomSeed === null) {                                                                                  // 816
	        randomSeed = DDPCommon.makeRpcSeed(enclosing, name);                                                      // 817
	      }                                                                                                           // 818
	      return randomSeed;                                                                                          // 819
	    };                                                                                                            // 820
	                                                                                                                  // 821
	    // Run the stub, if we have one. The stub is supposed to make some                                            // 822
	    // temporary writes to the database to give the user a smooth experience                                      // 823
	    // until the actual result of executing the method comes back from the                                        // 824
	    // server (whereupon the temporary writes to the database will be reversed                                    // 825
	    // during the beginUpdate/endUpdate process.)                                                                 // 826
	    //                                                                                                            // 827
	    // Normally, we ignore the return value of the stub (even if it is an                                         // 828
	    // exception), in favor of the real return value from the server. The                                         // 829
	    // exception is if the *caller* is a stub. In that case, we're not going                                      // 830
	    // to do a RPC, so we use the return value of the stub as our return                                          // 831
	    // value.                                                                                                     // 832
	                                                                                                                  // 833
	    var stub = self._methodHandlers[name];                                                                        // 834
	    if (stub) {                                                                                                   // 835
	      var setUserId = function(userId) {                                                                          // 836
	        self.setUserId(userId);                                                                                   // 837
	      };                                                                                                          // 838
	                                                                                                                  // 839
	      var invocation = new DDPCommon.MethodInvocation({                                                           // 840
	        isSimulation: true,                                                                                       // 841
	        userId: self.userId(),                                                                                    // 842
	        setUserId: setUserId,                                                                                     // 843
	        randomSeed: function () { return randomSeedGenerator(); }                                                 // 844
	      });                                                                                                         // 845
	                                                                                                                  // 846
	      if (!alreadyInSimulation)                                                                                   // 847
	        self._saveOriginals();                                                                                    // 848
	                                                                                                                  // 849
	      try {                                                                                                       // 850
	        // Note that unlike in the corresponding server code, we never audit                                      // 851
	        // that stubs check() their arguments.                                                                    // 852
	        var stubReturnValue = DDP._CurrentInvocation.withValue(invocation, function () {                          // 853
	          if (Meteor.isServer) {                                                                                  // 854
	            // Because saveOriginals and retrieveOriginals aren't reentrant,                                      // 855
	            // don't allow stubs to yield.                                                                        // 856
	            return Meteor._noYieldsAllowed(function () {                                                          // 857
	              // re-clone, so that the stub can't affect our caller's values                                      // 858
	              return stub.apply(invocation, EJSON.clone(args));                                                   // 859
	            });                                                                                                   // 860
	          } else {                                                                                                // 861
	            return stub.apply(invocation, EJSON.clone(args));                                                     // 862
	          }                                                                                                       // 863
	        });                                                                                                       // 864
	      }                                                                                                           // 865
	      catch (e) {                                                                                                 // 866
	        var exception = e;                                                                                        // 867
	      }                                                                                                           // 868
	                                                                                                                  // 869
	      if (!alreadyInSimulation)                                                                                   // 870
	        self._retrieveAndStoreOriginals(methodId());                                                              // 871
	    }                                                                                                             // 872
	                                                                                                                  // 873
	    // If we're in a simulation, stop and return the result we have,                                              // 874
	    // rather than going on to do an RPC. If there was no stub,                                                   // 875
	    // we'll end up returning undefined.                                                                          // 876
	    if (alreadyInSimulation) {                                                                                    // 877
	      if (callback) {                                                                                             // 878
	        callback(exception, stubReturnValue);                                                                     // 879
	        return undefined;                                                                                         // 880
	      }                                                                                                           // 881
	      if (exception)                                                                                              // 882
	        throw exception;                                                                                          // 883
	      return stubReturnValue;                                                                                     // 884
	    }                                                                                                             // 885
	                                                                                                                  // 886
	    // If an exception occurred in a stub, and we're ignoring it                                                  // 887
	    // because we're doing an RPC and want to use what the server                                                 // 888
	    // returns instead, log it so the developer knows                                                             // 889
	    // (unless they explicitly ask to see the error).                                                             // 890
	    //                                                                                                            // 891
	    // Tests can set the 'expected' flag on an exception so it won't                                              // 892
	    // go to log.                                                                                                 // 893
	    if (exception) {                                                                                              // 894
	      if (options.throwStubExceptions) {                                                                          // 895
	        throw exception;                                                                                          // 896
	      } else if (!exception.expected) {                                                                           // 897
	        Meteor._debug("Exception while simulating the effect of invoking '" +                                     // 898
	          name + "'", exception, exception.stack);                                                                // 899
	      }                                                                                                           // 900
	    }                                                                                                             // 901
	                                                                                                                  // 902
	                                                                                                                  // 903
	    // At this point we're definitely doing an RPC, and we're going to                                            // 904
	    // return the value of the RPC to the caller.                                                                 // 905
	                                                                                                                  // 906
	    // If the caller didn't give a callback, decide what to do.                                                   // 907
	    if (!callback) {                                                                                              // 908
	      if (Meteor.isClient) {                                                                                      // 909
	        // On the client, we don't have fibers, so we can't block. The                                            // 910
	        // only thing we can do is to return undefined and discard the                                            // 911
	        // result of the RPC. If an error occurred then print the error                                           // 912
	        // to the console.                                                                                        // 913
	        callback = function (err) {                                                                               // 914
	          err && Meteor._debug("Error invoking Method '" + name + "':",                                           // 915
	                               err.message);                                                                      // 916
	        };                                                                                                        // 917
	      } else {                                                                                                    // 918
	        // On the server, make the function synchronous. Throw on                                                 // 919
	        // errors, return on success.                                                                             // 920
	        var future = new Future;                                                                                  // 921
	        callback = future.resolver();                                                                             // 922
	      }                                                                                                           // 923
	    }                                                                                                             // 924
	    // Send the RPC. Note that on the client, it is important that the                                            // 925
	    // stub have finished before we send the RPC, so that we know we have                                         // 926
	    // a complete list of which local documents the stub wrote.                                                   // 927
	    var message = {                                                                                               // 928
	      msg: 'method',                                                                                              // 929
	      method: name,                                                                                               // 930
	      params: args,                                                                                               // 931
	      id: methodId()                                                                                              // 932
	    };                                                                                                            // 933
	                                                                                                                  // 934
	    // Send the randomSeed only if we used it                                                                     // 935
	    if (randomSeed !== null) {                                                                                    // 936
	      message.randomSeed = randomSeed;                                                                            // 937
	    }                                                                                                             // 938
	                                                                                                                  // 939
	    var methodInvoker = new MethodInvoker({                                                                       // 940
	      methodId: methodId(),                                                                                       // 941
	      callback: callback,                                                                                         // 942
	      connection: self,                                                                                           // 943
	      onResultReceived: options.onResultReceived,                                                                 // 944
	      wait: !!options.wait,                                                                                       // 945
	      message: message,                                                                                           // 946
	      noRetry: !!options.noRetry                                                                                  // 947
	    });                                                                                                           // 948
	                                                                                                                  // 949
	    if (options.wait) {                                                                                           // 950
	      // It's a wait method! Wait methods go in their own block.                                                  // 951
	      self._outstandingMethodBlocks.push(                                                                         // 952
	        {wait: true, methods: [methodInvoker]});                                                                  // 953
	    } else {                                                                                                      // 954
	      // Not a wait method. Start a new block if the previous block was a wait                                    // 955
	      // block, and add it to the last block of methods.                                                          // 956
	      if (_.isEmpty(self._outstandingMethodBlocks) ||                                                             // 957
	          _.last(self._outstandingMethodBlocks).wait)                                                             // 958
	        self._outstandingMethodBlocks.push({wait: false, methods: []});                                           // 959
	      _.last(self._outstandingMethodBlocks).methods.push(methodInvoker);                                          // 960
	    }                                                                                                             // 961
	                                                                                                                  // 962
	    // If we added it to the first block, send it out now.                                                        // 963
	    if (self._outstandingMethodBlocks.length === 1)                                                               // 964
	      methodInvoker.sendMessage();                                                                                // 965
	                                                                                                                  // 966
	    // If we're using the default callback on the server,                                                         // 967
	    // block waiting for the result.                                                                              // 968
	    if (future) {                                                                                                 // 969
	      return future.wait();                                                                                       // 970
	    }                                                                                                             // 971
	    return options.returnStubValue ? stubReturnValue : undefined;                                                 // 972
	  },                                                                                                              // 973
	                                                                                                                  // 974
	  // Before calling a method stub, prepare all stores to track changes and allow                                  // 975
	  // _retrieveAndStoreOriginals to get the original versions of changed                                           // 976
	  // documents.                                                                                                   // 977
	  _saveOriginals: function () {                                                                                   // 978
	    var self = this;                                                                                              // 979
	    _.each(self._stores, function (s) {                                                                           // 980
	      s.saveOriginals();                                                                                          // 981
	    });                                                                                                           // 982
	  },                                                                                                              // 983
	  // Retrieves the original versions of all documents modified by the stub for                                    // 984
	  // method 'methodId' from all stores and saves them to _serverDocuments (keyed                                  // 985
	  // by document) and _documentsWrittenByStub (keyed by method ID).                                               // 986
	  _retrieveAndStoreOriginals: function (methodId) {                                                               // 987
	    var self = this;                                                                                              // 988
	    if (self._documentsWrittenByStub[methodId])                                                                   // 989
	      throw new Error("Duplicate methodId in _retrieveAndStoreOriginals");                                        // 990
	                                                                                                                  // 991
	    var docsWritten = [];                                                                                         // 992
	    _.each(self._stores, function (s, collection) {                                                               // 993
	      var originals = s.retrieveOriginals();                                                                      // 994
	      // not all stores define retrieveOriginals                                                                  // 995
	      if (!originals)                                                                                             // 996
	        return;                                                                                                   // 997
	      originals.forEach(function (doc, id) {                                                                      // 998
	        docsWritten.push({collection: collection, id: id});                                                       // 999
	        if (!_.has(self._serverDocuments, collection))                                                            // 1000
	          self._serverDocuments[collection] = new MongoIDMap;                                                     // 1001
	        var serverDoc = self._serverDocuments[collection].setDefault(id, {});                                     // 1002
	        if (serverDoc.writtenByStubs) {                                                                           // 1003
	          // We're not the first stub to write this doc. Just add our method ID                                   // 1004
	          // to the record.                                                                                       // 1005
	          serverDoc.writtenByStubs[methodId] = true;                                                              // 1006
	        } else {                                                                                                  // 1007
	          // First stub! Save the original value and our method ID.                                               // 1008
	          serverDoc.document = doc;                                                                               // 1009
	          serverDoc.flushCallbacks = [];                                                                          // 1010
	          serverDoc.writtenByStubs = {};                                                                          // 1011
	          serverDoc.writtenByStubs[methodId] = true;                                                              // 1012
	        }                                                                                                         // 1013
	      });                                                                                                         // 1014
	    });                                                                                                           // 1015
	    if (!_.isEmpty(docsWritten)) {                                                                                // 1016
	      self._documentsWrittenByStub[methodId] = docsWritten;                                                       // 1017
	    }                                                                                                             // 1018
	  },                                                                                                              // 1019
	                                                                                                                  // 1020
	  // This is very much a private function we use to make the tests                                                // 1021
	  // take up fewer server resources after they complete.                                                          // 1022
	  _unsubscribeAll: function () {                                                                                  // 1023
	    var self = this;                                                                                              // 1024
	    _.each(_.clone(self._subscriptions), function (sub, id) {                                                     // 1025
	      // Avoid killing the autoupdate subscription so that developers                                             // 1026
	      // still get hot code pushes when writing tests.                                                            // 1027
	      //                                                                                                          // 1028
	      // XXX it's a hack to encode knowledge about autoupdate here,                                               // 1029
	      // but it doesn't seem worth it yet to have a special API for                                               // 1030
	      // subscriptions to preserve after unit tests.                                                              // 1031
	      if (sub.name !== 'meteor_autoupdate_clientVersions') {                                                      // 1032
	        self._subscriptions[id].stop();                                                                           // 1033
	      }                                                                                                           // 1034
	    });                                                                                                           // 1035
	  },                                                                                                              // 1036
	                                                                                                                  // 1037
	  // Sends the DDP stringification of the given message object                                                    // 1038
	  _send: function (obj) {                                                                                         // 1039
	    var self = this;                                                                                              // 1040
	    self._stream.send(DDPCommon.stringifyDDP(obj));                                                               // 1041
	  },                                                                                                              // 1042
	                                                                                                                  // 1043
	  // We detected via DDP-level heartbeats that we've lost the                                                     // 1044
	  // connection.  Unlike `disconnect` or `close`, a lost connection                                               // 1045
	  // will be automatically retried.                                                                               // 1046
	  _lostConnection: function (error) {                                                                             // 1047
	    var self = this;                                                                                              // 1048
	    self._stream._lostConnection(error);                                                                          // 1049
	  },                                                                                                              // 1050
	                                                                                                                  // 1051
	  /**                                                                                                             // 1052
	   * @summary Get the current connection status. A reactive data source.                                          // 1053
	   * @locus Client                                                                                                // 1054
	   * @memberOf Meteor                                                                                             // 1055
	   * @importFromPackage meteor                                                                                    // 1056
	   */                                                                                                             // 1057
	  status: function (/*passthrough args*/) {                                                                       // 1058
	    var self = this;                                                                                              // 1059
	    return self._stream.status.apply(self._stream, arguments);                                                    // 1060
	  },                                                                                                              // 1061
	                                                                                                                  // 1062
	  /**                                                                                                             // 1063
	   * @summary Force an immediate reconnection attempt if the client is not connected to the server.               // 1064
	                                                                                                                  // 1065
	  This method does nothing if the client is already connected.                                                    // 1066
	   * @locus Client                                                                                                // 1067
	   * @memberOf Meteor                                                                                             // 1068
	   * @importFromPackage meteor                                                                                    // 1069
	   */                                                                                                             // 1070
	  reconnect: function (/*passthrough args*/) {                                                                    // 1071
	    var self = this;                                                                                              // 1072
	    return self._stream.reconnect.apply(self._stream, arguments);                                                 // 1073
	  },                                                                                                              // 1074
	                                                                                                                  // 1075
	  /**                                                                                                             // 1076
	   * @summary Disconnect the client from the server.                                                              // 1077
	   * @locus Client                                                                                                // 1078
	   * @memberOf Meteor                                                                                             // 1079
	   * @importFromPackage meteor                                                                                    // 1080
	   */                                                                                                             // 1081
	  disconnect: function (/*passthrough args*/) {                                                                   // 1082
	    var self = this;                                                                                              // 1083
	    return self._stream.disconnect.apply(self._stream, arguments);                                                // 1084
	  },                                                                                                              // 1085
	                                                                                                                  // 1086
	  close: function () {                                                                                            // 1087
	    var self = this;                                                                                              // 1088
	    return self._stream.disconnect({_permanent: true});                                                           // 1089
	  },                                                                                                              // 1090
	                                                                                                                  // 1091
	  ///                                                                                                             // 1092
	  /// Reactive user system                                                                                        // 1093
	  ///                                                                                                             // 1094
	  userId: function () {                                                                                           // 1095
	    var self = this;                                                                                              // 1096
	    if (self._userIdDeps)                                                                                         // 1097
	      self._userIdDeps.depend();                                                                                  // 1098
	    return self._userId;                                                                                          // 1099
	  },                                                                                                              // 1100
	                                                                                                                  // 1101
	  setUserId: function (userId) {                                                                                  // 1102
	    var self = this;                                                                                              // 1103
	    // Avoid invalidating dependents if setUserId is called with current value.                                   // 1104
	    if (self._userId === userId)                                                                                  // 1105
	      return;                                                                                                     // 1106
	    self._userId = userId;                                                                                        // 1107
	    if (self._userIdDeps)                                                                                         // 1108
	      self._userIdDeps.changed();                                                                                 // 1109
	  },                                                                                                              // 1110
	                                                                                                                  // 1111
	  // Returns true if we are in a state after reconnect of waiting for subs to be                                  // 1112
	  // revived or early methods to finish their data, or we are waiting for a                                       // 1113
	  // "wait" method to finish.                                                                                     // 1114
	  _waitingForQuiescence: function () {                                                                            // 1115
	    var self = this;                                                                                              // 1116
	    return (! _.isEmpty(self._subsBeingRevived) ||                                                                // 1117
	            ! _.isEmpty(self._methodsBlockingQuiescence));                                                        // 1118
	  },                                                                                                              // 1119
	                                                                                                                  // 1120
	  // Returns true if any method whose message has been sent to the server has                                     // 1121
	  // not yet invoked its user callback.                                                                           // 1122
	  _anyMethodsAreOutstanding: function () {                                                                        // 1123
	    var self = this;                                                                                              // 1124
	    return _.any(_.pluck(self._methodInvokers, 'sentMessage'));                                                   // 1125
	  },                                                                                                              // 1126
	                                                                                                                  // 1127
	  _livedata_connected: function (msg) {                                                                           // 1128
	    var self = this;                                                                                              // 1129
	                                                                                                                  // 1130
	    if (self._version !== 'pre1' && self._heartbeatInterval !== 0) {                                              // 1131
	      self._heartbeat = new DDPCommon.Heartbeat({                                                                 // 1132
	        heartbeatInterval: self._heartbeatInterval,                                                               // 1133
	        heartbeatTimeout: self._heartbeatTimeout,                                                                 // 1134
	        onTimeout: function () {                                                                                  // 1135
	          self._lostConnection(                                                                                   // 1136
	            new DDP.ConnectionError("DDP heartbeat timed out"));                                                  // 1137
	        },                                                                                                        // 1138
	        sendPing: function () {                                                                                   // 1139
	          self._send({msg: 'ping'});                                                                              // 1140
	        }                                                                                                         // 1141
	      });                                                                                                         // 1142
	      self._heartbeat.start();                                                                                    // 1143
	    }                                                                                                             // 1144
	                                                                                                                  // 1145
	    // If this is a reconnect, we'll have to reset all stores.                                                    // 1146
	    if (self._lastSessionId)                                                                                      // 1147
	      self._resetStores = true;                                                                                   // 1148
	                                                                                                                  // 1149
	    if (typeof (msg.session) === "string") {                                                                      // 1150
	      var reconnectedToPreviousSession = (self._lastSessionId === msg.session);                                   // 1151
	      self._lastSessionId = msg.session;                                                                          // 1152
	    }                                                                                                             // 1153
	                                                                                                                  // 1154
	    if (reconnectedToPreviousSession) {                                                                           // 1155
	      // Successful reconnection -- pick up where we left off.  Note that right                                   // 1156
	      // now, this never happens: the server never connects us to a previous                                      // 1157
	      // session, because DDP doesn't provide enough data for the server to know                                  // 1158
	      // what messages the client has processed. We need to improve DDP to make                                   // 1159
	      // this possible, at which point we'll probably need more code here.                                        // 1160
	      return;                                                                                                     // 1161
	    }                                                                                                             // 1162
	                                                                                                                  // 1163
	    // Server doesn't have our data any more. Re-sync a new session.                                              // 1164
	                                                                                                                  // 1165
	    // Forget about messages we were buffering for unknown collections. They'll                                   // 1166
	    // be resent if still relevant.                                                                               // 1167
	    self._updatesForUnknownStores = {};                                                                           // 1168
	                                                                                                                  // 1169
	    if (self._resetStores) {                                                                                      // 1170
	      // Forget about the effects of stubs. We'll be resetting all collections                                    // 1171
	      // anyway.                                                                                                  // 1172
	      self._documentsWrittenByStub = {};                                                                          // 1173
	      self._serverDocuments = {};                                                                                 // 1174
	    }                                                                                                             // 1175
	                                                                                                                  // 1176
	    // Clear _afterUpdateCallbacks.                                                                               // 1177
	    self._afterUpdateCallbacks = [];                                                                              // 1178
	                                                                                                                  // 1179
	    // Mark all named subscriptions which are ready (ie, we already called the                                    // 1180
	    // ready callback) as needing to be revived.                                                                  // 1181
	    // XXX We should also block reconnect quiescence until unnamed subscriptions                                  // 1182
	    //     (eg, autopublish) are done re-publishing to avoid flicker!                                             // 1183
	    self._subsBeingRevived = {};                                                                                  // 1184
	    _.each(self._subscriptions, function (sub, id) {                                                              // 1185
	      if (sub.ready)                                                                                              // 1186
	        self._subsBeingRevived[id] = true;                                                                        // 1187
	    });                                                                                                           // 1188
	                                                                                                                  // 1189
	    // Arrange for "half-finished" methods to have their callbacks run, and                                       // 1190
	    // track methods that were sent on this connection so that we don't                                           // 1191
	    // quiesce until they are all done.                                                                           // 1192
	    //                                                                                                            // 1193
	    // Start by clearing _methodsBlockingQuiescence: methods sent before                                          // 1194
	    // reconnect don't matter, and any "wait" methods sent on the new connection                                  // 1195
	    // that we drop here will be restored by the loop below.                                                      // 1196
	    self._methodsBlockingQuiescence = {};                                                                         // 1197
	    if (self._resetStores) {                                                                                      // 1198
	      _.each(self._methodInvokers, function (invoker) {                                                           // 1199
	        if (invoker.gotResult()) {                                                                                // 1200
	          // This method already got its result, but it didn't call its callback                                  // 1201
	          // because its data didn't become visible. We did not resend the                                        // 1202
	          // method RPC. We'll call its callback when we get a full quiesce,                                      // 1203
	          // since that's as close as we'll get to "data must be visible".                                        // 1204
	          self._afterUpdateCallbacks.push(_.bind(invoker.dataVisible, invoker));                                  // 1205
	        } else if (invoker.sentMessage) {                                                                         // 1206
	          // This method has been sent on this connection (maybe as a resend                                      // 1207
	          // from the last connection, maybe from onReconnect, maybe just very                                    // 1208
	          // quickly before processing the connected message).                                                    // 1209
	          //                                                                                                      // 1210
	          // We don't need to do anything special to ensure its callbacks get                                     // 1211
	          // called, but we'll count it as a method which is preventing                                           // 1212
	          // reconnect quiescence. (eg, it might be a login method that was run                                   // 1213
	          // from onReconnect, and we don't want to see flicker by seeing a                                       // 1214
	          // logged-out state.)                                                                                   // 1215
	          self._methodsBlockingQuiescence[invoker.methodId] = true;                                               // 1216
	        }                                                                                                         // 1217
	      });                                                                                                         // 1218
	    }                                                                                                             // 1219
	                                                                                                                  // 1220
	    self._messagesBufferedUntilQuiescence = [];                                                                   // 1221
	                                                                                                                  // 1222
	    // If we're not waiting on any methods or subs, we can reset the stores and                                   // 1223
	    // call the callbacks immediately.                                                                            // 1224
	    if (!self._waitingForQuiescence()) {                                                                          // 1225
	      if (self._resetStores) {                                                                                    // 1226
	        _.each(self._stores, function (s) {                                                                       // 1227
	          s.beginUpdate(0, true);                                                                                 // 1228
	          s.endUpdate();                                                                                          // 1229
	        });                                                                                                       // 1230
	        self._resetStores = false;                                                                                // 1231
	      }                                                                                                           // 1232
	      self._runAfterUpdateCallbacks();                                                                            // 1233
	    }                                                                                                             // 1234
	  },                                                                                                              // 1235
	                                                                                                                  // 1236
	                                                                                                                  // 1237
	  _processOneDataMessage: function (msg, updates) {                                                               // 1238
	    var self = this;                                                                                              // 1239
	    // Using underscore here so as not to need to capitalize.                                                     // 1240
	    self['_process_' + msg.msg](msg, updates);                                                                    // 1241
	  },                                                                                                              // 1242
	                                                                                                                  // 1243
	                                                                                                                  // 1244
	  _livedata_data: function (msg) {                                                                                // 1245
	    var self = this;                                                                                              // 1246
	                                                                                                                  // 1247
	    if (self._waitingForQuiescence()) {                                                                           // 1248
	      self._messagesBufferedUntilQuiescence.push(msg);                                                            // 1249
	                                                                                                                  // 1250
	      if (msg.msg === "nosub")                                                                                    // 1251
	        delete self._subsBeingRevived[msg.id];                                                                    // 1252
	                                                                                                                  // 1253
	      _.each(msg.subs || [], function (subId) {                                                                   // 1254
	        delete self._subsBeingRevived[subId];                                                                     // 1255
	      });                                                                                                         // 1256
	      _.each(msg.methods || [], function (methodId) {                                                             // 1257
	        delete self._methodsBlockingQuiescence[methodId];                                                         // 1258
	      });                                                                                                         // 1259
	                                                                                                                  // 1260
	      if (self._waitingForQuiescence())                                                                           // 1261
	        return;                                                                                                   // 1262
	                                                                                                                  // 1263
	      // No methods or subs are blocking quiescence!                                                              // 1264
	      // We'll now process and all of our buffered messages, reset all stores,                                    // 1265
	      // and apply them all at once.                                                                              // 1266
	      _.each(self._messagesBufferedUntilQuiescence, function (bufferedMsg) {                                      // 1267
	        self._processOneDataMessage(bufferedMsg, self._bufferedWrites);                                           // 1268
	      });                                                                                                         // 1269
	      self._messagesBufferedUntilQuiescence = [];                                                                 // 1270
	    } else {                                                                                                      // 1271
	      self._processOneDataMessage(msg, self._bufferedWrites);                                                     // 1272
	    }                                                                                                             // 1273
	                                                                                                                  // 1274
	    // Immediately flush writes when:                                                                             // 1275
	    //  1. Buffering is disabled. Or;                                                                             // 1276
	    //  2. any non-(added/changed/removed) message arrives.                                                       // 1277
	    var standardWrite = _.include(['added', 'changed', 'removed'], msg.msg);                                      // 1278
	    if (self._bufferedWritesInterval === 0 || !standardWrite) {                                                   // 1279
	      self._flushBufferedWrites();                                                                                // 1280
	      return;                                                                                                     // 1281
	    }                                                                                                             // 1282
	                                                                                                                  // 1283
	    if (self._bufferedWritesFlushAt === null) {                                                                   // 1284
	      self._bufferedWritesFlushAt = new Date().valueOf() + self._bufferedWritesMaxAge;                            // 1285
	    }                                                                                                             // 1286
	    else if (self._bufferedWritesFlushAt < new Date().valueOf()) {                                                // 1287
	      self._flushBufferedWrites();                                                                                // 1288
	      return;                                                                                                     // 1289
	    }                                                                                                             // 1290
	                                                                                                                  // 1291
	    if (self._bufferedWritesFlushHandle) {                                                                        // 1292
	      clearTimeout(self._bufferedWritesFlushHandle);                                                              // 1293
	    }                                                                                                             // 1294
	    self._bufferedWritesFlushHandle = setTimeout(self.__flushBufferedWrites,                                      // 1295
	                                                      self._bufferedWritesInterval);                              // 1296
	  },                                                                                                              // 1297
	                                                                                                                  // 1298
	  _flushBufferedWrites: function () {                                                                             // 1299
	    var self = this;                                                                                              // 1300
	    if (self._bufferedWritesFlushHandle) {                                                                        // 1301
	      clearTimeout(self._bufferedWritesFlushHandle);                                                              // 1302
	      self._bufferedWritesFlushHandle = null;                                                                     // 1303
	    }                                                                                                             // 1304
	                                                                                                                  // 1305
	    self._bufferedWritesFlushAt = null;                                                                           // 1306
	    // We need to clear the buffer before passing it to                                                           // 1307
	    //  performWrites. As there's no guarantee that it                                                            // 1308
	    //  will exit cleanly.                                                                                        // 1309
	    var writes = self._bufferedWrites;                                                                            // 1310
	    self._bufferedWrites = {};                                                                                    // 1311
	    self._performWrites(writes);                                                                                  // 1312
	  },                                                                                                              // 1313
	                                                                                                                  // 1314
	  _performWrites: function(updates){                                                                              // 1315
	    var self = this;                                                                                              // 1316
	                                                                                                                  // 1317
	    if (self._resetStores || !_.isEmpty(updates)) {                                                               // 1318
	      // Begin a transactional update of each store.                                                              // 1319
	      _.each(self._stores, function (s, storeName) {                                                              // 1320
	        s.beginUpdate(_.has(updates, storeName) ? updates[storeName].length : 0,                                  // 1321
	                      self._resetStores);                                                                         // 1322
	      });                                                                                                         // 1323
	      self._resetStores = false;                                                                                  // 1324
	                                                                                                                  // 1325
	      _.each(updates, function (updateMessages, storeName) {                                                      // 1326
	        var store = self._stores[storeName];                                                                      // 1327
	        if (store) {                                                                                              // 1328
	          _.each(updateMessages, function (updateMessage) {                                                       // 1329
	            store.update(updateMessage);                                                                          // 1330
	          });                                                                                                     // 1331
	        } else {                                                                                                  // 1332
	          // Nobody's listening for this data. Queue it up until                                                  // 1333
	          // someone wants it.                                                                                    // 1334
	          // XXX memory use will grow without bound if you forget to                                              // 1335
	          // create a collection or just don't care about it... going                                             // 1336
	          // to have to do something about that.                                                                  // 1337
	          if (!_.has(self._updatesForUnknownStores, storeName))                                                   // 1338
	            self._updatesForUnknownStores[storeName] = [];                                                        // 1339
	          Array.prototype.push.apply(self._updatesForUnknownStores[storeName],                                    // 1340
	                                     updateMessages);                                                             // 1341
	        }                                                                                                         // 1342
	      });                                                                                                         // 1343
	                                                                                                                  // 1344
	      // End update transaction.                                                                                  // 1345
	      _.each(self._stores, function (s) { s.endUpdate(); });                                                      // 1346
	    }                                                                                                             // 1347
	                                                                                                                  // 1348
	    self._runAfterUpdateCallbacks();                                                                              // 1349
	  },                                                                                                              // 1350
	                                                                                                                  // 1351
	  // Call any callbacks deferred with _runWhenAllServerDocsAreFlushed whose                                       // 1352
	  // relevant docs have been flushed, as well as dataVisible callbacks at                                         // 1353
	  // reconnect-quiescence time.                                                                                   // 1354
	  _runAfterUpdateCallbacks: function () {                                                                         // 1355
	    var self = this;                                                                                              // 1356
	    var callbacks = self._afterUpdateCallbacks;                                                                   // 1357
	    self._afterUpdateCallbacks = [];                                                                              // 1358
	    _.each(callbacks, function (c) {                                                                              // 1359
	      c();                                                                                                        // 1360
	    });                                                                                                           // 1361
	  },                                                                                                              // 1362
	                                                                                                                  // 1363
	  _pushUpdate: function (updates, collection, msg) {                                                              // 1364
	    var self = this;                                                                                              // 1365
	    if (!_.has(updates, collection)) {                                                                            // 1366
	      updates[collection] = [];                                                                                   // 1367
	    }                                                                                                             // 1368
	    updates[collection].push(msg);                                                                                // 1369
	  },                                                                                                              // 1370
	                                                                                                                  // 1371
	  _getServerDoc: function (collection, id) {                                                                      // 1372
	    var self = this;                                                                                              // 1373
	    if (!_.has(self._serverDocuments, collection))                                                                // 1374
	      return null;                                                                                                // 1375
	    var serverDocsForCollection = self._serverDocuments[collection];                                              // 1376
	    return serverDocsForCollection.get(id) || null;                                                               // 1377
	  },                                                                                                              // 1378
	                                                                                                                  // 1379
	  _process_added: function (msg, updates) {                                                                       // 1380
	    var self = this;                                                                                              // 1381
	    var id = MongoID.idParse(msg.id);                                                                             // 1382
	    var serverDoc = self._getServerDoc(msg.collection, id);                                                       // 1383
	    if (serverDoc) {                                                                                              // 1384
	      // Some outstanding stub wrote here.                                                                        // 1385
	      var isExisting = (serverDoc.document !== undefined);                                                        // 1386
	                                                                                                                  // 1387
	      serverDoc.document = msg.fields || {};                                                                      // 1388
	      serverDoc.document._id = id;                                                                                // 1389
	                                                                                                                  // 1390
	      if (self._resetStores) {                                                                                    // 1391
	        // During reconnect the server is sending adds for existing ids.                                          // 1392
	        // Always push an update so that document stays in the store after                                        // 1393
	        // reset. Use current version of the document for this update, so                                         // 1394
	        // that stub-written values are preserved.                                                                // 1395
	        var currentDoc = self._stores[msg.collection].getDoc(msg.id);                                             // 1396
	        if (currentDoc !== undefined)                                                                             // 1397
	          msg.fields = currentDoc;                                                                                // 1398
	                                                                                                                  // 1399
	        self._pushUpdate(updates, msg.collection, msg);                                                           // 1400
	      } else if (isExisting) {                                                                                    // 1401
	        throw new Error("Server sent add for existing id: " + msg.id);                                            // 1402
	      }                                                                                                           // 1403
	    } else {                                                                                                      // 1404
	      self._pushUpdate(updates, msg.collection, msg);                                                             // 1405
	    }                                                                                                             // 1406
	  },                                                                                                              // 1407
	                                                                                                                  // 1408
	  _process_changed: function (msg, updates) {                                                                     // 1409
	    var self = this;                                                                                              // 1410
	    var serverDoc = self._getServerDoc(                                                                           // 1411
	      msg.collection, MongoID.idParse(msg.id));                                                                   // 1412
	    if (serverDoc) {                                                                                              // 1413
	      if (serverDoc.document === undefined)                                                                       // 1414
	        throw new Error("Server sent changed for nonexisting id: " + msg.id);                                     // 1415
	      DiffSequence.applyChanges(serverDoc.document, msg.fields);                                                  // 1416
	    } else {                                                                                                      // 1417
	      self._pushUpdate(updates, msg.collection, msg);                                                             // 1418
	    }                                                                                                             // 1419
	  },                                                                                                              // 1420
	                                                                                                                  // 1421
	  _process_removed: function (msg, updates) {                                                                     // 1422
	    var self = this;                                                                                              // 1423
	    var serverDoc = self._getServerDoc(                                                                           // 1424
	      msg.collection, MongoID.idParse(msg.id));                                                                   // 1425
	    if (serverDoc) {                                                                                              // 1426
	      // Some outstanding stub wrote here.                                                                        // 1427
	      if (serverDoc.document === undefined)                                                                       // 1428
	        throw new Error("Server sent removed for nonexisting id:" + msg.id);                                      // 1429
	      serverDoc.document = undefined;                                                                             // 1430
	    } else {                                                                                                      // 1431
	      self._pushUpdate(updates, msg.collection, {                                                                 // 1432
	        msg: 'removed',                                                                                           // 1433
	        collection: msg.collection,                                                                               // 1434
	        id: msg.id                                                                                                // 1435
	      });                                                                                                         // 1436
	    }                                                                                                             // 1437
	  },                                                                                                              // 1438
	                                                                                                                  // 1439
	  _process_updated: function (msg, updates) {                                                                     // 1440
	    var self = this;                                                                                              // 1441
	    // Process "method done" messages.                                                                            // 1442
	    _.each(msg.methods, function (methodId) {                                                                     // 1443
	      _.each(self._documentsWrittenByStub[methodId], function (written) {                                         // 1444
	        var serverDoc = self._getServerDoc(written.collection, written.id);                                       // 1445
	        if (!serverDoc)                                                                                           // 1446
	          throw new Error("Lost serverDoc for " + JSON.stringify(written));                                       // 1447
	        if (!serverDoc.writtenByStubs[methodId])                                                                  // 1448
	          throw new Error("Doc " + JSON.stringify(written) +                                                      // 1449
	                          " not written by  method " + methodId);                                                 // 1450
	        delete serverDoc.writtenByStubs[methodId];                                                                // 1451
	        if (_.isEmpty(serverDoc.writtenByStubs)) {                                                                // 1452
	          // All methods whose stubs wrote this method have completed! We can                                     // 1453
	          // now copy the saved document to the database (reverting the stub's                                    // 1454
	          // change if the server did not write to this object, or applying the                                   // 1455
	          // server's writes if it did).                                                                          // 1456
	                                                                                                                  // 1457
	          // This is a fake ddp 'replace' message.  It's just for talking                                         // 1458
	          // between livedata connections and minimongo.  (We have to stringify                                   // 1459
	          // the ID because it's supposed to look like a wire message.)                                           // 1460
	          self._pushUpdate(updates, written.collection, {                                                         // 1461
	            msg: 'replace',                                                                                       // 1462
	            id: MongoID.idStringify(written.id),                                                                  // 1463
	            replace: serverDoc.document                                                                           // 1464
	          });                                                                                                     // 1465
	          // Call all flush callbacks.                                                                            // 1466
	          _.each(serverDoc.flushCallbacks, function (c) {                                                         // 1467
	            c();                                                                                                  // 1468
	          });                                                                                                     // 1469
	                                                                                                                  // 1470
	          // Delete this completed serverDocument. Don't bother to GC empty                                       // 1471
	          // IdMaps inside self._serverDocuments, since there probably aren't                                     // 1472
	          // many collections and they'll be written repeatedly.                                                  // 1473
	          self._serverDocuments[written.collection].remove(written.id);                                           // 1474
	        }                                                                                                         // 1475
	      });                                                                                                         // 1476
	      delete self._documentsWrittenByStub[methodId];                                                              // 1477
	                                                                                                                  // 1478
	      // We want to call the data-written callback, but we can't do so until all                                  // 1479
	      // currently buffered messages are flushed.                                                                 // 1480
	      var callbackInvoker = self._methodInvokers[methodId];                                                       // 1481
	      if (!callbackInvoker)                                                                                       // 1482
	        throw new Error("No callback invoker for method " + methodId);                                            // 1483
	      self._runWhenAllServerDocsAreFlushed(                                                                       // 1484
	        _.bind(callbackInvoker.dataVisible, callbackInvoker));                                                    // 1485
	    });                                                                                                           // 1486
	  },                                                                                                              // 1487
	                                                                                                                  // 1488
	  _process_ready: function (msg, updates) {                                                                       // 1489
	    var self = this;                                                                                              // 1490
	    // Process "sub ready" messages. "sub ready" messages don't take effect                                       // 1491
	    // until all current server documents have been flushed to the local                                          // 1492
	    // database. We can use a write fence to implement this.                                                      // 1493
	    _.each(msg.subs, function (subId) {                                                                           // 1494
	      self._runWhenAllServerDocsAreFlushed(function () {                                                          // 1495
	        var subRecord = self._subscriptions[subId];                                                               // 1496
	        // Did we already unsubscribe?                                                                            // 1497
	        if (!subRecord)                                                                                           // 1498
	          return;                                                                                                 // 1499
	        // Did we already receive a ready message? (Oops!)                                                        // 1500
	        if (subRecord.ready)                                                                                      // 1501
	          return;                                                                                                 // 1502
	        subRecord.ready = true;                                                                                   // 1503
	        subRecord.readyCallback && subRecord.readyCallback();                                                     // 1504
	        subRecord.readyDeps.changed();                                                                            // 1505
	      });                                                                                                         // 1506
	    });                                                                                                           // 1507
	  },                                                                                                              // 1508
	                                                                                                                  // 1509
	  // Ensures that "f" will be called after all documents currently in                                             // 1510
	  // _serverDocuments have been written to the local cache. f will not be called                                  // 1511
	  // if the connection is lost before then!                                                                       // 1512
	  _runWhenAllServerDocsAreFlushed: function (f) {                                                                 // 1513
	    var self = this;                                                                                              // 1514
	    var runFAfterUpdates = function () {                                                                          // 1515
	      self._afterUpdateCallbacks.push(f);                                                                         // 1516
	    };                                                                                                            // 1517
	    var unflushedServerDocCount = 0;                                                                              // 1518
	    var onServerDocFlush = function () {                                                                          // 1519
	      --unflushedServerDocCount;                                                                                  // 1520
	      if (unflushedServerDocCount === 0) {                                                                        // 1521
	        // This was the last doc to flush! Arrange to run f after the updates                                     // 1522
	        // have been applied.                                                                                     // 1523
	        runFAfterUpdates();                                                                                       // 1524
	      }                                                                                                           // 1525
	    };                                                                                                            // 1526
	    _.each(self._serverDocuments, function (collectionDocs) {                                                     // 1527
	      collectionDocs.forEach(function (serverDoc) {                                                               // 1528
	        var writtenByStubForAMethodWithSentMessage = _.any(                                                       // 1529
	          serverDoc.writtenByStubs, function (dummy, methodId) {                                                  // 1530
	            var invoker = self._methodInvokers[methodId];                                                         // 1531
	            return invoker && invoker.sentMessage;                                                                // 1532
	          });                                                                                                     // 1533
	        if (writtenByStubForAMethodWithSentMessage) {                                                             // 1534
	          ++unflushedServerDocCount;                                                                              // 1535
	          serverDoc.flushCallbacks.push(onServerDocFlush);                                                        // 1536
	        }                                                                                                         // 1537
	      });                                                                                                         // 1538
	    });                                                                                                           // 1539
	    if (unflushedServerDocCount === 0) {                                                                          // 1540
	      // There aren't any buffered docs --- we can call f as soon as the current                                  // 1541
	      // round of updates is applied!                                                                             // 1542
	      runFAfterUpdates();                                                                                         // 1543
	    }                                                                                                             // 1544
	  },                                                                                                              // 1545
	                                                                                                                  // 1546
	  _livedata_nosub: function (msg) {                                                                               // 1547
	    var self = this;                                                                                              // 1548
	                                                                                                                  // 1549
	    // First pass it through _livedata_data, which only uses it to help get                                       // 1550
	    // towards quiescence.                                                                                        // 1551
	    self._livedata_data(msg);                                                                                     // 1552
	                                                                                                                  // 1553
	    // Do the rest of our processing immediately, with no                                                         // 1554
	    // buffering-until-quiescence.                                                                                // 1555
	                                                                                                                  // 1556
	    // we weren't subbed anyway, or we initiated the unsub.                                                       // 1557
	    if (!_.has(self._subscriptions, msg.id))                                                                      // 1558
	      return;                                                                                                     // 1559
	                                                                                                                  // 1560
	    // XXX COMPAT WITH 1.0.3.1 #errorCallback                                                                     // 1561
	    var errorCallback = self._subscriptions[msg.id].errorCallback;                                                // 1562
	    var stopCallback = self._subscriptions[msg.id].stopCallback;                                                  // 1563
	                                                                                                                  // 1564
	    self._subscriptions[msg.id].remove();                                                                         // 1565
	                                                                                                                  // 1566
	    var meteorErrorFromMsg = function (msgArg) {                                                                  // 1567
	      return msgArg && msgArg.error && new Meteor.Error(                                                          // 1568
	        msgArg.error.error, msgArg.error.reason, msgArg.error.details);                                           // 1569
	    }                                                                                                             // 1570
	                                                                                                                  // 1571
	    // XXX COMPAT WITH 1.0.3.1 #errorCallback                                                                     // 1572
	    if (errorCallback && msg.error) {                                                                             // 1573
	      errorCallback(meteorErrorFromMsg(msg));                                                                     // 1574
	    }                                                                                                             // 1575
	                                                                                                                  // 1576
	    if (stopCallback) {                                                                                           // 1577
	      stopCallback(meteorErrorFromMsg(msg));                                                                      // 1578
	    }                                                                                                             // 1579
	  },                                                                                                              // 1580
	                                                                                                                  // 1581
	  _process_nosub: function () {                                                                                   // 1582
	    // This is called as part of the "buffer until quiescence" process, but                                       // 1583
	    // nosub's effect is always immediate. It only goes in the buffer at all                                      // 1584
	    // because it's possible for a nosub to be the thing that triggers                                            // 1585
	    // quiescence, if we were waiting for a sub to be revived and it dies                                         // 1586
	    // instead.                                                                                                   // 1587
	  },                                                                                                              // 1588
	                                                                                                                  // 1589
	  _livedata_result: function (msg) {                                                                              // 1590
	    // id, result or error. error has error (code), reason, details                                               // 1591
	                                                                                                                  // 1592
	    var self = this;                                                                                              // 1593
	                                                                                                                  // 1594
	    // Lets make sure there are no buffered writes before returning result.                                       // 1595
	    if (!_.isEmpty(self._bufferedWrites)) {                                                                       // 1596
	      self._flushBufferedWrites();                                                                                // 1597
	    }                                                                                                             // 1598
	                                                                                                                  // 1599
	    // find the outstanding request                                                                               // 1600
	    // should be O(1) in nearly all realistic use cases                                                           // 1601
	    if (_.isEmpty(self._outstandingMethodBlocks)) {                                                               // 1602
	      Meteor._debug("Received method result but no methods outstanding");                                         // 1603
	      return;                                                                                                     // 1604
	    }                                                                                                             // 1605
	    var currentMethodBlock = self._outstandingMethodBlocks[0].methods;                                            // 1606
	    var m;                                                                                                        // 1607
	    for (var i = 0; i < currentMethodBlock.length; i++) {                                                         // 1608
	      m = currentMethodBlock[i];                                                                                  // 1609
	      if (m.methodId === msg.id)                                                                                  // 1610
	        break;                                                                                                    // 1611
	    }                                                                                                             // 1612
	                                                                                                                  // 1613
	    if (!m) {                                                                                                     // 1614
	      Meteor._debug("Can't match method response to original method call", msg);                                  // 1615
	      return;                                                                                                     // 1616
	    }                                                                                                             // 1617
	                                                                                                                  // 1618
	    // Remove from current method block. This may leave the block empty, but we                                   // 1619
	    // don't move on to the next block until the callback has been delivered, in                                  // 1620
	    // _outstandingMethodFinished.                                                                                // 1621
	    currentMethodBlock.splice(i, 1);                                                                              // 1622
	                                                                                                                  // 1623
	    if (_.has(msg, 'error')) {                                                                                    // 1624
	      m.receiveResult(new Meteor.Error(                                                                           // 1625
	        msg.error.error, msg.error.reason,                                                                        // 1626
	        msg.error.details));                                                                                      // 1627
	    } else {                                                                                                      // 1628
	      // msg.result may be undefined if the method didn't return a                                                // 1629
	      // value                                                                                                    // 1630
	      m.receiveResult(undefined, msg.result);                                                                     // 1631
	    }                                                                                                             // 1632
	  },                                                                                                              // 1633
	                                                                                                                  // 1634
	  // Called by MethodInvoker after a method's callback is invoked.  If this was                                   // 1635
	  // the last outstanding method in the current block, runs the next block. If                                    // 1636
	  // there are no more methods, consider accepting a hot code push.                                               // 1637
	  _outstandingMethodFinished: function () {                                                                       // 1638
	    var self = this;                                                                                              // 1639
	    if (self._anyMethodsAreOutstanding())                                                                         // 1640
	      return;                                                                                                     // 1641
	                                                                                                                  // 1642
	    // No methods are outstanding. This should mean that the first block of                                       // 1643
	    // methods is empty. (Or it might not exist, if this was a method that                                        // 1644
	    // half-finished before disconnect/reconnect.)                                                                // 1645
	    if (! _.isEmpty(self._outstandingMethodBlocks)) {                                                             // 1646
	      var firstBlock = self._outstandingMethodBlocks.shift();                                                     // 1647
	      if (! _.isEmpty(firstBlock.methods))                                                                        // 1648
	        throw new Error("No methods outstanding but nonempty block: " +                                           // 1649
	                        JSON.stringify(firstBlock));                                                              // 1650
	                                                                                                                  // 1651
	      // Send the outstanding methods now in the first block.                                                     // 1652
	      if (!_.isEmpty(self._outstandingMethodBlocks))                                                              // 1653
	        self._sendOutstandingMethods();                                                                           // 1654
	    }                                                                                                             // 1655
	                                                                                                                  // 1656
	    // Maybe accept a hot code push.                                                                              // 1657
	    self._maybeMigrate();                                                                                         // 1658
	  },                                                                                                              // 1659
	                                                                                                                  // 1660
	  // Sends messages for all the methods in the first block in                                                     // 1661
	  // _outstandingMethodBlocks.                                                                                    // 1662
	  _sendOutstandingMethods: function() {                                                                           // 1663
	    var self = this;                                                                                              // 1664
	    if (_.isEmpty(self._outstandingMethodBlocks))                                                                 // 1665
	      return;                                                                                                     // 1666
	    _.each(self._outstandingMethodBlocks[0].methods, function (m) {                                               // 1667
	      m.sendMessage();                                                                                            // 1668
	    });                                                                                                           // 1669
	  },                                                                                                              // 1670
	                                                                                                                  // 1671
	  _livedata_error: function (msg) {                                                                               // 1672
	    Meteor._debug("Received error from server: ", msg.reason);                                                    // 1673
	    if (msg.offendingMessage)                                                                                     // 1674
	      Meteor._debug("For: ", msg.offendingMessage);                                                               // 1675
	  },                                                                                                              // 1676
	                                                                                                                  // 1677
	  _callOnReconnectAndSendAppropriateOutstandingMethods: function() {                                              // 1678
	    var self = this;                                                                                              // 1679
	    var oldOutstandingMethodBlocks = self._outstandingMethodBlocks;                                               // 1680
	    self._outstandingMethodBlocks = [];                                                                           // 1681
	                                                                                                                  // 1682
	    self.onReconnect();                                                                                           // 1683
	                                                                                                                  // 1684
	    if (_.isEmpty(oldOutstandingMethodBlocks))                                                                    // 1685
	      return;                                                                                                     // 1686
	                                                                                                                  // 1687
	    // We have at least one block worth of old outstanding methods to try                                         // 1688
	    // again. First: did onReconnect actually send anything? If not, we just                                      // 1689
	    // restore all outstanding methods and run the first block.                                                   // 1690
	    if (_.isEmpty(self._outstandingMethodBlocks)) {                                                               // 1691
	      self._outstandingMethodBlocks = oldOutstandingMethodBlocks;                                                 // 1692
	      self._sendOutstandingMethods();                                                                             // 1693
	      return;                                                                                                     // 1694
	    }                                                                                                             // 1695
	                                                                                                                  // 1696
	    // OK, there are blocks on both sides. Special case: merge the last block of                                  // 1697
	    // the reconnect methods with the first block of the original methods, if                                     // 1698
	    // neither of them are "wait" blocks.                                                                         // 1699
	    if (!_.last(self._outstandingMethodBlocks).wait &&                                                            // 1700
	        !oldOutstandingMethodBlocks[0].wait) {                                                                    // 1701
	      _.each(oldOutstandingMethodBlocks[0].methods, function (m) {                                                // 1702
	        _.last(self._outstandingMethodBlocks).methods.push(m);                                                    // 1703
	                                                                                                                  // 1704
	        // If this "last block" is also the first block, send the message.                                        // 1705
	        if (self._outstandingMethodBlocks.length === 1)                                                           // 1706
	          m.sendMessage();                                                                                        // 1707
	      });                                                                                                         // 1708
	                                                                                                                  // 1709
	      oldOutstandingMethodBlocks.shift();                                                                         // 1710
	    }                                                                                                             // 1711
	                                                                                                                  // 1712
	    // Now add the rest of the original blocks on.                                                                // 1713
	    _.each(oldOutstandingMethodBlocks, function (block) {                                                         // 1714
	      self._outstandingMethodBlocks.push(block);                                                                  // 1715
	    });                                                                                                           // 1716
	  },                                                                                                              // 1717
	                                                                                                                  // 1718
	  // We can accept a hot code push if there are no methods in flight.                                             // 1719
	  _readyToMigrate: function() {                                                                                   // 1720
	    var self = this;                                                                                              // 1721
	    return _.isEmpty(self._methodInvokers);                                                                       // 1722
	  },                                                                                                              // 1723
	                                                                                                                  // 1724
	  // If we were blocking a migration, see if it's now possible to continue.                                       // 1725
	  // Call whenever the set of outstanding/blocked methods shrinks.                                                // 1726
	  _maybeMigrate: function () {                                                                                    // 1727
	    var self = this;                                                                                              // 1728
	    if (self._retryMigrate && self._readyToMigrate()) {                                                           // 1729
	      self._retryMigrate();                                                                                       // 1730
	      self._retryMigrate = null;                                                                                  // 1731
	    }                                                                                                             // 1732
	  }                                                                                                               // 1733
	});                                                                                                               // 1734
	                                                                                                                  // 1735
	LivedataTest.Connection = Connection;                                                                             // 1736
	                                                                                                                  // 1737
	// @param url {String} URL to Meteor app,                                                                         // 1738
	//     e.g.:                                                                                                      // 1739
	//     "subdomain.meteor.com",                                                                                    // 1740
	//     "http://subdomain.meteor.com",                                                                             // 1741
	//     "/",                                                                                                       // 1742
	//     "ddp+sockjs://ddp--****-foo.meteor.com/sockjs"                                                             // 1743
	                                                                                                                  // 1744
	/**                                                                                                               // 1745
	 * @summary Connect to the server of a different Meteor application to subscribe to its document sets and invoke its remote methods.
	 * @locus Anywhere                                                                                                // 1747
	 * @param {String} url The URL of another Meteor application.                                                     // 1748
	 */                                                                                                               // 1749
	DDP.connect = function (url, options) {                                                                           // 1750
	  var ret = new Connection(url, options);                                                                         // 1751
	  allConnections.push(ret); // hack. see below.                                                                   // 1752
	  return ret;                                                                                                     // 1753
	};                                                                                                                // 1754
	                                                                                                                  // 1755
	// Hack for `spiderable` package: a way to see if the page is done                                                // 1756
	// loading all the data it needs.                                                                                 // 1757
	//                                                                                                                // 1758
	allConnections = [];                                                                                              // 1759
	DDP._allSubscriptionsReady = function () {                                                                        // 1760
	  return _.all(allConnections, function (conn) {                                                                  // 1761
	    return _.all(conn._subscriptions, function (sub) {                                                            // 1762
	      return sub.ready;                                                                                           // 1763
	    });                                                                                                           // 1764
	  });                                                                                                             // 1765
	};                                                                                                                // 1766
	                                                                                                                  // 1767
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                //
	// packages/ddp-client/client_convenience.js                                                                      //
	//                                                                                                                //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                  //
	// Meteor.refresh can be called on the client (if you're in common code) but it                                   // 1
	// only has an effect on the server.                                                                              // 2
	Meteor.refresh = function (notification) {                                                                        // 3
	};                                                                                                                // 4
	                                                                                                                  // 5
	if (Meteor.isClient) {                                                                                            // 6
	  // By default, try to connect back to the same endpoint as the page                                             // 7
	  // was served from.                                                                                             // 8
	  //                                                                                                              // 9
	  // XXX We should be doing this a different way. Right now we don't                                              // 10
	  // include ROOT_URL_PATH_PREFIX when computing ddpUrl. (We don't                                                // 11
	  // include it on the server when computing                                                                      // 12
	  // DDP_DEFAULT_CONNECTION_URL, and we don't include it in our                                                   // 13
	  // default, '/'.) We get by with this because DDP.connect then                                                  // 14
	  // forces the URL passed to it to be interpreted relative to the                                                // 15
	  // app's deploy path, even if it is absolute. Instead, we should                                                // 16
	  // make DDP_DEFAULT_CONNECTION_URL, if set, include the path prefix;                                            // 17
	  // make the default ddpUrl be '' rather that '/'; and make                                                      // 18
	  // _translateUrl in stream_client_common.js not force absolute paths                                            // 19
	  // to be treated like relative paths. See also                                                                  // 20
	  // stream_client_common.js #RationalizingRelativeDDPURLs                                                        // 21
	  var ddpUrl = '/';                                                                                               // 22
	  if (typeof __meteor_runtime_config__ !== "undefined") {                                                         // 23
	    if (__meteor_runtime_config__.DDP_DEFAULT_CONNECTION_URL)                                                     // 24
	      ddpUrl = __meteor_runtime_config__.DDP_DEFAULT_CONNECTION_URL;                                              // 25
	  }                                                                                                               // 26
	                                                                                                                  // 27
	  var retry = new Retry();                                                                                        // 28
	                                                                                                                  // 29
	  var onDDPVersionNegotiationFailure = function (description) {                                                   // 30
	    Meteor._debug(description);                                                                                   // 31
	    if (Package.reload) {                                                                                         // 32
	      var migrationData = Package.reload.Reload._migrationData('livedata') || {};                                 // 33
	      var failures = migrationData.DDPVersionNegotiationFailures || 0;                                            // 34
	      ++failures;                                                                                                 // 35
	      Package.reload.Reload._onMigrate('livedata', function () {                                                  // 36
	        return [true, {DDPVersionNegotiationFailures: failures}];                                                 // 37
	      });                                                                                                         // 38
	      retry.retryLater(failures, function () {                                                                    // 39
	        Package.reload.Reload._reload();                                                                          // 40
	      });                                                                                                         // 41
	    }                                                                                                             // 42
	  };                                                                                                              // 43
	                                                                                                                  // 44
	  Meteor.connection =                                                                                             // 45
	    DDP.connect(ddpUrl, {                                                                                         // 46
	      onDDPVersionNegotiationFailure: onDDPVersionNegotiationFailure                                              // 47
	    });                                                                                                           // 48
	                                                                                                                  // 49
	  // Proxy the public methods of Meteor.connection so they can                                                    // 50
	  // be called directly on Meteor.                                                                                // 51
	  _.each(['subscribe', 'methods', 'call', 'apply', 'status', 'reconnect',                                         // 52
	          'disconnect'],                                                                                          // 53
	         function (name) {                                                                                        // 54
	           Meteor[name] = _.bind(Meteor.connection[name], Meteor.connection);                                     // 55
	         });                                                                                                      // 56
	} else {                                                                                                          // 57
	  // Never set up a default connection on the server. Don't even map                                              // 58
	  // subscribe/call/etc onto Meteor.                                                                              // 59
	  Meteor.connection = null;                                                                                       // 60
	}                                                                                                                 // 61
	                                                                                                                  // 62
	// Meteor.connection used to be called                                                                            // 63
	// Meteor.default_connection. Provide backcompat as a courtesy even                                               // 64
	// though it was never documented.                                                                                // 65
	// XXX COMPAT WITH 0.6.4                                                                                          // 66
	Meteor.default_connection = Meteor.connection;                                                                    // 67
	                                                                                                                  // 68
	// We should transition from Meteor.connect to DDP.connect.                                                       // 69
	// XXX COMPAT WITH 0.6.4                                                                                          // 70
	Meteor.connect = DDP.connect;                                                                                     // 71
	                                                                                                                  // 72
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['ddp-client'] = {}, {
	  DDP: DDP,
	  LivedataTest: LivedataTest
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/ddp-common.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var check = Package.check.check;
	var Match = Package.check.Match;
	var Random = Package.random.Random;
	var EJSON = Package.ejson.EJSON;
	var _ = Package.underscore._;
	var Tracker = Package.tracker.Tracker;
	var Deps = Package.tracker.Deps;
	var Retry = Package.retry.Retry;
	
	/* Package-scope variables */
	var DDPCommon;
	
	(function(){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                   //
	// packages/ddp-common/namespace.js                                                                  //
	//                                                                                                   //
	///////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                     //
	/**                                                                                                  // 1
	 * @namespace DDPCommon                                                                              // 2
	 * @summary Namespace for DDPCommon-related methods/classes. Shared between                          // 3
	 * `ddp-client` and `ddp-server`, where the ddp-client is the implementation                         // 4
	 * of a ddp client for both client AND server; and the ddp server is the                             // 5
	 * implementation of the livedata server and stream server. Common                                   // 6
	 * functionality shared between both can be shared under this namespace                              // 7
	 */                                                                                                  // 8
	DDPCommon = {};                                                                                      // 9
	                                                                                                     // 10
	///////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                   //
	// packages/ddp-common/heartbeat.js                                                                  //
	//                                                                                                   //
	///////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                     //
	// Heartbeat options:                                                                                // 1
	//   heartbeatInterval: interval to send pings, in milliseconds.                                     // 2
	//   heartbeatTimeout: timeout to close the connection if a reply isn't                              // 3
	//     received, in milliseconds.                                                                    // 4
	//   sendPing: function to call to send a ping on the connection.                                    // 5
	//   onTimeout: function to call to close the connection.                                            // 6
	                                                                                                     // 7
	DDPCommon.Heartbeat = function (options) {                                                           // 8
	  var self = this;                                                                                   // 9
	                                                                                                     // 10
	  self.heartbeatInterval = options.heartbeatInterval;                                                // 11
	  self.heartbeatTimeout = options.heartbeatTimeout;                                                  // 12
	  self._sendPing = options.sendPing;                                                                 // 13
	  self._onTimeout = options.onTimeout;                                                               // 14
	  self._seenPacket = false;                                                                          // 15
	                                                                                                     // 16
	  self._heartbeatIntervalHandle = null;                                                              // 17
	  self._heartbeatTimeoutHandle = null;                                                               // 18
	};                                                                                                   // 19
	                                                                                                     // 20
	_.extend(DDPCommon.Heartbeat.prototype, {                                                            // 21
	  stop: function () {                                                                                // 22
	    var self = this;                                                                                 // 23
	    self._clearHeartbeatIntervalTimer();                                                             // 24
	    self._clearHeartbeatTimeoutTimer();                                                              // 25
	  },                                                                                                 // 26
	                                                                                                     // 27
	  start: function () {                                                                               // 28
	    var self = this;                                                                                 // 29
	    self.stop();                                                                                     // 30
	    self._startHeartbeatIntervalTimer();                                                             // 31
	  },                                                                                                 // 32
	                                                                                                     // 33
	  _startHeartbeatIntervalTimer: function () {                                                        // 34
	    var self = this;                                                                                 // 35
	    self._heartbeatIntervalHandle = Meteor.setInterval(                                              // 36
	      _.bind(self._heartbeatIntervalFired, self),                                                    // 37
	      self.heartbeatInterval                                                                         // 38
	    );                                                                                               // 39
	  },                                                                                                 // 40
	                                                                                                     // 41
	  _startHeartbeatTimeoutTimer: function () {                                                         // 42
	    var self = this;                                                                                 // 43
	    self._heartbeatTimeoutHandle = Meteor.setTimeout(                                                // 44
	      _.bind(self._heartbeatTimeoutFired, self),                                                     // 45
	      self.heartbeatTimeout                                                                          // 46
	    );                                                                                               // 47
	  },                                                                                                 // 48
	                                                                                                     // 49
	  _clearHeartbeatIntervalTimer: function () {                                                        // 50
	    var self = this;                                                                                 // 51
	    if (self._heartbeatIntervalHandle) {                                                             // 52
	      Meteor.clearInterval(self._heartbeatIntervalHandle);                                           // 53
	      self._heartbeatIntervalHandle = null;                                                          // 54
	    }                                                                                                // 55
	  },                                                                                                 // 56
	                                                                                                     // 57
	  _clearHeartbeatTimeoutTimer: function () {                                                         // 58
	    var self = this;                                                                                 // 59
	    if (self._heartbeatTimeoutHandle) {                                                              // 60
	      Meteor.clearTimeout(self._heartbeatTimeoutHandle);                                             // 61
	      self._heartbeatTimeoutHandle = null;                                                           // 62
	    }                                                                                                // 63
	  },                                                                                                 // 64
	                                                                                                     // 65
	  // The heartbeat interval timer is fired when we should send a ping.                               // 66
	  _heartbeatIntervalFired: function () {                                                             // 67
	    var self = this;                                                                                 // 68
	    // don't send ping if we've seen a packet since we last checked,                                 // 69
	    // *or* if we have already sent a ping and are awaiting a timeout.                               // 70
	    // That shouldn't happen, but it's possible if                                                   // 71
	    // `self.heartbeatInterval` is smaller than                                                      // 72
	    // `self.heartbeatTimeout`.                                                                      // 73
	    if (! self._seenPacket && ! self._heartbeatTimeoutHandle) {                                      // 74
	      self._sendPing();                                                                              // 75
	      // Set up timeout, in case a pong doesn't arrive in time.                                      // 76
	      self._startHeartbeatTimeoutTimer();                                                            // 77
	    }                                                                                                // 78
	    self._seenPacket = false;                                                                        // 79
	  },                                                                                                 // 80
	                                                                                                     // 81
	  // The heartbeat timeout timer is fired when we sent a ping, but we                                // 82
	  // timed out waiting for the pong.                                                                 // 83
	  _heartbeatTimeoutFired: function () {                                                              // 84
	    var self = this;                                                                                 // 85
	    self._heartbeatTimeoutHandle = null;                                                             // 86
	    self._onTimeout();                                                                               // 87
	  },                                                                                                 // 88
	                                                                                                     // 89
	  messageReceived: function () {                                                                     // 90
	    var self = this;                                                                                 // 91
	    // Tell periodic checkin that we have seen a packet, and thus it                                 // 92
	    // does not need to send a ping this cycle.                                                      // 93
	    self._seenPacket = true;                                                                         // 94
	    // If we were waiting for a pong, we got it.                                                     // 95
	    if (self._heartbeatTimeoutHandle) {                                                              // 96
	      self._clearHeartbeatTimeoutTimer();                                                            // 97
	    }                                                                                                // 98
	  }                                                                                                  // 99
	});                                                                                                  // 100
	                                                                                                     // 101
	///////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                   //
	// packages/ddp-common/utils.js                                                                      //
	//                                                                                                   //
	///////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                     //
	DDPCommon.SUPPORTED_DDP_VERSIONS = [ '1', 'pre2', 'pre1' ];                                          // 1
	                                                                                                     // 2
	DDPCommon.parseDDP = function (stringMessage) {                                                      // 3
	  try {                                                                                              // 4
	    var msg = JSON.parse(stringMessage);                                                             // 5
	  } catch (e) {                                                                                      // 6
	    Meteor._debug("Discarding message with invalid JSON", stringMessage);                            // 7
	    return null;                                                                                     // 8
	  }                                                                                                  // 9
	  // DDP messages must be objects.                                                                   // 10
	  if (msg === null || typeof msg !== 'object') {                                                     // 11
	    Meteor._debug("Discarding non-object DDP message", stringMessage);                               // 12
	    return null;                                                                                     // 13
	  }                                                                                                  // 14
	                                                                                                     // 15
	  // massage msg to get it into "abstract ddp" rather than "wire ddp" format.                        // 16
	                                                                                                     // 17
	  // switch between "cleared" rep of unsetting fields and "undefined"                                // 18
	  // rep of same                                                                                     // 19
	  if (_.has(msg, 'cleared')) {                                                                       // 20
	    if (!_.has(msg, 'fields'))                                                                       // 21
	      msg.fields = {};                                                                               // 22
	    _.each(msg.cleared, function (clearKey) {                                                        // 23
	      msg.fields[clearKey] = undefined;                                                              // 24
	    });                                                                                              // 25
	    delete msg.cleared;                                                                              // 26
	  }                                                                                                  // 27
	                                                                                                     // 28
	  _.each(['fields', 'params', 'result'], function (field) {                                          // 29
	    if (_.has(msg, field))                                                                           // 30
	      msg[field] = EJSON._adjustTypesFromJSONValue(msg[field]);                                      // 31
	  });                                                                                                // 32
	                                                                                                     // 33
	  return msg;                                                                                        // 34
	};                                                                                                   // 35
	                                                                                                     // 36
	DDPCommon.stringifyDDP = function (msg) {                                                            // 37
	  var copy = EJSON.clone(msg);                                                                       // 38
	  // swizzle 'changed' messages from 'fields undefined' rep to 'fields                               // 39
	  // and cleared' rep                                                                                // 40
	  if (_.has(msg, 'fields')) {                                                                        // 41
	    var cleared = [];                                                                                // 42
	    _.each(msg.fields, function (value, key) {                                                       // 43
	      if (value === undefined) {                                                                     // 44
	        cleared.push(key);                                                                           // 45
	        delete copy.fields[key];                                                                     // 46
	      }                                                                                              // 47
	    });                                                                                              // 48
	    if (!_.isEmpty(cleared))                                                                         // 49
	      copy.cleared = cleared;                                                                        // 50
	    if (_.isEmpty(copy.fields))                                                                      // 51
	      delete copy.fields;                                                                            // 52
	  }                                                                                                  // 53
	  // adjust types to basic                                                                           // 54
	  _.each(['fields', 'params', 'result'], function (field) {                                          // 55
	    if (_.has(copy, field))                                                                          // 56
	      copy[field] = EJSON._adjustTypesToJSONValue(copy[field]);                                      // 57
	  });                                                                                                // 58
	  if (msg.id && typeof msg.id !== 'string') {                                                        // 59
	    throw new Error("Message id is not a string");                                                   // 60
	  }                                                                                                  // 61
	  return JSON.stringify(copy);                                                                       // 62
	};                                                                                                   // 63
	                                                                                                     // 64
	                                                                                                     // 65
	///////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                   //
	// packages/ddp-common/method_invocation.js                                                          //
	//                                                                                                   //
	///////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                     //
	// Instance name is this because it is usually referred to as this inside a                          // 1
	// method definition                                                                                 // 2
	/**                                                                                                  // 3
	 * @summary The state for a single invocation of a method, referenced by this                        // 4
	 * inside a method definition.                                                                       // 5
	 * @param {Object} options                                                                           // 6
	 * @instanceName this                                                                                // 7
	 * @showInstanceName true                                                                            // 8
	 */                                                                                                  // 9
	DDPCommon.MethodInvocation = function (options) {                                                    // 10
	  var self = this;                                                                                   // 11
	                                                                                                     // 12
	  // true if we're running not the actual method, but a stub (that is,                               // 13
	  // if we're on a client (which may be a browser, or in the future a                                // 14
	  // server connecting to another server) and presently running a                                    // 15
	  // simulation of a server-side method for latency compensation                                     // 16
	  // purposes). not currently true except in a client such as a browser,                             // 17
	  // since there's usually no point in running stubs unless you have a                               // 18
	  // zero-latency connection to the user.                                                            // 19
	                                                                                                     // 20
	  /**                                                                                                // 21
	   * @summary Access inside a method invocation.  Boolean value, true if this invocation is a stub.  // 22
	   * @locus Anywhere                                                                                 // 23
	   * @name  isSimulation                                                                             // 24
	   * @memberOf DDPCommon.MethodInvocation                                                            // 25
	   * @instance                                                                                       // 26
	   * @type {Boolean}                                                                                 // 27
	   */                                                                                                // 28
	  this.isSimulation = options.isSimulation;                                                          // 29
	                                                                                                     // 30
	  // call this function to allow other method invocations (from the                                  // 31
	  // same client) to continue running without waiting for this one to                                // 32
	  // complete.                                                                                       // 33
	  this._unblock = options.unblock || function () {};                                                 // 34
	  this._calledUnblock = false;                                                                       // 35
	                                                                                                     // 36
	  // current user id                                                                                 // 37
	                                                                                                     // 38
	  /**                                                                                                // 39
	   * @summary The id of the user that made this method call, or `null` if no user was logged in.     // 40
	   * @locus Anywhere                                                                                 // 41
	   * @name  userId                                                                                   // 42
	   * @memberOf DDPCommon.MethodInvocation                                                            // 43
	   * @instance                                                                                       // 44
	   */                                                                                                // 45
	  this.userId = options.userId;                                                                      // 46
	                                                                                                     // 47
	  // sets current user id in all appropriate server contexts and                                     // 48
	  // reruns subscriptions                                                                            // 49
	  this._setUserId = options.setUserId || function () {};                                             // 50
	                                                                                                     // 51
	  // On the server, the connection this method call came in on.                                      // 52
	                                                                                                     // 53
	  /**                                                                                                // 54
	   * @summary Access inside a method invocation. The [connection](#meteor_onconnection) that this method was received on. `null` if the method is not associated with a connection, eg. a server initiated method call. Calls to methods made from a server method which was in turn initiated from the client share the same `connection`.
	   * @locus Server                                                                                   // 56
	   * @name  connection                                                                               // 57
	   * @memberOf DDPCommon.MethodInvocation                                                            // 58
	   * @instance                                                                                       // 59
	   */                                                                                                // 60
	  this.connection = options.connection;                                                              // 61
	                                                                                                     // 62
	  // The seed for randomStream value generation                                                      // 63
	  this.randomSeed = options.randomSeed;                                                              // 64
	                                                                                                     // 65
	  // This is set by RandomStream.get; and holds the random stream state                              // 66
	  this.randomStream = null;                                                                          // 67
	};                                                                                                   // 68
	                                                                                                     // 69
	_.extend(DDPCommon.MethodInvocation.prototype, {                                                     // 70
	  /**                                                                                                // 71
	   * @summary Call inside a method invocation.  Allow subsequent method from this client to begin running in a new fiber.
	   * @locus Server                                                                                   // 73
	   * @memberOf DDPCommon.MethodInvocation                                                            // 74
	   * @instance                                                                                       // 75
	   */                                                                                                // 76
	  unblock: function () {                                                                             // 77
	    var self = this;                                                                                 // 78
	    self._calledUnblock = true;                                                                      // 79
	    self._unblock();                                                                                 // 80
	  },                                                                                                 // 81
	                                                                                                     // 82
	  /**                                                                                                // 83
	   * @summary Set the logged in user.                                                                // 84
	   * @locus Server                                                                                   // 85
	   * @memberOf DDPCommon.MethodInvocation                                                            // 86
	   * @instance                                                                                       // 87
	   * @param {String | null} userId The value that should be returned by `userId` on this connection.
	   */                                                                                                // 89
	  setUserId: function(userId) {                                                                      // 90
	    var self = this;                                                                                 // 91
	    if (self._calledUnblock)                                                                         // 92
	      throw new Error("Can't call setUserId in a method after calling unblock");                     // 93
	    self.userId = userId;                                                                            // 94
	    self._setUserId(userId);                                                                         // 95
	  }                                                                                                  // 96
	});                                                                                                  // 97
	                                                                                                     // 98
	///////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                   //
	// packages/ddp-common/random_stream.js                                                              //
	//                                                                                                   //
	///////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                     //
	// RandomStream allows for generation of pseudo-random values, from a seed.                          // 1
	//                                                                                                   // 2
	// We use this for consistent 'random' numbers across the client and server.                         // 3
	// We want to generate probably-unique IDs on the client, and we ideally want                        // 4
	// the server to generate the same IDs when it executes the method.                                  // 5
	//                                                                                                   // 6
	// For generated values to be the same, we must seed ourselves the same way,                         // 7
	// and we must keep track of the current state of our pseudo-random generators.                      // 8
	// We call this state the scope. By default, we use the current DDP method                           // 9
	// invocation as our scope.  DDP now allows the client to specify a randomSeed.                      // 10
	// If a randomSeed is provided it will be used to seed our random sequences.                         // 11
	// In this way, client and server method calls will generate the same values.                        // 12
	//                                                                                                   // 13
	// We expose multiple named streams; each stream is independent                                      // 14
	// and is seeded differently (but predictably from the name).                                        // 15
	// By using multiple streams, we support reordering of requests,                                     // 16
	// as long as they occur on different streams.                                                       // 17
	//                                                                                                   // 18
	// @param options {Optional Object}                                                                  // 19
	//   seed: Array or value - Seed value(s) for the generator.                                         // 20
	//                          If an array, will be used as-is                                          // 21
	//                          If a value, will be converted to a single-value array                    // 22
	//                          If omitted, a random array will be used as the seed.                     // 23
	DDPCommon.RandomStream = function (options) {                                                        // 24
	  var self = this;                                                                                   // 25
	                                                                                                     // 26
	  this.seed = [].concat(options.seed || randomToken());                                              // 27
	                                                                                                     // 28
	  this.sequences = {};                                                                               // 29
	};                                                                                                   // 30
	                                                                                                     // 31
	// Returns a random string of sufficient length for a random seed.                                   // 32
	// This is a placeholder function; a similar function is planned                                     // 33
	// for Random itself; when that is added we should remove this function,                             // 34
	// and call Random's randomToken instead.                                                            // 35
	function randomToken() {                                                                             // 36
	  return Random.hexString(20);                                                                       // 37
	};                                                                                                   // 38
	                                                                                                     // 39
	// Returns the random stream with the specified name, in the specified                               // 40
	// scope. If a scope is passed, then we use that to seed a (not                                      // 41
	// cryptographically secure) PRNG using the fast Alea algorithm.  If                                 // 42
	// scope is null (or otherwise falsey) then we use a generated seed.                                 // 43
	//                                                                                                   // 44
	// However, scope will normally be the current DDP method invocation,                                // 45
	// so we'll use the stream with the specified name, and we should get                                // 46
	// consistent values on the client and server sides of a method call.                                // 47
	DDPCommon.RandomStream.get = function (scope, name) {                                                // 48
	  if (!name) {                                                                                       // 49
	    name = "default";                                                                                // 50
	  }                                                                                                  // 51
	  if (!scope) {                                                                                      // 52
	    // There was no scope passed in; the sequence won't actually be                                  // 53
	    // reproducible. but make it fast (and not cryptographically                                     // 54
	    // secure) anyways, so that the behavior is similar to what you'd                                // 55
	    // get by passing in a scope.                                                                    // 56
	    return Random.insecure;                                                                          // 57
	  }                                                                                                  // 58
	  var randomStream = scope.randomStream;                                                             // 59
	  if (!randomStream) {                                                                               // 60
	    scope.randomStream = randomStream = new DDPCommon.RandomStream({                                 // 61
	      seed: scope.randomSeed                                                                         // 62
	    });                                                                                              // 63
	  }                                                                                                  // 64
	  return randomStream._sequence(name);                                                               // 65
	};                                                                                                   // 66
	                                                                                                     // 67
	                                                                                                     // 68
	// Creates a randomSeed for passing to a method call.                                                // 69
	// Note that we take enclosing as an argument,                                                       // 70
	// though we expect it to be DDP._CurrentInvocation.get()                                            // 71
	// However, we often evaluate makeRpcSeed lazily, and thus the relevant                              // 72
	// invocation may not be the one currently in scope.                                                 // 73
	// If enclosing is null, we'll use Random and values won't be repeatable.                            // 74
	DDPCommon.makeRpcSeed = function (enclosing, methodName) {                                           // 75
	  var stream = DDPCommon.RandomStream.get(enclosing, '/rpc/' + methodName);                          // 76
	  return stream.hexString(20);                                                                       // 77
	};                                                                                                   // 78
	                                                                                                     // 79
	_.extend(DDPCommon.RandomStream.prototype, {                                                         // 80
	  // Get a random sequence with the specified name, creating it if does not exist.                   // 81
	  // New sequences are seeded with the seed concatenated with the name.                              // 82
	  // By passing a seed into Random.create, we use the Alea generator.                                // 83
	  _sequence: function (name) {                                                                       // 84
	    var self = this;                                                                                 // 85
	                                                                                                     // 86
	    var sequence = self.sequences[name] || null;                                                     // 87
	    if (sequence === null) {                                                                         // 88
	      var sequenceSeed = self.seed.concat(name);                                                     // 89
	      for (var i = 0; i < sequenceSeed.length; i++) {                                                // 90
	        if (_.isFunction(sequenceSeed[i])) {                                                         // 91
	          sequenceSeed[i] = sequenceSeed[i]();                                                       // 92
	        }                                                                                            // 93
	      }                                                                                              // 94
	      self.sequences[name] = sequence = Random.createWithSeeds.apply(null, sequenceSeed);            // 95
	    }                                                                                                // 96
	    return sequence;                                                                                 // 97
	  }                                                                                                  // 98
	});                                                                                                  // 99
	                                                                                                     // 100
	///////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['ddp-common'] = {}, {
	  DDPCommon: DDPCommon
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/ddp-rate-limiter.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	Package['ddp-rate-limiter'] = {};
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/ddp-server.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	Package['ddp-server'] = {};
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/ddp.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var DDP = Package['ddp-client'].DDP;
	
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.ddp = {}, {
	  DDP: DDP
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/deps.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Tracker = Package.tracker.Tracker;
	var Deps = Package.tracker.Deps;
	
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.deps = {}, {
	  Tracker: Tracker,
	  Deps: Deps
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/diff-sequence.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	var EJSON = Package.ejson.EJSON;
	
	/* Package-scope variables */
	var DiffSequence;
	
	(function(){
	
	/////////////////////////////////////////////////////////////////////////////////////
	//                                                                                 //
	// packages/diff-sequence/diff.js                                                  //
	//                                                                                 //
	/////////////////////////////////////////////////////////////////////////////////////
	                                                                                   //
	DiffSequence = {};                                                                 // 1
	                                                                                   // 2
	// ordered: bool.                                                                  // 3
	// old_results and new_results: collections of documents.                          // 4
	//    if ordered, they are arrays.                                                 // 5
	//    if unordered, they are IdMaps                                                // 6
	DiffSequence.diffQueryChanges = function (ordered, oldResults, newResults,         // 7
	                                              observer, options) {                 // 8
	  if (ordered)                                                                     // 9
	    DiffSequence.diffQueryOrderedChanges(                                          // 10
	      oldResults, newResults, observer, options);                                  // 11
	  else                                                                             // 12
	    DiffSequence.diffQueryUnorderedChanges(                                        // 13
	      oldResults, newResults, observer, options);                                  // 14
	};                                                                                 // 15
	                                                                                   // 16
	DiffSequence.diffQueryUnorderedChanges = function (oldResults, newResults,         // 17
	                                                       observer, options) {        // 18
	  options = options || {};                                                         // 19
	  var projectionFn = options.projectionFn || EJSON.clone;                          // 20
	                                                                                   // 21
	  if (observer.movedBefore) {                                                      // 22
	    throw new Error("_diffQueryUnordered called with a movedBefore observer!");    // 23
	  }                                                                                // 24
	                                                                                   // 25
	  newResults.forEach(function (newDoc, id) {                                       // 26
	    var oldDoc = oldResults.get(id);                                               // 27
	    if (oldDoc) {                                                                  // 28
	      if (observer.changed && !EJSON.equals(oldDoc, newDoc)) {                     // 29
	        var projectedNew = projectionFn(newDoc);                                   // 30
	        var projectedOld = projectionFn(oldDoc);                                   // 31
	        var changedFields =                                                        // 32
	              DiffSequence.makeChangedFields(projectedNew, projectedOld);          // 33
	        if (! _.isEmpty(changedFields)) {                                          // 34
	          observer.changed(id, changedFields);                                     // 35
	        }                                                                          // 36
	      }                                                                            // 37
	    } else if (observer.added) {                                                   // 38
	      var fields = projectionFn(newDoc);                                           // 39
	      delete fields._id;                                                           // 40
	      observer.added(newDoc._id, fields);                                          // 41
	    }                                                                              // 42
	  });                                                                              // 43
	                                                                                   // 44
	  if (observer.removed) {                                                          // 45
	    oldResults.forEach(function (oldDoc, id) {                                     // 46
	      if (!newResults.has(id))                                                     // 47
	        observer.removed(id);                                                      // 48
	    });                                                                            // 49
	  }                                                                                // 50
	};                                                                                 // 51
	                                                                                   // 52
	                                                                                   // 53
	DiffSequence.diffQueryOrderedChanges = function (old_results, new_results,         // 54
	                                                     observer, options) {          // 55
	  options = options || {};                                                         // 56
	  var projectionFn = options.projectionFn || EJSON.clone;                          // 57
	                                                                                   // 58
	  var new_presence_of_id = {};                                                     // 59
	  _.each(new_results, function (doc) {                                             // 60
	    if (new_presence_of_id[doc._id])                                               // 61
	      Meteor._debug("Duplicate _id in new_results");                               // 62
	    new_presence_of_id[doc._id] = true;                                            // 63
	  });                                                                              // 64
	                                                                                   // 65
	  var old_index_of_id = {};                                                        // 66
	  _.each(old_results, function (doc, i) {                                          // 67
	    if (doc._id in old_index_of_id)                                                // 68
	      Meteor._debug("Duplicate _id in old_results");                               // 69
	    old_index_of_id[doc._id] = i;                                                  // 70
	  });                                                                              // 71
	                                                                                   // 72
	  // ALGORITHM:                                                                    // 73
	  //                                                                               // 74
	  // To determine which docs should be considered "moved" (and which               // 75
	  // merely change position because of other docs moving) we run                   // 76
	  // a "longest common subsequence" (LCS) algorithm.  The LCS of the               // 77
	  // old doc IDs and the new doc IDs gives the docs that should NOT be             // 78
	  // considered moved.                                                             // 79
	                                                                                   // 80
	  // To actually call the appropriate callbacks to get from the old state to the   // 81
	  // new state:                                                                    // 82
	                                                                                   // 83
	  // First, we call removed() on all the items that only appear in the old         // 84
	  // state.                                                                        // 85
	                                                                                   // 86
	  // Then, once we have the items that should not move, we walk through the new    // 87
	  // results array group-by-group, where a "group" is a set of items that have     // 88
	  // moved, anchored on the end by an item that should not move.  One by one, we   // 89
	  // move each of those elements into place "before" the anchoring end-of-group    // 90
	  // item, and fire changed events on them if necessary.  Then we fire a changed   // 91
	  // event on the anchor, and move on to the next group.  There is always at       // 92
	  // least one group; the last group is anchored by a virtual "null" id at the     // 93
	  // end.                                                                          // 94
	                                                                                   // 95
	  // Asymptotically: O(N k) where k is number of ops, or potentially               // 96
	  // O(N log N) if inner loop of LCS were made to be binary search.                // 97
	                                                                                   // 98
	                                                                                   // 99
	  //////// LCS (longest common sequence, with respect to _id)                      // 100
	  // (see Wikipedia article on Longest Increasing Subsequence,                     // 101
	  // where the LIS is taken of the sequence of old indices of the                  // 102
	  // docs in new_results)                                                          // 103
	  //                                                                               // 104
	  // unmoved: the output of the algorithm; members of the LCS,                     // 105
	  // in the form of indices into new_results                                       // 106
	  var unmoved = [];                                                                // 107
	  // max_seq_len: length of LCS found so far                                       // 108
	  var max_seq_len = 0;                                                             // 109
	  // seq_ends[i]: the index into new_results of the last doc in a                  // 110
	  // common subsequence of length of i+1 <= max_seq_len                            // 111
	  var N = new_results.length;                                                      // 112
	  var seq_ends = new Array(N);                                                     // 113
	  // ptrs:  the common subsequence ending with new_results[n] extends              // 114
	  // a common subsequence ending with new_results[ptr[n]], unless                  // 115
	  // ptr[n] is -1.                                                                 // 116
	  var ptrs = new Array(N);                                                         // 117
	  // virtual sequence of old indices of new results                                // 118
	  var old_idx_seq = function(i_new) {                                              // 119
	    return old_index_of_id[new_results[i_new]._id];                                // 120
	  };                                                                               // 121
	  // for each item in new_results, use it to extend a common subsequence           // 122
	  // of length j <= max_seq_len                                                    // 123
	  for(var i=0; i<N; i++) {                                                         // 124
	    if (old_index_of_id[new_results[i]._id] !== undefined) {                       // 125
	      var j = max_seq_len;                                                         // 126
	      // this inner loop would traditionally be a binary search,                   // 127
	      // but scanning backwards we will likely find a subseq to extend             // 128
	      // pretty soon, bounded for example by the total number of ops.              // 129
	      // If this were to be changed to a binary search, we'd still want            // 130
	      // to scan backwards a bit as an optimization.                               // 131
	      while (j > 0) {                                                              // 132
	        if (old_idx_seq(seq_ends[j-1]) < old_idx_seq(i))                           // 133
	          break;                                                                   // 134
	        j--;                                                                       // 135
	      }                                                                            // 136
	                                                                                   // 137
	      ptrs[i] = (j === 0 ? -1 : seq_ends[j-1]);                                    // 138
	      seq_ends[j] = i;                                                             // 139
	      if (j+1 > max_seq_len)                                                       // 140
	        max_seq_len = j+1;                                                         // 141
	    }                                                                              // 142
	  }                                                                                // 143
	                                                                                   // 144
	  // pull out the LCS/LIS into unmoved                                             // 145
	  var idx = (max_seq_len === 0 ? -1 : seq_ends[max_seq_len-1]);                    // 146
	  while (idx >= 0) {                                                               // 147
	    unmoved.push(idx);                                                             // 148
	    idx = ptrs[idx];                                                               // 149
	  }                                                                                // 150
	  // the unmoved item list is built backwards, so fix that                         // 151
	  unmoved.reverse();                                                               // 152
	                                                                                   // 153
	  // the last group is always anchored by the end of the result list, which is     // 154
	  // an id of "null"                                                               // 155
	  unmoved.push(new_results.length);                                                // 156
	                                                                                   // 157
	  _.each(old_results, function (doc) {                                             // 158
	    if (!new_presence_of_id[doc._id])                                              // 159
	      observer.removed && observer.removed(doc._id);                               // 160
	  });                                                                              // 161
	  // for each group of things in the new_results that is anchored by an unmoved    // 162
	  // element, iterate through the things before it.                                // 163
	  var startOfGroup = 0;                                                            // 164
	  _.each(unmoved, function (endOfGroup) {                                          // 165
	    var groupId = new_results[endOfGroup] ? new_results[endOfGroup]._id : null;    // 166
	    var oldDoc, newDoc, fields, projectedNew, projectedOld;                        // 167
	    for (var i = startOfGroup; i < endOfGroup; i++) {                              // 168
	      newDoc = new_results[i];                                                     // 169
	      if (!_.has(old_index_of_id, newDoc._id)) {                                   // 170
	        fields = projectionFn(newDoc);                                             // 171
	        delete fields._id;                                                         // 172
	        observer.addedBefore && observer.addedBefore(newDoc._id, fields, groupId);
	        observer.added && observer.added(newDoc._id, fields);                      // 174
	      } else {                                                                     // 175
	        // moved                                                                   // 176
	        oldDoc = old_results[old_index_of_id[newDoc._id]];                         // 177
	        projectedNew = projectionFn(newDoc);                                       // 178
	        projectedOld = projectionFn(oldDoc);                                       // 179
	        fields = DiffSequence.makeChangedFields(projectedNew, projectedOld);       // 180
	        if (!_.isEmpty(fields)) {                                                  // 181
	          observer.changed && observer.changed(newDoc._id, fields);                // 182
	        }                                                                          // 183
	        observer.movedBefore && observer.movedBefore(newDoc._id, groupId);         // 184
	      }                                                                            // 185
	    }                                                                              // 186
	    if (groupId) {                                                                 // 187
	      newDoc = new_results[endOfGroup];                                            // 188
	      oldDoc = old_results[old_index_of_id[newDoc._id]];                           // 189
	      projectedNew = projectionFn(newDoc);                                         // 190
	      projectedOld = projectionFn(oldDoc);                                         // 191
	      fields = DiffSequence.makeChangedFields(projectedNew, projectedOld);         // 192
	      if (!_.isEmpty(fields)) {                                                    // 193
	        observer.changed && observer.changed(newDoc._id, fields);                  // 194
	      }                                                                            // 195
	    }                                                                              // 196
	    startOfGroup = endOfGroup+1;                                                   // 197
	  });                                                                              // 198
	                                                                                   // 199
	                                                                                   // 200
	};                                                                                 // 201
	                                                                                   // 202
	                                                                                   // 203
	// General helper for diff-ing two objects.                                        // 204
	// callbacks is an object like so:                                                 // 205
	// { leftOnly: function (key, leftValue) {...},                                    // 206
	//   rightOnly: function (key, rightValue) {...},                                  // 207
	//   both: function (key, leftValue, rightValue) {...},                            // 208
	// }                                                                               // 209
	DiffSequence.diffObjects = function (left, right, callbacks) {                     // 210
	  _.each(left, function (leftValue, key) {                                         // 211
	    if (_.has(right, key))                                                         // 212
	      callbacks.both && callbacks.both(key, leftValue, right[key]);                // 213
	    else                                                                           // 214
	      callbacks.leftOnly && callbacks.leftOnly(key, leftValue);                    // 215
	  });                                                                              // 216
	  if (callbacks.rightOnly) {                                                       // 217
	    _.each(right, function(rightValue, key) {                                      // 218
	      if (!_.has(left, key))                                                       // 219
	        callbacks.rightOnly(key, rightValue);                                      // 220
	    });                                                                            // 221
	  }                                                                                // 222
	};                                                                                 // 223
	                                                                                   // 224
	                                                                                   // 225
	DiffSequence.makeChangedFields = function (newDoc, oldDoc) {                       // 226
	  var fields = {};                                                                 // 227
	  DiffSequence.diffObjects(oldDoc, newDoc, {                                       // 228
	    leftOnly: function (key, value) {                                              // 229
	      fields[key] = undefined;                                                     // 230
	    },                                                                             // 231
	    rightOnly: function (key, value) {                                             // 232
	      fields[key] = value;                                                         // 233
	    },                                                                             // 234
	    both: function (key, leftValue, rightValue) {                                  // 235
	      if (!EJSON.equals(leftValue, rightValue))                                    // 236
	        fields[key] = rightValue;                                                  // 237
	    }                                                                              // 238
	  });                                                                              // 239
	  return fields;                                                                   // 240
	};                                                                                 // 241
	                                                                                   // 242
	DiffSequence.applyChanges = function (doc, changeFields) {                         // 243
	  _.each(changeFields, function (value, key) {                                     // 244
	    if (value === undefined)                                                       // 245
	      delete doc[key];                                                             // 246
	    else                                                                           // 247
	      doc[key] = value;                                                            // 248
	  });                                                                              // 249
	};                                                                                 // 250
	                                                                                   // 251
	                                                                                   // 252
	/////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['diff-sequence'] = {}, {
	  DiffSequence: DiffSequence
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/ecmascript-runtime.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var meteorInstall = Package.modules.meteorInstall;
	var Buffer = Package.modules.Buffer;
	var process = Package.modules.process;
	var Promise = Package.promise.Promise;
	
	/* Package-scope variables */
	var Symbol, Map, Set, __g, __e;
	
	var require = meteorInstall({"node_modules":{"meteor":{"ecmascript-runtime":{"runtime.js":["meteor-ecmascript-runtime",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// packages/ecmascript-runtime/runtime.js                                                                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// TODO Allow just api.mainModule("meteor-ecmascript-runtime");                                                        // 1
	module.exports = require("meteor-ecmascript-runtime");                                                                 // 2
	                                                                                                                       // 3
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"node_modules":{"meteor-ecmascript-runtime":{"package.json":function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// ../../.0.3.15.11wv5mh++os+web.browser+web.cordova/npm/node_modules/meteor-ecmascript-runtime/package.json           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	exports.name = "meteor-ecmascript-runtime";                                                                            // 1
	exports.version = "0.2.9";                                                                                             // 2
	exports.main = "index.js";                                                                                             // 3
	                                                                                                                       // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"index.js":["core-js/es6/object","core-js/es6/array","core-js/es6/string","core-js/es6/function","core-js/fn/array/includes","core-js/fn/object/values","core-js/fn/object/entries","core-js/fn/object/get-own-property-descriptors","core-js/fn/string/pad-start","core-js/fn/string/pad-end","core-js/fn/string/trim-start","core-js/fn/string/trim-end","core-js/es6/symbol","core-js/es6/map","core-js/es6/set",function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/meteor-ecmascript-runtime/index.js                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require("core-js/es6/object");                                                                                         // 1
	require("core-js/es6/array");                                                                                          // 2
	require("core-js/es6/string");                                                                                         // 3
	require("core-js/es6/function");                                                                                       // 4
	require("core-js/fn/array/includes");                                                                                  // 5
	require("core-js/fn/object/values");                                                                                   // 6
	require("core-js/fn/object/entries");                                                                                  // 7
	require("core-js/fn/object/get-own-property-descriptors");                                                             // 8
	require("core-js/fn/string/pad-start");                                                                                // 9
	require("core-js/fn/string/pad-end");                                                                                  // 10
	require("core-js/fn/string/trim-start");                                                                               // 11
	require("core-js/fn/string/trim-end");                                                                                 // 12
	                                                                                                                       // 13
	Symbol = exports.Symbol = global.Symbol ||                                                                             // 14
	  require("core-js/es6/symbol");                                                                                       // 15
	                                                                                                                       // 16
	Map = exports.Map = require("core-js/es6/map");                                                                        // 17
	Set = exports.Set = require("core-js/es6/set");                                                                        // 18
	                                                                                                                       // 19
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]},"core-js":{"es6":{"object.js":["../modules/es6.symbol","../modules/es6.object.create","../modules/es6.object.define-property","../modules/es6.object.define-properties","../modules/es6.object.get-own-property-descriptor","../modules/es6.object.get-prototype-of","../modules/es6.object.keys","../modules/es6.object.get-own-property-names","../modules/es6.object.freeze","../modules/es6.object.seal","../modules/es6.object.prevent-extensions","../modules/es6.object.is-frozen","../modules/es6.object.is-sealed","../modules/es6.object.is-extensible","../modules/es6.object.assign","../modules/es6.object.is","../modules/es6.object.set-prototype-of","../modules/es6.object.to-string","../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/es6/object.js                                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../modules/es6.symbol');                                                                                      // 1
	require('../modules/es6.object.create');                                                                               // 2
	require('../modules/es6.object.define-property');                                                                      // 3
	require('../modules/es6.object.define-properties');                                                                    // 4
	require('../modules/es6.object.get-own-property-descriptor');                                                          // 5
	require('../modules/es6.object.get-prototype-of');                                                                     // 6
	require('../modules/es6.object.keys');                                                                                 // 7
	require('../modules/es6.object.get-own-property-names');                                                               // 8
	require('../modules/es6.object.freeze');                                                                               // 9
	require('../modules/es6.object.seal');                                                                                 // 10
	require('../modules/es6.object.prevent-extensions');                                                                   // 11
	require('../modules/es6.object.is-frozen');                                                                            // 12
	require('../modules/es6.object.is-sealed');                                                                            // 13
	require('../modules/es6.object.is-extensible');                                                                        // 14
	require('../modules/es6.object.assign');                                                                               // 15
	require('../modules/es6.object.is');                                                                                   // 16
	require('../modules/es6.object.set-prototype-of');                                                                     // 17
	require('../modules/es6.object.to-string');                                                                            // 18
	                                                                                                                       // 19
	module.exports = require('../modules/_core').Object;                                                                   // 20
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"array.js":["../modules/es6.string.iterator","../modules/es6.array.is-array","../modules/es6.array.from","../modules/es6.array.of","../modules/es6.array.join","../modules/es6.array.slice","../modules/es6.array.sort","../modules/es6.array.for-each","../modules/es6.array.map","../modules/es6.array.filter","../modules/es6.array.some","../modules/es6.array.every","../modules/es6.array.reduce","../modules/es6.array.reduce-right","../modules/es6.array.index-of","../modules/es6.array.last-index-of","../modules/es6.array.copy-within","../modules/es6.array.fill","../modules/es6.array.find","../modules/es6.array.find-index","../modules/es6.array.species","../modules/es6.array.iterator","../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/es6/array.js                                            //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../modules/es6.string.iterator');                                                                             // 1
	require('../modules/es6.array.is-array');                                                                              // 2
	require('../modules/es6.array.from');                                                                                  // 3
	require('../modules/es6.array.of');                                                                                    // 4
	require('../modules/es6.array.join');                                                                                  // 5
	require('../modules/es6.array.slice');                                                                                 // 6
	require('../modules/es6.array.sort');                                                                                  // 7
	require('../modules/es6.array.for-each');                                                                              // 8
	require('../modules/es6.array.map');                                                                                   // 9
	require('../modules/es6.array.filter');                                                                                // 10
	require('../modules/es6.array.some');                                                                                  // 11
	require('../modules/es6.array.every');                                                                                 // 12
	require('../modules/es6.array.reduce');                                                                                // 13
	require('../modules/es6.array.reduce-right');                                                                          // 14
	require('../modules/es6.array.index-of');                                                                              // 15
	require('../modules/es6.array.last-index-of');                                                                         // 16
	require('../modules/es6.array.copy-within');                                                                           // 17
	require('../modules/es6.array.fill');                                                                                  // 18
	require('../modules/es6.array.find');                                                                                  // 19
	require('../modules/es6.array.find-index');                                                                            // 20
	require('../modules/es6.array.species');                                                                               // 21
	require('../modules/es6.array.iterator');                                                                              // 22
	module.exports = require('../modules/_core').Array;                                                                    // 23
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"string.js":["../modules/es6.string.from-code-point","../modules/es6.string.raw","../modules/es6.string.trim","../modules/es6.string.iterator","../modules/es6.string.code-point-at","../modules/es6.string.ends-with","../modules/es6.string.includes","../modules/es6.string.repeat","../modules/es6.string.starts-with","../modules/es6.string.anchor","../modules/es6.string.big","../modules/es6.string.blink","../modules/es6.string.bold","../modules/es6.string.fixed","../modules/es6.string.fontcolor","../modules/es6.string.fontsize","../modules/es6.string.italics","../modules/es6.string.link","../modules/es6.string.small","../modules/es6.string.strike","../modules/es6.string.sub","../modules/es6.string.sup","../modules/es6.regexp.match","../modules/es6.regexp.replace","../modules/es6.regexp.search","../modules/es6.regexp.split","../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/es6/string.js                                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../modules/es6.string.from-code-point');                                                                      // 1
	require('../modules/es6.string.raw');                                                                                  // 2
	require('../modules/es6.string.trim');                                                                                 // 3
	require('../modules/es6.string.iterator');                                                                             // 4
	require('../modules/es6.string.code-point-at');                                                                        // 5
	require('../modules/es6.string.ends-with');                                                                            // 6
	require('../modules/es6.string.includes');                                                                             // 7
	require('../modules/es6.string.repeat');                                                                               // 8
	require('../modules/es6.string.starts-with');                                                                          // 9
	require('../modules/es6.string.anchor');                                                                               // 10
	require('../modules/es6.string.big');                                                                                  // 11
	require('../modules/es6.string.blink');                                                                                // 12
	require('../modules/es6.string.bold');                                                                                 // 13
	require('../modules/es6.string.fixed');                                                                                // 14
	require('../modules/es6.string.fontcolor');                                                                            // 15
	require('../modules/es6.string.fontsize');                                                                             // 16
	require('../modules/es6.string.italics');                                                                              // 17
	require('../modules/es6.string.link');                                                                                 // 18
	require('../modules/es6.string.small');                                                                                // 19
	require('../modules/es6.string.strike');                                                                               // 20
	require('../modules/es6.string.sub');                                                                                  // 21
	require('../modules/es6.string.sup');                                                                                  // 22
	require('../modules/es6.regexp.match');                                                                                // 23
	require('../modules/es6.regexp.replace');                                                                              // 24
	require('../modules/es6.regexp.search');                                                                               // 25
	require('../modules/es6.regexp.split');                                                                                // 26
	module.exports = require('../modules/_core').String;                                                                   // 27
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"function.js":["../modules/es6.function.bind","../modules/es6.function.name","../modules/es6.function.has-instance","../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/es6/function.js                                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../modules/es6.function.bind');                                                                               // 1
	require('../modules/es6.function.name');                                                                               // 2
	require('../modules/es6.function.has-instance');                                                                       // 3
	module.exports = require('../modules/_core').Function;                                                                 // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"symbol.js":["../modules/es6.symbol","../modules/es6.object.to-string","../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/es6/symbol.js                                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../modules/es6.symbol');                                                                                      // 1
	require('../modules/es6.object.to-string');                                                                            // 2
	module.exports = require('../modules/_core').Symbol;                                                                   // 3
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"map.js":["../modules/es6.object.to-string","../modules/es6.string.iterator","../modules/web.dom.iterable","../modules/es6.map","../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/es6/map.js                                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../modules/es6.object.to-string');                                                                            // 1
	require('../modules/es6.string.iterator');                                                                             // 2
	require('../modules/web.dom.iterable');                                                                                // 3
	require('../modules/es6.map');                                                                                         // 4
	module.exports = require('../modules/_core').Map;                                                                      // 5
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"set.js":["../modules/es6.object.to-string","../modules/es6.string.iterator","../modules/web.dom.iterable","../modules/es6.set","../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/es6/set.js                                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../modules/es6.object.to-string');                                                                            // 1
	require('../modules/es6.string.iterator');                                                                             // 2
	require('../modules/web.dom.iterable');                                                                                // 3
	require('../modules/es6.set');                                                                                         // 4
	module.exports = require('../modules/_core').Set;                                                                      // 5
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]},"modules":{"es6.symbol.js":["./_global","./_has","./_descriptors","./_export","./_redefine","./_meta","./_fails","./_shared","./_set-to-string-tag","./_uid","./_wks","./_wks-ext","./_wks-define","./_keyof","./_enum-keys","./_is-array","./_an-object","./_to-iobject","./_to-primitive","./_property-desc","./_object-create","./_object-gopn-ext","./_object-gopd","./_object-dp","./_object-keys","./_object-gopn","./_object-pie","./_object-gops","./_library","./_hide",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.symbol.js                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// ECMAScript 6 symbols shim                                                                                           // 2
	var global         = require('./_global')                                                                              // 3
	  , has            = require('./_has')                                                                                 // 4
	  , DESCRIPTORS    = require('./_descriptors')                                                                         // 5
	  , $export        = require('./_export')                                                                              // 6
	  , redefine       = require('./_redefine')                                                                            // 7
	  , META           = require('./_meta').KEY                                                                            // 8
	  , $fails         = require('./_fails')                                                                               // 9
	  , shared         = require('./_shared')                                                                              // 10
	  , setToStringTag = require('./_set-to-string-tag')                                                                   // 11
	  , uid            = require('./_uid')                                                                                 // 12
	  , wks            = require('./_wks')                                                                                 // 13
	  , wksExt         = require('./_wks-ext')                                                                             // 14
	  , wksDefine      = require('./_wks-define')                                                                          // 15
	  , keyOf          = require('./_keyof')                                                                               // 16
	  , enumKeys       = require('./_enum-keys')                                                                           // 17
	  , isArray        = require('./_is-array')                                                                            // 18
	  , anObject       = require('./_an-object')                                                                           // 19
	  , toIObject      = require('./_to-iobject')                                                                          // 20
	  , toPrimitive    = require('./_to-primitive')                                                                        // 21
	  , createDesc     = require('./_property-desc')                                                                       // 22
	  , _create        = require('./_object-create')                                                                       // 23
	  , gOPNExt        = require('./_object-gopn-ext')                                                                     // 24
	  , $GOPD          = require('./_object-gopd')                                                                         // 25
	  , $DP            = require('./_object-dp')                                                                           // 26
	  , $keys          = require('./_object-keys')                                                                         // 27
	  , gOPD           = $GOPD.f                                                                                           // 28
	  , dP             = $DP.f                                                                                             // 29
	  , gOPN           = gOPNExt.f                                                                                         // 30
	  , $Symbol        = global.Symbol                                                                                     // 31
	  , $JSON          = global.JSON                                                                                       // 32
	  , _stringify     = $JSON && $JSON.stringify                                                                          // 33
	  , PROTOTYPE      = 'prototype'                                                                                       // 34
	  , HIDDEN         = wks('_hidden')                                                                                    // 35
	  , TO_PRIMITIVE   = wks('toPrimitive')                                                                                // 36
	  , isEnum         = {}.propertyIsEnumerable                                                                           // 37
	  , SymbolRegistry = shared('symbol-registry')                                                                         // 38
	  , AllSymbols     = shared('symbols')                                                                                 // 39
	  , OPSymbols      = shared('op-symbols')                                                                              // 40
	  , ObjectProto    = Object[PROTOTYPE]                                                                                 // 41
	  , USE_NATIVE     = typeof $Symbol == 'function'                                                                      // 42
	  , QObject        = global.QObject;                                                                                   // 43
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173                                      // 44
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;                                         // 45
	                                                                                                                       // 46
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687                                         // 47
	var setSymbolDesc = DESCRIPTORS && $fails(function(){                                                                  // 48
	  return _create(dP({}, 'a', {                                                                                         // 49
	    get: function(){ return dP(this, 'a', {value: 7}).a; }                                                             // 50
	  })).a != 7;                                                                                                          // 51
	}) ? function(it, key, D){                                                                                             // 52
	  var protoDesc = gOPD(ObjectProto, key);                                                                              // 53
	  if(protoDesc)delete ObjectProto[key];                                                                                // 54
	  dP(it, key, D);                                                                                                      // 55
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);                                                  // 56
	} : dP;                                                                                                                // 57
	                                                                                                                       // 58
	var wrap = function(tag){                                                                                              // 59
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);                                                             // 60
	  sym._k = tag;                                                                                                        // 61
	  return sym;                                                                                                          // 62
	};                                                                                                                     // 63
	                                                                                                                       // 64
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){                                       // 65
	  return typeof it == 'symbol';                                                                                        // 66
	} : function(it){                                                                                                      // 67
	  return it instanceof $Symbol;                                                                                        // 68
	};                                                                                                                     // 69
	                                                                                                                       // 70
	var $defineProperty = function defineProperty(it, key, D){                                                             // 71
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);                                                            // 72
	  anObject(it);                                                                                                        // 73
	  key = toPrimitive(key, true);                                                                                        // 74
	  anObject(D);                                                                                                         // 75
	  if(has(AllSymbols, key)){                                                                                            // 76
	    if(!D.enumerable){                                                                                                 // 77
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));                                                           // 78
	      it[HIDDEN][key] = true;                                                                                          // 79
	    } else {                                                                                                           // 80
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;                                                   // 81
	      D = _create(D, {enumerable: createDesc(0, false)});                                                              // 82
	    } return setSymbolDesc(it, key, D);                                                                                // 83
	  } return dP(it, key, D);                                                                                             // 84
	};                                                                                                                     // 85
	var $defineProperties = function defineProperties(it, P){                                                              // 86
	  anObject(it);                                                                                                        // 87
	  var keys = enumKeys(P = toIObject(P))                                                                                // 88
	    , i    = 0                                                                                                         // 89
	    , l = keys.length                                                                                                  // 90
	    , key;                                                                                                             // 91
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);                                                            // 92
	  return it;                                                                                                           // 93
	};                                                                                                                     // 94
	var $create = function create(it, P){                                                                                  // 95
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);                                            // 96
	};                                                                                                                     // 97
	var $propertyIsEnumerable = function propertyIsEnumerable(key){                                                        // 98
	  var E = isEnum.call(this, key = toPrimitive(key, true));                                                             // 99
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;                                // 100
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;           // 101
	};                                                                                                                     // 102
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){                                            // 103
	  it  = toIObject(it);                                                                                                 // 104
	  key = toPrimitive(key, true);                                                                                        // 105
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;                                        // 106
	  var D = gOPD(it, key);                                                                                               // 107
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;                           // 108
	  return D;                                                                                                            // 109
	};                                                                                                                     // 110
	var $getOwnPropertyNames = function getOwnPropertyNames(it){                                                           // 111
	  var names  = gOPN(toIObject(it))                                                                                     // 112
	    , result = []                                                                                                      // 113
	    , i      = 0                                                                                                       // 114
	    , key;                                                                                                             // 115
	  while(names.length > i){                                                                                             // 116
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);                            // 117
	  } return result;                                                                                                     // 118
	};                                                                                                                     // 119
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){                                                       // 120
	  var IS_OP  = it === ObjectProto                                                                                      // 121
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))                                                                 // 122
	    , result = []                                                                                                      // 123
	    , i      = 0                                                                                                       // 124
	    , key;                                                                                                             // 125
	  while(names.length > i){                                                                                             // 126
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);       // 127
	  } return result;                                                                                                     // 128
	};                                                                                                                     // 129
	                                                                                                                       // 130
	// 19.4.1.1 Symbol([description])                                                                                      // 131
	if(!USE_NATIVE){                                                                                                       // 132
	  $Symbol = function Symbol(){                                                                                         // 133
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');                                        // 134
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);                                                    // 135
	    var $set = function(value){                                                                                        // 136
	      if(this === ObjectProto)$set.call(OPSymbols, value);                                                             // 137
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;                                        // 138
	      setSymbolDesc(this, tag, createDesc(1, value));                                                                  // 139
	    };                                                                                                                 // 140
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});                         // 141
	    return wrap(tag);                                                                                                  // 142
	  };                                                                                                                   // 143
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){                                                        // 144
	    return this._k;                                                                                                    // 145
	  });                                                                                                                  // 146
	                                                                                                                       // 147
	  $GOPD.f = $getOwnPropertyDescriptor;                                                                                 // 148
	  $DP.f   = $defineProperty;                                                                                           // 149
	  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;                                                      // 150
	  require('./_object-pie').f  = $propertyIsEnumerable;                                                                 // 151
	  require('./_object-gops').f = $getOwnPropertySymbols;                                                                // 152
	                                                                                                                       // 153
	  if(DESCRIPTORS && !require('./_library')){                                                                           // 154
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);                                        // 155
	  }                                                                                                                    // 156
	                                                                                                                       // 157
	  wksExt.f = function(name){                                                                                           // 158
	    return wrap(wks(name));                                                                                            // 159
	  }                                                                                                                    // 160
	}                                                                                                                      // 161
	                                                                                                                       // 162
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});                                           // 163
	                                                                                                                       // 164
	for(var symbols = (                                                                                                    // 165
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'     // 167
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);                                                           // 168
	                                                                                                                       // 169
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);                               // 170
	                                                                                                                       // 171
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {                                                               // 172
	  // 19.4.2.1 Symbol.for(key)                                                                                          // 173
	  'for': function(key){                                                                                                // 174
	    return has(SymbolRegistry, key += '')                                                                              // 175
	      ? SymbolRegistry[key]                                                                                            // 176
	      : SymbolRegistry[key] = $Symbol(key);                                                                            // 177
	  },                                                                                                                   // 178
	  // 19.4.2.5 Symbol.keyFor(sym)                                                                                       // 179
	  keyFor: function keyFor(key){                                                                                        // 180
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);                                                                // 181
	    throw TypeError(key + ' is not a symbol!');                                                                        // 182
	  },                                                                                                                   // 183
	  useSetter: function(){ setter = true; },                                                                             // 184
	  useSimple: function(){ setter = false; }                                                                             // 185
	});                                                                                                                    // 186
	                                                                                                                       // 187
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {                                                               // 188
	  // 19.1.2.2 Object.create(O [, Properties])                                                                          // 189
	  create: $create,                                                                                                     // 190
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)                                                                  // 191
	  defineProperty: $defineProperty,                                                                                     // 192
	  // 19.1.2.3 Object.defineProperties(O, Properties)                                                                   // 193
	  defineProperties: $defineProperties,                                                                                 // 194
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)                                                                    // 195
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,                                                                 // 196
	  // 19.1.2.7 Object.getOwnPropertyNames(O)                                                                            // 197
	  getOwnPropertyNames: $getOwnPropertyNames,                                                                           // 198
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)                                                                          // 199
	  getOwnPropertySymbols: $getOwnPropertySymbols                                                                        // 200
	});                                                                                                                    // 201
	                                                                                                                       // 202
	// 24.3.2 JSON.stringify(value [, replacer [, space]])                                                                 // 203
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){                                            // 204
	  var S = $Symbol();                                                                                                   // 205
	  // MS Edge converts symbol values to JSON as {}                                                                      // 206
	  // WebKit converts symbol values to JSON as null                                                                     // 207
	  // V8 throws on boxed symbols                                                                                        // 208
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';                   // 209
	})), 'JSON', {                                                                                                         // 210
	  stringify: function stringify(it){                                                                                   // 211
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined                                     // 212
	    var args = [it]                                                                                                    // 213
	      , i    = 1                                                                                                       // 214
	      , replacer, $replacer;                                                                                           // 215
	    while(arguments.length > i)args.push(arguments[i++]);                                                              // 216
	    replacer = args[1];                                                                                                // 217
	    if(typeof replacer == 'function')$replacer = replacer;                                                             // 218
	    if($replacer || !isArray(replacer))replacer = function(key, value){                                                // 219
	      if($replacer)value = $replacer.call(this, key, value);                                                           // 220
	      if(!isSymbol(value))return value;                                                                                // 221
	    };                                                                                                                 // 222
	    args[1] = replacer;                                                                                                // 223
	    return _stringify.apply($JSON, args);                                                                              // 224
	  }                                                                                                                    // 225
	});                                                                                                                    // 226
	                                                                                                                       // 227
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)                                                                      // 228
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);  // 229
	// 19.4.3.5 Symbol.prototype[@@toStringTag]                                                                            // 230
	setToStringTag($Symbol, 'Symbol');                                                                                     // 231
	// 20.2.1.9 Math[@@toStringTag]                                                                                        // 232
	setToStringTag(Math, 'Math', true);                                                                                    // 233
	// 24.3.3 JSON[@@toStringTag]                                                                                          // 234
	setToStringTag(global.JSON, 'JSON', true);                                                                             // 235
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_global.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_global.js                                      //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028                                                // 1
	var global = module.exports = typeof window != 'undefined' && window.Math == Math                                      // 2
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();                       // 3
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef                                                // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_has.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_has.js                                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var hasOwnProperty = {}.hasOwnProperty;                                                                                // 1
	module.exports = function(it, key){                                                                                    // 2
	  return hasOwnProperty.call(it, key);                                                                                 // 3
	};                                                                                                                     // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_descriptors.js":["./_fails",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_descriptors.js                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// Thank's IE8 for his funny defineProperty                                                                            // 1
	module.exports = !require('./_fails')(function(){                                                                      // 2
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;                                        // 3
	});                                                                                                                    // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_fails.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_fails.js                                       //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = function(exec){                                                                                       // 1
	  try {                                                                                                                // 2
	    return !!exec();                                                                                                   // 3
	  } catch(e){                                                                                                          // 4
	    return true;                                                                                                       // 5
	  }                                                                                                                    // 6
	};                                                                                                                     // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_export.js":["./_global","./_core","./_hide","./_redefine","./_ctx",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_export.js                                      //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var global    = require('./_global')                                                                                   // 1
	  , core      = require('./_core')                                                                                     // 2
	  , hide      = require('./_hide')                                                                                     // 3
	  , redefine  = require('./_redefine')                                                                                 // 4
	  , ctx       = require('./_ctx')                                                                                      // 5
	  , PROTOTYPE = 'prototype';                                                                                           // 6
	                                                                                                                       // 7
	var $export = function(type, name, source){                                                                            // 8
	  var IS_FORCED = type & $export.F                                                                                     // 9
	    , IS_GLOBAL = type & $export.G                                                                                     // 10
	    , IS_STATIC = type & $export.S                                                                                     // 11
	    , IS_PROTO  = type & $export.P                                                                                     // 12
	    , IS_BIND   = type & $export.B                                                                                     // 13
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})                                                   // 15
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})                                                      // 16
	    , key, own, out, exp;                                                                                              // 17
	  if(IS_GLOBAL)source = name;                                                                                          // 18
	  for(key in source){                                                                                                  // 19
	    // contains in native                                                                                              // 20
	    own = !IS_FORCED && target && target[key] !== undefined;                                                           // 21
	    // export native or passed                                                                                         // 22
	    out = (own ? target : source)[key];                                                                                // 23
	    // bind timers to global for call from export context                                                              // 24
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;    // 25
	    // extend global                                                                                                   // 26
	    if(target)redefine(target, key, out, type & $export.U);                                                            // 27
	    // export                                                                                                          // 28
	    if(exports[key] != out)hide(exports, key, exp);                                                                    // 29
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;                                                           // 30
	  }                                                                                                                    // 31
	};                                                                                                                     // 32
	global.core = core;                                                                                                    // 33
	// type bitmap                                                                                                         // 34
	$export.F = 1;   // forced                                                                                             // 35
	$export.G = 2;   // global                                                                                             // 36
	$export.S = 4;   // static                                                                                             // 37
	$export.P = 8;   // proto                                                                                              // 38
	$export.B = 16;  // bind                                                                                               // 39
	$export.W = 32;  // wrap                                                                                               // 40
	$export.U = 64;  // safe                                                                                               // 41
	$export.R = 128; // real proto method for `library`                                                                    // 42
	module.exports = $export;                                                                                              // 43
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_core.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_core.js                                        //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var core = module.exports = {version: '2.4.0'};                                                                        // 1
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef                                                  // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_hide.js":["./_object-dp","./_property-desc","./_descriptors",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_hide.js                                        //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var dP         = require('./_object-dp')                                                                               // 1
	  , createDesc = require('./_property-desc');                                                                          // 2
	module.exports = require('./_descriptors') ? function(object, key, value){                                             // 3
	  return dP.f(object, key, createDesc(1, value));                                                                      // 4
	} : function(object, key, value){                                                                                      // 5
	  object[key] = value;                                                                                                 // 6
	  return object;                                                                                                       // 7
	};                                                                                                                     // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-dp.js":["./_an-object","./_ie8-dom-define","./_to-primitive","./_descriptors",function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_object-dp.js                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var anObject       = require('./_an-object')                                                                           // 1
	  , IE8_DOM_DEFINE = require('./_ie8-dom-define')                                                                      // 2
	  , toPrimitive    = require('./_to-primitive')                                                                        // 3
	  , dP             = Object.defineProperty;                                                                            // 4
	                                                                                                                       // 5
	exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes){             // 6
	  anObject(O);                                                                                                         // 7
	  P = toPrimitive(P, true);                                                                                            // 8
	  anObject(Attributes);                                                                                                // 9
	  if(IE8_DOM_DEFINE)try {                                                                                              // 10
	    return dP(O, P, Attributes);                                                                                       // 11
	  } catch(e){ /* empty */ }                                                                                            // 12
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');                           // 13
	  if('value' in Attributes)O[P] = Attributes.value;                                                                    // 14
	  return O;                                                                                                            // 15
	};                                                                                                                     // 16
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_an-object.js":["./_is-object",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_an-object.js                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var isObject = require('./_is-object');                                                                                // 1
	module.exports = function(it){                                                                                         // 2
	  if(!isObject(it))throw TypeError(it + ' is not an object!');                                                         // 3
	  return it;                                                                                                           // 4
	};                                                                                                                     // 5
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_is-object.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_is-object.js                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = function(it){                                                                                         // 1
	  return typeof it === 'object' ? it !== null : typeof it === 'function';                                              // 2
	};                                                                                                                     // 3
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_ie8-dom-define.js":["./_descriptors","./_fails","./_dom-create",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_ie8-dom-define.js                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = !require('./_descriptors') && !require('./_fails')(function(){                                        // 1
	  return Object.defineProperty(require('./_dom-create')('div'), 'a', {get: function(){ return 7; }}).a != 7;           // 2
	});                                                                                                                    // 3
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_dom-create.js":["./_is-object","./_global",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_dom-create.js                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var isObject = require('./_is-object')                                                                                 // 1
	  , document = require('./_global').document                                                                           // 2
	  // in old IE typeof document.createElement is 'object'                                                               // 3
	  , is = isObject(document) && isObject(document.createElement);                                                       // 4
	module.exports = function(it){                                                                                         // 5
	  return is ? document.createElement(it) : {};                                                                         // 6
	};                                                                                                                     // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_to-primitive.js":["./_is-object",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_to-primitive.js                                //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 7.1.1 ToPrimitive(input [, PreferredType])                                                                          // 1
	var isObject = require('./_is-object');                                                                                // 2
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case                                             // 3
	// and the second argument - flag - preferred type is a string                                                         // 4
	module.exports = function(it, S){                                                                                      // 5
	  if(!isObject(it))return it;                                                                                          // 6
	  var fn, val;                                                                                                         // 7
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;                          // 8
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;                                // 9
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;                         // 10
	  throw TypeError("Can't convert object to primitive value");                                                          // 11
	};                                                                                                                     // 12
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_property-desc.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_property-desc.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = function(bitmap, value){                                                                              // 1
	  return {                                                                                                             // 2
	    enumerable  : !(bitmap & 1),                                                                                       // 3
	    configurable: !(bitmap & 2),                                                                                       // 4
	    writable    : !(bitmap & 4),                                                                                       // 5
	    value       : value                                                                                                // 6
	  };                                                                                                                   // 7
	};                                                                                                                     // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_redefine.js":["./_global","./_hide","./_has","./_uid","./_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_redefine.js                                    //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var global    = require('./_global')                                                                                   // 1
	  , hide      = require('./_hide')                                                                                     // 2
	  , has       = require('./_has')                                                                                      // 3
	  , SRC       = require('./_uid')('src')                                                                               // 4
	  , TO_STRING = 'toString'                                                                                             // 5
	  , $toString = Function[TO_STRING]                                                                                    // 6
	  , TPL       = ('' + $toString).split(TO_STRING);                                                                     // 7
	                                                                                                                       // 8
	require('./_core').inspectSource = function(it){                                                                       // 9
	  return $toString.call(it);                                                                                           // 10
	};                                                                                                                     // 11
	                                                                                                                       // 12
	(module.exports = function(O, key, val, safe){                                                                         // 13
	  var isFunction = typeof val == 'function';                                                                           // 14
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);                                                            // 15
	  if(O[key] === val)return;                                                                                            // 16
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));                         // 17
	  if(O === global){                                                                                                    // 18
	    O[key] = val;                                                                                                      // 19
	  } else {                                                                                                             // 20
	    if(!safe){                                                                                                         // 21
	      delete O[key];                                                                                                   // 22
	      hide(O, key, val);                                                                                               // 23
	    } else {                                                                                                           // 24
	      if(O[key])O[key] = val;                                                                                          // 25
	      else hide(O, key, val);                                                                                          // 26
	    }                                                                                                                  // 27
	  }                                                                                                                    // 28
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative        // 29
	})(Function.prototype, TO_STRING, function toString(){                                                                 // 30
	  return typeof this == 'function' && this[SRC] || $toString.call(this);                                               // 31
	});                                                                                                                    // 32
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_uid.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_uid.js                                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var id = 0                                                                                                             // 1
	  , px = Math.random();                                                                                                // 2
	module.exports = function(key){                                                                                        // 3
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));                               // 4
	};                                                                                                                     // 5
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_ctx.js":["./_a-function",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_ctx.js                                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// optional / simple context binding                                                                                   // 1
	var aFunction = require('./_a-function');                                                                              // 2
	module.exports = function(fn, that, length){                                                                           // 3
	  aFunction(fn);                                                                                                       // 4
	  if(that === undefined)return fn;                                                                                     // 5
	  switch(length){                                                                                                      // 6
	    case 1: return function(a){                                                                                        // 7
	      return fn.call(that, a);                                                                                         // 8
	    };                                                                                                                 // 9
	    case 2: return function(a, b){                                                                                     // 10
	      return fn.call(that, a, b);                                                                                      // 11
	    };                                                                                                                 // 12
	    case 3: return function(a, b, c){                                                                                  // 13
	      return fn.call(that, a, b, c);                                                                                   // 14
	    };                                                                                                                 // 15
	  }                                                                                                                    // 16
	  return function(/* ...args */){                                                                                      // 17
	    return fn.apply(that, arguments);                                                                                  // 18
	  };                                                                                                                   // 19
	};                                                                                                                     // 20
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_a-function.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_a-function.js                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = function(it){                                                                                         // 1
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');                                              // 2
	  return it;                                                                                                           // 3
	};                                                                                                                     // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_meta.js":["./_uid","./_is-object","./_has","./_object-dp","./_fails",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_meta.js                                        //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var META     = require('./_uid')('meta')                                                                               // 1
	  , isObject = require('./_is-object')                                                                                 // 2
	  , has      = require('./_has')                                                                                       // 3
	  , setDesc  = require('./_object-dp').f                                                                               // 4
	  , id       = 0;                                                                                                      // 5
	var isExtensible = Object.isExtensible || function(){                                                                  // 6
	  return true;                                                                                                         // 7
	};                                                                                                                     // 8
	var FREEZE = !require('./_fails')(function(){                                                                          // 9
	  return isExtensible(Object.preventExtensions({}));                                                                   // 10
	});                                                                                                                    // 11
	var setMeta = function(it){                                                                                            // 12
	  setDesc(it, META, {value: {                                                                                          // 13
	    i: 'O' + ++id, // object ID                                                                                        // 14
	    w: {}          // weak collections IDs                                                                             // 15
	  }});                                                                                                                 // 16
	};                                                                                                                     // 17
	var fastKey = function(it, create){                                                                                    // 18
	  // return primitive with prefix                                                                                      // 19
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;                       // 20
	  if(!has(it, META)){                                                                                                  // 21
	    // can't set metadata to uncaught frozen object                                                                    // 22
	    if(!isExtensible(it))return 'F';                                                                                   // 23
	    // not necessary to add metadata                                                                                   // 24
	    if(!create)return 'E';                                                                                             // 25
	    // add missing metadata                                                                                            // 26
	    setMeta(it);                                                                                                       // 27
	  // return object ID                                                                                                  // 28
	  } return it[META].i;                                                                                                 // 29
	};                                                                                                                     // 30
	var getWeak = function(it, create){                                                                                    // 31
	  if(!has(it, META)){                                                                                                  // 32
	    // can't set metadata to uncaught frozen object                                                                    // 33
	    if(!isExtensible(it))return true;                                                                                  // 34
	    // not necessary to add metadata                                                                                   // 35
	    if(!create)return false;                                                                                           // 36
	    // add missing metadata                                                                                            // 37
	    setMeta(it);                                                                                                       // 38
	  // return hash weak collections IDs                                                                                  // 39
	  } return it[META].w;                                                                                                 // 40
	};                                                                                                                     // 41
	// add metadata on freeze-family methods calling                                                                       // 42
	var onFreeze = function(it){                                                                                           // 43
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);                                            // 44
	  return it;                                                                                                           // 45
	};                                                                                                                     // 46
	var meta = module.exports = {                                                                                          // 47
	  KEY:      META,                                                                                                      // 48
	  NEED:     false,                                                                                                     // 49
	  fastKey:  fastKey,                                                                                                   // 50
	  getWeak:  getWeak,                                                                                                   // 51
	  onFreeze: onFreeze                                                                                                   // 52
	};                                                                                                                     // 53
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_shared.js":["./_global",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_shared.js                                      //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var global = require('./_global')                                                                                      // 1
	  , SHARED = '__core-js_shared__'                                                                                      // 2
	  , store  = global[SHARED] || (global[SHARED] = {});                                                                  // 3
	module.exports = function(key){                                                                                        // 4
	  return store[key] || (store[key] = {});                                                                              // 5
	};                                                                                                                     // 6
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_set-to-string-tag.js":["./_object-dp","./_has","./_wks",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_set-to-string-tag.js                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var def = require('./_object-dp').f                                                                                    // 1
	  , has = require('./_has')                                                                                            // 2
	  , TAG = require('./_wks')('toStringTag');                                                                            // 3
	                                                                                                                       // 4
	module.exports = function(it, tag, stat){                                                                              // 5
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});                    // 6
	};                                                                                                                     // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_wks.js":["./_shared","./_uid","./_global",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_wks.js                                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var store      = require('./_shared')('wks')                                                                           // 1
	  , uid        = require('./_uid')                                                                                     // 2
	  , Symbol     = require('./_global').Symbol                                                                           // 3
	  , USE_SYMBOL = typeof Symbol == 'function';                                                                          // 4
	                                                                                                                       // 5
	var $exports = module.exports = function(name){                                                                        // 6
	  return store[name] || (store[name] =                                                                                 // 7
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));                                      // 8
	};                                                                                                                     // 9
	                                                                                                                       // 10
	$exports.store = store;                                                                                                // 11
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_wks-ext.js":["./_wks",function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_wks-ext.js                                     //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	exports.f = require('./_wks');                                                                                         // 1
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_wks-define.js":["./_global","./_core","./_library","./_wks-ext","./_object-dp",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_wks-define.js                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var global         = require('./_global')                                                                              // 1
	  , core           = require('./_core')                                                                                // 2
	  , LIBRARY        = require('./_library')                                                                             // 3
	  , wksExt         = require('./_wks-ext')                                                                             // 4
	  , defineProperty = require('./_object-dp').f;                                                                        // 5
	module.exports = function(name){                                                                                       // 6
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});                                     // 7
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});               // 8
	};                                                                                                                     // 9
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_library.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_library.js                                     //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = false;                                                                                                // 1
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_keyof.js":["./_object-keys","./_to-iobject",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_keyof.js                                       //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var getKeys   = require('./_object-keys')                                                                              // 1
	  , toIObject = require('./_to-iobject');                                                                              // 2
	module.exports = function(object, el){                                                                                 // 3
	  var O      = toIObject(object)                                                                                       // 4
	    , keys   = getKeys(O)                                                                                              // 5
	    , length = keys.length                                                                                             // 6
	    , index  = 0                                                                                                       // 7
	    , key;                                                                                                             // 8
	  while(length > index)if(O[key = keys[index++]] === el)return key;                                                    // 9
	};                                                                                                                     // 10
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-keys.js":["./_object-keys-internal","./_enum-bug-keys",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_object-keys.js                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.14 / 15.2.3.14 Object.keys(O)                                                                                // 1
	var $keys       = require('./_object-keys-internal')                                                                   // 2
	  , enumBugKeys = require('./_enum-bug-keys');                                                                         // 3
	                                                                                                                       // 4
	module.exports = Object.keys || function keys(O){                                                                      // 5
	  return $keys(O, enumBugKeys);                                                                                        // 6
	};                                                                                                                     // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-keys-internal.js":["./_has","./_to-iobject","./_array-includes","./_shared-key",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_object-keys-internal.js                        //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var has          = require('./_has')                                                                                   // 1
	  , toIObject    = require('./_to-iobject')                                                                            // 2
	  , arrayIndexOf = require('./_array-includes')(false)                                                                 // 3
	  , IE_PROTO     = require('./_shared-key')('IE_PROTO');                                                               // 4
	                                                                                                                       // 5
	module.exports = function(object, names){                                                                              // 6
	  var O      = toIObject(object)                                                                                       // 7
	    , i      = 0                                                                                                       // 8
	    , result = []                                                                                                      // 9
	    , key;                                                                                                             // 10
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);                                                     // 11
	  // Don't enum bug & hidden keys                                                                                      // 12
	  while(names.length > i)if(has(O, key = names[i++])){                                                                 // 13
	    ~arrayIndexOf(result, key) || result.push(key);                                                                    // 14
	  }                                                                                                                    // 15
	  return result;                                                                                                       // 16
	};                                                                                                                     // 17
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_to-iobject.js":["./_iobject","./_defined",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_to-iobject.js                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// to indexed object, toObject with fallback for non-array-like ES3 strings                                            // 1
	var IObject = require('./_iobject')                                                                                    // 2
	  , defined = require('./_defined');                                                                                   // 3
	module.exports = function(it){                                                                                         // 4
	  return IObject(defined(it));                                                                                         // 5
	};                                                                                                                     // 6
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_iobject.js":["./_cof",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_iobject.js                                     //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// fallback for non-array-like ES3 and non-enumerable old V8 strings                                                   // 1
	var cof = require('./_cof');                                                                                           // 2
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){                                          // 3
	  return cof(it) == 'String' ? it.split('') : Object(it);                                                              // 4
	};                                                                                                                     // 5
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_cof.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_cof.js                                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var toString = {}.toString;                                                                                            // 1
	                                                                                                                       // 2
	module.exports = function(it){                                                                                         // 3
	  return toString.call(it).slice(8, -1);                                                                               // 4
	};                                                                                                                     // 5
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_defined.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_defined.js                                     //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 7.2.1 RequireObjectCoercible(argument)                                                                              // 1
	module.exports = function(it){                                                                                         // 2
	  if(it == undefined)throw TypeError("Can't call method on  " + it);                                                   // 3
	  return it;                                                                                                           // 4
	};                                                                                                                     // 5
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_array-includes.js":["./_to-iobject","./_to-length","./_to-index",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_array-includes.js                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// false -> Array#indexOf                                                                                              // 1
	// true  -> Array#includes                                                                                             // 2
	var toIObject = require('./_to-iobject')                                                                               // 3
	  , toLength  = require('./_to-length')                                                                                // 4
	  , toIndex   = require('./_to-index');                                                                                // 5
	module.exports = function(IS_INCLUDES){                                                                                // 6
	  return function($this, el, fromIndex){                                                                               // 7
	    var O      = toIObject($this)                                                                                      // 8
	      , length = toLength(O.length)                                                                                    // 9
	      , index  = toIndex(fromIndex, length)                                                                            // 10
	      , value;                                                                                                         // 11
	    // Array#includes uses SameValueZero equality algorithm                                                            // 12
	    if(IS_INCLUDES && el != el)while(length > index){                                                                  // 13
	      value = O[index++];                                                                                              // 14
	      if(value != value)return true;                                                                                   // 15
	    // Array#toIndex ignores holes, Array#includes - not                                                               // 16
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){                                                 // 17
	      if(O[index] === el)return IS_INCLUDES || index || 0;                                                             // 18
	    } return !IS_INCLUDES && -1;                                                                                       // 19
	  };                                                                                                                   // 20
	};                                                                                                                     // 21
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_to-length.js":["./_to-integer",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_to-length.js                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 7.1.15 ToLength                                                                                                     // 1
	var toInteger = require('./_to-integer')                                                                               // 2
	  , min       = Math.min;                                                                                              // 3
	module.exports = function(it){                                                                                         // 4
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991                      // 5
	};                                                                                                                     // 6
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_to-integer.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_to-integer.js                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 7.1.4 ToInteger                                                                                                     // 1
	var ceil  = Math.ceil                                                                                                  // 2
	  , floor = Math.floor;                                                                                                // 3
	module.exports = function(it){                                                                                         // 4
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);                                                            // 5
	};                                                                                                                     // 6
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_to-index.js":["./_to-integer",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_to-index.js                                    //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var toInteger = require('./_to-integer')                                                                               // 1
	  , max       = Math.max                                                                                               // 2
	  , min       = Math.min;                                                                                              // 3
	module.exports = function(index, length){                                                                              // 4
	  index = toInteger(index);                                                                                            // 5
	  return index < 0 ? max(index + length, 0) : min(index, length);                                                      // 6
	};                                                                                                                     // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_shared-key.js":["./_shared","./_uid",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_shared-key.js                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var shared = require('./_shared')('keys')                                                                              // 1
	  , uid    = require('./_uid');                                                                                        // 2
	module.exports = function(key){                                                                                        // 3
	  return shared[key] || (shared[key] = uid(key));                                                                      // 4
	};                                                                                                                     // 5
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_enum-bug-keys.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_enum-bug-keys.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// IE 8- don't enum bug keys                                                                                           // 1
	module.exports = (                                                                                                     // 2
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'                      // 3
	).split(',');                                                                                                          // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_enum-keys.js":["./_object-keys","./_object-gops","./_object-pie",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_enum-keys.js                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// all enumerable object keys, includes symbols                                                                        // 1
	var getKeys = require('./_object-keys')                                                                                // 2
	  , gOPS    = require('./_object-gops')                                                                                // 3
	  , pIE     = require('./_object-pie');                                                                                // 4
	module.exports = function(it){                                                                                         // 5
	  var result     = getKeys(it)                                                                                         // 6
	    , getSymbols = gOPS.f;                                                                                             // 7
	  if(getSymbols){                                                                                                      // 8
	    var symbols = getSymbols(it)                                                                                       // 9
	      , isEnum  = pIE.f                                                                                                // 10
	      , i       = 0                                                                                                    // 11
	      , key;                                                                                                           // 12
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);                                  // 13
	  } return result;                                                                                                     // 14
	};                                                                                                                     // 15
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-gops.js":function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_object-gops.js                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	exports.f = Object.getOwnPropertySymbols;                                                                              // 1
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_object-pie.js":function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_object-pie.js                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	exports.f = {}.propertyIsEnumerable;                                                                                   // 1
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_is-array.js":["./_cof",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_is-array.js                                    //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 7.2.2 IsArray(argument)                                                                                             // 1
	var cof = require('./_cof');                                                                                           // 2
	module.exports = Array.isArray || function isArray(arg){                                                               // 3
	  return cof(arg) == 'Array';                                                                                          // 4
	};                                                                                                                     // 5
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-create.js":["./_an-object","./_object-dps","./_enum-bug-keys","./_shared-key","./_dom-create","./_html",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_object-create.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])                                                                 // 1
	var anObject    = require('./_an-object')                                                                              // 2
	  , dPs         = require('./_object-dps')                                                                             // 3
	  , enumBugKeys = require('./_enum-bug-keys')                                                                          // 4
	  , IE_PROTO    = require('./_shared-key')('IE_PROTO')                                                                 // 5
	  , Empty       = function(){ /* empty */ }                                                                            // 6
	  , PROTOTYPE   = 'prototype';                                                                                         // 7
	                                                                                                                       // 8
	// Create object with fake `null` prototype: use iframe Object with cleared prototype                                  // 9
	var createDict = function(){                                                                                           // 10
	  // Thrash, waste and sodomy: IE GC bug                                                                               // 11
	  var iframe = require('./_dom-create')('iframe')                                                                      // 12
	    , i      = enumBugKeys.length                                                                                      // 13
	    , lt     = '<'                                                                                                     // 14
	    , gt     = '>'                                                                                                     // 15
	    , iframeDocument;                                                                                                  // 16
	  iframe.style.display = 'none';                                                                                       // 17
	  require('./_html').appendChild(iframe);                                                                              // 18
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url                                                     // 19
	  // createDict = iframe.contentWindow.Object;                                                                         // 20
	  // html.removeChild(iframe);                                                                                         // 21
	  iframeDocument = iframe.contentWindow.document;                                                                      // 22
	  iframeDocument.open();                                                                                               // 23
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);                                // 24
	  iframeDocument.close();                                                                                              // 25
	  createDict = iframeDocument.F;                                                                                       // 26
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];                                                              // 27
	  return createDict();                                                                                                 // 28
	};                                                                                                                     // 29
	                                                                                                                       // 30
	module.exports = Object.create || function create(O, Properties){                                                      // 31
	  var result;                                                                                                          // 32
	  if(O !== null){                                                                                                      // 33
	    Empty[PROTOTYPE] = anObject(O);                                                                                    // 34
	    result = new Empty;                                                                                                // 35
	    Empty[PROTOTYPE] = null;                                                                                           // 36
	    // add "__proto__" for Object.getPrototypeOf polyfill                                                              // 37
	    result[IE_PROTO] = O;                                                                                              // 38
	  } else result = createDict();                                                                                        // 39
	  return Properties === undefined ? result : dPs(result, Properties);                                                  // 40
	};                                                                                                                     // 41
	                                                                                                                       // 42
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-dps.js":["./_object-dp","./_an-object","./_object-keys","./_descriptors",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_object-dps.js                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var dP       = require('./_object-dp')                                                                                 // 1
	  , anObject = require('./_an-object')                                                                                 // 2
	  , getKeys  = require('./_object-keys');                                                                              // 3
	                                                                                                                       // 4
	module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties){       // 5
	  anObject(O);                                                                                                         // 6
	  var keys   = getKeys(Properties)                                                                                     // 7
	    , length = keys.length                                                                                             // 8
	    , i = 0                                                                                                            // 9
	    , P;                                                                                                               // 10
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);                                                              // 11
	  return O;                                                                                                            // 12
	};                                                                                                                     // 13
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_html.js":["./_global",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_html.js                                        //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = require('./_global').document && document.documentElement;                                            // 1
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-gopn-ext.js":["./_to-iobject","./_object-gopn",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_object-gopn-ext.js                             //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window                                           // 1
	var toIObject = require('./_to-iobject')                                                                               // 2
	  , gOPN      = require('./_object-gopn').f                                                                            // 3
	  , toString  = {}.toString;                                                                                           // 4
	                                                                                                                       // 5
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames                                    // 6
	  ? Object.getOwnPropertyNames(window) : [];                                                                           // 7
	                                                                                                                       // 8
	var getWindowNames = function(it){                                                                                     // 9
	  try {                                                                                                                // 10
	    return gOPN(it);                                                                                                   // 11
	  } catch(e){                                                                                                          // 12
	    return windowNames.slice();                                                                                        // 13
	  }                                                                                                                    // 14
	};                                                                                                                     // 15
	                                                                                                                       // 16
	module.exports.f = function getOwnPropertyNames(it){                                                                   // 17
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));             // 18
	};                                                                                                                     // 19
	                                                                                                                       // 20
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-gopn.js":["./_object-keys-internal","./_enum-bug-keys",function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_object-gopn.js                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)                                                                   // 1
	var $keys      = require('./_object-keys-internal')                                                                    // 2
	  , hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');                                            // 3
	                                                                                                                       // 4
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){                                             // 5
	  return $keys(O, hiddenKeys);                                                                                         // 6
	};                                                                                                                     // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-gopd.js":["./_object-pie","./_property-desc","./_to-iobject","./_to-primitive","./_has","./_ie8-dom-define","./_descriptors",function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_object-gopd.js                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var pIE            = require('./_object-pie')                                                                          // 1
	  , createDesc     = require('./_property-desc')                                                                       // 2
	  , toIObject      = require('./_to-iobject')                                                                          // 3
	  , toPrimitive    = require('./_to-primitive')                                                                        // 4
	  , has            = require('./_has')                                                                                 // 5
	  , IE8_DOM_DEFINE = require('./_ie8-dom-define')                                                                      // 6
	  , gOPD           = Object.getOwnPropertyDescriptor;                                                                  // 7
	                                                                                                                       // 8
	exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P){                                // 9
	  O = toIObject(O);                                                                                                    // 10
	  P = toPrimitive(P, true);                                                                                            // 11
	  if(IE8_DOM_DEFINE)try {                                                                                              // 12
	    return gOPD(O, P);                                                                                                 // 13
	  } catch(e){ /* empty */ }                                                                                            // 14
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);                                                             // 15
	};                                                                                                                     // 16
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.create.js":["./_export","./_object-create",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.object.create.js                            //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var $export = require('./_export')                                                                                     // 1
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])                                                                 // 2
	$export($export.S, 'Object', {create: require('./_object-create')});                                                   // 3
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.define-property.js":["./_export","./_descriptors","./_object-dp",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.object.define-property.js                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var $export = require('./_export');                                                                                    // 1
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)                                                         // 2
	$export($export.S + $export.F * !require('./_descriptors'), 'Object', {defineProperty: require('./_object-dp').f});    // 3
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.define-properties.js":["./_export","./_descriptors","./_object-dps",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.object.define-properties.js                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var $export = require('./_export');                                                                                    // 1
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)                                                          // 2
	$export($export.S + $export.F * !require('./_descriptors'), 'Object', {defineProperties: require('./_object-dps')});   // 3
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.get-own-property-descriptor.js":["./_to-iobject","./_object-gopd","./_object-sap",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.object.get-own-property-descriptor.js       //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)                                                                      // 1
	var toIObject                 = require('./_to-iobject')                                                               // 2
	  , $getOwnPropertyDescriptor = require('./_object-gopd').f;                                                           // 3
	                                                                                                                       // 4
	require('./_object-sap')('getOwnPropertyDescriptor', function(){                                                       // 5
	  return function getOwnPropertyDescriptor(it, key){                                                                   // 6
	    return $getOwnPropertyDescriptor(toIObject(it), key);                                                              // 7
	  };                                                                                                                   // 8
	});                                                                                                                    // 9
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-sap.js":["./_export","./_core","./_fails",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_object-sap.js                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// most Object methods by ES6 should accept primitives                                                                 // 1
	var $export = require('./_export')                                                                                     // 2
	  , core    = require('./_core')                                                                                       // 3
	  , fails   = require('./_fails');                                                                                     // 4
	module.exports = function(KEY, exec){                                                                                  // 5
	  var fn  = (core.Object || {})[KEY] || Object[KEY]                                                                    // 6
	    , exp = {};                                                                                                        // 7
	  exp[KEY] = exec(fn);                                                                                                 // 8
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);                                         // 9
	};                                                                                                                     // 10
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.get-prototype-of.js":["./_to-object","./_object-gpo","./_object-sap",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.object.get-prototype-of.js                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.9 Object.getPrototypeOf(O)                                                                                   // 1
	var toObject        = require('./_to-object')                                                                          // 2
	  , $getPrototypeOf = require('./_object-gpo');                                                                        // 3
	                                                                                                                       // 4
	require('./_object-sap')('getPrototypeOf', function(){                                                                 // 5
	  return function getPrototypeOf(it){                                                                                  // 6
	    return $getPrototypeOf(toObject(it));                                                                              // 7
	  };                                                                                                                   // 8
	});                                                                                                                    // 9
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_to-object.js":["./_defined",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_to-object.js                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 7.1.13 ToObject(argument)                                                                                           // 1
	var defined = require('./_defined');                                                                                   // 2
	module.exports = function(it){                                                                                         // 3
	  return Object(defined(it));                                                                                          // 4
	};                                                                                                                     // 5
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-gpo.js":["./_has","./_to-object","./_shared-key",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_object-gpo.js                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)                                                                        // 1
	var has         = require('./_has')                                                                                    // 2
	  , toObject    = require('./_to-object')                                                                              // 3
	  , IE_PROTO    = require('./_shared-key')('IE_PROTO')                                                                 // 4
	  , ObjectProto = Object.prototype;                                                                                    // 5
	                                                                                                                       // 6
	module.exports = Object.getPrototypeOf || function(O){                                                                 // 7
	  O = toObject(O);                                                                                                     // 8
	  if(has(O, IE_PROTO))return O[IE_PROTO];                                                                              // 9
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){                                                // 10
	    return O.constructor.prototype;                                                                                    // 11
	  } return O instanceof Object ? ObjectProto : null;                                                                   // 12
	};                                                                                                                     // 13
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.keys.js":["./_to-object","./_object-keys","./_object-sap",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.object.keys.js                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.14 Object.keys(O)                                                                                            // 1
	var toObject = require('./_to-object')                                                                                 // 2
	  , $keys    = require('./_object-keys');                                                                              // 3
	                                                                                                                       // 4
	require('./_object-sap')('keys', function(){                                                                           // 5
	  return function keys(it){                                                                                            // 6
	    return $keys(toObject(it));                                                                                        // 7
	  };                                                                                                                   // 8
	});                                                                                                                    // 9
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.get-own-property-names.js":["./_object-sap","./_object-gopn-ext",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.object.get-own-property-names.js            //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.7 Object.getOwnPropertyNames(O)                                                                              // 1
	require('./_object-sap')('getOwnPropertyNames', function(){                                                            // 2
	  return require('./_object-gopn-ext').f;                                                                              // 3
	});                                                                                                                    // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.freeze.js":["./_is-object","./_meta","./_object-sap",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.object.freeze.js                            //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.5 Object.freeze(O)                                                                                           // 1
	var isObject = require('./_is-object')                                                                                 // 2
	  , meta     = require('./_meta').onFreeze;                                                                            // 3
	                                                                                                                       // 4
	require('./_object-sap')('freeze', function($freeze){                                                                  // 5
	  return function freeze(it){                                                                                          // 6
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;                                                           // 7
	  };                                                                                                                   // 8
	});                                                                                                                    // 9
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.seal.js":["./_is-object","./_meta","./_object-sap",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.object.seal.js                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.17 Object.seal(O)                                                                                            // 1
	var isObject = require('./_is-object')                                                                                 // 2
	  , meta     = require('./_meta').onFreeze;                                                                            // 3
	                                                                                                                       // 4
	require('./_object-sap')('seal', function($seal){                                                                      // 5
	  return function seal(it){                                                                                            // 6
	    return $seal && isObject(it) ? $seal(meta(it)) : it;                                                               // 7
	  };                                                                                                                   // 8
	});                                                                                                                    // 9
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.prevent-extensions.js":["./_is-object","./_meta","./_object-sap",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.object.prevent-extensions.js                //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.15 Object.preventExtensions(O)                                                                               // 1
	var isObject = require('./_is-object')                                                                                 // 2
	  , meta     = require('./_meta').onFreeze;                                                                            // 3
	                                                                                                                       // 4
	require('./_object-sap')('preventExtensions', function($preventExtensions){                                            // 5
	  return function preventExtensions(it){                                                                               // 6
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;                                     // 7
	  };                                                                                                                   // 8
	});                                                                                                                    // 9
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.is-frozen.js":["./_is-object","./_object-sap",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.object.is-frozen.js                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.12 Object.isFrozen(O)                                                                                        // 1
	var isObject = require('./_is-object');                                                                                // 2
	                                                                                                                       // 3
	require('./_object-sap')('isFrozen', function($isFrozen){                                                              // 4
	  return function isFrozen(it){                                                                                        // 5
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;                                                    // 6
	  };                                                                                                                   // 7
	});                                                                                                                    // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.is-sealed.js":["./_is-object","./_object-sap",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.object.is-sealed.js                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.13 Object.isSealed(O)                                                                                        // 1
	var isObject = require('./_is-object');                                                                                // 2
	                                                                                                                       // 3
	require('./_object-sap')('isSealed', function($isSealed){                                                              // 4
	  return function isSealed(it){                                                                                        // 5
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;                                                    // 6
	  };                                                                                                                   // 7
	});                                                                                                                    // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.is-extensible.js":["./_is-object","./_object-sap",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.object.is-extensible.js                     //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.11 Object.isExtensible(O)                                                                                    // 1
	var isObject = require('./_is-object');                                                                                // 2
	                                                                                                                       // 3
	require('./_object-sap')('isExtensible', function($isExtensible){                                                      // 4
	  return function isExtensible(it){                                                                                    // 5
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;                                            // 6
	  };                                                                                                                   // 7
	});                                                                                                                    // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.assign.js":["./_export","./_object-assign",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.object.assign.js                            //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.3.1 Object.assign(target, source)                                                                              // 1
	var $export = require('./_export');                                                                                    // 2
	                                                                                                                       // 3
	$export($export.S + $export.F, 'Object', {assign: require('./_object-assign')});                                       // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-assign.js":["./_object-keys","./_object-gops","./_object-pie","./_to-object","./_iobject","./_fails",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_object-assign.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// 19.1.2.1 Object.assign(target, source, ...)                                                                         // 2
	var getKeys  = require('./_object-keys')                                                                               // 3
	  , gOPS     = require('./_object-gops')                                                                               // 4
	  , pIE      = require('./_object-pie')                                                                                // 5
	  , toObject = require('./_to-object')                                                                                 // 6
	  , IObject  = require('./_iobject')                                                                                   // 7
	  , $assign  = Object.assign;                                                                                          // 8
	                                                                                                                       // 9
	// should work with symbols and should have deterministic property order (V8 bug)                                      // 10
	module.exports = !$assign || require('./_fails')(function(){                                                           // 11
	  var A = {}                                                                                                           // 12
	    , B = {}                                                                                                           // 13
	    , S = Symbol()                                                                                                     // 14
	    , K = 'abcdefghijklmnopqrst';                                                                                      // 15
	  A[S] = 7;                                                                                                            // 16
	  K.split('').forEach(function(k){ B[k] = k; });                                                                       // 17
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;                                          // 18
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars                                            // 19
	  var T     = toObject(target)                                                                                         // 20
	    , aLen  = arguments.length                                                                                         // 21
	    , index = 1                                                                                                        // 22
	    , getSymbols = gOPS.f                                                                                              // 23
	    , isEnum     = pIE.f;                                                                                              // 24
	  while(aLen > index){                                                                                                 // 25
	    var S      = IObject(arguments[index++])                                                                           // 26
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)                                            // 27
	      , length = keys.length                                                                                           // 28
	      , j      = 0                                                                                                     // 29
	      , key;                                                                                                           // 30
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];                                               // 31
	  } return T;                                                                                                          // 32
	} : $assign;                                                                                                           // 33
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.is.js":["./_export","./_same-value",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.object.is.js                                //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.3.10 Object.is(value1, value2)                                                                                 // 1
	var $export = require('./_export');                                                                                    // 2
	$export($export.S, 'Object', {is: require('./_same-value')});                                                          // 3
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_same-value.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_same-value.js                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 7.2.9 SameValue(x, y)                                                                                               // 1
	module.exports = Object.is || function is(x, y){                                                                       // 2
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;                                                      // 3
	};                                                                                                                     // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"es6.object.set-prototype-of.js":["./_export","./_set-proto",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.object.set-prototype-of.js                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.3.19 Object.setPrototypeOf(O, proto)                                                                           // 1
	var $export = require('./_export');                                                                                    // 2
	$export($export.S, 'Object', {setPrototypeOf: require('./_set-proto').set});                                           // 3
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_set-proto.js":["./_is-object","./_an-object","./_ctx","./_object-gopd",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_set-proto.js                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// Works with __proto__ only. Old v8 can't work with null proto objects.                                               // 1
	/* eslint-disable no-proto */                                                                                          // 2
	var isObject = require('./_is-object')                                                                                 // 3
	  , anObject = require('./_an-object');                                                                                // 4
	var check = function(O, proto){                                                                                        // 5
	  anObject(O);                                                                                                         // 6
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");                          // 7
	};                                                                                                                     // 8
	module.exports = {                                                                                                     // 9
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line                                            // 10
	    function(test, buggy, set){                                                                                        // 11
	      try {                                                                                                            // 12
	        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);     // 13
	        set(test, []);                                                                                                 // 14
	        buggy = !(test instanceof Array);                                                                              // 15
	      } catch(e){ buggy = true; }                                                                                      // 16
	      return function setPrototypeOf(O, proto){                                                                        // 17
	        check(O, proto);                                                                                               // 18
	        if(buggy)O.__proto__ = proto;                                                                                  // 19
	        else set(O, proto);                                                                                            // 20
	        return O;                                                                                                      // 21
	      };                                                                                                               // 22
	    }({}, false) : undefined),                                                                                         // 23
	  check: check                                                                                                         // 24
	};                                                                                                                     // 25
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.to-string.js":["./_classof","./_wks","./_redefine",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.object.to-string.js                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// 19.1.3.6 Object.prototype.toString()                                                                                // 2
	var classof = require('./_classof')                                                                                    // 3
	  , test    = {};                                                                                                      // 4
	test[require('./_wks')('toStringTag')] = 'z';                                                                          // 5
	if(test + '' != '[object z]'){                                                                                         // 6
	  require('./_redefine')(Object.prototype, 'toString', function toString(){                                            // 7
	    return '[object ' + classof(this) + ']';                                                                           // 8
	  }, true);                                                                                                            // 9
	}                                                                                                                      // 10
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_classof.js":["./_cof","./_wks",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_classof.js                                     //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// getting tag from 19.1.3.6 Object.prototype.toString()                                                               // 1
	var cof = require('./_cof')                                                                                            // 2
	  , TAG = require('./_wks')('toStringTag')                                                                             // 3
	  // ES3 wrong here                                                                                                    // 4
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';                                                       // 5
	                                                                                                                       // 6
	// fallback for IE11 Script Access Denied error                                                                        // 7
	var tryGet = function(it, key){                                                                                        // 8
	  try {                                                                                                                // 9
	    return it[key];                                                                                                    // 10
	  } catch(e){ /* empty */ }                                                                                            // 11
	};                                                                                                                     // 12
	                                                                                                                       // 13
	module.exports = function(it){                                                                                         // 14
	  var O, T, B;                                                                                                         // 15
	  return it === undefined ? 'Undefined' : it === null ? 'Null'                                                         // 16
	    // @@toStringTag case                                                                                              // 17
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T                                                         // 18
	    // builtinTag case                                                                                                 // 19
	    : ARG ? cof(O)                                                                                                     // 20
	    // ES3 arguments fallback                                                                                          // 21
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;                                     // 22
	};                                                                                                                     // 23
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.iterator.js":["./_string-at","./_iter-define",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.iterator.js                          //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var $at  = require('./_string-at')(true);                                                                              // 2
	                                                                                                                       // 3
	// 21.1.3.27 String.prototype[@@iterator]()                                                                            // 4
	require('./_iter-define')(String, 'String', function(iterated){                                                        // 5
	  this._t = String(iterated); // target                                                                                // 6
	  this._i = 0;                // next index                                                                            // 7
	// 21.1.5.2.1 %StringIteratorPrototype%.next()                                                                         // 8
	}, function(){                                                                                                         // 9
	  var O     = this._t                                                                                                  // 10
	    , index = this._i                                                                                                  // 11
	    , point;                                                                                                           // 12
	  if(index >= O.length)return {value: undefined, done: true};                                                          // 13
	  point = $at(O, index);                                                                                               // 14
	  this._i += point.length;                                                                                             // 15
	  return {value: point, done: false};                                                                                  // 16
	});                                                                                                                    // 17
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_string-at.js":["./_to-integer","./_defined",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_string-at.js                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var toInteger = require('./_to-integer')                                                                               // 1
	  , defined   = require('./_defined');                                                                                 // 2
	// true  -> String#at                                                                                                  // 3
	// false -> String#codePointAt                                                                                         // 4
	module.exports = function(TO_STRING){                                                                                  // 5
	  return function(that, pos){                                                                                          // 6
	    var s = String(defined(that))                                                                                      // 7
	      , i = toInteger(pos)                                                                                             // 8
	      , l = s.length                                                                                                   // 9
	      , a, b;                                                                                                          // 10
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;                                                              // 11
	    a = s.charCodeAt(i);                                                                                               // 12
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff                 // 13
	      ? TO_STRING ? s.charAt(i) : a                                                                                    // 14
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;                                   // 15
	  };                                                                                                                   // 16
	};                                                                                                                     // 17
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_iter-define.js":["./_library","./_export","./_redefine","./_hide","./_has","./_iterators","./_iter-create","./_set-to-string-tag","./_object-gpo","./_wks",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_iter-define.js                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var LIBRARY        = require('./_library')                                                                             // 2
	  , $export        = require('./_export')                                                                              // 3
	  , redefine       = require('./_redefine')                                                                            // 4
	  , hide           = require('./_hide')                                                                                // 5
	  , has            = require('./_has')                                                                                 // 6
	  , Iterators      = require('./_iterators')                                                                           // 7
	  , $iterCreate    = require('./_iter-create')                                                                         // 8
	  , setToStringTag = require('./_set-to-string-tag')                                                                   // 9
	  , getPrototypeOf = require('./_object-gpo')                                                                          // 10
	  , ITERATOR       = require('./_wks')('iterator')                                                                     // 11
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`                        // 12
	  , FF_ITERATOR    = '@@iterator'                                                                                      // 13
	  , KEYS           = 'keys'                                                                                            // 14
	  , VALUES         = 'values';                                                                                         // 15
	                                                                                                                       // 16
	var returnThis = function(){ return this; };                                                                           // 17
	                                                                                                                       // 18
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){                                     // 19
	  $iterCreate(Constructor, NAME, next);                                                                                // 20
	  var getMethod = function(kind){                                                                                      // 21
	    if(!BUGGY && kind in proto)return proto[kind];                                                                     // 22
	    switch(kind){                                                                                                      // 23
	      case KEYS: return function keys(){ return new Constructor(this, kind); };                                        // 24
	      case VALUES: return function values(){ return new Constructor(this, kind); };                                    // 25
	    } return function entries(){ return new Constructor(this, kind); };                                                // 26
	  };                                                                                                                   // 27
	  var TAG        = NAME + ' Iterator'                                                                                  // 28
	    , DEF_VALUES = DEFAULT == VALUES                                                                                   // 29
	    , VALUES_BUG = false                                                                                               // 30
	    , proto      = Base.prototype                                                                                      // 31
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]                                  // 32
	    , $default   = $native || getMethod(DEFAULT)                                                                       // 33
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined                                 // 34
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native                                                // 35
	    , methods, key, IteratorPrototype;                                                                                 // 36
	  // Fix native                                                                                                        // 37
	  if($anyNative){                                                                                                      // 38
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));                                                     // 39
	    if(IteratorPrototype !== Object.prototype){                                                                        // 40
	      // Set @@toStringTag to native iterators                                                                         // 41
	      setToStringTag(IteratorPrototype, TAG, true);                                                                    // 42
	      // fix for some old engines                                                                                      // 43
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);                  // 44
	    }                                                                                                                  // 45
	  }                                                                                                                    // 46
	  // fix Array#{values, @@iterator}.name in V8 / FF                                                                    // 47
	  if(DEF_VALUES && $native && $native.name !== VALUES){                                                                // 48
	    VALUES_BUG = true;                                                                                                 // 49
	    $default = function values(){ return $native.call(this); };                                                        // 50
	  }                                                                                                                    // 51
	  // Define iterator                                                                                                   // 52
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){                                               // 53
	    hide(proto, ITERATOR, $default);                                                                                   // 54
	  }                                                                                                                    // 55
	  // Plug for library                                                                                                  // 56
	  Iterators[NAME] = $default;                                                                                          // 57
	  Iterators[TAG]  = returnThis;                                                                                        // 58
	  if(DEFAULT){                                                                                                         // 59
	    methods = {                                                                                                        // 60
	      values:  DEF_VALUES ? $default : getMethod(VALUES),                                                              // 61
	      keys:    IS_SET     ? $default : getMethod(KEYS),                                                                // 62
	      entries: $entries                                                                                                // 63
	    };                                                                                                                 // 64
	    if(FORCED)for(key in methods){                                                                                     // 65
	      if(!(key in proto))redefine(proto, key, methods[key]);                                                           // 66
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);                                      // 67
	  }                                                                                                                    // 68
	  return methods;                                                                                                      // 69
	};                                                                                                                     // 70
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_iterators.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_iterators.js                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = {};                                                                                                   // 1
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_iter-create.js":["./_object-create","./_property-desc","./_set-to-string-tag","./_hide","./_wks",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_iter-create.js                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var create         = require('./_object-create')                                                                       // 2
	  , descriptor     = require('./_property-desc')                                                                       // 3
	  , setToStringTag = require('./_set-to-string-tag')                                                                   // 4
	  , IteratorPrototype = {};                                                                                            // 5
	                                                                                                                       // 6
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()                                                                        // 7
	require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function(){ return this; });                      // 8
	                                                                                                                       // 9
	module.exports = function(Constructor, NAME, next){                                                                    // 10
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});                                      // 11
	  setToStringTag(Constructor, NAME + ' Iterator');                                                                     // 12
	};                                                                                                                     // 13
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.is-array.js":["./_export","./_is-array",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.is-array.js                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)                                                                              // 1
	var $export = require('./_export');                                                                                    // 2
	                                                                                                                       // 3
	$export($export.S, 'Array', {isArray: require('./_is-array')});                                                        // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.from.js":["./_ctx","./_export","./_to-object","./_iter-call","./_is-array-iter","./_to-length","./_create-property","./core.get-iterator-method","./_iter-detect",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.from.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var ctx            = require('./_ctx')                                                                                 // 2
	  , $export        = require('./_export')                                                                              // 3
	  , toObject       = require('./_to-object')                                                                           // 4
	  , call           = require('./_iter-call')                                                                           // 5
	  , isArrayIter    = require('./_is-array-iter')                                                                       // 6
	  , toLength       = require('./_to-length')                                                                           // 7
	  , createProperty = require('./_create-property')                                                                     // 8
	  , getIterFn      = require('./core.get-iterator-method');                                                            // 9
	                                                                                                                       // 10
	$export($export.S + $export.F * !require('./_iter-detect')(function(iter){ Array.from(iter); }), 'Array', {            // 11
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)                                            // 12
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){                                          // 13
	    var O       = toObject(arrayLike)                                                                                  // 14
	      , C       = typeof this == 'function' ? this : Array                                                             // 15
	      , aLen    = arguments.length                                                                                     // 16
	      , mapfn   = aLen > 1 ? arguments[1] : undefined                                                                  // 17
	      , mapping = mapfn !== undefined                                                                                  // 18
	      , index   = 0                                                                                                    // 19
	      , iterFn  = getIterFn(O)                                                                                         // 20
	      , length, result, step, iterator;                                                                                // 21
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);                                             // 22
	    // if object isn't iterable or it's array with default iterator - use simple case                                  // 23
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){                                                   // 24
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){                         // 25
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);        // 26
	      }                                                                                                                // 27
	    } else {                                                                                                           // 28
	      length = toLength(O.length);                                                                                     // 29
	      for(result = new C(length); length > index; index++){                                                            // 30
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);                                    // 31
	      }                                                                                                                // 32
	    }                                                                                                                  // 33
	    result.length = index;                                                                                             // 34
	    return result;                                                                                                     // 35
	  }                                                                                                                    // 36
	});                                                                                                                    // 37
	                                                                                                                       // 38
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_iter-call.js":["./_an-object",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_iter-call.js                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// call something on iterator step with safe closing on error                                                          // 1
	var anObject = require('./_an-object');                                                                                // 2
	module.exports = function(iterator, fn, value, entries){                                                               // 3
	  try {                                                                                                                // 4
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);                                                     // 5
	  // 7.4.6 IteratorClose(iterator, completion)                                                                         // 6
	  } catch(e){                                                                                                          // 7
	    var ret = iterator['return'];                                                                                      // 8
	    if(ret !== undefined)anObject(ret.call(iterator));                                                                 // 9
	    throw e;                                                                                                           // 10
	  }                                                                                                                    // 11
	};                                                                                                                     // 12
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_is-array-iter.js":["./_iterators","./_wks",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_is-array-iter.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// check on default Array iterator                                                                                     // 1
	var Iterators  = require('./_iterators')                                                                               // 2
	  , ITERATOR   = require('./_wks')('iterator')                                                                         // 3
	  , ArrayProto = Array.prototype;                                                                                      // 4
	                                                                                                                       // 5
	module.exports = function(it){                                                                                         // 6
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);                                  // 7
	};                                                                                                                     // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_create-property.js":["./_object-dp","./_property-desc",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_create-property.js                             //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var $defineProperty = require('./_object-dp')                                                                          // 2
	  , createDesc      = require('./_property-desc');                                                                     // 3
	                                                                                                                       // 4
	module.exports = function(object, index, value){                                                                       // 5
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));                                           // 6
	  else object[index] = value;                                                                                          // 7
	};                                                                                                                     // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"core.get-iterator-method.js":["./_classof","./_wks","./_iterators","./_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/core.get-iterator-method.js                     //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var classof   = require('./_classof')                                                                                  // 1
	  , ITERATOR  = require('./_wks')('iterator')                                                                          // 2
	  , Iterators = require('./_iterators');                                                                               // 3
	module.exports = require('./_core').getIteratorMethod = function(it){                                                  // 4
	  if(it != undefined)return it[ITERATOR]                                                                               // 5
	    || it['@@iterator']                                                                                                // 6
	    || Iterators[classof(it)];                                                                                         // 7
	};                                                                                                                     // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_iter-detect.js":["./_wks",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_iter-detect.js                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var ITERATOR     = require('./_wks')('iterator')                                                                       // 1
	  , SAFE_CLOSING = false;                                                                                              // 2
	                                                                                                                       // 3
	try {                                                                                                                  // 4
	  var riter = [7][ITERATOR]();                                                                                         // 5
	  riter['return'] = function(){ SAFE_CLOSING = true; };                                                                // 6
	  Array.from(riter, function(){ throw 2; });                                                                           // 7
	} catch(e){ /* empty */ }                                                                                              // 8
	                                                                                                                       // 9
	module.exports = function(exec, skipClosing){                                                                          // 10
	  if(!skipClosing && !SAFE_CLOSING)return false;                                                                       // 11
	  var safe = false;                                                                                                    // 12
	  try {                                                                                                                // 13
	    var arr  = [7]                                                                                                     // 14
	      , iter = arr[ITERATOR]();                                                                                        // 15
	    iter.next = function(){ return {done: safe = true}; };                                                             // 16
	    arr[ITERATOR] = function(){ return iter; };                                                                        // 17
	    exec(arr);                                                                                                         // 18
	  } catch(e){ /* empty */ }                                                                                            // 19
	  return safe;                                                                                                         // 20
	};                                                                                                                     // 21
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.of.js":["./_export","./_create-property","./_fails",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.of.js                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var $export        = require('./_export')                                                                              // 2
	  , createProperty = require('./_create-property');                                                                    // 3
	                                                                                                                       // 4
	// WebKit Array.of isn't generic                                                                                       // 5
	$export($export.S + $export.F * require('./_fails')(function(){                                                        // 6
	  function F(){}                                                                                                       // 7
	  return !(Array.of.call(F) instanceof F);                                                                             // 8
	}), 'Array', {                                                                                                         // 9
	  // 22.1.2.3 Array.of( ...items)                                                                                      // 10
	  of: function of(/* ...args */){                                                                                      // 11
	    var index  = 0                                                                                                     // 12
	      , aLen   = arguments.length                                                                                      // 13
	      , result = new (typeof this == 'function' ? this : Array)(aLen);                                                 // 14
	    while(aLen > index)createProperty(result, index, arguments[index++]);                                              // 15
	    result.length = aLen;                                                                                              // 16
	    return result;                                                                                                     // 17
	  }                                                                                                                    // 18
	});                                                                                                                    // 19
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.join.js":["./_export","./_to-iobject","./_iobject","./_strict-method",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.join.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// 22.1.3.13 Array.prototype.join(separator)                                                                           // 2
	var $export   = require('./_export')                                                                                   // 3
	  , toIObject = require('./_to-iobject')                                                                               // 4
	  , arrayJoin = [].join;                                                                                               // 5
	                                                                                                                       // 6
	// fallback for not array-like strings                                                                                 // 7
	$export($export.P + $export.F * (require('./_iobject') != Object || !require('./_strict-method')(arrayJoin)), 'Array', {
	  join: function join(separator){                                                                                      // 9
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);                                 // 10
	  }                                                                                                                    // 11
	});                                                                                                                    // 12
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_strict-method.js":["./_fails",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_strict-method.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var fails = require('./_fails');                                                                                       // 1
	                                                                                                                       // 2
	module.exports = function(method, arg){                                                                                // 3
	  return !!method && fails(function(){                                                                                 // 4
	    arg ? method.call(null, function(){}, 1) : method.call(null);                                                      // 5
	  });                                                                                                                  // 6
	};                                                                                                                     // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.slice.js":["./_export","./_html","./_cof","./_to-index","./_to-length","./_fails",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.slice.js                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var $export    = require('./_export')                                                                                  // 2
	  , html       = require('./_html')                                                                                    // 3
	  , cof        = require('./_cof')                                                                                     // 4
	  , toIndex    = require('./_to-index')                                                                                // 5
	  , toLength   = require('./_to-length')                                                                               // 6
	  , arraySlice = [].slice;                                                                                             // 7
	                                                                                                                       // 8
	// fallback for not array-like ES3 strings and DOM objects                                                             // 9
	$export($export.P + $export.F * require('./_fails')(function(){                                                        // 10
	  if(html)arraySlice.call(html);                                                                                       // 11
	}), 'Array', {                                                                                                         // 12
	  slice: function slice(begin, end){                                                                                   // 13
	    var len   = toLength(this.length)                                                                                  // 14
	      , klass = cof(this);                                                                                             // 15
	    end = end === undefined ? len : end;                                                                               // 16
	    if(klass == 'Array')return arraySlice.call(this, begin, end);                                                      // 17
	    var start  = toIndex(begin, len)                                                                                   // 18
	      , upTo   = toIndex(end, len)                                                                                     // 19
	      , size   = toLength(upTo - start)                                                                                // 20
	      , cloned = Array(size)                                                                                           // 21
	      , i      = 0;                                                                                                    // 22
	    for(; i < size; i++)cloned[i] = klass == 'String'                                                                  // 23
	      ? this.charAt(start + i)                                                                                         // 24
	      : this[start + i];                                                                                               // 25
	    return cloned;                                                                                                     // 26
	  }                                                                                                                    // 27
	});                                                                                                                    // 28
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.sort.js":["./_export","./_a-function","./_to-object","./_fails","./_strict-method",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.sort.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var $export   = require('./_export')                                                                                   // 2
	  , aFunction = require('./_a-function')                                                                               // 3
	  , toObject  = require('./_to-object')                                                                                // 4
	  , fails     = require('./_fails')                                                                                    // 5
	  , $sort     = [].sort                                                                                                // 6
	  , test      = [1, 2, 3];                                                                                             // 7
	                                                                                                                       // 8
	$export($export.P + $export.F * (fails(function(){                                                                     // 9
	  // IE8-                                                                                                              // 10
	  test.sort(undefined);                                                                                                // 11
	}) || !fails(function(){                                                                                               // 12
	  // V8 bug                                                                                                            // 13
	  test.sort(null);                                                                                                     // 14
	  // Old WebKit                                                                                                        // 15
	}) || !require('./_strict-method')($sort)), 'Array', {                                                                 // 16
	  // 22.1.3.25 Array.prototype.sort(comparefn)                                                                         // 17
	  sort: function sort(comparefn){                                                                                      // 18
	    return comparefn === undefined                                                                                     // 19
	      ? $sort.call(toObject(this))                                                                                     // 20
	      : $sort.call(toObject(this), aFunction(comparefn));                                                              // 21
	  }                                                                                                                    // 22
	});                                                                                                                    // 23
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.for-each.js":["./_export","./_array-methods","./_strict-method",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.for-each.js                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var $export  = require('./_export')                                                                                    // 2
	  , $forEach = require('./_array-methods')(0)                                                                          // 3
	  , STRICT   = require('./_strict-method')([].forEach, true);                                                          // 4
	                                                                                                                       // 5
	$export($export.P + $export.F * !STRICT, 'Array', {                                                                    // 6
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])                                             // 7
	  forEach: function forEach(callbackfn /* , thisArg */){                                                               // 8
	    return $forEach(this, callbackfn, arguments[1]);                                                                   // 9
	  }                                                                                                                    // 10
	});                                                                                                                    // 11
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_array-methods.js":["./_ctx","./_iobject","./_to-object","./_to-length","./_array-species-create",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_array-methods.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 0 -> Array#forEach                                                                                                  // 1
	// 1 -> Array#map                                                                                                      // 2
	// 2 -> Array#filter                                                                                                   // 3
	// 3 -> Array#some                                                                                                     // 4
	// 4 -> Array#every                                                                                                    // 5
	// 5 -> Array#find                                                                                                     // 6
	// 6 -> Array#findIndex                                                                                                // 7
	var ctx      = require('./_ctx')                                                                                       // 8
	  , IObject  = require('./_iobject')                                                                                   // 9
	  , toObject = require('./_to-object')                                                                                 // 10
	  , toLength = require('./_to-length')                                                                                 // 11
	  , asc      = require('./_array-species-create');                                                                     // 12
	module.exports = function(TYPE, $create){                                                                              // 13
	  var IS_MAP        = TYPE == 1                                                                                        // 14
	    , IS_FILTER     = TYPE == 2                                                                                        // 15
	    , IS_SOME       = TYPE == 3                                                                                        // 16
	    , IS_EVERY      = TYPE == 4                                                                                        // 17
	    , IS_FIND_INDEX = TYPE == 6                                                                                        // 18
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX                                                                       // 19
	    , create        = $create || asc;                                                                                  // 20
	  return function($this, callbackfn, that){                                                                            // 21
	    var O      = toObject($this)                                                                                       // 22
	      , self   = IObject(O)                                                                                            // 23
	      , f      = ctx(callbackfn, that, 3)                                                                              // 24
	      , length = toLength(self.length)                                                                                 // 25
	      , index  = 0                                                                                                     // 26
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined                             // 27
	      , val, res;                                                                                                      // 28
	    for(;length > index; index++)if(NO_HOLES || index in self){                                                        // 29
	      val = self[index];                                                                                               // 30
	      res = f(val, index, O);                                                                                          // 31
	      if(TYPE){                                                                                                        // 32
	        if(IS_MAP)result[index] = res;            // map                                                               // 33
	        else if(res)switch(TYPE){                                                                                      // 34
	          case 3: return true;                    // some                                                              // 35
	          case 5: return val;                     // find                                                              // 36
	          case 6: return index;                   // findIndex                                                         // 37
	          case 2: result.push(val);               // filter                                                            // 38
	        } else if(IS_EVERY)return false;          // every                                                             // 39
	      }                                                                                                                // 40
	    }                                                                                                                  // 41
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;                                               // 42
	  };                                                                                                                   // 43
	};                                                                                                                     // 44
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_array-species-create.js":["./_array-species-constructor",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_array-species-create.js                        //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)                                                                   // 1
	var speciesConstructor = require('./_array-species-constructor');                                                      // 2
	                                                                                                                       // 3
	module.exports = function(original, length){                                                                           // 4
	  return new (speciesConstructor(original))(length);                                                                   // 5
	};                                                                                                                     // 6
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_array-species-constructor.js":["./_is-object","./_is-array","./_wks",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_array-species-constructor.js                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var isObject = require('./_is-object')                                                                                 // 1
	  , isArray  = require('./_is-array')                                                                                  // 2
	  , SPECIES  = require('./_wks')('species');                                                                           // 3
	                                                                                                                       // 4
	module.exports = function(original){                                                                                   // 5
	  var C;                                                                                                               // 6
	  if(isArray(original)){                                                                                               // 7
	    C = original.constructor;                                                                                          // 8
	    // cross-realm fallback                                                                                            // 9
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;                                  // 10
	    if(isObject(C)){                                                                                                   // 11
	      C = C[SPECIES];                                                                                                  // 12
	      if(C === null)C = undefined;                                                                                     // 13
	    }                                                                                                                  // 14
	  } return C === undefined ? Array : C;                                                                                // 15
	};                                                                                                                     // 16
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.map.js":["./_export","./_array-methods","./_strict-method",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.map.js                                //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var $export = require('./_export')                                                                                     // 2
	  , $map    = require('./_array-methods')(1);                                                                          // 3
	                                                                                                                       // 4
	$export($export.P + $export.F * !require('./_strict-method')([].map, true), 'Array', {                                 // 5
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])                                                 // 6
	  map: function map(callbackfn /* , thisArg */){                                                                       // 7
	    return $map(this, callbackfn, arguments[1]);                                                                       // 8
	  }                                                                                                                    // 9
	});                                                                                                                    // 10
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.filter.js":["./_export","./_array-methods","./_strict-method",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.filter.js                             //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var $export = require('./_export')                                                                                     // 2
	  , $filter = require('./_array-methods')(2);                                                                          // 3
	                                                                                                                       // 4
	$export($export.P + $export.F * !require('./_strict-method')([].filter, true), 'Array', {                              // 5
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])                                               // 6
	  filter: function filter(callbackfn /* , thisArg */){                                                                 // 7
	    return $filter(this, callbackfn, arguments[1]);                                                                    // 8
	  }                                                                                                                    // 9
	});                                                                                                                    // 10
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.some.js":["./_export","./_array-methods","./_strict-method",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.some.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var $export = require('./_export')                                                                                     // 2
	  , $some   = require('./_array-methods')(3);                                                                          // 3
	                                                                                                                       // 4
	$export($export.P + $export.F * !require('./_strict-method')([].some, true), 'Array', {                                // 5
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])                                                // 6
	  some: function some(callbackfn /* , thisArg */){                                                                     // 7
	    return $some(this, callbackfn, arguments[1]);                                                                      // 8
	  }                                                                                                                    // 9
	});                                                                                                                    // 10
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.every.js":["./_export","./_array-methods","./_strict-method",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.every.js                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var $export = require('./_export')                                                                                     // 2
	  , $every  = require('./_array-methods')(4);                                                                          // 3
	                                                                                                                       // 4
	$export($export.P + $export.F * !require('./_strict-method')([].every, true), 'Array', {                               // 5
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])                                                // 6
	  every: function every(callbackfn /* , thisArg */){                                                                   // 7
	    return $every(this, callbackfn, arguments[1]);                                                                     // 8
	  }                                                                                                                    // 9
	});                                                                                                                    // 10
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.reduce.js":["./_export","./_array-reduce","./_strict-method",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.reduce.js                             //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var $export = require('./_export')                                                                                     // 2
	  , $reduce = require('./_array-reduce');                                                                              // 3
	                                                                                                                       // 4
	$export($export.P + $export.F * !require('./_strict-method')([].reduce, true), 'Array', {                              // 5
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])                                         // 6
	  reduce: function reduce(callbackfn /* , initialValue */){                                                            // 7
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);                                           // 8
	  }                                                                                                                    // 9
	});                                                                                                                    // 10
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_array-reduce.js":["./_a-function","./_to-object","./_iobject","./_to-length",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_array-reduce.js                                //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var aFunction = require('./_a-function')                                                                               // 1
	  , toObject  = require('./_to-object')                                                                                // 2
	  , IObject   = require('./_iobject')                                                                                  // 3
	  , toLength  = require('./_to-length');                                                                               // 4
	                                                                                                                       // 5
	module.exports = function(that, callbackfn, aLen, memo, isRight){                                                      // 6
	  aFunction(callbackfn);                                                                                               // 7
	  var O      = toObject(that)                                                                                          // 8
	    , self   = IObject(O)                                                                                              // 9
	    , length = toLength(O.length)                                                                                      // 10
	    , index  = isRight ? length - 1 : 0                                                                                // 11
	    , i      = isRight ? -1 : 1;                                                                                       // 12
	  if(aLen < 2)for(;;){                                                                                                 // 13
	    if(index in self){                                                                                                 // 14
	      memo = self[index];                                                                                              // 15
	      index += i;                                                                                                      // 16
	      break;                                                                                                           // 17
	    }                                                                                                                  // 18
	    index += i;                                                                                                        // 19
	    if(isRight ? index < 0 : length <= index){                                                                         // 20
	      throw TypeError('Reduce of empty array with no initial value');                                                  // 21
	    }                                                                                                                  // 22
	  }                                                                                                                    // 23
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){                                            // 24
	    memo = callbackfn(memo, self[index], index, O);                                                                    // 25
	  }                                                                                                                    // 26
	  return memo;                                                                                                         // 27
	};                                                                                                                     // 28
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.reduce-right.js":["./_export","./_array-reduce","./_strict-method",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.reduce-right.js                       //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var $export = require('./_export')                                                                                     // 2
	  , $reduce = require('./_array-reduce');                                                                              // 3
	                                                                                                                       // 4
	$export($export.P + $export.F * !require('./_strict-method')([].reduceRight, true), 'Array', {                         // 5
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])                                    // 6
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){                                                  // 7
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);                                            // 8
	  }                                                                                                                    // 9
	});                                                                                                                    // 10
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.index-of.js":["./_export","./_array-includes","./_strict-method",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.index-of.js                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var $export       = require('./_export')                                                                               // 2
	  , $indexOf      = require('./_array-includes')(false)                                                                // 3
	  , $native       = [].indexOf                                                                                         // 4
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;                                                           // 5
	                                                                                                                       // 6
	$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {                   // 7
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])                                        // 8
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){                                                       // 9
	    return NEGATIVE_ZERO                                                                                               // 10
	      // convert -0 to +0                                                                                              // 11
	      ? $native.apply(this, arguments) || 0                                                                            // 12
	      : $indexOf(this, searchElement, arguments[1]);                                                                   // 13
	  }                                                                                                                    // 14
	});                                                                                                                    // 15
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.last-index-of.js":["./_export","./_to-iobject","./_to-integer","./_to-length","./_strict-method",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.last-index-of.js                      //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var $export       = require('./_export')                                                                               // 2
	  , toIObject     = require('./_to-iobject')                                                                           // 3
	  , toInteger     = require('./_to-integer')                                                                           // 4
	  , toLength      = require('./_to-length')                                                                            // 5
	  , $native       = [].lastIndexOf                                                                                     // 6
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;                                                       // 7
	                                                                                                                       // 8
	$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {                   // 9
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])                                    // 10
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){                                          // 11
	    // convert -0 to +0                                                                                                // 12
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;                                                       // 13
	    var O      = toIObject(this)                                                                                       // 14
	      , length = toLength(O.length)                                                                                    // 15
	      , index  = length - 1;                                                                                           // 16
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));                                          // 17
	    if(index < 0)index = length + index;                                                                               // 18
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;                            // 19
	    return -1;                                                                                                         // 20
	  }                                                                                                                    // 21
	});                                                                                                                    // 22
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.copy-within.js":["./_export","./_array-copy-within","./_add-to-unscopables",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.copy-within.js                        //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)                                               // 1
	var $export = require('./_export');                                                                                    // 2
	                                                                                                                       // 3
	$export($export.P, 'Array', {copyWithin: require('./_array-copy-within')});                                            // 4
	                                                                                                                       // 5
	require('./_add-to-unscopables')('copyWithin');                                                                        // 6
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_array-copy-within.js":["./_to-object","./_to-index","./_to-length",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_array-copy-within.js                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)                                               // 1
	'use strict';                                                                                                          // 2
	var toObject = require('./_to-object')                                                                                 // 3
	  , toIndex  = require('./_to-index')                                                                                  // 4
	  , toLength = require('./_to-length');                                                                                // 5
	                                                                                                                       // 6
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){                     // 7
	  var O     = toObject(this)                                                                                           // 8
	    , len   = toLength(O.length)                                                                                       // 9
	    , to    = toIndex(target, len)                                                                                     // 10
	    , from  = toIndex(start, len)                                                                                      // 11
	    , end   = arguments.length > 2 ? arguments[2] : undefined                                                          // 12
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)                                 // 13
	    , inc   = 1;                                                                                                       // 14
	  if(from < to && to < from + count){                                                                                  // 15
	    inc  = -1;                                                                                                         // 16
	    from += count - 1;                                                                                                 // 17
	    to   += count - 1;                                                                                                 // 18
	  }                                                                                                                    // 19
	  while(count-- > 0){                                                                                                  // 20
	    if(from in O)O[to] = O[from];                                                                                      // 21
	    else delete O[to];                                                                                                 // 22
	    to   += inc;                                                                                                       // 23
	    from += inc;                                                                                                       // 24
	  } return O;                                                                                                          // 25
	};                                                                                                                     // 26
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_add-to-unscopables.js":["./_wks","./_hide",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_add-to-unscopables.js                          //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 22.1.3.31 Array.prototype[@@unscopables]                                                                            // 1
	var UNSCOPABLES = require('./_wks')('unscopables')                                                                     // 2
	  , ArrayProto  = Array.prototype;                                                                                     // 3
	if(ArrayProto[UNSCOPABLES] == undefined)require('./_hide')(ArrayProto, UNSCOPABLES, {});                               // 4
	module.exports = function(key){                                                                                        // 5
	  ArrayProto[UNSCOPABLES][key] = true;                                                                                 // 6
	};                                                                                                                     // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.fill.js":["./_export","./_array-fill","./_add-to-unscopables",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.fill.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)                                                  // 1
	var $export = require('./_export');                                                                                    // 2
	                                                                                                                       // 3
	$export($export.P, 'Array', {fill: require('./_array-fill')});                                                         // 4
	                                                                                                                       // 5
	require('./_add-to-unscopables')('fill');                                                                              // 6
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_array-fill.js":["./_to-object","./_to-index","./_to-length",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_array-fill.js                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)                                                  // 1
	'use strict';                                                                                                          // 2
	var toObject = require('./_to-object')                                                                                 // 3
	  , toIndex  = require('./_to-index')                                                                                  // 4
	  , toLength = require('./_to-length');                                                                                // 5
	module.exports = function fill(value /*, start = 0, end = @length */){                                                 // 6
	  var O      = toObject(this)                                                                                          // 7
	    , length = toLength(O.length)                                                                                      // 8
	    , aLen   = arguments.length                                                                                        // 9
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)                                                    // 10
	    , end    = aLen > 2 ? arguments[2] : undefined                                                                     // 11
	    , endPos = end === undefined ? length : toIndex(end, length);                                                      // 12
	  while(endPos > index)O[index++] = value;                                                                             // 13
	  return O;                                                                                                            // 14
	};                                                                                                                     // 15
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.find.js":["./_export","./_array-methods","./_add-to-unscopables",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.find.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)                                                       // 2
	var $export = require('./_export')                                                                                     // 3
	  , $find   = require('./_array-methods')(5)                                                                           // 4
	  , KEY     = 'find'                                                                                                   // 5
	  , forced  = true;                                                                                                    // 6
	// Shouldn't skip holes                                                                                                // 7
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });                                                             // 8
	$export($export.P + $export.F * forced, 'Array', {                                                                     // 9
	  find: function find(callbackfn/*, that = undefined */){                                                              // 10
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);                                   // 11
	  }                                                                                                                    // 12
	});                                                                                                                    // 13
	require('./_add-to-unscopables')(KEY);                                                                                 // 14
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.find-index.js":["./_export","./_array-methods","./_add-to-unscopables",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.find-index.js                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)                                                  // 2
	var $export = require('./_export')                                                                                     // 3
	  , $find   = require('./_array-methods')(6)                                                                           // 4
	  , KEY     = 'findIndex'                                                                                              // 5
	  , forced  = true;                                                                                                    // 6
	// Shouldn't skip holes                                                                                                // 7
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });                                                             // 8
	$export($export.P + $export.F * forced, 'Array', {                                                                     // 9
	  findIndex: function findIndex(callbackfn/*, that = undefined */){                                                    // 10
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);                                   // 11
	  }                                                                                                                    // 12
	});                                                                                                                    // 13
	require('./_add-to-unscopables')(KEY);                                                                                 // 14
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.species.js":["./_set-species",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.species.js                            //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('./_set-species')('Array');                                                                                    // 1
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_set-species.js":["./_global","./_object-dp","./_descriptors","./_wks",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_set-species.js                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var global      = require('./_global')                                                                                 // 2
	  , dP          = require('./_object-dp')                                                                              // 3
	  , DESCRIPTORS = require('./_descriptors')                                                                            // 4
	  , SPECIES     = require('./_wks')('species');                                                                        // 5
	                                                                                                                       // 6
	module.exports = function(KEY){                                                                                        // 7
	  var C = global[KEY];                                                                                                 // 8
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {                                                                // 9
	    configurable: true,                                                                                                // 10
	    get: function(){ return this; }                                                                                    // 11
	  });                                                                                                                  // 12
	};                                                                                                                     // 13
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.iterator.js":["./_add-to-unscopables","./_iter-step","./_iterators","./_to-iobject","./_iter-define",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.array.iterator.js                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var addToUnscopables = require('./_add-to-unscopables')                                                                // 2
	  , step             = require('./_iter-step')                                                                         // 3
	  , Iterators        = require('./_iterators')                                                                         // 4
	  , toIObject        = require('./_to-iobject');                                                                       // 5
	                                                                                                                       // 6
	// 22.1.3.4 Array.prototype.entries()                                                                                  // 7
	// 22.1.3.13 Array.prototype.keys()                                                                                    // 8
	// 22.1.3.29 Array.prototype.values()                                                                                  // 9
	// 22.1.3.30 Array.prototype[@@iterator]()                                                                             // 10
	module.exports = require('./_iter-define')(Array, 'Array', function(iterated, kind){                                   // 11
	  this._t = toIObject(iterated); // target                                                                             // 12
	  this._i = 0;                   // next index                                                                         // 13
	  this._k = kind;                // kind                                                                               // 14
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()                                                                          // 15
	}, function(){                                                                                                         // 16
	  var O     = this._t                                                                                                  // 17
	    , kind  = this._k                                                                                                  // 18
	    , index = this._i++;                                                                                               // 19
	  if(!O || index >= O.length){                                                                                         // 20
	    this._t = undefined;                                                                                               // 21
	    return step(1);                                                                                                    // 22
	  }                                                                                                                    // 23
	  if(kind == 'keys'  )return step(0, index);                                                                           // 24
	  if(kind == 'values')return step(0, O[index]);                                                                        // 25
	  return step(0, [index, O[index]]);                                                                                   // 26
	}, 'values');                                                                                                          // 27
	                                                                                                                       // 28
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)                                                 // 29
	Iterators.Arguments = Iterators.Array;                                                                                 // 30
	                                                                                                                       // 31
	addToUnscopables('keys');                                                                                              // 32
	addToUnscopables('values');                                                                                            // 33
	addToUnscopables('entries');                                                                                           // 34
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_iter-step.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_iter-step.js                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = function(done, value){                                                                                // 1
	  return {value: value, done: !!done};                                                                                 // 2
	};                                                                                                                     // 3
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"es6.string.from-code-point.js":["./_export","./_to-index",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.from-code-point.js                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var $export        = require('./_export')                                                                              // 1
	  , toIndex        = require('./_to-index')                                                                            // 2
	  , fromCharCode   = String.fromCharCode                                                                               // 3
	  , $fromCodePoint = String.fromCodePoint;                                                                             // 4
	                                                                                                                       // 5
	// length should be 1, old FF problem                                                                                  // 6
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {                          // 7
	  // 21.1.2.2 String.fromCodePoint(...codePoints)                                                                      // 8
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars                                      // 9
	    var res  = []                                                                                                      // 10
	      , aLen = arguments.length                                                                                        // 11
	      , i    = 0                                                                                                       // 12
	      , code;                                                                                                          // 13
	    while(aLen > i){                                                                                                   // 14
	      code = +arguments[i++];                                                                                          // 15
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');                       // 16
	      res.push(code < 0x10000                                                                                          // 17
	        ? fromCharCode(code)                                                                                           // 18
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)                                      // 19
	      );                                                                                                               // 20
	    } return res.join('');                                                                                             // 21
	  }                                                                                                                    // 22
	});                                                                                                                    // 23
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.raw.js":["./_export","./_to-iobject","./_to-length",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.raw.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var $export   = require('./_export')                                                                                   // 1
	  , toIObject = require('./_to-iobject')                                                                               // 2
	  , toLength  = require('./_to-length');                                                                               // 3
	                                                                                                                       // 4
	$export($export.S, 'String', {                                                                                         // 5
	  // 21.1.2.4 String.raw(callSite, ...substitutions)                                                                   // 6
	  raw: function raw(callSite){                                                                                         // 7
	    var tpl  = toIObject(callSite.raw)                                                                                 // 8
	      , len  = toLength(tpl.length)                                                                                    // 9
	      , aLen = arguments.length                                                                                        // 10
	      , res  = []                                                                                                      // 11
	      , i    = 0;                                                                                                      // 12
	    while(len > i){                                                                                                    // 13
	      res.push(String(tpl[i++]));                                                                                      // 14
	      if(i < aLen)res.push(String(arguments[i]));                                                                      // 15
	    } return res.join('');                                                                                             // 16
	  }                                                                                                                    // 17
	});                                                                                                                    // 18
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.trim.js":["./_string-trim",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.trim.js                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// 21.1.3.25 String.prototype.trim()                                                                                   // 2
	require('./_string-trim')('trim', function($trim){                                                                     // 3
	  return function trim(){                                                                                              // 4
	    return $trim(this, 3);                                                                                             // 5
	  };                                                                                                                   // 6
	});                                                                                                                    // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_string-trim.js":["./_export","./_defined","./_fails","./_string-ws",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_string-trim.js                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var $export = require('./_export')                                                                                     // 1
	  , defined = require('./_defined')                                                                                    // 2
	  , fails   = require('./_fails')                                                                                      // 3
	  , spaces  = require('./_string-ws')                                                                                  // 4
	  , space   = '[' + spaces + ']'                                                                                       // 5
	  , non     = '\u200b\u0085'                                                                                           // 6
	  , ltrim   = RegExp('^' + space + space + '*')                                                                        // 7
	  , rtrim   = RegExp(space + space + '*$');                                                                            // 8
	                                                                                                                       // 9
	var exporter = function(KEY, exec, ALIAS){                                                                             // 10
	  var exp   = {};                                                                                                      // 11
	  var FORCE = fails(function(){                                                                                        // 12
	    return !!spaces[KEY]() || non[KEY]() != non;                                                                       // 13
	  });                                                                                                                  // 14
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];                                                                // 15
	  if(ALIAS)exp[ALIAS] = fn;                                                                                            // 16
	  $export($export.P + $export.F * FORCE, 'String', exp);                                                               // 17
	};                                                                                                                     // 18
	                                                                                                                       // 19
	// 1 -> String#trimLeft                                                                                                // 20
	// 2 -> String#trimRight                                                                                               // 21
	// 3 -> String#trim                                                                                                    // 22
	var trim = exporter.trim = function(string, TYPE){                                                                     // 23
	  string = String(defined(string));                                                                                    // 24
	  if(TYPE & 1)string = string.replace(ltrim, '');                                                                      // 25
	  if(TYPE & 2)string = string.replace(rtrim, '');                                                                      // 26
	  return string;                                                                                                       // 27
	};                                                                                                                     // 28
	                                                                                                                       // 29
	module.exports = exporter;                                                                                             // 30
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_string-ws.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_string-ws.js                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +                                  // 1
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';                                    // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"es6.string.code-point-at.js":["./_export","./_string-at",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.code-point-at.js                     //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var $export = require('./_export')                                                                                     // 2
	  , $at     = require('./_string-at')(false);                                                                          // 3
	$export($export.P, 'String', {                                                                                         // 4
	  // 21.1.3.3 String.prototype.codePointAt(pos)                                                                        // 5
	  codePointAt: function codePointAt(pos){                                                                              // 6
	    return $at(this, pos);                                                                                             // 7
	  }                                                                                                                    // 8
	});                                                                                                                    // 9
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.ends-with.js":["./_export","./_to-length","./_string-context","./_fails-is-regexp",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.ends-with.js                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])                                                    // 1
	'use strict';                                                                                                          // 2
	var $export   = require('./_export')                                                                                   // 3
	  , toLength  = require('./_to-length')                                                                                // 4
	  , context   = require('./_string-context')                                                                           // 5
	  , ENDS_WITH = 'endsWith'                                                                                             // 6
	  , $endsWith = ''[ENDS_WITH];                                                                                         // 7
	                                                                                                                       // 8
	$export($export.P + $export.F * require('./_fails-is-regexp')(ENDS_WITH), 'String', {                                  // 9
	  endsWith: function endsWith(searchString /*, endPosition = @length */){                                              // 10
	    var that = context(this, searchString, ENDS_WITH)                                                                  // 11
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined                                                  // 12
	      , len    = toLength(that.length)                                                                                 // 13
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)                                // 14
	      , search = String(searchString);                                                                                 // 15
	    return $endsWith                                                                                                   // 16
	      ? $endsWith.call(that, search, end)                                                                              // 17
	      : that.slice(end - search.length, end) === search;                                                               // 18
	  }                                                                                                                    // 19
	});                                                                                                                    // 20
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_string-context.js":["./_is-regexp","./_defined",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_string-context.js                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// helper for String#{startsWith, endsWith, includes}                                                                  // 1
	var isRegExp = require('./_is-regexp')                                                                                 // 2
	  , defined  = require('./_defined');                                                                                  // 3
	                                                                                                                       // 4
	module.exports = function(that, searchString, NAME){                                                                   // 5
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");                              // 6
	  return String(defined(that));                                                                                        // 7
	};                                                                                                                     // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_is-regexp.js":["./_is-object","./_cof","./_wks",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_is-regexp.js                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 7.2.8 IsRegExp(argument)                                                                                            // 1
	var isObject = require('./_is-object')                                                                                 // 2
	  , cof      = require('./_cof')                                                                                       // 3
	  , MATCH    = require('./_wks')('match');                                                                             // 4
	module.exports = function(it){                                                                                         // 5
	  var isRegExp;                                                                                                        // 6
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');                    // 7
	};                                                                                                                     // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_fails-is-regexp.js":["./_wks",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_fails-is-regexp.js                             //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var MATCH = require('./_wks')('match');                                                                                // 1
	module.exports = function(KEY){                                                                                        // 2
	  var re = /./;                                                                                                        // 3
	  try {                                                                                                                // 4
	    '/./'[KEY](re);                                                                                                    // 5
	  } catch(e){                                                                                                          // 6
	    try {                                                                                                              // 7
	      re[MATCH] = false;                                                                                               // 8
	      return !'/./'[KEY](re);                                                                                          // 9
	    } catch(f){ /* empty */ }                                                                                          // 10
	  } return true;                                                                                                       // 11
	};                                                                                                                     // 12
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.includes.js":["./_export","./_string-context","./_fails-is-regexp",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.includes.js                          //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 21.1.3.7 String.prototype.includes(searchString, position = 0)                                                      // 1
	'use strict';                                                                                                          // 2
	var $export  = require('./_export')                                                                                    // 3
	  , context  = require('./_string-context')                                                                            // 4
	  , INCLUDES = 'includes';                                                                                             // 5
	                                                                                                                       // 6
	$export($export.P + $export.F * require('./_fails-is-regexp')(INCLUDES), 'String', {                                   // 7
	  includes: function includes(searchString /*, position = 0 */){                                                       // 8
	    return !!~context(this, searchString, INCLUDES)                                                                    // 9
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);                                         // 10
	  }                                                                                                                    // 11
	});                                                                                                                    // 12
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.repeat.js":["./_export","./_string-repeat",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.repeat.js                            //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var $export = require('./_export');                                                                                    // 1
	                                                                                                                       // 2
	$export($export.P, 'String', {                                                                                         // 3
	  // 21.1.3.13 String.prototype.repeat(count)                                                                          // 4
	  repeat: require('./_string-repeat')                                                                                  // 5
	});                                                                                                                    // 6
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_string-repeat.js":["./_to-integer","./_defined",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_string-repeat.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var toInteger = require('./_to-integer')                                                                               // 2
	  , defined   = require('./_defined');                                                                                 // 3
	                                                                                                                       // 4
	module.exports = function repeat(count){                                                                               // 5
	  var str = String(defined(this))                                                                                      // 6
	    , res = ''                                                                                                         // 7
	    , n   = toInteger(count);                                                                                          // 8
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");                                               // 9
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;                                                          // 10
	  return res;                                                                                                          // 11
	};                                                                                                                     // 12
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.starts-with.js":["./_export","./_to-length","./_string-context","./_fails-is-regexp",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.starts-with.js                       //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])                                                   // 1
	'use strict';                                                                                                          // 2
	var $export     = require('./_export')                                                                                 // 3
	  , toLength    = require('./_to-length')                                                                              // 4
	  , context     = require('./_string-context')                                                                         // 5
	  , STARTS_WITH = 'startsWith'                                                                                         // 6
	  , $startsWith = ''[STARTS_WITH];                                                                                     // 7
	                                                                                                                       // 8
	$export($export.P + $export.F * require('./_fails-is-regexp')(STARTS_WITH), 'String', {                                // 9
	  startsWith: function startsWith(searchString /*, position = 0 */){                                                   // 10
	    var that   = context(this, searchString, STARTS_WITH)                                                              // 11
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))                      // 12
	      , search = String(searchString);                                                                                 // 13
	    return $startsWith                                                                                                 // 14
	      ? $startsWith.call(that, search, index)                                                                          // 15
	      : that.slice(index, index + search.length) === search;                                                           // 16
	  }                                                                                                                    // 17
	});                                                                                                                    // 18
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.anchor.js":["./_string-html",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.anchor.js                            //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// B.2.3.2 String.prototype.anchor(name)                                                                               // 2
	require('./_string-html')('anchor', function(createHTML){                                                              // 3
	  return function anchor(name){                                                                                        // 4
	    return createHTML(this, 'a', 'name', name);                                                                        // 5
	  }                                                                                                                    // 6
	});                                                                                                                    // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_string-html.js":["./_export","./_fails","./_defined",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_string-html.js                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var $export = require('./_export')                                                                                     // 1
	  , fails   = require('./_fails')                                                                                      // 2
	  , defined = require('./_defined')                                                                                    // 3
	  , quot    = /"/g;                                                                                                    // 4
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)                                                                 // 5
	var createHTML = function(string, tag, attribute, value) {                                                             // 6
	  var S  = String(defined(string))                                                                                     // 7
	    , p1 = '<' + tag;                                                                                                  // 8
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';                      // 9
	  return p1 + '>' + S + '</' + tag + '>';                                                                              // 10
	};                                                                                                                     // 11
	module.exports = function(NAME, exec){                                                                                 // 12
	  var O = {};                                                                                                          // 13
	  O[NAME] = exec(createHTML);                                                                                          // 14
	  $export($export.P + $export.F * fails(function(){                                                                    // 15
	    var test = ''[NAME]('"');                                                                                          // 16
	    return test !== test.toLowerCase() || test.split('"').length > 3;                                                  // 17
	  }), 'String', O);                                                                                                    // 18
	};                                                                                                                     // 19
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.big.js":["./_string-html",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.big.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// B.2.3.3 String.prototype.big()                                                                                      // 2
	require('./_string-html')('big', function(createHTML){                                                                 // 3
	  return function big(){                                                                                               // 4
	    return createHTML(this, 'big', '', '');                                                                            // 5
	  }                                                                                                                    // 6
	});                                                                                                                    // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.blink.js":["./_string-html",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.blink.js                             //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// B.2.3.4 String.prototype.blink()                                                                                    // 2
	require('./_string-html')('blink', function(createHTML){                                                               // 3
	  return function blink(){                                                                                             // 4
	    return createHTML(this, 'blink', '', '');                                                                          // 5
	  }                                                                                                                    // 6
	});                                                                                                                    // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.bold.js":["./_string-html",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.bold.js                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// B.2.3.5 String.prototype.bold()                                                                                     // 2
	require('./_string-html')('bold', function(createHTML){                                                                // 3
	  return function bold(){                                                                                              // 4
	    return createHTML(this, 'b', '', '');                                                                              // 5
	  }                                                                                                                    // 6
	});                                                                                                                    // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.fixed.js":["./_string-html",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.fixed.js                             //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// B.2.3.6 String.prototype.fixed()                                                                                    // 2
	require('./_string-html')('fixed', function(createHTML){                                                               // 3
	  return function fixed(){                                                                                             // 4
	    return createHTML(this, 'tt', '', '');                                                                             // 5
	  }                                                                                                                    // 6
	});                                                                                                                    // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.fontcolor.js":["./_string-html",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.fontcolor.js                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// B.2.3.7 String.prototype.fontcolor(color)                                                                           // 2
	require('./_string-html')('fontcolor', function(createHTML){                                                           // 3
	  return function fontcolor(color){                                                                                    // 4
	    return createHTML(this, 'font', 'color', color);                                                                   // 5
	  }                                                                                                                    // 6
	});                                                                                                                    // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.fontsize.js":["./_string-html",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.fontsize.js                          //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// B.2.3.8 String.prototype.fontsize(size)                                                                             // 2
	require('./_string-html')('fontsize', function(createHTML){                                                            // 3
	  return function fontsize(size){                                                                                      // 4
	    return createHTML(this, 'font', 'size', size);                                                                     // 5
	  }                                                                                                                    // 6
	});                                                                                                                    // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.italics.js":["./_string-html",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.italics.js                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// B.2.3.9 String.prototype.italics()                                                                                  // 2
	require('./_string-html')('italics', function(createHTML){                                                             // 3
	  return function italics(){                                                                                           // 4
	    return createHTML(this, 'i', '', '');                                                                              // 5
	  }                                                                                                                    // 6
	});                                                                                                                    // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.link.js":["./_string-html",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.link.js                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// B.2.3.10 String.prototype.link(url)                                                                                 // 2
	require('./_string-html')('link', function(createHTML){                                                                // 3
	  return function link(url){                                                                                           // 4
	    return createHTML(this, 'a', 'href', url);                                                                         // 5
	  }                                                                                                                    // 6
	});                                                                                                                    // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.small.js":["./_string-html",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.small.js                             //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// B.2.3.11 String.prototype.small()                                                                                   // 2
	require('./_string-html')('small', function(createHTML){                                                               // 3
	  return function small(){                                                                                             // 4
	    return createHTML(this, 'small', '', '');                                                                          // 5
	  }                                                                                                                    // 6
	});                                                                                                                    // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.strike.js":["./_string-html",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.strike.js                            //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// B.2.3.12 String.prototype.strike()                                                                                  // 2
	require('./_string-html')('strike', function(createHTML){                                                              // 3
	  return function strike(){                                                                                            // 4
	    return createHTML(this, 'strike', '', '');                                                                         // 5
	  }                                                                                                                    // 6
	});                                                                                                                    // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.sub.js":["./_string-html",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.sub.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// B.2.3.13 String.prototype.sub()                                                                                     // 2
	require('./_string-html')('sub', function(createHTML){                                                                 // 3
	  return function sub(){                                                                                               // 4
	    return createHTML(this, 'sub', '', '');                                                                            // 5
	  }                                                                                                                    // 6
	});                                                                                                                    // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.string.sup.js":["./_string-html",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.string.sup.js                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// B.2.3.14 String.prototype.sup()                                                                                     // 2
	require('./_string-html')('sup', function(createHTML){                                                                 // 3
	  return function sup(){                                                                                               // 4
	    return createHTML(this, 'sup', '', '');                                                                            // 5
	  }                                                                                                                    // 6
	});                                                                                                                    // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.regexp.match.js":["./_fix-re-wks",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.regexp.match.js                             //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// @@match logic                                                                                                       // 1
	require('./_fix-re-wks')('match', 1, function(defined, MATCH, $match){                                                 // 2
	  // 21.1.3.11 String.prototype.match(regexp)                                                                          // 3
	  return [function match(regexp){                                                                                      // 4
	    'use strict';                                                                                                      // 5
	    var O  = defined(this)                                                                                             // 6
	      , fn = regexp == undefined ? undefined : regexp[MATCH];                                                          // 7
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));                               // 8
	  }, $match];                                                                                                          // 9
	});                                                                                                                    // 10
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_fix-re-wks.js":["./_hide","./_redefine","./_fails","./_defined","./_wks",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_fix-re-wks.js                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var hide     = require('./_hide')                                                                                      // 2
	  , redefine = require('./_redefine')                                                                                  // 3
	  , fails    = require('./_fails')                                                                                     // 4
	  , defined  = require('./_defined')                                                                                   // 5
	  , wks      = require('./_wks');                                                                                      // 6
	                                                                                                                       // 7
	module.exports = function(KEY, length, exec){                                                                          // 8
	  var SYMBOL   = wks(KEY)                                                                                              // 9
	    , fns      = exec(defined, SYMBOL, ''[KEY])                                                                        // 10
	    , strfn    = fns[0]                                                                                                // 11
	    , rxfn     = fns[1];                                                                                               // 12
	  if(fails(function(){                                                                                                 // 13
	    var O = {};                                                                                                        // 14
	    O[SYMBOL] = function(){ return 7; };                                                                               // 15
	    return ''[KEY](O) != 7;                                                                                            // 16
	  })){                                                                                                                 // 17
	    redefine(String.prototype, KEY, strfn);                                                                            // 18
	    hide(RegExp.prototype, SYMBOL, length == 2                                                                         // 19
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)                                                    // 20
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)                                                            // 21
	      ? function(string, arg){ return rxfn.call(string, this, arg); }                                                  // 22
	      // 21.2.5.6 RegExp.prototype[@@match](string)                                                                    // 23
	      // 21.2.5.9 RegExp.prototype[@@search](string)                                                                   // 24
	      : function(string){ return rxfn.call(string, this); }                                                            // 25
	    );                                                                                                                 // 26
	  }                                                                                                                    // 27
	};                                                                                                                     // 28
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.regexp.replace.js":["./_fix-re-wks",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.regexp.replace.js                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// @@replace logic                                                                                                     // 1
	require('./_fix-re-wks')('replace', 2, function(defined, REPLACE, $replace){                                           // 2
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)                                                     // 3
	  return [function replace(searchValue, replaceValue){                                                                 // 4
	    'use strict';                                                                                                      // 5
	    var O  = defined(this)                                                                                             // 6
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];                                              // 7
	    return fn !== undefined                                                                                            // 8
	      ? fn.call(searchValue, O, replaceValue)                                                                          // 9
	      : $replace.call(String(O), searchValue, replaceValue);                                                           // 10
	  }, $replace];                                                                                                        // 11
	});                                                                                                                    // 12
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.regexp.search.js":["./_fix-re-wks",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.regexp.search.js                            //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// @@search logic                                                                                                      // 1
	require('./_fix-re-wks')('search', 1, function(defined, SEARCH, $search){                                              // 2
	  // 21.1.3.15 String.prototype.search(regexp)                                                                         // 3
	  return [function search(regexp){                                                                                     // 4
	    'use strict';                                                                                                      // 5
	    var O  = defined(this)                                                                                             // 6
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];                                                         // 7
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));                              // 8
	  }, $search];                                                                                                         // 9
	});                                                                                                                    // 10
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.regexp.split.js":["./_fix-re-wks","./_is-regexp",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.regexp.split.js                             //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// @@split logic                                                                                                       // 1
	require('./_fix-re-wks')('split', 2, function(defined, SPLIT, $split){                                                 // 2
	  'use strict';                                                                                                        // 3
	  var isRegExp   = require('./_is-regexp')                                                                             // 4
	    , _split     = $split                                                                                              // 5
	    , $push      = [].push                                                                                             // 6
	    , $SPLIT     = 'split'                                                                                             // 7
	    , LENGTH     = 'length'                                                                                            // 8
	    , LAST_INDEX = 'lastIndex';                                                                                        // 9
	  if(                                                                                                                  // 10
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||                                                                                // 11
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||                                                                         // 12
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||                                                                            // 13
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||                                                                            // 14
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||                                                                                 // 15
	    ''[$SPLIT](/.?/)[LENGTH]                                                                                           // 16
	  ){                                                                                                                   // 17
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group                                   // 18
	    // based on es5-shim implementation, need to rework it                                                             // 19
	    $split = function(separator, limit){                                                                               // 20
	      var string = String(this);                                                                                       // 21
	      if(separator === undefined && limit === 0)return [];                                                             // 22
	      // If `separator` is not a regex, use native split                                                               // 23
	      if(!isRegExp(separator))return _split.call(string, separator, limit);                                            // 24
	      var output = [];                                                                                                 // 25
	      var flags = (separator.ignoreCase ? 'i' : '') +                                                                  // 26
	                  (separator.multiline ? 'm' : '') +                                                                   // 27
	                  (separator.unicode ? 'u' : '') +                                                                     // 28
	                  (separator.sticky ? 'y' : '');                                                                       // 29
	      var lastLastIndex = 0;                                                                                           // 30
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;                                                 // 31
	      // Make `global` and avoid `lastIndex` issues by working with a copy                                             // 32
	      var separatorCopy = new RegExp(separator.source, flags + 'g');                                                   // 33
	      var separator2, match, lastIndex, lastLength, i;                                                                 // 34
	      // Doesn't need flags gy, but they don't hurt                                                                    // 35
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);                                // 36
	      while(match = separatorCopy.exec(string)){                                                                       // 37
	        // `separatorCopy.lastIndex` is not reliable cross-browser                                                     // 38
	        lastIndex = match.index + match[0][LENGTH];                                                                    // 39
	        if(lastIndex > lastLastIndex){                                                                                 // 40
	          output.push(string.slice(lastLastIndex, match.index));                                                       // 41
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG                          // 42
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){                                       // 43
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;              // 44
	          });                                                                                                          // 45
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));                    // 46
	          lastLength = match[0][LENGTH];                                                                               // 47
	          lastLastIndex = lastIndex;                                                                                   // 48
	          if(output[LENGTH] >= splitLimit)break;                                                                       // 49
	        }                                                                                                              // 50
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop            // 51
	      }                                                                                                                // 52
	      if(lastLastIndex === string[LENGTH]){                                                                            // 53
	        if(lastLength || !separatorCopy.test(''))output.push('');                                                      // 54
	      } else output.push(string.slice(lastLastIndex));                                                                 // 55
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;                                       // 56
	    };                                                                                                                 // 57
	  // Chakra, V8                                                                                                        // 58
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){                                                                        // 59
	    $split = function(separator, limit){                                                                               // 60
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);                        // 61
	    };                                                                                                                 // 62
	  }                                                                                                                    // 63
	  // 21.1.3.17 String.prototype.split(separator, limit)                                                                // 64
	  return [function split(separator, limit){                                                                            // 65
	    var O  = defined(this)                                                                                             // 66
	      , fn = separator == undefined ? undefined : separator[SPLIT];                                                    // 67
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);                 // 68
	  }, $split];                                                                                                          // 69
	});                                                                                                                    // 70
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.function.bind.js":["./_export","./_bind",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.function.bind.js                            //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)                                                       // 1
	var $export = require('./_export');                                                                                    // 2
	                                                                                                                       // 3
	$export($export.P, 'Function', {bind: require('./_bind')});                                                            // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_bind.js":["./_a-function","./_is-object","./_invoke",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_bind.js                                        //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var aFunction  = require('./_a-function')                                                                              // 2
	  , isObject   = require('./_is-object')                                                                               // 3
	  , invoke     = require('./_invoke')                                                                                  // 4
	  , arraySlice = [].slice                                                                                              // 5
	  , factories  = {};                                                                                                   // 6
	                                                                                                                       // 7
	var construct = function(F, len, args){                                                                                // 8
	  if(!(len in factories)){                                                                                             // 9
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';                                                         // 10
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');                                             // 11
	  } return factories[len](F, args);                                                                                    // 12
	};                                                                                                                     // 13
	                                                                                                                       // 14
	module.exports = Function.bind || function bind(that /*, args... */){                                                  // 15
	  var fn       = aFunction(this)                                                                                       // 16
	    , partArgs = arraySlice.call(arguments, 1);                                                                        // 17
	  var bound = function(/* args... */){                                                                                 // 18
	    var args = partArgs.concat(arraySlice.call(arguments));                                                            // 19
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);                          // 20
	  };                                                                                                                   // 21
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;                                                            // 22
	  return bound;                                                                                                        // 23
	};                                                                                                                     // 24
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_invoke.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_invoke.js                                      //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// fast apply, http://jsperf.lnkit.com/fast-apply/5                                                                    // 1
	module.exports = function(fn, args, that){                                                                             // 2
	  var un = that === undefined;                                                                                         // 3
	  switch(args.length){                                                                                                 // 4
	    case 0: return un ? fn()                                                                                           // 5
	                      : fn.call(that);                                                                                 // 6
	    case 1: return un ? fn(args[0])                                                                                    // 7
	                      : fn.call(that, args[0]);                                                                        // 8
	    case 2: return un ? fn(args[0], args[1])                                                                           // 9
	                      : fn.call(that, args[0], args[1]);                                                               // 10
	    case 3: return un ? fn(args[0], args[1], args[2])                                                                  // 11
	                      : fn.call(that, args[0], args[1], args[2]);                                                      // 12
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])                                                         // 13
	                      : fn.call(that, args[0], args[1], args[2], args[3]);                                             // 14
	  } return              fn.apply(that, args);                                                                          // 15
	};                                                                                                                     // 16
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"es6.function.name.js":["./_object-dp","./_property-desc","./_has","./_descriptors",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.function.name.js                            //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var dP         = require('./_object-dp').f                                                                             // 1
	  , createDesc = require('./_property-desc')                                                                           // 2
	  , has        = require('./_has')                                                                                     // 3
	  , FProto     = Function.prototype                                                                                    // 4
	  , nameRE     = /^\s*function ([^ (]*)/                                                                               // 5
	  , NAME       = 'name';                                                                                               // 6
	                                                                                                                       // 7
	var isExtensible = Object.isExtensible || function(){                                                                  // 8
	  return true;                                                                                                         // 9
	};                                                                                                                     // 10
	                                                                                                                       // 11
	// 19.2.4.2 name                                                                                                       // 12
	NAME in FProto || require('./_descriptors') && dP(FProto, NAME, {                                                      // 13
	  configurable: true,                                                                                                  // 14
	  get: function(){                                                                                                     // 15
	    try {                                                                                                              // 16
	      var that = this                                                                                                  // 17
	        , name = ('' + that).match(nameRE)[1];                                                                         // 18
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));                                   // 19
	      return name;                                                                                                     // 20
	    } catch(e){                                                                                                        // 21
	      return '';                                                                                                       // 22
	    }                                                                                                                  // 23
	  }                                                                                                                    // 24
	});                                                                                                                    // 25
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.function.has-instance.js":["./_is-object","./_object-gpo","./_wks","./_object-dp",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.function.has-instance.js                    //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var isObject       = require('./_is-object')                                                                           // 2
	  , getPrototypeOf = require('./_object-gpo')                                                                          // 3
	  , HAS_INSTANCE   = require('./_wks')('hasInstance')                                                                  // 4
	  , FunctionProto  = Function.prototype;                                                                               // 5
	// 19.2.3.6 Function.prototype[@@hasInstance](V)                                                                       // 6
	if(!(HAS_INSTANCE in FunctionProto))require('./_object-dp').f(FunctionProto, HAS_INSTANCE, {value: function(O){        // 7
	  if(typeof this != 'function' || !isObject(O))return false;                                                           // 8
	  if(!isObject(this.prototype))return O instanceof this;                                                               // 9
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:                               // 10
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;                                                     // 11
	  return false;                                                                                                        // 12
	}});                                                                                                                   // 13
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es7.array.includes.js":["./_export","./_array-includes","./_add-to-unscopables",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es7.array.includes.js                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// https://github.com/tc39/Array.prototype.includes                                                                    // 2
	var $export   = require('./_export')                                                                                   // 3
	  , $includes = require('./_array-includes')(true);                                                                    // 4
	                                                                                                                       // 5
	$export($export.P, 'Array', {                                                                                          // 6
	  includes: function includes(el /*, fromIndex = 0 */){                                                                // 7
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);                                       // 8
	  }                                                                                                                    // 9
	});                                                                                                                    // 10
	                                                                                                                       // 11
	require('./_add-to-unscopables')('includes');                                                                          // 12
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es7.object.values.js":["./_export","./_object-to-array",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es7.object.values.js                            //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// https://github.com/tc39/proposal-object-values-entries                                                              // 1
	var $export = require('./_export')                                                                                     // 2
	  , $values = require('./_object-to-array')(false);                                                                    // 3
	                                                                                                                       // 4
	$export($export.S, 'Object', {                                                                                         // 5
	  values: function values(it){                                                                                         // 6
	    return $values(it);                                                                                                // 7
	  }                                                                                                                    // 8
	});                                                                                                                    // 9
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-to-array.js":["./_object-keys","./_to-iobject","./_object-pie",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_object-to-array.js                             //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var getKeys   = require('./_object-keys')                                                                              // 1
	  , toIObject = require('./_to-iobject')                                                                               // 2
	  , isEnum    = require('./_object-pie').f;                                                                            // 3
	module.exports = function(isEntries){                                                                                  // 4
	  return function(it){                                                                                                 // 5
	    var O      = toIObject(it)                                                                                         // 6
	      , keys   = getKeys(O)                                                                                            // 7
	      , length = keys.length                                                                                           // 8
	      , i      = 0                                                                                                     // 9
	      , result = []                                                                                                    // 10
	      , key;                                                                                                           // 11
	    while(length > i)if(isEnum.call(O, key = keys[i++])){                                                              // 12
	      result.push(isEntries ? [key, O[key]] : O[key]);                                                                 // 13
	    } return result;                                                                                                   // 14
	  };                                                                                                                   // 15
	};                                                                                                                     // 16
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es7.object.entries.js":["./_export","./_object-to-array",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es7.object.entries.js                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// https://github.com/tc39/proposal-object-values-entries                                                              // 1
	var $export  = require('./_export')                                                                                    // 2
	  , $entries = require('./_object-to-array')(true);                                                                    // 3
	                                                                                                                       // 4
	$export($export.S, 'Object', {                                                                                         // 5
	  entries: function entries(it){                                                                                       // 6
	    return $entries(it);                                                                                               // 7
	  }                                                                                                                    // 8
	});                                                                                                                    // 9
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es7.object.get-own-property-descriptors.js":["./_export","./_own-keys","./_to-iobject","./_object-gopd","./_create-property",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es7.object.get-own-property-descriptors.js      //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// https://github.com/tc39/proposal-object-getownpropertydescriptors                                                   // 1
	var $export        = require('./_export')                                                                              // 2
	  , ownKeys        = require('./_own-keys')                                                                            // 3
	  , toIObject      = require('./_to-iobject')                                                                          // 4
	  , gOPD           = require('./_object-gopd')                                                                         // 5
	  , createProperty = require('./_create-property');                                                                    // 6
	                                                                                                                       // 7
	$export($export.S, 'Object', {                                                                                         // 8
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){                                               // 9
	    var O       = toIObject(object)                                                                                    // 10
	      , getDesc = gOPD.f                                                                                               // 11
	      , keys    = ownKeys(O)                                                                                           // 12
	      , result  = {}                                                                                                   // 13
	      , i       = 0                                                                                                    // 14
	      , key;                                                                                                           // 15
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));                                    // 16
	    return result;                                                                                                     // 17
	  }                                                                                                                    // 18
	});                                                                                                                    // 19
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_own-keys.js":["./_object-gopn","./_object-gops","./_an-object","./_global",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_own-keys.js                                    //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// all object keys, includes non-enumerable and symbols                                                                // 1
	var gOPN     = require('./_object-gopn')                                                                               // 2
	  , gOPS     = require('./_object-gops')                                                                               // 3
	  , anObject = require('./_an-object')                                                                                 // 4
	  , Reflect  = require('./_global').Reflect;                                                                           // 5
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){                                                   // 6
	  var keys       = gOPN.f(anObject(it))                                                                                // 7
	    , getSymbols = gOPS.f;                                                                                             // 8
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;                                                              // 9
	};                                                                                                                     // 10
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es7.string.pad-start.js":["./_export","./_string-pad",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es7.string.pad-start.js                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// https://github.com/tc39/proposal-string-pad-start-end                                                               // 2
	var $export = require('./_export')                                                                                     // 3
	  , $pad    = require('./_string-pad');                                                                                // 4
	                                                                                                                       // 5
	$export($export.P, 'String', {                                                                                         // 6
	  padStart: function padStart(maxLength /*, fillString = ' ' */){                                                      // 7
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);                               // 8
	  }                                                                                                                    // 9
	});                                                                                                                    // 10
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_string-pad.js":["./_to-length","./_string-repeat","./_defined",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_string-pad.js                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// https://github.com/tc39/proposal-string-pad-start-end                                                               // 1
	var toLength = require('./_to-length')                                                                                 // 2
	  , repeat   = require('./_string-repeat')                                                                             // 3
	  , defined  = require('./_defined');                                                                                  // 4
	                                                                                                                       // 5
	module.exports = function(that, maxLength, fillString, left){                                                          // 6
	  var S            = String(defined(that))                                                                             // 7
	    , stringLength = S.length                                                                                          // 8
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)                                               // 9
	    , intMaxLength = toLength(maxLength);                                                                              // 10
	  if(intMaxLength <= stringLength || fillStr == '')return S;                                                           // 11
	  var fillLen = intMaxLength - stringLength                                                                            // 12
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));                                        // 13
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);                                      // 14
	  return left ? stringFiller + S : S + stringFiller;                                                                   // 15
	};                                                                                                                     // 16
	                                                                                                                       // 17
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es7.string.pad-end.js":["./_export","./_string-pad",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es7.string.pad-end.js                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// https://github.com/tc39/proposal-string-pad-start-end                                                               // 2
	var $export = require('./_export')                                                                                     // 3
	  , $pad    = require('./_string-pad');                                                                                // 4
	                                                                                                                       // 5
	$export($export.P, 'String', {                                                                                         // 6
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){                                                          // 7
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);                              // 8
	  }                                                                                                                    // 9
	});                                                                                                                    // 10
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es7.string.trim-left.js":["./_string-trim",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es7.string.trim-left.js                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim                                                    // 2
	require('./_string-trim')('trimLeft', function($trim){                                                                 // 3
	  return function trimLeft(){                                                                                          // 4
	    return $trim(this, 1);                                                                                             // 5
	  };                                                                                                                   // 6
	}, 'trimStart');                                                                                                       // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es7.string.trim-right.js":["./_string-trim",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es7.string.trim-right.js                        //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim                                                    // 2
	require('./_string-trim')('trimRight', function($trim){                                                                // 3
	  return function trimRight(){                                                                                         // 4
	    return $trim(this, 2);                                                                                             // 5
	  };                                                                                                                   // 6
	}, 'trimEnd');                                                                                                         // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"web.dom.iterable.js":["./es6.array.iterator","./_redefine","./_global","./_hide","./_iterators","./_wks",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/web.dom.iterable.js                             //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var $iterators    = require('./es6.array.iterator')                                                                    // 1
	  , redefine      = require('./_redefine')                                                                             // 2
	  , global        = require('./_global')                                                                               // 3
	  , hide          = require('./_hide')                                                                                 // 4
	  , Iterators     = require('./_iterators')                                                                            // 5
	  , wks           = require('./_wks')                                                                                  // 6
	  , ITERATOR      = wks('iterator')                                                                                    // 7
	  , TO_STRING_TAG = wks('toStringTag')                                                                                 // 8
	  , ArrayValues   = Iterators.Array;                                                                                   // 9
	                                                                                                                       // 10
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){  // 11
	  var NAME       = collections[i]                                                                                      // 12
	    , Collection = global[NAME]                                                                                        // 13
	    , proto      = Collection && Collection.prototype                                                                  // 14
	    , key;                                                                                                             // 15
	  if(proto){                                                                                                           // 16
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);                                                            // 17
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);                                                         // 18
	    Iterators[NAME] = ArrayValues;                                                                                     // 19
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);                                  // 20
	  }                                                                                                                    // 21
	}                                                                                                                      // 22
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.map.js":["./_collection-strong","./_collection",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.map.js                                      //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var strong = require('./_collection-strong');                                                                          // 2
	                                                                                                                       // 3
	// 23.1 Map Objects                                                                                                    // 4
	module.exports = require('./_collection')('Map', function(get){                                                        // 5
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };                         // 6
	}, {                                                                                                                   // 7
	  // 23.1.3.6 Map.prototype.get(key)                                                                                   // 8
	  get: function get(key){                                                                                              // 9
	    var entry = strong.getEntry(this, key);                                                                            // 10
	    return entry && entry.v;                                                                                           // 11
	  },                                                                                                                   // 12
	  // 23.1.3.9 Map.prototype.set(key, value)                                                                            // 13
	  set: function set(key, value){                                                                                       // 14
	    return strong.def(this, key === 0 ? 0 : key, value);                                                               // 15
	  }                                                                                                                    // 16
	}, strong, true);                                                                                                      // 17
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_collection-strong.js":["./_object-dp","./_object-create","./_redefine-all","./_ctx","./_an-instance","./_defined","./_for-of","./_iter-define","./_iter-step","./_set-species","./_descriptors","./_meta",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_collection-strong.js                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var dP          = require('./_object-dp').f                                                                            // 2
	  , create      = require('./_object-create')                                                                          // 3
	  , redefineAll = require('./_redefine-all')                                                                           // 4
	  , ctx         = require('./_ctx')                                                                                    // 5
	  , anInstance  = require('./_an-instance')                                                                            // 6
	  , defined     = require('./_defined')                                                                                // 7
	  , forOf       = require('./_for-of')                                                                                 // 8
	  , $iterDefine = require('./_iter-define')                                                                            // 9
	  , step        = require('./_iter-step')                                                                              // 10
	  , setSpecies  = require('./_set-species')                                                                            // 11
	  , DESCRIPTORS = require('./_descriptors')                                                                            // 12
	  , fastKey     = require('./_meta').fastKey                                                                           // 13
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';                                                                         // 14
	                                                                                                                       // 15
	var getEntry = function(that, key){                                                                                    // 16
	  // fast case                                                                                                         // 17
	  var index = fastKey(key), entry;                                                                                     // 18
	  if(index !== 'F')return that._i[index];                                                                              // 19
	  // frozen object case                                                                                                // 20
	  for(entry = that._f; entry; entry = entry.n){                                                                        // 21
	    if(entry.k == key)return entry;                                                                                    // 22
	  }                                                                                                                    // 23
	};                                                                                                                     // 24
	                                                                                                                       // 25
	module.exports = {                                                                                                     // 26
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){                                                              // 27
	    var C = wrapper(function(that, iterable){                                                                          // 28
	      anInstance(that, C, NAME, '_i');                                                                                 // 29
	      that._i = create(null); // index                                                                                 // 30
	      that._f = undefined;    // first entry                                                                           // 31
	      that._l = undefined;    // last entry                                                                            // 32
	      that[SIZE] = 0;         // size                                                                                  // 33
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);                                             // 34
	    });                                                                                                                // 35
	    redefineAll(C.prototype, {                                                                                         // 36
	      // 23.1.3.1 Map.prototype.clear()                                                                                // 37
	      // 23.2.3.2 Set.prototype.clear()                                                                                // 38
	      clear: function clear(){                                                                                         // 39
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){                                 // 40
	          entry.r = true;                                                                                              // 41
	          if(entry.p)entry.p = entry.p.n = undefined;                                                                  // 42
	          delete data[entry.i];                                                                                        // 43
	        }                                                                                                              // 44
	        that._f = that._l = undefined;                                                                                 // 45
	        that[SIZE] = 0;                                                                                                // 46
	      },                                                                                                               // 47
	      // 23.1.3.3 Map.prototype.delete(key)                                                                            // 48
	      // 23.2.3.4 Set.prototype.delete(value)                                                                          // 49
	      'delete': function(key){                                                                                         // 50
	        var that  = this                                                                                               // 51
	          , entry = getEntry(that, key);                                                                               // 52
	        if(entry){                                                                                                     // 53
	          var next = entry.n                                                                                           // 54
	            , prev = entry.p;                                                                                          // 55
	          delete that._i[entry.i];                                                                                     // 56
	          entry.r = true;                                                                                              // 57
	          if(prev)prev.n = next;                                                                                       // 58
	          if(next)next.p = prev;                                                                                       // 59
	          if(that._f == entry)that._f = next;                                                                          // 60
	          if(that._l == entry)that._l = prev;                                                                          // 61
	          that[SIZE]--;                                                                                                // 62
	        } return !!entry;                                                                                              // 63
	      },                                                                                                               // 64
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)                                               // 65
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)                                               // 66
	      forEach: function forEach(callbackfn /*, that = undefined */){                                                   // 67
	        anInstance(this, C, 'forEach');                                                                                // 68
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)                                    // 69
	          , entry;                                                                                                     // 70
	        while(entry = entry ? entry.n : this._f){                                                                      // 71
	          f(entry.v, entry.k, this);                                                                                   // 72
	          // revert to the last existing entry                                                                         // 73
	          while(entry && entry.r)entry = entry.p;                                                                      // 74
	        }                                                                                                              // 75
	      },                                                                                                               // 76
	      // 23.1.3.7 Map.prototype.has(key)                                                                               // 77
	      // 23.2.3.7 Set.prototype.has(value)                                                                             // 78
	      has: function has(key){                                                                                          // 79
	        return !!getEntry(this, key);                                                                                  // 80
	      }                                                                                                                // 81
	    });                                                                                                                // 82
	    if(DESCRIPTORS)dP(C.prototype, 'size', {                                                                           // 83
	      get: function(){                                                                                                 // 84
	        return defined(this[SIZE]);                                                                                    // 85
	      }                                                                                                                // 86
	    });                                                                                                                // 87
	    return C;                                                                                                          // 88
	  },                                                                                                                   // 89
	  def: function(that, key, value){                                                                                     // 90
	    var entry = getEntry(that, key)                                                                                    // 91
	      , prev, index;                                                                                                   // 92
	    // change existing entry                                                                                           // 93
	    if(entry){                                                                                                         // 94
	      entry.v = value;                                                                                                 // 95
	    // create new entry                                                                                                // 96
	    } else {                                                                                                           // 97
	      that._l = entry = {                                                                                              // 98
	        i: index = fastKey(key, true), // <- index                                                                     // 99
	        k: key,                        // <- key                                                                       // 100
	        v: value,                      // <- value                                                                     // 101
	        p: prev = that._l,             // <- previous entry                                                            // 102
	        n: undefined,                  // <- next entry                                                                // 103
	        r: false                       // <- removed                                                                   // 104
	      };                                                                                                               // 105
	      if(!that._f)that._f = entry;                                                                                     // 106
	      if(prev)prev.n = entry;                                                                                          // 107
	      that[SIZE]++;                                                                                                    // 108
	      // add to index                                                                                                  // 109
	      if(index !== 'F')that._i[index] = entry;                                                                         // 110
	    } return that;                                                                                                     // 111
	  },                                                                                                                   // 112
	  getEntry: getEntry,                                                                                                  // 113
	  setStrong: function(C, NAME, IS_MAP){                                                                                // 114
	    // add .keys, .values, .entries, [@@iterator]                                                                      // 115
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11                              // 116
	    $iterDefine(C, NAME, function(iterated, kind){                                                                     // 117
	      this._t = iterated;  // target                                                                                   // 118
	      this._k = kind;      // kind                                                                                     // 119
	      this._l = undefined; // previous                                                                                 // 120
	    }, function(){                                                                                                     // 121
	      var that  = this                                                                                                 // 122
	        , kind  = that._k                                                                                              // 123
	        , entry = that._l;                                                                                             // 124
	      // revert to the last existing entry                                                                             // 125
	      while(entry && entry.r)entry = entry.p;                                                                          // 126
	      // get next entry                                                                                                // 127
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){                                               // 128
	        // or finish the iteration                                                                                     // 129
	        that._t = undefined;                                                                                           // 130
	        return step(1);                                                                                                // 131
	      }                                                                                                                // 132
	      // return step by kind                                                                                           // 133
	      if(kind == 'keys'  )return step(0, entry.k);                                                                     // 134
	      if(kind == 'values')return step(0, entry.v);                                                                     // 135
	      return step(0, [entry.k, entry.v]);                                                                              // 136
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);                                                                 // 137
	                                                                                                                       // 138
	    // add [@@species], 23.1.2.2, 23.2.2.2                                                                             // 139
	    setSpecies(NAME);                                                                                                  // 140
	  }                                                                                                                    // 141
	};                                                                                                                     // 142
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_redefine-all.js":["./_redefine",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_redefine-all.js                                //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var redefine = require('./_redefine');                                                                                 // 1
	module.exports = function(target, src, safe){                                                                          // 2
	  for(var key in src)redefine(target, key, src[key], safe);                                                            // 3
	  return target;                                                                                                       // 4
	};                                                                                                                     // 5
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_an-instance.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_an-instance.js                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = function(it, Constructor, name, forbiddenField){                                                      // 1
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){                          // 2
	    throw TypeError(name + ': incorrect invocation!');                                                                 // 3
	  } return it;                                                                                                         // 4
	};                                                                                                                     // 5
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_for-of.js":["./_ctx","./_iter-call","./_is-array-iter","./_an-object","./_to-length","./core.get-iterator-method",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_for-of.js                                      //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var ctx         = require('./_ctx')                                                                                    // 1
	  , call        = require('./_iter-call')                                                                              // 2
	  , isArrayIter = require('./_is-array-iter')                                                                          // 3
	  , anObject    = require('./_an-object')                                                                              // 4
	  , toLength    = require('./_to-length')                                                                              // 5
	  , getIterFn   = require('./core.get-iterator-method')                                                                // 6
	  , BREAK       = {}                                                                                                   // 7
	  , RETURN      = {};                                                                                                  // 8
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){                                        // 9
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)                                         // 10
	    , f      = ctx(fn, that, entries ? 2 : 1)                                                                          // 11
	    , index  = 0                                                                                                       // 12
	    , length, step, iterator, result;                                                                                  // 13
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');                                      // 14
	  // fast case for arrays with default iterator                                                                        // 15
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){                             // 16
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);                           // 17
	    if(result === BREAK || result === RETURN)return result;                                                            // 18
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){                                      // 19
	    result = call(iterator, f, step.value, entries);                                                                   // 20
	    if(result === BREAK || result === RETURN)return result;                                                            // 21
	  }                                                                                                                    // 22
	};                                                                                                                     // 23
	exports.BREAK  = BREAK;                                                                                                // 24
	exports.RETURN = RETURN;                                                                                               // 25
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_collection.js":["./_global","./_export","./_redefine","./_redefine-all","./_meta","./_for-of","./_an-instance","./_is-object","./_fails","./_iter-detect","./_set-to-string-tag","./_inherit-if-required",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_collection.js                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var global            = require('./_global')                                                                           // 2
	  , $export           = require('./_export')                                                                           // 3
	  , redefine          = require('./_redefine')                                                                         // 4
	  , redefineAll       = require('./_redefine-all')                                                                     // 5
	  , meta              = require('./_meta')                                                                             // 6
	  , forOf             = require('./_for-of')                                                                           // 7
	  , anInstance        = require('./_an-instance')                                                                      // 8
	  , isObject          = require('./_is-object')                                                                        // 9
	  , fails             = require('./_fails')                                                                            // 10
	  , $iterDetect       = require('./_iter-detect')                                                                      // 11
	  , setToStringTag    = require('./_set-to-string-tag')                                                                // 12
	  , inheritIfRequired = require('./_inherit-if-required');                                                             // 13
	                                                                                                                       // 14
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){                                            // 15
	  var Base  = global[NAME]                                                                                             // 16
	    , C     = Base                                                                                                     // 17
	    , ADDER = IS_MAP ? 'set' : 'add'                                                                                   // 18
	    , proto = C && C.prototype                                                                                         // 19
	    , O     = {};                                                                                                      // 20
	  var fixMethod = function(KEY){                                                                                       // 21
	    var fn = proto[KEY];                                                                                               // 22
	    redefine(proto, KEY,                                                                                               // 23
	      KEY == 'delete' ? function(a){                                                                                   // 24
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);                                       // 25
	      } : KEY == 'has' ? function has(a){                                                                              // 26
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);                                       // 27
	      } : KEY == 'get' ? function get(a){                                                                              // 28
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);                                   // 29
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }                               // 30
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }                                        // 31
	    );                                                                                                                 // 32
	  };                                                                                                                   // 33
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){                                        // 34
	    new C().entries().next();                                                                                          // 35
	  }))){                                                                                                                // 36
	    // create collection constructor                                                                                   // 37
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);                                                           // 38
	    redefineAll(C.prototype, methods);                                                                                 // 39
	    meta.NEED = true;                                                                                                  // 40
	  } else {                                                                                                             // 41
	    var instance             = new C                                                                                   // 42
	      // early implementations not supports chaining                                                                   // 43
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance                                       // 44
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false                             // 45
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })                                                   // 46
	      // most early implementations doesn't supports iterables, most modern - not close it correctly                   // 47
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new               // 48
	      // for early implementations -0 and +0 not the same                                                              // 49
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){                                                                     // 50
	        // V8 ~ Chromium 42- fails only with 5+ elements                                                               // 51
	        var $instance = new C()                                                                                        // 52
	          , index     = 5;                                                                                             // 53
	        while(index--)$instance[ADDER](index, index);                                                                  // 54
	        return !$instance.has(-0);                                                                                     // 55
	      });                                                                                                              // 56
	    if(!ACCEPT_ITERABLES){                                                                                             // 57
	      C = wrapper(function(target, iterable){                                                                          // 58
	        anInstance(target, C, NAME);                                                                                   // 59
	        var that = inheritIfRequired(new Base, target, C);                                                             // 60
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);                                           // 61
	        return that;                                                                                                   // 62
	      });                                                                                                              // 63
	      C.prototype = proto;                                                                                             // 64
	      proto.constructor = C;                                                                                           // 65
	    }                                                                                                                  // 66
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){                                                                            // 67
	      fixMethod('delete');                                                                                             // 68
	      fixMethod('has');                                                                                                // 69
	      IS_MAP && fixMethod('get');                                                                                      // 70
	    }                                                                                                                  // 71
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);                                                                  // 72
	    // weak collections should not contains .clear method                                                              // 73
	    if(IS_WEAK && proto.clear)delete proto.clear;                                                                      // 74
	  }                                                                                                                    // 75
	                                                                                                                       // 76
	  setToStringTag(C, NAME);                                                                                             // 77
	                                                                                                                       // 78
	  O[NAME] = C;                                                                                                         // 79
	  $export($export.G + $export.W + $export.F * (C != Base), O);                                                         // 80
	                                                                                                                       // 81
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);                                                                       // 82
	                                                                                                                       // 83
	  return C;                                                                                                            // 84
	};                                                                                                                     // 85
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_inherit-if-required.js":["./_is-object","./_set-proto",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/_inherit-if-required.js                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var isObject       = require('./_is-object')                                                                           // 1
	  , setPrototypeOf = require('./_set-proto').set;                                                                      // 2
	module.exports = function(that, target, C){                                                                            // 3
	  var P, S = target.constructor;                                                                                       // 4
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){         // 5
	    setPrototypeOf(that, P);                                                                                           // 6
	  } return that;                                                                                                       // 7
	};                                                                                                                     // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.set.js":["./_collection-strong","./_collection",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/modules/es6.set.js                                      //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var strong = require('./_collection-strong');                                                                          // 2
	                                                                                                                       // 3
	// 23.2 Set Objects                                                                                                    // 4
	module.exports = require('./_collection')('Set', function(get){                                                        // 5
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };                         // 6
	}, {                                                                                                                   // 7
	  // 23.2.3.1 Set.prototype.add(value)                                                                                 // 8
	  add: function add(value){                                                                                            // 9
	    return strong.def(this, value = value === 0 ? 0 : value, value);                                                   // 10
	  }                                                                                                                    // 11
	}, strong);                                                                                                            // 12
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]},"fn":{"array":{"includes.js":["../../modules/es7.array.includes","../../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/fn/array/includes.js                                    //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../../modules/es7.array.includes');                                                                           // 1
	module.exports = require('../../modules/_core').Array.includes;                                                        // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]},"object":{"values.js":["../../modules/es7.object.values","../../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/fn/object/values.js                                     //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../../modules/es7.object.values');                                                                            // 1
	module.exports = require('../../modules/_core').Object.values;                                                         // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"entries.js":["../../modules/es7.object.entries","../../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/fn/object/entries.js                                    //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../../modules/es7.object.entries');                                                                           // 1
	module.exports = require('../../modules/_core').Object.entries;                                                        // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"get-own-property-descriptors.js":["../../modules/es7.object.get-own-property-descriptors","../../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/fn/object/get-own-property-descriptors.js               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../../modules/es7.object.get-own-property-descriptors');                                                      // 1
	module.exports = require('../../modules/_core').Object.getOwnPropertyDescriptors;                                      // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]},"string":{"pad-start.js":["../../modules/es7.string.pad-start","../../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/fn/string/pad-start.js                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../../modules/es7.string.pad-start');                                                                         // 1
	module.exports = require('../../modules/_core').String.padStart;                                                       // 2
	                                                                                                                       // 3
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"pad-end.js":["../../modules/es7.string.pad-end","../../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/fn/string/pad-end.js                                    //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../../modules/es7.string.pad-end');                                                                           // 1
	module.exports = require('../../modules/_core').String.padEnd;                                                         // 2
	                                                                                                                       // 3
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"trim-start.js":["../../modules/es7.string.trim-left","../../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/fn/string/trim-start.js                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../../modules/es7.string.trim-left');                                                                         // 1
	module.exports = require('../../modules/_core').String.trimLeft;                                                       // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"trim-end.js":["../../modules/es7.string.trim-right","../../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/ecmascript-runtime/node_modules/core-js/fn/string/trim-end.js                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../../modules/es7.string.trim-right');                                                                        // 1
	module.exports = require('../../modules/_core').String.trimRight;                                                      // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]}}}}}}}},{"extensions":[".js",".json"]});
	var exports = require("./node_modules/meteor/ecmascript-runtime/runtime.js");
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['ecmascript-runtime'] = exports, {
	  Symbol: Symbol,
	  Map: Map,
	  Set: Set
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/ejson.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	var Base64 = Package.base64.Base64;
	
	/* Package-scope variables */
	var EJSON, EJSONTest;
	
	(function(){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                   //
	// packages/ejson/ejson.js                                                                                           //
	//                                                                                                                   //
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                     //
	/**                                                                                                                  // 1
	 * @namespace                                                                                                        // 2
	 * @summary Namespace for EJSON functions                                                                            // 3
	 */                                                                                                                  // 4
	EJSON = {};                                                                                                          // 5
	EJSONTest = {};                                                                                                      // 6
	                                                                                                                     // 7
	                                                                                                                     // 8
	                                                                                                                     // 9
	// Custom type interface definition                                                                                  // 10
	/**                                                                                                                  // 11
	 * @class CustomType                                                                                                 // 12
	 * @instanceName customType                                                                                          // 13
	 * @memberOf EJSON                                                                                                   // 14
	 * @summary The interface that a class must satisfy to be able to become an                                          // 15
	 * EJSON custom type via EJSON.addType.                                                                              // 16
	 */                                                                                                                  // 17
	                                                                                                                     // 18
	/**                                                                                                                  // 19
	 * @function typeName                                                                                                // 20
	 * @memberOf EJSON.CustomType                                                                                        // 21
	 * @summary Return the tag used to identify this type.  This must match the tag used to register this type with [`EJSON.addType`](#ejson_add_type).
	 * @locus Anywhere                                                                                                   // 23
	 * @instance                                                                                                         // 24
	 */                                                                                                                  // 25
	                                                                                                                     // 26
	/**                                                                                                                  // 27
	 * @function toJSONValue                                                                                             // 28
	 * @memberOf EJSON.CustomType                                                                                        // 29
	 * @summary Serialize this instance into a JSON-compatible value.                                                    // 30
	 * @locus Anywhere                                                                                                   // 31
	 * @instance                                                                                                         // 32
	 */                                                                                                                  // 33
	                                                                                                                     // 34
	/**                                                                                                                  // 35
	 * @function clone                                                                                                   // 36
	 * @memberOf EJSON.CustomType                                                                                        // 37
	 * @summary Return a value `r` such that `this.equals(r)` is true, and modifications to `r` do not affect `this` and vice versa.
	 * @locus Anywhere                                                                                                   // 39
	 * @instance                                                                                                         // 40
	 */                                                                                                                  // 41
	                                                                                                                     // 42
	/**                                                                                                                  // 43
	 * @function equals                                                                                                  // 44
	 * @memberOf EJSON.CustomType                                                                                        // 45
	 * @summary Return `true` if `other` has a value equal to `this`; `false` otherwise.                                 // 46
	 * @locus Anywhere                                                                                                   // 47
	 * @param {Object} other Another object to compare this to.                                                          // 48
	 * @instance                                                                                                         // 49
	 */                                                                                                                  // 50
	                                                                                                                     // 51
	                                                                                                                     // 52
	var customTypes = {};                                                                                                // 53
	// Add a custom type, using a method of your choice to get to and                                                    // 54
	// from a basic JSON-able representation.  The factory argument                                                      // 55
	// is a function of JSON-able --> your object                                                                        // 56
	// The type you add must have:                                                                                       // 57
	// - A toJSONValue() method, so that Meteor can serialize it                                                         // 58
	// - a typeName() method, to show how to look it up in our type table.                                               // 59
	// It is okay if these methods are monkey-patched on.                                                                // 60
	// EJSON.clone will use toJSONValue and the given factory to produce                                                 // 61
	// a clone, but you may specify a method clone() that will be                                                        // 62
	// used instead.                                                                                                     // 63
	// Similarly, EJSON.equals will use toJSONValue to make comparisons,                                                 // 64
	// but you may provide a method equals() instead.                                                                    // 65
	/**                                                                                                                  // 66
	 * @summary Add a custom datatype to EJSON.                                                                          // 67
	 * @locus Anywhere                                                                                                   // 68
	 * @param {String} name A tag for your custom type; must be unique among custom data types defined in your project, and must match the result of your type's `typeName` method.
	 * @param {Function} factory A function that deserializes a JSON-compatible value into an instance of your type.  This should match the serialization performed by your type's `toJSONValue` method.
	 */                                                                                                                  // 71
	EJSON.addType = function (name, factory) {                                                                           // 72
	  if (_.has(customTypes, name))                                                                                      // 73
	    throw new Error("Type " + name + " already present");                                                            // 74
	  customTypes[name] = factory;                                                                                       // 75
	};                                                                                                                   // 76
	                                                                                                                     // 77
	var isInfOrNan = function (obj) {                                                                                    // 78
	  return _.isNaN(obj) || obj === Infinity || obj === -Infinity;                                                      // 79
	};                                                                                                                   // 80
	                                                                                                                     // 81
	var builtinConverters = [                                                                                            // 82
	  { // Date                                                                                                          // 83
	    matchJSONValue: function (obj) {                                                                                 // 84
	      return _.has(obj, '$date') && _.size(obj) === 1;                                                               // 85
	    },                                                                                                               // 86
	    matchObject: function (obj) {                                                                                    // 87
	      return obj instanceof Date;                                                                                    // 88
	    },                                                                                                               // 89
	    toJSONValue: function (obj) {                                                                                    // 90
	      return {$date: obj.getTime()};                                                                                 // 91
	    },                                                                                                               // 92
	    fromJSONValue: function (obj) {                                                                                  // 93
	      return new Date(obj.$date);                                                                                    // 94
	    }                                                                                                                // 95
	  },                                                                                                                 // 96
	  { // NaN, Inf, -Inf. (These are the only objects with typeof !== 'object'                                          // 97
	    // which we match.)                                                                                              // 98
	    matchJSONValue: function (obj) {                                                                                 // 99
	      return _.has(obj, '$InfNaN') && _.size(obj) === 1;                                                             // 100
	    },                                                                                                               // 101
	    matchObject: isInfOrNan,                                                                                         // 102
	    toJSONValue: function (obj) {                                                                                    // 103
	      var sign;                                                                                                      // 104
	      if (_.isNaN(obj))                                                                                              // 105
	        sign = 0;                                                                                                    // 106
	      else if (obj === Infinity)                                                                                     // 107
	        sign = 1;                                                                                                    // 108
	      else                                                                                                           // 109
	        sign = -1;                                                                                                   // 110
	      return {$InfNaN: sign};                                                                                        // 111
	    },                                                                                                               // 112
	    fromJSONValue: function (obj) {                                                                                  // 113
	      return obj.$InfNaN/0;                                                                                          // 114
	    }                                                                                                                // 115
	  },                                                                                                                 // 116
	  { // Binary                                                                                                        // 117
	    matchJSONValue: function (obj) {                                                                                 // 118
	      return _.has(obj, '$binary') && _.size(obj) === 1;                                                             // 119
	    },                                                                                                               // 120
	    matchObject: function (obj) {                                                                                    // 121
	      return typeof Uint8Array !== 'undefined' && obj instanceof Uint8Array                                          // 122
	        || (obj && _.has(obj, '$Uint8ArrayPolyfill'));                                                               // 123
	    },                                                                                                               // 124
	    toJSONValue: function (obj) {                                                                                    // 125
	      return {$binary: Base64.encode(obj)};                                                                          // 126
	    },                                                                                                               // 127
	    fromJSONValue: function (obj) {                                                                                  // 128
	      return Base64.decode(obj.$binary);                                                                             // 129
	    }                                                                                                                // 130
	  },                                                                                                                 // 131
	  { // Escaping one level                                                                                            // 132
	    matchJSONValue: function (obj) {                                                                                 // 133
	      return _.has(obj, '$escape') && _.size(obj) === 1;                                                             // 134
	    },                                                                                                               // 135
	    matchObject: function (obj) {                                                                                    // 136
	      if (_.isEmpty(obj) || _.size(obj) > 2) {                                                                       // 137
	        return false;                                                                                                // 138
	      }                                                                                                              // 139
	      return _.any(builtinConverters, function (converter) {                                                         // 140
	        return converter.matchJSONValue(obj);                                                                        // 141
	      });                                                                                                            // 142
	    },                                                                                                               // 143
	    toJSONValue: function (obj) {                                                                                    // 144
	      var newObj = {};                                                                                               // 145
	      _.each(obj, function (value, key) {                                                                            // 146
	        newObj[key] = EJSON.toJSONValue(value);                                                                      // 147
	      });                                                                                                            // 148
	      return {$escape: newObj};                                                                                      // 149
	    },                                                                                                               // 150
	    fromJSONValue: function (obj) {                                                                                  // 151
	      var newObj = {};                                                                                               // 152
	      _.each(obj.$escape, function (value, key) {                                                                    // 153
	        newObj[key] = EJSON.fromJSONValue(value);                                                                    // 154
	      });                                                                                                            // 155
	      return newObj;                                                                                                 // 156
	    }                                                                                                                // 157
	  },                                                                                                                 // 158
	  { // Custom                                                                                                        // 159
	    matchJSONValue: function (obj) {                                                                                 // 160
	      return _.has(obj, '$type') && _.has(obj, '$value') && _.size(obj) === 2;                                       // 161
	    },                                                                                                               // 162
	    matchObject: function (obj) {                                                                                    // 163
	      return EJSON._isCustomType(obj);                                                                               // 164
	    },                                                                                                               // 165
	    toJSONValue: function (obj) {                                                                                    // 166
	      var jsonValue = Meteor._noYieldsAllowed(function () {                                                          // 167
	        return obj.toJSONValue();                                                                                    // 168
	      });                                                                                                            // 169
	      return {$type: obj.typeName(), $value: jsonValue};                                                             // 170
	    },                                                                                                               // 171
	    fromJSONValue: function (obj) {                                                                                  // 172
	      var typeName = obj.$type;                                                                                      // 173
	      if (!_.has(customTypes, typeName))                                                                             // 174
	        throw new Error("Custom EJSON type " + typeName + " is not defined");                                        // 175
	      var converter = customTypes[typeName];                                                                         // 176
	      return Meteor._noYieldsAllowed(function () {                                                                   // 177
	        return converter(obj.$value);                                                                                // 178
	      });                                                                                                            // 179
	    }                                                                                                                // 180
	  }                                                                                                                  // 181
	];                                                                                                                   // 182
	                                                                                                                     // 183
	EJSON._isCustomType = function (obj) {                                                                               // 184
	  return obj &&                                                                                                      // 185
	    typeof obj.toJSONValue === 'function' &&                                                                         // 186
	    typeof obj.typeName === 'function' &&                                                                            // 187
	    _.has(customTypes, obj.typeName());                                                                              // 188
	};                                                                                                                   // 189
	                                                                                                                     // 190
	EJSON._getTypes = function () {                                                                                      // 191
	  return customTypes;                                                                                                // 192
	};                                                                                                                   // 193
	                                                                                                                     // 194
	EJSON._getConverters = function () {                                                                                 // 195
	  return builtinConverters;                                                                                          // 196
	};                                                                                                                   // 197
	                                                                                                                     // 198
	// for both arrays and objects, in-place modification.                                                               // 199
	var adjustTypesToJSONValue =                                                                                         // 200
	EJSON._adjustTypesToJSONValue = function (obj) {                                                                     // 201
	  // Is it an atom that we need to adjust?                                                                           // 202
	  if (obj === null)                                                                                                  // 203
	    return null;                                                                                                     // 204
	  var maybeChanged = toJSONValueHelper(obj);                                                                         // 205
	  if (maybeChanged !== undefined)                                                                                    // 206
	    return maybeChanged;                                                                                             // 207
	                                                                                                                     // 208
	  // Other atoms are unchanged.                                                                                      // 209
	  if (typeof obj !== 'object')                                                                                       // 210
	    return obj;                                                                                                      // 211
	                                                                                                                     // 212
	  // Iterate over array or object structure.                                                                         // 213
	  _.each(obj, function (value, key) {                                                                                // 214
	    if (typeof value !== 'object' && value !== undefined &&                                                          // 215
	        !isInfOrNan(value))                                                                                          // 216
	      return; // continue                                                                                            // 217
	                                                                                                                     // 218
	    var changed = toJSONValueHelper(value);                                                                          // 219
	    if (changed) {                                                                                                   // 220
	      obj[key] = changed;                                                                                            // 221
	      return; // on to the next key                                                                                  // 222
	    }                                                                                                                // 223
	    // if we get here, value is an object but not adjustable                                                         // 224
	    // at this level.  recurse.                                                                                      // 225
	    adjustTypesToJSONValue(value);                                                                                   // 226
	  });                                                                                                                // 227
	  return obj;                                                                                                        // 228
	};                                                                                                                   // 229
	                                                                                                                     // 230
	// Either return the JSON-compatible version of the argument, or undefined (if                                       // 231
	// the item isn't itself replaceable, but maybe some fields in it are)                                               // 232
	var toJSONValueHelper = function (item) {                                                                            // 233
	  for (var i = 0; i < builtinConverters.length; i++) {                                                               // 234
	    var converter = builtinConverters[i];                                                                            // 235
	    if (converter.matchObject(item)) {                                                                               // 236
	      return converter.toJSONValue(item);                                                                            // 237
	    }                                                                                                                // 238
	  }                                                                                                                  // 239
	  return undefined;                                                                                                  // 240
	};                                                                                                                   // 241
	                                                                                                                     // 242
	/**                                                                                                                  // 243
	 * @summary Serialize an EJSON-compatible value into its plain JSON representation.                                  // 244
	 * @locus Anywhere                                                                                                   // 245
	 * @param {EJSON} val A value to serialize to plain JSON.                                                            // 246
	 */                                                                                                                  // 247
	EJSON.toJSONValue = function (item) {                                                                                // 248
	  var changed = toJSONValueHelper(item);                                                                             // 249
	  if (changed !== undefined)                                                                                         // 250
	    return changed;                                                                                                  // 251
	  if (typeof item === 'object') {                                                                                    // 252
	    item = EJSON.clone(item);                                                                                        // 253
	    adjustTypesToJSONValue(item);                                                                                    // 254
	  }                                                                                                                  // 255
	  return item;                                                                                                       // 256
	};                                                                                                                   // 257
	                                                                                                                     // 258
	// for both arrays and objects. Tries its best to just                                                               // 259
	// use the object you hand it, but may return something                                                              // 260
	// different if the object you hand it itself needs changing.                                                        // 261
	//                                                                                                                   // 262
	var adjustTypesFromJSONValue =                                                                                       // 263
	EJSON._adjustTypesFromJSONValue = function (obj) {                                                                   // 264
	  if (obj === null)                                                                                                  // 265
	    return null;                                                                                                     // 266
	  var maybeChanged = fromJSONValueHelper(obj);                                                                       // 267
	  if (maybeChanged !== obj)                                                                                          // 268
	    return maybeChanged;                                                                                             // 269
	                                                                                                                     // 270
	  // Other atoms are unchanged.                                                                                      // 271
	  if (typeof obj !== 'object')                                                                                       // 272
	    return obj;                                                                                                      // 273
	                                                                                                                     // 274
	  _.each(obj, function (value, key) {                                                                                // 275
	    if (typeof value === 'object') {                                                                                 // 276
	      var changed = fromJSONValueHelper(value);                                                                      // 277
	      if (value !== changed) {                                                                                       // 278
	        obj[key] = changed;                                                                                          // 279
	        return;                                                                                                      // 280
	      }                                                                                                              // 281
	      // if we get here, value is an object but not adjustable                                                       // 282
	      // at this level.  recurse.                                                                                    // 283
	      adjustTypesFromJSONValue(value);                                                                               // 284
	    }                                                                                                                // 285
	  });                                                                                                                // 286
	  return obj;                                                                                                        // 287
	};                                                                                                                   // 288
	                                                                                                                     // 289
	// Either return the argument changed to have the non-json                                                           // 290
	// rep of itself (the Object version) or the argument itself.                                                        // 291
	                                                                                                                     // 292
	// DOES NOT RECURSE.  For actually getting the fully-changed value, use                                              // 293
	// EJSON.fromJSONValue                                                                                               // 294
	var fromJSONValueHelper = function (value) {                                                                         // 295
	  if (typeof value === 'object' && value !== null) {                                                                 // 296
	    if (_.size(value) <= 2                                                                                           // 297
	        && _.all(value, function (v, k) {                                                                            // 298
	          return typeof k === 'string' && k.substr(0, 1) === '$';                                                    // 299
	        })) {                                                                                                        // 300
	      for (var i = 0; i < builtinConverters.length; i++) {                                                           // 301
	        var converter = builtinConverters[i];                                                                        // 302
	        if (converter.matchJSONValue(value)) {                                                                       // 303
	          return converter.fromJSONValue(value);                                                                     // 304
	        }                                                                                                            // 305
	      }                                                                                                              // 306
	    }                                                                                                                // 307
	  }                                                                                                                  // 308
	  return value;                                                                                                      // 309
	};                                                                                                                   // 310
	                                                                                                                     // 311
	/**                                                                                                                  // 312
	 * @summary Deserialize an EJSON value from its plain JSON representation.                                           // 313
	 * @locus Anywhere                                                                                                   // 314
	 * @param {JSONCompatible} val A value to deserialize into EJSON.                                                    // 315
	 */                                                                                                                  // 316
	EJSON.fromJSONValue = function (item) {                                                                              // 317
	  var changed = fromJSONValueHelper(item);                                                                           // 318
	  if (changed === item && typeof item === 'object') {                                                                // 319
	    item = EJSON.clone(item);                                                                                        // 320
	    adjustTypesFromJSONValue(item);                                                                                  // 321
	    return item;                                                                                                     // 322
	  } else {                                                                                                           // 323
	    return changed;                                                                                                  // 324
	  }                                                                                                                  // 325
	};                                                                                                                   // 326
	                                                                                                                     // 327
	/**                                                                                                                  // 328
	 * @summary Serialize a value to a string.                                                                           // 329
	                                                                                                                     // 330
	For EJSON values, the serialization fully represents the value. For non-EJSON values, serializes the same way as `JSON.stringify`.
	 * @locus Anywhere                                                                                                   // 332
	 * @param {EJSON} val A value to stringify.                                                                          // 333
	 * @param {Object} [options]                                                                                         // 334
	 * @param {Boolean | Integer | String} options.indent Indents objects and arrays for easy readability.  When `true`, indents by 2 spaces; when an integer, indents by that number of spaces; and when a string, uses the string as the indentation pattern.
	 * @param {Boolean} options.canonical When `true`, stringifies keys in an object in sorted order.                    // 336
	 */                                                                                                                  // 337
	EJSON.stringify = function (item, options) {                                                                         // 338
	  var json = EJSON.toJSONValue(item);                                                                                // 339
	  if (options && (options.canonical || options.indent)) {                                                            // 340
	    return EJSON._canonicalStringify(json, options);                                                                 // 341
	  } else {                                                                                                           // 342
	    return JSON.stringify(json);                                                                                     // 343
	  }                                                                                                                  // 344
	};                                                                                                                   // 345
	                                                                                                                     // 346
	/**                                                                                                                  // 347
	 * @summary Parse a string into an EJSON value. Throws an error if the string is not valid EJSON.                    // 348
	 * @locus Anywhere                                                                                                   // 349
	 * @param {String} str A string to parse into an EJSON value.                                                        // 350
	 */                                                                                                                  // 351
	EJSON.parse = function (item) {                                                                                      // 352
	  if (typeof item !== 'string')                                                                                      // 353
	    throw new Error("EJSON.parse argument should be a string");                                                      // 354
	  return EJSON.fromJSONValue(JSON.parse(item));                                                                      // 355
	};                                                                                                                   // 356
	                                                                                                                     // 357
	/**                                                                                                                  // 358
	 * @summary Returns true if `x` is a buffer of binary data, as returned from [`EJSON.newBinary`](#ejson_new_binary).
	 * @param {Object} x The variable to check.                                                                          // 360
	 * @locus Anywhere                                                                                                   // 361
	 */                                                                                                                  // 362
	EJSON.isBinary = function (obj) {                                                                                    // 363
	  return !!((typeof Uint8Array !== 'undefined' && obj instanceof Uint8Array) ||                                      // 364
	    (obj && obj.$Uint8ArrayPolyfill));                                                                               // 365
	};                                                                                                                   // 366
	                                                                                                                     // 367
	/**                                                                                                                  // 368
	 * @summary Return true if `a` and `b` are equal to each other.  Return false otherwise.  Uses the `equals` method on `a` if present, otherwise performs a deep comparison.
	 * @locus Anywhere                                                                                                   // 370
	 * @param {EJSON} a                                                                                                  // 371
	 * @param {EJSON} b                                                                                                  // 372
	 * @param {Object} [options]                                                                                         // 373
	 * @param {Boolean} options.keyOrderSensitive Compare in key sensitive order, if supported by the JavaScript implementation.  For example, `{a: 1, b: 2}` is equal to `{b: 2, a: 1}` only when `keyOrderSensitive` is `false`.  The default is `false`.
	 */                                                                                                                  // 375
	EJSON.equals = function (a, b, options) {                                                                            // 376
	  var i;                                                                                                             // 377
	  var keyOrderSensitive = !!(options && options.keyOrderSensitive);                                                  // 378
	  if (a === b)                                                                                                       // 379
	    return true;                                                                                                     // 380
	  if (_.isNaN(a) && _.isNaN(b))                                                                                      // 381
	    return true; // This differs from the IEEE spec for NaN equality, b/c we don't want                              // 382
	                 // anything ever with a NaN to be poisoned from becoming equal to anything.                         // 383
	  if (!a || !b) // if either one is falsy, they'd have to be === to be equal                                         // 384
	    return false;                                                                                                    // 385
	  if (!(typeof a === 'object' && typeof b === 'object'))                                                             // 386
	    return false;                                                                                                    // 387
	  if (a instanceof Date && b instanceof Date)                                                                        // 388
	    return a.valueOf() === b.valueOf();                                                                              // 389
	  if (EJSON.isBinary(a) && EJSON.isBinary(b)) {                                                                      // 390
	    if (a.length !== b.length)                                                                                       // 391
	      return false;                                                                                                  // 392
	    for (i = 0; i < a.length; i++) {                                                                                 // 393
	      if (a[i] !== b[i])                                                                                             // 394
	        return false;                                                                                                // 395
	    }                                                                                                                // 396
	    return true;                                                                                                     // 397
	  }                                                                                                                  // 398
	  if (typeof (a.equals) === 'function')                                                                              // 399
	    return a.equals(b, options);                                                                                     // 400
	  if (typeof (b.equals) === 'function')                                                                              // 401
	    return b.equals(a, options);                                                                                     // 402
	  if (a instanceof Array) {                                                                                          // 403
	    if (!(b instanceof Array))                                                                                       // 404
	      return false;                                                                                                  // 405
	    if (a.length !== b.length)                                                                                       // 406
	      return false;                                                                                                  // 407
	    for (i = 0; i < a.length; i++) {                                                                                 // 408
	      if (!EJSON.equals(a[i], b[i], options))                                                                        // 409
	        return false;                                                                                                // 410
	    }                                                                                                                // 411
	    return true;                                                                                                     // 412
	  }                                                                                                                  // 413
	  // fallback for custom types that don't implement their own equals                                                 // 414
	  switch (EJSON._isCustomType(a) + EJSON._isCustomType(b)) {                                                         // 415
	    case 1: return false;                                                                                            // 416
	    case 2: return EJSON.equals(EJSON.toJSONValue(a), EJSON.toJSONValue(b));                                         // 417
	  }                                                                                                                  // 418
	  // fall back to structural equality of objects                                                                     // 419
	  var ret;                                                                                                           // 420
	  if (keyOrderSensitive) {                                                                                           // 421
	    var bKeys = [];                                                                                                  // 422
	    _.each(b, function (val, x) {                                                                                    // 423
	        bKeys.push(x);                                                                                               // 424
	    });                                                                                                              // 425
	    i = 0;                                                                                                           // 426
	    ret = _.all(a, function (val, x) {                                                                               // 427
	      if (i >= bKeys.length) {                                                                                       // 428
	        return false;                                                                                                // 429
	      }                                                                                                              // 430
	      if (x !== bKeys[i]) {                                                                                          // 431
	        return false;                                                                                                // 432
	      }                                                                                                              // 433
	      if (!EJSON.equals(val, b[bKeys[i]], options)) {                                                                // 434
	        return false;                                                                                                // 435
	      }                                                                                                              // 436
	      i++;                                                                                                           // 437
	      return true;                                                                                                   // 438
	    });                                                                                                              // 439
	    return ret && i === bKeys.length;                                                                                // 440
	  } else {                                                                                                           // 441
	    i = 0;                                                                                                           // 442
	    ret = _.all(a, function (val, key) {                                                                             // 443
	      if (!_.has(b, key)) {                                                                                          // 444
	        return false;                                                                                                // 445
	      }                                                                                                              // 446
	      if (!EJSON.equals(val, b[key], options)) {                                                                     // 447
	        return false;                                                                                                // 448
	      }                                                                                                              // 449
	      i++;                                                                                                           // 450
	      return true;                                                                                                   // 451
	    });                                                                                                              // 452
	    return ret && _.size(b) === i;                                                                                   // 453
	  }                                                                                                                  // 454
	};                                                                                                                   // 455
	                                                                                                                     // 456
	/**                                                                                                                  // 457
	 * @summary Return a deep copy of `val`.                                                                             // 458
	 * @locus Anywhere                                                                                                   // 459
	 * @param {EJSON} val A value to copy.                                                                               // 460
	 */                                                                                                                  // 461
	EJSON.clone = function (v) {                                                                                         // 462
	  var ret;                                                                                                           // 463
	  if (typeof v !== "object")                                                                                         // 464
	    return v;                                                                                                        // 465
	  if (v === null)                                                                                                    // 466
	    return null; // null has typeof "object"                                                                         // 467
	  if (v instanceof Date)                                                                                             // 468
	    return new Date(v.getTime());                                                                                    // 469
	  // RegExps are not really EJSON elements (eg we don't define a serialization                                       // 470
	  // for them), but they're immutable anyway, so we can support them in clone.                                       // 471
	  if (v instanceof RegExp)                                                                                           // 472
	    return v;                                                                                                        // 473
	  if (EJSON.isBinary(v)) {                                                                                           // 474
	    ret = EJSON.newBinary(v.length);                                                                                 // 475
	    for (var i = 0; i < v.length; i++) {                                                                             // 476
	      ret[i] = v[i];                                                                                                 // 477
	    }                                                                                                                // 478
	    return ret;                                                                                                      // 479
	  }                                                                                                                  // 480
	  // XXX: Use something better than underscore's isArray                                                             // 481
	  if (_.isArray(v) || _.isArguments(v)) {                                                                            // 482
	    // For some reason, _.map doesn't work in this context on Opera (weird test                                      // 483
	    // failures).                                                                                                    // 484
	    ret = [];                                                                                                        // 485
	    for (i = 0; i < v.length; i++)                                                                                   // 486
	      ret[i] = EJSON.clone(v[i]);                                                                                    // 487
	    return ret;                                                                                                      // 488
	  }                                                                                                                  // 489
	  // handle general user-defined typed Objects if they have a clone method                                           // 490
	  if (typeof v.clone === 'function') {                                                                               // 491
	    return v.clone();                                                                                                // 492
	  }                                                                                                                  // 493
	  // handle other custom types                                                                                       // 494
	  if (EJSON._isCustomType(v)) {                                                                                      // 495
	    return EJSON.fromJSONValue(EJSON.clone(EJSON.toJSONValue(v)), true);                                             // 496
	  }                                                                                                                  // 497
	  // handle other objects                                                                                            // 498
	  ret = {};                                                                                                          // 499
	  _.each(v, function (value, key) {                                                                                  // 500
	    ret[key] = EJSON.clone(value);                                                                                   // 501
	  });                                                                                                                // 502
	  return ret;                                                                                                        // 503
	};                                                                                                                   // 504
	                                                                                                                     // 505
	/**                                                                                                                  // 506
	 * @summary Allocate a new buffer of binary data that EJSON can serialize.                                           // 507
	 * @locus Anywhere                                                                                                   // 508
	 * @param {Number} size The number of bytes of binary data to allocate.                                              // 509
	 */                                                                                                                  // 510
	// EJSON.newBinary is the public documented API for this functionality,                                              // 511
	// but the implementation is in the 'base64' package to avoid                                                        // 512
	// introducing a circular dependency. (If the implementation were here,                                              // 513
	// then 'base64' would have to use EJSON.newBinary, and 'ejson' would                                                // 514
	// also have to use 'base64'.)                                                                                       // 515
	EJSON.newBinary = Base64.newBinary;                                                                                  // 516
	                                                                                                                     // 517
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                   //
	// packages/ejson/stringify.js                                                                                       //
	//                                                                                                                   //
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                     //
	// Based on json2.js from https://github.com/douglascrockford/JSON-js                                                // 1
	//                                                                                                                   // 2
	//    json2.js                                                                                                       // 3
	//    2012-10-08                                                                                                     // 4
	//                                                                                                                   // 5
	//    Public Domain.                                                                                                 // 6
	//                                                                                                                   // 7
	//    NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.                                                        // 8
	                                                                                                                     // 9
	function quote(string) {                                                                                             // 10
	  return JSON.stringify(string);                                                                                     // 11
	}                                                                                                                    // 12
	                                                                                                                     // 13
	var str = function (key, holder, singleIndent, outerIndent, canonical) {                                             // 14
	                                                                                                                     // 15
	  // Produce a string from holder[key].                                                                              // 16
	                                                                                                                     // 17
	  var i;          // The loop counter.                                                                               // 18
	  var k;          // The member key.                                                                                 // 19
	  var v;          // The member value.                                                                               // 20
	  var length;                                                                                                        // 21
	  var innerIndent = outerIndent;                                                                                     // 22
	  var partial;                                                                                                       // 23
	  var value = holder[key];                                                                                           // 24
	                                                                                                                     // 25
	  // What happens next depends on the value's type.                                                                  // 26
	                                                                                                                     // 27
	  switch (typeof value) {                                                                                            // 28
	  case 'string':                                                                                                     // 29
	    return quote(value);                                                                                             // 30
	  case 'number':                                                                                                     // 31
	    // JSON numbers must be finite. Encode non-finite numbers as null.                                               // 32
	    return isFinite(value) ? String(value) : 'null';                                                                 // 33
	  case 'boolean':                                                                                                    // 34
	    return String(value);                                                                                            // 35
	  // If the type is 'object', we might be dealing with an object or an array or                                      // 36
	  // null.                                                                                                           // 37
	  case 'object':                                                                                                     // 38
	    // Due to a specification blunder in ECMAScript, typeof null is 'object',                                        // 39
	    // so watch out for that case.                                                                                   // 40
	    if (!value) {                                                                                                    // 41
	      return 'null';                                                                                                 // 42
	    }                                                                                                                // 43
	    // Make an array to hold the partial results of stringifying this object value.                                  // 44
	    innerIndent = outerIndent + singleIndent;                                                                        // 45
	    partial = [];                                                                                                    // 46
	                                                                                                                     // 47
	    // Is the value an array?                                                                                        // 48
	    if (_.isArray(value) || _.isArguments(value)) {                                                                  // 49
	                                                                                                                     // 50
	      // The value is an array. Stringify every element. Use null as a placeholder                                   // 51
	      // for non-JSON values.                                                                                        // 52
	                                                                                                                     // 53
	      length = value.length;                                                                                         // 54
	      for (i = 0; i < length; i += 1) {                                                                              // 55
	        partial[i] = str(i, value, singleIndent, innerIndent, canonical) || 'null';                                  // 56
	      }                                                                                                              // 57
	                                                                                                                     // 58
	      // Join all of the elements together, separated with commas, and wrap them in                                  // 59
	      // brackets.                                                                                                   // 60
	                                                                                                                     // 61
	      if (partial.length === 0) {                                                                                    // 62
	        v = '[]';                                                                                                    // 63
	      } else if (innerIndent) {                                                                                      // 64
	        v = '[\n' + innerIndent + partial.join(',\n' + innerIndent) + '\n' + outerIndent + ']';                      // 65
	      } else {                                                                                                       // 66
	        v = '[' + partial.join(',') + ']';                                                                           // 67
	      }                                                                                                              // 68
	      return v;                                                                                                      // 69
	    }                                                                                                                // 70
	                                                                                                                     // 71
	                                                                                                                     // 72
	    // Iterate through all of the keys in the object.                                                                // 73
	    var keys = _.keys(value);                                                                                        // 74
	    if (canonical)                                                                                                   // 75
	      keys = keys.sort();                                                                                            // 76
	    _.each(keys, function (k) {                                                                                      // 77
	      v = str(k, value, singleIndent, innerIndent, canonical);                                                       // 78
	      if (v) {                                                                                                       // 79
	        partial.push(quote(k) + (innerIndent ? ': ' : ':') + v);                                                     // 80
	      }                                                                                                              // 81
	    });                                                                                                              // 82
	                                                                                                                     // 83
	                                                                                                                     // 84
	    // Join all of the member texts together, separated with commas,                                                 // 85
	    // and wrap them in braces.                                                                                      // 86
	                                                                                                                     // 87
	    if (partial.length === 0) {                                                                                      // 88
	      v = '{}';                                                                                                      // 89
	    } else if (innerIndent) {                                                                                        // 90
	      v = '{\n' + innerIndent + partial.join(',\n' + innerIndent) + '\n' + outerIndent + '}';                        // 91
	    } else {                                                                                                         // 92
	      v = '{' + partial.join(',') + '}';                                                                             // 93
	    }                                                                                                                // 94
	    return v;                                                                                                        // 95
	  }                                                                                                                  // 96
	}                                                                                                                    // 97
	                                                                                                                     // 98
	// If the JSON object does not yet have a stringify method, give it one.                                             // 99
	                                                                                                                     // 100
	EJSON._canonicalStringify = function (value, options) {                                                              // 101
	  // Make a fake root object containing our value under the key of ''.                                               // 102
	  // Return the result of stringifying the value.                                                                    // 103
	  options = _.extend({                                                                                               // 104
	    indent: "",                                                                                                      // 105
	    canonical: false                                                                                                 // 106
	  }, options);                                                                                                       // 107
	  if (options.indent === true) {                                                                                     // 108
	    options.indent = "  ";                                                                                           // 109
	  } else if (typeof options.indent === 'number') {                                                                   // 110
	    var newIndent = "";                                                                                              // 111
	    for (var i = 0; i < options.indent; i++) {                                                                       // 112
	      newIndent += ' ';                                                                                              // 113
	    }                                                                                                                // 114
	    options.indent = newIndent;                                                                                      // 115
	  }                                                                                                                  // 116
	  return str('', {'': value}, options.indent, "", options.canonical);                                                // 117
	};                                                                                                                   // 118
	                                                                                                                     // 119
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.ejson = {}, {
	  EJSON: EJSON,
	  EJSONTest: EJSONTest
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/email.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	Package.email = {};
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/geojson-utils.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var meteorInstall = Package.modules.meteorInstall;
	var Buffer = Package.modules.Buffer;
	var process = Package.modules.process;
	
	/* Package-scope variables */
	var GeoJSON;
	
	var require = meteorInstall({"node_modules":{"meteor":{"geojson-utils":{"main.js":["./geojson-utils.js",function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                         //
	// packages/geojson-utils/main.js                                                                          //
	//                                                                                                         //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                           //
	exports.GeoJSON = require("./geojson-utils.js");                                                           // 1
	                                                                                                           // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"geojson-utils.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                         //
	// packages/geojson-utils/geojson-utils.js                                                                 //
	//                                                                                                         //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                           //
	(function () {                                                                                             // 1
	  var gju = {};                                                                                            // 2
	                                                                                                           // 3
	  // Export the geojson object for **CommonJS**                                                            // 4
	  if (typeof module !== 'undefined' && module.exports) {                                                   // 5
	    module.exports = gju;                                                                                  // 6
	  }                                                                                                        // 7
	                                                                                                           // 8
	  // adapted from http://www.kevlindev.com/gui/math/intersection/Intersection.js                           // 9
	  gju.lineStringsIntersect = function (l1, l2) {                                                           // 10
	    var intersects = [];                                                                                   // 11
	    for (var i = 0; i <= l1.coordinates.length - 2; ++i) {                                                 // 12
	      for (var j = 0; j <= l2.coordinates.length - 2; ++j) {                                               // 13
	        var a1 = {                                                                                         // 14
	          x: l1.coordinates[i][1],                                                                         // 15
	          y: l1.coordinates[i][0]                                                                          // 16
	        },                                                                                                 // 17
	          a2 = {                                                                                           // 18
	            x: l1.coordinates[i + 1][1],                                                                   // 19
	            y: l1.coordinates[i + 1][0]                                                                    // 20
	          },                                                                                               // 21
	          b1 = {                                                                                           // 22
	            x: l2.coordinates[j][1],                                                                       // 23
	            y: l2.coordinates[j][0]                                                                        // 24
	          },                                                                                               // 25
	          b2 = {                                                                                           // 26
	            x: l2.coordinates[j + 1][1],                                                                   // 27
	            y: l2.coordinates[j + 1][0]                                                                    // 28
	          },                                                                                               // 29
	          ua_t = (b2.x - b1.x) * (a1.y - b1.y) - (b2.y - b1.y) * (a1.x - b1.x),                            // 30
	          ub_t = (a2.x - a1.x) * (a1.y - b1.y) - (a2.y - a1.y) * (a1.x - b1.x),                            // 31
	          u_b = (b2.y - b1.y) * (a2.x - a1.x) - (b2.x - b1.x) * (a2.y - a1.y);                             // 32
	        if (u_b != 0) {                                                                                    // 33
	          var ua = ua_t / u_b,                                                                             // 34
	            ub = ub_t / u_b;                                                                               // 35
	          if (0 <= ua && ua <= 1 && 0 <= ub && ub <= 1) {                                                  // 36
	            intersects.push({                                                                              // 37
	              'type': 'Point',                                                                             // 38
	              'coordinates': [a1.x + ua * (a2.x - a1.x), a1.y + ua * (a2.y - a1.y)]                        // 39
	            });                                                                                            // 40
	          }                                                                                                // 41
	        }                                                                                                  // 42
	      }                                                                                                    // 43
	    }                                                                                                      // 44
	    if (intersects.length == 0) intersects = false;                                                        // 45
	    return intersects;                                                                                     // 46
	  }                                                                                                        // 47
	                                                                                                           // 48
	  // Bounding Box                                                                                          // 49
	                                                                                                           // 50
	  function boundingBoxAroundPolyCoords (coords) {                                                          // 51
	    var xAll = [], yAll = []                                                                               // 52
	                                                                                                           // 53
	    for (var i = 0; i < coords[0].length; i++) {                                                           // 54
	      xAll.push(coords[0][i][1])                                                                           // 55
	      yAll.push(coords[0][i][0])                                                                           // 56
	    }                                                                                                      // 57
	                                                                                                           // 58
	    xAll = xAll.sort(function (a,b) { return a - b })                                                      // 59
	    yAll = yAll.sort(function (a,b) { return a - b })                                                      // 60
	                                                                                                           // 61
	    return [ [xAll[0], yAll[0]], [xAll[xAll.length - 1], yAll[yAll.length - 1]] ]                          // 62
	  }                                                                                                        // 63
	                                                                                                           // 64
	  gju.pointInBoundingBox = function (point, bounds) {                                                      // 65
	    return !(point.coordinates[1] < bounds[0][0] || point.coordinates[1] > bounds[1][0] || point.coordinates[0] < bounds[0][1] || point.coordinates[0] > bounds[1][1]) 
	  }                                                                                                        // 67
	                                                                                                           // 68
	  // Point in Polygon                                                                                      // 69
	  // http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html#Listing the Vertices           // 70
	                                                                                                           // 71
	  function pnpoly (x,y,coords) {                                                                           // 72
	    var vert = [ [0,0] ]                                                                                   // 73
	                                                                                                           // 74
	    for (var i = 0; i < coords.length; i++) {                                                              // 75
	      for (var j = 0; j < coords[i].length; j++) {                                                         // 76
	        vert.push(coords[i][j])                                                                            // 77
	      }                                                                                                    // 78
	      vert.push([0,0])                                                                                     // 79
	    }                                                                                                      // 80
	                                                                                                           // 81
	    var inside = false                                                                                     // 82
	    for (var i = 0, j = vert.length - 1; i < vert.length; j = i++) {                                       // 83
	      if (((vert[i][0] > y) != (vert[j][0] > y)) && (x < (vert[j][1] - vert[i][1]) * (y - vert[i][0]) / (vert[j][0] - vert[i][0]) + vert[i][1])) inside = !inside
	    }                                                                                                      // 85
	                                                                                                           // 86
	    return inside                                                                                          // 87
	  }                                                                                                        // 88
	                                                                                                           // 89
	  gju.pointInPolygon = function (p, poly) {                                                                // 90
	    var coords = (poly.type == "Polygon") ? [ poly.coordinates ] : poly.coordinates                        // 91
	                                                                                                           // 92
	    var insideBox = false                                                                                  // 93
	    for (var i = 0; i < coords.length; i++) {                                                              // 94
	      if (gju.pointInBoundingBox(p, boundingBoxAroundPolyCoords(coords[i]))) insideBox = true              // 95
	    }                                                                                                      // 96
	    if (!insideBox) return false                                                                           // 97
	                                                                                                           // 98
	    var insidePoly = false                                                                                 // 99
	    for (var i = 0; i < coords.length; i++) {                                                              // 100
	      if (pnpoly(p.coordinates[1], p.coordinates[0], coords[i])) insidePoly = true                         // 101
	    }                                                                                                      // 102
	                                                                                                           // 103
	    return insidePoly                                                                                      // 104
	  }                                                                                                        // 105
	                                                                                                           // 106
	  gju.numberToRadius = function (number) {                                                                 // 107
	    return number * Math.PI / 180;                                                                         // 108
	  }                                                                                                        // 109
	                                                                                                           // 110
	  gju.numberToDegree = function (number) {                                                                 // 111
	    return number * 180 / Math.PI;                                                                         // 112
	  }                                                                                                        // 113
	                                                                                                           // 114
	  // written with help from @tautologe                                                                     // 115
	  gju.drawCircle = function (radiusInMeters, centerPoint, steps) {                                         // 116
	    var center = [centerPoint.coordinates[1], centerPoint.coordinates[0]],                                 // 117
	      dist = (radiusInMeters / 1000) / 6371,                                                               // 118
	      // convert meters to radiant                                                                         // 119
	      radCenter = [gju.numberToRadius(center[0]), gju.numberToRadius(center[1])],                          // 120
	      steps = steps || 15,                                                                                 // 121
	      // 15 sided circle                                                                                   // 122
	      poly = [[center[0], center[1]]];                                                                     // 123
	    for (var i = 0; i < steps; i++) {                                                                      // 124
	      var brng = 2 * Math.PI * i / steps;                                                                  // 125
	      var lat = Math.asin(Math.sin(radCenter[0]) * Math.cos(dist)                                          // 126
	              + Math.cos(radCenter[0]) * Math.sin(dist) * Math.cos(brng));                                 // 127
	      var lng = radCenter[1] + Math.atan2(Math.sin(brng) * Math.sin(dist) * Math.cos(radCenter[0]),        // 128
	                                          Math.cos(dist) - Math.sin(radCenter[0]) * Math.sin(lat));        // 129
	      poly[i] = [];                                                                                        // 130
	      poly[i][1] = gju.numberToDegree(lat);                                                                // 131
	      poly[i][0] = gju.numberToDegree(lng);                                                                // 132
	    }                                                                                                      // 133
	    return {                                                                                               // 134
	      "type": "Polygon",                                                                                   // 135
	      "coordinates": [poly]                                                                                // 136
	    };                                                                                                     // 137
	  }                                                                                                        // 138
	                                                                                                           // 139
	  // assumes rectangle starts at lower left point                                                          // 140
	  gju.rectangleCentroid = function (rectangle) {                                                           // 141
	    var bbox = rectangle.coordinates[0];                                                                   // 142
	    var xmin = bbox[0][0],                                                                                 // 143
	      ymin = bbox[0][1],                                                                                   // 144
	      xmax = bbox[2][0],                                                                                   // 145
	      ymax = bbox[2][1];                                                                                   // 146
	    var xwidth = xmax - xmin;                                                                              // 147
	    var ywidth = ymax - ymin;                                                                              // 148
	    return {                                                                                               // 149
	      'type': 'Point',                                                                                     // 150
	      'coordinates': [xmin + xwidth / 2, ymin + ywidth / 2]                                                // 151
	    };                                                                                                     // 152
	  }                                                                                                        // 153
	                                                                                                           // 154
	  // from http://www.movable-type.co.uk/scripts/latlong.html                                               // 155
	  gju.pointDistance = function (pt1, pt2) {                                                                // 156
	    var lon1 = pt1.coordinates[0],                                                                         // 157
	      lat1 = pt1.coordinates[1],                                                                           // 158
	      lon2 = pt2.coordinates[0],                                                                           // 159
	      lat2 = pt2.coordinates[1],                                                                           // 160
	      dLat = gju.numberToRadius(lat2 - lat1),                                                              // 161
	      dLon = gju.numberToRadius(lon2 - lon1),                                                              // 162
	      a = Math.pow(Math.sin(dLat / 2), 2) + Math.cos(gju.numberToRadius(lat1))                             // 163
	        * Math.cos(gju.numberToRadius(lat2)) * Math.pow(Math.sin(dLon / 2), 2),                            // 164
	      c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));                                                  // 165
	    // Earth radius is 6371 km                                                                             // 166
	    return (6371 * c) * 1000; // returns meters                                                            // 167
	  },                                                                                                       // 168
	                                                                                                           // 169
	  // checks if geometry lies entirely within a circle                                                      // 170
	  // works with Point, LineString, Polygon                                                                 // 171
	  gju.geometryWithinRadius = function (geometry, center, radius) {                                         // 172
	    if (geometry.type == 'Point') {                                                                        // 173
	      return gju.pointDistance(geometry, center) <= radius;                                                // 174
	    } else if (geometry.type == 'LineString' || geometry.type == 'Polygon') {                              // 175
	      var point = {};                                                                                      // 176
	      var coordinates;                                                                                     // 177
	      if (geometry.type == 'Polygon') {                                                                    // 178
	        // it's enough to check the exterior ring of the Polygon                                           // 179
	        coordinates = geometry.coordinates[0];                                                             // 180
	      } else {                                                                                             // 181
	        coordinates = geometry.coordinates;                                                                // 182
	      }                                                                                                    // 183
	      for (var i in coordinates) {                                                                         // 184
	        point.coordinates = coordinates[i];                                                                // 185
	        if (gju.pointDistance(point, center) > radius) {                                                   // 186
	          return false;                                                                                    // 187
	        }                                                                                                  // 188
	      }                                                                                                    // 189
	    }                                                                                                      // 190
	    return true;                                                                                           // 191
	  }                                                                                                        // 192
	                                                                                                           // 193
	  // adapted from http://paulbourke.net/geometry/polyarea/javascript.txt                                   // 194
	  gju.area = function (polygon) {                                                                          // 195
	    var area = 0;                                                                                          // 196
	    // TODO: polygon holes at coordinates[1]                                                               // 197
	    var points = polygon.coordinates[0];                                                                   // 198
	    var j = points.length - 1;                                                                             // 199
	    var p1, p2;                                                                                            // 200
	                                                                                                           // 201
	    for (var i = 0; i < points.length; j = i++) {                                                          // 202
	      var p1 = {                                                                                           // 203
	        x: points[i][1],                                                                                   // 204
	        y: points[i][0]                                                                                    // 205
	      };                                                                                                   // 206
	      var p2 = {                                                                                           // 207
	        x: points[j][1],                                                                                   // 208
	        y: points[j][0]                                                                                    // 209
	      };                                                                                                   // 210
	      area += p1.x * p2.y;                                                                                 // 211
	      area -= p1.y * p2.x;                                                                                 // 212
	    }                                                                                                      // 213
	                                                                                                           // 214
	    area /= 2;                                                                                             // 215
	    return area;                                                                                           // 216
	  },                                                                                                       // 217
	                                                                                                           // 218
	  // adapted from http://paulbourke.net/geometry/polyarea/javascript.txt                                   // 219
	  gju.centroid = function (polygon) {                                                                      // 220
	    var f, x = 0,                                                                                          // 221
	      y = 0;                                                                                               // 222
	    // TODO: polygon holes at coordinates[1]                                                               // 223
	    var points = polygon.coordinates[0];                                                                   // 224
	    var j = points.length - 1;                                                                             // 225
	    var p1, p2;                                                                                            // 226
	                                                                                                           // 227
	    for (var i = 0; i < points.length; j = i++) {                                                          // 228
	      var p1 = {                                                                                           // 229
	        x: points[i][1],                                                                                   // 230
	        y: points[i][0]                                                                                    // 231
	      };                                                                                                   // 232
	      var p2 = {                                                                                           // 233
	        x: points[j][1],                                                                                   // 234
	        y: points[j][0]                                                                                    // 235
	      };                                                                                                   // 236
	      f = p1.x * p2.y - p2.x * p1.y;                                                                       // 237
	      x += (p1.x + p2.x) * f;                                                                              // 238
	      y += (p1.y + p2.y) * f;                                                                              // 239
	    }                                                                                                      // 240
	                                                                                                           // 241
	    f = gju.area(polygon) * 6;                                                                             // 242
	    return {                                                                                               // 243
	      'type': 'Point',                                                                                     // 244
	      'coordinates': [y / f, x / f]                                                                        // 245
	    };                                                                                                     // 246
	  },                                                                                                       // 247
	                                                                                                           // 248
	  gju.simplify = function (source, kink) { /* source[] array of geojson points */                          // 249
	    /* kink	in metres, kinks above this depth kept  */                                                     // 250
	    /* kink depth is the height of the triangle abc where a-b and b-c are two consecutive line segments */
	    kink = kink || 20;                                                                                     // 252
	    source = source.map(function (o) {                                                                     // 253
	      return {                                                                                             // 254
	        lng: o.coordinates[0],                                                                             // 255
	        lat: o.coordinates[1]                                                                              // 256
	      }                                                                                                    // 257
	    });                                                                                                    // 258
	                                                                                                           // 259
	    var n_source, n_stack, n_dest, start, end, i, sig;                                                     // 260
	    var dev_sqr, max_dev_sqr, band_sqr;                                                                    // 261
	    var x12, y12, d12, x13, y13, d13, x23, y23, d23;                                                       // 262
	    var F = (Math.PI / 180.0) * 0.5;                                                                       // 263
	    var index = new Array(); /* aray of indexes of source points to include in the reduced line */         // 264
	    var sig_start = new Array(); /* indices of start & end of working section */                           // 265
	    var sig_end = new Array();                                                                             // 266
	                                                                                                           // 267
	    /* check for simple cases */                                                                           // 268
	                                                                                                           // 269
	    if (source.length < 3) return (source); /* one or two points */                                        // 270
	                                                                                                           // 271
	    /* more complex case. initialize stack */                                                              // 272
	                                                                                                           // 273
	    n_source = source.length;                                                                              // 274
	    band_sqr = kink * 360.0 / (2.0 * Math.PI * 6378137.0); /* Now in degrees */                            // 275
	    band_sqr *= band_sqr;                                                                                  // 276
	    n_dest = 0;                                                                                            // 277
	    sig_start[0] = 0;                                                                                      // 278
	    sig_end[0] = n_source - 1;                                                                             // 279
	    n_stack = 1;                                                                                           // 280
	                                                                                                           // 281
	    /* while the stack is not empty  ... */                                                                // 282
	    while (n_stack > 0) {                                                                                  // 283
	                                                                                                           // 284
	      /* ... pop the top-most entries off the stacks */                                                    // 285
	                                                                                                           // 286
	      start = sig_start[n_stack - 1];                                                                      // 287
	      end = sig_end[n_stack - 1];                                                                          // 288
	      n_stack--;                                                                                           // 289
	                                                                                                           // 290
	      if ((end - start) > 1) { /* any intermediate points ? */                                             // 291
	                                                                                                           // 292
	        /* ... yes, so find most deviant intermediate point to                                             // 293
	        either side of line joining start & end points */                                                  // 294
	                                                                                                           // 295
	        x12 = (source[end].lng() - source[start].lng());                                                   // 296
	        y12 = (source[end].lat() - source[start].lat());                                                   // 297
	        if (Math.abs(x12) > 180.0) x12 = 360.0 - Math.abs(x12);                                            // 298
	        x12 *= Math.cos(F * (source[end].lat() + source[start].lat())); /* use avg lat to reduce lng */    // 299
	        d12 = (x12 * x12) + (y12 * y12);                                                                   // 300
	                                                                                                           // 301
	        for (i = start + 1, sig = start, max_dev_sqr = -1.0; i < end; i++) {                               // 302
	                                                                                                           // 303
	          x13 = source[i].lng() - source[start].lng();                                                     // 304
	          y13 = source[i].lat() - source[start].lat();                                                     // 305
	          if (Math.abs(x13) > 180.0) x13 = 360.0 - Math.abs(x13);                                          // 306
	          x13 *= Math.cos(F * (source[i].lat() + source[start].lat()));                                    // 307
	          d13 = (x13 * x13) + (y13 * y13);                                                                 // 308
	                                                                                                           // 309
	          x23 = source[i].lng() - source[end].lng();                                                       // 310
	          y23 = source[i].lat() - source[end].lat();                                                       // 311
	          if (Math.abs(x23) > 180.0) x23 = 360.0 - Math.abs(x23);                                          // 312
	          x23 *= Math.cos(F * (source[i].lat() + source[end].lat()));                                      // 313
	          d23 = (x23 * x23) + (y23 * y23);                                                                 // 314
	                                                                                                           // 315
	          if (d13 >= (d12 + d23)) dev_sqr = d23;                                                           // 316
	          else if (d23 >= (d12 + d13)) dev_sqr = d13;                                                      // 317
	          else dev_sqr = (x13 * y12 - y13 * x12) * (x13 * y12 - y13 * x12) / d12; // solve triangle        // 318
	          if (dev_sqr > max_dev_sqr) {                                                                     // 319
	            sig = i;                                                                                       // 320
	            max_dev_sqr = dev_sqr;                                                                         // 321
	          }                                                                                                // 322
	        }                                                                                                  // 323
	                                                                                                           // 324
	        if (max_dev_sqr < band_sqr) { /* is there a sig. intermediate point ? */                           // 325
	          /* ... no, so transfer current start point */                                                    // 326
	          index[n_dest] = start;                                                                           // 327
	          n_dest++;                                                                                        // 328
	        } else { /* ... yes, so push two sub-sections on stack for further processing */                   // 329
	          n_stack++;                                                                                       // 330
	          sig_start[n_stack - 1] = sig;                                                                    // 331
	          sig_end[n_stack - 1] = end;                                                                      // 332
	          n_stack++;                                                                                       // 333
	          sig_start[n_stack - 1] = start;                                                                  // 334
	          sig_end[n_stack - 1] = sig;                                                                      // 335
	        }                                                                                                  // 336
	      } else { /* ... no intermediate points, so transfer current start point */                           // 337
	        index[n_dest] = start;                                                                             // 338
	        n_dest++;                                                                                          // 339
	      }                                                                                                    // 340
	    }                                                                                                      // 341
	                                                                                                           // 342
	    /* transfer last point */                                                                              // 343
	    index[n_dest] = n_source - 1;                                                                          // 344
	    n_dest++;                                                                                              // 345
	                                                                                                           // 346
	    /* make return array */                                                                                // 347
	    var r = new Array();                                                                                   // 348
	    for (var i = 0; i < n_dest; i++)                                                                       // 349
	      r.push(source[index[i]]);                                                                            // 350
	                                                                                                           // 351
	    return r.map(function (o) {                                                                            // 352
	      return {                                                                                             // 353
	        type: "Point",                                                                                     // 354
	        coordinates: [o.lng, o.lat]                                                                        // 355
	      }                                                                                                    // 356
	    });                                                                                                    // 357
	  }                                                                                                        // 358
	                                                                                                           // 359
	  // http://www.movable-type.co.uk/scripts/latlong.html#destPoint                                          // 360
	  gju.destinationPoint = function (pt, brng, dist) {                                                       // 361
	    dist = dist/6371;  // convert dist to angular distance in radians                                      // 362
	    brng = gju.numberToRadius(brng);                                                                       // 363
	                                                                                                           // 364
	    var lat1 = gju.numberToRadius(pt.coordinates[0]);                                                      // 365
	    var lon1 = gju.numberToRadius(pt.coordinates[1]);                                                      // 366
	                                                                                                           // 367
	    var lat2 = Math.asin( Math.sin(lat1)*Math.cos(dist) +                                                  // 368
	                          Math.cos(lat1)*Math.sin(dist)*Math.cos(brng) );                                  // 369
	    var lon2 = lon1 + Math.atan2(Math.sin(brng)*Math.sin(dist)*Math.cos(lat1),                             // 370
	                                 Math.cos(dist)-Math.sin(lat1)*Math.sin(lat2));                            // 371
	    lon2 = (lon2+3*Math.PI) % (2*Math.PI) - Math.PI;  // normalise to -180..+180º                          // 372
	                                                                                                           // 373
	    return {                                                                                               // 374
	      'type': 'Point',                                                                                     // 375
	      'coordinates': [gju.numberToDegree(lat2), gju.numberToDegree(lon2)]                                  // 376
	    };                                                                                                     // 377
	  };                                                                                                       // 378
	                                                                                                           // 379
	})();                                                                                                      // 380
	                                                                                                           // 381
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}}}}},{"extensions":[".js",".json"]});
	var exports = require("./node_modules/meteor/geojson-utils/main.js");
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['geojson-utils'] = exports, {
	  GeoJSON: GeoJSON
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/http.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	var URL = Package.url.URL;
	var meteorInstall = Package.modules.meteorInstall;
	var Buffer = Package.modules.Buffer;
	var process = Package.modules.process;
	var Symbol = Package['ecmascript-runtime'].Symbol;
	var Map = Package['ecmascript-runtime'].Map;
	var Set = Package['ecmascript-runtime'].Set;
	var meteorBabelHelpers = Package['babel-runtime'].meteorBabelHelpers;
	var Promise = Package.promise.Promise;
	
	/* Package-scope variables */
	var makeErrorByStatus, populateData, HTTP;
	
	var require = meteorInstall({"node_modules":{"meteor":{"http":{"httpcall_common.js":function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                    //
	// packages/http/httpcall_common.js                                                                                   //
	//                                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                      //
	var MAX_LENGTH = 500; // if you change this, also change the appropriate test                                         // 1
	                                                                                                                      //
	makeErrorByStatus = function makeErrorByStatus(statusCode, content) {                                                 // 3
	  var message = 'failed [' + statusCode + ']';                                                                        // 4
	                                                                                                                      //
	  if (content) {                                                                                                      // 6
	    var stringContent = typeof content == "string" ? content : content.toString();                                    // 7
	                                                                                                                      //
	    message += ' ' + truncate(stringContent.replace(/\n/g, ' '), MAX_LENGTH);                                         // 10
	  }                                                                                                                   // 11
	                                                                                                                      //
	  return new Error(message);                                                                                          // 13
	};                                                                                                                    // 14
	                                                                                                                      //
	function truncate(str, length) {                                                                                      // 16
	  return str.length > length ? str.slice(0, length) + '...' : str;                                                    // 17
	}                                                                                                                     // 18
	                                                                                                                      //
	// Fill in `response.data` if the content-type is JSON.                                                               // 20
	populateData = function populateData(response) {                                                                      // 21
	  // Read Content-Type header, up to a ';' if there is one.                                                           // 22
	  // A typical header might be "application/json; charset=utf-8"                                                      // 23
	  // or just "application/json".                                                                                      // 24
	  var contentType = (response.headers['content-type'] || ';').split(';')[0];                                          // 25
	                                                                                                                      //
	  // Only try to parse data as JSON if server sets correct content type.                                              // 27
	  if (_.include(['application/json', 'text/javascript', 'application/javascript', 'application/x-javascript'], contentType)) {
	    try {                                                                                                             // 30
	      response.data = JSON.parse(response.content);                                                                   // 31
	    } catch (err) {                                                                                                   // 32
	      response.data = null;                                                                                           // 33
	    }                                                                                                                 // 34
	  } else {                                                                                                            // 35
	    response.data = null;                                                                                             // 36
	  }                                                                                                                   // 37
	};                                                                                                                    // 38
	                                                                                                                      //
	HTTP = {};                                                                                                            // 40
	                                                                                                                      //
	/**                                                                                                                   // 42
	 * @summary Send an HTTP `GET` request. Equivalent to calling [`HTTP.call`](#http_call) with "GET" as the first argument.
	 * @param {String} url The URL to which the request should be sent.                                                   //
	 * @param {Object} [callOptions] Options passed on to [`HTTP.call`](#http_call).                                      //
	 * @param {Function} [asyncCallback] Callback that is called when the request is completed. Required on the client.   //
	 * @locus Anywhere                                                                                                    //
	 */                                                                                                                   //
	HTTP.get = function () /* varargs */{                                                                                 // 49
	  return HTTP.call.apply(this, ["GET"].concat(_.toArray(arguments)));                                                 // 50
	};                                                                                                                    // 51
	                                                                                                                      //
	/**                                                                                                                   // 53
	 * @summary Send an HTTP `POST` request. Equivalent to calling [`HTTP.call`](#http_call) with "POST" as the first argument.
	 * @param {String} url The URL to which the request should be sent.                                                   //
	 * @param {Object} [callOptions] Options passed on to [`HTTP.call`](#http_call).                                      //
	 * @param {Function} [asyncCallback] Callback that is called when the request is completed. Required on the client.   //
	 * @locus Anywhere                                                                                                    //
	 */                                                                                                                   //
	HTTP.post = function () /* varargs */{                                                                                // 60
	  return HTTP.call.apply(this, ["POST"].concat(_.toArray(arguments)));                                                // 61
	};                                                                                                                    // 62
	                                                                                                                      //
	/**                                                                                                                   // 64
	 * @summary Send an HTTP `PUT` request. Equivalent to calling [`HTTP.call`](#http_call) with "PUT" as the first argument.
	 * @param {String} url The URL to which the request should be sent.                                                   //
	 * @param {Object} [callOptions] Options passed on to [`HTTP.call`](#http_call).                                      //
	 * @param {Function} [asyncCallback] Callback that is called when the request is completed. Required on the client.   //
	 * @locus Anywhere                                                                                                    //
	 */                                                                                                                   //
	HTTP.put = function () /* varargs */{                                                                                 // 71
	  return HTTP.call.apply(this, ["PUT"].concat(_.toArray(arguments)));                                                 // 72
	};                                                                                                                    // 73
	                                                                                                                      //
	/**                                                                                                                   // 75
	 * @summary Send an HTTP `DELETE` request. Equivalent to calling [`HTTP.call`](#http_call) with "DELETE" as the first argument. (Named `del` to avoid conflict with the Javascript keyword `delete`)
	 * @param {String} url The URL to which the request should be sent.                                                   //
	 * @param {Object} [callOptions] Options passed on to [`HTTP.call`](#http_call).                                      //
	 * @param {Function} [asyncCallback] Callback that is called when the request is completed. Required on the client.   //
	 * @locus Anywhere                                                                                                    //
	 */                                                                                                                   //
	HTTP.del = function () /* varargs */{                                                                                 // 82
	  return HTTP.call.apply(this, ["DELETE"].concat(_.toArray(arguments)));                                              // 83
	};                                                                                                                    // 84
	                                                                                                                      //
	/**                                                                                                                   // 86
	 * @summary Send an HTTP `PATCH` request. Equivalent to calling [`HTTP.call`](#http_call) with "PATCH" as the first argument.
	 * @param {String} url The URL to which the request should be sent.                                                   //
	 * @param {Object} [callOptions] Options passed on to [`HTTP.call`](#http_call).                                      //
	 * @param {Function} [asyncCallback] Callback that is called when the request is completed. Required on the client.   //
	 * @locus Anywhere                                                                                                    //
	 */                                                                                                                   //
	HTTP.patch = function () /* varargs */{                                                                               // 93
	  return HTTP.call.apply(this, ["PATCH"].concat(_.toArray(arguments)));                                               // 94
	};                                                                                                                    // 95
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"httpcall_client.js":function(require,exports,module){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                    //
	// packages/http/httpcall_client.js                                                                                   //
	//                                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                      //
	/**                                                                                                                   // 1
	 * @summary Perform an outbound HTTP request.                                                                         //
	 * @locus Anywhere                                                                                                    //
	 * @param {String} method The [HTTP method](http://en.wikipedia.org/wiki/HTTP_method) to use, such as "`GET`", "`POST`", or "`HEAD`".
	 * @param {String} url The URL to retrieve.                                                                           //
	 * @param {Object} [options]                                                                                          //
	 * @param {String} options.content String to use as the HTTP request body.                                            //
	 * @param {Object} options.data JSON-able object to stringify and use as the HTTP request body. Overwrites `content`.
	 * @param {String} options.query Query string to go in the URL. Overwrites any query string in `url`.                 //
	 * @param {Object} options.params Dictionary of request parameters to be encoded and placed in the URL (for GETs) or request body (for POSTs).  If `content` or `data` is specified, `params` will always be placed in the URL.
	 * @param {String} options.auth HTTP basic authentication string of the form `"username:password"`                    //
	 * @param {Object} options.headers Dictionary of strings, headers to add to the HTTP request.                         //
	 * @param {Number} options.timeout Maximum time in milliseconds to wait for the request before failing.  There is no timeout by default.
	 * @param {Boolean} options.followRedirects If `true`, transparently follow HTTP redirects. Cannot be set to `false` on the client. Default `true`.
	 * @param {Object} options.npmRequestOptions On the server, `HTTP.call` is implemented by using the [npm `request` module](https://www.npmjs.com/package/request). Any options in this object will be passed directly to the `request` invocation.
	 * @param {Function} options.beforeSend On the client, this will be called before the request is sent to allow for more direct manipulation of the underlying XMLHttpRequest object, which will be passed as the first argument. If the callback returns `false`, the request will be not be send.
	 * @param {Function} [asyncCallback] Optional callback.  If passed, the method runs asynchronously, instead of synchronously, and calls asyncCallback.  On the client, this callback is required.
	 */                                                                                                                   //
	HTTP.call = function (method, url, options, callback) {                                                               // 19
	                                                                                                                      //
	  ////////// Process arguments //////////                                                                             // 21
	                                                                                                                      //
	  if (!callback && typeof options === "function") {                                                                   // 23
	    // support (method, url, callback) argument list                                                                  // 24
	    callback = options;                                                                                               // 25
	    options = null;                                                                                                   // 26
	  }                                                                                                                   // 27
	                                                                                                                      //
	  options = options || {};                                                                                            // 29
	                                                                                                                      //
	  if (typeof callback !== "function") throw new Error("Can't make a blocking HTTP call from the client; callback required.");
	                                                                                                                      //
	  method = (method || "").toUpperCase();                                                                              // 35
	                                                                                                                      //
	  var headers = {};                                                                                                   // 37
	                                                                                                                      //
	  var content = options.content;                                                                                      // 39
	  if (options.data) {                                                                                                 // 40
	    content = JSON.stringify(options.data);                                                                           // 41
	    headers['Content-Type'] = 'application/json';                                                                     // 42
	  }                                                                                                                   // 43
	                                                                                                                      //
	  var params_for_url, params_for_body;                                                                                // 45
	  if (content || method === "GET" || method === "HEAD") params_for_url = options.params;else params_for_body = options.params;
	                                                                                                                      //
	  url = URL._constructUrl(url, options.query, params_for_url);                                                        // 51
	                                                                                                                      //
	  if (options.followRedirects === false) throw new Error("Option followRedirects:false not supported on client.");    // 53
	                                                                                                                      //
	  if (_.has(options, 'npmRequestOptions')) {                                                                          // 56
	    throw new Error("Option npmRequestOptions not supported on client.");                                             // 57
	  }                                                                                                                   // 58
	                                                                                                                      //
	  var username, password;                                                                                             // 60
	  if (options.auth) {                                                                                                 // 61
	    var colonLoc = options.auth.indexOf(':');                                                                         // 62
	    if (colonLoc < 0) throw new Error('auth option should be of the form "username:password"');                       // 63
	    username = options.auth.substring(0, colonLoc);                                                                   // 65
	    password = options.auth.substring(colonLoc + 1);                                                                  // 66
	  }                                                                                                                   // 67
	                                                                                                                      //
	  if (params_for_body) {                                                                                              // 69
	    content = URL._encodeParams(params_for_body);                                                                     // 70
	  }                                                                                                                   // 71
	                                                                                                                      //
	  _.extend(headers, options.headers || {});                                                                           // 73
	                                                                                                                      //
	  ////////// Callback wrapping //////////                                                                             // 75
	                                                                                                                      //
	  // wrap callback to add a 'response' property on an error, in case                                                  // 77
	  // we have both (http 4xx/5xx error, which has a response payload)                                                  // 78
	  callback = function (callback) {                                                                                    // 79
	    return function (error, response) {                                                                               // 80
	      if (error && response) error.response = response;                                                               // 81
	      callback(error, response);                                                                                      // 83
	    };                                                                                                                // 84
	  }(callback);                                                                                                        // 85
	                                                                                                                      //
	  // safety belt: only call the callback once.                                                                        // 87
	  callback = _.once(callback);                                                                                        // 88
	                                                                                                                      //
	  ////////// Kickoff! //////////                                                                                      // 91
	                                                                                                                      //
	  // from this point on, errors are because of something remote, not                                                  // 93
	  // something we should check in advance. Turn exceptions into error                                                 // 94
	  // results.                                                                                                         // 95
	  try {                                                                                                               // 96
	    // setup XHR object                                                                                               // 97
	    var xhr;                                                                                                          // 98
	    if (typeof XMLHttpRequest !== "undefined") xhr = new XMLHttpRequest();else if (typeof ActiveXObject !== "undefined") xhr = new ActiveXObject("Microsoft.XMLHttp"); // IE6
	    else throw new Error("Can't create XMLHttpRequest"); // ???                                                       // 101
	                                                                                                                      //
	    xhr.open(method, url, true, username, password);                                                                  // 106
	                                                                                                                      //
	    for (var k in meteorBabelHelpers.sanitizeForInObject(headers)) {                                                  // 108
	      xhr.setRequestHeader(k, headers[k]);                                                                            // 109
	    } // setup timeout                                                                                                // 108
	    var timed_out = false;                                                                                            // 113
	    var timer;                                                                                                        // 114
	    if (options.timeout) {                                                                                            // 115
	      timer = Meteor.setTimeout(function () {                                                                         // 116
	        timed_out = true;                                                                                             // 117
	        xhr.abort();                                                                                                  // 118
	      }, options.timeout);                                                                                            // 119
	    };                                                                                                                // 120
	                                                                                                                      //
	    // callback on complete                                                                                           // 122
	    xhr.onreadystatechange = function (evt) {                                                                         // 123
	      if (xhr.readyState === 4) {                                                                                     // 124
	        // COMPLETE                                                                                                   // 124
	        if (timer) Meteor.clearTimeout(timer);                                                                        // 125
	                                                                                                                      //
	        if (timed_out) {                                                                                              // 128
	          callback(new Error("timeout"));                                                                             // 129
	        } else if (!xhr.status) {                                                                                     // 130
	          // no HTTP response                                                                                         // 131
	          callback(new Error("network"));                                                                             // 132
	        } else {                                                                                                      // 133
	                                                                                                                      //
	          var response = {};                                                                                          // 135
	          response.statusCode = xhr.status;                                                                           // 136
	          response.content = xhr.responseText;                                                                        // 137
	                                                                                                                      //
	          response.headers = {};                                                                                      // 139
	          var header_str = xhr.getAllResponseHeaders();                                                               // 140
	                                                                                                                      //
	          // https://github.com/meteor/meteor/issues/553                                                              // 142
	          //                                                                                                          // 143
	          // In Firefox there is a weird issue, sometimes                                                             // 144
	          // getAllResponseHeaders returns the empty string, but                                                      // 145
	          // getResponseHeader returns correct results. Possibly this                                                 // 146
	          // issue:                                                                                                   // 147
	          // https://bugzilla.mozilla.org/show_bug.cgi?id=608735                                                      // 148
	          //                                                                                                          // 149
	          // If this happens we can't get a full list of headers, but                                                 // 150
	          // at least get content-type so our JSON decoding happens                                                   // 151
	          // correctly. In theory, we could try and rescue more header                                                // 152
	          // values with a list of common headers, but content-type is                                                // 153
	          // the only vital one for now.                                                                              // 154
	          if ("" === header_str && xhr.getResponseHeader("content-type")) header_str = "content-type: " + xhr.getResponseHeader("content-type");
	                                                                                                                      //
	          var headers_raw = header_str.split(/\r?\n/);                                                                // 159
	          _.each(headers_raw, function (h) {                                                                          // 160
	            var m = /^(.*?):(?:\s+)(.*)$/.exec(h);                                                                    // 161
	            if (m && m.length === 3) response.headers[m[1].toLowerCase()] = m[2];                                     // 162
	          });                                                                                                         // 164
	                                                                                                                      //
	          populateData(response);                                                                                     // 166
	                                                                                                                      //
	          var error = null;                                                                                           // 168
	          if (response.statusCode >= 400) error = makeErrorByStatus(response.statusCode, response.content);           // 169
	                                                                                                                      //
	          callback(error, response);                                                                                  // 172
	        }                                                                                                             // 173
	      }                                                                                                               // 174
	    };                                                                                                                // 175
	                                                                                                                      //
	    // Allow custom control over XHR and abort early.                                                                 // 177
	    if (options.beforeSend) {                                                                                         // 178
	      // Sanity                                                                                                       // 179
	      var beforeSend = _.once(options.beforeSend);                                                                    // 180
	                                                                                                                      //
	      // Call the callback and check to see if the request was aborted                                                // 182
	      if (false === beforeSend.call(null, xhr, options)) {                                                            // 183
	        return xhr.abort();                                                                                           // 184
	      }                                                                                                               // 185
	    }                                                                                                                 // 186
	                                                                                                                      //
	    // send it on its way                                                                                             // 188
	    xhr.send(content);                                                                                                // 189
	  } catch (err) {                                                                                                     // 191
	    callback(err);                                                                                                    // 192
	  }                                                                                                                   // 193
	};                                                                                                                    // 195
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"deprecated.js":function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                    //
	// packages/http/deprecated.js                                                                                        //
	//                                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                      //
	// The HTTP object used to be called Meteor.http.                                                                     // 1
	// XXX COMPAT WITH 0.6.4                                                                                              // 2
	Meteor.http = HTTP;                                                                                                   // 3
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}}}}},{"extensions":[".js",".json"]});
	require("./node_modules/meteor/http/httpcall_common.js");
	require("./node_modules/meteor/http/httpcall_client.js");
	require("./node_modules/meteor/http/deprecated.js");
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.http = {}, {
	  HTTP: HTTP
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/id-map.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	var EJSON = Package.ejson.EJSON;
	
	/* Package-scope variables */
	var IdMap;
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////
	//                                                                            //
	// packages/id-map/id-map.js                                                  //
	//                                                                            //
	////////////////////////////////////////////////////////////////////////////////
	                                                                              //
	IdMap = function (idStringify, idParse) {                                     // 1
	  var self = this;                                                            // 2
	  self._map = {};                                                             // 3
	  self._idStringify = idStringify || JSON.stringify;                          // 4
	  self._idParse = idParse || JSON.parse;                                      // 5
	};                                                                            // 6
	                                                                              // 7
	// Some of these methods are designed to match methods on OrderedDict, since  // 8
	// (eg) ObserveMultiplex and _CachingChangeObserver use them interchangeably.
	// (Conceivably, this should be replaced with "UnorderedDict" with a specific
	// set of methods that overlap between the two.)                              // 11
	                                                                              // 12
	_.extend(IdMap.prototype, {                                                   // 13
	  get: function (id) {                                                        // 14
	    var self = this;                                                          // 15
	    var key = self._idStringify(id);                                          // 16
	    return self._map[key];                                                    // 17
	  },                                                                          // 18
	  set: function (id, value) {                                                 // 19
	    var self = this;                                                          // 20
	    var key = self._idStringify(id);                                          // 21
	    self._map[key] = value;                                                   // 22
	  },                                                                          // 23
	  remove: function (id) {                                                     // 24
	    var self = this;                                                          // 25
	    var key = self._idStringify(id);                                          // 26
	    delete self._map[key];                                                    // 27
	  },                                                                          // 28
	  has: function (id) {                                                        // 29
	    var self = this;                                                          // 30
	    var key = self._idStringify(id);                                          // 31
	    return _.has(self._map, key);                                             // 32
	  },                                                                          // 33
	  empty: function () {                                                        // 34
	    var self = this;                                                          // 35
	    return _.isEmpty(self._map);                                              // 36
	  },                                                                          // 37
	  clear: function () {                                                        // 38
	    var self = this;                                                          // 39
	    self._map = {};                                                           // 40
	  },                                                                          // 41
	  // Iterates over the items in the map. Return `false` to break the loop.    // 42
	  forEach: function (iterator) {                                              // 43
	    var self = this;                                                          // 44
	    // don't use _.each, because we can't break out of it.                    // 45
	    var keys = _.keys(self._map);                                             // 46
	    for (var i = 0; i < keys.length; i++) {                                   // 47
	      var breakIfFalse = iterator.call(null, self._map[keys[i]],              // 48
	                                       self._idParse(keys[i]));               // 49
	      if (breakIfFalse === false)                                             // 50
	        return;                                                               // 51
	    }                                                                         // 52
	  },                                                                          // 53
	  size: function () {                                                         // 54
	    var self = this;                                                          // 55
	    return _.size(self._map);                                                 // 56
	  },                                                                          // 57
	  setDefault: function (id, def) {                                            // 58
	    var self = this;                                                          // 59
	    var key = self._idStringify(id);                                          // 60
	    if (_.has(self._map, key))                                                // 61
	      return self._map[key];                                                  // 62
	    self._map[key] = def;                                                     // 63
	    return def;                                                               // 64
	  },                                                                          // 65
	  // Assumes that values are EJSON-cloneable, and that we don't need to clone
	  // IDs (ie, that nobody is going to mutate an ObjectId).                    // 67
	  clone: function () {                                                        // 68
	    var self = this;                                                          // 69
	    var clone = new IdMap(self._idStringify, self._idParse);                  // 70
	    self.forEach(function (value, id) {                                       // 71
	      clone.set(id, EJSON.clone(value));                                      // 72
	    });                                                                       // 73
	    return clone;                                                             // 74
	  }                                                                           // 75
	});                                                                           // 76
	                                                                              // 77
	                                                                              // 78
	////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['id-map'] = {}, {
	  IdMap: IdMap
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/localstorage.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var Random = Package.random.Random;
	
	(function(){
	
	//////////////////////////////////////////////////////////////////////////////////////
	//                                                                                  //
	// packages/localstorage/localstorage.js                                            //
	//                                                                                  //
	//////////////////////////////////////////////////////////////////////////////////////
	                                                                                    //
	// Meteor._localStorage is not an ideal name, but we can change it later.           // 1
	                                                                                    // 2
	// Let's test to make sure that localStorage actually works. For example, in        // 3
	// Safari with private browsing on, window.localStorage exists but actually         // 4
	// trying to use it throws.                                                         // 5
	// Accessing window.localStorage can also immediately throw an error in IE (#1291).
	                                                                                    // 7
	var key = '_localstorage_test_' + Random.id();                                      // 8
	var retrieved;                                                                      // 9
	try {                                                                               // 10
	  if (window.localStorage) {                                                        // 11
	    window.localStorage.setItem(key, key);                                          // 12
	    retrieved = window.localStorage.getItem(key);                                   // 13
	    window.localStorage.removeItem(key);                                            // 14
	  }                                                                                 // 15
	} catch (e) {                                                                       // 16
	  // ... ignore                                                                     // 17
	}                                                                                   // 18
	if (key === retrieved) {                                                            // 19
	  Meteor._localStorage = {                                                          // 20
	    getItem: function (key) {                                                       // 21
	      return window.localStorage.getItem(key);                                      // 22
	    },                                                                              // 23
	    setItem: function (key, value) {                                                // 24
	      window.localStorage.setItem(key, value);                                      // 25
	    },                                                                              // 26
	    removeItem: function (key) {                                                    // 27
	      window.localStorage.removeItem(key);                                          // 28
	    }                                                                               // 29
	  };                                                                                // 30
	}                                                                                   // 31
	                                                                                    // 32
	if (!Meteor._localStorage) {                                                        // 33
	  Meteor._debug(                                                                    // 34
	    "You are running a browser with no localStorage or userData "                   // 35
	      + "support. Logging in from one tab will not cause another "                  // 36
	      + "tab to be logged in.");                                                    // 37
	                                                                                    // 38
	  Meteor._localStorage = {                                                          // 39
	    _data: {},                                                                      // 40
	                                                                                    // 41
	    setItem: function (key, val) {                                                  // 42
	      this._data[key] = val;                                                        // 43
	    },                                                                              // 44
	    removeItem: function (key) {                                                    // 45
	      delete this._data[key];                                                       // 46
	    },                                                                              // 47
	    getItem: function (key) {                                                       // 48
	      var value = this._data[key];                                                  // 49
	      if (value === undefined)                                                      // 50
	        return null;                                                                // 51
	      else                                                                          // 52
	        return value;                                                               // 53
	    }                                                                               // 54
	  };                                                                                // 55
	}                                                                                   // 56
	                                                                                    // 57
	//////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	Package.localstorage = {};
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/matb33_collection-hooks.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var Mongo = Package.mongo.Mongo;
	var Tracker = Package.tracker.Tracker;
	var Deps = Package.tracker.Deps;
	var _ = Package.underscore._;
	var EJSON = Package.ejson.EJSON;
	var LocalCollection = Package.minimongo.LocalCollection;
	var Minimongo = Package.minimongo.Minimongo;
	
	/* Package-scope variables */
	var CollectionHooks;
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                    //
	// packages/matb33_collection-hooks/collection-hooks.js                                                               //
	//                                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                      //
	/* global Package Meteor Mongo LocalCollection CollectionHooks _ EJSON */                                             // 1
	/* eslint-disable no-proto, no-native-reassign */                                                                     // 2
	                                                                                                                      // 3
	// Relevant AOP terminology:                                                                                          // 4
	// Aspect: User code that runs before/after (hook)                                                                    // 5
	// Advice: Wrapper code that knows when to call user code (aspects)                                                   // 6
	// Pointcut: before/after                                                                                             // 7
	                                                                                                                      // 8
	var advices = {}                                                                                                      // 9
	var Tracker = Package.tracker && Package.tracker.Tracker || Package.deps.Deps                                         // 10
	var publishUserId = Meteor.isServer && new Meteor.EnvironmentVariable()                                               // 11
	                                                                                                                      // 12
	CollectionHooks = {                                                                                                   // 13
	  defaults: {                                                                                                         // 14
	    before: {insert: {}, update: {}, remove: {}, upsert: {}, find: {}, findOne: {}, all: {}},                         // 15
	    after: {insert: {}, update: {}, remove: {}, find: {}, findOne: {}, all: {}},                                      // 16
	    all: {insert: {}, update: {}, remove: {}, find: {}, findOne: {}, all: {}}                                         // 17
	  },                                                                                                                  // 18
	  directEnv: new Meteor.EnvironmentVariable(),                                                                        // 19
	  directOp: function directOp (func) {                                                                                // 20
	    return this.directEnv.withValue(true, func)                                                                       // 21
	  },                                                                                                                  // 22
	  hookedOp: function hookedOp (func) {                                                                                // 23
	    return this.directEnv.withValue(false, func)                                                                      // 24
	  }                                                                                                                   // 25
	}                                                                                                                     // 26
	                                                                                                                      // 27
	CollectionHooks.getUserId = function getUserId () {                                                                   // 28
	  var userId                                                                                                          // 29
	                                                                                                                      // 30
	  if (Meteor.isClient) {                                                                                              // 31
	    Tracker.nonreactive(function () {                                                                                 // 32
	      userId = Meteor.userId && Meteor.userId()                                                                       // 33
	    })                                                                                                                // 34
	  }                                                                                                                   // 35
	                                                                                                                      // 36
	  if (Meteor.isServer) {                                                                                              // 37
	    try {                                                                                                             // 38
	      // Will throw an error unless within method call.                                                               // 39
	      // Attempt to recover gracefully by catching:                                                                   // 40
	      userId = Meteor.userId && Meteor.userId()                                                                       // 41
	    } catch (e) {}                                                                                                    // 42
	                                                                                                                      // 43
	    if (!userId) {                                                                                                    // 44
	      // Get the userId if we are in a publish function.                                                              // 45
	      userId = publishUserId.get()                                                                                    // 46
	    }                                                                                                                 // 47
	  }                                                                                                                   // 48
	                                                                                                                      // 49
	  return userId                                                                                                       // 50
	}                                                                                                                     // 51
	                                                                                                                      // 52
	CollectionHooks.extendCollectionInstance = function extendCollectionInstance (self, constructor) {                    // 53
	  // Offer a public API to allow the user to define aspects                                                           // 54
	  // Example: collection.before.insert(func);                                                                         // 55
	  _.each(['before', 'after'], function (pointcut) {                                                                   // 56
	    _.each(advices, function (advice, method) {                                                                       // 57
	      if (advice === 'upsert' && pointcut === 'after') return                                                         // 58
	                                                                                                                      // 59
	      Meteor._ensure(self, pointcut, method)                                                                          // 60
	      Meteor._ensure(self, '_hookAspects', method)                                                                    // 61
	                                                                                                                      // 62
	      self._hookAspects[method][pointcut] = []                                                                        // 63
	      self[pointcut][method] = function (aspect, options) {                                                           // 64
	        var len = self._hookAspects[method][pointcut].push({                                                          // 65
	          aspect: aspect,                                                                                             // 66
	          options: CollectionHooks.initOptions(options, pointcut, method)                                             // 67
	        })                                                                                                            // 68
	                                                                                                                      // 69
	        return {                                                                                                      // 70
	          replace: function (aspect, options) {                                                                       // 71
	            self._hookAspects[method][pointcut].splice(len - 1, 1, {                                                  // 72
	              aspect: aspect,                                                                                         // 73
	              options: CollectionHooks.initOptions(options, pointcut, method)                                         // 74
	            })                                                                                                        // 75
	          },                                                                                                          // 76
	          remove: function () {                                                                                       // 77
	            self._hookAspects[method][pointcut].splice(len - 1, 1)                                                    // 78
	          }                                                                                                           // 79
	        }                                                                                                             // 80
	      }                                                                                                               // 81
	    })                                                                                                                // 82
	  })                                                                                                                  // 83
	                                                                                                                      // 84
	  // Offer a publicly accessible object to allow the user to define                                                   // 85
	  // collection-wide hook options.                                                                                    // 86
	  // Example: collection.hookOptions.after.update = {fetchPrevious: false};                                           // 87
	  self.hookOptions = EJSON.clone(CollectionHooks.defaults)                                                            // 88
	                                                                                                                      // 89
	  // Wrap mutator methods, letting the defined advice do the work                                                     // 90
	  _.each(advices, function (advice, method) {                                                                         // 91
	    var collection = Meteor.isClient || method === 'upsert' ? self : self._collection                                 // 92
	                                                                                                                      // 93
	    // Store a reference to the original mutator method                                                               // 94
	    var _super = collection[method]                                                                                   // 95
	                                                                                                                      // 96
	    Meteor._ensure(self, 'direct', method)                                                                            // 97
	    self.direct[method] = function () {                                                                               // 98
	      var args = arguments                                                                                            // 99
	      return CollectionHooks.directOp(function () {                                                                   // 100
	        return constructor.prototype[method].apply(self, args)                                                        // 101
	      })                                                                                                              // 102
	    }                                                                                                                 // 103
	                                                                                                                      // 104
	    collection[method] = function () {                                                                                // 105
	      if (CollectionHooks.directEnv.get() === true) {                                                                 // 106
	        return _super.apply(collection, arguments)                                                                    // 107
	      }                                                                                                               // 108
	                                                                                                                      // 109
	      // NOTE: should we decide to force `update` with `{upsert:true}` to use                                         // 110
	      // the `upsert` hooks, this is what will accomplish it. It's important to                                       // 111
	      // realize that Meteor won't distinguish between an `update` and an                                             // 112
	      // `insert` though, so we'll end up with `after.update` getting called                                          // 113
	      // even on an `insert`. That's why we've chosen to disable this for now.                                        // 114
	      // if (method === "update" && _.isObject(arguments[2]) && arguments[2].upsert) {                                // 115
	      //   method = "upsert";                                                                                         // 116
	      //   advice = CollectionHooks.getAdvice(method);                                                                // 117
	      // }                                                                                                            // 118
	                                                                                                                      // 119
	      return advice.call(this,                                                                                        // 120
	        CollectionHooks.getUserId(),                                                                                  // 121
	        _super,                                                                                                       // 122
	        self,                                                                                                         // 123
	        method === 'upsert' ? {                                                                                       // 124
	          insert: self._hookAspects.insert || {},                                                                     // 125
	          update: self._hookAspects.update || {},                                                                     // 126
	          upsert: self._hookAspects.upsert || {}                                                                      // 127
	        } : self._hookAspects[method] || {},                                                                          // 128
	        function (doc) {                                                                                              // 129
	          return (                                                                                                    // 130
	            _.isFunction(self._transform)                                                                             // 131
	            ? function (d) { return self._transform(d || doc) }                                                       // 132
	            : function (d) { return d || doc }                                                                        // 133
	          )                                                                                                           // 134
	        },                                                                                                            // 135
	        _.toArray(arguments),                                                                                         // 136
	        false                                                                                                         // 137
	      )                                                                                                               // 138
	    }                                                                                                                 // 139
	  })                                                                                                                  // 140
	}                                                                                                                     // 141
	                                                                                                                      // 142
	CollectionHooks.defineAdvice = function defineAdvice (method, advice) {                                               // 143
	  advices[method] = advice                                                                                            // 144
	}                                                                                                                     // 145
	                                                                                                                      // 146
	CollectionHooks.getAdvice = function getAdvice (method) {                                                             // 147
	  return advices[method]                                                                                              // 148
	}                                                                                                                     // 149
	                                                                                                                      // 150
	CollectionHooks.initOptions = function initOptions (options, pointcut, method) {                                      // 151
	  return CollectionHooks.extendOptions(CollectionHooks.defaults, options, pointcut, method)                           // 152
	}                                                                                                                     // 153
	                                                                                                                      // 154
	CollectionHooks.extendOptions = function extendOptions (source, options, pointcut, method) {                          // 155
	  options = _.extend(options || {}, source.all.all)                                                                   // 156
	  options = _.extend(options, source[pointcut].all)                                                                   // 157
	  options = _.extend(options, source.all[method])                                                                     // 158
	  options = _.extend(options, source[pointcut][method])                                                               // 159
	  return options                                                                                                      // 160
	}                                                                                                                     // 161
	                                                                                                                      // 162
	CollectionHooks.getDocs = function getDocs (collection, selector, options) {                                          // 163
	  var findOptions = {transform: null, reactive: false} // added reactive: false                                       // 164
	                                                                                                                      // 165
	  /*                                                                                                                  // 166
	  // No "fetch" support at this time.                                                                                 // 167
	  if (!this._validators.fetchAllFields) {                                                                             // 168
	    findOptions.fields = {};                                                                                          // 169
	    _.each(this._validators.fetch, function(fieldName) {                                                              // 170
	      findOptions.fields[fieldName] = 1;                                                                              // 171
	    });                                                                                                               // 172
	  }                                                                                                                   // 173
	  */                                                                                                                  // 174
	                                                                                                                      // 175
	  // Bit of a magic condition here... only "update" passes options, so this is                                        // 176
	  // only relevant to when update calls getDocs:                                                                      // 177
	  if (options) {                                                                                                      // 178
	    // This was added because in our case, we are potentially iterating over                                          // 179
	    // multiple docs. If multi isn't enabled, force a limit (almost like                                              // 180
	    // findOne), as the default for update without multi enabled is to affect                                         // 181
	    // only the first matched document:                                                                               // 182
	    if (!options.multi) {                                                                                             // 183
	      findOptions.limit = 1                                                                                           // 184
	    }                                                                                                                 // 185
	  }                                                                                                                   // 186
	                                                                                                                      // 187
	  // Unlike validators, we iterate over multiple docs, so use                                                         // 188
	  // find instead of findOne:                                                                                         // 189
	  return collection.find(selector, findOptions)                                                                       // 190
	}                                                                                                                     // 191
	                                                                                                                      // 192
	// This function contains a snippet of code pulled and modified from:                                                 // 193
	// ~/.meteor/packages/mongo-livedata/collection.js                                                                    // 194
	// It's contained in these utility functions to make updates easier for us in                                         // 195
	// case this code changes.                                                                                            // 196
	CollectionHooks.getFields = function getFields (mutator) {                                                            // 197
	  // compute modified fields                                                                                          // 198
	  var fields = []                                                                                                     // 199
	                                                                                                                      // 200
	  _.each(mutator, function (params, op) {                                                                             // 201
	    // ====ADDED START=======================                                                                         // 202
	    if (_.contains(['$set', '$unset', '$inc', '$push', '$pull', '$pop', '$rename', '$pullAll', '$addToSet', '$bit'], op)) {
	    // ====ADDED END=========================                                                                         // 204
	      _.each(_.keys(params), function (field) {                                                                       // 205
	        // treat dotted fields as if they are replacing their                                                         // 206
	        // top-level part                                                                                             // 207
	        if (field.indexOf('.') !== -1) {                                                                              // 208
	          field = field.substring(0, field.indexOf('.'))                                                              // 209
	        }                                                                                                             // 210
	                                                                                                                      // 211
	        // record the field we are trying to change                                                                   // 212
	        if (!_.contains(fields, field)) {                                                                             // 213
	          fields.push(field)                                                                                          // 214
	        }                                                                                                             // 215
	      })                                                                                                              // 216
	      // ====ADDED START=======================                                                                       // 217
	    } else {                                                                                                          // 218
	      fields.push(op)                                                                                                 // 219
	    }                                                                                                                 // 220
	    // ====ADDED END=========================                                                                         // 221
	  })                                                                                                                  // 222
	                                                                                                                      // 223
	  return fields                                                                                                       // 224
	}                                                                                                                     // 225
	                                                                                                                      // 226
	CollectionHooks.reassignPrototype = function reassignPrototype (instance, constr) {                                   // 227
	  var hasSetPrototypeOf = typeof Object.setPrototypeOf === 'function'                                                 // 228
	                                                                                                                      // 229
	  if (!constr) constr = typeof Mongo !== 'undefined' ? Mongo.Collection : Meteor.Collection                           // 230
	                                                                                                                      // 231
	  // __proto__ is not available in < IE11                                                                             // 232
	  // Note: Assigning a prototype dynamically has performance implications                                             // 233
	  if (hasSetPrototypeOf) {                                                                                            // 234
	    Object.setPrototypeOf(instance, constr.prototype)                                                                 // 235
	  } else if (instance.__proto__) {                                                                                    // 236
	    instance.__proto__ = constr.prototype                                                                             // 237
	  }                                                                                                                   // 238
	}                                                                                                                     // 239
	                                                                                                                      // 240
	CollectionHooks.wrapCollection = function wrapCollection (ns, as) {                                                   // 241
	  if (!as._CollectionConstructor) as._CollectionConstructor = as.Collection                                           // 242
	  if (!as._CollectionPrototype) as._CollectionPrototype = new as.Collection(null)                                     // 243
	                                                                                                                      // 244
	  var constructor = as._CollectionConstructor                                                                         // 245
	  var proto = as._CollectionPrototype                                                                                 // 246
	                                                                                                                      // 247
	  ns.Collection = function () {                                                                                       // 248
	    var ret = constructor.apply(this, arguments)                                                                      // 249
	    CollectionHooks.extendCollectionInstance(this, constructor)                                                       // 250
	    return ret                                                                                                        // 251
	  }                                                                                                                   // 252
	                                                                                                                      // 253
	  ns.Collection.prototype = proto                                                                                     // 254
	  ns.Collection.prototype.constructor = ns.Collection                                                                 // 255
	                                                                                                                      // 256
	  for (var prop in constructor) {                                                                                     // 257
	    if (constructor.hasOwnProperty(prop)) {                                                                           // 258
	      ns.Collection[prop] = constructor[prop]                                                                         // 259
	    }                                                                                                                 // 260
	  }                                                                                                                   // 261
	}                                                                                                                     // 262
	                                                                                                                      // 263
	CollectionHooks.modify = LocalCollection._modify                                                                      // 264
	                                                                                                                      // 265
	if (typeof Mongo !== 'undefined') {                                                                                   // 266
	  CollectionHooks.wrapCollection(Meteor, Mongo)                                                                       // 267
	  CollectionHooks.wrapCollection(Mongo, Mongo)                                                                        // 268
	} else {                                                                                                              // 269
	  CollectionHooks.wrapCollection(Meteor, Meteor)                                                                      // 270
	}                                                                                                                     // 271
	                                                                                                                      // 272
	if (Meteor.isServer) {                                                                                                // 273
	  var _publish = Meteor.publish                                                                                       // 274
	  Meteor.publish = function (name, func) {                                                                            // 275
	    return _publish.call(this, name, function () {                                                                    // 276
	      // This function is called repeatedly in publications                                                           // 277
	      var ctx = this                                                                                                  // 278
	      var args = arguments                                                                                            // 279
	      return publishUserId.withValue(ctx && ctx.userId, function () {                                                 // 280
	        return func.apply(ctx, args)                                                                                  // 281
	      })                                                                                                              // 282
	    })                                                                                                                // 283
	  }                                                                                                                   // 284
	                                                                                                                      // 285
	  // Make the above available for packages with hooks that want to determine                                          // 286
	  // whether they are running inside a publish function or not.                                                       // 287
	  CollectionHooks.isWithinPublish = function isWithinPublish () {                                                     // 288
	    return publishUserId.get() !== undefined                                                                          // 289
	  }                                                                                                                   // 290
	}                                                                                                                     // 291
	                                                                                                                      // 292
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                    //
	// packages/matb33_collection-hooks/insert.js                                                                         //
	//                                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                      //
	/* global CollectionHooks _ EJSON */                                                                                  // 1
	                                                                                                                      // 2
	CollectionHooks.defineAdvice('insert', function (userId, _super, instance, aspects, getTransform, args, suppressAspects) {
	  var self = this                                                                                                     // 4
	  var ctx = {context: self, _super: _super, args: args}                                                               // 5
	  var callback = _.last(args)                                                                                         // 6
	  var async = _.isFunction(callback)                                                                                  // 7
	  var abort, ret                                                                                                      // 8
	                                                                                                                      // 9
	  // args[0] : doc                                                                                                    // 10
	  // args[1] : callback                                                                                               // 11
	                                                                                                                      // 12
	  // before                                                                                                           // 13
	  if (!suppressAspects) {                                                                                             // 14
	    try {                                                                                                             // 15
	      _.each(aspects.before, function (o) {                                                                           // 16
	        var r = o.aspect.call(_.extend({transform: getTransform(args[0])}, ctx), userId, args[0])                     // 17
	        if (r === false) abort = true                                                                                 // 18
	      })                                                                                                              // 19
	                                                                                                                      // 20
	      if (abort) return false                                                                                         // 21
	    } catch (e) {                                                                                                     // 22
	      if (async) return callback.call(self, e)                                                                        // 23
	      throw e                                                                                                         // 24
	    }                                                                                                                 // 25
	  }                                                                                                                   // 26
	                                                                                                                      // 27
	  function after (id, err) {                                                                                          // 28
	    var doc = args[0]                                                                                                 // 29
	    if (id) {                                                                                                         // 30
	      // In some cases (namely Meteor.users on Meteor 1.4+), the _id property                                         // 31
	      // is a raw mongo _id object. We need to extract the _id from this object                                       // 32
	      if (_.isObject(id) && id.ops) {                                                                                 // 33
	        // If _str then collection is using Mongo.ObjectID as ids                                                     // 34
	        if (doc._id._str) {                                                                                           // 35
	          id = new Mongo.ObjectID(doc._id._str.toString());                                                           // 36
	        } else {                                                                                                      // 37
	          id = id.ops && id.ops[0] && id.ops[0]._id                                                                   // 38
	        }                                                                                                             // 39
	      }                                                                                                               // 40
	      doc = EJSON.clone(args[0])                                                                                      // 41
	      doc._id = id                                                                                                    // 42
	    }                                                                                                                 // 43
	    if (!suppressAspects) {                                                                                           // 44
	      var lctx = _.extend({transform: getTransform(doc), _id: id, err: err}, ctx)                                     // 45
	      _.each(aspects.after, function (o) {                                                                            // 46
	        o.aspect.call(lctx, userId, doc)                                                                              // 47
	      })                                                                                                              // 48
	    }                                                                                                                 // 49
	    return id                                                                                                         // 50
	  }                                                                                                                   // 51
	                                                                                                                      // 52
	  if (async) {                                                                                                        // 53
	    args[args.length - 1] = function (err, obj) {                                                                     // 54
	      after(obj && obj[0] && obj[0]._id || obj, err)                                                                  // 55
	      return callback.apply(this, arguments)                                                                          // 56
	    }                                                                                                                 // 57
	    return _super.apply(self, args)                                                                                   // 58
	  } else {                                                                                                            // 59
	    ret = _super.apply(self, args)                                                                                    // 60
	    return after(ret && ret[0] && ret[0]._id || ret)                                                                  // 61
	  }                                                                                                                   // 62
	})                                                                                                                    // 63
	                                                                                                                      // 64
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                    //
	// packages/matb33_collection-hooks/update.js                                                                         //
	//                                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                      //
	/* global CollectionHooks _ EJSON */                                                                                  // 1
	                                                                                                                      // 2
	CollectionHooks.defineAdvice('update', function (userId, _super, instance, aspects, getTransform, args, suppressAspects) {
	  var self = this                                                                                                     // 4
	  var ctx = {context: self, _super: _super, args: args}                                                               // 5
	  var callback = _.last(args)                                                                                         // 6
	  var async = _.isFunction(callback)                                                                                  // 7
	  var docs                                                                                                            // 8
	  var docIds                                                                                                          // 9
	  var fields                                                                                                          // 10
	  var abort                                                                                                           // 11
	  var prev = {}                                                                                                       // 12
	  var collection = _.has(self, '_collection') ? self._collection : self                                               // 13
	                                                                                                                      // 14
	  // args[0] : selector                                                                                               // 15
	  // args[1] : mutator                                                                                                // 16
	  // args[2] : options (optional)                                                                                     // 17
	  // args[3] : callback                                                                                               // 18
	                                                                                                                      // 19
	  if (_.isFunction(args[2])) {                                                                                        // 20
	    callback = args[2]                                                                                                // 21
	    args[2] = {}                                                                                                      // 22
	  }                                                                                                                   // 23
	                                                                                                                      // 24
	  if (!suppressAspects) {                                                                                             // 25
	    try {                                                                                                             // 26
	      if (aspects.before || aspects.after) {                                                                          // 27
	        fields = CollectionHooks.getFields(args[1])                                                                   // 28
	        docs = CollectionHooks.getDocs.call(self, collection, args[0], args[2]).fetch()                               // 29
	        docIds = _.map(docs, function (doc) { return doc._id })                                                       // 30
	      }                                                                                                               // 31
	                                                                                                                      // 32
	      // copy originals for convenience for the 'after' pointcut                                                      // 33
	      if (aspects.after) {                                                                                            // 34
	        prev.mutator = EJSON.clone(args[1])                                                                           // 35
	        prev.options = EJSON.clone(args[2])                                                                           // 36
	        if (                                                                                                          // 37
	          _.some(aspects.after, function (o) { return o.options.fetchPrevious !== false }) &&                         // 38
	          CollectionHooks.extendOptions(instance.hookOptions, {}, 'after', 'update').fetchPrevious !== false          // 39
	        ) {                                                                                                           // 40
	          prev.docs = {}                                                                                              // 41
	          _.each(docs, function (doc) {                                                                               // 42
	            prev.docs[doc._id] = EJSON.clone(doc)                                                                     // 43
	          })                                                                                                          // 44
	        }                                                                                                             // 45
	      }                                                                                                               // 46
	                                                                                                                      // 47
	      // before                                                                                                       // 48
	      _.each(aspects.before, function (o) {                                                                           // 49
	        _.each(docs, function (doc) {                                                                                 // 50
	          var r = o.aspect.call(_.extend({transform: getTransform(doc)}, ctx), userId, doc, fields, args[1], args[2])
	          if (r === false) abort = true                                                                               // 52
	        })                                                                                                            // 53
	      })                                                                                                              // 54
	                                                                                                                      // 55
	      if (abort) return false                                                                                         // 56
	    } catch (e) {                                                                                                     // 57
	      if (async) return callback.call(self, e)                                                                        // 58
	      throw e                                                                                                         // 59
	    }                                                                                                                 // 60
	  }                                                                                                                   // 61
	                                                                                                                      // 62
	  function after (affected, err) {                                                                                    // 63
	    if (!suppressAspects) {                                                                                           // 64
	      var fields = CollectionHooks.getFields(args[1])                                                                 // 65
	      var docs = CollectionHooks.getDocs.call(self, collection, {_id: {$in: docIds}}, args[2]).fetch()                // 66
	                                                                                                                      // 67
	      _.each(aspects.after, function (o) {                                                                            // 68
	        _.each(docs, function (doc) {                                                                                 // 69
	          o.aspect.call(_.extend({                                                                                    // 70
	            transform: getTransform(doc),                                                                             // 71
	            previous: prev.docs && prev.docs[doc._id],                                                                // 72
	            affected: affected,                                                                                       // 73
	            err: err                                                                                                  // 74
	          }, ctx), userId, doc, fields, prev.mutator, prev.options)                                                   // 75
	        })                                                                                                            // 76
	      })                                                                                                              // 77
	    }                                                                                                                 // 78
	  }                                                                                                                   // 79
	                                                                                                                      // 80
	  if (async) {                                                                                                        // 81
	    args[args.length - 1] = function (err, affected) {                                                                // 82
	      after(affected, err)                                                                                            // 83
	      return callback.apply(this, arguments)                                                                          // 84
	    }                                                                                                                 // 85
	    return _super.apply(this, args)                                                                                   // 86
	  } else {                                                                                                            // 87
	    var affected = _super.apply(self, args)                                                                           // 88
	    after(affected)                                                                                                   // 89
	    return affected                                                                                                   // 90
	  }                                                                                                                   // 91
	})                                                                                                                    // 92
	                                                                                                                      // 93
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                    //
	// packages/matb33_collection-hooks/remove.js                                                                         //
	//                                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                      //
	/* global CollectionHooks _ EJSON */                                                                                  // 1
	                                                                                                                      // 2
	CollectionHooks.defineAdvice('remove', function (userId, _super, instance, aspects, getTransform, args, suppressAspects) {
	  var self = this                                                                                                     // 4
	  var ctx = {context: self, _super: _super, args: args}                                                               // 5
	  var callback = _.last(args)                                                                                         // 6
	  var async = _.isFunction(callback)                                                                                  // 7
	  var docs                                                                                                            // 8
	  var abort                                                                                                           // 9
	  var prev = []                                                                                                       // 10
	  var collection = _.has(self, '_collection') ? self._collection : self                                               // 11
	                                                                                                                      // 12
	  // args[0] : selector                                                                                               // 13
	  // args[1] : callback                                                                                               // 14
	                                                                                                                      // 15
	  if (!suppressAspects) {                                                                                             // 16
	    try {                                                                                                             // 17
	      if (aspects.before || aspects.after) {                                                                          // 18
	        docs = CollectionHooks.getDocs.call(self, collection, args[0]).fetch()                                        // 19
	      }                                                                                                               // 20
	                                                                                                                      // 21
	      // copy originals for convenience for the 'after' pointcut                                                      // 22
	      if (aspects.after) {                                                                                            // 23
	        _.each(docs, function (doc) {                                                                                 // 24
	          prev.push(EJSON.clone(doc))                                                                                 // 25
	        })                                                                                                            // 26
	      }                                                                                                               // 27
	                                                                                                                      // 28
	      // before                                                                                                       // 29
	      _.each(aspects.before, function (o) {                                                                           // 30
	        _.each(docs, function (doc) {                                                                                 // 31
	          var r = o.aspect.call(_.extend({transform: getTransform(doc)}, ctx), userId, doc)                           // 32
	          if (r === false) abort = true                                                                               // 33
	        })                                                                                                            // 34
	      })                                                                                                              // 35
	                                                                                                                      // 36
	      if (abort) return false                                                                                         // 37
	    } catch (e) {                                                                                                     // 38
	      if (async) return callback.call(self, e)                                                                        // 39
	      throw e                                                                                                         // 40
	    }                                                                                                                 // 41
	  }                                                                                                                   // 42
	                                                                                                                      // 43
	  function after (err) {                                                                                              // 44
	    if (!suppressAspects) {                                                                                           // 45
	      _.each(aspects.after, function (o) {                                                                            // 46
	        _.each(prev, function (doc) {                                                                                 // 47
	          o.aspect.call(_.extend({transform: getTransform(doc), err: err}, ctx), userId, doc)                         // 48
	        })                                                                                                            // 49
	      })                                                                                                              // 50
	    }                                                                                                                 // 51
	  }                                                                                                                   // 52
	                                                                                                                      // 53
	  if (async) {                                                                                                        // 54
	    args[args.length - 1] = function (err) {                                                                          // 55
	      after(err)                                                                                                      // 56
	      return callback.apply(this, arguments)                                                                          // 57
	    }                                                                                                                 // 58
	    return _super.apply(self, args)                                                                                   // 59
	  } else {                                                                                                            // 60
	    var result = _super.apply(self, args)                                                                             // 61
	    after()                                                                                                           // 62
	    return result                                                                                                     // 63
	  }                                                                                                                   // 64
	})                                                                                                                    // 65
	                                                                                                                      // 66
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                    //
	// packages/matb33_collection-hooks/upsert.js                                                                         //
	//                                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                      //
	/* global CollectionHooks _ EJSON */                                                                                  // 1
	                                                                                                                      // 2
	CollectionHooks.defineAdvice('upsert', function (userId, _super, instance, aspectGroup, getTransform, args, suppressAspects) {
	  var self = this                                                                                                     // 4
	  var ctx = {context: self, _super: _super, args: args}                                                               // 5
	  var callback = _.last(args)                                                                                         // 6
	  var async = _.isFunction(callback)                                                                                  // 7
	  var docs                                                                                                            // 8
	  var docIds                                                                                                          // 9
	  var abort                                                                                                           // 10
	  var prev = {}                                                                                                       // 11
	  var collection = _.has(self, '_collection') ? self._collection : self                                               // 12
	                                                                                                                      // 13
	  // args[0] : selector                                                                                               // 14
	  // args[1] : mutator                                                                                                // 15
	  // args[2] : options (optional)                                                                                     // 16
	  // args[3] : callback                                                                                               // 17
	                                                                                                                      // 18
	  if (_.isFunction(args[2])) {                                                                                        // 19
	    callback = args[2]                                                                                                // 20
	    args[2] = {}                                                                                                      // 21
	  }                                                                                                                   // 22
	                                                                                                                      // 23
	  if (!suppressAspects) {                                                                                             // 24
	    if (aspectGroup.upsert.before) {                                                                                  // 25
	      docs = CollectionHooks.getDocs.call(self, collection, args[0], args[2]).fetch()                                 // 26
	      docIds = _.map(docs, function (doc) { return doc._id })                                                         // 27
	    }                                                                                                                 // 28
	                                                                                                                      // 29
	    // copy originals for convenience for the 'after' pointcut                                                        // 30
	    if (aspectGroup.update.after) {                                                                                   // 31
	      if (_.some(aspectGroup.update.after, function (o) { return o.options.fetchPrevious !== false }) &&              // 32
	          CollectionHooks.extendOptions(instance.hookOptions, {}, 'after', 'update').fetchPrevious !== false) {       // 33
	        prev.mutator = EJSON.clone(args[1])                                                                           // 34
	        prev.options = EJSON.clone(args[2])                                                                           // 35
	        prev.docs = {}                                                                                                // 36
	        _.each(docs, function (doc) {                                                                                 // 37
	          prev.docs[doc._id] = EJSON.clone(doc)                                                                       // 38
	        })                                                                                                            // 39
	      }                                                                                                               // 40
	    }                                                                                                                 // 41
	                                                                                                                      // 42
	    // before                                                                                                         // 43
	    if (!suppressAspects) {                                                                                           // 44
	      _.each(aspectGroup.upsert.before, function (o) {                                                                // 45
	        var r = o.aspect.call(ctx, userId, args[0], args[1], args[2])                                                 // 46
	        if (r === false) abort = true                                                                                 // 47
	      })                                                                                                              // 48
	                                                                                                                      // 49
	      if (abort) return false                                                                                         // 50
	    }                                                                                                                 // 51
	  }                                                                                                                   // 52
	                                                                                                                      // 53
	  function afterUpdate (affected, err) {                                                                              // 54
	    if (!suppressAspects) {                                                                                           // 55
	      var fields = CollectionHooks.getFields(args[1])                                                                 // 56
	      var docs = CollectionHooks.getDocs.call(self, collection, {_id: {$in: docIds}}, args[2]).fetch()                // 57
	                                                                                                                      // 58
	      _.each(aspectGroup.update.after, function (o) {                                                                 // 59
	        _.each(docs, function (doc) {                                                                                 // 60
	          o.aspect.call(_.extend({                                                                                    // 61
	            transform: getTransform(doc),                                                                             // 62
	            previous: prev.docs && prev.docs[doc._id],                                                                // 63
	            affected: affected,                                                                                       // 64
	            err: err                                                                                                  // 65
	          }, ctx), userId, doc, fields, prev.mutator, prev.options)                                                   // 66
	        })                                                                                                            // 67
	      })                                                                                                              // 68
	    }                                                                                                                 // 69
	  }                                                                                                                   // 70
	                                                                                                                      // 71
	  function afterInsert (id, err) {                                                                                    // 72
	    if (!suppressAspects) {                                                                                           // 73
	      var doc = CollectionHooks.getDocs.call(self, collection, {_id: id}, args[0], {}).fetch()[0] // 3rd argument passes empty object which causes magic logic to imply limit:1
	      var lctx = _.extend({transform: getTransform(doc), _id: id, err: err}, ctx)                                     // 75
	      _.each(aspectGroup.insert.after, function (o) {                                                                 // 76
	        o.aspect.call(lctx, userId, doc)                                                                              // 77
	      })                                                                                                              // 78
	    }                                                                                                                 // 79
	  }                                                                                                                   // 80
	                                                                                                                      // 81
	  if (async) {                                                                                                        // 82
	    args[args.length - 1] = function (err, ret) {                                                                     // 83
	      if (err || ret.insertedId) {                                                                                    // 84
	        // Send any errors to afterInsert                                                                             // 85
	        afterInsert(ret && ret.insertedId, err)                                                                       // 86
	      } else {                                                                                                        // 87
	        afterUpdate(ret && ret.numberAffected, err) // Note that err can never reach here                             // 88
	      }                                                                                                               // 89
	                                                                                                                      // 90
	      return CollectionHooks.hookedOp(function () {                                                                   // 91
	        return callback.call(this, err, ret)                                                                          // 92
	      })                                                                                                              // 93
	    }                                                                                                                 // 94
	                                                                                                                      // 95
	    return CollectionHooks.directOp(function () {                                                                     // 96
	      return _super.apply(self, args)                                                                                 // 97
	    })                                                                                                                // 98
	  } else {                                                                                                            // 99
	    var ret = CollectionHooks.directOp(function () {                                                                  // 100
	      return _super.apply(self, args)                                                                                 // 101
	    })                                                                                                                // 102
	                                                                                                                      // 103
	    if (ret && ret.insertedId) {                                                                                      // 104
	      afterInsert(ret && ret.insertedId)                                                                              // 105
	    } else {                                                                                                          // 106
	      afterUpdate(ret && ret.numberAffected)                                                                          // 107
	    }                                                                                                                 // 108
	                                                                                                                      // 109
	    return ret                                                                                                        // 110
	  }                                                                                                                   // 111
	})                                                                                                                    // 112
	                                                                                                                      // 113
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                    //
	// packages/matb33_collection-hooks/find.js                                                                           //
	//                                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                      //
	/* global CollectionHooks _ */                                                                                        // 1
	                                                                                                                      // 2
	CollectionHooks.defineAdvice('find', function (userId, _super, instance, aspects, getTransform, args, suppressAspects) {
	  var self = this                                                                                                     // 4
	  var ctx = {context: self, _super: _super, args: args}                                                               // 5
	  var ret, abort                                                                                                      // 6
	                                                                                                                      // 7
	  // args[0] : selector                                                                                               // 8
	  // args[1] : options                                                                                                // 9
	                                                                                                                      // 10
	  // before                                                                                                           // 11
	  if (!suppressAspects) {                                                                                             // 12
	    _.each(aspects.before, function (o) {                                                                             // 13
	      var r = o.aspect.call(ctx, userId, args[0], args[1])                                                            // 14
	      if (r === false) abort = true                                                                                   // 15
	    })                                                                                                                // 16
	                                                                                                                      // 17
	    if (abort) return false                                                                                           // 18
	  }                                                                                                                   // 19
	                                                                                                                      // 20
	  function after (cursor) {                                                                                           // 21
	    if (!suppressAspects) {                                                                                           // 22
	      _.each(aspects.after, function (o) {                                                                            // 23
	        o.aspect.call(ctx, userId, args[0], args[1], cursor)                                                          // 24
	      })                                                                                                              // 25
	    }                                                                                                                 // 26
	  }                                                                                                                   // 27
	                                                                                                                      // 28
	  ret = _super.apply(self, args)                                                                                      // 29
	  after(ret)                                                                                                          // 30
	                                                                                                                      // 31
	  return ret                                                                                                          // 32
	})                                                                                                                    // 33
	                                                                                                                      // 34
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                    //
	// packages/matb33_collection-hooks/findone.js                                                                        //
	//                                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                      //
	/* global CollectionHooks _ */                                                                                        // 1
	                                                                                                                      // 2
	CollectionHooks.defineAdvice('findOne', function (userId, _super, instance, aspects, getTransform, args, suppressAspects) {
	  var self = this                                                                                                     // 4
	  var ctx = {context: self, _super: _super, args: args}                                                               // 5
	  var ret, abort                                                                                                      // 6
	                                                                                                                      // 7
	  // args[0] : selector                                                                                               // 8
	  // args[1] : options                                                                                                // 9
	                                                                                                                      // 10
	  // before                                                                                                           // 11
	  if (!suppressAspects) {                                                                                             // 12
	    _.each(aspects.before, function (o) {                                                                             // 13
	      var r = o.aspect.call(ctx, userId, args[0], args[1])                                                            // 14
	      if (r === false) abort = true                                                                                   // 15
	    })                                                                                                                // 16
	                                                                                                                      // 17
	    if (abort) return false                                                                                           // 18
	  }                                                                                                                   // 19
	                                                                                                                      // 20
	  function after (doc) {                                                                                              // 21
	    if (!suppressAspects) {                                                                                           // 22
	      _.each(aspects.after, function (o) {                                                                            // 23
	        o.aspect.call(ctx, userId, args[0], args[1], doc)                                                             // 24
	      })                                                                                                              // 25
	    }                                                                                                                 // 26
	  }                                                                                                                   // 27
	                                                                                                                      // 28
	  ret = _super.apply(self, args)                                                                                      // 29
	  after(ret)                                                                                                          // 30
	                                                                                                                      // 31
	  return ret                                                                                                          // 32
	})                                                                                                                    // 33
	                                                                                                                      // 34
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                    //
	// packages/matb33_collection-hooks/users-compat.js                                                                   //
	//                                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                      //
	/* global CollectionHooks Meteor Mongo */                                                                             // 1
	                                                                                                                      // 2
	if (Meteor.users) {                                                                                                   // 3
	  // If Meteor.users has been instantiated, attempt to re-assign its prototype:                                       // 4
	  CollectionHooks.reassignPrototype(Meteor.users)                                                                     // 5
	                                                                                                                      // 6
	  // Next, give it the hook aspects:                                                                                  // 7
	  var Collection = typeof Mongo !== 'undefined' && typeof Mongo.Collection !== 'undefined' ? Mongo.Collection : Meteor.Collection
	  CollectionHooks.extendCollectionInstance(Meteor.users, Collection)                                                  // 9
	}                                                                                                                     // 10
	                                                                                                                      // 11
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['matb33:collection-hooks'] = {}, {
	  CollectionHooks: CollectionHooks
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/mdg_validated-method.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var check = Package.check.check;
	var Match = Package.check.Match;
	var DDP = Package['ddp-client'].DDP;
	var _ = Package.underscore._;
	var meteorInstall = Package.modules.meteorInstall;
	var Buffer = Package.modules.Buffer;
	var process = Package.modules.process;
	var Symbol = Package['ecmascript-runtime'].Symbol;
	var Map = Package['ecmascript-runtime'].Map;
	var Set = Package['ecmascript-runtime'].Set;
	var meteorBabelHelpers = Package['babel-runtime'].meteorBabelHelpers;
	var Promise = Package.promise.Promise;
	
	/* Package-scope variables */
	var ValidatedMethod;
	
	var require = meteorInstall({"node_modules":{"meteor":{"mdg:validated-method":{"validated-method.js":["babel-runtime/helpers/classCallCheck",function(require,exports,module){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                    //
	// packages/mdg_validated-method/validated-method.js                                                                  //
	//                                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                      //
	var _classCallCheck;module.import('babel-runtime/helpers/classCallCheck',{"default":function(v){_classCallCheck=v}});
	/* global ValidatedMethod:true */                                                                                     // 1
	                                                                                                                      //
	ValidatedMethod = function () {                                                                                       // 3
	  function ValidatedMethod(options) {                                                                                 // 4
	    var _connection$methods;                                                                                          // 4
	                                                                                                                      //
	    _classCallCheck(this, ValidatedMethod);                                                                           // 4
	                                                                                                                      //
	    // Default to no mixins                                                                                           // 5
	    options.mixins = options.mixins || [];                                                                            // 6
	    check(options.mixins, [Function]);                                                                                // 7
	    check(options.name, String);                                                                                      // 8
	    options = applyMixins(options, options.mixins);                                                                   // 9
	                                                                                                                      //
	    // connection argument defaults to Meteor, which is where Methods are defined on client and                       // 11
	    // server                                                                                                         // 12
	    options.connection = options.connection || Meteor;                                                                // 13
	                                                                                                                      //
	    // Allow validate: null shorthand for methods that take no arguments                                              // 15
	    if (options.validate === null) {                                                                                  // 16
	      options.validate = function () {};                                                                              // 17
	    }                                                                                                                 // 18
	                                                                                                                      //
	    // If this is null/undefined, make it an empty object                                                             // 20
	    options.applyOptions = options.applyOptions || {};                                                                // 21
	                                                                                                                      //
	    check(options, Match.ObjectIncluding({                                                                            // 23
	      name: String,                                                                                                   // 24
	      validate: Function,                                                                                             // 25
	      run: Function,                                                                                                  // 26
	      mixins: [Function],                                                                                             // 27
	      connection: Object,                                                                                             // 28
	      applyOptions: Object                                                                                            // 29
	    }));                                                                                                              // 23
	                                                                                                                      //
	    // Default options passed to Meteor.apply, can be overridden with applyOptions                                    // 32
	    var defaultApplyOptions = {                                                                                       // 33
	      // Make it possible to get the ID of an inserted item                                                           // 34
	      returnStubValue: true,                                                                                          // 35
	                                                                                                                      //
	      // Don't call the server method if the client stub throws an error, so that we don't end                        // 37
	      // up doing validations twice                                                                                   // 38
	      throwStubExceptions: true                                                                                       // 39
	    };                                                                                                                // 33
	                                                                                                                      //
	    options.applyOptions = _.extend({}, defaultApplyOptions, options.applyOptions);                                   // 42
	                                                                                                                      //
	    // Attach all options to the ValidatedMethod instance                                                             // 44
	    _.extend(this, options);                                                                                          // 45
	                                                                                                                      //
	    var method = this;                                                                                                // 47
	    this.connection.methods((_connection$methods = {}, _connection$methods[options.name] = function (args) {          // 48
	      // Silence audit-argument-checks since arguments are always checked when using this package                     // 50
	      check(args, Match.Any);                                                                                         // 51
	      var methodInvocation = this;                                                                                    // 52
	                                                                                                                      //
	      return method._execute(methodInvocation, args);                                                                 // 54
	    }, _connection$methods));                                                                                         // 55
	  }                                                                                                                   // 57
	                                                                                                                      //
	  ValidatedMethod.prototype.call = function () {                                                                      // 3
	    function call(args, callback) {                                                                                   // 3
	      // Accept calling with just a callback                                                                          // 60
	      if (_.isFunction(args)) {                                                                                       // 61
	        callback = args;                                                                                              // 62
	        args = {};                                                                                                    // 63
	      }                                                                                                               // 64
	                                                                                                                      //
	      try {                                                                                                           // 66
	        return this.connection.apply(this.name, [args], this.applyOptions, callback);                                 // 67
	      } catch (err) {                                                                                                 // 68
	        if (callback) {                                                                                               // 69
	          // Get errors from the stub in the same way as from the server-side method                                  // 70
	          callback(err);                                                                                              // 71
	        } else {                                                                                                      // 72
	          // No callback passed, throw instead of silently failing; this is what                                      // 73
	          // "normal" Methods do if you don't pass a callback.                                                        // 74
	          throw err;                                                                                                  // 75
	        }                                                                                                             // 76
	      }                                                                                                               // 77
	    }                                                                                                                 // 78
	                                                                                                                      //
	    return call;                                                                                                      // 3
	  }();                                                                                                                // 3
	                                                                                                                      //
	  ValidatedMethod.prototype._execute = function () {                                                                  // 3
	    function _execute(methodInvocation, args) {                                                                       // 3
	      methodInvocation = methodInvocation || {};                                                                      // 81
	                                                                                                                      //
	      // Add `this.name` to reference the Method name                                                                 // 83
	      methodInvocation.name = this.name;                                                                              // 84
	                                                                                                                      //
	      var validateResult = this.validate.bind(methodInvocation)(args);                                                // 86
	                                                                                                                      //
	      if (typeof validateResult !== 'undefined') {                                                                    // 88
	        throw new Error('Returning from validate doesn\'t do anything; perhaps you meant to throw an error?');        // 89
	      }                                                                                                               // 91
	                                                                                                                      //
	      return this.run.bind(methodInvocation)(args);                                                                   // 93
	    }                                                                                                                 // 94
	                                                                                                                      //
	    return _execute;                                                                                                  // 3
	  }();                                                                                                                // 3
	                                                                                                                      //
	  return ValidatedMethod;                                                                                             // 3
	}();                                                                                                                  // 3
	                                                                                                                      //
	// Mixins get a chance to transform the arguments before they are passed to the actual Method                         // 97
	function applyMixins(args, mixins) {                                                                                  // 98
	  // You can pass nested arrays so that people can ship mixin packs                                                   // 99
	  var flatMixins = _.flatten(mixins);                                                                                 // 100
	  // Save name of the method here, so we can attach it to potential error messages                                    // 101
	  var _args = args;                                                                                                   // 98
	  var name = _args.name;                                                                                              // 98
	                                                                                                                      //
	                                                                                                                      //
	  flatMixins.forEach(function (mixin) {                                                                               // 104
	    args = mixin(args);                                                                                               // 105
	                                                                                                                      //
	    if (!Match.test(args, Object)) {                                                                                  // 107
	      var functionName = mixin.toString().match(/function\s(\w+)/);                                                   // 108
	      var msg = 'One of the mixins';                                                                                  // 109
	                                                                                                                      //
	      if (functionName) {                                                                                             // 111
	        msg = 'The function \'' + functionName[1] + '\'';                                                             // 112
	      }                                                                                                               // 113
	                                                                                                                      //
	      throw new Error('Error in ' + name + ' method: ' + msg + ' didn\'t return the options object.');                // 115
	    }                                                                                                                 // 116
	  });                                                                                                                 // 117
	                                                                                                                      //
	  return args;                                                                                                        // 119
	}                                                                                                                     // 120
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]}}}},{"extensions":[".js",".json"]});
	require("./node_modules/meteor/mdg:validated-method/validated-method.js");
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['mdg:validated-method'] = {}, {
	  ValidatedMethod: ValidatedMethod
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/mdg_validation-error.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var MongoObject = Package['aldeed:simple-schema'].MongoObject;
	var meteorInstall = Package.modules.meteorInstall;
	var Buffer = Package.modules.Buffer;
	var process = Package.modules.process;
	var Symbol = Package['ecmascript-runtime'].Symbol;
	var Map = Package['ecmascript-runtime'].Map;
	var Set = Package['ecmascript-runtime'].Set;
	var meteorBabelHelpers = Package['babel-runtime'].meteorBabelHelpers;
	var Promise = Package.promise.Promise;
	
	/* Package-scope variables */
	var ValidationError;
	
	var require = meteorInstall({"node_modules":{"meteor":{"mdg:validation-error":{"validation-error.js":["babel-runtime/helpers/classCallCheck","babel-runtime/helpers/possibleConstructorReturn","babel-runtime/helpers/inherits",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                         //
	// packages/mdg_validation-error/validation-error.js                                                       //
	//                                                                                                         //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                           //
	var _classCallCheck;module.import('babel-runtime/helpers/classCallCheck',{"default":function(v){_classCallCheck=v}});var _possibleConstructorReturn;module.import('babel-runtime/helpers/possibleConstructorReturn',{"default":function(v){_possibleConstructorReturn=v}});var _inherits;module.import('babel-runtime/helpers/inherits',{"default":function(v){_inherits=v}});
	                                                                                                           //
	                                                                                                           //
	/* global ValidationError:true */                                                                          // 1
	/* global SimpleSchema */                                                                                  // 2
	                                                                                                           //
	// This is exactly what comes out of SS.                                                                   // 4
	var errorSchema = new SimpleSchema({                                                                       // 5
	  name: { type: String },                                                                                  // 6
	  type: { type: String },                                                                                  // 7
	  details: { type: Object, blackbox: true, optional: true }                                                // 8
	});                                                                                                        // 5
	                                                                                                           //
	var errorsSchema = new SimpleSchema({                                                                      // 11
	  errors: { type: Array },                                                                                 // 12
	  'errors.$': { type: errorSchema }                                                                        // 13
	});                                                                                                        // 11
	                                                                                                           //
	ValidationError = function (_Meteor$Error) {                                                               // 16
	  _inherits(_class, _Meteor$Error);                                                                        // 16
	                                                                                                           //
	  function _class(errors) {                                                                                // 17
	    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Validation Failed';
	                                                                                                           //
	    _classCallCheck(this, _class);                                                                         // 17
	                                                                                                           //
	    errorsSchema.validate({ errors: errors });                                                             // 18
	                                                                                                           //
	    var _this = _possibleConstructorReturn(this, _Meteor$Error.call(this, ValidationError.ERROR_CODE, message, errors));
	                                                                                                           //
	    _this.errors = errors;                                                                                 // 22
	    return _this;                                                                                          // 17
	  }                                                                                                        // 23
	                                                                                                           //
	  return _class;                                                                                           // 16
	}(Meteor.Error);                                                                                           // 16
	                                                                                                           //
	// If people use this to check for the error code, we can change it                                        // 26
	// in future versions                                                                                      // 27
	ValidationError.ERROR_CODE = 'validation-error';                                                           // 28
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]}}}},{"extensions":[".js",".json"]});
	require("./node_modules/meteor/mdg:validation-error/validation-error.js");
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['mdg:validation-error'] = {}, {
	  ValidationError: ValidationError
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/meteor.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var _ = Package.underscore._;
	
	/* Package-scope variables */
	var global, meteorEnv, Meteor;
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                        //
	// packages/meteor/global.js                                                                              //
	//                                                                                                        //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                          //
	global = this;                                                                                            // 1
	                                                                                                          // 2
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                        //
	// packages/meteor/client_environment.js                                                                  //
	//                                                                                                        //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                          //
	meteorEnv = __meteor_runtime_config__.meteorEnv;                                                          // 1
	                                                                                                          // 2
	/**                                                                                                       // 3
	 * @summary The Meteor namespace                                                                          // 4
	 * @namespace Meteor                                                                                      // 5
	 */                                                                                                       // 6
	Meteor = {                                                                                                // 7
	  /**                                                                                                     // 8
	   * @summary Boolean variable.  True if running in production environment.                               // 9
	   * @locus Anywhere                                                                                      // 10
	   * @static                                                                                              // 11
	   * @type {Boolean}                                                                                      // 12
	   */                                                                                                     // 13
	  isProduction: meteorEnv.NODE_ENV === "production",                                                      // 14
	                                                                                                          // 15
	  /**                                                                                                     // 16
	   * @summary Boolean variable.  True if running in development environment.                              // 17
	   * @locus Anywhere                                                                                      // 18
	   * @static                                                                                              // 19
	   * @type {Boolean}                                                                                      // 20
	   */                                                                                                     // 21
	  isDevelopment: meteorEnv.NODE_ENV !== "production",                                                     // 22
	                                                                                                          // 23
	  /**                                                                                                     // 24
	   * @summary Boolean variable.  True if running in client environment.                                   // 25
	   * @locus Anywhere                                                                                      // 26
	   * @static                                                                                              // 27
	   * @type {Boolean}                                                                                      // 28
	   */                                                                                                     // 29
	  isClient: true,                                                                                         // 30
	                                                                                                          // 31
	  /**                                                                                                     // 32
	   * @summary Boolean variable.  True if running in server environment.                                   // 33
	   * @locus Anywhere                                                                                      // 34
	   * @static                                                                                              // 35
	   * @type {Boolean}                                                                                      // 36
	   */                                                                                                     // 37
	  isServer: false,                                                                                        // 38
	  isCordova: false                                                                                        // 39
	};                                                                                                        // 40
	                                                                                                          // 41
	if (typeof __meteor_runtime_config__ === 'object' &&                                                      // 42
	    __meteor_runtime_config__.PUBLIC_SETTINGS) {                                                          // 43
	  /**                                                                                                     // 44
	   * @summary `Meteor.settings` contains deployment-specific configuration options. You can initialize settings by passing the `--settings` option (which takes the name of a file containing JSON data) to `meteor run` or `meteor deploy`. When running your server directly (e.g. from a bundle), you instead specify settings by putting the JSON directly into the `METEOR_SETTINGS` environment variable. If the settings object contains a key named `public`, then `Meteor.settings.public` will be available on the client as well as the server.  All other properties of `Meteor.settings` are only defined on the server.  You can rely on `Meteor.settings` and `Meteor.settings.public` being defined objects (not undefined) on both client and server even if there are no settings specified.  Changes to `Meteor.settings.public` at runtime will be picked up by new client connections.
	   * @locus Anywhere                                                                                      // 46
	   * @type {Object}                                                                                       // 47
	   */                                                                                                     // 48
	  Meteor.settings = { 'public': __meteor_runtime_config__.PUBLIC_SETTINGS };                              // 49
	}                                                                                                         // 50
	                                                                                                          // 51
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                        //
	// packages/meteor/helpers.js                                                                             //
	//                                                                                                        //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                          //
	if (Meteor.isServer)                                                                                      // 1
	  var Future = Npm.require('fibers/future');                                                              // 2
	                                                                                                          // 3
	if (typeof __meteor_runtime_config__ === 'object' &&                                                      // 4
	    __meteor_runtime_config__.meteorRelease) {                                                            // 5
	  /**                                                                                                     // 6
	   * @summary `Meteor.release` is a string containing the name of the [release](#meteorupdate) with which the project was built (for example, `"1.2.3"`). It is `undefined` if the project was built using a git checkout of Meteor.
	   * @locus Anywhere                                                                                      // 8
	   * @type {String}                                                                                       // 9
	   */                                                                                                     // 10
	  Meteor.release = __meteor_runtime_config__.meteorRelease;                                               // 11
	}                                                                                                         // 12
	                                                                                                          // 13
	// XXX find a better home for these? Ideally they would be _.get,                                         // 14
	// _.ensure, _.delete..                                                                                   // 15
	                                                                                                          // 16
	_.extend(Meteor, {                                                                                        // 17
	  // _get(a,b,c,d) returns a[b][c][d], or else undefined if a[b] or                                       // 18
	  // a[b][c] doesn't exist.                                                                               // 19
	  //                                                                                                      // 20
	  _get: function (obj /*, arguments */) {                                                                 // 21
	    for (var i = 1; i < arguments.length; i++) {                                                          // 22
	      if (!(arguments[i] in obj))                                                                         // 23
	        return undefined;                                                                                 // 24
	      obj = obj[arguments[i]];                                                                            // 25
	    }                                                                                                     // 26
	    return obj;                                                                                           // 27
	  },                                                                                                      // 28
	                                                                                                          // 29
	  // _ensure(a,b,c,d) ensures that a[b][c][d] exists. If it does not,                                     // 30
	  // it is created and set to {}. Either way, it is returned.                                             // 31
	  //                                                                                                      // 32
	  _ensure: function (obj /*, arguments */) {                                                              // 33
	    for (var i = 1; i < arguments.length; i++) {                                                          // 34
	      var key = arguments[i];                                                                             // 35
	      if (!(key in obj))                                                                                  // 36
	        obj[key] = {};                                                                                    // 37
	      obj = obj[key];                                                                                     // 38
	    }                                                                                                     // 39
	                                                                                                          // 40
	    return obj;                                                                                           // 41
	  },                                                                                                      // 42
	                                                                                                          // 43
	  // _delete(a, b, c, d) deletes a[b][c][d], then a[b][c] unless it                                       // 44
	  // isn't empty, then a[b] unless it isn't empty.                                                        // 45
	  //                                                                                                      // 46
	  _delete: function (obj /*, arguments */) {                                                              // 47
	    var stack = [obj];                                                                                    // 48
	    var leaf = true;                                                                                      // 49
	    for (var i = 1; i < arguments.length - 1; i++) {                                                      // 50
	      var key = arguments[i];                                                                             // 51
	      if (!(key in obj)) {                                                                                // 52
	        leaf = false;                                                                                     // 53
	        break;                                                                                            // 54
	      }                                                                                                   // 55
	      obj = obj[key];                                                                                     // 56
	      if (typeof obj !== "object")                                                                        // 57
	        break;                                                                                            // 58
	      stack.push(obj);                                                                                    // 59
	    }                                                                                                     // 60
	                                                                                                          // 61
	    for (var i = stack.length - 1; i >= 0; i--) {                                                         // 62
	      var key = arguments[i+1];                                                                           // 63
	                                                                                                          // 64
	      if (leaf)                                                                                           // 65
	        leaf = false;                                                                                     // 66
	      else                                                                                                // 67
	        for (var other in stack[i][key])                                                                  // 68
	          return; // not empty -- we're done                                                              // 69
	                                                                                                          // 70
	      delete stack[i][key];                                                                               // 71
	    }                                                                                                     // 72
	  },                                                                                                      // 73
	                                                                                                          // 74
	  // wrapAsync can wrap any function that takes some number of arguments that                             // 75
	  // can't be undefined, followed by some optional arguments, where the callback                          // 76
	  // is the last optional argument.                                                                       // 77
	  // e.g. fs.readFile(pathname, [callback]),                                                              // 78
	  // fs.open(pathname, flags, [mode], [callback])                                                         // 79
	  // For maximum effectiveness and least confusion, wrapAsync should be used on                           // 80
	  // functions where the callback is the only argument of type Function.                                  // 81
	                                                                                                          // 82
	  /**                                                                                                     // 83
	   * @memberOf Meteor                                                                                     // 84
	   * @summary Wrap a function that takes a callback function as its final parameter. The signature of the callback of the wrapped function should be `function(error, result){}`. On the server, the wrapped function can be used either synchronously (without passing a callback) or asynchronously (when a callback is passed). On the client, a callback is always required; errors will be logged if there is no callback. If a callback is provided, the environment captured when the original function was called will be restored in the callback.
	   * @locus Anywhere                                                                                      // 86
	   * @param {Function} func A function that takes a callback as its final parameter                       // 87
	   * @param {Object} [context] Optional `this` object against which the original function will be invoked
	   */                                                                                                     // 89
	  wrapAsync: function (fn, context) {                                                                     // 90
	    return function (/* arguments */) {                                                                   // 91
	      var self = context || this;                                                                         // 92
	      var newArgs = _.toArray(arguments);                                                                 // 93
	      var callback;                                                                                       // 94
	                                                                                                          // 95
	      for (var i = newArgs.length - 1; i >= 0; --i) {                                                     // 96
	        var arg = newArgs[i];                                                                             // 97
	        var type = typeof arg;                                                                            // 98
	        if (type !== "undefined") {                                                                       // 99
	          if (type === "function") {                                                                      // 100
	            callback = arg;                                                                               // 101
	          }                                                                                               // 102
	          break;                                                                                          // 103
	        }                                                                                                 // 104
	      }                                                                                                   // 105
	                                                                                                          // 106
	      if (! callback) {                                                                                   // 107
	        if (Meteor.isClient) {                                                                            // 108
	          callback = logErr;                                                                              // 109
	        } else {                                                                                          // 110
	          var fut = new Future();                                                                         // 111
	          callback = fut.resolver();                                                                      // 112
	        }                                                                                                 // 113
	        ++i; // Insert the callback just after arg.                                                       // 114
	      }                                                                                                   // 115
	                                                                                                          // 116
	      newArgs[i] = Meteor.bindEnvironment(callback);                                                      // 117
	      var result = fn.apply(self, newArgs);                                                               // 118
	      return fut ? fut.wait() : result;                                                                   // 119
	    };                                                                                                    // 120
	  },                                                                                                      // 121
	                                                                                                          // 122
	  // Sets child's prototype to a new object whose prototype is parent's                                   // 123
	  // prototype. Used as:                                                                                  // 124
	  //   Meteor._inherits(ClassB, ClassA).                                                                  // 125
	  //   _.extend(ClassB.prototype, { ... })                                                                // 126
	  // Inspired by CoffeeScript's `extend` and Google Closure's `goog.inherits`.                            // 127
	  _inherits: function (Child, Parent) {                                                                   // 128
	    // copy Parent static properties                                                                      // 129
	    for (var key in Parent) {                                                                             // 130
	      // make sure we only copy hasOwnProperty properties vs. prototype                                   // 131
	      // properties                                                                                       // 132
	      if (_.has(Parent, key))                                                                             // 133
	        Child[key] = Parent[key];                                                                         // 134
	    }                                                                                                     // 135
	                                                                                                          // 136
	    // a middle member of prototype chain: takes the prototype from the Parent                            // 137
	    var Middle = function () {                                                                            // 138
	      this.constructor = Child;                                                                           // 139
	    };                                                                                                    // 140
	    Middle.prototype = Parent.prototype;                                                                  // 141
	    Child.prototype = new Middle();                                                                       // 142
	    Child.__super__ = Parent.prototype;                                                                   // 143
	    return Child;                                                                                         // 144
	  }                                                                                                       // 145
	});                                                                                                       // 146
	                                                                                                          // 147
	var warnedAboutWrapAsync = false;                                                                         // 148
	                                                                                                          // 149
	/**                                                                                                       // 150
	 * @deprecated in 0.9.3                                                                                   // 151
	 */                                                                                                       // 152
	Meteor._wrapAsync = function(fn, context) {                                                               // 153
	  if (! warnedAboutWrapAsync) {                                                                           // 154
	    Meteor._debug("Meteor._wrapAsync has been renamed to Meteor.wrapAsync");                              // 155
	    warnedAboutWrapAsync = true;                                                                          // 156
	  }                                                                                                       // 157
	  return Meteor.wrapAsync.apply(Meteor, arguments);                                                       // 158
	};                                                                                                        // 159
	                                                                                                          // 160
	function logErr(err) {                                                                                    // 161
	  if (err) {                                                                                              // 162
	    return Meteor._debug(                                                                                 // 163
	      "Exception in callback of async function",                                                          // 164
	      err.stack ? err.stack : err                                                                         // 165
	    );                                                                                                    // 166
	  }                                                                                                       // 167
	}                                                                                                         // 168
	                                                                                                          // 169
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                        //
	// packages/meteor/setimmediate.js                                                                        //
	//                                                                                                        //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                          //
	// Chooses one of three setImmediate implementations:                                                     // 1
	//                                                                                                        // 2
	// * Native setImmediate (IE 10, Node 0.9+)                                                               // 3
	//                                                                                                        // 4
	// * postMessage (many browsers)                                                                          // 5
	//                                                                                                        // 6
	// * setTimeout  (fallback)                                                                               // 7
	//                                                                                                        // 8
	// The postMessage implementation is based on                                                             // 9
	// https://github.com/NobleJS/setImmediate/tree/1.0.1                                                     // 10
	//                                                                                                        // 11
	// Don't use `nextTick` for Node since it runs its callbacks before                                       // 12
	// I/O, which is stricter than we're looking for.                                                         // 13
	//                                                                                                        // 14
	// Not installed as a polyfill, as our public API is `Meteor.defer`.                                      // 15
	// Since we're not trying to be a polyfill, we have some                                                  // 16
	// simplifications:                                                                                       // 17
	//                                                                                                        // 18
	// If one invocation of a setImmediate callback pauses itself by a                                        // 19
	// call to alert/prompt/showModelDialog, the NobleJS polyfill                                             // 20
	// implementation ensured that no setImmedate callback would run until                                    // 21
	// the first invocation completed.  While correct per the spec, what it                                   // 22
	// would mean for us in practice is that any reactive updates relying                                     // 23
	// on Meteor.defer would be hung in the main window until the modal                                       // 24
	// dialog was dismissed.  Thus we only ensure that a setImmediate                                         // 25
	// function is called in a later event loop.                                                              // 26
	//                                                                                                        // 27
	// We don't need to support using a string to be eval'ed for the                                          // 28
	// callback, arguments to the function, or clearImmediate.                                                // 29
	                                                                                                          // 30
	"use strict";                                                                                             // 31
	                                                                                                          // 32
	var global = this;                                                                                        // 33
	                                                                                                          // 34
	                                                                                                          // 35
	// IE 10, Node >= 9.1                                                                                     // 36
	                                                                                                          // 37
	function useSetImmediate() {                                                                              // 38
	  if (! global.setImmediate)                                                                              // 39
	    return null;                                                                                          // 40
	  else {                                                                                                  // 41
	    var setImmediate = function (fn) {                                                                    // 42
	      global.setImmediate(fn);                                                                            // 43
	    };                                                                                                    // 44
	    setImmediate.implementation = 'setImmediate';                                                         // 45
	    return setImmediate;                                                                                  // 46
	  }                                                                                                       // 47
	}                                                                                                         // 48
	                                                                                                          // 49
	                                                                                                          // 50
	// Android 2.3.6, Chrome 26, Firefox 20, IE 8-9, iOS 5.1.1 Safari                                         // 51
	                                                                                                          // 52
	function usePostMessage() {                                                                               // 53
	  // The test against `importScripts` prevents this implementation                                        // 54
	  // from being installed inside a web worker, where                                                      // 55
	  // `global.postMessage` means something completely different and                                        // 56
	  // can't be used for this purpose.                                                                      // 57
	                                                                                                          // 58
	  if (!global.postMessage || global.importScripts) {                                                      // 59
	    return null;                                                                                          // 60
	  }                                                                                                       // 61
	                                                                                                          // 62
	  // Avoid synchronous post message implementations.                                                      // 63
	                                                                                                          // 64
	  var postMessageIsAsynchronous = true;                                                                   // 65
	  var oldOnMessage = global.onmessage;                                                                    // 66
	  global.onmessage = function () {                                                                        // 67
	      postMessageIsAsynchronous = false;                                                                  // 68
	  };                                                                                                      // 69
	  global.postMessage("", "*");                                                                            // 70
	  global.onmessage = oldOnMessage;                                                                        // 71
	                                                                                                          // 72
	  if (! postMessageIsAsynchronous)                                                                        // 73
	    return null;                                                                                          // 74
	                                                                                                          // 75
	  var funcIndex = 0;                                                                                      // 76
	  var funcs = {};                                                                                         // 77
	                                                                                                          // 78
	  // Installs an event handler on `global` for the `message` event: see                                   // 79
	  // * https://developer.mozilla.org/en/DOM/window.postMessage                                            // 80
	  // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages       // 81
	                                                                                                          // 82
	  // XXX use Random.id() here?                                                                            // 83
	  var MESSAGE_PREFIX = "Meteor._setImmediate." + Math.random() + '.';                                     // 84
	                                                                                                          // 85
	  function isStringAndStartsWith(string, putativeStart) {                                                 // 86
	    return (typeof string === "string" &&                                                                 // 87
	            string.substring(0, putativeStart.length) === putativeStart);                                 // 88
	  }                                                                                                       // 89
	                                                                                                          // 90
	  function onGlobalMessage(event) {                                                                       // 91
	    // This will catch all incoming messages (even from other                                             // 92
	    // windows!), so we need to try reasonably hard to avoid letting                                      // 93
	    // anyone else trick us into firing off. We test the origin is                                        // 94
	    // still this window, and that a (randomly generated)                                                 // 95
	    // unpredictable identifying prefix is present.                                                       // 96
	    if (event.source === global &&                                                                        // 97
	        isStringAndStartsWith(event.data, MESSAGE_PREFIX)) {                                              // 98
	      var index = event.data.substring(MESSAGE_PREFIX.length);                                            // 99
	      try {                                                                                               // 100
	        if (funcs[index])                                                                                 // 101
	          funcs[index]();                                                                                 // 102
	      }                                                                                                   // 103
	      finally {                                                                                           // 104
	        delete funcs[index];                                                                              // 105
	      }                                                                                                   // 106
	    }                                                                                                     // 107
	  }                                                                                                       // 108
	                                                                                                          // 109
	  if (global.addEventListener) {                                                                          // 110
	    global.addEventListener("message", onGlobalMessage, false);                                           // 111
	  } else {                                                                                                // 112
	    global.attachEvent("onmessage", onGlobalMessage);                                                     // 113
	  }                                                                                                       // 114
	                                                                                                          // 115
	  var setImmediate = function (fn) {                                                                      // 116
	    // Make `global` post a message to itself with the handle and                                         // 117
	    // identifying prefix, thus asynchronously invoking our                                               // 118
	    // onGlobalMessage listener above.                                                                    // 119
	    ++funcIndex;                                                                                          // 120
	    funcs[funcIndex] = fn;                                                                                // 121
	    global.postMessage(MESSAGE_PREFIX + funcIndex, "*");                                                  // 122
	  };                                                                                                      // 123
	  setImmediate.implementation = 'postMessage';                                                            // 124
	  return setImmediate;                                                                                    // 125
	}                                                                                                         // 126
	                                                                                                          // 127
	                                                                                                          // 128
	function useTimeout() {                                                                                   // 129
	  var setImmediate = function (fn) {                                                                      // 130
	    global.setTimeout(fn, 0);                                                                             // 131
	  };                                                                                                      // 132
	  setImmediate.implementation = 'setTimeout';                                                             // 133
	  return setImmediate;                                                                                    // 134
	}                                                                                                         // 135
	                                                                                                          // 136
	                                                                                                          // 137
	Meteor._setImmediate =                                                                                    // 138
	  useSetImmediate() ||                                                                                    // 139
	  usePostMessage() ||                                                                                     // 140
	  useTimeout();                                                                                           // 141
	                                                                                                          // 142
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                        //
	// packages/meteor/timers.js                                                                              //
	//                                                                                                        //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                          //
	var withoutInvocation = function (f) {                                                                    // 1
	  if (Package.ddp) {                                                                                      // 2
	    var _CurrentInvocation = Package.ddp.DDP._CurrentInvocation;                                          // 3
	    if (_CurrentInvocation.get() && _CurrentInvocation.get().isSimulation)                                // 4
	      throw new Error("Can't set timers inside simulations");                                             // 5
	    return function () { _CurrentInvocation.withValue(null, f); };                                        // 6
	  }                                                                                                       // 7
	  else                                                                                                    // 8
	    return f;                                                                                             // 9
	};                                                                                                        // 10
	                                                                                                          // 11
	var bindAndCatch = function (context, f) {                                                                // 12
	  return Meteor.bindEnvironment(withoutInvocation(f), context);                                           // 13
	};                                                                                                        // 14
	                                                                                                          // 15
	_.extend(Meteor, {                                                                                        // 16
	  // Meteor.setTimeout and Meteor.setInterval callbacks scheduled                                         // 17
	  // inside a server method are not part of the method invocation and                                     // 18
	  // should clear out the CurrentInvocation environment variable.                                         // 19
	                                                                                                          // 20
	  /**                                                                                                     // 21
	   * @memberOf Meteor                                                                                     // 22
	   * @summary Call a function in the future after waiting for a specified delay.                          // 23
	   * @locus Anywhere                                                                                      // 24
	   * @param {Function} func The function to run                                                           // 25
	   * @param {Number} delay Number of milliseconds to wait before calling function                         // 26
	   */                                                                                                     // 27
	  setTimeout: function (f, duration) {                                                                    // 28
	    return setTimeout(bindAndCatch("setTimeout callback", f), duration);                                  // 29
	  },                                                                                                      // 30
	                                                                                                          // 31
	  /**                                                                                                     // 32
	   * @memberOf Meteor                                                                                     // 33
	   * @summary Call a function repeatedly, with a time delay between calls.                                // 34
	   * @locus Anywhere                                                                                      // 35
	   * @param {Function} func The function to run                                                           // 36
	   * @param {Number} delay Number of milliseconds to wait between each function call.                     // 37
	   */                                                                                                     // 38
	  setInterval: function (f, duration) {                                                                   // 39
	    return setInterval(bindAndCatch("setInterval callback", f), duration);                                // 40
	  },                                                                                                      // 41
	                                                                                                          // 42
	  /**                                                                                                     // 43
	   * @memberOf Meteor                                                                                     // 44
	   * @summary Cancel a repeating function call scheduled by `Meteor.setInterval`.                         // 45
	   * @locus Anywhere                                                                                      // 46
	   * @param {Number} id The handle returned by `Meteor.setInterval`                                       // 47
	   */                                                                                                     // 48
	  clearInterval: function(x) {                                                                            // 49
	    return clearInterval(x);                                                                              // 50
	  },                                                                                                      // 51
	                                                                                                          // 52
	  /**                                                                                                     // 53
	   * @memberOf Meteor                                                                                     // 54
	   * @summary Cancel a function call scheduled by `Meteor.setTimeout`.                                    // 55
	   * @locus Anywhere                                                                                      // 56
	   * @param {Number} id The handle returned by `Meteor.setTimeout`                                        // 57
	   */                                                                                                     // 58
	  clearTimeout: function(x) {                                                                             // 59
	    return clearTimeout(x);                                                                               // 60
	  },                                                                                                      // 61
	                                                                                                          // 62
	  // XXX consider making this guarantee ordering of defer'd callbacks, like                               // 63
	  // Tracker.afterFlush or Node's nextTick (in practice). Then tests can do:                              // 64
	  //    callSomethingThatDefersSomeWork();                                                                // 65
	  //    Meteor.defer(expect(somethingThatValidatesThatTheWorkHappened));                                  // 66
	                                                                                                          // 67
	  /**                                                                                                     // 68
	   * @memberOf Meteor                                                                                     // 69
	   * @summary Defer execution of a function to run asynchronously in the background (similar to `Meteor.setTimeout(func, 0)`.
	   * @locus Anywhere                                                                                      // 71
	   * @param {Function} func The function to run                                                           // 72
	   */                                                                                                     // 73
	  defer: function (f) {                                                                                   // 74
	    Meteor._setImmediate(bindAndCatch("defer callback", f));                                              // 75
	  }                                                                                                       // 76
	});                                                                                                       // 77
	                                                                                                          // 78
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                        //
	// packages/meteor/errors.js                                                                              //
	//                                                                                                        //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                          //
	// Makes an error subclass which properly contains a stack trace in most                                  // 1
	// environments. constructor can set fields on `this` (and should probably set                            // 2
	// `message`, which is what gets displayed at the top of a stack trace).                                  // 3
	//                                                                                                        // 4
	Meteor.makeErrorType = function (name, constructor) {                                                     // 5
	  var errorClass = function (/*arguments*/) {                                                             // 6
	    // Ensure we get a proper stack trace in most Javascript environments                                 // 7
	    if (Error.captureStackTrace) {                                                                        // 8
	      // V8 environments (Chrome and Node.js)                                                             // 9
	      Error.captureStackTrace(this, errorClass);                                                          // 10
	    } else {                                                                                              // 11
	      // Borrow the .stack property of a native Error object.                                             // 12
	      this.stack = new Error().stack;                                                                     // 13
	    }                                                                                                     // 14
	    // Safari magically works.                                                                            // 15
	                                                                                                          // 16
	    constructor.apply(this, arguments);                                                                   // 17
	                                                                                                          // 18
	    this.errorType = name;                                                                                // 19
	  };                                                                                                      // 20
	                                                                                                          // 21
	  Meteor._inherits(errorClass, Error);                                                                    // 22
	                                                                                                          // 23
	  return errorClass;                                                                                      // 24
	};                                                                                                        // 25
	                                                                                                          // 26
	// This should probably be in the livedata package, but we don't want                                     // 27
	// to require you to use the livedata package to get it. Eventually we                                    // 28
	// should probably rename it to DDP.Error and put it back in the                                          // 29
	// 'livedata' package (which we should rename to 'ddp' also.)                                             // 30
	//                                                                                                        // 31
	// Note: The DDP server assumes that Meteor.Error EJSON-serializes as an object                           // 32
	// containing 'error' and optionally 'reason' and 'details'.                                              // 33
	// The DDP client manually puts these into Meteor.Error objects. (We don't use                            // 34
	// EJSON.addType here because the type is determined by location in the                                   // 35
	// protocol, not text on the wire.)                                                                       // 36
	                                                                                                          // 37
	/**                                                                                                       // 38
	 * @summary This class represents a symbolic error thrown by a method.                                    // 39
	 * @locus Anywhere                                                                                        // 40
	 * @class                                                                                                 // 41
	 * @param {String} error A string code uniquely identifying this kind of error.                           // 42
	 * This string should be used by callers of the method to determine the                                   // 43
	 * appropriate action to take, instead of attempting to parse the reason                                  // 44
	 * or details fields. For example:                                                                        // 45
	 *                                                                                                        // 46
	 * ```                                                                                                    // 47
	 * // on the server, pick a code unique to this error                                                     // 48
	 * // the reason field should be a useful debug message                                                   // 49
	 * throw new Meteor.Error("logged-out",                                                                   // 50
	 *   "The user must be logged in to post a comment.");                                                    // 51
	 *                                                                                                        // 52
	 * // on the client                                                                                       // 53
	 * Meteor.call("methodName", function (error) {                                                           // 54
	 *   // identify the error                                                                                // 55
	 *   if (error && error.error === "logged-out") {                                                         // 56
	 *     // show a nice error message                                                                       // 57
	 *     Session.set("errorMessage", "Please log in to post a comment.");                                   // 58
	 *   }                                                                                                    // 59
	 * });                                                                                                    // 60
	 * ```                                                                                                    // 61
	 *                                                                                                        // 62
	 * For legacy reasons, some built-in Meteor functions such as `check` throw                               // 63
	 * errors with a number in this field.                                                                    // 64
	 *                                                                                                        // 65
	 * @param {String} [reason] Optional.  A short human-readable summary of the                              // 66
	 * error, like 'Not Found'.                                                                               // 67
	 * @param {String} [details] Optional.  Additional information about the error,                           // 68
	 * like a textual stack trace.                                                                            // 69
	 */                                                                                                       // 70
	Meteor.Error = Meteor.makeErrorType(                                                                      // 71
	  "Meteor.Error",                                                                                         // 72
	  function (error, reason, details) {                                                                     // 73
	    var self = this;                                                                                      // 74
	                                                                                                          // 75
	    // String code uniquely identifying this kind of error.                                               // 76
	    self.error = error;                                                                                   // 77
	                                                                                                          // 78
	    // Optional: A short human-readable summary of the error. Not                                         // 79
	    // intended to be shown to end users, just developers. ("Not Found",                                  // 80
	    // "Internal Server Error")                                                                           // 81
	    self.reason = reason;                                                                                 // 82
	                                                                                                          // 83
	    // Optional: Additional information about the error, say for                                          // 84
	    // debugging. It might be a (textual) stack trace if the server is                                    // 85
	    // willing to provide one. The corresponding thing in HTTP would be                                   // 86
	    // the body of a 404 or 500 response. (The difference is that we                                      // 87
	    // never expect this to be shown to end users, only developers, so                                    // 88
	    // it doesn't need to be pretty.)                                                                     // 89
	    self.details = details;                                                                               // 90
	                                                                                                          // 91
	    // This is what gets displayed at the top of a stack trace. Current                                   // 92
	    // format is "[404]" (if no reason is set) or "File not found [404]"                                  // 93
	    if (self.reason)                                                                                      // 94
	      self.message = self.reason + ' [' + self.error + ']';                                               // 95
	    else                                                                                                  // 96
	      self.message = '[' + self.error + ']';                                                              // 97
	  });                                                                                                     // 98
	                                                                                                          // 99
	// Meteor.Error is basically data and is sent over DDP, so you should be able to                          // 100
	// properly EJSON-clone it. This is especially important because if a                                     // 101
	// Meteor.Error is thrown through a Future, the error, reason, and details                                // 102
	// properties become non-enumerable so a standard Object clone won't preserve                             // 103
	// them and they will be lost from DDP.                                                                   // 104
	Meteor.Error.prototype.clone = function () {                                                              // 105
	  var self = this;                                                                                        // 106
	  return new Meteor.Error(self.error, self.reason, self.details);                                         // 107
	};                                                                                                        // 108
	                                                                                                          // 109
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                        //
	// packages/meteor/fiber_stubs_client.js                                                                  //
	//                                                                                                        //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                          //
	// This file is a partial analogue to fiber_helpers.js, which allows the client                           // 1
	// to use a queue too, and also to call noYieldsAllowed.                                                  // 2
	                                                                                                          // 3
	// The client has no ability to yield, so noYieldsAllowed is a noop.                                      // 4
	//                                                                                                        // 5
	Meteor._noYieldsAllowed = function (f) {                                                                  // 6
	  return f();                                                                                             // 7
	};                                                                                                        // 8
	                                                                                                          // 9
	// An even simpler queue of tasks than the fiber-enabled one.  This one just                              // 10
	// runs all the tasks when you call runTask or flush, synchronously.                                      // 11
	//                                                                                                        // 12
	Meteor._SynchronousQueue = function () {                                                                  // 13
	  var self = this;                                                                                        // 14
	  self._tasks = [];                                                                                       // 15
	  self._running = false;                                                                                  // 16
	  self._runTimeout = null;                                                                                // 17
	};                                                                                                        // 18
	                                                                                                          // 19
	_.extend(Meteor._SynchronousQueue.prototype, {                                                            // 20
	  runTask: function (task) {                                                                              // 21
	    var self = this;                                                                                      // 22
	    if (!self.safeToRunTask())                                                                            // 23
	      throw new Error("Could not synchronously run a task from a running task");                          // 24
	    self._tasks.push(task);                                                                               // 25
	    var tasks = self._tasks;                                                                              // 26
	    self._tasks = [];                                                                                     // 27
	    self._running = true;                                                                                 // 28
	                                                                                                          // 29
	    if (self._runTimeout) {                                                                               // 30
	      // Since we're going to drain the queue, we can forget about the timeout                            // 31
	      // which tries to run it.  (But if one of our tasks queues something else,                          // 32
	      // the timeout will be correctly re-created.)                                                       // 33
	      clearTimeout(self._runTimeout);                                                                     // 34
	      self._runTimeout = null;                                                                            // 35
	    }                                                                                                     // 36
	                                                                                                          // 37
	    try {                                                                                                 // 38
	      while (!_.isEmpty(tasks)) {                                                                         // 39
	        var t = tasks.shift();                                                                            // 40
	        try {                                                                                             // 41
	          t();                                                                                            // 42
	        } catch (e) {                                                                                     // 43
	          if (_.isEmpty(tasks)) {                                                                         // 44
	            // this was the last task, that is, the one we're calling runTask                             // 45
	            // for.                                                                                       // 46
	            throw e;                                                                                      // 47
	          } else {                                                                                        // 48
	            Meteor._debug("Exception in queued task: " + (e.stack || e));                                 // 49
	          }                                                                                               // 50
	        }                                                                                                 // 51
	      }                                                                                                   // 52
	    } finally {                                                                                           // 53
	      self._running = false;                                                                              // 54
	    }                                                                                                     // 55
	  },                                                                                                      // 56
	                                                                                                          // 57
	  queueTask: function (task) {                                                                            // 58
	    var self = this;                                                                                      // 59
	    self._tasks.push(task);                                                                               // 60
	    // Intentionally not using Meteor.setTimeout, because it doesn't like runing                          // 61
	    // in stubs for now.                                                                                  // 62
	    if (!self._runTimeout) {                                                                              // 63
	      self._runTimeout = setTimeout(_.bind(self.flush, self), 0);                                         // 64
	    }                                                                                                     // 65
	  },                                                                                                      // 66
	                                                                                                          // 67
	  flush: function () {                                                                                    // 68
	    var self = this;                                                                                      // 69
	    self.runTask(function () {});                                                                         // 70
	  },                                                                                                      // 71
	                                                                                                          // 72
	  drain: function () {                                                                                    // 73
	    var self = this;                                                                                      // 74
	    if (!self.safeToRunTask())                                                                            // 75
	      return;                                                                                             // 76
	    while (!_.isEmpty(self._tasks)) {                                                                     // 77
	      self.flush();                                                                                       // 78
	    }                                                                                                     // 79
	  },                                                                                                      // 80
	                                                                                                          // 81
	  safeToRunTask: function () {                                                                            // 82
	    var self = this;                                                                                      // 83
	    return !self._running;                                                                                // 84
	  }                                                                                                       // 85
	});                                                                                                       // 86
	                                                                                                          // 87
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                        //
	// packages/meteor/startup_client.js                                                                      //
	//                                                                                                        //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                          //
	var callbackQueue = [];                                                                                   // 1
	var isLoadingCompleted = false;                                                                           // 2
	var isReady = false;                                                                                      // 3
	                                                                                                          // 4
	// Keeps track of how many events to wait for in addition to loading completing,                          // 5
	// before we're considered ready.                                                                         // 6
	var readyHoldsCount = 0;                                                                                  // 7
	                                                                                                          // 8
	var holdReady =  function () {                                                                            // 9
	  readyHoldsCount++;                                                                                      // 10
	}                                                                                                         // 11
	                                                                                                          // 12
	var releaseReadyHold = function () {                                                                      // 13
	  readyHoldsCount--;                                                                                      // 14
	  maybeReady();                                                                                           // 15
	}                                                                                                         // 16
	                                                                                                          // 17
	var maybeReady = function () {                                                                            // 18
	  if (isReady || !isLoadingCompleted || readyHoldsCount > 0)                                              // 19
	    return;                                                                                               // 20
	                                                                                                          // 21
	  isReady = true;                                                                                         // 22
	                                                                                                          // 23
	  // Run startup callbacks                                                                                // 24
	  while (callbackQueue.length)                                                                            // 25
	    (callbackQueue.shift())();                                                                            // 26
	                                                                                                          // 27
	  if (Meteor.isCordova) {                                                                                 // 28
	    // Notify the WebAppLocalServer plugin that startup was completed successfully,                       // 29
	    // so we can roll back faulty versions if this doesn't happen                                         // 30
	    WebAppLocalServer.startupDidComplete();                                                               // 31
	  }                                                                                                       // 32
	};                                                                                                        // 33
	                                                                                                          // 34
	var loadingCompleted = function () {                                                                      // 35
	  if (!isLoadingCompleted) {                                                                              // 36
	    isLoadingCompleted = true;                                                                            // 37
	    maybeReady();                                                                                         // 38
	  }                                                                                                       // 39
	}                                                                                                         // 40
	                                                                                                          // 41
	if (Meteor.isCordova) {                                                                                   // 42
	  holdReady();                                                                                            // 43
	  document.addEventListener('deviceready', releaseReadyHold, false);                                      // 44
	}                                                                                                         // 45
	                                                                                                          // 46
	if (document.readyState === 'complete' || document.readyState === 'loaded') {                             // 47
	  // Loading has completed,                                                                               // 48
	  // but allow other scripts the opportunity to hold ready                                                // 49
	  window.setTimeout(loadingCompleted);                                                                    // 50
	} else { // Attach event listeners to wait for loading to complete                                        // 51
	  if (document.addEventListener) {                                                                        // 52
	    document.addEventListener('DOMContentLoaded', loadingCompleted, false);                               // 53
	    window.addEventListener('load', loadingCompleted, false);                                             // 54
	  } else { // Use IE event model for < IE9                                                                // 55
	    document.attachEvent('onreadystatechange', function () {                                              // 56
	      if (document.readyState === "complete") {                                                           // 57
	        loadingCompleted();                                                                               // 58
	      }                                                                                                   // 59
	    });                                                                                                   // 60
	    window.attachEvent('load', loadingCompleted);                                                         // 61
	  }                                                                                                       // 62
	}                                                                                                         // 63
	                                                                                                          // 64
	/**                                                                                                       // 65
	 * @summary Run code when a client or a server starts.                                                    // 66
	 * @locus Anywhere                                                                                        // 67
	 * @param {Function} func A function to run on startup.                                                   // 68
	 */                                                                                                       // 69
	Meteor.startup = function (callback) {                                                                    // 70
	  // Fix for < IE9, see http://javascript.nwbox.com/IEContentLoaded/                                      // 71
	  var doScroll = !document.addEventListener &&                                                            // 72
	    document.documentElement.doScroll;                                                                    // 73
	                                                                                                          // 74
	  if (!doScroll || window !== top) {                                                                      // 75
	    if (isReady)                                                                                          // 76
	      callback();                                                                                         // 77
	    else                                                                                                  // 78
	      callbackQueue.push(callback);                                                                       // 79
	  } else {                                                                                                // 80
	    try { doScroll('left'); }                                                                             // 81
	    catch (error) {                                                                                       // 82
	      setTimeout(function () { Meteor.startup(callback); }, 50);                                          // 83
	      return;                                                                                             // 84
	    };                                                                                                    // 85
	    callback();                                                                                           // 86
	  }                                                                                                       // 87
	};                                                                                                        // 88
	                                                                                                          // 89
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                        //
	// packages/meteor/debug.js                                                                               //
	//                                                                                                        //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                          //
	var suppress = 0;                                                                                         // 1
	                                                                                                          // 2
	// replacement for console.log. This is a temporary API. We should                                        // 3
	// provide a real logging API soon (possibly just a polyfill for                                          // 4
	// console?)                                                                                              // 5
	//                                                                                                        // 6
	// NOTE: this is used on the server to print the warning about                                            // 7
	// having autopublish enabled when you probably meant to turn it                                          // 8
	// off. it's not really the proper use of something called                                                // 9
	// _debug. the intent is for this message to go to the terminal and                                       // 10
	// be very visible. if you change _debug to go someplace else, etc,                                       // 11
	// please fix the autopublish code to do something reasonable.                                            // 12
	//                                                                                                        // 13
	Meteor._debug = function (/* arguments */) {                                                              // 14
	  if (suppress) {                                                                                         // 15
	    suppress--;                                                                                           // 16
	    return;                                                                                               // 17
	  }                                                                                                       // 18
	  if (typeof console !== 'undefined' &&                                                                   // 19
	      typeof console.log !== 'undefined') {                                                               // 20
	    if (arguments.length == 0) { // IE Companion breaks otherwise                                         // 21
	      // IE10 PP4 requires at least one argument                                                          // 22
	      console.log('');                                                                                    // 23
	    } else {                                                                                              // 24
	      // IE doesn't have console.log.apply, it's not a real Object.                                       // 25
	      // http://stackoverflow.com/questions/5538972/console-log-apply-not-working-in-ie9                  // 26
	      // http://patik.com/blog/complete-cross-browser-console-log/                                        // 27
	      if (typeof console.log.apply === "function") {                                                      // 28
	        // Most browsers                                                                                  // 29
	                                                                                                          // 30
	        // Chrome and Safari only hyperlink URLs to source files in first argument of                     // 31
	        // console.log, so try to call it with one argument if possible.                                  // 32
	        // Approach taken here: If all arguments are strings, join them on space.                         // 33
	        // See https://github.com/meteor/meteor/pull/732#issuecomment-13975991                            // 34
	        var allArgumentsOfTypeString = true;                                                              // 35
	        for (var i = 0; i < arguments.length; i++)                                                        // 36
	          if (typeof arguments[i] !== "string")                                                           // 37
	            allArgumentsOfTypeString = false;                                                             // 38
	                                                                                                          // 39
	        if (allArgumentsOfTypeString)                                                                     // 40
	          console.log.apply(console, [Array.prototype.join.call(arguments, " ")]);                        // 41
	        else                                                                                              // 42
	          console.log.apply(console, arguments);                                                          // 43
	                                                                                                          // 44
	      } else if (typeof Function.prototype.bind === "function") {                                         // 45
	        // IE9                                                                                            // 46
	        var log = Function.prototype.bind.call(console.log, console);                                     // 47
	        log.apply(console, arguments);                                                                    // 48
	      } else {                                                                                            // 49
	        // IE8                                                                                            // 50
	        Function.prototype.call.call(console.log, console, Array.prototype.slice.call(arguments));        // 51
	      }                                                                                                   // 52
	    }                                                                                                     // 53
	  }                                                                                                       // 54
	};                                                                                                        // 55
	                                                                                                          // 56
	// Suppress the next 'count' Meteor._debug messsages. Use this to                                         // 57
	// stop tests from spamming the console.                                                                  // 58
	//                                                                                                        // 59
	Meteor._suppress_log = function (count) {                                                                 // 60
	  suppress += count;                                                                                      // 61
	};                                                                                                        // 62
	                                                                                                          // 63
	Meteor._suppressed_log_expected = function () {                                                           // 64
	  return suppress !== 0;                                                                                  // 65
	};                                                                                                        // 66
	                                                                                                          // 67
	                                                                                                          // 68
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                        //
	// packages/meteor/string_utils.js                                                                        //
	//                                                                                                        //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                          //
	// Like Perl's quotemeta: quotes all regexp metacharacters.                                               // 1
	// Code taken from                                                                                        // 2
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions                      // 3
	Meteor._escapeRegExp = function (string) {                                                                // 4
	    return String(string).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");                                         // 5
	};                                                                                                        // 6
	                                                                                                          // 7
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                        //
	// packages/meteor/test_environment.js                                                                    //
	//                                                                                                        //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                          //
	var TEST_METADATA_STR;                                                                                    // 1
	if (Meteor.isClient) {                                                                                    // 2
	  TEST_METADATA_STR = meteorEnv.TEST_METADATA;                                                            // 3
	} else {                                                                                                  // 4
	  TEST_METADATA_STR = process.env.TEST_METADATA;                                                          // 5
	}                                                                                                         // 6
	                                                                                                          // 7
	var TEST_METADATA = JSON.parse(TEST_METADATA_STR || "{}");                                                // 8
	var testDriverPackageName = TEST_METADATA.driverPackage;                                                  // 9
	                                                                                                          // 10
	// Note that if we are in test-packages mode neither of these will be set,                                // 11
	// but we will have a test driver package                                                                 // 12
	Meteor.isTest = !!TEST_METADATA.isTest;                                                                   // 13
	Meteor.isAppTest = !!TEST_METADATA.isAppTest;                                                             // 14
	Meteor.isPackageTest = !!testDriverPackageName && !Meteor.isTest && !Meteor.isAppTest;                    // 15
	                                                                                                          // 16
	if (typeof testDriverPackageName === "string") {                                                          // 17
	  Meteor.startup(function() {                                                                             // 18
	    var testDriverPackage = Package[testDriverPackageName];                                               // 19
	    if (! testDriverPackage) {                                                                            // 20
	      throw new Error("Can't find test driver package: " + testDriverPackageName);                        // 21
	    }                                                                                                     // 22
	                                                                                                          // 23
	    // On the client, the test driver *must* define `runTests`                                            // 24
	    if (Meteor.isClient) {                                                                                // 25
	      if (typeof testDriverPackage.runTests !== "function") {                                             // 26
	        throw new Error("Test driver package " + testDriverPackageName                                    // 27
	          + " missing `runTests` export");                                                                // 28
	      }                                                                                                   // 29
	      testDriverPackage.runTests();                                                                       // 30
	    } else {                                                                                              // 31
	      // The server can optionally define `start`                                                         // 32
	      if (typeof testDriverPackage.start === "function") {                                                // 33
	        testDriverPackage.start();                                                                        // 34
	      }                                                                                                   // 35
	    }                                                                                                     // 36
	  });                                                                                                     // 37
	}                                                                                                         // 38
	                                                                                                          // 39
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                        //
	// packages/meteor/dynamics_browser.js                                                                    //
	//                                                                                                        //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                          //
	// Simple implementation of dynamic scoping, for use in browsers                                          // 1
	                                                                                                          // 2
	var nextSlot = 0;                                                                                         // 3
	var currentValues = [];                                                                                   // 4
	                                                                                                          // 5
	Meteor.EnvironmentVariable = function () {                                                                // 6
	  this.slot = nextSlot++;                                                                                 // 7
	};                                                                                                        // 8
	                                                                                                          // 9
	_.extend(Meteor.EnvironmentVariable.prototype, {                                                          // 10
	  get: function () {                                                                                      // 11
	    return currentValues[this.slot];                                                                      // 12
	  },                                                                                                      // 13
	                                                                                                          // 14
	  getOrNullIfOutsideFiber: function () {                                                                  // 15
	    return this.get();                                                                                    // 16
	  },                                                                                                      // 17
	                                                                                                          // 18
	  withValue: function (value, func) {                                                                     // 19
	    var saved = currentValues[this.slot];                                                                 // 20
	    try {                                                                                                 // 21
	      currentValues[this.slot] = value;                                                                   // 22
	      var ret = func();                                                                                   // 23
	    } finally {                                                                                           // 24
	      currentValues[this.slot] = saved;                                                                   // 25
	    }                                                                                                     // 26
	    return ret;                                                                                           // 27
	  }                                                                                                       // 28
	});                                                                                                       // 29
	                                                                                                          // 30
	Meteor.bindEnvironment = function (func, onException, _this) {                                            // 31
	  // needed in order to be able to create closures inside func and                                        // 32
	  // have the closed variables not change back to their original                                          // 33
	  // values                                                                                               // 34
	  var boundValues = _.clone(currentValues);                                                               // 35
	                                                                                                          // 36
	  if (!onException || typeof(onException) === 'string') {                                                 // 37
	    var description = onException || "callback of async function";                                        // 38
	    onException = function (error) {                                                                      // 39
	      Meteor._debug(                                                                                      // 40
	        "Exception in " + description + ":",                                                              // 41
	        error && error.stack || error                                                                     // 42
	      );                                                                                                  // 43
	    };                                                                                                    // 44
	  }                                                                                                       // 45
	                                                                                                          // 46
	  return function (/* arguments */) {                                                                     // 47
	    var savedValues = currentValues;                                                                      // 48
	    try {                                                                                                 // 49
	      currentValues = boundValues;                                                                        // 50
	      var ret = func.apply(_this, _.toArray(arguments));                                                  // 51
	    } catch (e) {                                                                                         // 52
	      // note: callback-hook currently relies on the fact that if onException                             // 53
	      // throws in the browser, the wrapped call throws.                                                  // 54
	      onException(e);                                                                                     // 55
	    } finally {                                                                                           // 56
	      currentValues = savedValues;                                                                        // 57
	    }                                                                                                     // 58
	    return ret;                                                                                           // 59
	  };                                                                                                      // 60
	};                                                                                                        // 61
	                                                                                                          // 62
	Meteor._nodeCodeMustBeInFiber = function () {                                                             // 63
	  // no-op on browser                                                                                     // 64
	};                                                                                                        // 65
	                                                                                                          // 66
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                        //
	// packages/meteor/url_common.js                                                                          //
	//                                                                                                        //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                          //
	/**                                                                                                       // 1
	 * @summary Generate an absolute URL pointing to the application. The server reads from the `ROOT_URL` environment variable to determine where it is running. This is taken care of automatically for apps deployed to Galaxy, but must be provided when using `meteor build`.
	 * @locus Anywhere                                                                                        // 3
	 * @param {String} [path] A path to append to the root URL. Do not include a leading "`/`".               // 4
	 * @param {Object} [options]                                                                              // 5
	 * @param {Boolean} options.secure Create an HTTPS URL.                                                   // 6
	 * @param {Boolean} options.replaceLocalhost Replace localhost with 127.0.0.1. Useful for services that don't recognize localhost as a domain name.
	 * @param {String} options.rootUrl Override the default ROOT_URL from the server environment. For example: "`http://foo.example.com`"
	 */                                                                                                       // 9
	Meteor.absoluteUrl = function (path, options) {                                                           // 10
	  // path is optional                                                                                     // 11
	  if (!options && typeof path === 'object') {                                                             // 12
	    options = path;                                                                                       // 13
	    path = undefined;                                                                                     // 14
	  }                                                                                                       // 15
	  // merge options with defaults                                                                          // 16
	  options = _.extend({}, Meteor.absoluteUrl.defaultOptions, options || {});                               // 17
	                                                                                                          // 18
	  var url = options.rootUrl;                                                                              // 19
	  if (!url)                                                                                               // 20
	    throw new Error("Must pass options.rootUrl or set ROOT_URL in the server environment");               // 21
	                                                                                                          // 22
	  if (!/^http[s]?:\/\//i.test(url)) // url starts with 'http://' or 'https://'                            // 23
	    url = 'http://' + url; // we will later fix to https if options.secure is set                         // 24
	                                                                                                          // 25
	  if (!/\/$/.test(url)) // url ends with '/'                                                              // 26
	    url += '/';                                                                                           // 27
	                                                                                                          // 28
	  if (path)                                                                                               // 29
	    url += path;                                                                                          // 30
	                                                                                                          // 31
	  // turn http to https if secure option is set, and we're not talking                                    // 32
	  // to localhost.                                                                                        // 33
	  if (options.secure &&                                                                                   // 34
	      /^http:/.test(url) && // url starts with 'http:'                                                    // 35
	      !/http:\/\/localhost[:\/]/.test(url) && // doesn't match localhost                                  // 36
	      !/http:\/\/127\.0\.0\.1[:\/]/.test(url)) // or 127.0.0.1                                            // 37
	    url = url.replace(/^http:/, 'https:');                                                                // 38
	                                                                                                          // 39
	  if (options.replaceLocalhost)                                                                           // 40
	    url = url.replace(/^http:\/\/localhost([:\/].*)/, 'http://127.0.0.1$1');                              // 41
	                                                                                                          // 42
	  return url;                                                                                             // 43
	};                                                                                                        // 44
	                                                                                                          // 45
	// allow later packages to override default options                                                       // 46
	Meteor.absoluteUrl.defaultOptions = { };                                                                  // 47
	if (typeof __meteor_runtime_config__ === "object" &&                                                      // 48
	    __meteor_runtime_config__.ROOT_URL)                                                                   // 49
	  Meteor.absoluteUrl.defaultOptions.rootUrl = __meteor_runtime_config__.ROOT_URL;                         // 50
	                                                                                                          // 51
	                                                                                                          // 52
	Meteor._relativeToSiteRootUrl = function (link) {                                                         // 53
	  if (typeof __meteor_runtime_config__ === "object" &&                                                    // 54
	      link.substr(0, 1) === "/")                                                                          // 55
	    link = (__meteor_runtime_config__.ROOT_URL_PATH_PREFIX || "") + link;                                 // 56
	  return link;                                                                                            // 57
	};                                                                                                        // 58
	                                                                                                          // 59
	////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.meteor = {}, {
	  Meteor: Meteor,
	  global: global,
	  meteorEnv: meteorEnv
	});
	
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/meteorhacks_cluster.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var DDP = Package['ddp-client'].DDP;
	var _ = Package.underscore._;
	
	/* Package-scope variables */
	var Cluster, ConnectionWatcher;
	
	(function(){
	
	//////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                      //
	// packages/meteorhacks_cluster/packages/meteorhacks_cluster.js                         //
	//                                                                                      //
	//////////////////////////////////////////////////////////////////////////////////////////
	                                                                                        //
	(function () {                                                                          // 1
	                                                                                        // 2
	////////////////////////////////////////////////////////////////////////////////////    // 3
	//                                                                                //    // 4
	// packages/meteorhacks:cluster/lib/namespace.js                                  //    // 5
	//                                                                                //    // 6
	////////////////////////////////////////////////////////////////////////////////////    // 7
	                                                                                  //    // 8
	Cluster = {};                                                                     // 1  // 9
	////////////////////////////////////////////////////////////////////////////////////    // 10
	                                                                                        // 11
	}).call(this);                                                                          // 12
	                                                                                        // 13
	                                                                                        // 14
	                                                                                        // 15
	                                                                                        // 16
	                                                                                        // 17
	                                                                                        // 18
	(function () {                                                                          // 19
	                                                                                        // 20
	////////////////////////////////////////////////////////////////////////////////////    // 21
	//                                                                                //    // 22
	// packages/meteorhacks:cluster/lib/connection_watcher.js                         //    // 23
	//                                                                                //    // 24
	////////////////////////////////////////////////////////////////////////////////////    // 25
	                                                                                  //    // 26
	ConnectionWatcher = function ConnectionWatcher(discovery, serviceName, options) { // 1  // 27
	  options = options || {};                                                        // 2  // 28
	                                                                                  // 3  // 29
	  this._discovery = discovery;                                                    // 4  // 30
	  this._serviceName = serviceName;                                                // 5  // 31
	  this._query = options.query || {};                                              // 6  // 32
	  this._ddpOptions = options.ddpOptions;                                          // 7  // 33
	  this._watchTimeout = options.watchTimeout || 5 * 1000;                          // 8  // 34
	                                                                                  // 9  // 35
	  this._currUrl = null;                                                           // 10
	  this._ddpUrls = {};                                                             // 11
	                                                                                  // 12
	  this._connection = DDP.connect(this._getDefaultURL(), this._ddpOptions);        // 13
	  this._connection.disconnect();                                                  // 14
	  this._newConnectionWatcher = this._watchForNewConnections();                    // 15
	};                                                                                // 16
	                                                                                  // 17
	ConnectionWatcher.prototype.getConnection = function() {                          // 18
	  return this._connection;                                                        // 19
	};                                                                                // 20
	                                                                                  // 21
	ConnectionWatcher.prototype._getDefaultURL = function() {                         // 22
	  if(Meteor.isServer) {                                                           // 23
	    return "";                                                                    // 24
	  } else {                                                                        // 25
	    return location.origin;                                                       // 26
	  }                                                                               // 27
	};                                                                                // 28
	                                                                                  // 29
	ConnectionWatcher.prototype._watchForNewConnections = function() {                // 30
	  var self = this;                                                                // 31
	  var connectInitially = false;                                                   // 32
	                                                                                  // 33
	  setConnectionIfNeeded();                                                        // 34
	  // to make sure, we are connecting again                                        // 35
	  var timeoutHandler =                                                            // 36
	    Meteor.setInterval(setConnectionIfNeeded, self._watchTimeout);                // 37
	                                                                                  // 38
	  function setConnectionIfNeeded() {                                              // 39
	    var status = self._connection.status();                                       // 40
	    // do not reconnect again, if disconnected manually                           // 41
	    // but not at the first time since we do it manually                          // 42
	    // until we pick an endpoint                                                  // 43
	    var isOffline = connectInitially && status.status == "offline";               // 44
	    if(!status.connected && !isOffline) {                                         // 45
	      var url = self._discovery.pickEndpoint(self._serviceName);                  // 46
	      if(url) {                                                                   // 47
	        self._connection.reconnect({url: url});                                   // 48
	        connectInitially = true;                                                  // 49
	      }                                                                           // 50
	    }                                                                             // 51
	  }                                                                               // 52
	                                                                                  // 53
	  var returnContext = {                                                           // 54
	    stop: function() {                                                            // 55
	      Meteor.clearTimeout(timeoutHandler);                                        // 56
	    }                                                                             // 57
	  };                                                                              // 58
	                                                                                  // 59
	  return returnContext;                                                           // 60
	};                                                                                // 61
	////////////////////////////////////////////////////////////////////////////////////    // 88
	                                                                                        // 89
	}).call(this);                                                                          // 90
	                                                                                        // 91
	                                                                                        // 92
	                                                                                        // 93
	                                                                                        // 94
	                                                                                        // 95
	                                                                                        // 96
	(function () {                                                                          // 97
	                                                                                        // 98
	////////////////////////////////////////////////////////////////////////////////////    // 99
	//                                                                                //    // 100
	// packages/meteorhacks:cluster/lib/client/api.js                                 //    // 101
	//                                                                                //    // 102
	////////////////////////////////////////////////////////////////////////////////////    // 103
	                                                                                  //    // 104
	Cluster.discoverConnection = function(serviceName) {                              // 1  // 105
	  return DDP.connect("/" + serviceName);                                          // 2  // 106
	};                                                                                // 3  // 107
	////////////////////////////////////////////////////////////////////////////////////    // 108
	                                                                                        // 109
	}).call(this);                                                                          // 110
	                                                                                        // 111
	//////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['meteorhacks:cluster'] = {}, {
	  Cluster: Cluster
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/meteorhacks_picker.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	
	/* Package-scope variables */
	var Picker;
	
	(function(){
	
	///////////////////////////////////////////////////////////////////////
	//                                                                   //
	// packages/meteorhacks_picker/packages/meteorhacks_picker.js        //
	//                                                                   //
	///////////////////////////////////////////////////////////////////////
	                                                                     //
	                                                                     // 1
	///////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['meteorhacks:picker'] = {}, {
	  Picker: Picker
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/minimongo.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	var EJSON = Package.ejson.EJSON;
	var IdMap = Package['id-map'].IdMap;
	var OrderedDict = Package['ordered-dict'].OrderedDict;
	var Tracker = Package.tracker.Tracker;
	var Deps = Package.tracker.Deps;
	var MongoID = Package['mongo-id'].MongoID;
	var Random = Package.random.Random;
	var DiffSequence = Package['diff-sequence'].DiffSequence;
	var GeoJSON = Package['geojson-utils'].GeoJSON;
	
	/* Package-scope variables */
	var LocalCollection, Minimongo, MinimongoTest, MinimongoError, isArray, isPlainObject, isIndexable, isOperatorObject, isNumericKey, regexpElementMatcher, equalityElementMatcher, ELEMENT_OPERATORS, makeLookupFunction, expandArraysInBranches, projectionDetails, pathsToTree;
	
	(function(){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                              //
	// packages/minimongo/minimongo.js                                                                              //
	//                                                                                                              //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                //
	// XXX type checking on selectors (graceful error if malformed)                                                 // 1
	                                                                                                                // 2
	// LocalCollection: a set of documents that supports queries and modifiers.                                     // 3
	                                                                                                                // 4
	// Cursor: a specification for a particular subset of documents, w/                                             // 5
	// a defined order, limit, and offset.  creating a Cursor with LocalCollection.find(),                          // 6
	                                                                                                                // 7
	// ObserveHandle: the return value of a live query.                                                             // 8
	                                                                                                                // 9
	LocalCollection = function (name) {                                                                             // 10
	  var self = this;                                                                                              // 11
	  self.name = name;                                                                                             // 12
	  // _id -> document (also containing id)                                                                       // 13
	  self._docs = new LocalCollection._IdMap;                                                                      // 14
	                                                                                                                // 15
	  self._observeQueue = new Meteor._SynchronousQueue();                                                          // 16
	                                                                                                                // 17
	  self.next_qid = 1; // live query id generator                                                                 // 18
	                                                                                                                // 19
	  // qid -> live query object. keys:                                                                            // 20
	  //  ordered: bool. ordered queries have addedBefore/movedBefore callbacks.                                    // 21
	  //  results: array (ordered) or object (unordered) of current results                                         // 22
	  //    (aliased with self._docs!)                                                                              // 23
	  //  resultsSnapshot: snapshot of results. null if not paused.                                                 // 24
	  //  cursor: Cursor object for the query.                                                                      // 25
	  //  selector, sorter, (callbacks): functions                                                                  // 26
	  self.queries = {};                                                                                            // 27
	                                                                                                                // 28
	  // null if not saving originals; an IdMap from id to original document value if                               // 29
	  // saving originals. See comments before saveOriginals().                                                     // 30
	  self._savedOriginals = null;                                                                                  // 31
	                                                                                                                // 32
	  // True when observers are paused and we should not send callbacks.                                           // 33
	  self.paused = false;                                                                                          // 34
	};                                                                                                              // 35
	                                                                                                                // 36
	Minimongo = {};                                                                                                 // 37
	                                                                                                                // 38
	// Object exported only for unit testing.                                                                       // 39
	// Use it to export private functions to test in Tinytest.                                                      // 40
	MinimongoTest = {};                                                                                             // 41
	                                                                                                                // 42
	MinimongoError = function (message) {                                                                           // 43
	  var e = new Error(message);                                                                                   // 44
	  e.name = "MinimongoError";                                                                                    // 45
	  return e;                                                                                                     // 46
	};                                                                                                              // 47
	                                                                                                                // 48
	                                                                                                                // 49
	// options may include sort, skip, limit, reactive                                                              // 50
	// sort may be any of these forms:                                                                              // 51
	//     {a: 1, b: -1}                                                                                            // 52
	//     [["a", "asc"], ["b", "desc"]]                                                                            // 53
	//     ["a", ["b", "desc"]]                                                                                     // 54
	//   (in the first form you're beholden to key enumeration order in                                             // 55
	//   your javascript VM)                                                                                        // 56
	//                                                                                                              // 57
	// reactive: if given, and false, don't register with Tracker (default                                          // 58
	// is true)                                                                                                     // 59
	//                                                                                                              // 60
	// XXX possibly should support retrieving a subset of fields? and                                               // 61
	// have it be a hint (ignored on the client, when not copying the                                               // 62
	// doc?)                                                                                                        // 63
	//                                                                                                              // 64
	// XXX sort does not yet support subkeys ('a.b') .. fix that!                                                   // 65
	// XXX add one more sort form: "key"                                                                            // 66
	// XXX tests                                                                                                    // 67
	LocalCollection.prototype.find = function (selector, options) {                                                 // 68
	  // default syntax for everything is to omit the selector argument.                                            // 69
	  // but if selector is explicitly passed in as false or undefined, we                                          // 70
	  // want a selector that matches nothing.                                                                      // 71
	  if (arguments.length === 0)                                                                                   // 72
	    selector = {};                                                                                              // 73
	                                                                                                                // 74
	  return new LocalCollection.Cursor(this, selector, options);                                                   // 75
	};                                                                                                              // 76
	                                                                                                                // 77
	// don't call this ctor directly.  use LocalCollection.find().                                                  // 78
	                                                                                                                // 79
	LocalCollection.Cursor = function (collection, selector, options) {                                             // 80
	  var self = this;                                                                                              // 81
	  if (!options) options = {};                                                                                   // 82
	                                                                                                                // 83
	  self.collection = collection;                                                                                 // 84
	  self.sorter = null;                                                                                           // 85
	  self.matcher = new Minimongo.Matcher(selector);                                                               // 86
	                                                                                                                // 87
	  if (LocalCollection._selectorIsId(selector)) {                                                                // 88
	    // stash for fast path                                                                                      // 89
	    self._selectorId = selector;                                                                                // 90
	  } else if (LocalCollection._selectorIsIdPerhapsAsObject(selector)) {                                          // 91
	    // also do the fast path for { _id: idString }                                                              // 92
	    self._selectorId = selector._id;                                                                            // 93
	  } else {                                                                                                      // 94
	    self._selectorId = undefined;                                                                               // 95
	    if (self.matcher.hasGeoQuery() || options.sort) {                                                           // 96
	      self.sorter = new Minimongo.Sorter(options.sort || [],                                                    // 97
	                                         { matcher: self.matcher });                                            // 98
	    }                                                                                                           // 99
	  }                                                                                                             // 100
	                                                                                                                // 101
	  self.skip = options.skip;                                                                                     // 102
	  self.limit = options.limit;                                                                                   // 103
	  self.fields = options.fields;                                                                                 // 104
	                                                                                                                // 105
	  self._projectionFn = LocalCollection._compileProjection(self.fields || {});                                   // 106
	                                                                                                                // 107
	  self._transform = LocalCollection.wrapTransform(options.transform);                                           // 108
	                                                                                                                // 109
	  // by default, queries register w/ Tracker when it is available.                                              // 110
	  if (typeof Tracker !== "undefined")                                                                           // 111
	    self.reactive = (options.reactive === undefined) ? true : options.reactive;                                 // 112
	};                                                                                                              // 113
	                                                                                                                // 114
	// Since we don't actually have a "nextObject" interface, there's really no                                     // 115
	// reason to have a "rewind" interface.  All it did was make multiple calls                                     // 116
	// to fetch/map/forEach return nothing the second time.                                                         // 117
	// XXX COMPAT WITH 0.8.1                                                                                        // 118
	LocalCollection.Cursor.prototype.rewind = function () {                                                         // 119
	};                                                                                                              // 120
	                                                                                                                // 121
	LocalCollection.prototype.findOne = function (selector, options) {                                              // 122
	  if (arguments.length === 0)                                                                                   // 123
	    selector = {};                                                                                              // 124
	                                                                                                                // 125
	  // NOTE: by setting limit 1 here, we end up using very inefficient                                            // 126
	  // code that recomputes the whole query on each update. The upside is                                         // 127
	  // that when you reactively depend on a findOne you only get                                                  // 128
	  // invalidated when the found object changes, not any object in the                                           // 129
	  // collection. Most findOne will be by id, which has a fast path, so                                          // 130
	  // this might not be a big deal. In most cases, invalidation causes                                           // 131
	  // the called to re-query anyway, so this should be a net performance                                         // 132
	  // improvement.                                                                                               // 133
	  options = options || {};                                                                                      // 134
	  options.limit = 1;                                                                                            // 135
	                                                                                                                // 136
	  return this.find(selector, options).fetch()[0];                                                               // 137
	};                                                                                                              // 138
	                                                                                                                // 139
	/**                                                                                                             // 140
	 * @callback IterationCallback                                                                                  // 141
	 * @param {Object} doc                                                                                          // 142
	 * @param {Number} index                                                                                        // 143
	 */                                                                                                             // 144
	/**                                                                                                             // 145
	 * @summary Call `callback` once for each matching document, sequentially and synchronously.                    // 146
	 * @locus Anywhere                                                                                              // 147
	 * @method  forEach                                                                                             // 148
	 * @instance                                                                                                    // 149
	 * @memberOf Mongo.Cursor                                                                                       // 150
	 * @param {IterationCallback} callback Function to call. It will be called with three arguments: the document, a 0-based index, and <em>cursor</em> itself.
	 * @param {Any} [thisArg] An object which will be the value of `this` inside `callback`.                        // 152
	 */                                                                                                             // 153
	LocalCollection.Cursor.prototype.forEach = function (callback, thisArg) {                                       // 154
	  var self = this;                                                                                              // 155
	                                                                                                                // 156
	  var objects = self._getRawObjects({ordered: true});                                                           // 157
	                                                                                                                // 158
	  if (self.reactive) {                                                                                          // 159
	    self._depend({                                                                                              // 160
	      addedBefore: true,                                                                                        // 161
	      removed: true,                                                                                            // 162
	      changed: true,                                                                                            // 163
	      movedBefore: true});                                                                                      // 164
	  }                                                                                                             // 165
	                                                                                                                // 166
	  _.each(objects, function (elt, i) {                                                                           // 167
	    // This doubles as a clone operation.                                                                       // 168
	    elt = self._projectionFn(elt);                                                                              // 169
	                                                                                                                // 170
	    if (self._transform)                                                                                        // 171
	      elt = self._transform(elt);                                                                               // 172
	    callback.call(thisArg, elt, i, self);                                                                       // 173
	  });                                                                                                           // 174
	};                                                                                                              // 175
	                                                                                                                // 176
	LocalCollection.Cursor.prototype.getTransform = function () {                                                   // 177
	  return this._transform;                                                                                       // 178
	};                                                                                                              // 179
	                                                                                                                // 180
	/**                                                                                                             // 181
	 * @summary Map callback over all matching documents.  Returns an Array.                                        // 182
	 * @locus Anywhere                                                                                              // 183
	 * @method map                                                                                                  // 184
	 * @instance                                                                                                    // 185
	 * @memberOf Mongo.Cursor                                                                                       // 186
	 * @param {IterationCallback} callback Function to call. It will be called with three arguments: the document, a 0-based index, and <em>cursor</em> itself.
	 * @param {Any} [thisArg] An object which will be the value of `this` inside `callback`.                        // 188
	 */                                                                                                             // 189
	LocalCollection.Cursor.prototype.map = function (callback, thisArg) {                                           // 190
	  var self = this;                                                                                              // 191
	  var res = [];                                                                                                 // 192
	  self.forEach(function (doc, index) {                                                                          // 193
	    res.push(callback.call(thisArg, doc, index, self));                                                         // 194
	  });                                                                                                           // 195
	  return res;                                                                                                   // 196
	};                                                                                                              // 197
	                                                                                                                // 198
	/**                                                                                                             // 199
	 * @summary Return all matching documents as an Array.                                                          // 200
	 * @memberOf Mongo.Cursor                                                                                       // 201
	 * @method  fetch                                                                                               // 202
	 * @instance                                                                                                    // 203
	 * @locus Anywhere                                                                                              // 204
	 * @returns {Object[]}                                                                                          // 205
	 */                                                                                                             // 206
	LocalCollection.Cursor.prototype.fetch = function () {                                                          // 207
	  var self = this;                                                                                              // 208
	  var res = [];                                                                                                 // 209
	  self.forEach(function (doc) {                                                                                 // 210
	    res.push(doc);                                                                                              // 211
	  });                                                                                                           // 212
	  return res;                                                                                                   // 213
	};                                                                                                              // 214
	                                                                                                                // 215
	/**                                                                                                             // 216
	 * @summary Returns the number of documents that match a query.                                                 // 217
	 * @memberOf Mongo.Cursor                                                                                       // 218
	 * @method  count                                                                                               // 219
	 * @instance                                                                                                    // 220
	 * @locus Anywhere                                                                                              // 221
	 * @returns {Number}                                                                                            // 222
	 */                                                                                                             // 223
	LocalCollection.Cursor.prototype.count = function () {                                                          // 224
	  var self = this;                                                                                              // 225
	                                                                                                                // 226
	  if (self.reactive)                                                                                            // 227
	    self._depend({added: true, removed: true},                                                                  // 228
	                 true /* allow the observe to be unordered */);                                                 // 229
	                                                                                                                // 230
	  return self._getRawObjects({ordered: true}).length;                                                           // 231
	};                                                                                                              // 232
	                                                                                                                // 233
	LocalCollection.Cursor.prototype._publishCursor = function (sub) {                                              // 234
	  var self = this;                                                                                              // 235
	  if (! self.collection.name)                                                                                   // 236
	    throw new Error("Can't publish a cursor from a collection without a name.");                                // 237
	  var collection = self.collection.name;                                                                        // 238
	                                                                                                                // 239
	  // XXX minimongo should not depend on mongo-livedata!                                                         // 240
	  if (! Package.mongo) {                                                                                        // 241
	    throw new Error("Can't publish from Minimongo without the `mongo` package.");                               // 242
	  }                                                                                                             // 243
	                                                                                                                // 244
	  return Package.mongo.Mongo.Collection._publishCursor(self, sub, collection);                                  // 245
	};                                                                                                              // 246
	                                                                                                                // 247
	LocalCollection.Cursor.prototype._getCollectionName = function () {                                             // 248
	  var self = this;                                                                                              // 249
	  return self.collection.name;                                                                                  // 250
	};                                                                                                              // 251
	                                                                                                                // 252
	LocalCollection._observeChangesCallbacksAreOrdered = function (callbacks) {                                     // 253
	  if (callbacks.added && callbacks.addedBefore)                                                                 // 254
	    throw new Error("Please specify only one of added() and addedBefore()");                                    // 255
	  return !!(callbacks.addedBefore || callbacks.movedBefore);                                                    // 256
	};                                                                                                              // 257
	                                                                                                                // 258
	LocalCollection._observeCallbacksAreOrdered = function (callbacks) {                                            // 259
	  if (callbacks.addedAt && callbacks.added)                                                                     // 260
	    throw new Error("Please specify only one of added() and addedAt()");                                        // 261
	  if (callbacks.changedAt && callbacks.changed)                                                                 // 262
	    throw new Error("Please specify only one of changed() and changedAt()");                                    // 263
	  if (callbacks.removed && callbacks.removedAt)                                                                 // 264
	    throw new Error("Please specify only one of removed() and removedAt()");                                    // 265
	                                                                                                                // 266
	  return !!(callbacks.addedAt || callbacks.movedTo || callbacks.changedAt                                       // 267
	            || callbacks.removedAt);                                                                            // 268
	};                                                                                                              // 269
	                                                                                                                // 270
	// the handle that comes back from observe.                                                                     // 271
	LocalCollection.ObserveHandle = function () {};                                                                 // 272
	                                                                                                                // 273
	// options to contain:                                                                                          // 274
	//  * callbacks for observe():                                                                                  // 275
	//    - addedAt (document, atIndex)                                                                             // 276
	//    - added (document)                                                                                        // 277
	//    - changedAt (newDocument, oldDocument, atIndex)                                                           // 278
	//    - changed (newDocument, oldDocument)                                                                      // 279
	//    - removedAt (document, atIndex)                                                                           // 280
	//    - removed (document)                                                                                      // 281
	//    - movedTo (document, oldIndex, newIndex)                                                                  // 282
	//                                                                                                              // 283
	// attributes available on returned query handle:                                                               // 284
	//  * stop(): end updates                                                                                       // 285
	//  * collection: the collection this query is querying                                                         // 286
	//                                                                                                              // 287
	// iff x is a returned query handle, (x instanceof                                                              // 288
	// LocalCollection.ObserveHandle) is true                                                                       // 289
	//                                                                                                              // 290
	// initial results delivered through added callback                                                             // 291
	// XXX maybe callbacks should take a list of objects, to expose transactions?                                   // 292
	// XXX maybe support field limiting (to limit what you're notified on)                                          // 293
	                                                                                                                // 294
	_.extend(LocalCollection.Cursor.prototype, {                                                                    // 295
	  /**                                                                                                           // 296
	   * @summary Watch a query.  Receive callbacks as the result set changes.                                      // 297
	   * @locus Anywhere                                                                                            // 298
	   * @memberOf Mongo.Cursor                                                                                     // 299
	   * @instance                                                                                                  // 300
	   * @param {Object} callbacks Functions to call to deliver the result set as it changes                        // 301
	   */                                                                                                           // 302
	  observe: function (options) {                                                                                 // 303
	    var self = this;                                                                                            // 304
	    return LocalCollection._observeFromObserveChanges(self, options);                                           // 305
	  },                                                                                                            // 306
	                                                                                                                // 307
	  /**                                                                                                           // 308
	   * @summary Watch a query.  Receive callbacks as the result set changes.  Only the differences between the old and new documents are passed to the callbacks.
	   * @locus Anywhere                                                                                            // 310
	   * @memberOf Mongo.Cursor                                                                                     // 311
	   * @instance                                                                                                  // 312
	   * @param {Object} callbacks Functions to call to deliver the result set as it changes                        // 313
	   */                                                                                                           // 314
	  observeChanges: function (options) {                                                                          // 315
	    var self = this;                                                                                            // 316
	                                                                                                                // 317
	    var ordered = LocalCollection._observeChangesCallbacksAreOrdered(options);                                  // 318
	                                                                                                                // 319
	    // there are several places that assume you aren't combining skip/limit with                                // 320
	    // unordered observe.  eg, update's EJSON.clone, and the "there are several"                                // 321
	    // comment in _modifyAndNotify                                                                              // 322
	    // XXX allow skip/limit with unordered observe                                                              // 323
	    if (!options._allow_unordered && !ordered && (self.skip || self.limit))                                     // 324
	      throw new Error("must use ordered observe (ie, 'addedBefore' instead of 'added') with skip or limit");    // 325
	                                                                                                                // 326
	    if (self.fields && (self.fields._id === 0 || self.fields._id === false))                                    // 327
	      throw Error("You may not observe a cursor with {fields: {_id: 0}}");                                      // 328
	                                                                                                                // 329
	    var query = {                                                                                               // 330
	      dirty: false,                                                                                             // 331
	      matcher: self.matcher, // not fast pathed                                                                 // 332
	      sorter: ordered && self.sorter,                                                                           // 333
	      distances: (                                                                                              // 334
	        self.matcher.hasGeoQuery() && ordered && new LocalCollection._IdMap),                                   // 335
	      resultsSnapshot: null,                                                                                    // 336
	      ordered: ordered,                                                                                         // 337
	      cursor: self,                                                                                             // 338
	      projectionFn: self._projectionFn                                                                          // 339
	    };                                                                                                          // 340
	    var qid;                                                                                                    // 341
	                                                                                                                // 342
	    // Non-reactive queries call added[Before] and then never call anything                                     // 343
	    // else.                                                                                                    // 344
	    if (self.reactive) {                                                                                        // 345
	      qid = self.collection.next_qid++;                                                                         // 346
	      self.collection.queries[qid] = query;                                                                     // 347
	    }                                                                                                           // 348
	    query.results = self._getRawObjects({                                                                       // 349
	      ordered: ordered, distances: query.distances});                                                           // 350
	    if (self.collection.paused)                                                                                 // 351
	      query.resultsSnapshot = (ordered ? [] : new LocalCollection._IdMap);                                      // 352
	                                                                                                                // 353
	    // wrap callbacks we were passed. callbacks only fire when not paused and                                   // 354
	    // are never undefined                                                                                      // 355
	    // Filters out blacklisted fields according to cursor's projection.                                         // 356
	    // XXX wrong place for this?                                                                                // 357
	                                                                                                                // 358
	    // furthermore, callbacks enqueue until the operation we're working on is                                   // 359
	    // done.                                                                                                    // 360
	    var wrapCallback = function (f) {                                                                           // 361
	      if (!f)                                                                                                   // 362
	        return function () {};                                                                                  // 363
	      return function (/*args*/) {                                                                              // 364
	        var context = this;                                                                                     // 365
	        var args = arguments;                                                                                   // 366
	                                                                                                                // 367
	        if (self.collection.paused)                                                                             // 368
	          return;                                                                                               // 369
	                                                                                                                // 370
	        self.collection._observeQueue.queueTask(function () {                                                   // 371
	          f.apply(context, args);                                                                               // 372
	        });                                                                                                     // 373
	      };                                                                                                        // 374
	    };                                                                                                          // 375
	    query.added = wrapCallback(options.added);                                                                  // 376
	    query.changed = wrapCallback(options.changed);                                                              // 377
	    query.removed = wrapCallback(options.removed);                                                              // 378
	    if (ordered) {                                                                                              // 379
	      query.addedBefore = wrapCallback(options.addedBefore);                                                    // 380
	      query.movedBefore = wrapCallback(options.movedBefore);                                                    // 381
	    }                                                                                                           // 382
	                                                                                                                // 383
	    if (!options._suppress_initial && !self.collection.paused) {                                                // 384
	      // XXX unify ordered and unordered interface                                                              // 385
	      var each = ordered                                                                                        // 386
	            ? _.bind(_.each, null, query.results)                                                               // 387
	            : _.bind(query.results.forEach, query.results);                                                     // 388
	      each(function (doc) {                                                                                     // 389
	        var fields = EJSON.clone(doc);                                                                          // 390
	                                                                                                                // 391
	        delete fields._id;                                                                                      // 392
	        if (ordered)                                                                                            // 393
	          query.addedBefore(doc._id, self._projectionFn(fields), null);                                         // 394
	        query.added(doc._id, self._projectionFn(fields));                                                       // 395
	      });                                                                                                       // 396
	    }                                                                                                           // 397
	                                                                                                                // 398
	    var handle = new LocalCollection.ObserveHandle;                                                             // 399
	    _.extend(handle, {                                                                                          // 400
	      collection: self.collection,                                                                              // 401
	      stop: function () {                                                                                       // 402
	        if (self.reactive)                                                                                      // 403
	          delete self.collection.queries[qid];                                                                  // 404
	      }                                                                                                         // 405
	    });                                                                                                         // 406
	                                                                                                                // 407
	    if (self.reactive && Tracker.active) {                                                                      // 408
	      // XXX in many cases, the same observe will be recreated when                                             // 409
	      // the current autorun is rerun.  we could save work by                                                   // 410
	      // letting it linger across rerun and potentially get                                                     // 411
	      // repurposed if the same observe is performed, using logic                                               // 412
	      // similar to that of Meteor.subscribe.                                                                   // 413
	      Tracker.onInvalidate(function () {                                                                        // 414
	        handle.stop();                                                                                          // 415
	      });                                                                                                       // 416
	    }                                                                                                           // 417
	    // run the observe callbacks resulting from the initial contents                                            // 418
	    // before we leave the observe.                                                                             // 419
	    self.collection._observeQueue.drain();                                                                      // 420
	                                                                                                                // 421
	    return handle;                                                                                              // 422
	  }                                                                                                             // 423
	});                                                                                                             // 424
	                                                                                                                // 425
	// Returns a collection of matching objects, but doesn't deep copy them.                                        // 426
	//                                                                                                              // 427
	// If ordered is set, returns a sorted array, respecting sorter, skip, and limit                                // 428
	// properties of the query.  if sorter is falsey, no sort -- you get the natural                                // 429
	// order.                                                                                                       // 430
	//                                                                                                              // 431
	// If ordered is not set, returns an object mapping from ID to doc (sorter, skip                                // 432
	// and limit should not be set).                                                                                // 433
	//                                                                                                              // 434
	// If ordered is set and this cursor is a $near geoquery, then this function                                    // 435
	// will use an _IdMap to track each distance from the $near argument point in                                   // 436
	// order to use it as a sort key. If an _IdMap is passed in the 'distances'                                     // 437
	// argument, this function will clear it and use it for this purpose (otherwise                                 // 438
	// it will just create its own _IdMap). The observeChanges implementation uses                                  // 439
	// this to remember the distances after this function returns.                                                  // 440
	LocalCollection.Cursor.prototype._getRawObjects = function (options) {                                          // 441
	  var self = this;                                                                                              // 442
	  options = options || {};                                                                                      // 443
	                                                                                                                // 444
	  // XXX use OrderedDict instead of array, and make IdMap and OrderedDict                                       // 445
	  // compatible                                                                                                 // 446
	  var results = options.ordered ? [] : new LocalCollection._IdMap;                                              // 447
	                                                                                                                // 448
	  // fast path for single ID value                                                                              // 449
	  if (self._selectorId !== undefined) {                                                                         // 450
	    // If you have non-zero skip and ask for a single id, you get                                               // 451
	    // nothing. This is so it matches the behavior of the '{_id: foo}'                                          // 452
	    // path.                                                                                                    // 453
	    if (self.skip)                                                                                              // 454
	      return results;                                                                                           // 455
	                                                                                                                // 456
	    var selectedDoc = self.collection._docs.get(self._selectorId);                                              // 457
	    if (selectedDoc) {                                                                                          // 458
	      if (options.ordered)                                                                                      // 459
	        results.push(selectedDoc);                                                                              // 460
	      else                                                                                                      // 461
	        results.set(self._selectorId, selectedDoc);                                                             // 462
	    }                                                                                                           // 463
	    return results;                                                                                             // 464
	  }                                                                                                             // 465
	                                                                                                                // 466
	  // slow path for arbitrary selector, sort, skip, limit                                                        // 467
	                                                                                                                // 468
	  // in the observeChanges case, distances is actually part of the "query" (ie,                                 // 469
	  // live results set) object.  in other cases, distances is only used inside                                   // 470
	  // this function.                                                                                             // 471
	  var distances;                                                                                                // 472
	  if (self.matcher.hasGeoQuery() && options.ordered) {                                                          // 473
	    if (options.distances) {                                                                                    // 474
	      distances = options.distances;                                                                            // 475
	      distances.clear();                                                                                        // 476
	    } else {                                                                                                    // 477
	      distances = new LocalCollection._IdMap();                                                                 // 478
	    }                                                                                                           // 479
	  }                                                                                                             // 480
	                                                                                                                // 481
	  self.collection._docs.forEach(function (doc, id) {                                                            // 482
	    var matchResult = self.matcher.documentMatches(doc);                                                        // 483
	    if (matchResult.result) {                                                                                   // 484
	      if (options.ordered) {                                                                                    // 485
	        results.push(doc);                                                                                      // 486
	        if (distances && matchResult.distance !== undefined)                                                    // 487
	          distances.set(id, matchResult.distance);                                                              // 488
	      } else {                                                                                                  // 489
	        results.set(id, doc);                                                                                   // 490
	      }                                                                                                         // 491
	    }                                                                                                           // 492
	    // Fast path for limited unsorted queries.                                                                  // 493
	    // XXX 'length' check here seems wrong for ordered                                                          // 494
	    if (self.limit && !self.skip && !self.sorter &&                                                             // 495
	        results.length === self.limit)                                                                          // 496
	      return false;  // break                                                                                   // 497
	    return true;  // continue                                                                                   // 498
	  });                                                                                                           // 499
	                                                                                                                // 500
	  if (!options.ordered)                                                                                         // 501
	    return results;                                                                                             // 502
	                                                                                                                // 503
	  if (self.sorter) {                                                                                            // 504
	    var comparator = self.sorter.getComparator({distances: distances});                                         // 505
	    results.sort(comparator);                                                                                   // 506
	  }                                                                                                             // 507
	                                                                                                                // 508
	  var idx_start = self.skip || 0;                                                                               // 509
	  var idx_end = self.limit ? (self.limit + idx_start) : results.length;                                         // 510
	  return results.slice(idx_start, idx_end);                                                                     // 511
	};                                                                                                              // 512
	                                                                                                                // 513
	// XXX Maybe we need a version of observe that just calls a callback if                                         // 514
	// anything changed.                                                                                            // 515
	LocalCollection.Cursor.prototype._depend = function (changers, _allow_unordered) {                              // 516
	  var self = this;                                                                                              // 517
	                                                                                                                // 518
	  if (Tracker.active) {                                                                                         // 519
	    var v = new Tracker.Dependency;                                                                             // 520
	    v.depend();                                                                                                 // 521
	    var notifyChange = _.bind(v.changed, v);                                                                    // 522
	                                                                                                                // 523
	    var options = {                                                                                             // 524
	      _suppress_initial: true,                                                                                  // 525
	      _allow_unordered: _allow_unordered                                                                        // 526
	    };                                                                                                          // 527
	    _.each(['added', 'changed', 'removed', 'addedBefore', 'movedBefore'],                                       // 528
	           function (fnName) {                                                                                  // 529
	             if (changers[fnName])                                                                              // 530
	               options[fnName] = notifyChange;                                                                  // 531
	           });                                                                                                  // 532
	                                                                                                                // 533
	    // observeChanges will stop() when this computation is invalidated                                          // 534
	    self.observeChanges(options);                                                                               // 535
	  }                                                                                                             // 536
	};                                                                                                              // 537
	                                                                                                                // 538
	// XXX enforce rule that field names can't start with '$' or contain '.'                                        // 539
	// (real mongodb does in fact enforce this)                                                                     // 540
	// XXX possibly enforce that 'undefined' does not appear (we assume                                             // 541
	// this in our handling of null and $exists)                                                                    // 542
	LocalCollection.prototype.insert = function (doc, callback) {                                                   // 543
	  var self = this;                                                                                              // 544
	  doc = EJSON.clone(doc);                                                                                       // 545
	                                                                                                                // 546
	  if (!_.has(doc, '_id')) {                                                                                     // 547
	    // if you really want to use ObjectIDs, set this global.                                                    // 548
	    // Mongo.Collection specifies its own ids and does not use this code.                                       // 549
	    doc._id = LocalCollection._useOID ? new MongoID.ObjectID()                                                  // 550
	                                      : Random.id();                                                            // 551
	  }                                                                                                             // 552
	  var id = doc._id;                                                                                             // 553
	                                                                                                                // 554
	  if (self._docs.has(id))                                                                                       // 555
	    throw MinimongoError("Duplicate _id '" + id + "'");                                                         // 556
	                                                                                                                // 557
	  self._saveOriginal(id, undefined);                                                                            // 558
	  self._docs.set(id, doc);                                                                                      // 559
	                                                                                                                // 560
	  var queriesToRecompute = [];                                                                                  // 561
	  // trigger live queries that match                                                                            // 562
	  for (var qid in self.queries) {                                                                               // 563
	    var query = self.queries[qid];                                                                              // 564
	    if (query.dirty) continue;                                                                                  // 565
	    var matchResult = query.matcher.documentMatches(doc);                                                       // 566
	    if (matchResult.result) {                                                                                   // 567
	      if (query.distances && matchResult.distance !== undefined)                                                // 568
	        query.distances.set(id, matchResult.distance);                                                          // 569
	      if (query.cursor.skip || query.cursor.limit)                                                              // 570
	        queriesToRecompute.push(qid);                                                                           // 571
	      else                                                                                                      // 572
	        LocalCollection._insertInResults(query, doc);                                                           // 573
	    }                                                                                                           // 574
	  }                                                                                                             // 575
	                                                                                                                // 576
	  _.each(queriesToRecompute, function (qid) {                                                                   // 577
	    if (self.queries[qid])                                                                                      // 578
	      self._recomputeResults(self.queries[qid]);                                                                // 579
	  });                                                                                                           // 580
	  self._observeQueue.drain();                                                                                   // 581
	                                                                                                                // 582
	  // Defer because the caller likely doesn't expect the callback to be run                                      // 583
	  // immediately.                                                                                               // 584
	  if (callback)                                                                                                 // 585
	    Meteor.defer(function () {                                                                                  // 586
	      callback(null, id);                                                                                       // 587
	    });                                                                                                         // 588
	  return id;                                                                                                    // 589
	};                                                                                                              // 590
	                                                                                                                // 591
	// Iterates over a subset of documents that could match selector; calls                                         // 592
	// f(doc, id) on each of them.  Specifically, if selector specifies                                             // 593
	// specific _id's, it only looks at those.  doc is *not* cloned: it is the                                      // 594
	// same object that is in _docs.                                                                                // 595
	LocalCollection.prototype._eachPossiblyMatchingDoc = function (selector, f) {                                   // 596
	  var self = this;                                                                                              // 597
	  var specificIds = LocalCollection._idsMatchedBySelector(selector);                                            // 598
	  if (specificIds) {                                                                                            // 599
	    for (var i = 0; i < specificIds.length; ++i) {                                                              // 600
	      var id = specificIds[i];                                                                                  // 601
	      var doc = self._docs.get(id);                                                                             // 602
	      if (doc) {                                                                                                // 603
	        var breakIfFalse = f(doc, id);                                                                          // 604
	        if (breakIfFalse === false)                                                                             // 605
	          break;                                                                                                // 606
	      }                                                                                                         // 607
	    }                                                                                                           // 608
	  } else {                                                                                                      // 609
	    self._docs.forEach(f);                                                                                      // 610
	  }                                                                                                             // 611
	};                                                                                                              // 612
	                                                                                                                // 613
	LocalCollection.prototype.remove = function (selector, callback) {                                              // 614
	  var self = this;                                                                                              // 615
	                                                                                                                // 616
	  // Easy special case: if we're not calling observeChanges callbacks and we're                                 // 617
	  // not saving originals and we got asked to remove everything, then just empty                                // 618
	  // everything directly.                                                                                       // 619
	  if (self.paused && !self._savedOriginals && EJSON.equals(selector, {})) {                                     // 620
	    var result = self._docs.size();                                                                             // 621
	    self._docs.clear();                                                                                         // 622
	    _.each(self.queries, function (query) {                                                                     // 623
	      if (query.ordered) {                                                                                      // 624
	        query.results = [];                                                                                     // 625
	      } else {                                                                                                  // 626
	        query.results.clear();                                                                                  // 627
	      }                                                                                                         // 628
	    });                                                                                                         // 629
	    if (callback) {                                                                                             // 630
	      Meteor.defer(function () {                                                                                // 631
	        callback(null, result);                                                                                 // 632
	      });                                                                                                       // 633
	    }                                                                                                           // 634
	    return result;                                                                                              // 635
	  }                                                                                                             // 636
	                                                                                                                // 637
	  var matcher = new Minimongo.Matcher(selector);                                                                // 638
	  var remove = [];                                                                                              // 639
	  self._eachPossiblyMatchingDoc(selector, function (doc, id) {                                                  // 640
	    if (matcher.documentMatches(doc).result)                                                                    // 641
	      remove.push(id);                                                                                          // 642
	  });                                                                                                           // 643
	                                                                                                                // 644
	  var queriesToRecompute = [];                                                                                  // 645
	  var queryRemove = [];                                                                                         // 646
	  for (var i = 0; i < remove.length; i++) {                                                                     // 647
	    var removeId = remove[i];                                                                                   // 648
	    var removeDoc = self._docs.get(removeId);                                                                   // 649
	    _.each(self.queries, function (query, qid) {                                                                // 650
	      if (query.dirty) return;                                                                                  // 651
	                                                                                                                // 652
	      if (query.matcher.documentMatches(removeDoc).result) {                                                    // 653
	        if (query.cursor.skip || query.cursor.limit)                                                            // 654
	          queriesToRecompute.push(qid);                                                                         // 655
	        else                                                                                                    // 656
	          queryRemove.push({qid: qid, doc: removeDoc});                                                         // 657
	      }                                                                                                         // 658
	    });                                                                                                         // 659
	    self._saveOriginal(removeId, removeDoc);                                                                    // 660
	    self._docs.remove(removeId);                                                                                // 661
	  }                                                                                                             // 662
	                                                                                                                // 663
	  // run live query callbacks _after_ we've removed the documents.                                              // 664
	  _.each(queryRemove, function (remove) {                                                                       // 665
	    var query = self.queries[remove.qid];                                                                       // 666
	    if (query) {                                                                                                // 667
	      query.distances && query.distances.remove(remove.doc._id);                                                // 668
	      LocalCollection._removeFromResults(query, remove.doc);                                                    // 669
	    }                                                                                                           // 670
	  });                                                                                                           // 671
	  _.each(queriesToRecompute, function (qid) {                                                                   // 672
	    var query = self.queries[qid];                                                                              // 673
	    if (query)                                                                                                  // 674
	      self._recomputeResults(query);                                                                            // 675
	  });                                                                                                           // 676
	  self._observeQueue.drain();                                                                                   // 677
	  result = remove.length;                                                                                       // 678
	  if (callback)                                                                                                 // 679
	    Meteor.defer(function () {                                                                                  // 680
	      callback(null, result);                                                                                   // 681
	    });                                                                                                         // 682
	  return result;                                                                                                // 683
	};                                                                                                              // 684
	                                                                                                                // 685
	// XXX atomicity: if multi is true, and one modification fails, do                                              // 686
	// we rollback the whole operation, or what?                                                                    // 687
	LocalCollection.prototype.update = function (selector, mod, options, callback) {                                // 688
	  var self = this;                                                                                              // 689
	  if (! callback && options instanceof Function) {                                                              // 690
	    callback = options;                                                                                         // 691
	    options = null;                                                                                             // 692
	  }                                                                                                             // 693
	  if (!options) options = {};                                                                                   // 694
	                                                                                                                // 695
	  var matcher = new Minimongo.Matcher(selector);                                                                // 696
	                                                                                                                // 697
	  // Save the original results of any query that we might need to                                               // 698
	  // _recomputeResults on, because _modifyAndNotify will mutate the objects in                                  // 699
	  // it. (We don't need to save the original results of paused queries because                                  // 700
	  // they already have a resultsSnapshot and we won't be diffing in                                             // 701
	  // _recomputeResults.)                                                                                        // 702
	  var qidToOriginalResults = {};                                                                                // 703
	  // We should only clone each document once, even if it appears in multiple queries                            // 704
	  var docMap = new LocalCollection._IdMap;                                                                      // 705
	  var idsMatchedBySelector = LocalCollection._idsMatchedBySelector(selector);                                   // 706
	                                                                                                                // 707
	  _.each(self.queries, function (query, qid) {                                                                  // 708
	    if ((query.cursor.skip || query.cursor.limit) && ! self.paused) {                                           // 709
	      // Catch the case of a reactive `count()` on a cursor with skip                                           // 710
	      // or limit, which registers an unordered observe. This is a                                              // 711
	      // pretty rare case, so we just clone the entire result set with                                          // 712
	      // no optimizations for documents that appear in these result                                             // 713
	      // sets and other queries.                                                                                // 714
	      if (query.results instanceof LocalCollection._IdMap) {                                                    // 715
	        qidToOriginalResults[qid] = query.results.clone();                                                      // 716
	        return;                                                                                                 // 717
	      }                                                                                                         // 718
	                                                                                                                // 719
	      if (!(query.results instanceof Array)) {                                                                  // 720
	        throw new Error("Assertion failed: query.results not an array");                                        // 721
	      }                                                                                                         // 722
	                                                                                                                // 723
	      // Clones a document to be stored in `qidToOriginalResults`                                               // 724
	      // because it may be modified before the new and old result sets                                          // 725
	      // are diffed. But if we know exactly which document IDs we're                                            // 726
	      // going to modify, then we only need to clone those.                                                     // 727
	      var memoizedCloneIfNeeded = function(doc) {                                                               // 728
	        if (docMap.has(doc._id)) {                                                                              // 729
	          return docMap.get(doc._id);                                                                           // 730
	        } else {                                                                                                // 731
	          var docToMemoize;                                                                                     // 732
	                                                                                                                // 733
	          if (idsMatchedBySelector && !_.any(idsMatchedBySelector, function(id) {                               // 734
	            return EJSON.equals(id, doc._id);                                                                   // 735
	          })) {                                                                                                 // 736
	            docToMemoize = doc;                                                                                 // 737
	          } else {                                                                                              // 738
	            docToMemoize = EJSON.clone(doc);                                                                    // 739
	          }                                                                                                     // 740
	                                                                                                                // 741
	          docMap.set(doc._id, docToMemoize);                                                                    // 742
	          return docToMemoize;                                                                                  // 743
	        }                                                                                                       // 744
	      };                                                                                                        // 745
	                                                                                                                // 746
	      qidToOriginalResults[qid] = query.results.map(memoizedCloneIfNeeded);                                     // 747
	    }                                                                                                           // 748
	  });                                                                                                           // 749
	  var recomputeQids = {};                                                                                       // 750
	                                                                                                                // 751
	  var updateCount = 0;                                                                                          // 752
	                                                                                                                // 753
	  self._eachPossiblyMatchingDoc(selector, function (doc, id) {                                                  // 754
	    var queryResult = matcher.documentMatches(doc);                                                             // 755
	    if (queryResult.result) {                                                                                   // 756
	      // XXX Should we save the original even if mod ends up being a no-op?                                     // 757
	      self._saveOriginal(id, doc);                                                                              // 758
	      self._modifyAndNotify(doc, mod, recomputeQids, queryResult.arrayIndices);                                 // 759
	      ++updateCount;                                                                                            // 760
	      if (!options.multi)                                                                                       // 761
	        return false;  // break                                                                                 // 762
	    }                                                                                                           // 763
	    return true;                                                                                                // 764
	  });                                                                                                           // 765
	                                                                                                                // 766
	  _.each(recomputeQids, function (dummy, qid) {                                                                 // 767
	    var query = self.queries[qid];                                                                              // 768
	    if (query)                                                                                                  // 769
	      self._recomputeResults(query, qidToOriginalResults[qid]);                                                 // 770
	  });                                                                                                           // 771
	  self._observeQueue.drain();                                                                                   // 772
	                                                                                                                // 773
	  // If we are doing an upsert, and we didn't modify any documents yet, then                                    // 774
	  // it's time to do an insert. Figure out what document we are inserting, and                                  // 775
	  // generate an id for it.                                                                                     // 776
	  var insertedId;                                                                                               // 777
	  if (updateCount === 0 && options.upsert) {                                                                    // 778
	    var newDoc = LocalCollection._removeDollarOperators(selector);                                              // 779
	    LocalCollection._modify(newDoc, mod, {isInsert: true});                                                     // 780
	    if (! newDoc._id && options.insertedId)                                                                     // 781
	      newDoc._id = options.insertedId;                                                                          // 782
	    insertedId = self.insert(newDoc);                                                                           // 783
	    updateCount = 1;                                                                                            // 784
	  }                                                                                                             // 785
	                                                                                                                // 786
	  // Return the number of affected documents, or in the upsert case, an object                                  // 787
	  // containing the number of affected docs and the id of the doc that was                                      // 788
	  // inserted, if any.                                                                                          // 789
	  var result;                                                                                                   // 790
	  if (options._returnObject) {                                                                                  // 791
	    result = {                                                                                                  // 792
	      numberAffected: updateCount                                                                               // 793
	    };                                                                                                          // 794
	    if (insertedId !== undefined)                                                                               // 795
	      result.insertedId = insertedId;                                                                           // 796
	  } else {                                                                                                      // 797
	    result = updateCount;                                                                                       // 798
	  }                                                                                                             // 799
	                                                                                                                // 800
	  if (callback)                                                                                                 // 801
	    Meteor.defer(function () {                                                                                  // 802
	      callback(null, result);                                                                                   // 803
	    });                                                                                                         // 804
	  return result;                                                                                                // 805
	};                                                                                                              // 806
	                                                                                                                // 807
	// A convenience wrapper on update. LocalCollection.upsert(sel, mod) is                                         // 808
	// equivalent to LocalCollection.update(sel, mod, { upsert: true, _returnObject:                                // 809
	// true }).                                                                                                     // 810
	LocalCollection.prototype.upsert = function (selector, mod, options, callback) {                                // 811
	  var self = this;                                                                                              // 812
	  if (! callback && typeof options === "function") {                                                            // 813
	    callback = options;                                                                                         // 814
	    options = {};                                                                                               // 815
	  }                                                                                                             // 816
	  return self.update(selector, mod, _.extend({}, options, {                                                     // 817
	    upsert: true,                                                                                               // 818
	    _returnObject: true                                                                                         // 819
	  }), callback);                                                                                                // 820
	};                                                                                                              // 821
	                                                                                                                // 822
	LocalCollection.prototype._modifyAndNotify = function (                                                         // 823
	    doc, mod, recomputeQids, arrayIndices) {                                                                    // 824
	  var self = this;                                                                                              // 825
	                                                                                                                // 826
	  var matched_before = {};                                                                                      // 827
	  for (var qid in self.queries) {                                                                               // 828
	    var query = self.queries[qid];                                                                              // 829
	    if (query.dirty) continue;                                                                                  // 830
	                                                                                                                // 831
	    if (query.ordered) {                                                                                        // 832
	      matched_before[qid] = query.matcher.documentMatches(doc).result;                                          // 833
	    } else {                                                                                                    // 834
	      // Because we don't support skip or limit (yet) in unordered queries, we                                  // 835
	      // can just do a direct lookup.                                                                           // 836
	      matched_before[qid] = query.results.has(doc._id);                                                         // 837
	    }                                                                                                           // 838
	  }                                                                                                             // 839
	                                                                                                                // 840
	  var old_doc = EJSON.clone(doc);                                                                               // 841
	                                                                                                                // 842
	  LocalCollection._modify(doc, mod, {arrayIndices: arrayIndices});                                              // 843
	                                                                                                                // 844
	  for (qid in self.queries) {                                                                                   // 845
	    query = self.queries[qid];                                                                                  // 846
	    if (query.dirty) continue;                                                                                  // 847
	                                                                                                                // 848
	    var before = matched_before[qid];                                                                           // 849
	    var afterMatch = query.matcher.documentMatches(doc);                                                        // 850
	    var after = afterMatch.result;                                                                              // 851
	    if (after && query.distances && afterMatch.distance !== undefined)                                          // 852
	      query.distances.set(doc._id, afterMatch.distance);                                                        // 853
	                                                                                                                // 854
	    if (query.cursor.skip || query.cursor.limit) {                                                              // 855
	      // We need to recompute any query where the doc may have been in the                                      // 856
	      // cursor's window either before or after the update. (Note that if skip                                  // 857
	      // or limit is set, "before" and "after" being true do not necessarily                                    // 858
	      // mean that the document is in the cursor's output after skip/limit is                                   // 859
	      // applied... but if they are false, then the document definitely is NOT                                  // 860
	      // in the output. So it's safe to skip recompute if neither before or                                     // 861
	      // after are true.)                                                                                       // 862
	      if (before || after)                                                                                      // 863
	        recomputeQids[qid] = true;                                                                              // 864
	    } else if (before && !after) {                                                                              // 865
	      LocalCollection._removeFromResults(query, doc);                                                           // 866
	    } else if (!before && after) {                                                                              // 867
	      LocalCollection._insertInResults(query, doc);                                                             // 868
	    } else if (before && after) {                                                                               // 869
	      LocalCollection._updateInResults(query, doc, old_doc);                                                    // 870
	    }                                                                                                           // 871
	  }                                                                                                             // 872
	};                                                                                                              // 873
	                                                                                                                // 874
	// XXX the sorted-query logic below is laughably inefficient. we'll                                             // 875
	// need to come up with a better datastructure for this.                                                        // 876
	//                                                                                                              // 877
	// XXX the logic for observing with a skip or a limit is even more                                              // 878
	// laughably inefficient. we recompute the whole results every time!                                            // 879
	                                                                                                                // 880
	LocalCollection._insertInResults = function (query, doc) {                                                      // 881
	  var fields = EJSON.clone(doc);                                                                                // 882
	  delete fields._id;                                                                                            // 883
	  if (query.ordered) {                                                                                          // 884
	    if (!query.sorter) {                                                                                        // 885
	      query.addedBefore(doc._id, query.projectionFn(fields), null);                                             // 886
	      query.results.push(doc);                                                                                  // 887
	    } else {                                                                                                    // 888
	      var i = LocalCollection._insertInSortedList(                                                              // 889
	        query.sorter.getComparator({distances: query.distances}),                                               // 890
	        query.results, doc);                                                                                    // 891
	      var next = query.results[i+1];                                                                            // 892
	      if (next)                                                                                                 // 893
	        next = next._id;                                                                                        // 894
	      else                                                                                                      // 895
	        next = null;                                                                                            // 896
	      query.addedBefore(doc._id, query.projectionFn(fields), next);                                             // 897
	    }                                                                                                           // 898
	    query.added(doc._id, query.projectionFn(fields));                                                           // 899
	  } else {                                                                                                      // 900
	    query.added(doc._id, query.projectionFn(fields));                                                           // 901
	    query.results.set(doc._id, doc);                                                                            // 902
	  }                                                                                                             // 903
	};                                                                                                              // 904
	                                                                                                                // 905
	LocalCollection._removeFromResults = function (query, doc) {                                                    // 906
	  if (query.ordered) {                                                                                          // 907
	    var i = LocalCollection._findInOrderedResults(query, doc);                                                  // 908
	    query.removed(doc._id);                                                                                     // 909
	    query.results.splice(i, 1);                                                                                 // 910
	  } else {                                                                                                      // 911
	    var id = doc._id;  // in case callback mutates doc                                                          // 912
	    query.removed(doc._id);                                                                                     // 913
	    query.results.remove(id);                                                                                   // 914
	  }                                                                                                             // 915
	};                                                                                                              // 916
	                                                                                                                // 917
	LocalCollection._updateInResults = function (query, doc, old_doc) {                                             // 918
	  if (!EJSON.equals(doc._id, old_doc._id))                                                                      // 919
	    throw new Error("Can't change a doc's _id while updating");                                                 // 920
	  var projectionFn = query.projectionFn;                                                                        // 921
	  var changedFields = DiffSequence.makeChangedFields(                                                           // 922
	    projectionFn(doc), projectionFn(old_doc));                                                                  // 923
	                                                                                                                // 924
	  if (!query.ordered) {                                                                                         // 925
	    if (!_.isEmpty(changedFields)) {                                                                            // 926
	      query.changed(doc._id, changedFields);                                                                    // 927
	      query.results.set(doc._id, doc);                                                                          // 928
	    }                                                                                                           // 929
	    return;                                                                                                     // 930
	  }                                                                                                             // 931
	                                                                                                                // 932
	  var orig_idx = LocalCollection._findInOrderedResults(query, doc);                                             // 933
	                                                                                                                // 934
	  if (!_.isEmpty(changedFields))                                                                                // 935
	    query.changed(doc._id, changedFields);                                                                      // 936
	  if (!query.sorter)                                                                                            // 937
	    return;                                                                                                     // 938
	                                                                                                                // 939
	  // just take it out and put it back in again, and see if the index                                            // 940
	  // changes                                                                                                    // 941
	  query.results.splice(orig_idx, 1);                                                                            // 942
	  var new_idx = LocalCollection._insertInSortedList(                                                            // 943
	    query.sorter.getComparator({distances: query.distances}),                                                   // 944
	    query.results, doc);                                                                                        // 945
	  if (orig_idx !== new_idx) {                                                                                   // 946
	    var next = query.results[new_idx+1];                                                                        // 947
	    if (next)                                                                                                   // 948
	      next = next._id;                                                                                          // 949
	    else                                                                                                        // 950
	      next = null;                                                                                              // 951
	    query.movedBefore && query.movedBefore(doc._id, next);                                                      // 952
	  }                                                                                                             // 953
	};                                                                                                              // 954
	                                                                                                                // 955
	// Recomputes the results of a query and runs observe callbacks for the                                         // 956
	// difference between the previous results and the current results (unless                                      // 957
	// paused). Used for skip/limit queries.                                                                        // 958
	//                                                                                                              // 959
	// When this is used by insert or remove, it can just use query.results for the                                 // 960
	// old results (and there's no need to pass in oldResults), because these                                       // 961
	// operations don't mutate the documents in the collection. Update needs to pass                                // 962
	// in an oldResults which was deep-copied before the modifier was applied.                                      // 963
	//                                                                                                              // 964
	// oldResults is guaranteed to be ignored if the query is not paused.                                           // 965
	LocalCollection.prototype._recomputeResults = function (query, oldResults) {                                    // 966
	  var self = this;                                                                                              // 967
	  if (self.paused) {                                                                                            // 968
	    // There's no reason to recompute the results now as we're still paused.                                    // 969
	    // By flagging the query as "dirty", the recompute will be performed                                        // 970
	    // when resumeObservers is called.                                                                          // 971
	    query.dirty = true;                                                                                         // 972
	    return;                                                                                                     // 973
	  }                                                                                                             // 974
	                                                                                                                // 975
	  if (! self.paused && ! oldResults)                                                                            // 976
	    oldResults = query.results;                                                                                 // 977
	  if (query.distances)                                                                                          // 978
	    query.distances.clear();                                                                                    // 979
	  query.results = query.cursor._getRawObjects({                                                                 // 980
	    ordered: query.ordered, distances: query.distances});                                                       // 981
	                                                                                                                // 982
	  if (! self.paused) {                                                                                          // 983
	    LocalCollection._diffQueryChanges(                                                                          // 984
	      query.ordered, oldResults, query.results, query,                                                          // 985
	      { projectionFn: query.projectionFn });                                                                    // 986
	  }                                                                                                             // 987
	};                                                                                                              // 988
	                                                                                                                // 989
	                                                                                                                // 990
	LocalCollection._findInOrderedResults = function (query, doc) {                                                 // 991
	  if (!query.ordered)                                                                                           // 992
	    throw new Error("Can't call _findInOrderedResults on unordered query");                                     // 993
	  for (var i = 0; i < query.results.length; i++)                                                                // 994
	    if (query.results[i] === doc)                                                                               // 995
	      return i;                                                                                                 // 996
	  throw Error("object missing from query");                                                                     // 997
	};                                                                                                              // 998
	                                                                                                                // 999
	// This binary search puts a value between any equal values, and the first                                      // 1000
	// lesser value.                                                                                                // 1001
	LocalCollection._binarySearch = function (cmp, array, value) {                                                  // 1002
	  var first = 0, rangeLength = array.length;                                                                    // 1003
	                                                                                                                // 1004
	  while (rangeLength > 0) {                                                                                     // 1005
	    var halfRange = Math.floor(rangeLength/2);                                                                  // 1006
	    if (cmp(value, array[first + halfRange]) >= 0) {                                                            // 1007
	      first += halfRange + 1;                                                                                   // 1008
	      rangeLength -= halfRange + 1;                                                                             // 1009
	    } else {                                                                                                    // 1010
	      rangeLength = halfRange;                                                                                  // 1011
	    }                                                                                                           // 1012
	  }                                                                                                             // 1013
	  return first;                                                                                                 // 1014
	};                                                                                                              // 1015
	                                                                                                                // 1016
	LocalCollection._insertInSortedList = function (cmp, array, value) {                                            // 1017
	  if (array.length === 0) {                                                                                     // 1018
	    array.push(value);                                                                                          // 1019
	    return 0;                                                                                                   // 1020
	  }                                                                                                             // 1021
	                                                                                                                // 1022
	  var idx = LocalCollection._binarySearch(cmp, array, value);                                                   // 1023
	  array.splice(idx, 0, value);                                                                                  // 1024
	  return idx;                                                                                                   // 1025
	};                                                                                                              // 1026
	                                                                                                                // 1027
	// To track what documents are affected by a piece of code, call saveOriginals()                                // 1028
	// before it and retrieveOriginals() after it. retrieveOriginals returns an                                     // 1029
	// object whose keys are the ids of the documents that were affected since the                                  // 1030
	// call to saveOriginals(), and the values are equal to the document's contents                                 // 1031
	// at the time of saveOriginals. (In the case of an inserted document, undefined                                // 1032
	// is the value.) You must alternate between calls to saveOriginals() and                                       // 1033
	// retrieveOriginals().                                                                                         // 1034
	LocalCollection.prototype.saveOriginals = function () {                                                         // 1035
	  var self = this;                                                                                              // 1036
	  if (self._savedOriginals)                                                                                     // 1037
	    throw new Error("Called saveOriginals twice without retrieveOriginals");                                    // 1038
	  self._savedOriginals = new LocalCollection._IdMap;                                                            // 1039
	};                                                                                                              // 1040
	LocalCollection.prototype.retrieveOriginals = function () {                                                     // 1041
	  var self = this;                                                                                              // 1042
	  if (!self._savedOriginals)                                                                                    // 1043
	    throw new Error("Called retrieveOriginals without saveOriginals");                                          // 1044
	                                                                                                                // 1045
	  var originals = self._savedOriginals;                                                                         // 1046
	  self._savedOriginals = null;                                                                                  // 1047
	  return originals;                                                                                             // 1048
	};                                                                                                              // 1049
	                                                                                                                // 1050
	LocalCollection.prototype._saveOriginal = function (id, doc) {                                                  // 1051
	  var self = this;                                                                                              // 1052
	  // Are we even trying to save originals?                                                                      // 1053
	  if (!self._savedOriginals)                                                                                    // 1054
	    return;                                                                                                     // 1055
	  // Have we previously mutated the original (and so 'doc' is not actually                                      // 1056
	  // original)?  (Note the 'has' check rather than truth: we store undefined                                    // 1057
	  // here for inserted docs!)                                                                                   // 1058
	  if (self._savedOriginals.has(id))                                                                             // 1059
	    return;                                                                                                     // 1060
	  self._savedOriginals.set(id, EJSON.clone(doc));                                                               // 1061
	};                                                                                                              // 1062
	                                                                                                                // 1063
	// Pause the observers. No callbacks from observers will fire until                                             // 1064
	// 'resumeObservers' is called.                                                                                 // 1065
	LocalCollection.prototype.pauseObservers = function () {                                                        // 1066
	  // No-op if already paused.                                                                                   // 1067
	  if (this.paused)                                                                                              // 1068
	    return;                                                                                                     // 1069
	                                                                                                                // 1070
	  // Set the 'paused' flag such that new observer messages don't fire.                                          // 1071
	  this.paused = true;                                                                                           // 1072
	                                                                                                                // 1073
	  // Take a snapshot of the query results for each query.                                                       // 1074
	  for (var qid in this.queries) {                                                                               // 1075
	    var query = this.queries[qid];                                                                              // 1076
	                                                                                                                // 1077
	    query.resultsSnapshot = EJSON.clone(query.results);                                                         // 1078
	  }                                                                                                             // 1079
	};                                                                                                              // 1080
	                                                                                                                // 1081
	// Resume the observers. Observers immediately receive change                                                   // 1082
	// notifications to bring them to the current state of the                                                      // 1083
	// database. Note that this is not just replaying all the changes that                                          // 1084
	// happened during the pause, it is a smarter 'coalesced' diff.                                                 // 1085
	LocalCollection.prototype.resumeObservers = function () {                                                       // 1086
	  var self = this;                                                                                              // 1087
	  // No-op if not paused.                                                                                       // 1088
	  if (!this.paused)                                                                                             // 1089
	    return;                                                                                                     // 1090
	                                                                                                                // 1091
	  // Unset the 'paused' flag. Make sure to do this first, otherwise                                             // 1092
	  // observer methods won't actually fire when we trigger them.                                                 // 1093
	  this.paused = false;                                                                                          // 1094
	                                                                                                                // 1095
	  for (var qid in this.queries) {                                                                               // 1096
	    var query = self.queries[qid];                                                                              // 1097
	    if (query.dirty) {                                                                                          // 1098
	      query.dirty = false;                                                                                      // 1099
	      // re-compute results will perform `LocalCollection._diffQueryChanges` automatically.                     // 1100
	      self._recomputeResults(query, query.resultsSnapshot);                                                     // 1101
	    } else {                                                                                                    // 1102
	      // Diff the current results against the snapshot and send to observers.                                   // 1103
	      // pass the query object for its observer callbacks.                                                      // 1104
	      LocalCollection._diffQueryChanges(                                                                        // 1105
	        query.ordered, query.resultsSnapshot, query.results, query,                                             // 1106
	        {projectionFn: query.projectionFn});                                                                    // 1107
	    }                                                                                                           // 1108
	    query.resultsSnapshot = null;                                                                               // 1109
	  }                                                                                                             // 1110
	  self._observeQueue.drain();                                                                                   // 1111
	};                                                                                                              // 1112
	                                                                                                                // 1113
	                                                                                                                // 1114
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                              //
	// packages/minimongo/wrap_transform.js                                                                         //
	//                                                                                                              //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                //
	// Wrap a transform function to return objects that have the _id field                                          // 1
	// of the untransformed document. This ensures that subsystems such as                                          // 2
	// the observe-sequence package that call `observe` can keep track of                                           // 3
	// the documents identities.                                                                                    // 4
	//                                                                                                              // 5
	// - Require that it returns objects                                                                            // 6
	// - If the return value has an _id field, verify that it matches the                                           // 7
	//   original _id field                                                                                         // 8
	// - If the return value doesn't have an _id field, add it back.                                                // 9
	LocalCollection.wrapTransform = function (transform) {                                                          // 10
	  if (! transform)                                                                                              // 11
	    return null;                                                                                                // 12
	                                                                                                                // 13
	  // No need to doubly-wrap transforms.                                                                         // 14
	  if (transform.__wrappedTransform__)                                                                           // 15
	    return transform;                                                                                           // 16
	                                                                                                                // 17
	  var wrapped = function (doc) {                                                                                // 18
	    if (!_.has(doc, '_id')) {                                                                                   // 19
	      // XXX do we ever have a transform on the oplog's collection? because that                                // 20
	      // collection has no _id.                                                                                 // 21
	      throw new Error("can only transform documents with _id");                                                 // 22
	    }                                                                                                           // 23
	                                                                                                                // 24
	    var id = doc._id;                                                                                           // 25
	    // XXX consider making tracker a weak dependency and checking Package.tracker here                          // 26
	    var transformed = Tracker.nonreactive(function () {                                                         // 27
	      return transform(doc);                                                                                    // 28
	    });                                                                                                         // 29
	                                                                                                                // 30
	    if (!isPlainObject(transformed)) {                                                                          // 31
	      throw new Error("transform must return object");                                                          // 32
	    }                                                                                                           // 33
	                                                                                                                // 34
	    if (_.has(transformed, '_id')) {                                                                            // 35
	      if (!EJSON.equals(transformed._id, id)) {                                                                 // 36
	        throw new Error("transformed document can't have different _id");                                       // 37
	      }                                                                                                         // 38
	    } else {                                                                                                    // 39
	      transformed._id = id;                                                                                     // 40
	    }                                                                                                           // 41
	    return transformed;                                                                                         // 42
	  };                                                                                                            // 43
	  wrapped.__wrappedTransform__ = true;                                                                          // 44
	  return wrapped;                                                                                               // 45
	};                                                                                                              // 46
	                                                                                                                // 47
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                              //
	// packages/minimongo/helpers.js                                                                                //
	//                                                                                                              //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                //
	// Like _.isArray, but doesn't regard polyfilled Uint8Arrays on old browsers as                                 // 1
	// arrays.                                                                                                      // 2
	// XXX maybe this should be EJSON.isArray                                                                       // 3
	isArray = function (x) {                                                                                        // 4
	  return _.isArray(x) && !EJSON.isBinary(x);                                                                    // 5
	};                                                                                                              // 6
	                                                                                                                // 7
	// XXX maybe this should be EJSON.isObject, though EJSON doesn't know about                                     // 8
	// RegExp                                                                                                       // 9
	// XXX note that _type(undefined) === 3!!!!                                                                     // 10
	isPlainObject = LocalCollection._isPlainObject = function (x) {                                                 // 11
	  return x && LocalCollection._f._type(x) === 3;                                                                // 12
	};                                                                                                              // 13
	                                                                                                                // 14
	isIndexable = function (x) {                                                                                    // 15
	  return isArray(x) || isPlainObject(x);                                                                        // 16
	};                                                                                                              // 17
	                                                                                                                // 18
	// Returns true if this is an object with at least one key and all keys begin                                   // 19
	// with $.  Unless inconsistentOK is set, throws if some keys begin with $ and                                  // 20
	// others don't.                                                                                                // 21
	isOperatorObject = function (valueSelector, inconsistentOK) {                                                   // 22
	  if (!isPlainObject(valueSelector))                                                                            // 23
	    return false;                                                                                               // 24
	                                                                                                                // 25
	  var theseAreOperators = undefined;                                                                            // 26
	  _.each(valueSelector, function (value, selKey) {                                                              // 27
	    var thisIsOperator = selKey.substr(0, 1) === '$';                                                           // 28
	    if (theseAreOperators === undefined) {                                                                      // 29
	      theseAreOperators = thisIsOperator;                                                                       // 30
	    } else if (theseAreOperators !== thisIsOperator) {                                                          // 31
	      if (!inconsistentOK)                                                                                      // 32
	        throw new Error("Inconsistent operator: " +                                                             // 33
	                        JSON.stringify(valueSelector));                                                         // 34
	      theseAreOperators = false;                                                                                // 35
	    }                                                                                                           // 36
	  });                                                                                                           // 37
	  return !!theseAreOperators;  // {} has no operators                                                           // 38
	};                                                                                                              // 39
	                                                                                                                // 40
	                                                                                                                // 41
	// string can be converted to integer                                                                           // 42
	isNumericKey = function (s) {                                                                                   // 43
	  return /^[0-9]+$/.test(s);                                                                                    // 44
	};                                                                                                              // 45
	                                                                                                                // 46
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                              //
	// packages/minimongo/selector.js                                                                               //
	//                                                                                                              //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                //
	// The minimongo selector compiler!                                                                             // 1
	                                                                                                                // 2
	// Terminology:                                                                                                 // 3
	//  - a "selector" is the EJSON object representing a selector                                                  // 4
	//  - a "matcher" is its compiled form (whether a full Minimongo.Matcher                                        // 5
	//    object or one of the component lambdas that matches parts of it)                                          // 6
	//  - a "result object" is an object with a "result" field and maybe                                            // 7
	//    distance and arrayIndices.                                                                                // 8
	//  - a "branched value" is an object with a "value" field and maybe                                            // 9
	//    "dontIterate" and "arrayIndices".                                                                         // 10
	//  - a "document" is a top-level object that can be stored in a collection.                                    // 11
	//  - a "lookup function" is a function that takes in a document and returns                                    // 12
	//    an array of "branched values".                                                                            // 13
	//  - a "branched matcher" maps from an array of branched values to a result                                    // 14
	//    object.                                                                                                   // 15
	//  - an "element matcher" maps from a single value to a bool.                                                  // 16
	                                                                                                                // 17
	// Main entry point.                                                                                            // 18
	//   var matcher = new Minimongo.Matcher({a: {$gt: 5}});                                                        // 19
	//   if (matcher.documentMatches({a: 7})) ...                                                                   // 20
	Minimongo.Matcher = function (selector) {                                                                       // 21
	  var self = this;                                                                                              // 22
	  // A set (object mapping string -> *) of all of the document paths looked                                     // 23
	  // at by the selector. Also includes the empty string if it may look at any                                   // 24
	  // path (eg, $where).                                                                                         // 25
	  self._paths = {};                                                                                             // 26
	  // Set to true if compilation finds a $near.                                                                  // 27
	  self._hasGeoQuery = false;                                                                                    // 28
	  // Set to true if compilation finds a $where.                                                                 // 29
	  self._hasWhere = false;                                                                                       // 30
	  // Set to false if compilation finds anything other than a simple equality or                                 // 31
	  // one or more of '$gt', '$gte', '$lt', '$lte', '$ne', '$in', '$nin' used with                                // 32
	  // scalars as operands.                                                                                       // 33
	  self._isSimple = true;                                                                                        // 34
	  // Set to a dummy document which always matches this Matcher. Or set to null                                  // 35
	  // if such document is too hard to find.                                                                      // 36
	  self._matchingDocument = undefined;                                                                           // 37
	  // A clone of the original selector. It may just be a function if the user                                    // 38
	  // passed in a function; otherwise is definitely an object (eg, IDs are                                       // 39
	  // translated into {_id: ID} first. Used by canBecomeTrueByModifier and                                       // 40
	  // Sorter._useWithMatcher.                                                                                    // 41
	  self._selector = null;                                                                                        // 42
	  self._docMatcher = self._compileSelector(selector);                                                           // 43
	};                                                                                                              // 44
	                                                                                                                // 45
	_.extend(Minimongo.Matcher.prototype, {                                                                         // 46
	  documentMatches: function (doc) {                                                                             // 47
	    if (!doc || typeof doc !== "object") {                                                                      // 48
	      throw Error("documentMatches needs a document");                                                          // 49
	    }                                                                                                           // 50
	    return this._docMatcher(doc);                                                                               // 51
	  },                                                                                                            // 52
	  hasGeoQuery: function () {                                                                                    // 53
	    return this._hasGeoQuery;                                                                                   // 54
	  },                                                                                                            // 55
	  hasWhere: function () {                                                                                       // 56
	    return this._hasWhere;                                                                                      // 57
	  },                                                                                                            // 58
	  isSimple: function () {                                                                                       // 59
	    return this._isSimple;                                                                                      // 60
	  },                                                                                                            // 61
	                                                                                                                // 62
	  // Given a selector, return a function that takes one argument, a                                             // 63
	  // document. It returns a result object.                                                                      // 64
	  _compileSelector: function (selector) {                                                                       // 65
	    var self = this;                                                                                            // 66
	    // you can pass a literal function instead of a selector                                                    // 67
	    if (selector instanceof Function) {                                                                         // 68
	      self._isSimple = false;                                                                                   // 69
	      self._selector = selector;                                                                                // 70
	      self._recordPathUsed('');                                                                                 // 71
	      return function (doc) {                                                                                   // 72
	        return {result: !!selector.call(doc)};                                                                  // 73
	      };                                                                                                        // 74
	    }                                                                                                           // 75
	                                                                                                                // 76
	    // shorthand -- scalars match _id                                                                           // 77
	    if (LocalCollection._selectorIsId(selector)) {                                                              // 78
	      self._selector = {_id: selector};                                                                         // 79
	      self._recordPathUsed('_id');                                                                              // 80
	      return function (doc) {                                                                                   // 81
	        return {result: EJSON.equals(doc._id, selector)};                                                       // 82
	      };                                                                                                        // 83
	    }                                                                                                           // 84
	                                                                                                                // 85
	    // protect against dangerous selectors.  falsey and {_id: falsey} are both                                  // 86
	    // likely programmer error, and not what you want, particularly for                                         // 87
	    // destructive operations.                                                                                  // 88
	    if (!selector || (('_id' in selector) && !selector._id)) {                                                  // 89
	      self._isSimple = false;                                                                                   // 90
	      return nothingMatcher;                                                                                    // 91
	    }                                                                                                           // 92
	                                                                                                                // 93
	    // Top level can't be an array or true or binary.                                                           // 94
	    if (typeof(selector) === 'boolean' || isArray(selector) ||                                                  // 95
	        EJSON.isBinary(selector))                                                                               // 96
	      throw new Error("Invalid selector: " + selector);                                                         // 97
	                                                                                                                // 98
	    self._selector = EJSON.clone(selector);                                                                     // 99
	    return compileDocumentSelector(selector, self, {isRoot: true});                                             // 100
	  },                                                                                                            // 101
	  _recordPathUsed: function (path) {                                                                            // 102
	    this._paths[path] = true;                                                                                   // 103
	  },                                                                                                            // 104
	  // Returns a list of key paths the given selector is looking for. It includes                                 // 105
	  // the empty string if there is a $where.                                                                     // 106
	  _getPaths: function () {                                                                                      // 107
	    return _.keys(this._paths);                                                                                 // 108
	  }                                                                                                             // 109
	});                                                                                                             // 110
	                                                                                                                // 111
	                                                                                                                // 112
	// Takes in a selector that could match a full document (eg, the original                                       // 113
	// selector). Returns a function mapping document->result object.                                               // 114
	//                                                                                                              // 115
	// matcher is the Matcher object we are compiling.                                                              // 116
	//                                                                                                              // 117
	// If this is the root document selector (ie, not wrapped in $and or the like),                                 // 118
	// then isRoot is true. (This is used by $near.)                                                                // 119
	var compileDocumentSelector = function (docSelector, matcher, options) {                                        // 120
	  options = options || {};                                                                                      // 121
	  var docMatchers = [];                                                                                         // 122
	  _.each(docSelector, function (subSelector, key) {                                                             // 123
	    if (key.substr(0, 1) === '$') {                                                                             // 124
	      // Outer operators are either logical operators (they recurse back into                                   // 125
	      // this function), or $where.                                                                             // 126
	      if (!_.has(LOGICAL_OPERATORS, key))                                                                       // 127
	        throw new Error("Unrecognized logical operator: " + key);                                               // 128
	      matcher._isSimple = false;                                                                                // 129
	      docMatchers.push(LOGICAL_OPERATORS[key](subSelector, matcher,                                             // 130
	                                              options.inElemMatch));                                            // 131
	    } else {                                                                                                    // 132
	      // Record this path, but only if we aren't in an elemMatcher, since in an                                 // 133
	      // elemMatch this is a path inside an object in an array, not in the doc                                  // 134
	      // root.                                                                                                  // 135
	      if (!options.inElemMatch)                                                                                 // 136
	        matcher._recordPathUsed(key);                                                                           // 137
	      var lookUpByIndex = makeLookupFunction(key);                                                              // 138
	      var valueMatcher =                                                                                        // 139
	        compileValueSelector(subSelector, matcher, options.isRoot);                                             // 140
	      docMatchers.push(function (doc) {                                                                         // 141
	        var branchValues = lookUpByIndex(doc);                                                                  // 142
	        return valueMatcher(branchValues);                                                                      // 143
	      });                                                                                                       // 144
	    }                                                                                                           // 145
	  });                                                                                                           // 146
	                                                                                                                // 147
	  return andDocumentMatchers(docMatchers);                                                                      // 148
	};                                                                                                              // 149
	                                                                                                                // 150
	// Takes in a selector that could match a key-indexed value in a document; eg,                                  // 151
	// {$gt: 5, $lt: 9}, or a regular expression, or any non-expression object (to                                  // 152
	// indicate equality).  Returns a branched matcher: a function mapping                                          // 153
	// [branched value]->result object.                                                                             // 154
	var compileValueSelector = function (valueSelector, matcher, isRoot) {                                          // 155
	  if (valueSelector instanceof RegExp) {                                                                        // 156
	    matcher._isSimple = false;                                                                                  // 157
	    return convertElementMatcherToBranchedMatcher(                                                              // 158
	      regexpElementMatcher(valueSelector));                                                                     // 159
	  } else if (isOperatorObject(valueSelector)) {                                                                 // 160
	    return operatorBranchedMatcher(valueSelector, matcher, isRoot);                                             // 161
	  } else {                                                                                                      // 162
	    return convertElementMatcherToBranchedMatcher(                                                              // 163
	      equalityElementMatcher(valueSelector));                                                                   // 164
	  }                                                                                                             // 165
	};                                                                                                              // 166
	                                                                                                                // 167
	// Given an element matcher (which evaluates a single value), returns a branched                                // 168
	// value (which evaluates the element matcher on all the branches and returns a                                 // 169
	// more structured return value possibly including arrayIndices).                                               // 170
	var convertElementMatcherToBranchedMatcher = function (                                                         // 171
	    elementMatcher, options) {                                                                                  // 172
	  options = options || {};                                                                                      // 173
	  return function (branches) {                                                                                  // 174
	    var expanded = branches;                                                                                    // 175
	    if (!options.dontExpandLeafArrays) {                                                                        // 176
	      expanded = expandArraysInBranches(                                                                        // 177
	        branches, options.dontIncludeLeafArrays);                                                               // 178
	    }                                                                                                           // 179
	    var ret = {};                                                                                               // 180
	    ret.result = _.any(expanded, function (element) {                                                           // 181
	      var matched = elementMatcher(element.value);                                                              // 182
	                                                                                                                // 183
	      // Special case for $elemMatch: it means "true, and use this as an array                                  // 184
	      // index if I didn't already have one".                                                                   // 185
	      if (typeof matched === 'number') {                                                                        // 186
	        // XXX This code dates from when we only stored a single array index                                    // 187
	        // (for the outermost array). Should we be also including deeper array                                  // 188
	        // indices from the $elemMatch match?                                                                   // 189
	        if (!element.arrayIndices)                                                                              // 190
	          element.arrayIndices = [matched];                                                                     // 191
	        matched = true;                                                                                         // 192
	      }                                                                                                         // 193
	                                                                                                                // 194
	      // If some element matched, and it's tagged with array indices, include                                   // 195
	      // those indices in our result object.                                                                    // 196
	      if (matched && element.arrayIndices)                                                                      // 197
	        ret.arrayIndices = element.arrayIndices;                                                                // 198
	                                                                                                                // 199
	      return matched;                                                                                           // 200
	    });                                                                                                         // 201
	    return ret;                                                                                                 // 202
	  };                                                                                                            // 203
	};                                                                                                              // 204
	                                                                                                                // 205
	// Takes a RegExp object and returns an element matcher.                                                        // 206
	regexpElementMatcher = function (regexp) {                                                                      // 207
	  return function (value) {                                                                                     // 208
	    if (value instanceof RegExp) {                                                                              // 209
	      // Comparing two regexps means seeing if the regexps are identical                                        // 210
	      // (really!). Underscore knows how.                                                                       // 211
	      return _.isEqual(value, regexp);                                                                          // 212
	    }                                                                                                           // 213
	    // Regexps only work against strings.                                                                       // 214
	    if (typeof value !== 'string')                                                                              // 215
	      return false;                                                                                             // 216
	                                                                                                                // 217
	    // Reset regexp's state to avoid inconsistent matching for objects with the                                 // 218
	    // same value on consecutive calls of regexp.test. This happens only if the                                 // 219
	    // regexp has the 'g' flag. Also note that ES6 introduces a new flag 'y' for                                // 220
	    // which we should *not* change the lastIndex but MongoDB doesn't support                                   // 221
	    // either of these flags.                                                                                   // 222
	    regexp.lastIndex = 0;                                                                                       // 223
	                                                                                                                // 224
	    return regexp.test(value);                                                                                  // 225
	  };                                                                                                            // 226
	};                                                                                                              // 227
	                                                                                                                // 228
	// Takes something that is not an operator object and returns an element matcher                                // 229
	// for equality with that thing.                                                                                // 230
	equalityElementMatcher = function (elementSelector) {                                                           // 231
	  if (isOperatorObject(elementSelector))                                                                        // 232
	    throw Error("Can't create equalityValueSelector for operator object");                                      // 233
	                                                                                                                // 234
	  // Special-case: null and undefined are equal (if you got undefined in there                                  // 235
	  // somewhere, or if you got it due to some branch being non-existent in the                                   // 236
	  // weird special case), even though they aren't with EJSON.equals.                                            // 237
	  if (elementSelector == null) {  // undefined or null                                                          // 238
	    return function (value) {                                                                                   // 239
	      return value == null;  // undefined or null                                                               // 240
	    };                                                                                                          // 241
	  }                                                                                                             // 242
	                                                                                                                // 243
	  return function (value) {                                                                                     // 244
	    return LocalCollection._f._equal(elementSelector, value);                                                   // 245
	  };                                                                                                            // 246
	};                                                                                                              // 247
	                                                                                                                // 248
	// Takes an operator object (an object with $ keys) and returns a branched                                      // 249
	// matcher for it.                                                                                              // 250
	var operatorBranchedMatcher = function (valueSelector, matcher, isRoot) {                                       // 251
	  // Each valueSelector works separately on the various branches.  So one                                       // 252
	  // operator can match one branch and another can match another branch.  This                                  // 253
	  // is OK.                                                                                                     // 254
	                                                                                                                // 255
	  var operatorMatchers = [];                                                                                    // 256
	  _.each(valueSelector, function (operand, operator) {                                                          // 257
	    var simpleRange = _.contains(['$lt', '$lte', '$gt', '$gte'], operator) &&                                   // 258
	      _.isNumber(operand);                                                                                      // 259
	    var simpleEquality = _.contains(['$ne', '$eq'], operator) && !_.isObject(operand);                          // 260
	    var simpleInclusion = _.contains(['$in', '$nin'], operator) &&                                              // 261
	      _.isArray(operand) && !_.any(operand, _.isObject);                                                        // 262
	                                                                                                                // 263
	    if (! (simpleRange || simpleInclusion || simpleEquality)) {                                                 // 264
	      matcher._isSimple = false;                                                                                // 265
	    }                                                                                                           // 266
	                                                                                                                // 267
	    if (_.has(VALUE_OPERATORS, operator)) {                                                                     // 268
	      operatorMatchers.push(                                                                                    // 269
	        VALUE_OPERATORS[operator](operand, valueSelector, matcher, isRoot));                                    // 270
	    } else if (_.has(ELEMENT_OPERATORS, operator)) {                                                            // 271
	      var options = ELEMENT_OPERATORS[operator];                                                                // 272
	      operatorMatchers.push(                                                                                    // 273
	        convertElementMatcherToBranchedMatcher(                                                                 // 274
	          options.compileElementSelector(                                                                       // 275
	            operand, valueSelector, matcher),                                                                   // 276
	          options));                                                                                            // 277
	    } else {                                                                                                    // 278
	      throw new Error("Unrecognized operator: " + operator);                                                    // 279
	    }                                                                                                           // 280
	  });                                                                                                           // 281
	                                                                                                                // 282
	  return andBranchedMatchers(operatorMatchers);                                                                 // 283
	};                                                                                                              // 284
	                                                                                                                // 285
	var compileArrayOfDocumentSelectors = function (                                                                // 286
	    selectors, matcher, inElemMatch) {                                                                          // 287
	  if (!isArray(selectors) || _.isEmpty(selectors))                                                              // 288
	    throw Error("$and/$or/$nor must be nonempty array");                                                        // 289
	  return _.map(selectors, function (subSelector) {                                                              // 290
	    if (!isPlainObject(subSelector))                                                                            // 291
	      throw Error("$or/$and/$nor entries need to be full objects");                                             // 292
	    return compileDocumentSelector(                                                                             // 293
	      subSelector, matcher, {inElemMatch: inElemMatch});                                                        // 294
	  });                                                                                                           // 295
	};                                                                                                              // 296
	                                                                                                                // 297
	// Operators that appear at the top level of a document selector.                                               // 298
	var LOGICAL_OPERATORS = {                                                                                       // 299
	  $and: function (subSelector, matcher, inElemMatch) {                                                          // 300
	    var matchers = compileArrayOfDocumentSelectors(                                                             // 301
	      subSelector, matcher, inElemMatch);                                                                       // 302
	    return andDocumentMatchers(matchers);                                                                       // 303
	  },                                                                                                            // 304
	                                                                                                                // 305
	  $or: function (subSelector, matcher, inElemMatch) {                                                           // 306
	    var matchers = compileArrayOfDocumentSelectors(                                                             // 307
	      subSelector, matcher, inElemMatch);                                                                       // 308
	                                                                                                                // 309
	    // Special case: if there is only one matcher, use it directly, *preserving*                                // 310
	    // any arrayIndices it returns.                                                                             // 311
	    if (matchers.length === 1)                                                                                  // 312
	      return matchers[0];                                                                                       // 313
	                                                                                                                // 314
	    return function (doc) {                                                                                     // 315
	      var result = _.any(matchers, function (f) {                                                               // 316
	        return f(doc).result;                                                                                   // 317
	      });                                                                                                       // 318
	      // $or does NOT set arrayIndices when it has multiple                                                     // 319
	      // sub-expressions. (Tested against MongoDB.)                                                             // 320
	      return {result: result};                                                                                  // 321
	    };                                                                                                          // 322
	  },                                                                                                            // 323
	                                                                                                                // 324
	  $nor: function (subSelector, matcher, inElemMatch) {                                                          // 325
	    var matchers = compileArrayOfDocumentSelectors(                                                             // 326
	      subSelector, matcher, inElemMatch);                                                                       // 327
	    return function (doc) {                                                                                     // 328
	      var result = _.all(matchers, function (f) {                                                               // 329
	        return !f(doc).result;                                                                                  // 330
	      });                                                                                                       // 331
	      // Never set arrayIndices, because we only match if nothing in particular                                 // 332
	      // "matched" (and because this is consistent with MongoDB).                                               // 333
	      return {result: result};                                                                                  // 334
	    };                                                                                                          // 335
	  },                                                                                                            // 336
	                                                                                                                // 337
	  $where: function (selectorValue, matcher) {                                                                   // 338
	    // Record that *any* path may be used.                                                                      // 339
	    matcher._recordPathUsed('');                                                                                // 340
	    matcher._hasWhere = true;                                                                                   // 341
	    if (!(selectorValue instanceof Function)) {                                                                 // 342
	      // XXX MongoDB seems to have more complex logic to decide where or or not                                 // 343
	      // to add "return"; not sure exactly what it is.                                                          // 344
	      selectorValue = Function("obj", "return " + selectorValue);                                               // 345
	    }                                                                                                           // 346
	    return function (doc) {                                                                                     // 347
	      // We make the document available as both `this` and `obj`.                                               // 348
	      // XXX not sure what we should do if this throws                                                          // 349
	      return {result: selectorValue.call(doc, doc)};                                                            // 350
	    };                                                                                                          // 351
	  },                                                                                                            // 352
	                                                                                                                // 353
	  // This is just used as a comment in the query (in MongoDB, it also ends up in                                // 354
	  // query logs); it has no effect on the actual selection.                                                     // 355
	  $comment: function () {                                                                                       // 356
	    return function () {                                                                                        // 357
	      return {result: true};                                                                                    // 358
	    };                                                                                                          // 359
	  }                                                                                                             // 360
	};                                                                                                              // 361
	                                                                                                                // 362
	// Returns a branched matcher that matches iff the given matcher does not.                                      // 363
	// Note that this implicitly "deMorganizes" the wrapped function.  ie, it                                       // 364
	// means that ALL branch values need to fail to match innerBranchedMatcher.                                     // 365
	var invertBranchedMatcher = function (branchedMatcher) {                                                        // 366
	  return function (branchValues) {                                                                              // 367
	    var invertMe = branchedMatcher(branchValues);                                                               // 368
	    // We explicitly choose to strip arrayIndices here: it doesn't make sense to                                // 369
	    // say "update the array element that does not match something", at least                                   // 370
	    // in mongo-land.                                                                                           // 371
	    return {result: !invertMe.result};                                                                          // 372
	  };                                                                                                            // 373
	};                                                                                                              // 374
	                                                                                                                // 375
	// Operators that (unlike LOGICAL_OPERATORS) pertain to individual paths in a                                   // 376
	// document, but (unlike ELEMENT_OPERATORS) do not have a simple definition as                                  // 377
	// "match each branched value independently and combine with                                                    // 378
	// convertElementMatcherToBranchedMatcher".                                                                     // 379
	var VALUE_OPERATORS = {                                                                                         // 380
	  $eq: function (operand) {                                                                                     // 381
	    return convertElementMatcherToBranchedMatcher(                                                              // 382
	      equalityElementMatcher(operand));                                                                         // 383
	  },                                                                                                            // 384
	  $not: function (operand, valueSelector, matcher) {                                                            // 385
	    return invertBranchedMatcher(compileValueSelector(operand, matcher));                                       // 386
	  },                                                                                                            // 387
	  $ne: function (operand) {                                                                                     // 388
	    return invertBranchedMatcher(convertElementMatcherToBranchedMatcher(                                        // 389
	      equalityElementMatcher(operand)));                                                                        // 390
	  },                                                                                                            // 391
	  $nin: function (operand) {                                                                                    // 392
	    return invertBranchedMatcher(convertElementMatcherToBranchedMatcher(                                        // 393
	      ELEMENT_OPERATORS.$in.compileElementSelector(operand)));                                                  // 394
	  },                                                                                                            // 395
	  $exists: function (operand) {                                                                                 // 396
	    var exists = convertElementMatcherToBranchedMatcher(function (value) {                                      // 397
	      return value !== undefined;                                                                               // 398
	    });                                                                                                         // 399
	    return operand ? exists : invertBranchedMatcher(exists);                                                    // 400
	  },                                                                                                            // 401
	  // $options just provides options for $regex; its logic is inside $regex                                      // 402
	  $options: function (operand, valueSelector) {                                                                 // 403
	    if (!_.has(valueSelector, '$regex'))                                                                        // 404
	      throw Error("$options needs a $regex");                                                                   // 405
	    return everythingMatcher;                                                                                   // 406
	  },                                                                                                            // 407
	  // $maxDistance is basically an argument to $near                                                             // 408
	  $maxDistance: function (operand, valueSelector) {                                                             // 409
	    if (!valueSelector.$near)                                                                                   // 410
	      throw Error("$maxDistance needs a $near");                                                                // 411
	    return everythingMatcher;                                                                                   // 412
	  },                                                                                                            // 413
	  $all: function (operand, valueSelector, matcher) {                                                            // 414
	    if (!isArray(operand))                                                                                      // 415
	      throw Error("$all requires array");                                                                       // 416
	    // Not sure why, but this seems to be what MongoDB does.                                                    // 417
	    if (_.isEmpty(operand))                                                                                     // 418
	      return nothingMatcher;                                                                                    // 419
	                                                                                                                // 420
	    var branchedMatchers = [];                                                                                  // 421
	    _.each(operand, function (criterion) {                                                                      // 422
	      // XXX handle $all/$elemMatch combination                                                                 // 423
	      if (isOperatorObject(criterion))                                                                          // 424
	        throw Error("no $ expressions in $all");                                                                // 425
	      // This is always a regexp or equality selector.                                                          // 426
	      branchedMatchers.push(compileValueSelector(criterion, matcher));                                          // 427
	    });                                                                                                         // 428
	    // andBranchedMatchers does NOT require all selectors to return true on the                                 // 429
	    // SAME branch.                                                                                             // 430
	    return andBranchedMatchers(branchedMatchers);                                                               // 431
	  },                                                                                                            // 432
	  $near: function (operand, valueSelector, matcher, isRoot) {                                                   // 433
	    if (!isRoot)                                                                                                // 434
	      throw Error("$near can't be inside another $ operator");                                                  // 435
	    matcher._hasGeoQuery = true;                                                                                // 436
	                                                                                                                // 437
	    // There are two kinds of geodata in MongoDB: coordinate pairs and                                          // 438
	    // GeoJSON. They use different distance metrics, too. GeoJSON queries are                                   // 439
	    // marked with a $geometry property.                                                                        // 440
	                                                                                                                // 441
	    var maxDistance, point, distance;                                                                           // 442
	    if (isPlainObject(operand) && _.has(operand, '$geometry')) {                                                // 443
	      // GeoJSON "2dsphere" mode.                                                                               // 444
	      maxDistance = operand.$maxDistance;                                                                       // 445
	      point = operand.$geometry;                                                                                // 446
	      distance = function (value) {                                                                             // 447
	        // XXX: for now, we don't calculate the actual distance between, say,                                   // 448
	        // polygon and circle. If people care about this use-case it will get                                   // 449
	        // a priority.                                                                                          // 450
	        if (!value || !value.type)                                                                              // 451
	          return null;                                                                                          // 452
	        if (value.type === "Point") {                                                                           // 453
	          return GeoJSON.pointDistance(point, value);                                                           // 454
	        } else {                                                                                                // 455
	          return GeoJSON.geometryWithinRadius(value, point, maxDistance)                                        // 456
	            ? 0 : maxDistance + 1;                                                                              // 457
	        }                                                                                                       // 458
	      };                                                                                                        // 459
	    } else {                                                                                                    // 460
	      maxDistance = valueSelector.$maxDistance;                                                                 // 461
	      if (!isArray(operand) && !isPlainObject(operand))                                                         // 462
	        throw Error("$near argument must be coordinate pair or GeoJSON");                                       // 463
	      point = pointToArray(operand);                                                                            // 464
	      distance = function (value) {                                                                             // 465
	        if (!isArray(value) && !isPlainObject(value))                                                           // 466
	          return null;                                                                                          // 467
	        return distanceCoordinatePairs(point, value);                                                           // 468
	      };                                                                                                        // 469
	    }                                                                                                           // 470
	                                                                                                                // 471
	    return function (branchedValues) {                                                                          // 472
	      // There might be multiple points in the document that match the given                                    // 473
	      // field. Only one of them needs to be within $maxDistance, but we need to                                // 474
	      // evaluate all of them and use the nearest one for the implicit sort                                     // 475
	      // specifier. (That's why we can't just use ELEMENT_OPERATORS here.)                                      // 476
	      //                                                                                                        // 477
	      // Note: This differs from MongoDB's implementation, where a document will                                // 478
	      // actually show up *multiple times* in the result set, with one entry for                                // 479
	      // each within-$maxDistance branching point.                                                              // 480
	      branchedValues = expandArraysInBranches(branchedValues);                                                  // 481
	      var result = {result: false};                                                                             // 482
	      _.each(branchedValues, function (branch) {                                                                // 483
	        var curDistance = distance(branch.value);                                                               // 484
	        // Skip branches that aren't real points or are too far away.                                           // 485
	        if (curDistance === null || curDistance > maxDistance)                                                  // 486
	          return;                                                                                               // 487
	        // Skip anything that's a tie.                                                                          // 488
	        if (result.distance !== undefined && result.distance <= curDistance)                                    // 489
	          return;                                                                                               // 490
	        result.result = true;                                                                                   // 491
	        result.distance = curDistance;                                                                          // 492
	        if (!branch.arrayIndices)                                                                               // 493
	          delete result.arrayIndices;                                                                           // 494
	        else                                                                                                    // 495
	          result.arrayIndices = branch.arrayIndices;                                                            // 496
	      });                                                                                                       // 497
	      return result;                                                                                            // 498
	    };                                                                                                          // 499
	  }                                                                                                             // 500
	};                                                                                                              // 501
	                                                                                                                // 502
	// Helpers for $near.                                                                                           // 503
	var distanceCoordinatePairs = function (a, b) {                                                                 // 504
	  a = pointToArray(a);                                                                                          // 505
	  b = pointToArray(b);                                                                                          // 506
	  var x = a[0] - b[0];                                                                                          // 507
	  var y = a[1] - b[1];                                                                                          // 508
	  if (_.isNaN(x) || _.isNaN(y))                                                                                 // 509
	    return null;                                                                                                // 510
	  return Math.sqrt(x * x + y * y);                                                                              // 511
	};                                                                                                              // 512
	// Makes sure we get 2 elements array and assume the first one to be x and                                      // 513
	// the second one to y no matter what user passes.                                                              // 514
	// In case user passes { lon: x, lat: y } returns [x, y]                                                        // 515
	var pointToArray = function (point) {                                                                           // 516
	  return _.map(point, _.identity);                                                                              // 517
	};                                                                                                              // 518
	                                                                                                                // 519
	// Helper for $lt/$gt/$lte/$gte.                                                                                // 520
	var makeInequality = function (cmpValueComparator) {                                                            // 521
	  return {                                                                                                      // 522
	    compileElementSelector: function (operand) {                                                                // 523
	      // Arrays never compare false with non-arrays for any inequality.                                         // 524
	      // XXX This was behavior we observed in pre-release MongoDB 2.5, but                                      // 525
	      //     it seems to have been reverted.                                                                    // 526
	      //     See https://jira.mongodb.org/browse/SERVER-11444                                                   // 527
	      if (isArray(operand)) {                                                                                   // 528
	        return function () {                                                                                    // 529
	          return false;                                                                                         // 530
	        };                                                                                                      // 531
	      }                                                                                                         // 532
	                                                                                                                // 533
	      // Special case: consider undefined and null the same (so true with                                       // 534
	      // $gte/$lte).                                                                                            // 535
	      if (operand === undefined)                                                                                // 536
	        operand = null;                                                                                         // 537
	                                                                                                                // 538
	      var operandType = LocalCollection._f._type(operand);                                                      // 539
	                                                                                                                // 540
	      return function (value) {                                                                                 // 541
	        if (value === undefined)                                                                                // 542
	          value = null;                                                                                         // 543
	        // Comparisons are never true among things of different type (except                                    // 544
	        // null vs undefined).                                                                                  // 545
	        if (LocalCollection._f._type(value) !== operandType)                                                    // 546
	          return false;                                                                                         // 547
	        return cmpValueComparator(LocalCollection._f._cmp(value, operand));                                     // 548
	      };                                                                                                        // 549
	    }                                                                                                           // 550
	  };                                                                                                            // 551
	};                                                                                                              // 552
	                                                                                                                // 553
	// Each element selector contains:                                                                              // 554
	//  - compileElementSelector, a function with args:                                                             // 555
	//    - operand - the "right hand side" of the operator                                                         // 556
	//    - valueSelector - the "context" for the operator (so that $regex can find                                 // 557
	//      $options)                                                                                               // 558
	//    - matcher - the Matcher this is going into (so that $elemMatch can compile                                // 559
	//      more things)                                                                                            // 560
	//    returning a function mapping a single value to bool.                                                      // 561
	//  - dontExpandLeafArrays, a bool which prevents expandArraysInBranches from                                   // 562
	//    being called                                                                                              // 563
	//  - dontIncludeLeafArrays, a bool which causes an argument to be passed to                                    // 564
	//    expandArraysInBranches if it is called                                                                    // 565
	ELEMENT_OPERATORS = {                                                                                           // 566
	  $lt: makeInequality(function (cmpValue) {                                                                     // 567
	    return cmpValue < 0;                                                                                        // 568
	  }),                                                                                                           // 569
	  $gt: makeInequality(function (cmpValue) {                                                                     // 570
	    return cmpValue > 0;                                                                                        // 571
	  }),                                                                                                           // 572
	  $lte: makeInequality(function (cmpValue) {                                                                    // 573
	    return cmpValue <= 0;                                                                                       // 574
	  }),                                                                                                           // 575
	  $gte: makeInequality(function (cmpValue) {                                                                    // 576
	    return cmpValue >= 0;                                                                                       // 577
	  }),                                                                                                           // 578
	  $mod: {                                                                                                       // 579
	    compileElementSelector: function (operand) {                                                                // 580
	      if (!(isArray(operand) && operand.length === 2                                                            // 581
	            && typeof(operand[0]) === 'number'                                                                  // 582
	            && typeof(operand[1]) === 'number')) {                                                              // 583
	        throw Error("argument to $mod must be an array of two numbers");                                        // 584
	      }                                                                                                         // 585
	      // XXX could require to be ints or round or something                                                     // 586
	      var divisor = operand[0];                                                                                 // 587
	      var remainder = operand[1];                                                                               // 588
	      return function (value) {                                                                                 // 589
	        return typeof value === 'number' && value % divisor === remainder;                                      // 590
	      };                                                                                                        // 591
	    }                                                                                                           // 592
	  },                                                                                                            // 593
	  $in: {                                                                                                        // 594
	    compileElementSelector: function (operand) {                                                                // 595
	      if (!isArray(operand))                                                                                    // 596
	        throw Error("$in needs an array");                                                                      // 597
	                                                                                                                // 598
	      var elementMatchers = [];                                                                                 // 599
	      _.each(operand, function (option) {                                                                       // 600
	        if (option instanceof RegExp)                                                                           // 601
	          elementMatchers.push(regexpElementMatcher(option));                                                   // 602
	        else if (isOperatorObject(option))                                                                      // 603
	          throw Error("cannot nest $ under $in");                                                               // 604
	        else                                                                                                    // 605
	          elementMatchers.push(equalityElementMatcher(option));                                                 // 606
	      });                                                                                                       // 607
	                                                                                                                // 608
	      return function (value) {                                                                                 // 609
	        // Allow {a: {$in: [null]}} to match when 'a' does not exist.                                           // 610
	        if (value === undefined)                                                                                // 611
	          value = null;                                                                                         // 612
	        return _.any(elementMatchers, function (e) {                                                            // 613
	          return e(value);                                                                                      // 614
	        });                                                                                                     // 615
	      };                                                                                                        // 616
	    }                                                                                                           // 617
	  },                                                                                                            // 618
	  $size: {                                                                                                      // 619
	    // {a: [[5, 5]]} must match {a: {$size: 1}} but not {a: {$size: 2}}, so we                                  // 620
	    // don't want to consider the element [5,5] in the leaf array [[5,5]] as a                                  // 621
	    // possible value.                                                                                          // 622
	    dontExpandLeafArrays: true,                                                                                 // 623
	    compileElementSelector: function (operand) {                                                                // 624
	      if (typeof operand === 'string') {                                                                        // 625
	        // Don't ask me why, but by experimentation, this seems to be what Mongo                                // 626
	        // does.                                                                                                // 627
	        operand = 0;                                                                                            // 628
	      } else if (typeof operand !== 'number') {                                                                 // 629
	        throw Error("$size needs a number");                                                                    // 630
	      }                                                                                                         // 631
	      return function (value) {                                                                                 // 632
	        return isArray(value) && value.length === operand;                                                      // 633
	      };                                                                                                        // 634
	    }                                                                                                           // 635
	  },                                                                                                            // 636
	  $type: {                                                                                                      // 637
	    // {a: [5]} must not match {a: {$type: 4}} (4 means array), but it should                                   // 638
	    // match {a: {$type: 1}} (1 means number), and {a: [[5]]} must match {$a:                                   // 639
	    // {$type: 4}}. Thus, when we see a leaf array, we *should* expand it but                                   // 640
	    // should *not* include it itself.                                                                          // 641
	    dontIncludeLeafArrays: true,                                                                                // 642
	    compileElementSelector: function (operand) {                                                                // 643
	      if (typeof operand !== 'number')                                                                          // 644
	        throw Error("$type needs a number");                                                                    // 645
	      return function (value) {                                                                                 // 646
	        return value !== undefined                                                                              // 647
	          && LocalCollection._f._type(value) === operand;                                                       // 648
	      };                                                                                                        // 649
	    }                                                                                                           // 650
	  },                                                                                                            // 651
	  $regex: {                                                                                                     // 652
	    compileElementSelector: function (operand, valueSelector) {                                                 // 653
	      if (!(typeof operand === 'string' || operand instanceof RegExp))                                          // 654
	        throw Error("$regex has to be a string or RegExp");                                                     // 655
	                                                                                                                // 656
	      var regexp;                                                                                               // 657
	      if (valueSelector.$options !== undefined) {                                                               // 658
	        // Options passed in $options (even the empty string) always overrides                                  // 659
	        // options in the RegExp object itself. (See also                                                       // 660
	        // Mongo.Collection._rewriteSelector.)                                                                  // 661
	                                                                                                                // 662
	        // Be clear that we only support the JS-supported options, not extended                                 // 663
	        // ones (eg, Mongo supports x and s). Ideally we would implement x and s                                // 664
	        // by transforming the regexp, but not today...                                                         // 665
	        if (/[^gim]/.test(valueSelector.$options))                                                              // 666
	          throw new Error("Only the i, m, and g regexp options are supported");                                 // 667
	                                                                                                                // 668
	        var regexSource = operand instanceof RegExp ? operand.source : operand;                                 // 669
	        regexp = new RegExp(regexSource, valueSelector.$options);                                               // 670
	      } else if (operand instanceof RegExp) {                                                                   // 671
	        regexp = operand;                                                                                       // 672
	      } else {                                                                                                  // 673
	        regexp = new RegExp(operand);                                                                           // 674
	      }                                                                                                         // 675
	      return regexpElementMatcher(regexp);                                                                      // 676
	    }                                                                                                           // 677
	  },                                                                                                            // 678
	  $elemMatch: {                                                                                                 // 679
	    dontExpandLeafArrays: true,                                                                                 // 680
	    compileElementSelector: function (operand, valueSelector, matcher) {                                        // 681
	      if (!isPlainObject(operand))                                                                              // 682
	        throw Error("$elemMatch need an object");                                                               // 683
	                                                                                                                // 684
	      var subMatcher, isDocMatcher;                                                                             // 685
	      if (isOperatorObject(_.omit(operand, _.keys(LOGICAL_OPERATORS)), true)) {                                 // 686
	        subMatcher = compileValueSelector(operand, matcher);                                                    // 687
	        isDocMatcher = false;                                                                                   // 688
	      } else {                                                                                                  // 689
	        // This is NOT the same as compileValueSelector(operand), and not just                                  // 690
	        // because of the slightly different calling convention.                                                // 691
	        // {$elemMatch: {x: 3}} means "an element has a field x:3", not                                         // 692
	        // "consists only of a field x:3". Also, regexps and sub-$ are allowed.                                 // 693
	        subMatcher = compileDocumentSelector(operand, matcher,                                                  // 694
	                                             {inElemMatch: true});                                              // 695
	        isDocMatcher = true;                                                                                    // 696
	      }                                                                                                         // 697
	                                                                                                                // 698
	      return function (value) {                                                                                 // 699
	        if (!isArray(value))                                                                                    // 700
	          return false;                                                                                         // 701
	        for (var i = 0; i < value.length; ++i) {                                                                // 702
	          var arrayElement = value[i];                                                                          // 703
	          var arg;                                                                                              // 704
	          if (isDocMatcher) {                                                                                   // 705
	            // We can only match {$elemMatch: {b: 3}} against objects.                                          // 706
	            // (We can also match against arrays, if there's numeric indices,                                   // 707
	            // eg {$elemMatch: {'0.b': 3}} or {$elemMatch: {0: 3}}.)                                            // 708
	            if (!isPlainObject(arrayElement) && !isArray(arrayElement))                                         // 709
	              return false;                                                                                     // 710
	            arg = arrayElement;                                                                                 // 711
	          } else {                                                                                              // 712
	            // dontIterate ensures that {a: {$elemMatch: {$gt: 5}}} matches                                     // 713
	            // {a: [8]} but not {a: [[8]]}                                                                      // 714
	            arg = [{value: arrayElement, dontIterate: true}];                                                   // 715
	          }                                                                                                     // 716
	          // XXX support $near in $elemMatch by propagating $distance?                                          // 717
	          if (subMatcher(arg).result)                                                                           // 718
	            return i;   // specially understood to mean "use as arrayIndices"                                   // 719
	        }                                                                                                       // 720
	        return false;                                                                                           // 721
	      };                                                                                                        // 722
	    }                                                                                                           // 723
	  }                                                                                                             // 724
	};                                                                                                              // 725
	                                                                                                                // 726
	// makeLookupFunction(key) returns a lookup function.                                                           // 727
	//                                                                                                              // 728
	// A lookup function takes in a document and returns an array of matching                                       // 729
	// branches.  If no arrays are found while looking up the key, this array will                                  // 730
	// have exactly one branches (possibly 'undefined', if some segment of the key                                  // 731
	// was not found).                                                                                              // 732
	//                                                                                                              // 733
	// If arrays are found in the middle, this can have more than one element, since                                // 734
	// we "branch". When we "branch", if there are more key segments to look up,                                    // 735
	// then we only pursue branches that are plain objects (not arrays or scalars).                                 // 736
	// This means we can actually end up with no branches!                                                          // 737
	//                                                                                                              // 738
	// We do *NOT* branch on arrays that are found at the end (ie, at the last                                      // 739
	// dotted member of the key). We just return that array; if you want to                                         // 740
	// effectively "branch" over the array's values, post-process the lookup                                        // 741
	// function with expandArraysInBranches.                                                                        // 742
	//                                                                                                              // 743
	// Each branch is an object with keys:                                                                          // 744
	//  - value: the value at the branch                                                                            // 745
	//  - dontIterate: an optional bool; if true, it means that 'value' is an array                                 // 746
	//    that expandArraysInBranches should NOT expand. This specifically happens                                  // 747
	//    when there is a numeric index in the key, and ensures the                                                 // 748
	//    perhaps-surprising MongoDB behavior where {'a.0': 5} does NOT                                             // 749
	//    match {a: [[5]]}.                                                                                         // 750
	//  - arrayIndices: if any array indexing was done during lookup (either due to                                 // 751
	//    explicit numeric indices or implicit branching), this will be an array of                                 // 752
	//    the array indices used, from outermost to innermost; it is falsey or                                      // 753
	//    absent if no array index is used. If an explicit numeric index is used,                                   // 754
	//    the index will be followed in arrayIndices by the string 'x'.                                             // 755
	//                                                                                                              // 756
	//    Note: arrayIndices is used for two purposes. First, it is used to                                         // 757
	//    implement the '$' modifier feature, which only ever looks at its first                                    // 758
	//    element.                                                                                                  // 759
	//                                                                                                              // 760
	//    Second, it is used for sort key generation, which needs to be able to tell                                // 761
	//    the difference between different paths. Moreover, it needs to                                             // 762
	//    differentiate between explicit and implicit branching, which is why                                       // 763
	//    there's the somewhat hacky 'x' entry: this means that explicit and                                        // 764
	//    implicit array lookups will have different full arrayIndices paths. (That                                 // 765
	//    code only requires that different paths have different arrayIndices; it                                   // 766
	//    doesn't actually "parse" arrayIndices. As an alternative, arrayIndices                                    // 767
	//    could contain objects with flags like "implicit", but I think that only                                   // 768
	//    makes the code surrounding them more complex.)                                                            // 769
	//                                                                                                              // 770
	//    (By the way, this field ends up getting passed around a lot without                                       // 771
	//    cloning, so never mutate any arrayIndices field/var in this package!)                                     // 772
	//                                                                                                              // 773
	//                                                                                                              // 774
	// At the top level, you may only pass in a plain object or array.                                              // 775
	//                                                                                                              // 776
	// See the test 'minimongo - lookup' for some examples of what lookup functions                                 // 777
	// return.                                                                                                      // 778
	makeLookupFunction = function (key, options) {                                                                  // 779
	  options = options || {};                                                                                      // 780
	  var parts = key.split('.');                                                                                   // 781
	  var firstPart = parts.length ? parts[0] : '';                                                                 // 782
	  var firstPartIsNumeric = isNumericKey(firstPart);                                                             // 783
	  var nextPartIsNumeric = parts.length >= 2 && isNumericKey(parts[1]);                                          // 784
	  var lookupRest;                                                                                               // 785
	  if (parts.length > 1) {                                                                                       // 786
	    lookupRest = makeLookupFunction(parts.slice(1).join('.'));                                                  // 787
	  }                                                                                                             // 788
	                                                                                                                // 789
	  var omitUnnecessaryFields = function (retVal) {                                                               // 790
	    if (!retVal.dontIterate)                                                                                    // 791
	      delete retVal.dontIterate;                                                                                // 792
	    if (retVal.arrayIndices && !retVal.arrayIndices.length)                                                     // 793
	      delete retVal.arrayIndices;                                                                               // 794
	    return retVal;                                                                                              // 795
	  };                                                                                                            // 796
	                                                                                                                // 797
	  // Doc will always be a plain object or an array.                                                             // 798
	  // apply an explicit numeric index, an array.                                                                 // 799
	  return function (doc, arrayIndices) {                                                                         // 800
	    if (!arrayIndices)                                                                                          // 801
	      arrayIndices = [];                                                                                        // 802
	                                                                                                                // 803
	    if (isArray(doc)) {                                                                                         // 804
	      // If we're being asked to do an invalid lookup into an array (non-integer                                // 805
	      // or out-of-bounds), return no results (which is different from returning                                // 806
	      // a single undefined result, in that `null` equality checks won't match).                                // 807
	      if (!(firstPartIsNumeric && firstPart < doc.length))                                                      // 808
	        return [];                                                                                              // 809
	                                                                                                                // 810
	      // Remember that we used this array index. Include an 'x' to indicate that                                // 811
	      // the previous index came from being considered as an explicit array                                     // 812
	      // index (not branching).                                                                                 // 813
	      arrayIndices = arrayIndices.concat(+firstPart, 'x');                                                      // 814
	    }                                                                                                           // 815
	                                                                                                                // 816
	    // Do our first lookup.                                                                                     // 817
	    var firstLevel = doc[firstPart];                                                                            // 818
	                                                                                                                // 819
	    // If there is no deeper to dig, return what we found.                                                      // 820
	    //                                                                                                          // 821
	    // If what we found is an array, most value selectors will choose to treat                                  // 822
	    // the elements of the array as matchable values in their own right, but                                    // 823
	    // that's done outside of the lookup function. (Exceptions to this are $size                                // 824
	    // and stuff relating to $elemMatch.  eg, {a: {$size: 2}} does not match {a:                                // 825
	    // [[1, 2]]}.)                                                                                              // 826
	    //                                                                                                          // 827
	    // That said, if we just did an *explicit* array lookup (on doc) to find                                    // 828
	    // firstLevel, and firstLevel is an array too, we do NOT want value                                         // 829
	    // selectors to iterate over it.  eg, {'a.0': 5} does not match {a: [[5]]}.                                 // 830
	    // So in that case, we mark the return value as "don't iterate".                                            // 831
	    if (!lookupRest) {                                                                                          // 832
	      return [omitUnnecessaryFields({                                                                           // 833
	        value: firstLevel,                                                                                      // 834
	        dontIterate: isArray(doc) && isArray(firstLevel),                                                       // 835
	        arrayIndices: arrayIndices})];                                                                          // 836
	    }                                                                                                           // 837
	                                                                                                                // 838
	    // We need to dig deeper.  But if we can't, because what we've found is not                                 // 839
	    // an array or plain object, we're done. If we just did a numeric index into                                // 840
	    // an array, we return nothing here (this is a change in Mongo 2.5 from                                     // 841
	    // Mongo 2.4, where {'a.0.b': null} stopped matching {a: [5]}). Otherwise,                                  // 842
	    // return a single `undefined` (which can, for example, match via equality                                  // 843
	    // with `null`).                                                                                            // 844
	    if (!isIndexable(firstLevel)) {                                                                             // 845
	      if (isArray(doc))                                                                                         // 846
	        return [];                                                                                              // 847
	      return [omitUnnecessaryFields({value: undefined,                                                          // 848
	                                      arrayIndices: arrayIndices})];                                            // 849
	    }                                                                                                           // 850
	                                                                                                                // 851
	    var result = [];                                                                                            // 852
	    var appendToResult = function (more) {                                                                      // 853
	      Array.prototype.push.apply(result, more);                                                                 // 854
	    };                                                                                                          // 855
	                                                                                                                // 856
	    // Dig deeper: look up the rest of the parts on whatever we've found.                                       // 857
	    // (lookupRest is smart enough to not try to do invalid lookups into                                        // 858
	    // firstLevel if it's an array.)                                                                            // 859
	    appendToResult(lookupRest(firstLevel, arrayIndices));                                                       // 860
	                                                                                                                // 861
	    // If we found an array, then in *addition* to potentially treating the next                                // 862
	    // part as a literal integer lookup, we should also "branch": try to look up                                // 863
	    // the rest of the parts on each array element in parallel.                                                 // 864
	    //                                                                                                          // 865
	    // In this case, we *only* dig deeper into array elements that are plain                                    // 866
	    // objects. (Recall that we only got this far if we have further to dig.)                                   // 867
	    // This makes sense: we certainly don't dig deeper into non-indexable                                       // 868
	    // objects. And it would be weird to dig into an array: it's simpler to have                                // 869
	    // a rule that explicit integer indexes only apply to an outer array, not to                                // 870
	    // an array you find after a branching search.                                                              // 871
	    //                                                                                                          // 872
	    // In the special case of a numeric part in a *sort selector* (not a query                                  // 873
	    // selector), we skip the branching: we ONLY allow the numeric part to mean                                 // 874
	    // "look up this index" in that case, not "also look up this index in all                                   // 875
	    // the elements of the array".                                                                              // 876
	    if (isArray(firstLevel) && !(nextPartIsNumeric && options.forSort)) {                                       // 877
	      _.each(firstLevel, function (branch, arrayIndex) {                                                        // 878
	        if (isPlainObject(branch)) {                                                                            // 879
	          appendToResult(lookupRest(                                                                            // 880
	            branch,                                                                                             // 881
	            arrayIndices.concat(arrayIndex)));                                                                  // 882
	        }                                                                                                       // 883
	      });                                                                                                       // 884
	    }                                                                                                           // 885
	                                                                                                                // 886
	    return result;                                                                                              // 887
	  };                                                                                                            // 888
	};                                                                                                              // 889
	MinimongoTest.makeLookupFunction = makeLookupFunction;                                                          // 890
	                                                                                                                // 891
	expandArraysInBranches = function (branches, skipTheArrays) {                                                   // 892
	  var branchesOut = [];                                                                                         // 893
	  _.each(branches, function (branch) {                                                                          // 894
	    var thisIsArray = isArray(branch.value);                                                                    // 895
	    // We include the branch itself, *UNLESS* we it's an array that we're going                                 // 896
	    // to iterate and we're told to skip arrays.  (That's right, we include some                                // 897
	    // arrays even skipTheArrays is true: these are arrays that were found via                                  // 898
	    // explicit numerical indices.)                                                                             // 899
	    if (!(skipTheArrays && thisIsArray && !branch.dontIterate)) {                                               // 900
	      branchesOut.push({                                                                                        // 901
	        value: branch.value,                                                                                    // 902
	        arrayIndices: branch.arrayIndices                                                                       // 903
	      });                                                                                                       // 904
	    }                                                                                                           // 905
	    if (thisIsArray && !branch.dontIterate) {                                                                   // 906
	      _.each(branch.value, function (leaf, i) {                                                                 // 907
	        branchesOut.push({                                                                                      // 908
	          value: leaf,                                                                                          // 909
	          arrayIndices: (branch.arrayIndices || []).concat(i)                                                   // 910
	        });                                                                                                     // 911
	      });                                                                                                       // 912
	    }                                                                                                           // 913
	  });                                                                                                           // 914
	  return branchesOut;                                                                                           // 915
	};                                                                                                              // 916
	                                                                                                                // 917
	var nothingMatcher = function (docOrBranchedValues) {                                                           // 918
	  return {result: false};                                                                                       // 919
	};                                                                                                              // 920
	                                                                                                                // 921
	var everythingMatcher = function (docOrBranchedValues) {                                                        // 922
	  return {result: true};                                                                                        // 923
	};                                                                                                              // 924
	                                                                                                                // 925
	                                                                                                                // 926
	// NB: We are cheating and using this function to implement "AND" for both                                      // 927
	// "document matchers" and "branched matchers". They both return result objects                                 // 928
	// but the argument is different: for the former it's a whole doc, whereas for                                  // 929
	// the latter it's an array of "branched values".                                                               // 930
	var andSomeMatchers = function (subMatchers) {                                                                  // 931
	  if (subMatchers.length === 0)                                                                                 // 932
	    return everythingMatcher;                                                                                   // 933
	  if (subMatchers.length === 1)                                                                                 // 934
	    return subMatchers[0];                                                                                      // 935
	                                                                                                                // 936
	  return function (docOrBranches) {                                                                             // 937
	    var ret = {};                                                                                               // 938
	    ret.result = _.all(subMatchers, function (f) {                                                              // 939
	      var subResult = f(docOrBranches);                                                                         // 940
	      // Copy a 'distance' number out of the first sub-matcher that has                                         // 941
	      // one. Yes, this means that if there are multiple $near fields in a                                      // 942
	      // query, something arbitrary happens; this appears to be consistent with                                 // 943
	      // Mongo.                                                                                                 // 944
	      if (subResult.result && subResult.distance !== undefined                                                  // 945
	          && ret.distance === undefined) {                                                                      // 946
	        ret.distance = subResult.distance;                                                                      // 947
	      }                                                                                                         // 948
	      // Similarly, propagate arrayIndices from sub-matchers... but to match                                    // 949
	      // MongoDB behavior, this time the *last* sub-matcher with arrayIndices                                   // 950
	      // wins.                                                                                                  // 951
	      if (subResult.result && subResult.arrayIndices) {                                                         // 952
	        ret.arrayIndices = subResult.arrayIndices;                                                              // 953
	      }                                                                                                         // 954
	      return subResult.result;                                                                                  // 955
	    });                                                                                                         // 956
	                                                                                                                // 957
	    // If we didn't actually match, forget any extra metadata we came up with.                                  // 958
	    if (!ret.result) {                                                                                          // 959
	      delete ret.distance;                                                                                      // 960
	      delete ret.arrayIndices;                                                                                  // 961
	    }                                                                                                           // 962
	    return ret;                                                                                                 // 963
	  };                                                                                                            // 964
	};                                                                                                              // 965
	                                                                                                                // 966
	var andDocumentMatchers = andSomeMatchers;                                                                      // 967
	var andBranchedMatchers = andSomeMatchers;                                                                      // 968
	                                                                                                                // 969
	                                                                                                                // 970
	// helpers used by compiled selector code                                                                       // 971
	LocalCollection._f = {                                                                                          // 972
	  // XXX for _all and _in, consider building 'inquery' at compile time..                                        // 973
	                                                                                                                // 974
	  _type: function (v) {                                                                                         // 975
	    if (typeof v === "number")                                                                                  // 976
	      return 1;                                                                                                 // 977
	    if (typeof v === "string")                                                                                  // 978
	      return 2;                                                                                                 // 979
	    if (typeof v === "boolean")                                                                                 // 980
	      return 8;                                                                                                 // 981
	    if (isArray(v))                                                                                             // 982
	      return 4;                                                                                                 // 983
	    if (v === null)                                                                                             // 984
	      return 10;                                                                                                // 985
	    if (v instanceof RegExp)                                                                                    // 986
	      // note that typeof(/x/) === "object"                                                                     // 987
	      return 11;                                                                                                // 988
	    if (typeof v === "function")                                                                                // 989
	      return 13;                                                                                                // 990
	    if (v instanceof Date)                                                                                      // 991
	      return 9;                                                                                                 // 992
	    if (EJSON.isBinary(v))                                                                                      // 993
	      return 5;                                                                                                 // 994
	    if (v instanceof MongoID.ObjectID)                                                                          // 995
	      return 7;                                                                                                 // 996
	    return 3; // object                                                                                         // 997
	                                                                                                                // 998
	    // XXX support some/all of these:                                                                           // 999
	    // 14, symbol                                                                                               // 1000
	    // 15, javascript code with scope                                                                           // 1001
	    // 16, 18: 32-bit/64-bit integer                                                                            // 1002
	    // 17, timestamp                                                                                            // 1003
	    // 255, minkey                                                                                              // 1004
	    // 127, maxkey                                                                                              // 1005
	  },                                                                                                            // 1006
	                                                                                                                // 1007
	  // deep equality test: use for literal document and array matches                                             // 1008
	  _equal: function (a, b) {                                                                                     // 1009
	    return EJSON.equals(a, b, {keyOrderSensitive: true});                                                       // 1010
	  },                                                                                                            // 1011
	                                                                                                                // 1012
	  // maps a type code to a value that can be used to sort values of                                             // 1013
	  // different types                                                                                            // 1014
	  _typeorder: function (t) {                                                                                    // 1015
	    // http://www.mongodb.org/display/DOCS/What+is+the+Compare+Order+for+BSON+Types                             // 1016
	    // XXX what is the correct sort position for Javascript code?                                               // 1017
	    // ('100' in the matrix below)                                                                              // 1018
	    // XXX minkey/maxkey                                                                                        // 1019
	    return [-1,  // (not a type)                                                                                // 1020
	            1,   // number                                                                                      // 1021
	            2,   // string                                                                                      // 1022
	            3,   // object                                                                                      // 1023
	            4,   // array                                                                                       // 1024
	            5,   // binary                                                                                      // 1025
	            -1,  // deprecated                                                                                  // 1026
	            6,   // ObjectID                                                                                    // 1027
	            7,   // bool                                                                                        // 1028
	            8,   // Date                                                                                        // 1029
	            0,   // null                                                                                        // 1030
	            9,   // RegExp                                                                                      // 1031
	            -1,  // deprecated                                                                                  // 1032
	            100, // JS code                                                                                     // 1033
	            2,   // deprecated (symbol)                                                                         // 1034
	            100, // JS code                                                                                     // 1035
	            1,   // 32-bit int                                                                                  // 1036
	            8,   // Mongo timestamp                                                                             // 1037
	            1    // 64-bit int                                                                                  // 1038
	           ][t];                                                                                                // 1039
	  },                                                                                                            // 1040
	                                                                                                                // 1041
	  // compare two values of unknown type according to BSON ordering                                              // 1042
	  // semantics. (as an extension, consider 'undefined' to be less than                                          // 1043
	  // any other value.) return negative if a is less, positive if b is                                           // 1044
	  // less, or 0 if equal                                                                                        // 1045
	  _cmp: function (a, b) {                                                                                       // 1046
	    if (a === undefined)                                                                                        // 1047
	      return b === undefined ? 0 : -1;                                                                          // 1048
	    if (b === undefined)                                                                                        // 1049
	      return 1;                                                                                                 // 1050
	    var ta = LocalCollection._f._type(a);                                                                       // 1051
	    var tb = LocalCollection._f._type(b);                                                                       // 1052
	    var oa = LocalCollection._f._typeorder(ta);                                                                 // 1053
	    var ob = LocalCollection._f._typeorder(tb);                                                                 // 1054
	    if (oa !== ob)                                                                                              // 1055
	      return oa < ob ? -1 : 1;                                                                                  // 1056
	    if (ta !== tb)                                                                                              // 1057
	      // XXX need to implement this if we implement Symbol or integers, or                                      // 1058
	      // Timestamp                                                                                              // 1059
	      throw Error("Missing type coercion logic in _cmp");                                                       // 1060
	    if (ta === 7) { // ObjectID                                                                                 // 1061
	      // Convert to string.                                                                                     // 1062
	      ta = tb = 2;                                                                                              // 1063
	      a = a.toHexString();                                                                                      // 1064
	      b = b.toHexString();                                                                                      // 1065
	    }                                                                                                           // 1066
	    if (ta === 9) { // Date                                                                                     // 1067
	      // Convert to millis.                                                                                     // 1068
	      ta = tb = 1;                                                                                              // 1069
	      a = a.getTime();                                                                                          // 1070
	      b = b.getTime();                                                                                          // 1071
	    }                                                                                                           // 1072
	                                                                                                                // 1073
	    if (ta === 1) // double                                                                                     // 1074
	      return a - b;                                                                                             // 1075
	    if (tb === 2) // string                                                                                     // 1076
	      return a < b ? -1 : (a === b ? 0 : 1);                                                                    // 1077
	    if (ta === 3) { // Object                                                                                   // 1078
	      // this could be much more efficient in the expected case ...                                             // 1079
	      var to_array = function (obj) {                                                                           // 1080
	        var ret = [];                                                                                           // 1081
	        for (var key in obj) {                                                                                  // 1082
	          ret.push(key);                                                                                        // 1083
	          ret.push(obj[key]);                                                                                   // 1084
	        }                                                                                                       // 1085
	        return ret;                                                                                             // 1086
	      };                                                                                                        // 1087
	      return LocalCollection._f._cmp(to_array(a), to_array(b));                                                 // 1088
	    }                                                                                                           // 1089
	    if (ta === 4) { // Array                                                                                    // 1090
	      for (var i = 0; ; i++) {                                                                                  // 1091
	        if (i === a.length)                                                                                     // 1092
	          return (i === b.length) ? 0 : -1;                                                                     // 1093
	        if (i === b.length)                                                                                     // 1094
	          return 1;                                                                                             // 1095
	        var s = LocalCollection._f._cmp(a[i], b[i]);                                                            // 1096
	        if (s !== 0)                                                                                            // 1097
	          return s;                                                                                             // 1098
	      }                                                                                                         // 1099
	    }                                                                                                           // 1100
	    if (ta === 5) { // binary                                                                                   // 1101
	      // Surprisingly, a small binary blob is always less than a large one in                                   // 1102
	      // Mongo.                                                                                                 // 1103
	      if (a.length !== b.length)                                                                                // 1104
	        return a.length - b.length;                                                                             // 1105
	      for (i = 0; i < a.length; i++) {                                                                          // 1106
	        if (a[i] < b[i])                                                                                        // 1107
	          return -1;                                                                                            // 1108
	        if (a[i] > b[i])                                                                                        // 1109
	          return 1;                                                                                             // 1110
	      }                                                                                                         // 1111
	      return 0;                                                                                                 // 1112
	    }                                                                                                           // 1113
	    if (ta === 8) { // boolean                                                                                  // 1114
	      if (a) return b ? 0 : 1;                                                                                  // 1115
	      return b ? -1 : 0;                                                                                        // 1116
	    }                                                                                                           // 1117
	    if (ta === 10) // null                                                                                      // 1118
	      return 0;                                                                                                 // 1119
	    if (ta === 11) // regexp                                                                                    // 1120
	      throw Error("Sorting not supported on regular expression"); // XXX                                        // 1121
	    // 13: javascript code                                                                                      // 1122
	    // 14: symbol                                                                                               // 1123
	    // 15: javascript code with scope                                                                           // 1124
	    // 16: 32-bit integer                                                                                       // 1125
	    // 17: timestamp                                                                                            // 1126
	    // 18: 64-bit integer                                                                                       // 1127
	    // 255: minkey                                                                                              // 1128
	    // 127: maxkey                                                                                              // 1129
	    if (ta === 13) // javascript code                                                                           // 1130
	      throw Error("Sorting not supported on Javascript code"); // XXX                                           // 1131
	    throw Error("Unknown type to sort");                                                                        // 1132
	  }                                                                                                             // 1133
	};                                                                                                              // 1134
	                                                                                                                // 1135
	// Oddball function used by upsert.                                                                             // 1136
	LocalCollection._removeDollarOperators = function (selector) {                                                  // 1137
	  var selectorDoc = {};                                                                                         // 1138
	  for (var k in selector)                                                                                       // 1139
	    if (k.substr(0, 1) !== '$')                                                                                 // 1140
	      selectorDoc[k] = selector[k];                                                                             // 1141
	  return selectorDoc;                                                                                           // 1142
	};                                                                                                              // 1143
	                                                                                                                // 1144
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                              //
	// packages/minimongo/sort.js                                                                                   //
	//                                                                                                              //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                //
	// Give a sort spec, which can be in any of these forms:                                                        // 1
	//   {"key1": 1, "key2": -1}                                                                                    // 2
	//   [["key1", "asc"], ["key2", "desc"]]                                                                        // 3
	//   ["key1", ["key2", "desc"]]                                                                                 // 4
	//                                                                                                              // 5
	// (.. with the first form being dependent on the key enumeration                                               // 6
	// behavior of your javascript VM, which usually does what you mean in                                          // 7
	// this case if the key names don't look like integers ..)                                                      // 8
	//                                                                                                              // 9
	// return a function that takes two objects, and returns -1 if the                                              // 10
	// first object comes first in order, 1 if the second object comes                                              // 11
	// first, or 0 if neither object comes before the other.                                                        // 12
	                                                                                                                // 13
	Minimongo.Sorter = function (spec, options) {                                                                   // 14
	  var self = this;                                                                                              // 15
	  options = options || {};                                                                                      // 16
	                                                                                                                // 17
	  self._sortSpecParts = [];                                                                                     // 18
	  self._sortFunction = null;                                                                                    // 19
	                                                                                                                // 20
	  var addSpecPart = function (path, ascending) {                                                                // 21
	    if (!path)                                                                                                  // 22
	      throw Error("sort keys must be non-empty");                                                               // 23
	    if (path.charAt(0) === '$')                                                                                 // 24
	      throw Error("unsupported sort key: " + path);                                                             // 25
	    self._sortSpecParts.push({                                                                                  // 26
	      path: path,                                                                                               // 27
	      lookup: makeLookupFunction(path, {forSort: true}),                                                        // 28
	      ascending: ascending                                                                                      // 29
	    });                                                                                                         // 30
	  };                                                                                                            // 31
	                                                                                                                // 32
	  if (spec instanceof Array) {                                                                                  // 33
	    for (var i = 0; i < spec.length; i++) {                                                                     // 34
	      if (typeof spec[i] === "string") {                                                                        // 35
	        addSpecPart(spec[i], true);                                                                             // 36
	      } else {                                                                                                  // 37
	        addSpecPart(spec[i][0], spec[i][1] !== "desc");                                                         // 38
	      }                                                                                                         // 39
	    }                                                                                                           // 40
	  } else if (typeof spec === "object") {                                                                        // 41
	    _.each(spec, function (value, key) {                                                                        // 42
	      addSpecPart(key, value >= 0);                                                                             // 43
	    });                                                                                                         // 44
	  } else if (typeof spec === "function") {                                                                      // 45
	    self._sortFunction = spec;                                                                                  // 46
	  } else {                                                                                                      // 47
	    throw Error("Bad sort specification: " + JSON.stringify(spec));                                             // 48
	  }                                                                                                             // 49
	                                                                                                                // 50
	  // If a function is specified for sorting, we skip the rest.                                                  // 51
	  if (self._sortFunction)                                                                                       // 52
	    return;                                                                                                     // 53
	                                                                                                                // 54
	  // To implement affectedByModifier, we piggy-back on top of Matcher's                                         // 55
	  // affectedByModifier code; we create a selector that is affected by the same                                 // 56
	  // modifiers as this sort order. This is only implemented on the server.                                      // 57
	  if (self.affectedByModifier) {                                                                                // 58
	    var selector = {};                                                                                          // 59
	    _.each(self._sortSpecParts, function (spec) {                                                               // 60
	      selector[spec.path] = 1;                                                                                  // 61
	    });                                                                                                         // 62
	    self._selectorForAffectedByModifier = new Minimongo.Matcher(selector);                                      // 63
	  }                                                                                                             // 64
	                                                                                                                // 65
	  self._keyComparator = composeComparators(                                                                     // 66
	    _.map(self._sortSpecParts, function (spec, i) {                                                             // 67
	      return self._keyFieldComparator(i);                                                                       // 68
	    }));                                                                                                        // 69
	                                                                                                                // 70
	  // If you specify a matcher for this Sorter, _keyFilter may be set to a                                       // 71
	  // function which selects whether or not a given "sort key" (tuple of values                                  // 72
	  // for the different sort spec fields) is compatible with the selector.                                       // 73
	  self._keyFilter = null;                                                                                       // 74
	  options.matcher && self._useWithMatcher(options.matcher);                                                     // 75
	};                                                                                                              // 76
	                                                                                                                // 77
	// In addition to these methods, sorter_project.js defines combineIntoProjection                                // 78
	// on the server only.                                                                                          // 79
	_.extend(Minimongo.Sorter.prototype, {                                                                          // 80
	  getComparator: function (options) {                                                                           // 81
	    var self = this;                                                                                            // 82
	                                                                                                                // 83
	    // If we have no distances, just use the comparator from the source                                         // 84
	    // specification (which defaults to "everything is equal".                                                  // 85
	    if (!options || !options.distances) {                                                                       // 86
	      return self._getBaseComparator();                                                                         // 87
	    }                                                                                                           // 88
	                                                                                                                // 89
	    var distances = options.distances;                                                                          // 90
	                                                                                                                // 91
	    // Return a comparator which first tries the sort specification, and if that                                // 92
	    // says "it's equal", breaks ties using $near distances.                                                    // 93
	    return composeComparators([self._getBaseComparator(), function (a, b) {                                     // 94
	      if (!distances.has(a._id))                                                                                // 95
	        throw Error("Missing distance for " + a._id);                                                           // 96
	      if (!distances.has(b._id))                                                                                // 97
	        throw Error("Missing distance for " + b._id);                                                           // 98
	      return distances.get(a._id) - distances.get(b._id);                                                       // 99
	    }]);                                                                                                        // 100
	  },                                                                                                            // 101
	                                                                                                                // 102
	  _getPaths: function () {                                                                                      // 103
	    var self = this;                                                                                            // 104
	    return _.pluck(self._sortSpecParts, 'path');                                                                // 105
	  },                                                                                                            // 106
	                                                                                                                // 107
	  // Finds the minimum key from the doc, according to the sort specs.  (We say                                  // 108
	  // "minimum" here but this is with respect to the sort spec, so "descending"                                  // 109
	  // sort fields mean we're finding the max for that field.)                                                    // 110
	  //                                                                                                            // 111
	  // Note that this is NOT "find the minimum value of the first field, the                                      // 112
	  // minimum value of the second field, etc"... it's "choose the                                                // 113
	  // lexicographically minimum value of the key vector, allowing only keys which                                // 114
	  // you can find along the same paths".  ie, for a doc {a: [{x: 0, y: 5}, {x:                                  // 115
	  // 1, y: 3}]} with sort spec {'a.x': 1, 'a.y': 1}, the only keys are [0,5] and                                // 116
	  // [1,3], and the minimum key is [0,5]; notably, [0,3] is NOT a key.                                          // 117
	  _getMinKeyFromDoc: function (doc) {                                                                           // 118
	    var self = this;                                                                                            // 119
	    var minKey = null;                                                                                          // 120
	                                                                                                                // 121
	    self._generateKeysFromDoc(doc, function (key) {                                                             // 122
	      if (!self._keyCompatibleWithSelector(key))                                                                // 123
	        return;                                                                                                 // 124
	                                                                                                                // 125
	      if (minKey === null) {                                                                                    // 126
	        minKey = key;                                                                                           // 127
	        return;                                                                                                 // 128
	      }                                                                                                         // 129
	      if (self._compareKeys(key, minKey) < 0) {                                                                 // 130
	        minKey = key;                                                                                           // 131
	      }                                                                                                         // 132
	    });                                                                                                         // 133
	                                                                                                                // 134
	    // This could happen if our key filter somehow filters out all the keys even                                // 135
	    // though somehow the selector matches.                                                                     // 136
	    if (minKey === null)                                                                                        // 137
	      throw Error("sort selector found no keys in doc?");                                                       // 138
	    return minKey;                                                                                              // 139
	  },                                                                                                            // 140
	                                                                                                                // 141
	  _keyCompatibleWithSelector: function (key) {                                                                  // 142
	    var self = this;                                                                                            // 143
	    return !self._keyFilter || self._keyFilter(key);                                                            // 144
	  },                                                                                                            // 145
	                                                                                                                // 146
	  // Iterates over each possible "key" from doc (ie, over each branch), calling                                 // 147
	  // 'cb' with the key.                                                                                         // 148
	  _generateKeysFromDoc: function (doc, cb) {                                                                    // 149
	    var self = this;                                                                                            // 150
	                                                                                                                // 151
	    if (self._sortSpecParts.length === 0)                                                                       // 152
	      throw new Error("can't generate keys without a spec");                                                    // 153
	                                                                                                                // 154
	    // maps index -> ({'' -> value} or {path -> value})                                                         // 155
	    var valuesByIndexAndPath = [];                                                                              // 156
	                                                                                                                // 157
	    var pathFromIndices = function (indices) {                                                                  // 158
	      return indices.join(',') + ',';                                                                           // 159
	    };                                                                                                          // 160
	                                                                                                                // 161
	    var knownPaths = null;                                                                                      // 162
	                                                                                                                // 163
	    _.each(self._sortSpecParts, function (spec, whichField) {                                                   // 164
	      // Expand any leaf arrays that we find, and ignore those arrays                                           // 165
	      // themselves.  (We never sort based on an array itself.)                                                 // 166
	      var branches = expandArraysInBranches(spec.lookup(doc), true);                                            // 167
	                                                                                                                // 168
	      // If there are no values for a key (eg, key goes to an empty array),                                     // 169
	      // pretend we found one null value.                                                                       // 170
	      if (!branches.length)                                                                                     // 171
	        branches = [{value: null}];                                                                             // 172
	                                                                                                                // 173
	      var usedPaths = false;                                                                                    // 174
	      valuesByIndexAndPath[whichField] = {};                                                                    // 175
	      _.each(branches, function (branch) {                                                                      // 176
	        if (!branch.arrayIndices) {                                                                             // 177
	          // If there are no array indices for a branch, then it must be the                                    // 178
	          // only branch, because the only thing that produces multiple branches                                // 179
	          // is the use of arrays.                                                                              // 180
	          if (branches.length > 1)                                                                              // 181
	            throw Error("multiple branches but no array used?");                                                // 182
	          valuesByIndexAndPath[whichField][''] = branch.value;                                                  // 183
	          return;                                                                                               // 184
	        }                                                                                                       // 185
	                                                                                                                // 186
	        usedPaths = true;                                                                                       // 187
	        var path = pathFromIndices(branch.arrayIndices);                                                        // 188
	        if (_.has(valuesByIndexAndPath[whichField], path))                                                      // 189
	          throw Error("duplicate path: " + path);                                                               // 190
	        valuesByIndexAndPath[whichField][path] = branch.value;                                                  // 191
	                                                                                                                // 192
	        // If two sort fields both go into arrays, they have to go into the                                     // 193
	        // exact same arrays and we have to find the same paths.  This is                                       // 194
	        // roughly the same condition that makes MongoDB throw this strange                                     // 195
	        // error message.  eg, the main thing is that if sort spec is {a: 1,                                    // 196
	        // b:1} then a and b cannot both be arrays.                                                             // 197
	        //                                                                                                      // 198
	        // (In MongoDB it seems to be OK to have {a: 1, 'a.x.y': 1} where 'a'                                   // 199
	        // and 'a.x.y' are both arrays, but we don't allow this for now.                                        // 200
	        // #NestedArraySort                                                                                     // 201
	        // XXX achieve full compatibility here                                                                  // 202
	        if (knownPaths && !_.has(knownPaths, path)) {                                                           // 203
	          throw Error("cannot index parallel arrays");                                                          // 204
	        }                                                                                                       // 205
	      });                                                                                                       // 206
	                                                                                                                // 207
	      if (knownPaths) {                                                                                         // 208
	        // Similarly to above, paths must match everywhere, unless this is a                                    // 209
	        // non-array field.                                                                                     // 210
	        if (!_.has(valuesByIndexAndPath[whichField], '') &&                                                     // 211
	            _.size(knownPaths) !== _.size(valuesByIndexAndPath[whichField])) {                                  // 212
	          throw Error("cannot index parallel arrays!");                                                         // 213
	        }                                                                                                       // 214
	      } else if (usedPaths) {                                                                                   // 215
	        knownPaths = {};                                                                                        // 216
	        _.each(valuesByIndexAndPath[whichField], function (x, path) {                                           // 217
	          knownPaths[path] = true;                                                                              // 218
	        });                                                                                                     // 219
	      }                                                                                                         // 220
	    });                                                                                                         // 221
	                                                                                                                // 222
	    if (!knownPaths) {                                                                                          // 223
	      // Easy case: no use of arrays.                                                                           // 224
	      var soleKey = _.map(valuesByIndexAndPath, function (values) {                                             // 225
	        if (!_.has(values, ''))                                                                                 // 226
	          throw Error("no value in sole key case?");                                                            // 227
	        return values[''];                                                                                      // 228
	      });                                                                                                       // 229
	      cb(soleKey);                                                                                              // 230
	      return;                                                                                                   // 231
	    }                                                                                                           // 232
	                                                                                                                // 233
	    _.each(knownPaths, function (x, path) {                                                                     // 234
	      var key = _.map(valuesByIndexAndPath, function (values) {                                                 // 235
	        if (_.has(values, ''))                                                                                  // 236
	          return values[''];                                                                                    // 237
	        if (!_.has(values, path))                                                                               // 238
	          throw Error("missing path?");                                                                         // 239
	        return values[path];                                                                                    // 240
	      });                                                                                                       // 241
	      cb(key);                                                                                                  // 242
	    });                                                                                                         // 243
	  },                                                                                                            // 244
	                                                                                                                // 245
	  // Takes in two keys: arrays whose lengths match the number of spec                                           // 246
	  // parts. Returns negative, 0, or positive based on using the sort spec to                                    // 247
	  // compare fields.                                                                                            // 248
	  _compareKeys: function (key1, key2) {                                                                         // 249
	    var self = this;                                                                                            // 250
	    if (key1.length !== self._sortSpecParts.length ||                                                           // 251
	        key2.length !== self._sortSpecParts.length) {                                                           // 252
	      throw Error("Key has wrong length");                                                                      // 253
	    }                                                                                                           // 254
	                                                                                                                // 255
	    return self._keyComparator(key1, key2);                                                                     // 256
	  },                                                                                                            // 257
	                                                                                                                // 258
	  // Given an index 'i', returns a comparator that compares two key arrays based                                // 259
	  // on field 'i'.                                                                                              // 260
	  _keyFieldComparator: function (i) {                                                                           // 261
	    var self = this;                                                                                            // 262
	    var invert = !self._sortSpecParts[i].ascending;                                                             // 263
	    return function (key1, key2) {                                                                              // 264
	      var compare = LocalCollection._f._cmp(key1[i], key2[i]);                                                  // 265
	      if (invert)                                                                                               // 266
	        compare = -compare;                                                                                     // 267
	      return compare;                                                                                           // 268
	    };                                                                                                          // 269
	  },                                                                                                            // 270
	                                                                                                                // 271
	  // Returns a comparator that represents the sort specification (but not                                       // 272
	  // including a possible geoquery distance tie-breaker).                                                       // 273
	  _getBaseComparator: function () {                                                                             // 274
	    var self = this;                                                                                            // 275
	                                                                                                                // 276
	    if (self._sortFunction)                                                                                     // 277
	      return self._sortFunction;                                                                                // 278
	                                                                                                                // 279
	    // If we're only sorting on geoquery distance and no specs, just say                                        // 280
	    // everything is equal.                                                                                     // 281
	    if (!self._sortSpecParts.length) {                                                                          // 282
	      return function (doc1, doc2) {                                                                            // 283
	        return 0;                                                                                               // 284
	      };                                                                                                        // 285
	    }                                                                                                           // 286
	                                                                                                                // 287
	    return function (doc1, doc2) {                                                                              // 288
	      var key1 = self._getMinKeyFromDoc(doc1);                                                                  // 289
	      var key2 = self._getMinKeyFromDoc(doc2);                                                                  // 290
	      return self._compareKeys(key1, key2);                                                                     // 291
	    };                                                                                                          // 292
	  },                                                                                                            // 293
	                                                                                                                // 294
	  // In MongoDB, if you have documents                                                                          // 295
	  //    {_id: 'x', a: [1, 10]} and                                                                              // 296
	  //    {_id: 'y', a: [5, 15]},                                                                                 // 297
	  // then C.find({}, {sort: {a: 1}}) puts x before y (1 comes before 5).                                        // 298
	  // But  C.find({a: {$gt: 3}}, {sort: {a: 1}}) puts y before x (1 does not                                     // 299
	  // match the selector, and 5 comes before 10).                                                                // 300
	  //                                                                                                            // 301
	  // The way this works is pretty subtle!  For example, if the documents                                        // 302
	  // are instead {_id: 'x', a: [{x: 1}, {x: 10}]}) and                                                          // 303
	  //             {_id: 'y', a: [{x: 5}, {x: 15}]}),                                                             // 304
	  // then C.find({'a.x': {$gt: 3}}, {sort: {'a.x': 1}}) and                                                     // 305
	  //      C.find({a: {$elemMatch: {x: {$gt: 3}}}}, {sort: {'a.x': 1}})                                          // 306
	  // both follow this rule (y before x).  (ie, you do have to apply this                                        // 307
	  // through $elemMatch.)                                                                                       // 308
	  //                                                                                                            // 309
	  // So if you pass a matcher to this sorter's constructor, we will attempt to                                  // 310
	  // skip sort keys that don't match the selector. The logic here is pretty                                     // 311
	  // subtle and undocumented; we've gotten as close as we can figure out based                                  // 312
	  // on our understanding of Mongo's behavior.                                                                  // 313
	  _useWithMatcher: function (matcher) {                                                                         // 314
	    var self = this;                                                                                            // 315
	                                                                                                                // 316
	    if (self._keyFilter)                                                                                        // 317
	      throw Error("called _useWithMatcher twice?");                                                             // 318
	                                                                                                                // 319
	    // If we are only sorting by distance, then we're not going to bother to                                    // 320
	    // build a key filter.                                                                                      // 321
	    // XXX figure out how geoqueries interact with this stuff                                                   // 322
	    if (_.isEmpty(self._sortSpecParts))                                                                         // 323
	      return;                                                                                                   // 324
	                                                                                                                // 325
	    var selector = matcher._selector;                                                                           // 326
	                                                                                                                // 327
	    // If the user just passed a literal function to find(), then we can't get a                                // 328
	    // key filter from it.                                                                                      // 329
	    if (selector instanceof Function)                                                                           // 330
	      return;                                                                                                   // 331
	                                                                                                                // 332
	    var constraintsByPath = {};                                                                                 // 333
	    _.each(self._sortSpecParts, function (spec, i) {                                                            // 334
	      constraintsByPath[spec.path] = [];                                                                        // 335
	    });                                                                                                         // 336
	                                                                                                                // 337
	    _.each(selector, function (subSelector, key) {                                                              // 338
	      // XXX support $and and $or                                                                               // 339
	                                                                                                                // 340
	      var constraints = constraintsByPath[key];                                                                 // 341
	      if (!constraints)                                                                                         // 342
	        return;                                                                                                 // 343
	                                                                                                                // 344
	      // XXX it looks like the real MongoDB implementation isn't "does the                                      // 345
	      // regexp match" but "does the value fall into a range named by the                                       // 346
	      // literal prefix of the regexp", ie "foo" in /^foo(bar|baz)+/  But                                       // 347
	      // "does the regexp match" is a good approximation.                                                       // 348
	      if (subSelector instanceof RegExp) {                                                                      // 349
	        // As far as we can tell, using either of the options that both we and                                  // 350
	        // MongoDB support ('i' and 'm') disables use of the key filter. This                                   // 351
	        // makes sense: MongoDB mostly appears to be calculating ranges of an                                   // 352
	        // index to use, which means it only cares about regexps that match                                     // 353
	        // one range (with a literal prefix), and both 'i' and 'm' prevent the                                  // 354
	        // literal prefix of the regexp from actually meaning one range.                                        // 355
	        if (subSelector.ignoreCase || subSelector.multiline)                                                    // 356
	          return;                                                                                               // 357
	        constraints.push(regexpElementMatcher(subSelector));                                                    // 358
	        return;                                                                                                 // 359
	      }                                                                                                         // 360
	                                                                                                                // 361
	      if (isOperatorObject(subSelector)) {                                                                      // 362
	        _.each(subSelector, function (operand, operator) {                                                      // 363
	          if (_.contains(['$lt', '$lte', '$gt', '$gte'], operator)) {                                           // 364
	            // XXX this depends on us knowing that these operators don't use any                                // 365
	            // of the arguments to compileElementSelector other than operand.                                   // 366
	            constraints.push(                                                                                   // 367
	              ELEMENT_OPERATORS[operator].compileElementSelector(operand));                                     // 368
	          }                                                                                                     // 369
	                                                                                                                // 370
	          // See comments in the RegExp block above.                                                            // 371
	          if (operator === '$regex' && !subSelector.$options) {                                                 // 372
	            constraints.push(                                                                                   // 373
	              ELEMENT_OPERATORS.$regex.compileElementSelector(                                                  // 374
	                operand, subSelector));                                                                         // 375
	          }                                                                                                     // 376
	                                                                                                                // 377
	          // XXX support {$exists: true}, $mod, $type, $in, $elemMatch                                          // 378
	        });                                                                                                     // 379
	        return;                                                                                                 // 380
	      }                                                                                                         // 381
	                                                                                                                // 382
	      // OK, it's an equality thing.                                                                            // 383
	      constraints.push(equalityElementMatcher(subSelector));                                                    // 384
	    });                                                                                                         // 385
	                                                                                                                // 386
	    // It appears that the first sort field is treated differently from the                                     // 387
	    // others; we shouldn't create a key filter unless the first sort field is                                  // 388
	    // restricted, though after that point we can restrict the other sort fields                                // 389
	    // or not as we wish.                                                                                       // 390
	    if (_.isEmpty(constraintsByPath[self._sortSpecParts[0].path]))                                              // 391
	      return;                                                                                                   // 392
	                                                                                                                // 393
	    self._keyFilter = function (key) {                                                                          // 394
	      return _.all(self._sortSpecParts, function (specPart, index) {                                            // 395
	        return _.all(constraintsByPath[specPart.path], function (f) {                                           // 396
	          return f(key[index]);                                                                                 // 397
	        });                                                                                                     // 398
	      });                                                                                                       // 399
	    };                                                                                                          // 400
	  }                                                                                                             // 401
	});                                                                                                             // 402
	                                                                                                                // 403
	// Given an array of comparators                                                                                // 404
	// (functions (a,b)->(negative or positive or zero)), returns a single                                          // 405
	// comparator which uses each comparator in order and returns the first                                         // 406
	// non-zero value.                                                                                              // 407
	var composeComparators = function (comparatorArray) {                                                           // 408
	  return function (a, b) {                                                                                      // 409
	    for (var i = 0; i < comparatorArray.length; ++i) {                                                          // 410
	      var compare = comparatorArray[i](a, b);                                                                   // 411
	      if (compare !== 0)                                                                                        // 412
	        return compare;                                                                                         // 413
	    }                                                                                                           // 414
	    return 0;                                                                                                   // 415
	  };                                                                                                            // 416
	};                                                                                                              // 417
	                                                                                                                // 418
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                              //
	// packages/minimongo/projection.js                                                                             //
	//                                                                                                              //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                //
	// Knows how to compile a fields projection to a predicate function.                                            // 1
	// @returns - Function: a closure that filters out an object according to the                                   // 2
	//            fields projection rules:                                                                          // 3
	//            @param obj - Object: MongoDB-styled document                                                      // 4
	//            @returns - Object: a document with the fields filtered out                                        // 5
	//                       according to projection rules. Doesn't retain subfields                                // 6
	//                       of passed argument.                                                                    // 7
	LocalCollection._compileProjection = function (fields) {                                                        // 8
	  LocalCollection._checkSupportedProjection(fields);                                                            // 9
	                                                                                                                // 10
	  var _idProjection = _.isUndefined(fields._id) ? true : fields._id;                                            // 11
	  var details = projectionDetails(fields);                                                                      // 12
	                                                                                                                // 13
	  // returns transformed doc according to ruleTree                                                              // 14
	  var transform = function (doc, ruleTree) {                                                                    // 15
	    // Special case for "sets"                                                                                  // 16
	    if (_.isArray(doc))                                                                                         // 17
	      return _.map(doc, function (subdoc) { return transform(subdoc, ruleTree); });                             // 18
	                                                                                                                // 19
	    var res = details.including ? {} : EJSON.clone(doc);                                                        // 20
	    _.each(ruleTree, function (rule, key) {                                                                     // 21
	      if (!_.has(doc, key))                                                                                     // 22
	        return;                                                                                                 // 23
	      if (_.isObject(rule)) {                                                                                   // 24
	        // For sub-objects/subsets we branch                                                                    // 25
	        if (_.isObject(doc[key]))                                                                               // 26
	          res[key] = transform(doc[key], rule);                                                                 // 27
	        // Otherwise we don't even touch this subfield                                                          // 28
	      } else if (details.including)                                                                             // 29
	        res[key] = EJSON.clone(doc[key]);                                                                       // 30
	      else                                                                                                      // 31
	        delete res[key];                                                                                        // 32
	    });                                                                                                         // 33
	                                                                                                                // 34
	    return res;                                                                                                 // 35
	  };                                                                                                            // 36
	                                                                                                                // 37
	  return function (obj) {                                                                                       // 38
	    var res = transform(obj, details.tree);                                                                     // 39
	                                                                                                                // 40
	    if (_idProjection && _.has(obj, '_id'))                                                                     // 41
	      res._id = obj._id;                                                                                        // 42
	    if (!_idProjection && _.has(res, '_id'))                                                                    // 43
	      delete res._id;                                                                                           // 44
	    return res;                                                                                                 // 45
	  };                                                                                                            // 46
	};                                                                                                              // 47
	                                                                                                                // 48
	// Traverses the keys of passed projection and constructs a tree where all                                      // 49
	// leaves are either all True or all False                                                                      // 50
	// @returns Object:                                                                                             // 51
	//  - tree - Object - tree representation of keys involved in projection                                        // 52
	//  (exception for '_id' as it is a special case handled separately)                                            // 53
	//  - including - Boolean - "take only certain fields" type of projection                                       // 54
	projectionDetails = function (fields) {                                                                         // 55
	  // Find the non-_id keys (_id is handled specially because it is included unless                              // 56
	  // explicitly excluded). Sort the keys, so that our code to detect overlaps                                   // 57
	  // like 'foo' and 'foo.bar' can assume that 'foo' comes first.                                                // 58
	  var fieldsKeys = _.keys(fields).sort();                                                                       // 59
	                                                                                                                // 60
	  // If _id is the only field in the projection, do not remove it, since it is                                  // 61
	  // required to determine if this is an exclusion or exclusion. Also keep an                                   // 62
	  // inclusive _id, since inclusive _id follows the normal rules about mixing                                   // 63
	  // inclusive and exclusive fields. If _id is not the only field in the                                        // 64
	  // projection and is exclusive, remove it so it can be handled later by a                                     // 65
	  // special case, since exclusive _id is always allowed.                                                       // 66
	  if (fieldsKeys.length > 0 &&                                                                                  // 67
	      !(fieldsKeys.length === 1 && fieldsKeys[0] === '_id') &&                                                  // 68
	      !(_.contains(fieldsKeys, '_id') && fields['_id']))                                                        // 69
	    fieldsKeys = _.reject(fieldsKeys, function (key) { return key === '_id'; });                                // 70
	                                                                                                                // 71
	  var including = null; // Unknown                                                                              // 72
	                                                                                                                // 73
	  _.each(fieldsKeys, function (keyPath) {                                                                       // 74
	    var rule = !!fields[keyPath];                                                                               // 75
	    if (including === null)                                                                                     // 76
	      including = rule;                                                                                         // 77
	    if (including !== rule)                                                                                     // 78
	      // This error message is copied from MongoDB shell                                                        // 79
	      throw MinimongoError("You cannot currently mix including and excluding fields.");                         // 80
	  });                                                                                                           // 81
	                                                                                                                // 82
	                                                                                                                // 83
	  var projectionRulesTree = pathsToTree(                                                                        // 84
	    fieldsKeys,                                                                                                 // 85
	    function (path) { return including; },                                                                      // 86
	    function (node, path, fullPath) {                                                                           // 87
	      // Check passed projection fields' keys: If you have two rules such as                                    // 88
	      // 'foo.bar' and 'foo.bar.baz', then the result becomes ambiguous. If                                     // 89
	      // that happens, there is a probability you are doing something wrong,                                    // 90
	      // framework should notify you about such mistake earlier on cursor                                       // 91
	      // compilation step than later during runtime.  Note, that real mongo                                     // 92
	      // doesn't do anything about it and the later rule appears in projection                                  // 93
	      // project, more priority it takes.                                                                       // 94
	      //                                                                                                        // 95
	      // Example, assume following in mongo shell:                                                              // 96
	      // > db.coll.insert({ a: { b: 23, c: 44 } })                                                              // 97
	      // > db.coll.find({}, { 'a': 1, 'a.b': 1 })                                                               // 98
	      // { "_id" : ObjectId("520bfe456024608e8ef24af3"), "a" : { "b" : 23 } }                                   // 99
	      // > db.coll.find({}, { 'a.b': 1, 'a': 1 })                                                               // 100
	      // { "_id" : ObjectId("520bfe456024608e8ef24af3"), "a" : { "b" : 23, "c" : 44 } }                         // 101
	      //                                                                                                        // 102
	      // Note, how second time the return set of keys is different.                                             // 103
	                                                                                                                // 104
	      var currentPath = fullPath;                                                                               // 105
	      var anotherPath = path;                                                                                   // 106
	      throw MinimongoError("both " + currentPath + " and " + anotherPath +                                      // 107
	                           " found in fields option, using both of them may trigger " +                         // 108
	                           "unexpected behavior. Did you mean to use only one of them?");                       // 109
	    });                                                                                                         // 110
	                                                                                                                // 111
	  return {                                                                                                      // 112
	    tree: projectionRulesTree,                                                                                  // 113
	    including: including                                                                                        // 114
	  };                                                                                                            // 115
	};                                                                                                              // 116
	                                                                                                                // 117
	// paths - Array: list of mongo style paths                                                                     // 118
	// newLeafFn - Function: of form function(path) should return a scalar value to                                 // 119
	//                       put into list created for that path                                                    // 120
	// conflictFn - Function: of form function(node, path, fullPath) is called                                      // 121
	//                        when building a tree path for 'fullPath' node on                                      // 122
	//                        'path' was already a leaf with a value. Must return a                                 // 123
	//                        conflict resolution.                                                                  // 124
	// initial tree - Optional Object: starting tree.                                                               // 125
	// @returns - Object: tree represented as a set of nested objects                                               // 126
	pathsToTree = function (paths, newLeafFn, conflictFn, tree) {                                                   // 127
	  tree = tree || {};                                                                                            // 128
	  _.each(paths, function (keyPath) {                                                                            // 129
	    var treePos = tree;                                                                                         // 130
	    var pathArr = keyPath.split('.');                                                                           // 131
	                                                                                                                // 132
	    // use _.all just for iteration with break                                                                  // 133
	    var success = _.all(pathArr.slice(0, -1), function (key, idx) {                                             // 134
	      if (!_.has(treePos, key))                                                                                 // 135
	        treePos[key] = {};                                                                                      // 136
	      else if (!_.isObject(treePos[key])) {                                                                     // 137
	        treePos[key] = conflictFn(treePos[key],                                                                 // 138
	                                  pathArr.slice(0, idx + 1).join('.'),                                          // 139
	                                  keyPath);                                                                     // 140
	        // break out of loop if we are failing for this path                                                    // 141
	        if (!_.isObject(treePos[key]))                                                                          // 142
	          return false;                                                                                         // 143
	      }                                                                                                         // 144
	                                                                                                                // 145
	      treePos = treePos[key];                                                                                   // 146
	      return true;                                                                                              // 147
	    });                                                                                                         // 148
	                                                                                                                // 149
	    if (success) {                                                                                              // 150
	      var lastKey = _.last(pathArr);                                                                            // 151
	      if (!_.has(treePos, lastKey))                                                                             // 152
	        treePos[lastKey] = newLeafFn(keyPath);                                                                  // 153
	      else                                                                                                      // 154
	        treePos[lastKey] = conflictFn(treePos[lastKey], keyPath, keyPath);                                      // 155
	    }                                                                                                           // 156
	  });                                                                                                           // 157
	                                                                                                                // 158
	  return tree;                                                                                                  // 159
	};                                                                                                              // 160
	                                                                                                                // 161
	LocalCollection._checkSupportedProjection = function (fields) {                                                 // 162
	  if (!_.isObject(fields) || _.isArray(fields))                                                                 // 163
	    throw MinimongoError("fields option must be an object");                                                    // 164
	                                                                                                                // 165
	  _.each(fields, function (val, keyPath) {                                                                      // 166
	    if (_.contains(keyPath.split('.'), '$'))                                                                    // 167
	      throw MinimongoError("Minimongo doesn't support $ operator in projections yet.");                         // 168
	    if (typeof val === 'object' && _.intersection(['$elemMatch', '$meta', '$slice'], _.keys(val)).length > 0)   // 169
	      throw MinimongoError("Minimongo doesn't support operators in projections yet.");                          // 170
	    if (_.indexOf([1, 0, true, false], val) === -1)                                                             // 171
	      throw MinimongoError("Projection values should be one of 1, 0, true, or false");                          // 172
	  });                                                                                                           // 173
	};                                                                                                              // 174
	                                                                                                                // 175
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                              //
	// packages/minimongo/modify.js                                                                                 //
	//                                                                                                              //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                //
	// XXX need a strategy for passing the binding of $ into this                                                   // 1
	// function, from the compiled selector                                                                         // 2
	//                                                                                                              // 3
	// maybe just {key.up.to.just.before.dollarsign: array_index}                                                   // 4
	//                                                                                                              // 5
	// XXX atomicity: if one modification fails, do we roll back the whole                                          // 6
	// change?                                                                                                      // 7
	//                                                                                                              // 8
	// options:                                                                                                     // 9
	//   - isInsert is set when _modify is being called to compute the document to                                  // 10
	//     insert as part of an upsert operation. We use this primarily to figure                                   // 11
	//     out when to set the fields in $setOnInsert, if present.                                                  // 12
	LocalCollection._modify = function (doc, mod, options) {                                                        // 13
	  options = options || {};                                                                                      // 14
	  if (!isPlainObject(mod))                                                                                      // 15
	    throw MinimongoError("Modifier must be an object");                                                         // 16
	                                                                                                                // 17
	  // Make sure the caller can't mutate our data structures.                                                     // 18
	  mod = EJSON.clone(mod);                                                                                       // 19
	                                                                                                                // 20
	  var isModifier = isOperatorObject(mod);                                                                       // 21
	                                                                                                                // 22
	  var newDoc;                                                                                                   // 23
	                                                                                                                // 24
	  if (!isModifier) {                                                                                            // 25
	    if (mod._id && !EJSON.equals(doc._id, mod._id))                                                             // 26
	      throw MinimongoError("Cannot change the _id of a document");                                              // 27
	                                                                                                                // 28
	    // replace the whole document                                                                               // 29
	    for (var k in mod) {                                                                                        // 30
	      if (/\./.test(k))                                                                                         // 31
	        throw MinimongoError(                                                                                   // 32
	          "When replacing document, field name may not contain '.'");                                           // 33
	    }                                                                                                           // 34
	    newDoc = mod;                                                                                               // 35
	  } else {                                                                                                      // 36
	    // apply modifiers to the doc.                                                                              // 37
	    newDoc = EJSON.clone(doc);                                                                                  // 38
	                                                                                                                // 39
	    _.each(mod, function (operand, op) {                                                                        // 40
	      var modFunc = MODIFIERS[op];                                                                              // 41
	      // Treat $setOnInsert as $set if this is an insert.                                                       // 42
	      if (options.isInsert && op === '$setOnInsert')                                                            // 43
	        modFunc = MODIFIERS['$set'];                                                                            // 44
	      if (!modFunc)                                                                                             // 45
	        throw MinimongoError("Invalid modifier specified " + op);                                               // 46
	      _.each(operand, function (arg, keypath) {                                                                 // 47
	        if (keypath === '') {                                                                                   // 48
	          throw MinimongoError("An empty update path is not valid.");                                           // 49
	        }                                                                                                       // 50
	                                                                                                                // 51
	        if (keypath === '_id' && op !== '$setOnInsert') {                                                       // 52
	          throw MinimongoError("Mod on _id not allowed");                                                       // 53
	        }                                                                                                       // 54
	                                                                                                                // 55
	        var keyparts = keypath.split('.');                                                                      // 56
	                                                                                                                // 57
	        if (! _.all(keyparts, _.identity)) {                                                                    // 58
	          throw MinimongoError(                                                                                 // 59
	            "The update path '" + keypath +                                                                     // 60
	              "' contains an empty field name, which is not allowed.");                                         // 61
	        }                                                                                                       // 62
	                                                                                                                // 63
	        var noCreate = _.has(NO_CREATE_MODIFIERS, op);                                                          // 64
	        var forbidArray = (op === "$rename");                                                                   // 65
	        var target = findModTarget(newDoc, keyparts, {                                                          // 66
	          noCreate: NO_CREATE_MODIFIERS[op],                                                                    // 67
	          forbidArray: (op === "$rename"),                                                                      // 68
	          arrayIndices: options.arrayIndices                                                                    // 69
	        });                                                                                                     // 70
	        var field = keyparts.pop();                                                                             // 71
	        modFunc(target, field, arg, keypath, newDoc);                                                           // 72
	      });                                                                                                       // 73
	    });                                                                                                         // 74
	  }                                                                                                             // 75
	                                                                                                                // 76
	  // move new document into place.                                                                              // 77
	  _.each(_.keys(doc), function (k) {                                                                            // 78
	    // Note: this used to be for (var k in doc) however, this does not                                          // 79
	    // work right in Opera. Deleting from a doc while iterating over it                                         // 80
	    // would sometimes cause opera to skip some keys.                                                           // 81
	    if (k !== '_id')                                                                                            // 82
	      delete doc[k];                                                                                            // 83
	  });                                                                                                           // 84
	  _.each(newDoc, function (v, k) {                                                                              // 85
	    doc[k] = v;                                                                                                 // 86
	  });                                                                                                           // 87
	};                                                                                                              // 88
	                                                                                                                // 89
	// for a.b.c.2.d.e, keyparts should be ['a', 'b', 'c', '2', 'd', 'e'],                                          // 90
	// and then you would operate on the 'e' property of the returned                                               // 91
	// object.                                                                                                      // 92
	//                                                                                                              // 93
	// if options.noCreate is falsey, creates intermediate levels of                                                // 94
	// structure as necessary, like mkdir -p (and raises an exception if                                            // 95
	// that would mean giving a non-numeric property to an array.) if                                               // 96
	// options.noCreate is true, return undefined instead.                                                          // 97
	//                                                                                                              // 98
	// may modify the last element of keyparts to signal to the caller that it needs                                // 99
	// to use a different value to index into the returned object (for example,                                     // 100
	// ['a', '01'] -> ['a', 1]).                                                                                    // 101
	//                                                                                                              // 102
	// if forbidArray is true, return null if the keypath goes through an array.                                    // 103
	//                                                                                                              // 104
	// if options.arrayIndices is set, use its first element for the (first) '$' in                                 // 105
	// the path.                                                                                                    // 106
	var findModTarget = function (doc, keyparts, options) {                                                         // 107
	  options = options || {};                                                                                      // 108
	  var usedArrayIndex = false;                                                                                   // 109
	  for (var i = 0; i < keyparts.length; i++) {                                                                   // 110
	    var last = (i === keyparts.length - 1);                                                                     // 111
	    var keypart = keyparts[i];                                                                                  // 112
	    var indexable = isIndexable(doc);                                                                           // 113
	    if (!indexable) {                                                                                           // 114
	      if (options.noCreate)                                                                                     // 115
	        return undefined;                                                                                       // 116
	      var e = MinimongoError(                                                                                   // 117
	        "cannot use the part '" + keypart + "' to traverse " + doc);                                            // 118
	      e.setPropertyError = true;                                                                                // 119
	      throw e;                                                                                                  // 120
	    }                                                                                                           // 121
	    if (doc instanceof Array) {                                                                                 // 122
	      if (options.forbidArray)                                                                                  // 123
	        return null;                                                                                            // 124
	      if (keypart === '$') {                                                                                    // 125
	        if (usedArrayIndex)                                                                                     // 126
	          throw MinimongoError("Too many positional (i.e. '$') elements");                                      // 127
	        if (!options.arrayIndices || !options.arrayIndices.length) {                                            // 128
	          throw MinimongoError("The positional operator did not find the " +                                    // 129
	                               "match needed from the query");                                                  // 130
	        }                                                                                                       // 131
	        keypart = options.arrayIndices[0];                                                                      // 132
	        usedArrayIndex = true;                                                                                  // 133
	      } else if (isNumericKey(keypart)) {                                                                       // 134
	        keypart = parseInt(keypart);                                                                            // 135
	      } else {                                                                                                  // 136
	        if (options.noCreate)                                                                                   // 137
	          return undefined;                                                                                     // 138
	        throw MinimongoError(                                                                                   // 139
	          "can't append to array using string field name ["                                                     // 140
	                    + keypart + "]");                                                                           // 141
	      }                                                                                                         // 142
	      if (last)                                                                                                 // 143
	        // handle 'a.01'                                                                                        // 144
	        keyparts[i] = keypart;                                                                                  // 145
	      if (options.noCreate && keypart >= doc.length)                                                            // 146
	        return undefined;                                                                                       // 147
	      while (doc.length < keypart)                                                                              // 148
	        doc.push(null);                                                                                         // 149
	      if (!last) {                                                                                              // 150
	        if (doc.length === keypart)                                                                             // 151
	          doc.push({});                                                                                         // 152
	        else if (typeof doc[keypart] !== "object")                                                              // 153
	          throw MinimongoError("can't modify field '" + keyparts[i + 1] +                                       // 154
	                      "' of list value " + JSON.stringify(doc[keypart]));                                       // 155
	      }                                                                                                         // 156
	    } else {                                                                                                    // 157
	      if (keypart.length && keypart.substr(0, 1) === '$')                                                       // 158
	        throw MinimongoError("can't set field named " + keypart);                                               // 159
	      if (!(keypart in doc)) {                                                                                  // 160
	        if (options.noCreate)                                                                                   // 161
	          return undefined;                                                                                     // 162
	        if (!last)                                                                                              // 163
	          doc[keypart] = {};                                                                                    // 164
	      }                                                                                                         // 165
	    }                                                                                                           // 166
	                                                                                                                // 167
	    if (last)                                                                                                   // 168
	      return doc;                                                                                               // 169
	    doc = doc[keypart];                                                                                         // 170
	  }                                                                                                             // 171
	                                                                                                                // 172
	  // notreached                                                                                                 // 173
	};                                                                                                              // 174
	                                                                                                                // 175
	var NO_CREATE_MODIFIERS = {                                                                                     // 176
	  $unset: true,                                                                                                 // 177
	  $pop: true,                                                                                                   // 178
	  $rename: true,                                                                                                // 179
	  $pull: true,                                                                                                  // 180
	  $pullAll: true                                                                                                // 181
	};                                                                                                              // 182
	                                                                                                                // 183
	var MODIFIERS = {                                                                                               // 184
	  $currentDate: function (target, field, arg) {                                                                 // 185
	    if (typeof arg === "object" && arg.hasOwnProperty("$type")) {                                               // 186
	       if (arg.$type !== "date") {                                                                              // 187
	         throw MinimongoError("Minimongo does currently only support the date type in $currentDate modifiers");
	       }                                                                                                        // 189
	    } else if (arg !== true) {                                                                                  // 190
	      throw MinimongoError("Invalid $currentDate modifier");                                                    // 191
	    }                                                                                                           // 192
	    target[field] = new Date();                                                                                 // 193
	  },                                                                                                            // 194
	  $min: function (target, field, arg) {                                                                         // 195
	    if (typeof arg !== "number") {                                                                              // 196
	      throw MinimongoError("Modifier $min allowed for numbers only");                                           // 197
	    }                                                                                                           // 198
	    if (field in target) {                                                                                      // 199
	      if (typeof target[field] !== "number") {                                                                  // 200
	        throw MinimongoError("Cannot apply $min modifier to non-number");                                       // 201
	      }                                                                                                         // 202
	      if (target[field] > arg) {                                                                                // 203
	        target[field] = arg;                                                                                    // 204
	      }                                                                                                         // 205
	    } else {                                                                                                    // 206
	      target[field] = arg;                                                                                      // 207
	    }                                                                                                           // 208
	  },                                                                                                            // 209
	  $max: function (target, field, arg) {                                                                         // 210
	    if (typeof arg !== "number") {                                                                              // 211
	      throw MinimongoError("Modifier $max allowed for numbers only");                                           // 212
	    }                                                                                                           // 213
	    if (field in target) {                                                                                      // 214
	      if (typeof target[field] !== "number") {                                                                  // 215
	        throw MinimongoError("Cannot apply $max modifier to non-number");                                       // 216
	      }                                                                                                         // 217
	      if (target[field] < arg) {                                                                                // 218
	         target[field] = arg;                                                                                   // 219
	      }                                                                                                         // 220
	    } else {                                                                                                    // 221
	      target[field] = arg;                                                                                      // 222
	    }                                                                                                           // 223
	  },                                                                                                            // 224
	  $inc: function (target, field, arg) {                                                                         // 225
	    if (typeof arg !== "number")                                                                                // 226
	      throw MinimongoError("Modifier $inc allowed for numbers only");                                           // 227
	    if (field in target) {                                                                                      // 228
	      if (typeof target[field] !== "number")                                                                    // 229
	        throw MinimongoError("Cannot apply $inc modifier to non-number");                                       // 230
	      target[field] += arg;                                                                                     // 231
	    } else {                                                                                                    // 232
	      target[field] = arg;                                                                                      // 233
	    }                                                                                                           // 234
	  },                                                                                                            // 235
	  $set: function (target, field, arg) {                                                                         // 236
	    if (!_.isObject(target)) { // not an array or an object                                                     // 237
	      var e = MinimongoError("Cannot set property on non-object field");                                        // 238
	      e.setPropertyError = true;                                                                                // 239
	      throw e;                                                                                                  // 240
	    }                                                                                                           // 241
	    if (target === null) {                                                                                      // 242
	      var e = MinimongoError("Cannot set property on null");                                                    // 243
	      e.setPropertyError = true;                                                                                // 244
	      throw e;                                                                                                  // 245
	    }                                                                                                           // 246
	    target[field] = arg;                                                                                        // 247
	  },                                                                                                            // 248
	  $setOnInsert: function (target, field, arg) {                                                                 // 249
	    // converted to `$set` in `_modify`                                                                         // 250
	  },                                                                                                            // 251
	  $unset: function (target, field, arg) {                                                                       // 252
	    if (target !== undefined) {                                                                                 // 253
	      if (target instanceof Array) {                                                                            // 254
	        if (field in target)                                                                                    // 255
	          target[field] = null;                                                                                 // 256
	      } else                                                                                                    // 257
	        delete target[field];                                                                                   // 258
	    }                                                                                                           // 259
	  },                                                                                                            // 260
	  $push: function (target, field, arg) {                                                                        // 261
	    if (target[field] === undefined)                                                                            // 262
	      target[field] = [];                                                                                       // 263
	    if (!(target[field] instanceof Array))                                                                      // 264
	      throw MinimongoError("Cannot apply $push modifier to non-array");                                         // 265
	                                                                                                                // 266
	    if (!(arg && arg.$each)) {                                                                                  // 267
	      // Simple mode: not $each                                                                                 // 268
	      target[field].push(arg);                                                                                  // 269
	      return;                                                                                                   // 270
	    }                                                                                                           // 271
	                                                                                                                // 272
	    // Fancy mode: $each (and maybe $slice and $sort and $position)                                             // 273
	    var toPush = arg.$each;                                                                                     // 274
	    if (!(toPush instanceof Array))                                                                             // 275
	      throw MinimongoError("$each must be an array");                                                           // 276
	                                                                                                                // 277
	    // Parse $position                                                                                          // 278
	    var position = undefined;                                                                                   // 279
	    if ('$position' in arg) {                                                                                   // 280
	      if (typeof arg.$position !== "number")                                                                    // 281
	        throw MinimongoError("$position must be a numeric value");                                              // 282
	      // XXX should check to make sure integer                                                                  // 283
	      if (arg.$position < 0)                                                                                    // 284
	        throw MinimongoError("$position in $push must be zero or positive");                                    // 285
	      position = arg.$position;                                                                                 // 286
	    }                                                                                                           // 287
	                                                                                                                // 288
	    // Parse $slice.                                                                                            // 289
	    var slice = undefined;                                                                                      // 290
	    if ('$slice' in arg) {                                                                                      // 291
	      if (typeof arg.$slice !== "number")                                                                       // 292
	        throw MinimongoError("$slice must be a numeric value");                                                 // 293
	      // XXX should check to make sure integer                                                                  // 294
	      if (arg.$slice > 0)                                                                                       // 295
	        throw MinimongoError("$slice in $push must be zero or negative");                                       // 296
	      slice = arg.$slice;                                                                                       // 297
	    }                                                                                                           // 298
	                                                                                                                // 299
	    // Parse $sort.                                                                                             // 300
	    var sortFunction = undefined;                                                                               // 301
	    if (arg.$sort) {                                                                                            // 302
	      if (slice === undefined)                                                                                  // 303
	        throw MinimongoError("$sort requires $slice to be present");                                            // 304
	      // XXX this allows us to use a $sort whose value is an array, but that's                                  // 305
	      // actually an extension of the Node driver, so it won't work                                             // 306
	      // server-side. Could be confusing!                                                                       // 307
	      // XXX is it correct that we don't do geo-stuff here?                                                     // 308
	      sortFunction = new Minimongo.Sorter(arg.$sort).getComparator();                                           // 309
	      for (var i = 0; i < toPush.length; i++) {                                                                 // 310
	        if (LocalCollection._f._type(toPush[i]) !== 3) {                                                        // 311
	          throw MinimongoError("$push like modifiers using $sort " +                                            // 312
	                      "require all elements to be objects");                                                    // 313
	        }                                                                                                       // 314
	      }                                                                                                         // 315
	    }                                                                                                           // 316
	                                                                                                                // 317
	    // Actually push.                                                                                           // 318
	    if (position === undefined) {                                                                               // 319
	      for (var j = 0; j < toPush.length; j++)                                                                   // 320
	        target[field].push(toPush[j]);                                                                          // 321
	    } else {                                                                                                    // 322
	      var spliceArguments = [position, 0];                                                                      // 323
	      for (var j = 0; j < toPush.length; j++)                                                                   // 324
	        spliceArguments.push(toPush[j]);                                                                        // 325
	      Array.prototype.splice.apply(target[field], spliceArguments);                                             // 326
	    }                                                                                                           // 327
	                                                                                                                // 328
	    // Actually sort.                                                                                           // 329
	    if (sortFunction)                                                                                           // 330
	      target[field].sort(sortFunction);                                                                         // 331
	                                                                                                                // 332
	    // Actually slice.                                                                                          // 333
	    if (slice !== undefined) {                                                                                  // 334
	      if (slice === 0)                                                                                          // 335
	        target[field] = [];  // differs from Array.slice!                                                       // 336
	      else                                                                                                      // 337
	        target[field] = target[field].slice(slice);                                                             // 338
	    }                                                                                                           // 339
	  },                                                                                                            // 340
	  $pushAll: function (target, field, arg) {                                                                     // 341
	    if (!(typeof arg === "object" && arg instanceof Array))                                                     // 342
	      throw MinimongoError("Modifier $pushAll/pullAll allowed for arrays only");                                // 343
	    var x = target[field];                                                                                      // 344
	    if (x === undefined)                                                                                        // 345
	      target[field] = arg;                                                                                      // 346
	    else if (!(x instanceof Array))                                                                             // 347
	      throw MinimongoError("Cannot apply $pushAll modifier to non-array");                                      // 348
	    else {                                                                                                      // 349
	      for (var i = 0; i < arg.length; i++)                                                                      // 350
	        x.push(arg[i]);                                                                                         // 351
	    }                                                                                                           // 352
	  },                                                                                                            // 353
	  $addToSet: function (target, field, arg) {                                                                    // 354
	    var isEach = false;                                                                                         // 355
	    if (typeof arg === "object") {                                                                              // 356
	      //check if first key is '$each'                                                                           // 357
	      for (var k in arg) {                                                                                      // 358
	        if (k === "$each")                                                                                      // 359
	          isEach = true;                                                                                        // 360
	        break;                                                                                                  // 361
	      }                                                                                                         // 362
	    }                                                                                                           // 363
	    var values = isEach ? arg["$each"] : [arg];                                                                 // 364
	    var x = target[field];                                                                                      // 365
	    if (x === undefined)                                                                                        // 366
	      target[field] = values;                                                                                   // 367
	    else if (!(x instanceof Array))                                                                             // 368
	      throw MinimongoError("Cannot apply $addToSet modifier to non-array");                                     // 369
	    else {                                                                                                      // 370
	      _.each(values, function (value) {                                                                         // 371
	        for (var i = 0; i < x.length; i++)                                                                      // 372
	          if (LocalCollection._f._equal(value, x[i]))                                                           // 373
	            return;                                                                                             // 374
	        x.push(value);                                                                                          // 375
	      });                                                                                                       // 376
	    }                                                                                                           // 377
	  },                                                                                                            // 378
	  $pop: function (target, field, arg) {                                                                         // 379
	    if (target === undefined)                                                                                   // 380
	      return;                                                                                                   // 381
	    var x = target[field];                                                                                      // 382
	    if (x === undefined)                                                                                        // 383
	      return;                                                                                                   // 384
	    else if (!(x instanceof Array))                                                                             // 385
	      throw MinimongoError("Cannot apply $pop modifier to non-array");                                          // 386
	    else {                                                                                                      // 387
	      if (typeof arg === 'number' && arg < 0)                                                                   // 388
	        x.splice(0, 1);                                                                                         // 389
	      else                                                                                                      // 390
	        x.pop();                                                                                                // 391
	    }                                                                                                           // 392
	  },                                                                                                            // 393
	  $pull: function (target, field, arg) {                                                                        // 394
	    if (target === undefined)                                                                                   // 395
	      return;                                                                                                   // 396
	    var x = target[field];                                                                                      // 397
	    if (x === undefined)                                                                                        // 398
	      return;                                                                                                   // 399
	    else if (!(x instanceof Array))                                                                             // 400
	      throw MinimongoError("Cannot apply $pull/pullAll modifier to non-array");                                 // 401
	    else {                                                                                                      // 402
	      var out = [];                                                                                             // 403
	      if (arg != null && typeof arg === "object" && !(arg instanceof Array)) {                                  // 404
	        // XXX would be much nicer to compile this once, rather than                                            // 405
	        // for each document we modify.. but usually we're not                                                  // 406
	        // modifying that many documents, so we'll let it slide for                                             // 407
	        // now                                                                                                  // 408
	                                                                                                                // 409
	        // XXX Minimongo.Matcher isn't up for the job, because we need                                          // 410
	        // to permit stuff like {$pull: {a: {$gt: 4}}}.. something                                              // 411
	        // like {$gt: 4} is not normally a complete selector.                                                   // 412
	        // same issue as $elemMatch possibly?                                                                   // 413
	        var matcher = new Minimongo.Matcher(arg);                                                               // 414
	        for (var i = 0; i < x.length; i++)                                                                      // 415
	          if (!matcher.documentMatches(x[i]).result)                                                            // 416
	            out.push(x[i]);                                                                                     // 417
	      } else {                                                                                                  // 418
	        for (var i = 0; i < x.length; i++)                                                                      // 419
	          if (!LocalCollection._f._equal(x[i], arg))                                                            // 420
	            out.push(x[i]);                                                                                     // 421
	      }                                                                                                         // 422
	      target[field] = out;                                                                                      // 423
	    }                                                                                                           // 424
	  },                                                                                                            // 425
	  $pullAll: function (target, field, arg) {                                                                     // 426
	    if (!(typeof arg === "object" && arg instanceof Array))                                                     // 427
	      throw MinimongoError("Modifier $pushAll/pullAll allowed for arrays only");                                // 428
	    if (target === undefined)                                                                                   // 429
	      return;                                                                                                   // 430
	    var x = target[field];                                                                                      // 431
	    if (x === undefined)                                                                                        // 432
	      return;                                                                                                   // 433
	    else if (!(x instanceof Array))                                                                             // 434
	      throw MinimongoError("Cannot apply $pull/pullAll modifier to non-array");                                 // 435
	    else {                                                                                                      // 436
	      var out = [];                                                                                             // 437
	      for (var i = 0; i < x.length; i++) {                                                                      // 438
	        var exclude = false;                                                                                    // 439
	        for (var j = 0; j < arg.length; j++) {                                                                  // 440
	          if (LocalCollection._f._equal(x[i], arg[j])) {                                                        // 441
	            exclude = true;                                                                                     // 442
	            break;                                                                                              // 443
	          }                                                                                                     // 444
	        }                                                                                                       // 445
	        if (!exclude)                                                                                           // 446
	          out.push(x[i]);                                                                                       // 447
	      }                                                                                                         // 448
	      target[field] = out;                                                                                      // 449
	    }                                                                                                           // 450
	  },                                                                                                            // 451
	  $rename: function (target, field, arg, keypath, doc) {                                                        // 452
	    if (keypath === arg)                                                                                        // 453
	      // no idea why mongo has this restriction..                                                               // 454
	      throw MinimongoError("$rename source must differ from target");                                           // 455
	    if (target === null)                                                                                        // 456
	      throw MinimongoError("$rename source field invalid");                                                     // 457
	    if (typeof arg !== "string")                                                                                // 458
	      throw MinimongoError("$rename target must be a string");                                                  // 459
	    if (target === undefined)                                                                                   // 460
	      return;                                                                                                   // 461
	    var v = target[field];                                                                                      // 462
	    delete target[field];                                                                                       // 463
	                                                                                                                // 464
	    var keyparts = arg.split('.');                                                                              // 465
	    var target2 = findModTarget(doc, keyparts, {forbidArray: true});                                            // 466
	    if (target2 === null)                                                                                       // 467
	      throw MinimongoError("$rename target field invalid");                                                     // 468
	    var field2 = keyparts.pop();                                                                                // 469
	    target2[field2] = v;                                                                                        // 470
	  },                                                                                                            // 471
	  $bit: function (target, field, arg) {                                                                         // 472
	    // XXX mongo only supports $bit on integers, and we only support                                            // 473
	    // native javascript numbers (doubles) so far, so we can't support $bit                                     // 474
	    throw MinimongoError("$bit is not supported");                                                              // 475
	  }                                                                                                             // 476
	};                                                                                                              // 477
	                                                                                                                // 478
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                              //
	// packages/minimongo/diff.js                                                                                   //
	//                                                                                                              //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                //
	// ordered: bool.                                                                                               // 1
	// old_results and new_results: collections of documents.                                                       // 2
	//    if ordered, they are arrays.                                                                              // 3
	//    if unordered, they are IdMaps                                                                             // 4
	LocalCollection._diffQueryChanges = function (ordered, oldResults, newResults, observer, options) {             // 5
	  return DiffSequence.diffQueryChanges(ordered, oldResults, newResults, observer, options);                     // 6
	};                                                                                                              // 7
	                                                                                                                // 8
	LocalCollection._diffQueryUnorderedChanges = function (oldResults, newResults, observer, options) {             // 9
	  return DiffSequence.diffQueryUnorderedChanges(oldResults, newResults, observer, options);                     // 10
	};                                                                                                              // 11
	                                                                                                                // 12
	                                                                                                                // 13
	LocalCollection._diffQueryOrderedChanges =                                                                      // 14
	  function (oldResults, newResults, observer, options) {                                                        // 15
	  return DiffSequence.diffQueryOrderedChanges(oldResults, newResults, observer, options);                       // 16
	};                                                                                                              // 17
	                                                                                                                // 18
	LocalCollection._diffObjects = function (left, right, callbacks) {                                              // 19
	  return DiffSequence.diffObjects(left, right, callbacks);                                                      // 20
	};                                                                                                              // 21
	                                                                                                                // 22
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                              //
	// packages/minimongo/id_map.js                                                                                 //
	//                                                                                                              //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                //
	LocalCollection._IdMap = function () {                                                                          // 1
	  var self = this;                                                                                              // 2
	  IdMap.call(self, MongoID.idStringify, MongoID.idParse);                                                       // 3
	};                                                                                                              // 4
	                                                                                                                // 5
	Meteor._inherits(LocalCollection._IdMap, IdMap);                                                                // 6
	                                                                                                                // 7
	                                                                                                                // 8
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                              //
	// packages/minimongo/observe.js                                                                                //
	//                                                                                                              //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                //
	// XXX maybe move these into another ObserveHelpers package or something                                        // 1
	                                                                                                                // 2
	// _CachingChangeObserver is an object which receives observeChanges callbacks                                  // 3
	// and keeps a cache of the current cursor state up to date in self.docs. Users                                 // 4
	// of this class should read the docs field but not modify it. You should pass                                  // 5
	// the "applyChange" field as the callbacks to the underlying observeChanges                                    // 6
	// call. Optionally, you can specify your own observeChanges callbacks which are                                // 7
	// invoked immediately before the docs field is updated; this object is made                                    // 8
	// available as `this` to those callbacks.                                                                      // 9
	LocalCollection._CachingChangeObserver = function (options) {                                                   // 10
	  var self = this;                                                                                              // 11
	  options = options || {};                                                                                      // 12
	                                                                                                                // 13
	  var orderedFromCallbacks = options.callbacks &&                                                               // 14
	        LocalCollection._observeChangesCallbacksAreOrdered(options.callbacks);                                  // 15
	  if (_.has(options, 'ordered')) {                                                                              // 16
	    self.ordered = options.ordered;                                                                             // 17
	    if (options.callbacks && options.ordered !== orderedFromCallbacks)                                          // 18
	      throw Error("ordered option doesn't match callbacks");                                                    // 19
	  } else if (options.callbacks) {                                                                               // 20
	    self.ordered = orderedFromCallbacks;                                                                        // 21
	  } else {                                                                                                      // 22
	    throw Error("must provide ordered or callbacks");                                                           // 23
	  }                                                                                                             // 24
	  var callbacks = options.callbacks || {};                                                                      // 25
	                                                                                                                // 26
	  if (self.ordered) {                                                                                           // 27
	    self.docs = new OrderedDict(MongoID.idStringify);                                                           // 28
	    self.applyChange = {                                                                                        // 29
	      addedBefore: function (id, fields, before) {                                                              // 30
	        var doc = EJSON.clone(fields);                                                                          // 31
	        doc._id = id;                                                                                           // 32
	        callbacks.addedBefore && callbacks.addedBefore.call(                                                    // 33
	          self, id, fields, before);                                                                            // 34
	        // This line triggers if we provide added with movedBefore.                                             // 35
	        callbacks.added && callbacks.added.call(self, id, fields);                                              // 36
	        // XXX could `before` be a falsy ID?  Technically                                                       // 37
	        // idStringify seems to allow for them -- though                                                        // 38
	        // OrderedDict won't call stringify on a falsy arg.                                                     // 39
	        self.docs.putBefore(id, doc, before || null);                                                           // 40
	      },                                                                                                        // 41
	      movedBefore: function (id, before) {                                                                      // 42
	        var doc = self.docs.get(id);                                                                            // 43
	        callbacks.movedBefore && callbacks.movedBefore.call(self, id, before);                                  // 44
	        self.docs.moveBefore(id, before || null);                                                               // 45
	      }                                                                                                         // 46
	    };                                                                                                          // 47
	  } else {                                                                                                      // 48
	    self.docs = new LocalCollection._IdMap;                                                                     // 49
	    self.applyChange = {                                                                                        // 50
	      added: function (id, fields) {                                                                            // 51
	        var doc = EJSON.clone(fields);                                                                          // 52
	        callbacks.added && callbacks.added.call(self, id, fields);                                              // 53
	        doc._id = id;                                                                                           // 54
	        self.docs.set(id,  doc);                                                                                // 55
	      }                                                                                                         // 56
	    };                                                                                                          // 57
	  }                                                                                                             // 58
	                                                                                                                // 59
	  // The methods in _IdMap and OrderedDict used by these callbacks are                                          // 60
	  // identical.                                                                                                 // 61
	  self.applyChange.changed = function (id, fields) {                                                            // 62
	    var doc = self.docs.get(id);                                                                                // 63
	    if (!doc)                                                                                                   // 64
	      throw new Error("Unknown id for changed: " + id);                                                         // 65
	    callbacks.changed && callbacks.changed.call(                                                                // 66
	      self, id, EJSON.clone(fields));                                                                           // 67
	    DiffSequence.applyChanges(doc, fields);                                                                     // 68
	  };                                                                                                            // 69
	  self.applyChange.removed = function (id) {                                                                    // 70
	    callbacks.removed && callbacks.removed.call(self, id);                                                      // 71
	    self.docs.remove(id);                                                                                       // 72
	  };                                                                                                            // 73
	};                                                                                                              // 74
	                                                                                                                // 75
	LocalCollection._observeFromObserveChanges = function (cursor, observeCallbacks) {                              // 76
	  var transform = cursor.getTransform() || function (doc) {return doc;};                                        // 77
	  var suppressed = !!observeCallbacks._suppress_initial;                                                        // 78
	                                                                                                                // 79
	  var observeChangesCallbacks;                                                                                  // 80
	  if (LocalCollection._observeCallbacksAreOrdered(observeCallbacks)) {                                          // 81
	    // The "_no_indices" option sets all index arguments to -1 and skips the                                    // 82
	    // linear scans required to generate them.  This lets observers that don't                                  // 83
	    // need absolute indices benefit from the other features of this API --                                     // 84
	    // relative order, transforms, and applyChanges -- without the speed hit.                                   // 85
	    var indices = !observeCallbacks._no_indices;                                                                // 86
	    observeChangesCallbacks = {                                                                                 // 87
	      addedBefore: function (id, fields, before) {                                                              // 88
	        var self = this;                                                                                        // 89
	        if (suppressed || !(observeCallbacks.addedAt || observeCallbacks.added))                                // 90
	          return;                                                                                               // 91
	        var doc = transform(_.extend(fields, {_id: id}));                                                       // 92
	        if (observeCallbacks.addedAt) {                                                                         // 93
	          var index = indices                                                                                   // 94
	                ? (before ? self.docs.indexOf(before) : self.docs.size()) : -1;                                 // 95
	          observeCallbacks.addedAt(doc, index, before);                                                         // 96
	        } else {                                                                                                // 97
	          observeCallbacks.added(doc);                                                                          // 98
	        }                                                                                                       // 99
	      },                                                                                                        // 100
	      changed: function (id, fields) {                                                                          // 101
	        var self = this;                                                                                        // 102
	        if (!(observeCallbacks.changedAt || observeCallbacks.changed))                                          // 103
	          return;                                                                                               // 104
	        var doc = EJSON.clone(self.docs.get(id));                                                               // 105
	        if (!doc)                                                                                               // 106
	          throw new Error("Unknown id for changed: " + id);                                                     // 107
	        var oldDoc = transform(EJSON.clone(doc));                                                               // 108
	        DiffSequence.applyChanges(doc, fields);                                                                 // 109
	        doc = transform(doc);                                                                                   // 110
	        if (observeCallbacks.changedAt) {                                                                       // 111
	          var index = indices ? self.docs.indexOf(id) : -1;                                                     // 112
	          observeCallbacks.changedAt(doc, oldDoc, index);                                                       // 113
	        } else {                                                                                                // 114
	          observeCallbacks.changed(doc, oldDoc);                                                                // 115
	        }                                                                                                       // 116
	      },                                                                                                        // 117
	      movedBefore: function (id, before) {                                                                      // 118
	        var self = this;                                                                                        // 119
	        if (!observeCallbacks.movedTo)                                                                          // 120
	          return;                                                                                               // 121
	        var from = indices ? self.docs.indexOf(id) : -1;                                                        // 122
	                                                                                                                // 123
	        var to = indices                                                                                        // 124
	              ? (before ? self.docs.indexOf(before) : self.docs.size()) : -1;                                   // 125
	        // When not moving backwards, adjust for the fact that removing the                                     // 126
	        // document slides everything back one slot.                                                            // 127
	        if (to > from)                                                                                          // 128
	          --to;                                                                                                 // 129
	        observeCallbacks.movedTo(transform(EJSON.clone(self.docs.get(id))),                                     // 130
	                                 from, to, before || null);                                                     // 131
	      },                                                                                                        // 132
	      removed: function (id) {                                                                                  // 133
	        var self = this;                                                                                        // 134
	        if (!(observeCallbacks.removedAt || observeCallbacks.removed))                                          // 135
	          return;                                                                                               // 136
	        // technically maybe there should be an EJSON.clone here, but it's about                                // 137
	        // to be removed from self.docs!                                                                        // 138
	        var doc = transform(self.docs.get(id));                                                                 // 139
	        if (observeCallbacks.removedAt) {                                                                       // 140
	          var index = indices ? self.docs.indexOf(id) : -1;                                                     // 141
	          observeCallbacks.removedAt(doc, index);                                                               // 142
	        } else {                                                                                                // 143
	          observeCallbacks.removed(doc);                                                                        // 144
	        }                                                                                                       // 145
	      }                                                                                                         // 146
	    };                                                                                                          // 147
	  } else {                                                                                                      // 148
	    observeChangesCallbacks = {                                                                                 // 149
	      added: function (id, fields) {                                                                            // 150
	        if (!suppressed && observeCallbacks.added) {                                                            // 151
	          var doc = _.extend(fields, {_id:  id});                                                               // 152
	          observeCallbacks.added(transform(doc));                                                               // 153
	        }                                                                                                       // 154
	      },                                                                                                        // 155
	      changed: function (id, fields) {                                                                          // 156
	        var self = this;                                                                                        // 157
	        if (observeCallbacks.changed) {                                                                         // 158
	          var oldDoc = self.docs.get(id);                                                                       // 159
	          var doc = EJSON.clone(oldDoc);                                                                        // 160
	          DiffSequence.applyChanges(doc, fields);                                                               // 161
	          observeCallbacks.changed(transform(doc),                                                              // 162
	                                   transform(EJSON.clone(oldDoc)));                                             // 163
	        }                                                                                                       // 164
	      },                                                                                                        // 165
	      removed: function (id) {                                                                                  // 166
	        var self = this;                                                                                        // 167
	        if (observeCallbacks.removed) {                                                                         // 168
	          observeCallbacks.removed(transform(self.docs.get(id)));                                               // 169
	        }                                                                                                       // 170
	      }                                                                                                         // 171
	    };                                                                                                          // 172
	  }                                                                                                             // 173
	                                                                                                                // 174
	  var changeObserver = new LocalCollection._CachingChangeObserver(                                              // 175
	    {callbacks: observeChangesCallbacks});                                                                      // 176
	  var handle = cursor.observeChanges(changeObserver.applyChange);                                               // 177
	  suppressed = false;                                                                                           // 178
	                                                                                                                // 179
	  return handle;                                                                                                // 180
	};                                                                                                              // 181
	                                                                                                                // 182
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                              //
	// packages/minimongo/objectid.js                                                                               //
	//                                                                                                              //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                //
	// Is this selector just shorthand for lookup by _id?                                                           // 1
	LocalCollection._selectorIsId = function (selector) {                                                           // 2
	  return (typeof selector === "string") ||                                                                      // 3
	    (typeof selector === "number") ||                                                                           // 4
	    selector instanceof MongoID.ObjectID;                                                                       // 5
	};                                                                                                              // 6
	                                                                                                                // 7
	// Is the selector just lookup by _id (shorthand or not)?                                                       // 8
	LocalCollection._selectorIsIdPerhapsAsObject = function (selector) {                                            // 9
	  return LocalCollection._selectorIsId(selector) ||                                                             // 10
	    (selector && typeof selector === "object" &&                                                                // 11
	     selector._id && LocalCollection._selectorIsId(selector._id) &&                                             // 12
	     _.size(selector) === 1);                                                                                   // 13
	};                                                                                                              // 14
	                                                                                                                // 15
	// If this is a selector which explicitly constrains the match by ID to a finite                                // 16
	// number of documents, returns a list of their IDs.  Otherwise returns                                         // 17
	// null. Note that the selector may have other restrictions so it may not even                                  // 18
	// match those document!  We care about $in and $and since those are generated                                  // 19
	// access-controlled update and remove.                                                                         // 20
	LocalCollection._idsMatchedBySelector = function (selector) {                                                   // 21
	  // Is the selector just an ID?                                                                                // 22
	  if (LocalCollection._selectorIsId(selector))                                                                  // 23
	    return [selector];                                                                                          // 24
	  if (!selector)                                                                                                // 25
	    return null;                                                                                                // 26
	                                                                                                                // 27
	  // Do we have an _id clause?                                                                                  // 28
	  if (_.has(selector, '_id')) {                                                                                 // 29
	    // Is the _id clause just an ID?                                                                            // 30
	    if (LocalCollection._selectorIsId(selector._id))                                                            // 31
	      return [selector._id];                                                                                    // 32
	    // Is the _id clause {_id: {$in: ["x", "y", "z"]}}?                                                         // 33
	    if (selector._id && selector._id.$in                                                                        // 34
	        && _.isArray(selector._id.$in)                                                                          // 35
	        && !_.isEmpty(selector._id.$in)                                                                         // 36
	        && _.all(selector._id.$in, LocalCollection._selectorIsId)) {                                            // 37
	      return selector._id.$in;                                                                                  // 38
	    }                                                                                                           // 39
	    return null;                                                                                                // 40
	  }                                                                                                             // 41
	                                                                                                                // 42
	  // If this is a top-level $and, and any of the clauses constrain their                                        // 43
	  // documents, then the whole selector is constrained by any one clause's                                      // 44
	  // constraint. (Well, by their intersection, but that seems unlikely.)                                        // 45
	  if (selector.$and && _.isArray(selector.$and)) {                                                              // 46
	    for (var i = 0; i < selector.$and.length; ++i) {                                                            // 47
	      var subIds = LocalCollection._idsMatchedBySelector(selector.$and[i]);                                     // 48
	      if (subIds)                                                                                               // 49
	        return subIds;                                                                                          // 50
	    }                                                                                                           // 51
	  }                                                                                                             // 52
	                                                                                                                // 53
	  return null;                                                                                                  // 54
	};                                                                                                              // 55
	                                                                                                                // 56
	                                                                                                                // 57
	                                                                                                                // 58
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.minimongo = {}, {
	  LocalCollection: LocalCollection,
	  Minimongo: Minimongo,
	  MinimongoTest: MinimongoTest
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/modules-runtime.js":
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(process) {//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	
	/* Package-scope variables */
	var makeInstaller, meteorInstall;
	
	/////////////////////////////////////////////////////////////////////////////
	//                                                                         //
	// packages/modules-runtime/.npm/package/node_modules/install/install.js   //
	// This file is in bare mode and is not in its own closure.                //
	//                                                                         //
	/////////////////////////////////////////////////////////////////////////////
	                                                                           //
	makeInstaller = function (options) {                                       // 1
	  "use strict";                                                            // 2
	                                                                           // 3
	  options = options || {};                                                 // 4
	                                                                           // 5
	  // These file extensions will be appended to required module identifiers
	  // if they do not exactly match an installed module.                     // 7
	  var defaultExtensions = options.extensions || [".js", ".json"];          // 8
	                                                                           // 9
	  // If defined, the options.onInstall function will be called any time    // 10
	  // new modules are installed.                                            // 11
	  var onInstall = options.onInstall;                                       // 12
	                                                                           // 13
	  // If defined, each module-specific require function will be passed to   // 14
	  // this function, along with the module.id of the parent module, and     // 15
	  // the result will be used in place of the original require function.    // 16
	  var wrapRequire = options.wrapRequire;                                   // 17
	                                                                           // 18
	  // If defined, the options.override function will be called before       // 19
	  // looking up any top-level package identifiers in node_modules          // 20
	  // directories. It can either return a string to provide an alternate    // 21
	  // package identifier, or a non-string value to prevent the lookup from  // 22
	  // proceeding.                                                           // 23
	  var override = options.override;                                         // 24
	                                                                           // 25
	  // If defined, the options.fallback function will be called when no      // 26
	  // installed module is found for a required module identifier. Often     // 27
	  // options.fallback will be implemented in terms of the native Node      // 28
	  // require function, which has the ability to load binary modules.       // 29
	  var fallback = options.fallback;                                         // 30
	                                                                           // 31
	  // Nothing special about MISSING.hasOwnProperty, except that it's fewer  // 32
	  // characters than Object.prototype.hasOwnProperty after minification.   // 33
	  var hasOwn = {}.hasOwnProperty;                                          // 34
	                                                                           // 35
	  // The file object representing the root directory of the installed      // 36
	  // module tree.                                                          // 37
	  var root = new File("/", new File("/.."));                               // 38
	  var rootRequire = makeRequire(root);                                     // 39
	                                                                           // 40
	  // Merges the given tree of directories and module factory functions     // 41
	  // into the tree of installed modules and returns a require function     // 42
	  // that behaves as if called from a module in the root directory.        // 43
	  function install(tree, options) {                                        // 44
	    if (isObject(tree)) {                                                  // 45
	      fileMergeContents(root, tree, options);                              // 46
	      if (isFunction(onInstall)) {                                         // 47
	        onInstall(rootRequire);                                            // 48
	      }                                                                    // 49
	    }                                                                      // 50
	    return rootRequire;                                                    // 51
	  }                                                                        // 52
	                                                                           // 53
	  // This constructor will be used to instantiate the module objects       // 54
	  // passed to module factory functions (i.e. the third argument after     // 55
	  // require and exports), and is exposed as install.Module in case the    // 56
	  // caller of makeInstaller wishes to modify Module.prototype.            // 57
	  function Module(id) {                                                    // 58
	    this.id = id;                                                          // 59
	    this.children = [];                                                    // 60
	  }                                                                        // 61
	                                                                           // 62
	  Module.prototype.resolve = function (id) {                               // 63
	    return this.require.resolve(id);                                       // 64
	  };                                                                       // 65
	                                                                           // 66
	  install.Module = Module;                                                 // 67
	                                                                           // 68
	  function getOwn(obj, key) {                                              // 69
	    return hasOwn.call(obj, key) && obj[key];                              // 70
	  }                                                                        // 71
	                                                                           // 72
	  function isObject(value) {                                               // 73
	    return value && typeof value === "object";                             // 74
	  }                                                                        // 75
	                                                                           // 76
	  function isFunction(value) {                                             // 77
	    return typeof value === "function";                                    // 78
	  }                                                                        // 79
	                                                                           // 80
	  function isString(value) {                                               // 81
	    return typeof value === "string";                                      // 82
	  }                                                                        // 83
	                                                                           // 84
	  function makeRequire(file) {                                             // 85
	    function require(id) {                                                 // 86
	      var result = fileResolve(file, id);                                  // 87
	      if (result) {                                                        // 88
	        return fileEvaluate(result, file.m);                               // 89
	      }                                                                    // 90
	                                                                           // 91
	      var error = new Error("Cannot find module '" + id + "'");            // 92
	                                                                           // 93
	      if (isFunction(fallback)) {                                          // 94
	        return fallback(                                                   // 95
	          id, // The missing module identifier.                            // 96
	          file.m.id, // The path of the requiring file.                    // 97
	          error // The error we would have thrown.                         // 98
	        );                                                                 // 99
	      }                                                                    // 100
	                                                                           // 101
	      throw error;                                                         // 102
	    }                                                                      // 103
	                                                                           // 104
	    if (isFunction(wrapRequire)) {                                         // 105
	      require = wrapRequire(require, file.m.id);                           // 106
	    }                                                                      // 107
	                                                                           // 108
	    require.resolve = function (id) {                                      // 109
	      var f = fileResolve(file, id);                                       // 110
	      if (f) return f.m.id;                                                // 111
	      var error = new Error("Cannot find module '" + id + "'");            // 112
	      if (fallback && isFunction(fallback.resolve)) {                      // 113
	        return fallback.resolve(id, file.m.id, error);                     // 114
	      }                                                                    // 115
	      throw error;                                                         // 116
	    };                                                                     // 117
	                                                                           // 118
	    return require;                                                        // 119
	  }                                                                        // 120
	                                                                           // 121
	  // File objects represent either directories or modules that have been   // 122
	  // installed. When a `File` respresents a directory, its `.c` (contents)
	  // property is an object containing the names of the files (or           // 124
	  // directories) that it contains. When a `File` represents a module, its
	  // `.c` property is a function that can be invoked with the appropriate  // 126
	  // `(require, exports, module)` arguments to evaluate the module. If the
	  // `.c` property is a string, that string will be resolved as a module   // 128
	  // identifier, and the exports of the resulting module will provide the  // 129
	  // exports of the original file. The `.p` (parent) property of a File is
	  // either a directory `File` or `null`. Note that a child may claim      // 131
	  // another `File` as its parent even if the parent does not have an      // 132
	  // entry for that child in its `.c` object.  This is important for       // 133
	  // implementing anonymous files, and preventing child modules from using
	  // `../relative/identifier` syntax to examine unrelated modules.         // 135
	  function File(name, parent) {                                            // 136
	    var file = this;                                                       // 137
	                                                                           // 138
	    // Link to the parent file.                                            // 139
	    file.p = parent = parent || null;                                      // 140
	                                                                           // 141
	    // The module object for this File, which will eventually boast an     // 142
	    // .exports property when/if the file is evaluated.                    // 143
	    file.m = new Module(name);                                             // 144
	  }                                                                        // 145
	                                                                           // 146
	  function fileEvaluate(file, parentModule) {                              // 147
	    var contents = file && file.c;                                         // 148
	    var module = file.m;                                                   // 149
	                                                                           // 150
	    if (! hasOwn.call(module, "exports")) {                                // 151
	      if (parentModule) {                                                  // 152
	        module.parent = parentModule;                                      // 153
	        var children = parentModule.children;                              // 154
	        if (Array.isArray(children)) {                                     // 155
	          children.push(module);                                           // 156
	        }                                                                  // 157
	      }                                                                    // 158
	                                                                           // 159
	      // If a Module.prototype.useNode method is defined, give it a chance
	      // to define module.exports based on module.id using Node.           // 161
	      if (! isFunction(module.useNode) ||                                  // 162
	          ! module.useNode()) {                                            // 163
	        contents(                                                          // 164
	          module.require = module.require || makeRequire(file),            // 165
	          module.exports = {},                                             // 166
	          module,                                                          // 167
	          file.m.id,                                                       // 168
	          file.p.m.id                                                      // 169
	        );                                                                 // 170
	      }                                                                    // 171
	                                                                           // 172
	      module.loaded = true;                                                // 173
	    }                                                                      // 174
	                                                                           // 175
	    if (isFunction(module.runModuleSetters)) {                             // 176
	      module.runModuleSetters();                                           // 177
	    }                                                                      // 178
	                                                                           // 179
	    return module.exports;                                                 // 180
	  }                                                                        // 181
	                                                                           // 182
	  function fileIsDirectory(file) {                                         // 183
	    return file && isObject(file.c);                                       // 184
	  }                                                                        // 185
	                                                                           // 186
	  function fileMergeContents(file, contents, options) {                    // 187
	    // If contents is an array of strings and functions, return the last   // 188
	    // function with a `.d` property containing all the strings.           // 189
	    if (Array.isArray(contents)) {                                         // 190
	      var deps = [];                                                       // 191
	                                                                           // 192
	      contents.forEach(function (item) {                                   // 193
	        if (isString(item)) {                                              // 194
	          deps.push(item);                                                 // 195
	        } else if (isFunction(item)) {                                     // 196
	          contents = item;                                                 // 197
	        }                                                                  // 198
	      });                                                                  // 199
	                                                                           // 200
	      if (isFunction(contents)) {                                          // 201
	        contents.d = deps;                                                 // 202
	      } else {                                                             // 203
	        // If the array did not contain a function, merge nothing.         // 204
	        contents = null;                                                   // 205
	      }                                                                    // 206
	                                                                           // 207
	    } else if (isFunction(contents)) {                                     // 208
	      // If contents is already a function, make sure it has `.d`.         // 209
	      contents.d = contents.d || [];                                       // 210
	                                                                           // 211
	    } else if (! isString(contents) &&                                     // 212
	               ! isObject(contents)) {                                     // 213
	      // If contents is neither an array nor a function nor a string nor   // 214
	      // an object, just give up and merge nothing.                        // 215
	      contents = null;                                                     // 216
	    }                                                                      // 217
	                                                                           // 218
	    if (contents) {                                                        // 219
	      file.c = file.c || (isObject(contents) ? {} : contents);             // 220
	      if (isObject(contents) && fileIsDirectory(file)) {                   // 221
	        Object.keys(contents).forEach(function (key) {                     // 222
	          if (key === "..") {                                              // 223
	            child = file.p;                                                // 224
	                                                                           // 225
	          } else {                                                         // 226
	            var child = getOwn(file.c, key);                               // 227
	            if (! child) {                                                 // 228
	              child = file.c[key] = new File(                              // 229
	                file.m.id.replace(/\/*$/, "/") + key,                      // 230
	                file                                                       // 231
	              );                                                           // 232
	                                                                           // 233
	              child.o = options;                                           // 234
	            }                                                              // 235
	          }                                                                // 236
	                                                                           // 237
	          fileMergeContents(child, contents[key], options);                // 238
	        });                                                                // 239
	      }                                                                    // 240
	    }                                                                      // 241
	  }                                                                        // 242
	                                                                           // 243
	  function fileGetExtensions(file) {                                       // 244
	    return file.o && file.o.extensions || defaultExtensions;               // 245
	  }                                                                        // 246
	                                                                           // 247
	  function fileAppendIdPart(file, part, extensions) {                      // 248
	    // Always append relative to a directory.                              // 249
	    while (file && ! fileIsDirectory(file)) {                              // 250
	      file = file.p;                                                       // 251
	    }                                                                      // 252
	                                                                           // 253
	    if (! file || ! part || part === ".") {                                // 254
	      return file;                                                         // 255
	    }                                                                      // 256
	                                                                           // 257
	    if (part === "..") {                                                   // 258
	      return file.p;                                                       // 259
	    }                                                                      // 260
	                                                                           // 261
	    var exactChild = getOwn(file.c, part);                                 // 262
	                                                                           // 263
	    // Only consider multiple file extensions if this part is the last     // 264
	    // part of a module identifier and not equal to `.` or `..`, and there
	    // was no exact match or the exact match was a directory.              // 266
	    if (extensions && (! exactChild || fileIsDirectory(exactChild))) {     // 267
	      for (var e = 0; e < extensions.length; ++e) {                        // 268
	        var child = getOwn(file.c, part + extensions[e]);                  // 269
	        if (child) {                                                       // 270
	          return child;                                                    // 271
	        }                                                                  // 272
	      }                                                                    // 273
	    }                                                                      // 274
	                                                                           // 275
	    return exactChild;                                                     // 276
	  }                                                                        // 277
	                                                                           // 278
	  function fileAppendId(file, id, extensions) {                            // 279
	    var parts = id.split("/");                                             // 280
	                                                                           // 281
	    // Use `Array.prototype.every` to terminate iteration early if         // 282
	    // `fileAppendIdPart` returns a falsy value.                           // 283
	    parts.every(function (part, i) {                                       // 284
	      return file = i < parts.length - 1                                   // 285
	        ? fileAppendIdPart(file, part)                                     // 286
	        : fileAppendIdPart(file, part, extensions);                        // 287
	    });                                                                    // 288
	                                                                           // 289
	    return file;                                                           // 290
	  }                                                                        // 291
	                                                                           // 292
	  function fileResolve(file, id, seenDirFiles) {                           // 293
	    var extensions = fileGetExtensions(file);                              // 294
	                                                                           // 295
	    file =                                                                 // 296
	      // Absolute module identifiers (i.e. those that begin with a `/`     // 297
	      // character) are interpreted relative to the root directory, which  // 298
	      // is a slight deviation from Node, which has access to the entire   // 299
	      // file system.                                                      // 300
	      id.charAt(0) === "/" ? fileAppendId(root, id, extensions) :          // 301
	      // Relative module identifiers are interpreted relative to the       // 302
	      // current file, naturally.                                          // 303
	      id.charAt(0) === "." ? fileAppendId(file, id, extensions) :          // 304
	      // Top-level module identifiers are interpreted as referring to      // 305
	      // packages in `node_modules` directories.                           // 306
	      nodeModulesLookup(file, id, extensions);                             // 307
	                                                                           // 308
	    // If the identifier resolves to a directory, we use the same logic as
	    // Node to find an `index.js` or `package.json` file to evaluate.      // 310
	    while (fileIsDirectory(file)) {                                        // 311
	      seenDirFiles = seenDirFiles || [];                                   // 312
	                                                                           // 313
	      // If the "main" field of a `package.json` file resolves to a        // 314
	      // directory we've already considered, then we should not attempt to
	      // read the same `package.json` file again. Using an array as a set  // 316
	      // is acceptable here because the number of directories to consider  // 317
	      // is rarely greater than 1 or 2. Also, using indexOf allows us to   // 318
	      // store File objects instead of strings.                            // 319
	      if (seenDirFiles.indexOf(file) < 0) {                                // 320
	        seenDirFiles.push(file);                                           // 321
	                                                                           // 322
	        var pkgJsonFile = fileAppendIdPart(file, "package.json");          // 323
	        var main = pkgJsonFile && fileEvaluate(pkgJsonFile).main;          // 324
	        if (isString(main)) {                                              // 325
	          // The "main" field of package.json does not have to begin with  // 326
	          // ./ to be considered relative, so first we try simply          // 327
	          // appending it to the directory path before falling back to a   // 328
	          // full fileResolve, which might return a package from a         // 329
	          // node_modules directory.                                       // 330
	          file = fileAppendId(file, main, extensions) ||                   // 331
	            fileResolve(file, main, seenDirFiles);                         // 332
	                                                                           // 333
	          if (file) {                                                      // 334
	            // The fileAppendId call above may have returned a directory,  // 335
	            // so continue the loop to make sure we resolve it to a        // 336
	            // non-directory file.                                         // 337
	            continue;                                                      // 338
	          }                                                                // 339
	        }                                                                  // 340
	      }                                                                    // 341
	                                                                           // 342
	      // If we didn't find a `package.json` file, or it didn't have a      // 343
	      // resolvable `.main` property, the only possibility left to         // 344
	      // consider is that this directory contains an `index.js` module.    // 345
	      // This assignment almost always terminates the while loop, because  // 346
	      // there's very little chance `fileIsDirectory(file)` will be true   // 347
	      // for the result of `fileAppendIdPart(file, "index.js")`. However,  // 348
	      // in principle it is remotely possible that a file called           // 349
	      // `index.js` could be a directory instead of a file.                // 350
	      file = fileAppendIdPart(file, "index.js");                           // 351
	    }                                                                      // 352
	                                                                           // 353
	    if (file && isString(file.c)) {                                        // 354
	      file = fileResolve(file, file.c, seenDirFiles);                      // 355
	    }                                                                      // 356
	                                                                           // 357
	    return file;                                                           // 358
	  };                                                                       // 359
	                                                                           // 360
	  function nodeModulesLookup(file, id, extensions) {                       // 361
	    if (isFunction(override)) {                                            // 362
	      id = override(id, file.m.id);                                        // 363
	    }                                                                      // 364
	                                                                           // 365
	    if (isString(id)) {                                                    // 366
	      for (var resolved; file && ! resolved; file = file.p) {              // 367
	        resolved = fileIsDirectory(file) &&                                // 368
	          fileAppendId(file, "node_modules/" + id, extensions);            // 369
	      }                                                                    // 370
	                                                                           // 371
	      return resolved;                                                     // 372
	    }                                                                      // 373
	  }                                                                        // 374
	                                                                           // 375
	  return install;                                                          // 376
	};                                                                         // 377
	                                                                           // 378
	if (true) {                                         // 379
	  exports.makeInstaller = makeInstaller;                                   // 380
	}                                                                          // 381
	                                                                           // 382
	/////////////////////////////////////////////////////////////////////////////
	
	
	
	
	
	
	
	(function(){
	
	/////////////////////////////////////////////////////////////////////////////
	//                                                                         //
	// packages/modules-runtime/modules-runtime.js                             //
	//                                                                         //
	/////////////////////////////////////////////////////////////////////////////
	                                                                           //
	var options = {};                                                          // 1
	var hasOwn = options.hasOwnProperty;                                       // 2
	                                                                           // 3
	// RegExp matching strings that don't start with a `.` or a `/`.           // 4
	var topLevelIdPattern = /^[^./]/;                                          // 5
	                                                                           // 6
	if (typeof Profile === "function" &&                                       // 7
	    process.env.METEOR_PROFILE) {                                          // 8
	  options.wrapRequire = function (require) {                               // 9
	    return Profile(function (id) {                                         // 10
	      return "require(" + JSON.stringify(id) + ")";                        // 11
	    }, require);                                                           // 12
	  };                                                                       // 13
	}                                                                          // 14
	                                                                           // 15
	// This function will be called whenever a module identifier that hasn't   // 16
	// been installed is required. For backwards compatibility, and so that we
	// can require binary dependencies on the server, we implement the         // 18
	// fallback in terms of Npm.require.                                       // 19
	options.fallback = function (id, parentId, error) {                        // 20
	  // For simplicity, we honor only top-level module identifiers here.      // 21
	  // We could try to honor relative and absolute module identifiers by     // 22
	  // somehow combining `id` with `dir`, but we'd have to be really careful
	  // that the resulting modules were located in a known directory (not     // 24
	  // some arbitrary location on the file system), and we only really need  // 25
	  // the fallback for dependencies installed in node_modules directories.  // 26
	  if (topLevelIdPattern.test(id)) {                                        // 27
	    if (typeof Npm === "object" &&                                         // 28
	        typeof Npm.require === "function") {                               // 29
	      return Npm.require(id);                                              // 30
	    }                                                                      // 31
	  }                                                                        // 32
	                                                                           // 33
	  throw error;                                                             // 34
	};                                                                         // 35
	                                                                           // 36
	options.fallback.resolve = function (id, parentId, error) {                // 37
	  if (Meteor.isServer &&                                                   // 38
	      topLevelIdPattern.test(id)) {                                        // 39
	    // Allow any top-level identifier to resolve to itself on the server,  // 40
	    // so that options.fallback can have a chance to handle it.            // 41
	    return id;                                                             // 42
	  }                                                                        // 43
	                                                                           // 44
	  throw error;                                                             // 45
	};                                                                         // 46
	                                                                           // 47
	meteorInstall = makeInstaller(options);                                    // 48
	var Mp = meteorInstall.Module.prototype;                                   // 49
	                                                                           // 50
	if (Meteor.isServer) {                                                     // 51
	  Mp.useNode = function () {                                               // 52
	    if (typeof npmRequire !== "function") {                                // 53
	      // Can't use Node if npmRequire is not defined.                      // 54
	      return false;                                                        // 55
	    }                                                                      // 56
	                                                                           // 57
	    var parts = this.id.split("/");                                        // 58
	    var start = 0;                                                         // 59
	    if (parts[start] === "") ++start;                                      // 60
	    if (parts[start] === "node_modules" &&                                 // 61
	        parts[start + 1] === "meteor") {                                   // 62
	      start += 2;                                                          // 63
	    }                                                                      // 64
	                                                                           // 65
	    if (parts.indexOf("node_modules", start) < 0) {                        // 66
	      // Don't try to use Node for modules that aren't in node_modules     // 67
	      // directories.                                                      // 68
	      return false;                                                        // 69
	    }                                                                      // 70
	                                                                           // 71
	    try {                                                                  // 72
	      npmRequire.resolve(this.id);                                         // 73
	    } catch (e) {                                                          // 74
	      return false;                                                        // 75
	    }                                                                      // 76
	                                                                           // 77
	    this.exports = npmRequire(this.id);                                    // 78
	                                                                           // 79
	    return true;                                                           // 80
	  };                                                                       // 81
	}                                                                          // 82
	                                                                           // 83
	/////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['modules-runtime'] = {}, {
	  meteorInstall: meteorInstall
	});
	
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/modules.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	var meteorInstall = Package['modules-runtime'].meteorInstall;
	
	/* Package-scope variables */
	var Buffer, process;
	
	var require = meteorInstall({"node_modules":{"meteor":{"modules":{"client.js":["./install-packages.js","./stubs.js","./buffer.js","./process.js","reify/lib/runtime","./css",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// packages/modules/client.js                                                                                          //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require("./install-packages.js");                                                                                      // 1
	require("./stubs.js");                                                                                                 // 2
	require("./buffer.js");                                                                                                // 3
	require("./process.js");                                                                                               // 4
	require("reify/lib/runtime").enable(module.constructor);                                                               // 5
	                                                                                                                       // 6
	exports.addStyles = require("./css").addStyles;                                                                        // 7
	                                                                                                                       // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"buffer.js":["buffer",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// packages/modules/buffer.js                                                                                          //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	try {                                                                                                                  // 1
	  Buffer = global.Buffer || require("buffer").Buffer;                                                                  // 2
	} catch (noBuffer) {}                                                                                                  // 3
	                                                                                                                       // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"css.js":function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// packages/modules/css.js                                                                                             //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var doc = document;                                                                                                    // 1
	var head = doc.getElementsByTagName("head").item(0);                                                                   // 2
	                                                                                                                       // 3
	exports.addStyles = function (css) {                                                                                   // 4
	  var style = doc.createElement("style");                                                                              // 5
	                                                                                                                       // 6
	  style.setAttribute("type", "text/css");                                                                              // 7
	                                                                                                                       // 8
	  // https://msdn.microsoft.com/en-us/library/ms535871(v=vs.85).aspx                                                   // 9
	  var internetExplorerSheetObject =                                                                                    // 10
	    style.sheet || // Edge/IE11.                                                                                       // 11
	    style.styleSheet; // Older IEs.                                                                                    // 12
	                                                                                                                       // 13
	  if (internetExplorerSheetObject) {                                                                                   // 14
	    internetExplorerSheetObject.cssText = css;                                                                         // 15
	  } else {                                                                                                             // 16
	    style.appendChild(doc.createTextNode(css));                                                                        // 17
	  }                                                                                                                    // 18
	                                                                                                                       // 19
	  return head.appendChild(style);                                                                                      // 20
	};                                                                                                                     // 21
	                                                                                                                       // 22
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"install-packages.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// packages/modules/install-packages.js                                                                                //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	function install(name, mainModule) {                                                                                   // 1
	  var meteorDir = {};                                                                                                  // 2
	                                                                                                                       // 3
	  // Given a package name <name>, install a stub module in the                                                         // 4
	  // /node_modules/meteor directory called <name>.js, so that                                                          // 5
	  // require.resolve("meteor/<name>") will always return                                                               // 6
	  // /node_modules/meteor/<name>.js instead of something like                                                          // 7
	  // /node_modules/meteor/<name>/index.js, in the rare but possible event                                              // 8
	  // that the package contains a file called index.js (#6590).                                                         // 9
	                                                                                                                       // 10
	  if (mainModule) {                                                                                                    // 11
	    meteorDir[name + ".js"] = [mainModule, function (require, e, module) {                                             // 12
	      module.exports = require(mainModule);                                                                            // 13
	    }];                                                                                                                // 14
	  } else {                                                                                                             // 15
	    // back compat with old Meteor packages                                                                            // 16
	    meteorDir[name + ".js"] = function (r, e, module) {                                                                // 17
	      module.exports = Package[name];                                                                                  // 18
	    };                                                                                                                 // 19
	  }                                                                                                                    // 20
	                                                                                                                       // 21
	  meteorInstall({                                                                                                      // 22
	    node_modules: {                                                                                                    // 23
	      meteor: meteorDir                                                                                                // 24
	    }                                                                                                                  // 25
	  });                                                                                                                  // 26
	}                                                                                                                      // 27
	                                                                                                                       // 28
	// This file will be modified during computeJsOutputFilesMap to include                                                // 29
	// install(<name>) calls for every Meteor package.                                                                     // 30
	                                                                                                                       // 31
	install("underscore");                                                                                                 // 32
	install("meteor");                                                                                                     // 33
	install("modules-runtime");                                                                                            // 34
	install("modules", "meteor/modules/client.js");                                                                        // 35
	install("promise", "meteor/promise/client.js");                                                                        // 36
	install("ecmascript-runtime", "meteor/ecmascript-runtime/runtime.js");                                                 // 37
	install("babel-compiler");                                                                                             // 38
	install("ecmascript");                                                                                                 // 39
	install("base64");                                                                                                     // 40
	install("ejson");                                                                                                      // 41
	install("id-map");                                                                                                     // 42
	install("ordered-dict");                                                                                               // 43
	install("tracker");                                                                                                    // 44
	install("babel-runtime", "meteor/babel-runtime/babel-runtime.js");                                                     // 45
	install("random");                                                                                                     // 46
	install("mongo-id");                                                                                                   // 47
	install("diff-sequence");                                                                                              // 48
	install("geojson-utils", "meteor/geojson-utils/main.js");                                                              // 49
	install("minimongo");                                                                                                  // 50
	install("check", "meteor/check/match.js");                                                                             // 51
	install("retry");                                                                                                      // 52
	install("ddp-common");                                                                                                 // 53
	install("ddp-client");                                                                                                 // 54
	install("ddp");                                                                                                        // 55
	install("ddp-server");                                                                                                 // 56
	install("allow-deny");                                                                                                 // 57
	install("mongo");                                                                                                      // 58
	install("webapp");                                                                                                     // 59
	install("autoupdate");                                                                                                 // 60
	install("dburles:collection-helpers");                                                                                 // 61
	install("ddp-rate-limiter");                                                                                           // 62
	install("localstorage");                                                                                               // 63
	install("callback-hook");                                                                                              // 64
	install("accounts-base", "meteor/accounts-base/client_main.js");                                                       // 65
	install("sha");                                                                                                        // 66
	install("srp");                                                                                                        // 67
	install("accounts-password");                                                                                          // 68
	install("deps");                                                                                                       // 69
	install("aldeed:simple-schema");                                                                                       // 70
	install("raix:eventemitter");                                                                                          // 71
	install("aldeed:collection2-core");                                                                                    // 72
	install("aldeed:schema-index");                                                                                        // 73
	install("aldeed:schema-deny");                                                                                         // 74
	install("aldeed:collection2");                                                                                         // 75
	install("reactive-dict");                                                                                              // 76
	install("session");                                                                                                    // 77
	install("email");                                                                                                      // 78
	install("matb33:collection-hooks");                                                                                    // 79
	install("mdg:validated-method");                                                                                       // 80
	install("url");                                                                                                        // 81
	install("http");                                                                                                       // 82
	install("meteorhacks:picker");                                                                                         // 83
	install("meteorhacks:cluster");                                                                                        // 84
	install("service-configuration");                                                                                      // 85
	install("mdg:validation-error");                                                                                       // 86
	                                                                                                                       // 87
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"process.js":["process",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// packages/modules/process.js                                                                                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	try {                                                                                                                  // 1
	  // The application can run `npm install process` to provide its own                                                  // 2
	  // process stub; otherwise this module will provide a partial stub.                                                  // 3
	  process = global.process || require("process");                                                                      // 4
	} catch (noProcess) {                                                                                                  // 5
	  process = {};                                                                                                        // 6
	}                                                                                                                      // 7
	                                                                                                                       // 8
	if (Meteor.isServer) {                                                                                                 // 9
	  // Make require("process") work on the server in all versions of Node.                                               // 10
	  meteorInstall({                                                                                                      // 11
	    node_modules: {                                                                                                    // 12
	      "process.js": function (r, e, module) {                                                                          // 13
	        module.exports = process;                                                                                      // 14
	      }                                                                                                                // 15
	    }                                                                                                                  // 16
	  });                                                                                                                  // 17
	} else {                                                                                                               // 18
	  process.platform = "browser";                                                                                        // 19
	  process.nextTick = process.nextTick || Meteor._setImmediate;                                                         // 20
	}                                                                                                                      // 21
	                                                                                                                       // 22
	if (typeof process.env !== "object") {                                                                                 // 23
	  process.env = {};                                                                                                    // 24
	}                                                                                                                      // 25
	                                                                                                                       // 26
	_.extend(process.env, meteorEnv);                                                                                      // 27
	                                                                                                                       // 28
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"stubs.js":["meteor-node-stubs",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// packages/modules/stubs.js                                                                                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	try {                                                                                                                  // 1
	  // When meteor-node-stubs is installed in the application's root                                                     // 2
	  // node_modules directory, requiring it here installs aliases for stubs                                              // 3
	  // for all Node built-in modules, such as fs, util, and http.                                                        // 4
	  require("meteor-node-stubs");                                                                                        // 5
	} catch (noStubs) {}                                                                                                   // 6
	                                                                                                                       // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"node_modules":{"reify":{"lib":{"runtime.js":["./entry.js","./utils.js",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/modules/node_modules/reify/lib/runtime.js                                                       //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var Entry = require("./entry.js").Entry;                                                                               // 1
	var utils = require("./utils.js");                                                                                     // 2
	                                                                                                                       // 3
	exports.enable = function (Module) {                                                                                   // 4
	  var Mp = Module.prototype;                                                                                           // 5
	                                                                                                                       // 6
	  if (typeof Mp.import === "function" &&                                                                               // 7
	      typeof Mp.export === "function") {                                                                               // 8
	    // If the Mp.{import,export} methods have already been                                                             // 9
	    // defined, abandon reification immediately.                                                                       // 10
	    return Module;                                                                                                     // 11
	  }                                                                                                                    // 12
	                                                                                                                       // 13
	  // Platform-specific code should implement this method however                                                       // 14
	  // appropriate. Module.prototype.resolve(id) should return an absolute                                               // 15
	  // version of the given module identifier, like require.resolve.                                                     // 16
	  Mp.resolve = Mp.resolve || function resolve(id) {                                                                    // 17
	    throw new Error("Module.prototype.resolve not implemented");                                                       // 18
	  };                                                                                                                   // 19
	                                                                                                                       // 20
	  // Platform-specific code should find a way to call this method whenever                                             // 21
	  // the module system is about to return module.exports from require. This                                            // 22
	  // might happen more than once per module, in case of dependency cycles,                                             // 23
	  // so we want Module.prototype.runModuleSetters to run each time.                                                    // 24
	  Mp.runModuleSetters = function runModuleSetters(valueToPassThrough) {                                                // 25
	    var entry = Entry.get(this.id);                                                                                    // 26
	    if (entry) {                                                                                                       // 27
	      entry.runModuleSetters(this);                                                                                    // 28
	    }                                                                                                                  // 29
	                                                                                                                       // 30
	    // Assignments to exported local variables get wrapped with calls to                                               // 31
	    // module.runModuleSetters, so module.runModuleSetters returns the                                                 // 32
	    // valueToPassThrough parameter to allow the value of the original                                                 // 33
	    // expression to pass through. For example,                                                                        // 34
	    //                                                                                                                 // 35
	    //   export var a = 1;                                                                                             // 36
	    //   console.log(a += 3);                                                                                          // 37
	    //                                                                                                                 // 38
	    // becomes                                                                                                         // 39
	    //                                                                                                                 // 40
	    //   module.export("a", () => a);                                                                                  // 41
	    //   var a = 1;                                                                                                    // 42
	    //   console.log(module.runModuleSetters(a += 3));                                                                 // 43
	    //                                                                                                                 // 44
	    // This ensures module.runModuleSetters runs immediately after the                                                 // 45
	    // assignment, and does not interfere with the larger computation.                                                 // 46
	    return valueToPassThrough;                                                                                         // 47
	  };                                                                                                                   // 48
	                                                                                                                       // 49
	  function setESModule(module) {                                                                                       // 50
	    var exports = module.exports;                                                                                      // 51
	    if (exports && typeof exports === "object") {                                                                      // 52
	      exports.__esModule = true;                                                                                       // 53
	    }                                                                                                                  // 54
	  }                                                                                                                    // 55
	                                                                                                                       // 56
	  Mp.import = function (id, setters) {                                                                                 // 57
	    var module = this;                                                                                                 // 58
	    setESModule(module);                                                                                               // 59
	                                                                                                                       // 60
	    var absoluteId = module.resolve(id);                                                                               // 61
	                                                                                                                       // 62
	    if (setters && typeof setters === "object") {                                                                      // 63
	      var entry = Entry.getOrCreate(absoluteId);                                                                       // 64
	      entry.addSetters(module, setters);                                                                               // 65
	    }                                                                                                                  // 66
	                                                                                                                       // 67
	    var countBefore = entry && entry.runCount;                                                                         // 68
	    var exports = typeof module.require === "function"                                                                 // 69
	      ? module.require(absoluteId)                                                                                     // 70
	      : require(absoluteId);                                                                                           // 71
	                                                                                                                       // 72
	    if (entry && entry.runCount === countBefore) {                                                                     // 73
	      // If require(absoluteId) didn't run any setters for this entry,                                                 // 74
	      // perhaps because it's not the first time this module has been                                                  // 75
	      // required, run the setters now using an object that passes as the                                              // 76
	      // real module object.                                                                                           // 77
	      entry.runModuleSetters({                                                                                         // 78
	        id: absoluteId,                                                                                                // 79
	        exports: exports,                                                                                              // 80
	        getExportByName: Mp.getExportByName                                                                            // 81
	      });                                                                                                              // 82
	    }                                                                                                                  // 83
	  };                                                                                                                   // 84
	                                                                                                                       // 85
	  // Register getter functions for local variables in the scope of an                                                  // 86
	  // export statement. The keys of the getters object are exported names,                                              // 87
	  // and the values are functions that return local values.                                                            // 88
	  Mp.export = function (getters) {                                                                                     // 89
	    var module = this;                                                                                                 // 90
	    setESModule(module);                                                                                               // 91
	                                                                                                                       // 92
	    if (utils.isPlainObject(getters)) {                                                                                // 93
	      Entry.getOrCreate(module.id).addGetters(getters);                                                                // 94
	    }                                                                                                                  // 95
	                                                                                                                       // 96
	    if (module.loaded) {                                                                                               // 97
	      // If the module has already been evaluated, then we need to trigger                                             // 98
	      // another round of entry.runModuleSetters calls, which begins by                                                // 99
	      // calling entry.runModuleGetters(module).                                                                       // 100
	      module.runModuleSetters();                                                                                       // 101
	    }                                                                                                                  // 102
	  };                                                                                                                   // 103
	                                                                                                                       // 104
	  // This method can be overridden by client code to implement custom export                                           // 105
	  // naming logic. The current implementation works well with Babel's                                                  // 106
	  // __esModule convention.                                                                                            // 107
	  Mp.getExportByName = function (name) {                                                                               // 108
	    var exports = this.exports;                                                                                        // 109
	                                                                                                                       // 110
	    if (name === "*") {                                                                                                // 111
	      return exports;                                                                                                  // 112
	    }                                                                                                                  // 113
	                                                                                                                       // 114
	    if (name === "default" &&                                                                                          // 115
	        ! (exports &&                                                                                                  // 116
	           typeof exports === "object" &&                                                                              // 117
	           exports.__esModule &&                                                                                       // 118
	           "default" in exports)) {                                                                                    // 119
	      return exports;                                                                                                  // 120
	    }                                                                                                                  // 121
	                                                                                                                       // 122
	    return exports && exports[name];                                                                                   // 123
	  };                                                                                                                   // 124
	                                                                                                                       // 125
	  return Module;                                                                                                       // 126
	};                                                                                                                     // 127
	                                                                                                                       // 128
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"entry.js":["./utils.js",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/modules/node_modules/reify/lib/entry.js                                                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var hasOwn = Object.prototype.hasOwnProperty;                                                                          // 1
	var entryMap = Object.create(null);                                                                                    // 2
	var utils = require("./utils.js");                                                                                     // 3
	                                                                                                                       // 4
	function Entry(id) {                                                                                                   // 5
	  // Same as module.id for this module.                                                                                // 6
	  this.id = id;                                                                                                        // 7
	  // The number of times this.runModuleSetters has been called.                                                        // 8
	  this.runCount = 0;                                                                                                   // 9
	  // Setters for assigning to local variables in parent modules.                                                       // 10
	  this.setters = Object.create(null);                                                                                  // 11
	  // Getters for local variables exported from this module.                                                            // 12
	  this.getters = Object.create(null);                                                                                  // 13
	}                                                                                                                      // 14
	                                                                                                                       // 15
	var Ep = Entry.prototype;                                                                                              // 16
	                                                                                                                       // 17
	Entry.get = function (id) {                                                                                            // 18
	  return entryMap[id] || null;                                                                                         // 19
	};                                                                                                                     // 20
	                                                                                                                       // 21
	Entry.getOrCreate = function (id) {                                                                                    // 22
	  return entryMap[id] = entryMap[id] || new Entry(id);                                                                 // 23
	};                                                                                                                     // 24
	                                                                                                                       // 25
	Ep.addSetters = function (parent, setters) {                                                                           // 26
	  var entry = this;                                                                                                    // 27
	                                                                                                                       // 28
	  Object.keys(setters).forEach(function (name) {                                                                       // 29
	    var setter = setters[name];                                                                                        // 30
	    if (typeof setter === "function" &&                                                                                // 31
	        // Ignore any requests for the exports.__esModule property."                                                   // 32
	        name !== "__esModule") {                                                                                       // 33
	      setter.parent = parent;                                                                                          // 34
	      (entry.setters[name] =                                                                                           // 35
	       entry.setters[name] || []                                                                                       // 36
	      ).push(setter);                                                                                                  // 37
	    }                                                                                                                  // 38
	  });                                                                                                                  // 39
	};                                                                                                                     // 40
	                                                                                                                       // 41
	Ep.addGetters = function (getters) {                                                                                   // 42
	  var entry = this;                                                                                                    // 43
	  Object.keys(getters).forEach(function (name) {                                                                       // 44
	    var getter = getters[name];                                                                                        // 45
	    if (typeof getter === "function" &&                                                                                // 46
	        // Ignore any requests for the exports.__esModule property."                                                   // 47
	        name !== "__esModule") {                                                                                       // 48
	      // Should this throw if hasOwn.call(this.getters, name)?                                                         // 49
	      entry.getters[name] = getter;                                                                                    // 50
	    }                                                                                                                  // 51
	  });                                                                                                                  // 52
	};                                                                                                                     // 53
	                                                                                                                       // 54
	function runModuleSetters(module) {                                                                                    // 55
	  var entry = entryMap[module.id];                                                                                     // 56
	  if (entry) {                                                                                                         // 57
	    entry.runModuleSetters(module);                                                                                    // 58
	  }                                                                                                                    // 59
	}                                                                                                                      // 60
	                                                                                                                       // 61
	function runModuleGetters(module) {                                                                                    // 62
	  var entry = entryMap[module.id];                                                                                     // 63
	  return entry ? entry.runModuleGetters(module) : 0;                                                                   // 64
	}                                                                                                                      // 65
	                                                                                                                       // 66
	Ep.runModuleGetters = function (module) {                                                                              // 67
	  var entry = this;                                                                                                    // 68
	  var changeCount = 0;                                                                                                 // 69
	                                                                                                                       // 70
	  Object.keys(entry.getters).forEach(function (name) {                                                                 // 71
	    if (entry.runGetter(module, name)) {                                                                               // 72
	      ++changeCount;                                                                                                   // 73
	    }                                                                                                                  // 74
	  });                                                                                                                  // 75
	                                                                                                                       // 76
	  return changeCount;                                                                                                  // 77
	};                                                                                                                     // 78
	                                                                                                                       // 79
	// Returns true iff the getter updated module.exports with a new value.                                                // 80
	Ep.runGetter = function (module, name) {                                                                               // 81
	  if (! hasOwn.call(this.getters, name)) {                                                                             // 82
	    return false;                                                                                                      // 83
	  }                                                                                                                    // 84
	                                                                                                                       // 85
	  var getter = this.getters[name];                                                                                     // 86
	  try {                                                                                                                // 87
	    var value = getter.call(module);                                                                                   // 88
	  } catch (e) {}                                                                                                       // 89
	  var exports = module.exports;                                                                                        // 90
	                                                                                                                       // 91
	  if (! hasOwn.call(exports, name) ||                                                                                  // 92
	      exports[name] !== value) {                                                                                       // 93
	    // We update module.exports[name] with the current value so that                                                   // 94
	    // CommonJS require calls remain consistent with module.import.                                                    // 95
	    exports[name] = value;                                                                                             // 96
	    return true;                                                                                                       // 97
	  }                                                                                                                    // 98
	                                                                                                                       // 99
	  return false;                                                                                                        // 100
	};                                                                                                                     // 101
	                                                                                                                       // 102
	// Called whenever module.exports might have changed, to trigger any                                                   // 103
	// setters associated with the newly exported values.                                                                  // 104
	Ep.runModuleSetters = function (module) {                                                                              // 105
	  var entry = this;                                                                                                    // 106
	  var names = Object.keys(entry.setters);                                                                              // 107
	                                                                                                                       // 108
	  // Make sure module.exports is up to date before we call                                                             // 109
	  // module.getExportByName(name).                                                                                     // 110
	  entry.runModuleGetters(module);                                                                                      // 111
	                                                                                                                       // 112
	  // Invoke the given callback once for every (setter, value, name) triple                                             // 113
	  // that needs to be called. Note that forEachSetter does not call any                                                // 114
	  // setters itself, only the given callback.                                                                          // 115
	  function forEachSetter(callback, context) {                                                                          // 116
	    names.forEach(function (name) {                                                                                    // 117
	      entry.setters[name].forEach(function (setter) {                                                                  // 118
	        var value = module.getExportByName(name);                                                                      // 119
	        if (name === "*") {                                                                                            // 120
	          Object.keys(value).forEach(function (name) {                                                                 // 121
	            call(setter, value[name], name);                                                                           // 122
	          });                                                                                                          // 123
	        } else {                                                                                                       // 124
	          call(setter, value, name);                                                                                   // 125
	        }                                                                                                              // 126
	      });                                                                                                              // 127
	    });                                                                                                                // 128
	                                                                                                                       // 129
	    function call(setter, value, name) {                                                                               // 130
	      if (name === "__esModule") {                                                                                     // 131
	        // Ignore setters asking for module.exports.__esModule.                                                        // 132
	        return;                                                                                                        // 133
	      }                                                                                                                // 134
	                                                                                                                       // 135
	      setter.last = setter.last || Object.create(null);                                                                // 136
	                                                                                                                       // 137
	      if (! hasOwn.call(setter.last, name) ||                                                                          // 138
	          setter.last[name] !== value) {                                                                               // 139
	        // Only invoke the callback if we have not called this setter                                                  // 140
	        // (with a value of this name) before, or the current value is                                                 // 141
	        // different from the last value we passed to this setter.                                                     // 142
	        return callback.apply(context, arguments);                                                                     // 143
	      }                                                                                                                // 144
	    }                                                                                                                  // 145
	  }                                                                                                                    // 146
	                                                                                                                       // 147
	  // Every three elements of this list form a (setter, value, name) triple                                             // 148
	  // that needs to be invoked.                                                                                         // 149
	  var settersToCall = [];                                                                                              // 150
	                                                                                                                       // 151
	  // Lazily-initialized objects mapping parent module identifiers to                                                   // 152
	  // relevant parent module objects and snapshots of their exports.                                                    // 153
	  var relevantParents;                                                                                                 // 154
	  var parentSnapshots;                                                                                                 // 155
	                                                                                                                       // 156
	  // Take snapshots of setter.parent.exports for any setters that we are                                               // 157
	  // planning to call, so that we can later determine if calling the                                                   // 158
	  // setters modified any of those exports objects.                                                                    // 159
	  forEachSetter(function (setter, value, name) {                                                                       // 160
	    var parent = setter.parent;                                                                                        // 161
	    parentSnapshots = parentSnapshots || Object.create(null);                                                          // 162
	    if (! hasOwn.call(parentSnapshots, parent.id)) {                                                                   // 163
	      relevantParents = relevantParents || Object.create(null);                                                        // 164
	      relevantParents[parent.id] = parent;                                                                             // 165
	      if (utils.isPlainObject(parent.exports)) {                                                                       // 166
	        // If parent.exports is an object, make a shallow clone of it so                                               // 167
	        // that we can see if it changes as a result of calling setters.                                               // 168
	        parentSnapshots[parent.id] = utils.assign({}, parent.exports);                                                 // 169
	      } else {                                                                                                         // 170
	        // If parent.exports is not an object, the "snapshot" is just the                                              // 171
	        // value of parent.exports.                                                                                    // 172
	        parentSnapshots[parent.id] = parent.exports;                                                                   // 173
	      }                                                                                                                // 174
	    }                                                                                                                  // 175
	                                                                                                                       // 176
	    // Push three elements at a time to avoid creating wrapper arrays for                                              // 177
	    // each (setter, value, name) triple. Note the i += 3 below.                                                       // 178
	    settersToCall.push(setter, value, name);                                                                           // 179
	  });                                                                                                                  // 180
	                                                                                                                       // 181
	  // Now call all the setters that we decided we need to call.                                                         // 182
	  for (var i = 0; i < settersToCall.length; i += 3) {                                                                  // 183
	    var setter = settersToCall[i];                                                                                     // 184
	    var value = settersToCall[i + 1];                                                                                  // 185
	    var name = settersToCall[i + 2];                                                                                   // 186
	    setter.call(module, setter.last[name] = value, name);                                                              // 187
	  }                                                                                                                    // 188
	                                                                                                                       // 189
	  ++entry.runCount;                                                                                                    // 190
	                                                                                                                       // 191
	  if (! relevantParents) {                                                                                             // 192
	    // If we never called takeSnapshot, then we can avoid checking                                                     // 193
	    // relevantParents and parentSnapshots below.                                                                      // 194
	    return;                                                                                                            // 195
	  }                                                                                                                    // 196
	                                                                                                                       // 197
	  // If any of the setters updated the module.exports of a parent module,                                              // 198
	  // or updated local variables that are exported by that parent module,                                               // 199
	  // then we must re-run any setters registered by that parent module.                                                 // 200
	  Object.keys(relevantParents).forEach(function (id) {                                                                 // 201
	    var parent = relevantParents[id];                                                                                  // 202
	                                                                                                                       // 203
	    if (runModuleGetters(parent) > 0) {                                                                                // 204
	      return runModuleSetters(parent);                                                                                 // 205
	    }                                                                                                                  // 206
	                                                                                                                       // 207
	    var exports = parent.exports;                                                                                      // 208
	    var snapshot = parentSnapshots[parent.id];                                                                         // 209
	    if (utils.shallowObjEqual(exports, snapshot)) {                                                                    // 210
	      // If parent.exports have not changed since we took the snapshot,                                                // 211
	      // then we do not need to run the parent's setters.                                                              // 212
	      return;                                                                                                          // 213
	    }                                                                                                                  // 214
	                                                                                                                       // 215
	    runModuleSetters(parent);                                                                                          // 216
	  });                                                                                                                  // 217
	};                                                                                                                     // 218
	                                                                                                                       // 219
	exports.Entry = Entry;                                                                                                 // 220
	                                                                                                                       // 221
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"utils.js":function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/meteor/modules/node_modules/reify/lib/utils.js                                                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var hasOwn = Object.prototype.hasOwnProperty;                                                                          // 1
	var objToStr = Object.prototype.toString;                                                                              // 2
	var objStr = objToStr.call({});                                                                                        // 3
	                                                                                                                       // 4
	function isPlainObject(value) {                                                                                        // 5
	  return objToStr.call(value) === objStr;                                                                              // 6
	}                                                                                                                      // 7
	exports.isPlainObject = isPlainObject;                                                                                 // 8
	                                                                                                                       // 9
	exports.assign = Object.assign || function (obj) {                                                                     // 10
	  var argc = arguments.length;                                                                                         // 11
	  for (var i = 1; i < argc; ++i) {                                                                                     // 12
	    var arg = arguments[i];                                                                                            // 13
	    if (arg && typeof arg === "object") {                                                                              // 14
	      var keys = Object.keys(arg);                                                                                     // 15
	      for (var k = 0; k < keys.length; ++k) {                                                                          // 16
	        var key = keys[k];                                                                                             // 17
	        obj[key] = arg[key];                                                                                           // 18
	      }                                                                                                                // 19
	    }                                                                                                                  // 20
	  }                                                                                                                    // 21
	  return obj;                                                                                                          // 22
	};                                                                                                                     // 23
	                                                                                                                       // 24
	exports.shallowObjEqual = function(a, b) {                                                                             // 25
	  if (a === b) {                                                                                                       // 26
	    return true;                                                                                                       // 27
	  }                                                                                                                    // 28
	                                                                                                                       // 29
	  if (! isPlainObject(a) ||                                                                                            // 30
	      ! isPlainObject(b)) {                                                                                            // 31
	    return false;                                                                                                      // 32
	  }                                                                                                                    // 33
	                                                                                                                       // 34
	  var aKeys = Object.keys(a);                                                                                          // 35
	  var bKeys = Object.keys(b);                                                                                          // 36
	                                                                                                                       // 37
	  if (aKeys.length !== bKeys.length) {                                                                                 // 38
	    return false;                                                                                                      // 39
	  }                                                                                                                    // 40
	                                                                                                                       // 41
	  return aKeys.every(function (key) {                                                                                  // 42
	    return hasOwn.call(b, key) &&                                                                                      // 43
	      a[key] === b[key];                                                                                               // 44
	  });                                                                                                                  // 45
	};                                                                                                                     // 46
	                                                                                                                       // 47
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}}}}}},"babel-runtime":{"regenerator":{"index.js":["regenerator-runtime",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/babel-runtime/regenerator/index.js                                                                     //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = require("regenerator-runtime");                                                                       // 1
	                                                                                                                       // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]},"helpers":{"classCallCheck.js":function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/babel-runtime/helpers/classCallCheck.js                                                                //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	"use strict";                                                                                                          // 1
	                                                                                                                       // 2
	exports.__esModule = true;                                                                                             // 3
	                                                                                                                       // 4
	exports.default = function (instance, Constructor) {                                                                   // 5
	  if (!(instance instanceof Constructor)) {                                                                            // 6
	    throw new TypeError("Cannot call a class as a function");                                                          // 7
	  }                                                                                                                    // 8
	};                                                                                                                     // 9
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"possibleConstructorReturn.js":["../helpers/typeof",function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/babel-runtime/helpers/possibleConstructorReturn.js                                                     //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	"use strict";                                                                                                          // 1
	                                                                                                                       // 2
	exports.__esModule = true;                                                                                             // 3
	                                                                                                                       // 4
	var _typeof2 = require("../helpers/typeof");                                                                           // 5
	                                                                                                                       // 6
	var _typeof3 = _interopRequireDefault(_typeof2);                                                                       // 7
	                                                                                                                       // 8
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }                        // 9
	                                                                                                                       // 10
	exports.default = function (self, call) {                                                                              // 11
	  if (!self) {                                                                                                         // 12
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");                             // 13
	  }                                                                                                                    // 14
	                                                                                                                       // 15
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};                                                                                                                     // 17
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"typeof.js":["../core-js/symbol/iterator","../core-js/symbol",function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/babel-runtime/helpers/typeof.js                                                                        //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	"use strict";                                                                                                          // 1
	                                                                                                                       // 2
	exports.__esModule = true;                                                                                             // 3
	                                                                                                                       // 4
	var _iterator = require("../core-js/symbol/iterator");                                                                 // 5
	                                                                                                                       // 6
	var _iterator2 = _interopRequireDefault(_iterator);                                                                    // 7
	                                                                                                                       // 8
	var _symbol = require("../core-js/symbol");                                                                            // 9
	                                                                                                                       // 10
	var _symbol2 = _interopRequireDefault(_symbol);                                                                        // 11
	                                                                                                                       // 12
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	                                                                                                                       // 14
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }                        // 15
	                                                                                                                       // 16
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);                                                      // 18
	} : function (obj) {                                                                                                   // 19
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};                                                                                                                     // 21
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"inherits.js":["../core-js/object/set-prototype-of","../core-js/object/create","../helpers/typeof",function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/babel-runtime/helpers/inherits.js                                                                      //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	"use strict";                                                                                                          // 1
	                                                                                                                       // 2
	exports.__esModule = true;                                                                                             // 3
	                                                                                                                       // 4
	var _setPrototypeOf = require("../core-js/object/set-prototype-of");                                                   // 5
	                                                                                                                       // 6
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);                                                        // 7
	                                                                                                                       // 8
	var _create = require("../core-js/object/create");                                                                     // 9
	                                                                                                                       // 10
	var _create2 = _interopRequireDefault(_create);                                                                        // 11
	                                                                                                                       // 12
	var _typeof2 = require("../helpers/typeof");                                                                           // 13
	                                                                                                                       // 14
	var _typeof3 = _interopRequireDefault(_typeof2);                                                                       // 15
	                                                                                                                       // 16
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }                        // 17
	                                                                                                                       // 18
	exports.default = function (subClass, superClass) {                                                                    // 19
	  if (typeof superClass !== "function" && superClass !== null) {                                                       // 20
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }                                                                                                                    // 22
	                                                                                                                       // 23
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {                                     // 24
	    constructor: {                                                                                                     // 25
	      value: subClass,                                                                                                 // 26
	      enumerable: false,                                                                                               // 27
	      writable: true,                                                                                                  // 28
	      configurable: true                                                                                               // 29
	    }                                                                                                                  // 30
	  });                                                                                                                  // 31
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};                                                                                                                     // 33
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]},"core-js":{"symbol":{"iterator.js":["core-js/library/fn/symbol/iterator",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/babel-runtime/core-js/symbol/iterator.js                                                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };                       // 1
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]},"symbol.js":["core-js/library/fn/symbol",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/babel-runtime/core-js/symbol.js                                                                        //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };                                // 1
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"object":{"set-prototype-of.js":["core-js/library/fn/object/set-prototype-of",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/babel-runtime/core-js/object/set-prototype-of.js                                                       //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };               // 1
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"create.js":["core-js/library/fn/object/create",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/babel-runtime/core-js/object/create.js                                                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };                         // 1
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]}}},"regenerator-runtime":{"package.json":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/regenerator-runtime/package.json                                                                       //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	exports.name = "regenerator-runtime";                                                                                  // 1
	exports.version = "0.11.1";                                                                                            // 2
	exports.main = "runtime-module.js";                                                                                    // 3
	                                                                                                                       // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"runtime-module.js":["./runtime",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/regenerator-runtime/runtime-module.js                                                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	/**                                                                                                                    // 1
	 * Copyright (c) 2014-present, Facebook, Inc.                                                                          // 2
	 *                                                                                                                     // 3
	 * This source code is licensed under the MIT license found in the                                                     // 4
	 * LICENSE file in the root directory of this source tree.                                                             // 5
	 */                                                                                                                    // 6
	                                                                                                                       // 7
	// This method of obtaining a reference to the global object needs to be                                               // 8
	// kept identical to the way it is obtained in runtime.js                                                              // 9
	var g = (function() { return this })() || Function("return this")();                                                   // 10
	                                                                                                                       // 11
	// Use `getOwnPropertyNames` because not all browsers support calling                                                  // 12
	// `hasOwnProperty` on the global `self` object in a worker. See #183.                                                 // 13
	var hadRuntime = g.regeneratorRuntime &&                                                                               // 14
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;                                                    // 15
	                                                                                                                       // 16
	// Save the old regeneratorRuntime in case it needs to be restored later.                                              // 17
	var oldRuntime = hadRuntime && g.regeneratorRuntime;                                                                   // 18
	                                                                                                                       // 19
	// Force reevalutation of runtime.js.                                                                                  // 20
	g.regeneratorRuntime = undefined;                                                                                      // 21
	                                                                                                                       // 22
	module.exports = require("./runtime");                                                                                 // 23
	                                                                                                                       // 24
	if (hadRuntime) {                                                                                                      // 25
	  // Restore the original runtime.                                                                                     // 26
	  g.regeneratorRuntime = oldRuntime;                                                                                   // 27
	} else {                                                                                                               // 28
	  // Remove the global property added by runtime.js.                                                                   // 29
	  try {                                                                                                                // 30
	    delete g.regeneratorRuntime;                                                                                       // 31
	  } catch(e) {                                                                                                         // 32
	    g.regeneratorRuntime = undefined;                                                                                  // 33
	  }                                                                                                                    // 34
	}                                                                                                                      // 35
	                                                                                                                       // 36
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"runtime.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/regenerator-runtime/runtime.js                                                                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	/**                                                                                                                    // 1
	 * Copyright (c) 2014-present, Facebook, Inc.                                                                          // 2
	 *                                                                                                                     // 3
	 * This source code is licensed under the MIT license found in the                                                     // 4
	 * LICENSE file in the root directory of this source tree.                                                             // 5
	 */                                                                                                                    // 6
	                                                                                                                       // 7
	!(function(global) {                                                                                                   // 8
	  "use strict";                                                                                                        // 9
	                                                                                                                       // 10
	  var Op = Object.prototype;                                                                                           // 11
	  var hasOwn = Op.hasOwnProperty;                                                                                      // 12
	  var undefined; // More compressible than void 0.                                                                     // 13
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};                                                            // 14
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";                                                               // 15
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";                                                // 16
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";                                                      // 17
	                                                                                                                       // 18
	  var inModule = typeof module === "object";                                                                           // 19
	  var runtime = global.regeneratorRuntime;                                                                             // 20
	  if (runtime) {                                                                                                       // 21
	    if (inModule) {                                                                                                    // 22
	      // If regeneratorRuntime is defined globally and we're in a module,                                              // 23
	      // make the exports object identical to regeneratorRuntime.                                                      // 24
	      module.exports = runtime;                                                                                        // 25
	    }                                                                                                                  // 26
	    // Don't bother evaluating the rest of this file if the runtime was                                                // 27
	    // already defined globally.                                                                                       // 28
	    return;                                                                                                            // 29
	  }                                                                                                                    // 30
	                                                                                                                       // 31
	  // Define the runtime globally (as expected by generated code) as either                                             // 32
	  // module.exports (if we're in a module) or a new, empty object.                                                     // 33
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};                                                // 34
	                                                                                                                       // 35
	  function wrap(innerFn, outerFn, self, tryLocsList) {                                                                 // 36
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.          // 37
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;                      // 38
	    var generator = Object.create(protoGenerator.prototype);                                                           // 39
	    var context = new Context(tryLocsList || []);                                                                      // 40
	                                                                                                                       // 41
	    // The ._invoke method unifies the implementations of the .next,                                                   // 42
	    // .throw, and .return methods.                                                                                    // 43
	    generator._invoke = makeInvokeMethod(innerFn, self, context);                                                      // 44
	                                                                                                                       // 45
	    return generator;                                                                                                  // 46
	  }                                                                                                                    // 47
	  runtime.wrap = wrap;                                                                                                 // 48
	                                                                                                                       // 49
	  // Try/catch helper to minimize deoptimizations. Returns a completion                                                // 50
	  // record like context.tryEntries[i].completion. This interface could                                                // 51
	  // have been (and was previously) designed to take a closure to be                                                   // 52
	  // invoked without arguments, but in all the cases we care about we                                                  // 53
	  // already have an existing method we want to call, so there's no need                                               // 54
	  // to create a new function object. We can even get away with assuming                                               // 55
	  // the method takes exactly one argument, since that happens to be true                                              // 56
	  // in every case, so we don't have to touch the arguments object. The                                                // 57
	  // only additional allocation required is the completion record, which                                               // 58
	  // has a stable shape and so hopefully should be cheap to allocate.                                                  // 59
	  function tryCatch(fn, obj, arg) {                                                                                    // 60
	    try {                                                                                                              // 61
	      return { type: "normal", arg: fn.call(obj, arg) };                                                               // 62
	    } catch (err) {                                                                                                    // 63
	      return { type: "throw", arg: err };                                                                              // 64
	    }                                                                                                                  // 65
	  }                                                                                                                    // 66
	                                                                                                                       // 67
	  var GenStateSuspendedStart = "suspendedStart";                                                                       // 68
	  var GenStateSuspendedYield = "suspendedYield";                                                                       // 69
	  var GenStateExecuting = "executing";                                                                                 // 70
	  var GenStateCompleted = "completed";                                                                                 // 71
	                                                                                                                       // 72
	  // Returning this object from the innerFn has the same effect as                                                     // 73
	  // breaking out of the dispatch switch statement.                                                                    // 74
	  var ContinueSentinel = {};                                                                                           // 75
	                                                                                                                       // 76
	  // Dummy constructor functions that we use as the .constructor and                                                   // 77
	  // .constructor.prototype properties for functions that return Generator                                             // 78
	  // objects. For full spec compliance, you may wish to configure your                                                 // 79
	  // minifier not to mangle the names of these two functions.                                                          // 80
	  function Generator() {}                                                                                              // 81
	  function GeneratorFunction() {}                                                                                      // 82
	  function GeneratorFunctionPrototype() {}                                                                             // 83
	                                                                                                                       // 84
	  // This is a polyfill for %IteratorPrototype% for environments that                                                  // 85
	  // don't natively support it.                                                                                        // 86
	  var IteratorPrototype = {};                                                                                          // 87
	  IteratorPrototype[iteratorSymbol] = function () {                                                                    // 88
	    return this;                                                                                                       // 89
	  };                                                                                                                   // 90
	                                                                                                                       // 91
	  var getProto = Object.getPrototypeOf;                                                                                // 92
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));                                            // 93
	  if (NativeIteratorPrototype &&                                                                                       // 94
	      NativeIteratorPrototype !== Op &&                                                                                // 95
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {                                                          // 96
	    // This environment has a native %IteratorPrototype%; use it instead                                               // 97
	    // of the polyfill.                                                                                                // 98
	    IteratorPrototype = NativeIteratorPrototype;                                                                       // 99
	  }                                                                                                                    // 100
	                                                                                                                       // 101
	  var Gp = GeneratorFunctionPrototype.prototype =                                                                      // 102
	    Generator.prototype = Object.create(IteratorPrototype);                                                            // 103
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;                                           // 104
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;                                                          // 105
	  GeneratorFunctionPrototype[toStringTagSymbol] =                                                                      // 106
	    GeneratorFunction.displayName = "GeneratorFunction";                                                               // 107
	                                                                                                                       // 108
	  // Helper for defining the .next, .throw, and .return methods of the                                                 // 109
	  // Iterator interface in terms of a single ._invoke method.                                                          // 110
	  function defineIteratorMethods(prototype) {                                                                          // 111
	    ["next", "throw", "return"].forEach(function(method) {                                                             // 112
	      prototype[method] = function(arg) {                                                                              // 113
	        return this._invoke(method, arg);                                                                              // 114
	      };                                                                                                               // 115
	    });                                                                                                                // 116
	  }                                                                                                                    // 117
	                                                                                                                       // 118
	  runtime.isGeneratorFunction = function(genFun) {                                                                     // 119
	    var ctor = typeof genFun === "function" && genFun.constructor;                                                     // 120
	    return ctor                                                                                                        // 121
	      ? ctor === GeneratorFunction ||                                                                                  // 122
	        // For the native GeneratorFunction constructor, the best we can                                               // 123
	        // do is to check its .name property.                                                                          // 124
	        (ctor.displayName || ctor.name) === "GeneratorFunction"                                                        // 125
	      : false;                                                                                                         // 126
	  };                                                                                                                   // 127
	                                                                                                                       // 128
	  runtime.mark = function(genFun) {                                                                                    // 129
	    if (Object.setPrototypeOf) {                                                                                       // 130
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);                                                       // 131
	    } else {                                                                                                           // 132
	      genFun.__proto__ = GeneratorFunctionPrototype;                                                                   // 133
	      if (!(toStringTagSymbol in genFun)) {                                                                            // 134
	        genFun[toStringTagSymbol] = "GeneratorFunction";                                                               // 135
	      }                                                                                                                // 136
	    }                                                                                                                  // 137
	    genFun.prototype = Object.create(Gp);                                                                              // 138
	    return genFun;                                                                                                     // 139
	  };                                                                                                                   // 140
	                                                                                                                       // 141
	  // Within the body of any async function, `await x` is transformed to                                                // 142
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test                                                 // 143
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is                                              // 144
	  // meant to be awaited.                                                                                              // 145
	  runtime.awrap = function(arg) {                                                                                      // 146
	    return { __await: arg };                                                                                           // 147
	  };                                                                                                                   // 148
	                                                                                                                       // 149
	  function AsyncIterator(generator) {                                                                                  // 150
	    function invoke(method, arg, resolve, reject) {                                                                    // 151
	      var record = tryCatch(generator[method], generator, arg);                                                        // 152
	      if (record.type === "throw") {                                                                                   // 153
	        reject(record.arg);                                                                                            // 154
	      } else {                                                                                                         // 155
	        var result = record.arg;                                                                                       // 156
	        var value = result.value;                                                                                      // 157
	        if (value &&                                                                                                   // 158
	            typeof value === "object" &&                                                                               // 159
	            hasOwn.call(value, "__await")) {                                                                           // 160
	          return Promise.resolve(value.__await).then(function(value) {                                                 // 161
	            invoke("next", value, resolve, reject);                                                                    // 162
	          }, function(err) {                                                                                           // 163
	            invoke("throw", err, resolve, reject);                                                                     // 164
	          });                                                                                                          // 165
	        }                                                                                                              // 166
	                                                                                                                       // 167
	        return Promise.resolve(value).then(function(unwrapped) {                                                       // 168
	          // When a yielded Promise is resolved, its final value becomes                                               // 169
	          // the .value of the Promise<{value,done}> result for the                                                    // 170
	          // current iteration. If the Promise is rejected, however, the                                               // 171
	          // result for this iteration will be rejected with the same                                                  // 172
	          // reason. Note that rejections of yielded Promises are not                                                  // 173
	          // thrown back into the generator function, as is the case                                                   // 174
	          // when an awaited Promise is rejected. This difference in                                                   // 175
	          // behavior between yield and await is important, because it                                                 // 176
	          // allows the consumer to decide what to do with the yielded                                                 // 177
	          // rejection (swallow it and continue, manually .throw it back                                               // 178
	          // into the generator, abandon iteration, whatever). With                                                    // 179
	          // await, by contrast, there is no opportunity to examine the                                                // 180
	          // rejection reason outside the generator function, so the                                                   // 181
	          // only option is to throw it from the await expression, and                                                 // 182
	          // let the generator function handle the exception.                                                          // 183
	          result.value = unwrapped;                                                                                    // 184
	          resolve(result);                                                                                             // 185
	        }, reject);                                                                                                    // 186
	      }                                                                                                                // 187
	    }                                                                                                                  // 188
	                                                                                                                       // 189
	    var previousPromise;                                                                                               // 190
	                                                                                                                       // 191
	    function enqueue(method, arg) {                                                                                    // 192
	      function callInvokeWithMethodAndArg() {                                                                          // 193
	        return new Promise(function(resolve, reject) {                                                                 // 194
	          invoke(method, arg, resolve, reject);                                                                        // 195
	        });                                                                                                            // 196
	      }                                                                                                                // 197
	                                                                                                                       // 198
	      return previousPromise =                                                                                         // 199
	        // If enqueue has been called before, then we want to wait until                                               // 200
	        // all previous Promises have been resolved before calling invoke,                                             // 201
	        // so that results are always delivered in the correct order. If                                               // 202
	        // enqueue has not been called before, then it is important to                                                 // 203
	        // call invoke immediately, without waiting on a callback to fire,                                             // 204
	        // so that the async generator function has the opportunity to do                                              // 205
	        // any necessary setup in a predictable way. This predictability                                               // 206
	        // is why the Promise constructor synchronously invokes its                                                    // 207
	        // executor callback, and why async functions synchronously                                                    // 208
	        // execute code before the first await. Since we implement simple                                              // 209
	        // async functions in terms of async generators, it is especially                                              // 210
	        // important to get this right, even though it requires care.                                                  // 211
	        previousPromise ? previousPromise.then(                                                                        // 212
	          callInvokeWithMethodAndArg,                                                                                  // 213
	          // Avoid propagating failures to Promises returned by later                                                  // 214
	          // invocations of the iterator.                                                                              // 215
	          callInvokeWithMethodAndArg                                                                                   // 216
	        ) : callInvokeWithMethodAndArg();                                                                              // 217
	    }                                                                                                                  // 218
	                                                                                                                       // 219
	    // Define the unified helper method that is used to implement .next,                                               // 220
	    // .throw, and .return (see defineIteratorMethods).                                                                // 221
	    this._invoke = enqueue;                                                                                            // 222
	  }                                                                                                                    // 223
	                                                                                                                       // 224
	  defineIteratorMethods(AsyncIterator.prototype);                                                                      // 225
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {                                                         // 226
	    return this;                                                                                                       // 227
	  };                                                                                                                   // 228
	  runtime.AsyncIterator = AsyncIterator;                                                                               // 229
	                                                                                                                       // 230
	  // Note that simple async functions are implemented on top of                                                        // 231
	  // AsyncIterator objects; they just return a Promise for the value of                                                // 232
	  // the final result produced by the iterator.                                                                        // 233
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {                                                      // 234
	    var iter = new AsyncIterator(                                                                                      // 235
	      wrap(innerFn, outerFn, self, tryLocsList)                                                                        // 236
	    );                                                                                                                 // 237
	                                                                                                                       // 238
	    return runtime.isGeneratorFunction(outerFn)                                                                        // 239
	      ? iter // If outerFn is a generator, return the full iterator.                                                   // 240
	      : iter.next().then(function(result) {                                                                            // 241
	          return result.done ? result.value : iter.next();                                                             // 242
	        });                                                                                                            // 243
	  };                                                                                                                   // 244
	                                                                                                                       // 245
	  function makeInvokeMethod(innerFn, self, context) {                                                                  // 246
	    var state = GenStateSuspendedStart;                                                                                // 247
	                                                                                                                       // 248
	    return function invoke(method, arg) {                                                                              // 249
	      if (state === GenStateExecuting) {                                                                               // 250
	        throw new Error("Generator is already running");                                                               // 251
	      }                                                                                                                // 252
	                                                                                                                       // 253
	      if (state === GenStateCompleted) {                                                                               // 254
	        if (method === "throw") {                                                                                      // 255
	          throw arg;                                                                                                   // 256
	        }                                                                                                              // 257
	                                                                                                                       // 258
	        // Be forgiving, per 25.3.3.3.3 of the spec:                                                                   // 259
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume                                   // 260
	        return doneResult();                                                                                           // 261
	      }                                                                                                                // 262
	                                                                                                                       // 263
	      context.method = method;                                                                                         // 264
	      context.arg = arg;                                                                                               // 265
	                                                                                                                       // 266
	      while (true) {                                                                                                   // 267
	        var delegate = context.delegate;                                                                               // 268
	        if (delegate) {                                                                                                // 269
	          var delegateResult = maybeInvokeDelegate(delegate, context);                                                 // 270
	          if (delegateResult) {                                                                                        // 271
	            if (delegateResult === ContinueSentinel) continue;                                                         // 272
	            return delegateResult;                                                                                     // 273
	          }                                                                                                            // 274
	        }                                                                                                              // 275
	                                                                                                                       // 276
	        if (context.method === "next") {                                                                               // 277
	          // Setting context._sent for legacy support of Babel's                                                       // 278
	          // function.sent implementation.                                                                             // 279
	          context.sent = context._sent = context.arg;                                                                  // 280
	                                                                                                                       // 281
	        } else if (context.method === "throw") {                                                                       // 282
	          if (state === GenStateSuspendedStart) {                                                                      // 283
	            state = GenStateCompleted;                                                                                 // 284
	            throw context.arg;                                                                                         // 285
	          }                                                                                                            // 286
	                                                                                                                       // 287
	          context.dispatchException(context.arg);                                                                      // 288
	                                                                                                                       // 289
	        } else if (context.method === "return") {                                                                      // 290
	          context.abrupt("return", context.arg);                                                                       // 291
	        }                                                                                                              // 292
	                                                                                                                       // 293
	        state = GenStateExecuting;                                                                                     // 294
	                                                                                                                       // 295
	        var record = tryCatch(innerFn, self, context);                                                                 // 296
	        if (record.type === "normal") {                                                                                // 297
	          // If an exception is thrown from innerFn, we leave state ===                                                // 298
	          // GenStateExecuting and loop back for another invocation.                                                   // 299
	          state = context.done                                                                                         // 300
	            ? GenStateCompleted                                                                                        // 301
	            : GenStateSuspendedYield;                                                                                  // 302
	                                                                                                                       // 303
	          if (record.arg === ContinueSentinel) {                                                                       // 304
	            continue;                                                                                                  // 305
	          }                                                                                                            // 306
	                                                                                                                       // 307
	          return {                                                                                                     // 308
	            value: record.arg,                                                                                         // 309
	            done: context.done                                                                                         // 310
	          };                                                                                                           // 311
	                                                                                                                       // 312
	        } else if (record.type === "throw") {                                                                          // 313
	          state = GenStateCompleted;                                                                                   // 314
	          // Dispatch the exception by looping back around to the                                                      // 315
	          // context.dispatchException(context.arg) call above.                                                        // 316
	          context.method = "throw";                                                                                    // 317
	          context.arg = record.arg;                                                                                    // 318
	        }                                                                                                              // 319
	      }                                                                                                                // 320
	    };                                                                                                                 // 321
	  }                                                                                                                    // 322
	                                                                                                                       // 323
	  // Call delegate.iterator[context.method](context.arg) and handle the                                                // 324
	  // result, either by returning a { value, done } result from the                                                     // 325
	  // delegate iterator, or by modifying context.method and context.arg,                                                // 326
	  // setting context.delegate to null, and returning the ContinueSentinel.                                             // 327
	  function maybeInvokeDelegate(delegate, context) {                                                                    // 328
	    var method = delegate.iterator[context.method];                                                                    // 329
	    if (method === undefined) {                                                                                        // 330
	      // A .throw or .return when the delegate iterator has no .throw                                                  // 331
	      // method always terminates the yield* loop.                                                                     // 332
	      context.delegate = null;                                                                                         // 333
	                                                                                                                       // 334
	      if (context.method === "throw") {                                                                                // 335
	        if (delegate.iterator.return) {                                                                                // 336
	          // If the delegate iterator has a return method, give it a                                                   // 337
	          // chance to clean up.                                                                                       // 338
	          context.method = "return";                                                                                   // 339
	          context.arg = undefined;                                                                                     // 340
	          maybeInvokeDelegate(delegate, context);                                                                      // 341
	                                                                                                                       // 342
	          if (context.method === "throw") {                                                                            // 343
	            // If maybeInvokeDelegate(context) changed context.method from                                             // 344
	            // "return" to "throw", let that override the TypeError below.                                             // 345
	            return ContinueSentinel;                                                                                   // 346
	          }                                                                                                            // 347
	        }                                                                                                              // 348
	                                                                                                                       // 349
	        context.method = "throw";                                                                                      // 350
	        context.arg = new TypeError(                                                                                   // 351
	          "The iterator does not provide a 'throw' method");                                                           // 352
	      }                                                                                                                // 353
	                                                                                                                       // 354
	      return ContinueSentinel;                                                                                         // 355
	    }                                                                                                                  // 356
	                                                                                                                       // 357
	    var record = tryCatch(method, delegate.iterator, context.arg);                                                     // 358
	                                                                                                                       // 359
	    if (record.type === "throw") {                                                                                     // 360
	      context.method = "throw";                                                                                        // 361
	      context.arg = record.arg;                                                                                        // 362
	      context.delegate = null;                                                                                         // 363
	      return ContinueSentinel;                                                                                         // 364
	    }                                                                                                                  // 365
	                                                                                                                       // 366
	    var info = record.arg;                                                                                             // 367
	                                                                                                                       // 368
	    if (! info) {                                                                                                      // 369
	      context.method = "throw";                                                                                        // 370
	      context.arg = new TypeError("iterator result is not an object");                                                 // 371
	      context.delegate = null;                                                                                         // 372
	      return ContinueSentinel;                                                                                         // 373
	    }                                                                                                                  // 374
	                                                                                                                       // 375
	    if (info.done) {                                                                                                   // 376
	      // Assign the result of the finished delegate to the temporary                                                   // 377
	      // variable specified by delegate.resultName (see delegateYield).                                                // 378
	      context[delegate.resultName] = info.value;                                                                       // 379
	                                                                                                                       // 380
	      // Resume execution at the desired location (see delegateYield).                                                 // 381
	      context.next = delegate.nextLoc;                                                                                 // 382
	                                                                                                                       // 383
	      // If context.method was "throw" but the delegate handled the                                                    // 384
	      // exception, let the outer generator proceed normally. If                                                       // 385
	      // context.method was "next", forget context.arg since it has been                                               // 386
	      // "consumed" by the delegate iterator. If context.method was                                                    // 387
	      // "return", allow the original .return call to continue in the                                                  // 388
	      // outer generator.                                                                                              // 389
	      if (context.method !== "return") {                                                                               // 390
	        context.method = "next";                                                                                       // 391
	        context.arg = undefined;                                                                                       // 392
	      }                                                                                                                // 393
	                                                                                                                       // 394
	    } else {                                                                                                           // 395
	      // Re-yield the result returned by the delegate method.                                                          // 396
	      return info;                                                                                                     // 397
	    }                                                                                                                  // 398
	                                                                                                                       // 399
	    // The delegate iterator is finished, so forget it and continue with                                               // 400
	    // the outer generator.                                                                                            // 401
	    context.delegate = null;                                                                                           // 402
	    return ContinueSentinel;                                                                                           // 403
	  }                                                                                                                    // 404
	                                                                                                                       // 405
	  // Define Generator.prototype.{next,throw,return} in terms of the                                                    // 406
	  // unified ._invoke helper method.                                                                                   // 407
	  defineIteratorMethods(Gp);                                                                                           // 408
	                                                                                                                       // 409
	  Gp[toStringTagSymbol] = "Generator";                                                                                 // 410
	                                                                                                                       // 411
	  // A Generator should always return itself as the iterator object when the                                           // 412
	  // @@iterator function is called on it. Some browsers' implementations of the                                        // 413
	  // iterator prototype chain incorrectly implement this, causing the Generator                                        // 414
	  // object to not be returned from this call. This ensures that doesn't happen.                                       // 415
	  // See https://github.com/facebook/regenerator/issues/274 for more details.                                          // 416
	  Gp[iteratorSymbol] = function() {                                                                                    // 417
	    return this;                                                                                                       // 418
	  };                                                                                                                   // 419
	                                                                                                                       // 420
	  Gp.toString = function() {                                                                                           // 421
	    return "[object Generator]";                                                                                       // 422
	  };                                                                                                                   // 423
	                                                                                                                       // 424
	  function pushTryEntry(locs) {                                                                                        // 425
	    var entry = { tryLoc: locs[0] };                                                                                   // 426
	                                                                                                                       // 427
	    if (1 in locs) {                                                                                                   // 428
	      entry.catchLoc = locs[1];                                                                                        // 429
	    }                                                                                                                  // 430
	                                                                                                                       // 431
	    if (2 in locs) {                                                                                                   // 432
	      entry.finallyLoc = locs[2];                                                                                      // 433
	      entry.afterLoc = locs[3];                                                                                        // 434
	    }                                                                                                                  // 435
	                                                                                                                       // 436
	    this.tryEntries.push(entry);                                                                                       // 437
	  }                                                                                                                    // 438
	                                                                                                                       // 439
	  function resetTryEntry(entry) {                                                                                      // 440
	    var record = entry.completion || {};                                                                               // 441
	    record.type = "normal";                                                                                            // 442
	    delete record.arg;                                                                                                 // 443
	    entry.completion = record;                                                                                         // 444
	  }                                                                                                                    // 445
	                                                                                                                       // 446
	  function Context(tryLocsList) {                                                                                      // 447
	    // The root entry object (effectively a try statement without a catch                                              // 448
	    // or a finally block) gives us a place to store values thrown from                                                // 449
	    // locations where there is no enclosing try statement.                                                            // 450
	    this.tryEntries = [{ tryLoc: "root" }];                                                                            // 451
	    tryLocsList.forEach(pushTryEntry, this);                                                                           // 452
	    this.reset(true);                                                                                                  // 453
	  }                                                                                                                    // 454
	                                                                                                                       // 455
	  runtime.keys = function(object) {                                                                                    // 456
	    var keys = [];                                                                                                     // 457
	    for (var key in object) {                                                                                          // 458
	      keys.push(key);                                                                                                  // 459
	    }                                                                                                                  // 460
	    keys.reverse();                                                                                                    // 461
	                                                                                                                       // 462
	    // Rather than returning an object with a next method, we keep                                                     // 463
	    // things simple and return the next function itself.                                                              // 464
	    return function next() {                                                                                           // 465
	      while (keys.length) {                                                                                            // 466
	        var key = keys.pop();                                                                                          // 467
	        if (key in object) {                                                                                           // 468
	          next.value = key;                                                                                            // 469
	          next.done = false;                                                                                           // 470
	          return next;                                                                                                 // 471
	        }                                                                                                              // 472
	      }                                                                                                                // 473
	                                                                                                                       // 474
	      // To avoid creating an additional object, we just hang the .value                                               // 475
	      // and .done properties off the next function object itself. This                                                // 476
	      // also ensures that the minifier will not anonymize the function.                                               // 477
	      next.done = true;                                                                                                // 478
	      return next;                                                                                                     // 479
	    };                                                                                                                 // 480
	  };                                                                                                                   // 481
	                                                                                                                       // 482
	  function values(iterable) {                                                                                          // 483
	    if (iterable) {                                                                                                    // 484
	      var iteratorMethod = iterable[iteratorSymbol];                                                                   // 485
	      if (iteratorMethod) {                                                                                            // 486
	        return iteratorMethod.call(iterable);                                                                          // 487
	      }                                                                                                                // 488
	                                                                                                                       // 489
	      if (typeof iterable.next === "function") {                                                                       // 490
	        return iterable;                                                                                               // 491
	      }                                                                                                                // 492
	                                                                                                                       // 493
	      if (!isNaN(iterable.length)) {                                                                                   // 494
	        var i = -1, next = function next() {                                                                           // 495
	          while (++i < iterable.length) {                                                                              // 496
	            if (hasOwn.call(iterable, i)) {                                                                            // 497
	              next.value = iterable[i];                                                                                // 498
	              next.done = false;                                                                                       // 499
	              return next;                                                                                             // 500
	            }                                                                                                          // 501
	          }                                                                                                            // 502
	                                                                                                                       // 503
	          next.value = undefined;                                                                                      // 504
	          next.done = true;                                                                                            // 505
	                                                                                                                       // 506
	          return next;                                                                                                 // 507
	        };                                                                                                             // 508
	                                                                                                                       // 509
	        return next.next = next;                                                                                       // 510
	      }                                                                                                                // 511
	    }                                                                                                                  // 512
	                                                                                                                       // 513
	    // Return an iterator with no values.                                                                              // 514
	    return { next: doneResult };                                                                                       // 515
	  }                                                                                                                    // 516
	  runtime.values = values;                                                                                             // 517
	                                                                                                                       // 518
	  function doneResult() {                                                                                              // 519
	    return { value: undefined, done: true };                                                                           // 520
	  }                                                                                                                    // 521
	                                                                                                                       // 522
	  Context.prototype = {                                                                                                // 523
	    constructor: Context,                                                                                              // 524
	                                                                                                                       // 525
	    reset: function(skipTempReset) {                                                                                   // 526
	      this.prev = 0;                                                                                                   // 527
	      this.next = 0;                                                                                                   // 528
	      // Resetting context._sent for legacy support of Babel's                                                         // 529
	      // function.sent implementation.                                                                                 // 530
	      this.sent = this._sent = undefined;                                                                              // 531
	      this.done = false;                                                                                               // 532
	      this.delegate = null;                                                                                            // 533
	                                                                                                                       // 534
	      this.method = "next";                                                                                            // 535
	      this.arg = undefined;                                                                                            // 536
	                                                                                                                       // 537
	      this.tryEntries.forEach(resetTryEntry);                                                                          // 538
	                                                                                                                       // 539
	      if (!skipTempReset) {                                                                                            // 540
	        for (var name in this) {                                                                                       // 541
	          // Not sure about the optimal order of these conditions:                                                     // 542
	          if (name.charAt(0) === "t" &&                                                                                // 543
	              hasOwn.call(this, name) &&                                                                               // 544
	              !isNaN(+name.slice(1))) {                                                                                // 545
	            this[name] = undefined;                                                                                    // 546
	          }                                                                                                            // 547
	        }                                                                                                              // 548
	      }                                                                                                                // 549
	    },                                                                                                                 // 550
	                                                                                                                       // 551
	    stop: function() {                                                                                                 // 552
	      this.done = true;                                                                                                // 553
	                                                                                                                       // 554
	      var rootEntry = this.tryEntries[0];                                                                              // 555
	      var rootRecord = rootEntry.completion;                                                                           // 556
	      if (rootRecord.type === "throw") {                                                                               // 557
	        throw rootRecord.arg;                                                                                          // 558
	      }                                                                                                                // 559
	                                                                                                                       // 560
	      return this.rval;                                                                                                // 561
	    },                                                                                                                 // 562
	                                                                                                                       // 563
	    dispatchException: function(exception) {                                                                           // 564
	      if (this.done) {                                                                                                 // 565
	        throw exception;                                                                                               // 566
	      }                                                                                                                // 567
	                                                                                                                       // 568
	      var context = this;                                                                                              // 569
	      function handle(loc, caught) {                                                                                   // 570
	        record.type = "throw";                                                                                         // 571
	        record.arg = exception;                                                                                        // 572
	        context.next = loc;                                                                                            // 573
	                                                                                                                       // 574
	        if (caught) {                                                                                                  // 575
	          // If the dispatched exception was caught by a catch block,                                                  // 576
	          // then let that catch block handle the exception normally.                                                  // 577
	          context.method = "next";                                                                                     // 578
	          context.arg = undefined;                                                                                     // 579
	        }                                                                                                              // 580
	                                                                                                                       // 581
	        return !! caught;                                                                                              // 582
	      }                                                                                                                // 583
	                                                                                                                       // 584
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {                                                          // 585
	        var entry = this.tryEntries[i];                                                                                // 586
	        var record = entry.completion;                                                                                 // 587
	                                                                                                                       // 588
	        if (entry.tryLoc === "root") {                                                                                 // 589
	          // Exception thrown outside of any try block that could handle                                               // 590
	          // it, so set the completion value of the entire function to                                                 // 591
	          // throw the exception.                                                                                      // 592
	          return handle("end");                                                                                        // 593
	        }                                                                                                              // 594
	                                                                                                                       // 595
	        if (entry.tryLoc <= this.prev) {                                                                               // 596
	          var hasCatch = hasOwn.call(entry, "catchLoc");                                                               // 597
	          var hasFinally = hasOwn.call(entry, "finallyLoc");                                                           // 598
	                                                                                                                       // 599
	          if (hasCatch && hasFinally) {                                                                                // 600
	            if (this.prev < entry.catchLoc) {                                                                          // 601
	              return handle(entry.catchLoc, true);                                                                     // 602
	            } else if (this.prev < entry.finallyLoc) {                                                                 // 603
	              return handle(entry.finallyLoc);                                                                         // 604
	            }                                                                                                          // 605
	                                                                                                                       // 606
	          } else if (hasCatch) {                                                                                       // 607
	            if (this.prev < entry.catchLoc) {                                                                          // 608
	              return handle(entry.catchLoc, true);                                                                     // 609
	            }                                                                                                          // 610
	                                                                                                                       // 611
	          } else if (hasFinally) {                                                                                     // 612
	            if (this.prev < entry.finallyLoc) {                                                                        // 613
	              return handle(entry.finallyLoc);                                                                         // 614
	            }                                                                                                          // 615
	                                                                                                                       // 616
	          } else {                                                                                                     // 617
	            throw new Error("try statement without catch or finally");                                                 // 618
	          }                                                                                                            // 619
	        }                                                                                                              // 620
	      }                                                                                                                // 621
	    },                                                                                                                 // 622
	                                                                                                                       // 623
	    abrupt: function(type, arg) {                                                                                      // 624
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {                                                          // 625
	        var entry = this.tryEntries[i];                                                                                // 626
	        if (entry.tryLoc <= this.prev &&                                                                               // 627
	            hasOwn.call(entry, "finallyLoc") &&                                                                        // 628
	            this.prev < entry.finallyLoc) {                                                                            // 629
	          var finallyEntry = entry;                                                                                    // 630
	          break;                                                                                                       // 631
	        }                                                                                                              // 632
	      }                                                                                                                // 633
	                                                                                                                       // 634
	      if (finallyEntry &&                                                                                              // 635
	          (type === "break" ||                                                                                         // 636
	           type === "continue") &&                                                                                     // 637
	          finallyEntry.tryLoc <= arg &&                                                                                // 638
	          arg <= finallyEntry.finallyLoc) {                                                                            // 639
	        // Ignore the finally entry if control is not jumping to a                                                     // 640
	        // location outside the try/catch block.                                                                       // 641
	        finallyEntry = null;                                                                                           // 642
	      }                                                                                                                // 643
	                                                                                                                       // 644
	      var record = finallyEntry ? finallyEntry.completion : {};                                                        // 645
	      record.type = type;                                                                                              // 646
	      record.arg = arg;                                                                                                // 647
	                                                                                                                       // 648
	      if (finallyEntry) {                                                                                              // 649
	        this.method = "next";                                                                                          // 650
	        this.next = finallyEntry.finallyLoc;                                                                           // 651
	        return ContinueSentinel;                                                                                       // 652
	      }                                                                                                                // 653
	                                                                                                                       // 654
	      return this.complete(record);                                                                                    // 655
	    },                                                                                                                 // 656
	                                                                                                                       // 657
	    complete: function(record, afterLoc) {                                                                             // 658
	      if (record.type === "throw") {                                                                                   // 659
	        throw record.arg;                                                                                              // 660
	      }                                                                                                                // 661
	                                                                                                                       // 662
	      if (record.type === "break" ||                                                                                   // 663
	          record.type === "continue") {                                                                                // 664
	        this.next = record.arg;                                                                                        // 665
	      } else if (record.type === "return") {                                                                           // 666
	        this.rval = this.arg = record.arg;                                                                             // 667
	        this.method = "return";                                                                                        // 668
	        this.next = "end";                                                                                             // 669
	      } else if (record.type === "normal" && afterLoc) {                                                               // 670
	        this.next = afterLoc;                                                                                          // 671
	      }                                                                                                                // 672
	                                                                                                                       // 673
	      return ContinueSentinel;                                                                                         // 674
	    },                                                                                                                 // 675
	                                                                                                                       // 676
	    finish: function(finallyLoc) {                                                                                     // 677
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {                                                          // 678
	        var entry = this.tryEntries[i];                                                                                // 679
	        if (entry.finallyLoc === finallyLoc) {                                                                         // 680
	          this.complete(entry.completion, entry.afterLoc);                                                             // 681
	          resetTryEntry(entry);                                                                                        // 682
	          return ContinueSentinel;                                                                                     // 683
	        }                                                                                                              // 684
	      }                                                                                                                // 685
	    },                                                                                                                 // 686
	                                                                                                                       // 687
	    "catch": function(tryLoc) {                                                                                        // 688
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {                                                          // 689
	        var entry = this.tryEntries[i];                                                                                // 690
	        if (entry.tryLoc === tryLoc) {                                                                                 // 691
	          var record = entry.completion;                                                                               // 692
	          if (record.type === "throw") {                                                                               // 693
	            var thrown = record.arg;                                                                                   // 694
	            resetTryEntry(entry);                                                                                      // 695
	          }                                                                                                            // 696
	          return thrown;                                                                                               // 697
	        }                                                                                                              // 698
	      }                                                                                                                // 699
	                                                                                                                       // 700
	      // The context.catch method must only be called with a location                                                  // 701
	      // argument that corresponds to a known catch block.                                                             // 702
	      throw new Error("illegal catch attempt");                                                                        // 703
	    },                                                                                                                 // 704
	                                                                                                                       // 705
	    delegateYield: function(iterable, resultName, nextLoc) {                                                           // 706
	      this.delegate = {                                                                                                // 707
	        iterator: values(iterable),                                                                                    // 708
	        resultName: resultName,                                                                                        // 709
	        nextLoc: nextLoc                                                                                               // 710
	      };                                                                                                               // 711
	                                                                                                                       // 712
	      if (this.method === "next") {                                                                                    // 713
	        // Deliberately forget the last sent value so that we don't                                                    // 714
	        // accidentally pass it on to the delegate.                                                                    // 715
	        this.arg = undefined;                                                                                          // 716
	      }                                                                                                                // 717
	                                                                                                                       // 718
	      return ContinueSentinel;                                                                                         // 719
	    }                                                                                                                  // 720
	  };                                                                                                                   // 721
	})(                                                                                                                    // 722
	  // In sloppy mode, unbound `this` refers to the global object, fallback to                                           // 723
	  // Function constructor if we're in global strict mode. That is sadly a form                                         // 724
	  // of indirect eval which violates Content Security Policy.                                                          // 725
	  (function() { return this })() || Function("return this")()                                                          // 726
	);                                                                                                                     // 727
	                                                                                                                       // 728
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}},"core-js":{"library":{"fn":{"symbol":{"iterator.js":["../../modules/es6.string.iterator","../../modules/web.dom.iterable","../../modules/_wks-ext",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/fn/symbol/iterator.js                                                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../../modules/es6.string.iterator');                                                                          // 1
	require('../../modules/web.dom.iterable');                                                                             // 2
	module.exports = require('../../modules/_wks-ext').f('iterator');                                                      // 3
	                                                                                                                       // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"index.js":["../../modules/es6.symbol","../../modules/es6.object.to-string","../../modules/es7.symbol.async-iterator","../../modules/es7.symbol.observable","../../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/fn/symbol/index.js                                                                     //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../../modules/es6.symbol');                                                                                   // 1
	require('../../modules/es6.object.to-string');                                                                         // 2
	require('../../modules/es7.symbol.async-iterator');                                                                    // 3
	require('../../modules/es7.symbol.observable');                                                                        // 4
	module.exports = require('../../modules/_core').Symbol;                                                                // 5
	                                                                                                                       // 6
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]},"object":{"set-prototype-of.js":["../../modules/es6.object.set-prototype-of","../../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/fn/object/set-prototype-of.js                                                          //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../../modules/es6.object.set-prototype-of');                                                                  // 1
	module.exports = require('../../modules/_core').Object.setPrototypeOf;                                                 // 2
	                                                                                                                       // 3
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"create.js":["../../modules/es6.object.create","../../modules/_core",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/fn/object/create.js                                                                    //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('../../modules/es6.object.create');                                                                            // 1
	var $Object = require('../../modules/_core').Object;                                                                   // 2
	module.exports = function create(P, D) {                                                                               // 3
	  return $Object.create(P, D);                                                                                         // 4
	};                                                                                                                     // 5
	                                                                                                                       // 6
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]}},"modules":{"es6.string.iterator.js":["./_string-at","./_iter-define",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/es6.string.iterator.js                                                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var $at = require('./_string-at')(true);                                                                               // 2
	                                                                                                                       // 3
	// 21.1.3.27 String.prototype[@@iterator]()                                                                            // 4
	require('./_iter-define')(String, 'String', function (iterated) {                                                      // 5
	  this._t = String(iterated); // target                                                                                // 6
	  this._i = 0;                // next index                                                                            // 7
	// 21.1.5.2.1 %StringIteratorPrototype%.next()                                                                         // 8
	}, function () {                                                                                                       // 9
	  var O = this._t;                                                                                                     // 10
	  var index = this._i;                                                                                                 // 11
	  var point;                                                                                                           // 12
	  if (index >= O.length) return { value: undefined, done: true };                                                      // 13
	  point = $at(O, index);                                                                                               // 14
	  this._i += point.length;                                                                                             // 15
	  return { value: point, done: false };                                                                                // 16
	});                                                                                                                    // 17
	                                                                                                                       // 18
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_string-at.js":["./_to-integer","./_defined",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_string-at.js                                                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var toInteger = require('./_to-integer');                                                                              // 1
	var defined = require('./_defined');                                                                                   // 2
	// true  -> String#at                                                                                                  // 3
	// false -> String#codePointAt                                                                                         // 4
	module.exports = function (TO_STRING) {                                                                                // 5
	  return function (that, pos) {                                                                                        // 6
	    var s = String(defined(that));                                                                                     // 7
	    var i = toInteger(pos);                                                                                            // 8
	    var l = s.length;                                                                                                  // 9
	    var a, b;                                                                                                          // 10
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;                                                            // 11
	    a = s.charCodeAt(i);                                                                                               // 12
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff                 // 13
	      ? TO_STRING ? s.charAt(i) : a                                                                                    // 14
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;                                   // 15
	  };                                                                                                                   // 16
	};                                                                                                                     // 17
	                                                                                                                       // 18
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_to-integer.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_to-integer.js                                                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 7.1.4 ToInteger                                                                                                     // 1
	var ceil = Math.ceil;                                                                                                  // 2
	var floor = Math.floor;                                                                                                // 3
	module.exports = function (it) {                                                                                       // 4
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);                                                            // 5
	};                                                                                                                     // 6
	                                                                                                                       // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_defined.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_defined.js                                                                    //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 7.2.1 RequireObjectCoercible(argument)                                                                              // 1
	module.exports = function (it) {                                                                                       // 2
	  if (it == undefined) throw TypeError("Can't call method on  " + it);                                                 // 3
	  return it;                                                                                                           // 4
	};                                                                                                                     // 5
	                                                                                                                       // 6
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_iter-define.js":["./_library","./_export","./_redefine","./_hide","./_iterators","./_iter-create","./_set-to-string-tag","./_object-gpo","./_wks",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_iter-define.js                                                                //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var LIBRARY = require('./_library');                                                                                   // 2
	var $export = require('./_export');                                                                                    // 3
	var redefine = require('./_redefine');                                                                                 // 4
	var hide = require('./_hide');                                                                                         // 5
	var Iterators = require('./_iterators');                                                                               // 6
	var $iterCreate = require('./_iter-create');                                                                           // 7
	var setToStringTag = require('./_set-to-string-tag');                                                                  // 8
	var getPrototypeOf = require('./_object-gpo');                                                                         // 9
	var ITERATOR = require('./_wks')('iterator');                                                                          // 10
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`                                // 11
	var FF_ITERATOR = '@@iterator';                                                                                        // 12
	var KEYS = 'keys';                                                                                                     // 13
	var VALUES = 'values';                                                                                                 // 14
	                                                                                                                       // 15
	var returnThis = function () { return this; };                                                                         // 16
	                                                                                                                       // 17
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {                                   // 18
	  $iterCreate(Constructor, NAME, next);                                                                                // 19
	  var getMethod = function (kind) {                                                                                    // 20
	    if (!BUGGY && kind in proto) return proto[kind];                                                                   // 21
	    switch (kind) {                                                                                                    // 22
	      case KEYS: return function keys() { return new Constructor(this, kind); };                                       // 23
	      case VALUES: return function values() { return new Constructor(this, kind); };                                   // 24
	    } return function entries() { return new Constructor(this, kind); };                                               // 25
	  };                                                                                                                   // 26
	  var TAG = NAME + ' Iterator';                                                                                        // 27
	  var DEF_VALUES = DEFAULT == VALUES;                                                                                  // 28
	  var VALUES_BUG = false;                                                                                              // 29
	  var proto = Base.prototype;                                                                                          // 30
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];                                    // 31
	  var $default = $native || getMethod(DEFAULT);                                                                        // 32
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;                                  // 33
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;                                               // 34
	  var methods, key, IteratorPrototype;                                                                                 // 35
	  // Fix native                                                                                                        // 36
	  if ($anyNative) {                                                                                                    // 37
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));                                                   // 38
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {                                            // 39
	      // Set @@toStringTag to native iterators                                                                         // 40
	      setToStringTag(IteratorPrototype, TAG, true);                                                                    // 41
	      // fix for some old engines                                                                                      // 42
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }                                                                                                                  // 44
	  }                                                                                                                    // 45
	  // fix Array#{values, @@iterator}.name in V8 / FF                                                                    // 46
	  if (DEF_VALUES && $native && $native.name !== VALUES) {                                                              // 47
	    VALUES_BUG = true;                                                                                                 // 48
	    $default = function values() { return $native.call(this); };                                                       // 49
	  }                                                                                                                    // 50
	  // Define iterator                                                                                                   // 51
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {                                             // 52
	    hide(proto, ITERATOR, $default);                                                                                   // 53
	  }                                                                                                                    // 54
	  // Plug for library                                                                                                  // 55
	  Iterators[NAME] = $default;                                                                                          // 56
	  Iterators[TAG] = returnThis;                                                                                         // 57
	  if (DEFAULT) {                                                                                                       // 58
	    methods = {                                                                                                        // 59
	      values: DEF_VALUES ? $default : getMethod(VALUES),                                                               // 60
	      keys: IS_SET ? $default : getMethod(KEYS),                                                                       // 61
	      entries: $entries                                                                                                // 62
	    };                                                                                                                 // 63
	    if (FORCED) for (key in methods) {                                                                                 // 64
	      if (!(key in proto)) redefine(proto, key, methods[key]);                                                         // 65
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);                                      // 66
	  }                                                                                                                    // 67
	  return methods;                                                                                                      // 68
	};                                                                                                                     // 69
	                                                                                                                       // 70
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_library.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_library.js                                                                    //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = true;                                                                                                 // 1
	                                                                                                                       // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_export.js":["./_global","./_core","./_ctx","./_hide","./_has",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_export.js                                                                     //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var global = require('./_global');                                                                                     // 1
	var core = require('./_core');                                                                                         // 2
	var ctx = require('./_ctx');                                                                                           // 3
	var hide = require('./_hide');                                                                                         // 4
	var has = require('./_has');                                                                                           // 5
	var PROTOTYPE = 'prototype';                                                                                           // 6
	                                                                                                                       // 7
	var $export = function (type, name, source) {                                                                          // 8
	  var IS_FORCED = type & $export.F;                                                                                    // 9
	  var IS_GLOBAL = type & $export.G;                                                                                    // 10
	  var IS_STATIC = type & $export.S;                                                                                    // 11
	  var IS_PROTO = type & $export.P;                                                                                     // 12
	  var IS_BIND = type & $export.B;                                                                                      // 13
	  var IS_WRAP = type & $export.W;                                                                                      // 14
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});                                                    // 15
	  var expProto = exports[PROTOTYPE];                                                                                   // 16
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];                        // 17
	  var key, own, out;                                                                                                   // 18
	  if (IS_GLOBAL) source = name;                                                                                        // 19
	  for (key in source) {                                                                                                // 20
	    // contains in native                                                                                              // 21
	    own = !IS_FORCED && target && target[key] !== undefined;                                                           // 22
	    if (own && has(exports, key)) continue;                                                                            // 23
	    // export native or passed                                                                                         // 24
	    out = own ? target[key] : source[key];                                                                             // 25
	    // prevent global pollution for namespaces                                                                         // 26
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]                                         // 27
	    // bind timers to global for call from export context                                                              // 28
	    : IS_BIND && own ? ctx(out, global)                                                                                // 29
	    // wrap global constructors for prevent change them in library                                                     // 30
	    : IS_WRAP && target[key] == out ? (function (C) {                                                                  // 31
	      var F = function (a, b, c) {                                                                                     // 32
	        if (this instanceof C) {                                                                                       // 33
	          switch (arguments.length) {                                                                                  // 34
	            case 0: return new C();                                                                                    // 35
	            case 1: return new C(a);                                                                                   // 36
	            case 2: return new C(a, b);                                                                                // 37
	          } return new C(a, b, c);                                                                                     // 38
	        } return C.apply(this, arguments);                                                                             // 39
	      };                                                                                                               // 40
	      F[PROTOTYPE] = C[PROTOTYPE];                                                                                     // 41
	      return F;                                                                                                        // 42
	    // make static versions for prototype methods                                                                      // 43
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;                                    // 44
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%                                                       // 45
	    if (IS_PROTO) {                                                                                                    // 46
	      (exports.virtual || (exports.virtual = {}))[key] = out;                                                          // 47
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%                                                   // 48
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);                                    // 49
	    }                                                                                                                  // 50
	  }                                                                                                                    // 51
	};                                                                                                                     // 52
	// type bitmap                                                                                                         // 53
	$export.F = 1;   // forced                                                                                             // 54
	$export.G = 2;   // global                                                                                             // 55
	$export.S = 4;   // static                                                                                             // 56
	$export.P = 8;   // proto                                                                                              // 57
	$export.B = 16;  // bind                                                                                               // 58
	$export.W = 32;  // wrap                                                                                               // 59
	$export.U = 64;  // safe                                                                                               // 60
	$export.R = 128; // real proto method for `library`                                                                    // 61
	module.exports = $export;                                                                                              // 62
	                                                                                                                       // 63
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_global.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_global.js                                                                     //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028                                                // 1
	var global = module.exports = typeof window != 'undefined' && window.Math == Math                                      // 2
	  ? window : typeof self != 'undefined' && self.Math == Math ? self                                                    // 3
	  // eslint-disable-next-line no-new-func                                                                              // 4
	  : Function('return this')();                                                                                         // 5
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef                                              // 6
	                                                                                                                       // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_core.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_core.js                                                                       //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var core = module.exports = { version: '2.6.12' };                                                                     // 1
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef                                                // 2
	                                                                                                                       // 3
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_ctx.js":["./_a-function",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_ctx.js                                                                        //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// optional / simple context binding                                                                                   // 1
	var aFunction = require('./_a-function');                                                                              // 2
	module.exports = function (fn, that, length) {                                                                         // 3
	  aFunction(fn);                                                                                                       // 4
	  if (that === undefined) return fn;                                                                                   // 5
	  switch (length) {                                                                                                    // 6
	    case 1: return function (a) {                                                                                      // 7
	      return fn.call(that, a);                                                                                         // 8
	    };                                                                                                                 // 9
	    case 2: return function (a, b) {                                                                                   // 10
	      return fn.call(that, a, b);                                                                                      // 11
	    };                                                                                                                 // 12
	    case 3: return function (a, b, c) {                                                                                // 13
	      return fn.call(that, a, b, c);                                                                                   // 14
	    };                                                                                                                 // 15
	  }                                                                                                                    // 16
	  return function (/* ...args */) {                                                                                    // 17
	    return fn.apply(that, arguments);                                                                                  // 18
	  };                                                                                                                   // 19
	};                                                                                                                     // 20
	                                                                                                                       // 21
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_a-function.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_a-function.js                                                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = function (it) {                                                                                       // 1
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');                                            // 2
	  return it;                                                                                                           // 3
	};                                                                                                                     // 4
	                                                                                                                       // 5
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_hide.js":["./_object-dp","./_property-desc","./_descriptors",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_hide.js                                                                       //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var dP = require('./_object-dp');                                                                                      // 1
	var createDesc = require('./_property-desc');                                                                          // 2
	module.exports = require('./_descriptors') ? function (object, key, value) {                                           // 3
	  return dP.f(object, key, createDesc(1, value));                                                                      // 4
	} : function (object, key, value) {                                                                                    // 5
	  object[key] = value;                                                                                                 // 6
	  return object;                                                                                                       // 7
	};                                                                                                                     // 8
	                                                                                                                       // 9
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-dp.js":["./_an-object","./_ie8-dom-define","./_to-primitive","./_descriptors",function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_object-dp.js                                                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var anObject = require('./_an-object');                                                                                // 1
	var IE8_DOM_DEFINE = require('./_ie8-dom-define');                                                                     // 2
	var toPrimitive = require('./_to-primitive');                                                                          // 3
	var dP = Object.defineProperty;                                                                                        // 4
	                                                                                                                       // 5
	exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {            // 6
	  anObject(O);                                                                                                         // 7
	  P = toPrimitive(P, true);                                                                                            // 8
	  anObject(Attributes);                                                                                                // 9
	  if (IE8_DOM_DEFINE) try {                                                                                            // 10
	    return dP(O, P, Attributes);                                                                                       // 11
	  } catch (e) { /* empty */ }                                                                                          // 12
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');                         // 13
	  if ('value' in Attributes) O[P] = Attributes.value;                                                                  // 14
	  return O;                                                                                                            // 15
	};                                                                                                                     // 16
	                                                                                                                       // 17
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_an-object.js":["./_is-object",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_an-object.js                                                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var isObject = require('./_is-object');                                                                                // 1
	module.exports = function (it) {                                                                                       // 2
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');                                                       // 3
	  return it;                                                                                                           // 4
	};                                                                                                                     // 5
	                                                                                                                       // 6
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_is-object.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_is-object.js                                                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = function (it) {                                                                                       // 1
	  return typeof it === 'object' ? it !== null : typeof it === 'function';                                              // 2
	};                                                                                                                     // 3
	                                                                                                                       // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_ie8-dom-define.js":["./_descriptors","./_fails","./_dom-create",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_ie8-dom-define.js                                                             //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = !require('./_descriptors') && !require('./_fails')(function () {                                      // 1
	  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;       // 2
	});                                                                                                                    // 3
	                                                                                                                       // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_descriptors.js":["./_fails",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_descriptors.js                                                                //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// Thank's IE8 for his funny defineProperty                                                                            // 1
	module.exports = !require('./_fails')(function () {                                                                    // 2
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;                                    // 3
	});                                                                                                                    // 4
	                                                                                                                       // 5
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_fails.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_fails.js                                                                      //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = function (exec) {                                                                                     // 1
	  try {                                                                                                                // 2
	    return !!exec();                                                                                                   // 3
	  } catch (e) {                                                                                                        // 4
	    return true;                                                                                                       // 5
	  }                                                                                                                    // 6
	};                                                                                                                     // 7
	                                                                                                                       // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_dom-create.js":["./_is-object","./_global",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_dom-create.js                                                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var isObject = require('./_is-object');                                                                                // 1
	var document = require('./_global').document;                                                                          // 2
	// typeof document.createElement is 'object' in old IE                                                                 // 3
	var is = isObject(document) && isObject(document.createElement);                                                       // 4
	module.exports = function (it) {                                                                                       // 5
	  return is ? document.createElement(it) : {};                                                                         // 6
	};                                                                                                                     // 7
	                                                                                                                       // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_to-primitive.js":["./_is-object",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_to-primitive.js                                                               //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 7.1.1 ToPrimitive(input [, PreferredType])                                                                          // 1
	var isObject = require('./_is-object');                                                                                // 2
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case                                             // 3
	// and the second argument - flag - preferred type is a string                                                         // 4
	module.exports = function (it, S) {                                                                                    // 5
	  if (!isObject(it)) return it;                                                                                        // 6
	  var fn, val;                                                                                                         // 7
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;                        // 8
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;                              // 9
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;                       // 10
	  throw TypeError("Can't convert object to primitive value");                                                          // 11
	};                                                                                                                     // 12
	                                                                                                                       // 13
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_property-desc.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_property-desc.js                                                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = function (bitmap, value) {                                                                            // 1
	  return {                                                                                                             // 2
	    enumerable: !(bitmap & 1),                                                                                         // 3
	    configurable: !(bitmap & 2),                                                                                       // 4
	    writable: !(bitmap & 4),                                                                                           // 5
	    value: value                                                                                                       // 6
	  };                                                                                                                   // 7
	};                                                                                                                     // 8
	                                                                                                                       // 9
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_has.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_has.js                                                                        //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var hasOwnProperty = {}.hasOwnProperty;                                                                                // 1
	module.exports = function (it, key) {                                                                                  // 2
	  return hasOwnProperty.call(it, key);                                                                                 // 3
	};                                                                                                                     // 4
	                                                                                                                       // 5
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_redefine.js":["./_hide",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_redefine.js                                                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = require('./_hide');                                                                                   // 1
	                                                                                                                       // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_iterators.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_iterators.js                                                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = {};                                                                                                   // 1
	                                                                                                                       // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_iter-create.js":["./_object-create","./_property-desc","./_set-to-string-tag","./_hide","./_wks",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_iter-create.js                                                                //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var create = require('./_object-create');                                                                              // 2
	var descriptor = require('./_property-desc');                                                                          // 3
	var setToStringTag = require('./_set-to-string-tag');                                                                  // 4
	var IteratorPrototype = {};                                                                                            // 5
	                                                                                                                       // 6
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()                                                                        // 7
	require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });                    // 8
	                                                                                                                       // 9
	module.exports = function (Constructor, NAME, next) {                                                                  // 10
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });                                    // 11
	  setToStringTag(Constructor, NAME + ' Iterator');                                                                     // 12
	};                                                                                                                     // 13
	                                                                                                                       // 14
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-create.js":["./_an-object","./_object-dps","./_enum-bug-keys","./_shared-key","./_dom-create","./_html",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_object-create.js                                                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])                                                                 // 1
	var anObject = require('./_an-object');                                                                                // 2
	var dPs = require('./_object-dps');                                                                                    // 3
	var enumBugKeys = require('./_enum-bug-keys');                                                                         // 4
	var IE_PROTO = require('./_shared-key')('IE_PROTO');                                                                   // 5
	var Empty = function () { /* empty */ };                                                                               // 6
	var PROTOTYPE = 'prototype';                                                                                           // 7
	                                                                                                                       // 8
	// Create object with fake `null` prototype: use iframe Object with cleared prototype                                  // 9
	var createDict = function () {                                                                                         // 10
	  // Thrash, waste and sodomy: IE GC bug                                                                               // 11
	  var iframe = require('./_dom-create')('iframe');                                                                     // 12
	  var i = enumBugKeys.length;                                                                                          // 13
	  var lt = '<';                                                                                                        // 14
	  var gt = '>';                                                                                                        // 15
	  var iframeDocument;                                                                                                  // 16
	  iframe.style.display = 'none';                                                                                       // 17
	  require('./_html').appendChild(iframe);                                                                              // 18
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url                                                     // 19
	  // createDict = iframe.contentWindow.Object;                                                                         // 20
	  // html.removeChild(iframe);                                                                                         // 21
	  iframeDocument = iframe.contentWindow.document;                                                                      // 22
	  iframeDocument.open();                                                                                               // 23
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);                                // 24
	  iframeDocument.close();                                                                                              // 25
	  createDict = iframeDocument.F;                                                                                       // 26
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];                                                            // 27
	  return createDict();                                                                                                 // 28
	};                                                                                                                     // 29
	                                                                                                                       // 30
	module.exports = Object.create || function create(O, Properties) {                                                     // 31
	  var result;                                                                                                          // 32
	  if (O !== null) {                                                                                                    // 33
	    Empty[PROTOTYPE] = anObject(O);                                                                                    // 34
	    result = new Empty();                                                                                              // 35
	    Empty[PROTOTYPE] = null;                                                                                           // 36
	    // add "__proto__" for Object.getPrototypeOf polyfill                                                              // 37
	    result[IE_PROTO] = O;                                                                                              // 38
	  } else result = createDict();                                                                                        // 39
	  return Properties === undefined ? result : dPs(result, Properties);                                                  // 40
	};                                                                                                                     // 41
	                                                                                                                       // 42
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-dps.js":["./_object-dp","./_an-object","./_object-keys","./_descriptors",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_object-dps.js                                                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var dP = require('./_object-dp');                                                                                      // 1
	var anObject = require('./_an-object');                                                                                // 2
	var getKeys = require('./_object-keys');                                                                               // 3
	                                                                                                                       // 4
	module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {      // 5
	  anObject(O);                                                                                                         // 6
	  var keys = getKeys(Properties);                                                                                      // 7
	  var length = keys.length;                                                                                            // 8
	  var i = 0;                                                                                                           // 9
	  var P;                                                                                                               // 10
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);                                                            // 11
	  return O;                                                                                                            // 12
	};                                                                                                                     // 13
	                                                                                                                       // 14
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-keys.js":["./_object-keys-internal","./_enum-bug-keys",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_object-keys.js                                                                //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.14 / 15.2.3.14 Object.keys(O)                                                                                // 1
	var $keys = require('./_object-keys-internal');                                                                        // 2
	var enumBugKeys = require('./_enum-bug-keys');                                                                         // 3
	                                                                                                                       // 4
	module.exports = Object.keys || function keys(O) {                                                                     // 5
	  return $keys(O, enumBugKeys);                                                                                        // 6
	};                                                                                                                     // 7
	                                                                                                                       // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-keys-internal.js":["./_has","./_to-iobject","./_array-includes","./_shared-key",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_object-keys-internal.js                                                       //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var has = require('./_has');                                                                                           // 1
	var toIObject = require('./_to-iobject');                                                                              // 2
	var arrayIndexOf = require('./_array-includes')(false);                                                                // 3
	var IE_PROTO = require('./_shared-key')('IE_PROTO');                                                                   // 4
	                                                                                                                       // 5
	module.exports = function (object, names) {                                                                            // 6
	  var O = toIObject(object);                                                                                           // 7
	  var i = 0;                                                                                                           // 8
	  var result = [];                                                                                                     // 9
	  var key;                                                                                                             // 10
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);                                                 // 11
	  // Don't enum bug & hidden keys                                                                                      // 12
	  while (names.length > i) if (has(O, key = names[i++])) {                                                             // 13
	    ~arrayIndexOf(result, key) || result.push(key);                                                                    // 14
	  }                                                                                                                    // 15
	  return result;                                                                                                       // 16
	};                                                                                                                     // 17
	                                                                                                                       // 18
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_to-iobject.js":["./_iobject","./_defined",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_to-iobject.js                                                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// to indexed object, toObject with fallback for non-array-like ES3 strings                                            // 1
	var IObject = require('./_iobject');                                                                                   // 2
	var defined = require('./_defined');                                                                                   // 3
	module.exports = function (it) {                                                                                       // 4
	  return IObject(defined(it));                                                                                         // 5
	};                                                                                                                     // 6
	                                                                                                                       // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_iobject.js":["./_cof",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_iobject.js                                                                    //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// fallback for non-array-like ES3 and non-enumerable old V8 strings                                                   // 1
	var cof = require('./_cof');                                                                                           // 2
	// eslint-disable-next-line no-prototype-builtins                                                                      // 3
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {                                        // 4
	  return cof(it) == 'String' ? it.split('') : Object(it);                                                              // 5
	};                                                                                                                     // 6
	                                                                                                                       // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_cof.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_cof.js                                                                        //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var toString = {}.toString;                                                                                            // 1
	                                                                                                                       // 2
	module.exports = function (it) {                                                                                       // 3
	  return toString.call(it).slice(8, -1);                                                                               // 4
	};                                                                                                                     // 5
	                                                                                                                       // 6
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_array-includes.js":["./_to-iobject","./_to-length","./_to-absolute-index",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_array-includes.js                                                             //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// false -> Array#indexOf                                                                                              // 1
	// true  -> Array#includes                                                                                             // 2
	var toIObject = require('./_to-iobject');                                                                              // 3
	var toLength = require('./_to-length');                                                                                // 4
	var toAbsoluteIndex = require('./_to-absolute-index');                                                                 // 5
	module.exports = function (IS_INCLUDES) {                                                                              // 6
	  return function ($this, el, fromIndex) {                                                                             // 7
	    var O = toIObject($this);                                                                                          // 8
	    var length = toLength(O.length);                                                                                   // 9
	    var index = toAbsoluteIndex(fromIndex, length);                                                                    // 10
	    var value;                                                                                                         // 11
	    // Array#includes uses SameValueZero equality algorithm                                                            // 12
	    // eslint-disable-next-line no-self-compare                                                                        // 13
	    if (IS_INCLUDES && el != el) while (length > index) {                                                              // 14
	      value = O[index++];                                                                                              // 15
	      // eslint-disable-next-line no-self-compare                                                                      // 16
	      if (value != value) return true;                                                                                 // 17
	    // Array#indexOf ignores holes, Array#includes - not                                                               // 18
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {                                             // 19
	      if (O[index] === el) return IS_INCLUDES || index || 0;                                                           // 20
	    } return !IS_INCLUDES && -1;                                                                                       // 21
	  };                                                                                                                   // 22
	};                                                                                                                     // 23
	                                                                                                                       // 24
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_to-length.js":["./_to-integer",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_to-length.js                                                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 7.1.15 ToLength                                                                                                     // 1
	var toInteger = require('./_to-integer');                                                                              // 2
	var min = Math.min;                                                                                                    // 3
	module.exports = function (it) {                                                                                       // 4
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991                      // 5
	};                                                                                                                     // 6
	                                                                                                                       // 7
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_to-absolute-index.js":["./_to-integer",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_to-absolute-index.js                                                          //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var toInteger = require('./_to-integer');                                                                              // 1
	var max = Math.max;                                                                                                    // 2
	var min = Math.min;                                                                                                    // 3
	module.exports = function (index, length) {                                                                            // 4
	  index = toInteger(index);                                                                                            // 5
	  return index < 0 ? max(index + length, 0) : min(index, length);                                                      // 6
	};                                                                                                                     // 7
	                                                                                                                       // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_shared-key.js":["./_shared","./_uid",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_shared-key.js                                                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var shared = require('./_shared')('keys');                                                                             // 1
	var uid = require('./_uid');                                                                                           // 2
	module.exports = function (key) {                                                                                      // 3
	  return shared[key] || (shared[key] = uid(key));                                                                      // 4
	};                                                                                                                     // 5
	                                                                                                                       // 6
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_shared.js":["./_core","./_global","./_library",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_shared.js                                                                     //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var core = require('./_core');                                                                                         // 1
	var global = require('./_global');                                                                                     // 2
	var SHARED = '__core-js_shared__';                                                                                     // 3
	var store = global[SHARED] || (global[SHARED] = {});                                                                   // 4
	                                                                                                                       // 5
	(module.exports = function (key, value) {                                                                              // 6
	  return store[key] || (store[key] = value !== undefined ? value : {});                                                // 7
	})('versions', []).push({                                                                                              // 8
	  version: core.version,                                                                                               // 9
	  mode: require('./_library') ? 'pure' : 'global',                                                                     // 10
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'                                                                    // 11
	});                                                                                                                    // 12
	                                                                                                                       // 13
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_uid.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_uid.js                                                                        //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var id = 0;                                                                                                            // 1
	var px = Math.random();                                                                                                // 2
	module.exports = function (key) {                                                                                      // 3
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));                               // 4
	};                                                                                                                     // 5
	                                                                                                                       // 6
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_enum-bug-keys.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_enum-bug-keys.js                                                              //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// IE 8- don't enum bug keys                                                                                           // 1
	module.exports = (                                                                                                     // 2
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'                      // 3
	).split(',');                                                                                                          // 4
	                                                                                                                       // 5
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_html.js":["./_global",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_html.js                                                                       //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var document = require('./_global').document;                                                                          // 1
	module.exports = document && document.documentElement;                                                                 // 2
	                                                                                                                       // 3
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_set-to-string-tag.js":["./_object-dp","./_has","./_wks",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_set-to-string-tag.js                                                          //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var def = require('./_object-dp').f;                                                                                   // 1
	var has = require('./_has');                                                                                           // 2
	var TAG = require('./_wks')('toStringTag');                                                                            // 3
	                                                                                                                       // 4
	module.exports = function (it, tag, stat) {                                                                            // 5
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });                // 6
	};                                                                                                                     // 7
	                                                                                                                       // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_wks.js":["./_shared","./_uid","./_global",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_wks.js                                                                        //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var store = require('./_shared')('wks');                                                                               // 1
	var uid = require('./_uid');                                                                                           // 2
	var Symbol = require('./_global').Symbol;                                                                              // 3
	var USE_SYMBOL = typeof Symbol == 'function';                                                                          // 4
	                                                                                                                       // 5
	var $exports = module.exports = function (name) {                                                                      // 6
	  return store[name] || (store[name] =                                                                                 // 7
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));                                      // 8
	};                                                                                                                     // 9
	                                                                                                                       // 10
	$exports.store = store;                                                                                                // 11
	                                                                                                                       // 12
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-gpo.js":["./_has","./_to-object","./_shared-key",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_object-gpo.js                                                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)                                                                        // 1
	var has = require('./_has');                                                                                           // 2
	var toObject = require('./_to-object');                                                                                // 3
	var IE_PROTO = require('./_shared-key')('IE_PROTO');                                                                   // 4
	var ObjectProto = Object.prototype;                                                                                    // 5
	                                                                                                                       // 6
	module.exports = Object.getPrototypeOf || function (O) {                                                               // 7
	  O = toObject(O);                                                                                                     // 8
	  if (has(O, IE_PROTO)) return O[IE_PROTO];                                                                            // 9
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {                                              // 10
	    return O.constructor.prototype;                                                                                    // 11
	  } return O instanceof Object ? ObjectProto : null;                                                                   // 12
	};                                                                                                                     // 13
	                                                                                                                       // 14
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_to-object.js":["./_defined",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_to-object.js                                                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 7.1.13 ToObject(argument)                                                                                           // 1
	var defined = require('./_defined');                                                                                   // 2
	module.exports = function (it) {                                                                                       // 3
	  return Object(defined(it));                                                                                          // 4
	};                                                                                                                     // 5
	                                                                                                                       // 6
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"web.dom.iterable.js":["./es6.array.iterator","./_global","./_hide","./_iterators","./_wks",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/web.dom.iterable.js                                                            //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('./es6.array.iterator');                                                                                       // 1
	var global = require('./_global');                                                                                     // 2
	var hide = require('./_hide');                                                                                         // 3
	var Iterators = require('./_iterators');                                                                               // 4
	var TO_STRING_TAG = require('./_wks')('toStringTag');                                                                  // 5
	                                                                                                                       // 6
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +         // 7
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +   // 8
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +   // 9
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +     // 10
	  'TextTrackList,TouchList').split(',');                                                                               // 11
	                                                                                                                       // 12
	for (var i = 0; i < DOMIterables.length; i++) {                                                                        // 13
	  var NAME = DOMIterables[i];                                                                                          // 14
	  var Collection = global[NAME];                                                                                       // 15
	  var proto = Collection && Collection.prototype;                                                                      // 16
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);                                                // 17
	  Iterators[NAME] = Iterators.Array;                                                                                   // 18
	}                                                                                                                      // 19
	                                                                                                                       // 20
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.array.iterator.js":["./_add-to-unscopables","./_iter-step","./_iterators","./_to-iobject","./_iter-define",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/es6.array.iterator.js                                                          //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	var addToUnscopables = require('./_add-to-unscopables');                                                               // 2
	var step = require('./_iter-step');                                                                                    // 3
	var Iterators = require('./_iterators');                                                                               // 4
	var toIObject = require('./_to-iobject');                                                                              // 5
	                                                                                                                       // 6
	// 22.1.3.4 Array.prototype.entries()                                                                                  // 7
	// 22.1.3.13 Array.prototype.keys()                                                                                    // 8
	// 22.1.3.29 Array.prototype.values()                                                                                  // 9
	// 22.1.3.30 Array.prototype[@@iterator]()                                                                             // 10
	module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {                                 // 11
	  this._t = toIObject(iterated); // target                                                                             // 12
	  this._i = 0;                   // next index                                                                         // 13
	  this._k = kind;                // kind                                                                               // 14
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()                                                                          // 15
	}, function () {                                                                                                       // 16
	  var O = this._t;                                                                                                     // 17
	  var kind = this._k;                                                                                                  // 18
	  var index = this._i++;                                                                                               // 19
	  if (!O || index >= O.length) {                                                                                       // 20
	    this._t = undefined;                                                                                               // 21
	    return step(1);                                                                                                    // 22
	  }                                                                                                                    // 23
	  if (kind == 'keys') return step(0, index);                                                                           // 24
	  if (kind == 'values') return step(0, O[index]);                                                                      // 25
	  return step(0, [index, O[index]]);                                                                                   // 26
	}, 'values');                                                                                                          // 27
	                                                                                                                       // 28
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)                                                 // 29
	Iterators.Arguments = Iterators.Array;                                                                                 // 30
	                                                                                                                       // 31
	addToUnscopables('keys');                                                                                              // 32
	addToUnscopables('values');                                                                                            // 33
	addToUnscopables('entries');                                                                                           // 34
	                                                                                                                       // 35
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_add-to-unscopables.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_add-to-unscopables.js                                                         //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = function () { /* empty */ };                                                                          // 1
	                                                                                                                       // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_iter-step.js":function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_iter-step.js                                                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	module.exports = function (done, value) {                                                                              // 1
	  return { value: value, done: !!done };                                                                               // 2
	};                                                                                                                     // 3
	                                                                                                                       // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_wks-ext.js":["./_wks",function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_wks-ext.js                                                                    //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	exports.f = require('./_wks');                                                                                         // 1
	                                                                                                                       // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.symbol.js":["./_global","./_has","./_descriptors","./_export","./_redefine","./_meta","./_fails","./_shared","./_set-to-string-tag","./_uid","./_wks","./_wks-ext","./_wks-define","./_enum-keys","./_is-array","./_an-object","./_is-object","./_to-object","./_to-iobject","./_to-primitive","./_property-desc","./_object-create","./_object-gopn-ext","./_object-gopd","./_object-gops","./_object-dp","./_object-keys","./_object-gopn","./_object-pie","./_library","./_hide",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/es6.symbol.js                                                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	'use strict';                                                                                                          // 1
	// ECMAScript 6 symbols shim                                                                                           // 2
	var global = require('./_global');                                                                                     // 3
	var has = require('./_has');                                                                                           // 4
	var DESCRIPTORS = require('./_descriptors');                                                                           // 5
	var $export = require('./_export');                                                                                    // 6
	var redefine = require('./_redefine');                                                                                 // 7
	var META = require('./_meta').KEY;                                                                                     // 8
	var $fails = require('./_fails');                                                                                      // 9
	var shared = require('./_shared');                                                                                     // 10
	var setToStringTag = require('./_set-to-string-tag');                                                                  // 11
	var uid = require('./_uid');                                                                                           // 12
	var wks = require('./_wks');                                                                                           // 13
	var wksExt = require('./_wks-ext');                                                                                    // 14
	var wksDefine = require('./_wks-define');                                                                              // 15
	var enumKeys = require('./_enum-keys');                                                                                // 16
	var isArray = require('./_is-array');                                                                                  // 17
	var anObject = require('./_an-object');                                                                                // 18
	var isObject = require('./_is-object');                                                                                // 19
	var toObject = require('./_to-object');                                                                                // 20
	var toIObject = require('./_to-iobject');                                                                              // 21
	var toPrimitive = require('./_to-primitive');                                                                          // 22
	var createDesc = require('./_property-desc');                                                                          // 23
	var _create = require('./_object-create');                                                                             // 24
	var gOPNExt = require('./_object-gopn-ext');                                                                           // 25
	var $GOPD = require('./_object-gopd');                                                                                 // 26
	var $GOPS = require('./_object-gops');                                                                                 // 27
	var $DP = require('./_object-dp');                                                                                     // 28
	var $keys = require('./_object-keys');                                                                                 // 29
	var gOPD = $GOPD.f;                                                                                                    // 30
	var dP = $DP.f;                                                                                                        // 31
	var gOPN = gOPNExt.f;                                                                                                  // 32
	var $Symbol = global.Symbol;                                                                                           // 33
	var $JSON = global.JSON;                                                                                               // 34
	var _stringify = $JSON && $JSON.stringify;                                                                             // 35
	var PROTOTYPE = 'prototype';                                                                                           // 36
	var HIDDEN = wks('_hidden');                                                                                           // 37
	var TO_PRIMITIVE = wks('toPrimitive');                                                                                 // 38
	var isEnum = {}.propertyIsEnumerable;                                                                                  // 39
	var SymbolRegistry = shared('symbol-registry');                                                                        // 40
	var AllSymbols = shared('symbols');                                                                                    // 41
	var OPSymbols = shared('op-symbols');                                                                                  // 42
	var ObjectProto = Object[PROTOTYPE];                                                                                   // 43
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;                                                            // 44
	var QObject = global.QObject;                                                                                          // 45
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173                                      // 46
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;                                         // 47
	                                                                                                                       // 48
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687                                         // 49
	var setSymbolDesc = DESCRIPTORS && $fails(function () {                                                                // 50
	  return _create(dP({}, 'a', {                                                                                         // 51
	    get: function () { return dP(this, 'a', { value: 7 }).a; }                                                         // 52
	  })).a != 7;                                                                                                          // 53
	}) ? function (it, key, D) {                                                                                           // 54
	  var protoDesc = gOPD(ObjectProto, key);                                                                              // 55
	  if (protoDesc) delete ObjectProto[key];                                                                              // 56
	  dP(it, key, D);                                                                                                      // 57
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);                                                // 58
	} : dP;                                                                                                                // 59
	                                                                                                                       // 60
	var wrap = function (tag) {                                                                                            // 61
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);                                                             // 62
	  sym._k = tag;                                                                                                        // 63
	  return sym;                                                                                                          // 64
	};                                                                                                                     // 65
	                                                                                                                       // 66
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {                                     // 67
	  return typeof it == 'symbol';                                                                                        // 68
	} : function (it) {                                                                                                    // 69
	  return it instanceof $Symbol;                                                                                        // 70
	};                                                                                                                     // 71
	                                                                                                                       // 72
	var $defineProperty = function defineProperty(it, key, D) {                                                            // 73
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);                                                          // 74
	  anObject(it);                                                                                                        // 75
	  key = toPrimitive(key, true);                                                                                        // 76
	  anObject(D);                                                                                                         // 77
	  if (has(AllSymbols, key)) {                                                                                          // 78
	    if (!D.enumerable) {                                                                                               // 79
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));                                                         // 80
	      it[HIDDEN][key] = true;                                                                                          // 81
	    } else {                                                                                                           // 82
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;                                                 // 83
	      D = _create(D, { enumerable: createDesc(0, false) });                                                            // 84
	    } return setSymbolDesc(it, key, D);                                                                                // 85
	  } return dP(it, key, D);                                                                                             // 86
	};                                                                                                                     // 87
	var $defineProperties = function defineProperties(it, P) {                                                             // 88
	  anObject(it);                                                                                                        // 89
	  var keys = enumKeys(P = toIObject(P));                                                                               // 90
	  var i = 0;                                                                                                           // 91
	  var l = keys.length;                                                                                                 // 92
	  var key;                                                                                                             // 93
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);                                                          // 94
	  return it;                                                                                                           // 95
	};                                                                                                                     // 96
	var $create = function create(it, P) {                                                                                 // 97
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);                                            // 98
	};                                                                                                                     // 99
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {                                                       // 100
	  var E = isEnum.call(this, key = toPrimitive(key, true));                                                             // 101
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;                              // 102
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;           // 103
	};                                                                                                                     // 104
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {                                           // 105
	  it = toIObject(it);                                                                                                  // 106
	  key = toPrimitive(key, true);                                                                                        // 107
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;                                      // 108
	  var D = gOPD(it, key);                                                                                               // 109
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;                         // 110
	  return D;                                                                                                            // 111
	};                                                                                                                     // 112
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {                                                          // 113
	  var names = gOPN(toIObject(it));                                                                                     // 114
	  var result = [];                                                                                                     // 115
	  var i = 0;                                                                                                           // 116
	  var key;                                                                                                             // 117
	  while (names.length > i) {                                                                                           // 118
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);                          // 119
	  } return result;                                                                                                     // 120
	};                                                                                                                     // 121
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {                                                      // 122
	  var IS_OP = it === ObjectProto;                                                                                      // 123
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));                                                                 // 124
	  var result = [];                                                                                                     // 125
	  var i = 0;                                                                                                           // 126
	  var key;                                                                                                             // 127
	  while (names.length > i) {                                                                                           // 128
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);     // 129
	  } return result;                                                                                                     // 130
	};                                                                                                                     // 131
	                                                                                                                       // 132
	// 19.4.1.1 Symbol([description])                                                                                      // 133
	if (!USE_NATIVE) {                                                                                                     // 134
	  $Symbol = function Symbol() {                                                                                        // 135
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');                                      // 136
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);                                                    // 137
	    var $set = function (value) {                                                                                      // 138
	      if (this === ObjectProto) $set.call(OPSymbols, value);                                                           // 139
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;                                      // 140
	      setSymbolDesc(this, tag, createDesc(1, value));                                                                  // 141
	    };                                                                                                                 // 142
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });                     // 143
	    return wrap(tag);                                                                                                  // 144
	  };                                                                                                                   // 145
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {                                                       // 146
	    return this._k;                                                                                                    // 147
	  });                                                                                                                  // 148
	                                                                                                                       // 149
	  $GOPD.f = $getOwnPropertyDescriptor;                                                                                 // 150
	  $DP.f = $defineProperty;                                                                                             // 151
	  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;                                                      // 152
	  require('./_object-pie').f = $propertyIsEnumerable;                                                                  // 153
	  $GOPS.f = $getOwnPropertySymbols;                                                                                    // 154
	                                                                                                                       // 155
	  if (DESCRIPTORS && !require('./_library')) {                                                                         // 156
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);                                        // 157
	  }                                                                                                                    // 158
	                                                                                                                       // 159
	  wksExt.f = function (name) {                                                                                         // 160
	    return wrap(wks(name));                                                                                            // 161
	  };                                                                                                                   // 162
	}                                                                                                                      // 163
	                                                                                                                       // 164
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });                                         // 165
	                                                                                                                       // 166
	for (var es6Symbols = (                                                                                                // 167
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'     // 169
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);                                                      // 170
	                                                                                                                       // 171
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);   // 172
	                                                                                                                       // 173
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {                                                               // 174
	  // 19.4.2.1 Symbol.for(key)                                                                                          // 175
	  'for': function (key) {                                                                                              // 176
	    return has(SymbolRegistry, key += '')                                                                              // 177
	      ? SymbolRegistry[key]                                                                                            // 178
	      : SymbolRegistry[key] = $Symbol(key);                                                                            // 179
	  },                                                                                                                   // 180
	  // 19.4.2.5 Symbol.keyFor(sym)                                                                                       // 181
	  keyFor: function keyFor(sym) {                                                                                       // 182
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');                                                    // 183
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;                                       // 184
	  },                                                                                                                   // 185
	  useSetter: function () { setter = true; },                                                                           // 186
	  useSimple: function () { setter = false; }                                                                           // 187
	});                                                                                                                    // 188
	                                                                                                                       // 189
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {                                                               // 190
	  // 19.1.2.2 Object.create(O [, Properties])                                                                          // 191
	  create: $create,                                                                                                     // 192
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)                                                                  // 193
	  defineProperty: $defineProperty,                                                                                     // 194
	  // 19.1.2.3 Object.defineProperties(O, Properties)                                                                   // 195
	  defineProperties: $defineProperties,                                                                                 // 196
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)                                                                    // 197
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,                                                                 // 198
	  // 19.1.2.7 Object.getOwnPropertyNames(O)                                                                            // 199
	  getOwnPropertyNames: $getOwnPropertyNames,                                                                           // 200
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)                                                                          // 201
	  getOwnPropertySymbols: $getOwnPropertySymbols                                                                        // 202
	});                                                                                                                    // 203
	                                                                                                                       // 204
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives                                                 // 205
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443                                                                // 206
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });                                                         // 207
	                                                                                                                       // 208
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {                                                       // 209
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {                                                          // 210
	    return $GOPS.f(toObject(it));                                                                                      // 211
	  }                                                                                                                    // 212
	});                                                                                                                    // 213
	                                                                                                                       // 214
	// 24.3.2 JSON.stringify(value [, replacer [, space]])                                                                 // 215
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {                                          // 216
	  var S = $Symbol();                                                                                                   // 217
	  // MS Edge converts symbol values to JSON as {}                                                                      // 218
	  // WebKit converts symbol values to JSON as null                                                                     // 219
	  // V8 throws on boxed symbols                                                                                        // 220
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';                 // 221
	})), 'JSON', {                                                                                                         // 222
	  stringify: function stringify(it) {                                                                                  // 223
	    var args = [it];                                                                                                   // 224
	    var i = 1;                                                                                                         // 225
	    var replacer, $replacer;                                                                                           // 226
	    while (arguments.length > i) args.push(arguments[i++]);                                                            // 227
	    $replacer = replacer = args[1];                                                                                    // 228
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined            // 229
	    if (!isArray(replacer)) replacer = function (key, value) {                                                         // 230
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);                                    // 231
	      if (!isSymbol(value)) return value;                                                                              // 232
	    };                                                                                                                 // 233
	    args[1] = replacer;                                                                                                // 234
	    return _stringify.apply($JSON, args);                                                                              // 235
	  }                                                                                                                    // 236
	});                                                                                                                    // 237
	                                                                                                                       // 238
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)                                                                      // 239
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);  // 240
	// 19.4.3.5 Symbol.prototype[@@toStringTag]                                                                            // 241
	setToStringTag($Symbol, 'Symbol');                                                                                     // 242
	// 20.2.1.9 Math[@@toStringTag]                                                                                        // 243
	setToStringTag(Math, 'Math', true);                                                                                    // 244
	// 24.3.3 JSON[@@toStringTag]                                                                                          // 245
	setToStringTag(global.JSON, 'JSON', true);                                                                             // 246
	                                                                                                                       // 247
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_meta.js":["./_uid","./_is-object","./_has","./_object-dp","./_fails",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_meta.js                                                                       //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var META = require('./_uid')('meta');                                                                                  // 1
	var isObject = require('./_is-object');                                                                                // 2
	var has = require('./_has');                                                                                           // 3
	var setDesc = require('./_object-dp').f;                                                                               // 4
	var id = 0;                                                                                                            // 5
	var isExtensible = Object.isExtensible || function () {                                                                // 6
	  return true;                                                                                                         // 7
	};                                                                                                                     // 8
	var FREEZE = !require('./_fails')(function () {                                                                        // 9
	  return isExtensible(Object.preventExtensions({}));                                                                   // 10
	});                                                                                                                    // 11
	var setMeta = function (it) {                                                                                          // 12
	  setDesc(it, META, { value: {                                                                                         // 13
	    i: 'O' + ++id, // object ID                                                                                        // 14
	    w: {}          // weak collections IDs                                                                             // 15
	  } });                                                                                                                // 16
	};                                                                                                                     // 17
	var fastKey = function (it, create) {                                                                                  // 18
	  // return primitive with prefix                                                                                      // 19
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;                     // 20
	  if (!has(it, META)) {                                                                                                // 21
	    // can't set metadata to uncaught frozen object                                                                    // 22
	    if (!isExtensible(it)) return 'F';                                                                                 // 23
	    // not necessary to add metadata                                                                                   // 24
	    if (!create) return 'E';                                                                                           // 25
	    // add missing metadata                                                                                            // 26
	    setMeta(it);                                                                                                       // 27
	  // return object ID                                                                                                  // 28
	  } return it[META].i;                                                                                                 // 29
	};                                                                                                                     // 30
	var getWeak = function (it, create) {                                                                                  // 31
	  if (!has(it, META)) {                                                                                                // 32
	    // can't set metadata to uncaught frozen object                                                                    // 33
	    if (!isExtensible(it)) return true;                                                                                // 34
	    // not necessary to add metadata                                                                                   // 35
	    if (!create) return false;                                                                                         // 36
	    // add missing metadata                                                                                            // 37
	    setMeta(it);                                                                                                       // 38
	  // return hash weak collections IDs                                                                                  // 39
	  } return it[META].w;                                                                                                 // 40
	};                                                                                                                     // 41
	// add metadata on freeze-family methods calling                                                                       // 42
	var onFreeze = function (it) {                                                                                         // 43
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);                                          // 44
	  return it;                                                                                                           // 45
	};                                                                                                                     // 46
	var meta = module.exports = {                                                                                          // 47
	  KEY: META,                                                                                                           // 48
	  NEED: false,                                                                                                         // 49
	  fastKey: fastKey,                                                                                                    // 50
	  getWeak: getWeak,                                                                                                    // 51
	  onFreeze: onFreeze                                                                                                   // 52
	};                                                                                                                     // 53
	                                                                                                                       // 54
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_wks-define.js":["./_global","./_core","./_library","./_wks-ext","./_object-dp",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_wks-define.js                                                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var global = require('./_global');                                                                                     // 1
	var core = require('./_core');                                                                                         // 2
	var LIBRARY = require('./_library');                                                                                   // 3
	var wksExt = require('./_wks-ext');                                                                                    // 4
	var defineProperty = require('./_object-dp').f;                                                                        // 5
	module.exports = function (name) {                                                                                     // 6
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});                                     // 7
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });           // 8
	};                                                                                                                     // 9
	                                                                                                                       // 10
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_enum-keys.js":["./_object-keys","./_object-gops","./_object-pie",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_enum-keys.js                                                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// all enumerable object keys, includes symbols                                                                        // 1
	var getKeys = require('./_object-keys');                                                                               // 2
	var gOPS = require('./_object-gops');                                                                                  // 3
	var pIE = require('./_object-pie');                                                                                    // 4
	module.exports = function (it) {                                                                                       // 5
	  var result = getKeys(it);                                                                                            // 6
	  var getSymbols = gOPS.f;                                                                                             // 7
	  if (getSymbols) {                                                                                                    // 8
	    var symbols = getSymbols(it);                                                                                      // 9
	    var isEnum = pIE.f;                                                                                                // 10
	    var i = 0;                                                                                                         // 11
	    var key;                                                                                                           // 12
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);                              // 13
	  } return result;                                                                                                     // 14
	};                                                                                                                     // 15
	                                                                                                                       // 16
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-gops.js":function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_object-gops.js                                                                //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	exports.f = Object.getOwnPropertySymbols;                                                                              // 1
	                                                                                                                       // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_object-pie.js":function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_object-pie.js                                                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	exports.f = {}.propertyIsEnumerable;                                                                                   // 1
	                                                                                                                       // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"_is-array.js":["./_cof",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_is-array.js                                                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 7.2.2 IsArray(argument)                                                                                             // 1
	var cof = require('./_cof');                                                                                           // 2
	module.exports = Array.isArray || function isArray(arg) {                                                              // 3
	  return cof(arg) == 'Array';                                                                                          // 4
	};                                                                                                                     // 5
	                                                                                                                       // 6
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-gopn-ext.js":["./_to-iobject","./_object-gopn",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_object-gopn-ext.js                                                            //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window                                           // 1
	var toIObject = require('./_to-iobject');                                                                              // 2
	var gOPN = require('./_object-gopn').f;                                                                                // 3
	var toString = {}.toString;                                                                                            // 4
	                                                                                                                       // 5
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames                                    // 6
	  ? Object.getOwnPropertyNames(window) : [];                                                                           // 7
	                                                                                                                       // 8
	var getWindowNames = function (it) {                                                                                   // 9
	  try {                                                                                                                // 10
	    return gOPN(it);                                                                                                   // 11
	  } catch (e) {                                                                                                        // 12
	    return windowNames.slice();                                                                                        // 13
	  }                                                                                                                    // 14
	};                                                                                                                     // 15
	                                                                                                                       // 16
	module.exports.f = function getOwnPropertyNames(it) {                                                                  // 17
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));             // 18
	};                                                                                                                     // 19
	                                                                                                                       // 20
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-gopn.js":["./_object-keys-internal","./_enum-bug-keys",function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_object-gopn.js                                                                //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)                                                                   // 1
	var $keys = require('./_object-keys-internal');                                                                        // 2
	var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');                                            // 3
	                                                                                                                       // 4
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {                                            // 5
	  return $keys(O, hiddenKeys);                                                                                         // 6
	};                                                                                                                     // 7
	                                                                                                                       // 8
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_object-gopd.js":["./_object-pie","./_property-desc","./_to-iobject","./_to-primitive","./_has","./_ie8-dom-define","./_descriptors",function(require,exports){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_object-gopd.js                                                                //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var pIE = require('./_object-pie');                                                                                    // 1
	var createDesc = require('./_property-desc');                                                                          // 2
	var toIObject = require('./_to-iobject');                                                                              // 3
	var toPrimitive = require('./_to-primitive');                                                                          // 4
	var has = require('./_has');                                                                                           // 5
	var IE8_DOM_DEFINE = require('./_ie8-dom-define');                                                                     // 6
	var gOPD = Object.getOwnPropertyDescriptor;                                                                            // 7
	                                                                                                                       // 8
	exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P) {                               // 9
	  O = toIObject(O);                                                                                                    // 10
	  P = toPrimitive(P, true);                                                                                            // 11
	  if (IE8_DOM_DEFINE) try {                                                                                            // 12
	    return gOPD(O, P);                                                                                                 // 13
	  } catch (e) { /* empty */ }                                                                                          // 14
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);                                                           // 15
	};                                                                                                                     // 16
	                                                                                                                       // 17
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.to-string.js":function(){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/es6.object.to-string.js                                                        //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	                                                                                                                       // 1
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"es7.symbol.async-iterator.js":["./_wks-define",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/es7.symbol.async-iterator.js                                                   //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('./_wks-define')('asyncIterator');                                                                             // 1
	                                                                                                                       // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es7.symbol.observable.js":["./_wks-define",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/es7.symbol.observable.js                                                       //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	require('./_wks-define')('observable');                                                                                // 1
	                                                                                                                       // 2
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.set-prototype-of.js":["./_export","./_set-proto",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/es6.object.set-prototype-of.js                                                 //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// 19.1.3.19 Object.setPrototypeOf(O, proto)                                                                           // 1
	var $export = require('./_export');                                                                                    // 2
	$export($export.S, 'Object', { setPrototypeOf: require('./_set-proto').set });                                         // 3
	                                                                                                                       // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"_set-proto.js":["./_is-object","./_an-object","./_ctx","./_object-gopd",function(require,exports,module){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/_set-proto.js                                                                  //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// Works with __proto__ only. Old v8 can't work with null proto objects.                                               // 1
	/* eslint-disable no-proto */                                                                                          // 2
	var isObject = require('./_is-object');                                                                                // 3
	var anObject = require('./_an-object');                                                                                // 4
	var check = function (O, proto) {                                                                                      // 5
	  anObject(O);                                                                                                         // 6
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");                        // 7
	};                                                                                                                     // 8
	module.exports = {                                                                                                     // 9
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line                                            // 10
	    function (test, buggy, set) {                                                                                      // 11
	      try {                                                                                                            // 12
	        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);     // 13
	        set(test, []);                                                                                                 // 14
	        buggy = !(test instanceof Array);                                                                              // 15
	      } catch (e) { buggy = true; }                                                                                    // 16
	      return function setPrototypeOf(O, proto) {                                                                       // 17
	        check(O, proto);                                                                                               // 18
	        if (buggy) O.__proto__ = proto;                                                                                // 19
	        else set(O, proto);                                                                                            // 20
	        return O;                                                                                                      // 21
	      };                                                                                                               // 22
	    }({}, false) : undefined),                                                                                         // 23
	  check: check                                                                                                         // 24
	};                                                                                                                     // 25
	                                                                                                                       // 26
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"es6.object.create.js":["./_export","./_object-create",function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// node_modules/core-js/library/modules/es6.object.create.js                                                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	var $export = require('./_export');                                                                                    // 1
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])                                                                 // 2
	$export($export.S, 'Object', { create: require('./_object-create') });                                                 // 3
	                                                                                                                       // 4
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]}}}}},{"extensions":[".js",".json"]});
	var exports = require("./node_modules/meteor/modules/client.js");
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.modules = exports, {
	  meteorInstall: meteorInstall,
	  Buffer: Buffer,
	  process: process
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/mongo-id.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var EJSON = Package.ejson.EJSON;
	var IdMap = Package['id-map'].IdMap;
	var Random = Package.random.Random;
	
	/* Package-scope variables */
	var MongoID;
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                    //
	// packages/mongo-id/id.js                                                                            //
	//                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                      //
	MongoID = {};                                                                                         // 1
	                                                                                                      // 2
	MongoID._looksLikeObjectID = function (str) {                                                         // 3
	  return str.length === 24 && str.match(/^[0-9a-f]*$/);                                               // 4
	};                                                                                                    // 5
	                                                                                                      // 6
	MongoID.ObjectID = function (hexString) {                                                             // 7
	  //random-based impl of Mongo ObjectID                                                               // 8
	  var self = this;                                                                                    // 9
	  if (hexString) {                                                                                    // 10
	    hexString = hexString.toLowerCase();                                                              // 11
	    if (!MongoID._looksLikeObjectID(hexString)) {                                                     // 12
	      throw new Error("Invalid hexadecimal string for creating an ObjectID");                         // 13
	    }                                                                                                 // 14
	    // meant to work with _.isEqual(), which relies on structural equality                            // 15
	    self._str = hexString;                                                                            // 16
	  } else {                                                                                            // 17
	    self._str = Random.hexString(24);                                                                 // 18
	  }                                                                                                   // 19
	};                                                                                                    // 20
	                                                                                                      // 21
	MongoID.ObjectID.prototype.toString = function () {                                                   // 22
	  var self = this;                                                                                    // 23
	  return "ObjectID(\"" + self._str + "\")";                                                           // 24
	};                                                                                                    // 25
	                                                                                                      // 26
	MongoID.ObjectID.prototype.equals = function (other) {                                                // 27
	  var self = this;                                                                                    // 28
	  return other instanceof MongoID.ObjectID &&                                                         // 29
	    self.valueOf() === other.valueOf();                                                               // 30
	};                                                                                                    // 31
	                                                                                                      // 32
	MongoID.ObjectID.prototype.clone = function () {                                                      // 33
	  var self = this;                                                                                    // 34
	  return new MongoID.ObjectID(self._str);                                                             // 35
	};                                                                                                    // 36
	                                                                                                      // 37
	MongoID.ObjectID.prototype.typeName = function() {                                                    // 38
	  return "oid";                                                                                       // 39
	};                                                                                                    // 40
	                                                                                                      // 41
	MongoID.ObjectID.prototype.getTimestamp = function() {                                                // 42
	  var self = this;                                                                                    // 43
	  return parseInt(self._str.substr(0, 8), 16);                                                        // 44
	};                                                                                                    // 45
	                                                                                                      // 46
	MongoID.ObjectID.prototype.valueOf =                                                                  // 47
	    MongoID.ObjectID.prototype.toJSONValue =                                                          // 48
	    MongoID.ObjectID.prototype.toHexString =                                                          // 49
	    function () { return this._str; };                                                                // 50
	                                                                                                      // 51
	EJSON.addType("oid",  function (str) {                                                                // 52
	  return new MongoID.ObjectID(str);                                                                   // 53
	});                                                                                                   // 54
	                                                                                                      // 55
	MongoID.idStringify = function (id) {                                                                 // 56
	  if (id instanceof MongoID.ObjectID) {                                                               // 57
	    return id.valueOf();                                                                              // 58
	  } else if (typeof id === 'string') {                                                                // 59
	    if (id === "") {                                                                                  // 60
	      return id;                                                                                      // 61
	    } else if (id.substr(0, 1) === "-" || // escape previously dashed strings                         // 62
	               id.substr(0, 1) === "~" || // escape escaped numbers, true, false                      // 63
	               MongoID._looksLikeObjectID(id) || // escape object-id-form strings                     // 64
	               id.substr(0, 1) === '{') { // escape object-form strings, for maybe implementing later
	      return "-" + id;                                                                                // 66
	    } else {                                                                                          // 67
	      return id; // other strings go through unchanged.                                               // 68
	    }                                                                                                 // 69
	  } else if (id === undefined) {                                                                      // 70
	    return '-';                                                                                       // 71
	  } else if (typeof id === 'object' && id !== null) {                                                 // 72
	    throw new Error("Meteor does not currently support objects other than ObjectID as ids");          // 73
	  } else { // Numbers, true, false, null                                                              // 74
	    return "~" + JSON.stringify(id);                                                                  // 75
	  }                                                                                                   // 76
	};                                                                                                    // 77
	                                                                                                      // 78
	                                                                                                      // 79
	MongoID.idParse = function (id) {                                                                     // 80
	  if (id === "") {                                                                                    // 81
	    return id;                                                                                        // 82
	  } else if (id === '-') {                                                                            // 83
	    return undefined;                                                                                 // 84
	  } else if (id.substr(0, 1) === '-') {                                                               // 85
	    return id.substr(1);                                                                              // 86
	  } else if (id.substr(0, 1) === '~') {                                                               // 87
	    return JSON.parse(id.substr(1));                                                                  // 88
	  } else if (MongoID._looksLikeObjectID(id)) {                                                        // 89
	    return new MongoID.ObjectID(id);                                                                  // 90
	  } else {                                                                                            // 91
	    return id;                                                                                        // 92
	  }                                                                                                   // 93
	};                                                                                                    // 94
	                                                                                                      // 95
	                                                                                                      // 96
	////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['mongo-id'] = {}, {
	  MongoID: MongoID
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/mongo.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var AllowDeny = Package['allow-deny'].AllowDeny;
	var Random = Package.random.Random;
	var EJSON = Package.ejson.EJSON;
	var _ = Package.underscore._;
	var LocalCollection = Package.minimongo.LocalCollection;
	var Minimongo = Package.minimongo.Minimongo;
	var DDP = Package['ddp-client'].DDP;
	var Tracker = Package.tracker.Tracker;
	var Deps = Package.tracker.Deps;
	var DiffSequence = Package['diff-sequence'].DiffSequence;
	var MongoID = Package['mongo-id'].MongoID;
	var check = Package.check.check;
	var Match = Package.check.Match;
	var meteorInstall = Package.modules.meteorInstall;
	var Buffer = Package.modules.Buffer;
	var process = Package.modules.process;
	var Symbol = Package['ecmascript-runtime'].Symbol;
	var Map = Package['ecmascript-runtime'].Map;
	var Set = Package['ecmascript-runtime'].Set;
	var meteorBabelHelpers = Package['babel-runtime'].meteorBabelHelpers;
	var Promise = Package.promise.Promise;
	
	/* Package-scope variables */
	var LocalCollectionDriver, Mongo;
	
	var require = meteorInstall({"node_modules":{"meteor":{"mongo":{"local_collection_driver.js":function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                    //
	// packages/mongo/local_collection_driver.js                                                                          //
	//                                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                      //
	LocalCollectionDriver = function LocalCollectionDriver() {                                                            // 1
	  var self = this;                                                                                                    // 2
	  self.noConnCollections = {};                                                                                        // 3
	};                                                                                                                    // 4
	                                                                                                                      //
	var ensureCollection = function ensureCollection(name, collections) {                                                 // 6
	  if (!(name in collections)) collections[name] = new LocalCollection(name);                                          // 7
	  return collections[name];                                                                                           // 9
	};                                                                                                                    // 10
	                                                                                                                      //
	_.extend(LocalCollectionDriver.prototype, {                                                                           // 12
	  open: function () {                                                                                                 // 13
	    function open(name, conn) {                                                                                       // 13
	      var self = this;                                                                                                // 14
	      if (!name) return new LocalCollection();                                                                        // 15
	      if (!conn) {                                                                                                    // 17
	        return ensureCollection(name, self.noConnCollections);                                                        // 18
	      }                                                                                                               // 19
	      if (!conn._mongo_livedata_collections) conn._mongo_livedata_collections = {};                                   // 20
	      // XXX is there a way to keep track of a connection's collections without                                       // 22
	      // dangling it off the connection object?                                                                       // 23
	      return ensureCollection(name, conn._mongo_livedata_collections);                                                // 24
	    }                                                                                                                 // 25
	                                                                                                                      //
	    return open;                                                                                                      // 13
	  }()                                                                                                                 // 13
	});                                                                                                                   // 12
	                                                                                                                      //
	// singleton                                                                                                          // 28
	LocalCollectionDriver = new LocalCollectionDriver();                                                                  // 29
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"collection.js":function(require,exports,module){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                    //
	// packages/mongo/collection.js                                                                                       //
	//                                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                      //
	// options.connection, if given, is a LivedataClient or LivedataServer                                                // 1
	// XXX presently there is no way to destroy/clean up a Collection                                                     // 2
	                                                                                                                      //
	/**                                                                                                                   // 4
	 * @summary Namespace for MongoDB-related items                                                                       //
	 * @namespace                                                                                                         //
	 */                                                                                                                   //
	Mongo = {};                                                                                                           // 8
	                                                                                                                      //
	/**                                                                                                                   // 10
	 * @summary Constructor for a Collection                                                                              //
	 * @locus Anywhere                                                                                                    //
	 * @instancename collection                                                                                           //
	 * @class                                                                                                             //
	 * @param {String} name The name of the collection.  If null, creates an unmanaged (unsynchronized) local collection.
	 * @param {Object} [options]                                                                                          //
	 * @param {Object} options.connection The server connection that will manage this collection. Uses the default connection if not specified.  Pass the return value of calling [`DDP.connect`](#ddp_connect) to specify a different server. Pass `null` to specify no connection. Unmanaged (`name` is null) collections cannot specify a connection.
	 * @param {String} options.idGeneration The method of generating the `_id` fields of new documents in this collection.  Possible values:
	                                                                                                                      //
	 - **`'STRING'`**: random strings                                                                                     //
	 - **`'MONGO'`**:  random [`Mongo.ObjectID`](#mongo_object_id) values                                                 //
	                                                                                                                      //
	The default id generation technique is `'STRING'`.                                                                    //
	 * @param {Function} options.transform An optional transformation function. Documents will be passed through this function before being returned from `fetch` or `findOne`, and before being passed to callbacks of `observe`, `map`, `forEach`, `allow`, and `deny`. Transforms are *not* applied for the callbacks of `observeChanges` or to cursors returned from publish functions.
	 * @param {Boolean} options.defineMutationMethods Set to `false` to skip setting up the mutation methods that enable insert/update/remove from client code. Default `true`.
	 */                                                                                                                   //
	Mongo.Collection = function (name, options) {                                                                         // 27
	  var self = this;                                                                                                    // 28
	  if (!(self instanceof Mongo.Collection)) throw new Error('use "new" to construct a Mongo.Collection');              // 29
	                                                                                                                      //
	  if (!name && name !== null) {                                                                                       // 32
	    Meteor._debug("Warning: creating anonymous collection. It will not be " + "saved or synchronized over the network. (Pass null for " + "the collection name to turn off this warning.)");
	    name = null;                                                                                                      // 36
	  }                                                                                                                   // 37
	                                                                                                                      //
	  if (name !== null && typeof name !== "string") {                                                                    // 39
	    throw new Error("First argument to new Mongo.Collection must be a string or null");                               // 40
	  }                                                                                                                   // 42
	                                                                                                                      //
	  if (options && options.methods) {                                                                                   // 44
	    // Backwards compatibility hack with original signature (which passed                                             // 45
	    // "connection" directly instead of in options. (Connections must have a "methods"                                // 46
	    // method.)                                                                                                       // 47
	    // XXX remove before 1.0                                                                                          // 48
	    options = { connection: options };                                                                                // 49
	  }                                                                                                                   // 50
	  // Backwards compatibility: "connection" used to be called "manager".                                               // 51
	  if (options && options.manager && !options.connection) {                                                            // 52
	    options.connection = options.manager;                                                                             // 53
	  }                                                                                                                   // 54
	  options = _.extend({                                                                                                // 55
	    connection: undefined,                                                                                            // 56
	    idGeneration: 'STRING',                                                                                           // 57
	    transform: null,                                                                                                  // 58
	    _driver: undefined,                                                                                               // 59
	    _preventAutopublish: false                                                                                        // 60
	  }, options);                                                                                                        // 55
	                                                                                                                      //
	  switch (options.idGeneration) {                                                                                     // 63
	    case 'MONGO':                                                                                                     // 64
	      self._makeNewID = function () {                                                                                 // 65
	        var src = name ? DDP.randomStream('/collection/' + name) : Random.insecure;                                   // 66
	        return new Mongo.ObjectID(src.hexString(24));                                                                 // 69
	      };                                                                                                              // 70
	      break;                                                                                                          // 71
	    case 'STRING':                                                                                                    // 72
	    default:                                                                                                          // 73
	      self._makeNewID = function () {                                                                                 // 74
	        var src = name ? DDP.randomStream('/collection/' + name) : Random.insecure;                                   // 75
	        return src.id();                                                                                              // 78
	      };                                                                                                              // 79
	      break;                                                                                                          // 80
	  }                                                                                                                   // 63
	                                                                                                                      //
	  self._transform = LocalCollection.wrapTransform(options.transform);                                                 // 83
	                                                                                                                      //
	  if (!name || options.connection === null)                                                                           // 85
	    // note: nameless collections never have a connection                                                             // 86
	    self._connection = null;else if (options.connection) self._connection = options.connection;else if (Meteor.isClient) self._connection = Meteor.connection;else self._connection = Meteor.server;
	                                                                                                                      //
	  if (!options._driver) {                                                                                             // 95
	    // XXX This check assumes that webapp is loaded so that Meteor.server !==                                         // 96
	    // null. We should fully support the case of "want to use a Mongo-backed                                          // 97
	    // collection from Node code without webapp", but we don't yet.                                                   // 98
	    // #MeteorServerNull                                                                                              // 99
	    if (name && self._connection === Meteor.server && typeof MongoInternals !== "undefined" && MongoInternals.defaultRemoteCollectionDriver) {
	      options._driver = MongoInternals.defaultRemoteCollectionDriver();                                               // 103
	    } else {                                                                                                          // 104
	      options._driver = LocalCollectionDriver;                                                                        // 105
	    }                                                                                                                 // 106
	  }                                                                                                                   // 107
	                                                                                                                      //
	  self._collection = options._driver.open(name, self._connection);                                                    // 109
	  self._name = name;                                                                                                  // 110
	  self._driver = options._driver;                                                                                     // 111
	                                                                                                                      //
	  if (self._connection && self._connection.registerStore) {                                                           // 113
	    // OK, we're going to be a slave, replicating some remote                                                         // 114
	    // database, except possibly with some temporary divergence while                                                 // 115
	    // we have unacknowledged RPC's.                                                                                  // 116
	    var ok = self._connection.registerStore(name, {                                                                   // 117
	      // Called at the beginning of a batch of updates. batchSize is the number                                       // 118
	      // of update calls to expect.                                                                                   // 119
	      //                                                                                                              // 120
	      // XXX This interface is pretty janky. reset probably ought to go back to                                       // 121
	      // being its own function, and callers shouldn't have to calculate                                              // 122
	      // batchSize. The optimization of not calling pause/remove should be                                            // 123
	      // delayed until later: the first call to update() should buffer its                                            // 124
	      // message, and then we can either directly apply it at endUpdate time if                                       // 125
	      // it was the only update, or do pauseObservers/apply/apply at the next                                         // 126
	      // update() if there's another one.                                                                             // 127
	      beginUpdate: function () {                                                                                      // 128
	        function beginUpdate(batchSize, reset) {                                                                      // 128
	          // pause observers so users don't see flicker when updating several                                         // 129
	          // objects at once (including the post-reconnect reset-and-reapply                                          // 130
	          // stage), and so that a re-sorting of a query can take advantage of the                                    // 131
	          // full _diffQuery moved calculation instead of applying change one at a                                    // 132
	          // time.                                                                                                    // 133
	          if (batchSize > 1 || reset) self._collection.pauseObservers();                                              // 134
	                                                                                                                      //
	          if (reset) self._collection.remove({});                                                                     // 137
	        }                                                                                                             // 139
	                                                                                                                      //
	        return beginUpdate;                                                                                           // 128
	      }(),                                                                                                            // 128
	                                                                                                                      //
	      // Apply an update.                                                                                             // 141
	      // XXX better specify this interface (not in terms of a wire message)?                                          // 142
	      update: function () {                                                                                           // 143
	        function update(msg) {                                                                                        // 143
	          var mongoId = MongoID.idParse(msg.id);                                                                      // 144
	          var doc = self._collection.findOne(mongoId);                                                                // 145
	                                                                                                                      //
	          // Is this a "replace the whole doc" message coming from the quiescence                                     // 147
	          // of method writes to an object? (Note that 'undefined' is a valid                                         // 148
	          // value meaning "remove it".)                                                                              // 149
	          if (msg.msg === 'replace') {                                                                                // 150
	            var replace = msg.replace;                                                                                // 151
	            if (!replace) {                                                                                           // 152
	              if (doc) self._collection.remove(mongoId);                                                              // 153
	            } else if (!doc) {                                                                                        // 155
	              self._collection.insert(replace);                                                                       // 156
	            } else {                                                                                                  // 157
	              // XXX check that replace has no $ ops                                                                  // 158
	              self._collection.update(mongoId, replace);                                                              // 159
	            }                                                                                                         // 160
	            return;                                                                                                   // 161
	          } else if (msg.msg === 'added') {                                                                           // 162
	            if (doc) {                                                                                                // 163
	              throw new Error("Expected not to find a document already present for an add");                          // 164
	            }                                                                                                         // 165
	            self._collection.insert(_.extend({ _id: mongoId }, msg.fields));                                          // 166
	          } else if (msg.msg === 'removed') {                                                                         // 167
	            if (!doc) throw new Error("Expected to find a document already present for removed");                     // 168
	            self._collection.remove(mongoId);                                                                         // 170
	          } else if (msg.msg === 'changed') {                                                                         // 171
	            if (!doc) throw new Error("Expected to find a document to change");                                       // 172
	            if (!_.isEmpty(msg.fields)) {                                                                             // 174
	              var modifier = {};                                                                                      // 175
	              _.each(msg.fields, function (value, key) {                                                              // 176
	                if (value === undefined) {                                                                            // 177
	                  if (!modifier.$unset) modifier.$unset = {};                                                         // 178
	                  modifier.$unset[key] = 1;                                                                           // 180
	                } else {                                                                                              // 181
	                  if (!modifier.$set) modifier.$set = {};                                                             // 182
	                  modifier.$set[key] = value;                                                                         // 184
	                }                                                                                                     // 185
	              });                                                                                                     // 186
	              self._collection.update(mongoId, modifier);                                                             // 187
	            }                                                                                                         // 188
	          } else {                                                                                                    // 189
	            throw new Error("I don't know how to deal with this message");                                            // 190
	          }                                                                                                           // 191
	        }                                                                                                             // 193
	                                                                                                                      //
	        return update;                                                                                                // 143
	      }(),                                                                                                            // 143
	                                                                                                                      //
	      // Called at the end of a batch of updates.                                                                     // 195
	      endUpdate: function () {                                                                                        // 196
	        function endUpdate() {                                                                                        // 196
	          self._collection.resumeObservers();                                                                         // 197
	        }                                                                                                             // 198
	                                                                                                                      //
	        return endUpdate;                                                                                             // 196
	      }(),                                                                                                            // 196
	                                                                                                                      //
	      // Called around method stub invocations to capture the original versions                                       // 200
	      // of modified documents.                                                                                       // 201
	      saveOriginals: function () {                                                                                    // 202
	        function saveOriginals() {                                                                                    // 202
	          self._collection.saveOriginals();                                                                           // 203
	        }                                                                                                             // 204
	                                                                                                                      //
	        return saveOriginals;                                                                                         // 202
	      }(),                                                                                                            // 202
	      retrieveOriginals: function () {                                                                                // 205
	        function retrieveOriginals() {                                                                                // 205
	          return self._collection.retrieveOriginals();                                                                // 206
	        }                                                                                                             // 207
	                                                                                                                      //
	        return retrieveOriginals;                                                                                     // 205
	      }(),                                                                                                            // 205
	                                                                                                                      //
	      // Used to preserve current versions of documents across a store reset.                                         // 209
	      getDoc: function () {                                                                                           // 210
	        function getDoc(id) {                                                                                         // 210
	          return self.findOne(id);                                                                                    // 211
	        }                                                                                                             // 212
	                                                                                                                      //
	        return getDoc;                                                                                                // 210
	      }(),                                                                                                            // 210
	                                                                                                                      //
	      // To be able to get back to the collection from the store.                                                     // 214
	      _getCollection: function () {                                                                                   // 215
	        function _getCollection() {                                                                                   // 215
	          return self;                                                                                                // 216
	        }                                                                                                             // 217
	                                                                                                                      //
	        return _getCollection;                                                                                        // 215
	      }()                                                                                                             // 215
	    });                                                                                                               // 117
	                                                                                                                      //
	    if (!ok) {                                                                                                        // 220
	      var message = "There is already a collection named \"" + name + "\"";                                           // 221
	      if (options._suppressSameNameError === true) {                                                                  // 222
	        // XXX In theory we do not have to throw when `ok` is falsy. The store is already defined                     // 223
	        // for this collection name, but this will simply be another reference to it and everything                   // 224
	        // should work. However, we have historically thrown an error here, so for now we will                        // 225
	        // skip the error only when `_suppressSameNameError` is `true`, allowing people to opt in                     // 226
	        // and give this some real world testing.                                                                     // 227
	        console.warn ? console.warn(message) : console.log(message);                                                  // 228
	      } else {                                                                                                        // 229
	        throw new Error(message);                                                                                     // 230
	      }                                                                                                               // 231
	    }                                                                                                                 // 232
	  }                                                                                                                   // 233
	                                                                                                                      //
	  // XXX don't define these until allow or deny is actually used for this                                             // 235
	  // collection. Could be hard if the security rules are only defined on the                                          // 236
	  // server.                                                                                                          // 237
	  if (options.defineMutationMethods !== false) {                                                                      // 238
	    try {                                                                                                             // 239
	      self._defineMutationMethods({ useExisting: options._suppressSameNameError === true });                          // 240
	    } catch (error) {                                                                                                 // 241
	      // Throw a more understandable error on the server for same collection name                                     // 242
	      if (error.message === "A method named '/" + name + "/insert' is already defined") throw new Error("There is already a collection named \"" + name + "\"");
	      throw error;                                                                                                    // 245
	    }                                                                                                                 // 246
	  }                                                                                                                   // 247
	                                                                                                                      //
	  // autopublish                                                                                                      // 249
	  if (Package.autopublish && !options._preventAutopublish && self._connection && self._connection.publish) {          // 250
	    self._connection.publish(null, function () {                                                                      // 252
	      return self.find();                                                                                             // 253
	    }, { is_auto: true });                                                                                            // 254
	  }                                                                                                                   // 255
	};                                                                                                                    // 256
	                                                                                                                      //
	///                                                                                                                   // 258
	/// Main collection API                                                                                               // 259
	///                                                                                                                   // 260
	                                                                                                                      //
	                                                                                                                      //
	_.extend(Mongo.Collection.prototype, {                                                                                // 263
	                                                                                                                      //
	  _getFindSelector: function () {                                                                                     // 265
	    function _getFindSelector(args) {                                                                                 // 265
	      if (args.length == 0) return {};else return args[0];                                                            // 266
	    }                                                                                                                 // 270
	                                                                                                                      //
	    return _getFindSelector;                                                                                          // 265
	  }(),                                                                                                                // 265
	                                                                                                                      //
	  _getFindOptions: function () {                                                                                      // 272
	    function _getFindOptions(args) {                                                                                  // 272
	      var self = this;                                                                                                // 273
	      if (args.length < 2) {                                                                                          // 274
	        return { transform: self._transform };                                                                        // 275
	      } else {                                                                                                        // 276
	        check(args[1], Match.Optional(Match.ObjectIncluding({                                                         // 277
	          fields: Match.Optional(Match.OneOf(Object, undefined)),                                                     // 278
	          sort: Match.Optional(Match.OneOf(Object, Array, Function, undefined)),                                      // 279
	          limit: Match.Optional(Match.OneOf(Number, undefined)),                                                      // 280
	          skip: Match.Optional(Match.OneOf(Number, undefined))                                                        // 281
	        })));                                                                                                         // 277
	                                                                                                                      //
	        return _.extend({                                                                                             // 284
	          transform: self._transform                                                                                  // 285
	        }, args[1]);                                                                                                  // 284
	      }                                                                                                               // 287
	    }                                                                                                                 // 288
	                                                                                                                      //
	    return _getFindOptions;                                                                                           // 272
	  }(),                                                                                                                // 272
	                                                                                                                      //
	  /**                                                                                                                 // 290
	   * @summary Find the documents in a collection that match the selector.                                             //
	   * @locus Anywhere                                                                                                  //
	   * @method find                                                                                                     //
	   * @memberOf Mongo.Collection                                                                                       //
	   * @instance                                                                                                        //
	   * @param {MongoSelector} [selector] A query describing the documents to find                                       //
	   * @param {Object} [options]                                                                                        //
	   * @param {MongoSortSpecifier} options.sort Sort order (default: natural order)                                     //
	   * @param {Number} options.skip Number of results to skip at the beginning                                          //
	   * @param {Number} options.limit Maximum number of results to return                                                //
	   * @param {MongoFieldSpecifier} options.fields Dictionary of fields to return or exclude.                           //
	   * @param {Boolean} options.reactive (Client only) Default `true`; pass `false` to disable reactivity               //
	   * @param {Function} options.transform Overrides `transform` on the  [`Collection`](#collections) for this cursor.  Pass `null` to disable transformation.
	   * @param {Boolean} options.disableOplog (Server only) Pass true to disable oplog-tailing on this query. This affects the way server processes calls to `observe` on this query. Disabling the oplog can be useful when working with data that updates in large batches.
	   * @param {Number} options.pollingIntervalMs (Server only) When oplog is disabled (through the use of `disableOplog` or when otherwise not available), the frequency (in milliseconds) of how often to poll this query when observing on the server. Defaults to 10000ms (10 seconds).
	   * @param {Number} options.pollingThrottleMs (Server only) When oplog is disabled (through the use of `disableOplog` or when otherwise not available), the minimum time (in milliseconds) to allow between re-polling when observing on the server. Increasing this will save CPU and mongo load at the expense of slower updates to users. Decreasing this is not recommended. Defaults to 50ms.
	   * @returns {Mongo.Cursor}                                                                                          //
	   */                                                                                                                 //
	  find: function () {                                                                                                 // 309
	    function find() /* selector, options */{                                                                          // 309
	      // Collection.find() (return all docs) behaves differently                                                      // 310
	      // from Collection.find(undefined) (return 0 docs).  so be                                                      // 311
	      // careful about the length of arguments.                                                                       // 312
	      var self = this;                                                                                                // 313
	      var argArray = _.toArray(arguments);                                                                            // 314
	      return self._collection.find(self._getFindSelector(argArray), self._getFindOptions(argArray));                  // 315
	    }                                                                                                                 // 317
	                                                                                                                      //
	    return find;                                                                                                      // 309
	  }(),                                                                                                                // 309
	                                                                                                                      //
	  /**                                                                                                                 // 319
	   * @summary Finds the first document that matches the selector, as ordered by sort and skip options. Returns `undefined` if no matching document is found.
	   * @locus Anywhere                                                                                                  //
	   * @method findOne                                                                                                  //
	   * @memberOf Mongo.Collection                                                                                       //
	   * @instance                                                                                                        //
	   * @param {MongoSelector} [selector] A query describing the documents to find                                       //
	   * @param {Object} [options]                                                                                        //
	   * @param {MongoSortSpecifier} options.sort Sort order (default: natural order)                                     //
	   * @param {Number} options.skip Number of results to skip at the beginning                                          //
	   * @param {MongoFieldSpecifier} options.fields Dictionary of fields to return or exclude.                           //
	   * @param {Boolean} options.reactive (Client only) Default true; pass false to disable reactivity                   //
	   * @param {Function} options.transform Overrides `transform` on the [`Collection`](#collections) for this cursor.  Pass `null` to disable transformation.
	   * @returns {Object}                                                                                                //
	   */                                                                                                                 //
	  findOne: function () {                                                                                              // 334
	    function findOne() /* selector, options */{                                                                       // 334
	      var self = this;                                                                                                // 335
	      var argArray = _.toArray(arguments);                                                                            // 336
	      return self._collection.findOne(self._getFindSelector(argArray), self._getFindOptions(argArray));               // 337
	    }                                                                                                                 // 339
	                                                                                                                      //
	    return findOne;                                                                                                   // 334
	  }()                                                                                                                 // 334
	                                                                                                                      //
	});                                                                                                                   // 263
	                                                                                                                      //
	Mongo.Collection._publishCursor = function (cursor, sub, collection) {                                                // 343
	  var observeHandle = cursor.observeChanges({                                                                         // 344
	    added: function () {                                                                                              // 345
	      function added(id, fields) {                                                                                    // 345
	        sub.added(collection, id, fields);                                                                            // 346
	      }                                                                                                               // 347
	                                                                                                                      //
	      return added;                                                                                                   // 345
	    }(),                                                                                                              // 345
	    changed: function () {                                                                                            // 348
	      function changed(id, fields) {                                                                                  // 348
	        sub.changed(collection, id, fields);                                                                          // 349
	      }                                                                                                               // 350
	                                                                                                                      //
	      return changed;                                                                                                 // 348
	    }(),                                                                                                              // 348
	    removed: function () {                                                                                            // 351
	      function removed(id) {                                                                                          // 351
	        sub.removed(collection, id);                                                                                  // 352
	      }                                                                                                               // 353
	                                                                                                                      //
	      return removed;                                                                                                 // 351
	    }()                                                                                                               // 351
	  });                                                                                                                 // 344
	                                                                                                                      //
	  // We don't call sub.ready() here: it gets called in livedata_server, after                                         // 356
	  // possibly calling _publishCursor on multiple returned cursors.                                                    // 357
	                                                                                                                      //
	  // register stop callback (expects lambda w/ no args).                                                              // 359
	  sub.onStop(function () {                                                                                            // 360
	    observeHandle.stop();                                                                                             // 360
	  });                                                                                                                 // 360
	                                                                                                                      //
	  // return the observeHandle in case it needs to be stopped early                                                    // 362
	  return observeHandle;                                                                                               // 363
	};                                                                                                                    // 364
	                                                                                                                      //
	// protect against dangerous selectors.  falsey and {_id: falsey} are both                                            // 366
	// likely programmer error, and not what you want, particularly for destructive                                       // 367
	// operations.  JS regexps don't serialize over DDP but can be trivially                                              // 368
	// replaced by $regex.                                                                                                // 369
	Mongo.Collection._rewriteSelector = function (selector) {                                                             // 370
	  // shorthand -- scalars match _id                                                                                   // 371
	  if (LocalCollection._selectorIsId(selector)) selector = { _id: selector };                                          // 372
	                                                                                                                      //
	  if (_.isArray(selector)) {                                                                                          // 375
	    // This is consistent with the Mongo console itself; if we don't do this                                          // 376
	    // check passing an empty array ends up selecting all items                                                       // 377
	    throw new Error("Mongo selector can't be an array.");                                                             // 378
	  }                                                                                                                   // 379
	                                                                                                                      //
	  if (!selector || '_id' in selector && !selector._id)                                                                // 381
	    // can't match anything                                                                                           // 382
	    return { _id: Random.id() };                                                                                      // 383
	                                                                                                                      //
	  var ret = {};                                                                                                       // 385
	  _.each(selector, function (value, key) {                                                                            // 386
	    // Mongo supports both {field: /foo/} and {field: {$regex: /foo/}}                                                // 387
	    if (value instanceof RegExp) {                                                                                    // 388
	      ret[key] = convertRegexpToMongoSelector(value);                                                                 // 389
	    } else if (value && value.$regex instanceof RegExp) {                                                             // 390
	      ret[key] = convertRegexpToMongoSelector(value.$regex);                                                          // 391
	      // if value is {$regex: /foo/, $options: ...} then $options                                                     // 392
	      // override the ones set on $regex.                                                                             // 393
	      if (value.$options !== undefined) ret[key].$options = value.$options;                                           // 394
	    } else if (_.contains(['$or', '$and', '$nor'], key)) {                                                            // 396
	      // Translate lower levels of $and/$or/$nor                                                                      // 398
	      ret[key] = _.map(value, function (v) {                                                                          // 399
	        return Mongo.Collection._rewriteSelector(v);                                                                  // 400
	      });                                                                                                             // 401
	    } else {                                                                                                          // 402
	      ret[key] = value;                                                                                               // 403
	    }                                                                                                                 // 404
	  });                                                                                                                 // 405
	  return ret;                                                                                                         // 406
	};                                                                                                                    // 407
	                                                                                                                      //
	// convert a JS RegExp object to a Mongo {$regex: ..., $options: ...}                                                 // 409
	// selector                                                                                                           // 410
	function convertRegexpToMongoSelector(regexp) {                                                                       // 411
	  check(regexp, RegExp); // safety belt                                                                               // 412
	                                                                                                                      //
	  var selector = { $regex: regexp.source };                                                                           // 414
	  var regexOptions = '';                                                                                              // 415
	  // JS RegExp objects support 'i', 'm', and 'g'. Mongo regex $options                                                // 416
	  // support 'i', 'm', 'x', and 's'. So we support 'i' and 'm' here.                                                  // 417
	  if (regexp.ignoreCase) regexOptions += 'i';                                                                         // 418
	  if (regexp.multiline) regexOptions += 'm';                                                                          // 420
	  if (regexOptions) selector.$options = regexOptions;                                                                 // 422
	                                                                                                                      //
	  return selector;                                                                                                    // 425
	};                                                                                                                    // 426
	                                                                                                                      //
	// 'insert' immediately returns the inserted document's new _id.                                                      // 428
	// The others return values immediately if you are in a stub, an in-memory                                            // 429
	// unmanaged collection, or a mongo-backed collection and you don't pass a                                            // 430
	// callback. 'update' and 'remove' return the number of affected                                                      // 431
	// documents. 'upsert' returns an object with keys 'numberAffected' and, if an                                        // 432
	// insert happened, 'insertedId'.                                                                                     // 433
	//                                                                                                                    // 434
	// Otherwise, the semantics are exactly like other methods: they take                                                 // 435
	// a callback as an optional last argument; if no callback is                                                         // 436
	// provided, they block until the operation is complete, and throw an                                                 // 437
	// exception if it fails; if a callback is provided, then they don't                                                  // 438
	// necessarily block, and they call the callback when they finish with error and                                      // 439
	// result arguments.  (The insert method provides the document ID as its result;                                      // 440
	// update and remove provide the number of affected docs as the result; upsert                                        // 441
	// provides an object with numberAffected and maybe insertedId.)                                                      // 442
	//                                                                                                                    // 443
	// On the client, blocking is impossible, so if a callback                                                            // 444
	// isn't provided, they just return immediately and any error                                                         // 445
	// information is lost.                                                                                               // 446
	//                                                                                                                    // 447
	// There's one more tweak. On the client, if you don't provide a                                                      // 448
	// callback, then if there is an error, a message will be logged with                                                 // 449
	// Meteor._debug.                                                                                                     // 450
	//                                                                                                                    // 451
	// The intent (though this is actually determined by the underlying                                                   // 452
	// drivers) is that the operations should be done synchronously, not                                                  // 453
	// generating their result until the database has acknowledged                                                        // 454
	// them. In the future maybe we should provide a flag to turn this                                                    // 455
	// off.                                                                                                               // 456
	                                                                                                                      //
	/**                                                                                                                   // 458
	 * @summary Insert a document in the collection.  Returns its unique _id.                                             //
	 * @locus Anywhere                                                                                                    //
	 * @method  insert                                                                                                    //
	 * @memberOf Mongo.Collection                                                                                         //
	 * @instance                                                                                                          //
	 * @param {Object} doc The document to insert. May not yet have an _id attribute, in which case Meteor will generate one for you.
	 * @param {Function} [callback] Optional.  If present, called with an error object as the first argument and, if no error, the _id as the second.
	 */                                                                                                                   //
	Mongo.Collection.prototype.insert = function () {                                                                     // 467
	  function insert(doc, callback) {                                                                                    // 467
	    // Make sure we were passed a document to insert                                                                  // 468
	    if (!doc) {                                                                                                       // 469
	      throw new Error("insert requires an argument");                                                                 // 470
	    }                                                                                                                 // 471
	                                                                                                                      //
	    // Shallow-copy the document and possibly generate an ID                                                          // 473
	    doc = _.extend({}, doc);                                                                                          // 474
	                                                                                                                      //
	    if ('_id' in doc) {                                                                                               // 476
	      if (!doc._id || !(typeof doc._id === 'string' || doc._id instanceof Mongo.ObjectID)) {                          // 477
	        throw new Error("Meteor requires document _id fields to be non-empty strings or ObjectIDs");                  // 479
	      }                                                                                                               // 480
	    } else {                                                                                                          // 481
	      var generateId = true;                                                                                          // 482
	                                                                                                                      //
	      // Don't generate the id if we're the client and the 'outermost' call                                           // 484
	      // This optimization saves us passing both the randomSeed and the id                                            // 485
	      // Passing both is redundant.                                                                                   // 486
	      if (this._isRemoteCollection()) {                                                                               // 487
	        var enclosing = DDP._CurrentInvocation.get();                                                                 // 488
	        if (!enclosing) {                                                                                             // 489
	          generateId = false;                                                                                         // 490
	        }                                                                                                             // 491
	      }                                                                                                               // 492
	                                                                                                                      //
	      if (generateId) {                                                                                               // 494
	        doc._id = this._makeNewID();                                                                                  // 495
	      }                                                                                                               // 496
	    }                                                                                                                 // 497
	                                                                                                                      //
	    // On inserts, always return the id that we generated; on all other                                               // 499
	    // operations, just return the result from the collection.                                                        // 500
	    var chooseReturnValueFromCollectionResult = function () {                                                         // 501
	      function chooseReturnValueFromCollectionResult(result) {                                                        // 501
	        if (doc._id) {                                                                                                // 502
	          return doc._id;                                                                                             // 503
	        }                                                                                                             // 504
	                                                                                                                      //
	        // XXX what is this for??                                                                                     // 506
	        // It's some iteraction between the callback to _callMutatorMethod and                                        // 507
	        // the return value conversion                                                                                // 508
	        doc._id = result;                                                                                             // 509
	                                                                                                                      //
	        return result;                                                                                                // 511
	      }                                                                                                               // 512
	                                                                                                                      //
	      return chooseReturnValueFromCollectionResult;                                                                   // 501
	    }();                                                                                                              // 501
	                                                                                                                      //
	    var wrappedCallback = wrapCallback(callback, chooseReturnValueFromCollectionResult);                              // 514
	                                                                                                                      //
	    if (this._isRemoteCollection()) {                                                                                 // 517
	      var result = this._callMutatorMethod("insert", [doc], wrappedCallback);                                         // 518
	      return chooseReturnValueFromCollectionResult(result);                                                           // 519
	    }                                                                                                                 // 520
	                                                                                                                      //
	    // it's my collection.  descend into the collection object                                                        // 522
	    // and propagate any exception.                                                                                   // 523
	    try {                                                                                                             // 524
	      // If the user provided a callback and the collection implements this                                           // 525
	      // operation asynchronously, then queryRet will be undefined, and the                                           // 526
	      // result will be returned through the callback instead.                                                        // 527
	      var _result = this._collection.insert(doc, wrappedCallback);                                                    // 528
	      return chooseReturnValueFromCollectionResult(_result);                                                          // 529
	    } catch (e) {                                                                                                     // 530
	      if (callback) {                                                                                                 // 531
	        callback(e);                                                                                                  // 532
	        return null;                                                                                                  // 533
	      }                                                                                                               // 534
	      throw e;                                                                                                        // 535
	    }                                                                                                                 // 536
	  }                                                                                                                   // 537
	                                                                                                                      //
	  return insert;                                                                                                      // 467
	}();                                                                                                                  // 467
	                                                                                                                      //
	/**                                                                                                                   // 539
	 * @summary Modify one or more documents in the collection. Returns the number of matched documents.                  //
	 * @locus Anywhere                                                                                                    //
	 * @method update                                                                                                     //
	 * @memberOf Mongo.Collection                                                                                         //
	 * @instance                                                                                                          //
	 * @param {MongoSelector} selector Specifies which documents to modify                                                //
	 * @param {MongoModifier} modifier Specifies how to modify the documents                                              //
	 * @param {Object} [options]                                                                                          //
	 * @param {Boolean} options.multi True to modify all matching documents; false to only modify one of the matching documents (the default).
	 * @param {Boolean} options.upsert True to insert a document if no matching documents are found.                      //
	 * @param {Function} [callback] Optional.  If present, called with an error object as the first argument and, if no error, the number of affected documents as the second.
	 */                                                                                                                   //
	Mongo.Collection.prototype.update = function () {                                                                     // 552
	  function update(selector, modifier) {                                                                               // 552
	    for (var _len = arguments.length, optionsAndCallback = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      optionsAndCallback[_key - 2] = arguments[_key];                                                                 // 552
	    }                                                                                                                 // 552
	                                                                                                                      //
	    var callback = popCallbackFromArgs(optionsAndCallback);                                                           // 553
	                                                                                                                      //
	    selector = Mongo.Collection._rewriteSelector(selector);                                                           // 555
	                                                                                                                      //
	    // We've already popped off the callback, so we are left with an array                                            // 557
	    // of one or zero items                                                                                           // 558
	    var options = _.clone(optionsAndCallback[0]) || {};                                                               // 559
	    if (options && options.upsert) {                                                                                  // 560
	      // set `insertedId` if absent.  `insertedId` is a Meteor extension.                                             // 561
	      if (options.insertedId) {                                                                                       // 562
	        if (!(typeof options.insertedId === 'string' || options.insertedId instanceof Mongo.ObjectID)) throw new Error("insertedId must be string or ObjectID");
	      } else if (!selector._id) {                                                                                     // 566
	        options.insertedId = this._makeNewID();                                                                       // 567
	      }                                                                                                               // 568
	    }                                                                                                                 // 569
	                                                                                                                      //
	    var wrappedCallback = wrapCallback(callback);                                                                     // 571
	                                                                                                                      //
	    if (this._isRemoteCollection()) {                                                                                 // 573
	      var args = [selector, modifier, options];                                                                       // 574
	                                                                                                                      //
	      return this._callMutatorMethod("update", args, wrappedCallback);                                                // 580
	    }                                                                                                                 // 581
	                                                                                                                      //
	    // it's my collection.  descend into the collection object                                                        // 583
	    // and propagate any exception.                                                                                   // 584
	    try {                                                                                                             // 585
	      // If the user provided a callback and the collection implements this                                           // 586
	      // operation asynchronously, then queryRet will be undefined, and the                                           // 587
	      // result will be returned through the callback instead.                                                        // 588
	      return this._collection.update(selector, modifier, options, wrappedCallback);                                   // 589
	    } catch (e) {                                                                                                     // 591
	      if (callback) {                                                                                                 // 592
	        callback(e);                                                                                                  // 593
	        return null;                                                                                                  // 594
	      }                                                                                                               // 595
	      throw e;                                                                                                        // 596
	    }                                                                                                                 // 597
	  }                                                                                                                   // 598
	                                                                                                                      //
	  return update;                                                                                                      // 552
	}();                                                                                                                  // 552
	                                                                                                                      //
	/**                                                                                                                   // 600
	 * @summary Remove documents from the collection                                                                      //
	 * @locus Anywhere                                                                                                    //
	 * @method remove                                                                                                     //
	 * @memberOf Mongo.Collection                                                                                         //
	 * @instance                                                                                                          //
	 * @param {MongoSelector} selector Specifies which documents to remove                                                //
	 * @param {Function} [callback] Optional.  If present, called with an error object as its argument.                   //
	 */                                                                                                                   //
	Mongo.Collection.prototype.remove = function () {                                                                     // 609
	  function remove(selector, callback) {                                                                               // 609
	    selector = Mongo.Collection._rewriteSelector(selector);                                                           // 610
	                                                                                                                      //
	    var wrappedCallback = wrapCallback(callback);                                                                     // 612
	                                                                                                                      //
	    if (this._isRemoteCollection()) {                                                                                 // 614
	      return this._callMutatorMethod("remove", [selector], wrappedCallback);                                          // 615
	    }                                                                                                                 // 616
	                                                                                                                      //
	    // it's my collection.  descend into the collection object                                                        // 618
	    // and propagate any exception.                                                                                   // 619
	    try {                                                                                                             // 620
	      // If the user provided a callback and the collection implements this                                           // 621
	      // operation asynchronously, then queryRet will be undefined, and the                                           // 622
	      // result will be returned through the callback instead.                                                        // 623
	      return this._collection.remove(selector, wrappedCallback);                                                      // 624
	    } catch (e) {                                                                                                     // 625
	      if (callback) {                                                                                                 // 626
	        callback(e);                                                                                                  // 627
	        return null;                                                                                                  // 628
	      }                                                                                                               // 629
	      throw e;                                                                                                        // 630
	    }                                                                                                                 // 631
	  }                                                                                                                   // 632
	                                                                                                                      //
	  return remove;                                                                                                      // 609
	}();                                                                                                                  // 609
	                                                                                                                      //
	// Determine if this collection is simply a minimongo representation of a real                                        // 634
	// database on another server                                                                                         // 635
	Mongo.Collection.prototype._isRemoteCollection = function () {                                                        // 636
	  function _isRemoteCollection() {                                                                                    // 636
	    // XXX see #MeteorServerNull                                                                                      // 637
	    return this._connection && this._connection !== Meteor.server;                                                    // 638
	  }                                                                                                                   // 639
	                                                                                                                      //
	  return _isRemoteCollection;                                                                                         // 636
	}();                                                                                                                  // 636
	                                                                                                                      //
	// Convert the callback to not return a result if there is an error                                                   // 641
	function wrapCallback(callback, convertResult) {                                                                      // 642
	  if (!callback) {                                                                                                    // 643
	    return;                                                                                                           // 644
	  }                                                                                                                   // 645
	                                                                                                                      //
	  // If no convert function was passed in, just use a "blank function"                                                // 647
	  convertResult = convertResult || _.identity;                                                                        // 648
	                                                                                                                      //
	  return function (error, result) {                                                                                   // 650
	    callback(error, !error && convertResult(result));                                                                 // 651
	  };                                                                                                                  // 652
	}                                                                                                                     // 653
	                                                                                                                      //
	/**                                                                                                                   // 655
	 * @summary Modify one or more documents in the collection, or insert one if no matching documents were found. Returns an object with keys `numberAffected` (the number of documents modified)  and `insertedId` (the unique _id of the document that was inserted, if any).
	 * @locus Anywhere                                                                                                    //
	 * @param {MongoSelector} selector Specifies which documents to modify                                                //
	 * @param {MongoModifier} modifier Specifies how to modify the documents                                              //
	 * @param {Object} [options]                                                                                          //
	 * @param {Boolean} options.multi True to modify all matching documents; false to only modify one of the matching documents (the default).
	 * @param {Function} [callback] Optional.  If present, called with an error object as the first argument and, if no error, the number of affected documents as the second.
	 */                                                                                                                   //
	Mongo.Collection.prototype.upsert = function () {                                                                     // 664
	  function upsert(selector, modifier, options, callback) {                                                            // 664
	    if (!callback && typeof options === "function") {                                                                 // 666
	      callback = options;                                                                                             // 667
	      options = {};                                                                                                   // 668
	    }                                                                                                                 // 669
	                                                                                                                      //
	    var updateOptions = _.extend({}, options, {                                                                       // 671
	      _returnObject: true,                                                                                            // 672
	      upsert: true                                                                                                    // 673
	    });                                                                                                               // 671
	                                                                                                                      //
	    return this.update(selector, modifier, updateOptions, callback);                                                  // 676
	  }                                                                                                                   // 677
	                                                                                                                      //
	  return upsert;                                                                                                      // 664
	}();                                                                                                                  // 664
	                                                                                                                      //
	// We'll actually design an index API later. For now, we just pass through to                                         // 679
	// Mongo's, but make it synchronous.                                                                                  // 680
	Mongo.Collection.prototype._ensureIndex = function (index, options) {                                                 // 681
	  var self = this;                                                                                                    // 682
	  if (!self._collection._ensureIndex) throw new Error("Can only call _ensureIndex on server collections");            // 683
	  self._collection._ensureIndex(index, options);                                                                      // 685
	};                                                                                                                    // 686
	Mongo.Collection.prototype._dropIndex = function (index) {                                                            // 687
	  var self = this;                                                                                                    // 688
	  if (!self._collection._dropIndex) throw new Error("Can only call _dropIndex on server collections");                // 689
	  self._collection._dropIndex(index);                                                                                 // 691
	};                                                                                                                    // 692
	Mongo.Collection.prototype._dropCollection = function () {                                                            // 693
	  var self = this;                                                                                                    // 694
	  if (!self._collection.dropCollection) throw new Error("Can only call _dropCollection on server collections");       // 695
	  self._collection.dropCollection();                                                                                  // 697
	};                                                                                                                    // 698
	Mongo.Collection.prototype._createCappedCollection = function (byteSize, maxDocuments) {                              // 699
	  var self = this;                                                                                                    // 700
	  if (!self._collection._createCappedCollection) throw new Error("Can only call _createCappedCollection on server collections");
	  self._collection._createCappedCollection(byteSize, maxDocuments);                                                   // 703
	};                                                                                                                    // 704
	                                                                                                                      //
	/**                                                                                                                   // 706
	 * @summary Returns the [`Collection`](http://mongodb.github.io/node-mongodb-native/2.2/api/Collection.html) object corresponding to this collection from the [npm `mongodb` driver module](https://www.npmjs.com/package/mongodb) which is wrapped by `Mongo.Collection`.
	 * @locus Server                                                                                                      //
	 */                                                                                                                   //
	Mongo.Collection.prototype.rawCollection = function () {                                                              // 710
	  var self = this;                                                                                                    // 711
	  if (!self._collection.rawCollection) {                                                                              // 712
	    throw new Error("Can only call rawCollection on server collections");                                             // 713
	  }                                                                                                                   // 714
	  return self._collection.rawCollection();                                                                            // 715
	};                                                                                                                    // 716
	                                                                                                                      //
	/**                                                                                                                   // 718
	 * @summary Returns the [`Db`](http://mongodb.github.io/node-mongodb-native/2.2/api/Db.html) object corresponding to this collection's database connection from the [npm `mongodb` driver module](https://www.npmjs.com/package/mongodb) which is wrapped by `Mongo.Collection`.
	 * @locus Server                                                                                                      //
	 */                                                                                                                   //
	Mongo.Collection.prototype.rawDatabase = function () {                                                                // 722
	  var self = this;                                                                                                    // 723
	  if (!(self._driver.mongo && self._driver.mongo.db)) {                                                               // 724
	    throw new Error("Can only call rawDatabase on server collections");                                               // 725
	  }                                                                                                                   // 726
	  return self._driver.mongo.db;                                                                                       // 727
	};                                                                                                                    // 728
	                                                                                                                      //
	/**                                                                                                                   // 731
	 * @summary Create a Mongo-style `ObjectID`.  If you don't specify a `hexString`, the `ObjectID` will generated randomly (not using MongoDB's ID construction rules).
	 * @locus Anywhere                                                                                                    //
	 * @class                                                                                                             //
	 * @param {String} [hexString] Optional.  The 24-character hexadecimal contents of the ObjectID to create             //
	 */                                                                                                                   //
	Mongo.ObjectID = MongoID.ObjectID;                                                                                    // 737
	                                                                                                                      //
	/**                                                                                                                   // 739
	 * @summary To create a cursor, use find. To access the documents in a cursor, use forEach, map, or fetch.            //
	 * @class                                                                                                             //
	 * @instanceName cursor                                                                                               //
	 */                                                                                                                   //
	Mongo.Cursor = LocalCollection.Cursor;                                                                                // 744
	                                                                                                                      //
	/**                                                                                                                   // 746
	 * @deprecated in 0.9.1                                                                                               //
	 */                                                                                                                   //
	Mongo.Collection.Cursor = Mongo.Cursor;                                                                               // 749
	                                                                                                                      //
	/**                                                                                                                   // 751
	 * @deprecated in 0.9.1                                                                                               //
	 */                                                                                                                   //
	Mongo.Collection.ObjectID = Mongo.ObjectID;                                                                           // 754
	                                                                                                                      //
	/**                                                                                                                   // 756
	 * @deprecated in 0.9.1                                                                                               //
	 */                                                                                                                   //
	Meteor.Collection = Mongo.Collection;                                                                                 // 759
	                                                                                                                      //
	// Allow deny stuff is now in the allow-deny package                                                                  // 761
	_.extend(Meteor.Collection.prototype, AllowDeny.CollectionPrototype);                                                 // 762
	                                                                                                                      //
	function popCallbackFromArgs(args) {                                                                                  // 764
	  // Pull off any callback (or perhaps a 'callback' variable that was passed                                          // 765
	  // in undefined, like how 'upsert' does it).                                                                        // 766
	  if (args.length && (args[args.length - 1] === undefined || args[args.length - 1] instanceof Function)) {            // 767
	    return args.pop();                                                                                                // 770
	  }                                                                                                                   // 771
	}                                                                                                                     // 772
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}}}}},{"extensions":[".js",".json"]});
	require("./node_modules/meteor/mongo/local_collection_driver.js");
	require("./node_modules/meteor/mongo/collection.js");
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.mongo = {}, {
	  Mongo: Mongo
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/ordered-dict.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	
	/* Package-scope variables */
	var OrderedDict;
	
	(function(){
	
	///////////////////////////////////////////////////////////////////////////////////
	//                                                                               //
	// packages/ordered-dict/ordered_dict.js                                         //
	//                                                                               //
	///////////////////////////////////////////////////////////////////////////////////
	                                                                                 //
	// This file defines an ordered dictionary abstraction that is useful for        // 1
	// maintaining a dataset backed by observeChanges.  It supports ordering items   // 2
	// by specifying the item they now come before.                                  // 3
	                                                                                 // 4
	// The implementation is a dictionary that contains nodes of a doubly-linked     // 5
	// list as its values.                                                           // 6
	                                                                                 // 7
	// constructs a new element struct                                               // 8
	// next and prev are whole elements, not keys.                                   // 9
	var element = function (key, value, next, prev) {                                // 10
	  return {                                                                       // 11
	    key: key,                                                                    // 12
	    value: value,                                                                // 13
	    next: next,                                                                  // 14
	    prev: prev                                                                   // 15
	  };                                                                             // 16
	};                                                                               // 17
	OrderedDict = function (/* ... */) {                                             // 18
	  var self = this;                                                               // 19
	  self._dict = {};                                                               // 20
	  self._first = null;                                                            // 21
	  self._last = null;                                                             // 22
	  self._size = 0;                                                                // 23
	  var args = _.toArray(arguments);                                               // 24
	  self._stringify = function (x) { return x; };                                  // 25
	  if (typeof args[0] === 'function')                                             // 26
	    self._stringify = args.shift();                                              // 27
	  _.each(args, function (kv) {                                                   // 28
	    self.putBefore(kv[0], kv[1], null);                                          // 29
	  });                                                                            // 30
	};                                                                               // 31
	                                                                                 // 32
	_.extend(OrderedDict.prototype, {                                                // 33
	  // the "prefix keys with a space" thing comes from here                        // 34
	  // https://github.com/documentcloud/underscore/issues/376#issuecomment-2815649
	  _k: function (key) { return " " + this._stringify(key); },                     // 36
	                                                                                 // 37
	  empty: function () {                                                           // 38
	    var self = this;                                                             // 39
	    return !self._first;                                                         // 40
	  },                                                                             // 41
	  size: function () {                                                            // 42
	    var self = this;                                                             // 43
	    return self._size;                                                           // 44
	  },                                                                             // 45
	  _linkEltIn: function (elt) {                                                   // 46
	    var self = this;                                                             // 47
	    if (!elt.next) {                                                             // 48
	      elt.prev = self._last;                                                     // 49
	      if (self._last)                                                            // 50
	        self._last.next = elt;                                                   // 51
	      self._last = elt;                                                          // 52
	    } else {                                                                     // 53
	      elt.prev = elt.next.prev;                                                  // 54
	      elt.next.prev = elt;                                                       // 55
	      if (elt.prev)                                                              // 56
	        elt.prev.next = elt;                                                     // 57
	    }                                                                            // 58
	    if (self._first === null || self._first === elt.next)                        // 59
	      self._first = elt;                                                         // 60
	  },                                                                             // 61
	  _linkEltOut: function (elt) {                                                  // 62
	    var self = this;                                                             // 63
	    if (elt.next)                                                                // 64
	      elt.next.prev = elt.prev;                                                  // 65
	    if (elt.prev)                                                                // 66
	      elt.prev.next = elt.next;                                                  // 67
	    if (elt === self._last)                                                      // 68
	      self._last = elt.prev;                                                     // 69
	    if (elt === self._first)                                                     // 70
	      self._first = elt.next;                                                    // 71
	  },                                                                             // 72
	  putBefore: function (key, item, before) {                                      // 73
	    var self = this;                                                             // 74
	    if (self._dict[self._k(key)])                                                // 75
	      throw new Error("Item " + key + " already present in OrderedDict");        // 76
	    var elt = before ?                                                           // 77
	          element(key, item, self._dict[self._k(before)]) :                      // 78
	          element(key, item, null);                                              // 79
	    if (elt.next === undefined)                                                  // 80
	      throw new Error("could not find item to put this one before");             // 81
	    self._linkEltIn(elt);                                                        // 82
	    self._dict[self._k(key)] = elt;                                              // 83
	    self._size++;                                                                // 84
	  },                                                                             // 85
	  append: function (key, item) {                                                 // 86
	    var self = this;                                                             // 87
	    self.putBefore(key, item, null);                                             // 88
	  },                                                                             // 89
	  remove: function (key) {                                                       // 90
	    var self = this;                                                             // 91
	    var elt = self._dict[self._k(key)];                                          // 92
	    if (elt === undefined)                                                       // 93
	      throw new Error("Item " + key + " not present in OrderedDict");            // 94
	    self._linkEltOut(elt);                                                       // 95
	    self._size--;                                                                // 96
	    delete self._dict[self._k(key)];                                             // 97
	    return elt.value;                                                            // 98
	  },                                                                             // 99
	  get: function (key) {                                                          // 100
	    var self = this;                                                             // 101
	    if (self.has(key))                                                           // 102
	        return self._dict[self._k(key)].value;                                   // 103
	    return undefined;                                                            // 104
	  },                                                                             // 105
	  has: function (key) {                                                          // 106
	    var self = this;                                                             // 107
	    return _.has(self._dict, self._k(key));                                      // 108
	  },                                                                             // 109
	  // Iterate through the items in this dictionary in order, calling              // 110
	  // iter(value, key, index) on each one.                                        // 111
	                                                                                 // 112
	  // Stops whenever iter returns OrderedDict.BREAK, or after the last element.   // 113
	  forEach: function (iter) {                                                     // 114
	    var self = this;                                                             // 115
	    var i = 0;                                                                   // 116
	    var elt = self._first;                                                       // 117
	    while (elt !== null) {                                                       // 118
	      var b = iter(elt.value, elt.key, i);                                       // 119
	      if (b === OrderedDict.BREAK)                                               // 120
	        return;                                                                  // 121
	      elt = elt.next;                                                            // 122
	      i++;                                                                       // 123
	    }                                                                            // 124
	  },                                                                             // 125
	  first: function () {                                                           // 126
	    var self = this;                                                             // 127
	    if (self.empty())                                                            // 128
	      return undefined;                                                          // 129
	    return self._first.key;                                                      // 130
	  },                                                                             // 131
	  firstValue: function () {                                                      // 132
	    var self = this;                                                             // 133
	    if (self.empty())                                                            // 134
	      return undefined;                                                          // 135
	    return self._first.value;                                                    // 136
	  },                                                                             // 137
	  last: function () {                                                            // 138
	    var self = this;                                                             // 139
	    if (self.empty())                                                            // 140
	      return undefined;                                                          // 141
	    return self._last.key;                                                       // 142
	  },                                                                             // 143
	  lastValue: function () {                                                       // 144
	    var self = this;                                                             // 145
	    if (self.empty())                                                            // 146
	      return undefined;                                                          // 147
	    return self._last.value;                                                     // 148
	  },                                                                             // 149
	  prev: function (key) {                                                         // 150
	    var self = this;                                                             // 151
	    if (self.has(key)) {                                                         // 152
	      var elt = self._dict[self._k(key)];                                        // 153
	      if (elt.prev)                                                              // 154
	        return elt.prev.key;                                                     // 155
	    }                                                                            // 156
	    return null;                                                                 // 157
	  },                                                                             // 158
	  next: function (key) {                                                         // 159
	    var self = this;                                                             // 160
	    if (self.has(key)) {                                                         // 161
	      var elt = self._dict[self._k(key)];                                        // 162
	      if (elt.next)                                                              // 163
	        return elt.next.key;                                                     // 164
	    }                                                                            // 165
	    return null;                                                                 // 166
	  },                                                                             // 167
	  moveBefore: function (key, before) {                                           // 168
	    var self = this;                                                             // 169
	    var elt = self._dict[self._k(key)];                                          // 170
	    var eltBefore = before ? self._dict[self._k(before)] : null;                 // 171
	    if (elt === undefined)                                                       // 172
	      throw new Error("Item to move is not present");                            // 173
	    if (eltBefore === undefined) {                                               // 174
	      throw new Error("Could not find element to move this one before");         // 175
	    }                                                                            // 176
	    if (eltBefore === elt.next) // no moving necessary                           // 177
	      return;                                                                    // 178
	    // remove from its old place                                                 // 179
	    self._linkEltOut(elt);                                                       // 180
	    // patch into its new place                                                  // 181
	    elt.next = eltBefore;                                                        // 182
	    self._linkEltIn(elt);                                                        // 183
	  },                                                                             // 184
	  // Linear, sadly.                                                              // 185
	  indexOf: function (key) {                                                      // 186
	    var self = this;                                                             // 187
	    var ret = null;                                                              // 188
	    self.forEach(function (v, k, i) {                                            // 189
	      if (self._k(k) === self._k(key)) {                                         // 190
	        ret = i;                                                                 // 191
	        return OrderedDict.BREAK;                                                // 192
	      }                                                                          // 193
	      return undefined;                                                          // 194
	    });                                                                          // 195
	    return ret;                                                                  // 196
	  },                                                                             // 197
	  _checkRep: function () {                                                       // 198
	    var self = this;                                                             // 199
	    _.each(self._dict, function (k, v) {                                         // 200
	      if (v.next === v)                                                          // 201
	        throw new Error("Next is a loop");                                       // 202
	      if (v.prev === v)                                                          // 203
	        throw new Error("Prev is a loop");                                       // 204
	    });                                                                          // 205
	  }                                                                              // 206
	                                                                                 // 207
	});                                                                              // 208
	OrderedDict.BREAK = {"break": true};                                             // 209
	                                                                                 // 210
	///////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['ordered-dict'] = {}, {
	  OrderedDict: OrderedDict
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/promise.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var meteorInstall = Package.modules.meteorInstall;
	var Buffer = Package.modules.Buffer;
	var process = Package.modules.process;
	
	/* Package-scope variables */
	var Promise;
	
	var require = meteorInstall({"node_modules":{"meteor":{"promise":{"client.js":["meteor-promise","./common.js",function(require,exports){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                  //
	// packages/promise/client.js                                                                                       //
	//                                                                                                                  //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                    //
	require("meteor-promise").makeCompatible(                                                                           // 1
	  exports.Promise = require("./common.js").Promise                                                                  // 2
	);                                                                                                                  // 3
	                                                                                                                    // 4
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"common.js":["promise/lib/es6-extensions",function(require,exports){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                  //
	// packages/promise/common.js                                                                                       //
	//                                                                                                                  //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                    //
	var global = this;                                                                                                  // 1
	                                                                                                                    // 2
	if (typeof global.Promise === "function") {                                                                         // 3
	  exports.Promise = global.Promise;                                                                                 // 4
	} else {                                                                                                            // 5
	  exports.Promise = require("promise/lib/es6-extensions");                                                          // 6
	}                                                                                                                   // 7
	                                                                                                                    // 8
	exports.Promise.prototype.done = function (onFulfilled, onRejected) {                                               // 9
	  var self = this;                                                                                                  // 10
	                                                                                                                    // 11
	  if (arguments.length > 0) {                                                                                       // 12
	    self = this.then.apply(this, arguments);                                                                        // 13
	  }                                                                                                                 // 14
	                                                                                                                    // 15
	  self.then(null, function (err) {                                                                                  // 16
	    Meteor._setImmediate(function () {                                                                              // 17
	      throw err;                                                                                                    // 18
	    });                                                                                                             // 19
	  });                                                                                                               // 20
	};                                                                                                                  // 21
	                                                                                                                    // 22
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"node_modules":{"meteor-promise":{"package.json":function(require,exports){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                  //
	// ../../.0.8.8.1iimx3o++os+web.browser+web.cordova/npm/node_modules/meteor-promise/package.json                    //
	//                                                                                                                  //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                    //
	exports.name = "meteor-promise";                                                                                    // 1
	exports.version = "0.8.0";                                                                                          // 2
	exports.main = "promise_client.js";                                                                                 // 3
	                                                                                                                    // 4
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"promise_client.js":function(require,exports){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                  //
	// node_modules/meteor/promise/node_modules/meteor-promise/promise_client.js                                        //
	//                                                                                                                  //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                    //
	exports.makeCompatible = function (Promise) {                                                                       // 1
	  var es6PromiseThen = Promise.prototype.then;                                                                      // 2
	                                                                                                                    // 3
	  Promise.prototype.then = function (onResolved, onRejected) {                                                      // 4
	    if (typeof Meteor === "object" &&                                                                               // 5
	        typeof Meteor.bindEnvironment === "function") {                                                             // 6
	      return es6PromiseThen.call(                                                                                   // 7
	        this,                                                                                                       // 8
	        onResolved && Meteor.bindEnvironment(onResolved, raise),                                                    // 9
	        onRejected && Meteor.bindEnvironment(onRejected, raise)                                                     // 10
	      );                                                                                                            // 11
	    }                                                                                                               // 12
	                                                                                                                    // 13
	    return es6PromiseThen.call(this, onResolved, onRejected);                                                       // 14
	  };                                                                                                                // 15
	};                                                                                                                  // 16
	                                                                                                                    // 17
	function raise(exception) {                                                                                         // 18
	  throw exception;                                                                                                  // 19
	}                                                                                                                   // 20
	                                                                                                                    // 21
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}},"promise":{"lib":{"es6-extensions.js":["./core.js",function(require,exports,module){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                  //
	// node_modules/meteor/promise/node_modules/promise/lib/es6-extensions.js                                           //
	//                                                                                                                  //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                    //
	'use strict';                                                                                                       // 1
	                                                                                                                    // 2
	//This file contains the ES6 extensions to the core Promises/A+ API                                                 // 3
	                                                                                                                    // 4
	var Promise = require('./core.js');                                                                                 // 5
	                                                                                                                    // 6
	module.exports = Promise;                                                                                           // 7
	                                                                                                                    // 8
	/* Static Functions */                                                                                              // 9
	                                                                                                                    // 10
	var TRUE = valuePromise(true);                                                                                      // 11
	var FALSE = valuePromise(false);                                                                                    // 12
	var NULL = valuePromise(null);                                                                                      // 13
	var UNDEFINED = valuePromise(undefined);                                                                            // 14
	var ZERO = valuePromise(0);                                                                                         // 15
	var EMPTYSTRING = valuePromise('');                                                                                 // 16
	                                                                                                                    // 17
	function valuePromise(value) {                                                                                      // 18
	  var p = new Promise(Promise._61);                                                                                 // 19
	  p._81 = 1;                                                                                                        // 20
	  p._65 = value;                                                                                                    // 21
	  return p;                                                                                                         // 22
	}                                                                                                                   // 23
	Promise.resolve = function (value) {                                                                                // 24
	  if (value instanceof Promise) return value;                                                                       // 25
	                                                                                                                    // 26
	  if (value === null) return NULL;                                                                                  // 27
	  if (value === undefined) return UNDEFINED;                                                                        // 28
	  if (value === true) return TRUE;                                                                                  // 29
	  if (value === false) return FALSE;                                                                                // 30
	  if (value === 0) return ZERO;                                                                                     // 31
	  if (value === '') return EMPTYSTRING;                                                                             // 32
	                                                                                                                    // 33
	  if (typeof value === 'object' || typeof value === 'function') {                                                   // 34
	    try {                                                                                                           // 35
	      var then = value.then;                                                                                        // 36
	      if (typeof then === 'function') {                                                                             // 37
	        return new Promise(then.bind(value));                                                                       // 38
	      }                                                                                                             // 39
	    } catch (ex) {                                                                                                  // 40
	      return new Promise(function (resolve, reject) {                                                               // 41
	        reject(ex);                                                                                                 // 42
	      });                                                                                                           // 43
	    }                                                                                                               // 44
	  }                                                                                                                 // 45
	  return valuePromise(value);                                                                                       // 46
	};                                                                                                                  // 47
	                                                                                                                    // 48
	Promise.all = function (arr) {                                                                                      // 49
	  var args = Array.prototype.slice.call(arr);                                                                       // 50
	                                                                                                                    // 51
	  return new Promise(function (resolve, reject) {                                                                   // 52
	    if (args.length === 0) return resolve([]);                                                                      // 53
	    var remaining = args.length;                                                                                    // 54
	    function res(i, val) {                                                                                          // 55
	      if (val && (typeof val === 'object' || typeof val === 'function')) {                                          // 56
	        if (val instanceof Promise && val.then === Promise.prototype.then) {                                        // 57
	          while (val._81 === 3) {                                                                                   // 58
	            val = val._65;                                                                                          // 59
	          }                                                                                                         // 60
	          if (val._81 === 1) return res(i, val._65);                                                                // 61
	          if (val._81 === 2) reject(val._65);                                                                       // 62
	          val.then(function (val) {                                                                                 // 63
	            res(i, val);                                                                                            // 64
	          }, reject);                                                                                               // 65
	          return;                                                                                                   // 66
	        } else {                                                                                                    // 67
	          var then = val.then;                                                                                      // 68
	          if (typeof then === 'function') {                                                                         // 69
	            var p = new Promise(then.bind(val));                                                                    // 70
	            p.then(function (val) {                                                                                 // 71
	              res(i, val);                                                                                          // 72
	            }, reject);                                                                                             // 73
	            return;                                                                                                 // 74
	          }                                                                                                         // 75
	        }                                                                                                           // 76
	      }                                                                                                             // 77
	      args[i] = val;                                                                                                // 78
	      if (--remaining === 0) {                                                                                      // 79
	        resolve(args);                                                                                              // 80
	      }                                                                                                             // 81
	    }                                                                                                               // 82
	    for (var i = 0; i < args.length; i++) {                                                                         // 83
	      res(i, args[i]);                                                                                              // 84
	    }                                                                                                               // 85
	  });                                                                                                               // 86
	};                                                                                                                  // 87
	                                                                                                                    // 88
	Promise.reject = function (value) {                                                                                 // 89
	  return new Promise(function (resolve, reject) {                                                                   // 90
	    reject(value);                                                                                                  // 91
	  });                                                                                                               // 92
	};                                                                                                                  // 93
	                                                                                                                    // 94
	Promise.race = function (values) {                                                                                  // 95
	  return new Promise(function (resolve, reject) {                                                                   // 96
	    values.forEach(function(value){                                                                                 // 97
	      Promise.resolve(value).then(resolve, reject);                                                                 // 98
	    });                                                                                                             // 99
	  });                                                                                                               // 100
	};                                                                                                                  // 101
	                                                                                                                    // 102
	/* Prototype Methods */                                                                                             // 103
	                                                                                                                    // 104
	Promise.prototype['catch'] = function (onRejected) {                                                                // 105
	  return this.then(null, onRejected);                                                                               // 106
	};                                                                                                                  // 107
	                                                                                                                    // 108
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"core.js":["asap/raw",function(require,exports,module){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                  //
	// node_modules/meteor/promise/node_modules/promise/lib/core.js                                                     //
	//                                                                                                                  //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                    //
	'use strict';                                                                                                       // 1
	                                                                                                                    // 2
	var asap = require('asap/raw');                                                                                     // 3
	                                                                                                                    // 4
	function noop() {}                                                                                                  // 5
	                                                                                                                    // 6
	// States:                                                                                                          // 7
	//                                                                                                                  // 8
	// 0 - pending                                                                                                      // 9
	// 1 - fulfilled with _value                                                                                        // 10
	// 2 - rejected with _value                                                                                         // 11
	// 3 - adopted the state of another promise, _value                                                                 // 12
	//                                                                                                                  // 13
	// once the state is no longer pending (0) it is immutable                                                          // 14
	                                                                                                                    // 15
	// All `_` prefixed properties will be reduced to `_{random number}`                                                // 16
	// at build time to obfuscate them and discourage their use.                                                        // 17
	// We don't use symbols or Object.defineProperty to fully hide them                                                 // 18
	// because the performance isn't good enough.                                                                       // 19
	                                                                                                                    // 20
	                                                                                                                    // 21
	// to avoid using try/catch inside critical functions, we                                                           // 22
	// extract them to here.                                                                                            // 23
	var LAST_ERROR = null;                                                                                              // 24
	var IS_ERROR = {};                                                                                                  // 25
	function getThen(obj) {                                                                                             // 26
	  try {                                                                                                             // 27
	    return obj.then;                                                                                                // 28
	  } catch (ex) {                                                                                                    // 29
	    LAST_ERROR = ex;                                                                                                // 30
	    return IS_ERROR;                                                                                                // 31
	  }                                                                                                                 // 32
	}                                                                                                                   // 33
	                                                                                                                    // 34
	function tryCallOne(fn, a) {                                                                                        // 35
	  try {                                                                                                             // 36
	    return fn(a);                                                                                                   // 37
	  } catch (ex) {                                                                                                    // 38
	    LAST_ERROR = ex;                                                                                                // 39
	    return IS_ERROR;                                                                                                // 40
	  }                                                                                                                 // 41
	}                                                                                                                   // 42
	function tryCallTwo(fn, a, b) {                                                                                     // 43
	  try {                                                                                                             // 44
	    fn(a, b);                                                                                                       // 45
	  } catch (ex) {                                                                                                    // 46
	    LAST_ERROR = ex;                                                                                                // 47
	    return IS_ERROR;                                                                                                // 48
	  }                                                                                                                 // 49
	}                                                                                                                   // 50
	                                                                                                                    // 51
	module.exports = Promise;                                                                                           // 52
	                                                                                                                    // 53
	function Promise(fn) {                                                                                              // 54
	  if (typeof this !== 'object') {                                                                                   // 55
	    throw new TypeError('Promises must be constructed via new');                                                    // 56
	  }                                                                                                                 // 57
	  if (typeof fn !== 'function') {                                                                                   // 58
	    throw new TypeError('not a function');                                                                          // 59
	  }                                                                                                                 // 60
	  this._45 = 0;                                                                                                     // 61
	  this._81 = 0;                                                                                                     // 62
	  this._65 = null;                                                                                                  // 63
	  this._54 = null;                                                                                                  // 64
	  if (fn === noop) return;                                                                                          // 65
	  doResolve(fn, this);                                                                                              // 66
	}                                                                                                                   // 67
	Promise._10 = null;                                                                                                 // 68
	Promise._97 = null;                                                                                                 // 69
	Promise._61 = noop;                                                                                                 // 70
	                                                                                                                    // 71
	Promise.prototype.then = function(onFulfilled, onRejected) {                                                        // 72
	  if (this.constructor !== Promise) {                                                                               // 73
	    return safeThen(this, onFulfilled, onRejected);                                                                 // 74
	  }                                                                                                                 // 75
	  var res = new Promise(noop);                                                                                      // 76
	  handle(this, new Handler(onFulfilled, onRejected, res));                                                          // 77
	  return res;                                                                                                       // 78
	};                                                                                                                  // 79
	                                                                                                                    // 80
	function safeThen(self, onFulfilled, onRejected) {                                                                  // 81
	  return new self.constructor(function (resolve, reject) {                                                          // 82
	    var res = new Promise(noop);                                                                                    // 83
	    res.then(resolve, reject);                                                                                      // 84
	    handle(self, new Handler(onFulfilled, onRejected, res));                                                        // 85
	  });                                                                                                               // 86
	};                                                                                                                  // 87
	function handle(self, deferred) {                                                                                   // 88
	  while (self._81 === 3) {                                                                                          // 89
	    self = self._65;                                                                                                // 90
	  }                                                                                                                 // 91
	  if (Promise._10) {                                                                                                // 92
	    Promise._10(self);                                                                                              // 93
	  }                                                                                                                 // 94
	  if (self._81 === 0) {                                                                                             // 95
	    if (self._45 === 0) {                                                                                           // 96
	      self._45 = 1;                                                                                                 // 97
	      self._54 = deferred;                                                                                          // 98
	      return;                                                                                                       // 99
	    }                                                                                                               // 100
	    if (self._45 === 1) {                                                                                           // 101
	      self._45 = 2;                                                                                                 // 102
	      self._54 = [self._54, deferred];                                                                              // 103
	      return;                                                                                                       // 104
	    }                                                                                                               // 105
	    self._54.push(deferred);                                                                                        // 106
	    return;                                                                                                         // 107
	  }                                                                                                                 // 108
	  handleResolved(self, deferred);                                                                                   // 109
	}                                                                                                                   // 110
	                                                                                                                    // 111
	function handleResolved(self, deferred) {                                                                           // 112
	  asap(function() {                                                                                                 // 113
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;                                           // 114
	    if (cb === null) {                                                                                              // 115
	      if (self._81 === 1) {                                                                                         // 116
	        resolve(deferred.promise, self._65);                                                                        // 117
	      } else {                                                                                                      // 118
	        reject(deferred.promise, self._65);                                                                         // 119
	      }                                                                                                             // 120
	      return;                                                                                                       // 121
	    }                                                                                                               // 122
	    var ret = tryCallOne(cb, self._65);                                                                             // 123
	    if (ret === IS_ERROR) {                                                                                         // 124
	      reject(deferred.promise, LAST_ERROR);                                                                         // 125
	    } else {                                                                                                        // 126
	      resolve(deferred.promise, ret);                                                                               // 127
	    }                                                                                                               // 128
	  });                                                                                                               // 129
	}                                                                                                                   // 130
	function resolve(self, newValue) {                                                                                  // 131
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {                                                                                          // 133
	    return reject(                                                                                                  // 134
	      self,                                                                                                         // 135
	      new TypeError('A promise cannot be resolved with itself.')                                                    // 136
	    );                                                                                                              // 137
	  }                                                                                                                 // 138
	  if (                                                                                                              // 139
	    newValue &&                                                                                                     // 140
	    (typeof newValue === 'object' || typeof newValue === 'function')                                                // 141
	  ) {                                                                                                               // 142
	    var then = getThen(newValue);                                                                                   // 143
	    if (then === IS_ERROR) {                                                                                        // 144
	      return reject(self, LAST_ERROR);                                                                              // 145
	    }                                                                                                               // 146
	    if (                                                                                                            // 147
	      then === self.then &&                                                                                         // 148
	      newValue instanceof Promise                                                                                   // 149
	    ) {                                                                                                             // 150
	      self._81 = 3;                                                                                                 // 151
	      self._65 = newValue;                                                                                          // 152
	      finale(self);                                                                                                 // 153
	      return;                                                                                                       // 154
	    } else if (typeof then === 'function') {                                                                        // 155
	      doResolve(then.bind(newValue), self);                                                                         // 156
	      return;                                                                                                       // 157
	    }                                                                                                               // 158
	  }                                                                                                                 // 159
	  self._81 = 1;                                                                                                     // 160
	  self._65 = newValue;                                                                                              // 161
	  finale(self);                                                                                                     // 162
	}                                                                                                                   // 163
	                                                                                                                    // 164
	function reject(self, newValue) {                                                                                   // 165
	  self._81 = 2;                                                                                                     // 166
	  self._65 = newValue;                                                                                              // 167
	  if (Promise._97) {                                                                                                // 168
	    Promise._97(self, newValue);                                                                                    // 169
	  }                                                                                                                 // 170
	  finale(self);                                                                                                     // 171
	}                                                                                                                   // 172
	function finale(self) {                                                                                             // 173
	  if (self._45 === 1) {                                                                                             // 174
	    handle(self, self._54);                                                                                         // 175
	    self._54 = null;                                                                                                // 176
	  }                                                                                                                 // 177
	  if (self._45 === 2) {                                                                                             // 178
	    for (var i = 0; i < self._54.length; i++) {                                                                     // 179
	      handle(self, self._54[i]);                                                                                    // 180
	    }                                                                                                               // 181
	    self._54 = null;                                                                                                // 182
	  }                                                                                                                 // 183
	}                                                                                                                   // 184
	                                                                                                                    // 185
	function Handler(onFulfilled, onRejected, promise){                                                                 // 186
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;                                        // 187
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;                                           // 188
	  this.promise = promise;                                                                                           // 189
	}                                                                                                                   // 190
	                                                                                                                    // 191
	/**                                                                                                                 // 192
	 * Take a potentially misbehaving resolver function and make sure                                                   // 193
	 * onFulfilled and onRejected are only called once.                                                                 // 194
	 *                                                                                                                  // 195
	 * Makes no guarantees about asynchrony.                                                                            // 196
	 */                                                                                                                 // 197
	function doResolve(fn, promise) {                                                                                   // 198
	  var done = false;                                                                                                 // 199
	  var res = tryCallTwo(fn, function (value) {                                                                       // 200
	    if (done) return;                                                                                               // 201
	    done = true;                                                                                                    // 202
	    resolve(promise, value);                                                                                        // 203
	  }, function (reason) {                                                                                            // 204
	    if (done) return;                                                                                               // 205
	    done = true;                                                                                                    // 206
	    reject(promise, reason);                                                                                        // 207
	  })                                                                                                                // 208
	  if (!done && res === IS_ERROR) {                                                                                  // 209
	    done = true;                                                                                                    // 210
	    reject(promise, LAST_ERROR);                                                                                    // 211
	  }                                                                                                                 // 212
	}                                                                                                                   // 213
	                                                                                                                    // 214
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]}},"asap":{"raw.js":["domain",function(require,exports,module){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                  //
	// node_modules/meteor/promise/node_modules/asap/raw.js                                                             //
	//                                                                                                                  //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                    //
	"use strict";                                                                                                       // 1
	                                                                                                                    // 2
	var domain; // The domain module is executed on demand                                                              // 3
	var hasSetImmediate = typeof setImmediate === "function";                                                           // 4
	                                                                                                                    // 5
	// Use the fastest means possible to execute a task in its own turn, with                                           // 6
	// priority over other events including network IO events in Node.js.                                               // 7
	//                                                                                                                  // 8
	// An exception thrown by a task will permanently interrupt the processing of                                       // 9
	// subsequent tasks. The higher level `asap` function ensures that if an                                            // 10
	// exception is thrown by a task, that the task queue will continue flushing as                                     // 11
	// soon as possible, but if you use `rawAsap` directly, you are responsible to                                      // 12
	// either ensure that no exceptions are thrown from your task, or to manually                                       // 13
	// call `rawAsap.requestFlush` if an exception is thrown.                                                           // 14
	module.exports = rawAsap;                                                                                           // 15
	function rawAsap(task) {                                                                                            // 16
	    if (!queue.length) {                                                                                            // 17
	        requestFlush();                                                                                             // 18
	        flushing = true;                                                                                            // 19
	    }                                                                                                               // 20
	    // Avoids a function call                                                                                       // 21
	    queue[queue.length] = task;                                                                                     // 22
	}                                                                                                                   // 23
	                                                                                                                    // 24
	var queue = [];                                                                                                     // 25
	// Once a flush has been requested, no further calls to `requestFlush` are                                          // 26
	// necessary until the next `flush` completes.                                                                      // 27
	var flushing = false;                                                                                               // 28
	// The position of the next task to execute in the task queue. This is                                              // 29
	// preserved between calls to `flush` so that it can be resumed if                                                  // 30
	// a task throws an exception.                                                                                      // 31
	var index = 0;                                                                                                      // 32
	// If a task schedules additional tasks recursively, the task queue can grow                                        // 33
	// unbounded. To prevent memory excaustion, the task queue will periodically                                        // 34
	// truncate already-completed tasks.                                                                                // 35
	var capacity = 1024;                                                                                                // 36
	                                                                                                                    // 37
	// The flush function processes all tasks that have been scheduled with                                             // 38
	// `rawAsap` unless and until one of those tasks throws an exception.                                               // 39
	// If a task throws an exception, `flush` ensures that its state will remain                                        // 40
	// consistent and will resume where it left off when called again.                                                  // 41
	// However, `flush` does not make any arrangements to be called again if an                                         // 42
	// exception is thrown.                                                                                             // 43
	function flush() {                                                                                                  // 44
	    while (index < queue.length) {                                                                                  // 45
	        var currentIndex = index;                                                                                   // 46
	        // Advance the index before calling the task. This ensures that we will                                     // 47
	        // begin flushing on the next task the task throws an error.                                                // 48
	        index = index + 1;                                                                                          // 49
	        queue[currentIndex].call();                                                                                 // 50
	        // Prevent leaking memory for long chains of recursive calls to `asap`.                                     // 51
	        // If we call `asap` within tasks scheduled by `asap`, the queue will                                       // 52
	        // grow, but to avoid an O(n) walk for every task we execute, we don't                                      // 53
	        // shift tasks off the queue after they have been executed.                                                 // 54
	        // Instead, we periodically shift 1024 tasks off the queue.                                                 // 55
	        if (index > capacity) {                                                                                     // 56
	            // Manually shift all values starting at the index back to the                                          // 57
	            // beginning of the queue.                                                                              // 58
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {                        // 59
	                queue[scan] = queue[scan + index];                                                                  // 60
	            }                                                                                                       // 61
	            queue.length -= index;                                                                                  // 62
	            index = 0;                                                                                              // 63
	        }                                                                                                           // 64
	    }                                                                                                               // 65
	    queue.length = 0;                                                                                               // 66
	    index = 0;                                                                                                      // 67
	    flushing = false;                                                                                               // 68
	}                                                                                                                   // 69
	                                                                                                                    // 70
	rawAsap.requestFlush = requestFlush;                                                                                // 71
	function requestFlush() {                                                                                           // 72
	    // Ensure flushing is not bound to any domain.                                                                  // 73
	    // It is not sufficient to exit the domain, because domains exist on a stack.                                   // 74
	    // To execute code outside of any domain, the following dance is necessary.                                     // 75
	    var parentDomain = process.domain;                                                                              // 76
	    if (parentDomain) {                                                                                             // 77
	        if (!domain) {                                                                                              // 78
	            // Lazy execute the domain module.                                                                      // 79
	            // Only employed if the user elects to use domains.                                                     // 80
	            domain = require("domain");                                                                             // 81
	        }                                                                                                           // 82
	        domain.active = process.domain = null;                                                                      // 83
	    }                                                                                                               // 84
	                                                                                                                    // 85
	    // `setImmediate` is slower that `process.nextTick`, but `process.nextTick`                                     // 86
	    // cannot handle recursion.                                                                                     // 87
	    // `requestFlush` will only be called recursively from `asap.js`, to resume                                     // 88
	    // flushing after an error is thrown into a domain.                                                             // 89
	    // Conveniently, `setImmediate` was introduced in the same version                                              // 90
	    // `process.nextTick` started throwing recursion errors.                                                        // 91
	    if (flushing && hasSetImmediate) {                                                                              // 92
	        setImmediate(flush);                                                                                        // 93
	    } else {                                                                                                        // 94
	        process.nextTick(flush);                                                                                    // 95
	    }                                                                                                               // 96
	                                                                                                                    // 97
	    if (parentDomain) {                                                                                             // 98
	        domain.active = process.domain = parentDomain;                                                              // 99
	    }                                                                                                               // 100
	}                                                                                                                   // 101
	                                                                                                                    // 102
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}]}}}}}},{"extensions":[".js",".json"]});
	var exports = require("./node_modules/meteor/promise/client.js");
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.promise = exports, {
	  Promise: Promise
	});
	
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/timers-browserify/main.js").setImmediate))

/***/ },

/***/ "./node_modules/timers-browserify/main.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__("./node_modules/process/browser.js").nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/timers-browserify/main.js").setImmediate, __webpack_require__("./node_modules/timers-browserify/main.js").clearImmediate))

/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/raix_eventemitter.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	
	/* Package-scope variables */
	var EventEmitter;
	
	(function(){
	
	///////////////////////////////////////////////////////////////////////
	//                                                                   //
	// packages/raix_eventemitter/packages/raix_eventemitter.js          //
	//                                                                   //
	///////////////////////////////////////////////////////////////////////
	                                                                     //
	(function () {                                                       // 1
	                                                                     // 2
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                    //
	// packages/raix:eventemitter/eventemitter.client.js                                                                  //
	//                                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                      //
	/* global EventEmitter: true */                                                                                       // 1
	EventEmitter = function(options) {                                                                                    // 2
	  var self = this;                                                                                                    // 3
	  // Check that the user uses "new" keyword for api consistency                                                       // 4
	  if (! (self instanceof EventEmitter)) {                                                                             // 5
	    throw new Error('use "new" to construct an EventEmitter');                                                        // 6
	  }                                                                                                                   // 7
	                                                                                                                      // 8
	  options = options || {};                                                                                            // 9
	                                                                                                                      // 10
	  // Hidden scope                                                                                                     // 11
	  self._eventEmitter = {                                                                                              // 12
	    onListeners: {},                                                                                                  // 13
	    onceListeners: {},                                                                                                // 14
	    maxListeners: options.maxListeners || 10                                                                          // 15
	  };                                                                                                                  // 16
	};                                                                                                                    // 17
	                                                                                                                      // 18
	var _checkListenerLimit = function(eventName, listenerCount) {                                                        // 19
	  var self = this;                                                                                                    // 20
	  // Check if we are to send a warning                                                                                // 21
	  if (self._eventEmitter.maxListeners && listenerCount > self._eventEmitter.maxListeners) {                           // 22
	    // Return string                                                                                                  // 23
	    return 'warning: possible EventEmitter memory leak detected. ' +                                                  // 24
	        listenerCount + ' listeners added on event "' + eventName +                                                   // 25
	        '". Use emitter.setMaxListeners() to increase limit. (' +                                                     // 26
	        self._eventEmitter.maxListeners + ')';                                                                        // 27
	                                                                                                                      // 28
	  }                                                                                                                   // 29
	};                                                                                                                    // 30
	                                                                                                                      // 31
	// By default EventEmitters will print a warning if more than 10 listeners are                                        // 32
	// added for a particular event. This is a useful default which helps finding                                         // 33
	// memory leaks. Obviously not all Emitters should be limited to 10. This function                                    // 34
	// allows that to be increased. Set to zero for unlimited.                                                            // 35
	EventEmitter.prototype.setMaxListeners = function(n) {                                                                // 36
	  this._eventEmitter.maxListeners = n;                                                                                // 37
	};                                                                                                                    // 38
	                                                                                                                      // 39
	var _addToList = function(list, eventName, listener) {                                                                // 40
	  // Check that we have a container for the event, Create listener array                                              // 41
	  if (typeof list[eventName] === 'undefined') {                                                                       // 42
	    list[eventName] = [];                                                                                             // 43
	  }                                                                                                                   // 44
	                                                                                                                      // 45
	  // Make sure the listener is not in there already?                                                                  // 46
	  // We have to comment this to be compliant with node.js                                                             // 47
	  // list[eventName] = _.without(list[eventName], listener);                                                          // 48
	                                                                                                                      // 49
	  // Add the listener and Check the limit                                                                             // 50
	  return _checkListenerLimit.apply(this, [eventName, list[eventName].push(listener)]);                                // 51
	};                                                                                                                    // 52
	                                                                                                                      // 53
	// Adds a listener to the end of the listeners array for the specified event.                                         // 54
	// server.on('connection', function (stream) {                                                                        // 55
	//   console.log('someone connected!');                                                                               // 56
	// });                                                                                                                // 57
	// Returns emitter, so calls can be chained.                                                                          // 58
	EventEmitter.prototype.on = function(eventName, listener) {                                                           // 59
	  var warn = _addToList.apply(this, [this._eventEmitter.onListeners, eventName, listener]);                           // 60
	                                                                                                                      // 61
	  // Warn if needed                                                                                                   // 62
	  if (warn) {                                                                                                         // 63
	    console.warn((new Error(warn)).stack);                                                                            // 64
	  }                                                                                                                   // 65
	                                                                                                                      // 66
	  // Return the emitter                                                                                               // 67
	  return this;                                                                                                        // 68
	};                                                                                                                    // 69
	                                                                                                                      // 70
	// Adds a one time listener for the event. This listener is invoked                                                   // 71
	// only the next time the event is fired, after which it is removed.                                                  // 72
	EventEmitter.prototype.once = function(eventName, listener) {                                                         // 73
	  var warn = _addToList.apply(this, [this._eventEmitter.onceListeners, eventName, listener]);                         // 74
	                                                                                                                      // 75
	  // Warn if needed                                                                                                   // 76
	  if (warn) {                                                                                                         // 77
	    console.warn((new Error(warn)).stack);                                                                            // 78
	  }                                                                                                                   // 79
	                                                                                                                      // 80
	  // Return the emitter                                                                                               // 81
	  return this;                                                                                                        // 82
	};                                                                                                                    // 83
	                                                                                                                      // 84
	var _runCallbacks = function(listenerArray, args) {                                                                   // 85
	  var self = this;                                                                                                    // 86
	  // count of listeners triggered                                                                                     // 87
	  var count = 0;                                                                                                      // 88
	  // Check if we have anything to work with                                                                           // 89
	  if (typeof listenerArray !== 'undefined') {                                                                         // 90
	    // Try to iterate over the listeners                                                                              // 91
	    _.each(listenerArray, function(listener) {                                                                        // 92
	      // Count listener calls                                                                                         // 93
	      count++;                                                                                                        // 94
	      // Send the job to the eventloop                                                                                // 95
	      listener.apply(self, args);                                                                                     // 96
	    });                                                                                                               // 97
	  }                                                                                                                   // 98
	                                                                                                                      // 99
	  // Return the count                                                                                                 // 100
	  return count;                                                                                                       // 101
	};                                                                                                                    // 102
	                                                                                                                      // 103
	// emitter.emit(event, [arg1], [arg2], [...])#                                                                        // 104
	// Execute each of the listeners in order with the supplied arguments.                                                // 105
	EventEmitter.prototype.emit = function(eventName /* arguments */) {                                                   // 106
	  var self = this;                                                                                                    // 107
	  // make argument list to pass on to listeners                                                                       // 108
	  var args = _.rest(arguments);                                                                                       // 109
	                                                                                                                      // 110
	  // Count listeners triggered                                                                                        // 111
	  var count = 0;                                                                                                      // 112
	                                                                                                                      // 113
	  // Swap once list                                                                                                   // 114
	  var onceList = self._eventEmitter.onceListeners[eventName];                                                         // 115
	                                                                                                                      // 116
	  // Empty the once list                                                                                              // 117
	  self._eventEmitter.onceListeners[eventName] = [];                                                                   // 118
	                                                                                                                      // 119
	  // Trigger on listeners                                                                                             // 120
	  count += _runCallbacks.call(self, self._eventEmitter.onListeners[eventName], args);                                 // 121
	                                                                                                                      // 122
	  // Trigger once listeners                                                                                           // 123
	  count += _runCallbacks.call(self, onceList, args);                                                                  // 124
	                                                                                                                      // 125
	  // Returns true if event had listeners, false otherwise.                                                            // 126
	  return (count > 0);                                                                                                 // 127
	};                                                                                                                    // 128
	                                                                                                                      // 129
	// XXX: When removing a listener in node js it only removes one - not all.                                            // 130
	var _withoutOne = function(list, obj) {                                                                               // 131
	  var found = false;                                                                                                  // 132
	  var result = [];                                                                                                    // 133
	                                                                                                                      // 134
	  // Iterate over listeners                                                                                           // 135
	  for (var i = 0; i < list.length; i++) {                                                                             // 136
	    // Check if we found one...                                                                                       // 137
	    if (!found && list[i] === obj) {                                                                                  // 138
	      found = true;                                                                                                   // 139
	    } else {                                                                                                          // 140
	      result.push(list[i]);                                                                                           // 141
	    }                                                                                                                 // 142
	  }                                                                                                                   // 143
	                                                                                                                      // 144
	  // return the new array                                                                                             // 145
	  return result;                                                                                                      // 146
	};                                                                                                                    // 147
	                                                                                                                      // 148
	// Removes all listeners, or those of the specified event. It's not a                                                 // 149
	// good idea to remove listeners that were added elsewhere in the code,                                               // 150
	// especially when it's on an emitter that you didn't create (e.g. sockets                                            // 151
	// or file streams).                                                                                                  // 152
	// Returns emitter, so calls can be chained.                                                                          // 153
	EventEmitter.prototype.off = function(eventName, listener) {                                                          // 154
	  var self = this;                                                                                                    // 155
	  if (eventName) {                                                                                                    // 156
	    if (typeof listener === 'function') {                                                                             // 157
	      // its a bit more tricky - we have to iterate over the arrays and only                                          // 158
	      // clone listeners not equal to                                                                                 // 159
	      if (typeof self._eventEmitter.onListeners[eventName] !== 'undefined') {                                         // 160
	        self._eventEmitter.onListeners[eventName] = _withoutOne(self._eventEmitter.onListeners[eventName], listener); // 161
	                                                                                                                      // 162
	      }                                                                                                               // 163
	      if (typeof self._eventEmitter.onceListeners[eventName] !== 'undefined') {                                       // 164
	        self._eventEmitter.onceListeners[eventName] = _withoutOne(self._eventEmitter.onceListeners[eventName], listener);
	                                                                                                                      // 166
	      }                                                                                                               // 167
	    } else {                                                                                                          // 168
	      // Remove all listeners for eventName                                                                           // 169
	      self._eventEmitter.onListeners[eventName] = [];                                                                 // 170
	      self._eventEmitter.onceListeners[eventName] = [];                                                               // 171
	    }                                                                                                                 // 172
	                                                                                                                      // 173
	  } else {                                                                                                            // 174
	    // Remove all listeners                                                                                           // 175
	    self._eventEmitter.onListeners = {};                                                                              // 176
	    self._eventEmitter.onceListeners = {};                                                                            // 177
	  }                                                                                                                   // 178
	};                                                                                                                    // 179
	                                                                                                                      // 180
	// Add api helpers                                                                                                    // 181
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;                                                       // 182
	EventEmitter.prototype.removeListener = EventEmitter.prototype.off;                                                   // 183
	EventEmitter.prototype.removeAllListeners = EventEmitter.prototype.off;                                               // 184
	                                                                                                                      // 185
	// Add jquery like helpers                                                                                            // 186
	EventEmitter.prototype.one = EventEmitter.prototype.once;                                                             // 187
	EventEmitter.prototype.trigger = EventEmitter.prototype.emit;                                                         // 188
	                                                                                                                      // 189
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                     // 199
	}).call(this);                                                       // 200
	                                                                     // 201
	///////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['raix:eventemitter'] = {}, {
	  EventEmitter: EventEmitter
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/random.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	var meteorInstall = Package.modules.meteorInstall;
	var Buffer = Package.modules.Buffer;
	var process = Package.modules.process;
	var Symbol = Package['ecmascript-runtime'].Symbol;
	var Map = Package['ecmascript-runtime'].Map;
	var Set = Package['ecmascript-runtime'].Set;
	var meteorBabelHelpers = Package['babel-runtime'].meteorBabelHelpers;
	var Promise = Package.promise.Promise;
	
	/* Package-scope variables */
	var Random;
	
	var require = meteorInstall({"node_modules":{"meteor":{"random":{"random.js":function(require){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// packages/random/random.js                                                                                           //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// We use cryptographically strong PRNGs (crypto.getRandomBytes() on the server,                                       // 1
	// window.crypto.getRandomValues() in the browser) when available. If these                                            // 2
	// PRNGs fail, we fall back to the Alea PRNG, which is not cryptographically                                           // 3
	// strong, and we seed it with various sources such as the date, Math.random,                                          // 4
	// and window size on the client.  When using crypto.getRandomValues(), our                                            // 5
	// primitive is hexString(), from which we construct fraction(). When using                                            // 6
	// window.crypto.getRandomValues() or alea, the primitive is fraction and we use                                       // 7
	// that to construct hex string.                                                                                       // 8
	                                                                                                                       //
	if (Meteor.isServer) var nodeCrypto = Npm.require('crypto');                                                           // 10
	                                                                                                                       //
	// see http://baagoe.org/en/wiki/Better_random_numbers_for_javascript                                                  // 13
	// for a full discussion and Alea implementation.                                                                      // 14
	var Alea = function Alea() {                                                                                           // 15
	  function Mash() {                                                                                                    // 16
	    var n = 0xefc8249d;                                                                                                // 17
	                                                                                                                       //
	    var mash = function mash(data) {                                                                                   // 19
	      data = data.toString();                                                                                          // 20
	      for (var i = 0; i < data.length; i++) {                                                                          // 21
	        n += data.charCodeAt(i);                                                                                       // 22
	        var h = 0.02519603282416938 * n;                                                                               // 23
	        n = h >>> 0;                                                                                                   // 24
	        h -= n;                                                                                                        // 25
	        h *= n;                                                                                                        // 26
	        n = h >>> 0;                                                                                                   // 27
	        h -= n;                                                                                                        // 28
	        n += h * 0x100000000; // 2^32                                                                                  // 29
	      }                                                                                                                // 30
	      return (n >>> 0) * 2.3283064365386963e-10; // 2^-32                                                              // 31
	    };                                                                                                                 // 32
	                                                                                                                       //
	    mash.version = 'Mash 0.9';                                                                                         // 34
	    return mash;                                                                                                       // 35
	  }                                                                                                                    // 36
	                                                                                                                       //
	  return function (args) {                                                                                             // 38
	    var s0 = 0;                                                                                                        // 39
	    var s1 = 0;                                                                                                        // 40
	    var s2 = 0;                                                                                                        // 41
	    var c = 1;                                                                                                         // 42
	                                                                                                                       //
	    if (args.length == 0) {                                                                                            // 44
	      args = [+new Date()];                                                                                            // 45
	    }                                                                                                                  // 46
	    var mash = Mash();                                                                                                 // 47
	    s0 = mash(' ');                                                                                                    // 48
	    s1 = mash(' ');                                                                                                    // 49
	    s2 = mash(' ');                                                                                                    // 50
	                                                                                                                       //
	    for (var i = 0; i < args.length; i++) {                                                                            // 52
	      s0 -= mash(args[i]);                                                                                             // 53
	      if (s0 < 0) {                                                                                                    // 54
	        s0 += 1;                                                                                                       // 55
	      }                                                                                                                // 56
	      s1 -= mash(args[i]);                                                                                             // 57
	      if (s1 < 0) {                                                                                                    // 58
	        s1 += 1;                                                                                                       // 59
	      }                                                                                                                // 60
	      s2 -= mash(args[i]);                                                                                             // 61
	      if (s2 < 0) {                                                                                                    // 62
	        s2 += 1;                                                                                                       // 63
	      }                                                                                                                // 64
	    }                                                                                                                  // 65
	    mash = null;                                                                                                       // 66
	                                                                                                                       //
	    var random = function random() {                                                                                   // 68
	      var t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32                                                      // 69
	      s0 = s1;                                                                                                         // 70
	      s1 = s2;                                                                                                         // 71
	      return s2 = t - (c = t | 0);                                                                                     // 72
	    };                                                                                                                 // 73
	    random.uint32 = function () {                                                                                      // 74
	      return random() * 0x100000000; // 2^32                                                                           // 75
	    };                                                                                                                 // 76
	    random.fract53 = function () {                                                                                     // 77
	      return random() + (random() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53                                   // 78
	    };                                                                                                                 // 80
	    random.version = 'Alea 0.9';                                                                                       // 81
	    random.args = args;                                                                                                // 82
	    return random;                                                                                                     // 83
	  }(Array.prototype.slice.call(arguments));                                                                            // 85
	};                                                                                                                     // 86
	                                                                                                                       //
	var UNMISTAKABLE_CHARS = "23456789ABCDEFGHJKLMNPQRSTWXYZabcdefghijkmnopqrstuvwxyz";                                    // 88
	var BASE64_CHARS = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ" + "0123456789-_";                            // 89
	                                                                                                                       //
	// `type` is one of `RandomGenerator.Type` as defined below.                                                           // 92
	//                                                                                                                     // 93
	// options:                                                                                                            // 94
	// - seeds: (required, only for RandomGenerator.Type.ALEA) an array                                                    // 95
	//   whose items will be `toString`ed and used as the seed to the Alea                                                 // 96
	//   algorithm                                                                                                         // 97
	var RandomGenerator = function RandomGenerator(type, options) {                                                        // 98
	  var self = this;                                                                                                     // 99
	  self.type = type;                                                                                                    // 100
	                                                                                                                       //
	  if (!RandomGenerator.Type[type]) {                                                                                   // 102
	    throw new Error("Unknown random generator type: " + type);                                                         // 103
	  }                                                                                                                    // 104
	                                                                                                                       //
	  if (type === RandomGenerator.Type.ALEA) {                                                                            // 106
	    if (!options.seeds) {                                                                                              // 107
	      throw new Error("No seeds were provided for Alea PRNG");                                                         // 108
	    }                                                                                                                  // 109
	    self.alea = Alea.apply(null, options.seeds);                                                                       // 110
	  }                                                                                                                    // 111
	};                                                                                                                     // 112
	                                                                                                                       //
	// Types of PRNGs supported by the `RandomGenerator` class                                                             // 114
	RandomGenerator.Type = {                                                                                               // 115
	  // Use Node's built-in `crypto.getRandomBytes` (cryptographically                                                    // 116
	  // secure but not seedable, runs only on the server). Reverts to                                                     // 117
	  // `crypto.getPseudoRandomBytes` in the extremely uncommon case that                                                 // 118
	  // there isn't enough entropy yet                                                                                    // 119
	  NODE_CRYPTO: "NODE_CRYPTO",                                                                                          // 120
	                                                                                                                       //
	  // Use non-IE browser's built-in `window.crypto.getRandomValues`                                                     // 122
	  // (cryptographically secure but not seedable, runs only in the                                                      // 123
	  // browser).                                                                                                         // 124
	  BROWSER_CRYPTO: "BROWSER_CRYPTO",                                                                                    // 125
	                                                                                                                       //
	  // Use the *fast*, seedaable and not cryptographically secure                                                        // 127
	  // Alea algorithm                                                                                                    // 128
	  ALEA: "ALEA"                                                                                                         // 129
	};                                                                                                                     // 115
	                                                                                                                       //
	/**                                                                                                                    // 132
	 * @name Random.fraction                                                                                               //
	 * @summary Return a number between 0 and 1, like `Math.random`.                                                       //
	 * @locus Anywhere                                                                                                     //
	 */                                                                                                                    //
	RandomGenerator.prototype.fraction = function () {                                                                     // 137
	  var self = this;                                                                                                     // 138
	  if (self.type === RandomGenerator.Type.ALEA) {                                                                       // 139
	    return self.alea();                                                                                                // 140
	  } else if (self.type === RandomGenerator.Type.NODE_CRYPTO) {                                                         // 141
	    var numerator = parseInt(self.hexString(8), 16);                                                                   // 142
	    return numerator * 2.3283064365386963e-10; // 2^-32                                                                // 143
	  } else if (self.type === RandomGenerator.Type.BROWSER_CRYPTO) {                                                      // 144
	    var array = new Uint32Array(1);                                                                                    // 145
	    window.crypto.getRandomValues(array);                                                                              // 146
	    return array[0] * 2.3283064365386963e-10; // 2^-32                                                                 // 147
	  } else {                                                                                                             // 148
	    throw new Error('Unknown random generator type: ' + self.type);                                                    // 149
	  }                                                                                                                    // 150
	};                                                                                                                     // 151
	                                                                                                                       //
	/**                                                                                                                    // 153
	 * @name Random.hexString                                                                                              //
	 * @summary Return a random string of `n` hexadecimal digits.                                                          //
	 * @locus Anywhere                                                                                                     //
	 * @param {Number} n Length of the string                                                                              //
	 */                                                                                                                    //
	RandomGenerator.prototype.hexString = function (digits) {                                                              // 159
	  var self = this;                                                                                                     // 160
	  if (self.type === RandomGenerator.Type.NODE_CRYPTO) {                                                                // 161
	    var numBytes = Math.ceil(digits / 2);                                                                              // 162
	    var bytes;                                                                                                         // 163
	    // Try to get cryptographically strong randomness. Fall back to                                                    // 164
	    // non-cryptographically strong if not available.                                                                  // 165
	    try {                                                                                                              // 166
	      bytes = nodeCrypto.randomBytes(numBytes);                                                                        // 167
	    } catch (e) {                                                                                                      // 168
	      // XXX should re-throw any error except insufficient entropy                                                     // 169
	      bytes = nodeCrypto.pseudoRandomBytes(numBytes);                                                                  // 170
	    }                                                                                                                  // 171
	    var result = bytes.toString("hex");                                                                                // 172
	    // If the number of digits is odd, we'll have generated an extra 4 bits                                            // 173
	    // of randomness, so we need to trim the last digit.                                                               // 174
	    return result.substring(0, digits);                                                                                // 175
	  } else {                                                                                                             // 176
	    return this._randomString(digits, "0123456789abcdef");                                                             // 177
	  }                                                                                                                    // 178
	};                                                                                                                     // 179
	                                                                                                                       //
	RandomGenerator.prototype._randomString = function (charsCount, alphabet) {                                            // 181
	  var self = this;                                                                                                     // 183
	  var digits = [];                                                                                                     // 184
	  for (var i = 0; i < charsCount; i++) {                                                                               // 185
	    digits[i] = self.choice(alphabet);                                                                                 // 186
	  }                                                                                                                    // 187
	  return digits.join("");                                                                                              // 188
	};                                                                                                                     // 189
	                                                                                                                       //
	/**                                                                                                                    // 191
	 * @name Random.id                                                                                                     //
	 * @summary Return a unique identifier, such as `"Jjwjg6gouWLXhMGKW"`, that is                                         //
	 * likely to be unique in the whole world.                                                                             //
	 * @locus Anywhere                                                                                                     //
	 * @param {Number} [n] Optional length of the identifier in characters                                                 //
	 *   (defaults to 17)                                                                                                  //
	 */                                                                                                                    //
	RandomGenerator.prototype.id = function (charsCount) {                                                                 // 199
	  var self = this;                                                                                                     // 200
	  // 17 characters is around 96 bits of entropy, which is the amount of                                                // 201
	  // state in the Alea PRNG.                                                                                           // 202
	  if (charsCount === undefined) charsCount = 17;                                                                       // 203
	                                                                                                                       //
	  return self._randomString(charsCount, UNMISTAKABLE_CHARS);                                                           // 206
	};                                                                                                                     // 207
	                                                                                                                       //
	/**                                                                                                                    // 209
	 * @name Random.secret                                                                                                 //
	 * @summary Return a random string of printable characters with 6 bits of                                              //
	 * entropy per character. Use `Random.secret` for security-critical secrets                                            //
	 * that are intended for machine, rather than human, consumption.                                                      //
	 * @locus Anywhere                                                                                                     //
	 * @param {Number} [n] Optional length of the secret string (defaults to 43                                            //
	 *   characters, or 256 bits of entropy)                                                                               //
	 */                                                                                                                    //
	RandomGenerator.prototype.secret = function (charsCount) {                                                             // 218
	  var self = this;                                                                                                     // 219
	  // Default to 256 bits of entropy, or 43 characters at 6 bits per                                                    // 220
	  // character.                                                                                                        // 221
	  if (charsCount === undefined) charsCount = 43;                                                                       // 222
	  return self._randomString(charsCount, BASE64_CHARS);                                                                 // 224
	};                                                                                                                     // 225
	                                                                                                                       //
	/**                                                                                                                    // 227
	 * @name Random.choice                                                                                                 //
	 * @summary Return a random element of the given array or string.                                                      //
	 * @locus Anywhere                                                                                                     //
	 * @param {Array|String} arrayOrString Array or string to choose from                                                  //
	 */                                                                                                                    //
	RandomGenerator.prototype.choice = function (arrayOrString) {                                                          // 233
	  var index = Math.floor(this.fraction() * arrayOrString.length);                                                      // 234
	  if (typeof arrayOrString === "string") return arrayOrString.substr(index, 1);else return arrayOrString[index];       // 235
	};                                                                                                                     // 239
	                                                                                                                       //
	// instantiate RNG.  Heuristically collect entropy from various sources when a                                         // 241
	// cryptographic PRNG isn't available.                                                                                 // 242
	                                                                                                                       //
	// client sources                                                                                                      // 244
	var height = typeof window !== 'undefined' && window.innerHeight || typeof document !== 'undefined' && document.documentElement && document.documentElement.clientHeight || typeof document !== 'undefined' && document.body && document.body.clientHeight || 1;
	                                                                                                                       //
	var width = typeof window !== 'undefined' && window.innerWidth || typeof document !== 'undefined' && document.documentElement && document.documentElement.clientWidth || typeof document !== 'undefined' && document.body && document.body.clientWidth || 1;
	                                                                                                                       //
	var agent = typeof navigator !== 'undefined' && navigator.userAgent || "";                                             // 263
	                                                                                                                       //
	function createAleaGeneratorWithGeneratedSeed() {                                                                      // 265
	  return new RandomGenerator(RandomGenerator.Type.ALEA, { seeds: [new Date(), height, width, agent, Math.random()] });
	};                                                                                                                     // 269
	                                                                                                                       //
	if (Meteor.isServer) {                                                                                                 // 271
	  Random = new RandomGenerator(RandomGenerator.Type.NODE_CRYPTO);                                                      // 272
	} else {                                                                                                               // 273
	  if (typeof window !== "undefined" && window.crypto && window.crypto.getRandomValues) {                               // 274
	    Random = new RandomGenerator(RandomGenerator.Type.BROWSER_CRYPTO);                                                 // 276
	  } else {                                                                                                             // 277
	    // On IE 10 and below, there's no browser crypto API                                                               // 278
	    // available. Fall back to Alea                                                                                    // 279
	    //                                                                                                                 // 280
	    // XXX looks like at the moment, we use Alea in IE 11 as well,                                                     // 281
	    // which has `window.msCrypto` instead of `window.crypto`.                                                         // 282
	    Random = createAleaGeneratorWithGeneratedSeed();                                                                   // 283
	  }                                                                                                                    // 284
	}                                                                                                                      // 285
	                                                                                                                       //
	// Create a non-cryptographically secure PRNG with a given seed (using                                                 // 287
	// the Alea algorithm)                                                                                                 // 288
	Random.createWithSeeds = function () {                                                                                 // 289
	  for (var _len = arguments.length, seeds = Array(_len), _key = 0; _key < _len; _key++) {                              // 289
	    seeds[_key] = arguments[_key];                                                                                     // 289
	  }                                                                                                                    // 289
	                                                                                                                       //
	  if (seeds.length === 0) {                                                                                            // 290
	    throw new Error("No seeds were provided");                                                                         // 291
	  }                                                                                                                    // 292
	  return new RandomGenerator(RandomGenerator.Type.ALEA, { seeds: seeds });                                             // 293
	};                                                                                                                     // 294
	                                                                                                                       //
	// Used like `Random`, but much faster and not cryptographically                                                       // 296
	// secure                                                                                                              // 297
	Random.insecure = createAleaGeneratorWithGeneratedSeed();                                                              // 298
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	},"deprecated.js":function(){
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                     //
	// packages/random/deprecated.js                                                                                       //
	//                                                                                                                     //
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                       //
	// Before this package existed, we used to use this Meteor.uuid()                                                      // 1
	// implementing the RFC 4122 v4 UUID. It is no longer documented                                                       // 2
	// and will go away.                                                                                                   // 3
	// XXX COMPAT WITH 0.5.6                                                                                               // 4
	Meteor.uuid = function () {                                                                                            // 5
	  var HEX_DIGITS = "0123456789abcdef";                                                                                 // 6
	  var s = [];                                                                                                          // 7
	  for (var i = 0; i < 36; i++) {                                                                                       // 8
	    s[i] = Random.choice(HEX_DIGITS);                                                                                  // 9
	  }                                                                                                                    // 10
	  s[14] = "4";                                                                                                         // 11
	  s[19] = HEX_DIGITS.substr(parseInt(s[19], 16) & 0x3 | 0x8, 1);                                                       // 12
	  s[8] = s[13] = s[18] = s[23] = "-";                                                                                  // 13
	                                                                                                                       //
	  var uuid = s.join("");                                                                                               // 15
	  return uuid;                                                                                                         // 16
	};                                                                                                                     // 17
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}}}}},{"extensions":[".js",".json"]});
	require("./node_modules/meteor/random/random.js");
	require("./node_modules/meteor/random/deprecated.js");
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.random = {}, {
	  Random: Random
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/reactive-dict.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	var Tracker = Package.tracker.Tracker;
	var Deps = Package.tracker.Deps;
	var EJSON = Package.ejson.EJSON;
	var meteorInstall = Package.modules.meteorInstall;
	var Buffer = Package.modules.Buffer;
	var process = Package.modules.process;
	var Symbol = Package['ecmascript-runtime'].Symbol;
	var Map = Package['ecmascript-runtime'].Map;
	var Set = Package['ecmascript-runtime'].Set;
	var meteorBabelHelpers = Package['babel-runtime'].meteorBabelHelpers;
	var Promise = Package.promise.Promise;
	
	/* Package-scope variables */
	var ReactiveDict;
	
	var require = meteorInstall({"node_modules":{"meteor":{"reactive-dict":{"reactive-dict.js":["babel-runtime/helpers/typeof",function(require,exports,module){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                //
	// packages/reactive-dict/reactive-dict.js                                                                        //
	//                                                                                                                //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                  //
	var _typeof;module.import('babel-runtime/helpers/typeof',{"default":function(v){_typeof=v}});                     //
	// XXX come up with a serialization method which canonicalizes object key                                         // 1
	// order, which would allow us to use objects as values for equals.                                               // 2
	var stringify = function stringify(value) {                                                                       // 3
	  if (value === undefined) return 'undefined';                                                                    // 4
	  return EJSON.stringify(value);                                                                                  // 6
	};                                                                                                                // 7
	var parse = function parse(serialized) {                                                                          // 8
	  if (serialized === undefined || serialized === 'undefined') return undefined;                                   // 9
	  return EJSON.parse(serialized);                                                                                 // 11
	};                                                                                                                // 12
	                                                                                                                  //
	var changed = function changed(v) {                                                                               // 14
	  v && v.changed();                                                                                               // 15
	};                                                                                                                // 16
	                                                                                                                  //
	// XXX COMPAT WITH 0.9.1 : accept migrationData instead of dictName                                               // 18
	ReactiveDict = function (_ReactiveDict) {                                                                         // 19
	  function ReactiveDict(_x) {                                                                                     // 19
	    return _ReactiveDict.apply(this, arguments);                                                                  // 19
	  }                                                                                                               // 19
	                                                                                                                  //
	  ReactiveDict.toString = function () {                                                                           // 19
	    return _ReactiveDict.toString();                                                                              // 19
	  };                                                                                                              // 19
	                                                                                                                  //
	  return ReactiveDict;                                                                                            // 19
	}(function (dictName) {                                                                                           // 19
	  // this.keys: key -> value                                                                                      // 20
	  if (dictName) {                                                                                                 // 21
	    if (typeof dictName === 'string') {                                                                           // 22
	      // the normal case, argument is a string name.                                                              // 23
	      // _registerDictForMigrate will throw an error on duplicate name.                                           // 24
	      ReactiveDict._registerDictForMigrate(dictName, this);                                                       // 25
	      this.keys = ReactiveDict._loadMigratedDict(dictName) || {};                                                 // 26
	      this.name = dictName;                                                                                       // 27
	    } else if ((typeof dictName === 'undefined' ? 'undefined' : _typeof(dictName)) === 'object') {                // 28
	      // back-compat case: dictName is actually migrationData                                                     // 29
	      this.keys = dictName;                                                                                       // 30
	    } else {                                                                                                      // 31
	      throw new Error("Invalid ReactiveDict argument: " + dictName);                                              // 32
	    }                                                                                                             // 33
	  } else {                                                                                                        // 34
	    // no name given; no migration will be performed                                                              // 35
	    this.keys = {};                                                                                               // 36
	  }                                                                                                               // 37
	                                                                                                                  //
	  this.allDeps = new Tracker.Dependency();                                                                        // 39
	  this.keyDeps = {}; // key -> Dependency                                                                         // 40
	  this.keyValueDeps = {}; // key -> Dependency                                                                    // 41
	});                                                                                                               // 42
	                                                                                                                  //
	_.extend(ReactiveDict.prototype, {                                                                                // 44
	  // set() began as a key/value method, but we are now overloading it                                             // 45
	  // to take an object of key/value pairs, similar to backbone                                                    // 46
	  // http://backbonejs.org/#Model-set                                                                             // 47
	                                                                                                                  //
	  set: function () {                                                                                              // 49
	    function set(keyOrObject, value) {                                                                            // 49
	      var self = this;                                                                                            // 50
	                                                                                                                  //
	      if ((typeof keyOrObject === 'undefined' ? 'undefined' : _typeof(keyOrObject)) === 'object' && value === undefined) {
	        // Called as `dict.set({...})`                                                                            // 53
	        self._setObject(keyOrObject);                                                                             // 54
	        return;                                                                                                   // 55
	      }                                                                                                           // 56
	      // the input isn't an object, so it must be a key                                                           // 57
	      // and we resume with the rest of the function                                                              // 58
	      var key = keyOrObject;                                                                                      // 59
	                                                                                                                  //
	      value = stringify(value);                                                                                   // 61
	                                                                                                                  //
	      var keyExisted = _.has(self.keys, key);                                                                     // 63
	      var oldSerializedValue = keyExisted ? self.keys[key] : 'undefined';                                         // 64
	      var isNewValue = value !== oldSerializedValue;                                                              // 65
	                                                                                                                  //
	      self.keys[key] = value;                                                                                     // 67
	                                                                                                                  //
	      if (isNewValue || !keyExisted) {                                                                            // 69
	        self.allDeps.changed();                                                                                   // 70
	      }                                                                                                           // 71
	                                                                                                                  //
	      if (isNewValue) {                                                                                           // 73
	        changed(self.keyDeps[key]);                                                                               // 74
	        if (self.keyValueDeps[key]) {                                                                             // 75
	          changed(self.keyValueDeps[key][oldSerializedValue]);                                                    // 76
	          changed(self.keyValueDeps[key][value]);                                                                 // 77
	        }                                                                                                         // 78
	      }                                                                                                           // 79
	    }                                                                                                             // 80
	                                                                                                                  //
	    return set;                                                                                                   // 49
	  }(),                                                                                                            // 49
	                                                                                                                  //
	  setDefault: function () {                                                                                       // 82
	    function setDefault(keyOrObject, value) {                                                                     // 82
	      var self = this;                                                                                            // 83
	                                                                                                                  //
	      if ((typeof keyOrObject === 'undefined' ? 'undefined' : _typeof(keyOrObject)) === 'object' && value === undefined) {
	        // Called as `dict.setDefault({...})`                                                                     // 86
	        self._setDefaultObject(keyOrObject);                                                                      // 87
	        return;                                                                                                   // 88
	      }                                                                                                           // 89
	      // the input isn't an object, so it must be a key                                                           // 90
	      // and we resume with the rest of the function                                                              // 91
	      var key = keyOrObject;                                                                                      // 92
	                                                                                                                  //
	      if (!_.has(self.keys, key)) {                                                                               // 94
	        self.set(key, value);                                                                                     // 95
	      }                                                                                                           // 96
	    }                                                                                                             // 97
	                                                                                                                  //
	    return setDefault;                                                                                            // 82
	  }(),                                                                                                            // 82
	                                                                                                                  //
	  get: function () {                                                                                              // 99
	    function get(key) {                                                                                           // 99
	      var self = this;                                                                                            // 100
	      self._ensureKey(key);                                                                                       // 101
	      self.keyDeps[key].depend();                                                                                 // 102
	      return parse(self.keys[key]);                                                                               // 103
	    }                                                                                                             // 104
	                                                                                                                  //
	    return get;                                                                                                   // 99
	  }(),                                                                                                            // 99
	                                                                                                                  //
	  equals: function () {                                                                                           // 106
	    function equals(key, value) {                                                                                 // 106
	      var self = this;                                                                                            // 107
	                                                                                                                  //
	      // Mongo.ObjectID is in the 'mongo' package                                                                 // 109
	      var ObjectID = null;                                                                                        // 110
	      if (Package.mongo) {                                                                                        // 111
	        ObjectID = Package.mongo.Mongo.ObjectID;                                                                  // 112
	      }                                                                                                           // 113
	                                                                                                                  //
	      // We don't allow objects (or arrays that might include objects) for                                        // 115
	      // .equals, because JSON.stringify doesn't canonicalize object key                                          // 116
	      // order. (We can make equals have the right return value by parsing the                                    // 117
	      // current value and using EJSON.equals, but we won't have a canonical                                      // 118
	      // element of keyValueDeps[key] to store the dependency.) You can still use                                 // 119
	      // "EJSON.equals(reactiveDict.get(key), value)".                                                            // 120
	      //                                                                                                          // 121
	      // XXX we could allow arrays as long as we recursively check that there                                     // 122
	      // are no objects                                                                                           // 123
	      if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'undefined' && !(value instanceof Date) && !(ObjectID && value instanceof ObjectID) && value !== null) {
	        throw new Error("ReactiveDict.equals: value must be scalar");                                             // 131
	      }                                                                                                           // 132
	      var serializedValue = stringify(value);                                                                     // 133
	                                                                                                                  //
	      if (Tracker.active) {                                                                                       // 135
	        self._ensureKey(key);                                                                                     // 136
	                                                                                                                  //
	        if (!_.has(self.keyValueDeps[key], serializedValue)) self.keyValueDeps[key][serializedValue] = new Tracker.Dependency();
	                                                                                                                  //
	        var isNew = self.keyValueDeps[key][serializedValue].depend();                                             // 141
	        if (isNew) {                                                                                              // 142
	          Tracker.onInvalidate(function () {                                                                      // 143
	            // clean up [key][serializedValue] if it's now empty, so we don't                                     // 144
	            // use O(n) memory for n = values seen ever                                                           // 145
	            if (!self.keyValueDeps[key][serializedValue].hasDependents()) delete self.keyValueDeps[key][serializedValue];
	          });                                                                                                     // 148
	        }                                                                                                         // 149
	      }                                                                                                           // 150
	                                                                                                                  //
	      var oldValue = undefined;                                                                                   // 152
	      if (_.has(self.keys, key)) oldValue = parse(self.keys[key]);                                                // 153
	      return EJSON.equals(oldValue, value);                                                                       // 154
	    }                                                                                                             // 155
	                                                                                                                  //
	    return equals;                                                                                                // 106
	  }(),                                                                                                            // 106
	                                                                                                                  //
	  all: function () {                                                                                              // 157
	    function all() {                                                                                              // 157
	      this.allDeps.depend();                                                                                      // 158
	      var ret = {};                                                                                               // 159
	      _.each(this.keys, function (value, key) {                                                                   // 160
	        ret[key] = parse(value);                                                                                  // 161
	      });                                                                                                         // 162
	      return ret;                                                                                                 // 163
	    }                                                                                                             // 164
	                                                                                                                  //
	    return all;                                                                                                   // 157
	  }(),                                                                                                            // 157
	                                                                                                                  //
	  clear: function () {                                                                                            // 166
	    function clear() {                                                                                            // 166
	      var self = this;                                                                                            // 167
	                                                                                                                  //
	      var oldKeys = self.keys;                                                                                    // 169
	      self.keys = {};                                                                                             // 170
	                                                                                                                  //
	      self.allDeps.changed();                                                                                     // 172
	                                                                                                                  //
	      _.each(oldKeys, function (value, key) {                                                                     // 174
	        changed(self.keyDeps[key]);                                                                               // 175
	        if (self.keyValueDeps[key]) {                                                                             // 176
	          changed(self.keyValueDeps[key][value]);                                                                 // 177
	          changed(self.keyValueDeps[key]['undefined']);                                                           // 178
	        }                                                                                                         // 179
	      });                                                                                                         // 180
	    }                                                                                                             // 182
	                                                                                                                  //
	    return clear;                                                                                                 // 166
	  }(),                                                                                                            // 166
	                                                                                                                  //
	  'delete': function () {                                                                                         // 184
	    function _delete(key) {                                                                                       // 184
	      var self = this;                                                                                            // 185
	      var didRemove = false;                                                                                      // 186
	                                                                                                                  //
	      if (_.has(self.keys, key)) {                                                                                // 188
	        var oldValue = self.keys[key];                                                                            // 189
	        delete self.keys[key];                                                                                    // 190
	        changed(self.keyDeps[key]);                                                                               // 191
	        if (self.keyValueDeps[key]) {                                                                             // 192
	          changed(self.keyValueDeps[key][oldValue]);                                                              // 193
	          changed(self.keyValueDeps[key]['undefined']);                                                           // 194
	        }                                                                                                         // 195
	        self.allDeps.changed();                                                                                   // 196
	        didRemove = true;                                                                                         // 197
	      }                                                                                                           // 198
	                                                                                                                  //
	      return didRemove;                                                                                           // 200
	    }                                                                                                             // 201
	                                                                                                                  //
	    return _delete;                                                                                               // 184
	  }(),                                                                                                            // 184
	                                                                                                                  //
	  _setObject: function () {                                                                                       // 203
	    function _setObject(object) {                                                                                 // 203
	      var self = this;                                                                                            // 204
	                                                                                                                  //
	      _.each(object, function (value, key) {                                                                      // 206
	        self.set(key, value);                                                                                     // 207
	      });                                                                                                         // 208
	    }                                                                                                             // 209
	                                                                                                                  //
	    return _setObject;                                                                                            // 203
	  }(),                                                                                                            // 203
	                                                                                                                  //
	  _setDefaultObject: function () {                                                                                // 211
	    function _setDefaultObject(object) {                                                                          // 211
	      var self = this;                                                                                            // 212
	                                                                                                                  //
	      _.each(object, function (value, key) {                                                                      // 214
	        self.setDefault(key, value);                                                                              // 215
	      });                                                                                                         // 216
	    }                                                                                                             // 217
	                                                                                                                  //
	    return _setDefaultObject;                                                                                     // 211
	  }(),                                                                                                            // 211
	                                                                                                                  //
	  _ensureKey: function () {                                                                                       // 219
	    function _ensureKey(key) {                                                                                    // 219
	      var self = this;                                                                                            // 220
	      if (!(key in self.keyDeps)) {                                                                               // 221
	        self.keyDeps[key] = new Tracker.Dependency();                                                             // 222
	        self.keyValueDeps[key] = {};                                                                              // 223
	      }                                                                                                           // 224
	    }                                                                                                             // 225
	                                                                                                                  //
	    return _ensureKey;                                                                                            // 219
	  }(),                                                                                                            // 219
	                                                                                                                  //
	  // Get a JSON value that can be passed to the constructor to                                                    // 227
	  // create a new ReactiveDict with the same contents as this one                                                 // 228
	  _getMigrationData: function () {                                                                                // 229
	    function _getMigrationData() {                                                                                // 229
	      // XXX sanitize and make sure it's JSONible?                                                                // 230
	      return this.keys;                                                                                           // 231
	    }                                                                                                             // 232
	                                                                                                                  //
	    return _getMigrationData;                                                                                     // 229
	  }()                                                                                                             // 229
	});                                                                                                               // 44
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}],"migration.js":function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                //
	// packages/reactive-dict/migration.js                                                                            //
	//                                                                                                                //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                  //
	ReactiveDict._migratedDictData = {}; // name -> data                                                              // 1
	ReactiveDict._dictsToMigrate = {}; // name -> ReactiveDict                                                        // 2
	                                                                                                                  //
	ReactiveDict._loadMigratedDict = function (dictName) {                                                            // 4
	  if (_.has(ReactiveDict._migratedDictData, dictName)) return ReactiveDict._migratedDictData[dictName];           // 5
	                                                                                                                  //
	  return null;                                                                                                    // 8
	};                                                                                                                // 9
	                                                                                                                  //
	ReactiveDict._registerDictForMigrate = function (dictName, dict) {                                                // 11
	  if (_.has(ReactiveDict._dictsToMigrate, dictName)) throw new Error("Duplicate ReactiveDict name: " + dictName);
	                                                                                                                  //
	  ReactiveDict._dictsToMigrate[dictName] = dict;                                                                  // 15
	};                                                                                                                // 16
	                                                                                                                  //
	if (Meteor.isClient && Package.reload) {                                                                          // 18
	  // Put old migrated data into ReactiveDict._migratedDictData,                                                   // 19
	  // where it can be accessed by ReactiveDict._loadMigratedDict.                                                  // 20
	  var migrationData = Package.reload.Reload._migrationData('reactive-dict');                                      // 21
	  if (migrationData && migrationData.dicts) ReactiveDict._migratedDictData = migrationData.dicts;                 // 22
	                                                                                                                  //
	  // On migration, assemble the data from all the dicts that have been                                            // 25
	  // registered.                                                                                                  // 26
	  Package.reload.Reload._onMigrate('reactive-dict', function () {                                                 // 27
	    var dictsToMigrate = ReactiveDict._dictsToMigrate;                                                            // 28
	    var dataToMigrate = {};                                                                                       // 29
	                                                                                                                  //
	    for (var dictName in meteorBabelHelpers.sanitizeForInObject(dictsToMigrate)) {                                // 31
	      dataToMigrate[dictName] = dictsToMigrate[dictName]._getMigrationData();                                     // 32
	    }return [true, { dicts: dataToMigrate }];                                                                     // 31
	  });                                                                                                             // 35
	}                                                                                                                 // 36
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}}}}},{"extensions":[".js",".json"]});
	require("./node_modules/meteor/reactive-dict/reactive-dict.js");
	require("./node_modules/meteor/reactive-dict/migration.js");
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['reactive-dict'] = {}, {
	  ReactiveDict: ReactiveDict
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/retry.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	var Random = Package.random.Random;
	
	/* Package-scope variables */
	var Retry;
	
	(function(){
	
	/////////////////////////////////////////////////////////////////////////////
	//                                                                         //
	// packages/retry/retry.js                                                 //
	//                                                                         //
	/////////////////////////////////////////////////////////////////////////////
	                                                                           //
	// Retry logic with an exponential backoff.                                // 1
	//                                                                         // 2
	// options:                                                                // 3
	//  baseTimeout: time for initial reconnect attempt (ms).                  // 4
	//  exponent: exponential factor to increase timeout each attempt.         // 5
	//  maxTimeout: maximum time between retries (ms).                         // 6
	//  minCount: how many times to reconnect "instantly".                     // 7
	//  minTimeout: time to wait for the first `minCount` retries (ms).        // 8
	//  fuzz: factor to randomize retry times by (to avoid retry storms).      // 9
	                                                                           // 10
	Retry = function (options) {                                               // 11
	  var self = this;                                                         // 12
	  _.extend(self, _.defaults(_.clone(options || {}), {                      // 13
	    baseTimeout: 1000, // 1 second                                         // 14
	    exponent: 2.2,                                                         // 15
	    // The default is high-ish to ensure a server can recover from a       // 16
	    // failure caused by load.                                             // 17
	    maxTimeout: 5 * 60000, // 5 minutes                                    // 18
	    minTimeout: 10,                                                        // 19
	    minCount: 2,                                                           // 20
	    fuzz: 0.5 // +- 25%                                                    // 21
	  }));                                                                     // 22
	  self.retryTimer = null;                                                  // 23
	};                                                                         // 24
	                                                                           // 25
	_.extend(Retry.prototype, {                                                // 26
	                                                                           // 27
	  // Reset a pending retry, if any.                                        // 28
	  clear: function () {                                                     // 29
	    var self = this;                                                       // 30
	    if (self.retryTimer)                                                   // 31
	      clearTimeout(self.retryTimer);                                       // 32
	    self.retryTimer = null;                                                // 33
	  },                                                                       // 34
	                                                                           // 35
	  // Calculate how long to wait in milliseconds to retry, based on the     // 36
	  // `count` of which retry this is.                                       // 37
	  _timeout: function (count) {                                             // 38
	    var self = this;                                                       // 39
	                                                                           // 40
	    if (count < self.minCount)                                             // 41
	      return self.minTimeout;                                              // 42
	                                                                           // 43
	    var timeout = Math.min(                                                // 44
	      self.maxTimeout,                                                     // 45
	      self.baseTimeout * Math.pow(self.exponent, count));                  // 46
	    // fuzz the timeout randomly, to avoid reconnect storms when a         // 47
	    // server goes down.                                                   // 48
	    timeout = timeout * ((Random.fraction() * self.fuzz) +                 // 49
	                         (1 - self.fuzz/2));                               // 50
	    return timeout;                                                        // 51
	  },                                                                       // 52
	                                                                           // 53
	  // Call `fn` after a delay, based on the `count` of which retry this is.
	  retryLater: function (count, fn) {                                       // 55
	    var self = this;                                                       // 56
	    var timeout = self._timeout(count);                                    // 57
	    if (self.retryTimer)                                                   // 58
	      clearTimeout(self.retryTimer);                                       // 59
	    self.retryTimer = Meteor.setTimeout(fn, timeout);                      // 60
	    return timeout;                                                        // 61
	  }                                                                        // 62
	                                                                           // 63
	});                                                                        // 64
	                                                                           // 65
	/////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.retry = {}, {
	  Retry: Retry
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/service-configuration.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var Accounts = Package['accounts-base'].Accounts;
	var Mongo = Package.mongo.Mongo;
	
	/* Package-scope variables */
	var ServiceConfiguration;
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                    //
	// packages/service-configuration/service_configuration_common.js                     //
	//                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////
	                                                                                      //
	if (typeof ServiceConfiguration === 'undefined') {                                    // 1
	  ServiceConfiguration = {};                                                          // 2
	}                                                                                     // 3
	                                                                                      // 4
	                                                                                      // 5
	// Table containing documents with configuration options for each                     // 6
	// login service                                                                      // 7
	ServiceConfiguration.configurations = new Mongo.Collection(                           // 8
	  "meteor_accounts_loginServiceConfiguration", {                                      // 9
	    _preventAutopublish: true,                                                        // 10
	    connection: Meteor.isClient ? Accounts.connection : Meteor.connection             // 11
	  });                                                                                 // 12
	// Leave this collection open in insecure mode. In theory, someone could              // 13
	// hijack your oauth connect requests to a different endpoint or appId,               // 14
	// but you did ask for 'insecure'. The advantage is that it is much                   // 15
	// easier to write a configuration wizard that works only in insecure                 // 16
	// mode.                                                                              // 17
	                                                                                      // 18
	                                                                                      // 19
	// Thrown when trying to use a login service which is not configured                  // 20
	ServiceConfiguration.ConfigError = function (serviceName) {                           // 21
	  if (Meteor.isClient && !Accounts.loginServicesConfigured()) {                       // 22
	    this.message = "Login service configuration not yet loaded";                      // 23
	  } else if (serviceName) {                                                           // 24
	    this.message = "Service " + serviceName + " not configured";                      // 25
	  } else {                                                                            // 26
	    this.message = "Service not configured";                                          // 27
	  }                                                                                   // 28
	};                                                                                    // 29
	ServiceConfiguration.ConfigError.prototype = new Error();                             // 30
	ServiceConfiguration.ConfigError.prototype.name = 'ServiceConfiguration.ConfigError';
	                                                                                      // 32
	////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package['service-configuration'] = {}, {
	  ServiceConfiguration: ServiceConfiguration
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/session.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	var ReactiveDict = Package['reactive-dict'].ReactiveDict;
	var EJSON = Package.ejson.EJSON;
	
	/* Package-scope variables */
	var Session;
	
	(function(){
	
	/////////////////////////////////////////////////////////////////////////////////
	//                                                                             //
	// packages/session/session.js                                                 //
	//                                                                             //
	/////////////////////////////////////////////////////////////////////////////////
	                                                                               //
	Session = new ReactiveDict('session');                                         // 1
	                                                                               // 2
	// Documentation here is really awkward because the methods are defined        // 3
	// elsewhere                                                                   // 4
	                                                                               // 5
	/**                                                                            // 6
	 * @memberOf Session                                                           // 7
	 * @method set                                                                 // 8
	 * @summary Set a variable in the session. Notify any listeners that the value
	 * has changed (eg: redraw templates, and rerun any                            // 10
	 * [`Tracker.autorun`](#tracker_autorun) computations, that called             // 11
	 * [`Session.get`](#session_get) on this `key`.)                               // 12
	 * @locus Client                                                               // 13
	 * @param {String} key The key to set, eg, `selectedItem`                      // 14
	 * @param {EJSONable | undefined} value The new value for `key`                // 15
	 */                                                                            // 16
	                                                                               // 17
	/**                                                                            // 18
	 * @memberOf Session                                                           // 19
	 * @method setDefault                                                          // 20
	 * @summary Set a variable in the session if it hasn't been set before.        // 21
	 * Otherwise works exactly the same as [`Session.set`](#session_set).          // 22
	 * @locus Client                                                               // 23
	 * @param {String} key The key to set, eg, `selectedItem`                      // 24
	 * @param {EJSONable | undefined} value The new value for `key`                // 25
	 */                                                                            // 26
	                                                                               // 27
	/**                                                                            // 28
	 * @memberOf Session                                                           // 29
	 * @method get                                                                 // 30
	 * @summary Get the value of a session variable. If inside a [reactive         // 31
	 * computation](#reactivity), invalidate the computation the next time the     // 32
	 * value of the variable is changed by [`Session.set`](#session_set). This     // 33
	 * returns a clone of the session value, so if it's an object or an array,     // 34
	 * mutating the returned value has no effect on the value stored in the        // 35
	 * session.                                                                    // 36
	 * @locus Client                                                               // 37
	 * @param {String} key The name of the session variable to return              // 38
	 */                                                                            // 39
	                                                                               // 40
	/**                                                                            // 41
	 * @memberOf Session                                                           // 42
	 * @method equals                                                              // 43
	 * @summary Test if a session variable is equal to a value. If inside a        // 44
	 * [reactive computation](#reactivity), invalidate the computation the next    // 45
	 * time the variable changes to or from the value.                             // 46
	 * @locus Client                                                               // 47
	 * @param {String} key The name of the session variable to test                // 48
	 * @param {String | Number | Boolean | null | undefined} value The value to    // 49
	 * test against                                                                // 50
	 */                                                                            // 51
	                                                                               // 52
	/////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.session = {}, {
	  Session: Session
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/sha.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	
	/* Package-scope variables */
	var SHA256;
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                            //
	// packages/sha/sha256.js                                                                                     //
	//                                                                                                            //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                              //
	/// METEOR WRAPPER                                                                                            // 1
	//                                                                                                            // 2
	SHA256 = (function () {                                                                                       // 3
	                                                                                                              // 4
	                                                                                                              // 5
	/**                                                                                                           // 6
	*                                                                                                             // 7
	*  Secure Hash Algorithm (SHA256)                                                                             // 8
	*  http://www.webtoolkit.info/javascript-sha256.html                                                          // 9
	*  http://anmar.eu.org/projects/jssha2/                                                                       // 10
	*                                                                                                             // 11
	*  Original code by Angel Marin, Paul Johnston.                                                               // 12
	*                                                                                                             // 13
	**/                                                                                                           // 14
	                                                                                                              // 15
	function SHA256(s){                                                                                           // 16
	                                                                                                              // 17
		var chrsz   = 8;                                                                                             // 18
		var hexcase = 0;                                                                                             // 19
	                                                                                                              // 20
		function safe_add (x, y) {                                                                                   // 21
			var lsw = (x & 0xFFFF) + (y & 0xFFFF);                                                                      // 22
			var msw = (x >> 16) + (y >> 16) + (lsw >> 16);                                                              // 23
			return (msw << 16) | (lsw & 0xFFFF);                                                                        // 24
		}                                                                                                            // 25
	                                                                                                              // 26
		function S (X, n) { return ( X >>> n ) | (X << (32 - n)); }                                                  // 27
		function R (X, n) { return ( X >>> n ); }                                                                    // 28
		function Ch(x, y, z) { return ((x & y) ^ ((~x) & z)); }                                                      // 29
		function Maj(x, y, z) { return ((x & y) ^ (x & z) ^ (y & z)); }                                              // 30
		function Sigma0256(x) { return (S(x, 2) ^ S(x, 13) ^ S(x, 22)); }                                            // 31
		function Sigma1256(x) { return (S(x, 6) ^ S(x, 11) ^ S(x, 25)); }                                            // 32
		function Gamma0256(x) { return (S(x, 7) ^ S(x, 18) ^ R(x, 3)); }                                             // 33
		function Gamma1256(x) { return (S(x, 17) ^ S(x, 19) ^ R(x, 10)); }                                           // 34
	                                                                                                              // 35
		function core_sha256 (m, l) {                                                                                // 36
			var K = new Array(0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5, 0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5, 0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3, 0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174, 0xE49B69C1, 0xEFBE4786, 0xFC19DC6, 0x240CA1CC, 0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA, 0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7, 0xC6E00BF3, 0xD5A79147, 0x6CA6351, 0x14292967, 0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13, 0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85, 0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3, 0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070, 0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5, 0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3, 0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208, 0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2);
			var HASH = new Array(0x6A09E667, 0xBB67AE85, 0x3C6EF372, 0xA54FF53A, 0x510E527F, 0x9B05688C, 0x1F83D9AB, 0x5BE0CD19);
			var W = new Array(64);                                                                                      // 39
			var a, b, c, d, e, f, g, h, i, j;                                                                           // 40
			var T1, T2;                                                                                                 // 41
	                                                                                                              // 42
			m[l >> 5] |= 0x80 << (24 - l % 32);                                                                         // 43
			m[((l + 64 >> 9) << 4) + 15] = l;                                                                           // 44
	                                                                                                              // 45
			for ( var i = 0; i<m.length; i+=16 ) {                                                                      // 46
				a = HASH[0];                                                                                               // 47
				b = HASH[1];                                                                                               // 48
				c = HASH[2];                                                                                               // 49
				d = HASH[3];                                                                                               // 50
				e = HASH[4];                                                                                               // 51
				f = HASH[5];                                                                                               // 52
				g = HASH[6];                                                                                               // 53
				h = HASH[7];                                                                                               // 54
	                                                                                                              // 55
				for ( var j = 0; j<64; j++) {                                                                              // 56
					if (j < 16) W[j] = m[j + i];                                                                              // 57
					else W[j] = safe_add(safe_add(safe_add(Gamma1256(W[j - 2]), W[j - 7]), Gamma0256(W[j - 15])), W[j - 16]);
	                                                                                                              // 59
					T1 = safe_add(safe_add(safe_add(safe_add(h, Sigma1256(e)), Ch(e, f, g)), K[j]), W[j]);                    // 60
					T2 = safe_add(Sigma0256(a), Maj(a, b, c));                                                                // 61
	                                                                                                              // 62
					h = g;                                                                                                    // 63
					g = f;                                                                                                    // 64
					f = e;                                                                                                    // 65
					e = safe_add(d, T1);                                                                                      // 66
					d = c;                                                                                                    // 67
					c = b;                                                                                                    // 68
					b = a;                                                                                                    // 69
					a = safe_add(T1, T2);                                                                                     // 70
				}                                                                                                          // 71
	                                                                                                              // 72
				HASH[0] = safe_add(a, HASH[0]);                                                                            // 73
				HASH[1] = safe_add(b, HASH[1]);                                                                            // 74
				HASH[2] = safe_add(c, HASH[2]);                                                                            // 75
				HASH[3] = safe_add(d, HASH[3]);                                                                            // 76
				HASH[4] = safe_add(e, HASH[4]);                                                                            // 77
				HASH[5] = safe_add(f, HASH[5]);                                                                            // 78
				HASH[6] = safe_add(g, HASH[6]);                                                                            // 79
				HASH[7] = safe_add(h, HASH[7]);                                                                            // 80
			}                                                                                                           // 81
			return HASH;                                                                                                // 82
		}                                                                                                            // 83
	                                                                                                              // 84
		function str2binb (str) {                                                                                    // 85
			var bin = Array();                                                                                          // 86
			var mask = (1 << chrsz) - 1;                                                                                // 87
			for(var i = 0; i < str.length * chrsz; i += chrsz) {                                                        // 88
				bin[i>>5] |= (str.charCodeAt(i / chrsz) & mask) << (24 - i%32);                                            // 89
			}                                                                                                           // 90
			return bin;                                                                                                 // 91
		}                                                                                                            // 92
	                                                                                                              // 93
		function Utf8Encode(string) {                                                                                // 94
			// METEOR change:                                                                                           // 95
			// The webtoolkit.info version of this code added this                                                      // 96
			// Utf8Encode function (which does seem necessary for dealing                                               // 97
			// with arbitrary Unicode), but the following line seems                                                    // 98
			// problematic:                                                                                             // 99
			//                                                                                                          // 100
			// string = string.replace(/\r\n/g,"\n");                                                                   // 101
			var utftext = "";                                                                                           // 102
	                                                                                                              // 103
			for (var n = 0; n < string.length; n++) {                                                                   // 104
	                                                                                                              // 105
				var c = string.charCodeAt(n);                                                                              // 106
	                                                                                                              // 107
				if (c < 128) {                                                                                             // 108
					utftext += String.fromCharCode(c);                                                                        // 109
				}                                                                                                          // 110
				else if((c > 127) && (c < 2048)) {                                                                         // 111
					utftext += String.fromCharCode((c >> 6) | 192);                                                           // 112
					utftext += String.fromCharCode((c & 63) | 128);                                                           // 113
				}                                                                                                          // 114
				else {                                                                                                     // 115
					utftext += String.fromCharCode((c >> 12) | 224);                                                          // 116
					utftext += String.fromCharCode(((c >> 6) & 63) | 128);                                                    // 117
					utftext += String.fromCharCode((c & 63) | 128);                                                           // 118
				}                                                                                                          // 119
	                                                                                                              // 120
			}                                                                                                           // 121
	                                                                                                              // 122
			return utftext;                                                                                             // 123
		}                                                                                                            // 124
	                                                                                                              // 125
		function binb2hex (binarray) {                                                                               // 126
			var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";                                            // 127
			var str = "";                                                                                               // 128
			for(var i = 0; i < binarray.length * 4; i++) {                                                              // 129
				str += hex_tab.charAt((binarray[i>>2] >> ((3 - i%4)*8+4)) & 0xF) +                                         // 130
				hex_tab.charAt((binarray[i>>2] >> ((3 - i%4)*8  )) & 0xF);                                                 // 131
			}                                                                                                           // 132
			return str;                                                                                                 // 133
		}                                                                                                            // 134
	                                                                                                              // 135
		s = Utf8Encode(s);                                                                                           // 136
		return binb2hex(core_sha256(str2binb(s), s.length * chrsz));                                                 // 137
	                                                                                                              // 138
	}                                                                                                             // 139
	                                                                                                              // 140
	/// METEOR WRAPPER                                                                                            // 141
	return SHA256;                                                                                                // 142
	})();                                                                                                         // 143
	                                                                                                              // 144
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.sha = {}, {
	  SHA256: SHA256
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/srp.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var Random = Package.random.Random;
	var check = Package.check.check;
	var Match = Package.check.Match;
	var SHA256 = Package.sha.SHA256;
	var _ = Package.underscore._;
	
	/* Package-scope variables */
	var BigInteger, SRP;
	
	(function(){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                  //
	// packages/srp/biginteger.js                                                                                       //
	//                                                                                                                  //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                    //
	/// METEOR WRAPPER                                                                                                  // 1
	BigInteger = (function () {                                                                                         // 2
	                                                                                                                    // 3
	                                                                                                                    // 4
	/// BEGIN jsbn.js                                                                                                   // 5
	                                                                                                                    // 6
	/*                                                                                                                  // 7
	 * Copyright (c) 2003-2005  Tom Wu                                                                                  // 8
	 * All Rights Reserved.                                                                                             // 9
	 *                                                                                                                  // 10
	 * Permission is hereby granted, free of charge, to any person obtaining                                            // 11
	 * a copy of this software and associated documentation files (the                                                  // 12
	 * "Software"), to deal in the Software without restriction, including                                              // 13
	 * without limitation the rights to use, copy, modify, merge, publish,                                              // 14
	 * distribute, sublicense, and/or sell copies of the Software, and to                                               // 15
	 * permit persons to whom the Software is furnished to do so, subject to                                            // 16
	 * the following conditions:                                                                                        // 17
	 *                                                                                                                  // 18
	 * The above copyright notice and this permission notice shall be                                                   // 19
	 * included in all copies or substantial portions of the Software.                                                  // 20
	 *                                                                                                                  // 21
	 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,                                               // 22
	 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY                                                 // 23
	 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.                                                 // 24
	 *                                                                                                                  // 25
	 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,                                                  // 26
	 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER                                         // 27
	 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF                                           // 28
	 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT                                           // 29
	 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.                                                // 30
	 *                                                                                                                  // 31
	 * In addition, the following condition applies:                                                                    // 32
	 *                                                                                                                  // 33
	 * All redistributions must retain an intact copy of this copyright notice                                          // 34
	 * and disclaimer.                                                                                                  // 35
	 */                                                                                                                 // 36
	                                                                                                                    // 37
	// Basic JavaScript BN library - subset useful for RSA encryption.                                                  // 38
	                                                                                                                    // 39
	// Bits per digit                                                                                                   // 40
	var dbits;                                                                                                          // 41
	                                                                                                                    // 42
	// JavaScript engine analysis                                                                                       // 43
	var canary = 0xdeadbeefcafe;                                                                                        // 44
	var j_lm = ((canary&0xffffff)==0xefcafe);                                                                           // 45
	                                                                                                                    // 46
	// (public) Constructor                                                                                             // 47
	function BigInteger(a,b,c) {                                                                                        // 48
	  if(a != null)                                                                                                     // 49
	    if("number" == typeof a) this.fromNumber(a,b,c);                                                                // 50
	    else if(b == null && "string" != typeof a) this.fromString(a,256);                                              // 51
	    else this.fromString(a,b);                                                                                      // 52
	}                                                                                                                   // 53
	                                                                                                                    // 54
	// return new, unset BigInteger                                                                                     // 55
	function nbi() { return new BigInteger(null); }                                                                     // 56
	                                                                                                                    // 57
	// am: Compute w_j += (x*this_i), propagate carries,                                                                // 58
	// c is initial carry, returns final carry.                                                                         // 59
	// c < 3*dvalue, x < 2*dvalue, this_i < dvalue                                                                      // 60
	// We need to select the fastest one that works in this environment.                                                // 61
	                                                                                                                    // 62
	// am1: use a single mult and divide to get the high bits,                                                          // 63
	// max digit bits should be 26 because                                                                              // 64
	// max internal value = 2*dvalue^2-2*dvalue (< 2^53)                                                                // 65
	function am1(i,x,w,j,c,n) {                                                                                         // 66
	  while(--n >= 0) {                                                                                                 // 67
	    var v = x*this[i++]+w[j]+c;                                                                                     // 68
	    c = Math.floor(v/0x4000000);                                                                                    // 69
	    w[j++] = v&0x3ffffff;                                                                                           // 70
	  }                                                                                                                 // 71
	  return c;                                                                                                         // 72
	}                                                                                                                   // 73
	// am2 avoids a big mult-and-extract completely.                                                                    // 74
	// Max digit bits should be <= 30 because we do bitwise ops                                                         // 75
	// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)                                                                   // 76
	function am2(i,x,w,j,c,n) {                                                                                         // 77
	  var xl = x&0x7fff, xh = x>>15;                                                                                    // 78
	  while(--n >= 0) {                                                                                                 // 79
	    var l = this[i]&0x7fff;                                                                                         // 80
	    var h = this[i++]>>15;                                                                                          // 81
	    var m = xh*l+h*xl;                                                                                              // 82
	    l = xl*l+((m&0x7fff)<<15)+w[j]+(c&0x3fffffff);                                                                  // 83
	    c = (l>>>30)+(m>>>15)+xh*h+(c>>>30);                                                                            // 84
	    w[j++] = l&0x3fffffff;                                                                                          // 85
	  }                                                                                                                 // 86
	  return c;                                                                                                         // 87
	}                                                                                                                   // 88
	// Alternately, set max digit bits to 28 since some                                                                 // 89
	// browsers slow down when dealing with 32-bit numbers.                                                             // 90
	function am3(i,x,w,j,c,n) {                                                                                         // 91
	  var xl = x&0x3fff, xh = x>>14;                                                                                    // 92
	  while(--n >= 0) {                                                                                                 // 93
	    var l = this[i]&0x3fff;                                                                                         // 94
	    var h = this[i++]>>14;                                                                                          // 95
	    var m = xh*l+h*xl;                                                                                              // 96
	    l = xl*l+((m&0x3fff)<<14)+w[j]+c;                                                                               // 97
	    c = (l>>28)+(m>>14)+xh*h;                                                                                       // 98
	    w[j++] = l&0xfffffff;                                                                                           // 99
	  }                                                                                                                 // 100
	  return c;                                                                                                         // 101
	}                                                                                                                   // 102
	                                                                                                                    // 103
	/* XXX METEOR XXX                                                                                                   // 104
	if(j_lm && (navigator.appName == "Microsoft Internet Explorer")) {                                                  // 105
	  BigInteger.prototype.am = am2;                                                                                    // 106
	  dbits = 30;                                                                                                       // 107
	}                                                                                                                   // 108
	else if(j_lm && (navigator.appName != "Netscape")) {                                                                // 109
	  BigInteger.prototype.am = am1;                                                                                    // 110
	  dbits = 26;                                                                                                       // 111
	}                                                                                                                   // 112
	else                                                                                                                // 113
	*/                                                                                                                  // 114
	                                                                                                                    // 115
	{ // Mozilla/Netscape seems to prefer am3                                                                           // 116
	  BigInteger.prototype.am = am3;                                                                                    // 117
	  dbits = 28;                                                                                                       // 118
	}                                                                                                                   // 119
	                                                                                                                    // 120
	BigInteger.prototype.DB = dbits;                                                                                    // 121
	BigInteger.prototype.DM = ((1<<dbits)-1);                                                                           // 122
	BigInteger.prototype.DV = (1<<dbits);                                                                               // 123
	                                                                                                                    // 124
	var BI_FP = 52;                                                                                                     // 125
	BigInteger.prototype.FV = Math.pow(2,BI_FP);                                                                        // 126
	BigInteger.prototype.F1 = BI_FP-dbits;                                                                              // 127
	BigInteger.prototype.F2 = 2*dbits-BI_FP;                                                                            // 128
	                                                                                                                    // 129
	// Digit conversions                                                                                                // 130
	var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";                                                                 // 131
	var BI_RC = new Array();                                                                                            // 132
	var rr,vv;                                                                                                          // 133
	rr = "0".charCodeAt(0);                                                                                             // 134
	for(vv = 0; vv <= 9; ++vv) BI_RC[rr++] = vv;                                                                        // 135
	rr = "a".charCodeAt(0);                                                                                             // 136
	for(vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;                                                                       // 137
	rr = "A".charCodeAt(0);                                                                                             // 138
	for(vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;                                                                       // 139
	                                                                                                                    // 140
	function int2char(n) { return BI_RM.charAt(n); }                                                                    // 141
	function intAt(s,i) {                                                                                               // 142
	  var c = BI_RC[s.charCodeAt(i)];                                                                                   // 143
	  return (c==null)?-1:c;                                                                                            // 144
	}                                                                                                                   // 145
	                                                                                                                    // 146
	// (protected) copy this to r                                                                                       // 147
	function bnpCopyTo(r) {                                                                                             // 148
	  for(var i = this.t-1; i >= 0; --i) r[i] = this[i];                                                                // 149
	  r.t = this.t;                                                                                                     // 150
	  r.s = this.s;                                                                                                     // 151
	}                                                                                                                   // 152
	                                                                                                                    // 153
	// (protected) set from integer value x, -DV <= x < DV                                                              // 154
	function bnpFromInt(x) {                                                                                            // 155
	  this.t = 1;                                                                                                       // 156
	  this.s = (x<0)?-1:0;                                                                                              // 157
	  if(x > 0) this[0] = x;                                                                                            // 158
	  else if(x < -1) this[0] = x+DV;                                                                                   // 159
	  else this.t = 0;                                                                                                  // 160
	}                                                                                                                   // 161
	                                                                                                                    // 162
	// return bigint initialized to value                                                                               // 163
	function nbv(i) { var r = nbi(); r.fromInt(i); return r; }                                                          // 164
	                                                                                                                    // 165
	// (protected) set from string and radix                                                                            // 166
	function bnpFromString(s,b) {                                                                                       // 167
	  var k;                                                                                                            // 168
	  if(b == 16) k = 4;                                                                                                // 169
	  else if(b == 8) k = 3;                                                                                            // 170
	  else if(b == 256) k = 8; // byte array                                                                            // 171
	  else if(b == 2) k = 1;                                                                                            // 172
	  else if(b == 32) k = 5;                                                                                           // 173
	  else if(b == 4) k = 2;                                                                                            // 174
	  else { this.fromRadix(s,b); return; }                                                                             // 175
	  this.t = 0;                                                                                                       // 176
	  this.s = 0;                                                                                                       // 177
	  var i = s.length, mi = false, sh = 0;                                                                             // 178
	  while(--i >= 0) {                                                                                                 // 179
	    var x = (k==8)?s[i]&0xff:intAt(s,i);                                                                            // 180
	    if(x < 0) {                                                                                                     // 181
	      if(s.charAt(i) == "-") mi = true;                                                                             // 182
	      continue;                                                                                                     // 183
	    }                                                                                                               // 184
	    mi = false;                                                                                                     // 185
	    if(sh == 0)                                                                                                     // 186
	      this[this.t++] = x;                                                                                           // 187
	    else if(sh+k > this.DB) {                                                                                       // 188
	      this[this.t-1] |= (x&((1<<(this.DB-sh))-1))<<sh;                                                              // 189
	      this[this.t++] = (x>>(this.DB-sh));                                                                           // 190
	    }                                                                                                               // 191
	    else                                                                                                            // 192
	      this[this.t-1] |= x<<sh;                                                                                      // 193
	    sh += k;                                                                                                        // 194
	    if(sh >= this.DB) sh -= this.DB;                                                                                // 195
	  }                                                                                                                 // 196
	  if(k == 8 && (s[0]&0x80) != 0) {                                                                                  // 197
	    this.s = -1;                                                                                                    // 198
	    if(sh > 0) this[this.t-1] |= ((1<<(this.DB-sh))-1)<<sh;                                                         // 199
	  }                                                                                                                 // 200
	  this.clamp();                                                                                                     // 201
	  if(mi) BigInteger.ZERO.subTo(this,this);                                                                          // 202
	}                                                                                                                   // 203
	                                                                                                                    // 204
	// (protected) clamp off excess high words                                                                          // 205
	function bnpClamp() {                                                                                               // 206
	  var c = this.s&this.DM;                                                                                           // 207
	  while(this.t > 0 && this[this.t-1] == c) --this.t;                                                                // 208
	}                                                                                                                   // 209
	                                                                                                                    // 210
	// (public) return string representation in given radix                                                             // 211
	function bnToString(b) {                                                                                            // 212
	  if(this.s < 0) return "-"+this.negate().toString(b);                                                              // 213
	  var k;                                                                                                            // 214
	  if(b == 16) k = 4;                                                                                                // 215
	  else if(b == 8) k = 3;                                                                                            // 216
	  else if(b == 2) k = 1;                                                                                            // 217
	  else if(b == 32) k = 5;                                                                                           // 218
	  else if(b == 4) k = 2;                                                                                            // 219
	  else return this.toRadix(b);                                                                                      // 220
	  var km = (1<<k)-1, d, m = false, r = "", i = this.t;                                                              // 221
	  var p = this.DB-(i*this.DB)%k;                                                                                    // 222
	  if(i-- > 0) {                                                                                                     // 223
	    if(p < this.DB && (d = this[i]>>p) > 0) { m = true; r = int2char(d); }                                          // 224
	    while(i >= 0) {                                                                                                 // 225
	      if(p < k) {                                                                                                   // 226
	        d = (this[i]&((1<<p)-1))<<(k-p);                                                                            // 227
	        d |= this[--i]>>(p+=this.DB-k);                                                                             // 228
	      }                                                                                                             // 229
	      else {                                                                                                        // 230
	        d = (this[i]>>(p-=k))&km;                                                                                   // 231
	        if(p <= 0) { p += this.DB; --i; }                                                                           // 232
	      }                                                                                                             // 233
	      if(d > 0) m = true;                                                                                           // 234
	      if(m) r += int2char(d);                                                                                       // 235
	    }                                                                                                               // 236
	  }                                                                                                                 // 237
	  return m?r:"0";                                                                                                   // 238
	}                                                                                                                   // 239
	                                                                                                                    // 240
	// (public) -this                                                                                                   // 241
	function bnNegate() { var r = nbi(); BigInteger.ZERO.subTo(this,r); return r; }                                     // 242
	                                                                                                                    // 243
	// (public) |this|                                                                                                  // 244
	function bnAbs() { return (this.s<0)?this.negate():this; }                                                          // 245
	                                                                                                                    // 246
	// (public) return + if this > a, - if this < a, 0 if equal                                                         // 247
	function bnCompareTo(a) {                                                                                           // 248
	  var r = this.s-a.s;                                                                                               // 249
	  if(r != 0) return r;                                                                                              // 250
	  var i = this.t;                                                                                                   // 251
	  r = i-a.t;                                                                                                        // 252
	  if(r != 0) return r;                                                                                              // 253
	  while(--i >= 0) if((r=this[i]-a[i]) != 0) return r;                                                               // 254
	  return 0;                                                                                                         // 255
	}                                                                                                                   // 256
	                                                                                                                    // 257
	// returns bit length of the integer x                                                                              // 258
	function nbits(x) {                                                                                                 // 259
	  var r = 1, t;                                                                                                     // 260
	  if((t=x>>>16) != 0) { x = t; r += 16; }                                                                           // 261
	  if((t=x>>8) != 0) { x = t; r += 8; }                                                                              // 262
	  if((t=x>>4) != 0) { x = t; r += 4; }                                                                              // 263
	  if((t=x>>2) != 0) { x = t; r += 2; }                                                                              // 264
	  if((t=x>>1) != 0) { x = t; r += 1; }                                                                              // 265
	  return r;                                                                                                         // 266
	}                                                                                                                   // 267
	                                                                                                                    // 268
	// (public) return the number of bits in "this"                                                                     // 269
	function bnBitLength() {                                                                                            // 270
	  if(this.t <= 0) return 0;                                                                                         // 271
	  return this.DB*(this.t-1)+nbits(this[this.t-1]^(this.s&this.DM));                                                 // 272
	}                                                                                                                   // 273
	                                                                                                                    // 274
	// (protected) r = this << n*DB                                                                                     // 275
	function bnpDLShiftTo(n,r) {                                                                                        // 276
	  var i;                                                                                                            // 277
	  for(i = this.t-1; i >= 0; --i) r[i+n] = this[i];                                                                  // 278
	  for(i = n-1; i >= 0; --i) r[i] = 0;                                                                               // 279
	  r.t = this.t+n;                                                                                                   // 280
	  r.s = this.s;                                                                                                     // 281
	}                                                                                                                   // 282
	                                                                                                                    // 283
	// (protected) r = this >> n*DB                                                                                     // 284
	function bnpDRShiftTo(n,r) {                                                                                        // 285
	  for(var i = n; i < this.t; ++i) r[i-n] = this[i];                                                                 // 286
	  r.t = Math.max(this.t-n,0);                                                                                       // 287
	  r.s = this.s;                                                                                                     // 288
	}                                                                                                                   // 289
	                                                                                                                    // 290
	// (protected) r = this << n                                                                                        // 291
	function bnpLShiftTo(n,r) {                                                                                         // 292
	  var bs = n%this.DB;                                                                                               // 293
	  var cbs = this.DB-bs;                                                                                             // 294
	  var bm = (1<<cbs)-1;                                                                                              // 295
	  var ds = Math.floor(n/this.DB), c = (this.s<<bs)&this.DM, i;                                                      // 296
	  for(i = this.t-1; i >= 0; --i) {                                                                                  // 297
	    r[i+ds+1] = (this[i]>>cbs)|c;                                                                                   // 298
	    c = (this[i]&bm)<<bs;                                                                                           // 299
	  }                                                                                                                 // 300
	  for(i = ds-1; i >= 0; --i) r[i] = 0;                                                                              // 301
	  r[ds] = c;                                                                                                        // 302
	  r.t = this.t+ds+1;                                                                                                // 303
	  r.s = this.s;                                                                                                     // 304
	  r.clamp();                                                                                                        // 305
	}                                                                                                                   // 306
	                                                                                                                    // 307
	// (protected) r = this >> n                                                                                        // 308
	function bnpRShiftTo(n,r) {                                                                                         // 309
	  r.s = this.s;                                                                                                     // 310
	  var ds = Math.floor(n/this.DB);                                                                                   // 311
	  if(ds >= this.t) { r.t = 0; return; }                                                                             // 312
	  var bs = n%this.DB;                                                                                               // 313
	  var cbs = this.DB-bs;                                                                                             // 314
	  var bm = (1<<bs)-1;                                                                                               // 315
	  r[0] = this[ds]>>bs;                                                                                              // 316
	  for(var i = ds+1; i < this.t; ++i) {                                                                              // 317
	    r[i-ds-1] |= (this[i]&bm)<<cbs;                                                                                 // 318
	    r[i-ds] = this[i]>>bs;                                                                                          // 319
	  }                                                                                                                 // 320
	  if(bs > 0) r[this.t-ds-1] |= (this.s&bm)<<cbs;                                                                    // 321
	  r.t = this.t-ds;                                                                                                  // 322
	  r.clamp();                                                                                                        // 323
	}                                                                                                                   // 324
	                                                                                                                    // 325
	// (protected) r = this - a                                                                                         // 326
	function bnpSubTo(a,r) {                                                                                            // 327
	  var i = 0, c = 0, m = Math.min(a.t,this.t);                                                                       // 328
	  while(i < m) {                                                                                                    // 329
	    c += this[i]-a[i];                                                                                              // 330
	    r[i++] = c&this.DM;                                                                                             // 331
	    c >>= this.DB;                                                                                                  // 332
	  }                                                                                                                 // 333
	  if(a.t < this.t) {                                                                                                // 334
	    c -= a.s;                                                                                                       // 335
	    while(i < this.t) {                                                                                             // 336
	      c += this[i];                                                                                                 // 337
	      r[i++] = c&this.DM;                                                                                           // 338
	      c >>= this.DB;                                                                                                // 339
	    }                                                                                                               // 340
	    c += this.s;                                                                                                    // 341
	  }                                                                                                                 // 342
	  else {                                                                                                            // 343
	    c += this.s;                                                                                                    // 344
	    while(i < a.t) {                                                                                                // 345
	      c -= a[i];                                                                                                    // 346
	      r[i++] = c&this.DM;                                                                                           // 347
	      c >>= this.DB;                                                                                                // 348
	    }                                                                                                               // 349
	    c -= a.s;                                                                                                       // 350
	  }                                                                                                                 // 351
	  r.s = (c<0)?-1:0;                                                                                                 // 352
	  if(c < -1) r[i++] = this.DV+c;                                                                                    // 353
	  else if(c > 0) r[i++] = c;                                                                                        // 354
	  r.t = i;                                                                                                          // 355
	  r.clamp();                                                                                                        // 356
	}                                                                                                                   // 357
	                                                                                                                    // 358
	// (protected) r = this * a, r != this,a (HAC 14.12)                                                                // 359
	// "this" should be the larger one if appropriate.                                                                  // 360
	function bnpMultiplyTo(a,r) {                                                                                       // 361
	  var x = this.abs(), y = a.abs();                                                                                  // 362
	  var i = x.t;                                                                                                      // 363
	  r.t = i+y.t;                                                                                                      // 364
	  while(--i >= 0) r[i] = 0;                                                                                         // 365
	  for(i = 0; i < y.t; ++i) r[i+x.t] = x.am(0,y[i],r,i,0,x.t);                                                       // 366
	  r.s = 0;                                                                                                          // 367
	  r.clamp();                                                                                                        // 368
	  if(this.s != a.s) BigInteger.ZERO.subTo(r,r);                                                                     // 369
	}                                                                                                                   // 370
	                                                                                                                    // 371
	// (protected) r = this^2, r != this (HAC 14.16)                                                                    // 372
	function bnpSquareTo(r) {                                                                                           // 373
	  var x = this.abs();                                                                                               // 374
	  var i = r.t = 2*x.t;                                                                                              // 375
	  while(--i >= 0) r[i] = 0;                                                                                         // 376
	  for(i = 0; i < x.t-1; ++i) {                                                                                      // 377
	    var c = x.am(i,x[i],r,2*i,0,1);                                                                                 // 378
	    if((r[i+x.t]+=x.am(i+1,2*x[i],r,2*i+1,c,x.t-i-1)) >= x.DV) {                                                    // 379
	      r[i+x.t] -= x.DV;                                                                                             // 380
	      r[i+x.t+1] = 1;                                                                                               // 381
	    }                                                                                                               // 382
	  }                                                                                                                 // 383
	  if(r.t > 0) r[r.t-1] += x.am(i,x[i],r,2*i,0,1);                                                                   // 384
	  r.s = 0;                                                                                                          // 385
	  r.clamp();                                                                                                        // 386
	}                                                                                                                   // 387
	                                                                                                                    // 388
	// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)                                         // 389
	// r != q, this != m.  q or r may be null.                                                                          // 390
	function bnpDivRemTo(m,q,r) {                                                                                       // 391
	  var pm = m.abs();                                                                                                 // 392
	  if(pm.t <= 0) return;                                                                                             // 393
	  var pt = this.abs();                                                                                              // 394
	  if(pt.t < pm.t) {                                                                                                 // 395
	    if(q != null) q.fromInt(0);                                                                                     // 396
	    if(r != null) this.copyTo(r);                                                                                   // 397
	    return;                                                                                                         // 398
	  }                                                                                                                 // 399
	  if(r == null) r = nbi();                                                                                          // 400
	  var y = nbi(), ts = this.s, ms = m.s;                                                                             // 401
	  var nsh = this.DB-nbits(pm[pm.t-1]);	// normalize modulus                                                         // 402
	  if(nsh > 0) { pm.lShiftTo(nsh,y); pt.lShiftTo(nsh,r); }                                                           // 403
	  else { pm.copyTo(y); pt.copyTo(r); }                                                                              // 404
	  var ys = y.t;                                                                                                     // 405
	  var y0 = y[ys-1];                                                                                                 // 406
	  if(y0 == 0) return;                                                                                               // 407
	  var yt = y0*(1<<this.F1)+((ys>1)?y[ys-2]>>this.F2:0);                                                             // 408
	  var d1 = this.FV/yt, d2 = (1<<this.F1)/yt, e = 1<<this.F2;                                                        // 409
	  var i = r.t, j = i-ys, t = (q==null)?nbi():q;                                                                     // 410
	  y.dlShiftTo(j,t);                                                                                                 // 411
	  if(r.compareTo(t) >= 0) {                                                                                         // 412
	    r[r.t++] = 1;                                                                                                   // 413
	    r.subTo(t,r);                                                                                                   // 414
	  }                                                                                                                 // 415
	  BigInteger.ONE.dlShiftTo(ys,t);                                                                                   // 416
	  t.subTo(y,y);	// "negative" y so we can replace sub with am later                                                 // 417
	  while(y.t < ys) y[y.t++] = 0;                                                                                     // 418
	  while(--j >= 0) {                                                                                                 // 419
	    // Estimate quotient digit                                                                                      // 420
	    var qd = (r[--i]==y0)?this.DM:Math.floor(r[i]*d1+(r[i-1]+e)*d2);                                                // 421
	    if((r[i]+=y.am(0,qd,r,j,0,ys)) < qd) {	// Try it out                                                            // 422
	      y.dlShiftTo(j,t);                                                                                             // 423
	      r.subTo(t,r);                                                                                                 // 424
	      while(r[i] < --qd) r.subTo(t,r);                                                                              // 425
	    }                                                                                                               // 426
	  }                                                                                                                 // 427
	  if(q != null) {                                                                                                   // 428
	    r.drShiftTo(ys,q);                                                                                              // 429
	    if(ts != ms) BigInteger.ZERO.subTo(q,q);                                                                        // 430
	  }                                                                                                                 // 431
	  r.t = ys;                                                                                                         // 432
	  r.clamp();                                                                                                        // 433
	  if(nsh > 0) r.rShiftTo(nsh,r);	// Denormalize remainder                                                           // 434
	  if(ts < 0) BigInteger.ZERO.subTo(r,r);                                                                            // 435
	}                                                                                                                   // 436
	                                                                                                                    // 437
	// (public) this mod a                                                                                              // 438
	function bnMod(a) {                                                                                                 // 439
	  var r = nbi();                                                                                                    // 440
	  this.abs().divRemTo(a,null,r);                                                                                    // 441
	  if(this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r,r);                                                  // 442
	  return r;                                                                                                         // 443
	}                                                                                                                   // 444
	                                                                                                                    // 445
	// Modular reduction using "classic" algorithm                                                                      // 446
	function Classic(m) { this.m = m; }                                                                                 // 447
	function cConvert(x) {                                                                                              // 448
	  if(x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);                                                     // 449
	  else return x;                                                                                                    // 450
	}                                                                                                                   // 451
	function cRevert(x) { return x; }                                                                                   // 452
	function cReduce(x) { x.divRemTo(this.m,null,x); }                                                                  // 453
	function cMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }                                                       // 454
	function cSqrTo(x,r) { x.squareTo(r); this.reduce(r); }                                                             // 455
	                                                                                                                    // 456
	Classic.prototype.convert = cConvert;                                                                               // 457
	Classic.prototype.revert = cRevert;                                                                                 // 458
	Classic.prototype.reduce = cReduce;                                                                                 // 459
	Classic.prototype.mulTo = cMulTo;                                                                                   // 460
	Classic.prototype.sqrTo = cSqrTo;                                                                                   // 461
	                                                                                                                    // 462
	// (protected) return "-1/this % 2^DB"; useful for Mont. reduction                                                  // 463
	// justification:                                                                                                   // 464
	//         xy == 1 (mod m)                                                                                          // 465
	//         xy =  1+km                                                                                               // 466
	//   xy(2-xy) = (1+km)(1-km)                                                                                        // 467
	// x[y(2-xy)] = 1-k^2m^2                                                                                            // 468
	// x[y(2-xy)] == 1 (mod m^2)                                                                                        // 469
	// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2                                                                   // 470
	// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.                                            // 471
	// JS multiply "overflows" differently from C/C++, so care is needed here.                                          // 472
	function bnpInvDigit() {                                                                                            // 473
	  if(this.t < 1) return 0;                                                                                          // 474
	  var x = this[0];                                                                                                  // 475
	  if((x&1) == 0) return 0;                                                                                          // 476
	  var y = x&3;		// y == 1/x mod 2^2                                                                                 // 477
	  y = (y*(2-(x&0xf)*y))&0xf;	// y == 1/x mod 2^4                                                                    // 478
	  y = (y*(2-(x&0xff)*y))&0xff;	// y == 1/x mod 2^8                                                                  // 479
	  y = (y*(2-(((x&0xffff)*y)&0xffff)))&0xffff;	// y == 1/x mod 2^16                                                  // 480
	  // last step - calculate inverse mod DV directly;                                                                 // 481
	  // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints                                                // 482
	  y = (y*(2-x*y%this.DV))%this.DV;		// y == 1/x mod 2^dbits                                                         // 483
	  // we really want the negative inverse, and -DV < y < DV                                                          // 484
	  return (y>0)?this.DV-y:-y;                                                                                        // 485
	}                                                                                                                   // 486
	                                                                                                                    // 487
	// Montgomery reduction                                                                                             // 488
	function Montgomery(m) {                                                                                            // 489
	  this.m = m;                                                                                                       // 490
	  this.mp = m.invDigit();                                                                                           // 491
	  this.mpl = this.mp&0x7fff;                                                                                        // 492
	  this.mph = this.mp>>15;                                                                                           // 493
	  this.um = (1<<(m.DB-15))-1;                                                                                       // 494
	  this.mt2 = 2*m.t;                                                                                                 // 495
	}                                                                                                                   // 496
	                                                                                                                    // 497
	// xR mod m                                                                                                         // 498
	function montConvert(x) {                                                                                           // 499
	  var r = nbi();                                                                                                    // 500
	  x.abs().dlShiftTo(this.m.t,r);                                                                                    // 501
	  r.divRemTo(this.m,null,r);                                                                                        // 502
	  if(x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r,r);                                                // 503
	  return r;                                                                                                         // 504
	}                                                                                                                   // 505
	                                                                                                                    // 506
	// x/R mod m                                                                                                        // 507
	function montRevert(x) {                                                                                            // 508
	  var r = nbi();                                                                                                    // 509
	  x.copyTo(r);                                                                                                      // 510
	  this.reduce(r);                                                                                                   // 511
	  return r;                                                                                                         // 512
	}                                                                                                                   // 513
	                                                                                                                    // 514
	// x = x/R mod m (HAC 14.32)                                                                                        // 515
	function montReduce(x) {                                                                                            // 516
	  while(x.t <= this.mt2)	// pad x so am has enough room later                                                       // 517
	    x[x.t++] = 0;                                                                                                   // 518
	  for(var i = 0; i < this.m.t; ++i) {                                                                               // 519
	    // faster way of calculating u0 = x[i]*mp mod DV                                                                // 520
	    var j = x[i]&0x7fff;                                                                                            // 521
	    var u0 = (j*this.mpl+(((j*this.mph+(x[i]>>15)*this.mpl)&this.um)<<15))&x.DM;                                    // 522
	    // use am to combine the multiply-shift-add into one call                                                       // 523
	    j = i+this.m.t;                                                                                                 // 524
	    x[j] += this.m.am(0,u0,x,i,0,this.m.t);                                                                         // 525
	    // propagate carry                                                                                              // 526
	    while(x[j] >= x.DV) { x[j] -= x.DV; x[++j]++; }                                                                 // 527
	  }                                                                                                                 // 528
	  x.clamp();                                                                                                        // 529
	  x.drShiftTo(this.m.t,x);                                                                                          // 530
	  if(x.compareTo(this.m) >= 0) x.subTo(this.m,x);                                                                   // 531
	}                                                                                                                   // 532
	                                                                                                                    // 533
	// r = "x^2/R mod m"; x != r                                                                                        // 534
	function montSqrTo(x,r) { x.squareTo(r); this.reduce(r); }                                                          // 535
	                                                                                                                    // 536
	// r = "xy/R mod m"; x,y != r                                                                                       // 537
	function montMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }                                                    // 538
	                                                                                                                    // 539
	Montgomery.prototype.convert = montConvert;                                                                         // 540
	Montgomery.prototype.revert = montRevert;                                                                           // 541
	Montgomery.prototype.reduce = montReduce;                                                                           // 542
	Montgomery.prototype.mulTo = montMulTo;                                                                             // 543
	Montgomery.prototype.sqrTo = montSqrTo;                                                                             // 544
	                                                                                                                    // 545
	// (protected) true iff this is even                                                                                // 546
	function bnpIsEven() { return ((this.t>0)?(this[0]&1):this.s) == 0; }                                               // 547
	                                                                                                                    // 548
	// (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)                                             // 549
	function bnpExp(e,z) {                                                                                              // 550
	  if(e > 0xffffffff || e < 1) return BigInteger.ONE;                                                                // 551
	  var r = nbi(), r2 = nbi(), g = z.convert(this), i = nbits(e)-1;                                                   // 552
	  g.copyTo(r);                                                                                                      // 553
	  while(--i >= 0) {                                                                                                 // 554
	    z.sqrTo(r,r2);                                                                                                  // 555
	    if((e&(1<<i)) > 0) z.mulTo(r2,g,r);                                                                             // 556
	    else { var t = r; r = r2; r2 = t; }                                                                             // 557
	  }                                                                                                                 // 558
	  return z.revert(r);                                                                                               // 559
	}                                                                                                                   // 560
	                                                                                                                    // 561
	// (public) this^e % m, 0 <= e < 2^32                                                                               // 562
	function bnModPowInt(e,m) {                                                                                         // 563
	  var z;                                                                                                            // 564
	  if(e < 256 || m.isEven()) z = new Classic(m); else z = new Montgomery(m);                                         // 565
	  return this.exp(e,z);                                                                                             // 566
	}                                                                                                                   // 567
	                                                                                                                    // 568
	// protected                                                                                                        // 569
	BigInteger.prototype.copyTo = bnpCopyTo;                                                                            // 570
	BigInteger.prototype.fromInt = bnpFromInt;                                                                          // 571
	BigInteger.prototype.fromString = bnpFromString;                                                                    // 572
	BigInteger.prototype.clamp = bnpClamp;                                                                              // 573
	BigInteger.prototype.dlShiftTo = bnpDLShiftTo;                                                                      // 574
	BigInteger.prototype.drShiftTo = bnpDRShiftTo;                                                                      // 575
	BigInteger.prototype.lShiftTo = bnpLShiftTo;                                                                        // 576
	BigInteger.prototype.rShiftTo = bnpRShiftTo;                                                                        // 577
	BigInteger.prototype.subTo = bnpSubTo;                                                                              // 578
	BigInteger.prototype.multiplyTo = bnpMultiplyTo;                                                                    // 579
	BigInteger.prototype.squareTo = bnpSquareTo;                                                                        // 580
	BigInteger.prototype.divRemTo = bnpDivRemTo;                                                                        // 581
	BigInteger.prototype.invDigit = bnpInvDigit;                                                                        // 582
	BigInteger.prototype.isEven = bnpIsEven;                                                                            // 583
	BigInteger.prototype.exp = bnpExp;                                                                                  // 584
	                                                                                                                    // 585
	// public                                                                                                           // 586
	BigInteger.prototype.toString = bnToString;                                                                         // 587
	BigInteger.prototype.negate = bnNegate;                                                                             // 588
	BigInteger.prototype.abs = bnAbs;                                                                                   // 589
	BigInteger.prototype.compareTo = bnCompareTo;                                                                       // 590
	BigInteger.prototype.bitLength = bnBitLength;                                                                       // 591
	BigInteger.prototype.mod = bnMod;                                                                                   // 592
	BigInteger.prototype.modPowInt = bnModPowInt;                                                                       // 593
	                                                                                                                    // 594
	// "constants"                                                                                                      // 595
	BigInteger.ZERO = nbv(0);                                                                                           // 596
	BigInteger.ONE = nbv(1);                                                                                            // 597
	                                                                                                                    // 598
	                                                                                                                    // 599
	/// BEGIN jsbn2.js                                                                                                  // 600
	                                                                                                                    // 601
	/*                                                                                                                  // 602
	 * Copyright (c) 2003-2005  Tom Wu                                                                                  // 603
	 * All Rights Reserved.                                                                                             // 604
	 *                                                                                                                  // 605
	 * Permission is hereby granted, free of charge, to any person obtaining                                            // 606
	 * a copy of this software and associated documentation files (the                                                  // 607
	 * "Software"), to deal in the Software without restriction, including                                              // 608
	 * without limitation the rights to use, copy, modify, merge, publish,                                              // 609
	 * distribute, sublicense, and/or sell copies of the Software, and to                                               // 610
	 * permit persons to whom the Software is furnished to do so, subject to                                            // 611
	 * the following conditions:                                                                                        // 612
	 *                                                                                                                  // 613
	 * The above copyright notice and this permission notice shall be                                                   // 614
	 * included in all copies or substantial portions of the Software.                                                  // 615
	 *                                                                                                                  // 616
	 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,                                               // 617
	 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY                                                 // 618
	 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.                                                 // 619
	 *                                                                                                                  // 620
	 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,                                                  // 621
	 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER                                         // 622
	 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF                                           // 623
	 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT                                           // 624
	 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.                                                // 625
	 *                                                                                                                  // 626
	 * In addition, the following condition applies:                                                                    // 627
	 *                                                                                                                  // 628
	 * All redistributions must retain an intact copy of this copyright notice                                          // 629
	 * and disclaimer.                                                                                                  // 630
	 */                                                                                                                 // 631
	                                                                                                                    // 632
	// Extended JavaScript BN functions, required for RSA private ops.                                                  // 633
	                                                                                                                    // 634
	// (public)                                                                                                         // 635
	function bnClone() { var r = nbi(); this.copyTo(r); return r; }                                                     // 636
	                                                                                                                    // 637
	// (public) return value as integer                                                                                 // 638
	function bnIntValue() {                                                                                             // 639
	  if(this.s < 0) {                                                                                                  // 640
	    if(this.t == 1) return this[0]-this.DV;                                                                         // 641
	    else if(this.t == 0) return -1;                                                                                 // 642
	  }                                                                                                                 // 643
	  else if(this.t == 1) return this[0];                                                                              // 644
	  else if(this.t == 0) return 0;                                                                                    // 645
	  // assumes 16 < DB < 32                                                                                           // 646
	  return ((this[1]&((1<<(32-this.DB))-1))<<this.DB)|this[0];                                                        // 647
	}                                                                                                                   // 648
	                                                                                                                    // 649
	// (public) return value as byte                                                                                    // 650
	function bnByteValue() { return (this.t==0)?this.s:(this[0]<<24)>>24; }                                             // 651
	                                                                                                                    // 652
	// (public) return value as short (assumes DB>=16)                                                                  // 653
	function bnShortValue() { return (this.t==0)?this.s:(this[0]<<16)>>16; }                                            // 654
	                                                                                                                    // 655
	// (protected) return x s.t. r^x < DV                                                                               // 656
	function bnpChunkSize(r) { return Math.floor(Math.LN2*this.DB/Math.log(r)); }                                       // 657
	                                                                                                                    // 658
	// (public) 0 if this == 0, 1 if this > 0                                                                           // 659
	function bnSigNum() {                                                                                               // 660
	  if(this.s < 0) return -1;                                                                                         // 661
	  else if(this.t <= 0 || (this.t == 1 && this[0] <= 0)) return 0;                                                   // 662
	  else return 1;                                                                                                    // 663
	}                                                                                                                   // 664
	                                                                                                                    // 665
	// (protected) convert to radix string                                                                              // 666
	function bnpToRadix(b) {                                                                                            // 667
	  if(b == null) b = 10;                                                                                             // 668
	  if(this.signum() == 0 || b < 2 || b > 36) return "0";                                                             // 669
	  var cs = this.chunkSize(b);                                                                                       // 670
	  var a = Math.pow(b,cs);                                                                                           // 671
	  var d = nbv(a), y = nbi(), z = nbi(), r = "";                                                                     // 672
	  this.divRemTo(d,y,z);                                                                                             // 673
	  while(y.signum() > 0) {                                                                                           // 674
	    r = (a+z.intValue()).toString(b).substr(1) + r;                                                                 // 675
	    y.divRemTo(d,y,z);                                                                                              // 676
	  }                                                                                                                 // 677
	  return z.intValue().toString(b) + r;                                                                              // 678
	}                                                                                                                   // 679
	                                                                                                                    // 680
	// (protected) convert from radix string                                                                            // 681
	function bnpFromRadix(s,b) {                                                                                        // 682
	  this.fromInt(0);                                                                                                  // 683
	  if(b == null) b = 10;                                                                                             // 684
	  var cs = this.chunkSize(b);                                                                                       // 685
	  var d = Math.pow(b,cs), mi = false, j = 0, w = 0;                                                                 // 686
	  for(var i = 0; i < s.length; ++i) {                                                                               // 687
	    var x = intAt(s,i);                                                                                             // 688
	    if(x < 0) {                                                                                                     // 689
	      if(s.charAt(i) == "-" && this.signum() == 0) mi = true;                                                       // 690
	      continue;                                                                                                     // 691
	    }                                                                                                               // 692
	    w = b*w+x;                                                                                                      // 693
	    if(++j >= cs) {                                                                                                 // 694
	      this.dMultiply(d);                                                                                            // 695
	      this.dAddOffset(w,0);                                                                                         // 696
	      j = 0;                                                                                                        // 697
	      w = 0;                                                                                                        // 698
	    }                                                                                                               // 699
	  }                                                                                                                 // 700
	  if(j > 0) {                                                                                                       // 701
	    this.dMultiply(Math.pow(b,j));                                                                                  // 702
	    this.dAddOffset(w,0);                                                                                           // 703
	  }                                                                                                                 // 704
	  if(mi) BigInteger.ZERO.subTo(this,this);                                                                          // 705
	}                                                                                                                   // 706
	                                                                                                                    // 707
	// (protected) alternate constructor                                                                                // 708
	function bnpFromNumber(a,b,c) {                                                                                     // 709
	  if("number" == typeof b) {                                                                                        // 710
	    // new BigInteger(int,int,RNG)                                                                                  // 711
	    if(a < 2) this.fromInt(1);                                                                                      // 712
	    else {                                                                                                          // 713
	      this.fromNumber(a,c);                                                                                         // 714
	      if(!this.testBit(a-1))	// force MSB set                                                                       // 715
	        this.bitwiseTo(BigInteger.ONE.shiftLeft(a-1),op_or,this);                                                   // 716
	      if(this.isEven()) this.dAddOffset(1,0); // force odd                                                          // 717
	      while(!this.isProbablePrime(b)) {                                                                             // 718
	        this.dAddOffset(2,0);                                                                                       // 719
	        if(this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a-1),this);                                    // 720
	      }                                                                                                             // 721
	    }                                                                                                               // 722
	  }                                                                                                                 // 723
	  else {                                                                                                            // 724
	    // new BigInteger(int,RNG)                                                                                      // 725
	    var x = new Array(), t = a&7;                                                                                   // 726
	    x.length = (a>>3)+1;                                                                                            // 727
	    b.nextBytes(x);                                                                                                 // 728
	    if(t > 0) x[0] &= ((1<<t)-1); else x[0] = 0;                                                                    // 729
	    this.fromString(x,256);                                                                                         // 730
	  }                                                                                                                 // 731
	}                                                                                                                   // 732
	                                                                                                                    // 733
	// (public) convert to bigendian byte array                                                                         // 734
	function bnToByteArray() {                                                                                          // 735
	  var i = this.t, r = new Array();                                                                                  // 736
	  r[0] = this.s;                                                                                                    // 737
	  var p = this.DB-(i*this.DB)%8, d, k = 0;                                                                          // 738
	  if(i-- > 0) {                                                                                                     // 739
	    if(p < this.DB && (d = this[i]>>p) != (this.s&this.DM)>>p)                                                      // 740
	      r[k++] = d|(this.s<<(this.DB-p));                                                                             // 741
	    while(i >= 0) {                                                                                                 // 742
	      if(p < 8) {                                                                                                   // 743
	        d = (this[i]&((1<<p)-1))<<(8-p);                                                                            // 744
	        d |= this[--i]>>(p+=this.DB-8);                                                                             // 745
	      }                                                                                                             // 746
	      else {                                                                                                        // 747
	        d = (this[i]>>(p-=8))&0xff;                                                                                 // 748
	        if(p <= 0) { p += this.DB; --i; }                                                                           // 749
	      }                                                                                                             // 750
	      if((d&0x80) != 0) d |= -256;                                                                                  // 751
	      if(k == 0 && (this.s&0x80) != (d&0x80)) ++k;                                                                  // 752
	      if(k > 0 || d != this.s) r[k++] = d;                                                                          // 753
	    }                                                                                                               // 754
	  }                                                                                                                 // 755
	  return r;                                                                                                         // 756
	}                                                                                                                   // 757
	                                                                                                                    // 758
	function bnEquals(a) { return(this.compareTo(a)==0); }                                                              // 759
	function bnMin(a) { return(this.compareTo(a)<0)?this:a; }                                                           // 760
	function bnMax(a) { return(this.compareTo(a)>0)?this:a; }                                                           // 761
	                                                                                                                    // 762
	// (protected) r = this op a (bitwise)                                                                              // 763
	function bnpBitwiseTo(a,op,r) {                                                                                     // 764
	  var i, f, m = Math.min(a.t,this.t);                                                                               // 765
	  for(i = 0; i < m; ++i) r[i] = op(this[i],a[i]);                                                                   // 766
	  if(a.t < this.t) {                                                                                                // 767
	    f = a.s&this.DM;                                                                                                // 768
	    for(i = m; i < this.t; ++i) r[i] = op(this[i],f);                                                               // 769
	    r.t = this.t;                                                                                                   // 770
	  }                                                                                                                 // 771
	  else {                                                                                                            // 772
	    f = this.s&this.DM;                                                                                             // 773
	    for(i = m; i < a.t; ++i) r[i] = op(f,a[i]);                                                                     // 774
	    r.t = a.t;                                                                                                      // 775
	  }                                                                                                                 // 776
	  r.s = op(this.s,a.s);                                                                                             // 777
	  r.clamp();                                                                                                        // 778
	}                                                                                                                   // 779
	                                                                                                                    // 780
	// (public) this & a                                                                                                // 781
	function op_and(x,y) { return x&y; }                                                                                // 782
	function bnAnd(a) { var r = nbi(); this.bitwiseTo(a,op_and,r); return r; }                                          // 783
	                                                                                                                    // 784
	// (public) this | a                                                                                                // 785
	function op_or(x,y) { return x|y; }                                                                                 // 786
	function bnOr(a) { var r = nbi(); this.bitwiseTo(a,op_or,r); return r; }                                            // 787
	                                                                                                                    // 788
	// (public) this ^ a                                                                                                // 789
	function op_xor(x,y) { return x^y; }                                                                                // 790
	function bnXor(a) { var r = nbi(); this.bitwiseTo(a,op_xor,r); return r; }                                          // 791
	                                                                                                                    // 792
	// (public) this & ~a                                                                                               // 793
	function op_andnot(x,y) { return x&~y; }                                                                            // 794
	function bnAndNot(a) { var r = nbi(); this.bitwiseTo(a,op_andnot,r); return r; }                                    // 795
	                                                                                                                    // 796
	// (public) ~this                                                                                                   // 797
	function bnNot() {                                                                                                  // 798
	  var r = nbi();                                                                                                    // 799
	  for(var i = 0; i < this.t; ++i) r[i] = this.DM&~this[i];                                                          // 800
	  r.t = this.t;                                                                                                     // 801
	  r.s = ~this.s;                                                                                                    // 802
	  return r;                                                                                                         // 803
	}                                                                                                                   // 804
	                                                                                                                    // 805
	// (public) this << n                                                                                               // 806
	function bnShiftLeft(n) {                                                                                           // 807
	  var r = nbi();                                                                                                    // 808
	  if(n < 0) this.rShiftTo(-n,r); else this.lShiftTo(n,r);                                                           // 809
	  return r;                                                                                                         // 810
	}                                                                                                                   // 811
	                                                                                                                    // 812
	// (public) this >> n                                                                                               // 813
	function bnShiftRight(n) {                                                                                          // 814
	  var r = nbi();                                                                                                    // 815
	  if(n < 0) this.lShiftTo(-n,r); else this.rShiftTo(n,r);                                                           // 816
	  return r;                                                                                                         // 817
	}                                                                                                                   // 818
	                                                                                                                    // 819
	// return index of lowest 1-bit in x, x < 2^31                                                                      // 820
	function lbit(x) {                                                                                                  // 821
	  if(x == 0) return -1;                                                                                             // 822
	  var r = 0;                                                                                                        // 823
	  if((x&0xffff) == 0) { x >>= 16; r += 16; }                                                                        // 824
	  if((x&0xff) == 0) { x >>= 8; r += 8; }                                                                            // 825
	  if((x&0xf) == 0) { x >>= 4; r += 4; }                                                                             // 826
	  if((x&3) == 0) { x >>= 2; r += 2; }                                                                               // 827
	  if((x&1) == 0) ++r;                                                                                               // 828
	  return r;                                                                                                         // 829
	}                                                                                                                   // 830
	                                                                                                                    // 831
	// (public) returns index of lowest 1-bit (or -1 if none)                                                           // 832
	function bnGetLowestSetBit() {                                                                                      // 833
	  for(var i = 0; i < this.t; ++i)                                                                                   // 834
	    if(this[i] != 0) return i*this.DB+lbit(this[i]);                                                                // 835
	  if(this.s < 0) return this.t*this.DB;                                                                             // 836
	  return -1;                                                                                                        // 837
	}                                                                                                                   // 838
	                                                                                                                    // 839
	// return number of 1 bits in x                                                                                     // 840
	function cbit(x) {                                                                                                  // 841
	  var r = 0;                                                                                                        // 842
	  while(x != 0) { x &= x-1; ++r; }                                                                                  // 843
	  return r;                                                                                                         // 844
	}                                                                                                                   // 845
	                                                                                                                    // 846
	// (public) return number of set bits                                                                               // 847
	function bnBitCount() {                                                                                             // 848
	  var r = 0, x = this.s&this.DM;                                                                                    // 849
	  for(var i = 0; i < this.t; ++i) r += cbit(this[i]^x);                                                             // 850
	  return r;                                                                                                         // 851
	}                                                                                                                   // 852
	                                                                                                                    // 853
	// (public) true iff nth bit is set                                                                                 // 854
	function bnTestBit(n) {                                                                                             // 855
	  var j = Math.floor(n/this.DB);                                                                                    // 856
	  if(j >= this.t) return(this.s!=0);                                                                                // 857
	  return((this[j]&(1<<(n%this.DB)))!=0);                                                                            // 858
	}                                                                                                                   // 859
	                                                                                                                    // 860
	// (protected) this op (1<<n)                                                                                       // 861
	function bnpChangeBit(n,op) {                                                                                       // 862
	  var r = BigInteger.ONE.shiftLeft(n);                                                                              // 863
	  this.bitwiseTo(r,op,r);                                                                                           // 864
	  return r;                                                                                                         // 865
	}                                                                                                                   // 866
	                                                                                                                    // 867
	// (public) this | (1<<n)                                                                                           // 868
	function bnSetBit(n) { return this.changeBit(n,op_or); }                                                            // 869
	                                                                                                                    // 870
	// (public) this & ~(1<<n)                                                                                          // 871
	function bnClearBit(n) { return this.changeBit(n,op_andnot); }                                                      // 872
	                                                                                                                    // 873
	// (public) this ^ (1<<n)                                                                                           // 874
	function bnFlipBit(n) { return this.changeBit(n,op_xor); }                                                          // 875
	                                                                                                                    // 876
	// (protected) r = this + a                                                                                         // 877
	function bnpAddTo(a,r) {                                                                                            // 878
	  var i = 0, c = 0, m = Math.min(a.t,this.t);                                                                       // 879
	  while(i < m) {                                                                                                    // 880
	    c += this[i]+a[i];                                                                                              // 881
	    r[i++] = c&this.DM;                                                                                             // 882
	    c >>= this.DB;                                                                                                  // 883
	  }                                                                                                                 // 884
	  if(a.t < this.t) {                                                                                                // 885
	    c += a.s;                                                                                                       // 886
	    while(i < this.t) {                                                                                             // 887
	      c += this[i];                                                                                                 // 888
	      r[i++] = c&this.DM;                                                                                           // 889
	      c >>= this.DB;                                                                                                // 890
	    }                                                                                                               // 891
	    c += this.s;                                                                                                    // 892
	  }                                                                                                                 // 893
	  else {                                                                                                            // 894
	    c += this.s;                                                                                                    // 895
	    while(i < a.t) {                                                                                                // 896
	      c += a[i];                                                                                                    // 897
	      r[i++] = c&this.DM;                                                                                           // 898
	      c >>= this.DB;                                                                                                // 899
	    }                                                                                                               // 900
	    c += a.s;                                                                                                       // 901
	  }                                                                                                                 // 902
	  r.s = (c<0)?-1:0;                                                                                                 // 903
	  if(c > 0) r[i++] = c;                                                                                             // 904
	  else if(c < -1) r[i++] = this.DV+c;                                                                               // 905
	  r.t = i;                                                                                                          // 906
	  r.clamp();                                                                                                        // 907
	}                                                                                                                   // 908
	                                                                                                                    // 909
	// (public) this + a                                                                                                // 910
	function bnAdd(a) { var r = nbi(); this.addTo(a,r); return r; }                                                     // 911
	                                                                                                                    // 912
	// (public) this - a                                                                                                // 913
	function bnSubtract(a) { var r = nbi(); this.subTo(a,r); return r; }                                                // 914
	                                                                                                                    // 915
	// (public) this * a                                                                                                // 916
	function bnMultiply(a) { var r = nbi(); this.multiplyTo(a,r); return r; }                                           // 917
	                                                                                                                    // 918
	// (public) this / a                                                                                                // 919
	function bnDivide(a) { var r = nbi(); this.divRemTo(a,r,null); return r; }                                          // 920
	                                                                                                                    // 921
	// (public) this % a                                                                                                // 922
	function bnRemainder(a) { var r = nbi(); this.divRemTo(a,null,r); return r; }                                       // 923
	                                                                                                                    // 924
	// (public) [this/a,this%a]                                                                                         // 925
	function bnDivideAndRemainder(a) {                                                                                  // 926
	  var q = nbi(), r = nbi();                                                                                         // 927
	  this.divRemTo(a,q,r);                                                                                             // 928
	  return new Array(q,r);                                                                                            // 929
	}                                                                                                                   // 930
	                                                                                                                    // 931
	// (protected) this *= n, this >= 0, 1 < n < DV                                                                     // 932
	function bnpDMultiply(n) {                                                                                          // 933
	  this[this.t] = this.am(0,n-1,this,0,0,this.t);                                                                    // 934
	  ++this.t;                                                                                                         // 935
	  this.clamp();                                                                                                     // 936
	}                                                                                                                   // 937
	                                                                                                                    // 938
	// (protected) this += n << w words, this >= 0                                                                      // 939
	function bnpDAddOffset(n,w) {                                                                                       // 940
	  while(this.t <= w) this[this.t++] = 0;                                                                            // 941
	  this[w] += n;                                                                                                     // 942
	  while(this[w] >= this.DV) {                                                                                       // 943
	    this[w] -= this.DV;                                                                                             // 944
	    if(++w >= this.t) this[this.t++] = 0;                                                                           // 945
	    ++this[w];                                                                                                      // 946
	  }                                                                                                                 // 947
	}                                                                                                                   // 948
	                                                                                                                    // 949
	// A "null" reducer                                                                                                 // 950
	function NullExp() {}                                                                                               // 951
	function nNop(x) { return x; }                                                                                      // 952
	function nMulTo(x,y,r) { x.multiplyTo(y,r); }                                                                       // 953
	function nSqrTo(x,r) { x.squareTo(r); }                                                                             // 954
	                                                                                                                    // 955
	NullExp.prototype.convert = nNop;                                                                                   // 956
	NullExp.prototype.revert = nNop;                                                                                    // 957
	NullExp.prototype.mulTo = nMulTo;                                                                                   // 958
	NullExp.prototype.sqrTo = nSqrTo;                                                                                   // 959
	                                                                                                                    // 960
	// (public) this^e                                                                                                  // 961
	function bnPow(e) { return this.exp(e,new NullExp()); }                                                             // 962
	                                                                                                                    // 963
	// (protected) r = lower n words of "this * a", a.t <= n                                                            // 964
	// "this" should be the larger one if appropriate.                                                                  // 965
	function bnpMultiplyLowerTo(a,n,r) {                                                                                // 966
	  var i = Math.min(this.t+a.t,n);                                                                                   // 967
	  r.s = 0; // assumes a,this >= 0                                                                                   // 968
	  r.t = i;                                                                                                          // 969
	  while(i > 0) r[--i] = 0;                                                                                          // 970
	  var j;                                                                                                            // 971
	  for(j = r.t-this.t; i < j; ++i) r[i+this.t] = this.am(0,a[i],r,i,0,this.t);                                       // 972
	  for(j = Math.min(a.t,n); i < j; ++i) this.am(0,a[i],r,i,0,n-i);                                                   // 973
	  r.clamp();                                                                                                        // 974
	}                                                                                                                   // 975
	                                                                                                                    // 976
	// (protected) r = "this * a" without lower n words, n > 0                                                          // 977
	// "this" should be the larger one if appropriate.                                                                  // 978
	function bnpMultiplyUpperTo(a,n,r) {                                                                                // 979
	  --n;                                                                                                              // 980
	  var i = r.t = this.t+a.t-n;                                                                                       // 981
	  r.s = 0; // assumes a,this >= 0                                                                                   // 982
	  while(--i >= 0) r[i] = 0;                                                                                         // 983
	  for(i = Math.max(n-this.t,0); i < a.t; ++i)                                                                       // 984
	    r[this.t+i-n] = this.am(n-i,a[i],r,0,0,this.t+i-n);                                                             // 985
	  r.clamp();                                                                                                        // 986
	  r.drShiftTo(1,r);                                                                                                 // 987
	}                                                                                                                   // 988
	                                                                                                                    // 989
	// Barrett modular reduction                                                                                        // 990
	function Barrett(m) {                                                                                               // 991
	  // setup Barrett                                                                                                  // 992
	  this.r2 = nbi();                                                                                                  // 993
	  this.q3 = nbi();                                                                                                  // 994
	  BigInteger.ONE.dlShiftTo(2*m.t,this.r2);                                                                          // 995
	  this.mu = this.r2.divide(m);                                                                                      // 996
	  this.m = m;                                                                                                       // 997
	}                                                                                                                   // 998
	                                                                                                                    // 999
	function barrettConvert(x) {                                                                                        // 1000
	  if(x.s < 0 || x.t > 2*this.m.t) return x.mod(this.m);                                                             // 1001
	  else if(x.compareTo(this.m) < 0) return x;                                                                        // 1002
	  else { var r = nbi(); x.copyTo(r); this.reduce(r); return r; }                                                    // 1003
	}                                                                                                                   // 1004
	                                                                                                                    // 1005
	function barrettRevert(x) { return x; }                                                                             // 1006
	                                                                                                                    // 1007
	// x = x mod m (HAC 14.42)                                                                                          // 1008
	function barrettReduce(x) {                                                                                         // 1009
	  x.drShiftTo(this.m.t-1,this.r2);                                                                                  // 1010
	  if(x.t > this.m.t+1) { x.t = this.m.t+1; x.clamp(); }                                                             // 1011
	  this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3);                                                              // 1012
	  this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);                                                               // 1013
	  while(x.compareTo(this.r2) < 0) x.dAddOffset(1,this.m.t+1);                                                       // 1014
	  x.subTo(this.r2,x);                                                                                               // 1015
	  while(x.compareTo(this.m) >= 0) x.subTo(this.m,x);                                                                // 1016
	}                                                                                                                   // 1017
	                                                                                                                    // 1018
	// r = x^2 mod m; x != r                                                                                            // 1019
	function barrettSqrTo(x,r) { x.squareTo(r); this.reduce(r); }                                                       // 1020
	                                                                                                                    // 1021
	// r = x*y mod m; x,y != r                                                                                          // 1022
	function barrettMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }                                                 // 1023
	                                                                                                                    // 1024
	Barrett.prototype.convert = barrettConvert;                                                                         // 1025
	Barrett.prototype.revert = barrettRevert;                                                                           // 1026
	Barrett.prototype.reduce = barrettReduce;                                                                           // 1027
	Barrett.prototype.mulTo = barrettMulTo;                                                                             // 1028
	Barrett.prototype.sqrTo = barrettSqrTo;                                                                             // 1029
	                                                                                                                    // 1030
	// (public) this^e % m (HAC 14.85)                                                                                  // 1031
	function bnModPow(e,m) {                                                                                            // 1032
	  var i = e.bitLength(), k, r = nbv(1), z;                                                                          // 1033
	  if(i <= 0) return r;                                                                                              // 1034
	  else if(i < 18) k = 1;                                                                                            // 1035
	  else if(i < 48) k = 3;                                                                                            // 1036
	  else if(i < 144) k = 4;                                                                                           // 1037
	  else if(i < 768) k = 5;                                                                                           // 1038
	  else k = 6;                                                                                                       // 1039
	  if(i < 8)                                                                                                         // 1040
	    z = new Classic(m);                                                                                             // 1041
	  else if(m.isEven())                                                                                               // 1042
	    z = new Barrett(m);                                                                                             // 1043
	  else                                                                                                              // 1044
	    z = new Montgomery(m);                                                                                          // 1045
	                                                                                                                    // 1046
	  // precomputation                                                                                                 // 1047
	  var g = new Array(), n = 3, k1 = k-1, km = (1<<k)-1;                                                              // 1048
	  g[1] = z.convert(this);                                                                                           // 1049
	  if(k > 1) {                                                                                                       // 1050
	    var g2 = nbi();                                                                                                 // 1051
	    z.sqrTo(g[1],g2);                                                                                               // 1052
	    while(n <= km) {                                                                                                // 1053
	      g[n] = nbi();                                                                                                 // 1054
	      z.mulTo(g2,g[n-2],g[n]);                                                                                      // 1055
	      n += 2;                                                                                                       // 1056
	    }                                                                                                               // 1057
	  }                                                                                                                 // 1058
	                                                                                                                    // 1059
	  var j = e.t-1, w, is1 = true, r2 = nbi(), t;                                                                      // 1060
	  i = nbits(e[j])-1;                                                                                                // 1061
	  while(j >= 0) {                                                                                                   // 1062
	    if(i >= k1) w = (e[j]>>(i-k1))&km;                                                                              // 1063
	    else {                                                                                                          // 1064
	      w = (e[j]&((1<<(i+1))-1))<<(k1-i);                                                                            // 1065
	      if(j > 0) w |= e[j-1]>>(this.DB+i-k1);                                                                        // 1066
	    }                                                                                                               // 1067
	                                                                                                                    // 1068
	    n = k;                                                                                                          // 1069
	    while((w&1) == 0) { w >>= 1; --n; }                                                                             // 1070
	    if((i -= n) < 0) { i += this.DB; --j; }                                                                         // 1071
	    if(is1) {	// ret == 1, don't bother squaring or multiplying it                                                  // 1072
	      g[w].copyTo(r);                                                                                               // 1073
	      is1 = false;                                                                                                  // 1074
	    }                                                                                                               // 1075
	    else {                                                                                                          // 1076
	      while(n > 1) { z.sqrTo(r,r2); z.sqrTo(r2,r); n -= 2; }                                                        // 1077
	      if(n > 0) z.sqrTo(r,r2); else { t = r; r = r2; r2 = t; }                                                      // 1078
	      z.mulTo(r2,g[w],r);                                                                                           // 1079
	    }                                                                                                               // 1080
	                                                                                                                    // 1081
	    while(j >= 0 && (e[j]&(1<<i)) == 0) {                                                                           // 1082
	      z.sqrTo(r,r2); t = r; r = r2; r2 = t;                                                                         // 1083
	      if(--i < 0) { i = this.DB-1; --j; }                                                                           // 1084
	    }                                                                                                               // 1085
	  }                                                                                                                 // 1086
	  return z.revert(r);                                                                                               // 1087
	}                                                                                                                   // 1088
	                                                                                                                    // 1089
	// (public) gcd(this,a) (HAC 14.54)                                                                                 // 1090
	function bnGCD(a) {                                                                                                 // 1091
	  var x = (this.s<0)?this.negate():this.clone();                                                                    // 1092
	  var y = (a.s<0)?a.negate():a.clone();                                                                             // 1093
	  if(x.compareTo(y) < 0) { var t = x; x = y; y = t; }                                                               // 1094
	  var i = x.getLowestSetBit(), g = y.getLowestSetBit();                                                             // 1095
	  if(g < 0) return x;                                                                                               // 1096
	  if(i < g) g = i;                                                                                                  // 1097
	  if(g > 0) {                                                                                                       // 1098
	    x.rShiftTo(g,x);                                                                                                // 1099
	    y.rShiftTo(g,y);                                                                                                // 1100
	  }                                                                                                                 // 1101
	  while(x.signum() > 0) {                                                                                           // 1102
	    if((i = x.getLowestSetBit()) > 0) x.rShiftTo(i,x);                                                              // 1103
	    if((i = y.getLowestSetBit()) > 0) y.rShiftTo(i,y);                                                              // 1104
	    if(x.compareTo(y) >= 0) {                                                                                       // 1105
	      x.subTo(y,x);                                                                                                 // 1106
	      x.rShiftTo(1,x);                                                                                              // 1107
	    }                                                                                                               // 1108
	    else {                                                                                                          // 1109
	      y.subTo(x,y);                                                                                                 // 1110
	      y.rShiftTo(1,y);                                                                                              // 1111
	    }                                                                                                               // 1112
	  }                                                                                                                 // 1113
	  if(g > 0) y.lShiftTo(g,y);                                                                                        // 1114
	  return y;                                                                                                         // 1115
	}                                                                                                                   // 1116
	                                                                                                                    // 1117
	// (protected) this % n, n < 2^26                                                                                   // 1118
	function bnpModInt(n) {                                                                                             // 1119
	  if(n <= 0) return 0;                                                                                              // 1120
	  var d = this.DV%n, r = (this.s<0)?n-1:0;                                                                          // 1121
	  if(this.t > 0)                                                                                                    // 1122
	    if(d == 0) r = this[0]%n;                                                                                       // 1123
	    else for(var i = this.t-1; i >= 0; --i) r = (d*r+this[i])%n;                                                    // 1124
	  return r;                                                                                                         // 1125
	}                                                                                                                   // 1126
	                                                                                                                    // 1127
	// (public) 1/this % m (HAC 14.61)                                                                                  // 1128
	function bnModInverse(m) {                                                                                          // 1129
	  var ac = m.isEven();                                                                                              // 1130
	  if((this.isEven() && ac) || m.signum() == 0) return BigInteger.ZERO;                                              // 1131
	  var u = m.clone(), v = this.clone();                                                                              // 1132
	  var a = nbv(1), b = nbv(0), c = nbv(0), d = nbv(1);                                                               // 1133
	  while(u.signum() != 0) {                                                                                          // 1134
	    while(u.isEven()) {                                                                                             // 1135
	      u.rShiftTo(1,u);                                                                                              // 1136
	      if(ac) {                                                                                                      // 1137
	        if(!a.isEven() || !b.isEven()) { a.addTo(this,a); b.subTo(m,b); }                                           // 1138
	        a.rShiftTo(1,a);                                                                                            // 1139
	      }                                                                                                             // 1140
	      else if(!b.isEven()) b.subTo(m,b);                                                                            // 1141
	      b.rShiftTo(1,b);                                                                                              // 1142
	    }                                                                                                               // 1143
	    while(v.isEven()) {                                                                                             // 1144
	      v.rShiftTo(1,v);                                                                                              // 1145
	      if(ac) {                                                                                                      // 1146
	        if(!c.isEven() || !d.isEven()) { c.addTo(this,c); d.subTo(m,d); }                                           // 1147
	        c.rShiftTo(1,c);                                                                                            // 1148
	      }                                                                                                             // 1149
	      else if(!d.isEven()) d.subTo(m,d);                                                                            // 1150
	      d.rShiftTo(1,d);                                                                                              // 1151
	    }                                                                                                               // 1152
	    if(u.compareTo(v) >= 0) {                                                                                       // 1153
	      u.subTo(v,u);                                                                                                 // 1154
	      if(ac) a.subTo(c,a);                                                                                          // 1155
	      b.subTo(d,b);                                                                                                 // 1156
	    }                                                                                                               // 1157
	    else {                                                                                                          // 1158
	      v.subTo(u,v);                                                                                                 // 1159
	      if(ac) c.subTo(a,c);                                                                                          // 1160
	      d.subTo(b,d);                                                                                                 // 1161
	    }                                                                                                               // 1162
	  }                                                                                                                 // 1163
	  if(v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;                                                      // 1164
	  if(d.compareTo(m) >= 0) return d.subtract(m);                                                                     // 1165
	  if(d.signum() < 0) d.addTo(m,d); else return d;                                                                   // 1166
	  if(d.signum() < 0) return d.add(m); else return d;                                                                // 1167
	}                                                                                                                   // 1168
	                                                                                                                    // 1169
	var lowprimes = [2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509];
	var lplim = (1<<26)/lowprimes[lowprimes.length-1];                                                                  // 1171
	                                                                                                                    // 1172
	// (public) test primality with certainty >= 1-.5^t                                                                 // 1173
	function bnIsProbablePrime(t) {                                                                                     // 1174
	  var i, x = this.abs();                                                                                            // 1175
	  if(x.t == 1 && x[0] <= lowprimes[lowprimes.length-1]) {                                                           // 1176
	    for(i = 0; i < lowprimes.length; ++i)                                                                           // 1177
	      if(x[0] == lowprimes[i]) return true;                                                                         // 1178
	    return false;                                                                                                   // 1179
	  }                                                                                                                 // 1180
	  if(x.isEven()) return false;                                                                                      // 1181
	  i = 1;                                                                                                            // 1182
	  while(i < lowprimes.length) {                                                                                     // 1183
	    var m = lowprimes[i], j = i+1;                                                                                  // 1184
	    while(j < lowprimes.length && m < lplim) m *= lowprimes[j++];                                                   // 1185
	    m = x.modInt(m);                                                                                                // 1186
	    while(i < j) if(m%lowprimes[i++] == 0) return false;                                                            // 1187
	  }                                                                                                                 // 1188
	  return x.millerRabin(t);                                                                                          // 1189
	}                                                                                                                   // 1190
	                                                                                                                    // 1191
	// (protected) true if probably prime (HAC 4.24, Miller-Rabin)                                                      // 1192
	function bnpMillerRabin(t) {                                                                                        // 1193
	  var n1 = this.subtract(BigInteger.ONE);                                                                           // 1194
	  var k = n1.getLowestSetBit();                                                                                     // 1195
	  if(k <= 0) return false;                                                                                          // 1196
	  var r = n1.shiftRight(k);                                                                                         // 1197
	  t = (t+1)>>1;                                                                                                     // 1198
	  if(t > lowprimes.length) t = lowprimes.length;                                                                    // 1199
	  var a = nbi();                                                                                                    // 1200
	  for(var i = 0; i < t; ++i) {                                                                                      // 1201
	    a.fromInt(lowprimes[i]);                                                                                        // 1202
	    var y = a.modPow(r,this);                                                                                       // 1203
	    if(y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {                                                  // 1204
	      var j = 1;                                                                                                    // 1205
	      while(j++ < k && y.compareTo(n1) != 0) {                                                                      // 1206
	        y = y.modPowInt(2,this);                                                                                    // 1207
	        if(y.compareTo(BigInteger.ONE) == 0) return false;                                                          // 1208
	      }                                                                                                             // 1209
	      if(y.compareTo(n1) != 0) return false;                                                                        // 1210
	    }                                                                                                               // 1211
	  }                                                                                                                 // 1212
	  return true;                                                                                                      // 1213
	}                                                                                                                   // 1214
	                                                                                                                    // 1215
	// protected                                                                                                        // 1216
	BigInteger.prototype.chunkSize = bnpChunkSize;                                                                      // 1217
	BigInteger.prototype.toRadix = bnpToRadix;                                                                          // 1218
	BigInteger.prototype.fromRadix = bnpFromRadix;                                                                      // 1219
	BigInteger.prototype.fromNumber = bnpFromNumber;                                                                    // 1220
	BigInteger.prototype.bitwiseTo = bnpBitwiseTo;                                                                      // 1221
	BigInteger.prototype.changeBit = bnpChangeBit;                                                                      // 1222
	BigInteger.prototype.addTo = bnpAddTo;                                                                              // 1223
	BigInteger.prototype.dMultiply = bnpDMultiply;                                                                      // 1224
	BigInteger.prototype.dAddOffset = bnpDAddOffset;                                                                    // 1225
	BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;                                                          // 1226
	BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;                                                          // 1227
	BigInteger.prototype.modInt = bnpModInt;                                                                            // 1228
	BigInteger.prototype.millerRabin = bnpMillerRabin;                                                                  // 1229
	                                                                                                                    // 1230
	// public                                                                                                           // 1231
	BigInteger.prototype.clone = bnClone;                                                                               // 1232
	BigInteger.prototype.intValue = bnIntValue;                                                                         // 1233
	BigInteger.prototype.byteValue = bnByteValue;                                                                       // 1234
	BigInteger.prototype.shortValue = bnShortValue;                                                                     // 1235
	BigInteger.prototype.signum = bnSigNum;                                                                             // 1236
	BigInteger.prototype.toByteArray = bnToByteArray;                                                                   // 1237
	BigInteger.prototype.equals = bnEquals;                                                                             // 1238
	BigInteger.prototype.min = bnMin;                                                                                   // 1239
	BigInteger.prototype.max = bnMax;                                                                                   // 1240
	BigInteger.prototype.and = bnAnd;                                                                                   // 1241
	BigInteger.prototype.or = bnOr;                                                                                     // 1242
	BigInteger.prototype.xor = bnXor;                                                                                   // 1243
	BigInteger.prototype.andNot = bnAndNot;                                                                             // 1244
	BigInteger.prototype.not = bnNot;                                                                                   // 1245
	BigInteger.prototype.shiftLeft = bnShiftLeft;                                                                       // 1246
	BigInteger.prototype.shiftRight = bnShiftRight;                                                                     // 1247
	BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;                                                           // 1248
	BigInteger.prototype.bitCount = bnBitCount;                                                                         // 1249
	BigInteger.prototype.testBit = bnTestBit;                                                                           // 1250
	BigInteger.prototype.setBit = bnSetBit;                                                                             // 1251
	BigInteger.prototype.clearBit = bnClearBit;                                                                         // 1252
	BigInteger.prototype.flipBit = bnFlipBit;                                                                           // 1253
	BigInteger.prototype.add = bnAdd;                                                                                   // 1254
	BigInteger.prototype.subtract = bnSubtract;                                                                         // 1255
	BigInteger.prototype.multiply = bnMultiply;                                                                         // 1256
	BigInteger.prototype.divide = bnDivide;                                                                             // 1257
	BigInteger.prototype.remainder = bnRemainder;                                                                       // 1258
	BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;                                                     // 1259
	BigInteger.prototype.modPow = bnModPow;                                                                             // 1260
	BigInteger.prototype.modInverse = bnModInverse;                                                                     // 1261
	BigInteger.prototype.pow = bnPow;                                                                                   // 1262
	BigInteger.prototype.gcd = bnGCD;                                                                                   // 1263
	BigInteger.prototype.isProbablePrime = bnIsProbablePrime;                                                           // 1264
	                                                                                                                    // 1265
	// BigInteger interfaces not implemented in jsbn:                                                                   // 1266
	                                                                                                                    // 1267
	// BigInteger(int signum, byte[] magnitude)                                                                         // 1268
	// double doubleValue()                                                                                             // 1269
	// float floatValue()                                                                                               // 1270
	// int hashCode()                                                                                                   // 1271
	// long longValue()                                                                                                 // 1272
	// static BigInteger valueOf(long val)                                                                              // 1273
	                                                                                                                    // 1274
	/// METEOR WRAPPER                                                                                                  // 1275
	return BigInteger;                                                                                                  // 1276
	})();                                                                                                               // 1277
	                                                                                                                    // 1278
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                  //
	// packages/srp/srp.js                                                                                              //
	//                                                                                                                  //
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                    //
	// This package contains just enough of the original SRP code to                                                    // 1
	// support the backwards-compatibility upgrade path.                                                                // 2
	//                                                                                                                  // 3
	// An SRP (and possibly also accounts-srp) package should eventually be                                             // 4
	// available in Atmosphere so that users can continue to use SRP if they                                            // 5
	// want to.                                                                                                         // 6
	                                                                                                                    // 7
	SRP = {};                                                                                                           // 8
	                                                                                                                    // 9
	/**                                                                                                                 // 10
	 * Generate a new SRP verifier. Password is the plaintext password.                                                 // 11
	 *                                                                                                                  // 12
	 * options is optional and can include:                                                                             // 13
	 * - identity: String. The SRP username to user. Mostly this is passed                                              // 14
	 *   in for testing.  Random UUID if not provided.                                                                  // 15
	 * - hashedIdentityAndPassword: combined identity and password, already hashed, for the SRP to bcrypt upgrade path.
	 * - salt: String. A salt to use.  Mostly this is passed in for                                                     // 17
	 *   testing.  Random UUID if not provided.                                                                         // 18
	 * - SRP parameters (see _defaults and paramsFromOptions below)                                                     // 19
	 */                                                                                                                 // 20
	SRP.generateVerifier = function (password, options) {                                                               // 21
	  var params = paramsFromOptions(options);                                                                          // 22
	                                                                                                                    // 23
	  var salt = (options && options.salt) || Random.secret();                                                          // 24
	                                                                                                                    // 25
	  var identity;                                                                                                     // 26
	  var hashedIdentityAndPassword = options && options.hashedIdentityAndPassword;                                     // 27
	  if (!hashedIdentityAndPassword) {                                                                                 // 28
	    identity = (options && options.identity) || Random.secret();                                                    // 29
	    hashedIdentityAndPassword = params.hash(identity + ":" + password);                                             // 30
	  }                                                                                                                 // 31
	                                                                                                                    // 32
	  var x = params.hash(salt + hashedIdentityAndPassword);                                                            // 33
	  var xi = new BigInteger(x, 16);                                                                                   // 34
	  var v = params.g.modPow(xi, params.N);                                                                            // 35
	                                                                                                                    // 36
	  return {                                                                                                          // 37
	    identity: identity,                                                                                             // 38
	    salt: salt,                                                                                                     // 39
	    verifier: v.toString(16)                                                                                        // 40
	  };                                                                                                                // 41
	};                                                                                                                  // 42
	                                                                                                                    // 43
	// For use with check().                                                                                            // 44
	SRP.matchVerifier = {                                                                                               // 45
	  identity: String,                                                                                                 // 46
	  salt: String,                                                                                                     // 47
	  verifier: String                                                                                                  // 48
	};                                                                                                                  // 49
	                                                                                                                    // 50
	                                                                                                                    // 51
	/**                                                                                                                 // 52
	 * Default parameter values for SRP.                                                                                // 53
	 *                                                                                                                  // 54
	 */                                                                                                                 // 55
	var _defaults = {                                                                                                   // 56
	  hash: function (x) { return SHA256(x).toLowerCase(); },                                                           // 57
	  N: new BigInteger("EEAF0AB9ADB38DD69C33F80AFA8FC5E86072618775FF3C0B9EA2314C9C256576D674DF7496EA81D3383B4813D692C6E0E0D5D8E250B98BE48E495C1D6089DAD15DC7D7B46154D6B6CE8EF4AD69B15D4982559B297BCF1885C529F566660E57EC68EDBC3C05726CC02FD4CBF4976EAA9AFD5138FE8376435B9FC61D2FC0EB06E3", 16),
	  g: new BigInteger("2")                                                                                            // 59
	};                                                                                                                  // 60
	_defaults.k = new BigInteger(                                                                                       // 61
	  _defaults.hash(                                                                                                   // 62
	    _defaults.N.toString(16) +                                                                                      // 63
	      _defaults.g.toString(16)),                                                                                    // 64
	  16);                                                                                                              // 65
	                                                                                                                    // 66
	/**                                                                                                                 // 67
	 * Process an options hash to create SRP parameters.                                                                // 68
	 *                                                                                                                  // 69
	 * Options can include:                                                                                             // 70
	 * - hash: Function. Defaults to SHA256.                                                                            // 71
	 * - N: String or BigInteger. Defaults to 1024 bit value from RFC 5054                                              // 72
	 * - g: String or BigInteger. Defaults to 2.                                                                        // 73
	 * - k: String or BigInteger. Defaults to hash(N, g)                                                                // 74
	 */                                                                                                                 // 75
	var paramsFromOptions = function (options) {                                                                        // 76
	  if (!options) // fast path                                                                                        // 77
	    return _defaults;                                                                                               // 78
	                                                                                                                    // 79
	  var ret = _.extend({}, _defaults);                                                                                // 80
	                                                                                                                    // 81
	  _.each(['N', 'g', 'k'], function (p) {                                                                            // 82
	    if (options[p]) {                                                                                               // 83
	      if (typeof options[p] === "string")                                                                           // 84
	        ret[p] = new BigInteger(options[p], 16);                                                                    // 85
	      else if (options[p] instanceof BigInteger)                                                                    // 86
	        ret[p] = options[p];                                                                                        // 87
	      else                                                                                                          // 88
	        throw new Error("Invalid parameter: " + p);                                                                 // 89
	    }                                                                                                               // 90
	  });                                                                                                               // 91
	                                                                                                                    // 92
	  if (options.hash)                                                                                                 // 93
	    ret.hash = function (x) { return options.hash(x).toLowerCase(); };                                              // 94
	                                                                                                                    // 95
	  if (!options.k && (options.N || options.g || options.hash)) {                                                     // 96
	    ret.k = ret.hash(ret.N.toString(16) + ret.g.toString(16));                                                      // 97
	  }                                                                                                                 // 98
	                                                                                                                    // 99
	  return ret;                                                                                                       // 100
	};                                                                                                                  // 101
	                                                                                                                    // 102
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.srp = {}, {
	  SRP: SRP
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/tracker.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	
	/* Package-scope variables */
	var Tracker, Deps;
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                    //
	// packages/tracker/tracker.js                                                                                        //
	//                                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                      //
	/////////////////////////////////////////////////////                                                                 // 1
	// Package docs at http://docs.meteor.com/#tracker //                                                                 // 2
	/////////////////////////////////////////////////////                                                                 // 3
	                                                                                                                      // 4
	/**                                                                                                                   // 5
	 * @namespace Tracker                                                                                                 // 6
	 * @summary The namespace for Tracker-related methods.                                                                // 7
	 */                                                                                                                   // 8
	Tracker = {};                                                                                                         // 9
	                                                                                                                      // 10
	// http://docs.meteor.com/#tracker_active                                                                             // 11
	                                                                                                                      // 12
	/**                                                                                                                   // 13
	 * @summary True if there is a current computation, meaning that dependencies on reactive data sources will be tracked and potentially cause the current computation to be rerun.
	 * @locus Client                                                                                                      // 15
	 * @type {Boolean}                                                                                                    // 16
	 */                                                                                                                   // 17
	Tracker.active = false;                                                                                               // 18
	                                                                                                                      // 19
	// http://docs.meteor.com/#tracker_currentcomputation                                                                 // 20
	                                                                                                                      // 21
	/**                                                                                                                   // 22
	 * @summary The current computation, or `null` if there isn't one.  The current computation is the [`Tracker.Computation`](#tracker_computation) object created by the innermost active call to `Tracker.autorun`, and it's the computation that gains dependencies when reactive data sources are accessed.
	 * @locus Client                                                                                                      // 24
	 * @type {Tracker.Computation}                                                                                        // 25
	 */                                                                                                                   // 26
	Tracker.currentComputation = null;                                                                                    // 27
	                                                                                                                      // 28
	var setCurrentComputation = function (c) {                                                                            // 29
	  Tracker.currentComputation = c;                                                                                     // 30
	  Tracker.active = !! c;                                                                                              // 31
	};                                                                                                                    // 32
	                                                                                                                      // 33
	var _debugFunc = function () {                                                                                        // 34
	  // We want this code to work without Meteor, and also without                                                       // 35
	  // "console" (which is technically non-standard and may be missing                                                  // 36
	  // on some browser we come across, like it was on IE 7).                                                            // 37
	  //                                                                                                                  // 38
	  // Lazy evaluation because `Meteor` does not exist right away.(??)                                                  // 39
	  return (typeof Meteor !== "undefined" ? Meteor._debug :                                                             // 40
	          ((typeof console !== "undefined") && console.error ?                                                        // 41
	           function () { console.error.apply(console, arguments); } :                                                 // 42
	           function () {}));                                                                                          // 43
	};                                                                                                                    // 44
	                                                                                                                      // 45
	var _maybeSuppressMoreLogs = function (messagesLength) {                                                              // 46
	  // Sometimes when running tests, we intentionally suppress logs on expected                                         // 47
	  // printed errors. Since the current implementation of _throwOrLog can log                                          // 48
	  // multiple separate log messages, suppress all of them if at least one suppress                                    // 49
	  // is expected as we still want them to count as one.                                                               // 50
	  if (typeof Meteor !== "undefined") {                                                                                // 51
	    if (Meteor._suppressed_log_expected()) {                                                                          // 52
	      Meteor._suppress_log(messagesLength - 1);                                                                       // 53
	    }                                                                                                                 // 54
	  }                                                                                                                   // 55
	};                                                                                                                    // 56
	                                                                                                                      // 57
	var _throwOrLog = function (from, e) {                                                                                // 58
	  if (throwFirstError) {                                                                                              // 59
	    throw e;                                                                                                          // 60
	  } else {                                                                                                            // 61
	    var printArgs = ["Exception from Tracker " + from + " function:"];                                                // 62
	    if (e.stack && e.message && e.name) {                                                                             // 63
	      var idx = e.stack.indexOf(e.message);                                                                           // 64
	      if (idx < 0 || idx > e.name.length + 2) { // check for "Error: "                                                // 65
	        // message is not part of the stack                                                                           // 66
	        var message = e.name + ": " + e.message;                                                                      // 67
	        printArgs.push(message);                                                                                      // 68
	      }                                                                                                               // 69
	    }                                                                                                                 // 70
	    printArgs.push(e.stack);                                                                                          // 71
	    _maybeSuppressMoreLogs(printArgs.length);                                                                         // 72
	                                                                                                                      // 73
	    for (var i = 0; i < printArgs.length; i++) {                                                                      // 74
	      _debugFunc()(printArgs[i]);                                                                                     // 75
	    }                                                                                                                 // 76
	  }                                                                                                                   // 77
	};                                                                                                                    // 78
	                                                                                                                      // 79
	// Takes a function `f`, and wraps it in a `Meteor._noYieldsAllowed`                                                  // 80
	// block if we are running on the server. On the client, returns the                                                  // 81
	// original function (since `Meteor._noYieldsAllowed` is a                                                            // 82
	// no-op). This has the benefit of not adding an unnecessary stack                                                    // 83
	// frame on the client.                                                                                               // 84
	var withNoYieldsAllowed = function (f) {                                                                              // 85
	  if ((typeof Meteor === 'undefined') || Meteor.isClient) {                                                           // 86
	    return f;                                                                                                         // 87
	  } else {                                                                                                            // 88
	    return function () {                                                                                              // 89
	      var args = arguments;                                                                                           // 90
	      Meteor._noYieldsAllowed(function () {                                                                           // 91
	        f.apply(null, args);                                                                                          // 92
	      });                                                                                                             // 93
	    };                                                                                                                // 94
	  }                                                                                                                   // 95
	};                                                                                                                    // 96
	                                                                                                                      // 97
	var nextId = 1;                                                                                                       // 98
	// computations whose callbacks we should call at flush time                                                          // 99
	var pendingComputations = [];                                                                                         // 100
	// `true` if a Tracker.flush is scheduled, or if we are in Tracker.flush now                                          // 101
	var willFlush = false;                                                                                                // 102
	// `true` if we are in Tracker.flush now                                                                              // 103
	var inFlush = false;                                                                                                  // 104
	// `true` if we are computing a computation now, either first time                                                    // 105
	// or recompute.  This matches Tracker.active unless we are inside                                                    // 106
	// Tracker.nonreactive, which nullfies currentComputation even though                                                 // 107
	// an enclosing computation may still be running.                                                                     // 108
	var inCompute = false;                                                                                                // 109
	// `true` if the `_throwFirstError` option was passed in to the call                                                  // 110
	// to Tracker.flush that we are in. When set, throw rather than log the                                               // 111
	// first error encountered while flushing. Before throwing the error,                                                 // 112
	// finish flushing (from a finally block), logging any subsequent                                                     // 113
	// errors.                                                                                                            // 114
	var throwFirstError = false;                                                                                          // 115
	                                                                                                                      // 116
	var afterFlushCallbacks = [];                                                                                         // 117
	                                                                                                                      // 118
	var requireFlush = function () {                                                                                      // 119
	  if (! willFlush) {                                                                                                  // 120
	    // We want this code to work without Meteor, see debugFunc above                                                  // 121
	    if (typeof Meteor !== "undefined")                                                                                // 122
	      Meteor._setImmediate(Tracker._runFlush);                                                                        // 123
	    else                                                                                                              // 124
	      setTimeout(Tracker._runFlush, 0);                                                                               // 125
	    willFlush = true;                                                                                                 // 126
	  }                                                                                                                   // 127
	};                                                                                                                    // 128
	                                                                                                                      // 129
	// Tracker.Computation constructor is visible but private                                                             // 130
	// (throws an error if you try to call it)                                                                            // 131
	var constructingComputation = false;                                                                                  // 132
	                                                                                                                      // 133
	//                                                                                                                    // 134
	// http://docs.meteor.com/#tracker_computation                                                                        // 135
	                                                                                                                      // 136
	/**                                                                                                                   // 137
	 * @summary A Computation object represents code that is repeatedly rerun                                             // 138
	 * in response to                                                                                                     // 139
	 * reactive data changes. Computations don't have return values; they just                                            // 140
	 * perform actions, such as rerendering a template on the screen. Computations                                        // 141
	 * are created using Tracker.autorun. Use stop to prevent further rerunning of a                                      // 142
	 * computation.                                                                                                       // 143
	 * @instancename computation                                                                                          // 144
	 */                                                                                                                   // 145
	Tracker.Computation = function (f, parent, onError) {                                                                 // 146
	  if (! constructingComputation)                                                                                      // 147
	    throw new Error(                                                                                                  // 148
	      "Tracker.Computation constructor is private; use Tracker.autorun");                                             // 149
	  constructingComputation = false;                                                                                    // 150
	                                                                                                                      // 151
	  var self = this;                                                                                                    // 152
	                                                                                                                      // 153
	  // http://docs.meteor.com/#computation_stopped                                                                      // 154
	                                                                                                                      // 155
	  /**                                                                                                                 // 156
	   * @summary True if this computation has been stopped.                                                              // 157
	   * @locus Client                                                                                                    // 158
	   * @memberOf Tracker.Computation                                                                                    // 159
	   * @instance                                                                                                        // 160
	   * @name  stopped                                                                                                   // 161
	   */                                                                                                                 // 162
	  self.stopped = false;                                                                                               // 163
	                                                                                                                      // 164
	  // http://docs.meteor.com/#computation_invalidated                                                                  // 165
	                                                                                                                      // 166
	  /**                                                                                                                 // 167
	   * @summary True if this computation has been invalidated (and not yet rerun), or if it has been stopped.           // 168
	   * @locus Client                                                                                                    // 169
	   * @memberOf Tracker.Computation                                                                                    // 170
	   * @instance                                                                                                        // 171
	   * @name  invalidated                                                                                               // 172
	   * @type {Boolean}                                                                                                  // 173
	   */                                                                                                                 // 174
	  self.invalidated = false;                                                                                           // 175
	                                                                                                                      // 176
	  // http://docs.meteor.com/#computation_firstrun                                                                     // 177
	                                                                                                                      // 178
	  /**                                                                                                                 // 179
	   * @summary True during the initial run of the computation at the time `Tracker.autorun` is called, and false on subsequent reruns and at other times.
	   * @locus Client                                                                                                    // 181
	   * @memberOf Tracker.Computation                                                                                    // 182
	   * @instance                                                                                                        // 183
	   * @name  firstRun                                                                                                  // 184
	   * @type {Boolean}                                                                                                  // 185
	   */                                                                                                                 // 186
	  self.firstRun = true;                                                                                               // 187
	                                                                                                                      // 188
	  self._id = nextId++;                                                                                                // 189
	  self._onInvalidateCallbacks = [];                                                                                   // 190
	  self._onStopCallbacks = [];                                                                                         // 191
	  // the plan is at some point to use the parent relation                                                             // 192
	  // to constrain the order that computations are processed                                                           // 193
	  self._parent = parent;                                                                                              // 194
	  self._func = f;                                                                                                     // 195
	  self._onError = onError;                                                                                            // 196
	  self._recomputing = false;                                                                                          // 197
	                                                                                                                      // 198
	  var errored = true;                                                                                                 // 199
	  try {                                                                                                               // 200
	    self._compute();                                                                                                  // 201
	    errored = false;                                                                                                  // 202
	  } finally {                                                                                                         // 203
	    self.firstRun = false;                                                                                            // 204
	    if (errored)                                                                                                      // 205
	      self.stop();                                                                                                    // 206
	  }                                                                                                                   // 207
	};                                                                                                                    // 208
	                                                                                                                      // 209
	// http://docs.meteor.com/#computation_oninvalidate                                                                   // 210
	                                                                                                                      // 211
	/**                                                                                                                   // 212
	 * @summary Registers `callback` to run when this computation is next invalidated, or runs it immediately if the computation is already invalidated.  The callback is run exactly once and not upon future invalidations unless `onInvalidate` is called again after the computation becomes valid again.
	 * @locus Client                                                                                                      // 214
	 * @param {Function} callback Function to be called on invalidation. Receives one argument, the computation that was invalidated.
	 */                                                                                                                   // 216
	Tracker.Computation.prototype.onInvalidate = function (f) {                                                           // 217
	  var self = this;                                                                                                    // 218
	                                                                                                                      // 219
	  if (typeof f !== 'function')                                                                                        // 220
	    throw new Error("onInvalidate requires a function");                                                              // 221
	                                                                                                                      // 222
	  if (self.invalidated) {                                                                                             // 223
	    Tracker.nonreactive(function () {                                                                                 // 224
	      withNoYieldsAllowed(f)(self);                                                                                   // 225
	    });                                                                                                               // 226
	  } else {                                                                                                            // 227
	    self._onInvalidateCallbacks.push(f);                                                                              // 228
	  }                                                                                                                   // 229
	};                                                                                                                    // 230
	                                                                                                                      // 231
	/**                                                                                                                   // 232
	 * @summary Registers `callback` to run when this computation is stopped, or runs it immediately if the computation is already stopped.  The callback is run after any `onInvalidate` callbacks.
	 * @locus Client                                                                                                      // 234
	 * @param {Function} callback Function to be called on stop. Receives one argument, the computation that was stopped.
	 */                                                                                                                   // 236
	Tracker.Computation.prototype.onStop = function (f) {                                                                 // 237
	  var self = this;                                                                                                    // 238
	                                                                                                                      // 239
	  if (typeof f !== 'function')                                                                                        // 240
	    throw new Error("onStop requires a function");                                                                    // 241
	                                                                                                                      // 242
	  if (self.stopped) {                                                                                                 // 243
	    Tracker.nonreactive(function () {                                                                                 // 244
	      withNoYieldsAllowed(f)(self);                                                                                   // 245
	    });                                                                                                               // 246
	  } else {                                                                                                            // 247
	    self._onStopCallbacks.push(f);                                                                                    // 248
	  }                                                                                                                   // 249
	};                                                                                                                    // 250
	                                                                                                                      // 251
	// http://docs.meteor.com/#computation_invalidate                                                                     // 252
	                                                                                                                      // 253
	/**                                                                                                                   // 254
	 * @summary Invalidates this computation so that it will be rerun.                                                    // 255
	 * @locus Client                                                                                                      // 256
	 */                                                                                                                   // 257
	Tracker.Computation.prototype.invalidate = function () {                                                              // 258
	  var self = this;                                                                                                    // 259
	  if (! self.invalidated) {                                                                                           // 260
	    // if we're currently in _recompute(), don't enqueue                                                              // 261
	    // ourselves, since we'll rerun immediately anyway.                                                               // 262
	    if (! self._recomputing && ! self.stopped) {                                                                      // 263
	      requireFlush();                                                                                                 // 264
	      pendingComputations.push(this);                                                                                 // 265
	    }                                                                                                                 // 266
	                                                                                                                      // 267
	    self.invalidated = true;                                                                                          // 268
	                                                                                                                      // 269
	    // callbacks can't add callbacks, because                                                                         // 270
	    // self.invalidated === true.                                                                                     // 271
	    for(var i = 0, f; f = self._onInvalidateCallbacks[i]; i++) {                                                      // 272
	      Tracker.nonreactive(function () {                                                                               // 273
	        withNoYieldsAllowed(f)(self);                                                                                 // 274
	      });                                                                                                             // 275
	    }                                                                                                                 // 276
	    self._onInvalidateCallbacks = [];                                                                                 // 277
	  }                                                                                                                   // 278
	};                                                                                                                    // 279
	                                                                                                                      // 280
	// http://docs.meteor.com/#computation_stop                                                                           // 281
	                                                                                                                      // 282
	/**                                                                                                                   // 283
	 * @summary Prevents this computation from rerunning.                                                                 // 284
	 * @locus Client                                                                                                      // 285
	 */                                                                                                                   // 286
	Tracker.Computation.prototype.stop = function () {                                                                    // 287
	  var self = this;                                                                                                    // 288
	                                                                                                                      // 289
	  if (! self.stopped) {                                                                                               // 290
	    self.stopped = true;                                                                                              // 291
	    self.invalidate();                                                                                                // 292
	    for(var i = 0, f; f = self._onStopCallbacks[i]; i++) {                                                            // 293
	      Tracker.nonreactive(function () {                                                                               // 294
	        withNoYieldsAllowed(f)(self);                                                                                 // 295
	      });                                                                                                             // 296
	    }                                                                                                                 // 297
	    self._onStopCallbacks = [];                                                                                       // 298
	  }                                                                                                                   // 299
	};                                                                                                                    // 300
	                                                                                                                      // 301
	Tracker.Computation.prototype._compute = function () {                                                                // 302
	  var self = this;                                                                                                    // 303
	  self.invalidated = false;                                                                                           // 304
	                                                                                                                      // 305
	  var previous = Tracker.currentComputation;                                                                          // 306
	  setCurrentComputation(self);                                                                                        // 307
	  var previousInCompute = inCompute;                                                                                  // 308
	  inCompute = true;                                                                                                   // 309
	  try {                                                                                                               // 310
	    withNoYieldsAllowed(self._func)(self);                                                                            // 311
	  } finally {                                                                                                         // 312
	    setCurrentComputation(previous);                                                                                  // 313
	    inCompute = previousInCompute;                                                                                    // 314
	  }                                                                                                                   // 315
	};                                                                                                                    // 316
	                                                                                                                      // 317
	Tracker.Computation.prototype._needsRecompute = function () {                                                         // 318
	  var self = this;                                                                                                    // 319
	  return self.invalidated && ! self.stopped;                                                                          // 320
	};                                                                                                                    // 321
	                                                                                                                      // 322
	Tracker.Computation.prototype._recompute = function () {                                                              // 323
	  var self = this;                                                                                                    // 324
	                                                                                                                      // 325
	  self._recomputing = true;                                                                                           // 326
	  try {                                                                                                               // 327
	    if (self._needsRecompute()) {                                                                                     // 328
	      try {                                                                                                           // 329
	        self._compute();                                                                                              // 330
	      } catch (e) {                                                                                                   // 331
	        if (self._onError) {                                                                                          // 332
	          self._onError(e);                                                                                           // 333
	        } else {                                                                                                      // 334
	          _throwOrLog("recompute", e);                                                                                // 335
	        }                                                                                                             // 336
	      }                                                                                                               // 337
	    }                                                                                                                 // 338
	  } finally {                                                                                                         // 339
	    self._recomputing = false;                                                                                        // 340
	  }                                                                                                                   // 341
	};                                                                                                                    // 342
	                                                                                                                      // 343
	/**                                                                                                                   // 344
	 * @summary Process the reactive updates for this computation immediately                                             // 345
	 * and ensure that the computation is rerun. The computation is rerun only                                            // 346
	 * if it is invalidated.                                                                                              // 347
	 * @locus Client                                                                                                      // 348
	 */                                                                                                                   // 349
	Tracker.Computation.prototype.flush = function () {                                                                   // 350
	  var self = this;                                                                                                    // 351
	                                                                                                                      // 352
	  if (self._recomputing)                                                                                              // 353
	    return;                                                                                                           // 354
	                                                                                                                      // 355
	  self._recompute();                                                                                                  // 356
	};                                                                                                                    // 357
	                                                                                                                      // 358
	/**                                                                                                                   // 359
	 * @summary Causes the function inside this computation to run and                                                    // 360
	 * synchronously process all reactive updtes.                                                                         // 361
	 * @locus Client                                                                                                      // 362
	 */                                                                                                                   // 363
	Tracker.Computation.prototype.run = function () {                                                                     // 364
	  var self = this;                                                                                                    // 365
	  self.invalidate();                                                                                                  // 366
	  self.flush();                                                                                                       // 367
	};                                                                                                                    // 368
	                                                                                                                      // 369
	//                                                                                                                    // 370
	// http://docs.meteor.com/#tracker_dependency                                                                         // 371
	                                                                                                                      // 372
	/**                                                                                                                   // 373
	 * @summary A Dependency represents an atomic unit of reactive data that a                                            // 374
	 * computation might depend on. Reactive data sources such as Session or                                              // 375
	 * Minimongo internally create different Dependency objects for different                                             // 376
	 * pieces of data, each of which may be depended on by multiple computations.                                         // 377
	 * When the data changes, the computations are invalidated.                                                           // 378
	 * @class                                                                                                             // 379
	 * @instanceName dependency                                                                                           // 380
	 */                                                                                                                   // 381
	Tracker.Dependency = function () {                                                                                    // 382
	  this._dependentsById = {};                                                                                          // 383
	};                                                                                                                    // 384
	                                                                                                                      // 385
	// http://docs.meteor.com/#dependency_depend                                                                          // 386
	//                                                                                                                    // 387
	// Adds `computation` to this set if it is not already                                                                // 388
	// present.  Returns true if `computation` is a new member of the set.                                                // 389
	// If no argument, defaults to currentComputation, or does nothing                                                    // 390
	// if there is no currentComputation.                                                                                 // 391
	                                                                                                                      // 392
	/**                                                                                                                   // 393
	 * @summary Declares that the current computation (or `fromComputation` if given) depends on `dependency`.  The computation will be invalidated the next time `dependency` changes.
	                                                                                                                      // 395
	If there is no current computation and `depend()` is called with no arguments, it does nothing and returns false.     // 396
	                                                                                                                      // 397
	Returns true if the computation is a new dependent of `dependency` rather than an existing one.                       // 398
	 * @locus Client                                                                                                      // 399
	 * @param {Tracker.Computation} [fromComputation] An optional computation declared to depend on `dependency` instead of the current computation.
	 * @returns {Boolean}                                                                                                 // 401
	 */                                                                                                                   // 402
	Tracker.Dependency.prototype.depend = function (computation) {                                                        // 403
	  if (! computation) {                                                                                                // 404
	    if (! Tracker.active)                                                                                             // 405
	      return false;                                                                                                   // 406
	                                                                                                                      // 407
	    computation = Tracker.currentComputation;                                                                         // 408
	  }                                                                                                                   // 409
	  var self = this;                                                                                                    // 410
	  var id = computation._id;                                                                                           // 411
	  if (! (id in self._dependentsById)) {                                                                               // 412
	    self._dependentsById[id] = computation;                                                                           // 413
	    computation.onInvalidate(function () {                                                                            // 414
	      delete self._dependentsById[id];                                                                                // 415
	    });                                                                                                               // 416
	    return true;                                                                                                      // 417
	  }                                                                                                                   // 418
	  return false;                                                                                                       // 419
	};                                                                                                                    // 420
	                                                                                                                      // 421
	// http://docs.meteor.com/#dependency_changed                                                                         // 422
	                                                                                                                      // 423
	/**                                                                                                                   // 424
	 * @summary Invalidate all dependent computations immediately and remove them as dependents.                          // 425
	 * @locus Client                                                                                                      // 426
	 */                                                                                                                   // 427
	Tracker.Dependency.prototype.changed = function () {                                                                  // 428
	  var self = this;                                                                                                    // 429
	  for (var id in self._dependentsById)                                                                                // 430
	    self._dependentsById[id].invalidate();                                                                            // 431
	};                                                                                                                    // 432
	                                                                                                                      // 433
	// http://docs.meteor.com/#dependency_hasdependents                                                                   // 434
	                                                                                                                      // 435
	/**                                                                                                                   // 436
	 * @summary True if this Dependency has one or more dependent Computations, which would be invalidated if this Dependency were to change.
	 * @locus Client                                                                                                      // 438
	 * @returns {Boolean}                                                                                                 // 439
	 */                                                                                                                   // 440
	Tracker.Dependency.prototype.hasDependents = function () {                                                            // 441
	  var self = this;                                                                                                    // 442
	  for(var id in self._dependentsById)                                                                                 // 443
	    return true;                                                                                                      // 444
	  return false;                                                                                                       // 445
	};                                                                                                                    // 446
	                                                                                                                      // 447
	// http://docs.meteor.com/#tracker_flush                                                                              // 448
	                                                                                                                      // 449
	/**                                                                                                                   // 450
	 * @summary Process all reactive updates immediately and ensure that all invalidated computations are rerun.          // 451
	 * @locus Client                                                                                                      // 452
	 */                                                                                                                   // 453
	Tracker.flush = function (options) {                                                                                  // 454
	  Tracker._runFlush({ finishSynchronously: true,                                                                      // 455
	                      throwFirstError: options && options._throwFirstError });                                        // 456
	};                                                                                                                    // 457
	                                                                                                                      // 458
	// Run all pending computations and afterFlush callbacks.  If we were not called                                      // 459
	// directly via Tracker.flush, this may return before they're all done to allow                                       // 460
	// the event loop to run a little before continuing.                                                                  // 461
	Tracker._runFlush = function (options) {                                                                              // 462
	  // XXX What part of the comment below is still true? (We no longer                                                  // 463
	  // have Spark)                                                                                                      // 464
	  //                                                                                                                  // 465
	  // Nested flush could plausibly happen if, say, a flush causes                                                      // 466
	  // DOM mutation, which causes a "blur" event, which runs an                                                         // 467
	  // app event handler that calls Tracker.flush.  At the moment                                                       // 468
	  // Spark blocks event handlers during DOM mutation anyway,                                                          // 469
	  // because the LiveRange tree isn't valid.  And we don't have                                                       // 470
	  // any useful notion of a nested flush.                                                                             // 471
	  //                                                                                                                  // 472
	  // https://app.asana.com/0/159908330244/385138233856                                                                // 473
	  if (inFlush)                                                                                                        // 474
	    throw new Error("Can't call Tracker.flush while flushing");                                                       // 475
	                                                                                                                      // 476
	  if (inCompute)                                                                                                      // 477
	    throw new Error("Can't flush inside Tracker.autorun");                                                            // 478
	                                                                                                                      // 479
	  options = options || {};                                                                                            // 480
	                                                                                                                      // 481
	  inFlush = true;                                                                                                     // 482
	  willFlush = true;                                                                                                   // 483
	  throwFirstError = !! options.throwFirstError;                                                                       // 484
	                                                                                                                      // 485
	  var recomputedCount = 0;                                                                                            // 486
	  var finishedTry = false;                                                                                            // 487
	  try {                                                                                                               // 488
	    while (pendingComputations.length ||                                                                              // 489
	           afterFlushCallbacks.length) {                                                                              // 490
	                                                                                                                      // 491
	      // recompute all pending computations                                                                           // 492
	      while (pendingComputations.length) {                                                                            // 493
	        var comp = pendingComputations.shift();                                                                       // 494
	        comp._recompute();                                                                                            // 495
	        if (comp._needsRecompute()) {                                                                                 // 496
	          pendingComputations.unshift(comp);                                                                          // 497
	        }                                                                                                             // 498
	                                                                                                                      // 499
	        if (! options.finishSynchronously && ++recomputedCount > 1000) {                                              // 500
	          finishedTry = true;                                                                                         // 501
	          return;                                                                                                     // 502
	        }                                                                                                             // 503
	      }                                                                                                               // 504
	                                                                                                                      // 505
	      if (afterFlushCallbacks.length) {                                                                               // 506
	        // call one afterFlush callback, which may                                                                    // 507
	        // invalidate more computations                                                                               // 508
	        var func = afterFlushCallbacks.shift();                                                                       // 509
	        try {                                                                                                         // 510
	          func();                                                                                                     // 511
	        } catch (e) {                                                                                                 // 512
	          _throwOrLog("afterFlush", e);                                                                               // 513
	        }                                                                                                             // 514
	      }                                                                                                               // 515
	    }                                                                                                                 // 516
	    finishedTry = true;                                                                                               // 517
	  } finally {                                                                                                         // 518
	    if (! finishedTry) {                                                                                              // 519
	      // we're erroring due to throwFirstError being true.                                                            // 520
	      inFlush = false; // needed before calling `Tracker.flush()` again                                               // 521
	      // finish flushing                                                                                              // 522
	      Tracker._runFlush({                                                                                             // 523
	        finishSynchronously: options.finishSynchronously,                                                             // 524
	        throwFirstError: false                                                                                        // 525
	      });                                                                                                             // 526
	    }                                                                                                                 // 527
	    willFlush = false;                                                                                                // 528
	    inFlush = false;                                                                                                  // 529
	    if (pendingComputations.length || afterFlushCallbacks.length) {                                                   // 530
	      // We're yielding because we ran a bunch of computations and we aren't                                          // 531
	      // required to finish synchronously, so we'd like to give the event loop a                                      // 532
	      // chance. We should flush again soon.                                                                          // 533
	      if (options.finishSynchronously) {                                                                              // 534
	        throw new Error("still have more to do?");  // shouldn't happen                                               // 535
	      }                                                                                                               // 536
	      setTimeout(requireFlush, 10);                                                                                   // 537
	    }                                                                                                                 // 538
	  }                                                                                                                   // 539
	};                                                                                                                    // 540
	                                                                                                                      // 541
	// http://docs.meteor.com/#tracker_autorun                                                                            // 542
	//                                                                                                                    // 543
	// Run f(). Record its dependencies. Rerun it whenever the                                                            // 544
	// dependencies change.                                                                                               // 545
	//                                                                                                                    // 546
	// Returns a new Computation, which is also passed to f.                                                              // 547
	//                                                                                                                    // 548
	// Links the computation to the current computation                                                                   // 549
	// so that it is stopped if the current computation is invalidated.                                                   // 550
	                                                                                                                      // 551
	/**                                                                                                                   // 552
	 * @callback Tracker.ComputationFunction                                                                              // 553
	 * @param {Tracker.Computation}                                                                                       // 554
	 */                                                                                                                   // 555
	/**                                                                                                                   // 556
	 * @summary Run a function now and rerun it later whenever its dependencies                                           // 557
	 * change. Returns a Computation object that can be used to stop or observe the                                       // 558
	 * rerunning.                                                                                                         // 559
	 * @locus Client                                                                                                      // 560
	 * @param {Tracker.ComputationFunction} runFunc The function to run. It receives                                      // 561
	 * one argument: the Computation object that will be returned.                                                        // 562
	 * @param {Object} [options]                                                                                          // 563
	 * @param {Function} options.onError Optional. The function to run when an error                                      // 564
	 * happens in the Computation. The only argument it recieves is the Error                                             // 565
	 * thrown. Defaults to the error being logged to the console.                                                         // 566
	 * @returns {Tracker.Computation}                                                                                     // 567
	 */                                                                                                                   // 568
	Tracker.autorun = function (f, options) {                                                                             // 569
	  if (typeof f !== 'function')                                                                                        // 570
	    throw new Error('Tracker.autorun requires a function argument');                                                  // 571
	                                                                                                                      // 572
	  options = options || {};                                                                                            // 573
	                                                                                                                      // 574
	  constructingComputation = true;                                                                                     // 575
	  var c = new Tracker.Computation(                                                                                    // 576
	    f, Tracker.currentComputation, options.onError);                                                                  // 577
	                                                                                                                      // 578
	  if (Tracker.active)                                                                                                 // 579
	    Tracker.onInvalidate(function () {                                                                                // 580
	      c.stop();                                                                                                       // 581
	    });                                                                                                               // 582
	                                                                                                                      // 583
	  return c;                                                                                                           // 584
	};                                                                                                                    // 585
	                                                                                                                      // 586
	// http://docs.meteor.com/#tracker_nonreactive                                                                        // 587
	//                                                                                                                    // 588
	// Run `f` with no current computation, returning the return value                                                    // 589
	// of `f`.  Used to turn off reactivity for the duration of `f`,                                                      // 590
	// so that reactive data sources accessed by `f` will not result in any                                               // 591
	// computations being invalidated.                                                                                    // 592
	                                                                                                                      // 593
	/**                                                                                                                   // 594
	 * @summary Run a function without tracking dependencies.                                                             // 595
	 * @locus Client                                                                                                      // 596
	 * @param {Function} func A function to call immediately.                                                             // 597
	 */                                                                                                                   // 598
	Tracker.nonreactive = function (f) {                                                                                  // 599
	  var previous = Tracker.currentComputation;                                                                          // 600
	  setCurrentComputation(null);                                                                                        // 601
	  try {                                                                                                               // 602
	    return f();                                                                                                       // 603
	  } finally {                                                                                                         // 604
	    setCurrentComputation(previous);                                                                                  // 605
	  }                                                                                                                   // 606
	};                                                                                                                    // 607
	                                                                                                                      // 608
	// http://docs.meteor.com/#tracker_oninvalidate                                                                       // 609
	                                                                                                                      // 610
	/**                                                                                                                   // 611
	 * @summary Registers a new [`onInvalidate`](#computation_oninvalidate) callback on the current computation (which must exist), to be called immediately when the current computation is invalidated or stopped.
	 * @locus Client                                                                                                      // 613
	 * @param {Function} callback A callback function that will be invoked as `func(c)`, where `c` is the computation on which the callback is registered.
	 */                                                                                                                   // 615
	Tracker.onInvalidate = function (f) {                                                                                 // 616
	  if (! Tracker.active)                                                                                               // 617
	    throw new Error("Tracker.onInvalidate requires a currentComputation");                                            // 618
	                                                                                                                      // 619
	  Tracker.currentComputation.onInvalidate(f);                                                                         // 620
	};                                                                                                                    // 621
	                                                                                                                      // 622
	// http://docs.meteor.com/#tracker_afterflush                                                                         // 623
	                                                                                                                      // 624
	/**                                                                                                                   // 625
	 * @summary Schedules a function to be called during the next flush, or later in the current flush if one is in progress, after all invalidated computations have been rerun.  The function will be run once and not on subsequent flushes unless `afterFlush` is called again.
	 * @locus Client                                                                                                      // 627
	 * @param {Function} callback A function to call at flush time.                                                       // 628
	 */                                                                                                                   // 629
	Tracker.afterFlush = function (f) {                                                                                   // 630
	  afterFlushCallbacks.push(f);                                                                                        // 631
	  requireFlush();                                                                                                     // 632
	};                                                                                                                    // 633
	                                                                                                                      // 634
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                                    //
	// packages/tracker/deprecated.js                                                                                     //
	//                                                                                                                    //
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                                      //
	// Deprecated functions.                                                                                              // 1
	                                                                                                                      // 2
	// These functions used to be on the Meteor object (and worked slightly                                               // 3
	// differently).                                                                                                      // 4
	// XXX COMPAT WITH 0.5.7                                                                                              // 5
	Meteor.flush = Tracker.flush;                                                                                         // 6
	Meteor.autorun = Tracker.autorun;                                                                                     // 7
	                                                                                                                      // 8
	// We used to require a special "autosubscribe" call to reactively subscribe to                                       // 9
	// things. Now, it works with autorun.                                                                                // 10
	// XXX COMPAT WITH 0.5.4                                                                                              // 11
	Meteor.autosubscribe = Tracker.autorun;                                                                               // 12
	                                                                                                                      // 13
	// This Tracker API briefly existed in 0.5.8 and 0.5.9                                                                // 14
	// XXX COMPAT WITH 0.5.9                                                                                              // 15
	Tracker.depend = function (d) {                                                                                       // 16
	  return d.depend();                                                                                                  // 17
	};                                                                                                                    // 18
	                                                                                                                      // 19
	Deps = Tracker;                                                                                                       // 20
	                                                                                                                      // 21
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.tracker = {}, {
	  Tracker: Tracker,
	  Deps: Deps
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/underscore.js":
/***/ function(module, exports, __webpack_require__) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Package-scope variables */
	var exports, _;
	
	(function(){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                       //
	// packages/underscore/pre.js                                                                            //
	//                                                                                                       //
	///////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                         //
	// Define an object named exports. This will cause underscore.js to put `_` as a                         // 1
	// field on it, instead of in the global namespace.  See also post.js.                                   // 2
	exports = {};                                                                                            // 3
	                                                                                                         // 4
	///////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                       //
	// packages/underscore/underscore.js                                                                     //
	//                                                                                                       //
	///////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                         //
	//     Underscore.js 1.5.2                                                                               // 1
	//     http://underscorejs.org                                                                           // 2
	//     (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors                // 3
	//     Underscore may be freely distributed under the MIT license.                                       // 4
	                                                                                                         // 5
	(function() {                                                                                            // 6
	                                                                                                         // 7
	  // Baseline setup                                                                                      // 8
	  // --------------                                                                                      // 9
	                                                                                                         // 10
	  // Establish the root object, `window` in the browser, or `exports` on the server.                     // 11
	  var root = this;                                                                                       // 12
	                                                                                                         // 13
	  // Save the previous value of the `_` variable.                                                        // 14
	  var previousUnderscore = root._;                                                                       // 15
	                                                                                                         // 16
	  // Establish the object that gets returned to break out of a loop iteration.                           // 17
	  var breaker = {};                                                                                      // 18
	                                                                                                         // 19
	  // Save bytes in the minified (but not gzipped) version:                                               // 20
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;         // 21
	                                                                                                         // 22
	  // Create quick reference variables for speed access to core prototypes.                               // 23
	  var                                                                                                    // 24
	    push             = ArrayProto.push,                                                                  // 25
	    slice            = ArrayProto.slice,                                                                 // 26
	    concat           = ArrayProto.concat,                                                                // 27
	    toString         = ObjProto.toString,                                                                // 28
	    hasOwnProperty   = ObjProto.hasOwnProperty;                                                          // 29
	                                                                                                         // 30
	  // All **ECMAScript 5** native function implementations that we hope to use                            // 31
	  // are declared here.                                                                                  // 32
	  var                                                                                                    // 33
	    nativeForEach      = ArrayProto.forEach,                                                             // 34
	    nativeMap          = ArrayProto.map,                                                                 // 35
	    nativeReduce       = ArrayProto.reduce,                                                              // 36
	    nativeReduceRight  = ArrayProto.reduceRight,                                                         // 37
	    nativeFilter       = ArrayProto.filter,                                                              // 38
	    nativeEvery        = ArrayProto.every,                                                               // 39
	    nativeSome         = ArrayProto.some,                                                                // 40
	    nativeIndexOf      = ArrayProto.indexOf,                                                             // 41
	    nativeLastIndexOf  = ArrayProto.lastIndexOf,                                                         // 42
	    nativeIsArray      = Array.isArray,                                                                  // 43
	    nativeKeys         = Object.keys,                                                                    // 44
	    nativeBind         = FuncProto.bind;                                                                 // 45
	                                                                                                         // 46
	  // Create a safe reference to the Underscore object for use below.                                     // 47
	  var _ = function(obj) {                                                                                // 48
	    if (obj instanceof _) return obj;                                                                    // 49
	    if (!(this instanceof _)) return new _(obj);                                                         // 50
	    this._wrapped = obj;                                                                                 // 51
	  };                                                                                                     // 52
	                                                                                                         // 53
	  // Export the Underscore object for **Node.js**, with                                                  // 54
	  // backwards-compatibility for the old `require()` API. If we're in                                    // 55
	  // the browser, add `_` as a global object via a string identifier,                                    // 56
	  // for Closure Compiler "advanced" mode.                                                               // 57
	  if (typeof exports !== 'undefined') {                                                                  // 58
	    if (typeof module !== 'undefined' && module.exports) {                                               // 59
	      exports = module.exports = _;                                                                      // 60
	    }                                                                                                    // 61
	    exports._ = _;                                                                                       // 62
	  } else {                                                                                               // 63
	    root._ = _;                                                                                          // 64
	  }                                                                                                      // 65
	                                                                                                         // 66
	  // Current version.                                                                                    // 67
	  _.VERSION = '1.5.2';                                                                                   // 68
	                                                                                                         // 69
	  // Collection Functions                                                                                // 70
	  // --------------------                                                                                // 71
	                                                                                                         // 72
	  // METEOR CHANGE: Define _isArguments instead of depending on                                          // 73
	  // _.isArguments which is defined using each. In looksLikeArray                                        // 74
	  // (which each depends on), we then use _isArguments instead of                                        // 75
	  // _.isArguments.                                                                                      // 76
	  var _isArguments = function (obj) {                                                                    // 77
	    return toString.call(obj) === '[object Arguments]';                                                  // 78
	  };                                                                                                     // 79
	  // Define a fallback version of the method in browsers (ahem, IE), where                               // 80
	  // there isn't any inspectable "Arguments" type.                                                       // 81
	  if (!_isArguments(arguments)) {                                                                        // 82
	    _isArguments = function (obj) {                                                                      // 83
	      return !!(obj && hasOwnProperty.call(obj, 'callee') && typeof obj.callee === 'function');          // 84
	    };                                                                                                   // 85
	  }                                                                                                      // 86
	                                                                                                         // 87
	  // METEOR CHANGE: _.each({length: 5}) should be treated like an object, not an                         // 88
	  // array. This looksLikeArray function is introduced by Meteor, and replaces                           // 89
	  // all instances of `obj.length === +obj.length`.                                                      // 90
	  // https://github.com/meteor/meteor/issues/594                                                         // 91
	  // https://github.com/jashkenas/underscore/issues/770                                                  // 92
	  var looksLikeArray = function (obj) {                                                                  // 93
	    return (obj.length === +obj.length                                                                   // 94
	            // _.isArguments not yet necessarily defined here                                            // 95
	            && (_isArguments(obj) || obj.constructor !== Object));                                       // 96
	  };                                                                                                     // 97
	                                                                                                         // 98
	  // The cornerstone, an `each` implementation, aka `forEach`.                                           // 99
	  // Handles objects with the built-in `forEach`, arrays, and raw objects.                               // 100
	  // Delegates to **ECMAScript 5**'s native `forEach` if available.                                      // 101
	  var each = _.each = _.forEach = function(obj, iterator, context) {                                     // 102
	    if (obj == null) return;                                                                             // 103
	    if (nativeForEach && obj.forEach === nativeForEach) {                                                // 104
	      obj.forEach(iterator, context);                                                                    // 105
	    } else if (looksLikeArray(obj)) {                                                                    // 106
	      for (var i = 0, length = obj.length; i < length; i++) {                                            // 107
	        if (iterator.call(context, obj[i], i, obj) === breaker) return;                                  // 108
	      }                                                                                                  // 109
	    } else {                                                                                             // 110
	      var keys = _.keys(obj);                                                                            // 111
	      for (var i = 0, length = keys.length; i < length; i++) {                                           // 112
	        if (iterator.call(context, obj[keys[i]], keys[i], obj) === breaker) return;                      // 113
	      }                                                                                                  // 114
	    }                                                                                                    // 115
	  };                                                                                                     // 116
	                                                                                                         // 117
	  // Return the results of applying the iterator to each element.                                        // 118
	  // Delegates to **ECMAScript 5**'s native `map` if available.                                          // 119
	  _.map = _.collect = function(obj, iterator, context) {                                                 // 120
	    var results = [];                                                                                    // 121
	    if (obj == null) return results;                                                                     // 122
	    if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);                           // 123
	    each(obj, function(value, index, list) {                                                             // 124
	      results.push(iterator.call(context, value, index, list));                                          // 125
	    });                                                                                                  // 126
	    return results;                                                                                      // 127
	  };                                                                                                     // 128
	                                                                                                         // 129
	  var reduceError = 'Reduce of empty array with no initial value';                                       // 130
	                                                                                                         // 131
	  // **Reduce** builds up a single result from a list of values, aka `inject`,                           // 132
	  // or `foldl`. Delegates to **ECMAScript 5**'s native `reduce` if available.                           // 133
	  _.reduce = _.foldl = _.inject = function(obj, iterator, memo, context) {                               // 134
	    var initial = arguments.length > 2;                                                                  // 135
	    if (obj == null) obj = [];                                                                           // 136
	    if (nativeReduce && obj.reduce === nativeReduce) {                                                   // 137
	      if (context) iterator = _.bind(iterator, context);                                                 // 138
	      return initial ? obj.reduce(iterator, memo) : obj.reduce(iterator);                                // 139
	    }                                                                                                    // 140
	    each(obj, function(value, index, list) {                                                             // 141
	      if (!initial) {                                                                                    // 142
	        memo = value;                                                                                    // 143
	        initial = true;                                                                                  // 144
	      } else {                                                                                           // 145
	        memo = iterator.call(context, memo, value, index, list);                                         // 146
	      }                                                                                                  // 147
	    });                                                                                                  // 148
	    if (!initial) throw new TypeError(reduceError);                                                      // 149
	    return memo;                                                                                         // 150
	  };                                                                                                     // 151
	                                                                                                         // 152
	  // The right-associative version of reduce, also known as `foldr`.                                     // 153
	  // Delegates to **ECMAScript 5**'s native `reduceRight` if available.                                  // 154
	  _.reduceRight = _.foldr = function(obj, iterator, memo, context) {                                     // 155
	    var initial = arguments.length > 2;                                                                  // 156
	    if (obj == null) obj = [];                                                                           // 157
	    if (nativeReduceRight && obj.reduceRight === nativeReduceRight) {                                    // 158
	      if (context) iterator = _.bind(iterator, context);                                                 // 159
	      return initial ? obj.reduceRight(iterator, memo) : obj.reduceRight(iterator);                      // 160
	    }                                                                                                    // 161
	    var length = obj.length;                                                                             // 162
	    if (!looksLikeArray(obj)) {                                                                          // 163
	      var keys = _.keys(obj);                                                                            // 164
	      length = keys.length;                                                                              // 165
	    }                                                                                                    // 166
	    each(obj, function(value, index, list) {                                                             // 167
	      index = keys ? keys[--length] : --length;                                                          // 168
	      if (!initial) {                                                                                    // 169
	        memo = obj[index];                                                                               // 170
	        initial = true;                                                                                  // 171
	      } else {                                                                                           // 172
	        memo = iterator.call(context, memo, obj[index], index, list);                                    // 173
	      }                                                                                                  // 174
	    });                                                                                                  // 175
	    if (!initial) throw new TypeError(reduceError);                                                      // 176
	    return memo;                                                                                         // 177
	  };                                                                                                     // 178
	                                                                                                         // 179
	  // Return the first value which passes a truth test. Aliased as `detect`.                              // 180
	  _.find = _.detect = function(obj, iterator, context) {                                                 // 181
	    var result;                                                                                          // 182
	    any(obj, function(value, index, list) {                                                              // 183
	      if (iterator.call(context, value, index, list)) {                                                  // 184
	        result = value;                                                                                  // 185
	        return true;                                                                                     // 186
	      }                                                                                                  // 187
	    });                                                                                                  // 188
	    return result;                                                                                       // 189
	  };                                                                                                     // 190
	                                                                                                         // 191
	  // Return all the elements that pass a truth test.                                                     // 192
	  // Delegates to **ECMAScript 5**'s native `filter` if available.                                       // 193
	  // Aliased as `select`.                                                                                // 194
	  _.filter = _.select = function(obj, iterator, context) {                                               // 195
	    var results = [];                                                                                    // 196
	    if (obj == null) return results;                                                                     // 197
	    if (nativeFilter && obj.filter === nativeFilter) return obj.filter(iterator, context);               // 198
	    each(obj, function(value, index, list) {                                                             // 199
	      if (iterator.call(context, value, index, list)) results.push(value);                               // 200
	    });                                                                                                  // 201
	    return results;                                                                                      // 202
	  };                                                                                                     // 203
	                                                                                                         // 204
	  // Return all the elements for which a truth test fails.                                               // 205
	  _.reject = function(obj, iterator, context) {                                                          // 206
	    return _.filter(obj, function(value, index, list) {                                                  // 207
	      return !iterator.call(context, value, index, list);                                                // 208
	    }, context);                                                                                         // 209
	  };                                                                                                     // 210
	                                                                                                         // 211
	  // Determine whether all of the elements match a truth test.                                           // 212
	  // Delegates to **ECMAScript 5**'s native `every` if available.                                        // 213
	  // Aliased as `all`.                                                                                   // 214
	  _.every = _.all = function(obj, iterator, context) {                                                   // 215
	    iterator || (iterator = _.identity);                                                                 // 216
	    var result = true;                                                                                   // 217
	    if (obj == null) return result;                                                                      // 218
	    if (nativeEvery && obj.every === nativeEvery) return obj.every(iterator, context);                   // 219
	    each(obj, function(value, index, list) {                                                             // 220
	      if (!(result = result && iterator.call(context, value, index, list))) return breaker;              // 221
	    });                                                                                                  // 222
	    return !!result;                                                                                     // 223
	  };                                                                                                     // 224
	                                                                                                         // 225
	  // Determine if at least one element in the object matches a truth test.                               // 226
	  // Delegates to **ECMAScript 5**'s native `some` if available.                                         // 227
	  // Aliased as `any`.                                                                                   // 228
	  var any = _.some = _.any = function(obj, iterator, context) {                                          // 229
	    iterator || (iterator = _.identity);                                                                 // 230
	    var result = false;                                                                                  // 231
	    if (obj == null) return result;                                                                      // 232
	    if (nativeSome && obj.some === nativeSome) return obj.some(iterator, context);                       // 233
	    each(obj, function(value, index, list) {                                                             // 234
	      if (result || (result = iterator.call(context, value, index, list))) return breaker;               // 235
	    });                                                                                                  // 236
	    return !!result;                                                                                     // 237
	  };                                                                                                     // 238
	                                                                                                         // 239
	  // Determine if the array or object contains a given value (using `===`).                              // 240
	  // Aliased as `include`.                                                                               // 241
	  _.contains = _.include = function(obj, target) {                                                       // 242
	    if (obj == null) return false;                                                                       // 243
	    if (nativeIndexOf && obj.indexOf === nativeIndexOf) return obj.indexOf(target) != -1;                // 244
	    return any(obj, function(value) {                                                                    // 245
	      return value === target;                                                                           // 246
	    });                                                                                                  // 247
	  };                                                                                                     // 248
	                                                                                                         // 249
	  // Invoke a method (with arguments) on every item in a collection.                                     // 250
	  _.invoke = function(obj, method) {                                                                     // 251
	    var args = slice.call(arguments, 2);                                                                 // 252
	    var isFunc = _.isFunction(method);                                                                   // 253
	    return _.map(obj, function(value) {                                                                  // 254
	      return (isFunc ? method : value[method]).apply(value, args);                                       // 255
	    });                                                                                                  // 256
	  };                                                                                                     // 257
	                                                                                                         // 258
	  // Convenience version of a common use case of `map`: fetching a property.                             // 259
	  _.pluck = function(obj, key) {                                                                         // 260
	    return _.map(obj, function(value){ return value[key]; });                                            // 261
	  };                                                                                                     // 262
	                                                                                                         // 263
	  // Convenience version of a common use case of `filter`: selecting only objects                        // 264
	  // containing specific `key:value` pairs.                                                              // 265
	  _.where = function(obj, attrs, first) {                                                                // 266
	    if (_.isEmpty(attrs)) return first ? void 0 : [];                                                    // 267
	    return _[first ? 'find' : 'filter'](obj, function(value) {                                           // 268
	      for (var key in attrs) {                                                                           // 269
	        if (attrs[key] !== value[key]) return false;                                                     // 270
	      }                                                                                                  // 271
	      return true;                                                                                       // 272
	    });                                                                                                  // 273
	  };                                                                                                     // 274
	                                                                                                         // 275
	  // Convenience version of a common use case of `find`: getting the first object                        // 276
	  // containing specific `key:value` pairs.                                                              // 277
	  _.findWhere = function(obj, attrs) {                                                                   // 278
	    return _.where(obj, attrs, true);                                                                    // 279
	  };                                                                                                     // 280
	                                                                                                         // 281
	  // Return the maximum element or (element-based computation).                                          // 282
	  // Can't optimize arrays of integers longer than 65,535 elements.                                      // 283
	  // See [WebKit Bug 80797](https://bugs.webkit.org/show_bug.cgi?id=80797)                               // 284
	  _.max = function(obj, iterator, context) {                                                             // 285
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {                       // 286
	      return Math.max.apply(Math, obj);                                                                  // 287
	    }                                                                                                    // 288
	    if (!iterator && _.isEmpty(obj)) return -Infinity;                                                   // 289
	    var result = {computed : -Infinity, value: -Infinity};                                               // 290
	    each(obj, function(value, index, list) {                                                             // 291
	      var computed = iterator ? iterator.call(context, value, index, list) : value;                      // 292
	      computed > result.computed && (result = {value : value, computed : computed});                     // 293
	    });                                                                                                  // 294
	    return result.value;                                                                                 // 295
	  };                                                                                                     // 296
	                                                                                                         // 297
	  // Return the minimum element (or element-based computation).                                          // 298
	  _.min = function(obj, iterator, context) {                                                             // 299
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {                       // 300
	      return Math.min.apply(Math, obj);                                                                  // 301
	    }                                                                                                    // 302
	    if (!iterator && _.isEmpty(obj)) return Infinity;                                                    // 303
	    var result = {computed : Infinity, value: Infinity};                                                 // 304
	    each(obj, function(value, index, list) {                                                             // 305
	      var computed = iterator ? iterator.call(context, value, index, list) : value;                      // 306
	      computed < result.computed && (result = {value : value, computed : computed});                     // 307
	    });                                                                                                  // 308
	    return result.value;                                                                                 // 309
	  };                                                                                                     // 310
	                                                                                                         // 311
	  // Shuffle an array, using the modern version of the                                                   // 312
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).                          // 313
	  _.shuffle = function(obj) {                                                                            // 314
	    var rand;                                                                                            // 315
	    var index = 0;                                                                                       // 316
	    var shuffled = [];                                                                                   // 317
	    each(obj, function(value) {                                                                          // 318
	      rand = _.random(index++);                                                                          // 319
	      shuffled[index - 1] = shuffled[rand];                                                              // 320
	      shuffled[rand] = value;                                                                            // 321
	    });                                                                                                  // 322
	    return shuffled;                                                                                     // 323
	  };                                                                                                     // 324
	                                                                                                         // 325
	  // Sample **n** random values from an array.                                                           // 326
	  // If **n** is not specified, returns a single random element from the array.                          // 327
	  // The internal `guard` argument allows it to work with `map`.                                         // 328
	  _.sample = function(obj, n, guard) {                                                                   // 329
	    if (arguments.length < 2 || guard) {                                                                 // 330
	      return obj[_.random(obj.length - 1)];                                                              // 331
	    }                                                                                                    // 332
	    return _.shuffle(obj).slice(0, Math.max(0, n));                                                      // 333
	  };                                                                                                     // 334
	                                                                                                         // 335
	  // An internal function to generate lookup iterators.                                                  // 336
	  var lookupIterator = function(value) {                                                                 // 337
	    return _.isFunction(value) ? value : function(obj){ return obj[value]; };                            // 338
	  };                                                                                                     // 339
	                                                                                                         // 340
	  // Sort the object's values by a criterion produced by an iterator.                                    // 341
	  _.sortBy = function(obj, value, context) {                                                             // 342
	    var iterator = lookupIterator(value);                                                                // 343
	    return _.pluck(_.map(obj, function(value, index, list) {                                             // 344
	      return {                                                                                           // 345
	        value: value,                                                                                    // 346
	        index: index,                                                                                    // 347
	        criteria: iterator.call(context, value, index, list)                                             // 348
	      };                                                                                                 // 349
	    }).sort(function(left, right) {                                                                      // 350
	      var a = left.criteria;                                                                             // 351
	      var b = right.criteria;                                                                            // 352
	      if (a !== b) {                                                                                     // 353
	        if (a > b || a === void 0) return 1;                                                             // 354
	        if (a < b || b === void 0) return -1;                                                            // 355
	      }                                                                                                  // 356
	      return left.index - right.index;                                                                   // 357
	    }), 'value');                                                                                        // 358
	  };                                                                                                     // 359
	                                                                                                         // 360
	  // An internal function used for aggregate "group by" operations.                                      // 361
	  var group = function(behavior) {                                                                       // 362
	    return function(obj, value, context) {                                                               // 363
	      var result = {};                                                                                   // 364
	      var iterator = value == null ? _.identity : lookupIterator(value);                                 // 365
	      each(obj, function(value, index) {                                                                 // 366
	        var key = iterator.call(context, value, index, obj);                                             // 367
	        behavior(result, key, value);                                                                    // 368
	      });                                                                                                // 369
	      return result;                                                                                     // 370
	    };                                                                                                   // 371
	  };                                                                                                     // 372
	                                                                                                         // 373
	  // Groups the object's values by a criterion. Pass either a string attribute                           // 374
	  // to group by, or a function that returns the criterion.                                              // 375
	  _.groupBy = group(function(result, key, value) {                                                       // 376
	    (_.has(result, key) ? result[key] : (result[key] = [])).push(value);                                 // 377
	  });                                                                                                    // 378
	                                                                                                         // 379
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for                           // 380
	  // when you know that your index values will be unique.                                                // 381
	  _.indexBy = group(function(result, key, value) {                                                       // 382
	    result[key] = value;                                                                                 // 383
	  });                                                                                                    // 384
	                                                                                                         // 385
	  // Counts instances of an object that group by a certain criterion. Pass                               // 386
	  // either a string attribute to count by, or a function that returns the                               // 387
	  // criterion.                                                                                          // 388
	  _.countBy = group(function(result, key) {                                                              // 389
	    _.has(result, key) ? result[key]++ : result[key] = 1;                                                // 390
	  });                                                                                                    // 391
	                                                                                                         // 392
	  // Use a comparator function to figure out the smallest index at which                                 // 393
	  // an object should be inserted so as to maintain order. Uses binary search.                           // 394
	  _.sortedIndex = function(array, obj, iterator, context) {                                              // 395
	    iterator = iterator == null ? _.identity : lookupIterator(iterator);                                 // 396
	    var value = iterator.call(context, obj);                                                             // 397
	    var low = 0, high = array.length;                                                                    // 398
	    while (low < high) {                                                                                 // 399
	      var mid = (low + high) >>> 1;                                                                      // 400
	      iterator.call(context, array[mid]) < value ? low = mid + 1 : high = mid;                           // 401
	    }                                                                                                    // 402
	    return low;                                                                                          // 403
	  };                                                                                                     // 404
	                                                                                                         // 405
	  // Safely create a real, live array from anything iterable.                                            // 406
	  _.toArray = function(obj) {                                                                            // 407
	    if (!obj) return [];                                                                                 // 408
	    if (_.isArray(obj)) return slice.call(obj);                                                          // 409
	    if (looksLikeArray(obj)) return _.map(obj, _.identity);                                              // 410
	    return _.values(obj);                                                                                // 411
	  };                                                                                                     // 412
	                                                                                                         // 413
	  // Return the number of elements in an object.                                                         // 414
	  _.size = function(obj) {                                                                               // 415
	    if (obj == null) return 0;                                                                           // 416
	    return (looksLikeArray(obj)) ? obj.length : _.keys(obj).length;                                      // 417
	  };                                                                                                     // 418
	                                                                                                         // 419
	  // Array Functions                                                                                     // 420
	  // ---------------                                                                                     // 421
	                                                                                                         // 422
	  // Get the first element of an array. Passing **n** will return the first N                            // 423
	  // values in the array. Aliased as `head` and `take`. The **guard** check                              // 424
	  // allows it to work with `_.map`.                                                                     // 425
	  _.first = _.head = _.take = function(array, n, guard) {                                                // 426
	    if (array == null) return void 0;                                                                    // 427
	    return (n == null) || guard ? array[0] : slice.call(array, 0, n);                                    // 428
	  };                                                                                                     // 429
	                                                                                                         // 430
	  // Returns everything but the last entry of the array. Especially useful on                            // 431
	  // the arguments object. Passing **n** will return all the values in                                   // 432
	  // the array, excluding the last N. The **guard** check allows it to work with                         // 433
	  // `_.map`.                                                                                            // 434
	  _.initial = function(array, n, guard) {                                                                // 435
	    return slice.call(array, 0, array.length - ((n == null) || guard ? 1 : n));                          // 436
	  };                                                                                                     // 437
	                                                                                                         // 438
	  // Get the last element of an array. Passing **n** will return the last N                              // 439
	  // values in the array. The **guard** check allows it to work with `_.map`.                            // 440
	  _.last = function(array, n, guard) {                                                                   // 441
	    if (array == null) return void 0;                                                                    // 442
	    if ((n == null) || guard) {                                                                          // 443
	      return array[array.length - 1];                                                                    // 444
	    } else {                                                                                             // 445
	      return slice.call(array, Math.max(array.length - n, 0));                                           // 446
	    }                                                                                                    // 447
	  };                                                                                                     // 448
	                                                                                                         // 449
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.                  // 450
	  // Especially useful on the arguments object. Passing an **n** will return                             // 451
	  // the rest N values in the array. The **guard**                                                       // 452
	  // check allows it to work with `_.map`.                                                               // 453
	  _.rest = _.tail = _.drop = function(array, n, guard) {                                                 // 454
	    return slice.call(array, (n == null) || guard ? 1 : n);                                              // 455
	  };                                                                                                     // 456
	                                                                                                         // 457
	  // Trim out all falsy values from an array.                                                            // 458
	  _.compact = function(array) {                                                                          // 459
	    return _.filter(array, _.identity);                                                                  // 460
	  };                                                                                                     // 461
	                                                                                                         // 462
	  // Internal implementation of a recursive `flatten` function.                                          // 463
	  var flatten = function(input, shallow, output) {                                                       // 464
	    if (shallow && _.every(input, _.isArray)) {                                                          // 465
	      return concat.apply(output, input);                                                                // 466
	    }                                                                                                    // 467
	    each(input, function(value) {                                                                        // 468
	      if (_.isArray(value) || _.isArguments(value)) {                                                    // 469
	        shallow ? push.apply(output, value) : flatten(value, shallow, output);                           // 470
	      } else {                                                                                           // 471
	        output.push(value);                                                                              // 472
	      }                                                                                                  // 473
	    });                                                                                                  // 474
	    return output;                                                                                       // 475
	  };                                                                                                     // 476
	                                                                                                         // 477
	  // Flatten out an array, either recursively (by default), or just one level.                           // 478
	  _.flatten = function(array, shallow) {                                                                 // 479
	    return flatten(array, shallow, []);                                                                  // 480
	  };                                                                                                     // 481
	                                                                                                         // 482
	  // Return a version of the array that does not contain the specified value(s).                         // 483
	  _.without = function(array) {                                                                          // 484
	    return _.difference(array, slice.call(arguments, 1));                                                // 485
	  };                                                                                                     // 486
	                                                                                                         // 487
	  // Produce a duplicate-free version of the array. If the array has already                             // 488
	  // been sorted, you have the option of using a faster algorithm.                                       // 489
	  // Aliased as `unique`.                                                                                // 490
	  _.uniq = _.unique = function(array, isSorted, iterator, context) {                                     // 491
	    if (_.isFunction(isSorted)) {                                                                        // 492
	      context = iterator;                                                                                // 493
	      iterator = isSorted;                                                                               // 494
	      isSorted = false;                                                                                  // 495
	    }                                                                                                    // 496
	    var initial = iterator ? _.map(array, iterator, context) : array;                                    // 497
	    var results = [];                                                                                    // 498
	    var seen = [];                                                                                       // 499
	    each(initial, function(value, index) {                                                               // 500
	      if (isSorted ? (!index || seen[seen.length - 1] !== value) : !_.contains(seen, value)) {           // 501
	        seen.push(value);                                                                                // 502
	        results.push(array[index]);                                                                      // 503
	      }                                                                                                  // 504
	    });                                                                                                  // 505
	    return results;                                                                                      // 506
	  };                                                                                                     // 507
	                                                                                                         // 508
	  // Produce an array that contains the union: each distinct element from all of                         // 509
	  // the passed-in arrays.                                                                               // 510
	  _.union = function() {                                                                                 // 511
	    return _.uniq(_.flatten(arguments, true));                                                           // 512
	  };                                                                                                     // 513
	                                                                                                         // 514
	  // Produce an array that contains every item shared between all the                                    // 515
	  // passed-in arrays.                                                                                   // 516
	  _.intersection = function(array) {                                                                     // 517
	    var rest = slice.call(arguments, 1);                                                                 // 518
	    return _.filter(_.uniq(array), function(item) {                                                      // 519
	      return _.every(rest, function(other) {                                                             // 520
	        return _.indexOf(other, item) >= 0;                                                              // 521
	      });                                                                                                // 522
	    });                                                                                                  // 523
	  };                                                                                                     // 524
	                                                                                                         // 525
	  // Take the difference between one array and a number of other arrays.                                 // 526
	  // Only the elements present in just the first array will remain.                                      // 527
	  _.difference = function(array) {                                                                       // 528
	    var rest = concat.apply(ArrayProto, slice.call(arguments, 1));                                       // 529
	    return _.filter(array, function(value){ return !_.contains(rest, value); });                         // 530
	  };                                                                                                     // 531
	                                                                                                         // 532
	  // Zip together multiple lists into a single array -- elements that share                              // 533
	  // an index go together.                                                                               // 534
	  _.zip = function() {                                                                                   // 535
	    var length = _.max(_.pluck(arguments, "length").concat(0));                                          // 536
	    var results = new Array(length);                                                                     // 537
	    for (var i = 0; i < length; i++) {                                                                   // 538
	      results[i] = _.pluck(arguments, '' + i);                                                           // 539
	    }                                                                                                    // 540
	    return results;                                                                                      // 541
	  };                                                                                                     // 542
	                                                                                                         // 543
	  // Converts lists into objects. Pass either a single array of `[key, value]`                           // 544
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of                         // 545
	  // the corresponding values.                                                                           // 546
	  _.object = function(list, values) {                                                                    // 547
	    if (list == null) return {};                                                                         // 548
	    var result = {};                                                                                     // 549
	    for (var i = 0, length = list.length; i < length; i++) {                                             // 550
	      if (values) {                                                                                      // 551
	        result[list[i]] = values[i];                                                                     // 552
	      } else {                                                                                           // 553
	        result[list[i][0]] = list[i][1];                                                                 // 554
	      }                                                                                                  // 555
	    }                                                                                                    // 556
	    return result;                                                                                       // 557
	  };                                                                                                     // 558
	                                                                                                         // 559
	  // If the browser doesn't supply us with indexOf (I'm looking at you, **MSIE**),                       // 560
	  // we need this function. Return the position of the first occurrence of an                            // 561
	  // item in an array, or -1 if the item is not included in the array.                                   // 562
	  // Delegates to **ECMAScript 5**'s native `indexOf` if available.                                      // 563
	  // If the array is large and already in sort order, pass `true`                                        // 564
	  // for **isSorted** to use binary search.                                                              // 565
	  _.indexOf = function(array, item, isSorted) {                                                          // 566
	    if (array == null) return -1;                                                                        // 567
	    var i = 0, length = array.length;                                                                    // 568
	    if (isSorted) {                                                                                      // 569
	      if (typeof isSorted == 'number') {                                                                 // 570
	        i = (isSorted < 0 ? Math.max(0, length + isSorted) : isSorted);                                  // 571
	      } else {                                                                                           // 572
	        i = _.sortedIndex(array, item);                                                                  // 573
	        return array[i] === item ? i : -1;                                                               // 574
	      }                                                                                                  // 575
	    }                                                                                                    // 576
	    if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item, isSorted);          // 577
	    for (; i < length; i++) if (array[i] === item) return i;                                             // 578
	    return -1;                                                                                           // 579
	  };                                                                                                     // 580
	                                                                                                         // 581
	  // Delegates to **ECMAScript 5**'s native `lastIndexOf` if available.                                  // 582
	  _.lastIndexOf = function(array, item, from) {                                                          // 583
	    if (array == null) return -1;                                                                        // 584
	    var hasIndex = from != null;                                                                         // 585
	    if (nativeLastIndexOf && array.lastIndexOf === nativeLastIndexOf) {                                  // 586
	      return hasIndex ? array.lastIndexOf(item, from) : array.lastIndexOf(item);                         // 587
	    }                                                                                                    // 588
	    var i = (hasIndex ? from : array.length);                                                            // 589
	    while (i--) if (array[i] === item) return i;                                                         // 590
	    return -1;                                                                                           // 591
	  };                                                                                                     // 592
	                                                                                                         // 593
	  // Generate an integer Array containing an arithmetic progression. A port of                           // 594
	  // the native Python `range()` function. See                                                           // 595
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).                    // 596
	  _.range = function(start, stop, step) {                                                                // 597
	    if (arguments.length <= 1) {                                                                         // 598
	      stop = start || 0;                                                                                 // 599
	      start = 0;                                                                                         // 600
	    }                                                                                                    // 601
	    step = arguments[2] || 1;                                                                            // 602
	                                                                                                         // 603
	    var length = Math.max(Math.ceil((stop - start) / step), 0);                                          // 604
	    var idx = 0;                                                                                         // 605
	    var range = new Array(length);                                                                       // 606
	                                                                                                         // 607
	    while(idx < length) {                                                                                // 608
	      range[idx++] = start;                                                                              // 609
	      start += step;                                                                                     // 610
	    }                                                                                                    // 611
	                                                                                                         // 612
	    return range;                                                                                        // 613
	  };                                                                                                     // 614
	                                                                                                         // 615
	  // Function (ahem) Functions                                                                           // 616
	  // ------------------                                                                                  // 617
	                                                                                                         // 618
	  // Reusable constructor function for prototype setting.                                                // 619
	  var ctor = function(){};                                                                               // 620
	                                                                                                         // 621
	  // Create a function bound to a given object (assigning `this`, and arguments,                         // 622
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if                              // 623
	  // available.                                                                                          // 624
	  _.bind = function(func, context) {                                                                     // 625
	    var args, bound;                                                                                     // 626
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError;                                                        // 628
	    args = slice.call(arguments, 2);                                                                     // 629
	    return bound = function() {                                                                          // 630
	      if (!(this instanceof bound)) return func.apply(context, args.concat(slice.call(arguments)));      // 631
	      ctor.prototype = func.prototype;                                                                   // 632
	      var self = new ctor;                                                                               // 633
	      ctor.prototype = null;                                                                             // 634
	      var result = func.apply(self, args.concat(slice.call(arguments)));                                 // 635
	      if (Object(result) === result) return result;                                                      // 636
	      return self;                                                                                       // 637
	    };                                                                                                   // 638
	  };                                                                                                     // 639
	                                                                                                         // 640
	  // Partially apply a function by creating a version that has had some of its                           // 641
	  // arguments pre-filled, without changing its dynamic `this` context.                                  // 642
	  _.partial = function(func) {                                                                           // 643
	    var args = slice.call(arguments, 1);                                                                 // 644
	    return function() {                                                                                  // 645
	      return func.apply(this, args.concat(slice.call(arguments)));                                       // 646
	    };                                                                                                   // 647
	  };                                                                                                     // 648
	                                                                                                         // 649
	  // Bind all of an object's methods to that object. Useful for ensuring that                            // 650
	  // all callbacks defined on an object belong to it.                                                    // 651
	  _.bindAll = function(obj) {                                                                            // 652
	    var funcs = slice.call(arguments, 1);                                                                // 653
	    if (funcs.length === 0) throw new Error("bindAll must be passed function names");                    // 654
	    each(funcs, function(f) { obj[f] = _.bind(obj[f], obj); });                                          // 655
	    return obj;                                                                                          // 656
	  };                                                                                                     // 657
	                                                                                                         // 658
	  // Memoize an expensive function by storing its results.                                               // 659
	  _.memoize = function(func, hasher) {                                                                   // 660
	    var memo = {};                                                                                       // 661
	    hasher || (hasher = _.identity);                                                                     // 662
	    return function() {                                                                                  // 663
	      var key = hasher.apply(this, arguments);                                                           // 664
	      return _.has(memo, key) ? memo[key] : (memo[key] = func.apply(this, arguments));                   // 665
	    };                                                                                                   // 666
	  };                                                                                                     // 667
	                                                                                                         // 668
	  // Delays a function for the given number of milliseconds, and then calls                              // 669
	  // it with the arguments supplied.                                                                     // 670
	  _.delay = function(func, wait) {                                                                       // 671
	    var args = slice.call(arguments, 2);                                                                 // 672
	    return setTimeout(function(){ return func.apply(null, args); }, wait);                               // 673
	  };                                                                                                     // 674
	                                                                                                         // 675
	  // Defers a function, scheduling it to run after the current call stack has                            // 676
	  // cleared.                                                                                            // 677
	  _.defer = function(func) {                                                                             // 678
	    return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));                                 // 679
	  };                                                                                                     // 680
	                                                                                                         // 681
	  // Returns a function, that, when invoked, will only be triggered at most once                         // 682
	  // during a given window of time. Normally, the throttled function will run                            // 683
	  // as much as it can, without ever going more than once per `wait` duration;                           // 684
	  // but if you'd like to disable the execution on the leading edge, pass                                // 685
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.                               // 686
	  _.throttle = function(func, wait, options) {                                                           // 687
	    var context, args, result;                                                                           // 688
	    var timeout = null;                                                                                  // 689
	    var previous = 0;                                                                                    // 690
	    options || (options = {});                                                                           // 691
	    var later = function() {                                                                             // 692
	      previous = options.leading === false ? 0 : new Date;                                               // 693
	      timeout = null;                                                                                    // 694
	      result = func.apply(context, args);                                                                // 695
	    };                                                                                                   // 696
	    return function() {                                                                                  // 697
	      var now = new Date;                                                                                // 698
	      if (!previous && options.leading === false) previous = now;                                        // 699
	      var remaining = wait - (now - previous);                                                           // 700
	      context = this;                                                                                    // 701
	      args = arguments;                                                                                  // 702
	      if (remaining <= 0) {                                                                              // 703
	        clearTimeout(timeout);                                                                           // 704
	        timeout = null;                                                                                  // 705
	        previous = now;                                                                                  // 706
	        result = func.apply(context, args);                                                              // 707
	      } else if (!timeout && options.trailing !== false) {                                               // 708
	        timeout = setTimeout(later, remaining);                                                          // 709
	      }                                                                                                  // 710
	      return result;                                                                                     // 711
	    };                                                                                                   // 712
	  };                                                                                                     // 713
	                                                                                                         // 714
	  // Returns a function, that, as long as it continues to be invoked, will not                           // 715
	  // be triggered. The function will be called after it stops being called for                           // 716
	  // N milliseconds. If `immediate` is passed, trigger the function on the                               // 717
	  // leading edge, instead of the trailing.                                                              // 718
	  _.debounce = function(func, wait, immediate) {                                                         // 719
	    var timeout, args, context, timestamp, result;                                                       // 720
	    return function() {                                                                                  // 721
	      context = this;                                                                                    // 722
	      args = arguments;                                                                                  // 723
	      timestamp = new Date();                                                                            // 724
	      var later = function() {                                                                           // 725
	        var last = (new Date()) - timestamp;                                                             // 726
	        if (last < wait) {                                                                               // 727
	          timeout = setTimeout(later, wait - last);                                                      // 728
	        } else {                                                                                         // 729
	          timeout = null;                                                                                // 730
	          if (!immediate) result = func.apply(context, args);                                            // 731
	        }                                                                                                // 732
	      };                                                                                                 // 733
	      var callNow = immediate && !timeout;                                                               // 734
	      if (!timeout) {                                                                                    // 735
	        timeout = setTimeout(later, wait);                                                               // 736
	      }                                                                                                  // 737
	      if (callNow) result = func.apply(context, args);                                                   // 738
	      return result;                                                                                     // 739
	    };                                                                                                   // 740
	  };                                                                                                     // 741
	                                                                                                         // 742
	  // Returns a function that will be executed at most one time, no matter how                            // 743
	  // often you call it. Useful for lazy initialization.                                                  // 744
	  _.once = function(func) {                                                                              // 745
	    var ran = false, memo;                                                                               // 746
	    return function() {                                                                                  // 747
	      if (ran) return memo;                                                                              // 748
	      ran = true;                                                                                        // 749
	      memo = func.apply(this, arguments);                                                                // 750
	      func = null;                                                                                       // 751
	      return memo;                                                                                       // 752
	    };                                                                                                   // 753
	  };                                                                                                     // 754
	                                                                                                         // 755
	  // Returns the first function passed as an argument to the second,                                     // 756
	  // allowing you to adjust arguments, run code before and after, and                                    // 757
	  // conditionally execute the original function.                                                        // 758
	  _.wrap = function(func, wrapper) {                                                                     // 759
	    return function() {                                                                                  // 760
	      var args = [func];                                                                                 // 761
	      push.apply(args, arguments);                                                                       // 762
	      return wrapper.apply(this, args);                                                                  // 763
	    };                                                                                                   // 764
	  };                                                                                                     // 765
	                                                                                                         // 766
	  // Returns a function that is the composition of a list of functions, each                             // 767
	  // consuming the return value of the function that follows.                                            // 768
	  _.compose = function() {                                                                               // 769
	    var funcs = arguments;                                                                               // 770
	    return function() {                                                                                  // 771
	      var args = arguments;                                                                              // 772
	      for (var i = funcs.length - 1; i >= 0; i--) {                                                      // 773
	        args = [funcs[i].apply(this, args)];                                                             // 774
	      }                                                                                                  // 775
	      return args[0];                                                                                    // 776
	    };                                                                                                   // 777
	  };                                                                                                     // 778
	                                                                                                         // 779
	  // Returns a function that will only be executed after being called N times.                           // 780
	  _.after = function(times, func) {                                                                      // 781
	    return function() {                                                                                  // 782
	      if (--times < 1) {                                                                                 // 783
	        return func.apply(this, arguments);                                                              // 784
	      }                                                                                                  // 785
	    };                                                                                                   // 786
	  };                                                                                                     // 787
	                                                                                                         // 788
	  // Object Functions                                                                                    // 789
	  // ----------------                                                                                    // 790
	                                                                                                         // 791
	  // Retrieve the names of an object's properties.                                                       // 792
	  // Delegates to **ECMAScript 5**'s native `Object.keys`                                                // 793
	  _.keys = nativeKeys || function(obj) {                                                                 // 794
	    if (obj !== Object(obj)) throw new TypeError('Invalid object');                                      // 795
	    var keys = [];                                                                                       // 796
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);                                            // 797
	    return keys;                                                                                         // 798
	  };                                                                                                     // 799
	                                                                                                         // 800
	  // Retrieve the values of an object's properties.                                                      // 801
	  _.values = function(obj) {                                                                             // 802
	    var keys = _.keys(obj);                                                                              // 803
	    var length = keys.length;                                                                            // 804
	    var values = new Array(length);                                                                      // 805
	    for (var i = 0; i < length; i++) {                                                                   // 806
	      values[i] = obj[keys[i]];                                                                          // 807
	    }                                                                                                    // 808
	    return values;                                                                                       // 809
	  };                                                                                                     // 810
	                                                                                                         // 811
	  // Convert an object into a list of `[key, value]` pairs.                                              // 812
	  _.pairs = function(obj) {                                                                              // 813
	    var keys = _.keys(obj);                                                                              // 814
	    var length = keys.length;                                                                            // 815
	    var pairs = new Array(length);                                                                       // 816
	    for (var i = 0; i < length; i++) {                                                                   // 817
	      pairs[i] = [keys[i], obj[keys[i]]];                                                                // 818
	    }                                                                                                    // 819
	    return pairs;                                                                                        // 820
	  };                                                                                                     // 821
	                                                                                                         // 822
	  // Invert the keys and values of an object. The values must be serializable.                           // 823
	  _.invert = function(obj) {                                                                             // 824
	    var result = {};                                                                                     // 825
	    var keys = _.keys(obj);                                                                              // 826
	    for (var i = 0, length = keys.length; i < length; i++) {                                             // 827
	      result[obj[keys[i]]] = keys[i];                                                                    // 828
	    }                                                                                                    // 829
	    return result;                                                                                       // 830
	  };                                                                                                     // 831
	                                                                                                         // 832
	  // Return a sorted list of the function names available on the object.                                 // 833
	  // Aliased as `methods`                                                                                // 834
	  _.functions = _.methods = function(obj) {                                                              // 835
	    var names = [];                                                                                      // 836
	    for (var key in obj) {                                                                               // 837
	      if (_.isFunction(obj[key])) names.push(key);                                                       // 838
	    }                                                                                                    // 839
	    return names.sort();                                                                                 // 840
	  };                                                                                                     // 841
	                                                                                                         // 842
	  // Extend a given object with all the properties in passed-in object(s).                               // 843
	  _.extend = function(obj) {                                                                             // 844
	    each(slice.call(arguments, 1), function(source) {                                                    // 845
	      if (source) {                                                                                      // 846
	        for (var prop in source) {                                                                       // 847
	          obj[prop] = source[prop];                                                                      // 848
	        }                                                                                                // 849
	      }                                                                                                  // 850
	    });                                                                                                  // 851
	    return obj;                                                                                          // 852
	  };                                                                                                     // 853
	                                                                                                         // 854
	  // Return a copy of the object only containing the whitelisted properties.                             // 855
	  _.pick = function(obj) {                                                                               // 856
	    var copy = {};                                                                                       // 857
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));                                       // 858
	    each(keys, function(key) {                                                                           // 859
	      if (key in obj) copy[key] = obj[key];                                                              // 860
	    });                                                                                                  // 861
	    return copy;                                                                                         // 862
	  };                                                                                                     // 863
	                                                                                                         // 864
	   // Return a copy of the object without the blacklisted properties.                                    // 865
	  _.omit = function(obj) {                                                                               // 866
	    var copy = {};                                                                                       // 867
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));                                       // 868
	    for (var key in obj) {                                                                               // 869
	      if (!_.contains(keys, key)) copy[key] = obj[key];                                                  // 870
	    }                                                                                                    // 871
	    return copy;                                                                                         // 872
	  };                                                                                                     // 873
	                                                                                                         // 874
	  // Fill in a given object with default properties.                                                     // 875
	  _.defaults = function(obj) {                                                                           // 876
	    each(slice.call(arguments, 1), function(source) {                                                    // 877
	      if (source) {                                                                                      // 878
	        for (var prop in source) {                                                                       // 879
	          if (obj[prop] === void 0) obj[prop] = source[prop];                                            // 880
	        }                                                                                                // 881
	      }                                                                                                  // 882
	    });                                                                                                  // 883
	    return obj;                                                                                          // 884
	  };                                                                                                     // 885
	                                                                                                         // 886
	  // Create a (shallow-cloned) duplicate of an object.                                                   // 887
	  _.clone = function(obj) {                                                                              // 888
	    if (!_.isObject(obj)) return obj;                                                                    // 889
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);                                             // 890
	  };                                                                                                     // 891
	                                                                                                         // 892
	  // Invokes interceptor with the obj, and then returns obj.                                             // 893
	  // The primary purpose of this method is to "tap into" a method chain, in                              // 894
	  // order to perform operations on intermediate results within the chain.                               // 895
	  _.tap = function(obj, interceptor) {                                                                   // 896
	    interceptor(obj);                                                                                    // 897
	    return obj;                                                                                          // 898
	  };                                                                                                     // 899
	                                                                                                         // 900
	  // Internal recursive comparison function for `isEqual`.                                               // 901
	  var eq = function(a, b, aStack, bStack) {                                                              // 902
	    // Identical objects are equal. `0 === -0`, but they aren't identical.                               // 903
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).           // 904
	    if (a === b) return a !== 0 || 1 / a == 1 / b;                                                       // 905
	    // A strict comparison is necessary because `null == undefined`.                                     // 906
	    if (a == null || b == null) return a === b;                                                          // 907
	    // Unwrap any wrapped objects.                                                                       // 908
	    if (a instanceof _) a = a._wrapped;                                                                  // 909
	    if (b instanceof _) b = b._wrapped;                                                                  // 910
	    // Compare `[[Class]]` names.                                                                        // 911
	    var className = toString.call(a);                                                                    // 912
	    if (className != toString.call(b)) return false;                                                     // 913
	    switch (className) {                                                                                 // 914
	      // Strings, numbers, dates, and booleans are compared by value.                                    // 915
	      case '[object String]':                                                                            // 916
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is             // 917
	        // equivalent to `new String("5")`.                                                              // 918
	        return a == String(b);                                                                           // 919
	      case '[object Number]':                                                                            // 920
	        // `NaN`s are equivalent, but non-reflexive. An `egal` comparison is performed for               // 921
	        // other numeric values.                                                                         // 922
	        return a != +a ? b != +b : (a == 0 ? 1 / a == 1 / b : a == +b);                                  // 923
	      case '[object Date]':                                                                              // 924
	      case '[object Boolean]':                                                                           // 925
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their            // 926
	        // millisecond representations. Note that invalid dates with millisecond representations         // 927
	        // of `NaN` are not equivalent.                                                                  // 928
	        return +a == +b;                                                                                 // 929
	      // RegExps are compared by their source patterns and flags.                                        // 930
	      case '[object RegExp]':                                                                            // 931
	        return a.source == b.source &&                                                                   // 932
	               a.global == b.global &&                                                                   // 933
	               a.multiline == b.multiline &&                                                             // 934
	               a.ignoreCase == b.ignoreCase;                                                             // 935
	    }                                                                                                    // 936
	    if (typeof a != 'object' || typeof b != 'object') return false;                                      // 937
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic                         // 938
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.                       // 939
	    var length = aStack.length;                                                                          // 940
	    while (length--) {                                                                                   // 941
	      // Linear search. Performance is inversely proportional to the number of                           // 942
	      // unique nested structures.                                                                       // 943
	      if (aStack[length] == a) return bStack[length] == b;                                               // 944
	    }                                                                                                    // 945
	    // Objects with different constructors are not equivalent, but `Object`s                             // 946
	    // from different frames are.                                                                        // 947
	    var aCtor = a.constructor, bCtor = b.constructor;                                                    // 948
	    if (aCtor !== bCtor && !(_.isFunction(aCtor) && (aCtor instanceof aCtor) &&                          // 949
	                             _.isFunction(bCtor) && (bCtor instanceof bCtor))) {                         // 950
	      return false;                                                                                      // 951
	    }                                                                                                    // 952
	    // Add the first object to the stack of traversed objects.                                           // 953
	    aStack.push(a);                                                                                      // 954
	    bStack.push(b);                                                                                      // 955
	    var size = 0, result = true;                                                                         // 956
	    // Recursively compare objects and arrays.                                                           // 957
	    if (className == '[object Array]') {                                                                 // 958
	      // Compare array lengths to determine if a deep comparison is necessary.                           // 959
	      size = a.length;                                                                                   // 960
	      result = size == b.length;                                                                         // 961
	      if (result) {                                                                                      // 962
	        // Deep compare the contents, ignoring non-numeric properties.                                   // 963
	        while (size--) {                                                                                 // 964
	          if (!(result = eq(a[size], b[size], aStack, bStack))) break;                                   // 965
	        }                                                                                                // 966
	      }                                                                                                  // 967
	    } else {                                                                                             // 968
	      // Deep compare objects.                                                                           // 969
	      for (var key in a) {                                                                               // 970
	        if (_.has(a, key)) {                                                                             // 971
	          // Count the expected number of properties.                                                    // 972
	          size++;                                                                                        // 973
	          // Deep compare each member.                                                                   // 974
	          if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;                    // 975
	        }                                                                                                // 976
	      }                                                                                                  // 977
	      // Ensure that both objects contain the same number of properties.                                 // 978
	      if (result) {                                                                                      // 979
	        for (key in b) {                                                                                 // 980
	          if (_.has(b, key) && !(size--)) break;                                                         // 981
	        }                                                                                                // 982
	        result = !size;                                                                                  // 983
	      }                                                                                                  // 984
	    }                                                                                                    // 985
	    // Remove the first object from the stack of traversed objects.                                      // 986
	    aStack.pop();                                                                                        // 987
	    bStack.pop();                                                                                        // 988
	    return result;                                                                                       // 989
	  };                                                                                                     // 990
	                                                                                                         // 991
	  // Perform a deep comparison to check if two objects are equal.                                        // 992
	  _.isEqual = function(a, b) {                                                                           // 993
	    return eq(a, b, [], []);                                                                             // 994
	  };                                                                                                     // 995
	                                                                                                         // 996
	  // Is a given array, string, or object empty?                                                          // 997
	  // An "empty" object has no enumerable own-properties.                                                 // 998
	  _.isEmpty = function(obj) {                                                                            // 999
	    if (obj == null) return true;                                                                        // 1000
	    if (_.isArray(obj) || _.isString(obj)) return obj.length === 0;                                      // 1001
	    for (var key in obj) if (_.has(obj, key)) return false;                                              // 1002
	    return true;                                                                                         // 1003
	  };                                                                                                     // 1004
	                                                                                                         // 1005
	  // Is a given value a DOM element?                                                                     // 1006
	  _.isElement = function(obj) {                                                                          // 1007
	    return !!(obj && obj.nodeType === 1);                                                                // 1008
	  };                                                                                                     // 1009
	                                                                                                         // 1010
	  // Is a given value an array?                                                                          // 1011
	  // Delegates to ECMA5's native Array.isArray                                                           // 1012
	  _.isArray = nativeIsArray || function(obj) {                                                           // 1013
	    return toString.call(obj) == '[object Array]';                                                       // 1014
	  };                                                                                                     // 1015
	                                                                                                         // 1016
	  // Is a given variable an object?                                                                      // 1017
	  _.isObject = function(obj) {                                                                           // 1018
	    return obj === Object(obj);                                                                          // 1019
	  };                                                                                                     // 1020
	                                                                                                         // 1021
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.             // 1022
	  each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function(name) {                 // 1023
	    _['is' + name] = function(obj) {                                                                     // 1024
	      return toString.call(obj) == '[object ' + name + ']';                                              // 1025
	    };                                                                                                   // 1026
	  });                                                                                                    // 1027
	                                                                                                         // 1028
	  // Define a fallback version of the method in browsers (ahem, IE), where                               // 1029
	  // there isn't any inspectable "Arguments" type.                                                       // 1030
	  if (!_.isArguments(arguments)) {                                                                       // 1031
	    _.isArguments = function(obj) {                                                                      // 1032
	      return !!(obj && _.has(obj, 'callee'));                                                            // 1033
	    };                                                                                                   // 1034
	  }                                                                                                      // 1035
	                                                                                                         // 1036
	  // Optimize `isFunction` if appropriate.                                                               // 1037
	  if (true) {                                                                     // 1038
	    _.isFunction = function(obj) {                                                                       // 1039
	      return typeof obj === 'function';                                                                  // 1040
	    };                                                                                                   // 1041
	  }                                                                                                      // 1042
	                                                                                                         // 1043
	  // Is a given object a finite number?                                                                  // 1044
	  _.isFinite = function(obj) {                                                                           // 1045
	    return isFinite(obj) && !isNaN(parseFloat(obj));                                                     // 1046
	  };                                                                                                     // 1047
	                                                                                                         // 1048
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).                     // 1049
	  _.isNaN = function(obj) {                                                                              // 1050
	    return _.isNumber(obj) && obj != +obj;                                                               // 1051
	  };                                                                                                     // 1052
	                                                                                                         // 1053
	  // Is a given value a boolean?                                                                         // 1054
	  _.isBoolean = function(obj) {                                                                          // 1055
	    return obj === true || obj === false || toString.call(obj) == '[object Boolean]';                    // 1056
	  };                                                                                                     // 1057
	                                                                                                         // 1058
	  // Is a given value equal to null?                                                                     // 1059
	  _.isNull = function(obj) {                                                                             // 1060
	    return obj === null;                                                                                 // 1061
	  };                                                                                                     // 1062
	                                                                                                         // 1063
	  // Is a given variable undefined?                                                                      // 1064
	  _.isUndefined = function(obj) {                                                                        // 1065
	    return obj === void 0;                                                                               // 1066
	  };                                                                                                     // 1067
	                                                                                                         // 1068
	  // Shortcut function for checking if an object has a given property directly                           // 1069
	  // on itself (in other words, not on a prototype).                                                     // 1070
	  _.has = function(obj, key) {                                                                           // 1071
	    return hasOwnProperty.call(obj, key);                                                                // 1072
	  };                                                                                                     // 1073
	                                                                                                         // 1074
	  // Utility Functions                                                                                   // 1075
	  // -----------------                                                                                   // 1076
	                                                                                                         // 1077
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its                           // 1078
	  // previous owner. Returns a reference to the Underscore object.                                       // 1079
	  _.noConflict = function() {                                                                            // 1080
	    root._ = previousUnderscore;                                                                         // 1081
	    return this;                                                                                         // 1082
	  };                                                                                                     // 1083
	                                                                                                         // 1084
	  // Keep the identity function around for default iterators.                                            // 1085
	  _.identity = function(value) {                                                                         // 1086
	    return value;                                                                                        // 1087
	  };                                                                                                     // 1088
	                                                                                                         // 1089
	  // Run a function **n** times.                                                                         // 1090
	  _.times = function(n, iterator, context) {                                                             // 1091
	    var accum = Array(Math.max(0, n));                                                                   // 1092
	    for (var i = 0; i < n; i++) accum[i] = iterator.call(context, i);                                    // 1093
	    return accum;                                                                                        // 1094
	  };                                                                                                     // 1095
	                                                                                                         // 1096
	  // Return a random integer between min and max (inclusive).                                            // 1097
	  _.random = function(min, max) {                                                                        // 1098
	    if (max == null) {                                                                                   // 1099
	      max = min;                                                                                         // 1100
	      min = 0;                                                                                           // 1101
	    }                                                                                                    // 1102
	    return min + Math.floor(Math.random() * (max - min + 1));                                            // 1103
	  };                                                                                                     // 1104
	                                                                                                         // 1105
	  // List of HTML entities for escaping.                                                                 // 1106
	  var entityMap = {                                                                                      // 1107
	    escape: {                                                                                            // 1108
	      '&': '&amp;',                                                                                      // 1109
	      '<': '&lt;',                                                                                       // 1110
	      '>': '&gt;',                                                                                       // 1111
	      '"': '&quot;',                                                                                     // 1112
	      "'": '&#x27;'                                                                                      // 1113
	    }                                                                                                    // 1114
	  };                                                                                                     // 1115
	  entityMap.unescape = _.invert(entityMap.escape);                                                       // 1116
	                                                                                                         // 1117
	  // Regexes containing the keys and values listed immediately above.                                    // 1118
	  var entityRegexes = {                                                                                  // 1119
	    escape:   new RegExp('[' + _.keys(entityMap.escape).join('') + ']', 'g'),                            // 1120
	    unescape: new RegExp('(' + _.keys(entityMap.unescape).join('|') + ')', 'g')                          // 1121
	  };                                                                                                     // 1122
	                                                                                                         // 1123
	  // Functions for escaping and unescaping strings to/from HTML interpolation.                           // 1124
	  _.each(['escape', 'unescape'], function(method) {                                                      // 1125
	    _[method] = function(string) {                                                                       // 1126
	      if (string == null) return '';                                                                     // 1127
	      return ('' + string).replace(entityRegexes[method], function(match) {                              // 1128
	        return entityMap[method][match];                                                                 // 1129
	      });                                                                                                // 1130
	    };                                                                                                   // 1131
	  });                                                                                                    // 1132
	                                                                                                         // 1133
	  // If the value of the named `property` is a function then invoke it with the                          // 1134
	  // `object` as context; otherwise, return it.                                                          // 1135
	  _.result = function(object, property) {                                                                // 1136
	    if (object == null) return void 0;                                                                   // 1137
	    var value = object[property];                                                                        // 1138
	    return _.isFunction(value) ? value.call(object) : value;                                             // 1139
	  };                                                                                                     // 1140
	                                                                                                         // 1141
	  // Add your own custom functions to the Underscore object.                                             // 1142
	  _.mixin = function(obj) {                                                                              // 1143
	    each(_.functions(obj), function(name) {                                                              // 1144
	      var func = _[name] = obj[name];                                                                    // 1145
	      _.prototype[name] = function() {                                                                   // 1146
	        var args = [this._wrapped];                                                                      // 1147
	        push.apply(args, arguments);                                                                     // 1148
	        return result.call(this, func.apply(_, args));                                                   // 1149
	      };                                                                                                 // 1150
	    });                                                                                                  // 1151
	  };                                                                                                     // 1152
	                                                                                                         // 1153
	  // Generate a unique integer id (unique within the entire client session).                             // 1154
	  // Useful for temporary DOM ids.                                                                       // 1155
	  var idCounter = 0;                                                                                     // 1156
	  _.uniqueId = function(prefix) {                                                                        // 1157
	    var id = ++idCounter + '';                                                                           // 1158
	    return prefix ? prefix + id : id;                                                                    // 1159
	  };                                                                                                     // 1160
	                                                                                                         // 1161
	  // By default, Underscore uses ERB-style template delimiters, change the                               // 1162
	  // following template settings to use alternative delimiters.                                          // 1163
	  _.templateSettings = {                                                                                 // 1164
	    evaluate    : /<%([\s\S]+?)%>/g,                                                                     // 1165
	    interpolate : /<%=([\s\S]+?)%>/g,                                                                    // 1166
	    escape      : /<%-([\s\S]+?)%>/g                                                                     // 1167
	  };                                                                                                     // 1168
	                                                                                                         // 1169
	  // When customizing `templateSettings`, if you don't want to define an                                 // 1170
	  // interpolation, evaluation or escaping regex, we need one that is                                    // 1171
	  // guaranteed not to match.                                                                            // 1172
	  var noMatch = /(.)^/;                                                                                  // 1173
	                                                                                                         // 1174
	  // Certain characters need to be escaped so that they can be put into a                                // 1175
	  // string literal.                                                                                     // 1176
	  var escapes = {                                                                                        // 1177
	    "'":      "'",                                                                                       // 1178
	    '\\':     '\\',                                                                                      // 1179
	    '\r':     'r',                                                                                       // 1180
	    '\n':     'n',                                                                                       // 1181
	    '\t':     't',                                                                                       // 1182
	    '\u2028': 'u2028',                                                                                   // 1183
	    '\u2029': 'u2029'                                                                                    // 1184
	  };                                                                                                     // 1185
	                                                                                                         // 1186
	  var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;                                                          // 1187
	                                                                                                         // 1188
	  // JavaScript micro-templating, similar to John Resig's implementation.                                // 1189
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,                           // 1190
	  // and correctly escapes quotes within interpolated code.                                              // 1191
	  _.template = function(text, data, settings) {                                                          // 1192
	    var render;                                                                                          // 1193
	    settings = _.defaults({}, settings, _.templateSettings);                                             // 1194
	                                                                                                         // 1195
	    // Combine delimiters into one regular expression via alternation.                                   // 1196
	    var matcher = new RegExp([                                                                           // 1197
	      (settings.escape || noMatch).source,                                                               // 1198
	      (settings.interpolate || noMatch).source,                                                          // 1199
	      (settings.evaluate || noMatch).source                                                              // 1200
	    ].join('|') + '|$', 'g');                                                                            // 1201
	                                                                                                         // 1202
	    // Compile the template source, escaping string literals appropriately.                              // 1203
	    var index = 0;                                                                                       // 1204
	    var source = "__p+='";                                                                               // 1205
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {                       // 1206
	      source += text.slice(index, offset)                                                                // 1207
	        .replace(escaper, function(match) { return '\\' + escapes[match]; });                            // 1208
	                                                                                                         // 1209
	      if (escape) {                                                                                      // 1210
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";                             // 1211
	      }                                                                                                  // 1212
	      if (interpolate) {                                                                                 // 1213
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";                                  // 1214
	      }                                                                                                  // 1215
	      if (evaluate) {                                                                                    // 1216
	        source += "';\n" + evaluate + "\n__p+='";                                                        // 1217
	      }                                                                                                  // 1218
	      index = offset + match.length;                                                                     // 1219
	      return match;                                                                                      // 1220
	    });                                                                                                  // 1221
	    source += "';\n";                                                                                    // 1222
	                                                                                                         // 1223
	    // If a variable is not specified, place data values in local scope.                                 // 1224
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';                                // 1225
	                                                                                                         // 1226
	    source = "var __t,__p='',__j=Array.prototype.join," +                                                // 1227
	      "print=function(){__p+=__j.call(arguments,'');};\n" +                                              // 1228
	      source + "return __p;\n";                                                                          // 1229
	                                                                                                         // 1230
	    try {                                                                                                // 1231
	      render = new Function(settings.variable || 'obj', '_', source);                                    // 1232
	    } catch (e) {                                                                                        // 1233
	      e.source = source;                                                                                 // 1234
	      throw e;                                                                                           // 1235
	    }                                                                                                    // 1236
	                                                                                                         // 1237
	    if (data) return render(data, _);                                                                    // 1238
	    var template = function(data) {                                                                      // 1239
	      return render.call(this, data, _);                                                                 // 1240
	    };                                                                                                   // 1241
	                                                                                                         // 1242
	    // Provide the compiled function source as a convenience for precompilation.                         // 1243
	    template.source = 'function(' + (settings.variable || 'obj') + '){\n' + source + '}';                // 1244
	                                                                                                         // 1245
	    return template;                                                                                     // 1246
	  };                                                                                                     // 1247
	                                                                                                         // 1248
	  // Add a "chain" function, which will delegate to the wrapper.                                         // 1249
	  _.chain = function(obj) {                                                                              // 1250
	    return _(obj).chain();                                                                               // 1251
	  };                                                                                                     // 1252
	                                                                                                         // 1253
	  // OOP                                                                                                 // 1254
	  // ---------------                                                                                     // 1255
	  // If Underscore is called as a function, it returns a wrapped object that                             // 1256
	  // can be used OO-style. This wrapper holds altered versions of all the                                // 1257
	  // underscore functions. Wrapped objects may be chained.                                               // 1258
	                                                                                                         // 1259
	  // Helper function to continue chaining intermediate results.                                          // 1260
	  var result = function(obj) {                                                                           // 1261
	    return this._chain ? _(obj).chain() : obj;                                                           // 1262
	  };                                                                                                     // 1263
	                                                                                                         // 1264
	  // Add all of the Underscore functions to the wrapper object.                                          // 1265
	  _.mixin(_);                                                                                            // 1266
	                                                                                                         // 1267
	  // Add all mutator Array functions to the wrapper.                                                     // 1268
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {                // 1269
	    var method = ArrayProto[name];                                                                       // 1270
	    _.prototype[name] = function() {                                                                     // 1271
	      var obj = this._wrapped;                                                                           // 1272
	      method.apply(obj, arguments);                                                                      // 1273
	      if ((name == 'shift' || name == 'splice') && obj.length === 0) delete obj[0];                      // 1274
	      return result.call(this, obj);                                                                     // 1275
	    };                                                                                                   // 1276
	  });                                                                                                    // 1277
	                                                                                                         // 1278
	  // Add all accessor Array functions to the wrapper.                                                    // 1279
	  each(['concat', 'join', 'slice'], function(name) {                                                     // 1280
	    var method = ArrayProto[name];                                                                       // 1281
	    _.prototype[name] = function() {                                                                     // 1282
	      return result.call(this, method.apply(this._wrapped, arguments));                                  // 1283
	    };                                                                                                   // 1284
	  });                                                                                                    // 1285
	                                                                                                         // 1286
	  _.extend(_.prototype, {                                                                                // 1287
	                                                                                                         // 1288
	    // Start chaining a wrapped Underscore object.                                                       // 1289
	    chain: function() {                                                                                  // 1290
	      this._chain = true;                                                                                // 1291
	      return this;                                                                                       // 1292
	    },                                                                                                   // 1293
	                                                                                                         // 1294
	    // Extracts the result from a wrapped and chained object.                                            // 1295
	    value: function() {                                                                                  // 1296
	      return this._wrapped;                                                                              // 1297
	    }                                                                                                    // 1298
	                                                                                                         // 1299
	  });                                                                                                    // 1300
	                                                                                                         // 1301
	}).call(this);                                                                                           // 1302
	                                                                                                         // 1303
	///////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////////
	//                                                                                                       //
	// packages/underscore/post.js                                                                           //
	//                                                                                                       //
	///////////////////////////////////////////////////////////////////////////////////////////////////////////
	                                                                                                         //
	// This exports object was created in pre.js.  Now copy the `_` object from it                           // 1
	// into the package-scope variable `_`, which will get exported.                                         // 2
	_ = exports._;                                                                                           // 3
	                                                                                                         // 4
	///////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.underscore = {}, {
	  _: _
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/url.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	
	/* Package-scope variables */
	var URL, buildUrl;
	
	(function(){
	
	/////////////////////////////////////////////////////////////////////////////////////
	//                                                                                 //
	// packages/url/url_common.js                                                      //
	//                                                                                 //
	/////////////////////////////////////////////////////////////////////////////////////
	                                                                                   //
	URL = {};                                                                          // 1
	                                                                                   // 2
	var encodeString = function(str) {                                                 // 3
	  return encodeURIComponent(str).replace(/[!'()]/g, escape).replace(/\*/g, "%2A");
	};                                                                                 // 5
	                                                                                   // 6
	                                                                                   // 7
	URL._encodeParams = function(params) {                                             // 8
	  var buf = [];                                                                    // 9
	  _.each(params, function(value, key) {                                            // 10
	    if (buf.length)                                                                // 11
	      buf.push('&');                                                               // 12
	    buf.push(encodeString(key), '=', encodeString(value));                         // 13
	  });                                                                              // 14
	  return buf.join('').replace(/%20/g, '+');                                        // 15
	};                                                                                 // 16
	                                                                                   // 17
	                                                                                   // 18
	buildUrl = function(before_qmark, from_qmark, opt_query, opt_params) {             // 19
	  var url_without_query = before_qmark;                                            // 20
	  var query = from_qmark ? from_qmark.slice(1) : null;                             // 21
	                                                                                   // 22
	  if (typeof opt_query === "string")                                               // 23
	    query = String(opt_query);                                                     // 24
	                                                                                   // 25
	  if (opt_params) {                                                                // 26
	    query = query || "";                                                           // 27
	    var prms = URL._encodeParams(opt_params);                                      // 28
	    if (query && prms)                                                             // 29
	      query += '&';                                                                // 30
	    query += prms;                                                                 // 31
	  }                                                                                // 32
	                                                                                   // 33
	  var url = url_without_query;                                                     // 34
	  if (query !== null)                                                              // 35
	    url += ("?"+query);                                                            // 36
	                                                                                   // 37
	  return url;                                                                      // 38
	};                                                                                 // 39
	                                                                                   // 40
	/////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	
	
	
	
	(function(){
	
	/////////////////////////////////////////////////////////////////////////////////////
	//                                                                                 //
	// packages/url/url_client.js                                                      //
	//                                                                                 //
	/////////////////////////////////////////////////////////////////////////////////////
	                                                                                   //
	URL._constructUrl = function (url, query, params) {                                // 1
	  var query_match = /^(.*?)(\?.*)?$/.exec(url);                                    // 2
	  return buildUrl(query_match[1], query_match[2], query, params);                  // 3
	};                                                                                 // 4
	                                                                                   // 5
	/////////////////////////////////////////////////////////////////////////////////////
	
	}).call(this);
	
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.url = {}, {
	  URL: URL
	});
	
	})();


/***/ },

/***/ "./build/meteor/bundle/programs/web.browser/packages/webapp.js":
/***/ function(module, exports) {

	//////////////////////////////////////////////////////////////////////////
	//                                                                      //
	// This is a generated file. You can view the original                  //
	// source in your browser if your browser supports source maps.         //
	// Source maps are supported by all recent versions of Chrome, Safari,  //
	// and Firefox, and by Internet Explorer 11.                            //
	//                                                                      //
	//////////////////////////////////////////////////////////////////////////
	
	
	(function () {
	
	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var _ = Package.underscore._;
	var meteorInstall = Package.modules.meteorInstall;
	var Buffer = Package.modules.Buffer;
	var process = Package.modules.process;
	var Symbol = Package['ecmascript-runtime'].Symbol;
	var Map = Package['ecmascript-runtime'].Map;
	var Set = Package['ecmascript-runtime'].Set;
	var meteorBabelHelpers = Package['babel-runtime'].meteorBabelHelpers;
	var Promise = Package.promise.Promise;
	
	/* Package-scope variables */
	var WebApp;
	
	var require = meteorInstall({"node_modules":{"meteor":{"webapp":{"webapp_client.js":function(){
	
	////////////////////////////////////////////////////////////////////////
	//                                                                    //
	// packages/webapp/webapp_client.js                                   //
	//                                                                    //
	////////////////////////////////////////////////////////////////////////
	                                                                      //
	WebApp = {                                                            // 1
	                                                                      //
	  _isCssLoaded: function () {                                         // 3
	    function _isCssLoaded() {                                         // 3
	      if (document.styleSheets.length === 0) return true;             // 4
	                                                                      //
	      return _.find(document.styleSheets, function (sheet) {          // 7
	        if (sheet.cssText && !sheet.cssRules) // IE8                  // 8
	          return !sheet.cssText.match(/meteor-css-not-found-error/);  // 9
	        return !_.find(sheet.cssRules, function (rule) {              // 10
	          return rule.selectorText === '.meteor-css-not-found-error';
	        });                                                           // 12
	      });                                                             // 13
	    }                                                                 // 14
	                                                                      //
	    return _isCssLoaded;                                              // 3
	  }()                                                                 // 3
	};                                                                    // 1
	////////////////////////////////////////////////////////////////////////
	
	}}}}},{"extensions":[".js",".json"]});
	require("./node_modules/meteor/webapp/webapp_client.js");
	
	/* Exports */
	if (typeof Package === 'undefined') Package = {};
	(function (pkg, symbols) {
	  for (var s in symbols)
	    (s in pkg) || (pkg[s] = symbols[s]);
	})(Package.webapp = {}, {
	  WebApp: WebApp
	});
	
	})();


/***/ },

/***/ "./src/universal/collections/simpleSchema.config.js":
/***/ function(module, exports) {

	'use strict';
	
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var Match = Package.check.Match;
	
	
	SimpleSchema.extendOptions({
		hide: Match.Optional(Boolean),
		uniforms: Match.Optional(Match.OneOf(String, Function, Match.ObjectIncluding({
			component: Match.Optional(Match.OneOf(String, Function))
		})))
	});
	
	SimpleSchema.messages({
		required: 'Le champ "[label]" est requis',
		minString: "[label] doit faire au moins [min] caractères",
		maxString: "[label] ne peut pas faire plus de [max] caractères",
		minNumber: "[label] doit être supérieur ou égal à [min]",
		maxNumber: "[label] doit être inférieur ou égal [max]",
		minDate: "[label] doit être après [min]",
		maxDate: "[label] ne peut pas être après [max]",
		badDate: "[label] n'est pas une date valide",
		minCount: "Le nombre de [label] doit être au moins de [minCount]",
		maxCount: "Le nombre de [label] doit être au plus de [maxCount]",
		noDecimal: "[label] doit être un nombre entier",
		notAllowed: "[value] n'est pas une valeur autorisée",
		expectedString: "[label] doit être du texte",
		expectedNumber: "[label] doit être un nombre",
		expectedBoolean: "[label] doit être un booléen",
		expectedArray: "[label] doit être un tableau de valeur",
		expectedObject: "[label] doit être un objet",
		expectedConstructor: "[label] doit être de type [type]",
		regEx: [{ msg: "[label] failed regular expression validation" }, { exp: SimpleSchema.RegEx.Email, msg: "[label] must be a valid e-mail address" }, { exp: SimpleSchema.RegEx.WeakEmail, msg: "[label] must be a valid e-mail address" }, { exp: SimpleSchema.RegEx.Domain, msg: "[label] must be a valid domain" }, { exp: SimpleSchema.RegEx.WeakDomain, msg: "[label] must be a valid domain" }, { exp: SimpleSchema.RegEx.IP, msg: "[label] must be a valid IPv4 or IPv6 address" }, { exp: SimpleSchema.RegEx.IPv4, msg: "[label] must be a valid IPv4 address" }, { exp: SimpleSchema.RegEx.IPv6, msg: "[label] must be a valid IPv6 address" }, { exp: SimpleSchema.RegEx.Url, msg: "[label] must be a valid URL" }, { exp: SimpleSchema.RegEx.Id, msg: "[label] must be a valid alphanumeric ID" }],
		keyNotInSchema: "[key] ne peut pas être renseigné"
	});

/***/ },

/***/ "./node_modules/react-hot-loader/index.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__("./node_modules/react-hot-loader/lib/index.js")


/***/ },

/***/ "./node_modules/react-hot-loader/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable global-require */
	
	if (true) {
	  module.exports = __webpack_require__("./node_modules/react-hot-loader/lib/index.prod.js");
	} else {
	  module.exports = require('./index.dev');
	}

/***/ },

/***/ "./node_modules/react-hot-loader/lib/index.prod.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports.AppContainer = __webpack_require__("./node_modules/react-hot-loader/lib/AppContainer.js");

/***/ },

/***/ "./node_modules/react-hot-loader/lib/AppContainer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable global-require */
	
	if (true) {
	  module.exports = __webpack_require__("./node_modules/react-hot-loader/lib/AppContainer.prod.js");
	} else {
	  module.exports = require('./AppContainer.dev');
	}

/***/ },

/***/ "./node_modules/react-hot-loader/lib/AppContainer.prod.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable react/prop-types */
	
	var React = __webpack_require__("./node_modules/react/react.js");
	
	var Component = React.Component;
	
	var AppContainer = function (_Component) {
	  _inherits(AppContainer, _Component);
	
	  function AppContainer() {
	    _classCallCheck(this, AppContainer);
	
	    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
	  }
	
	  _createClass(AppContainer, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.component) {
	        return React.createElement(this.props.component, this.props.props);
	      }
	
	      return React.Children.only(this.props.children);
	    }
	  }]);
	
	  return AppContainer;
	}(Component);
	
	module.exports = AppContainer;

/***/ },

/***/ "./node_modules/immutable/dist/immutable.js":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },

/***/ "./src/client/makeStore.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _immutable = __webpack_require__("./node_modules/immutable/dist/immutable.js");
	
	var _reactRouterRedux = __webpack_require__("./node_modules/react-router-redux/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _makeReducer = __webpack_require__("./src/universal/redux/makeReducer.js");
	
	var _makeReducer2 = _interopRequireDefault(_makeReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (initialState) {
	  var store = void 0;
	  var reducer = (0, _makeReducer2.default)();
	  var reduxRouterMiddleware = (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory);
	  var middlewares = [reduxRouterMiddleware];
	
	  if (true) {
	    store = (0, _redux.createStore)(reducer, initialState, _redux.applyMiddleware.apply(undefined, middlewares));
	  } else {
	    var devtoolsExt = global.devToolsExtension && global.devToolsExtension();
	    if (!devtoolsExt) {
	      // We don't have the Redux extension in the browser, show the Redux logger
	      var createLogger = require('redux-logger');
	      var logger = createLogger({
	        level: 'info',
	        collapsed: true
	      });
	      middlewares.push(logger);
	    }
	    store = (0, _redux.createStore)(reducer, initialState, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middlewares), devtoolsExt || function (f) {
	      return f;
	    }));
	  }
	  return store;
	};

/***/ },

/***/ "./node_modules/redux/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__("./node_modules/redux/lib/createStore.js");
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__("./node_modules/redux/lib/combineReducers.js");
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__("./node_modules/redux/lib/bindActionCreators.js");
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__("./node_modules/redux/lib/applyMiddleware.js");
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__("./node_modules/redux/lib/compose.js");
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__("./node_modules/redux/lib/utils/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },

/***/ "./node_modules/redux/lib/createStore.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__("./node_modules/lodash/isPlainObject.js");
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__("./node_modules/symbol-observable/lib/index.js");
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },

/***/ "./node_modules/lodash/isPlainObject.js":
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    getPrototype = __webpack_require__("./node_modules/lodash/_getPrototype.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },

/***/ "./node_modules/lodash/_baseGetTag.js":
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
	    getRawTag = __webpack_require__("./node_modules/lodash/_getRawTag.js"),
	    objectToString = __webpack_require__("./node_modules/lodash/_objectToString.js");
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },

/***/ "./node_modules/lodash/_Symbol.js":
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },

/***/ "./node_modules/lodash/_root.js":
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__("./node_modules/lodash/_freeGlobal.js");
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },

/***/ "./node_modules/lodash/_freeGlobal.js":
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "./node_modules/lodash/_getRawTag.js":
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },

/***/ "./node_modules/lodash/_objectToString.js":
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },

/***/ "./node_modules/lodash/_getPrototype.js":
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__("./node_modules/lodash/_overArg.js");
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },

/***/ "./node_modules/lodash/_overArg.js":
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },

/***/ "./node_modules/lodash/isObjectLike.js":
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },

/***/ "./node_modules/symbol-observable/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__("./node_modules/symbol-observable/lib/ponyfill.js");
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ },

/***/ "./node_modules/webpack/buildin/module.js":
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },

/***/ "./node_modules/symbol-observable/lib/ponyfill.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },

/***/ "./node_modules/redux/lib/combineReducers.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__("./node_modules/redux/lib/createStore.js");
	
	var _isPlainObject = __webpack_require__("./node_modules/lodash/isPlainObject.js");
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__("./node_modules/redux/lib/utils/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },

/***/ "./node_modules/redux/lib/utils/warning.js":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },

/***/ "./node_modules/redux/lib/bindActionCreators.js":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },

/***/ "./node_modules/redux/lib/applyMiddleware.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__("./node_modules/redux/lib/compose.js");
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },

/***/ "./node_modules/redux/lib/compose.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },

/***/ "./node_modules/react-router-redux/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__("./node_modules/react-router-redux/lib/reducer.js");
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__("./node_modules/react-router-redux/lib/actions.js");
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__("./node_modules/react-router-redux/lib/sync.js");
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__("./node_modules/react-router-redux/lib/middleware.js");
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ },

/***/ "./node_modules/react-router-redux/lib/reducer.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ },

/***/ "./node_modules/react-router-redux/lib/actions.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ },

/***/ "./node_modules/react-router-redux/lib/sync.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__("./node_modules/react-router-redux/lib/reducer.js");
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // support history 3.x
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      listener(lastPublishedLocation);
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ },

/***/ "./node_modules/react-router-redux/lib/middleware.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__("./node_modules/react-router-redux/lib/actions.js");
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ },

/***/ "./node_modules/react-router/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__("./node_modules/react-router/lib/RouteUtils.js");
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__("./node_modules/react-router/lib/PropTypes.js");
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__("./node_modules/react-router/lib/PatternUtils.js");
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__("./node_modules/react-router/lib/Router.js");
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__("./node_modules/react-router/lib/Link.js");
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__("./node_modules/react-router/lib/IndexLink.js");
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__("./node_modules/react-router/lib/withRouter.js");
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__("./node_modules/react-router/lib/IndexRedirect.js");
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__("./node_modules/react-router/lib/IndexRoute.js");
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__("./node_modules/react-router/lib/Redirect.js");
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__("./node_modules/react-router/lib/Route.js");
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__("./node_modules/react-router/lib/RouterContext.js");
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__("./node_modules/react-router/lib/match.js");
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__("./node_modules/react-router/lib/useRouterHistory.js");
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__("./node_modules/react-router/lib/applyRouterMiddleware.js");
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__("./node_modules/react-router/lib/browserHistory.js");
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__("./node_modules/react-router/lib/hashHistory.js");
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__("./node_modules/react-router/lib/createMemoryHistory.js");
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },

/***/ "./node_modules/react-router/lib/RouteUtils.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },

/***/ "./node_modules/react-router/lib/PropTypes.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ },

/***/ "./node_modules/prop-types/index.js":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__("./node_modules/prop-types/factoryWithThrowingShims.js")();
	}


/***/ },

/***/ "./node_modules/prop-types/factoryWithThrowingShims.js":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__("./node_modules/prop-types/lib/ReactPropTypesSecret.js");
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },

/***/ "./node_modules/react-router/lib/PatternUtils.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },

/***/ "./node_modules/invariant/browser.js":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },

/***/ "./node_modules/react-router/lib/Router.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__("./node_modules/create-react-class/index.js");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _createTransitionManager2 = __webpack_require__("./node_modules/react-router/lib/createTransitionManager.js");
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__("./node_modules/react-router/lib/InternalPropTypes.js");
	
	var _RouterContext = __webpack_require__("./node_modules/react-router/lib/RouterContext.js");
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__("./node_modules/react-router/lib/RouteUtils.js");
	
	var _RouterUtils = __webpack_require__("./node_modules/react-router/lib/RouterUtils.js");
	
	var _routerWarning = __webpack_require__("./node_modules/react-router/lib/routerWarning.js");
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	
	  /**
	   * A <Router> is a high-level API for automatically setting up
	   * a router that renders a <RouterContext> with all the props
	   * it needs each time the URL changes.
	   */
	};var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/create-react-class/index.js":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__("./node_modules/react/react.js");
	var factory = __webpack_require__("./node_modules/create-react-class/factory.js");
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },

/***/ "./node_modules/react-router/lib/createTransitionManager.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__("./node_modules/react-router/lib/routerWarning.js");
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__("./node_modules/react-router/lib/computeChangedRoutes.js");
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__("./node_modules/react-router/lib/TransitionUtils.js");
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__("./node_modules/react-router/lib/isActive.js");
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__("./node_modules/react-router/lib/getComponents.js");
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__("./node_modules/react-router/lib/matchRoutes.js");
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-router/lib/routerWarning.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },

/***/ "./node_modules/warning/browser.js":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },

/***/ "./node_modules/react-router/lib/computeChangedRoutes.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__("./node_modules/react-router/lib/PatternUtils.js");
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-router/lib/TransitionUtils.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__("./node_modules/react-router/lib/AsyncUtils.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-router/lib/AsyncUtils.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },

/***/ "./node_modules/react-router/lib/isActive.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__("./node_modules/react-router/lib/PatternUtils.js");
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-router/lib/getComponents.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__("./node_modules/react-router/lib/AsyncUtils.js");
	
	var _PromiseUtils = __webpack_require__("./node_modules/react-router/lib/PromiseUtils.js");
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-router/lib/PromiseUtils.js":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },

/***/ "./node_modules/react-router/lib/matchRoutes.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__("./node_modules/react-router/lib/AsyncUtils.js");
	
	var _PromiseUtils = __webpack_require__("./node_modules/react-router/lib/PromiseUtils.js");
	
	var _PatternUtils = __webpack_require__("./node_modules/react-router/lib/PatternUtils.js");
	
	var _routerWarning = __webpack_require__("./node_modules/react-router/lib/routerWarning.js");
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__("./node_modules/react-router/lib/RouteUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-router/lib/InternalPropTypes.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]);
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ },

/***/ "./node_modules/react-router/lib/RouterContext.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__("./node_modules/create-react-class/index.js");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _getRouteParams = __webpack_require__("./node_modules/react-router/lib/getRouteParams.js");
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__("./node_modules/react-router/lib/ContextUtils.js");
	
	var _RouteUtils = __webpack_require__("./node_modules/react-router/lib/RouteUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-router/lib/getRouteParams.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__("./node_modules/react-router/lib/PatternUtils.js");
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-router/lib/ContextUtils.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ },

/***/ "./node_modules/react-router/lib/RouterUtils.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },

/***/ "./node_modules/react-router/lib/Link.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__("./node_modules/create-react-class/index.js");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__("./node_modules/react-router/lib/PropTypes.js");
	
	var _ContextUtils = __webpack_require__("./node_modules/react-router/lib/ContextUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-router/lib/IndexLink.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__("./node_modules/create-react-class/index.js");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__("./node_modules/react-router/lib/Link.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-router/lib/withRouter.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__("./node_modules/create-react-class/index.js");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__("./node_modules/hoist-non-react-statics/index.js");
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__("./node_modules/react-router/lib/ContextUtils.js");
	
	var _PropTypes = __webpack_require__("./node_modules/react-router/lib/PropTypes.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/hoist-non-react-statics/index.js":
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },

/***/ "./node_modules/react-router/lib/IndexRedirect.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__("./node_modules/create-react-class/index.js");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _routerWarning = __webpack_require__("./node_modules/react-router/lib/routerWarning.js");
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__("./node_modules/react-router/lib/Redirect.js");
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__("./node_modules/react-router/lib/InternalPropTypes.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-router/lib/Redirect.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__("./node_modules/create-react-class/index.js");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__("./node_modules/react-router/lib/RouteUtils.js");
	
	var _PatternUtils = __webpack_require__("./node_modules/react-router/lib/PatternUtils.js");
	
	var _InternalPropTypes = __webpack_require__("./node_modules/react-router/lib/InternalPropTypes.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-router/lib/IndexRoute.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__("./node_modules/create-react-class/index.js");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _routerWarning = __webpack_require__("./node_modules/react-router/lib/routerWarning.js");
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__("./node_modules/react-router/lib/RouteUtils.js");
	
	var _InternalPropTypes = __webpack_require__("./node_modules/react-router/lib/InternalPropTypes.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-router/lib/Route.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__("./node_modules/create-react-class/index.js");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__("./node_modules/react-router/lib/RouteUtils.js");
	
	var _InternalPropTypes = __webpack_require__("./node_modules/react-router/lib/InternalPropTypes.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-router/lib/match.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__("./node_modules/history/lib/Actions.js");
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__("./node_modules/react-router/lib/createMemoryHistory.js");
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__("./node_modules/react-router/lib/createTransitionManager.js");
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__("./node_modules/react-router/lib/RouteUtils.js");
	
	var _RouterUtils = __webpack_require__("./node_modules/react-router/lib/RouterUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/history/lib/Actions.js":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },

/***/ "./node_modules/react-router/lib/createMemoryHistory.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__("./node_modules/history/lib/useQueries.js");
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__("./node_modules/history/lib/useBasename.js");
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__("./node_modules/history/lib/createMemoryHistory.js");
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/history/lib/useQueries.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__("./node_modules/query-string/index.js");
	
	var _runTransitionHook = __webpack_require__("./node_modules/history/lib/runTransitionHook.js");
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__("./node_modules/history/lib/LocationUtils.js");
	
	var _PathUtils = __webpack_require__("./node_modules/history/lib/PathUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },

/***/ "./node_modules/query-string/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__("./node_modules/strict-uri-encode/index.js");
	var objectAssign = __webpack_require__("./node_modules/object-assign/index.js");
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },

/***/ "./node_modules/strict-uri-encode/index.js":
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },

/***/ "./node_modules/history/lib/runTransitionHook.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },

/***/ "./node_modules/history/lib/LocationUtils.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__("./node_modules/history/lib/PathUtils.js");
	
	var _Actions = __webpack_require__("./node_modules/history/lib/Actions.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },

/***/ "./node_modules/history/lib/PathUtils.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },

/***/ "./node_modules/history/lib/useBasename.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__("./node_modules/history/lib/runTransitionHook.js");
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__("./node_modules/history/lib/PathUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },

/***/ "./node_modules/history/lib/createMemoryHistory.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__("./node_modules/history/lib/LocationUtils.js");
	
	var _PathUtils = __webpack_require__("./node_modules/history/lib/PathUtils.js");
	
	var _createHistory = __webpack_require__("./node_modules/history/lib/createHistory.js");
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__("./node_modules/history/lib/Actions.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },

/***/ "./node_modules/history/lib/createHistory.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__("./node_modules/history/lib/AsyncUtils.js");
	
	var _PathUtils = __webpack_require__("./node_modules/history/lib/PathUtils.js");
	
	var _runTransitionHook = __webpack_require__("./node_modules/history/lib/runTransitionHook.js");
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__("./node_modules/history/lib/Actions.js");
	
	var _LocationUtils = __webpack_require__("./node_modules/history/lib/LocationUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },

/***/ "./node_modules/history/lib/AsyncUtils.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },

/***/ "./node_modules/react-router/lib/useRouterHistory.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__("./node_modules/history/lib/useQueries.js");
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__("./node_modules/history/lib/useBasename.js");
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-router/lib/applyRouterMiddleware.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__("./node_modules/react-router/lib/RouterContext.js");
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__("./node_modules/react-router/lib/routerWarning.js");
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-router/lib/browserHistory.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__("./node_modules/history/lib/createBrowserHistory.js");
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__("./node_modules/react-router/lib/createRouterHistory.js");
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/history/lib/createBrowserHistory.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__("./node_modules/history/lib/ExecutionEnvironment.js");
	
	var _BrowserProtocol = __webpack_require__("./node_modules/history/lib/BrowserProtocol.js");
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__("./node_modules/history/lib/RefreshProtocol.js");
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__("./node_modules/history/lib/DOMUtils.js");
	
	var _createHistory = __webpack_require__("./node_modules/history/lib/createHistory.js");
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },

/***/ "./node_modules/history/lib/ExecutionEnvironment.js":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },

/***/ "./node_modules/history/lib/BrowserProtocol.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__("./node_modules/history/lib/LocationUtils.js");
	
	var _DOMUtils = __webpack_require__("./node_modules/history/lib/DOMUtils.js");
	
	var _DOMStateStorage = __webpack_require__("./node_modules/history/lib/DOMStateStorage.js");
	
	var _PathUtils = __webpack_require__("./node_modules/history/lib/PathUtils.js");
	
	var _ExecutionEnvironment = __webpack_require__("./node_modules/history/lib/ExecutionEnvironment.js");
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },

/***/ "./node_modules/history/lib/DOMUtils.js":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },

/***/ "./node_modules/history/lib/DOMStateStorage.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },

/***/ "./node_modules/history/lib/RefreshProtocol.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__("./node_modules/history/lib/BrowserProtocol.js");
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__("./node_modules/history/lib/LocationUtils.js");
	
	var _PathUtils = __webpack_require__("./node_modules/history/lib/PathUtils.js");
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },

/***/ "./node_modules/react-router/lib/createRouterHistory.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__("./node_modules/react-router/lib/useRouterHistory.js");
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-router/lib/hashHistory.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__("./node_modules/history/lib/createHashHistory.js");
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__("./node_modules/react-router/lib/createRouterHistory.js");
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/history/lib/createHashHistory.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__("./node_modules/history/lib/ExecutionEnvironment.js");
	
	var _DOMUtils = __webpack_require__("./node_modules/history/lib/DOMUtils.js");
	
	var _HashProtocol = __webpack_require__("./node_modules/history/lib/HashProtocol.js");
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__("./node_modules/history/lib/createHistory.js");
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },

/***/ "./node_modules/history/lib/HashProtocol.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__("./node_modules/history/lib/BrowserProtocol.js");
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__("./node_modules/history/lib/LocationUtils.js");
	
	var _DOMUtils = __webpack_require__("./node_modules/history/lib/DOMUtils.js");
	
	var _DOMStateStorage = __webpack_require__("./node_modules/history/lib/DOMStateStorage.js");
	
	var _PathUtils = __webpack_require__("./node_modules/history/lib/PathUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },

/***/ "./src/universal/redux/makeReducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _reduxImmutablejs = __webpack_require__("./node_modules/redux-immutablejs/lib/index.js");
	
	var _reactRouterRedux = __webpack_require__("./node_modules/react-router-redux/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentReducers = {
	  router: _reactRouterRedux.routerReducer
	};
	
	exports.default = function () {
	  var newReducers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _assign2.default)(currentReducers, newReducers);
	  return (0, _reduxImmutablejs.combineReducers)(currentReducers);
	};

/***/ },

/***/ "./node_modules/babel-runtime/core-js/object/assign.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/assign.js"), __esModule: true };

/***/ },

/***/ "./node_modules/core-js/library/fn/object/assign.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.object.assign.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.assign;


/***/ },

/***/ "./node_modules/core-js/library/modules/es6.object.assign.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__("./node_modules/core-js/library/modules/_object-assign.js") });


/***/ },

/***/ "./node_modules/core-js/library/modules/_export.js":
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
	var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
	var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
	var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
	var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },

/***/ "./node_modules/core-js/library/modules/_global.js":
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },

/***/ "./node_modules/core-js/library/modules/_core.js":
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },

/***/ "./node_modules/core-js/library/modules/_ctx.js":
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_a-function.js":
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_hide.js":
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
	var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_object-dp.js":
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
	var IE8_DOM_DEFINE = __webpack_require__("./node_modules/core-js/library/modules/_ie8-dom-define.js");
	var toPrimitive = __webpack_require__("./node_modules/core-js/library/modules/_to-primitive.js");
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_an-object.js":
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_is-object.js":
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_ie8-dom-define.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") && !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
	  return Object.defineProperty(__webpack_require__("./node_modules/core-js/library/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },

/***/ "./node_modules/core-js/library/modules/_descriptors.js":
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },

/***/ "./node_modules/core-js/library/modules/_fails.js":
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_dom-create.js":
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
	var document = __webpack_require__("./node_modules/core-js/library/modules/_global.js").document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_to-primitive.js":
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_property-desc.js":
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_has.js":
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_object-assign.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
	var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
	var gOPS = __webpack_require__("./node_modules/core-js/library/modules/_object-gops.js");
	var pIE = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js");
	var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
	var IObject = __webpack_require__("./node_modules/core-js/library/modules/_iobject.js");
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },

/***/ "./node_modules/core-js/library/modules/_object-keys.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys-internal.js");
	var enumBugKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-bug-keys.js");
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_object-keys-internal.js":
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
	var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
	var arrayIndexOf = __webpack_require__("./node_modules/core-js/library/modules/_array-includes.js")(false);
	var IE_PROTO = __webpack_require__("./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_to-iobject.js":
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__("./node_modules/core-js/library/modules/_iobject.js");
	var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_iobject.js":
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__("./node_modules/core-js/library/modules/_cof.js");
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_cof.js":
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_defined.js":
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_array-includes.js":
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
	var toLength = __webpack_require__("./node_modules/core-js/library/modules/_to-length.js");
	var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/library/modules/_to-absolute-index.js");
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_to-length.js":
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__("./node_modules/core-js/library/modules/_to-integer.js");
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_to-integer.js":
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_to-absolute-index.js":
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__("./node_modules/core-js/library/modules/_to-integer.js");
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_shared-key.js":
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__("./node_modules/core-js/library/modules/_shared.js")('keys');
	var uid = __webpack_require__("./node_modules/core-js/library/modules/_uid.js");
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_shared.js":
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
	var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__("./node_modules/core-js/library/modules/_library.js") ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ },

/***/ "./node_modules/core-js/library/modules/_library.js":
/***/ function(module, exports) {

	module.exports = true;


/***/ },

/***/ "./node_modules/core-js/library/modules/_uid.js":
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_enum-bug-keys.js":
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },

/***/ "./node_modules/core-js/library/modules/_object-gops.js":
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },

/***/ "./node_modules/core-js/library/modules/_object-pie.js":
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },

/***/ "./node_modules/core-js/library/modules/_to-object.js":
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },

/***/ "./node_modules/redux-immutablejs/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utilsCombineReducers = __webpack_require__("./node_modules/redux-immutablejs/lib/utils/combineReducers.js");
	
	var _utilsCombineReducers2 = _interopRequireDefault(_utilsCombineReducers);
	
	var _utilsCreateReducer = __webpack_require__("./node_modules/redux-immutablejs/lib/utils/createReducer.js");
	
	var _utilsCreateReducer2 = _interopRequireDefault(_utilsCreateReducer);
	
	exports.combineReducers = _utilsCombineReducers2['default'];
	exports.createReducer = _utilsCreateReducer2['default'];

/***/ },

/***/ "./node_modules/redux-immutablejs/lib/utils/combineReducers.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _immutable = __webpack_require__("./node_modules/immutable/dist/immutable.js");
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	// TODO need to find a way to reference Redux's init for compatability
	var ActionTypes = { INIT: 'INIT' };
	var isImmutable = function isImmutable(obj) {
	  return _immutable2['default'].Iterable.isIterable(obj);
	};
	
	/* eslint-disable no-console */
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Reducer "' + key + '" returned undefined handling ' + actionName + '. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateKeyWarningMessage(inputState, outputState, action) {
	  var reducerKeys = Object.keys(outputState);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isImmutable(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = inputState.keySeq().filter(function (key) {
	    return reducerKeys.indexOf(key) < 0;
	  });
	
	  if (unexpectedKeys.size > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  reducers.keySeq().forEach(function (key) {
	    var reducer = reducers.get(key);
	    var initialState = reducer(undefined, { type: ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	
	function combineReducers(reducers) {
	  var finalReducers = isImmutable(reducers) ? reducers : _immutable2['default'].fromJS(reducers);
	  finalReducers = finalReducers.filter(function (v) {
	    return typeof v === 'function';
	  });
	  var sanityError;
	
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  var defaultState = finalReducers.map(function (r) {
	    return undefined;
	  });
	
	  return function combination(state, action) {
	    if (state === undefined) state = defaultState;
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    var dirty = false;
	    var finalState = finalReducers.map(function (reducer, key) {
	      var oldState = state.get(key);
	      var newState = reducer(oldState, action);
	      dirty = dirty || oldState !== newState;
	      if (typeof newState === 'undefined') {
	        throw new Error(getErrorMessage(key, action));
	      }
	      return newState;
	    });
	
	    if (false) {
	      var warningMessage = getUnexpectedStateKeyWarningMessage(state, finalState, action);
	      if (warningMessage) {
	        console.error(warningMessage);
	      }
	    }
	
	    return dirty ? finalState : state;
	  };
	}
	
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/redux-immutablejs/lib/utils/createReducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createReducer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _immutable = __webpack_require__("./node_modules/immutable/dist/immutable.js");
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	/**
	 * Create a handler (action) map reducer for the given list of handlers
	 *
	 * @param  {object} initialState     The initial state of the reducer, expecting an Immutable.Iterable instance,
	 * otherwise given initialState is converted to immutable.
	 * @param  {object} handlers         A map of actions where key is action name and value is a reducer function
	 * @param  {boolean} enforceImmutable = true if to enforce immutable, in other words a TypeError is thrown in case
	 * a handler returned anything that is not an Immutable.Iterable type.
	 * @param  {function} constructor    A function to process non-immutable state, defaults to Immutable.fromJS.
	 * @return {object}                  The calculated next state
	 */
	
	function createReducer(initialState, handlers) {
	  var enforceImmutable = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	  var constructor = arguments.length <= 3 || arguments[3] === undefined ? _immutable2['default'].fromJS.bind(_immutable2['default']) : arguments[3];
	
	  return function (state, action) {
	    if (state === undefined) state = initialState;
	
	    // convert the initial state to immutable
	    // This is useful in isomorphic apps where states were serialized
	    if (!_immutable2['default'].Iterable.isIterable(state)) {
	      state = constructor(state);
	    }
	
	    var handler = action && action.type ? handlers[action.type] : undefined;
	
	    if (!handler) {
	      return state;
	    }
	
	    state = handler(state, action);
	
	    if (enforceImmutable && !_immutable2['default'].Iterable.isIterable(state)) {
	      throw new TypeError('Reducers must return Immutable objects.');
	    }
	
	    return state;
	  };
	}
	
	module.exports = exports['default'];

/***/ },

/***/ "./src/client/Root.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _index = __webpack_require__("./src/universal/routes/index.js");
	
	var _index2 = _interopRequireDefault(_index);
	
	var _reactRouterRedux = __webpack_require__("./node_modules/react-router-redux/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Root = (_temp = _class = function (_Component) {
		(0, _inherits3.default)(Root, _Component);
	
		function Root() {
			(0, _classCallCheck3.default)(this, Root);
			return (0, _possibleConstructorReturn3.default)(this, (Root.__proto__ || (0, _getPrototypeOf2.default)(Root)).apply(this, arguments));
		}
	
		(0, _createClass3.default)(Root, [{
			key: 'render',
			value: function render() {
				var store = this.props.store;
	
				var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store, {
					selectLocationState: function selectLocationState(state) {
						return state.get('router');
					}
				});
				return _react2.default.createElement(
					_reactRedux.Provider,
					{ store: store },
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_reactRouter.Router,
							{ history: history },
							(0, _index2.default)()
						)
					)
				);
			}
		}]);
		return Root;
	}(_react.Component), _class.propTypes = {
		store: _react.PropTypes.object.isRequired
	}, _temp);
	exports.default = Root;

/***/ },

/***/ "./node_modules/babel-runtime/core-js/object/get-prototype-of.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/get-prototype-of.js"), __esModule: true };

/***/ },

/***/ "./node_modules/core-js/library/fn/object/get-prototype-of.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.object.get-prototype-of.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.getPrototypeOf;


/***/ },

/***/ "./node_modules/core-js/library/modules/es6.object.get-prototype-of.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
	var $getPrototypeOf = __webpack_require__("./node_modules/core-js/library/modules/_object-gpo.js");
	
	__webpack_require__("./node_modules/core-js/library/modules/_object-sap.js")('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },

/***/ "./node_modules/core-js/library/modules/_object-gpo.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
	var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
	var IE_PROTO = __webpack_require__("./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_object-sap.js":
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
	var fails = __webpack_require__("./node_modules/core-js/library/modules/_fails.js");
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },

/***/ "./node_modules/babel-runtime/helpers/classCallCheck.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },

/***/ "./node_modules/babel-runtime/helpers/createClass.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },

/***/ "./node_modules/babel-runtime/core-js/object/define-property.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/define-property.js"), __esModule: true };

/***/ },

/***/ "./node_modules/core-js/library/fn/object/define-property.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.object.define-property.js");
	var $Object = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/es6.object.define-property.js":
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__("./node_modules/core-js/library/modules/_descriptors.js"), 'Object', { defineProperty: __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f });


/***/ },

/***/ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },

/***/ "./node_modules/babel-runtime/helpers/typeof.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__("./node_modules/babel-runtime/core-js/symbol/iterator.js");
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__("./node_modules/babel-runtime/core-js/symbol.js");
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },

/***/ "./node_modules/babel-runtime/core-js/symbol/iterator.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/symbol/iterator.js"), __esModule: true };

/***/ },

/***/ "./node_modules/core-js/library/fn/symbol/iterator.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
	__webpack_require__("./node_modules/core-js/library/modules/web.dom.iterable.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_wks-ext.js").f('iterator');


/***/ },

/***/ "./node_modules/core-js/library/modules/es6.string.iterator.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__("./node_modules/core-js/library/modules/_string-at.js")(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__("./node_modules/core-js/library/modules/_iter-define.js")(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },

/***/ "./node_modules/core-js/library/modules/_string-at.js":
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__("./node_modules/core-js/library/modules/_to-integer.js");
	var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_iter-define.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__("./node_modules/core-js/library/modules/_library.js");
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	var redefine = __webpack_require__("./node_modules/core-js/library/modules/_redefine.js");
	var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
	var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
	var $iterCreate = __webpack_require__("./node_modules/core-js/library/modules/_iter-create.js");
	var setToStringTag = __webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js");
	var getPrototypeOf = __webpack_require__("./node_modules/core-js/library/modules/_object-gpo.js");
	var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_redefine.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");


/***/ },

/***/ "./node_modules/core-js/library/modules/_iterators.js":
/***/ function(module, exports) {

	module.exports = {};


/***/ },

/***/ "./node_modules/core-js/library/modules/_iter-create.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__("./node_modules/core-js/library/modules/_object-create.js");
	var descriptor = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
	var setToStringTag = __webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js");
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__("./node_modules/core-js/library/modules/_hide.js")(IteratorPrototype, __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_object-create.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
	var dPs = __webpack_require__("./node_modules/core-js/library/modules/_object-dps.js");
	var enumBugKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-bug-keys.js");
	var IE_PROTO = __webpack_require__("./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__("./node_modules/core-js/library/modules/_dom-create.js")('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__("./node_modules/core-js/library/modules/_html.js").appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_object-dps.js":
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
	var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
	var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
	
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_html.js":
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__("./node_modules/core-js/library/modules/_global.js").document;
	module.exports = document && document.documentElement;


/***/ },

/***/ "./node_modules/core-js/library/modules/_set-to-string-tag.js":
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
	var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
	var TAG = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_wks.js":
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__("./node_modules/core-js/library/modules/_shared.js")('wks');
	var uid = __webpack_require__("./node_modules/core-js/library/modules/_uid.js");
	var Symbol = __webpack_require__("./node_modules/core-js/library/modules/_global.js").Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },

/***/ "./node_modules/core-js/library/modules/web.dom.iterable.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.array.iterator.js");
	var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
	var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
	var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
	var TO_STRING_TAG = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },

/***/ "./node_modules/core-js/library/modules/es6.array.iterator.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__("./node_modules/core-js/library/modules/_add-to-unscopables.js");
	var step = __webpack_require__("./node_modules/core-js/library/modules/_iter-step.js");
	var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
	var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },

/***/ "./node_modules/core-js/library/modules/_add-to-unscopables.js":
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },

/***/ "./node_modules/core-js/library/modules/_iter-step.js":
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_wks-ext.js":
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__("./node_modules/core-js/library/modules/_wks.js");


/***/ },

/***/ "./node_modules/babel-runtime/core-js/symbol.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/symbol/index.js"), __esModule: true };

/***/ },

/***/ "./node_modules/core-js/library/fn/symbol/index.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.symbol.js");
	__webpack_require__("./node_modules/core-js/library/modules/es6.object.to-string.js");
	__webpack_require__("./node_modules/core-js/library/modules/es7.symbol.async-iterator.js");
	__webpack_require__("./node_modules/core-js/library/modules/es7.symbol.observable.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Symbol;


/***/ },

/***/ "./node_modules/core-js/library/modules/es6.symbol.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
	var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
	var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	var redefine = __webpack_require__("./node_modules/core-js/library/modules/_redefine.js");
	var META = __webpack_require__("./node_modules/core-js/library/modules/_meta.js").KEY;
	var $fails = __webpack_require__("./node_modules/core-js/library/modules/_fails.js");
	var shared = __webpack_require__("./node_modules/core-js/library/modules/_shared.js");
	var setToStringTag = __webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js");
	var uid = __webpack_require__("./node_modules/core-js/library/modules/_uid.js");
	var wks = __webpack_require__("./node_modules/core-js/library/modules/_wks.js");
	var wksExt = __webpack_require__("./node_modules/core-js/library/modules/_wks-ext.js");
	var wksDefine = __webpack_require__("./node_modules/core-js/library/modules/_wks-define.js");
	var enumKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-keys.js");
	var isArray = __webpack_require__("./node_modules/core-js/library/modules/_is-array.js");
	var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
	var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
	var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
	var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
	var toPrimitive = __webpack_require__("./node_modules/core-js/library/modules/_to-primitive.js");
	var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
	var _create = __webpack_require__("./node_modules/core-js/library/modules/_object-create.js");
	var gOPNExt = __webpack_require__("./node_modules/core-js/library/modules/_object-gopn-ext.js");
	var $GOPD = __webpack_require__("./node_modules/core-js/library/modules/_object-gopd.js");
	var $GOPS = __webpack_require__("./node_modules/core-js/library/modules/_object-gops.js");
	var $DP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
	var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__("./node_modules/core-js/library/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js").f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__("./node_modules/core-js/library/modules/_library.js")) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("./node_modules/core-js/library/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },

/***/ "./node_modules/core-js/library/modules/_meta.js":
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__("./node_modules/core-js/library/modules/_uid.js")('meta');
	var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
	var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
	var setDesc = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_wks-define.js":
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
	var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
	var LIBRARY = __webpack_require__("./node_modules/core-js/library/modules/_library.js");
	var wksExt = __webpack_require__("./node_modules/core-js/library/modules/_wks-ext.js");
	var defineProperty = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_enum-keys.js":
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
	var gOPS = __webpack_require__("./node_modules/core-js/library/modules/_object-gops.js");
	var pIE = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js");
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_is-array.js":
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__("./node_modules/core-js/library/modules/_cof.js");
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_object-gopn-ext.js":
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
	var gOPN = __webpack_require__("./node_modules/core-js/library/modules/_object-gopn.js").f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_object-gopn.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys-internal.js");
	var hiddenKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-bug-keys.js").concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_object-gopd.js":
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js");
	var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
	var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
	var toPrimitive = __webpack_require__("./node_modules/core-js/library/modules/_to-primitive.js");
	var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
	var IE8_DOM_DEFINE = __webpack_require__("./node_modules/core-js/library/modules/_ie8-dom-define.js");
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/es6.object.to-string.js":
/***/ function(module, exports) {



/***/ },

/***/ "./node_modules/core-js/library/modules/es7.symbol.async-iterator.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/_wks-define.js")('asyncIterator');


/***/ },

/***/ "./node_modules/core-js/library/modules/es7.symbol.observable.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/_wks-define.js")('observable');


/***/ },

/***/ "./node_modules/babel-runtime/helpers/inherits.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/set-prototype-of.js");
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__("./node_modules/babel-runtime/core-js/object/create.js");
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },

/***/ "./node_modules/babel-runtime/core-js/object/set-prototype-of.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/set-prototype-of.js"), __esModule: true };

/***/ },

/***/ "./node_modules/core-js/library/fn/object/set-prototype-of.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.object.set-prototype-of.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.setPrototypeOf;


/***/ },

/***/ "./node_modules/core-js/library/modules/es6.object.set-prototype-of.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("./node_modules/core-js/library/modules/_set-proto.js").set });


/***/ },

/***/ "./node_modules/core-js/library/modules/_set-proto.js":
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
	var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js")(Function.call, __webpack_require__("./node_modules/core-js/library/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },

/***/ "./node_modules/babel-runtime/core-js/object/create.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/create.js"), __esModule: true };

/***/ },

/***/ "./node_modules/core-js/library/fn/object/create.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.object.create.js");
	var $Object = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/es6.object.create.js":
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__("./node_modules/core-js/library/modules/_object-create.js") });


/***/ },

/***/ "./node_modules/react-redux/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__("./node_modules/react-redux/lib/components/Provider.js");
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__("./node_modules/react-redux/lib/components/connect.js");
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },

/***/ "./node_modules/react-redux/lib/components/Provider.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _storeShape = __webpack_require__("./node_modules/react-redux/lib/utils/storeShape.js");
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__("./node_modules/react-redux/lib/utils/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },

/***/ "./node_modules/react-redux/lib/utils/storeShape.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	exports["default"] = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired
	});

/***/ },

/***/ "./node_modules/react-redux/lib/utils/warning.js":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },

/***/ "./node_modules/react-redux/lib/components/connect.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _storeShape = __webpack_require__("./node_modules/react-redux/lib/utils/storeShape.js");
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__("./node_modules/react-redux/lib/utils/shallowEqual.js");
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__("./node_modules/react-redux/lib/utils/wrapActionCreators.js");
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__("./node_modules/react-redux/lib/utils/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__("./node_modules/lodash/isPlainObject.js");
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__("./node_modules/hoist-non-react-statics/index.js");
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },

/***/ "./node_modules/react-redux/lib/utils/shallowEqual.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },

/***/ "./node_modules/react-redux/lib/utils/wrapActionCreators.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },

/***/ "./src/universal/routes/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.default = function () {
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				_reactRouter.Route,
				{ path: '/' },
				_react2.default.createElement(_reactRouter.IndexRoute, { component: _LoginPage2.default }),
				_react2.default.createElement(_reactRouter.Route, { path: '/login', component: _LoginPage2.default })
			),
			_react2.default.createElement(
				_reactRouter.Route,
				{ path: '/app', component: App, onEnter: requireAuth },
				_react2.default.createElement(_reactRouter.IndexRoute, { component: _pageHome2.default }),
				_react2.default.createElement(_reactRouter.Route, { path: '/account', component: _Account2.default }),
				_react2.default.createElement(_reactRouter.Route, { path: '/calendrier', component: _CalendarV2.default }),
				_react2.default.createElement(_reactRouter.Route, { path: '/calendrier2', component: _CalendarV2.default }),
				_react2.default.createElement(_reactRouter.Route, { path: '/contact', component: _contact2.default }),
				_react2.default.createElement(_reactRouter.Route, { path: '/reservations', component: _pageReservationsList2.default }),
				_react2.default.createElement(_reactRouter.Route, { path: '/reservations-add', component: _pageReservationsAdd2.default }),
				_react2.default.createElement(_reactRouter.Route, { path: '/reservations/:id', component: _pageReservationsView2.default }),
				_react2.default.createElement(_reactRouter.Route, { path: '/planning', component: _PlanningPage2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/planning/flights/:flightId', component: _PlanningProgrammePage2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/users', component: _UserList2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/users/add', component: _UserAdd2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/users/:id', component: _UserEdit2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/my-flights', component: _MyFlights2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/flights/:id/detail', component: _FlightDetail2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/partners', component: _PartnerList2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/partners/:id', component: _PartnerEdit2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/group-bills', component: _GroupBillList2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/group-bills/add', component: _GroupBillAdd2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/promotions', component: _PromotionsList2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/promotions-add', component: _PromotionsForm2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/promotions/:id', component: _PromotionsForm2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/options', component: _OptionsList2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/options-add', component: _OptionsForm2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/options/:id', component: _OptionsForm2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/flights', component: _FlightsTypeList2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/flights-add', component: _FlightsTypeForm2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/flights/:id', component: _FlightsTypeForm2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/prices', component: _PricesList2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/prices/:id', component: _PricesForm2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/prices-add', component: _PricesForm2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/montgolfieres', component: _MontgolfiereList2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/montgolfieres/add', component: _MontgolfiereAdd2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/montgolfieres/:id', component: _MontgolfiereEdit2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/montgolfieres/:id/view', component: _MontgolfiereView2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/places', component: _PlaceList2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/places/add', component: _PlaceAdd2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/places/:id', component: _PlaceEdit2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/alerts', component: _AlertList2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/alerts/add', component: _AlertAdd2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/alerts/:id', component: _AlertEdit2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/planifications', component: _PlanificationAddMultiplePage2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/exports', component: _Exports2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/sms', component: _Sms2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/statistiques', component: _Statistiques2.default, onEnter: allowToEnter }),
				_react2.default.createElement(_reactRouter.Route, { path: '/error', component: _3.default })
			)
		);
	};
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _Account = __webpack_require__("./src/universal/components/users/Account.page.js");
	
	var _Account2 = _interopRequireDefault(_Account);
	
	var _AlertAdd = __webpack_require__("./src/universal/components/alerts/AlertAdd.page.js");
	
	var _AlertAdd2 = _interopRequireDefault(_AlertAdd);
	
	var _AlertEdit = __webpack_require__("./src/universal/components/alerts/AlertEdit.page.js");
	
	var _AlertEdit2 = _interopRequireDefault(_AlertEdit);
	
	var _AlertList = __webpack_require__("./src/universal/components/alerts/AlertList.page.js");
	
	var _AlertList2 = _interopRequireDefault(_AlertList);
	
	var _Calendar = __webpack_require__("./src/universal/components/reservations/Calendar.page.js");
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _CalendarV = __webpack_require__("./src/universal/components/reservations/CalendarV2.page.js");
	
	var _CalendarV2 = _interopRequireDefault(_CalendarV);
	
	var _FlightsTypeForm = __webpack_require__("./src/universal/components/flights-type/FlightsTypeForm.page.js");
	
	var _FlightsTypeForm2 = _interopRequireDefault(_FlightsTypeForm);
	
	var _FlightsTypeList = __webpack_require__("./src/universal/components/flights-type/FlightsTypeList.page.js");
	
	var _FlightsTypeList2 = _interopRequireDefault(_FlightsTypeList);
	
	var _footer = __webpack_require__("./src/universal/components/layout/footer.js");
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _header = __webpack_require__("./src/universal/components/layout/header.js");
	
	var _header2 = _interopRequireDefault(_header);
	
	var _pageHome = __webpack_require__("./src/universal/components/home/page-home.js");
	
	var _pageHome2 = _interopRequireDefault(_pageHome);
	
	var _LoginPage = __webpack_require__("./src/universal/components/auth/LoginPage.js");
	
	var _LoginPage2 = _interopRequireDefault(_LoginPage);
	
	var _MontgolfiereAdd = __webpack_require__("./src/universal/components/montgolfieres/MontgolfiereAdd.page.js");
	
	var _MontgolfiereAdd2 = _interopRequireDefault(_MontgolfiereAdd);
	
	var _MontgolfiereEdit = __webpack_require__("./src/universal/components/montgolfieres/MontgolfiereEdit.page.js");
	
	var _MontgolfiereEdit2 = _interopRequireDefault(_MontgolfiereEdit);
	
	var _MontgolfiereView = __webpack_require__("./src/universal/components/montgolfieres/MontgolfiereView.page.js");
	
	var _MontgolfiereView2 = _interopRequireDefault(_MontgolfiereView);
	
	var _MontgolfiereList = __webpack_require__("./src/universal/components/montgolfieres/MontgolfiereList.page.js");
	
	var _MontgolfiereList2 = _interopRequireDefault(_MontgolfiereList);
	
	var _MyFlights = __webpack_require__("./src/universal/components/statistiques/MyFlights.page.js");
	
	var _MyFlights2 = _interopRequireDefault(_MyFlights);
	
	var _FlightDetail = __webpack_require__("./src/universal/components/flights/FlightDetail.page.js");
	
	var _FlightDetail2 = _interopRequireDefault(_FlightDetail);
	
	var _OptionsForm = __webpack_require__("./src/universal/components/options/OptionsForm.page.js");
	
	var _OptionsForm2 = _interopRequireDefault(_OptionsForm);
	
	var _OptionsList = __webpack_require__("./src/universal/components/options/OptionsList.page.js");
	
	var _OptionsList2 = _interopRequireDefault(_OptionsList);
	
	var _PlaceAdd = __webpack_require__("./src/universal/components/places/PlaceAdd.page.js");
	
	var _PlaceAdd2 = _interopRequireDefault(_PlaceAdd);
	
	var _PlaceEdit = __webpack_require__("./src/universal/components/places/PlaceEdit.page.js");
	
	var _PlaceEdit2 = _interopRequireDefault(_PlaceEdit);
	
	var _PlaceList = __webpack_require__("./src/universal/components/places/PlaceList.page.js");
	
	var _PlaceList2 = _interopRequireDefault(_PlaceList);
	
	var _PlanificationAddMultiplePage = __webpack_require__("./src/universal/components/planifications/PlanificationAddMultiplePage.js");
	
	var _PlanificationAddMultiplePage2 = _interopRequireDefault(_PlanificationAddMultiplePage);
	
	var _PlanificationListPage = __webpack_require__("./src/universal/components/planifications/PlanificationListPage.js");
	
	var _PlanificationListPage2 = _interopRequireDefault(_PlanificationListPage);
	
	var _PlanningPage = __webpack_require__("./src/universal/components/flights/PlanningPage.js");
	
	var _PlanningPage2 = _interopRequireDefault(_PlanningPage);
	
	var _PlanningProgrammePage = __webpack_require__("./src/universal/components/flights/PlanningProgrammePage.js");
	
	var _PlanningProgrammePage2 = _interopRequireDefault(_PlanningProgrammePage);
	
	var _PricesForm = __webpack_require__("./src/universal/components/prices/PricesForm.page.js");
	
	var _PricesForm2 = _interopRequireDefault(_PricesForm);
	
	var _PricesList = __webpack_require__("./src/universal/components/prices/PricesList.page.js");
	
	var _PricesList2 = _interopRequireDefault(_PricesList);
	
	var _PromotionsForm = __webpack_require__("./src/universal/components/promotions/PromotionsForm.page.js");
	
	var _PromotionsForm2 = _interopRequireDefault(_PromotionsForm);
	
	var _PromotionsList = __webpack_require__("./src/universal/components/promotions/PromotionsList.page.js");
	
	var _PromotionsList2 = _interopRequireDefault(_PromotionsList);
	
	var _pageReservationsAdd = __webpack_require__("./src/universal/components/reservations/page-reservations-add.js");
	
	var _pageReservationsAdd2 = _interopRequireDefault(_pageReservationsAdd);
	
	var _pageReservationsList = __webpack_require__("./src/universal/components/reservations/page-reservations-list.js");
	
	var _pageReservationsList2 = _interopRequireDefault(_pageReservationsList);
	
	var _pageReservationsView = __webpack_require__("./src/universal/components/reservations/page-reservations-view.js");
	
	var _pageReservationsView2 = _interopRequireDefault(_pageReservationsView);
	
	var _sidebar = __webpack_require__("./src/universal/components/layout/sidebar.js");
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _UserAdd = __webpack_require__("./src/universal/components/users/UserAdd.page.js");
	
	var _UserAdd2 = _interopRequireDefault(_UserAdd);
	
	var _UserEdit = __webpack_require__("./src/universal/components/users/UserEdit.page.js");
	
	var _UserEdit2 = _interopRequireDefault(_UserEdit);
	
	var _UserList = __webpack_require__("./src/universal/components/users/UserList.page.js");
	
	var _UserList2 = _interopRequireDefault(_UserList);
	
	var _Statistiques = __webpack_require__("./src/universal/components/statistiques/Statistiques.page.js");
	
	var _Statistiques2 = _interopRequireDefault(_Statistiques);
	
	var _PartnerList = __webpack_require__("./src/universal/components/partners/PartnerList.page.js");
	
	var _PartnerList2 = _interopRequireDefault(_PartnerList);
	
	var _PartnerEdit = __webpack_require__("./src/universal/components/partners/PartnerEdit.page.js");
	
	var _PartnerEdit2 = _interopRequireDefault(_PartnerEdit);
	
	var _GroupBillList = __webpack_require__("./src/universal/components/partners/GroupBillList.page.js");
	
	var _GroupBillList2 = _interopRequireDefault(_GroupBillList);
	
	var _GroupBillAdd = __webpack_require__("./src/universal/components/partners/GroupBillAdd.page.js");
	
	var _GroupBillAdd2 = _interopRequireDefault(_GroupBillAdd);
	
	var _GroupBillView = __webpack_require__("./src/universal/components/partners/GroupBillView.page.js");
	
	var _GroupBillView2 = _interopRequireDefault(_GroupBillView);
	
	var _Exports = __webpack_require__("./src/universal/components/exports/Exports.page.js");
	
	var _Exports2 = _interopRequireDefault(_Exports);
	
	var _Sms = __webpack_require__("./src/universal/components/sms/Sms.page.js");
	
	var _Sms2 = _interopRequireDefault(_Sms);
	
	var _contact = __webpack_require__("./src/universal/components/layout/contact.js");
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _2 = __webpack_require__("./src/universal/components/layout/404.js");
	
	var _3 = _interopRequireDefault(_2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Tracker = Package.tracker.Tracker;
	
	var App = function (_React$Component) {
		(0, _inherits3.default)(App, _React$Component);
	
		function App(props) {
			(0, _classCallCheck3.default)(this, App);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).call(this, props));
	
			_this.state = {};
	
			if (_.includes(Meteor.user().roles, 'partner')) _this.state.partner = true;else _this.state.partner = false;
			return _this;
		}
	
		(0, _createClass3.default)(App, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				Tracker.autorun(function (computation) {
					if (Meteor.loggingIn() || !_roles.Roles.isReady()) return;
	
					_this2.forceUpdate();
					computation.stop();
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_rubix.MainContainer,
					this.props,
					_react2.default.createElement(_sidebar2.default, null),
					_react2.default.createElement(_header2.default, null),
					_react2.default.createElement(
						'div',
						{ id: 'body' },
						_react2.default.createElement(
							_rubix.Grid,
							null,
							_react2.default.createElement(
								_rubix.Row,
								null,
								_react2.default.createElement(
									_rubix.Col,
									{ xs: 12 },
									this.props.children
								)
							)
						)
					),
					_react2.default.createElement(_footer2.default, null)
				);
			}
		}]);
		return App;
	}(_react2.default.Component);
	
	function requireAuth(nextState, replace, callback) {
		Tracker.autorun(function (computation) {
	
			if (Meteor.loggingIn()) return;
	
			if (!Meteor.user()) {
				return replace({
					pathname: '/login',
					state: { nextPathname: nextState.location.pathname }
				});
			}
	
			computation.stop();
			callback();
		});
	}
	
	function allowToEnter(nextState, replace, callback) {
	
		if (_.includes(Meteor.user().roles, 'partner')) {
			replace({
				pathname: '/error',
				state: { nextPathname: nextState.location.pathname }
			});
		}
	
		callback();
	}

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.utils = exports.Well = exports.Tooltip = exports.TimelineBody = exports.TimelineTitle = exports.TimelineAvatar = exports.TimelineIcon = exports.TimelineHeader = exports.TimelineItem = exports.TimelineView = exports.Thumbnail = exports.Tag = exports.Tabs = exports.TabPane = exports.Table = exports.TabContent = exports.TabContainer = exports.Tab = exports.SplitHoverButton = exports.SplitButton = exports.SidebarControlBtn = exports.SidebarControls = exports.SidebarNavItem = exports.SidebarDivider = exports.SidebarNav = exports.SidebarBtn = exports.Sidebar = exports.MainContainer = exports.SafeAnchor = exports.Row = exports.ResponsiveEmbed = exports.Radio = exports.ProgressGroup = exports.ProgressBar = exports.Progress = exports.PricingButtonContainer = exports.PricingTableHeader = exports.PricingTablePrice = exports.PricingTableBody = exports.PricingFeature = exports.PricingTable = exports.PricingTableContainer = exports.Popover = exports.Pagination = exports.Pager = exports.PageItem = exports.PageHeader = exports.PanelBody = exports.PanelRight = exports.PanelLeft = exports.PanelFooter = exports.PanelHeader = exports.Panel = exports.PanelTabContainer = exports.PanelContainer = exports.OverlayTrigger = exports.Overlay = exports.NavItem = exports.NavDropdownHover = exports.NavDropdown = exports.NavbarToggle = exports.NavbarHeader = exports.NavbarCollapse = exports.NavbarBrand = exports.Navbar = exports.Nav = exports.ModalTitle = exports.ModalHeader = exports.ModalFooter = exports.ModalDialog = exports.ModalBody = exports.Modal = exports.MenuItem = exports.MediaRight = exports.MediaListItem = exports.MediaList = exports.MediaLeft = exports.MediaHeading = exports.MediaBody = exports.Media = exports.LoremIpsum = exports.ListGroupItem = exports.ListGroup = exports.Lead = exports.Label = exports.L20n = exports.Jumbotron = exports.isBrowser = exports.InputGroup = exports.Image = exports.Icon = exports.HelpBlock = exports.Grid = exports.Glyphicon = exports.FormGroup = exports.FormControlStatic = exports.FormControlFeedback = exports.FormControl = exports.Form = exports.Fade = exports.DropdownHoverButton = exports.DropdownButton = exports.Dropdown = exports.Dispatcher = exports.Collapse = exports.Col = exports.ControlLabel = exports.Clearfix = exports.Checkbox = exports.Carousel = exports.BPanelGroup = exports.BPanel = exports.ButtonToolbar = exports.ButtonGroup = exports.Button = exports.BreadcrumbItem = exports.Breadcrumb = exports.Badge = exports.AlertLink = exports.Alert = exports.Accordion = undefined;
	
	var _NavDropdown2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/NavDropdown.js");
	
	Object.defineProperty(exports, 'NavDropdownHover', {
	  enumerable: true,
	  get: function get() {
	    return _NavDropdown2.NavDropdownHover;
	  }
	});
	
	var _Panel = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Panel.js");
	
	Object.defineProperty(exports, 'PanelTabContainer', {
	  enumerable: true,
	  get: function get() {
	    return _Panel.PanelTabContainer;
	  }
	});
	Object.defineProperty(exports, 'Panel', {
	  enumerable: true,
	  get: function get() {
	    return _Panel.Panel;
	  }
	});
	Object.defineProperty(exports, 'PanelHeader', {
	  enumerable: true,
	  get: function get() {
	    return _Panel.PanelHeader;
	  }
	});
	Object.defineProperty(exports, 'PanelFooter', {
	  enumerable: true,
	  get: function get() {
	    return _Panel.PanelFooter;
	  }
	});
	Object.defineProperty(exports, 'PanelLeft', {
	  enumerable: true,
	  get: function get() {
	    return _Panel.PanelLeft;
	  }
	});
	Object.defineProperty(exports, 'PanelRight', {
	  enumerable: true,
	  get: function get() {
	    return _Panel.PanelRight;
	  }
	});
	Object.defineProperty(exports, 'PanelBody', {
	  enumerable: true,
	  get: function get() {
	    return _Panel.PanelBody;
	  }
	});
	
	var _Pricing = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Pricing.js");
	
	Object.defineProperty(exports, 'PricingTable', {
	  enumerable: true,
	  get: function get() {
	    return _Pricing.PricingTable;
	  }
	});
	Object.defineProperty(exports, 'PricingFeature', {
	  enumerable: true,
	  get: function get() {
	    return _Pricing.PricingFeature;
	  }
	});
	Object.defineProperty(exports, 'PricingTableBody', {
	  enumerable: true,
	  get: function get() {
	    return _Pricing.PricingTableBody;
	  }
	});
	Object.defineProperty(exports, 'PricingTablePrice', {
	  enumerable: true,
	  get: function get() {
	    return _Pricing.PricingTablePrice;
	  }
	});
	Object.defineProperty(exports, 'PricingTableHeader', {
	  enumerable: true,
	  get: function get() {
	    return _Pricing.PricingTableHeader;
	  }
	});
	Object.defineProperty(exports, 'PricingButtonContainer', {
	  enumerable: true,
	  get: function get() {
	    return _Pricing.PricingButtonContainer;
	  }
	});
	
	var _Sidebar = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Sidebar.js");
	
	Object.defineProperty(exports, 'Sidebar', {
	  enumerable: true,
	  get: function get() {
	    return _Sidebar.Sidebar;
	  }
	});
	Object.defineProperty(exports, 'SidebarBtn', {
	  enumerable: true,
	  get: function get() {
	    return _Sidebar.SidebarBtn;
	  }
	});
	Object.defineProperty(exports, 'SidebarNav', {
	  enumerable: true,
	  get: function get() {
	    return _Sidebar.SidebarNav;
	  }
	});
	Object.defineProperty(exports, 'SidebarDivider', {
	  enumerable: true,
	  get: function get() {
	    return _Sidebar.SidebarDivider;
	  }
	});
	Object.defineProperty(exports, 'SidebarNavItem', {
	  enumerable: true,
	  get: function get() {
	    return _Sidebar.SidebarNavItem;
	  }
	});
	Object.defineProperty(exports, 'SidebarControls', {
	  enumerable: true,
	  get: function get() {
	    return _Sidebar.SidebarControls;
	  }
	});
	Object.defineProperty(exports, 'SidebarControlBtn', {
	  enumerable: true,
	  get: function get() {
	    return _Sidebar.SidebarControlBtn;
	  }
	});
	
	var _Timeline = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Timeline.js");
	
	Object.defineProperty(exports, 'TimelineView', {
	  enumerable: true,
	  get: function get() {
	    return _Timeline.TimelineView;
	  }
	});
	Object.defineProperty(exports, 'TimelineItem', {
	  enumerable: true,
	  get: function get() {
	    return _Timeline.TimelineItem;
	  }
	});
	Object.defineProperty(exports, 'TimelineHeader', {
	  enumerable: true,
	  get: function get() {
	    return _Timeline.TimelineHeader;
	  }
	});
	Object.defineProperty(exports, 'TimelineIcon', {
	  enumerable: true,
	  get: function get() {
	    return _Timeline.TimelineIcon;
	  }
	});
	Object.defineProperty(exports, 'TimelineAvatar', {
	  enumerable: true,
	  get: function get() {
	    return _Timeline.TimelineAvatar;
	  }
	});
	Object.defineProperty(exports, 'TimelineTitle', {
	  enumerable: true,
	  get: function get() {
	    return _Timeline.TimelineTitle;
	  }
	});
	Object.defineProperty(exports, 'TimelineBody', {
	  enumerable: true,
	  get: function get() {
	    return _Timeline.TimelineBody;
	  }
	});
	
	var _Accordion2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Accordion.js");
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	var _Alert2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Alert.js");
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	var _AlertLink2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/AlertLink.js");
	
	var _AlertLink3 = _interopRequireDefault(_AlertLink2);
	
	var _Badge2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Badge.js");
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _Breadcrumb2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Breadcrumb.js");
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	var _BreadcrumbItem2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/BreadcrumbItem.js");
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	var _Button2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Button.js");
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _ButtonGroup2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/ButtonGroup.js");
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	var _ButtonToolbar2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/ButtonToolbar.js");
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	var _BPanel2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/BPanel.js");
	
	var _BPanel3 = _interopRequireDefault(_BPanel2);
	
	var _BPanelGroup2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/BPanelGroup.js");
	
	var _BPanelGroup3 = _interopRequireDefault(_BPanelGroup2);
	
	var _Carousel2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Carousel.js");
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	var _Checkbox2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Checkbox.js");
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Clearfix2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Clearfix.js");
	
	var _Clearfix3 = _interopRequireDefault(_Clearfix2);
	
	var _ControlLabel2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/ControlLabel.js");
	
	var _ControlLabel3 = _interopRequireDefault(_ControlLabel2);
	
	var _Col2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Col.js");
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	var _Collapse2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Collapse.js");
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _Dispatcher2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Dispatcher.js");
	
	var _Dispatcher3 = _interopRequireDefault(_Dispatcher2);
	
	var _Dropdown2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Dropdown.js");
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	var _DropdownButton2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/DropdownButton.js");
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	var _DropdownHoverButton2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/DropdownHoverButton.js");
	
	var _DropdownHoverButton3 = _interopRequireDefault(_DropdownHoverButton2);
	
	var _Fade2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Fade.js");
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	var _Form2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Form.js");
	
	var _Form3 = _interopRequireDefault(_Form2);
	
	var _FormControl2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/FormControl.js");
	
	var _FormControl3 = _interopRequireDefault(_FormControl2);
	
	var _FormControlFeedback2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/FormControlFeedback.js");
	
	var _FormControlFeedback3 = _interopRequireDefault(_FormControlFeedback2);
	
	var _FormControlStatic2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/FormControlStatic.js");
	
	var _FormControlStatic3 = _interopRequireDefault(_FormControlStatic2);
	
	var _FormGroup2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/FormGroup.js");
	
	var _FormGroup3 = _interopRequireDefault(_FormGroup2);
	
	var _Glyphicon2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Glyphicon.js");
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	var _Grid2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Grid.js");
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _HelpBlock2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/HelpBlock.js");
	
	var _HelpBlock3 = _interopRequireDefault(_HelpBlock2);
	
	var _Icon2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Icon.js");
	
	var _Icon3 = _interopRequireDefault(_Icon2);
	
	var _Image2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Image.js");
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	var _InputGroup2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/InputGroup.js");
	
	var _InputGroup3 = _interopRequireDefault(_InputGroup2);
	
	var _isBrowser2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/isBrowser.js");
	
	var _isBrowser3 = _interopRequireDefault(_isBrowser2);
	
	var _Jumbotron2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Jumbotron.js");
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	var _L20n2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/L20n.js");
	
	var _L20n3 = _interopRequireDefault(_L20n2);
	
	var _Label2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Label.js");
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _Lead2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Lead.js");
	
	var _Lead3 = _interopRequireDefault(_Lead2);
	
	var _ListGroup2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/ListGroup.js");
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	var _ListGroupItem2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/ListGroupItem.js");
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	var _LoremIpsum2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/LoremIpsum.js");
	
	var _LoremIpsum3 = _interopRequireDefault(_LoremIpsum2);
	
	var _Media2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Media.js");
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MediaBody2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/MediaBody.js");
	
	var _MediaBody3 = _interopRequireDefault(_MediaBody2);
	
	var _MediaHeading2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/MediaHeading.js");
	
	var _MediaHeading3 = _interopRequireDefault(_MediaHeading2);
	
	var _MediaLeft2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/MediaLeft.js");
	
	var _MediaLeft3 = _interopRequireDefault(_MediaLeft2);
	
	var _MediaList2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/MediaList.js");
	
	var _MediaList3 = _interopRequireDefault(_MediaList2);
	
	var _MediaListItem2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/MediaListItem.js");
	
	var _MediaListItem3 = _interopRequireDefault(_MediaListItem2);
	
	var _MediaRight2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/MediaRight.js");
	
	var _MediaRight3 = _interopRequireDefault(_MediaRight2);
	
	var _MenuItem2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/MenuItem.js");
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _Modal2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Modal.js");
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _ModalBody2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/ModalBody.js");
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	var _ModalDialog2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/ModalDialog.js");
	
	var _ModalDialog3 = _interopRequireDefault(_ModalDialog2);
	
	var _ModalFooter2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/ModalFooter.js");
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	var _ModalHeader2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/ModalHeader.js");
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	var _ModalTitle2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/ModalTitle.js");
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	var _Nav2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Nav.js");
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	var _Navbar2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Navbar.js");
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	var _NavbarBrand2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/NavbarBrand.js");
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	var _NavbarCollapse2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/NavbarCollapse.js");
	
	var _NavbarCollapse3 = _interopRequireDefault(_NavbarCollapse2);
	
	var _NavbarHeader2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/NavbarHeader.js");
	
	var _NavbarHeader3 = _interopRequireDefault(_NavbarHeader2);
	
	var _NavbarToggle2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/NavbarToggle.js");
	
	var _NavbarToggle3 = _interopRequireDefault(_NavbarToggle2);
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	var _NavItem2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/NavItem.js");
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	var _Overlay2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Overlay.js");
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _OverlayTrigger2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/OverlayTrigger.js");
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _PageHeader2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/PageHeader.js");
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	var _PageItem2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/PageItem.js");
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	var _Pager2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Pager.js");
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	var _Pagination2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Pagination.js");
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	var _Popover2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Popover.js");
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _Pricing2 = _interopRequireDefault(_Pricing);
	
	var _Progress2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Progress.js");
	
	var _Progress3 = _interopRequireDefault(_Progress2);
	
	var _ProgressBar2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/ProgressBar.js");
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	var _ProgressGroup2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/ProgressGroup.js");
	
	var _ProgressGroup3 = _interopRequireDefault(_ProgressGroup2);
	
	var _Radio2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Radio.js");
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _ResponsiveEmbed2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/ResponsiveEmbed.js");
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	var _Row2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Row.js");
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	var _SafeAnchor2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/SafeAnchor.js");
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _SplitButton2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/SplitButton.js");
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	var _SplitHoverButton2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/SplitHoverButton.js");
	
	var _SplitHoverButton3 = _interopRequireDefault(_SplitHoverButton2);
	
	var _Tab2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Tab.js");
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _TabContainer2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/TabContainer.js");
	
	var _TabContainer3 = _interopRequireDefault(_TabContainer2);
	
	var _TabContent2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/TabContent.js");
	
	var _TabContent3 = _interopRequireDefault(_TabContent2);
	
	var _Table2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Table.js");
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TabPane2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/TabPane.js");
	
	var _TabPane3 = _interopRequireDefault(_TabPane2);
	
	var _Tabs2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Tabs.js");
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Tag2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Tag.js");
	
	var _Tag3 = _interopRequireDefault(_Tag2);
	
	var _Thumbnail2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Thumbnail.js");
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	var _Tooltip2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Tooltip.js");
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _Well2 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Well.js");
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	var _utils2 = __webpack_require__("./node_modules/react-bootstrap/lib/utils/index.js");
	
	var _utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Accordion = _Accordion3.default;
	exports.Alert = _Alert3.default;
	exports.AlertLink = _AlertLink3.default;
	exports.Badge = _Badge3.default;
	exports.Breadcrumb = _Breadcrumb3.default;
	exports.BreadcrumbItem = _BreadcrumbItem3.default;
	exports.Button = _Button3.default;
	exports.ButtonGroup = _ButtonGroup3.default;
	exports.ButtonToolbar = _ButtonToolbar3.default;
	exports.BPanel = _BPanel3.default;
	exports.BPanelGroup = _BPanelGroup3.default;
	exports.Carousel = _Carousel3.default;
	exports.Checkbox = _Checkbox3.default;
	exports.Clearfix = _Clearfix3.default;
	exports.ControlLabel = _ControlLabel3.default;
	exports.Col = _Col3.default;
	exports.Collapse = _Collapse3.default;
	exports.Dispatcher = _Dispatcher3.default;
	exports.Dropdown = _Dropdown3.default;
	exports.DropdownButton = _DropdownButton3.default;
	exports.DropdownHoverButton = _DropdownHoverButton3.default;
	exports.Fade = _Fade3.default;
	exports.Form = _Form3.default;
	exports.FormControl = _FormControl3.default;
	exports.FormControlFeedback = _FormControlFeedback3.default;
	exports.FormControlStatic = _FormControlStatic3.default;
	exports.FormGroup = _FormGroup3.default;
	exports.Glyphicon = _Glyphicon3.default;
	exports.Grid = _Grid3.default;
	exports.HelpBlock = _HelpBlock3.default;
	exports.Icon = _Icon3.default;
	exports.Image = _Image3.default;
	exports.InputGroup = _InputGroup3.default;
	exports.isBrowser = _isBrowser3.default;
	exports.Jumbotron = _Jumbotron3.default;
	exports.L20n = _L20n3.default;
	exports.Label = _Label3.default;
	exports.Lead = _Lead3.default;
	exports.ListGroup = _ListGroup3.default;
	exports.ListGroupItem = _ListGroupItem3.default;
	exports.LoremIpsum = _LoremIpsum3.default;
	exports.Media = _Media3.default;
	exports.MediaBody = _MediaBody3.default;
	exports.MediaHeading = _MediaHeading3.default;
	exports.MediaLeft = _MediaLeft3.default;
	exports.MediaList = _MediaList3.default;
	exports.MediaListItem = _MediaListItem3.default;
	exports.MediaRight = _MediaRight3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.Modal = _Modal3.default;
	exports.ModalBody = _ModalBody3.default;
	exports.ModalDialog = _ModalDialog3.default;
	exports.ModalFooter = _ModalFooter3.default;
	exports.ModalHeader = _ModalHeader3.default;
	exports.ModalTitle = _ModalTitle3.default;
	exports.Nav = _Nav3.default;
	exports.Navbar = _Navbar3.default;
	exports.NavbarBrand = _NavbarBrand3.default;
	exports.NavbarCollapse = _NavbarCollapse3.default;
	exports.NavbarHeader = _NavbarHeader3.default;
	exports.NavbarToggle = _NavbarToggle3.default;
	exports.NavDropdown = _NavDropdown3.default;
	exports.NavItem = _NavItem3.default;
	exports.Overlay = _Overlay3.default;
	exports.OverlayTrigger = _OverlayTrigger3.default;
	exports.PanelContainer = _Panel2.default;
	exports.PageHeader = _PageHeader3.default;
	exports.PageItem = _PageItem3.default;
	exports.Pager = _Pager3.default;
	exports.Pagination = _Pagination3.default;
	exports.Popover = _Popover3.default;
	exports.PricingTableContainer = _Pricing2.default;
	exports.Progress = _Progress3.default;
	exports.ProgressBar = _ProgressBar3.default;
	exports.ProgressGroup = _ProgressGroup3.default;
	exports.Radio = _Radio3.default;
	exports.ResponsiveEmbed = _ResponsiveEmbed3.default;
	exports.Row = _Row3.default;
	exports.SafeAnchor = _SafeAnchor3.default;
	exports.MainContainer = _Sidebar2.default;
	exports.SplitButton = _SplitButton3.default;
	exports.SplitHoverButton = _SplitHoverButton3.default;
	exports.Tab = _Tab3.default;
	exports.TabContainer = _TabContainer3.default;
	exports.TabContent = _TabContent3.default;
	exports.Table = _Table3.default;
	exports.TabPane = _TabPane3.default;
	exports.Tabs = _Tabs3.default;
	exports.Tag = _Tag3.default;
	exports.Thumbnail = _Thumbnail3.default;
	exports.Tooltip = _Tooltip3.default;
	exports.Well = _Well3.default;
	exports.utils = _utils;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/NavDropdown.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.NavDropdownHover = exports.NavDropdownHoverHOC = exports.NavDropdownHOC = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class4, _class5;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _BNavDropdown = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/BNavDropdown.js");
	
	var _BNavDropdown2 = _interopRequireDefault(_BNavDropdown);
	
	var _isBrowser = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/isBrowser.js");
	
	var _isBrowser2 = _interopRequireDefault(_isBrowser);
	
	var _isTouchDevice = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/isTouchDevice.js");
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestFrame = null,
	    rAF = function rAF() {},
	    cAF = function cAF() {};
	
	if ((0, _isBrowser2.default)()) {
	  requestFrame = __webpack_require__("./node_modules/request-frame/dist/request-frame.js");
	
	  requestFrame = typeof requestFrame === "function" ? requestFrame : requestFrame.default;
	
	  rAF = requestFrame('request');
	  cAF = requestFrame('cancel');
	}
	
	var expectedTypes = ["success", "warning", "danger", "info", "default", "primary", "link"];
	
	function isBtnOfType(type) {
	  for (var i = 0; i < expectedTypes.length; i++) {
	    if (expectedTypes[i] === type) {
	      return true;
	    }
	  }
	  return false;
	}
	
	var NavDropdownHOC = exports.NavDropdownHOC = function NavDropdownHOC(ComposedComponent) {
	  var _class, _temp;
	
	  return _temp = _class = function (_React$Component) {
	    (0, _inherits3.default)(_class, _React$Component);
	
	    function _class() {
	      (0, _classCallCheck3.default)(this, _class);
	      return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(_class, [{
	      key: 'render',
	      value: function render() {
	        var props = (0, _extends3.default)({}, this.props);
	
	        if (this.props.hasOwnProperty('xs')) {
	          props.bsSize = 'xsmall';
	          delete props.xs;
	        }
	
	        if (this.props.hasOwnProperty('sm')) {
	          props.bsSize = 'small';
	          delete props.sm;
	        }
	
	        if (this.props.hasOwnProperty('lg')) {
	          props.bsSize = 'large';
	          delete props.lg;
	        }
	
	        if (this.props.hasOwnProperty('bsStyle') && typeof this.props.bsStyle === 'string') {
	          var styles = this.props.bsStyle.split(/\s|\,/mgi).filter(function (a) {
	            return a;
	          });
	          for (var i = 0; i < styles.length; i++) {
	            if (styles[i] === 'link') {
	              props.bsClass = 'menu-default dropdown';
	            } else {
	              props.bsClass = 'menu-' + styles[i] + ' dropdown';
	            }
	            if (isBtnOfType(styles[i])) {
	              props.bsStyle = styles[i];
	            } else {
	              props.bsStyle = 'default';
	            }
	          }
	        }
	
	        if (!props.bsStyle) {
	          props.bsStyle = 'default';
	        }
	
	        if (!props.bsClass) {
	          props.bsClass = 'menu-default dropdown';
	        }
	
	        if (props.hasOwnProperty('dropup')) {
	          props.bsClass = 'dropup ' + props.bsClass;
	        }
	
	        delete props.dropup;
	
	        return _react2.default.createElement(ComposedComponent, { buttonProps: props });
	      }
	    }]);
	    return _class;
	  }(_react2.default.Component), _class.displayName = 'NavDropdown', _class.propTypes = {
	    xs: _react2.default.PropTypes.bool,
	    sm: _react2.default.PropTypes.bool,
	    lg: _react2.default.PropTypes.bool
	  }, _temp;
	};
	
	var NavDropdownHoverHOC = exports.NavDropdownHoverHOC = function NavDropdownHoverHOC(ComposedComponent) {
	  var _class2, _class3, _temp2;
	
	  return NavDropdownHOC(_class2 = (_temp2 = _class3 = function (_React$Component2) {
	    (0, _inherits3.default)(_class2, _React$Component2);
	
	    function _class2(props) {
	      (0, _classCallCheck3.default)(this, _class2);
	
	      var _this2 = (0, _possibleConstructorReturn3.default)(this, (_class2.__proto__ || (0, _getPrototypeOf2.default)(_class2)).call(this, props));
	
	      _this2.state = {
	        open: false
	      };
	
	      _this2._eventObject = {
	        handleEvent: _this2._handleOver.bind(_this2),
	        name: 'NavDropdownHoverEvent'
	      };
	
	      _this2._timeout = null;
	      return _this2;
	    }
	
	    (0, _createClass3.default)(_class2, [{
	      key: '_isWithinDropdown',
	      value: function _isWithinDropdown(node) {
	        var componentNode = _reactDom2.default.findDOMNode(this._node);
	        return componentNode.contains(node) || componentNode === node;
	      }
	    }, {
	      key: '_handleOver',
	      value: function _handleOver(e) {
	        var _this3 = this;
	
	        if (this._isWithinDropdown(e.target)) {
	          cAF(this._timeout);
	          this.setState({ open: true });
	        } else {
	          this._timeout = rAF(function () {
	            _this3.setState({ open: false });
	          });
	        }
	      }
	    }, {
	      key: '_onToggle',
	      value: function _onToggle(isOpen) {
	        this.setState({ open: isOpen });
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (!(0, _isTouchDevice2.default)()) {
	          document.removeEventListener('mouseover', this._eventObject);
	        }
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var _this4 = this;
	
	        if (!(0, _isTouchDevice2.default)()) {
	          rAF(function () {
	            document.addEventListener('mouseover', _this4._eventObject);
	          });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this5 = this;
	
	        return _react2.default.createElement(ComposedComponent, { ref: function ref(node) {
	            return _this5._node = node;
	          },
	          onToggle: this._onToggle.bind(this),
	          open: this.state.open,
	          buttonProps: this.props.buttonProps });
	      }
	    }]);
	    return _class2;
	  }(_react2.default.Component), _class3.displayName = 'NavDropdownHover', _temp2)) || _class2;
	};
	
	var NavDropdownHover = exports.NavDropdownHover = NavDropdownHoverHOC(_class4 = function (_React$Component3) {
	  (0, _inherits3.default)(NavDropdownHover, _React$Component3);
	
	  function NavDropdownHover() {
	    (0, _classCallCheck3.default)(this, NavDropdownHover);
	    return (0, _possibleConstructorReturn3.default)(this, (NavDropdownHover.__proto__ || (0, _getPrototypeOf2.default)(NavDropdownHover)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(NavDropdownHover, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_BNavDropdown2.default, (0, _extends3.default)({ open: this.props.open,
	        onToggle: this.props.onToggle
	      }, this.props.buttonProps));
	    }
	  }]);
	  return NavDropdownHover;
	}(_react2.default.Component)) || _class4;
	
	var NavDropdown = NavDropdownHOC(_class5 = function (_React$Component4) {
	  (0, _inherits3.default)(NavDropdown, _React$Component4);
	
	  function NavDropdown() {
	    (0, _classCallCheck3.default)(this, NavDropdown);
	    return (0, _possibleConstructorReturn3.default)(this, (NavDropdown.__proto__ || (0, _getPrototypeOf2.default)(NavDropdown)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(NavDropdown, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_BNavDropdown2.default, this.props.buttonProps);
	    }
	  }]);
	  return NavDropdown;
	}(_react2.default.Component)) || _class5;
	
	exports.default = NavDropdown;

/***/ },

/***/ "./node_modules/babel-runtime/helpers/extends.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/BNavDropdown.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/slicedToArray.js");
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dropdown = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Dropdown.js");
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps3 = __webpack_require__("./node_modules/react-bootstrap/lib/utils/splitComponentProps.js");
	
	var _splitComponentProps4 = _interopRequireDefault(_splitComponentProps3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Dropdown2.default.propTypes, {
	
	  // Toggle props.
	  title: _react2.default.PropTypes.node.isRequired,
	  noCaret: _react2.default.PropTypes.bool,
	  active: _react2.default.PropTypes.bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _react2.default.PropTypes.node
	});
	
	var NavDropdown = function (_React$Component) {
	  (0, _inherits3.default)(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    (0, _classCallCheck3.default)(this, NavDropdown);
	    return (0, _possibleConstructorReturn3.default)(this, (NavDropdown.__proto__ || (0, _getPrototypeOf2.default)(NavDropdown)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(NavDropdown, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          active = _props.active,
	          className = _props.className,
	          style = _props.style,
	          children = _props.children,
	          props = (0, _objectWithoutProperties3.default)(_props, ['title', 'active', 'className', 'style', 'children']);
	
	
	      delete props.eventKey;
	
	      // These are injected down by `<Nav>` for building `<SubNav>`s.
	      delete props.activeKey;
	      delete props.activeHref;
	
	      var _splitComponentProps = (0, _splitComponentProps4.default)(props, _Dropdown2.default.ControlledComponent),
	          _splitComponentProps2 = (0, _slicedToArray3.default)(_splitComponentProps, 2),
	          dropdownProps = _splitComponentProps2[0],
	          toggleProps = _splitComponentProps2[1];
	
	      // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
	      // rather than the `<Dropdown.Toggle>`.
	
	      return _react2.default.createElement(
	        _Dropdown2.default,
	        (0, _extends3.default)({}, dropdownProps, {
	          componentClass: 'li',
	          className: (0, _classnames2.default)(className, { active: active }),
	          style: style
	        }),
	        _react2.default.createElement(
	          _Dropdown2.default.Toggle,
	          (0, _extends3.default)({}, toggleProps, { useAnchor: true }),
	          title
	        ),
	        _react2.default.createElement(
	          _Dropdown2.default.Menu,
	          null,
	          children
	        )
	      );
	    }
	  }]);
	  return NavDropdown;
	}(_react2.default.Component);
	
	NavDropdown.propTypes = propTypes;
	
	exports.default = NavDropdown;

/***/ },

/***/ "./node_modules/babel-runtime/helpers/slicedToArray.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__("./node_modules/babel-runtime/core-js/is-iterable.js");
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__("./node_modules/babel-runtime/core-js/get-iterator.js");
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ },

/***/ "./node_modules/babel-runtime/core-js/is-iterable.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/is-iterable.js"), __esModule: true };

/***/ },

/***/ "./node_modules/core-js/library/fn/is-iterable.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/web.dom.iterable.js");
	__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/core.is-iterable.js");


/***/ },

/***/ "./node_modules/core-js/library/modules/core.is-iterable.js":
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__("./node_modules/core-js/library/modules/_classof.js");
	var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
	var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_classof.js":
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__("./node_modules/core-js/library/modules/_cof.js");
	var TAG = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },

/***/ "./node_modules/babel-runtime/core-js/get-iterator.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/get-iterator.js"), __esModule: true };

/***/ },

/***/ "./node_modules/core-js/library/fn/get-iterator.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/web.dom.iterable.js");
	__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/core.get-iterator.js");


/***/ },

/***/ "./node_modules/core-js/library/modules/core.get-iterator.js":
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
	var get = __webpack_require__("./node_modules/core-js/library/modules/core.get-iterator-method.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/core.get-iterator-method.js":
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__("./node_modules/core-js/library/modules/_classof.js");
	var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
	var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },

/***/ "./node_modules/babel-runtime/helpers/objectWithoutProperties.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },

/***/ "./node_modules/classnames/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}
	
			return classes;
		}
	
		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}
	
			if (typeof arg !== 'object') {
				return '';
			}
	
			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}
	
			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}
	
			var classes = '';
	
			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}
	
			return classes;
		}
	
		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Dropdown.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _activeElement = __webpack_require__("./node_modules/dom-helpers/activeElement.js");
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__("./node_modules/dom-helpers/query/contains.js");
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _keycode = __webpack_require__("./node_modules/keycode/index.js");
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__("./node_modules/react-prop-types/lib/all.js");
	
	var _all2 = _interopRequireDefault(_all);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _isRequiredForA11y = __webpack_require__("./node_modules/react-prop-types/lib/isRequiredForA11y.js");
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__("./node_modules/uncontrollable/index.js");
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ButtonGroup = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/ButtonGroup.js");
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/DropdownMenu.js");
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/DropdownToggle.js");
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _PropTypes = __webpack_require__("./node_modules/react-bootstrap/lib/utils/PropTypes.js");
	
	var _ValidComponentChildren = __webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js");
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TOGGLE_ROLE = _DropdownToggle2.default.defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2.default.defaultProps.bsRole;
	
	var propTypes = {
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _react2.default.PropTypes.bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2.default)(_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number])),
	
	  componentClass: _elementType2.default,
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
	   * @type {node}
	   */
	  children: (0, _all2.default)((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _react2.default.PropTypes.bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _react2.default.PropTypes.bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _react2.default.PropTypes.bool,
	
	  /**
	   * A callback fired when the Dropdown closes.
	   */
	  onClose: _react2.default.PropTypes.func,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value.
	   *
	   * ```js
	   * function(Boolean isOpen) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _react2.default.PropTypes.func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _react2.default.PropTypes.func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _react2.default.PropTypes.string
	};
	
	var defaultProps = {
	  componentClass: _ButtonGroup2.default
	};
	
	var Dropdown = function (_React$Component) {
	  (0, _inherits3.default)(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    (0, _classCallCheck3.default)(this, Dropdown);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Dropdown.__proto__ || (0, _getPrototypeOf2.default)(Dropdown)).call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	
	    _this._focusInDropdown = false;
	    _this.lastOpenEventType = null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Dropdown, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.focusNextOnOpen();
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (!nextProps.open && this.props.open) {
	        this._focusInDropdown = (0, _contains2.default)(_reactDom2.default.findDOMNode(this.menu), (0, _activeElement2.default)(document));
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var open = this.props.open;
	
	      var prevOpen = prevProps.open;
	
	      if (open && !prevOpen) {
	        this.focusNextOnOpen();
	      }
	
	      if (!open && prevOpen) {
	        // if focus hasn't already moved from the menu lets return it
	        // to the toggle
	        if (this._focusInDropdown) {
	          this._focusInDropdown = false;
	          this.focus();
	        }
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      if (this.props.disabled) {
	        return;
	      }
	
	      this.toggleOpen('click');
	    }
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(event) {
	      if (this.props.disabled) {
	        return;
	      }
	
	      switch (event.keyCode) {
	        case _keycode2.default.codes.down:
	          if (!this.props.open) {
	            this.toggleOpen('keydown');
	          } else if (this.menu.focusNext) {
	            this.menu.focusNext();
	          }
	          event.preventDefault();
	          break;
	        case _keycode2.default.codes.esc:
	        case _keycode2.default.codes.tab:
	          this.handleClose(event);
	          break;
	        default:
	      }
	    }
	  }, {
	    key: 'toggleOpen',
	    value: function toggleOpen(eventType) {
	      var open = !this.props.open;
	
	      if (open) {
	        this.lastOpenEventType = eventType;
	      }
	
	      if (this.props.onToggle) {
	        this.props.onToggle(open);
	      }
	    }
	  }, {
	    key: 'handleClose',
	    value: function handleClose() {
	      if (!this.props.open) {
	        return;
	      }
	
	      this.toggleOpen(null);
	    }
	  }, {
	    key: 'focusNextOnOpen',
	    value: function focusNextOnOpen() {
	      var menu = this.menu;
	
	      if (!menu.focusNext) {
	        return;
	      }
	
	      if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	        menu.focusNext();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      var toggle = _reactDom2.default.findDOMNode(this.toggle);
	
	      if (toggle && toggle.focus) {
	        toggle.focus();
	      }
	    }
	  }, {
	    key: 'renderToggle',
	    value: function renderToggle(child, props) {
	      var _this2 = this;
	
	      var ref = function ref(c) {
	        _this2.toggle = c;
	      };
	
	      if (typeof child.ref === 'string') {
	        (0, _warning2.default)(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');
	      } else {
	        ref = (0, _createChainedFunction2.default)(child.ref, ref);
	      }
	
	      return (0, _react.cloneElement)(child, (0, _extends3.default)({}, props, {
	        ref: ref,
	        bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
	        onClick: (0, _createChainedFunction2.default)(child.props.onClick, this.handleClick),
	        onKeyDown: (0, _createChainedFunction2.default)(child.props.onKeyDown, this.handleKeyDown)
	      }));
	    }
	  }, {
	    key: 'renderMenu',
	    value: function renderMenu(child, _ref) {
	      var _this3 = this;
	
	      var id = _ref.id,
	          onClose = _ref.onClose,
	          onSelect = _ref.onSelect,
	          props = (0, _objectWithoutProperties3.default)(_ref, ['id', 'onClose', 'onSelect']);
	
	      var ref = function ref(c) {
	        _this3.menu = c;
	      };
	
	      if (typeof child.ref === 'string') {
	        (0, _warning2.default)(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');
	      } else {
	        ref = (0, _createChainedFunction2.default)(child.ref, ref);
	      }
	
	      return (0, _react.cloneElement)(child, (0, _extends3.default)({}, props, {
	        ref: ref,
	        labelledBy: id,
	        bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
	        onClose: (0, _createChainedFunction2.default)(child.props.onClose, onClose, this.handleClose),
	        onSelect: (0, _createChainedFunction2.default)(child.props.onSelect, onSelect, this.handleClose)
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classes,
	          _this4 = this;
	
	      var _props = this.props,
	          Component = _props.componentClass,
	          id = _props.id,
	          dropup = _props.dropup,
	          disabled = _props.disabled,
	          pullRight = _props.pullRight,
	          open = _props.open,
	          onClose = _props.onClose,
	          onSelect = _props.onSelect,
	          role = _props.role,
	          bsClass = _props.bsClass,
	          className = _props.className,
	          children = _props.children,
	          props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onClose', 'onSelect', 'role', 'bsClass', 'className', 'children']);
	
	
	      delete props.onToggle;
	
	      var classes = (_classes = {}, (0, _defineProperty3.default)(_classes, bsClass, true), (0, _defineProperty3.default)(_classes, 'open', open), (0, _defineProperty3.default)(_classes, 'disabled', disabled), _classes);
	
	      if (dropup) {
	        classes[bsClass] = false;
	        classes.dropup = true;
	      }
	
	      // This intentionally forwards bsSize and bsStyle (if set) to the
	      // underlying component, to allow it to render size and style variants.
	
	      return _react2.default.createElement(
	        Component,
	        (0, _extends3.default)({}, props, {
	          className: (0, _classnames2.default)(className, classes)
	        }),
	        _ValidComponentChildren2.default.map(children, function (child) {
	          switch (child.props.bsRole) {
	            case TOGGLE_ROLE:
	              return _this4.renderToggle(child, {
	                id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
	              });
	            case MENU_ROLE:
	              return _this4.renderMenu(child, {
	                id: id, open: open, pullRight: pullRight, bsClass: bsClass, onClose: onClose, onSelect: onSelect
	              });
	            default:
	              return child;
	          }
	        })
	      );
	    }
	  }]);
	  return Dropdown;
	}(_react2.default.Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
	
	var UncontrolledDropdown = (0, _uncontrollable2.default)(Dropdown, { open: 'onToggle' });
	
	UncontrolledDropdown.Toggle = _DropdownToggle2.default;
	UncontrolledDropdown.Menu = _DropdownMenu2.default;
	
	exports.default = UncontrolledDropdown;

/***/ },

/***/ "./node_modules/babel-runtime/helpers/defineProperty.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ },

/***/ "./node_modules/dom-helpers/activeElement.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__("./node_modules/dom-helpers/util/babelHelpers.js");
	
	exports.__esModule = true;
	
	/**
	 * document.activeElement
	 */
	exports['default'] = activeElement;
	
	var _ownerDocument = __webpack_require__("./node_modules/dom-helpers/ownerDocument.js");
	
	var _ownerDocument2 = babelHelpers.interopRequireDefault(_ownerDocument);
	
	function activeElement() {
	  var doc = arguments[0] === undefined ? document : arguments[0];
	
	  try {
	    return doc.activeElement;
	  } catch (e) {}
	}
	
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/dom-helpers/util/babelHelpers.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === "object") {
	    factory(exports);
	  } else {
	    factory(root.babelHelpers = {});
	  }
	})(this, function (global) {
	  var babelHelpers = global;
	
	  babelHelpers.interopRequireDefault = function (obj) {
	    return obj && obj.__esModule ? obj : {
	      "default": obj
	    };
	  };
	
	  babelHelpers._extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	})

/***/ },

/***/ "./node_modules/dom-helpers/ownerDocument.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/dom-helpers/query/contains.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__("./node_modules/dom-helpers/util/inDOM.js");
	
	var contains = (function () {
	  var root = canUseDOM && document.documentElement;
	
	  return root && root.contains ? function (context, node) {
	    return context.contains(node);
	  } : root && root.compareDocumentPosition ? function (context, node) {
	    return context === node || !!(context.compareDocumentPosition(node) & 16);
	  } : function (context, node) {
	    if (node) do {
	      if (node === context) return true;
	    } while (node = node.parentNode);
	
	    return false;
	  };
	})();
	
	module.exports = contains;

/***/ },

/***/ "./node_modules/dom-helpers/util/inDOM.js":
/***/ function(module, exports) {

	'use strict';
	module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },

/***/ "./node_modules/keycode/index.js":
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },

/***/ "./node_modules/react-prop-types/lib/all.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__("./node_modules/react-prop-types/lib/utils/createChainableTypeChecker.js");
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}

/***/ },

/***/ "./node_modules/react-prop-types/lib/utils/createChainableTypeChecker.js":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ },

/***/ "./node_modules/react-prop-types/lib/elementType.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__("./node_modules/react-prop-types/lib/utils/createChainableTypeChecker.js");
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ },

/***/ "./node_modules/react-prop-types/lib/isRequiredForA11y.js":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ },

/***/ "./node_modules/uncontrollable/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__("./node_modules/uncontrollable/createUncontrollable.js");
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (!component.unmounted) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)(mixin, set);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/uncontrollable/createUncontrollable.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__("./node_modules/uncontrollable/utils.js");
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createUncontrollable(mixin, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var _class, _temp;
	
	    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        controlledProps = Object.keys(controlledValues),
	        propTypes;
	
	    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = (_temp = _class = function (_React$Component) {
	      _inherits(component, _React$Component);
	
	      function component() {
	        _classCallCheck(this, component);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	      }
	
	      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
	      };
	
	      component.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        var props = this.props;
	
	        this._values = {};
	
	        controlledProps.forEach(function (key) {
	          _this2._values[key] = props[utils.defaultKey(key)];
	        });
	      };
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	
	
	      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        var props = this.props;
	
	        if (mixin.componentWillReceiveProps) {
	          mixin.componentWillReceiveProps.call(this, nextProps);
	        }
	
	        controlledProps.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this3._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      };
	
	      component.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unmounted = true;
	      };
	
	      component.prototype.getControlledInstance = function getControlledInstance() {
	        return this.refs.inner;
	      };
	
	      component.prototype.render = function render() {
	        var _this4 = this;
	
	        var newProps = {},
	            props = omitProps(this.props);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this4.props[propName];
	
	          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
	            prop = _this4.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this4, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      };
	
	      return component;
	    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);
	
	    _extends(component.prototype, methods);
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	
	    function omitProps(props) {
	      var result = {};
	
	      utils.each(props, function (value, key) {
	        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
	      });
	
	      return result;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/uncontrollable/utils.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.has = has;
	exports.isReactComponent = isReactComponent;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = readOnlyPropType(handler, displayName);
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/ButtonGroup.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ButtonGroup = __webpack_require__("./node_modules/react-bootstrap/lib/ButtonGroup.js");
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonGroup = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    (0, _classCallCheck3.default)(this, ButtonGroup);
	    return (0, _possibleConstructorReturn3.default)(this, (ButtonGroup.__proto__ || (0, _getPrototypeOf2.default)(ButtonGroup)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ButtonGroup, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	
	      if (props.xs) {
	        props.bsSize = 'xsmall';
	        delete props.xs;
	      }
	
	      if (props.sm) {
	        props.bsSize = 'small';
	        delete props.sm;
	      }
	
	      if (props.lg) {
	        props.bsSize = 'large';
	        delete props.lg;
	      }
	
	      if (props.bsSize) {
	        props.children = _react2.default.Children.map(props.children, function (child) {
	          return _react2.default.cloneElement(child, {
	            bsSize: props.bsSize
	          });
	        });
	      }
	
	      return _react2.default.createElement(_ButtonGroup2.default, props);
	    }
	  }]);
	  return ButtonGroup;
	}(_react2.default.Component), _class.propTypes = {
	  xs: _react2.default.PropTypes.bool,
	  sm: _react2.default.PropTypes.bool,
	  lg: _react2.default.PropTypes.bool
	}, _temp);
	exports.default = ButtonGroup;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/ButtonGroup.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__("./node_modules/react-prop-types/lib/all.js");
	
	var _all2 = _interopRequireDefault(_all);
	
	var _Button = __webpack_require__("./node_modules/react-bootstrap/lib/Button.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  vertical: _propTypes2['default'].bool,
	  justified: _propTypes2['default'].bool,
	
	  /**
	   * Display block buttons; only useful when used with the "vertical" prop.
	   * @type {bool}
	   */
	  block: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var block = _ref.block,
	        vertical = _ref.vertical;
	    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
	  })
	};
	
	var defaultProps = {
	  block: false,
	  justified: false,
	  vertical: false
	};
	
	var ButtonGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    (0, _classCallCheck3['default'])(this, ButtonGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonGroup.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        block = _props.block,
	        justified = _props.justified,
	        vertical = _props.vertical,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['block', 'justified', 'vertical', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button2['default'].defaultProps, 'block')] = block, _extends2));
	
	    return _react2['default'].createElement('div', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonGroup;
	}(_react2['default'].Component);
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Button.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__("./node_modules/babel-runtime/core-js/object/values.js");
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends3 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");
	
	var _SafeAnchor = __webpack_require__("./node_modules/react-bootstrap/lib/SafeAnchor.js");
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  componentClass: _elementType2['default'],
	  href: _propTypes2['default'].string,
	  /**
	   * Defines HTML button type attribute
	   * @defaultValue 'button'
	   */
	  type: _propTypes2['default'].oneOf(['button', 'reset', 'submit'])
	};
	
	var defaultProps = {
	  active: false,
	  block: false,
	  disabled: false
	};
	
	var Button = function (_React$Component) {
	  (0, _inherits3['default'])(Button, _React$Component);
	
	  function Button() {
	    (0, _classCallCheck3['default'])(this, Button);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
	    return _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, elementProps.disabled && 'disabled')
	    }));
	  };
	
	  Button.prototype.renderButton = function renderButton(_ref, className) {
	    var componentClass = _ref.componentClass,
	        elementProps = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass']);
	
	    var Component = componentClass || 'button';
	
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, elementProps, {
	      type: elementProps.type || 'button',
	      className: className
	    }));
	  };
	
	  Button.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        active = _props.active,
	        block = _props.block,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'block', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
	    var fullClassName = (0, _classnames2['default'])(className, classes);
	
	    if (elementProps.href) {
	      return this.renderAnchor(elementProps, fullClassName);
	    }
	
	    return this.renderButton(elementProps, fullClassName);
	  };
	
	  return Button;
	}(_react2['default'].Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/babel-runtime/core-js/object/values.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/values.js"), __esModule: true };

/***/ },

/***/ "./node_modules/core-js/library/fn/object/values.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es7.object.values.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.values;


/***/ },

/***/ "./node_modules/core-js/library/modules/es7.object.values.js":
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	var $values = __webpack_require__("./node_modules/core-js/library/modules/_object-to-array.js")(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },

/***/ "./node_modules/core-js/library/modules/_object-to-array.js":
/***/ function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
	var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
	var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
	var isEnum = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js").f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ },

/***/ "./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;
	
	var _entries = __webpack_require__("./node_modules/babel-runtime/core-js/object/entries.js");
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	
	function prefix(props, variant) {
	  !(props.bsClass != null) ?  false ? (0, _invariant2['default'])(false, 'A `bsClass` prop is required for this component') : (0, _invariant2['default'])(false) : void 0;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _propTypes2['default'].string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _propTypes2['default'].oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = propType._values = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _propTypes2['default'].oneOf(values);
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref2) {
	    var propName = _ref2[0],
	        propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = exports._curry = curry;

/***/ },

/***/ "./node_modules/babel-runtime/core-js/object/entries.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/entries.js"), __esModule: true };

/***/ },

/***/ "./node_modules/core-js/library/fn/object/entries.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es7.object.entries.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.entries;


/***/ },

/***/ "./node_modules/core-js/library/modules/es7.object.entries.js":
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	var $entries = __webpack_require__("./node_modules/core-js/library/modules/_object-to-array.js")(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },

/***/ "./node_modules/react-bootstrap/lib/utils/StyleConfig.js":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var Size = exports.Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	
	var SIZE_MAP = exports.SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	
	var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	
	var State = exports.State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	
	var Style = exports.Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};

/***/ },

/***/ "./node_modules/react-bootstrap/lib/SafeAnchor.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  disabled: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string,
	  tabIndex: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = function (_React$Component) {
	  (0, _inherits3['default'])(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    (0, _classCallCheck3['default'])(this, SafeAnchor);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        href = _props.href,
	        onClick = _props.onClick;
	
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        disabled = _props2.disabled,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'disabled']);
	
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button';
	      // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	      props.href = props.href || '#';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends3['default'])({ pointerEvents: 'none' }, props.style);
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	      onClick: this.handleClick
	    }));
	  };
	
	  return SafeAnchor;
	}(_react2['default'].Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	
	exports['default'] = SafeAnchor;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/DropdownMenu.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DropdownMenu = __webpack_require__("./node_modules/react-bootstrap/lib/DropdownMenu.js");
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DropdownMenu2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/DropdownMenu.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _from = __webpack_require__("./node_modules/babel-runtime/core-js/array/from.js");
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__("./node_modules/keycode/index.js");
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _RootCloseWrapper = __webpack_require__("./node_modules/react-overlays/lib/RootCloseWrapper.js");
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js");
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  open: _propTypes2['default'].bool,
	  pullRight: _propTypes2['default'].bool,
	  onClose: _propTypes2['default'].func,
	  labelledBy: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  onSelect: _propTypes2['default'].func,
	  rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown'])
	};
	
	var defaultProps = {
	  bsRole: 'menu',
	  pullRight: false
	};
	
	var DropdownMenu = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    (0, _classCallCheck3['default'])(this, DropdownMenu);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.handleRootClose = _this.handleRootClose.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
	    this.props.onClose(event, { source: 'rootClose' });
	  };
	
	  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.props.onClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeIndex = items.indexOf(document.activeElement);
	
	    return { items: items, activeIndex: activeIndex };
	  };
	
	  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
	    var node = _reactDom2['default'].findDOMNode(this);
	    if (!node) {
	      return [];
	    }
	
	    return (0, _from2['default'])(node.querySelectorAll('[tabIndex="-1"]'));
	  };
	
	  DropdownMenu.prototype.focusNext = function focusNext() {
	    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd.items,
	        activeIndex = _getItemsAndActiveInd.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
	    items[nextIndex].focus();
	  };
	
	  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
	    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd2.items,
	        activeIndex = _getItemsAndActiveInd2.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
	    items[prevIndex].focus();
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var _extends2,
	        _this2 = this;
	
	    var _props = this.props,
	        open = _props.open,
	        pullRight = _props.pullRight,
	        labelledBy = _props.labelledBy,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onClose']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
	
	    return _react2['default'].createElement(
	      _RootCloseWrapper2['default'],
	      {
	        disabled: !open,
	        onRootClose: this.handleRootClose,
	        event: rootCloseEvent
	      },
	      _react2['default'].createElement(
	        'ul',
	        (0, _extends4['default'])({}, elementProps, {
	          role: 'menu',
	          className: (0, _classnames2['default'])(className, classes),
	          'aria-labelledby': labelledBy
	        }),
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, _this2.handleKeyDown),
	            onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	          });
	        })
	      )
	    );
	  };
	
	  return DropdownMenu;
	}(_react2['default'].Component);
	
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/babel-runtime/core-js/array/from.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/array/from.js"), __esModule: true };

/***/ },

/***/ "./node_modules/core-js/library/fn/array/from.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
	__webpack_require__("./node_modules/core-js/library/modules/es6.array.from.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Array.from;


/***/ },

/***/ "./node_modules/core-js/library/modules/es6.array.from.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
	var call = __webpack_require__("./node_modules/core-js/library/modules/_iter-call.js");
	var isArrayIter = __webpack_require__("./node_modules/core-js/library/modules/_is-array-iter.js");
	var toLength = __webpack_require__("./node_modules/core-js/library/modules/_to-length.js");
	var createProperty = __webpack_require__("./node_modules/core-js/library/modules/_create-property.js");
	var getIterFn = __webpack_require__("./node_modules/core-js/library/modules/core.get-iterator-method.js");
	
	$export($export.S + $export.F * !__webpack_require__("./node_modules/core-js/library/modules/_iter-detect.js")(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },

/***/ "./node_modules/core-js/library/modules/_iter-call.js":
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_is-array-iter.js":
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
	var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_create-property.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
	var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_iter-detect.js":
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },

/***/ "./node_modules/react-overlays/lib/RootCloseWrapper.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _contains = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/query/contains.js");
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__("./node_modules/react-overlays/lib/utils/addEventListener.js");
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__("./node_modules/react-overlays/lib/utils/ownerDocument.js");
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, (RootCloseWrapper.__proto__ || Object.getPrototypeOf(RootCloseWrapper)).call(this, props, context));
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  _createClass(RootCloseWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.disabled) {
	        this.addEventListeners();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!this.props.disabled && prevProps.disabled) {
	        this.addEventListeners();
	      } else if (this.props.disabled && !prevProps.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.props.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'addEventListeners',
	    value: function addEventListeners() {
	      var event = this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, this.handleMouseCapture, true);
	
	      this.documentMouseListener = (0, _addEventListener2.default)(doc, event, this.handleMouse);
	
	      this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'removeEventListeners',
	    value: function removeEventListeners() {
	      if (this.documentMouseCaptureListener) {
	        this.documentMouseCaptureListener.remove();
	      }
	
	      if (this.documentMouseListener) {
	        this.documentMouseListener.remove();
	      }
	
	      if (this.documentKeyupListener) {
	        this.documentKeyupListener.remove();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _react2.default.PropTypes.func,
	  /**
	   * Children to render.
	   */
	  children: _react2.default.PropTypes.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _react2.default.PropTypes.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _react2.default.PropTypes.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/query/contains.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/util/inDOM.js"));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js":
/***/ function(module, exports) {

	function _interopRequireDefault(e) {
	  return e && e.__esModule ? e : {
	    "default": e
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/util/inDOM.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/lib/utils/addEventListener.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/events/on.js");
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/events/off.js");
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/events/on.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/util/inDOM.js"));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/events/off.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/util/inDOM.js"));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/lib/utils/ownerDocument.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/ownerDocument.js");
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/ownerDocument.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/utils/createChainedFunction.js":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports['default'] = createChainedFunction;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	
	  return _react2['default'].Children.map(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	// TODO: This module should be ElementChildren, and should use named exports.
	
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function count(children) {
	  var result = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result = undefined;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function every(children, func, context) {
	  var index = 0;
	  var result = true;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (!func.call(context, child, index++)) {
	      result = false;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	function toArray(children) {
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    result.push(child);
	  });
	
	  return result;
	}
	
	exports['default'] = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  every: every,
	  some: some,
	  toArray: toArray
	};
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/DropdownToggle.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Button.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/SafeAnchor.js");
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  noCaret: _react2.default.PropTypes.bool,
	  open: _react2.default.PropTypes.bool,
	  title: _react2.default.PropTypes.string,
	  useAnchor: _react2.default.PropTypes.bool
	};
	
	var defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	var DropdownToggle = function (_React$Component) {
	  (0, _inherits3.default)(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    (0, _classCallCheck3.default)(this, DropdownToggle);
	    return (0, _possibleConstructorReturn3.default)(this, (DropdownToggle.__proto__ || (0, _getPrototypeOf2.default)(DropdownToggle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DropdownToggle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          noCaret = _props.noCaret,
	          open = _props.open,
	          useAnchor = _props.useAnchor,
	          bsClass = _props.bsClass,
	          className = _props.className,
	          children = _props.children,
	          props = (0, _objectWithoutProperties3.default)(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);
	
	
	      delete props.bsRole;
	
	      var Component = useAnchor ? _SafeAnchor2.default : _Button2.default;
	      var useCaret = !noCaret;
	
	      // This intentionally forwards bsSize and bsStyle (if set) to the
	      // underlying component, to allow it to render size and style variants.
	
	      // FIXME: Should this really fall back to `title` as children?
	
	      return _react2.default.createElement(
	        Component,
	        (0, _extends3.default)({}, props, {
	          role: 'button',
	          className: (0, _classnames2.default)(className, bsClass),
	          'aria-haspopup': true,
	          'aria-expanded': open
	        }),
	        children || props.title,
	        useCaret && ' ',
	        useCaret && _react2.default.createElement('span', { className: 'caret' })
	      );
	    }
	  }]);
	  return DropdownToggle;
	}(_react2.default.Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Button.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__("./node_modules/react-bootstrap/lib/Button.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var expectedTypes = ["success", "warning", "danger", "info", "default", "primary", "link"];
	
	function isBtnOfType(type) {
	  for (var i = 0; i < expectedTypes.length; i++) {
	    if (expectedTypes[i] === type) {
	      return true;
	    }
	  }
	  return false;
	}
	
	var Button = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(Button, _React$Component);
	
	  function Button() {
	    (0, _classCallCheck3.default)(this, Button);
	    return (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Button, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	
	      if (props.close) {
	        console.error('Button "close" prop has been deprecated in Rubix v4.0.0');
	      }
	
	      if (props.xs) {
	        props.bsSize = 'xsmall';
	        delete props.xs;
	      }
	
	      if (props.sm) {
	        props.bsSize = 'small';
	        delete props.sm;
	      }
	
	      if (props.lg) {
	        props.bsSize = 'large';
	        delete props.lg;
	      }
	
	      if (props.hasOwnProperty('bsStyle') && typeof props.bsStyle === 'string') {
	        var styles = props.bsStyle.split(/\s|\,/mgi).filter(function (a) {
	          return a;
	        });
	        for (var i = 0; i < styles.length; i++) {
	          if (isBtnOfType(styles[i])) {
	            props.bsStyle = styles[i];
	          } else {
	            props.className = (0, _classnames2.default)(props.className, 'btn-' + styles[i]);
	            props.bsStyle = 'default';
	          }
	        }
	      }
	
	      if (props.retainBackground) {
	        props.className = (0, _classnames2.default)(props.className, 'btn-retainBg');
	      }
	
	      if (props.rounded) {
	        props.className = (0, _classnames2.default)(props.className, 'btn-rounded');
	      }
	
	      if (props.onlyOnHover) {
	        props.className = (0, _classnames2.default)(props.className, 'btn-onlyOnHover');
	      }
	
	      if (props.inverse || props.retainBackground) {
	        props.className = (0, _classnames2.default)(props.className, 'btn-inverse');
	      }
	
	      if (props.outlined || props.onlyOnHover || props.inverse || props.retainBackground) {
	        props.className = (0, _classnames2.default)(props.className, 'btn-outlined');
	      }
	
	      delete props.retainBackground;
	      delete props.rounded;
	      delete props.onlyOnHover;
	      delete props.inverse;
	      delete props.outlined;
	
	      return _react2.default.createElement(_Button2.default, props);
	    }
	  }]);
	  return Button;
	}(_react2.default.Component), _class.propTypes = {
	  xs: _react2.default.PropTypes.bool,
	  sm: _react2.default.PropTypes.bool,
	  lg: _react2.default.PropTypes.bool,
	  rounded: _react2.default.PropTypes.bool,
	  onlyOnHover: _react2.default.PropTypes.bool,
	  retainBackground: _react2.default.PropTypes.bool,
	  inverse: _react2.default.PropTypes.bool,
	  outlined: _react2.default.PropTypes.bool
	}, _temp);
	exports.default = Button;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/SafeAnchor.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  href: _react2.default.PropTypes.string,
	  onClick: _react2.default.PropTypes.func,
	  disabled: _react2.default.PropTypes.bool,
	  role: _react2.default.PropTypes.string,
	  tabIndex: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number, _react2.default.PropTypes.string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = function (_React$Component) {
	  (0, _inherits3.default)(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    (0, _classCallCheck3.default)(this, SafeAnchor);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SafeAnchor.__proto__ || (0, _getPrototypeOf2.default)(SafeAnchor)).call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(SafeAnchor, [{
	    key: 'handleClick',
	    value: function handleClick(event) {
	      var _props = this.props,
	          disabled = _props.disabled,
	          href = _props.href,
	          onClick = _props.onClick;
	
	
	      if (disabled || isTrivialHref(href)) {
	        event.preventDefault();
	      }
	
	      if (disabled) {
	        event.stopPropagation();
	        return;
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          Component = _props2.componentClass,
	          disabled = _props2.disabled,
	          props = (0, _objectWithoutProperties3.default)(_props2, ['componentClass', 'disabled']);
	
	
	      if (isTrivialHref(props.href)) {
	        props.role = props.role || 'button';
	        // we want to make sure there is a href attribute on the node
	        // otherwise, the cursor incorrectly styled (except with role='button')
	        props.href = props.href || '';
	      }
	
	      if (disabled) {
	        props.tabIndex = -1;
	        props.style = (0, _extends3.default)({ pointerEvents: 'none' }, props.style);
	      }
	
	      delete props.bsStyle;
	
	      return _react2.default.createElement(Component, (0, _extends3.default)({}, props, {
	        onClick: this.handleClick
	      }));
	    }
	  }]);
	  return SafeAnchor;
	}(_react2.default.Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	
	exports.default = SafeAnchor;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/utils/PropTypes.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.requiredRoles = requiredRoles;
	exports.exclusiveRoles = exclusiveRoles;
	
	var _createChainableTypeChecker = __webpack_require__("./node_modules/react-prop-types/lib/utils/createChainableTypeChecker.js");
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	var _ValidComponentChildren = __webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js");
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function requiredRoles() {
	  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
	    roles[_key] = arguments[_key];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var missing = void 0;
	
	    roles.every(function (role) {
	      if (!_ValidComponentChildren2['default'].some(props.children, function (child) {
	        return child.props.bsRole === role;
	      })) {
	        missing = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (missing) {
	      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}
	
	function exclusiveRoles() {
	  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    roles[_key2] = arguments[_key2];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var duplicate = void 0;
	
	    roles.every(function (role) {
	      var childrenWithRole = _ValidComponentChildren2['default'].filter(props.children, function (child) {
	        return child.props.bsRole === role;
	      });
	
	      if (childrenWithRole.length > 1) {
	        duplicate = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (duplicate) {
	      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}

/***/ },

/***/ "./node_modules/react-bootstrap/lib/utils/splitComponentProps.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _entries = __webpack_require__("./node_modules/babel-runtime/core-js/object/entries.js");
	
	var _entries2 = _interopRequireDefault(_entries);
	
	exports["default"] = splitComponentProps;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function splitComponentProps(props, Component) {
	  var componentPropTypes = Component.propTypes;
	
	  var parentProps = {};
	  var childProps = {};
	
	  (0, _entries2["default"])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (componentPropTypes[propName]) {
	      parentProps[propName] = propValue;
	    } else {
	      childProps[propName] = propValue;
	    }
	  });
	
	  return [parentProps, childProps];
	}
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/isBrowser.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return typeof window !== 'undefined';
	};

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/isTouchDevice.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTouchDevice;
	
	var _isBrowser = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/isBrowser.js");
	
	var _isBrowser2 = _interopRequireDefault(_isBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function enableClassListShim() {
	  if ((0, _isBrowser2.default)()) {
	
	    /*
	     * classList.js: Cross-browser full element.classList implementation.
	     * 2014-07-23
	     *
	     * By Eli Grey, http://eligrey.com
	     * Public Domain.
	     * NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
	     */
	
	    /*global window, document, DOMException */
	
	    /*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js*/
	
	    if ("document" in window) {
	
	      // Full polyfill for browsers with no classList support
	      if (!("classList" in document.createElement("_"))) {
	
	        (function (view) {
	
	          "use strict";
	
	          if (!('Element' in view)) return;
	
	          var classListProp = "classList",
	              protoProp = "prototype",
	              elemCtrProto = view.Element[protoProp],
	              objCtr = Object,
	              strTrim = String[protoProp].trim || function () {
	            return this.replace(/^\s+|\s+$/g, "");
	          },
	              arrIndexOf = Array[protoProp].indexOf || function (item) {
	            var i = 0,
	                len = this.length;
	            for (; i < len; i++) {
	              if (i in this && this[i] === item) {
	                return i;
	              }
	            }
	            return -1;
	          }
	          // Vendors: please allow content code to instantiate DOMExceptions
	          ,
	              DOMEx = function DOMEx(type, message) {
	            this.name = type;
	            this.code = DOMException[type];
	            this.message = message;
	          },
	              checkTokenAndGetIndex = function checkTokenAndGetIndex(classList, token) {
	            if (token === "") {
	              throw new DOMEx("SYNTAX_ERR", "An invalid or illegal string was specified");
	            }
	            if (/\s/.test(token)) {
	              throw new DOMEx("INVALID_CHARACTER_ERR", "String contains an invalid character");
	            }
	            return arrIndexOf.call(classList, token);
	          },
	              ClassList = function ClassList(elem) {
	            var trimmedClasses = strTrim.call(elem.getAttribute("class") || ""),
	                classes = trimmedClasses ? trimmedClasses.split(/\s+/) : [],
	                i = 0,
	                len = classes.length;
	            for (; i < len; i++) {
	              this.push(classes[i]);
	            }
	            this._updateClassName = function () {
	              elem.setAttribute("class", this.toString());
	            };
	          },
	              classListProto = ClassList[protoProp] = [],
	              classListGetter = function classListGetter() {
	            return new ClassList(this);
	          };
	          // Most DOMException implementations don't allow calling DOMException's toString()
	          // on non-DOMExceptions. Error's toString() is sufficient here.
	          DOMEx[protoProp] = Error[protoProp];
	          classListProto.item = function (i) {
	            return this[i] || null;
	          };
	          classListProto.contains = function (token) {
	            token += "";
	            return checkTokenAndGetIndex(this, token) !== -1;
	          };
	          classListProto.add = function () {
	            var tokens = arguments,
	                i = 0,
	                l = tokens.length,
	                token,
	                updated = false;
	            do {
	              token = tokens[i] + "";
	              if (checkTokenAndGetIndex(this, token) === -1) {
	                this.push(token);
	                updated = true;
	              }
	            } while (++i < l);
	
	            if (updated) {
	              this._updateClassName();
	            }
	          };
	          classListProto.remove = function () {
	            var tokens = arguments,
	                i = 0,
	                l = tokens.length,
	                token,
	                updated = false,
	                index;
	            do {
	              token = tokens[i] + "";
	              index = checkTokenAndGetIndex(this, token);
	              while (index !== -1) {
	                this.splice(index, 1);
	                updated = true;
	                index = checkTokenAndGetIndex(this, token);
	              }
	            } while (++i < l);
	
	            if (updated) {
	              this._updateClassName();
	            }
	          };
	          classListProto.toggle = function (token, force) {
	            token += "";
	
	            var result = this.contains(token),
	                method = result ? force !== true && "remove" : force !== false && "add";
	
	            if (method) {
	              this[method](token);
	            }
	
	            if (force === true || force === false) {
	              return force;
	            } else {
	              return !result;
	            }
	          };
	          classListProto.toString = function () {
	            return this.join(" ");
	          };
	
	          if (objCtr.defineProperty) {
	            var classListPropDesc = {
	              get: classListGetter,
	              enumerable: true,
	              configurable: true
	            };
	            try {
	              objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	            } catch (ex) {
	              // IE 8 doesn't support enumerable:true
	              if (ex.number === -0x7FF5EC54) {
	                classListPropDesc.enumerable = false;
	                objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	              }
	            }
	          } else if (objCtr[protoProp].__defineGetter__) {
	            elemCtrProto.__defineGetter__(classListProp, classListGetter);
	          }
	        })(window);
	      } else {
	        // There is full or partial native classList support, so just check if we need
	        // to normalize the add/remove and toggle APIs.
	
	        (function () {
	          "use strict";
	
	          var testElement = document.createElement("_");
	
	          testElement.classList.add("c1", "c2");
	
	          // Polyfill for IE 10/11 and Firefox <26, where classList.add and
	          // classList.remove exist but support only one argument at a time.
	          if (!testElement.classList.contains("c2")) {
	            var createMethod = function createMethod(method) {
	              var original = DOMTokenList.prototype[method];
	
	              DOMTokenList.prototype[method] = function (token) {
	                var i,
	                    len = arguments.length;
	
	                for (i = 0; i < len; i++) {
	                  token = arguments[i];
	                  original.call(this, token);
	                }
	              };
	            };
	            createMethod('add');
	            createMethod('remove');
	          }
	
	          testElement.classList.toggle("c3", false);
	
	          // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
	          // support the second argument.
	          if (testElement.classList.contains("c3")) {
	            var _toggle = DOMTokenList.prototype.toggle;
	
	            DOMTokenList.prototype.toggle = function (token, force) {
	              if (1 in arguments && !this.contains(token) === !force) {
	                return force;
	              } else {
	                return _toggle.call(this, token);
	              }
	            };
	          }
	
	          testElement = null;
	        })();
	      }
	    }
	  }
	}
	
	enableClassListShim();
	
	function isTouchDevice() {
	  if ((0, _isBrowser2.default)()) {
	    var confirmed = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
	
	    if (confirmed) {
	      var html = document.getElementsByTagName('html')[0];
	      html.classList.add('touchevents');
	    }
	
	    return confirmed;
	  }
	
	  return false;
	};

/***/ },

/***/ "./node_modules/request-frame/dist/request-frame.js":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * request-frame - requestAnimationFrame & cancelAnimationFrame polyfill for optimal cross-browser development.
	 * @version v1.5.3
	 * @license MIT
	 * Copyright Julien Etienne 2015 All Rights Reserved.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.requestFrame = factory());
	}(this, (function () { 'use strict';
	
	/**
	 * @param  {String} type - request | cancel | native.
	 * @return {Function} Timing function.
	 */
	function requestFrame(type) {
	    // The only vendor prefixes required.
	    var vendors = ['moz', 'webkit'];
	
	    // Disassembled timing function abbreviations.
	    var aF = 'AnimationFrame';
	    var rqAF = 'Request' + aF;
	
	    // Checks for firefox 4 - 10 function pair mismatch.
	    var mozRAF = window.mozRequestAnimationFrame;
	    var mozCAF = window.mozCancelAnimationFrame;
	    var hasMozMismatch = mozRAF && !mozCAF;
	
	    // Final assigned functions.
	    var assignedRequestAnimationFrame;
	    var assignedCancelAnimationFrame;
	
	    // Initial time of the timing lapse.
	    var previousTime = 0;
	
	    var requestFrameMain;
	
	    // Date.now polyfill, mainly for legacy IE versions.
	    if (!Date.now) {
	        Date.now = function () {
	            return new Date().getTime();
	        };
	    }
	
	    /**
	     * hasIOS6RequestAnimationFrameBug.
	     * @See {@Link https://gist.github.com/julienetie/86ac394ec41f1271ff0a}
	     * - for Commentary.
	     * @Copyright 2015 - Julien Etienne. 
	     * @License: MIT.
	     */
	    function hasIOS6RequestAnimationFrameBug() {
	        var webkitRAF = window.webkitRequestAnimationFrame;
	        var rAF = window.requestAnimationFrame;
	
	        // CSS/ Device with max for iOS6 Devices.
	        var hasMobileDeviceWidth = screen.width <= 768 ? true : false;
	
	        // Only supports webkit prefixed requestAnimtionFrane.
	        var requiresWebkitprefix = !(webkitRAF && rAF);
	
	        // iOS6 webkit browsers don't support performance now.
	        var hasNoNavigationTiming = window.performance ? false : true;
	
	        var iOS6Notice = 'setTimeout is being used as a substitiue for \n            requestAnimationFrame due to a bug within iOS 6 builds';
	
	        var hasIOS6Bug = requiresWebkitprefix && hasMobileDeviceWidth && hasNoNavigationTiming;
	
	        var bugCheckresults = function bugCheckresults(timingFnA, timingFnB, notice) {
	            if (timingFnA || timingFnB) {
	                console.warn(notice);
	                return true;
	            } else {
	                return false;
	            }
	        };
	
	        var displayResults = function displayResults(hasBug, hasBugNotice, webkitFn, nativeFn) {
	            if (hasBug) {
	                return bugCheckresults(webkitFn, nativeFn, hasBugNotice);
	            } else {
	                return false;
	            }
	        };
	
	        return displayResults(hasIOS6Bug, iOS6Notice, webkitRAF, rAF);
	    }
	
	    /**
	     * Native clearTimeout function.
	     * @return {Function}
	     */
	    function clearTimeoutWithId(id) {
	        clearTimeout(id);
	    }
	
	    /**
	     * Based on a polyfill by Erik, introduced by Paul Irish & 
	     * further improved by Darius Bacon.
	     * @see  {@link http://www.paulirish.com/2011/
	     * requestanimationframe-for-smart-animating}
	     * @see  {@link https://github.com/darius/requestAnimationFrame/blob/
	     * master/requestAnimationFrame.js}
	     * @callback {Number} Timestamp.
	     * @return {Function} setTimeout Function.
	     */
	    function setTimeoutWithTimestamp(callback) {
	        var immediateTime = Date.now();
	        var lapsedTime = Math.max(previousTime + 16, immediateTime);
	        return setTimeout(function () {
	            callback(previousTime = lapsedTime);
	        }, lapsedTime - immediateTime);
	    }
	
	    /**
	     * Queries the native function, prefixed function 
	     * or use the setTimeoutWithTimestamp function.
	     * @return {Function}
	     */
	    function queryRequestAnimationFrame() {
	        if (Array.prototype.filter) {
	            assignedRequestAnimationFrame = window['request' + aF] || window[vendors.filter(function (vendor) {
	                if (window[vendor + rqAF] !== undefined) return vendor;
	            }) + rqAF] || setTimeoutWithTimestamp;
	        } else {
	            return setTimeoutWithTimestamp;
	        }
	        if (!hasIOS6RequestAnimationFrameBug()) {
	            return assignedRequestAnimationFrame;
	        } else {
	            return setTimeoutWithTimestamp;
	        }
	    }
	
	    /**
	     * Queries the native function, prefixed function 
	     * or use the clearTimeoutWithId function.
	     * @return {Function}
	     */
	    function queryCancelAnimationFrame() {
	        var cancellationNames = [];
	        if (Array.prototype.map) {
	            vendors.map(function (vendor) {
	                return ['Cancel', 'CancelRequest'].map(function (cancellationNamePrefix) {
	                    cancellationNames.push(vendor + cancellationNamePrefix + aF);
	                });
	            });
	        } else {
	            return clearTimeoutWithId;
	        }
	
	        /**
	         * Checks for the prefixed cancelAnimationFrame implementation.
	         * @param  {Array} prefixedNames - An array of the prefixed names. 
	         * @param  {Number} i - Iteration start point.
	         * @return {Function} prefixed cancelAnimationFrame function.
	         */
	        function prefixedCancelAnimationFrame(prefixedNames, i) {
	            var cancellationFunction = void 0;
	            for (; i < prefixedNames.length; i++) {
	                if (window[prefixedNames[i]]) {
	                    cancellationFunction = window[prefixedNames[i]];
	                    break;
	                }
	            }
	            return cancellationFunction;
	        }
	
	        // Use truthly function
	        assignedCancelAnimationFrame = window['cancel' + aF] || prefixedCancelAnimationFrame(cancellationNames, 0) || clearTimeoutWithId;
	
	        // Check for iOS 6 bug
	        if (!hasIOS6RequestAnimationFrameBug()) {
	            return assignedCancelAnimationFrame;
	        } else {
	            return clearTimeoutWithId;
	        }
	    }
	
	    function getRequestFn() {
	        if (hasMozMismatch) {
	            return setTimeoutWithTimestamp;
	        } else {
	            return queryRequestAnimationFrame();
	        }
	    }
	
	    function getCancelFn() {
	        return queryCancelAnimationFrame();
	    }
	
	    function setNativeFn() {
	        if (hasMozMismatch) {
	            window.requestAnimationFrame = setTimeoutWithTimestamp;
	            window.cancelAnimationFrame = clearTimeoutWithId;
	        } else {
	            window.requestAnimationFrame = queryRequestAnimationFrame();
	            window.cancelAnimationFrame = queryCancelAnimationFrame();
	        }
	    }
	
	    /**
	     * The type value "request" singles out firefox 4 - 10 and 
	     * assigns the setTimeout function if plausible.
	     */
	
	    switch (type) {
	        case 'request':
	        case '':
	            requestFrameMain = getRequestFn();
	            break;
	
	        case 'cancel':
	            requestFrameMain = getCancelFn();
	            break;
	
	        case 'native':
	            setNativeFn();
	            break;
	        default:
	            throw new Error('RequestFrame parameter is not a type.');
	    }
	    return requestFrameMain;
	}
	
	return requestFrame;
	
	})));


/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Panel.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PanelBody = exports.PanelRight = exports.PanelLeft = exports.PanelFooter = exports.PanelHeader = exports.Panel = exports.PanelTabContainer = exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp, _class2, _temp2, _class3, _temp3;
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Icon.js");
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Button.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TabContainer = __webpack_require__("./node_modules/react-bootstrap/lib/TabContainer.js");
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PanelContainer = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(PanelContainer, _React$Component);
	
	  function PanelContainer() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, PanelContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = PanelContainer.__proto__ || (0, _getPrototypeOf2.default)(PanelContainer)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = {
	      collapse: false, style: {}, hidden: false, glyph: 'minus'
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(PanelContainer, [{
	    key: 'getBtnProps',
	    value: function getBtnProps(func) {
	      return {
	        onClick: func,
	        onTouchEnd: func
	      };
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      this.setState({
	        collapse: true
	      });
	
	      if (this.props.onRemove) this.props.onRemove();
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      this.setState({
	        hidden: false,
	        glyph: 'minus',
	        style: {}
	      });
	
	      if (this.props.onShow) this.props.onShow();
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      this.setState({
	        hidden: true,
	        glyph: 'plus',
	        style: {
	          height: 16,
	          overflow: 'hidden'
	        }
	      });
	
	      this._node.scrollTop = 0;
	
	      if (this.props.onHide) this.props.onHide();
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      if (this.state.hidden) {
	        this.show();
	      } else {
	        this.hide();
	      }
	
	      if (this.props.onToggle) this.props.onToggle();
	    }
	  }, {
	    key: 'maximize',
	    value: function maximize() {
	      if (this.props.handleMaximize) {
	        this.props.handleMaximize();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref2, oldProps) {
	      var minimize = _ref2.minimize;
	
	      if (minimize === oldProps.minimize) return;
	
	      if (minimize === true) {
	        this.hide();
	      } else if (minimize === false) {
	        this.show();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.minimize === true) {
	        this.hide();
	      }
	    }
	  }, {
	    key: 'renderControls',
	    value: function renderControls() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'rubix-panel-controls' },
	        _react2.default.createElement(
	          _Button2.default,
	          this.getBtnProps(this.maximize.bind(this)),
	          _react2.default.createElement(_Icon2.default, { bundle: 'fontello', glyph: 'loop-alt-1' })
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          this.getBtnProps(this.toggle.bind(this)),
	          _react2.default.createElement(_Icon2.default, { bundle: 'fontello', glyph: this.state.glyph })
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          this.getBtnProps(this.remove.bind(this)),
	          _react2.default.createElement(_Icon2.default, { bundle: 'fontello', glyph: 'cancel' })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var props = (0, _extends3.default)({}, this.props);
	      var controls = this.renderControls();
	
	      if (props.controls === false) {
	        controls = null;
	      } else if (props.controls !== undefined) {
	        controls = _react2.default.createElement(
	          'div',
	          { className: 'rubix-panel-controls' },
	          this.props.controls
	        );
	      }
	
	      props.className = (0, _classnames2.default)('rubix-panel-container-with-controls', props.className, {
	        active: this.state.style.height === 16
	      });
	
	      var panelClassname = (0, _classnames2.default)('rubix-panel-container', {
	        'bordered': this.props.bordered,
	        'panel-plain': this.props.plain,
	        'noOverflow': this.props.noOverflow,
	        'panel-gutter-bottom': this.props.gutterBottom,
	        'panel-collapse-bottom': this.props.collapseBottom
	      }, this.props.containerClasses);
	
	      if (this.state.collapse) return null;
	
	      delete props.minimize;
	      delete props.controls;
	      delete props.containerClasses;
	      delete props.collapseBottom;
	      delete props.gutterBottom;
	      delete props.noOverflow;
	      delete props.bordered;
	      delete props.plain;
	      delete props.onMaximize;
	      delete props.onShow;
	      delete props.onHide;
	      delete props.onToggle;
	      delete props.onRemove;
	      delete props.defaultActiveKey;
	      delete props.generateChildId;
	      delete props.onSelect;
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, props, { ref: function ref(c) {
	            return _this2._node = c;
	          } }),
	        controls,
	        _react2.default.createElement(
	          'div',
	          { className: panelClassname, style: this.state.style },
	          this.props.children
	        )
	      );
	    }
	  }]);
	  return PanelContainer;
	}(_react2.default.Component), _class.propTypes = {
	  controls: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.element]),
	  minimize: _react2.default.PropTypes.bool,
	  containerClasses: _react2.default.PropTypes.string,
	  collapseBottom: _react2.default.PropTypes.bool,
	  gutterBottom: _react2.default.PropTypes.bool,
	  noOverflow: _react2.default.PropTypes.bool,
	  bordered: _react2.default.PropTypes.bool,
	  plain: _react2.default.PropTypes.bool,
	  onMaximize: _react2.default.PropTypes.func,
	  onShow: _react2.default.PropTypes.func,
	  onHide: _react2.default.PropTypes.func,
	  onToggle: _react2.default.PropTypes.func,
	  onRemove: _react2.default.PropTypes.func
	}, _temp);
	exports.default = PanelContainer;
	var PanelTabContainer = exports.PanelTabContainer = (_temp2 = _class2 = function (_React$Component2) {
	  (0, _inherits3.default)(PanelTabContainer, _React$Component2);
	
	  function PanelTabContainer() {
	    (0, _classCallCheck3.default)(this, PanelTabContainer);
	    return (0, _possibleConstructorReturn3.default)(this, (PanelTabContainer.__proto__ || (0, _getPrototypeOf2.default)(PanelTabContainer)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PanelTabContainer, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props, {
	        className: (0, _classnames2.default)('panel-tab-container', this.props.className)
	      });
	
	      return _react2.default.createElement(
	        _TabContainer2.default,
	        { id: this.props.id, activeKey: this.props.activeKey, defaultActiveKey: this.props.defaultActiveKey, onSelect: this.props.onSelect, generateChildId: this.props.generateChildId },
	        _react2.default.createElement(PanelContainer, (0, _extends3.default)({}, props, { id: null, activeKey: null, defaultActiveKey: null, onSelect: null, generateChildId: null }))
	      );
	    }
	  }]);
	  return PanelTabContainer;
	}(_react2.default.Component), _class2.propTypes = {
	  id: _react2.default.PropTypes.string.isRequired,
	  activeKey: _react2.default.PropTypes.any,
	  defaultActiveKey: _react2.default.PropTypes.any,
	  onSelect: _react2.default.PropTypes.func,
	  generateChildId: _react2.default.PropTypes.func
	}, _temp2);
	var Panel = exports.Panel = (_temp3 = _class3 = function (_React$Component3) {
	  (0, _inherits3.default)(Panel, _React$Component3);
	
	  function Panel() {
	    (0, _classCallCheck3.default)(this, Panel);
	    return (0, _possibleConstructorReturn3.default)(this, (Panel.__proto__ || (0, _getPrototypeOf2.default)(Panel)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Panel, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	      props.className = (0, _classnames2.default)('rubix-panel', {
	        horizontal: props.horizontal
	      }, props.className);
	
	      delete props.horizontal;
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, props, { children: null }),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.props.children
	        )
	      );
	    }
	  }]);
	  return Panel;
	}(_react2.default.Component), _class3.propTypes = {
	  horizontal: _react2.default.PropTypes.bool
	}, _temp3);
	
	var PanelHeader = exports.PanelHeader = function (_React$Component4) {
	  (0, _inherits3.default)(PanelHeader, _React$Component4);
	
	  function PanelHeader() {
	    (0, _classCallCheck3.default)(this, PanelHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (PanelHeader.__proto__ || (0, _getPrototypeOf2.default)(PanelHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PanelHeader, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	      props.className = (0, _classnames2.default)('rubix-panel-header', props.className);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, props, { children: null }),
	        this.props.children
	      );
	    }
	  }]);
	  return PanelHeader;
	}(_react2.default.Component);
	
	var PanelFooter = exports.PanelFooter = function (_React$Component5) {
	  (0, _inherits3.default)(PanelFooter, _React$Component5);
	
	  function PanelFooter() {
	    (0, _classCallCheck3.default)(this, PanelFooter);
	    return (0, _possibleConstructorReturn3.default)(this, (PanelFooter.__proto__ || (0, _getPrototypeOf2.default)(PanelFooter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PanelFooter, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	      props.className = (0, _classnames2.default)('rubix-panel-footer', props.className);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, props, { children: null }),
	        this.props.children
	      );
	    }
	  }]);
	  return PanelFooter;
	}(_react2.default.Component);
	
	var PanelLeft = exports.PanelLeft = function (_React$Component6) {
	  (0, _inherits3.default)(PanelLeft, _React$Component6);
	
	  function PanelLeft() {
	    (0, _classCallCheck3.default)(this, PanelLeft);
	    return (0, _possibleConstructorReturn3.default)(this, (PanelLeft.__proto__ || (0, _getPrototypeOf2.default)(PanelLeft)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PanelLeft, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	      props.className = (0, _classnames2.default)('rubix-panel-left', props.className);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, props, { children: null }),
	        this.props.children
	      );
	    }
	  }]);
	  return PanelLeft;
	}(_react2.default.Component);
	
	var PanelRight = exports.PanelRight = function (_React$Component7) {
	  (0, _inherits3.default)(PanelRight, _React$Component7);
	
	  function PanelRight() {
	    (0, _classCallCheck3.default)(this, PanelRight);
	    return (0, _possibleConstructorReturn3.default)(this, (PanelRight.__proto__ || (0, _getPrototypeOf2.default)(PanelRight)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PanelRight, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	      props.className = (0, _classnames2.default)('rubix-panel-right', props.className);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, props, { children: null }),
	        this.props.children
	      );
	    }
	  }]);
	  return PanelRight;
	}(_react2.default.Component);
	
	var PanelBody = exports.PanelBody = function (_React$Component8) {
	  (0, _inherits3.default)(PanelBody, _React$Component8);
	
	  function PanelBody() {
	    (0, _classCallCheck3.default)(this, PanelBody);
	    return (0, _possibleConstructorReturn3.default)(this, (PanelBody.__proto__ || (0, _getPrototypeOf2.default)(PanelBody)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PanelBody, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	      props.className = (0, _classnames2.default)('rubix-panel-body', props.className);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, props, { children: null }),
	        this.props.children
	      );
	    }
	  }]);
	  return PanelBody;
	}(_react2.default.Component);

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Icon.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Icon = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(Icon, _React$Component);
	
	  function Icon() {
	    (0, _classCallCheck3.default)(this, Icon);
	    return (0, _possibleConstructorReturn3.default)(this, (Icon.__proto__ || (0, _getPrototypeOf2.default)(Icon)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _glyph = this.props.glyph || "";
	      var _bundle = this.props.bundle || "";
	      var isGlyphicon = _glyph.search('glyphicon') !== -1 || _bundle.search('glyphicon') !== -1;
	
	      var iconString = _bundle + '-' + _glyph;
	      var bundle = _bundle.length ? !isGlyphicon ? 'icon-' + iconString : iconString : null;
	      var glyph = !_bundle.length ? _glyph : '';
	
	      var classes = (0, _classnames2.default)(this.props.className, bundle, glyph, {
	        'glyphicon': isGlyphicon,
	        'rubix-icon': !isGlyphicon,
	        'form-control-feedback': this.props.feedback
	      });
	
	      var props = (0, _extends3.default)({}, this.props, {
	        className: classes
	      });
	
	      delete props.glyph;
	      delete props.bundle;
	
	      return _react2.default.createElement('span', props);
	    }
	  }]);
	  return Icon;
	}(_react2.default.Component), _class.propTypes = {
	  bundle: _react2.default.PropTypes.string,
	  glyph: _react2.default.PropTypes.string.isRequired
	}, _temp);
	exports.default = Icon;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/TabContainer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uncontrollable = __webpack_require__("./node_modules/uncontrollable/index.js");
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(undefined, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2['default'].any
	};
	
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any,
	    onSelect: _propTypes2['default'].func.isRequired,
	    getTabId: _propTypes2['default'].func.isRequired,
	    getPaneId: _propTypes2['default'].func.isRequired
	  })
	};
	
	var TabContainer = function (_React$Component) {
	  (0, _inherits3['default'])(TabContainer, _React$Component);
	
	  function TabContainer() {
	    (0, _classCallCheck3['default'])(this, TabContainer);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  TabContainer.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        activeKey = _props.activeKey,
	        onSelect = _props.onSelect,
	        generateChildId = _props.generateChildId,
	        id = _props.id;
	
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + '-' + type + '-' + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  TabContainer.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['children']);
	
	
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	
	    return _react2['default'].cloneElement(_react2['default'].Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react2['default'].Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _uncontrollable2['default'])(TabContainer, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Pricing.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PricingButtonContainer = exports.PricingFeature = exports.PricingTableBody = exports.PricingTablePrice = exports.PricingTableHeader = exports.PricingTable = exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Col = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Col.js");
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _Row = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Row.js");
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Grid = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Grid.js");
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PricingTableContainer = function (_React$Component) {
	  (0, _inherits3.default)(PricingTableContainer, _React$Component);
	
	  function PricingTableContainer() {
	    (0, _classCallCheck3.default)(this, PricingTableContainer);
	    return (0, _possibleConstructorReturn3.default)(this, (PricingTableContainer.__proto__ || (0, _getPrototypeOf2.default)(PricingTableContainer)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PricingTableContainer, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props, {
	        className: (0, _classnames2.default)('container-sm-height', this.props.className)
	      });
	
	      return _react2.default.createElement(
	        _Grid2.default,
	        props,
	        _react2.default.createElement(
	          _Row2.default,
	          { className: 'row-sm-height' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	  return PricingTableContainer;
	}(_react2.default.Component);
	
	exports.default = PricingTableContainer;
	var PricingTable = exports.PricingTable = (_temp = _class = function (_React$Component2) {
	  (0, _inherits3.default)(PricingTable, _React$Component2);
	
	  function PricingTable() {
	    (0, _classCallCheck3.default)(this, PricingTable);
	    return (0, _possibleConstructorReturn3.default)(this, (PricingTable.__proto__ || (0, _getPrototypeOf2.default)(PricingTable)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PricingTable, [{
	    key: 'render',
	    value: function render() {
	      var classes = (0, _classnames2.default)({
	        'col-sm-height': true,
	        'pricing-table': true,
	        'preferred': this.props.preferred
	      });
	
	      var props = (0, _extends3.default)({
	        xs: 12
	      }, this.props, {
	        className: classes.trim()
	      });
	
	      delete props.preferred;
	
	      return _react2.default.createElement(
	        _Col2.default,
	        props,
	        this.props.children
	      );
	    }
	  }]);
	  return PricingTable;
	}(_react2.default.Component), _class.propTypes = {
	  preferred: _react2.default.PropTypes.bool
	}, _temp);
	
	var PricingTableHeader = exports.PricingTableHeader = function (_React$Component3) {
	  (0, _inherits3.default)(PricingTableHeader, _React$Component3);
	
	  function PricingTableHeader() {
	    (0, _classCallCheck3.default)(this, PricingTableHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (PricingTableHeader.__proto__ || (0, _getPrototypeOf2.default)(PricingTableHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PricingTableHeader, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props, {
	        className: (0, _classnames2.default)('pricing-table-header text-center text-uppercase', this.props.className)
	      });
	
	      return _react2.default.createElement(
	        'div',
	        props,
	        _react2.default.createElement(
	          'h3',
	          null,
	          this.props.children
	        )
	      );
	    }
	  }]);
	  return PricingTableHeader;
	}(_react2.default.Component);
	
	var PricingTablePrice = exports.PricingTablePrice = function (_React$Component4) {
	  (0, _inherits3.default)(PricingTablePrice, _React$Component4);
	
	  function PricingTablePrice() {
	    (0, _classCallCheck3.default)(this, PricingTablePrice);
	    return (0, _possibleConstructorReturn3.default)(this, (PricingTablePrice.__proto__ || (0, _getPrototypeOf2.default)(PricingTablePrice)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PricingTablePrice, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props, {
	        className: (0, _classnames2.default)('pricing-table-price text-center text-uppercase', this.props.className)
	      });
	
	      return _react2.default.createElement(
	        'div',
	        props,
	        _react2.default.createElement(
	          'h2',
	          null,
	          this.props.children
	        )
	      );
	    }
	  }]);
	  return PricingTablePrice;
	}(_react2.default.Component);
	
	var PricingTableBody = exports.PricingTableBody = function (_React$Component5) {
	  (0, _inherits3.default)(PricingTableBody, _React$Component5);
	
	  function PricingTableBody() {
	    (0, _classCallCheck3.default)(this, PricingTableBody);
	    return (0, _possibleConstructorReturn3.default)(this, (PricingTableBody.__proto__ || (0, _getPrototypeOf2.default)(PricingTableBody)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PricingTableBody, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props, {
	        className: (0, _classnames2.default)('pricing-table-body text-center', this.props.className)
	      });
	
	      return _react2.default.createElement(
	        'div',
	        props,
	        this.props.children
	      );
	    }
	  }]);
	  return PricingTableBody;
	}(_react2.default.Component);
	
	var PricingFeature = exports.PricingFeature = function (_React$Component6) {
	  (0, _inherits3.default)(PricingFeature, _React$Component6);
	
	  function PricingFeature() {
	    (0, _classCallCheck3.default)(this, PricingFeature);
	    return (0, _possibleConstructorReturn3.default)(this, (PricingFeature.__proto__ || (0, _getPrototypeOf2.default)(PricingFeature)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PricingFeature, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props, {
	        className: (0, _classnames2.default)('pricing-table-feature text-center', this.props.className)
	      });
	
	      return _react2.default.createElement(
	        'div',
	        props,
	        this.props.children
	      );
	    }
	  }]);
	  return PricingFeature;
	}(_react2.default.Component);
	
	var PricingButtonContainer = exports.PricingButtonContainer = function (_React$Component7) {
	  (0, _inherits3.default)(PricingButtonContainer, _React$Component7);
	
	  function PricingButtonContainer() {
	    (0, _classCallCheck3.default)(this, PricingButtonContainer);
	    return (0, _possibleConstructorReturn3.default)(this, (PricingButtonContainer.__proto__ || (0, _getPrototypeOf2.default)(PricingButtonContainer)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PricingButtonContainer, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props, {
	        className: (0, _classnames2.default)('pricing-btn-container text-center', this.props.className)
	      });
	
	      return _react2.default.createElement(
	        'div',
	        props,
	        this.props.children
	      );
	    }
	  }]);
	  return PricingButtonContainer;
	}(_react2.default.Component);

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Col.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Col = __webpack_require__("./node_modules/react-bootstrap/lib/Col.js");
	
	var _Col2 = _interopRequireDefault(_Col);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var breakpoints = ['xs', 'sm', 'md', 'lg'];
	var directions = ['left', 'right', 'top', 'bottom'];
	
	function ucfirst(str) {
	  return typeof str != "undefined" ? (str += '', str[0].toUpperCase() + str.substr(1)) : '';
	}
	
	function setLayoutClass(props, name, what, key) {
	  if (props[name] !== undefined && props[key] !== undefined) {
	    props.className = (0, _classnames2.default)('col-' + name + '-' + what + ' ', props.className);
	    delete props[key];
	  }
	}
	
	function convertAndSetCamelCaseClass(props, key) {
	  var klass = 'col-' + key.replace(/([A-Z])/mg, function (a) {
	    return '-' + a.toLowerCase();
	  });
	  props.className = (0, _classnames2.default)(klass, props.className);
	  delete props[key];
	}
	
	var Col = function (_React$Component) {
	  (0, _inherits3.default)(Col, _React$Component);
	
	  function Col() {
	    (0, _classCallCheck3.default)(this, Col);
	    return (0, _possibleConstructorReturn3.default)(this, (Col.__proto__ || (0, _getPrototypeOf2.default)(Col)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Col, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	
	      for (var i = 0; i < breakpoints.length; i++) {
	        for (var j = 0; j < directions.length; j++) {
	          setLayoutClass(props, breakpoints[i], 'collapse-' + directions[j], 'collapse' + ucfirst(directions[j]));
	          setLayoutClass(props, breakpoints[i], 'gutter-' + directions[j], 'gutter' + ucfirst(directions[j]));
	        }
	
	        if (props.hasOwnProperty(breakpoints[i] + 'Visible')) {
	          props.className = (0, _classnames2.default)('visible-' + breakpoints[i], props.className);
	        }
	      }
	
	      if (props.hasOwnProperty('visible') && typeof props.visible === 'string') {
	        var visibleBreakpoints = props.visible.split(',');
	        for (var i = 0; i < visibleBreakpoints.length; i++) {
	          var visibleBreakpoint = visibleBreakpoints[i].trim();
	          props.className = (0, _classnames2.default)('visible-' + visibleBreakpoint, props.className);
	        }
	      }
	
	      if (props.hasOwnProperty('hidden') && typeof props.hidden === 'string') {
	        var hiddenBreakpoints = props.hidden.split(',');
	        for (var i = 0; i < hiddenBreakpoints.length; i++) {
	          var hiddenBreakpoint = hiddenBreakpoints[i].trim();
	          props.className = (0, _classnames2.default)('hidden-' + hiddenBreakpoint, props.className);
	        }
	      }
	
	      for (var key in props) {
	        if (props.hasOwnProperty(key)) {
	          if (key.search('Collapse') !== -1 || key.search('Gutter') !== -1) {
	            convertAndSetCamelCaseClass(props, key);
	          }
	        }
	      }
	
	      delete props.visible;
	
	      return _react2.default.createElement(_Col2.default, props);
	    }
	  }]);
	  return Col;
	}(_react2.default.Component);
	
	exports.default = Col;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Col.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _propTypes2['default'].number,
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _propTypes2['default'].bool,
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _propTypes2['default'].number
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Col = function (_React$Component) {
	  (0, _inherits3['default'])(Col, _React$Component);
	
	  function Col() {
	    (0, _classCallCheck3['default'])(this, Col);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Col.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      function popProp(propSuffix, modifier) {
	        var propName = '' + size + propSuffix;
	        var propValue = elementProps[propName];
	
	        if (propValue != null) {
	          classes.push((0, _bootstrapUtils.prefix)(bsProps, '' + size + modifier + '-' + propValue));
	        }
	
	        delete elementProps[propName];
	      }
	
	      popProp('', '');
	      popProp('Offset', '-offset');
	      popProp('Push', '-push');
	      popProp('Pull', '-pull');
	
	      var hiddenPropName = size + 'Hidden';
	      if (elementProps[hiddenPropName]) {
	        classes.push('hidden-' + size);
	      }
	      delete elementProps[hiddenPropName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Col;
	}(_react2['default'].Component);
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('col', Col);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Row.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Row = __webpack_require__("./node_modules/react-bootstrap/lib/Row.js");
	
	var _Row2 = _interopRequireDefault(_Row);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Row2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Row.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Row = function (_React$Component) {
	  (0, _inherits3['default'])(Row, _React$Component);
	
	  function Row() {
	    (0, _classCallCheck3['default'])(this, Row);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Row.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Row;
	}(_react2['default'].Component);
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('row', Row);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Grid.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__("./node_modules/react-bootstrap/lib/Grid.js");
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Grid = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(Grid, _React$Component);
	
	  function Grid() {
	    (0, _classCallCheck3.default)(this, Grid);
	    return (0, _possibleConstructorReturn3.default)(this, (Grid.__proto__ || (0, _getPrototypeOf2.default)(Grid)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Grid, [{
	    key: 'render',
	    value: function render() {
	      var fluid = true;
	
	      if (this.props.fluid === false) {
	        fluid = false;
	      }
	
	      if (this.props.fixed === true) {
	        fluid = false;
	      }
	
	      var props = (0, _extends3.default)({}, this.props, {
	        fluid: fluid
	      });
	
	      props.className = (0, _classnames2.default)(props.className, {
	        'grid-gutter': props.gutter,
	        'grid-collapse': props.collapse,
	        'grid-gutter-top': props.gutterTop,
	        'grid-gutter-left': props.gutterLeft,
	        'grid-gutter-right': props.gutterRight,
	        'grid-gutter-bottom': props.gutterBottom
	      });
	
	      delete props.fixed;
	      delete props.gutter;
	      delete props.collapse;
	      delete props.gutterTop;
	      delete props.gutterLeft;
	      delete props.gutterRight;
	      delete props.gutterBottom;
	
	      return _react2.default.createElement(_Grid2.default, props);
	    }
	  }]);
	  return Grid;
	}(_react2.default.Component), _class.propTypes = {
	  fixed: _react2.default.PropTypes.bool,
	  gutter: _react2.default.PropTypes.bool,
	  collapse: _react2.default.PropTypes.bool,
	  gutterTop: _react2.default.PropTypes.bool,
	  gutterLeft: _react2.default.PropTypes.bool,
	  gutterRight: _react2.default.PropTypes.bool,
	  gutterBottom: _react2.default.PropTypes.bool
	}, _temp);
	exports.default = Grid;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Grid.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Turn any fixed-width grid layout into a full-width layout by this property.
	   *
	   * Adds `container-fluid` class.
	   */
	  fluid: _propTypes2['default'].bool,
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  fluid: false
	};
	
	var Grid = function (_React$Component) {
	  (0, _inherits3['default'])(Grid, _React$Component);
	
	  function Grid() {
	    (0, _classCallCheck3['default'])(this, Grid);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Grid.prototype.render = function render() {
	    var _props = this.props,
	        fluid = _props.fluid,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['fluid', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Grid;
	}(_react2['default'].Component);
	
	Grid.propTypes = propTypes;
	Grid.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('container', Grid);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Sidebar.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SidebarDivider = exports.SidebarBtn = exports.SidebarControlBtn = exports.SidebarControls = exports.SidebarNavItem = exports.SidebarNav = exports.Sidebar = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _React$createClass, _class, _temp, _class2, _temp2, _class3, _class4, _temp3, _class5, _temp4, _class6, _temp5, _class7, _temp7, _class8, _temp8;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _PatternUtils = __webpack_require__("./node_modules/react-router/lib/PatternUtils.js");
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactMotion = __webpack_require__("./node_modules/react-motion/lib/react-motion.js");
	
	var _Icon = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Icon.js");
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Dispatcher = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Dispatcher.js");
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	var _isBrowser = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/isBrowser.js");
	
	var _isBrowser2 = _interopRequireDefault(_isBrowser);
	
	var _isTouchDevice = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/isTouchDevice.js");
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _Nav = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Nav.js");
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/NavItem.js");
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routesStore = {};
	
	function enableStateForPathname(pathname, params) {
	  for (var pattern in routesStore) {
	    var matchedRoute = matchRoutes([pattern], pathname, params);
	
	    if (matchedRoute == pattern) {
	      routesStore[pattern] = true;
	    } else {
	      routesStore[pattern] = false;
	    }
	  }
	}
	
	function matchRoute(pattern, pathname, params) {
	  var remainingPathname = pathname;
	  var paramNames = [],
	      paramValues = [];
	
	  if (remainingPathname !== null && pattern) {
	    var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	
	    if (!matched || !matched.paramNames || !matched.paramValues) {
	      return false;
	    }
	    remainingPathname = matched.remainingPathname;
	    paramNames = [].concat((0, _toConsumableArray3.default)(paramNames), (0, _toConsumableArray3.default)(matched.paramNames));
	    paramValues = [].concat((0, _toConsumableArray3.default)(paramValues), (0, _toConsumableArray3.default)(matched.paramValues));
	
	    if (remainingPathname === '') {
	      // We have an exact match on the route. Just check that all the params
	      // match.
	      // FIXME: This doesn't work on repeated params.
	      return paramNames.every(function (paramName, index) {
	        return String(paramValues[index]) === String(params[paramName]);
	      });
	    }
	  }
	
	  return false;
	}
	
	function matchRoutes(routes, pathname, params) {
	  var matched = false,
	      patternMatched = '';
	  for (var i = 0; i < routes.length; i++) {
	    if (matchRoute(routes[i], pathname, params)) {
	      if (matched == true) {
	        if (matchRoute(patternMatched, routes[i], params)) {
	          patternMatched = routes[i];
	        }
	      } else {
	        matched = true;
	        patternMatched = routes[i];
	      }
	    }
	  }
	
	  if (matched) {
	    return patternMatched;
	  } else {
	    return false;
	  }
	}
	
	function getOpenState() {
	  return !(0, _isTouchDevice2.default)() ? localStorage.getItem('sidebar-open-state') === 'true' ? true : false : false;
	}
	
	var MainContainer = _react2.default.createClass((_React$createClass = {
	  displayName: 'MainContainer',
	  getInitialState: function getInitialState() {
	    return {
	      open: true,
	      forceClose: false
	    };
	  },
	  isOpen: function isOpen(open) {
	    return this.state.open === open;
	  },
	  closeSidebar: function closeSidebar() {
	    var forceClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    this.setState({
	      open: false,
	      forceClose: forceClose
	    });
	    localStorage.setItem('sidebar-open-state', false);
	  },
	  openSidebar: function openSidebar() {
	    var forceClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    this.setState({
	      open: true,
	      forceClose: forceClose
	    });
	    localStorage.setItem('sidebar-open-state', true);
	  },
	  toggleSidebar: function toggleSidebar() {
	    if (this.state.forceClose) {
	      this.openSidebar(false);
	    } else {
	      this.closeSidebar(true);
	    }
	  },
	  sidebarStateChangeCallback: function sidebarStateChangeCallback(open) {
	    var openState = getOpenState();
	    if (this.isOpen(open)) return;
	    if (open !== undefined) {
	      openState = open;
	    } else {
	      openState = !this.state.open;
	    }
	    this.setState({
	      open: openState // toggle sidebar
	    });
	    localStorage.setItem('sidebar-open-state', openState);
	  },
	  enablePath: function enablePath(props) {
	    if (props) {
	      enableStateForPathname(props.location.pathname, props.params);
	    }
	    _Dispatcher2.default.publish('sidebar:activate');
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var _this = this;
	
	    setTimeout(function () {
	      _this.enablePath(nextProps);
	    }, 50);
	    // this.enablePath();
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    _Dispatcher2.default.unsubscribe(this.handler);
	  },
	  startSwipe: function startSwipe(e) {
	    if (e.changedTouches.length) {
	      var touches = e.changedTouches[0];
	      this.startX = touches.pageX;
	    }
	  },
	  swiping: function swiping(e) {
	    if (e.changedTouches.length) {
	      var touches = e.changedTouches[0];
	      var change = Math.abs(touches.pageX - this.startX);
	      var hasSwiped = change > 25;
	
	      var body = document.getElementById('body');
	      var sidebar = document.getElementById('sidebar');
	      var header = document.getElementById('rubix-nav-header');
	      if (hasSwiped) {
	        if (!this.state.open) {
	          if (change > 250) return;
	          body.style.marginLeft = change + 'px';
	          body.style.marginRight = -change + 'px';
	          sidebar.style.left = -250 + change + 'px';
	          header.style.marginLeft = change + 'px';
	          header.style.marginRight = -change + 'px';
	        } else {
	          if (250 - change < 0) return;
	          body.style.marginLeft = 250 - change + 'px';
	          body.style.marginRight = -(250 - change) + 'px';
	          sidebar.style.left = 0 - (250 - change) + 'px';
	          header.style.marginLeft = 250 - change + 'px';
	          header.style.marginRight = -(250 - change) + 'px';
	        }
	      }
	    }
	  },
	  cancelSwipe: function cancelSwipe(e) {
	    this.startX = 0;
	    var body = document.getElementById('body');
	    var sidebar = document.getElementById('sidebar');
	    var header = document.getElementById('rubix-nav-header');
	    body.style.marginLeft = '';
	    body.style.marginRight = '';
	    sidebar.style.left = '';
	    header.style.marginLeft = '';
	    header.style.marginRight = '';
	    this.setState({
	      open: false
	    });
	  },
	  endSwipe: function endSwipe(e) {
	    if (e.changedTouches.length) {
	      var touches = e.changedTouches[0];
	      var change = touches.pageX - this.startX;
	      var hasSwiped = Math.abs(change) > 25;
	
	      var body = document.getElementById('body');
	      var sidebar = document.getElementById('sidebar');
	      var header = document.getElementById('rubix-nav-header');
	
	      if (hasSwiped) {
	        body.style.marginLeft = '';
	        body.style.marginRight = '';
	        sidebar.style.left = '';
	        header.style.marginLeft = '';
	        header.style.marginRight = '';
	
	        if (!this.state.open) {
	          this.setState({
	            open: true
	          });
	        } else {
	          this.setState({
	            open: false
	          });
	        }
	      }
	    }
	  }
	}, (0, _defineProperty3.default)(_React$createClass, 'componentWillUnmount', function componentWillUnmount() {
	  _Dispatcher2.default.unsubscribe(this.sidebarStateChangeCallback);
	  _Dispatcher2.default.unsubscribe(this.closeSidebar);
	  _Dispatcher2.default.unsubscribe(this.toggleSidebar);
	}), (0, _defineProperty3.default)(_React$createClass, 'componentDidMount', function componentDidMount() {
	  this.handler = _Dispatcher2.default.subscribe('sidebar', this.sidebarStateChangeCallback);
	  this.closeHandler = _Dispatcher2.default.subscribe('sidebar:closeSidebar', this.closeSidebar);
	  this.closeHandler = _Dispatcher2.default.subscribe('sidebar:toggleSidebar', this.toggleSidebar);
	
	  var openState = getOpenState();
	  this.setState({
	    open: openState
	  });
	
	  this.enablePath();
	}), (0, _defineProperty3.default)(_React$createClass, 'render', function render() {
	  var classes = (0, _classnames2.default)({
	    'container-open': this.state.open,
	    'force-close': this.state.forceClose
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'container', className: classes },
	    this.props.children
	  );
	}), _React$createClass));
	
	exports.default = MainContainer;
	var Sidebar = exports.Sidebar = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(Sidebar, _React$Component);
	
	  function Sidebar(props) {
	    (0, _classCallCheck3.default)(this, Sidebar);
	
	    var _this2 = (0, _possibleConstructorReturn3.default)(this, (Sidebar.__proto__ || (0, _getPrototypeOf2.default)(Sidebar)).call(this, props));
	
	    _this2.timer = null;
	
	    _this2.state = {
	      left: props.sidebar * 100 + '%',
	      visibility: props.sidebar === 0 ? 'visible' : 'hidden'
	    };
	
	    _this2.reinitializeScrollbarHandler = null;
	    _this2.destroyScrollbarHandler = null;
	    _this2.repositionHandler = null;
	    _this2.keychangeHandler = null;
	    _this2.updateHandler = null;
	    return _this2;
	  }
	
	  (0, _createClass3.default)(Sidebar, [{
	    key: 'repositionScrollbar',
	    value: function repositionScrollbar(child_node, top, height) {
	      var node = _reactDom2.default.findDOMNode(this.refs.sidebar);
	      var scrollTo = top - node.getBoundingClientRect().top + node.scrollTop;
	
	      while (child_node.parentNode) {
	        if (child_node.parentNode === node) {
	          if (scrollTo > window.innerHeight / 2) {
	            node.scrollTop = scrollTo - window.innerHeight / 2 + 100;
	          }
	          break;
	        }
	
	        child_node = child_node.parentNode;
	      }
	
	      if (!(0, _isTouchDevice2.default)()) {
	        this.updateScrollbar();
	      }
	    }
	  }, {
	    key: 'updateScrollbar',
	    value: function updateScrollbar() {
	      if (!(0, _isTouchDevice2.default)()) {
	        if ((0, _isBrowser2.default)()) {
	          if (window.Ps) {
	            Ps.update(_reactDom2.default.findDOMNode(this.refs.sidebar));
	          }
	        }
	      }
	    }
	  }, {
	    key: 'initializeScrollbar',
	    value: function initializeScrollbar() {
	      if ((0, _isBrowser2.default)() && !(0, _isTouchDevice2.default)()) {
	        if (window.Ps) {
	          Ps.initialize(_reactDom2.default.findDOMNode(this.refs.sidebar), {
	            suppressScrollX: true
	          });
	        }
	      }
	    }
	  }, {
	    key: 'destroyScrollbar',
	    value: function destroyScrollbar() {
	      if ((0, _isBrowser2.default)() && !(0, _isTouchDevice2.default)()) {
	        if (window.Ps) {
	          Ps.destroy(_reactDom2.default.findDOMNode(this.refs.sidebar));
	        }
	      }
	    }
	  }, {
	    key: 'handleKeyChange',
	    value: function handleKeyChange(sidebar) {
	      var newLeft = this.props.sidebar * 100 - sidebar * 100 + '%';
	      this.setState({
	        left: newLeft,
	        visibility: 'visible'
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Dispatcher2.default.unsubscribe(this.reinitializeScrollbarHandler);
	      _Dispatcher2.default.unsubscribe(this.destroyScrollbarHandler);
	      _Dispatcher2.default.unsubscribe(this.repositionHandler);
	      _Dispatcher2.default.unsubscribe(this.keychangeHandler);
	      _Dispatcher2.default.unsubscribe(this.updateHandler);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initializeScrollbar();
	
	      this.reinitializeScrollbarHandler = _Dispatcher2.default.subscribe('sidebar:reinitialize', this.initializeScrollbar.bind(this));
	      this.destroyScrollbarHandler = _Dispatcher2.default.subscribe('sidebar:destroy', this.destroyScrollbar.bind(this));
	      this.repositionHandler = _Dispatcher2.default.subscribe('sidebar:reposition', this.repositionScrollbar.bind(this));
	      this.keychangeHandler = _Dispatcher2.default.subscribe('sidebar:keychange', this.handleKeyChange.bind(this));
	      this.updateHandler = _Dispatcher2.default.subscribe('sidebar:update', this.updateScrollbar.bind(this));
	
	      if (this.props.active) {
	        _Dispatcher2.default.publish('sidebar:controlbtn', this.props);
	        _Dispatcher2.default.publish('sidebar:keychange', this.props.sidebar);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({
	        style: {
	          left: this.state.left,
	          visibility: this.state.visibility,
	          transition: 'all 0.3s ease',
	          OTransition: 'all 0.3s ease',
	          MsTransition: 'all 0.3s ease',
	          MozTransition: 'all 0.3s ease',
	          WebkitTransition: 'all 0.3s ease'
	        }
	      }, this.props, {
	        className: (0, _classnames2.default)('sidebar', 'sidebar__main', this.props.className)
	      });
	
	      delete props.sidebar;
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ ref: 'sidebar' }, props, { children: null, 'data-id': this.props.sidebar }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'innersidebar' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	  return Sidebar;
	}(_react2.default.Component), _class.belongsTo = 'Sidebar', _temp);
	var SidebarNav = exports.SidebarNav = (_temp2 = _class2 = function (_React$Component2) {
	  (0, _inherits3.default)(SidebarNav, _React$Component2);
	
	  function SidebarNav(props) {
	    (0, _classCallCheck3.default)(this, SidebarNav);
	
	    var _this3 = (0, _possibleConstructorReturn3.default)(this, (SidebarNav.__proto__ || (0, _getPrototypeOf2.default)(SidebarNav)).call(this, props));
	
	    _this3.id = ++SidebarNav.id;
	    return _this3;
	  }
	
	  (0, _createClass3.default)(SidebarNav, [{
	    key: 'getID',
	    value: function getID() {
	      return this.id;
	    }
	  }, {
	    key: 'getHeight',
	    value: function getHeight() {
	      return _reactDom2.default.findDOMNode(this.refs.ul).getClientRects()[0].height;
	    }
	  }, {
	    key: 'search',
	    value: function search(text) {
	      _Dispatcher2.default.publish('sidebar:search', text, this.getID());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var classes = (0, _classnames2.default)('sidebar-nav', this.props.className);
	
	      if (this.props.sidebarNavItem) {
	        this.props.sidebarNavItem.childSidebarNav = this;
	      }
	
	      var props = (0, _extends3.default)({}, this.props, {
	        className: classes
	      });
	
	      var children = _react2.default.Children.map(this.props.children, function (el) {
	        switch (el.type) {
	          case SidebarNav:
	          case SidebarNavItem:
	            return _react2.default.cloneElement(el, {
	              SidebarNavID: _this4.props.SidebarNavID || _this4.getID(),
	              sidebarNavItem: _this4.props.sidebarNavItem,
	              rootSidebarNavItem: _this4.props.rootSidebarNavItem
	            });
	          default:
	            return _react2.default.cloneElement(el);
	        }
	      });
	
	      delete props.SidebarNavID;
	      delete props.sidebarNavItem;
	      delete props.rootSidebarNavItem;
	
	      return _react2.default.createElement(
	        'ul',
	        (0, _extends3.default)({ ref: 'ul' }, props),
	        children
	      );
	    }
	  }]);
	  return SidebarNav;
	}(_react2.default.Component), _class2.belongsTo = 'Sidebar', _class2.id = 0, _temp2);
	
	var SidebarNavItem = exports.SidebarNavItem = (0, _reactRouter.withRouter)(_class3 = (_temp3 = _class4 = function (_React$Component3) {
	  (0, _inherits3.default)(SidebarNavItem, _React$Component3);
	
	  function SidebarNavItem(props) {
	    (0, _classCallCheck3.default)(this, SidebarNavItem);
	
	    var _this5 = (0, _possibleConstructorReturn3.default)(this, (SidebarNavItem.__proto__ || (0, _getPrototypeOf2.default)(SidebarNavItem)).call(this, props));
	
	    _this5.handleClick = function (e) {
	      if (!_this5.props.href) {
	        e.preventDefault();
	        e.stopPropagation();
	        _this5.toggleSidebarNav();
	      }
	      if (_this5.props.hasOwnProperty('onClick')) {
	        _this5.props.onClick();
	      }
	
	      _this5.closeNav();
	    };
	
	    _this5.state = {
	      open: props.open || false,
	      active: props.active || false,
	      toggleOpen: props.open || false,
	      dir: 'left',
	      opposite: false,
	      height: 45
	    };
	
	    _this5.routes = [];
	
	    _this5.activateHandler = null;
	    _this5.searchHandler = null;
	    _this5.closeHandler = null;
	    return _this5;
	  }
	
	  (0, _createClass3.default)(SidebarNavItem, [{
	    key: 'handleLayoutDirChange',
	    value: function handleLayoutDirChange(dir) {
	      this.setState({
	        dir: dir === 'ltr' ? 'left' : 'right',
	        opposite: dir === 'ltr' ? false : true
	      });
	    }
	  }, {
	    key: 'getTotalHeight',
	    value: function getTotalHeight() {
	      if (this.childSidebarNav) {
	        return this.childSidebarNav.getHeight() + 45;
	      } else {
	        return 45;
	      }
	    }
	  }, {
	    key: 'openSidebarNav',
	    value: function openSidebarNav(fullOpen, height, isClosing) {
	      var _this6 = this;
	
	      if (this.state.open && !height) return;
	
	      height = height || 0;
	      var thisHeight = this.getTotalHeight();
	      var totalHeight = height + thisHeight;
	
	      if (this.childSidebarNav) {
	        this.setState({
	          height: totalHeight,
	          open: true,
	          toggleOpen: true
	        }, function () {
	          _Dispatcher2.default.publish('sidebar:update');
	          if (_this6.props.sidebarNavItem) {
	            if (isClosing) {
	              _this6.props.sidebarNavItem.openSidebarNav(false, 45 - totalHeight, true);
	            } else {
	              if (fullOpen) {
	                _this6.props.sidebarNavItem.openSidebarNav(true, totalHeight - 45);
	              } else {
	                _this6.props.sidebarNavItem.openSidebarNav(false, thisHeight - 45);
	              }
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: 'closeSidebarNav',
	    value: function closeSidebarNav(collapseRoot) {
	      var _this7 = this;
	
	      if (!this.state.open) return;
	
	      var thisHeight = this.getTotalHeight();
	      if (this.childSidebarNav) {
	        this.setState({
	          height: 45,
	          open: false,
	          toggleOpen: false
	        }, function () {
	          _Dispatcher2.default.publish('sidebar:update');
	          if (_this7.props.sidebarNavItem) {
	            _this7.props.sidebarNavItem.openSidebarNav(false, 45 - thisHeight, true);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'toggleSidebarNav',
	    value: function toggleSidebarNav() {
	      if (this.state.height === 45) {
	        this.openSidebarNav();
	      } else {
	        this.closeSidebarNav();
	      }
	    }
	  }, {
	    key: 'getTopmostLi',
	    value: function getTopmostLi(node, li, original_node) {
	      if (!original_node) original_node = node;
	      while (node.parentNode) {
	        if (node.parentNode.className.search('sidebar-nav-container') !== -1) {
	          if (li) {
	            return li;
	          } else {
	            return original_node;
	          }
	        }
	
	        if (node.parentNode.nodeName.toLowerCase() === 'li') {
	          li = node.parentNode;
	        }
	        node = node.parentNode;
	      }
	    }
	  }, {
	    key: 'getSiblingsLi',
	    value: function getSiblingsLi(node) {
	      var original_node = node;
	      var sibilings = [];
	      while (node.nextSibling) {
	        sibilings.push(node.nextSibling);
	        node = node.nextSibling;
	      }
	      node = original_node;
	      while (node.previousSibling) {
	        sibilings.push(node.previousSibling);
	        node = node.previousSibling;
	      }
	
	      return sibilings;
	    }
	  }, {
	    key: 'getSiblingsNav',
	    value: function getSiblingsNav(node) {
	      var original_node = node;
	      var siblings = [];
	      while (node.nextSibling) {
	        if (node.nextSibling.className.search('sidebar-nav') !== -1) {
	          siblings.push(node.nextSibling);
	        }
	        node = node.nextSibling;
	      }
	      node = original_node;
	      while (node.previousSibling) {
	        if (node.previousSibling.className.search('sidebar-nav') !== -1) {
	          siblings.push(node.previousSibling);
	        }
	        node = node.previousSibling;
	      }
	
	      return siblings;
	    }
	  }, {
	    key: 'getTopmostSidebar',
	    value: function getTopmostSidebar(node) {
	      while (node.parentNode) {
	        if (node.parentNode.className.search('sidebar__main') !== -1) {
	          return node.parentNode;
	        }
	        node = node.parentNode;
	      }
	    }
	  }, {
	    key: 'checkAndClose',
	    value: function checkAndClose(props) {
	      var node = _reactDom2.default.findDOMNode(this._node);
	
	      var topmostLi = this.getTopmostLi(node);
	      var topmostSiblingLis = this.getSiblingsLi(topmostLi);
	      var siblingLis = this.getSiblingsLi(node);
	      var topmostSidebar = this.getTopmostSidebar(node);
	      var id = parseInt(topmostSidebar.getAttribute('data-id')) || 0;
	
	      _Dispatcher2.default.publish('sidebar:controlbtn', { sidebar: id });
	      _Dispatcher2.default.publish('sidebar:keychange', id);
	
	      for (var i = siblingLis.length - 1; i >= 0; i--) {
	        var li = siblingLis[i];
	        if (li && typeof li.close === 'function') li.close();
	      };
	
	      for (var i = 0; i < topmostSiblingLis.length; i++) {
	        var li = topmostSiblingLis[i];
	        if (li && typeof li.close === 'function') li.close();
	      }
	
	      try {
	        var height = node.getClientRects()[0].height;
	        var top = node.getClientRects()[0].top;
	        setTimeout(function () {
	          _Dispatcher2.default.publish('sidebar:reposition', node, top, height);
	
	          if ((0, _isTouchDevice2.default)()) {
	            _Dispatcher2.default.publish('sidebar:closeSidebar');
	          }
	        }, 300);
	      } catch (e) {}
	    }
	  }, {
	    key: 'handleSearch',
	    value: function handleSearch(text, id) {
	      var links = this._node.getElementsByTagName('a');
	      var link = links[0];
	
	      if (id === this.props.SidebarNavID) {
	        if (!this.props.hidden && links.length === 1) {
	          if (link.innerText.toLowerCase().search(text.toLowerCase()) === -1) {
	            this._node.style.display = 'none';
	          } else {
	            this._node.style.display = 'block';
	          }
	        } else if (links.length > 1) {
	          if (this._node.innerText.toLowerCase().search(text.toLowerCase()) === -1) {
	            this._node.style.display = 'none';
	          } else {
	            this._node.style.display = 'block';
	          }
	        }
	      }
	    }
	  }, {
	    key: 'closeNav',
	    value: function closeNav() {
	      this.closeSidebarNav();
	    }
	  }, {
	    key: 'activateSidebar',
	    value: function activateSidebar() {
	      var found = false,
	          route;
	      for (var i = 0; i < this.routes.length; i++) {
	        var r = this.routes[i];
	        if (routesStore[r]) {
	          route = r;
	          found = true;
	          break;
	        }
	      }
	      if (found) {
	        this.setState({
	          active: true
	        });
	
	        this.checkAndClose(this.props);
	
	        if (this.props.sidebarNavItem) {
	          this.props.sidebarNavItem.openSidebarNav(true);
	        }
	
	        if (this.props.rootSidebarNavItem) {
	          this.props.rootSidebarNavItem.openSidebarNav();
	        }
	      } else {
	        this.setState({
	          active: false
	        });
	      }
	    }
	  }, {
	    key: 'closeSidebarRoot',
	    value: function closeSidebarRoot() {
	      if (!this.props.sidebarNavItem) {
	        this.closeSidebarNav();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Dispatcher2.default.unsubscribe(this.activateHandler);
	      _Dispatcher2.default.unsubscribe(this.closeHandler);
	      _Dispatcher2.default.unsubscribe(this.searchHandler);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.activateHandler = _Dispatcher2.default.subscribe('sidebar:activate', this.activateSidebar.bind(this));
	      this.closeHandler = _Dispatcher2.default.subscribe('sidebar:close', this.closeSidebarRoot.bind(this));
	      this.searchHandler = _Dispatcher2.default.subscribe('sidebar:search', this.handleSearch.bind(this));
	
	      if (this.props.hasOwnProperty('href') && this.props.href.length && this.props.href !== '#') {
	        routesStore[this.props.href] = this.state.active;
	
	        this.routes.push(this.props.href);
	
	        if (this.props.aliases) {
	          for (var i = 0; i < this.props.aliases.length; i++) {
	            var alias = this.props.aliases[i];
	            this.routes.push(alias);
	            routesStore[alias] = this.state.active;
	          }
	        }
	      }
	
	      var node = _reactDom2.default.findDOMNode(this._node);
	      node.close = this.closeNav.bind(this);
	
	      enableStateForPathname(this.props.router.location.pathname, this.props.router.params);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var classes = (0, _classnames2.default)({
	        'open': this.state.open,
	        'active': this.state.active,
	        'sidebar-nav-item': true
	      });
	      var toggleClasses = (0, _classnames2.default)({
	        'toggle-button': true,
	        'open': this.state.toggleOpen,
	        'opposite': this.state.opposite
	      });
	      var icon = null,
	          toggleButton = null;
	      if (this.props.children) {
	        toggleButton = _react2.default.createElement(_Icon2.default, { className: toggleClasses.trim(), bundle: 'fontello', glyph: this.state.dir + '-open-3' });
	      }
	      if (this.props.glyph || this.props.bundle) {
	        icon = _react2.default.createElement(_Icon2.default, { bundle: this.props.bundle, glyph: this.props.glyph });
	      }
	      var style = { height: this.props.autoHeight ? 'auto' : this.state.height };
	
	      var props = {
	        name: null,
	        style: style,
	        tabIndex: '-1',
	        className: classes.trim()
	      };
	
	      var RouteLink = 'a';
	      var componentProps = {
	        name: null,
	        tabIndex: -1,
	        href: this.props.href || '',
	        onClick: this.handleClick,
	        style: { height: 45 }
	      };
	
	      var pointerEvents = 'all';
	      if (this.props.hasOwnProperty('href') && this.props.href.length && this.props.href !== '#') {
	        RouteLink = _reactRouter.Link;
	        componentProps.to = this.props.href;
	        delete componentProps.href;
	
	        if (this.props.href.search(":") !== -1) {
	          pointerEvents = 'none';
	        }
	      }
	
	      var isRoot = this.props.sidebarNavItem ? false : true;
	
	      var children = _react2.default.Children.map(this.props.children, function (el) {
	        return _react2.default.cloneElement(el, {
	          sidebarNavItem: _this8,
	          SidebarNavID: _this8.props.SidebarNavID,
	          rootSidebarNavItem: isRoot ? _this8 : _this8.props.rootSidebarNavItem
	        });
	      });
	
	      return _react2.default.createElement(
	        _reactMotion.Motion,
	        { style: { height: (0, _reactMotion.spring)(this.state.height, { stiffness: 300, damping: 20, precision: 0.0001 }) } },
	        function (style) {
	          return _react2.default.createElement(
	            'li',
	            (0, _extends3.default)({ ref: function ref(c) {
	                return _this8._node = c;
	              } }, props, { style: (0, _extends3.default)({ display: _this8.props.hidden ? 'none' : 'block', pointerEvents: pointerEvents }, style) }),
	            _react2.default.createElement(
	              RouteLink,
	              componentProps,
	              icon,
	              _react2.default.createElement(
	                'span',
	                { className: 'name' },
	                _this8.props.name
	              ),
	              toggleButton
	            ),
	            children
	          );
	        }
	      );
	    }
	  }]);
	  return SidebarNavItem;
	}(_react2.default.Component), _class4.belongsTo = 'Sidebar', _temp3)) || _class3;
	
	var SidebarControls = exports.SidebarControls = (_temp4 = _class5 = function (_React$Component4) {
	  (0, _inherits3.default)(SidebarControls, _React$Component4);
	
	  function SidebarControls() {
	    (0, _classCallCheck3.default)(this, SidebarControls);
	    return (0, _possibleConstructorReturn3.default)(this, (SidebarControls.__proto__ || (0, _getPrototypeOf2.default)(SidebarControls)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SidebarControls, [{
	    key: 'render',
	    value: function render() {
	      var classes = (0, _classnames2.default)('sidebar-controls-container', this.props.className);
	      var props = (0, _extends3.default)({
	        dir: 'ltr'
	      }, this.props, {
	        className: classes
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, props, { children: null }),
	        _react2.default.createElement(
	          'ul',
	          { className: 'sidebar-controls', tabIndex: '-1' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	  return SidebarControls;
	}(_react2.default.Component), _class5.belongsTo = 'Sidebar', _temp4);
	var SidebarControlBtn = exports.SidebarControlBtn = (_temp5 = _class6 = function (_React$Component5) {
	  (0, _inherits3.default)(SidebarControlBtn, _React$Component5);
	
	  function SidebarControlBtn(props) {
	    (0, _classCallCheck3.default)(this, SidebarControlBtn);
	
	    var _this10 = (0, _possibleConstructorReturn3.default)(this, (SidebarControlBtn.__proto__ || (0, _getPrototypeOf2.default)(SidebarControlBtn)).call(this, props));
	
	    _this10.handleClick = function (e) {
	      if (e) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	
	      _Dispatcher2.default.publish('sidebar:controlbtn', _this10.props);
	      _Dispatcher2.default.publish('sidebar:keychange', _this10.props.sidebar);
	    };
	
	    _this10.state = {
	      active: props.active || false
	    };
	
	    _this10.controlbtnHandler = null;
	    return _this10;
	  }
	
	  (0, _createClass3.default)(SidebarControlBtn, [{
	    key: 'handleState',
	    value: function handleState(props) {
	      if (props.hasOwnProperty('sidebar')) {
	        if (props.sidebar === this.props.sidebar) {
	          this.setState({ active: true });
	        } else {
	          this.setState({ active: false });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Dispatcher2.default.unsubscribe(this.controlbtnHandler);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.controlbtnHandler = _Dispatcher2.default.subscribe('sidebar:controlbtn', this.handleState.bind(this));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classes = (0, _classnames2.default)('sidebar-control-btn', {
	        'active': this.state.active
	      }, this.props.className);
	
	      var props = (0, _extends3.default)({
	        tabIndex: '-1',
	        onClick: this.handleClick
	      }, this.props, {
	        className: classes.trim()
	      });
	
	      delete props.glyph;
	      delete props.bundle;
	      delete props.sidebar;
	
	      return _react2.default.createElement(
	        'li',
	        props,
	        _react2.default.createElement(
	          'a',
	          { href: '#', tabIndex: '-1' },
	          _react2.default.createElement(_Icon2.default, { bundle: this.props.bundle, glyph: this.props.glyph })
	        )
	      );
	    }
	  }]);
	  return SidebarControlBtn;
	}(_react2.default.Component), _class6.belongsTo = 'Sidebar', _temp5);
	var SidebarBtn = exports.SidebarBtn = (_temp7 = _class7 = function (_React$Component6) {
	  (0, _inherits3.default)(SidebarBtn, _React$Component6);
	
	  function SidebarBtn() {
	    var _ref;
	
	    var _temp6, _this11, _ret;
	
	    (0, _classCallCheck3.default)(this, SidebarBtn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp6 = (_this11 = (0, _possibleConstructorReturn3.default)(this, (_ref = SidebarBtn.__proto__ || (0, _getPrototypeOf2.default)(SidebarBtn)).call.apply(_ref, [this].concat(args))), _this11), _this11.handleSidebarStateChange = function () {
	      var visible = _this11.props.visible;
	
	
	      if (!visible) {
	        _Dispatcher2.default.publish('sidebar');
	        return;
	      }
	
	      if ((0, _isBrowser2.default)()) {
	        if (window.hasOwnProperty('Rubix')) {
	          Rubix.redraw();
	        }
	      }
	
	      _Dispatcher2.default.publish('sidebar:toggleSidebar');
	    }, _temp6), (0, _possibleConstructorReturn3.default)(_this11, _ret);
	  }
	
	  (0, _createClass3.default)(SidebarBtn, [{
	    key: 'render',
	    value: function render() {
	      var classes = (0, _classnames2.default)({
	        'pull-left': true,
	        'visible-xs-inline-block': !this.props.visible
	      }, this.props.className);
	
	      var props = (0, _extends3.default)({}, this.props, {
	        className: classes
	      });
	
	      delete props.visible;
	
	      return _react2.default.createElement(
	        _Nav2.default,
	        (0, _extends3.default)({}, props, { onSelect: this.handleSidebarStateChange }),
	        _react2.default.createElement(
	          _NavItem2.default,
	          { 'data-id': 'sidebar-btn', className: 'sidebar-btn', href: '/' },
	          _react2.default.createElement(_Icon2.default, { bundle: 'fontello', glyph: 'th-list-5' })
	        )
	      );
	    }
	  }]);
	  return SidebarBtn;
	}(_react2.default.Component), _class7.belongsTo = 'Sidebar', _temp7);
	var SidebarDivider = exports.SidebarDivider = (_temp8 = _class8 = function (_React$Component7) {
	  (0, _inherits3.default)(SidebarDivider, _React$Component7);
	
	  function SidebarDivider() {
	    (0, _classCallCheck3.default)(this, SidebarDivider);
	    return (0, _possibleConstructorReturn3.default)(this, (SidebarDivider.__proto__ || (0, _getPrototypeOf2.default)(SidebarDivider)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SidebarDivider, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('hr', { style: {
	          borderColor: this.props.color,
	          borderWidth: 2,
	          marginTop: 15,
	          marginBottom: 0,
	          width: 200 } });
	    }
	  }]);
	  return SidebarDivider;
	}(_react2.default.Component), _class8.belongsTo = 'Sidebar', _class8.propTypes = {
	  color: _react2.default.PropTypes.string
	}, _class8.defaultProps = {
	  color: '#3B4648'
	}, _temp8);

/***/ },

/***/ "./node_modules/babel-runtime/helpers/toConsumableArray.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__("./node_modules/babel-runtime/core-js/array/from.js");
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },

/***/ "./node_modules/react-motion/lib/react-motion.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__("./node_modules/react-motion/lib/Motion.js");
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__("./node_modules/react-motion/lib/StaggeredMotion.js");
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__("./node_modules/react-motion/lib/TransitionMotion.js");
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__("./node_modules/react-motion/lib/spring.js");
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__("./node_modules/react-motion/lib/presets.js");
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__("./node_modules/react-motion/lib/stripStyle.js");
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__("./node_modules/react-motion/lib/reorderKeys.js");
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ },

/***/ "./node_modules/react-motion/lib/Motion.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__("./node_modules/react-motion/lib/mapToZero.js");
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__("./node_modules/react-motion/lib/stripStyle.js");
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__("./node_modules/react-motion/lib/stepper.js");
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__("./node_modules/performance-now/lib/performance-now.js");
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__("./node_modules/raf/index.js");
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__("./node_modules/react-motion/lib/shouldStopAnimation.js");
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__("./node_modules/create-react-class/index.js");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = _createReactClass2['default']({
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	    style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	    children: _propTypes2['default'].func.isRequired,
	    onRest: _propTypes2['default'].func
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  },
	
	  wasAnimating: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyle: null,
	  // after checking for unreadPropStyle != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(destStyle) {
	    var dirty = false;
	    var _state = this.state;
	    var currentStyle = _state.currentStyle;
	    var currentVelocity = _state.currentVelocity;
	    var lastIdealStyle = _state.lastIdealStyle;
	    var lastIdealVelocity = _state.lastIdealVelocity;
	
	    for (var key in destStyle) {
	      if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	        continue;
	      }
	
	      var styleValue = destStyle[key];
	      if (typeof styleValue === 'number') {
	        if (!dirty) {
	          dirty = true;
	          currentStyle = _extends({}, currentStyle);
	          currentVelocity = _extends({}, currentVelocity);
	          lastIdealStyle = _extends({}, lastIdealStyle);
	          lastIdealVelocity = _extends({}, lastIdealVelocity);
	        }
	
	        currentStyle[key] = styleValue;
	        currentVelocity[key] = 0;
	        lastIdealStyle[key] = styleValue;
	        lastIdealVelocity[key] = 0;
	      }
	    }
	
	    if (dirty) {
	      this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      // check if we need to animate in the first place
	      var propsStyle = _this.props.style;
	      if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	        if (_this.wasAnimating && _this.props.onRest) {
	          _this.props.onRest();
	        }
	
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.wasAnimating = false;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      _this.wasAnimating = true;
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyle = {};
	      var newLastIdealVelocity = {};
	      var newCurrentStyle = {};
	      var newCurrentVelocity = {};
	
	      for (var key in propsStyle) {
	        if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	          continue;
	        }
	
	        var styleValue = propsStyle[key];
	        if (typeof styleValue === 'number') {
	          newCurrentStyle[key] = styleValue;
	          newCurrentVelocity[key] = 0;
	          newLastIdealStyle[key] = styleValue;
	          newLastIdealVelocity[key] = 0;
	        } else {
	          var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	          var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	          for (var i = 0; i < framesToCatchUp; i++) {
	            var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            newLastIdealStyleValue = _stepper[0];
	            newLastIdealVelocityValue = _stepper[1];
	          }
	
	          var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	          var nextIdealX = _stepper2[0];
	          var nextIdealV = _stepper2[1];
	
	          newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	          newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	          newLastIdealStyle[key] = newLastIdealStyleValue;
	          newLastIdealVelocity[key] = newLastIdealVelocityValue;
	        }
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyle: newCurrentStyle,
	        currentVelocity: newCurrentVelocity,
	        lastIdealStyle: newLastIdealStyle,
	        lastIdealVelocity: newLastIdealVelocity
	      });
	
	      _this.unreadPropStyle = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = Motion;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-motion/lib/mapToZero.js":
/***/ function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-motion/lib/stripStyle.js":
/***/ function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-motion/lib/stepper.js":
/***/ function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ },

/***/ "./node_modules/performance-now/lib/performance-now.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ },

/***/ "./node_modules/raf/index.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__("./node_modules/raf/node_modules/performance-now/lib/performance-now.js")
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "./node_modules/raf/node_modules/performance-now/lib/performance-now.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ },

/***/ "./node_modules/react-motion/lib/shouldStopAnimation.js":
/***/ function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-motion/lib/StaggeredMotion.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__("./node_modules/react-motion/lib/mapToZero.js");
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__("./node_modules/react-motion/lib/stripStyle.js");
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__("./node_modules/react-motion/lib/stepper.js");
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__("./node_modules/performance-now/lib/performance-now.js");
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__("./node_modules/raf/index.js");
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__("./node_modules/react-motion/lib/shouldStopAnimation.js");
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__("./node_modules/create-react-class/index.js");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = _createReactClass2['default']({
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	    styles: _propTypes2['default'].func.isRequired,
	    children: _propTypes2['default'].func.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  },
	
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _state = this.state;
	    var currentStyles = _state.currentStyles;
	    var currentVelocities = _state.currentVelocities;
	    var lastIdealStyles = _state.lastIdealStyles;
	    var lastIdealVelocities = _state.lastIdealVelocities;
	
	    var someDirty = false;
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i];
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            someDirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	        }
	      }
	    }
	
	    if (someDirty) {
	      this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyles = [];
	      var newLastIdealVelocities = [];
	      var newCurrentStyles = [];
	      var newCurrentVelocities = [];
	
	      for (var i = 0; i < destStyles.length; i++) {
	        var destStyle = destStyles[i];
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in destStyle) {
	          if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	            continue;
	          }
	
	          var styleValue = destStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-motion/lib/TransitionMotion.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__("./node_modules/react-motion/lib/mapToZero.js");
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__("./node_modules/react-motion/lib/stripStyle.js");
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__("./node_modules/react-motion/lib/stepper.js");
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__("./node_modules/react-motion/lib/mergeDiff.js");
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__("./node_modules/performance-now/lib/performance-now.js");
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__("./node_modules/raf/index.js");
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__("./node_modules/react-motion/lib/shouldStopAnimation.js");
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__("./node_modules/create-react-class/index.js");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = _createReactClass2['default']({
	  propTypes: {
	    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	      key: _propTypes2['default'].string.isRequired,
	      data: _propTypes2['default'].any,
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	    })),
	    styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	      key: _propTypes2['default'].string.isRequired,
	      data: _propTypes2['default'].any,
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	    }))]).isRequired,
	    children: _propTypes2['default'].func.isRequired,
	    willEnter: _propTypes2['default'].func,
	    willLeave: _propTypes2['default'].func,
	    didLeave: _propTypes2['default'].func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync[0];
	    var currentStyles = _mergeAndSync[1];
	    var currentVelocities = _mergeAndSync[2];
	    var lastIdealStyles = _mergeAndSync[3];
	    var lastIdealVelocities = _mergeAndSync[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  },
	
	  unmounting: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _mergeAndSync2 = mergeAndSync(this.props.willEnter, this.props.willLeave, this.props.didLeave, this.state.mergedPropsStyles, unreadPropStyles, this.state.currentStyles, this.state.currentVelocities, this.state.lastIdealStyles, this.state.lastIdealVelocities);
	
	    var mergedPropsStyles = _mergeAndSync2[0];
	    var currentStyles = _mergeAndSync2[1];
	    var currentVelocities = _mergeAndSync2[2];
	    var lastIdealStyles = _mergeAndSync2[3];
	    var lastIdealVelocities = _mergeAndSync2[4];
	
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i].style;
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            mergedPropsStyles[i] = {
	              key: mergedPropsStyles[i].key,
	              data: mergedPropsStyles[i].data,
	              style: _extends({}, mergedPropsStyles[i].style)
	            };
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	          mergedPropsStyles[i].style[key] = styleValue;
	        }
	      }
	    }
	
	    // unlike the other 2 components, we can't detect staleness and optionally
	    // opt out of setState here. each style object's data might contain new
	    // stuff we're not/cannot compare
	    this.setState({
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      mergedPropsStyles: mergedPropsStyles,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities
	    });
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    if (this.unmounting) {
	      return;
	    }
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      // https://github.com/chenglou/react-motion/pull/420
	      // > if execution passes the conditional if (this.unmounting), then
	      // executes async defaultRaf and after that component unmounts and after
	      // that the callback of defaultRaf is called, then setState will be called
	      // on unmounted component.
	      if (_this.unmounting) {
	        return;
	      }
	
	      var propStyles = _this.props.styles;
	      var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var _mergeAndSync3 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var newMergedPropsStyles = _mergeAndSync3[0];
	      var newCurrentStyles = _mergeAndSync3[1];
	      var newCurrentVelocities = _mergeAndSync3[2];
	      var newLastIdealStyles = _mergeAndSync3[3];
	      var newLastIdealVelocities = _mergeAndSync3[4];
	
	      for (var i = 0; i < newMergedPropsStyles.length; i++) {
	        var newMergedPropsStyle = newMergedPropsStyles[i].style;
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in newMergedPropsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = newMergedPropsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = newLastIdealStyles[i][key];
	            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities,
	        mergedPropsStyles: newMergedPropsStyles
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives

/***/ },

/***/ "./node_modules/react-motion/lib/mergeDiff.js":
/***/ function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ },

/***/ "./node_modules/react-motion/lib/spring.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__("./node_modules/react-motion/lib/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-motion/lib/presets.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-motion/lib/reorderKeys.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Dispatcher.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pubsubJs = __webpack_require__("./node_modules/pubsub-js/src/pubsub.js");
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dispatcher = {
	  subscribe: function subscribe(event, callback) {
	    var _this = this;
	
	    var token = _pubsubJs2.default.subscribe(event, function (msg, data) {
	      callback.apply(_this, data);
	    });
	
	    return token;
	  },
	  unsubscribe: _pubsubJs2.default.unsubscribe,
	  publish: function publish(event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    _pubsubJs2.default.publish(event, args);
	  }
	};
	
	exports.default = Dispatcher;

/***/ },

/***/ "./node_modules/pubsub-js/src/pubsub.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Copyright (c) 2010,2011,2012,2013,2014 Morgan Roderick http://roderick.dk
	 * License: MIT - http://mrgnrdrck.mit-license.org
	 *
	 * https://github.com/mroderick/PubSubJS
	 */
	
	(function (root, factory){
	    'use strict';
	
	    var PubSub = {};
	
	    if (root.PubSub) {
	        PubSub = root.PubSub;
	        console.warn("PubSub already loaded, using existing version");
	    } else {
	        root.PubSub = PubSub;
	        factory(PubSub);
	    }
	    // CommonJS and Node.js module support
	    if (true){
	        if (module !== undefined && module.exports) {
	            exports = module.exports = PubSub; // Node.js specific `module.exports`
	        }
	        exports.PubSub = PubSub; // CommonJS module 1.1.1 spec
	        module.exports = exports = PubSub; // CommonJS
	    }
	    // AMD support
	    /* eslint-disable no-undef */
	    else if (typeof define === 'function' && define.amd){
	        define(function() { return PubSub; });
	        /* eslint-enable no-undef */
	    }
	
	}(( typeof window === 'object' && window ) || this || global, function (PubSub){
	    'use strict';
	
	    var messages = {},
	        lastUid = -1,
	        ALL_SUBSCRIBING_MSG = '*';
	
	    function hasKeys(obj){
	        var key;
	
	        for (key in obj){
	            if ( Object.prototype.hasOwnProperty.call(obj, key) ){
	                return true;
	            }
	        }
	        return false;
	    }
	
	    /**
	     * Returns a function that throws the passed exception, for use as argument for setTimeout
	     * @alias throwException
	     * @function
	     * @param { Object } ex An Error object
	     */
	    function throwException( ex ){
	        return function reThrowException(){
	            throw ex;
	        };
	    }
	
	    function callSubscriberWithDelayedExceptions( subscriber, message, data ){
	        try {
	            subscriber( message, data );
	        } catch( ex ){
	            setTimeout( throwException( ex ), 0);
	        }
	    }
	
	    function callSubscriberWithImmediateExceptions( subscriber, message, data ){
	        subscriber( message, data );
	    }
	
	    function deliverMessage( originalMessage, matchedMessage, data, immediateExceptions ){
	        var subscribers = messages[matchedMessage],
	            callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions,
	            s;
	
	        if ( !Object.prototype.hasOwnProperty.call( messages, matchedMessage ) ) {
	            return;
	        }
	
	        for (s in subscribers){
	            if ( Object.prototype.hasOwnProperty.call(subscribers, s)){
	                callSubscriber( subscribers[s], originalMessage, data );
	            }
	        }
	    }
	
	    function createDeliveryFunction( message, data, immediateExceptions ){
	        return function deliverNamespaced(){
	            var topic = String( message ),
	                position = topic.lastIndexOf( '.' );
	
	            // deliver the message as it is now
	            deliverMessage(message, message, data, immediateExceptions);
	
	            // trim the hierarchy and deliver message to each level
	            while( position !== -1 ){
	                topic = topic.substr( 0, position );
	                position = topic.lastIndexOf('.');
	                deliverMessage( message, topic, data, immediateExceptions );
	            }
	
	            deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
	        };
	    }
	
	    function hasDirectSubscribersFor( message ) {
	        var topic = String( message ),
	            found = Boolean(Object.prototype.hasOwnProperty.call( messages, topic ) && hasKeys(messages[topic]));
	
	        return found;
	    }
	
	    function messageHasSubscribers( message ){
	        var topic = String( message ),
	            found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG),
	            position = topic.lastIndexOf( '.' );
	
	        while ( !found && position !== -1 ){
	            topic = topic.substr( 0, position );
	            position = topic.lastIndexOf( '.' );
	            found = hasDirectSubscribersFor(topic);
	        }
	
	        return found;
	    }
	
	    function publish( message, data, sync, immediateExceptions ){
	        message = (typeof message === 'symbol') ? message.toString() : message;
	
	        var deliver = createDeliveryFunction( message, data, immediateExceptions ),
	            hasSubscribers = messageHasSubscribers( message );
	
	        if ( !hasSubscribers ){
	            return false;
	        }
	
	        if ( sync === true ){
	            deliver();
	        } else {
	            setTimeout( deliver, 0 );
	        }
	        return true;
	    }
	
	    /**
	     * Publishes the message, passing the data to it's subscribers
	     * @function
	     * @alias publish
	     * @param { String } message The message to publish
	     * @param {} data The data to pass to subscribers
	     * @return { Boolean }
	     */
	    PubSub.publish = function( message, data ){
	        return publish( message, data, false, PubSub.immediateExceptions );
	    };
	
	    /**
	     * Publishes the message synchronously, passing the data to it's subscribers
	     * @function
	     * @alias publishSync
	     * @param { String } message The message to publish
	     * @param {} data The data to pass to subscribers
	     * @return { Boolean }
	     */
	    PubSub.publishSync = function( message, data ){
	        return publish( message, data, true, PubSub.immediateExceptions );
	    };
	
	    /**
	     * Subscribes the passed function to the passed message. Every returned token is unique and should be stored if you need to unsubscribe
	     * @function
	     * @alias subscribe
	     * @param { String } message The message to subscribe to
	     * @param { Function } func The function to call when a new message is published
	     * @return { String }
	     */
	    PubSub.subscribe = function( message, func ){
	        if ( typeof func !== 'function'){
	            return false;
	        }
	
	        message = (typeof message === 'symbol') ? message.toString() : message;
	
	        // message is not registered yet
	        if ( !Object.prototype.hasOwnProperty.call( messages, message ) ){
	            messages[message] = {};
	        }
	
	        // forcing token as String, to allow for future expansions without breaking usage
	        // and allow for easy use as key names for the 'messages' object
	        var token = 'uid_' + String(++lastUid);
	        messages[message][token] = func;
	
	        // return token for unsubscribing
	        return token;
	    };
	
	    PubSub.subscribeAll = function( func ){
	        return PubSub.subscribe(ALL_SUBSCRIBING_MSG, func);
	    };
	
	    /**
	     * Subscribes the passed function to the passed message once
	     * @function
	     * @alias subscribeOnce
	     * @param { String } message The message to subscribe to
	     * @param { Function } func The function to call when a new message is published
	     * @return { PubSub }
	     */
	    PubSub.subscribeOnce = function( message, func ){
	        var token = PubSub.subscribe( message, function(){
	            // before func apply, unsubscribe message
	            PubSub.unsubscribe( token );
	            func.apply( this, arguments );
	        });
	        return PubSub;
	    };
	
	    /**
	     * Clears all subscriptions
	     * @function
	     * @public
	     * @alias clearAllSubscriptions
	     */
	    PubSub.clearAllSubscriptions = function clearAllSubscriptions(){
	        messages = {};
	    };
	
	    /**
	     * Clear subscriptions by the topic
	     * @function
	     * @public
	     * @alias clearAllSubscriptions
	     * @return { int }
	     */
	    PubSub.clearSubscriptions = function clearSubscriptions(topic){
	        var m;
	        for (m in messages){
	            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
	                delete messages[m];
	            }
	        }
	    };
	
	    /**
	       Count subscriptions by the topic
	     * @function
	     * @public
	     * @alias countSubscriptions
	     * @return { Array }
	    */
	    PubSub.countSubscriptions = function countSubscriptions(topic){
	        var m;
	        // eslint-disable-next-line no-unused-vars
	        var token;
	        var count = 0;
	        for (m in messages) {
	            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
	                for (token in messages[m]) {
	                    count++;
	                }
	                break;
	            }
	        }
	        return count;
	    };
	
	
	    /**
	       Gets subscriptions by the topic
	     * @function
	     * @public
	     * @alias getSubscriptions
	    */
	    PubSub.getSubscriptions = function getSubscriptions(topic){
	        var m;
	        var list = [];
	        for (m in messages){
	            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
	                list.push(m);
	            }
	        }
	        return list;
	    };
	
	    /**
	     * Removes subscriptions
	     *
	     * - When passed a token, removes a specific subscription.
	     *
		 * - When passed a function, removes all subscriptions for that function
	     *
		 * - When passed a topic, removes all subscriptions for that topic (hierarchy)
	     * @function
	     * @public
	     * @alias subscribeOnce
	     * @param { String | Function } value A token, function or topic to unsubscribe from
	     * @example // Unsubscribing with a token
	     * var token = PubSub.subscribe('mytopic', myFunc);
	     * PubSub.unsubscribe(token);
	     * @example // Unsubscribing with a function
	     * PubSub.unsubscribe(myFunc);
	     * @example // Unsubscribing from a topic
	     * PubSub.unsubscribe('mytopic');
	     */
	    PubSub.unsubscribe = function(value){
	        var descendantTopicExists = function(topic) {
	                var m;
	                for ( m in messages ){
	                    if ( Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0 ){
	                        // a descendant of the topic exists:
	                        return true;
	                    }
	                }
	
	                return false;
	            },
	            isTopic    = typeof value === 'string' && ( Object.prototype.hasOwnProperty.call(messages, value) || descendantTopicExists(value) ),
	            isToken    = !isTopic && typeof value === 'string',
	            isFunction = typeof value === 'function',
	            result = false,
	            m, message, t;
	
	        if (isTopic){
	            PubSub.clearSubscriptions(value);
	            return;
	        }
	
	        for ( m in messages ){
	            if ( Object.prototype.hasOwnProperty.call( messages, m ) ){
	                message = messages[m];
	
	                if ( isToken && message[value] ){
	                    delete message[value];
	                    result = value;
	                    // tokens are unique, so we can just stop here
	                    break;
	                }
	
	                if (isFunction) {
	                    for ( t in message ){
	                        if (Object.prototype.hasOwnProperty.call(message, t) && message[t] === value){
	                            delete message[t];
	                            result = true;
	                        }
	                    }
	                }
	            }
	        }
	
	        return result;
	    };
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Nav.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _slicedToArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/slicedToArray.js");
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__("./node_modules/keycode/index.js");
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__("./node_modules/react-prop-types/lib/all.js");
	
	var _all2 = _interopRequireDefault(_all);
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js");
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _react2.default.PropTypes.any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _react2.default.PropTypes.string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _react2.default.PropTypes.bool,
	
	  justified: (0, _all2.default)(_react2.default.PropTypes.bool, function (_ref) {
	    var justified = _ref.justified,
	        navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   *  Any eventKey,
	   *  SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _react2.default.PropTypes.func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _react2.default.PropTypes.string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _react2.default.PropTypes.bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _react2.default.PropTypes.bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _react2.default.PropTypes.bool
	};
	
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	var contextTypes = {
	  $bs_navbar: _react2.default.PropTypes.shape({
	    bsClass: _react2.default.PropTypes.string
	  }),
	
	  $bs_tabContainer: _react2.default.PropTypes.shape({
	    activeKey: _react2.default.PropTypes.any,
	    onSelect: _react2.default.PropTypes.func.isRequired,
	    getTabId: _react2.default.PropTypes.func.isRequired,
	    getPaneId: _react2.default.PropTypes.func.isRequired
	  })
	};
	
	var Nav = function (_React$Component) {
	  (0, _inherits3.default)(Nav, _React$Component);
	
	  function Nav() {
	    (0, _classCallCheck3.default)(this, Nav);
	    return (0, _possibleConstructorReturn3.default)(this, (Nav.__proto__ || (0, _getPrototypeOf2.default)(Nav)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Nav, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      if (!this._needsRefocus) {
	        return;
	      }
	
	      this._needsRefocus = false;
	
	      var children = this.props.children;
	
	      var activeChild = _ValidComponentChildren2.default.find(children, function (child) {
	        return _this2.isChildActive(child);
	      });
	
	      var childrenArray = _ValidComponentChildren2.default.toArray(children);
	      var activeChildIndex = childrenArray.indexOf(activeChild);
	
	      var childNodes = _reactDom2.default.findDOMNode(this).children;
	      var activeNode = childNodes && childNodes[activeChildIndex];
	
	      if (!activeNode || !activeNode.firstChild) {
	        return;
	      }
	
	      activeNode.firstChild.focus();
	    }
	  }, {
	    key: 'handleTabKeyDown',
	    value: function handleTabKeyDown(onSelect, event) {
	      var nextActiveChild = void 0;
	
	      switch (event.keyCode) {
	        case _keycode2.default.codes.left:
	        case _keycode2.default.codes.up:
	          nextActiveChild = this.getNextActiveChild(-1);
	          break;
	        case _keycode2.default.codes.right:
	        case _keycode2.default.codes.down:
	          nextActiveChild = this.getNextActiveChild(1);
	          break;
	        default:
	          // It was a different key; don't handle this keypress.
	          return;
	      }
	
	      event.preventDefault();
	
	      if (onSelect && nextActiveChild && nextActiveChild.props.eventKey) {
	        onSelect(nextActiveChild.props.eventKey);
	      }
	
	      this._needsRefocus = true;
	    }
	  }, {
	    key: 'getNextActiveChild',
	    value: function getNextActiveChild(offset) {
	      var _this3 = this;
	
	      var children = this.props.children;
	
	      var validChildren = children.filter(function (child) {
	        return child.props.eventKey && !child.props.disabled;
	      });
	
	      var activeChild = _ValidComponentChildren2.default.find(children, function (child) {
	        return _this3.isChildActive(child);
	      });
	
	      // This assumes the active child is not disabled.
	      var activeChildIndex = validChildren.indexOf(activeChild);
	      if (activeChildIndex === -1) {
	        // Something has gone wrong. Select the first valid child we can find.
	        return validChildren[0];
	      }
	
	      var nextIndex = activeChildIndex + offset;
	      var numValidChildren = validChildren.length;
	
	      if (nextIndex >= numValidChildren) {
	        nextIndex = 0;
	      } else if (nextIndex < 0) {
	        nextIndex = numValidChildren - 1;
	      }
	
	      return validChildren[nextIndex];
	    }
	  }, {
	    key: 'isChildActive',
	    value: function isChildActive(child) {
	      var _props = this.props,
	          activeKey = _props.activeKey,
	          activeHref = _props.activeHref;
	
	      var tabContainer = this.context.$bs_tabContainer;
	
	      if (tabContainer) {
	        var childKey = child.props.eventKey;
	
	        (0, _warning2.default)(!child.props.active, 'Specifying a `<NavItem>` `active` prop in the context of a ' + '`<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + childKey + '} />`'));
	
	        var active = childKey === tabContainer.activeKey;
	
	        // Only warn on the active child to avoid spamming the console.
	        (0, _warning2.default)(!active || activeKey == null && !activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + childKey + '} />`'));
	
	        return active;
	      }
	
	      if (child.props.active) {
	        return true;
	      }
	
	      if (activeKey != null && child.props.eventKey === activeKey) {
	        return true;
	      }
	
	      if (activeHref && child.props.href === activeHref) {
	        return true;
	      }
	
	      return child.props.active;
	    }
	  }, {
	    key: 'getTabProps',
	    value: function getTabProps(child, tabContainer, navRole, active, onSelect) {
	      var _this4 = this;
	
	      if (!tabContainer && navRole !== 'tablist') {
	        // No tab props here.
	        return null;
	      }
	
	      var _child$props = child.props,
	          id = _child$props.id,
	          controls = _child$props['aria-controls'],
	          eventKey = _child$props.eventKey,
	          role = _child$props.role,
	          onKeyDown = _child$props.onKeyDown,
	          tabIndex = _child$props.tabIndex;
	
	
	      if (tabContainer) {
	        (0, _warning2.default)(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.');
	
	        id = tabContainer.getTabId(eventKey);
	        controls = tabContainer.getPaneId(eventKey);
	      }
	
	      if (navRole === 'tablist') {
	        role = role || 'tab';
	        onKeyDown = (0, _createChainedFunction2.default)(function (event) {
	          return _this4.handleTabKeyDown(onSelect, event);
	        }, onKeyDown);
	        tabIndex = active ? tabIndex : -1;
	      }
	
	      return {
	        id: id,
	        role: role,
	        onKeyDown: onKeyDown,
	        'aria-controls': controls,
	        tabIndex: tabIndex
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _extends2,
	          _this5 = this;
	
	      var _props2 = this.props,
	          activeKey = _props2.activeKey,
	          activeHref = _props2.activeHref,
	          stacked = _props2.stacked,
	          justified = _props2.justified,
	          onSelect = _props2.onSelect,
	          propsRole = _props2.role,
	          propsNavbar = _props2.navbar,
	          pullRight = _props2.pullRight,
	          pullLeft = _props2.pullLeft,
	          className = _props2.className,
	          children = _props2.children,
	          props = (0, _objectWithoutProperties3.default)(_props2, ['activeKey', 'activeHref', 'stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);
	
	
	      var tabContainer = this.context.$bs_tabContainer;
	      var role = propsRole || (tabContainer ? 'tablist' : null);
	
	      var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	          _splitBsProps2 = (0, _slicedToArray3.default)(_splitBsProps, 2),
	          bsProps = _splitBsProps2[0],
	          elementProps = _splitBsProps2[1];
	
	      var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, (0, _defineProperty3.default)(_extends2, (0, _bootstrapUtils.prefix)(bsProps, 'stacked'), stacked), (0, _defineProperty3.default)(_extends2, (0, _bootstrapUtils.prefix)(bsProps, 'justified'), justified), _extends2));
	
	      var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	      var pullLeftClassName = void 0;
	      var pullRightClassName = void 0;
	
	      if (navbar) {
	        var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	        classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	
	        pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	        pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	      } else {
	        pullRightClassName = 'pull-right';
	        pullLeftClassName = 'pull-left';
	      }
	
	      classes[pullRightClassName] = pullRight;
	      classes[pullLeftClassName] = pullLeft;
	
	      delete elementProps.active;
	
	      return _react2.default.createElement(
	        'ul',
	        (0, _extends4.default)({}, elementProps, {
	          role: role,
	          className: (0, _classnames2.default)(className, classes)
	        }),
	        _ValidComponentChildren2.default.map(children, function (child) {
	          var active = _this5.isChildActive(child);
	          var childOnSelect = (0, _createChainedFunction2.default)(child.props.onSelect, onSelect, tabContainer && tabContainer.onSelect);
	
	          return (0, _react.cloneElement)(child, (0, _extends4.default)({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
	            active: active,
	            activeKey: activeKey,
	            activeHref: activeHref,
	            onSelect: childOnSelect
	          }));
	        })
	      );
	    }
	  }]);
	  return Nav;
	}(_react2.default.Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/NavItem.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _NavItem = __webpack_require__("./node_modules/react-bootstrap/lib/NavItem.js");
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavItem = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(NavItem, _React$Component);
	
	  function NavItem() {
	    (0, _classCallCheck3.default)(this, NavItem);
	    return (0, _possibleConstructorReturn3.default)(this, (NavItem.__proto__ || (0, _getPrototypeOf2.default)(NavItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(NavItem, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	
	      if (props.divider) {
	        props.className = (0, _classnames2.default)(props.className, 'divider');
	
	        return _react2.default.createElement('li', { className: props.className });
	      }
	
	      return _react2.default.createElement(_NavItem2.default, props);
	    }
	  }]);
	  return NavItem;
	}(_react2.default.Component), _class.propTypes = {
	  divider: _react2.default.PropTypes.bool
	}, _temp);
	exports.default = NavItem;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/NavItem.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__("./node_modules/react-bootstrap/lib/SafeAnchor.js");
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string,
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  eventKey: _propTypes2['default'].any
	};
	
	var defaultProps = {
	  active: false,
	  disabled: false
	};
	
	var NavItem = function (_React$Component) {
	  (0, _inherits3['default'])(NavItem, _React$Component);
	
	  function NavItem(props, context) {
	    (0, _classCallCheck3['default'])(this, NavItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  NavItem.prototype.handleClick = function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, e);
	      }
	    }
	  };
	
	  NavItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        onClick = _props.onClick,
	        className = _props.className,
	        style = _props.style,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    // These are injected down by `<Nav>` for building `<SubNav>`s.
	    delete props.activeKey;
	    delete props.activeHref;
	
	    if (!props.role) {
	      if (props.href === '#') {
	        props.role = 'button';
	      }
	    } else if (props.role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return NavItem;
	}(_react2['default'].Component);
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	
	exports['default'] = NavItem;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Timeline.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimelineBody = exports.TimelineTitle = exports.TimelineAvatar = exports.TimelineIcon = exports.TimelineHeader = exports.TimelineItem = exports.TimelineView = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Icon.js");
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimelineView = exports.TimelineView = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(TimelineView, _React$Component);
	
	  function TimelineView() {
	    (0, _classCallCheck3.default)(this, TimelineView);
	    return (0, _possibleConstructorReturn3.default)(this, (TimelineView.__proto__ || (0, _getPrototypeOf2.default)(TimelineView)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TimelineView, [{
	    key: 'render',
	    value: function render() {
	      var classes = (0, _classnames2.default)({
	        'rubix-timeline-view': true,
	        'rubix-timeline-centered': this.props.centered || false,
	        'rubix-timeline-with-header': this.props.withHeader || false,
	        'rubix-timeline-normal': !this.props.withHeader
	      }, this.props.className);
	
	      var props = (0, _extends3.default)({}, this.props, {
	        centered: null,
	        withHeader: null,
	        className: classes.trim()
	      });
	
	      delete props.centered;
	      delete props.withHeader;
	
	      return _react2.default.createElement(
	        'div',
	        props,
	        this.props.children
	      );
	    }
	  }]);
	  return TimelineView;
	}(_react2.default.Component), _class.propTypes = {
	  centered: _react2.default.PropTypes.bool,
	  withHeader: _react2.default.PropTypes.bool
	}, _temp);
	
	var TimelineItem = exports.TimelineItem = function (_React$Component2) {
	  (0, _inherits3.default)(TimelineItem, _React$Component2);
	
	  function TimelineItem() {
	    (0, _classCallCheck3.default)(this, TimelineItem);
	    return (0, _possibleConstructorReturn3.default)(this, (TimelineItem.__proto__ || (0, _getPrototypeOf2.default)(TimelineItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TimelineItem, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props, {
	        className: (0, _classnames2.default)('rubix-timeline-item', this.props.className)
	      });
	
	      return _react2.default.createElement(
	        'div',
	        props,
	        this.props.children
	      );
	    }
	  }]);
	  return TimelineItem;
	}(_react2.default.Component);
	
	var TimelineHeader = exports.TimelineHeader = function (_React$Component3) {
	  (0, _inherits3.default)(TimelineHeader, _React$Component3);
	
	  function TimelineHeader() {
	    (0, _classCallCheck3.default)(this, TimelineHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (TimelineHeader.__proto__ || (0, _getPrototypeOf2.default)(TimelineHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TimelineHeader, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props, {
	        className: (0, _classnames2.default)('rubix-timeline-header', this.props.className)
	      });
	
	      return _react2.default.createElement(
	        'div',
	        props,
	        this.props.children
	      );
	    }
	  }]);
	  return TimelineHeader;
	}(_react2.default.Component);
	
	var TimelineIcon = exports.TimelineIcon = function (_React$Component4) {
	  (0, _inherits3.default)(TimelineIcon, _React$Component4);
	
	  function TimelineIcon() {
	    (0, _classCallCheck3.default)(this, TimelineIcon);
	    return (0, _possibleConstructorReturn3.default)(this, (TimelineIcon.__proto__ || (0, _getPrototypeOf2.default)(TimelineIcon)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TimelineIcon, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props, {
	        className: (0, _classnames2.default)('rubix-timeline-icon', this.props.className)
	      });
	
	      return _react2.default.createElement(_Icon2.default, props);
	    }
	  }]);
	  return TimelineIcon;
	}(_react2.default.Component);
	
	var TimelineAvatar = exports.TimelineAvatar = function (_React$Component5) {
	  (0, _inherits3.default)(TimelineAvatar, _React$Component5);
	
	  function TimelineAvatar() {
	    (0, _classCallCheck3.default)(this, TimelineAvatar);
	    return (0, _possibleConstructorReturn3.default)(this, (TimelineAvatar.__proto__ || (0, _getPrototypeOf2.default)(TimelineAvatar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TimelineAvatar, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({
	        width: 30,
	        height: 30
	      }, this.props, {
	        className: (0, _classnames2.default)('rubix-timeline-avatar', this.props.className),
	        style: {
	          borderWidth: 2,
	          borderStyle: 'solid',
	          borderRadius: 100,
	          padding: 2,
	          position: 'absolute',
	          top: 0
	        }
	      });
	
	      return _react2.default.createElement('img', props);
	    }
	  }]);
	  return TimelineAvatar;
	}(_react2.default.Component);
	
	var TimelineTitle = exports.TimelineTitle = function (_React$Component6) {
	  (0, _inherits3.default)(TimelineTitle, _React$Component6);
	
	  function TimelineTitle() {
	    (0, _classCallCheck3.default)(this, TimelineTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (TimelineTitle.__proto__ || (0, _getPrototypeOf2.default)(TimelineTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TimelineTitle, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props, {
	        className: (0, _classnames2.default)('rubix-timeline-title', this.props.className)
	      });
	
	      return _react2.default.createElement(
	        'div',
	        props,
	        this.props.children
	      );
	    }
	  }]);
	  return TimelineTitle;
	}(_react2.default.Component);
	
	var TimelineBody = exports.TimelineBody = function (_React$Component7) {
	  (0, _inherits3.default)(TimelineBody, _React$Component7);
	
	  function TimelineBody() {
	    (0, _classCallCheck3.default)(this, TimelineBody);
	    return (0, _possibleConstructorReturn3.default)(this, (TimelineBody.__proto__ || (0, _getPrototypeOf2.default)(TimelineBody)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TimelineBody, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props, {
	        className: (0, _classnames2.default)('rubix-timeline-body', this.props.className)
	      });
	
	      return _react2.default.createElement(
	        'div',
	        props,
	        this.props.children
	      );
	    }
	  }]);
	  return TimelineBody;
	}(_react2.default.Component);

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Accordion.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Accordion = __webpack_require__("./node_modules/react-bootstrap/lib/Accordion.js");
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Accordion2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Accordion.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelGroup = __webpack_require__("./node_modules/react-bootstrap/lib/PanelGroup.js");
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Accordion = function (_React$Component) {
	  (0, _inherits3['default'])(Accordion, _React$Component);
	
	  function Accordion() {
	    (0, _classCallCheck3['default'])(this, Accordion);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Accordion.prototype.render = function render() {
	    return _react2['default'].createElement(
	      _PanelGroup2['default'],
	      (0, _extends3['default'])({}, this.props, { accordion: true }),
	      this.props.children
	    );
	  };
	
	  return Accordion;
	}(_react2['default'].Component);
	
	exports['default'] = Accordion;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/PanelGroup.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js");
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  accordion: _propTypes2['default'].bool,
	  activeKey: _propTypes2['default'].any,
	  defaultActiveKey: _propTypes2['default'].any,
	  onSelect: _propTypes2['default'].func,
	  role: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  accordion: false
	};
	
	// TODO: Use uncontrollable.
	
	var PanelGroup = function (_React$Component) {
	  (0, _inherits3['default'])(PanelGroup, _React$Component);
	
	  function PanelGroup(props, context) {
	    (0, _classCallCheck3['default'])(this, PanelGroup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	
	    _this.state = {
	      activeKey: props.defaultActiveKey
	    };
	    return _this;
	  }
	
	  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
	    e.preventDefault();
	
	    if (this.props.onSelect) {
	      this.props.onSelect(key, e);
	    }
	
	    if (this.state.activeKey === key) {
	      key = null;
	    }
	
	    this.setState({ activeKey: key });
	  };
	
	  PanelGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        accordion = _props.accordion,
	        propsActiveKey = _props.activeKey,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['accordion', 'activeKey', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultActiveKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeKey = void 0;
	    if (accordion) {
	      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
	      elementProps.role = elementProps.role || 'tablist';
	    }
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var childProps = {
	          bsStyle: child.props.bsStyle || bsProps.bsStyle
	        };
	
	        if (accordion) {
	          (0, _assign2['default'])(childProps, {
	            headerRole: 'tab',
	            panelRole: 'tabpanel',
	            collapsible: true,
	            expanded: child.props.eventKey === activeKey,
	            onSelect: (0, _createChainedFunction2['default'])(_this2.handleSelect, child.props.onSelect)
	          });
	        }
	
	        return (0, _react.cloneElement)(child, childProps);
	      })
	    );
	  };
	
	  return PanelGroup;
	}(_react2['default'].Component);
	
	PanelGroup.propTypes = propTypes;
	PanelGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel-group', PanelGroup);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Alert.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Alert = __webpack_require__("./node_modules/react-bootstrap/lib/Alert.js");
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Alert = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(Alert, _React$Component);
	
	  function Alert() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, Alert);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Alert.__proto__ || (0, _getPrototypeOf2.default)(Alert)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { alertVisible: true };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Alert, [{
	    key: 'handleAlertDismiss',
	    value: function handleAlertDismiss() {
	      this.setState({ alertVisible: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	
	      if (props.success) {
	        props.bsStyle = 'success';
	        delete props.success;
	      }
	
	      if (props.info) {
	        props.bsStyle = 'info';
	        delete props.info;
	      }
	
	      if (props.warning) {
	        props.bsStyle = 'warning';
	        delete props.warning;
	      }
	
	      if (props.danger) {
	        props.bsStyle = 'danger';
	        delete props.danger;
	      }
	
	      if (!props.dismissible) {
	        delete props.dismissible;
	        return _react2.default.createElement(_Alert2.default, props);
	      }
	
	      if (this.state.alertVisible) {
	        delete props.dismissible;
	        return _react2.default.createElement(_Alert2.default, (0, _extends3.default)({}, props, { onDismiss: this.handleAlertDismiss.bind(this) }));
	      }
	
	      return null;
	    }
	  }]);
	  return Alert;
	}(_react2.default.Component), _class.propTypes = {
	  success: _react2.default.PropTypes.bool,
	  info: _react2.default.PropTypes.bool,
	  warning: _react2.default.PropTypes.bool,
	  danger: _react2.default.PropTypes.bool,
	  dismissible: _react2.default.PropTypes.bool
	}, _temp);
	exports.default = Alert;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Alert.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__("./node_modules/babel-runtime/core-js/object/values.js");
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onDismiss: _propTypes2['default'].func,
	  closeLabel: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  closeLabel: 'Close alert'
	};
	
	var Alert = function (_React$Component) {
	  (0, _inherits3['default'])(Alert, _React$Component);
	
	  function Alert() {
	    (0, _classCallCheck3['default'])(this, Alert);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Alert.prototype.renderDismissButton = function renderDismissButton(onDismiss) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: onDismiss,
	        'aria-hidden': 'true',
	        tabIndex: '-1'
	      },
	      _react2['default'].createElement(
	        'span',
	        null,
	        '\xD7'
	      )
	    );
	  };
	
	  Alert.prototype.renderSrOnlyDismissButton = function renderSrOnlyDismissButton(onDismiss, closeLabel) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close sr-only',
	        onClick: onDismiss
	      },
	      closeLabel
	    );
	  };
	
	  Alert.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        onDismiss = _props.onDismiss,
	        closeLabel = _props.closeLabel,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onDismiss', 'closeLabel', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var dismissable = !!onDismiss;
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dismissable')] = dismissable, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'alert',
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      dismissable && this.renderDismissButton(onDismiss),
	      children,
	      dismissable && this.renderSrOnlyDismissButton(onDismiss, closeLabel)
	    );
	  };
	
	  return Alert;
	}(_react2['default'].Component);
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), _StyleConfig.State.INFO, (0, _bootstrapUtils.bsClass)('alert', Alert));
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/AlertLink.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertLink = function (_React$Component) {
	  (0, _inherits3.default)(AlertLink, _React$Component);
	
	  function AlertLink() {
	    (0, _classCallCheck3.default)(this, AlertLink);
	    return (0, _possibleConstructorReturn3.default)(this, (AlertLink.__proto__ || (0, _getPrototypeOf2.default)(AlertLink)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AlertLink, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	      props.className = (0, _classnames2.default)('alert-link', props.className);
	
	      return _react2.default.createElement('a', props);
	    }
	  }]);
	  return AlertLink;
	}(_react2.default.Component);
	
	exports.default = AlertLink;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Badge.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Badge = __webpack_require__("./node_modules/react-bootstrap/lib/Badge.js");
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Badge2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Badge.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `pullRight` doesn't belong here. There's no special handling here.
	
	var propTypes = {
	  pullRight: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  pullRight: false
	};
	
	var Badge = function (_React$Component) {
	  (0, _inherits3['default'])(Badge, _React$Component);
	
	  function Badge() {
	    (0, _classCallCheck3['default'])(this, Badge);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Badge.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Badge.prototype.render = function render() {
	    var _props = this.props,
	        pullRight = _props.pullRight,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['pullRight', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'pull-right': pullRight,
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Badge;
	}(_react2['default'].Component);
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('badge', Badge);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Breadcrumb.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Breadcrumb = __webpack_require__("./node_modules/react-bootstrap/lib/Breadcrumb.js");
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Breadcrumb2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Breadcrumb.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BreadcrumbItem = __webpack_require__("./node_modules/react-bootstrap/lib/BreadcrumbItem.js");
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Breadcrumb = function (_React$Component) {
	  (0, _inherits3['default'])(Breadcrumb, _React$Component);
	
	  function Breadcrumb() {
	    (0, _classCallCheck3['default'])(this, Breadcrumb);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Breadcrumb.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ol', (0, _extends3['default'])({}, elementProps, {
	      role: 'navigation',
	      'aria-label': 'breadcrumbs',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Breadcrumb;
	}(_react2['default'].Component);
	
	Breadcrumb.Item = _BreadcrumbItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('breadcrumb', Breadcrumb);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/BreadcrumbItem.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__("./node_modules/react-bootstrap/lib/SafeAnchor.js");
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * If set to true, renders `span` instead of `a`
	   */
	  active: _propTypes2['default'].bool,
	  /**
	   * `href` attribute for the inner `a` element
	   */
	  href: _propTypes2['default'].string,
	  /**
	   * `title` attribute for the inner `a` element
	   */
	  title: _propTypes2['default'].node,
	  /**
	   * `target` attribute for the inner `a` element
	   */
	  target: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  active: false
	};
	
	var BreadcrumbItem = function (_React$Component) {
	  (0, _inherits3['default'])(BreadcrumbItem, _React$Component);
	
	  function BreadcrumbItem() {
	    (0, _classCallCheck3['default'])(this, BreadcrumbItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  BreadcrumbItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        href = _props.href,
	        title = _props.title,
	        target = _props.target,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'href', 'title', 'target', 'className']);
	
	    // Don't try to render these props on non-active <span>.
	
	    var linkProps = { href: href, title: title, target: target };
	
	    return _react2['default'].createElement(
	      'li',
	      { className: (0, _classnames2['default'])(className, { active: active }) },
	      active ? _react2['default'].createElement('span', props) : _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, linkProps))
	    );
	  };
	
	  return BreadcrumbItem;
	}(_react2['default'].Component);
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	
	exports['default'] = BreadcrumbItem;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/BreadcrumbItem.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BreadcrumbItem = __webpack_require__("./node_modules/react-bootstrap/lib/BreadcrumbItem.js");
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BreadcrumbItem2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/ButtonToolbar.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ButtonToolbar = __webpack_require__("./node_modules/react-bootstrap/lib/ButtonToolbar.js");
	
	var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ButtonToolbar2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/ButtonToolbar.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__("./node_modules/react-bootstrap/lib/Button.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ButtonToolbar = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonToolbar, _React$Component);
	
	  function ButtonToolbar() {
	    (0, _classCallCheck3['default'])(this, ButtonToolbar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonToolbar.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'toolbar',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonToolbar;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-toolbar', (0, _bootstrapUtils.bsSizes)(_Button2['default'].SIZES, ButtonToolbar));
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/BPanel.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Panel = __webpack_require__("./node_modules/react-bootstrap/lib/Panel.js");
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Panel2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Panel.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__("./node_modules/babel-runtime/core-js/object/values.js");
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__("./node_modules/react-bootstrap/lib/Collapse.js");
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  collapsible: _propTypes2['default'].bool,
	  onSelect: _propTypes2['default'].func,
	  header: _propTypes2['default'].node,
	  id: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  footer: _propTypes2['default'].node,
	  defaultExpanded: _propTypes2['default'].bool,
	  expanded: _propTypes2['default'].bool,
	  eventKey: _propTypes2['default'].any,
	  headerRole: _propTypes2['default'].string,
	  panelRole: _propTypes2['default'].string,
	
	  // From Collapse.
	  onEnter: _propTypes2['default'].func,
	  onEntering: _propTypes2['default'].func,
	  onEntered: _propTypes2['default'].func,
	  onExit: _propTypes2['default'].func,
	  onExiting: _propTypes2['default'].func,
	  onExited: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  defaultExpanded: false
	};
	
	var Panel = function (_React$Component) {
	  (0, _inherits3['default'])(Panel, _React$Component);
	
	  function Panel(props, context) {
	    (0, _classCallCheck3['default'])(this, Panel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClickTitle = _this.handleClickTitle.bind(_this);
	
	    _this.state = {
	      expanded: _this.props.defaultExpanded
	    };
	    return _this;
	  }
	
	  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
	    // FIXME: What the heck? This API is horrible. This needs to go away!
	    e.persist();
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  };
	
	  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
	    var titleClassName = (0, _bootstrapUtils.prefix)(bsProps, 'title');
	
	    if (!collapsible) {
	      if (!_react2['default'].isValidElement(header)) {
	        return header;
	      }
	
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, titleClassName)
	      });
	    }
	
	    if (!_react2['default'].isValidElement(header)) {
	      return _react2['default'].createElement(
	        'h4',
	        { role: 'presentation', className: titleClassName },
	        this.renderAnchor(header, id, role, expanded)
	      );
	    }
	
	    return (0, _react.cloneElement)(header, {
	      className: (0, _classnames2['default'])(header.props.className, titleClassName),
	      children: this.renderAnchor(header.props.children, id, role, expanded)
	    });
	  };
	
	  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
	    return _react2['default'].createElement(
	      'a',
	      {
	        role: role,
	        href: id && '#' + id,
	        onClick: this.handleClickTitle,
	        'aria-controls': id,
	        'aria-expanded': expanded,
	        'aria-selected': expanded,
	        className: expanded ? null : 'collapsed'
	      },
	      header
	    );
	  };
	
	  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': expanded }, animationHooks),
	      _react2['default'].createElement(
	        'div',
	        {
	          id: id,
	          role: role,
	          className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse'),
	          'aria-hidden': !expanded
	        },
	        this.renderBody(children, bsProps)
	      )
	    );
	  };
	
	  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
	    var children = [];
	    var bodyChildren = [];
	
	    var bodyClassName = (0, _bootstrapUtils.prefix)(bsProps, 'body');
	
	    function maybeAddBody() {
	      if (!bodyChildren.length) {
	        return;
	      }
	
	      // Derive the key from the index here, since we need to make one up.
	      children.push(_react2['default'].createElement(
	        'div',
	        { key: children.length, className: bodyClassName },
	        bodyChildren
	      ));
	
	      bodyChildren = [];
	    }
	
	    // Convert to array so we can re-use keys.
	    _react2['default'].Children.toArray(rawChildren).forEach(function (child) {
	      if (_react2['default'].isValidElement(child) && child.props.fill) {
	        maybeAddBody();
	
	        // Remove the child's unknown `fill` prop.
	        children.push((0, _react.cloneElement)(child, { fill: undefined }));
	
	        return;
	      }
	
	      bodyChildren.push(child);
	    });
	
	    maybeAddBody();
	
	    return children;
	  };
	
	  Panel.prototype.render = function render() {
	    var _props = this.props,
	        collapsible = _props.collapsible,
	        header = _props.header,
	        id = _props.id,
	        footer = _props.footer,
	        propsExpanded = _props.expanded,
	        headerRole = _props.headerRole,
	        panelRole = _props.panelRole,
	        className = _props.className,
	        children = _props.children,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultExpanded', 'eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        id: collapsible ? null : id
	      }),
	      header && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'heading') },
	        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
	      ),
	      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
	      footer && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'footer') },
	        footer
	      )
	    );
	  };
	
	  return Panel;
	}(_react2['default'].Component);
	
	Panel.propTypes = propTypes;
	Panel.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel));
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Collapse.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/style/index.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__("./node_modules/react-overlays/lib/Transition.js");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _capitalize = __webpack_require__("./node_modules/react-bootstrap/lib/utils/capitalize.js");
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	function triggerBrowserReflow(node) {
	  node.offsetHeight; // eslint-disable-line no-unused-expressions
	}
	
	function getDimensionValue(dimension, elem) {
	  var value = elem['offset' + (0, _capitalize2['default'])(dimension)];
	  var margins = MARGINS[dimension];
	
	  return value + parseInt((0, _style2['default'])(elem, margins[0]), 10) + parseInt((0, _style2['default'])(elem, margins[1]), 10);
	}
	
	var propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  'in': _propTypes2['default'].bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _propTypes2['default'].bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2['default'].bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _propTypes2['default'].number,
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _propTypes2['default'].func,
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _propTypes2['default'].oneOfType([_propTypes2['default'].oneOf(['height', 'width']), _propTypes2['default'].func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _propTypes2['default'].func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	var Collapse = function (_React$Component) {
	  (0, _inherits3['default'])(Collapse, _React$Component);
	
	  function Collapse(props, context) {
	    (0, _classCallCheck3['default'])(this, Collapse);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleEntered = _this.handleEntered.bind(_this);
	    _this.handleExit = _this.handleExit.bind(_this);
	    _this.handleExiting = _this.handleExiting.bind(_this);
	    return _this;
	  }
	
	  /* -- Expanding -- */
	
	
	  Collapse.prototype.handleEnter = function handleEnter(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.handleEntering = function handleEntering(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
	  };
	
	  Collapse.prototype.handleEntered = function handleEntered(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = null;
	  };
	
	  /* -- Collapsing -- */
	
	
	  Collapse.prototype.handleExit = function handleExit(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
	    triggerBrowserReflow(elem);
	  };
	
	  Collapse.prototype.handleExiting = function handleExiting(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype._dimension = function _dimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  };
	
	  // for testing
	
	
	  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem['scroll' + (0, _capitalize2['default'])(dimension)] + 'px';
	  };
	
	  Collapse.prototype.render = function render() {
	    var _props = this.props,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);
	
	
	    delete props.dimension;
	    delete props.getDimensionValue;
	
	    var handleEnter = (0, _createChainedFunction2['default'])(this.handleEnter, onEnter);
	    var handleEntering = (0, _createChainedFunction2['default'])(this.handleEntering, onEntering);
	    var handleEntered = (0, _createChainedFunction2['default'])(this.handleEntered, onEntered);
	    var handleExit = (0, _createChainedFunction2['default'])(this.handleExit, onExit);
	    var handleExiting = (0, _createChainedFunction2['default'])(this.handleExiting, onExiting);
	
	    var classes = {
	      width: this._dimension() === 'width'
	    };
	
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, props, {
	      'aria-expanded': props.role ? props['in'] : null,
	      className: (0, _classnames2['default'])(className, classes),
	      exitedClassName: 'collapse',
	      exitingClassName: 'collapsing',
	      enteredClassName: 'collapse in',
	      enteringClassName: 'collapsing',
	      onEnter: handleEnter,
	      onEntering: handleEntering,
	      onEntered: handleEntered,
	      onExit: handleExit,
	      onExiting: handleExiting
	    }));
	  };
	
	  return Collapse;
	}(_react2['default'].Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	
	exports['default'] = Collapse;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/style/index.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/util/camelizeStyle.js"));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/util/hyphenateStyle.js"));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/style/getComputedStyle.js"));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/style/removeStyle.js"));
	
	var _properties = __webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/transition/properties.js");
	
	var _isTransform = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/transition/isTransform.js"));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/util/camelizeStyle.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/util/camelize.js"));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/util/camelize.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/util/hyphenateStyle.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/util/hyphenate.js"));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/util/hyphenate.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/style/getComputedStyle.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/util/camelizeStyle.js"));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/style/removeStyle.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/transition/properties.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/util/inDOM.js"));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/util/inDOM.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/transition/isTransform.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/lib/Transition.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/events/on.js");
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/transition/properties.js");
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this, props, context));
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  _createClass(Transition, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var status = this.state.status;
	
	
	      if (nextProps.in) {
	        if (status === UNMOUNTED) {
	          this.setState({ status: EXITED });
	        }
	        if (status !== ENTERING && status !== ENTERED) {
	          this.nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          this.nextStatus = EXITING;
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.cancelNextCallback();
	    }
	  }, {
	    key: 'updateStatus',
	    value: function updateStatus() {
	      var _this2 = this;
	
	      if (this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(this);
	
	        if (this.nextStatus === ENTERING) {
	          this.props.onEnter(node);
	
	          this.safeSetState({ status: ENTERING }, function () {
	            _this2.props.onEntering(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: ENTERED }, function () {
	                _this2.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          this.props.onExit(node);
	
	          this.safeSetState({ status: EXITING }, function () {
	            _this2.props.onExiting(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: EXITED }, function () {
	                _this2.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        this.nextStatus = null;
	      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	        this.setState({ status: UNMOUNTED });
	      }
	    }
	  }, {
	    key: 'cancelNextCallback',
	    value: function cancelNextCallback() {
	      if (this.nextCallback !== null) {
	        this.nextCallback.cancel();
	        this.nextCallback = null;
	      }
	    }
	  }, {
	    key: 'safeSetState',
	    value: function safeSetState(nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      this.setState(nextState, this.setNextCallback(callback));
	    }
	  }, {
	    key: 'setNextCallback',
	    value: function setNextCallback(callback) {
	      var _this3 = this;
	
	      var active = true;
	
	      this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this3.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return this.nextCallback;
	    }
	  }, {
	    key: 'onTransitionEnd',
	    value: function onTransitionEnd(node, handler) {
	      this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, this.nextCallback);
	        setTimeout(this.nextCallback, this.props.timeout);
	      } else {
	        setTimeout(this.nextCallback, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var status = this.state.status;
	      if (status === UNMOUNTED) {
	        return null;
	      }
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	      Object.keys(Transition.propTypes).forEach(function (key) {
	        return delete childProps[key];
	      });
	
	      var transitionClassName = void 0;
	      if (status === EXITED) {
	        transitionClassName = this.props.exitedClassName;
	      } else if (status === ENTERING) {
	        transitionClassName = this.props.enteringClassName;
	      } else if (status === ENTERED) {
	        transitionClassName = this.props.enteredClassName;
	      } else if (status === EXITING) {
	        transitionClassName = this.props.exitingClassName;
	      }
	
	      var child = _react2.default.Children.only(children);
	      return _react2.default.cloneElement(child, _extends({}, childProps, {
	        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	      }));
	    }
	  }]);
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _react2.default.PropTypes.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _react2.default.PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _react2.default.PropTypes.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2.default.PropTypes.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _react2.default.PropTypes.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _react2.default.PropTypes.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _react2.default.PropTypes.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _react2.default.PropTypes.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/transition/properties.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/util/inDOM.js"));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ },

/***/ "./node_modules/react-bootstrap/lib/utils/capitalize.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = capitalize;
	function capitalize(string) {
	  return "" + string.charAt(0).toUpperCase() + string.slice(1);
	}
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/BPanelGroup.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PanelGroup = __webpack_require__("./node_modules/react-bootstrap/lib/PanelGroup.js");
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PanelGroup2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Carousel.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Carousel = __webpack_require__("./node_modules/react-bootstrap/lib/Carousel.js");
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Carousel2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Carousel.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CarouselCaption = __webpack_require__("./node_modules/react-bootstrap/lib/CarouselCaption.js");
	
	var _CarouselCaption2 = _interopRequireDefault(_CarouselCaption);
	
	var _CarouselItem = __webpack_require__("./node_modules/react-bootstrap/lib/CarouselItem.js");
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _Glyphicon = __webpack_require__("./node_modules/react-bootstrap/lib/Glyphicon.js");
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _SafeAnchor = __webpack_require__("./node_modules/react-bootstrap/lib/SafeAnchor.js");
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _ValidComponentChildren = __webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js");
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `slide` should be `animate`.
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  slide: _propTypes2['default'].bool,
	  indicators: _propTypes2['default'].bool,
	  interval: _propTypes2['default'].number,
	  controls: _propTypes2['default'].bool,
	  pauseOnHover: _propTypes2['default'].bool,
	  wrap: _propTypes2['default'].bool,
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: any) => any | (eventKey: any, event: Object) => any
	   * ```
	   *
	   * If this callback takes two or more arguments, the second argument will
	   * be a persisted event object with `direction` set to the direction of the
	   * transition.
	   */
	  onSelect: _propTypes2['default'].func,
	  onSlideEnd: _propTypes2['default'].func,
	  activeIndex: _propTypes2['default'].number,
	  defaultActiveIndex: _propTypes2['default'].number,
	  direction: _propTypes2['default'].oneOf(['prev', 'next']),
	  prevIcon: _propTypes2['default'].node,
	  /**
	   * Label shown to screen readers only, can be used to show the previous element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  prevLabel: _propTypes2['default'].string,
	  nextIcon: _propTypes2['default'].node,
	  /**
	   * Label shown to screen readers only, can be used to show the next element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  nextLabel: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  slide: true,
	  interval: 5000,
	  pauseOnHover: true,
	  wrap: true,
	  indicators: true,
	  controls: true,
	  prevIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-left' }),
	  prevLabel: 'Previous',
	  nextIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-right' }),
	  nextLabel: 'Next'
	};
	
	var Carousel = function (_React$Component) {
	  (0, _inherits3['default'])(Carousel, _React$Component);
	
	  function Carousel(props, context) {
	    (0, _classCallCheck3['default'])(this, Carousel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handlePrev = _this.handlePrev.bind(_this);
	    _this.handleNext = _this.handleNext.bind(_this);
	    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);
	
	    var defaultActiveIndex = props.defaultActiveIndex;
	
	
	    _this.state = {
	      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
	      previousActiveIndex: null,
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	  };
	
	  Carousel.prototype.componentDidMount = function componentDidMount() {
	    this.waitForNext();
	  };
	
	  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	    this.isUnmounted = true;
	  };
	
	  Carousel.prototype.handleMouseOver = function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  };
	
	  Carousel.prototype.handleMouseOut = function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  Carousel.prototype.handlePrev = function handlePrev(e) {
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _ValidComponentChildren2['default'].count(this.props.children) - 1;
	    }
	
	    this.select(index, e, 'prev');
	  };
	
	  Carousel.prototype.handleNext = function handleNext(e) {
	    var index = this.getActiveIndex() + 1;
	    var count = _ValidComponentChildren2['default'].count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.select(index, e, 'next');
	  };
	
	  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  };
	
	  Carousel.prototype.getActiveIndex = function getActiveIndex() {
	    var activeIndexProp = this.props.activeIndex;
	    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
	  };
	
	  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  };
	
	  Carousel.prototype.select = function select(index, e, direction) {
	    clearTimeout(this.timeout);
	
	    // TODO: Is this necessary? Seems like the only risk is if the component
	    // unmounts while handleItemAnimateOutEnd fires.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
	    direction = direction || this.getDirection(previousActiveIndex, index);
	
	    var onSelect = this.props.onSelect;
	
	
	    if (onSelect) {
	      if (onSelect.length > 1) {
	        // React SyntheticEvents are pooled, so we need to remove this event
	        // from the pool to add a custom property. To avoid unnecessarily
	        // removing objects from the pool, only do this when the listener
	        // actually wants the event.
	        if (e) {
	          e.persist();
	          e.direction = direction;
	        } else {
	          e = { direction: direction };
	        }
	
	        onSelect(index, e);
	      } else {
	        onSelect(index);
	      }
	    }
	
	    if (this.props.activeIndex == null && index !== previousActiveIndex) {
	      if (this.state.previousActiveIndex != null) {
	        // If currently animating don't activate the new index.
	        // TODO: look into queueing this canceled call and
	        // animating after the current animation has ended.
	        return;
	      }
	
	      this.setState({
	        activeIndex: index,
	        previousActiveIndex: previousActiveIndex,
	        direction: direction
	      });
	    }
	  };
	
	  Carousel.prototype.waitForNext = function waitForNext() {
	    var _props = this.props,
	        slide = _props.slide,
	        interval = _props.interval,
	        activeIndexProp = _props.activeIndex;
	
	
	    if (!this.isPaused && slide && interval && activeIndexProp == null) {
	      this.timeout = setTimeout(this.handleNext, interval);
	    }
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.pause = function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.play = function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  };
	
	  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
	    var _this3 = this;
	
	    var indicators = [];
	
	    _ValidComponentChildren2['default'].forEach(children, function (child, index) {
	      indicators.push(_react2['default'].createElement('li', {
	        key: index,
	        className: index === activeIndex ? 'active' : null,
	        onClick: function onClick(e) {
	          return _this3.select(index, e);
	        }
	      }),
	
	      // Force whitespace between indicator elements. Bootstrap requires
	      // this for correct spacing of elements.
	      ' ');
	    });
	
	    return _react2['default'].createElement(
	      'ol',
	      { className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators') },
	      indicators
	    );
	  };
	
	  Carousel.prototype.renderControls = function renderControls(properties) {
	    var wrap = properties.wrap,
	        children = properties.children,
	        activeIndex = properties.activeIndex,
	        prevIcon = properties.prevIcon,
	        nextIcon = properties.nextIcon,
	        bsProps = properties.bsProps,
	        prevLabel = properties.prevLabel,
	        nextLabel = properties.nextLabel;
	
	    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');
	    var count = _ValidComponentChildren2['default'].count(children);
	
	    return [(wrap || activeIndex !== 0) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'prev',
	        className: (0, _classnames2['default'])(controlClassName, 'left'),
	        onClick: this.handlePrev
	      },
	      prevIcon,
	      prevLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        prevLabel
	      )
	    ), (wrap || activeIndex !== count - 1) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'next',
	        className: (0, _classnames2['default'])(controlClassName, 'right'),
	        onClick: this.handleNext
	      },
	      nextIcon,
	      nextLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        nextLabel
	      )
	    )];
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props,
	        slide = _props2.slide,
	        indicators = _props2.indicators,
	        controls = _props2.controls,
	        wrap = _props2.wrap,
	        prevIcon = _props2.prevIcon,
	        prevLabel = _props2.prevLabel,
	        nextIcon = _props2.nextIcon,
	        nextLabel = _props2.nextLabel,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);
	    var _state = this.state,
	        previousActiveIndex = _state.previousActiveIndex,
	        direction = _state.direction;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
	    'defaultActiveIndex', 'direction']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeIndex = this.getActiveIndex();
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      slide: slide
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      }),
	      indicators && this.renderIndicators(children, activeIndex, bsProps),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        _ValidComponentChildren2['default'].map(children, function (child, index) {
	          var active = index === activeIndex;
	          var previousActive = slide && index === previousActiveIndex;
	
	          return (0, _react.cloneElement)(child, {
	            active: active,
	            index: index,
	            animateOut: previousActive,
	            animateIn: active && previousActiveIndex != null && slide,
	            direction: direction,
	            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
	          });
	        })
	      ),
	      controls && this.renderControls({
	        wrap: wrap,
	        children: children,
	        activeIndex: activeIndex,
	        prevIcon: prevIcon,
	        prevLabel: prevLabel,
	        nextIcon: nextIcon,
	        nextLabel: nextLabel,
	        bsProps: bsProps
	      })
	    );
	  };
	
	  return Carousel;
	}(_react2['default'].Component);
	
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	
	Carousel.Caption = _CarouselCaption2['default'];
	Carousel.Item = _CarouselItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel', Carousel);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/CarouselCaption.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var CarouselCaption = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselCaption, _React$Component);
	
	  function CarouselCaption() {
	    (0, _classCallCheck3['default'])(this, CarouselCaption);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  CarouselCaption.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselCaption;
	}(_react2['default'].Component);
	
	CarouselCaption.propTypes = propTypes;
	CarouselCaption.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/CarouselItem.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionEvents = __webpack_require__("./node_modules/react-bootstrap/lib/utils/TransitionEvents.js");
	
	var _TransitionEvents2 = _interopRequireDefault(_TransitionEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should use a timeout instead of TransitionEvents, or else just
	// not wait until transition end to trigger continuing animations.
	
	var propTypes = {
	  direction: _propTypes2['default'].oneOf(['prev', 'next']),
	  onAnimateOutEnd: _propTypes2['default'].func,
	  active: _propTypes2['default'].bool,
	  animateIn: _propTypes2['default'].bool,
	  animateOut: _propTypes2['default'].bool,
	  index: _propTypes2['default'].number
	};
	
	var defaultProps = {
	  active: false,
	  animateIn: false,
	  animateOut: false
	};
	
	var CarouselItem = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselItem, _React$Component);
	
	  function CarouselItem(props, context) {
	    (0, _classCallCheck3['default'])(this, CarouselItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);
	
	    _this.state = {
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({ direction: null });
	    }
	  };
	
	  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    var active = this.props.active;
	
	    var prevActive = prevProps.active;
	
	    if (!active && prevActive) {
	      _TransitionEvents2['default'].addEndEventListener(_reactDom2['default'].findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (active !== prevActive) {
	      setTimeout(function () {
	        return _this2.startAnimation();
	      }, 20);
	    }
	  };
	
	  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    if (this.props.onAnimateOutEnd) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  };
	
	  CarouselItem.prototype.startAnimation = function startAnimation() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  };
	
	  CarouselItem.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        active = _props.active,
	        animateIn = _props.animateIn,
	        animateOut = _props.animateOut,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);
	
	
	    delete props.onAnimateOutEnd;
	    delete props.index;
	
	    var classes = {
	      item: true,
	      active: active && !animateIn || animateOut
	    };
	    if (direction && active && animateIn) {
	      classes[direction] = true;
	    }
	    if (this.state.direction && (animateIn || animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselItem;
	}(_react2['default'].Component);
	
	CarouselItem.propTypes = propTypes;
	CarouselItem.defaultProps = defaultProps;
	
	exports['default'] = CarouselItem;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/utils/TransitionEvents.js":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = ReactTransitionEvents;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Glyphicon.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
	   */
	  glyph: _propTypes2['default'].string.isRequired
	};
	
	var Glyphicon = function (_React$Component) {
	  (0, _inherits3['default'])(Glyphicon, _React$Component);
	
	  function Glyphicon() {
	    (0, _classCallCheck3['default'])(this, Glyphicon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Glyphicon.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        glyph = _props.glyph,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['glyph', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
	
	    return _react2['default'].createElement('span', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Glyphicon;
	}(_react2['default'].Component);
	
	Glyphicon.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Checkbox.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Checkbox = __webpack_require__("./node_modules/react-bootstrap/lib/Checkbox.js");
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Checkbox2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Checkbox.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Checkbox inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Checkbox = function (_React$Component) {
	  (0, _inherits3['default'])(Checkbox, _React$Component);
	
	  function Checkbox() {
	    (0, _classCallCheck3['default'])(this, Checkbox);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Checkbox.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'checkbox',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Checkbox;
	}(_react2['default'].Component);
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('checkbox', Checkbox);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Clearfix.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Clearfix = __webpack_require__("./node_modules/react-bootstrap/lib/Clearfix.js");
	
	var _Clearfix2 = _interopRequireDefault(_Clearfix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Clearfix2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Clearfix.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _capitalize = __webpack_require__("./node_modules/react-bootstrap/lib/utils/capitalize.js");
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Apply clearfix
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `visible-xs-block`
	   */
	  visibleXsBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Small devices Tablets
	   *
	   * adds class `visible-sm-block`
	   */
	  visibleSmBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `visible-md-block`
	   */
	  visibleMdBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Large devices Desktops
	   *
	   * adds class `visible-lg-block`
	   */
	  visibleLgBlock: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Clearfix = function (_React$Component) {
	  (0, _inherits3['default'])(Clearfix, _React$Component);
	
	  function Clearfix() {
	    (0, _classCallCheck3['default'])(this, Clearfix);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Clearfix.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      var propName = 'visible' + (0, _capitalize2['default'])(size) + 'Block';
	      if (elementProps[propName]) {
	        classes['visible-' + size + '-block'] = true;
	      }
	
	      delete elementProps[propName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Clearfix;
	}(_react2['default'].Component);
	
	Clearfix.propTypes = propTypes;
	Clearfix.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('clearfix', Clearfix);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/ControlLabel.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ControlLabel = __webpack_require__("./node_modules/react-bootstrap/lib/ControlLabel.js");
	
	var _ControlLabel2 = _interopRequireDefault(_ControlLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ControlLabel2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/ControlLabel.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  htmlFor: _propTypes2['default'].string,
	  srOnly: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  srOnly: false
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var ControlLabel = function (_React$Component) {
	  (0, _inherits3['default'])(ControlLabel, _React$Component);
	
	  function ControlLabel() {
	    (0, _classCallCheck3['default'])(this, ControlLabel);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ControlLabel.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        _props$htmlFor = _props.htmlFor,
	        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
	        srOnly = _props.srOnly,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['htmlFor', 'srOnly', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'sr-only': srOnly
	    });
	
	    return _react2['default'].createElement('label', (0, _extends3['default'])({}, elementProps, {
	      htmlFor: htmlFor,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ControlLabel;
	}(_react2['default'].Component);
	
	ControlLabel.propTypes = propTypes;
	ControlLabel.defaultProps = defaultProps;
	ControlLabel.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('control-label', ControlLabel);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Collapse.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Collapse = __webpack_require__("./node_modules/react-bootstrap/lib/Collapse.js");
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Collapse2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/DropdownButton.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.DropdownHoverButtonHOC = exports.DropdownButtonHOC = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class4;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DropdownButton = __webpack_require__("./node_modules/react-bootstrap/lib/DropdownButton.js");
	
	var _DropdownButton2 = _interopRequireDefault(_DropdownButton);
	
	var _isBrowser = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/isBrowser.js");
	
	var _isBrowser2 = _interopRequireDefault(_isBrowser);
	
	var _isTouchDevice = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/isTouchDevice.js");
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestFrame = null,
	    rAF = function rAF() {},
	    cAF = function cAF() {};
	
	if ((0, _isBrowser2.default)()) {
	  requestFrame = __webpack_require__("./node_modules/request-frame/dist/request-frame.js");
	
	  requestFrame = typeof requestFrame === "function" ? requestFrame : requestFrame.default;
	
	  rAF = requestFrame('request');
	  cAF = requestFrame('cancel');
	}
	
	var expectedTypes = ["success", "warning", "danger", "info", "default", "primary", "link"];
	
	function isBtnOfType(type) {
	  for (var i = 0; i < expectedTypes.length; i++) {
	    if (expectedTypes[i] === type) {
	      return true;
	    }
	  }
	  return false;
	}
	
	var DropdownButtonHOC = exports.DropdownButtonHOC = function DropdownButtonHOC(ComposedComponent) {
	  var _class, _temp;
	
	  return _temp = _class = function (_React$Component) {
	    (0, _inherits3.default)(_class, _React$Component);
	
	    function _class() {
	      (0, _classCallCheck3.default)(this, _class);
	      return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(_class, [{
	      key: 'render',
	      value: function render() {
	        var props = (0, _extends3.default)({}, this.props);
	
	        if (this.props.hasOwnProperty('xs')) {
	          props.bsSize = 'xsmall';
	          delete props.xs;
	        }
	
	        if (this.props.hasOwnProperty('sm')) {
	          props.bsSize = 'small';
	          delete props.sm;
	        }
	
	        if (this.props.hasOwnProperty('lg')) {
	          props.bsSize = 'large';
	          delete props.lg;
	        }
	
	        if (this.props.hasOwnProperty('bsStyle') && typeof this.props.bsStyle === 'string') {
	          var styles = this.props.bsStyle.split(/\s|\,/mgi).filter(function (a) {
	            return a;
	          });
	          for (var i = 0; i < styles.length; i++) {
	            props.className = (0, _classnames2.default)(props.className, 'btn-' + styles[i]);
	            if (styles[i] === 'link') {
	              props.bsClass = 'menu-default dropdown';
	            } else {
	              props.bsClass = 'menu-' + styles[i] + ' dropdown';
	            }
	            if (isBtnOfType(styles[i])) {
	              props.bsStyle = styles[i];
	            } else {
	              props.bsStyle = 'default';
	            }
	          }
	        }
	
	        if (!props.bsStyle) {
	          props.bsStyle = 'default';
	        }
	
	        if (!props.className) {
	          props.className = 'btn-default';
	        }
	
	        if (!props.bsClass) {
	          props.bsClass = 'menu-default dropdown';
	        }
	
	        if (props.hasOwnProperty('dropup')) {
	          props.bsClass = 'dropup ' + props.bsClass;
	        }
	
	        if (props.retainBackground) {
	          props.className = (0, _classnames2.default)(props.className, 'btn-retainBg');
	        }
	
	        if (props.rounded) {
	          props.className = (0, _classnames2.default)(props.className, 'btn-rounded');
	        }
	
	        if (props.onlyOnHover) {
	          props.className = (0, _classnames2.default)(props.className, 'btn-onlyOnHover');
	        }
	
	        if (props.inverse || props.retainBackground) {
	          props.className = (0, _classnames2.default)(props.className, 'btn-inverse');
	        }
	
	        if (props.outlined || props.onlyOnHover || props.inverse || props.retainBackground) {
	          props.className = (0, _classnames2.default)(props.className, 'btn-outlined');
	        }
	
	        delete props.retainBackground;
	        delete props.onlyOnHover;
	        delete props.outlined;
	        delete props.rounded;
	        delete props.inverse;
	        delete props.dropup;
	
	        return _react2.default.createElement(ComposedComponent, { buttonProps: props });
	      }
	    }]);
	    return _class;
	  }(_react2.default.Component), _class.displayName = 'DropdownButton', _class.propTypes = {
	    xs: _react2.default.PropTypes.bool,
	    sm: _react2.default.PropTypes.bool,
	    lg: _react2.default.PropTypes.bool,
	    rounded: _react2.default.PropTypes.bool,
	    onlyOnHover: _react2.default.PropTypes.bool,
	    retainBackground: _react2.default.PropTypes.bool,
	    inverse: _react2.default.PropTypes.bool,
	    outlined: _react2.default.PropTypes.bool
	  }, _temp;
	};
	
	var DropdownHoverButtonHOC = exports.DropdownHoverButtonHOC = function DropdownHoverButtonHOC(ComposedComponent) {
	  var _class2, _class3, _temp2;
	
	  return DropdownButtonHOC(_class2 = (_temp2 = _class3 = function (_React$Component2) {
	    (0, _inherits3.default)(_class2, _React$Component2);
	
	    function _class2(props) {
	      (0, _classCallCheck3.default)(this, _class2);
	
	      var _this2 = (0, _possibleConstructorReturn3.default)(this, (_class2.__proto__ || (0, _getPrototypeOf2.default)(_class2)).call(this, props));
	
	      _this2.state = {
	        open: false
	      };
	
	      _this2._eventObject = {
	        handleEvent: _this2._handleOver.bind(_this2),
	        name: 'DropdownHoverEvent'
	      };
	
	      _this2._timeout = null;
	      return _this2;
	    }
	
	    (0, _createClass3.default)(_class2, [{
	      key: '_isWithinDropdown',
	      value: function _isWithinDropdown(node) {
	        var componentNode = _reactDom2.default.findDOMNode(this._node);
	        return componentNode.contains(node) || componentNode === node;
	      }
	    }, {
	      key: '_handleOver',
	      value: function _handleOver(e) {
	        var _this3 = this;
	
	        if (this._isWithinDropdown(e.target)) {
	          cAF(this._timeout);
	          this.setState({ open: true });
	        } else {
	          this._timeout = rAF(function () {
	            _this3.setState({ open: false });
	          });
	        }
	      }
	    }, {
	      key: '_onToggle',
	      value: function _onToggle(isOpen) {
	        this.setState({ open: isOpen });
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (!(0, _isTouchDevice2.default)()) {
	          document.removeEventListener('mouseover', this._eventObject);
	        }
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var _this4 = this;
	
	        if (!(0, _isTouchDevice2.default)()) {
	          rAF(function () {
	            document.addEventListener('mouseover', _this4._eventObject);
	          });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this5 = this;
	
	        return _react2.default.createElement(ComposedComponent, { ref: function ref(node) {
	            return _this5._node = node;
	          },
	          onToggle: this._onToggle.bind(this),
	          open: this.state.open,
	          buttonProps: this.props.buttonProps });
	      }
	    }]);
	    return _class2;
	  }(_react2.default.Component), _class3.displayName = 'DropdownHoverButton', _temp2)) || _class2;
	};
	
	var DropdownButton = DropdownButtonHOC(_class4 = function (_React$Component3) {
	  (0, _inherits3.default)(DropdownButton, _React$Component3);
	
	  function DropdownButton() {
	    (0, _classCallCheck3.default)(this, DropdownButton);
	    return (0, _possibleConstructorReturn3.default)(this, (DropdownButton.__proto__ || (0, _getPrototypeOf2.default)(DropdownButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DropdownButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_DropdownButton2.default, this.props.buttonProps);
	    }
	  }]);
	  return DropdownButton;
	}(_react2.default.Component)) || _class4;
	
	exports.default = DropdownButton;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/DropdownButton.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__("./node_modules/react-bootstrap/lib/Dropdown.js");
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__("./node_modules/react-bootstrap/lib/utils/splitComponentProps.js");
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2['default'].string,
	  bsSize: _propTypes2['default'].string,
	  title: _propTypes2['default'].node.isRequired,
	  noCaret: _propTypes2['default'].bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var DropdownButton = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    (0, _classCallCheck3['default'])(this, DropdownButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, {
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return DropdownButton;
	}(_react2['default'].Component);
	
	DropdownButton.propTypes = propTypes;
	
	exports['default'] = DropdownButton;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Dropdown.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _activeElement = __webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/activeElement.js");
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/query/contains.js");
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _keycode = __webpack_require__("./node_modules/keycode/index.js");
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__("./node_modules/react-prop-types/lib/all.js");
	
	var _all2 = _interopRequireDefault(_all);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _isRequiredForA11y = __webpack_require__("./node_modules/react-prop-types/lib/isRequiredForA11y.js");
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__("./node_modules/uncontrollable/index.js");
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ButtonGroup = __webpack_require__("./node_modules/react-bootstrap/lib/ButtonGroup.js");
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__("./node_modules/react-bootstrap/lib/DropdownMenu.js");
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__("./node_modules/react-bootstrap/lib/DropdownToggle.js");
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _PropTypes = __webpack_require__("./node_modules/react-bootstrap/lib/utils/PropTypes.js");
	
	var _ValidComponentChildren = __webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js");
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TOGGLE_ROLE = _DropdownToggle2['default'].defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2['default'].defaultProps.bsRole;
	
	var propTypes = {
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _propTypes2['default'].bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  componentClass: _elementType2['default'],
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
	   * @type {node}
	   */
	  children: (0, _all2['default'])((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _propTypes2['default'].bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _propTypes2['default'].bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _propTypes2['default'].bool,
	
	  /**
	   * A callback fired when the Dropdown closes.
	   */
	  onClose: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
	   *
	   * ```js
	   * function(Boolean isOpen, Object event, { String source }) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _propTypes2['default'].string,
	
	  /**
	   * Which event when fired outside the component will cause it to be closed
	   */
	  rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown']),
	
	  /**
	   * @private
	   */
	  onMouseEnter: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseLeave: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: _ButtonGroup2['default']
	};
	
	var Dropdown = function (_React$Component) {
	  (0, _inherits3['default'])(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    (0, _classCallCheck3['default'])(this, Dropdown);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	
	    _this._focusInDropdown = false;
	    _this.lastOpenEventType = null;
	    return _this;
	  }
	
	  Dropdown.prototype.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = (0, _contains2['default'])(_reactDom2['default'].findDOMNode(this.menu), (0, _activeElement2['default'])(document));
	    }
	  };
	
	  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var open = this.props.open;
	
	    var prevOpen = prevProps.open;
	
	    if (open && !prevOpen) {
	      this.focusNextOnOpen();
	    }
	
	    if (!open && prevOpen) {
	      // if focus hasn't already moved from the menu lets return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  Dropdown.prototype.handleClick = function handleClick(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen(event, { source: 'click' });
	  };
	
	  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        if (!this.props.open) {
	          this.toggleOpen(event, { source: 'keydown' });
	        } else if (this.menu.focusNext) {
	          this.menu.focusNext();
	        }
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.handleClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventDetails.source;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open, event, eventDetails);
	    }
	  };
	
	  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen(event, eventDetails);
	  };
	
	  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.menu;
	
	    if (!menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  Dropdown.prototype.focus = function focus() {
	    var toggle = _reactDom2['default'].findDOMNode(this.toggle);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
	    var _this2 = this;
	
	    var ref = function ref(c) {
	      _this2.toggle = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
	      onClick: (0, _createChainedFunction2['default'])(child.props.onClick, this.handleClick),
	      onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, this.handleKeyDown)
	    }));
	  };
	
	  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
	    var _this3 = this;
	
	    var id = _ref.id,
	        onClose = _ref.onClose,
	        onSelect = _ref.onSelect,
	        rootCloseEvent = _ref.rootCloseEvent,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['id', 'onClose', 'onSelect', 'rootCloseEvent']);
	
	    var ref = function ref(c) {
	      _this3.menu = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      labelledBy: id,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
	      onClose: (0, _createChainedFunction2['default'])(child.props.onClose, onClose, this.handleClose),
	      onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, function (key, event) {
	        return _this3.handleClose(event, { source: 'select' });
	      }),
	      rootCloseEvent: rootCloseEvent
	    }));
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _classes,
	        _this4 = this;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        id = _props.id,
	        dropup = _props.dropup,
	        disabled = _props.disabled,
	        pullRight = _props.pullRight,
	        open = _props.open,
	        onClose = _props.onClose,
	        onSelect = _props.onSelect,
	        role = _props.role,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onClose', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);
	
	
	    delete props.onToggle;
	
	    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);
	
	    if (dropup) {
	      classes[bsClass] = false;
	      classes.dropup = true;
	    }
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        switch (child.props.bsRole) {
	          case TOGGLE_ROLE:
	            return _this4.renderToggle(child, {
	              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
	            });
	          case MENU_ROLE:
	            return _this4.renderMenu(child, {
	              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onClose: onClose, onSelect: onSelect, rootCloseEvent: rootCloseEvent
	            });
	          default:
	            return child;
	        }
	      })
	    );
	  };
	
	  return Dropdown;
	}(_react2['default'].Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
	
	var UncontrolledDropdown = (0, _uncontrollable2['default'])(Dropdown, { open: 'onToggle' });
	
	UncontrolledDropdown.Toggle = _DropdownToggle2['default'];
	UncontrolledDropdown.Menu = _DropdownMenu2['default'];
	
	exports['default'] = UncontrolledDropdown;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/activeElement.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/ownerDocument.js"));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/ownerDocument.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/query/contains.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/util/inDOM.js"));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/DropdownToggle.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__("./node_modules/react-bootstrap/lib/Button.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__("./node_modules/react-bootstrap/lib/SafeAnchor.js");
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  noCaret: _propTypes2['default'].bool,
	  open: _propTypes2['default'].bool,
	  title: _propTypes2['default'].string,
	  useAnchor: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	var DropdownToggle = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    (0, _classCallCheck3['default'])(this, DropdownToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownToggle.prototype.render = function render() {
	    var _props = this.props,
	        noCaret = _props.noCaret,
	        open = _props.open,
	        useAnchor = _props.useAnchor,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);
	
	
	    delete props.bsRole;
	
	    var Component = useAnchor ? _SafeAnchor2['default'] : _Button2['default'];
	    var useCaret = !noCaret;
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    // FIXME: Should this really fall back to `title` as children?
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        role: 'button',
	        className: (0, _classnames2['default'])(className, bsClass),
	        'aria-haspopup': true,
	        'aria-expanded': open
	      }),
	      children || props.title,
	      useCaret && ' ',
	      useCaret && _react2['default'].createElement('span', { className: 'caret' })
	    );
	  };
	
	  return DropdownToggle;
	}(_react2['default'].Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/DropdownHoverButton.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownButton = __webpack_require__("./node_modules/react-bootstrap/lib/DropdownButton.js");
	
	var _DropdownButton2 = _interopRequireDefault(_DropdownButton);
	
	var _DropdownButton3 = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/DropdownButton.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DropdownHoverButton = (0, _DropdownButton3.DropdownHoverButtonHOC)(_class = function (_React$Component) {
	  (0, _inherits3.default)(DropdownHoverButton, _React$Component);
	
	  function DropdownHoverButton() {
	    (0, _classCallCheck3.default)(this, DropdownHoverButton);
	    return (0, _possibleConstructorReturn3.default)(this, (DropdownHoverButton.__proto__ || (0, _getPrototypeOf2.default)(DropdownHoverButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DropdownHoverButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_DropdownButton2.default, (0, _extends3.default)({ open: this.props.open,
	        onToggle: this.props.onToggle
	      }, this.props.buttonProps));
	    }
	  }]);
	  return DropdownHoverButton;
	}(_react2.default.Component)) || _class;
	
	exports.default = DropdownHoverButton;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Fade.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Fade = __webpack_require__("./node_modules/react-bootstrap/lib/Fade.js");
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Fade2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Fade.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__("./node_modules/react-overlays/lib/Transition.js");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  'in': _propTypes2['default'].bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _propTypes2['default'].bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2['default'].bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _propTypes2['default'].number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _propTypes2['default'].func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _propTypes2['default'].func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	var Fade = function (_React$Component) {
	  (0, _inherits3['default'])(Fade, _React$Component);
	
	  function Fade() {
	    (0, _classCallCheck3['default'])(this, Fade);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Fade.prototype.render = function render() {
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, this.props, {
	      className: (0, _classnames2['default'])(this.props.className, 'fade'),
	      enteredClassName: 'in',
	      enteringClassName: 'in'
	    }));
	  };
	
	  return Fade;
	}(_react2['default'].Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	
	exports['default'] = Fade;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Form.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Form = __webpack_require__("./node_modules/react-bootstrap/lib/Form.js");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormGroup = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/FormGroup.js");
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _FormControl = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/FormControl.js");
	
	var _FormControl2 = _interopRequireDefault(_FormControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Form = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(Form, _React$Component);
	
	  function Form() {
	    (0, _classCallCheck3.default)(this, Form);
	    return (0, _possibleConstructorReturn3.default)(this, (Form.__proto__ || (0, _getPrototypeOf2.default)(Form)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Form, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	      var allowAutoComplete = { props: props };
	
	      delete props.allowAutoComplete;
	
	      if (!allowAutoComplete) {
	        return _react2.default.createElement(
	          _Form2.default,
	          (0, _extends3.default)({}, props, { autoComplete: 'off' }),
	          _react2.default.createElement(
	            'div',
	            { style: { height: 0, visibility: 'hidden' } },
	            _react2.default.createElement(
	              _FormGroup2.default,
	              null,
	              _react2.default.createElement(_FormControl2.default, { type: 'text' })
	            ),
	            _react2.default.createElement(
	              _FormGroup2.default,
	              null,
	              _react2.default.createElement(_FormControl2.default, { type: 'email' })
	            ),
	            _react2.default.createElement(
	              _FormGroup2.default,
	              null,
	              _react2.default.createElement(_FormControl2.default, { type: 'password' })
	            )
	          ),
	          this.props.children
	        );
	      }
	
	      return _react2.default.createElement(_Form2.default, props);
	    }
	  }]);
	  return Form;
	}(_react2.default.Component), _class.propTypes = {
	  allowAutoComplete: _react2.default.PropTypes.bool
	}, _class.defaultProps = {
	  allowAutoComplete: false
	}, _temp);
	exports.default = Form;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Form.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  horizontal: _propTypes2['default'].bool,
	  inline: _propTypes2['default'].bool,
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form = function (_React$Component) {
	  (0, _inherits3['default'])(Form, _React$Component);
	
	  function Form() {
	    (0, _classCallCheck3['default'])(this, Form);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Form.prototype.render = function render() {
	    var _props = this.props,
	        horizontal = _props.horizontal,
	        inline = _props.inline,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['horizontal', 'inline', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	    if (horizontal) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
	    }
	    if (inline) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Form;
	}(_react2['default'].Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form', Form);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/FormGroup.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FormGroup = __webpack_require__("./node_modules/react-bootstrap/lib/FormGroup.js");
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FormGroup2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/FormGroup.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");
	
	var _ValidComponentChildren = __webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js");
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _propTypes2['default'].string,
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null])
	};
	
	var childContextTypes = {
	  $bs_formGroup: _propTypes2['default'].object.isRequired
	};
	
	var FormGroup = function (_React$Component) {
	  (0, _inherits3['default'])(FormGroup, _React$Component);
	
	  function FormGroup() {
	    (0, _classCallCheck3['default'])(this, FormGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormGroup.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        controlId = _props.controlId,
	        validationState = _props.validationState;
	
	
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
	    var _this2 = this;
	
	    return _ValidComponentChildren2['default'].some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
	    });
	  };
	
	  FormGroup.prototype.render = function render() {
	    var _props2 = this.props,
	        validationState = _props2.validationState,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['validationState', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'has-feedback': this.hasFeedback(children)
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return FormGroup;
	}(_react2['default'].Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/FormControl.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FormControl = __webpack_require__("./node_modules/react-bootstrap/lib/FormControl.js");
	
	var _FormControl2 = _interopRequireDefault(_FormControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FormControl2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/FormControl.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _FormControlFeedback = __webpack_require__("./node_modules/react-bootstrap/lib/FormControlFeedback.js");
	
	var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);
	
	var _FormControlStatic = __webpack_require__("./node_modules/react-bootstrap/lib/FormControlStatic.js");
	
	var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _propTypes2['default'].string,
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _propTypes2['default'].string,
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <FormControl inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: 'input'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var FormControl = function (_React$Component) {
	  (0, _inherits3['default'])(FormControl, _React$Component);
	
	  function FormControl() {
	    (0, _classCallCheck3['default'])(this, FormControl);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControl.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        type = _props.type,
	        _props$id = _props.id,
	        id = _props$id === undefined ? controlId : _props$id,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        bsSize = _props.bsSize,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
	
	    // input[type="file"] should not have .form-control.
	    var classes = void 0;
	    if (type !== 'file') {
	      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    }
	
	    // If user provides a size, make sure to append it to classes as input-
	    // e.g. if bsSize is small, it will append input-sm
	    if (bsSize) {
	      var size = _StyleConfig.SIZE_MAP[bsSize] || bsSize;
	      classes[(0, _bootstrapUtils.prefix)({ bsClass: 'input' }, size)] = true;
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      type: type,
	      id: id,
	      ref: inputRef,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControl;
	}(_react2['default'].Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	
	FormControl.Feedback = _FormControlFeedback2['default'];
	FormControl.Static = _FormControlStatic2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.SMALL, _StyleConfig.Size.LARGE], FormControl));
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/FormControlFeedback.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Glyphicon = __webpack_require__("./node_modules/react-bootstrap/lib/Glyphicon.js");
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var FormControlFeedback = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    (0, _classCallCheck3['default'])(this, FormControlFeedback);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	      case 'warning':
	        return 'warning-sign';
	      case 'error':
	        return 'remove';
	      default:
	        return null;
	    }
	  };
	
	  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	    if (!glyph) {
	      return null;
	    }
	
	    return _react2['default'].createElement(_Glyphicon2['default'], (0, _extends3['default'])({}, elementProps, {
	      glyph: glyph,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  FormControlFeedback.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
	    }
	
	    var child = _react2['default'].Children.only(children);
	    return _react2['default'].cloneElement(child, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	}(_react2['default'].Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/FormControlStatic.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    (0, _classCallCheck3['default'])(this, FormControlStatic);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlStatic.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControlStatic;
	}(_react2['default'].Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/FormControlFeedback.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FormControlFeedback = __webpack_require__("./node_modules/react-bootstrap/lib/FormControlFeedback.js");
	
	var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FormControlFeedback2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/FormControlStatic.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FormControlStatic = __webpack_require__("./node_modules/react-bootstrap/lib/FormControlStatic.js");
	
	var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FormControlStatic2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Glyphicon.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Glyphicon = __webpack_require__("./node_modules/react-bootstrap/lib/Glyphicon.js");
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Glyphicon2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/HelpBlock.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HelpBlock = __webpack_require__("./node_modules/react-bootstrap/lib/HelpBlock.js");
	
	var _HelpBlock2 = _interopRequireDefault(_HelpBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _HelpBlock2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/HelpBlock.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var HelpBlock = function (_React$Component) {
	  (0, _inherits3['default'])(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    (0, _classCallCheck3['default'])(this, HelpBlock);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  HelpBlock.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return HelpBlock;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Image.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Image = __webpack_require__("./node_modules/react-bootstrap/lib/Image.js");
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Image2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Image.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets image as responsive image
	   */
	  responsive: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as rounded
	   */
	  rounded: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as circle
	   */
	  circle: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as thumbnail
	   */
	  thumbnail: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  responsive: false,
	  rounded: false,
	  circle: false,
	  thumbnail: false
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3['default'])(Image, _React$Component);
	
	  function Image() {
	    (0, _classCallCheck3['default'])(this, Image);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Image.prototype.render = function render() {
	    var _classes;
	
	    var _props = this.props,
	        responsive = _props.responsive,
	        rounded = _props.rounded,
	        circle = _props.circle,
	        thumbnail = _props.thumbnail,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (_classes = {}, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'responsive')] = responsive, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'rounded')] = rounded, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'circle')] = circle, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'thumbnail')] = thumbnail, _classes);
	
	    return _react2['default'].createElement('img', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Image;
	}(_react2['default'].Component);
	
	Image.propTypes = propTypes;
	Image.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('img', Image);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/InputGroup.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InputGroup = __webpack_require__("./node_modules/react-bootstrap/lib/InputGroup.js");
	
	var _InputGroup2 = _interopRequireDefault(_InputGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InputGroup2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/InputGroup.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputGroupAddon = __webpack_require__("./node_modules/react-bootstrap/lib/InputGroupAddon.js");
	
	var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);
	
	var _InputGroupButton = __webpack_require__("./node_modules/react-bootstrap/lib/InputGroupButton.js");
	
	var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroup = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroup, _React$Component);
	
	  function InputGroup() {
	    (0, _classCallCheck3['default'])(this, InputGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroup.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroup;
	}(_react2['default'].Component);
	
	InputGroup.Addon = _InputGroupAddon2['default'];
	InputGroup.Button = _InputGroupButton2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/InputGroupAddon.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupAddon = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    (0, _classCallCheck3['default'])(this, InputGroupAddon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupAddon.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupAddon;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/InputGroupButton.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupButton = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    (0, _classCallCheck3['default'])(this, InputGroupButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupButton.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupButton;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Jumbotron.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Jumbotron = __webpack_require__("./node_modules/react-bootstrap/lib/Jumbotron.js");
	
	var _Jumbotron2 = _interopRequireDefault(_Jumbotron);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Jumbotron2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Jumbotron.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Jumbotron = function (_React$Component) {
	  (0, _inherits3['default'])(Jumbotron, _React$Component);
	
	  function Jumbotron() {
	    (0, _classCallCheck3['default'])(this, Jumbotron);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Jumbotron.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Jumbotron;
	}(_react2['default'].Component);
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('jumbotron', Jumbotron);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/L20n.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dispatcher = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Dispatcher.js");
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	var _isBrowser = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/isBrowser.js");
	
	var _isBrowser2 = _interopRequireDefault(_isBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var win = null;
	if (!(0, _isBrowser2.default)()) {
	  win = {
	    L20n: {
	      getContext: function getContext() {}
	    }
	  };
	} else {
	  win = window;
	
	  if (!win.hasOwnProperty('L20n')) {
	    win.L20n = {
	      getContext: function getContext() {}
	    };
	  }
	}
	
	var ctx = win.L20n.getContext();
	
	var Entities = {
	  ready: false,
	  entities: {},
	  registerEntity: function registerEntity(entity) {
	    if (Entities.hasOwnProperty(entity)) {
	      if (!Entities.ready) return;
	      _Dispatcher2.default.publish('ctx:' + entity);
	      return;
	    }
	    ctx.localize([entity], function (l) {
	      _Dispatcher2.default.publish('ctx:' + entity);
	    });
	    Entities[entity] = 1;
	  }
	};
	
	var _initializeLocales = function _initializeLocales(locales, rpath) {
	  rpath = rpath || '';
	  ctx.ready(function () {
	    Entities.ready = true;
	    for (var i in Entities.entities) {
	      Entities.registerEntity(Entities.entities[i]);
	    }
	    _Dispatcher2.default.publish('ctx:ready');
	  });
	  ctx.linkResource(function (locale) {
	    return rpath + '/locales/' + locale + '/strings.l20n';
	  });
	  ctx.registerLocales(locales.default, locales.locales);
	  ctx.requestLocales(locales.default);
	};
	
	var Entity = _react2.default.createClass({
	  displayName: 'Entity',
	
	  propTypes: {
	    data: _react2.default.PropTypes.object,
	    entity: _react2.default.PropTypes.string,
	    dangerouslySetInnerHTML: _react2.default.PropTypes.bool
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'span',
	      componentAttribute: ''
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      entity: this.props.defaultValue || ''
	    };
	  },
	  handler: function handler() {
	    this.setState({
	      entity: ctx.getSync(this.props.entity, this.props.data)
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    this.subscription = _Dispatcher2.default.subscribe('ctx:' + this.props.entity, this.handler);
	    Entities.registerEntity(this.props.entity);
	    if (Entities.ready) {
	      this.handler();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    _Dispatcher2.default.unsubscribe(this.subscription);
	  },
	  render: function render() {
	    var ComponentClass = this.props.componentClass;
	    var componentAttribute = this.props.componentAttribute;
	
	    var props = (0, _extends3.default)({}, this.props, {
	      data: null,
	      entity: null,
	      componentClass: null,
	      componentAttribute: null
	    });
	
	    delete props.entity;
	    delete props.componentClass;
	    delete props.componentAttribute;
	    delete props.dangerouslySetInnerHTML;
	
	    if (ComponentClass && componentAttribute.length) {
	      props[componentAttribute] = this.state.entity;
	
	      return _react2.default.createElement(ComponentClass, props);
	    }
	
	    if (ComponentClass === 'input') {
	      return _react2.default.createElement(ComponentClass, (0, _extends3.default)({}, props, { value: this.state.entity }));
	    }
	    if (this.props.dangerouslySetInnerHTML) {
	      return _react2.default.createElement(ComponentClass, (0, _extends3.default)({}, props, { dangerouslySetInnerHTML: { __html: this.state.entity } }));
	    }
	    return _react2.default.createElement(
	      ComponentClass,
	      props,
	      this.state.entity
	    );
	  }
	});
	
	module.exports = {
	  ctx: ctx,
	  initializeLocales: function initializeLocales(locales, rpath) {
	    _initializeLocales(locales, rpath);
	  },
	  ready: function ready() {
	    if (Entities.ready) {
	      _Dispatcher2.default.publish('ctx:ready');
	      return;
	    }
	  },
	  changeLocale: function changeLocale(locale) {
	    ctx.requestLocales(locale);
	  },
	  Entity: Entity
	};

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Label.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Label = __webpack_require__("./node_modules/react-bootstrap/lib/Label.js");
	
	var _Label2 = _interopRequireDefault(_Label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Label2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Label.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__("./node_modules/babel-runtime/core-js/object/values.js");
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Label = function (_React$Component) {
	  (0, _inherits3['default'])(Label, _React$Component);
	
	  function Label() {
	    (0, _classCallCheck3['default'])(this, Label);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Label.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Label.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Label;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Lead.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Lead = function (_React$Component) {
	  (0, _inherits3.default)(Lead, _React$Component);
	
	  function Lead() {
	    (0, _classCallCheck3.default)(this, Lead);
	    return (0, _possibleConstructorReturn3.default)(this, (Lead.__proto__ || (0, _getPrototypeOf2.default)(Lead)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Lead, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({
	        className: (0, _classnames2.default)('lead', this.props.className)
	      }, this.props);
	
	      return _react2.default.createElement('p', props);
	    }
	  }]);
	  return Lead;
	}(_react2.default.Component);
	
	exports.default = Lead;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/ListGroup.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ListGroup = __webpack_require__("./node_modules/react-bootstrap/lib/ListGroup.js");
	
	var _ListGroup2 = _interopRequireDefault(_ListGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ListGroup2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/ListGroup.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _ListGroupItem = __webpack_require__("./node_modules/react-bootstrap/lib/ListGroupItem.js");
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _ValidComponentChildren = __webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js");
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * You can use a custom element type for this component.
	   *
	   * If not specified, it will be treated as `'li'` if every child is a
	   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
	   */
	  componentClass: _elementType2['default']
	};
	
	function getDefaultComponent(children) {
	  if (!children) {
	    // FIXME: This is the old behavior. Is this right?
	    return 'div';
	  }
	
	  if (_ValidComponentChildren2['default'].some(children, function (child) {
	    return child.type !== _ListGroupItem2['default'] || child.props.href || child.props.onClick;
	  })) {
	    return 'div';
	  }
	
	  return 'ul';
	}
	
	var ListGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroup, _React$Component);
	
	  function ListGroup() {
	    (0, _classCallCheck3['default'])(this, ListGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroup.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        _props$componentClass = _props.componentClass,
	        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var useListItem = Component === 'ul' && _ValidComponentChildren2['default'].every(children, function (child) {
	      return child.type === _ListGroupItem2['default'];
	    });
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      useListItem ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { listItem: true });
	      }) : children
	    );
	  };
	
	  return ListGroup;
	}(_react2['default'].Component);
	
	ListGroup.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group', ListGroup);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/ListGroupItem.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__("./node_modules/babel-runtime/core-js/object/values.js");
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].any,
	  disabled: _propTypes2['default'].any,
	  header: _propTypes2['default'].node,
	  listItem: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  href: _propTypes2['default'].string,
	  type: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  listItem: false
	};
	
	var ListGroupItem = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    (0, _classCallCheck3['default'])(this, ListGroupItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
	    if (_react2['default'].isValidElement(header)) {
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, headingClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'h4',
	      { className: headingClassName },
	      header
	    );
	  };
	
	  ListGroupItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        className = _props.className,
	        header = _props.header,
	        listItem = _props.listItem,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active,
	      disabled: disabled
	    });
	
	    var Component = void 0;
	
	    if (elementProps.href) {
	      Component = 'a';
	    } else if (elementProps.onClick) {
	      Component = 'button';
	      elementProps.type = elementProps.type || 'button';
	    } else if (listItem) {
	      Component = 'li';
	    } else {
	      Component = 'span';
	    }
	
	    elementProps.className = (0, _classnames2['default'])(className, classes);
	
	    // TODO: Deprecate `header` prop.
	    if (header) {
	      return _react2['default'].createElement(
	        Component,
	        elementProps,
	        this.renderHeader(header, (0, _bootstrapUtils.prefix)(bsProps, 'heading')),
	        _react2['default'].createElement(
	          'p',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'text') },
	          children
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      Component,
	      elementProps,
	      children
	    );
	  };
	
	  return ListGroupItem;
	}(_react2['default'].Component);
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group-item', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ListGroupItem));
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/ListGroupItem.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ListGroupItem = __webpack_require__("./node_modules/react-bootstrap/lib/ListGroupItem.js");
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ListGroupItem2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/LoremIpsum.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @copyright https://github.com/f/loremjs
	 * @licence https://github.com/f/loremjs/blob/master/LICENSE
	 */
	
	var Lorem;
	(function () {
	
	    //Create a class named Lorem and constructor
	    Lorem = function Lorem() {
	        //Default values.
	        this.type = null;
	        this.query = null;
	        this.data = null;
	    };
	    //Static variables
	    Lorem.IMAGE = 1;
	    Lorem.TEXT = 2;
	    Lorem.TYPE = {
	        PARAGRAPH: 1,
	        SENTENCE: 2,
	        WORD: 3
	    };
	    //Words to create lorem ipsum text.
	    Lorem.WORDS = ["lorem", "ipsum", "dolor", "sit", "amet,", "consectetur", "adipiscing", "elit", "ut", "aliquam,", "purus", "sit", "amet", "luctus", "venenatis,", "lectus", "magna", "fringilla", "urna,", "porttitor", "rhoncus", "dolor", "purus", "non", "enim", "praesent", "elementum", "facilisis", "leo,", "vel", "fringilla", "est", "ullamcorper", "eget", "nulla", "facilisi", "etiam", "dignissim", "diam", "quis", "enim", "lobortis", "scelerisque", "fermentum", "dui", "faucibus", "in", "ornare", "quam", "viverra", "orci", "sagittis", "eu", "volutpat", "odio", "facilisis", "mauris", "sit", "amet", "massa", "vitae", "tortor", "condimentum", "lacinia", "quis", "vel", "eros", "donec", "ac", "odio", "tempor", "orci", "dapibus", "ultrices", "in", "iaculis", "nunc", "sed", "augue", "lacus,", "viverra", "vitae", "congue", "eu,", "consequat", "ac", "felis", "donec", "et", "odio", "pellentesque", "diam", "volutpat", "commodo", "sed", "egestas", "egestas", "fringilla", "phasellus", "faucibus", "scelerisque", "eleifend", "donec", "pretium", "vulputate", "sapien", "nec", "sagittis", "aliquam", "malesuada", "bibendum", "arcu", "vitae", "elementum", "curabitur", "vitae", "nunc", "sed", "velit", "dignissim", "sodales", "ut", "eu", "sem", "integer", "vitae", "justo", "eget", "magna", "fermentum", "iaculis", "eu", "non", "diam", "phasellus", "vestibulum", "lorem", "sed", "risus", "ultricies", "tristique", "nulla", "aliquet", "enim", "tortor,", "at", "auctor", "urna", "nunc", "id", "cursus", "metus", "aliquam", "eleifend", "mi", "in", "nulla", "posuere", "sollicitudin", "aliquam", "ultrices", "sagittis", "orci,", "a", "scelerisque", "purus", "semper", "eget", "duis", "at", "tellus", "at", "urna", "condimentum", "mattis", "pellentesque", "id", "nibh", "tortor,", "id", "aliquet", "lectus", "proin", "nibh", "nisl,", "condimentum", "id", "venenatis", "a,", "condimentum", "vitae", "sapien", "pellentesque", "habitant", "morbi", "tristique", "senectus", "et", "netus", "et", "malesuada", "fames", "ac", "turpis", "egestas", "sed", "tempus,", "urna", "et", "pharetra", "pharetra,", "massa", "massa", "ultricies", "mi,", "quis", "hendrerit", "dolor", "magna", "eget", "est", "lorem", "ipsum", "dolor", "sit", "amet,", "consectetur", "adipiscing", "elit", "pellentesque", "habitant", "morbi", "tristique", "senectus", "et", "netus", "et", "malesuada", "fames", "ac", "turpis", "egestas", "integer", "eget", "aliquet", "nibh", "praesent", "tristique", "magna", "sit", "amet", "purus", "gravida", "quis", "blandit", "turpis", "cursus", "in", "hac", "habitasse", "platea", "dictumst", "quisque", "sagittis,", "purus", "sit", "amet", "volutpat", "consequat,", "mauris", "nunc", "congue", "nisi,", "vitae", "suscipit", "tellus", "mauris", "a", "diam", "maecenas", "sed", "enim", "ut", "sem", "viverra", "aliquet", "eget", "sit", "amet", "tellus", "cras", "adipiscing", "enim", "eu", "turpis", "egestas", "pretium", "aenean", "pharetra,", "magna", "ac", "placerat", "vestibulum,", "lectus", "mauris", "ultrices", "eros,", "in", "cursus", "turpis", "massa", "tincidunt", "dui", "ut", "ornare", "lectus", "sit", "amet", "est", "placerat", "in", "egestas", "erat", "imperdiet", "sed", "euismod", "nisi", "porta", "lorem", "mollis", "aliquam", "ut", "porttitor", "leo", "a", "diam", "sollicitudin", "tempor", "id", "eu", "nisl", "nunc", "mi", "ipsum,", "faucibus", "vitae", "aliquet", "nec,", "ullamcorper", "sit", "amet", "risus", "nullam", "eget", "felis", "eget", "nunc", "lobortis", "mattis", "aliquam", "faucibus", "purus", "in", "massa", "tempor", "nec", "feugiat", "nisl", "pretium", "fusce", "id", "velit", "ut", "tortor", "pretium", "viverra", "suspendisse", "potenti", "nullam", "ac", "tortor", "vitae", "purus", "faucibus", "ornare", "suspendisse", "sed", "nisi", "lacus,", "sed", "viverra", "tellus", "in", "hac", "habitasse", "platea", "dictumst", "vestibulum", "rhoncus", "est", "pellentesque", "elit", "ullamcorper", "dignissim", "cras", "tincidunt", "lobortis", "feugiat", "vivamus", "at", "augue", "eget", "arcu", "dictum", "varius", "duis", "at", "consectetur", "lorem", "donec", "massa", "sapien,", "faucibus", "et", "molestie", "ac,", "feugiat", "sed", "lectus", "vestibulum", "mattis", "ullamcorper", "velit", "sed", "ullamcorper", "morbi", "tincidunt", "ornare", "massa,", "eget", "egestas", "purus", "viverra", "accumsan", "in", "nisl", "nisi,", "scelerisque", "eu", "ultrices", "vitae,", "auctor", "eu", "augue", "ut", "lectus", "arcu,", "bibendum", "at", "varius", "vel,", "pharetra", "vel", "turpis", "nunc", "eget", "lorem", "dolor,", "sed", "viverra", "ipsum", "nunc", "aliquet", "bibendum", "enim,", "facilisis", "gravida", "neque", "convallis", "a", "cras", "semper", "auctor", "neque,", "vitae", "tempus", "quam", "pellentesque", "nec", "nam", "aliquam", "sem", "et", "tortor", "consequat", "id", "porta", "nibh", "venenatis", "cras", "sed", "felis", "eget", "velit", "aliquet", "sagittis", "id", "consectetur", "purus", "ut", "faucibus", "pulvinar", "elementum", "integer", "enim", "neque,", "volutpat", "ac", "tincidunt", "vitae,", "semper", "quis", "lectus", "nulla", "at", "volutpat", "diam", "ut", "venenatis", "tellus", "in", "metus", "vulputate", "eu", "scelerisque", "felis", "imperdiet", "proin", "fermentum", "leo", "vel", "orci", "porta", "non", "pulvinar", "neque", "laoreet", "suspendisse", "interdum", "consectetur", "libero,", "id", "faucibus", "nisl", "tincidunt", "eget", "nullam", "non", "nisi", "est,", "sit", "amet", "facilisis", "magna", "etiam", "tempor,", "orci", "eu", "lobortis", "elementum,", "nibh", "tellus", "molestie", "nunc,", "non", "blandit", "massa", "enim", "nec", "dui", "nunc", "mattis", "enim", "ut", "tellus", "elementum", "sagittis", "vitae", "et", "leo", "duis", "ut", "diam", "quam", "nulla", "porttitor", "massa", "id", "neque", "aliquam", "vestibulum", "morbi", "blandit", "cursus", "risus,", "at", "ultrices", "mi", "tempus", "imperdiet", "nulla", "malesuada", "pellentesque", "elit", "eget", "gravida", "cum", "sociis", "natoque", "penatibus", "et", "magnis", "dis", "parturient", "montes,", "nascetur", "ridiculus", "mus", "mauris", "vitae", "ultricies", "leo", "integer", "malesuada", "nunc", "vel", "risus", "commodo", "viverra", "maecenas", "accumsan,", "lacus", "vel", "facilisis", "volutpat,", "est", "velit", "egestas", "dui,", "id", "ornare", "arcu", "odio", "ut", "sem", "nulla", "pharetra", "diam", "sit", "amet", "nisl", "suscipit", "adipiscing", "bibendum", "est", "ultricies", "integer", "quis", "auctor", "elit", "sed", "vulputate", "mi", "sit", "amet", "mauris", "commodo", "quis", "imperdiet", "massa", "tincidunt", "nunc", "pulvinar", "sapien", "et", "ligula", "ullamcorper", "malesuada", "proin", "libero", "nunc,", "consequat", "interdum", "varius", "sit", "amet,", "mattis", "vulputate", "enim", "nulla", "aliquet", "porttitor", "lacus,", "luctus", "accumsan", "tortor", "posuere", "ac", "ut", "consequat", "semper", "viverra", "nam", "libero", "justo,", "laoreet", "sit", "amet", "cursus", "sit", "amet,", "dictum", "sit", "amet", "justo", "donec", "enim", "diam,", "vulputate", "ut", "pharetra", "sit", "amet,", "aliquam", "id", "diam", "maecenas", "ultricies", "mi", "eget", "mauris", "pharetra", "et", "ultrices", "neque", "ornare", "aenean", "euismod", "elementum", "nisi,", "quis", "eleifend", "quam", "adipiscing", "vitae", "proin", "sagittis,", "nisl", "rhoncus", "mattis", "rhoncus,", "urna", "neque", "viverra", "justo,", "nec", "ultrices", "dui", "sapien", "eget", "mi", "proin", "sed", "libero", "enim,", "sed", "faucibus", "turpis", "in", "eu", "mi", "bibendum", "neque", "egestas", "congue", "quisque", "egestas", "diam", "in", "arcu", "cursus", "euismod", "quis", "viverra", "nibh", "cras", "pulvinar", "mattis", "nunc,", "sed", "blandit", "libero", "volutpat", "sed", "cras", "ornare", "arcu", "dui", "vivamus", "arcu", "felis,", "bibendum", "ut", "tristique", "et,", "egestas", "quis", "ipsum", "suspendisse", "ultrices", "gravida", "dictum", "fusce", "ut", "placerat", "orci", "nulla", "pellentesque", "dignissim", "enim,", "sit", "amet", "venenatis", "urna", "cursus", "eget", "nunc", "scelerisque", "viverra", "mauris,", "in", "aliquam", "sem", "fringilla", "ut", "morbi", "tincidunt", "augue", "interdum", "velit", "euismod", "in", "pellentesque", "massa", "placerat", "duis", "ultricies", "lacus", "sed", "turpis", "tincidunt", "id", "aliquet", "risus", "feugiat", "in", "ante", "metus,", "dictum", "at", "tempor", "commodo,", "ullamcorper", "a", "lacus", "vestibulum", "sed", "arcu", "non", "odio", "euismod", "lacinia", "at", "quis", "risus", "sed", "vulputate", "odio", "ut", "enim", "blandit", "volutpat", "maecenas", "volutpat", "blandit", "aliquam", "etiam", "erat", "velit,", "scelerisque", "in", "dictum", "non,", "consectetur", "a", "erat", "nam", "at", "lectus", "urna", "duis", "convallis", "convallis", "tellus,", "id", "interdum", "velit", "laoreet", "id", "donec", "ultrices", "tincidunt", "arcu,", "non", "sodales", "neque", "sodales", "ut", "etiam", "sit", "amet", "nisl", "purus,", "in", "mollis", "nunc", "sed", "id", "semper", "risus", "in", "hendrerit", "gravida", "rutrum", "quisque", "non", "tellus", "orci,", "ac", "auctor", "augue", "mauris", "augue", "neque,", "gravida", "in", "fermentum", "et,", "sollicitudin", "ac", "orci", "phasellus", "egestas", "tellus", "rutrum", "tellus", "pellentesque", "eu", "tincidunt", "tortor", "aliquam", "nulla", "facilisi", "cras", "fermentum,", "odio", "eu", "feugiat", "pretium,", "nibh", "ipsum", "consequat", "nisl,", "vel", "pretium", "lectus", "quam", "id", "leo", "in", "vitae", "turpis", "massa", "sed", "elementum", "tempus", "egestas", "sed", "sed", "risus", "pretium", "quam", "vulputate", "dignissim", "suspendisse", "in", "est", "ante", "in", "nibh", "mauris,", "cursus", "mattis", "molestie", "a,", "iaculis", "at", "erat", "pellentesque", "adipiscing", "commodo", "elit,", "at", "imperdiet", "dui", "accumsan", "sit", "amet", "nulla", "facilisi", "morbi", "tempus", "iaculis", "urna,", "id", "volutpat", "lacus", "laoreet", "non", "curabitur", "gravida", "arcu", "ac", "tortor", "dignissim", "convallis", "aenean", "et", "tortor", "at", "risus", "viverra", "adipiscing", "at", "in", "tellus", "integer", "feugiat", "scelerisque", "varius", "morbi", "enim", "nunc,", "faucibus", "a", "pellentesque", "sit", "amet,", "porttitor", "eget", "dolor", "morbi", "non", "arcu", "risus,", "quis", "varius", "quam", "quisque", "id", "diam", "vel", "quam", "elementum", "pulvinar", "etiam", "non", "quam", "lacus", "suspendisse", "faucibus", "interdum", "posuere", "lorem", "ipsum", "dolor", "sit", "amet,", "consectetur", "adipiscing", "elit", "duis", "tristique", "sollicitudin", "nibh", "sit", "amet", "commodo", "nulla", "facilisi", "nullam", "vehicula", "ipsum", "a", "arcu", "cursus", "vitae", "congue", "mauris", "rhoncus", "aenean", "vel", "elit", "scelerisque", "mauris", "pellentesque", "pulvinar", "pellentesque", "habitant", "morbi", "tristique", "senectus", "et", "netus", "et", "malesuada", "fames", "ac", "turpis", "egestas", "maecenas", "pharetra", "convallis", "posuere", "morbi", "leo", "urna,", "molestie", "at", "elementum", "eu,", "facilisis", "sed", "odio", "morbi", "quis", "commodo", "odio", "aenean", "sed", "adipiscing", "diam", "donec", "adipiscing", "tristique", "risus", "nec", "feugiat", "in", "fermentum", "posuere", "urna", "nec", "tincidunt", "praesent", "semper", "feugiat", "nibh", "sed", "pulvinar", "proin", "gravida", "hendrerit", "lectus", "a", "molestie"];
	    //random integer method.
	    Lorem.prototype.randomInt = function (min, max) {
	        return Math.floor(Math.random() * (max - min + 1)) + min;
	    };
	    //text creator method with parameters: how many, what
	    Lorem.prototype.createText = function (count, type) {
	        switch (type) {
	            //paragraphs are loads of sentences.
	            case Lorem.TYPE.PARAGRAPH:
	                var paragraphs = new Array();
	                for (var i = 0; i < count; i++) {
	                    var paragraphLength = this.randomInt(10, 20);
	                    var paragraph = this.createText(paragraphLength, Lorem.TYPE.SENTENCE);
	                    paragraphs.push('<p>' + paragraph + '</p>');
	                }
	                return paragraphs.join('\n');
	                break;
	            //sentences are loads of words.
	            case Lorem.TYPE.SENTENCE:
	                var sentences = new Array();
	                for (var i = 0; i < count; i++) {
	                    var sentenceLength = this.randomInt(5, 10);
	                    var words = this.createText(sentenceLength, Lorem.TYPE.WORD).split(' ');
	                    words[0] = words[0].substr(0, 1).toUpperCase() + words[0].substr(1);
	                    var sentence = words.join(' ');
	
	                    sentences.push(sentence);
	                }
	                return (sentences.join('. ') + '.').replace(/(\.\,|\,\.)/g, '.');
	                break;
	            //words are words
	            case Lorem.TYPE.WORD:
	                var wordIndex = this.randomInt(0, Lorem.WORDS.length - count - 1);
	
	                return Lorem.WORDS.slice(wordIndex, wordIndex + count).join(' ').replace(/\.|\,/g, '');
	                break;
	        }
	    };
	    Lorem.prototype.createLorem = function (element) {
	
	        var lorem = new Array();
	        var count;
	
	        if (/\d+-\d+[psw]/.test(this.query)) {
	            var range = this.query.replace(/[a-z]/, '').split("-");
	            count = Math.floor(Math.random() * parseInt(range[1])) + parseInt(range[0]);
	        } else {
	            count = parseInt(this.query);
	        }
	
	        if (/\d+p/.test(this.query)) {
	            var type = Lorem.TYPE.PARAGRAPH;
	        } else if (/\d+s/.test(this.query)) {
	            var type = Lorem.TYPE.SENTENCE;
	        } else if (/\d+w/.test(this.query)) {
	            var type = Lorem.TYPE.WORD;
	        }
	
	        lorem.push(this.createText(count, type));
	        lorem = lorem.join(' ');
	
	        if (element) {
	            if (this.type == Lorem.TEXT) element.innerHTML += lorem;else if (this.type == Lorem.IMAGE) {
	                //TODO: for now, using lorempixel.
	                var path = '';
	                var options = this.query.split(' ');
	                if (options[0] == 'gray') {
	                    path += '/g';
	                    options[0] = '';
	                }
	                if (element.getAttribute('width')) path += '/' + element.getAttribute('width');
	
	                if (element.getAttribute('height')) path += '/' + element.getAttribute('height');
	
	                path += '/' + options.join(' ').replace(/(^\s+|\s+$)/, '');
	                element.src = 'http://lorempixel.com' + path.replace(/\/\//, '/');
	            }
	        }
	
	        if (element == null) return lorem;
	    };
	})();
	
	exports.default = _react2.default.createClass({
	    displayName: 'LoremIpsum',
	    propTypes: {
	        type: _react2.default.PropTypes.string,
	        query: _react2.default.PropTypes.string.isRequired
	    },
	    getDefaultProps: function getDefaultProps() {
	        return {
	            type: 'text'
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        var lorem = new Lorem();
	
	        switch (this.props.type) {
	            case 'img':
	                lorem.type = Lorem.IMAGE;
	                break;
	            case 'text':
	            default:
	                lorem.type = Lorem.TEXT;
	                break;
	        }
	
	        lorem.query = this.props.query;
	        var l = lorem.createLorem(this._node);
	    },
	    render: function render() {
	        var _this = this;
	
	        var props = (0, _extends3.default)({
	            type: null,
	            query: null
	        }, this.props);
	
	        delete props.type;
	        delete props.query;
	
	        var ComponentClass;
	        if (this.props.type === 'text') return _react2.default.createElement('span', (0, _extends3.default)({}, props, { ref: function ref(c) {
	                return _this._node = c;
	            } }));else return _react2.default.createElement('img', (0, _extends3.default)({}, props, { ref: function ref(c) {
	                return _this._node = c;
	            } }));
	    }
	});

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Media.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Media = __webpack_require__("./node_modules/react-bootstrap/lib/Media.js");
	
	var _Media2 = _interopRequireDefault(_Media);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Media2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Media.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _MediaBody = __webpack_require__("./node_modules/react-bootstrap/lib/MediaBody.js");
	
	var _MediaBody2 = _interopRequireDefault(_MediaBody);
	
	var _MediaHeading = __webpack_require__("./node_modules/react-bootstrap/lib/MediaHeading.js");
	
	var _MediaHeading2 = _interopRequireDefault(_MediaHeading);
	
	var _MediaLeft = __webpack_require__("./node_modules/react-bootstrap/lib/MediaLeft.js");
	
	var _MediaLeft2 = _interopRequireDefault(_MediaLeft);
	
	var _MediaList = __webpack_require__("./node_modules/react-bootstrap/lib/MediaList.js");
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	var _MediaListItem = __webpack_require__("./node_modules/react-bootstrap/lib/MediaListItem.js");
	
	var _MediaListItem2 = _interopRequireDefault(_MediaListItem);
	
	var _MediaRight = __webpack_require__("./node_modules/react-bootstrap/lib/MediaRight.js");
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Media = function (_React$Component) {
	  (0, _inherits3['default'])(Media, _React$Component);
	
	  function Media() {
	    (0, _classCallCheck3['default'])(this, Media);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Media.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Media;
	}(_react2['default'].Component);
	
	Media.propTypes = propTypes;
	Media.defaultProps = defaultProps;
	
	Media.Heading = _MediaHeading2['default'];
	Media.Body = _MediaBody2['default'];
	Media.Left = _MediaLeft2['default'];
	Media.Right = _MediaRight2['default'];
	Media.List = _MediaList2['default'];
	Media.ListItem = _MediaListItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', Media);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/MediaBody.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var MediaBody = function (_React$Component) {
	  (0, _inherits3['default'])(MediaBody, _React$Component);
	
	  function MediaBody() {
	    (0, _classCallCheck3['default'])(this, MediaBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaBody;
	}(_react2['default'].Component);
	
	MediaBody.propTypes = propTypes;
	MediaBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-body', MediaBody);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/MediaHeading.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var MediaHeading = function (_React$Component) {
	  (0, _inherits3['default'])(MediaHeading, _React$Component);
	
	  function MediaHeading() {
	    (0, _classCallCheck3['default'])(this, MediaHeading);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaHeading.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaHeading;
	}(_react2['default'].Component);
	
	MediaHeading.propTypes = propTypes;
	MediaHeading.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-heading', MediaHeading);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/MediaLeft.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__("./node_modules/react-bootstrap/lib/Media.js");
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2['default'].oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaLeft = function (_React$Component) {
	  (0, _inherits3['default'])(MediaLeft, _React$Component);
	
	  function MediaLeft() {
	    (0, _classCallCheck3['default'])(this, MediaLeft);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaLeft.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaLeft;
	}(_react2['default'].Component);
	
	MediaLeft.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-left', MediaLeft);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/MediaList.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaList = function (_React$Component) {
	  (0, _inherits3['default'])(MediaList, _React$Component);
	
	  function MediaList() {
	    (0, _classCallCheck3['default'])(this, MediaList);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaList.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ul', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaList;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-list', MediaList);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/MediaListItem.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaListItem = function (_React$Component) {
	  (0, _inherits3['default'])(MediaListItem, _React$Component);
	
	  function MediaListItem() {
	    (0, _classCallCheck3['default'])(this, MediaListItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaListItem.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaListItem;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', MediaListItem);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/MediaRight.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__("./node_modules/react-bootstrap/lib/Media.js");
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2['default'].oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaRight = function (_React$Component) {
	  (0, _inherits3['default'])(MediaRight, _React$Component);
	
	  function MediaRight() {
	    (0, _classCallCheck3['default'])(this, MediaRight);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaRight.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-right-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaRight;
	}(_react2['default'].Component);
	
	MediaRight.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-right', MediaRight);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/MediaBody.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MediaBody = __webpack_require__("./node_modules/react-bootstrap/lib/MediaBody.js");
	
	var _MediaBody2 = _interopRequireDefault(_MediaBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MediaBody2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/MediaHeading.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MediaHeading = __webpack_require__("./node_modules/react-bootstrap/lib/MediaHeading.js");
	
	var _MediaHeading2 = _interopRequireDefault(_MediaHeading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MediaHeading2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/MediaLeft.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MediaLeft = __webpack_require__("./node_modules/react-bootstrap/lib/MediaLeft.js");
	
	var _MediaLeft2 = _interopRequireDefault(_MediaLeft);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MediaLeft2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/MediaList.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MediaList = __webpack_require__("./node_modules/react-bootstrap/lib/MediaList.js");
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MediaList2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/MediaListItem.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MediaListItem = __webpack_require__("./node_modules/react-bootstrap/lib/MediaListItem.js");
	
	var _MediaListItem2 = _interopRequireDefault(_MediaListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MediaListItem2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/MediaRight.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MediaRight = __webpack_require__("./node_modules/react-bootstrap/lib/MediaRight.js");
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MediaRight2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/MenuItem.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _MenuItem = __webpack_require__("./node_modules/react-bootstrap/lib/MenuItem.js");
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuItem = function (_React$Component) {
	  (0, _inherits3.default)(MenuItem, _React$Component);
	
	  function MenuItem() {
	    (0, _classCallCheck3.default)(this, MenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MenuItem, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.noHover) {
	        var props = (0, _extends3.default)({}, this.props);
	
	        delete props.noHover;
	        delete props.eventKey;
	
	        return _react2.default.createElement('li', (0, _extends3.default)({ role: 'presentation' }, props));
	      }
	
	      return _react2.default.createElement(_MenuItem2.default, this.props);
	    }
	  }]);
	  return MenuItem;
	}(_react2.default.Component);
	
	exports.default = MenuItem;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/MenuItem.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__("./node_modules/react-prop-types/lib/all.js");
	
	var _all2 = _interopRequireDefault(_all);
	
	var _SafeAnchor = __webpack_require__("./node_modules/react-bootstrap/lib/SafeAnchor.js");
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _propTypes2['default'].bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _propTypes2['default'].bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var divider = _ref.divider,
	        children = _ref.children;
	    return divider && children ? new Error('Children will not be rendered for dividers') : null;
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _propTypes2['default'].any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _propTypes2['default'].bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _propTypes2['default'].string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _propTypes2['default'].func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	var MenuItem = function (_React$Component) {
	  (0, _inherits3['default'])(MenuItem, _React$Component);
	
	  function MenuItem(props, context) {
	    (0, _classCallCheck3['default'])(this, MenuItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        href = _props.href,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (!href || disabled) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  MenuItem.prototype.render = function render() {
	    var _props2 = this.props,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        divider = _props2.divider,
	        header = _props2.header,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    if (divider) {
	      // Forcibly blank out the children; separators shouldn't render any.
	      elementProps.children = undefined;
	
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'separator',
	        className: (0, _classnames2['default'])(className, 'divider'),
	        style: style
	      }));
	    }
	
	    if (header) {
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'heading',
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
	        style: style
	      }));
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, elementProps, {
	        role: 'menuitem',
	        tabIndex: '-1',
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return MenuItem;
	}(_react2['default'].Component);
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Modal.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("./node_modules/react-bootstrap/lib/Modal.js");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ModalDialog = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/ModalDialog.js");
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modal = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(Modal, _React$Component);
	
	  function Modal() {
	    (0, _classCallCheck3.default)(this, Modal);
	    return (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Modal, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	
	      if (props.sm) {
	        props.bsSize = 'small';
	        delete props.sm;
	      }
	
	      if (props.lg) {
	        props.bsSize = 'large';
	        delete props.lg;
	      }
	
	      return _react2.default.createElement(_Modal2.default, props);
	    }
	  }]);
	  return Modal;
	}(_react2.default.Component), _class.propTypes = {
	  sm: _react2.default.PropTypes.bool,
	  lg: _react2.default.PropTypes.bool
	}, _temp);
	exports.default = Modal;
	
	
	var keys = (0, _keys2.default)(_Modal2.default);
	var skipKeys = ['displayName', 'propTypes', 'childContextTypes', 'getDefaultProps', 'defaultProps'];
	for (var i = 0; i < keys.length; i++) {
	  var key = keys[i];
	  if (_Modal2.default.hasOwnProperty(key) && skipKeys.indexOf(key) < 0) {
	    Modal[key] = _Modal2.default[key];
	  }
	}
	
	Modal.Dialog = _ModalDialog2.default;

/***/ },

/***/ "./node_modules/babel-runtime/core-js/object/keys.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/keys.js"), __esModule: true };

/***/ },

/***/ "./node_modules/core-js/library/fn/object/keys.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.object.keys.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.keys;


/***/ },

/***/ "./node_modules/core-js/library/modules/es6.object.keys.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
	var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
	
	__webpack_require__("./node_modules/core-js/library/modules/_object-sap.js")('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },

/***/ "./node_modules/react-bootstrap/lib/Modal.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _events = __webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/events/index.js");
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ownerDocument = __webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/ownerDocument.js");
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/util/inDOM.js");
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/util/scrollbarSize.js");
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Modal = __webpack_require__("./node_modules/react-overlays/lib/Modal.js");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _isOverflowing = __webpack_require__("./node_modules/react-overlays/lib/utils/isOverflowing.js");
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__("./node_modules/react-bootstrap/lib/Fade.js");
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalBody = __webpack_require__("./node_modules/react-bootstrap/lib/ModalBody.js");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalDialog = __webpack_require__("./node_modules/react-bootstrap/lib/ModalDialog.js");
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalFooter = __webpack_require__("./node_modules/react-bootstrap/lib/ModalFooter.js");
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _ModalHeader = __webpack_require__("./node_modules/react-bootstrap/lib/ModalHeader.js");
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__("./node_modules/react-bootstrap/lib/ModalTitle.js");
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _splitComponentProps2 = __webpack_require__("./node_modules/react-bootstrap/lib/utils/splitComponentProps.js");
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Modal2['default'].propTypes, _ModalDialog2['default'].propTypes, {
	
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _propTypes2['default'].oneOf(['static', true, false]),
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2['default'].bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _propTypes2['default'].bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType2['default'],
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _propTypes2['default'].bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _propTypes2['default'].func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * @private
	   */
	  container: _Modal2['default'].propTypes.container
	});
	
	var defaultProps = (0, _extends3['default'])({}, _Modal2['default'].defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog2['default']
	});
	
	var childContextTypes = {
	  $bs_modal: _propTypes2['default'].shape({
	    onHide: _propTypes2['default'].func
	  })
	};
	
	var Modal = function (_React$Component) {
	  (0, _inherits3['default'])(Modal, _React$Component);
	
	  function Modal(props, context) {
	    (0, _classCallCheck3['default'])(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
	
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  Modal.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  Modal.prototype.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].on(window, 'resize', this.handleWindowResize);
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].off(window, 'resize', this.handleWindowResize);
	  };
	
	  Modal.prototype.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  Modal.prototype.updateStyle = function updateStyle() {
	    if (!_inDOM2['default']) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	    var dialogHeight = dialogNode.scrollHeight;
	
	    var document = (0, _ownerDocument2['default'])(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing2['default'])(_reactDom2['default'].findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined
	      }
	    });
	  };
	
	  Modal.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        backdrop = _props.backdrop,
	        animation = _props.animation,
	        show = _props.show,
	        Dialog = _props.dialogComponentClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        onEntering = _props.onEntering,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['backdrop', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Modal2['default']),
	        baseModalProps = _splitComponentProps[0],
	        dialogProps = _splitComponentProps[1];
	
	    var inClassName = show && !animation && 'in';
	
	    return _react2['default'].createElement(
	      _Modal2['default'],
	      (0, _extends3['default'])({}, baseModalProps, {
	        ref: function ref(c) {
	          _this2._modal = c;
	        },
	        show: show,
	        onEntering: (0, _createChainedFunction2['default'])(onEntering, this.handleEntering),
	        onExited: (0, _createChainedFunction2['default'])(onExited, this.handleExited),
	        backdrop: backdrop,
	        backdropClassName: (0, _classnames2['default'])((0, _bootstrapUtils.prefix)(props, 'backdrop'), inClassName),
	        containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	        transition: animation ? _Fade2['default'] : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      _react2['default'].createElement(
	        Dialog,
	        (0, _extends3['default'])({}, dialogProps, {
	          style: (0, _extends3['default'])({}, this.state.style, style),
	          className: (0, _classnames2['default'])(className, inClassName),
	          onClick: backdrop === true ? this.handleDialogClick : null
	        }),
	        children
	      )
	    );
	  };
	
	  return Modal;
	}(_react2['default'].Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	
	Modal.Body = _ModalBody2['default'];
	Modal.Header = _ModalHeader2['default'];
	Modal.Title = _ModalTitle2['default'];
	Modal.Footer = _ModalFooter2['default'];
	
	Modal.Dialog = _ModalDialog2['default'];
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/events/index.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _on = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/events/on.js"));
	
	exports.on = _on.default;
	
	var _off = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/events/off.js"));
	
	exports.off = _off.default;
	
	var _filter = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/events/filter.js"));
	
	exports.filter = _filter.default;
	
	var _listen = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/events/listen.js"));
	
	exports.listen = _listen.default;
	var _default = {
	  on: _on.default,
	  off: _off.default,
	  filter: _filter.default,
	  listen: _listen.default
	};
	exports.default = _default;

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/events/on.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/util/inDOM.js"));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/events/off.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/util/inDOM.js"));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/events/filter.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = filterEvents;
	
	var _contains = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/query/contains.js"));
	
	var _querySelectorAll = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/query/querySelectorAll.js"));
	
	function filterEvents(selector, handler) {
	  return function filterHandler(e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = (0, _querySelectorAll.default)(top, selector);
	    if (matches.some(function (match) {
	      return (0, _contains.default)(match, target);
	    })) handler.call(this, e);
	  };
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/query/querySelectorAll.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = qsa;
	// Zepto.js
	// (c) 2010-2015 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/;
	var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/events/listen.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/util/inDOM.js"));
	
	var _on = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/events/on.js"));
	
	var _off = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/events/off.js"));
	
	var listen = function listen() {};
	
	if (_inDOM.default) {
	  listen = function listen(node, eventName, handler, capture) {
	    (0, _on.default)(node, eventName, handler, capture);
	    return function () {
	      (0, _off.default)(node, eventName, handler, capture);
	    };
	  };
	}
	
	var _default = listen;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/node_modules/dom-helpers/util/scrollbarSize.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/util/inDOM.js"));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/lib/Modal.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*eslint-disable react/prop-types */
	
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _componentOrElement = __webpack_require__("./node_modules/react-prop-types/lib/componentOrElement.js");
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Portal = __webpack_require__("./node_modules/react-overlays/lib/Portal.js");
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ModalManager = __webpack_require__("./node_modules/react-overlays/lib/ModalManager.js");
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _ownerDocument = __webpack_require__("./node_modules/react-overlays/lib/utils/ownerDocument.js");
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _addEventListener = __webpack_require__("./node_modules/react-overlays/lib/utils/addEventListener.js");
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__("./node_modules/react-overlays/lib/utils/addFocusListener.js");
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _inDOM = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/util/inDOM.js");
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _activeElement = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/activeElement.js");
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/query/contains.js");
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _getContainer = __webpack_require__("./node_modules/react-overlays/lib/utils/getContainer.js");
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	var Modal = _react2.default.createClass({
	  displayName: 'Modal',
	
	
	  propTypes: _extends({}, _Portal2.default.propTypes, {
	
	    /**
	     * Set the visibility of the Modal
	     */
	    show: _react2.default.PropTypes.bool,
	
	    /**
	     * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	     *
	     * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	     * page content can be placed behind a virtual backdrop as well as a visual one.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	    /**
	     * A callback fired when the Modal is opening.
	     */
	    onShow: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	     *
	     * The `onHide` callback only signals intent from the Modal,
	     * you must actually set the `show` prop to `false` for the Modal to close.
	     */
	    onHide: _react2.default.PropTypes.func,
	
	    /**
	     * Include a backdrop component.
	     */
	    backdrop: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.oneOf(['static'])]),
	
	    /**
	     * A function that returns a backdrop component. Useful for custom
	     * backdrop rendering.
	     *
	     * ```js
	     *  renderBackdrop={props => <MyBackdrop {...props} />}
	     * ```
	     */
	    renderBackdrop: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	     */
	    onEscapeKeyUp: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the backdrop, if specified, is clicked.
	     */
	    onBackdropClick: _react2.default.PropTypes.func,
	
	    /**
	     * A style object for the backdrop component.
	     */
	    backdropStyle: _react2.default.PropTypes.object,
	
	    /**
	     * A css class or classes for the backdrop component.
	     */
	    backdropClassName: _react2.default.PropTypes.string,
	
	    /**
	     * A css class or set of classes applied to the modal container when the modal is open,
	     * and removed when it is closed.
	     */
	    containerClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Close the modal when escape key is pressed
	     */
	    keyboard: _react2.default.PropTypes.bool,
	
	    /**
	     * A `<Transition/>` component to use for the dialog and backdrop components.
	     */
	    transition: _elementType2.default,
	
	    /**
	     * The `timeout` of the dialog transition if specified. This number is used to ensure that
	     * transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    dialogTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * The `timeout` of the backdrop transition if specified. This number is used to
	     * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    backdropTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * When `true` The modal will automatically shift focus to itself when it opens, and
	     * replace it to the last focused element when it closes. This also
	     * works correctly with any Modal children that have the `autoFocus` prop.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    autoFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will prevent focus from leaving the Modal while open.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    enforceFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will restore focus to previously focused element once
	     * modal is hidden
	     */
	    restoreFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * Callback fired before the Modal transitions in
	     */
	    onEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition in
	     */
	    onEntering: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning in
	     */
	    onEntered: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired right before the Modal transitions out
	     */
	    onExit: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition out
	     */
	    onExiting: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning out
	     */
	    onExited: _react2.default.PropTypes.func,
	
	    /**
	     * A ModalManager instance used to track and manage the state of open
	     * Modals. Useful when customizing how modals interact within a container
	     */
	    manager: _react2.default.PropTypes.object.isRequired
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    var noop = function noop() {};
	
	    return {
	      show: false,
	      backdrop: true,
	      keyboard: true,
	      autoFocus: true,
	      enforceFocus: true,
	      restoreFocus: true,
	      onHide: noop,
	      manager: modalManager,
	      renderBackdrop: function renderBackdrop(props) {
	        return _react2.default.createElement('div', props);
	      }
	    };
	  },
	  omitProps: function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  },
	  getInitialState: function getInitialState() {
	    return { exited: !this.props.show };
	  },
	  render: function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: 'modal',
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        dialog
	      )
	    );
	  },
	  renderBackdrop: function renderBackdrop() {
	    var _this = this;
	
	    var _props2 = this.props,
	        backdropStyle = _props2.backdropStyle,
	        backdropClassName = _props2.backdropClassName,
	        renderBackdrop = _props2.renderBackdrop,
	        Transition = _props2.transition,
	        backdropTransitionTimeout = _props2.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this.backdrop = ref;
	    };
	
	    var backdrop = _react2.default.createElement('div', {
	      ref: backdropRef,
	      style: this.props.backdropStyle,
	      className: this.props.backdropClassName,
	      onClick: this.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': this.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        renderBackdrop({
	          ref: backdropRef,
	          style: backdropStyle,
	          className: backdropClassName,
	          onClick: this.handleBackdropClick
	        })
	      );
	    }
	
	    return backdrop;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.show) {
	      this.onShow();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var _props3 = this.props,
	        show = _props3.show,
	        transition = _props3.transition;
	
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  },
	  onShow: function onShow() {
	    var doc = (0, _ownerDocument2.default)(this);
	    var container = (0, _getContainer2.default)(this.props.container, doc.body);
	
	    this.props.manager.add(this, container, this.props.containerClassName);
	
	    this._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleDocumentKeyUp);
	
	    this._onFocusinListener = (0, _addFocusListener2.default)(this.enforceFocus);
	
	    this.focus();
	
	    if (this.props.onShow) {
	      this.props.onShow();
	    }
	  },
	  onHide: function onHide() {
	    this.props.manager.remove(this);
	
	    this._onDocumentKeyupListener.remove();
	
	    this._onFocusinListener.remove();
	
	    if (this.props.restoreFocus) {
	      this.restoreLastFocus();
	    }
	  },
	  setMountNode: function setMountNode(ref) {
	    this.mountNode = ref ? ref.getMountNode() : ref;
	  },
	  handleHidden: function handleHidden() {
	    this.setState({ exited: true });
	    this.onHide();
	
	    if (this.props.onExited) {
	      var _props4;
	
	      (_props4 = this.props).onExited.apply(_props4, arguments);
	    }
	  },
	  handleBackdropClick: function handleBackdropClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (this.props.onBackdropClick) {
	      this.props.onBackdropClick(e);
	    }
	
	    if (this.props.backdrop === true) {
	      this.props.onHide();
	    }
	  },
	  handleDocumentKeyUp: function handleDocumentKeyUp(e) {
	    if (this.props.keyboard && e.keyCode === 27 && this.isTopModal()) {
	      if (this.props.onEscapeKeyUp) {
	        this.props.onEscapeKeyUp(e);
	      }
	      this.props.onHide();
	    }
	  },
	  checkForFocus: function checkForFocus() {
	    if (_inDOM2.default) {
	      this.lastFocus = (0, _activeElement2.default)();
	    }
	  },
	  focus: function focus() {
	    var autoFocus = this.props.autoFocus;
	    var modalContent = this.getDialogElement();
	    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var focusInModal = current && (0, _contains2.default)(modalContent, current);
	
	    if (modalContent && autoFocus && !focusInModal) {
	      this.lastFocus = current;
	
	      if (!modalContent.hasAttribute('tabIndex')) {
	        modalContent.setAttribute('tabIndex', -1);
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
	      }
	
	      modalContent.focus();
	    }
	  },
	  restoreLastFocus: function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  },
	  enforceFocus: function enforceFocus() {
	    var enforceFocus = this.props.enforceFocus;
	
	
	    if (!enforceFocus || !this.isMounted() || !this.isTopModal()) {
	      return;
	    }
	
	    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var modal = this.getDialogElement();
	
	    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
	      modal.focus();
	    }
	  },
	
	
	  //instead of a ref, which might conflict with one the parent applied.
	  getDialogElement: function getDialogElement() {
	    var node = this.refs.modal;
	    return node && node.lastChild;
	  },
	  isTopModal: function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  }
	});
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-prop-types/lib/componentOrElement.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__("./node_modules/react-prop-types/lib/utils/createChainableTypeChecker.js");
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ },

/***/ "./node_modules/react-overlays/lib/Portal.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__("./node_modules/react-prop-types/lib/componentOrElement.js");
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _ownerDocument = __webpack_require__("./node_modules/react-overlays/lib/utils/ownerDocument.js");
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _getContainer = __webpack_require__("./node_modules/react-overlays/lib/utils/getContainer.js");
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = _react2.default.createClass({
	
	  displayName: 'Portal',
	
	  propTypes: {
	    /**
	     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	     * appended to it.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func])
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._renderOverlay();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._renderOverlay();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  },
	  _mountOverlayTarget: function _mountOverlayTarget() {
	    if (!this._overlayTarget) {
	      this._overlayTarget = document.createElement('div');
	      this._portalContainerNode = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  _unmountOverlayTarget: function _unmountOverlayTarget() {
	    if (this._overlayTarget) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._overlayTarget = null;
	    }
	    this._portalContainerNode = null;
	  },
	  _renderOverlay: function _renderOverlay() {
	
	    var overlay = !this.props.children ? null : _react2.default.Children.only(this.props.children);
	
	    // Save reference for future access.
	    if (overlay !== null) {
	      this._mountOverlayTarget();
	      this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	    } else {
	      // Unrender if the component is null for transitions to null
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  },
	  _unrenderOverlay: function _unrenderOverlay() {
	    if (this._overlayTarget) {
	      _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
	      this._overlayInstance = null;
	    }
	  },
	  render: function render() {
	    return null;
	  },
	  getMountNode: function getMountNode() {
	    return this._overlayTarget;
	  },
	  getOverlayDOMNode: function getOverlayDOMNode() {
	    if (!this.isMounted()) {
	      throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	    }
	
	    if (this._overlayInstance) {
	      return _reactDom2.default.findDOMNode(this._overlayInstance);
	    }
	
	    return null;
	  }
	});
	
	exports.default = Portal;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-overlays/lib/utils/getContainer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-overlays/lib/ModalManager.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/style/index.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	var _class = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/class/index.js");
	
	var _class2 = _interopRequireDefault(_class);
	
	var _scrollbarSize = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/util/scrollbarSize.js");
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__("./node_modules/react-overlays/lib/utils/isOverflowing.js");
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__("./node_modules/react-overlays/lib/utils/manageAriaHidden.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function () {
	  function ModalManager() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	        hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	        _ref2$handleContainer = _ref2.handleContainerOverflow,
	        handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	    _classCallCheck(this, ModalManager);
	
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.handleContainerOverflow = handleContainerOverflow;
	    this.modals = [];
	    this.containers = [];
	    this.data = [];
	  }
	
	  _createClass(ModalManager, [{
	    key: 'add',
	    value: function add(modal, container, className) {
	      var modalIdx = this.modals.indexOf(modal);
	      var containerIdx = this.containers.indexOf(container);
	
	      if (modalIdx !== -1) {
	        return modalIdx;
	      }
	
	      modalIdx = this.modals.length;
	      this.modals.push(modal);
	
	      if (this.hideSiblingNodes) {
	        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	      }
	
	      if (containerIdx !== -1) {
	        this.data[containerIdx].modals.push(modal);
	        return modalIdx;
	      }
	
	      var data = {
	        modals: [modal],
	        //right now only the first modal of a container will have its classes applied
	        classes: className ? className.split(/\s+/) : [],
	
	        overflowing: (0, _isOverflowing2.default)(container)
	      };
	
	      if (this.handleContainerOverflow) {
	        setContainerStyle(data, container);
	      }
	
	      data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	      this.containers.push(container);
	      this.data.push(data);
	
	      return modalIdx;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(modal) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx === -1) {
	        return;
	      }
	
	      var containerIdx = findContainer(this.data, modal);
	      var data = this.data[containerIdx];
	      var container = this.containers[containerIdx];
	
	      data.modals.splice(data.modals.indexOf(modal), 1);
	
	      this.modals.splice(modalIdx, 1);
	
	      // if that was the last modal in a container,
	      // clean up the container
	      if (data.modals.length === 0) {
	        data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	        if (this.handleContainerOverflow) {
	          removeContainerStyle(data, container);
	        }
	
	        if (this.hideSiblingNodes) {
	          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	        }
	        this.containers.splice(containerIdx, 1);
	        this.data.splice(containerIdx, 1);
	      } else if (this.hideSiblingNodes) {
	        //otherwise make sure the next top modal is visible to a SR
	        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	      }
	    }
	  }, {
	    key: 'isTopModal',
	    value: function isTopModal(modal) {
	      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	
	  return ModalManager;
	}();
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/style/index.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/util/camelizeStyle.js"));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/util/hyphenateStyle.js"));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/style/getComputedStyle.js"));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/style/removeStyle.js"));
	
	var _properties = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/transition/properties.js");
	
	var _isTransform = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/transition/isTransform.js"));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/util/camelizeStyle.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/util/camelize.js"));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/util/camelize.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/util/hyphenateStyle.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/util/hyphenate.js"));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/util/hyphenate.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/style/getComputedStyle.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/util/camelizeStyle.js"));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/style/removeStyle.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/transition/isTransform.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/class/index.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/class/addClass.js"));
	
	exports.addClass = _addClass.default;
	
	var _removeClass = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/class/removeClass.js"));
	
	exports.removeClass = _removeClass.default;
	
	var _hasClass = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/class/hasClass.js"));
	
	exports.hasClass = _hasClass.default;
	var _default = {
	  addClass: _addClass.default,
	  removeClass: _removeClass.default,
	  hasClass: _hasClass.default
	};
	exports.default = _default;

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/class/addClass.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/class/hasClass.js"));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/class/hasClass.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/class/removeClass.js":
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/util/scrollbarSize.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/util/inDOM.js"));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/lib/utils/isOverflowing.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/query/isWindow.js");
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/ownerDocument.js");
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/query/isWindow.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/lib/utils/manageAriaHidden.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ },

/***/ "./node_modules/react-overlays/lib/utils/addFocusListener.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/activeElement.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/ownerDocument.js"));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/ModalBody.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalBody = function (_React$Component) {
	  (0, _inherits3['default'])(ModalBody, _React$Component);
	
	  function ModalBody() {
	    (0, _classCallCheck3['default'])(this, ModalBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalBody;
	}(_react2['default'].Component);
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/ModalDialog.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _propTypes2['default'].string
	};
	
	var ModalDialog = function (_React$Component) {
	  (0, _inherits3['default'])(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    (0, _classCallCheck3['default'])(this, ModalDialog);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalDialog.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        dialogClassName = _props.dialogClassName,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['dialogClassName', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	
	    var modalStyle = (0, _extends4['default'])({ display: 'block' }, style);
	
	    var dialogClasses = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: (0, _classnames2['default'])(className, bsClassName)
	      }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(dialogClassName, dialogClasses) },
	        _react2['default'].createElement(
	          'div',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'content'), role: 'document' },
	          children
	        )
	      )
	    );
	  };
	
	  return ModalDialog;
	}(_react2['default'].Component);
	
	ModalDialog.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/ModalFooter.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalFooter = function (_React$Component) {
	  (0, _inherits3['default'])(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    (0, _classCallCheck3['default'])(this, ModalFooter);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalFooter.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalFooter;
	}(_react2['default'].Component);
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/ModalHeader.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `aria-label` should be `closeLabel`.
	
	var propTypes = {
	  /**
	   * The 'aria-label' attribute provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  'aria-label': _propTypes2['default'].string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _propTypes2['default'].bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  'aria-label': 'Close',
	  closeButton: false
	};
	
	var contextTypes = {
	  $bs_modal: _propTypes2['default'].shape({
	    onHide: _propTypes2['default'].func
	  })
	};
	
	var ModalHeader = function (_React$Component) {
	  (0, _inherits3['default'])(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    (0, _classCallCheck3['default'])(this, ModalHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props,
	        label = _props['aria-label'],
	        closeButton = _props.closeButton,
	        onHide = _props.onHide,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['aria-label', 'closeButton', 'onHide', 'className', 'children']);
	
	
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      closeButton && _react2['default'].createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'close',
	          'aria-label': label,
	          onClick: (0, _createChainedFunction2['default'])(modal && modal.onHide, onHide)
	        },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          '\xD7'
	        )
	      ),
	      children
	    );
	  };
	
	  return ModalHeader;
	}(_react2['default'].Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/ModalTitle.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var ModalTitle = function (_React$Component) {
	  (0, _inherits3['default'])(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    (0, _classCallCheck3['default'])(this, ModalTitle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalTitle.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalTitle;
	}(_react2['default'].Component);
	
	ModalTitle.propTypes = propTypes;
	ModalTitle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/ModalDialog.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ModalDialog = __webpack_require__("./node_modules/react-bootstrap/lib/ModalDialog.js");
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalDialog = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    (0, _classCallCheck3.default)(this, ModalDialog);
	    return (0, _possibleConstructorReturn3.default)(this, (ModalDialog.__proto__ || (0, _getPrototypeOf2.default)(ModalDialog)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ModalDialog, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	
	      if (props.sm) {
	        props.bsSize = 'small';
	        delete props.sm;
	      }
	
	      if (props.lg) {
	        props.bsSize = 'large';
	        delete props.lg;
	      }
	
	      return _react2.default.createElement(_ModalDialog2.default, props);
	    }
	  }]);
	  return ModalDialog;
	}(_react2.default.Component), _class.propTypes = {
	  sm: _react2.default.PropTypes.bool,
	  lg: _react2.default.PropTypes.bool
	}, _temp);
	exports.default = ModalDialog;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/ModalBody.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalBody = __webpack_require__("./node_modules/react-bootstrap/lib/ModalBody.js");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ModalBody2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/ModalFooter.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalFooter = __webpack_require__("./node_modules/react-bootstrap/lib/ModalFooter.js");
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ModalFooter2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/ModalHeader.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalHeader = __webpack_require__("./node_modules/react-bootstrap/lib/ModalHeader.js");
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ModalHeader2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/ModalTitle.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalTitle = __webpack_require__("./node_modules/react-bootstrap/lib/ModalTitle.js");
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ModalTitle2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Navbar.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Navbar = __webpack_require__("./node_modules/react-bootstrap/lib/Navbar.js");
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Navbar2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Navbar.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _uncontrollable = __webpack_require__("./node_modules/uncontrollable/index.js");
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Grid = __webpack_require__("./node_modules/react-bootstrap/lib/Grid.js");
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _NavbarBrand = __webpack_require__("./node_modules/react-bootstrap/lib/NavbarBrand.js");
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _NavbarCollapse = __webpack_require__("./node_modules/react-bootstrap/lib/NavbarCollapse.js");
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	var _NavbarHeader = __webpack_require__("./node_modules/react-bootstrap/lib/NavbarHeader.js");
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	var _NavbarToggle = __webpack_require__("./node_modules/react-bootstrap/lib/NavbarToggle.js");
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Create a fixed navbar along the top of the screen, that scrolls with the
	   * page
	   */
	  fixedTop: _propTypes2['default'].bool,
	  /**
	   * Create a fixed navbar along the bottom of the screen, that scrolls with
	   * the page
	   */
	  fixedBottom: _propTypes2['default'].bool,
	  /**
	   * Create a full-width navbar that scrolls away with the page
	   */
	  staticTop: _propTypes2['default'].bool,
	  /**
	   * An alternative dark visual style for the Navbar
	   */
	  inverse: _propTypes2['default'].bool,
	  /**
	   * Allow the Navbar to fluidly adjust to the page or container width, instead
	   * of at the predefined screen breakpoints
	   */
	  fluid: _propTypes2['default'].bool,
	
	  /**
	   * Set a custom element for this component.
	   */
	  componentClass: _elementType2['default'],
	  /**
	   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
	   * a `<Navbar.Toggle>` is clicked and called with the new `navExpanded`
	   * boolean value.
	   *
	   * @controllable navExpanded
	   */
	  onToggle: _propTypes2['default'].func,
	  /**
	   * A callback fired when a descendant of a child `<Nav>` is selected. Should
	   * be used to execute complex closing or other miscellaneous actions desired
	   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
	   * descendants exist. The callback is called with an eventKey, which is a
	   * prop from the selected `<Nav>` descendant, and an event.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * For basic closing behavior after all `<Nav>` descendant onSelect events in
	   * mobile viewports, try using collapseOnSelect.
	   *
	   * Note: If you are manually closing the navbar using this `OnSelect` prop,
	   * ensure that you are setting `expanded` to false and not *toggling* between
	   * true and false.
	   */
	  onSelect: _propTypes2['default'].func,
	  /**
	   * Sets `expanded` to `false` after the onSelect event of a descendant of a
	   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
	   *
	   * The onSelect callback should be used instead for more complex operations
	   * that need to be executed after the `select` event of `<Nav>` descendants.
	   */
	  collapseOnSelect: _propTypes2['default'].bool,
	  /**
	   * Explicitly set the visiblity of the navbar body
	   *
	   * @controllable onToggle
	   */
	  expanded: _propTypes2['default'].bool,
	
	  role: _propTypes2['default'].string
	}; // TODO: Remove this pragma once we upgrade eslint-config-airbnb.
	/* eslint-disable react/no-multi-comp */
	
	var defaultProps = {
	  componentClass: 'nav',
	  fixedTop: false,
	  fixedBottom: false,
	  staticTop: false,
	  inverse: false,
	  fluid: false,
	  collapseOnSelect: false
	};
	
	var childContextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool,
	    onToggle: _propTypes2['default'].func.isRequired,
	    onSelect: _propTypes2['default'].func
	  })
	};
	
	var Navbar = function (_React$Component) {
	  (0, _inherits3['default'])(Navbar, _React$Component);
	
	  function Navbar(props, context) {
	    (0, _classCallCheck3['default'])(this, Navbar);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleCollapse = _this.handleCollapse.bind(_this);
	    return _this;
	  }
	
	  Navbar.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        expanded = _props.expanded,
	        onSelect = _props.onSelect,
	        collapseOnSelect = _props.collapseOnSelect;
	
	
	    return {
	      $bs_navbar: {
	        bsClass: bsClass,
	        expanded: expanded,
	        onToggle: this.handleToggle,
	        onSelect: (0, _createChainedFunction2['default'])(onSelect, collapseOnSelect ? this.handleCollapse : null)
	      }
	    };
	  };
	
	  Navbar.prototype.handleCollapse = function handleCollapse() {
	    var _props2 = this.props,
	        onToggle = _props2.onToggle,
	        expanded = _props2.expanded;
	
	
	    if (expanded) {
	      onToggle(false);
	    }
	  };
	
	  Navbar.prototype.handleToggle = function handleToggle() {
	    var _props3 = this.props,
	        onToggle = _props3.onToggle,
	        expanded = _props3.expanded;
	
	
	    onToggle(!expanded);
	  };
	
	  Navbar.prototype.render = function render() {
	    var _extends2;
	
	    var _props4 = this.props,
	        Component = _props4.componentClass,
	        fixedTop = _props4.fixedTop,
	        fixedBottom = _props4.fixedBottom,
	        staticTop = _props4.staticTop,
	        inverse = _props4.inverse,
	        fluid = _props4.fluid,
	        className = _props4.className,
	        children = _props4.children,
	        props = (0, _objectWithoutProperties3['default'])(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	
	
	    if (elementProps.role === undefined && Component !== 'nav') {
	      elementProps.role = 'navigation';
	    }
	
	    if (inverse) {
	      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
	    }
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        _Grid2['default'],
	        { fluid: fluid },
	        children
	      )
	    );
	  };
	
	  return Navbar;
	}(_react2['default'].Component);
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	Navbar.childContextTypes = childContextTypes;
	
	(0, _bootstrapUtils.bsClass)('navbar', Navbar);
	
	var UncontrollableNavbar = (0, _uncontrollable2['default'])(Navbar, { expanded: 'onToggle' });
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var Wrapper = function Wrapper(_ref, _ref2) {
	    var _ref2$$bs_navbar = _ref2.$bs_navbar,
	        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;
	    var Component = _ref.componentClass,
	        className = _ref.className,
	        pullRight = _ref.pullRight,
	        pullLeft = _ref.pullLeft,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
	    }));
	  };
	
	  Wrapper.displayName = displayName;
	
	  Wrapper.propTypes = {
	    componentClass: _elementType2['default'],
	    pullRight: _propTypes2['default'].bool,
	    pullLeft: _propTypes2['default'].bool
	  };
	
	  Wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	
	  Wrapper.contextTypes = {
	    $bs_navbar: _propTypes2['default'].shape({
	      bsClass: _propTypes2['default'].string
	    })
	  };
	
	  return Wrapper;
	}
	
	UncontrollableNavbar.Brand = _NavbarBrand2['default'];
	UncontrollableNavbar.Header = _NavbarHeader2['default'];
	UncontrollableNavbar.Toggle = _NavbarToggle2['default'];
	UncontrollableNavbar.Collapse = _NavbarCollapse2['default'];
	
	UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');
	
	// Set bsStyles here so they can be overridden.
	exports['default'] = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT, UncontrollableNavbar);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/NavbarBrand.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string
	  })
	};
	
	var NavbarBrand = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    (0, _classCallCheck3['default'])(this, NavbarBrand);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarBrand.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');
	
	    if (_react2['default'].isValidElement(children)) {
	      return _react2['default'].cloneElement(children, {
	        className: (0, _classnames2['default'])(children.props.className, className, bsClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }),
	      children
	    );
	  };
	
	  return NavbarBrand;
	}(_react2['default'].Component);
	
	NavbarBrand.contextTypes = contextTypes;
	
	exports['default'] = NavbarBrand;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/NavbarCollapse.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__("./node_modules/react-bootstrap/lib/Collapse.js");
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool
	  })
	};
	
	var NavbarCollapse = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarCollapse, _React$Component);
	
	  function NavbarCollapse() {
	    (0, _classCallCheck3['default'])(this, NavbarCollapse);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarCollapse.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');
	
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': navbarProps.expanded }, props),
	      _react2['default'].createElement(
	        'div',
	        { className: bsClassName },
	        children
	      )
	    );
	  };
	
	  return NavbarCollapse;
	}(_react2['default'].Component);
	
	NavbarCollapse.contextTypes = contextTypes;
	
	exports['default'] = NavbarCollapse;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/NavbarHeader.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string
	  })
	};
	
	var NavbarHeader = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarHeader, _React$Component);
	
	  function NavbarHeader() {
	    (0, _classCallCheck3['default'])(this, NavbarHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }));
	  };
	
	  return NavbarHeader;
	}(_react2['default'].Component);
	
	NavbarHeader.contextTypes = contextTypes;
	
	exports['default'] = NavbarHeader;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/NavbarToggle.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onClick: _propTypes2['default'].func,
	  /**
	   * The toggle content, if left empty it will render the default toggle (seen above).
	   */
	  children: _propTypes2['default'].node
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool,
	    onToggle: _propTypes2['default'].func.isRequired
	  })
	};
	
	var NavbarToggle = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarToggle, _React$Component);
	
	  function NavbarToggle() {
	    (0, _classCallCheck3['default'])(this, NavbarToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarToggle.prototype.render = function render() {
	    var _props = this.props,
	        onClick = _props.onClick,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onClick', 'className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var buttonProps = (0, _extends3['default'])({
	      type: 'button'
	    }, props, {
	      onClick: (0, _createChainedFunction2['default'])(onClick, navbarProps.onToggle),
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
	    });
	
	    if (children) {
	      return _react2['default'].createElement(
	        'button',
	        buttonProps,
	        children
	      );
	    }
	
	    return _react2['default'].createElement(
	      'button',
	      buttonProps,
	      _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        'Toggle navigation'
	      ),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' })
	    );
	  };
	
	  return NavbarToggle;
	}(_react2['default'].Component);
	
	NavbarToggle.propTypes = propTypes;
	NavbarToggle.contextTypes = contextTypes;
	
	exports['default'] = NavbarToggle;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/NavbarBrand.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavbarBrand = __webpack_require__("./node_modules/react-bootstrap/lib/NavbarBrand.js");
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NavbarBrand2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/NavbarCollapse.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavbarCollapse = __webpack_require__("./node_modules/react-bootstrap/lib/NavbarCollapse.js");
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NavbarCollapse2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/NavbarHeader.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavbarHeader = __webpack_require__("./node_modules/react-bootstrap/lib/NavbarHeader.js");
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NavbarHeader2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/NavbarToggle.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavbarToggle = __webpack_require__("./node_modules/react-bootstrap/lib/NavbarToggle.js");
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NavbarToggle2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Overlay.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Overlay = __webpack_require__("./node_modules/react-bootstrap/lib/Overlay.js");
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Overlay2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Overlay.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Overlay = __webpack_require__("./node_modules/react-overlays/lib/Overlay.js");
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__("./node_modules/react-bootstrap/lib/Fade.js");
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2['default'].bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2['default'].bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _propTypes2['default'].func,
	
	  /**
	   * Use animation
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * Sets the direction of the Overlay.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left'])
	});
	
	var defaultProps = {
	  animation: _Fade2['default'],
	  rootClose: false,
	  show: false,
	  placement: 'right'
	};
	
	var Overlay = function (_React$Component) {
	  (0, _inherits3['default'])(Overlay, _React$Component);
	
	  function Overlay() {
	    (0, _classCallCheck3['default'])(this, Overlay);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        animation = _props.animation,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['animation', 'children']);
	
	
	    var transition = animation === true ? _Fade2['default'] : animation || null;
	
	    var child = void 0;
	
	    if (!transition) {
	      child = (0, _react.cloneElement)(children, {
	        className: (0, _classnames2['default'])(children.props.className, 'in')
	      });
	    } else {
	      child = children;
	    }
	
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2['default'].Component);
	
	Overlay.propTypes = propTypes;
	Overlay.defaultProps = defaultProps;
	
	exports['default'] = Overlay;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-overlays/lib/Overlay.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__("./node_modules/react-overlays/lib/Portal.js");
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__("./node_modules/react-overlays/lib/Position.js");
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__("./node_modules/react-overlays/lib/RootCloseWrapper.js");
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props, context));
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.show) {
	        this.setState({ exited: false });
	      } else if (!nextProps.transition) {
	        // Otherwise let handleHidden take care of marking exited.
	        this.setState({ exited: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          container = _props.container,
	          containerPadding = _props.containerPadding,
	          target = _props.target,
	          placement = _props.placement,
	          shouldUpdatePosition = _props.shouldUpdatePosition,
	          rootClose = _props.rootClose,
	          children = _props.children,
	          Transition = _props.transition,
	          props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	      // Don't un-render the overlay while it's transitioning out.
	
	
	      var mountOverlay = props.show || Transition && !this.state.exited;
	      if (!mountOverlay) {
	        // Don't bother showing anything if we don't have to.
	        return null;
	      }
	
	      var child = children;
	
	      // Position is be inner-most because it adds inline styles into the child,
	      // which the other wrappers don't forward correctly.
	      child = _react2.default.createElement(
	        _Position2.default,
	        { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	        child
	      );
	
	      if (Transition) {
	        var onExit = props.onExit,
	            onExiting = props.onExiting,
	            onEnter = props.onEnter,
	            onEntering = props.onEntering,
	            onEntered = props.onEntered;
	
	        // This animates the child node by injecting props, so it must precede
	        // anything that adds a wrapping div.
	
	        child = _react2.default.createElement(
	          Transition,
	          {
	            'in': props.show,
	            transitionAppear: true,
	            onExit: onExit,
	            onExiting: onExiting,
	            onExited: this.onHiddenListener,
	            onEnter: onEnter,
	            onEntering: onEntering,
	            onEntered: onEntered
	          },
	          child
	        );
	      }
	
	      // This goes after everything else because it adds a wrapping div.
	      if (rootClose) {
	        child = _react2.default.createElement(
	          _RootCloseWrapper2.default,
	          { onRootClose: props.onHide },
	          child
	        );
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { container: container },
	        child
	      );
	    }
	  }, {
	    key: 'handleHidden',
	    value: function handleHidden() {
	      this.setState({ exited: true });
	
	      if (this.props.onExited) {
	        var _props2;
	
	        (_props2 = this.props).onExited.apply(_props2, arguments);
	      }
	    }
	  }]);
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2.default.PropTypes.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _react2.default.PropTypes.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _react2.default.PropTypes.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2.default.PropTypes.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-overlays/lib/Position.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__("./node_modules/react-prop-types/lib/componentOrElement.js");
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _calculatePosition = __webpack_require__("./node_modules/react-overlays/lib/utils/calculatePosition.js");
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__("./node_modules/react-overlays/lib/utils/getContainer.js");
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__("./node_modules/react-overlays/lib/utils/ownerDocument.js");
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props, context));
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  _createClass(Position, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updatePosition(this.getTarget());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this._needsFlush = true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this._needsFlush) {
	        this._needsFlush = false;
	        this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['children', 'className']);
	
	      var _state = this.state,
	          positionLeft = _state.positionLeft,
	          positionTop = _state.positionTop,
	          arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	      // These should not be forwarded to the child.
	
	
	      delete props.target;
	      delete props.container;
	      delete props.containerPadding;
	      delete props.shouldUpdatePosition;
	
	      var child = _react2.default.Children.only(children);
	      return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	        // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	        // and `props.style`.
	        positionLeft: positionLeft,
	        positionTop: positionTop,
	        className: (0, _classnames2.default)(className, child.props.className),
	        style: _extends({}, child.props.style, {
	          left: positionLeft,
	          top: positionTop
	        })
	      }));
	    }
	  }, {
	    key: 'getTarget',
	    value: function getTarget() {
	      var target = this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    }
	  }, {
	    key: 'maybeUpdatePosition',
	    value: function maybeUpdatePosition(placementChanged) {
	      var target = this.getTarget();
	
	      if (!this.props.shouldUpdatePosition && target === this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      this.updatePosition(target);
	    }
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition(target) {
	      this._lastTarget = target;
	
	      if (!target) {
	        this.setState({
	          positionLeft: 0,
	          positionTop: 0,
	          arrowOffsetLeft: null,
	          arrowOffsetTop: null
	        });
	
	        return;
	      }
	
	      var overlay = _reactDom2.default.findDOMNode(this);
	      var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	      this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	    }
	  }]);
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _react2.default.PropTypes.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _react2.default.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _react2.default.PropTypes.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-overlays/lib/utils/calculatePosition.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/query/offset.js");
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/query/position.js");
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/query/scrollTop.js");
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__("./node_modules/react-overlays/lib/utils/ownerDocument.js");
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/query/offset.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = offset;
	
	var _contains = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/query/contains.js"));
	
	var _isWindow = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/query/isWindow.js"));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/ownerDocument.js"));
	
	function offset(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      win = (0, _isWindow.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = {
	    top: 0,
	    left: 0,
	    height: 0,
	    width: 0
	  };
	  if (!doc) return; // Make sure it's not a disconnected DOM node
	
	  if (!(0, _contains.default)(docElem, node)) return box;
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height
	
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	  return box;
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/query/position.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = position;
	
	var _extends2 = _interopRequireDefault(__webpack_require__("./node_modules/@babel/runtime/helpers/extends.js"));
	
	var _offset = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/query/offset.js"));
	
	var _offsetParent = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/query/offsetParent.js"));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/query/scrollTop.js"));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/query/scrollLeft.js"));
	
	var _style = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/style/index.js"));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = {
	    top: 0,
	    left: 0
	  },
	      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	
	  if ((0, _style.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent.default)(node);
	    offset = (0, _offset.default)(node);
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
	    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
	  } // Subtract parent offsets and node margins
	
	
	  return (0, _extends2.default)({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/@babel/runtime/helpers/extends.js":
/***/ function(module, exports) {

	function _extends() {
	  return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
	    for (var e = 1; e < arguments.length; e++) {
	      var t = arguments[e];
	      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
	    }
	    return n;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/query/offsetParent.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = offsetParent;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/ownerDocument.js"));
	
	var _style = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/style/index.js"));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/query/scrollTop.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/query/isWindow.js"));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/react-overlays/node_modules/dom-helpers/query/scrollLeft.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__("./node_modules/react-overlays/node_modules/dom-helpers/query/isWindow.js"));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/OverlayTrigger.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _OverlayTrigger = __webpack_require__("./node_modules/react-bootstrap/lib/OverlayTrigger.js");
	
	var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _OverlayTrigger2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/OverlayTrigger.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _contains = __webpack_require__("./node_modules/react-bootstrap/node_modules/dom-helpers/query/contains.js");
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__("./node_modules/react-bootstrap/lib/Overlay.js");
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var triggerType = _propTypes2['default'].oneOf(['click', 'hover', 'focus']);
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	  * Specify which action or actions trigger Overlay visibility
	  */
	  trigger: _propTypes2['default'].oneOfType([triggerType, _propTypes2['default'].arrayOf(triggerType)]),
	
	  /**
	   * A millisecond delay amount to show and hide the Overlay once triggered
	   */
	  delay: _propTypes2['default'].number,
	  /**
	   * A millisecond delay amount before showing the Overlay once triggered.
	   */
	  delayShow: _propTypes2['default'].number,
	  /**
	   * A millisecond delay amount before hiding the Overlay once triggered.
	   */
	  delayHide: _propTypes2['default'].number,
	
	  // FIXME: This should be `defaultShow`.
	  /**
	   * The initial visibility state of the Overlay. For more nuanced visibility
	   * control, consider using the Overlay component directly.
	   */
	  defaultOverlayShown: _propTypes2['default'].bool,
	
	  /**
	   * An element or text to overlay next to the target.
	   */
	  overlay: _propTypes2['default'].node.isRequired,
	
	  /**
	   * @private
	   */
	  onBlur: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onClick: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onFocus: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseOut: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseOver: _propTypes2['default'].func,
	
	  // Overridden props from `<Overlay>`.
	  /**
	   * @private
	   */
	  target: _propTypes2['default'].oneOf([null]),
	  /**
	  * @private
	  */
	  onHide: _propTypes2['default'].oneOf([null]),
	  /**
	   * @private
	   */
	  show: _propTypes2['default'].oneOf([null])
	});
	
	var defaultProps = {
	  defaultOverlayShown: false,
	  trigger: ['hover', 'focus']
	};
	
	var OverlayTrigger = function (_React$Component) {
	  (0, _inherits3['default'])(OverlayTrigger, _React$Component);
	
	  function OverlayTrigger(props, context) {
	    (0, _classCallCheck3['default'])(this, OverlayTrigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
	    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
	    _this.handleHide = _this.handleHide.bind(_this);
	
	    _this.handleMouseOver = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
	    };
	    _this.handleMouseOut = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
	    };
	
	    _this._mountNode = null;
	
	    _this.state = {
	      show: props.defaultOverlayShown
	    };
	    return _this;
	  }
	
	  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    _reactDom2['default'].unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  };
	
	  OverlayTrigger.prototype.handleToggle = function handleToggle() {
	    if (this.state.show) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
	    var _this2 = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.show || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this2._hoverShowDelay = null;
	      _this2.show();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
	    var _this3 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.show || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this3._hoverHideDelay = null;
	      _this3.hide();
	    }, delay);
	  };
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
	  // moving from one child element to another.
	
	
	  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if (!related || related !== target && !(0, _contains2['default'])(target, related)) {
	      handler(e);
	    }
	  };
	
	  OverlayTrigger.prototype.handleHide = function handleHide() {
	    this.hide();
	  };
	
	  OverlayTrigger.prototype.show = function show() {
	    this.setState({ show: true });
	  };
	
	  OverlayTrigger.prototype.hide = function hide() {
	    this.setState({ show: false });
	  };
	
	  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        show: this.state.show,
	        onHide: this.handleHide,
	        target: this
	      }),
	      overlay
	    );
	  };
	
	  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
	    _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  };
	
	  OverlayTrigger.prototype.render = function render() {
	    var _props = this.props,
	        trigger = _props.trigger,
	        overlay = _props.overlay,
	        children = _props.children,
	        onBlur = _props.onBlur,
	        onClick = _props.onClick,
	        onFocus = _props.onFocus,
	        onMouseOut = _props.onMouseOut,
	        onMouseOver = _props.onMouseOver,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);
	
	
	    delete props.delay;
	    delete props.delayShow;
	    delete props.delayHide;
	    delete props.defaultOverlayShown;
	
	    var child = _react2['default'].Children.only(children);
	    var childProps = child.props;
	    var triggerProps = {};
	
	    if (this.state.show) {
	      triggerProps['aria-describedby'] = overlay.props.id;
	    }
	
	    // FIXME: The logic here for passing through handlers on this component is
	    // inconsistent. We shouldn't be passing any of these props through.
	
	    triggerProps.onClick = (0, _createChainedFunction2['default'])(childProps.onClick, onClick);
	
	    if (isOneOf('click', trigger)) {
	      triggerProps.onClick = (0, _createChainedFunction2['default'])(triggerProps.onClick, this.handleToggle);
	    }
	
	    if (isOneOf('hover', trigger)) {
	       false ? (0, _warning2['default'])(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
	
	      triggerProps.onMouseOver = (0, _createChainedFunction2['default'])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
	      triggerProps.onMouseOut = (0, _createChainedFunction2['default'])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
	    }
	
	    if (isOneOf('focus', trigger)) {
	      triggerProps.onFocus = (0, _createChainedFunction2['default'])(childProps.onFocus, onFocus, this.handleDelayedShow);
	      triggerProps.onBlur = (0, _createChainedFunction2['default'])(childProps.onBlur, onBlur, this.handleDelayedHide);
	    }
	
	    this._overlay = this.makeOverlay(overlay, props);
	
	    return (0, _react.cloneElement)(child, triggerProps);
	  };
	
	  return OverlayTrigger;
	}(_react2['default'].Component);
	
	OverlayTrigger.propTypes = propTypes;
	OverlayTrigger.defaultProps = defaultProps;
	
	exports['default'] = OverlayTrigger;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/PageHeader.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PageHeader = __webpack_require__("./node_modules/react-bootstrap/lib/PageHeader.js");
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PageHeader2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/PageHeader.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PageHeader = function (_React$Component) {
	  (0, _inherits3['default'])(PageHeader, _React$Component);
	
	  function PageHeader() {
	    (0, _classCallCheck3['default'])(this, PageHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  PageHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        'h1',
	        null,
	        children
	      )
	    );
	  };
	
	  return PageHeader;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/PageItem.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PageItem = __webpack_require__("./node_modules/react-bootstrap/lib/PageItem.js");
	
	var _PageItem2 = _interopRequireDefault(_PageItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PageItem2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/PageItem.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PagerItem = __webpack_require__("./node_modules/react-bootstrap/lib/PagerItem.js");
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _deprecationWarning = __webpack_require__("./node_modules/react-bootstrap/lib/utils/deprecationWarning.js");
	
	var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _deprecationWarning2['default'].wrapper(_PagerItem2['default'], '`<PageItem>`', '`<Pager.Item>`');
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/PagerItem.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__("./node_modules/react-bootstrap/lib/SafeAnchor.js");
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  disabled: _propTypes2['default'].bool,
	  previous: _propTypes2['default'].bool,
	  next: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  eventKey: _propTypes2['default'].any
	};
	
	var defaultProps = {
	  disabled: false,
	  previous: false,
	  next: false
	};
	
	var PagerItem = function (_React$Component) {
	  (0, _inherits3['default'])(PagerItem, _React$Component);
	
	  function PagerItem(props, context) {
	    (0, _classCallCheck3['default'])(this, PagerItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  PagerItem.prototype.handleSelect = function handleSelect(e) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (onSelect || disabled) {
	      e.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, e);
	    }
	  };
	
	  PagerItem.prototype.render = function render() {
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        previous = _props2.previous,
	        next = _props2.next,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { disabled: disabled, previous: previous, next: next }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleSelect)
	      }))
	    );
	  };
	
	  return PagerItem;
	}(_react2['default'].Component);
	
	PagerItem.propTypes = propTypes;
	PagerItem.defaultProps = defaultProps;
	
	exports['default'] = PagerItem;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/utils/deprecationWarning.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message = void 0;
	
	  if ((typeof oldname === 'undefined' ? 'undefined' : (0, _typeof3['default'])(oldname)) === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + ' is deprecated. Use ' + newname + ' instead.';
	
	    if (link) {
	      message += '\nYou can read more about it at ' + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? (0, _warning2['default'])(false, message) : void 0;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return function (_Component) {
	    (0, _inherits3['default'])(DeprecatedComponent, _Component);
	
	    function DeprecatedComponent() {
	      (0, _classCallCheck3['default'])(this, DeprecatedComponent);
	      return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	    }
	
	    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
	      deprecationWarning.apply(undefined, args);
	
	      if (_Component.prototype.componentWillMount) {
	        var _Component$prototype$;
	
	        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          methodArgs[_key2] = arguments[_key2];
	        }
	
	        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
	      }
	    };
	
	    return DeprecatedComponent;
	  }(Component);
	};
	
	exports['default'] = deprecationWarning;
	function _resetWarned() {
	  warned = {};
	}

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Pager.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Pager = __webpack_require__("./node_modules/react-bootstrap/lib/Pager.js");
	
	var _Pager2 = _interopRequireDefault(_Pager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Pager2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Pager.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PagerItem = __webpack_require__("./node_modules/react-bootstrap/lib/PagerItem.js");
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js");
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onSelect: _propTypes2['default'].func
	};
	
	var Pager = function (_React$Component) {
	  (0, _inherits3['default'])(Pager, _React$Component);
	
	  function Pager() {
	    (0, _classCallCheck3['default'])(this, Pager);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pager.prototype.render = function render() {
	    var _props = this.props,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onSelect', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, {
	          onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	        });
	      })
	    );
	  };
	
	  return Pager;
	}(_react2['default'].Component);
	
	Pager.propTypes = propTypes;
	
	Pager.Item = _PagerItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pager', Pager);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Pagination.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Pagination = __webpack_require__("./node_modules/react-bootstrap/lib/Pagination.js");
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Pagination2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Pagination.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _PaginationButton = __webpack_require__("./node_modules/react-bootstrap/lib/PaginationButton.js");
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  activePage: _propTypes2['default'].number,
	  items: _propTypes2['default'].number,
	  maxButtons: _propTypes2['default'].number,
	
	  /**
	   * When `true`, will display the first and the last button page when
	   * displaying ellipsis.
	   */
	  boundaryLinks: _propTypes2['default'].bool,
	
	  /**
	   * When `true`, will display the default node value ('&hellip;').
	   * Otherwise, will display provided node (when specified).
	   */
	  ellipsis: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&laquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  first: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&raquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  last: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&lsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  prev: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&rsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  next: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * You can use a custom element for the buttons
	   */
	  buttonComponentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  activePage: 1,
	  items: 1,
	  maxButtons: 0,
	  first: false,
	  last: false,
	  prev: false,
	  next: false,
	  ellipsis: true,
	  boundaryLinks: false
	};
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3['default'])(Pagination, _React$Component);
	
	  function Pagination() {
	    (0, _classCallCheck3['default'])(this, Pagination);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
	    var pageButtons = [];
	
	    var startPage = void 0;
	    var endPage = void 0;
	
	    if (maxButtons && maxButtons < items) {
	      startPage = Math.max(Math.min(activePage - Math.floor(maxButtons / 2, 10), items - maxButtons + 1), 1);
	      endPage = startPage + maxButtons - 1;
	    } else {
	      startPage = 1;
	      endPage = items;
	    }
	
	    for (var page = startPage; page <= endPage; ++page) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: page,
	          eventKey: page,
	          active: page === activePage
	        }),
	        page
	      ));
	    }
	
	    if (ellipsis && boundaryLinks && startPage > 1) {
	      if (startPage > 2) {
	        pageButtons.unshift(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          {
	            key: 'ellipsisFirst',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2['default'].createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: 1,
	          eventKey: 1,
	          active: false
	        }),
	        '1'
	      ));
	    }
	
	    if (ellipsis && endPage < items) {
	      if (!boundaryLinks || endPage < items - 1) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          {
	            key: 'ellipsis',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2['default'].createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      if (boundaryLinks) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          (0, _extends3['default'])({}, buttonProps, {
	            key: items,
	            eventKey: items,
	            active: false
	          }),
	          items
	        ));
	      }
	    }
	
	    return pageButtons;
	  };
	
	  Pagination.prototype.render = function render() {
	    var _props = this.props,
	        activePage = _props.activePage,
	        items = _props.items,
	        maxButtons = _props.maxButtons,
	        boundaryLinks = _props.boundaryLinks,
	        ellipsis = _props.ellipsis,
	        first = _props.first,
	        last = _props.last,
	        prev = _props.prev,
	        next = _props.next,
	        onSelect = _props.onSelect,
	        buttonComponentClass = _props.buttonComponentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var buttonProps = {
	      onSelect: onSelect,
	      componentClass: buttonComponentClass
	    };
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      first && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'First' },
	          first === true ? '\xAB' : first
	        )
	      ),
	      prev && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage - 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Previous' },
	          prev === true ? '\u2039' : prev
	        )
	      ),
	      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
	      next && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage + 1,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Next' },
	          next === true ? '\u203A' : next
	        )
	      ),
	      last && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: items,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Last' },
	          last === true ? '\xBB' : last
	        )
	      )
	    );
	  };
	
	  return Pagination;
	}(_react2['default'].Component);
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pagination', Pagination);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/PaginationButton.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _SafeAnchor = __webpack_require__("./node_modules/react-bootstrap/lib/SafeAnchor.js");
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should be `<Pagination.Item>`.
	
	// TODO: This should use `componentClass` like other components.
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  className: _propTypes2['default'].string,
	  eventKey: _propTypes2['default'].any,
	  onSelect: _propTypes2['default'].func,
	  disabled: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: _SafeAnchor2['default'],
	  active: false,
	  disabled: false
	};
	
	var PaginationButton = function (_React$Component) {
	  (0, _inherits3['default'])(PaginationButton, _React$Component);
	
	  function PaginationButton(props, context) {
	    (0, _classCallCheck3['default'])(this, PaginationButton);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  PaginationButton.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  PaginationButton.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    if (Component === _SafeAnchor2['default']) {
	      // Assume that custom components want `eventKey`.
	      delete props.eventKey;
	    }
	
	    delete props.onSelect;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return PaginationButton;
	}(_react2['default'].Component);
	
	PaginationButton.propTypes = propTypes;
	PaginationButton.defaultProps = defaultProps;
	
	exports['default'] = PaginationButton;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Popover.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Popover = __webpack_require__("./node_modules/react-bootstrap/lib/Popover.js");
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Popover2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Popover.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__("./node_modules/react-prop-types/lib/isRequiredForA11y.js");
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Sets the direction the Popover is positioned towards.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Popover.
	   */
	  positionTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Popover.
	   */
	  positionLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * The "top" position value for the Popover arrow.
	   */
	  arrowOffsetTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Popover arrow.
	   */
	  arrowOffsetLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * Title content
	   */
	  title: _propTypes2['default'].node
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Popover = function (_React$Component) {
	  (0, _inherits3['default'])(Popover, _React$Component);
	
	  function Popover() {
	    (0, _classCallCheck3['default'])(this, Popover);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Popover.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        title = _props.title,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      display: 'block',
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: 'arrow', style: arrowStyle }),
	      title && _react2['default'].createElement(
	        'h3',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'title') },
	        title
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'content') },
	        children
	      )
	    );
	  };
	
	  return Popover;
	}(_react2['default'].Component);
	
	Popover.propTypes = propTypes;
	Popover.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('popover', Popover);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Progress.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _BProgressBar = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/BProgressBar.js");
	
	var _BProgressBar2 = _interopRequireDefault(_BProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_BProgressBar2.default.propTypes.children = _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.element);
	
	var Progress = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(Progress, _React$Component);
	
	  function Progress() {
	    (0, _classCallCheck3.default)(this, Progress);
	    return (0, _possibleConstructorReturn3.default)(this, (Progress.__proto__ || (0, _getPrototypeOf2.default)(Progress)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Progress, [{
	    key: 'getValue',
	    value: function getValue() {
	      console.warn("Progress.getValue() is deprecated in favor of Progress.value");
	      return this.value;
	    }
	  }, {
	    key: 'getMin',
	    value: function getMin() {
	      console.warn("Progress.getMin() is deprecated in favor of Progress.min");
	      return this.min;
	    }
	  }, {
	    key: 'getMax',
	    value: function getMax() {
	      console.warn("Progress.getMax() is deprecated in favor of Progress.max");
	      return this.max;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	
	      if (props.value) {
	        props.now = props.value;
	        delete props.value;
	      }
	
	      if (props.success) {
	        props.bsStyle = 'success';
	      }
	
	      if (props.info) {
	        props.bsStyle = 'info';
	      }
	
	      if (props.warning) {
	        props.bsStyle = 'warning';
	      }
	
	      if (props.danger) {
	        props.bsStyle = 'danger';
	      }
	
	      if (props.fgColor) {
	        props.style = (0, _extends3.default)({}, props.style, {
	          color: props.fgColor
	        });
	      }
	
	      if (props.collapseBottom) {
	        props.className = (0, _classnames2.default)(props.className, 'progress-collapse-bottom');
	      }
	
	      return _react2.default.createElement(_BProgressBar2.default, props);
	    }
	  }, {
	    key: 'value',
	    get: function get() {
	      return this.props.value || this.props.now;
	    }
	  }, {
	    key: 'min',
	    get: function get() {
	      return this.props.min;
	    }
	  }, {
	    key: 'max',
	    get: function get() {
	      return this.props.max;
	    }
	  }]);
	  return Progress;
	}(_react2.default.Component), _class.propTypes = {
	  value: _react2.default.PropTypes.number,
	  success: _react2.default.PropTypes.bool,
	  info: _react2.default.PropTypes.bool,
	  warning: _react2.default.PropTypes.bool,
	  danger: _react2.default.PropTypes.bool,
	  color: _react2.default.PropTypes.string,
	  fgColor: _react2.default.PropTypes.string,
	  collapseBottom: _react2.default.PropTypes.bool
	}, _temp);
	exports.default = Progress;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/BProgressBar.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__("./node_modules/babel-runtime/core-js/object/values.js");
	
	var _values2 = _interopRequireDefault(_values);
	
	var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _slicedToArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/slicedToArray.js");
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");
	
	var _ValidComponentChildren = __webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js");
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROUND_PRECISION = 1000;
	
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	
	    if (child.type === ProgressBar) {
	      // eslint-disable-line no-use-before-define
	      return;
	    }
	
	    var childIdentifier = _react2.default.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
	    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
	  });
	
	  return error;
	}
	
	var propTypes = {
	  min: _react.PropTypes.number,
	  now: _react.PropTypes.number,
	  max: _react.PropTypes.number,
	  label: _react.PropTypes.node,
	  srOnly: _react.PropTypes.bool,
	  striped: _react.PropTypes.bool,
	  active: _react.PropTypes.bool,
	  children: onlyProgressBar,
	
	  /**
	   * @private
	   */
	  isChild: _react.PropTypes.bool
	};
	
	var defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	var ProgressBar = function (_React$Component) {
	  (0, _inherits3.default)(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    (0, _classCallCheck3.default)(this, ProgressBar);
	    return (0, _possibleConstructorReturn3.default)(this, (ProgressBar.__proto__ || (0, _getPrototypeOf2.default)(ProgressBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProgressBar, [{
	    key: 'renderProgressBar',
	    value: function renderProgressBar(_ref) {
	      var min = _ref.min,
	          now = _ref.now,
	          max = _ref.max,
	          label = _ref.label,
	          srOnly = _ref.srOnly,
	          striped = _ref.striped,
	          active = _ref.active,
	          className = _ref.className,
	          style = _ref.style,
	          color = _ref.color,
	          props = (0, _objectWithoutProperties3.default)(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style', 'color']);
	
	      var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	          _splitBsProps2 = (0, _slicedToArray3.default)(_splitBsProps, 2),
	          bsProps = _splitBsProps2[0],
	          elementProps = _splitBsProps2[1];
	
	      var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (0, _defineProperty3.default)({
	        active: active
	      }, (0, _bootstrapUtils.prefix)(bsProps, 'striped'), active || striped));
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends4.default)({}, elementProps, {
	          role: 'progressbar',
	          className: (0, _classnames2.default)(className, classes),
	          style: (0, _extends4.default)({ width: getPercentage(now, min, max) + '%', backgroundColor: color }, style),
	          'aria-valuenow': now,
	          'aria-valuemin': min,
	          'aria-valuemax': max
	        }),
	        srOnly ? _react2.default.createElement(
	          'span',
	          { className: 'sr-only' },
	          label
	        ) : label
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isChild = _props.isChild,
	          props = (0, _objectWithoutProperties3.default)(_props, ['isChild']);
	
	
	      if (isChild) {
	        return this.renderProgressBar(props);
	      }
	
	      var min = props.min,
	          now = props.now,
	          max = props.max,
	          label = props.label,
	          srOnly = props.srOnly,
	          striped = props.striped,
	          active = props.active,
	          bsClass = props.bsClass,
	          bsStyle = props.bsStyle,
	          color = props.color,
	          className = props.className,
	          children = props.children,
	          wrapperProps = (0, _objectWithoutProperties3.default)(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'color', 'className', 'children']);
	
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends4.default)({}, wrapperProps, {
	          className: (0, _classnames2.default)(className, 'progress')
	        }),
	        children ? _ValidComponentChildren2.default.map(children, function (child) {
	          return (0, _react.cloneElement)(child, { isChild: true });
	        }) : this.renderProgressBar({
	          min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle, color: color
	        })
	      );
	    }
	  }]);
	  return ProgressBar;
	}(_react2.default.Component);
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values2.default)(_StyleConfig.State), ProgressBar));

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/ProgressBar.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BProgressBar = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/BProgressBar.js");
	
	var _BProgressBar2 = _interopRequireDefault(_BProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProgressBar = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    (0, _classCallCheck3.default)(this, ProgressBar);
	    return (0, _possibleConstructorReturn3.default)(this, (ProgressBar.__proto__ || (0, _getPrototypeOf2.default)(ProgressBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProgressBar, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	
	      if (props.value) {
	        props.now = props.value;
	        delete props.value;
	      }
	
	      return _react2.default.createElement(_BProgressBar2.default, props);
	    }
	  }]);
	  return ProgressBar;
	}(_react2.default.Component), _class.propTypes = {
	  value: _react2.default.PropTypes.number
	}, _temp);
	exports.default = ProgressBar;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/ProgressGroup.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProgressGroup = function (_React$Component) {
	  (0, _inherits3.default)(ProgressGroup, _React$Component);
	
	  function ProgressGroup() {
	    (0, _classCallCheck3.default)(this, ProgressGroup);
	    return (0, _possibleConstructorReturn3.default)(this, (ProgressGroup.__proto__ || (0, _getPrototypeOf2.default)(ProgressGroup)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProgressGroup, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'progress' },
	        this.props.children
	      );
	    }
	  }]);
	  return ProgressGroup;
	}(_react2.default.Component);
	
	exports.default = ProgressGroup;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Radio.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Radio = __webpack_require__("./node_modules/react-bootstrap/lib/Radio.js");
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Radio2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Radio.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Radio inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Radio = function (_React$Component) {
	  (0, _inherits3['default'])(Radio, _React$Component);
	
	  function Radio() {
	    (0, _classCallCheck3['default'])(this, Radio);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Radio.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'radio',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Radio;
	}(_react2['default'].Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('radio', Radio);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/ResponsiveEmbed.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ResponsiveEmbed = __webpack_require__("./node_modules/react-bootstrap/lib/ResponsiveEmbed.js");
	
	var _ResponsiveEmbed2 = _interopRequireDefault(_ResponsiveEmbed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ResponsiveEmbed2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/ResponsiveEmbed.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should probably take a single `aspectRatio` prop.
	
	var propTypes = {
	  /**
	   * This component requires a single child element
	   */
	  children: _propTypes2['default'].element.isRequired,
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _propTypes2['default'].bool,
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  a16by9: false,
	  a4by3: false
	};
	
	var ResponsiveEmbed = function (_React$Component) {
	  (0, _inherits3['default'])(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    (0, _classCallCheck3['default'])(this, ResponsiveEmbed);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ResponsiveEmbed.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        a16by9 = _props.a16by9,
	        a4by3 = _props.a4by3,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['a16by9', 'a4by3', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
	     false ? (0, _warning2['default'])(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '16by9')] = a16by9, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '4by3')] = a4by3, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(classes) },
	      (0, _react.cloneElement)(children, (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'item'))
	      }))
	    );
	  };
	
	  return ResponsiveEmbed;
	}(_react2['default'].Component);
	
	ResponsiveEmbed.propTypes = propTypes;
	ResponsiveEmbed.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('embed-responsive', ResponsiveEmbed);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/SplitButton.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RSplitButton = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/RSplitButton.js");
	
	var _RSplitButton2 = _interopRequireDefault(_RSplitButton);
	
	var _DropdownButton = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/DropdownButton.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SplitButton = (0, _DropdownButton.DropdownButtonHOC)(_class = function (_React$Component) {
	  (0, _inherits3.default)(SplitButton, _React$Component);
	
	  function SplitButton() {
	    (0, _classCallCheck3.default)(this, SplitButton);
	    return (0, _possibleConstructorReturn3.default)(this, (SplitButton.__proto__ || (0, _getPrototypeOf2.default)(SplitButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SplitButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_RSplitButton2.default, this.props.buttonProps);
	    }
	  }]);
	  return SplitButton;
	}(_react2.default.Component)) || _class;
	
	exports.default = SplitButton;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/RSplitButton.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__("./node_modules/react-bootstrap/lib/Button.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__("./node_modules/react-bootstrap/lib/Dropdown.js");
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__("./node_modules/react-bootstrap/lib/SplitToggle.js");
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _omit = __webpack_require__("./node_modules/lodash-compat/object/omit.js");
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _pick = __webpack_require__("./node_modules/lodash-compat/object/pick.js");
	
	var _pick2 = _interopRequireDefault(_pick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SplitButton = function (_React$Component) {
	  (0, _inherits3.default)(SplitButton, _React$Component);
	
	  function SplitButton() {
	    (0, _classCallCheck3.default)(this, SplitButton);
	    return (0, _possibleConstructorReturn3.default)(this, (SplitButton.__proto__ || (0, _getPrototypeOf2.default)(SplitButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SplitButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          title = _props.title,
	          onClick = _props.onClick,
	          target = _props.target,
	          href = _props.href,
	          toggleLabel = _props.toggleLabel,
	          bsSize = _props.bsSize,
	          bsStyle = _props.bsStyle,
	          props = (0, _objectWithoutProperties3.default)(_props, ['children', 'title', 'onClick', 'target', 'href', 'toggleLabel', 'bsSize', 'bsStyle']);
	      var disabled = props.disabled;
	
	
	      var dropdownProps = (0, _pick2.default)(props, (0, _keys2.default)(_Dropdown2.default.ControlledComponent.propTypes));
	      var buttonProps = (0, _omit2.default)(props, (0, _keys2.default)(_Dropdown2.default.ControlledComponent.propTypes));
	
	      return _react2.default.createElement(
	        _Dropdown2.default,
	        dropdownProps,
	        _react2.default.createElement(
	          _Button2.default,
	          (0, _extends3.default)({}, buttonProps, {
	            onClick: onClick,
	            bsStyle: bsStyle,
	            bsSize: bsSize,
	            disabled: disabled,
	            target: target,
	            href: href
	          }),
	          title
	        ),
	        _react2.default.createElement(_SplitToggle2.default, (0, _extends3.default)({}, buttonProps, {
	          'aria-label': toggleLabel || title,
	          bsStyle: bsStyle,
	          bsSize: bsSize,
	          disabled: disabled
	        })),
	        _react2.default.createElement(
	          _Dropdown2.default.Menu,
	          null,
	          children
	        )
	      );
	    }
	  }]);
	  return SplitButton;
	}(_react2.default.Component);
	
	SplitButton.propTypes = (0, _extends3.default)({}, _Dropdown2.default.propTypes, {
	  bsStyle: _Button2.default.propTypes.bsStyle,
	
	  /**
	   * @private
	   */
	  onClick: function onClick() {},
	
	  target: _react2.default.PropTypes.string,
	  href: _react2.default.PropTypes.string,
	  /**
	   * The content of the split button.
	   */
	  title: _react2.default.PropTypes.node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _react2.default.PropTypes.string
	});
	
	SplitButton.defaultProps = {
	  disabled: false,
	  dropup: false,
	  pullRight: false
	};
	
	SplitButton.Toggle = _SplitToggle2.default;
	
	exports.default = SplitButton;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/SplitToggle.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownToggle = __webpack_require__("./node_modules/react-bootstrap/lib/DropdownToggle.js");
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SplitToggle = function (_React$Component) {
	  (0, _inherits3['default'])(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    (0, _classCallCheck3['default'])(this, SplitToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitToggle.prototype.render = function render() {
	    return _react2['default'].createElement(_DropdownToggle2['default'], (0, _extends3['default'])({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	}(_react2['default'].Component);
	
	SplitToggle.defaultProps = _DropdownToggle2['default'].defaultProps;
	
	exports['default'] = SplitToggle;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/lodash-compat/object/omit.js":
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__("./node_modules/lodash-compat/internal/arrayMap.js"),
	    baseDifference = __webpack_require__("./node_modules/lodash-compat/internal/baseDifference.js"),
	    baseFlatten = __webpack_require__("./node_modules/lodash-compat/internal/baseFlatten.js"),
	    bindCallback = __webpack_require__("./node_modules/lodash-compat/internal/bindCallback.js"),
	    keysIn = __webpack_require__("./node_modules/lodash-compat/object/keysIn.js"),
	    pickByArray = __webpack_require__("./node_modules/lodash-compat/internal/pickByArray.js"),
	    pickByCallback = __webpack_require__("./node_modules/lodash-compat/internal/pickByCallback.js"),
	    restParam = __webpack_require__("./node_modules/lodash-compat/function/restParam.js");
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable properties of `object` that are not omitted.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|...(string|string[])} [predicate] The function invoked per
	 *  iteration or property names to omit, specified as individual property
	 *  names or arrays of property names.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'user': 'fred', 'age': 40 };
	 *
	 * _.omit(object, 'age');
	 * // => { 'user': 'fred' }
	 *
	 * _.omit(object, _.isNumber);
	 * // => { 'user': 'fred' }
	 */
	var omit = restParam(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  if (typeof props[0] != 'function') {
	    var props = arrayMap(baseFlatten(props), String);
	    return pickByArray(object, baseDifference(keysIn(object), props));
	  }
	  var predicate = bindCallback(props[0], props[1], 3);
	  return pickByCallback(object, function(value, key, object) {
	    return !predicate(value, key, object);
	  });
	});
	
	module.exports = omit;


/***/ },

/***/ "./node_modules/lodash-compat/internal/arrayMap.js":
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },

/***/ "./node_modules/lodash-compat/internal/baseDifference.js":
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__("./node_modules/lodash-compat/internal/baseIndexOf.js"),
	    cacheIndexOf = __webpack_require__("./node_modules/lodash-compat/internal/cacheIndexOf.js"),
	    createCache = __webpack_require__("./node_modules/lodash-compat/internal/createCache.js");
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.difference` which accepts a single array
	 * of values to exclude.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values) {
	  var length = array ? array.length : 0,
	      result = [];
	
	  if (!length) {
	    return result;
	  }
	  var index = -1,
	      indexOf = baseIndexOf,
	      isCommon = true,
	      cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	      valuesLength = values.length;
	
	  if (cache) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	    values = cache;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index];
	
	    if (isCommon && value === value) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === value) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (indexOf(values, value, 0) < 0) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },

/***/ "./node_modules/lodash-compat/internal/baseIndexOf.js":
/***/ function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__("./node_modules/lodash-compat/internal/indexOfNaN.js");
	
	/**
	 * The base implementation of `_.indexOf` without support for binary searches.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ },

/***/ "./node_modules/lodash-compat/internal/indexOfNaN.js":
/***/ function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 0 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ },

/***/ "./node_modules/lodash-compat/internal/cacheIndexOf.js":
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/lodash-compat/lang/isObject.js");
	
	/**
	 * Checks if `value` is in `cache` mimicking the return signature of
	 * `_.indexOf` by returning `0` if the value is found, else `-1`.
	 *
	 * @private
	 * @param {Object} cache The cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `0` if `value` is found, else `-1`.
	 */
	function cacheIndexOf(cache, value) {
	  var data = cache.data,
	      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	  return result ? 0 : -1;
	}
	
	module.exports = cacheIndexOf;


/***/ },

/***/ "./node_modules/lodash-compat/lang/isObject.js":
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },

/***/ "./node_modules/lodash-compat/internal/createCache.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var SetCache = __webpack_require__("./node_modules/lodash-compat/internal/SetCache.js"),
	    getNative = __webpack_require__("./node_modules/lodash-compat/internal/getNative.js");
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a `Set` cache object to optimize linear searches of large arrays.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	 */
	function createCache(values) {
	  return (nativeCreate && Set) ? new SetCache(values) : null;
	}
	
	module.exports = createCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "./node_modules/lodash-compat/internal/SetCache.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var cachePush = __webpack_require__("./node_modules/lodash-compat/internal/cachePush.js"),
	    getNative = __webpack_require__("./node_modules/lodash-compat/internal/getNative.js");
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 *
	 * Creates a cache object to store unique values.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var length = values ? values.length : 0;
	
	  this.data = { 'hash': nativeCreate(null), 'set': new Set };
	  while (length--) {
	    this.push(values[length]);
	  }
	}
	
	// Add functions to the `Set` cache.
	SetCache.prototype.push = cachePush;
	
	module.exports = SetCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "./node_modules/lodash-compat/internal/cachePush.js":
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/lodash-compat/lang/isObject.js");
	
	/**
	 * Adds `value` to the cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var data = this.data;
	  if (typeof value == 'string' || isObject(value)) {
	    data.set.add(value);
	  } else {
	    data.hash[value] = true;
	  }
	}
	
	module.exports = cachePush;


/***/ },

/***/ "./node_modules/lodash-compat/internal/getNative.js":
/***/ function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__("./node_modules/lodash-compat/lang/isNative.js");
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },

/***/ "./node_modules/lodash-compat/lang/isNative.js":
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__("./node_modules/lodash-compat/lang/isFunction.js"),
	    isHostObject = __webpack_require__("./node_modules/lodash-compat/internal/isHostObject.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash-compat/internal/isObjectLike.js");
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
	}
	
	module.exports = isNative;


/***/ },

/***/ "./node_modules/lodash-compat/lang/isFunction.js":
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/lodash-compat/lang/isObject.js");
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 which returns 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.exports = isFunction;


/***/ },

/***/ "./node_modules/lodash-compat/internal/isHostObject.js":
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	var isHostObject = (function() {
	  try {
	    Object({ 'toString': 0 } + '');
	  } catch(e) {
	    return function() { return false; };
	  }
	  return function(value) {
	    // IE < 9 presents many host objects as `Object` objects that can coerce
	    // to strings despite having improperly defined `toString` methods.
	    return typeof value.toString != 'function' && typeof (value + '') == 'string';
	  };
	}());
	
	module.exports = isHostObject;


/***/ },

/***/ "./node_modules/lodash-compat/internal/isObjectLike.js":
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },

/***/ "./node_modules/lodash-compat/internal/baseFlatten.js":
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__("./node_modules/lodash-compat/internal/arrayPush.js"),
	    isArguments = __webpack_require__("./node_modules/lodash-compat/lang/isArguments.js"),
	    isArray = __webpack_require__("./node_modules/lodash-compat/lang/isArray.js"),
	    isArrayLike = __webpack_require__("./node_modules/lodash-compat/internal/isArrayLike.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash-compat/internal/isObjectLike.js");
	
	/**
	 * The base implementation of `_.flatten` with added support for restricting
	 * flattening and specifying the start index.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {boolean} [isDeep] Specify a deep flatten.
	 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, isDeep, isStrict, result) {
	  result || (result = []);
	
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    if (isObjectLike(value) && isArrayLike(value) &&
	        (isStrict || isArray(value) || isArguments(value))) {
	      if (isDeep) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, isDeep, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },

/***/ "./node_modules/lodash-compat/internal/arrayPush.js":
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },

/***/ "./node_modules/lodash-compat/lang/isArguments.js":
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__("./node_modules/lodash-compat/internal/isArrayLike.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash-compat/internal/isObjectLike.js");
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.exports = isArguments;


/***/ },

/***/ "./node_modules/lodash-compat/internal/isArrayLike.js":
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__("./node_modules/lodash-compat/internal/getLength.js"),
	    isLength = __webpack_require__("./node_modules/lodash-compat/internal/isLength.js");
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ },

/***/ "./node_modules/lodash-compat/internal/getLength.js":
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__("./node_modules/lodash-compat/internal/baseProperty.js");
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },

/***/ "./node_modules/lodash-compat/internal/baseProperty.js":
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__("./node_modules/lodash-compat/internal/toObject.js");
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : toObject(object)[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },

/***/ "./node_modules/lodash-compat/internal/toObject.js":
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/lodash-compat/lang/isObject.js"),
	    isString = __webpack_require__("./node_modules/lodash-compat/lang/isString.js"),
	    support = __webpack_require__("./node_modules/lodash-compat/support.js");
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  if (support.unindexedChars && isString(value)) {
	    var index = -1,
	        length = value.length,
	        result = Object(value);
	
	    while (++index < length) {
	      result[index] = value.charAt(index);
	    }
	    return result;
	  }
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ },

/***/ "./node_modules/lodash-compat/lang/isString.js":
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__("./node_modules/lodash-compat/internal/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },

/***/ "./node_modules/lodash-compat/support.js":
/***/ function(module, exports) {

	/** Used for native method references. */
	var arrayProto = Array.prototype,
	    errorProto = Error.prototype,
	    objectProto = Object.prototype;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/**
	 * An object environment feature flags.
	 *
	 * @static
	 * @memberOf _
	 * @type Object
	 */
	var support = {};
	
	(function(x) {
	  var Ctor = function() { this.x = x; },
	      object = { '0': x, 'length': x },
	      props = [];
	
	  Ctor.prototype = { 'valueOf': x, 'y': x };
	  for (var key in new Ctor) { props.push(key); }
	
	  /**
	   * Detect if `name` or `message` properties of `Error.prototype` are
	   * enumerable by default (IE < 9, Safari < 5.1).
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.enumErrorProps = propertyIsEnumerable.call(errorProto, 'message') ||
	    propertyIsEnumerable.call(errorProto, 'name');
	
	  /**
	   * Detect if `prototype` properties are enumerable by default.
	   *
	   * Firefox < 3.6, Opera > 9.50 - Opera < 11.60, and Safari < 5.1
	   * (if the prototype or a property on the prototype has been set)
	   * incorrectly set the `[[Enumerable]]` value of a function's `prototype`
	   * property to `true`.
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.enumPrototypes = propertyIsEnumerable.call(Ctor, 'prototype');
	
	  /**
	   * Detect if properties shadowing those on `Object.prototype` are non-enumerable.
	   *
	   * In IE < 9 an object's own properties, shadowing non-enumerable ones,
	   * are made non-enumerable as well (a.k.a the JScript `[[DontEnum]]` bug).
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.nonEnumShadows = !/valueOf/.test(props);
	
	  /**
	   * Detect if own properties are iterated after inherited properties (IE < 9).
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.ownLast = props[0] != 'x';
	
	  /**
	   * Detect if `Array#shift` and `Array#splice` augment array-like objects
	   * correctly.
	   *
	   * Firefox < 10, compatibility modes of IE 8, and IE < 9 have buggy Array
	   * `shift()` and `splice()` functions that fail to remove the last element,
	   * `value[0]`, of array-like objects even though the "length" property is
	   * set to `0`. The `shift()` method is buggy in compatibility modes of IE 8,
	   * while `splice()` is buggy regardless of mode in IE < 9.
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.spliceObjects = (splice.call(object, 0, 1), !object[0]);
	
	  /**
	   * Detect lack of support for accessing string characters by index.
	   *
	   * IE < 8 can't access characters by index. IE 8 can only access characters
	   * by index on string literals, not string objects.
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.unindexedChars = ('x'[0] + Object('x')[0]) != 'xx';
	}(1, 0));
	
	module.exports = support;


/***/ },

/***/ "./node_modules/lodash-compat/internal/isLength.js":
/***/ function(module, exports) {

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },

/***/ "./node_modules/lodash-compat/lang/isArray.js":
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash-compat/internal/getNative.js"),
	    isLength = __webpack_require__("./node_modules/lodash-compat/internal/isLength.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash-compat/internal/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.exports = isArray;


/***/ },

/***/ "./node_modules/lodash-compat/internal/bindCallback.js":
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__("./node_modules/lodash-compat/utility/identity.js");
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ },

/***/ "./node_modules/lodash-compat/utility/identity.js":
/***/ function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },

/***/ "./node_modules/lodash-compat/object/keysIn.js":
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__("./node_modules/lodash-compat/internal/arrayEach.js"),
	    isArguments = __webpack_require__("./node_modules/lodash-compat/lang/isArguments.js"),
	    isArray = __webpack_require__("./node_modules/lodash-compat/lang/isArray.js"),
	    isFunction = __webpack_require__("./node_modules/lodash-compat/lang/isFunction.js"),
	    isIndex = __webpack_require__("./node_modules/lodash-compat/internal/isIndex.js"),
	    isLength = __webpack_require__("./node_modules/lodash-compat/internal/isLength.js"),
	    isObject = __webpack_require__("./node_modules/lodash-compat/lang/isObject.js"),
	    isString = __webpack_require__("./node_modules/lodash-compat/lang/isString.js"),
	    support = __webpack_require__("./node_modules/lodash-compat/support.js");
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/** Used to fix the JScript `[[DontEnum]]` bug. */
	var shadowProps = [
	  'constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable',
	  'toLocaleString', 'toString', 'valueOf'
	];
	
	/** Used for native method references. */
	var errorProto = Error.prototype,
	    objectProto = Object.prototype,
	    stringProto = String.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to avoid iterating over non-enumerable properties in IE < 9. */
	var nonEnumProps = {};
	nonEnumProps[arrayTag] = nonEnumProps[dateTag] = nonEnumProps[numberTag] = { 'constructor': true, 'toLocaleString': true, 'toString': true, 'valueOf': true };
	nonEnumProps[boolTag] = nonEnumProps[stringTag] = { 'constructor': true, 'toString': true, 'valueOf': true };
	nonEnumProps[errorTag] = nonEnumProps[funcTag] = nonEnumProps[regexpTag] = { 'constructor': true, 'toString': true };
	nonEnumProps[objectTag] = { 'constructor': true };
	
	arrayEach(shadowProps, function(key) {
	  for (var tag in nonEnumProps) {
	    if (hasOwnProperty.call(nonEnumProps, tag)) {
	      var props = nonEnumProps[tag];
	      props[key] = hasOwnProperty.call(props, key);
	    }
	  }
	});
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object) || isString(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      proto = (isFunction(Ctor) && Ctor.prototype) || objectProto,
	      isProto = proto === object,
	      result = Array(length),
	      skipIndexes = length > 0,
	      skipErrorProps = support.enumErrorProps && (object === errorProto || object instanceof Error),
	      skipProto = support.enumPrototypes && isFunction(object);
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  // lodash skips the `constructor` property when it infers it's iterating
	  // over a `prototype` object because IE < 9 can't set the `[[Enumerable]]`
	  // attribute of an existing property and the `constructor` property of a
	  // prototype defaults to non-enumerable.
	  for (var key in object) {
	    if (!(skipProto && key == 'prototype') &&
	        !(skipErrorProps && (key == 'message' || key == 'name')) &&
	        !(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  if (support.nonEnumShadows && object !== objectProto) {
	    var tag = object === stringProto ? stringTag : (object === errorProto ? errorTag : objToString.call(object)),
	        nonEnums = nonEnumProps[tag] || nonEnumProps[objectTag];
	
	    if (tag == objectTag) {
	      proto = objectProto;
	    }
	    length = shadowProps.length;
	    while (length--) {
	      key = shadowProps[length];
	      var nonEnum = nonEnums[key];
	      if (!(isProto && nonEnum) &&
	          (nonEnum ? hasOwnProperty.call(object, key) : object[key] !== proto[key])) {
	        result.push(key);
	      }
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },

/***/ "./node_modules/lodash-compat/internal/arrayEach.js":
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },

/***/ "./node_modules/lodash-compat/internal/isIndex.js":
/***/ function(module, exports) {

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ },

/***/ "./node_modules/lodash-compat/internal/pickByArray.js":
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__("./node_modules/lodash-compat/internal/toObject.js");
	
	/**
	 * A specialized version of `_.pick` which picks `object` properties specified
	 * by `props`.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property names to pick.
	 * @returns {Object} Returns the new object.
	 */
	function pickByArray(object, props) {
	  object = toObject(object);
	
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index];
	    if (key in object) {
	      result[key] = object[key];
	    }
	  }
	  return result;
	}
	
	module.exports = pickByArray;


/***/ },

/***/ "./node_modules/lodash-compat/internal/pickByCallback.js":
/***/ function(module, exports, __webpack_require__) {

	var baseForIn = __webpack_require__("./node_modules/lodash-compat/internal/baseForIn.js");
	
	/**
	 * A specialized version of `_.pick` which picks `object` properties `predicate`
	 * returns truthy for.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Object} Returns the new object.
	 */
	function pickByCallback(object, predicate) {
	  var result = {};
	  baseForIn(object, function(value, key, object) {
	    if (predicate(value, key, object)) {
	      result[key] = value;
	    }
	  });
	  return result;
	}
	
	module.exports = pickByCallback;


/***/ },

/***/ "./node_modules/lodash-compat/internal/baseForIn.js":
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__("./node_modules/lodash-compat/internal/baseFor.js"),
	    keysIn = __webpack_require__("./node_modules/lodash-compat/object/keysIn.js");
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	module.exports = baseForIn;


/***/ },

/***/ "./node_modules/lodash-compat/internal/baseFor.js":
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__("./node_modules/lodash-compat/internal/createBaseFor.js");
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },

/***/ "./node_modules/lodash-compat/internal/createBaseFor.js":
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__("./node_modules/lodash-compat/internal/toObject.js");
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },

/***/ "./node_modules/lodash-compat/function/restParam.js":
/***/ function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },

/***/ "./node_modules/lodash-compat/object/pick.js":
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__("./node_modules/lodash-compat/internal/baseFlatten.js"),
	    bindCallback = __webpack_require__("./node_modules/lodash-compat/internal/bindCallback.js"),
	    pickByArray = __webpack_require__("./node_modules/lodash-compat/internal/pickByArray.js"),
	    pickByCallback = __webpack_require__("./node_modules/lodash-compat/internal/pickByCallback.js"),
	    restParam = __webpack_require__("./node_modules/lodash-compat/function/restParam.js");
	
	/**
	 * Creates an object composed of the picked `object` properties. Property
	 * names may be specified as individual arguments or as arrays of property
	 * names. If `predicate` is provided it's invoked for each property of `object`
	 * picking the properties `predicate` returns truthy for. The predicate is
	 * bound to `thisArg` and invoked with three arguments: (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|...(string|string[])} [predicate] The function invoked per
	 *  iteration or property names to pick, specified as individual property
	 *  names or arrays of property names.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'user': 'fred', 'age': 40 };
	 *
	 * _.pick(object, 'user');
	 * // => { 'user': 'fred' }
	 *
	 * _.pick(object, _.isString);
	 * // => { 'user': 'fred' }
	 */
	var pick = restParam(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  return typeof props[0] == 'function'
	    ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	    : pickByArray(object, baseFlatten(props));
	});
	
	module.exports = pick;


/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/SplitHoverButton.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RSplitButton = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/RSplitButton.js");
	
	var _RSplitButton2 = _interopRequireDefault(_RSplitButton);
	
	var _DropdownButton = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/DropdownButton.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SplitHoverButton = (0, _DropdownButton.DropdownHoverButtonHOC)(_class = function (_React$Component) {
	  (0, _inherits3.default)(SplitHoverButton, _React$Component);
	
	  function SplitHoverButton() {
	    (0, _classCallCheck3.default)(this, SplitHoverButton);
	    return (0, _possibleConstructorReturn3.default)(this, (SplitHoverButton.__proto__ || (0, _getPrototypeOf2.default)(SplitHoverButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SplitHoverButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_RSplitButton2.default, (0, _extends3.default)({ open: this.props.open,
	        onToggle: this.props.onToggle
	      }, this.props.buttonProps));
	    }
	  }]);
	  return SplitHoverButton;
	}(_react2.default.Component)) || _class;
	
	exports.default = SplitHoverButton;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Tab.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tab = __webpack_require__("./node_modules/react-bootstrap/lib/Tab.js");
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _TabPane = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/TabPane.js");
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Tab2.default.Pane = _TabPane2.default;
	
	exports.default = _Tab2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Tab.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TabContainer = __webpack_require__("./node_modules/react-bootstrap/lib/TabContainer.js");
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__("./node_modules/react-bootstrap/lib/TabContent.js");
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _TabPane = __webpack_require__("./node_modules/react-bootstrap/lib/TabPane.js");
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _TabPane2['default'].propTypes, {
	
	  disabled: _propTypes2['default'].bool,
	
	  title: _propTypes2['default'].node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _propTypes2['default'].string
	});
	
	var Tab = function (_React$Component) {
	  (0, _inherits3['default'])(Tab, _React$Component);
	
	  function Tab() {
	    (0, _classCallCheck3['default'])(this, Tab);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tab.prototype.render = function render() {
	    var props = (0, _extends3['default'])({}, this.props);
	
	    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	
	    return _react2['default'].createElement(_TabPane2['default'], props);
	  };
	
	  return Tab;
	}(_react2['default'].Component);
	
	Tab.propTypes = propTypes;
	
	Tab.Container = _TabContainer2['default'];
	Tab.Content = _TabContent2['default'];
	Tab.Pane = _TabPane2['default'];
	
	exports['default'] = Tab;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/TabContent.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or any
	   * `<Transition>` component.
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any
	  })
	};
	
	var childContextTypes = {
	  $bs_tabContent: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	    activeKey: _propTypes2['default'].any,
	    mountOnEnter: _propTypes2['default'].bool,
	    unmountOnExit: _propTypes2['default'].bool,
	    onPaneEnter: _propTypes2['default'].func.isRequired,
	    onPaneExited: _propTypes2['default'].func.isRequired,
	    exiting: _propTypes2['default'].bool.isRequired
	  })
	};
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3['default'])(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    (0, _classCallCheck3['default'])(this, TabContent);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
	    _this.handlePaneExited = _this.handlePaneExited.bind(_this);
	
	    // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  TabContent.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit;
	
	
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        mountOnEnter: mountOnEnter,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({ activeKey: null, activeChild: null });
	    }
	  };
	
	  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    }
	
	    // It's possible that this child should be transitioning out.
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	
	    return true;
	  };
	
	  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  TabContent.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        className = _props2.className,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'className']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react2['default'].Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/TabPane.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__("./node_modules/react-prop-types/lib/elementType.js");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Fade = __webpack_require__("./node_modules/react-bootstrap/lib/Fade.js");
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _propTypes2['default'].any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or any `<Transition>`
	   * component.
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /** @private **/
	  id: _propTypes2['default'].string,
	
	  /** @private **/
	  'aria-labelledby': _propTypes2['default'].string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _propTypes2['default'].string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    getTabId: _propTypes2['default'].func,
	    getPaneId: _propTypes2['default'].func
	  }),
	  $bs_tabContent: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	    activeKey: _propTypes2['default'].any,
	    mountOnEnter: _propTypes2['default'].bool,
	    unmountOnExit: _propTypes2['default'].bool,
	    onPaneEnter: _propTypes2['default'].func.isRequired,
	    onPaneExited: _propTypes2['default'].func.isRequired,
	    exiting: _propTypes2['default'].bool.isRequired
	  })
	};
	
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2['default'].oneOf([null])
	};
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3['default'])(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    (0, _classCallCheck3['default'])(this, TabPane);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	
	    _this['in'] = false;
	    return _this;
	  }
	
	  TabPane.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  TabPane.prototype.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this['in']) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this['in']) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  TabPane.prototype.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    this['in'] = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  TabPane.prototype.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this['in'] = false;
	  };
	
	  TabPane.prototype.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  TabPane.prototype.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	
	    return this.props.eventKey === activeKey;
	  };
	
	  TabPane.prototype.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  TabPane.prototype.render = function render() {
	    var _props = this.props,
	        eventKey = _props.eventKey,
	        className = _props.className,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        propsMountOnEnter = _props.mountOnEnter,
	        propsUnmountOnExit = _props.unmountOnExit,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);
	    var _context = this.context,
	        tabContent = _context.$bs_tabContent,
	        tabContainer = _context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	
	    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade2['default'] : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'tabpanel',
	      'aria-hidden': !active,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	
	      return _react2['default'].createElement(
	        Transition,
	        {
	          'in': active && !exiting,
	          onEnter: (0, _createChainedFunction2['default'])(this.handleEnter, onEnter),
	          onEntering: onEntering,
	          onEntered: onEntered,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: (0, _createChainedFunction2['default'])(this.handleExited, onExited),
	          mountOnEnter: mountOnEnter,
	          unmountOnExit: unmountOnExit
	        },
	        pane
	      );
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react2['default'].Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/TabPane.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabPane = __webpack_require__("./node_modules/react-bootstrap/lib/TabPane.js");
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	var _isBrowser = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/isBrowser.js");
	
	var _isBrowser2 = _interopRequireDefault(_isBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3.default)(TabPane, _React$Component);
	
	  function TabPane() {
	    (0, _classCallCheck3.default)(this, TabPane);
	    return (0, _possibleConstructorReturn3.default)(this, (TabPane.__proto__ || (0, _getPrototypeOf2.default)(TabPane)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TabPane, [{
	    key: 'onEntering',
	    value: function onEntering() {
	      if ((0, _isBrowser2.default)()) {
	        if (window.hasOwnProperty('Rubix')) {
	          Rubix.redraw();
	        }
	      }
	
	      if (this.props.onEntering && typeof this.props.onEntering === 'function') {
	        this.props.onEntering();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props, {
	        onEntering: this.onEntering.bind(this)
	      });
	
	      return _react2.default.createElement(_TabPane2.default, props);
	    }
	  }]);
	  return TabPane;
	}(_react2.default.Component);
	
	exports.default = TabPane;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/TabContainer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TabContainer = __webpack_require__("./node_modules/react-bootstrap/lib/TabContainer.js");
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TabContainer2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/TabContent.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TabContent = __webpack_require__("./node_modules/react-bootstrap/lib/TabContent.js");
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TabContent2.default;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Table.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Table = __webpack_require__("./node_modules/react-bootstrap/lib/Table.js");
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Table = function (_React$Component) {
	  (0, _inherits3.default)(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck3.default)(this, Table);
	    return (0, _possibleConstructorReturn3.default)(this, (Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Table, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props, {
	        className: (0, _classnames2.default)(this.props.className, {
	          'table-collapsed': this.props.collapsed,
	          'table-middle-align': this.props.alignMiddle
	        })
	      });
	
	      delete props.collapsed;
	      delete props.alignMiddle;
	
	      return _react2.default.createElement(_Table2.default, props);
	    }
	  }]);
	  return Table;
	}(_react2.default.Component);
	
	exports.default = Table;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Table.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  striped: _propTypes2['default'].bool,
	  bordered: _propTypes2['default'].bool,
	  condensed: _propTypes2['default'].bool,
	  hover: _propTypes2['default'].bool,
	  responsive: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  bordered: false,
	  condensed: false,
	  hover: false,
	  responsive: false,
	  striped: false
	};
	
	var Table = function (_React$Component) {
	  (0, _inherits3['default'])(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck3['default'])(this, Table);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Table.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        striped = _props.striped,
	        bordered = _props.bordered,
	        condensed = _props.condensed,
	        hover = _props.hover,
	        responsive = _props.responsive,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));
	
	    var table = _react2['default'].createElement('table', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (responsive) {
	      return _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive') },
	        table
	      );
	    }
	
	    return table;
	  };
	
	  return Table;
	}(_react2['default'].Component);
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('table', Table);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Tabs.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tabs = __webpack_require__("./node_modules/react-bootstrap/lib/Tabs.js");
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Tabs2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Tabs.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__("./node_modules/react-prop-types/lib/isRequiredForA11y.js");
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__("./node_modules/uncontrollable/index.js");
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Nav = __webpack_require__("./node_modules/react-bootstrap/lib/Nav.js");
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__("./node_modules/react-bootstrap/lib/NavItem.js");
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _TabContainer = __webpack_require__("./node_modules/react-bootstrap/lib/TabContainer.js");
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__("./node_modules/react-bootstrap/lib/TabContent.js");
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _ValidComponentChildren = __webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js");
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabContainer = _TabContainer2['default'].ControlledComponent;
	
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2['default'].any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _propTypes2['default'].oneOf(['tabs', 'pills']),
	
	  animation: _propTypes2['default'].bool,
	
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey = void 0;
	  _ValidComponentChildren2['default'].forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3['default'])(Tabs, _React$Component);
	
	  function Tabs() {
	    (0, _classCallCheck3['default'])(this, Tabs);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tabs.prototype.renderTab = function renderTab(child) {
	    var _child$props = child.props,
	        title = _child$props.title,
	        eventKey = _child$props.eventKey,
	        disabled = _child$props.disabled,
	        tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _NavItem2['default'],
	      {
	        eventKey: eventKey,
	        disabled: disabled,
	        className: tabClassName
	      },
	      title
	    );
	  };
	
	  Tabs.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        onSelect = _props.onSelect,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        _props$activeKey = _props.activeKey,
	        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);
	
	
	    return _react2['default'].createElement(
	      TabContainer,
	      {
	        id: id,
	        activeKey: activeKey,
	        onSelect: onSelect,
	        className: className,
	        style: style
	      },
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _Nav2['default'],
	          (0, _extends3['default'])({}, props, {
	            role: 'tablist'
	          }),
	          _ValidComponentChildren2['default'].map(children, this.renderTab)
	        ),
	        _react2['default'].createElement(
	          _TabContent2['default'],
	          {
	            bsClass: bsClass,
	            animation: animation,
	            mountOnEnter: mountOnEnter,
	            unmountOnExit: unmountOnExit
	          },
	          children
	        )
	      )
	    );
	  };
	
	  return Tabs;
	}(_react2['default'].Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	exports['default'] = (0, _uncontrollable2['default'])(Tabs, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Nav.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__("./node_modules/keycode/index.js");
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__("./node_modules/react-prop-types/lib/all.js");
	
	var _all2 = _interopRequireDefault(_all);
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _createChainedFunction = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js");
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _propTypes2['default'].any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _propTypes2['default'].string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _propTypes2['default'].bool,
	
	  justified: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var justified = _ref.justified,
	        navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _propTypes2['default'].string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _propTypes2['default'].bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _propTypes2['default'].bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    onSelect: _propTypes2['default'].func
	  }),
	
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any,
	    onSelect: _propTypes2['default'].func.isRequired,
	    getTabId: _propTypes2['default'].func.isRequired,
	    getPaneId: _propTypes2['default'].func.isRequired
	  })
	};
	
	var Nav = function (_React$Component) {
	  (0, _inherits3['default'])(Nav, _React$Component);
	
	  function Nav() {
	    (0, _classCallCheck3['default'])(this, Nav);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    if (!this._needsRefocus) {
	      return;
	    }
	
	    this._needsRefocus = false;
	
	    var children = this.props.children;
	
	    var _getActiveProps = this.getActiveProps(),
	        activeKey = _getActiveProps.activeKey,
	        activeHref = _getActiveProps.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    });
	
	    var childrenArray = _ValidComponentChildren2['default'].toArray(children);
	    var activeChildIndex = childrenArray.indexOf(activeChild);
	
	    var childNodes = _reactDom2['default'].findDOMNode(this).children;
	    var activeNode = childNodes && childNodes[activeChildIndex];
	
	    if (!activeNode || !activeNode.firstChild) {
	      return;
	    }
	
	    activeNode.firstChild.focus();
	  };
	
	  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var nextActiveChild = void 0;
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.left:
	      case _keycode2['default'].codes.up:
	        nextActiveChild = this.getNextActiveChild(-1);
	        break;
	      case _keycode2['default'].codes.right:
	      case _keycode2['default'].codes.down:
	        nextActiveChild = this.getNextActiveChild(1);
	        break;
	      default:
	        // It was a different key; don't handle this keypress.
	        return;
	    }
	
	    event.preventDefault();
	
	    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
	      onSelect(nextActiveChild.props.eventKey);
	    }
	
	    this._needsRefocus = true;
	  };
	
	  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
	    var _this3 = this;
	
	    var children = this.props.children;
	
	    var validChildren = children.filter(function (child) {
	      return child.props.eventKey != null && !child.props.disabled;
	    });
	
	    var _getActiveProps2 = this.getActiveProps(),
	        activeKey = _getActiveProps2.activeKey,
	        activeHref = _getActiveProps2.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this3.isActive(child, activeKey, activeHref);
	    });
	
	    // This assumes the active child is not disabled.
	    var activeChildIndex = validChildren.indexOf(activeChild);
	    if (activeChildIndex === -1) {
	      // Something has gone wrong. Select the first valid child we can find.
	      return validChildren[0];
	    }
	
	    var nextIndex = activeChildIndex + offset;
	    var numValidChildren = validChildren.length;
	
	    if (nextIndex >= numValidChildren) {
	      nextIndex = 0;
	    } else if (nextIndex < 0) {
	      nextIndex = numValidChildren - 1;
	    }
	
	    return validChildren[nextIndex];
	  };
	
	  Nav.prototype.getActiveProps = function getActiveProps() {
	    var tabContainer = this.context.$bs_tabContainer;
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;
	
	      return tabContainer;
	    }
	
	    return this.props;
	  };
	
	  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
	    var props = _ref2.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
	    var _this4 = this;
	
	    if (!tabContainer && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props,
	        id = _child$props.id,
	        controls = _child$props['aria-controls'],
	        eventKey = _child$props.eventKey,
	        role = _child$props.role,
	        onKeyDown = _child$props.onKeyDown,
	        tabIndex = _child$props.tabIndex;
	
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      id = tabContainer.getTabId(eventKey);
	      controls = tabContainer.getPaneId(eventKey);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = (0, _createChainedFunction2['default'])(function (event) {
	        return _this4.handleTabKeyDown(onSelect, event);
	      }, onKeyDown);
	      tabIndex = active ? tabIndex : -1;
	    }
	
	    return {
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  Nav.prototype.render = function render() {
	    var _extends2,
	        _this5 = this;
	
	    var _props = this.props,
	        stacked = _props.stacked,
	        justified = _props.justified,
	        onSelect = _props.onSelect,
	        propsRole = _props.role,
	        propsNavbar = _props.navbar,
	        pullRight = _props.pullRight,
	        pullLeft = _props.pullLeft,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);
	
	
	    var tabContainer = this.context.$bs_tabContainer;
	    var role = propsRole || (tabContainer ? 'tablist' : null);
	
	    var _getActiveProps3 = this.getActiveProps(),
	        activeKey = _getActiveProps3.activeKey,
	        activeHref = _getActiveProps3.activeHref;
	
	    delete props.activeKey; // Accessed via this.getActiveProps().
	    delete props.activeHref; // Accessed via this.getActiveProps().
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
	
	    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	    var pullLeftClassName = void 0;
	    var pullRightClassName = void 0;
	
	    if (navbar) {
	      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	
	      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	    } else {
	      pullRightClassName = 'pull-right';
	      pullLeftClassName = 'pull-left';
	    }
	
	    classes[pullRightClassName] = pullRight;
	    classes[pullLeftClassName] = pullLeft;
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends4['default'])({}, elementProps, {
	        role: role,
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var active = _this5.isActive(child, activeKey, activeHref);
	        var childOnSelect = (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
	
	        return (0, _react.cloneElement)(child, (0, _extends4['default'])({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
	          active: active,
	          activeKey: activeKey,
	          activeHref: activeHref,
	          onSelect: childOnSelect
	        }));
	      })
	    );
	  };
	
	  return Nav;
	}(_react2['default'].Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Tag.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tag = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(Tag, _React$Component);
	
	  function Tag() {
	    (0, _classCallCheck3.default)(this, Tag);
	    return (0, _possibleConstructorReturn3.default)(this, (Tag.__proto__ || (0, _getPrototypeOf2.default)(Tag)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Tag, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          color = _props.color,
	          className = _props.className;
	
	      color = color || "darkgreen45";
	      var props = (0, _extends3.default)({}, this.props, {
	        href: this.props.href || "#",
	        className: (0, _classnames2.default)(className, {
	          'left-tag': true,
	          'fg-hover-white': true,
	          'bg-lightgray50': true,
	          'border-lightgray50': true,
	          'fg-text': true
	        }, 'border-hover-' + color, 'bg-hover-' + color)
	      });
	
	      delete props.color;
	
	      return _react2.default.createElement('a', props);
	    }
	  }]);
	  return Tag;
	}(_react2.default.Component), _class.propTypes = {
	  href: _react2.default.PropTypes.string,
	  color: _react2.default.PropTypes.string
	}, _temp);
	exports.default = Tag;

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Thumbnail.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Thumbnail = __webpack_require__("./node_modules/react-bootstrap/lib/Thumbnail.js");
	
	var _Thumbnail2 = _interopRequireDefault(_Thumbnail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Thumbnail2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Thumbnail.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__("./node_modules/react-bootstrap/lib/SafeAnchor.js");
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  src: _propTypes2['default'].string,
	  alt: _propTypes2['default'].string,
	  href: _propTypes2['default'].string
	};
	
	var Thumbnail = function (_React$Component) {
	  (0, _inherits3['default'])(Thumbnail, _React$Component);
	
	  function Thumbnail() {
	    (0, _classCallCheck3['default'])(this, Thumbnail);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Thumbnail.prototype.render = function render() {
	    var _props = this.props,
	        src = _props.src,
	        alt = _props.alt,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['src', 'alt', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var Component = elementProps.href ? _SafeAnchor2['default'] : 'div';
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement('img', { src: src, alt: alt }),
	      children && _react2['default'].createElement(
	        'div',
	        { className: 'caption' },
	        children
	      )
	    );
	  };
	
	  return Thumbnail;
	}(_react2['default'].Component);
	
	Thumbnail.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('thumbnail', Thumbnail);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Tooltip.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tooltip = __webpack_require__("./node_modules/react-bootstrap/lib/Tooltip.js");
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Tooltip2.default;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Tooltip.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__("./node_modules/react-prop-types/lib/isRequiredForA11y.js");
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Sets the direction the Tooltip is positioned towards.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Tooltip.
	   */
	  positionTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Tooltip.
	   */
	  positionLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * The "top" position value for the Tooltip arrow.
	   */
	  arrowOffsetTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Tooltip arrow.
	   */
	  arrowOffsetLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip = function (_React$Component) {
	  (0, _inherits3['default'])(Tooltip, _React$Component);
	
	  function Tooltip() {
	    (0, _classCallCheck3['default'])(this, Tooltip);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tooltip.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'), style: arrowStyle }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        children
	      )
	    );
	  };
	
	  return Tooltip;
	}(_react2['default'].Component);
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/@sketchpixy/rubix/lib/Well.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Well = __webpack_require__("./node_modules/react-bootstrap/lib/Well.js");
	
	var _Well2 = _interopRequireDefault(_Well);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Well = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(Well, _React$Component);
	
	  function Well() {
	    (0, _classCallCheck3.default)(this, Well);
	    return (0, _possibleConstructorReturn3.default)(this, (Well.__proto__ || (0, _getPrototypeOf2.default)(Well)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Well, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _extends3.default)({}, this.props);
	
	      if (props.hasOwnProperty('sm')) {
	        props.bsSize = 'sm';
	        delete props.sm;
	      }
	
	      if (props.hasOwnProperty('lg')) {
	        props.bsSize = 'lg';
	        delete props.lg;
	      }
	
	      if (props.hasOwnProperty('noMargin')) {
	        props.style = props.style || {};
	        props.style.margin = 0;
	      }
	
	      return _react2.default.createElement(_Well2.default, props);
	    }
	  }]);
	  return Well;
	}(_react2.default.Component), _class.propTypes = {
	  sm: _react2.default.PropTypes.bool,
	  lg: _react2.default.PropTypes.bool,
	  noMargin: _react2.default.PropTypes.bool
	}, _temp);
	exports.default = Well;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/Well.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Well = function (_React$Component) {
	  (0, _inherits3['default'])(Well, _React$Component);
	
	  function Well() {
	    (0, _classCallCheck3['default'])(this, Well);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Well.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Well;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('well', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Well));
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/utils/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ValidComponentChildren = exports.createChainedFunction = exports.bootstrapUtils = undefined;
	
	var _bootstrapUtils2 = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _bootstrapUtils = _interopRequireWildcard(_bootstrapUtils2);
	
	var _createChainedFunction2 = __webpack_require__("./node_modules/react-bootstrap/lib/utils/createChainedFunction.js");
	
	var _createChainedFunction3 = _interopRequireDefault(_createChainedFunction2);
	
	var _ValidComponentChildren2 = __webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js");
	
	var _ValidComponentChildren3 = _interopRequireDefault(_ValidComponentChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	exports.bootstrapUtils = _bootstrapUtils;
	exports.createChainedFunction = _createChainedFunction3['default'];
	exports.ValidComponentChildren = _ValidComponentChildren3['default'];

/***/ },

/***/ "./node_modules/roles/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Roles = undefined;
	
	var _roles = __webpack_require__("./node_modules/roles/lib/roles.js");
	
	var _roles2 = _interopRequireDefault(_roles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Roles = _roles2.default;

/***/ },

/***/ "./node_modules/roles/lib/roles.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var Meteor = Package.meteor.Meteor;
	var Mongo = Package.mongo.Mongo;
	var _Package$check = Package.check,
	    check = _Package$check.check,
	    Match = _Package$check.Match;
	
	
	var _ = __webpack_require__("./node_modules/lodash/lodash.js");
	
	/*
	 * Helpers
	 */
	var willChangeWithParent = function willChangeWithParent(object, key) {
	  if (!_.isObject(object)) {
	    return;
	  }
	  var willChange = false;
	  _.each(_.keys(object), function (modifyingKey) {
	    if (key && key.indexOf(modifyingKey) === 0) {
	      willChange = true;
	    }
	  });
	  return willChange;
	};
	
	var objectHasKey = function objectHasKey(object, key) {
	  var dotNotation = {};
	
	  (function recurse(obj, current) {
	    for (var key in obj) {
	      var value = obj[key];
	      var newKey = current ? current + "." + key : key; // joined key with dot
	      if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
	        recurse(value, newKey); // it's a nested object, so do it again
	      } else {
	        dotNotation[newKey] = value; // it's not an object, so set the property
	      }
	    }
	  })(object);
	
	  var keys = _.keys(dotNotation);
	  var newKeys = [];
	
	  _.each(keys, function (_key) {
	    var parts = _key.split('.');
	    var added = [];
	    _.each(parts, function (part) {
	      if (!isNaN(part)) {
	        part = '$';
	        added.push(part);
	      } else {
	        added.push(part);
	        newKeys.push(added.join('.'));
	      }
	    });
	  });
	
	  return _.includes(newKeys, key);
	};
	
	/**
	 * Init the variable
	 */
	var Roles = {};
	
	Roles.debug = false;
	
	/**
	 * Initialize variables
	 */
	Roles._roles = {};
	Roles._actions = [];
	Roles._helpers = [];
	Roles._usersCollection = Meteor.users;
	Roles._specialRoles = ['__loggedIn__', '__notAdmin__', '__notLoggedIn__', '__all__'];
	
	/**
	 * Old collection
	 */
	Roles._oldCollection = new Mongo.Collection('roles');
	
	/**
	 * Get the list of roles
	 */
	Roles.availableRoles = function () {
	  return _.difference(_.keys(this._roles), this._specialRoles);
	};
	
	/**
	 * Check if a user has a role
	 */
	Roles.userHasRole = function (userId, role) {
	  if (role == '__all__') return true;
	  if (role == '__notLoggedIn__' && !userId) return true;
	  if (role == '__default__' && userId) return true;
	  if (role == '__notAdmin__' && Roles._usersCollection.find({ _id: userId, roles: 'admin' }).count() === 0) return true;
	  return Roles._usersCollection.find({ _id: userId, roles: role }).count() > 0;
	};
	
	/**
	 * Creates a new action
	 */
	Roles.registerAction = function (name, adminAllow, adminDeny) {
	  check(name, String);
	  check(adminAllow, Match.Optional(Match.Any));
	  check(adminDeny, Match.Optional(Match.Any));
	
	  if (!_.includes(this._actions, name)) {
	    this._actions.push(name);
	  }
	
	  if (adminAllow) {
	    Roles.adminRole.allow(name, adminAllow);
	  }
	
	  if (adminDeny) {
	    Roles.adminRole.deny(name, adminDeny);
	  }
	};
	
	/**
	 * Creates a new helper
	 */
	Roles.registerHelper = function (name, adminHelper) {
	  check(name, String);
	  check(adminHelper, Match.Any);
	
	  if (!_.includes(this._helpers, name)) {
	    this._helpers.push(name);
	  }
	
	  if (adminHelper) {
	    Roles.adminRole.helper(name, adminHelper);
	  }
	};
	
	/**
	 * Constructs a new role
	 */
	Roles.Role = function (name) {
	  check(name, String);
	
	  if (!(this instanceof Roles.Role)) throw new Error('use "new" to construct a role');
	
	  if (_.has(Roles._roles, name)) throw new Error('"' + name + '" role is already defined');
	
	  this.name = name;
	  this.allowRules = {};
	  this.denyRules = {};
	  this.helpers = {};
	
	  Roles._roles[name] = this;
	};
	
	/**
	 * Adds allow properties to a role
	 */
	Roles.Role.prototype.allow = function (action, allow) {
	  check(action, String);
	  check(allow, Match.Any);
	
	  if (!_.includes(Roles._actions, action)) {
	    Roles.registerAction(action);
	  }
	
	  if (!_.isFunction(allow)) {
	    var clone = _.clone(allow);
	    allow = function allow() {
	      return clone;
	    };
	  }
	
	  this.allowRules[action] = this.allowRules[action] || [];
	  this.allowRules[action].push(allow);
	};
	
	/**
	 * Adds deny properties to a role
	 */
	Roles.Role.prototype.deny = function (action, deny) {
	  check(action, String);
	  check(deny, Match.Any);
	
	  if (!_.includes(Roles._actions, action)) {
	    Roles.registerAction(action);
	  }
	
	  if (!_.isFunction(deny)) {
	    var clone = _.clone(deny);
	    deny = function deny() {
	      return clone;
	    };
	  }
	
	  this.denyRules[action] = this.denyRules[action] || [];
	  this.denyRules[action].push(deny);
	};
	
	/**
	 * Adds a helper to a role
	 */
	Roles.Role.prototype.helper = function (helper, func) {
	  check(helper, String);
	  check(func, Match.Any);
	
	  if (!_.includes(Roles._helpers, helper)) {
	    Roles.registerHelper(helper);
	  }
	
	  if (!_.isFunction(func)) {
	    var value = _.clone(func);
	    func = function func() {
	      return value;
	    };
	  }
	
	  if (!this.helpers[helper]) {
	    this.helpers[helper] = [];
	  }
	
	  this.helpers[helper].push(func);
	};
	
	/**
	 * Get user roles
	 */
	Roles.getUserRoles = function (userId, includeSpecial) {
	  check(userId, Match.OneOf(String, null, undefined));
	  check(includeSpecial, Match.Optional(Boolean));
	  var object = Roles._usersCollection.findOne({ _id: userId }, { fields: { roles: 1 } });
	  var roles = object && object.roles || [];
	  if (includeSpecial) {
	    roles.push('__all__');
	    if (!userId) {
	      roles.push('__notLoggedIn__');
	    } else {
	      roles.push('__loggedIn__');
	      if (!_.includes(roles, 'admin')) {
	        roles.push('__notAdmin__');
	      }
	    }
	  }
	
	  return roles;
	};
	
	/**
	 * Calls a helper
	 */
	Roles.helper = function (userId, helper) {
	  var _this = this;
	
	  check(userId, Match.OneOf(String, null, undefined));
	  check(helper, String);
	  if (!_.includes(this._helpers, helper)) throw 'Helper "' + helper + '" is not defined';
	
	  var args = _.toArray(arguments).slice(2);
	  var context = { userId: userId };
	  var responses = [];
	  var roles = Roles.getUserRoles(userId, true);
	
	  _.each(roles, function (role) {
	    if (_this._roles[role] && _this._roles[role].helpers && _this._roles[role].helpers[helper]) {
	      var helpers = _this._roles[role].helpers[helper];
	      _.each(helpers, function (helper) {
	        responses.push(helper.apply(context, args));
	      });
	    }
	  });
	
	  return responses;
	};
	
	/**
	 * Returns if the user passes the allow check
	 */
	Roles.allow = function (userId, action) {
	  check(userId, Match.OneOf(String, null, undefined));
	  check(action, String);
	
	  var args = _.toArray(arguments).slice(2);
	  var self = this;
	  var context = { userId: userId };
	  var allowed = false;
	  var roles = Roles.getUserRoles(userId, true);
	
	  _.each(roles, function (role) {
	    if (!allowed && self._roles[role] && self._roles[role].allowRules && self._roles[role].allowRules[action]) {
	      _.each(self._roles[role].allowRules[action], function (func) {
	        var allow = func.apply(context, args);
	        if (allow === true) {
	          allowed = true;
	        }
	      });
	    }
	  });
	
	  return allowed;
	};
	
	/**
	 * Returns if the user has permission using deny and deny
	 */
	Roles.deny = function (userId, action) {
	  var _this2 = this;
	
	  check(userId, Match.OneOf(String, null, undefined));
	  check(action, String);
	
	  var args = _.toArray(arguments).slice(2);
	  var context = { userId: userId };
	  var denied = false;
	  var roles = Roles.getUserRoles(userId, true);
	
	  _.each(roles, function (role) {
	    if (!denied && _this2._roles[role] && _this2._roles[role].denyRules && _this2._roles[role].denyRules[action]) {
	      _.each(_this2._roles[role].denyRules[action], function (func) {
	        var denies = func.apply(context, args);
	        if (denies === true) {
	          denied = true;
	          if (Roles.debug) {
	            console.log("[" + action + "] denied for " + userId + " with role " + role);
	          }
	        }
	      });
	    }
	  });
	
	  return denied;
	};
	
	/**
	 * To check if a user has permisisons to execute an action
	 */
	Roles.userHasPermission = function () {
	  var allows = this.allow.apply(this, arguments);
	  var denies = this.deny.apply(this, arguments);
	  return allows === true && denies === false;
	};
	
	/**
	 * If the user doesn't has permission it will throw a error
	 */
	Roles.checkPermission = function () {
	  if (!this.userHasPermission.apply(this, arguments)) {
	    throw new Meteor.Error('unauthorized', 'The user has no permission to perform this action');
	  }
	};
	
	/**
	 * Adds helpers to users
	 */
	Roles.setUsersHelpers = function () {
	  Roles._usersCollection.helpers({
	    /**
	     * Returns the user roles
	     */
	    getRoles: function getRoles(includeSpecial) {
	      return Roles.getUserRoles(this._id, includeSpecial);
	    },
	    /**
	     * To check if the user has a role
	     */
	    hasRole: function hasRole(role) {
	      return Roles.userHasRole(this._id, role);
	    }
	  });
	};
	
	Roles.setUsersHelpers();
	
	/**
	 * The admin role, who recives the default actions.
	 */
	Roles.adminRole = new Roles.Role('admin');Roles._adminRole = Roles.adminRole; // Backwards compatibility
	/**
	 * All the logged in users users
	 */
	Roles.loggedInRole = new Roles.Role('__loggedIn__');Roles.defaultRole = Roles.loggedInRole; // Backwards compatibility
	/**
	 * The users that are not admins
	 */
	Roles.notAdminRole = new Roles.Role('__notAdmin__');
	/**
	 * The users that are not logged in
	 */
	Roles.notLoggedInRole = new Roles.Role('__notLoggedIn__');
	/**
	 * Always, no exception
	 */
	Roles.allRole = new Roles.Role('__all__');
	
	/**
	 * A Helper to attach actions to collections easily
	 */
	Mongo.Collection.prototype.attachRoles = function (name, dontAllow) {
	  Roles.registerAction(name + '.insert', !dontAllow);
	  Roles.registerAction(name + '.update', !dontAllow);
	  Roles.registerAction(name + '.remove', !dontAllow);
	  Roles.registerHelper(name + '.forbiddenFields', []);
	
	  this.allow({
	    insert: function insert(userId, doc) {
	      var allows = Roles.allow(userId, name + '.insert', userId, doc);
	      if (Roles.debug && !allows) {
	        console.log("[" + name + ".insert] not allowed for " + userId);
	      }
	
	      return allows;
	    },
	
	    update: function update(userId, doc, fields, modifier) {
	      var allows = Roles.allow(userId, name + '.update', userId, doc, fields, modifier);
	      if (Roles.debug && !allows) {
	        console.log("[" + name + ".update] not allowed for " + userId);
	      }
	
	      return allows;
	    },
	
	    remove: function remove(userId, doc) {
	      var allows = Roles.allow(userId, name + '.remove', userId, doc);
	      if (Roles.debug && !allows) {
	        console.log("[" + name + ".remove] not allowed for " + userId);
	      }
	
	      return allows;
	    }
	  });
	
	  this.deny({
	    insert: function insert(userId, doc) {
	      return Roles.deny(userId, name + '.insert', userId, doc);
	    },
	
	    update: function update(userId, doc, fields, modifier) {
	      return Roles.deny(userId, name + '.update', userId, doc, fields, modifier);
	    },
	
	    remove: function remove(userId, doc) {
	      return Roles.deny(userId, name + '.remove', userId, doc);
	    }
	  });
	
	  this.deny({
	    insert: function insert(userId, doc) {
	      var forbiddenFields = _.union.apply(this, Roles.helper(userId, name + '.forbiddenFields'));
	
	      for (var i in forbiddenFields) {
	        var field = forbiddenFields[i];
	        if (objectHasKey(doc, field)) {
	          if (Roles.debug) {
	            console.log("[" + name + ".forbiddenField] Field " + field + " is forbidden for " + userId);
	          }
	
	          return true;
	        }
	      }
	    },
	
	    update: function update(userId, doc, fields, modifier) {
	      var forbiddenFields = _.union.apply(this, Roles.helper(userId, name + '.forbiddenFields', doc._id));
	      var types = ['$inc', '$mul', '$rename', '$setOnInsert', '$set', '$unset', '$min', '$max', '$currentDate'];
	
	      // By some reason following for will itterate even through empty array. This will prevent unwanted habbit.
	      if (forbiddenFields.length === 0) {
	        return false;
	      }
	
	      for (var i in forbiddenFields) {
	        var field = forbiddenFields[i];
	        for (var j in types) {
	          var type = types[j];
	          if (objectHasKey(modifier[type], field)) {
	            if (Roles.debug) {
	              console.log("[" + name + ".forbiddenField] Field " + field + " is forbidden for " + userId);
	            }
	
	            return true;
	          }
	
	          if (willChangeWithParent(modifier[type], field)) {
	            if (Roles.debug) {
	              console.log("[" + name + ".forbiddenField] Field " + field + " is forbidden for " + userId + " is been changed by a parent object");
	            }
	
	            return true;
	          }
	        }
	      }
	    }
	  });
	};
	
	Roles.keys = {};
	
	/**
	 * Initialize the collection
	 */
	Roles.keys.collection = new Meteor.Collection('nicolaslopezj_roles_keys');
	
	/**
	 * Set the permissions
	 * Users can request keys just for them
	 */
	Roles.keys.collection.allow({
	  insert: function insert(userId, doc) {
	    return userId === doc.userId;
	  },
	  remove: function remove(userId, doc) {
	    return userId === doc.userId;
	  }
	});
	
	/**
	 * Requests a new key
	 * @param  {String} userId    Id of the userId
	 * @param  {Date}   expiresAt Date of expiration
	 * @return {String}           Id of the key
	 */
	Roles.keys.request = function (userId, expiresAt) {
	  check(userId, String);
	  var doc = {
	    userId: userId,
	    createdAt: new Date()
	  };
	  if (expiresAt) {
	    check(expiresAt, Date);
	    doc.expiresAt = expiresAt;
	  }
	  return this.collection.insert(doc);
	};
	
	/**
	 * Returns the userId of the specified key and deletes the key from the database
	 * @param  {String}  key
	 * @param  {Boolean} dontDelete True to leave the key in the database
	 * @return {String}             Id of the user
	 */
	Roles.keys.getUserId = function (key, dontDelete) {
	  check(key, String);
	  check(dontDelete, Match.Optional(Boolean));
	
	  var doc = this.collection.findOne({ _id: key, $or: [{ expiresAt: { $exists: false } }, { expiresAt: { $gte: new Date() } }] });
	  if (!doc) return;
	
	  if (!dontDelete) {
	    if (!doc.expiresAt) {
	      console.log('borrando por no tener expire at');
	      this.collection.remove({ _id: key });
	    } else {
	      if (moment(doc.expiresAt).isBefore(moment())) {
	        console.log('borrando por expire at ya pasó');
	        this.collection.remove({ _id: key });
	      }
	    }
	  }
	
	  return doc.userId;
	};
	
	if (Meteor.isServer) {
	  /**
	   * Publish user roles
	   */
	  Meteor.publish('nicolaslopezj_roles', function () {
	    return Meteor.users.find({ _id: this.userId }, { fields: { roles: 1 } });
	  });
	
	  /**
	   * Adds roles to a user
	   */
	  Roles.addUserToRoles = function (userId, roles) {
	    check(userId, String);
	    check(roles, Match.OneOf(String, Array));
	    if (!_.isArray(roles)) {
	      roles = [roles];
	    }
	
	    return Meteor.users.update({ _id: userId }, { $addToSet: { roles: { $each: roles } } });
	  };
	
	  /**
	   * Set user roles
	   */
	  Roles.setUserRoles = function (userId, roles) {
	    check(userId, String);
	    check(roles, Match.OneOf(String, Array));
	    if (!_.isArray(roles)) {
	      roles = [roles];
	    }
	
	    return Meteor.users.update({ _id: userId }, { $set: { roles: roles } });
	  };
	
	  /**
	   * Removes roles from a user
	   */
	  Roles.removeUserFromRoles = function (userId, roles) {
	    check(userId, String);
	    check(roles, Match.OneOf(String, Array));
	    if (!_.isArray(roles)) {
	      roles = [roles];
	    }
	
	    return Meteor.users.update({ _id: userId }, { $pullAll: { roles: roles } });
	  };
	
	  /**
	   * Requires a permission to run a resolver
	   */
	  var defaultOptions = {
	    returnNull: false,
	    showKey: true,
	    mapArgs: function mapArgs() {
	      for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return args;
	    }
	  };
	  Roles.action = function (action, userOptions) {
	    var options = _extends({}, defaultOptions, userOptions);
	    return function (target, key, descriptor) {
	      var fn = descriptor.value || target[key];
	      if (typeof fn !== 'function') {
	        throw new Error("@Roles.action decorator can only be applied to methods not: " + (typeof fn === "undefined" ? "undefined" : _typeof(fn)));
	      }
	
	      return {
	        configurable: true,
	        get: function get() {
	          var newFn = function newFn(root, params, context) {
	            for (var _len2 = arguments.length, other = Array(_len2 > 3 ? _len2 - 3 : 0), _key3 = 3; _key3 < _len2; _key3++) {
	              other[_key3 - 3] = arguments[_key3];
	            }
	
	            var args = options.mapArgs.apply(options, [root, params, context].concat(other));
	            var hasPermission = Roles.userHasPermission.apply(Roles, [context.userId, action].concat(_toConsumableArray(args)));
	            if (hasPermission) {
	              return fn.apply(undefined, [root, params, context].concat(other));
	            } else {
	              if (options.returnNull) {
	                return null;
	              } else {
	                var keyText = options.showKey ? " \"" + action + "\" in \"" + key + "\"" : '';
	                throw new Error("The user has no permission to perform the action" + keyText);
	              }
	            }
	          };
	          Object.defineProperty(this, key, {
	            value: newFn,
	            configurable: true,
	            writable: true
	          });
	          return newFn;
	        }
	      };
	    };
	  };
	}
	
	if (Meteor.isClient) {
	  var subscription = Meteor.subscribe('nicolaslopezj_roles');
	
	  /**
	   * Helper to check if roles are ready
	   */
	  Roles.isReady = function () {
	    return subscription.ready();
	  };
	}
	
	exports.default = Roles;

/***/ },

/***/ "./node_modules/lodash/lodash.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.5';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Gets the value at `key`, unless `key` is "__proto__".
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function safeGet(object, key) {
	    return key == '__proto__'
	      ? undefined
	      : object[key];
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	
	        return result;
	      }
	
	      if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	
	        return result;
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ },

/***/ "./src/universal/components/users/Account.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _uniformsBootstrap = __webpack_require__("./node_modules/uniforms-bootstrap3/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _users = __webpack_require__("./src/universal/collections/users/users.js");
	
	var _methods = __webpack_require__("./src/universal/collections/users/methods.js");
	
	var _datePickerField = __webpack_require__("./src/universal/components/fields/datePickerField.js");
	
	var _datePickerField2 = _interopRequireDefault(_datePickerField);
	
	var _mgfForm = __webpack_require__("./src/universal/components/common/mgfForm.js");
	
	var _mgfForm2 = _interopRequireDefault(_mgfForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	
	var AccountPage = function (_React$Component) {
		(0, _inherits3.default)(AccountPage, _React$Component);
	
		function AccountPage(props) {
			(0, _classCallCheck3.default)(this, AccountPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (AccountPage.__proto__ || (0, _getPrototypeOf2.default)(AccountPage)).call(this, props));
	
			_this.state = {};
	
			_this.user = Meteor.user();
	
			_this.ChangePasswordSchema = new SimpleSchema({
				"password": {
					type: String,
					label: "Mot de passe",
					min: 8,
					uniforms: {
						type: "password"
					}
				}
			});
	
			_this.ChangeCertificatSchema = new SimpleSchema({
				"certificat": {
					type: String,
					label: "Certificat",
					uniforms: {
						component: _datePickerField2.default
					}
				}
			});
	
			_this.ChangeLicenceSchema = new SimpleSchema({
				"licence": {
					type: String,
					label: "Licence",
					uniforms: {
						component: _datePickerField2.default
					}
				}
			});
			return _this;
		}
	
		(0, _createClass3.default)(AccountPage, [{
			key: 'handleSubmit',
			value: function handleSubmit(doc) {}
		}, {
			key: 'handlePasswordChange',
			value: function handlePasswordChange(doc) {
				return new _promise2.default(function (resolve, reject) {
					_methods.updatePassword.call(_lodash2.default.pick(doc, '_id', 'password'), function (error, result) {
						console.error(error);
						if (!error) {
							resolve(doc);
						}
						reject(error);
					});
				});
			}
		}, {
			key: 'handleCertificatChange',
			value: function handleCertificatChange(doc) {
				return new _promise2.default(function (resolve, reject) {
					_methods.updateCertificat.call(_lodash2.default.pick(doc, '_id', 'certificat'), function (error, result) {
						console.error(error);
						if (!error) {
							resolve(doc);
						}
						reject(error);
					});
				});
			}
		}, {
			key: 'handleLicenceChange',
			value: function handleLicenceChange(doc) {
				return new _promise2.default(function (resolve, reject) {
					_methods.updateLicence.call(_lodash2.default.pick(doc, '_id', 'licence'), function (error, result) {
						console.error(error);
						if (!error) {
							resolve(doc);
						}
						reject(error);
					});
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/account' },
								'Mon compte'
							)
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Modifier mon profil' },
						_react2.default.createElement(_mgfForm2.default, { schema: _users.UserSchema.omit('roles', 'roles.$'), collection: Meteor.users, model: this.user, onSubmit: this.handleSubmit.bind(this) })
					),
					_roles.Roles.userHasRole(this.user._id, 'pilot') && _react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Date d\'expiration du certificat m\xE9dical' },
						_react2.default.createElement(
							_mgfForm2.default,
							{ schema: this.ChangeCertificatSchema, collection: { label: "Date d'expiration" }, model: this.user, doSave: false, onSubmit: this.handleCertificatChange.bind(this) },
							_react2.default.createElement(_datePickerField2.default, { name: 'certificat', value: this.user.profile.certificat }),
							_react2.default.createElement(_uniformsBootstrap.SubmitField, { value: 'Changer' })
						)
					),
					_roles.Roles.userHasRole(this.user._id, 'pilot') && _react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Date d\'expiration de la licence de pilote' },
						_react2.default.createElement(
							_mgfForm2.default,
							{ schema: this.ChangeLicenceSchema, collection: { label: "Date d'expiration" }, model: this.user, doSave: false, onSubmit: this.handleLicenceChange.bind(this) },
							_react2.default.createElement(_datePickerField2.default, { name: 'licence', value: this.user.profile.licence }),
							_react2.default.createElement(_uniformsBootstrap.SubmitField, { value: 'Changer' })
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Mettre \xE0 jour mon mot de passe' },
						_react2.default.createElement(
							_mgfForm2.default,
							{ schema: this.ChangePasswordSchema, collection: { label: "Le mot de passe" }, model: this.user, doSave: false, onSubmit: this.handlePasswordChange.bind(this) },
							_react2.default.createElement(_uniformsBootstrap.TextField, { name: 'password' }),
							_react2.default.createElement(_uniformsBootstrap.SubmitField, { value: 'Changer' })
						)
					)
				);
			}
		}]);
		return AccountPage;
	}(_react2.default.Component);
	
	exports.default = AccountPage;
	
	
	AccountPage.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./node_modules/babel-runtime/core-js/promise.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/promise.js"), __esModule: true };

/***/ },

/***/ "./node_modules/core-js/library/fn/promise.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.object.to-string.js");
	__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
	__webpack_require__("./node_modules/core-js/library/modules/web.dom.iterable.js");
	__webpack_require__("./node_modules/core-js/library/modules/es6.promise.js");
	__webpack_require__("./node_modules/core-js/library/modules/es7.promise.finally.js");
	__webpack_require__("./node_modules/core-js/library/modules/es7.promise.try.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Promise;


/***/ },

/***/ "./node_modules/core-js/library/modules/es6.promise.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__("./node_modules/core-js/library/modules/_library.js");
	var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
	var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
	var classof = __webpack_require__("./node_modules/core-js/library/modules/_classof.js");
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
	var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");
	var anInstance = __webpack_require__("./node_modules/core-js/library/modules/_an-instance.js");
	var forOf = __webpack_require__("./node_modules/core-js/library/modules/_for-of.js");
	var speciesConstructor = __webpack_require__("./node_modules/core-js/library/modules/_species-constructor.js");
	var task = __webpack_require__("./node_modules/core-js/library/modules/_task.js").set;
	var microtask = __webpack_require__("./node_modules/core-js/library/modules/_microtask.js")();
	var newPromiseCapabilityModule = __webpack_require__("./node_modules/core-js/library/modules/_new-promise-capability.js");
	var perform = __webpack_require__("./node_modules/core-js/library/modules/_perform.js");
	var userAgent = __webpack_require__("./node_modules/core-js/library/modules/_user-agent.js");
	var promiseResolve = __webpack_require__("./node_modules/core-js/library/modules/_promise-resolve.js");
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__("./node_modules/core-js/library/modules/_wks.js")('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__("./node_modules/core-js/library/modules/_redefine-all.js")($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js")($Promise, PROMISE);
	__webpack_require__("./node_modules/core-js/library/modules/_set-species.js")(PROMISE);
	Wrapper = __webpack_require__("./node_modules/core-js/library/modules/_core.js")[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("./node_modules/core-js/library/modules/_iter-detect.js")(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },

/***/ "./node_modules/core-js/library/modules/_an-instance.js":
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_for-of.js":
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
	var call = __webpack_require__("./node_modules/core-js/library/modules/_iter-call.js");
	var isArrayIter = __webpack_require__("./node_modules/core-js/library/modules/_is-array-iter.js");
	var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
	var toLength = __webpack_require__("./node_modules/core-js/library/modules/_to-length.js");
	var getIterFn = __webpack_require__("./node_modules/core-js/library/modules/core.get-iterator-method.js");
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },

/***/ "./node_modules/core-js/library/modules/_species-constructor.js":
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
	var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");
	var SPECIES = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_task.js":
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
	var invoke = __webpack_require__("./node_modules/core-js/library/modules/_invoke.js");
	var html = __webpack_require__("./node_modules/core-js/library/modules/_html.js");
	var cel = __webpack_require__("./node_modules/core-js/library/modules/_dom-create.js");
	var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__("./node_modules/core-js/library/modules/_cof.js")(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_invoke.js":
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_microtask.js":
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
	var macrotask = __webpack_require__("./node_modules/core-js/library/modules/_task.js").set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__("./node_modules/core-js/library/modules/_cof.js")(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_new-promise-capability.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_perform.js":
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_user-agent.js":
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },

/***/ "./node_modules/core-js/library/modules/_promise-resolve.js":
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
	var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
	var newPromiseCapability = __webpack_require__("./node_modules/core-js/library/modules/_new-promise-capability.js");
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_redefine-all.js":
/***/ function(module, exports, __webpack_require__) {

	var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_set-species.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
	var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
	var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
	var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
	var SPECIES = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/es7.promise.finally.js":
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
	var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
	var speciesConstructor = __webpack_require__("./node_modules/core-js/library/modules/_species-constructor.js");
	var promiseResolve = __webpack_require__("./node_modules/core-js/library/modules/_promise-resolve.js");
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },

/***/ "./node_modules/core-js/library/modules/es7.promise.try.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	var newPromiseCapability = __webpack_require__("./node_modules/core-js/library/modules/_new-promise-capability.js");
	var perform = __webpack_require__("./node_modules/core-js/library/modules/_perform.js");
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },

/***/ "./node_modules/uniforms-bootstrap3/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AutoFields = __webpack_require__("./node_modules/uniforms-bootstrap3/AutoFields.js");
	
	Object.defineProperty(exports, 'AutoFields', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AutoFields).default;
	  }
	});
	
	var _AutoField = __webpack_require__("./node_modules/uniforms-bootstrap3/AutoField.js");
	
	Object.defineProperty(exports, 'AutoField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AutoField).default;
	  }
	});
	
	var _AutoForm = __webpack_require__("./node_modules/uniforms-bootstrap3/AutoForm.js");
	
	Object.defineProperty(exports, 'AutoForm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AutoForm).default;
	  }
	});
	
	var _BaseForm = __webpack_require__("./node_modules/uniforms-bootstrap3/BaseForm.js");
	
	Object.defineProperty(exports, 'BaseForm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BaseForm).default;
	  }
	});
	
	var _BoolField = __webpack_require__("./node_modules/uniforms-bootstrap3/BoolField.js");
	
	Object.defineProperty(exports, 'BoolField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BoolField).default;
	  }
	});
	
	var _DateField = __webpack_require__("./node_modules/uniforms-bootstrap3/DateField.js");
	
	Object.defineProperty(exports, 'DateField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DateField).default;
	  }
	});
	
	var _ErrorField = __webpack_require__("./node_modules/uniforms-bootstrap3/ErrorField.js");
	
	Object.defineProperty(exports, 'ErrorField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ErrorField).default;
	  }
	});
	
	var _ErrorsField = __webpack_require__("./node_modules/uniforms-bootstrap3/ErrorsField.js");
	
	Object.defineProperty(exports, 'ErrorsField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ErrorsField).default;
	  }
	});
	
	var _FormGroup = __webpack_require__("./node_modules/uniforms-bootstrap3/FormGroup.js");
	
	Object.defineProperty(exports, 'FormGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormGroup).default;
	  }
	});
	
	var _HiddenField = __webpack_require__("./node_modules/uniforms-bootstrap3/HiddenField.js");
	
	Object.defineProperty(exports, 'HiddenField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HiddenField).default;
	  }
	});
	
	var _ListAddField = __webpack_require__("./node_modules/uniforms-bootstrap3/ListAddField.js");
	
	Object.defineProperty(exports, 'ListAddField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListAddField).default;
	  }
	});
	
	var _ListDelField = __webpack_require__("./node_modules/uniforms-bootstrap3/ListDelField.js");
	
	Object.defineProperty(exports, 'ListDelField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListDelField).default;
	  }
	});
	
	var _ListField = __webpack_require__("./node_modules/uniforms-bootstrap3/ListField.js");
	
	Object.defineProperty(exports, 'ListField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListField).default;
	  }
	});
	
	var _ListItemField = __webpack_require__("./node_modules/uniforms-bootstrap3/ListItemField.js");
	
	Object.defineProperty(exports, 'ListItemField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListItemField).default;
	  }
	});
	
	var _LongTextField = __webpack_require__("./node_modules/uniforms-bootstrap3/LongTextField.js");
	
	Object.defineProperty(exports, 'LongTextField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LongTextField).default;
	  }
	});
	
	var _NestField = __webpack_require__("./node_modules/uniforms-bootstrap3/NestField.js");
	
	Object.defineProperty(exports, 'NestField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NestField).default;
	  }
	});
	
	var _NumField = __webpack_require__("./node_modules/uniforms-bootstrap3/NumField.js");
	
	Object.defineProperty(exports, 'NumField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NumField).default;
	  }
	});
	
	var _QuickForm = __webpack_require__("./node_modules/uniforms-bootstrap3/QuickForm.js");
	
	Object.defineProperty(exports, 'QuickForm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_QuickForm).default;
	  }
	});
	
	var _RadioField = __webpack_require__("./node_modules/uniforms-bootstrap3/RadioField.js");
	
	Object.defineProperty(exports, 'RadioField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RadioField).default;
	  }
	});
	
	var _SelectField = __webpack_require__("./node_modules/uniforms-bootstrap3/SelectField.js");
	
	Object.defineProperty(exports, 'SelectField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SelectField).default;
	  }
	});
	
	var _SubmitField = __webpack_require__("./node_modules/uniforms-bootstrap3/SubmitField.js");
	
	Object.defineProperty(exports, 'SubmitField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SubmitField).default;
	  }
	});
	
	var _TextField = __webpack_require__("./node_modules/uniforms-bootstrap3/TextField.js");
	
	Object.defineProperty(exports, 'TextField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextField).default;
	  }
	});
	
	var _ValidatedForm = __webpack_require__("./node_modules/uniforms-bootstrap3/ValidatedForm.js");
	
	Object.defineProperty(exports, 'ValidatedForm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ValidatedForm).default;
	  }
	});
	
	var _ValidatedQuickForm = __webpack_require__("./node_modules/uniforms-bootstrap3/ValidatedQuickForm.js");
	
	Object.defineProperty(exports, 'ValidatedQuickForm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ValidatedQuickForm).default;
	  }
	});
	
	var _gridClassName = __webpack_require__("./node_modules/uniforms-bootstrap3/gridClassName.js");
	
	Object.defineProperty(exports, 'gridClassName', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_gridClassName).default;
	  }
	});
	
	var _wrapField = __webpack_require__("./node_modules/uniforms-bootstrap3/wrapField.js");
	
	Object.defineProperty(exports, 'wrapField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_wrapField).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/AutoFields.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _AutoField = __webpack_require__("./node_modules/uniforms-bootstrap3/AutoField.js");
	
	var _AutoField2 = _interopRequireDefault(_AutoField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AutoFields = function AutoFields(_ref, _ref2) {
	    var schema = _ref2.uniforms.schema;
	    var autoField = _ref.autoField,
	        element = _ref.element,
	        fields = _ref.fields,
	        omitFields = _ref.omitFields,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['autoField', 'element', 'fields', 'omitFields']);
	    return (0, _react.createElement)(element, props, (fields || schema.getSubfields()).filter(function (field) {
	        return omitFields.indexOf(field) === -1;
	    }).map(function (field) {
	        return (0, _react.createElement)(autoField, { key: field, name: field });
	    }));
	};
	
	AutoFields.contextTypes = _AutoField2.default.contextTypes;
	
	AutoFields.propTypes = {
	    autoField: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    element: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	
	    fields: _propTypes2.default.arrayOf(_propTypes2.default.string),
	    omitFields: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	
	AutoFields.defaultProps = {
	    autoField: _AutoField2.default,
	    element: 'div',
	    omitFields: []
	};
	
	exports.default = AutoFields;

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/AutoField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _BaseField2 = __webpack_require__("./node_modules/uniforms/BaseField.js");
	
	var _BaseField3 = _interopRequireDefault(_BaseField2);
	
	var _invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _NumField = __webpack_require__("./node_modules/uniforms-bootstrap3/NumField.js");
	
	var _NumField2 = _interopRequireDefault(_NumField);
	
	var _BoolField = __webpack_require__("./node_modules/uniforms-bootstrap3/BoolField.js");
	
	var _BoolField2 = _interopRequireDefault(_BoolField);
	
	var _DateField = __webpack_require__("./node_modules/uniforms-bootstrap3/DateField.js");
	
	var _DateField2 = _interopRequireDefault(_DateField);
	
	var _ListField = __webpack_require__("./node_modules/uniforms-bootstrap3/ListField.js");
	
	var _ListField2 = _interopRequireDefault(_ListField);
	
	var _NestField = __webpack_require__("./node_modules/uniforms-bootstrap3/NestField.js");
	
	var _NestField2 = _interopRequireDefault(_NestField);
	
	var _TextField = __webpack_require__("./node_modules/uniforms-bootstrap3/TextField.js");
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _RadioField = __webpack_require__("./node_modules/uniforms-bootstrap3/RadioField.js");
	
	var _RadioField2 = _interopRequireDefault(_RadioField);
	
	var _SelectField = __webpack_require__("./node_modules/uniforms-bootstrap3/SelectField.js");
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AutoField = function (_BaseField) {
	    (0, _inherits3.default)(AutoField, _BaseField);
	
	    function AutoField() {
	        (0, _classCallCheck3.default)(this, AutoField);
	        return (0, _possibleConstructorReturn3.default)(this, (AutoField.__proto__ || Object.getPrototypeOf(AutoField)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(AutoField, [{
	        key: 'getChildContextName',
	        value: function getChildContextName() {
	            return this.context.uniforms.name;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var props = this.getFieldProps(undefined, { ensureValue: false });
	
	            if (props.component === undefined) {
	                if (props.allowedValues) {
	                    if (props.checkboxes && props.fieldType !== Array) {
	                        props.component = _RadioField2.default;
	                    } else {
	                        props.component = _SelectField2.default;
	                    }
	                } else {
	                    switch (props.fieldType) {
	                        case Date:
	                            props.component = _DateField2.default;break;
	                        case Array:
	                            props.component = _ListField2.default;break;
	                        case Number:
	                            props.component = _NumField2.default;break;
	                        case Object:
	                            props.component = _NestField2.default;break;
	                        case String:
	                            props.component = _TextField2.default;break;
	                        case Boolean:
	                            props.component = _BoolField2.default;break;
	                    }
	
	                    (0, _invariant2.default)(props.component, 'Unsupported field type: %s', props.fieldType.toString());
	                }
	            }
	
	            return (0, _react.createElement)(props.component, this.props);
	        }
	    }]);
	    return AutoField;
	}(_BaseField3.default);
	
	AutoField.displayName = 'AutoField';
	exports.default = AutoField;

/***/ },

/***/ "./node_modules/uniforms/BaseField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/slicedToArray.js");
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__("./node_modules/lodash/get.js");
	
	var _get2 = _interopRequireDefault(_get);
	
	var _invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isEqual = __webpack_require__("./node_modules/lodash/isEqual.js");
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _BaseForm = __webpack_require__("./node_modules/uniforms/BaseForm.js");
	
	var _BaseForm2 = _interopRequireDefault(_BaseForm);
	
	var _joinName = __webpack_require__("./node_modules/uniforms/joinName.js");
	
	var _joinName2 = _interopRequireDefault(_joinName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Used for calculating labels and placeholders.
	var flowingProp = function flowingProp(prop, schema, state, fallback) {
	    var propDisabled = prop === '' || prop === false;
	    var propSet = prop !== undefined;
	    var schemaDisabled = schema === '' || schema === false;
	    var schemaValue = schema === true || schema === undefined ? fallback : schema;
	    var stateDisabled = !state;
	
	    var value = propDisabled || !propSet && (schemaDisabled || stateDisabled) ? '' : propSet ? prop === true ? schemaDisabled ? '' : schemaValue : prop : schemaValue;
	
	    return [value, schemaValue];
	};
	
	var BaseField = function (_Component) {
	    (0, _inherits3.default)(BaseField, _Component);
	
	    function BaseField() {
	        (0, _classCallCheck3.default)(this, BaseField);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (BaseField.__proto__ || Object.getPrototypeOf(BaseField)).apply(this, arguments));
	
	        (0, _invariant2.default)(_this.context.uniforms, '<%s /> must be rendered within a form.', _this.constructor.displayName);
	
	        _this.options = {
	            ensureValue: true,
	            explicitInitialValue: false,
	            includeParent: false,
	            overrideValue: false
	        };
	
	        _this.randomId = _this.context.uniforms.randomId();
	
	        _this.findValue = _this.findValue.bind(_this);
	        _this.findField = _this.findField.bind(_this);
	        _this.findError = _this.findError.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(BaseField, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, _, _ref) {
	            var nextContext = _ref.uniforms;
	
	            var prevProps = this.props;
	            var prevContext = this.context.uniforms;
	
	            if (!(0, _isEqual2.default)(prevProps, nextProps)) {
	                return true;
	            }
	
	            var _nextContext$state = nextContext.state,
	                nextMap = _nextContext$state.changedMap,
	                nextState = (0, _objectWithoutProperties3.default)(_nextContext$state, ['changedMap']);
	            var _prevContext$state = prevContext.state,
	                prevMap = _prevContext$state.changedMap,
	                prevState = (0, _objectWithoutProperties3.default)(_prevContext$state, ['changedMap']);
	
	
	            if (!(0, _isEqual2.default)(prevState, nextState)) {
	                return true;
	            }
	
	            var prevName = (0, _joinName2.default)(prevContext.name, prevProps.name);
	            var nextName = (0, _joinName2.default)(nextContext.name, nextProps.name);
	
	            if (prevName !== nextName) {
	                return true;
	            }
	
	            if (!(0, _isEqual2.default)((0, _get2.default)(prevMap, prevName), (0, _get2.default)(nextMap, nextName))) {
	                return true;
	            }
	
	            // Fields which are using parent props, need to be updated when parent value change
	            if (this.options.includeParent && nextName.indexOf('.') !== -1) {
	                var prevParentValue = (0, _get2.default)(prevContext.model, prevName.replace(/(.+)\..+$/, '$1'));
	                var nextParentValue = (0, _get2.default)(nextContext.model, nextName.replace(/(.+)\..+$/, '$1'));
	
	                if (!(0, _isEqual2.default)(prevParentValue, nextParentValue)) {
	                    return true;
	                }
	            }
	
	            var prevValue = (0, _get2.default)(prevContext.model, prevName);
	            var nextValue = (0, _get2.default)(nextContext.model, nextName);
	
	            if (!(0, _isEqual2.default)(prevValue, nextValue)) {
	                return true;
	            }
	
	            if (prevContext.error !== nextContext.error) {
	                var prevError = prevContext.error && prevContext.schema.getError(prevName, prevContext.error);
	                var nextError = nextContext.error && nextContext.schema.getError(nextName, nextContext.error);
	
	                if (!(0, _isEqual2.default)(prevError, nextError)) {
	                    return true;
	                }
	
	                // Fields like List or Nest should update, whenever their children error has changed
	                if (nextValue === Object(nextValue) && !(nextValue instanceof Date)) {
	                    return true;
	                }
	            }
	
	            if (nextContext.schema !== prevContext.schema) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return {
	                uniforms: {
	                    name: this.getChildContextName(),
	                    error: this.getChildContextError(),
	                    model: this.getChildContextModel(),
	                    state: this.getChildContextState(),
	                    schema: this.getChildContextSchema(),
	                    onChange: this.getChildContextOnChange(),
	                    randomId: this.context.uniforms.randomId
	                }
	            };
	        }
	    }, {
	        key: 'getChildContextName',
	        value: function getChildContextName() {
	            return (0, _joinName2.default)(null, this.context.uniforms.name, this.props.name);
	        }
	    }, {
	        key: 'getChildContextError',
	        value: function getChildContextError() {
	            return this.context.uniforms.error;
	        }
	    }, {
	        key: 'getChildContextModel',
	        value: function getChildContextModel() {
	            return this.context.uniforms.model;
	        }
	    }, {
	        key: 'getChildContextState',
	        value: function getChildContextState() {
	            var state = this.context.uniforms.state;
	            var props = this.props;
	
	            var propagate = function propagate(name) {
	                return props[name] === undefined || props[name] === null ? state[name] : !!props[name];
	            };
	
	            return (0, _extends3.default)({}, state, {
	
	                label: propagate('label'),
	                disabled: propagate('disabled'),
	                placeholder: propagate('placeholder'),
	                showInlineError: propagate('showInlineError')
	            });
	        }
	    }, {
	        key: 'getChildContextSchema',
	        value: function getChildContextSchema() {
	            return this.context.uniforms.schema;
	        }
	    }, {
	        key: 'getChildContextOnChange',
	        value: function getChildContextOnChange() {
	            return this.context.uniforms.onChange;
	        }
	
	        // eslint-disable-next-line complexity
	
	    }, {
	        key: 'getFieldProps',
	        value: function getFieldProps(name, options) {
	            var context = this.context.uniforms;
	            var props = this.props;
	            var state = this.getChildContextState();
	
	            options = (0, _extends3.default)({}, this.options, options);
	
	            if (name === undefined) {
	                name = (0, _joinName2.default)(context.name, props.name);
	            }
	
	            var changed = !!(0, _get2.default)(context.state.changedMap, name);
	
	            var error = context.schema.getError(name, context.error);
	            var errorMessage = context.schema.getErrorMessage(name, context.error);
	            var field = context.schema.getField(name);
	            var fieldType = context.schema.getType(name);
	            var fields = context.schema.getSubfields(name);
	            var schemaProps = context.schema.getProps(name, (0, _extends3.default)({}, state, props));
	
	            var initialValue = options.explicitInitialValue ? context.schema.getInitialValue(name, props) : undefined;
	
	            var parent = options.includeParent && name.indexOf('.') !== -1 ? this.getFieldProps(name.replace(/(.+)\..+$/, '$1'), { includeParent: false }) : null;
	
	            var _flowingProp = flowingProp(props.label, schemaProps.label, state.label, ''),
	                _flowingProp2 = (0, _slicedToArray3.default)(_flowingProp, 2),
	                label = _flowingProp2[0],
	                none = _flowingProp2[1];
	
	            var _flowingProp3 = flowingProp(props.placeholder, schemaProps.placeholder, state.placeholder, label || none),
	                _flowingProp4 = (0, _slicedToArray3.default)(_flowingProp3, 1),
	                placeholder = _flowingProp4[0];
	
	            var value = void 0;
	            if (props.value === undefined || options.overrideValue) {
	                value = (0, _get2.default)(context.model, name);
	
	                if (value === undefined && !changed && !options.explicitInitialValue) {
	                    value = context.schema.getInitialValue(name, props);
	                }
	            }
	
	            // This prevents (un)controlled input change warning.
	            // More info: https://fb.me/react-controlled-components.
	            if (value === undefined && options.ensureValue) {
	                value = '';
	            }
	
	            return (0, _extends3.default)({
	                // 0. Constant props.
	                findError: this.findError,
	                findField: this.findField,
	                findValue: this.findValue,
	                id: this.randomId
	
	            }, state, {
	
	                // 2. Calculated field props.
	                changed: changed,
	                error: error,
	                errorMessage: errorMessage,
	                field: field,
	                fieldType: fieldType,
	                fields: fields,
	                onChange: function onChange(value) {
	                    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : name;
	                    return context.onChange(key, value);
	                },
	                parent: parent,
	                value: value
	
	            }, options.explicitInitialValue && { initialValue: initialValue }, schemaProps, props, (options.explicitInitialValue || options.overrideValue) && { value: value }, {
	
	                // 6. Calculated _special_ field props.
	                label: label,
	                name: name,
	                placeholder: placeholder
	            });
	        }
	    }, {
	        key: 'findError',
	        value: function findError(name) {
	            return this.context.uniforms.schema.getError(name, this.context.uniforms.error);
	        }
	    }, {
	        key: 'findField',
	        value: function findField(name) {
	            return this.context.uniforms.schema.getField(name);
	        }
	    }, {
	        key: 'findValue',
	        value: function findValue(name) {
	            return (0, _get2.default)(this.context.uniforms.model, name);
	        }
	    }]);
	    return BaseField;
	}(_react.Component);
	
	BaseField.displayName = 'Field';
	BaseField.contextTypes = _BaseForm2.default.childContextTypes;
	BaseField.childContextTypes = _BaseForm2.default.childContextTypes;
	exports.default = BaseField;
	BaseField.propTypes =  false ? {
	    id: _propTypes2.default.string,
	
	    name: _propTypes2.default.string.isRequired,
	    disabled: _propTypes2.default.bool,
	
	    label: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.node]),
	    placeholder: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])
	} : {};

/***/ },

/***/ "./node_modules/lodash/get.js":
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__("./node_modules/lodash/_baseGet.js");
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },

/***/ "./node_modules/lodash/_baseGet.js":
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__("./node_modules/lodash/_castPath.js"),
	    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },

/***/ "./node_modules/lodash/_castPath.js":
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isKey = __webpack_require__("./node_modules/lodash/_isKey.js"),
	    stringToPath = __webpack_require__("./node_modules/lodash/_stringToPath.js"),
	    toString = __webpack_require__("./node_modules/lodash/toString.js");
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },

/***/ "./node_modules/lodash/isArray.js":
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },

/***/ "./node_modules/lodash/_isKey.js":
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },

/***/ "./node_modules/lodash/isSymbol.js":
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },

/***/ "./node_modules/lodash/_stringToPath.js":
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__("./node_modules/lodash/_memoizeCapped.js");
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },

/***/ "./node_modules/lodash/_memoizeCapped.js":
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__("./node_modules/lodash/memoize.js");
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },

/***/ "./node_modules/lodash/memoize.js":
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__("./node_modules/lodash/_MapCache.js");
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },

/***/ "./node_modules/lodash/_MapCache.js":
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__("./node_modules/lodash/_mapCacheClear.js"),
	    mapCacheDelete = __webpack_require__("./node_modules/lodash/_mapCacheDelete.js"),
	    mapCacheGet = __webpack_require__("./node_modules/lodash/_mapCacheGet.js"),
	    mapCacheHas = __webpack_require__("./node_modules/lodash/_mapCacheHas.js"),
	    mapCacheSet = __webpack_require__("./node_modules/lodash/_mapCacheSet.js");
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },

/***/ "./node_modules/lodash/_mapCacheClear.js":
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__("./node_modules/lodash/_Hash.js"),
	    ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js"),
	    Map = __webpack_require__("./node_modules/lodash/_Map.js");
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },

/***/ "./node_modules/lodash/_Hash.js":
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__("./node_modules/lodash/_hashClear.js"),
	    hashDelete = __webpack_require__("./node_modules/lodash/_hashDelete.js"),
	    hashGet = __webpack_require__("./node_modules/lodash/_hashGet.js"),
	    hashHas = __webpack_require__("./node_modules/lodash/_hashHas.js"),
	    hashSet = __webpack_require__("./node_modules/lodash/_hashSet.js");
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },

/***/ "./node_modules/lodash/_hashClear.js":
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },

/***/ "./node_modules/lodash/_nativeCreate.js":
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js");
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },

/***/ "./node_modules/lodash/_getNative.js":
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__("./node_modules/lodash/_baseIsNative.js"),
	    getValue = __webpack_require__("./node_modules/lodash/_getValue.js");
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },

/***/ "./node_modules/lodash/_baseIsNative.js":
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__("./node_modules/lodash/isFunction.js"),
	    isMasked = __webpack_require__("./node_modules/lodash/_isMasked.js"),
	    isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
	    toSource = __webpack_require__("./node_modules/lodash/_toSource.js");
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },

/***/ "./node_modules/lodash/isFunction.js":
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    isObject = __webpack_require__("./node_modules/lodash/isObject.js");
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },

/***/ "./node_modules/lodash/isObject.js":
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },

/***/ "./node_modules/lodash/_isMasked.js":
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__("./node_modules/lodash/_coreJsData.js");
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },

/***/ "./node_modules/lodash/_coreJsData.js":
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },

/***/ "./node_modules/lodash/_toSource.js":
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },

/***/ "./node_modules/lodash/_getValue.js":
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },

/***/ "./node_modules/lodash/_hashDelete.js":
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },

/***/ "./node_modules/lodash/_hashGet.js":
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },

/***/ "./node_modules/lodash/_hashHas.js":
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },

/***/ "./node_modules/lodash/_hashSet.js":
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },

/***/ "./node_modules/lodash/_ListCache.js":
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__("./node_modules/lodash/_listCacheClear.js"),
	    listCacheDelete = __webpack_require__("./node_modules/lodash/_listCacheDelete.js"),
	    listCacheGet = __webpack_require__("./node_modules/lodash/_listCacheGet.js"),
	    listCacheHas = __webpack_require__("./node_modules/lodash/_listCacheHas.js"),
	    listCacheSet = __webpack_require__("./node_modules/lodash/_listCacheSet.js");
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },

/***/ "./node_modules/lodash/_listCacheClear.js":
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },

/***/ "./node_modules/lodash/_listCacheDelete.js":
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },

/***/ "./node_modules/lodash/_assocIndexOf.js":
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__("./node_modules/lodash/eq.js");
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },

/***/ "./node_modules/lodash/eq.js":
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },

/***/ "./node_modules/lodash/_listCacheGet.js":
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },

/***/ "./node_modules/lodash/_listCacheHas.js":
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },

/***/ "./node_modules/lodash/_listCacheSet.js":
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },

/***/ "./node_modules/lodash/_Map.js":
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
	    root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },

/***/ "./node_modules/lodash/_mapCacheDelete.js":
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },

/***/ "./node_modules/lodash/_getMapData.js":
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__("./node_modules/lodash/_isKeyable.js");
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },

/***/ "./node_modules/lodash/_isKeyable.js":
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },

/***/ "./node_modules/lodash/_mapCacheGet.js":
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },

/***/ "./node_modules/lodash/_mapCacheHas.js":
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },

/***/ "./node_modules/lodash/_mapCacheSet.js":
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },

/***/ "./node_modules/lodash/toString.js":
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__("./node_modules/lodash/_baseToString.js");
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },

/***/ "./node_modules/lodash/_baseToString.js":
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
	    arrayMap = __webpack_require__("./node_modules/lodash/_arrayMap.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },

/***/ "./node_modules/lodash/_arrayMap.js":
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },

/***/ "./node_modules/lodash/_toKey.js":
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },

/***/ "./node_modules/lodash/isEqual.js":
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__("./node_modules/lodash/_baseIsEqual.js");
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },

/***/ "./node_modules/lodash/_baseIsEqual.js":
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__("./node_modules/lodash/_baseIsEqualDeep.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },

/***/ "./node_modules/lodash/_baseIsEqualDeep.js":
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__("./node_modules/lodash/_Stack.js"),
	    equalArrays = __webpack_require__("./node_modules/lodash/_equalArrays.js"),
	    equalByTag = __webpack_require__("./node_modules/lodash/_equalByTag.js"),
	    equalObjects = __webpack_require__("./node_modules/lodash/_equalObjects.js"),
	    getTag = __webpack_require__("./node_modules/lodash/_getTag.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isBuffer = __webpack_require__("./node_modules/lodash/isBuffer.js"),
	    isTypedArray = __webpack_require__("./node_modules/lodash/isTypedArray.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },

/***/ "./node_modules/lodash/_Stack.js":
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js"),
	    stackClear = __webpack_require__("./node_modules/lodash/_stackClear.js"),
	    stackDelete = __webpack_require__("./node_modules/lodash/_stackDelete.js"),
	    stackGet = __webpack_require__("./node_modules/lodash/_stackGet.js"),
	    stackHas = __webpack_require__("./node_modules/lodash/_stackHas.js"),
	    stackSet = __webpack_require__("./node_modules/lodash/_stackSet.js");
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },

/***/ "./node_modules/lodash/_stackClear.js":
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js");
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },

/***/ "./node_modules/lodash/_stackDelete.js":
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },

/***/ "./node_modules/lodash/_stackGet.js":
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },

/***/ "./node_modules/lodash/_stackHas.js":
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },

/***/ "./node_modules/lodash/_stackSet.js":
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js"),
	    Map = __webpack_require__("./node_modules/lodash/_Map.js"),
	    MapCache = __webpack_require__("./node_modules/lodash/_MapCache.js");
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },

/***/ "./node_modules/lodash/_equalArrays.js":
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__("./node_modules/lodash/_SetCache.js"),
	    arraySome = __webpack_require__("./node_modules/lodash/_arraySome.js"),
	    cacheHas = __webpack_require__("./node_modules/lodash/_cacheHas.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },

/***/ "./node_modules/lodash/_SetCache.js":
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__("./node_modules/lodash/_MapCache.js"),
	    setCacheAdd = __webpack_require__("./node_modules/lodash/_setCacheAdd.js"),
	    setCacheHas = __webpack_require__("./node_modules/lodash/_setCacheHas.js");
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },

/***/ "./node_modules/lodash/_setCacheAdd.js":
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },

/***/ "./node_modules/lodash/_setCacheHas.js":
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },

/***/ "./node_modules/lodash/_arraySome.js":
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },

/***/ "./node_modules/lodash/_cacheHas.js":
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },

/***/ "./node_modules/lodash/_equalByTag.js":
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
	    Uint8Array = __webpack_require__("./node_modules/lodash/_Uint8Array.js"),
	    eq = __webpack_require__("./node_modules/lodash/eq.js"),
	    equalArrays = __webpack_require__("./node_modules/lodash/_equalArrays.js"),
	    mapToArray = __webpack_require__("./node_modules/lodash/_mapToArray.js"),
	    setToArray = __webpack_require__("./node_modules/lodash/_setToArray.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },

/***/ "./node_modules/lodash/_Uint8Array.js":
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },

/***/ "./node_modules/lodash/_mapToArray.js":
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },

/***/ "./node_modules/lodash/_setToArray.js":
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },

/***/ "./node_modules/lodash/_equalObjects.js":
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__("./node_modules/lodash/_getAllKeys.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },

/***/ "./node_modules/lodash/_getAllKeys.js":
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__("./node_modules/lodash/_baseGetAllKeys.js"),
	    getSymbols = __webpack_require__("./node_modules/lodash/_getSymbols.js"),
	    keys = __webpack_require__("./node_modules/lodash/keys.js");
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },

/***/ "./node_modules/lodash/_baseGetAllKeys.js":
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__("./node_modules/lodash/_arrayPush.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js");
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },

/***/ "./node_modules/lodash/_arrayPush.js":
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },

/***/ "./node_modules/lodash/_getSymbols.js":
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__("./node_modules/lodash/_arrayFilter.js"),
	    stubArray = __webpack_require__("./node_modules/lodash/stubArray.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },

/***/ "./node_modules/lodash/_arrayFilter.js":
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },

/***/ "./node_modules/lodash/stubArray.js":
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },

/***/ "./node_modules/lodash/keys.js":
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__("./node_modules/lodash/_arrayLikeKeys.js"),
	    baseKeys = __webpack_require__("./node_modules/lodash/_baseKeys.js"),
	    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js");
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },

/***/ "./node_modules/lodash/_arrayLikeKeys.js":
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__("./node_modules/lodash/_baseTimes.js"),
	    isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isBuffer = __webpack_require__("./node_modules/lodash/isBuffer.js"),
	    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js"),
	    isTypedArray = __webpack_require__("./node_modules/lodash/isTypedArray.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },

/***/ "./node_modules/lodash/_baseTimes.js":
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },

/***/ "./node_modules/lodash/isArguments.js":
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__("./node_modules/lodash/_baseIsArguments.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },

/***/ "./node_modules/lodash/_baseIsArguments.js":
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },

/***/ "./node_modules/lodash/isBuffer.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("./node_modules/lodash/_root.js"),
	    stubFalse = __webpack_require__("./node_modules/lodash/stubFalse.js");
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ },

/***/ "./node_modules/lodash/stubFalse.js":
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },

/***/ "./node_modules/lodash/_isIndex.js":
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },

/***/ "./node_modules/lodash/isTypedArray.js":
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__("./node_modules/lodash/_baseIsTypedArray.js"),
	    baseUnary = __webpack_require__("./node_modules/lodash/_baseUnary.js"),
	    nodeUtil = __webpack_require__("./node_modules/lodash/_nodeUtil.js");
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },

/***/ "./node_modules/lodash/_baseIsTypedArray.js":
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    isLength = __webpack_require__("./node_modules/lodash/isLength.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },

/***/ "./node_modules/lodash/isLength.js":
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },

/***/ "./node_modules/lodash/_baseUnary.js":
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },

/***/ "./node_modules/lodash/_nodeUtil.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__("./node_modules/lodash/_freeGlobal.js");
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ },

/***/ "./node_modules/lodash/_baseKeys.js":
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__("./node_modules/lodash/_isPrototype.js"),
	    nativeKeys = __webpack_require__("./node_modules/lodash/_nativeKeys.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },

/***/ "./node_modules/lodash/_isPrototype.js":
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },

/***/ "./node_modules/lodash/_nativeKeys.js":
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__("./node_modules/lodash/_overArg.js");
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },

/***/ "./node_modules/lodash/isArrayLike.js":
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__("./node_modules/lodash/isFunction.js"),
	    isLength = __webpack_require__("./node_modules/lodash/isLength.js");
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },

/***/ "./node_modules/lodash/_getTag.js":
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__("./node_modules/lodash/_DataView.js"),
	    Map = __webpack_require__("./node_modules/lodash/_Map.js"),
	    Promise = __webpack_require__("./node_modules/lodash/_Promise.js"),
	    Set = __webpack_require__("./node_modules/lodash/_Set.js"),
	    WeakMap = __webpack_require__("./node_modules/lodash/_WeakMap.js"),
	    baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    toSource = __webpack_require__("./node_modules/lodash/_toSource.js");
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },

/***/ "./node_modules/lodash/_DataView.js":
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
	    root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },

/***/ "./node_modules/lodash/_Promise.js":
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
	    root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },

/***/ "./node_modules/lodash/_Set.js":
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
	    root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },

/***/ "./node_modules/lodash/_WeakMap.js":
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
	    root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },

/***/ "./node_modules/uniforms/BaseForm.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cloneDeep = __webpack_require__("./node_modules/lodash/cloneDeep.js");
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _get = __webpack_require__("./node_modules/lodash/get.js");
	
	var _get2 = _interopRequireDefault(_get);
	
	var _set = __webpack_require__("./node_modules/lodash/set.js");
	
	var _set2 = _interopRequireDefault(_set);
	
	var _changedKeys = __webpack_require__("./node_modules/uniforms/changedKeys.js");
	
	var _changedKeys2 = _interopRequireDefault(_changedKeys);
	
	var _createSchemaBridge = __webpack_require__("./node_modules/uniforms/createSchemaBridge.js");
	
	var _createSchemaBridge2 = _interopRequireDefault(_createSchemaBridge);
	
	var _randomIds = __webpack_require__("./node_modules/uniforms/randomIds.js");
	
	var _randomIds2 = _interopRequireDefault(_randomIds);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BaseForm = function (_Component) {
	    (0, _inherits3.default)(BaseForm, _Component);
	
	    function BaseForm() {
	        (0, _classCallCheck3.default)(this, BaseForm);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).apply(this, arguments));
	
	        _this.state = { bridge: (0, _createSchemaBridge2.default)(_this.props.schema), changed: null, changedMap: {}, resetCount: 0 };
	
	        _this.delayId = false;
	        _this.randomId = (0, _randomIds2.default)(_this.props.id);
	
	        _this.onReset = _this.reset = _this.onReset.bind(_this);
	        _this.onChange = _this.change = _this.onChange.bind(_this);
	        _this.onSubmit = _this.submit = _this.onSubmit.bind(_this);
	
	        // TODO: It shouldn't be here
	        var getModel = _this.getModel.bind(_this);
	        _this.getModel = function () {
	            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	            var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getModel(mode);
	            return mode !== null && _this.props.modelTransform ? _this.props.modelTransform(mode, model) : model;
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(BaseForm, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return {
	                uniforms: {
	                    name: this.getChildContextName(),
	                    error: this.getChildContextError(),
	                    model: this.getChildContextModel(),
	                    state: this.getChildContextState(),
	                    schema: this.getChildContextSchema(),
	                    onChange: this.getChildContextOnChange(),
	                    randomId: this.randomId
	                }
	            };
	        }
	    }, {
	        key: 'getChildContextName',
	        value: function getChildContextName() {
	            return [];
	        }
	    }, {
	        key: 'getChildContextError',
	        value: function getChildContextError() {
	            return this.props.error;
	        }
	    }, {
	        key: 'getChildContextModel',
	        value: function getChildContextModel() {
	            return this.getModel('form');
	        }
	    }, {
	        key: 'getChildContextState',
	        value: function getChildContextState() {
	            return {
	                changed: !!this.state.changed,
	                changedMap: this.state.changedMap,
	
	                label: !!this.props.label,
	                disabled: !!this.props.disabled,
	                placeholder: !!this.props.placeholder,
	                showInlineError: !!this.props.showInlineError
	            };
	        }
	    }, {
	        key: 'getChildContextSchema',
	        value: function getChildContextSchema() {
	            return this.state.bridge;
	        }
	    }, {
	        key: 'getChildContextOnChange',
	        value: function getChildContextOnChange() {
	            return this.onChange;
	        }
	    }, {
	        key: 'getModel',
	        value: function getModel() /* mode */{
	            return this.props.model;
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            this.setState(function () {
	                return {};
	            }, function () {
	                return _this2.setState(function () {
	                    return { changed: false, changedMap: {} };
	                });
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var schema = _ref.schema;
	
	            if (this.props.schema !== schema) {
	                this.setState(function () {
	                    return { bridge: (0, _createSchemaBridge2.default)(schema) };
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('form', this.getNativeFormProps());
	        }
	    }, {
	        key: 'getChangedKeys',
	        value: function getChangedKeys(root, valueA, valueB) {
	            return (0, _changedKeys2.default)(root, valueA, valueB);
	        }
	    }, {
	        key: 'getNativeFormProps',
	        value: function getNativeFormProps() {
	            var _props = this.props,
	                autosave = _props.autosave,
	                autosaveDelay = _props.autosaveDelay,
	                disabled = _props.disabled,
	                error = _props.error,
	                label = _props.label,
	                model = _props.model,
	                modelTransform = _props.modelTransform,
	                onChange = _props.onChange,
	                onSubmit = _props.onSubmit,
	                onSubmitFailure = _props.onSubmitFailure,
	                onSubmitSuccess = _props.onSubmitSuccess,
	                placeholder = _props.placeholder,
	                schema = _props.schema,
	                showInlineError = _props.showInlineError,
	                props = (0, _objectWithoutProperties3.default)(_props, ['autosave', 'autosaveDelay', 'disabled', 'error', 'label', 'model', 'modelTransform', 'onChange', 'onSubmit', 'onSubmitFailure', 'onSubmitSuccess', 'placeholder', 'schema', 'showInlineError']);
	
	
	            return (0, _extends3.default)({}, props, {
	
	                onSubmit: this.onSubmit,
	
	                key: 'reset-' + this.state.resetCount
	            });
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange(key, value) {
	            var _this3 = this;
	
	            // Do not set `changed` before componentDidMount
	            if (this.state.changed !== null) {
	                this.state.changed = true;
	                this.getChangedKeys(key, value, (0, _get2.default)(this.getModel(), key)).forEach(function (key) {
	                    return _this3.setState(function (state) {
	                        return { changedMap: (0, _set2.default)((0, _cloneDeep2.default)(state.changedMap), key, {}) };
	                    });
	                });
	            }
	
	            if (this.props.onChange) {
	                this.props.onChange(key, value);
	            }
	
	            // Do not call `onSubmit` before componentDidMount
	            if (this.state.changed !== null && this.props.autosave) {
	                if (this.delayId) {
	                    this.delayId = clearTimeout(this.delayId);
	                }
	
	                if (this.props.autosaveDelay > 0) {
	                    this.delayId = setTimeout(this.onSubmit, this.props.autosaveDelay);
	                } else {
	                    this.onSubmit();
	                }
	            }
	        }
	    }, {
	        key: 'onReset',
	        value: function onReset() {
	            this.setState(function (state) {
	                return { changed: false, changedMap: {}, resetCount: state.resetCount + 1 };
	            });
	        }
	    }, {
	        key: 'onSubmit',
	        value: function onSubmit(event) {
	            if (event) {
	                event.preventDefault();
	                event.stopPropagation();
	            }
	
	            return Promise.resolve(this.props.onSubmit && this.props.onSubmit(this.getModel('submit'))).then(this.props.onSubmitSuccess, this.props.onSubmitFailure);
	        }
	    }]);
	    return BaseForm;
	}(_react.Component);
	
	BaseForm.displayName = 'Form';
	BaseForm.defaultProps = {
	    model: {},
	    label: true,
	
	    autosave: false,
	    autosaveDelay: 0,
	
	    noValidate: true
	};
	BaseForm.childContextTypes = {
	    uniforms: _propTypes2.default.shape({
	        name: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	
	        error: _propTypes2.default.object,
	        model: _propTypes2.default.object.isRequired,
	
	        schema: _propTypes2.default.shape({
	            getError: _propTypes2.default.func.isRequired,
	            getErrorMessage: _propTypes2.default.func.isRequired,
	            getErrorMessages: _propTypes2.default.func.isRequired,
	            getField: _propTypes2.default.func.isRequired,
	            getInitialValue: _propTypes2.default.func.isRequired,
	            getProps: _propTypes2.default.func.isRequired,
	            getSubfields: _propTypes2.default.func.isRequired,
	            getType: _propTypes2.default.func.isRequired,
	            getValidator: _propTypes2.default.func.isRequired
	        }).isRequired,
	
	        state: _propTypes2.default.shape({
	            changed: _propTypes2.default.bool.isRequired,
	            changedMap: _propTypes2.default.object.isRequired,
	
	            label: _propTypes2.default.bool.isRequired,
	            disabled: _propTypes2.default.bool.isRequired,
	            placeholder: _propTypes2.default.bool.isRequired,
	            showInlineError: _propTypes2.default.bool.isRequired
	        }).isRequired,
	
	        onChange: _propTypes2.default.func.isRequired,
	        randomId: _propTypes2.default.func.isRequired
	    }).isRequired
	};
	exports.default = BaseForm;
	BaseForm.propTypes =  false ? {
	    error: _propTypes2.default.object,
	    model: _propTypes2.default.object,
	    schema: _propTypes2.default.any.isRequired,
	
	    modelTransform: _propTypes2.default.func,
	
	    onChange: _propTypes2.default.func,
	    onSubmit: _propTypes2.default.func,
	    onSubmitFailure: _propTypes2.default.func,
	    onSubmitSuccess: _propTypes2.default.func,
	
	    label: _propTypes2.default.bool,
	    disabled: _propTypes2.default.bool,
	    placeholder: _propTypes2.default.bool,
	    showInlineError: _propTypes2.default.bool,
	
	    autosave: _propTypes2.default.bool,
	    autosaveDelay: _propTypes2.default.number
	} : {};

/***/ },

/***/ "./node_modules/lodash/cloneDeep.js":
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__("./node_modules/lodash/_baseClone.js");
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ },

/***/ "./node_modules/lodash/_baseClone.js":
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__("./node_modules/lodash/_Stack.js"),
	    arrayEach = __webpack_require__("./node_modules/lodash/_arrayEach.js"),
	    assignValue = __webpack_require__("./node_modules/lodash/_assignValue.js"),
	    baseAssign = __webpack_require__("./node_modules/lodash/_baseAssign.js"),
	    baseAssignIn = __webpack_require__("./node_modules/lodash/_baseAssignIn.js"),
	    cloneBuffer = __webpack_require__("./node_modules/lodash/_cloneBuffer.js"),
	    copyArray = __webpack_require__("./node_modules/lodash/_copyArray.js"),
	    copySymbols = __webpack_require__("./node_modules/lodash/_copySymbols.js"),
	    copySymbolsIn = __webpack_require__("./node_modules/lodash/_copySymbolsIn.js"),
	    getAllKeys = __webpack_require__("./node_modules/lodash/_getAllKeys.js"),
	    getAllKeysIn = __webpack_require__("./node_modules/lodash/_getAllKeysIn.js"),
	    getTag = __webpack_require__("./node_modules/lodash/_getTag.js"),
	    initCloneArray = __webpack_require__("./node_modules/lodash/_initCloneArray.js"),
	    initCloneByTag = __webpack_require__("./node_modules/lodash/_initCloneByTag.js"),
	    initCloneObject = __webpack_require__("./node_modules/lodash/_initCloneObject.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isBuffer = __webpack_require__("./node_modules/lodash/isBuffer.js"),
	    isMap = __webpack_require__("./node_modules/lodash/isMap.js"),
	    isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
	    isSet = __webpack_require__("./node_modules/lodash/isSet.js"),
	    keys = __webpack_require__("./node_modules/lodash/keys.js");
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	
	    return result;
	  }
	
	  if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	
	    return result;
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },

/***/ "./node_modules/lodash/_arrayEach.js":
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },

/***/ "./node_modules/lodash/_assignValue.js":
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__("./node_modules/lodash/_baseAssignValue.js"),
	    eq = __webpack_require__("./node_modules/lodash/eq.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },

/***/ "./node_modules/lodash/_baseAssignValue.js":
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__("./node_modules/lodash/_defineProperty.js");
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },

/***/ "./node_modules/lodash/_defineProperty.js":
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js");
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },

/***/ "./node_modules/lodash/_baseAssign.js":
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__("./node_modules/lodash/_copyObject.js"),
	    keys = __webpack_require__("./node_modules/lodash/keys.js");
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },

/***/ "./node_modules/lodash/_copyObject.js":
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__("./node_modules/lodash/_assignValue.js"),
	    baseAssignValue = __webpack_require__("./node_modules/lodash/_baseAssignValue.js");
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },

/***/ "./node_modules/lodash/_baseAssignIn.js":
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__("./node_modules/lodash/_copyObject.js"),
	    keysIn = __webpack_require__("./node_modules/lodash/keysIn.js");
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },

/***/ "./node_modules/lodash/keysIn.js":
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__("./node_modules/lodash/_arrayLikeKeys.js"),
	    baseKeysIn = __webpack_require__("./node_modules/lodash/_baseKeysIn.js"),
	    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js");
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },

/***/ "./node_modules/lodash/_baseKeysIn.js":
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
	    isPrototype = __webpack_require__("./node_modules/lodash/_isPrototype.js"),
	    nativeKeysIn = __webpack_require__("./node_modules/lodash/_nativeKeysIn.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },

/***/ "./node_modules/lodash/_nativeKeysIn.js":
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },

/***/ "./node_modules/lodash/_cloneBuffer.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ },

/***/ "./node_modules/lodash/_copyArray.js":
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },

/***/ "./node_modules/lodash/_copySymbols.js":
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__("./node_modules/lodash/_copyObject.js"),
	    getSymbols = __webpack_require__("./node_modules/lodash/_getSymbols.js");
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },

/***/ "./node_modules/lodash/_copySymbolsIn.js":
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__("./node_modules/lodash/_copyObject.js"),
	    getSymbolsIn = __webpack_require__("./node_modules/lodash/_getSymbolsIn.js");
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },

/***/ "./node_modules/lodash/_getSymbolsIn.js":
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__("./node_modules/lodash/_arrayPush.js"),
	    getPrototype = __webpack_require__("./node_modules/lodash/_getPrototype.js"),
	    getSymbols = __webpack_require__("./node_modules/lodash/_getSymbols.js"),
	    stubArray = __webpack_require__("./node_modules/lodash/stubArray.js");
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },

/***/ "./node_modules/lodash/_getAllKeysIn.js":
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__("./node_modules/lodash/_baseGetAllKeys.js"),
	    getSymbolsIn = __webpack_require__("./node_modules/lodash/_getSymbolsIn.js"),
	    keysIn = __webpack_require__("./node_modules/lodash/keysIn.js");
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },

/***/ "./node_modules/lodash/_initCloneArray.js":
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },

/***/ "./node_modules/lodash/_initCloneByTag.js":
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__("./node_modules/lodash/_cloneArrayBuffer.js"),
	    cloneDataView = __webpack_require__("./node_modules/lodash/_cloneDataView.js"),
	    cloneRegExp = __webpack_require__("./node_modules/lodash/_cloneRegExp.js"),
	    cloneSymbol = __webpack_require__("./node_modules/lodash/_cloneSymbol.js"),
	    cloneTypedArray = __webpack_require__("./node_modules/lodash/_cloneTypedArray.js");
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },

/***/ "./node_modules/lodash/_cloneArrayBuffer.js":
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__("./node_modules/lodash/_Uint8Array.js");
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },

/***/ "./node_modules/lodash/_cloneDataView.js":
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__("./node_modules/lodash/_cloneArrayBuffer.js");
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },

/***/ "./node_modules/lodash/_cloneRegExp.js":
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },

/***/ "./node_modules/lodash/_cloneSymbol.js":
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js");
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },

/***/ "./node_modules/lodash/_cloneTypedArray.js":
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__("./node_modules/lodash/_cloneArrayBuffer.js");
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },

/***/ "./node_modules/lodash/_initCloneObject.js":
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__("./node_modules/lodash/_baseCreate.js"),
	    getPrototype = __webpack_require__("./node_modules/lodash/_getPrototype.js"),
	    isPrototype = __webpack_require__("./node_modules/lodash/_isPrototype.js");
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },

/***/ "./node_modules/lodash/_baseCreate.js":
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/lodash/isObject.js");
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },

/***/ "./node_modules/lodash/isMap.js":
/***/ function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__("./node_modules/lodash/_baseIsMap.js"),
	    baseUnary = __webpack_require__("./node_modules/lodash/_baseUnary.js"),
	    nodeUtil = __webpack_require__("./node_modules/lodash/_nodeUtil.js");
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ },

/***/ "./node_modules/lodash/_baseIsMap.js":
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__("./node_modules/lodash/_getTag.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ },

/***/ "./node_modules/lodash/isSet.js":
/***/ function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__("./node_modules/lodash/_baseIsSet.js"),
	    baseUnary = __webpack_require__("./node_modules/lodash/_baseUnary.js"),
	    nodeUtil = __webpack_require__("./node_modules/lodash/_nodeUtil.js");
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ },

/***/ "./node_modules/lodash/_baseIsSet.js":
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__("./node_modules/lodash/_getTag.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ },

/***/ "./node_modules/lodash/set.js":
/***/ function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__("./node_modules/lodash/_baseSet.js");
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;


/***/ },

/***/ "./node_modules/lodash/_baseSet.js":
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__("./node_modules/lodash/_assignValue.js"),
	    castPath = __webpack_require__("./node_modules/lodash/_castPath.js"),
	    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js"),
	    isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
	    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ },

/***/ "./node_modules/uniforms/changedKeys.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = changedKeys;
	
	var _isEqual = __webpack_require__("./node_modules/lodash/isEqual.js");
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _xorWith = __webpack_require__("./node_modules/lodash/xorWith.js");
	
	var _xorWith2 = _interopRequireDefault(_xorWith);
	
	var _joinName = __webpack_require__("./node_modules/uniforms/joinName.js");
	
	var _joinName2 = _interopRequireDefault(_joinName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function changedKeys(root, valueA, valueB) {
	    if (valueA === Object(valueA) && !(valueA instanceof Date)) {
	        if (valueB) {
	            var pairsA = void 0;
	            var pairsB = void 0;
	
	            if (Array.isArray(valueA)) {
	                pairsA = valueA.map(function (value, index) {
	                    return [value, index];
	                });
	                pairsB = valueB.map(function (value, index) {
	                    return [value, index];
	                });
	            } else {
	                pairsA = Object.keys(valueA).map(function (key) {
	                    return [valueA[key], key];
	                });
	                pairsB = Object.keys(valueB).map(function (key) {
	                    return [valueB[key], key];
	                });
	            }
	
	            var changed = (0, _xorWith2.default)(pairsA, pairsB, _isEqual2.default).map(function (pair) {
	                return (0, _joinName2.default)(root, pair[1]);
	            });
	
	            if (changed.length) {
	                changed.unshift(root);
	            }
	
	            return changed;
	        }
	
	        return [root].concat(Object.keys(valueA).map(function (key) {
	            return (0, _joinName2.default)(root, key);
	        }));
	    }
	
	    return (0, _isEqual2.default)(valueA, valueB) ? [] : [root];
	}

/***/ },

/***/ "./node_modules/lodash/xorWith.js":
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__("./node_modules/lodash/_arrayFilter.js"),
	    baseRest = __webpack_require__("./node_modules/lodash/_baseRest.js"),
	    baseXor = __webpack_require__("./node_modules/lodash/_baseXor.js"),
	    isArrayLikeObject = __webpack_require__("./node_modules/lodash/isArrayLikeObject.js"),
	    last = __webpack_require__("./node_modules/lodash/last.js");
	
	/**
	 * This method is like `_.xor` except that it accepts `comparator` which is
	 * invoked to compare elements of `arrays`. The order of result values is
	 * determined by the order they occur in the arrays. The comparator is invoked
	 * with two arguments: (arrVal, othVal).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	 *
	 * _.xorWith(objects, others, _.isEqual);
	 * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	 */
	var xorWith = baseRest(function(arrays) {
	  var comparator = last(arrays);
	  comparator = typeof comparator == 'function' ? comparator : undefined;
	  return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	});
	
	module.exports = xorWith;


/***/ },

/***/ "./node_modules/lodash/_baseRest.js":
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__("./node_modules/lodash/identity.js"),
	    overRest = __webpack_require__("./node_modules/lodash/_overRest.js"),
	    setToString = __webpack_require__("./node_modules/lodash/_setToString.js");
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },

/***/ "./node_modules/lodash/identity.js":
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },

/***/ "./node_modules/lodash/_overRest.js":
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__("./node_modules/lodash/_apply.js");
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },

/***/ "./node_modules/lodash/_apply.js":
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },

/***/ "./node_modules/lodash/_setToString.js":
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__("./node_modules/lodash/_baseSetToString.js"),
	    shortOut = __webpack_require__("./node_modules/lodash/_shortOut.js");
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },

/***/ "./node_modules/lodash/_baseSetToString.js":
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__("./node_modules/lodash/constant.js"),
	    defineProperty = __webpack_require__("./node_modules/lodash/_defineProperty.js"),
	    identity = __webpack_require__("./node_modules/lodash/identity.js");
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },

/***/ "./node_modules/lodash/constant.js":
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },

/***/ "./node_modules/lodash/_shortOut.js":
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },

/***/ "./node_modules/lodash/_baseXor.js":
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__("./node_modules/lodash/_baseDifference.js"),
	    baseFlatten = __webpack_require__("./node_modules/lodash/_baseFlatten.js"),
	    baseUniq = __webpack_require__("./node_modules/lodash/_baseUniq.js");
	
	/**
	 * The base implementation of methods like `_.xor`, without support for
	 * iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of values.
	 */
	function baseXor(arrays, iteratee, comparator) {
	  var length = arrays.length;
	  if (length < 2) {
	    return length ? baseUniq(arrays[0]) : [];
	  }
	  var index = -1,
	      result = Array(length);
	
	  while (++index < length) {
	    var array = arrays[index],
	        othIndex = -1;
	
	    while (++othIndex < length) {
	      if (othIndex != index) {
	        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	      }
	    }
	  }
	  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	}
	
	module.exports = baseXor;


/***/ },

/***/ "./node_modules/lodash/_baseDifference.js":
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__("./node_modules/lodash/_SetCache.js"),
	    arrayIncludes = __webpack_require__("./node_modules/lodash/_arrayIncludes.js"),
	    arrayIncludesWith = __webpack_require__("./node_modules/lodash/_arrayIncludesWith.js"),
	    arrayMap = __webpack_require__("./node_modules/lodash/_arrayMap.js"),
	    baseUnary = __webpack_require__("./node_modules/lodash/_baseUnary.js"),
	    cacheHas = __webpack_require__("./node_modules/lodash/_cacheHas.js");
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },

/***/ "./node_modules/lodash/_arrayIncludes.js":
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__("./node_modules/lodash/_baseIndexOf.js");
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },

/***/ "./node_modules/lodash/_baseIndexOf.js":
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__("./node_modules/lodash/_baseFindIndex.js"),
	    baseIsNaN = __webpack_require__("./node_modules/lodash/_baseIsNaN.js"),
	    strictIndexOf = __webpack_require__("./node_modules/lodash/_strictIndexOf.js");
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },

/***/ "./node_modules/lodash/_baseFindIndex.js":
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },

/***/ "./node_modules/lodash/_baseIsNaN.js":
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },

/***/ "./node_modules/lodash/_strictIndexOf.js":
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },

/***/ "./src/styles/main.scss":
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/resolve-url-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/styles/main.scss");
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("./node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./main.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./main.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ "./node_modules/lodash/_baseFlatten.js":
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__("./node_modules/lodash/_arrayPush.js"),
	    isFlattenable = __webpack_require__("./node_modules/lodash/_isFlattenable.js");
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },

/***/ "./node_modules/lodash/_isFlattenable.js":
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
	    isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js");
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },

/***/ "./node_modules/lodash/_baseUniq.js":
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__("./node_modules/lodash/_SetCache.js"),
	    arrayIncludes = __webpack_require__("./node_modules/lodash/_arrayIncludes.js"),
	    arrayIncludesWith = __webpack_require__("./node_modules/lodash/_arrayIncludesWith.js"),
	    cacheHas = __webpack_require__("./node_modules/lodash/_cacheHas.js"),
	    createSet = __webpack_require__("./node_modules/lodash/_createSet.js"),
	    setToArray = __webpack_require__("./node_modules/lodash/_setToArray.js");
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },

/***/ "./node_modules/lodash/_createSet.js":
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__("./node_modules/lodash/_Set.js"),
	    noop = __webpack_require__("./node_modules/lodash/noop.js"),
	    setToArray = __webpack_require__("./node_modules/lodash/_setToArray.js");
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },

/***/ "./node_modules/lodash/noop.js":
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },

/***/ "./node_modules/lodash/isArrayLikeObject.js":
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },

/***/ "./node_modules/lodash/last.js":
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },

/***/ "./node_modules/uniforms/joinName.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = joinName;
	
	
	// FIXME: ESLint seems to have problems with this code.
	/* eslint-disable no-redeclare, no-unused-vars */
	
	function joinName() {
	    for (var _len = arguments.length, parts = Array(_len), _key = 0; _key < _len; _key++) {
	        parts[_key] = arguments[_key];
	    }
	
	    var name = parts.reduce(function (parts, part) {
	        return part || part === 0 ? parts.concat(typeof part === 'string' ? part.split('.') : part) : parts;
	    }, []);
	
	    return parts[0] === null ? name.map(function (part) {
	        return part.toString();
	    }) : name.join('.');
	}

/***/ },

/***/ "./node_modules/uniforms/createSchemaBridge.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = createSchemaBridge;
	
	var _invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _GraphQLBridge = __webpack_require__("./node_modules/uniforms/GraphQLBridge.js");
	
	var _GraphQLBridge2 = _interopRequireDefault(_GraphQLBridge);
	
	var _JSONSchemaBridge = __webpack_require__("./node_modules/uniforms/JSONSchemaBridge.js");
	
	var _JSONSchemaBridge2 = _interopRequireDefault(_JSONSchemaBridge);
	
	var _SimpleSchema2Bridge = __webpack_require__("./node_modules/uniforms/SimpleSchema2Bridge.js");
	
	var _SimpleSchema2Bridge2 = _interopRequireDefault(_SimpleSchema2Bridge);
	
	var _SimpleSchemaBridge = __webpack_require__("./node_modules/uniforms/SimpleSchemaBridge.js");
	
	var _SimpleSchemaBridge2 = _interopRequireDefault(_SimpleSchemaBridge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bridges = [_GraphQLBridge2.default, _JSONSchemaBridge2.default, _SimpleSchemaBridge2.default, _SimpleSchema2Bridge2.default];
	
	var isBridge = function isBridge(schema) {
	    return schema && schema.getError && schema.getErrorMessage && schema.getErrorMessages && schema.getField && schema.getInitialValue && schema.getProps && schema.getSubfields && schema.getType && schema.getValidator;
	};
	
	function createSchemaBridge(schema) {
	    // There's no need for an extra wrapper.
	    if (isBridge(schema)) {
	        return schema;
	    }
	
	    var Bridge = bridges.find(function (bridge) {
	        return bridge.check(schema);
	    });
	
	    (0, _invariant2.default)(Bridge, 'Unrecognised schema: %s', schema);
	
	    return new Bridge(schema);
	}

/***/ },

/***/ "./node_modules/uniforms/GraphQLBridge.js":
/***/ function(module, exports, __webpack_require__) {

	var require;'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Bridge2 = __webpack_require__("./node_modules/uniforms/Bridge.js");
	
	var _Bridge3 = _interopRequireDefault(_Bridge2);
	
	var _joinName = __webpack_require__("./node_modules/uniforms/joinName.js");
	
	var _joinName2 = _interopRequireDefault(_joinName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var graphql = void 0;
	try {
	    var r = require; // Silence Meteor missing module warning
	    graphql = __webpack_require__("./node_modules/graphql/index.js");
	} catch (_) {/* Ignore it. */}
	
	var extractFromNonNull = function extractFromNonNull(x) {
	    return x && x.type instanceof graphql.GraphQLNonNull ? (0, _extends3.default)({}, x, { type: x.type.ofType }) : x;
	};
	
	var GraphQLBridge = function (_Bridge) {
	    (0, _inherits3.default)(GraphQLBridge, _Bridge);
	
	    function GraphQLBridge(schema, validator) {
	        var extras = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	        (0, _classCallCheck3.default)(this, GraphQLBridge);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (GraphQLBridge.__proto__ || Object.getPrototypeOf(GraphQLBridge)).call(this));
	
	        _this.extras = extras;
	        _this.schema = schema;
	        _this.validator = validator;
	        return _this;
	    }
	
	    // This bridge has 3 arguments, so it cannot be constructed implicite in the
	    // createSchemaBridge.
	
	
	    (0, _createClass3.default)(GraphQLBridge, [{
	        key: 'getError',
	        value: function getError(name, error) {
	            return error && error.details && error.details.find && error.details.find(function (error) {
	                return error.name === name;
	            }) || null;
	        }
	    }, {
	        key: 'getErrorMessage',
	        value: function getErrorMessage(name, error) {
	            var scopedError = this.getError(name, error);
	            return !scopedError ? '' : scopedError.message;
	        }
	    }, {
	        key: 'getErrorMessages',
	        value: function getErrorMessages(error) {
	            if (error) {
	                if (Array.isArray(error.details)) {
	                    return error.details.map(function (error) {
	                        return error.message;
	                    });
	                }
	
	                if (error.message) {
	                    return [error.message];
	                }
	            }
	
	            if (error !== undefined) {
	                return [error];
	            }
	
	            return [];
	        }
	    }, {
	        key: 'getField',
	        value: function getField(name) {
	            var returnExtracted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	            return (0, _joinName2.default)(null, name).reduce(function (definition, next, index, array) {
	                if (next === '$' || next === '' + parseInt(next, 10)) {
	                    (0, _invariant2.default)(definition.type instanceof graphql.GraphQLList, 'Field not found in schema: "%s"', name);
	                    definition = { type: extractFromNonNull(definition.type.ofType) };
	                } else if (definition.type && definition.type._fields) {
	                    definition = definition.type._fields[next];
	                } else {
	                    definition = definition[next];
	                }
	
	                (0, _invariant2.default)(definition, 'Field not found in schema: "%s"', name);
	
	                var isLast = array.length - 1 === index;
	
	                if (isLast && !returnExtracted) {
	                    return definition;
	                }
	
	                var extracted = extractFromNonNull(definition);
	
	                if (isLast && returnExtracted || !(extracted.type instanceof graphql.GraphQLObjectType)) {
	                    return extracted;
	                }
	
	                (0, _invariant2.default)(extracted.type.getFields, 'Field not found in schema: "%s"', name);
	
	                return extracted.type.getFields();
	            }, this.schema.getFields());
	        }
	    }, {
	        key: 'getInitialValue',
	        value: function getInitialValue(name) {
	            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            var type = this.getType(name);
	
	            if (type === Array) {
	                var item = this.getInitialValue((0, _joinName2.default)(name, '0'));
	                var items = props.initialCount || 0;
	
	                return [].concat((0, _toConsumableArray3.default)(Array(items))).map(function () {
	                    return item;
	                });
	            }
	
	            if (type === Object) {
	                return {};
	            }
	
	            var defaultValue = this.getField(name).defaultValue;
	
	            return defaultValue === undefined ? this.extras[name] && this.extras[name].initialValue : defaultValue;
	        }
	
	        // eslint-disable-next-line complexity
	
	    }, {
	        key: 'getProps',
	        value: function getProps(nameNormal) {
	            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            var nameGeneric = nameNormal.replace(/\.\d+/, '.$');
	
	            var field = this.getField(nameGeneric, false);
	            var fieldType = extractFromNonNull(field.type);
	
	            var extra = (0, _extends3.default)({}, this.extras[nameGeneric], this.extras[nameNormal]);
	
	            var ready = (0, _extends3.default)({
	                label: '',
	                required: field.type instanceof graphql.GraphQLNonNull
	
	            }, extra, props);
	
	            if (props.label === true && extra.label) {
	                ready.label = extra.label;
	            } else if (props.label !== undefined && !props.label) {
	                ready.label = '';
	            }
	
	            if (fieldType instanceof graphql.GraphQLScalarType && fieldType.name === 'Float') {
	                ready.decimal = true;
	            }
	
	            if (ready.options) {
	                if (!Array.isArray(ready.options)) {
	                    ready.transform = function (value) {
	                        return ready.options[value];
	                    };
	                    ready.allowedValues = Object.keys(ready.options);
	                } else {
	                    ready.transform = function (value) {
	                        return ready.options.find(function (option) {
	                            return option.value === value;
	                        }).label;
	                    };
	                    ready.allowedValues = ready.options.map(function (option) {
	                        return option.value;
	                    });
	                }
	            }
	
	            return ready;
	        }
	    }, {
	        key: 'getSubfields',
	        value: function getSubfields(name) {
	            if (!name) {
	                return Object.keys(this.schema.getFields());
	            }
	
	            var fieldType = this.getField(name).type;
	
	            if (fieldType instanceof graphql.GraphQLObjectType || fieldType instanceof graphql.GraphQLInputObjectType) {
	                return Object.keys(fieldType.getFields());
	            }
	
	            return [];
	        }
	    }, {
	        key: 'getType',
	        value: function getType(name) {
	            var fieldType = this.getField(name).type;
	
	            if (fieldType instanceof graphql.GraphQLList) return Array;
	            if (fieldType instanceof graphql.GraphQLObjectType) return Object;
	            if (fieldType instanceof graphql.GraphQLInputObjectType) return Object;
	            if (fieldType instanceof graphql.GraphQLScalarType) {
	                if (fieldType.name === 'ID') return String;
	                if (fieldType.name === 'Int') return Number;
	                if (fieldType.name === 'Float') return Number;
	                if (fieldType.name === 'String') return String;
	                if (fieldType.name === 'Boolean') return Boolean;
	            }
	
	            return fieldType;
	        }
	    }, {
	        key: 'getValidator',
	        value: function getValidator() /* options */{
	            return this.validator;
	        }
	    }], [{
	        key: 'check',
	        value: function check() /* schema */{
	            return false;
	        }
	    }]);
	    return GraphQLBridge;
	}(_Bridge3.default);
	
	exports.default = GraphQLBridge;

/***/ },

/***/ "./node_modules/uniforms/Bridge.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bridge = function () {
	    function Bridge() {
	        (0, _classCallCheck3.default)(this, Bridge);
	
	        (0, _invariant2.default)(this.constructor !== Bridge, 'Bridge cannot be instantiated.');
	    }
	
	    (0, _createClass3.default)(Bridge, [{
	        key: 'getError',
	        value: function getError() /* name, error */{
	            (0, _invariant2.default)(false, '%s have not implemented `getError` method.', this.constructor.name);
	        }
	    }, {
	        key: 'getErrorMessage',
	        value: function getErrorMessage() /* name, error */{
	            (0, _invariant2.default)(false, '%s have not implemented `getError` method.', this.constructor.name);
	        }
	    }, {
	        key: 'getErrorMessages',
	        value: function getErrorMessages() /* error */{
	            (0, _invariant2.default)(false, '%s have not implemented `getErrorMessages` method.', this.constructor.name);
	        }
	    }, {
	        key: 'getField',
	        value: function getField() /* name */{
	            (0, _invariant2.default)(false, '%s have not implemented `getField` method.', this.constructor.name);
	        }
	    }, {
	        key: 'getInitialValue',
	        value: function getInitialValue() /* name, props */{
	            (0, _invariant2.default)(false, '%s have not implemented `getInitialValue` method.', this.constructor.name);
	        }
	    }, {
	        key: 'getProps',
	        value: function getProps() /* name, props */{
	            (0, _invariant2.default)(false, '%s have not implemented `getProps` method.', this.constructor.name);
	        }
	    }, {
	        key: 'getSubfields',
	        value: function getSubfields() /* name */{
	            (0, _invariant2.default)(false, '%s have not implemented `getSubfields` method.', this.constructor.name);
	        }
	    }, {
	        key: 'getType',
	        value: function getType() /* name */{
	            (0, _invariant2.default)(false, '%s have not implemented `getType` method.', this.constructor.name);
	        }
	    }, {
	        key: 'getValidator',
	        value: function getValidator() /* options */{
	            (0, _invariant2.default)(false, '%s have not implemented `getValidator` method.', this.constructor.name);
	        }
	    }], [{
	        key: 'check',
	        value: function check() /* schema */{
	            (0, _invariant2.default)(false, '%s have not implemented `check` method.', this.name);
	        }
	    }]);
	    return Bridge;
	}();
	
	exports.default = Bridge;

/***/ },

/***/ "./node_modules/graphql/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _graphql = __webpack_require__("./node_modules/graphql/graphql.js");
	
	Object.defineProperty(exports, 'graphql', {
	  enumerable: true,
	  get: function get() {
	    return _graphql.graphql;
	  }
	});
	
	var _type = __webpack_require__("./node_modules/graphql/type/index.js");
	
	Object.defineProperty(exports, 'GraphQLSchema', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLSchema;
	  }
	});
	Object.defineProperty(exports, 'GraphQLScalarType', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLScalarType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLObjectType', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLObjectType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLInterfaceType', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLInterfaceType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLUnionType', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLUnionType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLEnumType', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLEnumType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLInputObjectType', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLInputObjectType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLList', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLList;
	  }
	});
	Object.defineProperty(exports, 'GraphQLNonNull', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLNonNull;
	  }
	});
	Object.defineProperty(exports, 'GraphQLDirective', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLDirective;
	  }
	});
	Object.defineProperty(exports, 'TypeKind', {
	  enumerable: true,
	  get: function get() {
	    return _type.TypeKind;
	  }
	});
	Object.defineProperty(exports, 'DirectiveLocation', {
	  enumerable: true,
	  get: function get() {
	    return _type.DirectiveLocation;
	  }
	});
	Object.defineProperty(exports, 'GraphQLInt', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLInt;
	  }
	});
	Object.defineProperty(exports, 'GraphQLFloat', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLFloat;
	  }
	});
	Object.defineProperty(exports, 'GraphQLString', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLString;
	  }
	});
	Object.defineProperty(exports, 'GraphQLBoolean', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLBoolean;
	  }
	});
	Object.defineProperty(exports, 'GraphQLID', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLID;
	  }
	});
	Object.defineProperty(exports, 'specifiedDirectives', {
	  enumerable: true,
	  get: function get() {
	    return _type.specifiedDirectives;
	  }
	});
	Object.defineProperty(exports, 'GraphQLIncludeDirective', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLIncludeDirective;
	  }
	});
	Object.defineProperty(exports, 'GraphQLSkipDirective', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLSkipDirective;
	  }
	});
	Object.defineProperty(exports, 'GraphQLDeprecatedDirective', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLDeprecatedDirective;
	  }
	});
	Object.defineProperty(exports, 'DEFAULT_DEPRECATION_REASON', {
	  enumerable: true,
	  get: function get() {
	    return _type.DEFAULT_DEPRECATION_REASON;
	  }
	});
	Object.defineProperty(exports, 'SchemaMetaFieldDef', {
	  enumerable: true,
	  get: function get() {
	    return _type.SchemaMetaFieldDef;
	  }
	});
	Object.defineProperty(exports, 'TypeMetaFieldDef', {
	  enumerable: true,
	  get: function get() {
	    return _type.TypeMetaFieldDef;
	  }
	});
	Object.defineProperty(exports, 'TypeNameMetaFieldDef', {
	  enumerable: true,
	  get: function get() {
	    return _type.TypeNameMetaFieldDef;
	  }
	});
	Object.defineProperty(exports, '__Schema', {
	  enumerable: true,
	  get: function get() {
	    return _type.__Schema;
	  }
	});
	Object.defineProperty(exports, '__Directive', {
	  enumerable: true,
	  get: function get() {
	    return _type.__Directive;
	  }
	});
	Object.defineProperty(exports, '__DirectiveLocation', {
	  enumerable: true,
	  get: function get() {
	    return _type.__DirectiveLocation;
	  }
	});
	Object.defineProperty(exports, '__Type', {
	  enumerable: true,
	  get: function get() {
	    return _type.__Type;
	  }
	});
	Object.defineProperty(exports, '__Field', {
	  enumerable: true,
	  get: function get() {
	    return _type.__Field;
	  }
	});
	Object.defineProperty(exports, '__InputValue', {
	  enumerable: true,
	  get: function get() {
	    return _type.__InputValue;
	  }
	});
	Object.defineProperty(exports, '__EnumValue', {
	  enumerable: true,
	  get: function get() {
	    return _type.__EnumValue;
	  }
	});
	Object.defineProperty(exports, '__TypeKind', {
	  enumerable: true,
	  get: function get() {
	    return _type.__TypeKind;
	  }
	});
	Object.defineProperty(exports, 'isType', {
	  enumerable: true,
	  get: function get() {
	    return _type.isType;
	  }
	});
	Object.defineProperty(exports, 'isInputType', {
	  enumerable: true,
	  get: function get() {
	    return _type.isInputType;
	  }
	});
	Object.defineProperty(exports, 'isOutputType', {
	  enumerable: true,
	  get: function get() {
	    return _type.isOutputType;
	  }
	});
	Object.defineProperty(exports, 'isLeafType', {
	  enumerable: true,
	  get: function get() {
	    return _type.isLeafType;
	  }
	});
	Object.defineProperty(exports, 'isCompositeType', {
	  enumerable: true,
	  get: function get() {
	    return _type.isCompositeType;
	  }
	});
	Object.defineProperty(exports, 'isAbstractType', {
	  enumerable: true,
	  get: function get() {
	    return _type.isAbstractType;
	  }
	});
	Object.defineProperty(exports, 'assertType', {
	  enumerable: true,
	  get: function get() {
	    return _type.assertType;
	  }
	});
	Object.defineProperty(exports, 'assertInputType', {
	  enumerable: true,
	  get: function get() {
	    return _type.assertInputType;
	  }
	});
	Object.defineProperty(exports, 'assertOutputType', {
	  enumerable: true,
	  get: function get() {
	    return _type.assertOutputType;
	  }
	});
	Object.defineProperty(exports, 'assertLeafType', {
	  enumerable: true,
	  get: function get() {
	    return _type.assertLeafType;
	  }
	});
	Object.defineProperty(exports, 'assertCompositeType', {
	  enumerable: true,
	  get: function get() {
	    return _type.assertCompositeType;
	  }
	});
	Object.defineProperty(exports, 'assertAbstractType', {
	  enumerable: true,
	  get: function get() {
	    return _type.assertAbstractType;
	  }
	});
	Object.defineProperty(exports, 'getNullableType', {
	  enumerable: true,
	  get: function get() {
	    return _type.getNullableType;
	  }
	});
	Object.defineProperty(exports, 'getNamedType', {
	  enumerable: true,
	  get: function get() {
	    return _type.getNamedType;
	  }
	});
	
	var _language = __webpack_require__("./node_modules/graphql/language/index.js");
	
	Object.defineProperty(exports, 'Source', {
	  enumerable: true,
	  get: function get() {
	    return _language.Source;
	  }
	});
	Object.defineProperty(exports, 'getLocation', {
	  enumerable: true,
	  get: function get() {
	    return _language.getLocation;
	  }
	});
	Object.defineProperty(exports, 'parse', {
	  enumerable: true,
	  get: function get() {
	    return _language.parse;
	  }
	});
	Object.defineProperty(exports, 'parseValue', {
	  enumerable: true,
	  get: function get() {
	    return _language.parseValue;
	  }
	});
	Object.defineProperty(exports, 'parseType', {
	  enumerable: true,
	  get: function get() {
	    return _language.parseType;
	  }
	});
	Object.defineProperty(exports, 'print', {
	  enumerable: true,
	  get: function get() {
	    return _language.print;
	  }
	});
	Object.defineProperty(exports, 'visit', {
	  enumerable: true,
	  get: function get() {
	    return _language.visit;
	  }
	});
	Object.defineProperty(exports, 'visitInParallel', {
	  enumerable: true,
	  get: function get() {
	    return _language.visitInParallel;
	  }
	});
	Object.defineProperty(exports, 'visitWithTypeInfo', {
	  enumerable: true,
	  get: function get() {
	    return _language.visitWithTypeInfo;
	  }
	});
	Object.defineProperty(exports, 'Kind', {
	  enumerable: true,
	  get: function get() {
	    return _language.Kind;
	  }
	});
	Object.defineProperty(exports, 'TokenKind', {
	  enumerable: true,
	  get: function get() {
	    return _language.TokenKind;
	  }
	});
	Object.defineProperty(exports, 'BREAK', {
	  enumerable: true,
	  get: function get() {
	    return _language.BREAK;
	  }
	});
	
	var _execution = __webpack_require__("./node_modules/graphql/execution/index.js");
	
	Object.defineProperty(exports, 'execute', {
	  enumerable: true,
	  get: function get() {
	    return _execution.execute;
	  }
	});
	Object.defineProperty(exports, 'defaultFieldResolver', {
	  enumerable: true,
	  get: function get() {
	    return _execution.defaultFieldResolver;
	  }
	});
	Object.defineProperty(exports, 'responsePathAsArray', {
	  enumerable: true,
	  get: function get() {
	    return _execution.responsePathAsArray;
	  }
	});
	
	var _validation = __webpack_require__("./node_modules/graphql/validation/index.js");
	
	Object.defineProperty(exports, 'validate', {
	  enumerable: true,
	  get: function get() {
	    return _validation.validate;
	  }
	});
	Object.defineProperty(exports, 'ValidationContext', {
	  enumerable: true,
	  get: function get() {
	    return _validation.ValidationContext;
	  }
	});
	Object.defineProperty(exports, 'specifiedRules', {
	  enumerable: true,
	  get: function get() {
	    return _validation.specifiedRules;
	  }
	});
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	Object.defineProperty(exports, 'GraphQLError', {
	  enumerable: true,
	  get: function get() {
	    return _error.GraphQLError;
	  }
	});
	Object.defineProperty(exports, 'formatError', {
	  enumerable: true,
	  get: function get() {
	    return _error.formatError;
	  }
	});
	
	var _utilities = __webpack_require__("./node_modules/graphql/utilities/index.js");
	
	Object.defineProperty(exports, 'introspectionQuery', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.introspectionQuery;
	  }
	});
	Object.defineProperty(exports, 'getOperationAST', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.getOperationAST;
	  }
	});
	Object.defineProperty(exports, 'buildClientSchema', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.buildClientSchema;
	  }
	});
	Object.defineProperty(exports, 'buildASTSchema', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.buildASTSchema;
	  }
	});
	Object.defineProperty(exports, 'buildSchema', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.buildSchema;
	  }
	});
	Object.defineProperty(exports, 'extendSchema', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.extendSchema;
	  }
	});
	Object.defineProperty(exports, 'printSchema', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.printSchema;
	  }
	});
	Object.defineProperty(exports, 'printType', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.printType;
	  }
	});
	Object.defineProperty(exports, 'typeFromAST', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.typeFromAST;
	  }
	});
	Object.defineProperty(exports, 'valueFromAST', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.valueFromAST;
	  }
	});
	Object.defineProperty(exports, 'astFromValue', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.astFromValue;
	  }
	});
	Object.defineProperty(exports, 'TypeInfo', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.TypeInfo;
	  }
	});
	Object.defineProperty(exports, 'isValidJSValue', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.isValidJSValue;
	  }
	});
	Object.defineProperty(exports, 'isValidLiteralValue', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.isValidLiteralValue;
	  }
	});
	Object.defineProperty(exports, 'concatAST', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.concatAST;
	  }
	});
	Object.defineProperty(exports, 'separateOperations', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.separateOperations;
	  }
	});
	Object.defineProperty(exports, 'isEqualType', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.isEqualType;
	  }
	});
	Object.defineProperty(exports, 'isTypeSubTypeOf', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.isTypeSubTypeOf;
	  }
	});
	Object.defineProperty(exports, 'doTypesOverlap', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.doTypesOverlap;
	  }
	});
	Object.defineProperty(exports, 'assertValidName', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.assertValidName;
	  }
	});
	Object.defineProperty(exports, 'findBreakingChanges', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.findBreakingChanges;
	  }
	});

/***/ },

/***/ "./node_modules/graphql/graphql.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.graphql = graphql;
	
	var _source = __webpack_require__("./node_modules/graphql/language/source.js");
	
	var _parser = __webpack_require__("./node_modules/graphql/language/parser.js");
	
	var _validate = __webpack_require__("./node_modules/graphql/validation/validate.js");
	
	var _execute = __webpack_require__("./node_modules/graphql/execution/execute.js");
	
	/**
	 * This is the primary entry point function for fulfilling GraphQL operations
	 * by parsing, validating, and executing a GraphQL document along side a
	 * GraphQL schema.
	 *
	 * More sophisticated GraphQL servers, such as those which persist queries,
	 * may wish to separate the validation and execution phases to a static time
	 * tooling step, and a server runtime step.
	 *
	 * schema:
	 *    The GraphQL type system to use when validating and executing a query.
	 * requestString:
	 *    A GraphQL language formatted string representing the requested operation.
	 * rootValue:
	 *    The value provided as the first argument to resolver functions on the top
	 *    level type (e.g. the query object type).
	 * variableValues:
	 *    A mapping of variable name to runtime value to use for all variables
	 *    defined in the requestString.
	 * operationName:
	 *    The name of the operation to use if requestString contains multiple
	 *    possible operations. Can be omitted if requestString contains only
	 *    one operation.
	 */
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function graphql(schema, requestString, rootValue, contextValue, variableValues, operationName) {
	  return new Promise(function (resolve) {
	    var source = new _source.Source(requestString || '', 'GraphQL request');
	    var documentAST = (0, _parser.parse)(source);
	    var validationErrors = (0, _validate.validate)(schema, documentAST);
	    if (validationErrors.length > 0) {
	      resolve({ errors: validationErrors });
	    } else {
	      resolve((0, _execute.execute)(schema, documentAST, rootValue, contextValue, variableValues, operationName));
	    }
	  }).then(undefined, function (error) {
	    return { errors: [error] };
	  });
	}

/***/ },

/***/ "./node_modules/graphql/language/source.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	/**
	 * A representation of source input to GraphQL. The name is optional,
	 * but is mostly useful for clients who store GraphQL documents in
	 * source files; for example, if the GraphQL input is in a file Foo.graphql,
	 * it might be useful for name to be "Foo.graphql".
	 */
	var Source = exports.Source = function Source(body, name) {
	  _classCallCheck(this, Source);
	
	  this.body = body;
	  this.name = name || 'GraphQL';
	};

/***/ },

/***/ "./node_modules/graphql/language/parser.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parse = parse;
	exports.parseValue = parseValue;
	exports.parseType = parseType;
	exports.parseConstValue = parseConstValue;
	exports.parseTypeReference = parseTypeReference;
	exports.parseNamedType = parseNamedType;
	
	var _source = __webpack_require__("./node_modules/graphql/language/source.js");
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _lexer = __webpack_require__("./node_modules/graphql/language/lexer.js");
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	/**
	 * Given a GraphQL source, parses it into a Document.
	 * Throws GraphQLError if a syntax error is encountered.
	 */
	
	
	/**
	 * Configuration options to control parser behavior
	 */
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function parse(source, options) {
	  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
	  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
	  return parseDocument(lexer);
	}
	
	/**
	 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
	 * that value.
	 * Throws GraphQLError if a syntax error is encountered.
	 *
	 * This is useful within tools that operate upon GraphQL Values directly and
	 * in isolation of complete GraphQL documents.
	 *
	 * Consider providing the results to the utility function: valueFromAST().
	 */
	function parseValue(source, options) {
	  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
	  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
	  expect(lexer, _lexer.TokenKind.SOF);
	  var value = parseValueLiteral(lexer, false);
	  expect(lexer, _lexer.TokenKind.EOF);
	  return value;
	}
	
	/**
	 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
	 * that type.
	 * Throws GraphQLError if a syntax error is encountered.
	 *
	 * This is useful within tools that operate upon GraphQL Types directly and
	 * in isolation of complete GraphQL documents.
	 *
	 * Consider providing the results to the utility function: typeFromAST().
	 */
	function parseType(source, options) {
	  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
	  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
	  expect(lexer, _lexer.TokenKind.SOF);
	  var type = parseTypeReference(lexer);
	  expect(lexer, _lexer.TokenKind.EOF);
	  return type;
	}
	
	/**
	 * Converts a name lex token into a name parse node.
	 */
	function parseName(lexer) {
	  var token = expect(lexer, _lexer.TokenKind.NAME);
	  return {
	    kind: _kinds.NAME,
	    value: token.value,
	    loc: loc(lexer, token)
	  };
	}
	
	// Implements the parsing rules in the Document section.
	
	/**
	 * Document : Definition+
	 */
	function parseDocument(lexer) {
	  var start = lexer.token;
	  expect(lexer, _lexer.TokenKind.SOF);
	  var definitions = [];
	  do {
	    definitions.push(parseDefinition(lexer));
	  } while (!skip(lexer, _lexer.TokenKind.EOF));
	
	  return {
	    kind: _kinds.DOCUMENT,
	    definitions: definitions,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * Definition :
	 *   - OperationDefinition
	 *   - FragmentDefinition
	 *   - TypeSystemDefinition
	 */
	function parseDefinition(lexer) {
	  if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
	    return parseOperationDefinition(lexer);
	  }
	
	  if (peek(lexer, _lexer.TokenKind.NAME)) {
	    switch (lexer.token.value) {
	      // Note: subscription is an experimental non-spec addition.
	      case 'query':
	      case 'mutation':
	      case 'subscription':
	        return parseOperationDefinition(lexer);
	
	      case 'fragment':
	        return parseFragmentDefinition(lexer);
	
	      // Note: the Type System IDL is an experimental non-spec addition.
	      case 'schema':
	      case 'scalar':
	      case 'type':
	      case 'interface':
	      case 'union':
	      case 'enum':
	      case 'input':
	      case 'extend':
	      case 'directive':
	        return parseTypeSystemDefinition(lexer);
	    }
	  }
	
	  throw unexpected(lexer);
	}
	
	// Implements the parsing rules in the Operations section.
	
	/**
	 * OperationDefinition :
	 *  - SelectionSet
	 *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
	 */
	function parseOperationDefinition(lexer) {
	  var start = lexer.token;
	  if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
	    return {
	      kind: _kinds.OPERATION_DEFINITION,
	      operation: 'query',
	      name: null,
	      variableDefinitions: null,
	      directives: [],
	      selectionSet: parseSelectionSet(lexer),
	      loc: loc(lexer, start)
	    };
	  }
	  var operation = parseOperationType(lexer);
	  var name = void 0;
	  if (peek(lexer, _lexer.TokenKind.NAME)) {
	    name = parseName(lexer);
	  }
	  return {
	    kind: _kinds.OPERATION_DEFINITION,
	    operation: operation,
	    name: name,
	    variableDefinitions: parseVariableDefinitions(lexer),
	    directives: parseDirectives(lexer),
	    selectionSet: parseSelectionSet(lexer),
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * OperationType : one of query mutation subscription
	 */
	function parseOperationType(lexer) {
	  var operationToken = expect(lexer, _lexer.TokenKind.NAME);
	  switch (operationToken.value) {
	    case 'query':
	      return 'query';
	    case 'mutation':
	      return 'mutation';
	    // Note: subscription is an experimental non-spec addition.
	    case 'subscription':
	      return 'subscription';
	  }
	
	  throw unexpected(lexer, operationToken);
	}
	
	/**
	 * VariableDefinitions : ( VariableDefinition+ )
	 */
	function parseVariableDefinitions(lexer) {
	  return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, parseVariableDefinition, _lexer.TokenKind.PAREN_R) : [];
	}
	
	/**
	 * VariableDefinition : Variable : Type DefaultValue?
	 */
	function parseVariableDefinition(lexer) {
	  var start = lexer.token;
	  return {
	    kind: _kinds.VARIABLE_DEFINITION,
	    variable: parseVariable(lexer),
	    type: (expect(lexer, _lexer.TokenKind.COLON), parseTypeReference(lexer)),
	    defaultValue: skip(lexer, _lexer.TokenKind.EQUALS) ? parseValueLiteral(lexer, true) : null,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * Variable : $ Name
	 */
	function parseVariable(lexer) {
	  var start = lexer.token;
	  expect(lexer, _lexer.TokenKind.DOLLAR);
	  return {
	    kind: _kinds.VARIABLE,
	    name: parseName(lexer),
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * SelectionSet : { Selection+ }
	 */
	function parseSelectionSet(lexer) {
	  var start = lexer.token;
	  return {
	    kind: _kinds.SELECTION_SET,
	    selections: many(lexer, _lexer.TokenKind.BRACE_L, parseSelection, _lexer.TokenKind.BRACE_R),
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * Selection :
	 *   - Field
	 *   - FragmentSpread
	 *   - InlineFragment
	 */
	function parseSelection(lexer) {
	  return peek(lexer, _lexer.TokenKind.SPREAD) ? parseFragment(lexer) : parseField(lexer);
	}
	
	/**
	 * Field : Alias? Name Arguments? Directives? SelectionSet?
	 *
	 * Alias : Name :
	 */
	function parseField(lexer) {
	  var start = lexer.token;
	
	  var nameOrAlias = parseName(lexer);
	  var alias = void 0;
	  var name = void 0;
	  if (skip(lexer, _lexer.TokenKind.COLON)) {
	    alias = nameOrAlias;
	    name = parseName(lexer);
	  } else {
	    alias = null;
	    name = nameOrAlias;
	  }
	
	  return {
	    kind: _kinds.FIELD,
	    alias: alias,
	    name: name,
	    arguments: parseArguments(lexer),
	    directives: parseDirectives(lexer),
	    selectionSet: peek(lexer, _lexer.TokenKind.BRACE_L) ? parseSelectionSet(lexer) : null,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * Arguments : ( Argument+ )
	 */
	function parseArguments(lexer) {
	  return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, parseArgument, _lexer.TokenKind.PAREN_R) : [];
	}
	
	/**
	 * Argument : Name : Value
	 */
	function parseArgument(lexer) {
	  var start = lexer.token;
	  return {
	    kind: _kinds.ARGUMENT,
	    name: parseName(lexer),
	    value: (expect(lexer, _lexer.TokenKind.COLON), parseValueLiteral(lexer, false)),
	    loc: loc(lexer, start)
	  };
	}
	
	// Implements the parsing rules in the Fragments section.
	
	/**
	 * Corresponds to both FragmentSpread and InlineFragment in the spec.
	 *
	 * FragmentSpread : ... FragmentName Directives?
	 *
	 * InlineFragment : ... TypeCondition? Directives? SelectionSet
	 */
	function parseFragment(lexer) {
	  var start = lexer.token;
	  expect(lexer, _lexer.TokenKind.SPREAD);
	  if (peek(lexer, _lexer.TokenKind.NAME) && lexer.token.value !== 'on') {
	    return {
	      kind: _kinds.FRAGMENT_SPREAD,
	      name: parseFragmentName(lexer),
	      directives: parseDirectives(lexer),
	      loc: loc(lexer, start)
	    };
	  }
	  var typeCondition = null;
	  if (lexer.token.value === 'on') {
	    lexer.advance();
	    typeCondition = parseNamedType(lexer);
	  }
	  return {
	    kind: _kinds.INLINE_FRAGMENT,
	    typeCondition: typeCondition,
	    directives: parseDirectives(lexer),
	    selectionSet: parseSelectionSet(lexer),
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * FragmentDefinition :
	 *   - fragment FragmentName on TypeCondition Directives? SelectionSet
	 *
	 * TypeCondition : NamedType
	 */
	function parseFragmentDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'fragment');
	  return {
	    kind: _kinds.FRAGMENT_DEFINITION,
	    name: parseFragmentName(lexer),
	    typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
	    directives: parseDirectives(lexer),
	    selectionSet: parseSelectionSet(lexer),
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * FragmentName : Name but not `on`
	 */
	function parseFragmentName(lexer) {
	  if (lexer.token.value === 'on') {
	    throw unexpected(lexer);
	  }
	  return parseName(lexer);
	}
	
	// Implements the parsing rules in the Values section.
	
	/**
	 * Value[Const] :
	 *   - [~Const] Variable
	 *   - IntValue
	 *   - FloatValue
	 *   - StringValue
	 *   - BooleanValue
	 *   - NullValue
	 *   - EnumValue
	 *   - ListValue[?Const]
	 *   - ObjectValue[?Const]
	 *
	 * BooleanValue : one of `true` `false`
	 *
	 * NullValue : `null`
	 *
	 * EnumValue : Name but not `true`, `false` or `null`
	 */
	function parseValueLiteral(lexer, isConst) {
	  var token = lexer.token;
	  switch (token.kind) {
	    case _lexer.TokenKind.BRACKET_L:
	      return parseList(lexer, isConst);
	    case _lexer.TokenKind.BRACE_L:
	      return parseObject(lexer, isConst);
	    case _lexer.TokenKind.INT:
	      lexer.advance();
	      return {
	        kind: _kinds.INT,
	        value: token.value,
	        loc: loc(lexer, token)
	      };
	    case _lexer.TokenKind.FLOAT:
	      lexer.advance();
	      return {
	        kind: _kinds.FLOAT,
	        value: token.value,
	        loc: loc(lexer, token)
	      };
	    case _lexer.TokenKind.STRING:
	      lexer.advance();
	      return {
	        kind: _kinds.STRING,
	        value: token.value,
	        loc: loc(lexer, token)
	      };
	    case _lexer.TokenKind.NAME:
	      if (token.value === 'true' || token.value === 'false') {
	        lexer.advance();
	        return {
	          kind: _kinds.BOOLEAN,
	          value: token.value === 'true',
	          loc: loc(lexer, token)
	        };
	      } else if (token.value === 'null') {
	        lexer.advance();
	        return {
	          kind: _kinds.NULL,
	          loc: loc(lexer, token)
	        };
	      }
	      lexer.advance();
	      return {
	        kind: _kinds.ENUM,
	        value: token.value,
	        loc: loc(lexer, token)
	      };
	    case _lexer.TokenKind.DOLLAR:
	      if (!isConst) {
	        return parseVariable(lexer);
	      }
	      break;
	  }
	  throw unexpected(lexer);
	}
	
	function parseConstValue(lexer) {
	  return parseValueLiteral(lexer, true);
	}
	
	function parseValueValue(lexer) {
	  return parseValueLiteral(lexer, false);
	}
	
	/**
	 * ListValue[Const] :
	 *   - [ ]
	 *   - [ Value[?Const]+ ]
	 */
	function parseList(lexer, isConst) {
	  var start = lexer.token;
	  var item = isConst ? parseConstValue : parseValueValue;
	  return {
	    kind: _kinds.LIST,
	    values: any(lexer, _lexer.TokenKind.BRACKET_L, item, _lexer.TokenKind.BRACKET_R),
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * ObjectValue[Const] :
	 *   - { }
	 *   - { ObjectField[?Const]+ }
	 */
	function parseObject(lexer, isConst) {
	  var start = lexer.token;
	  expect(lexer, _lexer.TokenKind.BRACE_L);
	  var fields = [];
	  while (!skip(lexer, _lexer.TokenKind.BRACE_R)) {
	    fields.push(parseObjectField(lexer, isConst));
	  }
	  return {
	    kind: _kinds.OBJECT,
	    fields: fields,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * ObjectField[Const] : Name : Value[?Const]
	 */
	function parseObjectField(lexer, isConst) {
	  var start = lexer.token;
	  return {
	    kind: _kinds.OBJECT_FIELD,
	    name: parseName(lexer),
	    value: (expect(lexer, _lexer.TokenKind.COLON), parseValueLiteral(lexer, isConst)),
	    loc: loc(lexer, start)
	  };
	}
	
	// Implements the parsing rules in the Directives section.
	
	/**
	 * Directives : Directive+
	 */
	function parseDirectives(lexer) {
	  var directives = [];
	  while (peek(lexer, _lexer.TokenKind.AT)) {
	    directives.push(parseDirective(lexer));
	  }
	  return directives;
	}
	
	/**
	 * Directive : @ Name Arguments?
	 */
	function parseDirective(lexer) {
	  var start = lexer.token;
	  expect(lexer, _lexer.TokenKind.AT);
	  return {
	    kind: _kinds.DIRECTIVE,
	    name: parseName(lexer),
	    arguments: parseArguments(lexer),
	    loc: loc(lexer, start)
	  };
	}
	
	// Implements the parsing rules in the Types section.
	
	/**
	 * Type :
	 *   - NamedType
	 *   - ListType
	 *   - NonNullType
	 */
	function parseTypeReference(lexer) {
	  var start = lexer.token;
	  var type = void 0;
	  if (skip(lexer, _lexer.TokenKind.BRACKET_L)) {
	    type = parseTypeReference(lexer);
	    expect(lexer, _lexer.TokenKind.BRACKET_R);
	    type = {
	      kind: _kinds.LIST_TYPE,
	      type: type,
	      loc: loc(lexer, start)
	    };
	  } else {
	    type = parseNamedType(lexer);
	  }
	  if (skip(lexer, _lexer.TokenKind.BANG)) {
	    return {
	      kind: _kinds.NON_NULL_TYPE,
	      type: type,
	      loc: loc(lexer, start)
	    };
	  }
	  return type;
	}
	
	/**
	 * NamedType : Name
	 */
	function parseNamedType(lexer) {
	  var start = lexer.token;
	  return {
	    kind: _kinds.NAMED_TYPE,
	    name: parseName(lexer),
	    loc: loc(lexer, start)
	  };
	}
	
	// Implements the parsing rules in the Type Definition section.
	
	/**
	 * TypeSystemDefinition :
	 *   - SchemaDefinition
	 *   - TypeDefinition
	 *   - TypeExtensionDefinition
	 *   - DirectiveDefinition
	 *
	 * TypeDefinition :
	 *   - ScalarTypeDefinition
	 *   - ObjectTypeDefinition
	 *   - InterfaceTypeDefinition
	 *   - UnionTypeDefinition
	 *   - EnumTypeDefinition
	 *   - InputObjectTypeDefinition
	 */
	function parseTypeSystemDefinition(lexer) {
	  if (peek(lexer, _lexer.TokenKind.NAME)) {
	    switch (lexer.token.value) {
	      case 'schema':
	        return parseSchemaDefinition(lexer);
	      case 'scalar':
	        return parseScalarTypeDefinition(lexer);
	      case 'type':
	        return parseObjectTypeDefinition(lexer);
	      case 'interface':
	        return parseInterfaceTypeDefinition(lexer);
	      case 'union':
	        return parseUnionTypeDefinition(lexer);
	      case 'enum':
	        return parseEnumTypeDefinition(lexer);
	      case 'input':
	        return parseInputObjectTypeDefinition(lexer);
	      case 'extend':
	        return parseTypeExtensionDefinition(lexer);
	      case 'directive':
	        return parseDirectiveDefinition(lexer);
	    }
	  }
	
	  throw unexpected(lexer);
	}
	
	/**
	 * SchemaDefinition : schema Directives? { OperationTypeDefinition+ }
	 *
	 * OperationTypeDefinition : OperationType : NamedType
	 */
	function parseSchemaDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'schema');
	  var directives = parseDirectives(lexer);
	  var operationTypes = many(lexer, _lexer.TokenKind.BRACE_L, parseOperationTypeDefinition, _lexer.TokenKind.BRACE_R);
	  return {
	    kind: _kinds.SCHEMA_DEFINITION,
	    directives: directives,
	    operationTypes: operationTypes,
	    loc: loc(lexer, start)
	  };
	}
	
	function parseOperationTypeDefinition(lexer) {
	  var start = lexer.token;
	  var operation = parseOperationType(lexer);
	  expect(lexer, _lexer.TokenKind.COLON);
	  var type = parseNamedType(lexer);
	  return {
	    kind: _kinds.OPERATION_TYPE_DEFINITION,
	    operation: operation,
	    type: type,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * ScalarTypeDefinition : scalar Name Directives?
	 */
	function parseScalarTypeDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'scalar');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer);
	  return {
	    kind: _kinds.SCALAR_TYPE_DEFINITION,
	    name: name,
	    directives: directives,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * ObjectTypeDefinition :
	 *   - type Name ImplementsInterfaces? Directives? { FieldDefinition+ }
	 */
	function parseObjectTypeDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'type');
	  var name = parseName(lexer);
	  var interfaces = parseImplementsInterfaces(lexer);
	  var directives = parseDirectives(lexer);
	  var fields = any(lexer, _lexer.TokenKind.BRACE_L, parseFieldDefinition, _lexer.TokenKind.BRACE_R);
	  return {
	    kind: _kinds.OBJECT_TYPE_DEFINITION,
	    name: name,
	    interfaces: interfaces,
	    directives: directives,
	    fields: fields,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * ImplementsInterfaces : implements NamedType+
	 */
	function parseImplementsInterfaces(lexer) {
	  var types = [];
	  if (lexer.token.value === 'implements') {
	    lexer.advance();
	    do {
	      types.push(parseNamedType(lexer));
	    } while (peek(lexer, _lexer.TokenKind.NAME));
	  }
	  return types;
	}
	
	/**
	 * FieldDefinition : Name ArgumentsDefinition? : Type Directives?
	 */
	function parseFieldDefinition(lexer) {
	  var start = lexer.token;
	  var name = parseName(lexer);
	  var args = parseArgumentDefs(lexer);
	  expect(lexer, _lexer.TokenKind.COLON);
	  var type = parseTypeReference(lexer);
	  var directives = parseDirectives(lexer);
	  return {
	    kind: _kinds.FIELD_DEFINITION,
	    name: name,
	    arguments: args,
	    type: type,
	    directives: directives,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * ArgumentsDefinition : ( InputValueDefinition+ )
	 */
	function parseArgumentDefs(lexer) {
	  if (!peek(lexer, _lexer.TokenKind.PAREN_L)) {
	    return [];
	  }
	  return many(lexer, _lexer.TokenKind.PAREN_L, parseInputValueDef, _lexer.TokenKind.PAREN_R);
	}
	
	/**
	 * InputValueDefinition : Name : Type DefaultValue? Directives?
	 */
	function parseInputValueDef(lexer) {
	  var start = lexer.token;
	  var name = parseName(lexer);
	  expect(lexer, _lexer.TokenKind.COLON);
	  var type = parseTypeReference(lexer);
	  var defaultValue = null;
	  if (skip(lexer, _lexer.TokenKind.EQUALS)) {
	    defaultValue = parseConstValue(lexer);
	  }
	  var directives = parseDirectives(lexer);
	  return {
	    kind: _kinds.INPUT_VALUE_DEFINITION,
	    name: name,
	    type: type,
	    defaultValue: defaultValue,
	    directives: directives,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * InterfaceTypeDefinition : interface Name Directives? { FieldDefinition+ }
	 */
	function parseInterfaceTypeDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'interface');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer);
	  var fields = any(lexer, _lexer.TokenKind.BRACE_L, parseFieldDefinition, _lexer.TokenKind.BRACE_R);
	  return {
	    kind: _kinds.INTERFACE_TYPE_DEFINITION,
	    name: name,
	    directives: directives,
	    fields: fields,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * UnionTypeDefinition : union Name Directives? = UnionMembers
	 */
	function parseUnionTypeDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'union');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer);
	  expect(lexer, _lexer.TokenKind.EQUALS);
	  var types = parseUnionMembers(lexer);
	  return {
	    kind: _kinds.UNION_TYPE_DEFINITION,
	    name: name,
	    directives: directives,
	    types: types,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * UnionMembers :
	 *   - NamedType
	 *   - UnionMembers | NamedType
	 */
	function parseUnionMembers(lexer) {
	  var members = [];
	  do {
	    members.push(parseNamedType(lexer));
	  } while (skip(lexer, _lexer.TokenKind.PIPE));
	  return members;
	}
	
	/**
	 * EnumTypeDefinition : enum Name Directives? { EnumValueDefinition+ }
	 */
	function parseEnumTypeDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'enum');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer);
	  var values = many(lexer, _lexer.TokenKind.BRACE_L, parseEnumValueDefinition, _lexer.TokenKind.BRACE_R);
	  return {
	    kind: _kinds.ENUM_TYPE_DEFINITION,
	    name: name,
	    directives: directives,
	    values: values,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * EnumValueDefinition : EnumValue Directives?
	 *
	 * EnumValue : Name
	 */
	function parseEnumValueDefinition(lexer) {
	  var start = lexer.token;
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer);
	  return {
	    kind: _kinds.ENUM_VALUE_DEFINITION,
	    name: name,
	    directives: directives,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * InputObjectTypeDefinition : input Name Directives? { InputValueDefinition+ }
	 */
	function parseInputObjectTypeDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'input');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer);
	  var fields = any(lexer, _lexer.TokenKind.BRACE_L, parseInputValueDef, _lexer.TokenKind.BRACE_R);
	  return {
	    kind: _kinds.INPUT_OBJECT_TYPE_DEFINITION,
	    name: name,
	    directives: directives,
	    fields: fields,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * TypeExtensionDefinition : extend ObjectTypeDefinition
	 */
	function parseTypeExtensionDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'extend');
	  var definition = parseObjectTypeDefinition(lexer);
	  return {
	    kind: _kinds.TYPE_EXTENSION_DEFINITION,
	    definition: definition,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * DirectiveDefinition :
	 *   - directive @ Name ArgumentsDefinition? on DirectiveLocations
	 */
	function parseDirectiveDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'directive');
	  expect(lexer, _lexer.TokenKind.AT);
	  var name = parseName(lexer);
	  var args = parseArgumentDefs(lexer);
	  expectKeyword(lexer, 'on');
	  var locations = parseDirectiveLocations(lexer);
	  return {
	    kind: _kinds.DIRECTIVE_DEFINITION,
	    name: name,
	    arguments: args,
	    locations: locations,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * DirectiveLocations :
	 *   - Name
	 *   - DirectiveLocations | Name
	 */
	function parseDirectiveLocations(lexer) {
	  var locations = [];
	  do {
	    locations.push(parseName(lexer));
	  } while (skip(lexer, _lexer.TokenKind.PIPE));
	  return locations;
	}
	
	// Core parsing utility functions
	
	/**
	 * Returns a location object, used to identify the place in
	 * the source that created a given parsed object.
	 */
	function loc(lexer, startToken) {
	  if (!lexer.options.noLocation) {
	    return new Loc(startToken, lexer.lastToken, lexer.source);
	  }
	}
	
	function Loc(startToken, endToken, source) {
	  this.start = startToken.start;
	  this.end = endToken.end;
	  this.startToken = startToken;
	  this.endToken = endToken;
	  this.source = source;
	}
	
	// Print a simplified form when appearing in JSON/util.inspect.
	Loc.prototype.toJSON = Loc.prototype.inspect = function toJSON() {
	  return { start: this.start, end: this.end };
	};
	
	/**
	 * Determines if the next token is of a given kind
	 */
	function peek(lexer, kind) {
	  return lexer.token.kind === kind;
	}
	
	/**
	 * If the next token is of the given kind, return true after advancing
	 * the lexer. Otherwise, do not change the parser state and return false.
	 */
	function skip(lexer, kind) {
	  var match = lexer.token.kind === kind;
	  if (match) {
	    lexer.advance();
	  }
	  return match;
	}
	
	/**
	 * If the next token is of the given kind, return that token after advancing
	 * the lexer. Otherwise, do not change the parser state and throw an error.
	 */
	function expect(lexer, kind) {
	  var token = lexer.token;
	  if (token.kind === kind) {
	    lexer.advance();
	    return token;
	  }
	  throw (0, _error.syntaxError)(lexer.source, token.start, 'Expected ' + kind + ', found ' + (0, _lexer.getTokenDesc)(token));
	}
	
	/**
	 * If the next token is a keyword with the given value, return that token after
	 * advancing the lexer. Otherwise, do not change the parser state and return
	 * false.
	 */
	function expectKeyword(lexer, value) {
	  var token = lexer.token;
	  if (token.kind === _lexer.TokenKind.NAME && token.value === value) {
	    lexer.advance();
	    return token;
	  }
	  throw (0, _error.syntaxError)(lexer.source, token.start, 'Expected "' + value + '", found ' + (0, _lexer.getTokenDesc)(token));
	}
	
	/**
	 * Helper function for creating an error when an unexpected lexed token
	 * is encountered.
	 */
	function unexpected(lexer, atToken) {
	  var token = atToken || lexer.token;
	  return (0, _error.syntaxError)(lexer.source, token.start, 'Unexpected ' + (0, _lexer.getTokenDesc)(token));
	}
	
	/**
	 * Returns a possibly empty list of parse nodes, determined by
	 * the parseFn. This list begins with a lex token of openKind
	 * and ends with a lex token of closeKind. Advances the parser
	 * to the next lex token after the closing token.
	 */
	function any(lexer, openKind, parseFn, closeKind) {
	  expect(lexer, openKind);
	  var nodes = [];
	  while (!skip(lexer, closeKind)) {
	    nodes.push(parseFn(lexer));
	  }
	  return nodes;
	}
	
	/**
	 * Returns a non-empty list of parse nodes, determined by
	 * the parseFn. This list begins with a lex token of openKind
	 * and ends with a lex token of closeKind. Advances the parser
	 * to the next lex token after the closing token.
	 */
	function many(lexer, openKind, parseFn, closeKind) {
	  expect(lexer, openKind);
	  var nodes = [parseFn(lexer)];
	  while (!skip(lexer, closeKind)) {
	    nodes.push(parseFn(lexer));
	  }
	  return nodes;
	}

/***/ },

/***/ "./node_modules/graphql/error/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GraphQLError = __webpack_require__("./node_modules/graphql/error/GraphQLError.js");
	
	Object.defineProperty(exports, 'GraphQLError', {
	  enumerable: true,
	  get: function get() {
	    return _GraphQLError.GraphQLError;
	  }
	});
	
	var _syntaxError = __webpack_require__("./node_modules/graphql/error/syntaxError.js");
	
	Object.defineProperty(exports, 'syntaxError', {
	  enumerable: true,
	  get: function get() {
	    return _syntaxError.syntaxError;
	  }
	});
	
	var _locatedError = __webpack_require__("./node_modules/graphql/error/locatedError.js");
	
	Object.defineProperty(exports, 'locatedError', {
	  enumerable: true,
	  get: function get() {
	    return _locatedError.locatedError;
	  }
	});
	
	var _formatError = __webpack_require__("./node_modules/graphql/error/formatError.js");
	
	Object.defineProperty(exports, 'formatError', {
	  enumerable: true,
	  get: function get() {
	    return _formatError.formatError;
	  }
	});

/***/ },

/***/ "./node_modules/graphql/error/GraphQLError.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GraphQLError = GraphQLError;
	
	var _language = __webpack_require__("./node_modules/graphql/language/index.js");
	
	/**
	 * A GraphQLError describes an Error found during the parse, validate, or
	 * execute phases of performing a GraphQL operation. In addition to a message
	 * and stack trace, it also includes information about the locations in a
	 * GraphQL document and/or execution result that correspond to the Error.
	 */
	function GraphQLError( // eslint-disable-line no-redeclare
	message, nodes, source, positions, path, originalError) {
	  // Include (non-enumerable) stack trace.
	  if (originalError && originalError.stack) {
	    Object.defineProperty(this, 'stack', {
	      value: originalError.stack,
	      writable: true,
	      configurable: true
	    });
	  } else if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, GraphQLError);
	  } else {
	    Object.defineProperty(this, 'stack', {
	      value: Error().stack,
	      writable: true,
	      configurable: true
	    });
	  }
	
	  // Compute locations in the source for the given nodes/positions.
	  var _source = source;
	  if (!_source && nodes && nodes.length > 0) {
	    var node = nodes[0];
	    _source = node && node.loc && node.loc.source;
	  }
	
	  var _positions = positions;
	  if (!_positions && nodes) {
	    _positions = nodes.filter(function (node) {
	      return Boolean(node.loc);
	    }).map(function (node) {
	      return node.loc.start;
	    });
	  }
	  if (_positions && _positions.length === 0) {
	    _positions = undefined;
	  }
	
	  var _locations = void 0;
	  var _source2 = _source; // seems here Flow need a const to resolve type.
	  if (_source2 && _positions) {
	    _locations = _positions.map(function (pos) {
	      return (0, _language.getLocation)(_source2, pos);
	    });
	  }
	
	  Object.defineProperties(this, {
	    message: {
	      value: message,
	      // By being enumerable, JSON.stringify will include `message` in the
	      // resulting output. This ensures that the simplist possible GraphQL
	      // service adheres to the spec.
	      enumerable: true,
	      writable: true
	    },
	    locations: {
	      // Coercing falsey values to undefined ensures they will not be included
	      // in JSON.stringify() when not provided.
	      value: _locations || undefined,
	      // By being enumerable, JSON.stringify will include `locations` in the
	      // resulting output. This ensures that the simplist possible GraphQL
	      // service adheres to the spec.
	      enumerable: true
	    },
	    path: {
	      // Coercing falsey values to undefined ensures they will not be included
	      // in JSON.stringify() when not provided.
	      value: path || undefined,
	      // By being enumerable, JSON.stringify will include `path` in the
	      // resulting output. This ensures that the simplist possible GraphQL
	      // service adheres to the spec.
	      enumerable: true
	    },
	    nodes: {
	      value: nodes || undefined
	    },
	    source: {
	      value: _source || undefined
	    },
	    positions: {
	      value: _positions || undefined
	    },
	    originalError: {
	      value: originalError
	    }
	  });
	}
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	GraphQLError.prototype = Object.create(Error.prototype, {
	  constructor: { value: GraphQLError },
	  name: { value: 'GraphQLError' }
	});

/***/ },

/***/ "./node_modules/graphql/language/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BREAK = exports.visitWithTypeInfo = exports.visitInParallel = exports.visit = exports.Source = exports.print = exports.parseType = exports.parseValue = exports.parse = exports.TokenKind = exports.createLexer = exports.Kind = exports.getLocation = undefined;
	
	var _location = __webpack_require__("./node_modules/graphql/language/location.js");
	
	Object.defineProperty(exports, 'getLocation', {
	  enumerable: true,
	  get: function get() {
	    return _location.getLocation;
	  }
	});
	
	var _lexer = __webpack_require__("./node_modules/graphql/language/lexer.js");
	
	Object.defineProperty(exports, 'createLexer', {
	  enumerable: true,
	  get: function get() {
	    return _lexer.createLexer;
	  }
	});
	Object.defineProperty(exports, 'TokenKind', {
	  enumerable: true,
	  get: function get() {
	    return _lexer.TokenKind;
	  }
	});
	
	var _parser = __webpack_require__("./node_modules/graphql/language/parser.js");
	
	Object.defineProperty(exports, 'parse', {
	  enumerable: true,
	  get: function get() {
	    return _parser.parse;
	  }
	});
	Object.defineProperty(exports, 'parseValue', {
	  enumerable: true,
	  get: function get() {
	    return _parser.parseValue;
	  }
	});
	Object.defineProperty(exports, 'parseType', {
	  enumerable: true,
	  get: function get() {
	    return _parser.parseType;
	  }
	});
	
	var _printer = __webpack_require__("./node_modules/graphql/language/printer.js");
	
	Object.defineProperty(exports, 'print', {
	  enumerable: true,
	  get: function get() {
	    return _printer.print;
	  }
	});
	
	var _source = __webpack_require__("./node_modules/graphql/language/source.js");
	
	Object.defineProperty(exports, 'Source', {
	  enumerable: true,
	  get: function get() {
	    return _source.Source;
	  }
	});
	
	var _visitor = __webpack_require__("./node_modules/graphql/language/visitor.js");
	
	Object.defineProperty(exports, 'visit', {
	  enumerable: true,
	  get: function get() {
	    return _visitor.visit;
	  }
	});
	Object.defineProperty(exports, 'visitInParallel', {
	  enumerable: true,
	  get: function get() {
	    return _visitor.visitInParallel;
	  }
	});
	Object.defineProperty(exports, 'visitWithTypeInfo', {
	  enumerable: true,
	  get: function get() {
	    return _visitor.visitWithTypeInfo;
	  }
	});
	Object.defineProperty(exports, 'BREAK', {
	  enumerable: true,
	  get: function get() {
	    return _visitor.BREAK;
	  }
	});
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	var Kind = _interopRequireWildcard(_kinds);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.Kind = Kind;

/***/ },

/***/ "./node_modules/graphql/language/location.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLocation = getLocation;
	
	
	/**
	 * Takes a Source and a UTF-8 character offset, and returns the corresponding
	 * line and column as a SourceLocation.
	 */
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function getLocation(source, position) {
	  var lineRegexp = /\r\n|[\n\r]/g;
	  var line = 1;
	  var column = position + 1;
	  var match = void 0;
	  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
	    line += 1;
	    column = position + 1 - (match.index + match[0].length);
	  }
	  return { line: line, column: column };
	}
	
	/**
	 * Represents a location in a Source.
	 */

/***/ },

/***/ "./node_modules/graphql/language/lexer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TokenKind = undefined;
	exports.createLexer = createLexer;
	exports.getTokenDesc = getTokenDesc;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	/**
	 * Given a Source object, this returns a Lexer for that source.
	 * A Lexer is a stateful stream generator in that every time
	 * it is advanced, it returns the next token in the Source. Assuming the
	 * source lexes, the final Token emitted by the lexer will be of kind
	 * EOF, after which the lexer will repeatedly return the same EOF token
	 * whenever called.
	 */
	function createLexer(source, options) {
	  var startOfFileToken = new Tok(SOF, 0, 0, 0, 0, null);
	  var lexer = {
	    source: source,
	    options: options,
	    lastToken: startOfFileToken,
	    token: startOfFileToken,
	    line: 1,
	    lineStart: 0,
	    advance: advanceLexer
	  };
	  return lexer;
	} /*  /
	  /**
	   *  Copyright (c) 2015, Facebook, Inc.
	   *  All rights reserved.
	   *
	   *  This source code is licensed under the BSD-style license found in the
	   *  LICENSE file in the root directory of this source tree. An additional grant
	   *  of patent rights can be found in the PATENTS file in the same directory.
	   */
	
	function advanceLexer() {
	  var token = this.lastToken = this.token;
	  if (token.kind !== EOF) {
	    do {
	      token = token.next = readToken(this, token);
	    } while (token.kind === COMMENT);
	    this.token = token;
	  }
	  return token;
	}
	
	/**
	 * The return type of createLexer.
	 */
	
	
	// Each kind of token.
	var SOF = '<SOF>';
	var EOF = '<EOF>';
	var BANG = '!';
	var DOLLAR = '$';
	var PAREN_L = '(';
	var PAREN_R = ')';
	var SPREAD = '...';
	var COLON = ':';
	var EQUALS = '=';
	var AT = '@';
	var BRACKET_L = '[';
	var BRACKET_R = ']';
	var BRACE_L = '{';
	var PIPE = '|';
	var BRACE_R = '}';
	var NAME = 'Name';
	var INT = 'Int';
	var FLOAT = 'Float';
	var STRING = 'String';
	var COMMENT = 'Comment';
	
	/**
	 * An exported enum describing the different kinds of tokens that the
	 * lexer emits.
	 */
	var TokenKind = exports.TokenKind = {
	  SOF: SOF,
	  EOF: EOF,
	  BANG: BANG,
	  DOLLAR: DOLLAR,
	  PAREN_L: PAREN_L,
	  PAREN_R: PAREN_R,
	  SPREAD: SPREAD,
	  COLON: COLON,
	  EQUALS: EQUALS,
	  AT: AT,
	  BRACKET_L: BRACKET_L,
	  BRACKET_R: BRACKET_R,
	  BRACE_L: BRACE_L,
	  PIPE: PIPE,
	  BRACE_R: BRACE_R,
	  NAME: NAME,
	  INT: INT,
	  FLOAT: FLOAT,
	  STRING: STRING,
	  COMMENT: COMMENT
	};
	
	/**
	 * A helper function to describe a token as a string for debugging
	 */
	function getTokenDesc(token) {
	  var value = token.value;
	  return value ? token.kind + ' "' + value + '"' : token.kind;
	}
	
	var charCodeAt = String.prototype.charCodeAt;
	var slice = String.prototype.slice;
	
	/**
	 * Helper function for constructing the Token object.
	 */
	function Tok(kind, start, end, line, column, prev, value) {
	  this.kind = kind;
	  this.start = start;
	  this.end = end;
	  this.line = line;
	  this.column = column;
	  this.value = value;
	  this.prev = prev;
	  this.next = null;
	}
	
	// Print a simplified form when appearing in JSON/util.inspect.
	Tok.prototype.toJSON = Tok.prototype.inspect = function toJSON() {
	  return {
	    kind: this.kind,
	    value: this.value,
	    line: this.line,
	    column: this.column
	  };
	};
	
	function printCharCode(code) {
	  return (
	    // NaN/undefined represents access beyond the end of the file.
	    isNaN(code) ? EOF :
	    // Trust JSON for ASCII.
	    code < 0x007F ? JSON.stringify(String.fromCharCode(code)) :
	    // Otherwise print the escaped form.
	    '"\\u' + ('00' + code.toString(16).toUpperCase()).slice(-4) + '"'
	  );
	}
	
	/**
	 * Gets the next token from the source starting at the given position.
	 *
	 * This skips over whitespace and comments until it finds the next lexable
	 * token, then lexes punctuators immediately or calls the appropriate helper
	 * function for more complicated tokens.
	 */
	function readToken(lexer, prev) {
	  var source = lexer.source;
	  var body = source.body;
	  var bodyLength = body.length;
	
	  var position = positionAfterWhitespace(body, prev.end, lexer);
	  var line = lexer.line;
	  var col = 1 + position - lexer.lineStart;
	
	  if (position >= bodyLength) {
	    return new Tok(EOF, bodyLength, bodyLength, line, col, prev);
	  }
	
	  var code = charCodeAt.call(body, position);
	
	  // SourceCharacter
	  if (code < 0x0020 && code !== 0x0009 && code !== 0x000A && code !== 0x000D) {
	    throw (0, _error.syntaxError)(source, position, 'Cannot contain the invalid character ' + printCharCode(code) + '.');
	  }
	
	  switch (code) {
	    // !
	    case 33:
	      return new Tok(BANG, position, position + 1, line, col, prev);
	    // #
	    case 35:
	      return readComment(source, position, line, col, prev);
	    // $
	    case 36:
	      return new Tok(DOLLAR, position, position + 1, line, col, prev);
	    // (
	    case 40:
	      return new Tok(PAREN_L, position, position + 1, line, col, prev);
	    // )
	    case 41:
	      return new Tok(PAREN_R, position, position + 1, line, col, prev);
	    // .
	    case 46:
	      if (charCodeAt.call(body, position + 1) === 46 && charCodeAt.call(body, position + 2) === 46) {
	        return new Tok(SPREAD, position, position + 3, line, col, prev);
	      }
	      break;
	    // :
	    case 58:
	      return new Tok(COLON, position, position + 1, line, col, prev);
	    // =
	    case 61:
	      return new Tok(EQUALS, position, position + 1, line, col, prev);
	    // @
	    case 64:
	      return new Tok(AT, position, position + 1, line, col, prev);
	    // [
	    case 91:
	      return new Tok(BRACKET_L, position, position + 1, line, col, prev);
	    // ]
	    case 93:
	      return new Tok(BRACKET_R, position, position + 1, line, col, prev);
	    // {
	    case 123:
	      return new Tok(BRACE_L, position, position + 1, line, col, prev);
	    // |
	    case 124:
	      return new Tok(PIPE, position, position + 1, line, col, prev);
	    // }
	    case 125:
	      return new Tok(BRACE_R, position, position + 1, line, col, prev);
	    // A-Z _ a-z
	    case 65:case 66:case 67:case 68:case 69:case 70:case 71:case 72:
	    case 73:case 74:case 75:case 76:case 77:case 78:case 79:case 80:
	    case 81:case 82:case 83:case 84:case 85:case 86:case 87:case 88:
	    case 89:case 90:
	    case 95:
	    case 97:case 98:case 99:case 100:case 101:case 102:case 103:case 104:
	    case 105:case 106:case 107:case 108:case 109:case 110:case 111:
	    case 112:case 113:case 114:case 115:case 116:case 117:case 118:
	    case 119:case 120:case 121:case 122:
	      return readName(source, position, line, col, prev);
	    // - 0-9
	    case 45:
	    case 48:case 49:case 50:case 51:case 52:
	    case 53:case 54:case 55:case 56:case 57:
	      return readNumber(source, position, code, line, col, prev);
	    // "
	    case 34:
	      return readString(source, position, line, col, prev);
	  }
	
	  throw (0, _error.syntaxError)(source, position, unexpectedCharacterMessage(code));
	}
	
	/**
	 * Report a message that an unexpected character was encountered.
	 */
	function unexpectedCharacterMessage(code) {
	  if (code === 39) {
	    // '
	    return 'Unexpected single quote character (\'), did you mean to use ' + 'a double quote (")?';
	  }
	
	  return 'Cannot parse the unexpected character ' + printCharCode(code) + '.';
	}
	
	/**
	 * Reads from body starting at startPosition until it finds a non-whitespace
	 * or commented character, then returns the position of that character for
	 * lexing.
	 */
	function positionAfterWhitespace(body, startPosition, lexer) {
	  var bodyLength = body.length;
	  var position = startPosition;
	  while (position < bodyLength) {
	    var code = charCodeAt.call(body, position);
	    // tab | space | comma | BOM
	    if (code === 9 || code === 32 || code === 44 || code === 0xFEFF) {
	      ++position;
	    } else if (code === 10) {
	      // new line
	      ++position;
	      ++lexer.line;
	      lexer.lineStart = position;
	    } else if (code === 13) {
	      // carriage return
	      if (charCodeAt.call(body, position + 1) === 10) {
	        position += 2;
	      } else {
	        ++position;
	      }
	      ++lexer.line;
	      lexer.lineStart = position;
	    } else {
	      break;
	    }
	  }
	  return position;
	}
	
	/**
	 * Reads a comment token from the source file.
	 *
	 * #[\u0009\u0020-\uFFFF]*
	 */
	function readComment(source, start, line, col, prev) {
	  var body = source.body;
	  var code = void 0;
	  var position = start;
	
	  do {
	    code = charCodeAt.call(body, ++position);
	  } while (code !== null && (
	  // SourceCharacter but not LineTerminator
	  code > 0x001F || code === 0x0009));
	
	  return new Tok(COMMENT, start, position, line, col, prev, slice.call(body, start + 1, position));
	}
	
	/**
	 * Reads a number token from the source file, either a float
	 * or an int depending on whether a decimal point appears.
	 *
	 * Int:   -?(0|[1-9][0-9]*)
	 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
	 */
	function readNumber(source, start, firstCode, line, col, prev) {
	  var body = source.body;
	  var code = firstCode;
	  var position = start;
	  var isFloat = false;
	
	  if (code === 45) {
	    // -
	    code = charCodeAt.call(body, ++position);
	  }
	
	  if (code === 48) {
	    // 0
	    code = charCodeAt.call(body, ++position);
	    if (code >= 48 && code <= 57) {
	      throw (0, _error.syntaxError)(source, position, 'Invalid number, unexpected digit after 0: ' + printCharCode(code) + '.');
	    }
	  } else {
	    position = readDigits(source, position, code);
	    code = charCodeAt.call(body, position);
	  }
	
	  if (code === 46) {
	    // .
	    isFloat = true;
	
	    code = charCodeAt.call(body, ++position);
	    position = readDigits(source, position, code);
	    code = charCodeAt.call(body, position);
	  }
	
	  if (code === 69 || code === 101) {
	    // E e
	    isFloat = true;
	
	    code = charCodeAt.call(body, ++position);
	    if (code === 43 || code === 45) {
	      // + -
	      code = charCodeAt.call(body, ++position);
	    }
	    position = readDigits(source, position, code);
	  }
	
	  return new Tok(isFloat ? FLOAT : INT, start, position, line, col, prev, slice.call(body, start, position));
	}
	
	/**
	 * Returns the new position in the source after reading digits.
	 */
	function readDigits(source, start, firstCode) {
	  var body = source.body;
	  var position = start;
	  var code = firstCode;
	  if (code >= 48 && code <= 57) {
	    // 0 - 9
	    do {
	      code = charCodeAt.call(body, ++position);
	    } while (code >= 48 && code <= 57); // 0 - 9
	    return position;
	  }
	  throw (0, _error.syntaxError)(source, position, 'Invalid number, expected digit but got: ' + printCharCode(code) + '.');
	}
	
	/**
	 * Reads a string token from the source file.
	 *
	 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
	 */
	function readString(source, start, line, col, prev) {
	  var body = source.body;
	  var position = start + 1;
	  var chunkStart = position;
	  var code = 0;
	  var value = '';
	
	  while (position < body.length && (code = charCodeAt.call(body, position)) !== null &&
	  // not LineTerminator
	  code !== 0x000A && code !== 0x000D &&
	  // not Quote (")
	  code !== 34) {
	    // SourceCharacter
	    if (code < 0x0020 && code !== 0x0009) {
	      throw (0, _error.syntaxError)(source, position, 'Invalid character within String: ' + printCharCode(code) + '.');
	    }
	
	    ++position;
	    if (code === 92) {
	      // \
	      value += slice.call(body, chunkStart, position - 1);
	      code = charCodeAt.call(body, position);
	      switch (code) {
	        case 34:
	          value += '"';break;
	        case 47:
	          value += '/';break;
	        case 92:
	          value += '\\';break;
	        case 98:
	          value += '\b';break;
	        case 102:
	          value += '\f';break;
	        case 110:
	          value += '\n';break;
	        case 114:
	          value += '\r';break;
	        case 116:
	          value += '\t';break;
	        case 117:
	          // u
	          var charCode = uniCharCode(charCodeAt.call(body, position + 1), charCodeAt.call(body, position + 2), charCodeAt.call(body, position + 3), charCodeAt.call(body, position + 4));
	          if (charCode < 0) {
	            throw (0, _error.syntaxError)(source, position, 'Invalid character escape sequence: ' + ('\\u' + body.slice(position + 1, position + 5) + '.'));
	          }
	          value += String.fromCharCode(charCode);
	          position += 4;
	          break;
	        default:
	          throw (0, _error.syntaxError)(source, position, 'Invalid character escape sequence: \\' + String.fromCharCode(code) + '.');
	      }
	      ++position;
	      chunkStart = position;
	    }
	  }
	
	  if (code !== 34) {
	    // quote (")
	    throw (0, _error.syntaxError)(source, position, 'Unterminated string.');
	  }
	
	  value += slice.call(body, chunkStart, position);
	  return new Tok(STRING, start, position + 1, line, col, prev, value);
	}
	
	/**
	 * Converts four hexidecimal chars to the integer that the
	 * string represents. For example, uniCharCode('0','0','0','f')
	 * will return 15, and uniCharCode('0','0','f','f') returns 255.
	 *
	 * Returns a negative number on error, if a char was invalid.
	 *
	 * This is implemented by noting that char2hex() returns -1 on error,
	 * which means the result of ORing the char2hex() will also be negative.
	 */
	function uniCharCode(a, b, c, d) {
	  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
	}
	
	/**
	 * Converts a hex character to its integer value.
	 * '0' becomes 0, '9' becomes 9
	 * 'A' becomes 10, 'F' becomes 15
	 * 'a' becomes 10, 'f' becomes 15
	 *
	 * Returns -1 on error.
	 */
	function char2hex(a) {
	  return a >= 48 && a <= 57 ? a - 48 : // 0-9
	  a >= 65 && a <= 70 ? a - 55 : // A-F
	  a >= 97 && a <= 102 ? a - 87 : // a-f
	  -1;
	}
	
	/**
	 * Reads an alphanumeric + underscore name from the source.
	 *
	 * [_A-Za-z][_0-9A-Za-z]*
	 */
	function readName(source, position, line, col, prev) {
	  var body = source.body;
	  var bodyLength = body.length;
	  var end = position + 1;
	  var code = 0;
	  while (end !== bodyLength && (code = charCodeAt.call(body, end)) !== null && (code === 95 || // _
	  code >= 48 && code <= 57 || // 0-9
	  code >= 65 && code <= 90 || // A-Z
	  code >= 97 && code <= 122 // a-z
	  )) {
	    ++end;
	  }
	  return new Tok(NAME, position, end, line, col, prev, slice.call(body, position, end));
	}

/***/ },

/***/ "./node_modules/graphql/language/printer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.print = print;
	
	var _visitor = __webpack_require__("./node_modules/graphql/language/visitor.js");
	
	/**
	 * Converts an AST into a string, using one set of reasonable
	 * formatting rules.
	 */
	function print(ast) {
	  return (0, _visitor.visit)(ast, { leave: printDocASTReducer });
	} /**
	   *  Copyright (c) 2015, Facebook, Inc.
	   *  All rights reserved.
	   *
	   *  This source code is licensed under the BSD-style license found in the
	   *  LICENSE file in the root directory of this source tree. An additional grant
	   *  of patent rights can be found in the PATENTS file in the same directory.
	   */
	
	var printDocASTReducer = {
	  Name: function Name(node) {
	    return node.value;
	  },
	  Variable: function Variable(node) {
	    return '$' + node.name;
	  },
	
	  // Document
	
	  Document: function Document(node) {
	    return join(node.definitions, '\n\n') + '\n';
	  },
	
	  OperationDefinition: function OperationDefinition(node) {
	    var op = node.operation;
	    var name = node.name;
	    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
	    var directives = join(node.directives, ' ');
	    var selectionSet = node.selectionSet;
	    // Anonymous queries with no directives or variable definitions can use
	    // the query short form.
	    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
	  },
	
	
	  VariableDefinition: function VariableDefinition(_ref) {
	    var variable = _ref.variable,
	        type = _ref.type,
	        defaultValue = _ref.defaultValue;
	    return variable + ': ' + type + wrap(' = ', defaultValue);
	  },
	
	  SelectionSet: function SelectionSet(_ref2) {
	    var selections = _ref2.selections;
	    return block(selections);
	  },
	
	  Field: function Field(_ref3) {
	    var alias = _ref3.alias,
	        name = _ref3.name,
	        args = _ref3.arguments,
	        directives = _ref3.directives,
	        selectionSet = _ref3.selectionSet;
	    return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], ' ');
	  },
	
	  Argument: function Argument(_ref4) {
	    var name = _ref4.name,
	        value = _ref4.value;
	    return name + ': ' + value;
	  },
	
	  // Fragments
	
	  FragmentSpread: function FragmentSpread(_ref5) {
	    var name = _ref5.name,
	        directives = _ref5.directives;
	    return '...' + name + wrap(' ', join(directives, ' '));
	  },
	
	  InlineFragment: function InlineFragment(_ref6) {
	    var typeCondition = _ref6.typeCondition,
	        directives = _ref6.directives,
	        selectionSet = _ref6.selectionSet;
	    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
	  },
	
	  FragmentDefinition: function FragmentDefinition(_ref7) {
	    var name = _ref7.name,
	        typeCondition = _ref7.typeCondition,
	        directives = _ref7.directives,
	        selectionSet = _ref7.selectionSet;
	    return 'fragment ' + name + ' on ' + typeCondition + ' ' + wrap('', join(directives, ' '), ' ') + selectionSet;
	  },
	
	  // Value
	
	  IntValue: function IntValue(_ref8) {
	    var value = _ref8.value;
	    return value;
	  },
	  FloatValue: function FloatValue(_ref9) {
	    var value = _ref9.value;
	    return value;
	  },
	  StringValue: function StringValue(_ref10) {
	    var value = _ref10.value;
	    return JSON.stringify(value);
	  },
	  BooleanValue: function BooleanValue(_ref11) {
	    var value = _ref11.value;
	    return JSON.stringify(value);
	  },
	  NullValue: function NullValue() {
	    return 'null';
	  },
	  EnumValue: function EnumValue(_ref12) {
	    var value = _ref12.value;
	    return value;
	  },
	  ListValue: function ListValue(_ref13) {
	    var values = _ref13.values;
	    return '[' + join(values, ', ') + ']';
	  },
	  ObjectValue: function ObjectValue(_ref14) {
	    var fields = _ref14.fields;
	    return '{' + join(fields, ', ') + '}';
	  },
	  ObjectField: function ObjectField(_ref15) {
	    var name = _ref15.name,
	        value = _ref15.value;
	    return name + ': ' + value;
	  },
	
	  // Directive
	
	  Directive: function Directive(_ref16) {
	    var name = _ref16.name,
	        args = _ref16.arguments;
	    return '@' + name + wrap('(', join(args, ', '), ')');
	  },
	
	  // Type
	
	  NamedType: function NamedType(_ref17) {
	    var name = _ref17.name;
	    return name;
	  },
	  ListType: function ListType(_ref18) {
	    var type = _ref18.type;
	    return '[' + type + ']';
	  },
	  NonNullType: function NonNullType(_ref19) {
	    var type = _ref19.type;
	    return type + '!';
	  },
	
	  // Type System Definitions
	
	  SchemaDefinition: function SchemaDefinition(_ref20) {
	    var directives = _ref20.directives,
	        operationTypes = _ref20.operationTypes;
	    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
	  },
	
	  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
	    var operation = _ref21.operation,
	        type = _ref21.type;
	    return operation + ': ' + type;
	  },
	
	  ScalarTypeDefinition: function ScalarTypeDefinition(_ref22) {
	    var name = _ref22.name,
	        directives = _ref22.directives;
	    return join(['scalar', name, join(directives, ' ')], ' ');
	  },
	
	  ObjectTypeDefinition: function ObjectTypeDefinition(_ref23) {
	    var name = _ref23.name,
	        interfaces = _ref23.interfaces,
	        directives = _ref23.directives,
	        fields = _ref23.fields;
	    return join(['type', name, wrap('implements ', join(interfaces, ', ')), join(directives, ' '), block(fields)], ' ');
	  },
	
	  FieldDefinition: function FieldDefinition(_ref24) {
	    var name = _ref24.name,
	        args = _ref24.arguments,
	        type = _ref24.type,
	        directives = _ref24.directives;
	    return name + wrap('(', join(args, ', '), ')') + ': ' + type + wrap(' ', join(directives, ' '));
	  },
	
	  InputValueDefinition: function InputValueDefinition(_ref25) {
	    var name = _ref25.name,
	        type = _ref25.type,
	        defaultValue = _ref25.defaultValue,
	        directives = _ref25.directives;
	    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
	  },
	
	  InterfaceTypeDefinition: function InterfaceTypeDefinition(_ref26) {
	    var name = _ref26.name,
	        directives = _ref26.directives,
	        fields = _ref26.fields;
	    return join(['interface', name, join(directives, ' '), block(fields)], ' ');
	  },
	
	  UnionTypeDefinition: function UnionTypeDefinition(_ref27) {
	    var name = _ref27.name,
	        directives = _ref27.directives,
	        types = _ref27.types;
	    return join(['union', name, join(directives, ' '), '= ' + join(types, ' | ')], ' ');
	  },
	
	  EnumTypeDefinition: function EnumTypeDefinition(_ref28) {
	    var name = _ref28.name,
	        directives = _ref28.directives,
	        values = _ref28.values;
	    return join(['enum', name, join(directives, ' '), block(values)], ' ');
	  },
	
	  EnumValueDefinition: function EnumValueDefinition(_ref29) {
	    var name = _ref29.name,
	        directives = _ref29.directives;
	    return join([name, join(directives, ' ')], ' ');
	  },
	
	  InputObjectTypeDefinition: function InputObjectTypeDefinition(_ref30) {
	    var name = _ref30.name,
	        directives = _ref30.directives,
	        fields = _ref30.fields;
	    return join(['input', name, join(directives, ' '), block(fields)], ' ');
	  },
	
	  TypeExtensionDefinition: function TypeExtensionDefinition(_ref31) {
	    var definition = _ref31.definition;
	    return 'extend ' + definition;
	  },
	
	  DirectiveDefinition: function DirectiveDefinition(_ref32) {
	    var name = _ref32.name,
	        args = _ref32.arguments,
	        locations = _ref32.locations;
	    return 'directive @' + name + wrap('(', join(args, ', '), ')') + ' on ' + join(locations, ' | ');
	  }
	};
	
	/**
	 * Given maybeArray, print an empty string if it is null or empty, otherwise
	 * print all items together separated by separator if provided
	 */
	function join(maybeArray, separator) {
	  return maybeArray ? maybeArray.filter(function (x) {
	    return x;
	  }).join(separator || '') : '';
	}
	
	/**
	 * Given array, print each item on its own line, wrapped in an
	 * indented "{ }" block.
	 */
	function block(array) {
	  return array && array.length !== 0 ? indent('{\n' + join(array, '\n')) + '\n}' : '{}';
	}
	
	/**
	 * If maybeString is not null or empty, then wrap with start and end, otherwise
	 * print an empty string.
	 */
	function wrap(start, maybeString, end) {
	  return maybeString ? start + maybeString + (end || '') : '';
	}
	
	function indent(maybeString) {
	  return maybeString && maybeString.replace(/\n/g, '\n  ');
	}

/***/ },

/***/ "./node_modules/graphql/language/visitor.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.visit = visit;
	exports.visitInParallel = visitInParallel;
	exports.visitWithTypeInfo = visitWithTypeInfo;
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	var QueryDocumentKeys = exports.QueryDocumentKeys = {
	  Name: [],
	
	  Document: ['definitions'],
	  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
	  VariableDefinition: ['variable', 'type', 'defaultValue'],
	  Variable: ['name'],
	  SelectionSet: ['selections'],
	  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
	  Argument: ['name', 'value'],
	
	  FragmentSpread: ['name', 'directives'],
	  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
	  FragmentDefinition: ['name', 'typeCondition', 'directives', 'selectionSet'],
	
	  IntValue: [],
	  FloatValue: [],
	  StringValue: [],
	  BooleanValue: [],
	  NullValue: [],
	  EnumValue: [],
	  ListValue: ['values'],
	  ObjectValue: ['fields'],
	  ObjectField: ['name', 'value'],
	
	  Directive: ['name', 'arguments'],
	
	  NamedType: ['name'],
	  ListType: ['type'],
	  NonNullType: ['type'],
	
	  SchemaDefinition: ['directives', 'operationTypes'],
	  OperationTypeDefinition: ['type'],
	
	  ScalarTypeDefinition: ['name', 'directives'],
	  ObjectTypeDefinition: ['name', 'interfaces', 'directives', 'fields'],
	  FieldDefinition: ['name', 'arguments', 'type', 'directives'],
	  InputValueDefinition: ['name', 'type', 'defaultValue', 'directives'],
	  InterfaceTypeDefinition: ['name', 'directives', 'fields'],
	  UnionTypeDefinition: ['name', 'directives', 'types'],
	  EnumTypeDefinition: ['name', 'directives', 'values'],
	  EnumValueDefinition: ['name', 'directives'],
	  InputObjectTypeDefinition: ['name', 'directives', 'fields'],
	
	  TypeExtensionDefinition: ['definition'],
	
	  DirectiveDefinition: ['name', 'arguments', 'locations']
	};
	
	var BREAK = exports.BREAK = {};
	
	/**
	 * visit() will walk through an AST using a depth first traversal, calling
	 * the visitor's enter function at each node in the traversal, and calling the
	 * leave function after visiting that node and all of its child nodes.
	 *
	 * By returning different values from the enter and leave functions, the
	 * behavior of the visitor can be altered, including skipping over a sub-tree of
	 * the AST (by returning false), editing the AST by returning a value or null
	 * to remove the value, or to stop the whole traversal by returning BREAK.
	 *
	 * When using visit() to edit an AST, the original AST will not be modified, and
	 * a new version of the AST with the changes applied will be returned from the
	 * visit function.
	 *
	 *     const editedAST = visit(ast, {
	 *       enter(node, key, parent, path, ancestors) {
	 *         // @return
	 *         //   undefined: no action
	 *         //   false: skip visiting this node
	 *         //   visitor.BREAK: stop visiting altogether
	 *         //   null: delete this node
	 *         //   any value: replace this node with the returned value
	 *       },
	 *       leave(node, key, parent, path, ancestors) {
	 *         // @return
	 *         //   undefined: no action
	 *         //   false: no action
	 *         //   visitor.BREAK: stop visiting altogether
	 *         //   null: delete this node
	 *         //   any value: replace this node with the returned value
	 *       }
	 *     });
	 *
	 * Alternatively to providing enter() and leave() functions, a visitor can
	 * instead provide functions named the same as the kinds of AST nodes, or
	 * enter/leave visitors at a named key, leading to four permutations of
	 * visitor API:
	 *
	 * 1) Named visitors triggered when entering a node a specific kind.
	 *
	 *     visit(ast, {
	 *       Kind(node) {
	 *         // enter the "Kind" node
	 *       }
	 *     })
	 *
	 * 2) Named visitors that trigger upon entering and leaving a node of
	 *    a specific kind.
	 *
	 *     visit(ast, {
	 *       Kind: {
	 *         enter(node) {
	 *           // enter the "Kind" node
	 *         }
	 *         leave(node) {
	 *           // leave the "Kind" node
	 *         }
	 *       }
	 *     })
	 *
	 * 3) Generic visitors that trigger upon entering and leaving any node.
	 *
	 *     visit(ast, {
	 *       enter(node) {
	 *         // enter any node
	 *       },
	 *       leave(node) {
	 *         // leave any node
	 *       }
	 *     })
	 *
	 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
	 *
	 *     visit(ast, {
	 *       enter: {
	 *         Kind(node) {
	 *           // enter the "Kind" node
	 *         }
	 *       },
	 *       leave: {
	 *         Kind(node) {
	 *           // leave the "Kind" node
	 *         }
	 *       }
	 *     })
	 */
	function visit(root, visitor, keyMap) {
	  var visitorKeys = keyMap || QueryDocumentKeys;
	
	  var stack = void 0;
	  var inArray = Array.isArray(root);
	  var keys = [root];
	  var index = -1;
	  var edits = [];
	  var parent = void 0;
	  var path = [];
	  var ancestors = [];
	  var newRoot = root;
	
	  do {
	    index++;
	    var isLeaving = index === keys.length;
	    var key = void 0;
	    var node = void 0;
	    var isEdited = isLeaving && edits.length !== 0;
	    if (isLeaving) {
	      key = ancestors.length === 0 ? undefined : path.pop();
	      node = parent;
	      parent = ancestors.pop();
	      if (isEdited) {
	        if (inArray) {
	          node = node.slice();
	        } else {
	          var clone = {};
	          for (var k in node) {
	            if (node.hasOwnProperty(k)) {
	              clone[k] = node[k];
	            }
	          }
	          node = clone;
	        }
	        var editOffset = 0;
	        for (var ii = 0; ii < edits.length; ii++) {
	          var editKey = edits[ii][0];
	          var editValue = edits[ii][1];
	          if (inArray) {
	            editKey -= editOffset;
	          }
	          if (inArray && editValue === null) {
	            node.splice(editKey, 1);
	            editOffset++;
	          } else {
	            node[editKey] = editValue;
	          }
	        }
	      }
	      index = stack.index;
	      keys = stack.keys;
	      edits = stack.edits;
	      inArray = stack.inArray;
	      stack = stack.prev;
	    } else {
	      key = parent ? inArray ? index : keys[index] : undefined;
	      node = parent ? parent[key] : newRoot;
	      if (node === null || node === undefined) {
	        continue;
	      }
	      if (parent) {
	        path.push(key);
	      }
	    }
	
	    var result = void 0;
	    if (!Array.isArray(node)) {
	      if (!isNode(node)) {
	        throw new Error('Invalid AST Node: ' + JSON.stringify(node));
	      }
	      var visitFn = getVisitFn(visitor, node.kind, isLeaving);
	      if (visitFn) {
	        result = visitFn.call(visitor, node, key, parent, path, ancestors);
	
	        if (result === BREAK) {
	          break;
	        }
	
	        if (result === false) {
	          if (!isLeaving) {
	            path.pop();
	            continue;
	          }
	        } else if (result !== undefined) {
	          edits.push([key, result]);
	          if (!isLeaving) {
	            if (isNode(result)) {
	              node = result;
	            } else {
	              path.pop();
	              continue;
	            }
	          }
	        }
	      }
	    }
	
	    if (result === undefined && isEdited) {
	      edits.push([key, node]);
	    }
	
	    if (!isLeaving) {
	      stack = { inArray: inArray, index: index, keys: keys, edits: edits, prev: stack };
	      inArray = Array.isArray(node);
	      keys = inArray ? node : visitorKeys[node.kind] || [];
	      index = -1;
	      edits = [];
	      if (parent) {
	        ancestors.push(parent);
	      }
	      parent = node;
	    }
	  } while (stack !== undefined);
	
	  if (edits.length !== 0) {
	    newRoot = edits[edits.length - 1][1];
	  }
	
	  return newRoot;
	}
	
	function isNode(maybeNode) {
	  return maybeNode && typeof maybeNode.kind === 'string';
	}
	
	/**
	 * Creates a new visitor instance which delegates to many visitors to run in
	 * parallel. Each visitor will be visited for each node before moving on.
	 *
	 * If a prior visitor edits a node, no following visitors will see that node.
	 */
	function visitInParallel(visitors) {
	  var skipping = new Array(visitors.length);
	
	  return {
	    enter: function enter(node) {
	      for (var i = 0; i < visitors.length; i++) {
	        if (!skipping[i]) {
	          var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */false);
	          if (fn) {
	            var result = fn.apply(visitors[i], arguments);
	            if (result === false) {
	              skipping[i] = node;
	            } else if (result === BREAK) {
	              skipping[i] = BREAK;
	            } else if (result !== undefined) {
	              return result;
	            }
	          }
	        }
	      }
	    },
	    leave: function leave(node) {
	      for (var i = 0; i < visitors.length; i++) {
	        if (!skipping[i]) {
	          var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */true);
	          if (fn) {
	            var result = fn.apply(visitors[i], arguments);
	            if (result === BREAK) {
	              skipping[i] = BREAK;
	            } else if (result !== undefined && result !== false) {
	              return result;
	            }
	          }
	        } else if (skipping[i] === node) {
	          skipping[i] = null;
	        }
	      }
	    }
	  };
	}
	
	/**
	 * Creates a new visitor instance which maintains a provided TypeInfo instance
	 * along with visiting visitor.
	 */
	function visitWithTypeInfo(typeInfo, visitor) {
	  return {
	    enter: function enter(node) {
	      typeInfo.enter(node);
	      var fn = getVisitFn(visitor, node.kind, /* isLeaving */false);
	      if (fn) {
	        var result = fn.apply(visitor, arguments);
	        if (result !== undefined) {
	          typeInfo.leave(node);
	          if (isNode(result)) {
	            typeInfo.enter(result);
	          }
	        }
	        return result;
	      }
	    },
	    leave: function leave(node) {
	      var fn = getVisitFn(visitor, node.kind, /* isLeaving */true);
	      var result = void 0;
	      if (fn) {
	        result = fn.apply(visitor, arguments);
	      }
	      typeInfo.leave(node);
	      return result;
	    }
	  };
	}
	
	/**
	 * Given a visitor instance, if it is leaving or not, and a node kind, return
	 * the function the visitor runtime should call.
	 */
	function getVisitFn(visitor, kind, isLeaving) {
	  var kindVisitor = visitor[kind];
	  if (kindVisitor) {
	    if (!isLeaving && typeof kindVisitor === 'function') {
	      // { Kind() {} }
	      return kindVisitor;
	    }
	    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
	    if (typeof kindSpecificVisitor === 'function') {
	      // { Kind: { enter() {}, leave() {} } }
	      return kindSpecificVisitor;
	    }
	  } else {
	    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
	    if (specificVisitor) {
	      if (typeof specificVisitor === 'function') {
	        // { enter() {}, leave() {} }
	        return specificVisitor;
	      }
	      var specificKindVisitor = specificVisitor[kind];
	      if (typeof specificKindVisitor === 'function') {
	        // { enter: { Kind() {} }, leave: { Kind() {} } }
	        return specificKindVisitor;
	      }
	    }
	  }
	}

/***/ },

/***/ "./node_modules/graphql/language/kinds.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Name
	
	var NAME = exports.NAME = 'Name';
	
	// Document
	
	var DOCUMENT = exports.DOCUMENT = 'Document';
	var OPERATION_DEFINITION = exports.OPERATION_DEFINITION = 'OperationDefinition';
	var VARIABLE_DEFINITION = exports.VARIABLE_DEFINITION = 'VariableDefinition';
	var VARIABLE = exports.VARIABLE = 'Variable';
	var SELECTION_SET = exports.SELECTION_SET = 'SelectionSet';
	var FIELD = exports.FIELD = 'Field';
	var ARGUMENT = exports.ARGUMENT = 'Argument';
	
	// Fragments
	
	var FRAGMENT_SPREAD = exports.FRAGMENT_SPREAD = 'FragmentSpread';
	var INLINE_FRAGMENT = exports.INLINE_FRAGMENT = 'InlineFragment';
	var FRAGMENT_DEFINITION = exports.FRAGMENT_DEFINITION = 'FragmentDefinition';
	
	// Values
	
	var INT = exports.INT = 'IntValue';
	var FLOAT = exports.FLOAT = 'FloatValue';
	var STRING = exports.STRING = 'StringValue';
	var BOOLEAN = exports.BOOLEAN = 'BooleanValue';
	var NULL = exports.NULL = 'NullValue';
	var ENUM = exports.ENUM = 'EnumValue';
	var LIST = exports.LIST = 'ListValue';
	var OBJECT = exports.OBJECT = 'ObjectValue';
	var OBJECT_FIELD = exports.OBJECT_FIELD = 'ObjectField';
	
	// Directives
	
	var DIRECTIVE = exports.DIRECTIVE = 'Directive';
	
	// Types
	
	var NAMED_TYPE = exports.NAMED_TYPE = 'NamedType';
	var LIST_TYPE = exports.LIST_TYPE = 'ListType';
	var NON_NULL_TYPE = exports.NON_NULL_TYPE = 'NonNullType';
	
	// Type System Definitions
	
	var SCHEMA_DEFINITION = exports.SCHEMA_DEFINITION = 'SchemaDefinition';
	var OPERATION_TYPE_DEFINITION = exports.OPERATION_TYPE_DEFINITION = 'OperationTypeDefinition';
	
	// Type Definitions
	
	var SCALAR_TYPE_DEFINITION = exports.SCALAR_TYPE_DEFINITION = 'ScalarTypeDefinition';
	var OBJECT_TYPE_DEFINITION = exports.OBJECT_TYPE_DEFINITION = 'ObjectTypeDefinition';
	var FIELD_DEFINITION = exports.FIELD_DEFINITION = 'FieldDefinition';
	var INPUT_VALUE_DEFINITION = exports.INPUT_VALUE_DEFINITION = 'InputValueDefinition';
	var INTERFACE_TYPE_DEFINITION = exports.INTERFACE_TYPE_DEFINITION = 'InterfaceTypeDefinition';
	var UNION_TYPE_DEFINITION = exports.UNION_TYPE_DEFINITION = 'UnionTypeDefinition';
	var ENUM_TYPE_DEFINITION = exports.ENUM_TYPE_DEFINITION = 'EnumTypeDefinition';
	var ENUM_VALUE_DEFINITION = exports.ENUM_VALUE_DEFINITION = 'EnumValueDefinition';
	var INPUT_OBJECT_TYPE_DEFINITION = exports.INPUT_OBJECT_TYPE_DEFINITION = 'InputObjectTypeDefinition';
	
	// Type Extensions
	
	var TYPE_EXTENSION_DEFINITION = exports.TYPE_EXTENSION_DEFINITION = 'TypeExtensionDefinition';
	
	// Directive Definitions
	
	var DIRECTIVE_DEFINITION = exports.DIRECTIVE_DEFINITION = 'DirectiveDefinition';

/***/ },

/***/ "./node_modules/graphql/error/syntaxError.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.syntaxError = syntaxError;
	
	var _location = __webpack_require__("./node_modules/graphql/language/location.js");
	
	var _GraphQLError = __webpack_require__("./node_modules/graphql/error/GraphQLError.js");
	
	/**
	 * Produces a GraphQLError representing a syntax error, containing useful
	 * descriptive information about the syntax error's position in the source.
	 */
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function syntaxError(source, position, description) {
	  var location = (0, _location.getLocation)(source, position);
	  var error = new _GraphQLError.GraphQLError('Syntax Error ' + source.name + ' (' + location.line + ':' + location.column + ') ' + description + '\n\n' + highlightSourceAtLocation(source, location), undefined, source, [position]);
	  return error;
	}
	
	/**
	 * Render a helpful description of the location of the error in the GraphQL
	 * Source document.
	 */
	function highlightSourceAtLocation(source, location) {
	  var line = location.line;
	  var prevLineNum = (line - 1).toString();
	  var lineNum = line.toString();
	  var nextLineNum = (line + 1).toString();
	  var padLen = nextLineNum.length;
	  var lines = source.body.split(/\r\n|[\n\r]/g);
	  return (line >= 2 ? lpad(padLen, prevLineNum) + ': ' + lines[line - 2] + '\n' : '') + lpad(padLen, lineNum) + ': ' + lines[line - 1] + '\n' + Array(2 + padLen + location.column).join(' ') + '^\n' + (line < lines.length ? lpad(padLen, nextLineNum) + ': ' + lines[line] + '\n' : '');
	}
	
	function lpad(len, str) {
	  return Array(len - str.length + 1).join(' ') + str;
	}

/***/ },

/***/ "./node_modules/graphql/error/locatedError.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.locatedError = locatedError;
	
	var _GraphQLError = __webpack_require__("./node_modules/graphql/error/GraphQLError.js");
	
	/**
	 * Given an arbitrary Error, presumably thrown while attempting to execute a
	 * GraphQL operation, produce a new GraphQLError aware of the location in the
	 * document responsible for the original Error.
	 */
	function locatedError(originalError, nodes, path) {
	  // Note: this uses a brand-check to support GraphQL errors originating from
	  // other contexts.
	  if (originalError && originalError.path) {
	    return originalError;
	  }
	
	  var message = originalError ? originalError.message || String(originalError) : 'An unknown error occurred.';
	  return new _GraphQLError.GraphQLError(message, originalError && originalError.nodes || nodes, originalError && originalError.source, originalError && originalError.positions, path, originalError);
	}
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */

/***/ },

/***/ "./node_modules/graphql/error/formatError.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatError = formatError;
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Given a GraphQLError, format it according to the rules described by the
	 * Response Format, Errors section of the GraphQL Specification.
	 */
	function formatError(error) {
	  (0, _invariant2.default)(error, 'Received null or undefined error.');
	  return {
	    message: error.message,
	    locations: error.locations,
	    path: error.path
	  };
	}
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */

/***/ },

/***/ "./node_modules/graphql/jsutils/invariant.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = invariant;
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function invariant(condition, message) {
	  if (!condition) {
	    throw new Error(message);
	  }
	}

/***/ },

/***/ "./node_modules/graphql/validation/validate.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ValidationContext = undefined;
	exports.validate = validate;
	exports.visitUsingRules = visitUsingRules;
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _visitor = __webpack_require__("./node_modules/graphql/language/visitor.js");
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	var Kind = _interopRequireWildcard(_kinds);
	
	var _schema = __webpack_require__("./node_modules/graphql/type/schema.js");
	
	var _TypeInfo = __webpack_require__("./node_modules/graphql/utilities/TypeInfo.js");
	
	var _specifiedRules = __webpack_require__("./node_modules/graphql/validation/specifiedRules.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	/**
	 * Implements the "Validation" section of the spec.
	 *
	 * Validation runs synchronously, returning an array of encountered errors, or
	 * an empty array if no errors were encountered and the document is valid.
	 *
	 * A list of specific validation rules may be provided. If not provided, the
	 * default list of rules defined by the GraphQL specification will be used.
	 *
	 * Each validation rules is a function which returns a visitor
	 * (see the language/visitor API). Visitor methods are expected to return
	 * GraphQLErrors, or Arrays of GraphQLErrors when invalid.
	 */
	function validate(schema, ast, rules) {
	  (0, _invariant2.default)(schema, 'Must provide schema');
	  (0, _invariant2.default)(ast, 'Must provide document');
	  (0, _invariant2.default)(schema instanceof _schema.GraphQLSchema, 'Schema must be an instance of GraphQLSchema. Also ensure that there are ' + 'not multiple versions of GraphQL installed in your node_modules directory.');
	  var typeInfo = new _TypeInfo.TypeInfo(schema);
	  return visitUsingRules(schema, typeInfo, ast, rules || _specifiedRules.specifiedRules);
	}
	
	/**
	 * This uses a specialized visitor which runs multiple visitors in parallel,
	 * while maintaining the visitor skip and break API.
	 *
	 * @internal
	 */
	function visitUsingRules(schema, typeInfo, documentAST, rules) {
	  var context = new ValidationContext(schema, documentAST, typeInfo);
	  var visitors = rules.map(function (rule) {
	    return rule(context);
	  });
	  // Visit the whole document with each instance of all provided rules.
	  (0, _visitor.visit)(documentAST, (0, _visitor.visitWithTypeInfo)(typeInfo, (0, _visitor.visitInParallel)(visitors)));
	  return context.getErrors();
	}
	
	/**
	 * An instance of this class is passed as the "this" context to all validators,
	 * allowing access to commonly useful contextual information from within a
	 * validation rule.
	 */
	var ValidationContext = exports.ValidationContext = function () {
	  function ValidationContext(schema, ast, typeInfo) {
	    _classCallCheck(this, ValidationContext);
	
	    this._schema = schema;
	    this._ast = ast;
	    this._typeInfo = typeInfo;
	    this._errors = [];
	    this._fragmentSpreads = new Map();
	    this._recursivelyReferencedFragments = new Map();
	    this._variableUsages = new Map();
	    this._recursiveVariableUsages = new Map();
	  }
	
	  ValidationContext.prototype.reportError = function reportError(error) {
	    this._errors.push(error);
	  };
	
	  ValidationContext.prototype.getErrors = function getErrors() {
	    return this._errors;
	  };
	
	  ValidationContext.prototype.getSchema = function getSchema() {
	    return this._schema;
	  };
	
	  ValidationContext.prototype.getDocument = function getDocument() {
	    return this._ast;
	  };
	
	  ValidationContext.prototype.getFragment = function getFragment(name) {
	    var fragments = this._fragments;
	    if (!fragments) {
	      this._fragments = fragments = this.getDocument().definitions.reduce(function (frags, statement) {
	        if (statement.kind === Kind.FRAGMENT_DEFINITION) {
	          frags[statement.name.value] = statement;
	        }
	        return frags;
	      }, {});
	    }
	    return fragments[name];
	  };
	
	  ValidationContext.prototype.getFragmentSpreads = function getFragmentSpreads(node) {
	    var spreads = this._fragmentSpreads.get(node);
	    if (!spreads) {
	      spreads = [];
	      var setsToVisit = [node];
	      while (setsToVisit.length !== 0) {
	        var set = setsToVisit.pop();
	        for (var i = 0; i < set.selections.length; i++) {
	          var selection = set.selections[i];
	          if (selection.kind === Kind.FRAGMENT_SPREAD) {
	            spreads.push(selection);
	          } else if (selection.selectionSet) {
	            setsToVisit.push(selection.selectionSet);
	          }
	        }
	      }
	      this._fragmentSpreads.set(node, spreads);
	    }
	    return spreads;
	  };
	
	  ValidationContext.prototype.getRecursivelyReferencedFragments = function getRecursivelyReferencedFragments(operation) {
	    var fragments = this._recursivelyReferencedFragments.get(operation);
	    if (!fragments) {
	      fragments = [];
	      var collectedNames = Object.create(null);
	      var nodesToVisit = [operation.selectionSet];
	      while (nodesToVisit.length !== 0) {
	        var _node = nodesToVisit.pop();
	        var spreads = this.getFragmentSpreads(_node);
	        for (var i = 0; i < spreads.length; i++) {
	          var fragName = spreads[i].name.value;
	          if (collectedNames[fragName] !== true) {
	            collectedNames[fragName] = true;
	            var fragment = this.getFragment(fragName);
	            if (fragment) {
	              fragments.push(fragment);
	              nodesToVisit.push(fragment.selectionSet);
	            }
	          }
	        }
	      }
	      this._recursivelyReferencedFragments.set(operation, fragments);
	    }
	    return fragments;
	  };
	
	  ValidationContext.prototype.getVariableUsages = function getVariableUsages(node) {
	    var _this = this;
	
	    var usages = this._variableUsages.get(node);
	    if (!usages) {
	      (function () {
	        var newUsages = [];
	        var typeInfo = new _TypeInfo.TypeInfo(_this._schema);
	        (0, _visitor.visit)(node, (0, _visitor.visitWithTypeInfo)(typeInfo, {
	          VariableDefinition: function VariableDefinition() {
	            return false;
	          },
	          Variable: function Variable(variable) {
	            newUsages.push({ node: variable, type: typeInfo.getInputType() });
	          }
	        }));
	        usages = newUsages;
	        _this._variableUsages.set(node, usages);
	      })();
	    }
	    return usages;
	  };
	
	  ValidationContext.prototype.getRecursiveVariableUsages = function getRecursiveVariableUsages(operation) {
	    var usages = this._recursiveVariableUsages.get(operation);
	    if (!usages) {
	      usages = this.getVariableUsages(operation);
	      var fragments = this.getRecursivelyReferencedFragments(operation);
	      for (var i = 0; i < fragments.length; i++) {
	        Array.prototype.push.apply(usages, this.getVariableUsages(fragments[i]));
	      }
	      this._recursiveVariableUsages.set(operation, usages);
	    }
	    return usages;
	  };
	
	  ValidationContext.prototype.getType = function getType() {
	    return this._typeInfo.getType();
	  };
	
	  ValidationContext.prototype.getParentType = function getParentType() {
	    return this._typeInfo.getParentType();
	  };
	
	  ValidationContext.prototype.getInputType = function getInputType() {
	    return this._typeInfo.getInputType();
	  };
	
	  ValidationContext.prototype.getFieldDef = function getFieldDef() {
	    return this._typeInfo.getFieldDef();
	  };
	
	  ValidationContext.prototype.getDirective = function getDirective() {
	    return this._typeInfo.getDirective();
	  };
	
	  ValidationContext.prototype.getArgument = function getArgument() {
	    return this._typeInfo.getArgument();
	  };
	
	  return ValidationContext;
	}();

/***/ },

/***/ "./node_modules/graphql/type/schema.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GraphQLSchema = undefined;
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	var _directives = __webpack_require__("./node_modules/graphql/type/directives.js");
	
	var _introspection = __webpack_require__("./node_modules/graphql/type/introspection.js");
	
	var _find = __webpack_require__("./node_modules/graphql/jsutils/find.js");
	
	var _find2 = _interopRequireDefault(_find);
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _typeComparators = __webpack_require__("./node_modules/graphql/utilities/typeComparators.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	/**
	 * Schema Definition
	 *
	 * A Schema is created by supplying the root types of each type of operation,
	 * query and mutation (optional). A schema definition is then supplied to the
	 * validator and executor.
	 *
	 * Example:
	 *
	 *     const MyAppSchema = new GraphQLSchema({
	 *       query: MyAppQueryRootType,
	 *       mutation: MyAppMutationRootType,
	 *     })
	 *
	 * Note: If an array of `directives` are provided to GraphQLSchema, that will be
	 * the exact list of directives represented and allowed. If `directives` is not
	 * provided then a default set of the specified directives (e.g. @include and
	 * @skip) will be used. If you wish to provide *additional* directives to these
	 * specified directives, you must explicitly declare them. Example:
	 *
	 *     const MyAppSchema = new GraphQLSchema({
	 *       ...
	 *       directives: specifiedDirectives.concat([ myCustomDirective ]),
	 *     })
	 *
	 */
	var GraphQLSchema = exports.GraphQLSchema = function () {
	  function GraphQLSchema(config) {
	    var _this = this;
	
	    _classCallCheck(this, GraphQLSchema);
	
	    (0, _invariant2.default)(typeof config === 'object', 'Must provide configuration object.');
	
	    (0, _invariant2.default)(config.query instanceof _definition.GraphQLObjectType, 'Schema query must be Object Type but got: ' + String(config.query) + '.');
	    this._queryType = config.query;
	
	    (0, _invariant2.default)(!config.mutation || config.mutation instanceof _definition.GraphQLObjectType, 'Schema mutation must be Object Type if provided but got: ' + String(config.mutation) + '.');
	    this._mutationType = config.mutation;
	
	    (0, _invariant2.default)(!config.subscription || config.subscription instanceof _definition.GraphQLObjectType, 'Schema subscription must be Object Type if provided but got: ' + String(config.subscription) + '.');
	    this._subscriptionType = config.subscription;
	
	    (0, _invariant2.default)(!config.types || Array.isArray(config.types), 'Schema types must be Array if provided but got: ' + String(config.types) + '.');
	
	    (0, _invariant2.default)(!config.directives || Array.isArray(config.directives) && config.directives.every(function (directive) {
	      return directive instanceof _directives.GraphQLDirective;
	    }), 'Schema directives must be Array<GraphQLDirective> if provided but got: ' + String(config.directives) + '.');
	    // Provide specified directives (e.g. @include and @skip) by default.
	    this._directives = config.directives || _directives.specifiedDirectives;
	
	    // Build type map now to detect any errors within this schema.
	    var initialTypes = [this.getQueryType(), this.getMutationType(), this.getSubscriptionType(), _introspection.__Schema];
	
	    var types = config.types;
	    if (types) {
	      initialTypes = initialTypes.concat(types);
	    }
	
	    this._typeMap = initialTypes.reduce(typeMapReducer, Object.create(null));
	
	    // Keep track of all implementations by interface name.
	    this._implementations = Object.create(null);
	    Object.keys(this._typeMap).forEach(function (typeName) {
	      var type = _this._typeMap[typeName];
	      if (type instanceof _definition.GraphQLObjectType) {
	        type.getInterfaces().forEach(function (iface) {
	          var impls = _this._implementations[iface.name];
	          if (impls) {
	            impls.push(type);
	          } else {
	            _this._implementations[iface.name] = [type];
	          }
	        });
	      }
	    });
	
	    // Enforce correct interface implementations.
	    Object.keys(this._typeMap).forEach(function (typeName) {
	      var type = _this._typeMap[typeName];
	      if (type instanceof _definition.GraphQLObjectType) {
	        type.getInterfaces().forEach(function (iface) {
	          return assertObjectImplementsInterface(_this, type, iface);
	        });
	      }
	    });
	  }
	
	  GraphQLSchema.prototype.getQueryType = function getQueryType() {
	    return this._queryType;
	  };
	
	  GraphQLSchema.prototype.getMutationType = function getMutationType() {
	    return this._mutationType;
	  };
	
	  GraphQLSchema.prototype.getSubscriptionType = function getSubscriptionType() {
	    return this._subscriptionType;
	  };
	
	  GraphQLSchema.prototype.getTypeMap = function getTypeMap() {
	    return this._typeMap;
	  };
	
	  GraphQLSchema.prototype.getType = function getType(name) {
	    return this.getTypeMap()[name];
	  };
	
	  GraphQLSchema.prototype.getPossibleTypes = function getPossibleTypes(abstractType) {
	    if (abstractType instanceof _definition.GraphQLUnionType) {
	      return abstractType.getTypes();
	    }
	    (0, _invariant2.default)(abstractType instanceof _definition.GraphQLInterfaceType);
	    return this._implementations[abstractType.name];
	  };
	
	  GraphQLSchema.prototype.isPossibleType = function isPossibleType(abstractType, possibleType) {
	    var possibleTypeMap = this._possibleTypeMap;
	    if (!possibleTypeMap) {
	      this._possibleTypeMap = possibleTypeMap = Object.create(null);
	    }
	
	    if (!possibleTypeMap[abstractType.name]) {
	      var possibleTypes = this.getPossibleTypes(abstractType);
	      (0, _invariant2.default)(Array.isArray(possibleTypes), 'Could not find possible implementing types for ' + abstractType.name + ' ' + 'in schema. Check that schema.types is defined and is an array of ' + 'all possible types in the schema.');
	      possibleTypeMap[abstractType.name] = possibleTypes.reduce(function (map, type) {
	        return map[type.name] = true, map;
	      }, Object.create(null));
	    }
	
	    return Boolean(possibleTypeMap[abstractType.name][possibleType.name]);
	  };
	
	  GraphQLSchema.prototype.getDirectives = function getDirectives() {
	    return this._directives;
	  };
	
	  GraphQLSchema.prototype.getDirective = function getDirective(name) {
	    return (0, _find2.default)(this.getDirectives(), function (directive) {
	      return directive.name === name;
	    });
	  };
	
	  return GraphQLSchema;
	}();
	
	function typeMapReducer(map, type) {
	  if (!type) {
	    return map;
	  }
	  if (type instanceof _definition.GraphQLList || type instanceof _definition.GraphQLNonNull) {
	    return typeMapReducer(map, type.ofType);
	  }
	  if (map[type.name]) {
	    (0, _invariant2.default)(map[type.name] === type, 'Schema must contain unique named types but contains multiple ' + ('types named "' + type.name + '".'));
	    return map;
	  }
	  map[type.name] = type;
	
	  var reducedMap = map;
	
	  if (type instanceof _definition.GraphQLUnionType) {
	    reducedMap = type.getTypes().reduce(typeMapReducer, reducedMap);
	  }
	
	  if (type instanceof _definition.GraphQLObjectType) {
	    reducedMap = type.getInterfaces().reduce(typeMapReducer, reducedMap);
	  }
	
	  if (type instanceof _definition.GraphQLObjectType || type instanceof _definition.GraphQLInterfaceType) {
	    (function () {
	      var fieldMap = type.getFields();
	      Object.keys(fieldMap).forEach(function (fieldName) {
	        var field = fieldMap[fieldName];
	
	        if (field.args) {
	          var fieldArgTypes = field.args.map(function (arg) {
	            return arg.type;
	          });
	          reducedMap = fieldArgTypes.reduce(typeMapReducer, reducedMap);
	        }
	        reducedMap = typeMapReducer(reducedMap, field.type);
	      });
	    })();
	  }
	
	  if (type instanceof _definition.GraphQLInputObjectType) {
	    (function () {
	      var fieldMap = type.getFields();
	      Object.keys(fieldMap).forEach(function (fieldName) {
	        var field = fieldMap[fieldName];
	        reducedMap = typeMapReducer(reducedMap, field.type);
	      });
	    })();
	  }
	
	  return reducedMap;
	}
	
	function assertObjectImplementsInterface(schema, object, iface) {
	  var objectFieldMap = object.getFields();
	  var ifaceFieldMap = iface.getFields();
	
	  // Assert each interface field is implemented.
	  Object.keys(ifaceFieldMap).forEach(function (fieldName) {
	    var objectField = objectFieldMap[fieldName];
	    var ifaceField = ifaceFieldMap[fieldName];
	
	    // Assert interface field exists on object.
	    (0, _invariant2.default)(objectField, '"' + iface.name + '" expects field "' + fieldName + '" but "' + object.name + '" ' + 'does not provide it.');
	
	    // Assert interface field type is satisfied by object field type, by being
	    // a valid subtype. (covariant)
	    (0, _invariant2.default)((0, _typeComparators.isTypeSubTypeOf)(schema, objectField.type, ifaceField.type), iface.name + '.' + fieldName + ' expects type "' + String(ifaceField.type) + '" ' + 'but ' + (object.name + '.' + fieldName + ' provides type "' + String(objectField.type) + '".'));
	
	    // Assert each interface field arg is implemented.
	    ifaceField.args.forEach(function (ifaceArg) {
	      var argName = ifaceArg.name;
	      var objectArg = (0, _find2.default)(objectField.args, function (arg) {
	        return arg.name === argName;
	      });
	
	      // Assert interface field arg exists on object field.
	      (0, _invariant2.default)(objectArg, iface.name + '.' + fieldName + ' expects argument "' + argName + '" but ' + (object.name + '.' + fieldName + ' does not provide it.'));
	
	      // Assert interface field arg type matches object field arg type.
	      // (invariant)
	      (0, _invariant2.default)((0, _typeComparators.isEqualType)(ifaceArg.type, objectArg.type), iface.name + '.' + fieldName + '(' + argName + ':) expects type ' + ('"' + String(ifaceArg.type) + '" but ') + (object.name + '.' + fieldName + '(' + argName + ':) provides type ') + ('"' + String(objectArg.type) + '".'));
	    });
	
	    // Assert additional arguments must not be required.
	    objectField.args.forEach(function (objectArg) {
	      var argName = objectArg.name;
	      var ifaceArg = (0, _find2.default)(ifaceField.args, function (arg) {
	        return arg.name === argName;
	      });
	      if (!ifaceArg) {
	        (0, _invariant2.default)(!(objectArg.type instanceof _definition.GraphQLNonNull), object.name + '.' + fieldName + '(' + argName + ':) is of required type ' + ('"' + String(objectArg.type) + '" but is not also provided by the ') + ('interface ' + iface.name + '.' + fieldName + '.'));
	      }
	    });
	  });
	}

/***/ },

/***/ "./node_modules/graphql/type/definition.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GraphQLNonNull = exports.GraphQLList = exports.GraphQLInputObjectType = exports.GraphQLEnumType = exports.GraphQLUnionType = exports.GraphQLInterfaceType = exports.GraphQLObjectType = exports.GraphQLScalarType = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isType = isType;
	exports.assertType = assertType;
	exports.isInputType = isInputType;
	exports.assertInputType = assertInputType;
	exports.isOutputType = isOutputType;
	exports.assertOutputType = assertOutputType;
	exports.isLeafType = isLeafType;
	exports.assertLeafType = assertLeafType;
	exports.isCompositeType = isCompositeType;
	exports.assertCompositeType = assertCompositeType;
	exports.isAbstractType = isAbstractType;
	exports.assertAbstractType = assertAbstractType;
	exports.getNullableType = getNullableType;
	exports.getNamedType = getNamedType;
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isNullish = __webpack_require__("./node_modules/graphql/jsutils/isNullish.js");
	
	var _isNullish2 = _interopRequireDefault(_isNullish);
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	var _assertValidName = __webpack_require__("./node_modules/graphql/utilities/assertValidName.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Predicates & Assertions
	
	/**
	 * These are all of the possible kinds of types.
	 */
	function isType(type) {
	  return type instanceof GraphQLScalarType || type instanceof GraphQLObjectType || type instanceof GraphQLInterfaceType || type instanceof GraphQLUnionType || type instanceof GraphQLEnumType || type instanceof GraphQLInputObjectType || type instanceof GraphQLList || type instanceof GraphQLNonNull;
	}
	
	function assertType(type) {
	  (0, _invariant2.default)(isType(type), 'Expected ' + String(type) + ' to be a GraphQL type.');
	  return type;
	}
	
	/**
	 * These types may be used as input types for arguments and directives.
	 */
	function isInputType(type) {
	  var namedType = getNamedType(type);
	  return namedType instanceof GraphQLScalarType || namedType instanceof GraphQLEnumType || namedType instanceof GraphQLInputObjectType;
	}
	
	function assertInputType(type) {
	  (0, _invariant2.default)(isInputType(type), 'Expected ' + String(type) + ' to be a GraphQL input type.');
	  return type;
	}
	
	/**
	 * These types may be used as output types as the result of fields.
	 */
	function isOutputType(type) {
	  var namedType = getNamedType(type);
	  return namedType instanceof GraphQLScalarType || namedType instanceof GraphQLObjectType || namedType instanceof GraphQLInterfaceType || namedType instanceof GraphQLUnionType || namedType instanceof GraphQLEnumType;
	}
	
	function assertOutputType(type) {
	  (0, _invariant2.default)(isOutputType(type), 'Expected ' + String(type) + ' to be a GraphQL output type.');
	  return type;
	}
	
	/**
	 * These types may describe types which may be leaf values.
	 */
	function isLeafType(type) {
	  var namedType = getNamedType(type);
	  return namedType instanceof GraphQLScalarType || namedType instanceof GraphQLEnumType;
	}
	
	function assertLeafType(type) {
	  (0, _invariant2.default)(isLeafType(type), 'Expected ' + String(type) + ' to be a GraphQL leaf type.');
	  return type;
	}
	
	/**
	 * These types may describe the parent context of a selection set.
	 */
	function isCompositeType(type) {
	  return type instanceof GraphQLObjectType || type instanceof GraphQLInterfaceType || type instanceof GraphQLUnionType;
	}
	
	function assertCompositeType(type) {
	  (0, _invariant2.default)(isCompositeType(type), 'Expected ' + String(type) + ' to be a GraphQL composite type.');
	  return type;
	}
	
	/**
	 * These types may describe the parent context of a selection set.
	 */
	function isAbstractType(type) {
	  return type instanceof GraphQLInterfaceType || type instanceof GraphQLUnionType;
	}
	
	function assertAbstractType(type) {
	  (0, _invariant2.default)(isAbstractType(type), 'Expected ' + String(type) + ' to be a GraphQL abstract type.');
	  return type;
	}
	
	/**
	 * These types can all accept null as a value.
	 */
	function getNullableType(type) {
	  return type instanceof GraphQLNonNull ? type.ofType : type;
	}
	
	/**
	 * These named types do not include modifiers like List or NonNull.
	 */
	function getNamedType(type) {
	  var unmodifiedType = type;
	  while (unmodifiedType instanceof GraphQLList || unmodifiedType instanceof GraphQLNonNull) {
	    unmodifiedType = unmodifiedType.ofType;
	  }
	  return unmodifiedType;
	}
	
	/**
	 * Used while defining GraphQL types to allow for circular references in
	 * otherwise immutable type definitions.
	 */
	
	
	function resolveThunk(thunk) {
	  return typeof thunk === 'function' ? thunk() : thunk;
	}
	
	/**
	 * Scalar Type Definition
	 *
	 * The leaf values of any request and input values to arguments are
	 * Scalars (or Enums) and are defined with a name and a series of functions
	 * used to parse input from ast or variables and to ensure validity.
	 *
	 * Example:
	 *
	 *     const OddType = new GraphQLScalarType({
	 *       name: 'Odd',
	 *       serialize(value) {
	 *         return value % 2 === 1 ? value : null;
	 *       }
	 *     });
	 *
	 */
	
	var GraphQLScalarType = exports.GraphQLScalarType = function () {
	  function GraphQLScalarType(config) {
	    _classCallCheck(this, GraphQLScalarType);
	
	    (0, _invariant2.default)(config.name, 'Type must be named.');
	    (0, _assertValidName.assertValidName)(config.name);
	    this.name = config.name;
	    this.description = config.description;
	    (0, _invariant2.default)(typeof config.serialize === 'function', this.name + ' must provide "serialize" function. If this custom Scalar ' + 'is also used as an input type, ensure "parseValue" and "parseLiteral" ' + 'functions are also provided.');
	    if (config.parseValue || config.parseLiteral) {
	      (0, _invariant2.default)(typeof config.parseValue === 'function' && typeof config.parseLiteral === 'function', this.name + ' must provide both "parseValue" and "parseLiteral" ' + 'functions.');
	    }
	    this._scalarConfig = config;
	  }
	
	  // Serializes an internal value to include in a response.
	
	
	  GraphQLScalarType.prototype.serialize = function serialize(value) {
	    var serializer = this._scalarConfig.serialize;
	    return serializer(value);
	  };
	
	  // Parses an externally provided value to use as an input.
	
	
	  GraphQLScalarType.prototype.parseValue = function parseValue(value) {
	    var parser = this._scalarConfig.parseValue;
	    return parser ? parser(value) : null;
	  };
	
	  // Parses an externally provided literal value to use as an input.
	
	
	  GraphQLScalarType.prototype.parseLiteral = function parseLiteral(valueNode) {
	    var parser = this._scalarConfig.parseLiteral;
	    return parser ? parser(valueNode) : null;
	  };
	
	  GraphQLScalarType.prototype.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLScalarType;
	}();
	
	// Also provide toJSON and inspect aliases for toString.
	
	
	GraphQLScalarType.prototype.toJSON = GraphQLScalarType.prototype.inspect = GraphQLScalarType.prototype.toString;
	
	/**
	 * Object Type Definition
	 *
	 * Almost all of the GraphQL types you define will be object types. Object types
	 * have a name, but most importantly describe their fields.
	 *
	 * Example:
	 *
	 *     const AddressType = new GraphQLObjectType({
	 *       name: 'Address',
	 *       fields: {
	 *         street: { type: GraphQLString },
	 *         number: { type: GraphQLInt },
	 *         formatted: {
	 *           type: GraphQLString,
	 *           resolve(obj) {
	 *             return obj.number + ' ' + obj.street
	 *           }
	 *         }
	 *       }
	 *     });
	 *
	 * When two types need to refer to each other, or a type needs to refer to
	 * itself in a field, you can use a function expression (aka a closure or a
	 * thunk) to supply the fields lazily.
	 *
	 * Example:
	 *
	 *     const PersonType = new GraphQLObjectType({
	 *       name: 'Person',
	 *       fields: () => ({
	 *         name: { type: GraphQLString },
	 *         bestFriend: { type: PersonType },
	 *       })
	 *     });
	 *
	 */
	var GraphQLObjectType = exports.GraphQLObjectType = function () {
	  function GraphQLObjectType(config) {
	    _classCallCheck(this, GraphQLObjectType);
	
	    (0, _invariant2.default)(config.name, 'Type must be named.');
	    (0, _assertValidName.assertValidName)(config.name);
	    this.name = config.name;
	    this.description = config.description;
	    if (config.isTypeOf) {
	      (0, _invariant2.default)(typeof config.isTypeOf === 'function', this.name + ' must provide "isTypeOf" as a function.');
	    }
	    this.isTypeOf = config.isTypeOf;
	    this._typeConfig = config;
	  }
	
	  GraphQLObjectType.prototype.getFields = function getFields() {
	    return this._fields || (this._fields = defineFieldMap(this, this._typeConfig.fields));
	  };
	
	  GraphQLObjectType.prototype.getInterfaces = function getInterfaces() {
	    return this._interfaces || (this._interfaces = defineInterfaces(this, this._typeConfig.interfaces));
	  };
	
	  GraphQLObjectType.prototype.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLObjectType;
	}();
	
	// Also provide toJSON and inspect aliases for toString.
	
	
	GraphQLObjectType.prototype.toJSON = GraphQLObjectType.prototype.inspect = GraphQLObjectType.prototype.toString;
	
	function defineInterfaces(type, interfacesThunk) {
	  var interfaces = resolveThunk(interfacesThunk);
	  if (!interfaces) {
	    return [];
	  }
	  (0, _invariant2.default)(Array.isArray(interfaces), type.name + ' interfaces must be an Array or a function which returns ' + 'an Array.');
	  interfaces.forEach(function (iface) {
	    (0, _invariant2.default)(iface instanceof GraphQLInterfaceType, type.name + ' may only implement Interface types, it cannot ' + ('implement: ' + String(iface) + '.'));
	    if (typeof iface.resolveType !== 'function') {
	      (0, _invariant2.default)(typeof type.isTypeOf === 'function', 'Interface Type ' + iface.name + ' does not provide a "resolveType" ' + ('function and implementing Type ' + type.name + ' does not provide a ') + '"isTypeOf" function. There is no way to resolve this implementing ' + 'type during execution.');
	    }
	  });
	  return interfaces;
	}
	
	function defineFieldMap(type, fieldsThunk) {
	  var fieldMap = resolveThunk(fieldsThunk);
	  (0, _invariant2.default)(isPlainObj(fieldMap), type.name + ' fields must be an object with field names as keys or a ' + 'function which returns such an object.');
	
	  var fieldNames = Object.keys(fieldMap);
	  (0, _invariant2.default)(fieldNames.length > 0, type.name + ' fields must be an object with field names as keys or a ' + 'function which returns such an object.');
	
	  var resultFieldMap = {};
	  fieldNames.forEach(function (fieldName) {
	    (0, _assertValidName.assertValidName)(fieldName);
	    var fieldConfig = fieldMap[fieldName];
	    (0, _invariant2.default)(!fieldConfig.hasOwnProperty('isDeprecated'), type.name + '.' + fieldName + ' should provide "deprecationReason" instead ' + 'of "isDeprecated".');
	    var field = _extends({}, fieldConfig, {
	      isDeprecated: Boolean(fieldConfig.deprecationReason),
	      name: fieldName
	    });
	    (0, _invariant2.default)(isOutputType(field.type), type.name + '.' + fieldName + ' field type must be Output Type but ' + ('got: ' + String(field.type) + '.'));
	    var argsConfig = fieldConfig.args;
	    if (!argsConfig) {
	      field.args = [];
	    } else {
	      (0, _invariant2.default)(isPlainObj(argsConfig), type.name + '.' + fieldName + ' args must be an object with argument ' + 'names as keys.');
	      field.args = Object.keys(argsConfig).map(function (argName) {
	        (0, _assertValidName.assertValidName)(argName);
	        var arg = argsConfig[argName];
	        (0, _invariant2.default)(isInputType(arg.type), type.name + '.' + fieldName + '(' + argName + ':) argument type must be ' + ('Input Type but got: ' + String(arg.type) + '.'));
	        return {
	          name: argName,
	          description: arg.description === undefined ? null : arg.description,
	          type: arg.type,
	          defaultValue: arg.defaultValue
	        };
	      });
	    }
	    resultFieldMap[fieldName] = field;
	  });
	  return resultFieldMap;
	}
	
	function isPlainObj(obj) {
	  return obj && typeof obj === 'object' && !Array.isArray(obj);
	}
	
	/**
	 * Interface Type Definition
	 *
	 * When a field can return one of a heterogeneous set of types, a Interface type
	 * is used to describe what types are possible, what fields are in common across
	 * all types, as well as a function to determine which type is actually used
	 * when the field is resolved.
	 *
	 * Example:
	 *
	 *     const EntityType = new GraphQLInterfaceType({
	 *       name: 'Entity',
	 *       fields: {
	 *         name: { type: GraphQLString }
	 *       }
	 *     });
	 *
	 */
	var GraphQLInterfaceType = exports.GraphQLInterfaceType = function () {
	  function GraphQLInterfaceType(config) {
	    _classCallCheck(this, GraphQLInterfaceType);
	
	    (0, _invariant2.default)(config.name, 'Type must be named.');
	    (0, _assertValidName.assertValidName)(config.name);
	    this.name = config.name;
	    this.description = config.description;
	    if (config.resolveType) {
	      (0, _invariant2.default)(typeof config.resolveType === 'function', this.name + ' must provide "resolveType" as a function.');
	    }
	    this.resolveType = config.resolveType;
	    this._typeConfig = config;
	  }
	
	  GraphQLInterfaceType.prototype.getFields = function getFields() {
	    return this._fields || (this._fields = defineFieldMap(this, this._typeConfig.fields));
	  };
	
	  GraphQLInterfaceType.prototype.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLInterfaceType;
	}();
	
	// Also provide toJSON and inspect aliases for toString.
	
	
	GraphQLInterfaceType.prototype.toJSON = GraphQLInterfaceType.prototype.inspect = GraphQLInterfaceType.prototype.toString;
	
	/**
	 * Union Type Definition
	 *
	 * When a field can return one of a heterogeneous set of types, a Union type
	 * is used to describe what types are possible as well as providing a function
	 * to determine which type is actually used when the field is resolved.
	 *
	 * Example:
	 *
	 *     const PetType = new GraphQLUnionType({
	 *       name: 'Pet',
	 *       types: [ DogType, CatType ],
	 *       resolveType(value) {
	 *         if (value instanceof Dog) {
	 *           return DogType;
	 *         }
	 *         if (value instanceof Cat) {
	 *           return CatType;
	 *         }
	 *       }
	 *     });
	 *
	 */
	var GraphQLUnionType = exports.GraphQLUnionType = function () {
	  function GraphQLUnionType(config) {
	    _classCallCheck(this, GraphQLUnionType);
	
	    (0, _invariant2.default)(config.name, 'Type must be named.');
	    (0, _assertValidName.assertValidName)(config.name);
	    this.name = config.name;
	    this.description = config.description;
	    if (config.resolveType) {
	      (0, _invariant2.default)(typeof config.resolveType === 'function', this.name + ' must provide "resolveType" as a function.');
	    }
	    this.resolveType = config.resolveType;
	    this._typeConfig = config;
	  }
	
	  GraphQLUnionType.prototype.getTypes = function getTypes() {
	    return this._types || (this._types = defineTypes(this, this._typeConfig.types));
	  };
	
	  GraphQLUnionType.prototype.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLUnionType;
	}();
	
	// Also provide toJSON and inspect aliases for toString.
	
	
	GraphQLUnionType.prototype.toJSON = GraphQLUnionType.prototype.inspect = GraphQLUnionType.prototype.toString;
	
	function defineTypes(unionType, typesThunk) {
	  var types = resolveThunk(typesThunk);
	
	  (0, _invariant2.default)(Array.isArray(types) && types.length > 0, 'Must provide Array of types or a function which returns ' + ('such an array for Union ' + unionType.name + '.'));
	  types.forEach(function (objType) {
	    (0, _invariant2.default)(objType instanceof GraphQLObjectType, unionType.name + ' may only contain Object types, it cannot contain: ' + (String(objType) + '.'));
	    if (typeof unionType.resolveType !== 'function') {
	      (0, _invariant2.default)(typeof objType.isTypeOf === 'function', 'Union type "' + unionType.name + '" does not provide a "resolveType" ' + ('function and possible type "' + objType.name + '" does not provide an ') + '"isTypeOf" function. There is no way to resolve this possible type ' + 'during execution.');
	    }
	  });
	
	  return types;
	}
	
	/**
	 * Enum Type Definition
	 *
	 * Some leaf values of requests and input values are Enums. GraphQL serializes
	 * Enum values as strings, however internally Enums can be represented by any
	 * kind of type, often integers.
	 *
	 * Example:
	 *
	 *     const RGBType = new GraphQLEnumType({
	 *       name: 'RGB',
	 *       values: {
	 *         RED: { value: 0 },
	 *         GREEN: { value: 1 },
	 *         BLUE: { value: 2 }
	 *       }
	 *     });
	 *
	 * Note: If a value is not provided in a definition, the name of the enum value
	 * will be used as its internal value.
	 */
	var GraphQLEnumType /* <T> */ = exports.GraphQLEnumType = function () {
	  function GraphQLEnumType(config /* <T> */) {
	    _classCallCheck(this, GraphQLEnumType);
	
	    this.name = config.name;
	    (0, _assertValidName.assertValidName)(config.name);
	    this.description = config.description;
	    this._values = defineEnumValues(this, config.values);
	    this._enumConfig = config;
	  }
	
	  GraphQLEnumType.prototype.getValues = function getValues() {
	    return this._values;
	  };
	
	  GraphQLEnumType.prototype.serialize = function serialize(value /* T */) {
	    var enumValue = this._getValueLookup().get(value);
	    return enumValue ? enumValue.name : null;
	  };
	
	  GraphQLEnumType.prototype.parseValue = function parseValue(value) /* T */{
	    if (typeof value === 'string') {
	      var enumValue = this._getNameLookup()[value];
	      if (enumValue) {
	        return enumValue.value;
	      }
	    }
	  };
	
	  GraphQLEnumType.prototype.parseLiteral = function parseLiteral(valueNode) /* T */{
	    if (valueNode.kind === _kinds.ENUM) {
	      var enumValue = this._getNameLookup()[valueNode.value];
	      if (enumValue) {
	        return enumValue.value;
	      }
	    }
	  };
	
	  GraphQLEnumType.prototype._getValueLookup = function _getValueLookup() {
	    var _this = this;
	
	    if (!this._valueLookup) {
	      (function () {
	        var lookup = new Map();
	        _this.getValues().forEach(function (value) {
	          lookup.set(value.value, value);
	        });
	        _this._valueLookup = lookup;
	      })();
	    }
	    return this._valueLookup;
	  };
	
	  GraphQLEnumType.prototype._getNameLookup = function _getNameLookup() {
	    var _this2 = this;
	
	    if (!this._nameLookup) {
	      (function () {
	        var lookup = Object.create(null);
	        _this2.getValues().forEach(function (value) {
	          lookup[value.name] = value;
	        });
	        _this2._nameLookup = lookup;
	      })();
	    }
	    return this._nameLookup;
	  };
	
	  GraphQLEnumType.prototype.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLEnumType;
	}();
	
	// Also provide toJSON and inspect aliases for toString.
	
	
	GraphQLEnumType.prototype.toJSON = GraphQLEnumType.prototype.inspect = GraphQLEnumType.prototype.toString;
	
	function defineEnumValues(type, valueMap /* <T> */
	) {
	  (0, _invariant2.default)(isPlainObj(valueMap), type.name + ' values must be an object with value names as keys.');
	  var valueNames = Object.keys(valueMap);
	  (0, _invariant2.default)(valueNames.length > 0, type.name + ' values must be an object with value names as keys.');
	  return valueNames.map(function (valueName) {
	    (0, _assertValidName.assertValidName)(valueName);
	    var value = valueMap[valueName];
	    (0, _invariant2.default)(isPlainObj(value), type.name + '.' + valueName + ' must refer to an object with a "value" key ' + ('representing an internal value but got: ' + String(value) + '.'));
	    (0, _invariant2.default)(!value.hasOwnProperty('isDeprecated'), type.name + '.' + valueName + ' should provide "deprecationReason" instead ' + 'of "isDeprecated".');
	    return {
	      name: valueName,
	      description: value.description,
	      isDeprecated: Boolean(value.deprecationReason),
	      deprecationReason: value.deprecationReason,
	      value: (0, _isNullish2.default)(value.value) ? valueName : value.value
	    };
	  });
	} /* <T> */
	
	
	/**
	 * Input Object Type Definition
	 *
	 * An input object defines a structured collection of fields which may be
	 * supplied to a field argument.
	 *
	 * Using `NonNull` will ensure that a value must be provided by the query
	 *
	 * Example:
	 *
	 *     const GeoPoint = new GraphQLInputObjectType({
	 *       name: 'GeoPoint',
	 *       fields: {
	 *         lat: { type: new GraphQLNonNull(GraphQLFloat) },
	 *         lon: { type: new GraphQLNonNull(GraphQLFloat) },
	 *         alt: { type: GraphQLFloat, defaultValue: 0 },
	 *       }
	 *     });
	 *
	 */
	var GraphQLInputObjectType = exports.GraphQLInputObjectType = function () {
	  function GraphQLInputObjectType(config) {
	    _classCallCheck(this, GraphQLInputObjectType);
	
	    (0, _invariant2.default)(config.name, 'Type must be named.');
	    (0, _assertValidName.assertValidName)(config.name);
	    this.name = config.name;
	    this.description = config.description;
	    this._typeConfig = config;
	  }
	
	  GraphQLInputObjectType.prototype.getFields = function getFields() {
	    return this._fields || (this._fields = this._defineFieldMap());
	  };
	
	  GraphQLInputObjectType.prototype._defineFieldMap = function _defineFieldMap() {
	    var _this3 = this;
	
	    var fieldMap = resolveThunk(this._typeConfig.fields);
	    (0, _invariant2.default)(isPlainObj(fieldMap), this.name + ' fields must be an object with field names as keys or a ' + 'function which returns such an object.');
	    var fieldNames = Object.keys(fieldMap);
	    (0, _invariant2.default)(fieldNames.length > 0, this.name + ' fields must be an object with field names as keys or a ' + 'function which returns such an object.');
	    var resultFieldMap = {};
	    fieldNames.forEach(function (fieldName) {
	      (0, _assertValidName.assertValidName)(fieldName);
	      var field = _extends({}, fieldMap[fieldName], {
	        name: fieldName
	      });
	      (0, _invariant2.default)(isInputType(field.type), _this3.name + '.' + fieldName + ' field type must be Input Type but ' + ('got: ' + String(field.type) + '.'));
	      resultFieldMap[fieldName] = field;
	    });
	    return resultFieldMap;
	  };
	
	  GraphQLInputObjectType.prototype.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLInputObjectType;
	}();
	
	// Also provide toJSON and inspect aliases for toString.
	
	
	GraphQLInputObjectType.prototype.toJSON = GraphQLInputObjectType.prototype.inspect = GraphQLInputObjectType.prototype.toString;
	
	/**
	 * List Modifier
	 *
	 * A list is a kind of type marker, a wrapping type which points to another
	 * type. Lists are often created within the context of defining the fields of
	 * an object type.
	 *
	 * Example:
	 *
	 *     const PersonType = new GraphQLObjectType({
	 *       name: 'Person',
	 *       fields: () => ({
	 *         parents: { type: new GraphQLList(Person) },
	 *         children: { type: new GraphQLList(Person) },
	 *       })
	 *     })
	 *
	 */
	var GraphQLList = exports.GraphQLList = function () {
	  function GraphQLList(type) {
	    _classCallCheck(this, GraphQLList);
	
	    (0, _invariant2.default)(isType(type), 'Can only create List of a GraphQLType but got: ' + String(type) + '.');
	    this.ofType = type;
	  }
	
	  GraphQLList.prototype.toString = function toString() {
	    return '[' + String(this.ofType) + ']';
	  };
	
	  return GraphQLList;
	}();
	
	// Also provide toJSON and inspect aliases for toString.
	
	
	GraphQLList.prototype.toJSON = GraphQLList.prototype.inspect = GraphQLList.prototype.toString;
	
	/**
	 * Non-Null Modifier
	 *
	 * A non-null is a kind of type marker, a wrapping type which points to another
	 * type. Non-null types enforce that their values are never null and can ensure
	 * an error is raised if this ever occurs during a request. It is useful for
	 * fields which you can make a strong guarantee on non-nullability, for example
	 * usually the id field of a database row will never be null.
	 *
	 * Example:
	 *
	 *     const RowType = new GraphQLObjectType({
	 *       name: 'Row',
	 *       fields: () => ({
	 *         id: { type: new GraphQLNonNull(GraphQLString) },
	 *       })
	 *     })
	 *
	 * Note: the enforcement of non-nullability occurs within the executor.
	 */
	
	var GraphQLNonNull = exports.GraphQLNonNull = function () {
	  function GraphQLNonNull(type) {
	    _classCallCheck(this, GraphQLNonNull);
	
	    (0, _invariant2.default)(isType(type) && !(type instanceof GraphQLNonNull), 'Can only create NonNull of a Nullable GraphQLType but got: ' + (String(type) + '.'));
	    this.ofType = type;
	  }
	
	  GraphQLNonNull.prototype.toString = function toString() {
	    return this.ofType.toString() + '!';
	  };
	
	  return GraphQLNonNull;
	}();
	
	// Also provide toJSON and inspect aliases for toString.
	
	
	GraphQLNonNull.prototype.toJSON = GraphQLNonNull.prototype.inspect = GraphQLNonNull.prototype.toString;

/***/ },

/***/ "./node_modules/graphql/jsutils/isNullish.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isNullish;
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	/**
	 * Returns true if a value is null, undefined, or NaN.
	 */
	function isNullish(value) {
	  return value === null || value === undefined || value !== value;
	}

/***/ },

/***/ "./node_modules/graphql/utilities/assertValidName.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assertValidName = assertValidName;
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NAME_RX = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
	
	// Helper to assert that provided names are valid.
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function assertValidName(name) {
	  (0, _invariant2.default)(NAME_RX.test(name), 'Names must match /^[_a-zA-Z][_a-zA-Z0-9]*$/ but "' + name + '" does not.');
	}

/***/ },

/***/ "./node_modules/graphql/type/directives.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.specifiedDirectives = exports.GraphQLDeprecatedDirective = exports.DEFAULT_DEPRECATION_REASON = exports.GraphQLSkipDirective = exports.GraphQLIncludeDirective = exports.GraphQLDirective = exports.DirectiveLocation = undefined;
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	var _scalars = __webpack_require__("./node_modules/graphql/type/scalars.js");
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _assertValidName = __webpack_require__("./node_modules/graphql/utilities/assertValidName.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	var DirectiveLocation = exports.DirectiveLocation = {
	  // Operations
	  QUERY: 'QUERY',
	  MUTATION: 'MUTATION',
	  SUBSCRIPTION: 'SUBSCRIPTION',
	  FIELD: 'FIELD',
	  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
	  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
	  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
	  // Schema Definitions
	  SCHEMA: 'SCHEMA',
	  SCALAR: 'SCALAR',
	  OBJECT: 'OBJECT',
	  FIELD_DEFINITION: 'FIELD_DEFINITION',
	  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
	  INTERFACE: 'INTERFACE',
	  UNION: 'UNION',
	  ENUM: 'ENUM',
	  ENUM_VALUE: 'ENUM_VALUE',
	  INPUT_OBJECT: 'INPUT_OBJECT',
	  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
	};
	
	// eslint-disable-line
	
	/**
	 * Directives are used by the GraphQL runtime as a way of modifying execution
	 * behavior. Type system creators will usually not create these directly.
	 */
	var GraphQLDirective = exports.GraphQLDirective = function GraphQLDirective(config) {
	  _classCallCheck(this, GraphQLDirective);
	
	  (0, _invariant2.default)(config.name, 'Directive must be named.');
	  (0, _assertValidName.assertValidName)(config.name);
	  (0, _invariant2.default)(Array.isArray(config.locations), 'Must provide locations for directive.');
	  this.name = config.name;
	  this.description = config.description;
	  this.locations = config.locations;
	
	  var args = config.args;
	  if (!args) {
	    this.args = [];
	  } else {
	    (0, _invariant2.default)(!Array.isArray(args), '@' + config.name + ' args must be an object with argument names as keys.');
	    this.args = Object.keys(args).map(function (argName) {
	      (0, _assertValidName.assertValidName)(argName);
	      var arg = args[argName];
	      (0, _invariant2.default)((0, _definition.isInputType)(arg.type), '@' + config.name + '(' + argName + ':) argument type must be ' + ('Input Type but got: ' + String(arg.type) + '.'));
	      return {
	        name: argName,
	        description: arg.description === undefined ? null : arg.description,
	        type: arg.type,
	        defaultValue: arg.defaultValue
	      };
	    });
	  }
	};
	
	/**
	 * Used to conditionally include fields or fragments.
	 */
	var GraphQLIncludeDirective = exports.GraphQLIncludeDirective = new GraphQLDirective({
	  name: 'include',
	  description: 'Directs the executor to include this field or fragment only when ' + 'the `if` argument is true.',
	  locations: [DirectiveLocation.FIELD, DirectiveLocation.FRAGMENT_SPREAD, DirectiveLocation.INLINE_FRAGMENT],
	  args: {
	    if: {
	      type: new _definition.GraphQLNonNull(_scalars.GraphQLBoolean),
	      description: 'Included when true.'
	    }
	  }
	});
	
	/**
	 * Used to conditionally skip (exclude) fields or fragments.
	 */
	var GraphQLSkipDirective = exports.GraphQLSkipDirective = new GraphQLDirective({
	  name: 'skip',
	  description: 'Directs the executor to skip this field or fragment when the `if` ' + 'argument is true.',
	  locations: [DirectiveLocation.FIELD, DirectiveLocation.FRAGMENT_SPREAD, DirectiveLocation.INLINE_FRAGMENT],
	  args: {
	    if: {
	      type: new _definition.GraphQLNonNull(_scalars.GraphQLBoolean),
	      description: 'Skipped when true.'
	    }
	  }
	});
	
	/**
	 * Constant string used for default reason for a deprecation.
	 */
	var DEFAULT_DEPRECATION_REASON = exports.DEFAULT_DEPRECATION_REASON = 'No longer supported';
	
	/**
	 * Used to declare element of a GraphQL schema as deprecated.
	 */
	var GraphQLDeprecatedDirective = exports.GraphQLDeprecatedDirective = new GraphQLDirective({
	  name: 'deprecated',
	  description: 'Marks an element of a GraphQL schema as no longer supported.',
	  locations: [DirectiveLocation.FIELD_DEFINITION, DirectiveLocation.ENUM_VALUE],
	  args: {
	    reason: {
	      type: _scalars.GraphQLString,
	      description: 'Explains why this element was deprecated, usually also including a ' + 'suggestion for how to access supported similar data. Formatted ' + 'in [Markdown](https://daringfireball.net/projects/markdown/).',
	      defaultValue: DEFAULT_DEPRECATION_REASON
	    }
	  }
	});
	
	/**
	 * The full list of specified directives.
	 */
	var specifiedDirectives = exports.specifiedDirectives = [GraphQLIncludeDirective, GraphQLSkipDirective, GraphQLDeprecatedDirective];

/***/ },

/***/ "./node_modules/graphql/type/scalars.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GraphQLID = exports.GraphQLBoolean = exports.GraphQLString = exports.GraphQLFloat = exports.GraphQLInt = undefined;
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	var Kind = _interopRequireWildcard(_kinds);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// As per the GraphQL Spec, Integers are only treated as valid when a valid
	// 32-bit signed integer, providing the broadest support across platforms.
	//
	// n.b. JavaScript's integers are safe between -(2^53 - 1) and 2^53 - 1 because
	// they are internally represented as IEEE 754 doubles.
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	var MAX_INT = 2147483647;
	var MIN_INT = -2147483648;
	
	function coerceInt(value) {
	  if (value === '') {
	    throw new TypeError('Int cannot represent non 32-bit signed integer value: (empty string)');
	  }
	  var num = Number(value);
	  if (num === num && num <= MAX_INT && num >= MIN_INT) {
	    return (num < 0 ? Math.ceil : Math.floor)(num);
	  }
	  throw new TypeError('Int cannot represent non 32-bit signed integer value: ' + String(value));
	}
	
	var GraphQLInt = exports.GraphQLInt = new _definition.GraphQLScalarType({
	  name: 'Int',
	  description: 'The `Int` scalar type represents non-fractional signed whole numeric ' + 'values. Int can represent values between -(2^31) and 2^31 - 1. ',
	  serialize: coerceInt,
	  parseValue: coerceInt,
	  parseLiteral: function parseLiteral(ast) {
	    if (ast.kind === Kind.INT) {
	      var num = parseInt(ast.value, 10);
	      if (num <= MAX_INT && num >= MIN_INT) {
	        return num;
	      }
	    }
	    return null;
	  }
	});
	
	function coerceFloat(value) {
	  if (value === '') {
	    throw new TypeError('Float cannot represent non numeric value: (empty string)');
	  }
	  var num = Number(value);
	  if (num === num) {
	    return num;
	  }
	  throw new TypeError('Float cannot represent non numeric value: ' + String(value));
	}
	
	var GraphQLFloat = exports.GraphQLFloat = new _definition.GraphQLScalarType({
	  name: 'Float',
	  description: 'The `Float` scalar type represents signed double-precision fractional ' + 'values as specified by ' + '[IEEE 754](http://en.wikipedia.org/wiki/IEEE_floating_point). ',
	  serialize: coerceFloat,
	  parseValue: coerceFloat,
	  parseLiteral: function parseLiteral(ast) {
	    return ast.kind === Kind.FLOAT || ast.kind === Kind.INT ? parseFloat(ast.value) : null;
	  }
	});
	
	var GraphQLString = exports.GraphQLString = new _definition.GraphQLScalarType({
	  name: 'String',
	  description: 'The `String` scalar type represents textual data, represented as UTF-8 ' + 'character sequences. The String type is most often used by GraphQL to ' + 'represent free-form human-readable text.',
	  serialize: String,
	  parseValue: String,
	  parseLiteral: function parseLiteral(ast) {
	    return ast.kind === Kind.STRING ? ast.value : null;
	  }
	});
	
	var GraphQLBoolean = exports.GraphQLBoolean = new _definition.GraphQLScalarType({
	  name: 'Boolean',
	  description: 'The `Boolean` scalar type represents `true` or `false`.',
	  serialize: Boolean,
	  parseValue: Boolean,
	  parseLiteral: function parseLiteral(ast) {
	    return ast.kind === Kind.BOOLEAN ? ast.value : null;
	  }
	});
	
	var GraphQLID = exports.GraphQLID = new _definition.GraphQLScalarType({
	  name: 'ID',
	  description: 'The `ID` scalar type represents a unique identifier, often used to ' + 'refetch an object or as key for a cache. The ID type appears in a JSON ' + 'response as a String; however, it is not intended to be human-readable. ' + 'When expected as an input type, any string (such as `"4"`) or integer ' + '(such as `4`) input value will be accepted as an ID.',
	  serialize: String,
	  parseValue: String,
	  parseLiteral: function parseLiteral(ast) {
	    return ast.kind === Kind.STRING || ast.kind === Kind.INT ? ast.value : null;
	  }
	});

/***/ },

/***/ "./node_modules/graphql/type/introspection.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TypeNameMetaFieldDef = exports.TypeMetaFieldDef = exports.SchemaMetaFieldDef = exports.__TypeKind = exports.TypeKind = exports.__EnumValue = exports.__InputValue = exports.__Field = exports.__Type = exports.__DirectiveLocation = exports.__Directive = exports.__Schema = undefined;
	
	var _isInvalid = __webpack_require__("./node_modules/graphql/jsutils/isInvalid.js");
	
	var _isInvalid2 = _interopRequireDefault(_isInvalid);
	
	var _astFromValue = __webpack_require__("./node_modules/graphql/utilities/astFromValue.js");
	
	var _printer = __webpack_require__("./node_modules/graphql/language/printer.js");
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	var _scalars = __webpack_require__("./node_modules/graphql/type/scalars.js");
	
	var _directives = __webpack_require__("./node_modules/graphql/type/directives.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	var __Schema = exports.__Schema = new _definition.GraphQLObjectType({
	  name: '__Schema',
	  description: 'A GraphQL Schema defines the capabilities of a GraphQL server. It ' + 'exposes all available types and directives on the server, as well as ' + 'the entry points for query, mutation, and subscription operations.',
	  fields: function fields() {
	    return {
	      types: {
	        description: 'A list of all types supported by this server.',
	        type: new _definition.GraphQLNonNull(new _definition.GraphQLList(new _definition.GraphQLNonNull(__Type))),
	        resolve: function resolve(schema) {
	          var typeMap = schema.getTypeMap();
	          return Object.keys(typeMap).map(function (key) {
	            return typeMap[key];
	          });
	        }
	      },
	      queryType: {
	        description: 'The type that query operations will be rooted at.',
	        type: new _definition.GraphQLNonNull(__Type),
	        resolve: function resolve(schema) {
	          return schema.getQueryType();
	        }
	      },
	      mutationType: {
	        description: 'If this server supports mutation, the type that ' + 'mutation operations will be rooted at.',
	        type: __Type,
	        resolve: function resolve(schema) {
	          return schema.getMutationType();
	        }
	      },
	      subscriptionType: {
	        description: 'If this server support subscription, the type that ' + 'subscription operations will be rooted at.',
	        type: __Type,
	        resolve: function resolve(schema) {
	          return schema.getSubscriptionType();
	        }
	      },
	      directives: {
	        description: 'A list of all directives supported by this server.',
	        type: new _definition.GraphQLNonNull(new _definition.GraphQLList(new _definition.GraphQLNonNull(__Directive))),
	        resolve: function resolve(schema) {
	          return schema.getDirectives();
	        }
	      }
	    };
	  }
	});
	
	var __Directive = exports.__Directive = new _definition.GraphQLObjectType({
	  name: '__Directive',
	  description: 'A Directive provides a way to describe alternate runtime execution and ' + 'type validation behavior in a GraphQL document.' + '\n\nIn some cases, you need to provide options to alter GraphQL\'s ' + 'execution behavior in ways field arguments will not suffice, such as ' + 'conditionally including or skipping a field. Directives provide this by ' + 'describing additional information to the executor.',
	  fields: function fields() {
	    return {
	      name: { type: new _definition.GraphQLNonNull(_scalars.GraphQLString) },
	      description: { type: _scalars.GraphQLString },
	      locations: {
	        type: new _definition.GraphQLNonNull(new _definition.GraphQLList(new _definition.GraphQLNonNull(__DirectiveLocation)))
	      },
	      args: {
	        type: new _definition.GraphQLNonNull(new _definition.GraphQLList(new _definition.GraphQLNonNull(__InputValue))),
	        resolve: function resolve(directive) {
	          return directive.args || [];
	        }
	      },
	      // NOTE: the following three fields are deprecated and are no longer part
	      // of the GraphQL specification.
	      onOperation: {
	        deprecationReason: 'Use `locations`.',
	        type: new _definition.GraphQLNonNull(_scalars.GraphQLBoolean),
	        resolve: function resolve(d) {
	          return d.locations.indexOf(_directives.DirectiveLocation.QUERY) !== -1 || d.locations.indexOf(_directives.DirectiveLocation.MUTATION) !== -1 || d.locations.indexOf(_directives.DirectiveLocation.SUBSCRIPTION) !== -1;
	        }
	      },
	      onFragment: {
	        deprecationReason: 'Use `locations`.',
	        type: new _definition.GraphQLNonNull(_scalars.GraphQLBoolean),
	        resolve: function resolve(d) {
	          return d.locations.indexOf(_directives.DirectiveLocation.FRAGMENT_SPREAD) !== -1 || d.locations.indexOf(_directives.DirectiveLocation.INLINE_FRAGMENT) !== -1 || d.locations.indexOf(_directives.DirectiveLocation.FRAGMENT_DEFINITION) !== -1;
	        }
	      },
	      onField: {
	        deprecationReason: 'Use `locations`.',
	        type: new _definition.GraphQLNonNull(_scalars.GraphQLBoolean),
	        resolve: function resolve(d) {
	          return d.locations.indexOf(_directives.DirectiveLocation.FIELD) !== -1;
	        }
	      }
	    };
	  }
	});
	
	var __DirectiveLocation = exports.__DirectiveLocation = new _definition.GraphQLEnumType({
	  name: '__DirectiveLocation',
	  description: 'A Directive can be adjacent to many parts of the GraphQL language, a ' + '__DirectiveLocation describes one such possible adjacencies.',
	  values: {
	    QUERY: {
	      value: _directives.DirectiveLocation.QUERY,
	      description: 'Location adjacent to a query operation.'
	    },
	    MUTATION: {
	      value: _directives.DirectiveLocation.MUTATION,
	      description: 'Location adjacent to a mutation operation.'
	    },
	    SUBSCRIPTION: {
	      value: _directives.DirectiveLocation.SUBSCRIPTION,
	      description: 'Location adjacent to a subscription operation.'
	    },
	    FIELD: {
	      value: _directives.DirectiveLocation.FIELD,
	      description: 'Location adjacent to a field.'
	    },
	    FRAGMENT_DEFINITION: {
	      value: _directives.DirectiveLocation.FRAGMENT_DEFINITION,
	      description: 'Location adjacent to a fragment definition.'
	    },
	    FRAGMENT_SPREAD: {
	      value: _directives.DirectiveLocation.FRAGMENT_SPREAD,
	      description: 'Location adjacent to a fragment spread.'
	    },
	    INLINE_FRAGMENT: {
	      value: _directives.DirectiveLocation.INLINE_FRAGMENT,
	      description: 'Location adjacent to an inline fragment.'
	    },
	    SCHEMA: {
	      value: _directives.DirectiveLocation.SCHEMA,
	      description: 'Location adjacent to a schema definition.'
	    },
	    SCALAR: {
	      value: _directives.DirectiveLocation.SCALAR,
	      description: 'Location adjacent to a scalar definition.'
	    },
	    OBJECT: {
	      value: _directives.DirectiveLocation.OBJECT,
	      description: 'Location adjacent to an object type definition.'
	    },
	    FIELD_DEFINITION: {
	      value: _directives.DirectiveLocation.FIELD_DEFINITION,
	      description: 'Location adjacent to a field definition.'
	    },
	    ARGUMENT_DEFINITION: {
	      value: _directives.DirectiveLocation.ARGUMENT_DEFINITION,
	      description: 'Location adjacent to an argument definition.'
	    },
	    INTERFACE: {
	      value: _directives.DirectiveLocation.INTERFACE,
	      description: 'Location adjacent to an interface definition.'
	    },
	    UNION: {
	      value: _directives.DirectiveLocation.UNION,
	      description: 'Location adjacent to a union definition.'
	    },
	    ENUM: {
	      value: _directives.DirectiveLocation.ENUM,
	      description: 'Location adjacent to an enum definition.'
	    },
	    ENUM_VALUE: {
	      value: _directives.DirectiveLocation.ENUM_VALUE,
	      description: 'Location adjacent to an enum value definition.'
	    },
	    INPUT_OBJECT: {
	      value: _directives.DirectiveLocation.INPUT_OBJECT,
	      description: 'Location adjacent to an input object type definition.'
	    },
	    INPUT_FIELD_DEFINITION: {
	      value: _directives.DirectiveLocation.INPUT_FIELD_DEFINITION,
	      description: 'Location adjacent to an input object field definition.'
	    }
	  }
	});
	
	var __Type = exports.__Type = new _definition.GraphQLObjectType({
	  name: '__Type',
	  description: 'The fundamental unit of any GraphQL Schema is the type. There are ' + 'many kinds of types in GraphQL as represented by the `__TypeKind` enum.' + '\n\nDepending on the kind of a type, certain fields describe ' + 'information about that type. Scalar types provide no information ' + 'beyond a name and description, while Enum types provide their values. ' + 'Object and Interface types provide the fields they describe. Abstract ' + 'types, Union and Interface, provide the Object types possible ' + 'at runtime. List and NonNull types compose other types.',
	  fields: function fields() {
	    return {
	      kind: {
	        type: new _definition.GraphQLNonNull(__TypeKind),
	        resolve: function resolve(type) {
	          if (type instanceof _definition.GraphQLScalarType) {
	            return TypeKind.SCALAR;
	          } else if (type instanceof _definition.GraphQLObjectType) {
	            return TypeKind.OBJECT;
	          } else if (type instanceof _definition.GraphQLInterfaceType) {
	            return TypeKind.INTERFACE;
	          } else if (type instanceof _definition.GraphQLUnionType) {
	            return TypeKind.UNION;
	          } else if (type instanceof _definition.GraphQLEnumType) {
	            return TypeKind.ENUM;
	          } else if (type instanceof _definition.GraphQLInputObjectType) {
	            return TypeKind.INPUT_OBJECT;
	          } else if (type instanceof _definition.GraphQLList) {
	            return TypeKind.LIST;
	          } else if (type instanceof _definition.GraphQLNonNull) {
	            return TypeKind.NON_NULL;
	          }
	          throw new Error('Unknown kind of type: ' + type);
	        }
	      },
	      name: { type: _scalars.GraphQLString },
	      description: { type: _scalars.GraphQLString },
	      fields: {
	        type: new _definition.GraphQLList(new _definition.GraphQLNonNull(__Field)),
	        args: {
	          includeDeprecated: { type: _scalars.GraphQLBoolean, defaultValue: false }
	        },
	        resolve: function resolve(type, _ref) {
	          var includeDeprecated = _ref.includeDeprecated;
	
	          if (type instanceof _definition.GraphQLObjectType || type instanceof _definition.GraphQLInterfaceType) {
	            var _ret = function () {
	              var fieldMap = type.getFields();
	              var fields = Object.keys(fieldMap).map(function (fieldName) {
	                return fieldMap[fieldName];
	              });
	              if (!includeDeprecated) {
	                fields = fields.filter(function (field) {
	                  return !field.deprecationReason;
	                });
	              }
	              return {
	                v: fields
	              };
	            }();
	
	            if (typeof _ret === "object") return _ret.v;
	          }
	          return null;
	        }
	      },
	      interfaces: {
	        type: new _definition.GraphQLList(new _definition.GraphQLNonNull(__Type)),
	        resolve: function resolve(type) {
	          if (type instanceof _definition.GraphQLObjectType) {
	            return type.getInterfaces();
	          }
	        }
	      },
	      possibleTypes: {
	        type: new _definition.GraphQLList(new _definition.GraphQLNonNull(__Type)),
	        resolve: function resolve(type, args, context, _ref2) {
	          var schema = _ref2.schema;
	
	          if (type instanceof _definition.GraphQLInterfaceType || type instanceof _definition.GraphQLUnionType) {
	            return schema.getPossibleTypes(type);
	          }
	        }
	      },
	      enumValues: {
	        type: new _definition.GraphQLList(new _definition.GraphQLNonNull(__EnumValue)),
	        args: {
	          includeDeprecated: { type: _scalars.GraphQLBoolean, defaultValue: false }
	        },
	        resolve: function resolve(type, _ref3) {
	          var includeDeprecated = _ref3.includeDeprecated;
	
	          if (type instanceof _definition.GraphQLEnumType) {
	            var values = type.getValues();
	            if (!includeDeprecated) {
	              values = values.filter(function (value) {
	                return !value.deprecationReason;
	              });
	            }
	            return values;
	          }
	        }
	      },
	      inputFields: {
	        type: new _definition.GraphQLList(new _definition.GraphQLNonNull(__InputValue)),
	        resolve: function resolve(type) {
	          if (type instanceof _definition.GraphQLInputObjectType) {
	            var _ret2 = function () {
	              var fieldMap = type.getFields();
	              return {
	                v: Object.keys(fieldMap).map(function (fieldName) {
	                  return fieldMap[fieldName];
	                })
	              };
	            }();
	
	            if (typeof _ret2 === "object") return _ret2.v;
	          }
	        }
	      },
	      ofType: { type: __Type }
	    };
	  }
	});
	
	var __Field = exports.__Field = new _definition.GraphQLObjectType({
	  name: '__Field',
	  description: 'Object and Interface types are described by a list of Fields, each of ' + 'which has a name, potentially a list of arguments, and a return type.',
	  fields: function fields() {
	    return {
	      name: { type: new _definition.GraphQLNonNull(_scalars.GraphQLString) },
	      description: { type: _scalars.GraphQLString },
	      args: {
	        type: new _definition.GraphQLNonNull(new _definition.GraphQLList(new _definition.GraphQLNonNull(__InputValue))),
	        resolve: function resolve(field) {
	          return field.args || [];
	        }
	      },
	      type: { type: new _definition.GraphQLNonNull(__Type) },
	      isDeprecated: { type: new _definition.GraphQLNonNull(_scalars.GraphQLBoolean) },
	      deprecationReason: {
	        type: _scalars.GraphQLString
	      }
	    };
	  }
	});
	
	var __InputValue = exports.__InputValue = new _definition.GraphQLObjectType({
	  name: '__InputValue',
	  description: 'Arguments provided to Fields or Directives and the input fields of an ' + 'InputObject are represented as Input Values which describe their type ' + 'and optionally a default value.',
	  fields: function fields() {
	    return {
	      name: { type: new _definition.GraphQLNonNull(_scalars.GraphQLString) },
	      description: { type: _scalars.GraphQLString },
	      type: { type: new _definition.GraphQLNonNull(__Type) },
	      defaultValue: {
	        type: _scalars.GraphQLString,
	        description: 'A GraphQL-formatted string representing the default value for this ' + 'input value.',
	        resolve: function resolve(inputVal) {
	          return (0, _isInvalid2.default)(inputVal.defaultValue) ? null : (0, _printer.print)((0, _astFromValue.astFromValue)(inputVal.defaultValue, inputVal.type));
	        }
	      }
	    };
	  }
	});
	
	var __EnumValue = exports.__EnumValue = new _definition.GraphQLObjectType({
	  name: '__EnumValue',
	  description: 'One possible value for a given Enum. Enum values are unique values, not ' + 'a placeholder for a string or numeric value. However an Enum value is ' + 'returned in a JSON response as a string.',
	  fields: function fields() {
	    return {
	      name: { type: new _definition.GraphQLNonNull(_scalars.GraphQLString) },
	      description: { type: _scalars.GraphQLString },
	      isDeprecated: { type: new _definition.GraphQLNonNull(_scalars.GraphQLBoolean) },
	      deprecationReason: {
	        type: _scalars.GraphQLString
	      }
	    };
	  }
	});
	
	var TypeKind = exports.TypeKind = {
	  SCALAR: 'SCALAR',
	  OBJECT: 'OBJECT',
	  INTERFACE: 'INTERFACE',
	  UNION: 'UNION',
	  ENUM: 'ENUM',
	  INPUT_OBJECT: 'INPUT_OBJECT',
	  LIST: 'LIST',
	  NON_NULL: 'NON_NULL'
	};
	
	var __TypeKind = exports.__TypeKind = new _definition.GraphQLEnumType({
	  name: '__TypeKind',
	  description: 'An enum describing what kind of type a given `__Type` is.',
	  values: {
	    SCALAR: {
	      value: TypeKind.SCALAR,
	      description: 'Indicates this type is a scalar.'
	    },
	    OBJECT: {
	      value: TypeKind.OBJECT,
	      description: 'Indicates this type is an object. ' + '`fields` and `interfaces` are valid fields.'
	    },
	    INTERFACE: {
	      value: TypeKind.INTERFACE,
	      description: 'Indicates this type is an interface. ' + '`fields` and `possibleTypes` are valid fields.'
	    },
	    UNION: {
	      value: TypeKind.UNION,
	      description: 'Indicates this type is a union. ' + '`possibleTypes` is a valid field.'
	    },
	    ENUM: {
	      value: TypeKind.ENUM,
	      description: 'Indicates this type is an enum. ' + '`enumValues` is a valid field.'
	    },
	    INPUT_OBJECT: {
	      value: TypeKind.INPUT_OBJECT,
	      description: 'Indicates this type is an input object. ' + '`inputFields` is a valid field.'
	    },
	    LIST: {
	      value: TypeKind.LIST,
	      description: 'Indicates this type is a list. ' + '`ofType` is a valid field.'
	    },
	    NON_NULL: {
	      value: TypeKind.NON_NULL,
	      description: 'Indicates this type is a non-null. ' + '`ofType` is a valid field.'
	    }
	  }
	});
	
	/**
	 * Note that these are GraphQLField and not GraphQLFieldConfig,
	 * so the format for args is different.
	 */
	
	var SchemaMetaFieldDef = exports.SchemaMetaFieldDef = {
	  name: '__schema',
	  type: new _definition.GraphQLNonNull(__Schema),
	  description: 'Access the current type schema of this server.',
	  args: [],
	  resolve: function resolve(source, args, context, _ref4) {
	    var schema = _ref4.schema;
	    return schema;
	  }
	};
	
	var TypeMetaFieldDef = exports.TypeMetaFieldDef = {
	  name: '__type',
	  type: __Type,
	  description: 'Request the type information of a single type.',
	  args: [{ name: 'name', type: new _definition.GraphQLNonNull(_scalars.GraphQLString) }],
	  resolve: function resolve(source, _ref5, context, _ref6) {
	    var name = _ref5.name;
	    var schema = _ref6.schema;
	    return schema.getType(name);
	  }
	};
	
	var TypeNameMetaFieldDef = exports.TypeNameMetaFieldDef = {
	  name: '__typename',
	  type: new _definition.GraphQLNonNull(_scalars.GraphQLString),
	  description: 'The name of the current Object type at runtime.',
	  args: [],
	  resolve: function resolve(source, args, context, _ref7) {
	    var parentType = _ref7.parentType;
	    return parentType.name;
	  }
	};

/***/ },

/***/ "./node_modules/graphql/jsutils/isInvalid.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isInvalid;
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	/**
	 * Returns true if a value is undefined, or NaN.
	 */
	function isInvalid(value) {
	  return value === undefined || value !== value;
	}

/***/ },

/***/ "./node_modules/graphql/utilities/astFromValue.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.astFromValue = astFromValue;
	
	var _iterall = __webpack_require__("./node_modules/iterall/index.js");
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isNullish = __webpack_require__("./node_modules/graphql/jsutils/isNullish.js");
	
	var _isNullish2 = _interopRequireDefault(_isNullish);
	
	var _isInvalid = __webpack_require__("./node_modules/graphql/jsutils/isInvalid.js");
	
	var _isInvalid2 = _interopRequireDefault(_isInvalid);
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	var _scalars = __webpack_require__("./node_modules/graphql/type/scalars.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Produces a GraphQL Value AST given a JavaScript value.
	 *
	 * A GraphQL type must be provided, which will be used to interpret different
	 * JavaScript values.
	 *
	 * | JSON Value    | GraphQL Value        |
	 * | ------------- | -------------------- |
	 * | Object        | Input Object         |
	 * | Array         | List                 |
	 * | Boolean       | Boolean              |
	 * | String        | String / Enum Value  |
	 * | Number        | Int / Float          |
	 * | Mixed         | Enum Value           |
	 * | null          | NullValue            |
	 *
	 */
	function astFromValue(value, type) {
	  // Ensure flow knows that we treat function params as const.
	  var _value = value;
	
	  if (type instanceof _definition.GraphQLNonNull) {
	    var astValue = astFromValue(_value, type.ofType);
	    if (astValue && astValue.kind === _kinds.NULL) {
	      return null;
	    }
	    return astValue;
	  }
	
	  // only explicit null, not undefined, NaN
	  if (_value === null) {
	    return { kind: _kinds.NULL };
	  }
	
	  // undefined, NaN
	  if ((0, _isInvalid2.default)(_value)) {
	    return null;
	  }
	
	  // Convert JavaScript array to GraphQL list. If the GraphQLType is a list, but
	  // the value is not an array, convert the value using the list's item type.
	  if (type instanceof _definition.GraphQLList) {
	    var _ret = function () {
	      var itemType = type.ofType;
	      if ((0, _iterall.isCollection)(_value)) {
	        var _ret2 = function () {
	          var valuesNodes = [];
	          (0, _iterall.forEach)(_value, function (item) {
	            var itemNode = astFromValue(item, itemType);
	            if (itemNode) {
	              valuesNodes.push(itemNode);
	            }
	          });
	          return {
	            v: {
	              v: { kind: _kinds.LIST, values: valuesNodes }
	            }
	          };
	        }();
	
	        if (typeof _ret2 === "object") return _ret2.v;
	      }
	      return {
	        v: astFromValue(_value, itemType)
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	
	  // Populate the fields of the input object by creating ASTs from each value
	  // in the JavaScript object according to the fields in the input type.
	  if (type instanceof _definition.GraphQLInputObjectType) {
	    var _ret3 = function () {
	      if (_value === null || typeof _value !== 'object') {
	        return {
	          v: null
	        };
	      }
	      var fields = type.getFields();
	      var fieldNodes = [];
	      Object.keys(fields).forEach(function (fieldName) {
	        var fieldType = fields[fieldName].type;
	        var fieldValue = astFromValue(_value[fieldName], fieldType);
	        if (fieldValue) {
	          fieldNodes.push({
	            kind: _kinds.OBJECT_FIELD,
	            name: { kind: _kinds.NAME, value: fieldName },
	            value: fieldValue
	          });
	        }
	      });
	      return {
	        v: { kind: _kinds.OBJECT, fields: fieldNodes }
	      };
	    }();
	
	    if (typeof _ret3 === "object") return _ret3.v;
	  }
	
	  (0, _invariant2.default)(type instanceof _definition.GraphQLScalarType || type instanceof _definition.GraphQLEnumType, 'Must provide Input Type, cannot use: ' + String(type));
	
	  // Since value is an internally represented value, it must be serialized
	  // to an externally represented value before converting into an AST.
	  var serialized = type.serialize(_value);
	  if ((0, _isNullish2.default)(serialized)) {
	    return null;
	  }
	
	  // Others serialize based on their corresponding JavaScript scalar types.
	  if (typeof serialized === 'boolean') {
	    return { kind: _kinds.BOOLEAN, value: serialized };
	  }
	
	  // JavaScript numbers can be Int or Float values.
	  if (typeof serialized === 'number') {
	    var stringNum = String(serialized);
	    return (/^[0-9]+$/.test(stringNum) ? { kind: _kinds.INT, value: stringNum } : { kind: _kinds.FLOAT, value: stringNum }
	    );
	  }
	
	  if (typeof serialized === 'string') {
	    // Enum types use Enum literals.
	    if (type instanceof _definition.GraphQLEnumType) {
	      return { kind: _kinds.ENUM, value: serialized };
	    }
	
	    // ID types can use Int literals.
	    if (type === _scalars.GraphQLID && /^[0-9]+$/.test(serialized)) {
	      return { kind: _kinds.INT, value: serialized };
	    }
	
	    // Use JSON stringify, which uses the same string encoding as GraphQL,
	    // then remove the quotes.
	    return {
	      kind: _kinds.STRING,
	      value: JSON.stringify(serialized).slice(1, -1)
	    };
	  }
	
	  throw new TypeError('Cannot convert value to AST: ' + String(serialized));
	}
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */

/***/ },

/***/ "./node_modules/iterall/index.js":
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016, Lee Byron
	 * All rights reserved.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @ignore
	 */
	
	/**
	 * [Iterator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator)
	 * is a *protocol* which describes a standard way to produce a sequence of
	 * values, typically the values of the Iterable represented by this Iterator.
	 *
	 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterator-interface)
	 * it can be utilized by any version of JavaScript.
	 *
	 * @typedef {Object} Iterator
	 * @template T The type of each iterated value
	 * @property {function (): { value: T, done: boolean }} next
	 *   A method which produces either the next value in a sequence or a result
	 *   where the `done` property is `true` indicating the end of the Iterator.
	 */
	
	/**
	 * [Iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
	 * is a *protocol* which when implemented allows a JavaScript object to define
	 * their iteration behavior, such as what values are looped over in a `for..of`
	 * loop or `iterall`'s `forEach` function. Many [built-in types](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#Builtin_iterables)
	 * implement the Iterable protocol, including `Array` and `Map`.
	 *
	 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterable-interface)
	 * it can be utilized by any version of JavaScript.
	 *
	 * @typedef {Object} Iterable
	 * @template T The type of each iterated value
	 * @property {function (): Iterator<T>} Symbol.iterator
	 *   A method which produces an Iterator for this Iterable.
	 */
	
	// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
	var SYMBOL_ITERATOR = typeof Symbol === 'function' && Symbol.iterator
	
	/**
	 * A property name to be used as the name of an Iterable's method responsible
	 * for producing an Iterator, referred to as `@@iterator`. Typically represents
	 * the value `Symbol.iterator` but falls back to the string `"@@iterator"` when
	 * `Symbol.iterator` is not defined.
	 *
	 * Use `$$iterator` for defining new Iterables instead of `Symbol.iterator`,
	 * but do not use it for accessing existing Iterables, instead use
	 * `getIterator()` or `isIterable()`.
	 *
	 * @example
	 *
	 * var $$iterator = require('iterall').$$iterator
	 *
	 * function Counter (to) {
	 *   this.to = to
	 * }
	 *
	 * Counter.prototype[$$iterator] = function () {
	 *   return {
	 *     to: this.to,
	 *     num: 0,
	 *     next () {
	 *       if (this.num >= this.to) {
	 *         return { value: undefined, done: true }
	 *       }
	 *       return { value: this.num++, done: false }
	 *     }
	 *   }
	 * }
	 *
	 * var counter = new Counter(3)
	 * for (var number of counter) {
	 *   console.log(number) // 0 ... 1 ... 2
	 * }
	 *
	 * @type {Symbol|string}
	 */
	var $$iterator = SYMBOL_ITERATOR || '@@iterator'
	exports.$$iterator = $$iterator
	
	/**
	 * Returns true if the provided object implements the Iterator protocol via
	 * either implementing a `Symbol.iterator` or `"@@iterator"` method.
	 *
	 * @example
	 *
	 * var isIterable = require('iterall').isIterable
	 * isIterable([ 1, 2, 3 ]) // true
	 * isIterable('ABC') // true
	 * isIterable({ length: 1, 0: 'Alpha' }) // false
	 * isIterable({ key: 'value' }) // false
	 * isIterable(new Map()) // true
	 *
	 * @param obj
	 *   A value which might implement the Iterable protocol.
	 * @return {boolean} true if Iterable.
	 */
	function isIterable (obj) {
	  return !!getIteratorMethod(obj)
	}
	exports.isIterable = isIterable
	
	/**
	 * Returns true if the provided object implements the Array-like protocol via
	 * defining a positive-integer `length` property.
	 *
	 * @example
	 *
	 * var isArrayLike = require('iterall').isArrayLike
	 * isArrayLike([ 1, 2, 3 ]) // true
	 * isArrayLike('ABC') // true
	 * isArrayLike({ length: 1, 0: 'Alpha' }) // true
	 * isArrayLike({ key: 'value' }) // false
	 * isArrayLike(new Map()) // false
	 *
	 * @param obj
	 *   A value which might implement the Array-like protocol.
	 * @return {boolean} true if Array-like.
	 */
	function isArrayLike (obj) {
	  var length = obj != null && obj.length
	  return typeof length === 'number' && length >= 0 && length % 1 === 0
	}
	exports.isArrayLike = isArrayLike
	
	/**
	 * Returns true if the provided object is an Object (i.e. not a string literal)
	 * and is either Iterable or Array-like.
	 *
	 * This may be used in place of [Array.isArray()][isArray] to determine if an
	 * object should be iterated-over. It always excludes string literals and
	 * includes Arrays (regardless of if it is Iterable). It also includes other
	 * Array-like objects such as NodeList, TypedArray, and Buffer.
	 *
	 * @example
	 *
	 * var isCollection = require('iterall').isCollection
	 * isCollection([ 1, 2, 3 ]) // true
	 * isCollection('ABC') // false
	 * isCollection({ length: 1, 0: 'Alpha' }) // true
	 * isCollection({ key: 'value' }) // false
	 * isCollection(new Map()) // true
	 *
	 * @example
	 *
	 * var forEach = require('iterall').forEach
	 * if (isCollection(obj)) {
	 *   forEach(obj, function (value) {
	 *     console.log(value)
	 *   })
	 * }
	 *
	 * @param obj
	 *   An Object value which might implement the Iterable or Array-like protocols.
	 * @return {boolean} true if Iterable or Array-like Object.
	 */
	function isCollection (obj) {
	  return Object(obj) === obj && (isArrayLike(obj) || isIterable(obj))
	}
	exports.isCollection = isCollection
	
	/**
	 * If the provided object implements the Iterator protocol, its Iterator object
	 * is returned. Otherwise returns undefined.
	 *
	 * @example
	 *
	 * var getIterator = require('iterall').getIterator
	 * var iterator = getIterator([ 1, 2, 3 ])
	 * iterator.next() // { value: 1, done: false }
	 * iterator.next() // { value: 2, done: false }
	 * iterator.next() // { value: 3, done: false }
	 * iterator.next() // { value: undefined, done: true }
	 *
	 * @template T the type of each iterated value
	 * @param {Iterable<T>} iterable
	 *   An Iterable object which is the source of an Iterator.
	 * @return {Iterator<T>} new Iterator instance.
	 */
	function getIterator (iterable) {
	  var method = getIteratorMethod(iterable)
	  if (method) {
	    return method.call(iterable)
	  }
	}
	exports.getIterator = getIterator
	
	/**
	 * If the provided object implements the Iterator protocol, the method
	 * responsible for producing its Iterator object is returned.
	 *
	 * This is used in rare cases for performance tuning. This method must be called
	 * with obj as the contextual this-argument.
	 *
	 * @example
	 *
	 * var getIteratorMethod = require('iterall').getIteratorMethod
	 * var myArray = [ 1, 2, 3 ]
	 * var method = getIteratorMethod(myArray)
	 * if (method) {
	 *   var iterator = method.call(myArray)
	 * }
	 *
	 * @template T the type of each iterated value
	 * @param {Iterable<T>} iterable
	 *   An Iterable object which defines an `@@iterator` method.
	 * @return {function(): Iterator<T>} `@@iterator` method.
	 */
	function getIteratorMethod (iterable) {
	  if (iterable != null) {
	    var method = SYMBOL_ITERATOR && iterable[SYMBOL_ITERATOR] || iterable['@@iterator']
	    if (typeof method === 'function') {
	      return method
	    }
	  }
	}
	exports.getIteratorMethod = getIteratorMethod
	
	/**
	 * Given an object which either implements the Iterable protocol or is
	 * Array-like, iterate over it, calling the `callback` at each iteration.
	 *
	 * Use `forEach` where you would expect to use a `for ... of` loop in ES6.
	 * However `forEach` adheres to the behavior of [Array#forEach][] described in
	 * the ECMAScript specification, skipping over "holes" in Array-likes. It will
	 * also delegate to a `forEach` method on `collection` if one is defined,
	 * ensuring native performance for `Arrays`.
	 *
	 * Similar to [Array#forEach][], the `callback` function accepts three
	 * arguments, and is provided with `thisArg` as the calling context.
	 *
	 * Note: providing an infinite Iterator to forEach will produce an error.
	 *
	 * [Array#forEach]: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
	 *
	 * @example
	 *
	 * var forEach = require('iterall').forEach
	 *
	 * forEach(myIterable, function (value, index, iterable) {
	 *   console.log(value, index, iterable === myIterable)
	 * })
	 *
	 * @example
	 *
	 * // ES6:
	 * for (let value of myIterable) {
	 *   console.log(value)
	 * }
	 *
	 * // Any JavaScript environment:
	 * forEach(myIterable, function (value) {
	 *   console.log(value)
	 * })
	 *
	 * @template T the type of each iterated value
	 * @param {Iterable<T>|{ length: number }} collection
	 *   The Iterable or array to iterate over.
	 * @param {function(T, number, object)} callback
	 *   Function to execute for each iteration, taking up to three arguments
	 * @param [thisArg]
	 *   Optional. Value to use as `this` when executing `callback`.
	 */
	function forEach (collection, callback, thisArg) {
	  if (collection != null) {
	    if (typeof collection.forEach === 'function') {
	      return collection.forEach(callback, thisArg)
	    }
	    var i = 0
	    var iterator = getIterator(collection)
	    if (iterator) {
	      var step
	      while (!(step = iterator.next()).done) {
	        callback.call(thisArg, step.value, i++, collection)
	        // Infinite Iterators could cause forEach to run forever.
	        // After a very large number of iterations, produce an error.
	        /* istanbul ignore if */
	        if (i > 9999999) {
	          throw new TypeError('Near-infinite iteration.')
	        }
	      }
	    } else if (isArrayLike(collection)) {
	      for (; i < collection.length; i++) {
	        if (collection.hasOwnProperty(i)) {
	          callback.call(thisArg, collection[i], i, collection)
	        }
	      }
	    }
	  }
	}
	exports.forEach = forEach
	
	/**
	 * Similar to `getIterator()`, this method returns a new Iterator given an
	 * Iterable. However it will also create an Iterator for a non-Iterable
	 * Array-like collection, such as Array in a non-ES2015 environment.
	 *
	 * `createIterator` is complimentary to `forEach`, but allows a "pull"-based
	 * iteration as opposed to `forEach`'s "push"-based iteration.
	 *
	 * `createIterator` produces an Iterator for Array-likes with the same behavior
	 * as ArrayIteratorPrototype described in the ECMAScript specification, and
	 * does *not* skip over "holes".
	 *
	 * @example
	 *
	 * var createIterator = require('iterall').createIterator
	 *
	 * var myArraylike = { length: 3, 0: 'Alpha', 1: 'Bravo', 2: 'Charlie' }
	 * var iterator = createIterator(myArraylike)
	 * iterator.next() // { value: 'Alpha', done: false }
	 * iterator.next() // { value: 'Bravo', done: false }
	 * iterator.next() // { value: 'Charlie', done: false }
	 * iterator.next() // { value: undefined, done: true }
	 *
	 * @template T the type of each iterated value
	 * @param {Iterable<T>|{ length: number }} collection
	 *   An Iterable or Array-like object to produce an Iterator.
	 * @return {Iterator<T>} new Iterator instance.
	 */
	function createIterator (collection) {
	  if (collection != null) {
	    var iterator = getIterator(collection)
	    if (iterator) {
	      return iterator
	    }
	    if (isArrayLike(collection)) {
	      return new ArrayLikeIterator(collection)
	    }
	  }
	}
	exports.createIterator = createIterator
	
	// When the object provided to `createIterator` is not Iterable but is
	// Array-like, this simple Iterator is created.
	function ArrayLikeIterator (obj) {
	  this._o = obj
	  this._i = 0
	}
	
	// Note: all Iterators are themselves Iterable.
	ArrayLikeIterator.prototype[$$iterator] = function () {
	  return this
	}
	
	// A simple state-machine determines the IteratorResult returned, yielding
	// each value in the Array-like object in order of their indicies.
	ArrayLikeIterator.prototype.next = function () {
	  if (this._o === void 0 || this._i >= this._o.length) {
	    this._o = void 0
	    return { value: void 0, done: true }
	  }
	  return { value: this._o[this._i++], done: false }
	}


/***/ },

/***/ "./node_modules/graphql/jsutils/find.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = find;
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function find(list, predicate) {
	  for (var i = 0; i < list.length; i++) {
	    if (predicate(list[i])) {
	      return list[i];
	    }
	  }
	}

/***/ },

/***/ "./node_modules/graphql/utilities/typeComparators.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isEqualType = isEqualType;
	exports.isTypeSubTypeOf = isTypeSubTypeOf;
	exports.doTypesOverlap = doTypesOverlap;
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	/**
	 * Provided two types, return true if the types are equal (invariant).
	 */
	function isEqualType(typeA, typeB) {
	  // Equivalent types are equal.
	  if (typeA === typeB) {
	    return true;
	  }
	
	  // If either type is non-null, the other must also be non-null.
	  if (typeA instanceof _definition.GraphQLNonNull && typeB instanceof _definition.GraphQLNonNull) {
	    return isEqualType(typeA.ofType, typeB.ofType);
	  }
	
	  // If either type is a list, the other must also be a list.
	  if (typeA instanceof _definition.GraphQLList && typeB instanceof _definition.GraphQLList) {
	    return isEqualType(typeA.ofType, typeB.ofType);
	  }
	
	  // Otherwise the types are not equal.
	  return false;
	}
	
	/**
	 * Provided a type and a super type, return true if the first type is either
	 * equal or a subset of the second super type (covariant).
	 */
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function isTypeSubTypeOf(schema, maybeSubType, superType) {
	  // Equivalent type is a valid subtype
	  if (maybeSubType === superType) {
	    return true;
	  }
	
	  // If superType is non-null, maybeSubType must also be non-null.
	  if (superType instanceof _definition.GraphQLNonNull) {
	    if (maybeSubType instanceof _definition.GraphQLNonNull) {
	      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
	    }
	    return false;
	  } else if (maybeSubType instanceof _definition.GraphQLNonNull) {
	    // If superType is nullable, maybeSubType may be non-null or nullable.
	    return isTypeSubTypeOf(schema, maybeSubType.ofType, superType);
	  }
	
	  // If superType type is a list, maybeSubType type must also be a list.
	  if (superType instanceof _definition.GraphQLList) {
	    if (maybeSubType instanceof _definition.GraphQLList) {
	      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
	    }
	    return false;
	  } else if (maybeSubType instanceof _definition.GraphQLList) {
	    // If superType is not a list, maybeSubType must also be not a list.
	    return false;
	  }
	
	  // If superType type is an abstract type, maybeSubType type may be a currently
	  // possible object type.
	  if ((0, _definition.isAbstractType)(superType) && maybeSubType instanceof _definition.GraphQLObjectType && schema.isPossibleType(superType, maybeSubType)) {
	    return true;
	  }
	
	  // Otherwise, the child type is not a valid subtype of the parent type.
	  return false;
	}
	
	/**
	 * Provided two composite types, determine if they "overlap". Two composite
	 * types overlap when the Sets of possible concrete types for each intersect.
	 *
	 * This is often used to determine if a fragment of a given type could possibly
	 * be visited in a context of another type.
	 *
	 * This function is commutative.
	 */
	function doTypesOverlap(schema, typeA, typeB) {
	  // So flow is aware this is constant
	  var _typeB = typeB;
	
	  // Equivalent types overlap
	  if (typeA === _typeB) {
	    return true;
	  }
	
	  if (typeA instanceof _definition.GraphQLInterfaceType || typeA instanceof _definition.GraphQLUnionType) {
	    if (_typeB instanceof _definition.GraphQLInterfaceType || _typeB instanceof _definition.GraphQLUnionType) {
	      // If both types are abstract, then determine if there is any intersection
	      // between possible concrete types of each.
	      return schema.getPossibleTypes(typeA).some(function (type) {
	        return schema.isPossibleType(_typeB, type);
	      });
	    }
	    // Determine if the latter type is a possible concrete type of the former.
	    return schema.isPossibleType(typeA, _typeB);
	  }
	
	  if (_typeB instanceof _definition.GraphQLInterfaceType || _typeB instanceof _definition.GraphQLUnionType) {
	    // Determine if the former type is a possible concrete type of the latter.
	    return schema.isPossibleType(_typeB, typeA);
	  }
	
	  // Otherwise the types do not overlap.
	  return false;
	}

/***/ },

/***/ "./node_modules/graphql/utilities/TypeInfo.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TypeInfo = undefined;
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	var Kind = _interopRequireWildcard(_kinds);
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	var _introspection = __webpack_require__("./node_modules/graphql/type/introspection.js");
	
	var _typeFromAST = __webpack_require__("./node_modules/graphql/utilities/typeFromAST.js");
	
	var _find = __webpack_require__("./node_modules/graphql/jsutils/find.js");
	
	var _find2 = _interopRequireDefault(_find);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	/**
	 * TypeInfo is a utility class which, given a GraphQL schema, can keep track
	 * of the current field and type definitions at any point in a GraphQL document
	 * AST during a recursive descent by calling `enter(node)` and `leave(node)`.
	 */
	var TypeInfo = exports.TypeInfo = function () {
	  function TypeInfo(schema,
	  // NOTE: this experimental optional second parameter is only needed in order
	  // to support non-spec-compliant codebases. You should never need to use it.
	  getFieldDefFn) {
	    _classCallCheck(this, TypeInfo);
	
	    this._schema = schema;
	    this._typeStack = [];
	    this._parentTypeStack = [];
	    this._inputTypeStack = [];
	    this._fieldDefStack = [];
	    this._directive = null;
	    this._argument = null;
	    this._getFieldDef = getFieldDefFn || getFieldDef;
	  }
	
	  TypeInfo.prototype.getType = function getType() {
	    if (this._typeStack.length > 0) {
	      return this._typeStack[this._typeStack.length - 1];
	    }
	  };
	
	  TypeInfo.prototype.getParentType = function getParentType() {
	    if (this._parentTypeStack.length > 0) {
	      return this._parentTypeStack[this._parentTypeStack.length - 1];
	    }
	  };
	
	  TypeInfo.prototype.getInputType = function getInputType() {
	    if (this._inputTypeStack.length > 0) {
	      return this._inputTypeStack[this._inputTypeStack.length - 1];
	    }
	  };
	
	  TypeInfo.prototype.getFieldDef = function getFieldDef() {
	    if (this._fieldDefStack.length > 0) {
	      return this._fieldDefStack[this._fieldDefStack.length - 1];
	    }
	  };
	
	  TypeInfo.prototype.getDirective = function getDirective() {
	    return this._directive;
	  };
	
	  TypeInfo.prototype.getArgument = function getArgument() {
	    return this._argument;
	  };
	
	  // Flow does not yet handle this case.
	
	
	  TypeInfo.prototype.enter = function enter(node /* ASTNode */) {
	    var schema = this._schema;
	    switch (node.kind) {
	      case Kind.SELECTION_SET:
	        var namedType = (0, _definition.getNamedType)(this.getType());
	        var compositeType = void 0;
	        if ((0, _definition.isCompositeType)(namedType)) {
	          // isCompositeType is a type refining predicate, so this is safe.
	          compositeType = namedType;
	        }
	        this._parentTypeStack.push(compositeType);
	        break;
	      case Kind.FIELD:
	        var parentType = this.getParentType();
	        var fieldDef = void 0;
	        if (parentType) {
	          fieldDef = this._getFieldDef(schema, parentType, node);
	        }
	        this._fieldDefStack.push(fieldDef);
	        this._typeStack.push(fieldDef && fieldDef.type);
	        break;
	      case Kind.DIRECTIVE:
	        this._directive = schema.getDirective(node.name.value);
	        break;
	      case Kind.OPERATION_DEFINITION:
	        var type = void 0;
	        if (node.operation === 'query') {
	          type = schema.getQueryType();
	        } else if (node.operation === 'mutation') {
	          type = schema.getMutationType();
	        } else if (node.operation === 'subscription') {
	          type = schema.getSubscriptionType();
	        }
	        this._typeStack.push(type);
	        break;
	      case Kind.INLINE_FRAGMENT:
	      case Kind.FRAGMENT_DEFINITION:
	        var typeConditionAST = node.typeCondition;
	        var outputType = typeConditionAST ? (0, _typeFromAST.typeFromAST)(schema, typeConditionAST) : this.getType();
	        this._typeStack.push(outputType);
	        break;
	      case Kind.VARIABLE_DEFINITION:
	        var inputType = (0, _typeFromAST.typeFromAST)(schema, node.type);
	        this._inputTypeStack.push(inputType);
	        break;
	      case Kind.ARGUMENT:
	        var argDef = void 0;
	        var argType = void 0;
	        var fieldOrDirective = this.getDirective() || this.getFieldDef();
	        if (fieldOrDirective) {
	          argDef = (0, _find2.default)(fieldOrDirective.args, function (arg) {
	            return arg.name === node.name.value;
	          });
	          if (argDef) {
	            argType = argDef.type;
	          }
	        }
	        this._argument = argDef;
	        this._inputTypeStack.push(argType);
	        break;
	      case Kind.LIST:
	        var listType = (0, _definition.getNullableType)(this.getInputType());
	        this._inputTypeStack.push(listType instanceof _definition.GraphQLList ? listType.ofType : undefined);
	        break;
	      case Kind.OBJECT_FIELD:
	        var objectType = (0, _definition.getNamedType)(this.getInputType());
	        var fieldType = void 0;
	        if (objectType instanceof _definition.GraphQLInputObjectType) {
	          var inputField = objectType.getFields()[node.name.value];
	          fieldType = inputField ? inputField.type : undefined;
	        }
	        this._inputTypeStack.push(fieldType);
	        break;
	    }
	  };
	
	  TypeInfo.prototype.leave = function leave(node) {
	    switch (node.kind) {
	      case Kind.SELECTION_SET:
	        this._parentTypeStack.pop();
	        break;
	      case Kind.FIELD:
	        this._fieldDefStack.pop();
	        this._typeStack.pop();
	        break;
	      case Kind.DIRECTIVE:
	        this._directive = null;
	        break;
	      case Kind.OPERATION_DEFINITION:
	      case Kind.INLINE_FRAGMENT:
	      case Kind.FRAGMENT_DEFINITION:
	        this._typeStack.pop();
	        break;
	      case Kind.VARIABLE_DEFINITION:
	        this._inputTypeStack.pop();
	        break;
	      case Kind.ARGUMENT:
	        this._argument = null;
	        this._inputTypeStack.pop();
	        break;
	      case Kind.LIST:
	      case Kind.OBJECT_FIELD:
	        this._inputTypeStack.pop();
	        break;
	    }
	  };
	
	  return TypeInfo;
	}();
	
	/**
	 * Not exactly the same as the executor's definition of getFieldDef, in this
	 * statically evaluated environment we do not always have an Object type,
	 * and need to handle Interface and Union types.
	 */
	
	
	function getFieldDef(schema, parentType, fieldNode) {
	  var name = fieldNode.name.value;
	  if (name === _introspection.SchemaMetaFieldDef.name && schema.getQueryType() === parentType) {
	    return _introspection.SchemaMetaFieldDef;
	  }
	  if (name === _introspection.TypeMetaFieldDef.name && schema.getQueryType() === parentType) {
	    return _introspection.TypeMetaFieldDef;
	  }
	  if (name === _introspection.TypeNameMetaFieldDef.name && (parentType instanceof _definition.GraphQLObjectType || parentType instanceof _definition.GraphQLInterfaceType || parentType instanceof _definition.GraphQLUnionType)) {
	    return _introspection.TypeNameMetaFieldDef;
	  }
	  if (parentType instanceof _definition.GraphQLObjectType || parentType instanceof _definition.GraphQLInterfaceType) {
	    return parentType.getFields()[name];
	  }
	}

/***/ },

/***/ "./node_modules/graphql/utilities/typeFromAST.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.typeFromAST = typeFromAST;
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function typeFromAST(schema, typeNode) {
	  var innerType = void 0;
	  if (typeNode.kind === _kinds.LIST_TYPE) {
	    innerType = typeFromAST(schema, typeNode.type);
	    return innerType && new _definition.GraphQLList(innerType);
	  }
	  if (typeNode.kind === _kinds.NON_NULL_TYPE) {
	    innerType = typeFromAST(schema, typeNode.type);
	    return innerType && new _definition.GraphQLNonNull(innerType);
	  }
	  (0, _invariant2.default)(typeNode.kind === _kinds.NAMED_TYPE, 'Must be a named type.');
	  return schema.getType(typeNode.name.value);
	}
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */

/***/ },

/***/ "./node_modules/graphql/validation/specifiedRules.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.specifiedRules = undefined;
	
	var _UniqueOperationNames = __webpack_require__("./node_modules/graphql/validation/rules/UniqueOperationNames.js");
	
	var _LoneAnonymousOperation = __webpack_require__("./node_modules/graphql/validation/rules/LoneAnonymousOperation.js");
	
	var _KnownTypeNames = __webpack_require__("./node_modules/graphql/validation/rules/KnownTypeNames.js");
	
	var _FragmentsOnCompositeTypes = __webpack_require__("./node_modules/graphql/validation/rules/FragmentsOnCompositeTypes.js");
	
	var _VariablesAreInputTypes = __webpack_require__("./node_modules/graphql/validation/rules/VariablesAreInputTypes.js");
	
	var _ScalarLeafs = __webpack_require__("./node_modules/graphql/validation/rules/ScalarLeafs.js");
	
	var _FieldsOnCorrectType = __webpack_require__("./node_modules/graphql/validation/rules/FieldsOnCorrectType.js");
	
	var _UniqueFragmentNames = __webpack_require__("./node_modules/graphql/validation/rules/UniqueFragmentNames.js");
	
	var _KnownFragmentNames = __webpack_require__("./node_modules/graphql/validation/rules/KnownFragmentNames.js");
	
	var _NoUnusedFragments = __webpack_require__("./node_modules/graphql/validation/rules/NoUnusedFragments.js");
	
	var _PossibleFragmentSpreads = __webpack_require__("./node_modules/graphql/validation/rules/PossibleFragmentSpreads.js");
	
	var _NoFragmentCycles = __webpack_require__("./node_modules/graphql/validation/rules/NoFragmentCycles.js");
	
	var _UniqueVariableNames = __webpack_require__("./node_modules/graphql/validation/rules/UniqueVariableNames.js");
	
	var _NoUndefinedVariables = __webpack_require__("./node_modules/graphql/validation/rules/NoUndefinedVariables.js");
	
	var _NoUnusedVariables = __webpack_require__("./node_modules/graphql/validation/rules/NoUnusedVariables.js");
	
	var _KnownDirectives = __webpack_require__("./node_modules/graphql/validation/rules/KnownDirectives.js");
	
	var _UniqueDirectivesPerLocation = __webpack_require__("./node_modules/graphql/validation/rules/UniqueDirectivesPerLocation.js");
	
	var _KnownArgumentNames = __webpack_require__("./node_modules/graphql/validation/rules/KnownArgumentNames.js");
	
	var _UniqueArgumentNames = __webpack_require__("./node_modules/graphql/validation/rules/UniqueArgumentNames.js");
	
	var _ArgumentsOfCorrectType = __webpack_require__("./node_modules/graphql/validation/rules/ArgumentsOfCorrectType.js");
	
	var _ProvidedNonNullArguments = __webpack_require__("./node_modules/graphql/validation/rules/ProvidedNonNullArguments.js");
	
	var _DefaultValuesOfCorrectType = __webpack_require__("./node_modules/graphql/validation/rules/DefaultValuesOfCorrectType.js");
	
	var _VariablesInAllowedPosition = __webpack_require__("./node_modules/graphql/validation/rules/VariablesInAllowedPosition.js");
	
	var _OverlappingFieldsCanBeMerged = __webpack_require__("./node_modules/graphql/validation/rules/OverlappingFieldsCanBeMerged.js");
	
	var _UniqueInputFieldNames = __webpack_require__("./node_modules/graphql/validation/rules/UniqueInputFieldNames.js");
	
	/**
	 * This set includes all validation rules defined by the GraphQL spec.
	 */
	
	
	// Spec Section: "Field Selection Merging"
	
	
	// Spec Section: "Variable Default Values Are Correctly Typed"
	
	
	// Spec Section: "Argument Values Type Correctness"
	
	
	// Spec Section: "Argument Names"
	
	
	// Spec Section: "Directives Are Defined"
	
	
	// Spec Section: "All Variable Used Defined"
	
	
	// Spec Section: "Fragments must not form cycles"
	
	
	// Spec Section: "Fragments must be used"
	
	
	// Spec Section: "Fragment Name Uniqueness"
	
	
	// Spec Section: "Leaf Field Selections"
	
	
	// Spec Section: "Fragments on Composite Types"
	
	
	// Spec Section: "Lone Anonymous Operation"
	var specifiedRules = exports.specifiedRules = [_UniqueOperationNames.UniqueOperationNames, _LoneAnonymousOperation.LoneAnonymousOperation, _KnownTypeNames.KnownTypeNames, _FragmentsOnCompositeTypes.FragmentsOnCompositeTypes, _VariablesAreInputTypes.VariablesAreInputTypes, _ScalarLeafs.ScalarLeafs, _FieldsOnCorrectType.FieldsOnCorrectType, _UniqueFragmentNames.UniqueFragmentNames, _KnownFragmentNames.KnownFragmentNames, _NoUnusedFragments.NoUnusedFragments, _PossibleFragmentSpreads.PossibleFragmentSpreads, _NoFragmentCycles.NoFragmentCycles, _UniqueVariableNames.UniqueVariableNames, _NoUndefinedVariables.NoUndefinedVariables, _NoUnusedVariables.NoUnusedVariables, _KnownDirectives.KnownDirectives, _UniqueDirectivesPerLocation.UniqueDirectivesPerLocation, _KnownArgumentNames.KnownArgumentNames, _UniqueArgumentNames.UniqueArgumentNames, _ArgumentsOfCorrectType.ArgumentsOfCorrectType, _ProvidedNonNullArguments.ProvidedNonNullArguments, _DefaultValuesOfCorrectType.DefaultValuesOfCorrectType, _VariablesInAllowedPosition.VariablesInAllowedPosition, _OverlappingFieldsCanBeMerged.OverlappingFieldsCanBeMerged, _UniqueInputFieldNames.UniqueInputFieldNames];
	
	// Spec Section: "Input Object Field Uniqueness"
	
	
	// Spec Section: "All Variable Usages Are Allowed"
	
	
	// Spec Section: "Argument Optionality"
	
	
	// Spec Section: "Argument Uniqueness"
	
	
	// Spec Section: "Directives Are Unique Per Location"
	
	
	// Spec Section: "All Variables Used"
	
	
	// Spec Section: "Variable Uniqueness"
	
	
	// Spec Section: "Fragment spread is possible"
	
	
	// Spec Section: "Fragment spread target defined"
	
	
	// Spec Section: "Field Selections on Objects, Interfaces, and Unions Types"
	
	
	// Spec Section: "Variables are Input Types"
	
	
	// Spec Section: "Fragment Spread Type Existence"
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Spec Section: "Operation Name Uniqueness"

/***/ },

/***/ "./node_modules/graphql/validation/rules/UniqueOperationNames.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateOperationNameMessage = duplicateOperationNameMessage;
	exports.UniqueOperationNames = UniqueOperationNames;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function duplicateOperationNameMessage(operationName) {
	  return 'There can only be one operation named "' + operationName + '".';
	}
	
	/**
	 * Unique operation names
	 *
	 * A GraphQL document is only valid if all defined operations have unique names.
	 */
	function UniqueOperationNames(context) {
	  var knownOperationNames = Object.create(null);
	  return {
	    OperationDefinition: function OperationDefinition(node) {
	      var operationName = node.name;
	      if (operationName) {
	        if (knownOperationNames[operationName.value]) {
	          context.reportError(new _error.GraphQLError(duplicateOperationNameMessage(operationName.value), [knownOperationNames[operationName.value], operationName]));
	        } else {
	          knownOperationNames[operationName.value] = operationName;
	        }
	      }
	      return false;
	    },
	
	    FragmentDefinition: function FragmentDefinition() {
	      return false;
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/LoneAnonymousOperation.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.anonOperationNotAloneMessage = anonOperationNotAloneMessage;
	exports.LoneAnonymousOperation = LoneAnonymousOperation;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	function anonOperationNotAloneMessage() {
	  return 'This anonymous operation must be the only defined operation.';
	}
	
	/**
	 * Lone anonymous operation
	 *
	 * A GraphQL document is only valid if when it contains an anonymous operation
	 * (the query short-hand) that it contains only that one operation definition.
	 */
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function LoneAnonymousOperation(context) {
	  var operationCount = 0;
	  return {
	    Document: function Document(node) {
	      operationCount = node.definitions.filter(function (definition) {
	        return definition.kind === _kinds.OPERATION_DEFINITION;
	      }).length;
	    },
	    OperationDefinition: function OperationDefinition(node) {
	      if (!node.name && operationCount > 1) {
	        context.reportError(new _error.GraphQLError(anonOperationNotAloneMessage(), [node]));
	      }
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/KnownTypeNames.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unknownTypeMessage = unknownTypeMessage;
	exports.KnownTypeNames = KnownTypeNames;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _suggestionList = __webpack_require__("./node_modules/graphql/jsutils/suggestionList.js");
	
	var _suggestionList2 = _interopRequireDefault(_suggestionList);
	
	var _quotedOrList = __webpack_require__("./node_modules/graphql/jsutils/quotedOrList.js");
	
	var _quotedOrList2 = _interopRequireDefault(_quotedOrList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function unknownTypeMessage(type, suggestedTypes) {
	  var message = 'Unknown type "' + String(type) + '".';
	  if (suggestedTypes.length) {
	    message += ' Did you mean ' + (0, _quotedOrList2.default)(suggestedTypes) + '?';
	  }
	  return message;
	}
	
	/**
	 * Known type names
	 *
	 * A GraphQL document is only valid if referenced types (specifically
	 * variable definitions and fragment conditions) are defined by the type schema.
	 */
	function KnownTypeNames(context) {
	  return {
	    // TODO: when validating IDL, re-enable these. Experimental version does not
	    // add unreferenced types, resulting in false-positive errors. Squelched
	    // errors for now.
	    ObjectTypeDefinition: function ObjectTypeDefinition() {
	      return false;
	    },
	    InterfaceTypeDefinition: function InterfaceTypeDefinition() {
	      return false;
	    },
	    UnionTypeDefinition: function UnionTypeDefinition() {
	      return false;
	    },
	    InputObjectTypeDefinition: function InputObjectTypeDefinition() {
	      return false;
	    },
	    NamedType: function NamedType(node) {
	      var schema = context.getSchema();
	      var typeName = node.name.value;
	      var type = schema.getType(typeName);
	      if (!type) {
	        context.reportError(new _error.GraphQLError(unknownTypeMessage(typeName, (0, _suggestionList2.default)(typeName, Object.keys(schema.getTypeMap()))), [node]));
	      }
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/jsutils/suggestionList.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = suggestionList;
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	/**
	 * Given an invalid input string and a list of valid options, returns a filtered
	 * list of valid options sorted based on their similarity with the input.
	 */
	function suggestionList(input, options) {
	  var optionsByDistance = Object.create(null);
	  var oLength = options.length;
	  var inputThreshold = input.length / 2;
	  for (var i = 0; i < oLength; i++) {
	    var distance = lexicalDistance(input, options[i]);
	    var threshold = Math.max(inputThreshold, options[i].length / 2, 1);
	    if (distance <= threshold) {
	      optionsByDistance[options[i]] = distance;
	    }
	  }
	  return Object.keys(optionsByDistance).sort(function (a, b) {
	    return optionsByDistance[a] - optionsByDistance[b];
	  });
	}
	
	/**
	 * Computes the lexical distance between strings A and B.
	 *
	 * The "distance" between two strings is given by counting the minimum number
	 * of edits needed to transform string A into string B. An edit can be an
	 * insertion, deletion, or substitution of a single character, or a swap of two
	 * adjacent characters.
	 *
	 * This distance can be useful for detecting typos in input or sorting
	 *
	 * @param {string} a
	 * @param {string} b
	 * @return {int} distance in number of edits
	 */
	function lexicalDistance(a, b) {
	  var i = void 0;
	  var j = void 0;
	  var d = [];
	  var aLength = a.length;
	  var bLength = b.length;
	
	  for (i = 0; i <= aLength; i++) {
	    d[i] = [i];
	  }
	
	  for (j = 1; j <= bLength; j++) {
	    d[0][j] = j;
	  }
	
	  for (i = 1; i <= aLength; i++) {
	    for (j = 1; j <= bLength; j++) {
	      var cost = a[i - 1] === b[j - 1] ? 0 : 1;
	
	      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
	
	      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
	        d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + cost);
	      }
	    }
	  }
	
	  return d[aLength][bLength];
	}

/***/ },

/***/ "./node_modules/graphql/jsutils/quotedOrList.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = quotedOrList;
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	var MAX_LENGTH = 5;
	
	/**
	 * Given [ A, B, C ] return '"A", "B", or "C"'.
	 */
	function quotedOrList(items) {
	  var selected = items.slice(0, MAX_LENGTH);
	  return selected.map(function (item) {
	    return '"' + item + '"';
	  }).reduce(function (list, quoted, index) {
	    return list + (selected.length > 2 ? ', ' : ' ') + (index === selected.length - 1 ? 'or ' : '') + quoted;
	  });
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/FragmentsOnCompositeTypes.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.inlineFragmentOnNonCompositeErrorMessage = inlineFragmentOnNonCompositeErrorMessage;
	exports.fragmentOnNonCompositeErrorMessage = fragmentOnNonCompositeErrorMessage;
	exports.FragmentsOnCompositeTypes = FragmentsOnCompositeTypes;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _printer = __webpack_require__("./node_modules/graphql/language/printer.js");
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function inlineFragmentOnNonCompositeErrorMessage(type) {
	  return 'Fragment cannot condition on non composite type "' + String(type) + '".';
	}
	
	function fragmentOnNonCompositeErrorMessage(fragName, type) {
	  return 'Fragment "' + fragName + '" cannot condition on non composite ' + ('type "' + String(type) + '".');
	}
	
	/**
	 * Fragments on composite type
	 *
	 * Fragments use a type condition to determine if they apply, since fragments
	 * can only be spread into a composite type (object, interface, or union), the
	 * type condition must also be a composite type.
	 */
	function FragmentsOnCompositeTypes(context) {
	  return {
	    InlineFragment: function InlineFragment(node) {
	      var type = context.getType();
	      if (node.typeCondition && type && !(0, _definition.isCompositeType)(type)) {
	        context.reportError(new _error.GraphQLError(inlineFragmentOnNonCompositeErrorMessage((0, _printer.print)(node.typeCondition)), [node.typeCondition]));
	      }
	    },
	    FragmentDefinition: function FragmentDefinition(node) {
	      var type = context.getType();
	      if (type && !(0, _definition.isCompositeType)(type)) {
	        context.reportError(new _error.GraphQLError(fragmentOnNonCompositeErrorMessage(node.name.value, (0, _printer.print)(node.typeCondition)), [node.typeCondition]));
	      }
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/VariablesAreInputTypes.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nonInputTypeOnVarMessage = nonInputTypeOnVarMessage;
	exports.VariablesAreInputTypes = VariablesAreInputTypes;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _printer = __webpack_require__("./node_modules/graphql/language/printer.js");
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	var _typeFromAST = __webpack_require__("./node_modules/graphql/utilities/typeFromAST.js");
	
	function nonInputTypeOnVarMessage(variableName, typeName) {
	  return 'Variable "$' + variableName + '" cannot be non-input type "' + typeName + '".';
	}
	
	/**
	 * Variables are input types
	 *
	 * A GraphQL operation is only valid if all the variables it defines are of
	 * input types (scalar, enum, or input object).
	 */
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function VariablesAreInputTypes(context) {
	  return {
	    VariableDefinition: function VariableDefinition(node) {
	      var type = (0, _typeFromAST.typeFromAST)(context.getSchema(), node.type);
	
	      // If the variable type is not an input type, return an error.
	      if (type && !(0, _definition.isInputType)(type)) {
	        var variableName = node.variable.name.value;
	        context.reportError(new _error.GraphQLError(nonInputTypeOnVarMessage(variableName, (0, _printer.print)(node.type)), [node.type]));
	      }
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/ScalarLeafs.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.noSubselectionAllowedMessage = noSubselectionAllowedMessage;
	exports.requiredSubselectionMessage = requiredSubselectionMessage;
	exports.ScalarLeafs = ScalarLeafs;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	function noSubselectionAllowedMessage(fieldName, type) {
	  return 'Field "' + fieldName + '" must not have a selection since ' + ('type "' + String(type) + '" has no subfields.');
	}
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function requiredSubselectionMessage(fieldName, type) {
	  return 'Field "' + fieldName + '" of type "' + String(type) + '" must have a ' + ('selection of subfields. Did you mean "' + fieldName + ' { ... }"?');
	}
	
	/**
	 * Scalar leafs
	 *
	 * A GraphQL document is valid only if all leaf fields (fields without
	 * sub selections) are of scalar or enum types.
	 */
	function ScalarLeafs(context) {
	  return {
	    Field: function Field(node) {
	      var type = context.getType();
	      if (type) {
	        if ((0, _definition.isLeafType)(type)) {
	          if (node.selectionSet) {
	            context.reportError(new _error.GraphQLError(noSubselectionAllowedMessage(node.name.value, type), [node.selectionSet]));
	          }
	        } else if (!node.selectionSet) {
	          context.reportError(new _error.GraphQLError(requiredSubselectionMessage(node.name.value, type), [node]));
	        }
	      }
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/FieldsOnCorrectType.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.undefinedFieldMessage = undefinedFieldMessage;
	exports.FieldsOnCorrectType = FieldsOnCorrectType;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _suggestionList = __webpack_require__("./node_modules/graphql/jsutils/suggestionList.js");
	
	var _suggestionList2 = _interopRequireDefault(_suggestionList);
	
	var _quotedOrList = __webpack_require__("./node_modules/graphql/jsutils/quotedOrList.js");
	
	var _quotedOrList2 = _interopRequireDefault(_quotedOrList);
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function undefinedFieldMessage(fieldName, type, suggestedTypeNames, suggestedFieldNames) {
	  var message = 'Cannot query field "' + fieldName + '" on type "' + type + '".';
	  if (suggestedTypeNames.length !== 0) {
	    var suggestions = (0, _quotedOrList2.default)(suggestedTypeNames);
	    message += ' Did you mean to use an inline fragment on ' + suggestions + '?';
	  } else if (suggestedFieldNames.length !== 0) {
	    message += ' Did you mean ' + (0, _quotedOrList2.default)(suggestedFieldNames) + '?';
	  }
	  return message;
	}
	
	/**
	 * Fields on correct type
	 *
	 * A GraphQL document is only valid if all fields selected are defined by the
	 * parent type, or are an allowed meta field such as __typename.
	 */
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function FieldsOnCorrectType(context) {
	  return {
	    Field: function Field(node) {
	      var type = context.getParentType();
	      if (type) {
	        var fieldDef = context.getFieldDef();
	        if (!fieldDef) {
	          // This field doesn't exist, lets look for suggestions.
	          var schema = context.getSchema();
	          var fieldName = node.name.value;
	          // First determine if there are any suggested types to condition on.
	          var suggestedTypeNames = getSuggestedTypeNames(schema, type, fieldName);
	          // If there are no suggested types, then perhaps this was a typo?
	          var suggestedFieldNames = suggestedTypeNames.length !== 0 ? [] : getSuggestedFieldNames(schema, type, fieldName);
	
	          // Report an error, including helpful suggestions.
	          context.reportError(new _error.GraphQLError(undefinedFieldMessage(fieldName, type.name, suggestedTypeNames, suggestedFieldNames), [node]));
	        }
	      }
	    }
	  };
	}
	
	/**
	 * Go through all of the implementations of type, as well as the interfaces
	 * that they implement. If any of those types include the provided field,
	 * suggest them, sorted by how often the type is referenced,  starting
	 * with Interfaces.
	 */
	function getSuggestedTypeNames(schema, type, fieldName) {
	  if (type instanceof _definition.GraphQLInterfaceType || type instanceof _definition.GraphQLUnionType) {
	    var _ret = function () {
	      var suggestedObjectTypes = [];
	      var interfaceUsageCount = Object.create(null);
	      schema.getPossibleTypes(type).forEach(function (possibleType) {
	        if (!possibleType.getFields()[fieldName]) {
	          return;
	        }
	        // This object type defines this field.
	        suggestedObjectTypes.push(possibleType.name);
	        possibleType.getInterfaces().forEach(function (possibleInterface) {
	          if (!possibleInterface.getFields()[fieldName]) {
	            return;
	          }
	          // This interface type defines this field.
	          interfaceUsageCount[possibleInterface.name] = (interfaceUsageCount[possibleInterface.name] || 0) + 1;
	        });
	      });
	
	      // Suggest interface types based on how common they are.
	      var suggestedInterfaceTypes = Object.keys(interfaceUsageCount).sort(function (a, b) {
	        return interfaceUsageCount[b] - interfaceUsageCount[a];
	      });
	
	      // Suggest both interface and object types.
	      return {
	        v: suggestedInterfaceTypes.concat(suggestedObjectTypes)
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	
	  // Otherwise, must be an Object type, which does not have possible fields.
	  return [];
	}
	
	/**
	 * For the field name provided, determine if there are any similar field names
	 * that may be the result of a typo.
	 */
	function getSuggestedFieldNames(schema, type, fieldName) {
	  if (type instanceof _definition.GraphQLObjectType || type instanceof _definition.GraphQLInterfaceType) {
	    var possibleFieldNames = Object.keys(type.getFields());
	    return (0, _suggestionList2.default)(fieldName, possibleFieldNames);
	  }
	  // Otherwise, must be a Union type, which does not define fields.
	  return [];
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/UniqueFragmentNames.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateFragmentNameMessage = duplicateFragmentNameMessage;
	exports.UniqueFragmentNames = UniqueFragmentNames;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function duplicateFragmentNameMessage(fragName) {
	  return 'There can only be one fragment named "' + fragName + '".';
	}
	
	/**
	 * Unique fragment names
	 *
	 * A GraphQL document is only valid if all defined fragments have unique names.
	 */
	function UniqueFragmentNames(context) {
	  var knownFragmentNames = Object.create(null);
	  return {
	    OperationDefinition: function OperationDefinition() {
	      return false;
	    },
	    FragmentDefinition: function FragmentDefinition(node) {
	      var fragmentName = node.name.value;
	      if (knownFragmentNames[fragmentName]) {
	        context.reportError(new _error.GraphQLError(duplicateFragmentNameMessage(fragmentName), [knownFragmentNames[fragmentName], node.name]));
	      } else {
	        knownFragmentNames[fragmentName] = node.name;
	      }
	      return false;
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/KnownFragmentNames.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unknownFragmentMessage = unknownFragmentMessage;
	exports.KnownFragmentNames = KnownFragmentNames;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function unknownFragmentMessage(fragName) {
	  return 'Unknown fragment "' + fragName + '".';
	}
	
	/**
	 * Known fragment names
	 *
	 * A GraphQL document is only valid if all `...Fragment` fragment spreads refer
	 * to fragments defined in the same document.
	 */
	function KnownFragmentNames(context) {
	  return {
	    FragmentSpread: function FragmentSpread(node) {
	      var fragmentName = node.name.value;
	      var fragment = context.getFragment(fragmentName);
	      if (!fragment) {
	        context.reportError(new _error.GraphQLError(unknownFragmentMessage(fragmentName), [node.name]));
	      }
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/NoUnusedFragments.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unusedFragMessage = unusedFragMessage;
	exports.NoUnusedFragments = NoUnusedFragments;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function unusedFragMessage(fragName) {
	  return 'Fragment "' + fragName + '" is never used.';
	}
	
	/**
	 * No unused fragments
	 *
	 * A GraphQL document is only valid if all fragment definitions are spread
	 * within operations, or spread within other fragments spread within operations.
	 */
	function NoUnusedFragments(context) {
	  var operationDefs = [];
	  var fragmentDefs = [];
	
	  return {
	    OperationDefinition: function OperationDefinition(node) {
	      operationDefs.push(node);
	      return false;
	    },
	    FragmentDefinition: function FragmentDefinition(node) {
	      fragmentDefs.push(node);
	      return false;
	    },
	
	    Document: {
	      leave: function leave() {
	        var fragmentNameUsed = Object.create(null);
	        operationDefs.forEach(function (operation) {
	          context.getRecursivelyReferencedFragments(operation).forEach(function (fragment) {
	            fragmentNameUsed[fragment.name.value] = true;
	          });
	        });
	
	        fragmentDefs.forEach(function (fragmentDef) {
	          var fragName = fragmentDef.name.value;
	          if (fragmentNameUsed[fragName] !== true) {
	            context.reportError(new _error.GraphQLError(unusedFragMessage(fragName), [fragmentDef]));
	          }
	        });
	      }
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/PossibleFragmentSpreads.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.typeIncompatibleSpreadMessage = typeIncompatibleSpreadMessage;
	exports.typeIncompatibleAnonSpreadMessage = typeIncompatibleAnonSpreadMessage;
	exports.PossibleFragmentSpreads = PossibleFragmentSpreads;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _typeComparators = __webpack_require__("./node_modules/graphql/utilities/typeComparators.js");
	
	var _typeFromAST = __webpack_require__("./node_modules/graphql/utilities/typeFromAST.js");
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function typeIncompatibleSpreadMessage(fragName, parentType, fragType) {
	  return 'Fragment "' + fragName + '" cannot be spread here as objects of ' + ('type "' + String(parentType) + '" can never be of type "' + String(fragType) + '".');
	}
	
	function typeIncompatibleAnonSpreadMessage(parentType, fragType) {
	  return 'Fragment cannot be spread here as objects of ' + ('type "' + String(parentType) + '" can never be of type "' + String(fragType) + '".');
	}
	
	/**
	 * Possible fragment spread
	 *
	 * A fragment spread is only valid if the type condition could ever possibly
	 * be true: if there is a non-empty intersection of the possible parent types,
	 * and possible types which pass the type condition.
	 */
	function PossibleFragmentSpreads(context) {
	  return {
	    InlineFragment: function InlineFragment(node) {
	      var fragType = context.getType();
	      var parentType = context.getParentType();
	      if (fragType && parentType && !(0, _typeComparators.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
	        context.reportError(new _error.GraphQLError(typeIncompatibleAnonSpreadMessage(parentType, fragType), [node]));
	      }
	    },
	    FragmentSpread: function FragmentSpread(node) {
	      var fragName = node.name.value;
	      var fragType = getFragmentType(context, fragName);
	      var parentType = context.getParentType();
	      if (fragType && parentType && !(0, _typeComparators.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
	        context.reportError(new _error.GraphQLError(typeIncompatibleSpreadMessage(fragName, parentType, fragType), [node]));
	      }
	    }
	  };
	}
	
	function getFragmentType(context, name) {
	  var frag = context.getFragment(name);
	  return frag && (0, _typeFromAST.typeFromAST)(context.getSchema(), frag.typeCondition);
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/NoFragmentCycles.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cycleErrorMessage = cycleErrorMessage;
	exports.NoFragmentCycles = NoFragmentCycles;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function cycleErrorMessage(fragName, spreadNames) {
	  var via = spreadNames.length ? ' via ' + spreadNames.join(', ') : '';
	  return 'Cannot spread fragment "' + fragName + '" within itself' + via + '.';
	}
	
	function NoFragmentCycles(context) {
	  // Tracks already visited fragments to maintain O(N) and to ensure that cycles
	  // are not redundantly reported.
	  var visitedFrags = Object.create(null);
	
	  // Array of AST nodes used to produce meaningful errors
	  var spreadPath = [];
	
	  // Position in the spread path
	  var spreadPathIndexByName = Object.create(null);
	
	  return {
	    OperationDefinition: function OperationDefinition() {
	      return false;
	    },
	    FragmentDefinition: function FragmentDefinition(node) {
	      if (!visitedFrags[node.name.value]) {
	        detectCycleRecursive(node);
	      }
	      return false;
	    }
	  };
	
	  // This does a straight-forward DFS to find cycles.
	  // It does not terminate when a cycle was found but continues to explore
	  // the graph to find all possible cycles.
	  function detectCycleRecursive(fragment) {
	    var fragmentName = fragment.name.value;
	    visitedFrags[fragmentName] = true;
	
	    var spreadNodes = context.getFragmentSpreads(fragment.selectionSet);
	    if (spreadNodes.length === 0) {
	      return;
	    }
	
	    spreadPathIndexByName[fragmentName] = spreadPath.length;
	
	    for (var i = 0; i < spreadNodes.length; i++) {
	      var spreadNode = spreadNodes[i];
	      var spreadName = spreadNode.name.value;
	      var cycleIndex = spreadPathIndexByName[spreadName];
	
	      if (cycleIndex === undefined) {
	        spreadPath.push(spreadNode);
	        if (!visitedFrags[spreadName]) {
	          var spreadFragment = context.getFragment(spreadName);
	          if (spreadFragment) {
	            detectCycleRecursive(spreadFragment);
	          }
	        }
	        spreadPath.pop();
	      } else {
	        var cyclePath = spreadPath.slice(cycleIndex);
	        context.reportError(new _error.GraphQLError(cycleErrorMessage(spreadName, cyclePath.map(function (s) {
	          return s.name.value;
	        })), cyclePath.concat(spreadNode)));
	      }
	    }
	
	    spreadPathIndexByName[fragmentName] = undefined;
	  }
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/UniqueVariableNames.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateVariableMessage = duplicateVariableMessage;
	exports.UniqueVariableNames = UniqueVariableNames;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	function duplicateVariableMessage(variableName) {
	  return 'There can be only one variable named "' + variableName + '".';
	}
	
	/**
	 * Unique variable names
	 *
	 * A GraphQL operation is only valid if all its variables are uniquely named.
	 */
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function UniqueVariableNames(context) {
	  var knownVariableNames = Object.create(null);
	  return {
	    OperationDefinition: function OperationDefinition() {
	      knownVariableNames = Object.create(null);
	    },
	    VariableDefinition: function VariableDefinition(node) {
	      var variableName = node.variable.name.value;
	      if (knownVariableNames[variableName]) {
	        context.reportError(new _error.GraphQLError(duplicateVariableMessage(variableName), [knownVariableNames[variableName], node.variable.name]));
	      } else {
	        knownVariableNames[variableName] = node.variable.name;
	      }
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/NoUndefinedVariables.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.undefinedVarMessage = undefinedVarMessage;
	exports.NoUndefinedVariables = NoUndefinedVariables;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function undefinedVarMessage(varName, opName) {
	  return opName ? 'Variable "$' + varName + '" is not defined by operation "' + opName + '".' : 'Variable "$' + varName + '" is not defined.';
	}
	
	/**
	 * No undefined variables
	 *
	 * A GraphQL operation is only valid if all variables encountered, both directly
	 * and via fragment spreads, are defined by that operation.
	 */
	function NoUndefinedVariables(context) {
	  var variableNameDefined = Object.create(null);
	
	  return {
	    OperationDefinition: {
	      enter: function enter() {
	        variableNameDefined = Object.create(null);
	      },
	      leave: function leave(operation) {
	        var usages = context.getRecursiveVariableUsages(operation);
	
	        usages.forEach(function (_ref) {
	          var node = _ref.node;
	
	          var varName = node.name.value;
	          if (variableNameDefined[varName] !== true) {
	            context.reportError(new _error.GraphQLError(undefinedVarMessage(varName, operation.name && operation.name.value), [node, operation]));
	          }
	        });
	      }
	    },
	    VariableDefinition: function VariableDefinition(node) {
	      variableNameDefined[node.variable.name.value] = true;
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/NoUnusedVariables.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unusedVariableMessage = unusedVariableMessage;
	exports.NoUnusedVariables = NoUnusedVariables;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function unusedVariableMessage(varName, opName) {
	  return opName ? 'Variable "$' + varName + '" is never used in operation "' + opName + '".' : 'Variable "$' + varName + '" is never used.';
	}
	
	/**
	 * No unused variables
	 *
	 * A GraphQL operation is only valid if all variables defined by an operation
	 * are used, either directly or within a spread fragment.
	 */
	function NoUnusedVariables(context) {
	  var variableDefs = [];
	
	  return {
	    OperationDefinition: {
	      enter: function enter() {
	        variableDefs = [];
	      },
	      leave: function leave(operation) {
	        var variableNameUsed = Object.create(null);
	        var usages = context.getRecursiveVariableUsages(operation);
	        var opName = operation.name ? operation.name.value : null;
	
	        usages.forEach(function (_ref) {
	          var node = _ref.node;
	
	          variableNameUsed[node.name.value] = true;
	        });
	
	        variableDefs.forEach(function (variableDef) {
	          var variableName = variableDef.variable.name.value;
	          if (variableNameUsed[variableName] !== true) {
	            context.reportError(new _error.GraphQLError(unusedVariableMessage(variableName, opName), [variableDef]));
	          }
	        });
	      }
	    },
	    VariableDefinition: function VariableDefinition(def) {
	      variableDefs.push(def);
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/KnownDirectives.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unknownDirectiveMessage = unknownDirectiveMessage;
	exports.misplacedDirectiveMessage = misplacedDirectiveMessage;
	exports.KnownDirectives = KnownDirectives;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _find = __webpack_require__("./node_modules/graphql/jsutils/find.js");
	
	var _find2 = _interopRequireDefault(_find);
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	var _directives = __webpack_require__("./node_modules/graphql/type/directives.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unknownDirectiveMessage(directiveName) {
	  return 'Unknown directive "' + directiveName + '".';
	}
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function misplacedDirectiveMessage(directiveName, location) {
	  return 'Directive "' + directiveName + '" may not be used on ' + location + '.';
	}
	
	/**
	 * Known directives
	 *
	 * A GraphQL document is only valid if all `@directives` are known by the
	 * schema and legally positioned.
	 */
	function KnownDirectives(context) {
	  return {
	    Directive: function Directive(node, key, parent, path, ancestors) {
	      var directiveDef = (0, _find2.default)(context.getSchema().getDirectives(), function (def) {
	        return def.name === node.name.value;
	      });
	      if (!directiveDef) {
	        context.reportError(new _error.GraphQLError(unknownDirectiveMessage(node.name.value), [node]));
	        return;
	      }
	      var candidateLocation = getDirectiveLocationForASTPath(ancestors);
	      if (!candidateLocation) {
	        context.reportError(new _error.GraphQLError(misplacedDirectiveMessage(node.name.value, node.type), [node]));
	      } else if (directiveDef.locations.indexOf(candidateLocation) === -1) {
	        context.reportError(new _error.GraphQLError(misplacedDirectiveMessage(node.name.value, candidateLocation), [node]));
	      }
	    }
	  };
	}
	
	function getDirectiveLocationForASTPath(ancestors) {
	  var appliedTo = ancestors[ancestors.length - 1];
	  switch (appliedTo.kind) {
	    case _kinds.OPERATION_DEFINITION:
	      switch (appliedTo.operation) {
	        case 'query':
	          return _directives.DirectiveLocation.QUERY;
	        case 'mutation':
	          return _directives.DirectiveLocation.MUTATION;
	        case 'subscription':
	          return _directives.DirectiveLocation.SUBSCRIPTION;
	      }
	      break;
	    case _kinds.FIELD:
	      return _directives.DirectiveLocation.FIELD;
	    case _kinds.FRAGMENT_SPREAD:
	      return _directives.DirectiveLocation.FRAGMENT_SPREAD;
	    case _kinds.INLINE_FRAGMENT:
	      return _directives.DirectiveLocation.INLINE_FRAGMENT;
	    case _kinds.FRAGMENT_DEFINITION:
	      return _directives.DirectiveLocation.FRAGMENT_DEFINITION;
	    case _kinds.SCHEMA_DEFINITION:
	      return _directives.DirectiveLocation.SCHEMA;
	    case _kinds.SCALAR_TYPE_DEFINITION:
	      return _directives.DirectiveLocation.SCALAR;
	    case _kinds.OBJECT_TYPE_DEFINITION:
	      return _directives.DirectiveLocation.OBJECT;
	    case _kinds.FIELD_DEFINITION:
	      return _directives.DirectiveLocation.FIELD_DEFINITION;
	    case _kinds.INTERFACE_TYPE_DEFINITION:
	      return _directives.DirectiveLocation.INTERFACE;
	    case _kinds.UNION_TYPE_DEFINITION:
	      return _directives.DirectiveLocation.UNION;
	    case _kinds.ENUM_TYPE_DEFINITION:
	      return _directives.DirectiveLocation.ENUM;
	    case _kinds.ENUM_VALUE_DEFINITION:
	      return _directives.DirectiveLocation.ENUM_VALUE;
	    case _kinds.INPUT_OBJECT_TYPE_DEFINITION:
	      return _directives.DirectiveLocation.INPUT_OBJECT;
	    case _kinds.INPUT_VALUE_DEFINITION:
	      var parentNode = ancestors[ancestors.length - 3];
	      return parentNode.kind === _kinds.INPUT_OBJECT_TYPE_DEFINITION ? _directives.DirectiveLocation.INPUT_FIELD_DEFINITION : _directives.DirectiveLocation.ARGUMENT_DEFINITION;
	  }
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/UniqueDirectivesPerLocation.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateDirectiveMessage = duplicateDirectiveMessage;
	exports.UniqueDirectivesPerLocation = UniqueDirectivesPerLocation;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function duplicateDirectiveMessage(directiveName) {
	  return 'The directive "' + directiveName + '" can only be used once at ' + 'this location.';
	}
	
	/**
	 * Unique directive names per location
	 *
	 * A GraphQL document is only valid if all directives at a given location
	 * are uniquely named.
	 */
	function UniqueDirectivesPerLocation(context) {
	  return {
	    // Many different AST nodes may contain directives. Rather than listing
	    // them all, just listen for entering any node, and check to see if it
	    // defines any directives.
	    enter: function enter(node) {
	      if (node.directives) {
	        (function () {
	          var knownDirectives = Object.create(null);
	          node.directives.forEach(function (directive) {
	            var directiveName = directive.name.value;
	            if (knownDirectives[directiveName]) {
	              context.reportError(new _error.GraphQLError(duplicateDirectiveMessage(directiveName), [knownDirectives[directiveName], directive]));
	            } else {
	              knownDirectives[directiveName] = directive;
	            }
	          });
	        })();
	      }
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/KnownArgumentNames.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unknownArgMessage = unknownArgMessage;
	exports.unknownDirectiveArgMessage = unknownDirectiveArgMessage;
	exports.KnownArgumentNames = KnownArgumentNames;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _find = __webpack_require__("./node_modules/graphql/jsutils/find.js");
	
	var _find2 = _interopRequireDefault(_find);
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _suggestionList = __webpack_require__("./node_modules/graphql/jsutils/suggestionList.js");
	
	var _suggestionList2 = _interopRequireDefault(_suggestionList);
	
	var _quotedOrList = __webpack_require__("./node_modules/graphql/jsutils/quotedOrList.js");
	
	var _quotedOrList2 = _interopRequireDefault(_quotedOrList);
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unknownArgMessage(argName, fieldName, type, suggestedArgs) {
	  var message = 'Unknown argument "' + argName + '" on field "' + fieldName + '" of ' + ('type "' + String(type) + '".');
	  if (suggestedArgs.length) {
	    message += ' Did you mean ' + (0, _quotedOrList2.default)(suggestedArgs) + '?';
	  }
	  return message;
	}
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function unknownDirectiveArgMessage(argName, directiveName, suggestedArgs) {
	  var message = 'Unknown argument "' + argName + '" on directive "@' + directiveName + '".';
	  if (suggestedArgs.length) {
	    message += ' Did you mean ' + (0, _quotedOrList2.default)(suggestedArgs) + '?';
	  }
	  return message;
	}
	
	/**
	 * Known argument names
	 *
	 * A GraphQL field is only valid if all supplied arguments are defined by
	 * that field.
	 */
	function KnownArgumentNames(context) {
	  return {
	    Argument: function Argument(node, key, parent, path, ancestors) {
	      var argumentOf = ancestors[ancestors.length - 1];
	      if (argumentOf.kind === _kinds.FIELD) {
	        var fieldDef = context.getFieldDef();
	        if (fieldDef) {
	          var fieldArgDef = (0, _find2.default)(fieldDef.args, function (arg) {
	            return arg.name === node.name.value;
	          });
	          if (!fieldArgDef) {
	            var parentType = context.getParentType();
	            (0, _invariant2.default)(parentType);
	            context.reportError(new _error.GraphQLError(unknownArgMessage(node.name.value, fieldDef.name, parentType.name, (0, _suggestionList2.default)(node.name.value, fieldDef.args.map(function (arg) {
	              return arg.name;
	            }))), [node]));
	          }
	        }
	      } else if (argumentOf.kind === _kinds.DIRECTIVE) {
	        var directive = context.getDirective();
	        if (directive) {
	          var directiveArgDef = (0, _find2.default)(directive.args, function (arg) {
	            return arg.name === node.name.value;
	          });
	          if (!directiveArgDef) {
	            context.reportError(new _error.GraphQLError(unknownDirectiveArgMessage(node.name.value, directive.name, (0, _suggestionList2.default)(node.name.value, directive.args.map(function (arg) {
	              return arg.name;
	            }))), [node]));
	          }
	        }
	      }
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/UniqueArgumentNames.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateArgMessage = duplicateArgMessage;
	exports.UniqueArgumentNames = UniqueArgumentNames;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function duplicateArgMessage(argName) {
	  return 'There can be only one argument named "' + argName + '".';
	}
	
	/**
	 * Unique argument names
	 *
	 * A GraphQL field or directive is only valid if all supplied arguments are
	 * uniquely named.
	 */
	function UniqueArgumentNames(context) {
	  var knownArgNames = Object.create(null);
	  return {
	    Field: function Field() {
	      knownArgNames = Object.create(null);
	    },
	    Directive: function Directive() {
	      knownArgNames = Object.create(null);
	    },
	    Argument: function Argument(node) {
	      var argName = node.name.value;
	      if (knownArgNames[argName]) {
	        context.reportError(new _error.GraphQLError(duplicateArgMessage(argName), [knownArgNames[argName], node.name]));
	      } else {
	        knownArgNames[argName] = node.name;
	      }
	      return false;
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/ArgumentsOfCorrectType.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.badValueMessage = badValueMessage;
	exports.ArgumentsOfCorrectType = ArgumentsOfCorrectType;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _printer = __webpack_require__("./node_modules/graphql/language/printer.js");
	
	var _isValidLiteralValue = __webpack_require__("./node_modules/graphql/utilities/isValidLiteralValue.js");
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function badValueMessage(argName, type, value, verboseErrors) {
	  var message = verboseErrors ? '\n' + verboseErrors.join('\n') : '';
	  return 'Argument "' + argName + '" has invalid value ' + value + '.' + message;
	}
	
	/**
	 * Argument values of correct type
	 *
	 * A GraphQL document is only valid if all field argument literal values are
	 * of the type expected by their position.
	 */
	function ArgumentsOfCorrectType(context) {
	  return {
	    Argument: function Argument(node) {
	      var argDef = context.getArgument();
	      if (argDef) {
	        var errors = (0, _isValidLiteralValue.isValidLiteralValue)(argDef.type, node.value);
	        if (errors && errors.length > 0) {
	          context.reportError(new _error.GraphQLError(badValueMessage(node.name.value, argDef.type, (0, _printer.print)(node.value), errors), [node.value]));
	        }
	      }
	      return false;
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/utilities/isValidLiteralValue.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isValidLiteralValue = isValidLiteralValue;
	
	var _printer = __webpack_require__("./node_modules/graphql/language/printer.js");
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _keyMap = __webpack_require__("./node_modules/graphql/jsutils/keyMap.js");
	
	var _keyMap2 = _interopRequireDefault(_keyMap);
	
	var _isNullish = __webpack_require__("./node_modules/graphql/jsutils/isNullish.js");
	
	var _isNullish2 = _interopRequireDefault(_isNullish);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Utility for validators which determines if a value literal node is valid
	 * given an input type.
	 *
	 * Note that this only validates literal values, variables are assumed to
	 * provide values of the correct type.
	 */
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function isValidLiteralValue(type, valueNode) {
	  // A value must be provided if the type is non-null.
	  if (type instanceof _definition.GraphQLNonNull) {
	    if (!valueNode || valueNode.kind === _kinds.NULL) {
	      return ['Expected "' + String(type) + '", found null.'];
	    }
	    return isValidLiteralValue(type.ofType, valueNode);
	  }
	
	  if (!valueNode || valueNode.kind === _kinds.NULL) {
	    return [];
	  }
	
	  // This function only tests literals, and assumes variables will provide
	  // values of the correct type.
	  if (valueNode.kind === _kinds.VARIABLE) {
	    return [];
	  }
	
	  // Lists accept a non-list value as a list of one.
	  if (type instanceof _definition.GraphQLList) {
	    var _ret = function () {
	      var itemType = type.ofType;
	      if (valueNode.kind === _kinds.LIST) {
	        return {
	          v: valueNode.values.reduce(function (acc, item, index) {
	            var errors = isValidLiteralValue(itemType, item);
	            return acc.concat(errors.map(function (error) {
	              return 'In element #' + index + ': ' + error;
	            }));
	          }, [])
	        };
	      }
	      return {
	        v: isValidLiteralValue(itemType, valueNode)
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	
	  // Input objects check each defined field and look for undefined fields.
	  if (type instanceof _definition.GraphQLInputObjectType) {
	    var _ret2 = function () {
	      if (valueNode.kind !== _kinds.OBJECT) {
	        return {
	          v: ['Expected "' + type.name + '", found not an object.']
	        };
	      }
	      var fields = type.getFields();
	
	      var errors = [];
	
	      // Ensure every provided field is defined.
	      var fieldNodes = valueNode.fields;
	      fieldNodes.forEach(function (providedFieldNode) {
	        if (!fields[providedFieldNode.name.value]) {
	          errors.push('In field "' + providedFieldNode.name.value + '": Unknown field.');
	        }
	      });
	
	      // Ensure every defined field is valid.
	      var fieldNodeMap = (0, _keyMap2.default)(fieldNodes, function (fieldNode) {
	        return fieldNode.name.value;
	      });
	      Object.keys(fields).forEach(function (fieldName) {
	        var result = isValidLiteralValue(fields[fieldName].type, fieldNodeMap[fieldName] && fieldNodeMap[fieldName].value);
	        errors.push.apply(errors, result.map(function (error) {
	          return 'In field "' + fieldName + '": ' + error;
	        }));
	      });
	
	      return {
	        v: errors
	      };
	    }();
	
	    if (typeof _ret2 === "object") return _ret2.v;
	  }
	
	  (0, _invariant2.default)(type instanceof _definition.GraphQLScalarType || type instanceof _definition.GraphQLEnumType, 'Must be input type');
	
	  // Scalar/Enum input checks to ensure the type can parse the value to
	  // a non-null value.
	  var parseResult = type.parseLiteral(valueNode);
	  if ((0, _isNullish2.default)(parseResult)) {
	    return ['Expected type "' + type.name + '", found ' + (0, _printer.print)(valueNode) + '.'];
	  }
	
	  return [];
	}

/***/ },

/***/ "./node_modules/graphql/jsutils/keyMap.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = keyMap;
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	/**
	 * Creates a keyed JS object from an array, given a function to produce the keys
	 * for each value in the array.
	 *
	 * This provides a convenient lookup for the array items if the key function
	 * produces unique results.
	 *
	 *     const phoneBook = [
	 *       { name: 'Jon', num: '555-1234' },
	 *       { name: 'Jenny', num: '867-5309' }
	 *     ]
	 *
	 *     // { Jon: { name: 'Jon', num: '555-1234' },
	 *     //   Jenny: { name: 'Jenny', num: '867-5309' } }
	 *     const entriesByName = keyMap(
	 *       phoneBook,
	 *       entry => entry.name
	 *     )
	 *
	 *     // { name: 'Jenny', num: '857-6309' }
	 *     const jennyEntry = entriesByName['Jenny']
	 *
	 */
	function keyMap(list, keyFn) {
	  return list.reduce(function (map, item) {
	    return map[keyFn(item)] = item, map;
	  }, {});
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/ProvidedNonNullArguments.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.missingFieldArgMessage = missingFieldArgMessage;
	exports.missingDirectiveArgMessage = missingDirectiveArgMessage;
	exports.ProvidedNonNullArguments = ProvidedNonNullArguments;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _keyMap = __webpack_require__("./node_modules/graphql/jsutils/keyMap.js");
	
	var _keyMap2 = _interopRequireDefault(_keyMap);
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function missingFieldArgMessage(fieldName, argName, type) {
	  return 'Field "' + fieldName + '" argument "' + argName + '" of type ' + ('"' + String(type) + '" is required but not provided.');
	}
	
	function missingDirectiveArgMessage(directiveName, argName, type) {
	  return 'Directive "@' + directiveName + '" argument "' + argName + '" of type ' + ('"' + String(type) + '" is required but not provided.');
	}
	
	/**
	 * Provided required arguments
	 *
	 * A field or directive is only valid if all required (non-null) field arguments
	 * have been provided.
	 */
	function ProvidedNonNullArguments(context) {
	  return {
	    Field: {
	      // Validate on leave to allow for deeper errors to appear first.
	      leave: function leave(node) {
	        var fieldDef = context.getFieldDef();
	        if (!fieldDef) {
	          return false;
	        }
	        var argNodes = node.arguments || [];
	
	        var argNodeMap = (0, _keyMap2.default)(argNodes, function (arg) {
	          return arg.name.value;
	        });
	        fieldDef.args.forEach(function (argDef) {
	          var argNode = argNodeMap[argDef.name];
	          if (!argNode && argDef.type instanceof _definition.GraphQLNonNull) {
	            context.reportError(new _error.GraphQLError(missingFieldArgMessage(node.name.value, argDef.name, argDef.type), [node]));
	          }
	        });
	      }
	    },
	
	    Directive: {
	      // Validate on leave to allow for deeper errors to appear first.
	      leave: function leave(node) {
	        var directiveDef = context.getDirective();
	        if (!directiveDef) {
	          return false;
	        }
	        var argNodes = node.arguments || [];
	
	        var argNodeMap = (0, _keyMap2.default)(argNodes, function (arg) {
	          return arg.name.value;
	        });
	        directiveDef.args.forEach(function (argDef) {
	          var argNode = argNodeMap[argDef.name];
	          if (!argNode && argDef.type instanceof _definition.GraphQLNonNull) {
	            context.reportError(new _error.GraphQLError(missingDirectiveArgMessage(node.name.value, argDef.name, argDef.type), [node]));
	          }
	        });
	      }
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/DefaultValuesOfCorrectType.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultForNonNullArgMessage = defaultForNonNullArgMessage;
	exports.badValueForDefaultArgMessage = badValueForDefaultArgMessage;
	exports.DefaultValuesOfCorrectType = DefaultValuesOfCorrectType;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _printer = __webpack_require__("./node_modules/graphql/language/printer.js");
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	var _isValidLiteralValue = __webpack_require__("./node_modules/graphql/utilities/isValidLiteralValue.js");
	
	function defaultForNonNullArgMessage(varName, type, guessType) {
	  return 'Variable "$' + varName + '" of type "' + String(type) + '" is required and ' + 'will not use the default value. ' + ('Perhaps you meant to use type "' + String(guessType) + '".');
	}
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function badValueForDefaultArgMessage(varName, type, value, verboseErrors) {
	  var message = verboseErrors ? '\n' + verboseErrors.join('\n') : '';
	  return 'Variable "$' + varName + '" of type "' + String(type) + '" has invalid ' + ('default value ' + value + '.' + message);
	}
	
	/**
	 * Variable default values of correct type
	 *
	 * A GraphQL document is only valid if all variable default values are of the
	 * type expected by their definition.
	 */
	function DefaultValuesOfCorrectType(context) {
	  return {
	    VariableDefinition: function VariableDefinition(node) {
	      var name = node.variable.name.value;
	      var defaultValue = node.defaultValue;
	      var type = context.getInputType();
	      if (type instanceof _definition.GraphQLNonNull && defaultValue) {
	        context.reportError(new _error.GraphQLError(defaultForNonNullArgMessage(name, type, type.ofType), [defaultValue]));
	      }
	      if (type && defaultValue) {
	        var errors = (0, _isValidLiteralValue.isValidLiteralValue)(type, defaultValue);
	        if (errors && errors.length > 0) {
	          context.reportError(new _error.GraphQLError(badValueForDefaultArgMessage(name, type, (0, _printer.print)(defaultValue), errors), [defaultValue]));
	        }
	      }
	      return false;
	    },
	
	    SelectionSet: function SelectionSet() {
	      return false;
	    },
	    FragmentDefinition: function FragmentDefinition() {
	      return false;
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/VariablesInAllowedPosition.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.badVarPosMessage = badVarPosMessage;
	exports.VariablesInAllowedPosition = VariablesInAllowedPosition;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	var _typeComparators = __webpack_require__("./node_modules/graphql/utilities/typeComparators.js");
	
	var _typeFromAST = __webpack_require__("./node_modules/graphql/utilities/typeFromAST.js");
	
	function badVarPosMessage(varName, varType, expectedType) {
	  return 'Variable "$' + varName + '" of type "' + String(varType) + '" used in ' + ('position expecting type "' + String(expectedType) + '".');
	}
	
	/**
	 * Variables passed to field arguments conform to type
	 */
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function VariablesInAllowedPosition(context) {
	  var varDefMap = Object.create(null);
	
	  return {
	    OperationDefinition: {
	      enter: function enter() {
	        varDefMap = Object.create(null);
	      },
	      leave: function leave(operation) {
	        var usages = context.getRecursiveVariableUsages(operation);
	
	        usages.forEach(function (_ref) {
	          var node = _ref.node,
	              type = _ref.type;
	
	          var varName = node.name.value;
	          var varDef = varDefMap[varName];
	          if (varDef && type) {
	            // A var type is allowed if it is the same or more strict (e.g. is
	            // a subtype of) than the expected type. It can be more strict if
	            // the variable type is non-null when the expected type is nullable.
	            // If both are list types, the variable item type can be more strict
	            // than the expected item type (contravariant).
	            var schema = context.getSchema();
	            var varType = (0, _typeFromAST.typeFromAST)(schema, varDef.type);
	            if (varType && !(0, _typeComparators.isTypeSubTypeOf)(schema, effectiveType(varType, varDef), type)) {
	              context.reportError(new _error.GraphQLError(badVarPosMessage(varName, varType, type), [varDef, node]));
	            }
	          }
	        });
	      }
	    },
	    VariableDefinition: function VariableDefinition(node) {
	      varDefMap[node.variable.name.value] = node;
	    }
	  };
	}
	
	// If a variable definition has a default value, it's effectively non-null.
	function effectiveType(varType, varDef) {
	  return !varDef.defaultValue || varType instanceof _definition.GraphQLNonNull ? varType : new _definition.GraphQLNonNull(varType);
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/OverlappingFieldsCanBeMerged.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fieldsConflictMessage = fieldsConflictMessage;
	exports.OverlappingFieldsCanBeMerged = OverlappingFieldsCanBeMerged;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _find = __webpack_require__("./node_modules/graphql/jsutils/find.js");
	
	var _find2 = _interopRequireDefault(_find);
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	var _printer = __webpack_require__("./node_modules/graphql/language/printer.js");
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	var _typeFromAST = __webpack_require__("./node_modules/graphql/utilities/typeFromAST.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function fieldsConflictMessage(responseName, reason) {
	  return 'Fields "' + responseName + '" conflict because ' + reasonMessage(reason) + '. Use different aliases on the fields to fetch both if this was ' + 'intentional.';
	}
	
	function reasonMessage(reason) {
	  if (Array.isArray(reason)) {
	    return reason.map(function (_ref) {
	      var responseName = _ref[0],
	          subreason = _ref[1];
	      return 'subfields "' + responseName + '" conflict because ' + reasonMessage(subreason);
	    }).join(' and ');
	  }
	  return reason;
	}
	
	/**
	 * Overlapping fields can be merged
	 *
	 * A selection set is only valid if all fields (including spreading any
	 * fragments) either correspond to distinct response names or can be merged
	 * without ambiguity.
	 */
	function OverlappingFieldsCanBeMerged(context) {
	  // A memoization for when two fragments are compared "between" each other for
	  // conflicts. Two fragments may be compared many times, so memoizing this can
	  // dramatically improve the performance of this validator.
	  var comparedFragments = new PairSet();
	
	  // A cache for the "field map" and list of fragment names found in any given
	  // selection set. Selection sets may be asked for this information multiple
	  // times, so this improves the performance of this validator.
	  var cachedFieldsAndFragmentNames = new Map();
	
	  return {
	    SelectionSet: function SelectionSet(selectionSet) {
	      var conflicts = findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragments, context.getParentType(), selectionSet);
	      conflicts.forEach(function (_ref2) {
	        var _ref2$ = _ref2[0],
	            responseName = _ref2$[0],
	            reason = _ref2$[1],
	            fields1 = _ref2[1],
	            fields2 = _ref2[2];
	        return context.reportError(new _error.GraphQLError(fieldsConflictMessage(responseName, reason), fields1.concat(fields2)));
	      });
	    }
	  };
	}
	// Field name and reason.
	
	// Reason is a string, or a nested list of conflicts.
	
	// Tuple defining a field node in a context.
	
	// Map of array of those.
	
	
	/**
	 * Algorithm:
	 *
	 * Conflicts occur when two fields exist in a query which will produce the same
	 * response name, but represent differing values, thus creating a conflict.
	 * The algorithm below finds all conflicts via making a series of comparisons
	 * between fields. In order to compare as few fields as possible, this makes
	 * a series of comparisons "within" sets of fields and "between" sets of fields.
	 *
	 * Given any selection set, a collection produces both a set of fields by
	 * also including all inline fragments, as well as a list of fragments
	 * referenced by fragment spreads.
	 *
	 * A) Each selection set represented in the document first compares "within" its
	 * collected set of fields, finding any conflicts between every pair of
	 * overlapping fields.
	 * Note: This is the *only time* that a the fields "within" a set are compared
	 * to each other. After this only fields "between" sets are compared.
	 *
	 * B) Also, if any fragment is referenced in a selection set, then a
	 * comparison is made "between" the original set of fields and the
	 * referenced fragment.
	 *
	 * C) Also, if multiple fragments are referenced, then comparisons
	 * are made "between" each referenced fragment.
	 *
	 * D) When comparing "between" a set of fields and a referenced fragment, first
	 * a comparison is made between each field in the original set of fields and
	 * each field in the the referenced set of fields.
	 *
	 * E) Also, if any fragment is referenced in the referenced selection set,
	 * then a comparison is made "between" the original set of fields and the
	 * referenced fragment (recursively referring to step D).
	 *
	 * F) When comparing "between" two fragments, first a comparison is made between
	 * each field in the first referenced set of fields and each field in the the
	 * second referenced set of fields.
	 *
	 * G) Also, any fragments referenced by the first must be compared to the
	 * second, and any fragments referenced by the second must be compared to the
	 * first (recursively referring to step F).
	 *
	 * H) When comparing two fields, if both have selection sets, then a comparison
	 * is made "between" both selection sets, first comparing the set of fields in
	 * the first selection set with the set of fields in the second.
	 *
	 * I) Also, if any fragment is referenced in either selection set, then a
	 * comparison is made "between" the other set of fields and the
	 * referenced fragment.
	 *
	 * J) Also, if two fragments are referenced in both selection sets, then a
	 * comparison is made "between" the two fragments.
	 *
	 */
	
	// Find all conflicts found "within" a selection set, including those found
	// via spreading in fragments. Called when visiting each SelectionSet in the
	// GraphQL Document.
	function findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragments, parentType, selectionSet) {
	  var conflicts = [];
	
	  var _getFieldsAndFragment = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet),
	      fieldMap = _getFieldsAndFragment[0],
	      fragmentNames = _getFieldsAndFragment[1];
	
	  // (A) Find find all conflicts "within" the fields of this selection set.
	  // Note: this is the *only place* `collectConflictsWithin` is called.
	
	
	  collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, fieldMap);
	
	  // (B) Then collect conflicts between these fields and those represented by
	  // each spread fragment name found.
	  for (var i = 0; i < fragmentNames.length; i++) {
	    collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, false, fieldMap, fragmentNames[i]);
	    // (C) Then compare this fragment with all other fragments found in this
	    // selection set to collect conflicts between fragments spread together.
	    // This compares each item in the list of fragment names to every other item
	    // in that same list (except for itself).
	    for (var j = i + 1; j < fragmentNames.length; j++) {
	      collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, false, fragmentNames[i], fragmentNames[j]);
	    }
	  }
	  return conflicts;
	}
	
	// Collect all conflicts found between a set of fields and a fragment reference
	// including via spreading in any nested fragments.
	function collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fieldMap, fragmentName) {
	  var fragment = context.getFragment(fragmentName);
	  if (!fragment) {
	    return;
	  }
	
	  var _getReferencedFieldsA = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment),
	      fieldMap2 = _getReferencedFieldsA[0],
	      fragmentNames2 = _getReferencedFieldsA[1];
	
	  // (D) First collect any conflicts between the provided collection of fields
	  // and the collection of fields represented by the given fragment.
	
	
	  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fieldMap, fieldMap2);
	
	  // (E) Then collect any conflicts between the provided collection of fields
	  // and any fragment names found in the given fragment.
	  for (var i = 0; i < fragmentNames2.length; i++) {
	    collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fieldMap, fragmentNames2[i]);
	  }
	}
	
	// Collect all conflicts found between two fragments, including via spreading in
	// any nested fragments.
	function collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fragmentName1, fragmentName2) {
	  var fragment1 = context.getFragment(fragmentName1);
	  var fragment2 = context.getFragment(fragmentName2);
	  if (!fragment1 || !fragment2) {
	    return;
	  }
	
	  // No need to compare a fragment to itself.
	  if (fragment1 === fragment2) {
	    return;
	  }
	
	  // Memoize so two fragments are not compared for conflicts more than once.
	  if (comparedFragments.has(fragmentName1, fragmentName2, areMutuallyExclusive)) {
	    return;
	  }
	  comparedFragments.add(fragmentName1, fragmentName2, areMutuallyExclusive);
	
	  var _getReferencedFieldsA2 = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment1),
	      fieldMap1 = _getReferencedFieldsA2[0],
	      fragmentNames1 = _getReferencedFieldsA2[1];
	
	  var _getReferencedFieldsA3 = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment2),
	      fieldMap2 = _getReferencedFieldsA3[0],
	      fragmentNames2 = _getReferencedFieldsA3[1];
	
	  // (F) First, collect all conflicts between these two collections of fields
	  // (not including any nested fragments).
	
	
	  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fieldMap1, fieldMap2);
	
	  // (G) Then collect conflicts between the first fragment and any nested
	  // fragments spread in the second fragment.
	  for (var j = 0; j < fragmentNames2.length; j++) {
	    collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fragmentName1, fragmentNames2[j]);
	  }
	
	  // (G) Then collect conflicts between the second fragment and any nested
	  // fragments spread in the first fragment.
	  for (var i = 0; i < fragmentNames1.length; i++) {
	    collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fragmentNames1[i], fragmentName2);
	  }
	}
	
	// Find all conflicts found between two selection sets, including those found
	// via spreading in fragments. Called when determining if conflicts exist
	// between the sub-fields of two overlapping fields.
	function findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, parentType1, selectionSet1, parentType2, selectionSet2) {
	  var conflicts = [];
	
	  var _getFieldsAndFragment2 = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType1, selectionSet1),
	      fieldMap1 = _getFieldsAndFragment2[0],
	      fragmentNames1 = _getFieldsAndFragment2[1];
	
	  var _getFieldsAndFragment3 = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType2, selectionSet2),
	      fieldMap2 = _getFieldsAndFragment3[0],
	      fragmentNames2 = _getFieldsAndFragment3[1];
	
	  // (H) First, collect all conflicts between these two collections of field.
	
	
	  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fieldMap1, fieldMap2);
	
	  // (I) Then collect conflicts between the first collection of fields and
	  // those referenced by each fragment name associated with the second.
	  for (var j = 0; j < fragmentNames2.length; j++) {
	    collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fieldMap1, fragmentNames2[j]);
	  }
	
	  // (I) Then collect conflicts between the second collection of fields and
	  // those referenced by each fragment name associated with the first.
	  for (var i = 0; i < fragmentNames1.length; i++) {
	    collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fieldMap2, fragmentNames1[i]);
	  }
	
	  // (J) Also collect conflicts between any fragment names by the first and
	  // fragment names by the second. This compares each item in the first set of
	  // names to each item in the second set of names.
	  for (var _i = 0; _i < fragmentNames1.length; _i++) {
	    for (var _j = 0; _j < fragmentNames2.length; _j++) {
	      collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fragmentNames1[_i], fragmentNames2[_j]);
	    }
	  }
	  return conflicts;
	}
	
	// Collect all Conflicts "within" one collection of fields.
	function collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, fieldMap) {
	  // A field map is a keyed collection, where each key represents a response
	  // name and the value at that key is a list of all fields which provide that
	  // response name. For every response name, if there are multiple fields, they
	  // must be compared to find a potential conflict.
	  Object.keys(fieldMap).forEach(function (responseName) {
	    var fields = fieldMap[responseName];
	    // This compares every field in the list to every other field in this list
	    // (except to itself). If the list only has one item, nothing needs to
	    // be compared.
	    if (fields.length > 1) {
	      for (var i = 0; i < fields.length; i++) {
	        for (var j = i + 1; j < fields.length; j++) {
	          var conflict = findConflict(context, cachedFieldsAndFragmentNames, comparedFragments, false, // within one collection is never mutually exclusive
	          responseName, fields[i], fields[j]);
	          if (conflict) {
	            conflicts.push(conflict);
	          }
	        }
	      }
	    }
	  });
	}
	
	// Collect all Conflicts between two collections of fields. This is similar to,
	// but different from the `collectConflictsWithin` function above. This check
	// assumes that `collectConflictsWithin` has already been called on each
	// provided collection of fields. This is true because this validator traverses
	// each individual selection set.
	function collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, parentFieldsAreMutuallyExclusive, fieldMap1, fieldMap2) {
	  // A field map is a keyed collection, where each key represents a response
	  // name and the value at that key is a list of all fields which provide that
	  // response name. For any response name which appears in both provided field
	  // maps, each field from the first field map must be compared to every field
	  // in the second field map to find potential conflicts.
	  Object.keys(fieldMap1).forEach(function (responseName) {
	    var fields2 = fieldMap2[responseName];
	    if (fields2) {
	      var fields1 = fieldMap1[responseName];
	      for (var i = 0; i < fields1.length; i++) {
	        for (var j = 0; j < fields2.length; j++) {
	          var conflict = findConflict(context, cachedFieldsAndFragmentNames, comparedFragments, parentFieldsAreMutuallyExclusive, responseName, fields1[i], fields2[j]);
	          if (conflict) {
	            conflicts.push(conflict);
	          }
	        }
	      }
	    }
	  });
	}
	
	// Determines if there is a conflict between two particular fields, including
	// comparing their sub-fields.
	function findConflict(context, cachedFieldsAndFragmentNames, comparedFragments, parentFieldsAreMutuallyExclusive, responseName, field1, field2) {
	  var parentType1 = field1[0],
	      node1 = field1[1],
	      def1 = field1[2];
	  var parentType2 = field2[0],
	      node2 = field2[1],
	      def2 = field2[2];
	
	  // If it is known that two fields could not possibly apply at the same
	  // time, due to the parent types, then it is safe to permit them to diverge
	  // in aliased field or arguments used as they will not present any ambiguity
	  // by differing.
	  // It is known that two parent types could never overlap if they are
	  // different Object types. Interface or Union types might overlap - if not
	  // in the current state of the schema, then perhaps in some future version,
	  // thus may not safely diverge.
	
	  var areMutuallyExclusive = parentFieldsAreMutuallyExclusive || parentType1 !== parentType2 && parentType1 instanceof _definition.GraphQLObjectType && parentType2 instanceof _definition.GraphQLObjectType;
	
	  // The return type for each field.
	  var type1 = def1 && def1.type;
	  var type2 = def2 && def2.type;
	
	  if (!areMutuallyExclusive) {
	    // Two aliases must refer to the same field.
	    var name1 = node1.name.value;
	    var name2 = node2.name.value;
	    if (name1 !== name2) {
	      return [[responseName, name1 + ' and ' + name2 + ' are different fields'], [node1], [node2]];
	    }
	
	    // Two field calls must have the same arguments.
	    if (!sameArguments(node1.arguments || [], node2.arguments || [])) {
	      return [[responseName, 'they have differing arguments'], [node1], [node2]];
	    }
	  }
	
	  if (type1 && type2 && doTypesConflict(type1, type2)) {
	    return [[responseName, 'they return conflicting types ' + String(type1) + ' and ' + String(type2)], [node1], [node2]];
	  }
	
	  // Collect and compare sub-fields. Use the same "visited fragment names" list
	  // for both collections so fields in a fragment reference are never
	  // compared to themselves.
	  var selectionSet1 = node1.selectionSet;
	  var selectionSet2 = node2.selectionSet;
	  if (selectionSet1 && selectionSet2) {
	    var conflicts = findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, (0, _definition.getNamedType)(type1), selectionSet1, (0, _definition.getNamedType)(type2), selectionSet2);
	    return subfieldConflicts(conflicts, responseName, node1, node2);
	  }
	}
	
	function sameArguments(arguments1, arguments2) {
	  if (arguments1.length !== arguments2.length) {
	    return false;
	  }
	  return arguments1.every(function (argument1) {
	    var argument2 = (0, _find2.default)(arguments2, function (argument) {
	      return argument.name.value === argument1.name.value;
	    });
	    if (!argument2) {
	      return false;
	    }
	    return sameValue(argument1.value, argument2.value);
	  });
	}
	
	function sameValue(value1, value2) {
	  return !value1 && !value2 || (0, _printer.print)(value1) === (0, _printer.print)(value2);
	}
	
	// Two types conflict if both types could not apply to a value simultaneously.
	// Composite types are ignored as their individual field types will be compared
	// later recursively. However List and Non-Null types must match.
	function doTypesConflict(type1, type2) {
	  if (type1 instanceof _definition.GraphQLList) {
	    return type2 instanceof _definition.GraphQLList ? doTypesConflict(type1.ofType, type2.ofType) : true;
	  }
	  if (type2 instanceof _definition.GraphQLList) {
	    return type1 instanceof _definition.GraphQLList ? doTypesConflict(type1.ofType, type2.ofType) : true;
	  }
	  if (type1 instanceof _definition.GraphQLNonNull) {
	    return type2 instanceof _definition.GraphQLNonNull ? doTypesConflict(type1.ofType, type2.ofType) : true;
	  }
	  if (type2 instanceof _definition.GraphQLNonNull) {
	    return type1 instanceof _definition.GraphQLNonNull ? doTypesConflict(type1.ofType, type2.ofType) : true;
	  }
	  if ((0, _definition.isLeafType)(type1) || (0, _definition.isLeafType)(type2)) {
	    return type1 !== type2;
	  }
	  return false;
	}
	
	// Given a selection set, return the collection of fields (a mapping of response
	// name to field nodes and definitions) as well as a list of fragment names
	// referenced via fragment spreads.
	function getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet) {
	  var cached = cachedFieldsAndFragmentNames.get(selectionSet);
	  if (!cached) {
	    var nodeAndDefs = {};
	    var fragmentNames = {};
	    _collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames);
	    cached = [nodeAndDefs, Object.keys(fragmentNames)];
	    cachedFieldsAndFragmentNames.set(selectionSet, cached);
	  }
	  return cached;
	}
	
	// Given a reference to a fragment, return the represented collection of fields
	// as well as a list of nested fragment names referenced via fragment spreads.
	function getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment) {
	  // Short-circuit building a type from the node if possible.
	  var cached = cachedFieldsAndFragmentNames.get(fragment.selectionSet);
	  if (cached) {
	    return cached;
	  }
	
	  var fragmentType = (0, _typeFromAST.typeFromAST)(context.getSchema(), fragment.typeCondition);
	  return getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragmentType, fragment.selectionSet);
	}
	
	function _collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames) {
	  for (var i = 0; i < selectionSet.selections.length; i++) {
	    var selection = selectionSet.selections[i];
	    switch (selection.kind) {
	      case _kinds.FIELD:
	        var fieldName = selection.name.value;
	        var fieldDef = void 0;
	        if (parentType instanceof _definition.GraphQLObjectType || parentType instanceof _definition.GraphQLInterfaceType) {
	          fieldDef = parentType.getFields()[fieldName];
	        }
	        var responseName = selection.alias ? selection.alias.value : fieldName;
	        if (!nodeAndDefs[responseName]) {
	          nodeAndDefs[responseName] = [];
	        }
	        nodeAndDefs[responseName].push([parentType, selection, fieldDef]);
	        break;
	      case _kinds.FRAGMENT_SPREAD:
	        fragmentNames[selection.name.value] = true;
	        break;
	      case _kinds.INLINE_FRAGMENT:
	        var typeCondition = selection.typeCondition;
	        var inlineFragmentType = typeCondition ? (0, _typeFromAST.typeFromAST)(context.getSchema(), typeCondition) : parentType;
	        _collectFieldsAndFragmentNames(context, inlineFragmentType, selection.selectionSet, nodeAndDefs, fragmentNames);
	        break;
	    }
	  }
	}
	
	// Given a series of Conflicts which occurred between two sub-fields, generate
	// a single Conflict.
	function subfieldConflicts(conflicts, responseName, node1, node2) {
	  if (conflicts.length > 0) {
	    return [[responseName, conflicts.map(function (_ref3) {
	      var reason = _ref3[0];
	      return reason;
	    })], conflicts.reduce(function (allFields, _ref4) {
	      var fields1 = _ref4[1];
	      return allFields.concat(fields1);
	    }, [node1]), conflicts.reduce(function (allFields, _ref5) {
	      var fields2 = _ref5[2];
	      return allFields.concat(fields2);
	    }, [node2])];
	  }
	}
	
	/**
	 * A way to keep track of pairs of things when the ordering of the pair does
	 * not matter. We do this by maintaining a sort of double adjacency sets.
	 */
	
	var PairSet = function () {
	  function PairSet() {
	    _classCallCheck(this, PairSet);
	
	    this._data = Object.create(null);
	  }
	
	  PairSet.prototype.has = function has(a, b, areMutuallyExclusive) {
	    var first = this._data[a];
	    var result = first && first[b];
	    if (result === undefined) {
	      return false;
	    }
	    // areMutuallyExclusive being false is a superset of being true,
	    // hence if we want to know if this PairSet "has" these two with no
	    // exclusivity, we have to ensure it was added as such.
	    if (areMutuallyExclusive === false) {
	      return result === false;
	    }
	    return true;
	  };
	
	  PairSet.prototype.add = function add(a, b, areMutuallyExclusive) {
	    _pairSetAdd(this._data, a, b, areMutuallyExclusive);
	    _pairSetAdd(this._data, b, a, areMutuallyExclusive);
	  };
	
	  return PairSet;
	}();
	
	function _pairSetAdd(data, a, b, areMutuallyExclusive) {
	  var map = data[a];
	  if (!map) {
	    map = Object.create(null);
	    data[a] = map;
	  }
	  map[b] = areMutuallyExclusive;
	}

/***/ },

/***/ "./node_modules/graphql/validation/rules/UniqueInputFieldNames.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateInputFieldMessage = duplicateInputFieldMessage;
	exports.UniqueInputFieldNames = UniqueInputFieldNames;
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function duplicateInputFieldMessage(fieldName) {
	  return 'There can be only one input field named "' + fieldName + '".';
	}
	
	/**
	 * Unique input field names
	 *
	 * A GraphQL input object value is only valid if all supplied fields are
	 * uniquely named.
	 */
	function UniqueInputFieldNames(context) {
	  var knownNameStack = [];
	  var knownNames = Object.create(null);
	
	  return {
	    ObjectValue: {
	      enter: function enter() {
	        knownNameStack.push(knownNames);
	        knownNames = Object.create(null);
	      },
	      leave: function leave() {
	        knownNames = knownNameStack.pop();
	      }
	    },
	    ObjectField: function ObjectField(node) {
	      var fieldName = node.name.value;
	      if (knownNames[fieldName]) {
	        context.reportError(new _error.GraphQLError(duplicateInputFieldMessage(fieldName), [knownNames[fieldName], node.name]));
	      } else {
	        knownNames[fieldName] = node.name;
	      }
	      return false;
	    }
	  };
	}

/***/ },

/***/ "./node_modules/graphql/execution/execute.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultFieldResolver = undefined;
	exports.execute = execute;
	exports.responsePathAsArray = responsePathAsArray;
	
	var _iterall = __webpack_require__("./node_modules/iterall/index.js");
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _find = __webpack_require__("./node_modules/graphql/jsutils/find.js");
	
	var _find2 = _interopRequireDefault(_find);
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isNullish = __webpack_require__("./node_modules/graphql/jsutils/isNullish.js");
	
	var _isNullish2 = _interopRequireDefault(_isNullish);
	
	var _typeFromAST = __webpack_require__("./node_modules/graphql/utilities/typeFromAST.js");
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	var Kind = _interopRequireWildcard(_kinds);
	
	var _values = __webpack_require__("./node_modules/graphql/execution/values.js");
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	var _schema = __webpack_require__("./node_modules/graphql/type/schema.js");
	
	var _introspection = __webpack_require__("./node_modules/graphql/type/introspection.js");
	
	var _directives = __webpack_require__("./node_modules/graphql/type/directives.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Implements the "Evaluating requests" section of the GraphQL specification.
	 *
	 * Returns a Promise that will eventually be resolved and never rejected.
	 *
	 * If the arguments to this function do not result in a legal execution context,
	 * a GraphQLError will be thrown immediately explaining the invalid input.
	 */
	
	
	/**
	 * Terminology
	 *
	 * "Definitions" are the generic name for top-level statements in the document.
	 * Examples of this include:
	 * 1) Operations (such as a query)
	 * 2) Fragments
	 *
	 * "Operations" are a generic name for requests in the document.
	 * Examples of this include:
	 * 1) query,
	 * 2) mutation
	 *
	 * "Selections" are the definitions that can appear legally and at
	 * single level of the query. These include:
	 * 1) field references e.g "a"
	 * 2) fragment "spreads" e.g. "...c"
	 * 3) inline fragment "spreads" e.g. "...on Type { a }"
	 */
	
	/**
	 * Data that must be available at all points during query execution.
	 *
	 * Namely, schema of the type system that is currently executing,
	 * and the fragments defined in the query document
	 */
	
	
	/**
	 * The result of GraphQL execution.
	 *
	 *   - `data` is the result of a successful execution of the query.
	 *   - `errors` is included when any errors occurred as a non-empty array.
	 */
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function execute(schema, document, rootValue, contextValue, variableValues, operationName) {
	  (0, _invariant2.default)(schema, 'Must provide schema');
	  (0, _invariant2.default)(schema instanceof _schema.GraphQLSchema, 'Schema must be an instance of GraphQLSchema. Also ensure that there are ' + 'not multiple versions of GraphQL installed in your node_modules directory.');
	
	  // Variables, if provided, must be an object.
	  (0, _invariant2.default)(!variableValues || typeof variableValues === 'object', 'Variables must be provided as an Object where each property is a ' + 'variable value. Perhaps look to see if an unparsed JSON string ' + 'was provided.');
	
	  // If a valid context cannot be created due to incorrect arguments,
	  // this will throw an error.
	  var context = buildExecutionContext(schema, document, rootValue, contextValue, variableValues, operationName);
	
	  // Return a Promise that will eventually resolve to the data described by
	  // The "Response" section of the GraphQL specification.
	  //
	  // If errors are encountered while executing a GraphQL field, only that
	  // field and its descendants will be omitted, and sibling fields will still
	  // be executed. An execution which encounters errors will still result in a
	  // resolved Promise.
	  return new Promise(function (resolve) {
	    resolve(executeOperation(context, context.operation, rootValue));
	  }).then(undefined, function (error) {
	    // Errors from sub-fields of a NonNull type may propagate to the top level,
	    // at which point we still log the error and null the parent field, which
	    // in this case is the entire response.
	    context.errors.push(error);
	    return null;
	  }).then(function (data) {
	    if (!context.errors.length) {
	      return { data: data };
	    }
	    return { data: data, errors: context.errors };
	  });
	}
	
	/**
	 * Given a ResponsePath (found in the `path` entry in the information provided
	 * as the last argument to a field resolver), return an Array of the path keys.
	 */
	function responsePathAsArray(path) {
	  var flattened = [];
	  var curr = path;
	  while (curr) {
	    flattened.push(curr.key);
	    curr = curr.prev;
	  }
	  return flattened.reverse();
	}
	
	function addPath(prev, key) {
	  return { prev: prev, key: key };
	}
	
	/**
	 * Constructs a ExecutionContext object from the arguments passed to
	 * execute, which we will pass throughout the other execution methods.
	 *
	 * Throws a GraphQLError if a valid execution context cannot be created.
	 */
	function buildExecutionContext(schema, document, rootValue, contextValue, rawVariableValues, operationName) {
	  var errors = [];
	  var operation = void 0;
	  var fragments = Object.create(null);
	  document.definitions.forEach(function (definition) {
	    switch (definition.kind) {
	      case Kind.OPERATION_DEFINITION:
	        if (!operationName && operation) {
	          throw new _error.GraphQLError('Must provide operation name if query contains multiple operations.');
	        }
	        if (!operationName || definition.name && definition.name.value === operationName) {
	          operation = definition;
	        }
	        break;
	      case Kind.FRAGMENT_DEFINITION:
	        fragments[definition.name.value] = definition;
	        break;
	      default:
	        throw new _error.GraphQLError('GraphQL cannot execute a request containing a ' + definition.kind + '.', [definition]);
	    }
	  });
	  if (!operation) {
	    if (operationName) {
	      throw new _error.GraphQLError('Unknown operation named "' + operationName + '".');
	    } else {
	      throw new _error.GraphQLError('Must provide an operation.');
	    }
	  }
	  var variableValues = (0, _values.getVariableValues)(schema, operation.variableDefinitions || [], rawVariableValues || {});
	
	  return {
	    schema: schema,
	    fragments: fragments,
	    rootValue: rootValue,
	    contextValue: contextValue,
	    operation: operation,
	    variableValues: variableValues,
	    errors: errors
	  };
	}
	
	/**
	 * Implements the "Evaluating operations" section of the spec.
	 */
	function executeOperation(exeContext, operation, rootValue) {
	  var type = getOperationRootType(exeContext.schema, operation);
	  var fields = collectFields(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
	
	  var path = undefined;
	
	  if (operation.operation === 'mutation') {
	    return executeFieldsSerially(exeContext, type, rootValue, path, fields);
	  }
	  return executeFields(exeContext, type, rootValue, path, fields);
	}
	
	/**
	 * Extracts the root type of the operation from the schema.
	 */
	function getOperationRootType(schema, operation) {
	  switch (operation.operation) {
	    case 'query':
	      return schema.getQueryType();
	    case 'mutation':
	      var mutationType = schema.getMutationType();
	      if (!mutationType) {
	        throw new _error.GraphQLError('Schema is not configured for mutations', [operation]);
	      }
	      return mutationType;
	    case 'subscription':
	      var subscriptionType = schema.getSubscriptionType();
	      if (!subscriptionType) {
	        throw new _error.GraphQLError('Schema is not configured for subscriptions', [operation]);
	      }
	      return subscriptionType;
	    default:
	      throw new _error.GraphQLError('Can only execute queries, mutations and subscriptions', [operation]);
	  }
	}
	
	/**
	 * Implements the "Evaluating selection sets" section of the spec
	 * for "write" mode.
	 */
	function executeFieldsSerially(exeContext, parentType, sourceValue, path, fields) {
	  return Object.keys(fields).reduce(function (prevPromise, responseName) {
	    return prevPromise.then(function (results) {
	      var fieldNodes = fields[responseName];
	      var fieldPath = addPath(path, responseName);
	      var result = resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
	      if (result === undefined) {
	        return results;
	      }
	      if (isThenable(result)) {
	        return result.then(function (resolvedResult) {
	          results[responseName] = resolvedResult;
	          return results;
	        });
	      }
	      results[responseName] = result;
	      return results;
	    });
	  }, Promise.resolve({}));
	}
	
	/**
	 * Implements the "Evaluating selection sets" section of the spec
	 * for "read" mode.
	 */
	function executeFields(exeContext, parentType, sourceValue, path, fields) {
	  var containsPromise = false;
	
	  var finalResults = Object.keys(fields).reduce(function (results, responseName) {
	    var fieldNodes = fields[responseName];
	    var fieldPath = addPath(path, responseName);
	    var result = resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
	    if (result === undefined) {
	      return results;
	    }
	    results[responseName] = result;
	    if (isThenable(result)) {
	      containsPromise = true;
	    }
	    return results;
	  }, Object.create(null));
	
	  // If there are no promises, we can just return the object
	  if (!containsPromise) {
	    return finalResults;
	  }
	
	  // Otherwise, results is a map from field name to the result
	  // of resolving that field, which is possibly a promise. Return
	  // a promise that will return this same map, but with any
	  // promises replaced with the values they resolved to.
	  return promiseForObject(finalResults);
	}
	
	/**
	 * Given a selectionSet, adds all of the fields in that selection to
	 * the passed in map of fields, and returns it at the end.
	 *
	 * CollectFields requires the "runtime type" of an object. For a field which
	 * returns and Interface or Union type, the "runtime type" will be the actual
	 * Object type returned by that field.
	 */
	function collectFields(exeContext, runtimeType, selectionSet, fields, visitedFragmentNames) {
	  for (var i = 0; i < selectionSet.selections.length; i++) {
	    var selection = selectionSet.selections[i];
	    switch (selection.kind) {
	      case Kind.FIELD:
	        if (!shouldIncludeNode(exeContext, selection.directives)) {
	          continue;
	        }
	        var _name = getFieldEntryKey(selection);
	        if (!fields[_name]) {
	          fields[_name] = [];
	        }
	        fields[_name].push(selection);
	        break;
	      case Kind.INLINE_FRAGMENT:
	        if (!shouldIncludeNode(exeContext, selection.directives) || !doesFragmentConditionMatch(exeContext, selection, runtimeType)) {
	          continue;
	        }
	        collectFields(exeContext, runtimeType, selection.selectionSet, fields, visitedFragmentNames);
	        break;
	      case Kind.FRAGMENT_SPREAD:
	        var fragName = selection.name.value;
	        if (visitedFragmentNames[fragName] || !shouldIncludeNode(exeContext, selection.directives)) {
	          continue;
	        }
	        visitedFragmentNames[fragName] = true;
	        var fragment = exeContext.fragments[fragName];
	        if (!fragment || !doesFragmentConditionMatch(exeContext, fragment, runtimeType)) {
	          continue;
	        }
	        collectFields(exeContext, runtimeType, fragment.selectionSet, fields, visitedFragmentNames);
	        break;
	    }
	  }
	  return fields;
	}
	
	/**
	 * Determines if a field should be included based on the @include and @skip
	 * directives, where @skip has higher precidence than @include.
	 */
	function shouldIncludeNode(exeContext, directives) {
	  var skipNode = directives && (0, _find2.default)(directives, function (directive) {
	    return directive.name.value === _directives.GraphQLSkipDirective.name;
	  });
	  if (skipNode) {
	    var _getArgumentValues = (0, _values.getArgumentValues)(_directives.GraphQLSkipDirective, skipNode, exeContext.variableValues),
	        skipIf = _getArgumentValues.if;
	
	    if (skipIf === true) {
	      return false;
	    }
	  }
	
	  var includeNode = directives && (0, _find2.default)(directives, function (directive) {
	    return directive.name.value === _directives.GraphQLIncludeDirective.name;
	  });
	  if (includeNode) {
	    var _getArgumentValues2 = (0, _values.getArgumentValues)(_directives.GraphQLIncludeDirective, includeNode, exeContext.variableValues),
	        includeIf = _getArgumentValues2.if;
	
	    if (includeIf === false) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	/**
	 * Determines if a fragment is applicable to the given type.
	 */
	function doesFragmentConditionMatch(exeContext, fragment, type) {
	  var typeConditionNode = fragment.typeCondition;
	  if (!typeConditionNode) {
	    return true;
	  }
	  var conditionalType = (0, _typeFromAST.typeFromAST)(exeContext.schema, typeConditionNode);
	  if (conditionalType === type) {
	    return true;
	  }
	  if ((0, _definition.isAbstractType)(conditionalType)) {
	    var abstractType = conditionalType;
	    return exeContext.schema.isPossibleType(abstractType, type);
	  }
	  return false;
	}
	
	/**
	 * This function transforms a JS object `{[key: string]: Promise<T>}` into
	 * a `Promise<{[key: string]: T}>`
	 *
	 * This is akin to bluebird's `Promise.props`, but implemented only using
	 * `Promise.all` so it will work with any implementation of ES6 promises.
	 */
	function promiseForObject(object) {
	  var keys = Object.keys(object);
	  var valuesAndPromises = keys.map(function (name) {
	    return object[name];
	  });
	  return Promise.all(valuesAndPromises).then(function (values) {
	    return values.reduce(function (resolvedObject, value, i) {
	      resolvedObject[keys[i]] = value;
	      return resolvedObject;
	    }, Object.create(null));
	  });
	}
	
	/**
	 * Implements the logic to compute the key of a given field's entry
	 */
	function getFieldEntryKey(node) {
	  return node.alias ? node.alias.value : node.name.value;
	}
	
	/**
	 * Resolves the field on the given source object. In particular, this
	 * figures out the value that the field returns by calling its resolve function,
	 * then calls completeValue to complete promises, serialize scalars, or execute
	 * the sub-selection-set for objects.
	 */
	function resolveField(exeContext, parentType, source, fieldNodes, path) {
	  var fieldNode = fieldNodes[0];
	  var fieldName = fieldNode.name.value;
	
	  var fieldDef = getFieldDef(exeContext.schema, parentType, fieldName);
	  if (!fieldDef) {
	    return;
	  }
	
	  var returnType = fieldDef.type;
	  var resolveFn = fieldDef.resolve || defaultFieldResolver;
	
	  // The resolve function's optional third argument is a context value that
	  // is provided to every resolve function within an execution. It is commonly
	  // used to represent an authenticated user, or request-specific caches.
	  var context = exeContext.contextValue;
	
	  // The resolve function's optional fourth argument is a collection of
	  // information about the current execution state.
	  var info = {
	    fieldName: fieldName,
	    fieldNodes: fieldNodes,
	    returnType: returnType,
	    parentType: parentType,
	    path: path,
	    schema: exeContext.schema,
	    fragments: exeContext.fragments,
	    rootValue: exeContext.rootValue,
	    operation: exeContext.operation,
	    variableValues: exeContext.variableValues
	  };
	
	  // Get the resolve function, regardless of if its result is normal
	  // or abrupt (error).
	  var result = resolveOrError(exeContext, fieldDef, fieldNode, resolveFn, source, context, info);
	
	  return completeValueCatchingError(exeContext, returnType, fieldNodes, info, path, result);
	}
	
	// Isolates the "ReturnOrAbrupt" behavior to not de-opt the `resolveField`
	// function. Returns the result of resolveFn or the abrupt-return Error object.
	function resolveOrError(exeContext, fieldDef, fieldNode, resolveFn, source, context, info) {
	  try {
	    // Build a JS object of arguments from the field.arguments AST, using the
	    // variables scope to fulfill any variable references.
	    // TODO: find a way to memoize, in case this field is within a List type.
	    var args = (0, _values.getArgumentValues)(fieldDef, fieldNode, exeContext.variableValues);
	
	    return resolveFn(source, args, context, info);
	  } catch (error) {
	    // Sometimes a non-error is thrown, wrap it as an Error for a
	    // consistent interface.
	    return error instanceof Error ? error : new Error(error);
	  }
	}
	
	// This is a small wrapper around completeValue which detects and logs errors
	// in the execution context.
	function completeValueCatchingError(exeContext, returnType, fieldNodes, info, path, result) {
	  // If the field type is non-nullable, then it is resolved without any
	  // protection from errors, however it still properly locates the error.
	  if (returnType instanceof _definition.GraphQLNonNull) {
	    return completeValueWithLocatedError(exeContext, returnType, fieldNodes, info, path, result);
	  }
	
	  // Otherwise, error protection is applied, logging the error and resolving
	  // a null value for this field if one is encountered.
	  try {
	    var completed = completeValueWithLocatedError(exeContext, returnType, fieldNodes, info, path, result);
	    if (isThenable(completed)) {
	      // If `completeValueWithLocatedError` returned a rejected promise, log
	      // the rejection error and resolve to null.
	      // Note: we don't rely on a `catch` method, but we do expect "thenable"
	      // to take a second callback for the error case.
	      return completed.then(undefined, function (error) {
	        exeContext.errors.push(error);
	        return Promise.resolve(null);
	      });
	    }
	    return completed;
	  } catch (error) {
	    // If `completeValueWithLocatedError` returned abruptly (threw an error),
	    // log the error and return null.
	    exeContext.errors.push(error);
	    return null;
	  }
	}
	
	// This is a small wrapper around completeValue which annotates errors with
	// location information.
	function completeValueWithLocatedError(exeContext, returnType, fieldNodes, info, path, result) {
	  try {
	    var completed = completeValue(exeContext, returnType, fieldNodes, info, path, result);
	    if (isThenable(completed)) {
	      return completed.then(undefined, function (error) {
	        return Promise.reject((0, _error.locatedError)(error, fieldNodes, responsePathAsArray(path)));
	      });
	    }
	    return completed;
	  } catch (error) {
	    throw (0, _error.locatedError)(error, fieldNodes, responsePathAsArray(path));
	  }
	}
	
	/**
	 * Implements the instructions for completeValue as defined in the
	 * "Field entries" section of the spec.
	 *
	 * If the field type is Non-Null, then this recursively completes the value
	 * for the inner type. It throws a field error if that completion returns null,
	 * as per the "Nullability" section of the spec.
	 *
	 * If the field type is a List, then this recursively completes the value
	 * for the inner type on each item in the list.
	 *
	 * If the field type is a Scalar or Enum, ensures the completed value is a legal
	 * value of the type by calling the `serialize` method of GraphQL type
	 * definition.
	 *
	 * If the field is an abstract type, determine the runtime type of the value
	 * and then complete based on that type
	 *
	 * Otherwise, the field type expects a sub-selection set, and will complete the
	 * value by evaluating all sub-selections.
	 */
	function completeValue(exeContext, returnType, fieldNodes, info, path, result) {
	  // If result is a Promise, apply-lift over completeValue.
	  if (isThenable(result)) {
	    return result.then(function (resolved) {
	      return completeValue(exeContext, returnType, fieldNodes, info, path, resolved);
	    });
	  }
	
	  // If result is an Error, throw a located error.
	  if (result instanceof Error) {
	    throw result;
	  }
	
	  // If field type is NonNull, complete for inner type, and throw field error
	  // if result is null.
	  if (returnType instanceof _definition.GraphQLNonNull) {
	    var completed = completeValue(exeContext, returnType.ofType, fieldNodes, info, path, result);
	    if (completed === null) {
	      throw new Error('Cannot return null for non-nullable field ' + info.parentType.name + '.' + info.fieldName + '.');
	    }
	    return completed;
	  }
	
	  // If result value is null-ish (null, undefined, or NaN) then return null.
	  if ((0, _isNullish2.default)(result)) {
	    return null;
	  }
	
	  // If field type is List, complete each item in the list with the inner type
	  if (returnType instanceof _definition.GraphQLList) {
	    return completeListValue(exeContext, returnType, fieldNodes, info, path, result);
	  }
	
	  // If field type is a leaf type, Scalar or Enum, serialize to a valid value,
	  // returning null if serialization is not possible.
	  if (returnType instanceof _definition.GraphQLScalarType || returnType instanceof _definition.GraphQLEnumType) {
	    return completeLeafValue(returnType, result);
	  }
	
	  // If field type is an abstract type, Interface or Union, determine the
	  // runtime Object type and complete for that type.
	  if (returnType instanceof _definition.GraphQLInterfaceType || returnType instanceof _definition.GraphQLUnionType) {
	    return completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result);
	  }
	
	  // If field type is Object, execute and complete all sub-selections.
	  if (returnType instanceof _definition.GraphQLObjectType) {
	    return completeObjectValue(exeContext, returnType, fieldNodes, info, path, result);
	  }
	
	  // Not reachable. All possible output types have been considered.
	  throw new Error('Cannot complete value of unexpected type "' + String(returnType) + '".');
	}
	
	/**
	 * Complete a list value by completing each item in the list with the
	 * inner type
	 */
	function completeListValue(exeContext, returnType, fieldNodes, info, path, result) {
	  (0, _invariant2.default)((0, _iterall.isCollection)(result), 'Expected Iterable, but did not find one for field ' + info.parentType.name + '.' + info.fieldName + '.');
	
	  // This is specified as a simple map, however we're optimizing the path
	  // where the list contains no Promises by avoiding creating another Promise.
	  var itemType = returnType.ofType;
	  var containsPromise = false;
	  var completedResults = [];
	  (0, _iterall.forEach)(result, function (item, index) {
	    // No need to modify the info object containing the path,
	    // since from here on it is not ever accessed by resolver functions.
	    var fieldPath = addPath(path, index);
	    var completedItem = completeValueCatchingError(exeContext, itemType, fieldNodes, info, fieldPath, item);
	
	    if (!containsPromise && isThenable(completedItem)) {
	      containsPromise = true;
	    }
	    completedResults.push(completedItem);
	  });
	
	  return containsPromise ? Promise.all(completedResults) : completedResults;
	}
	
	/**
	 * Complete a Scalar or Enum by serializing to a valid value, returning
	 * null if serialization is not possible.
	 */
	function completeLeafValue(returnType, result) {
	  (0, _invariant2.default)(returnType.serialize, 'Missing serialize method on type');
	  var serializedResult = returnType.serialize(result);
	  if ((0, _isNullish2.default)(serializedResult)) {
	    throw new Error('Expected a value of type "' + String(returnType) + '" but ' + ('received: ' + String(result)));
	  }
	  return serializedResult;
	}
	
	/**
	 * Complete a value of an abstract type by determining the runtime object type
	 * of that value, then complete the value for that type.
	 */
	function completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result) {
	  var runtimeType = returnType.resolveType ? returnType.resolveType(result, exeContext.contextValue, info) : defaultResolveTypeFn(result, exeContext.contextValue, info, returnType);
	
	  // If resolveType returns a string, we assume it's a GraphQLObjectType name.
	  if (typeof runtimeType === 'string') {
	    runtimeType = exeContext.schema.getType(runtimeType);
	  }
	
	  if (!(runtimeType instanceof _definition.GraphQLObjectType)) {
	    throw new _error.GraphQLError('Abstract type ' + returnType.name + ' must resolve to an Object type at ' + ('runtime for field ' + info.parentType.name + '.' + info.fieldName + ' with ') + ('value "' + String(result) + '", received "' + String(runtimeType) + '".'), fieldNodes);
	  }
	
	  if (!exeContext.schema.isPossibleType(returnType, runtimeType)) {
	    throw new _error.GraphQLError('Runtime Object type "' + runtimeType.name + '" is not a possible type ' + ('for "' + returnType.name + '".'), fieldNodes);
	  }
	
	  return completeObjectValue(exeContext, runtimeType, fieldNodes, info, path, result);
	}
	
	/**
	 * Complete an Object value by executing all sub-selections.
	 */
	function completeObjectValue(exeContext, returnType, fieldNodes, info, path, result) {
	  // If there is an isTypeOf predicate function, call it with the
	  // current result. If isTypeOf returns false, then raise an error rather
	  // than continuing execution.
	  if (returnType.isTypeOf && !returnType.isTypeOf(result, exeContext.contextValue, info)) {
	    throw new _error.GraphQLError('Expected value of type "' + returnType.name + '" but got: ' + String(result) + '.', fieldNodes);
	  }
	
	  // Collect sub-fields to execute to complete this value.
	  var subFieldNodes = Object.create(null);
	  var visitedFragmentNames = Object.create(null);
	  for (var i = 0; i < fieldNodes.length; i++) {
	    var selectionSet = fieldNodes[i].selectionSet;
	    if (selectionSet) {
	      subFieldNodes = collectFields(exeContext, returnType, selectionSet, subFieldNodes, visitedFragmentNames);
	    }
	  }
	
	  return executeFields(exeContext, returnType, result, path, subFieldNodes);
	}
	
	/**
	 * If a resolveType function is not given, then a default resolve behavior is
	 * used which tests each possible type for the abstract type by calling
	 * isTypeOf for the object being coerced, returning the first type that matches.
	 */
	function defaultResolveTypeFn(value, context, info, abstractType) {
	  var possibleTypes = info.schema.getPossibleTypes(abstractType);
	  for (var i = 0; i < possibleTypes.length; i++) {
	    var type = possibleTypes[i];
	    if (type.isTypeOf && type.isTypeOf(value, context, info)) {
	      return type;
	    }
	  }
	}
	
	/**
	 * If a resolve function is not given, then a default resolve behavior is used
	 * which takes the property of the source object of the same name as the field
	 * and returns it as the result, or if it's a function, returns the result
	 * of calling that function while passing along args and context.
	 */
	var defaultFieldResolver = exports.defaultFieldResolver = function defaultFieldResolver(source, args, context, _ref) {
	  var fieldName = _ref.fieldName;
	
	  // ensure source is a value for which property access is acceptable.
	  if (typeof source === 'object' || typeof source === 'function') {
	    var property = source[fieldName];
	    if (typeof property === 'function') {
	      return source[fieldName](args, context);
	    }
	    return property;
	  }
	};
	
	/**
	 * Checks to see if this object acts like a Promise, i.e. has a "then"
	 * function.
	 */
	function isThenable(value) {
	  return typeof value === 'object' && value !== null && typeof value.then === 'function';
	}
	
	/**
	 * This method looks up the field on the given type defintion.
	 * It has special casing for the two introspection fields, __schema
	 * and __typename. __typename is special because it can always be
	 * queried as a field, even in situations where no other fields
	 * are allowed, like on a Union. __schema could get automatically
	 * added to the query type, but that would require mutating type
	 * definitions, which would cause issues.
	 */
	function getFieldDef(schema, parentType, fieldName) {
	  if (fieldName === _introspection.SchemaMetaFieldDef.name && schema.getQueryType() === parentType) {
	    return _introspection.SchemaMetaFieldDef;
	  } else if (fieldName === _introspection.TypeMetaFieldDef.name && schema.getQueryType() === parentType) {
	    return _introspection.TypeMetaFieldDef;
	  } else if (fieldName === _introspection.TypeNameMetaFieldDef.name) {
	    return _introspection.TypeNameMetaFieldDef;
	  }
	  return parentType.getFields()[fieldName];
	}

/***/ },

/***/ "./node_modules/graphql/execution/values.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVariableValues = getVariableValues;
	exports.getArgumentValues = getArgumentValues;
	
	var _iterall = __webpack_require__("./node_modules/iterall/index.js");
	
	var _error = __webpack_require__("./node_modules/graphql/error/index.js");
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isNullish = __webpack_require__("./node_modules/graphql/jsutils/isNullish.js");
	
	var _isNullish2 = _interopRequireDefault(_isNullish);
	
	var _isInvalid = __webpack_require__("./node_modules/graphql/jsutils/isInvalid.js");
	
	var _isInvalid2 = _interopRequireDefault(_isInvalid);
	
	var _keyMap = __webpack_require__("./node_modules/graphql/jsutils/keyMap.js");
	
	var _keyMap2 = _interopRequireDefault(_keyMap);
	
	var _typeFromAST = __webpack_require__("./node_modules/graphql/utilities/typeFromAST.js");
	
	var _valueFromAST = __webpack_require__("./node_modules/graphql/utilities/valueFromAST.js");
	
	var _isValidJSValue = __webpack_require__("./node_modules/graphql/utilities/isValidJSValue.js");
	
	var _isValidLiteralValue = __webpack_require__("./node_modules/graphql/utilities/isValidLiteralValue.js");
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	var Kind = _interopRequireWildcard(_kinds);
	
	var _printer = __webpack_require__("./node_modules/graphql/language/printer.js");
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Prepares an object map of variableValues of the correct type based on the
	 * provided variable definitions and arbitrary input. If the input cannot be
	 * parsed to match the variable definitions, a GraphQLError will be thrown.
	 */
	function getVariableValues(schema, varDefNodes, inputs) {
	  var coercedValues = Object.create(null);
	  for (var i = 0; i < varDefNodes.length; i++) {
	    var varDefNode = varDefNodes[i];
	    var varName = varDefNode.variable.name.value;
	    var varType = (0, _typeFromAST.typeFromAST)(schema, varDefNode.type);
	    if (!(0, _definition.isInputType)(varType)) {
	      throw new _error.GraphQLError('Variable "$' + varName + '" expected value of type ' + ('"' + (0, _printer.print)(varDefNode.type) + '" which cannot be used as an input type.'), [varDefNode.type]);
	    }
	    varType = varType;
	
	    var value = inputs[varName];
	    if ((0, _isInvalid2.default)(value)) {
	      var defaultValue = varDefNode.defaultValue;
	      if (defaultValue) {
	        coercedValues[varName] = (0, _valueFromAST.valueFromAST)(defaultValue, varType);
	      }
	      if (varType instanceof _definition.GraphQLNonNull) {
	        throw new _error.GraphQLError('Variable "$' + varName + '" of required type ' + ('"' + String(varType) + '" was not provided.'), [varDefNode]);
	      }
	    } else {
	      var errors = (0, _isValidJSValue.isValidJSValue)(value, varType);
	      if (errors.length) {
	        var message = errors ? '\n' + errors.join('\n') : '';
	        throw new _error.GraphQLError('Variable "$' + varName + '" got invalid value ' + (JSON.stringify(value) + '.' + message), [varDefNode]);
	      }
	
	      var coercedValue = coerceValue(varType, value);
	      (0, _invariant2.default)(!(0, _isInvalid2.default)(coercedValue), 'Should have reported error.');
	      coercedValues[varName] = coercedValue;
	    }
	  }
	  return coercedValues;
	}
	
	/**
	 * Prepares an object map of argument values given a list of argument
	 * definitions and list of argument AST nodes.
	 */
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function getArgumentValues(def, node, variableValues) {
	  var argDefs = def.args;
	  var argNodes = node.arguments;
	  if (!argDefs || !argNodes) {
	    return {};
	  }
	  var coercedValues = Object.create(null);
	  var argNodeMap = (0, _keyMap2.default)(argNodes, function (arg) {
	    return arg.name.value;
	  });
	  for (var i = 0; i < argDefs.length; i++) {
	    var argDef = argDefs[i];
	    var name = argDef.name;
	    var argType = argDef.type;
	    var argumentNode = argNodeMap[name];
	    var defaultValue = argDef.defaultValue;
	    if (!argumentNode) {
	      if (!(0, _isInvalid2.default)(defaultValue)) {
	        coercedValues[name] = defaultValue;
	      } else if (argType instanceof _definition.GraphQLNonNull) {
	        throw new _error.GraphQLError('Argument "' + name + '" of required type ' + ('"' + String(argType) + '" was not provided.'), [node]);
	      }
	    } else if (argumentNode.value.kind === Kind.VARIABLE) {
	      var variableName = argumentNode.value.name.value;
	      if (variableValues && !(0, _isInvalid2.default)(variableValues[variableName])) {
	        // Note: this does not check that this variable value is correct.
	        // This assumes that this query has been validated and the variable
	        // usage here is of the correct type.
	        coercedValues[name] = variableValues[variableName];
	      } else if (!(0, _isInvalid2.default)(defaultValue)) {
	        coercedValues[name] = defaultValue;
	      } else if (argType instanceof _definition.GraphQLNonNull) {
	        throw new _error.GraphQLError('Argument "' + name + '" of required type "' + String(argType) + '" was ' + ('provided the variable "$' + variableName + '" which was not provided ') + 'a runtime value.', [argumentNode.value]);
	      }
	    } else {
	      var valueNode = argumentNode.value;
	      var coercedValue = (0, _valueFromAST.valueFromAST)(valueNode, argType, variableValues);
	      if ((0, _isInvalid2.default)(coercedValue)) {
	        var errors = (0, _isValidLiteralValue.isValidLiteralValue)(argType, valueNode);
	        var message = errors ? '\n' + errors.join('\n') : '';
	        throw new _error.GraphQLError('Argument "' + name + '" got invalid value ' + (0, _printer.print)(valueNode) + '.' + message, [argumentNode.value]);
	      }
	      coercedValues[name] = coercedValue;
	    }
	  }
	  return coercedValues;
	}
	
	/**
	 * Given a type and any value, return a runtime value coerced to match the type.
	 */
	function coerceValue(type, value) {
	  // Ensure flow knows that we treat function params as const.
	  var _value = value;
	
	  if ((0, _isInvalid2.default)(_value)) {
	    return; // Intentionally return no value.
	  }
	
	  if (type instanceof _definition.GraphQLNonNull) {
	    if (_value === null) {
	      return; // Intentionally return no value.
	    }
	    return coerceValue(type.ofType, _value);
	  }
	
	  if (_value === null) {
	    // Intentionally return the value null.
	    return null;
	  }
	
	  if (type instanceof _definition.GraphQLList) {
	    var itemType = type.ofType;
	    if ((0, _iterall.isCollection)(_value)) {
	      var coercedValues = [];
	      var valueIter = (0, _iterall.createIterator)(_value);
	      if (!valueIter) {
	        return; // Intentionally return no value.
	      }
	      var step = void 0;
	      while (!(step = valueIter.next()).done) {
	        var itemValue = coerceValue(itemType, step.value);
	        if ((0, _isInvalid2.default)(itemValue)) {
	          return; // Intentionally return no value.
	        }
	        coercedValues.push(itemValue);
	      }
	      return coercedValues;
	    }
	    var coercedValue = coerceValue(itemType, _value);
	    if ((0, _isInvalid2.default)(coercedValue)) {
	      return; // Intentionally return no value.
	    }
	    return [coerceValue(itemType, _value)];
	  }
	
	  if (type instanceof _definition.GraphQLInputObjectType) {
	    if (typeof _value !== 'object') {
	      return; // Intentionally return no value.
	    }
	    var coercedObj = Object.create(null);
	    var fields = type.getFields();
	    var fieldNames = Object.keys(fields);
	    for (var i = 0; i < fieldNames.length; i++) {
	      var fieldName = fieldNames[i];
	      var field = fields[fieldName];
	      if ((0, _isInvalid2.default)(_value[fieldName])) {
	        if (!(0, _isInvalid2.default)(field.defaultValue)) {
	          coercedObj[fieldName] = field.defaultValue;
	        } else if (field.type instanceof _definition.GraphQLNonNull) {
	          return; // Intentionally return no value.
	        }
	        continue;
	      }
	      var fieldValue = coerceValue(field.type, _value[fieldName]);
	      if ((0, _isInvalid2.default)(fieldValue)) {
	        return; // Intentionally return no value.
	      }
	      coercedObj[fieldName] = fieldValue;
	    }
	    return coercedObj;
	  }
	
	  (0, _invariant2.default)(type instanceof _definition.GraphQLScalarType || type instanceof _definition.GraphQLEnumType, 'Must be input type');
	
	  var parsed = type.parseValue(_value);
	  if ((0, _isNullish2.default)(parsed)) {
	    // null or invalid values represent a failure to parse correctly,
	    // in which case no value is returned.
	    return;
	  }
	
	  return parsed;
	}

/***/ },

/***/ "./node_modules/graphql/utilities/valueFromAST.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.valueFromAST = valueFromAST;
	
	var _keyMap = __webpack_require__("./node_modules/graphql/jsutils/keyMap.js");
	
	var _keyMap2 = _interopRequireDefault(_keyMap);
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isNullish = __webpack_require__("./node_modules/graphql/jsutils/isNullish.js");
	
	var _isNullish2 = _interopRequireDefault(_isNullish);
	
	var _isInvalid = __webpack_require__("./node_modules/graphql/jsutils/isInvalid.js");
	
	var _isInvalid2 = _interopRequireDefault(_isInvalid);
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	var Kind = _interopRequireWildcard(_kinds);
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Produces a JavaScript value given a GraphQL Value AST.
	 *
	 * A GraphQL type must be provided, which will be used to interpret different
	 * GraphQL Value literals.
	 *
	 * Returns `undefined` when the value could not be validly coerced according to
	 * the provided type.
	 *
	 * | GraphQL Value        | JSON Value    |
	 * | -------------------- | ------------- |
	 * | Input Object         | Object        |
	 * | List                 | Array         |
	 * | Boolean              | Boolean       |
	 * | String               | String        |
	 * | Int / Float          | Number        |
	 * | Enum Value           | Mixed         |
	 * | NullValue            | null          |
	 *
	 */
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function valueFromAST(valueNode, type, variables) {
	  if (!valueNode) {
	    // When there is no node, then there is also no value.
	    // Importantly, this is different from returning the value null.
	    return;
	  }
	
	  if (type instanceof _definition.GraphQLNonNull) {
	    if (valueNode.kind === Kind.NULL) {
	      return; // Invalid: intentionally return no value.
	    }
	    return valueFromAST(valueNode, type.ofType, variables);
	  }
	
	  if (valueNode.kind === Kind.NULL) {
	    // This is explicitly returning the value null.
	    return null;
	  }
	
	  if (valueNode.kind === Kind.VARIABLE) {
	    var variableName = valueNode.name.value;
	    if (!variables || (0, _isInvalid2.default)(variables[variableName])) {
	      // No valid return value.
	      return;
	    }
	    // Note: we're not doing any checking that this variable is correct. We're
	    // assuming that this query has been validated and the variable usage here
	    // is of the correct type.
	    return variables[variableName];
	  }
	
	  if (type instanceof _definition.GraphQLList) {
	    var itemType = type.ofType;
	    if (valueNode.kind === Kind.LIST) {
	      var coercedValues = [];
	      var itemNodes = valueNode.values;
	      for (var i = 0; i < itemNodes.length; i++) {
	        if (isMissingVariable(itemNodes[i], variables)) {
	          // If an array contains a missing variable, it is either coerced to
	          // null or if the item type is non-null, it considered invalid.
	          if (itemType instanceof _definition.GraphQLNonNull) {
	            return; // Invalid: intentionally return no value.
	          }
	          coercedValues.push(null);
	        } else {
	          var itemValue = valueFromAST(itemNodes[i], itemType, variables);
	          if ((0, _isInvalid2.default)(itemValue)) {
	            return; // Invalid: intentionally return no value.
	          }
	          coercedValues.push(itemValue);
	        }
	      }
	      return coercedValues;
	    }
	    var coercedValue = valueFromAST(valueNode, itemType, variables);
	    if ((0, _isInvalid2.default)(coercedValue)) {
	      return; // Invalid: intentionally return no value.
	    }
	    return [coercedValue];
	  }
	
	  if (type instanceof _definition.GraphQLInputObjectType) {
	    if (valueNode.kind !== Kind.OBJECT) {
	      return; // Invalid: intentionally return no value.
	    }
	    var coercedObj = Object.create(null);
	    var fields = type.getFields();
	    var fieldNodes = (0, _keyMap2.default)(valueNode.fields, function (field) {
	      return field.name.value;
	    });
	    var fieldNames = Object.keys(fields);
	    for (var _i = 0; _i < fieldNames.length; _i++) {
	      var fieldName = fieldNames[_i];
	      var field = fields[fieldName];
	      var fieldNode = fieldNodes[fieldName];
	      if (!fieldNode || isMissingVariable(fieldNode.value, variables)) {
	        if (!(0, _isInvalid2.default)(field.defaultValue)) {
	          coercedObj[fieldName] = field.defaultValue;
	        } else if (field.type instanceof _definition.GraphQLNonNull) {
	          return; // Invalid: intentionally return no value.
	        }
	        continue;
	      }
	      var fieldValue = valueFromAST(fieldNode.value, field.type, variables);
	      if ((0, _isInvalid2.default)(fieldValue)) {
	        return; // Invalid: intentionally return no value.
	      }
	      coercedObj[fieldName] = fieldValue;
	    }
	    return coercedObj;
	  }
	
	  (0, _invariant2.default)(type instanceof _definition.GraphQLScalarType || type instanceof _definition.GraphQLEnumType, 'Must be input type');
	
	  var parsed = type.parseLiteral(valueNode);
	  if ((0, _isNullish2.default)(parsed)) {
	    // null or invalid values represent a failure to parse correctly,
	    // in which case no value is returned.
	    return;
	  }
	
	  return parsed;
	}
	
	// Returns true if the provided valueNode is a variable which is not defined
	// in the set of variables.
	function isMissingVariable(valueNode, variables) {
	  return valueNode.kind === Kind.VARIABLE && (!variables || (0, _isInvalid2.default)(variables[valueNode.name.value]));
	}

/***/ },

/***/ "./node_modules/graphql/utilities/isValidJSValue.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isValidJSValue = isValidJSValue;
	
	var _iterall = __webpack_require__("./node_modules/iterall/index.js");
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isNullish = __webpack_require__("./node_modules/graphql/jsutils/isNullish.js");
	
	var _isNullish2 = _interopRequireDefault(_isNullish);
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Given a JavaScript value and a GraphQL type, determine if the value will be
	 * accepted for that type. This is primarily useful for validating the
	 * runtime values of query variables.
	 */
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function isValidJSValue(value, type) {
	  // A value must be provided if the type is non-null.
	  if (type instanceof _definition.GraphQLNonNull) {
	    if ((0, _isNullish2.default)(value)) {
	      return ['Expected "' + String(type) + '", found null.'];
	    }
	    return isValidJSValue(value, type.ofType);
	  }
	
	  if ((0, _isNullish2.default)(value)) {
	    return [];
	  }
	
	  // Lists accept a non-list value as a list of one.
	  if (type instanceof _definition.GraphQLList) {
	    var _ret = function () {
	      var itemType = type.ofType;
	      if ((0, _iterall.isCollection)(value)) {
	        var _ret2 = function () {
	          var errors = [];
	          (0, _iterall.forEach)(value, function (item, index) {
	            errors.push.apply(errors, isValidJSValue(item, itemType).map(function (error) {
	              return 'In element #' + index + ': ' + error;
	            }));
	          });
	          return {
	            v: {
	              v: errors
	            }
	          };
	        }();
	
	        if (typeof _ret2 === "object") return _ret2.v;
	      }
	      return {
	        v: isValidJSValue(value, itemType)
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	
	  // Input objects check each defined field.
	  if (type instanceof _definition.GraphQLInputObjectType) {
	    var _ret3 = function () {
	      if (typeof value !== 'object' || value === null) {
	        return {
	          v: ['Expected "' + type.name + '", found not an object.']
	        };
	      }
	      var fields = type.getFields();
	
	      var errors = [];
	
	      // Ensure every provided field is defined.
	      Object.keys(value).forEach(function (providedField) {
	        if (!fields[providedField]) {
	          errors.push('In field "' + providedField + '": Unknown field.');
	        }
	      });
	
	      // Ensure every defined field is valid.
	      Object.keys(fields).forEach(function (fieldName) {
	        var newErrors = isValidJSValue(value[fieldName], fields[fieldName].type);
	        errors.push.apply(errors, newErrors.map(function (error) {
	          return 'In field "' + fieldName + '": ' + error;
	        }));
	      });
	
	      return {
	        v: errors
	      };
	    }();
	
	    if (typeof _ret3 === "object") return _ret3.v;
	  }
	
	  (0, _invariant2.default)(type instanceof _definition.GraphQLScalarType || type instanceof _definition.GraphQLEnumType, 'Must be input type');
	
	  // Scalar/Enum input checks to ensure the type can parse the value to
	  // a non-null value.
	  var parseResult = type.parseValue(value);
	  if ((0, _isNullish2.default)(parseResult)) {
	    return ['Expected type "' + type.name + '", found ' + JSON.stringify(value) + '.'];
	  }
	
	  return [];
	}

/***/ },

/***/ "./node_modules/graphql/type/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _schema = __webpack_require__("./node_modules/graphql/type/schema.js");
	
	Object.defineProperty(exports, 'GraphQLSchema', {
	  enumerable: true,
	  get: function get() {
	    return _schema.GraphQLSchema;
	  }
	});
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	Object.defineProperty(exports, 'isType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.isType;
	  }
	});
	Object.defineProperty(exports, 'isInputType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.isInputType;
	  }
	});
	Object.defineProperty(exports, 'isOutputType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.isOutputType;
	  }
	});
	Object.defineProperty(exports, 'isLeafType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.isLeafType;
	  }
	});
	Object.defineProperty(exports, 'isCompositeType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.isCompositeType;
	  }
	});
	Object.defineProperty(exports, 'isAbstractType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.isAbstractType;
	  }
	});
	Object.defineProperty(exports, 'assertType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertType;
	  }
	});
	Object.defineProperty(exports, 'assertInputType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertInputType;
	  }
	});
	Object.defineProperty(exports, 'assertOutputType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertOutputType;
	  }
	});
	Object.defineProperty(exports, 'assertLeafType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertLeafType;
	  }
	});
	Object.defineProperty(exports, 'assertCompositeType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertCompositeType;
	  }
	});
	Object.defineProperty(exports, 'assertAbstractType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertAbstractType;
	  }
	});
	Object.defineProperty(exports, 'getNullableType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.getNullableType;
	  }
	});
	Object.defineProperty(exports, 'getNamedType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.getNamedType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLScalarType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLScalarType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLObjectType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLObjectType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLInterfaceType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLInterfaceType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLUnionType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLUnionType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLEnumType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLEnumType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLInputObjectType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLInputObjectType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLList', {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLList;
	  }
	});
	Object.defineProperty(exports, 'GraphQLNonNull', {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLNonNull;
	  }
	});
	
	var _directives = __webpack_require__("./node_modules/graphql/type/directives.js");
	
	Object.defineProperty(exports, 'DirectiveLocation', {
	  enumerable: true,
	  get: function get() {
	    return _directives.DirectiveLocation;
	  }
	});
	Object.defineProperty(exports, 'GraphQLDirective', {
	  enumerable: true,
	  get: function get() {
	    return _directives.GraphQLDirective;
	  }
	});
	Object.defineProperty(exports, 'specifiedDirectives', {
	  enumerable: true,
	  get: function get() {
	    return _directives.specifiedDirectives;
	  }
	});
	Object.defineProperty(exports, 'GraphQLIncludeDirective', {
	  enumerable: true,
	  get: function get() {
	    return _directives.GraphQLIncludeDirective;
	  }
	});
	Object.defineProperty(exports, 'GraphQLSkipDirective', {
	  enumerable: true,
	  get: function get() {
	    return _directives.GraphQLSkipDirective;
	  }
	});
	Object.defineProperty(exports, 'GraphQLDeprecatedDirective', {
	  enumerable: true,
	  get: function get() {
	    return _directives.GraphQLDeprecatedDirective;
	  }
	});
	Object.defineProperty(exports, 'DEFAULT_DEPRECATION_REASON', {
	  enumerable: true,
	  get: function get() {
	    return _directives.DEFAULT_DEPRECATION_REASON;
	  }
	});
	
	var _scalars = __webpack_require__("./node_modules/graphql/type/scalars.js");
	
	Object.defineProperty(exports, 'GraphQLInt', {
	  enumerable: true,
	  get: function get() {
	    return _scalars.GraphQLInt;
	  }
	});
	Object.defineProperty(exports, 'GraphQLFloat', {
	  enumerable: true,
	  get: function get() {
	    return _scalars.GraphQLFloat;
	  }
	});
	Object.defineProperty(exports, 'GraphQLString', {
	  enumerable: true,
	  get: function get() {
	    return _scalars.GraphQLString;
	  }
	});
	Object.defineProperty(exports, 'GraphQLBoolean', {
	  enumerable: true,
	  get: function get() {
	    return _scalars.GraphQLBoolean;
	  }
	});
	Object.defineProperty(exports, 'GraphQLID', {
	  enumerable: true,
	  get: function get() {
	    return _scalars.GraphQLID;
	  }
	});
	
	var _introspection = __webpack_require__("./node_modules/graphql/type/introspection.js");
	
	Object.defineProperty(exports, 'TypeKind', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.TypeKind;
	  }
	});
	Object.defineProperty(exports, '__Schema', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__Schema;
	  }
	});
	Object.defineProperty(exports, '__Directive', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__Directive;
	  }
	});
	Object.defineProperty(exports, '__DirectiveLocation', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__DirectiveLocation;
	  }
	});
	Object.defineProperty(exports, '__Type', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__Type;
	  }
	});
	Object.defineProperty(exports, '__Field', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__Field;
	  }
	});
	Object.defineProperty(exports, '__InputValue', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__InputValue;
	  }
	});
	Object.defineProperty(exports, '__EnumValue', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__EnumValue;
	  }
	});
	Object.defineProperty(exports, '__TypeKind', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__TypeKind;
	  }
	});
	Object.defineProperty(exports, 'SchemaMetaFieldDef', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.SchemaMetaFieldDef;
	  }
	});
	Object.defineProperty(exports, 'TypeMetaFieldDef', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.TypeMetaFieldDef;
	  }
	});
	Object.defineProperty(exports, 'TypeNameMetaFieldDef', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.TypeNameMetaFieldDef;
	  }
	});

/***/ },

/***/ "./node_modules/graphql/execution/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _execute = __webpack_require__("./node_modules/graphql/execution/execute.js");
	
	Object.defineProperty(exports, 'execute', {
	  enumerable: true,
	  get: function get() {
	    return _execute.execute;
	  }
	});
	Object.defineProperty(exports, 'defaultFieldResolver', {
	  enumerable: true,
	  get: function get() {
	    return _execute.defaultFieldResolver;
	  }
	});
	Object.defineProperty(exports, 'responsePathAsArray', {
	  enumerable: true,
	  get: function get() {
	    return _execute.responsePathAsArray;
	  }
	});

/***/ },

/***/ "./node_modules/graphql/validation/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validate = __webpack_require__("./node_modules/graphql/validation/validate.js");
	
	Object.defineProperty(exports, 'validate', {
	  enumerable: true,
	  get: function get() {
	    return _validate.validate;
	  }
	});
	Object.defineProperty(exports, 'ValidationContext', {
	  enumerable: true,
	  get: function get() {
	    return _validate.ValidationContext;
	  }
	});
	
	var _specifiedRules = __webpack_require__("./node_modules/graphql/validation/specifiedRules.js");
	
	Object.defineProperty(exports, 'specifiedRules', {
	  enumerable: true,
	  get: function get() {
	    return _specifiedRules.specifiedRules;
	  }
	});

/***/ },

/***/ "./node_modules/graphql/utilities/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _introspectionQuery = __webpack_require__("./node_modules/graphql/utilities/introspectionQuery.js");
	
	Object.defineProperty(exports, 'introspectionQuery', {
	  enumerable: true,
	  get: function get() {
	    return _introspectionQuery.introspectionQuery;
	  }
	});
	
	var _getOperationAST = __webpack_require__("./node_modules/graphql/utilities/getOperationAST.js");
	
	Object.defineProperty(exports, 'getOperationAST', {
	  enumerable: true,
	  get: function get() {
	    return _getOperationAST.getOperationAST;
	  }
	});
	
	var _buildClientSchema = __webpack_require__("./node_modules/graphql/utilities/buildClientSchema.js");
	
	Object.defineProperty(exports, 'buildClientSchema', {
	  enumerable: true,
	  get: function get() {
	    return _buildClientSchema.buildClientSchema;
	  }
	});
	
	var _buildASTSchema = __webpack_require__("./node_modules/graphql/utilities/buildASTSchema.js");
	
	Object.defineProperty(exports, 'buildASTSchema', {
	  enumerable: true,
	  get: function get() {
	    return _buildASTSchema.buildASTSchema;
	  }
	});
	Object.defineProperty(exports, 'buildSchema', {
	  enumerable: true,
	  get: function get() {
	    return _buildASTSchema.buildSchema;
	  }
	});
	
	var _extendSchema = __webpack_require__("./node_modules/graphql/utilities/extendSchema.js");
	
	Object.defineProperty(exports, 'extendSchema', {
	  enumerable: true,
	  get: function get() {
	    return _extendSchema.extendSchema;
	  }
	});
	
	var _schemaPrinter = __webpack_require__("./node_modules/graphql/utilities/schemaPrinter.js");
	
	Object.defineProperty(exports, 'printSchema', {
	  enumerable: true,
	  get: function get() {
	    return _schemaPrinter.printSchema;
	  }
	});
	Object.defineProperty(exports, 'printType', {
	  enumerable: true,
	  get: function get() {
	    return _schemaPrinter.printType;
	  }
	});
	Object.defineProperty(exports, 'printIntrospectionSchema', {
	  enumerable: true,
	  get: function get() {
	    return _schemaPrinter.printIntrospectionSchema;
	  }
	});
	
	var _typeFromAST = __webpack_require__("./node_modules/graphql/utilities/typeFromAST.js");
	
	Object.defineProperty(exports, 'typeFromAST', {
	  enumerable: true,
	  get: function get() {
	    return _typeFromAST.typeFromAST;
	  }
	});
	
	var _valueFromAST = __webpack_require__("./node_modules/graphql/utilities/valueFromAST.js");
	
	Object.defineProperty(exports, 'valueFromAST', {
	  enumerable: true,
	  get: function get() {
	    return _valueFromAST.valueFromAST;
	  }
	});
	
	var _astFromValue = __webpack_require__("./node_modules/graphql/utilities/astFromValue.js");
	
	Object.defineProperty(exports, 'astFromValue', {
	  enumerable: true,
	  get: function get() {
	    return _astFromValue.astFromValue;
	  }
	});
	
	var _TypeInfo = __webpack_require__("./node_modules/graphql/utilities/TypeInfo.js");
	
	Object.defineProperty(exports, 'TypeInfo', {
	  enumerable: true,
	  get: function get() {
	    return _TypeInfo.TypeInfo;
	  }
	});
	
	var _isValidJSValue = __webpack_require__("./node_modules/graphql/utilities/isValidJSValue.js");
	
	Object.defineProperty(exports, 'isValidJSValue', {
	  enumerable: true,
	  get: function get() {
	    return _isValidJSValue.isValidJSValue;
	  }
	});
	
	var _isValidLiteralValue = __webpack_require__("./node_modules/graphql/utilities/isValidLiteralValue.js");
	
	Object.defineProperty(exports, 'isValidLiteralValue', {
	  enumerable: true,
	  get: function get() {
	    return _isValidLiteralValue.isValidLiteralValue;
	  }
	});
	
	var _concatAST = __webpack_require__("./node_modules/graphql/utilities/concatAST.js");
	
	Object.defineProperty(exports, 'concatAST', {
	  enumerable: true,
	  get: function get() {
	    return _concatAST.concatAST;
	  }
	});
	
	var _separateOperations = __webpack_require__("./node_modules/graphql/utilities/separateOperations.js");
	
	Object.defineProperty(exports, 'separateOperations', {
	  enumerable: true,
	  get: function get() {
	    return _separateOperations.separateOperations;
	  }
	});
	
	var _typeComparators = __webpack_require__("./node_modules/graphql/utilities/typeComparators.js");
	
	Object.defineProperty(exports, 'isEqualType', {
	  enumerable: true,
	  get: function get() {
	    return _typeComparators.isEqualType;
	  }
	});
	Object.defineProperty(exports, 'isTypeSubTypeOf', {
	  enumerable: true,
	  get: function get() {
	    return _typeComparators.isTypeSubTypeOf;
	  }
	});
	Object.defineProperty(exports, 'doTypesOverlap', {
	  enumerable: true,
	  get: function get() {
	    return _typeComparators.doTypesOverlap;
	  }
	});
	
	var _assertValidName = __webpack_require__("./node_modules/graphql/utilities/assertValidName.js");
	
	Object.defineProperty(exports, 'assertValidName', {
	  enumerable: true,
	  get: function get() {
	    return _assertValidName.assertValidName;
	  }
	});
	
	var _findBreakingChanges = __webpack_require__("./node_modules/graphql/utilities/findBreakingChanges.js");
	
	Object.defineProperty(exports, 'findBreakingChanges', {
	  enumerable: true,
	  get: function get() {
	    return _findBreakingChanges.findBreakingChanges;
	  }
	});

/***/ },

/***/ "./node_modules/graphql/utilities/introspectionQuery.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var introspectionQuery = exports.introspectionQuery = '\n  query IntrospectionQuery {\n    __schema {\n      queryType { name }\n      mutationType { name }\n      subscriptionType { name }\n      types {\n        ...FullType\n      }\n      directives {\n        name\n        description\n        locations\n        args {\n          ...InputValue\n        }\n      }\n    }\n  }\n\n  fragment FullType on __Type {\n    kind\n    name\n    description\n    fields(includeDeprecated: true) {\n      name\n      description\n      args {\n        ...InputValue\n      }\n      type {\n        ...TypeRef\n      }\n      isDeprecated\n      deprecationReason\n    }\n    inputFields {\n      ...InputValue\n    }\n    interfaces {\n      ...TypeRef\n    }\n    enumValues(includeDeprecated: true) {\n      name\n      description\n      isDeprecated\n      deprecationReason\n    }\n    possibleTypes {\n      ...TypeRef\n    }\n  }\n\n  fragment InputValue on __InputValue {\n    name\n    description\n    type { ...TypeRef }\n    defaultValue\n  }\n\n  fragment TypeRef on __Type {\n    kind\n    name\n    ofType {\n      kind\n      name\n      ofType {\n        kind\n        name\n        ofType {\n          kind\n          name\n          ofType {\n            kind\n            name\n            ofType {\n              kind\n              name\n              ofType {\n                kind\n                name\n                ofType {\n                  kind\n                  name\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n';
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */

/***/ },

/***/ "./node_modules/graphql/utilities/getOperationAST.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOperationAST = getOperationAST;
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	/**
	 * Returns an operation AST given a document AST and optionally an operation
	 * name. If a name is not provided, an operation is only returned if only one is
	 * provided in the document.
	 */
	function getOperationAST(documentAST, operationName) {
	  var operation = null;
	  for (var i = 0; i < documentAST.definitions.length; i++) {
	    var definition = documentAST.definitions[i];
	    if (definition.kind === _kinds.OPERATION_DEFINITION) {
	      if (!operationName) {
	        // If no operation name was provided, only return an Operation if there
	        // is one defined in the document. Upon encountering the second, return
	        // null.
	        if (operation) {
	          return null;
	        }
	        operation = definition;
	      } else if (definition.name && definition.name.value === operationName) {
	        return definition;
	      }
	    }
	  }
	  return operation;
	}
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */

/***/ },

/***/ "./node_modules/graphql/utilities/buildClientSchema.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buildClientSchema = buildClientSchema;
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _keyMap = __webpack_require__("./node_modules/graphql/jsutils/keyMap.js");
	
	var _keyMap2 = _interopRequireDefault(_keyMap);
	
	var _keyValMap = __webpack_require__("./node_modules/graphql/jsutils/keyValMap.js");
	
	var _keyValMap2 = _interopRequireDefault(_keyValMap);
	
	var _valueFromAST = __webpack_require__("./node_modules/graphql/utilities/valueFromAST.js");
	
	var _parser = __webpack_require__("./node_modules/graphql/language/parser.js");
	
	var _schema = __webpack_require__("./node_modules/graphql/type/schema.js");
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	var _introspection = __webpack_require__("./node_modules/graphql/type/introspection.js");
	
	var _scalars = __webpack_require__("./node_modules/graphql/type/scalars.js");
	
	var _directives = __webpack_require__("./node_modules/graphql/type/directives.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Build a GraphQLSchema for use by client tools.
	 *
	 * Given the result of a client running the introspection query, creates and
	 * returns a GraphQLSchema instance which can be then used with all graphql-js
	 * tools, but cannot be used to execute a query, as introspection does not
	 * represent the "resolver", "parse" or "serialize" functions or any other
	 * server-internal mechanisms.
	 */
	function buildClientSchema(introspection) {
	
	  // Get the schema from the introspection result.
	  var schemaIntrospection = introspection.__schema;
	
	  // Converts the list of types into a keyMap based on the type names.
	  var typeIntrospectionMap = (0, _keyMap2.default)(schemaIntrospection.types, function (type) {
	    return type.name;
	  });
	
	  // A cache to use to store the actual GraphQLType definition objects by name.
	  // Initialize to the GraphQL built in scalars. All functions below are inline
	  // so that this type def cache is within the scope of the closure.
	  var typeDefCache = {
	    String: _scalars.GraphQLString,
	    Int: _scalars.GraphQLInt,
	    Float: _scalars.GraphQLFloat,
	    Boolean: _scalars.GraphQLBoolean,
	    ID: _scalars.GraphQLID,
	    __Schema: _introspection.__Schema,
	    __Directive: _introspection.__Directive,
	    __DirectiveLocation: _introspection.__DirectiveLocation,
	    __Type: _introspection.__Type,
	    __Field: _introspection.__Field,
	    __InputValue: _introspection.__InputValue,
	    __EnumValue: _introspection.__EnumValue,
	    __TypeKind: _introspection.__TypeKind
	  };
	
	  // Given a type reference in introspection, return the GraphQLType instance.
	  // preferring cached instances before building new instances.
	  function getType(typeRef) {
	    if (typeRef.kind === _introspection.TypeKind.LIST) {
	      var itemRef = typeRef.ofType;
	      if (!itemRef) {
	        throw new Error('Decorated type deeper than introspection query.');
	      }
	      return new _definition.GraphQLList(getType(itemRef));
	    }
	    if (typeRef.kind === _introspection.TypeKind.NON_NULL) {
	      var nullableRef = typeRef.ofType;
	      if (!nullableRef) {
	        throw new Error('Decorated type deeper than introspection query.');
	      }
	      var nullableType = getType(nullableRef);
	      (0, _invariant2.default)(!(nullableType instanceof _definition.GraphQLNonNull), 'No nesting nonnull.');
	      return new _definition.GraphQLNonNull(nullableType);
	    }
	    return getNamedType(typeRef.name);
	  }
	
	  function getNamedType(typeName) {
	    if (typeDefCache[typeName]) {
	      return typeDefCache[typeName];
	    }
	    var typeIntrospection = typeIntrospectionMap[typeName];
	    if (!typeIntrospection) {
	      throw new Error('Invalid or incomplete schema, unknown type: ' + typeName + '. Ensure ' + 'that a full introspection query is used in order to build a ' + 'client schema.');
	    }
	    var typeDef = buildType(typeIntrospection);
	    typeDefCache[typeName] = typeDef;
	    return typeDef;
	  }
	
	  function getInputType(typeRef) {
	    var type = getType(typeRef);
	    (0, _invariant2.default)((0, _definition.isInputType)(type), 'Introspection must provide input type for arguments.');
	    return type;
	  }
	
	  function getOutputType(typeRef) {
	    var type = getType(typeRef);
	    (0, _invariant2.default)((0, _definition.isOutputType)(type), 'Introspection must provide output type for fields.');
	    return type;
	  }
	
	  function getObjectType(typeRef) {
	    var type = getType(typeRef);
	    (0, _invariant2.default)(type instanceof _definition.GraphQLObjectType, 'Introspection must provide object type for possibleTypes.');
	    return type;
	  }
	
	  function getInterfaceType(typeRef) {
	    var type = getType(typeRef);
	    (0, _invariant2.default)(type instanceof _definition.GraphQLInterfaceType, 'Introspection must provide interface type for interfaces.');
	    return type;
	  }
	
	  // Given a type's introspection result, construct the correct
	  // GraphQLType instance.
	  function buildType(type) {
	    switch (type.kind) {
	      case _introspection.TypeKind.SCALAR:
	        return buildScalarDef(type);
	      case _introspection.TypeKind.OBJECT:
	        return buildObjectDef(type);
	      case _introspection.TypeKind.INTERFACE:
	        return buildInterfaceDef(type);
	      case _introspection.TypeKind.UNION:
	        return buildUnionDef(type);
	      case _introspection.TypeKind.ENUM:
	        return buildEnumDef(type);
	      case _introspection.TypeKind.INPUT_OBJECT:
	        return buildInputObjectDef(type);
	      default:
	        throw new Error('Invalid or incomplete schema, unknown kind: ' + type.kind + '. Ensure ' + 'that a full introspection query is used in order to build a ' + 'client schema.');
	    }
	  }
	
	  function buildScalarDef(scalarIntrospection) {
	    return new _definition.GraphQLScalarType({
	      name: scalarIntrospection.name,
	      description: scalarIntrospection.description,
	      serialize: function serialize(id) {
	        return id;
	      },
	      // Note: validation calls the parse functions to determine if a
	      // literal value is correct. Returning null would cause use of custom
	      // scalars to always fail validation. Returning false causes them to
	      // always pass validation.
	      parseValue: function parseValue() {
	        return false;
	      },
	      parseLiteral: function parseLiteral() {
	        return false;
	      }
	    });
	  }
	
	  function buildObjectDef(objectIntrospection) {
	    return new _definition.GraphQLObjectType({
	      name: objectIntrospection.name,
	      description: objectIntrospection.description,
	      interfaces: objectIntrospection.interfaces.map(getInterfaceType),
	      fields: function fields() {
	        return buildFieldDefMap(objectIntrospection);
	      }
	    });
	  }
	
	  function buildInterfaceDef(interfaceIntrospection) {
	    return new _definition.GraphQLInterfaceType({
	      name: interfaceIntrospection.name,
	      description: interfaceIntrospection.description,
	      fields: function fields() {
	        return buildFieldDefMap(interfaceIntrospection);
	      },
	      resolveType: cannotExecuteClientSchema
	    });
	  }
	
	  function buildUnionDef(unionIntrospection) {
	    return new _definition.GraphQLUnionType({
	      name: unionIntrospection.name,
	      description: unionIntrospection.description,
	      types: unionIntrospection.possibleTypes.map(getObjectType),
	      resolveType: cannotExecuteClientSchema
	    });
	  }
	
	  function buildEnumDef(enumIntrospection) {
	    return new _definition.GraphQLEnumType({
	      name: enumIntrospection.name,
	      description: enumIntrospection.description,
	      values: (0, _keyValMap2.default)(enumIntrospection.enumValues, function (valueIntrospection) {
	        return valueIntrospection.name;
	      }, function (valueIntrospection) {
	        return {
	          description: valueIntrospection.description,
	          deprecationReason: valueIntrospection.deprecationReason
	        };
	      })
	    });
	  }
	
	  function buildInputObjectDef(inputObjectIntrospection) {
	    return new _definition.GraphQLInputObjectType({
	      name: inputObjectIntrospection.name,
	      description: inputObjectIntrospection.description,
	      fields: function fields() {
	        return buildInputValueDefMap(inputObjectIntrospection.inputFields);
	      }
	    });
	  }
	
	  function buildFieldDefMap(typeIntrospection) {
	    return (0, _keyValMap2.default)(typeIntrospection.fields, function (fieldIntrospection) {
	      return fieldIntrospection.name;
	    }, function (fieldIntrospection) {
	      return {
	        description: fieldIntrospection.description,
	        deprecationReason: fieldIntrospection.deprecationReason,
	        type: getOutputType(fieldIntrospection.type),
	        args: buildInputValueDefMap(fieldIntrospection.args)
	      };
	    });
	  }
	
	  function buildInputValueDefMap(inputValueIntrospections) {
	    return (0, _keyValMap2.default)(inputValueIntrospections, function (inputValue) {
	      return inputValue.name;
	    }, buildInputValue);
	  }
	
	  function buildInputValue(inputValueIntrospection) {
	    var type = getInputType(inputValueIntrospection.type);
	    var defaultValue = inputValueIntrospection.defaultValue ? (0, _valueFromAST.valueFromAST)((0, _parser.parseValue)(inputValueIntrospection.defaultValue), type) : undefined;
	    return {
	      name: inputValueIntrospection.name,
	      description: inputValueIntrospection.description,
	      type: type,
	      defaultValue: defaultValue
	    };
	  }
	
	  function buildDirective(directiveIntrospection) {
	    // Support deprecated `on****` fields for building `locations`, as this
	    // is used by GraphiQL which may need to support outdated servers.
	    var locations = directiveIntrospection.locations ? directiveIntrospection.locations.slice() : [].concat(!directiveIntrospection.onField ? [] : [_directives.DirectiveLocation.FIELD], !directiveIntrospection.onOperation ? [] : [_directives.DirectiveLocation.QUERY, _directives.DirectiveLocation.MUTATION, _directives.DirectiveLocation.SUBSCRIPTION], !directiveIntrospection.onFragment ? [] : [_directives.DirectiveLocation.FRAGMENT_DEFINITION, _directives.DirectiveLocation.FRAGMENT_SPREAD, _directives.DirectiveLocation.INLINE_FRAGMENT]);
	    return new _directives.GraphQLDirective({
	      name: directiveIntrospection.name,
	      description: directiveIntrospection.description,
	      locations: locations,
	      args: buildInputValueDefMap(directiveIntrospection.args)
	    });
	  }
	
	  // Iterate through all types, getting the type definition for each, ensuring
	  // that any type not directly referenced by a field will get created.
	  var types = schemaIntrospection.types.map(function (typeIntrospection) {
	    return getNamedType(typeIntrospection.name);
	  });
	
	  // Get the root Query, Mutation, and Subscription types.
	  var queryType = getObjectType(schemaIntrospection.queryType);
	
	  var mutationType = schemaIntrospection.mutationType ? getObjectType(schemaIntrospection.mutationType) : null;
	
	  var subscriptionType = schemaIntrospection.subscriptionType ? getObjectType(schemaIntrospection.subscriptionType) : null;
	
	  // Get the directives supported by Introspection, assuming empty-set if
	  // directives were not queried for.
	  var directives = schemaIntrospection.directives ? schemaIntrospection.directives.map(buildDirective) : [];
	
	  // Then produce and return a Schema with these types.
	  return new _schema.GraphQLSchema({
	    query: queryType,
	    mutation: mutationType,
	    subscription: subscriptionType,
	    types: types,
	    directives: directives
	  });
	}
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function cannotExecuteClientSchema() {
	  throw new Error('Client Schema cannot use Interface or Union types for execution.');
	}

/***/ },

/***/ "./node_modules/graphql/jsutils/keyValMap.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = keyValMap;
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	/**
	 * Creates a keyed JS object from an array, given a function to produce the keys
	 * and a function to produce the values from each item in the array.
	 *
	 *     const phoneBook = [
	 *       { name: 'Jon', num: '555-1234' },
	 *       { name: 'Jenny', num: '867-5309' }
	 *     ]
	 *
	 *     // { Jon: '555-1234', Jenny: '867-5309' }
	 *     const phonesByName = keyValMap(
	 *       phoneBook,
	 *       entry => entry.name,
	 *       entry => entry.num
	 *     )
	 *
	 */
	function keyValMap(list, keyFn, valFn) {
	  return list.reduce(function (map, item) {
	    return map[keyFn(item)] = valFn(item), map;
	  }, {});
	}

/***/ },

/***/ "./node_modules/graphql/utilities/buildASTSchema.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buildASTSchema = buildASTSchema;
	exports.getDescription = getDescription;
	exports.buildSchema = buildSchema;
	
	var _find = __webpack_require__("./node_modules/graphql/jsutils/find.js");
	
	var _find2 = _interopRequireDefault(_find);
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _keyValMap = __webpack_require__("./node_modules/graphql/jsutils/keyValMap.js");
	
	var _keyValMap2 = _interopRequireDefault(_keyValMap);
	
	var _valueFromAST = __webpack_require__("./node_modules/graphql/utilities/valueFromAST.js");
	
	var _lexer = __webpack_require__("./node_modules/graphql/language/lexer.js");
	
	var _parser = __webpack_require__("./node_modules/graphql/language/parser.js");
	
	var _values = __webpack_require__("./node_modules/graphql/execution/values.js");
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	var _schema = __webpack_require__("./node_modules/graphql/type/schema.js");
	
	var _scalars = __webpack_require__("./node_modules/graphql/type/scalars.js");
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	var _directives = __webpack_require__("./node_modules/graphql/type/directives.js");
	
	var _introspection = __webpack_require__("./node_modules/graphql/type/introspection.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function buildWrappedType(innerType, inputTypeNode) {
	  if (inputTypeNode.kind === _kinds.LIST_TYPE) {
	    return new _definition.GraphQLList(buildWrappedType(innerType, inputTypeNode.type));
	  }
	  if (inputTypeNode.kind === _kinds.NON_NULL_TYPE) {
	    var wrappedType = buildWrappedType(innerType, inputTypeNode.type);
	    (0, _invariant2.default)(!(wrappedType instanceof _definition.GraphQLNonNull), 'No nesting nonnull.');
	    return new _definition.GraphQLNonNull(wrappedType);
	  }
	  return innerType;
	}
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function getNamedTypeNode(typeNode) {
	  var namedType = typeNode;
	  while (namedType.kind === _kinds.LIST_TYPE || namedType.kind === _kinds.NON_NULL_TYPE) {
	    namedType = namedType.type;
	  }
	  return namedType;
	}
	
	/**
	 * This takes the ast of a schema document produced by the parse function in
	 * src/language/parser.js.
	 *
	 * If no schema definition is provided, then it will look for types named Query
	 * and Mutation.
	 *
	 * Given that AST it constructs a GraphQLSchema. The resulting schema
	 * has no resolve methods, so execution will use default resolvers.
	 */
	function buildASTSchema(ast) {
	  if (!ast || ast.kind !== _kinds.DOCUMENT) {
	    throw new Error('Must provide a document ast.');
	  }
	
	  var schemaDef = void 0;
	
	  var typeDefs = [];
	  var nodeMap = Object.create(null);
	  var directiveDefs = [];
	  for (var i = 0; i < ast.definitions.length; i++) {
	    var d = ast.definitions[i];
	    switch (d.kind) {
	      case _kinds.SCHEMA_DEFINITION:
	        if (schemaDef) {
	          throw new Error('Must provide only one schema definition.');
	        }
	        schemaDef = d;
	        break;
	      case _kinds.SCALAR_TYPE_DEFINITION:
	      case _kinds.OBJECT_TYPE_DEFINITION:
	      case _kinds.INTERFACE_TYPE_DEFINITION:
	      case _kinds.ENUM_TYPE_DEFINITION:
	      case _kinds.UNION_TYPE_DEFINITION:
	      case _kinds.INPUT_OBJECT_TYPE_DEFINITION:
	        typeDefs.push(d);
	        nodeMap[d.name.value] = d;
	        break;
	      case _kinds.DIRECTIVE_DEFINITION:
	        directiveDefs.push(d);
	        break;
	    }
	  }
	
	  var queryTypeName = void 0;
	  var mutationTypeName = void 0;
	  var subscriptionTypeName = void 0;
	  if (schemaDef) {
	    schemaDef.operationTypes.forEach(function (operationType) {
	      var typeName = operationType.type.name.value;
	      if (operationType.operation === 'query') {
	        if (queryTypeName) {
	          throw new Error('Must provide only one query type in schema.');
	        }
	        if (!nodeMap[typeName]) {
	          throw new Error('Specified query type "' + typeName + '" not found in document.');
	        }
	        queryTypeName = typeName;
	      } else if (operationType.operation === 'mutation') {
	        if (mutationTypeName) {
	          throw new Error('Must provide only one mutation type in schema.');
	        }
	        if (!nodeMap[typeName]) {
	          throw new Error('Specified mutation type "' + typeName + '" not found in document.');
	        }
	        mutationTypeName = typeName;
	      } else if (operationType.operation === 'subscription') {
	        if (subscriptionTypeName) {
	          throw new Error('Must provide only one subscription type in schema.');
	        }
	        if (!nodeMap[typeName]) {
	          throw new Error('Specified subscription type "' + typeName + '" not found in document.');
	        }
	        subscriptionTypeName = typeName;
	      }
	    });
	  } else {
	    if (nodeMap.Query) {
	      queryTypeName = 'Query';
	    }
	    if (nodeMap.Mutation) {
	      mutationTypeName = 'Mutation';
	    }
	    if (nodeMap.Subscription) {
	      subscriptionTypeName = 'Subscription';
	    }
	  }
	
	  if (!queryTypeName) {
	    throw new Error('Must provide schema definition with query type or a type named Query.');
	  }
	
	  var innerTypeMap = {
	    String: _scalars.GraphQLString,
	    Int: _scalars.GraphQLInt,
	    Float: _scalars.GraphQLFloat,
	    Boolean: _scalars.GraphQLBoolean,
	    ID: _scalars.GraphQLID,
	    __Schema: _introspection.__Schema,
	    __Directive: _introspection.__Directive,
	    __DirectiveLocation: _introspection.__DirectiveLocation,
	    __Type: _introspection.__Type,
	    __Field: _introspection.__Field,
	    __InputValue: _introspection.__InputValue,
	    __EnumValue: _introspection.__EnumValue,
	    __TypeKind: _introspection.__TypeKind
	  };
	
	  var types = typeDefs.map(function (def) {
	    return typeDefNamed(def.name.value);
	  });
	
	  var directives = directiveDefs.map(getDirective);
	
	  // If specified directives were not explicitly declared, add them.
	  if (!directives.some(function (directive) {
	    return directive.name === 'skip';
	  })) {
	    directives.push(_directives.GraphQLSkipDirective);
	  }
	
	  if (!directives.some(function (directive) {
	    return directive.name === 'include';
	  })) {
	    directives.push(_directives.GraphQLIncludeDirective);
	  }
	
	  if (!directives.some(function (directive) {
	    return directive.name === 'deprecated';
	  })) {
	    directives.push(_directives.GraphQLDeprecatedDirective);
	  }
	
	  return new _schema.GraphQLSchema({
	    query: getObjectType(nodeMap[queryTypeName]),
	    mutation: mutationTypeName ? getObjectType(nodeMap[mutationTypeName]) : null,
	    subscription: subscriptionTypeName ? getObjectType(nodeMap[subscriptionTypeName]) : null,
	    types: types,
	    directives: directives
	  });
	
	  function getDirective(directiveNode) {
	    return new _directives.GraphQLDirective({
	      name: directiveNode.name.value,
	      description: getDescription(directiveNode),
	      locations: directiveNode.locations.map(function (node) {
	        return node.value;
	      }),
	      args: directiveNode.arguments && makeInputValues(directiveNode.arguments)
	    });
	  }
	
	  function getObjectType(typeNode) {
	    var type = typeDefNamed(typeNode.name.value);
	    (0, _invariant2.default)(type instanceof _definition.GraphQLObjectType, 'AST must provide object type.');
	    return type;
	  }
	
	  function produceType(typeNode) {
	    var typeName = getNamedTypeNode(typeNode).name.value;
	    var typeDef = typeDefNamed(typeName);
	    return buildWrappedType(typeDef, typeNode);
	  }
	
	  function produceInputType(typeNode) {
	    var type = produceType(typeNode);
	    (0, _invariant2.default)((0, _definition.isInputType)(type), 'Expected Input type.');
	    return type;
	  }
	
	  function produceOutputType(typeNode) {
	    var type = produceType(typeNode);
	    (0, _invariant2.default)((0, _definition.isOutputType)(type), 'Expected Output type.');
	    return type;
	  }
	
	  function produceObjectType(typeNode) {
	    var type = produceType(typeNode);
	    (0, _invariant2.default)(type instanceof _definition.GraphQLObjectType, 'Expected Object type.');
	    return type;
	  }
	
	  function produceInterfaceType(typeNode) {
	    var type = produceType(typeNode);
	    (0, _invariant2.default)(type instanceof _definition.GraphQLInterfaceType, 'Expected Object type.');
	    return type;
	  }
	
	  function typeDefNamed(typeName) {
	    if (innerTypeMap[typeName]) {
	      return innerTypeMap[typeName];
	    }
	
	    if (!nodeMap[typeName]) {
	      throw new Error('Type "' + typeName + '" not found in document.');
	    }
	
	    var innerTypeDef = makeSchemaDef(nodeMap[typeName]);
	    if (!innerTypeDef) {
	      throw new Error('Nothing constructed for "' + typeName + '".');
	    }
	    innerTypeMap[typeName] = innerTypeDef;
	    return innerTypeDef;
	  }
	
	  function makeSchemaDef(def) {
	    if (!def) {
	      throw new Error('def must be defined');
	    }
	    switch (def.kind) {
	      case _kinds.OBJECT_TYPE_DEFINITION:
	        return makeTypeDef(def);
	      case _kinds.INTERFACE_TYPE_DEFINITION:
	        return makeInterfaceDef(def);
	      case _kinds.ENUM_TYPE_DEFINITION:
	        return makeEnumDef(def);
	      case _kinds.UNION_TYPE_DEFINITION:
	        return makeUnionDef(def);
	      case _kinds.SCALAR_TYPE_DEFINITION:
	        return makeScalarDef(def);
	      case _kinds.INPUT_OBJECT_TYPE_DEFINITION:
	        return makeInputObjectDef(def);
	      default:
	        throw new Error('Type kind "' + def.kind + '" not supported.');
	    }
	  }
	
	  function makeTypeDef(def) {
	    var typeName = def.name.value;
	    return new _definition.GraphQLObjectType({
	      name: typeName,
	      description: getDescription(def),
	      fields: function fields() {
	        return makeFieldDefMap(def);
	      },
	      interfaces: function interfaces() {
	        return makeImplementedInterfaces(def);
	      }
	    });
	  }
	
	  function makeFieldDefMap(def) {
	    return (0, _keyValMap2.default)(def.fields, function (field) {
	      return field.name.value;
	    }, function (field) {
	      return {
	        type: produceOutputType(field.type),
	        description: getDescription(field),
	        args: makeInputValues(field.arguments),
	        deprecationReason: getDeprecationReason(field.directives)
	      };
	    });
	  }
	
	  function makeImplementedInterfaces(def) {
	    return def.interfaces && def.interfaces.map(function (iface) {
	      return produceInterfaceType(iface);
	    });
	  }
	
	  function makeInputValues(values) {
	    return (0, _keyValMap2.default)(values, function (value) {
	      return value.name.value;
	    }, function (value) {
	      var type = produceInputType(value.type);
	      return {
	        type: type,
	        description: getDescription(value),
	        defaultValue: (0, _valueFromAST.valueFromAST)(value.defaultValue, type)
	      };
	    });
	  }
	
	  function makeInterfaceDef(def) {
	    var typeName = def.name.value;
	    return new _definition.GraphQLInterfaceType({
	      name: typeName,
	      description: getDescription(def),
	      fields: function fields() {
	        return makeFieldDefMap(def);
	      },
	      resolveType: cannotExecuteSchema
	    });
	  }
	
	  function makeEnumDef(def) {
	    var enumType = new _definition.GraphQLEnumType({
	      name: def.name.value,
	      description: getDescription(def),
	      values: (0, _keyValMap2.default)(def.values, function (enumValue) {
	        return enumValue.name.value;
	      }, function (enumValue) {
	        return {
	          description: getDescription(enumValue),
	          deprecationReason: getDeprecationReason(enumValue.directives)
	        };
	      })
	    });
	
	    return enumType;
	  }
	
	  function makeUnionDef(def) {
	    return new _definition.GraphQLUnionType({
	      name: def.name.value,
	      description: getDescription(def),
	      types: def.types.map(function (t) {
	        return produceObjectType(t);
	      }),
	      resolveType: cannotExecuteSchema
	    });
	  }
	
	  function makeScalarDef(def) {
	    return new _definition.GraphQLScalarType({
	      name: def.name.value,
	      description: getDescription(def),
	      serialize: function serialize() {
	        return null;
	      },
	      // Note: validation calls the parse functions to determine if a
	      // literal value is correct. Returning null would cause use of custom
	      // scalars to always fail validation. Returning false causes them to
	      // always pass validation.
	      parseValue: function parseValue() {
	        return false;
	      },
	      parseLiteral: function parseLiteral() {
	        return false;
	      }
	    });
	  }
	
	  function makeInputObjectDef(def) {
	    return new _definition.GraphQLInputObjectType({
	      name: def.name.value,
	      description: getDescription(def),
	      fields: function fields() {
	        return makeInputValues(def.fields);
	      }
	    });
	  }
	}
	
	function getDeprecationReason(directives) {
	  var deprecatedAST = directives && (0, _find2.default)(directives, function (directive) {
	    return directive.name.value === _directives.GraphQLDeprecatedDirective.name;
	  });
	  if (!deprecatedAST) {
	    return;
	  }
	
	  var _getArgumentValues = (0, _values.getArgumentValues)(_directives.GraphQLDeprecatedDirective, deprecatedAST),
	      reason = _getArgumentValues.reason;
	
	  return reason;
	}
	
	/**
	 * Given an ast node, returns its string description based on a contiguous
	 * block full-line of comments preceding it.
	 */
	function getDescription(node) {
	  var loc = node.loc;
	  if (!loc) {
	    return;
	  }
	  var comments = [];
	  var minSpaces = void 0;
	  var token = loc.startToken.prev;
	  while (token && token.kind === _lexer.TokenKind.COMMENT && token.next && token.prev && token.line + 1 === token.next.line && token.line !== token.prev.line) {
	    var value = String(token.value);
	    var spaces = leadingSpaces(value);
	    if (minSpaces === undefined || spaces < minSpaces) {
	      minSpaces = spaces;
	    }
	    comments.push(value);
	    token = token.prev;
	  }
	  return comments.reverse().map(function (comment) {
	    return comment.slice(minSpaces);
	  }).join('\n');
	}
	
	/**
	 * A helper function to build a GraphQLSchema directly from a source
	 * document.
	 */
	function buildSchema(source) {
	  return buildASTSchema((0, _parser.parse)(source));
	}
	
	// Count the number of spaces on the starting side of a string.
	function leadingSpaces(str) {
	  var i = 0;
	  for (; i < str.length; i++) {
	    if (str[i] !== ' ') {
	      break;
	    }
	  }
	  return i;
	}
	
	function cannotExecuteSchema() {
	  throw new Error('Generated Schema cannot use Interface or Union types for execution.');
	}

/***/ },

/***/ "./node_modules/graphql/utilities/extendSchema.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.extendSchema = extendSchema;
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _keyMap = __webpack_require__("./node_modules/graphql/jsutils/keyMap.js");
	
	var _keyMap2 = _interopRequireDefault(_keyMap);
	
	var _keyValMap = __webpack_require__("./node_modules/graphql/jsutils/keyValMap.js");
	
	var _keyValMap2 = _interopRequireDefault(_keyValMap);
	
	var _buildASTSchema = __webpack_require__("./node_modules/graphql/utilities/buildASTSchema.js");
	
	var _valueFromAST = __webpack_require__("./node_modules/graphql/utilities/valueFromAST.js");
	
	var _GraphQLError = __webpack_require__("./node_modules/graphql/error/GraphQLError.js");
	
	var _schema = __webpack_require__("./node_modules/graphql/type/schema.js");
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	var _directives = __webpack_require__("./node_modules/graphql/type/directives.js");
	
	var _introspection = __webpack_require__("./node_modules/graphql/type/introspection.js");
	
	var _scalars = __webpack_require__("./node_modules/graphql/type/scalars.js");
	
	var _kinds = __webpack_require__("./node_modules/graphql/language/kinds.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Produces a new schema given an existing schema and a document which may
	 * contain GraphQL type extensions and definitions. The original schema will
	 * remain unaltered.
	 *
	 * Because a schema represents a graph of references, a schema cannot be
	 * extended without effectively making an entire copy. We do not know until it's
	 * too late if subgraphs remain unchanged.
	 *
	 * This algorithm copies the provided schema, applying extensions while
	 * producing the copy. The original schema remains unaltered.
	 */
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function extendSchema(schema, documentAST) {
	  (0, _invariant2.default)(schema instanceof _schema.GraphQLSchema, 'Must provide valid GraphQLSchema');
	
	  (0, _invariant2.default)(documentAST && documentAST.kind === _kinds.DOCUMENT, 'Must provide valid Document AST');
	
	  // Collect the type definitions and extensions found in the document.
	  var typeDefinitionMap = {};
	  var typeExtensionsMap = {};
	
	  // New directives and types are separate because a directives and types can
	  // have the same name. For example, a type named "skip".
	  var directiveDefinitions = [];
	
	  for (var i = 0; i < documentAST.definitions.length; i++) {
	    var def = documentAST.definitions[i];
	    switch (def.kind) {
	      case _kinds.OBJECT_TYPE_DEFINITION:
	      case _kinds.INTERFACE_TYPE_DEFINITION:
	      case _kinds.ENUM_TYPE_DEFINITION:
	      case _kinds.UNION_TYPE_DEFINITION:
	      case _kinds.SCALAR_TYPE_DEFINITION:
	      case _kinds.INPUT_OBJECT_TYPE_DEFINITION:
	        // Sanity check that none of the defined types conflict with the
	        // schema's existing types.
	        var typeName = def.name.value;
	        if (schema.getType(typeName)) {
	          throw new _GraphQLError.GraphQLError('Type "' + typeName + '" already exists in the schema. It cannot also ' + 'be defined in this type definition.', [def]);
	        }
	        typeDefinitionMap[typeName] = def;
	        break;
	      case _kinds.TYPE_EXTENSION_DEFINITION:
	        // Sanity check that this type extension exists within the
	        // schema's existing types.
	        var extendedTypeName = def.definition.name.value;
	        var existingType = schema.getType(extendedTypeName);
	        if (!existingType) {
	          throw new _GraphQLError.GraphQLError('Cannot extend type "' + extendedTypeName + '" because it does not ' + 'exist in the existing schema.', [def.definition]);
	        }
	        if (!(existingType instanceof _definition.GraphQLObjectType)) {
	          throw new _GraphQLError.GraphQLError('Cannot extend non-object type "' + extendedTypeName + '".', [def.definition]);
	        }
	        var extensions = typeExtensionsMap[extendedTypeName];
	        if (extensions) {
	          extensions.push(def);
	        } else {
	          extensions = [def];
	        }
	        typeExtensionsMap[extendedTypeName] = extensions;
	        break;
	      case _kinds.DIRECTIVE_DEFINITION:
	        var directiveName = def.name.value;
	        var existingDirective = schema.getDirective(directiveName);
	        if (existingDirective) {
	          throw new _GraphQLError.GraphQLError('Directive "' + directiveName + '" already exists in the schema. It ' + 'cannot be redefined.', [def]);
	        }
	        directiveDefinitions.push(def);
	        break;
	    }
	  }
	
	  // If this document contains no new types, extensions, or directives then
	  // return the same unmodified GraphQLSchema instance.
	  if (Object.keys(typeExtensionsMap).length === 0 && Object.keys(typeDefinitionMap).length === 0 && directiveDefinitions.length === 0) {
	    return schema;
	  }
	
	  // A cache to use to store the actual GraphQLType definition objects by name.
	  // Initialize to the GraphQL built in scalars and introspection types. All
	  // functions below are inline so that this type def cache is within the scope
	  // of the closure.
	  var typeDefCache = {
	    String: _scalars.GraphQLString,
	    Int: _scalars.GraphQLInt,
	    Float: _scalars.GraphQLFloat,
	    Boolean: _scalars.GraphQLBoolean,
	    ID: _scalars.GraphQLID,
	    __Schema: _introspection.__Schema,
	    __Directive: _introspection.__Directive,
	    __DirectiveLocation: _introspection.__DirectiveLocation,
	    __Type: _introspection.__Type,
	    __Field: _introspection.__Field,
	    __InputValue: _introspection.__InputValue,
	    __EnumValue: _introspection.__EnumValue,
	    __TypeKind: _introspection.__TypeKind
	  };
	
	  // Get the root Query, Mutation, and Subscription object types.
	  var queryType = getTypeFromDef(schema.getQueryType());
	
	  var existingMutationType = schema.getMutationType();
	  var mutationType = existingMutationType ? getTypeFromDef(existingMutationType) : null;
	
	  var existingSubscriptionType = schema.getSubscriptionType();
	  var subscriptionType = existingSubscriptionType ? getTypeFromDef(existingSubscriptionType) : null;
	
	  // Iterate through all types, getting the type definition for each, ensuring
	  // that any type not directly referenced by a field will get created.
	  var typeMap = schema.getTypeMap();
	  var types = Object.keys(typeMap).map(function (typeName) {
	    return getTypeFromDef(typeMap[typeName]);
	  });
	
	  // Do the same with new types, appending to the list of defined types.
	  Object.keys(typeDefinitionMap).forEach(function (typeName) {
	    types.push(getTypeFromAST(typeDefinitionMap[typeName]));
	  });
	
	  // Then produce and return a Schema with these types.
	  return new _schema.GraphQLSchema({
	    query: queryType,
	    mutation: mutationType,
	    subscription: subscriptionType,
	    types: types,
	    directives: getMergedDirectives()
	  });
	
	  // Below are functions used for producing this schema that have closed over
	  // this scope and have access to the schema, cache, and newly defined types.
	
	  function getMergedDirectives() {
	    var existingDirectives = schema.getDirectives();
	    (0, _invariant2.default)(existingDirectives, 'schema must have default directives');
	
	    var newDirectives = directiveDefinitions.map(function (directiveNode) {
	      return getDirective(directiveNode);
	    });
	    return existingDirectives.concat(newDirectives);
	  }
	
	  function getTypeFromDef(typeDef) {
	    var type = _getNamedType(typeDef.name);
	    (0, _invariant2.default)(type, 'Missing type from schema');
	    return type;
	  }
	
	  function getTypeFromAST(node) {
	    var type = _getNamedType(node.name.value);
	    if (!type) {
	      throw new _GraphQLError.GraphQLError('Unknown type: "' + node.name.value + '". Ensure that this type exists ' + 'either in the original schema, or is added in a type definition.', [node]);
	    }
	    return type;
	  }
	
	  function getObjectTypeFromAST(node) {
	    var type = getTypeFromAST(node);
	    (0, _invariant2.default)(type instanceof _definition.GraphQLObjectType, 'Must be Object type.');
	    return type;
	  }
	
	  function getInterfaceTypeFromAST(node) {
	    var type = getTypeFromAST(node);
	    (0, _invariant2.default)(type instanceof _definition.GraphQLInterfaceType, 'Must be Interface type.');
	    return type;
	  }
	
	  function getInputTypeFromAST(node) {
	    var type = getTypeFromAST(node);
	    (0, _invariant2.default)((0, _definition.isInputType)(type), 'Must be Input type.');
	    return type;
	  }
	
	  function getOutputTypeFromAST(node) {
	    var type = getTypeFromAST(node);
	    (0, _invariant2.default)((0, _definition.isOutputType)(type), 'Must be Output type.');
	    return type;
	  }
	
	  // Given a name, returns a type from either the existing schema or an
	  // added type.
	  function _getNamedType(typeName) {
	    var cachedTypeDef = typeDefCache[typeName];
	    if (cachedTypeDef) {
	      return cachedTypeDef;
	    }
	
	    var existingType = schema.getType(typeName);
	    if (existingType) {
	      var typeDef = extendType(existingType);
	      typeDefCache[typeName] = typeDef;
	      return typeDef;
	    }
	
	    var typeNode = typeDefinitionMap[typeName];
	    if (typeNode) {
	      var _typeDef = buildType(typeNode);
	      typeDefCache[typeName] = _typeDef;
	      return _typeDef;
	    }
	  }
	
	  // Given a type's introspection result, construct the correct
	  // GraphQLType instance.
	  function extendType(type) {
	    if (type instanceof _definition.GraphQLObjectType) {
	      return extendObjectType(type);
	    }
	    if (type instanceof _definition.GraphQLInterfaceType) {
	      return extendInterfaceType(type);
	    }
	    if (type instanceof _definition.GraphQLUnionType) {
	      return extendUnionType(type);
	    }
	    return type;
	  }
	
	  function extendObjectType(type) {
	    return new _definition.GraphQLObjectType({
	      name: type.name,
	      description: type.description,
	      interfaces: function interfaces() {
	        return extendImplementedInterfaces(type);
	      },
	      fields: function fields() {
	        return extendFieldMap(type);
	      },
	      isTypeOf: type.isTypeOf
	    });
	  }
	
	  function extendInterfaceType(type) {
	    return new _definition.GraphQLInterfaceType({
	      name: type.name,
	      description: type.description,
	      fields: function fields() {
	        return extendFieldMap(type);
	      },
	      resolveType: type.resolveType
	    });
	  }
	
	  function extendUnionType(type) {
	    return new _definition.GraphQLUnionType({
	      name: type.name,
	      description: type.description,
	      types: type.getTypes().map(getTypeFromDef),
	      resolveType: type.resolveType
	    });
	  }
	
	  function extendImplementedInterfaces(type) {
	    var interfaces = type.getInterfaces().map(getTypeFromDef);
	
	    // If there are any extensions to the interfaces, apply those here.
	    var extensions = typeExtensionsMap[type.name];
	    if (extensions) {
	      extensions.forEach(function (extension) {
	        extension.definition.interfaces.forEach(function (namedType) {
	          var interfaceName = namedType.name.value;
	          if (interfaces.some(function (def) {
	            return def.name === interfaceName;
	          })) {
	            throw new _GraphQLError.GraphQLError('Type "' + type.name + '" already implements "' + interfaceName + '". ' + 'It cannot also be implemented in this type extension.', [namedType]);
	          }
	          interfaces.push(getInterfaceTypeFromAST(namedType));
	        });
	      });
	    }
	
	    return interfaces;
	  }
	
	  function extendFieldMap(type) {
	    var newFieldMap = {};
	    var oldFieldMap = type.getFields();
	    Object.keys(oldFieldMap).forEach(function (fieldName) {
	      var field = oldFieldMap[fieldName];
	      newFieldMap[fieldName] = {
	        description: field.description,
	        deprecationReason: field.deprecationReason,
	        type: extendFieldType(field.type),
	        args: (0, _keyMap2.default)(field.args, function (arg) {
	          return arg.name;
	        }),
	        resolve: field.resolve
	      };
	    });
	
	    // If there are any extensions to the fields, apply those here.
	    var extensions = typeExtensionsMap[type.name];
	    if (extensions) {
	      extensions.forEach(function (extension) {
	        extension.definition.fields.forEach(function (field) {
	          var fieldName = field.name.value;
	          if (oldFieldMap[fieldName]) {
	            throw new _GraphQLError.GraphQLError('Field "' + type.name + '.' + fieldName + '" already exists in the ' + 'schema. It cannot also be defined in this type extension.', [field]);
	          }
	          newFieldMap[fieldName] = {
	            description: (0, _buildASTSchema.getDescription)(field),
	            type: buildOutputFieldType(field.type),
	            args: buildInputValues(field.arguments)
	          };
	        });
	      });
	    }
	
	    return newFieldMap;
	  }
	
	  function extendFieldType(typeDef) {
	    if (typeDef instanceof _definition.GraphQLList) {
	      return new _definition.GraphQLList(extendFieldType(typeDef.ofType));
	    }
	    if (typeDef instanceof _definition.GraphQLNonNull) {
	      return new _definition.GraphQLNonNull(extendFieldType(typeDef.ofType));
	    }
	    return getTypeFromDef(typeDef);
	  }
	
	  function buildType(typeNode) {
	    switch (typeNode.kind) {
	      case _kinds.OBJECT_TYPE_DEFINITION:
	        return buildObjectType(typeNode);
	      case _kinds.INTERFACE_TYPE_DEFINITION:
	        return buildInterfaceType(typeNode);
	      case _kinds.UNION_TYPE_DEFINITION:
	        return buildUnionType(typeNode);
	      case _kinds.SCALAR_TYPE_DEFINITION:
	        return buildScalarType(typeNode);
	      case _kinds.ENUM_TYPE_DEFINITION:
	        return buildEnumType(typeNode);
	      case _kinds.INPUT_OBJECT_TYPE_DEFINITION:
	        return buildInputObjectType(typeNode);
	    }
	    throw new TypeError('Unknown type kind ' + typeNode.kind);
	  }
	
	  function buildObjectType(typeNode) {
	    return new _definition.GraphQLObjectType({
	      name: typeNode.name.value,
	      description: (0, _buildASTSchema.getDescription)(typeNode),
	      interfaces: function interfaces() {
	        return buildImplementedInterfaces(typeNode);
	      },
	      fields: function fields() {
	        return buildFieldMap(typeNode);
	      }
	    });
	  }
	
	  function buildInterfaceType(typeNode) {
	    return new _definition.GraphQLInterfaceType({
	      name: typeNode.name.value,
	      description: (0, _buildASTSchema.getDescription)(typeNode),
	      fields: function fields() {
	        return buildFieldMap(typeNode);
	      },
	      resolveType: cannotExecuteExtendedSchema
	    });
	  }
	
	  function buildUnionType(typeNode) {
	    return new _definition.GraphQLUnionType({
	      name: typeNode.name.value,
	      description: (0, _buildASTSchema.getDescription)(typeNode),
	      types: typeNode.types.map(getObjectTypeFromAST),
	      resolveType: cannotExecuteExtendedSchema
	    });
	  }
	
	  function buildScalarType(typeNode) {
	    return new _definition.GraphQLScalarType({
	      name: typeNode.name.value,
	      description: (0, _buildASTSchema.getDescription)(typeNode),
	      serialize: function serialize(id) {
	        return id;
	      },
	      // Note: validation calls the parse functions to determine if a
	      // literal value is correct. Returning null would cause use of custom
	      // scalars to always fail validation. Returning false causes them to
	      // always pass validation.
	      parseValue: function parseValue() {
	        return false;
	      },
	      parseLiteral: function parseLiteral() {
	        return false;
	      }
	    });
	  }
	
	  function buildEnumType(typeNode) {
	    return new _definition.GraphQLEnumType({
	      name: typeNode.name.value,
	      description: (0, _buildASTSchema.getDescription)(typeNode),
	      values: (0, _keyValMap2.default)(typeNode.values, function (v) {
	        return v.name.value;
	      }, function () {
	        return {};
	      })
	    });
	  }
	
	  function buildInputObjectType(typeNode) {
	    return new _definition.GraphQLInputObjectType({
	      name: typeNode.name.value,
	      description: (0, _buildASTSchema.getDescription)(typeNode),
	      fields: function fields() {
	        return buildInputValues(typeNode.fields);
	      }
	    });
	  }
	
	  function getDirective(directiveNode) {
	    return new _directives.GraphQLDirective({
	      name: directiveNode.name.value,
	      locations: directiveNode.locations.map(function (node) {
	        return node.value;
	      }),
	      args: directiveNode.arguments && buildInputValues(directiveNode.arguments)
	    });
	  }
	
	  function buildImplementedInterfaces(typeNode) {
	    return typeNode.interfaces && typeNode.interfaces.map(getInterfaceTypeFromAST);
	  }
	
	  function buildFieldMap(typeNode) {
	    return (0, _keyValMap2.default)(typeNode.fields, function (field) {
	      return field.name.value;
	    }, function (field) {
	      return {
	        type: buildOutputFieldType(field.type),
	        description: (0, _buildASTSchema.getDescription)(field),
	        args: buildInputValues(field.arguments)
	      };
	    });
	  }
	
	  function buildInputValues(values) {
	    return (0, _keyValMap2.default)(values, function (value) {
	      return value.name.value;
	    }, function (value) {
	      var type = buildInputFieldType(value.type);
	      return {
	        type: type,
	        description: (0, _buildASTSchema.getDescription)(value),
	        defaultValue: (0, _valueFromAST.valueFromAST)(value.defaultValue, type)
	      };
	    });
	  }
	
	  function buildInputFieldType(typeNode) {
	    if (typeNode.kind === _kinds.LIST_TYPE) {
	      return new _definition.GraphQLList(buildInputFieldType(typeNode.type));
	    }
	    if (typeNode.kind === _kinds.NON_NULL_TYPE) {
	      var nullableType = buildInputFieldType(typeNode.type);
	      (0, _invariant2.default)(!(nullableType instanceof _definition.GraphQLNonNull), 'Must be nullable');
	      return new _definition.GraphQLNonNull(nullableType);
	    }
	    return getInputTypeFromAST(typeNode);
	  }
	
	  function buildOutputFieldType(typeNode) {
	    if (typeNode.kind === _kinds.LIST_TYPE) {
	      return new _definition.GraphQLList(buildOutputFieldType(typeNode.type));
	    }
	    if (typeNode.kind === _kinds.NON_NULL_TYPE) {
	      var nullableType = buildOutputFieldType(typeNode.type);
	      (0, _invariant2.default)(!(nullableType instanceof _definition.GraphQLNonNull), 'Must be nullable');
	      return new _definition.GraphQLNonNull(nullableType);
	    }
	    return getOutputTypeFromAST(typeNode);
	  }
	}
	
	function cannotExecuteExtendedSchema() {
	  throw new Error('Extended Schema cannot use Interface or Union types for execution.');
	}

/***/ },

/***/ "./node_modules/graphql/utilities/schemaPrinter.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.printSchema = printSchema;
	exports.printIntrospectionSchema = printIntrospectionSchema;
	exports.printType = printType;
	
	var _invariant = __webpack_require__("./node_modules/graphql/jsutils/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isNullish = __webpack_require__("./node_modules/graphql/jsutils/isNullish.js");
	
	var _isNullish2 = _interopRequireDefault(_isNullish);
	
	var _isInvalid = __webpack_require__("./node_modules/graphql/jsutils/isInvalid.js");
	
	var _isInvalid2 = _interopRequireDefault(_isInvalid);
	
	var _astFromValue = __webpack_require__("./node_modules/graphql/utilities/astFromValue.js");
	
	var _printer = __webpack_require__("./node_modules/graphql/language/printer.js");
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	var _scalars = __webpack_require__("./node_modules/graphql/type/scalars.js");
	
	var _directives = __webpack_require__("./node_modules/graphql/type/directives.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	function printSchema(schema) {
	  return printFilteredSchema(schema, function (n) {
	    return !isSpecDirective(n);
	  }, isDefinedType);
	}
	
	function printIntrospectionSchema(schema) {
	  return printFilteredSchema(schema, isSpecDirective, isIntrospectionType);
	}
	
	function isSpecDirective(directiveName) {
	  return directiveName === 'skip' || directiveName === 'include' || directiveName === 'deprecated';
	}
	
	function isDefinedType(typename) {
	  return !isIntrospectionType(typename) && !isBuiltInScalar(typename);
	}
	
	function isIntrospectionType(typename) {
	  return typename.indexOf('__') === 0;
	}
	
	function isBuiltInScalar(typename) {
	  return typename === 'String' || typename === 'Boolean' || typename === 'Int' || typename === 'Float' || typename === 'ID';
	}
	
	function printFilteredSchema(schema, directiveFilter, typeFilter) {
	  var directives = schema.getDirectives().filter(function (directive) {
	    return directiveFilter(directive.name);
	  });
	  var typeMap = schema.getTypeMap();
	  var types = Object.keys(typeMap).filter(typeFilter).sort(function (name1, name2) {
	    return name1.localeCompare(name2);
	  }).map(function (typeName) {
	    return typeMap[typeName];
	  });
	
	  return [printSchemaDefinition(schema)].concat(directives.map(printDirective), types.map(printType)).filter(Boolean).join('\n\n') + '\n';
	}
	
	function printSchemaDefinition(schema) {
	  if (isSchemaOfCommonNames(schema)) {
	    return;
	  }
	
	  var operationTypes = [];
	
	  var queryType = schema.getQueryType();
	  if (queryType) {
	    operationTypes.push('  query: ' + queryType.name);
	  }
	
	  var mutationType = schema.getMutationType();
	  if (mutationType) {
	    operationTypes.push('  mutation: ' + mutationType.name);
	  }
	
	  var subscriptionType = schema.getSubscriptionType();
	  if (subscriptionType) {
	    operationTypes.push('  subscription: ' + subscriptionType.name);
	  }
	
	  return 'schema {\n' + operationTypes.join('\n') + '\n}';
	}
	
	/**
	 * GraphQL schema define root types for each type of operation. These types are
	 * the same as any other type and can be named in any manner, however there is
	 * a common naming convention:
	 *
	 *   schema {
	 *     query: Query
	 *     mutation: Mutation
	 *   }
	 *
	 * When using this naming convention, the schema description can be omitted.
	 */
	function isSchemaOfCommonNames(schema) {
	  var queryType = schema.getQueryType();
	  if (queryType && queryType.name !== 'Query') {
	    return false;
	  }
	
	  var mutationType = schema.getMutationType();
	  if (mutationType && mutationType.name !== 'Mutation') {
	    return false;
	  }
	
	  var subscriptionType = schema.getSubscriptionType();
	  if (subscriptionType && subscriptionType.name !== 'Subscription') {
	    return false;
	  }
	
	  return true;
	}
	
	function printType(type) {
	  if (type instanceof _definition.GraphQLScalarType) {
	    return printScalar(type);
	  } else if (type instanceof _definition.GraphQLObjectType) {
	    return printObject(type);
	  } else if (type instanceof _definition.GraphQLInterfaceType) {
	    return printInterface(type);
	  } else if (type instanceof _definition.GraphQLUnionType) {
	    return printUnion(type);
	  } else if (type instanceof _definition.GraphQLEnumType) {
	    return printEnum(type);
	  }
	  (0, _invariant2.default)(type instanceof _definition.GraphQLInputObjectType);
	  return printInputObject(type);
	}
	
	function printScalar(type) {
	  return printDescription(type) + ('scalar ' + type.name);
	}
	
	function printObject(type) {
	  var interfaces = type.getInterfaces();
	  var implementedInterfaces = interfaces.length ? ' implements ' + interfaces.map(function (i) {
	    return i.name;
	  }).join(', ') : '';
	  return printDescription(type) + ('type ' + type.name + implementedInterfaces + ' {\n') + printFields(type) + '\n' + '}';
	}
	
	function printInterface(type) {
	  return printDescription(type) + ('interface ' + type.name + ' {\n') + printFields(type) + '\n' + '}';
	}
	
	function printUnion(type) {
	  return printDescription(type) + ('union ' + type.name + ' = ' + type.getTypes().join(' | '));
	}
	
	function printEnum(type) {
	  return printDescription(type) + ('enum ' + type.name + ' {\n') + printEnumValues(type.getValues()) + '\n' + '}';
	}
	
	function printEnumValues(values) {
	  return values.map(function (value, i) {
	    return printDescription(value, '  ', !i) + '  ' + value.name + printDeprecated(value);
	  }).join('\n');
	}
	
	function printInputObject(type) {
	  var fieldMap = type.getFields();
	  var fields = Object.keys(fieldMap).map(function (fieldName) {
	    return fieldMap[fieldName];
	  });
	  return printDescription(type) + ('input ' + type.name + ' {\n') + fields.map(function (f, i) {
	    return printDescription(f, '  ', !i) + '  ' + printInputValue(f);
	  }).join('\n') + '\n' + '}';
	}
	
	function printFields(type) {
	  var fieldMap = type.getFields();
	  var fields = Object.keys(fieldMap).map(function (fieldName) {
	    return fieldMap[fieldName];
	  });
	  return fields.map(function (f, i) {
	    return printDescription(f, '  ', !i) + '  ' + f.name + printArgs(f.args, '  ') + ': ' + String(f.type) + printDeprecated(f);
	  }).join('\n');
	}
	
	function printArgs(args) {
	  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  if (args.length === 0) {
	    return '';
	  }
	
	  // If every arg does not have a description, print them on one line.
	  if (args.every(function (arg) {
	    return !arg.description;
	  })) {
	    return '(' + args.map(printInputValue).join(', ') + ')';
	  }
	
	  return '(\n' + args.map(function (arg, i) {
	    return printDescription(arg, '  ' + indentation, !i) + '  ' + indentation + printInputValue(arg);
	  }).join('\n') + '\n' + indentation + ')';
	}
	
	function printInputValue(arg) {
	  var argDecl = arg.name + ': ' + String(arg.type);
	  if (!(0, _isInvalid2.default)(arg.defaultValue)) {
	    argDecl += ' = ' + (0, _printer.print)((0, _astFromValue.astFromValue)(arg.defaultValue, arg.type));
	  }
	  return argDecl;
	}
	
	function printDirective(directive) {
	  return printDescription(directive) + 'directive @' + directive.name + printArgs(directive.args) + ' on ' + directive.locations.join(' | ');
	}
	
	function printDeprecated(fieldOrEnumVal) {
	  var reason = fieldOrEnumVal.deprecationReason;
	  if ((0, _isNullish2.default)(reason)) {
	    return '';
	  }
	  if (reason === '' || reason === _directives.DEFAULT_DEPRECATION_REASON) {
	    return ' @deprecated';
	  }
	  return ' @deprecated(reason: ' + (0, _printer.print)((0, _astFromValue.astFromValue)(reason, _scalars.GraphQLString)) + ')';
	}
	
	function printDescription(def) {
	  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var firstInBlock = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!def.description) {
	    return '';
	  }
	  var lines = def.description.split('\n');
	  var description = indentation && !firstInBlock ? '\n' : '';
	  for (var i = 0; i < lines.length; i++) {
	    if (lines[i] === '') {
	      description += indentation + '#\n';
	    } else {
	      // For > 120 character long lines, cut at space boundaries into sublines
	      // of ~80 chars.
	      var sublines = breakLine(lines[i], 120 - indentation.length);
	      for (var j = 0; j < sublines.length; j++) {
	        description += indentation + '# ' + sublines[j] + '\n';
	      }
	    }
	  }
	  return description;
	}
	
	function breakLine(line, len) {
	  if (line.length < len + 5) {
	    return [line];
	  }
	  var parts = line.split(new RegExp('((?: |^).{15,' + (len - 40) + '}(?= |$))'));
	  if (parts.length < 4) {
	    return [line];
	  }
	  var sublines = [parts[0] + parts[1] + parts[2]];
	  for (var i = 3; i < parts.length; i += 2) {
	    sublines.push(parts[i].slice(1) + parts[i + 1]);
	  }
	  return sublines;
	}

/***/ },

/***/ "./node_modules/graphql/utilities/concatAST.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.concatAST = concatAST;
	
	
	/**
	 * Provided a collection of ASTs, presumably each from different files,
	 * concatenate the ASTs together into batched AST, useful for validating many
	 * GraphQL source files which together represent one conceptual application.
	 */
	function concatAST(asts) {
	  var batchDefinitions = [];
	  for (var i = 0; i < asts.length; i++) {
	    var definitions = asts[i].definitions;
	    for (var j = 0; j < definitions.length; j++) {
	      batchDefinitions.push(definitions[j]);
	    }
	  }
	  return {
	    kind: 'Document',
	    definitions: batchDefinitions
	  };
	}
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */

/***/ },

/***/ "./node_modules/graphql/utilities/separateOperations.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.separateOperations = separateOperations;
	
	var _visitor = __webpack_require__("./node_modules/graphql/language/visitor.js");
	
	/**
	 * separateOperations accepts a single AST document which may contain many
	 * operations and fragments and returns a collection of AST documents each of
	 * which contains a single operation as well the fragment definitions it
	 * refers to.
	 */
	function separateOperations(documentAST) {
	
	  var operations = [];
	  var depGraph = Object.create(null);
	  var fromName = void 0;
	
	  // Populate the list of operations and build a dependency graph.
	  (0, _visitor.visit)(documentAST, {
	    OperationDefinition: function OperationDefinition(node) {
	      operations.push(node);
	      fromName = opName(node);
	    },
	    FragmentDefinition: function FragmentDefinition(node) {
	      fromName = node.name.value;
	    },
	    FragmentSpread: function FragmentSpread(node) {
	      var toName = node.name.value;
	      (depGraph[fromName] || (depGraph[fromName] = Object.create(null)))[toName] = true;
	    }
	  });
	
	  // For each operation, produce a new synthesized AST which includes only what
	  // is necessary for completing that operation.
	  var separatedDocumentASTs = Object.create(null);
	  operations.forEach(function (operation) {
	    var operationName = opName(operation);
	    var dependencies = Object.create(null);
	    collectTransitiveDependencies(dependencies, depGraph, operationName);
	
	    separatedDocumentASTs[operationName] = {
	      kind: 'Document',
	      definitions: documentAST.definitions.filter(function (def) {
	        return def === operation || def.kind === 'FragmentDefinition' && dependencies[def.name.value];
	      })
	    };
	  });
	
	  return separatedDocumentASTs;
	}
	/**
	 *  Copyright (c) 2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Provides the empty string for anonymous operations.
	function opName(operation) {
	  return operation.name ? operation.name.value : '';
	}
	
	// From a dependency graph, collects a list of transitive dependencies by
	// recursing through a dependency graph.
	function collectTransitiveDependencies(collected, depGraph, fromName) {
	  var immediateDeps = depGraph[fromName];
	  if (immediateDeps) {
	    Object.keys(immediateDeps).forEach(function (toName) {
	      if (!collected[toName]) {
	        collected[toName] = true;
	        collectTransitiveDependencies(collected, depGraph, toName);
	      }
	    });
	  }
	}

/***/ },

/***/ "./node_modules/graphql/utilities/findBreakingChanges.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BreakingChangeType = undefined;
	exports.findBreakingChanges = findBreakingChanges;
	exports.findRemovedTypes = findRemovedTypes;
	exports.findTypesThatChangedKind = findTypesThatChangedKind;
	exports.findFieldsThatChangedType = findFieldsThatChangedType;
	exports.findTypesRemovedFromUnions = findTypesRemovedFromUnions;
	exports.findValuesRemovedFromEnums = findValuesRemovedFromEnums;
	
	var _definition = __webpack_require__("./node_modules/graphql/type/definition.js");
	
	var _schema = __webpack_require__("./node_modules/graphql/type/schema.js");
	
	/**
	 *  Copyright (c) 2016, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	var BreakingChangeType = exports.BreakingChangeType = {
	  FIELD_CHANGED_KIND: 'FIELD_CHANGED_KIND',
	  FIELD_REMOVED: 'FIELD_REMOVED',
	  TYPE_CHANGED_KIND: 'TYPE_CHANGED_KIND',
	  TYPE_REMOVED: 'TYPE_REMOVED',
	  TYPE_REMOVED_FROM_UNION: 'TYPE_REMOVED_FROM_UNION',
	  VALUE_REMOVED_FROM_ENUM: 'VALUE_REMOVED_FROM_ENUM'
	};
	
	/**
	 * Given two schemas, returns an Array containing descriptions of all the types
	 * of breaking changes covered by the other functions down below.
	 */
	function findBreakingChanges(oldSchema, newSchema) {
	  return [].concat(findRemovedTypes(oldSchema, newSchema), findTypesThatChangedKind(oldSchema, newSchema), findFieldsThatChangedType(oldSchema, newSchema), findTypesRemovedFromUnions(oldSchema, newSchema), findValuesRemovedFromEnums(oldSchema, newSchema));
	}
	
	/**
	 * Given two schemas, returns an Array containing descriptions of any breaking
	 * changes in the newSchema related to removing an entire type.
	 */
	function findRemovedTypes(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	
	  var breakingChanges = [];
	  Object.keys(oldTypeMap).forEach(function (typeName) {
	    if (!newTypeMap[typeName]) {
	      breakingChanges.push({
	        type: BreakingChangeType.TYPE_REMOVED,
	        description: typeName + ' was removed.'
	      });
	    }
	  });
	  return breakingChanges;
	}
	
	/**
	 * Given two schemas, returns an Array containing descriptions of any breaking
	 * changes in the newSchema related to changing the type of a type.
	 */
	function findTypesThatChangedKind(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	
	  var breakingChanges = [];
	  Object.keys(oldTypeMap).forEach(function (typeName) {
	    if (!newTypeMap[typeName]) {
	      return;
	    }
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	    if (!(oldType instanceof newType.constructor)) {
	      breakingChanges.push({
	        type: BreakingChangeType.TYPE_CHANGED_KIND,
	        description: typeName + ' changed from ' + (typeKindName(oldType) + ' to ' + typeKindName(newType) + '.')
	      });
	    }
	  });
	  return breakingChanges;
	}
	
	function typeKindName(type) {
	  if (type instanceof _definition.GraphQLScalarType) {
	    return 'a Scalar type';
	  }
	  if (type instanceof _definition.GraphQLObjectType) {
	    return 'an Object type';
	  }
	  if (type instanceof _definition.GraphQLInterfaceType) {
	    return 'an Interface type';
	  }
	  if (type instanceof _definition.GraphQLUnionType) {
	    return 'a Union type';
	  }
	  if (type instanceof _definition.GraphQLEnumType) {
	    return 'an Enum type';
	  }
	  if (type instanceof _definition.GraphQLInputObjectType) {
	    return 'an Input type';
	  }
	  throw new TypeError('Unknown type ' + type.constructor.name);
	}
	
	/**
	 * Given two schemas, returns an Array containing descriptions of any breaking
	 * changes in the newSchema related to the fields on a type. This includes if
	 * a field has been removed from a type or if a field has changed type.
	 */
	function findFieldsThatChangedType(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	
	  var breakingFieldChanges = [];
	  Object.keys(oldTypeMap).forEach(function (typeName) {
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	    if (!(oldType instanceof _definition.GraphQLObjectType || oldType instanceof _definition.GraphQLInterfaceType || oldType instanceof _definition.GraphQLInputObjectType) || !(newType instanceof oldType.constructor)) {
	      return;
	    }
	
	    var oldTypeFieldsDef = oldType.getFields();
	    var newTypeFieldsDef = newType.getFields();
	    Object.keys(oldTypeFieldsDef).forEach(function (fieldName) {
	      // Check if the field is missing on the type in the new schema.
	      if (!(fieldName in newTypeFieldsDef)) {
	        breakingFieldChanges.push({
	          type: BreakingChangeType.FIELD_REMOVED,
	          description: typeName + '.' + fieldName + ' was removed.'
	        });
	      } else {
	        // Check if the field's type has changed in the new schema.
	        var oldFieldType = (0, _definition.getNamedType)(oldTypeFieldsDef[fieldName].type);
	        var newFieldType = (0, _definition.getNamedType)(newTypeFieldsDef[fieldName].type);
	        if (oldFieldType && newFieldType && oldFieldType.name !== newFieldType.name) {
	          breakingFieldChanges.push({
	            type: BreakingChangeType.FIELD_CHANGED_KIND,
	            description: typeName + '.' + fieldName + ' changed type from ' + (oldFieldType.name + ' to ' + newFieldType.name + '.')
	          });
	        }
	      }
	    });
	  });
	  return breakingFieldChanges;
	}
	
	/**
	 * Given two schemas, returns an Array containing descriptions of any breaking
	 * changes in the newSchema related to removing types from a union type.
	 */
	function findTypesRemovedFromUnions(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	
	  var typesRemovedFromUnion = [];
	  Object.keys(oldTypeMap).forEach(function (typeName) {
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	    if (!(oldType instanceof _definition.GraphQLUnionType) || !(newType instanceof _definition.GraphQLUnionType)) {
	      return;
	    }
	    var typeNamesInNewUnion = Object.create(null);
	    newType.getTypes().forEach(function (type) {
	      typeNamesInNewUnion[type.name] = true;
	    });
	    oldType.getTypes().forEach(function (type) {
	      if (!typeNamesInNewUnion[type.name]) {
	        typesRemovedFromUnion.push({
	          type: BreakingChangeType.TYPE_REMOVED_FROM_UNION,
	          description: type.name + ' was removed from union type ' + typeName + '.'
	        });
	      }
	    });
	  });
	  return typesRemovedFromUnion;
	}
	
	/**
	 * Given two schemas, returns an Array containing descriptions of any breaking
	 * changes in the newSchema related to removing values from an enum type.
	 */
	function findValuesRemovedFromEnums(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	
	  var valuesRemovedFromEnums = [];
	  Object.keys(oldTypeMap).forEach(function (typeName) {
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	    if (!(oldType instanceof _definition.GraphQLEnumType) || !(newType instanceof _definition.GraphQLEnumType)) {
	      return;
	    }
	    var valuesInNewEnum = Object.create(null);
	    newType.getValues().forEach(function (value) {
	      valuesInNewEnum[value.name] = true;
	    });
	    oldType.getValues().forEach(function (value) {
	      if (!valuesInNewEnum[value.name]) {
	        valuesRemovedFromEnums.push({
	          type: BreakingChangeType.VALUE_REMOVED_FROM_ENUM,
	          description: value.name + ' was removed from enum type ' + typeName + '.'
	        });
	      }
	    });
	  });
	  return valuesRemovedFromEnums;
	}

/***/ },

/***/ "./node_modules/uniforms/JSONSchemaBridge.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/slicedToArray.js");
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Bridge2 = __webpack_require__("./node_modules/uniforms/Bridge.js");
	
	var _Bridge3 = _interopRequireDefault(_Bridge2);
	
	var _joinName = __webpack_require__("./node_modules/uniforms/joinName.js");
	
	var _joinName2 = _interopRequireDefault(_joinName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resolveRef = function resolveRef(referance, schema) {
	    (0, _invariant2.default)(referance.startsWith('#'), 'Reference is not an internal reference, and only such are allowed: "%s"', referance);
	
	    var resolvedReference = referance.split('/').filter(function (part) {
	        return part && part !== '#';
	    }).reduce(function (definition, next) {
	        return definition[next];
	    }, schema);
	
	    (0, _invariant2.default)(resolvedReference, 'Reference not found in schema: "%s"', referance);
	
	    return resolvedReference;
	};
	
	var JSONSchemaBridge = function (_Bridge) {
	    (0, _inherits3.default)(JSONSchemaBridge, _Bridge);
	
	    function JSONSchemaBridge(schema, validator) {
	        (0, _classCallCheck3.default)(this, JSONSchemaBridge);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (JSONSchemaBridge.__proto__ || Object.getPrototypeOf(JSONSchemaBridge)).call(this));
	
	        _this.schema = schema;
	        _this._compiledSchema = {};
	        _this.validator = validator;
	        return _this;
	    }
	
	    (0, _createClass3.default)(JSONSchemaBridge, [{
	        key: 'getError',
	        value: function getError(name, error) {
	            return error && error.details && error.details.find && error.details.find(function (detail) {
	                return detail.dataPath && detail.dataPath.substring(1) === name;
	            });
	        }
	    }, {
	        key: 'getErrorMessage',
	        value: function getErrorMessage(name, error) {
	            var scopedError = this.getError(name, error) || {};
	
	            return scopedError && scopedError.message || '';
	        }
	    }, {
	        key: 'getErrorMessages',
	        value: function getErrorMessages(error) {
	            if (error) {
	                if (Array.isArray(error.details)) {
	                    return error.details.reduce(function (acc, _ref) {
	                        var message = _ref.message;
	                        return acc.concat(message);
	                    }, []);
	                }
	
	                return [error.message || error];
	            }
	
	            return [];
	        }
	    }, {
	        key: 'getField',
	        value: function getField(name) {
	            var _this2 = this;
	
	            return (0, _joinName2.default)(null, name).reduce(function (definition, next, nextIndex, array) {
	                // eslint-disable-line complexity
	                var previous = (0, _joinName2.default)(array.slice(0, nextIndex));
	                var isRequired = (definition.required || (_this2._compiledSchema[previous] || {}).required || []).includes(next);
	
	                var _key = (0, _joinName2.default)(previous, next);
	                var _definition = _this2._compiledSchema[_key] || {};
	
	                if (next === '$' || next === '' + parseInt(next, 10)) {
	                    (0, _invariant2.default)(definition.type === 'array', 'Field not found in schema: "%s"', name);
	                    definition = Array.isArray(definition.items) ? definition.items[parseInt(next, 10)] : definition.items;
	                } else if (definition.type === 'object') {
	                    definition = definition.properties[next];
	                } else {
	                    var _filter$map = ['allOf', 'anyOf', 'oneOf'].filter(function (key) {
	                        return definition[key];
	                    }).map(function (key) {
	                        return definition[key].find(function (_ref2) {
	                            var _ref2$properties = _ref2.properties,
	                                properties = _ref2$properties === undefined ? {} : _ref2$properties;
	                            return properties[next];
	                        });
	                    }),
	                        _filter$map2 = (0, _slicedToArray3.default)(_filter$map, 1),
	                        _filter$map2$ = _filter$map2[0];
	
	                    _filter$map2$ = _filter$map2$ === undefined ? {} : _filter$map2$;
	                    var _filter$map2$$propert = _filter$map2$.properties,
	                        combinedDefinition = _filter$map2$$propert === undefined ? {} : _filter$map2$$propert;
	
	
	                    definition = combinedDefinition[next];
	                }
	
	                (0, _invariant2.default)(definition, 'Field not found in schema: "%s"', name);
	
	                if (definition.$ref) {
	                    definition = resolveRef(definition.$ref, _this2.schema);
	                }
	
	                ['allOf', 'anyOf', 'oneOf'].filter(function (key) {
	                    return definition[key];
	                }).forEach(function (key) {
	                    _definition[key] = definition[key].map(function (def) {
	                        return def.$ref ? resolveRef(def.$ref, _this2.schema) : def;
	                    });
	                });
	
	                // Naive computation of combined type, properties and required
	                if (['allOf', 'anyOf', 'oneOf'].filter(function (key) {
	                    return definition[key];
	                }).length) {
	                    _definition.type = ([].concat(_definition.allOf, _definition.anyOf, _definition.oneOf).filter(function (def) {
	                        return def;
	                    }).find(function (def) {
	                        return def.type;
	                    }) || {}).type;
	
	                    var _concat$filter$reduce = [].concat(_definition.allOf, _definition.anyOf, _definition.oneOf).filter(function (def) {
	                        return def;
	                    }).reduce(function (_ref3, _ref4) {
	                        var _ref5 = (0, _slicedToArray3.default)(_ref3, 2),
	                            _properties = _ref5[0],
	                            _required = _ref5[1];
	
	                        var properties = _ref4.properties,
	                            required = _ref4.required;
	                        return [(0, _extends3.default)(_properties, properties), _required.concat(required)];
	                    }, [{}, []]),
	                        _concat$filter$reduce2 = (0, _slicedToArray3.default)(_concat$filter$reduce, 2),
	                        properties = _concat$filter$reduce2[0],
	                        required = _concat$filter$reduce2[1];
	
	                    _definition.properties = properties;
	                    _definition.required = required;
	                }
	
	                _this2._compiledSchema[_key] = (0, _extends3.default)(_definition, { isRequired: isRequired });
	
	                return definition;
	            }, this.schema);
	        }
	    }, {
	        key: 'getInitialValue',
	        value: function getInitialValue(name) {
	            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            var _getField = this.getField(name),
	                _default = _getField.default,
	                _type = _getField.type;
	
	            var _compiledSchema$name = this._compiledSchema[name],
	                _compiledSchema$name$ = _compiledSchema$name.default,
	                defaultValue = _compiledSchema$name$ === undefined ? _default : _compiledSchema$name$,
	                _compiledSchema$name$2 = _compiledSchema$name.type,
	                type = _compiledSchema$name$2 === undefined ? _type : _compiledSchema$name$2;
	
	
	            if (type === 'array') {
	                var item = this.getInitialValue((0, _joinName2.default)(name, '0'));
	                var items = props.initialCount || 0;
	
	                return [].concat((0, _toConsumableArray3.default)(Array(items))).map(function () {
	                    return item;
	                });
	            }
	
	            if (type === 'object') {
	                return {};
	            }
	
	            return defaultValue;
	        }
	    }, {
	        key: 'getProps',
	        value: function getProps(name) {
	            var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            var _ref6$label = _ref6.label,
	                label = _ref6$label === undefined ? true : _ref6$label,
	                opts = _ref6.options,
	                props = (0, _objectWithoutProperties3.default)(_ref6, ['label', 'options']);
	
	            var _getField2 = this.getField(name),
	                _enum = _getField2.enum,
	                _type = _getField2.type,
	                _options = _getField2.options,
	                uniforms = _getField2.uniforms;
	
	            var _compiledSchema$name2 = this._compiledSchema[name],
	                _compiledSchema$name3 = _compiledSchema$name2.enum,
	                allowedValues = _compiledSchema$name3 === undefined ? _enum : _compiledSchema$name3,
	                _compiledSchema$name4 = _compiledSchema$name2.options,
	                options = _compiledSchema$name4 === undefined ? _options : _compiledSchema$name4,
	                _compiledSchema$name5 = _compiledSchema$name2.type,
	                fieldType = _compiledSchema$name5 === undefined ? _type : _compiledSchema$name5,
	                isRequired = _compiledSchema$name2.isRequired;
	
	            var _joinName$slice$map = (0, _joinName2.default)(null, name).slice(-1).map(function (str) {
	                return str.replace(/([A-Z])/g, ' $1');
	            }),
	                _joinName$slice$map2 = (0, _slicedToArray3.default)(_joinName$slice$map, 1),
	                fieldName = _joinName$slice$map2[0];
	
	            var ready = (0, _extends3.default)({
	                allowedValues: allowedValues
	            }, fieldType === 'number' ? { decimal: true } : {}, {
	                options: opts || options,
	                label: label === true ? fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase() : label || '',
	                required: isRequired
	            });
	
	            if (ready.options) {
	                if (!Array.isArray(ready.options)) {
	                    ready.transform = function (value) {
	                        return ready.options[value];
	                    };
	                    ready.allowedValues = Object.keys(ready.options);
	                } else {
	                    ready.transform = function (value) {
	                        return ready.options.find(function (option) {
	                            return option.value === value;
	                        }).label;
	                    };
	                    ready.allowedValues = ready.options.map(function (option) {
	                        return option.value;
	                    });
	                }
	            }
	
	            return (0, _extends3.default)({}, uniforms, ready, props);
	        }
	    }, {
	        key: 'getSubfields',
	        value: function getSubfields(name) {
	            if (!name) {
	                return Object.keys(this.schema.properties);
	            }
	
	            var _getField3 = this.getField(name),
	                _type = _getField3.type,
	                _properties = _getField3.properties;
	
	            var _compiledSchema$name6 = this._compiledSchema[name],
	                _compiledSchema$name7 = _compiledSchema$name6.type,
	                fieldType = _compiledSchema$name7 === undefined ? _type : _compiledSchema$name7,
	                _compiledSchema$name8 = _compiledSchema$name6.properties,
	                fieldProperties = _compiledSchema$name8 === undefined ? _properties : _compiledSchema$name8;
	
	
	            if (fieldType === 'object') {
	                return Object.keys(fieldProperties);
	            }
	
	            return [];
	        }
	    }, {
	        key: 'getType',
	        value: function getType(name) {
	            var _getField4 = this.getField(name),
	                _type = _getField4.type,
	                fieldFormat = _getField4.format;
	
	            var _compiledSchema$name$3 = this._compiledSchema[name].type,
	                fieldType = _compiledSchema$name$3 === undefined ? _type : _compiledSchema$name$3;
	
	
	            if (fieldFormat === 'date-time') return Date;
	            if (fieldType === 'string') return String;
	            if (fieldType === 'number') return Number;
	            if (fieldType === 'integer') return Number;
	            if (fieldType === 'object') return Object;
	            if (fieldType === 'array') return Array;
	            if (fieldType === 'boolean') return Boolean;
	
	            (0, _invariant2.default)(fieldType !== 'null', 'Field "%s" can not be represented as a type null', name);
	
	            return fieldType;
	        }
	    }, {
	        key: 'getValidator',
	        value: function getValidator() {
	            return this.validator;
	        }
	    }], [{
	        key: 'check',
	        value: function check() {
	            return false;
	        }
	    }]);
	    return JSONSchemaBridge;
	}(_Bridge3.default);
	
	exports.default = JSONSchemaBridge;

/***/ },

/***/ "./node_modules/uniforms/SimpleSchema2Bridge.js":
/***/ function(module, exports, __webpack_require__) {

	var require;'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _cloneDeep = __webpack_require__("./node_modules/lodash/cloneDeep.js");
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Bridge2 = __webpack_require__("./node_modules/uniforms/Bridge.js");
	
	var _Bridge3 = _interopRequireDefault(_Bridge2);
	
	var _joinName = __webpack_require__("./node_modules/uniforms/joinName.js");
	
	var _joinName2 = _interopRequireDefault(_joinName);
	
	var _filterDOMProps = __webpack_require__("./node_modules/uniforms/filterDOMProps.js");
	
	var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SimpleSchema = void 0;
	try {
	    var r = require; // Silence Meteor missing module warning
	    SimpleSchema = __webpack_require__("./node_modules/simpl-schema/dist/main.js").default;
	    SimpleSchema.extendOptions(['uniforms']);
	
	    // There's no possibility to retrieve them at runtime
	    _filterDOMProps2.default.register('allowedValues', 'autoValue', 'blackbox', 'custom', 'decimal', 'defaultValue', 'exclusiveMax', 'exclusiveMin', 'label', 'max', 'maxCount', 'min', 'minCount', 'optional', 'regEx', 'trim', 'type');
	} catch (_) {/* Ignore it. */}
	
	var SimpleSchema2Bridge = function (_Bridge) {
	    (0, _inherits3.default)(SimpleSchema2Bridge, _Bridge);
	
	    function SimpleSchema2Bridge(schema) {
	        (0, _classCallCheck3.default)(this, SimpleSchema2Bridge);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (SimpleSchema2Bridge.__proto__ || Object.getPrototypeOf(SimpleSchema2Bridge)).call(this));
	
	        _this.schema = schema;
	        return _this;
	    }
	
	    (0, _createClass3.default)(SimpleSchema2Bridge, [{
	        key: 'getError',
	        value: function getError(name, error) {
	            return error && error.details && error.details.find && error.details.find(function (error) {
	                return error.name === name;
	            }) || null;
	        }
	    }, {
	        key: 'getErrorMessage',
	        value: function getErrorMessage(name, error) {
	            var scopedError = this.getError(name, error);
	            return !scopedError ? '' : this.schema.messageForError(scopedError);
	        }
	    }, {
	        key: 'getErrorMessages',
	        value: function getErrorMessages(error) {
	            var _this2 = this;
	
	            if (error) {
	                if (Array.isArray(error.details)) {
	                    return error.details.map(function (error) {
	                        return _this2.schema.messageForError(error);
	                    });
	                }
	
	                if (error.message) {
	                    return [error.message];
	                }
	            }
	
	            if (error !== undefined) {
	                return [error];
	            }
	
	            return [];
	        }
	    }, {
	        key: 'getField',
	        value: function getField(name) {
	            var definition = this.schema.getDefinition(name);
	
	            (0, _invariant2.default)(definition, 'Field not found in schema: "%s"', name);
	
	            var merged = (0, _extends3.default)({}, definition, definition.type[0]);
	
	            // aldeed/node-simple-schema#27
	            if (merged.autoValue && (merged.autoValue.name === 'defaultAutoValueFunction' || merged.autoValue.toString().indexOf('$setOnInsert:') !== -1 // FIXME: Hack.
	            )) {
	                try {
	                    merged.defaultValue = merged.autoValue.call({ operator: null });
	                } catch (_) {/* ignore it */}
	            }
	
	            return merged;
	        }
	    }, {
	        key: 'getInitialValue',
	        value: function getInitialValue(name) {
	            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            var field = this.getField(name);
	
	            if (field.type === Array) {
	                var item = this.getInitialValue((0, _joinName2.default)(name, '0'));
	                var items = Math.max(props.initialCount || 0, field.minCount || 0);
	
	                return [].concat((0, _toConsumableArray3.default)(Array(items))).map(function () {
	                    return item;
	                });
	            }
	
	            if (field.type === Object || SimpleSchema2Bridge.check(field.type)) {
	                return {};
	            }
	
	            return field.defaultValue;
	        }
	
	        // eslint-disable-next-line complexity
	
	    }, {
	        key: 'getProps',
	        value: function getProps(name) {
	            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            // Type should be omitted.
	            // eslint-disable-next-line no-unused-vars, prefer-const
	            var _getField = this.getField(name),
	                optional = _getField.optional,
	                type = _getField.type,
	                uniforms = _getField.uniforms,
	                field = (0, _objectWithoutProperties3.default)(_getField, ['optional', 'type', 'uniforms']);
	
	            field = (0, _extends3.default)({}, field, { required: !optional });
	
	            if (uniforms) {
	                if (typeof uniforms === 'string' || typeof uniforms === 'function') {
	                    field = (0, _extends3.default)({}, field, { component: uniforms });
	                } else {
	                    field = (0, _extends3.default)({}, field, uniforms);
	                }
	            }
	
	            if (type === Array) {
	                try {
	                    var itemProps = this.getProps(name + '.$', props);
	                    if (itemProps.allowedValues && !props.allowedValues) {
	                        field.allowedValues = itemProps.allowedValues;
	                    }
	
	                    if (itemProps.transform && !props.transform) {
	                        field.transform = itemProps.transform;
	                    }
	                } catch (_) {/* ignore it */}
	            } else if (type === Number) {
	                field = (0, _extends3.default)({}, field, { decimal: true });
	            }
	
	            var options = props.options || field.options;
	            if (options) {
	                if (typeof options === 'function') {
	                    options = options();
	                }
	
	                if (!Array.isArray(options)) {
	                    field = (0, _extends3.default)({}, field, {
	                        transform: function transform(value) {
	                            return options[value];
	                        },
	                        allowedValues: Object.keys(options)
	                    });
	                } else {
	                    field = (0, _extends3.default)({}, field, {
	                        transform: function transform(value) {
	                            return options.find(function (option) {
	                                return option.value === value;
	                            }).label;
	                        },
	                        allowedValues: options.map(function (option) {
	                            return option.value;
	                        })
	                    });
	                }
	            }
	
	            return field;
	        }
	    }, {
	        key: 'getSubfields',
	        value: function getSubfields(name) {
	            return this.schema.objectKeys(SimpleSchema._makeGeneric(name));
	        }
	    }, {
	        key: 'getType',
	        value: function getType(name) {
	            var type = this.getField(name).type;
	
	            if (type === SimpleSchema.Integer) {
	                return Number;
	            }
	
	            if (SimpleSchema2Bridge.check(type)) {
	                return Object;
	            }
	
	            return type;
	        }
	    }, {
	        key: 'getValidator',
	        value: function getValidator() {
	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { clean: true, mutate: true };
	
	            var validator = this.schema.validator(options);
	
	            // Clean mutate its argument, even if mutate is false.
	            if (options.clean) {
	                return function (model) {
	                    return validator((0, _cloneDeep2.default)((0, _extends3.default)({}, model)));
	                };
	            }
	
	            return validator;
	        }
	    }], [{
	        key: 'check',
	        value: function check(schema) {
	            return SimpleSchema && schema && schema.getDefinition && schema.messageBox && schema.objectKeys && schema.validator && schema.version === 2;
	        }
	    }]);
	    return SimpleSchema2Bridge;
	}(_Bridge3.default);
	
	exports.default = SimpleSchema2Bridge;

/***/ },

/***/ "./node_modules/uniforms/filterDOMProps.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = filterDOMProps;
	var unwantedProps = [
	// These props are provided by BaseField
	'changed', 'changedMap', 'disabled', 'error', 'errorMessage', 'field', 'fieldType', 'fields', 'findError', 'findField', 'findValue', 'initialCount', 'label', 'name', 'onChange', 'parent', 'placeholder', 'showInlineError', 'value',
	
	// This is used by AutoField
	'component'];
	
	// Some benchmarks
	// https://albertxing.com/stool/#bb5cbc0441ad7ac47602694f6c7183b4
	function filterDOMProps(props) {
	    var filteredProps = {};
	
	    for (var prop in props) {
	        if (unwantedProps.indexOf(prop) === -1) {
	            filteredProps[prop] = props[prop];
	        }
	    }
	
	    return filteredProps;
	}
	
	// Bridges have to register additional props
	filterDOMProps.register = function () {
	    for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
	        props[_key] = arguments[_key];
	    }
	
	    props.forEach(function (prop) {
	        if (unwantedProps.indexOf(prop) === -1) {
	            unwantedProps.push(prop);
	        }
	    });
	};
	
	// It might be handy at some point
	filterDOMProps.registered = unwantedProps;

/***/ },

/***/ "./node_modules/simpl-schema/dist/main.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ValidationContext = undefined;
	
	var _SimpleSchema = __webpack_require__("./node_modules/simpl-schema/dist/SimpleSchema.js");
	
	__webpack_require__("./node_modules/simpl-schema/dist/clean.js");
	
	exports.default = _SimpleSchema.SimpleSchema;
	exports.ValidationContext = _SimpleSchema.ValidationContext;

/***/ },

/***/ "./node_modules/simpl-schema/dist/SimpleSchema.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ValidationContext = exports.SimpleSchema = exports.schemaDefinitionOptions = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _deepExtend = __webpack_require__("./node_modules/simpl-schema/node_modules/deep-extend/lib/deep-extend.js");
	
	var _deepExtend2 = _interopRequireDefault(_deepExtend);
	
	var _mongoObject = __webpack_require__("./node_modules/mongo-object/dist/mongo-object.js");
	
	var _mongoObject2 = _interopRequireDefault(_mongoObject);
	
	var _underscore = __webpack_require__("./build/meteor/bundle/programs/web.browser/packages/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _messageBox = __webpack_require__("./node_modules/message-box/dist/MessageBox.js");
	
	var _messageBox2 = _interopRequireDefault(_messageBox);
	
	var _humanize = __webpack_require__("./node_modules/simpl-schema/dist/humanize.js");
	
	var _humanize2 = _interopRequireDefault(_humanize);
	
	var _ValidationContext = __webpack_require__("./node_modules/simpl-schema/dist/ValidationContext.js");
	
	var _ValidationContext2 = _interopRequireDefault(_ValidationContext);
	
	var _SimpleSchemaGroup = __webpack_require__("./node_modules/simpl-schema/dist/SimpleSchemaGroup.js");
	
	var _SimpleSchemaGroup2 = _interopRequireDefault(_SimpleSchemaGroup);
	
	var _regExp = __webpack_require__("./node_modules/simpl-schema/dist/regExp.js");
	
	var _regExp2 = _interopRequireDefault(_regExp);
	
	var _clean2 = __webpack_require__("./node_modules/simpl-schema/dist/clean.js");
	
	var _clean3 = _interopRequireDefault(_clean2);
	
	var _expandShorthand = __webpack_require__("./node_modules/simpl-schema/dist/expandShorthand.js");
	
	var _expandShorthand2 = _interopRequireDefault(_expandShorthand);
	
	var _utility = __webpack_require__("./node_modules/simpl-schema/dist/utility.js");
	
	var _defaultMessages = __webpack_require__("./node_modules/simpl-schema/dist/defaultMessages.js");
	
	var _defaultMessages2 = _interopRequireDefault(_defaultMessages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Exported for tests
	var schemaDefinitionOptions = exports.schemaDefinitionOptions = ['type', 'label', 'optional', 'required', 'autoValue', 'defaultValue'];
	
	var oneOfProps = ['type', 'min', 'max', 'minCount', 'maxCount', 'allowedValues', 'exclusiveMin', 'exclusiveMax', 'regEx', 'custom', 'blackbox', 'trim'];
	
	var propsThatCanBeFunction = ['label', 'optional', 'min', 'max', 'minCount', 'maxCount', 'allowedValues', 'exclusiveMin', 'exclusiveMax', 'regEx'];
	
	var SimpleSchema = function () {
	  function SimpleSchema() {
	    var schema = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    _classCallCheck(this, SimpleSchema);
	
	    this.pick = getPickOrOmit('pick');
	    this.omit = getPickOrOmit('omit');
	
	    // Stash the options object
	    this._constructorOptions = _extends({}, options);
	    if (this._constructorOptions.humanizeAutoLabels !== false) this._constructorOptions.humanizeAutoLabels = true;
	
	    // Custom validators for this instance
	    this._validators = [];
	    this._docValidators = [];
	
	    // Named validation contexts
	    this._validationContexts = {};
	
	    // Clone, expanding shorthand, and store the schema object in this._schema
	    this._schema = {};
	    this.extend(schema);
	
	    // Define default validation error messages
	    this.messageBox = new _messageBox2.default(_defaultMessages2.default);
	
	    // Schema-level defaults for cleaning
	    this._cleanOptions = _extends({
	      filter: true,
	      autoConvert: true,
	      removeEmptyStrings: true,
	      trimStrings: true,
	      getAutoValues: true,
	      removeNullsFromArrays: false,
	      extendAutoValueContext: {}
	    }, options.clean);
	
	    this.version = SimpleSchema.version;
	  }
	
	  _createClass(SimpleSchema, [{
	    key: 'findFirstAncestorSimpleSchema',
	    value: function findFirstAncestorSimpleSchema(key, func) {
	      var _this = this;
	
	      var genericKey = _mongoObject2.default.makeKeyGeneric(key);
	
	      var foundSchema = false;
	      (0, _utility.forEachKeyAncestor)(genericKey, function (ancestor) {
	        if (foundSchema) return; // skip remaining once we've found it
	        var def = _this._schema[ancestor];
	        if (!def) return;
	        def.type.definitions.forEach(function (typeDef) {
	          if (typeDef.type instanceof SimpleSchema) {
	            func(typeDef.type, ancestor, genericKey.slice(ancestor.length + 1));
	            foundSchema = true;
	          }
	        });
	      });
	
	      return foundSchema;
	    }
	
	    /**
	     * @param {String} [key] One specific or generic key for which to get the schema.
	     * @returns {Object} The entire schema object or just the definition for one key.
	     *
	     * Note that this returns the raw, unevaluated definition object. Use `getDefinition`
	     * if you want the evaluated definition, where any properties that are functions
	     * have been run to produce a result.
	     */
	
	  }, {
	    key: 'schema',
	    value: function schema(key) {
	      if (!key) return this._schema;
	
	      var genericKey = _mongoObject2.default.makeKeyGeneric(key);
	      var keySchema = this._schema[genericKey];
	
	      // If not defined in this schema, see if it's defined in a subschema
	      if (!keySchema) {
	        this.findFirstAncestorSimpleSchema(key, function (simpleSchema, ancestor, subSchemaKey) {
	          keySchema = simpleSchema.schema(subSchemaKey);
	        });
	      }
	
	      return keySchema;
	    }
	
	    /**
	     * @returns {Object} The entire schema object with subschemas merged. This is the
	     * equivalent of what schema() returned in SimpleSchema < 2.0
	     *
	     * Note that this returns the raw, unevaluated definition object. Use `getDefinition`
	     * if you want the evaluated definition, where any properties that are functions
	     * have been run to produce a result.
	     */
	
	  }, {
	    key: 'mergedSchema',
	    value: function mergedSchema() {
	      var mergedSchema = {};
	
	      _underscore2.default.each(this._schema, function (keySchema, key) {
	        mergedSchema[key] = keySchema;
	
	        keySchema.type.definitions.forEach(function (typeDef) {
	          if (!(typeDef.type instanceof SimpleSchema)) return;
	          _underscore2.default.each(typeDef.type.mergedSchema(), function (subKeySchema, subKey) {
	            mergedSchema[key + '.' + subKey] = subKeySchema;
	          });
	        });
	      });
	
	      return mergedSchema;
	    }
	
	    /**
	     * Returns the evaluated definition for one key in the schema
	     *
	     * @param {String} key Generic or specific schema key
	     * @param {Array(String)} [propList] Array of schema properties you need; performance optimization
	     * @param {Object} [functionContext] The context to use when evaluating schema options that are functions
	     * @returns {Object} The schema definition for the requested key
	     */
	
	  }, {
	    key: 'getDefinition',
	    value: function getDefinition(key, propList, functionContext) {
	      var _this2 = this;
	
	      var defs = this.schema(key);
	      if (!defs) return;
	
	      var getPropIterator = function getPropIterator(obj) {
	        return function (val, prop) {
	          if (Array.isArray(propList) && !_underscore2.default.contains(propList, prop)) return;
	          // For any options that support specifying a function, evaluate the functions
	          if (propsThatCanBeFunction.indexOf(prop) > -1 && typeof val === 'function') {
	            obj[prop] = val.call(functionContext || {});
	            // Inflect label if undefined
	            if (prop === 'label' && typeof obj[prop] !== 'string') obj[prop] = inflectedLabel(key, _this2._constructorOptions.humanizeAutoLabels);
	          } else {
	            obj[prop] = val;
	          }
	        };
	      };
	
	      var result = {};
	      _underscore2.default.each(defs, getPropIterator(result));
	
	      // Resolve all the types and convert to a normal array to make it easier
	      // to use.
	      if (defs.type) {
	        result.type = defs.type.definitions.map(function (typeDef) {
	          var newTypeDef = {};
	          _underscore2.default.each(typeDef, getPropIterator(newTypeDef));
	          return newTypeDef;
	        });
	      }
	
	      return result;
	    }
	
	    /**
	     * Returns a string identifying the best guess data type for a key. For keys
	     * that allow multiple types, the first type is used. This can be useful for
	     * building forms.
	     *
	     * @param {String} key Generic or specific schema key
	     * @returns {String} A type string. One of:
	     *  string, number, boolean, date, stringArray, numberArray, booleanArray,
	     *  dateArray, object
	     */
	
	  }, {
	    key: 'getQuickTypeForKey',
	    value: function getQuickTypeForKey(key) {
	      var type = void 0;
	
	      var fieldSchema = this.schema(key);
	      if (!fieldSchema) return;
	
	      var fieldType = fieldSchema.type.singleType;
	
	      if (fieldType === String) {
	        type = 'string';
	      } else if (fieldType === Number || fieldType === SimpleSchema.Integer) {
	        type = 'number';
	      } else if (fieldType === Boolean) {
	        type = 'boolean';
	      } else if (fieldType === Date) {
	        type = 'date';
	      } else if (fieldType === Array) {
	        var arrayItemFieldSchema = this.schema(key + '.$');
	        if (!arrayItemFieldSchema) return;
	
	        var arrayItemFieldType = arrayItemFieldSchema.type.singleType;
	        if (arrayItemFieldType === String) {
	          type = 'stringArray';
	        } else if (arrayItemFieldType === Number || arrayItemFieldType === SimpleSchema.Integer) {
	          type = 'numberArray';
	        } else if (arrayItemFieldType === Boolean) {
	          type = 'booleanArray';
	        } else if (arrayItemFieldType === Date) {
	          type = 'dateArray';
	        }
	      } else if (fieldType === Object) {
	        type = 'object';
	      }
	
	      return type;
	    }
	
	    /**
	     * Given a key that is an Object, returns a new SimpleSchema instance scoped to that object.
	     *
	     * @param {String} key Generic or specific schema key
	     */
	
	  }, {
	    key: 'getObjectSchema',
	    value: function getObjectSchema(key) {
	      var newSchemaDef = {};
	      var genericKey = _mongoObject2.default.makeKeyGeneric(key);
	      var searchString = genericKey + '.';
	
	      _underscore2.default.each(this.mergedSchema(), function (val, k) {
	        if (k.indexOf(searchString) === 0) {
	          newSchemaDef[k.slice(searchString.length)] = val;
	        }
	      });
	
	      return new SimpleSchema(newSchemaDef);
	    }
	
	    // Returns an array of all the autovalue functions, including those in subschemas all the
	    // way down the schema tree
	
	  }, {
	    key: 'autoValueFunctions',
	    value: function autoValueFunctions() {
	      var result = [];
	
	      function addFuncs(autoValues, closestSubschemaFieldName) {
	        _underscore2.default.each(autoValues, function (func, fieldName) {
	          result.push({
	            func: func,
	            fieldName: fieldName,
	            closestSubschemaFieldName: closestSubschemaFieldName
	          });
	        });
	      }
	
	      addFuncs(this._autoValues, '');
	
	      _underscore2.default.each(this._schema, function (keySchema, key) {
	        keySchema.type.definitions.forEach(function (typeDef) {
	          if (!(typeDef.type instanceof SimpleSchema)) return;
	          result = result.concat(typeDef.type.autoValueFunctions().map(function (_ref) {
	            var func = _ref.func;
	            var fieldName = _ref.fieldName;
	            var closestSubschemaFieldName = _ref.closestSubschemaFieldName;
	
	            return {
	              func: func,
	              fieldName: key + '.' + fieldName,
	              closestSubschemaFieldName: closestSubschemaFieldName.length ? key + '.' + closestSubschemaFieldName : key
	            };
	          }));
	        });
	      });
	
	      return result;
	    }
	
	    // Returns an array of all the blackbox keys, including those in subschemas
	
	  }, {
	    key: 'blackboxKeys',
	    value: function blackboxKeys() {
	      var blackboxKeys = this._blackboxKeys;
	      _underscore2.default.each(this._schema, function (keySchema, key) {
	        keySchema.type.definitions.forEach(function (typeDef) {
	          if (!(typeDef.type instanceof SimpleSchema)) return;
	          typeDef.type._blackboxKeys.forEach(function (blackboxKey) {
	            blackboxKeys.push(key + '.' + blackboxKey);
	          });
	        });
	      });
	      return _underscore2.default.uniq(blackboxKeys);
	    }
	
	    // Check if the key is a nested dot-syntax key inside of a blackbox object
	
	  }, {
	    key: 'keyIsInBlackBox',
	    value: function keyIsInBlackBox(key) {
	      var _this3 = this;
	
	      var isInBlackBox = false;
	      (0, _utility.forEachKeyAncestor)(_mongoObject2.default.makeKeyGeneric(key), function (ancestor, remainder) {
	        if (_this3._blackboxKeys.indexOf(ancestor) > -1) {
	          isInBlackBox = true;
	        } else {
	          var testKeySchema = _this3.schema(ancestor);
	          if (testKeySchema) {
	            testKeySchema.type.definitions.forEach(function (typeDef) {
	              if (!(typeDef.type instanceof SimpleSchema)) return;
	              if (typeDef.type.keyIsInBlackBox(remainder)) isInBlackBox = true;
	            });
	          }
	        }
	      });
	      return isInBlackBox;
	    }
	
	    // Returns true if key is explicitly allowed by the schema or implied
	    // by other explicitly allowed keys.
	    // The key string should have $ in place of any numeric array positions.
	
	  }, {
	    key: 'allowsKey',
	    value: function allowsKey(key) {
	      var _this4 = this;
	
	      // Loop through all keys in the schema
	      return _underscore2.default.any(this._schemaKeys, function (loopKey) {
	        // If the schema key is the test key, it's allowed.
	        if (loopKey === key) return true;
	
	        var fieldSchema = _this4.schema(loopKey);
	        var compare1 = key.slice(0, loopKey.length + 2);
	        var compare2 = compare1.slice(0, -1);
	
	        // Blackbox and subschema checks are needed only if key starts with
	        // loopKey + a dot
	        if (compare2 !== loopKey + '.') return false;
	
	        // Black box handling
	        if (fieldSchema.blackbox === true) {
	          // If the test key is the black box key + ".$", then the test
	          // key is NOT allowed because black box keys are by definition
	          // only for objects, and not for arrays.
	          return compare1 !== loopKey + '.$';
	        }
	
	        // Subschemas
	        var allowed = false;
	        var subKey = key.slice(loopKey.length + 1);
	        fieldSchema.type.definitions.forEach(function (typeDef) {
	          if (!(typeDef.type instanceof SimpleSchema)) return;
	          if (typeDef.type.allowsKey(subKey)) allowed = true;
	        });
	        return allowed;
	      });
	    }
	
	    /**
	     * Returns all the child keys for the object identified by the generic prefix,
	     * or all the top level keys if no prefix is supplied.
	     *
	     * @param {String} [keyPrefix] The Object-type generic key for which to get child keys. Omit for
	     *   top-level Object-type keys
	     * @returns {[[Type]]} [[Description]]
	     */
	
	  }, {
	    key: 'objectKeys',
	    value: function objectKeys(keyPrefix) {
	      if (!keyPrefix) return this._firstLevelSchemaKeys;
	      return this._objectKeys[keyPrefix + '.'] || [];
	    }
	
	    /**
	     * Extends this schema with another schema, key by key.
	     *
	     * @param {SimpleSchema|Object} schema
	     * @returns The SimpleSchema instance (chainable)
	     */
	
	  }, {
	    key: 'extend',
	    value: function extend() {
	      var _this5 = this;
	
	      var schema = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      var schemaObj = void 0;
	      if (schema instanceof SimpleSchema) {
	        schemaObj = schema._schema;
	        // Merge the validators
	        this._validators = this._validators.concat(schema._validators);
	        this._docValidators = this._docValidators.concat(schema._docValidators);
	      } else {
	        schemaObj = (0, _expandShorthand2.default)(schema);
	      }
	
	      // Extend this._schema with additional fields and definitions from schema
	      this._schema = mergeSchemas([this._schema, schemaObj]);
	
	      checkSchemaOverlap(this._schema);
	
	      // Set/Reset all of these
	      this._schemaKeys = [];
	      this._autoValues = {};
	      this._blackboxKeys = [];
	      this._firstLevelSchemaKeys = [];
	      this._depsLabels = {};
	      this._objectKeys = {};
	
	      // Update all of the information cached on the instance
	      _underscore2.default.each(this._schema, function (definition, fieldName) {
	        _this5._schema[fieldName] = definition = checkAndScrubDefinition(fieldName, definition, _this5._constructorOptions, _this5._schema);
	
	        // Keep list of all keys for speedier checking
	        _this5._schemaKeys.push(fieldName);
	
	        // Keep list of all top level keys
	        if (fieldName.indexOf('.') === -1) _this5._firstLevelSchemaKeys.push(fieldName);
	
	        // Initialize label reactive dependency (Meteor only)
	        if (_this5._constructorOptions.tracker) {
	          _this5._depsLabels[fieldName] = new _this5._constructorOptions.tracker.Dependency();
	        }
	
	        // Keep list of all blackbox keys for passing to MongoObject constructor
	        if (definition.blackbox) _this5._blackboxKeys.push(fieldName);
	
	        // Keep list of autoValue functions by key
	        if (definition.autoValue) _this5._autoValues[fieldName] = definition.autoValue;
	      });
	
	      // Store child keys keyed by parent. This needs to be done recursively to handle
	      // subschemas.
	      var setObjectKeys = function setObjectKeys(curSchema, schemaParentKey) {
	        _underscore2.default.each(curSchema, function (definition, fieldName) {
	          fieldName = schemaParentKey ? schemaParentKey + '.' + fieldName : fieldName;
	          if (fieldName.indexOf('.') > -1 && fieldName.slice(-2) !== '.$') {
	            var parentKey = fieldName.slice(0, fieldName.lastIndexOf('.'));
	            var parentKeyWithDot = parentKey + '.';
	            _this5._objectKeys[parentKeyWithDot] = _this5._objectKeys[parentKeyWithDot] || [];
	            _this5._objectKeys[parentKeyWithDot].push(fieldName.slice(fieldName.lastIndexOf('.') + 1));
	          }
	
	          // If the current field is a nested SimpleSchema,
	          // iterate over the child fields and cache their properties as well
	          definition.type.definitions.forEach(function (_ref2) {
	            var type = _ref2.type;
	
	            if (type instanceof SimpleSchema) {
	              setObjectKeys(type._schema, fieldName);
	            }
	          });
	        });
	      };
	
	      setObjectKeys(this._schema);
	
	      return this;
	    }
	  }, {
	    key: 'getAllowedValuesForKey',
	    value: function getAllowedValuesForKey(key) {
	      // For array fields, `allowedValues` is on the array item definition
	      if (this.allowsKey(key + '.$')) {
	        key = key + '.$';
	      }
	
	      var defs = this.getDefinition(key, ['allowedValues']);
	
	      return defs && defs.type[0].allowedValues;
	    }
	  }, {
	    key: 'newContext',
	    value: function newContext() {
	      return new _ValidationContext2.default(this);
	    }
	  }, {
	    key: 'namedContext',
	    value: function namedContext(name) {
	      if (typeof name !== 'string') name = 'default';
	      if (!this._validationContexts[name]) {
	        this._validationContexts[name] = new SimpleSchema.ValidationContext(this);
	      }
	      return this._validationContexts[name];
	    }
	  }, {
	    key: 'addValidator',
	    value: function addValidator(func) {
	      this._validators.push(func);
	    }
	  }, {
	    key: 'addDocValidator',
	    value: function addDocValidator(func) {
	      this._docValidators.push(func);
	    }
	
	    /**
	     * @param obj {Object|Object[]} Object or array of objects to validate.
	     * @param [options] {Object} Same options object that ValidationContext#validate takes
	     *
	     * Throws an Error with name `ClientError` and `details` property containing the errors.
	     */
	
	  }, {
	    key: 'validate',
	    value: function validate(obj, options) {
	      var _this6 = this;
	
	      // For Meteor apps, `check` option can be passed to silence audit-argument-checks
	      if (typeof this._constructorOptions.check === 'function') {
	        // Call check but ignore the error
	        try {
	          this._constructorOptions.check(obj);
	        } catch (e) {/* ignore error */}
	      }
	
	      // obj can be an array, in which case we validate each object in it and
	      // throw as soon as one has an error
	      var objects = Array.isArray(obj) ? obj : [obj];
	      objects.forEach(function (oneObj) {
	        var validationContext = _this6.newContext();
	        var isValid = validationContext.validate(oneObj, options);
	
	        if (isValid) return;
	
	        var errors = validationContext.validationErrors();
	
	        // In order for the message at the top of the stack trace to be useful,
	        // we set it to the first validation error message.
	        var message = _this6.messageForError(errors[0]);
	
	        var error = new Error(message);
	        error.name = error.errorType = 'ClientError';
	        error.details = errors;
	        error.error = 'validation-error';
	
	        // The primary use for the validationErrorTransform is for the Meteor package
	        // to convert the vanilla Error into a Meteor.Error until DDP is able to pass
	        // vanilla errors back to the client.
	        if (typeof SimpleSchema.validationErrorTransform === 'function') {
	          throw SimpleSchema.validationErrorTransform(error);
	        } else {
	          throw error;
	        }
	      });
	    }
	  }, {
	    key: 'validator',
	    value: function validator() {
	      var _this7 = this;
	
	      var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      return function (obj) {
	        var optionsClone = _extends({}, options);
	        if (options.clean === true) {
	          // Do this here and pass into both functions for better performance
	          optionsClone.mongoObject = new _mongoObject2.default(obj, _this7.blackboxKeys());
	          _this7.clean(obj, optionsClone);
	        }
	        _this7.validate(obj, optionsClone);
	      };
	    }
	  }, {
	    key: 'clean',
	    value: function clean() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _clean3.default.apply(undefined, [this].concat(args));
	    }
	
	    /**
	     * Change schema labels on the fly, causing mySchema.label computation
	     * to rerun. Useful when the user changes the language.
	     *
	     * @param {Object} labels A dictionary of all the new label values, by schema key.
	     */
	
	  }, {
	    key: 'labels',
	    value: function labels(_labels) {
	      var _this8 = this;
	
	      _underscore2.default.each(_labels, function (label, key) {
	        if (typeof label !== 'string' && typeof label !== 'function') return;
	        if (!_this8._schema.hasOwnProperty(key)) return;
	
	        _this8._schema[key].label = label;
	        _this8._depsLabels[key] && _this8._depsLabels[key].changed();
	      });
	    }
	
	    /**
	     * Gets a field's label or all field labels reactively.
	     *
	     * @param {String} [key] The schema key, specific or generic.
	     *   Omit this argument to get a dictionary of all labels.
	     * @returns {String} The label
	     */
	
	  }, {
	    key: 'label',
	    value: function label(key) {
	      var _this9 = this;
	
	      // Get all labels
	      if (key === null || key === undefined) {
	        var _ret = function () {
	          var result = {};
	          _underscore2.default.each(_this9._schemaKeys, function (schemaKey) {
	            result[schemaKey] = _this9.label(schemaKey);
	          });
	          return {
	            v: result
	          };
	        }();
	
	        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	      }
	
	      // Get label for one field
	      var def = this.getDefinition(key, ['label']);
	      if (!def) return null;
	
	      var genericKey = _mongoObject2.default.makeKeyGeneric(key);
	      this._depsLabels[genericKey] && this._depsLabels[genericKey].depend();
	      return def.label;
	    }
	
	    // Returns a string message for the given error type and key. Passes through
	    // to message-box pkg.
	
	  }, {
	    key: 'messageForError',
	    value: function messageForError(errorInfo) {
	      var name = errorInfo.name;
	
	
	      return this.messageBox.message(errorInfo, {
	        context: {
	          key: name, // backward compatibility
	
	          // The call to this.label() establishes a reactive dependency, too
	          label: this.label(name)
	        }
	      });
	    }
	
	    /**
	     * @method SimpleSchema#pick
	     * @param {[fields]} The list of fields to pick to instantiate the subschema
	     * @returns {SimpleSchema} The subschema
	     */
	
	
	    /**
	     * @method SimpleSchema#omit
	     * @param {[fields]} The list of fields to omit to instantiate the subschema
	     * @returns {SimpleSchema} The subschema
	     */
	
	  }], [{
	    key: 'extendOptions',
	
	
	    // If you need to allow properties other than those listed above, call this from your app or package
	    value: function extendOptions(options) {
	      // For backwards compatibility we still take an object here, but we only care about the names
	      if (!Array.isArray(options)) options = Object.keys(options);
	      options.forEach(function (option) {
	        schemaDefinitionOptions.push(option);
	      });
	    }
	  }, {
	    key: 'defineValidationErrorTransform',
	    value: function defineValidationErrorTransform(transform) {
	      if (typeof transform !== 'function') {
	        throw new Error('SimpleSchema.defineValidationErrorTransform must be passed a function that accepts an Error and returns an Error');
	      }
	      SimpleSchema.validationErrorTransform = transform;
	    }
	  }, {
	    key: 'validate',
	    value: function validate(obj, schema, options) {
	      // Allow passing just the schema object
	      if (!(schema instanceof SimpleSchema)) {
	        schema = new SimpleSchema(schema);
	      }
	
	      return schema.validate(obj, options);
	    }
	  }, {
	    key: 'oneOf',
	    value: function oneOf() {
	      for (var _len2 = arguments.length, definitions = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        definitions[_key2] = arguments[_key2];
	      }
	
	      return new (Function.prototype.bind.apply(_SimpleSchemaGroup2.default, [null].concat(definitions)))();
	    }
	
	    // Global custom validators
	
	  }, {
	    key: 'addValidator',
	    value: function addValidator(func) {
	      SimpleSchema._validators.push(func);
	    }
	  }, {
	    key: 'addDocValidator',
	    value: function addDocValidator(func) {
	      SimpleSchema._docValidators.push(func);
	    }
	
	    // Backwards compatibility
	
	  }]);
	
	  return SimpleSchema;
	}();
	
	/*
	 * PRIVATE
	 */
	
	SimpleSchema.version = 2;
	SimpleSchema.RegEx = _regExp2.default;
	SimpleSchema._validators = [];
	SimpleSchema._docValidators = [];
	SimpleSchema.ErrorTypes = {
	  REQUIRED: 'required',
	  MIN_STRING: 'minString',
	  MAX_STRING: 'maxString',
	  MIN_NUMBER: 'minNumber',
	  MAX_NUMBER: 'maxNumber',
	  MIN_NUMBER_EXCLUSIVE: 'minNumberExclusive',
	  MAX_NUMBER_EXCLUSIVE: 'maxNumberExclusive',
	  MIN_DATE: 'minDate',
	  MAX_DATE: 'maxDate',
	  BAD_DATE: 'badDate',
	  MIN_COUNT: 'minCount',
	  MAX_COUNT: 'maxCount',
	  MUST_BE_INTEGER: 'noDecimal',
	  VALUE_NOT_ALLOWED: 'notAllowed',
	  EXPECTED_TYPE: 'expectedType',
	  FAILED_REGULAR_EXPRESSION: 'regEx',
	  KEY_NOT_IN_SCHEMA: 'keyNotInSchema'
	};
	SimpleSchema.Integer = 'SimpleSchema.Integer';
	SimpleSchema._makeGeneric = _mongoObject2.default.makeKeyGeneric;
	SimpleSchema.ValidationContext = _ValidationContext2.default;
	
	SimpleSchema.setDefaultMessages = function (messages) {
	  (0, _deepExtend2.default)(_defaultMessages2.default, messages);
	};
	
	function mergeSchemas(schemas) {
	  var mergedSchema = {};
	  _underscore2.default.each(schemas, function (schema) {
	    // Loop through and extend each individual field
	    // definition. That way you can extend and overwrite
	    // base field definitions.
	    _underscore2.default.each(schema, function (def, field) {
	      mergedSchema[field] = mergedSchema[field] || {};
	      if (!(mergedSchema[field] instanceof _SimpleSchemaGroup2.default)) {
	        if (def instanceof _SimpleSchemaGroup2.default) {
	          mergedSchema[field] = def;
	        } else {
	          Object.assign(mergedSchema[field], def);
	        }
	      }
	    });
	  });
	  return mergedSchema;
	}
	
	// Throws an error if any fields are `type` SimpleSchema but then also
	// have subfields defined outside of that.
	function checkSchemaOverlap(schema) {
	  _underscore2.default.each(schema, function (val, key) {
	    if (!val.type) throw new Error(key + ' key is missing "type"');
	    _underscore2.default.each(val.type.definitions, function (def) {
	      if (!(def.type instanceof SimpleSchema)) return;
	
	      _underscore2.default.each(def.type._schema, function (subVal, subKey) {
	        var newKey = key + '.' + subKey;
	        if (schema.hasOwnProperty(newKey)) {
	          throw new Error('The type for "' + key + '" is set to a SimpleSchema instance that defines "' + key + '.' + subKey + '", but the parent SimpleSchema instance also tries to define "' + key + '.' + subKey + '"');
	        }
	      });
	    });
	  });
	}
	
	/**
	 * @param {String} fieldName The full generic schema key
	 * @param {Boolean} shouldHumanize Humanize it
	 * @returns {String} A label based on the key
	 */
	function inflectedLabel(fieldName, shouldHumanize) {
	  var pieces = fieldName.split('.');
	  var label = void 0;
	  do {
	    label = pieces.pop();
	  } while (label === '$' && pieces.length);
	  return shouldHumanize ? (0, _humanize2.default)(label) : label;
	}
	
	function getDefaultAutoValueFunction(defaultValue) {
	  return function defaultAutoValueFunction() {
	    if (this.isSet) return;
	    if (this.operator === null) return defaultValue;
	    // We don't know whether it's an upsert, but if it's not, this seems to be ignored,
	    // so this is a safe way to make sure the default value is added on upsert insert.
	    return { $setOnInsert: defaultValue };
	  };
	}
	
	function checkAndScrubDefinition(fieldName, definition, options, fullSchemaObj) {
	  var internalDefinition = _extends({}, definition);
	
	  // Internally, all definition types are stored as groups for simplicity of access
	  if (!(internalDefinition.type instanceof _SimpleSchemaGroup2.default)) {
	    internalDefinition.type = new _SimpleSchemaGroup2.default(_underscore2.default.pick(internalDefinition, oneOfProps));
	  }
	
	  // Limit to only the non-oneOf props
	  internalDefinition = _underscore2.default.omit(internalDefinition, _underscore2.default.without(oneOfProps, 'type'));
	
	  // Validate the field definition
	  _underscore2.default.each(internalDefinition, function (val, key) {
	    if (schemaDefinitionOptions.indexOf(key) === -1) {
	      throw new Error('Invalid definition for ' + fieldName + ' field: "' + key + '" is not a supported property');
	    }
	  });
	
	  // Make sure the `type`s are OK
	  internalDefinition.type.definitions.forEach(function (_ref3) {
	    var blackbox = _ref3.blackbox;
	    var type = _ref3.type;
	
	    if (!type) throw new Error('Invalid definition for ' + fieldName + ' field: "type" option is required');
	
	    if (Array.isArray(type)) {
	      throw new Error('Invalid definition for ' + fieldName + ' field: "type" may not be an array. Change it to Array.');
	    }
	
	    if (type instanceof SimpleSchema) {
	      _underscore2.default.each(type._schema, function (subVal, subKey) {
	        var newKey = fieldName + '.' + subKey;
	        if (fullSchemaObj.hasOwnProperty(newKey)) {
	          throw new Error('The type for "' + fieldName + '" is set to a SimpleSchema instance that defines "' + newKey + '", but the parent SimpleSchema instance also tries to define "' + newKey + '"');
	        }
	      });
	    }
	
	    // If any of the valid types are blackbox, mark blackbox on the overall definition
	    if (blackbox === true) internalDefinition.blackbox = true;
	  });
	
	  // defaultValue -> autoValue
	  // We support defaultValue shortcut by converting it immediately into an
	  // autoValue.
	  if ('defaultValue' in internalDefinition) {
	    if ('autoValue' in internalDefinition) {
	      console.warn('SimpleSchema: Found both autoValue and defaultValue options for "' + fieldName + '". Ignoring defaultValue.');
	    } else {
	      if (fieldName.endsWith('.$')) {
	        throw new Error('An array item field (one that ends with ".$") cannot have defaultValue.');
	      }
	      internalDefinition.autoValue = getDefaultAutoValueFunction(internalDefinition.defaultValue);
	      delete internalDefinition.defaultValue;
	    }
	  }
	
	  // REQUIREDNESS
	  if (fieldName.endsWith('.$')) {
	    internalDefinition.optional = true;
	  } else {
	    if (!internalDefinition.hasOwnProperty('optional')) {
	      if (internalDefinition.hasOwnProperty('required')) {
	        if (typeof internalDefinition.required === 'function') {
	          internalDefinition.optional = function optional() {
	            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	              args[_key3] = arguments[_key3];
	            }
	
	            return !internalDefinition.required.apply(this, args);
	          };
	        } else {
	          internalDefinition.optional = !internalDefinition.required;
	        }
	      } else {
	        internalDefinition.optional = options.requiredByDefault === false;
	      }
	    }
	  }
	
	  delete internalDefinition.required;
	
	  // LABELS
	  if (!internalDefinition.hasOwnProperty('label')) {
	    if (options.defaultLabel) {
	      internalDefinition.label = options.defaultLabel;
	    } else if (SimpleSchema.defaultLabel) {
	      internalDefinition.label = SimpleSchema.defaultLabel;
	    } else {
	      internalDefinition.label = inflectedLabel(fieldName, options.humanizeAutoLabels);
	    }
	  }
	
	  return internalDefinition;
	}
	
	function getPickOrOmit(type) {
	  return function pickOrOmit() {
	    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    // If they are picking/omitting an object or array field, we need to also include everything under it
	    var newSchema = {};
	    _underscore2.default.each(this._schema, function (value, key) {
	      // Pick/omit it if it IS in the array of keys they want OR if it
	      // STARTS WITH something that is in the array plus a period
	      var includeIt = _underscore2.default.any(args, function (wantedField) {
	        return key === wantedField || key.indexOf(wantedField + '.') === 0;
	      });
	
	      if (includeIt && type === 'pick' || !includeIt && type === 'omit') {
	        newSchema[key] = value;
	      }
	    });
	
	    return new SimpleSchema(newSchema);
	  };
	}
	
	exports.SimpleSchema = SimpleSchema;
	exports.ValidationContext = _ValidationContext2.default;

/***/ },

/***/ "./node_modules/simpl-schema/node_modules/deep-extend/lib/deep-extend.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * @description Recursive object extending
	 * @author Viacheslav Lotsmanov <lotsmanov89@gmail.com>
	 * @license MIT
	 *
	 * The MIT License (MIT)
	 *
	 * Copyright (c) 2013-2015 Viacheslav Lotsmanov
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of
	 * this software and associated documentation files (the "Software"), to deal in
	 * the Software without restriction, including without limitation the rights to
	 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
	 * the Software, and to permit persons to whom the Software is furnished to do so,
	 * subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
	 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
	 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
	 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	'use strict';
	
	function isSpecificValue(val) {
		return (
			val instanceof Buffer
			|| val instanceof Date
			|| val instanceof RegExp
		) ? true : false;
	}
	
	function cloneSpecificValue(val) {
		if (val instanceof Buffer) {
			var x = new Buffer(val.length);
			val.copy(x);
			return x;
		} else if (val instanceof Date) {
			return new Date(val.getTime());
		} else if (val instanceof RegExp) {
			return new RegExp(val);
		} else {
			throw new Error('Unexpected situation');
		}
	}
	
	/**
	 * Recursive cloning array.
	 */
	function deepCloneArray(arr) {
		var clone = [];
		arr.forEach(function (item, index) {
			if (typeof item === 'object' && item !== null) {
				if (Array.isArray(item)) {
					clone[index] = deepCloneArray(item);
				} else if (isSpecificValue(item)) {
					clone[index] = cloneSpecificValue(item);
				} else {
					clone[index] = deepExtend({}, item);
				}
			} else {
				clone[index] = item;
			}
		});
		return clone;
	}
	
	/**
	 * Extening object that entered in first argument.
	 *
	 * Returns extended object or false if have no target object or incorrect type.
	 *
	 * If you wish to clone source object (without modify it), just use empty new
	 * object as first argument, like this:
	 *   deepExtend({}, yourObj_1, [yourObj_N]);
	 */
	var deepExtend = module.exports = function (/*obj_1, [obj_2], [obj_N]*/) {
		if (arguments.length < 1 || typeof arguments[0] !== 'object') {
			return false;
		}
	
		if (arguments.length < 2) {
			return arguments[0];
		}
	
		var target = arguments[0];
	
		// convert arguments to array and cut off target object
		var args = Array.prototype.slice.call(arguments, 1);
	
		var val, src, clone;
	
		args.forEach(function (obj) {
			// skip argument if it is array or isn't object
			if (typeof obj !== 'object' || Array.isArray(obj)) {
				return;
			}
	
			Object.keys(obj).forEach(function (key) {
				src = target[key]; // source value
				val = obj[key]; // new value
	
				// recursion prevention
				if (val === target) {
					return;
	
				/**
				 * if new value isn't object then just overwrite by new value
				 * instead of extending.
				 */
				} else if (typeof val !== 'object' || val === null) {
					target[key] = val;
					return;
	
				// just clone arrays (and recursive clone objects inside)
				} else if (Array.isArray(val)) {
					target[key] = deepCloneArray(val);
					return;
	
				// custom cloning and overwrite for specific objects
				} else if (isSpecificValue(val)) {
					target[key] = cloneSpecificValue(val);
					return;
	
				// overwrite by new value if source isn't object or array
				} else if (typeof src !== 'object' || src === null || Array.isArray(src)) {
					target[key] = deepExtend({}, val);
					return;
	
				// source value and new value is objects both, extending...
				} else {
					target[key] = deepExtend(src, val);
					return;
				}
			});
		});
	
		return target;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ },

/***/ "./node_modules/node-libs-browser/node_modules/buffer/index.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__("./node_modules/node-libs-browser/node_modules/base64-js/index.js")
	var ieee754 = __webpack_require__("./node_modules/ieee754/index.js")
	var isArray = __webpack_require__("./node_modules/isarray/index.js")
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer, (function() { return this; }())))

/***/ },

/***/ "./node_modules/node-libs-browser/node_modules/base64-js/index.js":
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },

/***/ "./node_modules/ieee754/index.js":
/***/ function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },

/***/ "./node_modules/isarray/index.js":
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },

/***/ "./node_modules/mongo-object/dist/mongo-object.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var REMOVED_MARKER = '______MONGO_OBJECT_REMOVED______';
	
	var MongoObject = function () {
	  /*
	   * @constructor
	   * @param {Object} obj
	   * @param {string[]}  blackboxKeys  - A list of the names of keys that shouldn't be traversed
	   * @returns {undefined}
	   *
	   * Creates a new MongoObject instance. The object passed as the first argument
	   * will be modified in place by calls to instance methods. Also, immediately
	   * upon creation of the instance, the object will have any `undefined` keys
	   * removed recursively.
	   */
	
	  function MongoObject(obj) {
	    var blackboxKeys = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	
	    _classCallCheck(this, MongoObject);
	
	    this._obj = obj;
	    this._blackboxKeys = blackboxKeys;
	    this._reParseObj();
	  }
	
	  _createClass(MongoObject, [{
	    key: '_reParseObj',
	    value: function _reParseObj() {
	      var blackboxKeys = this._blackboxKeys;
	
	      this._affectedKeys = {};
	      this._genericAffectedKeys = {};
	      this._parentPositions = [];
	      this._positionsInsideArrays = [];
	      this._objectPositions = [];
	      this._arrayItemPositions = [];
	
	      function parseObj(_this, val, currentPosition, affectedKey, operator, adjusted, isWithinArray) {
	        // Adjust for first-level modifier operators
	        if (!operator && affectedKey && affectedKey.substring(0, 1) === '$') {
	          operator = affectedKey;
	          affectedKey = null;
	        }
	
	        var affectedKeyIsBlackBox = false;
	        var stop = false;
	        if (affectedKey) {
	          // Adjust for $push and $addToSet and $pull and $pop
	          if (!adjusted) {
	            if (operator === '$push' || operator === '$addToSet' || operator === '$pop') {
	              // Adjust for $each
	              // We can simply jump forward and pretend like the $each array
	              // is the array for the field. This has the added benefit of
	              // skipping past any $slice, which we also don't care about.
	              if (MongoObject.isBasicObject(val) && '$each' in val) {
	                val = val.$each;
	                currentPosition = currentPosition + '[$each]';
	              } else {
	                affectedKey = affectedKey + '.0';
	              }
	
	              adjusted = true;
	            } else if (operator === '$pull') {
	              affectedKey = affectedKey + '.0';
	              if (MongoObject.isBasicObject(val)) {
	                stop = true;
	              }
	
	              adjusted = true;
	            }
	          }
	
	          // Make generic key
	          var affectedKeyGeneric = MongoObject.makeKeyGeneric(affectedKey);
	
	          // Determine whether affected key should be treated as a black box
	          affectedKeyIsBlackBox = blackboxKeys.indexOf(affectedKeyGeneric) > -1;
	
	          // Mark that this position affects this generic and non-generic key
	          if (currentPosition) {
	            _this._affectedKeys[currentPosition] = affectedKey;
	            _this._genericAffectedKeys[currentPosition] = affectedKeyGeneric;
	
	            // If we're within an array, mark this position so we can omit it from flat docs
	            if (isWithinArray) _this._positionsInsideArrays.push(currentPosition);
	          }
	        }
	
	        if (stop) return;
	
	        // Loop through arrays
	        if (Array.isArray(val) && val.length > 0) {
	          if (currentPosition) {
	            // Mark positions with arrays that should be ignored when we want endpoints only
	            _this._parentPositions.push(currentPosition);
	          }
	
	          // Loop
	          _lodash2.default.each(val, function (v, i) {
	            if (currentPosition) _this._arrayItemPositions.push(currentPosition + '[' + i + ']');
	            parseObj(_this, v, currentPosition ? currentPosition + '[' + i + ']' : i, affectedKey + '.' + i, operator, adjusted, true);
	          });
	        } else if (MongoObject.isBasicObject(val) && !affectedKeyIsBlackBox || !currentPosition) {
	          // Loop through object keys, only for basic objects,
	          // but always for the passed-in object, even if it
	          // is a custom object.
	
	          if (currentPosition && !_lodash2.default.isEmpty(val)) {
	            // Mark positions with objects that should be ignored when we want endpoints only
	            _this._parentPositions.push(currentPosition);
	
	            // Mark positions with objects that should be left out of flat docs.
	            _this._objectPositions.push(currentPosition);
	          }
	
	          // Loop
	          _lodash2.default.each(val, function (v, k) {
	            if (v === void 0) {
	              delete val[k];
	            } else if (k !== '$slice') {
	              parseObj(_this, v, currentPosition ? currentPosition + '[' + k + ']' : k, appendAffectedKey(affectedKey, k), operator, adjusted, isWithinArray);
	            }
	          });
	        }
	      }
	
	      parseObj(this, this._obj);
	    }
	
	    /**
	     * @method MongoObject.forEachNode
	     * @param {Function} func
	     * @param {Object} [options]
	     * @param {Boolean} [options.endPointsOnly=true] - Only call function for endpoints and not for nodes that contain other nodes
	     * @returns {undefined}
	     *
	     * Runs a function for each endpoint node in the object tree, including all items in every array.
	     * The function arguments are
	     * (1) the value at this node
	     * (2) a string representing the node position
	     * (3) the representation of what would be changed in mongo, using mongo dot notation
	     * (4) the generic equivalent of argument 3, with '$' instead of numeric pieces
	     */
	
	  }, {
	    key: 'forEachNode',
	    value: function forEachNode(func) {
	      var _this2 = this;
	
	      var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      var _ref$endPointsOnly = _ref.endPointsOnly;
	      var endPointsOnly = _ref$endPointsOnly === undefined ? true : _ref$endPointsOnly;
	
	      if (typeof func !== 'function') throw new Error('filter requires a loop function');
	
	      var updatedValues = {};
	      _lodash2.default.each(this._affectedKeys, function (affectedKey, position) {
	        if (endPointsOnly && _this2._parentPositions.indexOf(position) > -1) return; // Only endpoints
	        func.call({
	          value: _this2.getValueForPosition(position),
	          isArrayItem: _this2._arrayItemPositions.indexOf(position) > -1,
	          operator: extractOp(position),
	          position: position,
	          key: affectedKey,
	          genericKey: _this2._genericAffectedKeys[position],
	          updateValue: function updateValue(newVal) {
	            updatedValues[position] = newVal;
	          },
	          remove: function remove() {
	            updatedValues[position] = undefined;
	          }
	        });
	      });
	
	      // Actually update/remove values as instructed
	      _lodash2.default.each(updatedValues, function (newVal, position) {
	        _this2.setValueForPosition(position, newVal);
	      });
	    }
	  }, {
	    key: 'getValueForPosition',
	    value: function getValueForPosition(position) {
	      var subkeys = position.split('[');
	      var current = this._obj;
	      var ln = subkeys.length;
	      for (var i = 0; i < ln; i++) {
	        var subkey = subkeys[i];
	
	        // If the subkey ends in ']', remove the ending
	        if (subkey.slice(-1) === ']') subkey = subkey.slice(0, -1);
	        current = current[subkey];
	        if (!Array.isArray(current) && !MongoObject.isBasicObject(current) && i < ln - 1) return;
	      }
	
	      if (current === REMOVED_MARKER) return;
	      return current;
	    }
	
	    /**
	     * @method MongoObject.prototype.setValueForPosition
	     * @param {String} position
	     * @param {Any} value
	     * @returns {undefined}
	     */
	
	  }, {
	    key: 'setValueForPosition',
	    value: function setValueForPosition(position, value) {
	      var subkeys = position.split('[');
	      var current = this._obj;
	      var ln = subkeys.length;
	
	      for (var i = 0; i < ln; i++) {
	        var subkey = subkeys[i];
	
	        // If the subkey ends in "]", remove the ending
	        if (subkey.slice(-1) === ']') subkey = subkey.slice(0, -1);
	
	        // If we've reached the key in the object tree that needs setting or
	        // deleting, do it.
	        if (i === ln - 1) {
	          // If value is undefined, delete the property
	          if (value === undefined) {
	            if (Array.isArray(current)) {
	              // We can't just delete it because indexes in the position strings will be off
	              // We will mark it uniquely and then parse this elsewhere
	              current[subkey] = REMOVED_MARKER;
	            } else {
	              delete current[subkey];
	            }
	          } else {
	            current[subkey] = value;
	          }
	        } else {
	          // Otherwise attempt to keep moving deeper into the object.
	          // If we're setting (as opposed to deleting) a key and we hit a place
	          // in the ancestor chain where the keys are not yet created, create them.
	          if (current[subkey] === undefined && value !== undefined) {
	            // See if the next piece is a number
	            var nextPiece = subkeys[i + 1];
	            nextPiece = parseInt(nextPiece, 10);
	            current[subkey] = isNaN(nextPiece) ? {} : [];
	          }
	
	          // Move deeper into the object
	          current = current[subkey];
	
	          // If we can go no further, then quit
	          if (!Array.isArray(current) && !MongoObject.isBasicObject(current) && i < ln - 1) return;
	        }
	      }
	
	      this._reParseObj();
	    }
	
	    /**
	     * @method MongoObject.prototype.removeValueForPosition
	     * @param {String} position
	     * @returns {undefined}
	     */
	
	  }, {
	    key: 'removeValueForPosition',
	    value: function removeValueForPosition(position) {
	      this.setValueForPosition(position, undefined);
	    }
	
	    /**
	     * @method MongoObject.prototype.getKeyForPosition
	     * @param {String} position
	     * @returns {undefined}
	     */
	
	  }, {
	    key: 'getKeyForPosition',
	    value: function getKeyForPosition(position) {
	      return this._affectedKeys[position];
	    }
	
	    /**
	     * @method MongoObject.prototype.getGenericKeyForPosition
	     * @param {String} position
	     * @returns {undefined}
	     */
	
	  }, {
	    key: 'getGenericKeyForPosition',
	    value: function getGenericKeyForPosition(position) {
	      return this._genericAffectedKeys[position];
	    }
	
	    /**
	     * @method MongoObject.getInfoForKey
	     * @param {String} key - Non-generic key
	     * @returns {undefined|Object}
	     *
	     * Returns the value and operator of the requested non-generic key.
	     * Example: {value: 1, operator: "$pull"}
	     */
	
	  }, {
	    key: 'getInfoForKey',
	    value: function getInfoForKey(key) {
	      // Get the info
	      var position = this.getPositionForKey(key);
	      if (position) {
	        return {
	          value: this.getValueForPosition(position),
	          operator: extractOp(position)
	        };
	      }
	
	      // If we haven't returned yet, check to see if there is an array value
	      // corresponding to this key
	      // We find the first item within the array, strip the last piece off the
	      // position string, and then return whatever is at that new position in
	      // the original object.
	      var positions = this.getPositionsForGenericKey(key + '.$');
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = positions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var pos = _step.value;
	
	          var value = this.getValueForPosition(pos);
	          if (value === undefined) {
	            var parentPosition = pos.slice(0, pos.lastIndexOf('['));
	            value = this.getValueForPosition(parentPosition);
	          }
	
	          if (value !== undefined) {
	            return {
	              value: value,
	              operator: extractOp(pos)
	            };
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	
	    /**
	     * @method MongoObject.getPositionForKey
	     * @param {String} key - Non-generic key
	     * @returns {undefined|String} Position string
	     *
	     * Returns the position string for the place in the object that
	     * affects the requested non-generic key.
	     * Example: 'foo[bar][0]'
	     */
	
	  }, {
	    key: 'getPositionForKey',
	    value: function getPositionForKey(key) {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = Object.getOwnPropertyNames(this._affectedKeys)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var position = _step2.value;
	
	          // We return the first one we find. While it's
	          // possible that multiple update operators could
	          // affect the same non-generic key, we'll assume that's not the case.
	          if (this._affectedKeys[position] === key) return position;
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	
	    /**
	     * @method MongoObject.getPositionsForGenericKey
	     * @param {String} key - Generic key
	     * @returns {String[]} Array of position strings
	     *
	     * Returns an array of position strings for the places in the object that
	     * affect the requested generic key.
	     * Example: ['foo[bar][0]']
	     */
	
	  }, {
	    key: 'getPositionsForGenericKey',
	    value: function getPositionsForGenericKey(key) {
	      var list = [];
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = Object.getOwnPropertyNames(this._genericAffectedKeys)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var position = _step3.value;
	
	          if (this._genericAffectedKeys[position] === key) list.push(position);
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      return list;
	    }
	
	    /**
	     * @method MongoObject.getPositionsInfoForGenericKey
	     * @param {String} genericKey - Generic key
	     * @returns {Object[]} Array of position info objects
	     *
	     * Returns an array of position info for the places in the object that
	     * affect the requested generic key.
	     * Example: ['foo[bar][0]']
	     */
	
	  }, {
	    key: 'getPositionsInfoForGenericKey',
	    value: function getPositionsInfoForGenericKey(genericKey) {
	      var _this3 = this;
	
	      var exactPositions = [];
	      var arrayItemPositions = [];
	
	      for (var position in this._genericAffectedKeys) {
	        if (this._genericAffectedKeys.hasOwnProperty(position)) {
	          var affectedKey = this._genericAffectedKeys[position];
	          if (affectedKey === genericKey) {
	            exactPositions.push(position);
	          } else if (affectedKey === genericKey + '.$') {
	            arrayItemPositions.push(position);
	          }
	        }
	      }
	
	      var list = exactPositions.length ? exactPositions : arrayItemPositions;
	
	      return list.map(function (position) {
	        var value = _this3.getValueForPosition(position);
	        var key = MongoObject._positionToKey(position);
	        var operator = extractOp(position);
	        return {
	          key: key,
	          value: value,
	          operator: operator,
	          position: position
	        };
	      });
	    }
	
	    /**
	     * @deprecated Use getInfoForKey
	     * @method MongoObject.getValueForKey
	     * @param {String} key - Non-generic key
	     * @returns {undefined|Any}
	     *
	     * Returns the value of the requested non-generic key
	     */
	
	  }, {
	    key: 'getValueForKey',
	    value: function getValueForKey(key) {
	      var position = this.getPositionForKey(key);
	      if (position) return this.getValueForPosition(position);
	    }
	
	    /**
	     * @method MongoObject.prototype.addKey
	     * @param {String} key - Key to set
	     * @param {Any} val - Value to give this key
	     * @param {String} op - Operator under which to set it, or `null` for a non-modifier object
	     * @returns {undefined}
	     *
	     * Adds `key` with value `val` under operator `op` to the source object.
	     */
	
	  }, {
	    key: 'addKey',
	    value: function addKey(key, val, op) {
	      var position = op ? op + '[' + key + ']' : MongoObject._keyToPosition(key);
	      this.setValueForPosition(position, val);
	    }
	
	    /**
	     * @method MongoObject.prototype.removeGenericKeys
	     * @param {String[]} keys
	     * @returns {undefined}
	     *
	     * Removes anything that affects any of the generic keys in the list
	     */
	
	  }, {
	    key: 'removeGenericKeys',
	    value: function removeGenericKeys(keys) {
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = Object.getOwnPropertyNames(this._genericAffectedKeys)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var position = _step4.value;
	
	          if (keys.indexOf(this._genericAffectedKeys[position]) > -1) {
	            this.removeValueForPosition(position);
	          }
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	    }
	
	    /**
	     * @method MongoObject.removeGenericKey
	     * @param {String} key
	     * @returns {undefined}
	     *
	     * Removes anything that affects the requested generic key
	     */
	
	  }, {
	    key: 'removeGenericKey',
	    value: function removeGenericKey(key) {
	      var _iteratorNormalCompletion5 = true;
	      var _didIteratorError5 = false;
	      var _iteratorError5 = undefined;
	
	      try {
	        for (var _iterator5 = Object.getOwnPropertyNames(this._genericAffectedKeys)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	          var position = _step5.value;
	
	          if (this._genericAffectedKeys[position] === key) {
	            this.removeValueForPosition(position);
	          }
	        }
	      } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion5 && _iterator5.return) {
	            _iterator5.return();
	          }
	        } finally {
	          if (_didIteratorError5) {
	            throw _iteratorError5;
	          }
	        }
	      }
	    }
	
	    /**
	     * @method MongoObject.removeKey
	     * @param {String} key
	     * @returns {undefined}
	     *
	     * Removes anything that affects the requested non-generic key
	     */
	
	  }, {
	    key: 'removeKey',
	    value: function removeKey(key) {
	      // We don't use getPositionForKey here because we want to be sure to
	      // remove for all positions if there are multiple.
	      var _iteratorNormalCompletion6 = true;
	      var _didIteratorError6 = false;
	      var _iteratorError6 = undefined;
	
	      try {
	        for (var _iterator6 = Object.getOwnPropertyNames(this._affectedKeys)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	          var position = _step6.value;
	
	          if (this._affectedKeys[position] === key) {
	            this.removeValueForPosition(position);
	          }
	        }
	      } catch (err) {
	        _didIteratorError6 = true;
	        _iteratorError6 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion6 && _iterator6.return) {
	            _iterator6.return();
	          }
	        } finally {
	          if (_didIteratorError6) {
	            throw _iteratorError6;
	          }
	        }
	      }
	    }
	
	    /**
	     * @method MongoObject.removeKeys
	     * @param {String[]} keys
	     * @returns {undefined}
	     *
	     * Removes anything that affects any of the non-generic keys in the list
	     */
	
	  }, {
	    key: 'removeKeys',
	    value: function removeKeys(keys) {
	      var _iteratorNormalCompletion7 = true;
	      var _didIteratorError7 = false;
	      var _iteratorError7 = undefined;
	
	      try {
	        for (var _iterator7 = keys[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	          var key = _step7.value;
	
	          this.removeKey(key);
	        }
	      } catch (err) {
	        _didIteratorError7 = true;
	        _iteratorError7 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion7 && _iterator7.return) {
	            _iterator7.return();
	          }
	        } finally {
	          if (_didIteratorError7) {
	            throw _iteratorError7;
	          }
	        }
	      }
	    }
	
	    /**
	     * @method MongoObject.filterGenericKeys
	     * @param {Function} test - Test function
	     * @returns {undefined}
	     *
	     * Passes all affected keys to a test function, which
	     * should return false to remove whatever is affecting that key
	     */
	
	  }, {
	    key: 'filterGenericKeys',
	    value: function filterGenericKeys(test) {
	      var checkedKeys = [];
	      var keysToRemove = [];
	      for (var position in this._genericAffectedKeys) {
	        if (this._genericAffectedKeys.hasOwnProperty(position)) {
	          var genericKey = this._genericAffectedKeys[position];
	          if (checkedKeys.indexOf(genericKey) === -1) {
	            checkedKeys.push(genericKey);
	            if (genericKey && !test(genericKey)) {
	              keysToRemove.push(genericKey);
	            }
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion8 = true;
	      var _didIteratorError8 = false;
	      var _iteratorError8 = undefined;
	
	      try {
	        for (var _iterator8 = keysToRemove[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	          var key = _step8.value;
	
	          this.removeGenericKey(key);
	        }
	      } catch (err) {
	        _didIteratorError8 = true;
	        _iteratorError8 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion8 && _iterator8.return) {
	            _iterator8.return();
	          }
	        } finally {
	          if (_didIteratorError8) {
	            throw _iteratorError8;
	          }
	        }
	      }
	    }
	
	    /**
	     * @method MongoObject.setValueForKey
	     * @param {String} key
	     * @param {Any} val
	     * @returns {undefined}
	     *
	     * Sets the value for every place in the object that affects
	     * the requested non-generic key
	     */
	
	  }, {
	    key: 'setValueForKey',
	    value: function setValueForKey(key, val) {
	      // We don't use getPositionForKey here because we want to be sure to
	      // set the value for all positions if there are multiple.
	      var _iteratorNormalCompletion9 = true;
	      var _didIteratorError9 = false;
	      var _iteratorError9 = undefined;
	
	      try {
	        for (var _iterator9 = Object.getOwnPropertyNames(this._affectedKeys)[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	          var position = _step9.value;
	
	          if (this._affectedKeys[position] === key) {
	            this.setValueForPosition(position, val);
	          }
	        }
	      } catch (err) {
	        _didIteratorError9 = true;
	        _iteratorError9 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion9 && _iterator9.return) {
	            _iterator9.return();
	          }
	        } finally {
	          if (_didIteratorError9) {
	            throw _iteratorError9;
	          }
	        }
	      }
	    }
	
	    /**
	     * @method MongoObject.setValueForGenericKey
	     * @param {String} key
	     * @param {Any} val
	     * @returns {undefined}
	     *
	     * Sets the value for every place in the object that affects
	     * the requested generic key
	     */
	
	  }, {
	    key: 'setValueForGenericKey',
	    value: function setValueForGenericKey(key, val) {
	      // We don't use getPositionForKey here because we want to be sure to
	      // set the value for all positions if there are multiple.
	      var _iteratorNormalCompletion10 = true;
	      var _didIteratorError10 = false;
	      var _iteratorError10 = undefined;
	
	      try {
	        for (var _iterator10 = Object.getOwnPropertyNames(this._genericAffectedKeys)[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	          var position = _step10.value;
	
	          if (this._genericAffectedKeys[position] === key) {
	            this.setValueForPosition(position, val);
	          }
	        }
	      } catch (err) {
	        _didIteratorError10 = true;
	        _iteratorError10 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion10 && _iterator10.return) {
	            _iterator10.return();
	          }
	        } finally {
	          if (_didIteratorError10) {
	            throw _iteratorError10;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'removeArrayItems',
	    value: function removeArrayItems() {
	      // Traverse and pull out removed array items at this point
	      function traverse(obj) {
	        _lodash2.default.each(obj, function (val, indexOrProp) {
	          // Move deeper into the object
	          var next = obj[indexOrProp];
	
	          // If we can go no further, then quit
	          if (MongoObject.isBasicObject(next)) {
	            traverse(next);
	          } else if (Array.isArray(next)) {
	            obj[indexOrProp] = _lodash2.default.without(next, REMOVED_MARKER);
	            traverse(obj[indexOrProp]);
	          }
	        });
	      }
	
	      traverse(this._obj);
	    }
	
	    /**
	     * @method MongoObject.getObject
	     * @returns {Object}
	     *
	     * Get the source object, potentially modified by other method calls on this
	     * MongoObject instance.
	     */
	
	  }, {
	    key: 'getObject',
	    value: function getObject() {
	      return this._obj;
	    }
	
	    /**
	     * @method MongoObject.getFlatObject
	     * @returns {Object}
	     *
	     * Gets a flat object based on the MongoObject instance.
	     * In a flat object, the key is the name of the non-generic affectedKey,
	     * with mongo dot notation if necessary, and the value is the value for
	     * that key.
	     *
	     * With `keepArrays: true`, we don't flatten within arrays. Currently
	     * MongoDB does not see a key such as `a.0.b` and automatically assume
	     * an array. Instead it would create an object with key '0' if there
	     * wasn't already an array saved as the value of `a`, which is rarely
	     * if ever what we actually want. To avoid this confusion, we
	     * set entire arrays.
	     */
	
	  }, {
	    key: 'getFlatObject',
	    value: function getFlatObject() {
	      var _this4 = this;
	
	      var _ref2 = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      var _ref2$keepArrays = _ref2.keepArrays;
	      var keepArrays = _ref2$keepArrays === undefined ? false : _ref2$keepArrays;
	
	      var newObj = {};
	      _lodash2.default.each(this._affectedKeys, function (affectedKey, position) {
	        if (typeof affectedKey === 'string' && keepArrays === true && _this4._positionsInsideArrays.indexOf(position) === -1 && _this4._objectPositions.indexOf(position) === -1 || keepArrays !== true && _this4._parentPositions.indexOf(position) === -1) {
	          newObj[affectedKey] = _this4.getValueForPosition(position);
	        }
	      });
	      return newObj;
	    }
	
	    /**
	     * @method MongoObject.affectsKey
	     * @param {String} key
	     * @returns {Object}
	     *
	     * Returns true if the non-generic key is affected by this object
	     */
	
	  }, {
	    key: 'affectsKey',
	    value: function affectsKey(key) {
	      return !!this.getPositionForKey(key);
	    }
	
	    /**
	     * @method MongoObject.affectsGenericKey
	     * @param {String} key
	     * @returns {Object}
	     *
	     * Returns true if the generic key is affected by this object
	     */
	
	  }, {
	    key: 'affectsGenericKey',
	    value: function affectsGenericKey(key) {
	      var _iteratorNormalCompletion11 = true;
	      var _didIteratorError11 = false;
	      var _iteratorError11 = undefined;
	
	      try {
	        for (var _iterator11 = Object.getOwnPropertyNames(this._genericAffectedKeys)[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	          var position = _step11.value;
	
	          if (this._genericAffectedKeys[position] === key) return true;
	        }
	      } catch (err) {
	        _didIteratorError11 = true;
	        _iteratorError11 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion11 && _iterator11.return) {
	            _iterator11.return();
	          }
	        } finally {
	          if (_didIteratorError11) {
	            throw _iteratorError11;
	          }
	        }
	      }
	
	      return false;
	    }
	
	    /**
	     * @method MongoObject.affectsGenericKeyImplicit
	     * @param {String} key
	     * @returns {Object}
	     *
	     * Like affectsGenericKey, but will return true if a child key is affected
	     */
	
	  }, {
	    key: 'affectsGenericKeyImplicit',
	    value: function affectsGenericKeyImplicit(key) {
	      var _iteratorNormalCompletion12 = true;
	      var _didIteratorError12 = false;
	      var _iteratorError12 = undefined;
	
	      try {
	        for (var _iterator12 = Object.getOwnPropertyNames(this._genericAffectedKeys)[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
	          var position = _step12.value;
	
	          var affectedKey = this._genericAffectedKeys[position];
	          if (genericKeyAffectsOtherGenericKey(key, affectedKey)) return true;
	        }
	      } catch (err) {
	        _didIteratorError12 = true;
	        _iteratorError12 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion12 && _iterator12.return) {
	            _iterator12.return();
	          }
	        } finally {
	          if (_didIteratorError12) {
	            throw _iteratorError12;
	          }
	        }
	      }
	
	      return false;
	    }
	
	    /* STATIC */
	
	    /* Takes a specific string that uses mongo-style dot notation
	     * and returns a generic string equivalent. Replaces all numeric
	     * "pieces" with a dollar sign ($).
	     *
	     * @param {type} name
	     * @returns {String} Generic name.
	     */
	
	  }], [{
	    key: 'makeKeyGeneric',
	    value: function makeKeyGeneric(key) {
	      if (typeof key !== 'string') return null;
	      return key.replace(/\.[0-9]+(?=\.|$)/g, '.$');
	    }
	
	    /** Takes a string representation of an object key and its value
	     *  and updates "obj" to contain that key with that value.
	     *
	     *  Example keys and results if val is 1:
	     *    "a" -> {a: 1}
	     *    "a[b]" -> {a: {b: 1}}
	     *    "a[b][0]" -> {a: {b: [1]}}
	     *    'a[b.0.c]' -> {a: {'b.0.c': 1}}
	     *
	     * @param {any} val
	     * @param {String} key
	     * @param {Object} obj
	     * @returns {undefined}
	     */
	
	  }, {
	    key: 'expandKey',
	    value: function expandKey(val, key, obj) {
	      var subkeys = key.split('[');
	      var current = obj;
	      for (var i = 0, ln = subkeys.length; i < ln; i++) {
	        var subkey = subkeys[i];
	        if (subkey.slice(-1) === ']') {
	          subkey = subkey.slice(0, -1);
	        }
	
	        if (i === ln - 1) {
	          // Last iteration; time to set the value; always overwrite
	          current[subkey] = val;
	
	          // If val is undefined, delete the property
	          if (val === void 0) delete current[subkey];
	        } else {
	          // See if the next piece is a number
	          var nextPiece = subkeys[i + 1];
	          nextPiece = parseInt(nextPiece, 10);
	          if (!current[subkey]) {
	            current[subkey] = isNaN(nextPiece) ? {} : [];
	          }
	        }
	
	        current = current[subkey];
	      }
	    }
	  }, {
	    key: '_keyToPosition',
	    value: function _keyToPosition(key, wrapAll) {
	      var position = '';
	      _lodash2.default.each(key.split('.'), function (piece, i) {
	        if (i === 0 && !wrapAll) {
	          position += piece;
	        } else {
	          position += '[' + piece + ']';
	        }
	      });
	      return position;
	    }
	
	    /**
	     * @method MongoObject._positionToKey
	     * @param {String} position
	     * @returns {String} The key that this position in an object would affect.
	     *
	     * This is different from MongoObject.prototype.getKeyForPosition in that
	     * this method does not depend on the requested position actually being
	     * present in any particular MongoObject.
	     */
	
	  }, {
	    key: '_positionToKey',
	    value: function _positionToKey(position) {
	      // XXX Probably a better way to do this, but this is
	      // foolproof for now.
	      var mDoc = new MongoObject({});
	      mDoc.setValueForPosition(position, 1); // Value doesn't matter
	      return mDoc.getKeyForPosition(position);
	    }
	
	    /**
	     * @method MongoObject.cleanNulls
	     * @public
	     * @param {Object} doc - Source object
	     * @returns {Object}
	     *
	     * Returns an object in which all properties with null, undefined, or empty
	     * string values have been removed, recursively.
	     */
	
	  }, {
	    key: 'cleanNulls',
	    value: function cleanNulls(doc, isArray, keepEmptyStrings) {
	      var newDoc = isArray ? [] : {};
	      _lodash2.default.each(doc, function (val, key) {
	        if (!Array.isArray(val) && MongoObject.isBasicObject(val)) {
	          val = MongoObject.cleanNulls(val, false, keepEmptyStrings); // Recurse into plain objects
	          if (!_lodash2.default.isEmpty(val)) newDoc[key] = val;
	        } else if (Array.isArray(val)) {
	          val = MongoObject.cleanNulls(val, true, keepEmptyStrings); // Recurse into non-typed arrays
	          if (!_lodash2.default.isEmpty(val)) newDoc[key] = val;
	        } else if (!isNullUndefinedOrEmptyString(val)) {
	          newDoc[key] = val;
	        } else if (keepEmptyStrings && typeof val === 'string' && val.length === 0) {
	          newDoc[key] = val;
	        }
	      });
	      return newDoc;
	    }
	
	    /**
	     * @method MongoObject.reportNulls
	     * @public
	     * @param {Object} flatDoc - An object with no properties that are also objects.
	     * @returns {Object} An object in which the keys represent the keys in the
	     * original object that were null, undefined, or empty strings, and the value
	     * of each key is "".
	     */
	
	  }, {
	    key: 'reportNulls',
	    value: function reportNulls(flatDoc, keepEmptyStrings) {
	      var nulls = {};
	
	      // Loop through the flat doc
	      _lodash2.default.each(flatDoc, function (val, key) {
	        if (val === null || val === undefined || !keepEmptyStrings && typeof val === 'string' && val.length === 0 ||
	
	        // If value is an array in which all the values recursively are undefined, null,
	        // or an empty string
	        Array.isArray(val) && MongoObject.cleanNulls(val, true, keepEmptyStrings).length === 0) {
	          nulls[key] = '';
	        }
	      });
	      return nulls;
	    }
	
	    /**
	     * @method MongoObject.docToModifier
	     * @public
	     * @param {Object} doc - An object to be converted into a MongoDB modifier
	     * @param {Object} [options] - Options
	     * @param {Boolean} [options.keepEmptyStrings] - Pass `true` to keep empty strings in the $set. Otherwise $unset them.
	     * @param {Boolean} [options.keepArrays] - Pass `true` to $set entire arrays. Otherwise the modifier will $set individual array items.
	     * @returns {Object} A MongoDB modifier.
	     *
	     * Converts an object into a modifier by flattening it, putting keys with
	     * null, undefined, and empty string values into `modifier.$unset`, and
	     * putting the rest of the keys into `modifier.$set`.
	     */
	
	  }, {
	    key: 'docToModifier',
	    value: function docToModifier(doc) {
	      var _ref3 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      var _ref3$keepArrays = _ref3.keepArrays;
	      var keepArrays = _ref3$keepArrays === undefined ? false : _ref3$keepArrays;
	      var _ref3$keepEmptyString = _ref3.keepEmptyStrings;
	      var keepEmptyStrings = _ref3$keepEmptyString === undefined ? false : _ref3$keepEmptyString;
	
	      // Flatten doc
	      var mDoc = new MongoObject(doc);
	      var flatDoc = mDoc.getFlatObject({ keepArrays: keepArrays });
	
	      // Get a list of null, undefined, and empty string values so we can unset them instead
	      var nulls = MongoObject.reportNulls(flatDoc, keepEmptyStrings);
	      flatDoc = MongoObject.cleanNulls(flatDoc, false, keepEmptyStrings);
	
	      var modifier = {};
	      if (!_lodash2.default.isEmpty(flatDoc)) modifier.$set = flatDoc;
	      if (!_lodash2.default.isEmpty(nulls)) modifier.$unset = nulls;
	      return modifier;
	    }
	
	    /* Tests whether "obj" is an Object as opposed to
	     * something that inherits from Object
	     *
	     * @param {any} obj
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'isBasicObject',
	    value: function isBasicObject(obj) {
	      return obj === Object(obj) && Object.getPrototypeOf(obj) === Object.prototype;
	    }
	
	    /**
	     * @method MongoObject.objAffectsKey
	     * @public
	     * @param  {Object} obj
	     * @param  {String} key
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'objAffectsKey',
	    value: function objAffectsKey(obj, key) {
	      var mDoc = new MongoObject(obj);
	      return mDoc.affectsKey(key);
	    }
	
	    /**
	     * @method MongoObject.expandObj
	     * @public
	     * @param  {Object} doc
	     * @return {Object}
	     *
	     * Takes a flat object and returns an expanded version of it.
	     */
	
	  }, {
	    key: 'expandObj',
	    value: function expandObj(doc) {
	      var newDoc = {};
	      _lodash2.default.each(doc, function (val, key) {
	        var subkeys = key.split('.');
	        var subkeylen = subkeys.length;
	        var current = newDoc;
	        for (var i = 0; i < subkeylen; i++) {
	          var subkey = subkeys[i];
	          if (typeof current[subkey] !== 'undefined' && !_lodash2.default.isObject(current[subkey])) {
	            break; // Already set for some reason; leave it alone
	          }
	
	          if (i === subkeylen - 1) {
	            // Last iteration; time to set the value
	            current[subkey] = val;
	          } else {
	            // See if the next piece is a number
	            var nextPiece = subkeys[i + 1];
	            nextPiece = parseInt(nextPiece, 10);
	            if (isNaN(nextPiece) && !_lodash2.default.isObject(current[subkey])) {
	              current[subkey] = {};
	            } else if (!isNaN(nextPiece) && !Array.isArray(current[subkey])) {
	              current[subkey] = [];
	            }
	          }
	
	          current = current[subkey];
	        }
	      });
	      return newDoc;
	    }
	  }]);
	
	  return MongoObject;
	}();
	
	/* PRIVATE */
	
	exports.default = MongoObject;
	function appendAffectedKey(affectedKey, key) {
	  if (key === '$each') return affectedKey;
	  return affectedKey ? affectedKey + '.' + key : key;
	}
	
	// Extracts operator piece, if present, from position string
	function extractOp(position) {
	  var firstPositionPiece = position.slice(0, position.indexOf('['));
	  return firstPositionPiece.substring(0, 1) === '$' ? firstPositionPiece : null;
	}
	
	function genericKeyAffectsOtherGenericKey(key, affectedKey) {
	  // If the affected key is the test key
	  if (affectedKey === key) return true;
	
	  // If the affected key implies the test key because the affected key
	  // starts with the test key followed by a period
	  if (affectedKey.substring(0, key.length + 1) === key + '.') return true;
	
	  // If the affected key implies the test key because the affected key
	  // starts with the test key and the test key ends with ".$"
	  var lastTwo = key.slice(-2);
	  if (lastTwo === '.$' && key.slice(0, -2) === affectedKey) return true;
	
	  return false;
	}
	
	function isNullUndefinedOrEmptyString(val) {
	  return val === undefined || val === null || typeof val === 'string' && val.length === 0;
	}

/***/ },

/***/ "./node_modules/message-box/dist/MessageBox.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _handlebars = __webpack_require__("./node_modules/handlebars/dist/handlebars.js");
	
	var _handlebars2 = _interopRequireDefault(_handlebars);
	
	var _deepExtend = __webpack_require__("./node_modules/message-box/node_modules/deep-extend/lib/deep-extend.js");
	
	var _deepExtend2 = _interopRequireDefault(_deepExtend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MessageBox = function () {
	  function MessageBox() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var initialLanguage = _ref.initialLanguage;
	    var messages = _ref.messages;
	    var tracker = _ref.tracker;
	
	    _classCallCheck(this, MessageBox);
	
	    this.language = initialLanguage || MessageBox.language || 'en';
	    this.messageList = messages || {};
	    if (tracker) this.trackerDep = new tracker.Dependency();
	  }
	
	  _createClass(MessageBox, [{
	    key: 'messages',
	    value: function messages(_messages) {
	      (0, _deepExtend2.default)(this.messageList, _messages);
	    }
	  }, {
	    key: 'getMessages',
	    value: function getMessages(language) {
	      if (!language) {
	        language = this.language;
	        if (this.trackerDep) this.trackerDep.depend();
	      }
	
	      var globalMessages = MessageBox.messages[language];
	
	      var messages = this.messageList[language];
	      if (messages) {
	        if (globalMessages) messages = (0, _deepExtend2.default)({}, globalMessages, messages);
	      } else {
	        messages = globalMessages;
	      }
	
	      if (!messages) throw new Error('No messages found for language "' + language + '"');
	
	      return {
	        messages: messages,
	        language: language
	      };
	    }
	  }, {
	    key: 'message',
	    value: function message(errorInfo) {
	      var _ref2 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      var language = _ref2.language;
	      var context = _ref2.context;
	
	      // Error objects can optionally include a preformatted message,
	      // in which case we use that.
	      if (errorInfo.message) return errorInfo.message;
	
	      var fieldName = errorInfo.name;
	      var genericName = MessageBox.makeNameGeneric(fieldName);
	
	      var _getMessages = this.getMessages(language);
	
	      var messages = _getMessages.messages;
	
	      var message = messages[errorInfo.type];
	
	      var fullContext = _extends({
	        genericName: genericName
	      }, context, errorInfo);
	
	      if (message && (typeof message === 'undefined' ? 'undefined' : _typeof(message)) === 'object') message = message[genericName] || message._default; // eslint-disable-line no-underscore-dangle
	
	      if (typeof message === 'string') message = _handlebars2.default.compile(message);
	
	      if (typeof message !== 'function') return fieldName + ' is invalid';
	
	      return message(fullContext);
	    }
	  }, {
	    key: 'setLanguage',
	    value: function setLanguage(language) {
	      this.language = language;
	      if (this.trackerDep) this.trackerDep.changed();
	    }
	  }], [{
	    key: 'makeNameGeneric',
	    value: function makeNameGeneric(name) {
	      if (typeof name !== 'string') return null;
	      return name.replace(/\.[0-9]+(?=\.|$)/g, '.$');
	    }
	  }, {
	    key: 'defaults',
	    value: function defaults() {
	      var _ref3 = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      var initialLanguage = _ref3.initialLanguage;
	      var messages = _ref3.messages;
	
	      if (typeof initialLanguage === 'string') MessageBox.language = initialLanguage;
	
	      if (messages) {
	        if (!MessageBox.messages) MessageBox.messages = {};
	        (0, _deepExtend2.default)(MessageBox.messages, messages);
	      }
	    }
	  }]);
	
	  return MessageBox;
	}();
	
	MessageBox.messages = {};
	exports.default = MessageBox;

/***/ },

/***/ "./node_modules/handlebars/dist/handlebars.js":
/***/ function(module, exports, __webpack_require__) {

	/**!
	
	 @license magnet:?xt=urn:btih:d3d9a9a6595521f9666a5e94cc830dab83b65699&dn=expat.txt Expat
	 handlebars v4.0.5
	
	Copyright (C) 2011-2016 by Yehuda Katz
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	
	*/
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["Handlebars"] = factory();
		else
			root["Handlebars"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		// istanbul ignore next
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _handlebarsRuntime = __webpack_require__(1);
	
		var _handlebarsRuntime2 = _interopRequireDefault(_handlebarsRuntime);
	
		// Compiler imports
	
		var _handlebarsCompilerAst = __webpack_require__(19);
	
		var _handlebarsCompilerAst2 = _interopRequireDefault(_handlebarsCompilerAst);
	
		var _handlebarsCompilerBase = __webpack_require__(20);
	
		var _handlebarsCompilerCompiler = __webpack_require__(25);
	
		var _handlebarsCompilerJavascriptCompiler = __webpack_require__(26);
	
		var _handlebarsCompilerJavascriptCompiler2 = _interopRequireDefault(_handlebarsCompilerJavascriptCompiler);
	
		var _handlebarsCompilerVisitor = __webpack_require__(23);
	
		var _handlebarsCompilerVisitor2 = _interopRequireDefault(_handlebarsCompilerVisitor);
	
		var _handlebarsNoConflict = __webpack_require__(18);
	
		var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);
	
		var _create = _handlebarsRuntime2['default'].create;
		function create() {
		  var hb = _create();
	
		  hb.compile = function (input, options) {
		    return _handlebarsCompilerCompiler.compile(input, options, hb);
		  };
		  hb.precompile = function (input, options) {
		    return _handlebarsCompilerCompiler.precompile(input, options, hb);
		  };
	
		  hb.AST = _handlebarsCompilerAst2['default'];
		  hb.Compiler = _handlebarsCompilerCompiler.Compiler;
		  hb.JavaScriptCompiler = _handlebarsCompilerJavascriptCompiler2['default'];
		  hb.Parser = _handlebarsCompilerBase.parser;
		  hb.parse = _handlebarsCompilerBase.parse;
	
		  return hb;
		}
	
		var inst = create();
		inst.create = create;
	
		_handlebarsNoConflict2['default'](inst);
	
		inst.Visitor = _handlebarsCompilerVisitor2['default'];
	
		inst['default'] = inst;
	
		exports['default'] = inst;
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,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
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		// istanbul ignore next
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		// istanbul ignore next
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
		var _handlebarsBase = __webpack_require__(2);
	
		var base = _interopRequireWildcard(_handlebarsBase);
	
		// Each of these augment the Handlebars object. No need to setup here.
		// (This is done to easily share code between commonjs and browse envs)
	
		var _handlebarsSafeString = __webpack_require__(16);
	
		var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);
	
		var _handlebarsException = __webpack_require__(4);
	
		var _handlebarsException2 = _interopRequireDefault(_handlebarsException);
	
		var _handlebarsUtils = __webpack_require__(3);
	
		var Utils = _interopRequireWildcard(_handlebarsUtils);
	
		var _handlebarsRuntime = __webpack_require__(17);
	
		var runtime = _interopRequireWildcard(_handlebarsRuntime);
	
		var _handlebarsNoConflict = __webpack_require__(18);
	
		var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);
	
		// For compatibility and usage outside of module systems, make the Handlebars object a namespace
		function create() {
		  var hb = new base.HandlebarsEnvironment();
	
		  Utils.extend(hb, base);
		  hb.SafeString = _handlebarsSafeString2['default'];
		  hb.Exception = _handlebarsException2['default'];
		  hb.Utils = Utils;
		  hb.escapeExpression = Utils.escapeExpression;
	
		  hb.VM = runtime;
		  hb.template = function (spec) {
		    return runtime.template(spec, hb);
		  };
	
		  return hb;
		}
	
		var inst = create();
		inst.create = create;
	
		_handlebarsNoConflict2['default'](inst);
	
		inst['default'] = inst;
	
		exports['default'] = inst;
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9oYW5kbGViYXJzLnJ1bnRpbWUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OEJBQXNCLG1CQUFtQjs7SUFBN0IsSUFBSTs7Ozs7b0NBSU8sMEJBQTBCOzs7O21DQUMzQix3QkFBd0I7Ozs7K0JBQ3ZCLG9CQUFvQjs7SUFBL0IsS0FBSzs7aUNBQ1Esc0JBQXNCOztJQUFuQyxPQUFPOztvQ0FFSSwwQkFBMEI7Ozs7O0FBR2pELFNBQVMsTUFBTSxHQUFHO0FBQ2hCLE1BQUksRUFBRSxHQUFHLElBQUksSUFBSSxDQUFDLHFCQUFxQixFQUFFLENBQUM7O0FBRTFDLE9BQUssQ0FBQyxNQUFNLENBQUMsRUFBRSxFQUFFLElBQUksQ0FBQyxDQUFDO0FBQ3ZCLElBQUUsQ0FBQyxVQUFVLG9DQUFhLENBQUM7QUFDM0IsSUFBRSxDQUFDLFNBQVMsbUNBQVksQ0FBQztBQUN6QixJQUFFLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQztBQUNqQixJQUFFLENBQUMsZ0JBQWdCLEdBQUcsS0FBSyxDQUFDLGdCQUFnQixDQUFDOztBQUU3QyxJQUFFLENBQUMsRUFBRSxHQUFHLE9BQU8sQ0FBQztBQUNoQixJQUFFLENBQUMsUUFBUSxHQUFHLFVBQVMsSUFBSSxFQUFFO0FBQzNCLFdBQU8sT0FBTyxDQUFDLFFBQVEsQ0FBQyxJQUFJLEVBQUUsRUFBRSxDQUFDLENBQUM7R0FDbkMsQ0FBQzs7QUFFRixTQUFPLEVBQUUsQ0FBQztDQUNYOztBQUVELElBQUksSUFBSSxHQUFHLE1BQU0sRUFBRSxDQUFDO0FBQ3BCLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDOztBQUVyQixrQ0FBVyxJQUFJLENBQUMsQ0FBQzs7QUFFakIsSUFBSSxDQUFDLFNBQVMsQ0FBQyxHQUFHLElBQUksQ0FBQzs7cUJBRVIsSUFBSSIsImZpbGUiOiJoYW5kbGViYXJzLnJ1bnRpbWUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgKiBhcyBiYXNlIGZyb20gJy4vaGFuZGxlYmFycy9iYXNlJztcblxuLy8gRWFjaCBvZiB0aGVzZSBhdWdtZW50IHRoZSBIYW5kbGViYXJzIG9iamVjdC4gTm8gbmVlZCB0byBzZXR1cCBoZXJlLlxuLy8gKFRoaXMgaXMgZG9uZSB0byBlYXNpbHkgc2hhcmUgY29kZSBiZXR3ZWVuIGNvbW1vbmpzIGFuZCBicm93c2UgZW52cylcbmltcG9ydCBTYWZlU3RyaW5nIGZyb20gJy4vaGFuZGxlYmFycy9zYWZlLXN0cmluZyc7XG5pbXBvcnQgRXhjZXB0aW9uIGZyb20gJy4vaGFuZGxlYmFycy9leGNlcHRpb24nO1xuaW1wb3J0ICogYXMgVXRpbHMgZnJvbSAnLi9oYW5kbGViYXJzL3V0aWxzJztcbmltcG9ydCAqIGFzIHJ1bnRpbWUgZnJvbSAnLi9oYW5kbGViYXJzL3J1bnRpbWUnO1xuXG5pbXBvcnQgbm9Db25mbGljdCBmcm9tICcuL2hhbmRsZWJhcnMvbm8tY29uZmxpY3QnO1xuXG4vLyBGb3IgY29tcGF0aWJpbGl0eSBhbmQgdXNhZ2Ugb3V0c2lkZSBvZiBtb2R1bGUgc3lzdGVtcywgbWFrZSB0aGUgSGFuZGxlYmFycyBvYmplY3QgYSBuYW1lc3BhY2VcbmZ1bmN0aW9uIGNyZWF0ZSgpIHtcbiAgbGV0IGhiID0gbmV3IGJhc2UuSGFuZGxlYmFyc0Vudmlyb25tZW50KCk7XG5cbiAgVXRpbHMuZXh0ZW5kKGhiLCBiYXNlKTtcbiAgaGIuU2FmZVN0cmluZyA9IFNhZmVTdHJpbmc7XG4gIGhiLkV4Y2VwdGlvbiA9IEV4Y2VwdGlvbjtcbiAgaGIuVXRpbHMgPSBVdGlscztcbiAgaGIuZXNjYXBlRXhwcmVzc2lvbiA9IFV0aWxzLmVzY2FwZUV4cHJlc3Npb247XG5cbiAgaGIuVk0gPSBydW50aW1lO1xuICBoYi50ZW1wbGF0ZSA9IGZ1bmN0aW9uKHNwZWMpIHtcbiAgICByZXR1cm4gcnVudGltZS50ZW1wbGF0ZShzcGVjLCBoYik7XG4gIH07XG5cbiAgcmV0dXJuIGhiO1xufVxuXG5sZXQgaW5zdCA9IGNyZWF0ZSgpO1xuaW5zdC5jcmVhdGUgPSBjcmVhdGU7XG5cbm5vQ29uZmxpY3QoaW5zdCk7XG5cbmluc3RbJ2RlZmF1bHQnXSA9IGluc3Q7XG5cbmV4cG9ydCBkZWZhdWx0IGluc3Q7XG4iXX0=
	
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.HandlebarsEnvironment = HandlebarsEnvironment;
		// istanbul ignore next
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _utils = __webpack_require__(3);
	
		var _exception = __webpack_require__(4);
	
		var _exception2 = _interopRequireDefault(_exception);
	
		var _helpers = __webpack_require__(5);
	
		var _decorators = __webpack_require__(13);
	
		var _logger = __webpack_require__(15);
	
		var _logger2 = _interopRequireDefault(_logger);
	
		var VERSION = '4.0.5';
		exports.VERSION = VERSION;
		var COMPILER_REVISION = 7;
	
		exports.COMPILER_REVISION = COMPILER_REVISION;
		var REVISION_CHANGES = {
		  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
		  2: '== 1.0.0-rc.3',
		  3: '== 1.0.0-rc.4',
		  4: '== 1.x.x',
		  5: '== 2.0.0-alpha.x',
		  6: '>= 2.0.0-beta.1',
		  7: '>= 4.0.0'
		};
	
		exports.REVISION_CHANGES = REVISION_CHANGES;
		var objectType = '[object Object]';
	
		function HandlebarsEnvironment(helpers, partials, decorators) {
		  this.helpers = helpers || {};
		  this.partials = partials || {};
		  this.decorators = decorators || {};
	
		  _helpers.registerDefaultHelpers(this);
		  _decorators.registerDefaultDecorators(this);
		}
	
		HandlebarsEnvironment.prototype = {
		  constructor: HandlebarsEnvironment,
	
		  logger: _logger2['default'],
		  log: _logger2['default'].log,
	
		  registerHelper: function registerHelper(name, fn) {
		    if (_utils.toString.call(name) === objectType) {
		      if (fn) {
		        throw new _exception2['default']('Arg not supported with multiple helpers');
		      }
		      _utils.extend(this.helpers, name);
		    } else {
		      this.helpers[name] = fn;
		    }
		  },
		  unregisterHelper: function unregisterHelper(name) {
		    delete this.helpers[name];
		  },
	
		  registerPartial: function registerPartial(name, partial) {
		    if (_utils.toString.call(name) === objectType) {
		      _utils.extend(this.partials, name);
		    } else {
		      if (typeof partial === 'undefined') {
		        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
		      }
		      this.partials[name] = partial;
		    }
		  },
		  unregisterPartial: function unregisterPartial(name) {
		    delete this.partials[name];
		  },
	
		  registerDecorator: function registerDecorator(name, fn) {
		    if (_utils.toString.call(name) === objectType) {
		      if (fn) {
		        throw new _exception2['default']('Arg not supported with multiple decorators');
		      }
		      _utils.extend(this.decorators, name);
		    } else {
		      this.decorators[name] = fn;
		    }
		  },
		  unregisterDecorator: function unregisterDecorator(name) {
		    delete this.decorators[name];
		  }
		};
	
		var log = _logger2['default'].log;
	
		exports.log = log;
		exports.createFrame = _utils.createFrame;
		exports.logger = _logger2['default'];
		//# sourceMappingURL=data:application/json;base64,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
	
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.extend = extend;
		exports.indexOf = indexOf;
		exports.escapeExpression = escapeExpression;
		exports.isEmpty = isEmpty;
		exports.createFrame = createFrame;
		var escape = {
		  '&': '&amp;',
		  '<': '&lt;',
		  '>': '&gt;',
		  '"': '&quot;',
		  "'": '&#x27;',
		  '`': '&#x60;',
		  '=': '&#x3D;'
		};
	
		var badChars = /[&<>"'`=]/g,
		    possible = /[&<>"'`=]/;
	
		function escapeChar(chr) {
		  return escape[chr];
		}
	
		function extend(obj /* , ...source */) {
		  for (var i = 1; i < arguments.length; i++) {
		    for (var key in arguments[i]) {
		      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
		        obj[key] = arguments[i][key];
		      }
		    }
		  }
	
		  return obj;
		}
	
		var toString = Object.prototype.toString;
	
		exports.toString = toString;
		// Sourced from lodash
		// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
		/* eslint-disable func-style */
		var isFunction = function isFunction(value) {
		  return typeof value === 'function';
		};
		// fallback for older versions of Chrome and Safari
		/* istanbul ignore next */
		if (isFunction(/x/)) {
		  exports.isFunction = isFunction = function (value) {
		    return typeof value === 'function' && toString.call(value) === '[object Function]';
		  };
		}
		exports.isFunction = isFunction;
	
		/* eslint-enable func-style */
	
		/* istanbul ignore next */
		var isArray = Array.isArray || function (value) {
		  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
		};
	
		exports.isArray = isArray;
		// Older IE versions do not directly support indexOf so we must implement our own, sadly.
	
		function indexOf(array, value) {
		  for (var i = 0, len = array.length; i < len; i++) {
		    if (array[i] === value) {
		      return i;
		    }
		  }
		  return -1;
		}
	
		function escapeExpression(string) {
		  if (typeof string !== 'string') {
		    // don't escape SafeStrings, since they're already safe
		    if (string && string.toHTML) {
		      return string.toHTML();
		    } else if (string == null) {
		      return '';
		    } else if (!string) {
		      return string + '';
		    }
	
		    // Force a string conversion as this will be done by the append regardless and
		    // the regex test will do this transparently behind the scenes, causing issues if
		    // an object's to string has escaped characters in it.
		    string = '' + string;
		  }
	
		  if (!possible.test(string)) {
		    return string;
		  }
		  return string.replace(badChars, escapeChar);
		}
	
		function isEmpty(value) {
		  if (!value && value !== 0) {
		    return true;
		  } else if (isArray(value) && value.length === 0) {
		    return true;
		  } else {
		    return false;
		  }
		}
	
		function createFrame(object) {
		  var frame = extend({}, object);
		  frame._parent = object;
		  return frame;
		}
		//# sourceMappingURL=data:application/json;base64,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
	
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];
	
		function Exception(message, node) {
		  var loc = node && node.loc,
		      line = undefined,
		      column = undefined;
		  if (loc) {
		    line = loc.start.line;
		    column = loc.start.column;
	
		    message += ' - ' + line + ':' + column;
		  }
	
		  var tmp = Error.prototype.constructor.call(this, message);
	
		  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
		  for (var idx = 0; idx < errorProps.length; idx++) {
		    this[errorProps[idx]] = tmp[errorProps[idx]];
		  }
	
		  /* istanbul ignore else */
		  if (Error.captureStackTrace) {
		    Error.captureStackTrace(this, Exception);
		  }
	
		  try {
		    if (loc) {
		      this.lineNumber = line;
	
		      // Work around issue under safari where we can't directly set the column value
		      /* istanbul ignore next */
		      if (Object.defineProperty) {
		        Object.defineProperty(this, 'column', { value: column });
		      } else {
		        this.column = column;
		      }
		    }
		  } catch (nop) {
		    /* Ignore if the browser is very particular */
		  }
		}
	
		Exception.prototype = new Error();
	
		exports['default'] = Exception;
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,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
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.registerDefaultHelpers = registerDefaultHelpers;
		// istanbul ignore next
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _helpersBlockHelperMissing = __webpack_require__(6);
	
		var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);
	
		var _helpersEach = __webpack_require__(7);
	
		var _helpersEach2 = _interopRequireDefault(_helpersEach);
	
		var _helpersHelperMissing = __webpack_require__(8);
	
		var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);
	
		var _helpersIf = __webpack_require__(9);
	
		var _helpersIf2 = _interopRequireDefault(_helpersIf);
	
		var _helpersLog = __webpack_require__(10);
	
		var _helpersLog2 = _interopRequireDefault(_helpersLog);
	
		var _helpersLookup = __webpack_require__(11);
	
		var _helpersLookup2 = _interopRequireDefault(_helpersLookup);
	
		var _helpersWith = __webpack_require__(12);
	
		var _helpersWith2 = _interopRequireDefault(_helpersWith);
	
		function registerDefaultHelpers(instance) {
		  _helpersBlockHelperMissing2['default'](instance);
		  _helpersEach2['default'](instance);
		  _helpersHelperMissing2['default'](instance);
		  _helpersIf2['default'](instance);
		  _helpersLog2['default'](instance);
		  _helpersLookup2['default'](instance);
		  _helpersWith2['default'](instance);
		}
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7eUNBQXVDLGdDQUFnQzs7OzsyQkFDOUMsZ0JBQWdCOzs7O29DQUNQLDBCQUEwQjs7Ozt5QkFDckMsY0FBYzs7OzswQkFDYixlQUFlOzs7OzZCQUNaLGtCQUFrQjs7OzsyQkFDcEIsZ0JBQWdCOzs7O0FBRWxDLFNBQVMsc0JBQXNCLENBQUMsUUFBUSxFQUFFO0FBQy9DLHlDQUEyQixRQUFRLENBQUMsQ0FBQztBQUNyQywyQkFBYSxRQUFRLENBQUMsQ0FBQztBQUN2QixvQ0FBc0IsUUFBUSxDQUFDLENBQUM7QUFDaEMseUJBQVcsUUFBUSxDQUFDLENBQUM7QUFDckIsMEJBQVksUUFBUSxDQUFDLENBQUM7QUFDdEIsNkJBQWUsUUFBUSxDQUFDLENBQUM7QUFDekIsMkJBQWEsUUFBUSxDQUFDLENBQUM7Q0FDeEIiLCJmaWxlIjoiaGVscGVycy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCByZWdpc3RlckJsb2NrSGVscGVyTWlzc2luZyBmcm9tICcuL2hlbHBlcnMvYmxvY2staGVscGVyLW1pc3NpbmcnO1xuaW1wb3J0IHJlZ2lzdGVyRWFjaCBmcm9tICcuL2hlbHBlcnMvZWFjaCc7XG5pbXBvcnQgcmVnaXN0ZXJIZWxwZXJNaXNzaW5nIGZyb20gJy4vaGVscGVycy9oZWxwZXItbWlzc2luZyc7XG5pbXBvcnQgcmVnaXN0ZXJJZiBmcm9tICcuL2hlbHBlcnMvaWYnO1xuaW1wb3J0IHJlZ2lzdGVyTG9nIGZyb20gJy4vaGVscGVycy9sb2cnO1xuaW1wb3J0IHJlZ2lzdGVyTG9va3VwIGZyb20gJy4vaGVscGVycy9sb29rdXAnO1xuaW1wb3J0IHJlZ2lzdGVyV2l0aCBmcm9tICcuL2hlbHBlcnMvd2l0aCc7XG5cbmV4cG9ydCBmdW5jdGlvbiByZWdpc3RlckRlZmF1bHRIZWxwZXJzKGluc3RhbmNlKSB7XG4gIHJlZ2lzdGVyQmxvY2tIZWxwZXJNaXNzaW5nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJFYWNoKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJIZWxwZXJNaXNzaW5nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJJZihpbnN0YW5jZSk7XG4gIHJlZ2lzdGVyTG9nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJMb29rdXAoaW5zdGFuY2UpO1xuICByZWdpc3RlcldpdGgoaW5zdGFuY2UpO1xufVxuIl19
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _utils = __webpack_require__(3);
	
		exports['default'] = function (instance) {
		  instance.registerHelper('blockHelperMissing', function (context, options) {
		    var inverse = options.inverse,
		        fn = options.fn;
	
		    if (context === true) {
		      return fn(this);
		    } else if (context === false || context == null) {
		      return inverse(this);
		    } else if (_utils.isArray(context)) {
		      if (context.length > 0) {
		        return instance.helpers.each(context, options);
		      } else {
		        return inverse(this);
		      }
		    } else {
		      return fn(context, options);
		    }
		  });
		};
	
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvYmxvY2staGVscGVyLW1pc3NpbmcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztxQkFBc0IsVUFBVTs7cUJBRWpCLFVBQVMsUUFBUSxFQUFFO0FBQ2hDLFVBQVEsQ0FBQyxjQUFjLENBQUMsb0JBQW9CLEVBQUUsVUFBUyxPQUFPLEVBQUUsT0FBTyxFQUFFO0FBQ3ZFLFFBQUksT0FBTyxHQUFHLE9BQU8sQ0FBQyxPQUFPO1FBQ3pCLEVBQUUsR0FBRyxPQUFPLENBQUMsRUFBRSxDQUFDOztBQUVwQixRQUFJLE9BQU8sS0FBSyxJQUFJLEVBQUU7QUFDcEIsYUFBTyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUM7S0FDakIsTUFBTSxJQUFJLE9BQU8sS0FBSyxLQUFLLElBQUksT0FBTyxJQUFJLElBQUksRUFBRTtBQUMvQyxhQUFPLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUN0QixNQUFNLElBQUksZUFBUSxPQUFPLENBQUMsRUFBRTtBQUMzQixVQUFJLE9BQU8sQ0FBQyxNQUFNLEdBQUcsQ0FBQyxFQUFFO0FBQ3RCLGVBQU8sUUFBUSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO09BQ2hELE1BQU07QUFDTCxlQUFPLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQztPQUN0QjtLQUNGLE1BQU07QUFDTCxhQUFPLEVBQUUsQ0FBQyxPQUFPLEVBQUUsT0FBTyxDQUFDLENBQUM7S0FDN0I7R0FDRixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJibG9jay1oZWxwZXItbWlzc2luZy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7aXNBcnJheX0gZnJvbSAnLi4vdXRpbHMnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbihpbnN0YW5jZSkge1xuICBpbnN0YW5jZS5yZWdpc3RlckhlbHBlcignYmxvY2tIZWxwZXJNaXNzaW5nJywgZnVuY3Rpb24oY29udGV4dCwgb3B0aW9ucykge1xuICAgIGxldCBpbnZlcnNlID0gb3B0aW9ucy5pbnZlcnNlLFxuICAgICAgICBmbiA9IG9wdGlvbnMuZm47XG5cbiAgICBpZiAoY29udGV4dCA9PT0gdHJ1ZSkge1xuICAgICAgcmV0dXJuIGZuKHRoaXMpO1xuICAgIH0gZWxzZSBpZiAoY29udGV4dCA9PT0gZmFsc2UgfHwgY29udGV4dCA9PSBudWxsKSB7XG4gICAgICByZXR1cm4gaW52ZXJzZSh0aGlzKTtcbiAgICB9IGVsc2UgaWYgKGlzQXJyYXkoY29udGV4dCkpIHtcbiAgICAgIGlmIChjb250ZXh0Lmxlbmd0aCA+IDApIHtcbiAgICAgICAgcmV0dXJuIGluc3RhbmNlLmhlbHBlcnMuZWFjaChjb250ZXh0LCBvcHRpb25zKTtcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIHJldHVybiBpbnZlcnNlKHRoaXMpO1xuICAgICAgfVxuICAgIH0gZWxzZSB7XG4gICAgICByZXR1cm4gZm4oY29udGV4dCwgb3B0aW9ucyk7XG4gICAgfVxuICB9KTtcbn1cbiJdfQ==
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		// istanbul ignore next
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _utils = __webpack_require__(3);
	
		var _exception = __webpack_require__(4);
	
		var _exception2 = _interopRequireDefault(_exception);
	
		exports['default'] = function (instance) {
		  instance.registerHelper('each', function (context, options) {
		    if (!options) {
		      throw new _exception2['default']('Must pass iterator to #each');
		    }
	
		    var fn = options.fn,
		        inverse = options.inverse,
		        i = 0,
		        ret = '',
		        data = undefined;
	
		    if (_utils.isFunction(context)) {
		      context = context.call(this);
		    }
	
		    if (options.data) {
		      data = _utils.createFrame(options.data);
		    }
	
		    function execIteration(field, index, last) {
		      if (data) {
		        data.key = field;
		        data.index = index;
		        data.first = index === 0;
		        data.last = !!last;
		      }
	
		      ret = ret + fn(context[field], {
		        data: data,
		        blockParams: [context[field], field]
		      });
		    }
	
		    if (context && typeof context === 'object') {
		      if (_utils.isArray(context)) {
		        for (var j = context.length; i < j; i++) {
		          if (i in context) {
		            execIteration(i, i, i === context.length - 1);
		          }
		        }
		      } else {
		        var priorKey = undefined;
	
		        for (var key in context) {
		          if (context.hasOwnProperty(key)) {
		            // We're running the iterations one step out of sync so we can detect
		            // the last iteration without have to scan the object twice and create
		            // an itermediate keys array.
		            if (priorKey !== undefined) {
		              execIteration(priorKey, i - 1);
		            }
		            priorKey = key;
		            i++;
		          }
		        }
		        if (priorKey !== undefined) {
		          execIteration(priorKey, i - 1, true);
		        }
		      }
		    }
	
		    if (i === 0) {
		      ret = inverse(this);
		    }
	
		    return ret;
		  });
		};
	
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,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
	
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		// istanbul ignore next
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _exception = __webpack_require__(4);
	
		var _exception2 = _interopRequireDefault(_exception);
	
		exports['default'] = function (instance) {
		  instance.registerHelper('helperMissing', function () /* [args, ]options */{
		    if (arguments.length === 1) {
		      // A missing field in a {{foo}} construct.
		      return undefined;
		    } else {
		      // Someone is actually trying to call something, blow up.
		      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
		    }
		  });
		};
	
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvaGVscGVyLW1pc3NpbmcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozt5QkFBc0IsY0FBYzs7OztxQkFFckIsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxlQUFlLEVBQUUsaUNBQWdDO0FBQ3ZFLFFBQUksU0FBUyxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7O0FBRTFCLGFBQU8sU0FBUyxDQUFDO0tBQ2xCLE1BQU07O0FBRUwsWUFBTSwyQkFBYyxtQkFBbUIsR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDLENBQUM7S0FDdkY7R0FDRixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJoZWxwZXItbWlzc2luZy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBFeGNlcHRpb24gZnJvbSAnLi4vZXhjZXB0aW9uJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2hlbHBlck1pc3NpbmcnLCBmdW5jdGlvbigvKiBbYXJncywgXW9wdGlvbnMgKi8pIHtcbiAgICBpZiAoYXJndW1lbnRzLmxlbmd0aCA9PT0gMSkge1xuICAgICAgLy8gQSBtaXNzaW5nIGZpZWxkIGluIGEge3tmb299fSBjb25zdHJ1Y3QuXG4gICAgICByZXR1cm4gdW5kZWZpbmVkO1xuICAgIH0gZWxzZSB7XG4gICAgICAvLyBTb21lb25lIGlzIGFjdHVhbGx5IHRyeWluZyB0byBjYWxsIHNvbWV0aGluZywgYmxvdyB1cC5cbiAgICAgIHRocm93IG5ldyBFeGNlcHRpb24oJ01pc3NpbmcgaGVscGVyOiBcIicgKyBhcmd1bWVudHNbYXJndW1lbnRzLmxlbmd0aCAtIDFdLm5hbWUgKyAnXCInKTtcbiAgICB9XG4gIH0pO1xufVxuIl19
	
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _utils = __webpack_require__(3);
	
		exports['default'] = function (instance) {
		  instance.registerHelper('if', function (conditional, options) {
		    if (_utils.isFunction(conditional)) {
		      conditional = conditional.call(this);
		    }
	
		    // Default behavior is to render the positive path if the value is truthy and not empty.
		    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
		    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
		    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
		      return options.inverse(this);
		    } else {
		      return options.fn(this);
		    }
		  });
	
		  instance.registerHelper('unless', function (conditional, options) {
		    return instance.helpers['if'].call(this, conditional, { fn: options.inverse, inverse: options.fn, hash: options.hash });
		  });
		};
	
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,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
	
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
	
		exports['default'] = function (instance) {
		  instance.registerHelper('log', function () /* message, options */{
		    var args = [undefined],
		        options = arguments[arguments.length - 1];
		    for (var i = 0; i < arguments.length - 1; i++) {
		      args.push(arguments[i]);
		    }
	
		    var level = 1;
		    if (options.hash.level != null) {
		      level = options.hash.level;
		    } else if (options.data && options.data.level != null) {
		      level = options.data.level;
		    }
		    args[0] = level;
	
		    instance.log.apply(instance, args);
		  });
		};
	
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxLQUFLLEVBQUUsa0NBQWlDO0FBQzlELFFBQUksSUFBSSxHQUFHLENBQUMsU0FBUyxDQUFDO1FBQ2xCLE9BQU8sR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQztBQUM5QyxTQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEVBQUU7QUFDN0MsVUFBSSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztLQUN6Qjs7QUFFRCxRQUFJLEtBQUssR0FBRyxDQUFDLENBQUM7QUFDZCxRQUFJLE9BQU8sQ0FBQyxJQUFJLENBQUMsS0FBSyxJQUFJLElBQUksRUFBRTtBQUM5QixXQUFLLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUM7S0FDNUIsTUFBTSxJQUFJLE9BQU8sQ0FBQyxJQUFJLElBQUksT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLElBQUksSUFBSSxFQUFFO0FBQ3JELFdBQUssR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQztLQUM1QjtBQUNELFFBQUksQ0FBQyxDQUFDLENBQUMsR0FBRyxLQUFLLENBQUM7O0FBRWhCLFlBQVEsQ0FBQyxHQUFHLE1BQUEsQ0FBWixRQUFRLEVBQVMsSUFBSSxDQUFDLENBQUM7R0FDeEIsQ0FBQyxDQUFDO0NBQ0oiLCJmaWxlIjoibG9nLmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2xvZycsIGZ1bmN0aW9uKC8qIG1lc3NhZ2UsIG9wdGlvbnMgKi8pIHtcbiAgICBsZXQgYXJncyA9IFt1bmRlZmluZWRdLFxuICAgICAgICBvcHRpb25zID0gYXJndW1lbnRzW2FyZ3VtZW50cy5sZW5ndGggLSAxXTtcbiAgICBmb3IgKGxldCBpID0gMDsgaSA8IGFyZ3VtZW50cy5sZW5ndGggLSAxOyBpKyspIHtcbiAgICAgIGFyZ3MucHVzaChhcmd1bWVudHNbaV0pO1xuICAgIH1cblxuICAgIGxldCBsZXZlbCA9IDE7XG4gICAgaWYgKG9wdGlvbnMuaGFzaC5sZXZlbCAhPSBudWxsKSB7XG4gICAgICBsZXZlbCA9IG9wdGlvbnMuaGFzaC5sZXZlbDtcbiAgICB9IGVsc2UgaWYgKG9wdGlvbnMuZGF0YSAmJiBvcHRpb25zLmRhdGEubGV2ZWwgIT0gbnVsbCkge1xuICAgICAgbGV2ZWwgPSBvcHRpb25zLmRhdGEubGV2ZWw7XG4gICAgfVxuICAgIGFyZ3NbMF0gPSBsZXZlbDtcblxuICAgIGluc3RhbmNlLmxvZyguLi4gYXJncyk7XG4gIH0pO1xufVxuIl19
	
	
	/***/ },
	/* 11 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
	
		exports['default'] = function (instance) {
		  instance.registerHelper('lookup', function (obj, field) {
		    return obj && obj[field];
		  });
		};
	
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9va3VwLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxRQUFRLEVBQUUsVUFBUyxHQUFHLEVBQUUsS0FBSyxFQUFFO0FBQ3JELFdBQU8sR0FBRyxJQUFJLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQztHQUMxQixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJsb29rdXAuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbihpbnN0YW5jZSkge1xuICBpbnN0YW5jZS5yZWdpc3RlckhlbHBlcignbG9va3VwJywgZnVuY3Rpb24ob2JqLCBmaWVsZCkge1xuICAgIHJldHVybiBvYmogJiYgb2JqW2ZpZWxkXTtcbiAgfSk7XG59XG4iXX0=
	
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _utils = __webpack_require__(3);
	
		exports['default'] = function (instance) {
		  instance.registerHelper('with', function (context, options) {
		    if (_utils.isFunction(context)) {
		      context = context.call(this);
		    }
	
		    var fn = options.fn;
	
		    if (!_utils.isEmpty(context)) {
		      var data = options.data;
	
		      return fn(context, {
		        data: data,
		        blockParams: [context]
		      });
		    } else {
		      return options.inverse(this);
		    }
		  });
		};
	
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvd2l0aC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O3FCQUFrQyxVQUFVOztxQkFFN0IsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxNQUFNLEVBQUUsVUFBUyxPQUFPLEVBQUUsT0FBTyxFQUFFO0FBQ3pELFFBQUksa0JBQVcsT0FBTyxDQUFDLEVBQUU7QUFBRSxhQUFPLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUFFOztBQUUxRCxRQUFJLEVBQUUsR0FBRyxPQUFPLENBQUMsRUFBRSxDQUFDOztBQUVwQixRQUFJLENBQUMsZUFBUSxPQUFPLENBQUMsRUFBRTtBQUNyQixVQUFJLElBQUksR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDOztBQUV4QixhQUFPLEVBQUUsQ0FBQyxPQUFPLEVBQUU7QUFDakIsWUFBSSxFQUFFLElBQUk7QUFDVixtQkFBVyxFQUFFLENBQUMsT0FBTyxDQUFDO09BQ3ZCLENBQUMsQ0FBQztLQUNKLE1BQU07QUFDTCxhQUFPLE9BQU8sQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7S0FDOUI7R0FDRixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJ3aXRoLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtpc0VtcHR5LCBpc0Z1bmN0aW9ufSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uKGluc3RhbmNlKSB7XG4gIGluc3RhbmNlLnJlZ2lzdGVySGVscGVyKCd3aXRoJywgZnVuY3Rpb24oY29udGV4dCwgb3B0aW9ucykge1xuICAgIGlmIChpc0Z1bmN0aW9uKGNvbnRleHQpKSB7IGNvbnRleHQgPSBjb250ZXh0LmNhbGwodGhpcyk7IH1cblxuICAgIGxldCBmbiA9IG9wdGlvbnMuZm47XG5cbiAgICBpZiAoIWlzRW1wdHkoY29udGV4dCkpIHtcbiAgICAgIGxldCBkYXRhID0gb3B0aW9ucy5kYXRhO1xuXG4gICAgICByZXR1cm4gZm4oY29udGV4dCwge1xuICAgICAgICBkYXRhOiBkYXRhLFxuICAgICAgICBibG9ja1BhcmFtczogW2NvbnRleHRdXG4gICAgICB9KTtcbiAgICB9IGVsc2Uge1xuICAgICAgcmV0dXJuIG9wdGlvbnMuaW52ZXJzZSh0aGlzKTtcbiAgICB9XG4gIH0pO1xufVxuIl19
	
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.registerDefaultDecorators = registerDefaultDecorators;
		// istanbul ignore next
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _decoratorsInline = __webpack_require__(14);
	
		var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);
	
		function registerDefaultDecorators(instance) {
		  _decoratorsInline2['default'](instance);
		}
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Z0NBQTJCLHFCQUFxQjs7OztBQUV6QyxTQUFTLHlCQUF5QixDQUFDLFFBQVEsRUFBRTtBQUNsRCxnQ0FBZSxRQUFRLENBQUMsQ0FBQztDQUMxQiIsImZpbGUiOiJkZWNvcmF0b3JzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHJlZ2lzdGVySW5saW5lIGZyb20gJy4vZGVjb3JhdG9ycy9pbmxpbmUnO1xuXG5leHBvcnQgZnVuY3Rpb24gcmVnaXN0ZXJEZWZhdWx0RGVjb3JhdG9ycyhpbnN0YW5jZSkge1xuICByZWdpc3RlcklubGluZShpbnN0YW5jZSk7XG59XG5cbiJdfQ==
	
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _utils = __webpack_require__(3);
	
		exports['default'] = function (instance) {
		  instance.registerDecorator('inline', function (fn, props, container, options) {
		    var ret = fn;
		    if (!props.partials) {
		      props.partials = {};
		      ret = function (context, options) {
		        // Create a new partials stack frame prior to exec.
		        var original = container.partials;
		        container.partials = _utils.extend({}, original, props.partials);
		        var ret = fn(context, options);
		        container.partials = original;
		        return ret;
		      };
		    }
	
		    props.partials[options.args[0]] = options.fn;
	
		    return ret;
		  });
		};
	
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMvaW5saW5lLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQXFCLFVBQVU7O3FCQUVoQixVQUFTLFFBQVEsRUFBRTtBQUNoQyxVQUFRLENBQUMsaUJBQWlCLENBQUMsUUFBUSxFQUFFLFVBQVMsRUFBRSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsT0FBTyxFQUFFO0FBQzNFLFFBQUksR0FBRyxHQUFHLEVBQUUsQ0FBQztBQUNiLFFBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxFQUFFO0FBQ25CLFdBQUssQ0FBQyxRQUFRLEdBQUcsRUFBRSxDQUFDO0FBQ3BCLFNBQUcsR0FBRyxVQUFTLE9BQU8sRUFBRSxPQUFPLEVBQUU7O0FBRS9CLFlBQUksUUFBUSxHQUFHLFNBQVMsQ0FBQyxRQUFRLENBQUM7QUFDbEMsaUJBQVMsQ0FBQyxRQUFRLEdBQUcsY0FBTyxFQUFFLEVBQUUsUUFBUSxFQUFFLEtBQUssQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUMxRCxZQUFJLEdBQUcsR0FBRyxFQUFFLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQy9CLGlCQUFTLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztBQUM5QixlQUFPLEdBQUcsQ0FBQztPQUNaLENBQUM7S0FDSDs7QUFFRCxTQUFLLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxPQUFPLENBQUMsRUFBRSxDQUFDOztBQUU3QyxXQUFPLEdBQUcsQ0FBQztHQUNaLENBQUMsQ0FBQztDQUNKIiwiZmlsZSI6ImlubGluZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7ZXh0ZW5kfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uKGluc3RhbmNlKSB7XG4gIGluc3RhbmNlLnJlZ2lzdGVyRGVjb3JhdG9yKCdpbmxpbmUnLCBmdW5jdGlvbihmbiwgcHJvcHMsIGNvbnRhaW5lciwgb3B0aW9ucykge1xuICAgIGxldCByZXQgPSBmbjtcbiAgICBpZiAoIXByb3BzLnBhcnRpYWxzKSB7XG4gICAgICBwcm9wcy5wYXJ0aWFscyA9IHt9O1xuICAgICAgcmV0ID0gZnVuY3Rpb24oY29udGV4dCwgb3B0aW9ucykge1xuICAgICAgICAvLyBDcmVhdGUgYSBuZXcgcGFydGlhbHMgc3RhY2sgZnJhbWUgcHJpb3IgdG8gZXhlYy5cbiAgICAgICAgbGV0IG9yaWdpbmFsID0gY29udGFpbmVyLnBhcnRpYWxzO1xuICAgICAgICBjb250YWluZXIucGFydGlhbHMgPSBleHRlbmQoe30sIG9yaWdpbmFsLCBwcm9wcy5wYXJ0aWFscyk7XG4gICAgICAgIGxldCByZXQgPSBmbihjb250ZXh0LCBvcHRpb25zKTtcbiAgICAgICAgY29udGFpbmVyLnBhcnRpYWxzID0gb3JpZ2luYWw7XG4gICAgICAgIHJldHVybiByZXQ7XG4gICAgICB9O1xuICAgIH1cblxuICAgIHByb3BzLnBhcnRpYWxzW29wdGlvbnMuYXJnc1swXV0gPSBvcHRpb25zLmZuO1xuXG4gICAgcmV0dXJuIHJldDtcbiAgfSk7XG59XG4iXX0=
	
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _utils = __webpack_require__(3);
	
		var logger = {
		  methodMap: ['debug', 'info', 'warn', 'error'],
		  level: 'info',
	
		  // Maps a given level value to the `methodMap` indexes above.
		  lookupLevel: function lookupLevel(level) {
		    if (typeof level === 'string') {
		      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
		      if (levelMap >= 0) {
		        level = levelMap;
		      } else {
		        level = parseInt(level, 10);
		      }
		    }
	
		    return level;
		  },
	
		  // Can be overridden in the host environment
		  log: function log(level) {
		    level = logger.lookupLevel(level);
	
		    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
		      var method = logger.methodMap[level];
		      if (!console[method]) {
		        // eslint-disable-line no-console
		        method = 'log';
		      }
	
		      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		        message[_key - 1] = arguments[_key];
		      }
	
		      console[method].apply(console, message); // eslint-disable-line no-console
		    }
		  }
		};
	
		exports['default'] = logger;
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,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
	
	
	/***/ },
	/* 16 */
	/***/ function(module, exports) {
	
		// Build out our basic SafeString type
		'use strict';
	
		exports.__esModule = true;
		function SafeString(string) {
		  this.string = string;
		}
	
		SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
		  return '' + this.string;
		};
	
		exports['default'] = SafeString;
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL3NhZmUtc3RyaW5nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFDQSxTQUFTLFVBQVUsQ0FBQyxNQUFNLEVBQUU7QUFDMUIsTUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUM7Q0FDdEI7O0FBRUQsVUFBVSxDQUFDLFNBQVMsQ0FBQyxRQUFRLEdBQUcsVUFBVSxDQUFDLFNBQVMsQ0FBQyxNQUFNLEdBQUcsWUFBVztBQUN2RSxTQUFPLEVBQUUsR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDO0NBQ3pCLENBQUM7O3FCQUVhLFVBQVUiLCJmaWxlIjoic2FmZS1zdHJpbmcuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBCdWlsZCBvdXQgb3VyIGJhc2ljIFNhZmVTdHJpbmcgdHlwZVxuZnVuY3Rpb24gU2FmZVN0cmluZyhzdHJpbmcpIHtcbiAgdGhpcy5zdHJpbmcgPSBzdHJpbmc7XG59XG5cblNhZmVTdHJpbmcucHJvdG90eXBlLnRvU3RyaW5nID0gU2FmZVN0cmluZy5wcm90b3R5cGUudG9IVE1MID0gZnVuY3Rpb24oKSB7XG4gIHJldHVybiAnJyArIHRoaXMuc3RyaW5nO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgU2FmZVN0cmluZztcbiJdfQ==
	
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.checkRevision = checkRevision;
		exports.template = template;
		exports.wrapProgram = wrapProgram;
		exports.resolvePartial = resolvePartial;
		exports.invokePartial = invokePartial;
		exports.noop = noop;
		// istanbul ignore next
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		// istanbul ignore next
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
		var _utils = __webpack_require__(3);
	
		var Utils = _interopRequireWildcard(_utils);
	
		var _exception = __webpack_require__(4);
	
		var _exception2 = _interopRequireDefault(_exception);
	
		var _base = __webpack_require__(2);
	
		function checkRevision(compilerInfo) {
		  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
		      currentRevision = _base.COMPILER_REVISION;
	
		  if (compilerRevision !== currentRevision) {
		    if (compilerRevision < currentRevision) {
		      var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
		          compilerVersions = _base.REVISION_CHANGES[compilerRevision];
		      throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
		    } else {
		      // Use the embedded version info since the runtime doesn't know about this revision yet
		      throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
		    }
		  }
		}
	
		function template(templateSpec, env) {
		  /* istanbul ignore next */
		  if (!env) {
		    throw new _exception2['default']('No environment passed to template');
		  }
		  if (!templateSpec || !templateSpec.main) {
		    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
		  }
	
		  templateSpec.main.decorator = templateSpec.main_d;
	
		  // Note: Using env.VM references rather than local var references throughout this section to allow
		  // for external users to override these as psuedo-supported APIs.
		  env.VM.checkRevision(templateSpec.compiler);
	
		  function invokePartialWrapper(partial, context, options) {
		    if (options.hash) {
		      context = Utils.extend({}, context, options.hash);
		    }
	
		    partial = env.VM.resolvePartial.call(this, partial, context, options);
		    var result = env.VM.invokePartial.call(this, partial, context, options);
	
		    if (result == null && env.compile) {
		      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
		      result = options.partials[options.name](context, options);
		    }
		    if (result != null) {
		      if (options.indent) {
		        var lines = result.split('\n');
		        for (var i = 0, l = lines.length; i < l; i++) {
		          if (!lines[i] && i + 1 === l) {
		            break;
		          }
	
		          lines[i] = options.indent + lines[i];
		        }
		        result = lines.join('\n');
		      }
		      return result;
		    } else {
		      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
		    }
		  }
	
		  // Just add water
		  var container = {
		    strict: function strict(obj, name) {
		      if (!(name in obj)) {
		        throw new _exception2['default']('"' + name + '" not defined in ' + obj);
		      }
		      return obj[name];
		    },
		    lookup: function lookup(depths, name) {
		      var len = depths.length;
		      for (var i = 0; i < len; i++) {
		        if (depths[i] && depths[i][name] != null) {
		          return depths[i][name];
		        }
		      }
		    },
		    lambda: function lambda(current, context) {
		      return typeof current === 'function' ? current.call(context) : current;
		    },
	
		    escapeExpression: Utils.escapeExpression,
		    invokePartial: invokePartialWrapper,
	
		    fn: function fn(i) {
		      var ret = templateSpec[i];
		      ret.decorator = templateSpec[i + '_d'];
		      return ret;
		    },
	
		    programs: [],
		    program: function program(i, data, declaredBlockParams, blockParams, depths) {
		      var programWrapper = this.programs[i],
		          fn = this.fn(i);
		      if (data || depths || blockParams || declaredBlockParams) {
		        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
		      } else if (!programWrapper) {
		        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
		      }
		      return programWrapper;
		    },
	
		    data: function data(value, depth) {
		      while (value && depth--) {
		        value = value._parent;
		      }
		      return value;
		    },
		    merge: function merge(param, common) {
		      var obj = param || common;
	
		      if (param && common && param !== common) {
		        obj = Utils.extend({}, common, param);
		      }
	
		      return obj;
		    },
	
		    noop: env.VM.noop,
		    compilerInfo: templateSpec.compiler
		  };
	
		  function ret(context) {
		    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		    var data = options.data;
	
		    _setup(options);
		    if (!options.partial && templateSpec.useData) {
		      data = initData(context, data);
		    }
		    var depths = undefined,
		        blockParams = templateSpec.useBlockParams ? [] : undefined;
		    if (templateSpec.useDepths) {
		      if (options.depths) {
		        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
		      } else {
		        depths = [context];
		      }
		    }
	
		    function main(context /*, options*/) {
		      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
		    }
		    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
		    return main(context, options);
		  }
		  ret.isTop = true;
	
		  function _setup(options) {
		    if (!options.partial) {
		      container.helpers = container.merge(options.helpers, env.helpers);
	
		      if (templateSpec.usePartial) {
		        container.partials = container.merge(options.partials, env.partials);
		      }
		      if (templateSpec.usePartial || templateSpec.useDecorators) {
		        container.decorators = container.merge(options.decorators, env.decorators);
		      }
		    } else {
		      container.helpers = options.helpers;
		      container.partials = options.partials;
		      container.decorators = options.decorators;
		    }
		  }
	
		  return ret;
		}
	
		function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
		  function prog(context) {
		    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		    var currentDepths = depths;
		    if (depths && context != depths[0]) {
		      currentDepths = [context].concat(depths);
		    }
	
		    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
		  }
	
		  prog = executeDecorators(fn, prog, container, depths, data, blockParams);
	
		  prog.program = i;
		  prog.depth = depths ? depths.length : 0;
		  prog.blockParams = declaredBlockParams || 0;
		  return prog;
		}
	
		function resolvePartial(partial, context, options) {
		  if (!partial) {
		    if (options.name === '@partial-block') {
		      var data = options.data;
		      while (data['partial-block'] === noop) {
		        data = data._parent;
		      }
		      partial = data['partial-block'];
		      data['partial-block'] = noop;
		    } else {
		      partial = options.partials[options.name];
		    }
		  } else if (!partial.call && !options.name) {
		    // This is a dynamic partial that returned a string
		    options.name = partial;
		    partial = options.partials[partial];
		  }
		  return partial;
		}
	
		function invokePartial(partial, context, options) {
		  options.partial = true;
	
		  var partialBlock = undefined;
		  if (options.fn && options.fn !== noop) {
		    options.data = _base.createFrame(options.data);
		    partialBlock = options.data['partial-block'] = options.fn;
	
		    if (partialBlock.partials) {
		      options.partials = Utils.extend({}, options.partials, partialBlock.partials);
		    }
		  }
	
		  if (partial === undefined && partialBlock) {
		    partial = partialBlock;
		  }
	
		  if (partial === undefined) {
		    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
		  } else if (partial instanceof Function) {
		    return partial(context, options);
		  }
		}
	
		function noop() {
		  return '';
		}
	
		function initData(context, data) {
		  if (!data || !('root' in data)) {
		    data = data ? _base.createFrame(data) : {};
		    data.root = context;
		  }
		  return data;
		}
	
		function executeDecorators(fn, prog, container, depths, data, blockParams) {
		  if (fn.decorator) {
		    var props = {};
		    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
		    Utils.extend(prog, props);
		  }
		  return prog;
		}
		//# sourceMappingURL=data:application/json;base64,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
	
	
	/***/ },
	/* 18 */
	/***/ function(module, exports) {
	
		/* WEBPACK VAR INJECTION */(function(global) {/* global window */
		'use strict';
	
		exports.__esModule = true;
	
		exports['default'] = function (Handlebars) {
		  /* istanbul ignore next */
		  var root = typeof global !== 'undefined' ? global : window,
		      $Handlebars = root.Handlebars;
		  /* istanbul ignore next */
		  Handlebars.noConflict = function () {
		    if (root.Handlebars === Handlebars) {
		      root.Handlebars = $Handlebars;
		    }
		    return Handlebars;
		  };
		};
	
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL25vLWNvbmZsaWN0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O3FCQUNlLFVBQVMsVUFBVSxFQUFFOztBQUVsQyxNQUFJLElBQUksR0FBRyxPQUFPLE1BQU0sS0FBSyxXQUFXLEdBQUcsTUFBTSxHQUFHLE1BQU07TUFDdEQsV0FBVyxHQUFHLElBQUksQ0FBQyxVQUFVLENBQUM7O0FBRWxDLFlBQVUsQ0FBQyxVQUFVLEdBQUcsWUFBVztBQUNqQyxRQUFJLElBQUksQ0FBQyxVQUFVLEtBQUssVUFBVSxFQUFFO0FBQ2xDLFVBQUksQ0FBQyxVQUFVLEdBQUcsV0FBVyxDQUFDO0tBQy9CO0FBQ0QsV0FBTyxVQUFVLENBQUM7R0FDbkIsQ0FBQztDQUNIIiwiZmlsZSI6Im5vLWNvbmZsaWN0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyogZ2xvYmFsIHdpbmRvdyAqL1xuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oSGFuZGxlYmFycykge1xuICAvKiBpc3RhbmJ1bCBpZ25vcmUgbmV4dCAqL1xuICBsZXQgcm9vdCA9IHR5cGVvZiBnbG9iYWwgIT09ICd1bmRlZmluZWQnID8gZ2xvYmFsIDogd2luZG93LFxuICAgICAgJEhhbmRsZWJhcnMgPSByb290LkhhbmRsZWJhcnM7XG4gIC8qIGlzdGFuYnVsIGlnbm9yZSBuZXh0ICovXG4gIEhhbmRsZWJhcnMubm9Db25mbGljdCA9IGZ1bmN0aW9uKCkge1xuICAgIGlmIChyb290LkhhbmRsZWJhcnMgPT09IEhhbmRsZWJhcnMpIHtcbiAgICAgIHJvb3QuSGFuZGxlYmFycyA9ICRIYW5kbGViYXJzO1xuICAgIH1cbiAgICByZXR1cm4gSGFuZGxlYmFycztcbiAgfTtcbn1cbiJdfQ==
	
		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))
	
	/***/ },
	/* 19 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		var AST = {
		  // Public API used to evaluate derived attributes regarding AST nodes
		  helpers: {
		    // a mustache is definitely a helper if:
		    // * it is an eligible helper, and
		    // * it has at least one parameter or hash segment
		    helperExpression: function helperExpression(node) {
		      return node.type === 'SubExpression' || (node.type === 'MustacheStatement' || node.type === 'BlockStatement') && !!(node.params && node.params.length || node.hash);
		    },
	
		    scopedId: function scopedId(path) {
		      return (/^\.|this\b/.test(path.original)
		      );
		    },
	
		    // an ID is simple if it only has one part, and that part is not
		    // `..` or `this`.
		    simpleId: function simpleId(path) {
		      return path.parts.length === 1 && !AST.helpers.scopedId(path) && !path.depth;
		    }
		  }
		};
	
		// Must be exported as an object rather than the root of the module as the jison lexer
		// must modify the object to operate properly.
		exports['default'] = AST;
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,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
	
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.parse = parse;
		// istanbul ignore next
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
		// istanbul ignore next
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _parser = __webpack_require__(21);
	
		var _parser2 = _interopRequireDefault(_parser);
	
		var _whitespaceControl = __webpack_require__(22);
	
		var _whitespaceControl2 = _interopRequireDefault(_whitespaceControl);
	
		var _helpers = __webpack_require__(24);
	
		var Helpers = _interopRequireWildcard(_helpers);
	
		var _utils = __webpack_require__(3);
	
		exports.parser = _parser2['default'];
	
		var yy = {};
		_utils.extend(yy, Helpers);
	
		function parse(input, options) {
		  // Just return if an already-compiled AST was passed in.
		  if (input.type === 'Program') {
		    return input;
		  }
	
		  _parser2['default'].yy = yy;
	
		  // Altering the shared object here, but this is ok as parser is a sync operation
		  yy.locInfo = function (locInfo) {
		    return new yy.SourceLocation(options && options.srcName, locInfo);
		  };
	
		  var strip = new _whitespaceControl2['default'](options);
		  return strip.accept(_parser2['default'].parse(input));
		}
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2NvbXBpbGVyL2Jhc2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O3NCQUFtQixVQUFVOzs7O2lDQUNDLHNCQUFzQjs7Ozt1QkFDM0IsV0FBVzs7SUFBeEIsT0FBTzs7cUJBQ0ksVUFBVTs7UUFFeEIsTUFBTTs7QUFFZixJQUFJLEVBQUUsR0FBRyxFQUFFLENBQUM7QUFDWixjQUFPLEVBQUUsRUFBRSxPQUFPLENBQUMsQ0FBQzs7QUFFYixTQUFTLEtBQUssQ0FBQyxLQUFLLEVBQUUsT0FBTyxFQUFFOztBQUVwQyxNQUFJLEtBQUssQ0FBQyxJQUFJLEtBQUssU0FBUyxFQUFFO0FBQUUsV0FBTyxLQUFLLENBQUM7R0FBRTs7QUFFL0Msc0JBQU8sRUFBRSxHQUFHLEVBQUUsQ0FBQzs7O0FBR2YsSUFBRSxDQUFDLE9BQU8sR0FBRyxVQUFTLE9BQU8sRUFBRTtBQUM3QixXQUFPLElBQUksRUFBRSxDQUFDLGNBQWMsQ0FBQyxPQUFPLElBQUksT0FBTyxDQUFDLE9BQU8sRUFBRSxPQUFPLENBQUMsQ0FBQztHQUNuRSxDQUFDOztBQUVGLE1BQUksS0FBSyxHQUFHLG1DQUFzQixPQUFPLENBQUMsQ0FBQztBQUMzQyxTQUFPLEtBQUssQ0FBQyxNQUFNLENBQUMsb0JBQU8sS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUM7Q0FDMUMiLCJmaWxlIjoiYmFzZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBwYXJzZXIgZnJvbSAnLi9wYXJzZXInO1xuaW1wb3J0IFdoaXRlc3BhY2VDb250cm9sIGZyb20gJy4vd2hpdGVzcGFjZS1jb250cm9sJztcbmltcG9ydCAqIGFzIEhlbHBlcnMgZnJvbSAnLi9oZWxwZXJzJztcbmltcG9ydCB7IGV4dGVuZCB9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IHsgcGFyc2VyIH07XG5cbmxldCB5eSA9IHt9O1xuZXh0ZW5kKHl5LCBIZWxwZXJzKTtcblxuZXhwb3J0IGZ1bmN0aW9uIHBhcnNlKGlucHV0LCBvcHRpb25zKSB7XG4gIC8vIEp1c3QgcmV0dXJuIGlmIGFuIGFscmVhZHktY29tcGlsZWQgQVNUIHdhcyBwYXNzZWQgaW4uXG4gIGlmIChpbnB1dC50eXBlID09PSAnUHJvZ3JhbScpIHsgcmV0dXJuIGlucHV0OyB9XG5cbiAgcGFyc2VyLnl5ID0geXk7XG5cbiAgLy8gQWx0ZXJpbmcgdGhlIHNoYXJlZCBvYmplY3QgaGVyZSwgYnV0IHRoaXMgaXMgb2sgYXMgcGFyc2VyIGlzIGEgc3luYyBvcGVyYXRpb25cbiAgeXkubG9jSW5mbyA9IGZ1bmN0aW9uKGxvY0luZm8pIHtcbiAgICByZXR1cm4gbmV3IHl5LlNvdXJjZUxvY2F0aW9uKG9wdGlvbnMgJiYgb3B0aW9ucy5zcmNOYW1lLCBsb2NJbmZvKTtcbiAgfTtcblxuICBsZXQgc3RyaXAgPSBuZXcgV2hpdGVzcGFjZUNvbnRyb2wob3B0aW9ucyk7XG4gIHJldHVybiBzdHJpcC5hY2NlcHQocGFyc2VyLnBhcnNlKGlucHV0KSk7XG59XG4iXX0=
	
	
	/***/ },
	/* 21 */
	/***/ function(module, exports) {
	
		/* istanbul ignore next */
		/* parser generated by jison 0.4.16 */
		/*
		  Returns a Parser object of the following structure:
	
		  Parser: {
		    yy: {}
		  }
	
		  Parser.prototype: {
		    yy: {},
		    trace: function(),
		    symbols_: {associative list: name ==> number},
		    terminals_: {associative list: number ==> name},
		    productions_: [...],
		    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
		    table: [...],
		    defaultActions: {...},
		    parseError: function(str, hash),
		    parse: function(input),
	
		    lexer: {
		        EOF: 1,
		        parseError: function(str, hash),
		        setInput: function(input),
		        input: function(),
		        unput: function(str),
		        more: function(),
		        less: function(n),
		        pastInput: function(),
		        upcomingInput: function(),
		        showPosition: function(),
		        test_match: function(regex_match_array, rule_index),
		        next: function(),
		        lex: function(),
		        begin: function(condition),
		        popState: function(),
		        _currentRules: function(),
		        topState: function(),
		        pushState: function(condition),
	
		        options: {
		            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
		            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
		            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
		        },
	
		        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
		        rules: [...],
		        conditions: {associative list: name ==> set},
		    }
		  }
	
	
		  token location info (@$, _$, etc.): {
		    first_line: n,
		    last_line: n,
		    first_column: n,
		    last_column: n,
		    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
		  }
	
	
		  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
		    text:        (matched text)
		    token:       (the produced terminal token, if any)
		    line:        (yylineno)
		  }
		  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
		    loc:         (yylloc)
		    expected:    (string describing the set of expected tokens)
		    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
		  }
		*/
		"use strict";
	
		var handlebars = (function () {
		    var o = function o(k, v, _o, l) {
		        for (_o = _o || {}, l = k.length; l--; _o[k[l]] = v);return _o;
		    },
		        $V0 = [2, 46],
		        $V1 = [1, 20],
		        $V2 = [5, 14, 15, 19, 29, 34, 39, 44, 47, 48, 51, 55, 60],
		        $V3 = [1, 35],
		        $V4 = [1, 28],
		        $V5 = [1, 29],
		        $V6 = [1, 30],
		        $V7 = [1, 31],
		        $V8 = [1, 32],
		        $V9 = [1, 34],
		        $Va = [14, 15, 19, 29, 34, 39, 44, 47, 48, 51, 55, 60],
		        $Vb = [14, 15, 19, 29, 34, 44, 47, 48, 51, 55, 60],
		        $Vc = [1, 44],
		        $Vd = [14, 15, 19, 29, 34, 47, 48, 51, 55, 60],
		        $Ve = [33, 65, 72, 80, 81, 82, 83, 84, 85],
		        $Vf = [23, 33, 54, 65, 68, 72, 75, 80, 81, 82, 83, 84, 85],
		        $Vg = [1, 51],
		        $Vh = [23, 33, 54, 65, 68, 72, 75, 80, 81, 82, 83, 84, 85, 87],
		        $Vi = [2, 45],
		        $Vj = [54, 65, 72, 80, 81, 82, 83, 84, 85],
		        $Vk = [1, 58],
		        $Vl = [1, 59],
		        $Vm = [15, 18],
		        $Vn = [1, 67],
		        $Vo = [33, 65, 72, 75, 80, 81, 82, 83, 84, 85],
		        $Vp = [23, 65, 72, 80, 81, 82, 83, 84, 85],
		        $Vq = [1, 79],
		        $Vr = [65, 68, 72, 80, 81, 82, 83, 84, 85],
		        $Vs = [33, 75],
		        $Vt = [23, 33, 54, 68, 72, 75],
		        $Vu = [1, 109],
		        $Vv = [1, 121],
		        $Vw = [72, 77];
		    var parser = { trace: function trace() {},
		        yy: {},
		        symbols_: { "error": 2, "root": 3, "program": 4, "EOF": 5, "program_repetition0": 6, "statement": 7, "mustache": 8, "block": 9, "rawBlock": 10, "partial": 11, "partialBlock": 12, "content": 13, "COMMENT": 14, "CONTENT": 15, "openRawBlock": 16, "rawBlock_repetition_plus0": 17, "END_RAW_BLOCK": 18, "OPEN_RAW_BLOCK": 19, "helperName": 20, "openRawBlock_repetition0": 21, "openRawBlock_option0": 22, "CLOSE_RAW_BLOCK": 23, "openBlock": 24, "block_option0": 25, "closeBlock": 26, "openInverse": 27, "block_option1": 28, "OPEN_BLOCK": 29, "openBlock_repetition0": 30, "openBlock_option0": 31, "openBlock_option1": 32, "CLOSE": 33, "OPEN_INVERSE": 34, "openInverse_repetition0": 35, "openInverse_option0": 36, "openInverse_option1": 37, "openInverseChain": 38, "OPEN_INVERSE_CHAIN": 39, "openInverseChain_repetition0": 40, "openInverseChain_option0": 41, "openInverseChain_option1": 42, "inverseAndProgram": 43, "INVERSE": 44, "inverseChain": 45, "inverseChain_option0": 46, "OPEN_ENDBLOCK": 47, "OPEN": 48, "mustache_repetition0": 49, "mustache_option0": 50, "OPEN_UNESCAPED": 51, "mustache_repetition1": 52, "mustache_option1": 53, "CLOSE_UNESCAPED": 54, "OPEN_PARTIAL": 55, "partialName": 56, "partial_repetition0": 57, "partial_option0": 58, "openPartialBlock": 59, "OPEN_PARTIAL_BLOCK": 60, "openPartialBlock_repetition0": 61, "openPartialBlock_option0": 62, "param": 63, "sexpr": 64, "OPEN_SEXPR": 65, "sexpr_repetition0": 66, "sexpr_option0": 67, "CLOSE_SEXPR": 68, "hash": 69, "hash_repetition_plus0": 70, "hashSegment": 71, "ID": 72, "EQUALS": 73, "blockParams": 74, "OPEN_BLOCK_PARAMS": 75, "blockParams_repetition_plus0": 76, "CLOSE_BLOCK_PARAMS": 77, "path": 78, "dataName": 79, "STRING": 80, "NUMBER": 81, "BOOLEAN": 82, "UNDEFINED": 83, "NULL": 84, "DATA": 85, "pathSegments": 86, "SEP": 87, "$accept": 0, "$end": 1 },
		        terminals_: { 2: "error", 5: "EOF", 14: "COMMENT", 15: "CONTENT", 18: "END_RAW_BLOCK", 19: "OPEN_RAW_BLOCK", 23: "CLOSE_RAW_BLOCK", 29: "OPEN_BLOCK", 33: "CLOSE", 34: "OPEN_INVERSE", 39: "OPEN_INVERSE_CHAIN", 44: "INVERSE", 47: "OPEN_ENDBLOCK", 48: "OPEN", 51: "OPEN_UNESCAPED", 54: "CLOSE_UNESCAPED", 55: "OPEN_PARTIAL", 60: "OPEN_PARTIAL_BLOCK", 65: "OPEN_SEXPR", 68: "CLOSE_SEXPR", 72: "ID", 73: "EQUALS", 75: "OPEN_BLOCK_PARAMS", 77: "CLOSE_BLOCK_PARAMS", 80: "STRING", 81: "NUMBER", 82: "BOOLEAN", 83: "UNDEFINED", 84: "NULL", 85: "DATA", 87: "SEP" },
		        productions_: [0, [3, 2], [4, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [13, 1], [10, 3], [16, 5], [9, 4], [9, 4], [24, 6], [27, 6], [38, 6], [43, 2], [45, 3], [45, 1], [26, 3], [8, 5], [8, 5], [11, 5], [12, 3], [59, 5], [63, 1], [63, 1], [64, 5], [69, 1], [71, 3], [74, 3], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [56, 1], [56, 1], [79, 2], [78, 1], [86, 3], [86, 1], [6, 0], [6, 2], [17, 1], [17, 2], [21, 0], [21, 2], [22, 0], [22, 1], [25, 0], [25, 1], [28, 0], [28, 1], [30, 0], [30, 2], [31, 0], [31, 1], [32, 0], [32, 1], [35, 0], [35, 2], [36, 0], [36, 1], [37, 0], [37, 1], [40, 0], [40, 2], [41, 0], [41, 1], [42, 0], [42, 1], [46, 0], [46, 1], [49, 0], [49, 2], [50, 0], [50, 1], [52, 0], [52, 2], [53, 0], [53, 1], [57, 0], [57, 2], [58, 0], [58, 1], [61, 0], [61, 2], [62, 0], [62, 1], [66, 0], [66, 2], [67, 0], [67, 1], [70, 1], [70, 2], [76, 1], [76, 2]],
		        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, /* action[1] */$$, /* vstack */_$ /* lstack */) {
		            /* this == yyval */
	
		            var $0 = $$.length - 1;
		            switch (yystate) {
		                case 1:
		                    return $$[$0 - 1];
		                    break;
		                case 2:
		                    this.$ = yy.prepareProgram($$[$0]);
		                    break;
		                case 3:case 4:case 5:case 6:case 7:case 8:case 20:case 27:case 28:case 33:case 34:case 40:case 41:
		                    this.$ = $$[$0];
		                    break;
		                case 9:
	
		                    this.$ = {
		                        type: 'CommentStatement',
		                        value: yy.stripComment($$[$0]),
		                        strip: yy.stripFlags($$[$0], $$[$0]),
		                        loc: yy.locInfo(this._$)
		                    };
	
		                    break;
		                case 10:
	
		                    this.$ = {
		                        type: 'ContentStatement',
		                        original: $$[$0],
		                        value: $$[$0],
		                        loc: yy.locInfo(this._$)
		                    };
	
		                    break;
		                case 11:
		                    this.$ = yy.prepareRawBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
		                    break;
		                case 12:
		                    this.$ = { path: $$[$0 - 3], params: $$[$0 - 2], hash: $$[$0 - 1] };
		                    break;
		                case 13:
		                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], false, this._$);
		                    break;
		                case 14:
		                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], true, this._$);
		                    break;
		                case 15:
		                    this.$ = { open: $$[$0 - 5], path: $$[$0 - 4], params: $$[$0 - 3], hash: $$[$0 - 2], blockParams: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 5], $$[$0]) };
		                    break;
		                case 16:case 17:
		                    this.$ = { path: $$[$0 - 4], params: $$[$0 - 3], hash: $$[$0 - 2], blockParams: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 5], $$[$0]) };
		                    break;
		                case 18:
		                    this.$ = { strip: yy.stripFlags($$[$0 - 1], $$[$0 - 1]), program: $$[$0] };
		                    break;
		                case 19:
	
		                    var inverse = yy.prepareBlock($$[$0 - 2], $$[$0 - 1], $$[$0], $$[$0], false, this._$),
		                        program = yy.prepareProgram([inverse], $$[$0 - 1].loc);
		                    program.chained = true;
	
		                    this.$ = { strip: $$[$0 - 2].strip, program: program, chain: true };
	
		                    break;
		                case 21:
		                    this.$ = { path: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 2], $$[$0]) };
		                    break;
		                case 22:case 23:
		                    this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
		                    break;
		                case 24:
	
		                    this.$ = {
		                        type: 'PartialStatement',
		                        name: $$[$0 - 3],
		                        params: $$[$0 - 2],
		                        hash: $$[$0 - 1],
		                        indent: '',
		                        strip: yy.stripFlags($$[$0 - 4], $$[$0]),
		                        loc: yy.locInfo(this._$)
		                    };
	
		                    break;
		                case 25:
		                    this.$ = yy.preparePartialBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
		                    break;
		                case 26:
		                    this.$ = { path: $$[$0 - 3], params: $$[$0 - 2], hash: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 4], $$[$0]) };
		                    break;
		                case 29:
	
		                    this.$ = {
		                        type: 'SubExpression',
		                        path: $$[$0 - 3],
		                        params: $$[$0 - 2],
		                        hash: $$[$0 - 1],
		                        loc: yy.locInfo(this._$)
		                    };
	
		                    break;
		                case 30:
		                    this.$ = { type: 'Hash', pairs: $$[$0], loc: yy.locInfo(this._$) };
		                    break;
		                case 31:
		                    this.$ = { type: 'HashPair', key: yy.id($$[$0 - 2]), value: $$[$0], loc: yy.locInfo(this._$) };
		                    break;
		                case 32:
		                    this.$ = yy.id($$[$0 - 1]);
		                    break;
		                case 35:
		                    this.$ = { type: 'StringLiteral', value: $$[$0], original: $$[$0], loc: yy.locInfo(this._$) };
		                    break;
		                case 36:
		                    this.$ = { type: 'NumberLiteral', value: Number($$[$0]), original: Number($$[$0]), loc: yy.locInfo(this._$) };
		                    break;
		                case 37:
		                    this.$ = { type: 'BooleanLiteral', value: $$[$0] === 'true', original: $$[$0] === 'true', loc: yy.locInfo(this._$) };
		                    break;
		                case 38:
		                    this.$ = { type: 'UndefinedLiteral', original: undefined, value: undefined, loc: yy.locInfo(this._$) };
		                    break;
		                case 39:
		                    this.$ = { type: 'NullLiteral', original: null, value: null, loc: yy.locInfo(this._$) };
		                    break;
		                case 42:
		                    this.$ = yy.preparePath(true, $$[$0], this._$);
		                    break;
		                case 43:
		                    this.$ = yy.preparePath(false, $$[$0], this._$);
		                    break;
		                case 44:
		                    $$[$0 - 2].push({ part: yy.id($$[$0]), original: $$[$0], separator: $$[$0 - 1] });this.$ = $$[$0 - 2];
		                    break;
		                case 45:
		                    this.$ = [{ part: yy.id($$[$0]), original: $$[$0] }];
		                    break;
		                case 46:case 50:case 58:case 64:case 70:case 78:case 82:case 86:case 90:case 94:
		                    this.$ = [];
		                    break;
		                case 47:case 49:case 51:case 59:case 65:case 71:case 79:case 83:case 87:case 91:case 95:case 99:case 101:
		                    $$[$0 - 1].push($$[$0]);
		                    break;
		                case 48:case 98:case 100:
		                    this.$ = [$$[$0]];
		                    break;
		            }
		        },
		        table: [o([5, 14, 15, 19, 29, 34, 48, 51, 55, 60], $V0, { 3: 1, 4: 2, 6: 3 }), { 1: [3] }, { 5: [1, 4] }, o([5, 39, 44, 47], [2, 2], { 7: 5, 8: 6, 9: 7, 10: 8, 11: 9, 12: 10, 13: 11, 24: 15, 27: 16, 16: 17, 59: 19, 14: [1, 12], 15: $V1, 19: [1, 23], 29: [1, 21], 34: [1, 22], 48: [1, 13], 51: [1, 14], 55: [1, 18], 60: [1, 24] }), { 1: [2, 1] }, o($V2, [2, 47]), o($V2, [2, 3]), o($V2, [2, 4]), o($V2, [2, 5]), o($V2, [2, 6]), o($V2, [2, 7]), o($V2, [2, 8]), o($V2, [2, 9]), { 20: 25, 72: $V3, 78: 26, 79: 27, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9, 86: 33 }, { 20: 36, 72: $V3, 78: 26, 79: 27, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9, 86: 33 }, o($Va, $V0, { 6: 3, 4: 37 }), o($Vb, $V0, { 6: 3, 4: 38 }), { 13: 40, 15: $V1, 17: 39 }, { 20: 42, 56: 41, 64: 43, 65: $Vc, 72: $V3, 78: 26, 79: 27, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9, 86: 33 }, o($Vd, $V0, { 6: 3, 4: 45 }), o([5, 14, 15, 18, 19, 29, 34, 39, 44, 47, 48, 51, 55, 60], [2, 10]), { 20: 46, 72: $V3, 78: 26, 79: 27, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9, 86: 33 }, { 20: 47, 72: $V3, 78: 26, 79: 27, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9, 86: 33 }, { 20: 48, 72: $V3, 78: 26, 79: 27, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9, 86: 33 }, { 20: 42, 56: 49, 64: 43, 65: $Vc, 72: $V3, 78: 26, 79: 27, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9, 86: 33 }, o($Ve, [2, 78], { 49: 50 }), o($Vf, [2, 33]), o($Vf, [2, 34]), o($Vf, [2, 35]), o($Vf, [2, 36]), o($Vf, [2, 37]), o($Vf, [2, 38]), o($Vf, [2, 39]), o($Vf, [2, 43], { 87: $Vg }), { 72: $V3, 86: 52 }, o($Vh, $Vi), o($Vj, [2, 82], { 52: 53 }), { 25: 54, 38: 56, 39: $Vk, 43: 57, 44: $Vl, 45: 55, 47: [2, 54] }, { 28: 60, 43: 61, 44: $Vl, 47: [2, 56] }, { 13: 63, 15: $V1, 18: [1, 62] }, o($Vm, [2, 48]), o($Ve, [2, 86], { 57: 64 }), o($Ve, [2, 40]), o($Ve, [2, 41]), { 20: 65, 72: $V3, 78: 26, 79: 27, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9, 86: 33 }, { 26: 66, 47: $Vn }, o($Vo, [2, 58], { 30: 68 }), o($Vo, [2, 64], { 35: 69 }), o($Vp, [2, 50], { 21: 70 }), o($Ve, [2, 90], { 61: 71 }), { 20: 75, 33: [2, 80], 50: 72, 63: 73, 64: 76, 65: $Vc, 69: 74, 70: 77, 71: 78, 72: $Vq, 78: 26, 79: 27, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9, 86: 33 }, { 72: [1, 80] }, o($Vf, [2, 42], { 87: $Vg }), { 20: 75, 53: 81, 54: [2, 84], 63: 82, 64: 76, 65: $Vc, 69: 83, 70: 77, 71: 78, 72: $Vq, 78: 26, 79: 27, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9, 86: 33 }, { 26: 84, 47: $Vn }, { 47: [2, 55] }, o($Va, $V0, { 6: 3, 4: 85 }), { 47: [2, 20] }, { 20: 86, 72: $V3, 78: 26, 79: 27, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9, 86: 33 }, o($Vd, $V0, { 6: 3, 4: 87 }), { 26: 88, 47: $Vn }, { 47: [2, 57] }, o($V2, [2, 11]), o($Vm, [2, 49]), { 20: 75, 33: [2, 88], 58: 89, 63: 90, 64: 76, 65: $Vc, 69: 91, 70: 77, 71: 78, 72: $Vq, 78: 26, 79: 27, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9, 86: 33 }, o($Vr, [2, 94], { 66: 92 }), o($V2, [2, 25]), { 20: 93, 72: $V3, 78: 26, 79: 27, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9, 86: 33 }, o($Vs, [2, 60], { 78: 26, 79: 27, 86: 33, 20: 75, 64: 76, 70: 77, 71: 78, 31: 94, 63: 95, 69: 96, 65: $Vc, 72: $Vq, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9 }), o($Vs, [2, 66], { 78: 26, 79: 27, 86: 33, 20: 75, 64: 76, 70: 77, 71: 78, 36: 97, 63: 98, 69: 99, 65: $Vc, 72: $Vq, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9 }), { 20: 75, 22: 100, 23: [2, 52], 63: 101, 64: 76, 65: $Vc, 69: 102, 70: 77, 71: 78, 72: $Vq, 78: 26, 79: 27, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9, 86: 33 }, { 20: 75, 33: [2, 92], 62: 103, 63: 104, 64: 76, 65: $Vc, 69: 105, 70: 77, 71: 78, 72: $Vq, 78: 26, 79: 27, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9, 86: 33 }, { 33: [1, 106] }, o($Ve, [2, 79]), { 33: [2, 81] }, o($Vf, [2, 27]), o($Vf, [2, 28]), o([23, 33, 54, 68, 75], [2, 30], { 71: 107, 72: [1, 108] }), o($Vt, [2, 98]), o($Vh, $Vi, { 73: $Vu }), o($Vh, [2, 44]), { 54: [1, 110] }, o($Vj, [2, 83]), { 54: [2, 85] }, o($V2, [2, 13]), { 38: 56, 39: $Vk, 43: 57, 44: $Vl, 45: 112, 46: 111, 47: [2, 76] }, o($Vo, [2, 70], { 40: 113 }), { 47: [2, 18] }, o($V2, [2, 14]), { 33: [1, 114] }, o($Ve, [2, 87]), { 33: [2, 89] }, { 20: 75, 63: 116, 64: 76, 65: $Vc, 67: 115, 68: [2, 96], 69: 117, 70: 77, 71: 78, 72: $Vq, 78: 26, 79: 27, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9, 86: 33 }, { 33: [1, 118] }, { 32: 119, 33: [2, 62], 74: 120, 75: $Vv }, o($Vo, [2, 59]), o($Vs, [2, 61]), { 33: [2, 68], 37: 122, 74: 123, 75: $Vv }, o($Vo, [2, 65]), o($Vs, [2, 67]), { 23: [1, 124] }, o($Vp, [2, 51]), { 23: [2, 53] }, { 33: [1, 125] }, o($Ve, [2, 91]), { 33: [2, 93] }, o($V2, [2, 22]), o($Vt, [2, 99]), { 73: $Vu }, { 20: 75, 63: 126, 64: 76, 65: $Vc, 72: $V3, 78: 26, 79: 27, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9, 86: 33 }, o($V2, [2, 23]), { 47: [2, 19] }, { 47: [2, 77] }, o($Vs, [2, 72], { 78: 26, 79: 27, 86: 33, 20: 75, 64: 76, 70: 77, 71: 78, 41: 127, 63: 128, 69: 129, 65: $Vc, 72: $Vq, 80: $V4, 81: $V5, 82: $V6, 83: $V7, 84: $V8, 85: $V9 }), o($V2, [2, 24]), { 68: [1, 130] }, o($Vr, [2, 95]), { 68: [2, 97] }, o($V2, [2, 21]), { 33: [1, 131] }, { 33: [2, 63] }, { 72: [1, 133], 76: 132 }, { 33: [1, 134] }, { 33: [2, 69] }, { 15: [2, 12] }, o($Vd, [2, 26]), o($Vt, [2, 31]), { 33: [2, 74], 42: 135, 74: 136, 75: $Vv }, o($Vo, [2, 71]), o($Vs, [2, 73]), o($Vf, [2, 29]), o($Va, [2, 15]), { 72: [1, 138], 77: [1, 137] }, o($Vw, [2, 100]), o($Vb, [2, 16]), { 33: [1, 139] }, { 33: [2, 75] }, { 33: [2, 32] }, o($Vw, [2, 101]), o($Va, [2, 17])],
		        defaultActions: { 4: [2, 1], 55: [2, 55], 57: [2, 20], 61: [2, 57], 74: [2, 81], 83: [2, 85], 87: [2, 18], 91: [2, 89], 102: [2, 53], 105: [2, 93], 111: [2, 19], 112: [2, 77], 117: [2, 97], 120: [2, 63], 123: [2, 69], 124: [2, 12], 136: [2, 75], 137: [2, 32] },
		        parseError: function parseError(str, hash) {
		            if (hash.recoverable) {
		                this.trace(str);
		            } else {
		                var _parseError = function _parseError(msg, hash) {
		                    this.message = msg;
		                    this.hash = hash;
		                };
	
		                _parseError.prototype = new Error();
	
		                throw new _parseError(str, hash);
		            }
		        },
		        parse: function parse(input) {
		            var self = this,
		                stack = [0],
		                tstack = [],
		                vstack = [null],
		                lstack = [],
		                table = this.table,
		                yytext = '',
		                yylineno = 0,
		                yyleng = 0,
		                recovering = 0,
		                TERROR = 2,
		                EOF = 1;
		            var args = lstack.slice.call(arguments, 1);
		            var lexer = Object.create(this.lexer);
		            var sharedState = { yy: {} };
		            for (var k in this.yy) {
		                if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
		                    sharedState.yy[k] = this.yy[k];
		                }
		            }
		            lexer.setInput(input, sharedState.yy);
		            sharedState.yy.lexer = lexer;
		            sharedState.yy.parser = this;
		            if (typeof lexer.yylloc == 'undefined') {
		                lexer.yylloc = {};
		            }
		            var yyloc = lexer.yylloc;
		            lstack.push(yyloc);
		            var ranges = lexer.options && lexer.options.ranges;
		            if (typeof sharedState.yy.parseError === 'function') {
		                this.parseError = sharedState.yy.parseError;
		            } else {
		                this.parseError = Object.getPrototypeOf(this).parseError;
		            }
		            function popStack(n) {
		                stack.length = stack.length - 2 * n;
		                vstack.length = vstack.length - n;
		                lstack.length = lstack.length - n;
		            }
		            _token_stack: var lex = function lex() {
		                var token;
		                token = lexer.lex() || EOF;
		                if (typeof token !== 'number') {
		                    token = self.symbols_[token] || token;
		                }
		                return token;
		            };
		            var symbol,
		                preErrorSymbol,
		                state,
		                action,
		                a,
		                r,
		                yyval = {},
		                p,
		                len,
		                newState,
		                expected;
		            while (true) {
		                state = stack[stack.length - 1];
		                if (this.defaultActions[state]) {
		                    action = this.defaultActions[state];
		                } else {
		                    if (symbol === null || typeof symbol == 'undefined') {
		                        symbol = lex();
		                    }
		                    action = table[state] && table[state][symbol];
		                }
		                if (typeof action === 'undefined' || !action.length || !action[0]) {
		                    var errStr = '';
		                    expected = [];
		                    for (p in table[state]) {
		                        if (this.terminals_[p] && p > TERROR) {
		                            expected.push('\'' + this.terminals_[p] + '\'');
		                        }
		                    }
		                    if (lexer.showPosition) {
		                        errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
		                    } else {
		                        errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
		                    }
		                    this.parseError(errStr, {
		                        text: lexer.match,
		                        token: this.terminals_[symbol] || symbol,
		                        line: lexer.yylineno,
		                        loc: yyloc,
		                        expected: expected
		                    });
		                }
		                if (action[0] instanceof Array && action.length > 1) {
		                    throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
		                }
		                switch (action[0]) {
		                    case 1:
		                        stack.push(symbol);
		                        vstack.push(lexer.yytext);
		                        lstack.push(lexer.yylloc);
		                        stack.push(action[1]);
		                        symbol = null;
		                        if (!preErrorSymbol) {
		                            yyleng = lexer.yyleng;
		                            yytext = lexer.yytext;
		                            yylineno = lexer.yylineno;
		                            yyloc = lexer.yylloc;
		                            if (recovering > 0) {
		                                recovering--;
		                            }
		                        } else {
		                            symbol = preErrorSymbol;
		                            preErrorSymbol = null;
		                        }
		                        break;
		                    case 2:
		                        len = this.productions_[action[1]][1];
		                        yyval.$ = vstack[vstack.length - len];
		                        yyval._$ = {
		                            first_line: lstack[lstack.length - (len || 1)].first_line,
		                            last_line: lstack[lstack.length - 1].last_line,
		                            first_column: lstack[lstack.length - (len || 1)].first_column,
		                            last_column: lstack[lstack.length - 1].last_column
		                        };
		                        if (ranges) {
		                            yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
		                        }
		                        r = this.performAction.apply(yyval, [yytext, yyleng, yylineno, sharedState.yy, action[1], vstack, lstack].concat(args));
		                        if (typeof r !== 'undefined') {
		                            return r;
		                        }
		                        if (len) {
		                            stack = stack.slice(0, -1 * len * 2);
		                            vstack = vstack.slice(0, -1 * len);
		                            lstack = lstack.slice(0, -1 * len);
		                        }
		                        stack.push(this.productions_[action[1]][0]);
		                        vstack.push(yyval.$);
		                        lstack.push(yyval._$);
		                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
		                        stack.push(newState);
		                        break;
		                    case 3:
		                        return true;
		                }
		            }
		            return true;
		        } };
		    /* generated by jison-lex 0.3.4 */
		    var lexer = (function () {
		        var lexer = {
	
		            EOF: 1,
	
		            parseError: function parseError(str, hash) {
		                if (this.yy.parser) {
		                    this.yy.parser.parseError(str, hash);
		                } else {
		                    throw new Error(str);
		                }
		            },
	
		            // resets the lexer, sets new input
		            setInput: function setInput(input, yy) {
		                this.yy = yy || this.yy || {};
		                this._input = input;
		                this._more = this._backtrack = this.done = false;
		                this.yylineno = this.yyleng = 0;
		                this.yytext = this.matched = this.match = '';
		                this.conditionStack = ['INITIAL'];
		                this.yylloc = {
		                    first_line: 1,
		                    first_column: 0,
		                    last_line: 1,
		                    last_column: 0
		                };
		                if (this.options.ranges) {
		                    this.yylloc.range = [0, 0];
		                }
		                this.offset = 0;
		                return this;
		            },
	
		            // consumes and returns one char from the input
		            input: function input() {
		                var ch = this._input[0];
		                this.yytext += ch;
		                this.yyleng++;
		                this.offset++;
		                this.match += ch;
		                this.matched += ch;
		                var lines = ch.match(/(?:\r\n?|\n).*/g);
		                if (lines) {
		                    this.yylineno++;
		                    this.yylloc.last_line++;
		                } else {
		                    this.yylloc.last_column++;
		                }
		                if (this.options.ranges) {
		                    this.yylloc.range[1]++;
		                }
	
		                this._input = this._input.slice(1);
		                return ch;
		            },
	
		            // unshifts one char (or a string) into the input
		            unput: function unput(ch) {
		                var len = ch.length;
		                var lines = ch.split(/(?:\r\n?|\n)/g);
	
		                this._input = ch + this._input;
		                this.yytext = this.yytext.substr(0, this.yytext.length - len);
		                //this.yyleng -= len;
		                this.offset -= len;
		                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
		                this.match = this.match.substr(0, this.match.length - 1);
		                this.matched = this.matched.substr(0, this.matched.length - 1);
	
		                if (lines.length - 1) {
		                    this.yylineno -= lines.length - 1;
		                }
		                var r = this.yylloc.range;
	
		                this.yylloc = {
		                    first_line: this.yylloc.first_line,
		                    last_line: this.yylineno + 1,
		                    first_column: this.yylloc.first_column,
		                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
		                };
	
		                if (this.options.ranges) {
		                    this.yylloc.range = [r[0], r[0] + this.yyleng - len];
		                }
		                this.yyleng = this.yytext.length;
		                return this;
		            },
	
		            // When called from action, caches matched text and appends it on next action
		            more: function more() {
		                this._more = true;
		                return this;
		            },
	
		            // When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
		            reject: function reject() {
		                if (this.options.backtrack_lexer) {
		                    this._backtrack = true;
		                } else {
		                    return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
		                        text: "",
		                        token: null,
		                        line: this.yylineno
		                    });
		                }
		                return this;
		            },
	
		            // retain first n characters of the match
		            less: function less(n) {
		                this.unput(this.match.slice(n));
		            },
	
		            // displays already matched input, i.e. for error messages
		            pastInput: function pastInput() {
		                var past = this.matched.substr(0, this.matched.length - this.match.length);
		                return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
		            },
	
		            // displays upcoming input, i.e. for error messages
		            upcomingInput: function upcomingInput() {
		                var next = this.match;
		                if (next.length < 20) {
		                    next += this._input.substr(0, 20 - next.length);
		                }
		                return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
		            },
	
		            // displays the character position where the lexing error occurred, i.e. for error messages
		            showPosition: function showPosition() {
		                var pre = this.pastInput();
		                var c = new Array(pre.length + 1).join("-");
		                return pre + this.upcomingInput() + "\n" + c + "^";
		            },
	
		            // test the lexed token: return FALSE when not a match, otherwise return token
		            test_match: function test_match(match, indexed_rule) {
		                var token, lines, backup;
	
		                if (this.options.backtrack_lexer) {
		                    // save context
		                    backup = {
		                        yylineno: this.yylineno,
		                        yylloc: {
		                            first_line: this.yylloc.first_line,
		                            last_line: this.last_line,
		                            first_column: this.yylloc.first_column,
		                            last_column: this.yylloc.last_column
		                        },
		                        yytext: this.yytext,
		                        match: this.match,
		                        matches: this.matches,
		                        matched: this.matched,
		                        yyleng: this.yyleng,
		                        offset: this.offset,
		                        _more: this._more,
		                        _input: this._input,
		                        yy: this.yy,
		                        conditionStack: this.conditionStack.slice(0),
		                        done: this.done
		                    };
		                    if (this.options.ranges) {
		                        backup.yylloc.range = this.yylloc.range.slice(0);
		                    }
		                }
	
		                lines = match[0].match(/(?:\r\n?|\n).*/g);
		                if (lines) {
		                    this.yylineno += lines.length;
		                }
		                this.yylloc = {
		                    first_line: this.yylloc.last_line,
		                    last_line: this.yylineno + 1,
		                    first_column: this.yylloc.last_column,
		                    last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length
		                };
		                this.yytext += match[0];
		                this.match += match[0];
		                this.matches = match;
		                this.yyleng = this.yytext.length;
		                if (this.options.ranges) {
		                    this.yylloc.range = [this.offset, this.offset += this.yyleng];
		                }
		                this._more = false;
		                this._backtrack = false;
		                this._input = this._input.slice(match[0].length);
		                this.matched += match[0];
		                token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
		                if (this.done && this._input) {
		                    this.done = false;
		                }
		                if (token) {
		                    return token;
		                } else if (this._backtrack) {
		                    // recover context
		                    for (var k in backup) {
		                        this[k] = backup[k];
		                    }
		                    return false; // rule action called reject() implying the next rule should be tested instead.
		                }
		                return false;
		            },
	
		            // return next match in input
		            next: function next() {
		                if (this.done) {
		                    return this.EOF;
		                }
		                if (!this._input) {
		                    this.done = true;
		                }
	
		                var token, match, tempMatch, index;
		                if (!this._more) {
		                    this.yytext = '';
		                    this.match = '';
		                }
		                var rules = this._currentRules();
		                for (var i = 0; i < rules.length; i++) {
		                    tempMatch = this._input.match(this.rules[rules[i]]);
		                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
		                        match = tempMatch;
		                        index = i;
		                        if (this.options.backtrack_lexer) {
		                            token = this.test_match(tempMatch, rules[i]);
		                            if (token !== false) {
		                                return token;
		                            } else if (this._backtrack) {
		                                match = false;
		                                continue; // rule action called reject() implying a rule MISmatch.
		                            } else {
		                                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
		                                    return false;
		                                }
		                        } else if (!this.options.flex) {
		                            break;
		                        }
		                    }
		                }
		                if (match) {
		                    token = this.test_match(match, rules[index]);
		                    if (token !== false) {
		                        return token;
		                    }
		                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
		                    return false;
		                }
		                if (this._input === "") {
		                    return this.EOF;
		                } else {
		                    return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
		                        text: "",
		                        token: null,
		                        line: this.yylineno
		                    });
		                }
		            },
	
		            // return next match that has a token
		            lex: function lex() {
		                var r = this.next();
		                if (r) {
		                    return r;
		                } else {
		                    return this.lex();
		                }
		            },
	
		            // activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
		            begin: function begin(condition) {
		                this.conditionStack.push(condition);
		            },
	
		            // pop the previously active lexer condition state off the condition stack
		            popState: function popState() {
		                var n = this.conditionStack.length - 1;
		                if (n > 0) {
		                    return this.conditionStack.pop();
		                } else {
		                    return this.conditionStack[0];
		                }
		            },
	
		            // produce the lexer rule set which is active for the currently active lexer condition state
		            _currentRules: function _currentRules() {
		                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
		                    return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
		                } else {
		                    return this.conditions["INITIAL"].rules;
		                }
		            },
	
		            // return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
		            topState: function topState(n) {
		                n = this.conditionStack.length - 1 - Math.abs(n || 0);
		                if (n >= 0) {
		                    return this.conditionStack[n];
		                } else {
		                    return "INITIAL";
		                }
		            },
	
		            // alias for begin(condition)
		            pushState: function pushState(condition) {
		                this.begin(condition);
		            },
	
		            // return the number of states currently on the stack
		            stateStackSize: function stateStackSize() {
		                return this.conditionStack.length;
		            },
		            options: {},
		            performAction: function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
	
		                function strip(start, end) {
		                    return yy_.yytext = yy_.yytext.substr(start, yy_.yyleng - end);
		                }
	
		                var YYSTATE = YY_START;
		                switch ($avoiding_name_collisions) {
		                    case 0:
		                        if (yy_.yytext.slice(-2) === "\\\\") {
		                            strip(0, 1);
		                            this.begin("mu");
		                        } else if (yy_.yytext.slice(-1) === "\\") {
		                            strip(0, 1);
		                            this.begin("emu");
		                        } else {
		                            this.begin("mu");
		                        }
		                        if (yy_.yytext) return 15;
	
		                        break;
		                    case 1:
		                        return 15;
		                        break;
		                    case 2:
		                        this.popState();
		                        return 15;
	
		                        break;
		                    case 3:
		                        this.begin('raw');return 15;
		                        break;
		                    case 4:
		                        this.popState();
		                        // Should be using `this.topState()` below, but it currently
		                        // returns the second top instead of the first top. Opened an
		                        // issue about it at https://github.com/zaach/jison/issues/291
		                        if (this.conditionStack[this.conditionStack.length - 1] === 'raw') {
		                            return 15;
		                        } else {
		                            yy_.yytext = yy_.yytext.substr(5, yy_.yyleng - 9);
		                            return 18;
		                        }
	
		                        break;
		                    case 5:
		                        return 15;
		                        break;
		                    case 6:
		                        this.popState();
		                        return 14;
	
		                        break;
		                    case 7:
		                        return 65;
		                        break;
		                    case 8:
		                        return 68;
		                        break;
		                    case 9:
		                        return 19;
		                        break;
		                    case 10:
		                        this.popState();
		                        this.begin('raw');
		                        return 23;
	
		                        break;
		                    case 11:
		                        return 55;
		                        break;
		                    case 12:
		                        return 60;
		                        break;
		                    case 13:
		                        return 29;
		                        break;
		                    case 14:
		                        return 47;
		                        break;
		                    case 15:
		                        this.popState();return 44;
		                        break;
		                    case 16:
		                        this.popState();return 44;
		                        break;
		                    case 17:
		                        return 34;
		                        break;
		                    case 18:
		                        return 39;
		                        break;
		                    case 19:
		                        return 51;
		                        break;
		                    case 20:
		                        return 48;
		                        break;
		                    case 21:
		                        this.unput(yy_.yytext);
		                        this.popState();
		                        this.begin('com');
	
		                        break;
		                    case 22:
		                        this.popState();
		                        return 14;
	
		                        break;
		                    case 23:
		                        return 48;
		                        break;
		                    case 24:
		                        return 73;
		                        break;
		                    case 25:
		                        return 72;
		                        break;
		                    case 26:
		                        return 72;
		                        break;
		                    case 27:
		                        return 87;
		                        break;
		                    case 28:
		                        // ignore whitespace
		                        break;
		                    case 29:
		                        this.popState();return 54;
		                        break;
		                    case 30:
		                        this.popState();return 33;
		                        break;
		                    case 31:
		                        yy_.yytext = strip(1, 2).replace(/\\"/g, '"');return 80;
		                        break;
		                    case 32:
		                        yy_.yytext = strip(1, 2).replace(/\\'/g, "'");return 80;
		                        break;
		                    case 33:
		                        return 85;
		                        break;
		                    case 34:
		                        return 82;
		                        break;
		                    case 35:
		                        return 82;
		                        break;
		                    case 36:
		                        return 83;
		                        break;
		                    case 37:
		                        return 84;
		                        break;
		                    case 38:
		                        return 81;
		                        break;
		                    case 39:
		                        return 75;
		                        break;
		                    case 40:
		                        return 77;
		                        break;
		                    case 41:
		                        return 72;
		                        break;
		                    case 42:
		                        yy_.yytext = yy_.yytext.replace(/\\([\\\]])/g, '$1');return 72;
		                        break;
		                    case 43:
		                        return 'INVALID';
		                        break;
		                    case 44:
		                        return 5;
		                        break;
		                }
		            },
		            rules: [/^(?:[^\x00]*?(?=(\{\{)))/, /^(?:[^\x00]+)/, /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/, /^(?:\{\{\{\{(?=[^\/]))/, /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/, /^(?:[^\x00]*?(?=(\{\{\{\{)))/, /^(?:[\s\S]*?--(~)?\}\})/, /^(?:\()/, /^(?:\))/, /^(?:\{\{\{\{)/, /^(?:\}\}\}\})/, /^(?:\{\{(~)?>)/, /^(?:\{\{(~)?#>)/, /^(?:\{\{(~)?#\*?)/, /^(?:\{\{(~)?\/)/, /^(?:\{\{(~)?\^\s*(~)?\}\})/, /^(?:\{\{(~)?\s*else\s*(~)?\}\})/, /^(?:\{\{(~)?\^)/, /^(?:\{\{(~)?\s*else\b)/, /^(?:\{\{(~)?\{)/, /^(?:\{\{(~)?&)/, /^(?:\{\{(~)?!--)/, /^(?:\{\{(~)?![\s\S]*?\}\})/, /^(?:\{\{(~)?\*?)/, /^(?:=)/, /^(?:\.\.)/, /^(?:\.(?=([=~}\s\/.)|])))/, /^(?:[\/.])/, /^(?:\s+)/, /^(?:\}(~)?\}\})/, /^(?:(~)?\}\})/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*')/, /^(?:@)/, /^(?:true(?=([~}\s)])))/, /^(?:false(?=([~}\s)])))/, /^(?:undefined(?=([~}\s)])))/, /^(?:null(?=([~}\s)])))/, /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/, /^(?:as\s+\|)/, /^(?:\|)/, /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/, /^(?:\[(\\\]|[^\]])*\])/, /^(?:.)/, /^(?:$)/],
		            conditions: { "mu": { "rules": [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44], "inclusive": false }, "emu": { "rules": [2], "inclusive": false }, "com": { "rules": [6], "inclusive": false }, "raw": { "rules": [3, 4, 5], "inclusive": false }, "INITIAL": { "rules": [0, 1, 44], "inclusive": true } }
		        };
		        return lexer;
		    })();
		    parser.lexer = lexer;
		    function Parser() {
		        this.yy = {};
		    }
		    Parser.prototype = parser;parser.Parser = Parser;
		    return new Parser();
		})();exports.__esModule = true;
		exports['default'] = handlebars;
		//# sourceMappingURL=data:application/json;base64,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
	
	
	/***/ },
	/* 22 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		// istanbul ignore next
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _visitor = __webpack_require__(23);
	
		var _visitor2 = _interopRequireDefault(_visitor);
	
		function WhitespaceControl() {
		  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
		  this.options = options;
		}
		WhitespaceControl.prototype = new _visitor2['default']();
	
		WhitespaceControl.prototype.Program = function (program) {
		  var doStandalone = !this.options.ignoreStandalone;
	
		  var isRoot = !this.isRootSeen;
		  this.isRootSeen = true;
	
		  var body = program.body;
		  for (var i = 0, l = body.length; i < l; i++) {
		    var current = body[i],
		        strip = this.accept(current);
	
		    if (!strip) {
		      continue;
		    }
	
		    var _isPrevWhitespace = isPrevWhitespace(body, i, isRoot),
		        _isNextWhitespace = isNextWhitespace(body, i, isRoot),
		        openStandalone = strip.openStandalone && _isPrevWhitespace,
		        closeStandalone = strip.closeStandalone && _isNextWhitespace,
		        inlineStandalone = strip.inlineStandalone && _isPrevWhitespace && _isNextWhitespace;
	
		    if (strip.close) {
		      omitRight(body, i, true);
		    }
		    if (strip.open) {
		      omitLeft(body, i, true);
		    }
	
		    if (doStandalone && inlineStandalone) {
		      omitRight(body, i);
	
		      if (omitLeft(body, i)) {
		        // If we are on a standalone node, save the indent info for partials
		        if (current.type === 'PartialStatement') {
		          // Pull out the whitespace from the final line
		          current.indent = /([ \t]+$)/.exec(body[i - 1].original)[1];
		        }
		      }
		    }
		    if (doStandalone && openStandalone) {
		      omitRight((current.program || current.inverse).body);
	
		      // Strip out the previous content node if it's whitespace only
		      omitLeft(body, i);
		    }
		    if (doStandalone && closeStandalone) {
		      // Always strip the next node
		      omitRight(body, i);
	
		      omitLeft((current.inverse || current.program).body);
		    }
		  }
	
		  return program;
		};
	
		WhitespaceControl.prototype.BlockStatement = WhitespaceControl.prototype.DecoratorBlock = WhitespaceControl.prototype.PartialBlockStatement = function (block) {
		  this.accept(block.program);
		  this.accept(block.inverse);
	
		  // Find the inverse program that is involed with whitespace stripping.
		  var program = block.program || block.inverse,
		      inverse = block.program && block.inverse,
		      firstInverse = inverse,
		      lastInverse = inverse;
	
		  if (inverse && inverse.chained) {
		    firstInverse = inverse.body[0].program;
	
		    // Walk the inverse chain to find the last inverse that is actually in the chain.
		    while (lastInverse.chained) {
		      lastInverse = lastInverse.body[lastInverse.body.length - 1].program;
		    }
		  }
	
		  var strip = {
		    open: block.openStrip.open,
		    close: block.closeStrip.close,
	
		    // Determine the standalone candiacy. Basically flag our content as being possibly standalone
		    // so our parent can determine if we actually are standalone
		    openStandalone: isNextWhitespace(program.body),
		    closeStandalone: isPrevWhitespace((firstInverse || program).body)
		  };
	
		  if (block.openStrip.close) {
		    omitRight(program.body, null, true);
		  }
	
		  if (inverse) {
		    var inverseStrip = block.inverseStrip;
	
		    if (inverseStrip.open) {
		      omitLeft(program.body, null, true);
		    }
	
		    if (inverseStrip.close) {
		      omitRight(firstInverse.body, null, true);
		    }
		    if (block.closeStrip.open) {
		      omitLeft(lastInverse.body, null, true);
		    }
	
		    // Find standalone else statments
		    if (!this.options.ignoreStandalone && isPrevWhitespace(program.body) && isNextWhitespace(firstInverse.body)) {
		      omitLeft(program.body);
		      omitRight(firstInverse.body);
		    }
		  } else if (block.closeStrip.open) {
		    omitLeft(program.body, null, true);
		  }
	
		  return strip;
		};
	
		WhitespaceControl.prototype.Decorator = WhitespaceControl.prototype.MustacheStatement = function (mustache) {
		  return mustache.strip;
		};
	
		WhitespaceControl.prototype.PartialStatement = WhitespaceControl.prototype.CommentStatement = function (node) {
		  /* istanbul ignore next */
		  var strip = node.strip || {};
		  return {
		    inlineStandalone: true,
		    open: strip.open,
		    close: strip.close
		  };
		};
	
		function isPrevWhitespace(body, i, isRoot) {
		  if (i === undefined) {
		    i = body.length;
		  }
	
		  // Nodes that end with newlines are considered whitespace (but are special
		  // cased for strip operations)
		  var prev = body[i - 1],
		      sibling = body[i - 2];
		  if (!prev) {
		    return isRoot;
		  }
	
		  if (prev.type === 'ContentStatement') {
		    return (sibling || !isRoot ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(prev.original);
		  }
		}
		function isNextWhitespace(body, i, isRoot) {
		  if (i === undefined) {
		    i = -1;
		  }
	
		  var next = body[i + 1],
		      sibling = body[i + 2];
		  if (!next) {
		    return isRoot;
		  }
	
		  if (next.type === 'ContentStatement') {
		    return (sibling || !isRoot ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(next.original);
		  }
		}
	
		// Marks the node to the right of the position as omitted.
		// I.e. {{foo}}' ' will mark the ' ' node as omitted.
		//
		// If i is undefined, then the first child will be marked as such.
		//
		// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
		// content is met.
		function omitRight(body, i, multiple) {
		  var current = body[i == null ? 0 : i + 1];
		  if (!current || current.type !== 'ContentStatement' || !multiple && current.rightStripped) {
		    return;
		  }
	
		  var original = current.value;
		  current.value = current.value.replace(multiple ? /^\s+/ : /^[ \t]*\r?\n?/, '');
		  current.rightStripped = current.value !== original;
		}
	
		// Marks the node to the left of the position as omitted.
		// I.e. ' '{{foo}} will mark the ' ' node as omitted.
		//
		// If i is undefined then the last child will be marked as such.
		//
		// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
		// content is met.
		function omitLeft(body, i, multiple) {
		  var current = body[i == null ? body.length - 1 : i - 1];
		  if (!current || current.type !== 'ContentStatement' || !multiple && current.leftStripped) {
		    return;
		  }
	
		  // We omit the last node if it's whitespace only and not preceeded by a non-content node.
		  var original = current.value;
		  current.value = current.value.replace(multiple ? /\s+$/ : /[ \t]+$/, '');
		  current.leftStripped = current.value !== original;
		  return current.leftStripped;
		}
	
		exports['default'] = WhitespaceControl;
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,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
	
	
	/***/ },
	/* 23 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		// istanbul ignore next
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _exception = __webpack_require__(4);
	
		var _exception2 = _interopRequireDefault(_exception);
	
		function Visitor() {
		  this.parents = [];
		}
	
		Visitor.prototype = {
		  constructor: Visitor,
		  mutating: false,
	
		  // Visits a given value. If mutating, will replace the value if necessary.
		  acceptKey: function acceptKey(node, name) {
		    var value = this.accept(node[name]);
		    if (this.mutating) {
		      // Hacky sanity check: This may have a few false positives for type for the helper
		      // methods but will generally do the right thing without a lot of overhead.
		      if (value && !Visitor.prototype[value.type]) {
		        throw new _exception2['default']('Unexpected node type "' + value.type + '" found when accepting ' + name + ' on ' + node.type);
		      }
		      node[name] = value;
		    }
		  },
	
		  // Performs an accept operation with added sanity check to ensure
		  // required keys are not removed.
		  acceptRequired: function acceptRequired(node, name) {
		    this.acceptKey(node, name);
	
		    if (!node[name]) {
		      throw new _exception2['default'](node.type + ' requires ' + name);
		    }
		  },
	
		  // Traverses a given array. If mutating, empty respnses will be removed
		  // for child elements.
		  acceptArray: function acceptArray(array) {
		    for (var i = 0, l = array.length; i < l; i++) {
		      this.acceptKey(array, i);
	
		      if (!array[i]) {
		        array.splice(i, 1);
		        i--;
		        l--;
		      }
		    }
		  },
	
		  accept: function accept(object) {
		    if (!object) {
		      return;
		    }
	
		    /* istanbul ignore next: Sanity code */
		    if (!this[object.type]) {
		      throw new _exception2['default']('Unknown type: ' + object.type, object);
		    }
	
		    if (this.current) {
		      this.parents.unshift(this.current);
		    }
		    this.current = object;
	
		    var ret = this[object.type](object);
	
		    this.current = this.parents.shift();
	
		    if (!this.mutating || ret) {
		      return ret;
		    } else if (ret !== false) {
		      return object;
		    }
		  },
	
		  Program: function Program(program) {
		    this.acceptArray(program.body);
		  },
	
		  MustacheStatement: visitSubExpression,
		  Decorator: visitSubExpression,
	
		  BlockStatement: visitBlock,
		  DecoratorBlock: visitBlock,
	
		  PartialStatement: visitPartial,
		  PartialBlockStatement: function PartialBlockStatement(partial) {
		    visitPartial.call(this, partial);
	
		    this.acceptKey(partial, 'program');
		  },
	
		  ContentStatement: function ContentStatement() /* content */{},
		  CommentStatement: function CommentStatement() /* comment */{},
	
		  SubExpression: visitSubExpression,
	
		  PathExpression: function PathExpression() /* path */{},
	
		  StringLiteral: function StringLiteral() /* string */{},
		  NumberLiteral: function NumberLiteral() /* number */{},
		  BooleanLiteral: function BooleanLiteral() /* bool */{},
		  UndefinedLiteral: function UndefinedLiteral() /* literal */{},
		  NullLiteral: function NullLiteral() /* literal */{},
	
		  Hash: function Hash(hash) {
		    this.acceptArray(hash.pairs);
		  },
		  HashPair: function HashPair(pair) {
		    this.acceptRequired(pair, 'value');
		  }
		};
	
		function visitSubExpression(mustache) {
		  this.acceptRequired(mustache, 'path');
		  this.acceptArray(mustache.params);
		  this.acceptKey(mustache, 'hash');
		}
		function visitBlock(block) {
		  visitSubExpression.call(this, block);
	
		  this.acceptKey(block, 'program');
		  this.acceptKey(block, 'inverse');
		}
		function visitPartial(partial) {
		  this.acceptRequired(partial, 'name');
		  this.acceptArray(partial.params);
		  this.acceptKey(partial, 'hash');
		}
	
		exports['default'] = Visitor;
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,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
	
	
	/***/ },
	/* 24 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.SourceLocation = SourceLocation;
		exports.id = id;
		exports.stripFlags = stripFlags;
		exports.stripComment = stripComment;
		exports.preparePath = preparePath;
		exports.prepareMustache = prepareMustache;
		exports.prepareRawBlock = prepareRawBlock;
		exports.prepareBlock = prepareBlock;
		exports.prepareProgram = prepareProgram;
		exports.preparePartialBlock = preparePartialBlock;
		// istanbul ignore next
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _exception = __webpack_require__(4);
	
		var _exception2 = _interopRequireDefault(_exception);
	
		function validateClose(open, close) {
		  close = close.path ? close.path.original : close;
	
		  if (open.path.original !== close) {
		    var errorNode = { loc: open.path.loc };
	
		    throw new _exception2['default'](open.path.original + " doesn't match " + close, errorNode);
		  }
		}
	
		function SourceLocation(source, locInfo) {
		  this.source = source;
		  this.start = {
		    line: locInfo.first_line,
		    column: locInfo.first_column
		  };
		  this.end = {
		    line: locInfo.last_line,
		    column: locInfo.last_column
		  };
		}
	
		function id(token) {
		  if (/^\[.*\]$/.test(token)) {
		    return token.substr(1, token.length - 2);
		  } else {
		    return token;
		  }
		}
	
		function stripFlags(open, close) {
		  return {
		    open: open.charAt(2) === '~',
		    close: close.charAt(close.length - 3) === '~'
		  };
		}
	
		function stripComment(comment) {
		  return comment.replace(/^\{\{~?\!-?-?/, '').replace(/-?-?~?\}\}$/, '');
		}
	
		function preparePath(data, parts, loc) {
		  loc = this.locInfo(loc);
	
		  var original = data ? '@' : '',
		      dig = [],
		      depth = 0;
	
		  for (var i = 0, l = parts.length; i < l; i++) {
		    var part = parts[i].part,
	
		    // If we have [] syntax then we do not treat path references as operators,
		    // i.e. foo.[this] resolves to approximately context.foo['this']
		    isLiteral = parts[i].original !== part;
		    original += (parts[i].separator || '') + part;
	
		    if (!isLiteral && (part === '..' || part === '.' || part === 'this')) {
		      if (dig.length > 0) {
		        throw new _exception2['default']('Invalid path: ' + original, { loc: loc });
		      } else if (part === '..') {
		        depth++;
		      }
		    } else {
		      dig.push(part);
		    }
		  }
	
		  return {
		    type: 'PathExpression',
		    data: data,
		    depth: depth,
		    parts: dig,
		    original: original,
		    loc: loc
		  };
		}
	
		function prepareMustache(path, params, hash, open, strip, locInfo) {
		  // Must use charAt to support IE pre-10
		  var escapeFlag = open.charAt(3) || open.charAt(2),
		      escaped = escapeFlag !== '{' && escapeFlag !== '&';
	
		  var decorator = /\*/.test(open);
		  return {
		    type: decorator ? 'Decorator' : 'MustacheStatement',
		    path: path,
		    params: params,
		    hash: hash,
		    escaped: escaped,
		    strip: strip,
		    loc: this.locInfo(locInfo)
		  };
		}
	
		function prepareRawBlock(openRawBlock, contents, close, locInfo) {
		  validateClose(openRawBlock, close);
	
		  locInfo = this.locInfo(locInfo);
		  var program = {
		    type: 'Program',
		    body: contents,
		    strip: {},
		    loc: locInfo
		  };
	
		  return {
		    type: 'BlockStatement',
		    path: openRawBlock.path,
		    params: openRawBlock.params,
		    hash: openRawBlock.hash,
		    program: program,
		    openStrip: {},
		    inverseStrip: {},
		    closeStrip: {},
		    loc: locInfo
		  };
		}
	
		function prepareBlock(openBlock, program, inverseAndProgram, close, inverted, locInfo) {
		  if (close && close.path) {
		    validateClose(openBlock, close);
		  }
	
		  var decorator = /\*/.test(openBlock.open);
	
		  program.blockParams = openBlock.blockParams;
	
		  var inverse = undefined,
		      inverseStrip = undefined;
	
		  if (inverseAndProgram) {
		    if (decorator) {
		      throw new _exception2['default']('Unexpected inverse block on decorator', inverseAndProgram);
		    }
	
		    if (inverseAndProgram.chain) {
		      inverseAndProgram.program.body[0].closeStrip = close.strip;
		    }
	
		    inverseStrip = inverseAndProgram.strip;
		    inverse = inverseAndProgram.program;
		  }
	
		  if (inverted) {
		    inverted = inverse;
		    inverse = program;
		    program = inverted;
		  }
	
		  return {
		    type: decorator ? 'DecoratorBlock' : 'BlockStatement',
		    path: openBlock.path,
		    params: openBlock.params,
		    hash: openBlock.hash,
		    program: program,
		    inverse: inverse,
		    openStrip: openBlock.strip,
		    inverseStrip: inverseStrip,
		    closeStrip: close && close.strip,
		    loc: this.locInfo(locInfo)
		  };
		}
	
		function prepareProgram(statements, loc) {
		  if (!loc && statements.length) {
		    var firstLoc = statements[0].loc,
		        lastLoc = statements[statements.length - 1].loc;
	
		    /* istanbul ignore else */
		    if (firstLoc && lastLoc) {
		      loc = {
		        source: firstLoc.source,
		        start: {
		          line: firstLoc.start.line,
		          column: firstLoc.start.column
		        },
		        end: {
		          line: lastLoc.end.line,
		          column: lastLoc.end.column
		        }
		      };
		    }
		  }
	
		  return {
		    type: 'Program',
		    body: statements,
		    strip: {},
		    loc: loc
		  };
		}
	
		function preparePartialBlock(open, program, close, locInfo) {
		  validateClose(open, close);
	
		  return {
		    type: 'PartialBlockStatement',
		    name: open.path,
		    params: open.params,
		    hash: open.hash,
		    program: program,
		    openStrip: open.strip,
		    closeStrip: close && close.strip,
		    loc: this.locInfo(locInfo)
		  };
		}
		//# sourceMappingURL=data:application/json;base64,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
	
	
	/***/ },
	/* 25 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* eslint-disable new-cap */
	
		'use strict';
	
		exports.__esModule = true;
		exports.Compiler = Compiler;
		exports.precompile = precompile;
		exports.compile = compile;
		// istanbul ignore next
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _exception = __webpack_require__(4);
	
		var _exception2 = _interopRequireDefault(_exception);
	
		var _utils = __webpack_require__(3);
	
		var _ast = __webpack_require__(19);
	
		var _ast2 = _interopRequireDefault(_ast);
	
		var slice = [].slice;
	
		function Compiler() {}
	
		// the foundHelper register will disambiguate helper lookup from finding a
		// function in a context. This is necessary for mustache compatibility, which
		// requires that context functions in blocks are evaluated by blockHelperMissing,
		// and then proceed as if the resulting value was provided to blockHelperMissing.
	
		Compiler.prototype = {
		  compiler: Compiler,
	
		  equals: function equals(other) {
		    var len = this.opcodes.length;
		    if (other.opcodes.length !== len) {
		      return false;
		    }
	
		    for (var i = 0; i < len; i++) {
		      var opcode = this.opcodes[i],
		          otherOpcode = other.opcodes[i];
		      if (opcode.opcode !== otherOpcode.opcode || !argEquals(opcode.args, otherOpcode.args)) {
		        return false;
		      }
		    }
	
		    // We know that length is the same between the two arrays because they are directly tied
		    // to the opcode behavior above.
		    len = this.children.length;
		    for (var i = 0; i < len; i++) {
		      if (!this.children[i].equals(other.children[i])) {
		        return false;
		      }
		    }
	
		    return true;
		  },
	
		  guid: 0,
	
		  compile: function compile(program, options) {
		    this.sourceNode = [];
		    this.opcodes = [];
		    this.children = [];
		    this.options = options;
	
		    options.blockParams = options.blockParams || [];
	
		    // These changes will propagate to the other compiler components
		    var knownHelpers = options.knownHelpers;
		    options.knownHelpers = {
		      'helperMissing': true,
		      'blockHelperMissing': true,
		      'each': true,
		      'if': true,
		      'unless': true,
		      'with': true,
		      'log': true,
		      'lookup': true
		    };
		    if (knownHelpers) {
		      for (var _name in knownHelpers) {
		        /* istanbul ignore else */
		        if (_name in knownHelpers) {
		          options.knownHelpers[_name] = knownHelpers[_name];
		        }
		      }
		    }
	
		    return this.accept(program);
		  },
	
		  compileProgram: function compileProgram(program) {
		    var childCompiler = new this.compiler(),
		        // eslint-disable-line new-cap
		    result = childCompiler.compile(program, this.options),
		        guid = this.guid++;
	
		    this.usePartial = this.usePartial || result.usePartial;
	
		    this.children[guid] = result;
		    this.useDepths = this.useDepths || result.useDepths;
	
		    return guid;
		  },
	
		  accept: function accept(node) {
		    /* istanbul ignore next: Sanity code */
		    if (!this[node.type]) {
		      throw new _exception2['default']('Unknown type: ' + node.type, node);
		    }
	
		    this.sourceNode.unshift(node);
		    var ret = this[node.type](node);
		    this.sourceNode.shift();
		    return ret;
		  },
	
		  Program: function Program(program) {
		    this.options.blockParams.unshift(program.blockParams);
	
		    var body = program.body,
		        bodyLength = body.length;
		    for (var i = 0; i < bodyLength; i++) {
		      this.accept(body[i]);
		    }
	
		    this.options.blockParams.shift();
	
		    this.isSimple = bodyLength === 1;
		    this.blockParams = program.blockParams ? program.blockParams.length : 0;
	
		    return this;
		  },
	
		  BlockStatement: function BlockStatement(block) {
		    transformLiteralToPath(block);
	
		    var program = block.program,
		        inverse = block.inverse;
	
		    program = program && this.compileProgram(program);
		    inverse = inverse && this.compileProgram(inverse);
	
		    var type = this.classifySexpr(block);
	
		    if (type === 'helper') {
		      this.helperSexpr(block, program, inverse);
		    } else if (type === 'simple') {
		      this.simpleSexpr(block);
	
		      // now that the simple mustache is resolved, we need to
		      // evaluate it by executing `blockHelperMissing`
		      this.opcode('pushProgram', program);
		      this.opcode('pushProgram', inverse);
		      this.opcode('emptyHash');
		      this.opcode('blockValue', block.path.original);
		    } else {
		      this.ambiguousSexpr(block, program, inverse);
	
		      // now that the simple mustache is resolved, we need to
		      // evaluate it by executing `blockHelperMissing`
		      this.opcode('pushProgram', program);
		      this.opcode('pushProgram', inverse);
		      this.opcode('emptyHash');
		      this.opcode('ambiguousBlockValue');
		    }
	
		    this.opcode('append');
		  },
	
		  DecoratorBlock: function DecoratorBlock(decorator) {
		    var program = decorator.program && this.compileProgram(decorator.program);
		    var params = this.setupFullMustacheParams(decorator, program, undefined),
		        path = decorator.path;
	
		    this.useDecorators = true;
		    this.opcode('registerDecorator', params.length, path.original);
		  },
	
		  PartialStatement: function PartialStatement(partial) {
		    this.usePartial = true;
	
		    var program = partial.program;
		    if (program) {
		      program = this.compileProgram(partial.program);
		    }
	
		    var params = partial.params;
		    if (params.length > 1) {
		      throw new _exception2['default']('Unsupported number of partial arguments: ' + params.length, partial);
		    } else if (!params.length) {
		      if (this.options.explicitPartialContext) {
		        this.opcode('pushLiteral', 'undefined');
		      } else {
		        params.push({ type: 'PathExpression', parts: [], depth: 0 });
		      }
		    }
	
		    var partialName = partial.name.original,
		        isDynamic = partial.name.type === 'SubExpression';
		    if (isDynamic) {
		      this.accept(partial.name);
		    }
	
		    this.setupFullMustacheParams(partial, program, undefined, true);
	
		    var indent = partial.indent || '';
		    if (this.options.preventIndent && indent) {
		      this.opcode('appendContent', indent);
		      indent = '';
		    }
	
		    this.opcode('invokePartial', isDynamic, partialName, indent);
		    this.opcode('append');
		  },
		  PartialBlockStatement: function PartialBlockStatement(partialBlock) {
		    this.PartialStatement(partialBlock);
		  },
	
		  MustacheStatement: function MustacheStatement(mustache) {
		    this.SubExpression(mustache);
	
		    if (mustache.escaped && !this.options.noEscape) {
		      this.opcode('appendEscaped');
		    } else {
		      this.opcode('append');
		    }
		  },
		  Decorator: function Decorator(decorator) {
		    this.DecoratorBlock(decorator);
		  },
	
		  ContentStatement: function ContentStatement(content) {
		    if (content.value) {
		      this.opcode('appendContent', content.value);
		    }
		  },
	
		  CommentStatement: function CommentStatement() {},
	
		  SubExpression: function SubExpression(sexpr) {
		    transformLiteralToPath(sexpr);
		    var type = this.classifySexpr(sexpr);
	
		    if (type === 'simple') {
		      this.simpleSexpr(sexpr);
		    } else if (type === 'helper') {
		      this.helperSexpr(sexpr);
		    } else {
		      this.ambiguousSexpr(sexpr);
		    }
		  },
		  ambiguousSexpr: function ambiguousSexpr(sexpr, program, inverse) {
		    var path = sexpr.path,
		        name = path.parts[0],
		        isBlock = program != null || inverse != null;
	
		    this.opcode('getContext', path.depth);
	
		    this.opcode('pushProgram', program);
		    this.opcode('pushProgram', inverse);
	
		    path.strict = true;
		    this.accept(path);
	
		    this.opcode('invokeAmbiguous', name, isBlock);
		  },
	
		  simpleSexpr: function simpleSexpr(sexpr) {
		    var path = sexpr.path;
		    path.strict = true;
		    this.accept(path);
		    this.opcode('resolvePossibleLambda');
		  },
	
		  helperSexpr: function helperSexpr(sexpr, program, inverse) {
		    var params = this.setupFullMustacheParams(sexpr, program, inverse),
		        path = sexpr.path,
		        name = path.parts[0];
	
		    if (this.options.knownHelpers[name]) {
		      this.opcode('invokeKnownHelper', params.length, name);
		    } else if (this.options.knownHelpersOnly) {
		      throw new _exception2['default']('You specified knownHelpersOnly, but used the unknown helper ' + name, sexpr);
		    } else {
		      path.strict = true;
		      path.falsy = true;
	
		      this.accept(path);
		      this.opcode('invokeHelper', params.length, path.original, _ast2['default'].helpers.simpleId(path));
		    }
		  },
	
		  PathExpression: function PathExpression(path) {
		    this.addDepth(path.depth);
		    this.opcode('getContext', path.depth);
	
		    var name = path.parts[0],
		        scoped = _ast2['default'].helpers.scopedId(path),
		        blockParamId = !path.depth && !scoped && this.blockParamIndex(name);
	
		    if (blockParamId) {
		      this.opcode('lookupBlockParam', blockParamId, path.parts);
		    } else if (!name) {
		      // Context reference, i.e. `{{foo .}}` or `{{foo ..}}`
		      this.opcode('pushContext');
		    } else if (path.data) {
		      this.options.data = true;
		      this.opcode('lookupData', path.depth, path.parts, path.strict);
		    } else {
		      this.opcode('lookupOnContext', path.parts, path.falsy, path.strict, scoped);
		    }
		  },
	
		  StringLiteral: function StringLiteral(string) {
		    this.opcode('pushString', string.value);
		  },
	
		  NumberLiteral: function NumberLiteral(number) {
		    this.opcode('pushLiteral', number.value);
		  },
	
		  BooleanLiteral: function BooleanLiteral(bool) {
		    this.opcode('pushLiteral', bool.value);
		  },
	
		  UndefinedLiteral: function UndefinedLiteral() {
		    this.opcode('pushLiteral', 'undefined');
		  },
	
		  NullLiteral: function NullLiteral() {
		    this.opcode('pushLiteral', 'null');
		  },
	
		  Hash: function Hash(hash) {
		    var pairs = hash.pairs,
		        i = 0,
		        l = pairs.length;
	
		    this.opcode('pushHash');
	
		    for (; i < l; i++) {
		      this.pushParam(pairs[i].value);
		    }
		    while (i--) {
		      this.opcode('assignToHash', pairs[i].key);
		    }
		    this.opcode('popHash');
		  },
	
		  // HELPERS
		  opcode: function opcode(name) {
		    this.opcodes.push({ opcode: name, args: slice.call(arguments, 1), loc: this.sourceNode[0].loc });
		  },
	
		  addDepth: function addDepth(depth) {
		    if (!depth) {
		      return;
		    }
	
		    this.useDepths = true;
		  },
	
		  classifySexpr: function classifySexpr(sexpr) {
		    var isSimple = _ast2['default'].helpers.simpleId(sexpr.path);
	
		    var isBlockParam = isSimple && !!this.blockParamIndex(sexpr.path.parts[0]);
	
		    // a mustache is an eligible helper if:
		    // * its id is simple (a single part, not `this` or `..`)
		    var isHelper = !isBlockParam && _ast2['default'].helpers.helperExpression(sexpr);
	
		    // if a mustache is an eligible helper but not a definite
		    // helper, it is ambiguous, and will be resolved in a later
		    // pass or at runtime.
		    var isEligible = !isBlockParam && (isHelper || isSimple);
	
		    // if ambiguous, we can possibly resolve the ambiguity now
		    // An eligible helper is one that does not have a complex path, i.e. `this.foo`, `../foo` etc.
		    if (isEligible && !isHelper) {
		      var _name2 = sexpr.path.parts[0],
		          options = this.options;
	
		      if (options.knownHelpers[_name2]) {
		        isHelper = true;
		      } else if (options.knownHelpersOnly) {
		        isEligible = false;
		      }
		    }
	
		    if (isHelper) {
		      return 'helper';
		    } else if (isEligible) {
		      return 'ambiguous';
		    } else {
		      return 'simple';
		    }
		  },
	
		  pushParams: function pushParams(params) {
		    for (var i = 0, l = params.length; i < l; i++) {
		      this.pushParam(params[i]);
		    }
		  },
	
		  pushParam: function pushParam(val) {
		    this.accept(val);
		  },
	
		  setupFullMustacheParams: function setupFullMustacheParams(sexpr, program, inverse, omitEmpty) {
		    var params = sexpr.params;
		    this.pushParams(params);
	
		    this.opcode('pushProgram', program);
		    this.opcode('pushProgram', inverse);
	
		    if (sexpr.hash) {
		      this.accept(sexpr.hash);
		    } else {
		      this.opcode('emptyHash', omitEmpty);
		    }
	
		    return params;
		  },
	
		  blockParamIndex: function blockParamIndex(name) {
		    for (var depth = 0, len = this.options.blockParams.length; depth < len; depth++) {
		      var blockParams = this.options.blockParams[depth],
		          param = blockParams && _utils.indexOf(blockParams, name);
		      if (blockParams && param >= 0) {
		        return [depth, param];
		      }
		    }
		  }
		};
	
		function precompile(input, options, env) {
		  if (options === undefined) options = {};
	
		  validateInput(input, options);
	
		  var environment = compileEnvironment(input, options, env);
		  return new env.JavaScriptCompiler().compile(environment, options);
		}
	
		function compile(input, options, env) {
		  if (options === undefined) options = {};
	
		  validateInput(input, options);
	
		  var compiled = undefined;
	
		  function compileInput() {
		    var environment = compileEnvironment(input, options, env),
		        templateSpec = new env.JavaScriptCompiler().compile(environment, options, undefined, true);
		    return env.template(templateSpec);
		  }
	
		  // Template is only compiled on first use and cached after that point.
		  return function (context, execOptions) {
		    if (!compiled) {
		      compiled = compileInput();
		    }
		    return compiled.call(this, context, execOptions);
		  };
		}
	
		function validateInput(input, options) {
		  if (input == null || typeof input !== 'string' && input.type !== 'Program') {
		    throw new _exception2['default']('You must pass a string or Handlebars AST to Handlebars.compile. You passed ' + input);
		  }
	
		  if (options.trackIds || options.stringParams) {
		    throw new _exception2['default']('TrackIds and stringParams are no longer supported. See Github #1145');
		  }
	
		  if (!('data' in options)) {
		    options.data = true;
		  }
		  if (options.compat) {
		    options.useDepths = true;
		  }
		}
		function compileEnvironment(input, options, env) {
		  var ast = env.parse(input, options);
		  return new env.Compiler().compile(ast, options);
		}
	
		function argEquals(a, b) {
		  if (a === b) {
		    return true;
		  }
	
		  if (_utils.isArray(a) && _utils.isArray(b) && a.length === b.length) {
		    for (var i = 0; i < a.length; i++) {
		      if (!argEquals(a[i], b[i])) {
		        return false;
		      }
		    }
		    return true;
		  }
		}
	
		function transformLiteralToPath(sexpr) {
		  if (!sexpr.path.parts) {
		    var literal = sexpr.path;
		    // Casting to string here to make false and 0 literal values play nicely with the rest
		    // of the system.
		    sexpr.path = {
		      type: 'PathExpression',
		      data: false,
		      depth: 0,
		      parts: [literal.original + ''],
		      original: literal.original + '',
		      loc: literal.loc
		    };
		  }
		}
		//# sourceMappingURL=data:application/json;base64,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
	
	
	/***/ },
	/* 26 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		// istanbul ignore next
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _base = __webpack_require__(2);
	
		var _exception = __webpack_require__(4);
	
		var _exception2 = _interopRequireDefault(_exception);
	
		var _utils = __webpack_require__(3);
	
		var _codeGen = __webpack_require__(27);
	
		var _codeGen2 = _interopRequireDefault(_codeGen);
	
		function Literal(value) {
		  this.value = value;
		}
	
		function JavaScriptCompiler() {}
	
		JavaScriptCompiler.prototype = {
		  // PUBLIC API: You can override these methods in a subclass to provide
		  // alternative compiled forms for name lookup and buffering semantics
		  nameLookup: function nameLookup(parent, name /* , type*/) {
		    if (JavaScriptCompiler.isValidJavaScriptVariableName(name)) {
		      return [parent, '.', name];
		    } else {
		      return [parent, '[', JSON.stringify(name), ']'];
		    }
		  },
		  depthedLookup: function depthedLookup(name) {
		    return [this.aliasable('container.lookup'), '(depths, "', name, '")'];
		  },
	
		  compilerInfo: function compilerInfo() {
		    var revision = _base.COMPILER_REVISION,
		        versions = _base.REVISION_CHANGES[revision];
		    return [revision, versions];
		  },
	
		  appendToBuffer: function appendToBuffer(source, location, explicit) {
		    // Force a source as this simplifies the merge logic.
		    if (!_utils.isArray(source)) {
		      source = [source];
		    }
		    source = this.source.wrap(source, location);
	
		    if (this.environment.isSimple) {
		      return ['return ', source, ';'];
		    } else if (explicit) {
		      // This is a case where the buffer operation occurs as a child of another
		      // construct, generally braces. We have to explicitly output these buffer
		      // operations to ensure that the emitted code goes in the correct location.
		      return ['buffer += ', source, ';'];
		    } else {
		      source.appendToBuffer = true;
		      return source;
		    }
		  },
	
		  initializeBuffer: function initializeBuffer() {
		    return this.quotedString('');
		  },
		  // END PUBLIC API
	
		  compile: function compile(environment, options, context, asObject) {
		    this.environment = environment;
		    this.options = options;
		    this.precompile = !asObject;
	
		    this.name = this.environment.name;
		    this.isChild = !!context;
		    this.context = context || {
		      decorators: [],
		      programs: [],
		      environments: []
		    };
	
		    this.preamble();
	
		    this.stackSlot = 0;
		    this.stackVars = [];
		    this.aliases = {};
		    this.registers = { list: [] };
		    this.hashes = [];
		    this.compileStack = [];
		    this.inlineStack = [];
		    this.blockParams = [];
	
		    this.compileChildren(environment, options);
	
		    this.useDepths = this.useDepths || environment.useDepths || environment.useDecorators || this.options.compat;
		    this.useBlockParams = this.useBlockParams || environment.useBlockParams;
	
		    var opcodes = environment.opcodes,
		        opcode = undefined,
		        firstLoc = undefined,
		        i = undefined,
		        l = undefined;
	
		    for (i = 0, l = opcodes.length; i < l; i++) {
		      opcode = opcodes[i];
	
		      this.source.currentLocation = opcode.loc;
		      firstLoc = firstLoc || opcode.loc;
		      this[opcode.opcode].apply(this, opcode.args);
		    }
	
		    // Flush any trailing content that might be pending.
		    this.source.currentLocation = firstLoc;
		    this.pushSource('');
	
		    /* istanbul ignore next */
		    if (this.stackSlot || this.inlineStack.length || this.compileStack.length) {
		      throw new _exception2['default']('Compile completed with content left on stack');
		    }
	
		    if (!this.decorators.isEmpty()) {
		      this.useDecorators = true;
	
		      this.decorators.prepend('var decorators = container.decorators;\n');
		      this.decorators.push('return fn;');
	
		      if (asObject) {
		        this.decorators = Function.apply(this, ['fn', 'props', 'container', 'depth0', 'data', 'blockParams', 'depths', this.decorators.merge()]);
		      } else {
		        this.decorators.prepend('function(fn, props, container, depth0, data, blockParams, depths) {\n');
		        this.decorators.push('}\n');
		        this.decorators = this.decorators.merge();
		      }
		    } else {
		      this.decorators = undefined;
		    }
	
		    var fn = this.createFunctionContext(asObject);
		    if (!this.isChild) {
		      var ret = {
		        compiler: this.compilerInfo(),
		        main: fn
		      };
	
		      if (this.decorators) {
		        ret.main_d = this.decorators; // eslint-disable-line camelcase
		        ret.useDecorators = true;
		      }
	
		      var _context = this.context;
		      var programs = _context.programs;
		      var decorators = _context.decorators;
	
		      for (i = 0, l = programs.length; i < l; i++) {
		        if (programs[i]) {
		          ret[i] = programs[i];
		          if (decorators[i]) {
		            ret[i + '_d'] = decorators[i];
		            ret.useDecorators = true;
		          }
		        }
		      }
	
		      if (this.environment.usePartial) {
		        ret.usePartial = true;
		      }
		      if (this.options.data) {
		        ret.useData = true;
		      }
		      if (this.useDepths) {
		        ret.useDepths = true;
		      }
		      if (this.useBlockParams) {
		        ret.useBlockParams = true;
		      }
		      if (this.options.compat) {
		        ret.compat = true;
		      }
	
		      if (!asObject) {
		        ret.compiler = JSON.stringify(ret.compiler);
	
		        this.source.currentLocation = { start: { line: 1, column: 0 } };
		        ret = this.objectLiteral(ret);
	
		        if (options.srcName) {
		          ret = ret.toStringWithSourceMap({ file: options.destName });
		          ret.map = ret.map && ret.map.toString();
		        } else {
		          ret = ret.toString();
		        }
		      } else {
		        ret.compilerOptions = this.options;
		      }
	
		      return ret;
		    } else {
		      return fn;
		    }
		  },
	
		  preamble: function preamble() {
		    // track the last context pushed into place to allow skipping the
		    // getContext opcode when it would be a noop
		    this.lastContext = 0;
		    this.source = new _codeGen2['default'](this.options.srcName);
		    this.decorators = new _codeGen2['default'](this.options.srcName);
		  },
	
		  createFunctionContext: function createFunctionContext(asObject) {
		    var varDeclarations = '';
	
		    var locals = this.stackVars.concat(this.registers.list);
		    if (locals.length > 0) {
		      varDeclarations += ', ' + locals.join(', ');
		    }
	
		    // Generate minimizer alias mappings
		    //
		    // When using true SourceNodes, this will update all references to the given alias
		    // as the source nodes are reused in situ. For the non-source node compilation mode,
		    // aliases will not be used, but this case is already being run on the client and
		    // we aren't concern about minimizing the template size.
		    var aliasCount = 0;
		    for (var alias in this.aliases) {
		      // eslint-disable-line guard-for-in
		      var node = this.aliases[alias];
	
		      if (this.aliases.hasOwnProperty(alias) && node.children && node.referenceCount > 1) {
		        varDeclarations += ', alias' + ++aliasCount + '=' + alias;
		        node.children[0] = 'alias' + aliasCount;
		      }
		    }
	
		    var params = ['container', 'depth0', 'helpers', 'partials', 'data'];
	
		    if (this.useBlockParams || this.useDepths) {
		      params.push('blockParams');
		    }
		    if (this.useDepths) {
		      params.push('depths');
		    }
	
		    // Perform a second pass over the output to merge content when possible
		    var source = this.mergeSource(varDeclarations);
	
		    if (asObject) {
		      params.push(source);
	
		      return Function.apply(this, params);
		    } else {
		      return this.source.wrap(['function(', params.join(','), ') {\n  ', source, '}']);
		    }
		  },
		  mergeSource: function mergeSource(varDeclarations) {
		    var isSimple = this.environment.isSimple,
		        appendOnly = !this.forceBuffer,
		        appendFirst = undefined,
		        sourceSeen = undefined,
		        bufferStart = undefined,
		        bufferEnd = undefined;
		    this.source.each(function (line) {
		      if (line.appendToBuffer) {
		        if (bufferStart) {
		          line.prepend('  + ');
		        } else {
		          bufferStart = line;
		        }
		        bufferEnd = line;
		      } else {
		        if (bufferStart) {
		          if (!sourceSeen) {
		            appendFirst = true;
		          } else {
		            bufferStart.prepend('buffer += ');
		          }
		          bufferEnd.add(';');
		          bufferStart = bufferEnd = undefined;
		        }
	
		        sourceSeen = true;
		        if (!isSimple) {
		          appendOnly = false;
		        }
		      }
		    });
	
		    if (appendOnly) {
		      if (bufferStart) {
		        bufferStart.prepend('return ');
		        bufferEnd.add(';');
		      } else if (!sourceSeen) {
		        this.source.push('return "";');
		      }
		    } else {
		      varDeclarations += ', buffer = ' + (appendFirst ? '' : this.initializeBuffer());
	
		      if (bufferStart) {
		        bufferStart.prepend('return buffer + ');
		        bufferEnd.add(';');
		      } else {
		        this.source.push('return buffer;');
		      }
		    }
	
		    if (varDeclarations) {
		      this.source.prepend('var ' + varDeclarations.substring(2) + (appendFirst ? '' : ';\n'));
		    }
	
		    return this.source.merge();
		  },
	
		  // [blockValue]
		  //
		  // On stack, before: hash, inverse, program, value
		  // On stack, after: return value of blockHelperMissing
		  //
		  // The purpose of this opcode is to take a block of the form
		  // `{{#this.foo}}...{{/this.foo}}`, resolve the value of `foo`, and
		  // replace it on the stack with the result of properly
		  // invoking blockHelperMissing.
		  blockValue: function blockValue(name) {
		    var blockHelperMissing = this.aliasable('helpers.blockHelperMissing'),
		        params = [this.contextName(0)];
		    this.setupHelperArgs(name, 0, params);
	
		    var blockName = this.popStack();
		    params.splice(1, 0, blockName);
	
		    this.push(this.source.functionCall(blockHelperMissing, 'call', params));
		  },
	
		  // [ambiguousBlockValue]
		  //
		  // On stack, before: hash, inverse, program, value
		  // Compiler value, before: lastHelper=value of last found helper, if any
		  // On stack, after, if no lastHelper: same as [blockValue]
		  // On stack, after, if lastHelper: value
		  ambiguousBlockValue: function ambiguousBlockValue() {
		    // We're being a bit cheeky and reusing the options value from the prior exec
		    var blockHelperMissing = this.aliasable('helpers.blockHelperMissing'),
		        params = [this.contextName(0)];
		    this.setupHelperArgs('', 0, params, true);
	
		    this.flushInline();
	
		    var current = this.topStack();
		    params.splice(1, 0, current);
	
		    this.pushSource(['if (!', this.lastHelper, ') { ', current, ' = ', this.source.functionCall(blockHelperMissing, 'call', params), '}']);
		  },
	
		  // [appendContent]
		  //
		  // On stack, before: ...
		  // On stack, after: ...
		  //
		  // Appends the string value of `content` to the current buffer
		  appendContent: function appendContent(content) {
		    if (this.pendingContent) {
		      content = this.pendingContent + content;
		    } else {
		      this.pendingLocation = this.source.currentLocation;
		    }
	
		    this.pendingContent = content;
		  },
	
		  // [append]
		  //
		  // On stack, before: value, ...
		  // On stack, after: ...
		  //
		  // Coerces `value` to a String and appends it to the current buffer.
		  //
		  // If `value` is truthy, or 0, it is coerced into a string and appended
		  // Otherwise, the empty string is appended
		  append: function append() {
		    if (this.isInline()) {
		      this.replaceStack(function (current) {
		        return [' != null ? ', current, ' : ""'];
		      });
	
		      this.pushSource(this.appendToBuffer(this.popStack()));
		    } else {
		      var local = this.popStack();
		      this.pushSource(['if (', local, ' != null) { ', this.appendToBuffer(local, undefined, true), ' }']);
		      if (this.environment.isSimple) {
		        this.pushSource(['else { ', this.appendToBuffer("''", undefined, true), ' }']);
		      }
		    }
		  },
	
		  // [appendEscaped]
		  //
		  // On stack, before: value, ...
		  // On stack, after: ...
		  //
		  // Escape `value` and append it to the buffer
		  appendEscaped: function appendEscaped() {
		    this.pushSource(this.appendToBuffer([this.aliasable('container.escapeExpression'), '(', this.popStack(), ')']));
		  },
	
		  // [getContext]
		  //
		  // On stack, before: ...
		  // On stack, after: ...
		  // Compiler value, after: lastContext=depth
		  //
		  // Set the value of the `lastContext` compiler value to the depth
		  getContext: function getContext(depth) {
		    this.lastContext = depth;
		  },
	
		  // [pushContext]
		  //
		  // On stack, before: ...
		  // On stack, after: currentContext, ...
		  //
		  // Pushes the value of the current context onto the stack.
		  pushContext: function pushContext() {
		    this.pushStackLiteral(this.contextName(this.lastContext));
		  },
	
		  // [lookupOnContext]
		  //
		  // On stack, before: ...
		  // On stack, after: currentContext[name], ...
		  //
		  // Looks up the value of `name` on the current context and pushes
		  // it onto the stack.
		  lookupOnContext: function lookupOnContext(parts, falsy, strict, scoped) {
		    var i = 0;
	
		    if (!scoped && this.options.compat && !this.lastContext) {
		      // The depthed query is expected to handle the undefined logic for the root level that
		      // is implemented below, so we evaluate that directly in compat mode
		      this.push(this.depthedLookup(parts[i++]));
		    } else {
		      this.pushContext();
		    }
	
		    this.resolvePath('context', parts, i, falsy, strict);
		  },
	
		  // [lookupBlockParam]
		  //
		  // On stack, before: ...
		  // On stack, after: blockParam[name], ...
		  //
		  // Looks up the value of `parts` on the given block param and pushes
		  // it onto the stack.
		  lookupBlockParam: function lookupBlockParam(blockParamId, parts) {
		    this.useBlockParams = true;
	
		    this.push(['blockParams[', blockParamId[0], '][', blockParamId[1], ']']);
		    this.resolvePath('context', parts, 1);
		  },
	
		  // [lookupData]
		  //
		  // On stack, before: ...
		  // On stack, after: data, ...
		  //
		  // Push the data lookup operator
		  lookupData: function lookupData(depth, parts, strict) {
		    if (!depth) {
		      this.pushStackLiteral('data');
		    } else {
		      this.pushStackLiteral('container.data(data, ' + depth + ')');
		    }
	
		    this.resolvePath('data', parts, 0, true, strict);
		  },
	
		  resolvePath: function resolvePath(type, parts, i, falsy, strict) {
		    // istanbul ignore next
	
		    var _this = this;
	
		    if (this.options.strict || this.options.assumeObjects) {
		      this.push(strictLookup(this.options.strict && strict, this, parts, type));
		      return;
		    }
	
		    var len = parts.length;
		    for (; i < len; i++) {
		      /* eslint-disable no-loop-func */
		      this.replaceStack(function (current) {
		        var lookup = _this.nameLookup(current, parts[i], type);
		        // We want to ensure that zero and false are handled properly if the context (falsy flag)
		        // needs to have the special handling for these values.
		        if (!falsy) {
		          return [' != null ? ', lookup, ' : ', current];
		        } else {
		          // Otherwise we can use generic falsy handling
		          return [' && ', lookup];
		        }
		      });
		      /* eslint-enable no-loop-func */
		    }
		  },
	
		  // [resolvePossibleLambda]
		  //
		  // On stack, before: value, ...
		  // On stack, after: resolved value, ...
		  //
		  // If the `value` is a lambda, replace it on the stack by
		  // the return value of the lambda
		  resolvePossibleLambda: function resolvePossibleLambda() {
		    this.push([this.aliasable('container.lambda'), '(', this.popStack(), ', ', this.contextName(0), ')']);
		  },
	
		  emptyHash: function emptyHash(omitEmpty) {
		    this.pushStackLiteral(omitEmpty ? 'undefined' : '{}');
		  },
		  pushHash: function pushHash() {
		    if (this.hash) {
		      this.hashes.push(this.hash);
		    }
		    this.hash = { values: {} };
		  },
		  popHash: function popHash() {
		    var hash = this.hash;
		    this.hash = this.hashes.pop();
	
		    this.push(this.objectLiteral(hash.values));
		  },
	
		  // [pushString]
		  //
		  // On stack, before: ...
		  // On stack, after: quotedString(string), ...
		  //
		  // Push a quoted version of `string` onto the stack
		  pushString: function pushString(string) {
		    this.pushStackLiteral(this.quotedString(string));
		  },
	
		  // [pushLiteral]
		  //
		  // On stack, before: ...
		  // On stack, after: value, ...
		  //
		  // Pushes a value onto the stack. This operation prevents
		  // the compiler from creating a temporary variable to hold
		  // it.
		  pushLiteral: function pushLiteral(value) {
		    this.pushStackLiteral(value);
		  },
	
		  // [pushProgram]
		  //
		  // On stack, before: ...
		  // On stack, after: program(guid), ...
		  //
		  // Push a program expression onto the stack. This takes
		  // a compile-time guid and converts it into a runtime-accessible
		  // expression.
		  pushProgram: function pushProgram(guid) {
		    if (guid != null) {
		      this.pushStackLiteral(this.programExpression(guid));
		    } else {
		      this.pushStackLiteral(null);
		    }
		  },
	
		  // [registerDecorator]
		  //
		  // On stack, before: hash, program, params..., ...
		  // On stack, after: ...
		  //
		  // Pops off the decorator's parameters, invokes the decorator,
		  // and inserts the decorator into the decorators list.
		  registerDecorator: function registerDecorator(paramSize, name) {
		    var foundDecorator = this.nameLookup('decorators', name, 'decorator'),
		        options = this.setupHelperArgs(name, paramSize);
	
		    this.decorators.push(['fn = ', this.decorators.functionCall(foundDecorator, '', ['fn', 'props', 'container', options]), ' || fn;']);
		  },
	
		  // [invokeHelper]
		  //
		  // On stack, before: hash, inverse, program, params..., ...
		  // On stack, after: result of helper invocation
		  //
		  // Pops off the helper's parameters, invokes the helper,
		  // and pushes the helper's return value onto the stack.
		  //
		  // If the helper is not found, `helperMissing` is called.
		  invokeHelper: function invokeHelper(paramSize, name, isSimple) {
		    var nonHelper = this.popStack(),
		        helper = this.setupHelper(paramSize, name),
		        simple = isSimple ? [helper.name, ' || '] : '';
	
		    var lookup = ['('].concat(simple, nonHelper);
		    if (!this.options.strict) {
		      lookup.push(' || ', this.aliasable('helpers.helperMissing'));
		    }
		    lookup.push(')');
	
		    this.push(this.source.functionCall(lookup, 'call', helper.callParams));
		  },
	
		  // [invokeKnownHelper]
		  //
		  // On stack, before: hash, inverse, program, params..., ...
		  // On stack, after: result of helper invocation
		  //
		  // This operation is used when the helper is known to exist,
		  // so a `helperMissing` fallback is not required.
		  invokeKnownHelper: function invokeKnownHelper(paramSize, name) {
		    var helper = this.setupHelper(paramSize, name);
		    this.push(this.source.functionCall(helper.name, 'call', helper.callParams));
		  },
	
		  // [invokeAmbiguous]
		  //
		  // On stack, before: hash, inverse, program, params..., ...
		  // On stack, after: result of disambiguation
		  //
		  // This operation is used when an expression like `{{foo}}`
		  // is provided, but we don't know at compile-time whether it
		  // is a helper or a path.
		  //
		  // This operation emits more code than the other options,
		  // and can be avoided by passing the `knownHelpers` and
		  // `knownHelpersOnly` flags at compile-time.
		  invokeAmbiguous: function invokeAmbiguous(name, helperCall) {
		    this.useRegister('helper');
	
		    var nonHelper = this.popStack();
	
		    this.emptyHash();
		    var helper = this.setupHelper(0, name, helperCall);
	
		    var helperName = this.lastHelper = this.nameLookup('helpers', name, 'helper');
	
		    var lookup = ['(', '(helper = ', helperName, ' || ', nonHelper, ')'];
		    if (!this.options.strict) {
		      lookup[0] = '(helper = ';
		      lookup.push(' != null ? helper : ', this.aliasable('helpers.helperMissing'));
		    }
	
		    this.push(['(', lookup, helper.paramsInit ? ['),(', helper.paramsInit] : [], '),', '(typeof helper === ', this.aliasable('"function"'), ' ? ', this.source.functionCall('helper', 'call', helper.callParams), ' : helper))']);
		  },
	
		  // [invokePartial]
		  //
		  // On stack, before: context, ...
		  // On stack after: result of partial invocation
		  //
		  // This operation pops off a context, invokes a partial with that context,
		  // and pushes the result of the invocation back.
		  invokePartial: function invokePartial(isDynamic, name, indent) {
		    var params = [],
		        options = this.setupParams(name, 1, params);
	
		    if (isDynamic) {
		      name = this.popStack();
		      delete options.name;
		    }
	
		    if (indent) {
		      options.indent = JSON.stringify(indent);
		    }
		    options.helpers = 'helpers';
		    options.partials = 'partials';
		    options.decorators = 'container.decorators';
	
		    if (!isDynamic) {
		      params.unshift(this.nameLookup('partials', name, 'partial'));
		    } else {
		      params.unshift(name);
		    }
	
		    if (this.options.compat) {
		      options.depths = 'depths';
		    }
		    options = this.objectLiteral(options);
		    params.push(options);
	
		    this.push(this.source.functionCall('container.invokePartial', '', params));
		  },
	
		  // [assignToHash]
		  //
		  // On stack, before: value, ..., hash, ...
		  // On stack, after: ..., hash, ...
		  //
		  // Pops a value off the stack and assigns it to the current hash
		  assignToHash: function assignToHash(key) {
		    this.hash.values[key] = this.popStack();
		  },
	
		  // HELPERS
	
		  compiler: JavaScriptCompiler,
	
		  compileChildren: function compileChildren(environment, options) {
		    var children = environment.children,
		        child = undefined,
		        compiler = undefined;
	
		    for (var i = 0, l = children.length; i < l; i++) {
		      child = children[i];
		      compiler = new this.compiler(); // eslint-disable-line new-cap
	
		      var existing = this.matchExistingProgram(child);
	
		      if (existing == null) {
		        this.context.programs.push(''); // Placeholder to prevent name conflicts for nested children
		        var index = this.context.programs.length;
		        child.index = index;
		        child.name = 'program' + index;
		        this.context.programs[index] = compiler.compile(child, options, this.context, !this.precompile);
		        this.context.decorators[index] = compiler.decorators;
		        this.context.environments[index] = child;
	
		        this.useDepths = this.useDepths || compiler.useDepths;
		        this.useBlockParams = this.useBlockParams || compiler.useBlockParams;
		        child.useDepths = this.useDepths;
		        child.useBlockParams = this.useBlockParams;
		      } else {
		        child.index = existing.index;
		        child.name = 'program' + existing.index;
	
		        this.useDepths = this.useDepths || existing.useDepths;
		        this.useBlockParams = this.useBlockParams || existing.useBlockParams;
		      }
		    }
		  },
		  matchExistingProgram: function matchExistingProgram(child) {
		    for (var i = 0, len = this.context.environments.length; i < len; i++) {
		      var environment = this.context.environments[i];
		      if (environment && environment.equals(child)) {
		        return environment;
		      }
		    }
		  },
	
		  programExpression: function programExpression(guid) {
		    var child = this.environment.children[guid],
		        programParams = [child.index, 'data', child.blockParams];
	
		    if (this.useBlockParams || this.useDepths) {
		      programParams.push('blockParams');
		    }
		    if (this.useDepths) {
		      programParams.push('depths');
		    }
	
		    return 'container.program(' + programParams.join(', ') + ')';
		  },
	
		  useRegister: function useRegister(name) {
		    if (!this.registers[name]) {
		      this.registers[name] = true;
		      this.registers.list.push(name);
		    }
		  },
	
		  push: function push(expr) {
		    if (!(expr instanceof Literal)) {
		      expr = this.source.wrap(expr);
		    }
	
		    this.inlineStack.push(expr);
		    return expr;
		  },
	
		  pushStackLiteral: function pushStackLiteral(item) {
		    this.push(new Literal(item));
		  },
	
		  pushSource: function pushSource(source) {
		    if (this.pendingContent) {
		      this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation));
		      this.pendingContent = undefined;
		    }
	
		    if (source) {
		      this.source.push(source);
		    }
		  },
	
		  replaceStack: function replaceStack(callback) {
		    var prefix = ['('],
		        stack = undefined,
		        createdStack = undefined,
		        usedLiteral = undefined;
	
		    /* istanbul ignore next */
		    if (!this.isInline()) {
		      throw new _exception2['default']('replaceStack on non-inline');
		    }
	
		    // We want to merge the inline statement into the replacement statement via ','
		    var top = this.popStack(true);
	
		    if (top instanceof Literal) {
		      // Literals do not need to be inlined
		      stack = [top.value];
		      prefix = ['(', stack];
		      usedLiteral = true;
		    } else {
		      // Get or create the current stack name for use by the inline
		      createdStack = true;
		      var _name = this.incrStack();
	
		      prefix = ['((', this.push(_name), ' = ', top, ')'];
		      stack = this.topStack();
		    }
	
		    var item = callback.call(this, stack);
	
		    if (!usedLiteral) {
		      this.popStack();
		    }
		    if (createdStack) {
		      this.stackSlot--;
		    }
		    this.push(prefix.concat(item, ')'));
		  },
	
		  incrStack: function incrStack() {
		    this.stackSlot++;
		    if (this.stackSlot > this.stackVars.length) {
		      this.stackVars.push('stack' + this.stackSlot);
		    }
		    return this.topStackName();
		  },
		  topStackName: function topStackName() {
		    return 'stack' + this.stackSlot;
		  },
		  flushInline: function flushInline() {
		    var inlineStack = this.inlineStack;
		    this.inlineStack = [];
		    for (var i = 0, len = inlineStack.length; i < len; i++) {
		      var entry = inlineStack[i];
		      /* istanbul ignore if */
		      if (entry instanceof Literal) {
		        this.compileStack.push(entry);
		      } else {
		        var stack = this.incrStack();
		        this.pushSource([stack, ' = ', entry, ';']);
		        this.compileStack.push(stack);
		      }
		    }
		  },
		  isInline: function isInline() {
		    return this.inlineStack.length;
		  },
	
		  popStack: function popStack(wrapped) {
		    var inline = this.isInline(),
		        item = (inline ? this.inlineStack : this.compileStack).pop();
	
		    if (!wrapped && item instanceof Literal) {
		      return item.value;
		    } else {
		      if (!inline) {
		        /* istanbul ignore next */
		        if (!this.stackSlot) {
		          throw new _exception2['default']('Invalid stack pop');
		        }
		        this.stackSlot--;
		      }
		      return item;
		    }
		  },
	
		  topStack: function topStack() {
		    var stack = this.isInline() ? this.inlineStack : this.compileStack,
		        item = stack[stack.length - 1];
	
		    /* istanbul ignore if */
		    if (item instanceof Literal) {
		      return item.value;
		    } else {
		      return item;
		    }
		  },
	
		  contextName: function contextName(context) {
		    if (this.useDepths && context) {
		      return 'depths[' + context + ']';
		    } else {
		      return 'depth' + context;
		    }
		  },
	
		  quotedString: function quotedString(str) {
		    return this.source.quotedString(str);
		  },
	
		  objectLiteral: function objectLiteral(obj) {
		    return this.source.objectLiteral(obj);
		  },
	
		  aliasable: function aliasable(name) {
		    var ret = this.aliases[name];
		    if (ret) {
		      ret.referenceCount++;
		      return ret;
		    }
	
		    ret = this.aliases[name] = this.source.wrap(name);
		    ret.aliasable = true;
		    ret.referenceCount = 1;
	
		    return ret;
		  },
	
		  setupHelper: function setupHelper(paramSize, name, blockHelper) {
		    var params = [],
		        paramsInit = this.setupHelperArgs(name, paramSize, params, blockHelper);
		    var foundHelper = this.nameLookup('helpers', name, 'helper'),
		        callContext = this.aliasable(this.contextName(0) + ' != null ? ' + this.contextName(0) + ' : {}');
	
		    return {
		      params: params,
		      paramsInit: paramsInit,
		      name: foundHelper,
		      callParams: [callContext].concat(params)
		    };
		  },
	
		  setupParams: function setupParams(helper, paramSize, params) {
		    var options = {},
		        objectArgs = !params,
		        param = undefined;
	
		    if (objectArgs) {
		      params = [];
		    }
	
		    options.name = this.quotedString(helper);
		    options.hash = this.popStack();
	
		    var inverse = this.popStack(),
		        program = this.popStack();
	
		    // Avoid setting fn and inverse if neither are set. This allows
		    // helpers to do a check for `if (options.fn)`
		    if (program || inverse) {
		      options.fn = program || 'container.noop';
		      options.inverse = inverse || 'container.noop';
		    }
	
		    // The parameters go on to the stack in order (making sure that they are evaluated in order)
		    // so we need to pop them off the stack in reverse order
		    var i = paramSize;
		    while (i--) {
		      param = this.popStack();
		      params[i] = param;
		    }
	
		    if (objectArgs) {
		      options.args = this.source.generateArray(params);
		    }
	
		    if (this.options.data) {
		      options.data = 'data';
		    }
		    if (this.useBlockParams) {
		      options.blockParams = 'blockParams';
		    }
		    return options;
		  },
	
		  setupHelperArgs: function setupHelperArgs(helper, paramSize, params, useRegister) {
		    var options = this.setupParams(helper, paramSize, params);
		    options = this.objectLiteral(options);
		    if (useRegister) {
		      this.useRegister('options');
		      params.push('options');
		      return ['options=', options];
		    } else if (params) {
		      params.push(options);
		      return '';
		    } else {
		      return options;
		    }
		  }
		};
	
		(function () {
		  var reservedWords = ('break else new var' + ' case finally return void' + ' catch for switch while' + ' continue function this with' + ' default if throw' + ' delete in try' + ' do instanceof typeof' + ' abstract enum int short' + ' boolean export interface static' + ' byte extends long super' + ' char final native synchronized' + ' class float package throws' + ' const goto private transient' + ' debugger implements protected volatile' + ' double import public let yield await' + ' null true false').split(' ');
	
		  var compilerWords = JavaScriptCompiler.RESERVED_WORDS = {};
	
		  for (var i = 0, l = reservedWords.length; i < l; i++) {
		    compilerWords[reservedWords[i]] = true;
		  }
		})();
	
		JavaScriptCompiler.isValidJavaScriptVariableName = function (name) {
		  return !JavaScriptCompiler.RESERVED_WORDS[name] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(name);
		};
	
		function strictLookup(requireTerminal, compiler, parts, type) {
		  var stack = compiler.popStack(),
		      i = 0,
		      len = parts.length;
		  if (requireTerminal) {
		    len--;
		  }
	
		  for (; i < len; i++) {
		    stack = compiler.nameLookup(stack, parts[i], type);
		  }
	
		  if (requireTerminal) {
		    return [compiler.aliasable('container.strict'), '(', stack, ', ', compiler.quotedString(parts[i]), ')'];
		  } else {
		    return stack;
		  }
		}
	
		exports['default'] = JavaScriptCompiler;
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,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
	
	
	/***/ },
	/* 27 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* global define */
		'use strict';
	
		exports.__esModule = true;
	
		var _utils = __webpack_require__(3);
	
		var SourceNode = undefined;
	
		try {
		  /* istanbul ignore next */
		  if (false) {
		    // We don't support this in AMD environments. For these environments, we asusme that
		    // they are running on the browser and thus have no need for the source-map library.
		    var SourceMap = require('source-map');
		    SourceNode = SourceMap.SourceNode;
		  }
		} catch (err) {}
		/* NOP */
	
		/* istanbul ignore if: tested but not covered in istanbul due to dist build  */
		if (!SourceNode) {
		  SourceNode = function (line, column, srcFile, chunks) {
		    this.src = '';
		    if (chunks) {
		      this.add(chunks);
		    }
		  };
		  /* istanbul ignore next */
		  SourceNode.prototype = {
		    add: function add(chunks) {
		      if (_utils.isArray(chunks)) {
		        chunks = chunks.join('');
		      }
		      this.src += chunks;
		    },
		    prepend: function prepend(chunks) {
		      if (_utils.isArray(chunks)) {
		        chunks = chunks.join('');
		      }
		      this.src = chunks + this.src;
		    },
		    toStringWithSourceMap: function toStringWithSourceMap() {
		      return { code: this.toString() };
		    },
		    toString: function toString() {
		      return this.src;
		    }
		  };
		}
	
		function castChunk(chunk, codeGen, loc) {
		  if (_utils.isArray(chunk)) {
		    var ret = [];
	
		    for (var i = 0, len = chunk.length; i < len; i++) {
		      ret.push(codeGen.wrap(chunk[i], loc));
		    }
		    return ret;
		  } else if (typeof chunk === 'boolean' || typeof chunk === 'number') {
		    // Handle primitives that the SourceNode will throw up on
		    return chunk + '';
		  }
		  return chunk;
		}
	
		function CodeGen(srcFile) {
		  this.srcFile = srcFile;
		  this.source = [];
		}
	
		CodeGen.prototype = {
		  isEmpty: function isEmpty() {
		    return !this.source.length;
		  },
		  prepend: function prepend(source, loc) {
		    this.source.unshift(this.wrap(source, loc));
		  },
		  push: function push(source, loc) {
		    this.source.push(this.wrap(source, loc));
		  },
	
		  merge: function merge() {
		    var source = this.empty();
		    this.each(function (line) {
		      source.add(['  ', line, '\n']);
		    });
		    return source;
		  },
	
		  each: function each(iter) {
		    for (var i = 0, len = this.source.length; i < len; i++) {
		      iter(this.source[i]);
		    }
		  },
	
		  empty: function empty() {
		    var loc = this.currentLocation || { start: {} };
		    return new SourceNode(loc.start.line, loc.start.column, this.srcFile);
		  },
		  wrap: function wrap(chunk) {
		    var loc = arguments.length <= 1 || arguments[1] === undefined ? this.currentLocation || { start: {} } : arguments[1];
	
		    if (chunk instanceof SourceNode) {
		      return chunk;
		    }
	
		    chunk = castChunk(chunk, this, loc);
	
		    return new SourceNode(loc.start.line, loc.start.column, this.srcFile, chunk);
		  },
	
		  functionCall: function functionCall(fn, type, params) {
		    params = this.generateList(params);
		    return this.wrap([fn, type ? '.' + type + '(' : '(', params, ')']);
		  },
	
		  quotedString: function quotedString(str) {
		    return '"' + (str + '').replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\u2028/g, '\\u2028') // Per Ecma-262 7.3 + 7.8.4
		    .replace(/\u2029/g, '\\u2029') + '"';
		  },
	
		  objectLiteral: function objectLiteral(obj) {
		    var pairs = [];
	
		    for (var key in obj) {
		      if (obj.hasOwnProperty(key)) {
		        var value = castChunk(obj[key], this);
		        if (value !== 'undefined') {
		          pairs.push([this.quotedString(key), ':', value]);
		        }
		      }
		    }
	
		    var ret = this.generateList(pairs);
		    ret.prepend('{');
		    ret.add('}');
		    return ret;
		  },
	
		  generateList: function generateList(entries) {
		    var ret = this.empty();
	
		    for (var i = 0, len = entries.length; i < len; i++) {
		      if (i) {
		        ret.add(',');
		      }
	
		      ret.add(castChunk(entries[i], this));
		    }
	
		    return ret;
		  },
	
		  generateArray: function generateArray(entries) {
		    var ret = this.generateList(entries);
		    ret.prepend('[');
		    ret.add(']');
	
		    return ret;
		  }
		};
	
		exports['default'] = CodeGen;
		module.exports = exports['default'];
		//# sourceMappingURL=data:application/json;base64,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
	
	
	/***/ }
	/******/ ])
	});
	;
	// @license-end


/***/ },

/***/ "./node_modules/message-box/node_modules/deep-extend/lib/deep-extend.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * @description Recursive object extending
	 * @author Viacheslav Lotsmanov <lotsmanov89@gmail.com>
	 * @license MIT
	 *
	 * The MIT License (MIT)
	 *
	 * Copyright (c) 2013-2015 Viacheslav Lotsmanov
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of
	 * this software and associated documentation files (the "Software"), to deal in
	 * the Software without restriction, including without limitation the rights to
	 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
	 * the Software, and to permit persons to whom the Software is furnished to do so,
	 * subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
	 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
	 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
	 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	'use strict';
	
	function isSpecificValue(val) {
		return (
			val instanceof Buffer
			|| val instanceof Date
			|| val instanceof RegExp
		) ? true : false;
	}
	
	function cloneSpecificValue(val) {
		if (val instanceof Buffer) {
			var x = new Buffer(val.length);
			val.copy(x);
			return x;
		} else if (val instanceof Date) {
			return new Date(val.getTime());
		} else if (val instanceof RegExp) {
			return new RegExp(val);
		} else {
			throw new Error('Unexpected situation');
		}
	}
	
	/**
	 * Recursive cloning array.
	 */
	function deepCloneArray(arr) {
		var clone = [];
		arr.forEach(function (item, index) {
			if (typeof item === 'object' && item !== null) {
				if (Array.isArray(item)) {
					clone[index] = deepCloneArray(item);
				} else if (isSpecificValue(item)) {
					clone[index] = cloneSpecificValue(item);
				} else {
					clone[index] = deepExtend({}, item);
				}
			} else {
				clone[index] = item;
			}
		});
		return clone;
	}
	
	/**
	 * Extening object that entered in first argument.
	 *
	 * Returns extended object or false if have no target object or incorrect type.
	 *
	 * If you wish to clone source object (without modify it), just use empty new
	 * object as first argument, like this:
	 *   deepExtend({}, yourObj_1, [yourObj_N]);
	 */
	var deepExtend = module.exports = function (/*obj_1, [obj_2], [obj_N]*/) {
		if (arguments.length < 1 || typeof arguments[0] !== 'object') {
			return false;
		}
	
		if (arguments.length < 2) {
			return arguments[0];
		}
	
		var target = arguments[0];
	
		// convert arguments to array and cut off target object
		var args = Array.prototype.slice.call(arguments, 1);
	
		var val, src, clone;
	
		args.forEach(function (obj) {
			// skip argument if isn't an object, is null, or is an array
			if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
				return;
			}
	
			Object.keys(obj).forEach(function (key) {
				src = target[key]; // source value
				val = obj[key]; // new value
	
				// recursion prevention
				if (val === target) {
					return;
	
				/**
				 * if new value isn't object then just overwrite by new value
				 * instead of extending.
				 */
				} else if (typeof val !== 'object' || val === null) {
					target[key] = val;
					return;
	
				// just clone arrays (and recursive clone objects inside)
				} else if (Array.isArray(val)) {
					target[key] = deepCloneArray(val);
					return;
	
				// custom cloning and overwrite for specific objects
				} else if (isSpecificValue(val)) {
					target[key] = cloneSpecificValue(val);
					return;
	
				// overwrite by new value if source isn't object or array
				} else if (typeof src !== 'object' || src === null || Array.isArray(src)) {
					target[key] = deepExtend({}, val);
					return;
	
				// source value and new value is objects both, extending...
				} else {
					target[key] = deepExtend(src, val);
					return;
				}
			});
		});
	
		return target;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ },

/***/ "./node_modules/simpl-schema/dist/humanize.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*
	  Code source:
	    https://github.com/jxson/string-humanize
	    https://github.com/jxson/string-capitalize
	 */
	
	function capitalize(text) {
	  text = text || '';
	  text = text.trim();
	
	  if (text[0]) {
	    text = text[0].toUpperCase() + text.substr(1).toLowerCase();
	  }
	
	  // Do "ID" instead of "id" or "Id"
	  text = text.replace(/\bid\b/g, 'ID');
	  text = text.replace(/\bId\b/g, 'ID');
	
	  return text;
	}
	
	function underscore(text) {
	  text = text || '';
	  text = text.toString(); // might be a number
	  text = text.trim();
	  text = text.replace(/([a-z\d])([A-Z]+)/g, '$1_$2');
	  text = text.replace(/[-\s]+/g, '_').toLowerCase();
	
	  return text;
	}
	
	function extname(text) {
	  var index = text.lastIndexOf('.');
	  var ext = text.substring(index, text.length);
	
	  return index === -1 ? '' : ext;
	}
	
	function humanize(text) {
	  text = text || '';
	  text = text.toString(); // might be a number
	  text = text.trim();
	  text = text.replace(extname(text), '');
	  text = underscore(text);
	  text = text.replace(/[\W_]+/g, ' ');
	
	  return capitalize(text);
	}
	
	exports.default = humanize;

/***/ },

/***/ "./node_modules/simpl-schema/dist/ValidationContext.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mongoObject = __webpack_require__("./node_modules/mongo-object/dist/mongo-object.js");
	
	var _mongoObject2 = _interopRequireDefault(_mongoObject);
	
	var _doValidation = __webpack_require__("./node_modules/simpl-schema/dist/doValidation.js");
	
	var _doValidation2 = _interopRequireDefault(_doValidation);
	
	var _underscore = __webpack_require__("./build/meteor/bundle/programs/web.browser/packages/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ValidationContext = function () {
	  function ValidationContext(ss) {
	    _classCallCheck(this, ValidationContext);
	
	    this._simpleSchema = ss;
	    this._schema = ss.schema();
	    this._schemaKeys = Object.keys(this._schema);
	    this._validationErrors = [];
	
	    // Set up validation dependencies
	    this._deps = {};
	    var tracker = ss._constructorOptions.tracker;
	
	    if (tracker) {
	      this._depsAny = new tracker.Dependency();
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this._schemaKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var key = _step.value;
	
	          this._deps[key] = new tracker.Dependency();
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }
	
	  _createClass(ValidationContext, [{
	    key: '_markKeyChanged',
	    value: function _markKeyChanged(key) {
	      var genericKey = _mongoObject2.default.makeKeyGeneric(key);
	      if (this._deps.hasOwnProperty(genericKey)) this._deps[genericKey].changed();
	    }
	  }, {
	    key: '_markKeysChanged',
	    value: function _markKeysChanged(keys) {
	      if (!keys || !Array.isArray(keys) || !keys.length) return;
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var key = _step2.value;
	
	          this._markKeyChanged(key);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      this._depsAny && this._depsAny.changed();
	    }
	  }, {
	    key: 'setValidationErrors',
	    value: function setValidationErrors(errors) {
	      var previousValidationErrors = _underscore2.default.pluck(this._validationErrors, 'name');
	      var newValidationErrors = _underscore2.default.pluck(errors, 'name');
	
	      this._validationErrors = errors;
	
	      // Mark all previous plus all new as changed
	      var changedKeys = previousValidationErrors.concat(newValidationErrors);
	      this._markKeysChanged(changedKeys);
	    }
	  }, {
	    key: 'addValidationErrors',
	    value: function addValidationErrors(errors) {
	      var newValidationErrors = _underscore2.default.pluck(errors, 'name');
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = errors[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var error = _step3.value;
	
	          this._validationErrors.push(error);
	        }
	
	        // Mark all new as changed
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      this._markKeysChanged(newValidationErrors);
	    }
	
	    // Reset the validationErrors array
	
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.setValidationErrors([]);
	    }
	  }, {
	    key: 'getErrorForKey',
	    value: function getErrorForKey(key) {
	      var genericKey = arguments.length <= 1 || arguments[1] === undefined ? _mongoObject2.default.makeKeyGeneric(key) : arguments[1];
	
	      var errors = this._validationErrors;
	      return _underscore2.default.findWhere(errors, { name: key }) || _underscore2.default.findWhere(errors, { name: genericKey });
	    }
	  }, {
	    key: '_keyIsInvalid',
	    value: function _keyIsInvalid(key, genericKey) {
	      return !!this.getErrorForKey(key, genericKey);
	    }
	
	    // Like the internal one, but with deps
	
	  }, {
	    key: 'keyIsInvalid',
	    value: function keyIsInvalid(key) {
	      var genericKey = arguments.length <= 1 || arguments[1] === undefined ? _mongoObject2.default.makeKeyGeneric(key) : arguments[1];
	
	      if (this._deps.hasOwnProperty(genericKey)) this._deps[genericKey].depend();
	
	      return this._keyIsInvalid(key, genericKey);
	    }
	  }, {
	    key: 'keyErrorMessage',
	    value: function keyErrorMessage(key) {
	      var genericKey = arguments.length <= 1 || arguments[1] === undefined ? _mongoObject2.default.makeKeyGeneric(key) : arguments[1];
	
	      if (this._deps.hasOwnProperty(genericKey)) this._deps[genericKey].depend();
	
	      var errorObj = this.getErrorForKey(key, genericKey);
	      if (!errorObj) return '';
	
	      return this._simpleSchema.messageForError(errorObj);
	    }
	
	    /**
	     * Validates the object against the simple schema and sets a reactive array of error objects
	     */
	
	  }, {
	    key: 'validate',
	    value: function validate(obj) {
	      var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      var _ref$extendedCustomCo = _ref.extendedCustomContext;
	      var extendedCustomContext = _ref$extendedCustomCo === undefined ? {} : _ref$extendedCustomCo;
	      var _ref$ignore = _ref.ignore;
	      var ignoreTypes = _ref$ignore === undefined ? [] : _ref$ignore;
	      var keysToValidate = _ref.keys;
	      var _ref$modifier = _ref.modifier;
	      var isModifier = _ref$modifier === undefined ? false : _ref$modifier;
	      var mongoObject = _ref.mongoObject;
	      var _ref$upsert = _ref.upsert;
	      var isUpsert = _ref$upsert === undefined ? false : _ref$upsert;
	
	      var validationErrors = (0, _doValidation2.default)({
	        extendedCustomContext: extendedCustomContext,
	        ignoreTypes: ignoreTypes,
	        isModifier: isModifier,
	        isUpsert: isUpsert,
	        keysToValidate: keysToValidate,
	        mongoObject: mongoObject,
	        obj: obj,
	        schema: this._simpleSchema,
	        validationContext: this
	      });
	
	      if (keysToValidate) {
	        // We have only revalidated the listed keys, so if there
	        // are any other existing errors that are NOT in the keys list,
	        // we should keep these errors.
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          var _loop = function _loop() {
	            var error = _step4.value;
	
	            var wasValidated = _underscore2.default.any(keysToValidate, function (key) {
	              return key === error.name || error.name.startsWith(key + '.');
	            });
	            if (!wasValidated) validationErrors.push(error);
	          };
	
	          for (var _iterator4 = this._validationErrors[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            _loop();
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	      }
	
	      this.setValidationErrors(validationErrors);
	
	      // Return true if it was valid; otherwise, return false
	      return !validationErrors.length;
	    }
	  }, {
	    key: 'isValid',
	    value: function isValid() {
	      this._depsAny && this._depsAny.depend();
	      return this._validationErrors.length === 0;
	    }
	  }, {
	    key: 'validationErrors',
	    value: function validationErrors() {
	      this._depsAny && this._depsAny.depend();
	      return this._validationErrors;
	    }
	  }, {
	    key: 'clean',
	    value: function clean() {
	      var _simpleSchema;
	
	      return (_simpleSchema = this._simpleSchema).clean.apply(_simpleSchema, arguments);
	    }
	  }]);
	
	  return ValidationContext;
	}();
	
	exports.default = ValidationContext;

/***/ },

/***/ "./node_modules/simpl-schema/dist/doValidation.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mongoObject = __webpack_require__("./node_modules/mongo-object/dist/mongo-object.js");
	
	var _mongoObject2 = _interopRequireDefault(_mongoObject);
	
	var _underscore = __webpack_require__("./build/meteor/bundle/programs/web.browser/packages/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _SimpleSchema = __webpack_require__("./node_modules/simpl-schema/dist/SimpleSchema.js");
	
	var _utility = __webpack_require__("./node_modules/simpl-schema/dist/utility.js");
	
	var _typeValidator = __webpack_require__("./node_modules/simpl-schema/dist/validation/typeValidator.js");
	
	var _typeValidator2 = _interopRequireDefault(_typeValidator);
	
	var _requiredValidator = __webpack_require__("./node_modules/simpl-schema/dist/validation/requiredValidator.js");
	
	var _requiredValidator2 = _interopRequireDefault(_requiredValidator);
	
	var _allowedValuesValidator = __webpack_require__("./node_modules/simpl-schema/dist/validation/allowedValuesValidator.js");
	
	var _allowedValuesValidator2 = _interopRequireDefault(_allowedValuesValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function shouldCheck(key) {
	  if (key === '$pushAll') throw new Error('$pushAll is not supported; use $push + $each');
	  return ['$pull', '$pullAll', '$pop', '$slice'].indexOf(key) === -1;
	}
	
	function doValidation(_ref) {
	  var extendedCustomContext = _ref.extendedCustomContext;
	  var ignoreTypes = _ref.ignoreTypes;
	  var isModifier = _ref.isModifier;
	  var isUpsert = _ref.isUpsert;
	  var keysToValidate = _ref.keysToValidate;
	  var mongoObject = _ref.mongoObject;
	  var obj = _ref.obj;
	  var schema = _ref.schema;
	  var validationContext = _ref.validationContext;
	
	  // First do some basic checks of the object, and throw errors if necessary
	  if (!_underscore2.default.isObject(obj)) {
	    throw new Error('The first argument of validate() must be an object');
	  }
	
	  if (!isModifier && (0, _utility.looksLikeModifier)(obj)) {
	    throw new Error('When the validation object contains mongo operators, you must set the modifier option to true');
	  }
	
	  var validationErrors = [];
	
	  // Validation function called for each affected key
	  function validate(val, affectedKey, affectedKeyGeneric, def, op, isInArrayItemObject, isInSubObject) {
	    // Get the schema for this key, marking invalid if there isn't one.
	    if (!def) {
	      // We don't need KEY_NOT_IN_SCHEMA error for $unset and we also don't need to continue
	      if (op === '$unset') return;
	
	      validationErrors.push({
	        name: affectedKey,
	        type: _SimpleSchema.SimpleSchema.ErrorTypes.KEY_NOT_IN_SCHEMA,
	        value: val
	      });
	      return;
	    }
	
	    // For $rename, make sure that the new name is allowed by the schema
	    if (op === '$rename' && !schema.allowsKey(val)) {
	      validationErrors.push({
	        name: val,
	        type: _SimpleSchema.SimpleSchema.ErrorTypes.KEY_NOT_IN_SCHEMA,
	        value: null
	      });
	      return;
	    }
	
	    // Prepare the context object for the validator functions
	    var fieldParentName = (0, _utility.getParentOfKey)(affectedKey, true);
	
	    function getFieldInfo(key) {
	      // Create mongoObject if necessary, cache for speed
	      if (!mongoObject) mongoObject = new _mongoObject2.default(obj, schema.blackboxKeys());
	
	      var keyInfo = mongoObject.getInfoForKey(key) || {};
	      return {
	        isSet: keyInfo.value !== undefined,
	        value: keyInfo.value,
	        operator: keyInfo.operator || null
	      };
	    }
	
	    var fieldValidationErrors = [];
	
	    var validatorContext = _extends({
	      addValidationErrors: function addValidationErrors(errors) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var error = _step.value;
	
	            fieldValidationErrors.push(error);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      },
	      field: function field(fName) {
	        return getFieldInfo(fName);
	      },
	
	      genericKey: affectedKeyGeneric,
	      isInArrayItemObject: isInArrayItemObject,
	      isInSubObject: isInSubObject,
	      isModifier: isModifier,
	      isSet: val !== undefined,
	      key: affectedKey,
	      obj: obj,
	      operator: op,
	      siblingField: function siblingField(fName) {
	        return getFieldInfo(fieldParentName + fName);
	      },
	
	      validationContext: validationContext,
	      value: val,
	      // Value checks are not necessary for null or undefined values,
	      // except for null array items, or for $unset or $rename values
	      valueShouldBeChecked: op !== '$unset' && op !== '$rename' && (val !== undefined && val !== null || affectedKeyGeneric.slice(-2) === '.$' && val === null)
	    }, extendedCustomContext || {});
	
	    var builtInValidators = [_requiredValidator2.default, _typeValidator2.default, _allowedValuesValidator2.default];
	    var validators = builtInValidators.concat(schema._validators).concat(_SimpleSchema.SimpleSchema._validators);
	
	    // Loop through each of the definitions in the SimpleSchemaGroup.
	    // If any return true, we're valid.
	    var fieldIsValid = _underscore2.default.some(def.type, function (typeDef) {
	      var finalValidatorContext = _extends({}, validatorContext, {
	
	        // Take outer definition props like "optional" and "label"
	        // and add them to inner props like "type" and "min"
	        definition: _extends({}, _underscore2.default.omit(def, 'type'), typeDef)
	      });
	
	      // Add custom field validators to the list after the built-in
	      // validators but before the schema and global validators.
	      var fieldValidators = validators.slice(0);
	      if (typeof typeDef.custom === 'function') {
	        fieldValidators.splice(builtInValidators.length, 0, typeDef.custom);
	      }
	
	      // We use _.every just so that we don't continue running more validator
	      // functions after the first one returns false or an error string.
	      return _underscore2.default.every(fieldValidators, function (validator) {
	        var result = validator.call(finalValidatorContext);
	
	        // If the validator returns a string, assume it is the
	        // error type.
	        if (typeof result === 'string') {
	          fieldValidationErrors.push({
	            name: affectedKey,
	            type: result,
	            value: val
	          });
	          return false;
	        }
	
	        // If the validator returns an object, assume it is an
	        // error object.
	        if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object' && result !== null) {
	          fieldValidationErrors.push(_extends({
	            name: affectedKey,
	            value: val
	          }, result));
	          return false;
	        }
	
	        // If the validator returns false, assume they already
	        // called this.addValidationErrors within the function
	        if (result === false) return false;
	
	        // Any other return value we assume means it was valid
	        return true;
	      });
	    });
	
	    if (!fieldIsValid) {
	      validationErrors = validationErrors.concat(fieldValidationErrors);
	    }
	  }
	
	  // The recursive function
	  function checkObj(_ref2) {
	    var val = _ref2.val;
	    var affectedKey = _ref2.affectedKey;
	    var operator = _ref2.operator;
	    var _ref2$isInArrayItemOb = _ref2.isInArrayItemObject;
	    var isInArrayItemObject = _ref2$isInArrayItemOb === undefined ? false : _ref2$isInArrayItemOb;
	    var _ref2$isInSubObject = _ref2.isInSubObject;
	    var isInSubObject = _ref2$isInSubObject === undefined ? false : _ref2$isInSubObject;
	
	    var affectedKeyGeneric = void 0;
	    var def = void 0;
	
	    if (affectedKey) {
	      // When we hit a blackbox key, we don't progress any further
	      if (schema.keyIsInBlackBox(affectedKey)) return;
	
	      // Make a generic version of the affected key, and use that
	      // to get the schema for this key.
	      affectedKeyGeneric = _mongoObject2.default.makeKeyGeneric(affectedKey);
	      def = schema.getDefinition(affectedKey);
	
	      var shouldValidateKey = !keysToValidate || _underscore2.default.any(keysToValidate, function (keyToValidate) {
	        return keyToValidate === affectedKey || keyToValidate === affectedKeyGeneric || affectedKey.startsWith(keyToValidate + '.') || affectedKeyGeneric.startsWith(keyToValidate + '.');
	      });
	
	      // Perform validation for this key
	      if (shouldValidateKey) {
	        validate(val, affectedKey, affectedKeyGeneric, def, operator, isInArrayItemObject, isInSubObject);
	      }
	    }
	
	    // If affectedKeyGeneric is undefined due to this being the first run of this
	    // function, objectKeys will return the top-level keys.
	    var childKeys = schema.objectKeys(affectedKeyGeneric);
	
	    // Temporarily convert missing objects to empty objects
	    // so that the looping code will be called and required
	    // descendent keys can be validated.
	    if ((val === undefined || val === null) && (!def || !def.optional && childKeys && childKeys.length > 0)) {
	      val = {};
	    }
	
	    // Loop through arrays
	    if (Array.isArray(val)) {
	      _underscore2.default.each(val, function (v, i) {
	        checkObj({
	          val: v,
	          affectedKey: affectedKey + '.' + i,
	          operator: operator
	        });
	      });
	    } else if ((0, _utility.isObjectWeShouldTraverse)(val) && (!def || !def.blackbox)) {
	      // Loop through object keys
	
	      // Get list of present keys
	      var presentKeys = Object.keys(val);
	
	      // Check all present keys plus all keys defined by the schema.
	      // This allows us to detect extra keys not allowed by the schema plus
	      // any missing required keys, and to run any custom functions for other keys.
	      var keysToCheck = _underscore2.default.union(presentKeys, childKeys);
	
	      // If this object is within an array, make sure we check for
	      // required as if it's not a modifier
	      isInArrayItemObject = affectedKeyGeneric && affectedKeyGeneric.slice(-2) === '.$';
	
	      // Check all keys in the merged list
	      _underscore2.default.each(keysToCheck, function (key) {
	        checkObj({
	          val: val[key],
	          affectedKey: (0, _utility.appendAffectedKey)(affectedKey, key),
	          operator: operator,
	          isInArrayItemObject: isInArrayItemObject,
	          isInSubObject: true
	        });
	      });
	    }
	  }
	
	  function checkModifier(mod) {
	    // If this is an upsert, add all the $setOnInsert keys to $set;
	    // since we don't know whether it will be an insert or update, we'll
	    // validate upserts as if they will be an insert.
	    if ('$setOnInsert' in mod) {
	      if (isUpsert) {
	        mod.$set = mod.$set || {};
	        mod.$set = Object.assign(mod.$set, mod.$setOnInsert);
	      }
	      delete mod.$setOnInsert;
	    }
	
	    // Loop through operators
	    _underscore2.default.each(mod, function (opObj, op) {
	      // If non-operators are mixed in, throw error
	      if (op.slice(0, 1) !== '$') {
	        throw new Error('Expected \'' + op + '\' to be a modifier operator like \'$set\'');
	      }
	      if (shouldCheck(op)) {
	        // For an upsert, missing props would not be set if an insert is performed,
	        // so we check them all with undefined value to force any 'required' checks to fail
	        if (isUpsert && op === '$set') {
	          (function () {
	            var presentKeys = Object.keys(opObj);
	            schema.objectKeys().forEach(function (schemaKey) {
	              if (!_underscore2.default.contains(presentKeys, schemaKey)) {
	                checkObj({
	                  val: undefined,
	                  affectedKey: schemaKey,
	                  operator: op
	                });
	              }
	            });
	          })();
	        }
	        _underscore2.default.each(opObj, function (v, k) {
	          if (op === '$push' || op === '$addToSet') {
	            if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && '$each' in v) {
	              v = v.$each;
	            } else {
	              k = k + '.0';
	            }
	          }
	          checkObj({
	            val: v,
	            affectedKey: k,
	            operator: op
	          });
	        });
	      }
	    });
	  }
	
	  // Kick off the validation
	  if (isModifier) {
	    checkModifier(obj);
	  } else {
	    checkObj({ val: obj });
	  }
	
	  // Custom whole-doc validators
	  var docValidators = schema._docValidators.concat(_SimpleSchema.SimpleSchema._docValidators);
	  docValidators.forEach(function (func) {
	    var errors = func(obj);
	    if (!Array.isArray(errors)) throw new Error('Custom doc validator must return an array of error objects');
	    if (errors.length) validationErrors = validationErrors.concat(errors);
	  });
	
	  var addedFieldNames = [];
	  validationErrors = _underscore2.default.filter(validationErrors, function (errObj) {
	    // Remove error types the user doesn't care about
	    if (_underscore2.default.contains(ignoreTypes, errObj.type)) return false;
	    // Make sure there is only one error per fieldName
	    if (_underscore2.default.contains(addedFieldNames, errObj.name)) return false;
	
	    addedFieldNames.push(errObj.name);
	    return true;
	  });
	  return validationErrors;
	}
	
	exports.default = doValidation;

/***/ },

/***/ "./node_modules/simpl-schema/dist/utility.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function appendAffectedKey(affectedKey, key) {
	  if (key === '$each') return affectedKey;
	  return affectedKey ? affectedKey + '.' + key : key;
	}
	
	function dateToDateString(date) {
	  var m = date.getUTCMonth() + 1;
	  if (m < 10) m = '0' + m;
	  var d = date.getUTCDate();
	  if (d < 10) d = '0' + d;
	  return date.getUTCFullYear() + '-' + m + '-' + d;
	}
	
	function isObjectWeShouldTraverse(val) {
	  if (val !== Object(val)) return false;
	
	  // There are some object types that we know we shouldn't traverse because
	  // they will often result in overflows and it makes no sense to validate them.
	  if (val instanceof Date) return false;
	  if (val instanceof Int8Array) return false;
	  if (val instanceof Uint8Array) return false;
	  if (val instanceof Uint8ClampedArray) return false;
	  if (val instanceof Int16Array) return false;
	  if (val instanceof Uint16Array) return false;
	  if (val instanceof Int32Array) return false;
	  if (val instanceof Uint32Array) return false;
	  if (val instanceof Float32Array) return false;
	  if (val instanceof Float64Array) return false;
	
	  return true;
	}
	
	function looksLikeModifier(obj) {
	  return !!Object.keys(obj || {}).find(function (key) {
	    return key.substring(0, 1) === '$';
	  });
	}
	
	/**
	 * Run loopFunc for each ancestor key in a dot-delimited key. For example,
	 * if key is "a.b.c", loopFunc will be called first with ('a.b', 'c') and then with ('a', 'b.c')
	 */
	function forEachKeyAncestor(key, loopFunc) {
	  var lastDot = void 0;
	
	  // Iterate the dot-syntax hierarchy
	  var ancestor = key;
	  do {
	    lastDot = ancestor.lastIndexOf('.');
	    if (lastDot !== -1) {
	      ancestor = ancestor.slice(0, lastDot);
	      var remainder = key.slice(ancestor.length + 1);
	      loopFunc(ancestor, remainder); // Remove last path component
	    }
	  } while (lastDot !== -1);
	}
	
	/**
	 * Returns the parent of a key. For example, returns 'a.b' when passed 'a.b.c'.
	 * If no parent, returns an empty string. If withEndDot is true, the return
	 * value will have a dot appended when it isn't an empty string.
	 */
	function getParentOfKey(key, withEndDot) {
	  var lastDot = key.lastIndexOf('.');
	  return lastDot === -1 ? '' : key.slice(0, lastDot + Number(!!withEndDot));
	}
	
	exports.appendAffectedKey = appendAffectedKey;
	exports.dateToDateString = dateToDateString;
	exports.isObjectWeShouldTraverse = isObjectWeShouldTraverse;
	exports.looksLikeModifier = looksLikeModifier;
	exports.forEachKeyAncestor = forEachKeyAncestor;
	exports.getParentOfKey = getParentOfKey;

/***/ },

/***/ "./node_modules/simpl-schema/dist/validation/typeValidator.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SimpleSchema = __webpack_require__("./node_modules/simpl-schema/dist/SimpleSchema.js");
	
	var _doDateChecks = __webpack_require__("./node_modules/simpl-schema/dist/validation/doDateChecks.js");
	
	var _doDateChecks2 = _interopRequireDefault(_doDateChecks);
	
	var _doNumberChecks = __webpack_require__("./node_modules/simpl-schema/dist/validation/doNumberChecks.js");
	
	var _doNumberChecks2 = _interopRequireDefault(_doNumberChecks);
	
	var _doStringChecks = __webpack_require__("./node_modules/simpl-schema/dist/validation/doStringChecks.js");
	
	var _doStringChecks2 = _interopRequireDefault(_doStringChecks);
	
	var _doArrayChecks = __webpack_require__("./node_modules/simpl-schema/dist/validation/doArrayChecks.js");
	
	var _doArrayChecks2 = _interopRequireDefault(_doArrayChecks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function typeValidator() {
	  if (!this.valueShouldBeChecked) return;
	
	  var def = this.definition;
	  var expectedType = def.type;
	  var keyValue = this.value;
	  var op = this.operator;
	
	  if (expectedType === String) return (0, _doStringChecks2.default)(def, keyValue);
	  if (expectedType === Number) return (0, _doNumberChecks2.default)(def, keyValue, op, false);
	  if (expectedType === _SimpleSchema.SimpleSchema.Integer) return (0, _doNumberChecks2.default)(def, keyValue, op, true);
	
	  if (expectedType === Boolean) {
	    // Is it a boolean?
	    if (typeof keyValue === 'boolean') return;
	    return { type: _SimpleSchema.SimpleSchema.ErrorTypes.EXPECTED_TYPE, dataType: 'Boolean' };
	  }
	
	  if (expectedType === Object || expectedType instanceof _SimpleSchema.SimpleSchema) {
	    // Is it an object?
	    if (keyValue === Object(keyValue) && !(keyValue instanceof Date)) return;
	    return { type: _SimpleSchema.SimpleSchema.ErrorTypes.EXPECTED_TYPE, dataType: 'Object' };
	  }
	
	  if (expectedType === Array) return (0, _doArrayChecks2.default)(def, keyValue);
	
	  if (expectedType instanceof Function) {
	    // Generic constructor checks
	    if (!(keyValue instanceof expectedType)) return { type: _SimpleSchema.SimpleSchema.ErrorTypes.EXPECTED_TYPE, dataType: expectedType.name };
	
	    // Date checks
	    if (expectedType === Date) return (0, _doDateChecks2.default)(def, keyValue);
	  }
	}
	
	exports.default = typeValidator;

/***/ },

/***/ "./node_modules/simpl-schema/dist/validation/doDateChecks.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SimpleSchema = __webpack_require__("./node_modules/simpl-schema/dist/SimpleSchema.js");
	
	var _utility = __webpack_require__("./node_modules/simpl-schema/dist/utility.js");
	
	function doDateChecks(def, keyValue) {
	  // Is it an invalid date?
	  if (isNaN(keyValue.getTime())) return { type: _SimpleSchema.SimpleSchema.ErrorTypes.BAD_DATE };
	
	  // Is it earlier than the minimum date?
	  if (def.min && typeof def.min.getTime === 'function' && def.min.getTime() > keyValue.getTime()) {
	    return { type: _SimpleSchema.SimpleSchema.ErrorTypes.MIN_DATE, min: (0, _utility.dateToDateString)(def.min) };
	  }
	
	  // Is it later than the maximum date?
	  if (def.max && typeof def.max.getTime === 'function' && def.max.getTime() < keyValue.getTime()) {
	    return { type: _SimpleSchema.SimpleSchema.ErrorTypes.MAX_DATE, max: (0, _utility.dateToDateString)(def.max) };
	  }
	}
	
	exports.default = doDateChecks;

/***/ },

/***/ "./node_modules/simpl-schema/dist/validation/doNumberChecks.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SimpleSchema = __webpack_require__("./node_modules/simpl-schema/dist/SimpleSchema.js");
	
	function doNumberChecks(def, keyValue, op, expectsInteger) {
	  // Is it a valid number?
	  if (typeof keyValue !== 'number' || isNaN(keyValue)) {
	    return { type: _SimpleSchema.SimpleSchema.ErrorTypes.EXPECTED_TYPE, dataType: expectsInteger ? 'Integer' : 'Number' };
	  }
	
	  // Assuming we are not incrementing, is the value less than the maximum value?
	  if (op !== '$inc' && def.max !== null && (!!def.exclusiveMax ? def.max <= keyValue : def.max < keyValue)) {
	    return { type: !!def.exclusiveMax ? _SimpleSchema.SimpleSchema.ErrorTypes.MAX_NUMBER_EXCLUSIVE : _SimpleSchema.SimpleSchema.ErrorTypes.MAX_NUMBER, max: def.max };
	  }
	
	  // Assuming we are not incrementing, is the value more than the minimum value?
	  if (op !== '$inc' && def.min !== null && (!!def.exclusiveMin ? def.min >= keyValue : def.min > keyValue)) {
	    return { type: !!def.exclusiveMin ? _SimpleSchema.SimpleSchema.ErrorTypes.MIN_NUMBER_EXCLUSIVE : _SimpleSchema.SimpleSchema.ErrorTypes.MIN_NUMBER, min: def.min };
	  }
	
	  // Is it an integer if we expect an integer?
	  if (expectsInteger && !Number.isInteger(keyValue)) {
	    return { type: _SimpleSchema.SimpleSchema.ErrorTypes.MUST_BE_INTEGER };
	  }
	}
	
	exports.default = doNumberChecks;

/***/ },

/***/ "./node_modules/simpl-schema/dist/validation/doStringChecks.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SimpleSchema = __webpack_require__("./node_modules/simpl-schema/dist/SimpleSchema.js");
	
	var _underscore = __webpack_require__("./build/meteor/bundle/programs/web.browser/packages/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function doStringChecks(def, keyValue) {
	  // Is it a String?
	  if (typeof keyValue !== 'string') {
	    return { type: _SimpleSchema.SimpleSchema.ErrorTypes.EXPECTED_TYPE, dataType: 'String' };
	  }
	
	  // Is the string too long?
	  if (def.max !== null && def.max < keyValue.length) {
	    return { type: _SimpleSchema.SimpleSchema.ErrorTypes.MAX_STRING, max: def.max };
	  }
	
	  // Is the string too short?
	  if (def.min !== null && def.min > keyValue.length) {
	    return { type: _SimpleSchema.SimpleSchema.ErrorTypes.MIN_STRING, min: def.min };
	  }
	
	  // Does the string match the regular expression?
	  if (def.regEx instanceof RegExp && !def.regEx.test(keyValue)) {
	    return { type: _SimpleSchema.SimpleSchema.ErrorTypes.FAILED_REGULAR_EXPRESSION, regExp: def.regEx.toString() };
	  }
	
	  // If regEx is an array of regular expressions, does the string match all of them?
	  if (Array.isArray(def.regEx)) {
	    var regExError = void 0;
	    _underscore2.default.every(def.regEx, function (re) {
	      if (!re.test(keyValue)) {
	        regExError = { type: _SimpleSchema.SimpleSchema.ErrorTypes.FAILED_REGULAR_EXPRESSION, regExp: re.toString() };
	        return false;
	      }
	      return true;
	    });
	    if (regExError) return regExError;
	  }
	}
	
	exports.default = doStringChecks;

/***/ },

/***/ "./node_modules/simpl-schema/dist/validation/doArrayChecks.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SimpleSchema = __webpack_require__("./node_modules/simpl-schema/dist/SimpleSchema.js");
	
	function doArrayChecks(def, keyValue) {
	  // Is it an array?
	  if (!Array.isArray(keyValue)) {
	    return { type: _SimpleSchema.SimpleSchema.ErrorTypes.EXPECTED_TYPE, dataType: 'Array' };
	  }
	
	  // Are there fewer than the minimum number of items in the array?
	  if (def.minCount !== null && keyValue.length < def.minCount) {
	    return { type: _SimpleSchema.SimpleSchema.ErrorTypes.MIN_COUNT, minCount: def.minCount };
	  }
	
	  // Are there more than the maximum number of items in the array?
	  if (def.maxCount !== null && keyValue.length > def.maxCount) {
	    return { type: _SimpleSchema.SimpleSchema.ErrorTypes.MAX_COUNT, maxCount: def.maxCount };
	  }
	}
	
	exports.default = doArrayChecks;

/***/ },

/***/ "./node_modules/simpl-schema/dist/validation/requiredValidator.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__("./build/meteor/bundle/programs/web.browser/packages/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _SimpleSchema = __webpack_require__("./node_modules/simpl-schema/dist/SimpleSchema.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Check for missing required values. The general logic is this:
	// * If the operator is $unset or $rename, it's invalid.
	// * If the value is null, it's invalid.
	// * If the value is undefined and one of the following are true, it's invalid:
	//     * We're validating a key of a sub-object.
	//     * We're validating a key of an object that is an array item.
	//     * We're validating a document (as opposed to a modifier).
	//     * We're validating a key under the $set operator in a modifier, and it's an upsert.
	function requiredValidator() {
	  var _this = this;
	
	  if (this.definition.optional) return;
	
	  // We can skip the required check for keys that are ancestors
	  // of those in $set or $setOnInsert because they will be created
	  // by MongoDB while setting.
	  var setKeys = Object.keys(this.obj.$set || {}).concat(Object.keys(this.obj.$setOnInsert || {}));
	  var willBeCreatedAutomatically = _underscore2.default.some(setKeys, function (sk) {
	    return sk.slice(0, _this.key.length + 1) === _this.key + '.';
	  });
	  if (willBeCreatedAutomatically) return;
	
	  if (this.value === null || this.operator === '$unset' || this.operator === '$rename' || this.value === undefined && (this.isInArrayItemObject || this.isInSubObject || !this.operator || this.operator === '$set')) {
	    return _SimpleSchema.SimpleSchema.ErrorTypes.REQUIRED;
	  }
	}
	
	exports.default = requiredValidator;

/***/ },

/***/ "./node_modules/simpl-schema/dist/validation/allowedValuesValidator.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__("./build/meteor/bundle/programs/web.browser/packages/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _SimpleSchema = __webpack_require__("./node_modules/simpl-schema/dist/SimpleSchema.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function allowedValuesValidator() {
	  if (!this.valueShouldBeChecked) return;
	
	  var allowedValues = this.definition.allowedValues;
	  if (!allowedValues) return;
	
	  var isAllowed = _underscore2.default.contains(allowedValues, this.value);
	  return isAllowed ? true : _SimpleSchema.SimpleSchema.ErrorTypes.VALUE_NOT_ALLOWED;
	}
	
	exports.default = allowedValuesValidator;

/***/ },

/***/ "./node_modules/simpl-schema/dist/SimpleSchemaGroup.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mongoObject = __webpack_require__("./node_modules/mongo-object/dist/mongo-object.js");
	
	var _mongoObject2 = _interopRequireDefault(_mongoObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SimpleSchemaGroup = function () {
	  function SimpleSchemaGroup() {
	    _classCallCheck(this, SimpleSchemaGroup);
	
	    for (var _len = arguments.length, definitions = Array(_len), _key = 0; _key < _len; _key++) {
	      definitions[_key] = arguments[_key];
	    }
	
	    this.definitions = definitions.map(function (definition) {
	      if (_mongoObject2.default.isBasicObject(definition)) return definition;
	
	      if (definition instanceof RegExp) {
	        return {
	          type: String,
	          regEx: definition
	        };
	      }
	
	      return {
	        type: definition
	      };
	    });
	  }
	
	  _createClass(SimpleSchemaGroup, [{
	    key: 'singleType',
	    get: function get() {
	      return this.definitions[0].type;
	    }
	  }]);
	
	  return SimpleSchemaGroup;
	}();
	
	exports.default = SimpleSchemaGroup;

/***/ },

/***/ "./node_modules/simpl-schema/dist/regExp.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// this domain regex matches all domains that have at least one .
	// sadly IPv4 Adresses will be caught too but technically those are valid domains
	// this expression is extracted from the original RFC 5322 mail expression
	// a modification enforces that the tld consists only of characters
	var rxDomain = '(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z](?:[a-z-]*[a-z])?';
	// this domain regex matches everythign that could be a domain in intranet
	// that means "localhost" is a valid domain
	var rxNameDomain = '(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\\.|$))+';
	// strict IPv4 expression which allows 0-255 per oktett
	var rxIPv4 = '(?:(?:[0-1]?\\d{1,2}|2[0-4]\\d|25[0-5])(?:\\.|$)){4}';
	// strict IPv6 expression which allows (and validates) all shortcuts
	var rxIPv6 = '(?:(?:[\\dA-Fa-f]{1,4}(?::|$)){8}' // full adress
	 + '|(?=(?:[^:\\s]|:[^:\\s])*::(?:[^:\\s]|:[^:\\s])*$)' // or min/max one '::'
	 + '[\\dA-Fa-f]{0,4}(?:::?(?:[\\dA-Fa-f]{1,4}|$)){1,6})'; // and short adress
	// this allows domains (also localhost etc) and ip adresses
	var rxWeakDomain = '(?:' + [rxNameDomain, rxIPv4, rxIPv6].join('|') + ')';
	
	var regEx = {
	  // We use the RegExp suggested by W3C in http://www.w3.org/TR/html5/forms.html#valid-e-mail-address
	  // This is probably the same logic used by most browsers when type=email, which is our goal. It is
	  // a very permissive expression. Some apps may wish to be more strict and can write their own RegExp.
	  Email: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
	  // Like Email but requires the TLD (.com, etc)
	  EmailWithTLD: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[A-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[A-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?$/,
	
	  Domain: new RegExp('^' + rxDomain + '$'),
	  WeakDomain: new RegExp('^' + rxWeakDomain + '$'),
	
	  IP: new RegExp('^(?:' + rxIPv4 + '|' + rxIPv6 + ')$'),
	  IPv4: new RegExp('^' + rxIPv4 + '$'),
	  IPv6: new RegExp('^' + rxIPv6 + '$'),
	  // URL RegEx from https://gist.github.com/dperini/729294
	  // http://mathiasbynens.be/demo/url-regex
	  Url: /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i,
	  // unique id from the random package also used by minimongo
	  // character list: https://github.com/meteor/meteor/blob/release/0.8.0/packages/random/random.js#L88
	  // string length: https://github.com/meteor/meteor/blob/release/0.8.0/packages/random/random.js#L143
	  Id: /^[23456789ABCDEFGHJKLMNPQRSTWXYZabcdefghijkmnopqrstuvwxyz]{17}$/,
	  // allows for a 5 digit zip code followed by a whitespace or dash and then 4 more digits
	  // matches 11111 and 11111-1111 and 11111 1111
	  ZipCode: /^\d{5}(?:[-\s]\d{4})?$/,
	  // taken from Google's libphonenumber library
	  // https://github.com/googlei18n/libphonenumber/blob/master/javascript/i18n/phonenumbers/phonenumberutil.js
	  // reference the VALID_PHONE_NUMBER_PATTERN key
	  // allows for common phone number symbols including + () and -
	  Phone: /^[0-9０-９٠-٩۰-۹]{2}$|^[+＋]*(?:[-x‐-―−ー－-／  ­​⁠　()（）［］.\[\]/~⁓∼～*]*[0-9０-９٠-٩۰-۹]){3,}[-x‐-―−ー－-／  ­​⁠　()（）［］.\[\]/~⁓∼～0-9０-９٠-٩۰-۹]*(?:;ext=([0-9０-９٠-٩۰-۹]{1,7})|[  \t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|[,xｘ#＃~～]|int|anexo|ｉｎｔ)[:\.．]?[  \t,-]*([0-9０-９٠-٩۰-۹]{1,7})#?|[- ]+([0-9０-９٠-٩۰-۹]{1,5})#)?$/i };
	
	// eslint-disable-line no-irregular-whitespace
	exports.default = regEx;

/***/ },

/***/ "./node_modules/simpl-schema/dist/clean.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mongoObject = __webpack_require__("./node_modules/mongo-object/dist/mongo-object.js");
	
	var _mongoObject2 = _interopRequireDefault(_mongoObject);
	
	var _underscore = __webpack_require__("./build/meteor/bundle/programs/web.browser/packages/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _utility = __webpack_require__("./node_modules/simpl-schema/dist/utility.js");
	
	var _SimpleSchema = __webpack_require__("./node_modules/simpl-schema/dist/SimpleSchema.js");
	
	var _convertToProperType = __webpack_require__("./node_modules/simpl-schema/dist/clean/convertToProperType.js");
	
	var _convertToProperType2 = _interopRequireDefault(_convertToProperType);
	
	var _setAutoValues = __webpack_require__("./node_modules/simpl-schema/dist/clean/setAutoValues.js");
	
	var _setAutoValues2 = _interopRequireDefault(_setAutoValues);
	
	var _clone = __webpack_require__("./node_modules/clone/clone.js");
	
	var _clone2 = _interopRequireDefault(_clone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @param {SimpleSchema} ss - A SimpleSchema instance
	 * @param {Object} doc - Document or modifier to clean. Referenced object will be modified in place.
	 * @param {Object} [options]
	 * @param {Boolean} [options.mutate=false] - Mutate doc. Set this to true to improve performance if you don't mind mutating the object you're cleaning.
	 * @param {Boolean} [options.filter=true] - Do filtering?
	 * @param {Boolean} [options.autoConvert=true] - Do automatic type converting?
	 * @param {Boolean} [options.removeEmptyStrings=true] - Remove keys in normal object or $set where the value is an empty string?
	 * @param {Boolean} [options.removeNullsFromArrays=false] - Remove all null items from all arrays
	 * @param {Boolean} [options.trimStrings=true] - Trim string values?
	 * @param {Boolean} [options.getAutoValues=true] - Inject automatic and default values?
	 * @param {Boolean} [options.isModifier=false] - Is doc a modifier object?
	 * @param {Boolean} [options.mongoObject] - If you already have the mongoObject instance, pass it to improve performance
	 * @param {Object} [options.extendAutoValueContext] - This object will be added to the `this` context of autoValue functions.
	 * @returns {Object} The modified doc.
	 *
	 * Cleans a document or modifier object. By default, will filter, automatically
	 * type convert where possible, and inject automatic/default values. Use the options
	 * to skip one or more of these.
	 */
	function clean(ss, doc) {
	  var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	  // By default, doc will be filtered and autoconverted
	  options = _extends({
	    isModifier: (0, _utility.looksLikeModifier)(doc)
	  }, ss._cleanOptions, options);
	
	  // Clone so we do not mutate
	  var cleanDoc = options.mutate ? doc : (0, _clone2.default)(doc);
	
	  var mongoObject = options.mongoObject || new _mongoObject2.default(cleanDoc, ss.blackboxKeys());
	
	  // Clean loop
	  if (options.filter || options.autoConvert || options.removeEmptyStrings || options.trimStrings) {
	    (function () {
	      var removedPositions = []; // For removing now-empty objects after
	
	      mongoObject.forEachNode(function eachNode() {
	        // The value of a $unset is irrelevant, so no point in cleaning it.
	        // Also we do not care if fields not in the schema are unset.
	        if (this.operator === '$unset') return;
	
	        var gKey = this.genericKey;
	        if (!gKey) return;
	
	        var val = this.value;
	        if (val === undefined) return;
	
	        var p = void 0;
	
	        // Filter out props if necessary
	        if (options.filter && !ss.allowsKey(gKey) || options.removeNullsFromArrays && this.isArrayItem) {
	          // XXX Special handling for $each; maybe this could be made nicer
	          if (this.position.slice(-7) === '[$each]') {
	            mongoObject.removeValueForPosition(this.position.slice(0, -7));
	            removedPositions.push(this.position.slice(0, -7));
	          } else {
	            this.remove();
	            removedPositions.push(this.position);
	          }
	          if (_SimpleSchema.SimpleSchema.debug) {
	            console.info('SimpleSchema.clean: filtered out value that would have affected key "' + gKey + '", which is not allowed by the schema');
	          }
	          return; // no reason to do more
	        }
	
	        var outerDef = ss.schema(gKey);
	        var def = outerDef && outerDef.type.definitions[0];
	
	        // Autoconvert values if requested and if possible
	        if (options.autoConvert && def) {
	          var newVal = (0, _convertToProperType2.default)(val, def.type);
	          if (newVal !== undefined && newVal !== val) {
	            _SimpleSchema.SimpleSchema.debug && console.info('SimpleSchema.clean: autoconverted value ' + val + ' from ' + (typeof val === 'undefined' ? 'undefined' : _typeof(val)) + ' to ' + (typeof newVal === 'undefined' ? 'undefined' : _typeof(newVal)) + ' for ' + gKey);
	            val = newVal;
	            this.updateValue(newVal);
	          }
	        }
	
	        // Trim strings if
	        // 1. The trimStrings option is `true` AND
	        // 2. The field is not in the schema OR is in the schema with `trim` !== `false` AND
	        // 3. The value is a string.
	        if (options.trimStrings && (!def || def.trim !== false) && typeof val === 'string') {
	          val = val.trim();
	          this.updateValue(val);
	        }
	
	        // Remove empty strings if
	        // 1. The removeEmptyStrings option is `true` AND
	        // 2. The value is in a normal object or in the $set part of a modifier
	        // 3. The value is an empty string.
	        if (options.removeEmptyStrings && (!this.operator || this.operator === '$set') && typeof val === 'string' && !val.length) {
	          // For a document, we remove any fields that are being set to an empty string
	          this.remove();
	          // For a modifier, we $unset any fields that are being set to an empty string.
	          // But only if we're not already within an entire object that is being set.
	          if (this.operator === '$set' && this.position.match(/\[.+?\]/g).length < 2) {
	            p = this.position.replace('$set', '$unset');
	            mongoObject.setValueForPosition(p, '');
	          }
	        }
	      }, { endPointsOnly: false });
	
	      // Remove any objects that are now empty after filtering
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = removedPositions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var removedPosition = _step.value;
	
	          var lastBrace = removedPosition.lastIndexOf('[');
	          if (lastBrace === -1) continue;
	          var removedPositionParent = removedPosition.slice(0, lastBrace);
	          var value = mongoObject.getValueForPosition(removedPositionParent);
	          if (_underscore2.default.isEmpty(value)) mongoObject.removeValueForPosition(removedPositionParent);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      mongoObject.removeArrayItems();
	    })();
	  }
	
	  // Set automatic values
	  options.getAutoValues && (0, _setAutoValues2.default)(ss.autoValueFunctions(), mongoObject, options.isModifier, options.extendAutoValueContext);
	
	  // Ensure we don't have any operators set to an empty object
	  // since MongoDB 2.6+ will throw errors.
	  if (options.isModifier) {
	    Object.keys(cleanDoc || {}).forEach(function (op) {
	      if (_underscore2.default.isEmpty(cleanDoc[op])) delete cleanDoc[op];
	    });
	  }
	
	  return cleanDoc;
	}
	
	exports.default = clean;

/***/ },

/***/ "./node_modules/simpl-schema/dist/clean/convertToProperType.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _SimpleSchema = __webpack_require__("./node_modules/simpl-schema/dist/SimpleSchema.js");
	
	/**
	 * Converts value to proper type
	 *
	 * @param {Any} value Value to try to convert
	 * @param {Any} type  A type
	 * @returns {Any} Value converted to type.
	 */
	function convertToProperType(value, type) {
	  // Can't and shouldn't convert arrays or objects
	  if (Array.isArray(value) || value && (typeof value === 'function' || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') && !(value instanceof Date)) return value;
	
	  // Convert to String type
	  if (type === String) {
	    if (value === null || value === undefined) return value;
	    return value.toString();
	  }
	
	  // Convert to Number type
	  if (type === Number || type === _SimpleSchema.SimpleSchema.Integer) {
	    if (typeof value === 'string' && value.length > 0) {
	      // Try to convert numeric strings to numbers
	      var numberVal = Number(value);
	      if (!isNaN(numberVal)) return numberVal;
	    }
	    // Leave it; will fail validation
	    return value;
	  }
	
	  // If target type is a Date we can safely convert from either a
	  // number (Integer value representing the number of milliseconds
	  // since 1 January 1970 00:00:00 UTC) or a string that can be parsed
	  // by Date.
	  if (type === Date) {
	    if (typeof value === 'string') {
	      var parsedDate = Date.parse(value);
	      if (isNaN(parsedDate) === false) return new Date(parsedDate);
	    }
	    if (typeof value === 'number') return new Date(value);
	  }
	
	  // If an array is what you want, I'll give you an array
	  if (type === Array) return [value];
	
	  // Could not convert
	  return value;
	}
	
	exports.default = convertToProperType;

/***/ },

/***/ "./node_modules/simpl-schema/dist/clean/setAutoValues.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__("./build/meteor/bundle/programs/web.browser/packages/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _mongoObject = __webpack_require__("./node_modules/mongo-object/dist/mongo-object.js");
	
	var _mongoObject2 = _interopRequireDefault(_mongoObject);
	
	var _utility = __webpack_require__("./node_modules/simpl-schema/dist/utility.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @method setAutoValues
	 * @private
	 * @param {Array} autoValueFunctions - An array of objects with func, fieldName, and closestSubschemaFieldName props
	 * @param {MongoObject} mongoObject
	 * @param {Boolean} [isModifier=false] - Is it a modifier doc?
	 * @param {Object} [extendedAutoValueContext] - Object that will be added to the context when calling each autoValue function
	 * @returns {undefined}
	 *
	 * Updates doc with automatic values from autoValue functions or default
	 * values from defaultValue. Modifies the referenced object in place.
	 */
	function setAutoValues(autoValueFunctions, mongoObject, isModifier, extendedAutoValueContext) {
	  var doneKeys = [];
	
	  function getFieldInfo(key) {
	    var keyInfo = mongoObject.getInfoForKey(key) || {};
	    return {
	      isSet: keyInfo.value !== undefined,
	      value: keyInfo.value,
	      operator: keyInfo.operator || null
	    };
	  }
	
	  function runAV(func, closestSubschemaFieldName) {
	    var affectedKey = this.key;
	
	    // If already called for this key, skip it
	    if (_underscore2.default.contains(doneKeys, affectedKey)) return;
	
	    var fieldParentName = (0, _utility.getParentOfKey)(affectedKey, true);
	
	    var doUnset = false;
	    var autoValue = func.call(_extends({
	      isSet: this.value !== undefined,
	      unset: function unset() {
	        doUnset = true;
	      },
	
	      value: this.value,
	      operator: this.operator,
	      field: function field(fName) {
	        return getFieldInfo(closestSubschemaFieldName + fName);
	      },
	      siblingField: function siblingField(fName) {
	        return getFieldInfo(fieldParentName + fName);
	      }
	    }, extendedAutoValueContext || {}), mongoObject.getObject());
	
	    // Update tracking of which keys we've run autovalue for
	    doneKeys.push(affectedKey);
	
	    if (doUnset) mongoObject.removeValueForPosition(this.position);
	
	    if (autoValue === undefined) return;
	
	    // If the user's auto value is of the pseudo-modifier format, parse it
	    // into operator and value.
	    if (isModifier) {
	      var op = void 0;
	      var newValue = void 0;
	      if (autoValue && (typeof autoValue === 'undefined' ? 'undefined' : _typeof(autoValue)) === 'object') {
	        var avOperator = Object.keys(autoValue).find(function (avProp) {
	          return avProp.substring(0, 1) === '$';
	        });
	        if (avOperator) {
	          op = avOperator;
	          newValue = autoValue[avOperator];
	        }
	      }
	
	      // Add $set for updates and upserts if necessary. Keep this
	      // above the "if (op)" block below since we might change op
	      // in this line.
	      if (!op && this.position.slice(0, 1) !== '$') {
	        op = '$set';
	        newValue = autoValue;
	      }
	
	      if (op) {
	        // Update/change value
	        mongoObject.removeValueForPosition(this.position);
	        mongoObject.setValueForPosition(op + '[' + affectedKey + ']', newValue);
	        return;
	      }
	    }
	
	    // Update/change value
	    mongoObject.setValueForPosition(this.position, autoValue);
	  }
	
	  _underscore2.default.each(autoValueFunctions, function (_ref) {
	    var func = _ref.func;
	    var fieldName = _ref.fieldName;
	    var closestSubschemaFieldName = _ref.closestSubschemaFieldName;
	
	    // autoValue should run for the exact key only, for each array item if under array
	    // should run whenever
	    // 1 it is set
	    // 2 it will be set by an ancestor field being set
	    // 3 it is not set and is not within an array
	    // 4 it is not set and is within an array, run for each array item that is set
	    // 5 if doing $set[a.$] or $set[a.$.b]
	
	    var test = fieldName;
	    var positions = [];
	    var lastDot = void 0;
	    var lastDollar = fieldName.lastIndexOf('$');
	    var isOrIsWithinArray = lastDollar !== -1;
	
	    // Starting from the whole dotted field name for which the autoValue function
	    // is defined, work backwards until finding one that is set.
	    while (test.length > 0) {
	      var currentPositions = mongoObject.getPositionsInfoForGenericKey(test);
	      if (fieldName !== test && currentPositions.length > 0) {
	        (function () {
	          var lastPart = '';
	          if (fieldName.indexOf(test + '.') === 0) {
	            lastPart = fieldName.replace(test + '.', '');
	            if (lastPart.startsWith('$.')) lastPart = lastPart.slice(2);
	          }
	          currentPositions = _underscore2.default.map(currentPositions, function (position) {
	            position.key = position.key + '.' + lastPart;
	            position.position = position.position + '[' + lastPart.replace(/\./g, '][') + ']';
	            position.value = mongoObject.getValueForPosition(position.position);
	            return position;
	          });
	        })();
	      }
	      positions = positions.concat(currentPositions);
	
	      // Do the parent
	      lastDot = test.lastIndexOf('.');
	      if (lastDot > -1) {
	        test = test.slice(0, lastDot);
	      } else {
	        test = '';
	      }
	    }
	
	    if (positions.length === 0) {
	      if (!isOrIsWithinArray) {
	        positions.push({
	          key: fieldName,
	          value: undefined,
	          operator: isModifier ? '$set' : null,
	          position: isModifier ? '$set[' + fieldName + ']' : _mongoObject2.default._keyToPosition(fieldName)
	        });
	      }
	    }
	
	    // Run the autoValue function once for each place in the object that
	    // has a value or that potentially should.
	    _underscore2.default.each(positions, function (position) {
	      runAV.call(position, func, closestSubschemaFieldName);
	    });
	  });
	}
	
	exports.default = setAutoValues;

/***/ },

/***/ "./node_modules/clone/clone.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var clone = (function() {
	'use strict';
	
	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	*/
	function clone(parent, circular, depth, prototype) {
	  var filter;
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    filter = circular.filter;
	    circular = circular.circular
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];
	
	  var useBuffer = typeof Buffer != 'undefined';
	
	  if (typeof circular == 'undefined')
	    circular = true;
	
	  if (typeof depth == 'undefined')
	    depth = Infinity;
	
	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;
	
	    if (depth == 0)
	      return parent;
	
	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }
	
	    if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      child = new Buffer(parent.length);
	      parent.copy(child);
	      return child;
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }
	
	    if (circular) {
	      var index = allParents.indexOf(parent);
	
	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }
	
	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }
	
	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }
	
	    return child;
	  }
	
	  return _clone(parent, depth);
	}
	
	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;
	
	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};
	
	// private utility functions
	
	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	};
	clone.__objToStr = __objToStr;
	
	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	};
	clone.__isDate = __isDate;
	
	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	};
	clone.__isArray = __isArray;
	
	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	};
	clone.__isRegExp = __isRegExp;
	
	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	};
	clone.__getRegExpFlags = __getRegExpFlags;
	
	return clone;
	})();
	
	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ },

/***/ "./node_modules/simpl-schema/dist/expandShorthand.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__("./build/meteor/bundle/programs/web.browser/packages/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _mongoObject = __webpack_require__("./node_modules/mongo-object/dist/mongo-object.js");
	
	var _mongoObject2 = _interopRequireDefault(_mongoObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Clones a schema object, expanding shorthand as it does it.
	 */
	function expandShorthand(schema) {
	  var schemaClone = {};
	
	  _underscore2.default.each(schema, function (definition, key) {
	    // CASE 1: Not shorthand. Just clone
	    if (_mongoObject2.default.isBasicObject(definition)) {
	      schemaClone[key] = _extends({}, definition);
	      return;
	    }
	
	    // CASE 2: The definition is an array of some type
	    if (Array.isArray(definition)) {
	      if (Array.isArray(definition[0])) {
	        throw new Error('Array shorthand may only be used to one level of depth (' + key + ')');
	      }
	      var type = definition[0];
	      schemaClone[key] = { type: Array };
	
	      // Also add the item key definition
	      var itemKey = key + '.$';
	      if (schema[itemKey]) {
	        throw new Error('Array shorthand used for ' + key + ' field but ' + key + '.$ key is already in the schema');
	      }
	
	      if (type instanceof RegExp) {
	        schemaClone[itemKey] = { type: String, regEx: type };
	      } else {
	        schemaClone[itemKey] = { type: type };
	      }
	      return;
	    }
	
	    // CASE 3: The definition is a regular expression
	    if (definition instanceof RegExp) {
	      schemaClone[key] = {
	        type: String,
	        regEx: definition
	      };
	      return;
	    }
	
	    // CASE 4: The definition is something, a type
	    schemaClone[key] = { type: definition };
	  });
	
	  return schemaClone;
	}
	
	exports.default = expandShorthand;

/***/ },

/***/ "./node_modules/simpl-schema/dist/defaultMessages.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__("./build/meteor/bundle/programs/web.browser/packages/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _regExp = __webpack_require__("./node_modules/simpl-schema/dist/regExp.js");
	
	var _regExp2 = _interopRequireDefault(_regExp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var regExpMessages = [{ exp: _regExp2.default.Email, msg: 'must be a valid email address' }, { exp: _regExp2.default.EmailWithTLD, msg: 'must be a valid email address' }, { exp: _regExp2.default.Domain, msg: 'must be a valid domain' }, { exp: _regExp2.default.WeakDomain, msg: 'must be a valid domain' }, { exp: _regExp2.default.IP, msg: 'must be a valid IPv4 or IPv6 address' }, { exp: _regExp2.default.IPv4, msg: 'must be a valid IPv4 address' }, { exp: _regExp2.default.IPv6, msg: 'must be a valid IPv6 address' }, { exp: _regExp2.default.Url, msg: 'must be a valid URL' }, { exp: _regExp2.default.Id, msg: 'must be a valid alphanumeric ID' }, { exp: _regExp2.default.ZipCode, msg: 'must be a valid ZIP code' }, { exp: _regExp2.default.Phone, msg: 'must be a valid phone number' }];
	
	var defaultMessages = {
	  initialLanguage: 'en',
	  messages: {
	    en: {
	      required: '{{{label}}} is required',
	      minString: '{{{label}}} must be at least {{min}} characters',
	      maxString: '{{{label}}} cannot exceed {{max}} characters',
	      minNumber: '{{{label}}} must be at least {{min}}',
	      maxNumber: '{{{label}}} cannot exceed {{max}}',
	      minNumberExclusive: '{{{label}}} must be greater than {{min}}',
	      maxNumberExclusive: '{{{label}}} must be less than {{max}}',
	      minDate: '{{{label}}} must be on or after {{min}}',
	      maxDate: '{{{label}}} cannot be after {{max}}',
	      badDate: '{{{label}}} is not a valid date',
	      minCount: 'You must specify at least {{minCount}} values',
	      maxCount: 'You cannot specify more than {{maxCount}} values',
	      noDecimal: '{{{label}}} must be an integer',
	      notAllowed: '{{{value}}} is not an allowed value',
	      expectedType: '{{{label}}} must be of type {{dataType}}',
	      regEx: function regEx(_ref) {
	        var label = _ref.label;
	        var regExp = _ref.regExp;
	
	        // See if there's one where exp matches this expression
	        var msgObj = void 0;
	        if (regExp) {
	          msgObj = _underscore2.default.find(regExpMessages, function (o) {
	            return o.exp && o.exp.toString() === regExp;
	          });
	        }
	
	        var regExpMessage = msgObj ? msgObj.msg : 'failed regular expression validation';
	
	        return label + ' ' + regExpMessage;
	      },
	
	      keyNotInSchema: '{{name}} is not allowed by the schema'
	    }
	  }
	};
	
	exports.default = defaultMessages;

/***/ },

/***/ "./node_modules/uniforms/SimpleSchemaBridge.js":
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _cloneDeep = __webpack_require__("./node_modules/lodash/cloneDeep.js");
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Bridge2 = __webpack_require__("./node_modules/uniforms/Bridge.js");
	
	var _Bridge3 = _interopRequireDefault(_Bridge2);
	
	var _joinName = __webpack_require__("./node_modules/uniforms/joinName.js");
	
	var _joinName2 = _interopRequireDefault(_joinName);
	
	var _filterDOMProps = __webpack_require__("./node_modules/uniforms/filterDOMProps.js");
	
	var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Match = ((typeof global === 'undefined' ? 'undefined' : (0, _typeof3.default)(global)) === 'object' ? global : window).Match; /* global Package */
	
	var SimpleSchema = ((typeof global === 'undefined' ? 'undefined' : (0, _typeof3.default)(global)) === 'object' ? global : window).SimpleSchema;
	
	/* istanbul ignore next */
	try {
	    if (Match === undefined && (typeof Package === 'undefined' ? 'undefined' : (0, _typeof3.default)(Package)) === 'object') {
	        Match = Package['check'].Match;
	    }
	
	    if (SimpleSchema === undefined && (typeof Package === 'undefined' ? 'undefined' : (0, _typeof3.default)(Package)) === 'object') {
	        SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	    }
	} catch (_) {/* Ignore it. */}
	
	try {
	    var r = require; // Silence Meteor missing module warning
	
	    if (Match === undefined) {
	        Match = __webpack_require__("./build/meteor/bundle/programs/web.browser/packages/check.js").Match;
	    }
	
	    if (SimpleSchema === undefined) {
	        SimpleSchema = __webpack_require__("./build/meteor/bundle/programs/web.browser/packages/aldeed_simple-schema.js").SimpleSchema;
	    }
	} catch (_) {/* Ignore it. */}
	
	if (SimpleSchema) {
	    SimpleSchema.extendOptions({
	        uniforms: Match.Optional(Match.OneOf(String, Function, Match.ObjectIncluding({
	            component: Match.Optional(Match.OneOf(String, Function))
	        })))
	    });
	
	    // There's no possibility to retrieve them at runtime
	    _filterDOMProps2.default.register('allowedValues', 'autoValue', 'blackbox', 'custom', 'decimal', 'defaultValue', 'exclusiveMax', 'exclusiveMin', 'label', 'max', 'maxCount', 'min', 'minCount', 'optional', 'regEx', 'trim', 'type');
	}
	
	var SimpleSchemaBridge = function (_Bridge) {
	    (0, _inherits3.default)(SimpleSchemaBridge, _Bridge);
	
	    function SimpleSchemaBridge(schema) {
	        (0, _classCallCheck3.default)(this, SimpleSchemaBridge);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (SimpleSchemaBridge.__proto__ || Object.getPrototypeOf(SimpleSchemaBridge)).call(this));
	
	        _this.schema = schema;
	        return _this;
	    }
	
	    (0, _createClass3.default)(SimpleSchemaBridge, [{
	        key: 'getError',
	        value: function getError(name, error) {
	            return error && error.details && error.details.find && error.details.find(function (error) {
	                return error.name === name;
	            }) || null;
	        }
	    }, {
	        key: 'getErrorMessage',
	        value: function getErrorMessage(name, error) {
	            var scopedError = this.getError(name, error);
	            return !scopedError ? '' : this.schema.messageForError(scopedError.type, scopedError.name, null, scopedError.details && scopedError.details.value);
	        }
	    }, {
	        key: 'getErrorMessages',
	        value: function getErrorMessages(error) {
	            var _this2 = this;
	
	            if (error) {
	                if (Array.isArray(error.details)) {
	                    return error.details.map(function (error) {
	                        return _this2.schema.messageForError(error.type, error.name, null, error.details && error.details.value);
	                    });
	                }
	
	                if (error.message) {
	                    return [error.message];
	                }
	            }
	
	            if (error !== undefined) {
	                return [error];
	            }
	
	            return [];
	        }
	    }, {
	        key: 'getField',
	        value: function getField(name) {
	            var definition = this.schema.getDefinition(name);
	
	            (0, _invariant2.default)(definition, 'Field not found in schema: "%s"', name);
	
	            return definition;
	        }
	    }, {
	        key: 'getInitialValue',
	        value: function getInitialValue(name) {
	            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            var field = this.getField(name);
	
	            if (field.type === Array) {
	                var item = this.getInitialValue((0, _joinName2.default)(name, '0'));
	                var items = Math.max(props.initialCount || 0, field.minCount || 0);
	
	                return [].concat((0, _toConsumableArray3.default)(Array(items))).map(function () {
	                    return item;
	                });
	            }
	
	            if (field.type === Object) {
	                return {};
	            }
	
	            return field.defaultValue;
	        }
	
	        // eslint-disable-next-line complexity
	
	    }, {
	        key: 'getProps',
	        value: function getProps(name) {
	            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            // Type should be omitted.
	            // eslint-disable-next-line no-unused-vars, prefer-const
	            var _getField = this.getField(name),
	                optional = _getField.optional,
	                type = _getField.type,
	                uniforms = _getField.uniforms,
	                field = (0, _objectWithoutProperties3.default)(_getField, ['optional', 'type', 'uniforms']);
	
	            field = (0, _extends3.default)({}, field, { required: !optional });
	
	            if (uniforms) {
	                if (typeof uniforms === 'string' || typeof uniforms === 'function') {
	                    field = (0, _extends3.default)({}, field, { component: uniforms });
	                } else {
	                    field = (0, _extends3.default)({}, field, uniforms);
	                }
	            }
	
	            if (type === Array) {
	                try {
	                    var itemProps = this.getProps(name + '.$', props);
	                    if (itemProps.allowedValues && !props.allowedValues) {
	                        field.allowedValues = itemProps.allowedValues;
	                    }
	
	                    if (itemProps.transform && !props.transform) {
	                        field.transform = itemProps.transform;
	                    }
	                } catch (_) {/* ignore it */}
	            }
	
	            var options = props.options || field.options;
	            if (options) {
	                if (typeof options === 'function') {
	                    options = options();
	                }
	
	                if (!Array.isArray(options)) {
	                    field = (0, _extends3.default)({}, field, {
	                        transform: function transform(value) {
	                            return options[value];
	                        },
	                        allowedValues: Object.keys(options)
	                    });
	                } else {
	                    field = (0, _extends3.default)({}, field, {
	                        transform: function transform(value) {
	                            return options.find(function (option) {
	                                return option.value === value;
	                            }).label;
	                        },
	                        allowedValues: options.map(function (option) {
	                            return option.value;
	                        })
	                    });
	                }
	            }
	
	            return field;
	        }
	    }, {
	        key: 'getSubfields',
	        value: function getSubfields(name) {
	            return this.schema.objectKeys(SimpleSchema._makeGeneric(name));
	        }
	    }, {
	        key: 'getType',
	        value: function getType(name) {
	            return this.getField(name).type;
	        }
	    }, {
	        key: 'getValidator',
	        value: function getValidator() {
	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { clean: true };
	
	            var validator = this.schema.validator(options);
	
	            // Clean mutate its argument.
	            if (options.clean) {
	                return function (model) {
	                    return validator((0, _cloneDeep2.default)((0, _extends3.default)({}, model)));
	                };
	            }
	
	            return validator;
	        }
	    }], [{
	        key: 'check',
	        value: function check(schema) {
	            return SimpleSchema && schema && schema.getDefinition && schema.messageForError && schema.objectKeys && schema.validator && schema.version !== 2;
	        }
	    }]);
	    return SimpleSchemaBridge;
	}(_Bridge3.default);
	
	exports.default = SimpleSchemaBridge;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "./node_modules/uniforms/randomIds.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = randomIds;
	
	
	// Workaround for SSR
	// https://github.com/vazco/uniforms/issues/40
	// https://github.com/facebook/react/issues/4000
	function randomIdsGenerator(prefix) {
	    var counter = 0;
	
	    return function () {
	        return prefix + '-' + ('000' + (counter++).toString(36)).slice(-4);
	    };
	}
	
	var randomIdPrefix = randomIdsGenerator('uniforms');
	
	function randomIds() {
	    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : randomIdPrefix();
	
	    return randomIdsGenerator(prefix);
	}

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/NumField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _wrapField = __webpack_require__("./node_modules/uniforms-bootstrap3/wrapField.js");
	
	var _wrapField2 = _interopRequireDefault(_wrapField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noneIfNaN = function noneIfNaN(x) {
	    return isNaN(x) ? undefined : x;
	};
	
	var Num_ = function Num_(props) {
	    return (0, _wrapField2.default)(props, _react2.default.createElement('input', {
	        className: (0, _classnames2.default)(props.inputClassName, 'form-control', { 'form-control-danger': props.error }),
	        disabled: props.disabled,
	        id: props.id,
	        max: props.max,
	        min: props.min,
	        name: props.name,
	        onChange: props.onChange,
	        placeholder: props.placeholder,
	        ref: props.inputRef,
	        step: props.step || (props.decimal ? 0.01 : 1),
	        type: 'number',
	        value: props.value
	    }));
	};
	
	// NOTE: React < 16 workaround. Make it optional?
	
	var Num = function (_Component) {
	    (0, _inherits3.default)(Num, _Component);
	
	    function Num() {
	        (0, _classCallCheck3.default)(this, Num);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Num.__proto__ || Object.getPrototypeOf(Num)).apply(this, arguments));
	
	        _this.state = { value: '' + _this.props.value };
	
	        _this.onChange = _this.onChange.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(Num, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var decimal = _ref.decimal,
	                value = _ref.value;
	
	            var parse = decimal ? parseFloat : parseInt;
	
	            if (noneIfNaN(parse(value)) !== noneIfNaN(parse(this.state.value.replace(/[.,]+$/, '')))) {
	                this.setState({ value: value === undefined || value === '' ? '' : '' + value });
	            }
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange(_ref2) {
	            var value = _ref2.target.value;
	
	            var change = value.replace(/[^\d.,-]/g, '');
	
	            this.setState({ value: change });
	            this.props.onChange(noneIfNaN((this.props.decimal ? parseFloat : parseInt)(change)));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return Num_((0, _extends3.default)({}, this.props, { onChange: this.onChange, value: this.state.value }));
	        }
	    }]);
	    return Num;
	}(_react.Component);
	
	exports.default = (0, _connectField2.default)(Num);

/***/ },

/***/ "./node_modules/uniforms/connectField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__("./node_modules/babel-runtime/helpers/get.js");
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.default = connectField;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _BaseField = __webpack_require__("./node_modules/uniforms/BaseField.js");
	
	var _BaseField2 = _interopRequireDefault(_BaseField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var identity = function identity(x) {
	    return x;
	};
	
	function connectField(component) {
	    var _class, _temp;
	
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        _ref$baseField = _ref.baseField,
	        baseField = _ref$baseField === undefined ? _BaseField2.default : _ref$baseField,
	        _ref$mapProps = _ref.mapProps,
	        mapProps = _ref$mapProps === undefined ? identity : _ref$mapProps,
	        ensureValue = _ref.ensureValue,
	        includeInChain = _ref.includeInChain,
	        includeParent = _ref.includeParent,
	        initialValue = _ref.initialValue;
	
	    return _temp = _class = function (_baseField) {
	        (0, _inherits3.default)(_class, _baseField);
	
	        function _class() {
	            (0, _classCallCheck3.default)(this, _class);
	
	            var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	
	            _this.options.includeInChain = includeInChain === undefined ? true : includeInChain;
	            _this.options.initialValue = initialValue === undefined ? true : initialValue;
	
	            if (ensureValue !== undefined) _this.options.ensureValue = ensureValue;
	            if (includeParent !== undefined) _this.options.includeParent = includeParent;
	            return _this;
	        }
	
	        (0, _createClass3.default)(_class, [{
	            key: 'getChildContextName',
	            value: function getChildContextName() {
	                return this.options.includeInChain ? (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'getChildContextName', this).call(this) : this.context.uniforms.name;
	            }
	        }, {
	            key: 'componentWillMount',
	            value: function componentWillMount() {
	                if (this.options.initialValue) {
	                    var props = this.getFieldProps(undefined, {
	                        ensureValue: false,
	                        explicitInitialValue: true,
	                        includeParent: false
	                    });
	
	                    // https://github.com/vazco/uniforms/issues/52
	                    // If field is initially rendered with value, we treat it as an initial value.
	                    if (this.props.value !== undefined && this.props.value !== props.value) {
	                        props.onChange(this.props.value);
	                        return;
	                    }
	
	                    if (props.required && props.initialValue !== undefined && props.value === undefined) {
	                        props.onChange(props.initialValue);
	                    }
	                }
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return (0, _react.createElement)(component, mapProps(this.getFieldProps()));
	            }
	        }]);
	        return _class;
	    }(baseField), _class.displayName = '' + (component.displayName || component.name) + (baseField.displayName || baseField.name), _temp;
	}

/***/ },

/***/ "./node_modules/babel-runtime/helpers/get.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);
	
	  if (desc === undefined) {
	    var parent = (0, _getPrototypeOf2.default)(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};

/***/ },

/***/ "./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/get-own-property-descriptor.js"), __esModule: true };

/***/ },

/***/ "./node_modules/core-js/library/fn/object/get-own-property-descriptor.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.object.get-own-property-descriptor.js");
	var $Object = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/es6.object.get-own-property-descriptor.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
	var $getOwnPropertyDescriptor = __webpack_require__("./node_modules/core-js/library/modules/_object-gopd.js").f;
	
	__webpack_require__("./node_modules/core-js/library/modules/_object-sap.js")('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },

/***/ "./node_modules/uniforms-bootstrap3/wrapField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = wrapField;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _filterDOMProps = __webpack_require__("./node_modules/uniforms/filterDOMProps.js");
	
	var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);
	
	var _gridClassName = __webpack_require__("./node_modules/uniforms-bootstrap3/gridClassName.js");
	
	var _gridClassName2 = _interopRequireDefault(_gridClassName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapField(_ref, children) {
	    var checkboxes = _ref.checkboxes,
	        className = _ref.className,
	        disabled = _ref.disabled,
	        error = _ref.error,
	        errorMessage = _ref.errorMessage,
	        feedbackable = _ref.feedbackable,
	        grid = _ref.grid,
	        help = _ref.help,
	        helpClassName = _ref.helpClassName,
	        id = _ref.id,
	        inline = _ref.inline,
	        inputClassName = _ref.inputClassName,
	        inputRef = _ref.inputRef,
	        label = _ref.label,
	        required = _ref.required,
	        rows = _ref.rows,
	        showInlineError = _ref.showInlineError,
	        transform = _ref.transform,
	        wrapClassName = _ref.wrapClassName,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['checkboxes', 'className', 'disabled', 'error', 'errorMessage', 'feedbackable', 'grid', 'help', 'helpClassName', 'id', 'inline', 'inputClassName', 'inputRef', 'label', 'required', 'rows', 'showInlineError', 'transform', 'wrapClassName']);
	
	    var hasWrap = !!(grid || wrapClassName);
	
	    var blockError = !!(error && showInlineError) && _react2.default.createElement(
	        'span',
	        { className: 'help-block' },
	        errorMessage
	    );
	
	    var blockFeedback = !!(error && feedbackable) && _react2.default.createElement('i', { className: 'glyphicon glyphicon-remove form-control-feedback' });
	
	    var blockHelp = !!help && _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)('help-block', helpClassName) },
	        help
	    );
	
	    return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({
	            className: (0, _classnames2.default)(className, 'field', 'form-group', {
	                'has-feedback': error && feedbackable,
	                'has-error': error,
	                disabled: disabled,
	                required: required
	            })
	        }, (0, _filterDOMProps2.default)(props)),
	        label && _react2.default.createElement(
	            'label',
	            { htmlFor: id, className: (0, _classnames2.default)('control-label', (0, _gridClassName2.default)(grid, 'label')) },
	            label
	        ),
	        hasWrap && _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(wrapClassName, (0, _gridClassName2.default)(grid, 'input')) },
	            children,
	            blockFeedback,
	            blockHelp,
	            blockError
	        ),
	        !hasWrap && children,
	        !hasWrap && blockFeedback,
	        !hasWrap && blockHelp,
	        !hasWrap && blockError
	    );
	}

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/gridClassName.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.default = gridClassName;
	
	var _filterDOMProps = __webpack_require__("./node_modules/uniforms/filterDOMProps.js");
	
	var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_filterDOMProps2.default.register('grid');
	
	function gridClassNamePart(size, value, side) {
	    return side === 'label' ? 'col-' + size + '-' + value : 'col-' + size + '-' + (12 - value);
	}
	
	function gridClassName(grid, side) {
	    // Example: 6
	    if (typeof grid === 'number') {
	        return gridClassNamePart('sm', grid, side);
	    }
	
	    // Example: '6'
	    if (typeof grid === 'string' && !isNaN(parseInt(grid))) {
	        return gridClassNamePart('sm', parseInt(grid), side);
	    }
	
	    // Example: 'col-md-6'
	    if (typeof grid === 'string') {
	        return grid;
	    }
	
	    // Example: {xs: 6, sm: 4, md: 3}
	    if ((typeof grid === 'undefined' ? 'undefined' : (0, _typeof3.default)(grid)) === 'object') {
	        return Object.keys(grid).map(function (size) {
	            return gridClassNamePart(size, grid[size], side);
	        }).join(' ');
	    }
	
	    return '';
	}

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/BoolField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _wrapField = __webpack_require__("./node_modules/uniforms-bootstrap3/wrapField.js");
	
	var _wrapField2 = _interopRequireDefault(_wrapField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bool = function Bool(_ref) {
	    var label = _ref.label,
	        labelBefore = _ref.labelBefore,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['label', 'labelBefore']);
	    return (0, _wrapField2.default)((0, _extends3.default)({ label: labelBefore }, props), _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(props.inputClassName, 'checkbox' + (props.inline ? '-inline' : '')) },
	        _react2.default.createElement(
	            'label',
	            { htmlFor: props.id },
	            _react2.default.createElement('input', {
	                checked: props.value,
	                disabled: props.disabled,
	                id: props.id,
	                name: props.name,
	                onChange: function onChange() {
	                    return props.onChange(!props.value);
	                },
	                ref: props.inputRef,
	                type: 'checkbox'
	            }),
	            '\xA0',
	            label
	        )
	    ));
	};
	
	exports.default = (0, _connectField2.default)(Bool);

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/DateField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _wrapField = __webpack_require__("./node_modules/uniforms-bootstrap3/wrapField.js");
	
	var _wrapField2 = _interopRequireDefault(_wrapField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormat = function dateFormat(value) {
	    return value && value.toISOString().slice(0, -8);
	};
	var dateParse = function dateParse(timestamp, onChange) {
	    var date = new Date(timestamp);
	    if (date.getFullYear() < 10000) {
	        onChange(date);
	    } else if (isNaN(timestamp)) {
	        onChange(undefined);
	    }
	};
	
	var Date_ = function Date_(props) {
	    return (0, _wrapField2.default)(props, _react2.default.createElement('input', {
	        className: (0, _classnames2.default)(props.inputClassName, 'form-control', { 'form-control-danger': props.error }),
	        disabled: props.disabled,
	        id: props.id,
	        max: dateFormat(props.max),
	        min: dateFormat(props.min),
	        name: props.name,
	        onChange: function onChange(event) {
	            return dateParse(event.target.valueAsNumber, props.onChange);
	        },
	        placeholder: props.placeholder,
	        ref: props.inputRef,
	        type: 'datetime-local',
	        value: dateFormat(props.value)
	    }));
	};
	
	Date_.displayName = 'Date';
	
	exports.default = (0, _connectField2.default)(Date_);

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/ListField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _filterDOMProps = __webpack_require__("./node_modules/uniforms/filterDOMProps.js");
	
	var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);
	
	var _joinName = __webpack_require__("./node_modules/uniforms/joinName.js");
	
	var _joinName2 = _interopRequireDefault(_joinName);
	
	var _ListAddField = __webpack_require__("./node_modules/uniforms-bootstrap3/ListAddField.js");
	
	var _ListAddField2 = _interopRequireDefault(_ListAddField);
	
	var _ListItemField = __webpack_require__("./node_modules/uniforms-bootstrap3/ListItemField.js");
	
	var _ListItemField2 = _interopRequireDefault(_ListItemField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = function List(_ref) {
	    var addIcon = _ref.addIcon,
	        children = _ref.children,
	        className = _ref.className,
	        error = _ref.error,
	        errorMessage = _ref.errorMessage,
	        initialCount = _ref.initialCount,
	        itemProps = _ref.itemProps,
	        label = _ref.label,
	        name = _ref.name,
	        removeIcon = _ref.removeIcon,
	        showInlineError = _ref.showInlineError,
	        value = _ref.value,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['addIcon', 'children', 'className', 'error', 'errorMessage', 'initialCount', 'itemProps', 'label', 'name', 'removeIcon', 'showInlineError', 'value']);
	    return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({
	            className: (0, _classnames2.default)('panel panel-default', { 'panel-danger': error }, className)
	        }, (0, _filterDOMProps2.default)(props)),
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-body' },
	            label && _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('panel-heading', { 'has-error': error }) },
	                _react2.default.createElement(
	                    'label',
	                    { className: 'control-label' },
	                    label,
	                    '\xA0'
	                ),
	                _react2.default.createElement(_ListAddField2.default, { name: name + '.$', initialCount: initialCount, addIcon: addIcon }),
	                !!(error && showInlineError) && _react2.default.createElement(
	                    'span',
	                    { className: 'help-block' },
	                    errorMessage
	                )
	            ),
	            children ? value.map(function (item, index) {
	                return _react.Children.map(children, function (child) {
	                    return _react2.default.cloneElement(child, {
	                        key: index,
	                        label: null,
	                        name: (0, _joinName2.default)(name, child.props.name && child.props.name.replace('$', index)),
	                        removeIcon: removeIcon
	                    });
	                });
	            }) : value.map(function (item, index) {
	                return _react2.default.createElement(_ListItemField2.default, (0, _extends3.default)({
	                    key: index,
	                    label: null,
	                    name: (0, _joinName2.default)(name, index),
	                    removeIcon: removeIcon
	                }, itemProps));
	            })
	        )
	    );
	};
	
	exports.default = (0, _connectField2.default)(List, { ensureValue: true, includeInChain: false });

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/ListAddField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _filterDOMProps = __webpack_require__("./node_modules/uniforms/filterDOMProps.js");
	
	var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListAdd = function ListAdd(_ref) {
	    var addIcon = _ref.addIcon,
	        className = _ref.className,
	        disabled = _ref.disabled,
	        parent = _ref.parent,
	        value = _ref.value,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['addIcon', 'className', 'disabled', 'parent', 'value']);
	
	    var limitNotReached = !disabled && !(parent.maxCount <= parent.value.length);
	
	    return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({
	            className: (0, _classnames2.default)('badge pull-right', className),
	            onClick: function onClick() {
	                return limitNotReached && parent.onChange(parent.value.concat([value]));
	            }
	        }, (0, _filterDOMProps2.default)(props)),
	        addIcon
	    );
	};
	
	ListAdd.defaultProps = { addIcon: _react2.default.createElement('i', { className: 'glyphicon glyphicon-plus' }) };
	
	exports.default = (0, _connectField2.default)(ListAdd, { includeParent: true, initialValue: false });

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/ListItemField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _joinName = __webpack_require__("./node_modules/uniforms/joinName.js");
	
	var _joinName2 = _interopRequireDefault(_joinName);
	
	var _AutoField = __webpack_require__("./node_modules/uniforms-bootstrap3/AutoField.js");
	
	var _AutoField2 = _interopRequireDefault(_AutoField);
	
	var _ListDelField = __webpack_require__("./node_modules/uniforms-bootstrap3/ListDelField.js");
	
	var _ListDelField2 = _interopRequireDefault(_ListDelField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListItem = function ListItem(_ref) {
	    var removeIcon = _ref.removeIcon,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['removeIcon']);
	    return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-xs-1' },
	            _react2.default.createElement(_ListDelField2.default, { name: props.name, removeIcon: removeIcon })
	        ),
	        props.children ? _react.Children.map(props.children, function (child) {
	            return _react2.default.cloneElement(child, {
	                className: 'col-xs-11',
	                name: (0, _joinName2.default)(props.name, child.props.name),
	                label: null
	            });
	        }) : _react2.default.createElement(_AutoField2.default, (0, _extends3.default)({}, props, { className: 'col-xs-11' }))
	    );
	};
	
	exports.default = (0, _connectField2.default)(ListItem, { includeInChain: false, includeParent: true });

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/ListDelField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _filterDOMProps = __webpack_require__("./node_modules/uniforms/filterDOMProps.js");
	
	var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListDel = function ListDel(_ref) {
	    var className = _ref.className,
	        disabled = _ref.disabled,
	        name = _ref.name,
	        parent = _ref.parent,
	        removeIcon = _ref.removeIcon,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['className', 'disabled', 'name', 'parent', 'removeIcon']);
	
	    var fieldIndex = +name.slice(1 + name.lastIndexOf('.'));
	    var limitNotReached = !disabled && !(parent.minCount >= parent.value.length);
	
	    return _react2.default.createElement(
	        'span',
	        (0, _extends3.default)({
	            className: (0, _classnames2.default)('badge', className),
	            onClick: function onClick() {
	                return limitNotReached && parent.onChange([].concat(parent.value.slice(0, fieldIndex)).concat(parent.value.slice(1 + fieldIndex)));
	            }
	        }, (0, _filterDOMProps2.default)(props)),
	        removeIcon
	    );
	};
	
	ListDel.defaultProps = { removeIcon: _react2.default.createElement('i', { className: 'glyphicon glyphicon-minus' }) };
	
	exports.default = (0, _connectField2.default)(ListDel, { includeParent: true, initialValue: false });

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/NestField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _filterDOMProps = __webpack_require__("./node_modules/uniforms/filterDOMProps.js");
	
	var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);
	
	var _injectName = __webpack_require__("./node_modules/uniforms/injectName.js");
	
	var _injectName2 = _interopRequireDefault(_injectName);
	
	var _joinName = __webpack_require__("./node_modules/uniforms/joinName.js");
	
	var _joinName2 = _interopRequireDefault(_joinName);
	
	var _AutoField = __webpack_require__("./node_modules/uniforms-bootstrap3/AutoField.js");
	
	var _AutoField2 = _interopRequireDefault(_AutoField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Nest = function Nest(_ref) {
	    var children = _ref.children,
	        className = _ref.className,
	        error = _ref.error,
	        errorMessage = _ref.errorMessage,
	        fields = _ref.fields,
	        itemProps = _ref.itemProps,
	        label = _ref.label,
	        name = _ref.name,
	        showInlineError = _ref.showInlineError,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['children', 'className', 'error', 'errorMessage', 'fields', 'itemProps', 'label', 'name', 'showInlineError']);
	    return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ className: (0, _classnames2.default)(className, { 'has-error': error }) }, (0, _filterDOMProps2.default)(props)),
	        label && _react2.default.createElement(
	            'label',
	            null,
	            label
	        ),
	        !!(error && showInlineError) && _react2.default.createElement(
	            'span',
	            { className: 'help-block' },
	            errorMessage
	        ),
	        children ? (0, _injectName2.default)(name, children) : fields.map(function (key) {
	            return _react2.default.createElement(_AutoField2.default, (0, _extends3.default)({ key: key, name: (0, _joinName2.default)(name, key) }, itemProps));
	        })
	    );
	};
	
	exports.default = (0, _connectField2.default)(Nest, { ensureValue: false, includeInChain: false });

/***/ },

/***/ "./node_modules/uniforms/injectName.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = injectName;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _joinName = __webpack_require__("./node_modules/uniforms/joinName.js");
	
	var _joinName2 = _interopRequireDefault(_joinName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function injectName(name, children, parent) {
	    return _react.Children.map(children, function (child) {
	        return child && typeof child !== 'string' && (!parent || !parent.props || !parent.props.name) ? !child.props ? _react2.default.cloneElement(child, { name: name }) : _react2.default.cloneElement(child, {
	            name: (0, _joinName2.default)(name, child.props.name),
	            children: injectName(name, child.props.children, child)
	        }) : child;
	    });
	}

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/TextField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _wrapField = __webpack_require__("./node_modules/uniforms-bootstrap3/wrapField.js");
	
	var _wrapField2 = _interopRequireDefault(_wrapField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Text = function Text(props) {
	    return (0, _wrapField2.default)((0, _extends3.default)({ feedbackable: true }, props), _react2.default.createElement('input', {
	        className: (0, _classnames2.default)(props.inputClassName, 'form-control', { 'form-control-danger': props.error }),
	        disabled: props.disabled,
	        id: props.id,
	        name: props.name,
	        onChange: function onChange(event) {
	            return props.onChange(event.target.value);
	        },
	        placeholder: props.placeholder,
	        ref: props.inputRef,
	        type: props.type,
	        value: props.value
	    }));
	};
	
	Text.defaultProps = { type: 'text' };
	
	exports.default = (0, _connectField2.default)(Text);

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/RadioField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _wrapField = __webpack_require__("./node_modules/uniforms-bootstrap3/wrapField.js");
	
	var _wrapField2 = _interopRequireDefault(_wrapField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Radio = function Radio(props) {
	    return (0, _wrapField2.default)(props, props.allowedValues.map(function (item) {
	        return _react2.default.createElement(
	            'div',
	            { key: item, className: (0, _classnames2.default)(props.inputClassName, 'radio' + (props.inline ? '-inline' : '')) },
	            _react2.default.createElement(
	                'label',
	                { htmlFor: props.id + '-' + item },
	                _react2.default.createElement('input', {
	                    checked: item === props.value,
	                    disabled: props.disabled,
	                    id: props.id + '-' + item,
	                    name: props.name,
	                    onChange: function onChange() {
	                        return props.onChange(item);
	                    },
	                    type: 'radio'
	                }),
	                props.transform ? props.transform(item) : item
	            )
	        );
	    }));
	};
	
	exports.default = (0, _connectField2.default)(Radio);

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/SelectField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _wrapField = __webpack_require__("./node_modules/uniforms-bootstrap3/wrapField.js");
	
	var _wrapField2 = _interopRequireDefault(_wrapField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var xor = function xor(item, array) {
	    var index = array.indexOf(item);
	    if (index === -1) {
	        return array.concat([item]);
	    }
	
	    return array.slice(0, index).concat(array.slice(index + 1));
	};
	
	var renderCheckboxes = function renderCheckboxes(props) {
	    return props.allowedValues.map(function (item) {
	        return _react2.default.createElement(
	            'div',
	            { key: item, className: (0, _classnames2.default)(props.inputClassName, 'checkbox' + (props.inline ? '-inline' : '')) },
	            _react2.default.createElement(
	                'label',
	                { htmlFor: props.id + '-' + item },
	                _react2.default.createElement('input', {
	                    checked: props.fieldType === Array ? props.value.includes(item) : props.value === item,
	                    disabled: props.disabled,
	                    id: props.id + '-' + item,
	                    name: props.name,
	                    onChange: function onChange() {
	                        return props.onChange(props.fieldType === Array ? xor(item, props.value) : item);
	                    },
	                    type: 'checkbox'
	                }),
	                props.transform ? props.transform(item) : item
	            )
	        );
	    });
	};
	
	var renderSelect = function renderSelect(props) {
	    return _react2.default.createElement(
	        'select',
	        {
	            className: (0, _classnames2.default)(props.inputClassName, 'form-control', { 'form-control-danger': props.error }),
	            disabled: props.disabled,
	            id: props.id,
	            name: props.name,
	            onChange: function onChange(event) {
	                return props.onChange(event.target.value);
	            },
	            ref: props.inputRef,
	            value: props.value
	        },
	        (!!props.placeholder || !props.required) && _react2.default.createElement(
	            'option',
	            { value: '', disabled: props.required, hidden: props.required },
	            props.placeholder ? props.placeholder : props.label
	        ),
	        props.allowedValues.map(function (value) {
	            return _react2.default.createElement(
	                'option',
	                { key: value, value: value },
	                props.transform ? props.transform(value) : value
	            );
	        })
	    );
	};
	
	var Select = function Select(props) {
	    return (0, _wrapField2.default)(props, props.checkboxes || props.fieldType === Array ? renderCheckboxes(props) : renderSelect(props));
	};
	
	exports.default = (0, _connectField2.default)(Select);

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/AutoForm.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _AutoForm = __webpack_require__("./node_modules/uniforms/AutoForm.js");
	
	var _AutoForm2 = _interopRequireDefault(_AutoForm);
	
	var _ValidatedQuickForm = __webpack_require__("./node_modules/uniforms-bootstrap3/ValidatedQuickForm.js");
	
	var _ValidatedQuickForm2 = _interopRequireDefault(_ValidatedQuickForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Auto = function Auto(parent) {
	    var _class, _temp;
	
	    return _temp = _class = function (_AutoForm$Auto) {
	        (0, _inherits3.default)(_class, _AutoForm$Auto);
	
	        function _class() {
	            (0, _classCallCheck3.default)(this, _class);
	            return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	        }
	
	        return _class;
	    }(_AutoForm2.default.Auto(parent)), _class.Auto = Auto, _temp;
	};
	
	exports.default = Auto(_ValidatedQuickForm2.default);

/***/ },

/***/ "./node_modules/uniforms/AutoForm.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__("./node_modules/babel-runtime/helpers/get.js");
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cloneDeep = __webpack_require__("./node_modules/lodash/cloneDeep.js");
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _isEqual = __webpack_require__("./node_modules/lodash/isEqual.js");
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _set = __webpack_require__("./node_modules/lodash/set.js");
	
	var _set2 = _interopRequireDefault(_set);
	
	var _ValidatedQuickForm = __webpack_require__("./node_modules/uniforms/ValidatedQuickForm.js");
	
	var _ValidatedQuickForm2 = _interopRequireDefault(_ValidatedQuickForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Auto = function Auto(parent) {
	    var _class, _temp;
	
	    return _temp = _class = function (_parent) {
	        (0, _inherits3.default)(_class, _parent);
	
	        function _class() {
	            (0, _classCallCheck3.default)(this, _class);
	
	            var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	
	            _this.state = (0, _extends3.default)({}, _this.state, {
	
	                model: _this.props.model,
	                modelSync: _this.props.model
	            });
	            return _this;
	        }
	
	        (0, _createClass3.default)(_class, [{
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(_ref) {
	                var model = _ref.model;
	
	                (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'componentWillReceiveProps', this).apply(this, arguments);
	
	                if (!(0, _isEqual2.default)(this.props.model, model)) {
	                    this.setState(function () {
	                        return { model: model, modelSync: model };
	                    });
	                }
	            }
	        }, {
	            key: 'getNativeFormProps',
	            value: function getNativeFormProps() {
	                var _get$call = (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'getNativeFormProps', this).call(this),
	                    onChangeModel = _get$call.onChangeModel,
	                    props = (0, _objectWithoutProperties3.default)(_get$call, ['onChangeModel']);
	
	                return props;
	            }
	        }, {
	            key: 'getModel',
	            value: function getModel(mode) {
	                return mode === 'form' ? this.state.modelSync : this.state.model;
	            }
	        }, {
	            key: 'onChange',
	            value: function onChange(key, value) {
	                var _this2 = this,
	                    _arguments = arguments;
	
	                var updateState = function updateState(state) {
	                    return { modelSync: (0, _set2.default)((0, _cloneDeep2.default)(state.modelSync), key, value) };
	                };
	                var updateModel = function updateModel(state) {
	                    if (_this2.props.onChangeModel) {
	                        _this2.props.onChangeModel(state.modelSync);
	                    }
	
	                    return { model: state.modelSync };
	                };
	
	                // Before componentDidMount, every call to onChange should call BaseForm#onChange synchronously
	                if (this.state.changed === null) {
	                    this.setState(updateState);
	                    (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'onChange', this).apply(this, arguments);
	                    this.setState(updateModel);
	                } else {
	                    this.setState(updateState, function () {
	                        (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'onChange', _this2).apply(_this2, _arguments);
	                        _this2.setState(updateModel);
	                    });
	                }
	            }
	        }, {
	            key: 'onReset',
	            value: function onReset() {
	                var _this3 = this;
	
	                this.setState(function () {
	                    (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'onReset', _this3).call(_this3);
	
	                    return {
	                        model: _this3.props.model,
	                        modelSync: _this3.props.model
	                    };
	                });
	            }
	        }, {
	            key: 'onValidate',
	            value: function onValidate() {
	                return this.onValidateModel(this.getChildContextModel());
	            }
	        }]);
	        return _class;
	    }(parent), _class.Auto = Auto, _class.displayName = 'Auto' + parent.displayName, _class.propTypes = (0, _extends3.default)({}, parent.propTypes, {
	
	        onChangeModel: _propTypes2.default.func
	    }), _temp;
	};
	
	exports.default = Auto(_ValidatedQuickForm2.default);

/***/ },

/***/ "./node_modules/uniforms/ValidatedQuickForm.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseForm = __webpack_require__("./node_modules/uniforms/BaseForm.js");
	
	var _BaseForm2 = _interopRequireDefault(_BaseForm);
	
	var _QuickForm = __webpack_require__("./node_modules/uniforms/QuickForm.js");
	
	var _QuickForm2 = _interopRequireDefault(_QuickForm);
	
	var _ValidatedForm = __webpack_require__("./node_modules/uniforms/ValidatedForm.js");
	
	var _ValidatedForm2 = _interopRequireDefault(_ValidatedForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ValidatedForm2.default.Validated(_QuickForm2.default.Quick(_BaseForm2.default));

/***/ },

/***/ "./node_modules/uniforms/QuickForm.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__("./node_modules/babel-runtime/helpers/get.js");
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BaseForm = __webpack_require__("./node_modules/uniforms/BaseForm.js");
	
	var _BaseForm2 = _interopRequireDefault(_BaseForm);
	
	var _nothing = __webpack_require__("./node_modules/uniforms/nothing.js");
	
	var _nothing2 = _interopRequireDefault(_nothing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Quick = function Quick(parent) {
	    var _class, _temp;
	
	    return _temp = _class = function (_parent) {
	        (0, _inherits3.default)(_class, _parent);
	
	        function _class() {
	            (0, _classCallCheck3.default)(this, _class);
	            return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	        }
	
	        (0, _createClass3.default)(_class, [{
	            key: 'getNativeFormProps',
	            value: function getNativeFormProps() {
	                var _get$call = (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'getNativeFormProps', this).call(this),
	                    autoField = _get$call.autoField,
	                    errorsField = _get$call.errorsField,
	                    submitField = _get$call.submitField,
	                    props = (0, _objectWithoutProperties3.default)(_get$call, ['autoField', 'errorsField', 'submitField']);
	
	                return props;
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var nativeFormProps = this.getNativeFormProps();
	                if (nativeFormProps.children) {
	                    return (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'render', this).call(this);
	                }
	
	                var AutoField = this.props.autoField || this.getAutoField();
	                var ErrorsField = this.props.errorsField || this.getErrorsField();
	                var SubmitField = this.props.submitField || this.getSubmitField();
	
	                return _react2.default.createElement(
	                    'form',
	                    nativeFormProps,
	                    this.getChildContextSchema().getSubfields().map(function (key) {
	                        return _react2.default.createElement(AutoField, { key: key, name: key });
	                    }),
	                    _react2.default.createElement(ErrorsField, null),
	                    _react2.default.createElement(SubmitField, null)
	                );
	            }
	        }, {
	            key: 'getAutoField',
	            value: function getAutoField() {
	                return function () {
	                    return _nothing2.default;
	                };
	            }
	        }, {
	            key: 'getErrorsField',
	            value: function getErrorsField() {
	                return function () {
	                    return _nothing2.default;
	                };
	            }
	        }, {
	            key: 'getSubmitField',
	            value: function getSubmitField() {
	                return function () {
	                    return _nothing2.default;
	                };
	            }
	        }]);
	        return _class;
	    }(parent), _class.Quick = Quick, _class.displayName = 'Quick' + parent.displayName, _class.propTypes = (0, _extends3.default)({}, parent.propTypes, {
	
	        autoField: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	        errorsField: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	        submitField: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	    }), _temp;
	};
	
	exports.default = Quick(_BaseForm2.default);

/***/ },

/***/ "./node_modules/uniforms/nothing.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// React < 15 workaround
	// https://github.com/vazco/uniforms/issues/42
	// https://github.com/facebook/react/issues/5355
	exports.default = parseInt(_react2.default.version, 10) < 15 ? _react2.default.createElement('noscript', null) : null;

/***/ },

/***/ "./node_modules/uniforms/ValidatedForm.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__("./node_modules/babel-runtime/helpers/get.js");
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cloneDeep = __webpack_require__("./node_modules/lodash/cloneDeep.js");
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _isEqual = __webpack_require__("./node_modules/lodash/isEqual.js");
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _set = __webpack_require__("./node_modules/lodash/set.js");
	
	var _set2 = _interopRequireDefault(_set);
	
	var _BaseForm = __webpack_require__("./node_modules/uniforms/BaseForm.js");
	
	var _BaseForm2 = _interopRequireDefault(_BaseForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Validated = function Validated(parent) {
	    var _class, _temp;
	
	    return _temp = _class = function (_parent) {
	        (0, _inherits3.default)(_class, _parent);
	
	        function _class() {
	            (0, _classCallCheck3.default)(this, _class);
	
	            var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	
	            _this.state = (0, _extends3.default)({}, _this.state, {
	
	                error: null,
	                validate: false,
	                validator: _this.getChildContextSchema().getValidator(_this.props.validator)
	            });
	
	            _this.onValidate = _this.validate = _this.onValidate.bind(_this);
	            _this.onValidateModel = _this.validateModel = _this.onValidateModel.bind(_this);
	            return _this;
	        }
	
	        (0, _createClass3.default)(_class, [{
	            key: 'getChildContextError',
	            value: function getChildContextError() {
	                return (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'getChildContextError', this).call(this) || this.state.error;
	            }
	        }, {
	            key: 'getNativeFormProps',
	            value: function getNativeFormProps() {
	                var _get$call = (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'getNativeFormProps', this).call(this),
	                    onValidate = _get$call.onValidate,
	                    validator = _get$call.validator,
	                    validate = _get$call.validate,
	                    props = (0, _objectWithoutProperties3.default)(_get$call, ['onValidate', 'validator', 'validate']);
	
	                return props;
	            }
	        }, {
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(_ref) {
	                var _this2 = this;
	
	                var model = _ref.model,
	                    schema = _ref.schema,
	                    validate = _ref.validate,
	                    validator = _ref.validator;
	
	                (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'componentWillReceiveProps', this).apply(this, arguments);
	
	                if (this.props.schema !== schema || this.props.validator !== validator) {
	                    this.setState(function (_ref2) {
	                        var bridge = _ref2.bridge;
	                        return {
	                            validator: bridge.getValidator(validator)
	                        };
	                    }, function () {
	                        if (validate === 'onChange' || validate === 'onChangeAfterSubmit' && _this2.state.validate) {
	                            _this2.onValidate();
	                        }
	                    });
	                } else if (!(0, _isEqual2.default)(this.props.model, model)) {
	                    if (validate === 'onChange' || validate === 'onChangeAfterSubmit' && this.state.validate) {
	                        this.onValidateModel(model);
	                    }
	                }
	            }
	        }, {
	            key: 'onChange',
	            value: function onChange(key, value) {
	                // eslint-disable-next-line max-len
	                if (this.props.validate === 'onChange' || this.props.validate === 'onChangeAfterSubmit' && this.state.validate) {
	                    this.onValidate(key, value).catch(function () {});
	                }
	
	                // FIXME: https://github.com/vazco/uniforms/issues/293
	                // if (this.props.validate === 'onSubmit' && this.state.validate) {
	                //     this.setState(() => ({error: null}));
	                // }
	
	                (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'onChange', this).apply(this, arguments);
	            }
	        }, {
	            key: 'onReset',
	            value: function onReset() {
	                (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'onReset', this).call(this);
	                this.setState(function () {
	                    return { error: null, validate: false };
	                });
	            }
	        }, {
	            key: 'onSubmit',
	            value: function onSubmit(event) {
	                var _this3 = this;
	
	                if (event) {
	                    event.preventDefault();
	                    event.stopPropagation();
	                }
	
	                var promise = new Promise(function (resolve, reject) {
	                    _this3.setState(function () {
	                        return { validate: true };
	                    }, function () {
	                        _this3.onValidate().then(function () {
	                            (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'onSubmit', _this3).call(_this3).then(resolve, function (error) {
	                                _this3.setState({ error: error });
	                                reject(error);
	                            });
	                        }, reject);
	                    });
	                });
	
	                // NOTE: It's okay for this Promise to reject.
	                promise.catch(function () {});
	
	                return promise;
	            }
	        }, {
	            key: 'onValidate',
	            value: function onValidate(key, value) {
	                var model = this.getChildContextModel();
	                if (model && key) {
	                    model = (0, _set2.default)((0, _cloneDeep2.default)(model), key, (0, _cloneDeep2.default)(value));
	                }
	
	                return this.onValidateModel(model);
	            }
	        }, {
	            key: 'onValidateModel',
	            value: function onValidateModel(model) {
	                var _this4 = this;
	
	                model = this.getModel('validate', model);
	
	                var catched = this.props.error || null;
	                try {
	                    this.state.validator(model);
	                } catch (error) {
	                    catched = error;
	                }
	
	                return new Promise(function (resolve, reject) {
	                    _this4.props.onValidate(model, catched, function () {
	                        var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : catched;
	
	                        // Do not copy error from props to state.
	                        _this4.setState(function () {
	                            return { error: error === _this4.props.error ? null : error };
	                        }, function () {
	                            if (error) {
	                                reject(error);
	                            } else {
	                                resolve();
	                            }
	                        });
	                    });
	                });
	            }
	        }]);
	        return _class;
	    }(parent), _class.Validated = Validated, _class.displayName = 'Validated' + parent.displayName, _class.defaultProps = (0, _extends3.default)({}, parent.defaultProps, {
	        onValidate: function onValidate(model, error, callback) {
	            callback();
	        },
	
	
	        validate: 'onChangeAfterSubmit'
	    }), _class.propTypes = (0, _extends3.default)({}, parent.propTypes, {
	
	        onValidate: _propTypes2.default.func.isRequired,
	
	        validator: _propTypes2.default.any,
	        validate: _propTypes2.default.oneOf(['onChange', 'onChangeAfterSubmit', 'onSubmit']).isRequired
	    }), _temp;
	};
	
	exports.default = Validated(_BaseForm2.default);

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/ValidatedQuickForm.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseForm = __webpack_require__("./node_modules/uniforms-bootstrap3/BaseForm.js");
	
	var _BaseForm2 = _interopRequireDefault(_BaseForm);
	
	var _QuickForm = __webpack_require__("./node_modules/uniforms-bootstrap3/QuickForm.js");
	
	var _QuickForm2 = _interopRequireDefault(_QuickForm);
	
	var _ValidatedForm = __webpack_require__("./node_modules/uniforms-bootstrap3/ValidatedForm.js");
	
	var _ValidatedForm2 = _interopRequireDefault(_ValidatedForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ValidatedForm2.default.Validated(_QuickForm2.default.Quick(_BaseForm2.default));

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/BaseForm.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__("./node_modules/babel-runtime/helpers/get.js");
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _BaseForm = __webpack_require__("./node_modules/uniforms/BaseForm.js");
	
	var _BaseForm2 = _interopRequireDefault(_BaseForm);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bootstrap3 = function Bootstrap3(parent) {
	    var _class, _temp;
	
	    return _temp = _class = function (_parent) {
	        (0, _inherits3.default)(_class, _parent);
	
	        function _class() {
	            (0, _classCallCheck3.default)(this, _class);
	            return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	        }
	
	        (0, _createClass3.default)(_class, [{
	            key: 'getChildContextState',
	            value: function getChildContextState() {
	                return (0, _extends3.default)({}, (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'getChildContextState', this).call(this), {
	                    grid: this.props.grid
	                });
	            }
	        }, {
	            key: 'getNativeFormProps',
	            value: function getNativeFormProps() {
	                var error = this.getChildContextError();
	
	                var _get$call = (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'getNativeFormProps', this).call(this),
	                    className = _get$call.className,
	                    grid = _get$call.grid,
	                    props = (0, _objectWithoutProperties3.default)(_get$call, ['className', 'grid']);
	
	                return (0, _extends3.default)({}, props, {
	                    className: (0, _classnames2.default)('form', { error: error, 'form-horizontal': grid }, className)
	                });
	            }
	        }]);
	        return _class;
	    }(parent), _class.Bootstrap3 = Bootstrap3, _class.displayName = 'Bootstrap3' + parent.displayName, _class.propTypes = (0, _extends3.default)({}, parent.propTypes, {
	
	        grid: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.string])
	    }), _temp;
	};
	
	exports.default = Bootstrap3(_BaseForm2.default);

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/QuickForm.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _QuickForm = __webpack_require__("./node_modules/uniforms/QuickForm.js");
	
	var _QuickForm2 = _interopRequireDefault(_QuickForm);
	
	var _BaseForm = __webpack_require__("./node_modules/uniforms-bootstrap3/BaseForm.js");
	
	var _BaseForm2 = _interopRequireDefault(_BaseForm);
	
	var _AutoField = __webpack_require__("./node_modules/uniforms-bootstrap3/AutoField.js");
	
	var _AutoField2 = _interopRequireDefault(_AutoField);
	
	var _ErrorsField = __webpack_require__("./node_modules/uniforms-bootstrap3/ErrorsField.js");
	
	var _ErrorsField2 = _interopRequireDefault(_ErrorsField);
	
	var _SubmitField = __webpack_require__("./node_modules/uniforms-bootstrap3/SubmitField.js");
	
	var _SubmitField2 = _interopRequireDefault(_SubmitField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Quick = function Quick(parent) {
	    var _class, _temp;
	
	    return _temp = _class = function (_QuickForm$Quick) {
	        (0, _inherits3.default)(_class, _QuickForm$Quick);
	
	        function _class() {
	            (0, _classCallCheck3.default)(this, _class);
	            return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	        }
	
	        (0, _createClass3.default)(_class, [{
	            key: 'getAutoField',
	            value: function getAutoField() {
	                return _AutoField2.default;
	            }
	        }, {
	            key: 'getErrorsField',
	            value: function getErrorsField() {
	                return _ErrorsField2.default;
	            }
	        }, {
	            key: 'getSubmitField',
	            value: function getSubmitField() {
	                return _SubmitField2.default;
	            }
	        }]);
	        return _class;
	    }(_QuickForm2.default.Quick(parent)), _class.Quick = Quick, _temp;
	};
	
	exports.default = Quick(_BaseForm2.default);

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/ErrorsField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _BaseField = __webpack_require__("./node_modules/uniforms/BaseField.js");
	
	var _BaseField2 = _interopRequireDefault(_BaseField);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _filterDOMProps = __webpack_require__("./node_modules/uniforms/filterDOMProps.js");
	
	var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);
	
	var _nothing = __webpack_require__("./node_modules/uniforms/nothing.js");
	
	var _nothing2 = _interopRequireDefault(_nothing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrorsField = function ErrorsField(_ref, _ref2) {
	    var _ref2$uniforms = _ref2.uniforms,
	        error = _ref2$uniforms.error,
	        schema = _ref2$uniforms.schema;
	    var className = _ref.className,
	        children = _ref.children,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['className', 'children']);
	    return !error && !children ? _nothing2.default : _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ className: (0, _classnames2.default)('panel panel-danger', className) }, (0, _filterDOMProps2.default)(props)),
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-body' },
	            children,
	            schema.getErrorMessages(error).map(function (message, index) {
	                return _react2.default.createElement(
	                    'div',
	                    { key: index },
	                    message
	                );
	            })
	        )
	    );
	};
	
	ErrorsField.contextTypes = _BaseField2.default.contextTypes;
	
	exports.default = ErrorsField;

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/SubmitField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _BaseField = __webpack_require__("./node_modules/uniforms/BaseField.js");
	
	var _BaseField2 = _interopRequireDefault(_BaseField);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _filterDOMProps = __webpack_require__("./node_modules/uniforms/filterDOMProps.js");
	
	var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);
	
	var _gridClassName = __webpack_require__("./node_modules/uniforms-bootstrap3/gridClassName.js");
	
	var _gridClassName2 = _interopRequireDefault(_gridClassName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubmitField = function SubmitField(_ref, _ref2) {
	    var _ref2$uniforms = _ref2.uniforms,
	        error = _ref2$uniforms.error,
	        state = _ref2$uniforms.state;
	    var className = _ref.className,
	        disabled = _ref.disabled,
	        inputClassName = _ref.inputClassName,
	        inputRef = _ref.inputRef,
	        value = _ref.value,
	        wrapClassName = _ref.wrapClassName,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['className', 'disabled', 'inputClassName', 'inputRef', 'value', 'wrapClassName']);
	
	    var hasWrap = !!(state.grid || wrapClassName);
	
	    var blockInput = _react2.default.createElement('input', {
	        className: inputClassName,
	        disabled: disabled === undefined ? !!(error || state.disabled) : disabled,
	        ref: inputRef,
	        type: 'submit',
	        value: value
	    });
	
	    return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ className: (0, _classnames2.default)(className, { 'has-danger': error, row: state.grid }) }, (0, _filterDOMProps2.default)(props)),
	        hasWrap && _react2.default.createElement(
	            'label',
	            { className: (0, _classnames2.default)('form-control-label', (0, _gridClassName2.default)(state.grid, 'label')) },
	            '\xA0'
	        ),
	        hasWrap && _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(wrapClassName, (0, _gridClassName2.default)(state.grid, 'input')) },
	            blockInput
	        ),
	        !hasWrap && blockInput
	    );
	};
	
	SubmitField.contextTypes = _BaseField2.default.contextTypes;
	SubmitField.defaultProps = { inputClassName: 'btn btn-primary' };
	
	exports.default = SubmitField;

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/ValidatedForm.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _ValidatedForm = __webpack_require__("./node_modules/uniforms/ValidatedForm.js");
	
	var _ValidatedForm2 = _interopRequireDefault(_ValidatedForm);
	
	var _BaseForm = __webpack_require__("./node_modules/uniforms-bootstrap3/BaseForm.js");
	
	var _BaseForm2 = _interopRequireDefault(_BaseForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Validated = function Validated(parent) {
	    var _class, _temp;
	
	    return _temp = _class = function (_ValidatedForm$Valida) {
	        (0, _inherits3.default)(_class, _ValidatedForm$Valida);
	
	        function _class() {
	            (0, _classCallCheck3.default)(this, _class);
	            return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	        }
	
	        return _class;
	    }(_ValidatedForm2.default.Validated(parent)), _class.Validated = Validated, _temp;
	};
	
	exports.default = Validated(_BaseForm2.default);

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/ErrorField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _filterDOMProps = __webpack_require__("./node_modules/uniforms/filterDOMProps.js");
	
	var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);
	
	var _nothing = __webpack_require__("./node_modules/uniforms/nothing.js");
	
	var _nothing2 = _interopRequireDefault(_nothing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Error = function Error(_ref) {
	    var children = _ref.children,
	        className = _ref.className,
	        error = _ref.error,
	        errorMessage = _ref.errorMessage,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['children', 'className', 'error', 'errorMessage']);
	    return !error ? _nothing2.default : _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ className: (0, _classnames2.default)('panel panel-danger text-danger', className) }, (0, _filterDOMProps2.default)(props)),
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-body' },
	            children ? children : _react2.default.createElement(
	                'div',
	                { className: 'panel-heading' },
	                _react2.default.createElement(
	                    'h4',
	                    { className: 'panel-title' },
	                    errorMessage
	                )
	            )
	        )
	    );
	};
	
	exports.default = (0, _connectField2.default)(Error, { initialValue: false });

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/FormGroup.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _wrapField = __webpack_require__("./node_modules/uniforms-bootstrap3/wrapField.js");
	
	var _wrapField2 = _interopRequireDefault(_wrapField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormGroup = function FormGroup(_ref) {
	    var children = _ref.children,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['children']);
	
	    (0, _warning2.default)(false, 'FormGroup is deprecated and will be removed in the next release.');
	
	    return (0, _wrapField2.default)(props, children);
	};
	
	exports.default = FormGroup;

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/HiddenField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _BaseField2 = __webpack_require__("./node_modules/uniforms/BaseField.js");
	
	var _BaseField3 = _interopRequireDefault(_BaseField2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _filterDOMProps = __webpack_require__("./node_modules/uniforms/filterDOMProps.js");
	
	var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);
	
	var _nothing = __webpack_require__("./node_modules/uniforms/nothing.js");
	
	var _nothing2 = _interopRequireDefault(_nothing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HiddenField = function (_BaseField) {
	    (0, _inherits3.default)(HiddenField, _BaseField);
	
	    function HiddenField() {
	        (0, _classCallCheck3.default)(this, HiddenField);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (HiddenField.__proto__ || Object.getPrototypeOf(HiddenField)).apply(this, arguments));
	
	        _this.options = {
	            ensureValue: true,
	            overrideValue: true
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(HiddenField, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var valueDesired = _ref.value;
	
	            if (valueDesired === undefined) {
	                return;
	            }
	
	            var props = this.getFieldProps();
	            if (props.value !== valueDesired) {
	                props.onChange(valueDesired);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var props = this.getFieldProps();
	
	            return props.noDOM ? _nothing2.default : _react2.default.createElement('input', (0, _extends3.default)({
	                disabled: props.disabled,
	                id: props.id,
	                name: props.name,
	                ref: props.inputRef,
	                type: 'hidden',
	                value: props.value
	            }, (0, _filterDOMProps2.default)(props)));
	        }
	    }]);
	    return HiddenField;
	}(_BaseField3.default);
	
	HiddenField.displayName = 'HiddenField';
	exports.default = HiddenField;

/***/ },

/***/ "./node_modules/uniforms-bootstrap3/LongTextField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _wrapField = __webpack_require__("./node_modules/uniforms-bootstrap3/wrapField.js");
	
	var _wrapField2 = _interopRequireDefault(_wrapField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LongText = function LongText(props) {
	    return (0, _wrapField2.default)(props, _react2.default.createElement('textarea', {
	        className: (0, _classnames2.default)(props.inputClassName, 'form-control', { 'form-control-danger': props.error }),
	        disabled: props.disabled,
	        id: props.id,
	        name: props.name,
	        onChange: function onChange(event) {
	            return props.onChange(event.target.value);
	        },
	        placeholder: props.placeholder,
	        ref: props.inputRef,
	        value: props.value
	    }));
	};
	
	exports.default = (0, _connectField2.default)(LongText);

/***/ },

/***/ "./node_modules/moment/moment.js":
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.20.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    if (Object.getOwnPropertyNames) {
	        return (Object.getOwnPropertyNames(obj).length === 0);
	    } else {
	        var k;
	        for (k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                return false;
	            }
	        }
	        return true;
	    }
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.weekdayMismatch &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid() && !isNaN(value)) {
	        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	        }
	        else {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function mod(n, x) {
	    return ((n % x) + x) % x;
	}
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	function daysInMonth(year, month) {
	    if (isNaN(year) || isNaN(month)) {
	        return NaN;
	    }
	    var modMonth = mod(month, 12);
	    year += (month - modMonth) / 12;
	    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            var aliasedRequire = require;
	            __webpack_require__(2)("./" + name);
	            getSetGlobalLocale(oldLocale);
	        } catch (e) {}
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, tmpLocale, parentConfig = baseConfig;
	        // MERGE
	        tmpLocale = loadLocale(name);
	        if (tmpLocale != null) {
	            parentConfig = tmpLocale._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	
	    // check for mismatching day of week
	    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	        getParsingFlags(config).weekdayMismatch = true;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	    var result = [
	        untruncateYear(yearStr),
	        defaultLocaleMonthsShort.indexOf(monthStr),
	        parseInt(dayStr, 10),
	        parseInt(hourStr, 10),
	        parseInt(minuteStr, 10)
	    ];
	
	    if (secondStr) {
	        result.push(parseInt(secondStr, 10));
	    }
	
	    return result;
	}
	
	function untruncateYear(yearStr) {
	    var year = parseInt(yearStr, 10);
	    if (year <= 49) {
	        return 2000 + year;
	    } else if (year <= 999) {
	        return 1900 + year;
	    }
	    return year;
	}
	
	function preprocessRFC2822(s) {
	    // Remove comments and folding whitespace and replace multiple-spaces with a single space
	    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
	}
	
	function checkWeekday(weekdayStr, parsedInput, config) {
	    if (weekdayStr) {
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	        if (weekdayProvided !== weekdayActual) {
	            getParsingFlags(config).weekdayMismatch = true;
	            config._isValid = false;
	            return false;
	        }
	    }
	    return true;
	}
	
	var obsOffsets = {
	    UT: 0,
	    GMT: 0,
	    EDT: -4 * 60,
	    EST: -5 * 60,
	    CDT: -5 * 60,
	    CST: -6 * 60,
	    MDT: -6 * 60,
	    MST: -7 * 60,
	    PDT: -7 * 60,
	    PST: -8 * 60
	};
	
	function calculateOffset(obsOffset, militaryOffset, numOffset) {
	    if (obsOffset) {
	        return obsOffsets[obsOffset];
	    } else if (militaryOffset) {
	        // the only allowed military tz is Z
	        return 0;
	    } else {
	        var hm = parseInt(numOffset, 10);
	        var m = hm % 100, h = (hm - m) / 100;
	        return h * 60 + m;
	    }
	}
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var match = rfc2822.exec(preprocessRFC2822(config._i));
	    if (match) {
	        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	        if (!checkWeekday(match[1], parsedArray, config)) {
	            return;
	        }
	
	        config._a = parsedArray;
	        config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	        config._d = createUTCDate.apply(null, config._a);
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible to translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    switch (units) {
	        case 'year': output = monthDiff(this, that) / 12; break;
	        case 'month': output = monthDiff(this, that); break;
	        case 'quarter': output = monthDiff(this, that) / 3; break;
	        case 'second': output = (this - that) / 1e3; break; // 1000
	        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	        default: output = this - that;
	    }
	
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString(keepOffset) {
	    if (!this.isValid()) {
	        return null;
	    }
	    var utc = keepOffset !== true;
	    var m = utc ? this.clone().utc() : this;
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        if (utc) {
	            return this.toDate().toISOString();
	        } else {
	            return new Date(this._d.valueOf()).toISOString().replace('Z', formatMoment(m, 'Z'));
	        }
	    }
	    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0]);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function clone$1 () {
	    return createDuration(this);
	}
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function sign(x) {
	    return ((x > 0) - (x < 0)) || +x;
	}
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    var totalSign = total < 0 ? '-' : '';
	    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	    return totalSign + 'P' +
	        (Y ? ymSign + Y + 'Y' : '') +
	        (M ? ymSign + M + 'M' : '') +
	        (D ? daysSign + D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? hmsSign + h + 'H' : '') +
	        (m ? hmsSign + m + 'M' : '') +
	        (s ? hmsSign + s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.clone          = clone$1;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.20.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	// currently HTML5 input type only supports 24-hour formats
	hooks.HTML5_FMT = {
	    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	    DATE: 'YYYY-MM-DD',                             // <input type="date" />
	    TIME: 'HH:mm',                                  // <input type="time" />
	    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
	    MONTH: 'YYYY-MM'                                // <input type="month" />
	};
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ },

/***/ 2:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": "./node_modules/moment/locale/af.js",
		"./af.js": "./node_modules/moment/locale/af.js",
		"./ar": "./node_modules/moment/locale/ar.js",
		"./ar-dz": "./node_modules/moment/locale/ar-dz.js",
		"./ar-dz.js": "./node_modules/moment/locale/ar-dz.js",
		"./ar-kw": "./node_modules/moment/locale/ar-kw.js",
		"./ar-kw.js": "./node_modules/moment/locale/ar-kw.js",
		"./ar-ly": "./node_modules/moment/locale/ar-ly.js",
		"./ar-ly.js": "./node_modules/moment/locale/ar-ly.js",
		"./ar-ma": "./node_modules/moment/locale/ar-ma.js",
		"./ar-ma.js": "./node_modules/moment/locale/ar-ma.js",
		"./ar-sa": "./node_modules/moment/locale/ar-sa.js",
		"./ar-sa.js": "./node_modules/moment/locale/ar-sa.js",
		"./ar-tn": "./node_modules/moment/locale/ar-tn.js",
		"./ar-tn.js": "./node_modules/moment/locale/ar-tn.js",
		"./ar.js": "./node_modules/moment/locale/ar.js",
		"./az": "./node_modules/moment/locale/az.js",
		"./az.js": "./node_modules/moment/locale/az.js",
		"./be": "./node_modules/moment/locale/be.js",
		"./be.js": "./node_modules/moment/locale/be.js",
		"./bg": "./node_modules/moment/locale/bg.js",
		"./bg.js": "./node_modules/moment/locale/bg.js",
		"./bm": "./node_modules/moment/locale/bm.js",
		"./bm.js": "./node_modules/moment/locale/bm.js",
		"./bn": "./node_modules/moment/locale/bn.js",
		"./bn.js": "./node_modules/moment/locale/bn.js",
		"./bo": "./node_modules/moment/locale/bo.js",
		"./bo.js": "./node_modules/moment/locale/bo.js",
		"./br": "./node_modules/moment/locale/br.js",
		"./br.js": "./node_modules/moment/locale/br.js",
		"./bs": "./node_modules/moment/locale/bs.js",
		"./bs.js": "./node_modules/moment/locale/bs.js",
		"./ca": "./node_modules/moment/locale/ca.js",
		"./ca.js": "./node_modules/moment/locale/ca.js",
		"./cs": "./node_modules/moment/locale/cs.js",
		"./cs.js": "./node_modules/moment/locale/cs.js",
		"./cv": "./node_modules/moment/locale/cv.js",
		"./cv.js": "./node_modules/moment/locale/cv.js",
		"./cy": "./node_modules/moment/locale/cy.js",
		"./cy.js": "./node_modules/moment/locale/cy.js",
		"./da": "./node_modules/moment/locale/da.js",
		"./da.js": "./node_modules/moment/locale/da.js",
		"./de": "./node_modules/moment/locale/de.js",
		"./de-at": "./node_modules/moment/locale/de-at.js",
		"./de-at.js": "./node_modules/moment/locale/de-at.js",
		"./de-ch": "./node_modules/moment/locale/de-ch.js",
		"./de-ch.js": "./node_modules/moment/locale/de-ch.js",
		"./de.js": "./node_modules/moment/locale/de.js",
		"./dv": "./node_modules/moment/locale/dv.js",
		"./dv.js": "./node_modules/moment/locale/dv.js",
		"./el": "./node_modules/moment/locale/el.js",
		"./el.js": "./node_modules/moment/locale/el.js",
		"./en-au": "./node_modules/moment/locale/en-au.js",
		"./en-au.js": "./node_modules/moment/locale/en-au.js",
		"./en-ca": "./node_modules/moment/locale/en-ca.js",
		"./en-ca.js": "./node_modules/moment/locale/en-ca.js",
		"./en-gb": "./node_modules/moment/locale/en-gb.js",
		"./en-gb.js": "./node_modules/moment/locale/en-gb.js",
		"./en-ie": "./node_modules/moment/locale/en-ie.js",
		"./en-ie.js": "./node_modules/moment/locale/en-ie.js",
		"./en-nz": "./node_modules/moment/locale/en-nz.js",
		"./en-nz.js": "./node_modules/moment/locale/en-nz.js",
		"./eo": "./node_modules/moment/locale/eo.js",
		"./eo.js": "./node_modules/moment/locale/eo.js",
		"./es": "./node_modules/moment/locale/es.js",
		"./es-do": "./node_modules/moment/locale/es-do.js",
		"./es-do.js": "./node_modules/moment/locale/es-do.js",
		"./es-us": "./node_modules/moment/locale/es-us.js",
		"./es-us.js": "./node_modules/moment/locale/es-us.js",
		"./es.js": "./node_modules/moment/locale/es.js",
		"./et": "./node_modules/moment/locale/et.js",
		"./et.js": "./node_modules/moment/locale/et.js",
		"./eu": "./node_modules/moment/locale/eu.js",
		"./eu.js": "./node_modules/moment/locale/eu.js",
		"./fa": "./node_modules/moment/locale/fa.js",
		"./fa.js": "./node_modules/moment/locale/fa.js",
		"./fi": "./node_modules/moment/locale/fi.js",
		"./fi.js": "./node_modules/moment/locale/fi.js",
		"./fo": "./node_modules/moment/locale/fo.js",
		"./fo.js": "./node_modules/moment/locale/fo.js",
		"./fr": "./node_modules/moment/locale/fr.js",
		"./fr-ca": "./node_modules/moment/locale/fr-ca.js",
		"./fr-ca.js": "./node_modules/moment/locale/fr-ca.js",
		"./fr-ch": "./node_modules/moment/locale/fr-ch.js",
		"./fr-ch.js": "./node_modules/moment/locale/fr-ch.js",
		"./fr.js": "./node_modules/moment/locale/fr.js",
		"./fy": "./node_modules/moment/locale/fy.js",
		"./fy.js": "./node_modules/moment/locale/fy.js",
		"./gd": "./node_modules/moment/locale/gd.js",
		"./gd.js": "./node_modules/moment/locale/gd.js",
		"./gl": "./node_modules/moment/locale/gl.js",
		"./gl.js": "./node_modules/moment/locale/gl.js",
		"./gom-latn": "./node_modules/moment/locale/gom-latn.js",
		"./gom-latn.js": "./node_modules/moment/locale/gom-latn.js",
		"./gu": "./node_modules/moment/locale/gu.js",
		"./gu.js": "./node_modules/moment/locale/gu.js",
		"./he": "./node_modules/moment/locale/he.js",
		"./he.js": "./node_modules/moment/locale/he.js",
		"./hi": "./node_modules/moment/locale/hi.js",
		"./hi.js": "./node_modules/moment/locale/hi.js",
		"./hr": "./node_modules/moment/locale/hr.js",
		"./hr.js": "./node_modules/moment/locale/hr.js",
		"./hu": "./node_modules/moment/locale/hu.js",
		"./hu.js": "./node_modules/moment/locale/hu.js",
		"./hy-am": "./node_modules/moment/locale/hy-am.js",
		"./hy-am.js": "./node_modules/moment/locale/hy-am.js",
		"./id": "./node_modules/moment/locale/id.js",
		"./id.js": "./node_modules/moment/locale/id.js",
		"./is": "./node_modules/moment/locale/is.js",
		"./is.js": "./node_modules/moment/locale/is.js",
		"./it": "./node_modules/moment/locale/it.js",
		"./it.js": "./node_modules/moment/locale/it.js",
		"./ja": "./node_modules/moment/locale/ja.js",
		"./ja.js": "./node_modules/moment/locale/ja.js",
		"./jv": "./node_modules/moment/locale/jv.js",
		"./jv.js": "./node_modules/moment/locale/jv.js",
		"./ka": "./node_modules/moment/locale/ka.js",
		"./ka.js": "./node_modules/moment/locale/ka.js",
		"./kk": "./node_modules/moment/locale/kk.js",
		"./kk.js": "./node_modules/moment/locale/kk.js",
		"./km": "./node_modules/moment/locale/km.js",
		"./km.js": "./node_modules/moment/locale/km.js",
		"./kn": "./node_modules/moment/locale/kn.js",
		"./kn.js": "./node_modules/moment/locale/kn.js",
		"./ko": "./node_modules/moment/locale/ko.js",
		"./ko.js": "./node_modules/moment/locale/ko.js",
		"./ky": "./node_modules/moment/locale/ky.js",
		"./ky.js": "./node_modules/moment/locale/ky.js",
		"./lb": "./node_modules/moment/locale/lb.js",
		"./lb.js": "./node_modules/moment/locale/lb.js",
		"./lo": "./node_modules/moment/locale/lo.js",
		"./lo.js": "./node_modules/moment/locale/lo.js",
		"./lt": "./node_modules/moment/locale/lt.js",
		"./lt.js": "./node_modules/moment/locale/lt.js",
		"./lv": "./node_modules/moment/locale/lv.js",
		"./lv.js": "./node_modules/moment/locale/lv.js",
		"./me": "./node_modules/moment/locale/me.js",
		"./me.js": "./node_modules/moment/locale/me.js",
		"./mi": "./node_modules/moment/locale/mi.js",
		"./mi.js": "./node_modules/moment/locale/mi.js",
		"./mk": "./node_modules/moment/locale/mk.js",
		"./mk.js": "./node_modules/moment/locale/mk.js",
		"./ml": "./node_modules/moment/locale/ml.js",
		"./ml.js": "./node_modules/moment/locale/ml.js",
		"./mr": "./node_modules/moment/locale/mr.js",
		"./mr.js": "./node_modules/moment/locale/mr.js",
		"./ms": "./node_modules/moment/locale/ms.js",
		"./ms-my": "./node_modules/moment/locale/ms-my.js",
		"./ms-my.js": "./node_modules/moment/locale/ms-my.js",
		"./ms.js": "./node_modules/moment/locale/ms.js",
		"./mt": "./node_modules/moment/locale/mt.js",
		"./mt.js": "./node_modules/moment/locale/mt.js",
		"./my": "./node_modules/moment/locale/my.js",
		"./my.js": "./node_modules/moment/locale/my.js",
		"./nb": "./node_modules/moment/locale/nb.js",
		"./nb.js": "./node_modules/moment/locale/nb.js",
		"./ne": "./node_modules/moment/locale/ne.js",
		"./ne.js": "./node_modules/moment/locale/ne.js",
		"./nl": "./node_modules/moment/locale/nl.js",
		"./nl-be": "./node_modules/moment/locale/nl-be.js",
		"./nl-be.js": "./node_modules/moment/locale/nl-be.js",
		"./nl.js": "./node_modules/moment/locale/nl.js",
		"./nn": "./node_modules/moment/locale/nn.js",
		"./nn.js": "./node_modules/moment/locale/nn.js",
		"./pa-in": "./node_modules/moment/locale/pa-in.js",
		"./pa-in.js": "./node_modules/moment/locale/pa-in.js",
		"./pl": "./node_modules/moment/locale/pl.js",
		"./pl.js": "./node_modules/moment/locale/pl.js",
		"./pt": "./node_modules/moment/locale/pt.js",
		"./pt-br": "./node_modules/moment/locale/pt-br.js",
		"./pt-br.js": "./node_modules/moment/locale/pt-br.js",
		"./pt.js": "./node_modules/moment/locale/pt.js",
		"./ro": "./node_modules/moment/locale/ro.js",
		"./ro.js": "./node_modules/moment/locale/ro.js",
		"./ru": "./node_modules/moment/locale/ru.js",
		"./ru.js": "./node_modules/moment/locale/ru.js",
		"./sd": "./node_modules/moment/locale/sd.js",
		"./sd.js": "./node_modules/moment/locale/sd.js",
		"./se": "./node_modules/moment/locale/se.js",
		"./se.js": "./node_modules/moment/locale/se.js",
		"./si": "./node_modules/moment/locale/si.js",
		"./si.js": "./node_modules/moment/locale/si.js",
		"./sk": "./node_modules/moment/locale/sk.js",
		"./sk.js": "./node_modules/moment/locale/sk.js",
		"./sl": "./node_modules/moment/locale/sl.js",
		"./sl.js": "./node_modules/moment/locale/sl.js",
		"./sq": "./node_modules/moment/locale/sq.js",
		"./sq.js": "./node_modules/moment/locale/sq.js",
		"./sr": "./node_modules/moment/locale/sr.js",
		"./sr-cyrl": "./node_modules/moment/locale/sr-cyrl.js",
		"./sr-cyrl.js": "./node_modules/moment/locale/sr-cyrl.js",
		"./sr.js": "./node_modules/moment/locale/sr.js",
		"./ss": "./node_modules/moment/locale/ss.js",
		"./ss.js": "./node_modules/moment/locale/ss.js",
		"./sv": "./node_modules/moment/locale/sv.js",
		"./sv.js": "./node_modules/moment/locale/sv.js",
		"./sw": "./node_modules/moment/locale/sw.js",
		"./sw.js": "./node_modules/moment/locale/sw.js",
		"./ta": "./node_modules/moment/locale/ta.js",
		"./ta.js": "./node_modules/moment/locale/ta.js",
		"./te": "./node_modules/moment/locale/te.js",
		"./te.js": "./node_modules/moment/locale/te.js",
		"./tet": "./node_modules/moment/locale/tet.js",
		"./tet.js": "./node_modules/moment/locale/tet.js",
		"./th": "./node_modules/moment/locale/th.js",
		"./th.js": "./node_modules/moment/locale/th.js",
		"./tl-ph": "./node_modules/moment/locale/tl-ph.js",
		"./tl-ph.js": "./node_modules/moment/locale/tl-ph.js",
		"./tlh": "./node_modules/moment/locale/tlh.js",
		"./tlh.js": "./node_modules/moment/locale/tlh.js",
		"./tr": "./node_modules/moment/locale/tr.js",
		"./tr.js": "./node_modules/moment/locale/tr.js",
		"./tzl": "./node_modules/moment/locale/tzl.js",
		"./tzl.js": "./node_modules/moment/locale/tzl.js",
		"./tzm": "./node_modules/moment/locale/tzm.js",
		"./tzm-latn": "./node_modules/moment/locale/tzm-latn.js",
		"./tzm-latn.js": "./node_modules/moment/locale/tzm-latn.js",
		"./tzm.js": "./node_modules/moment/locale/tzm.js",
		"./uk": "./node_modules/moment/locale/uk.js",
		"./uk.js": "./node_modules/moment/locale/uk.js",
		"./ur": "./node_modules/moment/locale/ur.js",
		"./ur.js": "./node_modules/moment/locale/ur.js",
		"./uz": "./node_modules/moment/locale/uz.js",
		"./uz-latn": "./node_modules/moment/locale/uz-latn.js",
		"./uz-latn.js": "./node_modules/moment/locale/uz-latn.js",
		"./uz.js": "./node_modules/moment/locale/uz.js",
		"./vi": "./node_modules/moment/locale/vi.js",
		"./vi.js": "./node_modules/moment/locale/vi.js",
		"./x-pseudo": "./node_modules/moment/locale/x-pseudo.js",
		"./x-pseudo.js": "./node_modules/moment/locale/x-pseudo.js",
		"./yo": "./node_modules/moment/locale/yo.js",
		"./yo.js": "./node_modules/moment/locale/yo.js",
		"./zh-cn": "./node_modules/moment/locale/zh-cn.js",
		"./zh-cn.js": "./node_modules/moment/locale/zh-cn.js",
		"./zh-hk": "./node_modules/moment/locale/zh-hk.js",
		"./zh-hk.js": "./node_modules/moment/locale/zh-hk.js",
		"./zh-tw": "./node_modules/moment/locale/zh-tw.js",
		"./zh-tw.js": "./node_modules/moment/locale/zh-tw.js"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2;


/***/ },

/***/ "./node_modules/moment/locale/af.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        ss : '%d sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ar.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        ss : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ar-dz.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ar-kw.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ar-ly.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        ss : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ar-ma.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ar-sa.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ar-tn.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        ss : '%d ثانية',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/az.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        ss : '%d saniyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/be.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/bg.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        ss : '%d секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/bm.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	// Language contact person : Abdoufata Kane : https://github.com/abdoufata
	
	var bm = moment.defineLocale('bm', {
	    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'MMMM [tile] D [san] YYYY',
	        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bi lɛrɛ] LT',
	        nextDay : '[Sini lɛrɛ] LT',
	        nextWeek : 'dddd [don lɛrɛ] LT',
	        lastDay : '[Kunu lɛrɛ] LT',
	        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s kɔnɔ',
	        past : 'a bɛ %s bɔ',
	        s : 'sanga dama dama',
	        ss : 'sekondi %d',
	        m : 'miniti kelen',
	        mm : 'miniti %d',
	        h : 'lɛrɛ kelen',
	        hh : 'lɛrɛ %d',
	        d : 'tile kelen',
	        dd : 'tile %d',
	        M : 'kalo kelen',
	        MM : 'kalo %d',
	        y : 'san kelen',
	        yy : 'san %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return bm;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/bn.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        ss : '%d সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/bo.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        ss : '%d སྐར་ཆ།',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/br.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        ss : '%d eilenn',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/bs.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            if (number === 1) {
	                result += 'sekunda';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sekunde';
	            } else {
	                result += 'sekundi';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        ss     : translate,
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ca.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : 'D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        ss : '%d segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/cs.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            } else {
	                return result + 'sekundami';
	            }
	            break;
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/cv.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        ss : '%d ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/cy.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        ss: '%d eiliad',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/da.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        ss : '%d sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/de.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/de-at.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/de-ch.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/dv.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        ss : 'd% ސިކުންތު',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/el.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        ss : '%d δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/en-au.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/en-ca.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/en-gb.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/en-ie.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/en-nz.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/eo.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        ss : '%d sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/es.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex : monthsRegex,
	    monthsShortRegex : monthsRegex,
	    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/es-do.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse: monthsParse,
	    longMonthsParse: monthsParse,
	    shortMonthsParse: monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/es-us.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esUs = moment.defineLocale('es-us', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'MM/DD/YYYY',
	        LL : 'MMMM [de] D [de] YYYY',
	        LLL : 'MMMM [de] D [de] YYYY h:mm A',
	        LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return esUs;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/et.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'ss': [number + 'sekundi', number + 'sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        ss     : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/eu.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        ss : '%d segundo',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/fa.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        ss : 'ثانیه d%',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/fi.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'ss':
	            return isFuture ? 'sekunnin' : 'sekuntia';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/fo.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        ss : '%d sekundir',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/fr.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/fr-ca.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/fr-ch.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/fy.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        ss : '%d sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/gd.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        ss : '%d diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/gl.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/gom-latn.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'ss': [number + ' secondanim', number + ' second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        ss : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/gu.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	        '1': '૧',
	        '2': '૨',
	        '3': '૩',
	        '4': '૪',
	        '5': '૫',
	        '6': '૬',
	        '7': '૭',
	        '8': '૮',
	        '9': '૯',
	        '0': '૦'
	    };
	var numberMap = {
	        '૧': '1',
	        '૨': '2',
	        '૩': '3',
	        '૪': '4',
	        '૫': '5',
	        '૬': '6',
	        '૭': '7',
	        '૮': '8',
	        '૯': '9',
	        '૦': '0'
	    };
	
	var gu = moment.defineLocale('gu', {
	    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm વાગ્યે',
	        LTS: 'A h:mm:ss વાગ્યે',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	    },
	    calendar: {
	        sameDay: '[આજ] LT',
	        nextDay: '[કાલે] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[ગઇકાલે] LT',
	        lastWeek: '[પાછલા] dddd, LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%s મા',
	        past: '%s પેહલા',
	        s: 'અમુક પળો',
	        ss: '%d સેકંડ',
	        m: 'એક મિનિટ',
	        mm: '%d મિનિટ',
	        h: 'એક કલાક',
	        hh: '%d કલાક',
	        d: 'એક દિવસ',
	        dd: '%d દિવસ',
	        M: 'એક મહિનો',
	        MM: '%d મહિનો',
	        y: 'એક વર્ષ',
	        yy: '%d વર્ષ'
	    },
	    preparse: function (string) {
	        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'રાત') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'સવાર') {
	            return hour;
	        } else if (meridiem === 'બપોર') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'સાંજ') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'રાત';
	        } else if (hour < 10) {
	            return 'સવાર';
	        } else if (hour < 17) {
	            return 'બપોર';
	        } else if (hour < 20) {
	            return 'સાંજ';
	        } else {
	            return 'રાત';
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return gu;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/he.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        ss : '%d שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/hi.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        ss : '%d सेकंड',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/hr.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            if (number === 1) {
	                result += 'sekunda';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sekunde';
	            } else {
	                result += 'sekundi';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        ss     : translate,
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/hu.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'ss':
	            return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/hy-am.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        ss : '%d վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/id.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        ss : '%d detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/is.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'ss':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	            }
	            return result + 'sekúnda';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/it.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        ss : '%d secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ja.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        ss : '%d秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/jv.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        ss : '%d detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ka.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        ss : '%d წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/kk.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        ss : '%d секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/km.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        ss: '%d វិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/kn.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        ss : '%d ಸೆಕೆಂಡುಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ko.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '일';
	            case 'M':
	                return number + '월';
	            case 'w':
	            case 'W':
	                return number + '주';
	            default:
	                return number;
	        }
	    },
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ky.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        ss : '%d секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/lb.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        ss : '%d Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/lo.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        ss : '%d ວິນາທີ' ,
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/lt.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'ss' : 'sekundė_sekundžių_sekundes',
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        ss : translate,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/lv.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/me.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['sekund', 'sekunda', 'sekundi'],
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/mi.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        ss: '%d hēkona',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/mk.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        ss : '%d секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ml.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        ss : '%d സെക്കൻഡ്',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/mr.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'ss': output = '%d सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'ss': output = '%d सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        ss: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ms.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        ss : '%d saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ms-my.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        ss : '%d saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/mt.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mt = moment.defineLocale('mt', {
	    months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	    monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	    weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	    weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	    weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Illum fil-]LT',
	        nextDay : '[Għada fil-]LT',
	        nextWeek : 'dddd [fil-]LT',
	        lastDay : '[Il-bieraħ fil-]LT',
	        lastWeek : 'dddd [li għadda] [fil-]LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'f’ %s',
	        past : '%s ilu',
	        s : 'ftit sekondi',
	        ss : '%d sekondi',
	        m : 'minuta',
	        mm : '%d minuti',
	        h : 'siegħa',
	        hh : '%d siegħat',
	        d : 'ġurnata',
	        dd : '%d ġranet',
	        M : 'xahar',
	        MM : '%d xhur',
	        y : 'sena',
	        yy : '%d sni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mt;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/my.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        ss : '%d စက္ကန့်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/nb.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        ss : '%d sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ne.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        ss : '%d सेकेण्ड',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/nl.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        ss : '%d seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/nl-be.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        ss : '%d seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/nn.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        ss : '%d sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/pa-in.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        ss : '%d ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/pl.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            return result + (plural(number) ? 'sekundy' : 'sekund');
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W niedzielę o] LT';
	
	                case 2:
	                    return '[We wtorek o] LT';
	
	                case 3:
	                    return '[W środę o] LT';
	
	                case 6:
	                    return '[W sobotę o] LT';
	
	                default:
	                    return '[W] dddd [o] LT';
	            }
	        },
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/pt.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        ss : '%d segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/pt-br.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        ss : '%d segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ro.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'ss': 'secunde',
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        ss : relativeTimeWithPlural,
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ru.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., H:mm',
	        LLLL : 'dddd, D MMMM YYYY г., H:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/sd.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        ss : '%d سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/se.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        ss: '%d sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/si.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        ss : 'තත්පර %d',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/sk.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'sekundy' : 'sekúnd');
	            } else {
	                return result + 'sekundami';
	            }
	            break;
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/sl.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'ss':
	            if (number === 1) {
	                result += withoutSuffix ? 'sekundo' : 'sekundi';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	            } else {
	                result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        ss     : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/sq.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        ss : '%d sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/sr.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['sekunda', 'sekunde', 'sekundi'],
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/sr-cyrl.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['секунда', 'секунде', 'секунди'],
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ss.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        ss : '%d mzuzwana',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/sv.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        ss : '%d sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/sw.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        ss : 'sekunde %d',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ta.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        ss : '%d விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/te.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        ss : '%d సెకన్లు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/tet.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        ss : 'minutu %d',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/th.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        ss : '%d วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/tl-ph.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        ss : '%d segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/tlh.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'ss':
	            return numberNoun + ' lup';
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        ss : translate,
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/tr.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[gelecek] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        ss : '%d saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/tzl.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        ss : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'ss': [number + ' secunds', '' + number + ' secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/tzm.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        ss : '%d ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/tzm-latn.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        ss : '%d imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/uk.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/ur.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        ss : '%d سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/uz.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        ss : '%d фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/uz-latn.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        ss : '%d soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/vi.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        ss : '%d giây' ,
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/x-pseudo.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        ss : '%d s~écóñ~ds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/yo.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        ss :'aayá %d',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/zh-cn.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日Ah点mm分',
	        LLLL : 'YYYY年M月D日ddddAh点mm分',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        ss : '%d 秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/zh-hk.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日dddd HH:mm',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        ss : '%d 秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },

/***/ "./node_modules/moment/locale/zh-tw.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日dddd HH:mm',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        ss : '%d 秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },

/***/ "./src/universal/collections/users/users.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.UserSchema = exports.UserListSchema = undefined;
	
	var _getIterator2 = __webpack_require__("./node_modules/babel-runtime/core-js/get-iterator.js");
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _baseSchema = __webpack_require__("./src/universal/collections/baseSchema.js");
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _uniformsBootstrap = __webpack_require__("./node_modules/uniforms-bootstrap3/index.js");
	
	var _datePickerField = __webpack_require__("./src/universal/components/fields/datePickerField.js");
	
	var _datePickerField2 = _interopRequireDefault(_datePickerField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var Mongo = Package.mongo.Mongo;
	
	
	Meteor.users.attachRoles('users');
	
	Meteor.users.label = "L'utilisateur";
	
	exports.default = Meteor.users;
	var UserListSchema = exports.UserListSchema = new SimpleSchema([{
		"username": {
			type: String,
			label: "Login"
		},
		"profile": {
			type: Object,
			uniforms: {
				label: null
			}
		},
		"profile.firstName": {
			type: String,
			label: "Prénom"
		},
		"profile.lastName": {
			type: String,
			label: "Nom"
		}
	}, _baseSchema.BaseSchema]);
	
	var UserSchema = exports.UserSchema = new SimpleSchema([{
		"username": {
			type: String,
			label: "Login"
		},
		"profile": {
			type: Object,
			uniforms: {
				label: null
			}
		},
		"profile.firstName": {
			type: String,
			label: "Prénom"
		},
		"profile.lastName": {
			type: String,
			label: "Nom"
		},
		"profile.email": {
			type: String,
			regEx: SimpleSchema.RegEx.Email,
			label: "E-mail",
			uniforms: {
				type: "email"
			}
		},
		"profile.certificat": {
			type: String,
			label: "Certificat",
			hide: true,
			optional: true,
			uniforms: {
				component: _uniformsBootstrap.HiddenField
			}
		},
		"profile.licence": {
			type: String,
			label: "Licence",
			hide: true,
			optional: true,
			uniforms: {
				component: _uniformsBootstrap.HiddenField
			}
		},
		"profile.weight": {
			type: Number,
			label: "Poids (en kg)",
			defaultValue: 0
		},
		"profile.freeFlights": {
			type: String,
			hide: true,
			optional: true,
			uniforms: {
				component: _uniformsBootstrap.HiddenField
			}
	
		},
		"profile.billType": {
			type: String,
			hide: true,
			optional: true,
			uniforms: {
				component: _uniformsBootstrap.HiddenField
			}
	
		},
		"profile.accessToCalendar": {
			type: String,
			hide: true,
			optional: true,
			uniforms: {
				component: _uniformsBootstrap.HiddenField
			}
	
		},
		"profile.type": {
			type: String,
			hide: true,
			optional: true,
			uniforms: {
				component: _uniformsBootstrap.HiddenField
			}
	
		},
		"profile.street": {
			type: String,
			hide: true,
			optional: true,
			uniforms: {
				component: _uniformsBootstrap.HiddenField
			}
	
		},
		"profile.city": {
			type: String,
			hide: true,
			optional: true,
			uniforms: {
				component: _uniformsBootstrap.HiddenField
			}
	
		},
		"profile.phone": {
			type: String,
			label: "Telephone",
			optional: true
		},
		"profile.availabilities": {
			type: [Object],
			optional: true,
			blackbox: true,
			hide: true,
			uniforms: {
				component: _uniformsBootstrap.HiddenField
			}
		},
		"roles": {
			type: [String],
			label: "Roles",
			allowedValues: ["organizer", "pilot", "partner", "god"],
			defaultValue: [],
			uniforms: {
				checkboxes: true,
				transform: function transform(option) {
					switch (option) {
						case "organizer":
							return "Administrateur";
						case "pilot":
							return "Pilote";
						case "partner":
							return "Partenaire";
						case "god":
							return "Super-Administrateur";
						default:
							return "N/C";
					}
				}
			}
		}
	}, _baseSchema.BaseSchema]);
	
	Meteor.users.attachSchema(new SimpleSchema([{
		"services": {
			type: Object,
			blackbox: true,
			optional: true
		}
	}, UserSchema]));
	
	Meteor.users.helpers({
		type: function type() {
			var type = "";
	
			console.log('this.profile.roles', this.profile.roles);
	
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;
	
			try {
				for (var _iterator = (0, _getIterator3.default)(this.profile.roles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var role = _step.value;
	
					if (type.length) type += " / ";
	
					switch (role) {
						case 'organizer':
							type += 'Administrateur';
							break;
						case 'pilot':
							type += 'Pilote';
							break;
						case 'partner':
							type += 'Partenaire';
							break;
						case 'god':
							type += 'Super-Administrateur';
							break;
						default:
							return 'N/C';
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
	
			return type;
		},
		displayName: function displayName() {
			return this.profile.firstName + ' ' + this.profile.lastName;
		},
		flightScheduledAt: function flightScheduledAt(date, period) {
			return _flights.Flights.findOne({
				pilotId: this._id,
				date: (0, _moment2.default)(date).startOf('day').toDate(),
				period: period
			});
		}
	});

/***/ },

/***/ "./src/universal/collections/baseSchema.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.BaseSchema = undefined;
	
	var _uniformsBootstrap = __webpack_require__("./node_modules/uniforms-bootstrap3/index.js");
	
	var BaseSchema = exports.BaseSchema = {
		updatedAt: {
			type: Date,
			label: "Date de dernière modification",
			uniforms: _uniformsBootstrap.HiddenField,
			optional: true,
			hide: true,
			autoValue: function autoValue() {
				return new Date();
			}
		},
		createdAt: {
			type: Date,
			label: "Date de création",
			uniforms: _uniformsBootstrap.HiddenField,
			optional: true,
			autoValue: function autoValue() {
				if (this.isInsert) {
					return new Date();
				} else if (this.isUpsert) {
					return { $setOnInsert: new Date() };
				} else {
					//this.unset();  // Prevent user from supplying their own value
				}
			}
		}
	};

/***/ },

/***/ "./src/universal/collections/flights/flights.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FlightSchema = exports.Flights = undefined;
	
	var _baseSchema = __webpack_require__("./src/universal/collections/baseSchema.js");
	
	var _places = __webpack_require__("./src/universal/collections/flights/places.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	var _users = __webpack_require__("./src/universal/collections/users/users.js");
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Mongo = Package.mongo.Mongo;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var Flights = exports.Flights = new Mongo.Collection('flights');
	
	Flights.attachRoles('flights');
	
	var FlightSchema = exports.FlightSchema = new SimpleSchema([{
	    date: {
	        type: Date,
	        label: "Date du vol"
	    },
	    period: {
	        type: String,
	        label: "Periode du vol"
	    },
	    place: {
	        type: String,
	        label: "Lieu du vol"
	    },
	    placeId: {
	        type: String,
	        label: "Lieu d'envol",
	        optional: true
	    },
	    pilotId: {
	        type: String,
	        label: "Pilote",
	        optional: true
	    },
	    montgolfiereId: {
	        type: String,
	        label: "Montgolfiere",
	        optional: true
	    },
	    reservationIds: {
	        type: [String],
	        label: "Reservations",
	        optional: true
	    },
	    status: {
	        type: String,
	        label: "Etat du vol",
	        allowedValues: ["preparing", "prepared", "cancelled", "validated"]
	    },
	    meetingDate: {
	        type: Date,
	        label: "Heure de rendez-vous",
	        optional: true
	    },
	    takeOffDate: {
	        type: Date,
	        label: "Heure de début",
	        optional: true
	    },
	    landingDate: {
	        type: Date,
	        label: "Heure de fin",
	        optional: true
	    },
	    takeOffPlace: {
	        type: String,
	        label: "Lieu de décollage",
	        optional: true
	    },
	    landingPlace: {
	        type: String,
	        label: "Lieu d'atterrissage",
	        optional: true
	    },
	    time: {
	        type: Number,
	        label: "Temps de vol",
	        optional: true,
	        autoValue: function autoValue() {
	            if (this.field("takeOffDate").value && this.field("landingDate").value) return (0, _moment2.default)(this.field("landingDate").value).diff((0, _moment2.default)(this.field("takeOffDate").value), 'minutes');else this.field("time").value;
	        }
	    },
	    temp: {
	        type: Number,
	        optional: true
	    },
	    validToFlight: {
	        type: Boolean,
	        defaultValue: false
	    }
	}, _baseSchema.BaseSchema]);
	
	Flights.attachSchema(FlightSchema);
	
	Meteor.methods({
	    'flights.insert': function flightsInsert(attributes) {
	        Flights.insert(attributes);
	    }
	});
	
	Flights.helpers({
	    getPilote: function getPilote() {
	        return Meteor.users.findOne({ _id: this.pilotId });
	    },
	    getMontgolfiere: function getMontgolfiere() {
	        return _montgolfieres.Montgolfieres.findOne({ _id: this.montgolfiereId });
	    },
	    getReservations: function getReservations() {
	        if (!this.reservationIds) return [];
	        return this.reservationIds.map(function (reservationId) {
	            return _reservations.Reservations.findOne({ _id: reservationId });
	        });
	    },
	    getDisplayDate: function getDisplayDate() {
	        return (0, _moment2.default)(this.date).format('DD/MM/YYYY');
	    },
	    getSeats: function getSeats() {
	        var seats = this.getMontgolfiere().maxPassengers;
	        _.each(this.getReservations(), function (reservation) {
	            seats = seats - reservation.passengers.length;
	        });
	        return seats;
	    },
	    getPeriod: function getPeriod() {
	        if (this.period == "morning") return "Matin";else return "Soir";
	    },
	    getStatus: function getStatus() {
	        if (this.status == 'preparing') return "En préparation";
	        if (this.status == 'prepared') return "Validé";
	        if (this.status == 'cancelled') return "Annulé";
	        if (this.status == 'pending') return "En attente";
	        if (this.status = 'validated') return "Clôturé";
	    },
	    getPlace: function getPlace() {
	        if (this.place == 'anjou') return "Sites d'envol Montgolfieres d'Anjou";else return "Sites d'envol Nantes Montgolfieres";
	    },
	    getPlaceCode: function getPlaceCode() {
	        if (this.place == 'anjou') return "[A]";else return "[N]";
	    },
	    getMeetPoint: function getMeetPoint() {
	        return _places.Places.findOne(this.placeId);
	    },
	    removeReservation: function removeReservation(_id) {
	        var reservations = _.without(this.reservations, _id);
	        Flights.update(this._id, { $set: { reservations: reservations } });
	    }
	});

/***/ },

/***/ "./src/universal/collections/flights/places.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PlaceSchema = exports.Places = undefined;
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _baseSchema = __webpack_require__("./src/universal/collections/baseSchema.js");
	
	var _googleMapsField = __webpack_require__("./src/universal/components/fields/googleMapsField.js");
	
	var _googleMapsField2 = _interopRequireDefault(_googleMapsField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var Mongo = Package.mongo.Mongo;
	var Places = exports.Places = new Mongo.Collection('places');
	exports.default = Places;
	
	
	Places.attachRoles('places');
	
	Places.label = "Lieu d'envol";
	
	var PlaceSchema = exports.PlaceSchema = new SimpleSchema([{
	    name: {
	        type: String,
	        label: "Nom du lieu",
	        uniforms: {
	            component: _googleMapsField2.default
	        }
	    },
	    precision: {
	        type: String,
	        label: "Précision"
	    }
	}, _baseSchema.BaseSchema]);
	
	Places.attachSchema(PlaceSchema);

/***/ },

/***/ "./src/universal/components/fields/googleMapsField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _reactGoogleMapsLoader = __webpack_require__("./node_modules/react-google-maps-loader/lib/index.js");
	
	var _reactGoogleMapsLoader2 = _interopRequireDefault(_reactGoogleMapsLoader);
	
	var _reactGooglePlacesSuggest = __webpack_require__("./node_modules/react-google-places-suggest/lib/index.js");
	
	var _reactGooglePlacesSuggest2 = _interopRequireDefault(_reactGooglePlacesSuggest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	
	var MY_API_KEY = "AIzaSyBMHkygr3-56LBRNrjiQI53xDU6G7LLptY";
	
	var GoogleMapsField = function (_React$Component) {
		(0, _inherits3.default)(GoogleMapsField, _React$Component);
	
		function GoogleMapsField(props) {
			(0, _classCallCheck3.default)(this, GoogleMapsField);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (GoogleMapsField.__proto__ || (0, _getPrototypeOf2.default)(GoogleMapsField)).call(this, props));
	
			_this.state = {
				search: props.value,
				selectedCoordinate: null
			};
	
			return _this;
		}
	
		(0, _createClass3.default)(GoogleMapsField, [{
			key: 'handleSearchChange',
			value: function handleSearchChange(e) {
				if (e.target.value != this.state.search) this.setState({ search: e.target.value });
			}
		}, {
			key: 'handleSelectSuggest',
			value: function handleSelectSuggest(suggest, coordinate) {
				this.setState({ search: suggest.description, selectedCoordinate: coordinate });
				this.props.onChange(suggest.description);
			}
		}, {
			key: 'render',
			value: function render() {
				var search = this.state.search;
				var googleMaps = this.props.googleMaps;
	
	
				if (googleMaps) {
	
					return _react2.default.createElement(
						_reactGooglePlacesSuggest2.default,
						{
							googleMaps: googleMaps,
							onSelectSuggest: this.handleSelectSuggest.bind(this),
							search: search },
						_react2.default.createElement(
							'label',
							{ className: 'control-label' },
							this.props.label,
							'\xA0'
						),
						_react2.default.createElement('input', {
							type: 'text',
							autoComplete: 'off',
							value: search,
							placeholder: 'Recherche...',
							ref: this.props.inputRef,
							id: this.props.id,
							name: this.props.name,
							onChange: this.handleSearchChange.bind(this),
							className: 'input-fullwidth' })
					);
				} else {
					return _react2.default.createElement(
						'p',
						null,
						'Chargement...'
					);
				}
			}
		}]);
		return GoogleMapsField;
	}(_react2.default.Component);
	
	exports.default = (0, _connectField2.default)((0, _reactGoogleMapsLoader2.default)(GoogleMapsField, {
		libraries: ["places"],
		key: MY_API_KEY
	}), { includeInChain: false });

/***/ },

/***/ "./node_modules/react-google-maps-loader/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__("./node_modules/react/react.js")):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports["react-google-maps-loader"]=t(require("react")):e["react-google-maps-loader"]=t(e.React)}(this,function(e){return function(e){function t(o){if(n[o])return n[o].exports;var r=n[o]={exports:{},id:o,loaded:!1};return e[o].call(r.exports,r,r.exports,t),r.loaded=!0,r.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function u(e,t){"undefined"!=typeof window&&(j===b?t(x):j===v?w.push(t):null!=window.google&&null!=window.google.maps?(j=b,x=window.google.maps,t(x)):(j=v,w.push(t),(0,d["default"])(h+"?"+y["default"].stringify(e),function(e){if(e)throw new Error("Unable to load Google Map SDK");for(j=b,x=window.google.maps;w.length>0;)w.pop()(x)})))}Object.defineProperty(t,"__esModule",{value:!0});var c=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),s=n(4),f=o(s),p=n(3),d=o(p),g=n(1),y=o(g),h="https://maps.googleapis.com/maps/api/js",m=0,v=1,b=2,w=[],j=m,x=void 0,O=function(e,t){return function(n){function o(){r(this,o);var e=a(this,(o.__proto__||Object.getPrototypeOf(o)).call(this));return e.state={googleMaps:null},e}return i(o,n),l(o,[{key:"componentWillMount",value:function(){var e=this;u(t,function(t){return e.setState({googleMaps:t})})}},{key:"render",value:function(){var t=this.state.googleMaps;return f["default"].createElement(e,c({googleMaps:t},this.props))}}]),o}(s.Component)};t["default"]=O},function(e,t,n){"use strict";var o=n(2);t.extract=function(e){return e.split("?")[1]||""},t.parse=function(e){return"string"!=typeof e?{}:(e=e.trim().replace(/^(\?|#|&)/,""),e?e.split("&").reduce(function(e,t){var n=t.replace(/\+/g," ").split("="),o=n.shift(),r=n.length>0?n.join("="):void 0;return o=decodeURIComponent(o),r=void 0===r?null:decodeURIComponent(r),e.hasOwnProperty(o)?Array.isArray(e[o])?e[o].push(r):e[o]=[e[o],r]:e[o]=r,e},{}):{})},t.stringify=function(e){return e?Object.keys(e).sort().map(function(t){var n=e[t];return void 0===n?"":null===n?t:Array.isArray(n)?n.slice().sort().map(function(e){return o(t)+"="+o(e)}).join("&"):o(t)+"="+o(n)}).filter(function(e){return e.length>0}).join("&"):""}},function(e,t){"use strict";e.exports=function(e){return encodeURIComponent(e).replace(/[!'()*]/g,function(e){return"%"+e.charCodeAt(0).toString(16).toUpperCase()})}},function(e,t,n){!function(){var t={},n=0,o=function(e){var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)},r=function(e,r,a){var i,u,c=document.createElement("script"),l=!1,s=function(){l||(l=!0,u(),r&&r.call(a,i))},f=function(){i=new Error(e||"EMPTY"),s()};if(!c.readyState||"async"in c)u=function(){c.onload=c.onerror=null},c.onerror=f,c.onload=s,c.async=!0,c.charset="utf-8",c.src=e,o(c);else{var p=n++,d={loaded:!0,complete:!0},g=!1;u=function(){c.onreadystatechange=c.onerror=null,t[p]=void 0},c.onreadystatechange=function(){var e=c.readyState;if(!i)return!g&&d[e]&&(g=!0,o(c)),"loaded"===e&&(c.children,"loading"===c.readyState)?f():void("complete"===c.readyState&&s())},c.onerror=f,t[p]=c,c.src=e}};e.exports=r}()},function(t,n){t.exports=e}])});

/***/ },

/***/ "./node_modules/react-google-places-suggest/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GooglePlacesSuggest = function (_Component) {
	  _inherits(GooglePlacesSuggest, _Component);
	
	  function GooglePlacesSuggest() {
	    _classCallCheck(this, GooglePlacesSuggest);
	
	    var _this = _possibleConstructorReturn(this, (GooglePlacesSuggest.__proto__ || Object.getPrototypeOf(GooglePlacesSuggest)).call(this));
	
	    _this.state = {
	      coordinate: null,
	      googleMaps: null,
	      focusedSuggestIndex: 0,
	      selectedLabel: "",
	      suggests: []
	    };
	
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  _createClass(GooglePlacesSuggest, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.updateSuggests(this.props.search);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      this.updateSuggests(nextProps.search);
	    }
	  }, {
	    key: "handleSelectSuggest",
	    value: function handleSelectSuggest(suggest) {
	      var _this2 = this;
	
	      var onSelectSuggest = this.props.onSelectSuggest;
	
	
	      this.geocodeSuggest(suggest.description, function () {
	        _this2.setState({ selectedLabel: suggest.description, suggests: [] }, function () {
	          onSelectSuggest(suggest, _this2.state.coordinate);
	        });
	      });
	    }
	  }, {
	    key: "updateSuggests",
	    value: function updateSuggests(search) {
	      var _this3 = this;
	
	      var _props = this.props,
	          googleMaps = _props.googleMaps,
	          suggestRadius = _props.suggestRadius;
	
	      var autocompleteService = new googleMaps.places.AutocompleteService();
	
	      if (!search) {
	        this.setState({ suggests: [] });
	        return;
	      }
	
	      autocompleteService.getPlacePredictions({
	        input: search,
	        location: new googleMaps.LatLng(0, 0),
	        radius: suggestRadius
	      }, function (googleSuggests) {
	        if (!googleSuggests) {
	          _this3.setState({ suggests: [] });
	          return;
	        }
	
	        _this3.setState({
	          focusedSuggestIndex: 0,
	          suggests: googleSuggests
	        });
	      });
	    }
	  }, {
	    key: "geocodeSuggest",
	    value: function geocodeSuggest(suggestLabel, callback) {
	      var _this4 = this;
	
	      var googleMaps = this.props.googleMaps;
	
	      var geocoder = new googleMaps.Geocoder();
	
	      geocoder.geocode({ address: suggestLabel }, function (results, status) {
	        if (status === googleMaps.GeocoderStatus.OK) {
	          var location = results[0].geometry.location;
	          var coordinate = {
	            latitude: location.lat(),
	            longitude: location.lng(),
	            title: suggestLabel
	          };
	
	          _this4.setState({ coordinate: coordinate }, callback);
	        }
	      });
	    }
	  }, {
	    key: "handleKeyDown",
	    value: function handleKeyDown(e) {
	      var _state = this.state,
	          focusedSuggestIndex = _state.focusedSuggestIndex,
	          suggests = _state.suggests;
	
	
	      if (suggests.length > 0) {
	        if (e.key === "Enter") {
	          this.handleSelectSuggest(suggests[focusedSuggestIndex]);
	        } else if (e.key === "ArrowUp") {
	          if (suggests.length > 0 && focusedSuggestIndex > 0) {
	            this.focusSuggest(focusedSuggestIndex - 1);
	          }
	        } else if (e.key === "ArrowDown") {
	          if (suggests.length > 0 && focusedSuggestIndex < suggests.length - 1) {
	            this.focusSuggest(focusedSuggestIndex + 1);
	          }
	        }
	      }
	    }
	  }, {
	    key: "focusSuggest",
	    value: function focusSuggest(index) {
	      this.setState({ focusedSuggestIndex: index });
	    }
	  }, {
	    key: "renderNoResults",
	    value: function renderNoResults() {
	      var textNoResults = this.props.textNoResults;
	
	      return _react2.default.createElement(
	        "li",
	        { className: "placesSuggest_suggest" },
	        textNoResults
	      );
	    }
	  }, {
	    key: "renderDefaultSuggest",
	    value: function renderDefaultSuggest(suggest) {
	      var description = suggest.description,
	          structured_formatting = suggest.structured_formatting;
	
	      var firstMatchedString = structured_formatting.main_text_matched_substrings.shift();
	      var labelParts = null;
	
	      if (firstMatchedString) {
	        labelParts = {
	          before: description.substr(0, firstMatchedString.offset),
	          matched: description.substr(firstMatchedString.offset, firstMatchedString.length),
	          after: description.substr(firstMatchedString.offset + firstMatchedString.length)
	        };
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "span",
	          { className: "placesSuggest_suggestLabel" },
	          labelParts ? _react2.default.createElement(
	            "span",
	            null,
	            labelParts.before.length > 0 ? _react2.default.createElement(
	              "span",
	              null,
	              labelParts.before
	            ) : null,
	            _react2.default.createElement(
	              "span",
	              { className: "placesSuggest_suggestMatch" },
	              labelParts.matched
	            ),
	            labelParts.after.length > 0 ? _react2.default.createElement(
	              "span",
	              null,
	              labelParts.after
	            ) : null
	          ) : description
	        )
	      );
	    }
	  }, {
	    key: "renderSuggest",
	    value: function renderSuggest(suggest) {
	      var renderSuggest = this.props.renderSuggest;
	
	      return renderSuggest ? this.renderSuggest(suggest) : this.renderDefaultSuggest(suggest);
	    }
	  }, {
	    key: "renderSuggests",
	    value: function renderSuggests() {
	      var _this5 = this;
	
	      var _state2 = this.state,
	          focusedSuggestIndex = _state2.focusedSuggestIndex,
	          suggests = _state2.suggests;
	
	      return _react2.default.createElement(
	        "ul",
	        { className: "placesSuggest_suggests" },
	        suggests.length > 0 ? suggests.map(function (suggest, key) {
	          return _react2.default.createElement(
	            "li",
	            {
	              key: key,
	              className: "placesSuggest_suggest " + (focusedSuggestIndex === key && "placesSuggest_suggest-active"),
	              onClick: function onClick() {
	                return _this5.handleSelectSuggest(suggest);
	              }
	            },
	            _this5.renderSuggest(suggest)
	          );
	        }) : this.renderNoResults()
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var selectedLabel = this.state.selectedLabel;
	      var _props2 = this.props,
	          children = _props2.children,
	          search = _props2.search;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "placesSuggest", onKeyDown: this.handleKeyDown },
	        children,
	        search && selectedLabel !== search && this.renderSuggests()
	      );
	    }
	  }]);
	
	  return GooglePlacesSuggest;
	}(_react.Component);
	
	GooglePlacesSuggest.propTypes = {
	  children: _react.PropTypes.any.isRequired,
	  googleMaps: _react.PropTypes.object.isRequired,
	  onSelectSuggest: _react.PropTypes.func,
	  renderSuggest: _react.PropTypes.func,
	  search: _react.PropTypes.string,
	  suggestRadius: _react.PropTypes.number,
	  textNoResults: _react.PropTypes.string
	};
	
	GooglePlacesSuggest.defaultProps = {
	  onSelectSuggest: function onSelectSuggest() {},
	  search: "",
	  suggestRadius: 20,
	  textNoResults: "No results"
	};
	
	exports.default = GooglePlacesSuggest;
	module.exports = exports["default"];
	//# sourceMappingURL=index.js.map

/***/ },

/***/ "./src/universal/collections/montgolfieres/montgolfieres.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.MontgolfiereSchema = exports.Montgolfieres = undefined;
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _baseSchema = __webpack_require__("./src/universal/collections/baseSchema.js");
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _uniformsBootstrap = __webpack_require__("./node_modules/uniforms-bootstrap3/index.js");
	
	var _dynamicListField = __webpack_require__("./src/universal/components/fields/dynamicListField.js");
	
	var _dynamicListField2 = _interopRequireDefault(_dynamicListField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var Mongo = Package.mongo.Mongo;
	var Montgolfieres = exports.Montgolfieres = new Mongo.Collection('montgolfieres');
	exports.default = Montgolfieres;
	
	
	Montgolfieres.attachRoles('montgolfieres');
	
	Montgolfieres.label = "La montgolfière";
	
	var MontgolfiereSchema = exports.MontgolfiereSchema = new SimpleSchema([{
		name: {
			type: String,
			label: "Nom"
		},
		archived: {
			type: Boolean,
			defaultValue: false,
			label: "Archiver ?"
		},
		online: {
			type: Boolean,
			defaultValue: true,
			label: "En ligne ?"
		},
		place: {
			type: String,
			label: "Lieu d'envol",
			allowedValues: ["anjou", "nantes"],
			defaultValue: "anjou",
			uniforms: {
				component: _uniformsBootstrap.SelectField,
				transform: function transform(option) {
					switch (option) {
						case "anjou":
							return "Montgolfieres d'anjou";
						case "nantes":
							return "Montgolfieres de nantes";
						default:
							return "N/C";
					}
				}
			}
		},
		availabilities: {
			type: [Object],
			optional: true,
			blackbox: true,
			hide: true,
			uniforms: {
				component: _uniformsBootstrap.HiddenField
			}
		},
		maxPassengers: {
			type: Number,
			min: 0,
			defaultValue: 0,
			label: "Nombre de passagers maximum"
		},
		allowedPilots: {
			type: [String],
			label: "Pilotes autorisés",
			hide: true,
			uniforms: {
				component: _dynamicListField2.default,
				options: Meteor.users,
				subscription: "users",
				filters: { "roles": { $in: ["pilot"] } }
			}
		},
		"allowedPilots.$": {
			type: String,
			label: "Pilote"
		},
		"defaultWeight": {
			type: Number,
			min: 0,
			defaultValue: 0,
			label: "Masse ballon (en kg)"
		},
		"emptyWeight": {
			type: Number,
			min: 0,
			defaultValue: 0,
			label: "Masse de carburant (en kg)"
		},
		"defaultAllowedWeight": {
			type: Number,
			min: 0,
			defaultValue: 0,
			label: "Masse maximale autorisée par défaut (en kg)"
		},
		maxWeight: {
			type: Object,
			label: "Masses maximales autorisées (en kg)",
			hide: true
		},
		"maxWeight.temp1": {
			type: Number,
			min: 0,
			defaultValue: 0,
			hide: true,
			label: "0° à 8° C"
		},
		"maxWeight.temp2": {
			type: Number,
			min: 0,
			defaultValue: 0,
			hide: true,
			label: "8° à 16° C"
		},
		"maxWeight.temp3": {
			type: Number,
			min: 0,
			defaultValue: 0,
			hide: true,
			label: "16° à 22° C"
		},
		"maxWeight.temp4": {
			type: Number,
			min: 0,
			defaultValue: 0,
			hide: true,
			label: "22° à 28° C"
		},
		"maxWeight.temp5": {
			type: Number,
			min: 0,
			defaultValue: 0,
			hide: true,
			label: "28° à 36° C"
		},
		"maxWeight.temp6": {
			type: Number,
			min: 0,
			defaultValue: 0,
			hide: true,
			label: "36° et +"
		}
	
	}, _baseSchema.BaseSchema]);
	
	Montgolfieres.attachSchema(MontgolfiereSchema);
	
	Montgolfieres.helpers({
		getPlace: function getPlace() {
			if (this.place == 'anjou') return "Montgolfieres d'anjou";else return "Montgolfieres de nantes";
		},
		flightScheduledAt: function flightScheduledAt(date, period) {
			return _flights.Flights.findOne({
				montgolfiereId: this._id,
				date: (0, _moment2.default)(date).startOf('day').toDate(),
				period: period
			});
		}
	});

/***/ },

/***/ "./src/universal/components/fields/dynamicListField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _filterDOMProps = __webpack_require__("./node_modules/uniforms/filterDOMProps.js");
	
	var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);
	
	var _joinName = __webpack_require__("./node_modules/uniforms/joinName.js");
	
	var _joinName2 = _interopRequireDefault(_joinName);
	
	var _DynamicListAddField = __webpack_require__("./src/universal/components/fields/DynamicListAddField.js");
	
	var _DynamicListAddField2 = _interopRequireDefault(_DynamicListAddField);
	
	var _ListItemField = __webpack_require__("./src/universal/components/fields/ListItemField.js");
	
	var _ListItemField2 = _interopRequireDefault(_ListItemField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var DynamicList = function (_React$Component) {
		(0, _inherits3.default)(DynamicList, _React$Component);
	
		function DynamicList(props) {
			(0, _classCallCheck3.default)(this, DynamicList);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (DynamicList.__proto__ || (0, _getPrototypeOf2.default)(DynamicList)).call(this, props));
	
			_this.state = {
				subscription: Meteor.subscribe(_this.props.subscription, function () {
					return _this.forceUpdate();
				})
			};
			return _this;
		}
	
		(0, _createClass3.default)(DynamicList, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.state.subscription.stop();
			}
		}, {
			key: 'resources',
			value: function resources() {
				return this.props.options.find((0, _assign2.default)(this.props.filters, { _id: { $nin: this.props.value } })).fetch();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					(0, _extends3.default)({
						className: (0, _classnames2.default)('panel panel-default dynamic-list-field', { 'panel-danger': this.props.error }, this.props.className)
					}, (0, _filterDOMProps2.default)(this.props)),
					_react2.default.createElement(
						'div',
						{ className: 'panel-body' },
						this.props.label && _react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)('panel-heading', { 'has-error': this.props.error }) },
							_react2.default.createElement(
								'label',
								{ className: 'control-label' },
								this.props.label,
								'\xA0:'
							),
							_react2.default.createElement('br', null),
							_react2.default.createElement(_DynamicListAddField2.default, { name: this.props.name + '.$', initialCount: this.props.initialCount, addIcon: this.props.addIcon, valueList: this.resources() }),
							!!(this.props.errorMessage && this.props.showInlineError) && _react2.default.createElement(
								'span',
								{ className: 'help-block' },
								this.props.errorMessage
							)
						),
						this.props.value && this.state.subscription.ready() && this.props.value.map(function (item, index) {
							return _react2.default.createElement(_ListItemField2.default, (0, _extends3.default)({
								key: index,
								label: null,
								children: _this2.props.options.findOne({ '_id': item }) ? _react2.default.createElement(
									'span',
									null,
									_this2.props.options.findOne({ '_id': item }).username
								) : !_this2.props.options.findOne({ '_id': item }) && _react2.default.createElement(
									'span',
									null,
									'Utilisateur supprim\xE9'
								),
								name: (0, _joinName2.default)(_this2.props.name, index),
								removeIcon: _this2.props.removeIcon
							}, _this2.props.itemProps));
						})
					)
				);
			}
		}]);
		return DynamicList;
	}(_react2.default.Component);
	
	exports.default = (0, _connectField2.default)(DynamicList, { includeInChain: false });

/***/ },

/***/ "./src/universal/components/fields/DynamicListAddField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _filterDOMProps = __webpack_require__("./node_modules/uniforms/filterDOMProps.js");
	
	var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _AutoField = __webpack_require__("./node_modules/uniforms-bootstrap3/AutoField.js");
	
	var _AutoField2 = _interopRequireDefault(_AutoField);
	
	var _SelectField = __webpack_require__("./node_modules/uniforms-bootstrap3/SelectField.js");
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DynamicListAdd = function DynamicListAdd(_ref) {
		var addIcon = _ref.addIcon,
		    className = _ref.className,
		    disabled = _ref.disabled,
		    onChange = _ref.onChange,
		    parent = _ref.parent,
		    value = _ref.value,
		    valueList = _ref.valueList,
		    props = (0, _objectWithoutProperties3.default)(_ref, ['addIcon', 'className', 'disabled', 'onChange', 'parent', 'value', 'valueList']);
	
		var limitNotReached = !disabled && !(parent.maxCount <= parent.value.length);
		var selectRef = null;
	
		return _react2.default.createElement(
			_rubix.Col,
			{ sm: 12 },
			_react2.default.createElement(
				'div',
				null,
				valueList && valueList.length > 0 && _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Col,
						{ sm: 10 },
						_react2.default.createElement(
							_rubix.FormControl,
							{ componentClass: 'select', type: 'select', inputRef: function inputRef(input) {
									selectRef = input;
								} },
							valueList.map(function (item) {
								return _react2.default.createElement(
									'option',
									{ value: item._id },
									item.username && _react2.default.createElement(
										'span',
										null,
										item.username
									)
								);
							})
						)
					),
					_react2.default.createElement(
						_rubix.Col,
						{ sm: 2 },
						_react2.default.createElement(
							'div',
							(0, _extends3.default)({
								onClick: function onClick() {
									return limitNotReached && !parent.value.includes(selectRef.value) && parent.onChange(parent.value.concat([selectRef.value]));
								}
							}, (0, _filterDOMProps2.default)(props)),
							addIcon
						)
					),
					_react2.default.createElement('br', null),
					_react2.default.createElement('br', null)
				)
			)
		);
	};
	
	DynamicListAdd.defaultProps = {
		addIcon: _react2.default.createElement(
			_rubix.Button,
			{ bsStyle: 'success' },
			'Ajouter'
		),
		valueList: []
	};
	
	exports.default = (0, _connectField2.default)(DynamicListAdd, { includeParent: true, initialValue: false });

/***/ },

/***/ "./src/universal/components/fields/ListItemField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _joinName = __webpack_require__("./node_modules/uniforms/joinName.js");
	
	var _joinName2 = _interopRequireDefault(_joinName);
	
	var _uniformsBootstrap = __webpack_require__("./node_modules/uniforms-bootstrap3/index.js");
	
	var _ListDelField = __webpack_require__("./src/universal/components/fields/ListDelField.js");
	
	var _ListDelField2 = _interopRequireDefault(_ListDelField);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListItem = function ListItem(_ref) {
	    var removeIcon = _ref.removeIcon,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['removeIcon']);
	    return _react2.default.createElement(
	        _rubix.Col,
	        { sm: 12 },
	        _react2.default.createElement(
	            _rubix.Col,
	            { sm: 2 },
	            _react2.default.createElement(_ListDelField2.default, { name: props.name, removeIcon: removeIcon })
	        ),
	        _react2.default.createElement(
	            _rubix.Col,
	            { sm: 10 },
	            _react2.default.createElement(
	                _rubix.Table,
	                null,
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    props.children ? _react.Children.map(props.children, function (child) {
	                        return _react2.default.cloneElement(child, {
	                            className: 'col-xs-11',
	                            name: (0, _joinName2.default)(props.name, child.props.name),
	                            label: null
	                        });
	                    }) : _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(_uniformsBootstrap.AutoField, props)
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = (0, _connectField2.default)(ListItem, { includeInChain: false });

/***/ },

/***/ "./src/universal/components/fields/ListDelField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _filterDOMProps = __webpack_require__("./node_modules/uniforms/filterDOMProps.js");
	
	var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListDel = function ListDel(_ref) {
	    var className = _ref.className,
	        disabled = _ref.disabled,
	        name = _ref.name,
	        parent = _ref.parent,
	        removeIcon = _ref.removeIcon,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['className', 'disabled', 'name', 'parent', 'removeIcon']);
	
	    var fieldIndex = +name.slice(1 + name.lastIndexOf('.'));
	    var limitNotReached = !disabled && !(parent.minCount >= parent.value.length);
	
	    return _react2.default.createElement(
	        'span',
	        (0, _extends3.default)({
	            onClick: function onClick() {
	                return limitNotReached && parent.onChange([].concat(parent.value.slice(0, fieldIndex)).concat(parent.value.slice(1 + fieldIndex)));
	            }
	        }, (0, _filterDOMProps2.default)(props)),
	        removeIcon
	    );
	};
	
	ListDel.defaultProps = { removeIcon: _react2.default.createElement(
	        _rubix.Button,
	        { bsStyle: 'danger' },
	        'Supprimer'
	    ) };
	
	exports.default = (0, _connectField2.default)(ListDel, { includeParent: true, initialValue: false });

/***/ },

/***/ "./src/universal/collections/reservations/reservations.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Reservation = exports.Reservations = undefined;
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _addresses = __webpack_require__("./src/universal/collections/reservations/addresses.js");
	
	var _baseSchema = __webpack_require__("./src/universal/collections/baseSchema.js");
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _flightsType = __webpack_require__("./src/universal/collections/flights-type/flights-type.js");
	
	var _options = __webpack_require__("./src/universal/collections/flights-type/options.js");
	
	var _promotions = __webpack_require__("./src/universal/collections/flights-type/promotions.js");
	
	var _passengers = __webpack_require__("./src/universal/collections/reservations/passengers.js");
	
	var _payments = __webpack_require__("./src/universal/collections/reservations/payments.js");
	
	var _methods = __webpack_require__("./src/universal/collections/reservations/methods.js");
	
	var _axios = __webpack_require__("./node_modules/axios/index.js");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Email = Package.email.Email;
	var Meteor = Package.meteor.Meteor;
	var Mongo = Package.mongo.Mongo;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var HTTP = Package.http.HTTP;
	var Base64 = Package.base64.Base64;
	var Reservations = exports.Reservations = new Mongo.Collection('reservations');
	
	
	Reservations.attachRoles('reservations');
	
	var Reservation = exports.Reservation = new SimpleSchema([{
		id: {
			type: Number,
			label: "N° Réservation",
			autoValue: function autoValue() {
				if (this.isInsert) {
					var last = Reservations.find({}, { sort: { id: -1 }, limit: 1 }).fetch();
					if (!last[0]) return 1;
					return parseInt(last[0].id + 1);
				} else {
					this.unset(); // Prevent user from supplying their own value
				}
			}
		},
		id_facture: {
			type: String,
			label: "N° Facture",
			optional: true,
			autoValue: function autoValue() {
				var d = new Date();
				var total = parseInt(Reservations.find({ id_facture: { $regex: ".*" + d.getFullYear().toString().slice(-2) + "-.*" } }).fetch().length) + 1;
	
				var numerotation = '';
				for (var i = 0; i < 4 - total.toString().length; i++) {
					numerotation += '0';
				}
	
				if (!this.field("id_facture").value && this.field("state").value < 3) {
					return d.getFullYear().toString().slice(-2) + '-' + numerotation + total;
				} else {
					return this.field("id_facture").value;
				}
			}
		},
		id_billet: {
			type: String,
			label: "N° Billet",
			optional: true,
			autoValue: function autoValue() {
				if (!this.field("id_billet").value && this.field("state").value == 3) {
					return _methods.getBilletID.call({});
				} else {
					return this.field("id_billet").value;
				}
			}
		},
		id_internet: {
			type: String,
			label: "Identifiant internet",
			optional: true
		},
		subscriber: {
			type: _addresses.Addresses,
			label: "information d'achat"
		},
		delivery: {
			type: _addresses.Addresses,
			label: "information de livraison"
		},
		passengers: {
			type: [_passengers.Passengers],
			label: "passagers"
		},
		selectedFlight: {
			type: _flights.Flights,
			label: "vol"
		},
		place: {
			type: String,
			label: "Zone d'envol"
		},
		options: {
			type: [_options.Options],
			label: "Options",
			optional: true
		},
		promotions: {
			type: [String],
			label: "Promotions",
			optional: true
		},
		period: {
			type: String,
			label: "Période",
			optional: true
		},
		periodTime: {
			type: String,
			label: "Période Matin/Soir",
			optional: true
		},
		author: {
			type: String,
			label: "Auteur",
			optional: true
		},
		state: {
			type: Number,
			label: "Status"
		},
		payment: {
			type: Number,
			label: "Mode de paiement"
		},
		billAt: {
			type: String,
			label: "Facturé le",
			optional: true,
			autoValue: function autoValue() {
				if (!this.field("billAt").value && this.field("state").value >= 3) return (0, _moment2.default)().format('DD/MM/YYYY');else return this.field("billAt").value;
			}
		},
		price: {
			type: String,
			label: "prix"
		},
		solde: {
			type: String,
			label: "Solde restant",
			optional: true
		},
		infoPayment: {
			type: String,
			label: "Information sur le paiement",
			optional: true
		},
		infoReservation: {
			type: String,
			label: "Information sur la réservation",
			optional: true
		},
		linkReservation: {
			type: String,
			label: "Billets liés",
			optional: true
		},
		infoClient: {
			type: String,
			label: "Information du client",
			optional: true
		},
		livraisonType: {
			type: Number,
			label: "Billet ou Billet + Facture ?",
			optional: true
		},
		searchName: {
			type: String,
			optional: true,
			label: "Recherche par nom/prenom"
		},
		scheduledAt: {
			type: Date,
			optional: true
		},
		history: {
			type: [Object],
			defaultValue: []
		},
		"history.$": {
			type: Object,
			blackbox: true
		},
		userId: {
			type: String,
			label: "Auteur",
			optional: true
		},
		freeFlights: {
			type: Boolean,
			label: "Vol gratuit",
			optional: true
		},
		groupBill: {
			type: Boolean,
			label: "Facturé en groupe",
			optional: true
		},
		pendingSMS: {
			type: Boolean,
			optional: true,
			label: "SMS en attente"
		},
		impression: {
			type: Boolean,
			optional: true,
			label: "Ne pas envoyer le billet"
		},
		mailSending: {
			type: Number,
			optional: true,
			defaultValue: 0
		},
		flightName: {
			type: String,
			label: "Nom du vol",
			optional: true
		},
		codePromoName: {
			label: "Code Promo Nom",
			type: String,
			optional: true
		},
		codePromoType: {
			label: "Code Promo Type",
			type: String,
			optional: true
		},
		codePromoReduction: {
			label: "Code Promo Reduction",
			type: String,
			optional: true
		},
		color: {
			label: "Couleur",
			type: String,
			optional: true
		},
		expireAt: {
			label: "Expire en",
			type: String,
			optional: true
		}
	}, _baseSchema.BaseSchema]);
	
	Reservations.attachSchema(Reservation);
	
	// Dbs methods :
	
	Meteor.methods({
		'reservations.insert': function reservationsInsert(attributes) {
			var subscriber = _addresses.Addresses.insert(attributes.subscriber);
			var delivery = _addresses.Addresses.insert(attributes.delivery);
	
			attributes.subscriber = subscriber;
			attributes.delivery = delivery;
	
			Reservations.insert(attributes);
		},
		'reservations.update': function reservationsUpdate(_ref) {
			var _id = _ref._id,
			    attributes = _ref.attributes;
	
			Reservations.update(_id, { "$set": attributes });
		},
	
		sendEmail: function sendEmail(to, from, subject, html) {
			Email.send({
				to: to,
				from: from,
				subject: subject,
				html: html
			});
		},
		sendEmailV2: function sendEmailV2(email, subject, templateId, data) {
	
			if (Meteor.isServer) {
	
				console.log(data);
	
				var btoa = function btoa(text) {
					return Buffer.from(text, 'binary').toString('base64');
				};
	
				var basicAuth = 'Basic ' + btoa(process.env.MJ_APIKEY_PUBLIC + ':' + process.env.MJ_APIKEY_PRIVATE);
	
				console.log(basicAuth);
				_axios2.default.post('https://api.mailjet.com/v3.1/send', {
					"Messages": [{
						"From": {
							"Email": "noreply@montgolfieres.fr",
							"Name": "Anjou Nantes Montgolfieres"
						},
						"To": [{
							"Email": email
						}],
						"Subject": subject,
						"TemplateID": templateId,
						"TemplateLanguage": true,
						"Variables": data
					}]
				}, {
					headers: { 'Authorization': +basicAuth },
					auth: {
						username: process.env.MJ_APIKEY_PUBLIC,
						password: process.env.MJ_APIKEY_PRIVATE
					}
				}).then(function (response) {
					console.log('Email sended !');
				}).catch(function (error) {
					console.log('Error on Authentication', error);
				});
			}
		}
	});
	
	Reservations.after.insert(function (userId, doc) {
		if (doc.freeFlights) {
			var freeFlights = Meteor.user().profile.freeFlights - doc.passengers.length;
			Meteor.users.update(Meteor.user()._id, { "$set": { 'profile.freeFlights': freeFlights } });
		}
	
		if (doc.userId) {
			/*let d = new Date();
	  let last = Reservations.find({id_billet: {$regex: ".*" + d.getFullYear().toString().slice(-2) + "-.*"}}, {sort: {id_billet: -1}}).fetch();
	  	let total = parseInt(last[0].id_billet.split('-')[1]) + 1;
	  	let numerotation = '';
	  for(let i = 0; i < (4 - total.toString().length); i++) {
	  numerotation += '0';
	  }*/
	
			Reservations.update(doc._id, { "$set": { 'id_billet': _methods.getBilletID.call({}), 'state': 5 } });
		}
	});
	
	// Helpers :
	Reservations.helpers({
		getSolde: function getSolde() {
			var payments = _payments.Payments.find({ reservation: this._id }).fetch();
			var solde = this.getPrice();
	
			_lodash2.default.map(payments, function (payment) {
				solde -= parseFloat(payment.montant);
			});
	
			if (solde != this.solde) {
				Reservations.update(this._id, { '$set': { solde: solde } });
			}
	
			return solde;
		},
		getPrice: function getPrice() {
			var passengers = [];
			var price = 0;
			_lodash2.default.each(this.passengers, function (passenger) {
				var data = _passengers.Passengers.findOne({ _id: passenger });
				if (data) price += parseInt(data.price);
			});
	
			if (this.freeFlights) return 0;
	
			return price;
		},
		getCancelTime: function getCancelTime() {
			var counter = 0;
			_lodash2.default.each(this.history, function (history) {
				if (history.type == 'cancelled') counter++;
			});
	
			return counter;
		},
		getLastCancelTime: function getLastCancelTime() {
			var target = 'null';
			_lodash2.default.each(this.history, function (history) {
				if (history.type == 'cancelled') {
					target = history.scheduledAt;
				}
			});
	
			return target;
		},
		getSubscriber: function getSubscriber() {
			return _addresses.Addresses.findOne({ _id: this.subscriber });
		},
		getDelivery: function getDelivery() {
			return _addresses.Addresses.findOne({ _id: this.delivery });
		},
		getPassengers: function getPassengers() {
			var passengers = [];
			_lodash2.default.each(this.passengers, function (passenger) {
				var data = _passengers.Passengers.findOne({ _id: passenger });
				if (data) {
					data.AEM = data.getAEM();
					passengers.push(data);
				}
			});
			return passengers;
		},
		getFlightType: function getFlightType() {
			return _flightsType.FlightsType.findOne({ _id: this.selectedFlight });
		},
		getFlightColor: function getFlightColor() {
			return _flightsType.FlightsType.findOne({ _id: this.selectedFlight }).color;
		},
		getOptions: function getOptions() {
			var options = [];
			_lodash2.default.each(this.options, function (option) {
				options.push(_options.Options.findOne({ _id: option }));
			});
			return options;
		},
		getPromotions: function getPromotions() {
			var promotions = [];
			_lodash2.default.each(this.promotions, function (promotion) {
				promotions.push(_promotions.Promotions.findOne({ _id: promotion }));
			});
			return promotions;
		},
		getPlace: function getPlace() {
			if (this.place == "anjou") return "Site d'envol Anjou";else return "Site d'envol de Nantes";
		},
		getFlightName: function getFlightName() {
			if (!this.flightName && this.getFlightType()) {
				Reservations.update(this._id, { '$set': { flightName: this.getFlightType().title } });
			}
	
			if (!this.flightName && !this.getFlightType()) {
				Reservations.update(this._id, { '$set': { flightName: '-' } });
			}
	
			return this.flightName;
		},
		getPeriod: function getPeriod() {
	
			//return this.period;
	
			if (this.period == "Libre date" || this.period == "Semaine uniquement") {
				return this.period;
			}
	
			if (this.period == "Tous les jours") {
				return "Libre date";
			}
	
			if (this.period == "aucune" || this.period == "Aucune restriction") return "Libre date";else return "Semaine uniquement";
		},
		getPeriodTime: function getPeriodTime() {
	
			var period = '';
	
			if (!this.periodTime) period = this.period;else period = this.periodTime;
	
			if (period == "morning") return "Matin";else return "Soir";
		},
		getState: function getState() {
			if (this.state == 2) return "En attente de paiement";
			if (this.state == 3) return "Facturé";
			if (this.state == 4) return "Confirmée";
			if (this.state == 5) return "Expédiée";
			if (this.state == 6) return "Volée";
		},
		getPayment: function getPayment() {
			if (this.payment == 0) return "En attente de paiement";
			if (this.payment == 1) return "En liquide";
			if (this.payment == 2) return "Par virement";
			if (this.payment == 3) return "En CB";
		},
		getAuthor: function getAuthor() {
			Meteor.subscribe('users');
			var user = Meteor.users.findOne(this.userId);
	
			if (!user) return '-';
	
			return user.profile.firstName + ' ' + user.profile.lastName;
		},
		getFlight: function getFlight() {
			return _flights.Flights.findOne({ reservationIds: { $in: [this._id] }, date: this.scheduledAt });
		},
		totalWeight: function totalWeight() {
			return _lodash2.default.reduce(_passengers.Passengers.find({ _id: { $in: this.passengers } }).fetch(), function (weight, passenger) {
				return weight + parseInt(passenger.weight) + 4;
			}, 0);
		},
		isPartners: function isPartners() {
			var user = Meteor.users.findOne(this.userId);
	
			if (!user) return false;
	
			if (_lodash2.default.includes(user.roles, 'partner')) return true;
	
			return false;
		},
		getPartner: function getPartner() {
			Meteor.subscribe('users');
			return Meteor.users.findOne(this.userId);
		},
		consume: function consume() {
			Reservations.update(this._id, { '$set': { state: 6 } });
	
			/*let subscriber = this.getSubscriber();
	  	let passengers = [];
	  _.each(this.getPassengers(), (passenger) => {
	  passengers.push({
	  "name": this.flightName .
	  });
	  });
	  let json_params = {
	  "api_token": "iptSvl4EZP15z1UdGfaD/2pulse",
	  "invoice": {
	  "kind":"vat",
	  "number": null,
	  "seller_name": "Anjou - Nantes Montgolfieres",
	  "buyer_name": subscriber.name,
	  "buyer_city": subscriber.city,
	  "positions":[
	  {"name":"Produkt A1", "tax":23, "total_price_gross":10.23, "quantity":1},
	  {"name":"Produkt A2", "tax":0, "total_price_gross":50, "quantity":2}
	  ]
	  }}
	  //alert(JSON.stringify(json_params))
	  let endpoint = 'https://2pulse.vosfactures.fr/invoices.json'
	  // Création de la facture :
	  HTTP.post(endpoint, {
	  data: json_params,
	  dataType: 'json',
	  }, (error, result) => {
	  result = JSON.parse(result.content);
	  console.log('result', result);
	  });*/
		},
		sendBillet: function sendBillet() {
			var _this = this;
	
			var data = {
				'reservation': this,
				'period': this.getPeriod(),
				'place': this.getPlace(),
				'flight': this.getFlightType(),
				'passengers': this.getPassengers(),
				'subscriber': this.getSubscriber(),
				'delivery': this.getDelivery(),
				'password': (0, _moment2.default)(this.createdAt).format('X').slice(-4)
			};
	
			data.reservation.expireAt = (0, _moment2.default)(data.reservation.billAt, 'DD-MM-YYYY').add(2, 'years').format('DD/MM/YYYY');
	
			HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=billet', {
				data: data,
				strictSSL: false
			}, function (error, result) {
				var aerostack_url =  true ? 'https://resa.montgolfieres.fr/sendBillet' : 'http://localhost:4000/sendBillet';
				HTTP.get(aerostack_url + '?id=' + result.data.id + '&email=' + _this.getSubscriber().email + '&id_billet=' + _this.id_billet + '&password=' + (0, _moment2.default)(_this.createdAt).format('X').slice(-4), {}, function (error, result) {});
			});
		},
		getEmail: function getEmail() {
	
			var email = null;
	
			//Vérification email des passagers :
			_lodash2.default.each(this.getPassengers(), function (passenger) {
				if (passenger.email) {
					email = passenger.email;
				}
			});
	
			if (email == null && this.getSubscriber()) {
				email = this.getSubscriber().email;
			}
	
			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (re.test(email)) return email;
	
			return false;
		},
		sendPassengersEmail: function sendPassengersEmail(infos) {
	
			_lodash2.default.each(this.passengers, function (passenger) {
				var data = _passengers.Passengers.findOne({ _id: passenger });
				if (data) {
					if (data.email) {
						console.log('passenger has email', data.email);
						Meteor.call('sendEmailV2', data.email, 'Plannification de votre vol', 4011951, { 'infos': infos });
					}
				}
			});
		},
		sendCancelDateEmail: function sendCancelDateEmail() {}
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer, __webpack_require__("./node_modules/process/browser.js")))

/***/ },

/***/ "./src/universal/collections/reservations/addresses.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Mongo = Package.mongo.Mongo;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var Addresses = exports.Addresses = new Mongo.Collection('addresses');
	
	Addresses.allow({
	    insert: function insert() {
	        return true;
	    },
	    update: function update() {
	        return true;
	    },
	    remove: function remove() {
	        return true;
	    }
	});
	
	var Address = exports.Address = new SimpleSchema({
	    civility: {
	        type: String,
	        label: "Civilité"
	    },
	    name: {
	        type: String,
	        label: "Nom / Prénom"
	    },
	    street: {
	        type: String,
	        label: "N° / Voie"
	    },
	    city: {
	        type: String,
	        label: "Code Postal / Ville"
	    },
	    phone: {
	        type: String,
	        label: "Téléphone",
	        optional: true
	    },
	    email: {
	        type: String,
	        label: "Email",
	        optional: true
	    },
	    createdAt: {
	        type: Date,
	        label: "Date de création",
	        optional: true
	    },
	    updatedAt: {
	        type: Date,
	        label: "Dernière mise à jour",
	        optional: true
	    }
	});
	
	Addresses.attachSchema(Address);

/***/ },

/***/ "./src/universal/collections/flights-type/flights-type.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FlightType = exports.FlightsType = undefined;
	
	var _places = __webpack_require__("./src/universal/collections/flights-type/places.js");
	
	var _options = __webpack_require__("./src/universal/collections/flights-type/options.js");
	
	var _prices = __webpack_require__("./src/universal/collections/flights-type/prices.js");
	
	var _promotions = __webpack_require__("./src/universal/collections/flights-type/promotions.js");
	
	var Meteor = Package.meteor.Meteor;
	var Mongo = Package.mongo.Mongo;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var FlightsType = exports.FlightsType = new Mongo.Collection('flights_type');
	var FlightType = exports.FlightType = new SimpleSchema({
	    title: {
	        type: String,
	        label: "Titre"
	    },
	    description: {
	        type: String,
	        label: "Description",
	        optional: true
	    },
	    remboursement: {
	        type: String,
	        label: "Remboursement",
	        optional: true
	    },
	    color: {
	        type: String,
	        label: "Couleur",
	        optional: true
	    },
	    constraintPlace: {
	        type: String,
	        label: "Contrainte de lieu",
	        optional: true
	    },
	    constraintPeriod: {
	        type: String,
	        label: "Contrainte de periode",
	        optional: true
	    },
	    constraintPassengerMin: {
	        type: Number,
	        label: "Nombre de passagers minimum",
	        autoValue: function autoValue(value) {
	            if (!value) return 0;
	        }
	    },
	    constraintPassengerMax: {
	        type: Number,
	        label: "Nombre de passagers maximum",
	        autoValue: function autoValue(value) {
	            if (!value) return 7;
	        }
	    },
	    priceIds: {
	        type: [_prices.Prices],
	        label: "Tarifs possibles",
	        optional: true
	    },
	    priceSemaine: {
	        type: Number,
	        label: "Prix SEMAINE",
	        optional: true
	    },
	    priceLibreDate: {
	        type: Number,
	        label: "Prix LIBRE DATE",
	        optional: true
	    },
	    priceEnfant: {
	        type: Number,
	        label: "Prix ENFANT",
	        optional: true
	    },
	    optionIds: {
	        type: [_options.Options],
	        label: "Options possibles"
	    },
	    promotionIds: {
	        type: [_promotions.Promotions],
	        label: "Promotions possibles"
	    },
	    reference: {
	        type: String,
	        label: "Référence sur le site internet",
	        optional: true
	    },
	    infoBillet: {
	        type: String,
	        label: "Info sur le billet",
	        optional: true
	    },
	    partnerId: {
	        type: String,
	        label: "Vol partenaire",
	        optional: true
	    },
	    quantity: {
	        type: Number,
	        label: "Nombre maximum d'utilisation",
	        optional: true
	    },
	    deleted: {
	        type: Boolean,
	        label: "Supprimé",
	        defaultValue: false
	    },
	    createdAt: {
	        type: Date,
	        label: "Date de création"
	    }
	});
	
	FlightsType.attachSchema(FlightType);
	
	// Dbs methods :
	
	Meteor.methods({
	    'flightsType.remove': function flightsTypeRemove(_id) {
	        FlightsType.update(_id, { "$set": { deleted: true } });
	    },
	    'flightsType.update': function flightsTypeUpdate(_ref) {
	        var _id = _ref._id,
	            attributes = _ref.attributes;
	
	        FlightsType.update(_id, { "$set": attributes });
	    },
	    'flightsType.insert': function flightsTypeInsert(_ref2) {
	        var attributes = _ref2.attributes;
	
	        FlightsType.insert(attributes);
	    },
	    'flightsType.insertPartner': function flightsTypeInsertPartner(_ref3) {
	        var attributes = _ref3.attributes;
	
	        delete attributes._id;
	        FlightsType.insert(attributes);
	
	        console.log('attributes', attributes);
	    }
	});
	
	FlightsType.helpers({
	    prices: function prices() {
	        return _prices.Prices.find({ _id: { $in: this.priceIds } }).fetch();
	    },
	    options: function options() {
	        return _options.Options.find({ _id: { $in: this.optionIds } }).fetch();
	    },
	    promotions: function promotions() {
	        return _promotions.Promotions.find({ _id: { $in: this.promotionIds } }).fetch();
	    },
	    periodes: function periodes() {
	        if (this.constraintPeriod == 'Aucune restriction') {
	            return [{
	                _id: 'aucune',
	                name: 'Tous les jours'
	            }, {
	                _id: "Semaine uniquement",
	                name: "Semaine uniquement"
	            }];
	        } else {
	            return [{
	                _id: "Semaine uniquement",
	                name: "Semaine uniquement"
	            }];
	        }
	    },
	    places: function places() {
	
	        return [{
	            _id: "anjou",
	            name: "Sites d'envol Anjou"
	        }, {
	            _id: "nantes",
	            name: "Sites d'envol de Nantes"
	        }];
	
	        if (this.constraintPlace == 'aucune') {
	            return [{
	                _id: "anjou",
	                name: "Sites d'envol Anjou"
	            }, {
	                _id: "nantes",
	                name: "Sites d'envol de Nantes"
	            }];
	        }
	        if (this.constraintPlace == 'anjou') {
	            return [{
	                _id: "anjou",
	                name: "Sites d'envol Anjou"
	            }];
	        }
	        if (this.constraintPlace == 'nantes') {
	            return [{
	                _id: "nantes",
	                name: "Sites d'envol de Nantes"
	            }];
	        }
	    }
	});

/***/ },

/***/ "./src/universal/collections/flights-type/places.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Mongo = Package.mongo.Mongo;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var Places = exports.Places = new Mongo.Collection('flight_places');
	var Place = exports.Place = new SimpleSchema({
	    id: {
	        type: SimpleSchema.RegEx.Id,
	        label: "Id",
	        min: 0
	    },
	    title: {
	        type: String,
	        label: "Nom du lieu d'envol"
	    }
	});
	
	Places.attachSchema(Place);

/***/ },

/***/ "./src/universal/collections/flights-type/options.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Meteor = Package.meteor.Meteor;
	var Mongo = Package.mongo.Mongo;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var Options = exports.Options = new Mongo.Collection('flight_options');
	
	Options.allow({
	  insert: function insert() {
	    return true;
	  },
	  update: function update() {
	    return true;
	  },
	  remove: function remove() {
	    return true;
	  }
	});
	
	var Option = exports.Option = new SimpleSchema({
	  title: {
	    type: String,
	    label: "titre"
	  },
	  price: {
	    type: Number,
	    label: "prix"
	  },
	  reference: {
	    type: String,
	    label: "Référence sur le site internet",
	    optional: true
	  },
	  createdAt: {
	    type: Date,
	    label: "Date de création",
	    autoValue: function autoValue() {
	      return new Date();
	    }
	  }
	});
	
	Options.attachSchema(Option);
	
	// Dbs methods : 
	
	Meteor.methods({
	  'options.remove': function optionsRemove(optionId) {
	    Options.remove(optionId);
	  },
	  'options.update': function optionsUpdate(_ref) {
	    var _id = _ref._id,
	        attributes = _ref.attributes;
	
	    Options.update(_id, { "$set": attributes });
	  },
	  'options.insert': function optionsInsert(_ref2) {
	    var attributes = _ref2.attributes;
	
	    Options.insert(attributes);
	  }
	});
	
	Options.helpers({
	  displayValue: function displayValue() {
	    return this.title + ' - ' + this.price + '€';
	  }
	});

/***/ },

/***/ "./src/universal/collections/flights-type/prices.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Price = exports.Prices = undefined;
	
	var _places = __webpack_require__("./src/universal/collections/flights-type/places.js");
	
	var _flightsType = __webpack_require__("./src/universal/collections/flights-type/flights-type.js");
	
	var Meteor = Package.meteor.Meteor;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var Mongo = Package.mongo.Mongo;
	var Prices = exports.Prices = new Mongo.Collection('flight_prices');
	
	Prices.allow({
	    insert: function insert() {
	        return true;
	    },
	    update: function update() {
	        return true;
	    },
	    remove: function remove() {
	        return true;
	    }
	});
	
	var Price = exports.Price = new SimpleSchema({
	    title: {
	        type: String,
	        label: "Titre"
	    },
	    price: {
	        type: Number,
	        label: "Prix par passager",
	        decimal: true
	    },
	    flightId: {
	        type: String,
	        label: "Id du vol",
	        optional: true
	    },
	    constraintPeriod: {
	        type: String,
	        label: "Contrainte de période",
	        allowedValues: ["Aucune restriction", "Semaine uniquement"]
	    },
	    constraintPlace: {
	        type: String,
	        label: "Contrainte de lieu",
	        allowedValues: ["aucune", "anjou", "nantes"]
	    },
	    constraintAge: {
	        type: Number,
	        label: "Contrainte d'age",
	        optional: true
	    },
	    constraintWeight: {
	        type: Number,
	        label: "Contraite de poids",
	        optional: true
	    },
	    reference: {
	        type: String,
	        label: "Référence sur le site internet",
	        optional: true
	    },
	    partnerId: {
	        type: String,
	        label: "Vol partenaire",
	        optional: true
	    },
	    createdAt: {
	        type: Date,
	        label: "Date de création"
	    },
	    editedAt: {
	        type: Date,
	        label: "Dernière modification",
	        autoValue: function autoValue() {
	            return new Date();
	        }
	    }
	});
	
	Prices.attachSchema(Price);
	
	// Dbs methods : 
	
	Meteor.methods({
	    'prices.remove': function pricesRemove(priceId) {
	        Prices.remove(priceId);
	    },
	    'prices.update': function pricesUpdate(_ref) {
	        var _id = _ref._id,
	            attributes = _ref.attributes;
	
	        Prices.update(_id, { "$set": attributes });
	    },
	    'prices.insert': function pricesInsert(_ref2) {
	        var attributes = _ref2.attributes;
	
	        Prices.insert(attributes);
	    }
	});
	
	Prices.helpers({
	    flight: function flight() {
	        return _flightsType.FlightsType.findOne(this.flightId);
	    }
	});

/***/ },

/***/ "./src/universal/collections/flights-type/promotions.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Promotion = exports.Promotions = undefined;
	
	var _users = __webpack_require__("./src/universal/collections/users/users.js");
	
	var Meteor = Package.meteor.Meteor;
	var Mongo = Package.mongo.Mongo;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var Promotions = exports.Promotions = new Mongo.Collection('flight_promotions');
	var Promotion = exports.Promotion = new SimpleSchema({
	    title: {
	        type: String,
	        label: "Titre"
	    },
	    percentage: {
	        type: SimpleSchema.Integer,
	        label: "Pourcentage de réduction"
	    },
	    constraintOfUsers: {
	        type: SimpleSchema.Integer,
	        label: "Nombre min. de passagers"
	    },
	    reference: {
	        type: String,
	        label: "Référence sur le site internet",
	        optional: true
	    },
	    createdAt: {
	        type: Date,
	        label: "Date de création"
	    }
	});
	
	Promotions.attachSchema(Promotion);
	
	// Dbs methods : 
	
	Meteor.methods({
	    'promotions.remove': function promotionsRemove(promotionId) {
	        Promotions.remove(promotionId);
	    },
	    'promotions.update': function promotionsUpdate(_ref) {
	        var _id = _ref._id,
	            attributes = _ref.attributes;
	
	        Promotions.update(_id, { "$set": attributes });
	    },
	    'promotions.insert': function promotionsInsert(_ref2) {
	        var attributes = _ref2.attributes;
	
	        Promotions.insert(attributes);
	    }
	});

/***/ },

/***/ "./src/universal/collections/reservations/passengers.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Passenger = exports.Passengers = undefined;
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	var _addresses = __webpack_require__("./src/universal/collections/reservations/addresses.js");
	
	var Meteor = Package.meteor.Meteor;
	var Mongo = Package.mongo.Mongo;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var Passengers = exports.Passengers = new Mongo.Collection('passengers');
	
	Passengers.allow({
	    insert: function insert() {
	        return true;
	    },
	    update: function update() {
	        return true;
	    },
	    remove: function remove() {
	        return true;
	    }
	});
	
	var Passenger = exports.Passenger = new SimpleSchema({
	    tempID: {
	        type: String,
	        label: "ID temporaire",
	        optional: true
	    },
	    firstName: {
	        type: String,
	        label: "Prenom",
	        optional: true
	    },
	    lastName: {
	        type: String,
	        label: "Nom",
	        optional: true
	    },
	    age: {
	        type: SimpleSchema.Integer,
	        label: "Age",
	        min: 8
	    },
	    weight: {
	        type: Number,
	        label: "Poids"
	    },
	    phone: {
	        type: String,
	        label: "Téléphone",
	        optional: true
	    },
	    email: {
	        type: String,
	        label: "Email",
	        optional: true
	    },
	    info: {
	        type: String,
	        label: "Information",
	        optional: true
	    },
	    price: {
	        type: String,
	        label: "Prix individuel",
	        optional: true
	    },
	    mobility: {
	        type: Boolean,
	        label: "Mobilité réduite ?",
	        optional: true
	    }
	});
	
	Passengers.attachSchema(Passenger);
	
	Meteor.methods({
	    'passengers.remove': function passengersRemove(passengerId) {
	        Passengers.remove(passengerId);
	    },
	    'passengers.update': function passengersUpdate(_ref) {
	        var _id = _ref._id,
	            attributes = _ref.attributes;
	
	        Passengers.update(_id, { "$set": attributes });
	    },
	    'passengers.insert': function passengersInsert(attributes) {
	        Passengers.insert(attributes);
	    }
	});
	
	// Helpers :
	Passengers.helpers({
	    getAEM: function getAEM() {
	        if (this.mobility) return 'M';
	
	        if (this.age <= 12) return 'E';else return 'A';
	    },
	    sendSMS: function sendSMS(message) {
	
	        var phone = this.phone.slice(1);;
	        phone = phone.replace(' ', '');
	        phone = phone.replace('.', '');
	        phone = '33' + phone;
	
	        console.log('phone', phone);
	
	        if (phone[2] == '6' || phone[2] == '7') {
	            Meteor.call('send.sms', {
	                'to': phone,
	                'message': message
	            });
	        }
	    }
	});

/***/ },

/***/ "./src/universal/collections/reservations/payments.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Payment = exports.Payments = undefined;
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _baseSchema = __webpack_require__("./src/universal/collections/baseSchema.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Mongo = Package.mongo.Mongo;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var Payments = exports.Payments = new Mongo.Collection('payments');
	
	Payments.attachRoles('payments');
	
	var Payment = exports.Payment = new SimpleSchema([{
		type: {
			type: String,
			label: "Type"
		},
		montant: {
			type: String,
			label: "Montant"
		},
		reservation: {
			type: String,
			label: "Identifiant de la réservation"
		},
		informations: {
			type: String,
			label: "Informations",
			optional: true
		}
	}, _baseSchema.BaseSchema]);
	
	Payments.attachSchema(Payment);
	
	// Dbs methods : 
	
	Meteor.methods({
		'payments.insert': function paymentsInsert(attributes) {
			Payments.insert(attributes);
		},
		'payments.remove': function paymentsRemove(_id) {
			Payments.remove(_id);
		}
	});
	
	// Helpers :
	Payments.helpers({});

/***/ },

/***/ "./src/universal/collections/reservations/methods.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getBilletID = exports.scheduleReservation = undefined;
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _availabilities = __webpack_require__("./src/universal/helpers/availabilities.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var ValidatedMethod = Package['mdg:validated-method'].ValidatedMethod;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var DDPRateLimiter = Package['ddp-rate-limiter'].DDPRateLimiter;
	var scheduleReservation = exports.scheduleReservation = new ValidatedMethod({
		name: 'reservations.schedule',
		validate: new SimpleSchema({
			_id: { type: String },
			date: { type: Date },
			place: { type: String, allowedValues: ["anjou", "nantes"] },
			period: { type: String, allowedValues: ["morning", "evening"] }
		}).validator(),
		run: function run(_ref) {
			var _id = _ref._id,
			    date = _ref.date,
			    place = _ref.place,
			    period = _ref.period;
	
			var reservation = _reservations.Reservations.findOne(_id);
			var userId = Meteor.userId();
			if (!reservation) throw new Meteor.Error('reservation_not_found', 'La réservation n\'existe plus en base de donnée');
	
			//if (Flights.findOne({reservationIds: { $in: [reservation._id] }, status: { $ne: "cancelled" }}) OR )
			//	throw new Meteor.Error('already_prepared',
			//								'Cette réservation a déjà été attaché à un vol');
	
			if (reservation.passengers.length > (0, _availabilities.getAvailabilityCount)(date, place, period)) throw new Meteor.Error('not_enough_availability', 'Il n\'y pas suffisament de place sur ce créneau pour cette réservation');
	
			// TODO : Vérifier si la reservation est bien possible selon les poids et la repartition dans les montgolfieres
	
			var historyItem = {
				type: "scheduled",
				date: new Date(),
				'scheduledAt': (0, _moment2.default)(date).startOf('day').toDate(),
				place: place,
				period: period,
				userId: userId
			};
	
			_reservations.Reservations.update(_id, {
				$set: {
					'scheduledAt': (0, _moment2.default)(date).startOf('day').toDate(),
					place: place,
					'periodTime': period
				},
				$push: {
					history: historyItem
				}
			});
	
			return true;
		}
	});
	
	var getBilletID = exports.getBilletID = new ValidatedMethod({
		name: 'reservations.getBilletID',
		validate: new SimpleSchema().validator(),
		run: function run() {
	
			if (this.isSimulation) {
				console.log('client side');
				return;
			} else {
				console.log('server side');
	
				var d = new Date();
				var reservations = _reservations.Reservations.find({ id_billet: { $regex: ".*" + d.getFullYear().toString().slice(-2) + "-.*" } }, { sort: { id_billet: -1 } }).fetch();
	
				var bigger = 0;
	
				_lodash2.default.each(reservations, function (reservation) {
					var numerotation = reservation.id_billet.replace(d.getFullYear().toString().slice(-2) + '-', '');
					if (numerotation > bigger) {
						bigger = parseInt(numerotation);
					}
				});
	
				var total = bigger + 1;
	
				console.log('total', total);
	
				var numerotation = '';
				for (var i = 0; i < 4 - total.toString().length; i++) {
					numerotation += '0';
				}
	
				console.log(d.getFullYear().toString().slice(-2) + '-' + numerotation + total);
	
				return d.getFullYear().toString().slice(-2) + '-' + numerotation + total;
			}
		}
	});
	
	// Get list of all method names on Lists
	var LISTS_METHODS = _lodash2.default.map([scheduleReservation, getBilletID], 'name');
	
	if (Meteor.isServer) {
		// Only allow 5 list operations per connection per second
		DDPRateLimiter.addRule({
			name: function name(_name) {
				return _lodash2.default.includes(LISTS_METHODS, _name);
			},
	
	
			// Rate limit per connection ID
			connectionId: function connectionId() {
				return true;
			}
		}, 5, 1000);
	}

/***/ },

/***/ "./src/universal/helpers/availabilities.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getMemoFromDate = exports.getReservedCount = exports.getAvailabilityTotalCount = exports.getAllAvailabilities = exports.getAvailabilityCount = undefined;
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentFerieFr = __webpack_require__("./node_modules/moment-ferie-fr/moment-ferie-fr.js");
	
	var momentferiefr = _interopRequireWildcard(_momentFerieFr);
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _memos = __webpack_require__("./src/universal/collections/memos/memos.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var getAvailabilityCount = exports.getAvailabilityCount = getAvailabilityCountFunc;
	var getAllAvailabilities = exports.getAllAvailabilities = getAllAvailabilitiesFunc;
	var getAvailabilityTotalCount = exports.getAvailabilityTotalCount = getAvailabilityTotalCountFunc;
	var getReservedCount = exports.getReservedCount = getReservedCountFunc;
	var getMemoFromDate = exports.getMemoFromDate = getMemoFromDateFunc;
	
	function getAvailabilityCountFunc(date, place, period) {
		var online = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
		var availability = 0;
	
		//date = moment(date).format('YYYY-MM-DD');
		//date = date.subtract(1, 'days');
	
		// Query available pilots & montgolfieres
		var projection = {
			$elemMatch: {
				startDate: { $lte: (0, _moment2.default)(date).startOf('day').toDate() },
				endDate: { $gte: (0, _moment2.default)(date).endOf('day').toDate() },
				isAvailable: true,
				place: place
			}
		};
	
		if (period) projection["$elemMatch"].period = period;
		var pilots = Meteor.users.find({ "profile.availabilities": projection }).fetch();
		var montgolfieres = _montgolfieres.Montgolfieres.find({ "availabilities": projection, allowedPilots: { $in: _lodash2.default.map(pilots, '_id') } }).fetch();
	
		// If not enough pilots, keep the largest montgolfieres
	
		var _loop = function _loop() {
			var toRemove = _lodash2.default.minBy(montgolfieres, function (montgolfiere) {
				return montgolfiere.maxPassengers;
			});
			montgolfieres = _lodash2.default.reject(montgolfieres, function (montgolfiere) {
				return montgolfiere._id == toRemove._id;
			});
		};
	
		while (pilots.length < montgolfieres.length) {
			_loop();
		}
	
		var nbmgf = 0;
	
		// Compute total availibity count
		availability += _lodash2.default.reduce(montgolfieres, function (acc, montgolfiere) {
			if (online) {
				var onlineAvailabilities = montgolfiere.availabilities.filter(function (availability) {
					return (0, _moment2.default)(availability.startDate).isSameOrBefore((0, _moment2.default)(date)) && (0, _moment2.default)(availability.endDate).isSameOrAfter((0, _moment2.default)(date));
				});
	
				var onlineAvailability = onlineAvailabilities.length > 0 ? onlineAvailabilities[0].online : 0;
	
				if (!onlineAvailability) {
					return acc += 0;
				}
	
				nbmgf++;
	
				return acc += Math.round(montgolfiere.maxPassengers * (onlineAvailability / 100));
			}
			return acc += montgolfiere.maxPassengers;
		}, 0);
	
		// Subtract scheduled passengers
		var reservations = _reservations.Reservations.find({ 'scheduledAt': { $gte: (0, _moment2.default)(date).startOf("day").toDate(), $lte: (0, _moment2.default)(date).endOf("day").toDate() }, place: place, $or: [{ 'periodTime': period }, { 'period': period }] }).fetch();
	
		var results = _lodash2.default.reject(reservations, function (reservation) {
			if (reservation.period && reservation.periodTime) {
				if (reservation.periodTime != period) {
					return true;
				}
			}
		});
	
		var total = 0;
		availability -= _lodash2.default.reduce(results, function (acc, reservation) {
			total += reservation.getPassengers().length;
			return acc += reservation.getPassengers().length;
		}, 0);
	
		return availability;
	}
	
	function getAvailabilityTotalCountFunc(date, place, period) {
	
		var availability = 0;
	
		// Query available pilots & montgolfieres
		var projection = {
			$elemMatch: {
				startDate: { $lte: date },
				endDate: { $gte: date },
				isAvailable: true,
				place: place
			}
		};
	
		if (period) projection["$elemMatch"].period = period;
	
		var pilots = Meteor.users.find({ "profile.availabilities": projection }).fetch();
		var montgolfieres = _montgolfieres.Montgolfieres.find({ "availabilities": projection, allowedPilots: { $in: _lodash2.default.map(pilots, '_id') } }).fetch();
	
		// If not enough pilots, keep the largest montgolfieres
	
		var _loop2 = function _loop2() {
			var toRemove = _lodash2.default.minBy(montgolfieres, function (montgolfiere) {
				return montgolfiere.maxPassengers;
			});
			montgolfieres = _lodash2.default.reject(montgolfieres, function (montgolfiere) {
				return montgolfiere._id == toRemove._id;
			});
		};
	
		while (pilots.length < montgolfieres.length) {
			_loop2();
		}
	
		// Compute total availibity count
		availability += _lodash2.default.reduce(montgolfieres, function (acc, montgolfiere) {
			return acc += montgolfiere.maxPassengers;
		}, 0);
	
		return availability;
	}
	
	function getReservedCountFunc(date, place, period) {
	
		var reserved = 0;
		var query = {
			'scheduledAt': { $gte: (0, _moment2.default)(date).startOf("day").toDate(), $lte: (0, _moment2.default)(date).endOf("day").toDate() },
			place: place,
			$or: [{ 'periodTime': period }, { 'period': period }]
		};
	
		var reservations = _reservations.Reservations.find(query).fetch();
	
		var exclude = [];
		_lodash2.default.each(reservations, function (reservation) {
			if (reservation.period && reservation.periodTime) {
				if (reservation.periodTime != period) {
					reserved -= reservation.passengers.length;
				}
			}
		});
	
		reserved += _lodash2.default.reduce(reservations, function (acc, reservation) {
			return acc += reservation.passengers.length;
		}, 0);
	
		return reserved;
	}
	
	function getAllAvailabilitiesFunc(startDate, endDate, reservation) {
		var availabilities = [];
	
		startDate = (0, _moment2.default)(startDate);
	
		for (var i = 0; i <= (0, _moment2.default)(endDate).diff((0, _moment2.default)(startDate), 'days'); i++) {
			var date = (0, _moment2.default)(startDate).add(i, 'days');
	
			console.log(date);
	
			if (reservation.getPeriod() == 'Libre date' || reservation.getPeriod() == 'Semaine uniquement' && (0, _moment2.default)(startDate).add(i, 'days').isWorkingDay()) {
				if ((0, _moment2.default)().add(2, 'days').isSameOrAfter((0, _moment2.default)(date))) {
					availabilities.push({
						'anjou': {
							'morning': 0,
							'evening': 0
						},
						'nantes': {
							'morning': 0,
							'evening': 0
						},
						'date': date.add(1, 'days')
					});
				} else {
					availabilities.push({
						'anjou': {
							'morning': getAvailabilityCountFunc(date, "anjou", "morning", true),
							'evening': getAvailabilityCountFunc(date, 'anjou', 'evening', true)
						},
						'nantes': {
							'morning': getAvailabilityCountFunc(date, 'nantes', 'morning', true),
							'evening': getAvailabilityCountFunc(date, 'nantes', 'evening', true)
						},
						'date': date.add(1, 'days')
					});
				}
			} else {
				availabilities.push({
					'anjou': {
						'morning': 0,
						'evening': 0
					},
					'nantes': {
						'morning': 0,
						'evening': 0
					},
					'date': date.add(1, 'days')
				});
			}
		}
	
		return availabilities;
	}
	
	function getMemoFromDateFunc(date) {
		var memo = _memos.Memos.find({ date: date }).fetch();
	
		if (memo.length == 0) {
			var id = _memos.Memos.insert({ date: date });
			return _memos.Memos.findOne(id);
		}
	
		return memo[0];
	}

/***/ },

/***/ "./node_modules/moment-ferie-fr/moment-ferie-fr.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// https://github.com/damienlabat/moment-ferie-fr
	(function () {
	
	  "use strict";
	
	  var initialize = function (moment) {
	
	    // Source: http://techneilogy.blogspot.fr/2012/02/couple-of-years-ago-i-posted-source.html
	    moment.fn.easterDay = moment.fn.paques = function (Y) {
	      if (Y === undefined) {
	        Y = this.year();
	      }
	      var a = Y % 19;
	      var b = Math.floor(Y / 100);
	      var c = Y % 100;
	      var d = Math.floor(b / 4);
	      var e = b % 4;
	      var f = Math.floor((b + 8) / 25);
	      var g = Math.floor((b - f + 1) / 3);
	      var h = (19 * a + b - d - g + 15) % 30;
	      var i = Math.floor(c / 4);
	      var k = c % 4;
	      var l = (32 + 2 * e + 2 * i - h - k) % 7;
	      var m = Math.floor((a + 11 * h + 22 * l) / 451);
	      var n0 = (h + l + 7 * m + 114);
	      var n = Math.floor(n0 / 31) - 1;
	      var p = n0 % 31 + 1;
	      var date = new Date(Y, n, p);
	      return moment(date);
	    };
	
	    moment.fn.lundiDePaques = function (Y) {
	      if (Y === undefined) {
	        Y = this.year();
	      }
	      return moment.fn.paques(Y).add(1, "days");
	    };
	
	    moment.fn.ascension = function (Y) {
	      if (Y === undefined) {
	        Y = this.year();
	      }
	      return moment.fn.paques(Y).add(39, "days");
	    };
	
	    moment.fn.pentecote = function (Y) {
	      if (Y === undefined) {
	        Y = this.year();
	      }
	      return moment.fn.paques(Y).add(50, "days");
	    };
	
	    moment.fn.jourDeLAn = function (Y) {
	      if (Y === undefined) {
	        Y = this.year();
	      }
	      return moment("1-1-" + Y, "DD-MM-YYYY");
	    };
	
	    moment.fn.feteDuTravail = function (Y) {
	      if (Y === undefined) {
	        Y = this.year();
	      }
	      return moment("1-5-" + Y, "DD-MM-YYYY");
	    };
	
	    moment.fn.victoireDeAllies = function (Y) {
	      if (Y === undefined) {
	        Y = this.year();
	      }
	      return moment("8-5-" + Y, "DD-MM-YYYY");
	    };
	
	    moment.fn.feteNationale = function (Y) {
	      if (Y === undefined) {
	        Y = this.year();
	      }
	      return moment("14-7-" + Y, "DD-MM-YYYY");
	    };
	
	    moment.fn.assomption = function (Y) {
	      if (Y === undefined) {
	        Y = this.year();
	      }
	      return moment("15-8-" + Y, "DD-MM-YYYY");
	    };
	
	    moment.fn.toussaint = function (Y) {
	      if (Y === undefined) {
	        Y = this.year();
	      }
	      return moment("1-11-" + Y, "DD-MM-YYYY");
	    };
	
	    moment.fn.armistice = function (Y) {
	      if (Y === undefined) {
	        Y = this.year();
	      }
	      return moment("11-11-" + Y, "DD-MM-YYYY");
	    };
	
	    moment.fn.noel = function (Y) {
	      if (Y === undefined) {
	        Y = this.year();
	      }
	      return moment("25-12-" + Y, "DD-MM-YYYY");
	    };
	
	    var listeFerie = {
	      "Jour de l'an": moment.fn.jourDeLAn,
	      "Fête du travail": moment.fn.feteDuTravail,
	      "Victoire des alliés": moment.fn.victoireDeAllies,
	      "Fête Nationale": moment.fn.feteNationale,
	      "Assomption": moment.fn.assomption,
	      "Toussaint": moment.fn.toussaint,
	      "Armistice": moment.fn.armistice,
	      "Noël": moment.fn.noel,
	      "Pâques": moment.fn.paques,
	      "Lundi de Pâques": moment.fn.lundiDePaques,
	      "Ascension": moment.fn.ascension,
	      "Pentecôte": moment.fn.pentecote
	    };
	
	    moment.fn.getFerieList = function (Y) {
	      if (Y === undefined) {
	        Y = this.year();
	      }
	
	      var res = [];
	      for (var key in listeFerie) {
	        if (listeFerie.hasOwnProperty(key)) {
	          res.push({name: key, date: listeFerie[key](Y) });
	        }
	      }
	      return res;
	    };
	
	    moment.fn.getFerie = function () {
	      for (var key in listeFerie) {
	        if (listeFerie.hasOwnProperty(key)) {
	          if (this.isSame(listeFerie[key].call(this), 'days')) {
	            return key;
	          }
	        }
	      }
	      return null;
	    };
	
	    moment.fn.isFerie = function () {
	      return (this.getFerie() !== null);
	    };
	
	    moment.fn.isWeekEnd = function () {
	      return (this.day() === 0 || this.day() === 6);
	    };
	
	    moment.fn.isWorkingDay = function () {
	      return (!this.isWeekEnd() && !this.isFerie());
	    };
	
	    return moment;
	  };
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./node_modules/moment/moment.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (moment) {
	      return this.moment = initialize(moment);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module !== "undefined") {
	    module.exports = initialize(require("moment"));
	  } else if (typeof window !== "undefined" && window.moment) {
	    this.moment = initialize(this.moment);
	  }
	
	}).call(this);

/***/ },

/***/ "./src/universal/collections/memos/memos.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MemoSchema = exports.Memos = undefined;
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _baseSchema = __webpack_require__("./src/universal/collections/baseSchema.js");
	
	var Meteor = Package.meteor.Meteor;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var Mongo = Package.mongo.Mongo;
	var Memos = exports.Memos = new Mongo.Collection('memos');
	exports.default = Memos;
	
	
	Memos.attachRoles('places');
	
	Memos.label = "Mémos";
	
	var MemoSchema = exports.MemoSchema = new SimpleSchema([{
	    content: {
	        type: String,
	        label: "Contenu",
	        optional: true
	    },
	    date: {
	        type: Date,
	        label: "Date"
	    }
	}, _baseSchema.BaseSchema]);
	
	Memos.attachSchema(MemoSchema);

/***/ },

/***/ "./node_modules/axios/index.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__("./node_modules/axios/lib/axios.js");

/***/ },

/***/ "./node_modules/axios/lib/axios.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
	var bind = __webpack_require__("./node_modules/axios/lib/helpers/bind.js");
	var Axios = __webpack_require__("./node_modules/axios/lib/core/Axios.js");
	var mergeConfig = __webpack_require__("./node_modules/axios/lib/core/mergeConfig.js");
	var defaults = __webpack_require__("./node_modules/axios/lib/defaults/index.js");
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  // Factory for creating new instances
	  instance.create = function create(instanceConfig) {
	    return createInstance(mergeConfig(defaultConfig, instanceConfig));
	  };
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Expose Cancel & CancelToken
	axios.CanceledError = __webpack_require__("./node_modules/axios/lib/cancel/CanceledError.js");
	axios.CancelToken = __webpack_require__("./node_modules/axios/lib/cancel/CancelToken.js");
	axios.isCancel = __webpack_require__("./node_modules/axios/lib/cancel/isCancel.js");
	axios.VERSION = __webpack_require__("./node_modules/axios/lib/env/data.js").version;
	axios.toFormData = __webpack_require__("./node_modules/axios/lib/helpers/toFormData.js");
	
	// Expose AxiosError class
	axios.AxiosError = __webpack_require__("./node_modules/axios/lib/core/AxiosError.js");
	
	// alias for CanceledError for backward compatibility
	axios.Cancel = axios.CanceledError;
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__("./node_modules/axios/lib/helpers/spread.js");
	
	// Expose isAxiosError
	axios.isAxiosError = __webpack_require__("./node_modules/axios/lib/helpers/isAxiosError.js");
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },

/***/ "./node_modules/axios/lib/utils.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__("./node_modules/axios/lib/helpers/bind.js");
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	// eslint-disable-next-line func-names
	var kindOf = (function(cache) {
	  // eslint-disable-next-line func-names
	  return function(thing) {
	    var str = toString.call(thing);
	    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
	  };
	})(Object.create(null));
	
	function kindOfTest(type) {
	  type = type.toLowerCase();
	  return function isKindOf(thing) {
	    return kindOf(thing) === type;
	  };
	}
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return Array.isArray(val);
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */
	function isBuffer(val) {
	  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
	    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	var isArrayBuffer = kindOfTest('ArrayBuffer');
	
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a plain Object
	 *
	 * @param {Object} val The value to test
	 * @return {boolean} True if value is a plain Object, otherwise false
	 */
	function isPlainObject(val) {
	  if (kindOf(val) !== 'object') {
	    return false;
	  }
	
	  var prototype = Object.getPrototypeOf(val);
	  return prototype === null || prototype === Object.prototype;
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	var isDate = kindOfTest('Date');
	
	/**
	 * Determine if a value is a File
	 *
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	var isFile = kindOfTest('File');
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	var isBlob = kindOfTest('Blob');
	
	/**
	 * Determine if a value is a FileList
	 *
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	var isFileList = kindOfTest('FileList');
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} thing The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(thing) {
	  var pattern = '[object FormData]';
	  return thing && (
	    (typeof FormData === 'function' && thing instanceof FormData) ||
	    toString.call(thing) === pattern ||
	    (isFunction(thing.toString) && thing.toString() === pattern)
	  );
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	var isURLSearchParams = kindOfTest('URLSearchParams');
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
	                                           navigator.product === 'NativeScript' ||
	                                           navigator.product === 'NS')) {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (isPlainObject(result[key]) && isPlainObject(val)) {
	      result[key] = merge(result[key], val);
	    } else if (isPlainObject(val)) {
	      result[key] = merge({}, val);
	    } else if (isArray(val)) {
	      result[key] = val.slice();
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	/**
	 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
	 *
	 * @param {string} content with BOM
	 * @return {string} content value without BOM
	 */
	function stripBOM(content) {
	  if (content.charCodeAt(0) === 0xFEFF) {
	    content = content.slice(1);
	  }
	  return content;
	}
	
	/**
	 * Inherit the prototype methods from one constructor into another
	 * @param {function} constructor
	 * @param {function} superConstructor
	 * @param {object} [props]
	 * @param {object} [descriptors]
	 */
	
	function inherits(constructor, superConstructor, props, descriptors) {
	  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
	  constructor.prototype.constructor = constructor;
	  props && Object.assign(constructor.prototype, props);
	}
	
	/**
	 * Resolve object with deep prototype chain to a flat object
	 * @param {Object} sourceObj source object
	 * @param {Object} [destObj]
	 * @param {Function} [filter]
	 * @returns {Object}
	 */
	
	function toFlatObject(sourceObj, destObj, filter) {
	  var props;
	  var i;
	  var prop;
	  var merged = {};
	
	  destObj = destObj || {};
	
	  do {
	    props = Object.getOwnPropertyNames(sourceObj);
	    i = props.length;
	    while (i-- > 0) {
	      prop = props[i];
	      if (!merged[prop]) {
	        destObj[prop] = sourceObj[prop];
	        merged[prop] = true;
	      }
	    }
	    sourceObj = Object.getPrototypeOf(sourceObj);
	  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
	
	  return destObj;
	}
	
	/*
	 * determines whether a string ends with the characters of a specified string
	 * @param {String} str
	 * @param {String} searchString
	 * @param {Number} [position= 0]
	 * @returns {boolean}
	 */
	function endsWith(str, searchString, position) {
	  str = String(str);
	  if (position === undefined || position > str.length) {
	    position = str.length;
	  }
	  position -= searchString.length;
	  var lastIndex = str.indexOf(searchString, position);
	  return lastIndex !== -1 && lastIndex === position;
	}
	
	
	/**
	 * Returns new array from array like object
	 * @param {*} [thing]
	 * @returns {Array}
	 */
	function toArray(thing) {
	  if (!thing) return null;
	  var i = thing.length;
	  if (isUndefined(i)) return null;
	  var arr = new Array(i);
	  while (i-- > 0) {
	    arr[i] = thing[i];
	  }
	  return arr;
	}
	
	// eslint-disable-next-line func-names
	var isTypedArray = (function(TypedArray) {
	  // eslint-disable-next-line func-names
	  return function(thing) {
	    return TypedArray && thing instanceof TypedArray;
	  };
	})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isPlainObject: isPlainObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim,
	  stripBOM: stripBOM,
	  inherits: inherits,
	  toFlatObject: toFlatObject,
	  kindOf: kindOf,
	  kindOfTest: kindOfTest,
	  endsWith: endsWith,
	  toArray: toArray,
	  isTypedArray: isTypedArray,
	  isFileList: isFileList
	};


/***/ },

/***/ "./node_modules/axios/lib/helpers/bind.js":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },

/***/ "./node_modules/axios/lib/core/Axios.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
	var buildURL = __webpack_require__("./node_modules/axios/lib/helpers/buildURL.js");
	var InterceptorManager = __webpack_require__("./node_modules/axios/lib/core/InterceptorManager.js");
	var dispatchRequest = __webpack_require__("./node_modules/axios/lib/core/dispatchRequest.js");
	var mergeConfig = __webpack_require__("./node_modules/axios/lib/core/mergeConfig.js");
	var buildFullPath = __webpack_require__("./node_modules/axios/lib/core/buildFullPath.js");
	var validator = __webpack_require__("./node_modules/axios/lib/helpers/validator.js");
	
	var validators = validator.validators;
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(configOrUrl, config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof configOrUrl === 'string') {
	    config = config || {};
	    config.url = configOrUrl;
	  } else {
	    config = configOrUrl || {};
	  }
	
	  config = mergeConfig(this.defaults, config);
	
	  // Set config.method
	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  }
	
	  var transitional = config.transitional;
	
	  if (transitional !== undefined) {
	    validator.assertOptions(transitional, {
	      silentJSONParsing: validators.transitional(validators.boolean),
	      forcedJSONParsing: validators.transitional(validators.boolean),
	      clarifyTimeoutError: validators.transitional(validators.boolean)
	    }, false);
	  }
	
	  // filter out skipped interceptors
	  var requestInterceptorChain = [];
	  var synchronousRequestInterceptors = true;
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
	      return;
	    }
	
	    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
	
	    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  var responseInterceptorChain = [];
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  var promise;
	
	  if (!synchronousRequestInterceptors) {
	    var chain = [dispatchRequest, undefined];
	
	    Array.prototype.unshift.apply(chain, requestInterceptorChain);
	    chain = chain.concat(responseInterceptorChain);
	
	    promise = Promise.resolve(config);
	    while (chain.length) {
	      promise = promise.then(chain.shift(), chain.shift());
	    }
	
	    return promise;
	  }
	
	
	  var newConfig = config;
	  while (requestInterceptorChain.length) {
	    var onFulfilled = requestInterceptorChain.shift();
	    var onRejected = requestInterceptorChain.shift();
	    try {
	      newConfig = onFulfilled(newConfig);
	    } catch (error) {
	      onRejected(error);
	      break;
	    }
	  }
	
	  try {
	    promise = dispatchRequest(newConfig);
	  } catch (error) {
	    return Promise.reject(error);
	  }
	
	  while (responseInterceptorChain.length) {
	    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
	  }
	
	  return promise;
	};
	
	Axios.prototype.getUri = function getUri(config) {
	  config = mergeConfig(this.defaults, config);
	  var fullPath = buildFullPath(config.baseURL, config.url);
	  return buildURL(fullPath, config.params, config.paramsSerializer);
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: (config || {}).data
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	
	  function generateHTTPMethod(isForm) {
	    return function httpMethod(url, data, config) {
	      return this.request(mergeConfig(config || {}, {
	        method: method,
	        headers: isForm ? {
	          'Content-Type': 'multipart/form-data'
	        } : {},
	        url: url,
	        data: data
	      }));
	    };
	  }
	
	  Axios.prototype[method] = generateHTTPMethod();
	
	  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
	});
	
	module.exports = Axios;


/***/ },

/***/ "./node_modules/axios/lib/helpers/buildURL.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');
	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }
	
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },

/***/ "./node_modules/axios/lib/core/InterceptorManager.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected,
	    synchronous: options ? options.synchronous : false,
	    runWhen: options ? options.runWhen : null
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },

/***/ "./node_modules/axios/lib/core/dispatchRequest.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
	var transformData = __webpack_require__("./node_modules/axios/lib/core/transformData.js");
	var isCancel = __webpack_require__("./node_modules/axios/lib/cancel/isCancel.js");
	var defaults = __webpack_require__("./node_modules/axios/lib/defaults/index.js");
	var CanceledError = __webpack_require__("./node_modules/axios/lib/cancel/CanceledError.js");
	
	/**
	 * Throws a `CanceledError` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	
	  if (config.signal && config.signal.aborted) {
	    throw new CanceledError();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData.call(
	    config,
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData.call(
	      config,
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData.call(
	          config,
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },

/***/ "./node_modules/axios/lib/core/transformData.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
	var defaults = __webpack_require__("./node_modules/axios/lib/defaults/index.js");
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  var context = this || defaults;
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn.call(context, data, headers);
	  });
	
	  return data;
	};


/***/ },

/***/ "./node_modules/axios/lib/defaults/index.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
	var normalizeHeaderName = __webpack_require__("./node_modules/axios/lib/helpers/normalizeHeaderName.js");
	var AxiosError = __webpack_require__("./node_modules/axios/lib/core/AxiosError.js");
	var transitionalDefaults = __webpack_require__("./node_modules/axios/lib/defaults/transitional.js");
	var toFormData = __webpack_require__("./node_modules/axios/lib/helpers/toFormData.js");
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__("./node_modules/axios/lib/adapters/xhr.js");
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__("./node_modules/axios/lib/adapters/xhr.js");
	  }
	  return adapter;
	}
	
	function stringifySafely(rawValue, parser, encoder) {
	  if (utils.isString(rawValue)) {
	    try {
	      (parser || JSON.parse)(rawValue);
	      return utils.trim(rawValue);
	    } catch (e) {
	      if (e.name !== 'SyntaxError') {
	        throw e;
	      }
	    }
	  }
	
	  return (encoder || JSON.stringify)(rawValue);
	}
	
	var defaults = {
	
	  transitional: transitionalDefaults,
	
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');
	
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	
	    var isObjectPayload = utils.isObject(data);
	    var contentType = headers && headers['Content-Type'];
	
	    var isFileList;
	
	    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
	      var _FormData = this.env && this.env.FormData;
	      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
	    } else if (isObjectPayload || contentType === 'application/json') {
	      setContentTypeIfUnset(headers, 'application/json');
	      return stringifySafely(data);
	    }
	
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    var transitional = this.transitional || defaults.transitional;
	    var silentJSONParsing = transitional && transitional.silentJSONParsing;
	    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
	    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
	
	    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
	      try {
	        return JSON.parse(data);
	      } catch (e) {
	        if (strictJSONParsing) {
	          if (e.name === 'SyntaxError') {
	            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
	          }
	          throw e;
	        }
	      }
	    }
	
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	  maxBodyLength: -1,
	
	  env: {
	    FormData: __webpack_require__("./node_modules/axios/lib/helpers/null.js")
	  },
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  },
	
	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    }
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ },

/***/ "./node_modules/axios/lib/helpers/normalizeHeaderName.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },

/***/ "./node_modules/axios/lib/core/AxiosError.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [config] The config.
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	function AxiosError(message, code, config, request, response) {
	  Error.call(this);
	  this.message = message;
	  this.name = 'AxiosError';
	  code && (this.code = code);
	  config && (this.config = config);
	  request && (this.request = request);
	  response && (this.response = response);
	}
	
	utils.inherits(AxiosError, Error, {
	  toJSON: function toJSON() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code,
	      status: this.response && this.response.status ? this.response.status : null
	    };
	  }
	});
	
	var prototype = AxiosError.prototype;
	var descriptors = {};
	
	[
	  'ERR_BAD_OPTION_VALUE',
	  'ERR_BAD_OPTION',
	  'ECONNABORTED',
	  'ETIMEDOUT',
	  'ERR_NETWORK',
	  'ERR_FR_TOO_MANY_REDIRECTS',
	  'ERR_DEPRECATED',
	  'ERR_BAD_RESPONSE',
	  'ERR_BAD_REQUEST',
	  'ERR_CANCELED'
	// eslint-disable-next-line func-names
	].forEach(function(code) {
	  descriptors[code] = {value: code};
	});
	
	Object.defineProperties(AxiosError, descriptors);
	Object.defineProperty(prototype, 'isAxiosError', {value: true});
	
	// eslint-disable-next-line func-names
	AxiosError.from = function(error, code, config, request, response, customProps) {
	  var axiosError = Object.create(prototype);
	
	  utils.toFlatObject(error, axiosError, function filter(obj) {
	    return obj !== Error.prototype;
	  });
	
	  AxiosError.call(axiosError, error.message, code, config, request, response);
	
	  axiosError.name = error.name;
	
	  customProps && Object.assign(axiosError, customProps);
	
	  return axiosError;
	};
	
	module.exports = AxiosError;


/***/ },

/***/ "./node_modules/axios/lib/defaults/transitional.js":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  silentJSONParsing: true,
	  forcedJSONParsing: true,
	  clarifyTimeoutError: false
	};


/***/ },

/***/ "./node_modules/axios/lib/helpers/toFormData.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
	
	/**
	 * Convert a data object to FormData
	 * @param {Object} obj
	 * @param {?Object} [formData]
	 * @returns {Object}
	 **/
	
	function toFormData(obj, formData) {
	  // eslint-disable-next-line no-param-reassign
	  formData = formData || new FormData();
	
	  var stack = [];
	
	  function convertValue(value) {
	    if (value === null) return '';
	
	    if (utils.isDate(value)) {
	      return value.toISOString();
	    }
	
	    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
	      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
	    }
	
	    return value;
	  }
	
	  function build(data, parentKey) {
	    if (utils.isPlainObject(data) || utils.isArray(data)) {
	      if (stack.indexOf(data) !== -1) {
	        throw Error('Circular reference detected in ' + parentKey);
	      }
	
	      stack.push(data);
	
	      utils.forEach(data, function each(value, key) {
	        if (utils.isUndefined(value)) return;
	        var fullKey = parentKey ? parentKey + '.' + key : key;
	        var arr;
	
	        if (value && !parentKey && typeof value === 'object') {
	          if (utils.endsWith(key, '{}')) {
	            // eslint-disable-next-line no-param-reassign
	            value = JSON.stringify(value);
	          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
	            // eslint-disable-next-line func-names
	            arr.forEach(function(el) {
	              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
	            });
	            return;
	          }
	        }
	
	        build(value, fullKey);
	      });
	
	      stack.pop();
	    } else {
	      formData.append(parentKey, convertValue(data));
	    }
	  }
	
	  build(obj);
	
	  return formData;
	}
	
	module.exports = toFormData;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ },

/***/ "./node_modules/axios/lib/adapters/xhr.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
	var settle = __webpack_require__("./node_modules/axios/lib/core/settle.js");
	var cookies = __webpack_require__("./node_modules/axios/lib/helpers/cookies.js");
	var buildURL = __webpack_require__("./node_modules/axios/lib/helpers/buildURL.js");
	var buildFullPath = __webpack_require__("./node_modules/axios/lib/core/buildFullPath.js");
	var parseHeaders = __webpack_require__("./node_modules/axios/lib/helpers/parseHeaders.js");
	var isURLSameOrigin = __webpack_require__("./node_modules/axios/lib/helpers/isURLSameOrigin.js");
	var transitionalDefaults = __webpack_require__("./node_modules/axios/lib/defaults/transitional.js");
	var AxiosError = __webpack_require__("./node_modules/axios/lib/core/AxiosError.js");
	var CanceledError = __webpack_require__("./node_modules/axios/lib/cancel/CanceledError.js");
	var parseProtocol = __webpack_require__("./node_modules/axios/lib/helpers/parseProtocol.js");
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	    var responseType = config.responseType;
	    var onCanceled;
	    function done() {
	      if (config.cancelToken) {
	        config.cancelToken.unsubscribe(onCanceled);
	      }
	
	      if (config.signal) {
	        config.signal.removeEventListener('abort', onCanceled);
	      }
	    }
	
	    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    var fullPath = buildFullPath(config.baseURL, config.url);
	
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    function onloadend() {
	      if (!request) {
	        return;
	      }
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
	        request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(function _resolve(value) {
	        resolve(value);
	        done();
	      }, function _reject(err) {
	        reject(err);
	        done();
	      }, response);
	
	      // Clean up request
	      request = null;
	    }
	
	    if ('onloadend' in request) {
	      // Use onloadend if available
	      request.onloadend = onloadend;
	    } else {
	      // Listen for ready state to emulate onloadend
	      request.onreadystatechange = function handleLoad() {
	        if (!request || request.readyState !== 4) {
	          return;
	        }
	
	        // The request errored out and we didn't get a response, this will be
	        // handled by onerror instead
	        // With one exception: request that using file: protocol, most browsers
	        // will return status as 0 even though it's a successful request
	        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	          return;
	        }
	        // readystate handler is calling before onerror or ontimeout handlers,
	        // so we should call onloadend on the next 'tick'
	        setTimeout(onloadend);
	      };
	    }
	
	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }
	
	      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
	      var transitional = config.transitional || transitionalDefaults;
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(new AxiosError(
	        timeoutErrorMessage,
	        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
	        config,
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }
	
	    // Add responseType to request if needed
	    if (responseType && responseType !== 'json') {
	      request.responseType = config.responseType;
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken || config.signal) {
	      // Handle cancellation
	      // eslint-disable-next-line func-names
	      onCanceled = function(cancel) {
	        if (!request) {
	          return;
	        }
	        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
	        request.abort();
	        request = null;
	      };
	
	      config.cancelToken && config.cancelToken.subscribe(onCanceled);
	      if (config.signal) {
	        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
	      }
	    }
	
	    if (!requestData) {
	      requestData = null;
	    }
	
	    var protocol = parseProtocol(fullPath);
	
	    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
	      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
	      return;
	    }
	
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },

/***/ "./node_modules/axios/lib/core/settle.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var AxiosError = __webpack_require__("./node_modules/axios/lib/core/AxiosError.js");
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(new AxiosError(
	      'Request failed with status code ' + response.status,
	      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
	      response.config,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },

/***/ "./node_modules/axios/lib/helpers/cookies.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));
	
	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }
	
	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }
	
	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }
	
	          if (secure === true) {
	            cookie.push('secure');
	          }
	
	          document.cookie = cookie.join('; ');
	        },
	
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },
	
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);


/***/ },

/***/ "./node_modules/axios/lib/core/buildFullPath.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isAbsoluteURL = __webpack_require__("./node_modules/axios/lib/helpers/isAbsoluteURL.js");
	var combineURLs = __webpack_require__("./node_modules/axios/lib/helpers/combineURLs.js");
	
	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	module.exports = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};


/***/ },

/***/ "./node_modules/axios/lib/helpers/isAbsoluteURL.js":
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
	};


/***/ },

/***/ "./node_modules/axios/lib/helpers/combineURLs.js":
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },

/***/ "./node_modules/axios/lib/helpers/parseHeaders.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ },

/***/ "./node_modules/axios/lib/helpers/isURLSameOrigin.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	
	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;
	
	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }
	
	        urlParsingNode.setAttribute('href', href);
	
	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }
	
	      originURL = resolveURL(window.location.href);
	
	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);


/***/ },

/***/ "./node_modules/axios/lib/cancel/CanceledError.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var AxiosError = __webpack_require__("./node_modules/axios/lib/core/AxiosError.js");
	var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
	
	/**
	 * A `CanceledError` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function CanceledError(message) {
	  // eslint-disable-next-line no-eq-null,eqeqeq
	  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
	  this.name = 'CanceledError';
	}
	
	utils.inherits(CanceledError, AxiosError, {
	  __CANCEL__: true
	});
	
	module.exports = CanceledError;


/***/ },

/***/ "./node_modules/axios/lib/helpers/parseProtocol.js":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function parseProtocol(url) {
	  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
	  return match && match[1] || '';
	};


/***/ },

/***/ "./node_modules/axios/lib/helpers/null.js":
/***/ function(module, exports) {

	// eslint-disable-next-line strict
	module.exports = null;


/***/ },

/***/ "./node_modules/axios/lib/cancel/isCancel.js":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },

/***/ "./node_modules/axios/lib/core/mergeConfig.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
	
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */
	module.exports = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	
	  function getMergedValue(target, source) {
	    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
	      return utils.merge(target, source);
	    } else if (utils.isPlainObject(source)) {
	      return utils.merge({}, source);
	    } else if (utils.isArray(source)) {
	      return source.slice();
	    }
	    return source;
	  }
	
	  // eslint-disable-next-line consistent-return
	  function mergeDeepProperties(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      return getMergedValue(config1[prop], config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  // eslint-disable-next-line consistent-return
	  function valueFromConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      return getMergedValue(undefined, config2[prop]);
	    }
	  }
	
	  // eslint-disable-next-line consistent-return
	  function defaultToConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      return getMergedValue(undefined, config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  // eslint-disable-next-line consistent-return
	  function mergeDirectKeys(prop) {
	    if (prop in config2) {
	      return getMergedValue(config1[prop], config2[prop]);
	    } else if (prop in config1) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  var mergeMap = {
	    'url': valueFromConfig2,
	    'method': valueFromConfig2,
	    'data': valueFromConfig2,
	    'baseURL': defaultToConfig2,
	    'transformRequest': defaultToConfig2,
	    'transformResponse': defaultToConfig2,
	    'paramsSerializer': defaultToConfig2,
	    'timeout': defaultToConfig2,
	    'timeoutMessage': defaultToConfig2,
	    'withCredentials': defaultToConfig2,
	    'adapter': defaultToConfig2,
	    'responseType': defaultToConfig2,
	    'xsrfCookieName': defaultToConfig2,
	    'xsrfHeaderName': defaultToConfig2,
	    'onUploadProgress': defaultToConfig2,
	    'onDownloadProgress': defaultToConfig2,
	    'decompress': defaultToConfig2,
	    'maxContentLength': defaultToConfig2,
	    'maxBodyLength': defaultToConfig2,
	    'beforeRedirect': defaultToConfig2,
	    'transport': defaultToConfig2,
	    'httpAgent': defaultToConfig2,
	    'httpsAgent': defaultToConfig2,
	    'cancelToken': defaultToConfig2,
	    'socketPath': defaultToConfig2,
	    'responseEncoding': defaultToConfig2,
	    'validateStatus': mergeDirectKeys
	  };
	
	  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
	    var merge = mergeMap[prop] || mergeDeepProperties;
	    var configValue = merge(prop);
	    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
	  });
	
	  return config;
	};


/***/ },

/***/ "./node_modules/axios/lib/helpers/validator.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var VERSION = __webpack_require__("./node_modules/axios/lib/env/data.js").version;
	var AxiosError = __webpack_require__("./node_modules/axios/lib/core/AxiosError.js");
	
	var validators = {};
	
	// eslint-disable-next-line func-names
	['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
	  validators[type] = function validator(thing) {
	    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
	  };
	});
	
	var deprecatedWarnings = {};
	
	/**
	 * Transitional option validator
	 * @param {function|boolean?} validator - set to false if the transitional option has been removed
	 * @param {string?} version - deprecated version / removed since version
	 * @param {string?} message - some message with additional info
	 * @returns {function}
	 */
	validators.transitional = function transitional(validator, version, message) {
	  function formatMessage(opt, desc) {
	    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
	  }
	
	  // eslint-disable-next-line func-names
	  return function(value, opt, opts) {
	    if (validator === false) {
	      throw new AxiosError(
	        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
	        AxiosError.ERR_DEPRECATED
	      );
	    }
	
	    if (version && !deprecatedWarnings[opt]) {
	      deprecatedWarnings[opt] = true;
	      // eslint-disable-next-line no-console
	      console.warn(
	        formatMessage(
	          opt,
	          ' has been deprecated since v' + version + ' and will be removed in the near future'
	        )
	      );
	    }
	
	    return validator ? validator(value, opt, opts) : true;
	  };
	};
	
	/**
	 * Assert object's properties type
	 * @param {object} options
	 * @param {object} schema
	 * @param {boolean?} allowUnknown
	 */
	
	function assertOptions(options, schema, allowUnknown) {
	  if (typeof options !== 'object') {
	    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
	  }
	  var keys = Object.keys(options);
	  var i = keys.length;
	  while (i-- > 0) {
	    var opt = keys[i];
	    var validator = schema[opt];
	    if (validator) {
	      var value = options[opt];
	      var result = value === undefined || validator(value, opt, options);
	      if (result !== true) {
	        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
	      }
	      continue;
	    }
	    if (allowUnknown !== true) {
	      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
	    }
	  }
	}
	
	module.exports = {
	  assertOptions: assertOptions,
	  validators: validators
	};


/***/ },

/***/ "./node_modules/axios/lib/env/data.js":
/***/ function(module, exports) {

	module.exports = {
	  "version": "0.27.2"
	};

/***/ },

/***/ "./node_modules/axios/lib/cancel/CancelToken.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var CanceledError = __webpack_require__("./node_modules/axios/lib/cancel/CanceledError.js");
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	
	  // eslint-disable-next-line func-names
	  this.promise.then(function(cancel) {
	    if (!token._listeners) return;
	
	    var i;
	    var l = token._listeners.length;
	
	    for (i = 0; i < l; i++) {
	      token._listeners[i](cancel);
	    }
	    token._listeners = null;
	  });
	
	  // eslint-disable-next-line func-names
	  this.promise.then = function(onfulfilled) {
	    var _resolve;
	    // eslint-disable-next-line func-names
	    var promise = new Promise(function(resolve) {
	      token.subscribe(resolve);
	      _resolve = resolve;
	    }).then(onfulfilled);
	
	    promise.cancel = function reject() {
	      token.unsubscribe(_resolve);
	    };
	
	    return promise;
	  };
	
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new CanceledError(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `CanceledError` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Subscribe to the cancel signal
	 */
	
	CancelToken.prototype.subscribe = function subscribe(listener) {
	  if (this.reason) {
	    listener(this.reason);
	    return;
	  }
	
	  if (this._listeners) {
	    this._listeners.push(listener);
	  } else {
	    this._listeners = [listener];
	  }
	};
	
	/**
	 * Unsubscribe from the cancel signal
	 */
	
	CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
	  if (!this._listeners) {
	    return;
	  }
	  var index = this._listeners.indexOf(listener);
	  if (index !== -1) {
	    this._listeners.splice(index, 1);
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },

/***/ "./node_modules/axios/lib/helpers/spread.js":
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },

/***/ "./node_modules/axios/lib/helpers/isAxiosError.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
	
	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	module.exports = function isAxiosError(payload) {
	  return utils.isObject(payload) && (payload.isAxiosError === true);
	};


/***/ },

/***/ "./src/universal/components/fields/datePickerField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var DatePicker = __webpack_require__("./node_modules/react-bootstrap-date-picker/lib/index.js");
	
	var DatePickerField = function (_React$Component) {
		(0, _inherits3.default)(DatePickerField, _React$Component);
	
		function DatePickerField(props) {
			(0, _classCallCheck3.default)(this, DatePickerField);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (DatePickerField.__proto__ || (0, _getPrototypeOf2.default)(DatePickerField)).call(this, props));
	
			_this.state = {
				date: _this.props.value
			};
			return _this;
		}
	
		(0, _createClass3.default)(DatePickerField, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'label',
						{ className: 'control-label' },
						this.props.label,
						'\xA0'
					),
					_react2.default.createElement(DatePicker, {
						dayLabels: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
						monthLabels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
						id: this.props.id, value: this.state.date, onChange: function onChange(value) {
							_this2.setState({ date: (0, _moment2.default)(value).format() });_this2.props.onChange((0, _moment2.default)(value).format());
						} }),
					' ',
					_react2.default.createElement('br', null)
				);
			}
		}]);
		return DatePickerField;
	}(_react2.default.Component);
	
	exports.default = (0, _connectField2.default)(DatePickerField);

/***/ },

/***/ "./node_modules/react-bootstrap-date-picker/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var instanceCount = 0; // See http://jszen.blogspot.com/2007/03/how-to-build-simple-calendar-with.html for calendar logic.
	
	var CalendarHeader = _react2.default.createClass({
	  displayName: 'DatePickerHeader',
	
	  propTypes: {
	    displayDate: _react2.default.PropTypes.object.isRequired,
	    onChange: _react2.default.PropTypes.func.isRequired,
	    monthLabels: _react2.default.PropTypes.array.isRequired,
	    previousButtonElement: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object]).isRequired,
	    nextButtonElement: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object]).isRequired
	  },
	
	  handleClickPrevious: function handleClickPrevious() {
	    var newDisplayDate = new Date(this.props.displayDate);
	    newDisplayDate.setMonth(newDisplayDate.getMonth() - 1);
	    this.props.onChange(newDisplayDate);
	  },
	  handleClickNext: function handleClickNext() {
	    var newDisplayDate = new Date(this.props.displayDate);
	    newDisplayDate.setMonth(newDisplayDate.getMonth() + 1);
	    this.props.onChange(newDisplayDate);
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'text-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'text-muted pull-left', onClick: this.handleClickPrevious, style: { cursor: 'pointer' } },
	        this.props.previousButtonElement
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        this.props.monthLabels[this.props.displayDate.getMonth()],
	        ' ',
	        this.props.displayDate.getFullYear()
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'text-muted pull-right', onClick: this.handleClickNext, style: { cursor: 'pointer' } },
	        this.props.nextButtonElement
	      )
	    );
	  }
	});
	
	var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	var Calendar = _react2.default.createClass({
	  displayName: 'DatePickerCalendar',
	
	  propTypes: {
	    selectedDate: _react2.default.PropTypes.object,
	    displayDate: _react2.default.PropTypes.object.isRequired,
	    onChange: _react2.default.PropTypes.func.isRequired,
	    dayLabels: _react2.default.PropTypes.array.isRequired,
	    cellPadding: _react2.default.PropTypes.string.isRequired,
	    weekStartsOnMonday: _react2.default.PropTypes.bool,
	    showTodayButton: _react2.default.PropTypes.bool,
	    todayButtonLabel: _react2.default.PropTypes.string
	  },
	
	  handleClick: function handleClick(day) {
	    var newSelectedDate = new Date(this.props.displayDate);
	    newSelectedDate.setHours(12);
	    newSelectedDate.setMinutes(0);
	    newSelectedDate.setSeconds(0);
	    newSelectedDate.setMilliseconds(0);
	    newSelectedDate.setDate(day);
	    this.props.onChange(newSelectedDate);
	  },
	  handleClickToday: function handleClickToday() {
	    var newSelectedDate = new Date();
	    newSelectedDate.setHours(12);
	    newSelectedDate.setMinutes(0);
	    newSelectedDate.setSeconds(0);
	    newSelectedDate.setMilliseconds(0);
	    this.props.onChange(newSelectedDate);
	  },
	  render: function render() {
	    var _this = this;
	
	    var currentDate = new Date();
	    var currentDay = currentDate.getDate();
	    var currentMonth = currentDate.getMonth();
	    var currentYear = currentDate.getFullYear();
	    var selectedDay = this.props.selectedDate ? this.props.selectedDate.getDate() : null;
	    var selectedMonth = this.props.selectedDate ? this.props.selectedDate.getMonth() : null;
	    var selectedYear = this.props.selectedDate ? this.props.selectedDate.getFullYear() : null;
	    var year = this.props.displayDate.getFullYear();
	    var month = this.props.displayDate.getMonth();
	    var firstDay = new Date(year, month, 1);
	    var startingDay = this.props.weekStartsOnMonday ? firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1 : firstDay.getDay();
	
	    var monthLength = daysInMonth[month];
	    if (month == 1) {
	      if (year % 4 == 0 && year % 100 != 0 || year % 400 == 0) {
	        monthLength = 29;
	      }
	    }
	
	    var weeks = [];
	    var day = 1;
	    for (var i = 0; i < 9; i++) {
	      var week = [];
	      for (var j = 0; j <= 6; j++) {
	        if (day <= monthLength && (i > 0 || j >= startingDay)) {
	          var selected = day === selectedDay && month == selectedMonth && year === selectedYear;
	          var current = day === currentDay && month == currentMonth && year === currentYear;
	          week.push(_react2.default.createElement(
	            'td',
	            {
	              key: j,
	              onClick: this.handleClick.bind(this, day),
	              style: { cursor: 'pointer', padding: this.props.cellPadding },
	              className: selected ? 'bg-primary' : current ? 'text-muted' : null },
	            day
	          ));
	          day++;
	        } else {
	          week.push(_react2.default.createElement('td', { key: j }));
	        }
	      }
	
	      weeks.push(_react2.default.createElement(
	        'tr',
	        { key: i },
	        week
	      ));
	      if (day > monthLength) {
	        break;
	      }
	    }
	
	    return _react2.default.createElement(
	      'table',
	      { className: 'text-center' },
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          this.props.dayLabels.map(function (label, index) {
	            return _react2.default.createElement(
	              'td',
	              {
	                key: index,
	                className: 'text-muted',
	                style: { padding: _this.props.cellPadding } },
	              _react2.default.createElement(
	                'small',
	                null,
	                label
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        weeks
	      ),
	      this.props.showTodayButton && _react2.default.createElement(
	        'tfoot',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            { colSpan: this.props.dayLabels.length, style: { paddingTop: '9px' } },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                block: true,
	                bsSize: 'xsmall',
	                className: 'u-today-button',
	                onClick: this.handleClickToday },
	              this.props.todayButtonLabel
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = _react2.default.createClass({
	  displayName: 'DatePicker',
	
	  propTypes: {
	    defaultValue: _react2.default.PropTypes.string,
	    value: _react2.default.PropTypes.string,
	    className: _react2.default.PropTypes.string,
	    style: _react2.default.PropTypes.object,
	    cellPadding: _react2.default.PropTypes.string,
	    placeholder: _react2.default.PropTypes.string,
	    dayLabels: _react2.default.PropTypes.array,
	    monthLabels: _react2.default.PropTypes.array,
	    onChange: _react2.default.PropTypes.func,
	    onClear: _react2.default.PropTypes.func,
	    onBlur: _react2.default.PropTypes.func,
	    onFocus: _react2.default.PropTypes.func,
	    autoFocus: _react2.default.PropTypes.bool,
	    disabled: _react2.default.PropTypes.bool,
	    weekStartsOnMonday: _react2.default.PropTypes.bool,
	    clearButtonElement: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object]),
	    showClearButton: _react2.default.PropTypes.bool,
	    previousButtonElement: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object]),
	    nextButtonElement: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object]),
	    calendarPlacement: _react2.default.PropTypes.string,
	    dateFormat: _react2.default.PropTypes.string, // 'MM/DD/YYYY', 'DD/MM/YYYY', 'YYYY/MM/DD', 'DD-MM-YYYY'
	    bsClass: _react2.default.PropTypes.string,
	    bsSize: _react2.default.PropTypes.string,
	    calendarContainer: _react2.default.PropTypes.object,
	    id: _react2.default.PropTypes.string,
	    name: _react2.default.PropTypes.string,
	    showTodayButton: _react2.default.PropTypes.bool,
	    todayButtonLabel: _react2.default.PropTypes.string,
	    customControl: _react2.default.PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    var language = typeof window !== 'undefined' && window.navigator ? (window.navigator.userLanguage || window.navigator.language || '').toLowerCase() : '';
	    var dateFormat = !language || language === 'en-us' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
	    return {
	      cellPadding: '5px',
	      dayLabels: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	      monthLabels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	      clearButtonElement: '×',
	      previousButtonElement: '<',
	      nextButtonElement: '>',
	      calendarPlacement: 'bottom',
	      dateFormat: dateFormat,
	      showClearButton: true,
	      autoFocus: false,
	      disabled: false,
	      showTodayButton: false,
	      todayButtonLabel: 'Today',
	      instanceCount: instanceCount++,
	      style: {
	        width: '100%'
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    if (this.props.value && this.props.defaultValue) {
	      throw new Error('Conflicting DatePicker properties \'value\' and \'defaultValue\'');
	    }
	    var state = this.makeDateValues(this.props.value || this.props.defaultValue);
	    if (this.props.weekStartsOnMonday) {
	      state.dayLabels = this.props.dayLabels.slice(1).concat(this.props.dayLabels.slice(0, 1));
	    } else {
	      state.dayLabels = this.props.dayLabels;
	    }
	    state.focused = false;
	    state.inputFocused = false;
	    state.placeholder = this.props.placeholder || this.props.dateFormat;
	    state.separator = this.props.dateFormat.match(/[^A-Z]/)[0];
	    return state;
	  },
	  makeDateValues: function makeDateValues(isoString) {
	    var displayDate = void 0;
	    var selectedDate = isoString ? new Date(isoString.slice(0, 10) + 'T12:00:00.000Z') : null;
	    var inputValue = isoString ? this.makeInputValueString(selectedDate) : null;
	    if (selectedDate) {
	      displayDate = new Date(selectedDate);
	    } else {
	      displayDate = new Date(new Date().toISOString().slice(0, 10) + 'T12:00:00.000Z');
	    }
	
	    return {
	      value: selectedDate ? selectedDate.toISOString() : null,
	      displayDate: displayDate,
	      selectedDate: selectedDate,
	      inputValue: inputValue
	    };
	  },
	  clear: function clear() {
	    if (this.props.onClear) {
	      this.props.onClear();
	    } else {
	      this.setState(this.makeDateValues(null));
	    }
	
	    if (this.props.onChange) {
	      this.props.onChange(null, null);
	    }
	  },
	  handleHide: function handleHide() {
	    if (this.state.inputFocused) {
	      return;
	    }
	    this.setState({
	      focused: false
	    });
	    if (this.props.onBlur) {
	      var event = document.createEvent('CustomEvent');
	      event.initEvent('Change Date', true, false);
	      _reactDom2.default.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
	      this.props.onBlur(event);
	    }
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    if (e.which === 9 && this.state.inputFocused) {
	      this.setState({
	        focused: false
	      });
	
	      if (this.props.onBlur) {
	        var event = document.createEvent('CustomEvent');
	        event.initEvent('Change Date', true, false);
	        _reactDom2.default.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
	        this.props.onBlur(event);
	      }
	    }
	  },
	  handleFocus: function handleFocus() {
	    if (this.state.focused === true) {
	      return;
	    }
	
	    this.setState({
	      inputFocused: true,
	      focused: true
	    });
	
	    if (this.props.onFocus) {
	      var event = document.createEvent('CustomEvent');
	      event.initEvent('Change Date', true, false);
	      _reactDom2.default.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
	      this.props.onFocus(event);
	    }
	  },
	  handleBlur: function handleBlur() {
	    this.setState({
	      inputFocused: false
	    });
	  },
	
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !(this.state.inputFocused === true && nextState.inputFocused === false);
	  },
	
	  getValue: function getValue() {
	    return this.state.selectedDate ? this.state.selectedDate.toISOString() : null;
	  },
	  getFormattedValue: function getFormattedValue() {
	    return this.state.displayDate ? this.state.inputValue : null;
	  },
	  makeInputValueString: function makeInputValueString(date) {
	    var month = date.getMonth() + 1;
	    var day = date.getDate();
	
	    //this method is executed during intialState setup... handle a missing state properly
	    var separator = this.state ? this.state.separator : this.props.dateFormat.match(/[^A-Z]/)[0];
	    if (this.props.dateFormat.match(/MM.DD.YYYY/)) {
	      return (month > 9 ? month : '0' + month) + separator + (day > 9 ? day : '0' + day) + separator + date.getFullYear();
	    } else if (this.props.dateFormat.match(/DD.MM.YYYY/)) {
	      return (day > 9 ? day : '0' + day) + separator + (month > 9 ? month : '0' + month) + separator + date.getFullYear();
	    } else {
	      return date.getFullYear() + separator + (month > 9 ? month : '0' + month) + separator + (day > 9 ? day : '0' + day);
	    }
	  },
	  handleBadInput: function handleBadInput(originalValue) {
	    var parts = originalValue.replace(new RegExp('[^0-9' + this.state.separator + ']'), '').split(this.state.separator);
	    if (this.props.dateFormat.match(/MM.DD.YYYY/) || this.props.dateFormat.match(/DD.MM.YYYY/)) {
	      if (parts[0] && parts[0].length > 2) {
	        parts[1] = parts[0].slice(2) + (parts[1] || '');
	        parts[0] = parts[0].slice(0, 2);
	      }
	      if (parts[1] && parts[1].length > 2) {
	        parts[2] = parts[1].slice(2) + (parts[2] || '');
	        parts[1] = parts[1].slice(0, 2);
	      }
	      if (parts[2]) {
	        parts[2] = parts[2].slice(0, 4);
	      }
	    } else {
	      if (parts[0] && parts[0].length > 4) {
	        parts[1] = parts[0].slice(4) + (parts[1] || '');
	        parts[0] = parts[0].slice(0, 4);
	      }
	      if (parts[1] && parts[1].length > 2) {
	        parts[2] = parts[1].slice(2) + (parts[2] || '');
	        parts[1] = parts[1].slice(0, 2);
	      }
	      if (parts[2]) {
	        parts[2] = parts[2].slice(0, 2);
	      }
	    }
	    this.setState({
	      inputValue: parts.join(this.state.separator)
	    });
	  },
	  handleInputChange: function handleInputChange() {
	
	    var originalValue = _reactDom2.default.findDOMNode(this.refs.input).value;
	    var inputValue = originalValue.replace(/(-|\/\/)/g, this.state.separator).slice(0, 10);
	
	    var month = void 0,
	        day = void 0,
	        year = void 0;
	    if (this.props.dateFormat.match(/MM.DD.YYYY/)) {
	      if (!inputValue.match(/[0-1][0-9].[0-3][0-9].[1-2][0-9][0-9][0-9]/)) {
	        return this.handleBadInput(originalValue);
	      }
	
	      month = inputValue.slice(0, 2).replace(/[^0-9]/g, '');
	      day = inputValue.slice(3, 5).replace(/[^0-9]/g, '');
	      year = inputValue.slice(6, 10).replace(/[^0-9]/g, '');
	    } else if (this.props.dateFormat.match(/DD.MM.YYYY/)) {
	      if (!inputValue.match(/[0-3][0-9].[0-1][0-9].[1-2][0-9][0-9][0-9]/)) {
	        return this.handleBadInput(originalValue);
	      }
	
	      day = inputValue.slice(0, 2).replace(/[^0-9]/g, '');
	      month = inputValue.slice(3, 5).replace(/[^0-9]/g, '');
	      year = inputValue.slice(6, 10).replace(/[^0-9]/g, '');
	    } else {
	      if (!inputValue.match(/[1-2][0-9][0-9][0-9].[0-1][0-9].[0-3][0-9]/)) {
	        return this.handleBadInput(originalValue);
	      }
	
	      year = inputValue.slice(0, 4).replace(/[^0-9]/g, '');
	      month = inputValue.slice(5, 7).replace(/[^0-9]/g, '');
	      day = inputValue.slice(8, 10).replace(/[^0-9]/g, '');
	    }
	
	    var monthInteger = parseInt(month, 10);
	    var dayInteger = parseInt(day, 10);
	    var yearInteger = parseInt(year, 10);
	    if (monthInteger > 12 || dayInteger > 31) {
	      return this.handleBadInput(originalValue);
	    }
	
	    if (!isNaN(monthInteger) && !isNaN(dayInteger) && !isNaN(yearInteger) && monthInteger <= 12 && dayInteger <= 31 && yearInteger > 999) {
	      var selectedDate = new Date(yearInteger, monthInteger - 1, dayInteger, 12, 0, 0, 0);
	      this.setState({
	        selectedDate: selectedDate,
	        displayDate: selectedDate,
	        value: selectedDate.toISOString()
	      });
	
	      if (this.props.onChange) {
	        this.props.onChange(selectedDate.toISOString(), inputValue);
	      }
	    }
	
	    this.setState({
	      inputValue: inputValue
	    });
	  },
	  onChangeMonth: function onChangeMonth(newDisplayDate) {
	    this.setState({
	      displayDate: newDisplayDate
	    });
	  },
	  onChangeDate: function onChangeDate(newSelectedDate) {
	    var inputValue = this.makeInputValueString(newSelectedDate);
	    this.setState({
	      inputValue: inputValue,
	      selectedDate: newSelectedDate,
	      displayDate: newSelectedDate,
	      value: newSelectedDate.toISOString(),
	      focused: false
	    });
	
	    if (this.props.onBlur) {
	      var event = document.createEvent('CustomEvent');
	      event.initEvent('Change Date', true, false);
	      _reactDom2.default.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
	      this.props.onBlur(event);
	    }
	
	    if (this.props.onChange) {
	      this.props.onChange(newSelectedDate.toISOString(), inputValue);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    var value = newProps.value;
	    if (this.getValue() !== value) {
	      this.setState(this.makeDateValues(value));
	    }
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var calendarHeader = _react2.default.createElement(CalendarHeader, {
	      previousButtonElement: this.props.previousButtonElement,
	      nextButtonElement: this.props.nextButtonElement,
	      displayDate: this.state.displayDate,
	      onChange: this.onChangeMonth,
	      monthLabels: this.props.monthLabels,
	      dateFormat: this.props.dateFormat });
	
	    var control = this.props.customControl ? _react2.default.cloneElement(this.props.customControl, {
	      onKeyDown: this.handleKeyDown,
	      value: this.state.inputValue || '',
	      placeholder: this.state.focused ? this.props.dateFormat : this.state.placeholder,
	      ref: 'input',
	      disabled: this.props.disabled,
	      onFocus: this.handleFocus,
	      onBlur: this.handleBlur,
	      onChange: this.handleInputChange,
	      className: this.props.className,
	      style: this.props.style
	    }) : _react2.default.createElement(_reactBootstrap.FormControl, {
	      onKeyDown: this.handleKeyDown,
	      value: this.state.inputValue || '',
	      ref: 'input',
	      type: 'text',
	      className: this.props.className,
	      style: this.props.style,
	      autoFocus: this.props.autoFocus,
	      disabled: this.props.disabled,
	      placeholder: this.state.focused ? this.props.dateFormat : this.state.placeholder,
	      onFocus: this.handleFocus,
	      onBlur: this.handleBlur,
	      onChange: this.handleInputChange
	    });
	
	    return _react2.default.createElement(
	      _reactBootstrap.InputGroup,
	      {
	        ref: 'inputGroup',
	        bsClass: this.props.showClearButton ? this.props.bsClass : '',
	        bsSize: this.props.bsSize,
	        id: this.props.id ? this.props.id + '_group' : null },
	      _react2.default.createElement(
	        _reactBootstrap.Overlay,
	        {
	          rootClose: true,
	          onHide: this.handleHide,
	          show: this.state.focused,
	          container: function container() {
	            return _this2.props.calendarContainer || _reactDom2.default.findDOMNode(_this2.refs.overlayContainer);
	          },
	          target: function target() {
	            return _reactDom2.default.findDOMNode(_this2.refs.input);
	          },
	          placement: this.props.calendarPlacement,
	          delayHide: 200 },
	        _react2.default.createElement(
	          _reactBootstrap.Popover,
	          { id: 'date-picker-popover-' + this.props.instanceCount, className: 'date-picker-popover', title: calendarHeader },
	          _react2.default.createElement(Calendar, {
	            cellPadding: this.props.cellPadding,
	            selectedDate: this.state.selectedDate,
	            displayDate: this.state.displayDate,
	            onChange: this.onChangeDate,
	            dayLabels: this.state.dayLabels,
	            weekStartsOnMonday: this.props.weekStartsOnMonday,
	            showTodayButton: this.props.showTodayButton,
	            todayButtonLabel: this.props.todayButtonLabel })
	        )
	      ),
	      _react2.default.createElement('div', { ref: 'overlayContainer', style: { position: 'relative' } }),
	      _react2.default.createElement('input', { ref: 'hiddenInput', type: 'hidden', id: this.props.id, name: this.props.name, value: this.state.value || '', 'data-formattedvalue': this.state.value ? this.state.inputValue : '' }),
	      control,
	      this.props.showClearButton && !this.props.customControl && _react2.default.createElement(
	        _reactBootstrap.InputGroup.Addon,
	        {
	          onClick: this.props.disabled ? null : this.clear,
	          style: { cursor: this.state.inputValue && !this.props.disabled ? 'pointer' : 'not-allowed' } },
	        _react2.default.createElement(
	          'div',
	          { style: { opacity: this.state.inputValue && !this.props.disabled ? 1 : 0.5 } },
	          this.props.clearButtonElement
	        )
	      )
	    );
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.Well = exports.Tooltip = exports.Thumbnail = exports.Tabs = exports.TabPane = exports.Table = exports.TabContent = exports.TabContainer = exports.Tab = exports.SplitButton = exports.SafeAnchor = exports.Row = exports.ResponsiveEmbed = exports.Radio = exports.ProgressBar = exports.Popover = exports.PanelGroup = exports.Panel = exports.PaginationButton = exports.Pagination = exports.Pager = exports.PageItem = exports.PageHeader = exports.OverlayTrigger = exports.Overlay = exports.NavItem = exports.NavDropdown = exports.NavbarBrand = exports.Navbar = exports.Nav = exports.ModalTitle = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = exports.Modal = exports.MenuItem = exports.Media = exports.ListGroupItem = exports.ListGroup = exports.Label = exports.Jumbotron = exports.InputGroup = exports.Image = exports.HelpBlock = exports.Grid = exports.Glyphicon = exports.FormGroup = exports.FormControl = exports.Form = exports.Fade = exports.DropdownButton = exports.Dropdown = exports.Collapse = exports.Col = exports.ControlLabel = exports.Clearfix = exports.Checkbox = exports.CarouselItem = exports.Carousel = exports.ButtonToolbar = exports.ButtonGroup = exports.Button = exports.BreadcrumbItem = exports.Breadcrumb = exports.Badge = exports.Alert = exports.Accordion = undefined;
	
	var _Accordion2 = __webpack_require__("./node_modules/react-bootstrap/lib/Accordion.js");
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	var _Alert2 = __webpack_require__("./node_modules/react-bootstrap/lib/Alert.js");
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	var _Badge2 = __webpack_require__("./node_modules/react-bootstrap/lib/Badge.js");
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _Breadcrumb2 = __webpack_require__("./node_modules/react-bootstrap/lib/Breadcrumb.js");
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	var _BreadcrumbItem2 = __webpack_require__("./node_modules/react-bootstrap/lib/BreadcrumbItem.js");
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	var _Button2 = __webpack_require__("./node_modules/react-bootstrap/lib/Button.js");
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _ButtonGroup2 = __webpack_require__("./node_modules/react-bootstrap/lib/ButtonGroup.js");
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	var _ButtonToolbar2 = __webpack_require__("./node_modules/react-bootstrap/lib/ButtonToolbar.js");
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	var _Carousel2 = __webpack_require__("./node_modules/react-bootstrap/lib/Carousel.js");
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	var _CarouselItem2 = __webpack_require__("./node_modules/react-bootstrap/lib/CarouselItem.js");
	
	var _CarouselItem3 = _interopRequireDefault(_CarouselItem2);
	
	var _Checkbox2 = __webpack_require__("./node_modules/react-bootstrap/lib/Checkbox.js");
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Clearfix2 = __webpack_require__("./node_modules/react-bootstrap/lib/Clearfix.js");
	
	var _Clearfix3 = _interopRequireDefault(_Clearfix2);
	
	var _ControlLabel2 = __webpack_require__("./node_modules/react-bootstrap/lib/ControlLabel.js");
	
	var _ControlLabel3 = _interopRequireDefault(_ControlLabel2);
	
	var _Col2 = __webpack_require__("./node_modules/react-bootstrap/lib/Col.js");
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	var _Collapse2 = __webpack_require__("./node_modules/react-bootstrap/lib/Collapse.js");
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _Dropdown2 = __webpack_require__("./node_modules/react-bootstrap/lib/Dropdown.js");
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	var _DropdownButton2 = __webpack_require__("./node_modules/react-bootstrap/lib/DropdownButton.js");
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	var _Fade2 = __webpack_require__("./node_modules/react-bootstrap/lib/Fade.js");
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	var _Form2 = __webpack_require__("./node_modules/react-bootstrap/lib/Form.js");
	
	var _Form3 = _interopRequireDefault(_Form2);
	
	var _FormControl2 = __webpack_require__("./node_modules/react-bootstrap/lib/FormControl.js");
	
	var _FormControl3 = _interopRequireDefault(_FormControl2);
	
	var _FormGroup2 = __webpack_require__("./node_modules/react-bootstrap/lib/FormGroup.js");
	
	var _FormGroup3 = _interopRequireDefault(_FormGroup2);
	
	var _Glyphicon2 = __webpack_require__("./node_modules/react-bootstrap/lib/Glyphicon.js");
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	var _Grid2 = __webpack_require__("./node_modules/react-bootstrap/lib/Grid.js");
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _HelpBlock2 = __webpack_require__("./node_modules/react-bootstrap/lib/HelpBlock.js");
	
	var _HelpBlock3 = _interopRequireDefault(_HelpBlock2);
	
	var _Image2 = __webpack_require__("./node_modules/react-bootstrap/lib/Image.js");
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	var _InputGroup2 = __webpack_require__("./node_modules/react-bootstrap/lib/InputGroup.js");
	
	var _InputGroup3 = _interopRequireDefault(_InputGroup2);
	
	var _Jumbotron2 = __webpack_require__("./node_modules/react-bootstrap/lib/Jumbotron.js");
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	var _Label2 = __webpack_require__("./node_modules/react-bootstrap/lib/Label.js");
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _ListGroup2 = __webpack_require__("./node_modules/react-bootstrap/lib/ListGroup.js");
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	var _ListGroupItem2 = __webpack_require__("./node_modules/react-bootstrap/lib/ListGroupItem.js");
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	var _Media2 = __webpack_require__("./node_modules/react-bootstrap/lib/Media.js");
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MenuItem2 = __webpack_require__("./node_modules/react-bootstrap/lib/MenuItem.js");
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _Modal2 = __webpack_require__("./node_modules/react-bootstrap/lib/Modal.js");
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _ModalBody2 = __webpack_require__("./node_modules/react-bootstrap/lib/ModalBody.js");
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	var _ModalFooter2 = __webpack_require__("./node_modules/react-bootstrap/lib/ModalFooter.js");
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	var _ModalHeader2 = __webpack_require__("./node_modules/react-bootstrap/lib/ModalHeader.js");
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	var _ModalTitle2 = __webpack_require__("./node_modules/react-bootstrap/lib/ModalTitle.js");
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	var _Nav2 = __webpack_require__("./node_modules/react-bootstrap/lib/Nav.js");
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	var _Navbar2 = __webpack_require__("./node_modules/react-bootstrap/lib/Navbar.js");
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	var _NavbarBrand2 = __webpack_require__("./node_modules/react-bootstrap/lib/NavbarBrand.js");
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	var _NavDropdown2 = __webpack_require__("./node_modules/react-bootstrap/lib/NavDropdown.js");
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	var _NavItem2 = __webpack_require__("./node_modules/react-bootstrap/lib/NavItem.js");
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	var _Overlay2 = __webpack_require__("./node_modules/react-bootstrap/lib/Overlay.js");
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _OverlayTrigger2 = __webpack_require__("./node_modules/react-bootstrap/lib/OverlayTrigger.js");
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	var _PageHeader2 = __webpack_require__("./node_modules/react-bootstrap/lib/PageHeader.js");
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	var _PageItem2 = __webpack_require__("./node_modules/react-bootstrap/lib/PageItem.js");
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	var _Pager2 = __webpack_require__("./node_modules/react-bootstrap/lib/Pager.js");
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	var _Pagination2 = __webpack_require__("./node_modules/react-bootstrap/lib/Pagination.js");
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	var _PaginationButton2 = __webpack_require__("./node_modules/react-bootstrap/lib/PaginationButton.js");
	
	var _PaginationButton3 = _interopRequireDefault(_PaginationButton2);
	
	var _Panel2 = __webpack_require__("./node_modules/react-bootstrap/lib/Panel.js");
	
	var _Panel3 = _interopRequireDefault(_Panel2);
	
	var _PanelGroup2 = __webpack_require__("./node_modules/react-bootstrap/lib/PanelGroup.js");
	
	var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);
	
	var _Popover2 = __webpack_require__("./node_modules/react-bootstrap/lib/Popover.js");
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _ProgressBar2 = __webpack_require__("./node_modules/react-bootstrap/lib/ProgressBar.js");
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	var _Radio2 = __webpack_require__("./node_modules/react-bootstrap/lib/Radio.js");
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _ResponsiveEmbed2 = __webpack_require__("./node_modules/react-bootstrap/lib/ResponsiveEmbed.js");
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	var _Row2 = __webpack_require__("./node_modules/react-bootstrap/lib/Row.js");
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	var _SafeAnchor2 = __webpack_require__("./node_modules/react-bootstrap/lib/SafeAnchor.js");
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	var _SplitButton2 = __webpack_require__("./node_modules/react-bootstrap/lib/SplitButton.js");
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	var _Tab2 = __webpack_require__("./node_modules/react-bootstrap/lib/Tab.js");
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _TabContainer2 = __webpack_require__("./node_modules/react-bootstrap/lib/TabContainer.js");
	
	var _TabContainer3 = _interopRequireDefault(_TabContainer2);
	
	var _TabContent2 = __webpack_require__("./node_modules/react-bootstrap/lib/TabContent.js");
	
	var _TabContent3 = _interopRequireDefault(_TabContent2);
	
	var _Table2 = __webpack_require__("./node_modules/react-bootstrap/lib/Table.js");
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TabPane2 = __webpack_require__("./node_modules/react-bootstrap/lib/TabPane.js");
	
	var _TabPane3 = _interopRequireDefault(_TabPane2);
	
	var _Tabs2 = __webpack_require__("./node_modules/react-bootstrap/lib/Tabs.js");
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Thumbnail2 = __webpack_require__("./node_modules/react-bootstrap/lib/Thumbnail.js");
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	var _Tooltip2 = __webpack_require__("./node_modules/react-bootstrap/lib/Tooltip.js");
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _Well2 = __webpack_require__("./node_modules/react-bootstrap/lib/Well.js");
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	var _utils2 = __webpack_require__("./node_modules/react-bootstrap/lib/utils/index.js");
	
	var _utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.Accordion = _Accordion3['default'];
	exports.Alert = _Alert3['default'];
	exports.Badge = _Badge3['default'];
	exports.Breadcrumb = _Breadcrumb3['default'];
	exports.BreadcrumbItem = _BreadcrumbItem3['default'];
	exports.Button = _Button3['default'];
	exports.ButtonGroup = _ButtonGroup3['default'];
	exports.ButtonToolbar = _ButtonToolbar3['default'];
	exports.Carousel = _Carousel3['default'];
	exports.CarouselItem = _CarouselItem3['default'];
	exports.Checkbox = _Checkbox3['default'];
	exports.Clearfix = _Clearfix3['default'];
	exports.ControlLabel = _ControlLabel3['default'];
	exports.Col = _Col3['default'];
	exports.Collapse = _Collapse3['default'];
	exports.Dropdown = _Dropdown3['default'];
	exports.DropdownButton = _DropdownButton3['default'];
	exports.Fade = _Fade3['default'];
	exports.Form = _Form3['default'];
	exports.FormControl = _FormControl3['default'];
	exports.FormGroup = _FormGroup3['default'];
	exports.Glyphicon = _Glyphicon3['default'];
	exports.Grid = _Grid3['default'];
	exports.HelpBlock = _HelpBlock3['default'];
	exports.Image = _Image3['default'];
	exports.InputGroup = _InputGroup3['default'];
	exports.Jumbotron = _Jumbotron3['default'];
	exports.Label = _Label3['default'];
	exports.ListGroup = _ListGroup3['default'];
	exports.ListGroupItem = _ListGroupItem3['default'];
	exports.Media = _Media3['default'];
	exports.MenuItem = _MenuItem3['default'];
	exports.Modal = _Modal3['default'];
	exports.ModalBody = _ModalBody3['default'];
	exports.ModalFooter = _ModalFooter3['default'];
	exports.ModalHeader = _ModalHeader3['default'];
	exports.ModalTitle = _ModalTitle3['default'];
	exports.Nav = _Nav3['default'];
	exports.Navbar = _Navbar3['default'];
	exports.NavbarBrand = _NavbarBrand3['default'];
	exports.NavDropdown = _NavDropdown3['default'];
	exports.NavItem = _NavItem3['default'];
	exports.Overlay = _Overlay3['default'];
	exports.OverlayTrigger = _OverlayTrigger3['default'];
	exports.PageHeader = _PageHeader3['default'];
	exports.PageItem = _PageItem3['default'];
	exports.Pager = _Pager3['default'];
	exports.Pagination = _Pagination3['default'];
	exports.PaginationButton = _PaginationButton3['default'];
	exports.Panel = _Panel3['default'];
	exports.PanelGroup = _PanelGroup3['default'];
	exports.Popover = _Popover3['default'];
	exports.ProgressBar = _ProgressBar3['default'];
	exports.Radio = _Radio3['default'];
	exports.ResponsiveEmbed = _ResponsiveEmbed3['default'];
	exports.Row = _Row3['default'];
	exports.SafeAnchor = _SafeAnchor3['default'];
	exports.SplitButton = _SplitButton3['default'];
	exports.Tab = _Tab3['default'];
	exports.TabContainer = _TabContainer3['default'];
	exports.TabContent = _TabContent3['default'];
	exports.Table = _Table3['default'];
	exports.TabPane = _TabPane3['default'];
	exports.Tabs = _Tabs3['default'];
	exports.Thumbnail = _Thumbnail3['default'];
	exports.Tooltip = _Tooltip3['default'];
	exports.Well = _Well3['default'];
	exports.utils = _utils;

/***/ },

/***/ "./node_modules/react-bootstrap/lib/NavDropdown.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__("./node_modules/react-bootstrap/lib/Dropdown.js");
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__("./node_modules/react-bootstrap/lib/utils/splitComponentProps.js");
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _ValidComponentChildren = __webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js");
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  title: _propTypes2['default'].node.isRequired,
	  noCaret: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var NavDropdown = function (_React$Component) {
	  (0, _inherits3['default'])(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    (0, _classCallCheck3['default'])(this, NavDropdown);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
	    var props = _ref.props;
	
	    var _this2 = this;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    if (_ValidComponentChildren2['default'].some(props.children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    })) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  NavDropdown.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        activeKey = _props.activeKey,
	        activeHref = _props.activeHref,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);
	
	
	    var active = this.isActive(this, activeKey, activeHref);
	    delete props.active; // Accessed via this.isActive().
	    delete props.eventKey; // Accessed via this.isActive().
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
	    // rather than the `<Dropdown.Toggle>`.
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        componentClass: 'li',
	        className: (0, _classnames2['default'])(className, { active: active }),
	        style: style
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, { useAnchor: true }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            active: _this3.isActive(child, activeKey, activeHref)
	          });
	        })
	      )
	    );
	  };
	
	  return NavDropdown;
	}(_react2['default'].Component);
	
	NavDropdown.propTypes = propTypes;
	
	exports['default'] = NavDropdown;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/ProgressBar.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__("./node_modules/babel-runtime/core-js/object/values.js");
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__("./node_modules/react-bootstrap/lib/utils/bootstrapUtils.js");
	
	var _StyleConfig = __webpack_require__("./node_modules/react-bootstrap/lib/utils/StyleConfig.js");
	
	var _ValidComponentChildren = __webpack_require__("./node_modules/react-bootstrap/lib/utils/ValidComponentChildren.js");
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ROUND_PRECISION = 1000;
	
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	
	    if (child.type === ProgressBar) {
	      // eslint-disable-line no-use-before-define
	      return;
	    }
	
	    var childIdentifier = _react2['default'].isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
	    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
	  });
	
	  return error;
	}
	
	var propTypes = {
	  min: _propTypes2['default'].number,
	  now: _propTypes2['default'].number,
	  max: _propTypes2['default'].number,
	  label: _propTypes2['default'].node,
	  srOnly: _propTypes2['default'].bool,
	  striped: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	  children: onlyProgressBar,
	
	  /**
	   * @private
	   */
	  isChild: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	var ProgressBar = function (_React$Component) {
	  (0, _inherits3['default'])(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    (0, _classCallCheck3['default'])(this, ProgressBar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
	    var _extends2;
	
	    var min = _ref.min,
	        now = _ref.now,
	        max = _ref.max,
	        label = _ref.label,
	        srOnly = _ref.srOnly,
	        striped = _ref.striped,
	        active = _ref.active,
	        className = _ref.className,
	        style = _ref.style,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = active || striped, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'progressbar',
	        className: (0, _classnames2['default'])(className, classes),
	        style: (0, _extends4['default'])({ width: getPercentage(now, min, max) + '%' }, style),
	        'aria-valuenow': now,
	        'aria-valuemin': min,
	        'aria-valuemax': max
	      }),
	      srOnly ? _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      ) : label
	    );
	  };
	
	  ProgressBar.prototype.render = function render() {
	    var _props = this.props,
	        isChild = _props.isChild,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['isChild']);
	
	
	    if (isChild) {
	      return this.renderProgressBar(props);
	    }
	
	    var min = props.min,
	        now = props.now,
	        max = props.max,
	        label = props.label,
	        srOnly = props.srOnly,
	        striped = props.striped,
	        active = props.active,
	        bsClass = props.bsClass,
	        bsStyle = props.bsStyle,
	        className = props.className,
	        children = props.children,
	        wrapperProps = (0, _objectWithoutProperties3['default'])(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);
	
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, wrapperProps, {
	        className: (0, _classnames2['default'])(className, 'progress')
	      }),
	      children ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { isChild: true });
	      }) : this.renderProgressBar({
	        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
	      })
	    );
	  };
	
	  return ProgressBar;
	}(_react2['default'].Component);
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ProgressBar));
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-bootstrap/lib/SplitButton.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__("./node_modules/react-bootstrap/lib/Button.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__("./node_modules/react-bootstrap/lib/Dropdown.js");
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__("./node_modules/react-bootstrap/lib/SplitToggle.js");
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _splitComponentProps2 = __webpack_require__("./node_modules/react-bootstrap/lib/utils/splitComponentProps.js");
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2['default'].string,
	  bsSize: _propTypes2['default'].string,
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  /**
	   * The content of the split button.
	   */
	  title: _propTypes2['default'].node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _propTypes2['default'].string,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var SplitButton = function (_React$Component) {
	  (0, _inherits3['default'])(SplitButton, _React$Component);
	
	  function SplitButton() {
	    (0, _classCallCheck3['default'])(this, SplitButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        toggleLabel = _props.toggleLabel,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        buttonProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Button2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          disabled: props.disabled,
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(_SplitToggle2['default'], {
	        'aria-label': toggleLabel || title,
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return SplitButton;
	}(_react2['default'].Component);
	
	SplitButton.propTypes = propTypes;
	
	SplitButton.Toggle = _SplitToggle2['default'];
	
	exports['default'] = SplitButton;
	module.exports = exports['default'];

/***/ },

/***/ "./src/universal/collections/users/methods.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getPartners = exports.createUser = exports.updateLicence = exports.updateCertificat = exports.updatePassword = undefined;
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _alerts = __webpack_require__("./src/universal/collections/alerts/alerts.js");
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Accounts = Package['accounts-base'].Accounts;
	var ValidatedMethod = Package['mdg:validated-method'].ValidatedMethod;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var DDPRateLimiter = Package['ddp-rate-limiter'].DDPRateLimiter;
	var updatePassword = exports.updatePassword = new ValidatedMethod({
		name: 'users.updatePassword',
		validate: new SimpleSchema({
			_id: { type: String },
			password: { type: String, min: 8 }
		}).validator(),
		run: function run(_ref) {
			var _id = _ref._id,
			    password = _ref.password;
	
			if (!_roles.Roles.userHasPermission(Meteor.userId(), 'users.update', Meteor.userId(), Meteor.users.findOne(_id))) throw new Meteor.Error('unauthorized', 'Vous ne pouvez pas modifier ce mot de passe.');
	
			if (Meteor.isServer) Accounts.setPassword(_id, password, { logout: false });
	
			return true;
		}
	});
	
	var updateCertificat = exports.updateCertificat = new ValidatedMethod({
		name: 'users.updateCertificat',
		validate: new SimpleSchema({
			_id: { type: String },
			certificat: { type: String }
		}).validator(),
		run: function run(_ref2) {
			var _id = _ref2._id,
			    certificat = _ref2.certificat;
	
			if (!_roles.Roles.userHasPermission(Meteor.userId(), 'users.update', Meteor.userId(), Meteor.users.findOne(_id))) throw new Meteor.Error('unauthorized', 'Vous ne pouvez pas modifier ce certificat.');
			if (Meteor.isServer) Meteor.users.update(_id, { "$set": { 'profile.certificat': certificat } });
	
			var user = Meteor.user();
	
			_alerts.Alerts.remove({ to_users: [user._id], ref: 'certificat' });
	
			var alert = {
				content: 'Le certificat médical de ' + user.profile.firstName + ' ' + user.profile.lastName + ' expire le ' + (0, _moment2.default)(certificat).format('DD/MM/YYYY'),
				from: (0, _moment2.default)(certificat).subtract(30, 'days').format().toString(),
				to: (0, _moment2.default)(certificat).add(5, 'days').format().toString(),
				ref: 'certificat',
				to_users: [user._id],
				to_type: ['organizer', 'god'],
				type: "Alerte"
			};
			_alerts.Alerts.insert(alert);
	
			return true;
		}
	});
	
	var updateLicence = exports.updateLicence = new ValidatedMethod({
		name: 'users.updateLicence',
		validate: new SimpleSchema({
			_id: { type: String },
			licence: { type: String }
		}).validator(),
		run: function run(_ref3) {
			var _id = _ref3._id,
			    licence = _ref3.licence;
	
			if (!_roles.Roles.userHasPermission(Meteor.userId(), 'users.update', Meteor.userId(), Meteor.users.findOne(_id))) throw new Meteor.Error('unauthorized', 'Vous ne pouvez pas modifier cette licence.');
			if (Meteor.isServer) Meteor.users.update(_id, { "$set": { 'profile.licence': licence } });
	
			var user = Meteor.user();
	
			_alerts.Alerts.remove({ to_users: [user._id], ref: 'licence' });
	
			var alert = {
				content: 'La licence pilote de ' + user.profile.firstName + ' ' + user.profile.lastName + ' expire le ' + (0, _moment2.default)(licence).format('DD/MM/YYYY'),
				from: (0, _moment2.default)(licence).subtract(30, 'days').format().toString(),
				to: (0, _moment2.default)(licence).add(5, 'days').format().toString(),
				ref: 'licence',
				to_users: [user._id],
				to_type: ['organizer', 'god'],
				type: "Alerte"
			};
			_alerts.Alerts.insert(alert);
	
			return true;
		}
	});
	
	var createUser = exports.createUser = new ValidatedMethod({
		name: 'users.create',
		validate: new SimpleSchema({
			username: { type: String, min: 4 },
			password: { type: String },
			email: { type: String },
			profile: { type: Object, blackbox: true },
			roles: { type: [String], label: "roles" }
		}).validator(),
		run: function run(_ref4) {
			var username = _ref4.username,
			    password = _ref4.password,
			    email = _ref4.email,
			    profile = _ref4.profile,
			    roles = _ref4.roles;
	
			_roles.Roles.checkPermission(Meteor.userId(), "users.insert", { username: username, password: password, email: email, profile: profile, roles: roles });
	
			if (Meteor.isServer) {
				var userId = Accounts.createUser({ username: username, password: password, email: email, profile: profile });
				_roles.Roles.setUserRoles(userId, roles);
			}
		}
	});
	
	var getPartners = exports.getPartners = new ValidatedMethod({
		name: 'get.partners',
		validate: new SimpleSchema({}).validator(),
		run: function run() {
			_roles.Roles.checkPermission(Meteor.userId(), "users.insert", { username: username, password: password, email: email, profile: profile, roles: roles });
	
			console.log('TEST GET');
	
			if (Meteor.isServer) {
				return Meteor.users.find({ roles: { $in: ['partner'] }, 'profile.billType': 'groupe' });
			}
		}
	});
	
	// Get list of all method names on Lists
	var LISTS_METHODS = _lodash2.default.map([updatePassword, createUser, getPartners], 'name');
	
	if (Meteor.isServer) {
		// Only allow 5 list operations per connection per second
		DDPRateLimiter.addRule({
			name: function name(_name) {
				return _lodash2.default.includes(LISTS_METHODS, _name);
			},
	
	
			// Rate limit per connection ID
			connectionId: function connectionId() {
				return true;
			}
		}, 5, 1000);
	}

/***/ },

/***/ "./src/universal/collections/alerts/alerts.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AlertSchema = exports.Alerts = undefined;
	
	var _uniformsBootstrap = __webpack_require__("./node_modules/uniforms-bootstrap3/index.js");
	
	var _baseSchema = __webpack_require__("./src/universal/collections/baseSchema.js");
	
	var _customListField = __webpack_require__("./src/universal/components/fields/customListField.js");
	
	var _customListField2 = _interopRequireDefault(_customListField);
	
	var _datePickerField = __webpack_require__("./src/universal/components/fields/datePickerField.js");
	
	var _datePickerField2 = _interopRequireDefault(_datePickerField);
	
	var _dynamicListField = __webpack_require__("./src/universal/components/fields/dynamicListField.js");
	
	var _dynamicListField2 = _interopRequireDefault(_dynamicListField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var Mongo = Package.mongo.Mongo;
	var Alerts = exports.Alerts = new Mongo.Collection('alerts');
	exports.default = Alerts;
	
	
	Alerts.attachRoles('alerts');
	
	Alerts.label = "Alertes";
	
	var AlertSchema = exports.AlertSchema = new SimpleSchema([{
	    content: {
	        type: String,
	        label: "Contenu",
	        uniforms: {
	            component: _uniformsBootstrap.LongTextField
	        }
	    },
	    from: {
	        type: String,
	        label: "Date de début",
	        hide: true,
	        uniforms: {
	            component: _datePickerField2.default
	        }
	    },
	    to: {
	        type: String,
	        hide: true,
	        label: "Date de fin",
	        uniforms: {
	            component: _datePickerField2.default
	        }
	    },
	    ref: {
	        type: String,
	        label: "Référence",
	        optional: true,
	        hide: true,
	        uniforms: {
	            component: _uniformsBootstrap.HiddenField
	        }
	    },
	    to_type: {
	        type: [String],
	        label: "Visible par",
	        hide: true,
	        optional: true,
	        allowedValues: ["organizer", "pilot", "partner", "god"],
	        uniforms: {
	            component: _customListField2.default,
	            transform: function transform(option) {
	                switch (option) {
	                    case "organizer":
	                        return "Administrateur";
	                    case "pilot":
	                        return "Pilote";
	                    case "partner":
	                        return "Partenaire";
	                    case "god":
	                        return "Super-Administrateur";
	                    default:
	                        return "N/C";
	                }
	            }
	        }
	    },
	    to_users: {
	        type: [String],
	        label: "Visble pour les utilisateurs",
	        hide: true,
	        uniforms: {
	            component: _dynamicListField2.default,
	            options: Meteor.users,
	            subscription: "users",
	            filters: {}
	        }
	    },
	    type: {
	        type: String,
	        label: "Type",
	        allowedValues: ["Alerte", "Attention", "Information"],
	        defaultValue: "Alerte",
	        uniforms: {
	            component: _uniformsBootstrap.SelectField
	        }
	    }
	}, _baseSchema.BaseSchema]);
	
	Alerts.attachSchema(AlertSchema);

/***/ },

/***/ "./src/universal/components/fields/customListField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _filterDOMProps = __webpack_require__("./node_modules/uniforms/filterDOMProps.js");
	
	var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);
	
	var _joinName = __webpack_require__("./node_modules/uniforms/joinName.js");
	
	var _joinName2 = _interopRequireDefault(_joinName);
	
	var _ListItemField = __webpack_require__("./src/universal/components/fields/ListItemField.js");
	
	var _ListItemField2 = _interopRequireDefault(_ListItemField);
	
	var _ListAddField = __webpack_require__("./src/universal/components/fields/ListAddField.js");
	
	var _ListAddField2 = _interopRequireDefault(_ListAddField);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomListField = function CustomListField(_ref) {
	    var addIcon = _ref.addIcon,
	        children = _ref.children,
	        className = _ref.className,
	        error = _ref.error,
	        errorMessage = _ref.errorMessage,
	        initialCount = _ref.initialCount,
	        itemProps = _ref.itemProps,
	        label = _ref.label,
	        name = _ref.name,
	        removeIcon = _ref.removeIcon,
	        showInlineError = _ref.showInlineError,
	        value = _ref.value,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['addIcon', 'children', 'className', 'error', 'errorMessage', 'initialCount', 'itemProps', 'label', 'name', 'removeIcon', 'showInlineError', 'value']);
	    return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({
	            className: (0, _classnames2.default)('panel panel-default custom-list-field', { 'panel-danger': error }, className)
	        }, (0, _filterDOMProps2.default)(props)),
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-body' },
	            _react2.default.createElement(
	                _rubix.Col,
	                { sm: 12 },
	                label && _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('panel-heading', { 'has-error': error }) },
	                    _react2.default.createElement(
	                        _rubix.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'control-label' },
	                            label,
	                            '\xA0 : \xA0\xA0\xA0\xA0',
	                            _react2.default.createElement(_ListAddField2.default, { name: name + '.$', initialCount: initialCount, addIcon: addIcon })
	                        )
	                    ),
	                    !!(errorMessage && showInlineError) && _react2.default.createElement(
	                        'span',
	                        { className: 'help-block' },
	                        errorMessage
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null)
	                )
	            ),
	            _react2.default.createElement(
	                _rubix.Col,
	                { sm: 12 },
	                children ? value.map(function (item, index) {
	                    return _react.Children.map(children, function (child) {
	                        return _react2.default.cloneElement(child, {
	                            key: index,
	                            label: null,
	                            name: (0, _joinName2.default)(name, child.props.name && child.props.name.replace('$', index)),
	                            removeIcon: removeIcon
	                        });
	                    });
	                }) : value.map(function (item, index) {
	                    return _react2.default.createElement(_ListItemField2.default, (0, _extends3.default)({
	                        key: index,
	                        label: null,
	                        name: (0, _joinName2.default)(name, index),
	                        removeIcon: removeIcon
	                    }, itemProps));
	                })
	            )
	        )
	    );
	};
	
	exports.default = (0, _connectField2.default)(CustomListField, { includeInChain: false });

/***/ },

/***/ "./src/universal/components/fields/ListAddField.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connectField = __webpack_require__("./node_modules/uniforms/connectField.js");
	
	var _connectField2 = _interopRequireDefault(_connectField);
	
	var _filterDOMProps = __webpack_require__("./node_modules/uniforms/filterDOMProps.js");
	
	var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListAdd = function ListAdd(_ref) {
	    var addIcon = _ref.addIcon,
	        className = _ref.className,
	        disabled = _ref.disabled,
	        parent = _ref.parent,
	        value = _ref.value,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['addIcon', 'className', 'disabled', 'parent', 'value']);
	
	    var limitNotReached = !disabled && !(parent.maxCount <= parent.value.length);
	
	    return _react2.default.createElement(
	        'span',
	        (0, _extends3.default)({
	            onClick: function onClick() {
	                return limitNotReached && parent.onChange(parent.value.concat([value]));
	            }
	        }, (0, _filterDOMProps2.default)(props)),
	        addIcon
	    );
	};
	
	ListAdd.defaultProps = { addIcon: _react2.default.createElement(
	        _rubix.Button,
	        { bsStyle: 'success' },
	        'Ajouter'
	    ) };
	
	exports.default = (0, _connectField2.default)(ListAdd, { includeParent: true, initialValue: false });

/***/ },

/***/ "./src/universal/components/common/mgfForm.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends4 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__("./node_modules/babel-runtime/helpers/get.js");
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _uniformsBootstrap = __webpack_require__("./node_modules/uniforms-bootstrap3/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MgfForm = function MgfForm(parent) {
		var _class, _temp;
	
		return _temp = _class = function (_parent) {
			(0, _inherits3.default)(_class, _parent);
	
			function _class() {
				(0, _classCallCheck3.default)(this, _class);
	
				var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));
	
				_this.onSubmitSuccess = _this.onSubmitSuccess.bind(_this);
				_this.onSubmitFailure = _this.onSubmitFailure.bind(_this);
				return _this;
			}
	
			(0, _createClass3.default)(_class, [{
				key: 'getNativeFormProps',
				value: function getNativeFormProps() {
					var _get$call = (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'getNativeFormProps', this).call(this),
					    doSave = _get$call.doSave,
					    collection = _get$call.collection,
					    props = (0, _objectWithoutProperties3.default)(_get$call, ['doSave', 'collection']);
	
					return props;
				}
			}, {
				key: 'getModel',
				value: function getModel(mode) {
					if (mode === 'submit') {
						var doc = (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'getModel', this).call(this, 'submit');
						var keys = _lodash2.default.without(this.getChildContextSchema().getSubfields(), 'createdAt', 'updatedAt');
	
						var update = keys.filter(function (key) {
							return doc[key] !== undefined;
						});
						var remove = keys.filter(function (key) {
							return doc[key] === undefined;
						});
	
						var $set = update.reduce(function (acc, key) {
							return (0, _extends5.default)({}, acc, (0, _defineProperty3.default)({}, key, doc[key]));
						}, {});
						var $unset = remove.reduce(function (acc, key) {
							return (0, _extends5.default)({}, acc, (0, _defineProperty3.default)({}, key, ''));
						}, {});
	
						return { $set: $set, $unset: $unset };
					}
	
					return (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'getModel', this).call(this, mode);
				}
			}, {
				key: 'getSubmitField',
				value: function getSubmitField() {
					var text = this.props.model && this.props.model['_id'] ? "Editer" : "Créer";
	
					return function (props) {
						return _react2.default.createElement(_uniformsBootstrap.SubmitField, { value: text });
					};
				}
			}, {
				key: 'onSubmit',
				value: function onSubmit(event) {
					var _this2 = this;
	
					if (event) {
						event.preventDefault();
						event.stopPropagation();
					}
	
					return new _promise2.default(function (resolve) {
						/* validating form */
						_this2.setState({ validate: true }, function () {
							resolve(_this2.onValidate());
						});
					}).then(function (doc) {
						/* saving resource */
						return new _promise2.default(function (resolve, reject) {
							var doc = _this2.getModel('submit');
							if (_this2.props.collection && _this2.props.doSave) {
								if (_this2.props.model['_id']) {
									_this2.props.collection.update({ _id: _this2.props.model ? _this2.props.model['_id'] : null }, doc, function (err, nb) {
										err ? reject(err) : resolve(doc);
									});
								} else {
									var insert = doc.$set;
									_this2.props.collection.insert(insert, function (err, nb) {
										err ? reject(err) : resolve(doc);
									});
								}
							} else {
								return resolve(_this2.getModel('form'));
							}
						});
					}).then(function (doc) {
						/* call supplied handler */
						return _promise2.default.resolve(_this2.props.onSubmit && _this2.props.onSubmit(_this2.getModel('form')));
					}).then(this.onSubmitSuccess).catch(this.onSubmitFailure);
				}
			}, {
				key: 'onSubmitSuccess',
				value: function onSubmitSuccess(doc) {
					Messenger().post({
						message: (this.props.collection && this.props.collection.label ? this.props.collection.label : "La resource") + " a été " + (this.props.model && this.props.model['_id'] ? "modifié" : "ajouté") + " avec succès.",
						type: "success"
					});
	
					return this.props.onSubmitSuccess ? this.props.onSubmitSuccess(doc) : doc;
				}
			}, {
				key: 'onSubmitFailure',
				value: function onSubmitFailure(err) {
					console.error(err);
					if (err) Messenger().post({
						message: err,
						type: "error"
					});
	
					return this.props.onSubmitFailure ? this.props.onSubmitFailure(err) : err;
				}
			}]);
			return _class;
		}(parent), _class.MgfForm = MgfForm, _class.displayName = 'MgfForm' + parent.displayName, _class.defaultProps = (0, _extends5.default)({}, parent.defaultProps, {
	
			doSave: true
		}), _class.propTypes = (0, _extends5.default)({}, parent.propTypes, {
	
			doSave: _react.PropTypes.oneOfType([_react.PropTypes.bool]),
			collection: _react.PropTypes.oneOfType([_react.PropTypes.object])
		}), _temp;
	};
	
	// Now we have to inject our functionality. This one is a ModifierForm. Use any
	// form component you want.
	exports.default = MgfForm(_uniformsBootstrap.AutoForm);

/***/ },

/***/ "./src/universal/components/alerts/AlertAdd.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _alerts = __webpack_require__("./src/universal/collections/alerts/alerts.js");
	
	var _mgfForm = __webpack_require__("./src/universal/components/common/mgfForm.js");
	
	var _mgfForm2 = _interopRequireDefault(_mgfForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlerteAddPage = function (_React$Component) {
		(0, _inherits3.default)(AlerteAddPage, _React$Component);
	
		function AlerteAddPage(props) {
			(0, _classCallCheck3.default)(this, AlerteAddPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (AlerteAddPage.__proto__ || (0, _getPrototypeOf2.default)(AlerteAddPage)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(AlerteAddPage, [{
			key: 'handleSubmit',
			value: function handleSubmit(doc) {
				this.context.router.push('/alerts');
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/alerts' },
								'Alertes'
							)
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ href: '#', active: true },
							'Ajouter une alerte'
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Ajouter une alerte' },
						_react2.default.createElement(_mgfForm2.default, { schema: _alerts.AlertSchema, collection: _alerts.Alerts, onSubmit: this.handleSubmit.bind(this) })
					)
				);
			}
		}]);
		return AlerteAddPage;
	}(_react2.default.Component);
	
	exports.default = AlerteAddPage;
	
	
	AlerteAddPage.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/alerts/AlertEdit.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _alerts = __webpack_require__("./src/universal/collections/alerts/alerts.js");
	
	var _mgfForm = __webpack_require__("./src/universal/components/common/mgfForm.js");
	
	var _mgfForm2 = _interopRequireDefault(_mgfForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertEditPage = function (_React$Component) {
		(0, _inherits3.default)(AlertEditPage, _React$Component);
	
		function AlertEditPage(props) {
			(0, _classCallCheck3.default)(this, AlertEditPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (AlertEditPage.__proto__ || (0, _getPrototypeOf2.default)(AlertEditPage)).call(this, props));
	
			_this.state = {};
	
			if (_this.props.params.id) _this.place = _alerts.Alerts.findOne({ _id: _this.props.params.id });else _this.context.router.push('/alerts');
			return _this;
		}
	
		(0, _createClass3.default)(AlertEditPage, [{
			key: 'handleSubmit',
			value: function handleSubmit(doc) {
				this.context.router.push('/alerts');
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/alerts' },
								'Alertes'
							)
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ href: '#', active: true },
							'Modifier une alerte'
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Modifier une alerte' },
						_react2.default.createElement(_mgfForm2.default, { schema: _alerts.AlertSchema, collection: _alerts.Alerts, model: this.place, onSubmit: this.handleSubmit.bind(this) })
					)
				);
			}
		}]);
		return AlertEditPage;
	}(_react2.default.Component);
	
	exports.default = AlertEditPage;
	
	
	AlertEditPage.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/alerts/AlertList.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _alerts = __webpack_require__("./src/universal/collections/alerts/alerts.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _mgfTable = __webpack_require__("./src/universal/components/common/mgfTable.js");
	
	var _mgfTable2 = _interopRequireDefault(_mgfTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var AlertListPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["alerts"],
		alerts: _alerts.Alerts.find({}, { order: { createdAt: 1 } })
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(AlertListPage, _React$Component);
	
		function AlertListPage(props) {
			(0, _classCallCheck3.default)(this, AlertListPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (AlertListPage.__proto__ || (0, _getPrototypeOf2.default)(AlertListPage)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(AlertListPage, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							'Alertes'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ active: true },
							'Liste des alertes'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_roles.Roles.userHasPermission(Meteor.userId(), 'alerts.insert') && _react2.default.createElement(
								_reactRouter.Link,
								{ to: '/alerts/add' },
								_react2.default.createElement(
									_rubix.Button,
									{ bsStyle: 'success' },
									'Ajouter'
								)
							)
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Liste des alertes' },
						this.props.isReady && _react2.default.createElement(_mgfTable2.default, { fields: _alerts.AlertSchema._schema, list: this.props.alerts, type: 'alerts' })
					)
				);
			}
		}]);
		return AlertListPage;
	}(_react2.default.Component)) || _class);
	exports.default = AlertListPage;
	
	
	AlertListPage.propTypes = {
		places: _react2.default.PropTypes.array.isRequired
	};

/***/ },

/***/ "./src/universal/components/common/Reactive.mixin.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Reactive = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Tracker = Package.tracker.Tracker;
	var Reactive = exports.Reactive = function Reactive(annotations) {
	
		return function (ComposedComponent) {
			return function (_React$Component) {
				(0, _inherits3.default)(_class, _React$Component);
	
				function _class(props) {
					(0, _classCallCheck3.default)(this, _class);
	
					var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, props));
	
					_this.state = {};
					return _this;
				}
	
				(0, _createClass3.default)(_class, [{
					key: 'componentWillMount',
					value: function componentWillMount() {
						if (Meteor.isServer) return;
	
						this.setState({
							isReady: false
						});
	
						this._trackers = [];
						this._subscriptions = [];
	
						this.launch();
					}
				}, {
					key: 'launch',
					value: function launch() {
						var _this2 = this;
	
						var subscriptions = this.state.subscriptions || [];
	
						console.log("subscriptions : ", subscriptions);
						console.log("annotations : ", annotations);
	
						/*
	      * Launch subscriptions
	      */
						var subscriptionsAreReady = [];
						_lodash2.default.each(annotations.subscriptions, function (subscription) {
							Tracker.nonreactive(function () {
								subscriptionsAreReady.push(new _promise2.default(function (resolve, reject) {
									var subscriptionName = subscription;
									var options = {};
	
									if (_lodash2.default.isObject(subscription)) {
										console.log("subcription is object");
										subscriptionName = subscription.name;
										if (subscription.paginate) {
											options.page = subscriptions[subscriptionName] ? subscriptions[subscriptionName].page : 1;
										}
										if (subscription.param) {
											options[subscription.param] = _this2.props.params[subscription.param];
										}
	
										options.query = subscriptions[subscriptionName] ? subscriptions[subscriptionName].query : '';
									}
	
									console.log("will subsribe", subscriptionName);
									var subscribed = Meteor.subscribe(subscriptionName, options, {
										onStop: function onStop(error) {
											if (error) console.error(error);
										},
										onReady: function onReady() {
											resolve(true);
										}
									});
	
									_this2._subscriptions.push(subscribed);
									subscriptions[subscriptionName] = {
										more: function () {
											subscriptions[subscriptionName].page++;
											_this2.setState({ subscriptions: subscriptions });
											_this2.launch();
										}.bind(_this2),
										next: function () {
											subscriptions[subscriptionName].page++;
											_this2.setState({ subscriptions: subscriptions });
											_this2.unsubscribe();
											_this2.launch();
										}.bind(_this2),
										clear: function clear() {
											subscriptions[subscriptionName].query = false;
											subscriptions[subscriptionName].page = 1;
											_this2.setState({ subscriptions: subscriptions });
											_this2.unsubscribe();
											_this2.launch();
										},
										search: function (query) {
											subscriptions[subscriptionName].query = query;
											subscriptions[subscriptionName].page = 1;
											_this2.setState({ subscriptions: subscriptions });
											_this2.unsubscribe();
											_this2.launch();
										}.bind(_this2),
										query: subscriptions[subscriptionName] ? subscriptions[subscriptionName].query : '',
										page: subscriptions[subscriptionName] ? subscriptions[subscriptionName].page : 1
									};
								}));
							});
						});
	
						this.setState({ subscriptions: subscriptions });
	
						/*
	      * Set resources initial state
	      */
						_lodash2.default.each(annotations, function (value, key) {
							if (value && value.collection && value.reactive && value.matcher) {
								var modifier = {};
								modifier[key] = [];
								_this2.setState(modifier);
							}
						});
	
						/*
	      * Configure appropriate tracker for each resource when subscriptions are ready
	      */
						var ready = _promise2.default.all(subscriptionsAreReady).then(function () {
							!_this2.state.isReady && _this2.setState({
								isReady: true
							});
							_lodash2.default.each(annotations, function (value, key) {
								if (value && value.collection && value.reactive && value.matcher) {
									_this2._trackers.push(Tracker.autorun(function () {
										var modifier = {};
										modifier[key] = value.fetch();
										_this2.setState(modifier);
									}));
								}
							});
	
							return true;
						});
						this.setState({
							ready: ready
						});
					}
				}, {
					key: 'unsubscribe',
					value: function unsubscribe() {
						if (Meteor.isServer) return;
	
						_lodash2.default.each(this._subscriptions, function (subscription) {
							console.log('subscription stop !');
							subscription.stop();
						});
	
						_lodash2.default.each(this._trackers, function (tracker) {
							tracker.stop();
						});
					}
				}, {
					key: 'componentWillUnmount',
					value: function componentWillUnmount() {
						this.unsubscribe();
					}
				}, {
					key: 'render',
					value: function render() {
						return _react2.default.createElement(ComposedComponent, (0, _extends3.default)({}, this.props, this.state));
					}
				}]);
				return _class;
			}(_react2.default.Component);
		};
	};

/***/ },

/***/ "./src/universal/components/common/mgfTable.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _mgfRow = __webpack_require__("./src/universal/components/common/mgfRow.js");
	
	var _mgfRow2 = _interopRequireDefault(_mgfRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MgfTableComponent = function (_React$Component) {
		(0, _inherits3.default)(MgfTableComponent, _React$Component);
	
		function MgfTableComponent(props) {
			(0, _classCallCheck3.default)(this, MgfTableComponent);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (MgfTableComponent.__proto__ || (0, _getPrototypeOf2.default)(MgfTableComponent)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(MgfTableComponent, [{
			key: 'removeHiddenFields',
			value: function removeHiddenFields(fields) {
				return _lodash2.default.omit.apply(this, [fields].concat(_lodash2.default.reduce(fields, function (acc, field, key) {
					if (field.hide === true || key.match(/(.*)\.\$/)) acc.push(key);
					return acc;
				}, [])));
			}
		}, {
			key: 'renderHeader',
			value: function renderHeader() {
				return _lodash2.default.map(this.removeHiddenFields(this.props.fields), function (field, key) {
					return _react2.default.createElement(
						'th',
						{ key: key },
						field.label
					);
				});
			}
		}, {
			key: 'renderRows',
			value: function renderRows() {
				var _this2 = this;
	
				return this.props.list.map(function (item, index) {
					return _react2.default.createElement(_mgfRow2.default, { key: index, item: item, fields: _this2.removeHiddenFields(_this2.props.fields), type: _this2.props.type });
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_rubix.Table,
					{ responsive: true },
					_react2.default.createElement(
						'thead',
						null,
						_react2.default.createElement(
							'tr',
							null,
							this.renderHeader(),
							_react2.default.createElement(
								'th',
								{ key: 'actions' },
								'Actions'
							)
						)
					),
					_react2.default.createElement(
						'tbody',
						null,
						this.renderRows()
					)
				);
			}
		}]);
		return MgfTableComponent;
	}(_react2.default.Component);
	
	exports.default = MgfTableComponent;
	
	
	MgfTableComponent.propTypes = {
		list: _react2.default.PropTypes.array.isRequired,
		fields: _react2.default.PropTypes.object.isRequired,
		type: _react2.default.PropTypes.string.isRequired
	};

/***/ },

/***/ "./src/universal/components/common/mgfRow.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _reactRouter2 = _interopRequireDefault(_reactRouter);
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _flattenObject = __webpack_require__("./src/universal/helpers/flattenObject.js");
	
	var _flattenObject2 = _interopRequireDefault(_flattenObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var MgfRowComponent = function (_React$Component) {
		(0, _inherits3.default)(MgfRowComponent, _React$Component);
	
		function MgfRowComponent(props) {
			(0, _classCallCheck3.default)(this, MgfRowComponent);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (MgfRowComponent.__proto__ || (0, _getPrototypeOf2.default)(MgfRowComponent)).call(this, props));
	
			_this.state = {};
	
			return _this;
		}
	
		(0, _createClass3.default)(MgfRowComponent, [{
			key: 'delete',
			value: function _delete() {
				var collectionFile = __webpack_require__(3)("./" + this.props.type + '/' + this.props.type);
	
				if (collectionFile.default) collectionFile.default.remove({ _id: this.props.item._id });
			}
		}, {
			key: 'edit',
			value: function edit() {
				this.context.router.push('/' + this.props.type + '/' + this.props.item._id);
			}
		}, {
			key: 'view',
			value: function view() {
				this.context.router.push('/' + this.props.type + '/' + this.props.item._id + '/view');
			}
		}, {
			key: 'renderColumns',
			value: function renderColumns() {
				var flatten = (0, _flattenObject2.default)(this.props.item);
				return _.map(this.props.fields, function (field, key) {
					return _react2.default.createElement(
						'td',
						{ key: key },
						field.type === Date && _react2.default.createElement(
							_reactMoment2.default,
							{ format: 'DD/MM/YYYY' },
							flatten[key]
						),
						(field.type === String || field.type === Number) && field.uniforms && field.uniforms.transform && field.uniforms.transform(flatten[key]),
						(field.type === String || field.type === Number) && !(field.uniforms && field.uniforms.transform) && flatten[key]
					);
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'tr',
					null,
					this.renderColumns(),
					_react2.default.createElement(
						'td',
						null,
						_roles.Roles.userHasPermission(Meteor.userId(), this.props.type + '.view', Meteor.userId(), this.props.item) && _react2.default.createElement(
							_rubix.Button,
							{ bsStyle: 'primary', onClick: this.view.bind(this) },
							'Voir'
						),
						'\xA0\xA0',
						_roles.Roles.userHasPermission(Meteor.userId(), this.props.type + '.update', Meteor.userId(), this.props.item) && _react2.default.createElement(
							_rubix.Button,
							{ bsStyle: 'warning', onClick: this.edit.bind(this) },
							'Modifier'
						),
						'\xA0\xA0',
						_roles.Roles.userHasPermission(Meteor.userId(), this.props.type + '.update', Meteor.userId(), this.props.item) && _react2.default.createElement(
							_rubix.Button,
							{ bsStyle: 'danger', onClick: this.delete.bind(this) },
							'Supprimer'
						)
					)
				);
			}
		}]);
		return MgfRowComponent;
	}(_react2.default.Component);
	
	exports.default = MgfRowComponent;
	
	
	MgfRowComponent.propTypes = {
		item: _react2.default.PropTypes.object.isRequired,
		fields: _react2.default.PropTypes.object.isRequired,
		type: _react2.default.PropTypes.string.isRequired
	};
	
	MgfRowComponent.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./node_modules/react-moment/dist/index.js":
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__("./node_modules/react/react.js"), __webpack_require__("./node_modules/moment/moment.js"));
		else if(typeof define === 'function' && define.amd)
			define(["react", "moment"], factory);
		else if(typeof exports === 'object')
			exports["react-moment"] = factory(require("react"), require("moment"));
		else
			root["react-moment"] = factory(root["react"], root["moment"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _moment = __webpack_require__(2);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Moment = function (_React$Component) {
		    _inherits(Moment, _React$Component);
	
		    function Moment() {
		        var _ref;
	
		        var _temp, _this, _ret;
	
		        _classCallCheck(this, Moment);
	
		        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		            args[_key] = arguments[_key];
		        }
	
		        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Moment.__proto__ || Object.getPrototypeOf(Moment)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
		            content: ''
		        }, _temp), _possibleConstructorReturn(_this, _ret);
		    }
	
		    _createClass(Moment, [{
		        key: 'componentWillMount',
		        value: function componentWillMount() {
		            this.generateContent();
		        }
		    }, {
		        key: 'componentDidMount',
		        value: function componentDidMount() {
		            var _this2 = this;
	
		            this.interval = global.setInterval(function () {
		                _this2.generateContent();
		            }, 60000);
		        }
		    }, {
		        key: 'componentWillUnmount',
		        value: function componentWillUnmount() {
		            clearInterval(this.interval);
		        }
		    }, {
		        key: 'getDatetime',
		        value: function getDatetime() {
		            var _props = this.props,
		                date = _props.date,
		                parse = _props.parse,
		                utc = _props.utc,
		                unix = _props.unix;
	
		            date = date || this.props.children;
	
		            var datetime = null;
	
		            if (utc) {
		                datetime = _moment2.default.utc(date, parse);
		            } else if (unix) {
		                datetime = _moment2.default.unix(date);
		            } else {
		                datetime = (0, _moment2.default)(date, parse);
		            }
	
		            return datetime;
		        }
		    }, {
		        key: 'generateContent',
		        value: function generateContent() {
		            var _props2 = this.props,
		                format = _props2.format,
		                fromNow = _props2.fromNow,
		                from = _props2.from,
		                toNow = _props2.toNow,
		                to = _props2.to,
		                calendar = _props2.calendar,
		                ago = _props2.ago,
		                unix = _props2.unix;
	
	
		            var datetime = this.getDatetime();
	
		            var content = '';
		            if (format) {
		                content = datetime.format(format);
		            } else if (from) {
		                content = datetime.from(from, ago);
		            } else if (fromNow) {
		                content = datetime.fromNow(ago);
		            } else if (to) {
		                content = datetime.to(to, ago);
		            } else if (toNow) {
		                content = datetime.toNow(ago);
		            } else if (calendar) {
		                content = datetime.calendar();
		            } else {
		                content = datetime.toString();
		            }
	
		            this.setState({ content: content });
		        }
		    }, {
		        key: 'render',
		        value: function render() {
		            var _props3 = this.props,
		                date = _props3.date,
		                parse = _props3.parse,
		                format = _props3.format,
		                fromNow = _props3.fromNow,
		                from = _props3.from,
		                toNow = _props3.toNow,
		                to = _props3.to,
		                calendar = _props3.calendar,
		                ago = _props3.ago,
		                utc = _props3.utc,
		                unix = _props3.unix,
		                other = _objectWithoutProperties(_props3, ['date', 'parse', 'format', 'fromNow', 'from', 'toNow', 'to', 'calendar', 'ago', 'utc', 'unix']);
	
		            var datetime = this.getDatetime();
		            var content = this.state.content;
	
	
		            return _react2.default.createElement(
		                'time',
		                _extends({ dateTime: datetime.format() }, other),
		                content
		            );
		        }
		    }]);
	
		    return Moment;
		}(_react2.default.Component);
	
		exports.default = Moment;
	
	
		var dateTypes = [_react2.default.PropTypes.string, _react2.default.PropTypes.number, _react2.default.PropTypes.array, _react2.default.PropTypes.object];
	
		var parseTypes = [_react2.default.PropTypes.string, _react2.default.PropTypes.array];
	
		Moment.propTypes = {
		    date: _react2.default.PropTypes.oneOfType(dateTypes),
		    parse: _react2.default.PropTypes.oneOfType(parseTypes),
		    format: _react2.default.PropTypes.string,
		    ago: _react2.default.PropTypes.bool,
		    fromNow: _react2.default.PropTypes.bool,
		    from: _react2.default.PropTypes.oneOfType(dateTypes),
		    toNow: _react2.default.PropTypes.bool,
		    to: _react2.default.PropTypes.oneOfType(dateTypes),
		    calendar: _react2.default.PropTypes.bool,
		    unix: _react2.default.PropTypes.bool,
		    utc: _react2.default.PropTypes.bool
		};
	
		Moment.defaultProps = {
		    fromNow: false,
		    toNow: false,
		    calendar: false,
		    ago: false,
		    unix: false,
		    utc: false
		};
		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }
	/******/ ])
	});
	;

/***/ },

/***/ "./src/universal/helpers/flattenObject.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = function (obj) {
		return (0, _keys2.default)(obj).reduce(function (toReturn, k) {
	
			if (Object.prototype.toString.call(obj[k]) === '[object Date]') {
				toReturn[k] = obj[k].toString();
			} else if ((0, _typeof3.default)(obj[k]) === 'object' && obj[k]) {
				(0, _keys2.default)(obj[k]).forEach(function (k2) {
					toReturn[k + '.' + k2] = obj[k][k2];
				});
			} else {
				toReturn[k] = obj[k];
			}
	
			return toReturn;
		}, {});
	};
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },

/***/ 3:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./Counts": "./src/universal/collections/Counts.js",
		"./Counts.js": "./src/universal/collections/Counts.js",
		"./alerts/alerts": "./src/universal/collections/alerts/alerts.js",
		"./alerts/alerts.js": "./src/universal/collections/alerts/alerts.js",
		"./availabilities/methods": "./src/universal/collections/availabilities/methods.js",
		"./availabilities/methods.js": "./src/universal/collections/availabilities/methods.js",
		"./baseSchema": "./src/universal/collections/baseSchema.js",
		"./baseSchema.js": "./src/universal/collections/baseSchema.js",
		"./flights-type/flights-type": "./src/universal/collections/flights-type/flights-type.js",
		"./flights-type/flights-type.js": "./src/universal/collections/flights-type/flights-type.js",
		"./flights-type/options": "./src/universal/collections/flights-type/options.js",
		"./flights-type/options.js": "./src/universal/collections/flights-type/options.js",
		"./flights-type/places": "./src/universal/collections/flights-type/places.js",
		"./flights-type/places.js": "./src/universal/collections/flights-type/places.js",
		"./flights-type/prices": "./src/universal/collections/flights-type/prices.js",
		"./flights-type/prices.js": "./src/universal/collections/flights-type/prices.js",
		"./flights-type/promotions": "./src/universal/collections/flights-type/promotions.js",
		"./flights-type/promotions.js": "./src/universal/collections/flights-type/promotions.js",
		"./flights/flights": "./src/universal/collections/flights/flights.js",
		"./flights/flights.js": "./src/universal/collections/flights/flights.js",
		"./flights/methods": "./src/universal/collections/flights/methods.js",
		"./flights/methods.js": "./src/universal/collections/flights/methods.js",
		"./flights/places": "./src/universal/collections/flights/places.js",
		"./flights/places.js": "./src/universal/collections/flights/places.js",
		"./memos/memos": "./src/universal/collections/memos/memos.js",
		"./memos/memos.js": "./src/universal/collections/memos/memos.js",
		"./montgolfieres/montgolfieres": "./src/universal/collections/montgolfieres/montgolfieres.js",
		"./montgolfieres/montgolfieres.js": "./src/universal/collections/montgolfieres/montgolfieres.js",
		"./partners/group-bills": "./src/universal/collections/partners/group-bills.js",
		"./partners/group-bills-payments": "./src/universal/collections/partners/group-bills-payments.js",
		"./partners/group-bills-payments.js": "./src/universal/collections/partners/group-bills-payments.js",
		"./partners/group-bills.js": "./src/universal/collections/partners/group-bills.js",
		"./reservations/addresses": "./src/universal/collections/reservations/addresses.js",
		"./reservations/addresses.js": "./src/universal/collections/reservations/addresses.js",
		"./reservations/index.html": "./src/universal/collections/reservations/index.html",
		"./reservations/methods": "./src/universal/collections/reservations/methods.js",
		"./reservations/methods.js": "./src/universal/collections/reservations/methods.js",
		"./reservations/passengers": "./src/universal/collections/reservations/passengers.js",
		"./reservations/passengers.js": "./src/universal/collections/reservations/passengers.js",
		"./reservations/payments": "./src/universal/collections/reservations/payments.js",
		"./reservations/payments.js": "./src/universal/collections/reservations/payments.js",
		"./reservations/reservations": "./src/universal/collections/reservations/reservations.js",
		"./reservations/reservations.js": "./src/universal/collections/reservations/reservations.js",
		"./simpleSchema.config": "./src/universal/collections/simpleSchema.config.js",
		"./simpleSchema.config.js": "./src/universal/collections/simpleSchema.config.js",
		"./statistics/flights": "./src/universal/collections/statistics/flights.js",
		"./statistics/flights.js": "./src/universal/collections/statistics/flights.js",
		"./statistics/montgolfieres": "./src/universal/collections/statistics/montgolfieres.js",
		"./statistics/montgolfieres.js": "./src/universal/collections/statistics/montgolfieres.js",
		"./statistics/pilots": "./src/universal/collections/statistics/pilots.js",
		"./statistics/pilots.js": "./src/universal/collections/statistics/pilots.js",
		"./statistics/reservations": "./src/universal/collections/statistics/reservations.js",
		"./statistics/reservations.js": "./src/universal/collections/statistics/reservations.js",
		"./users/methods": "./src/universal/collections/users/methods.js",
		"./users/methods.js": "./src/universal/collections/users/methods.js",
		"./users/roles/god": "./src/universal/collections/users/roles/god.js",
		"./users/roles/god.js": "./src/universal/collections/users/roles/god.js",
		"./users/roles/organizer": "./src/universal/collections/users/roles/organizer.js",
		"./users/roles/organizer.js": "./src/universal/collections/users/roles/organizer.js",
		"./users/roles/partner": "./src/universal/collections/users/roles/partner.js",
		"./users/roles/partner.js": "./src/universal/collections/users/roles/partner.js",
		"./users/roles/pilot": "./src/universal/collections/users/roles/pilot.js",
		"./users/roles/pilot.js": "./src/universal/collections/users/roles/pilot.js",
		"./users/users": "./src/universal/collections/users/users.js",
		"./users/users.js": "./src/universal/collections/users/users.js"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 3;


/***/ },

/***/ "./src/universal/collections/Counts.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Meteor = Package.meteor.Meteor;
	var Mongo = Package.mongo.Mongo;
	
	
	var Counts = new Mongo.Collection('counts');
	
	exports.default = Counts;
	
	
	if (Meteor.isServer) {
	  Meteor.publish({
	    counts: function counts(_id) {
	      Counts.upsert({ _id: _id }, { $set: { value: 0 } });
	      this.ready();
	      var interval = Meteor.setInterval(function () {
	        Counts.update({ _id: _id }, { $inc: { value: 1 } });
	      }, 1000);
	      this.onStop(function () {
	        return Meteor.clearInterval(interval);
	      });
	      return Counts.find({ _id: _id });
	    }
	  });
	}

/***/ },

/***/ "./src/universal/collections/availabilities/methods.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.scheduleManyAvailabilities = exports.scheduleAvailability = undefined;
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DDPRateLimiter = Package['ddp-rate-limiter'].DDPRateLimiter;
	var Meteor = Package.meteor.Meteor;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var ValidatedMethod = Package['mdg:validated-method'].ValidatedMethod;
	var scheduleAvailability = exports.scheduleAvailability = new ValidatedMethod({
		name: 'availabilities.schedule',
		validate: new SimpleSchema({
			_id: { type: String },
			target: { type: String, allowedValues: ["user", "montgolfiere"] },
			startDate: { type: Date },
			endDate: { type: Date },
			isAvailable: { type: Boolean },
			place: { type: String, allowedValues: ["anjou", "nantes"] },
			period: { type: String, allowedValues: ["morning", "evening"] },
			override: { type: Boolean },
			online: { type: Number }
		}).validator(),
		run: function run(_ref) {
			var _id = _ref._id,
			    target = _ref.target,
			    startDate = _ref.startDate,
			    endDate = _ref.endDate,
			    isAvailable = _ref.isAvailable,
			    place = _ref.place,
			    period = _ref.period,
			    override = _ref.override,
			    online = _ref.online;
	
			var availabilities = [];
	
			console.log('####################################');
	
			switch (target) {
				case "user":
					_roles.Roles.checkPermission(Meteor.userId(), 'users.update', Meteor.userId(), Meteor.users.findOne(_id));
					var user = Meteor.users.findOne(_id);
					availabilities = user.profile.availabilities || [];
					break;
				case "montgolfiere":
					_roles.Roles.checkPermission(Meteor.userId(), 'montgolfieres.update', Meteor.userId(), Meteor.users.findOne(_id));
					var montgolfiere = _montgolfieres.Montgolfieres.findOne(_id);
					availabilities = montgolfiere.availabilities || [];
					break;
			}
	
			if ((0, _moment2.default)(startDate).isAfter(endDate)) throw new Meteor.Error('invalid_date', 'La date de début doit être inférieur à la date de fin.');
	
			var alreadyDefined = false;
			var appended = [];
			startDate = (0, _moment2.default)(startDate).startOf("day");
			endDate = (0, _moment2.default)(endDate).endOf("day");
	
			console.log('startDate', startDate);
			console.log('endDate', endDate);
	
			/*
	   * Compare each existing availabilities with the new one,
	   * and make required adjustements & erasments
	   */
			availabilities = _lodash2.default.map(availabilities, function (availability) {
				if (availability.period !== period) return availability;
	
				var contains = (0, _moment2.default)(availability.startDate).isSameOrBefore(startDate) && (0, _moment2.default)(availability.endDate).isSameOrAfter(endDate);
				var contained = (0, _moment2.default)(startDate).isSameOrBefore(availability.startDate) && (0, _moment2.default)(endDate).isSameOrAfter(availability.endDate);
				var overlapsAtStart = !contained && (0, _moment2.default)(availability.endDate).isBetween(startDate, endDate, null, '[]');
				var overlapsAtEnd = !contained && (0, _moment2.default)(availability.startDate).isBetween(startDate, endDate, null, '[]');
	
				/* In case it's contained or contains */
				if (contained && availability.isAvailable == isAvailable && availability.place == place || contained && override && (availability.isAvailable !== isAvailable || availability.place !== place)) return null; // erase existing availability
	
				if (contains && availability.isAvailable == isAvailable && availability.place == place || contains && !override && (availability.isAvailable !== isAvailable || availability.place !== place)) alreadyDefined = true; // erase new availability
	
				if (contained && !override && (availability.isAvailable !== isAvailable || availability.place !== place)) {
					console.log('preserve existing availability, by splitting the new in 2 sequences MODE NO OVERIDE');
					// preserve existing availability, by splitting the new in 2 sequences
					appended.push({
						startDate: (0, _moment2.default)(availability.endDate).add(1, 'days').startOf('day').toDate(),
						endDate: endDate.toDate ? endDate.toDate() : endDate,
						place: place,
						period: period,
						isAvailable: isAvailable,
						online: online
					});
					endDate = (0, _moment2.default)(availability.startDate).subtract(1, 'days').endOf('day').toDate();
	
					console.log('availability', availability);
					console.log('appended', appended);
				}
	
				if (contains && override && (availability.isAvailable !== isAvailable || availability.place !== place)) {
					console.log('preserve new availability, by splitting the current in 2 sequences MODE OVERIDE');
					// preserve new availability, by splitting the current in 2 sequences
					appended.push({
						startDate: (0, _moment2.default)(endDate).add(1, 'days').startOf('day').toDate(),
						endDate: availability.endDate,
						place: availability.place,
						period: availability.period,
						isAvailable: availability.isAvailable,
						online: availability.online
					});
	
					availability.endDate = (0, _moment2.default)(startDate).subtract(1, 'days').endOf('day').toDate();
	
					console.log('availability', availability);
					console.log('appended', appended);
				}
	
				/*
	    *  In case it overlaps,
	    *  we adjust end or start date,
	    *  on current or new availibity,
	    *  according to override setting
	    */
				if (overlapsAtStart && availability.isAvailable == isAvailable && availability.place == place || overlapsAtStart && override && (availability.isAvailable !== isAvailable || availability.place !== place)) availability.endDate = (0, _moment2.default)(startDate).subtract(1, 'days').endOf('day').toDate();
	
				if (overlapsAtStart && !override && (availability.isAvailable !== isAvailable || availability.place !== place)) startDate = (0, _moment2.default)(availability.endDate).add(1, 'days').startOf('day').toDate();
	
				if (overlapsAtEnd && availability.isAvailable == isAvailable && availability.place == place || overlapsAtEnd && override && (availability.isAvailable !== isAvailable || availability.place !== place)) availability.startDate = (0, _moment2.default)(endDate).add(1, 'days').startOf('day').toDate();
	
				if (overlapsAtEnd && !override && (availability.isAvailable !== isAvailable || availability.place !== place)) endDate = (0, _moment2.default)(availability.startDate).subtract(1, 'days').endOf('day').toDate();
	
				return availability;
			});
	
			console.log('Append new availability items if needed');
			/*
	   * Append new availability items if needed
	   */
	
			startDate = startDate.toDate ? startDate.toDate() : startDate;
			endDate = endDate.toDate ? endDate.toDate() : endDate;
			availabilities = _lodash2.default.compact(availabilities);
			if (!alreadyDefined && (0, _moment2.default)(startDate).isBefore(endDate)) availabilities.push({ startDate: startDate, endDate: endDate, isAvailable: isAvailable, place: place, period: period, online: online });
	
			console.log('final appended', appended);
			console.log('final availabilities', availabilities);
	
			availabilities = availabilities.concat(appended);
	
			switch (target) {
				case "user":
					Meteor.users.update(_id, {
						$set: {
							"profile.availabilities": availabilities
						}
					});
					break;
				case "montgolfiere":
					_montgolfieres.Montgolfieres.update(_id, {
						$set: {
							availabilities: availabilities
						}
					});
					break;
			}
	
			return true;
		}
	});
	
	var scheduleManyAvailabilities = exports.scheduleManyAvailabilities = new ValidatedMethod({
		name: 'availabilities.scheduleMany',
		validate: new SimpleSchema({
			groups: { type: [Object] },
			"groups.$.place": { type: String },
			"groups.$.period": { type: String },
			"groups.$.items": { type: [Object] },
			"groups.$.items.$.isAvailable": { type: Boolean },
			"groups.$.items.$.target": { type: String },
			"groups.$.items.$._id": { type: String },
			startDate: { type: Date },
			endDate: { type: Date },
			override: { type: Boolean },
			online: { type: Number }
		}).validator(),
		run: function run(_ref2) {
			var groups = _ref2.groups,
			    startDate = _ref2.startDate,
			    endDate = _ref2.endDate,
			    override = _ref2.override,
			    online = _ref2.online;
	
			if ((0, _moment2.default)(startDate).isAfter(endDate)) throw new Meteor.Error('invalid_date', 'La date de début doit être inférieur à la date de fin.');
	
			_lodash2.default.each(groups, function (_ref3) {
				var place = _ref3.place,
				    period = _ref3.period,
				    items = _ref3.items;
	
				_lodash2.default.each(items, function (_ref4) {
					var _id = _ref4._id,
					    target = _ref4.target,
					    isAvailable = _ref4.isAvailable;
	
					scheduleAvailability.call({
						_id: _id, target: target, startDate: startDate, endDate: endDate, isAvailable: isAvailable, place: place, period: period, override: override, online: online
					});
				});
			});
	
			return true;
		}
	});
	
	// Get list of all method names on Lists
	var LISTS_METHODS = _lodash2.default.map([scheduleAvailability, scheduleManyAvailabilities], 'name');
	
	if (Meteor.isServer) {
		// Only allow 5 list operations per connection per second
		DDPRateLimiter.addRule({
			name: function name(_name) {
				return _lodash2.default.includes(LISTS_METHODS, _name);
			},
	
	
			// Rate limit per connection ID
			connectionId: function connectionId() {
				return true;
			}
		}, 5, 1000);
	}

/***/ },

/***/ "./src/universal/collections/flights/methods.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.encloseFlight = exports.cancelFlight = exports.confirmFlight = exports.prepareFlight = undefined;
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _places = __webpack_require__("./src/universal/collections/flights/places.js");
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	var _smsManager = __webpack_require__("./src/universal/external_api/smsManager.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var ValidatedMethod = Package['mdg:validated-method'].ValidatedMethod;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var DDPRateLimiter = Package['ddp-rate-limiter'].DDPRateLimiter;
	var prepareFlight = exports.prepareFlight = new ValidatedMethod({
		name: 'flights.prepare',
		validate: new SimpleSchema({
			_id: { type: String },
			place: { type: String, label: "lieu", allowedValues: ["anjou", "nantes"] },
			reservationIds: { type: [String], label: "réservations", minCount: 1 },
			pilotId: { type: String, label: "pilote", optional: true },
			montgolfiereId: { type: String, label: "montgolfiere" },
			temp: { type: Number }
		}).validator(),
		run: function run(_ref) {
			var _id = _ref._id,
			    reservationIds = _ref.reservationIds,
			    place = _ref.place,
			    pilotId = _ref.pilotId,
			    montgolfiereId = _ref.montgolfiereId,
			    temp = _ref.temp;
	
			var flight = _flights.Flights.findOne(_id);
			var pilot = Meteor.users.findOne(pilotId);
			var montgolfiere = _montgolfieres.Montgolfieres.findOne(montgolfiereId);
			var reservations = _reservations.Reservations.find({ _id: { $in: reservationIds } }).fetch();
			var passengersCount = _lodash2.default.reduce(reservations, function (count, reservation) {
				return count + reservation.passengers.length;
			}, 0);
			var weightCount = _lodash2.default.reduce(reservations, function (count, reservation) {
				return count + reservation.totalWeight();
			}, 0) + (pilot && pilot.profile.weight ? pilot.profile.weight : 0);
			var maxWeight = temp ? montgolfiere.maxWeight["temp" + temp] : montgolfiere.defaultWeight;
	
			/*if (flight.status !== "preparing")
	  	throw new Meteor.Error('already_prepared',
	  								'Vous ne pouvez plus modifier les informations de ce vol');*/
	
			if (!reservations.length) throw new Meteor.Error('need_passengers', 'Il n\'y aucun passagers pour ce vol');
	
			if (passengersCount > montgolfiere.maxPassengers) throw new Meteor.Error('too_much_passengers', 'Il n\'y pas suffisament de place dans la montgolfiere');
	
			if (weightCount > maxWeight) throw new Meteor.Error('too_much_weight', 'La montgolfiere ne peut pas supporter une telle charge');
	
			if (_flights.Flights.findOne({ _id: { $ne: _id }, period: flight.period, date: flight.date, montgolfiereId: montgolfiereId, status: { $ne: 'cancelled' } })) throw new Meteor.Error('montgolfiere_already_used', 'La montgolfiere est déjà reservée pour un autre vol');
	
			if (!montgolfiere.allowedPilots.includes(pilotId)) throw new Meteor.Error('not_allowed', 'Vous ne pouvez pas piloter cette montgolfiere');
	
			if (pilotId !== Meteor.userId() && !_roles.Roles.userHasPermission(Meteor.userId(), 'flights.organize')) throw new Meteor.Error('not_allowed', 'Vous ne pouvez pas preparer un vol pour un autre pilote');
	
			if (_flights.Flights.findOne({ _id: { $ne: _id }, period: flight.period, date: flight.date, reservationIds: { $in: reservationIds } })) throw new Meteor.Error('reservations_already_used', 'Les réservations choisies sont déjà programmés sur un autre vol');
	
			_flights.Flights.update(_id, {
				$set: {
					temp: temp,
					place: place,
					reservationIds: reservationIds,
					pilotId: pilotId,
					montgolfiereId: montgolfiereId,
					validToFlight: true
				}
			});
		}
	});
	
	var confirmFlight = exports.confirmFlight = new ValidatedMethod({
		name: 'flights.confirm',
		validate: new SimpleSchema({
			_id: { type: String },
			temp: { type: Number },
			placeId: { type: String },
			meetingDate: { type: Date }
		}).validator(),
		run: function run(_ref2) {
			var _id = _ref2._id,
			    temp = _ref2.temp,
			    placeId = _ref2.placeId,
			    meetingDate = _ref2.meetingDate;
	
			var flight = _flights.Flights.findOne(_id);
			var pilot = Meteor.users.findOne(flight.pilotId);
	
			if (!flight.validToFlight) throw new Meteor.Error('not_valid', 'Veuillez renseigner correctement les informations de ce vol avant le valider.');
	
			var availableTotalWeight = flight.getMontgolfiere().maxWeight["temp" + temp];
			var scheduledPassengersWeight = _lodash2.default.reduce(flight.getReservations(), function (weight, reservation) {
				return weight + reservation.totalWeight();
			}, 0) + (pilot && pilot.profile.weight ? pilot.profile.weight : 0);
			if (scheduledPassengersWeight > availableTotalWeight) throw new Meteor.Error('too_much_weight', 'La montgolfiere ne peut pas supporter une telle charge à cette température');
	
			if (Meteor.userId() !== flight.pilotId) throw new Meteor.Error('not_allowed', 'Vous devez être le pilote de ce vol pour pouvoir le préparer');
	
			_flights.Flights.update(_id, {
				$set: {
					temp: temp,
					placeId: placeId,
					meetingDate: meetingDate,
					status: "prepared"
				}
			});
	
			var userId = Meteor.userId();
			_lodash2.default.each(flight.getReservations(), function (reservation) {
				// History :
				var historyItem = {
					type: "confirmed",
					date: new Date(),
					scheduledAt: flight.date,
					userId: userId
				};
	
				_reservations.Reservations.update(reservation._id, {
					$push: {
						history: historyItem
					}
				});
			});
	
			if (flight.status == "preparing" && Meteor.isServer) {
				_smsManager.SmsManager.notifyProgrammation(flight.getReservations(), meetingDate, flight.getPilote(), _places.Places.findOne(placeId));
			}
		}
	});
	
	var cancelFlight = exports.cancelFlight = new ValidatedMethod({
		name: 'flights.cancel',
		validate: new SimpleSchema({
			_id: { type: String },
			reason: { type: String }
		}).validator(),
		run: function run(_ref3) {
			var _id = _ref3._id,
			    reason = _ref3.reason;
	
			var flight = _flights.Flights.findOne(_id);
			var pilot = Meteor.users.findOne(flight.pilotId);
	
			if (Meteor.userId() !== flight.pilotId) throw new Meteor.Error('not_allowed', 'Vous devez être le pilote de ce vol pour pouvoir l\'annuler');
	
			_flights.Flights.update(_id, {
				$set: {
					status: "cancelled"
				}
			});
	
			var userId = Meteor.userId();
			_lodash2.default.each(flight.getReservations(), function (reservation) {
				var historyItem = {
					type: "cancelled",
					date: new Date(),
					scheduledAt: flight.date,
					userId: userId
				};
	
				_reservations.Reservations.update(reservation._id, {
					$push: {
						history: historyItem
					},
					$set: {
						scheduledAt: null
					}
				});
			});
	
			if (Meteor.isServer) _smsManager.SmsManager.cancelProgrammation(flight.getReservations(), flight.date, reason, pilot);
		}
	});
	
	var encloseFlight = exports.encloseFlight = new ValidatedMethod({
		name: 'flights.enclose',
		validate: new SimpleSchema({
			_id: { type: String },
			takeOffDate: { type: Date },
			landingDate: { type: Date },
			takeOffPlace: { type: String },
			landingPlace: { type: String },
			montgolfiereId: { type: String },
			pilotId: { type: String }
		}).validator(),
		run: function run(_ref4) {
			var _id = _ref4._id,
			    takeOffDate = _ref4.takeOffDate,
			    landingDate = _ref4.landingDate,
			    takeOffPlace = _ref4.takeOffPlace,
			    landingPlace = _ref4.landingPlace,
			    montgolfiereId = _ref4.montgolfiereId,
			    pilotId = _ref4.pilotId;
	
			var flight = _flights.Flights.findOne(_id);
	
			_roles.Roles.checkPermission(Meteor.userId(), "flights.enclose", Meteor.userId(), flight);
	
			if ((0, _moment2.default)(takeOffDate).isAfter(landingDate)) throw new Meteor.Error('wrong_time', "L'heure d'atterissage doit être après l'heure de décollage");
	
			console.log('montgolfiereId', montgolfiereId);
			console.log('pilotId', pilotId);
	
			_lodash2.default.each(flight.getReservations(), function (reservation) {
				reservation.consume();
			});
	
			var userId = Meteor.userId();
			_lodash2.default.each(flight.getReservations(), function (reservation) {
				var historyItem = {
					type: "consumed",
					date: new Date(),
					scheduledAt: flight.date,
					userId: userId
				};
	
				_reservations.Reservations.update(reservation._id, {
					$push: {
						history: historyItem
					}
				});
			});
	
			_flights.Flights.update(_id, {
				$set: {
					status: "validated",
					landingDate: landingDate,
					takeOffDate: takeOffDate,
					landingPlace: landingPlace,
					takeOffPlace: takeOffPlace,
					montgolfiereId: montgolfiereId,
					pilotId: pilotId
				}
			});
		}
	});
	
	// Get list of all method names on Lists
	var LISTS_METHODS = _lodash2.default.map([prepareFlight, confirmFlight, cancelFlight, encloseFlight], 'name');
	
	if (Meteor.isServer) {
		// Only allow 5 list operations per connection per second
		DDPRateLimiter.addRule({
			name: function name(_name) {
				return _lodash2.default.includes(LISTS_METHODS, _name);
			},
	
	
			// Rate limit per connection ID
			connectionId: function connectionId() {
				return true;
			}
		}, 5, 1000);
	}

/***/ },

/***/ "./src/universal/external_api/smsManager.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SmsManager = undefined;
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var SmsManager = exports.SmsManager = function () {
		function SmsManager() {
			(0, _classCallCheck3.default)(this, SmsManager);
		}
	
		(0, _createClass3.default)(SmsManager, null, [{
			key: 'notifyProgrammation',
			value: function notifyProgrammation(reservations, date, pilote, place) {
				var alreadyNotify = [];
				_lodash2.default.each(reservations, function (reservation) {
	
					/*let message = 'Bonjour. \n\nVotre réservation' + (reservation.id_billet ? ' N°' + reservation.id_billet : ' ') + ' a été programmée le ' + moment(date).format('DD/MM/YYYY à HH:mm') + ' avec le pilote ' + pilote.profile.firstName + '\n\nLe lieu de rendez-vous est : ' + place.name;
	    	if (place.precision)
	    	message += '\n\nPrécision sur le lieu de rendez-vous : ' + place.precision;
	    	message += '\n\nVoir sur Google Maps : https://www.google.fr/maps/search/' + place.name.replace(' ', '+');
	    message += '\n\nNuméro du pilote : ' + pilote.profile.phone;*/
	
					var message = (reservation.id_billet ? ' Billet N°' + reservation.id_billet : ' ') + ' fixé le ' + (0, _moment2.default)(date).format('DD/MM/YYYY à HH:mm') + ' à ' + place.name;
					message += '\nInfo pilote :' + pilote.profile.firstName + ' / ' + pilote.profile.phone;
	
					_reservations.Reservations.update(reservation._id, { "$set": { pendingSMS: true } });
					reservation.passengers = reservation.getPassengers();
					_lodash2.default.each(reservation.passengers, function (passenger) {
						if (passenger.phone && !_lodash2.default.includes(alreadyNotify, passenger.phone)) {
	
							//suppresion des espaces et des points.
							var phone = passenger.phone.slice(1);
							phone = phone.replace(' ', '');
							phone = phone.replace('.', '');
							phone = '33' + phone;
	
							if (phone[2] == '6' || phone[2] == '7') {
								Meteor.call('send.sms', {
									'to': phone,
									'message': message,
									'refID': reservation._id
								});
							}
	
							alreadyNotify.push(passenger.phone);
						}
					});
				});
			}
		}, {
			key: 'cancelProgrammation',
			value: function cancelProgrammation(reservations, date, cause, pilote) {
				var alreadyNotify = [];
	
				if (!cause) {
					return;
				}
	
				_lodash2.default.each(reservations, function (reservation) {
	
					var message = 'Bonjour,\n\nVotre r\xE9servation ' + reservation.id_billet + ' a \xE9t\xE9 programm\xE9 le ' + (0, _moment2.default)(date).format('DD/MM/YYYY') + '.\n\nNous sommes d\xE9sol\xE9s de vous annoncer que celui-ci est annul\xE9 car : ' + cause + '.\n\nVous pouvez \xE0 tout moment reprogrammer un vol sur notre site internet \xE0 l\'adresse suivante http://monvol.montgolfieres.fr\n\nNum\xE9ro de billet : ' + reservation.id_billet + '\nMot de passe : ' + (0, _moment2.default)(reservation.createdAt).format('X').slice(-4) + '\n\nCordialement, votre pilote ' + pilote.displayName() + '.';
	
					_reservations.Reservations.update(reservation._id, { "$set": { pendingSMS: true } });
					reservation.passengers = reservation.getPassengers();
					_lodash2.default.each(reservation.passengers, function (passenger) {
						if (passenger.phone && !_lodash2.default.includes(alreadyNotify, passenger.phone)) {
	
							//suppresion des espaces et des points.
							var phone = passenger.phone.slice(1);
							phone = phone.replace(' ', '');
							phone = phone.replace('.', '');
							phone = '33' + phone;
	
							if (phone[2] == '6' || phone[2] == '7') {
								Meteor.call('send.sms', {
									'to': phone,
									'message': message,
									'refID': reservation._id
								});
							}
	
							alreadyNotify.push(passenger.phone);
						}
					});
				});
			}
		}]);
		return SmsManager;
	}();

/***/ },

/***/ "./src/universal/collections/partners/group-bills.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.GroupBill = exports.GroupBills = undefined;
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	var _groupBillsPayments = __webpack_require__("./src/universal/collections/partners/group-bills-payments.js");
	
	var _payments = __webpack_require__("./src/universal/collections/reservations/payments.js");
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var Mongo = Package.mongo.Mongo;
	var HTTP = Package.http.HTTP;
	var Email = Package.email.Email;
	var GroupBills = exports.GroupBills = new Mongo.Collection('group_bills');
	
	GroupBills.allow({
		insert: function insert() {
			return true;
		},
		update: function update() {
			return true;
		},
		remove: function remove() {
			return true;
		}
	});
	
	var GroupBill = exports.GroupBill = new SimpleSchema({
		id_facture: {
			type: String,
			label: "N° Facture",
			optional: true
		},
		reservations: {
			type: [String],
			label: "reservations"
		},
		partnerId: {
			type: String,
			label: "Partenaire cible"
		},
		month: {
			type: String,
			label: "Partenaire cible",
			optional: true
		},
		price: {
			type: String,
			label: "prix",
			optional: true
		},
		solde: {
			type: String,
			label: "Solde restant",
			optional: true
		},
		createdAt: {
			type: Date,
			label: "Date de création"
		},
		editedAt: {
			type: Date,
			label: "Dernière modification",
			autoValue: function autoValue() {
				return new Date();
			}
		}
	});
	
	GroupBills.attachSchema(GroupBill);
	
	// Dbs methods :
	
	Meteor.methods({
		'groupBills.insert': function groupBillsInsert(data) {
	
			console.log('month bill', data.month);
	
			var startDate = (0, _moment2.default)().startOf('year').toDate();
			var endDate = (0, _moment2.default)().endOf('year').toDate();
	
			console.log(startDate);
			console.log(endDate);
	
			var reservations = _reservations.Reservations.find({ userId: data.partnerId, groupBill: null, createdAt: { $gte: startDate, $lte: endDate } }).fetch();
			var reservationsIds = [];
	
			if (!reservations.length > 0) {
				console.log('Rien a facturer !');
				return false;
			}
	
			console.log(reservations.length + ' reservation(s) a facturer !');
	
			var totalPrice = 0;
	
			_lodash2.default.each(reservations, function (reservation) {
				_reservations.Reservations.update(reservation._id, { $set: { groupBill: true, state: 5 } });
				reservationsIds.push(reservation._id);
				totalPrice += reservation.getPrice();
			});
	
			var d = new Date();
			var total = parseInt(GroupBills.find({ id_facture: { $regex: ".*" + d.getFullYear().toString().slice(-2) + "-.*" } }).fetch().length) + 1;
	
			var numerotation = '';
			for (var i = 0; i < 4 - total.toString().length; i++) {
				numerotation += '0';
			}
	
			var groupBillId = GroupBills.insert({
				'id_facture': 'G-' + d.getFullYear().toString().slice(-2) + '-' + numerotation + total,
				'reservations': reservationsIds,
				'partnerId': data.partnerId,
				'createdAt': new Date(),
				'month': data.month,
				'price': totalPrice,
				'solde': totalPrice
			}, function (err, _id) {
	
				console.log('creation du paiement ...', _id);
				var bill = GroupBills.findOne(_id);
				// création du paiement indépendant :
				_lodash2.default.each(reservations, function (reservation) {
					var payment = {
						'type': 'Facture groupée',
						'montant': reservation.getPrice(),
						'informations': 'Facture partenaire n°' + bill.id_facture,
						'reservation': reservation._id
					};
	
					_payments.Payments.insert(payment);
					//data.groupBill.month = moment(data.groupBill.month).format('MMM YYYY');
				});
	
				var data = {
					'groupBill': bill,
					'reservations': bill.getReservations(),
					'partner': bill.getPartner()
				};
	
				HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=groupFacture', {
					data: data
				}, function (error, result) {
					result = JSON.parse(result.content);
	
					console.log('PDF créé !');
					var invoice = "https://montgolfieres-pdf.amaia.at/" + result.id + ".pdf";
	
					Email.send({
						to: 'facture@montgolfieres.fr',
						from: 'anjou@montgolfieres.fr',
						subject: 'Facture partenaire',
						html: 'Télécharger : ' + invoice
					});
				});
			});
		}
	});
	
	GroupBills.helpers({
		getPartner: function getPartner() {
			// Meteor.subscribe('users');
			return Meteor.users.findOne(this.partnerId);
		},
		getReservations: function getReservations() {
			var reservations = [];
	
			_lodash2.default.each(this.reservations, function (id) {
				var reservation = _reservations.Reservations.findOne(id);
				if (reservation) {
					reservation.flight = reservation.getFlightType();
					reservation.price = reservation.getPrice();
					reservations.push(reservation);
				}
			});
	
			return reservations;
		},
		getSolde: function getSolde() {
			var _this = this;
	
			var payments = _groupBillsPayments.GroupBillsPayments.find({ bill: this._id }).fetch();
			var solde = 0;
	
			_lodash2.default.each(this.getReservations(), function (reservation) {
				solde += reservation.getPrice();
	
				if (_this.price != solde) {
					GroupBills.update(_this._id, { '$set': { price: solde } });
				}
			});
	
			_lodash2.default.map(payments, function (payment) {
				solde -= payment.montant;
			});
	
			if (solde != this.solde) {
				GroupBills.update(this._id, { '$set': { solde: solde } });
			}
	
			return solde;
		}
	});

/***/ },

/***/ "./src/universal/collections/partners/group-bills-payments.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.GroupBillsPayment = exports.GroupBillsPayments = undefined;
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _baseSchema = __webpack_require__("./src/universal/collections/baseSchema.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Mongo = Package.mongo.Mongo;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var GroupBillsPayments = exports.GroupBillsPayments = new Mongo.Collection('groupbillspayments');
	
	GroupBillsPayments.attachRoles('groupbillspayments');
	
	var GroupBillsPayment = exports.GroupBillsPayment = new SimpleSchema([{
		type: {
			type: String,
			label: "Type"
		},
		montant: {
			type: Number,
			label: "Montant"
		},
		bill: {
			type: String,
			label: "Identifiant de la facture"
		},
		informations: {
			type: String,
			label: "Informations",
			optional: true
		}
	}, _baseSchema.BaseSchema]);
	
	GroupBillsPayments.attachSchema(GroupBillsPayment);
	
	// Dbs methods :
	
	Meteor.methods({
		'groupbills.payments.insert': function groupbillsPaymentsInsert(attributes) {
			console.log('attribues', attributes);
			GroupBillsPayments.insert(attributes);
		},
		'groupbills.payments.remove': function groupbillsPaymentsRemove(_id) {
			GroupBillsPayments.remove(_id);
		}
	});

/***/ },

/***/ "./src/universal/collections/reservations/index.html":
/***/ function(module, exports) {



/***/ },

/***/ "./src/universal/collections/statistics/flights.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.flightsStatistics = undefined;
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var ValidatedMethod = Package['mdg:validated-method'].ValidatedMethod;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var DDPRateLimiter = Package['ddp-rate-limiter'].DDPRateLimiter;
	var flightsStatistics = exports.flightsStatistics = new ValidatedMethod({
	  name: 'flights.statistics',
	  validate: new SimpleSchema({
	    from: { type: String },
	    to: { type: String },
	    affichage: { type: String }
	  }).validator(),
	  run: function run(_ref) {
	    var from = _ref.from,
	        to = _ref.to,
	        affichage = _ref.affichage;
	
	
	    var startOf = affichage.slice(0, -1);
	    var dataAngers = [];
	    var dataNantes = [];
	    var dataAll = [];
	
	    for (var i = 0; i <= (0, _moment2.default)(to).diff((0, _moment2.default)(from), affichage); i++) {
	
	      var startDate = (0, _moment2.default)(from).startOf(startOf).add('1', 'hours').add(i, affichage).toDate();
	      var endDate = (0, _moment2.default)(from).endOf(startOf).add(i, affichage).toDate();
	
	      if (i == 0) {
	        startDate = (0, _moment2.default)(from).toDate();
	      }
	
	      if (i == (0, _moment2.default)(to).diff((0, _moment2.default)(from), affichage)) {
	        var _endDate = (0, _moment2.default)(to).toDate();
	      }
	
	      dataAll.push(_flights.Flights.find({ date: { $gte: startDate, $lte: endDate }, status: "validated" }).fetch().length);
	      dataAngers.push(_flights.Flights.find({ date: { $gte: startDate, $lte: endDate }, place: "anjou", status: "validated" }).fetch().length);
	      dataNantes.push(_flights.Flights.find({ date: { $gte: startDate, $lte: endDate }, place: "nantes", status: "validated" }).fetch().length);
	    }
	
	    return [dataAll, dataAngers, dataNantes];
	  }
	});
	
	// Get list of all method names on Lists
	var LISTS_METHODS = _lodash2.default.map([flightsStatistics], 'name');
	
	if (Meteor.isServer) {
	  // Only allow 5 list operations per connection per second
	  DDPRateLimiter.addRule({
	    name: function name(_name) {
	      return _lodash2.default.includes(LISTS_METHODS, _name);
	    },
	
	
	    // Rate limit per connection ID
	    connectionId: function connectionId() {
	      return true;
	    }
	  }, 5, 1000);
	}

/***/ },

/***/ "./src/universal/collections/statistics/montgolfieres.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.montgolfieresHoursStatistics = exports.montgolfieresFlightsStatistics = undefined;
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var ValidatedMethod = Package['mdg:validated-method'].ValidatedMethod;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var DDPRateLimiter = Package['ddp-rate-limiter'].DDPRateLimiter;
	var montgolfieresFlightsStatistics = exports.montgolfieresFlightsStatistics = new ValidatedMethod({
		name: 'montgolfieres.statistics',
		validate: new SimpleSchema({
			from: { type: String },
			to: { type: String },
			affichage: { type: String }
		}).validator(),
		run: function run(_ref) {
			var from = _ref.from,
			    to = _ref.to,
			    affichage = _ref.affichage;
	
	
			var datas = [];
			var montgolfieres = _montgolfieres.Montgolfieres.find().fetch();
	
			_lodash2.default.each(montgolfieres, function (montgolfiere) {
				var color = Math.floor(Math.random() * 256) + ',' + Math.floor(Math.random() * 256) + ',' + Math.floor(Math.random() * 256);
	
				var startOf = affichage.slice(0, -1);
				var data = [];
	
				for (var i = 0; i <= (0, _moment2.default)(to).diff((0, _moment2.default)(from), affichage); i++) {
	
					var startDate = (0, _moment2.default)(from).startOf(startOf).add('1', 'hours').add(i, affichage).toDate();
					var endDate = (0, _moment2.default)(from).endOf(startOf).add(i, affichage).toDate();
	
					if (i == 0) {
						startDate = (0, _moment2.default)(from).toDate();
					}
	
					if (i == (0, _moment2.default)(to).diff((0, _moment2.default)(from), affichage)) {
						var _endDate = (0, _moment2.default)(to).toDate();
					}
	
					data.push(_flights.Flights.find({ date: { $gte: startDate, $lte: endDate }, status: "validated", montgolfiereId: montgolfiere._id }).fetch().length);
				}
	
				datas.push([montgolfiere.name, data, color]);
			});
	
			return datas;
		}
	});
	
	var montgolfieresHoursStatistics = exports.montgolfieresHoursStatistics = new ValidatedMethod({
		name: 'montgolfieres.hours.statistics',
		validate: new SimpleSchema({
			from: { type: String },
			to: { type: String },
			affichage: { type: String }
		}).validator(),
		run: function run(_ref2) {
			var from = _ref2.from,
			    to = _ref2.to,
			    affichage = _ref2.affichage;
	
	
			var datas = [];
			var montgolfieres = _montgolfieres.Montgolfieres.find().fetch();
	
			_lodash2.default.each(montgolfieres, function (montgolfiere) {
				var color = Math.floor(Math.random() * 256) + ',' + Math.floor(Math.random() * 256) + ',' + Math.floor(Math.random() * 256);
	
				var startOf = affichage.slice(0, -1);
				var data = [];
	
				for (var i = 0; i <= (0, _moment2.default)(to).diff((0, _moment2.default)(from), affichage); i++) {
	
					var startDate = (0, _moment2.default)(from).startOf(startOf).add('1', 'hours').add(i, affichage).toDate();
					var endDate = (0, _moment2.default)(from).endOf(startOf).add(i, affichage).toDate();
	
					if (i == 0) {
						startDate = (0, _moment2.default)(from).toDate();
					}
	
					if (i == (0, _moment2.default)(to).diff((0, _moment2.default)(from), affichage)) {
						var _endDate2 = (0, _moment2.default)(to).toDate();
					}
	
					var hours = 0;
					_lodash2.default.each(_flights.Flights.find({ date: { $gte: startDate, $lte: endDate }, status: "validated", montgolfiereId: montgolfiere._id }).fetch(), function (flight) {
						hours += flight.time;
					});
	
					hours = Math.round(hours / 60 * 10) / 10;
	
					data.push(hours);
				}
	
				datas.push([montgolfiere.name, data, color]);
			});
	
			return datas;
		}
	});
	
	// Get list of all method names on Lists
	var LISTS_METHODS = _lodash2.default.map([montgolfieresFlightsStatistics], 'name');
	
	if (Meteor.isServer) {
		// Only allow 5 list operations per connection per second
		DDPRateLimiter.addRule({
			name: function name(_name) {
				return _lodash2.default.includes(LISTS_METHODS, _name);
			},
	
	
			// Rate limit per connection ID
			connectionId: function connectionId() {
				return true;
			}
		}, 5, 1000);
	}

/***/ },

/***/ "./src/universal/collections/statistics/pilots.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.pilotsHoursStatistics = exports.pilotsFlightsStatistics = undefined;
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _users = __webpack_require__("./src/universal/collections/users/users.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var ValidatedMethod = Package['mdg:validated-method'].ValidatedMethod;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var DDPRateLimiter = Package['ddp-rate-limiter'].DDPRateLimiter;
	var pilotsFlightsStatistics = exports.pilotsFlightsStatistics = new ValidatedMethod({
		name: 'pilots.flights.statistics',
		validate: new SimpleSchema({
			from: { type: String },
			to: { type: String },
			affichage: { type: String }
		}).validator(),
		run: function run(_ref) {
			var from = _ref.from,
			    to = _ref.to,
			    affichage = _ref.affichage;
	
	
			var datas = [];
			var pilots = Meteor.users.find({ roles: { $in: ['pilot'] } }).fetch();
	
			_lodash2.default.each(pilots, function (pilot) {
				var color = Math.floor(Math.random() * 256) + ',' + Math.floor(Math.random() * 256) + ',' + Math.floor(Math.random() * 256);
	
				var startOf = affichage.slice(0, -1);
				var data = [];
	
				for (var i = 0; i <= (0, _moment2.default)(to).diff((0, _moment2.default)(from), affichage); i++) {
	
					var startDate = (0, _moment2.default)(from).startOf(startOf).add('1', 'hours').add(i, affichage).toDate();
					var endDate = (0, _moment2.default)(from).endOf(startOf).add(i, affichage).toDate();
	
					if (i == 0) {
						startDate = (0, _moment2.default)(from).toDate();
					}
	
					if (i == (0, _moment2.default)(to).diff((0, _moment2.default)(from), affichage)) {
						var _endDate = (0, _moment2.default)(to).toDate();
					}
	
					data.push(_flights.Flights.find({ date: { $gte: startDate, $lte: endDate }, status: "validated", pilotId: pilot._id }).fetch().length);
				}
	
				datas.push([pilot.profile.firstName + ' ' + pilot.profile.lastName, data, color]);
			});
	
			return datas;
		}
	});
	
	var pilotsHoursStatistics = exports.pilotsHoursStatistics = new ValidatedMethod({
		name: 'pilots.hours.statistics',
		validate: new SimpleSchema({
			from: { type: String },
			to: { type: String },
			affichage: { type: String }
		}).validator(),
		run: function run(_ref2) {
			var from = _ref2.from,
			    to = _ref2.to,
			    affichage = _ref2.affichage;
	
	
			var datas = [];
			var pilots = Meteor.users.find({ roles: { $in: ['pilot'] } }).fetch();
	
			_lodash2.default.each(pilots, function (pilot) {
				var color = Math.floor(Math.random() * 256) + ',' + Math.floor(Math.random() * 256) + ',' + Math.floor(Math.random() * 256);
	
				var startOf = affichage.slice(0, -1);
				var data = [];
	
				for (var i = 0; i <= (0, _moment2.default)(to).diff((0, _moment2.default)(from), affichage); i++) {
	
					var startDate = (0, _moment2.default)(from).startOf(startOf).add('1', 'hours').add(i, affichage).toDate();
					var endDate = (0, _moment2.default)(from).endOf(startOf).add(i, affichage).toDate();
	
					if (i == 0) {
						startDate = (0, _moment2.default)(from).toDate();
					}
	
					if (i == (0, _moment2.default)(to).diff((0, _moment2.default)(from), affichage)) {
						var _endDate2 = (0, _moment2.default)(to).toDate();
					}
	
					var hours = 0;
					_lodash2.default.each(_flights.Flights.find({ date: { $gte: startDate, $lte: endDate }, status: "validated", pilotId: pilot._id }).fetch(), function (flight) {
						hours += flight.time;
					});
	
					hours = Math.round(hours / 60 * 10) / 10;
	
					data.push(hours);
				}
	
				datas.push([pilot.profile.firstName + ' ' + pilot.profile.lastName, data, color]);
			});
	
			return datas;
		}
	});
	
	// Get list of all method names on Lists
	var LISTS_METHODS = _lodash2.default.map([pilotsFlightsStatistics, pilotsHoursStatistics], 'name');
	
	if (Meteor.isServer) {
		// Only allow 5 list operations per connection per second
		DDPRateLimiter.addRule({
			name: function name(_name) {
				return _lodash2.default.includes(LISTS_METHODS, _name);
			},
	
	
			// Rate limit per connection ID
			connectionId: function connectionId() {
				return true;
			}
		}, 5, 1000);
	}

/***/ },

/***/ "./src/universal/collections/statistics/reservations.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.reservationsCancelSMS = exports.reservationsCancelExport = exports.reservationsExport = exports.reservationsStatistics = undefined;
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var ValidatedMethod = Package['mdg:validated-method'].ValidatedMethod;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var DDPRateLimiter = Package['ddp-rate-limiter'].DDPRateLimiter;
	var reservationsStatistics = exports.reservationsStatistics = new ValidatedMethod({
		name: 'reservations.statistics',
		validate: new SimpleSchema({
			from: { type: String },
			to: { type: String },
			affichage: { type: String }
		}).validator(),
		run: function run(_ref) {
			var from = _ref.from,
			    to = _ref.to,
			    affichage = _ref.affichage;
	
	
			var startOf = affichage.slice(0, -1);
			var dataAngers = [];
			var dataNantes = [];
			var dataAll = [];
	
			for (var i = 0; i <= (0, _moment2.default)(to).diff((0, _moment2.default)(from), affichage); i++) {
	
				var startDate = (0, _moment2.default)(from).startOf(startOf).add('1', 'hours').add(i, affichage).toDate();
				var endDate = (0, _moment2.default)(from).endOf(startOf).add(i, affichage).toDate();
	
				if (i == 0) {
					startDate = (0, _moment2.default)(from).toDate();
				}
	
				if (i == (0, _moment2.default)(to).diff((0, _moment2.default)(from), affichage)) {
					var _endDate = (0, _moment2.default)(to).toDate();
				}
	
				dataAll.push(_reservations.Reservations.find({ createdAt: { $gte: startDate, $lte: endDate }, billAt: { $ne: "" } }).fetch().length);
				dataAngers.push(_reservations.Reservations.find({ createdAt: { $gte: startDate, $lte: endDate }, billAt: { $ne: "" }, place: "anjou" }).fetch().length);
				dataNantes.push(_reservations.Reservations.find({ createdAt: { $gte: startDate, $lte: endDate }, billAt: { $ne: "" }, place: "nantes" }).fetch().length);
			}
	
			return [dataAll, dataAngers, dataNantes];
		}
	});
	
	var reservationsExport = exports.reservationsExport = new ValidatedMethod({
		name: 'reservations.export',
		validate: new SimpleSchema({
			'selectedYear': { type: String }
		}).validator(),
		run: function run(_ref2) {
			var selectedYear = _ref2.selectedYear;
	
	
			var datas = [];
			var startDate = (0, _moment2.default)().year(selectedYear).startOf('year').toDate();
			var endDate = (0, _moment2.default)().year(selectedYear).endOf('year').toDate();
	
			var reservations = _reservations.Reservations.find({ createdAt: { $gte: startDate, $lte: endDate } }).fetch();
	
			_lodash2.default.each(reservations, function (reservation) {
	
				var souscripteur = reservation.getSubscriber();
				var passengers = reservation.getPassengers();
	
				var emails = [];
				var phones = [];
	
				_lodash2.default.each(passengers, function (passenger) {
					if (passenger.email && passenger.email.length > 3) {
						emails.push(' ' + passenger.email + ' ');
					}
					if (passenger.phone) {
						phones.push(' ' + passenger.phone + ' ');
					}
				});
	
				if (reservation.id_billet) {
					datas.push({
						'N° Billet': reservation.id_billet,
						'Emails passagers': emails,
						'Téléphones passagers': phones,
						'Email acheteur': souscripteur ? souscripteur.email : '-',
						'Date achat': (0, _moment2.default)(reservation.createdAt).format('D/M/Y'),
						'Prestation': reservation.flightName,
						'Status': reservation.getState(),
						'Date vol': reservation.scheduledAt ? (0, _moment2.default)(reservation.scheduledAt).format('D/M/Y') : '-',
						'Passagers': passengers.length,
						'Lieu envol': reservation.getPlace(),
						'Type': reservation.flightName,
						'Adresse': souscripteur ? souscripteur.city : '-',
						'Prix': reservation.getPrice(),
						'Payée': reservation.price <= reservation.getSolde() ? 'Oui' : 'Non',
						'Periode': reservation.period,
						'Informations': reservation.infoReservation ? reservation.infoReservation.replace(/;/g, ',') : '-'
					});
				}
			});
	
			return datas;
		}
	});
	
	var reservationsCancelExport = exports.reservationsCancelExport = new ValidatedMethod({
		name: 'reservationsCancel.export',
		validate: new SimpleSchema({
			'selectedYear': { type: String }
		}).validator(),
		run: function run(_ref3) {
			var selectedYear = _ref3.selectedYear;
	
	
			var datas = [];
			var startDate = (0, _moment2.default)().year(selectedYear).startOf('year').toDate();
			var endDate = (0, _moment2.default)().year(selectedYear).endOf('year').toDate();
	
			var reservations = _reservations.Reservations.find({ state: { $lt: 6 },
				history: { $elemMatch: {
						date: { $gte: startDate, $lte: endDate },
						type: 'cancelled'
					}
				} }).fetch();
	
			_lodash2.default.each(reservations, function (reservation) {
	
				var souscripteur = reservation.getSubscriber();
				var passengers = reservation.getPassengers();
	
				var emails = [];
				var phones = [];
	
				_lodash2.default.each(passengers, function (passenger) {
					if (passenger.email && passenger.email.length > 3) {
						emails.push(' ' + passenger.email + ' ');
					}
					if (passenger.phone) {
						phones.push(' ' + passenger.phone + ' ');
					}
				});
	
				if (reservation.id_billet && reservation.getCancelTime() > 0) {
					datas.push({
						'N° Billet': reservation.id_billet,
						'Emails passagers': emails,
						'Téléphones passagers': phones,
						'Email acheteur': souscripteur ? souscripteur.email : '-',
						'Date achat': (0, _moment2.default)(reservation.createdAt).format('DD/MM/YYYY'),
						'Lieu envol': reservation.getPlace(),
						'Prestation': reservation.flightName ? reservation.flightName : reservation.getFlightType().title,
						'Annulation': reservation.getCancelTime(),
						'Dernière annulation': (0, _moment2.default)(reservation.getLastCancelTime()).format('DD/MM/YYYY'),
						'Informations': reservation.infoReservation ? reservation.infoReservation.replace(/;/g, ',') : '-'
					});
				}
			});
	
			return datas;
		}
	});
	
	var reservationsCancelSMS = exports.reservationsCancelSMS = new ValidatedMethod({
		name: 'reservationsCancelSMS.export',
		validate: new SimpleSchema({}).validator(),
		run: function run() {
	
			var datas = [];
			// let reservations = Reservations.find(
			// 	{state: {$lt: 6},
			//     history: { $elemMatch: {
			//       date: {$gte: startDate},
			//     }
			//   }, $expr: { $eq: [{ "$arrayElemAt": ["$history.type", -1] }, 'cancelled'] }}).fetch();
	
	
			var reservations = _reservations.Reservations.find({
				updatedAt: { $gte: (0, _moment2.default)().subtract(15, 'days').toDate() }
			}).fetch();
	
			_lodash2.default.each(reservations, function (reservation) {
	
				if (reservation.history.slice(-1)[0] && reservation.history.slice(-1)[0].type == 'cancelled' && reservation.history.slice(-1)[0].date >= (0, _moment2.default)().subtract(15, 'days').toDate()) {
					reservation.passengers = reservation.getPassengers();
					datas.push(reservation);
				}
			});
	
			return datas;
		}
	});
	
	// Get list of all method names on Lists
	var LISTS_METHODS = _lodash2.default.map([reservationsStatistics, reservationsExport, reservationsCancelExport, reservationsCancelSMS], 'name');
	
	if (Meteor.isServer) {
		// Only allow 5 list operations per connection per second
		DDPRateLimiter.addRule({
			name: function name(_name) {
				return _lodash2.default.includes(LISTS_METHODS, _name);
			},
	
	
			// Rate limit per connection ID
			connectionId: function connectionId() {
				return true;
			}
		}, 5, 1000);
	}

/***/ },

/***/ "./src/universal/collections/users/roles/god.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.god = undefined;
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var god = exports.god = new _roles.Roles.Role('god');
	
	/*
	 *	List Permissions
	 *	Manage page access
	 */
	god.allow('alerts.list', true);
	god.allow('calendar.list', true);
	god.allow('orders.list', true);
	god.allow('flights.list', true);
	god.allow('flights-type.list', true);
	god.allow('places.list', true);
	god.allow('prices.list', true);
	god.allow('promotions.list', true);
	god.allow('options.list', true);
	god.allow('users.list', true);
	god.allow('montgolfieres.list', true);
	god.allow('montgolfieres.view', true);
	god.allow('places.list', true);
	god.allow('statistics.list', true);
	god.allow('planifications.list', true);
	
	/*
	 * Partners
	 */
	god.allow('partners.update', true);
	
	/*
	 *	Users
	 */
	god.allow('users.insert', true);
	god.allow('users.update', true);
	god.allow('users.remove', function (userId, doc) {
	  return doc._id !== userId;
	});
	
	/*
	 *	Montgolfieres
	 */
	god.allow('montgolfieres.insert', true);
	god.allow('montgolfieres.update', true);
	god.allow('montgolfieres.remove', false);
	
	/*
	 *  Flights
	 */
	god.allow('flights.insert', function (userId, doc) {
	  //if (moment().startOf('day').isAfter(moment(doc.date).startOf('day')))
	  //	return false;
	
	  /*if (doc.pilotId && Flights.findOne({ date: doc.date, period: doc.period, pilotId: doc.pilotId }))
	  	return false;
	  	const montgolfiere = Montgolfieres.findOne(doc.montgolfiereId);
	  if ((doc.montgolfiereId && !montgolfiere) || (montgolfiere && !_.includes(montgolfiere.allowedPilots, doc.pilotId)))
	  	return false;
	  	if (doc.reservationIds && doc.reservationIds.length)
	  	return false;
	  	if (doc.status && doc.status !== "preparing")
	  	return false;*/
	
	  return true;
	});
	god.allow('flights.update', false);
	god.allow('flights.prepare', function (userId, doc) {
	  return doc.status == "preparing";
	});
	god.allow('flights.enclose', function (userId, doc) {
	  return doc.status == "prepared" /* && moment().isAfter(moment(doc.date).startOf('day').add(doc.period == 'morning' ? 12 : 23, 'hours')) */;
	});
	god.allow('flights.organize', true);
	god.allow('flights.remove', function (userId, doc) {
	  return doc.status === 'preparing';
	});
	
	/*
	 *  Lieux d'envols
	 */
	god.allow('places.insert', true);
	god.allow('places.update', true);
	god.allow('places.remove', false);
	
	/*
	 *  Reservations
	 */
	god.allow('reservations.insert', true);
	god.allow('reservations.update', true);
	god.allow('reservations.remove', true);
	
	/*
	 *  Alerts
	 */
	god.allow('alerts.insert', true);
	god.allow('alerts.update', true);
	god.allow('alerts.remove', true);

/***/ },

/***/ "./src/universal/collections/users/roles/organizer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.organizer = undefined;
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var organizer = exports.organizer = new _roles.Roles.Role('organizer');
	
	/*
	 *	List Permissions
	 *	Manage page access
	 */
	organizer.allow('alerts.list', true);
	organizer.allow('calendar.list', true);
	organizer.allow('orders.list', true);
	organizer.allow('flights.list', true);
	organizer.allow('flights-type.list', true);
	organizer.allow('places.list', true);
	organizer.allow('prices.list', true);
	organizer.allow('promotions.list', true);
	organizer.allow('options.list', true);
	organizer.allow('users.list', true);
	organizer.allow('montgolfieres.list', true);
	organizer.allow('statistics.list', true);
	organizer.allow('planifications.list', true);
	
	/*
	 *	Users
	 */
	/*organizer.allow('users.insert', (userId, doc) => {
		return _.indexOf(doc.roles, "god") == -1;
	})*/;
	
	organizer.deny('users.update', function (userId, doc, fields, modifier) {
		return modifier && modifier['$set'] && modifier['$set']['roles'] && _lodash2.default.indexOf(modifier['$set']['roles'], "god") !== -1;
	});
	organizer.allow('users.remove', function (userId, doc) {
		return _lodash2.default.indexOf(doc.roles, "god") == -1 && doc._id !== userId;
	});
	
	/*
	 *	Montgolfieres
	 */
	organizer.allow('montgolfieres.insert', true);
	organizer.allow('montgolfieres.update', true);
	organizer.allow('montgolfieres.remove', false);
	
	/*
	 *  Flights
	 */
	organizer.allow('flights.insert', function (userId, doc) {
		/*if (moment().startOf('day').isAfter(moment(doc.date).startOf('day')))
	 	return false;
	 	//if (pilotId && Flights.findOne({ date: doc.date, period: doc.period, pilotId: doc.pilotId }))
	 //	return false;
	 	const montgolfiere = Montgolfieres.findOne(doc.montgolfiereId);
	 if ((doc.montgolfiereId && !montgolfiere) || (montgolfiere && !_.includes(montgolfiere.allowedPilots, doc.pilotId)))
	 	return false;
	 	if (doc.reservationIds && doc.reservationIds.length)
	 	return false;
	 	if (doc.status !== "preparing")
	 	return false;
	 	const projection = {
	 	$elemMatch: {
	 		startDate: {$lte: doc.date},
	 		endDate: {$gte: doc.date},
	 		isAvailable: true,
	 		period: doc.period
	 	}
	 };*/
	
		return true;
	});
	organizer.allow('flights.update', false);
	organizer.allow('flights.prepare', true);
	organizer.allow('flights.prepare', function (userId, doc) {
		return doc.status == "preparing";
	});
	organizer.allow('flights.enclose', function (userId, doc) {
		return doc.status == "prepared" /* && moment().isAfter(moment(doc.date).startOf('day').add(doc.period == 'morning' ? 12 : 23, 'hours')) */;
	});
	organizer.allow('flights.remove', function (userId, doc) {
		return doc.status === 'preparing';
	});
	
	/*
	 *  Lieux d'envols
	 */
	organizer.allow('places.insert', true);
	organizer.allow('places.update', true);
	organizer.allow('places.remove', false);
	
	/*
	 *  Reservations
	 */
	organizer.allow('reservations.insert', true);
	organizer.allow('reservations.update', true);
	organizer.allow('reservations.remove', true);
	
	/*
	 *  Alerts
	 */
	organizer.allow('alerts.insert', true);
	organizer.allow('alerts.update', true);
	organizer.allow('alerts.remove', true);

/***/ },

/***/ "./src/universal/collections/users/roles/partner.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.partner = undefined;
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var partner = exports.partner = new _roles.Roles.Role('partner');
	
	/*
	 *	List Permissions
	 *	Manage page access
	 */
	
	partner.allow('calendar.list', false);
	partner.allow('orders.list', true);
	partner.allow('flights.list', true);
	partner.allow('flights-type.list', true);
	partner.allow('places.list', false);
	partner.allow('prices.list', false);
	partner.allow('promotions.list', false);
	partner.allow('options.list', false);
	partner.allow('users.list', false);
	partner.allow('montgolfieres.list', true);
	partner.allow('statistics.list', false);
	partner.allow('planifications.list', false);
	
	/*
	 *	Users
	 */
	partner.allow('users.insert', false);
	partner.allow('users.update', function (userId, doc) {
	  return doc._id === userId;
	});
	partner.deny('users.update', function (userId, doc, fields, modifier) {
	  return _lodash2.default.includes(fields, 'roles') || modifier && modifier['$set'] && modifier['$set']['roles'] && (modifier['$set']['roles'].length > 1 || modifier['$set']['roles'][0] !== "partner");
	});
	partner.allow('users.remove', false);
	
	/*
	 *	Montgolfieres
	 */
	partner.allow('montgolfieres.insert', false);
	partner.allow('montgolfieres.update', false);
	partner.allow('montgolfieres.remove', false);
	
	/*
	 *  Flights
	 */
	partner.allow('flights.insert', false);
	partner.allow('flights.update', false);
	partner.allow('flights.remove', false);
	
	/*
	 *  Lieux d'envols
	 */
	partner.allow('places.insert', false);
	partner.allow('places.update', false);
	partner.allow('places.remove', false);
	
	/*
	 *  Prix
	 */
	partner.allow('prices.insert', false);
	partner.allow('prices.update', false);
	partner.allow('prices.remove', false);
	
	/*
	 *  Flights-type
	 */
	partner.allow('flights-type.insert', false);
	partner.allow('flights-type.update', false);
	partner.allow('flights-type.remove', false);
	
	/*
	 *  Reservations
	 */
	partner.allow('reservations.insert', true);
	partner.allow('reservations.update', function (userId, doc) {
	  return doc.userId == userId;
	});
	partner.allow('reservations.remove', function (userId, doc) {
	  return doc.userId == userId;
	});
	
	/*
	 *  Alerts
	 */
	partner.allow('alerts.insert', false);
	partner.allow('alerts.update', false);
	partner.allow('alerts.remove', false);

/***/ },

/***/ "./src/universal/collections/users/roles/pilot.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.pilot = undefined;
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var pilot = exports.pilot = new _roles.Roles.Role('pilot');
	
	/*
	 *	List Permissions
	 *	Manage page access
	 */
	pilot.allow('alerts.list', true);
	pilot.allow('calendar.list', true);
	pilot.allow('orders.list', true);
	pilot.allow('flights.list', true);
	pilot.allow('flights-type.list', true);
	pilot.allow('places.list', true);
	pilot.allow('prices.list', true);
	pilot.allow('promotions.list', true);
	pilot.allow('options.list', false);
	pilot.allow('users.list', true);
	pilot.allow('montgolfieres.list', true);
	pilot.allow('statistics.list', false);
	pilot.allow('my-flights.list', true);
	
	/*
	 *	Users
	 */
	pilot.allow('users.update', function (userId, doc, fields) {
		return doc._id === userId;
	});
	pilot.deny('users.update', function (userId, doc, fields, modifier) {
		if (_roles.Roles.userHasRole(userId, 'god') || _roles.Roles.userHasRole(userId, 'organizer')) return false;
	
		return _lodash2.default.includes(fields, 'roles') || modifier && modifier['$set'] && modifier['$set']['roles'] && (modifier['$set']['roles'].length > 1 || modifier['$set']['roles'][0] !== "pilot");
	});
	
	/*
	 *	Montgolfieres
	 */
	pilot.allow('montgolfieres.insert', false);
	pilot.allow('montgolfieres.update', false);
	pilot.allow('montgolfieres.remove', false);
	
	/*
	 *  Flights
	 */
	pilot.allow('flights.insert', function (userId, doc) {
		/*if (moment().startOf('day').isAfter(moment(doc.date).startOf('day')))
	 	return false;
	 	if (Flights.findOne({ date: doc.date, period: doc.period, pilotId: userId }))
	 	return false;
	 	const montgolfiere = Montgolfieres.findOne(doc.montgolfiereId);
	 if ((doc.montgolfiereId && !montgolfiere) || (montgolfiere && !_.includes(montgolfiere.allowedPilots, userId)))
	 	return false;
	 	if (doc.reservationIds && doc.reservationIds.length)
	 	return false;
	 	if (doc.pilotId !== userId)
	 	return false;
	 	if (doc.status !== "preparing")
	 	return false;
	 	const projection = {
	 	$elemMatch: {
	 		startDate: {$lte: doc.date},
	 		endDate: {$gte: doc.date},
	 		isAvailable: true,
	 		period: doc.period
	 	}
	 };
	 	if (!Meteor.users.findOne({"_id": userId, "profile.availabilities": projection}))
	 	return false;*/
	
		return true;
	});
	pilot.allow('flights.update', false);
	pilot.allow('flights.prepare', function (userId, doc) {
		return doc.pilotId === userId && doc.status == "preparing";
	});
	pilot.allow('flights.enclose', function (userId, doc) {
		return doc.status == "prepared" && doc.pilotId == userId
		/*&& moment().isAfter(moment(doc.date).startOf('day').add(doc.period == 'morning' ? 12 : 23, 'hours'))*/;
	});
	pilot.allow('flights.remove', function (userId, doc) {
		return doc.status === 'preparing' && doc.pilotId === userId;
	});
	
	/*
	 *  Lieux d'envols
	 */
	pilot.allow('places.insert', false);
	pilot.allow('places.update', false);
	pilot.allow('places.remove', false);
	
	/*
	 *  Reservations
	 */
	pilot.allow('reservations.insert', true);
	pilot.allow('reservations.update', true);
	pilot.allow('reservations.remove', true);
	
	/*
	 *  Alerts
	 */
	pilot.allow('alerts.insert', true);
	pilot.allow('alerts.update', true);
	pilot.allow('alerts.remove', true);

/***/ },

/***/ "./src/universal/components/reservations/Calendar.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class;
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactMomentProptypes = __webpack_require__("./node_modules/react-moment-proptypes/src/index.js");
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _server = __webpack_require__("./node_modules/react-dom/server.js");
	
	var _server2 = _interopRequireDefault(_server);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	var _availabilities = __webpack_require__("./src/universal/helpers/availabilities.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Tracker = Package.tracker.Tracker;
	
	
	var jQuery = __webpack_require__("./node_modules/jquery/dist/jquery.js");
	__webpack_require__("./node_modules/fullcalendar/dist/fullcalendar.js");
	__webpack_require__("./node_modules/fullcalendar/dist/locale/fr.js");
	
	var CalendarPage = (0, _reactRouter.withRouter)(_class = function (_React$Component) {
		(0, _inherits3.default)(CalendarPage, _React$Component);
	
		function CalendarPage(props) {
			(0, _classCallCheck3.default)(this, CalendarPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (CalendarPage.__proto__ || (0, _getPrototypeOf2.default)(CalendarPage)).call(this, props));
	
			_this.state = {};
	
			_this.startDate = (0, _moment2.default)().startOf('month').toDate();
			_this.endDate = (0, _moment2.default)().endOf('month').toDate();
			return _this;
		}
	
		(0, _createClass3.default)(CalendarPage, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				var that = this;
				Tracker.nonreactive(function () {
					jQuery('#calendar').fullCalendar({
						locale: 'fr',
						height: jQuery('#calendar').height(),
						viewRender: function viewRender(view, element) {
							console.log("viewRender");
							if (_this2.startDate == (0, _moment2.default)(date).startOf('month').toDate()) return;
							if (_this2.reloading) return;
							console.log("pass test");
	
							_this2.reloading = false;
	
							var date = jQuery('#calendar').fullCalendar('getDate');
							_this2.startDate = (0, _moment2.default)(date).startOf('month').toDate();
							_this2.endDate = (0, _moment2.default)(date).endOf('month').toDate();
	
							_this2.subscriptions && _this2.subscriptions.available.stop();
							Tracker.nonreactive(function () {
								console.log("subscription launched");
								_this2.subscriptions = {};
								_this2.subscriptions.available = Meteor.subscribe("availableAndScheduledBetween", _this2.startDate, _this2.endDate, function () {
									console.log("subscription done");
									_this2.reloading = true;
	
									var $calendar = jQuery('#calendar');
									$calendar.fullCalendar('prev');
									$calendar.fullCalendar('next');
									$calendar.fullCalendar('refresh');
									/*let view = $calendar.fullCalendar('getView');
	        view.unrenderDates();
	        view.renderDates();*/
								});
							});
						},
						dayRender: function dayRender(momentDate, cell) {
							var date = momentDate.toDate();
	
							var anjou = _server2.default.renderToStaticMarkup(_react2.default.createElement(
								'div',
								{ className: 'calendar' },
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 6 },
									_react2.default.createElement(
										'p',
										null,
										(0, _availabilities.getReservedCount)(date, "anjou", "morning") + '/' + (0, _availabilities.getAvailabilityTotalCount)(date, "anjou", "morning") + " places"
									),
									_react2.default.createElement(_rubix.Progress, { striped: true, bsStyle: 'info', value: (0, _availabilities.getReservedCount)(date, "anjou", "morning") / (0, _availabilities.getAvailabilityTotalCount)(date, "anjou", "morning") * 100 })
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 6 },
									_react2.default.createElement(
										'p',
										null,
										(0, _availabilities.getReservedCount)(date, "anjou", "evening") + '/' + (0, _availabilities.getAvailabilityTotalCount)(date, "anjou", "evening") + " places"
									),
									_react2.default.createElement(_rubix.Progress, { striped: true, bsStyle: 'info', value: (0, _availabilities.getReservedCount)(date, "anjou", "evening") / (0, _availabilities.getAvailabilityTotalCount)(date, "anjou", "evening") * 100 })
								)
							));
							var nantes = _server2.default.renderToStaticMarkup(_react2.default.createElement(
								'div',
								{ className: 'calendar' },
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 6 },
									_react2.default.createElement(
										'p',
										null,
										(0, _availabilities.getReservedCount)(date, "nantes", "morning") + '/' + (0, _availabilities.getAvailabilityTotalCount)(date, "nantes", "morning") + " places"
									),
									_react2.default.createElement(_rubix.Progress, { striped: true, bsStyle: 'info', value: (0, _availabilities.getReservedCount)(date, "nantes", "morning") / (0, _availabilities.getAvailabilityTotalCount)(date, "nantes", "morning") * 100 })
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 6 },
									_react2.default.createElement(
										'p',
										null,
										(0, _availabilities.getReservedCount)(date, "nantes", "evening") + '/' + (0, _availabilities.getAvailabilityTotalCount)(date, "nantes", "evening") + " places"
									),
									_react2.default.createElement(_rubix.Progress, { striped: true, bsStyle: 'info', value: (0, _availabilities.getReservedCount)(date, "nantes", "evening") / (0, _availabilities.getAvailabilityTotalCount)(date, "nantes", "evening") * 100 })
								)
							));
	
							cell.html("<div class='calendar-day'>" + anjou + nantes + "</div>");
						},
						dayClick: function dayClick(date, jsEvent, view, resourceObj) {
							if (!_.includes(Meteor.user().roles, 'partner')) that.props.router.push('/planning?date=' + date.format());
						}
					});
				});
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.subscriptions.available.stop();
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Calendrier des disponibilit\xE9s' },
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 12 },
							_react2.default.createElement('div', { id: 'calendar' })
						)
					)
				);
			}
		}]);
		return CalendarPage;
	}(_react2.default.Component)) || _class;
	
	exports.default = CalendarPage;
	
	
	CalendarPage.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./node_modules/react-moment-proptypes/src/index.js":
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__("./node_modules/moment/moment.js");
	var momentValidationWrapper = __webpack_require__("./node_modules/react-moment-proptypes/src/moment-validation-wrapper.js");
	var core = __webpack_require__("./node_modules/react-moment-proptypes/src/core.js");
	
	moment.createFromInputFallback = function(config) {
	  config._d = new Date(config._i);
	};
	
	module.exports = {
	
	  momentObj : core.createMomentChecker(
	    'object',
	    function(obj) {
	      return typeof obj === 'object';
	    },
	    function isValid(value) {
	      return momentValidationWrapper.isValidMoment(value);
	    },
	    'Moment'
	  ),
	
	  momentString : core.createMomentChecker(
	    'string',
	    function(str) {
	      return typeof str === 'string';
	    },
	    function isValid(value) {
	      return momentValidationWrapper.isValidMoment(moment(value));
	    },
	    'Moment'
	  ),
	
	  momentDurationObj : core.createMomentChecker(
	    'object',
	    function(obj) {
	      return typeof obj === 'object';
	    },
	    function isValid(value) {
	      return moment.isDuration(value);
	    },
	    'Duration'
	  ),
	
	};


/***/ },

/***/ "./node_modules/react-moment-proptypes/src/moment-validation-wrapper.js":
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__("./node_modules/moment/moment.js");
	
	function isValidMoment(testMoment) {
	  if (typeof moment.isMoment === 'function' && !moment.isMoment(testMoment)) {
	    return false;
	  }
	
	  /* istanbul ignore else  */
	  if (typeof testMoment.isValid === 'function') {
	    // moment 1.7.0+
	    return testMoment.isValid();
	  }
	
	  /* istanbul ignore next */
	  return !isNaN(testMoment);
	}
	
	module.exports = {
	  isValidMoment : isValidMoment,
	};


/***/ },

/***/ "./node_modules/react-moment-proptypes/src/core.js":
/***/ function(module, exports) {

	var messages = {
	  invalidPredicate: '`predicate` must be a function',
	  invalidPropValidator: '`propValidator` must be a function',
	  requiredCore: 'is marked as required',
	  invalidTypeCore: 'Invalid input type',
	  predicateFailureCore: 'Failed to succeed with predicate',
	  anonymousMessage: '<<anonymous>>',
	  baseInvalidMessage: 'Invalid ',
	};
	
	function constructPropValidatorVariations(propValidator) {
	  if (typeof propValidator !== 'function') {
	    throw new Error(messages.invalidPropValidator);
	  }
	
	  var requiredPropValidator = propValidator.bind(null, false, null);
	  requiredPropValidator.isRequired = propValidator.bind(null, true, null);
	
	  requiredPropValidator.withPredicate = function predicateApplication(predicate) {
	    if (typeof predicate !== 'function') {
	      throw new Error(messages.invalidPredicate);
	    }
	    var basePropValidator = propValidator.bind(null, false, predicate);
	    basePropValidator.isRequired = propValidator.bind(null, true, predicate);
	    return basePropValidator;
	  };
	
	  return requiredPropValidator;
	}
	
	function createInvalidRequiredErrorMessage(propName, componentName, value) {
	  return new Error(
	    'The prop `' + propName + '` ' + messages.requiredCore +
	    ' in `' + componentName + '`, but its value is `' + value + '`.'
	  );
	}
	
	function createMomentChecker(type, typeValidator, validator, momentType) {
	
	  function propValidator(
	    isRequired, // Bound parameter to indicate with the propType is required
	    predicate, // Bound parameter to allow user to add dynamic validation
	    props,
	    propName,
	    componentName,
	    location,
	    propFullName
	  ) {
	    var propValue = props[ propName ];
	    var propType = typeof propValue;
	
	    var isPropValueUndefined = typeof propValue === 'undefined';
	    var isPropValueNull = propValue === null;
	
	    if (isRequired) {
	      componentName = componentName ||  messages.anonymousMessage;
	      propFullName = propFullName || propName;
	      if (isPropValueUndefined) {
	        return createInvalidRequiredErrorMessage(propFullName, componentName, 'undefined');
	      } else if (isPropValueNull) {
	        return createInvalidRequiredErrorMessage(propFullName, componentName, 'null');
	      }
	    }
	
	    if (isPropValueUndefined || isPropValueNull) {
	      return null;
	    }
	
	    if (typeValidator && !typeValidator(propValue)) {
	      return new Error(
	        messages.invalidTypeCore + ': `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`, expected `' + type + '`.'
	      );
	    }
	
	    if (! validator(propValue)) {
	      return new Error(
	        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`, expected `' + momentType + '`.'
	      );
	    }
	
	    if (predicate && ! predicate(propValue)) {
	      var predicateName = predicate.name || messages.anonymousMessage;
	      return new Error(
	        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`. ' + messages.predicateFailureCore + ' `' +
	        predicateName + '`.'
	      );
	    }
	
	    return null;
	
	  }
	
	  return constructPropValidatorVariations(propValidator);
	
	}
	
	module.exports = {
	  constructPropValidatorVariations: constructPropValidatorVariations,
	  createMomentChecker: createMomentChecker,
	  messages: messages,
	};


/***/ },

/***/ "./node_modules/react-dom/server.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__("./node_modules/react-dom/lib/ReactDOMServer.js");


/***/ },

/***/ "./node_modules/react-dom/lib/ReactDOMServer.js":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__("./node_modules/react-dom/lib/ReactDefaultInjection.js");
	var ReactServerRendering = __webpack_require__("./node_modules/react-dom/lib/ReactServerRendering.js");
	var ReactVersion = __webpack_require__("./node_modules/react-dom/lib/ReactVersion.js");
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },

/***/ "./node_modules/react-dom/lib/ReactServerRendering.js":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");
	
	var React = __webpack_require__("./node_modules/react/lib/React.js");
	var ReactDOMContainerInfo = __webpack_require__("./node_modules/react-dom/lib/ReactDOMContainerInfo.js");
	var ReactDefaultBatchingStrategy = __webpack_require__("./node_modules/react-dom/lib/ReactDefaultBatchingStrategy.js");
	var ReactInstrumentation = __webpack_require__("./node_modules/react-dom/lib/ReactInstrumentation.js");
	var ReactMarkupChecksum = __webpack_require__("./node_modules/react-dom/lib/ReactMarkupChecksum.js");
	var ReactReconciler = __webpack_require__("./node_modules/react-dom/lib/ReactReconciler.js");
	var ReactServerBatchingStrategy = __webpack_require__("./node_modules/react-dom/lib/ReactServerBatchingStrategy.js");
	var ReactServerRenderingTransaction = __webpack_require__("./node_modules/react-dom/lib/ReactServerRenderingTransaction.js");
	var ReactUpdates = __webpack_require__("./node_modules/react-dom/lib/ReactUpdates.js");
	
	var emptyObject = __webpack_require__("./node_modules/fbjs/lib/emptyObject.js");
	var instantiateReactComponent = __webpack_require__("./node_modules/react-dom/lib/instantiateReactComponent.js");
	var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
	
	var pendingTransactions = 0;
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToStringImpl(element, makeStaticMarkup) {
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);
	
	    pendingTransactions++;
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, true);
	      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
	      );
	      if (false) {
	        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
	      }
	      if (!makeStaticMarkup) {
	        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
	      }
	      return markup;
	    }, null);
	  } finally {
	    pendingTransactions--;
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    if (!pendingTransactions) {
	      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	    }
	  }
	}
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
	 */
	function renderToString(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
	  return renderToStringImpl(element, false);
	}
	
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
	 */
	function renderToStaticMarkup(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
	  return renderToStringImpl(element, true);
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },

/***/ "./node_modules/react-dom/lib/ReactServerBatchingStrategy.js":
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },

/***/ "./node_modules/jquery/dist/jquery.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.3.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2018-01-20T17:24Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			noModule: true
		};
	
		function DOMEval( code, doc, node ) {
			doc = doc || document;
	
			var i,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
					if ( node[ i ] ) {
						script[ i ] = node[ i ];
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.3.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && Array.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
	        if ( nodeName( elem, "iframe" ) ) {
	            return elem.contentDocument;
	        }
	
	        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
	        // Treat the template element as a regular one in browsers that
	        // don't support it.
	        if ( nodeName( elem, "template" ) ) {
	            elem = elem.content || elem;
	        }
	
	        return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			div.style.position = "absolute";
			scrollboxSizeVal = div.offsetWidth === 36 || "absolute";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a property mapped along what jQuery.cssProps suggests or to
	// a vendor prefixed property.
	function finalPropName( name ) {
		var ret = jQuery.cssProps[ name ];
		if ( !ret ) {
			ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
		}
		return ret;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
			) );
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
			val = curCSS( elem, dimension, styles ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox;
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = valueIsBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ dimension ] );
	
		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		if ( val === "auto" ||
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {
	
			val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];
	
			// offsetWidth/offsetHeight provide border-box values
			valueIsBorderBox = true;
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
					isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra && boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					);
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && support.scrollboxSize() === styles.position ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = Date.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ },

/***/ "./node_modules/fullcalendar/dist/fullcalendar.js":
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * FullCalendar v3.8.2
	 * Docs & License: https://fullcalendar.io/
	 * (c) 2018 Adam Shaw
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__("./node_modules/moment/moment.js"), __webpack_require__("./node_modules/jquery/dist/jquery.js"));
		else if(typeof define === 'function' && define.amd)
			define(["moment", "jquery"], factory);
		else if(typeof exports === 'object')
			exports["FullCalendar"] = factory(require("moment"), require("jquery"));
		else
			root["FullCalendar"] = factory(root["moment"], root["jQuery"]);
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 236);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
	
	/***/ }),
	/* 1 */,
	/* 2 */
	/***/ (function(module, exports) {
	
	/*
	derived from:
	https://github.com/Microsoft/tslib/blob/v1.6.0/tslib.js
	
	only include the helpers we need, to keep down filesize
	*/
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b)
	        if (b.hasOwnProperty(p))
	            d[p] = b[p]; };
	exports.__extends = function (d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(0);
	var $ = __webpack_require__(3);
	/* FullCalendar-specific DOM Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	// Given the scrollbar widths of some other container, create borders/margins on rowEls in order to match the left
	// and right space that was offset by the scrollbars. A 1-pixel border first, then margin beyond that.
	function compensateScroll(rowEls, scrollbarWidths) {
	    if (scrollbarWidths.left) {
	        rowEls.css({
	            'border-left-width': 1,
	            'margin-left': scrollbarWidths.left - 1
	        });
	    }
	    if (scrollbarWidths.right) {
	        rowEls.css({
	            'border-right-width': 1,
	            'margin-right': scrollbarWidths.right - 1
	        });
	    }
	}
	exports.compensateScroll = compensateScroll;
	// Undoes compensateScroll and restores all borders/margins
	function uncompensateScroll(rowEls) {
	    rowEls.css({
	        'margin-left': '',
	        'margin-right': '',
	        'border-left-width': '',
	        'border-right-width': ''
	    });
	}
	exports.uncompensateScroll = uncompensateScroll;
	// Make the mouse cursor express that an event is not allowed in the current area
	function disableCursor() {
	    $('body').addClass('fc-not-allowed');
	}
	exports.disableCursor = disableCursor;
	// Returns the mouse cursor to its original look
	function enableCursor() {
	    $('body').removeClass('fc-not-allowed');
	}
	exports.enableCursor = enableCursor;
	// Given a total available height to fill, have `els` (essentially child rows) expand to accomodate.
	// By default, all elements that are shorter than the recommended height are expanded uniformly, not considering
	// any other els that are already too tall. if `shouldRedistribute` is on, it considers these tall rows and
	// reduces the available height.
	function distributeHeight(els, availableHeight, shouldRedistribute) {
	    // *FLOORING NOTE*: we floor in certain places because zoom can give inaccurate floating-point dimensions,
	    // and it is better to be shorter than taller, to avoid creating unnecessary scrollbars.
	    var minOffset1 = Math.floor(availableHeight / els.length); // for non-last element
	    var minOffset2 = Math.floor(availableHeight - minOffset1 * (els.length - 1)); // for last element *FLOORING NOTE*
	    var flexEls = []; // elements that are allowed to expand. array of DOM nodes
	    var flexOffsets = []; // amount of vertical space it takes up
	    var flexHeights = []; // actual css height
	    var usedHeight = 0;
	    undistributeHeight(els); // give all elements their natural height
	    // find elements that are below the recommended height (expandable).
	    // important to query for heights in a single first pass (to avoid reflow oscillation).
	    els.each(function (i, el) {
	        var minOffset = i === els.length - 1 ? minOffset2 : minOffset1;
	        var naturalOffset = $(el).outerHeight(true);
	        if (naturalOffset < minOffset) {
	            flexEls.push(el);
	            flexOffsets.push(naturalOffset);
	            flexHeights.push($(el).height());
	        }
	        else {
	            // this element stretches past recommended height (non-expandable). mark the space as occupied.
	            usedHeight += naturalOffset;
	        }
	    });
	    // readjust the recommended height to only consider the height available to non-maxed-out rows.
	    if (shouldRedistribute) {
	        availableHeight -= usedHeight;
	        minOffset1 = Math.floor(availableHeight / flexEls.length);
	        minOffset2 = Math.floor(availableHeight - minOffset1 * (flexEls.length - 1)); // *FLOORING NOTE*
	    }
	    // assign heights to all expandable elements
	    $(flexEls).each(function (i, el) {
	        var minOffset = i === flexEls.length - 1 ? minOffset2 : minOffset1;
	        var naturalOffset = flexOffsets[i];
	        var naturalHeight = flexHeights[i];
	        var newHeight = minOffset - (naturalOffset - naturalHeight); // subtract the margin/padding
	        if (naturalOffset < minOffset) {
	            $(el).height(newHeight);
	        }
	    });
	}
	exports.distributeHeight = distributeHeight;
	// Undoes distrubuteHeight, restoring all els to their natural height
	function undistributeHeight(els) {
	    els.height('');
	}
	exports.undistributeHeight = undistributeHeight;
	// Given `els`, a jQuery set of <td> cells, find the cell with the largest natural width and set the widths of all the
	// cells to be that width.
	// PREREQUISITE: if you want a cell to take up width, it needs to have a single inner element w/ display:inline
	function matchCellWidths(els) {
	    var maxInnerWidth = 0;
	    els.find('> *').each(function (i, innerEl) {
	        var innerWidth = $(innerEl).outerWidth();
	        if (innerWidth > maxInnerWidth) {
	            maxInnerWidth = innerWidth;
	        }
	    });
	    maxInnerWidth++; // sometimes not accurate of width the text needs to stay on one line. insurance
	    els.width(maxInnerWidth);
	    return maxInnerWidth;
	}
	exports.matchCellWidths = matchCellWidths;
	// Given one element that resides inside another,
	// Subtracts the height of the inner element from the outer element.
	function subtractInnerElHeight(outerEl, innerEl) {
	    var both = outerEl.add(innerEl);
	    var diff;
	    // effin' IE8/9/10/11 sometimes returns 0 for dimensions. this weird hack was the only thing that worked
	    both.css({
	        position: 'relative',
	        left: -1 // ensure reflow in case the el was already relative. negative is less likely to cause new scroll
	    });
	    diff = outerEl.outerHeight() - innerEl.outerHeight(); // grab the dimensions
	    both.css({ position: '', left: '' }); // undo hack
	    return diff;
	}
	exports.subtractInnerElHeight = subtractInnerElHeight;
	/* Element Geom Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	// borrowed from https://github.com/jquery/jquery-ui/blob/1.11.0/ui/core.js#L51
	function getScrollParent(el) {
	    var position = el.css('position');
	    var scrollParent = el.parents().filter(function () {
	        var parent = $(this);
	        return (/(auto|scroll)/).test(parent.css('overflow') + parent.css('overflow-y') + parent.css('overflow-x'));
	    }).eq(0);
	    return position === 'fixed' || !scrollParent.length ? $(el[0].ownerDocument || document) : scrollParent;
	}
	exports.getScrollParent = getScrollParent;
	// Queries the outer bounding area of a jQuery element.
	// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
	// Origin is optional.
	function getOuterRect(el, origin) {
	    var offset = el.offset();
	    var left = offset.left - (origin ? origin.left : 0);
	    var top = offset.top - (origin ? origin.top : 0);
	    return {
	        left: left,
	        right: left + el.outerWidth(),
	        top: top,
	        bottom: top + el.outerHeight()
	    };
	}
	exports.getOuterRect = getOuterRect;
	// Queries the area within the margin/border/scrollbars of a jQuery element. Does not go within the padding.
	// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
	// Origin is optional.
	// WARNING: given element can't have borders
	// NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.
	function getClientRect(el, origin) {
	    var offset = el.offset();
	    var scrollbarWidths = getScrollbarWidths(el);
	    var left = offset.left + getCssFloat(el, 'border-left-width') + scrollbarWidths.left - (origin ? origin.left : 0);
	    var top = offset.top + getCssFloat(el, 'border-top-width') + scrollbarWidths.top - (origin ? origin.top : 0);
	    return {
	        left: left,
	        right: left + el[0].clientWidth,
	        top: top,
	        bottom: top + el[0].clientHeight // clientHeight includes padding but NOT scrollbars
	    };
	}
	exports.getClientRect = getClientRect;
	// Queries the area within the margin/border/padding of a jQuery element. Assumed not to have scrollbars.
	// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
	// Origin is optional.
	function getContentRect(el, origin) {
	    var offset = el.offset(); // just outside of border, margin not included
	    var left = offset.left + getCssFloat(el, 'border-left-width') + getCssFloat(el, 'padding-left') -
	        (origin ? origin.left : 0);
	    var top = offset.top + getCssFloat(el, 'border-top-width') + getCssFloat(el, 'padding-top') -
	        (origin ? origin.top : 0);
	    return {
	        left: left,
	        right: left + el.width(),
	        top: top,
	        bottom: top + el.height()
	    };
	}
	exports.getContentRect = getContentRect;
	// Returns the computed left/right/top/bottom scrollbar widths for the given jQuery element.
	// WARNING: given element can't have borders (which will cause offsetWidth/offsetHeight to be larger).
	// NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.
	function getScrollbarWidths(el) {
	    var leftRightWidth = el[0].offsetWidth - el[0].clientWidth;
	    var bottomWidth = el[0].offsetHeight - el[0].clientHeight;
	    var widths;
	    leftRightWidth = sanitizeScrollbarWidth(leftRightWidth);
	    bottomWidth = sanitizeScrollbarWidth(bottomWidth);
	    widths = { left: 0, right: 0, top: 0, bottom: bottomWidth };
	    if (getIsLeftRtlScrollbars() && el.css('direction') === 'rtl') {
	        widths.left = leftRightWidth;
	    }
	    else {
	        widths.right = leftRightWidth;
	    }
	    return widths;
	}
	exports.getScrollbarWidths = getScrollbarWidths;
	// The scrollbar width computations in getScrollbarWidths are sometimes flawed when it comes to
	// retina displays, rounding, and IE11. Massage them into a usable value.
	function sanitizeScrollbarWidth(width) {
	    width = Math.max(0, width); // no negatives
	    width = Math.round(width);
	    return width;
	}
	// Logic for determining if, when the element is right-to-left, the scrollbar appears on the left side
	var _isLeftRtlScrollbars = null;
	function getIsLeftRtlScrollbars() {
	    if (_isLeftRtlScrollbars === null) {
	        _isLeftRtlScrollbars = computeIsLeftRtlScrollbars();
	    }
	    return _isLeftRtlScrollbars;
	}
	function computeIsLeftRtlScrollbars() {
	    var el = $('<div><div/></div>')
	        .css({
	        position: 'absolute',
	        top: -1000,
	        left: 0,
	        border: 0,
	        padding: 0,
	        overflow: 'scroll',
	        direction: 'rtl'
	    })
	        .appendTo('body');
	    var innerEl = el.children();
	    var res = innerEl.offset().left > el.offset().left; // is the inner div shifted to accommodate a left scrollbar?
	    el.remove();
	    return res;
	}
	// Retrieves a jQuery element's computed CSS value as a floating-point number.
	// If the queried value is non-numeric (ex: IE can return "medium" for border width), will just return zero.
	function getCssFloat(el, prop) {
	    return parseFloat(el.css(prop)) || 0;
	}
	/* Mouse / Touch Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	// Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
	function isPrimaryMouseButton(ev) {
	    return ev.which === 1 && !ev.ctrlKey;
	}
	exports.isPrimaryMouseButton = isPrimaryMouseButton;
	function getEvX(ev) {
	    var touches = ev.originalEvent.touches;
	    // on mobile FF, pageX for touch events is present, but incorrect,
	    // so, look at touch coordinates first.
	    if (touches && touches.length) {
	        return touches[0].pageX;
	    }
	    return ev.pageX;
	}
	exports.getEvX = getEvX;
	function getEvY(ev) {
	    var touches = ev.originalEvent.touches;
	    // on mobile FF, pageX for touch events is present, but incorrect,
	    // so, look at touch coordinates first.
	    if (touches && touches.length) {
	        return touches[0].pageY;
	    }
	    return ev.pageY;
	}
	exports.getEvY = getEvY;
	function getEvIsTouch(ev) {
	    return /^touch/.test(ev.type);
	}
	exports.getEvIsTouch = getEvIsTouch;
	function preventSelection(el) {
	    el.addClass('fc-unselectable')
	        .on('selectstart', preventDefault);
	}
	exports.preventSelection = preventSelection;
	function allowSelection(el) {
	    el.removeClass('fc-unselectable')
	        .off('selectstart', preventDefault);
	}
	exports.allowSelection = allowSelection;
	// Stops a mouse/touch event from doing it's native browser action
	function preventDefault(ev) {
	    ev.preventDefault();
	}
	exports.preventDefault = preventDefault;
	/* General Geometry Utils
	----------------------------------------------------------------------------------------------------------------------*/
	// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
	function intersectRects(rect1, rect2) {
	    var res = {
	        left: Math.max(rect1.left, rect2.left),
	        right: Math.min(rect1.right, rect2.right),
	        top: Math.max(rect1.top, rect2.top),
	        bottom: Math.min(rect1.bottom, rect2.bottom)
	    };
	    if (res.left < res.right && res.top < res.bottom) {
	        return res;
	    }
	    return false;
	}
	exports.intersectRects = intersectRects;
	// Returns a new point that will have been moved to reside within the given rectangle
	function constrainPoint(point, rect) {
	    return {
	        left: Math.min(Math.max(point.left, rect.left), rect.right),
	        top: Math.min(Math.max(point.top, rect.top), rect.bottom)
	    };
	}
	exports.constrainPoint = constrainPoint;
	// Returns a point that is the center of the given rectangle
	function getRectCenter(rect) {
	    return {
	        left: (rect.left + rect.right) / 2,
	        top: (rect.top + rect.bottom) / 2
	    };
	}
	exports.getRectCenter = getRectCenter;
	// Subtracts point2's coordinates from point1's coordinates, returning a delta
	function diffPoints(point1, point2) {
	    return {
	        left: point1.left - point2.left,
	        top: point1.top - point2.top
	    };
	}
	exports.diffPoints = diffPoints;
	/* Object Ordering by Field
	----------------------------------------------------------------------------------------------------------------------*/
	function parseFieldSpecs(input) {
	    var specs = [];
	    var tokens = [];
	    var i;
	    var token;
	    if (typeof input === 'string') {
	        tokens = input.split(/\s*,\s*/);
	    }
	    else if (typeof input === 'function') {
	        tokens = [input];
	    }
	    else if ($.isArray(input)) {
	        tokens = input;
	    }
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        if (typeof token === 'string') {
	            specs.push(token.charAt(0) === '-' ?
	                { field: token.substring(1), order: -1 } :
	                { field: token, order: 1 });
	        }
	        else if (typeof token === 'function') {
	            specs.push({ func: token });
	        }
	    }
	    return specs;
	}
	exports.parseFieldSpecs = parseFieldSpecs;
	function compareByFieldSpecs(obj1, obj2, fieldSpecs, obj1fallback, obj2fallback) {
	    var i;
	    var cmp;
	    for (i = 0; i < fieldSpecs.length; i++) {
	        cmp = compareByFieldSpec(obj1, obj2, fieldSpecs[i], obj1fallback, obj2fallback);
	        if (cmp) {
	            return cmp;
	        }
	    }
	    return 0;
	}
	exports.compareByFieldSpecs = compareByFieldSpecs;
	function compareByFieldSpec(obj1, obj2, fieldSpec, obj1fallback, obj2fallback) {
	    if (fieldSpec.func) {
	        return fieldSpec.func(obj1, obj2);
	    }
	    var val1 = obj1[fieldSpec.field];
	    var val2 = obj2[fieldSpec.field];
	    if (val1 == null && obj1fallback) {
	        val1 = obj1fallback[fieldSpec.field];
	    }
	    if (val2 == null && obj2fallback) {
	        val2 = obj2fallback[fieldSpec.field];
	    }
	    return flexibleCompare(val1, val2) * (fieldSpec.order || 1);
	}
	exports.compareByFieldSpec = compareByFieldSpec;
	function flexibleCompare(a, b) {
	    if (!a && !b) {
	        return 0;
	    }
	    if (b == null) {
	        return -1;
	    }
	    if (a == null) {
	        return 1;
	    }
	    if ($.type(a) === 'string' || $.type(b) === 'string') {
	        return String(a).localeCompare(String(b));
	    }
	    return a - b;
	}
	exports.flexibleCompare = flexibleCompare;
	/* Date Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	exports.dayIDs = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
	exports.unitsDesc = ['year', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond']; // descending
	// Diffs the two moments into a Duration where full-days are recorded first, then the remaining time.
	// Moments will have their timezones normalized.
	function diffDayTime(a, b) {
	    return moment.duration({
	        days: a.clone().stripTime().diff(b.clone().stripTime(), 'days'),
	        ms: a.time() - b.time() // time-of-day from day start. disregards timezone
	    });
	}
	exports.diffDayTime = diffDayTime;
	// Diffs the two moments via their start-of-day (regardless of timezone). Produces whole-day durations.
	function diffDay(a, b) {
	    return moment.duration({
	        days: a.clone().stripTime().diff(b.clone().stripTime(), 'days')
	    });
	}
	exports.diffDay = diffDay;
	// Diffs two moments, producing a duration, made of a whole-unit-increment of the given unit. Uses rounding.
	function diffByUnit(a, b, unit) {
	    return moment.duration(Math.round(a.diff(b, unit, true)), // returnFloat=true
	    unit);
	}
	exports.diffByUnit = diffByUnit;
	// Computes the unit name of the largest whole-unit period of time.
	// For example, 48 hours will be "days" whereas 49 hours will be "hours".
	// Accepts start/end, a range object, or an original duration object.
	function computeGreatestUnit(start, end) {
	    var i;
	    var unit;
	    var val;
	    for (i = 0; i < exports.unitsDesc.length; i++) {
	        unit = exports.unitsDesc[i];
	        val = computeRangeAs(unit, start, end);
	        if (val >= 1 && isInt(val)) {
	            break;
	        }
	    }
	    return unit; // will be "milliseconds" if nothing else matches
	}
	exports.computeGreatestUnit = computeGreatestUnit;
	// like computeGreatestUnit, but has special abilities to interpret the source input for clues
	function computeDurationGreatestUnit(duration, durationInput) {
	    var unit = computeGreatestUnit(duration);
	    // prevent days:7 from being interpreted as a week
	    if (unit === 'week' && typeof durationInput === 'object' && durationInput.days) {
	        unit = 'day';
	    }
	    return unit;
	}
	exports.computeDurationGreatestUnit = computeDurationGreatestUnit;
	// Computes the number of units (like "hours") in the given range.
	// Range can be a {start,end} object, separate start/end args, or a Duration.
	// Results are based on Moment's .as() and .diff() methods, so results can depend on internal handling
	// of month-diffing logic (which tends to vary from version to version).
	function computeRangeAs(unit, start, end) {
	    if (end != null) {
	        return end.diff(start, unit, true);
	    }
	    else if (moment.isDuration(start)) {
	        return start.as(unit);
	    }
	    else {
	        return start.end.diff(start.start, unit, true);
	    }
	}
	// Intelligently divides a range (specified by a start/end params) by a duration
	function divideRangeByDuration(start, end, dur) {
	    var months;
	    if (durationHasTime(dur)) {
	        return (end - start) / dur;
	    }
	    months = dur.asMonths();
	    if (Math.abs(months) >= 1 && isInt(months)) {
	        return end.diff(start, 'months', true) / months;
	    }
	    return end.diff(start, 'days', true) / dur.asDays();
	}
	exports.divideRangeByDuration = divideRangeByDuration;
	// Intelligently divides one duration by another
	function divideDurationByDuration(dur1, dur2) {
	    var months1;
	    var months2;
	    if (durationHasTime(dur1) || durationHasTime(dur2)) {
	        return dur1 / dur2;
	    }
	    months1 = dur1.asMonths();
	    months2 = dur2.asMonths();
	    if (Math.abs(months1) >= 1 && isInt(months1) &&
	        Math.abs(months2) >= 1 && isInt(months2)) {
	        return months1 / months2;
	    }
	    return dur1.asDays() / dur2.asDays();
	}
	exports.divideDurationByDuration = divideDurationByDuration;
	// Intelligently multiplies a duration by a number
	function multiplyDuration(dur, n) {
	    var months;
	    if (durationHasTime(dur)) {
	        return moment.duration(dur * n);
	    }
	    months = dur.asMonths();
	    if (Math.abs(months) >= 1 && isInt(months)) {
	        return moment.duration({ months: months * n });
	    }
	    return moment.duration({ days: dur.asDays() * n });
	}
	exports.multiplyDuration = multiplyDuration;
	// Returns a boolean about whether the given duration has any time parts (hours/minutes/seconds/ms)
	function durationHasTime(dur) {
	    return Boolean(dur.hours() || dur.minutes() || dur.seconds() || dur.milliseconds());
	}
	exports.durationHasTime = durationHasTime;
	function isNativeDate(input) {
	    return Object.prototype.toString.call(input) === '[object Date]' || input instanceof Date;
	}
	exports.isNativeDate = isNativeDate;
	// Returns a boolean about whether the given input is a time string, like "06:40:00" or "06:00"
	function isTimeString(str) {
	    return typeof str === 'string' &&
	        /^\d+\:\d+(?:\:\d+\.?(?:\d{3})?)?$/.test(str);
	}
	exports.isTimeString = isTimeString;
	/* Logging and Debug
	----------------------------------------------------------------------------------------------------------------------*/
	function log() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var console = window.console;
	    if (console && console.log) {
	        return console.log.apply(console, args);
	    }
	}
	exports.log = log;
	function warn() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var console = window.console;
	    if (console && console.warn) {
	        return console.warn.apply(console, args);
	    }
	    else {
	        return log.apply(null, args);
	    }
	}
	exports.warn = warn;
	/* General Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	var hasOwnPropMethod = {}.hasOwnProperty;
	// Merges an array of objects into a single object.
	// The second argument allows for an array of property names who's object values will be merged together.
	function mergeProps(propObjs, complexProps) {
	    var dest = {};
	    var i;
	    var name;
	    var complexObjs;
	    var j;
	    var val;
	    var props;
	    if (complexProps) {
	        for (i = 0; i < complexProps.length; i++) {
	            name = complexProps[i];
	            complexObjs = [];
	            // collect the trailing object values, stopping when a non-object is discovered
	            for (j = propObjs.length - 1; j >= 0; j--) {
	                val = propObjs[j][name];
	                if (typeof val === 'object') {
	                    complexObjs.unshift(val);
	                }
	                else if (val !== undefined) {
	                    dest[name] = val; // if there were no objects, this value will be used
	                    break;
	                }
	            }
	            // if the trailing values were objects, use the merged value
	            if (complexObjs.length) {
	                dest[name] = mergeProps(complexObjs);
	            }
	        }
	    }
	    // copy values into the destination, going from last to first
	    for (i = propObjs.length - 1; i >= 0; i--) {
	        props = propObjs[i];
	        for (name in props) {
	            if (!(name in dest)) {
	                dest[name] = props[name];
	            }
	        }
	    }
	    return dest;
	}
	exports.mergeProps = mergeProps;
	function copyOwnProps(src, dest) {
	    for (var name_1 in src) {
	        if (hasOwnProp(src, name_1)) {
	            dest[name_1] = src[name_1];
	        }
	    }
	}
	exports.copyOwnProps = copyOwnProps;
	function hasOwnProp(obj, name) {
	    return hasOwnPropMethod.call(obj, name);
	}
	exports.hasOwnProp = hasOwnProp;
	function applyAll(functions, thisObj, args) {
	    if ($.isFunction(functions)) {
	        functions = [functions];
	    }
	    if (functions) {
	        var i = void 0;
	        var ret = void 0;
	        for (i = 0; i < functions.length; i++) {
	            ret = functions[i].apply(thisObj, args) || ret;
	        }
	        return ret;
	    }
	}
	exports.applyAll = applyAll;
	function removeMatching(array, testFunc) {
	    var removeCnt = 0;
	    var i = 0;
	    while (i < array.length) {
	        if (testFunc(array[i])) {
	            array.splice(i, 1);
	            removeCnt++;
	        }
	        else {
	            i++;
	        }
	    }
	    return removeCnt;
	}
	exports.removeMatching = removeMatching;
	function removeExact(array, exactVal) {
	    var removeCnt = 0;
	    var i = 0;
	    while (i < array.length) {
	        if (array[i] === exactVal) {
	            array.splice(i, 1);
	            removeCnt++;
	        }
	        else {
	            i++;
	        }
	    }
	    return removeCnt;
	}
	exports.removeExact = removeExact;
	function isArraysEqual(a0, a1) {
	    var len = a0.length;
	    var i;
	    if (len == null || len !== a1.length) {
	        return false;
	    }
	    for (i = 0; i < len; i++) {
	        if (a0[i] !== a1[i]) {
	            return false;
	        }
	    }
	    return true;
	}
	exports.isArraysEqual = isArraysEqual;
	function firstDefined() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    for (var i = 0; i < args.length; i++) {
	        if (args[i] !== undefined) {
	            return args[i];
	        }
	    }
	}
	exports.firstDefined = firstDefined;
	function htmlEscape(s) {
	    return (s + '').replace(/&/g, '&amp;')
	        .replace(/</g, '&lt;')
	        .replace(/>/g, '&gt;')
	        .replace(/'/g, '&#039;')
	        .replace(/"/g, '&quot;')
	        .replace(/\n/g, '<br />');
	}
	exports.htmlEscape = htmlEscape;
	function stripHtmlEntities(text) {
	    return text.replace(/&.*?;/g, '');
	}
	exports.stripHtmlEntities = stripHtmlEntities;
	// Given a hash of CSS properties, returns a string of CSS.
	// Uses property names as-is (no camel-case conversion). Will not make statements for null/undefined values.
	function cssToStr(cssProps) {
	    var statements = [];
	    $.each(cssProps, function (name, val) {
	        if (val != null) {
	            statements.push(name + ':' + val);
	        }
	    });
	    return statements.join(';');
	}
	exports.cssToStr = cssToStr;
	// Given an object hash of HTML attribute names to values,
	// generates a string that can be injected between < > in HTML
	function attrsToStr(attrs) {
	    var parts = [];
	    $.each(attrs, function (name, val) {
	        if (val != null) {
	            parts.push(name + '="' + htmlEscape(val) + '"');
	        }
	    });
	    return parts.join(' ');
	}
	exports.attrsToStr = attrsToStr;
	function capitaliseFirstLetter(str) {
	    return str.charAt(0).toUpperCase() + str.slice(1);
	}
	exports.capitaliseFirstLetter = capitaliseFirstLetter;
	function compareNumbers(a, b) {
	    return a - b;
	}
	exports.compareNumbers = compareNumbers;
	function isInt(n) {
	    return n % 1 === 0;
	}
	exports.isInt = isInt;
	// Returns a method bound to the given object context.
	// Just like one of the jQuery.proxy signatures, but without the undesired behavior of treating the same method with
	// different contexts as identical when binding/unbinding events.
	function proxy(obj, methodName) {
	    var method = obj[methodName];
	    return function () {
	        return method.apply(obj, arguments);
	    };
	}
	exports.proxy = proxy;
	// Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds. If `immediate` is passed, trigger the function on the
	// leading edge, instead of the trailing.
	// https://github.com/jashkenas/underscore/blob/1.6.0/underscore.js#L714
	function debounce(func, wait, immediate) {
	    if (immediate === void 0) { immediate = false; }
	    var timeout;
	    var args;
	    var context;
	    var timestamp;
	    var result;
	    var later = function () {
	        var last = +new Date() - timestamp;
	        if (last < wait) {
	            timeout = setTimeout(later, wait - last);
	        }
	        else {
	            timeout = null;
	            if (!immediate) {
	                result = func.apply(context, args);
	                context = args = null;
	            }
	        }
	    };
	    return function () {
	        context = this;
	        args = arguments;
	        timestamp = +new Date();
	        var callNow = immediate && !timeout;
	        if (!timeout) {
	            timeout = setTimeout(later, wait);
	        }
	        if (callNow) {
	            result = func.apply(context, args);
	            context = args = null;
	        }
	        return result;
	    };
	}
	exports.debounce = debounce;
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(0);
	var moment_ext_1 = __webpack_require__(10);
	var UnzonedRange = /** @class */ (function () {
	    function UnzonedRange(startInput, endInput) {
	        // TODO: move these into footprint.
	        // Especially, doesn't make sense for null startMs/endMs.
	        this.isStart = true;
	        this.isEnd = true;
	        if (moment.isMoment(startInput)) {
	            startInput = startInput.clone().stripZone();
	        }
	        if (moment.isMoment(endInput)) {
	            endInput = endInput.clone().stripZone();
	        }
	        if (startInput) {
	            this.startMs = startInput.valueOf();
	        }
	        if (endInput) {
	            this.endMs = endInput.valueOf();
	        }
	    }
	    /*
	    SIDEEFFECT: will mutate eventRanges.
	    Will return a new array result.
	    Only works for non-open-ended ranges.
	    */
	    UnzonedRange.invertRanges = function (ranges, constraintRange) {
	        var invertedRanges = [];
	        var startMs = constraintRange.startMs; // the end of the previous range. the start of the new range
	        var i;
	        var dateRange;
	        // ranges need to be in order. required for our date-walking algorithm
	        ranges.sort(compareUnzonedRanges);
	        for (i = 0; i < ranges.length; i++) {
	            dateRange = ranges[i];
	            // add the span of time before the event (if there is any)
	            if (dateRange.startMs > startMs) {
	                invertedRanges.push(new UnzonedRange(startMs, dateRange.startMs));
	            }
	            if (dateRange.endMs > startMs) {
	                startMs = dateRange.endMs;
	            }
	        }
	        // add the span of time after the last event (if there is any)
	        if (startMs < constraintRange.endMs) {
	            invertedRanges.push(new UnzonedRange(startMs, constraintRange.endMs));
	        }
	        return invertedRanges;
	    };
	    UnzonedRange.prototype.intersect = function (otherRange) {
	        var startMs = this.startMs;
	        var endMs = this.endMs;
	        var newRange = null;
	        if (otherRange.startMs != null) {
	            if (startMs == null) {
	                startMs = otherRange.startMs;
	            }
	            else {
	                startMs = Math.max(startMs, otherRange.startMs);
	            }
	        }
	        if (otherRange.endMs != null) {
	            if (endMs == null) {
	                endMs = otherRange.endMs;
	            }
	            else {
	                endMs = Math.min(endMs, otherRange.endMs);
	            }
	        }
	        if (startMs == null || endMs == null || startMs < endMs) {
	            newRange = new UnzonedRange(startMs, endMs);
	            newRange.isStart = this.isStart && startMs === this.startMs;
	            newRange.isEnd = this.isEnd && endMs === this.endMs;
	        }
	        return newRange;
	    };
	    UnzonedRange.prototype.intersectsWith = function (otherRange) {
	        return (this.endMs == null || otherRange.startMs == null || this.endMs > otherRange.startMs) &&
	            (this.startMs == null || otherRange.endMs == null || this.startMs < otherRange.endMs);
	    };
	    UnzonedRange.prototype.containsRange = function (innerRange) {
	        return (this.startMs == null || (innerRange.startMs != null && innerRange.startMs >= this.startMs)) &&
	            (this.endMs == null || (innerRange.endMs != null && innerRange.endMs <= this.endMs));
	    };
	    // `date` can be a moment, a Date, or a millisecond time.
	    UnzonedRange.prototype.containsDate = function (date) {
	        var ms = date.valueOf();
	        return (this.startMs == null || ms >= this.startMs) &&
	            (this.endMs == null || ms < this.endMs);
	    };
	    // If the given date is not within the given range, move it inside.
	    // (If it's past the end, make it one millisecond before the end).
	    // `date` can be a moment, a Date, or a millisecond time.
	    // Returns a MS-time.
	    UnzonedRange.prototype.constrainDate = function (date) {
	        var ms = date.valueOf();
	        if (this.startMs != null && ms < this.startMs) {
	            ms = this.startMs;
	        }
	        if (this.endMs != null && ms >= this.endMs) {
	            ms = this.endMs - 1;
	        }
	        return ms;
	    };
	    UnzonedRange.prototype.equals = function (otherRange) {
	        return this.startMs === otherRange.startMs && this.endMs === otherRange.endMs;
	    };
	    UnzonedRange.prototype.clone = function () {
	        var range = new UnzonedRange(this.startMs, this.endMs);
	        range.isStart = this.isStart;
	        range.isEnd = this.isEnd;
	        return range;
	    };
	    // Returns an ambig-zoned moment from startMs.
	    // BEWARE: returned moment is not localized.
	    // Formatting and start-of-week will be default.
	    UnzonedRange.prototype.getStart = function () {
	        if (this.startMs != null) {
	            return moment_ext_1.default.utc(this.startMs).stripZone();
	        }
	        return null;
	    };
	    // Returns an ambig-zoned moment from startMs.
	    // BEWARE: returned moment is not localized.
	    // Formatting and start-of-week will be default.
	    UnzonedRange.prototype.getEnd = function () {
	        if (this.endMs != null) {
	            return moment_ext_1.default.utc(this.endMs).stripZone();
	        }
	        return null;
	    };
	    UnzonedRange.prototype.as = function (unit) {
	        return moment.utc(this.endMs).diff(moment.utc(this.startMs), unit, true);
	    };
	    return UnzonedRange;
	}());
	exports.default = UnzonedRange;
	/*
	Only works for non-open-ended ranges.
	*/
	function compareUnzonedRanges(range1, range2) {
	    return range1.startMs - range2.startMs; // earlier ranges go first
	}
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var ParsableModelMixin_1 = __webpack_require__(208);
	var Class_1 = __webpack_require__(32);
	var EventDefParser_1 = __webpack_require__(49);
	var EventSource = /** @class */ (function (_super) {
	    tslib_1.__extends(EventSource, _super);
	    // can we do away with calendar? at least for the abstract?
	    // useful for buildEventDef
	    function EventSource(calendar) {
	        var _this = _super.call(this) || this;
	        _this.calendar = calendar;
	        _this.className = [];
	        _this.uid = String(EventSource.uuid++);
	        return _this;
	    }
	    /*
	    rawInput can be any data type!
	    */
	    EventSource.parse = function (rawInput, calendar) {
	        var source = new this(calendar);
	        if (typeof rawInput === 'object') {
	            if (source.applyProps(rawInput)) {
	                return source;
	            }
	        }
	        return false;
	    };
	    EventSource.normalizeId = function (id) {
	        if (id) {
	            return String(id);
	        }
	        return null;
	    };
	    EventSource.prototype.fetch = function (start, end, timezone) {
	        // subclasses must implement. must return a promise.
	    };
	    EventSource.prototype.removeEventDefsById = function (eventDefId) {
	        // optional for subclasses to implement
	    };
	    EventSource.prototype.removeAllEventDefs = function () {
	        // optional for subclasses to implement
	    };
	    /*
	    For compairing/matching
	    */
	    EventSource.prototype.getPrimitive = function (otherSource) {
	        // subclasses must implement
	    };
	    EventSource.prototype.parseEventDefs = function (rawEventDefs) {
	        var i;
	        var eventDef;
	        var eventDefs = [];
	        for (i = 0; i < rawEventDefs.length; i++) {
	            eventDef = this.parseEventDef(rawEventDefs[i]);
	            if (eventDef) {
	                eventDefs.push(eventDef);
	            }
	        }
	        return eventDefs;
	    };
	    EventSource.prototype.parseEventDef = function (rawInput) {
	        var calendarTransform = this.calendar.opt('eventDataTransform');
	        var sourceTransform = this.eventDataTransform;
	        if (calendarTransform) {
	            rawInput = calendarTransform(rawInput, this.calendar);
	        }
	        if (sourceTransform) {
	            rawInput = sourceTransform(rawInput, this.calendar);
	        }
	        return EventDefParser_1.default.parse(rawInput, this);
	    };
	    EventSource.prototype.applyManualStandardProps = function (rawProps) {
	        if (rawProps.id != null) {
	            this.id = EventSource.normalizeId(rawProps.id);
	        }
	        // TODO: converge with EventDef
	        if ($.isArray(rawProps.className)) {
	            this.className = rawProps.className;
	        }
	        else if (typeof rawProps.className === 'string') {
	            this.className = rawProps.className.split(/\s+/);
	        }
	        return true;
	    };
	    EventSource.uuid = 0;
	    EventSource.defineStandardProps = ParsableModelMixin_1.default.defineStandardProps;
	    EventSource.copyVerbatimStandardProps = ParsableModelMixin_1.default.copyVerbatimStandardProps;
	    return EventSource;
	}(Class_1.default));
	exports.default = EventSource;
	ParsableModelMixin_1.default.mixInto(EventSource);
	// Parsing
	// ---------------------------------------------------------------------------------------------------------------------
	EventSource.defineStandardProps({
	    // manually process...
	    id: false,
	    className: false,
	    // automatically transfer...
	    color: true,
	    backgroundColor: true,
	    borderColor: true,
	    textColor: true,
	    editable: true,
	    startEditable: true,
	    durationEditable: true,
	    rendering: true,
	    overlap: true,
	    constraint: true,
	    allDayDefault: true,
	    eventDataTransform: true
	});
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/*
	Utility methods for easily listening to events on another object,
	and more importantly, easily unlistening from them.
	
	USAGE:
	  import { default as ListenerMixin, ListenerInterface } from './ListenerMixin'
	in class:
	  listenTo: ListenerInterface['listenTo']
	  stopListeningTo: ListenerInterface['stopListeningTo']
	after class:
	  ListenerMixin.mixInto(TheClass)
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var Mixin_1 = __webpack_require__(14);
	var guid = 0;
	var ListenerMixin = /** @class */ (function (_super) {
	    tslib_1.__extends(ListenerMixin, _super);
	    function ListenerMixin() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /*
	    Given an `other` object that has on/off methods, bind the given `callback` to an event by the given name.
	    The `callback` will be called with the `this` context of the object that .listenTo is being called on.
	    Can be called:
	      .listenTo(other, eventName, callback)
	    OR
	      .listenTo(other, {
	        eventName1: callback1,
	        eventName2: callback2
	      })
	    */
	    ListenerMixin.prototype.listenTo = function (other, arg, callback) {
	        if (typeof arg === 'object') {
	            for (var eventName in arg) {
	                if (arg.hasOwnProperty(eventName)) {
	                    this.listenTo(other, eventName, arg[eventName]);
	                }
	            }
	        }
	        else if (typeof arg === 'string') {
	            other.on(arg + '.' + this.getListenerNamespace(), // use event namespacing to identify this object
	            $.proxy(callback, this) // always use `this` context
	            // the usually-undesired jQuery guid behavior doesn't matter,
	            // because we always unbind via namespace
	            );
	        }
	    };
	    /*
	    Causes the current object to stop listening to events on the `other` object.
	    `eventName` is optional. If omitted, will stop listening to ALL events on `other`.
	    */
	    ListenerMixin.prototype.stopListeningTo = function (other, eventName) {
	        other.off((eventName || '') + '.' + this.getListenerNamespace());
	    };
	    /*
	    Returns a string, unique to this object, to be used for event namespacing
	    */
	    ListenerMixin.prototype.getListenerNamespace = function () {
	        if (this.listenerId == null) {
	            this.listenerId = guid++;
	        }
	        return '_listener' + this.listenerId;
	    };
	    return ListenerMixin;
	}(Mixin_1.default));
	exports.default = ListenerMixin;
	
	
	/***/ }),
	/* 8 */,
	/* 9 */,
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(0);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var ambigDateOfMonthRegex = /^\s*\d{4}-\d\d$/;
	var ambigTimeOrZoneRegex = /^\s*\d{4}-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?)?$/;
	var newMomentProto = moment.fn; // where we will attach our new methods
	exports.newMomentProto = newMomentProto;
	var oldMomentProto = $.extend({}, newMomentProto); // copy of original moment methods
	exports.oldMomentProto = oldMomentProto;
	// tell momentjs to transfer these properties upon clone
	var momentProperties = moment.momentProperties;
	momentProperties.push('_fullCalendar');
	momentProperties.push('_ambigTime');
	momentProperties.push('_ambigZone');
	/*
	Call this if you want Moment's original format method to be used
	*/
	function oldMomentFormat(mom, formatStr) {
	    return oldMomentProto.format.call(mom, formatStr); // oldMomentProto defined in moment-ext.js
	}
	exports.oldMomentFormat = oldMomentFormat;
	// Creating
	// -------------------------------------------------------------------------------------------------
	// Creates a new moment, similar to the vanilla moment(...) constructor, but with
	// extra features (ambiguous time, enhanced formatting). When given an existing moment,
	// it will function as a clone (and retain the zone of the moment). Anything else will
	// result in a moment in the local zone.
	var momentExt = function () {
	    return makeMoment(arguments);
	};
	exports.default = momentExt;
	// Sames as momentExt, but forces the resulting moment to be in the UTC timezone.
	momentExt.utc = function () {
	    var mom = makeMoment(arguments, true);
	    // Force it into UTC because makeMoment doesn't guarantee it
	    // (if given a pre-existing moment for example)
	    if (mom.hasTime()) {
	        mom.utc();
	    }
	    return mom;
	};
	// Same as momentExt, but when given an ISO8601 string, the timezone offset is preserved.
	// ISO8601 strings with no timezone offset will become ambiguously zoned.
	momentExt.parseZone = function () {
	    return makeMoment(arguments, true, true);
	};
	// Builds an enhanced moment from args. When given an existing moment, it clones. When given a
	// native Date, or called with no arguments (the current time), the resulting moment will be local.
	// Anything else needs to be "parsed" (a string or an array), and will be affected by:
	//    parseAsUTC - if there is no zone information, should we parse the input in UTC?
	//    parseZone - if there is zone information, should we force the zone of the moment?
	function makeMoment(args, parseAsUTC, parseZone) {
	    if (parseAsUTC === void 0) { parseAsUTC = false; }
	    if (parseZone === void 0) { parseZone = false; }
	    var input = args[0];
	    var isSingleString = args.length === 1 && typeof input === 'string';
	    var isAmbigTime;
	    var isAmbigZone;
	    var ambigMatch;
	    var mom;
	    if (moment.isMoment(input) || util_1.isNativeDate(input) || input === undefined) {
	        mom = moment.apply(null, args);
	    }
	    else {
	        isAmbigTime = false;
	        isAmbigZone = false;
	        if (isSingleString) {
	            if (ambigDateOfMonthRegex.test(input)) {
	                // accept strings like '2014-05', but convert to the first of the month
	                input += '-01';
	                args = [input]; // for when we pass it on to moment's constructor
	                isAmbigTime = true;
	                isAmbigZone = true;
	            }
	            else if ((ambigMatch = ambigTimeOrZoneRegex.exec(input))) {
	                isAmbigTime = !ambigMatch[5]; // no time part?
	                isAmbigZone = true;
	            }
	        }
	        else if ($.isArray(input)) {
	            // arrays have no timezone information, so assume ambiguous zone
	            isAmbigZone = true;
	        }
	        // otherwise, probably a string with a format
	        if (parseAsUTC || isAmbigTime) {
	            mom = moment.utc.apply(moment, args);
	        }
	        else {
	            mom = moment.apply(null, args);
	        }
	        if (isAmbigTime) {
	            mom._ambigTime = true;
	            mom._ambigZone = true; // ambiguous time always means ambiguous zone
	        }
	        else if (parseZone) {
	            if (isAmbigZone) {
	                mom._ambigZone = true;
	            }
	            else if (isSingleString) {
	                mom.utcOffset(input); // if not a valid zone, will assign UTC
	            }
	        }
	    }
	    mom._fullCalendar = true; // flag for extended functionality
	    return mom;
	}
	// Week Number
	// -------------------------------------------------------------------------------------------------
	// Returns the week number, considering the locale's custom week number calcuation
	// `weeks` is an alias for `week`
	newMomentProto.week = newMomentProto.weeks = function (input) {
	    var weekCalc = this._locale._fullCalendar_weekCalc;
	    if (input == null && typeof weekCalc === 'function') {
	        return weekCalc(this);
	    }
	    else if (weekCalc === 'ISO') {
	        return oldMomentProto.isoWeek.apply(this, arguments); // ISO getter/setter
	    }
	    return oldMomentProto.week.apply(this, arguments); // local getter/setter
	};
	// Time-of-day
	// -------------------------------------------------------------------------------------------------
	// GETTER
	// Returns a Duration with the hours/minutes/seconds/ms values of the moment.
	// If the moment has an ambiguous time, a duration of 00:00 will be returned.
	//
	// SETTER
	// You can supply a Duration, a Moment, or a Duration-like argument.
	// When setting the time, and the moment has an ambiguous time, it then becomes unambiguous.
	newMomentProto.time = function (time) {
	    // Fallback to the original method (if there is one) if this moment wasn't created via FullCalendar.
	    // `time` is a generic enough method name where this precaution is necessary to avoid collisions w/ other plugins.
	    if (!this._fullCalendar) {
	        return oldMomentProto.time.apply(this, arguments);
	    }
	    if (time == null) {
	        return moment.duration({
	            hours: this.hours(),
	            minutes: this.minutes(),
	            seconds: this.seconds(),
	            milliseconds: this.milliseconds()
	        });
	    }
	    else {
	        this._ambigTime = false; // mark that the moment now has a time
	        if (!moment.isDuration(time) && !moment.isMoment(time)) {
	            time = moment.duration(time);
	        }
	        // The day value should cause overflow (so 24 hours becomes 00:00:00 of next day).
	        // Only for Duration times, not Moment times.
	        var dayHours = 0;
	        if (moment.isDuration(time)) {
	            dayHours = Math.floor(time.asDays()) * 24;
	        }
	        // We need to set the individual fields.
	        // Can't use startOf('day') then add duration. In case of DST at start of day.
	        return this.hours(dayHours + time.hours())
	            .minutes(time.minutes())
	            .seconds(time.seconds())
	            .milliseconds(time.milliseconds());
	    }
	};
	// Converts the moment to UTC, stripping out its time-of-day and timezone offset,
	// but preserving its YMD. A moment with a stripped time will display no time
	// nor timezone offset when .format() is called.
	newMomentProto.stripTime = function () {
	    if (!this._ambigTime) {
	        this.utc(true); // keepLocalTime=true (for keeping *date* value)
	        // set time to zero
	        this.set({
	            hours: 0,
	            minutes: 0,
	            seconds: 0,
	            ms: 0
	        });
	        // Mark the time as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
	        // which clears all ambig flags.
	        this._ambigTime = true;
	        this._ambigZone = true; // if ambiguous time, also ambiguous timezone offset
	    }
	    return this; // for chaining
	};
	// Returns if the moment has a non-ambiguous time (boolean)
	newMomentProto.hasTime = function () {
	    return !this._ambigTime;
	};
	// Timezone
	// -------------------------------------------------------------------------------------------------
	// Converts the moment to UTC, stripping out its timezone offset, but preserving its
	// YMD and time-of-day. A moment with a stripped timezone offset will display no
	// timezone offset when .format() is called.
	newMomentProto.stripZone = function () {
	    var wasAmbigTime;
	    if (!this._ambigZone) {
	        wasAmbigTime = this._ambigTime;
	        this.utc(true); // keepLocalTime=true (for keeping date and time values)
	        // the above call to .utc()/.utcOffset() unfortunately might clear the ambig flags, so restore
	        this._ambigTime = wasAmbigTime || false;
	        // Mark the zone as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
	        // which clears the ambig flags.
	        this._ambigZone = true;
	    }
	    return this; // for chaining
	};
	// Returns of the moment has a non-ambiguous timezone offset (boolean)
	newMomentProto.hasZone = function () {
	    return !this._ambigZone;
	};
	// implicitly marks a zone
	newMomentProto.local = function (keepLocalTime) {
	    // for when converting from ambiguously-zoned to local,
	    // keep the time values when converting from UTC -> local
	    oldMomentProto.local.call(this, this._ambigZone || keepLocalTime);
	    // ensure non-ambiguous
	    // this probably already happened via local() -> utcOffset(), but don't rely on Moment's internals
	    this._ambigTime = false;
	    this._ambigZone = false;
	    return this; // for chaining
	};
	// implicitly marks a zone
	newMomentProto.utc = function (keepLocalTime) {
	    oldMomentProto.utc.call(this, keepLocalTime);
	    // ensure non-ambiguous
	    // this probably already happened via utc() -> utcOffset(), but don't rely on Moment's internals
	    this._ambigTime = false;
	    this._ambigZone = false;
	    return this;
	};
	// implicitly marks a zone (will probably get called upon .utc() and .local())
	newMomentProto.utcOffset = function (tzo) {
	    if (tzo != null) {
	        // these assignments needs to happen before the original zone method is called.
	        // I forget why, something to do with a browser crash.
	        this._ambigTime = false;
	        this._ambigZone = false;
	    }
	    return oldMomentProto.utcOffset.apply(this, arguments);
	};
	
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/*
	USAGE:
	  import { default as EmitterMixin, EmitterInterface } from './EmitterMixin'
	in class:
	  on: EmitterInterface['on']
	  one: EmitterInterface['one']
	  off: EmitterInterface['off']
	  trigger: EmitterInterface['trigger']
	  triggerWith: EmitterInterface['triggerWith']
	  hasHandlers: EmitterInterface['hasHandlers']
	after class:
	  EmitterMixin.mixInto(TheClass)
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var Mixin_1 = __webpack_require__(14);
	var EmitterMixin = /** @class */ (function (_super) {
	    tslib_1.__extends(EmitterMixin, _super);
	    function EmitterMixin() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // jQuery-ification via $(this) allows a non-DOM object to have
	    // the same event handling capabilities (including namespaces).
	    EmitterMixin.prototype.on = function (types, handler) {
	        $(this).on(types, this._prepareIntercept(handler));
	        return this; // for chaining
	    };
	    EmitterMixin.prototype.one = function (types, handler) {
	        $(this).one(types, this._prepareIntercept(handler));
	        return this; // for chaining
	    };
	    EmitterMixin.prototype._prepareIntercept = function (handler) {
	        // handlers are always called with an "event" object as their first param.
	        // sneak the `this` context and arguments into the extra parameter object
	        // and forward them on to the original handler.
	        var intercept = function (ev, extra) {
	            return handler.apply(extra.context || this, extra.args || []);
	        };
	        // mimick jQuery's internal "proxy" system (risky, I know)
	        // causing all functions with the same .guid to appear to be the same.
	        // https://github.com/jquery/jquery/blob/2.2.4/src/core.js#L448
	        // this is needed for calling .off with the original non-intercept handler.
	        if (!handler.guid) {
	            handler.guid = $.guid++;
	        }
	        intercept.guid = handler.guid;
	        return intercept;
	    };
	    EmitterMixin.prototype.off = function (types, handler) {
	        $(this).off(types, handler);
	        return this; // for chaining
	    };
	    EmitterMixin.prototype.trigger = function (types) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        // pass in "extra" info to the intercept
	        $(this).triggerHandler(types, { args: args });
	        return this; // for chaining
	    };
	    EmitterMixin.prototype.triggerWith = function (types, context, args) {
	        // `triggerHandler` is less reliant on the DOM compared to `trigger`.
	        // pass in "extra" info to the intercept.
	        $(this).triggerHandler(types, { context: context, args: args });
	        return this; // for chaining
	    };
	    EmitterMixin.prototype.hasHandlers = function (type) {
	        var hash = $._data(this, 'events'); // http://blog.jquery.com/2012/08/09/jquery-1-8-released/
	        return hash && hash[type] && hash[type].length > 0;
	    };
	    return EmitterMixin;
	}(Mixin_1.default));
	exports.default = EmitterMixin;
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	Meant to be immutable
	*/
	var ComponentFootprint = /** @class */ (function () {
	    function ComponentFootprint(unzonedRange, isAllDay) {
	        this.isAllDay = false; // component can choose to ignore this
	        this.unzonedRange = unzonedRange;
	        this.isAllDay = isAllDay;
	    }
	    /*
	    Only works for non-open-ended ranges.
	    */
	    ComponentFootprint.prototype.toLegacy = function (calendar) {
	        return {
	            start: calendar.msToMoment(this.unzonedRange.startMs, this.isAllDay),
	            end: calendar.msToMoment(this.unzonedRange.endMs, this.isAllDay)
	        };
	    };
	    return ComponentFootprint;
	}());
	exports.default = ComponentFootprint;
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var EventDef_1 = __webpack_require__(33);
	var EventInstance_1 = __webpack_require__(209);
	var EventDateProfile_1 = __webpack_require__(17);
	var SingleEventDef = /** @class */ (function (_super) {
	    tslib_1.__extends(SingleEventDef, _super);
	    function SingleEventDef() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /*
	    Will receive start/end params, but will be ignored.
	    */
	    SingleEventDef.prototype.buildInstances = function () {
	        return [this.buildInstance()];
	    };
	    SingleEventDef.prototype.buildInstance = function () {
	        return new EventInstance_1.default(this, // definition
	        this.dateProfile);
	    };
	    SingleEventDef.prototype.isAllDay = function () {
	        return this.dateProfile.isAllDay();
	    };
	    SingleEventDef.prototype.clone = function () {
	        var def = _super.prototype.clone.call(this);
	        def.dateProfile = this.dateProfile;
	        return def;
	    };
	    SingleEventDef.prototype.rezone = function () {
	        var calendar = this.source.calendar;
	        var dateProfile = this.dateProfile;
	        this.dateProfile = new EventDateProfile_1.default(calendar.moment(dateProfile.start), dateProfile.end ? calendar.moment(dateProfile.end) : null, calendar);
	    };
	    /*
	    NOTE: if super-method fails, should still attempt to apply
	    */
	    SingleEventDef.prototype.applyManualStandardProps = function (rawProps) {
	        var superSuccess = _super.prototype.applyManualStandardProps.call(this, rawProps);
	        var dateProfile = EventDateProfile_1.default.parse(rawProps, this.source); // returns null on failure
	        if (dateProfile) {
	            this.dateProfile = dateProfile;
	            // make sure `date` shows up in the legacy event objects as-is
	            if (rawProps.date != null) {
	                this.miscProps.date = rawProps.date;
	            }
	            return superSuccess;
	        }
	        else {
	            return false;
	        }
	    };
	    return SingleEventDef;
	}(EventDef_1.default));
	exports.default = SingleEventDef;
	// Parsing
	// ---------------------------------------------------------------------------------------------------------------------
	SingleEventDef.defineStandardProps({
	    start: false,
	    date: false,
	    end: false,
	    allDay: false
	});
	
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Mixin = /** @class */ (function () {
	    function Mixin() {
	    }
	    Mixin.mixInto = function (destClass) {
	        var _this = this;
	        Object.getOwnPropertyNames(this.prototype).forEach(function (name) {
	            if (!destClass.prototype[name]) {
	                destClass.prototype[name] = _this.prototype[name];
	            }
	        });
	    };
	    /*
	    will override existing methods
	    TODO: remove! not used anymore
	    */
	    Mixin.mixOver = function (destClass) {
	        var _this = this;
	        Object.getOwnPropertyNames(this.prototype).forEach(function (name) {
	            destClass.prototype[name] = _this.prototype[name];
	        });
	    };
	    return Mixin;
	}());
	exports.default = Mixin;
	
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Interaction = /** @class */ (function () {
	    function Interaction(component) {
	        this.view = component._getView();
	        this.component = component;
	    }
	    Interaction.prototype.opt = function (name) {
	        return this.view.opt(name);
	    };
	    Interaction.prototype.end = function () {
	        // subclasses can implement
	    };
	    return Interaction;
	}());
	exports.default = Interaction;
	
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.version = '3.8.2';
	// When introducing internal API incompatibilities (where fullcalendar plugins would break),
	// the minor version of the calendar should be upped (ex: 2.7.2 -> 2.8.0)
	// and the below integer should be incremented.
	exports.internalApiVersion = 12;
	var util_1 = __webpack_require__(4);
	exports.applyAll = util_1.applyAll;
	exports.debounce = util_1.debounce;
	exports.isInt = util_1.isInt;
	exports.htmlEscape = util_1.htmlEscape;
	exports.cssToStr = util_1.cssToStr;
	exports.proxy = util_1.proxy;
	exports.capitaliseFirstLetter = util_1.capitaliseFirstLetter;
	exports.getOuterRect = util_1.getOuterRect;
	exports.getClientRect = util_1.getClientRect;
	exports.getContentRect = util_1.getContentRect;
	exports.getScrollbarWidths = util_1.getScrollbarWidths;
	exports.preventDefault = util_1.preventDefault;
	exports.parseFieldSpecs = util_1.parseFieldSpecs;
	exports.compareByFieldSpecs = util_1.compareByFieldSpecs;
	exports.compareByFieldSpec = util_1.compareByFieldSpec;
	exports.flexibleCompare = util_1.flexibleCompare;
	exports.computeGreatestUnit = util_1.computeGreatestUnit;
	exports.divideRangeByDuration = util_1.divideRangeByDuration;
	exports.divideDurationByDuration = util_1.divideDurationByDuration;
	exports.multiplyDuration = util_1.multiplyDuration;
	exports.durationHasTime = util_1.durationHasTime;
	exports.log = util_1.log;
	exports.warn = util_1.warn;
	exports.removeExact = util_1.removeExact;
	exports.intersectRects = util_1.intersectRects;
	var date_formatting_1 = __webpack_require__(47);
	exports.formatDate = date_formatting_1.formatDate;
	exports.formatRange = date_formatting_1.formatRange;
	exports.queryMostGranularFormatUnit = date_formatting_1.queryMostGranularFormatUnit;
	var locale_1 = __webpack_require__(30);
	exports.datepickerLocale = locale_1.datepickerLocale;
	exports.locale = locale_1.locale;
	var moment_ext_1 = __webpack_require__(10);
	exports.moment = moment_ext_1.default;
	var EmitterMixin_1 = __webpack_require__(11);
	exports.EmitterMixin = EmitterMixin_1.default;
	var ListenerMixin_1 = __webpack_require__(7);
	exports.ListenerMixin = ListenerMixin_1.default;
	var Model_1 = __webpack_require__(48);
	exports.Model = Model_1.default;
	var Constraints_1 = __webpack_require__(207);
	exports.Constraints = Constraints_1.default;
	var UnzonedRange_1 = __webpack_require__(5);
	exports.UnzonedRange = UnzonedRange_1.default;
	var ComponentFootprint_1 = __webpack_require__(12);
	exports.ComponentFootprint = ComponentFootprint_1.default;
	var BusinessHourGenerator_1 = __webpack_require__(212);
	exports.BusinessHourGenerator = BusinessHourGenerator_1.default;
	var EventDef_1 = __webpack_require__(33);
	exports.EventDef = EventDef_1.default;
	var EventDefMutation_1 = __webpack_require__(36);
	exports.EventDefMutation = EventDefMutation_1.default;
	var EventSourceParser_1 = __webpack_require__(37);
	exports.EventSourceParser = EventSourceParser_1.default;
	var EventSource_1 = __webpack_require__(6);
	exports.EventSource = EventSource_1.default;
	var ThemeRegistry_1 = __webpack_require__(51);
	exports.defineThemeSystem = ThemeRegistry_1.defineThemeSystem;
	var EventInstanceGroup_1 = __webpack_require__(18);
	exports.EventInstanceGroup = EventInstanceGroup_1.default;
	var ArrayEventSource_1 = __webpack_require__(52);
	exports.ArrayEventSource = ArrayEventSource_1.default;
	var FuncEventSource_1 = __webpack_require__(215);
	exports.FuncEventSource = FuncEventSource_1.default;
	var JsonFeedEventSource_1 = __webpack_require__(216);
	exports.JsonFeedEventSource = JsonFeedEventSource_1.default;
	var EventFootprint_1 = __webpack_require__(35);
	exports.EventFootprint = EventFootprint_1.default;
	var Class_1 = __webpack_require__(32);
	exports.Class = Class_1.default;
	var Mixin_1 = __webpack_require__(14);
	exports.Mixin = Mixin_1.default;
	var CoordCache_1 = __webpack_require__(53);
	exports.CoordCache = CoordCache_1.default;
	var DragListener_1 = __webpack_require__(54);
	exports.DragListener = DragListener_1.default;
	var Promise_1 = __webpack_require__(19);
	exports.Promise = Promise_1.default;
	var TaskQueue_1 = __webpack_require__(217);
	exports.TaskQueue = TaskQueue_1.default;
	var RenderQueue_1 = __webpack_require__(218);
	exports.RenderQueue = RenderQueue_1.default;
	var Scroller_1 = __webpack_require__(39);
	exports.Scroller = Scroller_1.default;
	var Theme_1 = __webpack_require__(38);
	exports.Theme = Theme_1.default;
	var DateComponent_1 = __webpack_require__(219);
	exports.DateComponent = DateComponent_1.default;
	var InteractiveDateComponent_1 = __webpack_require__(40);
	exports.InteractiveDateComponent = InteractiveDateComponent_1.default;
	var Calendar_1 = __webpack_require__(220);
	exports.Calendar = Calendar_1.default;
	var View_1 = __webpack_require__(41);
	exports.View = View_1.default;
	var ViewRegistry_1 = __webpack_require__(21);
	exports.defineView = ViewRegistry_1.defineView;
	exports.getViewConfig = ViewRegistry_1.getViewConfig;
	var DayTableMixin_1 = __webpack_require__(55);
	exports.DayTableMixin = DayTableMixin_1.default;
	var BusinessHourRenderer_1 = __webpack_require__(56);
	exports.BusinessHourRenderer = BusinessHourRenderer_1.default;
	var EventRenderer_1 = __webpack_require__(42);
	exports.EventRenderer = EventRenderer_1.default;
	var FillRenderer_1 = __webpack_require__(57);
	exports.FillRenderer = FillRenderer_1.default;
	var HelperRenderer_1 = __webpack_require__(58);
	exports.HelperRenderer = HelperRenderer_1.default;
	var ExternalDropping_1 = __webpack_require__(222);
	exports.ExternalDropping = ExternalDropping_1.default;
	var EventResizing_1 = __webpack_require__(223);
	exports.EventResizing = EventResizing_1.default;
	var EventPointing_1 = __webpack_require__(59);
	exports.EventPointing = EventPointing_1.default;
	var EventDragging_1 = __webpack_require__(224);
	exports.EventDragging = EventDragging_1.default;
	var DateSelecting_1 = __webpack_require__(225);
	exports.DateSelecting = DateSelecting_1.default;
	var StandardInteractionsMixin_1 = __webpack_require__(60);
	exports.StandardInteractionsMixin = StandardInteractionsMixin_1.default;
	var AgendaView_1 = __webpack_require__(226);
	exports.AgendaView = AgendaView_1.default;
	var TimeGrid_1 = __webpack_require__(227);
	exports.TimeGrid = TimeGrid_1.default;
	var DayGrid_1 = __webpack_require__(61);
	exports.DayGrid = DayGrid_1.default;
	var BasicView_1 = __webpack_require__(62);
	exports.BasicView = BasicView_1.default;
	var MonthView_1 = __webpack_require__(229);
	exports.MonthView = MonthView_1.default;
	var ListView_1 = __webpack_require__(230);
	exports.ListView = ListView_1.default;
	
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var UnzonedRange_1 = __webpack_require__(5);
	/*
	Meant to be immutable
	*/
	var EventDateProfile = /** @class */ (function () {
	    function EventDateProfile(start, end, calendar) {
	        this.start = start;
	        this.end = end || null;
	        this.unzonedRange = this.buildUnzonedRange(calendar);
	    }
	    /*
	    Needs an EventSource object
	    */
	    EventDateProfile.parse = function (rawProps, source) {
	        var startInput = rawProps.start || rawProps.date;
	        var endInput = rawProps.end;
	        if (!startInput) {
	            return false;
	        }
	        var calendar = source.calendar;
	        var start = calendar.moment(startInput);
	        var end = endInput ? calendar.moment(endInput) : null;
	        var forcedAllDay = rawProps.allDay;
	        var forceEventDuration = calendar.opt('forceEventDuration');
	        if (!start.isValid()) {
	            return false;
	        }
	        if (end && (!end.isValid() || !end.isAfter(start))) {
	            end = null;
	        }
	        if (forcedAllDay == null) {
	            forcedAllDay = source.allDayDefault;
	            if (forcedAllDay == null) {
	                forcedAllDay = calendar.opt('allDayDefault');
	            }
	        }
	        if (forcedAllDay === true) {
	            start.stripTime();
	            if (end) {
	                end.stripTime();
	            }
	        }
	        else if (forcedAllDay === false) {
	            if (!start.hasTime()) {
	                start.time(0);
	            }
	            if (end && !end.hasTime()) {
	                end.time(0);
	            }
	        }
	        if (!end && forceEventDuration) {
	            end = calendar.getDefaultEventEnd(!start.hasTime(), start);
	        }
	        return new EventDateProfile(start, end, calendar);
	    };
	    EventDateProfile.isStandardProp = function (propName) {
	        return propName === 'start' || propName === 'date' || propName === 'end' || propName === 'allDay';
	    };
	    EventDateProfile.prototype.isAllDay = function () {
	        return !(this.start.hasTime() || (this.end && this.end.hasTime()));
	    };
	    /*
	    Needs a Calendar object
	    */
	    EventDateProfile.prototype.buildUnzonedRange = function (calendar) {
	        var startMs = this.start.clone().stripZone().valueOf();
	        var endMs = this.getEnd(calendar).stripZone().valueOf();
	        return new UnzonedRange_1.default(startMs, endMs);
	    };
	    /*
	    Needs a Calendar object
	    */
	    EventDateProfile.prototype.getEnd = function (calendar) {
	        return this.end ?
	            this.end.clone() :
	            // derive the end from the start and allDay. compute allDay if necessary
	            calendar.getDefaultEventEnd(this.isAllDay(), this.start);
	    };
	    return EventDateProfile;
	}());
	exports.default = EventDateProfile;
	
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var UnzonedRange_1 = __webpack_require__(5);
	var util_1 = __webpack_require__(34);
	var EventRange_1 = __webpack_require__(211);
	/*
	It's expected that there will be at least one EventInstance,
	OR that an explicitEventDef is assigned.
	*/
	var EventInstanceGroup = /** @class */ (function () {
	    function EventInstanceGroup(eventInstances) {
	        this.eventInstances = eventInstances || [];
	    }
	    EventInstanceGroup.prototype.getAllEventRanges = function (constraintRange) {
	        if (constraintRange) {
	            return this.sliceNormalRenderRanges(constraintRange);
	        }
	        else {
	            return this.eventInstances.map(util_1.eventInstanceToEventRange);
	        }
	    };
	    EventInstanceGroup.prototype.sliceRenderRanges = function (constraintRange) {
	        if (this.isInverse()) {
	            return this.sliceInverseRenderRanges(constraintRange);
	        }
	        else {
	            return this.sliceNormalRenderRanges(constraintRange);
	        }
	    };
	    EventInstanceGroup.prototype.sliceNormalRenderRanges = function (constraintRange) {
	        var eventInstances = this.eventInstances;
	        var i;
	        var eventInstance;
	        var slicedRange;
	        var slicedEventRanges = [];
	        for (i = 0; i < eventInstances.length; i++) {
	            eventInstance = eventInstances[i];
	            slicedRange = eventInstance.dateProfile.unzonedRange.intersect(constraintRange);
	            if (slicedRange) {
	                slicedEventRanges.push(new EventRange_1.default(slicedRange, eventInstance.def, eventInstance));
	            }
	        }
	        return slicedEventRanges;
	    };
	    EventInstanceGroup.prototype.sliceInverseRenderRanges = function (constraintRange) {
	        var unzonedRanges = this.eventInstances.map(util_1.eventInstanceToUnzonedRange);
	        var ownerDef = this.getEventDef();
	        unzonedRanges = UnzonedRange_1.default.invertRanges(unzonedRanges, constraintRange);
	        return unzonedRanges.map(function (unzonedRange) {
	            return new EventRange_1.default(unzonedRange, ownerDef); // don't give an EventInstance
	        });
	    };
	    EventInstanceGroup.prototype.isInverse = function () {
	        return this.getEventDef().hasInverseRendering();
	    };
	    EventInstanceGroup.prototype.getEventDef = function () {
	        return this.explicitEventDef || this.eventInstances[0].def;
	    };
	    return EventInstanceGroup;
	}());
	exports.default = EventInstanceGroup;
	
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var PromiseStub = {
	    construct: function (executor) {
	        var deferred = $.Deferred();
	        var promise = deferred.promise();
	        if (typeof executor === 'function') {
	            executor(function (val) {
	                deferred.resolve(val);
	                attachImmediatelyResolvingThen(promise, val);
	            }, function () {
	                deferred.reject();
	                attachImmediatelyRejectingThen(promise);
	            });
	        }
	        return promise;
	    },
	    resolve: function (val) {
	        var deferred = $.Deferred().resolve(val);
	        var promise = deferred.promise();
	        attachImmediatelyResolvingThen(promise, val);
	        return promise;
	    },
	    reject: function () {
	        var deferred = $.Deferred().reject();
	        var promise = deferred.promise();
	        attachImmediatelyRejectingThen(promise);
	        return promise;
	    }
	};
	exports.default = PromiseStub;
	function attachImmediatelyResolvingThen(promise, val) {
	    promise.then = function (onResolve) {
	        if (typeof onResolve === 'function') {
	            return PromiseStub.resolve(onResolve(val));
	        }
	        return promise;
	    };
	}
	function attachImmediatelyRejectingThen(promise) {
	    promise.then = function (onResolve, onReject) {
	        if (typeof onReject === 'function') {
	            onReject();
	        }
	        return promise;
	    };
	}
	
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var exportHooks = __webpack_require__(16);
	var EmitterMixin_1 = __webpack_require__(11);
	var ListenerMixin_1 = __webpack_require__(7);
	exportHooks.touchMouseIgnoreWait = 500;
	var globalEmitter = null;
	var neededCount = 0;
	/*
	Listens to document and window-level user-interaction events, like touch events and mouse events,
	and fires these events as-is to whoever is observing a GlobalEmitter.
	Best when used as a singleton via GlobalEmitter.get()
	
	Normalizes mouse/touch events. For examples:
	- ignores the the simulated mouse events that happen after a quick tap: mousemove+mousedown+mouseup+click
	- compensates for various buggy scenarios where a touchend does not fire
	*/
	var GlobalEmitter = /** @class */ (function () {
	    function GlobalEmitter() {
	        this.isTouching = false;
	        this.mouseIgnoreDepth = 0;
	    }
	    // gets the singleton
	    GlobalEmitter.get = function () {
	        if (!globalEmitter) {
	            globalEmitter = new GlobalEmitter();
	            globalEmitter.bind();
	        }
	        return globalEmitter;
	    };
	    // called when an object knows it will need a GlobalEmitter in the near future.
	    GlobalEmitter.needed = function () {
	        GlobalEmitter.get(); // ensures globalEmitter
	        neededCount++;
	    };
	    // called when the object that originally called needed() doesn't need a GlobalEmitter anymore.
	    GlobalEmitter.unneeded = function () {
	        neededCount--;
	        if (!neededCount) {
	            globalEmitter.unbind();
	            globalEmitter = null;
	        }
	    };
	    GlobalEmitter.prototype.bind = function () {
	        var _this = this;
	        this.listenTo($(document), {
	            touchstart: this.handleTouchStart,
	            touchcancel: this.handleTouchCancel,
	            touchend: this.handleTouchEnd,
	            mousedown: this.handleMouseDown,
	            mousemove: this.handleMouseMove,
	            mouseup: this.handleMouseUp,
	            click: this.handleClick,
	            selectstart: this.handleSelectStart,
	            contextmenu: this.handleContextMenu
	        });
	        // because we need to call preventDefault
	        // because https://www.chromestatus.com/features/5093566007214080
	        // TODO: investigate performance because this is a global handler
	        window.addEventListener('touchmove', this.handleTouchMoveProxy = function (ev) {
	            _this.handleTouchMove($.Event(ev));
	        }, { passive: false } // allows preventDefault()
	        );
	        // attach a handler to get called when ANY scroll action happens on the page.
	        // this was impossible to do with normal on/off because 'scroll' doesn't bubble.
	        // http://stackoverflow.com/a/32954565/96342
	        window.addEventListener('scroll', this.handleScrollProxy = function (ev) {
	            _this.handleScroll($.Event(ev));
	        }, true // useCapture
	        );
	    };
	    GlobalEmitter.prototype.unbind = function () {
	        this.stopListeningTo($(document));
	        window.removeEventListener('touchmove', this.handleTouchMoveProxy);
	        window.removeEventListener('scroll', this.handleScrollProxy, true // useCapture
	        );
	    };
	    // Touch Handlers
	    // -----------------------------------------------------------------------------------------------------------------
	    GlobalEmitter.prototype.handleTouchStart = function (ev) {
	        // if a previous touch interaction never ended with a touchend, then implicitly end it,
	        // but since a new touch interaction is about to begin, don't start the mouse ignore period.
	        this.stopTouch(ev, true); // skipMouseIgnore=true
	        this.isTouching = true;
	        this.trigger('touchstart', ev);
	    };
	    GlobalEmitter.prototype.handleTouchMove = function (ev) {
	        if (this.isTouching) {
	            this.trigger('touchmove', ev);
	        }
	    };
	    GlobalEmitter.prototype.handleTouchCancel = function (ev) {
	        if (this.isTouching) {
	            this.trigger('touchcancel', ev);
	            // Have touchcancel fire an artificial touchend. That way, handlers won't need to listen to both.
	            // If touchend fires later, it won't have any effect b/c isTouching will be false.
	            this.stopTouch(ev);
	        }
	    };
	    GlobalEmitter.prototype.handleTouchEnd = function (ev) {
	        this.stopTouch(ev);
	    };
	    // Mouse Handlers
	    // -----------------------------------------------------------------------------------------------------------------
	    GlobalEmitter.prototype.handleMouseDown = function (ev) {
	        if (!this.shouldIgnoreMouse()) {
	            this.trigger('mousedown', ev);
	        }
	    };
	    GlobalEmitter.prototype.handleMouseMove = function (ev) {
	        if (!this.shouldIgnoreMouse()) {
	            this.trigger('mousemove', ev);
	        }
	    };
	    GlobalEmitter.prototype.handleMouseUp = function (ev) {
	        if (!this.shouldIgnoreMouse()) {
	            this.trigger('mouseup', ev);
	        }
	    };
	    GlobalEmitter.prototype.handleClick = function (ev) {
	        if (!this.shouldIgnoreMouse()) {
	            this.trigger('click', ev);
	        }
	    };
	    // Misc Handlers
	    // -----------------------------------------------------------------------------------------------------------------
	    GlobalEmitter.prototype.handleSelectStart = function (ev) {
	        this.trigger('selectstart', ev);
	    };
	    GlobalEmitter.prototype.handleContextMenu = function (ev) {
	        this.trigger('contextmenu', ev);
	    };
	    GlobalEmitter.prototype.handleScroll = function (ev) {
	        this.trigger('scroll', ev);
	    };
	    // Utils
	    // -----------------------------------------------------------------------------------------------------------------
	    GlobalEmitter.prototype.stopTouch = function (ev, skipMouseIgnore) {
	        if (skipMouseIgnore === void 0) { skipMouseIgnore = false; }
	        if (this.isTouching) {
	            this.isTouching = false;
	            this.trigger('touchend', ev);
	            if (!skipMouseIgnore) {
	                this.startTouchMouseIgnore();
	            }
	        }
	    };
	    GlobalEmitter.prototype.startTouchMouseIgnore = function () {
	        var _this = this;
	        var wait = exportHooks.touchMouseIgnoreWait;
	        if (wait) {
	            this.mouseIgnoreDepth++;
	            setTimeout(function () {
	                _this.mouseIgnoreDepth--;
	            }, wait);
	        }
	    };
	    GlobalEmitter.prototype.shouldIgnoreMouse = function () {
	        return this.isTouching || Boolean(this.mouseIgnoreDepth);
	    };
	    return GlobalEmitter;
	}());
	exports.default = GlobalEmitter;
	ListenerMixin_1.default.mixInto(GlobalEmitter);
	EmitterMixin_1.default.mixInto(GlobalEmitter);
	
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var exportHooks = __webpack_require__(16);
	exports.viewHash = {};
	exportHooks.views = exports.viewHash;
	function defineView(viewName, viewConfig) {
	    exports.viewHash[viewName] = viewConfig;
	}
	exports.defineView = defineView;
	function getViewConfig(viewName) {
	    return exports.viewHash[viewName];
	}
	exports.getViewConfig = getViewConfig;
	
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var util_1 = __webpack_require__(4);
	var DragListener_1 = __webpack_require__(54);
	/* Tracks mouse movements over a component and raises events about which hit the mouse is over.
	------------------------------------------------------------------------------------------------------------------------
	options:
	- subjectEl
	- subjectCenter
	*/
	var HitDragListener = /** @class */ (function (_super) {
	    tslib_1.__extends(HitDragListener, _super);
	    function HitDragListener(component, options) {
	        var _this = _super.call(this, options) || this;
	        _this.component = component;
	        return _this;
	    }
	    // Called when drag listening starts (but a real drag has not necessarily began).
	    // ev might be undefined if dragging was started manually.
	    HitDragListener.prototype.handleInteractionStart = function (ev) {
	        var subjectEl = this.subjectEl;
	        var subjectRect;
	        var origPoint;
	        var point;
	        this.component.hitsNeeded();
	        this.computeScrollBounds(); // for autoscroll
	        if (ev) {
	            origPoint = { left: util_1.getEvX(ev), top: util_1.getEvY(ev) };
	            point = origPoint;
	            // constrain the point to bounds of the element being dragged
	            if (subjectEl) {
	                subjectRect = util_1.getOuterRect(subjectEl); // used for centering as well
	                point = util_1.constrainPoint(point, subjectRect);
	            }
	            this.origHit = this.queryHit(point.left, point.top);
	            // treat the center of the subject as the collision point?
	            if (subjectEl && this.options.subjectCenter) {
	                // only consider the area the subject overlaps the hit. best for large subjects.
	                // TODO: skip this if hit didn't supply left/right/top/bottom
	                if (this.origHit) {
	                    subjectRect = util_1.intersectRects(this.origHit, subjectRect) ||
	                        subjectRect; // in case there is no intersection
	                }
	                point = util_1.getRectCenter(subjectRect);
	            }
	            this.coordAdjust = util_1.diffPoints(point, origPoint); // point - origPoint
	        }
	        else {
	            this.origHit = null;
	            this.coordAdjust = null;
	        }
	        // call the super-method. do it after origHit has been computed
	        _super.prototype.handleInteractionStart.call(this, ev);
	    };
	    // Called when the actual drag has started
	    HitDragListener.prototype.handleDragStart = function (ev) {
	        var hit;
	        _super.prototype.handleDragStart.call(this, ev);
	        // might be different from this.origHit if the min-distance is large
	        hit = this.queryHit(util_1.getEvX(ev), util_1.getEvY(ev));
	        // report the initial hit the mouse is over
	        // especially important if no min-distance and drag starts immediately
	        if (hit) {
	            this.handleHitOver(hit);
	        }
	    };
	    // Called when the drag moves
	    HitDragListener.prototype.handleDrag = function (dx, dy, ev) {
	        var hit;
	        _super.prototype.handleDrag.call(this, dx, dy, ev);
	        hit = this.queryHit(util_1.getEvX(ev), util_1.getEvY(ev));
	        if (!isHitsEqual(hit, this.hit)) {
	            if (this.hit) {
	                this.handleHitOut();
	            }
	            if (hit) {
	                this.handleHitOver(hit);
	            }
	        }
	    };
	    // Called when dragging has been stopped
	    HitDragListener.prototype.handleDragEnd = function (ev) {
	        this.handleHitDone();
	        _super.prototype.handleDragEnd.call(this, ev);
	    };
	    // Called when a the mouse has just moved over a new hit
	    HitDragListener.prototype.handleHitOver = function (hit) {
	        var isOrig = isHitsEqual(hit, this.origHit);
	        this.hit = hit;
	        this.trigger('hitOver', this.hit, isOrig, this.origHit);
	    };
	    // Called when the mouse has just moved out of a hit
	    HitDragListener.prototype.handleHitOut = function () {
	        if (this.hit) {
	            this.trigger('hitOut', this.hit);
	            this.handleHitDone();
	            this.hit = null;
	        }
	    };
	    // Called after a hitOut. Also called before a dragStop
	    HitDragListener.prototype.handleHitDone = function () {
	        if (this.hit) {
	            this.trigger('hitDone', this.hit);
	        }
	    };
	    // Called when the interaction ends, whether there was a real drag or not
	    HitDragListener.prototype.handleInteractionEnd = function (ev, isCancelled) {
	        _super.prototype.handleInteractionEnd.call(this, ev, isCancelled);
	        this.origHit = null;
	        this.hit = null;
	        this.component.hitsNotNeeded();
	    };
	    // Called when scrolling has stopped, whether through auto scroll, or the user scrolling
	    HitDragListener.prototype.handleScrollEnd = function () {
	        _super.prototype.handleScrollEnd.call(this);
	        // hits' absolute positions will be in new places after a user's scroll.
	        // HACK for recomputing.
	        if (this.isDragging) {
	            this.component.releaseHits();
	            this.component.prepareHits();
	        }
	    };
	    // Gets the hit underneath the coordinates for the given mouse event
	    HitDragListener.prototype.queryHit = function (left, top) {
	        if (this.coordAdjust) {
	            left += this.coordAdjust.left;
	            top += this.coordAdjust.top;
	        }
	        return this.component.queryHit(left, top);
	    };
	    return HitDragListener;
	}(DragListener_1.default));
	exports.default = HitDragListener;
	// Returns `true` if the hits are identically equal. `false` otherwise. Must be from the same component.
	// Two null values will be considered equal, as two "out of the component" states are the same.
	function isHitsEqual(hit0, hit1) {
	    if (!hit0 && !hit1) {
	        return true;
	    }
	    if (hit0 && hit1) {
	        return hit0.component === hit1.component &&
	            isHitPropsWithin(hit0, hit1) &&
	            isHitPropsWithin(hit1, hit0); // ensures all props are identical
	    }
	    return false;
	}
	// Returns true if all of subHit's non-standard properties are within superHit
	function isHitPropsWithin(subHit, superHit) {
	    for (var propName in subHit) {
	        if (!/^(component|left|right|top|bottom)$/.test(propName)) {
	            if (subHit[propName] !== superHit[propName]) {
	                return false;
	            }
	        }
	    }
	    return true;
	}
	
	
	/***/ }),
	/* 23 */,
	/* 24 */,
	/* 25 */,
	/* 26 */,
	/* 27 */,
	/* 28 */,
	/* 29 */,
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var moment = __webpack_require__(0);
	var exportHooks = __webpack_require__(16);
	var options_1 = __webpack_require__(31);
	var util_1 = __webpack_require__(4);
	exports.localeOptionHash = {};
	exportHooks.locales = exports.localeOptionHash;
	// NOTE: can't guarantee any of these computations will run because not every locale has datepicker
	// configs, so make sure there are English fallbacks for these in the defaults file.
	var dpComputableOptions = {
	    buttonText: function (dpOptions) {
	        return {
	            // the translations sometimes wrongly contain HTML entities
	            prev: util_1.stripHtmlEntities(dpOptions.prevText),
	            next: util_1.stripHtmlEntities(dpOptions.nextText),
	            today: util_1.stripHtmlEntities(dpOptions.currentText)
	        };
	    },
	    // Produces format strings like "MMMM YYYY" -> "September 2014"
	    monthYearFormat: function (dpOptions) {
	        return dpOptions.showMonthAfterYear ?
	            'YYYY[' + dpOptions.yearSuffix + '] MMMM' :
	            'MMMM YYYY[' + dpOptions.yearSuffix + ']';
	    }
	};
	var momComputableOptions = {
	    // Produces format strings like "ddd M/D" -> "Fri 9/15"
	    dayOfMonthFormat: function (momOptions, fcOptions) {
	        var format = momOptions.longDateFormat('l'); // for the format like "M/D/YYYY"
	        // strip the year off the edge, as well as other misc non-whitespace chars
	        format = format.replace(/^Y+[^\w\s]*|[^\w\s]*Y+$/g, '');
	        if (fcOptions.isRTL) {
	            format += ' ddd'; // for RTL, add day-of-week to end
	        }
	        else {
	            format = 'ddd ' + format; // for LTR, add day-of-week to beginning
	        }
	        return format;
	    },
	    // Produces format strings like "h:mma" -> "6:00pm"
	    mediumTimeFormat: function (momOptions) {
	        return momOptions.longDateFormat('LT')
	            .replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
	    },
	    // Produces format strings like "h(:mm)a" -> "6pm" / "6:30pm"
	    smallTimeFormat: function (momOptions) {
	        return momOptions.longDateFormat('LT')
	            .replace(':mm', '(:mm)')
	            .replace(/(\Wmm)$/, '($1)') // like above, but for foreign locales
	            .replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
	    },
	    // Produces format strings like "h(:mm)t" -> "6p" / "6:30p"
	    extraSmallTimeFormat: function (momOptions) {
	        return momOptions.longDateFormat('LT')
	            .replace(':mm', '(:mm)')
	            .replace(/(\Wmm)$/, '($1)') // like above, but for foreign locales
	            .replace(/\s*a$/i, 't'); // convert to AM/PM/am/pm to lowercase one-letter. remove any spaces beforehand
	    },
	    // Produces format strings like "ha" / "H" -> "6pm" / "18"
	    hourFormat: function (momOptions) {
	        return momOptions.longDateFormat('LT')
	            .replace(':mm', '')
	            .replace(/(\Wmm)$/, '') // like above, but for foreign locales
	            .replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
	    },
	    // Produces format strings like "h:mm" -> "6:30" (with no AM/PM)
	    noMeridiemTimeFormat: function (momOptions) {
	        return momOptions.longDateFormat('LT')
	            .replace(/\s*a$/i, ''); // remove trailing AM/PM
	    }
	};
	// options that should be computed off live calendar options (considers override options)
	// TODO: best place for this? related to locale?
	// TODO: flipping text based on isRTL is a bad idea because the CSS `direction` might want to handle it
	var instanceComputableOptions = {
	    // Produces format strings for results like "Mo 16"
	    smallDayDateFormat: function (options) {
	        return options.isRTL ?
	            'D dd' :
	            'dd D';
	    },
	    // Produces format strings for results like "Wk 5"
	    weekFormat: function (options) {
	        return options.isRTL ?
	            'w[ ' + options.weekNumberTitle + ']' :
	            '[' + options.weekNumberTitle + ' ]w';
	    },
	    // Produces format strings for results like "Wk5"
	    smallWeekFormat: function (options) {
	        return options.isRTL ?
	            'w[' + options.weekNumberTitle + ']' :
	            '[' + options.weekNumberTitle + ']w';
	    }
	};
	// TODO: make these computable properties in optionsManager
	function populateInstanceComputableOptions(options) {
	    $.each(instanceComputableOptions, function (name, func) {
	        if (options[name] == null) {
	            options[name] = func(options);
	        }
	    });
	}
	exports.populateInstanceComputableOptions = populateInstanceComputableOptions;
	// Initialize jQuery UI datepicker translations while using some of the translations
	// Will set this as the default locales for datepicker.
	function datepickerLocale(localeCode, dpLocaleCode, dpOptions) {
	    // get the FullCalendar internal option hash for this locale. create if necessary
	    var fcOptions = exports.localeOptionHash[localeCode] || (exports.localeOptionHash[localeCode] = {});
	    // transfer some simple options from datepicker to fc
	    fcOptions.isRTL = dpOptions.isRTL;
	    fcOptions.weekNumberTitle = dpOptions.weekHeader;
	    // compute some more complex options from datepicker
	    $.each(dpComputableOptions, function (name, func) {
	        fcOptions[name] = func(dpOptions);
	    });
	    var jqDatePicker = $.datepicker;
	    // is jQuery UI Datepicker is on the page?
	    if (jqDatePicker) {
	        // Register the locale data.
	        // FullCalendar and MomentJS use locale codes like "pt-br" but Datepicker
	        // does it like "pt-BR" or if it doesn't have the locale, maybe just "pt".
	        // Make an alias so the locale can be referenced either way.
	        jqDatePicker.regional[dpLocaleCode] =
	            jqDatePicker.regional[localeCode] = // alias
	                dpOptions;
	        // Alias 'en' to the default locale data. Do this every time.
	        jqDatePicker.regional.en = jqDatePicker.regional[''];
	        // Set as Datepicker's global defaults.
	        jqDatePicker.setDefaults(dpOptions);
	    }
	}
	exports.datepickerLocale = datepickerLocale;
	// Sets FullCalendar-specific translations. Will set the locales as the global default.
	function locale(localeCode, newFcOptions) {
	    var fcOptions;
	    var momOptions;
	    // get the FullCalendar internal option hash for this locale. create if necessary
	    fcOptions = exports.localeOptionHash[localeCode] || (exports.localeOptionHash[localeCode] = {});
	    // provided new options for this locales? merge them in
	    if (newFcOptions) {
	        fcOptions = exports.localeOptionHash[localeCode] = options_1.mergeOptions([fcOptions, newFcOptions]);
	    }
	    // compute locale options that weren't defined.
	    // always do this. newFcOptions can be undefined when initializing from i18n file,
	    // so no way to tell if this is an initialization or a default-setting.
	    momOptions = getMomentLocaleData(localeCode); // will fall back to en
	    $.each(momComputableOptions, function (name, func) {
	        if (fcOptions[name] == null) {
	            fcOptions[name] = (func)(momOptions, fcOptions);
	        }
	    });
	    // set it as the default locale for FullCalendar
	    options_1.globalDefaults.locale = localeCode;
	}
	exports.locale = locale;
	// Returns moment's internal locale data. If doesn't exist, returns English.
	function getMomentLocaleData(localeCode) {
	    return moment.localeData(localeCode) || moment.localeData('en');
	}
	exports.getMomentLocaleData = getMomentLocaleData;
	// Initialize English by forcing computation of moment-derived options.
	// Also, sets it as the default.
	locale('en', options_1.englishDefaults);
	
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(4);
	exports.globalDefaults = {
	    titleRangeSeparator: ' \u2013 ',
	    monthYearFormat: 'MMMM YYYY',
	    defaultTimedEventDuration: '02:00:00',
	    defaultAllDayEventDuration: { days: 1 },
	    forceEventDuration: false,
	    nextDayThreshold: '09:00:00',
	    // display
	    columnHeader: true,
	    defaultView: 'month',
	    aspectRatio: 1.35,
	    header: {
	        left: 'title',
	        center: '',
	        right: 'today prev,next'
	    },
	    weekends: true,
	    weekNumbers: false,
	    weekNumberTitle: 'W',
	    weekNumberCalculation: 'local',
	    // editable: false,
	    // nowIndicator: false,
	    scrollTime: '06:00:00',
	    minTime: '00:00:00',
	    maxTime: '24:00:00',
	    showNonCurrentDates: true,
	    // event ajax
	    lazyFetching: true,
	    startParam: 'start',
	    endParam: 'end',
	    timezoneParam: 'timezone',
	    timezone: false,
	    // allDayDefault: undefined,
	    // locale
	    locale: null,
	    isRTL: false,
	    buttonText: {
	        prev: 'prev',
	        next: 'next',
	        prevYear: 'prev year',
	        nextYear: 'next year',
	        year: 'year',
	        today: 'today',
	        month: 'month',
	        week: 'week',
	        day: 'day'
	    },
	    // buttonIcons: null,
	    allDayText: 'all-day',
	    // allows setting a min-height to the event segment to prevent short events overlapping each other
	    agendaEventMinHeight: 0,
	    // jquery-ui theming
	    theme: false,
	    // themeButtonIcons: null,
	    // eventResizableFromStart: false,
	    dragOpacity: .75,
	    dragRevertDuration: 500,
	    dragScroll: true,
	    // selectable: false,
	    unselectAuto: true,
	    // selectMinDistance: 0,
	    dropAccept: '*',
	    eventOrder: 'title',
	    // eventRenderWait: null,
	    eventLimit: false,
	    eventLimitText: 'more',
	    eventLimitClick: 'popover',
	    dayPopoverFormat: 'LL',
	    handleWindowResize: true,
	    windowResizeDelay: 100,
	    longPressDelay: 1000
	};
	exports.englishDefaults = {
	    dayPopoverFormat: 'dddd, MMMM D'
	};
	exports.rtlDefaults = {
	    header: {
	        left: 'next,prev today',
	        center: '',
	        right: 'title'
	    },
	    buttonIcons: {
	        prev: 'right-single-arrow',
	        next: 'left-single-arrow',
	        prevYear: 'right-double-arrow',
	        nextYear: 'left-double-arrow'
	    },
	    themeButtonIcons: {
	        prev: 'circle-triangle-e',
	        next: 'circle-triangle-w',
	        nextYear: 'seek-prev',
	        prevYear: 'seek-next'
	    }
	};
	var complexOptions = [
	    'header',
	    'footer',
	    'buttonText',
	    'buttonIcons',
	    'themeButtonIcons'
	];
	// Merges an array of option objects into a single object
	function mergeOptions(optionObjs) {
	    return util_1.mergeProps(optionObjs, complexOptions);
	}
	exports.mergeOptions = mergeOptions;
	
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var util_1 = __webpack_require__(4);
	// Class that all other classes will inherit from
	var Class = /** @class */ (function () {
	    function Class() {
	    }
	    // Called on a class to create a subclass.
	    // LIMITATION: cannot provide a constructor!
	    Class.extend = function (members) {
	        var SubClass = /** @class */ (function (_super) {
	            tslib_1.__extends(SubClass, _super);
	            function SubClass() {
	                return _super !== null && _super.apply(this, arguments) || this;
	            }
	            return SubClass;
	        }(this));
	        util_1.copyOwnProps(members, SubClass.prototype);
	        return SubClass;
	    };
	    // Adds new member variables/methods to the class's prototype.
	    // Can be called with another class, or a plain object hash containing new members.
	    Class.mixin = function (members) {
	        util_1.copyOwnProps(members, this.prototype);
	    };
	    return Class;
	}());
	exports.default = Class;
	
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var ParsableModelMixin_1 = __webpack_require__(208);
	var EventDef = /** @class */ (function () {
	    function EventDef(source) {
	        this.source = source;
	        this.className = [];
	        this.miscProps = {};
	    }
	    EventDef.parse = function (rawInput, source) {
	        var def = new this(source);
	        if (def.applyProps(rawInput)) {
	            return def;
	        }
	        return false;
	    };
	    EventDef.normalizeId = function (id) {
	        return String(id);
	    };
	    EventDef.generateId = function () {
	        return '_fc' + (EventDef.uuid++);
	    };
	    EventDef.prototype.clone = function () {
	        var copy = new this.constructor(this.source);
	        copy.id = this.id;
	        copy.rawId = this.rawId;
	        copy.uid = this.uid; // not really unique anymore :(
	        EventDef.copyVerbatimStandardProps(this, copy);
	        copy.className = this.className.slice(); // copy
	        copy.miscProps = $.extend({}, this.miscProps);
	        return copy;
	    };
	    EventDef.prototype.hasInverseRendering = function () {
	        return this.getRendering() === 'inverse-background';
	    };
	    EventDef.prototype.hasBgRendering = function () {
	        var rendering = this.getRendering();
	        return rendering === 'inverse-background' || rendering === 'background';
	    };
	    EventDef.prototype.getRendering = function () {
	        if (this.rendering != null) {
	            return this.rendering;
	        }
	        return this.source.rendering;
	    };
	    EventDef.prototype.getConstraint = function () {
	        if (this.constraint != null) {
	            return this.constraint;
	        }
	        if (this.source.constraint != null) {
	            return this.source.constraint;
	        }
	        return this.source.calendar.opt('eventConstraint'); // what about View option?
	    };
	    EventDef.prototype.getOverlap = function () {
	        if (this.overlap != null) {
	            return this.overlap;
	        }
	        if (this.source.overlap != null) {
	            return this.source.overlap;
	        }
	        return this.source.calendar.opt('eventOverlap'); // what about View option?
	    };
	    EventDef.prototype.isStartExplicitlyEditable = function () {
	        if (this.startEditable != null) {
	            return this.startEditable;
	        }
	        return this.source.startEditable;
	    };
	    EventDef.prototype.isDurationExplicitlyEditable = function () {
	        if (this.durationEditable != null) {
	            return this.durationEditable;
	        }
	        return this.source.durationEditable;
	    };
	    EventDef.prototype.isExplicitlyEditable = function () {
	        if (this.editable != null) {
	            return this.editable;
	        }
	        return this.source.editable;
	    };
	    EventDef.prototype.toLegacy = function () {
	        var obj = $.extend({}, this.miscProps);
	        obj._id = this.uid;
	        obj.source = this.source;
	        obj.className = this.className.slice(); // copy
	        obj.allDay = this.isAllDay();
	        if (this.rawId != null) {
	            obj.id = this.rawId;
	        }
	        EventDef.copyVerbatimStandardProps(this, obj);
	        return obj;
	    };
	    EventDef.prototype.applyManualStandardProps = function (rawProps) {
	        if (rawProps.id != null) {
	            this.id = EventDef.normalizeId((this.rawId = rawProps.id));
	        }
	        else {
	            this.id = EventDef.generateId();
	        }
	        if (rawProps._id != null) {
	            this.uid = String(rawProps._id);
	        }
	        else {
	            this.uid = EventDef.generateId();
	        }
	        // TODO: converge with EventSource
	        if ($.isArray(rawProps.className)) {
	            this.className = rawProps.className;
	        }
	        if (typeof rawProps.className === 'string') {
	            this.className = rawProps.className.split(/\s+/);
	        }
	        return true;
	    };
	    EventDef.prototype.applyMiscProps = function (rawProps) {
	        $.extend(this.miscProps, rawProps);
	    };
	    EventDef.uuid = 0;
	    EventDef.defineStandardProps = ParsableModelMixin_1.default.defineStandardProps;
	    EventDef.copyVerbatimStandardProps = ParsableModelMixin_1.default.copyVerbatimStandardProps;
	    return EventDef;
	}());
	exports.default = EventDef;
	ParsableModelMixin_1.default.mixInto(EventDef);
	EventDef.defineStandardProps({
	    // not automatically assigned (`false`)
	    _id: false,
	    id: false,
	    className: false,
	    source: false,
	    // automatically assigned (`true`)
	    title: true,
	    url: true,
	    rendering: true,
	    constraint: true,
	    overlap: true,
	    editable: true,
	    startEditable: true,
	    durationEditable: true,
	    color: true,
	    backgroundColor: true,
	    borderColor: true,
	    textColor: true
	});
	
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventRange_1 = __webpack_require__(211);
	var EventFootprint_1 = __webpack_require__(35);
	var ComponentFootprint_1 = __webpack_require__(12);
	function eventDefsToEventInstances(eventDefs, unzonedRange) {
	    var eventInstances = [];
	    var i;
	    for (i = 0; i < eventDefs.length; i++) {
	        eventInstances.push.apply(eventInstances, // append
	        eventDefs[i].buildInstances(unzonedRange));
	    }
	    return eventInstances;
	}
	exports.eventDefsToEventInstances = eventDefsToEventInstances;
	function eventInstanceToEventRange(eventInstance) {
	    return new EventRange_1.default(eventInstance.dateProfile.unzonedRange, eventInstance.def, eventInstance);
	}
	exports.eventInstanceToEventRange = eventInstanceToEventRange;
	function eventRangeToEventFootprint(eventRange) {
	    return new EventFootprint_1.default(new ComponentFootprint_1.default(eventRange.unzonedRange, eventRange.eventDef.isAllDay()), eventRange.eventDef, eventRange.eventInstance // might not exist
	    );
	}
	exports.eventRangeToEventFootprint = eventRangeToEventFootprint;
	function eventInstanceToUnzonedRange(eventInstance) {
	    return eventInstance.dateProfile.unzonedRange;
	}
	exports.eventInstanceToUnzonedRange = eventInstanceToUnzonedRange;
	function eventFootprintToComponentFootprint(eventFootprint) {
	    return eventFootprint.componentFootprint;
	}
	exports.eventFootprintToComponentFootprint = eventFootprintToComponentFootprint;
	
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventFootprint = /** @class */ (function () {
	    function EventFootprint(componentFootprint, eventDef, eventInstance) {
	        this.componentFootprint = componentFootprint;
	        this.eventDef = eventDef;
	        if (eventInstance) {
	            this.eventInstance = eventInstance;
	        }
	    }
	    EventFootprint.prototype.getEventLegacy = function () {
	        return (this.eventInstance || this.eventDef).toLegacy();
	    };
	    return EventFootprint;
	}());
	exports.default = EventFootprint;
	
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(4);
	var EventDateProfile_1 = __webpack_require__(17);
	var EventDef_1 = __webpack_require__(33);
	var EventDefDateMutation_1 = __webpack_require__(50);
	var SingleEventDef_1 = __webpack_require__(13);
	var EventDefMutation = /** @class */ (function () {
	    function EventDefMutation() {
	    }
	    EventDefMutation.createFromRawProps = function (eventInstance, rawProps, largeUnit) {
	        var eventDef = eventInstance.def;
	        var dateProps = {};
	        var standardProps = {};
	        var miscProps = {};
	        var verbatimStandardProps = {};
	        var eventDefId = null;
	        var className = null;
	        var propName;
	        var dateProfile;
	        var dateMutation;
	        var defMutation;
	        for (propName in rawProps) {
	            if (EventDateProfile_1.default.isStandardProp(propName)) {
	                dateProps[propName] = rawProps[propName];
	            }
	            else if (eventDef.isStandardProp(propName)) {
	                standardProps[propName] = rawProps[propName];
	            }
	            else if (eventDef.miscProps[propName] !== rawProps[propName]) {
	                miscProps[propName] = rawProps[propName];
	            }
	        }
	        dateProfile = EventDateProfile_1.default.parse(dateProps, eventDef.source);
	        if (dateProfile) {
	            dateMutation = EventDefDateMutation_1.default.createFromDiff(eventInstance.dateProfile, dateProfile, largeUnit);
	        }
	        if (standardProps.id !== eventDef.id) {
	            eventDefId = standardProps.id; // only apply if there's a change
	        }
	        if (!util_1.isArraysEqual(standardProps.className, eventDef.className)) {
	            className = standardProps.className; // only apply if there's a change
	        }
	        EventDef_1.default.copyVerbatimStandardProps(standardProps, // src
	        verbatimStandardProps // dest
	        );
	        defMutation = new EventDefMutation();
	        defMutation.eventDefId = eventDefId;
	        defMutation.className = className;
	        defMutation.verbatimStandardProps = verbatimStandardProps;
	        defMutation.miscProps = miscProps;
	        if (dateMutation) {
	            defMutation.dateMutation = dateMutation;
	        }
	        return defMutation;
	    };
	    /*
	    eventDef assumed to be a SingleEventDef.
	    returns an undo function.
	    */
	    EventDefMutation.prototype.mutateSingle = function (eventDef) {
	        var origDateProfile;
	        if (this.dateMutation) {
	            origDateProfile = eventDef.dateProfile;
	            eventDef.dateProfile = this.dateMutation.buildNewDateProfile(origDateProfile, eventDef.source.calendar);
	        }
	        // can't undo
	        // TODO: more DRY with EventDef::applyManualStandardProps
	        if (this.eventDefId != null) {
	            eventDef.id = EventDef_1.default.normalizeId((eventDef.rawId = this.eventDefId));
	        }
	        // can't undo
	        // TODO: more DRY with EventDef::applyManualStandardProps
	        if (this.className) {
	            eventDef.className = this.className;
	        }
	        // can't undo
	        if (this.verbatimStandardProps) {
	            SingleEventDef_1.default.copyVerbatimStandardProps(this.verbatimStandardProps, // src
	            eventDef // dest
	            );
	        }
	        // can't undo
	        if (this.miscProps) {
	            eventDef.applyMiscProps(this.miscProps);
	        }
	        if (origDateProfile) {
	            return function () {
	                eventDef.dateProfile = origDateProfile;
	            };
	        }
	        else {
	            return function () { };
	        }
	    };
	    EventDefMutation.prototype.setDateMutation = function (dateMutation) {
	        if (dateMutation && !dateMutation.isEmpty()) {
	            this.dateMutation = dateMutation;
	        }
	        else {
	            this.dateMutation = null;
	        }
	    };
	    EventDefMutation.prototype.isEmpty = function () {
	        return !this.dateMutation;
	    };
	    return EventDefMutation;
	}());
	exports.default = EventDefMutation;
	
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    sourceClasses: [],
	    registerClass: function (EventSourceClass) {
	        this.sourceClasses.unshift(EventSourceClass); // give highest priority
	    },
	    parse: function (rawInput, calendar) {
	        var sourceClasses = this.sourceClasses;
	        var i;
	        var eventSource;
	        for (i = 0; i < sourceClasses.length; i++) {
	            eventSource = sourceClasses[i].parse(rawInput, calendar);
	            if (eventSource) {
	                return eventSource;
	            }
	        }
	    }
	};
	
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var Theme = /** @class */ (function () {
	    function Theme(optionsManager) {
	        this.optionsManager = optionsManager;
	        this.processIconOverride();
	    }
	    Theme.prototype.processIconOverride = function () {
	        if (this.iconOverrideOption) {
	            this.setIconOverride(this.optionsManager.get(this.iconOverrideOption));
	        }
	    };
	    Theme.prototype.setIconOverride = function (iconOverrideHash) {
	        var iconClassesCopy;
	        var buttonName;
	        if ($.isPlainObject(iconOverrideHash)) {
	            iconClassesCopy = $.extend({}, this.iconClasses);
	            for (buttonName in iconOverrideHash) {
	                iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
	            }
	            this.iconClasses = iconClassesCopy;
	        }
	        else if (iconOverrideHash === false) {
	            this.iconClasses = {};
	        }
	    };
	    Theme.prototype.applyIconOverridePrefix = function (className) {
	        var prefix = this.iconOverridePrefix;
	        if (prefix && className.indexOf(prefix) !== 0) {
	            className = prefix + className;
	        }
	        return className;
	    };
	    Theme.prototype.getClass = function (key) {
	        return this.classes[key] || '';
	    };
	    Theme.prototype.getIconClass = function (buttonName) {
	        var className = this.iconClasses[buttonName];
	        if (className) {
	            return this.baseIconClass + ' ' + className;
	        }
	        return '';
	    };
	    Theme.prototype.getCustomButtonIconClass = function (customButtonProps) {
	        var className;
	        if (this.iconOverrideCustomButtonOption) {
	            className = customButtonProps[this.iconOverrideCustomButtonOption];
	            if (className) {
	                return this.baseIconClass + ' ' + this.applyIconOverridePrefix(className);
	            }
	        }
	        return '';
	    };
	    return Theme;
	}());
	exports.default = Theme;
	Theme.prototype.classes = {};
	Theme.prototype.iconClasses = {};
	Theme.prototype.baseIconClass = '';
	Theme.prototype.iconOverridePrefix = '';
	
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var Class_1 = __webpack_require__(32);
	/*
	Embodies a div that has potential scrollbars
	*/
	var Scroller = /** @class */ (function (_super) {
	    tslib_1.__extends(Scroller, _super);
	    function Scroller(options) {
	        var _this = _super.call(this) || this;
	        options = options || {};
	        _this.overflowX = options.overflowX || options.overflow || 'auto';
	        _this.overflowY = options.overflowY || options.overflow || 'auto';
	        return _this;
	    }
	    Scroller.prototype.render = function () {
	        this.el = this.renderEl();
	        this.applyOverflow();
	    };
	    Scroller.prototype.renderEl = function () {
	        return (this.scrollEl = $('<div class="fc-scroller"></div>'));
	    };
	    // sets to natural height, unlocks overflow
	    Scroller.prototype.clear = function () {
	        this.setHeight('auto');
	        this.applyOverflow();
	    };
	    Scroller.prototype.destroy = function () {
	        this.el.remove();
	    };
	    // Overflow
	    // -----------------------------------------------------------------------------------------------------------------
	    Scroller.prototype.applyOverflow = function () {
	        this.scrollEl.css({
	            'overflow-x': this.overflowX,
	            'overflow-y': this.overflowY
	        });
	    };
	    // Causes any 'auto' overflow values to resolves to 'scroll' or 'hidden'.
	    // Useful for preserving scrollbar widths regardless of future resizes.
	    // Can pass in scrollbarWidths for optimization.
	    Scroller.prototype.lockOverflow = function (scrollbarWidths) {
	        var overflowX = this.overflowX;
	        var overflowY = this.overflowY;
	        scrollbarWidths = scrollbarWidths || this.getScrollbarWidths();
	        if (overflowX === 'auto') {
	            overflowX = (scrollbarWidths.top || scrollbarWidths.bottom || // horizontal scrollbars?
	                // OR scrolling pane with massless scrollbars?
	                this.scrollEl[0].scrollWidth - 1 > this.scrollEl[0].clientWidth) ? 'scroll' : 'hidden';
	        }
	        if (overflowY === 'auto') {
	            overflowY = (scrollbarWidths.left || scrollbarWidths.right || // vertical scrollbars?
	                // OR scrolling pane with massless scrollbars?
	                this.scrollEl[0].scrollHeight - 1 > this.scrollEl[0].clientHeight) ? 'scroll' : 'hidden';
	        }
	        this.scrollEl.css({ 'overflow-x': overflowX, 'overflow-y': overflowY });
	    };
	    // Getters / Setters
	    // -----------------------------------------------------------------------------------------------------------------
	    Scroller.prototype.setHeight = function (height) {
	        this.scrollEl.height(height);
	    };
	    Scroller.prototype.getScrollTop = function () {
	        return this.scrollEl.scrollTop();
	    };
	    Scroller.prototype.setScrollTop = function (top) {
	        this.scrollEl.scrollTop(top);
	    };
	    Scroller.prototype.getClientWidth = function () {
	        return this.scrollEl[0].clientWidth;
	    };
	    Scroller.prototype.getClientHeight = function () {
	        return this.scrollEl[0].clientHeight;
	    };
	    Scroller.prototype.getScrollbarWidths = function () {
	        return util_1.getScrollbarWidths(this.scrollEl);
	    };
	    return Scroller;
	}(Class_1.default));
	exports.default = Scroller;
	
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var DateComponent_1 = __webpack_require__(219);
	var GlobalEmitter_1 = __webpack_require__(20);
	var InteractiveDateComponent = /** @class */ (function (_super) {
	    tslib_1.__extends(InteractiveDateComponent, _super);
	    function InteractiveDateComponent(_view, _options) {
	        var _this = _super.call(this, _view, _options) || this;
	        // self-config, overridable by subclasses
	        _this.segSelector = '.fc-event-container > *'; // what constitutes an event element?
	        if (_this.dateSelectingClass) {
	            _this.dateClicking = new _this.dateClickingClass(_this);
	        }
	        if (_this.dateSelectingClass) {
	            _this.dateSelecting = new _this.dateSelectingClass(_this);
	        }
	        if (_this.eventPointingClass) {
	            _this.eventPointing = new _this.eventPointingClass(_this);
	        }
	        if (_this.eventDraggingClass && _this.eventPointing) {
	            _this.eventDragging = new _this.eventDraggingClass(_this, _this.eventPointing);
	        }
	        if (_this.eventResizingClass && _this.eventPointing) {
	            _this.eventResizing = new _this.eventResizingClass(_this, _this.eventPointing);
	        }
	        if (_this.externalDroppingClass) {
	            _this.externalDropping = new _this.externalDroppingClass(_this);
	        }
	        return _this;
	    }
	    // Sets the container element that the view should render inside of, does global DOM-related initializations,
	    // and renders all the non-date-related content inside.
	    InteractiveDateComponent.prototype.setElement = function (el) {
	        _super.prototype.setElement.call(this, el);
	        if (this.dateClicking) {
	            this.dateClicking.bindToEl(el);
	        }
	        if (this.dateSelecting) {
	            this.dateSelecting.bindToEl(el);
	        }
	        this.bindAllSegHandlersToEl(el);
	    };
	    InteractiveDateComponent.prototype.removeElement = function () {
	        this.endInteractions();
	        _super.prototype.removeElement.call(this);
	    };
	    InteractiveDateComponent.prototype.executeEventUnrender = function () {
	        this.endInteractions();
	        _super.prototype.executeEventUnrender.call(this);
	    };
	    InteractiveDateComponent.prototype.bindGlobalHandlers = function () {
	        _super.prototype.bindGlobalHandlers.call(this);
	        if (this.externalDropping) {
	            this.externalDropping.bindToDocument();
	        }
	    };
	    InteractiveDateComponent.prototype.unbindGlobalHandlers = function () {
	        _super.prototype.unbindGlobalHandlers.call(this);
	        if (this.externalDropping) {
	            this.externalDropping.unbindFromDocument();
	        }
	    };
	    InteractiveDateComponent.prototype.bindDateHandlerToEl = function (el, name, handler) {
	        var _this = this;
	        // attach a handler to the grid's root element.
	        // jQuery will take care of unregistering them when removeElement gets called.
	        this.el.on(name, function (ev) {
	            if (!$(ev.target).is(_this.segSelector + ':not(.fc-helper),' + // directly on an event element
	                _this.segSelector + ':not(.fc-helper) *,' + // within an event element
	                '.fc-more,' + // a "more.." link
	                'a[data-goto]' // a clickable nav link
	            )) {
	                return handler.call(_this, ev);
	            }
	        });
	    };
	    InteractiveDateComponent.prototype.bindAllSegHandlersToEl = function (el) {
	        [
	            this.eventPointing,
	            this.eventDragging,
	            this.eventResizing
	        ].forEach(function (eventInteraction) {
	            if (eventInteraction) {
	                eventInteraction.bindToEl(el);
	            }
	        });
	    };
	    InteractiveDateComponent.prototype.bindSegHandlerToEl = function (el, name, handler) {
	        var _this = this;
	        el.on(name, this.segSelector, function (ev) {
	            var segEl = $(ev.currentTarget);
	            if (!segEl.is('.fc-helper')) {
	                var seg = segEl.data('fc-seg'); // grab segment data. put there by View::renderEventsPayload
	                if (seg && !_this.shouldIgnoreEventPointing()) {
	                    return handler.call(_this, seg, ev); // context will be the Grid
	                }
	            }
	        });
	    };
	    InteractiveDateComponent.prototype.shouldIgnoreMouse = function () {
	        // HACK
	        // This will still work even though bindDateHandlerToEl doesn't use GlobalEmitter.
	        return GlobalEmitter_1.default.get().shouldIgnoreMouse();
	    };
	    InteractiveDateComponent.prototype.shouldIgnoreTouch = function () {
	        var view = this._getView();
	        // On iOS (and Android?) when a new selection is initiated overtop another selection,
	        // the touchend never fires because the elements gets removed mid-touch-interaction (my theory).
	        // HACK: simply don't allow this to happen.
	        // ALSO: prevent selection when an *event* is already raised.
	        return view.isSelected || view.selectedEvent;
	    };
	    InteractiveDateComponent.prototype.shouldIgnoreEventPointing = function () {
	        // only call the handlers if there is not a drag/resize in progress
	        return (this.eventDragging && this.eventDragging.isDragging) ||
	            (this.eventResizing && this.eventResizing.isResizing);
	    };
	    InteractiveDateComponent.prototype.canStartSelection = function (seg, ev) {
	        return util_1.getEvIsTouch(ev) &&
	            !this.canStartResize(seg, ev) &&
	            (this.isEventDefDraggable(seg.footprint.eventDef) ||
	                this.isEventDefResizable(seg.footprint.eventDef));
	    };
	    InteractiveDateComponent.prototype.canStartDrag = function (seg, ev) {
	        return !this.canStartResize(seg, ev) &&
	            this.isEventDefDraggable(seg.footprint.eventDef);
	    };
	    InteractiveDateComponent.prototype.canStartResize = function (seg, ev) {
	        var view = this._getView();
	        var eventDef = seg.footprint.eventDef;
	        return (!util_1.getEvIsTouch(ev) || view.isEventDefSelected(eventDef)) &&
	            this.isEventDefResizable(eventDef) &&
	            $(ev.target).is('.fc-resizer');
	    };
	    // Kills all in-progress dragging.
	    // Useful for when public API methods that result in re-rendering are invoked during a drag.
	    // Also useful for when touch devices misbehave and don't fire their touchend.
	    InteractiveDateComponent.prototype.endInteractions = function () {
	        [
	            this.dateClicking,
	            this.dateSelecting,
	            this.eventPointing,
	            this.eventDragging,
	            this.eventResizing
	        ].forEach(function (interaction) {
	            if (interaction) {
	                interaction.end();
	            }
	        });
	    };
	    // Event Drag-n-Drop
	    // ---------------------------------------------------------------------------------------------------------------
	    // Computes if the given event is allowed to be dragged by the user
	    InteractiveDateComponent.prototype.isEventDefDraggable = function (eventDef) {
	        return this.isEventDefStartEditable(eventDef);
	    };
	    InteractiveDateComponent.prototype.isEventDefStartEditable = function (eventDef) {
	        var isEditable = eventDef.isStartExplicitlyEditable();
	        if (isEditable == null) {
	            isEditable = this.opt('eventStartEditable');
	            if (isEditable == null) {
	                isEditable = this.isEventDefGenerallyEditable(eventDef);
	            }
	        }
	        return isEditable;
	    };
	    InteractiveDateComponent.prototype.isEventDefGenerallyEditable = function (eventDef) {
	        var isEditable = eventDef.isExplicitlyEditable();
	        if (isEditable == null) {
	            isEditable = this.opt('editable');
	        }
	        return isEditable;
	    };
	    // Event Resizing
	    // ---------------------------------------------------------------------------------------------------------------
	    // Computes if the given event is allowed to be resized from its starting edge
	    InteractiveDateComponent.prototype.isEventDefResizableFromStart = function (eventDef) {
	        return this.opt('eventResizableFromStart') && this.isEventDefResizable(eventDef);
	    };
	    // Computes if the given event is allowed to be resized from its ending edge
	    InteractiveDateComponent.prototype.isEventDefResizableFromEnd = function (eventDef) {
	        return this.isEventDefResizable(eventDef);
	    };
	    // Computes if the given event is allowed to be resized by the user at all
	    InteractiveDateComponent.prototype.isEventDefResizable = function (eventDef) {
	        var isResizable = eventDef.isDurationExplicitlyEditable();
	        if (isResizable == null) {
	            isResizable = this.opt('eventDurationEditable');
	            if (isResizable == null) {
	                isResizable = this.isEventDefGenerallyEditable(eventDef);
	            }
	        }
	        return isResizable;
	    };
	    // Event Mutation / Constraints
	    // ---------------------------------------------------------------------------------------------------------------
	    // Diffs the two dates, returning a duration, based on granularity of the grid
	    // TODO: port isTimeScale into this system?
	    InteractiveDateComponent.prototype.diffDates = function (a, b) {
	        if (this.largeUnit) {
	            return util_1.diffByUnit(a, b, this.largeUnit);
	        }
	        else {
	            return util_1.diffDayTime(a, b);
	        }
	    };
	    // is it allowed, in relation to the view's validRange?
	    // NOTE: very similar to isExternalInstanceGroupAllowed
	    InteractiveDateComponent.prototype.isEventInstanceGroupAllowed = function (eventInstanceGroup) {
	        var view = this._getView();
	        var dateProfile = this.dateProfile;
	        var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
	        var i;
	        for (i = 0; i < eventFootprints.length; i++) {
	            // TODO: just use getAllEventRanges directly
	            if (!dateProfile.validUnzonedRange.containsRange(eventFootprints[i].componentFootprint.unzonedRange)) {
	                return false;
	            }
	        }
	        return view.calendar.constraints.isEventInstanceGroupAllowed(eventInstanceGroup);
	    };
	    // NOTE: very similar to isEventInstanceGroupAllowed
	    // when it's a completely anonymous external drag, no event.
	    InteractiveDateComponent.prototype.isExternalInstanceGroupAllowed = function (eventInstanceGroup) {
	        var view = this._getView();
	        var dateProfile = this.dateProfile;
	        var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
	        var i;
	        for (i = 0; i < eventFootprints.length; i++) {
	            if (!dateProfile.validUnzonedRange.containsRange(eventFootprints[i].componentFootprint.unzonedRange)) {
	                return false;
	            }
	        }
	        for (i = 0; i < eventFootprints.length; i++) {
	            // treat it as a selection
	            // TODO: pass in eventInstanceGroup instead
	            //  because we don't want calendar's constraint system to depend on a component's
	            //  determination of footprints.
	            if (!view.calendar.constraints.isSelectionFootprintAllowed(eventFootprints[i].componentFootprint)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    return InteractiveDateComponent;
	}(DateComponent_1.default));
	exports.default = InteractiveDateComponent;
	
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var moment = __webpack_require__(0);
	var util_1 = __webpack_require__(4);
	var RenderQueue_1 = __webpack_require__(218);
	var DateProfileGenerator_1 = __webpack_require__(221);
	var InteractiveDateComponent_1 = __webpack_require__(40);
	var GlobalEmitter_1 = __webpack_require__(20);
	var UnzonedRange_1 = __webpack_require__(5);
	/* An abstract class from which other views inherit from
	----------------------------------------------------------------------------------------------------------------------*/
	var View = /** @class */ (function (_super) {
	    tslib_1.__extends(View, _super);
	    function View(calendar, viewSpec) {
	        var _this = _super.call(this, null, viewSpec.options) || this;
	        _this.batchRenderDepth = 0;
	        _this.isSelected = false; // boolean whether a range of time is user-selected or not
	        _this.calendar = calendar;
	        _this.viewSpec = viewSpec;
	        // shortcuts
	        _this.type = viewSpec.type;
	        // .name is deprecated
	        _this.name = _this.type;
	        _this.initRenderQueue();
	        _this.initHiddenDays();
	        _this.dateProfileGenerator = new _this.dateProfileGeneratorClass(_this);
	        _this.bindBaseRenderHandlers();
	        _this.eventOrderSpecs = util_1.parseFieldSpecs(_this.opt('eventOrder'));
	        // legacy
	        if (_this['initialize']) {
	            _this['initialize']();
	        }
	        return _this;
	    }
	    View.prototype._getView = function () {
	        return this;
	    };
	    // Retrieves an option with the given name
	    View.prototype.opt = function (name) {
	        return this.options[name];
	    };
	    /* Render Queue
	    ------------------------------------------------------------------------------------------------------------------*/
	    View.prototype.initRenderQueue = function () {
	        this.renderQueue = new RenderQueue_1.default({
	            event: this.opt('eventRenderWait')
	        });
	        this.renderQueue.on('start', this.onRenderQueueStart.bind(this));
	        this.renderQueue.on('stop', this.onRenderQueueStop.bind(this));
	        this.on('before:change', this.startBatchRender);
	        this.on('change', this.stopBatchRender);
	    };
	    View.prototype.onRenderQueueStart = function () {
	        this.calendar.freezeContentHeight();
	        this.addScroll(this.queryScroll());
	    };
	    View.prototype.onRenderQueueStop = function () {
	        if (this.calendar.updateViewSize()) {
	            this.popScroll();
	        }
	        this.calendar.thawContentHeight();
	    };
	    View.prototype.startBatchRender = function () {
	        if (!(this.batchRenderDepth++)) {
	            this.renderQueue.pause();
	        }
	    };
	    View.prototype.stopBatchRender = function () {
	        if (!(--this.batchRenderDepth)) {
	            this.renderQueue.resume();
	        }
	    };
	    View.prototype.requestRender = function (func, namespace, actionType) {
	        this.renderQueue.queue(func, namespace, actionType);
	    };
	    // given func will auto-bind to `this`
	    View.prototype.whenSizeUpdated = function (func) {
	        if (this.renderQueue.isRunning) {
	            this.renderQueue.one('stop', func.bind(this));
	        }
	        else {
	            func.call(this);
	        }
	    };
	    /* Title and Date Formatting
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Computes what the title at the top of the calendar should be for this view
	    View.prototype.computeTitle = function (dateProfile) {
	        var unzonedRange;
	        // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
	        if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) {
	            unzonedRange = dateProfile.currentUnzonedRange;
	        }
	        else {
	            unzonedRange = dateProfile.activeUnzonedRange;
	        }
	        return this.formatRange({
	            start: this.calendar.msToMoment(unzonedRange.startMs, dateProfile.isRangeAllDay),
	            end: this.calendar.msToMoment(unzonedRange.endMs, dateProfile.isRangeAllDay)
	        }, dateProfile.isRangeAllDay, this.opt('titleFormat') || this.computeTitleFormat(dateProfile), this.opt('titleRangeSeparator'));
	    };
	    // Generates the format string that should be used to generate the title for the current date range.
	    // Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
	    View.prototype.computeTitleFormat = function (dateProfile) {
	        var currentRangeUnit = dateProfile.currentRangeUnit;
	        if (currentRangeUnit === 'year') {
	            return 'YYYY';
	        }
	        else if (currentRangeUnit === 'month') {
	            return this.opt('monthYearFormat'); // like "September 2014"
	        }
	        else if (dateProfile.currentUnzonedRange.as('days') > 1) {
	            return 'll'; // multi-day range. shorter, like "Sep 9 - 10 2014"
	        }
	        else {
	            return 'LL'; // one day. longer, like "September 9 2014"
	        }
	    };
	    // Date Setting/Unsetting
	    // -----------------------------------------------------------------------------------------------------------------
	    View.prototype.setDate = function (date) {
	        var currentDateProfile = this.get('dateProfile');
	        var newDateProfile = this.dateProfileGenerator.build(date, undefined, true); // forceToValid=true
	        if (!currentDateProfile ||
	            !currentDateProfile.activeUnzonedRange.equals(newDateProfile.activeUnzonedRange)) {
	            this.set('dateProfile', newDateProfile);
	        }
	    };
	    View.prototype.unsetDate = function () {
	        this.unset('dateProfile');
	    };
	    // Event Data
	    // -----------------------------------------------------------------------------------------------------------------
	    View.prototype.fetchInitialEvents = function (dateProfile) {
	        var calendar = this.calendar;
	        var forceAllDay = dateProfile.isRangeAllDay && !this.usesMinMaxTime;
	        return calendar.requestEvents(calendar.msToMoment(dateProfile.activeUnzonedRange.startMs, forceAllDay), calendar.msToMoment(dateProfile.activeUnzonedRange.endMs, forceAllDay));
	    };
	    View.prototype.bindEventChanges = function () {
	        this.listenTo(this.calendar, 'eventsReset', this.resetEvents); // TODO: make this a real event
	    };
	    View.prototype.unbindEventChanges = function () {
	        this.stopListeningTo(this.calendar, 'eventsReset');
	    };
	    View.prototype.setEvents = function (eventsPayload) {
	        this.set('currentEvents', eventsPayload);
	        this.set('hasEvents', true);
	    };
	    View.prototype.unsetEvents = function () {
	        this.unset('currentEvents');
	        this.unset('hasEvents');
	    };
	    View.prototype.resetEvents = function (eventsPayload) {
	        this.startBatchRender();
	        this.unsetEvents();
	        this.setEvents(eventsPayload);
	        this.stopBatchRender();
	    };
	    // Date High-level Rendering
	    // -----------------------------------------------------------------------------------------------------------------
	    View.prototype.requestDateRender = function (dateProfile) {
	        var _this = this;
	        this.requestRender(function () {
	            _this.executeDateRender(dateProfile);
	        }, 'date', 'init');
	    };
	    View.prototype.requestDateUnrender = function () {
	        var _this = this;
	        this.requestRender(function () {
	            _this.executeDateUnrender();
	        }, 'date', 'destroy');
	    };
	    // if dateProfile not specified, uses current
	    View.prototype.executeDateRender = function (dateProfile) {
	        _super.prototype.executeDateRender.call(this, dateProfile);
	        if (this['render']) {
	            this['render'](); // TODO: deprecate
	        }
	        this.trigger('datesRendered');
	        this.addScroll({ isDateInit: true });
	        this.startNowIndicator(); // shouldn't render yet because updateSize will be called soon
	    };
	    View.prototype.executeDateUnrender = function () {
	        this.unselect();
	        this.stopNowIndicator();
	        this.trigger('before:datesUnrendered');
	        if (this['destroy']) {
	            this['destroy'](); // TODO: deprecate
	        }
	        _super.prototype.executeDateUnrender.call(this);
	    };
	    // "Base" rendering
	    // -----------------------------------------------------------------------------------------------------------------
	    View.prototype.bindBaseRenderHandlers = function () {
	        var _this = this;
	        this.on('datesRendered', function () {
	            _this.whenSizeUpdated(_this.triggerViewRender);
	        });
	        this.on('before:datesUnrendered', function () {
	            _this.triggerViewDestroy();
	        });
	    };
	    View.prototype.triggerViewRender = function () {
	        this.publiclyTrigger('viewRender', {
	            context: this,
	            args: [this, this.el]
	        });
	    };
	    View.prototype.triggerViewDestroy = function () {
	        this.publiclyTrigger('viewDestroy', {
	            context: this,
	            args: [this, this.el]
	        });
	    };
	    // Event High-level Rendering
	    // -----------------------------------------------------------------------------------------------------------------
	    View.prototype.requestEventsRender = function (eventsPayload) {
	        var _this = this;
	        this.requestRender(function () {
	            _this.executeEventRender(eventsPayload);
	            _this.whenSizeUpdated(_this.triggerAfterEventsRendered);
	        }, 'event', 'init');
	    };
	    View.prototype.requestEventsUnrender = function () {
	        var _this = this;
	        this.requestRender(function () {
	            _this.triggerBeforeEventsDestroyed();
	            _this.executeEventUnrender();
	        }, 'event', 'destroy');
	    };
	    // Business Hour High-level Rendering
	    // -----------------------------------------------------------------------------------------------------------------
	    View.prototype.requestBusinessHoursRender = function (businessHourGenerator) {
	        var _this = this;
	        this.requestRender(function () {
	            _this.renderBusinessHours(businessHourGenerator);
	        }, 'businessHours', 'init');
	    };
	    View.prototype.requestBusinessHoursUnrender = function () {
	        var _this = this;
	        this.requestRender(function () {
	            _this.unrenderBusinessHours();
	        }, 'businessHours', 'destroy');
	    };
	    // Misc view rendering utils
	    // -----------------------------------------------------------------------------------------------------------------
	    // Binds DOM handlers to elements that reside outside the view container, such as the document
	    View.prototype.bindGlobalHandlers = function () {
	        _super.prototype.bindGlobalHandlers.call(this);
	        this.listenTo(GlobalEmitter_1.default.get(), {
	            touchstart: this.processUnselect,
	            mousedown: this.handleDocumentMousedown
	        });
	    };
	    // Unbinds DOM handlers from elements that reside outside the view container
	    View.prototype.unbindGlobalHandlers = function () {
	        _super.prototype.unbindGlobalHandlers.call(this);
	        this.stopListeningTo(GlobalEmitter_1.default.get());
	    };
	    /* Now Indicator
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Immediately render the current time indicator and begins re-rendering it at an interval,
	    // which is defined by this.getNowIndicatorUnit().
	    // TODO: somehow do this for the current whole day's background too
	    View.prototype.startNowIndicator = function () {
	        var _this = this;
	        var unit;
	        var update;
	        var delay; // ms wait value
	        if (this.opt('nowIndicator')) {
	            unit = this.getNowIndicatorUnit();
	            if (unit) {
	                update = util_1.proxy(this, 'updateNowIndicator'); // bind to `this`
	                this.initialNowDate = this.calendar.getNow();
	                this.initialNowQueriedMs = new Date().valueOf();
	                // wait until the beginning of the next interval
	                delay = this.initialNowDate.clone().startOf(unit).add(1, unit).valueOf() - this.initialNowDate.valueOf();
	                this.nowIndicatorTimeoutID = setTimeout(function () {
	                    _this.nowIndicatorTimeoutID = null;
	                    update();
	                    delay = +moment.duration(1, unit);
	                    delay = Math.max(100, delay); // prevent too frequent
	                    _this.nowIndicatorIntervalID = setInterval(update, delay); // update every interval
	                }, delay);
	            }
	            // rendering will be initiated in updateSize
	        }
	    };
	    // rerenders the now indicator, computing the new current time from the amount of time that has passed
	    // since the initial getNow call.
	    View.prototype.updateNowIndicator = function () {
	        if (this.isDatesRendered &&
	            this.initialNowDate // activated before?
	        ) {
	            this.unrenderNowIndicator(); // won't unrender if unnecessary
	            this.renderNowIndicator(this.initialNowDate.clone().add(new Date().valueOf() - this.initialNowQueriedMs) // add ms
	            );
	            this.isNowIndicatorRendered = true;
	        }
	    };
	    // Immediately unrenders the view's current time indicator and stops any re-rendering timers.
	    // Won't cause side effects if indicator isn't rendered.
	    View.prototype.stopNowIndicator = function () {
	        if (this.isNowIndicatorRendered) {
	            if (this.nowIndicatorTimeoutID) {
	                clearTimeout(this.nowIndicatorTimeoutID);
	                this.nowIndicatorTimeoutID = null;
	            }
	            if (this.nowIndicatorIntervalID) {
	                clearInterval(this.nowIndicatorIntervalID);
	                this.nowIndicatorIntervalID = null;
	            }
	            this.unrenderNowIndicator();
	            this.isNowIndicatorRendered = false;
	        }
	    };
	    /* Dimensions
	    ------------------------------------------------------------------------------------------------------------------*/
	    View.prototype.updateSize = function (totalHeight, isAuto, isResize) {
	        if (this['setHeight']) {
	            this['setHeight'](totalHeight, isAuto);
	        }
	        else {
	            _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
	        }
	        this.updateNowIndicator();
	    };
	    /* Scroller
	    ------------------------------------------------------------------------------------------------------------------*/
	    View.prototype.addScroll = function (scroll) {
	        var queuedScroll = this.queuedScroll || (this.queuedScroll = {});
	        $.extend(queuedScroll, scroll);
	    };
	    View.prototype.popScroll = function () {
	        this.applyQueuedScroll();
	        this.queuedScroll = null;
	    };
	    View.prototype.applyQueuedScroll = function () {
	        if (this.queuedScroll) {
	            this.applyScroll(this.queuedScroll);
	        }
	    };
	    View.prototype.queryScroll = function () {
	        var scroll = {};
	        if (this.isDatesRendered) {
	            $.extend(scroll, this.queryDateScroll());
	        }
	        return scroll;
	    };
	    View.prototype.applyScroll = function (scroll) {
	        if (scroll.isDateInit && this.isDatesRendered) {
	            $.extend(scroll, this.computeInitialDateScroll());
	        }
	        if (this.isDatesRendered) {
	            this.applyDateScroll(scroll);
	        }
	    };
	    View.prototype.computeInitialDateScroll = function () {
	        return {}; // subclasses must implement
	    };
	    View.prototype.queryDateScroll = function () {
	        return {}; // subclasses must implement
	    };
	    View.prototype.applyDateScroll = function (scroll) {
	        // subclasses must implement
	    };
	    /* Event Drag-n-Drop
	    ------------------------------------------------------------------------------------------------------------------*/
	    View.prototype.reportEventDrop = function (eventInstance, eventMutation, el, ev) {
	        var eventManager = this.calendar.eventManager;
	        var undoFunc = eventManager.mutateEventsWithId(eventInstance.def.id, eventMutation);
	        var dateMutation = eventMutation.dateMutation;
	        // update the EventInstance, for handlers
	        if (dateMutation) {
	            eventInstance.dateProfile = dateMutation.buildNewDateProfile(eventInstance.dateProfile, this.calendar);
	        }
	        this.triggerEventDrop(eventInstance, 
	        // a drop doesn't necessarily mean a date mutation (ex: resource change)
	        (dateMutation && dateMutation.dateDelta) || moment.duration(), undoFunc, el, ev);
	    };
	    // Triggers event-drop handlers that have subscribed via the API
	    View.prototype.triggerEventDrop = function (eventInstance, dateDelta, undoFunc, el, ev) {
	        this.publiclyTrigger('eventDrop', {
	            context: el[0],
	            args: [
	                eventInstance.toLegacy(),
	                dateDelta,
	                undoFunc,
	                ev,
	                {},
	                this
	            ]
	        });
	    };
	    /* External Element Drag-n-Drop
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Must be called when an external element, via jQuery UI, has been dropped onto the calendar.
	    // `meta` is the parsed data that has been embedded into the dragging event.
	    // `dropLocation` is an object that contains the new zoned start/end/allDay values for the event.
	    View.prototype.reportExternalDrop = function (singleEventDef, isEvent, isSticky, el, ev, ui) {
	        if (isEvent) {
	            this.calendar.eventManager.addEventDef(singleEventDef, isSticky);
	        }
	        this.triggerExternalDrop(singleEventDef, isEvent, el, ev, ui);
	    };
	    // Triggers external-drop handlers that have subscribed via the API
	    View.prototype.triggerExternalDrop = function (singleEventDef, isEvent, el, ev, ui) {
	        // trigger 'drop' regardless of whether element represents an event
	        this.publiclyTrigger('drop', {
	            context: el[0],
	            args: [
	                singleEventDef.dateProfile.start.clone(),
	                ev,
	                ui,
	                this
	            ]
	        });
	        if (isEvent) {
	            // signal an external event landed
	            this.publiclyTrigger('eventReceive', {
	                context: this,
	                args: [
	                    singleEventDef.buildInstance().toLegacy(),
	                    this
	                ]
	            });
	        }
	    };
	    /* Event Resizing
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Must be called when an event in the view has been resized to a new length
	    View.prototype.reportEventResize = function (eventInstance, eventMutation, el, ev) {
	        var eventManager = this.calendar.eventManager;
	        var undoFunc = eventManager.mutateEventsWithId(eventInstance.def.id, eventMutation);
	        // update the EventInstance, for handlers
	        eventInstance.dateProfile = eventMutation.dateMutation.buildNewDateProfile(eventInstance.dateProfile, this.calendar);
	        this.triggerEventResize(eventInstance, eventMutation.dateMutation.endDelta, undoFunc, el, ev);
	    };
	    // Triggers event-resize handlers that have subscribed via the API
	    View.prototype.triggerEventResize = function (eventInstance, durationDelta, undoFunc, el, ev) {
	        this.publiclyTrigger('eventResize', {
	            context: el[0],
	            args: [
	                eventInstance.toLegacy(),
	                durationDelta,
	                undoFunc,
	                ev,
	                {},
	                this
	            ]
	        });
	    };
	    /* Selection (time range)
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Selects a date span on the view. `start` and `end` are both Moments.
	    // `ev` is the native mouse event that begin the interaction.
	    View.prototype.select = function (footprint, ev) {
	        this.unselect(ev);
	        this.renderSelectionFootprint(footprint);
	        this.reportSelection(footprint, ev);
	    };
	    View.prototype.renderSelectionFootprint = function (footprint) {
	        if (this['renderSelection']) {
	            this['renderSelection'](footprint.toLegacy(this.calendar));
	        }
	        else {
	            _super.prototype.renderSelectionFootprint.call(this, footprint);
	        }
	    };
	    // Called when a new selection is made. Updates internal state and triggers handlers.
	    View.prototype.reportSelection = function (footprint, ev) {
	        this.isSelected = true;
	        this.triggerSelect(footprint, ev);
	    };
	    // Triggers handlers to 'select'
	    View.prototype.triggerSelect = function (footprint, ev) {
	        var dateProfile = this.calendar.footprintToDateProfile(footprint); // abuse of "Event"DateProfile?
	        this.publiclyTrigger('select', {
	            context: this,
	            args: [
	                dateProfile.start,
	                dateProfile.end,
	                ev,
	                this
	            ]
	        });
	    };
	    // Undoes a selection. updates in the internal state and triggers handlers.
	    // `ev` is the native mouse event that began the interaction.
	    View.prototype.unselect = function (ev) {
	        if (this.isSelected) {
	            this.isSelected = false;
	            if (this['destroySelection']) {
	                this['destroySelection'](); // TODO: deprecate
	            }
	            this.unrenderSelection();
	            this.publiclyTrigger('unselect', {
	                context: this,
	                args: [ev, this]
	            });
	        }
	    };
	    /* Event Selection
	    ------------------------------------------------------------------------------------------------------------------*/
	    View.prototype.selectEventInstance = function (eventInstance) {
	        if (!this.selectedEventInstance ||
	            this.selectedEventInstance !== eventInstance) {
	            this.unselectEventInstance();
	            this.getEventSegs().forEach(function (seg) {
	                if (seg.footprint.eventInstance === eventInstance &&
	                    seg.el // necessary?
	                ) {
	                    seg.el.addClass('fc-selected');
	                }
	            });
	            this.selectedEventInstance = eventInstance;
	        }
	    };
	    View.prototype.unselectEventInstance = function () {
	        if (this.selectedEventInstance) {
	            this.getEventSegs().forEach(function (seg) {
	                if (seg.el) {
	                    seg.el.removeClass('fc-selected');
	                }
	            });
	            this.selectedEventInstance = null;
	        }
	    };
	    View.prototype.isEventDefSelected = function (eventDef) {
	        // event references might change on refetchEvents(), while selectedEventInstance doesn't,
	        // so compare IDs
	        return this.selectedEventInstance && this.selectedEventInstance.def.id === eventDef.id;
	    };
	    /* Mouse / Touch Unselecting (time range & event unselection)
	    ------------------------------------------------------------------------------------------------------------------*/
	    // TODO: move consistently to down/start or up/end?
	    // TODO: don't kill previous selection if touch scrolling
	    View.prototype.handleDocumentMousedown = function (ev) {
	        if (util_1.isPrimaryMouseButton(ev)) {
	            this.processUnselect(ev);
	        }
	    };
	    View.prototype.processUnselect = function (ev) {
	        this.processRangeUnselect(ev);
	        this.processEventUnselect(ev);
	    };
	    View.prototype.processRangeUnselect = function (ev) {
	        var ignore;
	        // is there a time-range selection?
	        if (this.isSelected && this.opt('unselectAuto')) {
	            // only unselect if the clicked element is not identical to or inside of an 'unselectCancel' element
	            ignore = this.opt('unselectCancel');
	            if (!ignore || !$(ev.target).closest(ignore).length) {
	                this.unselect(ev);
	            }
	        }
	    };
	    View.prototype.processEventUnselect = function (ev) {
	        if (this.selectedEventInstance) {
	            if (!$(ev.target).closest('.fc-selected').length) {
	                this.unselectEventInstance();
	            }
	        }
	    };
	    /* Triggers
	    ------------------------------------------------------------------------------------------------------------------*/
	    View.prototype.triggerBaseRendered = function () {
	        this.publiclyTrigger('viewRender', {
	            context: this,
	            args: [this, this.el]
	        });
	    };
	    View.prototype.triggerBaseUnrendered = function () {
	        this.publiclyTrigger('viewDestroy', {
	            context: this,
	            args: [this, this.el]
	        });
	    };
	    // Triggers handlers to 'dayClick'
	    // Span has start/end of the clicked area. Only the start is useful.
	    View.prototype.triggerDayClick = function (footprint, dayEl, ev) {
	        var dateProfile = this.calendar.footprintToDateProfile(footprint); // abuse of "Event"DateProfile?
	        this.publiclyTrigger('dayClick', {
	            context: dayEl,
	            args: [dateProfile.start, ev, this]
	        });
	    };
	    /* Date Utils
	    ------------------------------------------------------------------------------------------------------------------*/
	    // For DateComponent::getDayClasses
	    View.prototype.isDateInOtherMonth = function (date, dateProfile) {
	        return false;
	    };
	    // Arguments after name will be forwarded to a hypothetical function value
	    // WARNING: passed-in arguments will be given to generator functions as-is and can cause side-effects.
	    // Always clone your objects if you fear mutation.
	    View.prototype.getUnzonedRangeOption = function (name) {
	        var val = this.opt(name);
	        if (typeof val === 'function') {
	            val = val.apply(null, Array.prototype.slice.call(arguments, 1));
	        }
	        if (val) {
	            return this.calendar.parseUnzonedRange(val);
	        }
	    };
	    /* Hidden Days
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Initializes internal variables related to calculating hidden days-of-week
	    View.prototype.initHiddenDays = function () {
	        var hiddenDays = this.opt('hiddenDays') || []; // array of day-of-week indices that are hidden
	        var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
	        var dayCnt = 0;
	        var i;
	        if (this.opt('weekends') === false) {
	            hiddenDays.push(0, 6); // 0=sunday, 6=saturday
	        }
	        for (i = 0; i < 7; i++) {
	            if (!(isHiddenDayHash[i] = $.inArray(i, hiddenDays) !== -1)) {
	                dayCnt++;
	            }
	        }
	        if (!dayCnt) {
	            throw new Error('invalid hiddenDays'); // all days were hidden? bad.
	        }
	        this.isHiddenDayHash = isHiddenDayHash;
	    };
	    // Remove days from the beginning and end of the range that are computed as hidden.
	    // If the whole range is trimmed off, returns null
	    View.prototype.trimHiddenDays = function (inputUnzonedRange) {
	        var start = inputUnzonedRange.getStart();
	        var end = inputUnzonedRange.getEnd();
	        if (start) {
	            start = this.skipHiddenDays(start);
	        }
	        if (end) {
	            end = this.skipHiddenDays(end, -1, true);
	        }
	        if (start === null || end === null || start < end) {
	            return new UnzonedRange_1.default(start, end);
	        }
	        return null;
	    };
	    // Is the current day hidden?
	    // `day` is a day-of-week index (0-6), or a Moment
	    View.prototype.isHiddenDay = function (day) {
	        if (moment.isMoment(day)) {
	            day = day.day();
	        }
	        return this.isHiddenDayHash[day];
	    };
	    // Incrementing the current day until it is no longer a hidden day, returning a copy.
	    // DOES NOT CONSIDER validUnzonedRange!
	    // If the initial value of `date` is not a hidden day, don't do anything.
	    // Pass `isExclusive` as `true` if you are dealing with an end date.
	    // `inc` defaults to `1` (increment one day forward each time)
	    View.prototype.skipHiddenDays = function (date, inc, isExclusive) {
	        if (inc === void 0) { inc = 1; }
	        if (isExclusive === void 0) { isExclusive = false; }
	        var out = date.clone();
	        while (this.isHiddenDayHash[(out.day() + (isExclusive ? inc : 0) + 7) % 7]) {
	            out.add(inc, 'days');
	        }
	        return out;
	    };
	    return View;
	}(InteractiveDateComponent_1.default));
	exports.default = View;
	View.prototype.usesMinMaxTime = false;
	View.prototype.dateProfileGeneratorClass = DateProfileGenerator_1.default;
	View.watch('displayingDates', ['isInDom', 'dateProfile'], function (deps) {
	    this.requestDateRender(deps.dateProfile);
	}, function () {
	    this.requestDateUnrender();
	});
	View.watch('displayingBusinessHours', ['displayingDates', 'businessHourGenerator'], function (deps) {
	    this.requestBusinessHoursRender(deps.businessHourGenerator);
	}, function () {
	    this.requestBusinessHoursUnrender();
	});
	View.watch('initialEvents', ['dateProfile'], function (deps) {
	    return this.fetchInitialEvents(deps.dateProfile);
	});
	View.watch('bindingEvents', ['initialEvents'], function (deps) {
	    this.setEvents(deps.initialEvents);
	    this.bindEventChanges();
	}, function () {
	    this.unbindEventChanges();
	    this.unsetEvents();
	});
	View.watch('displayingEvents', ['displayingDates', 'hasEvents'], function () {
	    this.requestEventsRender(this.get('currentEvents'));
	}, function () {
	    this.requestEventsUnrender();
	});
	View.watch('title', ['dateProfile'], function (deps) {
	    return (this.title = this.computeTitle(deps.dateProfile)); // assign to View for legacy reasons
	});
	View.watch('legacyDateProps', ['dateProfile'], function (deps) {
	    var calendar = this.calendar;
	    var dateProfile = deps.dateProfile;
	    // DEPRECATED, but we need to keep it updated...
	    this.start = calendar.msToMoment(dateProfile.activeUnzonedRange.startMs, dateProfile.isRangeAllDay);
	    this.end = calendar.msToMoment(dateProfile.activeUnzonedRange.endMs, dateProfile.isRangeAllDay);
	    this.intervalStart = calendar.msToMoment(dateProfile.currentUnzonedRange.startMs, dateProfile.isRangeAllDay);
	    this.intervalEnd = calendar.msToMoment(dateProfile.currentUnzonedRange.endMs, dateProfile.isRangeAllDay);
	});
	
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var EventRenderer = /** @class */ (function () {
	    function EventRenderer(component, fillRenderer) {
	        this.view = component._getView();
	        this.component = component;
	        this.fillRenderer = fillRenderer;
	    }
	    EventRenderer.prototype.opt = function (name) {
	        return this.view.opt(name);
	    };
	    // Updates values that rely on options and also relate to range
	    EventRenderer.prototype.rangeUpdated = function () {
	        var displayEventTime;
	        var displayEventEnd;
	        this.eventTimeFormat =
	            this.opt('eventTimeFormat') ||
	                this.opt('timeFormat') || // deprecated
	                this.computeEventTimeFormat();
	        displayEventTime = this.opt('displayEventTime');
	        if (displayEventTime == null) {
	            displayEventTime = this.computeDisplayEventTime(); // might be based off of range
	        }
	        displayEventEnd = this.opt('displayEventEnd');
	        if (displayEventEnd == null) {
	            displayEventEnd = this.computeDisplayEventEnd(); // might be based off of range
	        }
	        this.displayEventTime = displayEventTime;
	        this.displayEventEnd = displayEventEnd;
	    };
	    EventRenderer.prototype.render = function (eventsPayload) {
	        var dateProfile = this.component._getDateProfile();
	        var eventDefId;
	        var instanceGroup;
	        var eventRanges;
	        var bgRanges = [];
	        var fgRanges = [];
	        for (eventDefId in eventsPayload) {
	            instanceGroup = eventsPayload[eventDefId];
	            eventRanges = instanceGroup.sliceRenderRanges(dateProfile.activeUnzonedRange);
	            if (instanceGroup.getEventDef().hasBgRendering()) {
	                bgRanges.push.apply(bgRanges, eventRanges);
	            }
	            else {
	                fgRanges.push.apply(fgRanges, eventRanges);
	            }
	        }
	        this.renderBgRanges(bgRanges);
	        this.renderFgRanges(fgRanges);
	    };
	    EventRenderer.prototype.unrender = function () {
	        this.unrenderBgRanges();
	        this.unrenderFgRanges();
	    };
	    EventRenderer.prototype.renderFgRanges = function (eventRanges) {
	        var eventFootprints = this.component.eventRangesToEventFootprints(eventRanges);
	        var segs = this.component.eventFootprintsToSegs(eventFootprints);
	        // render an `.el` on each seg
	        // returns a subset of the segs. segs that were actually rendered
	        segs = this.renderFgSegEls(segs);
	        if (this.renderFgSegs(segs) !== false) {
	            this.fgSegs = segs;
	        }
	    };
	    EventRenderer.prototype.unrenderFgRanges = function () {
	        this.unrenderFgSegs(this.fgSegs || []);
	        this.fgSegs = null;
	    };
	    EventRenderer.prototype.renderBgRanges = function (eventRanges) {
	        var eventFootprints = this.component.eventRangesToEventFootprints(eventRanges);
	        var segs = this.component.eventFootprintsToSegs(eventFootprints);
	        if (this.renderBgSegs(segs) !== false) {
	            this.bgSegs = segs;
	        }
	    };
	    EventRenderer.prototype.unrenderBgRanges = function () {
	        this.unrenderBgSegs();
	        this.bgSegs = null;
	    };
	    EventRenderer.prototype.getSegs = function () {
	        return (this.bgSegs || []).concat(this.fgSegs || []);
	    };
	    // Renders foreground event segments onto the grid
	    EventRenderer.prototype.renderFgSegs = function (segs) {
	        // subclasses must implement
	        // segs already has rendered els, and has been filtered.
	        return false; // signal failure if not implemented
	    };
	    // Unrenders all currently rendered foreground segments
	    EventRenderer.prototype.unrenderFgSegs = function (segs) {
	        // subclasses must implement
	    };
	    EventRenderer.prototype.renderBgSegs = function (segs) {
	        var _this = this;
	        if (this.fillRenderer) {
	            this.fillRenderer.renderSegs('bgEvent', segs, {
	                getClasses: function (seg) {
	                    return _this.getBgClasses(seg.footprint.eventDef);
	                },
	                getCss: function (seg) {
	                    return {
	                        'background-color': _this.getBgColor(seg.footprint.eventDef)
	                    };
	                },
	                filterEl: function (seg, el) {
	                    return _this.filterEventRenderEl(seg.footprint, el);
	                }
	            });
	        }
	        else {
	            return false; // signal failure if no fillRenderer
	        }
	    };
	    EventRenderer.prototype.unrenderBgSegs = function () {
	        if (this.fillRenderer) {
	            this.fillRenderer.unrender('bgEvent');
	        }
	    };
	    // Renders and assigns an `el` property for each foreground event segment.
	    // Only returns segments that successfully rendered.
	    EventRenderer.prototype.renderFgSegEls = function (segs, disableResizing) {
	        var _this = this;
	        if (disableResizing === void 0) { disableResizing = false; }
	        var hasEventRenderHandlers = this.view.hasPublicHandlers('eventRender');
	        var html = '';
	        var renderedSegs = [];
	        var i;
	        if (segs.length) {
	            // build a large concatenation of event segment HTML
	            for (i = 0; i < segs.length; i++) {
	                this.beforeFgSegHtml(segs[i]);
	                html += this.fgSegHtml(segs[i], disableResizing);
	            }
	            // Grab individual elements from the combined HTML string. Use each as the default rendering.
	            // Then, compute the 'el' for each segment. An el might be null if the eventRender callback returned false.
	            $(html).each(function (i, node) {
	                var seg = segs[i];
	                var el = $(node);
	                if (hasEventRenderHandlers) {
	                    el = _this.filterEventRenderEl(seg.footprint, el);
	                }
	                if (el) {
	                    el.data('fc-seg', seg); // used by handlers
	                    seg.el = el;
	                    renderedSegs.push(seg);
	                }
	            });
	        }
	        return renderedSegs;
	    };
	    EventRenderer.prototype.beforeFgSegHtml = function (seg) {
	    };
	    // Generates the HTML for the default rendering of a foreground event segment. Used by renderFgSegEls()
	    EventRenderer.prototype.fgSegHtml = function (seg, disableResizing) {
	        // subclasses should implement
	    };
	    // Generic utility for generating the HTML classNames for an event segment's element
	    EventRenderer.prototype.getSegClasses = function (seg, isDraggable, isResizable) {
	        var classes = [
	            'fc-event',
	            seg.isStart ? 'fc-start' : 'fc-not-start',
	            seg.isEnd ? 'fc-end' : 'fc-not-end'
	        ].concat(this.getClasses(seg.footprint.eventDef));
	        if (isDraggable) {
	            classes.push('fc-draggable');
	        }
	        if (isResizable) {
	            classes.push('fc-resizable');
	        }
	        // event is currently selected? attach a className.
	        if (this.view.isEventDefSelected(seg.footprint.eventDef)) {
	            classes.push('fc-selected');
	        }
	        return classes;
	    };
	    // Given an event and the default element used for rendering, returns the element that should actually be used.
	    // Basically runs events and elements through the eventRender hook.
	    EventRenderer.prototype.filterEventRenderEl = function (eventFootprint, el) {
	        var legacy = eventFootprint.getEventLegacy();
	        var custom = this.view.publiclyTrigger('eventRender', {
	            context: legacy,
	            args: [legacy, el, this.view]
	        });
	        if (custom === false) {
	            el = null;
	        }
	        else if (custom && custom !== true) {
	            el = $(custom);
	        }
	        return el;
	    };
	    // Compute the text that should be displayed on an event's element.
	    // `range` can be the Event object itself, or something range-like, with at least a `start`.
	    // If event times are disabled, or the event has no time, will return a blank string.
	    // If not specified, formatStr will default to the eventTimeFormat setting,
	    // and displayEnd will default to the displayEventEnd setting.
	    EventRenderer.prototype.getTimeText = function (eventFootprint, formatStr, displayEnd) {
	        return this._getTimeText(eventFootprint.eventInstance.dateProfile.start, eventFootprint.eventInstance.dateProfile.end, eventFootprint.componentFootprint.isAllDay, formatStr, displayEnd);
	    };
	    EventRenderer.prototype._getTimeText = function (start, end, isAllDay, formatStr, displayEnd) {
	        if (formatStr == null) {
	            formatStr = this.eventTimeFormat;
	        }
	        if (displayEnd == null) {
	            displayEnd = this.displayEventEnd;
	        }
	        if (this.displayEventTime && !isAllDay) {
	            if (displayEnd && end) {
	                return this.view.formatRange({ start: start, end: end }, false, // allDay
	                formatStr);
	            }
	            else {
	                return start.format(formatStr);
	            }
	        }
	        return '';
	    };
	    EventRenderer.prototype.computeEventTimeFormat = function () {
	        return this.opt('smallTimeFormat');
	    };
	    EventRenderer.prototype.computeDisplayEventTime = function () {
	        return true;
	    };
	    EventRenderer.prototype.computeDisplayEventEnd = function () {
	        return true;
	    };
	    EventRenderer.prototype.getBgClasses = function (eventDef) {
	        var classNames = this.getClasses(eventDef);
	        classNames.push('fc-bgevent');
	        return classNames;
	    };
	    EventRenderer.prototype.getClasses = function (eventDef) {
	        var objs = this.getStylingObjs(eventDef);
	        var i;
	        var classNames = [];
	        for (i = 0; i < objs.length; i++) {
	            classNames.push.apply(// append
	            classNames, objs[i].eventClassName || objs[i].className || []);
	        }
	        return classNames;
	    };
	    // Utility for generating event skin-related CSS properties
	    EventRenderer.prototype.getSkinCss = function (eventDef) {
	        return {
	            'background-color': this.getBgColor(eventDef),
	            'border-color': this.getBorderColor(eventDef),
	            color: this.getTextColor(eventDef)
	        };
	    };
	    // Queries for caller-specified color, then falls back to default
	    EventRenderer.prototype.getBgColor = function (eventDef) {
	        var objs = this.getStylingObjs(eventDef);
	        var i;
	        var val;
	        for (i = 0; i < objs.length && !val; i++) {
	            val = objs[i].eventBackgroundColor || objs[i].eventColor ||
	                objs[i].backgroundColor || objs[i].color;
	        }
	        if (!val) {
	            val = this.opt('eventBackgroundColor') || this.opt('eventColor');
	        }
	        return val;
	    };
	    // Queries for caller-specified color, then falls back to default
	    EventRenderer.prototype.getBorderColor = function (eventDef) {
	        var objs = this.getStylingObjs(eventDef);
	        var i;
	        var val;
	        for (i = 0; i < objs.length && !val; i++) {
	            val = objs[i].eventBorderColor || objs[i].eventColor ||
	                objs[i].borderColor || objs[i].color;
	        }
	        if (!val) {
	            val = this.opt('eventBorderColor') || this.opt('eventColor');
	        }
	        return val;
	    };
	    // Queries for caller-specified color, then falls back to default
	    EventRenderer.prototype.getTextColor = function (eventDef) {
	        var objs = this.getStylingObjs(eventDef);
	        var i;
	        var val;
	        for (i = 0; i < objs.length && !val; i++) {
	            val = objs[i].eventTextColor ||
	                objs[i].textColor;
	        }
	        if (!val) {
	            val = this.opt('eventTextColor');
	        }
	        return val;
	    };
	    EventRenderer.prototype.getStylingObjs = function (eventDef) {
	        var objs = this.getFallbackStylingObjs(eventDef);
	        objs.unshift(eventDef);
	        return objs;
	    };
	    EventRenderer.prototype.getFallbackStylingObjs = function (eventDef) {
	        return [eventDef.source];
	    };
	    EventRenderer.prototype.sortEventSegs = function (segs) {
	        segs.sort(util_1.proxy(this, 'compareEventSegs'));
	    };
	    // A cmp function for determining which segments should take visual priority
	    EventRenderer.prototype.compareEventSegs = function (seg1, seg2) {
	        var f1 = seg1.footprint;
	        var f2 = seg2.footprint;
	        var cf1 = f1.componentFootprint;
	        var cf2 = f2.componentFootprint;
	        var r1 = cf1.unzonedRange;
	        var r2 = cf2.unzonedRange;
	        return r1.startMs - r2.startMs || // earlier events go first
	            (r2.endMs - r2.startMs) - (r1.endMs - r1.startMs) || // tie? longer events go first
	            cf2.isAllDay - cf1.isAllDay || // tie? put all-day events first (booleans cast to 0/1)
	            util_1.compareByFieldSpecs(f1.eventDef, f2.eventDef, this.view.eventOrderSpecs, f1.eventDef.miscProps, f2.eventDef.miscProps);
	    };
	    return EventRenderer;
	}());
	exports.default = EventRenderer;
	
	
	/***/ }),
	/* 43 */,
	/* 44 */,
	/* 45 */,
	/* 46 */,
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment_ext_1 = __webpack_require__(10);
	// Plugin
	// -------------------------------------------------------------------------------------------------
	moment_ext_1.newMomentProto.format = function () {
	    if (this._fullCalendar && arguments[0]) {
	        return formatDate(this, arguments[0]); // our extended formatting
	    }
	    if (this._ambigTime) {
	        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD');
	    }
	    if (this._ambigZone) {
	        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD[T]HH:mm:ss');
	    }
	    if (this._fullCalendar) {
	        // moment.format() doesn't ensure english, but we want to.
	        return moment_ext_1.oldMomentFormat(englishMoment(this));
	    }
	    return moment_ext_1.oldMomentProto.format.apply(this, arguments);
	};
	moment_ext_1.newMomentProto.toISOString = function () {
	    if (this._ambigTime) {
	        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD');
	    }
	    if (this._ambigZone) {
	        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD[T]HH:mm:ss');
	    }
	    if (this._fullCalendar) {
	        // depending on browser, moment might not output english. ensure english.
	        // https://github.com/moment/moment/blob/2.18.1/src/lib/moment/format.js#L22
	        return moment_ext_1.oldMomentProto.toISOString.apply(englishMoment(this), arguments);
	    }
	    return moment_ext_1.oldMomentProto.toISOString.apply(this, arguments);
	};
	function englishMoment(mom) {
	    if (mom.locale() !== 'en') {
	        return mom.clone().locale('en');
	    }
	    return mom;
	}
	// Config
	// ---------------------------------------------------------------------------------------------------------------------
	/*
	Inserted between chunks in the fake ("intermediate") formatting string.
	Important that it passes as whitespace (\s) because moment often identifies non-standalone months
	via a regexp with an \s.
	*/
	var PART_SEPARATOR = '\u000b'; // vertical tab
	/*
	Inserted as the first character of a literal-text chunk to indicate that the literal text is not actually literal text,
	but rather, a "special" token that has custom rendering (see specialTokens map).
	*/
	var SPECIAL_TOKEN_MARKER = '\u001f'; // information separator 1
	/*
	Inserted at the beginning and end of a span of text that must have non-zero numeric characters.
	Handling of these markers is done in a post-processing step at the very end of text rendering.
	*/
	var MAYBE_MARKER = '\u001e'; // information separator 2
	var MAYBE_REGEXP = new RegExp(MAYBE_MARKER + '([^' + MAYBE_MARKER + ']*)' + MAYBE_MARKER, 'g'); // must be global
	/*
	Addition formatting tokens we want recognized
	*/
	var specialTokens = {
	    t: function (date) {
	        return moment_ext_1.oldMomentFormat(date, 'a').charAt(0);
	    },
	    T: function (date) {
	        return moment_ext_1.oldMomentFormat(date, 'A').charAt(0);
	    }
	};
	/*
	The first characters of formatting tokens for units that are 1 day or larger.
	`value` is for ranking relative size (lower means bigger).
	`unit` is a normalized unit, used for comparing moments.
	*/
	var largeTokenMap = {
	    Y: { value: 1, unit: 'year' },
	    M: { value: 2, unit: 'month' },
	    W: { value: 3, unit: 'week' },
	    w: { value: 3, unit: 'week' },
	    D: { value: 4, unit: 'day' },
	    d: { value: 4, unit: 'day' } // day of week
	};
	// Single Date Formatting
	// ---------------------------------------------------------------------------------------------------------------------
	/*
	Formats `date` with a Moment formatting string, but allow our non-zero areas and special token
	*/
	function formatDate(date, formatStr) {
	    return renderFakeFormatString(getParsedFormatString(formatStr).fakeFormatString, date);
	}
	exports.formatDate = formatDate;
	// Date Range Formatting
	// -------------------------------------------------------------------------------------------------
	// TODO: make it work with timezone offset
	/*
	Using a formatting string meant for a single date, generate a range string, like
	"Sep 2 - 9 2013", that intelligently inserts a separator where the dates differ.
	If the dates are the same as far as the format string is concerned, just return a single
	rendering of one date, without any separator.
	*/
	function formatRange(date1, date2, formatStr, separator, isRTL) {
	    var localeData;
	    date1 = moment_ext_1.default.parseZone(date1);
	    date2 = moment_ext_1.default.parseZone(date2);
	    localeData = date1.localeData();
	    // Expand localized format strings, like "LL" -> "MMMM D YYYY".
	    // BTW, this is not important for `formatDate` because it is impossible to put custom tokens
	    // or non-zero areas in Moment's localized format strings.
	    formatStr = localeData.longDateFormat(formatStr) || formatStr;
	    return renderParsedFormat(getParsedFormatString(formatStr), date1, date2, separator || ' - ', isRTL);
	}
	exports.formatRange = formatRange;
	/*
	Renders a range with an already-parsed format string.
	*/
	function renderParsedFormat(parsedFormat, date1, date2, separator, isRTL) {
	    var sameUnits = parsedFormat.sameUnits;
	    var unzonedDate1 = date1.clone().stripZone(); // for same-unit comparisons
	    var unzonedDate2 = date2.clone().stripZone(); // "
	    var renderedParts1 = renderFakeFormatStringParts(parsedFormat.fakeFormatString, date1);
	    var renderedParts2 = renderFakeFormatStringParts(parsedFormat.fakeFormatString, date2);
	    var leftI;
	    var leftStr = '';
	    var rightI;
	    var rightStr = '';
	    var middleI;
	    var middleStr1 = '';
	    var middleStr2 = '';
	    var middleStr = '';
	    // Start at the leftmost side of the formatting string and continue until you hit a token
	    // that is not the same between dates.
	    for (leftI = 0; leftI < sameUnits.length && (!sameUnits[leftI] || unzonedDate1.isSame(unzonedDate2, sameUnits[leftI])); leftI++) {
	        leftStr += renderedParts1[leftI];
	    }
	    // Similarly, start at the rightmost side of the formatting string and move left
	    for (rightI = sameUnits.length - 1; rightI > leftI && (!sameUnits[rightI] || unzonedDate1.isSame(unzonedDate2, sameUnits[rightI])); rightI--) {
	        // If current chunk is on the boundary of unique date-content, and is a special-case
	        // date-formatting postfix character, then don't consume it. Consider it unique date-content.
	        // TODO: make configurable
	        if (rightI - 1 === leftI && renderedParts1[rightI] === '.') {
	            break;
	        }
	        rightStr = renderedParts1[rightI] + rightStr;
	    }
	    // The area in the middle is different for both of the dates.
	    // Collect them distinctly so we can jam them together later.
	    for (middleI = leftI; middleI <= rightI; middleI++) {
	        middleStr1 += renderedParts1[middleI];
	        middleStr2 += renderedParts2[middleI];
	    }
	    if (middleStr1 || middleStr2) {
	        if (isRTL) {
	            middleStr = middleStr2 + separator + middleStr1;
	        }
	        else {
	            middleStr = middleStr1 + separator + middleStr2;
	        }
	    }
	    return processMaybeMarkers(leftStr + middleStr + rightStr);
	}
	// Format String Parsing
	// ---------------------------------------------------------------------------------------------------------------------
	var parsedFormatStrCache = {};
	/*
	Returns a parsed format string, leveraging a cache.
	*/
	function getParsedFormatString(formatStr) {
	    return parsedFormatStrCache[formatStr] ||
	        (parsedFormatStrCache[formatStr] = parseFormatString(formatStr));
	}
	/*
	Parses a format string into the following:
	- fakeFormatString: a momentJS formatting string, littered with special control characters that get post-processed.
	- sameUnits: for every part in fakeFormatString, if the part is a token, the value will be a unit string (like "day"),
	  that indicates how similar a range's start & end must be in order to share the same formatted text.
	  If not a token, then the value is null.
	  Always a flat array (not nested liked "chunks").
	*/
	function parseFormatString(formatStr) {
	    var chunks = chunkFormatString(formatStr);
	    return {
	        fakeFormatString: buildFakeFormatString(chunks),
	        sameUnits: buildSameUnits(chunks)
	    };
	}
	/*
	Break the formatting string into an array of chunks.
	A 'maybe' chunk will have nested chunks.
	*/
	function chunkFormatString(formatStr) {
	    var chunks = [];
	    var match;
	    // TODO: more descrimination
	    // \4 is a backreference to the first character of a multi-character set.
	    var chunker = /\[([^\]]*)\]|\(([^\)]*)\)|(LTS|LT|(\w)\4*o?)|([^\w\[\(]+)/g;
	    while ((match = chunker.exec(formatStr))) {
	        if (match[1]) {
	            chunks.push.apply(chunks, // append
	            splitStringLiteral(match[1]));
	        }
	        else if (match[2]) {
	            chunks.push({ maybe: chunkFormatString(match[2]) });
	        }
	        else if (match[3]) {
	            chunks.push({ token: match[3] });
	        }
	        else if (match[5]) {
	            chunks.push.apply(chunks, // append
	            splitStringLiteral(match[5]));
	        }
	    }
	    return chunks;
	}
	/*
	Potentially splits a literal-text string into multiple parts. For special cases.
	*/
	function splitStringLiteral(s) {
	    if (s === '. ') {
	        return ['.', ' ']; // for locales with periods bound to the end of each year/month/date
	    }
	    else {
	        return [s];
	    }
	}
	/*
	Given chunks parsed from a real format string, generate a fake (aka "intermediate") format string with special control
	characters that will eventually be given to moment for formatting, and then post-processed.
	*/
	function buildFakeFormatString(chunks) {
	    var parts = [];
	    var i;
	    var chunk;
	    for (i = 0; i < chunks.length; i++) {
	        chunk = chunks[i];
	        if (typeof chunk === 'string') {
	            parts.push('[' + chunk + ']');
	        }
	        else if (chunk.token) {
	            if (chunk.token in specialTokens) {
	                parts.push(SPECIAL_TOKEN_MARKER + // useful during post-processing
	                    '[' + chunk.token + ']' // preserve as literal text
	                );
	            }
	            else {
	                parts.push(chunk.token); // unprotected text implies a format string
	            }
	        }
	        else if (chunk.maybe) {
	            parts.push(MAYBE_MARKER + // useful during post-processing
	                buildFakeFormatString(chunk.maybe) +
	                MAYBE_MARKER);
	        }
	    }
	    return parts.join(PART_SEPARATOR);
	}
	/*
	Given parsed chunks from a real formatting string, generates an array of unit strings (like "day") that indicate
	in which regard two dates must be similar in order to share range formatting text.
	The `chunks` can be nested (because of "maybe" chunks), however, the returned array will be flat.
	*/
	function buildSameUnits(chunks) {
	    var units = [];
	    var i;
	    var chunk;
	    var tokenInfo;
	    for (i = 0; i < chunks.length; i++) {
	        chunk = chunks[i];
	        if (chunk.token) {
	            tokenInfo = largeTokenMap[chunk.token.charAt(0)];
	            units.push(tokenInfo ? tokenInfo.unit : 'second'); // default to a very strict same-second
	        }
	        else if (chunk.maybe) {
	            units.push.apply(units, // append
	            buildSameUnits(chunk.maybe));
	        }
	        else {
	            units.push(null);
	        }
	    }
	    return units;
	}
	// Rendering to text
	// ---------------------------------------------------------------------------------------------------------------------
	/*
	Formats a date with a fake format string, post-processes the control characters, then returns.
	*/
	function renderFakeFormatString(fakeFormatString, date) {
	    return processMaybeMarkers(renderFakeFormatStringParts(fakeFormatString, date).join(''));
	}
	/*
	Formats a date into parts that will have been post-processed, EXCEPT for the "maybe" markers.
	*/
	function renderFakeFormatStringParts(fakeFormatString, date) {
	    var parts = [];
	    var fakeRender = moment_ext_1.oldMomentFormat(date, fakeFormatString);
	    var fakeParts = fakeRender.split(PART_SEPARATOR);
	    var i;
	    var fakePart;
	    for (i = 0; i < fakeParts.length; i++) {
	        fakePart = fakeParts[i];
	        if (fakePart.charAt(0) === SPECIAL_TOKEN_MARKER) {
	            parts.push(
	            // the literal string IS the token's name.
	            // call special token's registered function.
	            specialTokens[fakePart.substring(1)](date));
	        }
	        else {
	            parts.push(fakePart);
	        }
	    }
	    return parts;
	}
	/*
	Accepts an almost-finally-formatted string and processes the "maybe" control characters, returning a new string.
	*/
	function processMaybeMarkers(s) {
	    return s.replace(MAYBE_REGEXP, function (m0, m1) {
	        if (m1.match(/[1-9]/)) {
	            return m1;
	        }
	        else {
	            return '';
	        }
	    });
	}
	// Misc Utils
	// -------------------------------------------------------------------------------------------------
	/*
	Returns a unit string, either 'year', 'month', 'day', or null for the most granular formatting token in the string.
	*/
	function queryMostGranularFormatUnit(formatStr) {
	    var chunks = chunkFormatString(formatStr);
	    var i;
	    var chunk;
	    var candidate;
	    var best;
	    for (i = 0; i < chunks.length; i++) {
	        chunk = chunks[i];
	        if (chunk.token) {
	            candidate = largeTokenMap[chunk.token.charAt(0)];
	            if (candidate) {
	                if (!best || candidate.value > best.value) {
	                    best = candidate;
	                }
	            }
	        }
	    }
	    if (best) {
	        return best.unit;
	    }
	    return null;
	}
	exports.queryMostGranularFormatUnit = queryMostGranularFormatUnit;
	
	
	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var Class_1 = __webpack_require__(32);
	var EmitterMixin_1 = __webpack_require__(11);
	var ListenerMixin_1 = __webpack_require__(7);
	var Model = /** @class */ (function (_super) {
	    tslib_1.__extends(Model, _super);
	    function Model() {
	        var _this = _super.call(this) || this;
	        _this._watchers = {};
	        _this._props = {};
	        _this.applyGlobalWatchers();
	        _this.constructed();
	        return _this;
	    }
	    Model.watch = function (name) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        // subclasses should make a masked-copy of the superclass's map
	        // TODO: write test
	        if (!this.prototype.hasOwnProperty('_globalWatchArgs')) {
	            this.prototype._globalWatchArgs = Object.create(this.prototype._globalWatchArgs);
	        }
	        this.prototype._globalWatchArgs[name] = args;
	    };
	    Model.prototype.constructed = function () {
	        // useful for monkeypatching. TODO: BaseClass?
	    };
	    Model.prototype.applyGlobalWatchers = function () {
	        var map = this._globalWatchArgs;
	        var name;
	        for (name in map) {
	            this.watch.apply(this, [name].concat(map[name]));
	        }
	    };
	    Model.prototype.has = function (name) {
	        return name in this._props;
	    };
	    Model.prototype.get = function (name) {
	        if (name === undefined) {
	            return this._props;
	        }
	        return this._props[name];
	    };
	    Model.prototype.set = function (name, val) {
	        var newProps;
	        if (typeof name === 'string') {
	            newProps = {};
	            newProps[name] = val === undefined ? null : val;
	        }
	        else {
	            newProps = name;
	        }
	        this.setProps(newProps);
	    };
	    Model.prototype.reset = function (newProps) {
	        var oldProps = this._props;
	        var changeset = {}; // will have undefined's to signal unsets
	        var name;
	        for (name in oldProps) {
	            changeset[name] = undefined;
	        }
	        for (name in newProps) {
	            changeset[name] = newProps[name];
	        }
	        this.setProps(changeset);
	    };
	    Model.prototype.unset = function (name) {
	        var newProps = {};
	        var names;
	        var i;
	        if (typeof name === 'string') {
	            names = [name];
	        }
	        else {
	            names = name;
	        }
	        for (i = 0; i < names.length; i++) {
	            newProps[names[i]] = undefined;
	        }
	        this.setProps(newProps);
	    };
	    Model.prototype.setProps = function (newProps) {
	        var changedProps = {};
	        var changedCnt = 0;
	        var name;
	        var val;
	        for (name in newProps) {
	            val = newProps[name];
	            // a change in value?
	            // if an object, don't check equality, because might have been mutated internally.
	            // TODO: eventually enforce immutability.
	            if (typeof val === 'object' ||
	                val !== this._props[name]) {
	                changedProps[name] = val;
	                changedCnt++;
	            }
	        }
	        if (changedCnt) {
	            this.trigger('before:batchChange', changedProps);
	            for (name in changedProps) {
	                val = changedProps[name];
	                this.trigger('before:change', name, val);
	                this.trigger('before:change:' + name, val);
	            }
	            for (name in changedProps) {
	                val = changedProps[name];
	                if (val === undefined) {
	                    delete this._props[name];
	                }
	                else {
	                    this._props[name] = val;
	                }
	                this.trigger('change:' + name, val);
	                this.trigger('change', name, val);
	            }
	            this.trigger('batchChange', changedProps);
	        }
	    };
	    Model.prototype.watch = function (name, depList, startFunc, stopFunc) {
	        var _this = this;
	        this.unwatch(name);
	        this._watchers[name] = this._watchDeps(depList, function (deps) {
	            var res = startFunc.call(_this, deps);
	            if (res && res.then) {
	                _this.unset(name); // put in an unset state while resolving
	                res.then(function (val) {
	                    _this.set(name, val);
	                });
	            }
	            else {
	                _this.set(name, res);
	            }
	        }, function (deps) {
	            _this.unset(name);
	            if (stopFunc) {
	                stopFunc.call(_this, deps);
	            }
	        });
	    };
	    Model.prototype.unwatch = function (name) {
	        var watcher = this._watchers[name];
	        if (watcher) {
	            delete this._watchers[name];
	            watcher.teardown();
	        }
	    };
	    Model.prototype._watchDeps = function (depList, startFunc, stopFunc) {
	        var _this = this;
	        var queuedChangeCnt = 0;
	        var depCnt = depList.length;
	        var satisfyCnt = 0;
	        var values = {}; // what's passed as the `deps` arguments
	        var bindTuples = []; // array of [ eventName, handlerFunc ] arrays
	        var isCallingStop = false;
	        var onBeforeDepChange = function (depName, val, isOptional) {
	            queuedChangeCnt++;
	            if (queuedChangeCnt === 1) {
	                if (satisfyCnt === depCnt) {
	                    isCallingStop = true;
	                    stopFunc(values);
	                    isCallingStop = false;
	                }
	            }
	        };
	        var onDepChange = function (depName, val, isOptional) {
	            if (val === undefined) {
	                // required dependency that was previously set?
	                if (!isOptional && values[depName] !== undefined) {
	                    satisfyCnt--;
	                }
	                delete values[depName];
	            }
	            else {
	                // required dependency that was previously unset?
	                if (!isOptional && values[depName] === undefined) {
	                    satisfyCnt++;
	                }
	                values[depName] = val;
	            }
	            queuedChangeCnt--;
	            if (!queuedChangeCnt) {
	                // now finally satisfied or satisfied all along?
	                if (satisfyCnt === depCnt) {
	                    // if the stopFunc initiated another value change, ignore it.
	                    // it will be processed by another change event anyway.
	                    if (!isCallingStop) {
	                        startFunc(values);
	                    }
	                }
	            }
	        };
	        // intercept for .on() that remembers handlers
	        var bind = function (eventName, handler) {
	            _this.on(eventName, handler);
	            bindTuples.push([eventName, handler]);
	        };
	        // listen to dependency changes
	        depList.forEach(function (depName) {
	            var isOptional = false;
	            if (depName.charAt(0) === '?') {
	                depName = depName.substring(1);
	                isOptional = true;
	            }
	            bind('before:change:' + depName, function (val) {
	                onBeforeDepChange(depName, val, isOptional);
	            });
	            bind('change:' + depName, function (val) {
	                onDepChange(depName, val, isOptional);
	            });
	        });
	        // process current dependency values
	        depList.forEach(function (depName) {
	            var isOptional = false;
	            if (depName.charAt(0) === '?') {
	                depName = depName.substring(1);
	                isOptional = true;
	            }
	            if (_this.has(depName)) {
	                values[depName] = _this.get(depName);
	                satisfyCnt++;
	            }
	            else if (isOptional) {
	                satisfyCnt++;
	            }
	        });
	        // initially satisfied
	        if (satisfyCnt === depCnt) {
	            startFunc(values);
	        }
	        return {
	            teardown: function () {
	                // remove all handlers
	                for (var i = 0; i < bindTuples.length; i++) {
	                    _this.off(bindTuples[i][0], bindTuples[i][1]);
	                }
	                bindTuples = null;
	                // was satisfied, so call stopFunc
	                if (satisfyCnt === depCnt) {
	                    stopFunc();
	                }
	            },
	            flash: function () {
	                if (satisfyCnt === depCnt) {
	                    stopFunc();
	                    startFunc(values);
	                }
	            }
	        };
	    };
	    Model.prototype.flash = function (name) {
	        var watcher = this._watchers[name];
	        if (watcher) {
	            watcher.flash();
	        }
	    };
	    return Model;
	}(Class_1.default));
	exports.default = Model;
	Model.prototype._globalWatchArgs = {}; // mutation protection in Model.watch
	EmitterMixin_1.default.mixInto(Model);
	ListenerMixin_1.default.mixInto(Model);
	
	
	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(0);
	var util_1 = __webpack_require__(4);
	var SingleEventDef_1 = __webpack_require__(13);
	var RecurringEventDef_1 = __webpack_require__(210);
	exports.default = {
	    parse: function (eventInput, source) {
	        if (util_1.isTimeString(eventInput.start) || moment.isDuration(eventInput.start) ||
	            util_1.isTimeString(eventInput.end) || moment.isDuration(eventInput.end)) {
	            return RecurringEventDef_1.default.parse(eventInput, source);
	        }
	        else {
	            return SingleEventDef_1.default.parse(eventInput, source);
	        }
	    }
	};
	
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(4);
	var EventDateProfile_1 = __webpack_require__(17);
	var EventDefDateMutation = /** @class */ (function () {
	    function EventDefDateMutation() {
	        this.clearEnd = false;
	        this.forceTimed = false;
	        this.forceAllDay = false;
	    }
	    EventDefDateMutation.createFromDiff = function (dateProfile0, dateProfile1, largeUnit) {
	        var clearEnd = dateProfile0.end && !dateProfile1.end;
	        var forceTimed = dateProfile0.isAllDay() && !dateProfile1.isAllDay();
	        var forceAllDay = !dateProfile0.isAllDay() && dateProfile1.isAllDay();
	        var dateDelta;
	        var endDiff;
	        var endDelta;
	        var mutation;
	        // subtracts the dates in the appropriate way, returning a duration
	        function subtractDates(date1, date0) {
	            if (largeUnit) {
	                return util_1.diffByUnit(date1, date0, largeUnit); // poorly named
	            }
	            else if (dateProfile1.isAllDay()) {
	                return util_1.diffDay(date1, date0); // poorly named
	            }
	            else {
	                return util_1.diffDayTime(date1, date0); // poorly named
	            }
	        }
	        dateDelta = subtractDates(dateProfile1.start, dateProfile0.start);
	        if (dateProfile1.end) {
	            // use unzonedRanges because dateProfile0.end might be null
	            endDiff = subtractDates(dateProfile1.unzonedRange.getEnd(), dateProfile0.unzonedRange.getEnd());
	            endDelta = endDiff.subtract(dateDelta);
	        }
	        mutation = new EventDefDateMutation();
	        mutation.clearEnd = clearEnd;
	        mutation.forceTimed = forceTimed;
	        mutation.forceAllDay = forceAllDay;
	        mutation.setDateDelta(dateDelta);
	        mutation.setEndDelta(endDelta);
	        return mutation;
	    };
	    /*
	    returns an undo function.
	    */
	    EventDefDateMutation.prototype.buildNewDateProfile = function (eventDateProfile, calendar) {
	        var start = eventDateProfile.start.clone();
	        var end = null;
	        var shouldRezone = false;
	        if (eventDateProfile.end && !this.clearEnd) {
	            end = eventDateProfile.end.clone();
	        }
	        else if (this.endDelta && !end) {
	            end = calendar.getDefaultEventEnd(eventDateProfile.isAllDay(), start);
	        }
	        if (this.forceTimed) {
	            shouldRezone = true;
	            if (!start.hasTime()) {
	                start.time(0);
	            }
	            if (end && !end.hasTime()) {
	                end.time(0);
	            }
	        }
	        else if (this.forceAllDay) {
	            if (start.hasTime()) {
	                start.stripTime();
	            }
	            if (end && end.hasTime()) {
	                end.stripTime();
	            }
	        }
	        if (this.dateDelta) {
	            shouldRezone = true;
	            start.add(this.dateDelta);
	            if (end) {
	                end.add(this.dateDelta);
	            }
	        }
	        // do this before adding startDelta to start, so we can work off of start
	        if (this.endDelta) {
	            shouldRezone = true;
	            end.add(this.endDelta);
	        }
	        if (this.startDelta) {
	            shouldRezone = true;
	            start.add(this.startDelta);
	        }
	        if (shouldRezone) {
	            start = calendar.applyTimezone(start);
	            if (end) {
	                end = calendar.applyTimezone(end);
	            }
	        }
	        // TODO: okay to access calendar option?
	        if (!end && calendar.opt('forceEventDuration')) {
	            end = calendar.getDefaultEventEnd(eventDateProfile.isAllDay(), start);
	        }
	        return new EventDateProfile_1.default(start, end, calendar);
	    };
	    EventDefDateMutation.prototype.setDateDelta = function (dateDelta) {
	        if (dateDelta && dateDelta.valueOf()) {
	            this.dateDelta = dateDelta;
	        }
	        else {
	            this.dateDelta = null;
	        }
	    };
	    EventDefDateMutation.prototype.setStartDelta = function (startDelta) {
	        if (startDelta && startDelta.valueOf()) {
	            this.startDelta = startDelta;
	        }
	        else {
	            this.startDelta = null;
	        }
	    };
	    EventDefDateMutation.prototype.setEndDelta = function (endDelta) {
	        if (endDelta && endDelta.valueOf()) {
	            this.endDelta = endDelta;
	        }
	        else {
	            this.endDelta = null;
	        }
	    };
	    EventDefDateMutation.prototype.isEmpty = function () {
	        return !this.clearEnd && !this.forceTimed && !this.forceAllDay &&
	            !this.dateDelta && !this.startDelta && !this.endDelta;
	    };
	    return EventDefDateMutation;
	}());
	exports.default = EventDefDateMutation;
	
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var StandardTheme_1 = __webpack_require__(213);
	var JqueryUiTheme_1 = __webpack_require__(214);
	var themeClassHash = {};
	function defineThemeSystem(themeName, themeClass) {
	    themeClassHash[themeName] = themeClass;
	}
	exports.defineThemeSystem = defineThemeSystem;
	function getThemeSystemClass(themeSetting) {
	    if (!themeSetting) {
	        return StandardTheme_1.default;
	    }
	    else if (themeSetting === true) {
	        return JqueryUiTheme_1.default;
	    }
	    else {
	        return themeClassHash[themeSetting];
	    }
	}
	exports.getThemeSystemClass = getThemeSystemClass;
	
	
	/***/ }),
	/* 52 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var Promise_1 = __webpack_require__(19);
	var EventSource_1 = __webpack_require__(6);
	var SingleEventDef_1 = __webpack_require__(13);
	var ArrayEventSource = /** @class */ (function (_super) {
	    tslib_1.__extends(ArrayEventSource, _super);
	    function ArrayEventSource(calendar) {
	        var _this = _super.call(this, calendar) || this;
	        _this.eventDefs = []; // for if setRawEventDefs is never called
	        return _this;
	    }
	    ArrayEventSource.parse = function (rawInput, calendar) {
	        var rawProps;
	        // normalize raw input
	        if ($.isArray(rawInput.events)) {
	            rawProps = rawInput;
	        }
	        else if ($.isArray(rawInput)) {
	            rawProps = { events: rawInput };
	        }
	        if (rawProps) {
	            return EventSource_1.default.parse.call(this, rawProps, calendar);
	        }
	        return false;
	    };
	    ArrayEventSource.prototype.setRawEventDefs = function (rawEventDefs) {
	        this.rawEventDefs = rawEventDefs;
	        this.eventDefs = this.parseEventDefs(rawEventDefs);
	    };
	    ArrayEventSource.prototype.fetch = function (start, end, timezone) {
	        var eventDefs = this.eventDefs;
	        var i;
	        if (this.currentTimezone != null &&
	            this.currentTimezone !== timezone) {
	            for (i = 0; i < eventDefs.length; i++) {
	                if (eventDefs[i] instanceof SingleEventDef_1.default) {
	                    eventDefs[i].rezone();
	                }
	            }
	        }
	        this.currentTimezone = timezone;
	        return Promise_1.default.resolve(eventDefs);
	    };
	    ArrayEventSource.prototype.addEventDef = function (eventDef) {
	        this.eventDefs.push(eventDef);
	    };
	    /*
	    eventDefId already normalized to a string
	    */
	    ArrayEventSource.prototype.removeEventDefsById = function (eventDefId) {
	        return util_1.removeMatching(this.eventDefs, function (eventDef) {
	            return eventDef.id === eventDefId;
	        });
	    };
	    ArrayEventSource.prototype.removeAllEventDefs = function () {
	        this.eventDefs = [];
	    };
	    ArrayEventSource.prototype.getPrimitive = function () {
	        return this.rawEventDefs;
	    };
	    ArrayEventSource.prototype.applyManualStandardProps = function (rawProps) {
	        var superSuccess = _super.prototype.applyManualStandardProps.call(this, rawProps);
	        this.setRawEventDefs(rawProps.events);
	        return superSuccess;
	    };
	    return ArrayEventSource;
	}(EventSource_1.default));
	exports.default = ArrayEventSource;
	ArrayEventSource.defineStandardProps({
	    events: false // don't automatically transfer
	});
	
	
	/***/ }),
	/* 53 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	/*
	A cache for the left/right/top/bottom/width/height values for one or more elements.
	Works with both offset (from topleft document) and position (from offsetParent).
	
	options:
	- els
	- isHorizontal
	- isVertical
	*/
	var CoordCache = /** @class */ (function () {
	    function CoordCache(options) {
	        this.isHorizontal = false; // whether to query for left/right/width
	        this.isVertical = false; // whether to query for top/bottom/height
	        this.els = $(options.els);
	        this.isHorizontal = options.isHorizontal;
	        this.isVertical = options.isVertical;
	        this.forcedOffsetParentEl = options.offsetParent ? $(options.offsetParent) : null;
	    }
	    // Queries the els for coordinates and stores them.
	    // Call this method before using and of the get* methods below.
	    CoordCache.prototype.build = function () {
	        var offsetParentEl = this.forcedOffsetParentEl;
	        if (!offsetParentEl && this.els.length > 0) {
	            offsetParentEl = this.els.eq(0).offsetParent();
	        }
	        this.origin = offsetParentEl ?
	            offsetParentEl.offset() :
	            null;
	        this.boundingRect = this.queryBoundingRect();
	        if (this.isHorizontal) {
	            this.buildElHorizontals();
	        }
	        if (this.isVertical) {
	            this.buildElVerticals();
	        }
	    };
	    // Destroys all internal data about coordinates, freeing memory
	    CoordCache.prototype.clear = function () {
	        this.origin = null;
	        this.boundingRect = null;
	        this.lefts = null;
	        this.rights = null;
	        this.tops = null;
	        this.bottoms = null;
	    };
	    // When called, if coord caches aren't built, builds them
	    CoordCache.prototype.ensureBuilt = function () {
	        if (!this.origin) {
	            this.build();
	        }
	    };
	    // Populates the left/right internal coordinate arrays
	    CoordCache.prototype.buildElHorizontals = function () {
	        var lefts = [];
	        var rights = [];
	        this.els.each(function (i, node) {
	            var el = $(node);
	            var left = el.offset().left;
	            var width = el.outerWidth();
	            lefts.push(left);
	            rights.push(left + width);
	        });
	        this.lefts = lefts;
	        this.rights = rights;
	    };
	    // Populates the top/bottom internal coordinate arrays
	    CoordCache.prototype.buildElVerticals = function () {
	        var tops = [];
	        var bottoms = [];
	        this.els.each(function (i, node) {
	            var el = $(node);
	            var top = el.offset().top;
	            var height = el.outerHeight();
	            tops.push(top);
	            bottoms.push(top + height);
	        });
	        this.tops = tops;
	        this.bottoms = bottoms;
	    };
	    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
	    // If no intersection is made, returns undefined.
	    CoordCache.prototype.getHorizontalIndex = function (leftOffset) {
	        this.ensureBuilt();
	        var lefts = this.lefts;
	        var rights = this.rights;
	        var len = lefts.length;
	        var i;
	        for (i = 0; i < len; i++) {
	            if (leftOffset >= lefts[i] && leftOffset < rights[i]) {
	                return i;
	            }
	        }
	    };
	    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
	    // If no intersection is made, returns undefined.
	    CoordCache.prototype.getVerticalIndex = function (topOffset) {
	        this.ensureBuilt();
	        var tops = this.tops;
	        var bottoms = this.bottoms;
	        var len = tops.length;
	        var i;
	        for (i = 0; i < len; i++) {
	            if (topOffset >= tops[i] && topOffset < bottoms[i]) {
	                return i;
	            }
	        }
	    };
	    // Gets the left offset (from document left) of the element at the given index
	    CoordCache.prototype.getLeftOffset = function (leftIndex) {
	        this.ensureBuilt();
	        return this.lefts[leftIndex];
	    };
	    // Gets the left position (from offsetParent left) of the element at the given index
	    CoordCache.prototype.getLeftPosition = function (leftIndex) {
	        this.ensureBuilt();
	        return this.lefts[leftIndex] - this.origin.left;
	    };
	    // Gets the right offset (from document left) of the element at the given index.
	    // This value is NOT relative to the document's right edge, like the CSS concept of "right" would be.
	    CoordCache.prototype.getRightOffset = function (leftIndex) {
	        this.ensureBuilt();
	        return this.rights[leftIndex];
	    };
	    // Gets the right position (from offsetParent left) of the element at the given index.
	    // This value is NOT relative to the offsetParent's right edge, like the CSS concept of "right" would be.
	    CoordCache.prototype.getRightPosition = function (leftIndex) {
	        this.ensureBuilt();
	        return this.rights[leftIndex] - this.origin.left;
	    };
	    // Gets the width of the element at the given index
	    CoordCache.prototype.getWidth = function (leftIndex) {
	        this.ensureBuilt();
	        return this.rights[leftIndex] - this.lefts[leftIndex];
	    };
	    // Gets the top offset (from document top) of the element at the given index
	    CoordCache.prototype.getTopOffset = function (topIndex) {
	        this.ensureBuilt();
	        return this.tops[topIndex];
	    };
	    // Gets the top position (from offsetParent top) of the element at the given position
	    CoordCache.prototype.getTopPosition = function (topIndex) {
	        this.ensureBuilt();
	        return this.tops[topIndex] - this.origin.top;
	    };
	    // Gets the bottom offset (from the document top) of the element at the given index.
	    // This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
	    CoordCache.prototype.getBottomOffset = function (topIndex) {
	        this.ensureBuilt();
	        return this.bottoms[topIndex];
	    };
	    // Gets the bottom position (from the offsetParent top) of the element at the given index.
	    // This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
	    CoordCache.prototype.getBottomPosition = function (topIndex) {
	        this.ensureBuilt();
	        return this.bottoms[topIndex] - this.origin.top;
	    };
	    // Gets the height of the element at the given index
	    CoordCache.prototype.getHeight = function (topIndex) {
	        this.ensureBuilt();
	        return this.bottoms[topIndex] - this.tops[topIndex];
	    };
	    // Bounding Rect
	    // TODO: decouple this from CoordCache
	    // Compute and return what the elements' bounding rectangle is, from the user's perspective.
	    // Right now, only returns a rectangle if constrained by an overflow:scroll element.
	    // Returns null if there are no elements
	    CoordCache.prototype.queryBoundingRect = function () {
	        var scrollParentEl;
	        if (this.els.length > 0) {
	            scrollParentEl = util_1.getScrollParent(this.els.eq(0));
	            if (!scrollParentEl.is(document)) {
	                return util_1.getClientRect(scrollParentEl);
	            }
	        }
	        return null;
	    };
	    CoordCache.prototype.isPointInBounds = function (leftOffset, topOffset) {
	        return this.isLeftInBounds(leftOffset) && this.isTopInBounds(topOffset);
	    };
	    CoordCache.prototype.isLeftInBounds = function (leftOffset) {
	        return !this.boundingRect || (leftOffset >= this.boundingRect.left && leftOffset < this.boundingRect.right);
	    };
	    CoordCache.prototype.isTopInBounds = function (topOffset) {
	        return !this.boundingRect || (topOffset >= this.boundingRect.top && topOffset < this.boundingRect.bottom);
	    };
	    return CoordCache;
	}());
	exports.default = CoordCache;
	
	
	/***/ }),
	/* 54 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var ListenerMixin_1 = __webpack_require__(7);
	var GlobalEmitter_1 = __webpack_require__(20);
	/* Tracks a drag's mouse movement, firing various handlers
	----------------------------------------------------------------------------------------------------------------------*/
	// TODO: use Emitter
	var DragListener = /** @class */ (function () {
	    function DragListener(options) {
	        this.isInteracting = false;
	        this.isDistanceSurpassed = false;
	        this.isDelayEnded = false;
	        this.isDragging = false;
	        this.isTouch = false;
	        this.isGeneric = false; // initiated by 'dragstart' (jqui)
	        this.shouldCancelTouchScroll = true;
	        this.scrollAlwaysKills = false;
	        this.isAutoScroll = false;
	        // defaults
	        this.scrollSensitivity = 30; // pixels from edge for scrolling to start
	        this.scrollSpeed = 200; // pixels per second, at maximum speed
	        this.scrollIntervalMs = 50; // millisecond wait between scroll increment
	        this.options = options || {};
	    }
	    // Interaction (high-level)
	    // -----------------------------------------------------------------------------------------------------------------
	    DragListener.prototype.startInteraction = function (ev, extraOptions) {
	        if (extraOptions === void 0) { extraOptions = {}; }
	        if (ev.type === 'mousedown') {
	            if (GlobalEmitter_1.default.get().shouldIgnoreMouse()) {
	                return;
	            }
	            else if (!util_1.isPrimaryMouseButton(ev)) {
	                return;
	            }
	            else {
	                ev.preventDefault(); // prevents native selection in most browsers
	            }
	        }
	        if (!this.isInteracting) {
	            // process options
	            this.delay = util_1.firstDefined(extraOptions.delay, this.options.delay, 0);
	            this.minDistance = util_1.firstDefined(extraOptions.distance, this.options.distance, 0);
	            this.subjectEl = this.options.subjectEl;
	            util_1.preventSelection($('body'));
	            this.isInteracting = true;
	            this.isTouch = util_1.getEvIsTouch(ev);
	            this.isGeneric = ev.type === 'dragstart';
	            this.isDelayEnded = false;
	            this.isDistanceSurpassed = false;
	            this.originX = util_1.getEvX(ev);
	            this.originY = util_1.getEvY(ev);
	            this.scrollEl = util_1.getScrollParent($(ev.target));
	            this.bindHandlers();
	            this.initAutoScroll();
	            this.handleInteractionStart(ev);
	            this.startDelay(ev);
	            if (!this.minDistance) {
	                this.handleDistanceSurpassed(ev);
	            }
	        }
	    };
	    DragListener.prototype.handleInteractionStart = function (ev) {
	        this.trigger('interactionStart', ev);
	    };
	    DragListener.prototype.endInteraction = function (ev, isCancelled) {
	        if (this.isInteracting) {
	            this.endDrag(ev);
	            if (this.delayTimeoutId) {
	                clearTimeout(this.delayTimeoutId);
	                this.delayTimeoutId = null;
	            }
	            this.destroyAutoScroll();
	            this.unbindHandlers();
	            this.isInteracting = false;
	            this.handleInteractionEnd(ev, isCancelled);
	            util_1.allowSelection($('body'));
	        }
	    };
	    DragListener.prototype.handleInteractionEnd = function (ev, isCancelled) {
	        this.trigger('interactionEnd', ev, isCancelled || false);
	    };
	    // Binding To DOM
	    // -----------------------------------------------------------------------------------------------------------------
	    DragListener.prototype.bindHandlers = function () {
	        // some browsers (Safari in iOS 10) don't allow preventDefault on touch events that are bound after touchstart,
	        // so listen to the GlobalEmitter singleton, which is always bound, instead of the document directly.
	        var globalEmitter = GlobalEmitter_1.default.get();
	        if (this.isGeneric) {
	            this.listenTo($(document), {
	                drag: this.handleMove,
	                dragstop: this.endInteraction
	            });
	        }
	        else if (this.isTouch) {
	            this.listenTo(globalEmitter, {
	                touchmove: this.handleTouchMove,
	                touchend: this.endInteraction,
	                scroll: this.handleTouchScroll
	            });
	        }
	        else {
	            this.listenTo(globalEmitter, {
	                mousemove: this.handleMouseMove,
	                mouseup: this.endInteraction
	            });
	        }
	        this.listenTo(globalEmitter, {
	            selectstart: util_1.preventDefault,
	            contextmenu: util_1.preventDefault // long taps would open menu on Chrome dev tools
	        });
	    };
	    DragListener.prototype.unbindHandlers = function () {
	        this.stopListeningTo(GlobalEmitter_1.default.get());
	        this.stopListeningTo($(document)); // for isGeneric
	    };
	    // Drag (high-level)
	    // -----------------------------------------------------------------------------------------------------------------
	    // extraOptions ignored if drag already started
	    DragListener.prototype.startDrag = function (ev, extraOptions) {
	        this.startInteraction(ev, extraOptions); // ensure interaction began
	        if (!this.isDragging) {
	            this.isDragging = true;
	            this.handleDragStart(ev);
	        }
	    };
	    DragListener.prototype.handleDragStart = function (ev) {
	        this.trigger('dragStart', ev);
	    };
	    DragListener.prototype.handleMove = function (ev) {
	        var dx = util_1.getEvX(ev) - this.originX;
	        var dy = util_1.getEvY(ev) - this.originY;
	        var minDistance = this.minDistance;
	        var distanceSq; // current distance from the origin, squared
	        if (!this.isDistanceSurpassed) {
	            distanceSq = dx * dx + dy * dy;
	            if (distanceSq >= minDistance * minDistance) {
	                this.handleDistanceSurpassed(ev);
	            }
	        }
	        if (this.isDragging) {
	            this.handleDrag(dx, dy, ev);
	        }
	    };
	    // Called while the mouse is being moved and when we know a legitimate drag is taking place
	    DragListener.prototype.handleDrag = function (dx, dy, ev) {
	        this.trigger('drag', dx, dy, ev);
	        this.updateAutoScroll(ev); // will possibly cause scrolling
	    };
	    DragListener.prototype.endDrag = function (ev) {
	        if (this.isDragging) {
	            this.isDragging = false;
	            this.handleDragEnd(ev);
	        }
	    };
	    DragListener.prototype.handleDragEnd = function (ev) {
	        this.trigger('dragEnd', ev);
	    };
	    // Delay
	    // -----------------------------------------------------------------------------------------------------------------
	    DragListener.prototype.startDelay = function (initialEv) {
	        var _this = this;
	        if (this.delay) {
	            this.delayTimeoutId = setTimeout(function () {
	                _this.handleDelayEnd(initialEv);
	            }, this.delay);
	        }
	        else {
	            this.handleDelayEnd(initialEv);
	        }
	    };
	    DragListener.prototype.handleDelayEnd = function (initialEv) {
	        this.isDelayEnded = true;
	        if (this.isDistanceSurpassed) {
	            this.startDrag(initialEv);
	        }
	    };
	    // Distance
	    // -----------------------------------------------------------------------------------------------------------------
	    DragListener.prototype.handleDistanceSurpassed = function (ev) {
	        this.isDistanceSurpassed = true;
	        if (this.isDelayEnded) {
	            this.startDrag(ev);
	        }
	    };
	    // Mouse / Touch
	    // -----------------------------------------------------------------------------------------------------------------
	    DragListener.prototype.handleTouchMove = function (ev) {
	        // prevent inertia and touchmove-scrolling while dragging
	        if (this.isDragging && this.shouldCancelTouchScroll) {
	            ev.preventDefault();
	        }
	        this.handleMove(ev);
	    };
	    DragListener.prototype.handleMouseMove = function (ev) {
	        this.handleMove(ev);
	    };
	    // Scrolling (unrelated to auto-scroll)
	    // -----------------------------------------------------------------------------------------------------------------
	    DragListener.prototype.handleTouchScroll = function (ev) {
	        // if the drag is being initiated by touch, but a scroll happens before
	        // the drag-initiating delay is over, cancel the drag
	        if (!this.isDragging || this.scrollAlwaysKills) {
	            this.endInteraction(ev, true); // isCancelled=true
	        }
	    };
	    // Utils
	    // -----------------------------------------------------------------------------------------------------------------
	    // Triggers a callback. Calls a function in the option hash of the same name.
	    // Arguments beyond the first `name` are forwarded on.
	    DragListener.prototype.trigger = function (name) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        if (this.options[name]) {
	            this.options[name].apply(this, args);
	        }
	        // makes _methods callable by event name. TODO: kill this
	        if (this['_' + name]) {
	            this['_' + name].apply(this, args);
	        }
	    };
	    // Auto-scroll
	    // -----------------------------------------------------------------------------------------------------------------
	    DragListener.prototype.initAutoScroll = function () {
	        var scrollEl = this.scrollEl;
	        this.isAutoScroll =
	            this.options.scroll &&
	                scrollEl &&
	                !scrollEl.is(window) &&
	                !scrollEl.is(document);
	        if (this.isAutoScroll) {
	            // debounce makes sure rapid calls don't happen
	            this.listenTo(scrollEl, 'scroll', util_1.debounce(this.handleDebouncedScroll, 100));
	        }
	    };
	    DragListener.prototype.destroyAutoScroll = function () {
	        this.endAutoScroll(); // kill any animation loop
	        // remove the scroll handler if there is a scrollEl
	        if (this.isAutoScroll) {
	            this.stopListeningTo(this.scrollEl, 'scroll'); // will probably get removed by unbindHandlers too :(
	        }
	    };
	    // Computes and stores the bounding rectangle of scrollEl
	    DragListener.prototype.computeScrollBounds = function () {
	        if (this.isAutoScroll) {
	            this.scrollBounds = util_1.getOuterRect(this.scrollEl);
	            // TODO: use getClientRect in future. but prevents auto scrolling when on top of scrollbars
	        }
	    };
	    // Called when the dragging is in progress and scrolling should be updated
	    DragListener.prototype.updateAutoScroll = function (ev) {
	        var sensitivity = this.scrollSensitivity;
	        var bounds = this.scrollBounds;
	        var topCloseness;
	        var bottomCloseness;
	        var leftCloseness;
	        var rightCloseness;
	        var topVel = 0;
	        var leftVel = 0;
	        if (bounds) {
	            // compute closeness to edges. valid range is from 0.0 - 1.0
	            topCloseness = (sensitivity - (util_1.getEvY(ev) - bounds.top)) / sensitivity;
	            bottomCloseness = (sensitivity - (bounds.bottom - util_1.getEvY(ev))) / sensitivity;
	            leftCloseness = (sensitivity - (util_1.getEvX(ev) - bounds.left)) / sensitivity;
	            rightCloseness = (sensitivity - (bounds.right - util_1.getEvX(ev))) / sensitivity;
	            // translate vertical closeness into velocity.
	            // mouse must be completely in bounds for velocity to happen.
	            if (topCloseness >= 0 && topCloseness <= 1) {
	                topVel = topCloseness * this.scrollSpeed * -1; // negative. for scrolling up
	            }
	            else if (bottomCloseness >= 0 && bottomCloseness <= 1) {
	                topVel = bottomCloseness * this.scrollSpeed;
	            }
	            // translate horizontal closeness into velocity
	            if (leftCloseness >= 0 && leftCloseness <= 1) {
	                leftVel = leftCloseness * this.scrollSpeed * -1; // negative. for scrolling left
	            }
	            else if (rightCloseness >= 0 && rightCloseness <= 1) {
	                leftVel = rightCloseness * this.scrollSpeed;
	            }
	        }
	        this.setScrollVel(topVel, leftVel);
	    };
	    // Sets the speed-of-scrolling for the scrollEl
	    DragListener.prototype.setScrollVel = function (topVel, leftVel) {
	        this.scrollTopVel = topVel;
	        this.scrollLeftVel = leftVel;
	        this.constrainScrollVel(); // massages into realistic values
	        // if there is non-zero velocity, and an animation loop hasn't already started, then START
	        if ((this.scrollTopVel || this.scrollLeftVel) && !this.scrollIntervalId) {
	            this.scrollIntervalId = setInterval(util_1.proxy(this, 'scrollIntervalFunc'), // scope to `this`
	            this.scrollIntervalMs);
	        }
	    };
	    // Forces scrollTopVel and scrollLeftVel to be zero if scrolling has already gone all the way
	    DragListener.prototype.constrainScrollVel = function () {
	        var el = this.scrollEl;
	        if (this.scrollTopVel < 0) {
	            if (el.scrollTop() <= 0) {
	                this.scrollTopVel = 0;
	            }
	        }
	        else if (this.scrollTopVel > 0) {
	            if (el.scrollTop() + el[0].clientHeight >= el[0].scrollHeight) {
	                this.scrollTopVel = 0;
	            }
	        }
	        if (this.scrollLeftVel < 0) {
	            if (el.scrollLeft() <= 0) {
	                this.scrollLeftVel = 0;
	            }
	        }
	        else if (this.scrollLeftVel > 0) {
	            if (el.scrollLeft() + el[0].clientWidth >= el[0].scrollWidth) {
	                this.scrollLeftVel = 0;
	            }
	        }
	    };
	    // This function gets called during every iteration of the scrolling animation loop
	    DragListener.prototype.scrollIntervalFunc = function () {
	        var el = this.scrollEl;
	        var frac = this.scrollIntervalMs / 1000; // considering animation frequency, what the vel should be mult'd by
	        // change the value of scrollEl's scroll
	        if (this.scrollTopVel) {
	            el.scrollTop(el.scrollTop() + this.scrollTopVel * frac);
	        }
	        if (this.scrollLeftVel) {
	            el.scrollLeft(el.scrollLeft() + this.scrollLeftVel * frac);
	        }
	        this.constrainScrollVel(); // since the scroll values changed, recompute the velocities
	        // if scrolled all the way, which causes the vels to be zero, stop the animation loop
	        if (!this.scrollTopVel && !this.scrollLeftVel) {
	            this.endAutoScroll();
	        }
	    };
	    // Kills any existing scrolling animation loop
	    DragListener.prototype.endAutoScroll = function () {
	        if (this.scrollIntervalId) {
	            clearInterval(this.scrollIntervalId);
	            this.scrollIntervalId = null;
	            this.handleScrollEnd();
	        }
	    };
	    // Get called when the scrollEl is scrolled (NOTE: this is delayed via debounce)
	    DragListener.prototype.handleDebouncedScroll = function () {
	        // recompute all coordinates, but *only* if this is *not* part of our scrolling animation
	        if (!this.scrollIntervalId) {
	            this.handleScrollEnd();
	        }
	    };
	    DragListener.prototype.handleScrollEnd = function () {
	        // Called when scrolling has stopped, whether through auto scroll, or the user scrolling
	    };
	    return DragListener;
	}());
	exports.default = DragListener;
	ListenerMixin_1.default.mixInto(DragListener);
	
	
	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var util_1 = __webpack_require__(4);
	var Mixin_1 = __webpack_require__(14);
	/*
	A set of rendering and date-related methods for a visual component comprised of one or more rows of day columns.
	Prerequisite: the object being mixed into needs to be a *Grid*
	*/
	var DayTableMixin = /** @class */ (function (_super) {
	    tslib_1.__extends(DayTableMixin, _super);
	    function DayTableMixin() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // Populates internal variables used for date calculation and rendering
	    DayTableMixin.prototype.updateDayTable = function () {
	        var t = this;
	        var view = t.view;
	        var calendar = view.calendar;
	        var date = calendar.msToUtcMoment(t.dateProfile.renderUnzonedRange.startMs, true);
	        var end = calendar.msToUtcMoment(t.dateProfile.renderUnzonedRange.endMs, true);
	        var dayIndex = -1;
	        var dayIndices = [];
	        var dayDates = [];
	        var daysPerRow;
	        var firstDay;
	        var rowCnt;
	        while (date.isBefore(end)) {
	            if (view.isHiddenDay(date)) {
	                dayIndices.push(dayIndex + 0.5); // mark that it's between indices
	            }
	            else {
	                dayIndex++;
	                dayIndices.push(dayIndex);
	                dayDates.push(date.clone());
	            }
	            date.add(1, 'days');
	        }
	        if (this.breakOnWeeks) {
	            // count columns until the day-of-week repeats
	            firstDay = dayDates[0].day();
	            for (daysPerRow = 1; daysPerRow < dayDates.length; daysPerRow++) {
	                if (dayDates[daysPerRow].day() === firstDay) {
	                    break;
	                }
	            }
	            rowCnt = Math.ceil(dayDates.length / daysPerRow);
	        }
	        else {
	            rowCnt = 1;
	            daysPerRow = dayDates.length;
	        }
	        this.dayDates = dayDates;
	        this.dayIndices = dayIndices;
	        this.daysPerRow = daysPerRow;
	        this.rowCnt = rowCnt;
	        this.updateDayTableCols();
	    };
	    // Computes and assigned the colCnt property and updates any options that may be computed from it
	    DayTableMixin.prototype.updateDayTableCols = function () {
	        this.colCnt = this.computeColCnt();
	        this.colHeadFormat =
	            this.opt('columnHeaderFormat') ||
	                this.opt('columnFormat') || // deprecated
	                this.computeColHeadFormat();
	    };
	    // Determines how many columns there should be in the table
	    DayTableMixin.prototype.computeColCnt = function () {
	        return this.daysPerRow;
	    };
	    // Computes the ambiguously-timed moment for the given cell
	    DayTableMixin.prototype.getCellDate = function (row, col) {
	        return this.dayDates[this.getCellDayIndex(row, col)].clone();
	    };
	    // Computes the ambiguously-timed date range for the given cell
	    DayTableMixin.prototype.getCellRange = function (row, col) {
	        var start = this.getCellDate(row, col);
	        var end = start.clone().add(1, 'days');
	        return { start: start, end: end };
	    };
	    // Returns the number of day cells, chronologically, from the first of the grid (0-based)
	    DayTableMixin.prototype.getCellDayIndex = function (row, col) {
	        return row * this.daysPerRow + this.getColDayIndex(col);
	    };
	    // Returns the numner of day cells, chronologically, from the first cell in *any given row*
	    DayTableMixin.prototype.getColDayIndex = function (col) {
	        if (this.isRTL) {
	            return this.colCnt - 1 - col;
	        }
	        else {
	            return col;
	        }
	    };
	    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
	    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
	    // If before the first offset, returns a negative number.
	    // If after the last offset, returns an offset past the last cell offset.
	    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
	    DayTableMixin.prototype.getDateDayIndex = function (date) {
	        var dayIndices = this.dayIndices;
	        var dayOffset = date.diff(this.dayDates[0], 'days');
	        if (dayOffset < 0) {
	            return dayIndices[0] - 1;
	        }
	        else if (dayOffset >= dayIndices.length) {
	            return dayIndices[dayIndices.length - 1] + 1;
	        }
	        else {
	            return dayIndices[dayOffset];
	        }
	    };
	    /* Options
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Computes a default column header formatting string if `colFormat` is not explicitly defined
	    DayTableMixin.prototype.computeColHeadFormat = function () {
	        // if more than one week row, or if there are a lot of columns with not much space,
	        // put just the day numbers will be in each cell
	        if (this.rowCnt > 1 || this.colCnt > 10) {
	            return 'ddd'; // "Sat"
	        }
	        else if (this.colCnt > 1) {
	            return this.opt('dayOfMonthFormat'); // "Sat 12/10"
	        }
	        else {
	            return 'dddd'; // "Saturday"
	        }
	    };
	    /* Slicing
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Slices up a date range into a segment for every week-row it intersects with
	    DayTableMixin.prototype.sliceRangeByRow = function (unzonedRange) {
	        var daysPerRow = this.daysPerRow;
	        var normalRange = this.view.computeDayRange(unzonedRange); // make whole-day range, considering nextDayThreshold
	        var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
	        var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, 'days')); // inclusive last index
	        var segs = [];
	        var row;
	        var rowFirst;
	        var rowLast; // inclusive day-index range for current row
	        var segFirst;
	        var segLast; // inclusive day-index range for segment
	        for (row = 0; row < this.rowCnt; row++) {
	            rowFirst = row * daysPerRow;
	            rowLast = rowFirst + daysPerRow - 1;
	            // intersect segment's offset range with the row's
	            segFirst = Math.max(rangeFirst, rowFirst);
	            segLast = Math.min(rangeLast, rowLast);
	            // deal with in-between indices
	            segFirst = Math.ceil(segFirst); // in-between starts round to next cell
	            segLast = Math.floor(segLast); // in-between ends round to prev cell
	            if (segFirst <= segLast) {
	                segs.push({
	                    row: row,
	                    // normalize to start of row
	                    firstRowDayIndex: segFirst - rowFirst,
	                    lastRowDayIndex: segLast - rowFirst,
	                    // must be matching integers to be the segment's start/end
	                    isStart: segFirst === rangeFirst,
	                    isEnd: segLast === rangeLast
	                });
	            }
	        }
	        return segs;
	    };
	    // Slices up a date range into a segment for every day-cell it intersects with.
	    // TODO: make more DRY with sliceRangeByRow somehow.
	    DayTableMixin.prototype.sliceRangeByDay = function (unzonedRange) {
	        var daysPerRow = this.daysPerRow;
	        var normalRange = this.view.computeDayRange(unzonedRange); // make whole-day range, considering nextDayThreshold
	        var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
	        var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, 'days')); // inclusive last index
	        var segs = [];
	        var row;
	        var rowFirst;
	        var rowLast; // inclusive day-index range for current row
	        var i;
	        var segFirst;
	        var segLast; // inclusive day-index range for segment
	        for (row = 0; row < this.rowCnt; row++) {
	            rowFirst = row * daysPerRow;
	            rowLast = rowFirst + daysPerRow - 1;
	            for (i = rowFirst; i <= rowLast; i++) {
	                // intersect segment's offset range with the row's
	                segFirst = Math.max(rangeFirst, i);
	                segLast = Math.min(rangeLast, i);
	                // deal with in-between indices
	                segFirst = Math.ceil(segFirst); // in-between starts round to next cell
	                segLast = Math.floor(segLast); // in-between ends round to prev cell
	                if (segFirst <= segLast) {
	                    segs.push({
	                        row: row,
	                        // normalize to start of row
	                        firstRowDayIndex: segFirst - rowFirst,
	                        lastRowDayIndex: segLast - rowFirst,
	                        // must be matching integers to be the segment's start/end
	                        isStart: segFirst === rangeFirst,
	                        isEnd: segLast === rangeLast
	                    });
	                }
	            }
	        }
	        return segs;
	    };
	    /* Header Rendering
	    ------------------------------------------------------------------------------------------------------------------*/
	    DayTableMixin.prototype.renderHeadHtml = function () {
	        var theme = this.view.calendar.theme;
	        return '' +
	            '<div class="fc-row ' + theme.getClass('headerRow') + '">' +
	            '<table class="' + theme.getClass('tableGrid') + '">' +
	            '<thead>' +
	            this.renderHeadTrHtml() +
	            '</thead>' +
	            '</table>' +
	            '</div>';
	    };
	    DayTableMixin.prototype.renderHeadIntroHtml = function () {
	        return this.renderIntroHtml(); // fall back to generic
	    };
	    DayTableMixin.prototype.renderHeadTrHtml = function () {
	        return '' +
	            '<tr>' +
	            (this.isRTL ? '' : this.renderHeadIntroHtml()) +
	            this.renderHeadDateCellsHtml() +
	            (this.isRTL ? this.renderHeadIntroHtml() : '') +
	            '</tr>';
	    };
	    DayTableMixin.prototype.renderHeadDateCellsHtml = function () {
	        var htmls = [];
	        var col;
	        var date;
	        for (col = 0; col < this.colCnt; col++) {
	            date = this.getCellDate(0, col);
	            htmls.push(this.renderHeadDateCellHtml(date));
	        }
	        return htmls.join('');
	    };
	    // TODO: when internalApiVersion, accept an object for HTML attributes
	    // (colspan should be no different)
	    DayTableMixin.prototype.renderHeadDateCellHtml = function (date, colspan, otherAttrs) {
	        var t = this;
	        var view = t.view;
	        var isDateValid = t.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.
	        var classNames = [
	            'fc-day-header',
	            view.calendar.theme.getClass('widgetHeader')
	        ];
	        var innerHtml;
	        if (typeof t.opt('columnHeaderHtml') === 'function') {
	            innerHtml = t.opt('columnHeaderHtml')(date);
	        }
	        else if (typeof t.opt('columnHeaderText') === 'function') {
	            innerHtml = util_1.htmlEscape(t.opt('columnHeaderText')(date));
	        }
	        else {
	            innerHtml = util_1.htmlEscape(date.format(t.colHeadFormat));
	        }
	        // if only one row of days, the classNames on the header can represent the specific days beneath
	        if (t.rowCnt === 1) {
	            classNames = classNames.concat(
	            // includes the day-of-week class
	            // noThemeHighlight=true (don't highlight the header)
	            t.getDayClasses(date, true));
	        }
	        else {
	            classNames.push('fc-' + util_1.dayIDs[date.day()]); // only add the day-of-week class
	        }
	        return '' +
	            '<th class="' + classNames.join(' ') + '"' +
	            ((isDateValid && t.rowCnt) === 1 ?
	                ' data-date="' + date.format('YYYY-MM-DD') + '"' :
	                '') +
	            (colspan > 1 ?
	                ' colspan="' + colspan + '"' :
	                '') +
	            (otherAttrs ?
	                ' ' + otherAttrs :
	                '') +
	            '>' +
	            (isDateValid ?
	                // don't make a link if the heading could represent multiple days, or if there's only one day (forceOff)
	                view.buildGotoAnchorHtml({ date: date, forceOff: t.rowCnt > 1 || t.colCnt === 1 }, innerHtml) :
	                // if not valid, display text, but no link
	                innerHtml) +
	            '</th>';
	    };
	    /* Background Rendering
	    ------------------------------------------------------------------------------------------------------------------*/
	    DayTableMixin.prototype.renderBgTrHtml = function (row) {
	        return '' +
	            '<tr>' +
	            (this.isRTL ? '' : this.renderBgIntroHtml(row)) +
	            this.renderBgCellsHtml(row) +
	            (this.isRTL ? this.renderBgIntroHtml(row) : '') +
	            '</tr>';
	    };
	    DayTableMixin.prototype.renderBgIntroHtml = function (row) {
	        return this.renderIntroHtml(); // fall back to generic
	    };
	    DayTableMixin.prototype.renderBgCellsHtml = function (row) {
	        var htmls = [];
	        var col;
	        var date;
	        for (col = 0; col < this.colCnt; col++) {
	            date = this.getCellDate(row, col);
	            htmls.push(this.renderBgCellHtml(date));
	        }
	        return htmls.join('');
	    };
	    DayTableMixin.prototype.renderBgCellHtml = function (date, otherAttrs) {
	        var t = this;
	        var view = t.view;
	        var isDateValid = t.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.
	        var classes = t.getDayClasses(date);
	        classes.unshift('fc-day', view.calendar.theme.getClass('widgetContent'));
	        return '<td class="' + classes.join(' ') + '"' +
	            (isDateValid ?
	                ' data-date="' + date.format('YYYY-MM-DD') + '"' : // if date has a time, won't format it
	                '') +
	            (otherAttrs ?
	                ' ' + otherAttrs :
	                '') +
	            '></td>';
	    };
	    /* Generic
	    ------------------------------------------------------------------------------------------------------------------*/
	    DayTableMixin.prototype.renderIntroHtml = function () {
	        // Generates the default HTML intro for any row. User classes should override
	    };
	    // TODO: a generic method for dealing with <tr>, RTL, intro
	    // when increment internalApiVersion
	    // wrapTr (scheduler)
	    /* Utils
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Applies the generic "intro" and "outro" HTML to the given cells.
	    // Intro means the leftmost cell when the calendar is LTR and the rightmost cell when RTL. Vice-versa for outro.
	    DayTableMixin.prototype.bookendCells = function (trEl) {
	        var introHtml = this.renderIntroHtml();
	        if (introHtml) {
	            if (this.isRTL) {
	                trEl.append(introHtml);
	            }
	            else {
	                trEl.prepend(introHtml);
	            }
	        }
	    };
	    return DayTableMixin;
	}(Mixin_1.default));
	exports.default = DayTableMixin;
	
	
	/***/ }),
	/* 56 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var BusinessHourRenderer = /** @class */ (function () {
	    /*
	    component implements:
	      - eventRangesToEventFootprints
	      - eventFootprintsToSegs
	    */
	    function BusinessHourRenderer(component, fillRenderer) {
	        this.component = component;
	        this.fillRenderer = fillRenderer;
	    }
	    BusinessHourRenderer.prototype.render = function (businessHourGenerator) {
	        var component = this.component;
	        var unzonedRange = component._getDateProfile().activeUnzonedRange;
	        var eventInstanceGroup = businessHourGenerator.buildEventInstanceGroup(component.hasAllDayBusinessHours, unzonedRange);
	        var eventFootprints = eventInstanceGroup ?
	            component.eventRangesToEventFootprints(eventInstanceGroup.sliceRenderRanges(unzonedRange)) :
	            [];
	        this.renderEventFootprints(eventFootprints);
	    };
	    BusinessHourRenderer.prototype.renderEventFootprints = function (eventFootprints) {
	        var segs = this.component.eventFootprintsToSegs(eventFootprints);
	        this.renderSegs(segs);
	        this.segs = segs;
	    };
	    BusinessHourRenderer.prototype.renderSegs = function (segs) {
	        if (this.fillRenderer) {
	            this.fillRenderer.renderSegs('businessHours', segs, {
	                getClasses: function (seg) {
	                    return ['fc-nonbusiness', 'fc-bgevent'];
	                }
	            });
	        }
	    };
	    BusinessHourRenderer.prototype.unrender = function () {
	        if (this.fillRenderer) {
	            this.fillRenderer.unrender('businessHours');
	        }
	        this.segs = null;
	    };
	    BusinessHourRenderer.prototype.getSegs = function () {
	        return this.segs || [];
	    };
	    return BusinessHourRenderer;
	}());
	exports.default = BusinessHourRenderer;
	
	
	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var FillRenderer = /** @class */ (function () {
	    function FillRenderer(component) {
	        this.fillSegTag = 'div';
	        this.component = component;
	        this.elsByFill = {};
	    }
	    FillRenderer.prototype.renderFootprint = function (type, componentFootprint, props) {
	        this.renderSegs(type, this.component.componentFootprintToSegs(componentFootprint), props);
	    };
	    FillRenderer.prototype.renderSegs = function (type, segs, props) {
	        var els;
	        segs = this.buildSegEls(type, segs, props); // assignes `.el` to each seg. returns successfully rendered segs
	        els = this.attachSegEls(type, segs);
	        if (els) {
	            this.reportEls(type, els);
	        }
	        return segs;
	    };
	    // Unrenders a specific type of fill that is currently rendered on the grid
	    FillRenderer.prototype.unrender = function (type) {
	        var el = this.elsByFill[type];
	        if (el) {
	            el.remove();
	            delete this.elsByFill[type];
	        }
	    };
	    // Renders and assigns an `el` property for each fill segment. Generic enough to work with different types.
	    // Only returns segments that successfully rendered.
	    FillRenderer.prototype.buildSegEls = function (type, segs, props) {
	        var _this = this;
	        var html = '';
	        var renderedSegs = [];
	        var i;
	        if (segs.length) {
	            // build a large concatenation of segment HTML
	            for (i = 0; i < segs.length; i++) {
	                html += this.buildSegHtml(type, segs[i], props);
	            }
	            // Grab individual elements from the combined HTML string. Use each as the default rendering.
	            // Then, compute the 'el' for each segment.
	            $(html).each(function (i, node) {
	                var seg = segs[i];
	                var el = $(node);
	                // allow custom filter methods per-type
	                if (props.filterEl) {
	                    el = props.filterEl(seg, el);
	                }
	                if (el) {
	                    el = $(el); // allow custom filter to return raw DOM node
	                    // correct element type? (would be bad if a non-TD were inserted into a table for example)
	                    if (el.is(_this.fillSegTag)) {
	                        seg.el = el;
	                        renderedSegs.push(seg);
	                    }
	                }
	            });
	        }
	        return renderedSegs;
	    };
	    // Builds the HTML needed for one fill segment. Generic enough to work with different types.
	    FillRenderer.prototype.buildSegHtml = function (type, seg, props) {
	        // custom hooks per-type
	        var classes = props.getClasses ? props.getClasses(seg) : [];
	        var css = util_1.cssToStr(props.getCss ? props.getCss(seg) : {});
	        return '<' + this.fillSegTag +
	            (classes.length ? ' class="' + classes.join(' ') + '"' : '') +
	            (css ? ' style="' + css + '"' : '') +
	            ' />';
	    };
	    // Should return wrapping DOM structure
	    FillRenderer.prototype.attachSegEls = function (type, segs) {
	        // subclasses must implement
	    };
	    FillRenderer.prototype.reportEls = function (type, nodes) {
	        if (this.elsByFill[type]) {
	            this.elsByFill[type] = this.elsByFill[type].add(nodes);
	        }
	        else {
	            this.elsByFill[type] = $(nodes);
	        }
	    };
	    return FillRenderer;
	}());
	exports.default = FillRenderer;
	
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var SingleEventDef_1 = __webpack_require__(13);
	var EventFootprint_1 = __webpack_require__(35);
	var EventSource_1 = __webpack_require__(6);
	var HelperRenderer = /** @class */ (function () {
	    function HelperRenderer(component, eventRenderer) {
	        this.view = component._getView();
	        this.component = component;
	        this.eventRenderer = eventRenderer;
	    }
	    HelperRenderer.prototype.renderComponentFootprint = function (componentFootprint) {
	        this.renderEventFootprints([
	            this.fabricateEventFootprint(componentFootprint)
	        ]);
	    };
	    HelperRenderer.prototype.renderEventDraggingFootprints = function (eventFootprints, sourceSeg, isTouch) {
	        this.renderEventFootprints(eventFootprints, sourceSeg, 'fc-dragging', isTouch ? null : this.view.opt('dragOpacity'));
	    };
	    HelperRenderer.prototype.renderEventResizingFootprints = function (eventFootprints, sourceSeg, isTouch) {
	        this.renderEventFootprints(eventFootprints, sourceSeg, 'fc-resizing');
	    };
	    HelperRenderer.prototype.renderEventFootprints = function (eventFootprints, sourceSeg, extraClassNames, opacity) {
	        var segs = this.component.eventFootprintsToSegs(eventFootprints);
	        var classNames = 'fc-helper ' + (extraClassNames || '');
	        var i;
	        // assigns each seg's el and returns a subset of segs that were rendered
	        segs = this.eventRenderer.renderFgSegEls(segs);
	        for (i = 0; i < segs.length; i++) {
	            segs[i].el.addClass(classNames);
	        }
	        if (opacity != null) {
	            for (i = 0; i < segs.length; i++) {
	                segs[i].el.css('opacity', opacity);
	            }
	        }
	        this.helperEls = this.renderSegs(segs, sourceSeg);
	    };
	    /*
	    Must return all mock event elements
	    */
	    HelperRenderer.prototype.renderSegs = function (segs, sourceSeg) {
	        // Subclasses must implement
	    };
	    HelperRenderer.prototype.unrender = function () {
	        if (this.helperEls) {
	            this.helperEls.remove();
	            this.helperEls = null;
	        }
	    };
	    HelperRenderer.prototype.fabricateEventFootprint = function (componentFootprint) {
	        var calendar = this.view.calendar;
	        var eventDateProfile = calendar.footprintToDateProfile(componentFootprint);
	        var dummyEvent = new SingleEventDef_1.default(new EventSource_1.default(calendar));
	        var dummyInstance;
	        dummyEvent.dateProfile = eventDateProfile;
	        dummyInstance = dummyEvent.buildInstance();
	        return new EventFootprint_1.default(componentFootprint, dummyEvent, dummyInstance);
	    };
	    return HelperRenderer;
	}());
	exports.default = HelperRenderer;
	
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var GlobalEmitter_1 = __webpack_require__(20);
	var Interaction_1 = __webpack_require__(15);
	var EventPointing = /** @class */ (function (_super) {
	    tslib_1.__extends(EventPointing, _super);
	    function EventPointing() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /*
	    component must implement:
	      - publiclyTrigger
	    */
	    EventPointing.prototype.bindToEl = function (el) {
	        var component = this.component;
	        component.bindSegHandlerToEl(el, 'click', this.handleClick.bind(this));
	        component.bindSegHandlerToEl(el, 'mouseenter', this.handleMouseover.bind(this));
	        component.bindSegHandlerToEl(el, 'mouseleave', this.handleMouseout.bind(this));
	    };
	    EventPointing.prototype.handleClick = function (seg, ev) {
	        var res = this.component.publiclyTrigger('eventClick', {
	            context: seg.el[0],
	            args: [seg.footprint.getEventLegacy(), ev, this.view]
	        });
	        if (res === false) {
	            ev.preventDefault();
	        }
	    };
	    // Updates internal state and triggers handlers for when an event element is moused over
	    EventPointing.prototype.handleMouseover = function (seg, ev) {
	        if (!GlobalEmitter_1.default.get().shouldIgnoreMouse() &&
	            !this.mousedOverSeg) {
	            this.mousedOverSeg = seg;
	            // TODO: move to EventSelecting's responsibility
	            if (this.view.isEventDefResizable(seg.footprint.eventDef)) {
	                seg.el.addClass('fc-allow-mouse-resize');
	            }
	            this.component.publiclyTrigger('eventMouseover', {
	                context: seg.el[0],
	                args: [seg.footprint.getEventLegacy(), ev, this.view]
	            });
	        }
	    };
	    // Updates internal state and triggers handlers for when an event element is moused out.
	    // Can be given no arguments, in which case it will mouseout the segment that was previously moused over.
	    EventPointing.prototype.handleMouseout = function (seg, ev) {
	        if (this.mousedOverSeg) {
	            this.mousedOverSeg = null;
	            // TODO: move to EventSelecting's responsibility
	            if (this.view.isEventDefResizable(seg.footprint.eventDef)) {
	                seg.el.removeClass('fc-allow-mouse-resize');
	            }
	            this.component.publiclyTrigger('eventMouseout', {
	                context: seg.el[0],
	                args: [
	                    seg.footprint.getEventLegacy(),
	                    ev || {},
	                    this.view
	                ]
	            });
	        }
	    };
	    EventPointing.prototype.end = function () {
	        if (this.mousedOverSeg) {
	            this.handleMouseout(this.mousedOverSeg);
	        }
	    };
	    return EventPointing;
	}(Interaction_1.default));
	exports.default = EventPointing;
	
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var Mixin_1 = __webpack_require__(14);
	var DateClicking_1 = __webpack_require__(245);
	var DateSelecting_1 = __webpack_require__(225);
	var EventPointing_1 = __webpack_require__(59);
	var EventDragging_1 = __webpack_require__(224);
	var EventResizing_1 = __webpack_require__(223);
	var ExternalDropping_1 = __webpack_require__(222);
	var StandardInteractionsMixin = /** @class */ (function (_super) {
	    tslib_1.__extends(StandardInteractionsMixin, _super);
	    function StandardInteractionsMixin() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return StandardInteractionsMixin;
	}(Mixin_1.default));
	exports.default = StandardInteractionsMixin;
	StandardInteractionsMixin.prototype.dateClickingClass = DateClicking_1.default;
	StandardInteractionsMixin.prototype.dateSelectingClass = DateSelecting_1.default;
	StandardInteractionsMixin.prototype.eventPointingClass = EventPointing_1.default;
	StandardInteractionsMixin.prototype.eventDraggingClass = EventDragging_1.default;
	StandardInteractionsMixin.prototype.eventResizingClass = EventResizing_1.default;
	StandardInteractionsMixin.prototype.externalDroppingClass = ExternalDropping_1.default;
	
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var CoordCache_1 = __webpack_require__(53);
	var Popover_1 = __webpack_require__(249);
	var UnzonedRange_1 = __webpack_require__(5);
	var ComponentFootprint_1 = __webpack_require__(12);
	var EventFootprint_1 = __webpack_require__(35);
	var BusinessHourRenderer_1 = __webpack_require__(56);
	var StandardInteractionsMixin_1 = __webpack_require__(60);
	var InteractiveDateComponent_1 = __webpack_require__(40);
	var DayTableMixin_1 = __webpack_require__(55);
	var DayGridEventRenderer_1 = __webpack_require__(250);
	var DayGridHelperRenderer_1 = __webpack_require__(251);
	var DayGridFillRenderer_1 = __webpack_require__(252);
	/* A component that renders a grid of whole-days that runs horizontally. There can be multiple rows, one per week.
	----------------------------------------------------------------------------------------------------------------------*/
	var DayGrid = /** @class */ (function (_super) {
	    tslib_1.__extends(DayGrid, _super);
	    function DayGrid(view) {
	        var _this = _super.call(this, view) || this;
	        _this.cellWeekNumbersVisible = false; // display week numbers in day cell?
	        _this.bottomCoordPadding = 0; // hack for extending the hit area for the last row of the coordinate grid
	        // isRigid determines whether the individual rows should ignore the contents and be a constant height.
	        // Relies on the view's colCnt and rowCnt. In the future, this component should probably be self-sufficient.
	        _this.isRigid = false;
	        _this.hasAllDayBusinessHours = true;
	        return _this;
	    }
	    // Slices up the given span (unzoned start/end with other misc data) into an array of segments
	    DayGrid.prototype.componentFootprintToSegs = function (componentFootprint) {
	        var segs = this.sliceRangeByRow(componentFootprint.unzonedRange);
	        var i;
	        var seg;
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            if (this.isRTL) {
	                seg.leftCol = this.daysPerRow - 1 - seg.lastRowDayIndex;
	                seg.rightCol = this.daysPerRow - 1 - seg.firstRowDayIndex;
	            }
	            else {
	                seg.leftCol = seg.firstRowDayIndex;
	                seg.rightCol = seg.lastRowDayIndex;
	            }
	        }
	        return segs;
	    };
	    /* Date Rendering
	    ------------------------------------------------------------------------------------------------------------------*/
	    DayGrid.prototype.renderDates = function (dateProfile) {
	        this.dateProfile = dateProfile;
	        this.updateDayTable();
	        this.renderGrid();
	    };
	    DayGrid.prototype.unrenderDates = function () {
	        this.removeSegPopover();
	    };
	    // Renders the rows and columns into the component's `this.el`, which should already be assigned.
	    DayGrid.prototype.renderGrid = function () {
	        var view = this.view;
	        var rowCnt = this.rowCnt;
	        var colCnt = this.colCnt;
	        var html = '';
	        var row;
	        var col;
	        if (this.headContainerEl) {
	            this.headContainerEl.html(this.renderHeadHtml());
	        }
	        for (row = 0; row < rowCnt; row++) {
	            html += this.renderDayRowHtml(row, this.isRigid);
	        }
	        this.el.html(html);
	        this.rowEls = this.el.find('.fc-row');
	        this.cellEls = this.el.find('.fc-day, .fc-disabled-day');
	        this.rowCoordCache = new CoordCache_1.default({
	            els: this.rowEls,
	            isVertical: true
	        });
	        this.colCoordCache = new CoordCache_1.default({
	            els: this.cellEls.slice(0, this.colCnt),
	            isHorizontal: true
	        });
	        // trigger dayRender with each cell's element
	        for (row = 0; row < rowCnt; row++) {
	            for (col = 0; col < colCnt; col++) {
	                this.publiclyTrigger('dayRender', {
	                    context: view,
	                    args: [
	                        this.getCellDate(row, col),
	                        this.getCellEl(row, col),
	                        view
	                    ]
	                });
	            }
	        }
	    };
	    // Generates the HTML for a single row, which is a div that wraps a table.
	    // `row` is the row number.
	    DayGrid.prototype.renderDayRowHtml = function (row, isRigid) {
	        var theme = this.view.calendar.theme;
	        var classes = ['fc-row', 'fc-week', theme.getClass('dayRow')];
	        if (isRigid) {
	            classes.push('fc-rigid');
	        }
	        return '' +
	            '<div class="' + classes.join(' ') + '">' +
	            '<div class="fc-bg">' +
	            '<table class="' + theme.getClass('tableGrid') + '">' +
	            this.renderBgTrHtml(row) +
	            '</table>' +
	            '</div>' +
	            '<div class="fc-content-skeleton">' +
	            '<table>' +
	            (this.getIsNumbersVisible() ?
	                '<thead>' +
	                    this.renderNumberTrHtml(row) +
	                    '</thead>' :
	                '') +
	            '</table>' +
	            '</div>' +
	            '</div>';
	    };
	    DayGrid.prototype.getIsNumbersVisible = function () {
	        return this.getIsDayNumbersVisible() || this.cellWeekNumbersVisible;
	    };
	    DayGrid.prototype.getIsDayNumbersVisible = function () {
	        return this.rowCnt > 1;
	    };
	    /* Grid Number Rendering
	    ------------------------------------------------------------------------------------------------------------------*/
	    DayGrid.prototype.renderNumberTrHtml = function (row) {
	        return '' +
	            '<tr>' +
	            (this.isRTL ? '' : this.renderNumberIntroHtml(row)) +
	            this.renderNumberCellsHtml(row) +
	            (this.isRTL ? this.renderNumberIntroHtml(row) : '') +
	            '</tr>';
	    };
	    DayGrid.prototype.renderNumberIntroHtml = function (row) {
	        return this.renderIntroHtml();
	    };
	    DayGrid.prototype.renderNumberCellsHtml = function (row) {
	        var htmls = [];
	        var col;
	        var date;
	        for (col = 0; col < this.colCnt; col++) {
	            date = this.getCellDate(row, col);
	            htmls.push(this.renderNumberCellHtml(date));
	        }
	        return htmls.join('');
	    };
	    // Generates the HTML for the <td>s of the "number" row in the DayGrid's content skeleton.
	    // The number row will only exist if either day numbers or week numbers are turned on.
	    DayGrid.prototype.renderNumberCellHtml = function (date) {
	        var view = this.view;
	        var html = '';
	        var isDateValid = this.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.
	        var isDayNumberVisible = this.getIsDayNumbersVisible() && isDateValid;
	        var classes;
	        var weekCalcFirstDoW;
	        if (!isDayNumberVisible && !this.cellWeekNumbersVisible) {
	            // no numbers in day cell (week number must be along the side)
	            return '<td/>'; //  will create an empty space above events :(
	        }
	        classes = this.getDayClasses(date);
	        classes.unshift('fc-day-top');
	        if (this.cellWeekNumbersVisible) {
	            // To determine the day of week number change under ISO, we cannot
	            // rely on moment.js methods such as firstDayOfWeek() or weekday(),
	            // because they rely on the locale's dow (possibly overridden by
	            // our firstDay option), which may not be Monday. We cannot change
	            // dow, because that would affect the calendar start day as well.
	            if (date._locale._fullCalendar_weekCalc === 'ISO') {
	                weekCalcFirstDoW = 1; // Monday by ISO 8601 definition
	            }
	            else {
	                weekCalcFirstDoW = date._locale.firstDayOfWeek();
	            }
	        }
	        html += '<td class="' + classes.join(' ') + '"' +
	            (isDateValid ?
	                ' data-date="' + date.format() + '"' :
	                '') +
	            '>';
	        if (this.cellWeekNumbersVisible && (date.day() === weekCalcFirstDoW)) {
	            html += view.buildGotoAnchorHtml({ date: date, type: 'week' }, { 'class': 'fc-week-number' }, date.format('w') // inner HTML
	            );
	        }
	        if (isDayNumberVisible) {
	            html += view.buildGotoAnchorHtml(date, { 'class': 'fc-day-number' }, date.format('D') // inner HTML
	            );
	        }
	        html += '</td>';
	        return html;
	    };
	    /* Hit System
	    ------------------------------------------------------------------------------------------------------------------*/
	    DayGrid.prototype.prepareHits = function () {
	        this.colCoordCache.build();
	        this.rowCoordCache.build();
	        this.rowCoordCache.bottoms[this.rowCnt - 1] += this.bottomCoordPadding; // hack
	    };
	    DayGrid.prototype.releaseHits = function () {
	        this.colCoordCache.clear();
	        this.rowCoordCache.clear();
	    };
	    DayGrid.prototype.queryHit = function (leftOffset, topOffset) {
	        if (this.colCoordCache.isLeftInBounds(leftOffset) && this.rowCoordCache.isTopInBounds(topOffset)) {
	            var col = this.colCoordCache.getHorizontalIndex(leftOffset);
	            var row = this.rowCoordCache.getVerticalIndex(topOffset);
	            if (row != null && col != null) {
	                return this.getCellHit(row, col);
	            }
	        }
	    };
	    DayGrid.prototype.getHitFootprint = function (hit) {
	        var range = this.getCellRange(hit.row, hit.col);
	        return new ComponentFootprint_1.default(new UnzonedRange_1.default(range.start, range.end), true // all-day?
	        );
	    };
	    DayGrid.prototype.getHitEl = function (hit) {
	        return this.getCellEl(hit.row, hit.col);
	    };
	    /* Cell System
	    ------------------------------------------------------------------------------------------------------------------*/
	    // FYI: the first column is the leftmost column, regardless of date
	    DayGrid.prototype.getCellHit = function (row, col) {
	        return {
	            row: row,
	            col: col,
	            component: this,
	            left: this.colCoordCache.getLeftOffset(col),
	            right: this.colCoordCache.getRightOffset(col),
	            top: this.rowCoordCache.getTopOffset(row),
	            bottom: this.rowCoordCache.getBottomOffset(row)
	        };
	    };
	    DayGrid.prototype.getCellEl = function (row, col) {
	        return this.cellEls.eq(row * this.colCnt + col);
	    };
	    /* Event Rendering
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Unrenders all events currently rendered on the grid
	    DayGrid.prototype.executeEventUnrender = function () {
	        this.removeSegPopover(); // removes the "more.." events popover
	        _super.prototype.executeEventUnrender.call(this);
	    };
	    // Retrieves all rendered segment objects currently rendered on the grid
	    DayGrid.prototype.getOwnEventSegs = function () {
	        // append the segments from the "more..." popover
	        return _super.prototype.getOwnEventSegs.call(this).concat(this.popoverSegs || []);
	    };
	    /* Event Drag Visualization
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Renders a visual indication of an event or external element being dragged.
	    // `eventLocation` has zoned start and end (optional)
	    DayGrid.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
	        var i;
	        for (i = 0; i < eventFootprints.length; i++) {
	            this.renderHighlight(eventFootprints[i].componentFootprint);
	        }
	        // render drags from OTHER components as helpers
	        if (eventFootprints.length && seg && seg.component !== this) {
	            this.helperRenderer.renderEventDraggingFootprints(eventFootprints, seg, isTouch);
	            return true; // signal helpers rendered
	        }
	    };
	    // Unrenders any visual indication of a hovering event
	    DayGrid.prototype.unrenderDrag = function () {
	        this.unrenderHighlight();
	        this.helperRenderer.unrender();
	    };
	    /* Event Resize Visualization
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Renders a visual indication of an event being resized
	    DayGrid.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
	        var i;
	        for (i = 0; i < eventFootprints.length; i++) {
	            this.renderHighlight(eventFootprints[i].componentFootprint);
	        }
	        this.helperRenderer.renderEventResizingFootprints(eventFootprints, seg, isTouch);
	    };
	    // Unrenders a visual indication of an event being resized
	    DayGrid.prototype.unrenderEventResize = function () {
	        this.unrenderHighlight();
	        this.helperRenderer.unrender();
	    };
	    /* More+ Link Popover
	    ------------------------------------------------------------------------------------------------------------------*/
	    DayGrid.prototype.removeSegPopover = function () {
	        if (this.segPopover) {
	            this.segPopover.hide(); // in handler, will call segPopover's removeElement
	        }
	    };
	    // Limits the number of "levels" (vertically stacking layers of events) for each row of the grid.
	    // `levelLimit` can be false (don't limit), a number, or true (should be computed).
	    DayGrid.prototype.limitRows = function (levelLimit) {
	        var rowStructs = this.eventRenderer.rowStructs || [];
	        var row; // row #
	        var rowLevelLimit;
	        for (row = 0; row < rowStructs.length; row++) {
	            this.unlimitRow(row);
	            if (!levelLimit) {
	                rowLevelLimit = false;
	            }
	            else if (typeof levelLimit === 'number') {
	                rowLevelLimit = levelLimit;
	            }
	            else {
	                rowLevelLimit = this.computeRowLevelLimit(row);
	            }
	            if (rowLevelLimit !== false) {
	                this.limitRow(row, rowLevelLimit);
	            }
	        }
	    };
	    // Computes the number of levels a row will accomodate without going outside its bounds.
	    // Assumes the row is "rigid" (maintains a constant height regardless of what is inside).
	    // `row` is the row number.
	    DayGrid.prototype.computeRowLevelLimit = function (row) {
	        var rowEl = this.rowEls.eq(row); // the containing "fake" row div
	        var rowHeight = rowEl.height(); // TODO: cache somehow?
	        var trEls = this.eventRenderer.rowStructs[row].tbodyEl.children();
	        var i;
	        var trEl;
	        var trHeight;
	        function iterInnerHeights(i, childNode) {
	            trHeight = Math.max(trHeight, $(childNode).outerHeight());
	        }
	        // Reveal one level <tr> at a time and stop when we find one out of bounds
	        for (i = 0; i < trEls.length; i++) {
	            trEl = trEls.eq(i).removeClass('fc-limited'); // reset to original state (reveal)
	            // with rowspans>1 and IE8, trEl.outerHeight() would return the height of the largest cell,
	            // so instead, find the tallest inner content element.
	            trHeight = 0;
	            trEl.find('> td > :first-child').each(iterInnerHeights);
	            if (trEl.position().top + trHeight > rowHeight) {
	                return i;
	            }
	        }
	        return false; // should not limit at all
	    };
	    // Limits the given grid row to the maximum number of levels and injects "more" links if necessary.
	    // `row` is the row number.
	    // `levelLimit` is a number for the maximum (inclusive) number of levels allowed.
	    DayGrid.prototype.limitRow = function (row, levelLimit) {
	        var _this = this;
	        var rowStruct = this.eventRenderer.rowStructs[row];
	        var moreNodes = []; // array of "more" <a> links and <td> DOM nodes
	        var col = 0; // col #, left-to-right (not chronologically)
	        var levelSegs; // array of segment objects in the last allowable level, ordered left-to-right
	        var cellMatrix; // a matrix (by level, then column) of all <td> jQuery elements in the row
	        var limitedNodes; // array of temporarily hidden level <tr> and segment <td> DOM nodes
	        var i;
	        var seg;
	        var segsBelow; // array of segment objects below `seg` in the current `col`
	        var totalSegsBelow; // total number of segments below `seg` in any of the columns `seg` occupies
	        var colSegsBelow; // array of segment arrays, below seg, one for each column (offset from segs's first column)
	        var td;
	        var rowspan;
	        var segMoreNodes; // array of "more" <td> cells that will stand-in for the current seg's cell
	        var j;
	        var moreTd;
	        var moreWrap;
	        var moreLink;
	        // Iterates through empty level cells and places "more" links inside if need be
	        var emptyCellsUntil = function (endCol) {
	            while (col < endCol) {
	                segsBelow = _this.getCellSegs(row, col, levelLimit);
	                if (segsBelow.length) {
	                    td = cellMatrix[levelLimit - 1][col];
	                    moreLink = _this.renderMoreLink(row, col, segsBelow);
	                    moreWrap = $('<div/>').append(moreLink);
	                    td.append(moreWrap);
	                    moreNodes.push(moreWrap[0]);
	                }
	                col++;
	            }
	        };
	        if (levelLimit && levelLimit < rowStruct.segLevels.length) {
	            levelSegs = rowStruct.segLevels[levelLimit - 1];
	            cellMatrix = rowStruct.cellMatrix;
	            limitedNodes = rowStruct.tbodyEl.children().slice(levelLimit) // get level <tr> elements past the limit
	                .addClass('fc-limited').get(); // hide elements and get a simple DOM-nodes array
	            // iterate though segments in the last allowable level
	            for (i = 0; i < levelSegs.length; i++) {
	                seg = levelSegs[i];
	                emptyCellsUntil(seg.leftCol); // process empty cells before the segment
	                // determine *all* segments below `seg` that occupy the same columns
	                colSegsBelow = [];
	                totalSegsBelow = 0;
	                while (col <= seg.rightCol) {
	                    segsBelow = this.getCellSegs(row, col, levelLimit);
	                    colSegsBelow.push(segsBelow);
	                    totalSegsBelow += segsBelow.length;
	                    col++;
	                }
	                if (totalSegsBelow) {
	                    td = cellMatrix[levelLimit - 1][seg.leftCol]; // the segment's parent cell
	                    rowspan = td.attr('rowspan') || 1;
	                    segMoreNodes = [];
	                    // make a replacement <td> for each column the segment occupies. will be one for each colspan
	                    for (j = 0; j < colSegsBelow.length; j++) {
	                        moreTd = $('<td class="fc-more-cell"/>').attr('rowspan', rowspan);
	                        segsBelow = colSegsBelow[j];
	                        moreLink = this.renderMoreLink(row, seg.leftCol + j, [seg].concat(segsBelow) // count seg as hidden too
	                        );
	                        moreWrap = $('<div/>').append(moreLink);
	                        moreTd.append(moreWrap);
	                        segMoreNodes.push(moreTd[0]);
	                        moreNodes.push(moreTd[0]);
	                    }
	                    td.addClass('fc-limited').after($(segMoreNodes)); // hide original <td> and inject replacements
	                    limitedNodes.push(td[0]);
	                }
	            }
	            emptyCellsUntil(this.colCnt); // finish off the level
	            rowStruct.moreEls = $(moreNodes); // for easy undoing later
	            rowStruct.limitedEls = $(limitedNodes); // for easy undoing later
	        }
	    };
	    // Reveals all levels and removes all "more"-related elements for a grid's row.
	    // `row` is a row number.
	    DayGrid.prototype.unlimitRow = function (row) {
	        var rowStruct = this.eventRenderer.rowStructs[row];
	        if (rowStruct.moreEls) {
	            rowStruct.moreEls.remove();
	            rowStruct.moreEls = null;
	        }
	        if (rowStruct.limitedEls) {
	            rowStruct.limitedEls.removeClass('fc-limited');
	            rowStruct.limitedEls = null;
	        }
	    };
	    // Renders an <a> element that represents hidden event element for a cell.
	    // Responsible for attaching click handler as well.
	    DayGrid.prototype.renderMoreLink = function (row, col, hiddenSegs) {
	        var _this = this;
	        var view = this.view;
	        return $('<a class="fc-more"/>')
	            .text(this.getMoreLinkText(hiddenSegs.length))
	            .on('click', function (ev) {
	            var clickOption = _this.opt('eventLimitClick');
	            var date = _this.getCellDate(row, col);
	            var moreEl = $(ev.currentTarget);
	            var dayEl = _this.getCellEl(row, col);
	            var allSegs = _this.getCellSegs(row, col);
	            // rescope the segments to be within the cell's date
	            var reslicedAllSegs = _this.resliceDaySegs(allSegs, date);
	            var reslicedHiddenSegs = _this.resliceDaySegs(hiddenSegs, date);
	            if (typeof clickOption === 'function') {
	                // the returned value can be an atomic option
	                clickOption = _this.publiclyTrigger('eventLimitClick', {
	                    context: view,
	                    args: [
	                        {
	                            date: date.clone(),
	                            dayEl: dayEl,
	                            moreEl: moreEl,
	                            segs: reslicedAllSegs,
	                            hiddenSegs: reslicedHiddenSegs
	                        },
	                        ev,
	                        view
	                    ]
	                });
	            }
	            if (clickOption === 'popover') {
	                _this.showSegPopover(row, col, moreEl, reslicedAllSegs);
	            }
	            else if (typeof clickOption === 'string') {
	                view.calendar.zoomTo(date, clickOption);
	            }
	        });
	    };
	    // Reveals the popover that displays all events within a cell
	    DayGrid.prototype.showSegPopover = function (row, col, moreLink, segs) {
	        var _this = this;
	        var view = this.view;
	        var moreWrap = moreLink.parent(); // the <div> wrapper around the <a>
	        var topEl; // the element we want to match the top coordinate of
	        var options;
	        if (this.rowCnt === 1) {
	            topEl = view.el; // will cause the popover to cover any sort of header
	        }
	        else {
	            topEl = this.rowEls.eq(row); // will align with top of row
	        }
	        options = {
	            className: 'fc-more-popover ' + view.calendar.theme.getClass('popover'),
	            content: this.renderSegPopoverContent(row, col, segs),
	            parentEl: view.el,
	            top: topEl.offset().top,
	            autoHide: true,
	            viewportConstrain: this.opt('popoverViewportConstrain'),
	            hide: function () {
	                // kill everything when the popover is hidden
	                // notify events to be removed
	                if (_this.popoverSegs) {
	                    _this.triggerBeforeEventSegsDestroyed(_this.popoverSegs);
	                }
	                _this.segPopover.removeElement();
	                _this.segPopover = null;
	                _this.popoverSegs = null;
	            }
	        };
	        // Determine horizontal coordinate.
	        // We use the moreWrap instead of the <td> to avoid border confusion.
	        if (this.isRTL) {
	            options.right = moreWrap.offset().left + moreWrap.outerWidth() + 1; // +1 to be over cell border
	        }
	        else {
	            options.left = moreWrap.offset().left - 1; // -1 to be over cell border
	        }
	        this.segPopover = new Popover_1.default(options);
	        this.segPopover.show();
	        // the popover doesn't live within the grid's container element, and thus won't get the event
	        // delegated-handlers for free. attach event-related handlers to the popover.
	        this.bindAllSegHandlersToEl(this.segPopover.el);
	        this.triggerAfterEventSegsRendered(segs);
	    };
	    // Builds the inner DOM contents of the segment popover
	    DayGrid.prototype.renderSegPopoverContent = function (row, col, segs) {
	        var view = this.view;
	        var theme = view.calendar.theme;
	        var title = this.getCellDate(row, col).format(this.opt('dayPopoverFormat'));
	        var content = $('<div class="fc-header ' + theme.getClass('popoverHeader') + '">' +
	            '<span class="fc-close ' + theme.getIconClass('close') + '"></span>' +
	            '<span class="fc-title">' +
	            util_1.htmlEscape(title) +
	            '</span>' +
	            '<div class="fc-clear"/>' +
	            '</div>' +
	            '<div class="fc-body ' + theme.getClass('popoverContent') + '">' +
	            '<div class="fc-event-container"></div>' +
	            '</div>');
	        var segContainer = content.find('.fc-event-container');
	        var i;
	        // render each seg's `el` and only return the visible segs
	        segs = this.eventRenderer.renderFgSegEls(segs, true); // disableResizing=true
	        this.popoverSegs = segs;
	        for (i = 0; i < segs.length; i++) {
	            // because segments in the popover are not part of a grid coordinate system, provide a hint to any
	            // grids that want to do drag-n-drop about which cell it came from
	            this.hitsNeeded();
	            segs[i].hit = this.getCellHit(row, col);
	            this.hitsNotNeeded();
	            segContainer.append(segs[i].el);
	        }
	        return content;
	    };
	    // Given the events within an array of segment objects, reslice them to be in a single day
	    DayGrid.prototype.resliceDaySegs = function (segs, dayDate) {
	        var dayStart = dayDate.clone();
	        var dayEnd = dayStart.clone().add(1, 'days');
	        var dayRange = new UnzonedRange_1.default(dayStart, dayEnd);
	        var newSegs = [];
	        var i;
	        var seg;
	        var slicedRange;
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            slicedRange = seg.footprint.componentFootprint.unzonedRange.intersect(dayRange);
	            if (slicedRange) {
	                newSegs.push($.extend({}, seg, {
	                    footprint: new EventFootprint_1.default(new ComponentFootprint_1.default(slicedRange, seg.footprint.componentFootprint.isAllDay), seg.footprint.eventDef, seg.footprint.eventInstance),
	                    isStart: seg.isStart && slicedRange.isStart,
	                    isEnd: seg.isEnd && slicedRange.isEnd
	                }));
	            }
	        }
	        // force an order because eventsToSegs doesn't guarantee one
	        // TODO: research if still needed
	        this.eventRenderer.sortEventSegs(newSegs);
	        return newSegs;
	    };
	    // Generates the text that should be inside a "more" link, given the number of events it represents
	    DayGrid.prototype.getMoreLinkText = function (num) {
	        var opt = this.opt('eventLimitText');
	        if (typeof opt === 'function') {
	            return opt(num);
	        }
	        else {
	            return '+' + num + ' ' + opt;
	        }
	    };
	    // Returns segments within a given cell.
	    // If `startLevel` is specified, returns only events including and below that level. Otherwise returns all segs.
	    DayGrid.prototype.getCellSegs = function (row, col, startLevel) {
	        var segMatrix = this.eventRenderer.rowStructs[row].segMatrix;
	        var level = startLevel || 0;
	        var segs = [];
	        var seg;
	        while (level < segMatrix.length) {
	            seg = segMatrix[level][col];
	            if (seg) {
	                segs.push(seg);
	            }
	            level++;
	        }
	        return segs;
	    };
	    return DayGrid;
	}(InteractiveDateComponent_1.default));
	exports.default = DayGrid;
	DayGrid.prototype.eventRendererClass = DayGridEventRenderer_1.default;
	DayGrid.prototype.businessHourRendererClass = BusinessHourRenderer_1.default;
	DayGrid.prototype.helperRendererClass = DayGridHelperRenderer_1.default;
	DayGrid.prototype.fillRendererClass = DayGridFillRenderer_1.default;
	StandardInteractionsMixin_1.default.mixInto(DayGrid);
	DayTableMixin_1.default.mixInto(DayGrid);
	
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var Scroller_1 = __webpack_require__(39);
	var View_1 = __webpack_require__(41);
	var BasicViewDateProfileGenerator_1 = __webpack_require__(228);
	var DayGrid_1 = __webpack_require__(61);
	/* An abstract class for the "basic" views, as well as month view. Renders one or more rows of day cells.
	----------------------------------------------------------------------------------------------------------------------*/
	// It is a manager for a DayGrid subcomponent, which does most of the heavy lifting.
	// It is responsible for managing width/height.
	var BasicView = /** @class */ (function (_super) {
	    tslib_1.__extends(BasicView, _super);
	    function BasicView(calendar, viewSpec) {
	        var _this = _super.call(this, calendar, viewSpec) || this;
	        _this.dayGrid = _this.instantiateDayGrid();
	        _this.dayGrid.isRigid = _this.hasRigidRows();
	        if (_this.opt('weekNumbers')) {
	            if (_this.opt('weekNumbersWithinDays')) {
	                _this.dayGrid.cellWeekNumbersVisible = true;
	                _this.dayGrid.colWeekNumbersVisible = false;
	            }
	            else {
	                _this.dayGrid.cellWeekNumbersVisible = false;
	                _this.dayGrid.colWeekNumbersVisible = true;
	            }
	        }
	        _this.addChild(_this.dayGrid);
	        _this.scroller = new Scroller_1.default({
	            overflowX: 'hidden',
	            overflowY: 'auto'
	        });
	        return _this;
	    }
	    // Generates the DayGrid object this view needs. Draws from this.dayGridClass
	    BasicView.prototype.instantiateDayGrid = function () {
	        // generate a subclass on the fly with BasicView-specific behavior
	        // TODO: cache this subclass
	        var subclass = makeDayGridSubclass(this.dayGridClass);
	        return new subclass(this);
	    };
	    BasicView.prototype.executeDateRender = function (dateProfile) {
	        this.dayGrid.breakOnWeeks = /year|month|week/.test(dateProfile.currentRangeUnit);
	        _super.prototype.executeDateRender.call(this, dateProfile);
	    };
	    BasicView.prototype.renderSkeleton = function () {
	        var dayGridContainerEl;
	        var dayGridEl;
	        this.el.addClass('fc-basic-view').html(this.renderSkeletonHtml());
	        this.scroller.render();
	        dayGridContainerEl = this.scroller.el.addClass('fc-day-grid-container');
	        dayGridEl = $('<div class="fc-day-grid" />').appendTo(dayGridContainerEl);
	        this.el.find('.fc-body > tr > td').append(dayGridContainerEl);
	        this.dayGrid.headContainerEl = this.el.find('.fc-head-container');
	        this.dayGrid.setElement(dayGridEl);
	    };
	    BasicView.prototype.unrenderSkeleton = function () {
	        this.dayGrid.removeElement();
	        this.scroller.destroy();
	    };
	    // Builds the HTML skeleton for the view.
	    // The day-grid component will render inside of a container defined by this HTML.
	    BasicView.prototype.renderSkeletonHtml = function () {
	        var theme = this.calendar.theme;
	        return '' +
	            '<table class="' + theme.getClass('tableGrid') + '">' +
	            (this.opt('columnHeader') ?
	                '<thead class="fc-head">' +
	                    '<tr>' +
	                    '<td class="fc-head-container ' + theme.getClass('widgetHeader') + '">&nbsp;</td>' +
	                    '</tr>' +
	                    '</thead>' :
	                '') +
	            '<tbody class="fc-body">' +
	            '<tr>' +
	            '<td class="' + theme.getClass('widgetContent') + '"></td>' +
	            '</tr>' +
	            '</tbody>' +
	            '</table>';
	    };
	    // Generates an HTML attribute string for setting the width of the week number column, if it is known
	    BasicView.prototype.weekNumberStyleAttr = function () {
	        if (this.weekNumberWidth != null) {
	            return 'style="width:' + this.weekNumberWidth + 'px"';
	        }
	        return '';
	    };
	    // Determines whether each row should have a constant height
	    BasicView.prototype.hasRigidRows = function () {
	        var eventLimit = this.opt('eventLimit');
	        return eventLimit && typeof eventLimit !== 'number';
	    };
	    /* Dimensions
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Refreshes the horizontal dimensions of the view
	    BasicView.prototype.updateSize = function (totalHeight, isAuto, isResize) {
	        var eventLimit = this.opt('eventLimit');
	        var headRowEl = this.dayGrid.headContainerEl.find('.fc-row');
	        var scrollerHeight;
	        var scrollbarWidths;
	        // hack to give the view some height prior to dayGrid's columns being rendered
	        // TODO: separate setting height from scroller VS dayGrid.
	        if (!this.dayGrid.rowEls) {
	            if (!isAuto) {
	                scrollerHeight = this.computeScrollerHeight(totalHeight);
	                this.scroller.setHeight(scrollerHeight);
	            }
	            return;
	        }
	        _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
	        if (this.dayGrid.colWeekNumbersVisible) {
	            // Make sure all week number cells running down the side have the same width.
	            // Record the width for cells created later.
	            this.weekNumberWidth = util_1.matchCellWidths(this.el.find('.fc-week-number'));
	        }
	        // reset all heights to be natural
	        this.scroller.clear();
	        util_1.uncompensateScroll(headRowEl);
	        this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed
	        // is the event limit a constant level number?
	        if (eventLimit && typeof eventLimit === 'number') {
	            this.dayGrid.limitRows(eventLimit); // limit the levels first so the height can redistribute after
	        }
	        // distribute the height to the rows
	        // (totalHeight is a "recommended" value if isAuto)
	        scrollerHeight = this.computeScrollerHeight(totalHeight);
	        this.setGridHeight(scrollerHeight, isAuto);
	        // is the event limit dynamically calculated?
	        if (eventLimit && typeof eventLimit !== 'number') {
	            this.dayGrid.limitRows(eventLimit); // limit the levels after the grid's row heights have been set
	        }
	        if (!isAuto) {
	            this.scroller.setHeight(scrollerHeight);
	            scrollbarWidths = this.scroller.getScrollbarWidths();
	            if (scrollbarWidths.left || scrollbarWidths.right) {
	                util_1.compensateScroll(headRowEl, scrollbarWidths);
	                // doing the scrollbar compensation might have created text overflow which created more height. redo
	                scrollerHeight = this.computeScrollerHeight(totalHeight);
	                this.scroller.setHeight(scrollerHeight);
	            }
	            // guarantees the same scrollbar widths
	            this.scroller.lockOverflow(scrollbarWidths);
	        }
	    };
	    // given a desired total height of the view, returns what the height of the scroller should be
	    BasicView.prototype.computeScrollerHeight = function (totalHeight) {
	        return totalHeight -
	            util_1.subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
	    };
	    // Sets the height of just the DayGrid component in this view
	    BasicView.prototype.setGridHeight = function (height, isAuto) {
	        if (isAuto) {
	            util_1.undistributeHeight(this.dayGrid.rowEls); // let the rows be their natural height with no expanding
	        }
	        else {
	            util_1.distributeHeight(this.dayGrid.rowEls, height, true); // true = compensate for height-hogging rows
	        }
	    };
	    /* Scroll
	    ------------------------------------------------------------------------------------------------------------------*/
	    BasicView.prototype.computeInitialDateScroll = function () {
	        return { top: 0 };
	    };
	    BasicView.prototype.queryDateScroll = function () {
	        return { top: this.scroller.getScrollTop() };
	    };
	    BasicView.prototype.applyDateScroll = function (scroll) {
	        if (scroll.top !== undefined) {
	            this.scroller.setScrollTop(scroll.top);
	        }
	    };
	    return BasicView;
	}(View_1.default));
	exports.default = BasicView;
	BasicView.prototype.dateProfileGeneratorClass = BasicViewDateProfileGenerator_1.default;
	BasicView.prototype.dayGridClass = DayGrid_1.default;
	// customize the rendering behavior of BasicView's dayGrid
	function makeDayGridSubclass(SuperClass) {
	    return /** @class */ (function (_super) {
	        tslib_1.__extends(SubClass, _super);
	        function SubClass() {
	            var _this = _super !== null && _super.apply(this, arguments) || this;
	            _this.colWeekNumbersVisible = false; // display week numbers along the side?
	            return _this;
	        }
	        // Generates the HTML that will go before the day-of week header cells
	        SubClass.prototype.renderHeadIntroHtml = function () {
	            var view = this.view;
	            if (this.colWeekNumbersVisible) {
	                return '' +
	                    '<th class="fc-week-number ' + view.calendar.theme.getClass('widgetHeader') + '" ' + view.weekNumberStyleAttr() + '>' +
	                    '<span>' + // needed for matchCellWidths
	                    util_1.htmlEscape(this.opt('weekNumberTitle')) +
	                    '</span>' +
	                    '</th>';
	            }
	            return '';
	        };
	        // Generates the HTML that will go before content-skeleton cells that display the day/week numbers
	        SubClass.prototype.renderNumberIntroHtml = function (row) {
	            var view = this.view;
	            var weekStart = this.getCellDate(row, 0);
	            if (this.colWeekNumbersVisible) {
	                return '' +
	                    '<td class="fc-week-number" ' + view.weekNumberStyleAttr() + '>' +
	                    view.buildGotoAnchorHtml(// aside from link, important for matchCellWidths
	                    { date: weekStart, type: 'week', forceOff: this.colCnt === 1 }, weekStart.format('w') // inner HTML
	                    ) +
	                    '</td>';
	            }
	            return '';
	        };
	        // Generates the HTML that goes before the day bg cells for each day-row
	        SubClass.prototype.renderBgIntroHtml = function () {
	            var view = this.view;
	            if (this.colWeekNumbersVisible) {
	                return '<td class="fc-week-number ' + view.calendar.theme.getClass('widgetContent') + '" ' +
	                    view.weekNumberStyleAttr() + '></td>';
	            }
	            return '';
	        };
	        // Generates the HTML that goes before every other type of row generated by DayGrid.
	        // Affects helper-skeleton and highlight-skeleton rows.
	        SubClass.prototype.renderIntroHtml = function () {
	            var view = this.view;
	            if (this.colWeekNumbersVisible) {
	                return '<td class="fc-week-number" ' + view.weekNumberStyleAttr() + '></td>';
	            }
	            return '';
	        };
	        SubClass.prototype.getIsNumbersVisible = function () {
	            return DayGrid_1.default.prototype.getIsNumbersVisible.apply(this, arguments) || this.colWeekNumbersVisible;
	        };
	        return SubClass;
	    }(SuperClass));
	}
	
	
	/***/ }),
	/* 63 */,
	/* 64 */,
	/* 65 */,
	/* 66 */,
	/* 67 */,
	/* 68 */,
	/* 69 */,
	/* 70 */,
	/* 71 */,
	/* 72 */,
	/* 73 */,
	/* 74 */,
	/* 75 */,
	/* 76 */,
	/* 77 */,
	/* 78 */,
	/* 79 */,
	/* 80 */,
	/* 81 */,
	/* 82 */,
	/* 83 */,
	/* 84 */,
	/* 85 */,
	/* 86 */,
	/* 87 */,
	/* 88 */,
	/* 89 */,
	/* 90 */,
	/* 91 */,
	/* 92 */,
	/* 93 */,
	/* 94 */,
	/* 95 */,
	/* 96 */,
	/* 97 */,
	/* 98 */,
	/* 99 */,
	/* 100 */,
	/* 101 */,
	/* 102 */,
	/* 103 */,
	/* 104 */,
	/* 105 */,
	/* 106 */,
	/* 107 */,
	/* 108 */,
	/* 109 */,
	/* 110 */,
	/* 111 */,
	/* 112 */,
	/* 113 */,
	/* 114 */,
	/* 115 */,
	/* 116 */,
	/* 117 */,
	/* 118 */,
	/* 119 */,
	/* 120 */,
	/* 121 */,
	/* 122 */,
	/* 123 */,
	/* 124 */,
	/* 125 */,
	/* 126 */,
	/* 127 */,
	/* 128 */,
	/* 129 */,
	/* 130 */,
	/* 131 */,
	/* 132 */,
	/* 133 */,
	/* 134 */,
	/* 135 */,
	/* 136 */,
	/* 137 */,
	/* 138 */,
	/* 139 */,
	/* 140 */,
	/* 141 */,
	/* 142 */,
	/* 143 */,
	/* 144 */,
	/* 145 */,
	/* 146 */,
	/* 147 */,
	/* 148 */,
	/* 149 */,
	/* 150 */,
	/* 151 */,
	/* 152 */,
	/* 153 */,
	/* 154 */,
	/* 155 */,
	/* 156 */,
	/* 157 */,
	/* 158 */,
	/* 159 */,
	/* 160 */,
	/* 161 */,
	/* 162 */,
	/* 163 */,
	/* 164 */,
	/* 165 */,
	/* 166 */,
	/* 167 */,
	/* 168 */,
	/* 169 */,
	/* 170 */,
	/* 171 */,
	/* 172 */,
	/* 173 */,
	/* 174 */,
	/* 175 */,
	/* 176 */,
	/* 177 */,
	/* 178 */,
	/* 179 */,
	/* 180 */,
	/* 181 */,
	/* 182 */,
	/* 183 */,
	/* 184 */,
	/* 185 */,
	/* 186 */,
	/* 187 */,
	/* 188 */,
	/* 189 */,
	/* 190 */,
	/* 191 */,
	/* 192 */,
	/* 193 */,
	/* 194 */,
	/* 195 */,
	/* 196 */,
	/* 197 */,
	/* 198 */,
	/* 199 */,
	/* 200 */,
	/* 201 */,
	/* 202 */,
	/* 203 */,
	/* 204 */,
	/* 205 */,
	/* 206 */,
	/* 207 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var UnzonedRange_1 = __webpack_require__(5);
	var ComponentFootprint_1 = __webpack_require__(12);
	var EventDefParser_1 = __webpack_require__(49);
	var EventSource_1 = __webpack_require__(6);
	var util_1 = __webpack_require__(34);
	var Constraints = /** @class */ (function () {
	    function Constraints(eventManager, _calendar) {
	        this.eventManager = eventManager;
	        this._calendar = _calendar;
	    }
	    Constraints.prototype.opt = function (name) {
	        return this._calendar.opt(name);
	    };
	    /*
	    determines if eventInstanceGroup is allowed,
	    in relation to other EVENTS and business hours.
	    */
	    Constraints.prototype.isEventInstanceGroupAllowed = function (eventInstanceGroup) {
	        var eventDef = eventInstanceGroup.getEventDef();
	        var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
	        var i;
	        var peerEventInstances = this.getPeerEventInstances(eventDef);
	        var peerEventRanges = peerEventInstances.map(util_1.eventInstanceToEventRange);
	        var peerEventFootprints = this.eventRangesToEventFootprints(peerEventRanges);
	        var constraintVal = eventDef.getConstraint();
	        var overlapVal = eventDef.getOverlap();
	        var eventAllowFunc = this.opt('eventAllow');
	        for (i = 0; i < eventFootprints.length; i++) {
	            if (!this.isFootprintAllowed(eventFootprints[i].componentFootprint, peerEventFootprints, constraintVal, overlapVal, eventFootprints[i].eventInstance)) {
	                return false;
	            }
	        }
	        if (eventAllowFunc) {
	            for (i = 0; i < eventFootprints.length; i++) {
	                if (eventAllowFunc(eventFootprints[i].componentFootprint.toLegacy(this._calendar), eventFootprints[i].getEventLegacy()) === false) {
	                    return false;
	                }
	            }
	        }
	        return true;
	    };
	    Constraints.prototype.getPeerEventInstances = function (eventDef) {
	        return this.eventManager.getEventInstancesWithoutId(eventDef.id);
	    };
	    Constraints.prototype.isSelectionFootprintAllowed = function (componentFootprint) {
	        var peerEventInstances = this.eventManager.getEventInstances();
	        var peerEventRanges = peerEventInstances.map(util_1.eventInstanceToEventRange);
	        var peerEventFootprints = this.eventRangesToEventFootprints(peerEventRanges);
	        var selectAllowFunc;
	        if (this.isFootprintAllowed(componentFootprint, peerEventFootprints, this.opt('selectConstraint'), this.opt('selectOverlap'))) {
	            selectAllowFunc = this.opt('selectAllow');
	            if (selectAllowFunc) {
	                return selectAllowFunc(componentFootprint.toLegacy(this._calendar)) !== false;
	            }
	            else {
	                return true;
	            }
	        }
	        return false;
	    };
	    Constraints.prototype.isFootprintAllowed = function (componentFootprint, peerEventFootprints, constraintVal, overlapVal, subjectEventInstance // optional
	    ) {
	        var constraintFootprints; // ComponentFootprint[]
	        var overlapEventFootprints; // EventFootprint[]
	        if (constraintVal != null) {
	            constraintFootprints = this.constraintValToFootprints(constraintVal, componentFootprint.isAllDay);
	            if (!this.isFootprintWithinConstraints(componentFootprint, constraintFootprints)) {
	                return false;
	            }
	        }
	        overlapEventFootprints = this.collectOverlapEventFootprints(peerEventFootprints, componentFootprint);
	        if (overlapVal === false) {
	            if (overlapEventFootprints.length) {
	                return false;
	            }
	        }
	        else if (typeof overlapVal === 'function') {
	            if (!isOverlapsAllowedByFunc(overlapEventFootprints, overlapVal, subjectEventInstance)) {
	                return false;
	            }
	        }
	        if (subjectEventInstance) {
	            if (!isOverlapEventInstancesAllowed(overlapEventFootprints, subjectEventInstance)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    // Constraint
	    // ------------------------------------------------------------------------------------------------
	    Constraints.prototype.isFootprintWithinConstraints = function (componentFootprint, constraintFootprints) {
	        var i;
	        for (i = 0; i < constraintFootprints.length; i++) {
	            if (this.footprintContainsFootprint(constraintFootprints[i], componentFootprint)) {
	                return true;
	            }
	        }
	        return false;
	    };
	    Constraints.prototype.constraintValToFootprints = function (constraintVal, isAllDay) {
	        var eventInstances;
	        if (constraintVal === 'businessHours') {
	            return this.buildCurrentBusinessFootprints(isAllDay);
	        }
	        else if (typeof constraintVal === 'object') {
	            eventInstances = this.parseEventDefToInstances(constraintVal); // handles recurring events
	            if (!eventInstances) {
	                return this.parseFootprints(constraintVal);
	            }
	            else {
	                return this.eventInstancesToFootprints(eventInstances);
	            }
	        }
	        else if (constraintVal != null) {
	            eventInstances = this.eventManager.getEventInstancesWithId(constraintVal);
	            return this.eventInstancesToFootprints(eventInstances);
	        }
	    };
	    // returns ComponentFootprint[]
	    // uses current view's range
	    Constraints.prototype.buildCurrentBusinessFootprints = function (isAllDay) {
	        var view = this._calendar.view;
	        var businessHourGenerator = view.get('businessHourGenerator');
	        var unzonedRange = view.dateProfile.activeUnzonedRange;
	        var eventInstanceGroup = businessHourGenerator.buildEventInstanceGroup(isAllDay, unzonedRange);
	        if (eventInstanceGroup) {
	            return this.eventInstancesToFootprints(eventInstanceGroup.eventInstances);
	        }
	        else {
	            return [];
	        }
	    };
	    // conversion util
	    Constraints.prototype.eventInstancesToFootprints = function (eventInstances) {
	        var eventRanges = eventInstances.map(util_1.eventInstanceToEventRange);
	        var eventFootprints = this.eventRangesToEventFootprints(eventRanges);
	        return eventFootprints.map(util_1.eventFootprintToComponentFootprint);
	    };
	    // Overlap
	    // ------------------------------------------------------------------------------------------------
	    Constraints.prototype.collectOverlapEventFootprints = function (peerEventFootprints, targetFootprint) {
	        var overlapEventFootprints = [];
	        var i;
	        for (i = 0; i < peerEventFootprints.length; i++) {
	            if (this.footprintsIntersect(targetFootprint, peerEventFootprints[i].componentFootprint)) {
	                overlapEventFootprints.push(peerEventFootprints[i]);
	            }
	        }
	        return overlapEventFootprints;
	    };
	    // Conversion: eventDefs -> eventInstances -> eventRanges -> eventFootprints -> componentFootprints
	    // ------------------------------------------------------------------------------------------------
	    // NOTE: this might seem like repetitive code with the Grid class, however, this code is related to
	    // constraints whereas the Grid code is related to rendering. Each approach might want to convert
	    // eventRanges -> eventFootprints in a different way. Regardless, there are opportunities to make
	    // this more DRY.
	    /*
	    Returns false on invalid input.
	    */
	    Constraints.prototype.parseEventDefToInstances = function (eventInput) {
	        var eventManager = this.eventManager;
	        var eventDef = EventDefParser_1.default.parse(eventInput, new EventSource_1.default(this._calendar));
	        if (!eventDef) {
	            return false;
	        }
	        return eventDef.buildInstances(eventManager.currentPeriod.unzonedRange);
	    };
	    Constraints.prototype.eventRangesToEventFootprints = function (eventRanges) {
	        var i;
	        var eventFootprints = [];
	        for (i = 0; i < eventRanges.length; i++) {
	            eventFootprints.push.apply(// footprints
	            eventFootprints, this.eventRangeToEventFootprints(eventRanges[i]));
	        }
	        return eventFootprints;
	    };
	    Constraints.prototype.eventRangeToEventFootprints = function (eventRange) {
	        return [util_1.eventRangeToEventFootprint(eventRange)];
	    };
	    /*
	    Parses footprints directly.
	    Very similar to EventDateProfile::parse :(
	    */
	    Constraints.prototype.parseFootprints = function (rawInput) {
	        var start;
	        var end;
	        if (rawInput.start) {
	            start = this._calendar.moment(rawInput.start);
	            if (!start.isValid()) {
	                start = null;
	            }
	        }
	        if (rawInput.end) {
	            end = this._calendar.moment(rawInput.end);
	            if (!end.isValid()) {
	                end = null;
	            }
	        }
	        return [
	            new ComponentFootprint_1.default(new UnzonedRange_1.default(start, end), (start && !start.hasTime()) || (end && !end.hasTime()) // isAllDay
	            )
	        ];
	    };
	    // Footprint Utils
	    // ----------------------------------------------------------------------------------------
	    Constraints.prototype.footprintContainsFootprint = function (outerFootprint, innerFootprint) {
	        return outerFootprint.unzonedRange.containsRange(innerFootprint.unzonedRange);
	    };
	    Constraints.prototype.footprintsIntersect = function (footprint0, footprint1) {
	        return footprint0.unzonedRange.intersectsWith(footprint1.unzonedRange);
	    };
	    return Constraints;
	}());
	exports.default = Constraints;
	// optional subjectEventInstance
	function isOverlapsAllowedByFunc(overlapEventFootprints, overlapFunc, subjectEventInstance) {
	    var i;
	    for (i = 0; i < overlapEventFootprints.length; i++) {
	        if (!overlapFunc(overlapEventFootprints[i].eventInstance.toLegacy(), subjectEventInstance ? subjectEventInstance.toLegacy() : null)) {
	            return false;
	        }
	    }
	    return true;
	}
	function isOverlapEventInstancesAllowed(overlapEventFootprints, subjectEventInstance) {
	    var subjectLegacyInstance = subjectEventInstance.toLegacy();
	    var i;
	    var overlapEventInstance;
	    var overlapEventDef;
	    var overlapVal;
	    for (i = 0; i < overlapEventFootprints.length; i++) {
	        overlapEventInstance = overlapEventFootprints[i].eventInstance;
	        overlapEventDef = overlapEventInstance.def;
	        // don't need to pass in calendar, because don't want to consider global eventOverlap property,
	        // because we already considered that earlier in the process.
	        overlapVal = overlapEventDef.getOverlap();
	        if (overlapVal === false) {
	            return false;
	        }
	        else if (typeof overlapVal === 'function') {
	            if (!overlapVal(overlapEventInstance.toLegacy(), subjectLegacyInstance)) {
	                return false;
	            }
	        }
	    }
	    return true;
	}
	
	
	/***/ }),
	/* 208 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/*
	USAGE:
	  import { default as ParsableModelMixin, ParsableModelInterface } from './ParsableModelMixin'
	in class:
	  applyProps: ParsableModelInterface['applyProps']
	  applyManualStandardProps: ParsableModelInterface['applyManualStandardProps']
	  applyMiscProps: ParsableModelInterface['applyMiscProps']
	  isStandardProp: ParsableModelInterface['isStandardProp']
	  static defineStandardProps = ParsableModelMixin.defineStandardProps
	  static copyVerbatimStandardProps = ParsableModelMixin.copyVerbatimStandardProps
	after class:
	  ParsableModelMixin.mixInto(TheClass)
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var util_1 = __webpack_require__(4);
	var Mixin_1 = __webpack_require__(14);
	var ParsableModelMixin = /** @class */ (function (_super) {
	    tslib_1.__extends(ParsableModelMixin, _super);
	    function ParsableModelMixin() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ParsableModelMixin.defineStandardProps = function (propDefs) {
	        var proto = this.prototype;
	        if (!proto.hasOwnProperty('standardPropMap')) {
	            proto.standardPropMap = Object.create(proto.standardPropMap);
	        }
	        util_1.copyOwnProps(propDefs, proto.standardPropMap);
	    };
	    ParsableModelMixin.copyVerbatimStandardProps = function (src, dest) {
	        var map = this.prototype.standardPropMap;
	        var propName;
	        for (propName in map) {
	            if (src[propName] != null && // in the src object?
	                map[propName] === true // false means "copy verbatim"
	            ) {
	                dest[propName] = src[propName];
	            }
	        }
	    };
	    /*
	    Returns true/false for success.
	    Meant to be only called ONCE, at object creation.
	    */
	    ParsableModelMixin.prototype.applyProps = function (rawProps) {
	        var standardPropMap = this.standardPropMap;
	        var manualProps = {};
	        var miscProps = {};
	        var propName;
	        for (propName in rawProps) {
	            if (standardPropMap[propName] === true) {
	                this[propName] = rawProps[propName];
	            }
	            else if (standardPropMap[propName] === false) {
	                manualProps[propName] = rawProps[propName];
	            }
	            else {
	                miscProps[propName] = rawProps[propName];
	            }
	        }
	        this.applyMiscProps(miscProps);
	        return this.applyManualStandardProps(manualProps);
	    };
	    /*
	    If subclasses override, they must call this supermethod and return the boolean response.
	    Meant to be only called ONCE, at object creation.
	    */
	    ParsableModelMixin.prototype.applyManualStandardProps = function (rawProps) {
	        return true;
	    };
	    /*
	    Can be called even after initial object creation.
	    */
	    ParsableModelMixin.prototype.applyMiscProps = function (rawProps) {
	        // subclasses can implement
	    };
	    /*
	    TODO: why is this a method when defineStandardProps is static
	    */
	    ParsableModelMixin.prototype.isStandardProp = function (propName) {
	        return propName in this.standardPropMap;
	    };
	    return ParsableModelMixin;
	}(Mixin_1.default));
	exports.default = ParsableModelMixin;
	ParsableModelMixin.prototype.standardPropMap = {}; // will be cloned by defineStandardProps
	
	
	/***/ }),
	/* 209 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventInstance = /** @class */ (function () {
	    function EventInstance(def, dateProfile) {
	        this.def = def;
	        this.dateProfile = dateProfile;
	    }
	    EventInstance.prototype.toLegacy = function () {
	        var dateProfile = this.dateProfile;
	        var obj = this.def.toLegacy();
	        obj.start = dateProfile.start.clone();
	        obj.end = dateProfile.end ? dateProfile.end.clone() : null;
	        return obj;
	    };
	    return EventInstance;
	}());
	exports.default = EventInstance;
	
	
	/***/ }),
	/* 210 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var moment = __webpack_require__(0);
	var EventDef_1 = __webpack_require__(33);
	var EventInstance_1 = __webpack_require__(209);
	var EventDateProfile_1 = __webpack_require__(17);
	var RecurringEventDef = /** @class */ (function (_super) {
	    tslib_1.__extends(RecurringEventDef, _super);
	    function RecurringEventDef() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    RecurringEventDef.prototype.isAllDay = function () {
	        return !this.startTime && !this.endTime;
	    };
	    RecurringEventDef.prototype.buildInstances = function (unzonedRange) {
	        var calendar = this.source.calendar;
	        var unzonedDate = unzonedRange.getStart();
	        var unzonedEnd = unzonedRange.getEnd();
	        var zonedDayStart;
	        var instanceStart;
	        var instanceEnd;
	        var instances = [];
	        while (unzonedDate.isBefore(unzonedEnd)) {
	            // if everyday, or this particular day-of-week
	            if (!this.dowHash || this.dowHash[unzonedDate.day()]) {
	                zonedDayStart = calendar.applyTimezone(unzonedDate);
	                instanceStart = zonedDayStart.clone();
	                instanceEnd = null;
	                if (this.startTime) {
	                    instanceStart.time(this.startTime);
	                }
	                else {
	                    instanceStart.stripTime();
	                }
	                if (this.endTime) {
	                    instanceEnd = zonedDayStart.clone().time(this.endTime);
	                }
	                instances.push(new EventInstance_1.default(this, // definition
	                new EventDateProfile_1.default(instanceStart, instanceEnd, calendar)));
	            }
	            unzonedDate.add(1, 'days');
	        }
	        return instances;
	    };
	    RecurringEventDef.prototype.setDow = function (dowNumbers) {
	        if (!this.dowHash) {
	            this.dowHash = {};
	        }
	        for (var i = 0; i < dowNumbers.length; i++) {
	            this.dowHash[dowNumbers[i]] = true;
	        }
	    };
	    RecurringEventDef.prototype.clone = function () {
	        var def = _super.prototype.clone.call(this);
	        if (def.startTime) {
	            def.startTime = moment.duration(this.startTime);
	        }
	        if (def.endTime) {
	            def.endTime = moment.duration(this.endTime);
	        }
	        if (this.dowHash) {
	            def.dowHash = $.extend({}, this.dowHash);
	        }
	        return def;
	    };
	    return RecurringEventDef;
	}(EventDef_1.default));
	exports.default = RecurringEventDef;
	/*
	HACK to work with TypeScript mixins
	NOTE: if super-method fails, should still attempt to apply
	*/
	RecurringEventDef.prototype.applyProps = function (rawProps) {
	    var superSuccess = EventDef_1.default.prototype.applyProps.call(this, rawProps);
	    if (rawProps.start) {
	        this.startTime = moment.duration(rawProps.start);
	    }
	    if (rawProps.end) {
	        this.endTime = moment.duration(rawProps.end);
	    }
	    if (rawProps.dow) {
	        this.setDow(rawProps.dow);
	    }
	    return superSuccess;
	};
	// Parsing
	// ---------------------------------------------------------------------------------------------------------------------
	RecurringEventDef.defineStandardProps({
	    start: false,
	    end: false,
	    dow: false
	});
	
	
	/***/ }),
	/* 211 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventRange = /** @class */ (function () {
	    function EventRange(unzonedRange, eventDef, eventInstance) {
	        this.unzonedRange = unzonedRange;
	        this.eventDef = eventDef;
	        if (eventInstance) {
	            this.eventInstance = eventInstance;
	        }
	    }
	    return EventRange;
	}());
	exports.default = EventRange;
	
	
	/***/ }),
	/* 212 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(34);
	var EventInstanceGroup_1 = __webpack_require__(18);
	var RecurringEventDef_1 = __webpack_require__(210);
	var EventSource_1 = __webpack_require__(6);
	var BUSINESS_HOUR_EVENT_DEFAULTS = {
	    start: '09:00',
	    end: '17:00',
	    dow: [1, 2, 3, 4, 5],
	    rendering: 'inverse-background'
	    // classNames are defined in businessHoursSegClasses
	};
	var BusinessHourGenerator = /** @class */ (function () {
	    function BusinessHourGenerator(rawComplexDef, calendar) {
	        this.rawComplexDef = rawComplexDef;
	        this.calendar = calendar;
	    }
	    BusinessHourGenerator.prototype.buildEventInstanceGroup = function (isAllDay, unzonedRange) {
	        var eventDefs = this.buildEventDefs(isAllDay);
	        var eventInstanceGroup;
	        if (eventDefs.length) {
	            eventInstanceGroup = new EventInstanceGroup_1.default(util_1.eventDefsToEventInstances(eventDefs, unzonedRange));
	            // so that inverse-background rendering can happen even when no eventRanges in view
	            eventInstanceGroup.explicitEventDef = eventDefs[0];
	            return eventInstanceGroup;
	        }
	    };
	    BusinessHourGenerator.prototype.buildEventDefs = function (isAllDay) {
	        var rawComplexDef = this.rawComplexDef;
	        var rawDefs = [];
	        var requireDow = false;
	        var i;
	        var defs = [];
	        if (rawComplexDef === true) {
	            rawDefs = [{}]; // will get BUSINESS_HOUR_EVENT_DEFAULTS verbatim
	        }
	        else if ($.isPlainObject(rawComplexDef)) {
	            rawDefs = [rawComplexDef];
	        }
	        else if ($.isArray(rawComplexDef)) {
	            rawDefs = rawComplexDef;
	            requireDow = true; // every sub-definition NEEDS a day-of-week
	        }
	        for (i = 0; i < rawDefs.length; i++) {
	            if (!requireDow || rawDefs[i].dow) {
	                defs.push(this.buildEventDef(isAllDay, rawDefs[i]));
	            }
	        }
	        return defs;
	    };
	    BusinessHourGenerator.prototype.buildEventDef = function (isAllDay, rawDef) {
	        var fullRawDef = $.extend({}, BUSINESS_HOUR_EVENT_DEFAULTS, rawDef);
	        if (isAllDay) {
	            fullRawDef.start = null;
	            fullRawDef.end = null;
	        }
	        return RecurringEventDef_1.default.parse(fullRawDef, new EventSource_1.default(this.calendar) // dummy source
	        );
	    };
	    return BusinessHourGenerator;
	}());
	exports.default = BusinessHourGenerator;
	
	
	/***/ }),
	/* 213 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var Theme_1 = __webpack_require__(38);
	var StandardTheme = /** @class */ (function (_super) {
	    tslib_1.__extends(StandardTheme, _super);
	    function StandardTheme() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return StandardTheme;
	}(Theme_1.default));
	exports.default = StandardTheme;
	StandardTheme.prototype.classes = {
	    widget: 'fc-unthemed',
	    widgetHeader: 'fc-widget-header',
	    widgetContent: 'fc-widget-content',
	    buttonGroup: 'fc-button-group',
	    button: 'fc-button',
	    cornerLeft: 'fc-corner-left',
	    cornerRight: 'fc-corner-right',
	    stateDefault: 'fc-state-default',
	    stateActive: 'fc-state-active',
	    stateDisabled: 'fc-state-disabled',
	    stateHover: 'fc-state-hover',
	    stateDown: 'fc-state-down',
	    popoverHeader: 'fc-widget-header',
	    popoverContent: 'fc-widget-content',
	    // day grid
	    headerRow: 'fc-widget-header',
	    dayRow: 'fc-widget-content',
	    // list view
	    listView: 'fc-widget-content'
	};
	StandardTheme.prototype.baseIconClass = 'fc-icon';
	StandardTheme.prototype.iconClasses = {
	    close: 'fc-icon-x',
	    prev: 'fc-icon-left-single-arrow',
	    next: 'fc-icon-right-single-arrow',
	    prevYear: 'fc-icon-left-double-arrow',
	    nextYear: 'fc-icon-right-double-arrow'
	};
	StandardTheme.prototype.iconOverrideOption = 'buttonIcons';
	StandardTheme.prototype.iconOverrideCustomButtonOption = 'icon';
	StandardTheme.prototype.iconOverridePrefix = 'fc-icon-';
	
	
	/***/ }),
	/* 214 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var Theme_1 = __webpack_require__(38);
	var JqueryUiTheme = /** @class */ (function (_super) {
	    tslib_1.__extends(JqueryUiTheme, _super);
	    function JqueryUiTheme() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return JqueryUiTheme;
	}(Theme_1.default));
	exports.default = JqueryUiTheme;
	JqueryUiTheme.prototype.classes = {
	    widget: 'ui-widget',
	    widgetHeader: 'ui-widget-header',
	    widgetContent: 'ui-widget-content',
	    buttonGroup: 'fc-button-group',
	    button: 'ui-button',
	    cornerLeft: 'ui-corner-left',
	    cornerRight: 'ui-corner-right',
	    stateDefault: 'ui-state-default',
	    stateActive: 'ui-state-active',
	    stateDisabled: 'ui-state-disabled',
	    stateHover: 'ui-state-hover',
	    stateDown: 'ui-state-down',
	    today: 'ui-state-highlight',
	    popoverHeader: 'ui-widget-header',
	    popoverContent: 'ui-widget-content',
	    // day grid
	    headerRow: 'ui-widget-header',
	    dayRow: 'ui-widget-content',
	    // list view
	    listView: 'ui-widget-content'
	};
	JqueryUiTheme.prototype.baseIconClass = 'ui-icon';
	JqueryUiTheme.prototype.iconClasses = {
	    close: 'ui-icon-closethick',
	    prev: 'ui-icon-circle-triangle-w',
	    next: 'ui-icon-circle-triangle-e',
	    prevYear: 'ui-icon-seek-prev',
	    nextYear: 'ui-icon-seek-next'
	};
	JqueryUiTheme.prototype.iconOverrideOption = 'themeButtonIcons';
	JqueryUiTheme.prototype.iconOverrideCustomButtonOption = 'themeIcon';
	JqueryUiTheme.prototype.iconOverridePrefix = 'ui-icon-';
	
	
	/***/ }),
	/* 215 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var Promise_1 = __webpack_require__(19);
	var EventSource_1 = __webpack_require__(6);
	var FuncEventSource = /** @class */ (function (_super) {
	    tslib_1.__extends(FuncEventSource, _super);
	    function FuncEventSource() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FuncEventSource.parse = function (rawInput, calendar) {
	        var rawProps;
	        // normalize raw input
	        if ($.isFunction(rawInput.events)) {
	            rawProps = rawInput;
	        }
	        else if ($.isFunction(rawInput)) {
	            rawProps = { events: rawInput };
	        }
	        if (rawProps) {
	            return EventSource_1.default.parse.call(this, rawProps, calendar);
	        }
	        return false;
	    };
	    FuncEventSource.prototype.fetch = function (start, end, timezone) {
	        var _this = this;
	        this.calendar.pushLoading();
	        return Promise_1.default.construct(function (onResolve) {
	            _this.func.call(_this.calendar, start.clone(), end.clone(), timezone, function (rawEventDefs) {
	                _this.calendar.popLoading();
	                onResolve(_this.parseEventDefs(rawEventDefs));
	            });
	        });
	    };
	    FuncEventSource.prototype.getPrimitive = function () {
	        return this.func;
	    };
	    FuncEventSource.prototype.applyManualStandardProps = function (rawProps) {
	        var superSuccess = _super.prototype.applyManualStandardProps.call(this, rawProps);
	        this.func = rawProps.events;
	        return superSuccess;
	    };
	    return FuncEventSource;
	}(EventSource_1.default));
	exports.default = FuncEventSource;
	FuncEventSource.defineStandardProps({
	    events: false // don't automatically transfer
	});
	
	
	/***/ }),
	/* 216 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var Promise_1 = __webpack_require__(19);
	var EventSource_1 = __webpack_require__(6);
	var JsonFeedEventSource = /** @class */ (function (_super) {
	    tslib_1.__extends(JsonFeedEventSource, _super);
	    function JsonFeedEventSource() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    JsonFeedEventSource.parse = function (rawInput, calendar) {
	        var rawProps;
	        // normalize raw input
	        if (typeof rawInput.url === 'string') {
	            rawProps = rawInput;
	        }
	        else if (typeof rawInput === 'string') {
	            rawProps = { url: rawInput };
	        }
	        if (rawProps) {
	            return EventSource_1.default.parse.call(this, rawProps, calendar);
	        }
	        return false;
	    };
	    JsonFeedEventSource.prototype.fetch = function (start, end, timezone) {
	        var _this = this;
	        var ajaxSettings = this.ajaxSettings;
	        var onSuccess = ajaxSettings.success;
	        var onError = ajaxSettings.error;
	        var requestParams = this.buildRequestParams(start, end, timezone);
	        // todo: eventually handle the promise's then,
	        // don't intercept success/error
	        // tho will be a breaking API change
	        this.calendar.pushLoading();
	        return Promise_1.default.construct(function (onResolve, onReject) {
	            $.ajax($.extend({}, // destination
	            JsonFeedEventSource.AJAX_DEFAULTS, ajaxSettings, {
	                url: _this.url,
	                data: requestParams,
	                success: function (rawEventDefs, status, xhr) {
	                    var callbackRes;
	                    _this.calendar.popLoading();
	                    if (rawEventDefs) {
	                        callbackRes = util_1.applyAll(onSuccess, _this, [rawEventDefs, status, xhr]); // redirect `this`
	                        if ($.isArray(callbackRes)) {
	                            rawEventDefs = callbackRes;
	                        }
	                        onResolve(_this.parseEventDefs(rawEventDefs));
	                    }
	                    else {
	                        onReject();
	                    }
	                },
	                error: function (xhr, statusText, errorThrown) {
	                    _this.calendar.popLoading();
	                    util_1.applyAll(onError, _this, [xhr, statusText, errorThrown]); // redirect `this`
	                    onReject();
	                }
	            }));
	        });
	    };
	    JsonFeedEventSource.prototype.buildRequestParams = function (start, end, timezone) {
	        var calendar = this.calendar;
	        var ajaxSettings = this.ajaxSettings;
	        var startParam;
	        var endParam;
	        var timezoneParam;
	        var customRequestParams;
	        var params = {};
	        startParam = this.startParam;
	        if (startParam == null) {
	            startParam = calendar.opt('startParam');
	        }
	        endParam = this.endParam;
	        if (endParam == null) {
	            endParam = calendar.opt('endParam');
	        }
	        timezoneParam = this.timezoneParam;
	        if (timezoneParam == null) {
	            timezoneParam = calendar.opt('timezoneParam');
	        }
	        // retrieve any outbound GET/POST $.ajax data from the options
	        if ($.isFunction(ajaxSettings.data)) {
	            // supplied as a function that returns a key/value object
	            customRequestParams = ajaxSettings.data();
	        }
	        else {
	            // probably supplied as a straight key/value object
	            customRequestParams = ajaxSettings.data || {};
	        }
	        $.extend(params, customRequestParams);
	        params[startParam] = start.format();
	        params[endParam] = end.format();
	        if (timezone && timezone !== 'local') {
	            params[timezoneParam] = timezone;
	        }
	        return params;
	    };
	    JsonFeedEventSource.prototype.getPrimitive = function () {
	        return this.url;
	    };
	    JsonFeedEventSource.prototype.applyMiscProps = function (rawProps) {
	        this.ajaxSettings = rawProps;
	    };
	    JsonFeedEventSource.AJAX_DEFAULTS = {
	        dataType: 'json',
	        cache: false
	    };
	    return JsonFeedEventSource;
	}(EventSource_1.default));
	exports.default = JsonFeedEventSource;
	JsonFeedEventSource.defineStandardProps({
	    // automatically transfer (true)...
	    url: true,
	    startParam: true,
	    endParam: true,
	    timezoneParam: true
	});
	
	
	/***/ }),
	/* 217 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var EmitterMixin_1 = __webpack_require__(11);
	var TaskQueue = /** @class */ (function () {
	    function TaskQueue() {
	        this.q = [];
	        this.isPaused = false;
	        this.isRunning = false;
	    }
	    TaskQueue.prototype.queue = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this.q.push.apply(this.q, args); // append
	        this.tryStart();
	    };
	    TaskQueue.prototype.pause = function () {
	        this.isPaused = true;
	    };
	    TaskQueue.prototype.resume = function () {
	        this.isPaused = false;
	        this.tryStart();
	    };
	    TaskQueue.prototype.getIsIdle = function () {
	        return !this.isRunning && !this.isPaused;
	    };
	    TaskQueue.prototype.tryStart = function () {
	        if (!this.isRunning && this.canRunNext()) {
	            this.isRunning = true;
	            this.trigger('start');
	            this.runRemaining();
	        }
	    };
	    TaskQueue.prototype.canRunNext = function () {
	        return !this.isPaused && this.q.length;
	    };
	    TaskQueue.prototype.runRemaining = function () {
	        var _this = this;
	        var task;
	        var res;
	        do {
	            task = this.q.shift(); // always freshly reference q. might have been reassigned.
	            res = this.runTask(task);
	            if (res && res.then) {
	                res.then(function () {
	                    if (_this.canRunNext()) {
	                        _this.runRemaining();
	                    }
	                });
	                return; // prevent marking as stopped
	            }
	        } while (this.canRunNext());
	        this.trigger('stop'); // not really a 'stop' ... more of a 'drained'
	        this.isRunning = false;
	        // if 'stop' handler added more tasks.... TODO: write test for this
	        this.tryStart();
	    };
	    TaskQueue.prototype.runTask = function (task) {
	        return task(); // task *is* the function, but subclasses can change the format of a task
	    };
	    return TaskQueue;
	}());
	exports.default = TaskQueue;
	EmitterMixin_1.default.mixInto(TaskQueue);
	
	
	/***/ }),
	/* 218 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var TaskQueue_1 = __webpack_require__(217);
	var RenderQueue = /** @class */ (function (_super) {
	    tslib_1.__extends(RenderQueue, _super);
	    function RenderQueue(waitsByNamespace) {
	        var _this = _super.call(this) || this;
	        _this.waitsByNamespace = waitsByNamespace || {};
	        return _this;
	    }
	    RenderQueue.prototype.queue = function (taskFunc, namespace, type) {
	        var task = {
	            func: taskFunc,
	            namespace: namespace,
	            type: type
	        };
	        var waitMs;
	        if (namespace) {
	            waitMs = this.waitsByNamespace[namespace];
	        }
	        if (this.waitNamespace) {
	            if (namespace === this.waitNamespace && waitMs != null) {
	                this.delayWait(waitMs);
	            }
	            else {
	                this.clearWait();
	                this.tryStart();
	            }
	        }
	        if (this.compoundTask(task)) {
	            if (!this.waitNamespace && waitMs != null) {
	                this.startWait(namespace, waitMs);
	            }
	            else {
	                this.tryStart();
	            }
	        }
	    };
	    RenderQueue.prototype.startWait = function (namespace, waitMs) {
	        this.waitNamespace = namespace;
	        this.spawnWait(waitMs);
	    };
	    RenderQueue.prototype.delayWait = function (waitMs) {
	        clearTimeout(this.waitId);
	        this.spawnWait(waitMs);
	    };
	    RenderQueue.prototype.spawnWait = function (waitMs) {
	        var _this = this;
	        this.waitId = setTimeout(function () {
	            _this.waitNamespace = null;
	            _this.tryStart();
	        }, waitMs);
	    };
	    RenderQueue.prototype.clearWait = function () {
	        if (this.waitNamespace) {
	            clearTimeout(this.waitId);
	            this.waitId = null;
	            this.waitNamespace = null;
	        }
	    };
	    RenderQueue.prototype.canRunNext = function () {
	        if (!_super.prototype.canRunNext.call(this)) {
	            return false;
	        }
	        // waiting for a certain namespace to stop receiving tasks?
	        if (this.waitNamespace) {
	            var q = this.q;
	            // if there was a different namespace task in the meantime,
	            // that forces all previously-waiting tasks to suddenly execute.
	            // TODO: find a way to do this in constant time.
	            for (var i = 0; i < q.length; i++) {
	                if (q[i].namespace !== this.waitNamespace) {
	                    return true; // allow execution
	                }
	            }
	            return false;
	        }
	        return true;
	    };
	    RenderQueue.prototype.runTask = function (task) {
	        task.func();
	    };
	    RenderQueue.prototype.compoundTask = function (newTask) {
	        var q = this.q;
	        var shouldAppend = true;
	        var i;
	        var task;
	        if (newTask.namespace && newTask.type === 'destroy') {
	            // remove all init/add/remove ops with same namespace, regardless of order
	            for (i = q.length - 1; i >= 0; i--) {
	                task = q[i];
	                switch (task.type) {
	                    case 'init':
	                        shouldAppend = false;
	                    // the latest destroy is cancelled out by not doing the init
	                    /* falls through */
	                    case 'add':
	                    /* falls through */
	                    case 'remove':
	                        q.splice(i, 1); // remove task
	                }
	            }
	        }
	        if (shouldAppend) {
	            q.push(newTask);
	        }
	        return shouldAppend;
	    };
	    return RenderQueue;
	}(TaskQueue_1.default));
	exports.default = RenderQueue;
	
	
	/***/ }),
	/* 219 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var moment = __webpack_require__(0);
	var util_1 = __webpack_require__(4);
	var moment_ext_1 = __webpack_require__(10);
	var date_formatting_1 = __webpack_require__(47);
	var Component_1 = __webpack_require__(237);
	var util_2 = __webpack_require__(34);
	var DateComponent = /** @class */ (function (_super) {
	    tslib_1.__extends(DateComponent, _super);
	    function DateComponent(_view, _options) {
	        var _this = _super.call(this) || this;
	        _this.isRTL = false; // frequently accessed options
	        _this.hitsNeededDepth = 0; // necessary because multiple callers might need the same hits
	        _this.hasAllDayBusinessHours = false; // TODO: unify with largeUnit and isTimeScale?
	        _this.isDatesRendered = false;
	        // hack to set options prior to the this.opt calls
	        if (_view) {
	            _this['view'] = _view;
	        }
	        if (_options) {
	            _this['options'] = _options;
	        }
	        _this.uid = String(DateComponent.guid++);
	        _this.childrenByUid = {};
	        _this.nextDayThreshold = moment.duration(_this.opt('nextDayThreshold'));
	        _this.isRTL = _this.opt('isRTL');
	        if (_this.fillRendererClass) {
	            _this.fillRenderer = new _this.fillRendererClass(_this);
	        }
	        if (_this.eventRendererClass) {
	            _this.eventRenderer = new _this.eventRendererClass(_this, _this.fillRenderer);
	        }
	        if (_this.helperRendererClass && _this.eventRenderer) {
	            _this.helperRenderer = new _this.helperRendererClass(_this, _this.eventRenderer);
	        }
	        if (_this.businessHourRendererClass && _this.fillRenderer) {
	            _this.businessHourRenderer = new _this.businessHourRendererClass(_this, _this.fillRenderer);
	        }
	        return _this;
	    }
	    DateComponent.prototype.addChild = function (child) {
	        if (!this.childrenByUid[child.uid]) {
	            this.childrenByUid[child.uid] = child;
	            return true;
	        }
	        return false;
	    };
	    DateComponent.prototype.removeChild = function (child) {
	        if (this.childrenByUid[child.uid]) {
	            delete this.childrenByUid[child.uid];
	            return true;
	        }
	        return false;
	    };
	    // TODO: only do if isInDom?
	    // TODO: make part of Component, along with children/batch-render system?
	    DateComponent.prototype.updateSize = function (totalHeight, isAuto, isResize) {
	        this.callChildren('updateSize', arguments);
	    };
	    // Options
	    // -----------------------------------------------------------------------------------------------------------------
	    DateComponent.prototype.opt = function (name) {
	        return this._getView().opt(name); // default implementation
	    };
	    DateComponent.prototype.publiclyTrigger = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var calendar = this._getCalendar();
	        return calendar.publiclyTrigger.apply(calendar, args);
	    };
	    DateComponent.prototype.hasPublicHandlers = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var calendar = this._getCalendar();
	        return calendar.hasPublicHandlers.apply(calendar, args);
	    };
	    // Date
	    // -----------------------------------------------------------------------------------------------------------------
	    DateComponent.prototype.executeDateRender = function (dateProfile) {
	        this.dateProfile = dateProfile; // for rendering
	        this.renderDates(dateProfile);
	        this.isDatesRendered = true;
	        this.callChildren('executeDateRender', arguments);
	    };
	    DateComponent.prototype.executeDateUnrender = function () {
	        this.callChildren('executeDateUnrender', arguments);
	        this.dateProfile = null;
	        this.unrenderDates();
	        this.isDatesRendered = false;
	    };
	    // date-cell content only
	    DateComponent.prototype.renderDates = function (dateProfile) {
	        // subclasses should implement
	    };
	    // date-cell content only
	    DateComponent.prototype.unrenderDates = function () {
	        // subclasses should override
	    };
	    // Now-Indicator
	    // -----------------------------------------------------------------------------------------------------------------
	    // Returns a string unit, like 'second' or 'minute' that defined how often the current time indicator
	    // should be refreshed. If something falsy is returned, no time indicator is rendered at all.
	    DateComponent.prototype.getNowIndicatorUnit = function () {
	        // subclasses should implement
	    };
	    // Renders a current time indicator at the given datetime
	    DateComponent.prototype.renderNowIndicator = function (date) {
	        this.callChildren('renderNowIndicator', arguments);
	    };
	    // Undoes the rendering actions from renderNowIndicator
	    DateComponent.prototype.unrenderNowIndicator = function () {
	        this.callChildren('unrenderNowIndicator', arguments);
	    };
	    // Business Hours
	    // ---------------------------------------------------------------------------------------------------------------
	    DateComponent.prototype.renderBusinessHours = function (businessHourGenerator) {
	        if (this.businessHourRenderer) {
	            this.businessHourRenderer.render(businessHourGenerator);
	        }
	        this.callChildren('renderBusinessHours', arguments);
	    };
	    // Unrenders previously-rendered business-hours
	    DateComponent.prototype.unrenderBusinessHours = function () {
	        this.callChildren('unrenderBusinessHours', arguments);
	        if (this.businessHourRenderer) {
	            this.businessHourRenderer.unrender();
	        }
	    };
	    // Event Displaying
	    // -----------------------------------------------------------------------------------------------------------------
	    DateComponent.prototype.executeEventRender = function (eventsPayload) {
	        if (this.eventRenderer) {
	            this.eventRenderer.rangeUpdated(); // poorly named now
	            this.eventRenderer.render(eventsPayload);
	        }
	        else if (this['renderEvents']) {
	            this['renderEvents'](convertEventsPayloadToLegacyArray(eventsPayload));
	        }
	        this.callChildren('executeEventRender', arguments);
	    };
	    DateComponent.prototype.executeEventUnrender = function () {
	        this.callChildren('executeEventUnrender', arguments);
	        if (this.eventRenderer) {
	            this.eventRenderer.unrender();
	        }
	        else if (this['destroyEvents']) {
	            this['destroyEvents']();
	        }
	    };
	    DateComponent.prototype.getBusinessHourSegs = function () {
	        var segs = this.getOwnBusinessHourSegs();
	        this.iterChildren(function (child) {
	            segs.push.apply(segs, child.getBusinessHourSegs());
	        });
	        return segs;
	    };
	    DateComponent.prototype.getOwnBusinessHourSegs = function () {
	        if (this.businessHourRenderer) {
	            return this.businessHourRenderer.getSegs();
	        }
	        return [];
	    };
	    DateComponent.prototype.getEventSegs = function () {
	        var segs = this.getOwnEventSegs();
	        this.iterChildren(function (child) {
	            segs.push.apply(segs, child.getEventSegs());
	        });
	        return segs;
	    };
	    DateComponent.prototype.getOwnEventSegs = function () {
	        if (this.eventRenderer) {
	            return this.eventRenderer.getSegs();
	        }
	        return [];
	    };
	    // Event Rendering Triggering
	    // -----------------------------------------------------------------------------------------------------------------
	    DateComponent.prototype.triggerAfterEventsRendered = function () {
	        this.triggerAfterEventSegsRendered(this.getEventSegs());
	        this.publiclyTrigger('eventAfterAllRender', {
	            context: this,
	            args: [this]
	        });
	    };
	    DateComponent.prototype.triggerAfterEventSegsRendered = function (segs) {
	        var _this = this;
	        // an optimization, because getEventLegacy is expensive
	        if (this.hasPublicHandlers('eventAfterRender')) {
	            segs.forEach(function (seg) {
	                var legacy;
	                if (seg.el) {
	                    legacy = seg.footprint.getEventLegacy();
	                    _this.publiclyTrigger('eventAfterRender', {
	                        context: legacy,
	                        args: [legacy, seg.el, _this]
	                    });
	                }
	            });
	        }
	    };
	    DateComponent.prototype.triggerBeforeEventsDestroyed = function () {
	        this.triggerBeforeEventSegsDestroyed(this.getEventSegs());
	    };
	    DateComponent.prototype.triggerBeforeEventSegsDestroyed = function (segs) {
	        var _this = this;
	        if (this.hasPublicHandlers('eventDestroy')) {
	            segs.forEach(function (seg) {
	                var legacy;
	                if (seg.el) {
	                    legacy = seg.footprint.getEventLegacy();
	                    _this.publiclyTrigger('eventDestroy', {
	                        context: legacy,
	                        args: [legacy, seg.el, _this]
	                    });
	                }
	            });
	        }
	    };
	    // Event Rendering Utils
	    // -----------------------------------------------------------------------------------------------------------------
	    // Hides all rendered event segments linked to the given event
	    // RECURSIVE with subcomponents
	    DateComponent.prototype.showEventsWithId = function (eventDefId) {
	        this.getEventSegs().forEach(function (seg) {
	            if (seg.footprint.eventDef.id === eventDefId &&
	                seg.el // necessary?
	            ) {
	                seg.el.css('visibility', '');
	            }
	        });
	        this.callChildren('showEventsWithId', arguments);
	    };
	    // Shows all rendered event segments linked to the given event
	    // RECURSIVE with subcomponents
	    DateComponent.prototype.hideEventsWithId = function (eventDefId) {
	        this.getEventSegs().forEach(function (seg) {
	            if (seg.footprint.eventDef.id === eventDefId &&
	                seg.el // necessary?
	            ) {
	                seg.el.css('visibility', 'hidden');
	            }
	        });
	        this.callChildren('hideEventsWithId', arguments);
	    };
	    // Drag-n-Drop Rendering (for both events and external elements)
	    // ---------------------------------------------------------------------------------------------------------------
	    // Renders a visual indication of a event or external-element drag over the given drop zone.
	    // If an external-element, seg will be `null`.
	    // Must return elements used for any mock events.
	    DateComponent.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
	        var renderedHelper = false;
	        this.iterChildren(function (child) {
	            if (child.renderDrag(eventFootprints, seg, isTouch)) {
	                renderedHelper = true;
	            }
	        });
	        return renderedHelper;
	    };
	    // Unrenders a visual indication of an event or external-element being dragged.
	    DateComponent.prototype.unrenderDrag = function () {
	        this.callChildren('unrenderDrag', arguments);
	    };
	    // Event Resizing
	    // ---------------------------------------------------------------------------------------------------------------
	    // Renders a visual indication of an event being resized.
	    DateComponent.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
	        this.callChildren('renderEventResize', arguments);
	    };
	    // Unrenders a visual indication of an event being resized.
	    DateComponent.prototype.unrenderEventResize = function () {
	        this.callChildren('unrenderEventResize', arguments);
	    };
	    // Selection
	    // ---------------------------------------------------------------------------------------------------------------
	    // Renders a visual indication of the selection
	    // TODO: rename to `renderSelection` after legacy is gone
	    DateComponent.prototype.renderSelectionFootprint = function (componentFootprint) {
	        this.renderHighlight(componentFootprint);
	        this.callChildren('renderSelectionFootprint', arguments);
	    };
	    // Unrenders a visual indication of selection
	    DateComponent.prototype.unrenderSelection = function () {
	        this.unrenderHighlight();
	        this.callChildren('unrenderSelection', arguments);
	    };
	    // Highlight
	    // ---------------------------------------------------------------------------------------------------------------
	    // Renders an emphasis on the given date range. Given a span (unzoned start/end and other misc data)
	    DateComponent.prototype.renderHighlight = function (componentFootprint) {
	        if (this.fillRenderer) {
	            this.fillRenderer.renderFootprint('highlight', componentFootprint, {
	                getClasses: function () {
	                    return ['fc-highlight'];
	                }
	            });
	        }
	        this.callChildren('renderHighlight', arguments);
	    };
	    // Unrenders the emphasis on a date range
	    DateComponent.prototype.unrenderHighlight = function () {
	        if (this.fillRenderer) {
	            this.fillRenderer.unrender('highlight');
	        }
	        this.callChildren('unrenderHighlight', arguments);
	    };
	    // Hit Areas
	    // ---------------------------------------------------------------------------------------------------------------
	    // just because all DateComponents support this interface
	    // doesn't mean they need to have their own internal coord system. they can defer to sub-components.
	    DateComponent.prototype.hitsNeeded = function () {
	        if (!(this.hitsNeededDepth++)) {
	            this.prepareHits();
	        }
	        this.callChildren('hitsNeeded', arguments);
	    };
	    DateComponent.prototype.hitsNotNeeded = function () {
	        if (this.hitsNeededDepth && !(--this.hitsNeededDepth)) {
	            this.releaseHits();
	        }
	        this.callChildren('hitsNotNeeded', arguments);
	    };
	    DateComponent.prototype.prepareHits = function () {
	        // subclasses can implement
	    };
	    DateComponent.prototype.releaseHits = function () {
	        // subclasses can implement
	    };
	    // Given coordinates from the topleft of the document, return data about the date-related area underneath.
	    // Can return an object with arbitrary properties (although top/right/left/bottom are encouraged).
	    // Must have a `grid` property, a reference to this current grid. TODO: avoid this
	    // The returned object will be processed by getHitFootprint and getHitEl.
	    DateComponent.prototype.queryHit = function (leftOffset, topOffset) {
	        var childrenByUid = this.childrenByUid;
	        var uid;
	        var hit;
	        for (uid in childrenByUid) {
	            hit = childrenByUid[uid].queryHit(leftOffset, topOffset);
	            if (hit) {
	                break;
	            }
	        }
	        return hit;
	    };
	    DateComponent.prototype.getSafeHitFootprint = function (hit) {
	        var footprint = this.getHitFootprint(hit);
	        if (!this.dateProfile.activeUnzonedRange.containsRange(footprint.unzonedRange)) {
	            return null;
	        }
	        return footprint;
	    };
	    DateComponent.prototype.getHitFootprint = function (hit) {
	        // what about being abstract!?
	    };
	    // Given position-level information about a date-related area within the grid,
	    // should return a jQuery element that best represents it. passed to dayClick callback.
	    DateComponent.prototype.getHitEl = function (hit) {
	        // what about being abstract!?
	    };
	    /* Converting eventRange -> eventFootprint
	    ------------------------------------------------------------------------------------------------------------------*/
	    DateComponent.prototype.eventRangesToEventFootprints = function (eventRanges) {
	        var eventFootprints = [];
	        var i;
	        for (i = 0; i < eventRanges.length; i++) {
	            eventFootprints.push.apply(// append
	            eventFootprints, this.eventRangeToEventFootprints(eventRanges[i]));
	        }
	        return eventFootprints;
	    };
	    DateComponent.prototype.eventRangeToEventFootprints = function (eventRange) {
	        return [util_2.eventRangeToEventFootprint(eventRange)];
	    };
	    /* Converting componentFootprint/eventFootprint -> segs
	    ------------------------------------------------------------------------------------------------------------------*/
	    DateComponent.prototype.eventFootprintsToSegs = function (eventFootprints) {
	        var segs = [];
	        var i;
	        for (i = 0; i < eventFootprints.length; i++) {
	            segs.push.apply(segs, this.eventFootprintToSegs(eventFootprints[i]));
	        }
	        return segs;
	    };
	    // Given an event's span (unzoned start/end and other misc data), and the event itself,
	    // slices into segments and attaches event-derived properties to them.
	    // eventSpan - { start, end, isStart, isEnd, otherthings... }
	    DateComponent.prototype.eventFootprintToSegs = function (eventFootprint) {
	        var unzonedRange = eventFootprint.componentFootprint.unzonedRange;
	        var segs;
	        var i;
	        var seg;
	        segs = this.componentFootprintToSegs(eventFootprint.componentFootprint);
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            if (!unzonedRange.isStart) {
	                seg.isStart = false;
	            }
	            if (!unzonedRange.isEnd) {
	                seg.isEnd = false;
	            }
	            seg.footprint = eventFootprint;
	            // TODO: rename to seg.eventFootprint
	        }
	        return segs;
	    };
	    DateComponent.prototype.componentFootprintToSegs = function (componentFootprint) {
	        return [];
	    };
	    // Utils
	    // ---------------------------------------------------------------------------------------------------------------
	    DateComponent.prototype.callChildren = function (methodName, args) {
	        this.iterChildren(function (child) {
	            child[methodName].apply(child, args);
	        });
	    };
	    DateComponent.prototype.iterChildren = function (func) {
	        var childrenByUid = this.childrenByUid;
	        var uid;
	        for (uid in childrenByUid) {
	            func(childrenByUid[uid]);
	        }
	    };
	    DateComponent.prototype._getCalendar = function () {
	        var t = this;
	        return t.calendar || t.view.calendar;
	    };
	    DateComponent.prototype._getView = function () {
	        return this.view;
	    };
	    DateComponent.prototype._getDateProfile = function () {
	        return this._getView().get('dateProfile');
	    };
	    // Generates HTML for an anchor to another view into the calendar.
	    // Will either generate an <a> tag or a non-clickable <span> tag, depending on enabled settings.
	    // `gotoOptions` can either be a moment input, or an object with the form:
	    // { date, type, forceOff }
	    // `type` is a view-type like "day" or "week". default value is "day".
	    // `attrs` and `innerHtml` are use to generate the rest of the HTML tag.
	    DateComponent.prototype.buildGotoAnchorHtml = function (gotoOptions, attrs, innerHtml) {
	        var date;
	        var type;
	        var forceOff;
	        var finalOptions;
	        if ($.isPlainObject(gotoOptions)) {
	            date = gotoOptions.date;
	            type = gotoOptions.type;
	            forceOff = gotoOptions.forceOff;
	        }
	        else {
	            date = gotoOptions; // a single moment input
	        }
	        date = moment_ext_1.default(date); // if a string, parse it
	        finalOptions = {
	            date: date.format('YYYY-MM-DD'),
	            type: type || 'day'
	        };
	        if (typeof attrs === 'string') {
	            innerHtml = attrs;
	            attrs = null;
	        }
	        attrs = attrs ? ' ' + util_1.attrsToStr(attrs) : ''; // will have a leading space
	        innerHtml = innerHtml || '';
	        if (!forceOff && this.opt('navLinks')) {
	            return '<a' + attrs +
	                ' data-goto="' + util_1.htmlEscape(JSON.stringify(finalOptions)) + '">' +
	                innerHtml +
	                '</a>';
	        }
	        else {
	            return '<span' + attrs + '>' +
	                innerHtml +
	                '</span>';
	        }
	    };
	    DateComponent.prototype.getAllDayHtml = function () {
	        return this.opt('allDayHtml') || util_1.htmlEscape(this.opt('allDayText'));
	    };
	    // Computes HTML classNames for a single-day element
	    DateComponent.prototype.getDayClasses = function (date, noThemeHighlight) {
	        var view = this._getView();
	        var classes = [];
	        var today;
	        if (!this.dateProfile.activeUnzonedRange.containsDate(date)) {
	            classes.push('fc-disabled-day'); // TODO: jQuery UI theme?
	        }
	        else {
	            classes.push('fc-' + util_1.dayIDs[date.day()]);
	            if (view.isDateInOtherMonth(date, this.dateProfile)) {
	                classes.push('fc-other-month');
	            }
	            today = view.calendar.getNow();
	            if (date.isSame(today, 'day')) {
	                classes.push('fc-today');
	                if (noThemeHighlight !== true) {
	                    classes.push(view.calendar.theme.getClass('today'));
	                }
	            }
	            else if (date < today) {
	                classes.push('fc-past');
	            }
	            else {
	                classes.push('fc-future');
	            }
	        }
	        return classes;
	    };
	    // Utility for formatting a range. Accepts a range object, formatting string, and optional separator.
	    // Displays all-day ranges naturally, with an inclusive end. Takes the current isRTL into account.
	    // The timezones of the dates within `range` will be respected.
	    DateComponent.prototype.formatRange = function (range, isAllDay, formatStr, separator) {
	        var end = range.end;
	        if (isAllDay) {
	            end = end.clone().subtract(1); // convert to inclusive. last ms of previous day
	        }
	        return date_formatting_1.formatRange(range.start, end, formatStr, separator, this.isRTL);
	    };
	    // Compute the number of the give units in the "current" range.
	    // Will return a floating-point number. Won't round.
	    DateComponent.prototype.currentRangeAs = function (unit) {
	        return this._getDateProfile().currentUnzonedRange.as(unit);
	    };
	    // Returns the date range of the full days the given range visually appears to occupy.
	    // Returns a plain object with start/end, NOT an UnzonedRange!
	    DateComponent.prototype.computeDayRange = function (unzonedRange) {
	        var calendar = this._getCalendar();
	        var startDay = calendar.msToUtcMoment(unzonedRange.startMs, true); // the beginning of the day the range starts
	        var end = calendar.msToUtcMoment(unzonedRange.endMs);
	        var endTimeMS = +end.time(); // # of milliseconds into `endDay`
	        var endDay = end.clone().stripTime(); // the beginning of the day the range exclusively ends
	        // If the end time is actually inclusively part of the next day and is equal to or
	        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
	        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
	        if (endTimeMS && endTimeMS >= this.nextDayThreshold) {
	            endDay.add(1, 'days');
	        }
	        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
	        if (endDay <= startDay) {
	            endDay = startDay.clone().add(1, 'days');
	        }
	        return { start: startDay, end: endDay };
	    };
	    // Does the given range visually appear to occupy more than one day?
	    DateComponent.prototype.isMultiDayRange = function (unzonedRange) {
	        var dayRange = this.computeDayRange(unzonedRange);
	        return dayRange.end.diff(dayRange.start, 'days') > 1;
	    };
	    DateComponent.guid = 0; // TODO: better system for this?
	    return DateComponent;
	}(Component_1.default));
	exports.default = DateComponent;
	// legacy
	function convertEventsPayloadToLegacyArray(eventsPayload) {
	    var eventDefId;
	    var eventInstances;
	    var legacyEvents = [];
	    var i;
	    for (eventDefId in eventsPayload) {
	        eventInstances = eventsPayload[eventDefId].eventInstances;
	        for (i = 0; i < eventInstances.length; i++) {
	            legacyEvents.push(eventInstances[i].toLegacy());
	        }
	    }
	    return legacyEvents;
	}
	
	
	/***/ }),
	/* 220 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var moment = __webpack_require__(0);
	var util_1 = __webpack_require__(4);
	var options_1 = __webpack_require__(31);
	var Iterator_1 = __webpack_require__(238);
	var GlobalEmitter_1 = __webpack_require__(20);
	var EmitterMixin_1 = __webpack_require__(11);
	var ListenerMixin_1 = __webpack_require__(7);
	var Toolbar_1 = __webpack_require__(239);
	var OptionsManager_1 = __webpack_require__(240);
	var ViewSpecManager_1 = __webpack_require__(241);
	var Constraints_1 = __webpack_require__(207);
	var locale_1 = __webpack_require__(30);
	var moment_ext_1 = __webpack_require__(10);
	var UnzonedRange_1 = __webpack_require__(5);
	var ComponentFootprint_1 = __webpack_require__(12);
	var EventDateProfile_1 = __webpack_require__(17);
	var EventManager_1 = __webpack_require__(242);
	var BusinessHourGenerator_1 = __webpack_require__(212);
	var EventSourceParser_1 = __webpack_require__(37);
	var EventDefParser_1 = __webpack_require__(49);
	var SingleEventDef_1 = __webpack_require__(13);
	var EventDefMutation_1 = __webpack_require__(36);
	var EventSource_1 = __webpack_require__(6);
	var ThemeRegistry_1 = __webpack_require__(51);
	var Calendar = /** @class */ (function () {
	    function Calendar(el, overrides) {
	        this.loadingLevel = 0; // number of simultaneous loading tasks
	        this.ignoreUpdateViewSize = 0;
	        this.freezeContentHeightDepth = 0;
	        // declare the current calendar instance relies on GlobalEmitter. needed for garbage collection.
	        // unneeded() is called in destroy.
	        GlobalEmitter_1.default.needed();
	        this.el = el;
	        this.viewsByType = {};
	        this.optionsManager = new OptionsManager_1.default(this, overrides);
	        this.viewSpecManager = new ViewSpecManager_1.default(this.optionsManager, this);
	        this.initMomentInternals(); // needs to happen after options hash initialized
	        this.initCurrentDate();
	        this.initEventManager();
	        this.constraints = new Constraints_1.default(this.eventManager, this);
	        this.constructed();
	    }
	    Calendar.prototype.constructed = function () {
	        // useful for monkeypatching. used?
	    };
	    Calendar.prototype.getView = function () {
	        return this.view;
	    };
	    Calendar.prototype.publiclyTrigger = function (name, triggerInfo) {
	        var optHandler = this.opt(name);
	        var context;
	        var args;
	        if ($.isPlainObject(triggerInfo)) {
	            context = triggerInfo.context;
	            args = triggerInfo.args;
	        }
	        else if ($.isArray(triggerInfo)) {
	            args = triggerInfo;
	        }
	        if (context == null) {
	            context = this.el[0]; // fallback context
	        }
	        if (!args) {
	            args = [];
	        }
	        this.triggerWith(name, context, args); // Emitter's method
	        if (optHandler) {
	            return optHandler.apply(context, args);
	        }
	    };
	    Calendar.prototype.hasPublicHandlers = function (name) {
	        return this.hasHandlers(name) ||
	            this.opt(name); // handler specified in options
	    };
	    // Options Public API
	    // -----------------------------------------------------------------------------------------------------------------
	    // public getter/setter
	    Calendar.prototype.option = function (name, value) {
	        var newOptionHash;
	        if (typeof name === 'string') {
	            if (value === undefined) {
	                return this.optionsManager.get(name);
	            }
	            else {
	                newOptionHash = {};
	                newOptionHash[name] = value;
	                this.optionsManager.add(newOptionHash);
	            }
	        }
	        else if (typeof name === 'object') {
	            this.optionsManager.add(name);
	        }
	    };
	    // private getter
	    Calendar.prototype.opt = function (name) {
	        return this.optionsManager.get(name);
	    };
	    // View
	    // -----------------------------------------------------------------------------------------------------------------
	    // Given a view name for a custom view or a standard view, creates a ready-to-go View object
	    Calendar.prototype.instantiateView = function (viewType) {
	        var spec = this.viewSpecManager.getViewSpec(viewType);
	        if (!spec) {
	            throw new Error("View type \"" + viewType + "\" is not valid");
	        }
	        return new spec['class'](this, spec);
	    };
	    // Returns a boolean about whether the view is okay to instantiate at some point
	    Calendar.prototype.isValidViewType = function (viewType) {
	        return Boolean(this.viewSpecManager.getViewSpec(viewType));
	    };
	    Calendar.prototype.changeView = function (viewName, dateOrRange) {
	        if (dateOrRange) {
	            if (dateOrRange.start && dateOrRange.end) {
	                this.optionsManager.recordOverrides({
	                    visibleRange: dateOrRange
	                });
	            }
	            else {
	                this.currentDate = this.moment(dateOrRange).stripZone(); // just like gotoDate
	            }
	        }
	        this.renderView(viewName);
	    };
	    // Forces navigation to a view for the given date.
	    // `viewType` can be a specific view name or a generic one like "week" or "day".
	    Calendar.prototype.zoomTo = function (newDate, viewType) {
	        var spec;
	        viewType = viewType || 'day'; // day is default zoom
	        spec = this.viewSpecManager.getViewSpec(viewType) ||
	            this.viewSpecManager.getUnitViewSpec(viewType);
	        this.currentDate = newDate.clone();
	        this.renderView(spec ? spec.type : null);
	    };
	    // Current Date
	    // -----------------------------------------------------------------------------------------------------------------
	    Calendar.prototype.initCurrentDate = function () {
	        var defaultDateInput = this.opt('defaultDate');
	        // compute the initial ambig-timezone date
	        if (defaultDateInput != null) {
	            this.currentDate = this.moment(defaultDateInput).stripZone();
	        }
	        else {
	            this.currentDate = this.getNow(); // getNow already returns unzoned
	        }
	    };
	    Calendar.prototype.prev = function () {
	        var view = this.view;
	        var prevInfo = view.dateProfileGenerator.buildPrev(view.get('dateProfile'));
	        if (prevInfo.isValid) {
	            this.currentDate = prevInfo.date;
	            this.renderView();
	        }
	    };
	    Calendar.prototype.next = function () {
	        var view = this.view;
	        var nextInfo = view.dateProfileGenerator.buildNext(view.get('dateProfile'));
	        if (nextInfo.isValid) {
	            this.currentDate = nextInfo.date;
	            this.renderView();
	        }
	    };
	    Calendar.prototype.prevYear = function () {
	        this.currentDate.add(-1, 'years');
	        this.renderView();
	    };
	    Calendar.prototype.nextYear = function () {
	        this.currentDate.add(1, 'years');
	        this.renderView();
	    };
	    Calendar.prototype.today = function () {
	        this.currentDate = this.getNow(); // should deny like prev/next?
	        this.renderView();
	    };
	    Calendar.prototype.gotoDate = function (zonedDateInput) {
	        this.currentDate = this.moment(zonedDateInput).stripZone();
	        this.renderView();
	    };
	    Calendar.prototype.incrementDate = function (delta) {
	        this.currentDate.add(moment.duration(delta));
	        this.renderView();
	    };
	    // for external API
	    Calendar.prototype.getDate = function () {
	        return this.applyTimezone(this.currentDate); // infuse the calendar's timezone
	    };
	    // Loading Triggering
	    // -----------------------------------------------------------------------------------------------------------------
	    // Should be called when any type of async data fetching begins
	    Calendar.prototype.pushLoading = function () {
	        if (!(this.loadingLevel++)) {
	            this.publiclyTrigger('loading', [true, this.view]);
	        }
	    };
	    // Should be called when any type of async data fetching completes
	    Calendar.prototype.popLoading = function () {
	        if (!(--this.loadingLevel)) {
	            this.publiclyTrigger('loading', [false, this.view]);
	        }
	    };
	    // High-level Rendering
	    // -----------------------------------------------------------------------------------
	    Calendar.prototype.render = function () {
	        if (!this.contentEl) {
	            this.initialRender();
	        }
	        else if (this.elementVisible()) {
	            // mainly for the public API
	            this.calcSize();
	            this.updateViewSize();
	        }
	    };
	    Calendar.prototype.initialRender = function () {
	        var _this = this;
	        var el = this.el;
	        el.addClass('fc');
	        // event delegation for nav links
	        el.on('click.fc', 'a[data-goto]', function (ev) {
	            var anchorEl = $(ev.currentTarget);
	            var gotoOptions = anchorEl.data('goto'); // will automatically parse JSON
	            var date = _this.moment(gotoOptions.date);
	            var viewType = gotoOptions.type;
	            // property like "navLinkDayClick". might be a string or a function
	            var customAction = _this.view.opt('navLink' + util_1.capitaliseFirstLetter(viewType) + 'Click');
	            if (typeof customAction === 'function') {
	                customAction(date, ev);
	            }
	            else {
	                if (typeof customAction === 'string') {
	                    viewType = customAction;
	                }
	                _this.zoomTo(date, viewType);
	            }
	        });
	        // called immediately, and upon option change
	        this.optionsManager.watch('settingTheme', ['?theme', '?themeSystem'], function (opts) {
	            var themeClass = ThemeRegistry_1.getThemeSystemClass(opts.themeSystem || opts.theme);
	            var theme = new themeClass(_this.optionsManager);
	            var widgetClass = theme.getClass('widget');
	            _this.theme = theme;
	            if (widgetClass) {
	                el.addClass(widgetClass);
	            }
	        }, function () {
	            var widgetClass = _this.theme.getClass('widget');
	            _this.theme = null;
	            if (widgetClass) {
	                el.removeClass(widgetClass);
	            }
	        });
	        this.optionsManager.watch('settingBusinessHourGenerator', ['?businessHours'], function (deps) {
	            _this.businessHourGenerator = new BusinessHourGenerator_1.default(deps.businessHours, _this);
	            if (_this.view) {
	                _this.view.set('businessHourGenerator', _this.businessHourGenerator);
	            }
	        }, function () {
	            _this.businessHourGenerator = null;
	        });
	        // called immediately, and upon option change.
	        // HACK: locale often affects isRTL, so we explicitly listen to that too.
	        this.optionsManager.watch('applyingDirClasses', ['?isRTL', '?locale'], function (opts) {
	            el.toggleClass('fc-ltr', !opts.isRTL);
	            el.toggleClass('fc-rtl', opts.isRTL);
	        });
	        this.contentEl = $("<div class='fc-view-container'/>").prependTo(el);
	        this.initToolbars();
	        this.renderHeader();
	        this.renderFooter();
	        this.renderView(this.opt('defaultView'));
	        if (this.opt('handleWindowResize')) {
	            $(window).resize(this.windowResizeProxy = util_1.debounce(// prevents rapid calls
	            this.windowResize.bind(this), this.opt('windowResizeDelay')));
	        }
	    };
	    Calendar.prototype.destroy = function () {
	        if (this.view) {
	            this.clearView();
	        }
	        this.toolbarsManager.proxyCall('removeElement');
	        this.contentEl.remove();
	        this.el.removeClass('fc fc-ltr fc-rtl');
	        // removes theme-related root className
	        this.optionsManager.unwatch('settingTheme');
	        this.optionsManager.unwatch('settingBusinessHourGenerator');
	        this.el.off('.fc'); // unbind nav link handlers
	        if (this.windowResizeProxy) {
	            $(window).unbind('resize', this.windowResizeProxy);
	            this.windowResizeProxy = null;
	        }
	        GlobalEmitter_1.default.unneeded();
	    };
	    Calendar.prototype.elementVisible = function () {
	        return this.el.is(':visible');
	    };
	    // Render Queue
	    // -----------------------------------------------------------------------------------------------------------------
	    Calendar.prototype.bindViewHandlers = function (view) {
	        var _this = this;
	        view.watch('titleForCalendar', ['title'], function (deps) {
	            if (view === _this.view) {
	                _this.setToolbarsTitle(deps.title);
	            }
	        });
	        view.watch('dateProfileForCalendar', ['dateProfile'], function (deps) {
	            if (view === _this.view) {
	                _this.currentDate = deps.dateProfile.date; // might have been constrained by view dates
	                _this.updateToolbarButtons(deps.dateProfile);
	            }
	        });
	    };
	    Calendar.prototype.unbindViewHandlers = function (view) {
	        view.unwatch('titleForCalendar');
	        view.unwatch('dateProfileForCalendar');
	    };
	    // View Rendering
	    // -----------------------------------------------------------------------------------
	    // Renders a view because of a date change, view-type change, or for the first time.
	    // If not given a viewType, keep the current view but render different dates.
	    // Accepts an optional scroll state to restore to.
	    Calendar.prototype.renderView = function (viewType) {
	        var oldView = this.view;
	        var newView;
	        this.freezeContentHeight();
	        if (oldView && viewType && oldView.type !== viewType) {
	            this.clearView();
	        }
	        // if viewType changed, or the view was never created, create a fresh view
	        if (!this.view && viewType) {
	            newView = this.view =
	                this.viewsByType[viewType] ||
	                    (this.viewsByType[viewType] = this.instantiateView(viewType));
	            this.bindViewHandlers(newView);
	            newView.startBatchRender(); // so that setElement+setDate rendering are joined
	            newView.setElement($("<div class='fc-view fc-" + viewType + "-view' />").appendTo(this.contentEl));
	            this.toolbarsManager.proxyCall('activateButton', viewType);
	        }
	        if (this.view) {
	            // prevent unnecessary change firing
	            if (this.view.get('businessHourGenerator') !== this.businessHourGenerator) {
	                this.view.set('businessHourGenerator', this.businessHourGenerator);
	            }
	            this.view.setDate(this.currentDate);
	            if (newView) {
	                newView.stopBatchRender();
	            }
	        }
	        this.thawContentHeight();
	    };
	    // Unrenders the current view and reflects this change in the Header.
	    // Unregsiters the `view`, but does not remove from viewByType hash.
	    Calendar.prototype.clearView = function () {
	        var currentView = this.view;
	        this.toolbarsManager.proxyCall('deactivateButton', currentView.type);
	        this.unbindViewHandlers(currentView);
	        currentView.removeElement();
	        currentView.unsetDate(); // so bindViewHandlers doesn't fire with old values next time
	        this.view = null;
	    };
	    // Destroys the view, including the view object. Then, re-instantiates it and renders it.
	    // Maintains the same scroll state.
	    // TODO: maintain any other user-manipulated state.
	    Calendar.prototype.reinitView = function () {
	        var oldView = this.view;
	        var scroll = oldView.queryScroll(); // wouldn't be so complicated if Calendar owned the scroll
	        this.freezeContentHeight();
	        this.clearView();
	        this.calcSize();
	        this.renderView(oldView.type); // needs the type to freshly render
	        this.view.applyScroll(scroll);
	        this.thawContentHeight();
	    };
	    // Resizing
	    // -----------------------------------------------------------------------------------
	    Calendar.prototype.getSuggestedViewHeight = function () {
	        if (this.suggestedViewHeight == null) {
	            this.calcSize();
	        }
	        return this.suggestedViewHeight;
	    };
	    Calendar.prototype.isHeightAuto = function () {
	        return this.opt('contentHeight') === 'auto' || this.opt('height') === 'auto';
	    };
	    Calendar.prototype.updateViewSize = function (isResize) {
	        if (isResize === void 0) { isResize = false; }
	        var view = this.view;
	        var scroll;
	        if (!this.ignoreUpdateViewSize && view) {
	            if (isResize) {
	                this.calcSize();
	                scroll = view.queryScroll();
	            }
	            this.ignoreUpdateViewSize++;
	            view.updateSize(this.getSuggestedViewHeight(), this.isHeightAuto(), isResize);
	            this.ignoreUpdateViewSize--;
	            if (isResize) {
	                view.applyScroll(scroll);
	            }
	            return true; // signal success
	        }
	    };
	    Calendar.prototype.calcSize = function () {
	        if (this.elementVisible()) {
	            this._calcSize();
	        }
	    };
	    Calendar.prototype._calcSize = function () {
	        var contentHeightInput = this.opt('contentHeight');
	        var heightInput = this.opt('height');
	        if (typeof contentHeightInput === 'number') {
	            this.suggestedViewHeight = contentHeightInput;
	        }
	        else if (typeof contentHeightInput === 'function') {
	            this.suggestedViewHeight = contentHeightInput();
	        }
	        else if (typeof heightInput === 'number') {
	            this.suggestedViewHeight = heightInput - this.queryToolbarsHeight();
	        }
	        else if (typeof heightInput === 'function') {
	            this.suggestedViewHeight = heightInput() - this.queryToolbarsHeight();
	        }
	        else if (heightInput === 'parent') {
	            this.suggestedViewHeight = this.el.parent().height() - this.queryToolbarsHeight();
	        }
	        else {
	            this.suggestedViewHeight = Math.round(this.contentEl.width() /
	                Math.max(this.opt('aspectRatio'), .5));
	        }
	    };
	    Calendar.prototype.windowResize = function (ev) {
	        if (
	        // the purpose: so we don't process jqui "resize" events that have bubbled up
	        // cast to any because .target, which is Element, can't be compared to window for some reason.
	        ev.target === window &&
	            this.view &&
	            this.view.isDatesRendered) {
	            if (this.updateViewSize(true)) {
	                this.publiclyTrigger('windowResize', [this.view]);
	            }
	        }
	    };
	    /* Height "Freezing"
	    -----------------------------------------------------------------------------*/
	    Calendar.prototype.freezeContentHeight = function () {
	        if (!(this.freezeContentHeightDepth++)) {
	            this.forceFreezeContentHeight();
	        }
	    };
	    Calendar.prototype.forceFreezeContentHeight = function () {
	        this.contentEl.css({
	            width: '100%',
	            height: this.contentEl.height(),
	            overflow: 'hidden'
	        });
	    };
	    Calendar.prototype.thawContentHeight = function () {
	        this.freezeContentHeightDepth--;
	        // always bring back to natural height
	        this.contentEl.css({
	            width: '',
	            height: '',
	            overflow: ''
	        });
	        // but if there are future thaws, re-freeze
	        if (this.freezeContentHeightDepth) {
	            this.forceFreezeContentHeight();
	        }
	    };
	    // Toolbar
	    // -----------------------------------------------------------------------------------------------------------------
	    Calendar.prototype.initToolbars = function () {
	        this.header = new Toolbar_1.default(this, this.computeHeaderOptions());
	        this.footer = new Toolbar_1.default(this, this.computeFooterOptions());
	        this.toolbarsManager = new Iterator_1.default([this.header, this.footer]);
	    };
	    Calendar.prototype.computeHeaderOptions = function () {
	        return {
	            extraClasses: 'fc-header-toolbar',
	            layout: this.opt('header')
	        };
	    };
	    Calendar.prototype.computeFooterOptions = function () {
	        return {
	            extraClasses: 'fc-footer-toolbar',
	            layout: this.opt('footer')
	        };
	    };
	    // can be called repeatedly and Header will rerender
	    Calendar.prototype.renderHeader = function () {
	        var header = this.header;
	        header.setToolbarOptions(this.computeHeaderOptions());
	        header.render();
	        if (header.el) {
	            this.el.prepend(header.el);
	        }
	    };
	    // can be called repeatedly and Footer will rerender
	    Calendar.prototype.renderFooter = function () {
	        var footer = this.footer;
	        footer.setToolbarOptions(this.computeFooterOptions());
	        footer.render();
	        if (footer.el) {
	            this.el.append(footer.el);
	        }
	    };
	    Calendar.prototype.setToolbarsTitle = function (title) {
	        this.toolbarsManager.proxyCall('updateTitle', title);
	    };
	    Calendar.prototype.updateToolbarButtons = function (dateProfile) {
	        var now = this.getNow();
	        var view = this.view;
	        var todayInfo = view.dateProfileGenerator.build(now);
	        var prevInfo = view.dateProfileGenerator.buildPrev(view.get('dateProfile'));
	        var nextInfo = view.dateProfileGenerator.buildNext(view.get('dateProfile'));
	        this.toolbarsManager.proxyCall((todayInfo.isValid && !dateProfile.currentUnzonedRange.containsDate(now)) ?
	            'enableButton' :
	            'disableButton', 'today');
	        this.toolbarsManager.proxyCall(prevInfo.isValid ?
	            'enableButton' :
	            'disableButton', 'prev');
	        this.toolbarsManager.proxyCall(nextInfo.isValid ?
	            'enableButton' :
	            'disableButton', 'next');
	    };
	    Calendar.prototype.queryToolbarsHeight = function () {
	        return this.toolbarsManager.items.reduce(function (accumulator, toolbar) {
	            var toolbarHeight = toolbar.el ? toolbar.el.outerHeight(true) : 0; // includes margin
	            return accumulator + toolbarHeight;
	        }, 0);
	    };
	    // Selection
	    // -----------------------------------------------------------------------------------------------------------------
	    // this public method receives start/end dates in any format, with any timezone
	    Calendar.prototype.select = function (zonedStartInput, zonedEndInput) {
	        this.view.select(this.buildSelectFootprint.apply(this, arguments));
	    };
	    Calendar.prototype.unselect = function () {
	        if (this.view) {
	            this.view.unselect();
	        }
	    };
	    // Given arguments to the select method in the API, returns a span (unzoned start/end and other info)
	    Calendar.prototype.buildSelectFootprint = function (zonedStartInput, zonedEndInput) {
	        var start = this.moment(zonedStartInput).stripZone();
	        var end;
	        if (zonedEndInput) {
	            end = this.moment(zonedEndInput).stripZone();
	        }
	        else if (start.hasTime()) {
	            end = start.clone().add(this.defaultTimedEventDuration);
	        }
	        else {
	            end = start.clone().add(this.defaultAllDayEventDuration);
	        }
	        return new ComponentFootprint_1.default(new UnzonedRange_1.default(start, end), !start.hasTime());
	    };
	    // Date Utils
	    // -----------------------------------------------------------------------------------------------------------------
	    Calendar.prototype.initMomentInternals = function () {
	        var _this = this;
	        this.defaultAllDayEventDuration = moment.duration(this.opt('defaultAllDayEventDuration'));
	        this.defaultTimedEventDuration = moment.duration(this.opt('defaultTimedEventDuration'));
	        // Called immediately, and when any of the options change.
	        // Happens before any internal objects rebuild or rerender, because this is very core.
	        this.optionsManager.watch('buildingMomentLocale', [
	            '?locale', '?monthNames', '?monthNamesShort', '?dayNames', '?dayNamesShort',
	            '?firstDay', '?weekNumberCalculation'
	        ], function (opts) {
	            var weekNumberCalculation = opts.weekNumberCalculation;
	            var firstDay = opts.firstDay;
	            var _week;
	            // normalize
	            if (weekNumberCalculation === 'iso') {
	                weekNumberCalculation = 'ISO'; // normalize
	            }
	            var localeData = Object.create(// make a cheap copy
	            locale_1.getMomentLocaleData(opts.locale) // will fall back to en
	            );
	            if (opts.monthNames) {
	                localeData._months = opts.monthNames;
	            }
	            if (opts.monthNamesShort) {
	                localeData._monthsShort = opts.monthNamesShort;
	            }
	            if (opts.dayNames) {
	                localeData._weekdays = opts.dayNames;
	            }
	            if (opts.dayNamesShort) {
	                localeData._weekdaysShort = opts.dayNamesShort;
	            }
	            if (firstDay == null && weekNumberCalculation === 'ISO') {
	                firstDay = 1;
	            }
	            if (firstDay != null) {
	                _week = Object.create(localeData._week); // _week: { dow: # }
	                _week.dow = firstDay;
	                localeData._week = _week;
	            }
	            if (weekNumberCalculation === 'ISO' ||
	                weekNumberCalculation === 'local' ||
	                typeof weekNumberCalculation === 'function') {
	                localeData._fullCalendar_weekCalc = weekNumberCalculation; // moment-ext will know what to do with it
	            }
	            _this.localeData = localeData;
	            // If the internal current date object already exists, move to new locale.
	            // We do NOT need to do this technique for event dates, because this happens when converting to "segments".
	            if (_this.currentDate) {
	                _this.localizeMoment(_this.currentDate); // sets to localeData
	            }
	        });
	    };
	    // Builds a moment using the settings of the current calendar: timezone and locale.
	    // Accepts anything the vanilla moment() constructor accepts.
	    Calendar.prototype.moment = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var mom;
	        if (this.opt('timezone') === 'local') {
	            mom = moment_ext_1.default.apply(null, args);
	            // Force the moment to be local, because momentExt doesn't guarantee it.
	            if (mom.hasTime()) {
	                mom.local();
	            }
	        }
	        else if (this.opt('timezone') === 'UTC') {
	            mom = moment_ext_1.default.utc.apply(null, args); // process as UTC
	        }
	        else {
	            mom = moment_ext_1.default.parseZone.apply(null, args); // let the input decide the zone
	        }
	        this.localizeMoment(mom); // TODO
	        return mom;
	    };
	    Calendar.prototype.msToMoment = function (ms, forceAllDay) {
	        var mom = moment_ext_1.default.utc(ms); // TODO: optimize by using Date.UTC
	        if (forceAllDay) {
	            mom.stripTime();
	        }
	        else {
	            mom = this.applyTimezone(mom); // may or may not apply locale
	        }
	        this.localizeMoment(mom);
	        return mom;
	    };
	    Calendar.prototype.msToUtcMoment = function (ms, forceAllDay) {
	        var mom = moment_ext_1.default.utc(ms); // TODO: optimize by using Date.UTC
	        if (forceAllDay) {
	            mom.stripTime();
	        }
	        this.localizeMoment(mom);
	        return mom;
	    };
	    // Updates the given moment's locale settings to the current calendar locale settings.
	    Calendar.prototype.localizeMoment = function (mom) {
	        mom._locale = this.localeData;
	    };
	    // Returns a boolean about whether or not the calendar knows how to calculate
	    // the timezone offset of arbitrary dates in the current timezone.
	    Calendar.prototype.getIsAmbigTimezone = function () {
	        return this.opt('timezone') !== 'local' && this.opt('timezone') !== 'UTC';
	    };
	    // Returns a copy of the given date in the current timezone. Has no effect on dates without times.
	    Calendar.prototype.applyTimezone = function (date) {
	        if (!date.hasTime()) {
	            return date.clone();
	        }
	        var zonedDate = this.moment(date.toArray());
	        var timeAdjust = date.time().asMilliseconds() - zonedDate.time().asMilliseconds();
	        var adjustedZonedDate;
	        // Safari sometimes has problems with this coersion when near DST. Adjust if necessary. (bug #2396)
	        if (timeAdjust) {
	            adjustedZonedDate = zonedDate.clone().add(timeAdjust); // add milliseconds
	            if (date.time().asMilliseconds() - adjustedZonedDate.time().asMilliseconds() === 0) {
	                zonedDate = adjustedZonedDate;
	            }
	        }
	        return zonedDate;
	    };
	    /*
	    Assumes the footprint is non-open-ended.
	    */
	    Calendar.prototype.footprintToDateProfile = function (componentFootprint, ignoreEnd) {
	        if (ignoreEnd === void 0) { ignoreEnd = false; }
	        var start = moment_ext_1.default.utc(componentFootprint.unzonedRange.startMs);
	        var end;
	        if (!ignoreEnd) {
	            end = moment_ext_1.default.utc(componentFootprint.unzonedRange.endMs);
	        }
	        if (componentFootprint.isAllDay) {
	            start.stripTime();
	            if (end) {
	                end.stripTime();
	            }
	        }
	        else {
	            start = this.applyTimezone(start);
	            if (end) {
	                end = this.applyTimezone(end);
	            }
	        }
	        return new EventDateProfile_1.default(start, end, this);
	    };
	    // Returns a moment for the current date, as defined by the client's computer or from the `now` option.
	    // Will return an moment with an ambiguous timezone.
	    Calendar.prototype.getNow = function () {
	        var now = this.opt('now');
	        if (typeof now === 'function') {
	            now = now();
	        }
	        return this.moment(now).stripZone();
	    };
	    // Produces a human-readable string for the given duration.
	    // Side-effect: changes the locale of the given duration.
	    Calendar.prototype.humanizeDuration = function (duration) {
	        return duration.locale(this.opt('locale')).humanize();
	    };
	    // will return `null` if invalid range
	    Calendar.prototype.parseUnzonedRange = function (rangeInput) {
	        var start = null;
	        var end = null;
	        if (rangeInput.start) {
	            start = this.moment(rangeInput.start).stripZone();
	        }
	        if (rangeInput.end) {
	            end = this.moment(rangeInput.end).stripZone();
	        }
	        if (!start && !end) {
	            return null;
	        }
	        if (start && end && end.isBefore(start)) {
	            return null;
	        }
	        return new UnzonedRange_1.default(start, end);
	    };
	    // Event-Date Utilities
	    // -----------------------------------------------------------------------------------------------------------------
	    Calendar.prototype.initEventManager = function () {
	        var _this = this;
	        var eventManager = new EventManager_1.default(this);
	        var rawSources = this.opt('eventSources') || [];
	        var singleRawSource = this.opt('events');
	        this.eventManager = eventManager;
	        if (singleRawSource) {
	            rawSources.unshift(singleRawSource);
	        }
	        eventManager.on('release', function (eventsPayload) {
	            _this.trigger('eventsReset', eventsPayload);
	        });
	        eventManager.freeze();
	        rawSources.forEach(function (rawSource) {
	            var source = EventSourceParser_1.default.parse(rawSource, _this);
	            if (source) {
	                eventManager.addSource(source);
	            }
	        });
	        eventManager.thaw();
	    };
	    Calendar.prototype.requestEvents = function (start, end) {
	        return this.eventManager.requestEvents(start, end, this.opt('timezone'), !this.opt('lazyFetching'));
	    };
	    // Get an event's normalized end date. If not present, calculate it from the defaults.
	    Calendar.prototype.getEventEnd = function (event) {
	        if (event.end) {
	            return event.end.clone();
	        }
	        else {
	            return this.getDefaultEventEnd(event.allDay, event.start);
	        }
	    };
	    // Given an event's allDay status and start date, return what its fallback end date should be.
	    // TODO: rename to computeDefaultEventEnd
	    Calendar.prototype.getDefaultEventEnd = function (allDay, zonedStart) {
	        var end = zonedStart.clone();
	        if (allDay) {
	            end.stripTime().add(this.defaultAllDayEventDuration);
	        }
	        else {
	            end.add(this.defaultTimedEventDuration);
	        }
	        if (this.getIsAmbigTimezone()) {
	            end.stripZone(); // we don't know what the tzo should be
	        }
	        return end;
	    };
	    // Public Events API
	    // -----------------------------------------------------------------------------------------------------------------
	    Calendar.prototype.rerenderEvents = function () {
	        this.view.flash('displayingEvents');
	    };
	    Calendar.prototype.refetchEvents = function () {
	        this.eventManager.refetchAllSources();
	    };
	    Calendar.prototype.renderEvents = function (eventInputs, isSticky) {
	        this.eventManager.freeze();
	        for (var i = 0; i < eventInputs.length; i++) {
	            this.renderEvent(eventInputs[i], isSticky);
	        }
	        this.eventManager.thaw();
	    };
	    Calendar.prototype.renderEvent = function (eventInput, isSticky) {
	        if (isSticky === void 0) { isSticky = false; }
	        var eventManager = this.eventManager;
	        var eventDef = EventDefParser_1.default.parse(eventInput, eventInput.source || eventManager.stickySource);
	        if (eventDef) {
	            eventManager.addEventDef(eventDef, isSticky);
	        }
	    };
	    // legacyQuery operates on legacy event instance objects
	    Calendar.prototype.removeEvents = function (legacyQuery) {
	        var eventManager = this.eventManager;
	        var legacyInstances = [];
	        var idMap = {};
	        var eventDef;
	        var i;
	        if (legacyQuery == null) {
	            eventManager.removeAllEventDefs(); // persist=true
	        }
	        else {
	            eventManager.getEventInstances().forEach(function (eventInstance) {
	                legacyInstances.push(eventInstance.toLegacy());
	            });
	            legacyInstances = filterLegacyEventInstances(legacyInstances, legacyQuery);
	            // compute unique IDs
	            for (i = 0; i < legacyInstances.length; i++) {
	                eventDef = this.eventManager.getEventDefByUid(legacyInstances[i]._id);
	                idMap[eventDef.id] = true;
	            }
	            eventManager.freeze();
	            for (i in idMap) {
	                eventManager.removeEventDefsById(i); // persist=true
	            }
	            eventManager.thaw();
	        }
	    };
	    // legacyQuery operates on legacy event instance objects
	    Calendar.prototype.clientEvents = function (legacyQuery) {
	        var legacyEventInstances = [];
	        this.eventManager.getEventInstances().forEach(function (eventInstance) {
	            legacyEventInstances.push(eventInstance.toLegacy());
	        });
	        return filterLegacyEventInstances(legacyEventInstances, legacyQuery);
	    };
	    Calendar.prototype.updateEvents = function (eventPropsArray) {
	        this.eventManager.freeze();
	        for (var i = 0; i < eventPropsArray.length; i++) {
	            this.updateEvent(eventPropsArray[i]);
	        }
	        this.eventManager.thaw();
	    };
	    Calendar.prototype.updateEvent = function (eventProps) {
	        var eventDef = this.eventManager.getEventDefByUid(eventProps._id);
	        var eventInstance;
	        var eventDefMutation;
	        if (eventDef instanceof SingleEventDef_1.default) {
	            eventInstance = eventDef.buildInstance();
	            eventDefMutation = EventDefMutation_1.default.createFromRawProps(eventInstance, eventProps, // raw props
	            null // largeUnit -- who uses it?
	            );
	            this.eventManager.mutateEventsWithId(eventDef.id, eventDefMutation); // will release
	        }
	    };
	    // Public Event Sources API
	    // ------------------------------------------------------------------------------------
	    Calendar.prototype.getEventSources = function () {
	        return this.eventManager.otherSources.slice(); // clone
	    };
	    Calendar.prototype.getEventSourceById = function (id) {
	        return this.eventManager.getSourceById(EventSource_1.default.normalizeId(id));
	    };
	    Calendar.prototype.addEventSource = function (sourceInput) {
	        var source = EventSourceParser_1.default.parse(sourceInput, this);
	        if (source) {
	            this.eventManager.addSource(source);
	        }
	    };
	    Calendar.prototype.removeEventSources = function (sourceMultiQuery) {
	        var eventManager = this.eventManager;
	        var sources;
	        var i;
	        if (sourceMultiQuery == null) {
	            this.eventManager.removeAllSources();
	        }
	        else {
	            sources = eventManager.multiQuerySources(sourceMultiQuery);
	            eventManager.freeze();
	            for (i = 0; i < sources.length; i++) {
	                eventManager.removeSource(sources[i]);
	            }
	            eventManager.thaw();
	        }
	    };
	    Calendar.prototype.removeEventSource = function (sourceQuery) {
	        var eventManager = this.eventManager;
	        var sources = eventManager.querySources(sourceQuery);
	        var i;
	        eventManager.freeze();
	        for (i = 0; i < sources.length; i++) {
	            eventManager.removeSource(sources[i]);
	        }
	        eventManager.thaw();
	    };
	    Calendar.prototype.refetchEventSources = function (sourceMultiQuery) {
	        var eventManager = this.eventManager;
	        var sources = eventManager.multiQuerySources(sourceMultiQuery);
	        var i;
	        eventManager.freeze();
	        for (i = 0; i < sources.length; i++) {
	            eventManager.refetchSource(sources[i]);
	        }
	        eventManager.thaw();
	    };
	    // not for internal use. use options module directly instead.
	    Calendar.defaults = options_1.globalDefaults;
	    Calendar.englishDefaults = options_1.englishDefaults;
	    Calendar.rtlDefaults = options_1.rtlDefaults;
	    return Calendar;
	}());
	exports.default = Calendar;
	EmitterMixin_1.default.mixInto(Calendar);
	ListenerMixin_1.default.mixInto(Calendar);
	function filterLegacyEventInstances(legacyEventInstances, legacyQuery) {
	    if (legacyQuery == null) {
	        return legacyEventInstances;
	    }
	    else if ($.isFunction(legacyQuery)) {
	        return legacyEventInstances.filter(legacyQuery);
	    }
	    else {
	        legacyQuery += ''; // normalize to string
	        return legacyEventInstances.filter(function (legacyEventInstance) {
	            // soft comparison because id not be normalized to string
	            // tslint:disable-next-line
	            return legacyEventInstance.id == legacyQuery ||
	                legacyEventInstance._id === legacyQuery; // can specify internal id, but must exactly match
	        });
	    }
	}
	
	
	/***/ }),
	/* 221 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(0);
	var util_1 = __webpack_require__(4);
	var UnzonedRange_1 = __webpack_require__(5);
	var DateProfileGenerator = /** @class */ (function () {
	    function DateProfileGenerator(_view) {
	        this._view = _view;
	    }
	    DateProfileGenerator.prototype.opt = function (name) {
	        return this._view.opt(name);
	    };
	    DateProfileGenerator.prototype.trimHiddenDays = function (unzonedRange) {
	        return this._view.trimHiddenDays(unzonedRange);
	    };
	    DateProfileGenerator.prototype.msToUtcMoment = function (ms, forceAllDay) {
	        return this._view.calendar.msToUtcMoment(ms, forceAllDay);
	    };
	    /* Date Range Computation
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Builds a structure with info about what the dates/ranges will be for the "prev" view.
	    DateProfileGenerator.prototype.buildPrev = function (currentDateProfile) {
	        var prevDate = currentDateProfile.date.clone()
	            .startOf(currentDateProfile.currentRangeUnit)
	            .subtract(currentDateProfile.dateIncrement);
	        return this.build(prevDate, -1);
	    };
	    // Builds a structure with info about what the dates/ranges will be for the "next" view.
	    DateProfileGenerator.prototype.buildNext = function (currentDateProfile) {
	        var nextDate = currentDateProfile.date.clone()
	            .startOf(currentDateProfile.currentRangeUnit)
	            .add(currentDateProfile.dateIncrement);
	        return this.build(nextDate, 1);
	    };
	    // Builds a structure holding dates/ranges for rendering around the given date.
	    // Optional direction param indicates whether the date is being incremented/decremented
	    // from its previous value. decremented = -1, incremented = 1 (default).
	    DateProfileGenerator.prototype.build = function (date, direction, forceToValid) {
	        if (forceToValid === void 0) { forceToValid = false; }
	        var isDateAllDay = !date.hasTime();
	        var validUnzonedRange;
	        var minTime = null;
	        var maxTime = null;
	        var currentInfo;
	        var isRangeAllDay;
	        var renderUnzonedRange;
	        var activeUnzonedRange;
	        var isValid;
	        validUnzonedRange = this.buildValidRange();
	        validUnzonedRange = this.trimHiddenDays(validUnzonedRange);
	        if (forceToValid) {
	            date = this.msToUtcMoment(validUnzonedRange.constrainDate(date), // returns MS
	            isDateAllDay);
	        }
	        currentInfo = this.buildCurrentRangeInfo(date, direction);
	        isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
	        renderUnzonedRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.unzonedRange), currentInfo.unit, isRangeAllDay);
	        renderUnzonedRange = this.trimHiddenDays(renderUnzonedRange);
	        activeUnzonedRange = renderUnzonedRange.clone();
	        if (!this.opt('showNonCurrentDates')) {
	            activeUnzonedRange = activeUnzonedRange.intersect(currentInfo.unzonedRange);
	        }
	        minTime = moment.duration(this.opt('minTime'));
	        maxTime = moment.duration(this.opt('maxTime'));
	        activeUnzonedRange = this.adjustActiveRange(activeUnzonedRange, minTime, maxTime);
	        activeUnzonedRange = activeUnzonedRange.intersect(validUnzonedRange); // might return null
	        if (activeUnzonedRange) {
	            date = this.msToUtcMoment(activeUnzonedRange.constrainDate(date), // returns MS
	            isDateAllDay);
	        }
	        // it's invalid if the originally requested date is not contained,
	        // or if the range is completely outside of the valid range.
	        isValid = currentInfo.unzonedRange.intersectsWith(validUnzonedRange);
	        return {
	            // constraint for where prev/next operations can go and where events can be dragged/resized to.
	            // an object with optional start and end properties.
	            validUnzonedRange: validUnzonedRange,
	            // range the view is formally responsible for.
	            // for example, a month view might have 1st-31st, excluding padded dates
	            currentUnzonedRange: currentInfo.unzonedRange,
	            // name of largest unit being displayed, like "month" or "week"
	            currentRangeUnit: currentInfo.unit,
	            isRangeAllDay: isRangeAllDay,
	            // dates that display events and accept drag-n-drop
	            // will be `null` if no dates accept events
	            activeUnzonedRange: activeUnzonedRange,
	            // date range with a rendered skeleton
	            // includes not-active days that need some sort of DOM
	            renderUnzonedRange: renderUnzonedRange,
	            // Duration object that denotes the first visible time of any given day
	            minTime: minTime,
	            // Duration object that denotes the exclusive visible end time of any given day
	            maxTime: maxTime,
	            isValid: isValid,
	            date: date,
	            // how far the current date will move for a prev/next operation
	            dateIncrement: this.buildDateIncrement(currentInfo.duration)
	            // pass a fallback (might be null) ^
	        };
	    };
	    // Builds an object with optional start/end properties.
	    // Indicates the minimum/maximum dates to display.
	    // not responsible for trimming hidden days.
	    DateProfileGenerator.prototype.buildValidRange = function () {
	        return this._view.getUnzonedRangeOption('validRange', this._view.calendar.getNow()) ||
	            new UnzonedRange_1.default(); // completely open-ended
	    };
	    // Builds a structure with info about the "current" range, the range that is
	    // highlighted as being the current month for example.
	    // See build() for a description of `direction`.
	    // Guaranteed to have `range` and `unit` properties. `duration` is optional.
	    // TODO: accept a MS-time instead of a moment `date`?
	    DateProfileGenerator.prototype.buildCurrentRangeInfo = function (date, direction) {
	        var viewSpec = this._view.viewSpec;
	        var duration = null;
	        var unit = null;
	        var unzonedRange = null;
	        var dayCount;
	        if (viewSpec.duration) {
	            duration = viewSpec.duration;
	            unit = viewSpec.durationUnit;
	            unzonedRange = this.buildRangeFromDuration(date, direction, duration, unit);
	        }
	        else if ((dayCount = this.opt('dayCount'))) {
	            unit = 'day';
	            unzonedRange = this.buildRangeFromDayCount(date, direction, dayCount);
	        }
	        else if ((unzonedRange = this.buildCustomVisibleRange(date))) {
	            unit = util_1.computeGreatestUnit(unzonedRange.getStart(), unzonedRange.getEnd());
	        }
	        else {
	            duration = this.getFallbackDuration();
	            unit = util_1.computeGreatestUnit(duration);
	            unzonedRange = this.buildRangeFromDuration(date, direction, duration, unit);
	        }
	        return { duration: duration, unit: unit, unzonedRange: unzonedRange };
	    };
	    DateProfileGenerator.prototype.getFallbackDuration = function () {
	        return moment.duration({ days: 1 });
	    };
	    // Returns a new activeUnzonedRange to have time values (un-ambiguate)
	    // minTime or maxTime causes the range to expand.
	    DateProfileGenerator.prototype.adjustActiveRange = function (unzonedRange, minTime, maxTime) {
	        var start = unzonedRange.getStart();
	        var end = unzonedRange.getEnd();
	        if (this._view.usesMinMaxTime) {
	            if (minTime < 0) {
	                start.time(0).add(minTime);
	            }
	            if (maxTime > 24 * 60 * 60 * 1000) {
	                end.time(maxTime - (24 * 60 * 60 * 1000));
	            }
	        }
	        return new UnzonedRange_1.default(start, end);
	    };
	    // Builds the "current" range when it is specified as an explicit duration.
	    // `unit` is the already-computed computeGreatestUnit value of duration.
	    // TODO: accept a MS-time instead of a moment `date`?
	    DateProfileGenerator.prototype.buildRangeFromDuration = function (date, direction, duration, unit) {
	        var alignment = this.opt('dateAlignment');
	        var dateIncrementInput;
	        var dateIncrementDuration;
	        var start;
	        var end;
	        var res;
	        // compute what the alignment should be
	        if (!alignment) {
	            dateIncrementInput = this.opt('dateIncrement');
	            if (dateIncrementInput) {
	                dateIncrementDuration = moment.duration(dateIncrementInput);
	                // use the smaller of the two units
	                if (dateIncrementDuration < duration) {
	                    alignment = util_1.computeDurationGreatestUnit(dateIncrementDuration, dateIncrementInput);
	                }
	                else {
	                    alignment = unit;
	                }
	            }
	            else {
	                alignment = unit;
	            }
	        }
	        // if the view displays a single day or smaller
	        if (duration.as('days') <= 1) {
	            if (this._view.isHiddenDay(start)) {
	                start = this._view.skipHiddenDays(start, direction);
	                start.startOf('day');
	            }
	        }
	        function computeRes() {
	            start = date.clone().startOf(alignment);
	            end = start.clone().add(duration);
	            res = new UnzonedRange_1.default(start, end);
	        }
	        computeRes();
	        // if range is completely enveloped by hidden days, go past the hidden days
	        if (!this.trimHiddenDays(res)) {
	            date = this._view.skipHiddenDays(date, direction);
	            computeRes();
	        }
	        return res;
	    };
	    // Builds the "current" range when a dayCount is specified.
	    // TODO: accept a MS-time instead of a moment `date`?
	    DateProfileGenerator.prototype.buildRangeFromDayCount = function (date, direction, dayCount) {
	        var customAlignment = this.opt('dateAlignment');
	        var runningCount = 0;
	        var start = date.clone();
	        var end;
	        if (customAlignment) {
	            start.startOf(customAlignment);
	        }
	        start.startOf('day');
	        start = this._view.skipHiddenDays(start, direction);
	        end = start.clone();
	        do {
	            end.add(1, 'day');
	            if (!this._view.isHiddenDay(end)) {
	                runningCount++;
	            }
	        } while (runningCount < dayCount);
	        return new UnzonedRange_1.default(start, end);
	    };
	    // Builds a normalized range object for the "visible" range,
	    // which is a way to define the currentUnzonedRange and activeUnzonedRange at the same time.
	    // TODO: accept a MS-time instead of a moment `date`?
	    DateProfileGenerator.prototype.buildCustomVisibleRange = function (date) {
	        var visibleUnzonedRange = this._view.getUnzonedRangeOption('visibleRange', this._view.calendar.applyTimezone(date) // correct zone. also generates new obj that avoids mutations
	        );
	        if (visibleUnzonedRange && (visibleUnzonedRange.startMs == null || visibleUnzonedRange.endMs == null)) {
	            return null;
	        }
	        return visibleUnzonedRange;
	    };
	    // Computes the range that will represent the element/cells for *rendering*,
	    // but which may have voided days/times.
	    // not responsible for trimming hidden days.
	    DateProfileGenerator.prototype.buildRenderRange = function (currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
	        return currentUnzonedRange.clone();
	    };
	    // Compute the duration value that should be added/substracted to the current date
	    // when a prev/next operation happens.
	    DateProfileGenerator.prototype.buildDateIncrement = function (fallback) {
	        var dateIncrementInput = this.opt('dateIncrement');
	        var customAlignment;
	        if (dateIncrementInput) {
	            return moment.duration(dateIncrementInput);
	        }
	        else if ((customAlignment = this.opt('dateAlignment'))) {
	            return moment.duration(1, customAlignment);
	        }
	        else if (fallback) {
	            return fallback;
	        }
	        else {
	            return moment.duration({ days: 1 });
	        }
	    };
	    return DateProfileGenerator;
	}());
	exports.default = DateProfileGenerator;
	
	
	/***/ }),
	/* 222 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var moment = __webpack_require__(0);
	var exportHooks = __webpack_require__(16);
	var util_1 = __webpack_require__(4);
	var moment_ext_1 = __webpack_require__(10);
	var ListenerMixin_1 = __webpack_require__(7);
	var HitDragListener_1 = __webpack_require__(22);
	var SingleEventDef_1 = __webpack_require__(13);
	var EventInstanceGroup_1 = __webpack_require__(18);
	var EventSource_1 = __webpack_require__(6);
	var Interaction_1 = __webpack_require__(15);
	var ExternalDropping = /** @class */ (function (_super) {
	    tslib_1.__extends(ExternalDropping, _super);
	    function ExternalDropping() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.isDragging = false; // jqui-dragging an external element? boolean
	        return _this;
	    }
	    /*
	    component impements:
	      - eventRangesToEventFootprints
	      - isEventInstanceGroupAllowed
	      - isExternalInstanceGroupAllowed
	      - renderDrag
	      - unrenderDrag
	    */
	    ExternalDropping.prototype.end = function () {
	        if (this.dragListener) {
	            this.dragListener.endInteraction();
	        }
	    };
	    ExternalDropping.prototype.bindToDocument = function () {
	        this.listenTo($(document), {
	            dragstart: this.handleDragStart,
	            sortstart: this.handleDragStart // jqui
	        });
	    };
	    ExternalDropping.prototype.unbindFromDocument = function () {
	        this.stopListeningTo($(document));
	    };
	    // Called when a jQuery UI drag is initiated anywhere in the DOM
	    ExternalDropping.prototype.handleDragStart = function (ev, ui) {
	        var el;
	        var accept;
	        if (this.opt('droppable')) {
	            el = $((ui ? ui.item : null) || ev.target);
	            // Test that the dragged element passes the dropAccept selector or filter function.
	            // FYI, the default is "*" (matches all)
	            accept = this.opt('dropAccept');
	            if ($.isFunction(accept) ? accept.call(el[0], el) : el.is(accept)) {
	                if (!this.isDragging) {
	                    this.listenToExternalDrag(el, ev, ui);
	                }
	            }
	        }
	    };
	    // Called when a jQuery UI drag starts and it needs to be monitored for dropping
	    ExternalDropping.prototype.listenToExternalDrag = function (el, ev, ui) {
	        var _this = this;
	        var component = this.component;
	        var view = this.view;
	        var meta = getDraggedElMeta(el); // extra data about event drop, including possible event to create
	        var singleEventDef; // a null value signals an unsuccessful drag
	        // listener that tracks mouse movement over date-associated pixel regions
	        var dragListener = this.dragListener = new HitDragListener_1.default(component, {
	            interactionStart: function () {
	                _this.isDragging = true;
	            },
	            hitOver: function (hit) {
	                var isAllowed = true;
	                var hitFootprint = hit.component.getSafeHitFootprint(hit); // hit might not belong to this grid
	                var mutatedEventInstanceGroup;
	                if (hitFootprint) {
	                    singleEventDef = _this.computeExternalDrop(hitFootprint, meta);
	                    if (singleEventDef) {
	                        mutatedEventInstanceGroup = new EventInstanceGroup_1.default(singleEventDef.buildInstances());
	                        isAllowed = meta.eventProps ? // isEvent?
	                            component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup) :
	                            component.isExternalInstanceGroupAllowed(mutatedEventInstanceGroup);
	                    }
	                    else {
	                        isAllowed = false;
	                    }
	                }
	                else {
	                    isAllowed = false;
	                }
	                if (!isAllowed) {
	                    singleEventDef = null;
	                    util_1.disableCursor();
	                }
	                if (singleEventDef) {
	                    component.renderDrag(// called without a seg parameter
	                    component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, view.calendar)));
	                }
	            },
	            hitOut: function () {
	                singleEventDef = null; // signal unsuccessful
	            },
	            hitDone: function () {
	                util_1.enableCursor();
	                component.unrenderDrag();
	            },
	            interactionEnd: function (ev) {
	                if (singleEventDef) {
	                    view.reportExternalDrop(singleEventDef, Boolean(meta.eventProps), // isEvent
	                    Boolean(meta.stick), // isSticky
	                    el, ev, ui);
	                }
	                _this.isDragging = false;
	                _this.dragListener = null;
	            }
	        });
	        dragListener.startDrag(ev); // start listening immediately
	    };
	    // Given a hit to be dropped upon, and misc data associated with the jqui drag (guaranteed to be a plain object),
	    // returns the zoned start/end dates for the event that would result from the hypothetical drop. end might be null.
	    // Returning a null value signals an invalid drop hit.
	    // DOES NOT consider overlap/constraint.
	    // Assumes both footprints are non-open-ended.
	    ExternalDropping.prototype.computeExternalDrop = function (componentFootprint, meta) {
	        var calendar = this.view.calendar;
	        var start = moment_ext_1.default.utc(componentFootprint.unzonedRange.startMs).stripZone();
	        var end;
	        var eventDef;
	        if (componentFootprint.isAllDay) {
	            // if dropped on an all-day span, and element's metadata specified a time, set it
	            if (meta.startTime) {
	                start.time(meta.startTime);
	            }
	            else {
	                start.stripTime();
	            }
	        }
	        if (meta.duration) {
	            end = start.clone().add(meta.duration);
	        }
	        start = calendar.applyTimezone(start);
	        if (end) {
	            end = calendar.applyTimezone(end);
	        }
	        eventDef = SingleEventDef_1.default.parse($.extend({}, meta.eventProps, {
	            start: start,
	            end: end
	        }), new EventSource_1.default(calendar));
	        return eventDef;
	    };
	    return ExternalDropping;
	}(Interaction_1.default));
	exports.default = ExternalDropping;
	ListenerMixin_1.default.mixInto(ExternalDropping);
	/* External-Dragging-Element Data
	----------------------------------------------------------------------------------------------------------------------*/
	// Require all HTML5 data-* attributes used by FullCalendar to have this prefix.
	// A value of '' will query attributes like data-event. A value of 'fc' will query attributes like data-fc-event.
	exportHooks.dataAttrPrefix = '';
	// Given a jQuery element that might represent a dragged FullCalendar event, returns an intermediate data structure
	// to be used for Event Object creation.
	// A defined `.eventProps`, even when empty, indicates that an event should be created.
	function getDraggedElMeta(el) {
	    var prefix = exportHooks.dataAttrPrefix;
	    var eventProps; // properties for creating the event, not related to date/time
	    var startTime; // a Duration
	    var duration;
	    var stick;
	    if (prefix) {
	        prefix += '-';
	    }
	    eventProps = el.data(prefix + 'event') || null;
	    if (eventProps) {
	        if (typeof eventProps === 'object') {
	            eventProps = $.extend({}, eventProps); // make a copy
	        }
	        else {
	            eventProps = {};
	        }
	        // pluck special-cased date/time properties
	        startTime = eventProps.start;
	        if (startTime == null) {
	            startTime = eventProps.time;
	        } // accept 'time' as well
	        duration = eventProps.duration;
	        stick = eventProps.stick;
	        delete eventProps.start;
	        delete eventProps.time;
	        delete eventProps.duration;
	        delete eventProps.stick;
	    }
	    // fallback to standalone attribute values for each of the date/time properties
	    if (startTime == null) {
	        startTime = el.data(prefix + 'start');
	    }
	    if (startTime == null) {
	        startTime = el.data(prefix + 'time');
	    } // accept 'time' as well
	    if (duration == null) {
	        duration = el.data(prefix + 'duration');
	    }
	    if (stick == null) {
	        stick = el.data(prefix + 'stick');
	    }
	    // massage into correct data types
	    startTime = startTime != null ? moment.duration(startTime) : null;
	    duration = duration != null ? moment.duration(duration) : null;
	    stick = Boolean(stick);
	    return { eventProps: eventProps, startTime: startTime, duration: duration, stick: stick };
	}
	
	
	/***/ }),
	/* 223 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var EventDefMutation_1 = __webpack_require__(36);
	var EventDefDateMutation_1 = __webpack_require__(50);
	var HitDragListener_1 = __webpack_require__(22);
	var Interaction_1 = __webpack_require__(15);
	var EventResizing = /** @class */ (function (_super) {
	    tslib_1.__extends(EventResizing, _super);
	    /*
	    component impements:
	      - bindSegHandlerToEl
	      - publiclyTrigger
	      - diffDates
	      - eventRangesToEventFootprints
	      - isEventInstanceGroupAllowed
	      - getSafeHitFootprint
	    */
	    function EventResizing(component, eventPointing) {
	        var _this = _super.call(this, component) || this;
	        _this.isResizing = false;
	        _this.eventPointing = eventPointing;
	        return _this;
	    }
	    EventResizing.prototype.end = function () {
	        if (this.dragListener) {
	            this.dragListener.endInteraction();
	        }
	    };
	    EventResizing.prototype.bindToEl = function (el) {
	        var component = this.component;
	        component.bindSegHandlerToEl(el, 'mousedown', this.handleMouseDown.bind(this));
	        component.bindSegHandlerToEl(el, 'touchstart', this.handleTouchStart.bind(this));
	    };
	    EventResizing.prototype.handleMouseDown = function (seg, ev) {
	        if (this.component.canStartResize(seg, ev)) {
	            this.buildDragListener(seg, $(ev.target).is('.fc-start-resizer'))
	                .startInteraction(ev, { distance: 5 });
	        }
	    };
	    EventResizing.prototype.handleTouchStart = function (seg, ev) {
	        if (this.component.canStartResize(seg, ev)) {
	            this.buildDragListener(seg, $(ev.target).is('.fc-start-resizer'))
	                .startInteraction(ev);
	        }
	    };
	    // Creates a listener that tracks the user as they resize an event segment.
	    // Generic enough to work with any type of Grid.
	    EventResizing.prototype.buildDragListener = function (seg, isStart) {
	        var _this = this;
	        var component = this.component;
	        var view = this.view;
	        var calendar = view.calendar;
	        var eventManager = calendar.eventManager;
	        var el = seg.el;
	        var eventDef = seg.footprint.eventDef;
	        var eventInstance = seg.footprint.eventInstance;
	        var isDragging;
	        var resizeMutation; // zoned event date properties. falsy if invalid resize
	        // Tracks mouse movement over the *grid's* coordinate map
	        var dragListener = this.dragListener = new HitDragListener_1.default(component, {
	            scroll: this.opt('dragScroll'),
	            subjectEl: el,
	            interactionStart: function () {
	                isDragging = false;
	            },
	            dragStart: function (ev) {
	                isDragging = true;
	                // ensure a mouseout on the manipulated event has been reported
	                _this.eventPointing.handleMouseout(seg, ev);
	                _this.segResizeStart(seg, ev);
	            },
	            hitOver: function (hit, isOrig, origHit) {
	                var isAllowed = true;
	                var origHitFootprint = component.getSafeHitFootprint(origHit);
	                var hitFootprint = component.getSafeHitFootprint(hit);
	                var mutatedEventInstanceGroup;
	                if (origHitFootprint && hitFootprint) {
	                    resizeMutation = isStart ?
	                        _this.computeEventStartResizeMutation(origHitFootprint, hitFootprint, seg.footprint) :
	                        _this.computeEventEndResizeMutation(origHitFootprint, hitFootprint, seg.footprint);
	                    if (resizeMutation) {
	                        mutatedEventInstanceGroup = eventManager.buildMutatedEventInstanceGroup(eventDef.id, resizeMutation);
	                        isAllowed = component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup);
	                    }
	                    else {
	                        isAllowed = false;
	                    }
	                }
	                else {
	                    isAllowed = false;
	                }
	                if (!isAllowed) {
	                    resizeMutation = null;
	                    util_1.disableCursor();
	                }
	                else if (resizeMutation.isEmpty()) {
	                    // no change. (FYI, event dates might have zones)
	                    resizeMutation = null;
	                }
	                if (resizeMutation) {
	                    view.hideEventsWithId(seg.footprint.eventDef.id);
	                    view.renderEventResize(component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, calendar)), seg);
	                }
	            },
	            hitOut: function () {
	                resizeMutation = null;
	            },
	            hitDone: function () {
	                view.unrenderEventResize(seg);
	                view.showEventsWithId(seg.footprint.eventDef.id);
	                util_1.enableCursor();
	            },
	            interactionEnd: function (ev) {
	                if (isDragging) {
	                    _this.segResizeStop(seg, ev);
	                }
	                if (resizeMutation) {
	                    // no need to re-show original, will rerender all anyways. esp important if eventRenderWait
	                    view.reportEventResize(eventInstance, resizeMutation, el, ev);
	                }
	                _this.dragListener = null;
	            }
	        });
	        return dragListener;
	    };
	    // Called before event segment resizing starts
	    EventResizing.prototype.segResizeStart = function (seg, ev) {
	        this.isResizing = true;
	        this.component.publiclyTrigger('eventResizeStart', {
	            context: seg.el[0],
	            args: [
	                seg.footprint.getEventLegacy(),
	                ev,
	                {},
	                this.view
	            ]
	        });
	    };
	    // Called after event segment resizing stops
	    EventResizing.prototype.segResizeStop = function (seg, ev) {
	        this.isResizing = false;
	        this.component.publiclyTrigger('eventResizeStop', {
	            context: seg.el[0],
	            args: [
	                seg.footprint.getEventLegacy(),
	                ev,
	                {},
	                this.view
	            ]
	        });
	    };
	    // Returns new date-information for an event segment being resized from its start
	    EventResizing.prototype.computeEventStartResizeMutation = function (startFootprint, endFootprint, origEventFootprint) {
	        var origRange = origEventFootprint.componentFootprint.unzonedRange;
	        var startDelta = this.component.diffDates(endFootprint.unzonedRange.getStart(), startFootprint.unzonedRange.getStart());
	        var dateMutation;
	        var eventDefMutation;
	        if (origRange.getStart().add(startDelta) < origRange.getEnd()) {
	            dateMutation = new EventDefDateMutation_1.default();
	            dateMutation.setStartDelta(startDelta);
	            eventDefMutation = new EventDefMutation_1.default();
	            eventDefMutation.setDateMutation(dateMutation);
	            return eventDefMutation;
	        }
	        return false;
	    };
	    // Returns new date-information for an event segment being resized from its end
	    EventResizing.prototype.computeEventEndResizeMutation = function (startFootprint, endFootprint, origEventFootprint) {
	        var origRange = origEventFootprint.componentFootprint.unzonedRange;
	        var endDelta = this.component.diffDates(endFootprint.unzonedRange.getEnd(), startFootprint.unzonedRange.getEnd());
	        var dateMutation;
	        var eventDefMutation;
	        if (origRange.getEnd().add(endDelta) > origRange.getStart()) {
	            dateMutation = new EventDefDateMutation_1.default();
	            dateMutation.setEndDelta(endDelta);
	            eventDefMutation = new EventDefMutation_1.default();
	            eventDefMutation.setDateMutation(dateMutation);
	            return eventDefMutation;
	        }
	        return false;
	    };
	    return EventResizing;
	}(Interaction_1.default));
	exports.default = EventResizing;
	
	
	/***/ }),
	/* 224 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var util_1 = __webpack_require__(4);
	var EventDefMutation_1 = __webpack_require__(36);
	var EventDefDateMutation_1 = __webpack_require__(50);
	var DragListener_1 = __webpack_require__(54);
	var HitDragListener_1 = __webpack_require__(22);
	var MouseFollower_1 = __webpack_require__(244);
	var Interaction_1 = __webpack_require__(15);
	var EventDragging = /** @class */ (function (_super) {
	    tslib_1.__extends(EventDragging, _super);
	    /*
	    component implements:
	      - bindSegHandlerToEl
	      - publiclyTrigger
	      - diffDates
	      - eventRangesToEventFootprints
	      - isEventInstanceGroupAllowed
	    */
	    function EventDragging(component, eventPointing) {
	        var _this = _super.call(this, component) || this;
	        _this.isDragging = false;
	        _this.eventPointing = eventPointing;
	        return _this;
	    }
	    EventDragging.prototype.end = function () {
	        if (this.dragListener) {
	            this.dragListener.endInteraction();
	        }
	    };
	    EventDragging.prototype.getSelectionDelay = function () {
	        var delay = this.opt('eventLongPressDelay');
	        if (delay == null) {
	            delay = this.opt('longPressDelay'); // fallback
	        }
	        return delay;
	    };
	    EventDragging.prototype.bindToEl = function (el) {
	        var component = this.component;
	        component.bindSegHandlerToEl(el, 'mousedown', this.handleMousedown.bind(this));
	        component.bindSegHandlerToEl(el, 'touchstart', this.handleTouchStart.bind(this));
	    };
	    EventDragging.prototype.handleMousedown = function (seg, ev) {
	        if (!this.component.shouldIgnoreMouse() &&
	            this.component.canStartDrag(seg, ev)) {
	            this.buildDragListener(seg).startInteraction(ev, { distance: 5 });
	        }
	    };
	    EventDragging.prototype.handleTouchStart = function (seg, ev) {
	        var component = this.component;
	        var settings = {
	            delay: this.view.isEventDefSelected(seg.footprint.eventDef) ? // already selected?
	                0 : this.getSelectionDelay()
	        };
	        if (component.canStartDrag(seg, ev)) {
	            this.buildDragListener(seg).startInteraction(ev, settings);
	        }
	        else if (component.canStartSelection(seg, ev)) {
	            this.buildSelectListener(seg).startInteraction(ev, settings);
	        }
	    };
	    // seg isn't draggable, but let's use a generic DragListener
	    // simply for the delay, so it can be selected.
	    // Has side effect of setting/unsetting `dragListener`
	    EventDragging.prototype.buildSelectListener = function (seg) {
	        var _this = this;
	        var view = this.view;
	        var eventDef = seg.footprint.eventDef;
	        var eventInstance = seg.footprint.eventInstance; // null for inverse-background events
	        if (this.dragListener) {
	            return this.dragListener;
	        }
	        var dragListener = this.dragListener = new DragListener_1.default({
	            dragStart: function (ev) {
	                if (dragListener.isTouch &&
	                    !view.isEventDefSelected(eventDef) &&
	                    eventInstance) {
	                    // if not previously selected, will fire after a delay. then, select the event
	                    view.selectEventInstance(eventInstance);
	                }
	            },
	            interactionEnd: function (ev) {
	                _this.dragListener = null;
	            }
	        });
	        return dragListener;
	    };
	    // Builds a listener that will track user-dragging on an event segment.
	    // Generic enough to work with any type of Grid.
	    // Has side effect of setting/unsetting `dragListener`
	    EventDragging.prototype.buildDragListener = function (seg) {
	        var _this = this;
	        var component = this.component;
	        var view = this.view;
	        var calendar = view.calendar;
	        var eventManager = calendar.eventManager;
	        var el = seg.el;
	        var eventDef = seg.footprint.eventDef;
	        var eventInstance = seg.footprint.eventInstance; // null for inverse-background events
	        var isDragging;
	        var mouseFollower; // A clone of the original element that will move with the mouse
	        var eventDefMutation;
	        if (this.dragListener) {
	            return this.dragListener;
	        }
	        // Tracks mouse movement over the *view's* coordinate map. Allows dragging and dropping between subcomponents
	        // of the view.
	        var dragListener = this.dragListener = new HitDragListener_1.default(view, {
	            scroll: this.opt('dragScroll'),
	            subjectEl: el,
	            subjectCenter: true,
	            interactionStart: function (ev) {
	                seg.component = component; // for renderDrag
	                isDragging = false;
	                mouseFollower = new MouseFollower_1.default(seg.el, {
	                    additionalClass: 'fc-dragging',
	                    parentEl: view.el,
	                    opacity: dragListener.isTouch ? null : _this.opt('dragOpacity'),
	                    revertDuration: _this.opt('dragRevertDuration'),
	                    zIndex: 2 // one above the .fc-view
	                });
	                mouseFollower.hide(); // don't show until we know this is a real drag
	                mouseFollower.start(ev);
	            },
	            dragStart: function (ev) {
	                if (dragListener.isTouch &&
	                    !view.isEventDefSelected(eventDef) &&
	                    eventInstance) {
	                    // if not previously selected, will fire after a delay. then, select the event
	                    view.selectEventInstance(eventInstance);
	                }
	                isDragging = true;
	                // ensure a mouseout on the manipulated event has been reported
	                _this.eventPointing.handleMouseout(seg, ev);
	                _this.segDragStart(seg, ev);
	                view.hideEventsWithId(seg.footprint.eventDef.id);
	            },
	            hitOver: function (hit, isOrig, origHit) {
	                var isAllowed = true;
	                var origFootprint;
	                var footprint;
	                var mutatedEventInstanceGroup;
	                // starting hit could be forced (DayGrid.limit)
	                if (seg.hit) {
	                    origHit = seg.hit;
	                }
	                // hit might not belong to this grid, so query origin grid
	                origFootprint = origHit.component.getSafeHitFootprint(origHit);
	                footprint = hit.component.getSafeHitFootprint(hit);
	                if (origFootprint && footprint) {
	                    eventDefMutation = _this.computeEventDropMutation(origFootprint, footprint, eventDef);
	                    if (eventDefMutation) {
	                        mutatedEventInstanceGroup = eventManager.buildMutatedEventInstanceGroup(eventDef.id, eventDefMutation);
	                        isAllowed = component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup);
	                    }
	                    else {
	                        isAllowed = false;
	                    }
	                }
	                else {
	                    isAllowed = false;
	                }
	                if (!isAllowed) {
	                    eventDefMutation = null;
	                    util_1.disableCursor();
	                }
	                // if a valid drop location, have the subclass render a visual indication
	                if (eventDefMutation &&
	                    view.renderDrag(// truthy if rendered something
	                    component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, calendar)), seg, dragListener.isTouch)) {
	                    mouseFollower.hide(); // if the subclass is already using a mock event "helper", hide our own
	                }
	                else {
	                    mouseFollower.show(); // otherwise, have the helper follow the mouse (no snapping)
	                }
	                if (isOrig) {
	                    // needs to have moved hits to be a valid drop
	                    eventDefMutation = null;
	                }
	            },
	            hitOut: function () {
	                view.unrenderDrag(seg); // unrender whatever was done in renderDrag
	                mouseFollower.show(); // show in case we are moving out of all hits
	                eventDefMutation = null;
	            },
	            hitDone: function () {
	                util_1.enableCursor();
	            },
	            interactionEnd: function (ev) {
	                delete seg.component; // prevent side effects
	                // do revert animation if hasn't changed. calls a callback when finished (whether animation or not)
	                mouseFollower.stop(!eventDefMutation, function () {
	                    if (isDragging) {
	                        view.unrenderDrag(seg);
	                        _this.segDragStop(seg, ev);
	                    }
	                    view.showEventsWithId(seg.footprint.eventDef.id);
	                    if (eventDefMutation) {
	                        // no need to re-show original, will rerender all anyways. esp important if eventRenderWait
	                        view.reportEventDrop(eventInstance, eventDefMutation, el, ev);
	                    }
	                });
	                _this.dragListener = null;
	            }
	        });
	        return dragListener;
	    };
	    // Called before event segment dragging starts
	    EventDragging.prototype.segDragStart = function (seg, ev) {
	        this.isDragging = true;
	        this.component.publiclyTrigger('eventDragStart', {
	            context: seg.el[0],
	            args: [
	                seg.footprint.getEventLegacy(),
	                ev,
	                {},
	                this.view
	            ]
	        });
	    };
	    // Called after event segment dragging stops
	    EventDragging.prototype.segDragStop = function (seg, ev) {
	        this.isDragging = false;
	        this.component.publiclyTrigger('eventDragStop', {
	            context: seg.el[0],
	            args: [
	                seg.footprint.getEventLegacy(),
	                ev,
	                {},
	                this.view
	            ]
	        });
	    };
	    // DOES NOT consider overlap/constraint
	    EventDragging.prototype.computeEventDropMutation = function (startFootprint, endFootprint, eventDef) {
	        var eventDefMutation = new EventDefMutation_1.default();
	        eventDefMutation.setDateMutation(this.computeEventDateMutation(startFootprint, endFootprint));
	        return eventDefMutation;
	    };
	    EventDragging.prototype.computeEventDateMutation = function (startFootprint, endFootprint) {
	        var date0 = startFootprint.unzonedRange.getStart();
	        var date1 = endFootprint.unzonedRange.getStart();
	        var clearEnd = false;
	        var forceTimed = false;
	        var forceAllDay = false;
	        var dateDelta;
	        var dateMutation;
	        if (startFootprint.isAllDay !== endFootprint.isAllDay) {
	            clearEnd = true;
	            if (endFootprint.isAllDay) {
	                forceAllDay = true;
	                date0.stripTime();
	            }
	            else {
	                forceTimed = true;
	            }
	        }
	        dateDelta = this.component.diffDates(date1, date0);
	        dateMutation = new EventDefDateMutation_1.default();
	        dateMutation.clearEnd = clearEnd;
	        dateMutation.forceTimed = forceTimed;
	        dateMutation.forceAllDay = forceAllDay;
	        dateMutation.setDateDelta(dateDelta);
	        return dateMutation;
	    };
	    return EventDragging;
	}(Interaction_1.default));
	exports.default = EventDragging;
	
	
	/***/ }),
	/* 225 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var util_1 = __webpack_require__(4);
	var HitDragListener_1 = __webpack_require__(22);
	var ComponentFootprint_1 = __webpack_require__(12);
	var UnzonedRange_1 = __webpack_require__(5);
	var Interaction_1 = __webpack_require__(15);
	var DateSelecting = /** @class */ (function (_super) {
	    tslib_1.__extends(DateSelecting, _super);
	    /*
	    component must implement:
	      - bindDateHandlerToEl
	      - getSafeHitFootprint
	      - renderHighlight
	      - unrenderHighlight
	    */
	    function DateSelecting(component) {
	        var _this = _super.call(this, component) || this;
	        _this.dragListener = _this.buildDragListener();
	        return _this;
	    }
	    DateSelecting.prototype.end = function () {
	        this.dragListener.endInteraction();
	    };
	    DateSelecting.prototype.getDelay = function () {
	        var delay = this.opt('selectLongPressDelay');
	        if (delay == null) {
	            delay = this.opt('longPressDelay'); // fallback
	        }
	        return delay;
	    };
	    DateSelecting.prototype.bindToEl = function (el) {
	        var _this = this;
	        var component = this.component;
	        var dragListener = this.dragListener;
	        component.bindDateHandlerToEl(el, 'mousedown', function (ev) {
	            if (_this.opt('selectable') && !component.shouldIgnoreMouse()) {
	                dragListener.startInteraction(ev, {
	                    distance: _this.opt('selectMinDistance')
	                });
	            }
	        });
	        component.bindDateHandlerToEl(el, 'touchstart', function (ev) {
	            if (_this.opt('selectable') && !component.shouldIgnoreTouch()) {
	                dragListener.startInteraction(ev, {
	                    delay: _this.getDelay()
	                });
	            }
	        });
	        util_1.preventSelection(el);
	    };
	    // Creates a listener that tracks the user's drag across day elements, for day selecting.
	    DateSelecting.prototype.buildDragListener = function () {
	        var _this = this;
	        var component = this.component;
	        var selectionFootprint; // null if invalid selection
	        var dragListener = new HitDragListener_1.default(component, {
	            scroll: this.opt('dragScroll'),
	            interactionStart: function () {
	                selectionFootprint = null;
	            },
	            dragStart: function (ev) {
	                _this.view.unselect(ev); // since we could be rendering a new selection, we want to clear any old one
	            },
	            hitOver: function (hit, isOrig, origHit) {
	                var origHitFootprint;
	                var hitFootprint;
	                if (origHit) {
	                    origHitFootprint = component.getSafeHitFootprint(origHit);
	                    hitFootprint = component.getSafeHitFootprint(hit);
	                    if (origHitFootprint && hitFootprint) {
	                        selectionFootprint = _this.computeSelection(origHitFootprint, hitFootprint);
	                    }
	                    else {
	                        selectionFootprint = null;
	                    }
	                    if (selectionFootprint) {
	                        component.renderSelectionFootprint(selectionFootprint);
	                    }
	                    else if (selectionFootprint === false) {
	                        util_1.disableCursor();
	                    }
	                }
	            },
	            hitOut: function () {
	                selectionFootprint = null;
	                component.unrenderSelection();
	            },
	            hitDone: function () {
	                util_1.enableCursor();
	            },
	            interactionEnd: function (ev, isCancelled) {
	                if (!isCancelled && selectionFootprint) {
	                    // the selection will already have been rendered. just report it
	                    _this.view.reportSelection(selectionFootprint, ev);
	                }
	            }
	        });
	        return dragListener;
	    };
	    // Given the first and last date-spans of a selection, returns another date-span object.
	    // Subclasses can override and provide additional data in the span object. Will be passed to renderSelectionFootprint().
	    // Will return false if the selection is invalid and this should be indicated to the user.
	    // Will return null/undefined if a selection invalid but no error should be reported.
	    DateSelecting.prototype.computeSelection = function (footprint0, footprint1) {
	        var wholeFootprint = this.computeSelectionFootprint(footprint0, footprint1);
	        if (wholeFootprint && !this.isSelectionFootprintAllowed(wholeFootprint)) {
	            return false;
	        }
	        return wholeFootprint;
	    };
	    // Given two spans, must return the combination of the two.
	    // TODO: do this separation of concerns (combining VS validation) for event dnd/resize too.
	    // Assumes both footprints are non-open-ended.
	    DateSelecting.prototype.computeSelectionFootprint = function (footprint0, footprint1) {
	        var ms = [
	            footprint0.unzonedRange.startMs,
	            footprint0.unzonedRange.endMs,
	            footprint1.unzonedRange.startMs,
	            footprint1.unzonedRange.endMs
	        ];
	        ms.sort(util_1.compareNumbers);
	        return new ComponentFootprint_1.default(new UnzonedRange_1.default(ms[0], ms[3]), footprint0.isAllDay);
	    };
	    DateSelecting.prototype.isSelectionFootprintAllowed = function (componentFootprint) {
	        return this.component.dateProfile.validUnzonedRange.containsRange(componentFootprint.unzonedRange) &&
	            this.view.calendar.constraints.isSelectionFootprintAllowed(componentFootprint);
	    };
	    return DateSelecting;
	}(Interaction_1.default));
	exports.default = DateSelecting;
	
	
	/***/ }),
	/* 226 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var moment = __webpack_require__(0);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var Scroller_1 = __webpack_require__(39);
	var View_1 = __webpack_require__(41);
	var TimeGrid_1 = __webpack_require__(227);
	var DayGrid_1 = __webpack_require__(61);
	var AGENDA_ALL_DAY_EVENT_LIMIT = 5;
	var agendaTimeGridMethods;
	var agendaDayGridMethods;
	/* An abstract class for all agenda-related views. Displays one more columns with time slots running vertically.
	----------------------------------------------------------------------------------------------------------------------*/
	// Is a manager for the TimeGrid subcomponent and possibly the DayGrid subcomponent (if allDaySlot is on).
	// Responsible for managing width/height.
	var AgendaView = /** @class */ (function (_super) {
	    tslib_1.__extends(AgendaView, _super);
	    function AgendaView(calendar, viewSpec) {
	        var _this = _super.call(this, calendar, viewSpec) || this;
	        _this.usesMinMaxTime = true; // indicates that minTime/maxTime affects rendering
	        _this.timeGrid = _this.instantiateTimeGrid();
	        _this.addChild(_this.timeGrid);
	        if (_this.opt('allDaySlot')) {
	            _this.dayGrid = _this.instantiateDayGrid(); // the all-day subcomponent of this view
	            _this.addChild(_this.dayGrid);
	        }
	        _this.scroller = new Scroller_1.default({
	            overflowX: 'hidden',
	            overflowY: 'auto'
	        });
	        return _this;
	    }
	    // Instantiates the TimeGrid object this view needs. Draws from this.timeGridClass
	    AgendaView.prototype.instantiateTimeGrid = function () {
	        var timeGrid = new this.timeGridClass(this);
	        util_1.copyOwnProps(agendaTimeGridMethods, timeGrid);
	        return timeGrid;
	    };
	    // Instantiates the DayGrid object this view might need. Draws from this.dayGridClass
	    AgendaView.prototype.instantiateDayGrid = function () {
	        var dayGrid = new this.dayGridClass(this);
	        util_1.copyOwnProps(agendaDayGridMethods, dayGrid);
	        return dayGrid;
	    };
	    /* Rendering
	    ------------------------------------------------------------------------------------------------------------------*/
	    AgendaView.prototype.renderSkeleton = function () {
	        var timeGridWrapEl;
	        var timeGridEl;
	        this.el.addClass('fc-agenda-view').html(this.renderSkeletonHtml());
	        this.scroller.render();
	        timeGridWrapEl = this.scroller.el.addClass('fc-time-grid-container');
	        timeGridEl = $('<div class="fc-time-grid" />').appendTo(timeGridWrapEl);
	        this.el.find('.fc-body > tr > td').append(timeGridWrapEl);
	        this.timeGrid.headContainerEl = this.el.find('.fc-head-container');
	        this.timeGrid.setElement(timeGridEl);
	        if (this.dayGrid) {
	            this.dayGrid.setElement(this.el.find('.fc-day-grid'));
	            // have the day-grid extend it's coordinate area over the <hr> dividing the two grids
	            this.dayGrid.bottomCoordPadding = this.dayGrid.el.next('hr').outerHeight();
	        }
	    };
	    AgendaView.prototype.unrenderSkeleton = function () {
	        this.timeGrid.removeElement();
	        if (this.dayGrid) {
	            this.dayGrid.removeElement();
	        }
	        this.scroller.destroy();
	    };
	    // Builds the HTML skeleton for the view.
	    // The day-grid and time-grid components will render inside containers defined by this HTML.
	    AgendaView.prototype.renderSkeletonHtml = function () {
	        var theme = this.calendar.theme;
	        return '' +
	            '<table class="' + theme.getClass('tableGrid') + '">' +
	            (this.opt('columnHeader') ?
	                '<thead class="fc-head">' +
	                    '<tr>' +
	                    '<td class="fc-head-container ' + theme.getClass('widgetHeader') + '">&nbsp;</td>' +
	                    '</tr>' +
	                    '</thead>' :
	                '') +
	            '<tbody class="fc-body">' +
	            '<tr>' +
	            '<td class="' + theme.getClass('widgetContent') + '">' +
	            (this.dayGrid ?
	                '<div class="fc-day-grid"/>' +
	                    '<hr class="fc-divider ' + theme.getClass('widgetHeader') + '"/>' :
	                '') +
	            '</td>' +
	            '</tr>' +
	            '</tbody>' +
	            '</table>';
	    };
	    // Generates an HTML attribute string for setting the width of the axis, if it is known
	    AgendaView.prototype.axisStyleAttr = function () {
	        if (this.axisWidth != null) {
	            return 'style="width:' + this.axisWidth + 'px"';
	        }
	        return '';
	    };
	    /* Now Indicator
	    ------------------------------------------------------------------------------------------------------------------*/
	    AgendaView.prototype.getNowIndicatorUnit = function () {
	        return this.timeGrid.getNowIndicatorUnit();
	    };
	    /* Dimensions
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Adjusts the vertical dimensions of the view to the specified values
	    AgendaView.prototype.updateSize = function (totalHeight, isAuto, isResize) {
	        var eventLimit;
	        var scrollerHeight;
	        var scrollbarWidths;
	        _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
	        // make all axis cells line up, and record the width so newly created axis cells will have it
	        this.axisWidth = util_1.matchCellWidths(this.el.find('.fc-axis'));
	        // hack to give the view some height prior to timeGrid's columns being rendered
	        // TODO: separate setting height from scroller VS timeGrid.
	        if (!this.timeGrid.colEls) {
	            if (!isAuto) {
	                scrollerHeight = this.computeScrollerHeight(totalHeight);
	                this.scroller.setHeight(scrollerHeight);
	            }
	            return;
	        }
	        // set of fake row elements that must compensate when scroller has scrollbars
	        var noScrollRowEls = this.el.find('.fc-row:not(.fc-scroller *)');
	        // reset all dimensions back to the original state
	        this.timeGrid.bottomRuleEl.hide(); // .show() will be called later if this <hr> is necessary
	        this.scroller.clear(); // sets height to 'auto' and clears overflow
	        util_1.uncompensateScroll(noScrollRowEls);
	        // limit number of events in the all-day area
	        if (this.dayGrid) {
	            this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed
	            eventLimit = this.opt('eventLimit');
	            if (eventLimit && typeof eventLimit !== 'number') {
	                eventLimit = AGENDA_ALL_DAY_EVENT_LIMIT; // make sure "auto" goes to a real number
	            }
	            if (eventLimit) {
	                this.dayGrid.limitRows(eventLimit);
	            }
	        }
	        if (!isAuto) {
	            scrollerHeight = this.computeScrollerHeight(totalHeight);
	            this.scroller.setHeight(scrollerHeight);
	            scrollbarWidths = this.scroller.getScrollbarWidths();
	            if (scrollbarWidths.left || scrollbarWidths.right) {
	                // make the all-day and header rows lines up
	                util_1.compensateScroll(noScrollRowEls, scrollbarWidths);
	                // the scrollbar compensation might have changed text flow, which might affect height, so recalculate
	                // and reapply the desired height to the scroller.
	                scrollerHeight = this.computeScrollerHeight(totalHeight);
	                this.scroller.setHeight(scrollerHeight);
	            }
	            // guarantees the same scrollbar widths
	            this.scroller.lockOverflow(scrollbarWidths);
	            // if there's any space below the slats, show the horizontal rule.
	            // this won't cause any new overflow, because lockOverflow already called.
	            if (this.timeGrid.getTotalSlatHeight() < scrollerHeight) {
	                this.timeGrid.bottomRuleEl.show();
	            }
	        }
	    };
	    // given a desired total height of the view, returns what the height of the scroller should be
	    AgendaView.prototype.computeScrollerHeight = function (totalHeight) {
	        return totalHeight -
	            util_1.subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
	    };
	    /* Scroll
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Computes the initial pre-configured scroll state prior to allowing the user to change it
	    AgendaView.prototype.computeInitialDateScroll = function () {
	        var scrollTime = moment.duration(this.opt('scrollTime'));
	        var top = this.timeGrid.computeTimeTop(scrollTime);
	        // zoom can give weird floating-point values. rather scroll a little bit further
	        top = Math.ceil(top);
	        if (top) {
	            top++; // to overcome top border that slots beyond the first have. looks better
	        }
	        return { top: top };
	    };
	    AgendaView.prototype.queryDateScroll = function () {
	        return { top: this.scroller.getScrollTop() };
	    };
	    AgendaView.prototype.applyDateScroll = function (scroll) {
	        if (scroll.top !== undefined) {
	            this.scroller.setScrollTop(scroll.top);
	        }
	    };
	    /* Hit Areas
	    ------------------------------------------------------------------------------------------------------------------*/
	    // forward all hit-related method calls to the grids (dayGrid might not be defined)
	    AgendaView.prototype.getHitFootprint = function (hit) {
	        // TODO: hit.component is set as a hack to identify where the hit came from
	        return hit.component.getHitFootprint(hit);
	    };
	    AgendaView.prototype.getHitEl = function (hit) {
	        // TODO: hit.component is set as a hack to identify where the hit came from
	        return hit.component.getHitEl(hit);
	    };
	    /* Event Rendering
	    ------------------------------------------------------------------------------------------------------------------*/
	    AgendaView.prototype.executeEventRender = function (eventsPayload) {
	        var dayEventsPayload = {};
	        var timedEventsPayload = {};
	        var id;
	        var eventInstanceGroup;
	        // separate the events into all-day and timed
	        for (id in eventsPayload) {
	            eventInstanceGroup = eventsPayload[id];
	            if (eventInstanceGroup.getEventDef().isAllDay()) {
	                dayEventsPayload[id] = eventInstanceGroup;
	            }
	            else {
	                timedEventsPayload[id] = eventInstanceGroup;
	            }
	        }
	        this.timeGrid.executeEventRender(timedEventsPayload);
	        if (this.dayGrid) {
	            this.dayGrid.executeEventRender(dayEventsPayload);
	        }
	    };
	    /* Dragging/Resizing Routing
	    ------------------------------------------------------------------------------------------------------------------*/
	    // A returned value of `true` signals that a mock "helper" event has been rendered.
	    AgendaView.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
	        var groups = groupEventFootprintsByAllDay(eventFootprints);
	        var renderedHelper = false;
	        renderedHelper = this.timeGrid.renderDrag(groups.timed, seg, isTouch);
	        if (this.dayGrid) {
	            renderedHelper = this.dayGrid.renderDrag(groups.allDay, seg, isTouch) || renderedHelper;
	        }
	        return renderedHelper;
	    };
	    AgendaView.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
	        var groups = groupEventFootprintsByAllDay(eventFootprints);
	        this.timeGrid.renderEventResize(groups.timed, seg, isTouch);
	        if (this.dayGrid) {
	            this.dayGrid.renderEventResize(groups.allDay, seg, isTouch);
	        }
	    };
	    /* Selection
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Renders a visual indication of a selection
	    AgendaView.prototype.renderSelectionFootprint = function (componentFootprint) {
	        if (!componentFootprint.isAllDay) {
	            this.timeGrid.renderSelectionFootprint(componentFootprint);
	        }
	        else if (this.dayGrid) {
	            this.dayGrid.renderSelectionFootprint(componentFootprint);
	        }
	    };
	    return AgendaView;
	}(View_1.default));
	exports.default = AgendaView;
	AgendaView.prototype.timeGridClass = TimeGrid_1.default;
	AgendaView.prototype.dayGridClass = DayGrid_1.default;
	// Will customize the rendering behavior of the AgendaView's timeGrid
	agendaTimeGridMethods = {
	    // Generates the HTML that will go before the day-of week header cells
	    renderHeadIntroHtml: function () {
	        var view = this.view;
	        var calendar = view.calendar;
	        var weekStart = calendar.msToUtcMoment(this.dateProfile.renderUnzonedRange.startMs, true);
	        var weekText;
	        if (this.opt('weekNumbers')) {
	            weekText = weekStart.format(this.opt('smallWeekFormat'));
	            return '' +
	                '<th class="fc-axis fc-week-number ' + calendar.theme.getClass('widgetHeader') + '" ' + view.axisStyleAttr() + '>' +
	                view.buildGotoAnchorHtml(// aside from link, important for matchCellWidths
	                { date: weekStart, type: 'week', forceOff: this.colCnt > 1 }, util_1.htmlEscape(weekText) // inner HTML
	                ) +
	                '</th>';
	        }
	        else {
	            return '<th class="fc-axis ' + calendar.theme.getClass('widgetHeader') + '" ' + view.axisStyleAttr() + '></th>';
	        }
	    },
	    // Generates the HTML that goes before the bg of the TimeGrid slot area. Long vertical column.
	    renderBgIntroHtml: function () {
	        var view = this.view;
	        return '<td class="fc-axis ' + view.calendar.theme.getClass('widgetContent') + '" ' + view.axisStyleAttr() + '></td>';
	    },
	    // Generates the HTML that goes before all other types of cells.
	    // Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
	    renderIntroHtml: function () {
	        var view = this.view;
	        return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
	    }
	};
	// Will customize the rendering behavior of the AgendaView's dayGrid
	agendaDayGridMethods = {
	    // Generates the HTML that goes before the all-day cells
	    renderBgIntroHtml: function () {
	        var view = this.view;
	        return '' +
	            '<td class="fc-axis ' + view.calendar.theme.getClass('widgetContent') + '" ' + view.axisStyleAttr() + '>' +
	            '<span>' + // needed for matchCellWidths
	            view.getAllDayHtml() +
	            '</span>' +
	            '</td>';
	    },
	    // Generates the HTML that goes before all other types of cells.
	    // Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
	    renderIntroHtml: function () {
	        var view = this.view;
	        return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
	    }
	};
	function groupEventFootprintsByAllDay(eventFootprints) {
	    var allDay = [];
	    var timed = [];
	    var i;
	    for (i = 0; i < eventFootprints.length; i++) {
	        if (eventFootprints[i].componentFootprint.isAllDay) {
	            allDay.push(eventFootprints[i]);
	        }
	        else {
	            timed.push(eventFootprints[i]);
	        }
	    }
	    return { allDay: allDay, timed: timed };
	}
	
	
	/***/ }),
	/* 227 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var moment = __webpack_require__(0);
	var util_1 = __webpack_require__(4);
	var InteractiveDateComponent_1 = __webpack_require__(40);
	var BusinessHourRenderer_1 = __webpack_require__(56);
	var StandardInteractionsMixin_1 = __webpack_require__(60);
	var DayTableMixin_1 = __webpack_require__(55);
	var CoordCache_1 = __webpack_require__(53);
	var UnzonedRange_1 = __webpack_require__(5);
	var ComponentFootprint_1 = __webpack_require__(12);
	var TimeGridEventRenderer_1 = __webpack_require__(246);
	var TimeGridHelperRenderer_1 = __webpack_require__(247);
	var TimeGridFillRenderer_1 = __webpack_require__(248);
	/* A component that renders one or more columns of vertical time slots
	----------------------------------------------------------------------------------------------------------------------*/
	// We mixin DayTable, even though there is only a single row of days
	// potential nice values for the slot-duration and interval-duration
	// from largest to smallest
	var AGENDA_STOCK_SUB_DURATIONS = [
	    { hours: 1 },
	    { minutes: 30 },
	    { minutes: 15 },
	    { seconds: 30 },
	    { seconds: 15 }
	];
	var TimeGrid = /** @class */ (function (_super) {
	    tslib_1.__extends(TimeGrid, _super);
	    function TimeGrid(view) {
	        var _this = _super.call(this, view) || this;
	        _this.processOptions();
	        return _this;
	    }
	    // Slices up the given span (unzoned start/end with other misc data) into an array of segments
	    TimeGrid.prototype.componentFootprintToSegs = function (componentFootprint) {
	        var segs = this.sliceRangeByTimes(componentFootprint.unzonedRange);
	        var i;
	        for (i = 0; i < segs.length; i++) {
	            if (this.isRTL) {
	                segs[i].col = this.daysPerRow - 1 - segs[i].dayIndex;
	            }
	            else {
	                segs[i].col = segs[i].dayIndex;
	            }
	        }
	        return segs;
	    };
	    /* Date Handling
	    ------------------------------------------------------------------------------------------------------------------*/
	    TimeGrid.prototype.sliceRangeByTimes = function (unzonedRange) {
	        var segs = [];
	        var segRange;
	        var dayIndex;
	        for (dayIndex = 0; dayIndex < this.daysPerRow; dayIndex++) {
	            segRange = unzonedRange.intersect(this.dayRanges[dayIndex]);
	            if (segRange) {
	                segs.push({
	                    startMs: segRange.startMs,
	                    endMs: segRange.endMs,
	                    isStart: segRange.isStart,
	                    isEnd: segRange.isEnd,
	                    dayIndex: dayIndex
	                });
	            }
	        }
	        return segs;
	    };
	    /* Options
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Parses various options into properties of this object
	    TimeGrid.prototype.processOptions = function () {
	        var slotDuration = this.opt('slotDuration');
	        var snapDuration = this.opt('snapDuration');
	        var input;
	        slotDuration = moment.duration(slotDuration);
	        snapDuration = snapDuration ? moment.duration(snapDuration) : slotDuration;
	        this.slotDuration = slotDuration;
	        this.snapDuration = snapDuration;
	        this.snapsPerSlot = slotDuration / snapDuration; // TODO: ensure an integer multiple?
	        // might be an array value (for TimelineView).
	        // if so, getting the most granular entry (the last one probably).
	        input = this.opt('slotLabelFormat');
	        if ($.isArray(input)) {
	            input = input[input.length - 1];
	        }
	        this.labelFormat = input ||
	            this.opt('smallTimeFormat'); // the computed default
	        input = this.opt('slotLabelInterval');
	        this.labelInterval = input ?
	            moment.duration(input) :
	            this.computeLabelInterval(slotDuration);
	    };
	    // Computes an automatic value for slotLabelInterval
	    TimeGrid.prototype.computeLabelInterval = function (slotDuration) {
	        var i;
	        var labelInterval;
	        var slotsPerLabel;
	        // find the smallest stock label interval that results in more than one slots-per-label
	        for (i = AGENDA_STOCK_SUB_DURATIONS.length - 1; i >= 0; i--) {
	            labelInterval = moment.duration(AGENDA_STOCK_SUB_DURATIONS[i]);
	            slotsPerLabel = util_1.divideDurationByDuration(labelInterval, slotDuration);
	            if (util_1.isInt(slotsPerLabel) && slotsPerLabel > 1) {
	                return labelInterval;
	            }
	        }
	        return moment.duration(slotDuration); // fall back. clone
	    };
	    /* Date Rendering
	    ------------------------------------------------------------------------------------------------------------------*/
	    TimeGrid.prototype.renderDates = function (dateProfile) {
	        this.dateProfile = dateProfile;
	        this.updateDayTable();
	        this.renderSlats();
	        this.renderColumns();
	    };
	    TimeGrid.prototype.unrenderDates = function () {
	        // this.unrenderSlats(); // don't need this because repeated .html() calls clear
	        this.unrenderColumns();
	    };
	    TimeGrid.prototype.renderSkeleton = function () {
	        var theme = this.view.calendar.theme;
	        this.el.html('<div class="fc-bg"></div>' +
	            '<div class="fc-slats"></div>' +
	            '<hr class="fc-divider ' + theme.getClass('widgetHeader') + '" style="display:none" />');
	        this.bottomRuleEl = this.el.find('hr');
	    };
	    TimeGrid.prototype.renderSlats = function () {
	        var theme = this.view.calendar.theme;
	        this.slatContainerEl = this.el.find('> .fc-slats')
	            .html(// avoids needing ::unrenderSlats()
	        '<table class="' + theme.getClass('tableGrid') + '">' +
	            this.renderSlatRowHtml() +
	            '</table>');
	        this.slatEls = this.slatContainerEl.find('tr');
	        this.slatCoordCache = new CoordCache_1.default({
	            els: this.slatEls,
	            isVertical: true
	        });
	    };
	    // Generates the HTML for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
	    TimeGrid.prototype.renderSlatRowHtml = function () {
	        var view = this.view;
	        var calendar = view.calendar;
	        var theme = calendar.theme;
	        var isRTL = this.isRTL;
	        var dateProfile = this.dateProfile;
	        var html = '';
	        var slotTime = moment.duration(+dateProfile.minTime); // wish there was .clone() for durations
	        var slotIterator = moment.duration(0);
	        var slotDate; // will be on the view's first day, but we only care about its time
	        var isLabeled;
	        var axisHtml;
	        // Calculate the time for each slot
	        while (slotTime < dateProfile.maxTime) {
	            slotDate = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.startMs).time(slotTime);
	            isLabeled = util_1.isInt(util_1.divideDurationByDuration(slotIterator, this.labelInterval));
	            axisHtml =
	                '<td class="fc-axis fc-time ' + theme.getClass('widgetContent') + '" ' + view.axisStyleAttr() + '>' +
	                    (isLabeled ?
	                        '<span>' + // for matchCellWidths
	                            util_1.htmlEscape(slotDate.format(this.labelFormat)) +
	                            '</span>' :
	                        '') +
	                    '</td>';
	            html +=
	                '<tr data-time="' + slotDate.format('HH:mm:ss') + '"' +
	                    (isLabeled ? '' : ' class="fc-minor"') +
	                    '>' +
	                    (!isRTL ? axisHtml : '') +
	                    '<td class="' + theme.getClass('widgetContent') + '"/>' +
	                    (isRTL ? axisHtml : '') +
	                    '</tr>';
	            slotTime.add(this.slotDuration);
	            slotIterator.add(this.slotDuration);
	        }
	        return html;
	    };
	    TimeGrid.prototype.renderColumns = function () {
	        var dateProfile = this.dateProfile;
	        var theme = this.view.calendar.theme;
	        this.dayRanges = this.dayDates.map(function (dayDate) {
	            return new UnzonedRange_1.default(dayDate.clone().add(dateProfile.minTime), dayDate.clone().add(dateProfile.maxTime));
	        });
	        if (this.headContainerEl) {
	            this.headContainerEl.html(this.renderHeadHtml());
	        }
	        this.el.find('> .fc-bg').html('<table class="' + theme.getClass('tableGrid') + '">' +
	            this.renderBgTrHtml(0) + // row=0
	            '</table>');
	        this.colEls = this.el.find('.fc-day, .fc-disabled-day');
	        this.colCoordCache = new CoordCache_1.default({
	            els: this.colEls,
	            isHorizontal: true
	        });
	        this.renderContentSkeleton();
	    };
	    TimeGrid.prototype.unrenderColumns = function () {
	        this.unrenderContentSkeleton();
	    };
	    /* Content Skeleton
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Renders the DOM that the view's content will live in
	    TimeGrid.prototype.renderContentSkeleton = function () {
	        var cellHtml = '';
	        var i;
	        var skeletonEl;
	        for (i = 0; i < this.colCnt; i++) {
	            cellHtml +=
	                '<td>' +
	                    '<div class="fc-content-col">' +
	                    '<div class="fc-event-container fc-helper-container"></div>' +
	                    '<div class="fc-event-container"></div>' +
	                    '<div class="fc-highlight-container"></div>' +
	                    '<div class="fc-bgevent-container"></div>' +
	                    '<div class="fc-business-container"></div>' +
	                    '</div>' +
	                    '</td>';
	        }
	        skeletonEl = this.contentSkeletonEl = $('<div class="fc-content-skeleton">' +
	            '<table>' +
	            '<tr>' + cellHtml + '</tr>' +
	            '</table>' +
	            '</div>');
	        this.colContainerEls = skeletonEl.find('.fc-content-col');
	        this.helperContainerEls = skeletonEl.find('.fc-helper-container');
	        this.fgContainerEls = skeletonEl.find('.fc-event-container:not(.fc-helper-container)');
	        this.bgContainerEls = skeletonEl.find('.fc-bgevent-container');
	        this.highlightContainerEls = skeletonEl.find('.fc-highlight-container');
	        this.businessContainerEls = skeletonEl.find('.fc-business-container');
	        this.bookendCells(skeletonEl.find('tr')); // TODO: do this on string level
	        this.el.append(skeletonEl);
	    };
	    TimeGrid.prototype.unrenderContentSkeleton = function () {
	        if (this.contentSkeletonEl) {
	            this.contentSkeletonEl.remove();
	            this.contentSkeletonEl = null;
	            this.colContainerEls = null;
	            this.helperContainerEls = null;
	            this.fgContainerEls = null;
	            this.bgContainerEls = null;
	            this.highlightContainerEls = null;
	            this.businessContainerEls = null;
	        }
	    };
	    // Given a flat array of segments, return an array of sub-arrays, grouped by each segment's col
	    TimeGrid.prototype.groupSegsByCol = function (segs) {
	        var segsByCol = [];
	        var i;
	        for (i = 0; i < this.colCnt; i++) {
	            segsByCol.push([]);
	        }
	        for (i = 0; i < segs.length; i++) {
	            segsByCol[segs[i].col].push(segs[i]);
	        }
	        return segsByCol;
	    };
	    // Given segments grouped by column, insert the segments' elements into a parallel array of container
	    // elements, each living within a column.
	    TimeGrid.prototype.attachSegsByCol = function (segsByCol, containerEls) {
	        var col;
	        var segs;
	        var i;
	        for (col = 0; col < this.colCnt; col++) {
	            segs = segsByCol[col];
	            for (i = 0; i < segs.length; i++) {
	                containerEls.eq(col).append(segs[i].el);
	            }
	        }
	    };
	    /* Now Indicator
	    ------------------------------------------------------------------------------------------------------------------*/
	    TimeGrid.prototype.getNowIndicatorUnit = function () {
	        return 'minute'; // will refresh on the minute
	    };
	    TimeGrid.prototype.renderNowIndicator = function (date) {
	        // HACK: if date columns not ready for some reason (scheduler)
	        if (!this.colContainerEls) {
	            return;
	        }
	        // seg system might be overkill, but it handles scenario where line needs to be rendered
	        //  more than once because of columns with the same date (resources columns for example)
	        var segs = this.componentFootprintToSegs(new ComponentFootprint_1.default(new UnzonedRange_1.default(date, date.valueOf() + 1), // protect against null range
	        false // all-day
	        ));
	        var top = this.computeDateTop(date, date);
	        var nodes = [];
	        var i;
	        // render lines within the columns
	        for (i = 0; i < segs.length; i++) {
	            nodes.push($('<div class="fc-now-indicator fc-now-indicator-line"></div>')
	                .css('top', top)
	                .appendTo(this.colContainerEls.eq(segs[i].col))[0]);
	        }
	        // render an arrow over the axis
	        if (segs.length > 0) {
	            nodes.push($('<div class="fc-now-indicator fc-now-indicator-arrow"></div>')
	                .css('top', top)
	                .appendTo(this.el.find('.fc-content-skeleton'))[0]);
	        }
	        this.nowIndicatorEls = $(nodes);
	    };
	    TimeGrid.prototype.unrenderNowIndicator = function () {
	        if (this.nowIndicatorEls) {
	            this.nowIndicatorEls.remove();
	            this.nowIndicatorEls = null;
	        }
	    };
	    /* Coordinates
	    ------------------------------------------------------------------------------------------------------------------*/
	    TimeGrid.prototype.updateSize = function (totalHeight, isAuto, isResize) {
	        _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
	        this.slatCoordCache.build();
	        if (isResize) {
	            this.updateSegVerticals([].concat(this.eventRenderer.getSegs(), this.businessSegs || []));
	        }
	    };
	    TimeGrid.prototype.getTotalSlatHeight = function () {
	        return this.slatContainerEl.outerHeight();
	    };
	    // Computes the top coordinate, relative to the bounds of the grid, of the given date.
	    // `ms` can be a millisecond UTC time OR a UTC moment.
	    // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
	    TimeGrid.prototype.computeDateTop = function (ms, startOfDayDate) {
	        return this.computeTimeTop(moment.duration(ms - startOfDayDate.clone().stripTime()));
	    };
	    // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
	    TimeGrid.prototype.computeTimeTop = function (time) {
	        var len = this.slatEls.length;
	        var dateProfile = this.dateProfile;
	        var slatCoverage = (time - dateProfile.minTime) / this.slotDuration; // floating-point value of # of slots covered
	        var slatIndex;
	        var slatRemainder;
	        // compute a floating-point number for how many slats should be progressed through.
	        // from 0 to number of slats (inclusive)
	        // constrained because minTime/maxTime might be customized.
	        slatCoverage = Math.max(0, slatCoverage);
	        slatCoverage = Math.min(len, slatCoverage);
	        // an integer index of the furthest whole slat
	        // from 0 to number slats (*exclusive*, so len-1)
	        slatIndex = Math.floor(slatCoverage);
	        slatIndex = Math.min(slatIndex, len - 1);
	        // how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
	        // could be 1.0 if slatCoverage is covering *all* the slots
	        slatRemainder = slatCoverage - slatIndex;
	        return this.slatCoordCache.getTopPosition(slatIndex) +
	            this.slatCoordCache.getHeight(slatIndex) * slatRemainder;
	    };
	    // Refreshes the CSS top/bottom coordinates for each segment element.
	    // Works when called after initial render, after a window resize/zoom for example.
	    TimeGrid.prototype.updateSegVerticals = function (segs) {
	        this.computeSegVerticals(segs);
	        this.assignSegVerticals(segs);
	    };
	    // For each segment in an array, computes and assigns its top and bottom properties
	    TimeGrid.prototype.computeSegVerticals = function (segs) {
	        var eventMinHeight = this.opt('agendaEventMinHeight');
	        var i;
	        var seg;
	        var dayDate;
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            dayDate = this.dayDates[seg.dayIndex];
	            seg.top = this.computeDateTop(seg.startMs, dayDate);
	            seg.bottom = Math.max(seg.top + eventMinHeight, this.computeDateTop(seg.endMs, dayDate));
	        }
	    };
	    // Given segments that already have their top/bottom properties computed, applies those values to
	    // the segments' elements.
	    TimeGrid.prototype.assignSegVerticals = function (segs) {
	        var i;
	        var seg;
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            seg.el.css(this.generateSegVerticalCss(seg));
	        }
	    };
	    // Generates an object with CSS properties for the top/bottom coordinates of a segment element
	    TimeGrid.prototype.generateSegVerticalCss = function (seg) {
	        return {
	            top: seg.top,
	            bottom: -seg.bottom // flipped because needs to be space beyond bottom edge of event container
	        };
	    };
	    /* Hit System
	    ------------------------------------------------------------------------------------------------------------------*/
	    TimeGrid.prototype.prepareHits = function () {
	        this.colCoordCache.build();
	        this.slatCoordCache.build();
	    };
	    TimeGrid.prototype.releaseHits = function () {
	        this.colCoordCache.clear();
	        // NOTE: don't clear slatCoordCache because we rely on it for computeTimeTop
	    };
	    TimeGrid.prototype.queryHit = function (leftOffset, topOffset) {
	        var snapsPerSlot = this.snapsPerSlot;
	        var colCoordCache = this.colCoordCache;
	        var slatCoordCache = this.slatCoordCache;
	        if (colCoordCache.isLeftInBounds(leftOffset) && slatCoordCache.isTopInBounds(topOffset)) {
	            var colIndex = colCoordCache.getHorizontalIndex(leftOffset);
	            var slatIndex = slatCoordCache.getVerticalIndex(topOffset);
	            if (colIndex != null && slatIndex != null) {
	                var slatTop = slatCoordCache.getTopOffset(slatIndex);
	                var slatHeight = slatCoordCache.getHeight(slatIndex);
	                var partial = (topOffset - slatTop) / slatHeight; // floating point number between 0 and 1
	                var localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat
	                var snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
	                var snapTop = slatTop + (localSnapIndex / snapsPerSlot) * slatHeight;
	                var snapBottom = slatTop + ((localSnapIndex + 1) / snapsPerSlot) * slatHeight;
	                return {
	                    col: colIndex,
	                    snap: snapIndex,
	                    component: this,
	                    left: colCoordCache.getLeftOffset(colIndex),
	                    right: colCoordCache.getRightOffset(colIndex),
	                    top: snapTop,
	                    bottom: snapBottom
	                };
	            }
	        }
	    };
	    TimeGrid.prototype.getHitFootprint = function (hit) {
	        var start = this.getCellDate(0, hit.col); // row=0
	        var time = this.computeSnapTime(hit.snap); // pass in the snap-index
	        var end;
	        start.time(time);
	        end = start.clone().add(this.snapDuration);
	        return new ComponentFootprint_1.default(new UnzonedRange_1.default(start, end), false // all-day?
	        );
	    };
	    // Given a row number of the grid, representing a "snap", returns a time (Duration) from its start-of-day
	    TimeGrid.prototype.computeSnapTime = function (snapIndex) {
	        return moment.duration(this.dateProfile.minTime + this.snapDuration * snapIndex);
	    };
	    TimeGrid.prototype.getHitEl = function (hit) {
	        return this.colEls.eq(hit.col);
	    };
	    /* Event Drag Visualization
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Renders a visual indication of an event being dragged over the specified date(s).
	    // A returned value of `true` signals that a mock "helper" event has been rendered.
	    TimeGrid.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
	        var i;
	        if (seg) {
	            if (eventFootprints.length) {
	                this.helperRenderer.renderEventDraggingFootprints(eventFootprints, seg, isTouch);
	                // signal that a helper has been rendered
	                return true;
	            }
	        }
	        else {
	            for (i = 0; i < eventFootprints.length; i++) {
	                this.renderHighlight(eventFootprints[i].componentFootprint);
	            }
	        }
	    };
	    // Unrenders any visual indication of an event being dragged
	    TimeGrid.prototype.unrenderDrag = function () {
	        this.unrenderHighlight();
	        this.helperRenderer.unrender();
	    };
	    /* Event Resize Visualization
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Renders a visual indication of an event being resized
	    TimeGrid.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
	        this.helperRenderer.renderEventResizingFootprints(eventFootprints, seg, isTouch);
	    };
	    // Unrenders any visual indication of an event being resized
	    TimeGrid.prototype.unrenderEventResize = function () {
	        this.helperRenderer.unrender();
	    };
	    /* Selection
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Renders a visual indication of a selection. Overrides the default, which was to simply render a highlight.
	    TimeGrid.prototype.renderSelectionFootprint = function (componentFootprint) {
	        if (this.opt('selectHelper')) {
	            this.helperRenderer.renderComponentFootprint(componentFootprint);
	        }
	        else {
	            this.renderHighlight(componentFootprint);
	        }
	    };
	    // Unrenders any visual indication of a selection
	    TimeGrid.prototype.unrenderSelection = function () {
	        this.helperRenderer.unrender();
	        this.unrenderHighlight();
	    };
	    return TimeGrid;
	}(InteractiveDateComponent_1.default));
	exports.default = TimeGrid;
	TimeGrid.prototype.eventRendererClass = TimeGridEventRenderer_1.default;
	TimeGrid.prototype.businessHourRendererClass = BusinessHourRenderer_1.default;
	TimeGrid.prototype.helperRendererClass = TimeGridHelperRenderer_1.default;
	TimeGrid.prototype.fillRendererClass = TimeGridFillRenderer_1.default;
	StandardInteractionsMixin_1.default.mixInto(TimeGrid);
	DayTableMixin_1.default.mixInto(TimeGrid);
	
	
	/***/ }),
	/* 228 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var UnzonedRange_1 = __webpack_require__(5);
	var DateProfileGenerator_1 = __webpack_require__(221);
	var BasicViewDateProfileGenerator = /** @class */ (function (_super) {
	    tslib_1.__extends(BasicViewDateProfileGenerator, _super);
	    function BasicViewDateProfileGenerator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // Computes the date range that will be rendered.
	    BasicViewDateProfileGenerator.prototype.buildRenderRange = function (currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
	        var renderUnzonedRange = _super.prototype.buildRenderRange.call(this, currentUnzonedRange, currentRangeUnit, isRangeAllDay); // an UnzonedRange
	        var start = this.msToUtcMoment(renderUnzonedRange.startMs, isRangeAllDay);
	        var end = this.msToUtcMoment(renderUnzonedRange.endMs, isRangeAllDay);
	        // year and month views should be aligned with weeks. this is already done for week
	        if (/^(year|month)$/.test(currentRangeUnit)) {
	            start.startOf('week');
	            // make end-of-week if not already
	            if (end.weekday()) {
	                end.add(1, 'week').startOf('week'); // exclusively move backwards
	            }
	        }
	        return new UnzonedRange_1.default(start, end);
	    };
	    return BasicViewDateProfileGenerator;
	}(DateProfileGenerator_1.default));
	exports.default = BasicViewDateProfileGenerator;
	
	
	/***/ }),
	/* 229 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var moment = __webpack_require__(0);
	var util_1 = __webpack_require__(4);
	var BasicView_1 = __webpack_require__(62);
	var MonthViewDateProfileGenerator_1 = __webpack_require__(253);
	/* A month view with day cells running in rows (one-per-week) and columns
	----------------------------------------------------------------------------------------------------------------------*/
	var MonthView = /** @class */ (function (_super) {
	    tslib_1.__extends(MonthView, _super);
	    function MonthView() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // Overrides the default BasicView behavior to have special multi-week auto-height logic
	    MonthView.prototype.setGridHeight = function (height, isAuto) {
	        // if auto, make the height of each row the height that it would be if there were 6 weeks
	        if (isAuto) {
	            height *= this.dayGrid.rowCnt / 6;
	        }
	        util_1.distributeHeight(this.dayGrid.rowEls, height, !isAuto); // if auto, don't compensate for height-hogging rows
	    };
	    MonthView.prototype.isDateInOtherMonth = function (date, dateProfile) {
	        return date.month() !== moment.utc(dateProfile.currentUnzonedRange.startMs).month(); // TODO: optimize
	    };
	    return MonthView;
	}(BasicView_1.default));
	exports.default = MonthView;
	MonthView.prototype.dateProfileGeneratorClass = MonthViewDateProfileGenerator_1.default;
	
	
	/***/ }),
	/* 230 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var UnzonedRange_1 = __webpack_require__(5);
	var View_1 = __webpack_require__(41);
	var Scroller_1 = __webpack_require__(39);
	var ListEventRenderer_1 = __webpack_require__(254);
	var ListEventPointing_1 = __webpack_require__(255);
	/*
	Responsible for the scroller, and forwarding event-related actions into the "grid".
	*/
	var ListView = /** @class */ (function (_super) {
	    tslib_1.__extends(ListView, _super);
	    function ListView(calendar, viewSpec) {
	        var _this = _super.call(this, calendar, viewSpec) || this;
	        _this.segSelector = '.fc-list-item'; // which elements accept event actions
	        _this.scroller = new Scroller_1.default({
	            overflowX: 'hidden',
	            overflowY: 'auto'
	        });
	        return _this;
	    }
	    ListView.prototype.renderSkeleton = function () {
	        this.el.addClass('fc-list-view ' +
	            this.calendar.theme.getClass('listView'));
	        this.scroller.render();
	        this.scroller.el.appendTo(this.el);
	        this.contentEl = this.scroller.scrollEl; // shortcut
	    };
	    ListView.prototype.unrenderSkeleton = function () {
	        this.scroller.destroy(); // will remove the Grid too
	    };
	    ListView.prototype.updateSize = function (totalHeight, isAuto, isResize) {
	        this.scroller.setHeight(this.computeScrollerHeight(totalHeight));
	    };
	    ListView.prototype.computeScrollerHeight = function (totalHeight) {
	        return totalHeight -
	            util_1.subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
	    };
	    ListView.prototype.renderDates = function (dateProfile) {
	        var calendar = this.calendar;
	        var dayStart = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.startMs, true);
	        var viewEnd = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.endMs, true);
	        var dayDates = [];
	        var dayRanges = [];
	        while (dayStart < viewEnd) {
	            dayDates.push(dayStart.clone());
	            dayRanges.push(new UnzonedRange_1.default(dayStart, dayStart.clone().add(1, 'day')));
	            dayStart.add(1, 'day');
	        }
	        this.dayDates = dayDates;
	        this.dayRanges = dayRanges;
	        // all real rendering happens in EventRenderer
	    };
	    // slices by day
	    ListView.prototype.componentFootprintToSegs = function (footprint) {
	        var dayRanges = this.dayRanges;
	        var dayIndex;
	        var segRange;
	        var seg;
	        var segs = [];
	        for (dayIndex = 0; dayIndex < dayRanges.length; dayIndex++) {
	            segRange = footprint.unzonedRange.intersect(dayRanges[dayIndex]);
	            if (segRange) {
	                seg = {
	                    startMs: segRange.startMs,
	                    endMs: segRange.endMs,
	                    isStart: segRange.isStart,
	                    isEnd: segRange.isEnd,
	                    dayIndex: dayIndex
	                };
	                segs.push(seg);
	                // detect when footprint won't go fully into the next day,
	                // and mutate the latest seg to the be the end.
	                if (!seg.isEnd && !footprint.isAllDay &&
	                    dayIndex + 1 < dayRanges.length &&
	                    footprint.unzonedRange.endMs < dayRanges[dayIndex + 1].startMs + this.nextDayThreshold) {
	                    seg.endMs = footprint.unzonedRange.endMs;
	                    seg.isEnd = true;
	                    break;
	                }
	            }
	        }
	        return segs;
	    };
	    ListView.prototype.renderEmptyMessage = function () {
	        this.contentEl.html('<div class="fc-list-empty-wrap2">' + // TODO: try less wraps
	            '<div class="fc-list-empty-wrap1">' +
	            '<div class="fc-list-empty">' +
	            util_1.htmlEscape(this.opt('noEventsMessage')) +
	            '</div>' +
	            '</div>' +
	            '</div>');
	    };
	    // render the event segments in the view
	    ListView.prototype.renderSegList = function (allSegs) {
	        var segsByDay = this.groupSegsByDay(allSegs); // sparse array
	        var dayIndex;
	        var daySegs;
	        var i;
	        var tableEl = $('<table class="fc-list-table ' + this.calendar.theme.getClass('tableList') + '"><tbody/></table>');
	        var tbodyEl = tableEl.find('tbody');
	        for (dayIndex = 0; dayIndex < segsByDay.length; dayIndex++) {
	            daySegs = segsByDay[dayIndex];
	            if (daySegs) {
	                // append a day header
	                tbodyEl.append(this.dayHeaderHtml(this.dayDates[dayIndex]));
	                this.eventRenderer.sortEventSegs(daySegs);
	                for (i = 0; i < daySegs.length; i++) {
	                    tbodyEl.append(daySegs[i].el); // append event row
	                }
	            }
	        }
	        this.contentEl.empty().append(tableEl);
	    };
	    // Returns a sparse array of arrays, segs grouped by their dayIndex
	    ListView.prototype.groupSegsByDay = function (segs) {
	        var segsByDay = []; // sparse array
	        var i;
	        var seg;
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            (segsByDay[seg.dayIndex] || (segsByDay[seg.dayIndex] = []))
	                .push(seg);
	        }
	        return segsByDay;
	    };
	    // generates the HTML for the day headers that live amongst the event rows
	    ListView.prototype.dayHeaderHtml = function (dayDate) {
	        var mainFormat = this.opt('listDayFormat');
	        var altFormat = this.opt('listDayAltFormat');
	        return '<tr class="fc-list-heading" data-date="' + dayDate.format('YYYY-MM-DD') + '">' +
	            '<td class="' + this.calendar.theme.getClass('widgetHeader') + '" colspan="3">' +
	            (mainFormat ?
	                this.buildGotoAnchorHtml(dayDate, { 'class': 'fc-list-heading-main' }, util_1.htmlEscape(dayDate.format(mainFormat)) // inner HTML
	                ) :
	                '') +
	            (altFormat ?
	                this.buildGotoAnchorHtml(dayDate, { 'class': 'fc-list-heading-alt' }, util_1.htmlEscape(dayDate.format(altFormat)) // inner HTML
	                ) :
	                '') +
	            '</td>' +
	            '</tr>';
	    };
	    return ListView;
	}(View_1.default));
	exports.default = ListView;
	ListView.prototype.eventRendererClass = ListEventRenderer_1.default;
	ListView.prototype.eventPointingClass = ListEventPointing_1.default;
	
	
	/***/ }),
	/* 231 */,
	/* 232 */,
	/* 233 */,
	/* 234 */,
	/* 235 */,
	/* 236 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var $ = __webpack_require__(3);
	var exportHooks = __webpack_require__(16);
	var util_1 = __webpack_require__(4);
	var Calendar_1 = __webpack_require__(220);
	// for intentional side-effects
	__webpack_require__(10);
	__webpack_require__(47);
	__webpack_require__(256);
	__webpack_require__(257);
	__webpack_require__(259);
	__webpack_require__(260);
	__webpack_require__(261);
	__webpack_require__(262);
	$.fullCalendar = exportHooks;
	$.fn.fullCalendar = function (options) {
	    var args = Array.prototype.slice.call(arguments, 1); // for a possible method call
	    var res = this; // what this function will return (this jQuery object by default)
	    this.each(function (i, _element) {
	        var element = $(_element);
	        var calendar = element.data('fullCalendar'); // get the existing calendar object (if any)
	        var singleRes; // the returned value of this single method call
	        // a method call
	        if (typeof options === 'string') {
	            if (options === 'getCalendar') {
	                if (!i) {
	                    res = calendar;
	                }
	            }
	            else if (options === 'destroy') {
	                if (calendar) {
	                    calendar.destroy();
	                    element.removeData('fullCalendar');
	                }
	            }
	            else if (!calendar) {
	                util_1.warn('Attempting to call a FullCalendar method on an element with no calendar.');
	            }
	            else if ($.isFunction(calendar[options])) {
	                singleRes = calendar[options].apply(calendar, args);
	                if (!i) {
	                    res = singleRes; // record the first method call result
	                }
	                if (options === 'destroy') {
	                    element.removeData('fullCalendar');
	                }
	            }
	            else {
	                util_1.warn("'" + options + "' is an unknown FullCalendar method.");
	            }
	        }
	        else if (!calendar) {
	            calendar = new Calendar_1.default(element, options);
	            element.data('fullCalendar', calendar);
	            calendar.render();
	        }
	    });
	    return res;
	};
	module.exports = exportHooks;
	
	
	/***/ }),
	/* 237 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var Model_1 = __webpack_require__(48);
	var Component = /** @class */ (function (_super) {
	    tslib_1.__extends(Component, _super);
	    function Component() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Component.prototype.setElement = function (el) {
	        this.el = el;
	        this.bindGlobalHandlers();
	        this.renderSkeleton();
	        this.set('isInDom', true);
	    };
	    Component.prototype.removeElement = function () {
	        this.unset('isInDom');
	        this.unrenderSkeleton();
	        this.unbindGlobalHandlers();
	        this.el.remove();
	        // NOTE: don't null-out this.el in case the View was destroyed within an API callback.
	        // We don't null-out the View's other jQuery element references upon destroy,
	        //  so we shouldn't kill this.el either.
	    };
	    Component.prototype.bindGlobalHandlers = function () {
	        // subclasses can override
	    };
	    Component.prototype.unbindGlobalHandlers = function () {
	        // subclasses can override
	    };
	    /*
	    NOTE: Can't have a `render` method. Read the deprecation notice in View::executeDateRender
	    */
	    // Renders the basic structure of the view before any content is rendered
	    Component.prototype.renderSkeleton = function () {
	        // subclasses should implement
	    };
	    // Unrenders the basic structure of the view
	    Component.prototype.unrenderSkeleton = function () {
	        // subclasses should implement
	    };
	    return Component;
	}(Model_1.default));
	exports.default = Component;
	
	
	/***/ }),
	/* 238 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Iterator = /** @class */ (function () {
	    function Iterator(items) {
	        this.items = items || [];
	    }
	    /* Calls a method on every item passing the arguments through */
	    Iterator.prototype.proxyCall = function (methodName) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var results = [];
	        this.items.forEach(function (item) {
	            results.push(item[methodName].apply(item, args));
	        });
	        return results;
	    };
	    return Iterator;
	}());
	exports.default = Iterator;
	
	
	/***/ }),
	/* 239 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	/* Toolbar with buttons and title
	----------------------------------------------------------------------------------------------------------------------*/
	var Toolbar = /** @class */ (function () {
	    function Toolbar(calendar, toolbarOptions) {
	        this.el = null; // mirrors local `el`
	        this.viewsWithButtons = [];
	        this.calendar = calendar;
	        this.toolbarOptions = toolbarOptions;
	    }
	    // method to update toolbar-specific options, not calendar-wide options
	    Toolbar.prototype.setToolbarOptions = function (newToolbarOptions) {
	        this.toolbarOptions = newToolbarOptions;
	    };
	    // can be called repeatedly and will rerender
	    Toolbar.prototype.render = function () {
	        var sections = this.toolbarOptions.layout;
	        var el = this.el;
	        if (sections) {
	            if (!el) {
	                el = this.el = $("<div class='fc-toolbar " + this.toolbarOptions.extraClasses + "'/>");
	            }
	            else {
	                el.empty();
	            }
	            el.append(this.renderSection('left'))
	                .append(this.renderSection('right'))
	                .append(this.renderSection('center'))
	                .append('<div class="fc-clear"/>');
	        }
	        else {
	            this.removeElement();
	        }
	    };
	    Toolbar.prototype.removeElement = function () {
	        if (this.el) {
	            this.el.remove();
	            this.el = null;
	        }
	    };
	    Toolbar.prototype.renderSection = function (position) {
	        var _this = this;
	        var calendar = this.calendar;
	        var theme = calendar.theme;
	        var optionsManager = calendar.optionsManager;
	        var viewSpecManager = calendar.viewSpecManager;
	        var sectionEl = $('<div class="fc-' + position + '"/>');
	        var buttonStr = this.toolbarOptions.layout[position];
	        var calendarCustomButtons = optionsManager.get('customButtons') || {};
	        var calendarButtonTextOverrides = optionsManager.overrides.buttonText || {};
	        var calendarButtonText = optionsManager.get('buttonText') || {};
	        if (buttonStr) {
	            $.each(buttonStr.split(' '), function (i, buttonGroupStr) {
	                var groupChildren = $();
	                var isOnlyButtons = true;
	                var groupEl;
	                $.each(buttonGroupStr.split(','), function (j, buttonName) {
	                    var customButtonProps;
	                    var viewSpec;
	                    var buttonClick;
	                    var buttonIcon; // only one of these will be set
	                    var buttonText; // "
	                    var buttonInnerHtml;
	                    var buttonClasses;
	                    var buttonEl;
	                    var buttonAriaAttr;
	                    if (buttonName === 'title') {
	                        groupChildren = groupChildren.add($('<h2>&nbsp;</h2>')); // we always want it to take up height
	                        isOnlyButtons = false;
	                    }
	                    else {
	                        if ((customButtonProps = calendarCustomButtons[buttonName])) {
	                            buttonClick = function (ev) {
	                                if (customButtonProps.click) {
	                                    customButtonProps.click.call(buttonEl[0], ev);
	                                }
	                            };
	                            (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) ||
	                                (buttonIcon = theme.getIconClass(buttonName)) ||
	                                (buttonText = customButtonProps.text);
	                        }
	                        else if ((viewSpec = viewSpecManager.getViewSpec(buttonName))) {
	                            _this.viewsWithButtons.push(buttonName);
	                            buttonClick = function () {
	                                calendar.changeView(buttonName);
	                            };
	                            (buttonText = viewSpec.buttonTextOverride) ||
	                                (buttonIcon = theme.getIconClass(buttonName)) ||
	                                (buttonText = viewSpec.buttonTextDefault);
	                        }
	                        else if (calendar[buttonName]) {
	                            buttonClick = function () {
	                                calendar[buttonName]();
	                            };
	                            (buttonText = calendarButtonTextOverrides[buttonName]) ||
	                                (buttonIcon = theme.getIconClass(buttonName)) ||
	                                (buttonText = calendarButtonText[buttonName]);
	                            //            ^ everything else is considered default
	                        }
	                        if (buttonClick) {
	                            buttonClasses = [
	                                'fc-' + buttonName + '-button',
	                                theme.getClass('button'),
	                                theme.getClass('stateDefault')
	                            ];
	                            if (buttonText) {
	                                buttonInnerHtml = util_1.htmlEscape(buttonText);
	                                buttonAriaAttr = '';
	                            }
	                            else if (buttonIcon) {
	                                buttonInnerHtml = "<span class='" + buttonIcon + "'></span>";
	                                buttonAriaAttr = ' aria-label="' + buttonName + '"';
	                            }
	                            buttonEl = $(// type="button" so that it doesn't submit a form
	                            '<button type="button" class="' + buttonClasses.join(' ') + '"' +
	                                buttonAriaAttr +
	                                '>' + buttonInnerHtml + '</button>')
	                                .click(function (ev) {
	                                // don't process clicks for disabled buttons
	                                if (!buttonEl.hasClass(theme.getClass('stateDisabled'))) {
	                                    buttonClick(ev);
	                                    // after the click action, if the button becomes the "active" tab, or disabled,
	                                    // it should never have a hover class, so remove it now.
	                                    if (buttonEl.hasClass(theme.getClass('stateActive')) ||
	                                        buttonEl.hasClass(theme.getClass('stateDisabled'))) {
	                                        buttonEl.removeClass(theme.getClass('stateHover'));
	                                    }
	                                }
	                            })
	                                .mousedown(function () {
	                                // the *down* effect (mouse pressed in).
	                                // only on buttons that are not the "active" tab, or disabled
	                                buttonEl
	                                    .not('.' + theme.getClass('stateActive'))
	                                    .not('.' + theme.getClass('stateDisabled'))
	                                    .addClass(theme.getClass('stateDown'));
	                            })
	                                .mouseup(function () {
	                                // undo the *down* effect
	                                buttonEl.removeClass(theme.getClass('stateDown'));
	                            })
	                                .hover(function () {
	                                // the *hover* effect.
	                                // only on buttons that are not the "active" tab, or disabled
	                                buttonEl
	                                    .not('.' + theme.getClass('stateActive'))
	                                    .not('.' + theme.getClass('stateDisabled'))
	                                    .addClass(theme.getClass('stateHover'));
	                            }, function () {
	                                // undo the *hover* effect
	                                buttonEl
	                                    .removeClass(theme.getClass('stateHover'))
	                                    .removeClass(theme.getClass('stateDown')); // if mouseleave happens before mouseup
	                            });
	                            groupChildren = groupChildren.add(buttonEl);
	                        }
	                    }
	                });
	                if (isOnlyButtons) {
	                    groupChildren
	                        .first().addClass(theme.getClass('cornerLeft')).end()
	                        .last().addClass(theme.getClass('cornerRight')).end();
	                }
	                if (groupChildren.length > 1) {
	                    groupEl = $('<div/>');
	                    if (isOnlyButtons) {
	                        groupEl.addClass(theme.getClass('buttonGroup'));
	                    }
	                    groupEl.append(groupChildren);
	                    sectionEl.append(groupEl);
	                }
	                else {
	                    sectionEl.append(groupChildren); // 1 or 0 children
	                }
	            });
	        }
	        return sectionEl;
	    };
	    Toolbar.prototype.updateTitle = function (text) {
	        if (this.el) {
	            this.el.find('h2').text(text);
	        }
	    };
	    Toolbar.prototype.activateButton = function (buttonName) {
	        if (this.el) {
	            this.el.find('.fc-' + buttonName + '-button')
	                .addClass(this.calendar.theme.getClass('stateActive'));
	        }
	    };
	    Toolbar.prototype.deactivateButton = function (buttonName) {
	        if (this.el) {
	            this.el.find('.fc-' + buttonName + '-button')
	                .removeClass(this.calendar.theme.getClass('stateActive'));
	        }
	    };
	    Toolbar.prototype.disableButton = function (buttonName) {
	        if (this.el) {
	            this.el.find('.fc-' + buttonName + '-button')
	                .prop('disabled', true)
	                .addClass(this.calendar.theme.getClass('stateDisabled'));
	        }
	    };
	    Toolbar.prototype.enableButton = function (buttonName) {
	        if (this.el) {
	            this.el.find('.fc-' + buttonName + '-button')
	                .prop('disabled', false)
	                .removeClass(this.calendar.theme.getClass('stateDisabled'));
	        }
	    };
	    Toolbar.prototype.getViewsWithButtons = function () {
	        return this.viewsWithButtons;
	    };
	    return Toolbar;
	}());
	exports.default = Toolbar;
	
	
	/***/ }),
	/* 240 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var options_1 = __webpack_require__(31);
	var locale_1 = __webpack_require__(30);
	var Model_1 = __webpack_require__(48);
	var OptionsManager = /** @class */ (function (_super) {
	    tslib_1.__extends(OptionsManager, _super);
	    function OptionsManager(_calendar, overrides) {
	        var _this = _super.call(this) || this;
	        _this._calendar = _calendar;
	        _this.overrides = $.extend({}, overrides); // make a copy
	        _this.dynamicOverrides = {};
	        _this.compute();
	        return _this;
	    }
	    OptionsManager.prototype.add = function (newOptionHash) {
	        var optionCnt = 0;
	        var optionName;
	        this.recordOverrides(newOptionHash); // will trigger this model's watchers
	        for (optionName in newOptionHash) {
	            optionCnt++;
	        }
	        // special-case handling of single option change.
	        // if only one option change, `optionName` will be its name.
	        if (optionCnt === 1) {
	            if (optionName === 'height' || optionName === 'contentHeight' || optionName === 'aspectRatio') {
	                this._calendar.updateViewSize(true); // isResize=true
	                return;
	            }
	            else if (optionName === 'defaultDate') {
	                return; // can't change date this way. use gotoDate instead
	            }
	            else if (optionName === 'businessHours') {
	                return; // this model already reacts to this
	            }
	            else if (/^(event|select)(Overlap|Constraint|Allow)$/.test(optionName)) {
	                return; // doesn't affect rendering. only interactions.
	            }
	            else if (optionName === 'timezone') {
	                this._calendar.view.flash('initialEvents');
	                return;
	            }
	        }
	        // catch-all. rerender the header and footer and rebuild/rerender the current view
	        this._calendar.renderHeader();
	        this._calendar.renderFooter();
	        // even non-current views will be affected by this option change. do before rerender
	        // TODO: detangle
	        this._calendar.viewsByType = {};
	        this._calendar.reinitView();
	    };
	    // Computes the flattened options hash for the calendar and assigns to `this.options`.
	    // Assumes this.overrides and this.dynamicOverrides have already been initialized.
	    OptionsManager.prototype.compute = function () {
	        var locale;
	        var localeDefaults;
	        var isRTL;
	        var dirDefaults;
	        var rawOptions;
	        locale = util_1.firstDefined(// explicit locale option given?
	        this.dynamicOverrides.locale, this.overrides.locale);
	        localeDefaults = locale_1.localeOptionHash[locale];
	        if (!localeDefaults) {
	            locale = options_1.globalDefaults.locale;
	            localeDefaults = locale_1.localeOptionHash[locale] || {};
	        }
	        isRTL = util_1.firstDefined(// based on options computed so far, is direction RTL?
	        this.dynamicOverrides.isRTL, this.overrides.isRTL, localeDefaults.isRTL, options_1.globalDefaults.isRTL);
	        dirDefaults = isRTL ? options_1.rtlDefaults : {};
	        this.dirDefaults = dirDefaults;
	        this.localeDefaults = localeDefaults;
	        rawOptions = options_1.mergeOptions([
	            options_1.globalDefaults,
	            dirDefaults,
	            localeDefaults,
	            this.overrides,
	            this.dynamicOverrides
	        ]);
	        locale_1.populateInstanceComputableOptions(rawOptions); // fill in gaps with computed options
	        this.reset(rawOptions);
	    };
	    // stores the new options internally, but does not rerender anything.
	    OptionsManager.prototype.recordOverrides = function (newOptionHash) {
	        var optionName;
	        for (optionName in newOptionHash) {
	            this.dynamicOverrides[optionName] = newOptionHash[optionName];
	        }
	        this._calendar.viewSpecManager.clearCache(); // the dynamic override invalidates the options in this cache, so just clear it
	        this.compute(); // this.options needs to be recomputed after the dynamic override
	    };
	    return OptionsManager;
	}(Model_1.default));
	exports.default = OptionsManager;
	
	
	/***/ }),
	/* 241 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(0);
	var $ = __webpack_require__(3);
	var ViewRegistry_1 = __webpack_require__(21);
	var util_1 = __webpack_require__(4);
	var options_1 = __webpack_require__(31);
	var locale_1 = __webpack_require__(30);
	var ViewSpecManager = /** @class */ (function () {
	    function ViewSpecManager(optionsManager, _calendar) {
	        this.optionsManager = optionsManager;
	        this._calendar = _calendar;
	        this.clearCache();
	    }
	    ViewSpecManager.prototype.clearCache = function () {
	        this.viewSpecCache = {};
	    };
	    // Gets information about how to create a view. Will use a cache.
	    ViewSpecManager.prototype.getViewSpec = function (viewType) {
	        var cache = this.viewSpecCache;
	        return cache[viewType] || (cache[viewType] = this.buildViewSpec(viewType));
	    };
	    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
	    // Preference is given to views that have corresponding buttons.
	    ViewSpecManager.prototype.getUnitViewSpec = function (unit) {
	        var viewTypes;
	        var i;
	        var spec;
	        if ($.inArray(unit, util_1.unitsDesc) !== -1) {
	            // put views that have buttons first. there will be duplicates, but oh well
	            viewTypes = this._calendar.header.getViewsWithButtons(); // TODO: include footer as well?
	            $.each(ViewRegistry_1.viewHash, function (viewType) {
	                viewTypes.push(viewType);
	            });
	            for (i = 0; i < viewTypes.length; i++) {
	                spec = this.getViewSpec(viewTypes[i]);
	                if (spec) {
	                    if (spec.singleUnit === unit) {
	                        return spec;
	                    }
	                }
	            }
	        }
	    };
	    // Builds an object with information on how to create a given view
	    ViewSpecManager.prototype.buildViewSpec = function (requestedViewType) {
	        var viewOverrides = this.optionsManager.overrides.views || {};
	        var specChain = []; // for the view. lowest to highest priority
	        var defaultsChain = []; // for the view. lowest to highest priority
	        var overridesChain = []; // for the view. lowest to highest priority
	        var viewType = requestedViewType;
	        var spec; // for the view
	        var overrides; // for the view
	        var durationInput;
	        var duration;
	        var unit;
	        // iterate from the specific view definition to a more general one until we hit an actual View class
	        while (viewType) {
	            spec = ViewRegistry_1.viewHash[viewType];
	            overrides = viewOverrides[viewType];
	            viewType = null; // clear. might repopulate for another iteration
	            if (typeof spec === 'function') {
	                spec = { 'class': spec };
	            }
	            if (spec) {
	                specChain.unshift(spec);
	                defaultsChain.unshift(spec.defaults || {});
	                durationInput = durationInput || spec.duration;
	                viewType = viewType || spec.type;
	            }
	            if (overrides) {
	                overridesChain.unshift(overrides); // view-specific option hashes have options at zero-level
	                durationInput = durationInput || overrides.duration;
	                viewType = viewType || overrides.type;
	            }
	        }
	        spec = util_1.mergeProps(specChain);
	        spec.type = requestedViewType;
	        if (!spec['class']) {
	            return false;
	        }
	        // fall back to top-level `duration` option
	        durationInput = durationInput ||
	            this.optionsManager.dynamicOverrides.duration ||
	            this.optionsManager.overrides.duration;
	        if (durationInput) {
	            duration = moment.duration(durationInput);
	            if (duration.valueOf()) {
	                unit = util_1.computeDurationGreatestUnit(duration, durationInput);
	                spec.duration = duration;
	                spec.durationUnit = unit;
	                // view is a single-unit duration, like "week" or "day"
	                // incorporate options for this. lowest priority
	                if (duration.as(unit) === 1) {
	                    spec.singleUnit = unit;
	                    overridesChain.unshift(viewOverrides[unit] || {});
	                }
	            }
	        }
	        spec.defaults = options_1.mergeOptions(defaultsChain);
	        spec.overrides = options_1.mergeOptions(overridesChain);
	        this.buildViewSpecOptions(spec);
	        this.buildViewSpecButtonText(spec, requestedViewType);
	        return spec;
	    };
	    // Builds and assigns a view spec's options object from its already-assigned defaults and overrides
	    ViewSpecManager.prototype.buildViewSpecOptions = function (spec) {
	        var optionsManager = this.optionsManager;
	        spec.options = options_1.mergeOptions([
	            options_1.globalDefaults,
	            spec.defaults,
	            optionsManager.dirDefaults,
	            optionsManager.localeDefaults,
	            optionsManager.overrides,
	            spec.overrides,
	            optionsManager.dynamicOverrides // dynamically set via setter. highest precedence
	        ]);
	        locale_1.populateInstanceComputableOptions(spec.options);
	    };
	    // Computes and assigns a view spec's buttonText-related options
	    ViewSpecManager.prototype.buildViewSpecButtonText = function (spec, requestedViewType) {
	        var optionsManager = this.optionsManager;
	        // given an options object with a possible `buttonText` hash, lookup the buttonText for the
	        // requested view, falling back to a generic unit entry like "week" or "day"
	        function queryButtonText(options) {
	            var buttonText = options.buttonText || {};
	            return buttonText[requestedViewType] ||
	                // view can decide to look up a certain key
	                (spec.buttonTextKey ? buttonText[spec.buttonTextKey] : null) ||
	                // a key like "month"
	                (spec.singleUnit ? buttonText[spec.singleUnit] : null);
	        }
	        // highest to lowest priority
	        spec.buttonTextOverride =
	            queryButtonText(optionsManager.dynamicOverrides) ||
	                queryButtonText(optionsManager.overrides) || // constructor-specified buttonText lookup hash takes precedence
	                spec.overrides.buttonText; // `buttonText` for view-specific options is a string
	        // highest to lowest priority. mirrors buildViewSpecOptions
	        spec.buttonTextDefault =
	            queryButtonText(optionsManager.localeDefaults) ||
	                queryButtonText(optionsManager.dirDefaults) ||
	                spec.defaults.buttonText || // a single string. from ViewSubclass.defaults
	                queryButtonText(options_1.globalDefaults) ||
	                (spec.duration ? this._calendar.humanizeDuration(spec.duration) : null) || // like "3 days"
	                requestedViewType; // fall back to given view name
	    };
	    return ViewSpecManager;
	}());
	exports.default = ViewSpecManager;
	
	
	/***/ }),
	/* 242 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var EventPeriod_1 = __webpack_require__(243);
	var ArrayEventSource_1 = __webpack_require__(52);
	var EventSource_1 = __webpack_require__(6);
	var EventSourceParser_1 = __webpack_require__(37);
	var SingleEventDef_1 = __webpack_require__(13);
	var EventInstanceGroup_1 = __webpack_require__(18);
	var EmitterMixin_1 = __webpack_require__(11);
	var ListenerMixin_1 = __webpack_require__(7);
	var EventManager = /** @class */ (function () {
	    function EventManager(calendar) {
	        this.calendar = calendar;
	        this.stickySource = new ArrayEventSource_1.default(calendar);
	        this.otherSources = [];
	    }
	    EventManager.prototype.requestEvents = function (start, end, timezone, force) {
	        if (force ||
	            !this.currentPeriod ||
	            !this.currentPeriod.isWithinRange(start, end) ||
	            timezone !== this.currentPeriod.timezone) {
	            this.setPeriod(// will change this.currentPeriod
	            new EventPeriod_1.default(start, end, timezone));
	        }
	        return this.currentPeriod.whenReleased();
	    };
	    // Source Adding/Removing
	    // -----------------------------------------------------------------------------------------------------------------
	    EventManager.prototype.addSource = function (eventSource) {
	        this.otherSources.push(eventSource);
	        if (this.currentPeriod) {
	            this.currentPeriod.requestSource(eventSource); // might release
	        }
	    };
	    EventManager.prototype.removeSource = function (doomedSource) {
	        util_1.removeExact(this.otherSources, doomedSource);
	        if (this.currentPeriod) {
	            this.currentPeriod.purgeSource(doomedSource); // might release
	        }
	    };
	    EventManager.prototype.removeAllSources = function () {
	        this.otherSources = [];
	        if (this.currentPeriod) {
	            this.currentPeriod.purgeAllSources(); // might release
	        }
	    };
	    // Source Refetching
	    // -----------------------------------------------------------------------------------------------------------------
	    EventManager.prototype.refetchSource = function (eventSource) {
	        var currentPeriod = this.currentPeriod;
	        if (currentPeriod) {
	            currentPeriod.freeze();
	            currentPeriod.purgeSource(eventSource);
	            currentPeriod.requestSource(eventSource);
	            currentPeriod.thaw();
	        }
	    };
	    EventManager.prototype.refetchAllSources = function () {
	        var currentPeriod = this.currentPeriod;
	        if (currentPeriod) {
	            currentPeriod.freeze();
	            currentPeriod.purgeAllSources();
	            currentPeriod.requestSources(this.getSources());
	            currentPeriod.thaw();
	        }
	    };
	    // Source Querying
	    // -----------------------------------------------------------------------------------------------------------------
	    EventManager.prototype.getSources = function () {
	        return [this.stickySource].concat(this.otherSources);
	    };
	    // like querySources, but accepts multple match criteria (like multiple IDs)
	    EventManager.prototype.multiQuerySources = function (matchInputs) {
	        // coerce into an array
	        if (!matchInputs) {
	            matchInputs = [];
	        }
	        else if (!$.isArray(matchInputs)) {
	            matchInputs = [matchInputs];
	        }
	        var matchingSources = [];
	        var i;
	        // resolve raw inputs to real event source objects
	        for (i = 0; i < matchInputs.length; i++) {
	            matchingSources.push.apply(// append
	            matchingSources, this.querySources(matchInputs[i]));
	        }
	        return matchingSources;
	    };
	    // matchInput can either by a real event source object, an ID, or the function/URL for the source.
	    // returns an array of matching source objects.
	    EventManager.prototype.querySources = function (matchInput) {
	        var sources = this.otherSources;
	        var i;
	        var source;
	        // given a proper event source object
	        for (i = 0; i < sources.length; i++) {
	            source = sources[i];
	            if (source === matchInput) {
	                return [source];
	            }
	        }
	        // an ID match
	        source = this.getSourceById(EventSource_1.default.normalizeId(matchInput));
	        if (source) {
	            return [source];
	        }
	        // parse as an event source
	        matchInput = EventSourceParser_1.default.parse(matchInput, this.calendar);
	        if (matchInput) {
	            return $.grep(sources, function (source) {
	                return isSourcesEquivalent(matchInput, source);
	            });
	        }
	    };
	    /*
	    ID assumed to already be normalized
	    */
	    EventManager.prototype.getSourceById = function (id) {
	        return $.grep(this.otherSources, function (source) {
	            return source.id && source.id === id;
	        })[0];
	    };
	    // Event-Period
	    // -----------------------------------------------------------------------------------------------------------------
	    EventManager.prototype.setPeriod = function (eventPeriod) {
	        if (this.currentPeriod) {
	            this.unbindPeriod(this.currentPeriod);
	            this.currentPeriod = null;
	        }
	        this.currentPeriod = eventPeriod;
	        this.bindPeriod(eventPeriod);
	        eventPeriod.requestSources(this.getSources());
	    };
	    EventManager.prototype.bindPeriod = function (eventPeriod) {
	        this.listenTo(eventPeriod, 'release', function (eventsPayload) {
	            this.trigger('release', eventsPayload);
	        });
	    };
	    EventManager.prototype.unbindPeriod = function (eventPeriod) {
	        this.stopListeningTo(eventPeriod);
	    };
	    // Event Getting/Adding/Removing
	    // -----------------------------------------------------------------------------------------------------------------
	    EventManager.prototype.getEventDefByUid = function (uid) {
	        if (this.currentPeriod) {
	            return this.currentPeriod.getEventDefByUid(uid);
	        }
	    };
	    EventManager.prototype.addEventDef = function (eventDef, isSticky) {
	        if (isSticky) {
	            this.stickySource.addEventDef(eventDef);
	        }
	        if (this.currentPeriod) {
	            this.currentPeriod.addEventDef(eventDef); // might release
	        }
	    };
	    EventManager.prototype.removeEventDefsById = function (eventId) {
	        this.getSources().forEach(function (eventSource) {
	            eventSource.removeEventDefsById(eventId);
	        });
	        if (this.currentPeriod) {
	            this.currentPeriod.removeEventDefsById(eventId); // might release
	        }
	    };
	    EventManager.prototype.removeAllEventDefs = function () {
	        this.getSources().forEach(function (eventSource) {
	            eventSource.removeAllEventDefs();
	        });
	        if (this.currentPeriod) {
	            this.currentPeriod.removeAllEventDefs();
	        }
	    };
	    // Event Mutating
	    // -----------------------------------------------------------------------------------------------------------------
	    /*
	    Returns an undo function.
	    */
	    EventManager.prototype.mutateEventsWithId = function (eventDefId, eventDefMutation) {
	        var currentPeriod = this.currentPeriod;
	        var eventDefs;
	        var undoFuncs = [];
	        if (currentPeriod) {
	            currentPeriod.freeze();
	            eventDefs = currentPeriod.getEventDefsById(eventDefId);
	            eventDefs.forEach(function (eventDef) {
	                // add/remove esp because id might change
	                currentPeriod.removeEventDef(eventDef);
	                undoFuncs.push(eventDefMutation.mutateSingle(eventDef));
	                currentPeriod.addEventDef(eventDef);
	            });
	            currentPeriod.thaw();
	            return function () {
	                currentPeriod.freeze();
	                for (var i = 0; i < eventDefs.length; i++) {
	                    currentPeriod.removeEventDef(eventDefs[i]);
	                    undoFuncs[i]();
	                    currentPeriod.addEventDef(eventDefs[i]);
	                }
	                currentPeriod.thaw();
	            };
	        }
	        return function () { };
	    };
	    /*
	    copies and then mutates
	    */
	    EventManager.prototype.buildMutatedEventInstanceGroup = function (eventDefId, eventDefMutation) {
	        var eventDefs = this.getEventDefsById(eventDefId);
	        var i;
	        var defCopy;
	        var allInstances = [];
	        for (i = 0; i < eventDefs.length; i++) {
	            defCopy = eventDefs[i].clone();
	            if (defCopy instanceof SingleEventDef_1.default) {
	                eventDefMutation.mutateSingle(defCopy);
	                allInstances.push.apply(allInstances, // append
	                defCopy.buildInstances());
	            }
	        }
	        return new EventInstanceGroup_1.default(allInstances);
	    };
	    // Freezing
	    // -----------------------------------------------------------------------------------------------------------------
	    EventManager.prototype.freeze = function () {
	        if (this.currentPeriod) {
	            this.currentPeriod.freeze();
	        }
	    };
	    EventManager.prototype.thaw = function () {
	        if (this.currentPeriod) {
	            this.currentPeriod.thaw();
	        }
	    };
	    // methods that simply forward to EventPeriod
	    EventManager.prototype.getEventDefsById = function (eventDefId) {
	        return this.currentPeriod.getEventDefsById(eventDefId);
	    };
	    EventManager.prototype.getEventInstances = function () {
	        return this.currentPeriod.getEventInstances();
	    };
	    EventManager.prototype.getEventInstancesWithId = function (eventDefId) {
	        return this.currentPeriod.getEventInstancesWithId(eventDefId);
	    };
	    EventManager.prototype.getEventInstancesWithoutId = function (eventDefId) {
	        return this.currentPeriod.getEventInstancesWithoutId(eventDefId);
	    };
	    return EventManager;
	}());
	exports.default = EventManager;
	EmitterMixin_1.default.mixInto(EventManager);
	ListenerMixin_1.default.mixInto(EventManager);
	function isSourcesEquivalent(source0, source1) {
	    return source0.getPrimitive() === source1.getPrimitive();
	}
	
	
	/***/ }),
	/* 243 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var Promise_1 = __webpack_require__(19);
	var EmitterMixin_1 = __webpack_require__(11);
	var UnzonedRange_1 = __webpack_require__(5);
	var EventInstanceGroup_1 = __webpack_require__(18);
	var EventPeriod = /** @class */ (function () {
	    function EventPeriod(start, end, timezone) {
	        this.pendingCnt = 0;
	        this.freezeDepth = 0;
	        this.stuntedReleaseCnt = 0;
	        this.releaseCnt = 0;
	        this.start = start;
	        this.end = end;
	        this.timezone = timezone;
	        this.unzonedRange = new UnzonedRange_1.default(start.clone().stripZone(), end.clone().stripZone());
	        this.requestsByUid = {};
	        this.eventDefsByUid = {};
	        this.eventDefsById = {};
	        this.eventInstanceGroupsById = {};
	    }
	    EventPeriod.prototype.isWithinRange = function (start, end) {
	        // TODO: use a range util function?
	        return !start.isBefore(this.start) && !end.isAfter(this.end);
	    };
	    // Requesting and Purging
	    // -----------------------------------------------------------------------------------------------------------------
	    EventPeriod.prototype.requestSources = function (sources) {
	        this.freeze();
	        for (var i = 0; i < sources.length; i++) {
	            this.requestSource(sources[i]);
	        }
	        this.thaw();
	    };
	    EventPeriod.prototype.requestSource = function (source) {
	        var _this = this;
	        var request = { source: source, status: 'pending', eventDefs: null };
	        this.requestsByUid[source.uid] = request;
	        this.pendingCnt += 1;
	        source.fetch(this.start, this.end, this.timezone).then(function (eventDefs) {
	            if (request.status !== 'cancelled') {
	                request.status = 'completed';
	                request.eventDefs = eventDefs;
	                _this.addEventDefs(eventDefs);
	                _this.pendingCnt--;
	                _this.tryRelease();
	            }
	        }, function () {
	            if (request.status !== 'cancelled') {
	                request.status = 'failed';
	                _this.pendingCnt--;
	                _this.tryRelease();
	            }
	        });
	    };
	    EventPeriod.prototype.purgeSource = function (source) {
	        var request = this.requestsByUid[source.uid];
	        if (request) {
	            delete this.requestsByUid[source.uid];
	            if (request.status === 'pending') {
	                request.status = 'cancelled';
	                this.pendingCnt--;
	                this.tryRelease();
	            }
	            else if (request.status === 'completed') {
	                request.eventDefs.forEach(this.removeEventDef.bind(this));
	            }
	        }
	    };
	    EventPeriod.prototype.purgeAllSources = function () {
	        var requestsByUid = this.requestsByUid;
	        var uid;
	        var request;
	        var completedCnt = 0;
	        for (uid in requestsByUid) {
	            request = requestsByUid[uid];
	            if (request.status === 'pending') {
	                request.status = 'cancelled';
	            }
	            else if (request.status === 'completed') {
	                completedCnt++;
	            }
	        }
	        this.requestsByUid = {};
	        this.pendingCnt = 0;
	        if (completedCnt) {
	            this.removeAllEventDefs(); // might release
	        }
	    };
	    // Event Definitions
	    // -----------------------------------------------------------------------------------------------------------------
	    EventPeriod.prototype.getEventDefByUid = function (eventDefUid) {
	        return this.eventDefsByUid[eventDefUid];
	    };
	    EventPeriod.prototype.getEventDefsById = function (eventDefId) {
	        var a = this.eventDefsById[eventDefId];
	        if (a) {
	            return a.slice(); // clone
	        }
	        return [];
	    };
	    EventPeriod.prototype.addEventDefs = function (eventDefs) {
	        for (var i = 0; i < eventDefs.length; i++) {
	            this.addEventDef(eventDefs[i]);
	        }
	    };
	    EventPeriod.prototype.addEventDef = function (eventDef) {
	        var eventDefsById = this.eventDefsById;
	        var eventDefId = eventDef.id;
	        var eventDefs = eventDefsById[eventDefId] || (eventDefsById[eventDefId] = []);
	        var eventInstances = eventDef.buildInstances(this.unzonedRange);
	        var i;
	        eventDefs.push(eventDef);
	        this.eventDefsByUid[eventDef.uid] = eventDef;
	        for (i = 0; i < eventInstances.length; i++) {
	            this.addEventInstance(eventInstances[i], eventDefId);
	        }
	    };
	    EventPeriod.prototype.removeEventDefsById = function (eventDefId) {
	        var _this = this;
	        this.getEventDefsById(eventDefId).forEach(function (eventDef) {
	            _this.removeEventDef(eventDef);
	        });
	    };
	    EventPeriod.prototype.removeAllEventDefs = function () {
	        var isEmpty = $.isEmptyObject(this.eventDefsByUid);
	        this.eventDefsByUid = {};
	        this.eventDefsById = {};
	        this.eventInstanceGroupsById = {};
	        if (!isEmpty) {
	            this.tryRelease();
	        }
	    };
	    EventPeriod.prototype.removeEventDef = function (eventDef) {
	        var eventDefsById = this.eventDefsById;
	        var eventDefs = eventDefsById[eventDef.id];
	        delete this.eventDefsByUid[eventDef.uid];
	        if (eventDefs) {
	            util_1.removeExact(eventDefs, eventDef);
	            if (!eventDefs.length) {
	                delete eventDefsById[eventDef.id];
	            }
	            this.removeEventInstancesForDef(eventDef);
	        }
	    };
	    // Event Instances
	    // -----------------------------------------------------------------------------------------------------------------
	    EventPeriod.prototype.getEventInstances = function () {
	        var eventInstanceGroupsById = this.eventInstanceGroupsById;
	        var eventInstances = [];
	        var id;
	        for (id in eventInstanceGroupsById) {
	            eventInstances.push.apply(eventInstances, // append
	            eventInstanceGroupsById[id].eventInstances);
	        }
	        return eventInstances;
	    };
	    EventPeriod.prototype.getEventInstancesWithId = function (eventDefId) {
	        var eventInstanceGroup = this.eventInstanceGroupsById[eventDefId];
	        if (eventInstanceGroup) {
	            return eventInstanceGroup.eventInstances.slice(); // clone
	        }
	        return [];
	    };
	    EventPeriod.prototype.getEventInstancesWithoutId = function (eventDefId) {
	        var eventInstanceGroupsById = this.eventInstanceGroupsById;
	        var matchingInstances = [];
	        var id;
	        for (id in eventInstanceGroupsById) {
	            if (id !== eventDefId) {
	                matchingInstances.push.apply(matchingInstances, // append
	                eventInstanceGroupsById[id].eventInstances);
	            }
	        }
	        return matchingInstances;
	    };
	    EventPeriod.prototype.addEventInstance = function (eventInstance, eventDefId) {
	        var eventInstanceGroupsById = this.eventInstanceGroupsById;
	        var eventInstanceGroup = eventInstanceGroupsById[eventDefId] ||
	            (eventInstanceGroupsById[eventDefId] = new EventInstanceGroup_1.default());
	        eventInstanceGroup.eventInstances.push(eventInstance);
	        this.tryRelease();
	    };
	    EventPeriod.prototype.removeEventInstancesForDef = function (eventDef) {
	        var eventInstanceGroupsById = this.eventInstanceGroupsById;
	        var eventInstanceGroup = eventInstanceGroupsById[eventDef.id];
	        var removeCnt;
	        if (eventInstanceGroup) {
	            removeCnt = util_1.removeMatching(eventInstanceGroup.eventInstances, function (currentEventInstance) {
	                return currentEventInstance.def === eventDef;
	            });
	            if (!eventInstanceGroup.eventInstances.length) {
	                delete eventInstanceGroupsById[eventDef.id];
	            }
	            if (removeCnt) {
	                this.tryRelease();
	            }
	        }
	    };
	    // Releasing and Freezing
	    // -----------------------------------------------------------------------------------------------------------------
	    EventPeriod.prototype.tryRelease = function () {
	        if (!this.pendingCnt) {
	            if (!this.freezeDepth) {
	                this.release();
	            }
	            else {
	                this.stuntedReleaseCnt++;
	            }
	        }
	    };
	    EventPeriod.prototype.release = function () {
	        this.releaseCnt++;
	        this.trigger('release', this.eventInstanceGroupsById);
	    };
	    EventPeriod.prototype.whenReleased = function () {
	        var _this = this;
	        if (this.releaseCnt) {
	            return Promise_1.default.resolve(this.eventInstanceGroupsById);
	        }
	        else {
	            return Promise_1.default.construct(function (onResolve) {
	                _this.one('release', onResolve);
	            });
	        }
	    };
	    EventPeriod.prototype.freeze = function () {
	        if (!(this.freezeDepth++)) {
	            this.stuntedReleaseCnt = 0;
	        }
	    };
	    EventPeriod.prototype.thaw = function () {
	        if (!(--this.freezeDepth) && this.stuntedReleaseCnt && !this.pendingCnt) {
	            this.release();
	        }
	    };
	    return EventPeriod;
	}());
	exports.default = EventPeriod;
	EmitterMixin_1.default.mixInto(EventPeriod);
	
	
	/***/ }),
	/* 244 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var ListenerMixin_1 = __webpack_require__(7);
	/* Creates a clone of an element and lets it track the mouse as it moves
	----------------------------------------------------------------------------------------------------------------------*/
	var MouseFollower = /** @class */ (function () {
	    function MouseFollower(sourceEl, options) {
	        this.isFollowing = false;
	        this.isHidden = false;
	        this.isAnimating = false; // doing the revert animation?
	        this.options = options = options || {};
	        this.sourceEl = sourceEl;
	        this.parentEl = options.parentEl ? $(options.parentEl) : sourceEl.parent(); // default to sourceEl's parent
	    }
	    // Causes the element to start following the mouse
	    MouseFollower.prototype.start = function (ev) {
	        if (!this.isFollowing) {
	            this.isFollowing = true;
	            this.y0 = util_1.getEvY(ev);
	            this.x0 = util_1.getEvX(ev);
	            this.topDelta = 0;
	            this.leftDelta = 0;
	            if (!this.isHidden) {
	                this.updatePosition();
	            }
	            if (util_1.getEvIsTouch(ev)) {
	                this.listenTo($(document), 'touchmove', this.handleMove);
	            }
	            else {
	                this.listenTo($(document), 'mousemove', this.handleMove);
	            }
	        }
	    };
	    // Causes the element to stop following the mouse. If shouldRevert is true, will animate back to original position.
	    // `callback` gets invoked when the animation is complete. If no animation, it is invoked immediately.
	    MouseFollower.prototype.stop = function (shouldRevert, callback) {
	        var _this = this;
	        var revertDuration = this.options.revertDuration;
	        var complete = function () {
	            _this.isAnimating = false;
	            _this.removeElement();
	            _this.top0 = _this.left0 = null; // reset state for future updatePosition calls
	            if (callback) {
	                callback();
	            }
	        };
	        if (this.isFollowing && !this.isAnimating) {
	            this.isFollowing = false;
	            this.stopListeningTo($(document));
	            if (shouldRevert && revertDuration && !this.isHidden) {
	                this.isAnimating = true;
	                this.el.animate({
	                    top: this.top0,
	                    left: this.left0
	                }, {
	                    duration: revertDuration,
	                    complete: complete
	                });
	            }
	            else {
	                complete();
	            }
	        }
	    };
	    // Gets the tracking element. Create it if necessary
	    MouseFollower.prototype.getEl = function () {
	        var el = this.el;
	        if (!el) {
	            el = this.el = this.sourceEl.clone()
	                .addClass(this.options.additionalClass || '')
	                .css({
	                position: 'absolute',
	                visibility: '',
	                display: this.isHidden ? 'none' : '',
	                margin: 0,
	                right: 'auto',
	                bottom: 'auto',
	                width: this.sourceEl.width(),
	                height: this.sourceEl.height(),
	                opacity: this.options.opacity || '',
	                zIndex: this.options.zIndex
	            });
	            // we don't want long taps or any mouse interaction causing selection/menus.
	            // would use preventSelection(), but that prevents selectstart, causing problems.
	            el.addClass('fc-unselectable');
	            el.appendTo(this.parentEl);
	        }
	        return el;
	    };
	    // Removes the tracking element if it has already been created
	    MouseFollower.prototype.removeElement = function () {
	        if (this.el) {
	            this.el.remove();
	            this.el = null;
	        }
	    };
	    // Update the CSS position of the tracking element
	    MouseFollower.prototype.updatePosition = function () {
	        var sourceOffset;
	        var origin;
	        this.getEl(); // ensure this.el
	        // make sure origin info was computed
	        if (this.top0 == null) {
	            sourceOffset = this.sourceEl.offset();
	            origin = this.el.offsetParent().offset();
	            this.top0 = sourceOffset.top - origin.top;
	            this.left0 = sourceOffset.left - origin.left;
	        }
	        this.el.css({
	            top: this.top0 + this.topDelta,
	            left: this.left0 + this.leftDelta
	        });
	    };
	    // Gets called when the user moves the mouse
	    MouseFollower.prototype.handleMove = function (ev) {
	        this.topDelta = util_1.getEvY(ev) - this.y0;
	        this.leftDelta = util_1.getEvX(ev) - this.x0;
	        if (!this.isHidden) {
	            this.updatePosition();
	        }
	    };
	    // Temporarily makes the tracking element invisible. Can be called before following starts
	    MouseFollower.prototype.hide = function () {
	        if (!this.isHidden) {
	            this.isHidden = true;
	            if (this.el) {
	                this.el.hide();
	            }
	        }
	    };
	    // Show the tracking element after it has been temporarily hidden
	    MouseFollower.prototype.show = function () {
	        if (this.isHidden) {
	            this.isHidden = false;
	            this.updatePosition();
	            this.getEl().show();
	        }
	    };
	    return MouseFollower;
	}());
	exports.default = MouseFollower;
	ListenerMixin_1.default.mixInto(MouseFollower);
	
	
	/***/ }),
	/* 245 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var HitDragListener_1 = __webpack_require__(22);
	var Interaction_1 = __webpack_require__(15);
	var DateClicking = /** @class */ (function (_super) {
	    tslib_1.__extends(DateClicking, _super);
	    /*
	    component must implement:
	      - bindDateHandlerToEl
	      - getSafeHitFootprint
	      - getHitEl
	    */
	    function DateClicking(component) {
	        var _this = _super.call(this, component) || this;
	        _this.dragListener = _this.buildDragListener();
	        return _this;
	    }
	    DateClicking.prototype.end = function () {
	        this.dragListener.endInteraction();
	    };
	    DateClicking.prototype.bindToEl = function (el) {
	        var component = this.component;
	        var dragListener = this.dragListener;
	        component.bindDateHandlerToEl(el, 'mousedown', function (ev) {
	            if (!component.shouldIgnoreMouse()) {
	                dragListener.startInteraction(ev);
	            }
	        });
	        component.bindDateHandlerToEl(el, 'touchstart', function (ev) {
	            if (!component.shouldIgnoreTouch()) {
	                dragListener.startInteraction(ev);
	            }
	        });
	    };
	    // Creates a listener that tracks the user's drag across day elements, for day clicking.
	    DateClicking.prototype.buildDragListener = function () {
	        var _this = this;
	        var component = this.component;
	        var dayClickHit; // null if invalid dayClick
	        var dragListener = new HitDragListener_1.default(component, {
	            scroll: this.opt('dragScroll'),
	            interactionStart: function () {
	                dayClickHit = dragListener.origHit;
	            },
	            hitOver: function (hit, isOrig, origHit) {
	                // if user dragged to another cell at any point, it can no longer be a dayClick
	                if (!isOrig) {
	                    dayClickHit = null;
	                }
	            },
	            hitOut: function () {
	                dayClickHit = null;
	            },
	            interactionEnd: function (ev, isCancelled) {
	                var componentFootprint;
	                if (!isCancelled && dayClickHit) {
	                    componentFootprint = component.getSafeHitFootprint(dayClickHit);
	                    if (componentFootprint) {
	                        _this.view.triggerDayClick(componentFootprint, component.getHitEl(dayClickHit), ev);
	                    }
	                }
	            }
	        });
	        // because dragListener won't be called with any time delay, "dragging" will begin immediately,
	        // which will kill any touchmoving/scrolling. Prevent this.
	        dragListener.shouldCancelTouchScroll = false;
	        dragListener.scrollAlwaysKills = true;
	        return dragListener;
	    };
	    return DateClicking;
	}(Interaction_1.default));
	exports.default = DateClicking;
	
	
	/***/ }),
	/* 246 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var util_1 = __webpack_require__(4);
	var EventRenderer_1 = __webpack_require__(42);
	/*
	Only handles foreground segs.
	Does not own rendering. Use for low-level util methods by TimeGrid.
	*/
	var TimeGridEventRenderer = /** @class */ (function (_super) {
	    tslib_1.__extends(TimeGridEventRenderer, _super);
	    function TimeGridEventRenderer(timeGrid, fillRenderer) {
	        var _this = _super.call(this, timeGrid, fillRenderer) || this;
	        _this.timeGrid = timeGrid;
	        return _this;
	    }
	    TimeGridEventRenderer.prototype.renderFgSegs = function (segs) {
	        this.renderFgSegsIntoContainers(segs, this.timeGrid.fgContainerEls);
	    };
	    // Given an array of foreground segments, render a DOM element for each, computes position,
	    // and attaches to the column inner-container elements.
	    TimeGridEventRenderer.prototype.renderFgSegsIntoContainers = function (segs, containerEls) {
	        var segsByCol;
	        var col;
	        segsByCol = this.timeGrid.groupSegsByCol(segs);
	        for (col = 0; col < this.timeGrid.colCnt; col++) {
	            this.updateFgSegCoords(segsByCol[col]);
	        }
	        this.timeGrid.attachSegsByCol(segsByCol, containerEls);
	    };
	    TimeGridEventRenderer.prototype.unrenderFgSegs = function () {
	        if (this.fgSegs) {
	            this.fgSegs.forEach(function (seg) {
	                seg.el.remove();
	            });
	        }
	    };
	    // Computes a default event time formatting string if `timeFormat` is not explicitly defined
	    TimeGridEventRenderer.prototype.computeEventTimeFormat = function () {
	        return this.opt('noMeridiemTimeFormat'); // like "6:30" (no AM/PM)
	    };
	    // Computes a default `displayEventEnd` value if one is not expliclty defined
	    TimeGridEventRenderer.prototype.computeDisplayEventEnd = function () {
	        return true;
	    };
	    // Renders the HTML for a single event segment's default rendering
	    TimeGridEventRenderer.prototype.fgSegHtml = function (seg, disableResizing) {
	        var view = this.view;
	        var calendar = view.calendar;
	        var componentFootprint = seg.footprint.componentFootprint;
	        var isAllDay = componentFootprint.isAllDay;
	        var eventDef = seg.footprint.eventDef;
	        var isDraggable = view.isEventDefDraggable(eventDef);
	        var isResizableFromStart = !disableResizing && seg.isStart && view.isEventDefResizableFromStart(eventDef);
	        var isResizableFromEnd = !disableResizing && seg.isEnd && view.isEventDefResizableFromEnd(eventDef);
	        var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
	        var skinCss = util_1.cssToStr(this.getSkinCss(eventDef));
	        var timeText;
	        var fullTimeText; // more verbose time text. for the print stylesheet
	        var startTimeText; // just the start time text
	        classes.unshift('fc-time-grid-event', 'fc-v-event');
	        // if the event appears to span more than one day...
	        if (view.isMultiDayRange(componentFootprint.unzonedRange)) {
	            // Don't display time text on segments that run entirely through a day.
	            // That would appear as midnight-midnight and would look dumb.
	            // Otherwise, display the time text for the *segment's* times (like 6pm-midnight or midnight-10am)
	            if (seg.isStart || seg.isEnd) {
	                var zonedStart = calendar.msToMoment(seg.startMs);
	                var zonedEnd = calendar.msToMoment(seg.endMs);
	                timeText = this._getTimeText(zonedStart, zonedEnd, isAllDay);
	                fullTimeText = this._getTimeText(zonedStart, zonedEnd, isAllDay, 'LT');
	                startTimeText = this._getTimeText(zonedStart, zonedEnd, isAllDay, null, false); // displayEnd=false
	            }
	        }
	        else {
	            // Display the normal time text for the *event's* times
	            timeText = this.getTimeText(seg.footprint);
	            fullTimeText = this.getTimeText(seg.footprint, 'LT');
	            startTimeText = this.getTimeText(seg.footprint, null, false); // displayEnd=false
	        }
	        return '<a class="' + classes.join(' ') + '"' +
	            (eventDef.url ?
	                ' href="' + util_1.htmlEscape(eventDef.url) + '"' :
	                '') +
	            (skinCss ?
	                ' style="' + skinCss + '"' :
	                '') +
	            '>' +
	            '<div class="fc-content">' +
	            (timeText ?
	                '<div class="fc-time"' +
	                    ' data-start="' + util_1.htmlEscape(startTimeText) + '"' +
	                    ' data-full="' + util_1.htmlEscape(fullTimeText) + '"' +
	                    '>' +
	                    '<span>' + util_1.htmlEscape(timeText) + '</span>' +
	                    '</div>' :
	                '') +
	            (eventDef.title ?
	                '<div class="fc-title">' +
	                    util_1.htmlEscape(eventDef.title) +
	                    '</div>' :
	                '') +
	            '</div>' +
	            '<div class="fc-bg"/>' +
	            /* TODO: write CSS for this
	            (isResizableFromStart ?
	              '<div class="fc-resizer fc-start-resizer" />' :
	              ''
	              ) +
	            */
	            (isResizableFromEnd ?
	                '<div class="fc-resizer fc-end-resizer" />' :
	                '') +
	            '</a>';
	    };
	    // Given segments that are assumed to all live in the *same column*,
	    // compute their verical/horizontal coordinates and assign to their elements.
	    TimeGridEventRenderer.prototype.updateFgSegCoords = function (segs) {
	        this.timeGrid.computeSegVerticals(segs); // horizontals relies on this
	        this.computeFgSegHorizontals(segs); // compute horizontal coordinates, z-index's, and reorder the array
	        this.timeGrid.assignSegVerticals(segs);
	        this.assignFgSegHorizontals(segs);
	    };
	    // Given an array of segments that are all in the same column, sets the backwardCoord and forwardCoord on each.
	    // NOTE: Also reorders the given array by date!
	    TimeGridEventRenderer.prototype.computeFgSegHorizontals = function (segs) {
	        var levels;
	        var level0;
	        var i;
	        this.sortEventSegs(segs); // order by certain criteria
	        levels = buildSlotSegLevels(segs);
	        computeForwardSlotSegs(levels);
	        if ((level0 = levels[0])) {
	            for (i = 0; i < level0.length; i++) {
	                computeSlotSegPressures(level0[i]);
	            }
	            for (i = 0; i < level0.length; i++) {
	                this.computeFgSegForwardBack(level0[i], 0, 0);
	            }
	        }
	    };
	    // Calculate seg.forwardCoord and seg.backwardCoord for the segment, where both values range
	    // from 0 to 1. If the calendar is left-to-right, the seg.backwardCoord maps to "left" and
	    // seg.forwardCoord maps to "right" (via percentage). Vice-versa if the calendar is right-to-left.
	    //
	    // The segment might be part of a "series", which means consecutive segments with the same pressure
	    // who's width is unknown until an edge has been hit. `seriesBackwardPressure` is the number of
	    // segments behind this one in the current series, and `seriesBackwardCoord` is the starting
	    // coordinate of the first segment in the series.
	    TimeGridEventRenderer.prototype.computeFgSegForwardBack = function (seg, seriesBackwardPressure, seriesBackwardCoord) {
	        var forwardSegs = seg.forwardSegs;
	        var i;
	        if (seg.forwardCoord === undefined) {
	            if (!forwardSegs.length) {
	                // if there are no forward segments, this segment should butt up against the edge
	                seg.forwardCoord = 1;
	            }
	            else {
	                // sort highest pressure first
	                this.sortForwardSegs(forwardSegs);
	                // this segment's forwardCoord will be calculated from the backwardCoord of the
	                // highest-pressure forward segment.
	                this.computeFgSegForwardBack(forwardSegs[0], seriesBackwardPressure + 1, seriesBackwardCoord);
	                seg.forwardCoord = forwardSegs[0].backwardCoord;
	            }
	            // calculate the backwardCoord from the forwardCoord. consider the series
	            seg.backwardCoord = seg.forwardCoord -
	                (seg.forwardCoord - seriesBackwardCoord) / // available width for series
	                    (seriesBackwardPressure + 1); // # of segments in the series
	            // use this segment's coordinates to computed the coordinates of the less-pressurized
	            // forward segments
	            for (i = 0; i < forwardSegs.length; i++) {
	                this.computeFgSegForwardBack(forwardSegs[i], 0, seg.forwardCoord);
	            }
	        }
	    };
	    TimeGridEventRenderer.prototype.sortForwardSegs = function (forwardSegs) {
	        forwardSegs.sort(util_1.proxy(this, 'compareForwardSegs'));
	    };
	    // A cmp function for determining which forward segment to rely on more when computing coordinates.
	    TimeGridEventRenderer.prototype.compareForwardSegs = function (seg1, seg2) {
	        // put higher-pressure first
	        return seg2.forwardPressure - seg1.forwardPressure ||
	            // put segments that are closer to initial edge first (and favor ones with no coords yet)
	            (seg1.backwardCoord || 0) - (seg2.backwardCoord || 0) ||
	            // do normal sorting...
	            this.compareEventSegs(seg1, seg2);
	    };
	    // Given foreground event segments that have already had their position coordinates computed,
	    // assigns position-related CSS values to their elements.
	    TimeGridEventRenderer.prototype.assignFgSegHorizontals = function (segs) {
	        var i;
	        var seg;
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            seg.el.css(this.generateFgSegHorizontalCss(seg));
	            // if the height is short, add a className for alternate styling
	            if (seg.bottom - seg.top < 30) {
	                seg.el.addClass('fc-short');
	            }
	        }
	    };
	    // Generates an object with CSS properties/values that should be applied to an event segment element.
	    // Contains important positioning-related properties that should be applied to any event element, customized or not.
	    TimeGridEventRenderer.prototype.generateFgSegHorizontalCss = function (seg) {
	        var shouldOverlap = this.opt('slotEventOverlap');
	        var backwardCoord = seg.backwardCoord; // the left side if LTR. the right side if RTL. floating-point
	        var forwardCoord = seg.forwardCoord; // the right side if LTR. the left side if RTL. floating-point
	        var props = this.timeGrid.generateSegVerticalCss(seg); // get top/bottom first
	        var isRTL = this.timeGrid.isRTL;
	        var left; // amount of space from left edge, a fraction of the total width
	        var right; // amount of space from right edge, a fraction of the total width
	        if (shouldOverlap) {
	            // double the width, but don't go beyond the maximum forward coordinate (1.0)
	            forwardCoord = Math.min(1, backwardCoord + (forwardCoord - backwardCoord) * 2);
	        }
	        if (isRTL) {
	            left = 1 - forwardCoord;
	            right = backwardCoord;
	        }
	        else {
	            left = backwardCoord;
	            right = 1 - forwardCoord;
	        }
	        props.zIndex = seg.level + 1; // convert from 0-base to 1-based
	        props.left = left * 100 + '%';
	        props.right = right * 100 + '%';
	        if (shouldOverlap && seg.forwardPressure) {
	            // add padding to the edge so that forward stacked events don't cover the resizer's icon
	            props[isRTL ? 'marginLeft' : 'marginRight'] = 10 * 2; // 10 is a guesstimate of the icon's width
	        }
	        return props;
	    };
	    return TimeGridEventRenderer;
	}(EventRenderer_1.default));
	exports.default = TimeGridEventRenderer;
	// Builds an array of segments "levels". The first level will be the leftmost tier of segments if the calendar is
	// left-to-right, or the rightmost if the calendar is right-to-left. Assumes the segments are already ordered by date.
	function buildSlotSegLevels(segs) {
	    var levels = [];
	    var i;
	    var seg;
	    var j;
	    for (i = 0; i < segs.length; i++) {
	        seg = segs[i];
	        // go through all the levels and stop on the first level where there are no collisions
	        for (j = 0; j < levels.length; j++) {
	            if (!computeSlotSegCollisions(seg, levels[j]).length) {
	                break;
	            }
	        }
	        seg.level = j;
	        (levels[j] || (levels[j] = [])).push(seg);
	    }
	    return levels;
	}
	// For every segment, figure out the other segments that are in subsequent
	// levels that also occupy the same vertical space. Accumulate in seg.forwardSegs
	function computeForwardSlotSegs(levels) {
	    var i;
	    var level;
	    var j;
	    var seg;
	    var k;
	    for (i = 0; i < levels.length; i++) {
	        level = levels[i];
	        for (j = 0; j < level.length; j++) {
	            seg = level[j];
	            seg.forwardSegs = [];
	            for (k = i + 1; k < levels.length; k++) {
	                computeSlotSegCollisions(seg, levels[k], seg.forwardSegs);
	            }
	        }
	    }
	}
	// Figure out which path forward (via seg.forwardSegs) results in the longest path until
	// the furthest edge is reached. The number of segments in this path will be seg.forwardPressure
	function computeSlotSegPressures(seg) {
	    var forwardSegs = seg.forwardSegs;
	    var forwardPressure = 0;
	    var i;
	    var forwardSeg;
	    if (seg.forwardPressure === undefined) {
	        for (i = 0; i < forwardSegs.length; i++) {
	            forwardSeg = forwardSegs[i];
	            // figure out the child's maximum forward path
	            computeSlotSegPressures(forwardSeg);
	            // either use the existing maximum, or use the child's forward pressure
	            // plus one (for the forwardSeg itself)
	            forwardPressure = Math.max(forwardPressure, 1 + forwardSeg.forwardPressure);
	        }
	        seg.forwardPressure = forwardPressure;
	    }
	}
	// Find all the segments in `otherSegs` that vertically collide with `seg`.
	// Append into an optionally-supplied `results` array and return.
	function computeSlotSegCollisions(seg, otherSegs, results) {
	    if (results === void 0) { results = []; }
	    for (var i = 0; i < otherSegs.length; i++) {
	        if (isSlotSegCollision(seg, otherSegs[i])) {
	            results.push(otherSegs[i]);
	        }
	    }
	    return results;
	}
	// Do these segments occupy the same vertical space?
	function isSlotSegCollision(seg1, seg2) {
	    return seg1.bottom > seg2.top && seg1.top < seg2.bottom;
	}
	
	
	/***/ }),
	/* 247 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var HelperRenderer_1 = __webpack_require__(58);
	var TimeGridHelperRenderer = /** @class */ (function (_super) {
	    tslib_1.__extends(TimeGridHelperRenderer, _super);
	    function TimeGridHelperRenderer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TimeGridHelperRenderer.prototype.renderSegs = function (segs, sourceSeg) {
	        var helperNodes = [];
	        var i;
	        var seg;
	        var sourceEl;
	        // TODO: not good to call eventRenderer this way
	        this.eventRenderer.renderFgSegsIntoContainers(segs, this.component.helperContainerEls);
	        // Try to make the segment that is in the same row as sourceSeg look the same
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            if (sourceSeg && sourceSeg.col === seg.col) {
	                sourceEl = sourceSeg.el;
	                seg.el.css({
	                    left: sourceEl.css('left'),
	                    right: sourceEl.css('right'),
	                    'margin-left': sourceEl.css('margin-left'),
	                    'margin-right': sourceEl.css('margin-right')
	                });
	            }
	            helperNodes.push(seg.el[0]);
	        }
	        return $(helperNodes); // must return the elements rendered
	    };
	    return TimeGridHelperRenderer;
	}(HelperRenderer_1.default));
	exports.default = TimeGridHelperRenderer;
	
	
	/***/ }),
	/* 248 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var FillRenderer_1 = __webpack_require__(57);
	var TimeGridFillRenderer = /** @class */ (function (_super) {
	    tslib_1.__extends(TimeGridFillRenderer, _super);
	    function TimeGridFillRenderer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TimeGridFillRenderer.prototype.attachSegEls = function (type, segs) {
	        var timeGrid = this.component;
	        var containerEls;
	        // TODO: more efficient lookup
	        if (type === 'bgEvent') {
	            containerEls = timeGrid.bgContainerEls;
	        }
	        else if (type === 'businessHours') {
	            containerEls = timeGrid.businessContainerEls;
	        }
	        else if (type === 'highlight') {
	            containerEls = timeGrid.highlightContainerEls;
	        }
	        timeGrid.updateSegVerticals(segs);
	        timeGrid.attachSegsByCol(timeGrid.groupSegsByCol(segs), containerEls);
	        return segs.map(function (seg) {
	            return seg.el[0];
	        });
	    };
	    return TimeGridFillRenderer;
	}(FillRenderer_1.default));
	exports.default = TimeGridFillRenderer;
	
	
	/***/ }),
	/* 249 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* A rectangular panel that is absolutely positioned over other content
	------------------------------------------------------------------------------------------------------------------------
	Options:
	  - className (string)
	  - content (HTML string or jQuery element set)
	  - parentEl
	  - top
	  - left
	  - right (the x coord of where the right edge should be. not a "CSS" right)
	  - autoHide (boolean)
	  - show (callback)
	  - hide (callback)
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var ListenerMixin_1 = __webpack_require__(7);
	var Popover = /** @class */ (function () {
	    function Popover(options) {
	        this.isHidden = true;
	        this.margin = 10; // the space required between the popover and the edges of the scroll container
	        this.options = options || {};
	    }
	    // Shows the popover on the specified position. Renders it if not already
	    Popover.prototype.show = function () {
	        if (this.isHidden) {
	            if (!this.el) {
	                this.render();
	            }
	            this.el.show();
	            this.position();
	            this.isHidden = false;
	            this.trigger('show');
	        }
	    };
	    // Hides the popover, through CSS, but does not remove it from the DOM
	    Popover.prototype.hide = function () {
	        if (!this.isHidden) {
	            this.el.hide();
	            this.isHidden = true;
	            this.trigger('hide');
	        }
	    };
	    // Creates `this.el` and renders content inside of it
	    Popover.prototype.render = function () {
	        var _this = this;
	        var options = this.options;
	        this.el = $('<div class="fc-popover"/>')
	            .addClass(options.className || '')
	            .css({
	            // position initially to the top left to avoid creating scrollbars
	            top: 0,
	            left: 0
	        })
	            .append(options.content)
	            .appendTo(options.parentEl);
	        // when a click happens on anything inside with a 'fc-close' className, hide the popover
	        this.el.on('click', '.fc-close', function () {
	            _this.hide();
	        });
	        if (options.autoHide) {
	            this.listenTo($(document), 'mousedown', this.documentMousedown);
	        }
	    };
	    // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
	    Popover.prototype.documentMousedown = function (ev) {
	        // only hide the popover if the click happened outside the popover
	        if (this.el && !$(ev.target).closest(this.el).length) {
	            this.hide();
	        }
	    };
	    // Hides and unregisters any handlers
	    Popover.prototype.removeElement = function () {
	        this.hide();
	        if (this.el) {
	            this.el.remove();
	            this.el = null;
	        }
	        this.stopListeningTo($(document), 'mousedown');
	    };
	    // Positions the popover optimally, using the top/left/right options
	    Popover.prototype.position = function () {
	        var options = this.options;
	        var origin = this.el.offsetParent().offset();
	        var width = this.el.outerWidth();
	        var height = this.el.outerHeight();
	        var windowEl = $(window);
	        var viewportEl = util_1.getScrollParent(this.el);
	        var viewportTop;
	        var viewportLeft;
	        var viewportOffset;
	        var top; // the "position" (not "offset") values for the popover
	        var left; //
	        // compute top and left
	        top = options.top || 0;
	        if (options.left !== undefined) {
	            left = options.left;
	        }
	        else if (options.right !== undefined) {
	            left = options.right - width; // derive the left value from the right value
	        }
	        else {
	            left = 0;
	        }
	        if (viewportEl.is(window) || viewportEl.is(document)) {
	            viewportEl = windowEl;
	            viewportTop = 0; // the window is always at the top left
	            viewportLeft = 0; // (and .offset() won't work if called here)
	        }
	        else {
	            viewportOffset = viewportEl.offset();
	            viewportTop = viewportOffset.top;
	            viewportLeft = viewportOffset.left;
	        }
	        // if the window is scrolled, it causes the visible area to be further down
	        viewportTop += windowEl.scrollTop();
	        viewportLeft += windowEl.scrollLeft();
	        // constrain to the view port. if constrained by two edges, give precedence to top/left
	        if (options.viewportConstrain !== false) {
	            top = Math.min(top, viewportTop + viewportEl.outerHeight() - height - this.margin);
	            top = Math.max(top, viewportTop + this.margin);
	            left = Math.min(left, viewportLeft + viewportEl.outerWidth() - width - this.margin);
	            left = Math.max(left, viewportLeft + this.margin);
	        }
	        this.el.css({
	            top: top - origin.top,
	            left: left - origin.left
	        });
	    };
	    // Triggers a callback. Calls a function in the option hash of the same name.
	    // Arguments beyond the first `name` are forwarded on.
	    // TODO: better code reuse for this. Repeat code
	    Popover.prototype.trigger = function (name) {
	        if (this.options[name]) {
	            this.options[name].apply(this, Array.prototype.slice.call(arguments, 1));
	        }
	    };
	    return Popover;
	}());
	exports.default = Popover;
	ListenerMixin_1.default.mixInto(Popover);
	
	
	/***/ }),
	/* 250 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var EventRenderer_1 = __webpack_require__(42);
	/* Event-rendering methods for the DayGrid class
	----------------------------------------------------------------------------------------------------------------------*/
	var DayGridEventRenderer = /** @class */ (function (_super) {
	    tslib_1.__extends(DayGridEventRenderer, _super);
	    function DayGridEventRenderer(dayGrid, fillRenderer) {
	        var _this = _super.call(this, dayGrid, fillRenderer) || this;
	        _this.dayGrid = dayGrid;
	        return _this;
	    }
	    DayGridEventRenderer.prototype.renderBgRanges = function (eventRanges) {
	        // don't render timed background events
	        eventRanges = $.grep(eventRanges, function (eventRange) {
	            return eventRange.eventDef.isAllDay();
	        });
	        _super.prototype.renderBgRanges.call(this, eventRanges);
	    };
	    // Renders the given foreground event segments onto the grid
	    DayGridEventRenderer.prototype.renderFgSegs = function (segs) {
	        var rowStructs = this.rowStructs = this.renderSegRows(segs);
	        // append to each row's content skeleton
	        this.dayGrid.rowEls.each(function (i, rowNode) {
	            $(rowNode).find('.fc-content-skeleton > table').append(rowStructs[i].tbodyEl);
	        });
	    };
	    // Unrenders all currently rendered foreground event segments
	    DayGridEventRenderer.prototype.unrenderFgSegs = function () {
	        var rowStructs = this.rowStructs || [];
	        var rowStruct;
	        while ((rowStruct = rowStructs.pop())) {
	            rowStruct.tbodyEl.remove();
	        }
	        this.rowStructs = null;
	    };
	    // Uses the given events array to generate <tbody> elements that should be appended to each row's content skeleton.
	    // Returns an array of rowStruct objects (see the bottom of `renderSegRow`).
	    // PRECONDITION: each segment shoud already have a rendered and assigned `.el`
	    DayGridEventRenderer.prototype.renderSegRows = function (segs) {
	        var rowStructs = [];
	        var segRows;
	        var row;
	        segRows = this.groupSegRows(segs); // group into nested arrays
	        // iterate each row of segment groupings
	        for (row = 0; row < segRows.length; row++) {
	            rowStructs.push(this.renderSegRow(row, segRows[row]));
	        }
	        return rowStructs;
	    };
	    // Given a row # and an array of segments all in the same row, render a <tbody> element, a skeleton that contains
	    // the segments. Returns object with a bunch of internal data about how the render was calculated.
	    // NOTE: modifies rowSegs
	    DayGridEventRenderer.prototype.renderSegRow = function (row, rowSegs) {
	        var colCnt = this.dayGrid.colCnt;
	        var segLevels = this.buildSegLevels(rowSegs); // group into sub-arrays of levels
	        var levelCnt = Math.max(1, segLevels.length); // ensure at least one level
	        var tbody = $('<tbody/>');
	        var segMatrix = []; // lookup for which segments are rendered into which level+col cells
	        var cellMatrix = []; // lookup for all <td> elements of the level+col matrix
	        var loneCellMatrix = []; // lookup for <td> elements that only take up a single column
	        var i;
	        var levelSegs;
	        var col;
	        var tr;
	        var j;
	        var seg;
	        var td;
	        // populates empty cells from the current column (`col`) to `endCol`
	        function emptyCellsUntil(endCol) {
	            while (col < endCol) {
	                // try to grab a cell from the level above and extend its rowspan. otherwise, create a fresh cell
	                td = (loneCellMatrix[i - 1] || [])[col];
	                if (td) {
	                    td.attr('rowspan', parseInt(td.attr('rowspan') || 1, 10) + 1);
	                }
	                else {
	                    td = $('<td/>');
	                    tr.append(td);
	                }
	                cellMatrix[i][col] = td;
	                loneCellMatrix[i][col] = td;
	                col++;
	            }
	        }
	        for (i = 0; i < levelCnt; i++) {
	            levelSegs = segLevels[i];
	            col = 0;
	            tr = $('<tr/>');
	            segMatrix.push([]);
	            cellMatrix.push([]);
	            loneCellMatrix.push([]);
	            // levelCnt might be 1 even though there are no actual levels. protect against this.
	            // this single empty row is useful for styling.
	            if (levelSegs) {
	                for (j = 0; j < levelSegs.length; j++) {
	                    seg = levelSegs[j];
	                    emptyCellsUntil(seg.leftCol);
	                    // create a container that occupies or more columns. append the event element.
	                    td = $('<td class="fc-event-container"/>').append(seg.el);
	                    if (seg.leftCol !== seg.rightCol) {
	                        td.attr('colspan', seg.rightCol - seg.leftCol + 1);
	                    }
	                    else {
	                        loneCellMatrix[i][col] = td;
	                    }
	                    while (col <= seg.rightCol) {
	                        cellMatrix[i][col] = td;
	                        segMatrix[i][col] = seg;
	                        col++;
	                    }
	                    tr.append(td);
	                }
	            }
	            emptyCellsUntil(colCnt); // finish off the row
	            this.dayGrid.bookendCells(tr);
	            tbody.append(tr);
	        }
	        return {
	            row: row,
	            tbodyEl: tbody,
	            cellMatrix: cellMatrix,
	            segMatrix: segMatrix,
	            segLevels: segLevels,
	            segs: rowSegs
	        };
	    };
	    // Stacks a flat array of segments, which are all assumed to be in the same row, into subarrays of vertical levels.
	    // NOTE: modifies segs
	    DayGridEventRenderer.prototype.buildSegLevels = function (segs) {
	        var levels = [];
	        var i;
	        var seg;
	        var j;
	        // Give preference to elements with certain criteria, so they have
	        // a chance to be closer to the top.
	        this.sortEventSegs(segs);
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            // loop through levels, starting with the topmost, until the segment doesn't collide with other segments
	            for (j = 0; j < levels.length; j++) {
	                if (!isDaySegCollision(seg, levels[j])) {
	                    break;
	                }
	            }
	            // `j` now holds the desired subrow index
	            seg.level = j;
	            // create new level array if needed and append segment
	            (levels[j] || (levels[j] = [])).push(seg);
	        }
	        // order segments left-to-right. very important if calendar is RTL
	        for (j = 0; j < levels.length; j++) {
	            levels[j].sort(compareDaySegCols);
	        }
	        return levels;
	    };
	    // Given a flat array of segments, return an array of sub-arrays, grouped by each segment's row
	    DayGridEventRenderer.prototype.groupSegRows = function (segs) {
	        var segRows = [];
	        var i;
	        for (i = 0; i < this.dayGrid.rowCnt; i++) {
	            segRows.push([]);
	        }
	        for (i = 0; i < segs.length; i++) {
	            segRows[segs[i].row].push(segs[i]);
	        }
	        return segRows;
	    };
	    // Computes a default event time formatting string if `timeFormat` is not explicitly defined
	    DayGridEventRenderer.prototype.computeEventTimeFormat = function () {
	        return this.opt('extraSmallTimeFormat'); // like "6p" or "6:30p"
	    };
	    // Computes a default `displayEventEnd` value if one is not expliclty defined
	    DayGridEventRenderer.prototype.computeDisplayEventEnd = function () {
	        return this.dayGrid.colCnt === 1; // we'll likely have space if there's only one day
	    };
	    // Builds the HTML to be used for the default element for an individual segment
	    DayGridEventRenderer.prototype.fgSegHtml = function (seg, disableResizing) {
	        var view = this.view;
	        var eventDef = seg.footprint.eventDef;
	        var isAllDay = seg.footprint.componentFootprint.isAllDay;
	        var isDraggable = view.isEventDefDraggable(eventDef);
	        var isResizableFromStart = !disableResizing && isAllDay &&
	            seg.isStart && view.isEventDefResizableFromStart(eventDef);
	        var isResizableFromEnd = !disableResizing && isAllDay &&
	            seg.isEnd && view.isEventDefResizableFromEnd(eventDef);
	        var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
	        var skinCss = util_1.cssToStr(this.getSkinCss(eventDef));
	        var timeHtml = '';
	        var timeText;
	        var titleHtml;
	        classes.unshift('fc-day-grid-event', 'fc-h-event');
	        // Only display a timed events time if it is the starting segment
	        if (seg.isStart) {
	            timeText = this.getTimeText(seg.footprint);
	            if (timeText) {
	                timeHtml = '<span class="fc-time">' + util_1.htmlEscape(timeText) + '</span>';
	            }
	        }
	        titleHtml =
	            '<span class="fc-title">' +
	                (util_1.htmlEscape(eventDef.title || '') || '&nbsp;') + // we always want one line of height
	                '</span>';
	        return '<a class="' + classes.join(' ') + '"' +
	            (eventDef.url ?
	                ' href="' + util_1.htmlEscape(eventDef.url) + '"' :
	                '') +
	            (skinCss ?
	                ' style="' + skinCss + '"' :
	                '') +
	            '>' +
	            '<div class="fc-content">' +
	            (this.dayGrid.isRTL ?
	                titleHtml + ' ' + timeHtml : // put a natural space in between
	                timeHtml + ' ' + titleHtml //
	            ) +
	            '</div>' +
	            (isResizableFromStart ?
	                '<div class="fc-resizer fc-start-resizer" />' :
	                '') +
	            (isResizableFromEnd ?
	                '<div class="fc-resizer fc-end-resizer" />' :
	                '') +
	            '</a>';
	    };
	    return DayGridEventRenderer;
	}(EventRenderer_1.default));
	exports.default = DayGridEventRenderer;
	// Computes whether two segments' columns collide. They are assumed to be in the same row.
	function isDaySegCollision(seg, otherSegs) {
	    var i;
	    var otherSeg;
	    for (i = 0; i < otherSegs.length; i++) {
	        otherSeg = otherSegs[i];
	        if (otherSeg.leftCol <= seg.rightCol &&
	            otherSeg.rightCol >= seg.leftCol) {
	            return true;
	        }
	    }
	    return false;
	}
	// A cmp function for determining the leftmost event
	function compareDaySegCols(a, b) {
	    return a.leftCol - b.leftCol;
	}
	
	
	/***/ }),
	/* 251 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var HelperRenderer_1 = __webpack_require__(58);
	var DayGridHelperRenderer = /** @class */ (function (_super) {
	    tslib_1.__extends(DayGridHelperRenderer, _super);
	    function DayGridHelperRenderer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // Renders a mock "helper" event. `sourceSeg` is the associated internal segment object. It can be null.
	    DayGridHelperRenderer.prototype.renderSegs = function (segs, sourceSeg) {
	        var helperNodes = [];
	        var rowStructs;
	        // TODO: not good to call eventRenderer this way
	        rowStructs = this.eventRenderer.renderSegRows(segs);
	        // inject each new event skeleton into each associated row
	        this.component.rowEls.each(function (row, rowNode) {
	            var rowEl = $(rowNode); // the .fc-row
	            var skeletonEl = $('<div class="fc-helper-skeleton"><table/></div>'); // will be absolutely positioned
	            var skeletonTopEl;
	            var skeletonTop;
	            // If there is an original segment, match the top position. Otherwise, put it at the row's top level
	            if (sourceSeg && sourceSeg.row === row) {
	                skeletonTop = sourceSeg.el.position().top;
	            }
	            else {
	                skeletonTopEl = rowEl.find('.fc-content-skeleton tbody');
	                if (!skeletonTopEl.length) {
	                    skeletonTopEl = rowEl.find('.fc-content-skeleton table');
	                }
	                skeletonTop = skeletonTopEl.position().top;
	            }
	            skeletonEl.css('top', skeletonTop)
	                .find('table')
	                .append(rowStructs[row].tbodyEl);
	            rowEl.append(skeletonEl);
	            helperNodes.push(skeletonEl[0]);
	        });
	        return $(helperNodes); // must return the elements rendered
	    };
	    return DayGridHelperRenderer;
	}(HelperRenderer_1.default));
	exports.default = DayGridHelperRenderer;
	
	
	/***/ }),
	/* 252 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var FillRenderer_1 = __webpack_require__(57);
	var DayGridFillRenderer = /** @class */ (function (_super) {
	    tslib_1.__extends(DayGridFillRenderer, _super);
	    function DayGridFillRenderer() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.fillSegTag = 'td'; // override the default tag name
	        return _this;
	    }
	    DayGridFillRenderer.prototype.attachSegEls = function (type, segs) {
	        var nodes = [];
	        var i;
	        var seg;
	        var skeletonEl;
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            skeletonEl = this.renderFillRow(type, seg);
	            this.component.rowEls.eq(seg.row).append(skeletonEl);
	            nodes.push(skeletonEl[0]);
	        }
	        return nodes;
	    };
	    // Generates the HTML needed for one row of a fill. Requires the seg's el to be rendered.
	    DayGridFillRenderer.prototype.renderFillRow = function (type, seg) {
	        var colCnt = this.component.colCnt;
	        var startCol = seg.leftCol;
	        var endCol = seg.rightCol + 1;
	        var className;
	        var skeletonEl;
	        var trEl;
	        if (type === 'businessHours') {
	            className = 'bgevent';
	        }
	        else {
	            className = type.toLowerCase();
	        }
	        skeletonEl = $('<div class="fc-' + className + '-skeleton">' +
	            '<table><tr/></table>' +
	            '</div>');
	        trEl = skeletonEl.find('tr');
	        if (startCol > 0) {
	            trEl.append('<td colspan="' + startCol + '"/>');
	        }
	        trEl.append(seg.el.attr('colspan', endCol - startCol));
	        if (endCol < colCnt) {
	            trEl.append('<td colspan="' + (colCnt - endCol) + '"/>');
	        }
	        this.component.bookendCells(trEl);
	        return skeletonEl;
	    };
	    return DayGridFillRenderer;
	}(FillRenderer_1.default));
	exports.default = DayGridFillRenderer;
	
	
	/***/ }),
	/* 253 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var BasicViewDateProfileGenerator_1 = __webpack_require__(228);
	var UnzonedRange_1 = __webpack_require__(5);
	var MonthViewDateProfileGenerator = /** @class */ (function (_super) {
	    tslib_1.__extends(MonthViewDateProfileGenerator, _super);
	    function MonthViewDateProfileGenerator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // Computes the date range that will be rendered.
	    MonthViewDateProfileGenerator.prototype.buildRenderRange = function (currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
	        var renderUnzonedRange = _super.prototype.buildRenderRange.call(this, currentUnzonedRange, currentRangeUnit, isRangeAllDay);
	        var start = this.msToUtcMoment(renderUnzonedRange.startMs, isRangeAllDay);
	        var end = this.msToUtcMoment(renderUnzonedRange.endMs, isRangeAllDay);
	        var rowCnt;
	        // ensure 6 weeks
	        if (this.opt('fixedWeekCount')) {
	            rowCnt = Math.ceil(// could be partial weeks due to hiddenDays
	            end.diff(start, 'weeks', true) // dontRound=true
	            );
	            end.add(6 - rowCnt, 'weeks');
	        }
	        return new UnzonedRange_1.default(start, end);
	    };
	    return MonthViewDateProfileGenerator;
	}(BasicViewDateProfileGenerator_1.default));
	exports.default = MonthViewDateProfileGenerator;
	
	
	/***/ }),
	/* 254 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var util_1 = __webpack_require__(4);
	var EventRenderer_1 = __webpack_require__(42);
	var ListEventRenderer = /** @class */ (function (_super) {
	    tslib_1.__extends(ListEventRenderer, _super);
	    function ListEventRenderer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ListEventRenderer.prototype.renderFgSegs = function (segs) {
	        if (!segs.length) {
	            this.component.renderEmptyMessage();
	        }
	        else {
	            this.component.renderSegList(segs);
	        }
	    };
	    // generates the HTML for a single event row
	    ListEventRenderer.prototype.fgSegHtml = function (seg) {
	        var view = this.view;
	        var calendar = view.calendar;
	        var theme = calendar.theme;
	        var eventFootprint = seg.footprint;
	        var eventDef = eventFootprint.eventDef;
	        var componentFootprint = eventFootprint.componentFootprint;
	        var url = eventDef.url;
	        var classes = ['fc-list-item'].concat(this.getClasses(eventDef));
	        var bgColor = this.getBgColor(eventDef);
	        var timeHtml;
	        if (componentFootprint.isAllDay) {
	            timeHtml = view.getAllDayHtml();
	        }
	        else if (view.isMultiDayRange(componentFootprint.unzonedRange)) {
	            if (seg.isStart || seg.isEnd) {
	                timeHtml = util_1.htmlEscape(this._getTimeText(calendar.msToMoment(seg.startMs), calendar.msToMoment(seg.endMs), componentFootprint.isAllDay));
	            }
	            else {
	                timeHtml = view.getAllDayHtml();
	            }
	        }
	        else {
	            // Display the normal time text for the *event's* times
	            timeHtml = util_1.htmlEscape(this.getTimeText(eventFootprint));
	        }
	        if (url) {
	            classes.push('fc-has-url');
	        }
	        return '<tr class="' + classes.join(' ') + '">' +
	            (this.displayEventTime ?
	                '<td class="fc-list-item-time ' + theme.getClass('widgetContent') + '">' +
	                    (timeHtml || '') +
	                    '</td>' :
	                '') +
	            '<td class="fc-list-item-marker ' + theme.getClass('widgetContent') + '">' +
	            '<span class="fc-event-dot"' +
	            (bgColor ?
	                ' style="background-color:' + bgColor + '"' :
	                '') +
	            '></span>' +
	            '</td>' +
	            '<td class="fc-list-item-title ' + theme.getClass('widgetContent') + '">' +
	            '<a' + (url ? ' href="' + util_1.htmlEscape(url) + '"' : '') + '>' +
	            util_1.htmlEscape(eventDef.title || '') +
	            '</a>' +
	            '</td>' +
	            '</tr>';
	    };
	    // like "4:00am"
	    ListEventRenderer.prototype.computeEventTimeFormat = function () {
	        return this.opt('mediumTimeFormat');
	    };
	    return ListEventRenderer;
	}(EventRenderer_1.default));
	exports.default = ListEventRenderer;
	
	
	/***/ }),
	/* 255 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var EventPointing_1 = __webpack_require__(59);
	var ListEventPointing = /** @class */ (function (_super) {
	    tslib_1.__extends(ListEventPointing, _super);
	    function ListEventPointing() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // for events with a url, the whole <tr> should be clickable,
	    // but it's impossible to wrap with an <a> tag. simulate this.
	    ListEventPointing.prototype.handleClick = function (seg, ev) {
	        var url;
	        _super.prototype.handleClick.call(this, seg, ev); // might prevent the default action
	        // not clicking on or within an <a> with an href
	        if (!$(ev.target).closest('a[href]').length) {
	            url = seg.footprint.eventDef.url;
	            if (url && !ev.isDefaultPrevented()) {
	                window.location.href = url; // simulate link click
	            }
	        }
	    };
	    return ListEventPointing;
	}(EventPointing_1.default));
	exports.default = ListEventPointing;
	
	
	/***/ }),
	/* 256 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventSourceParser_1 = __webpack_require__(37);
	var ArrayEventSource_1 = __webpack_require__(52);
	var FuncEventSource_1 = __webpack_require__(215);
	var JsonFeedEventSource_1 = __webpack_require__(216);
	EventSourceParser_1.default.registerClass(ArrayEventSource_1.default);
	EventSourceParser_1.default.registerClass(FuncEventSource_1.default);
	EventSourceParser_1.default.registerClass(JsonFeedEventSource_1.default);
	
	
	/***/ }),
	/* 257 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var ThemeRegistry_1 = __webpack_require__(51);
	var StandardTheme_1 = __webpack_require__(213);
	var JqueryUiTheme_1 = __webpack_require__(214);
	var BootstrapTheme_1 = __webpack_require__(258);
	ThemeRegistry_1.defineThemeSystem('standard', StandardTheme_1.default);
	ThemeRegistry_1.defineThemeSystem('jquery-ui', JqueryUiTheme_1.default);
	ThemeRegistry_1.defineThemeSystem('bootstrap3', BootstrapTheme_1.default);
	
	
	/***/ }),
	/* 258 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var Theme_1 = __webpack_require__(38);
	var BootstrapTheme = /** @class */ (function (_super) {
	    tslib_1.__extends(BootstrapTheme, _super);
	    function BootstrapTheme() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return BootstrapTheme;
	}(Theme_1.default));
	exports.default = BootstrapTheme;
	BootstrapTheme.prototype.classes = {
	    widget: 'fc-bootstrap3',
	    tableGrid: 'table-bordered',
	    tableList: 'table table-striped',
	    buttonGroup: 'btn-group',
	    button: 'btn btn-default',
	    stateActive: 'active',
	    stateDisabled: 'disabled',
	    today: 'alert alert-info',
	    popover: 'panel panel-default',
	    popoverHeader: 'panel-heading',
	    popoverContent: 'panel-body',
	    // day grid
	    headerRow: 'panel-default',
	    dayRow: 'panel-default',
	    // list view
	    listView: 'panel panel-default'
	};
	BootstrapTheme.prototype.baseIconClass = 'glyphicon';
	BootstrapTheme.prototype.iconClasses = {
	    close: 'glyphicon-remove',
	    prev: 'glyphicon-chevron-left',
	    next: 'glyphicon-chevron-right',
	    prevYear: 'glyphicon-backward',
	    nextYear: 'glyphicon-forward'
	};
	BootstrapTheme.prototype.iconOverrideOption = 'bootstrapGlyphicons';
	BootstrapTheme.prototype.iconOverrideCustomButtonOption = 'bootstrapGlyphicon';
	BootstrapTheme.prototype.iconOverridePrefix = 'glyphicon-';
	
	
	/***/ }),
	/* 259 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var ViewRegistry_1 = __webpack_require__(21);
	var BasicView_1 = __webpack_require__(62);
	var MonthView_1 = __webpack_require__(229);
	ViewRegistry_1.defineView('basic', {
	    'class': BasicView_1.default
	});
	ViewRegistry_1.defineView('basicDay', {
	    type: 'basic',
	    duration: { days: 1 }
	});
	ViewRegistry_1.defineView('basicWeek', {
	    type: 'basic',
	    duration: { weeks: 1 }
	});
	ViewRegistry_1.defineView('month', {
	    'class': MonthView_1.default,
	    duration: { months: 1 },
	    defaults: {
	        fixedWeekCount: true
	    }
	});
	
	
	/***/ }),
	/* 260 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var ViewRegistry_1 = __webpack_require__(21);
	var AgendaView_1 = __webpack_require__(226);
	ViewRegistry_1.defineView('agenda', {
	    'class': AgendaView_1.default,
	    defaults: {
	        allDaySlot: true,
	        slotDuration: '00:30:00',
	        slotEventOverlap: true // a bad name. confused with overlap/constraint system
	    }
	});
	ViewRegistry_1.defineView('agendaDay', {
	    type: 'agenda',
	    duration: { days: 1 }
	});
	ViewRegistry_1.defineView('agendaWeek', {
	    type: 'agenda',
	    duration: { weeks: 1 }
	});
	
	
	/***/ }),
	/* 261 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var ViewRegistry_1 = __webpack_require__(21);
	var ListView_1 = __webpack_require__(230);
	ViewRegistry_1.defineView('list', {
	    'class': ListView_1.default,
	    buttonTextKey: 'list',
	    defaults: {
	        buttonText: 'list',
	        listDayFormat: 'LL',
	        noEventsMessage: 'No events to display'
	    }
	});
	ViewRegistry_1.defineView('listDay', {
	    type: 'list',
	    duration: { days: 1 },
	    defaults: {
	        listDayFormat: 'dddd' // day-of-week is all we need. full date is probably in header
	    }
	});
	ViewRegistry_1.defineView('listWeek', {
	    type: 'list',
	    duration: { weeks: 1 },
	    defaults: {
	        listDayFormat: 'dddd',
	        listDayAltFormat: 'LL'
	    }
	});
	ViewRegistry_1.defineView('listMonth', {
	    type: 'list',
	    duration: { month: 1 },
	    defaults: {
	        listDayAltFormat: 'dddd' // day-of-week is nice-to-have
	    }
	});
	ViewRegistry_1.defineView('listYear', {
	    type: 'list',
	    duration: { year: 1 },
	    defaults: {
	        listDayAltFormat: 'dddd' // day-of-week is nice-to-have
	    }
	});
	
	
	/***/ }),
	/* 262 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	
	
	/***/ })
	/******/ ]);
	});

/***/ },

/***/ "./node_modules/fullcalendar/dist/locale/fr.js":
/***/ function(module, exports, __webpack_require__) {

	!function(e,r){ true?module.exports=r(__webpack_require__("./node_modules/moment/moment.js"),__webpack_require__("./node_modules/fullcalendar/dist/fullcalendar.js")):"function"==typeof define&&define.amd?define(["moment","fullcalendar"],r):"object"==typeof exports?r(require("moment"),require("fullcalendar")):r(e.moment,e.FullCalendar)}("undefined"!=typeof self?self:this,function(e,r){return function(e){function r(t){if(n[t])return n[t].exports;var a=n[t]={i:t,l:!1,exports:{}};return e[t].call(a.exports,a,a.exports,r),a.l=!0,a.exports}var n={};return r.m=e,r.c=n,r.d=function(e,n,t){r.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:t})},r.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(n,"a",n),n},r.o=function(e,r){return Object.prototype.hasOwnProperty.call(e,r)},r.p="",r(r.s=127)}({0:function(r,n){r.exports=e},1:function(e,n){e.exports=r},127:function(e,r,n){Object.defineProperty(r,"__esModule",{value:!0}),n(128);var t=n(1);t.datepickerLocale("fr","fr",{closeText:"Fermer",prevText:"Précédent",nextText:"Suivant",currentText:"Aujourd'hui",monthNames:["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],monthNamesShort:["janv.","févr.","mars","avr.","mai","juin","juil.","août","sept.","oct.","nov.","déc."],dayNames:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],dayNamesShort:["dim.","lun.","mar.","mer.","jeu.","ven.","sam."],dayNamesMin:["D","L","M","M","J","V","S"],weekHeader:"Sem.",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),t.locale("fr",{buttonText:{year:"Année",month:"Mois",week:"Semaine",day:"Jour",list:"Mon planning"},allDayHtml:"Toute la<br/>journée",eventLimitText:"en plus",noEventsMessage:"Aucun événement à afficher"})},128:function(e,r,n){!function(e,r){r(n(0))}(0,function(e){return e.defineLocale("fr",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd’hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|)/,ordinal:function(e,r){switch(r){case"D":return e+(1===e?"er":"");default:case"M":case"Q":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}},week:{dow:1,doy:4}})})}})});

/***/ },

/***/ "./src/universal/components/reservations/CalendarV2.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactMomentProptypes = __webpack_require__("./node_modules/react-moment-proptypes/src/index.js");
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _server = __webpack_require__("./node_modules/react-dom/server.js");
	
	var _server2 = _interopRequireDefault(_server);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	var _availabilities = __webpack_require__("./src/universal/helpers/availabilities.js");
	
	var _memos = __webpack_require__("./src/universal/collections/memos/memos.js");
	
	var _componentMemo = __webpack_require__("./src/universal/components/reservations/components/component-memo.js");
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Tracker = Package.tracker.Tracker;
	
	
	var jQuery = __webpack_require__("./node_modules/jquery/dist/jquery.js");
	__webpack_require__("./node_modules/fullcalendar/dist/fullcalendar.js");
	__webpack_require__("./node_modules/fullcalendar/dist/locale/fr.js");
	
	var CalendarPageV2 = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["flights-type", "reservations-planner", "montgolfieres", "users", "places"]
	}), (0, _reactRouter.withRouter)(_class = _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(CalendarPageV2, _React$Component);
	
		function CalendarPageV2(props) {
			(0, _classCallCheck3.default)(this, CalendarPageV2);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (CalendarPageV2.__proto__ || (0, _getPrototypeOf2.default)(CalendarPageV2)).call(this, props));
	
			_this.state = {};
	
			_this.startDate = (0, _moment2.default)().startOf('week').toDate();
			_this.endDate = (0, _moment2.default)().endOf('week').toDate();
	
			return _this;
		}
	
		(0, _createClass3.default)(CalendarPageV2, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				var that = this;
				Tracker.nonreactive(function () {
					jQuery('#calendar').fullCalendar({
						locale: 'fr',
						height: jQuery('#calendar').height(),
						defaultView: 'basicWeek',
						selectable: false,
						eventAfterAllRender: function eventAfterAllRender(view) {
							console.log("rerender");
							jQuery('textarea').keyup(function (e) {
								var content = jQuery(e.target).val();
								var id = jQuery(e.target).attr('id');
	
								console.log('update', id);
								_memos.Memos.update(id, { "$set": { content: content } });
							});
						},
						viewRender: function viewRender(view, element) {
							console.log("viewRender");
							if (_this2.startDate == (0, _moment2.default)(date).startOf('week').toDate()) return;
							if (_this2.reloading) return;
							console.log("pass test");
	
							_this2.reloading = false;
	
							var date = jQuery('#calendar').fullCalendar('getDate');
							_this2.startDate = (0, _moment2.default)(date).startOf('week').toDate();
							_this2.endDate = (0, _moment2.default)(date).endOf('week').toDate();
	
							_this2.subscriptions && _this2.subscriptions.available.stop();
							Tracker.nonreactive(function () {
								console.log("subscription launched");
								_this2.subscriptions = {};
								_this2.subscriptions.available = Meteor.subscribe("availableAndScheduledBetween", _this2.startDate, _this2.endDate, function () {
									console.log("subscription done");
									_this2.reloading = true;
	
									var $calendar = jQuery('#calendar');
									$calendar.fullCalendar('prev');
									$calendar.fullCalendar('next');
									$calendar.fullCalendar('refresh');
									/*let view = $calendar.fullCalendar('getView');
	        view.unrenderDates();
	        view.renderDates();*/
								});
							});
						},
						dayRender: function dayRender(momentDate, cell) {
							var date = momentDate.toDate();
	
							console.log('la date', date);
	
							var anjou = _server2.default.renderToStaticMarkup(_react2.default.createElement(
								'div',
								{ className: 'calendar' },
								_react2.default.createElement(
									_rubix.BPanel,
									{ header: 'Angers' },
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 12 },
										_react2.default.createElement(
											'p',
											null,
											(0, _availabilities.getAvailabilityTotalCount)(date, "anjou", "evening") - (0, _availabilities.getReservedCount)(date, "anjou", "morning") + " places (matin)"
										),
										_react2.default.createElement(_rubix.Progress, { striped: true, bsStyle: 'info', value: (0, _availabilities.getReservedCount)(date, "anjou", "morning") / (0, _availabilities.getAvailabilityTotalCount)(date, "anjou", "morning") * 100 })
									),
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 12 },
										_react2.default.createElement(
											'p',
											null,
											(0, _availabilities.getAvailabilityTotalCount)(date, "anjou", "evening") - (0, _availabilities.getReservedCount)(date, "anjou", "evening") + " places (soir)"
										),
										_react2.default.createElement(_rubix.Progress, { striped: true, bsStyle: 'info', value: (0, _availabilities.getReservedCount)(date, "anjou", "evening") / (0, _availabilities.getAvailabilityTotalCount)(date, "anjou", "evening") * 100 }),
										_react2.default.createElement('br', null)
									)
								)
							));
							var nantes = _server2.default.renderToStaticMarkup(_react2.default.createElement(
								'div',
								{ className: 'calendar' },
								_react2.default.createElement(
									_rubix.BPanel,
									{ header: 'Nantes' },
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 12 },
										_react2.default.createElement(
											'p',
											null,
											(0, _availabilities.getAvailabilityTotalCount)(date, "anjou", "evening") - (0, _availabilities.getReservedCount)(date, "nantes", "morning") + " places (matin)"
										),
										_react2.default.createElement(_rubix.Progress, { striped: true, bsStyle: 'info', value: (0, _availabilities.getReservedCount)(date, "nantes", "morning") / (0, _availabilities.getAvailabilityTotalCount)(date, "nantes", "morning") * 100 })
									),
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 12 },
										_react2.default.createElement(
											'p',
											null,
											(0, _availabilities.getAvailabilityTotalCount)(date, "anjou", "evening") - (0, _availabilities.getReservedCount)(date, "nantes", "evening") + " places (soir)"
										),
										_react2.default.createElement(_rubix.Progress, { striped: true, bsStyle: 'info', value: (0, _availabilities.getReservedCount)(date, "nantes", "evening") / (0, _availabilities.getAvailabilityTotalCount)(date, "nantes", "evening") * 100 }),
										_react2.default.createElement('br', null)
									)
								),
								!_.includes(Meteor.user().roles, 'partner') && _react2.default.createElement(
									'center',
									null,
									_react2.default.createElement(
										_rubix.Button,
										{ bsStyle: 'primary' },
										'Ouvrir'
									)
								)
							));
	
							var memos = _server2.default.renderToStaticMarkup(_react2.default.createElement(_componentMemo.MemoComponent, { memo: (0, _availabilities.getMemoFromDate)(date) }));
	
							if (Meteor.user().roles == 'partner') {
								memos = '';
							}
	
							cell.html("<div class='calendar-day'><br/>" + memos + anjou + nantes + "</div>");
						},
						dayClick: function dayClick(event, jsEvent, view) {
							jQuery(jsEvent.target).focus();
	
							if (jsEvent.target.type != 'button') return;
	
							if (!_.includes(Meteor.user().roles, 'partner')) that.props.router.push('/planning?date=' + event.format());
						}
					});
				});
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.subscriptions.available.stop();
			}
		}, {
			key: 'render',
			value: function render() {
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Calendrier des disponibilit\xE9s' },
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 12 },
							_react2.default.createElement('div', { id: 'calendar' })
						)
					)
				);
			}
		}]);
		return CalendarPageV2;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = CalendarPageV2;
	
	
	CalendarPageV2.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/reservations/components/component-memo.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MemoComponent = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _memos = __webpack_require__("./src/universal/collections/memos/memos.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var MemoComponent = exports.MemoComponent = function (_React$Component) {
	  (0, _inherits3.default)(MemoComponent, _React$Component);
	
	  function MemoComponent(props) {
	    (0, _classCallCheck3.default)(this, MemoComponent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MemoComponent.__proto__ || (0, _getPrototypeOf2.default)(MemoComponent)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  (0, _createClass3.default)(MemoComponent, [{
	    key: 'changeMemoInfos',
	    value: function changeMemoInfos(event) {
	      console.log("test");
	      //Memos.update(event.target.id, { "$set": {content: event.target.value}});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'calendar-memo' },
	        _react2.default.createElement(
	          _rubix.BPanel,
	          { header: 'M\xE9mo' },
	          _react2.default.createElement(
	            _rubix.FormGroup,
	            { controlId: 'formControlsTextarea' },
	            _react2.default.createElement(_rubix.FormControl, { style: { height: '200px', border: 'none' }, ref: 'memo', id: this.props.memo._id, defaultValue: this.props.memo.content, onChange: this.changeMemoInfos.bind(this), type: 'text', componentClass: 'textarea' })
	          )
	        )
	      );
	    }
	  }]);
	  return MemoComponent;
	}(_react2.default.Component);
	
	MemoComponent.propTypes = {
	  memo: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/flights-type/FlightsTypeForm.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _flightsType = __webpack_require__("./src/universal/collections/flights-type/flights-type.js");
	
	var _options = __webpack_require__("./src/universal/collections/flights-type/options.js");
	
	var _prices = __webpack_require__("./src/universal/collections/flights-type/prices.js");
	
	var _promotions = __webpack_require__("./src/universal/collections/flights-type/promotions.js");
	
	var _reactColor = __webpack_require__("./node_modules/react-color/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var FlightsTypeFormPage = (_dec = (0, _ReactiveMixin.Reactive)({
	  subscriptions: ["flights-type"]
	}), (0, _reactRouter.withRouter)(_class = _dec(_class = function (_React$Component) {
	  (0, _inherits3.default)(FlightsTypeFormPage, _React$Component);
	
	  function FlightsTypeFormPage(props) {
	    (0, _classCallCheck3.default)(this, FlightsTypeFormPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FlightsTypeFormPage.__proto__ || (0, _getPrototypeOf2.default)(FlightsTypeFormPage)).call(this, props));
	
	    _this.state = {};
	    if (_this.props.params.id) _this.flight = _flightsType.FlightsType.find({ _id: _this.props.params.id }).fetch()[0];else _this.flight = {};
	    _this.state.prices = _prices.Prices.find({ partnerId: null }, { sort: { 'title': 1 } }).fetch();
	    _this.state.options = _options.Options.find({}, { sort: { 'title': 1 } }).fetch();
	    _this.state.promotions = _promotions.Promotions.find({}, { sort: { 'title': 1 } }).fetch();
	
	    if (!_this.flight) _this.state.color = "#03a9f4";else _this.state.color = _this.flight.color;
	    return _this;
	  }
	
	  (0, _createClass3.default)(FlightsTypeFormPage, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	
	      var newFlight = {};
	      var params = {};
	      var message = null;
	      var method = null;
	
	      params.attributes = {};
	      _lodash2.default.each(this.refs, function (ref, key) {
	        if (_reactDom2.default.findDOMNode(ref).type == 'select-multiple') {
	          var option = void 0;
	          var node = _reactDom2.default.findDOMNode(ref);
	          var options = [].slice.call(node.querySelectorAll('option'));
	          var selected = options.filter(function (option) {
	            return option.selected;
	          });
	          var selectedValues = selected.map(function (option) {
	            return option.value;
	          });
	          params.attributes[key] = selectedValues;
	        } else {
	          params.attributes[key] = _reactDom2.default.findDOMNode(ref).value.trim();
	        }
	      });
	
	      params.attributes['color'] = this.state.color;
	
	      if (this.props.params.id) {
	        message = "Le vol a été modifié avec succès.";
	        method = "flightsType.update";
	        params._id = this.props.params.id;
	      } else {
	        message = "Le vol a été ajouté avec succès.";
	        method = "flightsType.insert";
	        params.attributes["createdAt"] = new Date();
	      }
	
	      Meteor.call(method, params, function (err, _id) {
	
	        if (err) {
	          Messenger().post({
	            message: err,
	            type: "error"
	          });
	          return;
	        }
	
	        Messenger().post({
	          message: message,
	          type: "success"
	        });
	
	        this.props.router.push('/flights');
	      }.bind(this));
	    }
	  }, {
	    key: 'selectPlace',
	    value: function selectPlace(event) {
	      if (event.target.value == 'aucune') {
	        this.setState({
	          prices: _prices.Prices.find()
	        });
	      } else {
	        this.setState({
	          prices: _prices.Prices.find({ constraintPlace: { $in: [event.target.value] } }).fetch()
	        });
	      }
	    }
	  }, {
	    key: 'selectColor',
	    value: function selectColor(color, event) {
	      console.log(color);
	      console.log(event);
	      this.setState({
	        color: color.hex
	      });
	      console.log(this.state);
	    }
	  }, {
	    key: 'renderPrices',
	    value: function renderPrices() {
	      return this.state.prices.map(function (price) {
	        return _react2.default.createElement(
	          'option',
	          { value: price._id },
	          price.title,
	          ' : ',
	          price.price,
	          '\u20AC'
	        );
	      });
	    }
	  }, {
	    key: 'renderPromotions',
	    value: function renderPromotions() {
	      return this.state.promotions.map(function (promotion) {
	        return _react2.default.createElement(
	          'option',
	          { value: promotion._id },
	          promotion.title
	        );
	      });
	    }
	  }, {
	    key: 'renderOptions',
	    value: function renderOptions() {
	      return this.state.options.map(function (option) {
	        return _react2.default.createElement(
	          'option',
	          { value: option._id },
	          option.title,
	          ' : ',
	          option.price,
	          '\u20AC'
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _rubix.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _rubix.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/flights' },
	              'Vols'
	            )
	          ),
	          _react2.default.createElement(
	            _rubix.Breadcrumb.Item,
	            { href: '#', active: true },
	            'Ajouter un vol'
	          )
	        ),
	        _react2.default.createElement(
	          _rubix.BPanel,
	          { header: 'Ajouter un vol' },
	          _react2.default.createElement(
	            _rubix.Form,
	            { horizontal: true, onSubmit: this.handleSubmit.bind(this) },
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              { controlId: 'formHorizontalEmail' },
	              _react2.default.createElement(
	                _rubix.Col,
	                { componentClass: _rubix.ControlLabel, sm: 3 },
	                'Titre du vol'
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 9 },
	                _react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'title', defaultValue: this.flight.title })
	              )
	            ),
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              { controlId: 'formHorizontalPassword' },
	              _react2.default.createElement(
	                _rubix.Col,
	                { componentClass: _rubix.ControlLabel, sm: 3 },
	                'Description du vol'
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 9 },
	                _react2.default.createElement(_rubix.FormControl, { componentClass: 'textarea', ref: 'description', defaultValue: this.flight.description })
	              )
	            ),
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              { controlId: 'formHorizontalPassword' },
	              _react2.default.createElement(
	                _rubix.Col,
	                { componentClass: _rubix.ControlLabel, sm: 3 },
	                'Couleur'
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 9 },
	                _react2.default.createElement(_reactColor.CirclePicker, { onChangeComplete: this.selectColor.bind(this), color: this.state.color })
	              )
	            ),
	            _react2.default.createElement('hr', null),
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              { controlId: 'formHorizontalPassword' },
	              _react2.default.createElement(
	                _rubix.Col,
	                { componentClass: _rubix.ControlLabel, sm: 3 },
	                'Nombre de passagers minimum *'
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 2 },
	                _react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'constraintPassengerMin', defaultValue: this.flight.constraintPassengerMin })
	              )
	            ),
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              { controlId: 'formHorizontalPassword' },
	              _react2.default.createElement(
	                _rubix.Col,
	                { componentClass: _rubix.ControlLabel, sm: 3 },
	                'Nombre de passagers maximum *'
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 2 },
	                _react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'constraintPassengerMax', defaultValue: this.flight.constraintPassengerMax })
	              )
	            ),
	            _react2.default.createElement('hr', null),
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              { controlId: 'formHorizontalPassword' },
	              _react2.default.createElement(
	                _rubix.Col,
	                { componentClass: _rubix.ControlLabel, sm: 3 },
	                'Prix SEMAINE'
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 2 },
	                _react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'priceSemaine', defaultValue: this.flight.priceSemaine })
	              )
	            ),
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              { controlId: 'formHorizontalPassword' },
	              _react2.default.createElement(
	                _rubix.Col,
	                { componentClass: _rubix.ControlLabel, sm: 3 },
	                'Prix LIBRE DATE'
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 2 },
	                _react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'priceLibreDate', defaultValue: this.flight.priceLibreDate })
	              )
	            ),
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              { controlId: 'formHorizontalPassword' },
	              _react2.default.createElement(
	                _rubix.Col,
	                { componentClass: _rubix.ControlLabel, sm: 3 },
	                'Prix ENFANT'
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 2 },
	                _react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'priceEnfant', defaultValue: this.flight.priceEnfant })
	              )
	            ),
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              { controlId: 'formHorizontalPassword' },
	              _react2.default.createElement(
	                _rubix.Col,
	                { componentClass: _rubix.ControlLabel, sm: 3 },
	                'Conditions de remboursement'
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 9 },
	                _react2.default.createElement(_rubix.FormControl, { componentClass: 'textarea', ref: 'remboursement', defaultValue: this.flight.remboursement })
	              )
	            ),
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              { controlId: 'formHorizontalPassword' },
	              _react2.default.createElement(
	                _rubix.Col,
	                { componentClass: _rubix.ControlLabel, sm: 3 },
	                'Info sur le billet'
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 9 },
	                _react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'infoBillet', defaultValue: this.flight.infoBillet })
	              )
	            ),
	            _react2.default.createElement('hr', null),
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              { controlId: 'formHorizontalPassword' },
	              _react2.default.createElement(
	                _rubix.Col,
	                { componentClass: _rubix.ControlLabel, sm: 3 },
	                'Options possibles'
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 9 },
	                _react2.default.createElement(
	                  _rubix.FormControl,
	                  { componentClass: 'select', placeholder: 'select', ref: 'optionIds', multiple: true, defaultValue: this.flight.optionIds },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    'Aucune options'
	                  ),
	                  this.renderOptions()
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              { controlId: 'formHorizontalPassword' },
	              _react2.default.createElement(
	                _rubix.Col,
	                { componentClass: _rubix.ControlLabel, sm: 3 },
	                'Promotions possibles'
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 9 },
	                _react2.default.createElement(
	                  _rubix.FormControl,
	                  { componentClass: 'select', placeholder: 'select', ref: 'promotionIds', multiple: true, defaultValue: this.flight.promotionIds },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    'Aucune promotions'
	                  ),
	                  this.renderPromotions()
	                )
	              )
	            ),
	            _react2.default.createElement('hr', null),
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              { controlId: 'formHorizontalPassword' },
	              _react2.default.createElement(
	                _rubix.Col,
	                { componentClass: _rubix.ControlLabel, sm: 3 },
	                'R\xE9f\xE9rence*'
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 2 },
	                _react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'reference', defaultValue: this.flight.reference })
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 7 },
	                _react2.default.createElement(
	                  'small',
	                  null,
	                  '* laisser vide si ce vol n\'existe pas sur le site.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              null,
	              _react2.default.createElement(
	                _rubix.Col,
	                { smOffset: 2, sm: 10 },
	                _react2.default.createElement(
	                  _rubix.Button,
	                  { type: 'submit' },
	                  'Enregistrer'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return FlightsTypeFormPage;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = FlightsTypeFormPage;
	
	
	FlightsTypeFormPage.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./node_modules/react-color/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomPicker = exports.TwitterPicker = exports.SwatchesPicker = exports.SliderPicker = exports.SketchPicker = exports.PhotoshopPicker = exports.MaterialPicker = exports.HuePicker = exports.GithubPicker = exports.CompactPicker = exports.ChromePicker = exports.default = exports.CirclePicker = exports.BlockPicker = exports.AlphaPicker = undefined;
	
	var _Alpha = __webpack_require__("./node_modules/react-color/lib/components/alpha/Alpha.js");
	
	Object.defineProperty(exports, 'AlphaPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Alpha).default;
	  }
	});
	
	var _Block = __webpack_require__("./node_modules/react-color/lib/components/block/Block.js");
	
	Object.defineProperty(exports, 'BlockPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Block).default;
	  }
	});
	
	var _Circle = __webpack_require__("./node_modules/react-color/lib/components/circle/Circle.js");
	
	Object.defineProperty(exports, 'CirclePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Circle).default;
	  }
	});
	
	var _Chrome = __webpack_require__("./node_modules/react-color/lib/components/chrome/Chrome.js");
	
	Object.defineProperty(exports, 'ChromePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Chrome).default;
	  }
	});
	
	var _Compact = __webpack_require__("./node_modules/react-color/lib/components/compact/Compact.js");
	
	Object.defineProperty(exports, 'CompactPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Compact).default;
	  }
	});
	
	var _Github = __webpack_require__("./node_modules/react-color/lib/components/github/Github.js");
	
	Object.defineProperty(exports, 'GithubPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Github).default;
	  }
	});
	
	var _Hue = __webpack_require__("./node_modules/react-color/lib/components/hue/Hue.js");
	
	Object.defineProperty(exports, 'HuePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hue).default;
	  }
	});
	
	var _Material = __webpack_require__("./node_modules/react-color/lib/components/material/Material.js");
	
	Object.defineProperty(exports, 'MaterialPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Material).default;
	  }
	});
	
	var _Photoshop = __webpack_require__("./node_modules/react-color/lib/components/photoshop/Photoshop.js");
	
	Object.defineProperty(exports, 'PhotoshopPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Photoshop).default;
	  }
	});
	
	var _Sketch = __webpack_require__("./node_modules/react-color/lib/components/sketch/Sketch.js");
	
	Object.defineProperty(exports, 'SketchPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sketch).default;
	  }
	});
	
	var _Slider = __webpack_require__("./node_modules/react-color/lib/components/slider/Slider.js");
	
	Object.defineProperty(exports, 'SliderPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Slider).default;
	  }
	});
	
	var _Swatches = __webpack_require__("./node_modules/react-color/lib/components/swatches/Swatches.js");
	
	Object.defineProperty(exports, 'SwatchesPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Swatches).default;
	  }
	});
	
	var _Twitter = __webpack_require__("./node_modules/react-color/lib/components/twitter/Twitter.js");
	
	Object.defineProperty(exports, 'TwitterPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Twitter).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__("./node_modules/react-color/lib/components/common/ColorWrap.js");
	
	Object.defineProperty(exports, 'CustomPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	var _Chrome2 = _interopRequireDefault(_Chrome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chrome2.default;

/***/ },

/***/ "./node_modules/react-color/lib/components/alpha/Alpha.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlphaPicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	var _AlphaPointer = __webpack_require__("./node_modules/react-color/lib/components/alpha/AlphaPointer.js");
	
	var _AlphaPointer2 = _interopRequireDefault(_AlphaPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlphaPicker = exports.AlphaPicker = function AlphaPicker(_ref) {
	  var rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      direction = _ref.direction,
	      style = _ref.style,
	      renderers = _ref.renderers,
	      pointer = _ref.pointer,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        position: 'relative',
	        width: width,
	        height: height
	      },
	      alpha: {
	        radius: '2px',
	        style: style
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'alpha-picker ' + className },
	    _react2.default.createElement(_common.Alpha, _extends({}, styles.alpha, {
	      rgb: rgb,
	      hsl: hsl,
	      pointer: pointer,
	      renderers: renderers,
	      onChange: onChange,
	      direction: direction
	    }))
	  );
	};
	
	AlphaPicker.defaultProps = {
	  width: '316px',
	  height: '16px',
	  direction: 'horizontal',
	  pointer: _AlphaPointer2.default
	};
	
	exports.default = (0, _common.ColorWrap)(AlphaPicker);

/***/ },

/***/ "./node_modules/reactcss/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;
	
	var _flattenNames = __webpack_require__("./node_modules/reactcss/lib/flattenNames.js");
	
	var _flattenNames2 = _interopRequireDefault(_flattenNames);
	
	var _mergeClasses = __webpack_require__("./node_modules/reactcss/lib/mergeClasses.js");
	
	var _mergeClasses2 = _interopRequireDefault(_mergeClasses);
	
	var _autoprefix = __webpack_require__("./node_modules/reactcss/lib/autoprefix.js");
	
	var _autoprefix2 = _interopRequireDefault(_autoprefix);
	
	var _hover2 = __webpack_require__("./node_modules/reactcss/lib/components/hover.js");
	
	var _hover3 = _interopRequireDefault(_hover2);
	
	var _active = __webpack_require__("./node_modules/reactcss/lib/components/active.js");
	
	var _active2 = _interopRequireDefault(_active);
	
	var _loop2 = __webpack_require__("./node_modules/reactcss/lib/loop.js");
	
	var _loop3 = _interopRequireDefault(_loop2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.hover = _hover3.default;
	exports.handleHover = _hover3.default;
	exports.handleActive = _active2.default;
	exports.loop = _loop3.default;
	var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
	  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    activations[_key - 1] = arguments[_key];
	  }
	
	  var activeNames = (0, _flattenNames2.default)(activations);
	  var merged = (0, _mergeClasses2.default)(classes, activeNames);
	  return (0, _autoprefix2.default)(merged);
	};
	
	exports.default = ReactCSS;

/***/ },

/***/ "./node_modules/reactcss/lib/flattenNames.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.flattenNames = undefined;
	
	var _isString2 = __webpack_require__("./node_modules/lodash/isString.js");
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _forOwn2 = __webpack_require__("./node_modules/lodash/forOwn.js");
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _isPlainObject2 = __webpack_require__("./node_modules/lodash/isPlainObject.js");
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _map2 = __webpack_require__("./node_modules/lodash/map.js");
	
	var _map3 = _interopRequireDefault(_map2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var flattenNames = exports.flattenNames = function flattenNames() {
	  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var names = [];
	
	  (0, _map3.default)(things, function (thing) {
	    if (Array.isArray(thing)) {
	      flattenNames(thing).map(function (name) {
	        return names.push(name);
	      });
	    } else if ((0, _isPlainObject3.default)(thing)) {
	      (0, _forOwn3.default)(thing, function (value, key) {
	        value === true && names.push(key);
	        names.push(key + '-' + value);
	      });
	    } else if ((0, _isString3.default)(thing)) {
	      names.push(thing);
	    }
	  });
	
	  return names;
	};
	
	exports.default = flattenNames;

/***/ },

/***/ "./node_modules/lodash/isString.js":
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },

/***/ "./node_modules/lodash/forOwn.js":
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__("./node_modules/lodash/_baseForOwn.js"),
	    castFunction = __webpack_require__("./node_modules/lodash/_castFunction.js");
	
	/**
	 * Iterates over own enumerable string keyed properties of an object and
	 * invokes `iteratee` for each property. The iteratee is invoked with three
	 * arguments: (value, key, object). Iteratee functions may exit iteration
	 * early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forOwnRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forOwn(object, iteratee) {
	  return object && baseForOwn(object, castFunction(iteratee));
	}
	
	module.exports = forOwn;


/***/ },

/***/ "./node_modules/lodash/_baseForOwn.js":
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__("./node_modules/lodash/_baseFor.js"),
	    keys = __webpack_require__("./node_modules/lodash/keys.js");
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },

/***/ "./node_modules/lodash/_baseFor.js":
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__("./node_modules/lodash/_createBaseFor.js");
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },

/***/ "./node_modules/lodash/_createBaseFor.js":
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },

/***/ "./node_modules/lodash/_castFunction.js":
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__("./node_modules/lodash/identity.js");
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ },

/***/ "./node_modules/lodash/map.js":
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__("./node_modules/lodash/_arrayMap.js"),
	    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
	    baseMap = __webpack_require__("./node_modules/lodash/_baseMap.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js");
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },

/***/ "./node_modules/lodash/_baseIteratee.js":
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__("./node_modules/lodash/_baseMatches.js"),
	    baseMatchesProperty = __webpack_require__("./node_modules/lodash/_baseMatchesProperty.js"),
	    identity = __webpack_require__("./node_modules/lodash/identity.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    property = __webpack_require__("./node_modules/lodash/property.js");
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },

/***/ "./node_modules/lodash/_baseMatches.js":
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__("./node_modules/lodash/_baseIsMatch.js"),
	    getMatchData = __webpack_require__("./node_modules/lodash/_getMatchData.js"),
	    matchesStrictComparable = __webpack_require__("./node_modules/lodash/_matchesStrictComparable.js");
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },

/***/ "./node_modules/lodash/_baseIsMatch.js":
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__("./node_modules/lodash/_Stack.js"),
	    baseIsEqual = __webpack_require__("./node_modules/lodash/_baseIsEqual.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },

/***/ "./node_modules/lodash/_getMatchData.js":
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__("./node_modules/lodash/_isStrictComparable.js"),
	    keys = __webpack_require__("./node_modules/lodash/keys.js");
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },

/***/ "./node_modules/lodash/_isStrictComparable.js":
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/lodash/isObject.js");
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },

/***/ "./node_modules/lodash/_matchesStrictComparable.js":
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },

/***/ "./node_modules/lodash/_baseMatchesProperty.js":
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__("./node_modules/lodash/_baseIsEqual.js"),
	    get = __webpack_require__("./node_modules/lodash/get.js"),
	    hasIn = __webpack_require__("./node_modules/lodash/hasIn.js"),
	    isKey = __webpack_require__("./node_modules/lodash/_isKey.js"),
	    isStrictComparable = __webpack_require__("./node_modules/lodash/_isStrictComparable.js"),
	    matchesStrictComparable = __webpack_require__("./node_modules/lodash/_matchesStrictComparable.js"),
	    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },

/***/ "./node_modules/lodash/hasIn.js":
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__("./node_modules/lodash/_baseHasIn.js"),
	    hasPath = __webpack_require__("./node_modules/lodash/_hasPath.js");
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },

/***/ "./node_modules/lodash/_baseHasIn.js":
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },

/***/ "./node_modules/lodash/_hasPath.js":
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__("./node_modules/lodash/_castPath.js"),
	    isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js"),
	    isLength = __webpack_require__("./node_modules/lodash/isLength.js"),
	    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },

/***/ "./node_modules/lodash/property.js":
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__("./node_modules/lodash/_baseProperty.js"),
	    basePropertyDeep = __webpack_require__("./node_modules/lodash/_basePropertyDeep.js"),
	    isKey = __webpack_require__("./node_modules/lodash/_isKey.js"),
	    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },

/***/ "./node_modules/lodash/_baseProperty.js":
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },

/***/ "./node_modules/lodash/_basePropertyDeep.js":
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__("./node_modules/lodash/_baseGet.js");
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },

/***/ "./node_modules/lodash/_baseMap.js":
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__("./node_modules/lodash/_baseEach.js"),
	    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js");
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },

/***/ "./node_modules/lodash/_baseEach.js":
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__("./node_modules/lodash/_baseForOwn.js"),
	    createBaseEach = __webpack_require__("./node_modules/lodash/_createBaseEach.js");
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },

/***/ "./node_modules/lodash/_createBaseEach.js":
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js");
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },

/***/ "./node_modules/reactcss/lib/mergeClasses.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mergeClasses = undefined;
	
	var _forOwn2 = __webpack_require__("./node_modules/lodash/forOwn.js");
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _cloneDeep2 = __webpack_require__("./node_modules/lodash/cloneDeep.js");
	
	var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
	  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
	  activeNames.map(function (name) {
	    var toMerge = classes[name];
	    if (toMerge) {
	      (0, _forOwn3.default)(toMerge, function (value, key) {
	        if (!styles[key]) {
	          styles[key] = {};
	        }
	
	        styles[key] = _extends({}, styles[key], toMerge[key]);
	      });
	    }
	
	    return name;
	  });
	  return styles;
	};
	
	exports.default = mergeClasses;

/***/ },

/***/ "./node_modules/reactcss/lib/autoprefix.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.autoprefix = undefined;
	
	var _forOwn2 = __webpack_require__("./node_modules/lodash/forOwn.js");
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transforms = {
	  borderRadius: function borderRadius(value) {
	    return {
	      msBorderRadius: value,
	      MozBorderRadius: value,
	      OBorderRadius: value,
	      WebkitBorderRadius: value,
	      borderRadius: value
	    };
	  },
	  boxShadow: function boxShadow(value) {
	    return {
	      msBoxShadow: value,
	      MozBoxShadow: value,
	      OBoxShadow: value,
	      WebkitBoxShadow: value,
	      boxShadow: value
	    };
	  },
	  userSelect: function userSelect(value) {
	    return {
	      WebkitTouchCallout: value,
	      KhtmlUserSelect: value,
	      MozUserSelect: value,
	      msUserSelect: value,
	      WebkitUserSelect: value,
	      userSelect: value
	    };
	  },
	
	  flex: function flex(value) {
	    return {
	      WebkitBoxFlex: value,
	      MozBoxFlex: value,
	      WebkitFlex: value,
	      msFlex: value,
	      flex: value
	    };
	  },
	  flexBasis: function flexBasis(value) {
	    return {
	      WebkitFlexBasis: value,
	      flexBasis: value
	    };
	  },
	  justifyContent: function justifyContent(value) {
	    return {
	      WebkitJustifyContent: value,
	      justifyContent: value
	    };
	  },
	
	  transition: function transition(value) {
	    return {
	      msTransition: value,
	      MozTransition: value,
	      OTransition: value,
	      WebkitTransition: value,
	      transition: value
	    };
	  },
	
	  transform: function transform(value) {
	    return {
	      msTransform: value,
	      MozTransform: value,
	      OTransform: value,
	      WebkitTransform: value,
	      transform: value
	    };
	  },
	  absolute: function absolute(value) {
	    var direction = value && value.split(' ');
	    return {
	      position: 'absolute',
	      top: direction && direction[0],
	      right: direction && direction[1],
	      bottom: direction && direction[2],
	      left: direction && direction[3]
	    };
	  },
	  extend: function extend(name, otherElementStyles) {
	    var otherStyle = otherElementStyles[name];
	    if (otherStyle) {
	      return otherStyle;
	    }
	    return {
	      'extend': name
	    };
	  }
	};
	
	var autoprefix = exports.autoprefix = function autoprefix(elements) {
	  var prefixed = {};
	  (0, _forOwn3.default)(elements, function (styles, element) {
	    var expanded = {};
	    (0, _forOwn3.default)(styles, function (value, key) {
	      var transform = transforms[key];
	      if (transform) {
	        expanded = _extends({}, expanded, transform(value));
	      } else {
	        expanded[key] = value;
	      }
	    });
	    prefixed[element] = expanded;
	  });
	  return prefixed;
	};
	
	exports.default = autoprefix;

/***/ },

/***/ "./node_modules/reactcss/lib/components/hover.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hover = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hover = exports.hover = function hover(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	
	  return function (_React$Component) {
	    _inherits(Hover, _React$Component);
	
	    function Hover() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Hover);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
	        return _this.setState({ hover: true });
	      }, _this.handleMouseOut = function () {
	        return _this.setState({ hover: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Hover;
	  }(_react2.default.Component);
	};
	
	exports.default = hover;

/***/ },

/***/ "./node_modules/reactcss/lib/components/active.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.active = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var active = exports.active = function active(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	
	  return function (_React$Component) {
	    _inherits(Active, _React$Component);
	
	    function Active() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Active);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
	        return _this.setState({ active: true });
	      }, _this.handleMouseUp = function () {
	        return _this.setState({ active: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Active;
	  }(_react2.default.Component);
	};
	
	exports.default = active;

/***/ },

/***/ "./node_modules/reactcss/lib/loop.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var loopable = function loopable(i, length) {
	  var props = {};
	  var setProp = function setProp(name) {
	    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    props[name] = value;
	  };
	
	  i === 0 && setProp('first-child');
	  i === length - 1 && setProp('last-child');
	  (i === 0 || i % 2 === 0) && setProp('even');
	  Math.abs(i % 2) === 1 && setProp('odd');
	  setProp('nth-child', i);
	
	  return props;
	};
	
	exports.default = loopable;

/***/ },

/***/ "./node_modules/react-color/lib/components/common/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Alpha = __webpack_require__("./node_modules/react-color/lib/components/common/Alpha.js");
	
	Object.defineProperty(exports, 'Alpha', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Alpha).default;
	  }
	});
	
	var _Checkboard = __webpack_require__("./node_modules/react-color/lib/components/common/Checkboard.js");
	
	Object.defineProperty(exports, 'Checkboard', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkboard).default;
	  }
	});
	
	var _EditableInput = __webpack_require__("./node_modules/react-color/lib/components/common/EditableInput.js");
	
	Object.defineProperty(exports, 'EditableInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EditableInput).default;
	  }
	});
	
	var _Hue = __webpack_require__("./node_modules/react-color/lib/components/common/Hue.js");
	
	Object.defineProperty(exports, 'Hue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hue).default;
	  }
	});
	
	var _Raised = __webpack_require__("./node_modules/react-color/lib/components/common/Raised.js");
	
	Object.defineProperty(exports, 'Raised', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Raised).default;
	  }
	});
	
	var _Saturation = __webpack_require__("./node_modules/react-color/lib/components/common/Saturation.js");
	
	Object.defineProperty(exports, 'Saturation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Saturation).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__("./node_modules/react-color/lib/components/common/ColorWrap.js");
	
	Object.defineProperty(exports, 'ColorWrap', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	var _Swatch = __webpack_require__("./node_modules/react-color/lib/components/common/Swatch.js");
	
	Object.defineProperty(exports, 'Swatch', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Swatch).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },

/***/ "./node_modules/react-color/lib/components/common/Alpha.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Alpha = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _alpha = __webpack_require__("./node_modules/react-color/lib/helpers/alpha.js");
	
	var alpha = _interopRequireWildcard(_alpha);
	
	var _Checkboard = __webpack_require__("./node_modules/react-color/lib/components/common/Checkboard.js");
	
	var _Checkboard2 = _interopRequireDefault(_Checkboard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Alpha = exports.Alpha = function (_ref) {
	  _inherits(Alpha, _ref);
	
	  function Alpha() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Alpha);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e, skip) {
	      var change = alpha.calculateChange(e, skip, _this.props, _this.container);
	      change && _this.props.onChange && _this.props.onChange(change, e);
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleChange);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Alpha, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var rgb = this.props.rgb;
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          alpha: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius
	          },
	          checkboard: {
	            absolute: '0px 0px 0px 0px',
	            overflow: 'hidden'
	          },
	          gradient: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
	            boxShadow: this.props.shadow,
	            borderRadius: this.props.radius
	          },
	          container: {
	            position: 'relative',
	            height: '100%',
	            margin: '0 3px'
	          },
	          pointer: {
	            position: 'absolute',
	            left: rgb.a * 100 + '%'
	          },
	          slider: {
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            marginTop: '1px',
	            transform: 'translateX(-2px)'
	          }
	        },
	        'vertical': {
	          gradient: {
	            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
	          },
	          pointer: {
	            left: 0,
	            top: rgb.a * 100 + '%'
	          }
	        },
	        'overwrite': _extends({}, this.props.style)
	      }, {
	        vertical: this.props.direction === 'vertical',
	        overwrite: true
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.alpha },
	        _react2.default.createElement(
	          'div',
	          { style: styles.checkboard },
	          _react2.default.createElement(_Checkboard2.default, { renderers: this.props.renderers })
	        ),
	        _react2.default.createElement('div', { style: styles.gradient }),
	        _react2.default.createElement(
	          'div',
	          {
	            style: styles.container,
	            ref: function ref(container) {
	              return _this2.container = container;
	            },
	            onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange
	          },
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Alpha;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Alpha;

/***/ },

/***/ "./node_modules/react-color/lib/helpers/alpha.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
	  e.preventDefault();
	  var containerWidth = container.clientWidth;
	  var containerHeight = container.clientHeight;
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (props.direction === 'vertical') {
	    var a = void 0;
	    if (top < 0) {
	      a = 0;
	    } else if (top > containerHeight) {
	      a = 1;
	    } else {
	      a = Math.round(top * 100 / containerHeight) / 100;
	    }
	
	    if (props.hsl.a !== a) {
	      return {
	        h: props.hsl.h,
	        s: props.hsl.s,
	        l: props.hsl.l,
	        a: a,
	        source: 'rgb'
	      };
	    }
	  } else {
	    var _a = void 0;
	    if (left < 0) {
	      _a = 0;
	    } else if (left > containerWidth) {
	      _a = 1;
	    } else {
	      _a = Math.round(left * 100 / containerWidth) / 100;
	    }
	
	    if (props.a !== _a) {
	      return {
	        h: props.hsl.h,
	        s: props.hsl.s,
	        l: props.hsl.l,
	        a: _a,
	        source: 'rgb'
	      };
	    }
	  }
	  return null;
	};

/***/ },

/***/ "./node_modules/react-color/lib/components/common/Checkboard.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Checkboard = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _checkboard = __webpack_require__("./node_modules/react-color/lib/helpers/checkboard.js");
	
	var checkboard = _interopRequireWildcard(_checkboard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Checkboard = exports.Checkboard = function Checkboard(_ref) {
	  var white = _ref.white,
	      grey = _ref.grey,
	      size = _ref.size,
	      renderers = _ref.renderers,
	      borderRadius = _ref.borderRadius,
	      boxShadow = _ref.boxShadow;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      grid: {
	        borderRadius: borderRadius,
	        boxShadow: boxShadow,
	        absolute: '0px 0px 0px 0px',
	        background: 'url(' + checkboard.get(white, grey, size, renderers.canvas) + ') center left'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.grid });
	};
	
	Checkboard.defaultProps = {
	  size: 8,
	  white: 'transparent',
	  grey: 'rgba(0,0,0,.08)',
	  renderers: {}
	};
	
	exports.default = Checkboard;

/***/ },

/***/ "./node_modules/react-color/lib/helpers/checkboard.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var checkboardCache = {};
	
	var render = exports.render = function render(c1, c2, size, serverCanvas) {
	  if (typeof document === 'undefined' && !serverCanvas) {
	    return null;
	  }
	  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
	  canvas.width = size * 2;
	  canvas.height = size * 2;
	  var ctx = canvas.getContext('2d');
	  if (!ctx) {
	    return null;
	  } // If no context can be found, return early.
	  ctx.fillStyle = c1;
	  ctx.fillRect(0, 0, canvas.width, canvas.height);
	  ctx.fillStyle = c2;
	  ctx.fillRect(0, 0, size, size);
	  ctx.translate(size, size);
	  ctx.fillRect(0, 0, size, size);
	  return canvas.toDataURL();
	};
	
	var get = exports.get = function get(c1, c2, size, serverCanvas) {
	  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
	  var checkboard = render(c1, c2, size, serverCanvas);
	
	  if (checkboardCache[key]) {
	    return checkboardCache[key];
	  }
	  checkboardCache[key] = checkboard;
	  return checkboard;
	};

/***/ },

/***/ "./node_modules/react-color/lib/components/common/EditableInput.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EditableInput = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditableInput = exports.EditableInput = function (_ref) {
	  _inherits(EditableInput, _ref);
	
	  function EditableInput(props) {
	    _classCallCheck(this, EditableInput);
	
	    var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
	
	    _this.handleBlur = function () {
	      if (_this.state.blurValue) {
	        _this.setState({ value: _this.state.blurValue, blurValue: null });
	      }
	    };
	
	    _this.handleChange = function (e) {
	      if (_this.props.label) {
	        _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, e.target.value), e);
	      } else {
	        _this.props.onChange && _this.props.onChange(e.target.value, e);
	      }
	
	      _this.setState({ value: e.target.value });
	    };
	
	    _this.handleKeyDown = function (e) {
	      // In case `e.target.value` is a percentage remove the `%` character
	      // and update accordingly with a percentage
	      // https://github.com/casesandberg/react-color/issues/383
	      var stringValue = String(e.target.value);
	      var isPercentage = stringValue.indexOf('%') > -1;
	      var number = Number(stringValue.replace(/%/g, ''));
	      if (!isNaN(number)) {
	        var amount = _this.props.arrowOffset || 1;
	
	        // Up
	        if (e.keyCode === 38) {
	          if (_this.props.label !== null) {
	            _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, number + amount), e);
	          } else {
	            _this.props.onChange && _this.props.onChange(number + amount, e);
	          }
	
	          if (isPercentage) {
	            _this.setState({ value: number + amount + '%' });
	          } else {
	            _this.setState({ value: number + amount });
	          }
	        }
	
	        // Down
	        if (e.keyCode === 40) {
	          if (_this.props.label !== null) {
	            _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, number - amount), e);
	          } else {
	            _this.props.onChange && _this.props.onChange(number - amount, e);
	          }
	
	          if (isPercentage) {
	            _this.setState({ value: number - amount + '%' });
	          } else {
	            _this.setState({ value: number - amount });
	          }
	        }
	      }
	    };
	
	    _this.handleDrag = function (e) {
	      if (_this.props.dragLabel) {
	        var newValue = Math.round(_this.props.value + e.movementX);
	        if (newValue >= 0 && newValue <= _this.props.dragMax) {
	          _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, newValue), e);
	        }
	      }
	    };
	
	    _this.handleMouseDown = function (e) {
	      if (_this.props.dragLabel) {
	        e.preventDefault();
	        _this.handleDrag(e);
	        window.addEventListener('mousemove', _this.handleDrag);
	        window.addEventListener('mouseup', _this.handleMouseUp);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleDrag);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.state = {
	      value: String(props.value).toUpperCase(),
	      blurValue: String(props.value).toUpperCase()
	    };
	    return _this;
	  }
	
	  _createClass(EditableInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var input = this.input;
	      if (nextProps.value !== this.state.value) {
	        if (input === document.activeElement) {
	          this.setState({ blurValue: String(nextProps.value).toUpperCase() });
	        } else {
	          this.setState({ value: String(nextProps.value).toUpperCase() });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            position: 'relative'
	          }
	        },
	        'user-override': {
	          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
	          input: this.props.style && this.props.style.input ? this.props.style.input : {},
	          label: this.props.style && this.props.style.label ? this.props.style.label : {}
	        },
	        'dragLabel-true': {
	          label: {
	            cursor: 'ew-resize'
	          }
	        }
	      }, {
	        'user-override': true
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap },
	        _react2.default.createElement('input', {
	          style: styles.input,
	          ref: function ref(input) {
	            return _this2.input = input;
	          },
	          value: this.state.value,
	          onKeyDown: this.handleKeyDown,
	          onChange: this.handleChange,
	          onBlur: this.handleBlur,
	          placeholder: this.props.placeholder,
	          spellCheck: 'false'
	        }),
	        this.props.label ? _react2.default.createElement(
	          'span',
	          { style: styles.label, onMouseDown: this.handleMouseDown },
	          this.props.label
	        ) : null
	      );
	    }
	  }]);
	
	  return EditableInput;
	}(_react.PureComponent || _react.Component);
	
	exports.default = EditableInput;

/***/ },

/***/ "./node_modules/react-color/lib/components/common/Hue.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hue = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _hue = __webpack_require__("./node_modules/react-color/lib/helpers/hue.js");
	
	var hue = _interopRequireWildcard(_hue);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hue = exports.Hue = function (_ref) {
	  _inherits(Hue, _ref);
	
	  function Hue() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Hue);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e, skip) {
	      var change = hue.calculateChange(e, skip, _this.props, _this.container);
	      change && _this.props.onChange && _this.props.onChange(change, e);
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Hue, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$direction = this.props.direction,
	          direction = _props$direction === undefined ? 'horizontal' : _props$direction;
	
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          hue: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius,
	            boxShadow: this.props.shadow
	          },
	          container: {
	            padding: '0 2px',
	            position: 'relative',
	            height: '100%'
	          },
	          pointer: {
	            position: 'absolute',
	            left: this.props.hsl.h * 100 / 360 + '%'
	          },
	          slider: {
	            marginTop: '1px',
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            transform: 'translateX(-2px)'
	          }
	        },
	        'vertical': {
	          pointer: {
	            left: '0px',
	            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
	          }
	        }
	      }, { vertical: direction === 'vertical' });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.hue },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'hue-' + direction,
	            style: styles.container,
	            ref: function ref(container) {
	              return _this2.container = container;
	            },
	            onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange
	          },
	          _react2.default.createElement(
	            'style',
	            null,
	            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Hue;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Hue;

/***/ },

/***/ "./node_modules/react-color/lib/helpers/hue.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
	  e.preventDefault();
	  var containerWidth = container.clientWidth;
	  var containerHeight = container.clientHeight;
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (props.direction === 'vertical') {
	    var h = void 0;
	    if (top < 0) {
	      h = 359;
	    } else if (top > containerHeight) {
	      h = 0;
	    } else {
	      var percent = -(top * 100 / containerHeight) + 100;
	      h = 360 * percent / 100;
	    }
	
	    if (props.hsl.h !== h) {
	      return {
	        h: h,
	        s: props.hsl.s,
	        l: props.hsl.l,
	        a: props.hsl.a,
	        source: 'rgb'
	      };
	    }
	  } else {
	    var _h = void 0;
	    if (left < 0) {
	      _h = 0;
	    } else if (left > containerWidth) {
	      _h = 359;
	    } else {
	      var _percent = left * 100 / containerWidth;
	      _h = 360 * _percent / 100;
	    }
	
	    if (props.hsl.h !== _h) {
	      return {
	        h: _h,
	        s: props.hsl.s,
	        l: props.hsl.l,
	        a: props.hsl.a,
	        source: 'rgb'
	      };
	    }
	  }
	  return null;
	};

/***/ },

/***/ "./node_modules/react-color/lib/components/common/Raised.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Raised = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Raised = exports.Raised = function Raised(_ref) {
	  var zDepth = _ref.zDepth,
	      radius = _ref.radius,
	      background = _ref.background,
	      children = _ref.children;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      wrap: {
	        position: 'relative',
	        display: 'inline-block'
	      },
	      content: {
	        position: 'relative'
	      },
	      bg: {
	        absolute: '0px 0px 0px 0px',
	        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
	        borderRadius: radius,
	        background: background
	      }
	    },
	    'zDepth-0': {
	      bg: {
	        boxShadow: 'none'
	      }
	    },
	
	    'zDepth-1': {
	      bg: {
	        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
	      }
	    },
	    'zDepth-2': {
	      bg: {
	        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
	      }
	    },
	    'zDepth-3': {
	      bg: {
	        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
	      }
	    },
	    'zDepth-4': {
	      bg: {
	        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
	      }
	    },
	    'zDepth-5': {
	      bg: {
	        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
	      }
	    },
	    'square': {
	      bg: {
	        borderRadius: '0'
	      }
	    },
	    'circle': {
	      bg: {
	        borderRadius: '50%'
	      }
	    }
	  }, { 'zDepth-1': zDepth === 1 });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.wrap },
	    _react2.default.createElement('div', { style: styles.bg }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.content },
	      children
	    )
	  );
	};
	
	Raised.propTypes = {
	  background: _propTypes2.default.string,
	  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5]),
	  radius: _propTypes2.default.number
	};
	
	Raised.defaultProps = {
	  background: '#fff',
	  zDepth: 1,
	  radius: 2
	};
	
	exports.default = Raised;

/***/ },

/***/ "./node_modules/react-color/lib/components/common/Saturation.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Saturation = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _throttle = __webpack_require__("./node_modules/lodash/throttle.js");
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _saturation = __webpack_require__("./node_modules/react-color/lib/helpers/saturation.js");
	
	var saturation = _interopRequireWildcard(_saturation);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Saturation = exports.Saturation = function (_ref) {
	  _inherits(Saturation, _ref);
	
	  function Saturation(props) {
	    _classCallCheck(this, Saturation);
	
	    var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
	
	    _this.handleChange = function (e, skip) {
	      _this.props.onChange && _this.throttle(_this.props.onChange, saturation.calculateChange(e, skip, _this.props, _this.container), e);
	    };
	
	    _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
	      fn(data, e);
	    }, 50);
	    return _this;
	  }
	
	  _createClass(Saturation, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _ref2 = this.props.style || {},
	          color = _ref2.color,
	          white = _ref2.white,
	          black = _ref2.black,
	          pointer = _ref2.pointer,
	          circle = _ref2.circle;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          color: {
	            absolute: '0px 0px 0px 0px',
	            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
	            borderRadius: this.props.radius
	          },
	          white: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius
	          },
	          black: {
	            absolute: '0px 0px 0px 0px',
	            boxShadow: this.props.shadow,
	            borderRadius: this.props.radius
	          },
	          pointer: {
	            position: 'absolute',
	            top: -(this.props.hsv.v * 100) + 100 + '%',
	            left: this.props.hsv.s * 100 + '%',
	            cursor: 'default'
	          },
	          circle: {
	            width: '4px',
	            height: '4px',
	            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
	            borderRadius: '50%',
	            cursor: 'hand',
	            transform: 'translate(-2px, -2px)'
	          }
	        },
	        'custom': {
	          color: color,
	          white: white,
	          black: black,
	          pointer: pointer,
	          circle: circle
	        }
	      }, { 'custom': !!this.props.style });
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: styles.color,
	          ref: function ref(container) {
	            return _this2.container = container;
	          },
	          onMouseDown: this.handleMouseDown,
	          onTouchMove: this.handleChange,
	          onTouchStart: this.handleChange
	        },
	        _react2.default.createElement(
	          'style',
	          null,
	          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.white, className: 'saturation-white' },
	          _react2.default.createElement('div', { style: styles.black, className: 'saturation-black' }),
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.circle })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Saturation;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Saturation;

/***/ },

/***/ "./node_modules/lodash/throttle.js":
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__("./node_modules/lodash/debounce.js"),
	    isObject = __webpack_require__("./node_modules/lodash/isObject.js");
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },

/***/ "./node_modules/lodash/debounce.js":
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
	    now = __webpack_require__("./node_modules/lodash/now.js"),
	    toNumber = __webpack_require__("./node_modules/lodash/toNumber.js");
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },

/***/ "./node_modules/lodash/now.js":
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },

/***/ "./node_modules/lodash/toNumber.js":
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
	    isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },

/***/ "./node_modules/react-color/lib/helpers/saturation.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
	  e.preventDefault();
	
	  var _container$getBoundin = container.getBoundingClientRect(),
	      containerWidth = _container$getBoundin.width,
	      containerHeight = _container$getBoundin.height;
	
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (left < 0) {
	    left = 0;
	  } else if (left > containerWidth) {
	    left = containerWidth;
	  } else if (top < 0) {
	    top = 0;
	  } else if (top > containerHeight) {
	    top = containerHeight;
	  }
	
	  var saturation = left * 100 / containerWidth;
	  var bright = -(top * 100 / containerHeight) + 100;
	
	  return {
	    h: props.hsl.h,
	    s: saturation,
	    v: bright,
	    a: props.hsl.a,
	    source: 'rgb'
	  };
	};

/***/ },

/***/ "./node_modules/react-color/lib/components/common/ColorWrap.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorWrap = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _debounce = __webpack_require__("./node_modules/lodash/debounce.js");
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _color = __webpack_require__("./node_modules/react-color/lib/helpers/color.js");
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
	  var ColorPicker = function (_ref) {
	    _inherits(ColorPicker, _ref);
	
	    function ColorPicker(props) {
	      _classCallCheck(this, ColorPicker);
	
	      var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
	
	      _this.handleChange = function (data, event) {
	        var isValidColor = _color2.default.simpleCheckForValidColor(data);
	        if (isValidColor) {
	          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
	          _this.setState(colors);
	          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
	          _this.props.onChange && _this.props.onChange(colors, event);
	        }
	      };
	
	      _this.handleSwatchHover = function (data, event) {
	        var isValidColor = _color2.default.simpleCheckForValidColor(data);
	        if (isValidColor) {
	          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
	          _this.setState(colors);
	          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
	        }
	      };
	
	      _this.state = _extends({}, _color2.default.toState(props.color, 0));
	
	      _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
	        fn(data, event);
	      }, 100);
	      return _this;
	    }
	
	    _createClass(ColorPicker, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        this.setState(_extends({}, _color2.default.toState(nextProps.color, this.state.oldHue)));
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var optionalEvents = {};
	        if (this.props.onSwatchHover) {
	          optionalEvents.onSwatchHover = this.handleSwatchHover;
	        }
	
	        return _react2.default.createElement(Picker, _extends({}, this.props, this.state, {
	          onChange: this.handleChange
	        }, optionalEvents));
	      }
	    }]);
	
	    return ColorPicker;
	  }(_react.PureComponent || _react.Component);
	
	  ColorPicker.propTypes = _extends({}, Picker.propTypes);
	
	  ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
	    color: {
	      h: 250,
	      s: 0.50,
	      l: 0.20,
	      a: 1
	    }
	  });
	
	  return ColorPicker;
	};
	
	exports.default = ColorWrap;

/***/ },

/***/ "./node_modules/react-color/lib/helpers/color.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.red = undefined;
	
	var _each = __webpack_require__("./node_modules/lodash/each.js");
	
	var _each2 = _interopRequireDefault(_each);
	
	var _tinycolor = __webpack_require__("./node_modules/tinycolor2/cjs/tinycolor.js");
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  simpleCheckForValidColor: function simpleCheckForValidColor(data) {
	    var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
	    var checked = 0;
	    var passed = 0;
	    (0, _each2.default)(keysToCheck, function (letter) {
	      if (data[letter]) {
	        checked += 1;
	        if (!isNaN(data[letter])) {
	          passed += 1;
	        }
	      }
	    });
	    return checked === passed ? data : false;
	  },
	  toState: function toState(data, oldHue) {
	    var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
	    var hsl = color.toHsl();
	    var hsv = color.toHsv();
	    var rgb = color.toRgb();
	    var hex = color.toHex();
	    if (hsl.s === 0) {
	      hsl.h = oldHue || 0;
	      hsv.h = oldHue || 0;
	    }
	    var transparent = hex === '000000' && rgb.a === 0;
	
	    return {
	      hsl: hsl,
	      hex: transparent ? 'transparent' : '#' + hex,
	      rgb: rgb,
	      hsv: hsv,
	      oldHue: data.h || oldHue || hsl.h,
	      source: data.source
	    };
	  },
	  isValidHex: function isValidHex(hex) {
	    return (0, _tinycolor2.default)(hex).isValid();
	  }
	};
	var red = exports.red = {
	  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
	  hex: '#ff0000',
	  rgb: { r: 255, g: 0, b: 0, a: 1 },
	  hsv: { h: 0, s: 1, v: 1, a: 1 }
	};

/***/ },

/***/ "./node_modules/lodash/each.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__("./node_modules/lodash/forEach.js");


/***/ },

/***/ "./node_modules/lodash/forEach.js":
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__("./node_modules/lodash/_arrayEach.js"),
	    baseEach = __webpack_require__("./node_modules/lodash/_baseEach.js"),
	    castFunction = __webpack_require__("./node_modules/lodash/_castFunction.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js");
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ },

/***/ "./node_modules/tinycolor2/cjs/tinycolor.js":
/***/ function(module, exports, __webpack_require__) {

	// This file is autogenerated. It's used to publish CJS to npm.
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.tinycolor = factory());
	})(this, (function () { 'use strict';
	
	  function _typeof(obj) {
	    "@babel/helpers - typeof";
	
	    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	      return typeof obj;
	    } : function (obj) {
	      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    }, _typeof(obj);
	  }
	
	  // https://github.com/bgrins/TinyColor
	  // Brian Grinstead, MIT License
	
	  var trimLeft = /^\s+/;
	  var trimRight = /\s+$/;
	  function tinycolor(color, opts) {
	    color = color ? color : "";
	    opts = opts || {};
	
	    // If input is already a tinycolor, return itself
	    if (color instanceof tinycolor) {
	      return color;
	    }
	    // If we are called as a function, call using new instead
	    if (!(this instanceof tinycolor)) {
	      return new tinycolor(color, opts);
	    }
	    var rgb = inputToRGB(color);
	    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
	    this._gradientType = opts.gradientType;
	
	    // Don't let the range of [0,255] come back in [0,1].
	    // Potentially lose a little bit of precision here, but will fix issues where
	    // .5 gets interpreted as half of the total, instead of half of 1
	    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
	    if (this._r < 1) this._r = Math.round(this._r);
	    if (this._g < 1) this._g = Math.round(this._g);
	    if (this._b < 1) this._b = Math.round(this._b);
	    this._ok = rgb.ok;
	  }
	  tinycolor.prototype = {
	    isDark: function isDark() {
	      return this.getBrightness() < 128;
	    },
	    isLight: function isLight() {
	      return !this.isDark();
	    },
	    isValid: function isValid() {
	      return this._ok;
	    },
	    getOriginalInput: function getOriginalInput() {
	      return this._originalInput;
	    },
	    getFormat: function getFormat() {
	      return this._format;
	    },
	    getAlpha: function getAlpha() {
	      return this._a;
	    },
	    getBrightness: function getBrightness() {
	      //http://www.w3.org/TR/AERT#color-contrast
	      var rgb = this.toRgb();
	      return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
	    },
	    getLuminance: function getLuminance() {
	      //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
	      var rgb = this.toRgb();
	      var RsRGB, GsRGB, BsRGB, R, G, B;
	      RsRGB = rgb.r / 255;
	      GsRGB = rgb.g / 255;
	      BsRGB = rgb.b / 255;
	      if (RsRGB <= 0.03928) R = RsRGB / 12.92;else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
	      if (GsRGB <= 0.03928) G = GsRGB / 12.92;else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
	      if (BsRGB <= 0.03928) B = BsRGB / 12.92;else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
	      return 0.2126 * R + 0.7152 * G + 0.0722 * B;
	    },
	    setAlpha: function setAlpha(value) {
	      this._a = boundAlpha(value);
	      this._roundA = Math.round(100 * this._a) / 100;
	      return this;
	    },
	    toHsv: function toHsv() {
	      var hsv = rgbToHsv(this._r, this._g, this._b);
	      return {
	        h: hsv.h * 360,
	        s: hsv.s,
	        v: hsv.v,
	        a: this._a
	      };
	    },
	    toHsvString: function toHsvString() {
	      var hsv = rgbToHsv(this._r, this._g, this._b);
	      var h = Math.round(hsv.h * 360),
	        s = Math.round(hsv.s * 100),
	        v = Math.round(hsv.v * 100);
	      return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
	    },
	    toHsl: function toHsl() {
	      var hsl = rgbToHsl(this._r, this._g, this._b);
	      return {
	        h: hsl.h * 360,
	        s: hsl.s,
	        l: hsl.l,
	        a: this._a
	      };
	    },
	    toHslString: function toHslString() {
	      var hsl = rgbToHsl(this._r, this._g, this._b);
	      var h = Math.round(hsl.h * 360),
	        s = Math.round(hsl.s * 100),
	        l = Math.round(hsl.l * 100);
	      return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
	    },
	    toHex: function toHex(allow3Char) {
	      return rgbToHex(this._r, this._g, this._b, allow3Char);
	    },
	    toHexString: function toHexString(allow3Char) {
	      return "#" + this.toHex(allow3Char);
	    },
	    toHex8: function toHex8(allow4Char) {
	      return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
	    },
	    toHex8String: function toHex8String(allow4Char) {
	      return "#" + this.toHex8(allow4Char);
	    },
	    toRgb: function toRgb() {
	      return {
	        r: Math.round(this._r),
	        g: Math.round(this._g),
	        b: Math.round(this._b),
	        a: this._a
	      };
	    },
	    toRgbString: function toRgbString() {
	      return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
	    },
	    toPercentageRgb: function toPercentageRgb() {
	      return {
	        r: Math.round(bound01(this._r, 255) * 100) + "%",
	        g: Math.round(bound01(this._g, 255) * 100) + "%",
	        b: Math.round(bound01(this._b, 255) * 100) + "%",
	        a: this._a
	      };
	    },
	    toPercentageRgbString: function toPercentageRgbString() {
	      return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
	    },
	    toName: function toName() {
	      if (this._a === 0) {
	        return "transparent";
	      }
	      if (this._a < 1) {
	        return false;
	      }
	      return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
	    },
	    toFilter: function toFilter(secondColor) {
	      var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
	      var secondHex8String = hex8String;
	      var gradientType = this._gradientType ? "GradientType = 1, " : "";
	      if (secondColor) {
	        var s = tinycolor(secondColor);
	        secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
	      }
	      return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
	    },
	    toString: function toString(format) {
	      var formatSet = !!format;
	      format = format || this._format;
	      var formattedString = false;
	      var hasAlpha = this._a < 1 && this._a >= 0;
	      var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
	      if (needsAlphaFormat) {
	        // Special case for "transparent", all other non-alpha formats
	        // will return rgba when there is transparency.
	        if (format === "name" && this._a === 0) {
	          return this.toName();
	        }
	        return this.toRgbString();
	      }
	      if (format === "rgb") {
	        formattedString = this.toRgbString();
	      }
	      if (format === "prgb") {
	        formattedString = this.toPercentageRgbString();
	      }
	      if (format === "hex" || format === "hex6") {
	        formattedString = this.toHexString();
	      }
	      if (format === "hex3") {
	        formattedString = this.toHexString(true);
	      }
	      if (format === "hex4") {
	        formattedString = this.toHex8String(true);
	      }
	      if (format === "hex8") {
	        formattedString = this.toHex8String();
	      }
	      if (format === "name") {
	        formattedString = this.toName();
	      }
	      if (format === "hsl") {
	        formattedString = this.toHslString();
	      }
	      if (format === "hsv") {
	        formattedString = this.toHsvString();
	      }
	      return formattedString || this.toHexString();
	    },
	    clone: function clone() {
	      return tinycolor(this.toString());
	    },
	    _applyModification: function _applyModification(fn, args) {
	      var color = fn.apply(null, [this].concat([].slice.call(args)));
	      this._r = color._r;
	      this._g = color._g;
	      this._b = color._b;
	      this.setAlpha(color._a);
	      return this;
	    },
	    lighten: function lighten() {
	      return this._applyModification(_lighten, arguments);
	    },
	    brighten: function brighten() {
	      return this._applyModification(_brighten, arguments);
	    },
	    darken: function darken() {
	      return this._applyModification(_darken, arguments);
	    },
	    desaturate: function desaturate() {
	      return this._applyModification(_desaturate, arguments);
	    },
	    saturate: function saturate() {
	      return this._applyModification(_saturate, arguments);
	    },
	    greyscale: function greyscale() {
	      return this._applyModification(_greyscale, arguments);
	    },
	    spin: function spin() {
	      return this._applyModification(_spin, arguments);
	    },
	    _applyCombination: function _applyCombination(fn, args) {
	      return fn.apply(null, [this].concat([].slice.call(args)));
	    },
	    analogous: function analogous() {
	      return this._applyCombination(_analogous, arguments);
	    },
	    complement: function complement() {
	      return this._applyCombination(_complement, arguments);
	    },
	    monochromatic: function monochromatic() {
	      return this._applyCombination(_monochromatic, arguments);
	    },
	    splitcomplement: function splitcomplement() {
	      return this._applyCombination(_splitcomplement, arguments);
	    },
	    // Disabled until https://github.com/bgrins/TinyColor/issues/254
	    // polyad: function (number) {
	    //   return this._applyCombination(polyad, [number]);
	    // },
	    triad: function triad() {
	      return this._applyCombination(polyad, [3]);
	    },
	    tetrad: function tetrad() {
	      return this._applyCombination(polyad, [4]);
	    }
	  };
	
	  // If input is an object, force 1 into "1.0" to handle ratios properly
	  // String input requires "1.0" as input, so 1 will be treated as 1
	  tinycolor.fromRatio = function (color, opts) {
	    if (_typeof(color) == "object") {
	      var newColor = {};
	      for (var i in color) {
	        if (color.hasOwnProperty(i)) {
	          if (i === "a") {
	            newColor[i] = color[i];
	          } else {
	            newColor[i] = convertToPercentage(color[i]);
	          }
	        }
	      }
	      color = newColor;
	    }
	    return tinycolor(color, opts);
	  };
	
	  // Given a string or object, convert that input to RGB
	  // Possible string inputs:
	  //
	  //     "red"
	  //     "#f00" or "f00"
	  //     "#ff0000" or "ff0000"
	  //     "#ff000000" or "ff000000"
	  //     "rgb 255 0 0" or "rgb (255, 0, 0)"
	  //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
	  //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
	  //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
	  //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
	  //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
	  //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
	  //
	  function inputToRGB(color) {
	    var rgb = {
	      r: 0,
	      g: 0,
	      b: 0
	    };
	    var a = 1;
	    var s = null;
	    var v = null;
	    var l = null;
	    var ok = false;
	    var format = false;
	    if (typeof color == "string") {
	      color = stringInputToObject(color);
	    }
	    if (_typeof(color) == "object") {
	      if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
	        rgb = rgbToRgb(color.r, color.g, color.b);
	        ok = true;
	        format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
	      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
	        s = convertToPercentage(color.s);
	        v = convertToPercentage(color.v);
	        rgb = hsvToRgb(color.h, s, v);
	        ok = true;
	        format = "hsv";
	      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
	        s = convertToPercentage(color.s);
	        l = convertToPercentage(color.l);
	        rgb = hslToRgb(color.h, s, l);
	        ok = true;
	        format = "hsl";
	      }
	      if (color.hasOwnProperty("a")) {
	        a = color.a;
	      }
	    }
	    a = boundAlpha(a);
	    return {
	      ok: ok,
	      format: color.format || format,
	      r: Math.min(255, Math.max(rgb.r, 0)),
	      g: Math.min(255, Math.max(rgb.g, 0)),
	      b: Math.min(255, Math.max(rgb.b, 0)),
	      a: a
	    };
	  }
	
	  // Conversion Functions
	  // --------------------
	
	  // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
	  // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
	
	  // `rgbToRgb`
	  // Handle bounds / percentage checking to conform to CSS color spec
	  // <http://www.w3.org/TR/css3-color/>
	  // *Assumes:* r, g, b in [0, 255] or [0, 1]
	  // *Returns:* { r, g, b } in [0, 255]
	  function rgbToRgb(r, g, b) {
	    return {
	      r: bound01(r, 255) * 255,
	      g: bound01(g, 255) * 255,
	      b: bound01(b, 255) * 255
	    };
	  }
	
	  // `rgbToHsl`
	  // Converts an RGB color value to HSL.
	  // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
	  // *Returns:* { h, s, l } in [0,1]
	  function rgbToHsl(r, g, b) {
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	    var max = Math.max(r, g, b),
	      min = Math.min(r, g, b);
	    var h,
	      s,
	      l = (max + min) / 2;
	    if (max == min) {
	      h = s = 0; // achromatic
	    } else {
	      var d = max - min;
	      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	      switch (max) {
	        case r:
	          h = (g - b) / d + (g < b ? 6 : 0);
	          break;
	        case g:
	          h = (b - r) / d + 2;
	          break;
	        case b:
	          h = (r - g) / d + 4;
	          break;
	      }
	      h /= 6;
	    }
	    return {
	      h: h,
	      s: s,
	      l: l
	    };
	  }
	
	  // `hslToRgb`
	  // Converts an HSL color value to RGB.
	  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
	  // *Returns:* { r, g, b } in the set [0, 255]
	  function hslToRgb(h, s, l) {
	    var r, g, b;
	    h = bound01(h, 360);
	    s = bound01(s, 100);
	    l = bound01(l, 100);
	    function hue2rgb(p, q, t) {
	      if (t < 0) t += 1;
	      if (t > 1) t -= 1;
	      if (t < 1 / 6) return p + (q - p) * 6 * t;
	      if (t < 1 / 2) return q;
	      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	      return p;
	    }
	    if (s === 0) {
	      r = g = b = l; // achromatic
	    } else {
	      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	      var p = 2 * l - q;
	      r = hue2rgb(p, q, h + 1 / 3);
	      g = hue2rgb(p, q, h);
	      b = hue2rgb(p, q, h - 1 / 3);
	    }
	    return {
	      r: r * 255,
	      g: g * 255,
	      b: b * 255
	    };
	  }
	
	  // `rgbToHsv`
	  // Converts an RGB color value to HSV
	  // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	  // *Returns:* { h, s, v } in [0,1]
	  function rgbToHsv(r, g, b) {
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	    var max = Math.max(r, g, b),
	      min = Math.min(r, g, b);
	    var h,
	      s,
	      v = max;
	    var d = max - min;
	    s = max === 0 ? 0 : d / max;
	    if (max == min) {
	      h = 0; // achromatic
	    } else {
	      switch (max) {
	        case r:
	          h = (g - b) / d + (g < b ? 6 : 0);
	          break;
	        case g:
	          h = (b - r) / d + 2;
	          break;
	        case b:
	          h = (r - g) / d + 4;
	          break;
	      }
	      h /= 6;
	    }
	    return {
	      h: h,
	      s: s,
	      v: v
	    };
	  }
	
	  // `hsvToRgb`
	  // Converts an HSV color value to RGB.
	  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	  // *Returns:* { r, g, b } in the set [0, 255]
	  function hsvToRgb(h, s, v) {
	    h = bound01(h, 360) * 6;
	    s = bound01(s, 100);
	    v = bound01(v, 100);
	    var i = Math.floor(h),
	      f = h - i,
	      p = v * (1 - s),
	      q = v * (1 - f * s),
	      t = v * (1 - (1 - f) * s),
	      mod = i % 6,
	      r = [v, q, p, p, t, v][mod],
	      g = [t, v, v, q, p, p][mod],
	      b = [p, p, t, v, v, q][mod];
	    return {
	      r: r * 255,
	      g: g * 255,
	      b: b * 255
	    };
	  }
	
	  // `rgbToHex`
	  // Converts an RGB color to hex
	  // Assumes r, g, and b are contained in the set [0, 255]
	  // Returns a 3 or 6 character hex
	  function rgbToHex(r, g, b, allow3Char) {
	    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
	
	    // Return a 3 character hex if possible
	    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
	      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
	    }
	    return hex.join("");
	  }
	
	  // `rgbaToHex`
	  // Converts an RGBA color plus alpha transparency to hex
	  // Assumes r, g, b are contained in the set [0, 255] and
	  // a in [0, 1]. Returns a 4 or 8 character rgba hex
	  function rgbaToHex(r, g, b, a, allow4Char) {
	    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];
	
	    // Return a 4 character hex if possible
	    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
	      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
	    }
	    return hex.join("");
	  }
	
	  // `rgbaToArgbHex`
	  // Converts an RGBA color to an ARGB Hex8 string
	  // Rarely used, but required for "toFilter()"
	  function rgbaToArgbHex(r, g, b, a) {
	    var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
	    return hex.join("");
	  }
	
	  // `equals`
	  // Can be called with any tinycolor input
	  tinycolor.equals = function (color1, color2) {
	    if (!color1 || !color2) return false;
	    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
	  };
	  tinycolor.random = function () {
	    return tinycolor.fromRatio({
	      r: Math.random(),
	      g: Math.random(),
	      b: Math.random()
	    });
	  };
	
	  // Modification Functions
	  // ----------------------
	  // Thanks to less.js for some of the basics here
	  // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
	
	  function _desaturate(color, amount) {
	    amount = amount === 0 ? 0 : amount || 10;
	    var hsl = tinycolor(color).toHsl();
	    hsl.s -= amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	  }
	  function _saturate(color, amount) {
	    amount = amount === 0 ? 0 : amount || 10;
	    var hsl = tinycolor(color).toHsl();
	    hsl.s += amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	  }
	  function _greyscale(color) {
	    return tinycolor(color).desaturate(100);
	  }
	  function _lighten(color, amount) {
	    amount = amount === 0 ? 0 : amount || 10;
	    var hsl = tinycolor(color).toHsl();
	    hsl.l += amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	  }
	  function _brighten(color, amount) {
	    amount = amount === 0 ? 0 : amount || 10;
	    var rgb = tinycolor(color).toRgb();
	    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
	    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
	    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
	    return tinycolor(rgb);
	  }
	  function _darken(color, amount) {
	    amount = amount === 0 ? 0 : amount || 10;
	    var hsl = tinycolor(color).toHsl();
	    hsl.l -= amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	  }
	
	  // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
	  // Values outside of this range will be wrapped into this range.
	  function _spin(color, amount) {
	    var hsl = tinycolor(color).toHsl();
	    var hue = (hsl.h + amount) % 360;
	    hsl.h = hue < 0 ? 360 + hue : hue;
	    return tinycolor(hsl);
	  }
	
	  // Combination Functions
	  // ---------------------
	  // Thanks to jQuery xColor for some of the ideas behind these
	  // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
	
	  function _complement(color) {
	    var hsl = tinycolor(color).toHsl();
	    hsl.h = (hsl.h + 180) % 360;
	    return tinycolor(hsl);
	  }
	  function polyad(color, number) {
	    if (isNaN(number) || number <= 0) {
	      throw new Error("Argument to polyad must be a positive number");
	    }
	    var hsl = tinycolor(color).toHsl();
	    var result = [tinycolor(color)];
	    var step = 360 / number;
	    for (var i = 1; i < number; i++) {
	      result.push(tinycolor({
	        h: (hsl.h + i * step) % 360,
	        s: hsl.s,
	        l: hsl.l
	      }));
	    }
	    return result;
	  }
	  function _splitcomplement(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [tinycolor(color), tinycolor({
	      h: (h + 72) % 360,
	      s: hsl.s,
	      l: hsl.l
	    }), tinycolor({
	      h: (h + 216) % 360,
	      s: hsl.s,
	      l: hsl.l
	    })];
	  }
	  function _analogous(color, results, slices) {
	    results = results || 6;
	    slices = slices || 30;
	    var hsl = tinycolor(color).toHsl();
	    var part = 360 / slices;
	    var ret = [tinycolor(color)];
	    for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
	      hsl.h = (hsl.h + part) % 360;
	      ret.push(tinycolor(hsl));
	    }
	    return ret;
	  }
	  function _monochromatic(color, results) {
	    results = results || 6;
	    var hsv = tinycolor(color).toHsv();
	    var h = hsv.h,
	      s = hsv.s,
	      v = hsv.v;
	    var ret = [];
	    var modification = 1 / results;
	    while (results--) {
	      ret.push(tinycolor({
	        h: h,
	        s: s,
	        v: v
	      }));
	      v = (v + modification) % 1;
	    }
	    return ret;
	  }
	
	  // Utility Functions
	  // ---------------------
	
	  tinycolor.mix = function (color1, color2, amount) {
	    amount = amount === 0 ? 0 : amount || 50;
	    var rgb1 = tinycolor(color1).toRgb();
	    var rgb2 = tinycolor(color2).toRgb();
	    var p = amount / 100;
	    var rgba = {
	      r: (rgb2.r - rgb1.r) * p + rgb1.r,
	      g: (rgb2.g - rgb1.g) * p + rgb1.g,
	      b: (rgb2.b - rgb1.b) * p + rgb1.b,
	      a: (rgb2.a - rgb1.a) * p + rgb1.a
	    };
	    return tinycolor(rgba);
	  };
	
	  // Readability Functions
	  // ---------------------
	  // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
	
	  // `contrast`
	  // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
	  tinycolor.readability = function (color1, color2) {
	    var c1 = tinycolor(color1);
	    var c2 = tinycolor(color2);
	    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
	  };
	
	  // `isReadable`
	  // Ensure that foreground and background color combinations meet WCAG2 guidelines.
	  // The third argument is an optional Object.
	  //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
	  //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
	  // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
	
	  // *Example*
	  //    tinycolor.isReadable("#000", "#111") => false
	  //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
	  tinycolor.isReadable = function (color1, color2, wcag2) {
	    var readability = tinycolor.readability(color1, color2);
	    var wcag2Parms, out;
	    out = false;
	    wcag2Parms = validateWCAG2Parms(wcag2);
	    switch (wcag2Parms.level + wcag2Parms.size) {
	      case "AAsmall":
	      case "AAAlarge":
	        out = readability >= 4.5;
	        break;
	      case "AAlarge":
	        out = readability >= 3;
	        break;
	      case "AAAsmall":
	        out = readability >= 7;
	        break;
	    }
	    return out;
	  };
	
	  // `mostReadable`
	  // Given a base color and a list of possible foreground or background
	  // colors for that base, returns the most readable color.
	  // Optionally returns Black or White if the most readable color is unreadable.
	  // *Example*
	  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
	  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
	  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
	  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
	  tinycolor.mostReadable = function (baseColor, colorList, args) {
	    var bestColor = null;
	    var bestScore = 0;
	    var readability;
	    var includeFallbackColors, level, size;
	    args = args || {};
	    includeFallbackColors = args.includeFallbackColors;
	    level = args.level;
	    size = args.size;
	    for (var i = 0; i < colorList.length; i++) {
	      readability = tinycolor.readability(baseColor, colorList[i]);
	      if (readability > bestScore) {
	        bestScore = readability;
	        bestColor = tinycolor(colorList[i]);
	      }
	    }
	    if (tinycolor.isReadable(baseColor, bestColor, {
	      level: level,
	      size: size
	    }) || !includeFallbackColors) {
	      return bestColor;
	    } else {
	      args.includeFallbackColors = false;
	      return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
	    }
	  };
	
	  // Big List of Colors
	  // ------------------
	  // <https://www.w3.org/TR/css-color-4/#named-colors>
	  var names = tinycolor.names = {
	    aliceblue: "f0f8ff",
	    antiquewhite: "faebd7",
	    aqua: "0ff",
	    aquamarine: "7fffd4",
	    azure: "f0ffff",
	    beige: "f5f5dc",
	    bisque: "ffe4c4",
	    black: "000",
	    blanchedalmond: "ffebcd",
	    blue: "00f",
	    blueviolet: "8a2be2",
	    brown: "a52a2a",
	    burlywood: "deb887",
	    burntsienna: "ea7e5d",
	    cadetblue: "5f9ea0",
	    chartreuse: "7fff00",
	    chocolate: "d2691e",
	    coral: "ff7f50",
	    cornflowerblue: "6495ed",
	    cornsilk: "fff8dc",
	    crimson: "dc143c",
	    cyan: "0ff",
	    darkblue: "00008b",
	    darkcyan: "008b8b",
	    darkgoldenrod: "b8860b",
	    darkgray: "a9a9a9",
	    darkgreen: "006400",
	    darkgrey: "a9a9a9",
	    darkkhaki: "bdb76b",
	    darkmagenta: "8b008b",
	    darkolivegreen: "556b2f",
	    darkorange: "ff8c00",
	    darkorchid: "9932cc",
	    darkred: "8b0000",
	    darksalmon: "e9967a",
	    darkseagreen: "8fbc8f",
	    darkslateblue: "483d8b",
	    darkslategray: "2f4f4f",
	    darkslategrey: "2f4f4f",
	    darkturquoise: "00ced1",
	    darkviolet: "9400d3",
	    deeppink: "ff1493",
	    deepskyblue: "00bfff",
	    dimgray: "696969",
	    dimgrey: "696969",
	    dodgerblue: "1e90ff",
	    firebrick: "b22222",
	    floralwhite: "fffaf0",
	    forestgreen: "228b22",
	    fuchsia: "f0f",
	    gainsboro: "dcdcdc",
	    ghostwhite: "f8f8ff",
	    gold: "ffd700",
	    goldenrod: "daa520",
	    gray: "808080",
	    green: "008000",
	    greenyellow: "adff2f",
	    grey: "808080",
	    honeydew: "f0fff0",
	    hotpink: "ff69b4",
	    indianred: "cd5c5c",
	    indigo: "4b0082",
	    ivory: "fffff0",
	    khaki: "f0e68c",
	    lavender: "e6e6fa",
	    lavenderblush: "fff0f5",
	    lawngreen: "7cfc00",
	    lemonchiffon: "fffacd",
	    lightblue: "add8e6",
	    lightcoral: "f08080",
	    lightcyan: "e0ffff",
	    lightgoldenrodyellow: "fafad2",
	    lightgray: "d3d3d3",
	    lightgreen: "90ee90",
	    lightgrey: "d3d3d3",
	    lightpink: "ffb6c1",
	    lightsalmon: "ffa07a",
	    lightseagreen: "20b2aa",
	    lightskyblue: "87cefa",
	    lightslategray: "789",
	    lightslategrey: "789",
	    lightsteelblue: "b0c4de",
	    lightyellow: "ffffe0",
	    lime: "0f0",
	    limegreen: "32cd32",
	    linen: "faf0e6",
	    magenta: "f0f",
	    maroon: "800000",
	    mediumaquamarine: "66cdaa",
	    mediumblue: "0000cd",
	    mediumorchid: "ba55d3",
	    mediumpurple: "9370db",
	    mediumseagreen: "3cb371",
	    mediumslateblue: "7b68ee",
	    mediumspringgreen: "00fa9a",
	    mediumturquoise: "48d1cc",
	    mediumvioletred: "c71585",
	    midnightblue: "191970",
	    mintcream: "f5fffa",
	    mistyrose: "ffe4e1",
	    moccasin: "ffe4b5",
	    navajowhite: "ffdead",
	    navy: "000080",
	    oldlace: "fdf5e6",
	    olive: "808000",
	    olivedrab: "6b8e23",
	    orange: "ffa500",
	    orangered: "ff4500",
	    orchid: "da70d6",
	    palegoldenrod: "eee8aa",
	    palegreen: "98fb98",
	    paleturquoise: "afeeee",
	    palevioletred: "db7093",
	    papayawhip: "ffefd5",
	    peachpuff: "ffdab9",
	    peru: "cd853f",
	    pink: "ffc0cb",
	    plum: "dda0dd",
	    powderblue: "b0e0e6",
	    purple: "800080",
	    rebeccapurple: "663399",
	    red: "f00",
	    rosybrown: "bc8f8f",
	    royalblue: "4169e1",
	    saddlebrown: "8b4513",
	    salmon: "fa8072",
	    sandybrown: "f4a460",
	    seagreen: "2e8b57",
	    seashell: "fff5ee",
	    sienna: "a0522d",
	    silver: "c0c0c0",
	    skyblue: "87ceeb",
	    slateblue: "6a5acd",
	    slategray: "708090",
	    slategrey: "708090",
	    snow: "fffafa",
	    springgreen: "00ff7f",
	    steelblue: "4682b4",
	    tan: "d2b48c",
	    teal: "008080",
	    thistle: "d8bfd8",
	    tomato: "ff6347",
	    turquoise: "40e0d0",
	    violet: "ee82ee",
	    wheat: "f5deb3",
	    white: "fff",
	    whitesmoke: "f5f5f5",
	    yellow: "ff0",
	    yellowgreen: "9acd32"
	  };
	
	  // Make it easy to access colors via `hexNames[hex]`
	  var hexNames = tinycolor.hexNames = flip(names);
	
	  // Utilities
	  // ---------
	
	  // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
	  function flip(o) {
	    var flipped = {};
	    for (var i in o) {
	      if (o.hasOwnProperty(i)) {
	        flipped[o[i]] = i;
	      }
	    }
	    return flipped;
	  }
	
	  // Return a valid alpha value [0,1] with all invalid values being set to 1
	  function boundAlpha(a) {
	    a = parseFloat(a);
	    if (isNaN(a) || a < 0 || a > 1) {
	      a = 1;
	    }
	    return a;
	  }
	
	  // Take input from [0, n] and return it as [0, 1]
	  function bound01(n, max) {
	    if (isOnePointZero(n)) n = "100%";
	    var processPercent = isPercentage(n);
	    n = Math.min(max, Math.max(0, parseFloat(n)));
	
	    // Automatically convert percentage into number
	    if (processPercent) {
	      n = parseInt(n * max, 10) / 100;
	    }
	
	    // Handle floating point rounding errors
	    if (Math.abs(n - max) < 0.000001) {
	      return 1;
	    }
	
	    // Convert into [0, 1] range if it isn't already
	    return n % max / parseFloat(max);
	  }
	
	  // Force a number between 0 and 1
	  function clamp01(val) {
	    return Math.min(1, Math.max(0, val));
	  }
	
	  // Parse a base-16 hex value into a base-10 integer
	  function parseIntFromHex(val) {
	    return parseInt(val, 16);
	  }
	
	  // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	  // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	  function isOnePointZero(n) {
	    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
	  }
	
	  // Check to see if string passed in is a percentage
	  function isPercentage(n) {
	    return typeof n === "string" && n.indexOf("%") != -1;
	  }
	
	  // Force a hex value to have 2 characters
	  function pad2(c) {
	    return c.length == 1 ? "0" + c : "" + c;
	  }
	
	  // Replace a decimal with it's percentage value
	  function convertToPercentage(n) {
	    if (n <= 1) {
	      n = n * 100 + "%";
	    }
	    return n;
	  }
	
	  // Converts a decimal to a hex value
	  function convertDecimalToHex(d) {
	    return Math.round(parseFloat(d) * 255).toString(16);
	  }
	  // Converts a hex value to a decimal
	  function convertHexToDecimal(h) {
	    return parseIntFromHex(h) / 255;
	  }
	  var matchers = function () {
	    // <http://www.w3.org/TR/css3-values/#integers>
	    var CSS_INTEGER = "[-\\+]?\\d+%?";
	
	    // <http://www.w3.org/TR/css3-values/#number-value>
	    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
	
	    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
	    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
	
	    // Actual matching.
	    // Parentheses and commas are optional, but not required.
	    // Whitespace can take the place of commas or opening paren
	    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	    return {
	      CSS_UNIT: new RegExp(CSS_UNIT),
	      rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
	      rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
	      hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
	      hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
	      hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
	      hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
	      hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	      hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
	      hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	      hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
	    };
	  }();
	
	  // `isValidCSSUnit`
	  // Take in a single string / number and check to see if it looks like a CSS unit
	  // (see `matchers` above for definition).
	  function isValidCSSUnit(color) {
	    return !!matchers.CSS_UNIT.exec(color);
	  }
	
	  // `stringInputToObject`
	  // Permissive string parsing.  Take in a number of formats, and output an object
	  // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
	  function stringInputToObject(color) {
	    color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
	    var named = false;
	    if (names[color]) {
	      color = names[color];
	      named = true;
	    } else if (color == "transparent") {
	      return {
	        r: 0,
	        g: 0,
	        b: 0,
	        a: 0,
	        format: "name"
	      };
	    }
	
	    // Try to match string input using regular expressions.
	    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
	    // Just return an object and let the conversion functions handle that.
	    // This way the result will be the same whether the tinycolor is initialized with string or object.
	    var match;
	    if (match = matchers.rgb.exec(color)) {
	      return {
	        r: match[1],
	        g: match[2],
	        b: match[3]
	      };
	    }
	    if (match = matchers.rgba.exec(color)) {
	      return {
	        r: match[1],
	        g: match[2],
	        b: match[3],
	        a: match[4]
	      };
	    }
	    if (match = matchers.hsl.exec(color)) {
	      return {
	        h: match[1],
	        s: match[2],
	        l: match[3]
	      };
	    }
	    if (match = matchers.hsla.exec(color)) {
	      return {
	        h: match[1],
	        s: match[2],
	        l: match[3],
	        a: match[4]
	      };
	    }
	    if (match = matchers.hsv.exec(color)) {
	      return {
	        h: match[1],
	        s: match[2],
	        v: match[3]
	      };
	    }
	    if (match = matchers.hsva.exec(color)) {
	      return {
	        h: match[1],
	        s: match[2],
	        v: match[3],
	        a: match[4]
	      };
	    }
	    if (match = matchers.hex8.exec(color)) {
	      return {
	        r: parseIntFromHex(match[1]),
	        g: parseIntFromHex(match[2]),
	        b: parseIntFromHex(match[3]),
	        a: convertHexToDecimal(match[4]),
	        format: named ? "name" : "hex8"
	      };
	    }
	    if (match = matchers.hex6.exec(color)) {
	      return {
	        r: parseIntFromHex(match[1]),
	        g: parseIntFromHex(match[2]),
	        b: parseIntFromHex(match[3]),
	        format: named ? "name" : "hex"
	      };
	    }
	    if (match = matchers.hex4.exec(color)) {
	      return {
	        r: parseIntFromHex(match[1] + "" + match[1]),
	        g: parseIntFromHex(match[2] + "" + match[2]),
	        b: parseIntFromHex(match[3] + "" + match[3]),
	        a: convertHexToDecimal(match[4] + "" + match[4]),
	        format: named ? "name" : "hex8"
	      };
	    }
	    if (match = matchers.hex3.exec(color)) {
	      return {
	        r: parseIntFromHex(match[1] + "" + match[1]),
	        g: parseIntFromHex(match[2] + "" + match[2]),
	        b: parseIntFromHex(match[3] + "" + match[3]),
	        format: named ? "name" : "hex"
	      };
	    }
	    return false;
	  }
	  function validateWCAG2Parms(parms) {
	    // return valid WCAG2 parms for isReadable.
	    // If input parms are invalid, return {"level":"AA", "size":"small"}
	    var level, size;
	    parms = parms || {
	      level: "AA",
	      size: "small"
	    };
	    level = (parms.level || "AA").toUpperCase();
	    size = (parms.size || "small").toLowerCase();
	    if (level !== "AA" && level !== "AAA") {
	      level = "AA";
	    }
	    if (size !== "small" && size !== "large") {
	      size = "small";
	    }
	    return {
	      level: level,
	      size: size
	    };
	  }
	
	  return tinycolor;
	
	}));


/***/ },

/***/ "./node_modules/react-color/lib/components/common/Swatch.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Swatch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _interaction = __webpack_require__("./node_modules/react-color/lib/helpers/interaction.js");
	
	var _ = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ENTER = 13;
	
	var Swatch = exports.Swatch = function Swatch(_ref) {
	  var color = _ref.color,
	      style = _ref.style,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onHover = _ref.onHover,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? color : _ref$title,
	      children = _ref.children,
	      focus = _ref.focus,
	      _ref$focusStyle = _ref.focusStyle,
	      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
	
	  var transparent = color === 'transparent';
	  var styles = (0, _reactcss2.default)({
	    default: {
	      swatch: _extends({
	        background: color,
	        height: '100%',
	        width: '100%',
	        cursor: 'pointer',
	        position: 'relative',
	        outline: 'none'
	      }, style, focus ? focusStyle : {})
	    }
	  });
	
	  var handleClick = function handleClick(e) {
	    return onClick(color, e);
	  };
	  var handleKeyDown = function handleKeyDown(e) {
	    return e.keyCode === ENTER && onClick(color, e);
	  };
	  var handleHover = function handleHover(e) {
	    return onHover(color, e);
	  };
	
	  var optionalEvents = {};
	  if (onHover) {
	    optionalEvents.onMouseOver = handleHover;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    _extends({
	      style: styles.swatch,
	      onClick: handleClick,
	      title: title,
	      tabIndex: 0,
	      onKeyDown: handleKeyDown
	    }, optionalEvents),
	    children,
	    transparent && _react2.default.createElement(_.Checkboard, {
	      borderRadius: styles.swatch.borderRadius,
	      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
	    })
	  );
	};
	
	exports.default = (0, _interaction.handleFocus)(Swatch);

/***/ },

/***/ "./node_modules/react-color/lib/helpers/interaction.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleFocus = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-invalid-this */
	
	
	var handleFocus = exports.handleFocus = function handleFocus(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	  return function (_React$Component) {
	    _inherits(Focus, _React$Component);
	
	    function Focus() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Focus);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
	        return _this.setState({ focus: true });
	      }, _this.handleBlur = function () {
	        return _this.setState({ focus: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onFocus: _this.handleFocus, onBlur: _this.handleBlur },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Focus;
	  }(_react2.default.Component);
	};

/***/ },

/***/ "./node_modules/react-color/lib/components/alpha/AlphaPointer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlphaPointer = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlphaPointer = exports.AlphaPointer = function AlphaPointer(_ref) {
	  var direction = _ref.direction;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '18px',
	        height: '18px',
	        borderRadius: '50%',
	        transform: 'translate(-9px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    },
	    'vertical': {
	      picker: {
	        transform: 'translate(-3px, -9px)'
	      }
	    }
	  }, { vertical: direction === 'vertical' });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = AlphaPointer;

/***/ },

/***/ "./node_modules/react-color/lib/components/block/Block.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Block = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__("./node_modules/react-color/lib/helpers/color.js");
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	var _BlockSwatches = __webpack_require__("./node_modules/react-color/lib/components/block/BlockSwatches.js");
	
	var _BlockSwatches2 = _interopRequireDefault(_BlockSwatches);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Block = exports.Block = function Block(_ref) {
	  var onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      hex = _ref.hex,
	      colors = _ref.colors,
	      width = _ref.width,
	      triangle = _ref.triangle,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var transparent = hex === 'transparent';
	  var handleChange = function handleChange(hexCode, e) {
	    _color2.default.isValidHex(hexCode) && onChange({
	      hex: hexCode,
	      source: 'hex'
	    }, e);
	  };
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        boxShadow: '0 1px rgba(0,0,0,.1)',
	        borderRadius: '6px',
	        position: 'relative'
	      },
	      head: {
	        height: '110px',
	        background: hex,
	        borderRadius: '6px 6px 0 0',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center',
	        position: 'relative'
	      },
	      body: {
	        padding: '10px'
	      },
	      label: {
	        fontSize: '18px',
	        color: transparent ? 'rgba(0,0,0,0.4)' : '#fff',
	        position: 'relative'
	      },
	      triangle: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 10px 10px 10px',
	        borderColor: 'transparent transparent ' + hex + ' transparent',
	        position: 'absolute',
	        top: '-10px',
	        left: '50%',
	        marginLeft: '-10px'
	      },
	      input: {
	        width: '100%',
	        fontSize: '12px',
	        color: '#666',
	        border: '0px',
	        outline: 'none',
	        height: '22px',
	        boxShadow: 'inset 0 0 0 1px #ddd',
	        borderRadius: '4px',
	        padding: '0 7px',
	        boxSizing: 'border-box'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      }
	    }
	  }, { 'hide-triangle': triangle === 'hide' });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'block-picker ' + className },
	    _react2.default.createElement('div', { style: styles.triangle }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.head },
	      transparent && _react2.default.createElement(_common.Checkboard, { borderRadius: '6px 6px 0 0' }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.label },
	        hex
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      _react2.default.createElement(_BlockSwatches2.default, { colors: colors, onClick: handleChange, onSwatchHover: onSwatchHover }),
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input },
	        value: hex,
	        onChange: handleChange
	      })
	    )
	  );
	};
	
	Block.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  triangle: _propTypes2.default.oneOf(['top', 'hide'])
	};
	
	Block.defaultProps = {
	  width: 170,
	  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
	  triangle: 'top'
	};
	
	exports.default = (0, _common.ColorWrap)(Block);

/***/ },

/***/ "./node_modules/react-color/lib/components/block/BlockSwatches.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BlockSwatches = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__("./node_modules/lodash/map.js");
	
	var _map2 = _interopRequireDefault(_map);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlockSwatches = exports.BlockSwatches = function BlockSwatches(_ref) {
	  var colors = _ref.colors,
	      onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        marginRight: '-10px'
	      },
	      swatch: {
	        width: '22px',
	        height: '22px',
	        float: 'left',
	        marginRight: '10px',
	        marginBottom: '10px',
	        borderRadius: '4px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatches },
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_common.Swatch, {
	        key: c,
	        color: c,
	        style: styles.swatch,
	        onClick: onClick,
	        onHover: onSwatchHover,
	        focusStyle: {
	          boxShadow: '0 0 4px ' + c
	        }
	      });
	    }),
	    _react2.default.createElement('div', { style: styles.clear })
	  );
	};
	
	exports.default = BlockSwatches;

/***/ },

/***/ "./node_modules/react-color/lib/components/circle/Circle.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Circle = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__("./node_modules/lodash/map.js");
	
	var _map2 = _interopRequireDefault(_map);
	
	var _materialColors = __webpack_require__("./node_modules/material-colors/dist/colors.js");
	
	var material = _interopRequireWildcard(_materialColors);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	var _CircleSwatch = __webpack_require__("./node_modules/react-color/lib/components/circle/CircleSwatch.js");
	
	var _CircleSwatch2 = _interopRequireDefault(_CircleSwatch);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Circle = exports.Circle = function Circle(_ref) {
	  var width = _ref.width,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      circleSize = _ref.circleSize,
	      circleSpacing = _ref.circleSpacing,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      card: {
	        width: width,
	        display: 'flex',
	        flexWrap: 'wrap',
	        marginRight: -circleSpacing,
	        marginBottom: -circleSpacing
	      }
	    }
	  });
	
	  var handleChange = function handleChange(hexCode, e) {
	    return onChange({ hex: hexCode, source: 'hex' }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'circle-picker ' + className },
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_CircleSwatch2.default, {
	        key: c,
	        color: c,
	        onClick: handleChange,
	        onSwatchHover: onSwatchHover,
	        active: hex === c.toLowerCase(),
	        circleSize: circleSize,
	        circleSpacing: circleSpacing
	      });
	    })
	  );
	};
	
	Circle.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  circleSize: _propTypes2.default.number,
	  circleSpacing: _propTypes2.default.number
	};
	
	Circle.defaultProps = {
	  width: 252,
	  circleSize: 28,
	  circleSpacing: 14,
	  colors: [material.red['500'], material.pink['500'], material.purple['500'], material.deepPurple['500'], material.indigo['500'], material.blue['500'], material.lightBlue['500'], material.cyan['500'], material.teal['500'], material.green['500'], material.lightGreen['500'], material.lime['500'], material.yellow['500'], material.amber['500'], material.orange['500'], material.deepOrange['500'], material.brown['500'], material.blueGrey['500']]
	};
	
	exports.default = (0, _common.ColorWrap)(Circle);

/***/ },

/***/ "./node_modules/material-colors/dist/colors.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.materialColors = factory();
	  }
	})(this, function() {
	  return {"red":{"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"},"pink":{"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"},"purple":{"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"},"deepPurple":{"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"},"indigo":{"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"},"blue":{"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"},"lightBlue":{"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"},"cyan":{"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"},"teal":{"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"},"green":{"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"},"lightGreen":{"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"},"lime":{"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"},"yellow":{"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"},"amber":{"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"},"orange":{"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"},"deepOrange":{"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"},"brown":{"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"},"grey":{"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"},"blueGrey":{"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"},"darkText":{"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"},"lightText":{"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"},"darkIcons":{"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"},"lightIcons":{"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"},"white":"#ffffff","black":"#000000"};
	});


/***/ },

/***/ "./node_modules/react-color/lib/components/circle/CircleSwatch.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CircleSwatch = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleSwatch = exports.CircleSwatch = function CircleSwatch(_ref) {
	  var color = _ref.color,
	      onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      hover = _ref.hover,
	      active = _ref.active,
	      circleSize = _ref.circleSize,
	      circleSpacing = _ref.circleSpacing;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        width: circleSize,
	        height: circleSize,
	        marginRight: circleSpacing,
	        marginBottom: circleSpacing,
	        transform: 'scale(1)',
	        transition: '100ms transform ease'
	      },
	      Swatch: {
	        borderRadius: '50%',
	        background: 'transparent',
	        boxShadow: 'inset 0 0 0 ' + circleSize / 2 + 'px ' + color,
	        transition: '100ms box-shadow ease'
	      }
	    },
	    'hover': {
	      swatch: {
	        transform: 'scale(1.2)'
	      }
	    },
	    'active': {
	      Swatch: {
	        boxShadow: 'inset 0 0 0 3px ' + color
	      }
	    }
	  }, { hover: hover, active: active });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatch },
	    _react2.default.createElement(_common.Swatch, {
	      style: styles.Swatch,
	      color: color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
	    })
	  );
	};
	
	CircleSwatch.defaultProps = {
	  circleSize: 28,
	  circleSpacing: 14
	};
	
	exports.default = (0, _reactcss.handleHover)(CircleSwatch);

/***/ },

/***/ "./node_modules/react-color/lib/components/chrome/Chrome.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Chrome = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	var _ChromeFields = __webpack_require__("./node_modules/react-color/lib/components/chrome/ChromeFields.js");
	
	var _ChromeFields2 = _interopRequireDefault(_ChromeFields);
	
	var _ChromePointer = __webpack_require__("./node_modules/react-color/lib/components/chrome/ChromePointer.js");
	
	var _ChromePointer2 = _interopRequireDefault(_ChromePointer);
	
	var _ChromePointerCircle = __webpack_require__("./node_modules/react-color/lib/components/chrome/ChromePointerCircle.js");
	
	var _ChromePointerCircle2 = _interopRequireDefault(_ChromePointerCircle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chrome = exports.Chrome = function Chrome(_ref) {
	  var onChange = _ref.onChange,
	      disableAlpha = _ref.disableAlpha,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hsv = _ref.hsv,
	      hex = _ref.hex,
	      renderers = _ref.renderers,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        background: '#fff',
	        borderRadius: '2px',
	        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
	        boxSizing: 'initial',
	        width: '225px',
	        fontFamily: 'Menlo'
	      },
	      saturation: {
	        width: '100%',
	        paddingBottom: '55%',
	        position: 'relative',
	        borderRadius: '2px 2px 0 0',
	        overflow: 'hidden'
	      },
	      Saturation: {
	        radius: '2px 2px 0 0'
	      },
	      body: {
	        padding: '16px 16px 12px'
	      },
	      controls: {
	        display: 'flex'
	      },
	      color: {
	        width: '32px'
	      },
	      swatch: {
	        marginTop: '6px',
	        width: '16px',
	        height: '16px',
	        borderRadius: '8px',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      active: {
	        absolute: '0px 0px 0px 0px',
	        borderRadius: '8px',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
	        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
	        zIndex: '2'
	      },
	      toggles: {
	        flex: '1'
	      },
	      hue: {
	        height: '10px',
	        position: 'relative',
	        marginBottom: '8px'
	      },
	      Hue: {
	        radius: '2px'
	      },
	      alpha: {
	        height: '10px',
	        position: 'relative'
	      },
	      Alpha: {
	        radius: '2px'
	      }
	    },
	    'disableAlpha': {
	      color: {
	        width: '22px'
	      },
	      alpha: {
	        display: 'none'
	      },
	      hue: {
	        marginBottom: '0px'
	      },
	      swatch: {
	        width: '10px',
	        height: '10px',
	        marginTop: '0px'
	      }
	    }
	  }, { disableAlpha: disableAlpha });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'chrome-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.saturation },
	      _react2.default.createElement(_common.Saturation, {
	        style: styles.Saturation,
	        hsl: hsl,
	        hsv: hsv,
	        pointer: _ChromePointerCircle2.default,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      _react2.default.createElement(
	        'div',
	        { style: styles.controls, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.color },
	          _react2.default.createElement(
	            'div',
	            { style: styles.swatch },
	            _react2.default.createElement('div', { style: styles.active }),
	            _react2.default.createElement(_common.Checkboard, { renderers: renderers })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.toggles },
	          _react2.default.createElement(
	            'div',
	            { style: styles.hue },
	            _react2.default.createElement(_common.Hue, {
	              style: styles.Hue,
	              hsl: hsl,
	              pointer: _ChromePointer2.default,
	              onChange: onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.Alpha, {
	              style: styles.Alpha,
	              rgb: rgb,
	              hsl: hsl,
	              pointer: _ChromePointer2.default,
	              renderers: renderers,
	              onChange: onChange
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(_ChromeFields2.default, {
	        rgb: rgb,
	        hsl: hsl,
	        hex: hex,
	        onChange: onChange,
	        disableAlpha: disableAlpha
	      })
	    )
	  );
	};
	
	Chrome.propTypes = {
	  disableAlpha: _propTypes2.default.bool
	};
	
	Chrome.defaultProps = {
	  disableAlpha: false
	};
	
	exports.default = (0, _common.ColorWrap)(Chrome);

/***/ },

/***/ "./node_modules/react-color/lib/components/chrome/ChromeFields.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromeFields = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__("./node_modules/react-color/lib/helpers/color.js");
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-did-mount-set-state, no-param-reassign */
	
	var ChromeFields = exports.ChromeFields = function (_React$Component) {
	  _inherits(ChromeFields, _React$Component);
	
	  function ChromeFields() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChromeFields);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      view: ''
	    }, _this.toggleViews = function () {
	      if (_this.state.view === 'hex') {
	        _this.setState({ view: 'rgb' });
	      } else if (_this.state.view === 'rgb') {
	        _this.setState({ view: 'hsl' });
	      } else if (_this.state.view === 'hsl') {
	        if (_this.props.hsl.a === 1) {
	          _this.setState({ view: 'hex' });
	        } else {
	          _this.setState({ view: 'rgb' });
	        }
	      }
	    }, _this.handleChange = function (data, e) {
	      if (data.hex) {
	        _color2.default.isValidHex(data.hex) && _this.props.onChange({
	          hex: data.hex,
	          source: 'hex'
	        }, e);
	      } else if (data.r || data.g || data.b) {
	        _this.props.onChange({
	          r: data.r || _this.props.rgb.r,
	          g: data.g || _this.props.rgb.g,
	          b: data.b || _this.props.rgb.b,
	          source: 'rgb'
	        }, e);
	      } else if (data.a) {
	        if (data.a < 0) {
	          data.a = 0;
	        } else if (data.a > 1) {
	          data.a = 1;
	        }
	
	        _this.props.onChange({
	          h: _this.props.hsl.h,
	          s: _this.props.hsl.s,
	          l: _this.props.hsl.l,
	          a: Math.round(data.a * 100) / 100,
	          source: 'rgb'
	        }, e);
	      } else if (data.h || data.s || data.l) {
	        _this.props.onChange({
	          h: data.h || _this.props.hsl.h,
	          s: data.s && data.s || _this.props.hsl.s,
	          l: data.l && data.l || _this.props.hsl.l,
	          source: 'hsl'
	        }, e);
	      }
	    }, _this.showHighlight = function (e) {
	      e.target.style.background = '#eee';
	    }, _this.hideHighlight = function (e) {
	      e.target.style.background = 'transparent';
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChromeFields, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.hsl.a === 1 && this.state.view !== 'hex') {
	        this.setState({ view: 'hex' });
	      } else if (this.state.view !== 'rgb' && this.state.view !== 'hsl') {
	        this.setState({ view: 'rgb' });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hsl.a !== 1 && this.state.view === 'hex') {
	        this.setState({ view: 'rgb' });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            paddingTop: '16px',
	            display: 'flex'
	          },
	          fields: {
	            flex: '1',
	            display: 'flex',
	            marginLeft: '-6px'
	          },
	          field: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          alpha: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          toggle: {
	            width: '32px',
	            textAlign: 'right',
	            position: 'relative'
	          },
	          icon: {
	            marginRight: '-4px',
	            marginTop: '12px',
	            cursor: 'pointer',
	            position: 'relative'
	          },
	          iconHighlight: {
	            position: 'absolute',
	            width: '24px',
	            height: '28px',
	            background: '#eee',
	            borderRadius: '4px',
	            top: '10px',
	            left: '12px',
	            display: 'none'
	          },
	          input: {
	            fontSize: '11px',
	            color: '#333',
	            width: '100%',
	            borderRadius: '2px',
	            border: 'none',
	            boxShadow: 'inset 0 0 0 1px #dadada',
	            height: '21px',
	            textAlign: 'center'
	          },
	          label: {
	            textTransform: 'uppercase',
	            fontSize: '11px',
	            lineHeight: '11px',
	            color: '#969696',
	            textAlign: 'center',
	            display: 'block',
	            marginTop: '12px'
	          },
	          svg: {
	            width: '24px',
	            height: '24px',
	            border: '1px transparent solid',
	            borderRadius: '5px'
	          }
	        },
	        'disableAlpha': {
	          alpha: {
	            display: 'none'
	          }
	        }
	      }, this.props, this.state);
	
	      var fields = void 0;
	      if (this.state.view === 'hex') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'hex', value: this.props.hex,
	              onChange: this.handleChange
	            })
	          )
	        );
	      } else if (this.state.view === 'rgb') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'r',
	              value: this.props.rgb.r,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'g',
	              value: this.props.rgb.g,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'b',
	              value: this.props.rgb.b,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'a',
	              value: this.props.rgb.a,
	              arrowOffset: 0.01,
	              onChange: this.handleChange
	            })
	          )
	        );
	      } else if (this.state.view === 'hsl') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'h',
	              value: Math.round(this.props.hsl.h),
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 's',
	              value: Math.round(this.props.hsl.s * 100) + '%',
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'l',
	              value: Math.round(this.props.hsl.l * 100) + '%',
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'a',
	              value: this.props.hsl.a,
	              arrowOffset: 0.01,
	              onChange: this.handleChange
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap, className: 'flexbox-fix' },
	        fields,
	        _react2.default.createElement(
	          'div',
	          { style: styles.toggle },
	          _react2.default.createElement(
	            'div',
	            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
	                return _this2.icon = icon;
	              } },
	            _react2.default.createElement(
	              'svg',
	              {
	                style: styles.svg,
	                viewBox: '0 0 24 24',
	                onMouseOver: this.showHighlight,
	                onMouseEnter: this.showHighlight,
	                onMouseOut: this.hideHighlight
	              },
	              _react2.default.createElement('path', {
	                ref: function ref(iconUp) {
	                  return _this2.iconUp = iconUp;
	                },
	                fill: '#333',
	                d: 'M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
	              }),
	              _react2.default.createElement('path', {
	                ref: function ref(iconDown) {
	                  return _this2.iconDown = iconDown;
	                },
	                fill: '#333',
	                d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15Z'
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChromeFields;
	}(_react2.default.Component);
	
	exports.default = ChromeFields;

/***/ },

/***/ "./node_modules/react-color/lib/components/chrome/ChromePointer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointer = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChromePointer = exports.ChromePointer = function ChromePointer() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        transform: 'translate(-6px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = ChromePointer;

/***/ },

/***/ "./node_modules/react-color/lib/components/chrome/ChromePointerCircle.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointerCircle = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChromePointerCircle = exports.ChromePointerCircle = function ChromePointerCircle() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        boxShadow: 'inset 0 0 0 1px #fff',
	        transform: 'translate(-6px, -6px)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = ChromePointerCircle;

/***/ },

/***/ "./node_modules/react-color/lib/components/compact/Compact.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Compact = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__("./node_modules/lodash/map.js");
	
	var _map2 = _interopRequireDefault(_map);
	
	var _color = __webpack_require__("./node_modules/react-color/lib/helpers/color.js");
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	var _CompactColor = __webpack_require__("./node_modules/react-color/lib/components/compact/CompactColor.js");
	
	var _CompactColor2 = _interopRequireDefault(_CompactColor);
	
	var _CompactFields = __webpack_require__("./node_modules/react-color/lib/components/compact/CompactFields.js");
	
	var _CompactFields2 = _interopRequireDefault(_CompactFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Compact = exports.Compact = function Compact(_ref) {
	  var onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      rgb = _ref.rgb,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      Compact: {
	        background: '#f6f6f6',
	        radius: '4px'
	      },
	      compact: {
	        paddingTop: '5px',
	        paddingLeft: '5px',
	        boxSizing: 'initial',
	        width: '240px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      _color2.default.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else {
	      onChange(data, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    _common.Raised,
	    { style: styles.Compact },
	    _react2.default.createElement(
	      'div',
	      { style: styles.compact, className: 'compact-picker ' + className },
	      _react2.default.createElement(
	        'div',
	        null,
	        (0, _map2.default)(colors, function (c) {
	          return _react2.default.createElement(_CompactColor2.default, {
	            key: c,
	            color: c,
	            active: c.toLowerCase() === hex,
	            onClick: handleChange,
	            onSwatchHover: onSwatchHover
	          });
	        }),
	        _react2.default.createElement('div', { style: styles.clear })
	      ),
	      _react2.default.createElement(_CompactFields2.default, { hex: hex, rgb: rgb, onChange: handleChange })
	    )
	  );
	};
	
	Compact.propTypes = {
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	
	Compact.defaultProps = {
	  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E']
	};
	
	exports.default = (0, _common.ColorWrap)(Compact);

/***/ },

/***/ "./node_modules/react-color/lib/components/compact/CompactColor.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactColor = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompactColor = exports.CompactColor = function CompactColor(_ref) {
	  var color = _ref.color,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      color: {
	        background: color,
	        width: '15px',
	        height: '15px',
	        float: 'left',
	        marginRight: '5px',
	        marginBottom: '5px',
	        position: 'relative',
	        cursor: 'pointer'
	      },
	      dot: {
	        absolute: '5px 5px 5px 5px',
	        background: '#fff',
	        borderRadius: '50%',
	        opacity: '0'
	      }
	    },
	    'active': {
	      dot: {
	        opacity: '1'
	      }
	    },
	    'color-#FFFFFF': {
	      color: {
	        boxShadow: 'inset 0 0 0 1px #ddd'
	      },
	      dot: {
	        background: '#000'
	      }
	    },
	    'transparent': {
	      dot: {
	        background: '#000'
	      }
	    }
	  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF', 'transparent': color === 'transparent' });
	
	  return _react2.default.createElement(
	    _common.Swatch,
	    {
	      style: styles.color,
	      color: color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: { boxShadow: '0 0 4px ' + color }
	    },
	    _react2.default.createElement('div', { style: styles.dot })
	  );
	};
	
	exports.default = CompactColor;

/***/ },

/***/ "./node_modules/react-color/lib/components/compact/CompactFields.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactFields = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompactFields = exports.CompactFields = function CompactFields(_ref) {
	  var hex = _ref.hex,
	      rgb = _ref.rgb,
	      onChange = _ref.onChange;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        display: 'flex',
	        paddingBottom: '6px',
	        paddingRight: '5px',
	        position: 'relative'
	      },
	      active: {
	        position: 'absolute',
	        top: '6px',
	        left: '5px',
	        height: '9px',
	        width: '9px',
	        background: hex
	      },
	      HEXwrap: {
	        flex: '6',
	        position: 'relative'
	      },
	      HEXinput: {
	        width: '80%',
	        padding: '0px',
	        paddingLeft: '20%',
	        border: 'none',
	        outline: 'none',
	        background: 'none',
	        fontSize: '12px',
	        color: '#333',
	        height: '16px'
	      },
	      HEXlabel: {
	        display: 'none'
	      },
	      RGBwrap: {
	        flex: '3',
	        position: 'relative'
	      },
	      RGBinput: {
	        width: '70%',
	        padding: '0px',
	        paddingLeft: '30%',
	        border: 'none',
	        outline: 'none',
	        background: 'none',
	        fontSize: '12px',
	        color: '#333',
	        height: '16px'
	      },
	      RGBlabel: {
	        position: 'absolute',
	        top: '3px',
	        left: '0px',
	        lineHeight: '16px',
	        textTransform: 'uppercase',
	        fontSize: '12px',
	        color: '#999'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    } else {
	      onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields, className: 'flexbox-fix' },
	    _react2.default.createElement('div', { style: styles.active }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	      label: 'hex',
	      value: hex,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'r',
	      value: rgb.r,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'g',
	      value: rgb.g,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'b',
	      value: rgb.b,
	      onChange: handleChange
	    })
	  );
	};
	
	exports.default = CompactFields;

/***/ },

/***/ "./node_modules/react-color/lib/components/github/Github.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Github = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__("./node_modules/lodash/map.js");
	
	var _map2 = _interopRequireDefault(_map);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	var _GithubSwatch = __webpack_require__("./node_modules/react-color/lib/components/github/GithubSwatch.js");
	
	var _GithubSwatch2 = _interopRequireDefault(_GithubSwatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Github = exports.Github = function Github(_ref) {
	  var width = _ref.width,
	      colors = _ref.colors,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      triangle = _ref.triangle,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        border: '1px solid rgba(0,0,0,0.2)',
	        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
	        borderRadius: '4px',
	        position: 'relative',
	        padding: '5px',
	        display: 'flex',
	        flexWrap: 'wrap'
	      },
	      triangle: {
	        position: 'absolute',
	        border: '7px solid transparent',
	        borderBottomColor: '#fff'
	      },
	      triangleShadow: {
	        position: 'absolute',
	        border: '8px solid transparent',
	        borderBottomColor: 'rgba(0,0,0,0.15)'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      },
	      triangleShadow: {
	        display: 'none'
	      }
	    },
	    'top-left-triangle': {
	      triangle: {
	        top: '-14px',
	        left: '10px'
	      },
	      triangleShadow: {
	        top: '-16px',
	        left: '9px'
	      }
	    },
	    'top-right-triangle': {
	      triangle: {
	        top: '-14px',
	        right: '10px'
	      },
	      triangleShadow: {
	        top: '-16px',
	        right: '9px'
	      }
	    },
	    'bottom-right-triangle': {
	      triangle: {
	        top: '35px',
	        right: '10px',
	        transform: 'rotate(180deg)'
	      },
	      triangleShadow: {
	        top: '37px',
	        right: '9px',
	        transform: 'rotate(180deg)'
	      }
	    }
	  }, {
	    'hide-triangle': triangle === 'hide',
	    'top-left-triangle': triangle === 'top-left',
	    'top-right-triangle': triangle === 'top-right',
	    'bottom-right-triangle': triangle === 'bottom-right'
	  });
	
	  var handleChange = function handleChange(hex, e) {
	    return onChange({ hex: hex, source: 'hex' }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'github-picker ' + className },
	    _react2.default.createElement('div', { style: styles.triangleShadow }),
	    _react2.default.createElement('div', { style: styles.triangle }),
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_GithubSwatch2.default, {
	        color: c,
	        key: c,
	        onClick: handleChange,
	        onSwatchHover: onSwatchHover
	      });
	    })
	  );
	};
	
	Github.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right'])
	};
	
	Github.defaultProps = {
	  width: 200,
	  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
	  triangle: 'top-left'
	};
	
	exports.default = (0, _common.ColorWrap)(Github);

/***/ },

/***/ "./node_modules/react-color/lib/components/github/GithubSwatch.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GithubSwatch = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GithubSwatch = exports.GithubSwatch = function GithubSwatch(_ref) {
	  var hover = _ref.hover,
	      color = _ref.color,
	      onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover;
	
	  var hoverSwatch = {
	    position: 'relative',
	    zIndex: '2',
	    outline: '2px solid #fff',
	    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
	  };
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        width: '25px',
	        height: '25px',
	        fontSize: '0'
	      }
	    },
	    'hover': {
	      swatch: hoverSwatch
	    }
	  }, { hover: hover });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatch },
	    _react2.default.createElement(_common.Swatch, {
	      color: color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: hoverSwatch
	    })
	  );
	};
	
	exports.default = (0, _reactcss.handleHover)(GithubSwatch);

/***/ },

/***/ "./node_modules/react-color/lib/components/hue/Hue.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HuePicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	var _HuePointer = __webpack_require__("./node_modules/react-color/lib/components/hue/HuePointer.js");
	
	var _HuePointer2 = _interopRequireDefault(_HuePointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HuePicker = exports.HuePicker = function HuePicker(_ref) {
	  var width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      hsl = _ref.hsl,
	      direction = _ref.direction,
	      pointer = _ref.pointer,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        position: 'relative',
	        width: width,
	        height: height
	      },
	      hue: {
	        radius: '2px'
	      }
	    }
	  });
	
	  // Overwrite to provide pure hue color
	  var handleChange = function handleChange(data) {
	    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'hue-picker ' + className },
	    _react2.default.createElement(_common.Hue, _extends({}, styles.hue, {
	      hsl: hsl,
	      pointer: pointer,
	      onChange: handleChange,
	      direction: direction
	    }))
	  );
	};
	
	HuePicker.defaultProps = {
	  width: '316px',
	  height: '16px',
	  direction: 'horizontal',
	  pointer: _HuePointer2.default
	};
	
	exports.default = (0, _common.ColorWrap)(HuePicker);

/***/ },

/***/ "./node_modules/react-color/lib/components/hue/HuePointer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderPointer = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderPointer = exports.SliderPointer = function SliderPointer(_ref) {
	  var direction = _ref.direction;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '18px',
	        height: '18px',
	        borderRadius: '50%',
	        transform: 'translate(-9px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    },
	    'vertical': {
	      picker: {
	        transform: 'translate(-3px, -9px)'
	      }
	    }
	  }, { vertical: direction === 'vertical' });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = SliderPointer;

/***/ },

/***/ "./node_modules/react-color/lib/components/material/Material.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Material = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__("./node_modules/react-color/lib/helpers/color.js");
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Material = exports.Material = function Material(_ref) {
	  var onChange = _ref.onChange,
	      hex = _ref.hex,
	      rgb = _ref.rgb,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      material: {
	        width: '98px',
	        height: '98px',
	        padding: '16px',
	        fontFamily: 'Roboto'
	      },
	      HEXwrap: {
	        position: 'relative'
	      },
	      HEXinput: {
	        width: '100%',
	        marginTop: '12px',
	        fontSize: '15px',
	        color: '#333',
	        padding: '0px',
	        border: '0px',
	        borderBottom: '2px solid ' + hex,
	        outline: 'none',
	        height: '30px'
	      },
	      HEXlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        fontSize: '11px',
	        color: '#999999',
	        textTransform: 'capitalize'
	      },
	      Hex: {
	        style: {}
	      },
	      RGBwrap: {
	        position: 'relative'
	      },
	      RGBinput: {
	        width: '100%',
	        marginTop: '12px',
	        fontSize: '15px',
	        color: '#333',
	        padding: '0px',
	        border: '0px',
	        borderBottom: '1px solid #eee',
	        outline: 'none',
	        height: '30px'
	      },
	      RGBlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        fontSize: '11px',
	        color: '#999999',
	        textTransform: 'capitalize'
	      },
	      split: {
	        display: 'flex',
	        marginRight: '-10px',
	        paddingTop: '11px'
	      },
	      third: {
	        flex: '1',
	        paddingRight: '10px'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      _color2.default.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    _common.Raised,
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: styles.material, className: 'material-picker ' + className },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	        label: 'hex',
	        value: hex,
	        onChange: handleChange
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.split, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'r', value: rgb.r,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'g',
	            value: rgb.g,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'b',
	            value: rgb.b,
	            onChange: handleChange
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _common.ColorWrap)(Material);

/***/ },

/***/ "./node_modules/react-color/lib/components/photoshop/Photoshop.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Photoshop = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	var _PhotoshopFields = __webpack_require__("./node_modules/react-color/lib/components/photoshop/PhotoshopFields.js");
	
	var _PhotoshopFields2 = _interopRequireDefault(_PhotoshopFields);
	
	var _PhotoshopPointerCircle = __webpack_require__("./node_modules/react-color/lib/components/photoshop/PhotoshopPointerCircle.js");
	
	var _PhotoshopPointerCircle2 = _interopRequireDefault(_PhotoshopPointerCircle);
	
	var _PhotoshopPointer = __webpack_require__("./node_modules/react-color/lib/components/photoshop/PhotoshopPointer.js");
	
	var _PhotoshopPointer2 = _interopRequireDefault(_PhotoshopPointer);
	
	var _PhotoshopButton = __webpack_require__("./node_modules/react-color/lib/components/photoshop/PhotoshopButton.js");
	
	var _PhotoshopButton2 = _interopRequireDefault(_PhotoshopButton);
	
	var _PhotoshopPreviews = __webpack_require__("./node_modules/react-color/lib/components/photoshop/PhotoshopPreviews.js");
	
	var _PhotoshopPreviews2 = _interopRequireDefault(_PhotoshopPreviews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Photoshop = exports.Photoshop = function (_React$Component) {
	  _inherits(Photoshop, _React$Component);
	
	  function Photoshop(props) {
	    _classCallCheck(this, Photoshop);
	
	    var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
	
	    _this.state = {
	      currentColor: props.hex
	    };
	    return _this;
	  }
	
	  _createClass(Photoshop, [{
	    key: 'render',
	    value: function render() {
	      var _props$className = this.props.className,
	          className = _props$className === undefined ? '' : _props$className;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            background: '#DCDCDC',
	            borderRadius: '4px',
	            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
	            boxSizing: 'initial',
	            width: '513px'
	          },
	          head: {
	            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
	            borderBottom: '1px solid #B1B1B1',
	            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
	            height: '23px',
	            lineHeight: '24px',
	            borderRadius: '4px 4px 0 0',
	            fontSize: '13px',
	            color: '#4D4D4D',
	            textAlign: 'center'
	          },
	          body: {
	            padding: '15px 15px 0',
	            display: 'flex'
	          },
	          saturation: {
	            width: '256px',
	            height: '256px',
	            position: 'relative',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0',
	            overflow: 'hidden'
	          },
	          hue: {
	            position: 'relative',
	            height: '256px',
	            width: '19px',
	            marginLeft: '10px',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0'
	          },
	          controls: {
	            width: '180px',
	            marginLeft: '10px'
	          },
	          top: {
	            display: 'flex'
	          },
	          previews: {
	            width: '60px'
	          },
	          actions: {
	            flex: '1',
	            marginLeft: '20px'
	          }
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.picker, className: 'photoshop-picker ' + className },
	        _react2.default.createElement(
	          'div',
	          { style: styles.head },
	          this.props.header
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.body, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.saturation },
	            _react2.default.createElement(_common.Saturation, {
	              hsl: this.props.hsl,
	              hsv: this.props.hsv,
	              pointer: _PhotoshopPointerCircle2.default,
	              onChange: this.props.onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.hue },
	            _react2.default.createElement(_common.Hue, {
	              direction: 'vertical',
	              hsl: this.props.hsl,
	              pointer: _PhotoshopPointer2.default,
	              onChange: this.props.onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.controls },
	            _react2.default.createElement(
	              'div',
	              { style: styles.top, className: 'flexbox-fix' },
	              _react2.default.createElement(
	                'div',
	                { style: styles.previews },
	                _react2.default.createElement(_PhotoshopPreviews2.default, {
	                  rgb: this.props.rgb,
	                  currentColor: this.state.currentColor
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: styles.actions },
	                _react2.default.createElement(_PhotoshopButton2.default, { label: 'OK', onClick: this.props.onAccept, active: true }),
	                _react2.default.createElement(_PhotoshopButton2.default, { label: 'Cancel', onClick: this.props.onCancel }),
	                _react2.default.createElement(_PhotoshopFields2.default, {
	                  onChange: this.props.onChange,
	                  rgb: this.props.rgb,
	                  hsv: this.props.hsv,
	                  hex: this.props.hex
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Photoshop;
	}(_react2.default.Component);
	
	Photoshop.propTypes = {
	  header: _propTypes2.default.string
	};
	
	Photoshop.defaultProps = {
	  header: 'Color Picker'
	};
	
	exports.default = (0, _common.ColorWrap)(Photoshop);

/***/ },

/***/ "./node_modules/react-color/lib/components/photoshop/PhotoshopFields.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPicker = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__("./node_modules/react-color/lib/helpers/color.js");
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPicker = exports.PhotoshopPicker = function PhotoshopPicker(_ref) {
	  var onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsv = _ref.hsv,
	      hex = _ref.hex;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        paddingTop: '5px',
	        paddingBottom: '9px',
	        width: '80px',
	        position: 'relative'
	      },
	      divider: {
	        height: '5px'
	      },
	      RGBwrap: {
	        position: 'relative'
	      },
	      RGBinput: {
	        marginLeft: '40%',
	        width: '40%',
	        height: '18px',
	        border: '1px solid #888888',
	        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	        marginBottom: '5px',
	        fontSize: '13px',
	        paddingLeft: '3px',
	        marginRight: '10px'
	      },
	      RGBlabel: {
	        left: '0px',
	        width: '34px',
	        textTransform: 'uppercase',
	        fontSize: '13px',
	        height: '18px',
	        lineHeight: '22px',
	        position: 'absolute'
	      },
	      HEXwrap: {
	        position: 'relative'
	      },
	      HEXinput: {
	        marginLeft: '20%',
	        width: '80%',
	        height: '18px',
	        border: '1px solid #888888',
	        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	        marginBottom: '6px',
	        fontSize: '13px',
	        paddingLeft: '3px'
	      },
	      HEXlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        width: '14px',
	        textTransform: 'uppercase',
	        fontSize: '13px',
	        height: '18px',
	        lineHeight: '22px'
	      },
	      fieldSymbols: {
	        position: 'absolute',
	        top: '5px',
	        right: '-7px',
	        fontSize: '13px'
	      },
	      symbol: {
	        height: '20px',
	        lineHeight: '22px',
	        paddingBottom: '7px'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data['#']) {
	      _color2.default.isValidHex(data['#']) && onChange({
	        hex: data['#'],
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    } else if (data.h || data.s || data.v) {
	      onChange({
	        h: data.h || hsv.h,
	        s: data.s || hsv.s,
	        v: data.v || hsv.v,
	        source: 'hsv'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields },
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'h',
	      value: Math.round(hsv.h),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 's',
	      value: Math.round(hsv.s * 100),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'v',
	      value: Math.round(hsv.v * 100),
	      onChange: handleChange
	    }),
	    _react2.default.createElement('div', { style: styles.divider }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'r',
	      value: rgb.r,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'g',
	      value: rgb.g,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'b',
	      value: rgb.b,
	      onChange: handleChange
	    }),
	    _react2.default.createElement('div', { style: styles.divider }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	      label: '#',
	      value: hex.replace('#', ''),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.fieldSymbols },
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '\xB0'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '%'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '%'
	      )
	    )
	  );
	};
	
	exports.default = PhotoshopPicker;

/***/ },

/***/ "./node_modules/react-color/lib/components/photoshop/PhotoshopPointerCircle.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
	  var hsl = _ref.hsl;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        boxShadow: 'inset 0 0 0 1px #fff',
	        transform: 'translate(-6px, -6px)'
	      }
	    },
	    'black-outline': {
	      picker: {
	        boxShadow: 'inset 0 0 0 1px #000'
	      }
	    }
	  }, { 'black-outline': hsl.l > 0.5 });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = PhotoshopPointerCircle;

/***/ },

/***/ "./node_modules/react-color/lib/components/photoshop/PhotoshopPointer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      triangle: {
	        width: 0,
	        height: 0,
	        borderStyle: 'solid',
	        borderWidth: '4px 0 4px 6px',
	        borderColor: 'transparent transparent transparent #fff',
	        position: 'absolute',
	        top: '1px',
	        left: '1px'
	      },
	      triangleBorder: {
	        width: 0,
	        height: 0,
	        borderStyle: 'solid',
	        borderWidth: '5px 0 5px 8px',
	        borderColor: 'transparent transparent transparent #555'
	      },
	
	      left: {
	        Extend: 'triangleBorder',
	        transform: 'translate(-13px, -4px)'
	      },
	      leftInside: {
	        Extend: 'triangle',
	        transform: 'translate(-8px, -5px)'
	      },
	
	      right: {
	        Extend: 'triangleBorder',
	        transform: 'translate(20px, -14px) rotate(180deg)'
	      },
	      rightInside: {
	        Extend: 'triangle',
	        transform: 'translate(-8px, -5px)'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.pointer },
	    _react2.default.createElement(
	      'div',
	      { style: styles.left },
	      _react2.default.createElement('div', { style: styles.leftInside })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.right },
	      _react2.default.createElement('div', { style: styles.rightInside })
	    )
	  );
	};
	
	exports.default = PhotoshopPointerCircle;

/***/ },

/***/ "./node_modules/react-color/lib/components/photoshop/PhotoshopButton.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopBotton = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopBotton = exports.PhotoshopBotton = function PhotoshopBotton(_ref) {
	  var onClick = _ref.onClick,
	      label = _ref.label,
	      children = _ref.children,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      button: {
	        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
	        border: '1px solid #878787',
	        borderRadius: '2px',
	        height: '20px',
	        boxShadow: '0 1px 0 0 #EAEAEA',
	        fontSize: '14px',
	        color: '#000',
	        lineHeight: '20px',
	        textAlign: 'center',
	        marginBottom: '10px',
	        cursor: 'pointer'
	      }
	    },
	    'active': {
	      button: {
	        boxShadow: '0 0 0 1px #878787'
	      }
	    }
	  }, { active: active });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.button, onClick: onClick },
	    label || children
	  );
	};
	
	exports.default = PhotoshopBotton;

/***/ },

/***/ "./node_modules/react-color/lib/components/photoshop/PhotoshopPreviews.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPreviews = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPreviews = exports.PhotoshopPreviews = function PhotoshopPreviews(_ref) {
	  var rgb = _ref.rgb,
	      currentColor = _ref.currentColor;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        border: '1px solid #B3B3B3',
	        borderBottom: '1px solid #F0F0F0',
	        marginBottom: '2px',
	        marginTop: '1px'
	      },
	      new: {
	        height: '34px',
	        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
	        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
	      },
	      current: {
	        height: '34px',
	        background: currentColor,
	        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
	      },
	      label: {
	        fontSize: '14px',
	        color: '#000',
	        textAlign: 'center'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: styles.label },
	      'new'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatches },
	      _react2.default.createElement('div', { style: styles.new }),
	      _react2.default.createElement('div', { style: styles.current })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.label },
	      'current'
	    )
	  );
	};
	
	exports.default = PhotoshopPreviews;

/***/ },

/***/ "./node_modules/react-color/lib/components/sketch/Sketch.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Sketch = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	var _SketchFields = __webpack_require__("./node_modules/react-color/lib/components/sketch/SketchFields.js");
	
	var _SketchFields2 = _interopRequireDefault(_SketchFields);
	
	var _SketchPresetColors = __webpack_require__("./node_modules/react-color/lib/components/sketch/SketchPresetColors.js");
	
	var _SketchPresetColors2 = _interopRequireDefault(_SketchPresetColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sketch = exports.Sketch = function Sketch(_ref) {
	  var width = _ref.width,
	      rgb = _ref.rgb,
	      hex = _ref.hex,
	      hsv = _ref.hsv,
	      hsl = _ref.hsl,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      disableAlpha = _ref.disableAlpha,
	      presetColors = _ref.presetColors,
	      renderers = _ref.renderers,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: width,
	        padding: '10px 10px 0',
	        boxSizing: 'initial',
	        background: '#fff',
	        borderRadius: '4px',
	        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
	      },
	      saturation: {
	        width: '100%',
	        paddingBottom: '75%',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      Saturation: {
	        radius: '3px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	      controls: {
	        display: 'flex'
	      },
	      sliders: {
	        padding: '4px 0',
	        flex: '1'
	      },
	      color: {
	        width: '24px',
	        height: '24px',
	        position: 'relative',
	        marginTop: '4px',
	        marginLeft: '4px',
	        borderRadius: '3px'
	      },
	      activeColor: {
	        absolute: '0px 0px 0px 0px',
	        borderRadius: '2px',
	        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	      hue: {
	        position: 'relative',
	        height: '10px',
	        overflow: 'hidden'
	      },
	      Hue: {
	        radius: '2px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	
	      alpha: {
	        position: 'relative',
	        height: '10px',
	        marginTop: '4px',
	        overflow: 'hidden'
	      },
	      Alpha: {
	        radius: '2px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      }
	    },
	    'disableAlpha': {
	      color: {
	        height: '10px'
	      },
	      hue: {
	        height: '10px'
	      },
	      alpha: {
	        display: 'none'
	      }
	    }
	  }, { disableAlpha: disableAlpha });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'sketch-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.saturation },
	      _react2.default.createElement(_common.Saturation, {
	        style: styles.Saturation,
	        hsl: hsl,
	        hsv: hsv,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.controls, className: 'flexbox-fix' },
	      _react2.default.createElement(
	        'div',
	        { style: styles.sliders },
	        _react2.default.createElement(
	          'div',
	          { style: styles.hue },
	          _react2.default.createElement(_common.Hue, {
	            style: styles.Hue,
	            hsl: hsl,
	            onChange: onChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.alpha },
	          _react2.default.createElement(_common.Alpha, {
	            style: styles.Alpha,
	            rgb: rgb,
	            hsl: hsl,
	            renderers: renderers,
	            onChange: onChange
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.color },
	        _react2.default.createElement(_common.Checkboard, null),
	        _react2.default.createElement('div', { style: styles.activeColor })
	      )
	    ),
	    _react2.default.createElement(_SketchFields2.default, {
	      rgb: rgb,
	      hsl: hsl,
	      hex: hex,
	      onChange: onChange,
	      disableAlpha: disableAlpha
	    }),
	    _react2.default.createElement(_SketchPresetColors2.default, {
	      colors: presetColors,
	      onClick: onChange,
	      onSwatchHover: onSwatchHover
	    })
	  );
	};
	
	Sketch.propTypes = {
	  disableAlpha: _propTypes2.default.bool,
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Sketch.defaultProps = {
	  disableAlpha: false,
	  width: 200,
	  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
	};
	
	exports.default = (0, _common.ColorWrap)(Sketch);

/***/ },

/***/ "./node_modules/react-color/lib/components/sketch/SketchFields.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SketchFields = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__("./node_modules/react-color/lib/helpers/color.js");
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-param-reassign */
	
	var SketchFields = exports.SketchFields = function SketchFields(_ref) {
	  var onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hex = _ref.hex,
	      disableAlpha = _ref.disableAlpha;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        display: 'flex',
	        paddingTop: '4px'
	      },
	      single: {
	        flex: '1',
	        paddingLeft: '6px'
	      },
	      alpha: {
	        flex: '1',
	        paddingLeft: '6px'
	      },
	      double: {
	        flex: '2'
	      },
	      input: {
	        width: '80%',
	        padding: '4px 10% 3px',
	        border: 'none',
	        boxShadow: 'inset 0 0 0 1px #ccc',
	        fontSize: '11px'
	      },
	      label: {
	        display: 'block',
	        textAlign: 'center',
	        fontSize: '11px',
	        color: '#222',
	        paddingTop: '3px',
	        paddingBottom: '4px',
	        textTransform: 'capitalize'
	      }
	    },
	    'disableAlpha': {
	      alpha: {
	        display: 'none'
	      }
	    }
	  }, { disableAlpha: disableAlpha });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      _color2.default.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        a: rgb.a,
	        source: 'rgb'
	      }, e);
	    } else if (data.a) {
	      if (data.a < 0) {
	        data.a = 0;
	      } else if (data.a > 100) {
	        data.a = 100;
	      }
	
	      data.a /= 100;
	      onChange({
	        h: hsl.h,
	        s: hsl.s,
	        l: hsl.l,
	        a: data.a,
	        source: 'rgb'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields, className: 'flexbox-fix' },
	    _react2.default.createElement(
	      'div',
	      { style: styles.double },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'hex',
	        value: hex.replace('#', ''),
	        onChange: handleChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'r',
	        value: rgb.r,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'g',
	        value: rgb.g,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'b',
	        value: rgb.b,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.alpha },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'a',
	        value: Math.round(rgb.a * 100),
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '100'
	      })
	    )
	  );
	};
	
	exports.default = SketchFields;

/***/ },

/***/ "./node_modules/react-color/lib/components/sketch/SketchPresetColors.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SketchPresetColors = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SketchPresetColors = exports.SketchPresetColors = function SketchPresetColors(_ref) {
	  var colors = _ref.colors,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onSwatchHover = _ref.onSwatchHover;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      colors: {
	        margin: '0 -10px',
	        padding: '10px 0 0 10px',
	        borderTop: '1px solid #eee',
	        display: 'flex',
	        flexWrap: 'wrap',
	        position: 'relative'
	      },
	      swatchWrap: {
	        width: '16px',
	        height: '16px',
	        margin: '0 10px 10px 0'
	      },
	      swatch: {
	        borderRadius: '3px',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
	      }
	    },
	    'no-presets': {
	      colors: {
	        display: 'none'
	      }
	    }
	  }, {
	    'no-presets': !colors || !colors.length
	  });
	
	  var handleClick = function handleClick(hex, e) {
	    onClick({
	      hex: hex,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.colors, className: 'flexbox-fix' },
	    colors.map(function (colorObjOrString) {
	      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
	      return _react2.default.createElement(
	        'div',
	        { key: c.color, style: styles.swatchWrap },
	        _react2.default.createElement(_common.Swatch, _extends({}, c, {
	          style: styles.swatch,
	          onClick: handleClick,
	          onHover: onSwatchHover,
	          focusStyle: {
	            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
	          }
	        }))
	      );
	    })
	  );
	};
	
	SketchPresetColors.propTypes = {
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    color: _propTypes2.default.string,
	    title: _propTypes2.default.string
	  })])).isRequired
	};
	
	exports.default = SketchPresetColors;

/***/ },

/***/ "./node_modules/react-color/lib/components/slider/Slider.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Slider = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	var _SliderSwatches = __webpack_require__("./node_modules/react-color/lib/components/slider/SliderSwatches.js");
	
	var _SliderSwatches2 = _interopRequireDefault(_SliderSwatches);
	
	var _SliderPointer = __webpack_require__("./node_modules/react-color/lib/components/slider/SliderPointer.js");
	
	var _SliderPointer2 = _interopRequireDefault(_SliderPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Slider = exports.Slider = function Slider(_ref) {
	  var hsl = _ref.hsl,
	      onChange = _ref.onChange,
	      pointer = _ref.pointer,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      hue: {
	        height: '12px',
	        position: 'relative'
	      },
	      Hue: {
	        radius: '2px'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'slider-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.hue },
	      _react2.default.createElement(_common.Hue, {
	        style: styles.Hue,
	        hsl: hsl,
	        pointer: pointer,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatches },
	      _react2.default.createElement(_SliderSwatches2.default, { hsl: hsl, onClick: onChange })
	    )
	  );
	};
	
	Slider.defaultProps = {
	  pointer: _SliderPointer2.default
	};
	
	exports.default = (0, _common.ColorWrap)(Slider);

/***/ },

/***/ "./node_modules/react-color/lib/components/slider/SliderSwatches.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatches = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _SliderSwatch = __webpack_require__("./node_modules/react-color/lib/components/slider/SliderSwatch.js");
	
	var _SliderSwatch2 = _interopRequireDefault(_SliderSwatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderSwatches = exports.SliderSwatches = function SliderSwatches(_ref) {
	  var onClick = _ref.onClick,
	      hsl = _ref.hsl;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        marginTop: '20px'
	      },
	      swatch: {
	        boxSizing: 'border-box',
	        width: '20%',
	        paddingRight: '1px',
	        float: 'left'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatches },
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.80',
	        active: Math.round(hsl.l * 100) / 100 === 0.80 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick,
	        first: true
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.65',
	        active: Math.round(hsl.l * 100) / 100 === 0.65 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.50',
	        active: Math.round(hsl.l * 100) / 100 === 0.50 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.35',
	        active: Math.round(hsl.l * 100) / 100 === 0.35 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.20',
	        active: Math.round(hsl.l * 100) / 100 === 0.20 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick,
	        last: true
	      })
	    ),
	    _react2.default.createElement('div', { style: styles.clear })
	  );
	};
	
	exports.default = SliderSwatches;

/***/ },

/***/ "./node_modules/react-color/lib/components/slider/SliderSwatch.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatch = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderSwatch = exports.SliderSwatch = function SliderSwatch(_ref) {
	  var hsl = _ref.hsl,
	      offset = _ref.offset,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      active = _ref.active,
	      first = _ref.first,
	      last = _ref.last;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        height: '12px',
	        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
	        cursor: 'pointer'
	      }
	    },
	    'first': {
	      swatch: {
	        borderRadius: '2px 0 0 2px'
	      }
	    },
	    'last': {
	      swatch: {
	        borderRadius: '0 2px 2px 0'
	      }
	    },
	    'active': {
	      swatch: {
	        transform: 'scaleY(1.8)',
	        borderRadius: '3.6px/2px'
	      }
	    }
	  }, { active: active, first: first, last: last });
	
	  var handleClick = function handleClick(e) {
	    return onClick({
	      h: hsl.h,
	      s: 0.5,
	      l: offset,
	      source: 'hsl'
	    }, e);
	  };
	
	  return _react2.default.createElement('div', { style: styles.swatch, onClick: handleClick });
	};
	
	exports.default = SliderSwatch;

/***/ },

/***/ "./node_modules/react-color/lib/components/slider/SliderPointer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderPointer = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderPointer = exports.SliderPointer = function SliderPointer() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '14px',
	        height: '14px',
	        borderRadius: '6px',
	        transform: 'translate(-7px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = SliderPointer;

/***/ },

/***/ "./node_modules/react-color/lib/components/swatches/Swatches.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Swatches = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__("./node_modules/lodash/map.js");
	
	var _map2 = _interopRequireDefault(_map);
	
	var _color = __webpack_require__("./node_modules/react-color/lib/helpers/color.js");
	
	var _color2 = _interopRequireDefault(_color);
	
	var _materialColors = __webpack_require__("./node_modules/material-colors/dist/colors.js");
	
	var material = _interopRequireWildcard(_materialColors);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	var _SwatchesGroup = __webpack_require__("./node_modules/react-color/lib/components/swatches/SwatchesGroup.js");
	
	var _SwatchesGroup2 = _interopRequireDefault(_SwatchesGroup);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Swatches = exports.Swatches = function Swatches(_ref) {
	  var width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: width,
	        height: height
	      },
	      overflow: {
	        height: height,
	        overflowY: 'scroll'
	      },
	      body: {
	        padding: '16px 0 6px 16px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    _color2.default.isValidHex(data) && onChange({
	      hex: data,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'swatches-picker ' + className },
	    _react2.default.createElement(
	      _common.Raised,
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: styles.overflow },
	        _react2.default.createElement(
	          'div',
	          { style: styles.body },
	          (0, _map2.default)(colors, function (group) {
	            return _react2.default.createElement(_SwatchesGroup2.default, {
	              key: group.toString(),
	              group: group,
	              active: hex,
	              onClick: handleChange,
	              onSwatchHover: onSwatchHover
	            });
	          }),
	          _react2.default.createElement('div', { style: styles.clear })
	        )
	      )
	    )
	  );
	};
	
	Swatches.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.string))
	
	  /* eslint-disable max-len */
	};Swatches.defaultProps = {
	  width: 320,
	  height: 240,
	  colors: [[material.red['900'], material.red['700'], material.red['500'], material.red['300'], material.red['100']], [material.pink['900'], material.pink['700'], material.pink['500'], material.pink['300'], material.pink['100']], [material.purple['900'], material.purple['700'], material.purple['500'], material.purple['300'], material.purple['100']], [material.deepPurple['900'], material.deepPurple['700'], material.deepPurple['500'], material.deepPurple['300'], material.deepPurple['100']], [material.indigo['900'], material.indigo['700'], material.indigo['500'], material.indigo['300'], material.indigo['100']], [material.blue['900'], material.blue['700'], material.blue['500'], material.blue['300'], material.blue['100']], [material.lightBlue['900'], material.lightBlue['700'], material.lightBlue['500'], material.lightBlue['300'], material.lightBlue['100']], [material.cyan['900'], material.cyan['700'], material.cyan['500'], material.cyan['300'], material.cyan['100']], [material.teal['900'], material.teal['700'], material.teal['500'], material.teal['300'], material.teal['100']], ['#194D33', material.green['700'], material.green['500'], material.green['300'], material.green['100']], [material.lightGreen['900'], material.lightGreen['700'], material.lightGreen['500'], material.lightGreen['300'], material.lightGreen['100']], [material.lime['900'], material.lime['700'], material.lime['500'], material.lime['300'], material.lime['100']], [material.yellow['900'], material.yellow['700'], material.yellow['500'], material.yellow['300'], material.yellow['100']], [material.amber['900'], material.amber['700'], material.amber['500'], material.amber['300'], material.amber['100']], [material.orange['900'], material.orange['700'], material.orange['500'], material.orange['300'], material.orange['100']], [material.deepOrange['900'], material.deepOrange['700'], material.deepOrange['500'], material.deepOrange['300'], material.deepOrange['100']], [material.brown['900'], material.brown['700'], material.brown['500'], material.brown['300'], material.brown['100']], [material.blueGrey['900'], material.blueGrey['700'], material.blueGrey['500'], material.blueGrey['300'], material.blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']]
	};
	
	exports.default = (0, _common.ColorWrap)(Swatches);

/***/ },

/***/ "./node_modules/react-color/lib/components/swatches/SwatchesGroup.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesGroup = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__("./node_modules/lodash/map.js");
	
	var _map2 = _interopRequireDefault(_map);
	
	var _SwatchesColor = __webpack_require__("./node_modules/react-color/lib/components/swatches/SwatchesColor.js");
	
	var _SwatchesColor2 = _interopRequireDefault(_SwatchesColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SwatchesGroup = exports.SwatchesGroup = function SwatchesGroup(_ref) {
	  var onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      group = _ref.group,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      group: {
	        paddingBottom: '10px',
	        width: '40px',
	        float: 'left',
	        marginRight: '10px'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.group },
	    (0, _map2.default)(group, function (color, i) {
	      return _react2.default.createElement(_SwatchesColor2.default, {
	        key: color,
	        color: color,
	        active: color.toLowerCase() === active,
	        first: i === 0,
	        last: i === group.length - 1,
	        onClick: onClick,
	        onSwatchHover: onSwatchHover
	      });
	    })
	  );
	};
	
	exports.default = SwatchesGroup;

/***/ },

/***/ "./node_modules/react-color/lib/components/swatches/SwatchesColor.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesColor = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SwatchesColor = exports.SwatchesColor = function SwatchesColor(_ref) {
	  var color = _ref.color,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      first = _ref.first,
	      last = _ref.last,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      color: {
	        width: '40px',
	        height: '24px',
	        cursor: 'pointer',
	        background: color,
	        marginBottom: '1px'
	      },
	      check: {
	        fill: '#fff',
	        marginLeft: '8px',
	        display: 'none'
	      }
	    },
	    'first': {
	      color: {
	        overflow: 'hidden',
	        borderRadius: '2px 2px 0 0'
	      }
	    },
	    'last': {
	      color: {
	        overflow: 'hidden',
	        borderRadius: '0 0 2px 2px'
	      }
	    },
	    'active': {
	      check: {
	        display: 'block'
	      }
	    },
	    'color-#FFFFFF': {
	      color: {
	        boxShadow: 'inset 0 0 0 1px #ddd'
	      },
	      check: {
	        fill: '#333'
	      }
	    },
	    'transparent': {
	      check: {
	        fill: '#333'
	      }
	    }
	  }, {
	    first: first,
	    last: last,
	    active: active,
	    'color-#FFFFFF': color === '#FFFFFF',
	    'transparent': color === 'transparent'
	  });
	
	  return _react2.default.createElement(
	    _common.Swatch,
	    {
	      color: color,
	      style: styles.color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: { boxShadow: '0 0 4px ' + color }
	    },
	    _react2.default.createElement(
	      'div',
	      { style: styles.check },
	      _react2.default.createElement(
	        'svg',
	        { style: { width: '24px', height: '24px' }, viewBox: '0 0 24 24' },
	        _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
	      )
	    )
	  );
	};
	
	exports.default = SwatchesColor;

/***/ },

/***/ "./node_modules/react-color/lib/components/twitter/Twitter.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Twitter = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__("./node_modules/reactcss/lib/index.js");
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__("./node_modules/lodash/map.js");
	
	var _map2 = _interopRequireDefault(_map);
	
	var _color = __webpack_require__("./node_modules/react-color/lib/helpers/color.js");
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__("./node_modules/react-color/lib/components/common/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Twitter = exports.Twitter = function Twitter(_ref) {
	  var onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      hex = _ref.hex,
	      colors = _ref.colors,
	      width = _ref.width,
	      triangle = _ref.triangle,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        border: '0 solid rgba(0,0,0,0.25)',
	        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
	        borderRadius: '4px',
	        position: 'relative'
	      },
	      body: {
	        padding: '15px 9px 9px 15px'
	      },
	      label: {
	        fontSize: '18px',
	        color: '#fff'
	      },
	      triangle: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 9px 10px 9px',
	        borderColor: 'transparent transparent #fff transparent',
	        position: 'absolute'
	      },
	      triangleShadow: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 9px 10px 9px',
	        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
	        position: 'absolute'
	      },
	      hash: {
	        background: '#F0F0F0',
	        height: '30px',
	        width: '30px',
	        borderRadius: '4px 0 0 4px',
	        float: 'left',
	        color: '#98A1A4',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center'
	      },
	      input: {
	        width: '100px',
	        fontSize: '14px',
	        color: '#666',
	        border: '0px',
	        outline: 'none',
	        height: '28px',
	        boxShadow: 'inset 0 0 0 1px #F0F0F0',
	        boxSizing: 'content-box',
	        borderRadius: '0 4px 4px 0',
	        float: 'left',
	        paddingLeft: '8px'
	      },
	      swatch: {
	        width: '30px',
	        height: '30px',
	        float: 'left',
	        borderRadius: '4px',
	        margin: '0 6px 6px 0'
	      },
	      clear: {
	        clear: 'both'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      },
	      triangleShadow: {
	        display: 'none'
	      }
	    },
	    'top-left-triangle': {
	      triangle: {
	        top: '-10px',
	        left: '12px'
	      },
	      triangleShadow: {
	        top: '-11px',
	        left: '12px'
	      }
	    },
	    'top-right-triangle': {
	      triangle: {
	        top: '-10px',
	        right: '12px'
	      },
	      triangleShadow: {
	        top: '-11px',
	        right: '12px'
	      }
	    }
	  }, {
	    'hide-triangle': triangle === 'hide',
	    'top-left-triangle': triangle === 'top-left',
	    'top-right-triangle': triangle === 'top-right'
	  });
	
	  var handleChange = function handleChange(hexcode, e) {
	    _color2.default.isValidHex(hexcode) && onChange({
	      hex: hexcode,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'twitter-picker ' + className },
	    _react2.default.createElement('div', { style: styles.triangleShadow }),
	    _react2.default.createElement('div', { style: styles.triangle }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      (0, _map2.default)(colors, function (c, i) {
	        return _react2.default.createElement(_common.Swatch, {
	          key: i,
	          color: c,
	          hex: c,
	          style: styles.swatch,
	          onClick: handleChange,
	          onHover: onSwatchHover,
	          focusStyle: {
	            boxShadow: '0 0 4px ' + c
	          }
	        });
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.hash },
	        '#'
	      ),
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input },
	        value: hex.replace('#', ''),
	        onChange: handleChange
	      }),
	      _react2.default.createElement('div', { style: styles.clear })
	    )
	  );
	};
	
	Twitter.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right']),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	
	Twitter.defaultProps = {
	  width: 276,
	  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
	  triangle: 'top-left'
	};
	
	exports.default = (0, _common.ColorWrap)(Twitter);

/***/ },

/***/ "./src/universal/components/flights-type/FlightsTypeList.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _flightsType = __webpack_require__("./src/universal/collections/flights-type/flights-type.js");
	
	var _componentFlightsTypeList = __webpack_require__("./src/universal/components/flights-type/component-flights-type-list.js");
	
	var _componentFlightsTypeList2 = _interopRequireDefault(_componentFlightsTypeList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var FlightsListPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["flights-type"],
		flights: _flightsType.FlightsType.find({ partnerId: { $exists: false } })
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(FlightsListPage, _React$Component);
	
		function FlightsListPage(props) {
			(0, _classCallCheck3.default)(this, FlightsListPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (FlightsListPage.__proto__ || (0, _getPrototypeOf2.default)(FlightsListPage)).call(this, props));
	
			_this.state = {};
	
			return _this;
		}
	
		(0, _createClass3.default)(FlightsListPage, [{
			key: 'renderFlights',
			value: function renderFlights() {
				return this.props.flights.map(function (flight) {
					return _react2.default.createElement(_componentFlightsTypeList2.default, { key: flight._id, flight: flight });
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							'Vols'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ active: true },
							'Liste des vols'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/flights-add' },
								_react2.default.createElement(
									_rubix.Button,
									{ bsStyle: 'success' },
									'Ajouter'
								)
							)
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Liste des vols' },
						_react2.default.createElement(
							_rubix.Table,
							{ responsive: true },
							_react2.default.createElement(
								'thead',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'th',
										null,
										'Nom'
									),
									_react2.default.createElement(
										'th',
										null,
										'G\xE9n\xE9rique ?'
									),
									_react2.default.createElement(
										'th',
										null,
										'Date de cr\xE9ation'
									),
									_react2.default.createElement(
										'th',
										null,
										'Derni\xE8re modification'
									),
									_react2.default.createElement(
										'th',
										null,
										'Actions'
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								this.renderFlights()
							)
						)
					)
				);
			}
		}]);
		return FlightsListPage;
	}(_react2.default.Component)) || _class);
	exports.default = FlightsListPage;

/***/ },

/***/ "./src/universal/components/flights-type/component-flights-type-list.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _reactRouter2 = _interopRequireDefault(_reactRouter);
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var FlightListComponent = function (_React$Component) {
	  (0, _inherits3.default)(FlightListComponent, _React$Component);
	
	  function FlightListComponent() {
	    (0, _classCallCheck3.default)(this, FlightListComponent);
	    return (0, _possibleConstructorReturn3.default)(this, (FlightListComponent.__proto__ || (0, _getPrototypeOf2.default)(FlightListComponent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FlightListComponent, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.flight.deleted == true) {
	        return _react2.default.createElement('span', null);
	      }
	
	      return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          this.props.flight.title
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          'Oui'
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _reactMoment2.default,
	            { format: 'DD/MM/YYYY' },
	            this.props.flight.createdAt
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _reactMoment2.default,
	            { format: 'DD/MM/YYYY' },
	            this.props.flight.editedAt
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _rubix.Button,
	            { bsStyle: 'warning', onClick: this.goToEditView.bind(this) },
	            'Modifier'
	          ),
	          '\xA0\xA0',
	          _react2.default.createElement(
	            _rubix.Button,
	            { bsStyle: 'danger', onClick: this.deleteThisPrice.bind(this) },
	            'Supprimer'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'deleteThisPrice',
	    value: function deleteThisPrice() {
	      Meteor.call('flightsType.remove', this.props.flight._id);
	    }
	  }, {
	    key: 'goToEditView',
	    value: function goToEditView() {
	      this.context.router.push('/flights/' + this.props.flight._id);
	    }
	  }]);
	  return FlightListComponent;
	}(_react2.default.Component);
	
	exports.default = FlightListComponent;
	
	
	FlightListComponent.propTypes = {
	  // This component gets the task to display through a React prop.
	  // We can use propTypes to indicate it is required
	  flight: _react2.default.PropTypes.object.isRequired
	};
	
	FlightListComponent.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/layout/footer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function (_React$Component) {
	  (0, _inherits3.default)(Footer, _React$Component);
	
	  function Footer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Footer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      version: 0
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Footer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        version: document.body.getAttribute('data-version')
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var year = new Date().getFullYear();
	      return _react2.default.createElement(
	        'div',
	        { id: 'footer-container' },
	        _react2.default.createElement(
	          _rubix.Grid,
	          { id: 'footer', className: 'text-center' },
	          _react2.default.createElement(
	            _rubix.Row,
	            null,
	            _react2.default.createElement(
	              _rubix.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'div',
	                null,
	                '\xA9 ',
	                year,
	                ' Balloon Manager'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;

/***/ },

/***/ "./src/universal/components/layout/header.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _L20n = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/L20n.js");
	
	var _L20n2 = _interopRequireDefault(_L20n);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var Brand = function (_React$Component) {
	  (0, _inherits3.default)(Brand, _React$Component);
	
	  function Brand() {
	    (0, _classCallCheck3.default)(this, Brand);
	    return (0, _possibleConstructorReturn3.default)(this, (Brand.__proto__ || (0, _getPrototypeOf2.default)(Brand)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Brand, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _rubix.Navbar.Header,
	        this.props,
	        _react2.default.createElement(
	          _rubix.Navbar.Brand,
	          { tabIndex: '-1' },
	          _react2.default.createElement(
	            'a',
	            { href: '#' },
	            'Administration'
	          )
	        )
	      );
	    }
	  }]);
	  return Brand;
	}(_react2.default.Component);
	
	var HeaderNavigation = (0, _reactRouter.withRouter)(_class = function (_React$Component2) {
	  (0, _inherits3.default)(HeaderNavigation, _React$Component2);
	
	  function HeaderNavigation() {
	    (0, _classCallCheck3.default)(this, HeaderNavigation);
	    return (0, _possibleConstructorReturn3.default)(this, (HeaderNavigation.__proto__ || (0, _getPrototypeOf2.default)(HeaderNavigation)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(HeaderNavigation, [{
	    key: 'logout',
	    value: function logout() {
	      var _this3 = this;
	
	      Meteor.logout(function () {
	        _this3.props.router.push('/login');
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _rubix.Nav,
	        { pullRight: true },
	        _react2.default.createElement(
	          _rubix.Nav,
	          null,
	          _react2.default.createElement(
	            _rubix.NavItem,
	            { className: 'logout', onClick: this.logout.bind(this) },
	            _react2.default.createElement(_rubix.Icon, { bundle: 'fontello', glyph: 'off-1' })
	          )
	        )
	      );
	    }
	  }]);
	  return HeaderNavigation;
	}(_react2.default.Component)) || _class;
	
	var Header = function (_React$Component3) {
	  (0, _inherits3.default)(Header, _React$Component3);
	
	  function Header() {
	    (0, _classCallCheck3.default)(this, Header);
	    return (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Header, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _rubix.Grid,
	        (0, _extends3.default)({ id: 'navbar' }, this.props),
	        _react2.default.createElement(
	          _rubix.Row,
	          null,
	          _react2.default.createElement(
	            _rubix.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              _rubix.Navbar,
	              { fixedTop: true, fluid: true, id: 'rubix-nav-header' },
	              _react2.default.createElement(
	                _rubix.Row,
	                null,
	                _react2.default.createElement(
	                  _rubix.Col,
	                  { xs: 3, visible: 'xs' },
	                  _react2.default.createElement(_rubix.SidebarBtn, null)
	                ),
	                _react2.default.createElement(
	                  _rubix.Col,
	                  { xs: 6, sm: 4 },
	                  _react2.default.createElement(Brand, null)
	                ),
	                _react2.default.createElement(
	                  _rubix.Col,
	                  { xs: 3, sm: 8, collapseRight: true, className: 'text-right' },
	                  _react2.default.createElement(HeaderNavigation, null)
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;

/***/ },

/***/ "./src/universal/components/home/page-home.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _AlertsViewer = __webpack_require__("./src/universal/components/alerts/AlertsViewer.js");
	
	var _weather = __webpack_require__("./src/universal/external_api/weather.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var HomePage = function (_React$Component) {
		(0, _inherits3.default)(HomePage, _React$Component);
	
		function HomePage(props) {
			(0, _classCallCheck3.default)(this, HomePage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (HomePage.__proto__ || (0, _getPrototypeOf2.default)(HomePage)).call(this, props));
	
			_this.state = {};
	
			if (_.includes(Meteor.user().roles, 'partner')) _this.state.partner = true;
	
			var that = _this;
			Meteor.call('getEnv', 'CLIENT_NAME', function (err, result) {
				that.setState({ CLIENT_NAME: result });
			});
	
			return _this;
		}
	
		(0, _createClass3.default)(HomePage, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_rubix.PanelContainer,
					null,
					_react2.default.createElement(
						_rubix.Panel,
						null,
						_react2.default.createElement(
							_rubix.PanelBody,
							{ style: { padding: 0, paddingBottom: 25 } },
							_react2.default.createElement(
								_rubix.Grid,
								null,
								_react2.default.createElement(
									_rubix.Row,
									null,
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 5, className: 'col-welcome' },
										_react2.default.createElement(
											'h3',
											null,
											'Bienvenue sur l\'intranet de ',
											this.state.CLIENT_NAME
										),
										_react2.default.createElement(_AlertsViewer.AlertsViewer, null)
									),
									!this.state.partner && _react2.default.createElement(
										_rubix.Col,
										{ sm: 7, className: 'col-weather', style: { 'display': 'flex', 'align-items': 'center', 'justify-content': 'center' } },
										_react2.default.createElement('iframe', { id: 'wf-forecast-angers_lac-de-maine', src: 'https://www.windfinder.com/widget/forecast/angers_lac-de-maine?show_pressure=1&unit_temperature=c&show_day=1&show_rain=1&unit_rain=mm&days=4&unit_wind=kts&show_clouds=1&show_wind=1&show_temperature=1&show_waves=1&columns=2&unit_wave=m\', \'', scrolling: 'no', marginwidth: '0', width: '520px', height: '520px', marginheight: '0', frameborder: '0', style: { 'border': 'none' } }),
										'        '
									)
								)
							)
						)
					)
				);
			}
		}]);
		return HomePage;
	}(_react2.default.Component);
	
	exports.default = HomePage;

/***/ },

/***/ "./src/universal/components/alerts/AlertsViewer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.AlertsViewer = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _alerts = __webpack_require__("./src/universal/collections/alerts/alerts.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _Reactive = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var AlertsViewer = exports.AlertsViewer = (_dec = (0, _Reactive.Reactive)({
		subscriptions: ["alerts"],
		alerts: _alerts.Alerts.find({
			to: {
				$gte: new Date().toISOString()
			},
			from: {
				$lte: new Date().toISOString()
			}
		})
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(AlertsViewer, _React$Component);
	
		function AlertsViewer(props) {
			(0, _classCallCheck3.default)(this, AlertsViewer);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (AlertsViewer.__proto__ || (0, _getPrototypeOf2.default)(AlertsViewer)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(AlertsViewer, [{
			key: 'getContent',
			value: function getContent(content) {
				return _react2.default.createElement(
					'span',
					null,
					content.split("\n").map(function (item) {
						return _react2.default.createElement(
							'p',
							null,
							item
						);
					})
				);
			}
		}, {
			key: 'renderAlert',
			value: function renderAlert(alert) {
				if (alert.type == "Alerte") {
					return _react2.default.createElement(
						_reactBootstrap.Alert,
						{ bsStyle: 'danger' },
						_react2.default.createElement(
							'p',
							null,
							this.getContent(alert.content)
						)
					);
				} else if (alert.type == "Attention") {
					return _react2.default.createElement(
						_reactBootstrap.Alert,
						{ bsStyle: 'warning' },
						_react2.default.createElement(
							'p',
							null,
							this.getContent(alert.content)
						)
					);
				} else {
					return _react2.default.createElement(
						_reactBootstrap.Alert,
						{ bsStyle: 'info' },
						_react2.default.createElement(
							'p',
							null,
							this.getContent(alert.content)
						)
					);
				}
			}
		}, {
			key: 'renderAlerts',
			value: function renderAlerts() {
				var _this2 = this;
	
				var alerts = [];
				var user = Meteor.user();
	
				_lodash2.default.each(this.props.alerts, function (alert) {
					if (_lodash2.default.includes(alert.to_users, user._id) || _lodash2.default.intersection(alert.to_type, user.roles).length) {
						alerts.push(alert);
					}
				});
	
				return alerts.map(function (alert) {
					return _react2.default.createElement(
						'div',
						null,
						_this2.renderAlert(alert)
					);
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_rubix.BPanel,
					{ header: 'Alertes' },
					_react2.default.createElement(
						'div',
						{ className: 'alerts-viewer' },
						this.renderAlerts()
					)
				);
			}
		}]);
		return AlertsViewer;
	}(_react2.default.Component)) || _class);

/***/ },

/***/ "./src/universal/external_api/weather.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Weather = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HTTP = Package.http.HTTP;
	var Session = Package.session.Session;
	
	var Weather = exports.Weather = function (_React$Component) {
		(0, _inherits3.default)(Weather, _React$Component);
	
		function Weather(props) {
			(0, _classCallCheck3.default)(this, Weather);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (Weather.__proto__ || (0, _getPrototypeOf2.default)(Weather)).call(this, props));
	
			_this.state = {};
			_this.verify(props.date);
			return _this;
		}
	
		(0, _createClass3.default)(Weather, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(_ref) {
				var date = _ref.date;
	
				this.verify(date);
			}
		}, {
			key: 'verify',
			value: function verify(date) {
				if (Session.get(this.props.date)) {
					this.setState({
						sunrise: (0, _moment2.default)(Session.get(this.props.date).sunrise).format('kk:mm'),
						sunset: (0, _moment2.default)(Session.get(this.props.date).sunset).format('kk:mm')
					});
				} else {
					this.get(date);
				}
			}
		}, {
			key: 'get',
			value: function get(date) {
				var self = this;
				HTTP.call('GET', 'https://api.sunrise-sunset.org/json?lat=47.478419&lng=-0.563166&formatted=0&date=' + date, {}, function (error, response) {
					if (error) return console.error("Failed to fetch weather", error);
	
					self.set(response.data.results);
				});
			}
		}, {
			key: 'set',
			value: function set(data) {
				Session.setDefault(this.props.date, data);
				this.setState({
					sunrise: (0, _moment2.default)(data.sunrise).format('kk:mm'),
					sunset: (0, _moment2.default)(data.sunset).format('kk:mm')
				});
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.state.sunrise) {
					return _react2.default.createElement(
						'small',
						null,
						'( ',
						this.state.sunrise,
						' - ',
						this.state.sunset,
						' )'
					);
				} else {
					return _react2.default.createElement(
						'small',
						null,
						'-'
					);
				}
			}
		}]);
		return Weather;
	}(_react2.default.Component);

/***/ },

/***/ "./src/universal/components/auth/LoginPage.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var LoginPage = function (_React$Component) {
		(0, _inherits3.default)(LoginPage, _React$Component);
	
		function LoginPage(props) {
			(0, _classCallCheck3.default)(this, LoginPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (LoginPage.__proto__ || (0, _getPrototypeOf2.default)(LoginPage)).call(this, props));
	
			_this.state = {
				status: 'UNKNOWN',
				login: null,
				password: null
			};
	
			if (Meteor.user()) {
				_this.props.router.push('/app');
			}
			return _this;
		}
	
		(0, _createClass3.default)(LoginPage, [{
			key: 'login',
			value: function login(e) {
				var _this2 = this;
	
				e.preventDefault();
				var elements = e.target.elements;
	
				this.setState({ status: 'LOADING' });
				Meteor.loginWithPassword(elements.login.value, elements.password.value, function (error) {
					if (error) return _this2.setState({ status: 'LOGIN_FAILED' });
					_this2.props.router.push('/app');
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ id: 'auth-container', className: 'login' },
					_react2.default.createElement(
						'div',
						{ id: 'auth-row' },
						_react2.default.createElement(
							'div',
							{ id: 'auth-cell' },
							_react2.default.createElement(
								_rubix.Grid,
								null,
								_react2.default.createElement(
									_rubix.Row,
									null,
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 4, smOffset: 4, xs: 10, xsOffset: 1, collapseLeft: true, collapseRight: true },
										_react2.default.createElement(
											_rubix.PanelContainer,
											{ controls: false },
											_react2.default.createElement(
												_rubix.Panel,
												null,
												_react2.default.createElement(
													_rubix.PanelBody,
													{ style: { padding: 0 } },
													_react2.default.createElement(
														'div',
														{ className: 'text-center bg-darkblue fg-white' },
														_react2.default.createElement(
															'h3',
															{ style: { margin: 0, padding: 25 } },
															'Connexion'
														)
													),
													_react2.default.createElement(
														'div',
														null,
														_react2.default.createElement(
															'div',
															{ style: { padding: 25, paddingTop: 0, paddingBottom: 0, margin: 'auto', marginBottom: 25, marginTop: 25 } },
															_react2.default.createElement(
																_rubix.Form,
																{ onSubmit: this.login.bind(this) },
																_react2.default.createElement(
																	_rubix.FormGroup,
																	{ controlId: 'login' },
																	_react2.default.createElement(
																		_rubix.InputGroup,
																		{ bsSize: 'large' },
																		_react2.default.createElement(
																			_rubix.InputGroup.Addon,
																			null,
																			_react2.default.createElement(_rubix.Icon, { glyph: 'icon-fontello-user' })
																		),
																		_react2.default.createElement(_rubix.FormControl, { autoFocus: true, type: 'text', className: 'border-focus-blue', placeholder: 'Login', ref: 'login', name: 'email' })
																	)
																),
																_react2.default.createElement(
																	_rubix.FormGroup,
																	{ controlId: 'password' },
																	_react2.default.createElement(
																		_rubix.InputGroup,
																		{ bsSize: 'large' },
																		_react2.default.createElement(
																			_rubix.InputGroup.Addon,
																			null,
																			_react2.default.createElement(_rubix.Icon, { glyph: 'icon-fontello-key' })
																		),
																		_react2.default.createElement(_rubix.FormControl, { type: 'password', className: 'border-focus-blue', placeholder: 'Mot de passe', ref: 'password', name: 'password' })
																	)
																),
																_react2.default.createElement(
																	_rubix.Button,
																	{ outlined: true, lg: true, type: 'submit', bsStyle: 'blue', style: { margin: '16px auto', display: 'block', width: '100%' } },
																	this.state.status == 'LOADING' ? _react2.default.createElement(_rubix.Icon, { glyph: 'glyphicon-refresh', className: 'glyphicon-spin' }) : 'Se connecter'
																),
																_react2.default.createElement(
																	_rubix.Fade,
																	{ 'in': this.state.status == 'LOGIN_FAILED' },
																	_react2.default.createElement(
																		_rubix.Alert,
																		{ bsStyle: 'danger' },
																		_react2.default.createElement(
																			'strong',
																			null,
																			'Mauvaise combinaison login/mot de passe.'
																		)
																	)
																)
															)
														)
													)
												)
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
		return LoginPage;
	}(_react2.default.Component);
	
	exports.default = LoginPage;

/***/ },

/***/ "./src/universal/components/montgolfieres/MontgolfiereAdd.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _mgfForm = __webpack_require__("./src/universal/components/common/mgfForm.js");
	
	var _mgfForm2 = _interopRequireDefault(_mgfForm);
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Accounts = Package['accounts-base'].Accounts;
	
	var MontgolfiereAddPage = function (_React$Component) {
		(0, _inherits3.default)(MontgolfiereAddPage, _React$Component);
	
		function MontgolfiereAddPage(props) {
			(0, _classCallCheck3.default)(this, MontgolfiereAddPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (MontgolfiereAddPage.__proto__ || (0, _getPrototypeOf2.default)(MontgolfiereAddPage)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(MontgolfiereAddPage, [{
			key: 'handleSubmit',
			value: function handleSubmit(doc) {
				this.context.router.push('/montgolfieres');
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/montgolfieres' },
								'Montgolfieres'
							)
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ href: '#', active: true },
							'Ajouter une montgolfiere'
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Ajouter une montgolfiere' },
						_react2.default.createElement(_mgfForm2.default, { schema: _montgolfieres.MontgolfiereSchema, collection: _montgolfieres.Montgolfieres, onSubmit: this.handleSubmit.bind(this) })
					)
				);
			}
		}]);
		return MontgolfiereAddPage;
	}(_react2.default.Component);
	
	exports.default = MontgolfiereAddPage;
	
	
	MontgolfiereAddPage.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/montgolfieres/MontgolfiereEdit.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _mgfForm = __webpack_require__("./src/universal/components/common/mgfForm.js");
	
	var _mgfForm2 = _interopRequireDefault(_mgfForm);
	
	var _uniformsBootstrap = __webpack_require__("./node_modules/uniforms-bootstrap3/index.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _Reactive = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Accounts = Package['accounts-base'].Accounts;
	var MontgolfiereEditPage = (_dec = (0, _Reactive.Reactive)({
		subscriptions: ["montgolfieres"]
	}), _dec(_class = (0, _reactRouter.withRouter)(_class = function (_React$Component) {
		(0, _inherits3.default)(MontgolfiereEditPage, _React$Component);
	
		function MontgolfiereEditPage(props) {
			(0, _classCallCheck3.default)(this, MontgolfiereEditPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (MontgolfiereEditPage.__proto__ || (0, _getPrototypeOf2.default)(MontgolfiereEditPage)).call(this, props));
	
			_this.state = {};
	
			if (!_this.props.params.id) _this.props.router.push('/montgolfieres');
			return _this;
		}
	
		(0, _createClass3.default)(MontgolfiereEditPage, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.isReady && !this.props.isReady) this.setState({
					montgolfiere: _montgolfieres.Montgolfieres.findOne({ _id: this.props.params.id })
				});
			}
		}, {
			key: 'handleSubmit',
			value: function handleSubmit(doc) {
				this.props.router.push('/montgolfieres');
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/montgolfieres' },
								'Montgolfieres'
							)
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ href: '#', active: true },
							'Modifier une montgolfiere'
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Modifier la montgolfiere' },
						this.props.isReady && _react2.default.createElement(_mgfForm2.default, { schema: _montgolfieres.MontgolfiereSchema, collection: _montgolfieres.Montgolfieres, model: this.state.montgolfiere, onSubmit: this.handleSubmit.bind(this) })
					)
				);
			}
		}]);
		return MontgolfiereEditPage;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = MontgolfiereEditPage;

/***/ },

/***/ "./src/universal/components/montgolfieres/MontgolfiereView.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _mgfForm = __webpack_require__("./src/universal/components/common/mgfForm.js");
	
	var _mgfForm2 = _interopRequireDefault(_mgfForm);
	
	var _uniformsBootstrap = __webpack_require__("./node_modules/uniforms-bootstrap3/index.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _Reactive = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Accounts = Package['accounts-base'].Accounts;
	var Tracker = Package.tracker.Tracker;
	
	var DatePicker = __webpack_require__("./node_modules/react-bootstrap-date-picker/lib/index.js");
	
	var MontgolfiereViewPage = (_dec = (0, _Reactive.Reactive)({
		subscriptions: ["montgolfieres", "flights"]
	}), _dec(_class = (0, _reactRouter.withRouter)(_class = function (_React$Component) {
		(0, _inherits3.default)(MontgolfiereViewPage, _React$Component);
	
		function MontgolfiereViewPage(props) {
			(0, _classCallCheck3.default)(this, MontgolfiereViewPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (MontgolfiereViewPage.__proto__ || (0, _getPrototypeOf2.default)(MontgolfiereViewPage)).call(this, props));
	
			_this.state = {};
			//set start and ending date :
			_this.state.startDate = (0, _moment2.default)().startOf('year').format();
			_this.state.endDate = (0, _moment2.default)().format();
			return _this;
		}
	
		(0, _createClass3.default)(MontgolfiereViewPage, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.isReady && !this.props.isReady) {
					this.setState({
						flights: _flights.Flights.find((0, _defineProperty3.default)({ montgolfiereId: this.props.params.id, createdAt: { $gte: (0, _moment2.default)(this.state.startDate).toDate() } }, 'createdAt', { $lte: (0, _moment2.default)(this.state.endDate).toDate() }), { sort: { date: 1 } }).fetch().reverse()
					});
				}
			}
		}, {
			key: 'changeDate',
			value: function changeDate() {
				this.setState({
					flights: _flights.Flights.find((0, _defineProperty3.default)({ pilotId: Meteor.user()._id, createdAt: { $gt: (0, _moment2.default)(this.state.startDate).toDate() } }, 'createdAt', { $lt: (0, _moment2.default)(this.state.endDate).toDate() }), { sort: { date: 1 } }).fetch().reverse()
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				if (!this.state.flights) {
					return _react2.default.createElement(
						'div',
						null,
						'Chargement...'
					);
				}
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Filtrer' },
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 1 },
							'Du'
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 4 },
							_react2.default.createElement(DatePicker, {
								dayLabels: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
								monthLabels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
								id: 'start_date', value: this.state.startDate, onChange: function onChange(value) {
									return _this2.setState({ startDate: value });
								} })
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 1 },
							'Au'
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 4 },
							_react2.default.createElement(DatePicker, {
								dayLabels: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
								monthLabels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
								id: 'end_date', value: this.state.endDate, onChange: function onChange(value) {
									return _this2.setState({ endDate: value });
								} })
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 2 },
							_react2.default.createElement(
								_rubix.Button,
								{ onClick: this.changeDate.bind(this) },
								'Changer'
							)
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: "Liste de vos vols (" + this.state.count + " vols) :" },
						_react2.default.createElement(
							_rubix.Table,
							{ responsive: true },
							_react2.default.createElement(
								'thead',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'th',
										null,
										'Date'
									),
									_react2.default.createElement(
										'th',
										null,
										'P\xE9riode'
									),
									_react2.default.createElement(
										'th',
										null,
										'Status'
									),
									_react2.default.createElement(
										'th',
										null,
										'Lieu'
									),
									_react2.default.createElement(
										'th',
										null,
										'Actions'
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								this.state.flights.map(function (flight) {
									return _react2.default.createElement(
										'tr',
										null,
										_react2.default.createElement(
											'td',
											null,
											flight.getDisplayDate()
										),
										_react2.default.createElement(
											'td',
											null,
											flight.getPeriod()
										),
										_react2.default.createElement(
											'td',
											null,
											flight.getStatus()
										),
										_react2.default.createElement(
											'td',
											null,
											flight.getPlace()
										),
										_react2.default.createElement(
											'td',
											null,
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: '/flights/' + flight._id + '/detail' },
												_react2.default.createElement(
													_rubix.Button,
													{ bsStyle: 'primary' },
													'Voir'
												)
											)
										)
									);
								})
							)
						)
					)
				);
			}
		}]);
		return MontgolfiereViewPage;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = MontgolfiereViewPage;

/***/ },

/***/ "./src/universal/components/montgolfieres/MontgolfiereList.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _mgfTable = __webpack_require__("./src/universal/components/common/mgfTable.js");
	
	var _mgfTable2 = _interopRequireDefault(_mgfTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Tracker = Package.tracker.Tracker;
	var MontgolfiereListPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["montgolfieres"]
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(MontgolfiereListPage, _React$Component);
	
		function MontgolfiereListPage(props) {
			(0, _classCallCheck3.default)(this, MontgolfiereListPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (MontgolfiereListPage.__proto__ || (0, _getPrototypeOf2.default)(MontgolfiereListPage)).call(this, props));
	
			_this.state = {
				archived: false,
				montgolfieres: []
			};
	
			props.ready.then(function () {
				Tracker.autorun(function () {
					_this.setState({
						'montgolfieres': _montgolfieres.Montgolfieres.find({ archived: { $ne: true } }, { sort: { id: -1 } }).fetch()
					});
				});
			});
			return _this;
		}
	
		(0, _createClass3.default)(MontgolfiereListPage, [{
			key: 'toggleArchived',
			value: function toggleArchived() {
				this.setState({
					archived: !this.state.archived
				});
	
				console.log('achived', this.state.archived);
				if (!this.state.archived) {
					this.setState({
						'montgolfieres': _montgolfieres.Montgolfieres.find({ archived: true }, { sort: { id: -1 } }).fetch()
					});
				} else {
					this.setState({
						'montgolfieres': _montgolfieres.Montgolfieres.find({ archived: { $ne: true } }, { sort: { id: -1 } }).fetch()
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							'Montgolfieres'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ active: true },
							'Liste des montgolfieres'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_roles.Roles.userHasPermission(Meteor.userId(), 'montgolfieres.insert') && _react2.default.createElement(
								_reactRouter.Link,
								{ to: '/montgolfieres/add' },
								_react2.default.createElement(
									_rubix.Button,
									{ bsStyle: 'success' },
									'Ajouter'
								)
							)
						)
					),
					_react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'primary', onClick: this.toggleArchived.bind(this) },
						!this.state.archived ? _react2.default.createElement(
							'p',
							null,
							'Voir les montgolfieres archiv\xE9es'
						) : _react2.default.createElement(
							'p',
							null,
							'Voir les montgolfieres actives'
						)
					),
					_react2.default.createElement('br', null),
					_react2.default.createElement('br', null),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Liste des montgolfieres' },
						this.props.isReady && _react2.default.createElement(_mgfTable2.default, { fields: _montgolfieres.MontgolfiereSchema._schema, list: this.state.montgolfieres, type: 'montgolfieres' })
					)
				);
			}
		}]);
		return MontgolfiereListPage;
	}(_react2.default.Component)) || _class);
	exports.default = MontgolfiereListPage;
	
	
	MontgolfiereListPage.propTypes = {
		montgolfieres: _react2.default.PropTypes.array.isRequired
	};

/***/ },

/***/ "./src/universal/components/statistiques/MyFlights.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var DatePicker = __webpack_require__("./node_modules/react-bootstrap-date-picker/lib/index.js");
	var MyFlightsPage = (_dec = (0, _ReactiveMixin.Reactive)({
	  subscriptions: ["flights", "users"]
	}), _dec(_class = function (_React$Component) {
	  (0, _inherits3.default)(MyFlightsPage, _React$Component);
	
	  function MyFlightsPage(props) {
	    (0, _classCallCheck3.default)(this, MyFlightsPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MyFlightsPage.__proto__ || (0, _getPrototypeOf2.default)(MyFlightsPage)).call(this, props));
	
	    _this.state = {};
	
	    //set start and ending date :
	    _this.state.startDate = (0, _moment2.default)().startOf('year').format();
	    _this.state.endDate = (0, _moment2.default)().format();
	
	    props.ready.then(function () {
	      _this.setState({
	        flights: _flights.Flights.find({ pilotId: Meteor.user()._id, createdAt: { $gte: (0, _moment2.default)(_this.state.startDate).toDate(), $lte: (0, _moment2.default)(_this.state.endDate).toDate() } }).fetch().reverse(),
	        pilots: Meteor.users.find({ roles: { $in: ['pilot'] } }).fetch()
	      });
	    });
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(MyFlightsPage, [{
	    key: 'update',
	    value: function update() {
	
	      var pilot = _reactDom2.default.findDOMNode(this.refs.pilot).value.trim();
	      var status = [_reactDom2.default.findDOMNode(this.refs.status).value.trim()];
	
	      if (!status[0]) {
	        status = ["preparing", "prepared", "cancelled", "validated"];
	      }
	
	      if (!_.includes(Meteor.user().roles, 'god')) {
	        pilot = Meteor.user()._id;
	      }
	
	      if (!pilot) {
	        this.setState({
	          flights: _flights.Flights.find({ status: { $in: status }, date: { $gte: (0, _moment2.default)(this.state.startDate).toDate(), $lte: (0, _moment2.default)(this.state.endDate).toDate() } }, { sort: { date: -1 } }).fetch()
	        });
	      } else {
	        this.setState({
	          flights: _flights.Flights.find({ pilotId: pilot, status: { $in: status }, date: { $gt: (0, _moment2.default)(this.state.startDate).toDate(), $lt: (0, _moment2.default)(this.state.endDate).toDate() } }, { sort: { date: -1 } }).fetch()
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (!this.state.flights) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          'Chargement...'
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _rubix.BPanel,
	          { header: 'Mes vols' },
	          _.includes(Meteor.user().roles, 'god') && _react2.default.createElement(
	            _rubix.BPanel,
	            { header: 'Filtrer par pilote' },
	            _react2.default.createElement(
	              _rubix.FormControl,
	              { id: 'pilot', componentClass: 'select', type: 'select', ref: 'pilot' },
	              _react2.default.createElement(
	                'option',
	                { value: '' },
	                'Tous les pilotes'
	              ),
	              this.state.pilots.map(function (pilot) {
	                return _react2.default.createElement(
	                  'option',
	                  { value: pilot._id },
	                  pilot.displayName()
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _rubix.Col,
	            { sm: 1 },
	            'Du'
	          ),
	          _react2.default.createElement(
	            _rubix.Col,
	            { sm: 5 },
	            _react2.default.createElement(DatePicker, {
	              dayLabels: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
	              monthLabels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
	              id: 'start_date', value: this.state.startDate, onChange: function onChange(value) {
	                return _this2.setState({ startDate: value });
	              } })
	          ),
	          _react2.default.createElement(
	            _rubix.Col,
	            { sm: 1 },
	            'Au'
	          ),
	          _react2.default.createElement(
	            _rubix.Col,
	            { sm: 5 },
	            _react2.default.createElement(DatePicker, {
	              dayLabels: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
	              monthLabels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
	              id: 'end_date', value: this.state.endDate, onChange: function onChange(value) {
	                return _this2.setState({ endDate: value });
	              } })
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            _rubix.Col,
	            { sm: 1 },
	            'Status'
	          ),
	          _react2.default.createElement(
	            _rubix.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              _rubix.FormControl,
	              { id: 'status', componentClass: 'select', type: 'select', ref: 'status', onChange: function onChange(value) {
	                  return _this2.setState({ status: value });
	                } },
	              _react2.default.createElement(
	                'option',
	                { value: '' },
	                'Tous les vols'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'validated' },
	                'Cl\xF4tur\xE9'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'preparing' },
	                'En pr\xE9paration'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'cancelled' },
	                'Annul\xE9'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _rubix.Col,
	            { sm: 2 },
	            _react2.default.createElement(
	              _rubix.Button,
	              { onClick: this.update.bind(this) },
	              'Changer'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _rubix.BPanel,
	          { header: "Liste de vos vols (" + this.state.flights.length + " vols) :" },
	          _react2.default.createElement(
	            _rubix.Table,
	            { responsive: true },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Date'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Pilote'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'P\xE9riode'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Status'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Lieu'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Actions'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              this.state.flights.map(function (flight) {
	                return _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    flight.getDisplayDate()
	                  ),
	                  flight.getPilote() && _react2.default.createElement(
	                    'td',
	                    null,
	                    flight.getPilote().displayName()
	                  ),
	                  !flight.getPilote() && _react2.default.createElement(
	                    'td',
	                    null,
	                    'Pilote supprim\xE9'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    flight.getPeriod()
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    flight.getStatus()
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    flight.getPlace()
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { to: '/flights/' + flight._id + '/detail' },
	                      _react2.default.createElement(
	                        _rubix.Button,
	                        { bsStyle: 'primary' },
	                        'Voir'
	                      )
	                    )
	                  )
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return MyFlightsPage;
	}(_react2.default.Component)) || _class);
	exports.default = MyFlightsPage;

/***/ },

/***/ "./src/universal/components/flights/FlightDetail.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var HTTP = Package.http.HTTP;
	
	var DatePicker = __webpack_require__("./node_modules/react-bootstrap-date-picker/lib/index.js");
	var Base64 = Package.base64.Base64;
	var FlightDetailPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: [{ name: 'flight', param: 'id' }]
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(FlightDetailPage, _React$Component);
	
		function FlightDetailPage(props) {
			(0, _classCallCheck3.default)(this, FlightDetailPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (FlightDetailPage.__proto__ || (0, _getPrototypeOf2.default)(FlightDetailPage)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(FlightDetailPage, [{
			key: 'openPopUp',
			value: function openPopUp(urlToOpen) {
				var popup_window = window.open(urlToOpen, "myWindow", "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=yes, width=400, height=400");
				try {
					popup_window.focus();
				} catch (e) {
					alert("Les fenêtes Pop-up sont bloquées ! Pour télécharger ce document, merci de les débloquer.");
				}
			}
		}, {
			key: 'downloadDDV',
			value: function downloadDDV() {
				var _this2 = this;
	
				var flight = this.state.flight;
				var reservations = _reservations.Reservations.find({ _id: { $in: flight.reservationIds } }, { fields: { "id_billet": 1, "passengers": 1, "payment": 1 } }).fetch();
	
				_.each(reservations, function (reservation) {
					reservation.passengers = reservation.getPassengers();
					console.log('getPassengers', reservation.getPassengers());
					reservation.payementMode = reservation.getPayment();
				});
	
				var selectedMontgolfiere = _montgolfieres.Montgolfieres.findOne(flight.montgolfiereId);
				var montgolfieresDatas = _montgolfieres.Montgolfieres.find({ $or: [{ online: true }, { _id: flight.montgolfiereId }] }).fetch();
	
				var montgolfieres = [];
				_.each(montgolfieresDatas, function (montgolfiere) {
					montgolfieres.push({
						'maxWeight': montgolfiere.maxWeight,
						'defaultWeight': montgolfiere.defaultWeight,
						'emptyWeight': montgolfiere.emptyWeight,
						'name': montgolfiere.name,
						'archived': montgolfiere.archived
					});
				});
	
				var pilote = Meteor.users.findOne(flight.pilotId);
	
				var data = {
					montgolfieres: montgolfieres,
					selectedMontgolfiere: {
						'defaultWeight': selectedMontgolfiere.defaultWeight,
						'maxWeight': selectedMontgolfiere.maxWeight,
						'name': selectedMontgolfiere.name
					},
					reservations: reservations,
					temp: flight.temp,
					date: (0, _moment2.default)(flight.date).format('DD/MM/YYYY'),
					period: flight.period,
					place: flight.place,
					pilote: {
						'firstName': pilote.profile.firstName,
						'lastName': pilote.profile.lastName,
						'weight': pilote.profile.weight
					},
					meetPoint: flight.getMeetPoint(),
					meetingDate: (0, _moment2.default)(flight.meetingDate).format('HH:mm')
				};
	
				console.log('data', data);
	
				HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=vol', {
					data: data
				}, function (error, result) {
					result = JSON.parse(result.content);
					_this2.openPopUp("https://montgolfieres-pdf.amaia.at/" + result.id + ".pdf");
				});
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.isReady && !this.props.isReady) {
					this.setState({
						flight: _flights.Flights.findOne({ _id: this.props.params.id })
					});
	
					console.log('flight', _flights.Flights.findOne({ _id: this.props.params.id }).getReservations());
				}
			}
		}, {
			key: 'render',
			value: function render() {
	
				if (!this.state.flight) {
					return _react2.default.createElement(
						'div',
						null,
						'Chargement...'
					);
				}
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: "Vol du " + (0, _moment2.default)(this.state.flight.date).format('DD/MM/YYYY') + " le " + this.state.flight.getPeriod() },
						_react2.default.createElement(
							_rubix.Table,
							{ striped: true, bordered: true, condensed: true, hover: true },
							_react2.default.createElement(
								'tbody',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Date'
									),
									_react2.default.createElement(
										'td',
										null,
										(0, _moment2.default)(this.state.flight.date).format('DD/MM/YYYY')
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'P\xE9riode'
									),
									_react2.default.createElement(
										'td',
										null,
										this.state.flight.getPeriod()
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Lieu d\'envol'
									),
									_react2.default.createElement(
										'td',
										null,
										this.state.flight.getPlace()
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Status'
									),
									_react2.default.createElement(
										'td',
										null,
										this.state.flight.getStatus()
									)
								),
								this.state.flight.getPilote() && _react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Pilote'
									),
									_react2.default.createElement(
										'td',
										null,
										this.state.flight.getPilote().displayName()
									)
								),
								this.state.flight.getMontgolfiere() && _react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Montgolfiere'
									),
									_react2.default.createElement(
										'td',
										null,
										this.state.flight.getMontgolfiere().name
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'R\xE9servations'
									),
									_react2.default.createElement(
										'td',
										null,
										this.state.flight.getReservations().map(function (reservation) {
											return _react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													_react2.default.createElement(
														_reactRouter.Link,
														{ to: 'reservations/' + reservation._id },
														'Reservation n\xB0 ',
														reservation.id_billet
													)
												)
											);
										})
									)
								)
							)
						),
						_react2.default.createElement(
							_rubix.Table,
							{ striped: true, bordered: true, condensed: true, hover: true },
							_react2.default.createElement(
								'tbody',
								null,
								this.state.flight.meetingDate && _react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Heure de rendez-vous'
									),
									_react2.default.createElement(
										'td',
										null,
										(0, _moment2.default)(this.state.flight.meetingDate).format('HH:mm')
									)
								),
								this.state.flight.getMeetPoint() && _react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Lieu de rendez-vous'
									),
									_react2.default.createElement(
										'td',
										null,
										this.state.flight.getMeetPoint().name
									)
								)
							)
						),
						_react2.default.createElement(
							_rubix.Table,
							{ striped: true, bordered: true, condensed: true, hover: true },
							_react2.default.createElement(
								'tbody',
								null,
								this.state.flight.takeOffDate && _react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Heure de d\xE9collage'
									),
									_react2.default.createElement(
										'td',
										null,
										(0, _moment2.default)(this.state.flight.takeOffDate).format('HH:mm')
									)
								),
								this.state.flight.landingDate && _react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Heure d\'atterrissage'
									),
									_react2.default.createElement(
										'td',
										null,
										(0, _moment2.default)(this.state.flight.landingDate).format('HH:mm')
									)
								),
								this.state.flight.time && _react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Dur\xE9e du vol'
									),
									_react2.default.createElement(
										'td',
										null,
										Math.abs(this.state.flight.time) + 'mn'
									)
								),
								this.state.flight.takeOffPlace && _react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Lieu de d\xE9collage'
									),
									_react2.default.createElement(
										'td',
										null,
										this.state.flight.takeOffPlace
									)
								),
								this.state.flight.landingPlace && _react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Lieu d\'atterrissage'
									),
									_react2.default.createElement(
										'td',
										null,
										this.state.flight.landingPlace
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Dossier de vol'
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(
											_rubix.Button,
											{ bsStyle: 'info', onClick: this.downloadDDV.bind(this) },
											'T\xE9l\xE9charger'
										)
									)
								)
							)
						),
						_react2.default.createElement('br', null)
					)
				);
			}
		}]);
		return FlightDetailPage;
	}(_react2.default.Component)) || _class);
	exports.default = FlightDetailPage;

/***/ },

/***/ "./src/universal/components/options/OptionsForm.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _options = __webpack_require__("./src/universal/collections/flights-type/options.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var OptionsFormPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["flights-type"]
	}), (0, _reactRouter.withRouter)(_class = _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(OptionsFormPage, _React$Component);
	
		function OptionsFormPage(props) {
			(0, _classCallCheck3.default)(this, OptionsFormPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (OptionsFormPage.__proto__ || (0, _getPrototypeOf2.default)(OptionsFormPage)).call(this, props));
	
			_this.state = {};
			if (_this.props.params.id) _this.option = _options.Options.find({ _id: _this.props.params.id }).fetch()[0];else _this.option = {};
			return _this;
		}
	
		(0, _createClass3.default)(OptionsFormPage, [{
			key: 'handleSubmit',
			value: function handleSubmit(e) {
				e.preventDefault();
	
				var params = {};
				var message = null;
				var method = null;
	
				params.attributes = {};
				_lodash2.default.each(this.refs, function (ref, key) {
					params.attributes[key] = _reactDom2.default.findDOMNode(ref).value.trim();
				});
	
				if (this.props.params.id) {
					message = "L'option a été modifiée avec succès.";
					method = "options.update";
					params._id = this.props.params.id;
				} else {
					message = "L'option a été ajoutée avec succès.";
					method = "options.insert";
					params.attributes["createdAt"] = new Date();
				}
	
				Meteor.call(method, params, function (err, _id) {
	
					if (err) {
						Messenger().post({
							message: err,
							type: "error"
						});
						return;
					}
	
					Messenger().post({
						message: message,
						type: "success"
					});
					this.props.router.push('/options');
				}.bind(this));
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/options' },
								'Options'
							)
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ href: '#', active: true },
							'Ajouter/Modifier une option'
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Ajouter/Modifier une option' },
						_react2.default.createElement(
							_rubix.Form,
							{ horizontal: true, onSubmit: this.handleSubmit.bind(this) },
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalEmail' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'Titre de l\'option'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 10 },
									_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'title', defaultValue: this.option.title })
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalEmail' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'Prix de l\'option'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 10 },
									_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'price', defaultValue: this.option.price })
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalPassword' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'R\xE9f\xE9rence*'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 2 },
									_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'reference', defaultValue: this.option.reference })
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 8 },
									_react2.default.createElement(
										'small',
										null,
										'* laisser vide si cette option n\'existe pas sur le site.'
									)
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								null,
								_react2.default.createElement(
									_rubix.Col,
									{ smOffset: 2, sm: 10 },
									_react2.default.createElement(
										_rubix.Button,
										{ type: 'submit' },
										'Enregistrer'
									)
								)
							)
						)
					)
				);
			}
		}]);
		return OptionsFormPage;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = OptionsFormPage;
	
	
	OptionsFormPage.propTypes = {
		options: _react2.default.PropTypes.array.isRequired
	};
	
	OptionsFormPage.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/options/OptionsList.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _options = __webpack_require__("./src/universal/collections/flights-type/options.js");
	
	var _componentOptionsList = __webpack_require__("./src/universal/components/options/component-options-list.js");
	
	var _componentOptionsList2 = _interopRequireDefault(_componentOptionsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var OptionsListPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["flights-type"],
		options: _options.Options.find({})
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(OptionsListPage, _React$Component);
	
		function OptionsListPage(props) {
			(0, _classCallCheck3.default)(this, OptionsListPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (OptionsListPage.__proto__ || (0, _getPrototypeOf2.default)(OptionsListPage)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(OptionsListPage, [{
			key: 'renderOptions',
			value: function renderOptions() {
				return this.props.options.map(function (option) {
					return _react2.default.createElement(_componentOptionsList2.default, { key: option._id, option: option });
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							'Options'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ active: true },
							'Liste des options'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/options-add' },
								_react2.default.createElement(
									_rubix.Button,
									{ bsStyle: 'success' },
									'Ajouter'
								)
							)
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Liste des options' },
						_react2.default.createElement(
							_rubix.Table,
							{ responsive: true },
							_react2.default.createElement(
								'thead',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'th',
										null,
										'Nom'
									),
									_react2.default.createElement(
										'th',
										null,
										'Prix par passager'
									),
									_react2.default.createElement(
										'th',
										null,
										'Date de cr\xE9ation'
									),
									_react2.default.createElement(
										'th',
										null,
										'Derni\xE8re modification'
									),
									_react2.default.createElement(
										'th',
										null,
										'Actions'
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								this.renderOptions()
							)
						)
					)
				);
			}
		}]);
		return OptionsListPage;
	}(_react2.default.Component)) || _class);
	exports.default = OptionsListPage;

/***/ },

/***/ "./src/universal/components/options/component-options-list.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _reactRouter2 = _interopRequireDefault(_reactRouter);
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var OptionListComponent = function (_React$Component) {
	  (0, _inherits3.default)(OptionListComponent, _React$Component);
	
	  function OptionListComponent() {
	    (0, _classCallCheck3.default)(this, OptionListComponent);
	    return (0, _possibleConstructorReturn3.default)(this, (OptionListComponent.__proto__ || (0, _getPrototypeOf2.default)(OptionListComponent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(OptionListComponent, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          this.props.option.title
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          this.props.option.price,
	          '\u20AC'
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _reactMoment2.default,
	            { format: 'DD/MM/YYYY' },
	            this.props.option.createdAt
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _reactMoment2.default,
	            { format: 'DD/MM/YYYY' },
	            this.props.option.editedAt
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _rubix.Button,
	            { bsStyle: 'warning', onClick: this.goToEditView.bind(this) },
	            'Modifier'
	          ),
	          '\xA0\xA0',
	          _react2.default.createElement(
	            _rubix.Button,
	            { bsStyle: 'danger', onClick: this.deleteThisPrice.bind(this) },
	            'Supprimer'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'deleteThisPrice',
	    value: function deleteThisPrice() {
	      Meteor.call('options.remove', this.props.option._id);
	    }
	  }, {
	    key: 'goToEditView',
	    value: function goToEditView() {
	      this.context.router.push('/options/' + this.props.option._id);
	    }
	  }]);
	  return OptionListComponent;
	}(_react2.default.Component);
	
	exports.default = OptionListComponent;
	
	
	OptionListComponent.propTypes = {
	  // This component gets the task to display through a React prop.
	  // We can use propTypes to indicate it is required
	  option: _react2.default.PropTypes.object.isRequired
	};
	
	OptionListComponent.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/places/PlaceAdd.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _mgfForm = __webpack_require__("./src/universal/components/common/mgfForm.js");
	
	var _mgfForm2 = _interopRequireDefault(_mgfForm);
	
	var _places = __webpack_require__("./src/universal/collections/flights/places.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Accounts = Package['accounts-base'].Accounts;
	
	var PlaceAddPage = function (_React$Component) {
		(0, _inherits3.default)(PlaceAddPage, _React$Component);
	
		function PlaceAddPage(props) {
			(0, _classCallCheck3.default)(this, PlaceAddPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (PlaceAddPage.__proto__ || (0, _getPrototypeOf2.default)(PlaceAddPage)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(PlaceAddPage, [{
			key: 'handleSubmit',
			value: function handleSubmit(doc) {
				this.context.router.push('/places');
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/places' },
								'Lieux d\'envols'
							)
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ href: '#', active: true },
							'Ajouter un lieu d\'envol'
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Ajouter un lieu d\'envol' },
						_react2.default.createElement(_mgfForm2.default, { schema: _places.PlaceSchema, collection: _places.Places, onSubmit: this.handleSubmit.bind(this) })
					)
				);
			}
		}]);
		return PlaceAddPage;
	}(_react2.default.Component);
	
	exports.default = PlaceAddPage;
	
	
	PlaceAddPage.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/places/PlaceEdit.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _mgfForm = __webpack_require__("./src/universal/components/common/mgfForm.js");
	
	var _mgfForm2 = _interopRequireDefault(_mgfForm);
	
	var _uniformsBootstrap = __webpack_require__("./node_modules/uniforms-bootstrap3/index.js");
	
	var _places = __webpack_require__("./src/universal/collections/flights/places.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Accounts = Package['accounts-base'].Accounts;
	
	var PlaceEditPage = function (_React$Component) {
		(0, _inherits3.default)(PlaceEditPage, _React$Component);
	
		function PlaceEditPage(props) {
			(0, _classCallCheck3.default)(this, PlaceEditPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (PlaceEditPage.__proto__ || (0, _getPrototypeOf2.default)(PlaceEditPage)).call(this, props));
	
			_this.state = {};
	
			if (_this.props.params.id) _this.place = _places.Places.findOne({ _id: _this.props.params.id });else _this.context.router.push('/places');
			return _this;
		}
	
		(0, _createClass3.default)(PlaceEditPage, [{
			key: 'handleSubmit',
			value: function handleSubmit(doc) {
				this.context.router.push('/places');
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/places' },
								'Lieux d\'envols'
							)
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ href: '#', active: true },
							'Modifier un lieu d\'envol'
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Modifier un lieu d\'evol' },
						_react2.default.createElement(_mgfForm2.default, { schema: _places.PlaceSchema, collection: _places.Places, model: this.place, onSubmit: this.handleSubmit.bind(this) })
					)
				);
			}
		}]);
		return PlaceEditPage;
	}(_react2.default.Component);
	
	exports.default = PlaceEditPage;
	
	
	PlaceEditPage.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/places/PlaceList.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _places = __webpack_require__("./src/universal/collections/flights/places.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _mgfTable = __webpack_require__("./src/universal/components/common/mgfTable.js");
	
	var _mgfTable2 = _interopRequireDefault(_mgfTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var PlaceListPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["places"],
		places: _places.Places.find({})
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(PlaceListPage, _React$Component);
	
		function PlaceListPage(props) {
			(0, _classCallCheck3.default)(this, PlaceListPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (PlaceListPage.__proto__ || (0, _getPrototypeOf2.default)(PlaceListPage)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(PlaceListPage, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							'Places'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ active: true },
							'Liste des places'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_roles.Roles.userHasPermission(Meteor.userId(), 'places.insert') && _react2.default.createElement(
								_reactRouter.Link,
								{ to: '/places/add' },
								_react2.default.createElement(
									_rubix.Button,
									{ bsStyle: 'success' },
									'Ajouter'
								)
							)
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Liste des places' },
						this.props.isReady && _react2.default.createElement(_mgfTable2.default, { fields: _places.PlaceSchema._schema, list: this.props.places, type: 'places', subtype: 'flights' })
					)
				);
			}
		}]);
		return PlaceListPage;
	}(_react2.default.Component)) || _class);
	exports.default = PlaceListPage;
	
	
	PlaceListPage.propTypes = {
		places: _react2.default.PropTypes.array.isRequired
	};

/***/ },

/***/ "./src/universal/components/planifications/PlanificationAddMultiplePage.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _PlanificationGroup = __webpack_require__("./src/universal/components/planifications/PlanificationGroup.component.js");
	
	var _methods = __webpack_require__("./src/universal/collections/availabilities/methods.js");
	
	var _Reactive = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var DatePicker = __webpack_require__("./node_modules/react-bootstrap-date-picker/lib/index.js");
	
	var PlanificationAddMultiplePage = (_dec = (0, _Reactive.Reactive)({
		subscriptions: ["users", "montgolfieres"],
		pilots: Meteor.users.find({ "roles": { $in: ["pilot"] } }),
		montgolfieres: _montgolfieres.Montgolfieres.find({ archived: { $ne: true } })
	}), _dec(_class = (0, _reactRouter.withRouter)(_class = function (_React$Component) {
		(0, _inherits3.default)(PlanificationAddMultiplePage, _React$Component);
	
		function PlanificationAddMultiplePage(props) {
			(0, _classCallCheck3.default)(this, PlanificationAddMultiplePage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (PlanificationAddMultiplePage.__proto__ || (0, _getPrototypeOf2.default)(PlanificationAddMultiplePage)).call(this, props));
	
			_this.state = {
				startDate: new Date().toISOString(),
				endDate: new Date().toISOString(),
				override: false,
				anjouAllDay: false,
				nantesAllDay: false,
				groups: [{
					period: "morning", place: "anjou", items: []
				}, {
					period: "morning", place: "nantes", items: []
				}, {
					period: "evening", place: "anjou", items: []
				}, {
					period: "evening", place: "nantes", items: []
				}]
			};
			return _this;
		}
	
		(0, _createClass3.default)(PlanificationAddMultiplePage, [{
			key: 'onChange',
			value: function onChange(groupKey, _id, target, isAvailable) {
				if (!_id || !target) return;
	
				if (isAvailable == undefined) this.state.groups[groupKey].items = this.state.groups[groupKey].items.filter(function (item) {
					return item._id !== _id;
				});else this.state.groups[groupKey].items.push({ _id: _id, target: target, isAvailable: isAvailable });
	
				this.setState({
					groups: this.state.groups
				});
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit() {
				var _this2 = this;
	
				var groups = this.state.groups;
	
				if (this.state.anjouAllDay) groups[2].items = groups[0].items;
				if (this.state.nantesAllDay) groups[3].items = groups[1].items;
	
				var online = parseInt(_reactDom2.default.findDOMNode(this.refs.online).value);
				console.log('online', online);
	
				_methods.scheduleManyAvailabilities.call({
					groups: groups,
					override: this.state.override,
					startDate: new Date(this.state.startDate),
					endDate: new Date(this.state.endDate),
					online: online
				}, function (err) {
					if (err) return Messenger().post({
						message: err,
						type: "error"
					});
	
					Messenger().post({
						message: "La planification a été effectué avec succès.",
						type: "success"
					});
					_this2.props.router.push('/planning');
				});
			}
		}, {
			key: 'availablePilots',
			value: function availablePilots(place, period) {
				var _this3 = this;
	
				var conflictingGroupIds = _([0, 1, 2, 3]).pullAll(place == "anjou" ? [0, 2] : [1, 3]).pullAll(period == "morning" ? [2, 3] : [0, 1]).value();
	
				if (this.state.anjouAllDay && _.includes(conflictingGroupIds, 1)) conflictingGroupIds.push(3);
				if (this.state.nantesAllDay && _.includes(conflictingGroupIds, 0)) conflictingGroupIds.push(2);
	
				var items = _.reduce(conflictingGroupIds, function (acc, groupId) {
					return acc.concat(_this3.state.groups[groupId].items);
				}, []);
	
				return _.reject(this.props.pilots, function (pilot) {
					return _.find(items, { _id: pilot._id });
				});
			}
		}, {
			key: 'availableMontgolfieres',
			value: function availableMontgolfieres(place, period) {
				var _this4 = this;
	
				var conflictingGroupIds = _([0, 1, 2, 3]).pullAll(place == "anjou" ? [0, 2] : [1, 3]).pullAll(period == "morning" ? [0, 1] : [2, 3]).value();
	
				if (this.state.anjouAllDay && _.includes(conflictingGroupIds, 1)) conflictingGroupIds.push(3);
				if (this.state.nantesAllDay && _.includes(conflictingGroupIds, 0)) conflictingGroupIds.push(2);
	
				var items = _.reduce(conflictingGroupIds, function (acc, groupId) {
					return acc.concat(_this4.state.groups[groupId].items);
				}, []);
	
				return _.reject(this.props.montgolfieres, function (montgolfiere) {
					return _.find(items, { _id: montgolfiere._id });
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ href: '#', active: true },
							'Planifications'
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Programmation des disponibilit\xE9s' },
						_react2.default.createElement(
							_rubix.Well,
							null,
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 12 },
									_react2.default.createElement(
										'center',
										null,
										_react2.default.createElement(
											_rubix.Col,
											{ sm: 2 },
											'Du'
										),
										_react2.default.createElement(
											_rubix.Col,
											{ sm: 4 },
											_react2.default.createElement(DatePicker, { id: 'start_date', value: this.state.startDate, onChange: function onChange(value) {
													return _this5.setState({ startDate: value });
												} })
										),
										_react2.default.createElement(
											_rubix.Col,
											{ sm: 2 },
											'Au'
										),
										_react2.default.createElement(
											_rubix.Col,
											{ sm: 4 },
											_react2.default.createElement(DatePicker, { id: 'end_date', value: this.state.endDate, onChange: function onChange(value) {
													return _this5.setState({ endDate: value });
												} })
										)
									)
								),
								_react2.default.createElement('br', null)
							)
						),
						_react2.default.createElement(
							_rubix.Well,
							null,
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 8 },
									'R\xE9servation en ligne (%) :'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 4 },
									_react2.default.createElement(_rubix.FormControl, { ref: 'online', type: 'number', defaultValue: '0', max: '100', min: '0' })
								),
								_react2.default.createElement('br', null)
							)
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 12 },
							_react2.default.createElement('br', null)
						),
						_react2.default.createElement(
							_rubix.Row,
							null,
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 6 },
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 12 },
									_react2.default.createElement(
										'p',
										null,
										_react2.default.createElement(
											'center',
											null,
											_react2.default.createElement(
												_rubix.Checkbox,
												{ inline: true, onChange: function onChange(event) {
														return _this5.setState({ anjouAllDay: event.target.checked });
													} },
												'Matin et Soir identique'
											)
										)
									),
									_react2.default.createElement(
										_rubix.BPanel,
										{ header: 'Sites d\'Anjou - Vol du matin' },
										this.props.isReady && _react2.default.createElement(_PlanificationGroup.PlanificationGroup, { groupKey: 0, items: this.state.groups[0].items, pilots: this.availablePilots("anjou", "morning"), montgolfieres: this.availableMontgolfieres("anjou", "morning"), onChange: this.onChange.bind(this) })
									)
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 12 },
									'\xA0'
								),
								!this.state.anjouAllDay && _react2.default.createElement(
									_rubix.Col,
									{ sm: 12 },
									_react2.default.createElement(
										_rubix.BPanel,
										{ header: 'Sites d\'Anjou - Vol du soir' },
										this.props.isReady && _react2.default.createElement(_PlanificationGroup.PlanificationGroup, { groupKey: 2, items: this.state.groups[2].items, pilots: this.availablePilots("anjou", "evening"), montgolfieres: this.availableMontgolfieres("anjou", "evening"), onChange: this.onChange.bind(this) })
									)
								)
							),
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 6 },
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 12 },
									_react2.default.createElement(
										'p',
										null,
										_react2.default.createElement(
											'center',
											null,
											_react2.default.createElement(
												_rubix.Checkbox,
												{ inline: true, onChange: function onChange(event) {
														return _this5.setState({ nantesAllDay: event.target.checked });
													} },
												'Matin et Soir identique'
											)
										)
									),
									_react2.default.createElement(
										_rubix.BPanel,
										{ header: 'Sites de Nantes - Vol du matin' },
										this.props.isReady && _react2.default.createElement(_PlanificationGroup.PlanificationGroup, { groupKey: 1, items: this.state.groups[1].items, pilots: this.availablePilots("nantes", "morning"), montgolfieres: this.availableMontgolfieres("nantes", "morning"), onChange: this.onChange.bind(this) })
									)
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 12 },
									'\xA0'
								),
								!this.state.nantesAllDay && _react2.default.createElement(
									_rubix.Col,
									{ sm: 12 },
									_react2.default.createElement(
										_rubix.BPanel,
										{ header: 'Sites de Nantes - Vol du soir' },
										this.props.isReady && _react2.default.createElement(_PlanificationGroup.PlanificationGroup, { groupKey: 3, items: this.state.groups[3].items, pilots: this.availablePilots("nantes", "evening"), montgolfieres: this.availableMontgolfieres("nantes", "evening"), onChange: this.onChange.bind(this) })
									)
								)
							)
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 6 },
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'center',
									null,
									_react2.default.createElement(
										_rubix.Checkbox,
										{ inline: true, ref: 'override', onChange: function onChange(event) {
												return _this5.setState({ override: event.target.checked });
											} },
										'Ecraser les informations pr\xE9c\xE9demment renseign\xE9es *'
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										_rubix.Button,
										{ bsStyle: 'primary', onClick: function onClick() {
												return _this5.onSubmit();
											} },
										'Programmer'
									)
								)
							)
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 6 },
							_react2.default.createElement(
								_rubix.Alert,
								{ bsStyle: 'warning' },
								_react2.default.createElement(
									'p',
									null,
									'* Les disponibilit\xE9s et indisponibilit\xE9s pr\xE9c\xE9demment d\xE9finies pour les pilotes et les montgolfi\xE8res choisies seront \xE9cras\xE9es'
								)
							)
						)
					)
				);
			}
		}]);
		return PlanificationAddMultiplePage;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = PlanificationAddMultiplePage;

/***/ },

/***/ "./src/universal/components/planifications/PlanificationGroup.component.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.PlanificationGroup = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var PlanificationGroup = exports.PlanificationGroup = function PlanificationGroup(_ref) {
		var groupKey = _ref.groupKey,
		    items = _ref.items,
		    pilots = _ref.pilots,
		    montgolfieres = _ref.montgolfieres,
		    onChange = _ref.onChange;
	
		var pilotRef = null;
		var montgolfiereRef = null;
	
		return _react2.default.createElement(
			'div',
			null,
			pilots.length > 0 && _react2.default.createElement(
				_rubix.PanelContainer,
				null,
				_react2.default.createElement(
					_rubix.Panel,
					null,
					_react2.default.createElement(
						_rubix.PanelBody,
						{ style: { padding: 0 } },
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 12 },
							_react2.default.createElement(
								_rubix.FormControl,
								{ componentClass: 'select', type: 'select', placeholder: 'Pilote...', inputRef: function inputRef(input) {
										pilotRef = input;
									} },
								_.reject(pilots, function (pilot) {
									return _.find(items, { _id: pilot._id });
								}).map(function (pilot) {
									return _react2.default.createElement(
										'option',
										{ value: pilot._id, key: pilot._id },
										pilot.displayName()
									);
								})
							)
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 6 },
							_react2.default.createElement(
								_rubix.Button,
								{ bsStyle: 'success', onClick: function onClick() {
										return onChange(groupKey, pilotRef && pilotRef.value, "user", true);
									} },
								'Disponible'
							)
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 6 },
							_react2.default.createElement(
								_rubix.Button,
								{ bsStyle: 'danger', onClick: function onClick() {
										return onChange(groupKey, pilotRef && pilotRef.value, "user", false);
									} },
								'Indisponible'
							)
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 12 },
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								_rubix.ListGroup,
								null,
								_.filter(items, { target: "user" }).map(function (item) {
									return _react2.default.createElement(
										_rubix.ListGroupItem,
										{ key: item._id, bsStyle: item.isAvailable ? 'success' : 'danger' },
										_react2.default.createElement(_rubix.Icon, { glyph: 'glyphicon-remove', onClick: function onClick() {
												return onChange(groupKey, item._id, "pilot", undefined);
											} }),
										' \xA0',
										_.find(pilots, { _id: item._id }).displayName()
									);
								})
							),
							_react2.default.createElement('hr', null)
						)
					)
				)
			),
			montgolfieres.length > 0 && _react2.default.createElement(
				_rubix.PanelContainer,
				null,
				_react2.default.createElement(
					_rubix.Panel,
					null,
					_react2.default.createElement(
						_rubix.PanelBody,
						{ style: { padding: 0 } },
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 12 },
							_react2.default.createElement(
								_rubix.FormControl,
								{ componentClass: 'select', type: 'select', placeholder: 'Montgolfieres...', inputRef: function inputRef(input) {
										montgolfiereRef = input;
									} },
								_.reject(montgolfieres, function (montgolfiere) {
									return _.find(items, { _id: montgolfiere._id });
								}).map(function (montgolfiere) {
									return _react2.default.createElement(
										'option',
										{ value: montgolfiere._id, key: montgolfiere._id },
										montgolfiere.name
									);
								})
							)
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 6 },
							_react2.default.createElement(
								_rubix.Button,
								{ bsStyle: 'success', onClick: function onClick() {
										return onChange(groupKey, montgolfiereRef && montgolfiereRef.value, "montgolfiere", true);
									} },
								'Disponible'
							)
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 6 },
							_react2.default.createElement(
								_rubix.Button,
								{ bsStyle: 'danger', onClick: function onClick() {
										return onChange(groupKey, montgolfiereRef && montgolfiereRef.value, "montgolfiere", false);
									} },
								'Indisponible'
							)
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 12 },
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								_rubix.ListGroup,
								null,
								_.filter(items, { target: "montgolfiere" }).map(function (item) {
									return _react2.default.createElement(
										_rubix.ListGroupItem,
										{ key: item._id, bsStyle: item.isAvailable ? 'success' : 'danger' },
										_react2.default.createElement(_rubix.Icon, { glyph: 'glyphicon-remove', onClick: function onClick() {
												return onChange(groupKey, item._id, "montgolfiere", undefined);
											} }),
										' \xA0',
										_.find(montgolfieres, { _id: item._id }).name
									);
								})
							)
						)
					)
				)
			)
		);
	};

/***/ },

/***/ "./src/universal/components/planifications/PlanificationListPage.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _mgfTable = __webpack_require__("./src/universal/components/common/mgfTable.js");
	
	var _mgfTable2 = _interopRequireDefault(_mgfTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var PlanificationListPage = function (_React$Component) {
	  (0, _inherits3.default)(PlanificationListPage, _React$Component);
	
	  function PlanificationListPage(props) {
	    (0, _classCallCheck3.default)(this, PlanificationListPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanificationListPage.__proto__ || (0, _getPrototypeOf2.default)(PlanificationListPage)).call(this, props));
	
	    _this.state = {
	      //subscription: Meteor.subscribe('planifications'),
	    };
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(PlanificationListPage, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      //this.state.subscription.stop();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _rubix.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _rubix.Breadcrumb.Item,
	            null,
	            'Planifications'
	          ),
	          _react2.default.createElement(
	            _rubix.Breadcrumb.Item,
	            { active: true },
	            'Liste des planifications'
	          ),
	          _react2.default.createElement(
	            _rubix.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/planifications/add' },
	              _react2.default.createElement(
	                _rubix.Button,
	                { bsStyle: 'success' },
	                'Ajout simple'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _rubix.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/planifications/add-multiple' },
	              _react2.default.createElement(
	                _rubix.Button,
	                { bsStyle: 'success' },
	                'Ajout multiple'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_rubix.BPanel, { header: 'Liste des planifications' })
	      );
	    }
	  }]);
	  return PlanificationListPage;
	}(_react2.default.Component);
	
	exports.default = PlanificationListPage;
	
	
	PlanificationListPage.propTypes = {
	  planifications: _react2.default.PropTypes.array.isRequired
	};

/***/ },

/***/ "./src/universal/components/flights/PlanningPage.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _AlertsViewer = __webpack_require__("./src/universal/components/alerts/AlertsViewer.js");
	
	var _PlanningDay = __webpack_require__("./src/universal/components/flights/PlanningDay.js");
	
	var _PlanningDateIntervalSelector = __webpack_require__("./src/universal/components/flights/PlanningDateIntervalSelector.js");
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	var _smsManager = __webpack_require__("./src/universal/external_api/smsManager.js");
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Tracker = Package.tracker.Tracker;
	var PlanningPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["flights-type", "montgolfieres", "users", "places"]
	}), (0, _reactRouter.withRouter)(_class = _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(PlanningPage, _React$Component);
	
		function PlanningPage(props) {
			(0, _classCallCheck3.default)(this, PlanningPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (PlanningPage.__proto__ || (0, _getPrototypeOf2.default)(PlanningPage)).call(this, props));
	
			_this.state = {};
			_this.state.place = "all";
			_this.state.startDate = new Date();
			_this.state.endDate = (0, _moment2.default)().add(1, 'week').toDate();
	
			if (_this.props.location.query.date) {
				_this.state.startDate = new Date(_this.props.location.query.date);
				_this.state.endDate = (0, _moment2.default)(_this.props.location.query.date).add(1, 'week').toDate();
			}
	
			Tracker.nonreactive(function () {
				_this.state.subscriptions = {
					available: Meteor.subscribe("availableAndScheduledBetween", _this.state.startDate, _this.state.endDate, function () {
						return _this.forceUpdate();
					})
				};
			});
	
			_this.changeInterval = _.debounce(_this.changeInterval, 300);
			return _this;
		}
	
		(0, _createClass3.default)(PlanningPage, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
	
				if (this.place) this.place.setAttribute('nochilddrag', true);
	
				var $container = jQuery('#body .container-fluid').css({
					overflow: 'scroll'
				});
	
				var width = $container.width();
	
				console.log('width', width);
	
				if (width > 950) {
					$container.kinetic ? $container.kinetic('attach') : $container.kinetic({
						slowdown: 0.2,
						triggerHardware: true,
						filterTarget: function filterTarget(target, e) {
							if (!/down|start/.test(e.type)) {
								return !/area|a|input|select/i.test(target.tagName);
							}
						}
					});
				}
				jQuery('#body').css({
					paddingTop: 0,
					paddingBottom: 0
				});
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				jQuery('#body .container-fluid').css({
					overflow: 'auto',
					paddingTop: 0
				}).kinetic('detach');
				jQuery('#body').css({
					paddingTop: 25,
					paddingBottom: 25
				});
	
				this.state.subscriptions.available.stop();
			}
		}, {
			key: 'renderDays',
			value: function renderDays() {
				var days = [];
				for (var i = 0; i < 7; i++) {
					days.push(_react2.default.createElement(
						_rubix.Col,
						{ sm: 4, key: i },
						_react2.default.createElement(_PlanningDay.PlanningDay, { date: (0, _moment2.default)(this.state.startDate).add(i, 'days').toDate(), place: this.state.place !== "all" ? this.state.place : null })
					));
				}
	
				return days;
			}
		}, {
			key: 'changeInterval',
			value: function changeInterval(_ref) {
				var _this2 = this;
	
				var startDate = _ref.startDate,
				    endDate = _ref.endDate;
	
				this.state.subscriptions.available.stop();
				this.setState({
					subscriptions: { available: Meteor.subscribe("availableAndScheduledBetween", startDate, endDate, function () {
							_this2.forceUpdate();
						}) },
					startDate: startDate,
					endDate: endDate
				});
				this.props.router.push('/planning?date=' + startDate);
			}
		}, {
			key: 'handleChangePlace',
			value: function handleChangePlace(e) {
				var _this3 = this;
	
				var place = e.target.value;
	
				this.state.subscriptions.available.stop();
				this.setState({
					subscriptions: { available: Meteor.subscribe("availableAndScheduledBetween", this.state.startDate, this.state.endDate, function () {
							return _this3.forceUpdate();
						}) },
					place: place
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				if (!this.props.isReady) {
					return _react2.default.createElement(
						'p',
						null,
						'Chargement...'
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'planning-container' },
					_react2.default.createElement(
						_rubix.Col,
						{ sm: 4 },
						_react2.default.createElement(_PlanningDateIntervalSelector.PlanningDateIntervalSelector, { startDate: this.state.startDate, endDate: this.state.endDate, onChange: this.changeInterval.bind(this) }),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 12 },
							_react2.default.createElement(
								_rubix.BPanel,
								{ header: 'Planning' },
								_react2.default.createElement(
									_rubix.FormGroup,
									{ controlId: 'place' },
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 3 },
										_react2.default.createElement(
											_rubix.ControlLabel,
											null,
											'Lieux'
										)
									),
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 9 },
										_react2.default.createElement(
											_rubix.FormControl,
											{ componentClass: 'select', placeholder: 'Lieux', onChange: this.handleChangePlace.bind(this), inputRef: function inputRef(ref) {
													return _this4.place = ref;
												} },
											_react2.default.createElement(
												'option',
												{ value: 'all' },
												'Tous'
											),
											_react2.default.createElement(
												'option',
												{ value: 'anjou' },
												'Anjou'
											),
											_react2.default.createElement(
												'option',
												{ value: 'nantes' },
												'Nantes'
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 12 },
							_react2.default.createElement(_AlertsViewer.AlertsViewer, null)
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 12 },
							_react2.default.createElement(
								_rubix.BPanel,
								{ header: 'L\xE9gende' },
								_react2.default.createElement(
									_rubix.ListGroup,
									null,
									_react2.default.createElement(
										_rubix.ListGroupItem,
										{ bsStyle: 'info' },
										'Anjou'
									),
									_react2.default.createElement(
										_rubix.ListGroupItem,
										{ bsStyle: 'warning' },
										'Nantes'
									),
									_react2.default.createElement(
										_rubix.ListGroupItem,
										{ disabled: true },
										'Programm\xE9'
									)
								)
							)
						)
					),
					this.renderDays()
				);
			}
		}]);
		return PlanningPage;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = PlanningPage;

/***/ },

/***/ "./src/universal/components/flights/PlanningDay.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.PlanningDay = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _PlanningPeriod = __webpack_require__("./src/universal/components/flights/PlanningPeriod.js");
	
	var _weather = __webpack_require__("./src/universal/external_api/weather.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HTTP = Package.http.HTTP;
	var PlanningDay = exports.PlanningDay = function PlanningDay(_ref) {
		var date = _ref.date,
		    place = _ref.place;
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				_rubix.Col,
				{ sm: 12 },
				_react2.default.createElement(
					'center',
					null,
					_react2.default.createElement(
						'p',
						null,
						(0, _moment2.default)(date).format('dddd D MMMM'),
						'\xA0',
						_react2.default.createElement(_weather.Weather, { date: (0, _moment2.default)(date).format('YYYY-MM-DD') })
					)
				)
			),
			_react2.default.createElement(
				_rubix.Col,
				{ sm: 6 },
				_react2.default.createElement(_PlanningPeriod.PlanningPeriod, { date: date, place: place, period: 'morning' })
			),
			_react2.default.createElement(
				_rubix.Col,
				{ sm: 6 },
				_react2.default.createElement(_PlanningPeriod.PlanningPeriod, { date: date, place: place, period: 'evening' })
			)
		);
	};

/***/ },

/***/ "./src/universal/components/flights/PlanningPeriod.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.PlanningPeriod = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class;
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	var _PlanningAnnuleModal = __webpack_require__("./src/universal/components/flights/PlanningAnnuleModal.js");
	
	var _PlanningConfirmModal = __webpack_require__("./src/universal/components/flights/PlanningConfirmModal.js");
	
	var _PlanningClotureModal = __webpack_require__("./src/universal/components/flights/PlanningClotureModal.js");
	
	var _flightTypeColorComponent = __webpack_require__("./src/universal/components/reservations/components/flightTypeColorComponent.js");
	
	var _componentNotifySms = __webpack_require__("./src/universal/components/flights/component-notify-sms.js");
	
	var _availabilities = __webpack_require__("./src/universal/helpers/availabilities.js");
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Tracker = Package.tracker.Tracker;
	var Base64 = Package.base64.Base64;
	var HTTP = Package.http.HTTP;
	
	var PlanningPeriod = exports.PlanningPeriod = (0, _reactRouter.withRouter)(_class = function (_React$Component) {
		(0, _inherits3.default)(PlanningPeriod, _React$Component);
	
		function PlanningPeriod(props) {
			(0, _classCallCheck3.default)(this, PlanningPeriod);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (PlanningPeriod.__proto__ || (0, _getPrototypeOf2.default)(PlanningPeriod)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(PlanningPeriod, [{
			key: 'componentDidMount',
			value: function componentDidMount() {}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps() {
				this.fetchFlight();
				this.fetchStats();
				this.setObservers();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._flightsHandle && this._flightsHandle.stop();
			}
		}, {
			key: 'setObservers',
			value: function setObservers() {
				var projection = {
					period: this.props.period,
					date: (0, _moment2.default)(this.props.date).startOf("day").toDate()
				};
				this._flightsHandle && this._flightsHandle.stop();
				this._flightsHandle = _flights.Flights.find(projection).observe({
					changed: this.fetchFlight.bind(this)
				});
			}
		}, {
			key: 'scheduleFlight',
			value: function scheduleFlight() {
				var _this2 = this;
	
				var projection = {
					$elemMatch: {
						startDate: { $lte: this.props.date },
						endDate: { $gte: this.props.date },
						isAvailable: true,
						period: this.props.period,
						place: "anjou"
					}
				};
				var isAnjou = Meteor.users.findOne({ "_id": Meteor.userId(), "profile.availabilities": projection });
	
				if (!isAnjou) projection["$elemMatch"]["place"] = "nantes";
				var pilotId = _roles.Roles.userHasRole(Meteor.userId(), "pilot") && !_flights.Flights.findOne({
					date: (0, _moment2.default)(this.props.date).startOf('day').toDate(),
					period: this.props.period,
					pilotId: Meteor.userId()
				}) && Meteor.users.findOne({ "_id": Meteor.userId(), "profile.availabilities": projection }) ? Meteor.userId() : null;
	
				_flights.Flights.insert({
					date: (0, _moment2.default)(this.props.date).startOf('day').toDate(),
					period: this.props.period,
					place: isAnjou ? 'anjou' : 'nantes',
					pilotId: pilotId,
					status: "preparing"
				}, function (err, _id) {
					if (err) return Messenger().post({
						message: err,
						type: "error"
					});
	
					_this2.props.router.push('/planning/flights/' + _id);
				}.bind(this));
			}
		}, {
			key: 'openPopUp',
			value: function openPopUp(urlToOpen) {
				var popup_window = window.open(urlToOpen, "myWindow", "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=yes, width=400, height=400");
				try {
					popup_window.focus();
				} catch (e) {
					alert("Les fenêtes Pop-up sont bloquées ! Pour télécharger ce document, merci de les débloquer.");
				}
			}
		}, {
			key: 'downloadDDV',
			value: function downloadDDV() {
				var _this3 = this;
	
				var flight = this.state.flight;
				var reservations = _reservations.Reservations.find({ _id: { $in: flight.reservationIds } }, { fields: { "id_billet": 1, "passengers": 1, "payment": 1 } }).fetch();
	
				_lodash2.default.each(reservations, function (reservation) {
					reservation.passengers = reservation.getPassengers();
					console.log('getPassengers', reservation.getPassengers());
					reservation.payementMode = reservation.getPayment();
				});
	
				var selectedMontgolfiere = _montgolfieres.Montgolfieres.findOne(flight.montgolfiereId);
				var montgolfieresDatas = _montgolfieres.Montgolfieres.find({ $or: [{ online: true }, { _id: flight.montgolfiereId }] }).fetch();
	
				var montgolfieres = [];
				_lodash2.default.each(montgolfieresDatas, function (montgolfiere) {
					montgolfieres.push({
						'maxWeight': montgolfiere.maxWeight,
						'defaultWeight': montgolfiere.defaultWeight,
						'emptyWeight': montgolfiere.emptyWeight,
						'name': montgolfiere.name,
						'archived': montgolfiere.archived
					});
				});
	
				var pilote = Meteor.users.findOne(flight.pilotId);
	
				var data = {
					montgolfieres: montgolfieres,
					selectedMontgolfiere: {
						'defaultWeight': selectedMontgolfiere.defaultWeight,
						'maxWeight': selectedMontgolfiere.maxWeight,
						'name': selectedMontgolfiere.name
					},
					reservations: reservations,
					temp: flight.temp,
					date: (0, _moment2.default)(flight.date).format('DD/MM/YYYY'),
					period: flight.period,
					place: flight.place,
					pilote: {
						'firstName': pilote.profile.firstName,
						'lastName': pilote.profile.lastName,
						'weight': pilote.profile.weight
					},
					meetPoint: flight.getMeetPoint(),
					meetingDate: (0, _moment2.default)(flight.meetingDate).format('HH:mm')
				};
	
				console.log('data', data);
	
				HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=vol', {
					data: data
				}, function (error, result) {
					result = JSON.parse(result.content);
					_this3.openPopUp("https://montgolfieres-pdf.amaia.at/" + result.id + ".pdf");
				});
			}
		}, {
			key: 'editFlight',
			value: function editFlight() {
				if (!this.state.flight) return;
	
				this.props.router.push('/planning/flights/' + this.state.flight._id);
			}
		}, {
			key: 'fetchStats',
			value: function fetchStats() {
				var stats = {
					anjou: {
						reservedCount: (0, _availabilities.getReservedCount)(this.props.date, "anjou", this.props.period),
						totalCount: (0, _availabilities.getAvailabilityTotalCount)(this.props.date, "anjou", this.props.period)
					},
					nantes: {
						reservedCount: (0, _availabilities.getReservedCount)(this.props.date, "nantes", this.props.period),
						totalCount: (0, _availabilities.getAvailabilityTotalCount)(this.props.date, "nantes", this.props.period)
					}
				};
	
				stats.anjou.percent = stats.anjou.reservedCount / stats.anjou.totalCount * 100;
				if (stats.anjou.percent == 0) stats.anjou.percent = 0.1;
				if (_lodash2.default.isNaN(stats.anjou.percent)) stats.anjou.percent = 0.1;
	
				stats.nantes.percent = stats.nantes.reservedCount / stats.nantes.totalCount * 100;
				if (stats.nantes.percent == 0) stats.nantes.percent = 0.1;
				if (_lodash2.default.isNaN(stats.nantes.percent)) stats.nantes.percent = 0.1;
	
				this.setState({ stats: stats });
			}
		}, {
			key: 'fetchFlight',
			value: function fetchFlight() {
				var flight = _flights.Flights.findOne({
					date: (0, _moment2.default)(this.props.date).startOf('day').toDate(),
					period: this.props.period,
					pilotId: Meteor.userId(),
					status: { $in: ["preparing", "prepared", "cancelled", "validated"] }
				});
	
				this.setState({ flight: flight });
			}
		}, {
			key: 'flights',
			value: function flights() {
				var projection = {
					period: this.props.period,
					date: (0, _moment2.default)(this.props.date).startOf("day").toDate()
				};
				if (this.props.place) projection["place"] = this.props.place;
	
				return _flights.Flights.find(projection).fetch();
			}
		}, {
			key: 'reservations',
			value: function reservations(place) {
				var _this4 = this;
	
				var projection = {
					'place': place,
					'scheduledAt': { $gte: (0, _moment2.default)(this.props.date).startOf("day").subtract(2, 'hours').toDate(), $lte: (0, _moment2.default)(this.props.date).endOf("day").toDate() },
					$or: [{ 'periodTime': this.props.period }, { 'period': this.props.period }]
				};
				if (this.props.place && this.props.place !== place) return [];
	
				var reservations = _reservations.Reservations.find(projection).fetch();
	
				var results = _lodash2.default.reject(reservations, function (reservation) {
					if (reservation.period && reservation.periodTime) {
						if (reservation.periodTime != _this4.props.period) {
							return true;
						}
					}
				});
	
				return results;
			}
		}, {
			key: 'totalWeight',
			value: function totalWeight(place) {
				var totalWeightReservations = 0;
				var totalWeightMontgolfieres = 0;
	
				this.reservations(place).map(function (reservation) {
					totalWeightReservations += reservation.totalWeight();
				});
	
				this.montgolfieres(place).map(function (montgolfiere) {
					totalWeightMontgolfieres += montgolfiere.defaultAllowedWeight;
				});
	
				return totalWeightReservations + '/' + totalWeightMontgolfieres;
			}
		}, {
			key: 'pilots',
			value: function pilots(place) {
				var projection = {
					$elemMatch: {
						startDate: { $lte: this.props.date },
						endDate: { $gte: this.props.date },
						isAvailable: true,
						period: this.props.period,
						place: place
					}
				};
				if (this.props.place && this.props.place !== place) return [];
	
				return Meteor.users.find({ "profile.availabilities": projection }).fetch();
			}
		}, {
			key: 'montgolfieres',
			value: function montgolfieres(place) {
				var projection = {
					$elemMatch: {
						startDate: { $lte: this.props.date },
						endDate: { $gte: this.props.date },
						isAvailable: true,
						period: this.props.period,
						place: place
					}
				};
				if (this.props.place && this.props.place !== place) return [];
	
				return _montgolfieres.Montgolfieres.find({ "availabilities": projection }).fetch();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				this.state.flight = _flights.Flights.findOne({
					date: (0, _moment2.default)(this.props.date).startOf('day').toDate(),
					period: this.props.period,
					pilotId: Meteor.userId(),
					status: { $in: ["preparing", "prepared", "cancelled", "validated"] }
				}, { sort: { createdAt: -1, limit: 1 } });
	
				return _react2.default.createElement(
					_rubix.BPanel,
					{ header: this.props.period == "morning" ? "Matin" : "Soir", className: 'planning-period' },
					this.state.stats && _react2.default.createElement(
						'div',
						{ className: 'availability-progress-container' },
						(!this.props.place || this.props.place == "anjou") && _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'p',
								null,
								this.state.stats.anjou.reservedCount + "/" + this.state.stats.anjou.totalCount + " places",
								' - ',
								this.totalWeight('anjou'),
								'KG'
							),
							_react2.default.createElement(_rubix.Progress, { striped: true, bsStyle: 'info', value: this.state.stats.anjou.percent })
						),
						(!this.props.place || this.props.place == "nantes") && _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'p',
								null,
								this.state.stats.nantes.reservedCount + "/" + this.state.stats.nantes.totalCount + " places",
								' - ',
								this.totalWeight('nantes'),
								'KG'
							),
							_react2.default.createElement(_rubix.Progress, { striped: true, bsStyle: 'warning', value: this.state.stats.nantes.reservedCount / this.state.stats.nantes.totalCount * 100 })
						),
						_react2.default.createElement('hr', null)
					),
					this.state.flight && this.state.flight.status == "pending" && _react2.default.createElement(_PlanningClotureModal.PlanningClotureModal, null),
					_roles.Roles.userHasPermission(Meteor.userId(), "flights.insert", Meteor.userId(), { date: (0, _moment2.default)(this.props.date).startOf('day').toDate(), period: this.props.period, pilotId: Meteor.userId(), status: "preparing" }) && _react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'primary', onClick: this.scheduleFlight.bind(this) },
						'Programmer un vol'
					),
					this.state.flight && this.state.flight.status != 'validated' && _react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'primary', onClick: this.editFlight.bind(this) },
						'Editer mon vol'
					),
					this.state.flight && this.state.flight.status == 'preparing' && this.state.flight.validToFlight && _react2.default.createElement(_PlanningConfirmModal.PlanningConfirmModal, { flight: this.state.flight }),
					this.state.flight && _roles.Roles.userHasPermission(Meteor.userId(), "flights.enclose", Meteor.userId(), this.state.flight) && _react2.default.createElement(
						'span',
						null,
						_react2.default.createElement(_PlanningClotureModal.PlanningClotureModal, { flight: this.state.flight })
					),
					this.state.flight && this.state.flight.status == 'prepared' && _react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'info', onClick: this.downloadDDV.bind(this) },
						'T\xE9l\xE9charger mon dossier de vol'
					),
					this.state.flight && this.state.flight.status !== "cancelled" && this.state.flight.status !== "validated" && this.state.flight.validToFlight && _react2.default.createElement(_PlanningAnnuleModal.PlanningAnnuleModal, { flight: this.state.flight, onCancel: function onCancel() {
							return _this5.setState({ flight: { status: "cancelled" } });
						} }),
					this.state.flight && this.state.flight.status == 'cancelled' && _react2.default.createElement(
						'span',
						null,
						_react2.default.createElement(
							_rubix.Button,
							{ bsStyle: 'warning', disabled: true },
							'Annul\xE9'
						),
						' \xA0',
						_react2.default.createElement(
							_rubix.Button,
							{ bsStyle: 'primary', onClick: this.scheduleFlight.bind(this) },
							'Programmer un vol'
						)
					),
					this.state.flight && this.state.flight.status == 'validated' && _react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'success', disabled: true },
						'Cl\xF4tur\xE9'
					),
					_react2.default.createElement('hr', null),
					_react2.default.createElement(
						'strong',
						null,
						'Vols programm\xE9s :'
					),
					this.flights().map(function (flight) {
						return _react2.default.createElement(
							_rubix.ListGroup,
							{ key: flight._id },
							flight.getPilote() && _react2.default.createElement(
								_rubix.ListGroupItem,
								{ bsStyle: flight.place == "anjou" ? "info" : "warning" },
								'Pilote : ',
								flight.getPilote().profile.firstName + " " + flight.getPilote().profile.lastName
							),
							flight.getMontgolfiere() && _react2.default.createElement(
								_rubix.ListGroupItem,
								{ bsStyle: flight.place == "anjou" ? "info" : "warning" },
								'Ballon : ',
								flight.getMontgolfiere().name
							),
							flight.getReservations() && flight.getReservations()[0] && flight.getReservations().map(function (reservation) {
								if (!reservation) return _react2.default.createElement('span', null);
								return _react2.default.createElement(
									_reactRouter.Link,
									{ to: "reservations/" + reservation._id, key: reservation._id },
									_react2.default.createElement(
										_rubix.ListGroupItem,
										{ bsStyle: flight.place == "anjou" ? "info" : "warning" },
										reservation.id_billet,
										' - ',
										reservation.getPassengers().length,
										'PAX - ',
										reservation.totalWeight(),
										'KG',
										reservation.getFlightType() && _react2.default.createElement(_flightTypeColorComponent.FlightTypeColor, { flightType: reservation.getFlightType() }),
										_react2.default.createElement(_componentNotifySms.NotifySmsComponent, { reservation: reservation })
									)
								);
							}),
							_react2.default.createElement(
								_rubix.ListGroupItem,
								{ bsStyle: flight.place == "anjou" ? "info" : "warning" },
								'Statut : ',
								flight.getStatus()
							),
							_roles.Roles.userHasPermission(Meteor.userId(), "flights.prepare", Meteor.userId(), flight) && _react2.default.createElement(
								_reactRouter.Link,
								{ to: "planning/flights/" + flight._id },
								_react2.default.createElement(
									_rubix.ListGroupItem,
									{ className: 'list-group-item-primary' },
									_react2.default.createElement(_rubix.Icon, { glyph: 'glyphicon-edit' }),
									'\xA0 Editer'
								)
							)
						);
					}),
					_react2.default.createElement('hr', null),
					_react2.default.createElement(
						'strong',
						null,
						'R\xE9servations :'
					),
					_react2.default.createElement(
						_rubix.ListGroup,
						null,
						this.reservations("anjou").map(function (reservation) {
							reservation.getFlight();
							if (!reservation) return _react2.default.createElement('span', null);
							return _react2.default.createElement(
								_reactRouter.Link,
								{ to: "reservations/" + reservation._id, key: reservation._id },
								_react2.default.createElement(
									_rubix.ListGroupItem,
									{ disabled: reservation.getFlight(), bsStyle: 'info' },
									reservation.id_billet,
									' - ',
									reservation.getPassengers().length,
									'PAX - ',
									reservation.totalWeight(),
									'KG',
									reservation.getFlightType() && _react2.default.createElement(_flightTypeColorComponent.FlightTypeColor, { flightType: reservation.getFlightType() })
								)
							);
						}),
						this.reservations("nantes").map(function (reservation) {
							if (!reservation) return _react2.default.createElement('span', null);
							return _react2.default.createElement(
								_reactRouter.Link,
								{ to: "reservations/" + reservation._id, key: reservation._id },
								_react2.default.createElement(
									_rubix.ListGroupItem,
									{ disabled: reservation.getFlight(), bsStyle: 'warning' },
									reservation.id_billet,
									' - ',
									reservation.getPassengers().length,
									'PAX - ',
									reservation.totalWeight(),
									'KG',
									_react2.default.createElement(_flightTypeColorComponent.FlightTypeColor, { flightType: reservation.getFlightType() })
								)
							);
						})
					),
					_react2.default.createElement('hr', null),
					_react2.default.createElement(
						'strong',
						null,
						'Pilotes :'
					),
					_react2.default.createElement(
						_rubix.ListGroup,
						null,
						this.pilots("anjou").map(function (pilot) {
							return _react2.default.createElement(
								_rubix.ListGroupItem,
								{ disabled: pilot.flightScheduledAt(_this5.props.date, _this5.props.period), bsStyle: 'info', key: pilot._id },
								pilot.profile.firstName + ' ' + pilot.profile.lastName
							);
						}),
						this.pilots("nantes").map(function (pilot) {
							return _react2.default.createElement(
								_rubix.ListGroupItem,
								{ disabled: pilot.flightScheduledAt(_this5.props.date, _this5.props.period), bsStyle: 'warning', key: pilot._id },
								pilot.profile.firstName + ' ' + pilot.profile.lastName
							);
						})
					),
					_react2.default.createElement('hr', null),
					_react2.default.createElement(
						'strong',
						null,
						'Ballons :'
					),
					_react2.default.createElement(
						_rubix.ListGroup,
						null,
						this.montgolfieres("anjou").map(function (montgolfiere) {
							return _react2.default.createElement(
								_rubix.ListGroupItem,
								{ disabled: montgolfiere.flightScheduledAt(_this5.props.date, _this5.props.period), bsStyle: 'info', key: montgolfiere._id },
								montgolfiere.name
							);
						}),
						this.montgolfieres("nantes").map(function (montgolfiere) {
							return _react2.default.createElement(
								_rubix.ListGroupItem,
								{ disabled: montgolfiere.flightScheduledAt(_this5.props.date, _this5.props.period), bsStyle: 'warning', key: montgolfiere._id },
								montgolfiere.name
							);
						})
					)
				);
			}
		}]);
		return PlanningPeriod;
	}(_react2.default.Component)) || _class;
	
	PlanningPeriod.propTypes = {
		date: _react2.default.PropTypes.instanceOf(Date),
		period: _react2.default.PropTypes.string
	};

/***/ },

/***/ "./src/universal/components/flights/PlanningAnnuleModal.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PlanningAnnuleModal = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _methods = __webpack_require__("./src/universal/collections/flights/methods.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var DatePicker = __webpack_require__("./node_modules/react-bootstrap-date-picker/lib/index.js");
	
	var PlanningAnnuleModal = exports.PlanningAnnuleModal = function (_React$Component) {
	  (0, _inherits3.default)(PlanningAnnuleModal, _React$Component);
	
	  function PlanningAnnuleModal(props) {
	    (0, _classCallCheck3.default)(this, PlanningAnnuleModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanningAnnuleModal.__proto__ || (0, _getPrototypeOf2.default)(PlanningAnnuleModal)).call(this, props));
	
	    _this.state = {};
	    _this.state.showModal = false;
	    return _this;
	  }
	
	  (0, _createClass3.default)(PlanningAnnuleModal, [{
	    key: 'closeModal',
	    value: function closeModal() {
	      this.setState({ showModal: false });
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal() {
	      this.setState({ showModal: true });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      var _this2 = this;
	
	      _methods.cancelFlight.call({
	        _id: this.props.flight._id,
	        reason: _reactDom2.default.findDOMNode(this.refs.reason).value.trim()
	      }, function (err) {
	        if (err) return Messenger().post({
	          message: err,
	          type: "error"
	        });
	
	        Messenger().post({
	          message: "Le vol a bien été annulé et les passagers ont été prévenus par SMS",
	          type: "success"
	        });
	
	        _this2.closeModal();
	        _this2.props.onCancel && _this2.props.onCancel();
	      }.bind(this));
	    }
	  }, {
	    key: 'renderModal',
	    value: function renderModal() {
	      return _react2.default.createElement(
	        _rubix.Modal,
	        { show: this.state.showModal, onHide: this.closeModal.bind(this) },
	        _react2.default.createElement(
	          _rubix.Modal.Header,
	          { closeButton: true },
	          _react2.default.createElement(
	            _rubix.Modal.Title,
	            null,
	            'Annulation du vol du ',
	            (0, _moment2.default)(this.props.flight.date).format("DD/MM/YYYY"),
	            ' - ',
	            this.props.flight.getPeriod(),
	            ' - ',
	            this.props.flight.getPlace()
	          )
	        ),
	        _react2.default.createElement(
	          _rubix.Modal.Body,
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Informations d\'annulation :'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _rubix.FormGroup,
	            { controlId: 'formControlsSelect' },
	            _react2.default.createElement(
	              _rubix.Col,
	              { sm: 5 },
	              _react2.default.createElement(
	                _rubix.ControlLabel,
	                null,
	                'Raison de l\'annulation :'
	              )
	            ),
	            _react2.default.createElement(
	              _rubix.Col,
	              { sm: 7 },
	              _react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'reason' })
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	          _rubix.Modal.Footer,
	          null,
	          _react2.default.createElement(
	            _rubix.Button,
	            { bsStyle: 'danger', onClick: this.cancel.bind(this) },
	            'Annuler'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.showModal) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          this.renderModal()
	        );
	      } else {
	        return _react2.default.createElement(
	          _rubix.Button,
	          { bsStyle: 'danger', onClick: this.openModal.bind(this) },
	          'Annuler'
	        );
	      }
	    }
	  }]);
	  return PlanningAnnuleModal;
	}(_react2.default.Component);
	
	PlanningAnnuleModal.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/flights/PlanningConfirmModal.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.PlanningConfirmModal = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactBootstrapTimePicker = __webpack_require__("./node_modules/react-bootstrap-time-picker/dist/bundle.js");
	
	var _reactBootstrapTimePicker2 = _interopRequireDefault(_reactBootstrapTimePicker);
	
	var _places = __webpack_require__("./src/universal/collections/flights/places.js");
	
	var _methods = __webpack_require__("./src/universal/collections/flights/methods.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Tracker = Package.tracker.Tracker;
	
	var PlanningConfirmModal = exports.PlanningConfirmModal = function (_React$Component) {
		(0, _inherits3.default)(PlanningConfirmModal, _React$Component);
	
		function PlanningConfirmModal(props) {
			(0, _classCallCheck3.default)(this, PlanningConfirmModal);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (PlanningConfirmModal.__proto__ || (0, _getPrototypeOf2.default)(PlanningConfirmModal)).call(this, props));
	
			_this.state = {};
			_this.state.showModal = false;
	
			if (_this.props.flight) {
				Tracker.nonreactive(function () {
					_this.state.subscription = Meteor.subscribe('flight', _this.props.flight._id, function () {
						_this.setState({
							placeId: _this.props.flight.placeId || (_this.places().length ? _this.places()[0]._id : null),
							temp: parseInt(_this.props.flight.temp) || 1,
							time: _this.props.flight.period == 'morning' ? 9 : 17
						});
						_this.setState({
							meetingDate: (0, _moment2.default)(_this.props.flight.date).add(_this.state.time, 'hours').toDate()
						});
					});
				});
			}
			return _this;
		}
	
		(0, _createClass3.default)(PlanningConfirmModal, [{
			key: 'closeModal',
			value: function closeModal() {
				this.setState({ showModal: false });
			}
		}, {
			key: 'openModal',
			value: function openModal() {
				this.setState({ showModal: true });
			}
		}, {
			key: 'confirm',
			value: function confirm() {
				var _this2 = this;
	
				_methods.confirmFlight.call({
					_id: this.props.flight._id,
					temp: parseInt(this.state.temp),
					placeId: this.state.placeId,
					meetingDate: this.state.meetingDate
				}, function (err) {
					if (err) return Messenger().post({
						message: err,
						type: "error"
					});
	
					Messenger().post({
						message: "Le vol a été validé avec succès.",
						type: "success"
					});
	
					_this2.closeModal();
				}.bind(this));
			}
		}, {
			key: 'getTimeRange',
			value: function getTimeRange() {
				if (!this.props.flight) return { start: '0', end: '23' };
	
				if (this.props.flight.period == 'morning') return { start: '5', end: '23' };else return { start: '5', end: '23' };
			}
		}, {
			key: 'places',
			value: function places() {
				return _places.Places.find({}).fetch();
			}
		}, {
			key: 'setMeetingDate',
			value: function setMeetingDate(time) {
				this.setState({
					time: time,
					meetingDate: (0, _moment2.default)(this.props.flight.date).add(time, 'seconds').toDate()
				});
			}
		}, {
			key: 'renderModal',
			value: function renderModal() {
				var _this3 = this;
	
				return _react2.default.createElement(
					_rubix.Modal,
					{ show: this.state.showModal, onHide: this.closeModal.bind(this) },
					_react2.default.createElement(
						_rubix.Modal.Header,
						{ closeButton: true },
						_react2.default.createElement(
							_rubix.Modal.Title,
							null,
							'Confirmation du vol du ',
							(0, _moment2.default)(this.props.flight.date).format("DD/MM/YYYY"),
							' - ',
							this.props.flight.getPeriod(),
							' - ',
							this.props.flight.getPlace()
						)
					),
					_react2.default.createElement(
						_rubix.Modal.Body,
						null,
						_react2.default.createElement(
							_rubix.FormGroup,
							{ controlId: 'formControlsSelect' },
							_react2.default.createElement(
								_rubix.ControlLabel,
								null,
								'Heure de rendez-vous :'
							),
							_react2.default.createElement(_reactBootstrapTimePicker2.default, { start: this.getTimeRange().start, end: this.getTimeRange().end, step: 15, format: 24, onChange: this.setMeetingDate.bind(this), value: this.state.time })
						),
						_react2.default.createElement(
							_rubix.FormGroup,
							{ controlId: 'formControlsSelect' },
							_react2.default.createElement(
								_rubix.ControlLabel,
								null,
								'Temp\xE9rature :'
							),
							_react2.default.createElement(
								_rubix.FormControl,
								{ componentClass: 'select', placeholder: 'Temp\xE9rature', onChange: function onChange(e) {
										return _this3.setState({ temp: e.target.value });
									}, defaultValue: this.state.temp },
								_react2.default.createElement(
									'option',
									{ value: 1 },
									'De 0\xB0 \xE0 8\xB0C'
								),
								_react2.default.createElement(
									'option',
									{ value: 2 },
									'De 8\xB0 \xE0 16\xB0C'
								),
								_react2.default.createElement(
									'option',
									{ value: 3 },
									'De 16\xB0 \xE0 22\xB0C'
								),
								_react2.default.createElement(
									'option',
									{ value: 4 },
									'De 22\xB0 \xE0 28\xB0C'
								),
								_react2.default.createElement(
									'option',
									{ value: 5 },
									'De 28\xB0 \xE0 36\xB0C'
								),
								_react2.default.createElement(
									'option',
									{ value: 6 },
									'36\xB0C et +'
								)
							)
						),
						_react2.default.createElement(
							_rubix.FormGroup,
							{ controlId: 'formControlsSelect' },
							_react2.default.createElement(
								_rubix.ControlLabel,
								null,
								'Lieu de rendez-vous :'
							),
							_react2.default.createElement(
								_rubix.FormControl,
								{ componentClass: 'select', placeholder: 'Lieu de rendez-vous', onChange: function onChange(e) {
										return _this3.setState({ placeId: e.target.value });
									}, defaultValue: this.state.placeId },
								this.places().map(function (place) {
									return _react2.default.createElement(
										'option',
										{ value: place._id },
										place.name
									);
								})
							)
						)
					),
					_react2.default.createElement(
						_rubix.Modal.Footer,
						null,
						_react2.default.createElement(
							_rubix.Button,
							{ bsStyle: 'success', onClick: this.confirm.bind(this) },
							'Valider'
						)
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'success', onClick: this.openModal.bind(this) },
						'Valider mon vol'
					),
					this.state.showModal && this.renderModal()
				);
			}
		}]);
		return PlanningConfirmModal;
	}(_react2.default.Component);

/***/ },

/***/ "./node_modules/react-bootstrap-time-picker/dist/bundle.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports=function(e){function t(n){if(r[n])return r[n].exports;var a=r[n]={exports:{},id:n,loaded:!1};return e[n].call(a.exports,a,a.exports,t),a.loaded=!0,a.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){e.exports=r(2)},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function a(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function o(e){function t(e){var t=(0,p.timeFromInt)(e,!1);if(24===c)return t;var r=t.match(/^(\d+):/),n=parseInt(r[1],10);if(0===n)return t.replace(/^\d+/,"12")+" AM";if(n<12)return t+" AM";if(12===n)return t+" PM";var a=n<22?"0"+(n-12):(n-12).toString();return t.replace(/^\d+/,a)+" PM"}function r(){for(var e=[],t=(0,p.timeToInt)(i,!1),r=(0,p.timeToInt)(g,!1);r<=t;r+=60*b)e.push(r);return e}function n(){return r().map(function(e){var r=t(e);return{key:e,val:r}})}var o=e.end,i=void 0===o?"23:59":o,f=e.format,c=void 0===f?12:f,d=e.initialValue,v=void 0===d?"00:00":d,m=e.onChange,y=void 0===m?function(){}:m,x=e.start,g=void 0===x?"00:00":x,h=e.step,b=void 0===h?30:h,I=e.value,M=void 0===I?null:I,O=a(e,["end","format","initialValue","onChange","start","step","value"]),_=n(),C=_.map(function(e){var t=e.key,r=e.val;return l.default.createElement("option",{key:t,value:t},r)}),P=M||v;try{P=(0,p.timeToInt)(P)}catch(e){P=parseInt(P,10)}return _.filter(function(e){var t=e.key;return P===t}).length||(P=(0,p.timeToInt)(g)),l.default.createElement(s.default,u({componentClass:"select",onChange:function(e){y(parseInt(e.target.value,10))},value:P},O),C)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},i=r(4),l=n(i),f=r(3),c=n(f),d=r(5),s=n(d),p=r(6),v={end:c.default.string,format:c.default.number,initialValue:c.default.any,onChange:c.default.func,start:c.default.string,step:c.default.number,value:c.default.any};o.propTypes=v,t.default=o},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=r(1),o=n(a);t.default=o.default},function(e,t){e.exports=__webpack_require__("./node_modules/prop-types/index.js")},function(e,t){e.exports=__webpack_require__("./node_modules/react/react.js")},function(e,t){e.exports=__webpack_require__("./node_modules/react-bootstrap/lib/FormControl.js")},function(e,t){e.exports=__webpack_require__("./node_modules/time-number/dist/time-number.js")}]);

/***/ },

/***/ "./node_modules/time-number/dist/time-number.js":
/***/ function(module, exports) {

	module.exports=function(e){function r(n){if(t[n])return t[n].exports;var o=t[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,r),o.loaded=!0,o.exports}var t={};return r.m=e,r.c=t,r.p="",r(0)}([function(e,r,t){e.exports=t(1)},function(e,r){"use strict";function t(e){return"time-number"===e.message.substring(0,11)}function n(e){for(var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:2,t=e.toString(),n=r-t.length,o="";o.length<n;)o+="0";return""+o+t}function o(e,r){var t=r.validate,o=r.format,a=r.leadingZero,i=parseInt(e,10);if(t&&(i<0||i>=86400))throw new RangeError("time-number, timeFromInt(): rangeError, value supposed to be between 0 and 86399");var u=Math.floor(i/3600),m=Math.floor((i-3600*u)/60),d=i-3600*u-60*m,s=null;12!==o&&"12"!==o||(s=u<12?"AM":"PM",0===u?u=12:u>12&&(u-=12));var f=[a?n(u):u,n(m)];d&&f.push(n(d));var l=f.join(":");return s?l+" "+s:l}function a(e){return"boolean"==typeof e?{validate:e}:e}function i(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n={validate:!0,format:24,leadingZero:!0},i=Object.assign({},n,a(r)),u=i.validate;if(!u)return o(e,i);try{if(e-parseFloat(e,10)+1>=0)return o(e,i);throw new Error}catch(r){if(t(r))throw r;throw new Error("time-number, timeFromInt(): invalud value: '"+e+"', supposed to be number")}}function u(e,r){for(var t=r.validate,n=e.split(":"),o=n.length;n.length<3;)n.push("0");var a=n.map(function(e){return parseInt(e,10)});if(t){var i=a[0];if(i<0||i>23)throw new RangeError("time-number, timeToInt(): hours must be between 0 and 23, provided value: '"+e+"'");if(o>1){var u=a[1];if(u<0||u>59)throw new RangeError("time-number, timeToInt(): minutes must be between 0 and 59, provided value: '"+e+"'")}if(o>2){var m=a[2];if(m<0||m>59)throw new RangeError("time-number, timeToInt(): seconds must be between 0 and 59, provided value: '"+e+"'")}}return 3600*a[0]+60*a[1]+a[2]}function m(e){if(!e||!e.match)return e;if(!e.match(/(am|pm)$/i))return e;if(e.match(/^0+:/))throw new Error("12h format can't have 00:30 AM, it should be 12:30 AM instead");return e.match(/am$/i)?e.replace(/^(\d+)/,function(e){return"12"===e?"0":e}).replace(/\s*am$/i,""):e.replace(/^(\d+)/,function(e){return"12"===e?e:(parseInt(e,10)+12).toString()}).replace(/\s*pm$/i,"")}function d(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n={validate:!0},o=Object.assign({},n,a(r)),i=o.validate;if(!i){var d=m(e);return u(d,o)}try{var s=m(e);if(!s.match(/^\d+(:\d+(:\d+)?)?$/))throw new Error;return u(s,o)}catch(r){if(t(r))throw r;throw new Error("time-number, timeToInt(): supported formats are 'HH', 'HH:mm', 'HH:mm:ss', provided value: '"+e+"' doesn't match any of them")}}Object.defineProperty(r,"__esModule",{value:!0}),r.timeFromInt=i,r.timeToInt=d}]);

/***/ },

/***/ "./src/universal/components/flights/PlanningClotureModal.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.PlanningClotureModal = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactBootstrapTimePicker = __webpack_require__("./node_modules/react-bootstrap-time-picker/dist/bundle.js");
	
	var _reactBootstrapTimePicker2 = _interopRequireDefault(_reactBootstrapTimePicker);
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	var _users = __webpack_require__("./src/universal/collections/users/users.js");
	
	var _methods = __webpack_require__("./src/universal/collections/flights/methods.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var PlanningClotureModal = exports.PlanningClotureModal = function (_React$Component) {
		(0, _inherits3.default)(PlanningClotureModal, _React$Component);
	
		function PlanningClotureModal(props) {
			(0, _classCallCheck3.default)(this, PlanningClotureModal);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (PlanningClotureModal.__proto__ || (0, _getPrototypeOf2.default)(PlanningClotureModal)).call(this, props));
	
			_this.state = {
				showModal: false,
				takeOffTime: _this.props.flight.period == 'morning' ? 9 : 16,
				landingTime: _this.props.flight.period == 'morning' ? 9 : 16,
				montgolfiereId: _this.props.flight.montgolfiereId,
				pilotId: _this.props.flight.pilotId
			};
	
			_.extend(_this.state, {
				takeOffDate: (0, _moment2.default)(_this.props.flight.date).add(_this.state.takeOffTime, 'hours').toDate(),
				landingDate: (0, _moment2.default)(_this.props.flight.date).add(_this.state.landingTime, 'hours').toDate()
			});
			return _this;
		}
	
		(0, _createClass3.default)(PlanningClotureModal, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps() {
				this.setState({
					takeOffTime: this.props.flight.period == 'morning' ? 9 : 16,
					landingTime: this.props.flight.period == 'morning' ? 9 : 16
				});
				this.setState({
					takeOffDate: (0, _moment2.default)(this.props.flight.date).add(this.state.takeOffTime, 'hours').toDate(),
					landingDate: (0, _moment2.default)(this.props.flight.date).add(this.state.landingTime, 'hours').toDate(),
					pilotId: this.props.flight.pilotId,
					montgolfiereId: this.props.flight.montgolfiereId
				});
			}
		}, {
			key: 'closeModal',
			value: function closeModal() {
				this.setState({ showModal: false });
			}
		}, {
			key: 'openModal',
			value: function openModal() {
				this.setState({ showModal: true });
			}
		}, {
			key: 'montgolfieres',
			value: function montgolfieres() {
				return _montgolfieres.Montgolfieres.find({}).fetch();
			}
		}, {
			key: 'pilots',
			value: function pilots() {
				return Meteor.users.find({}).fetch();
			}
		}, {
			key: 'updatePilot',
			value: function updatePilot(pilotId) {
				this.setState({ pilotId: pilotId });
			}
		}, {
			key: 'updateMontgolfiere',
			value: function updateMontgolfiere(montgolfiereId) {
				this.setState({ montgolfiereId: montgolfiereId });
			}
		}, {
			key: 'encloseFlight',
			value: function encloseFlight() {
				var _this2 = this;
	
				_methods.encloseFlight.call({
					_id: this.props.flight._id,
					takeOffDate: this.state.takeOffDate,
					landingDate: this.state.landingDate,
					takeOffPlace: _reactDom2.default.findDOMNode(this.refs.takeOffPlace).value.trim(),
					landingPlace: _reactDom2.default.findDOMNode(this.refs.landingPlace).value.trim(),
					montgolfiereId: this.state.montgolfiereId,
					pilotId: this.state.pilotId
				}, function (err) {
					if (err) return Messenger().post({
						message: err,
						type: "error"
					});
	
					Messenger().post({
						message: "Le vol a été clôturé avec succès.",
						type: "success"
					});
	
					_this2.closeModal();
				}.bind(this));
			}
		}, {
			key: 'getTimeRange',
			value: function getTimeRange() {
				if (!this.props.flight) return { start: '0', end: '23' };
	
				if (this.props.flight.period == 'morning') return { start: '0', end: '23:55' };else return { start: '0', end: '23:55' };
			}
		}, {
			key: 'setTakeOffDate',
			value: function setTakeOffDate(takeOffTime) {
				this.setState({
					takeOffTime: takeOffTime,
					takeOffDate: (0, _moment2.default)(this.props.flight.date).add(takeOffTime, 'seconds').toDate()
				});
			}
		}, {
			key: 'setLandingDate',
			value: function setLandingDate(landingTime) {
				this.setState({
					landingTime: landingTime,
					landingDate: (0, _moment2.default)(this.props.flight.date).add(landingTime, 'seconds').toDate()
				});
			}
		}, {
			key: 'renderModal',
			value: function renderModal() {
				var _this3 = this;
	
				return _react2.default.createElement(
					_rubix.Modal,
					{ show: this.state.showModal, onHide: this.closeModal.bind(this) },
					_react2.default.createElement(
						_rubix.Modal.Header,
						{ closeButton: true },
						_react2.default.createElement(
							_rubix.Modal.Title,
							null,
							'Cloture du vol du ',
							(0, _moment2.default)(this.props.flight.date).format("DD/MM/YYYY"),
							' - ',
							this.props.flight.getPeriod(),
							' - ',
							this.props.flight.getPlace()
						)
					),
					_react2.default.createElement(
						_rubix.Modal.Body,
						null,
						_react2.default.createElement(
							_rubix.FormGroup,
							{ controlId: 'formControlsSelect' },
							_react2.default.createElement(
								_rubix.ControlLabel,
								null,
								'Montgolfiere :'
							),
							_react2.default.createElement(
								_rubix.FormControl,
								{ componentClass: 'select', placeholder: 'Montgolfiere', onChange: function onChange(e) {
										return _this3.setState({ montgolfiereId: e.target.value });
									}, defaultValue: this.props.flight.montgolfiereId },
								this.montgolfieres().map(function (montgolfiere) {
									return _react2.default.createElement(
										'option',
										{ value: montgolfiere._id },
										montgolfiere.name
									);
								})
							)
						),
						_react2.default.createElement(
							_rubix.FormGroup,
							{ controlId: 'formControlsSelect' },
							_react2.default.createElement(
								_rubix.ControlLabel,
								null,
								'Pilote :'
							),
							_react2.default.createElement(
								_rubix.FormControl,
								{ componentClass: 'select', placeholder: 'Pilote', onChange: function onChange(e) {
										return _this3.updatePilot(e.target.value);
									}, defaultValue: this.props.flight.pilotId },
								this.pilots().map(function (pilot) {
									return _react2.default.createElement(
										'option',
										{ value: pilot._id },
										pilot.profile.firstName + ' ' + pilot.profile.lastName
									);
								})
							)
						),
						_react2.default.createElement('hr', null),
						_react2.default.createElement(
							'strong',
							null,
							'Informations de la cloture :'
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							_rubix.FormGroup,
							{ controlId: 'formControlsSelect' },
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 5 },
								_react2.default.createElement(
									_rubix.ControlLabel,
									null,
									'Heure d\'envol :'
								)
							),
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 7 },
								_react2.default.createElement(_reactBootstrapTimePicker2.default, { start: this.getTimeRange().start, end: this.getTimeRange().end, step: 5, format: 24, onChange: this.setTakeOffDate.bind(this), value: this.state.takeOffTime })
							)
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							_rubix.FormGroup,
							{ controlId: 'formControlsSelect' },
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 5 },
								_react2.default.createElement(
									_rubix.ControlLabel,
									null,
									'Lieu d\'envol :'
								)
							),
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 7 },
								_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'takeOffPlace' })
							)
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							_rubix.FormGroup,
							{ controlId: 'formControlsSelect' },
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 5 },
								_react2.default.createElement(
									_rubix.ControlLabel,
									null,
									'Heure d\'atterrissage :'
								)
							),
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 7 },
								_react2.default.createElement(_reactBootstrapTimePicker2.default, { start: this.getTimeRange().start, end: this.getTimeRange().end, step: 5, format: 24, onChange: this.setLandingDate.bind(this), value: this.state.landingTime })
							)
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							_rubix.FormGroup,
							{ controlId: 'formControlsSelect' },
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 5 },
								_react2.default.createElement(
									_rubix.ControlLabel,
									null,
									'Lieu d\'atterrissage :'
								)
							),
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 7 },
								_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'landingPlace' })
							)
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement('br', null)
					),
					_react2.default.createElement(
						_rubix.Modal.Footer,
						null,
						_react2.default.createElement(
							_rubix.Button,
							{ bsStyle: 'success', onClick: this.encloseFlight.bind(this) },
							'Cloturer'
						)
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'primary', onClick: this.openModal.bind(this) },
						'Cloturer mon vol'
					),
					this.state.showModal && this.renderModal()
				);
			}
		}]);
		return PlanningClotureModal;
	}(_react2.default.Component);

/***/ },

/***/ "./src/universal/components/reservations/components/flightTypeColorComponent.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.FlightTypeColor = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactColor = __webpack_require__("./node_modules/react-color/lib/index.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var FlightTypeColor = exports.FlightTypeColor = function (_React$Component) {
		(0, _inherits3.default)(FlightTypeColor, _React$Component);
	
		function FlightTypeColor(props) {
			(0, _classCallCheck3.default)(this, FlightTypeColor);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (FlightTypeColor.__proto__ || (0, _getPrototypeOf2.default)(FlightTypeColor)).call(this, props));
	
			_this.state = {
				flightType: props.flightType,
				tooltip: ''
				//tooltip : <Tooltip id='link-tooltip'>{props.flightType.title}</Tooltip>
			};
	
			return _this;
		}
	
		(0, _createClass3.default)(FlightTypeColor, [{
			key: 'render',
			value: function render() {
	
				if (!this.state.flightType.color) {
					return _react2.default.createElement(
						'div',
						{ className: 'flight-type-color', style: { backgroundColor: this.state.flightType } },
						'\xA0'
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'flight-type-color', style: { backgroundColor: this.state.flightType.color } },
					'\xA0'
				);
			}
		}]);
		return FlightTypeColor;
	}(_react2.default.Component);

/***/ },

/***/ "./src/universal/components/flights/component-notify-sms.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.NotifySmsComponent = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var NotifySmsComponent = exports.NotifySmsComponent = function (_React$Component) {
		(0, _inherits3.default)(NotifySmsComponent, _React$Component);
	
		function NotifySmsComponent(props) {
			(0, _classCallCheck3.default)(this, NotifySmsComponent);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (NotifySmsComponent.__proto__ || (0, _getPrototypeOf2.default)(NotifySmsComponent)).call(this, props));
	
			_this.state = {};
	
			_this.state = {
				tooltip: _react2.default.createElement(
					_rubix.Tooltip,
					{ id: 'link-tooltip' },
					'En attente de r\xE9ception du SMS'
				)
			};
	
			return _this;
		}
	
		(0, _createClass3.default)(NotifySmsComponent, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'span',
					{ className: 'notify-sms' },
					this.props.reservation.pendingSMS && _react2.default.createElement(
						_rubix.OverlayTrigger,
						{ placement: 'right', overlay: this.state.tooltip },
						_react2.default.createElement(_rubix.Icon, { bundle: 'glyphicon', glyph: 'time' })
					)
				);
			}
		}]);
		return NotifySmsComponent;
	}(_react2.default.Component);

/***/ },

/***/ "./src/universal/components/flights/PlanningDateIntervalSelector.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.PlanningDateIntervalSelector = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlanningDateIntervalSelector = exports.PlanningDateIntervalSelector = function (_React$Component) {
		(0, _inherits3.default)(PlanningDateIntervalSelector, _React$Component);
	
		function PlanningDateIntervalSelector(props) {
			(0, _classCallCheck3.default)(this, PlanningDateIntervalSelector);
			return (0, _possibleConstructorReturn3.default)(this, (PlanningDateIntervalSelector.__proto__ || (0, _getPrototypeOf2.default)(PlanningDateIntervalSelector)).call(this, props));
		}
	
		(0, _createClass3.default)(PlanningDateIntervalSelector, [{
			key: 'addDay',
			value: function addDay() {
				this.props.onChange({
					startDate: (0, _moment2.default)(this.props.startDate).add(1, 'day').toDate(),
					endDate: (0, _moment2.default)(this.props.endDate).add(1, 'day').toDate()
				});
			}
		}, {
			key: 'subDay',
			value: function subDay() {
				this.props.onChange({
					startDate: (0, _moment2.default)(this.props.startDate).subtract(1, 'day').toDate(),
					endDate: (0, _moment2.default)(this.props.endDate).subtract(1, 'day').toDate()
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Col,
						{ sm: 2 },
						_react2.default.createElement(_rubix.Icon, { bundle: 'glyphicon', glyph: 'arrow-left', onClick: this.subDay.bind(this) })
					),
					_react2.default.createElement(
						_rubix.Col,
						{ sm: 8 },
						_react2.default.createElement(
							'p',
							null,
							'Du \xA0',
							(0, _moment2.default)(this.props.startDate).format('DD/MM/YYYY'),
							'\xA0 au \xA0',
							(0, _moment2.default)(this.props.endDate).format('DD/MM/YYYY')
						)
					),
					_react2.default.createElement(
						_rubix.Col,
						{ sm: 2 },
						_react2.default.createElement(_rubix.Icon, { bundle: 'glyphicon', glyph: 'arrow-right', onClick: this.addDay.bind(this) })
					)
				);
			}
		}]);
		return PlanningDateIntervalSelector;
	}(_react2.default.Component);
	
	PlanningDateIntervalSelector.propTypes = {
		startDate: _react2.default.PropTypes.instanceOf(Date),
		endDate: _react2.default.PropTypes.instanceOf(Date),
		onChange: _react2.default.PropTypes.func
	};

/***/ },

/***/ "./src/universal/components/flights/PlanningProgrammePage.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _map = __webpack_require__("./node_modules/babel-runtime/core-js/map.js");
	
	var _map2 = _interopRequireDefault(_map);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class;
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _FlightIndicator = __webpack_require__("./src/universal/components/flights/FlightIndicator.js");
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	var _ReservationTable = __webpack_require__("./src/universal/components/reservations/components/ReservationTable.js");
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	var _methods = __webpack_require__("./src/universal/collections/flights/methods.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Tracker = Package.tracker.Tracker;
	
	var PlanningProgrammePage = (0, _reactRouter.withRouter)(_class = function (_React$Component) {
		(0, _inherits3.default)(PlanningProgrammePage, _React$Component);
	
		function PlanningProgrammePage(props) {
			(0, _classCallCheck3.default)(this, PlanningProgrammePage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (PlanningProgrammePage.__proto__ || (0, _getPrototypeOf2.default)(PlanningProgrammePage)).call(this, props));
	
			_this.state = {};
	
			Tracker.nonreactive(function () {
				_this.state.subscription = Meteor.subscribe('flight', _this.props.params.flightId, function () {
					_this.state.flight = _flights.Flights.findOne(_this.props.params.flightId);
	
					if (!_this.state.flight) _this.props.router.push('/planning');
	
					_this.setState({
						ready: true,
						modalInfoVisibility: false,
						montgolfiereId: _this.state.montgolfiereId || (_this.montgolfieres().length ? _this.montgolfieres()[0]._id : null),
						temp: _this.state.flight.temp || 1,
						schedulableReservations: _this.schedulableReservations(),
						scheduledReservations: _this.scheduledReservations(),
						schedulableReservationsSelected: new _map2.default(),
						scheduledReservationsSelected: new _map2.default()
					});
	
					if (!_this.state.flight.pilotId) {
						_this.updatePilot(Meteor.userId());
					}
				});
			});
			return _this;
		}
	
		(0, _createClass3.default)(PlanningProgrammePage, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				if (this.state.flight && (!this.state.scheduledReservations || !this.state.scheduledReservations.length || !this.state.flight.pilotId || !this.state.montgolfiereId)) {
					_flights.Flights.remove({ _id: this.state.flight._id });
				}
	
				this.state.subscription.stop();
			}
		}, {
			key: 'prepareFlight',
			value: function prepareFlight() {
				var _this2 = this;
	
				_methods.prepareFlight.call({
					_id: this.state.flight._id,
					place: this.state.flight.place,
					reservationIds: _.map(this.state.scheduledReservations, '_id'),
					pilotId: this.state.flight.pilotId,
					montgolfiereId: this.state.montgolfiereId,
					temp: parseInt(this.state.temp)
				}, function (err) {
					if (err) return Messenger().post({
						message: err,
						type: "error"
					});
	
					Messenger().post({
						message: "Le vol a été preparé avec succès.",
						type: "success"
					});
	
					_this2.props.router.push('/planning?date=' + _this2.state.flight.date);
				}.bind(this));
			}
		}, {
			key: 'updatePlace',
			value: function updatePlace(place) {
				this.setState({ flight: _.extend(this.state.flight, { place: place, reservationIds: [] }) });
				this.setState({
					flight: _.extend(this.state.flight, { pilotId: this.pilots().length ? this.pilots()[0]._id : null }),
					montgolfiereId: this.montgolfieres().length ? this.montgolfieres()[0]._id : null,
					schedulableReservations: this.schedulableReservations(),
					scheduledReservations: this.scheduledReservations(),
					schedulableReservationsSelected: new _map2.default(),
					scheduledReservationsSelected: new _map2.default()
				});
			}
		}, {
			key: 'updatePilot',
			value: function updatePilot(pilotId) {
				this.setState({ flight: _.extend(this.state.flight, { pilotId: pilotId }) });
				this.setState({
					montgolfiereId: this.montgolfieres().length ? this.montgolfieres()[0]._id : null
				});
			}
		}, {
			key: 'add',
			value: function add() {
				var _this3 = this;
	
				this.setState({
					schedulableReservations: _.reject(this.state.schedulableReservations, function (reservation) {
						return _.includes(_.map([].concat((0, _toConsumableArray3.default)(_this3.state.schedulableReservationsSelected.values())), '_id'), reservation._id);
					}),
					scheduledReservations: _.concat(this.state.scheduledReservations, [].concat((0, _toConsumableArray3.default)(this.state.schedulableReservationsSelected.values()))),
					schedulableReservationsSelected: new _map2.default(),
					scheduledReservationsSelected: new _map2.default()
				});
			}
		}, {
			key: 'subtract',
			value: function subtract() {
				var _this4 = this;
	
				this.setState({
					schedulableReservations: _.concat(this.state.schedulableReservations, [].concat((0, _toConsumableArray3.default)(this.state.scheduledReservationsSelected.values()))),
					scheduledReservations: _.reject(this.state.scheduledReservations, function (reservation) {
						return _.includes(_.map([].concat((0, _toConsumableArray3.default)(_this4.state.scheduledReservationsSelected.values())), '_id'), reservation._id);
					}),
					schedulableReservationsSelected: new _map2.default(),
					scheduledReservationsSelected: new _map2.default()
				});
			}
		}, {
			key: 'schedulableReservations',
			value: function schedulableReservations() {
				var _this5 = this;
	
				var existingFlight = _flights.Flights.find({ _id: { $ne: this.state.flight._id }, status: { $ne: 'cancelled' }, place: this.state.flight.place, period: this.state.flight.period, date: (0, _moment2.default)(this.state.flight.date).startOf("day").toDate() }).fetch();
				var scheduledReservationIds = _.reduce(existingFlight, function (acc, flight) {
					return acc.concat(flight.reservationIds);
				}, []).concat(_.map(this.scheduledReservations(), '_id'));
	
				var reservations = _reservations.Reservations.find({
					_id: { $nin: scheduledReservationIds },
					place: this.state.flight.place,
					$or: [{ 'periodTime': this.state.flight.period }, { 'period': this.state.flight.period }],
					scheduledAt: (0, _moment2.default)(this.state.flight.date).startOf("day").toDate()
				}).fetch();
	
				var results = _.reject(reservations, function (reservation) {
					if (reservation.period && reservation.periodTime) {
						if (reservation.periodTime != _this5.state.flight.period) {
							return true;
						}
					}
				});
	
				console.log('results', results);
	
				return results;
			}
		}, {
			key: 'scheduledReservations',
			value: function scheduledReservations() {
				return _reservations.Reservations.find({
					_id: { $in: this.state.flight.reservationIds || [] }
				}).fetch();
			}
		}, {
			key: 'montgolfieres',
			value: function montgolfieres() {
				var existingFlight = _flights.Flights.find({ _id: { $ne: this.state.flight._id }, place: this.state.flight.place, period: this.state.flight.period, date: (0, _moment2.default)(this.state.flight.date).startOf("day").toDate(), status: { $ne: 'cancelled' } }).fetch();
				var scheduledMontgolfiereIds = _.reduce(existingFlight, function (acc, flight) {
					acc.push(flight.montgolfiereId);
					return acc;
				}, []);
	
				var projection = {
					$elemMatch: {
						startDate: { $lte: this.state.flight.date },
						endDate: { $gte: this.state.flight.date },
						isAvailable: true,
						period: this.state.flight.period,
						place: this.state.flight.place
					}
				};
	
				return _montgolfieres.Montgolfieres.find({
					_id: { $nin: scheduledMontgolfiereIds },
					availabilities: projection,
					allowedPilots: { $in: [this.state.flight.pilotId] }
				}).fetch();
			}
		}, {
			key: 'pilots',
			value: function pilots() {
				var existingFlight = _flights.Flights.find({ _id: { $ne: this.state.flight._id }, place: this.state.flight.place, period: this.state.flight.period, date: (0, _moment2.default)(this.state.flight.date).startOf("day").toDate(), status: { $ne: 'cancelled' } }).fetch();
				var scheduledPilotIds = _.reduce(existingFlight, function (acc, flight) {
					acc.push(flight.pilotId);
					return acc;
				}, []);
	
				var projection = {
					$elemMatch: {
						startDate: { $lte: this.state.flight.date },
						endDate: { $gte: this.state.flight.date },
						isAvailable: true,
						period: this.state.flight.period,
						place: this.state.flight.place
					}
				};
	
				return Meteor.users.find({
					_id: { $nin: scheduledPilotIds },
					"profile.availabilities": projection
				}).fetch();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this6 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'planning-programme' },
					this.state.ready && _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 12 },
							_react2.default.createElement(
								'h3',
								null,
								'Programmer un vol le ',
								(0, _moment2.default)(this.state.flight.date).format("DD/MM/YYYY")
							),
							_react2.default.createElement('br', null)
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 12 },
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 6 },
								_react2.default.createElement(
									_rubix.BPanel,
									{ header: 'R\xE9servations' },
									_react2.default.createElement(
										_rubix.Table,
										{ striped: true, bordered: true, condensed: true, hover: true },
										_react2.default.createElement(
											'tbody',
											null,
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													_react2.default.createElement(
														'div',
														{ className: 'flight-type-color', style: { backgroundColor: '#8bc34a' } },
														'\xA0'
													)
												),
												_react2.default.createElement(
													'td',
													null,
													'Vol d\xE9couverte'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													_react2.default.createElement(
														'div',
														{ className: 'flight-type-color', style: { backgroundColor: '#f44336' } },
														'\xA0'
													)
												),
												_react2.default.createElement(
													'td',
													null,
													'Vol exclusif'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													_react2.default.createElement(
														'div',
														{ className: 'flight-type-color', style: { backgroundColor: '#ffeb3b' } },
														'\xA0'
													)
												),
												_react2.default.createElement(
													'td',
													null,
													'Vol soleil levant'
												)
											)
										)
									),
									this.state.schedulableReservations.length > 0 && _react2.default.createElement(_ReservationTable.ReservationTable, { reservations: this.state.schedulableReservations, selected: this.state.schedulableReservationsSelected })
								)
							),
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 1, className: 'programmation-buttons' },
								_react2.default.createElement(
									'center',
									null,
									_react2.default.createElement(
										_rubix.Button,
										{ bsStyle: 'green', onClick: this.add.bind(this) },
										_react2.default.createElement(_rubix.Icon, { glyph: 'glyphicon-plus-sign' })
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										_rubix.Button,
										{ bsStyle: 'red', onClick: this.subtract.bind(this) },
										_react2.default.createElement(_rubix.Icon, { glyph: 'glyphicon-minus-sign' })
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement('br', null)
								)
							),
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 5 },
								_react2.default.createElement(
									_rubix.BPanel,
									{ header: 'Mon Vol' },
									_react2.default.createElement(
										_rubix.Form,
										null,
										_roles.Roles.userHasPermission(Meteor.userId(), "flights.organize") && _react2.default.createElement(
											_rubix.FormGroup,
											{ controlId: 'formControlsSelect' },
											_react2.default.createElement(
												_rubix.ControlLabel,
												null,
												'Lieu :'
											),
											_react2.default.createElement(
												_rubix.FormControl,
												{ componentClass: 'select', placeholder: 'Lieu', onChange: function onChange(e) {
														return _this6.updatePlace(e.target.value);
													}, defaultValue: this.state.flight.place },
												_react2.default.createElement(
													'option',
													{ value: "anjou" },
													'Anjou'
												),
												_react2.default.createElement(
													'option',
													{ value: "nantes" },
													'Nantes'
												)
											)
										),
										_roles.Roles.userHasPermission(Meteor.userId(), "flights.organize") && _react2.default.createElement(
											_rubix.FormGroup,
											{ controlId: 'formControlsSelect' },
											_react2.default.createElement(
												_rubix.ControlLabel,
												null,
												'Pilote :'
											),
											_react2.default.createElement(
												_rubix.FormControl,
												{ componentClass: 'select', placeholder: 'Pilote', onChange: function onChange(e) {
														return _this6.updatePilot(e.target.value);
													}, defaultValue: this.state.flight.pilotId },
												this.pilots().map(function (pilot) {
													return _react2.default.createElement(
														'option',
														{ value: pilot._id },
														pilot.profile.firstName + ' ' + pilot.profile.lastName
													);
												})
											)
										),
										_react2.default.createElement(
											_rubix.FormGroup,
											{ controlId: 'formControlsSelect' },
											_react2.default.createElement(
												_rubix.ControlLabel,
												null,
												'Montgolfiere :'
											),
											_react2.default.createElement(
												_rubix.FormControl,
												{ componentClass: 'select', placeholder: 'Montgolfiere', onChange: function onChange(e) {
														return _this6.setState({ montgolfiereId: e.target.value });
													}, defaultValue: this.state.montgolfiereId },
												this.montgolfieres().map(function (montgolfiere) {
													return _react2.default.createElement(
														'option',
														{ value: montgolfiere._id },
														montgolfiere.name
													);
												})
											)
										),
										_react2.default.createElement(
											_rubix.FormGroup,
											{ controlId: 'formControlsSelect' },
											_react2.default.createElement(
												_rubix.ControlLabel,
												null,
												'Temp\xE9rature :'
											),
											_react2.default.createElement(
												_rubix.FormControl,
												{ componentClass: 'select', placeholder: 'Temp\xE9rature', onChange: function onChange(e) {
														return _this6.setState({ temp: e.target.value });
													}, defaultValue: this.state.temp },
												_react2.default.createElement(
													'option',
													{ value: 1 },
													'De 0\xB0 \xE0 8\xB0C'
												),
												_react2.default.createElement(
													'option',
													{ value: 2 },
													'De 8\xB0 \xE0 16\xB0C'
												),
												_react2.default.createElement(
													'option',
													{ value: 3 },
													'De 16\xB0 \xE0 22\xB0C'
												),
												_react2.default.createElement(
													'option',
													{ value: 4 },
													'De 22\xB0 \xE0 28\xB0C'
												),
												_react2.default.createElement(
													'option',
													{ value: 5 },
													'De 28\xB0 \xE0 36\xB0C'
												),
												_react2.default.createElement(
													'option',
													{ value: 6 },
													'36\xB0C et +'
												)
											)
										)
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'strong',
										null,
										'R\xE9servations ajout\xE9es :'
									),
									_react2.default.createElement('br', null),
									this.state.scheduledReservations.length > 0 && _react2.default.createElement(_ReservationTable.ReservationTable, { reservations: this.state.scheduledReservations, selected: this.state.scheduledReservationsSelected }),
									_react2.default.createElement('hr', null),
									_react2.default.createElement(_FlightIndicator.FlightIndicator, {
										montgolfiere: _montgolfieres.Montgolfieres.findOne(this.state.montgolfiereId),
										pilot: Meteor.users.findOne(this.state.flight.pilotId),
										temp: this.state.temp,
										reservations: this.state.scheduledReservations
									}),
									_react2.default.createElement('hr', null),
									_react2.default.createElement(
										'center',
										null,
										_react2.default.createElement(
											_rubix.Button,
											{ bsStyle: 'primary', onClick: this.prepareFlight.bind(this) },
											'Programmer'
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
		return PlanningProgrammePage;
	}(_react2.default.Component)) || _class;
	
	exports.default = PlanningProgrammePage;

/***/ },

/***/ "./node_modules/babel-runtime/core-js/map.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/map.js"), __esModule: true };

/***/ },

/***/ "./node_modules/core-js/library/fn/map.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.object.to-string.js");
	__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
	__webpack_require__("./node_modules/core-js/library/modules/web.dom.iterable.js");
	__webpack_require__("./node_modules/core-js/library/modules/es6.map.js");
	__webpack_require__("./node_modules/core-js/library/modules/es7.map.to-json.js");
	__webpack_require__("./node_modules/core-js/library/modules/es7.map.of.js");
	__webpack_require__("./node_modules/core-js/library/modules/es7.map.from.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Map;


/***/ },

/***/ "./node_modules/core-js/library/modules/es6.map.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__("./node_modules/core-js/library/modules/_collection-strong.js");
	var validate = __webpack_require__("./node_modules/core-js/library/modules/_validate-collection.js");
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_collection.js")(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },

/***/ "./node_modules/core-js/library/modules/_collection-strong.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
	var create = __webpack_require__("./node_modules/core-js/library/modules/_object-create.js");
	var redefineAll = __webpack_require__("./node_modules/core-js/library/modules/_redefine-all.js");
	var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
	var anInstance = __webpack_require__("./node_modules/core-js/library/modules/_an-instance.js");
	var forOf = __webpack_require__("./node_modules/core-js/library/modules/_for-of.js");
	var $iterDefine = __webpack_require__("./node_modules/core-js/library/modules/_iter-define.js");
	var step = __webpack_require__("./node_modules/core-js/library/modules/_iter-step.js");
	var setSpecies = __webpack_require__("./node_modules/core-js/library/modules/_set-species.js");
	var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
	var fastKey = __webpack_require__("./node_modules/core-js/library/modules/_meta.js").fastKey;
	var validate = __webpack_require__("./node_modules/core-js/library/modules/_validate-collection.js");
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_validate-collection.js":
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_collection.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	var meta = __webpack_require__("./node_modules/core-js/library/modules/_meta.js");
	var fails = __webpack_require__("./node_modules/core-js/library/modules/_fails.js");
	var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
	var redefineAll = __webpack_require__("./node_modules/core-js/library/modules/_redefine-all.js");
	var forOf = __webpack_require__("./node_modules/core-js/library/modules/_for-of.js");
	var anInstance = __webpack_require__("./node_modules/core-js/library/modules/_an-instance.js");
	var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
	var setToStringTag = __webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js");
	var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
	var each = __webpack_require__("./node_modules/core-js/library/modules/_array-methods.js")(0);
	var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    C = wrapper(function (target, iterable) {
	      anInstance(target, C, NAME, '_c');
	      target._c = new Base();
	      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
	        anInstance(this, C, KEY);
	        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    IS_WEAK || dP(C.prototype, 'size', {
	      get: function () {
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_array-methods.js":
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
	var IObject = __webpack_require__("./node_modules/core-js/library/modules/_iobject.js");
	var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
	var toLength = __webpack_require__("./node_modules/core-js/library/modules/_to-length.js");
	var asc = __webpack_require__("./node_modules/core-js/library/modules/_array-species-create.js");
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_array-species-create.js":
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__("./node_modules/core-js/library/modules/_array-species-constructor.js");
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_array-species-constructor.js":
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
	var isArray = __webpack_require__("./node_modules/core-js/library/modules/_is-array.js");
	var SPECIES = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/es7.map.to-json.js":
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__("./node_modules/core-js/library/modules/_collection-to-json.js")('Map') });


/***/ },

/***/ "./node_modules/core-js/library/modules/_collection-to-json.js":
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__("./node_modules/core-js/library/modules/_classof.js");
	var from = __webpack_require__("./node_modules/core-js/library/modules/_array-from-iterable.js");
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/_array-from-iterable.js":
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__("./node_modules/core-js/library/modules/_for-of.js");
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/es7.map.of.js":
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__("./node_modules/core-js/library/modules/_set-collection-of.js")('Map');


/***/ },

/***/ "./node_modules/core-js/library/modules/_set-collection-of.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },

/***/ "./node_modules/core-js/library/modules/es7.map.from.js":
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__("./node_modules/core-js/library/modules/_set-collection-from.js")('Map');


/***/ },

/***/ "./node_modules/core-js/library/modules/_set-collection-from.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");
	var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
	var forOf = __webpack_require__("./node_modules/core-js/library/modules/_for-of.js");
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },

/***/ "./src/universal/components/flights/FlightIndicator.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.FlightIndicator = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FlightIndicator = exports.FlightIndicator = function (_React$Component) {
		(0, _inherits3.default)(FlightIndicator, _React$Component);
	
		function FlightIndicator(props) {
			(0, _classCallCheck3.default)(this, FlightIndicator);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (FlightIndicator.__proto__ || (0, _getPrototypeOf2.default)(FlightIndicator)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(FlightIndicator, [{
			key: 'scheduledPassengersWeight',
			value: function scheduledPassengersWeight() {
				return _.reduce(this.props.reservations, function (weight, reservation) {
					return weight + reservation.totalWeight();
				}, 0) + (this.props.pilot && this.props.pilot.profile.weight ? this.props.pilot.profile.weight : 0);
			}
		}, {
			key: 'availableTotalWeight',
			value: function availableTotalWeight() {
				if (!this.props.montgolfiere) return 0;
	
				return (this.props.temp ? this.props.montgolfiere.maxWeight["temp" + this.props.temp] : this.props.montgolfiere.defaultWeight) - this.props.montgolfiere.defaultWeight;
			}
		}, {
			key: 'availableRemainingWeight',
			value: function availableRemainingWeight() {
				return this.availableTotalWeight() - this.scheduledPassengersWeight();
			}
		}, {
			key: 'scheduledPassengersCount',
			value: function scheduledPassengersCount() {
				return _.reduce(this.props.reservations, function (count, reservation) {
					return count + reservation.passengers.length;
				}, 0);
			}
		}, {
			key: 'availablePassengersCount',
			value: function availablePassengersCount() {
				if (!this.props.montgolfiere) return 0;
	
				return this.props.montgolfiere.maxPassengers;
			}
		}, {
			key: 'weightRatio',
			value: function weightRatio() {
				var ratio = this.scheduledPassengersWeight() / this.availableTotalWeight() * 100;
	
				return ratio > 100 ? 100 : ratio;
			}
		}, {
			key: 'passengersRatio',
			value: function passengersRatio() {
				var ratio = this.scheduledPassengersCount() / this.availablePassengersCount() * 100;
	
				return ratio > 100 ? 100 : ratio;
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_rubix.Progress, { striped: true, danger: this.weightRatio() >= 100, value: this.weightRatio(), label: this.scheduledPassengersWeight() + "Kg / " + this.availableTotalWeight() + "Kg - Restant : " + this.availableRemainingWeight() + "Kg" }),
					_react2.default.createElement(_rubix.Progress, { striped: true, danger: this.passengersRatio() >= 100, value: this.passengersRatio(), label: this.scheduledPassengersCount() + " / " + this.availablePassengersCount() + " passagers" })
				);
			}
		}]);
		return FlightIndicator;
	}(_react2.default.Component);

/***/ },

/***/ "./src/universal/components/reservations/components/ReservationTable.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ReservationTable = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _ReservationModal = __webpack_require__("./src/universal/components/reservations/components/ReservationModal.js");
	
	var _flightTypeColorComponent = __webpack_require__("./src/universal/components/reservations/components/flightTypeColorComponent.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var ReservationTable = exports.ReservationTable = function (_React$Component) {
		(0, _inherits3.default)(ReservationTable, _React$Component);
	
		function ReservationTable(props) {
			(0, _classCallCheck3.default)(this, ReservationTable);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (ReservationTable.__proto__ || (0, _getPrototypeOf2.default)(ReservationTable)).call(this, props));
	
			_this.state = {
				modal: {
					visible: false,
					reservation: null
				}
			};
			return _this;
		}
	
		(0, _createClass3.default)(ReservationTable, [{
			key: 'openModal',
			value: function openModal(reservation) {
				this.setState({
					modal: {
						visible: true,
						reservation: reservation
					}
				});
			}
		}, {
			key: 'handleCheckboxChange',
			value: function handleCheckboxChange(e, reservation) {
				var value = e.target.checked;
	
				if (value) this.props.selected.set(reservation._id, reservation);else this.props.selected.delete(reservation._id);
	
				console.log('type', reservation.getFlightType());
	
				this.forceUpdate();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ style: { 'overflow': 'scroll' } },
					_react2.default.createElement(
						_rubix.Table,
						{ striped: true, bordered: true, condensed: true, hover: true },
						_react2.default.createElement(
							'thead',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									null,
									'#'
								),
								_react2.default.createElement(
									'th',
									null,
									'Type'
								),
								_react2.default.createElement(
									'th',
									null,
									'Billet'
								),
								_react2.default.createElement(
									'th',
									null,
									'Passagers'
								),
								_react2.default.createElement(
									'th',
									null,
									'Poids'
								),
								_react2.default.createElement(
									'th',
									null,
									'Liaison ?'
								),
								_react2.default.createElement(
									'th',
									null,
									'Infos'
								)
							)
						),
						_react2.default.createElement(
							'tbody',
							null,
							this.props.reservations && this.props.reservations.map(function (reservation) {
								return _react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(_rubix.Checkbox, { checked: _this2.props.selected.has(reservation._id), onChange: function onChange(e) {
												return _this2.handleCheckboxChange(e, reservation);
											} })
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(
											'div',
											{ className: 'flight-type-color', style: { backgroundColor: reservation.color } },
											'\xA0'
										)
									),
									_react2.default.createElement(
										'td',
										null,
										'N\xB0',
										reservation.id_billet
									),
									_react2.default.createElement(
										'td',
										null,
										reservation.passengers.length,
										' pax'
									),
									_react2.default.createElement(
										'td',
										null,
										reservation.totalWeight(),
										'Kg'
									),
									_react2.default.createElement(
										'td',
										null,
										reservation.linkReservation
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(_rubix.Icon, { glyph: 'glyphicon-search', onClick: function onClick() {
												return _this2.openModal(reservation);
											} })
									)
								);
							})
						)
					),
					_react2.default.createElement(_ReservationModal.ReservationModal, { visible: this.state.modal.visible, reservation: this.state.modal.reservation, onHide: function onHide() {
							return _this2.setState({ modal: { visible: false } });
						} })
				);
			}
		}]);
		return ReservationTable;
	}(_react2.default.Component);

/***/ },

/***/ "./src/universal/components/reservations/components/ReservationModal.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ReservationModal = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var ReservationModal = exports.ReservationModal = function (_React$Component) {
		(0, _inherits3.default)(ReservationModal, _React$Component);
	
		function ReservationModal(props) {
			(0, _classCallCheck3.default)(this, ReservationModal);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (ReservationModal.__proto__ || (0, _getPrototypeOf2.default)(ReservationModal)).call(this, props));
	
			_this.state = {
				visible: _this.props.visible
			};
			return _this;
		}
	
		(0, _createClass3.default)(ReservationModal, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(_ref) {
				var visible = _ref.visible;
	
				this.setState({
					visible: visible
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _context;
	
				if (!this.props.reservation) return null;
	
				return _react2.default.createElement(
					_rubix.Modal,
					{ show: this.state.visible, lg: true, 'aria-labelledby': 'contained-modal-title-lg', onHide: (_context = this.props).onHide.bind(_context) },
					_react2.default.createElement(
						_rubix.Modal.Header,
						{ closeButton: true },
						_react2.default.createElement(
							_rubix.Modal.Title,
							{ id: 'contained-modal-title-lg' },
							'R\xE9servation N\xB0',
							this.props.reservation.id
						)
					),
					_react2.default.createElement(
						_rubix.Modal.Body,
						null,
						_react2.default.createElement(
							'strong',
							null,
							'Informations sur les passagers :'
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							'div',
							{ style: { 'overflow': 'scroll' } },
							_react2.default.createElement(
								_rubix.Table,
								{ striped: true, bordered: true, condensed: true, hover: true },
								_react2.default.createElement(
									'thead',
									null,
									_react2.default.createElement(
										'tr',
										null,
										_react2.default.createElement(
											'th',
											null,
											'Nom'
										),
										_react2.default.createElement(
											'th',
											null,
											'Pr\xE9nom'
										),
										_react2.default.createElement(
											'th',
											null,
											'Poids'
										),
										_react2.default.createElement(
											'th',
											null,
											'Age'
										),
										_react2.default.createElement(
											'th',
											null,
											'T\xE9l\xE9phone'
										),
										_react2.default.createElement(
											'th',
											null,
											'Information'
										)
									)
								),
								_react2.default.createElement(
									'tbody',
									null,
									this.props.reservation.getPassengers().map(function (passenger) {
										return _react2.default.createElement(
											'tr',
											null,
											_react2.default.createElement(
												'td',
												null,
												passenger.lastName
											),
											_react2.default.createElement(
												'td',
												null,
												passenger.firstName
											),
											_react2.default.createElement(
												'td',
												null,
												passenger.weight,
												'kg'
											),
											_react2.default.createElement(
												'td',
												null,
												passenger.age,
												' ans'
											),
											_react2.default.createElement(
												'td',
												null,
												passenger.phone
											),
											_react2.default.createElement(
												'td',
												null,
												passenger.info
											)
										);
									})
								)
							)
						),
						_react2.default.createElement('hr', null),
						_react2.default.createElement(
							'strong',
							null,
							'Note interne :'
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							'p',
							null,
							this.props.reservation.infoReservation
						)
					),
					_react2.default.createElement(
						_rubix.Modal.Footer,
						null,
						_react2.default.createElement(
							_rubix.Button,
							{ onClick: (_context = this.props).onHide.bind(_context) },
							'Fermer'
						)
					)
				);
			}
		}]);
		return ReservationModal;
	}(_react2.default.Component);

/***/ },

/***/ "./src/universal/components/prices/PricesForm.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _prices = __webpack_require__("./src/universal/collections/flights-type/prices.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var PricesFormPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["flights-type"]
	}), (0, _reactRouter.withRouter)(_class = _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(PricesFormPage, _React$Component);
	
		function PricesFormPage(props) {
			(0, _classCallCheck3.default)(this, PricesFormPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (PricesFormPage.__proto__ || (0, _getPrototypeOf2.default)(PricesFormPage)).call(this, props));
	
			_this.state = {};
			if (_this.props.params.id) _this.price = _prices.Prices.find({ _id: _this.props.params.id }).fetch()[0];else _this.price = {};
			return _this;
		}
	
		(0, _createClass3.default)(PricesFormPage, [{
			key: 'handleSubmit',
			value: function handleSubmit(e) {
				e.preventDefault();
	
				var params = {};
				var message = null;
				var method = null;
	
				params.attributes = {};
				_lodash2.default.each(this.refs, function (ref, key) {
					params.attributes[key] = _reactDom2.default.findDOMNode(ref).value.trim();
				});
	
				if (this.props.params.id) {
					message = "Le tarif a été modifié avec succès.";
					method = "prices.update";
					params._id = this.props.params.id;
				} else {
					message = "Le tarif a été ajouté avec succès.";
					method = "prices.insert";
					params.attributes["createdAt"] = new Date();
				}
	
				Meteor.call(method, params, function (err, _id) {
	
					if (err) {
						Messenger().post({
							message: err,
							type: "error"
						});
						return;
					}
	
					Messenger().post({
						message: message,
						type: "success"
					});
	
					this.props.router.push('/prices');
				}.bind(this));
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/prices' },
								'Tarifs'
							)
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ href: '#', active: true },
							'Ajouter/Modifier un Tarif'
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Ajouter/Modifier un tarif' },
						_react2.default.createElement(
							_rubix.Form,
							{ horizontal: true, onSubmit: this.handleSubmit.bind(this) },
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalEmail' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'Titre du tarif'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 10 },
									_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'title', defaultValue: this.price.title })
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalPassword' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'Prix par passager'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 10 },
									_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'price', defaultValue: this.price.price })
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalPassword' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'Contrainte de p\xE9riode'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 10 },
									_react2.default.createElement(
										_rubix.FormControl,
										{ componentClass: 'select', placeholder: 'select', ref: 'constraintPeriod', defaultValue: this.price.constraintPeriod },
										_react2.default.createElement(
											'option',
											{ value: 'Aucune restriction' },
											'Aucune'
										),
										_react2.default.createElement(
											'option',
											{ value: 'Semaine uniquement' },
											'Semaine seulement'
										)
									)
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalPassword' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'Contrainte de lieu'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 10 },
									_react2.default.createElement(
										_rubix.FormControl,
										{ componentClass: 'select', placeholder: 'select', ref: 'constraintPlace', defaultValue: this.price.constraintPlace },
										_react2.default.createElement(
											'option',
											{ value: 'aucune' },
											'Aucune'
										),
										_react2.default.createElement(
											'option',
											{ value: 'anjou' },
											'Sites Anjou seulement'
										),
										_react2.default.createElement(
											'option',
											{ value: 'nantes' },
											'Sites Nantes seulement'
										)
									)
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalPassword' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'Contrainte d\'age*'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 2 },
									_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'constraintAge', defaultValue: this.price.constraintAge })
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 8 },
									_react2.default.createElement(
										'small',
										null,
										'*Age maximum, laisser vide sinon'
									)
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalPassword' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'Contrainte de poids*'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 2 },
									_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'constraintWeight', defaultValue: this.price.constraintWeight })
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 8 },
									_react2.default.createElement(
										'small',
										null,
										'*Poids maximum, laisser vide sinon'
									)
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalPassword' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'R\xE9f\xE9rence*'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 2 },
									_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'reference', defaultValue: this.price.reference })
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 8 },
									_react2.default.createElement(
										'small',
										null,
										'* laisser vide si ce prix n\'existe pas sur le site.'
									)
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								null,
								_react2.default.createElement(
									_rubix.Col,
									{ smOffset: 2, sm: 10 },
									_react2.default.createElement(
										_rubix.Button,
										{ type: 'submit' },
										'Enregistrer'
									)
								)
							)
						)
					)
				);
			}
		}]);
		return PricesFormPage;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = PricesFormPage;
	
	
	PricesFormPage.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/prices/PricesList.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _prices = __webpack_require__("./src/universal/collections/flights-type/prices.js");
	
	var _componentPricesList = __webpack_require__("./src/universal/components/prices/component-prices-list.js");
	
	var _componentPricesList2 = _interopRequireDefault(_componentPricesList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var PricesListPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["flights-type"],
		prices: _prices.Prices.find({ partnerId: null })
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(PricesListPage, _React$Component);
	
		function PricesListPage(props) {
			(0, _classCallCheck3.default)(this, PricesListPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (PricesListPage.__proto__ || (0, _getPrototypeOf2.default)(PricesListPage)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(PricesListPage, [{
			key: 'renderPrices',
			value: function renderPrices() {
				return this.props.prices.map(function (price) {
					return _react2.default.createElement(_componentPricesList2.default, { key: price._id, price: price });
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							'Prix'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ active: true },
							'Liste des prix'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/prices-add' },
								_react2.default.createElement(
									_rubix.Button,
									{ bsStyle: 'success' },
									'Ajouter'
								)
							)
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Liste des prix' },
						_react2.default.createElement(
							_rubix.Table,
							{ responsive: true },
							_react2.default.createElement(
								'thead',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'th',
										null,
										'Nom'
									),
									_react2.default.createElement(
										'th',
										null,
										'G\xE9n\xE9rique ?'
									),
									_react2.default.createElement(
										'th',
										null,
										'Date de cr\xE9ation'
									),
									_react2.default.createElement(
										'th',
										null,
										'Derni\xE8re modification'
									),
									_react2.default.createElement(
										'th',
										null,
										'Actions'
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								this.renderPrices()
							)
						)
					)
				);
			}
		}]);
		return PricesListPage;
	}(_react2.default.Component)) || _class);
	exports.default = PricesListPage;

/***/ },

/***/ "./src/universal/components/prices/component-prices-list.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _reactRouter2 = _interopRequireDefault(_reactRouter);
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var PriceListComponent = function (_React$Component) {
	  (0, _inherits3.default)(PriceListComponent, _React$Component);
	
	  function PriceListComponent() {
	    (0, _classCallCheck3.default)(this, PriceListComponent);
	    return (0, _possibleConstructorReturn3.default)(this, (PriceListComponent.__proto__ || (0, _getPrototypeOf2.default)(PriceListComponent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PriceListComponent, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          this.props.price.title
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          this.props.price.price,
	          '\u20AC'
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _reactMoment2.default,
	            { format: 'DD/MM/YYYY' },
	            this.props.price.createdAt
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _reactMoment2.default,
	            { format: 'DD/MM/YYYY' },
	            this.props.price.editedAt
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _rubix.Button,
	            { bsStyle: 'warning', onClick: this.goToEditView.bind(this) },
	            'Modifier'
	          ),
	          '\xA0\xA0',
	          _react2.default.createElement(
	            _rubix.Button,
	            { bsStyle: 'danger', onClick: this.deleteThisPrice.bind(this) },
	            'Supprimer'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'deleteThisPrice',
	    value: function deleteThisPrice() {
	      Meteor.call('prices.remove', this.props.price._id);
	    }
	  }, {
	    key: 'goToEditView',
	    value: function goToEditView() {
	      this.context.router.push('/prices/' + this.props.price._id);
	    }
	  }]);
	  return PriceListComponent;
	}(_react2.default.Component);
	
	exports.default = PriceListComponent;
	
	
	PriceListComponent.propTypes = {
	  // This component gets the task to display through a React prop.
	  // We can use propTypes to indicate it is required
	  price: _react2.default.PropTypes.object.isRequired
	};
	
	PriceListComponent.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/promotions/PromotionsForm.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _promotions = __webpack_require__("./src/universal/collections/flights-type/promotions.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var PromotionsFormPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["flights-type"]
	}), (0, _reactRouter.withRouter)(_class = _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(PromotionsFormPage, _React$Component);
	
		function PromotionsFormPage(props) {
			(0, _classCallCheck3.default)(this, PromotionsFormPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (PromotionsFormPage.__proto__ || (0, _getPrototypeOf2.default)(PromotionsFormPage)).call(this, props));
	
			_this.state = {};
			if (_this.props.params.id) _this.promotion = _promotions.Promotions.find({ _id: _this.props.params.id }).fetch()[0];else _this.promotion = {};
			return _this;
		}
	
		(0, _createClass3.default)(PromotionsFormPage, [{
			key: 'handleSubmit',
			value: function handleSubmit(e) {
				e.preventDefault();
	
				var params = {};
				var message = null;
				var method = null;
	
				params.attributes = {};
				_lodash2.default.each(this.refs, function (ref, key) {
					params.attributes[key] = _reactDom2.default.findDOMNode(ref).value.trim();
				});
	
				if (this.props.params.id) {
					message = "Le tarif a été modifié avec succès.";
					method = "promotions.update";
					params._id = this.props.params.id;
				} else {
					message = "Le tarif a été ajouté avec succès.";
					method = "promotions.insert";
					params.attributes["createdAt"] = new Date();
				}
	
				Meteor.call(method, params, function (err, _id) {
	
					if (err) {
						Messenger().post({
							message: err,
							type: "error"
						});
						return;
					}
	
					Messenger().post({
						message: message,
						type: "success"
					});
	
					this.props.router.push('/promotions');
				}.bind(this));
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/promotions' },
								'Tarifs'
							)
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ href: '#', active: true },
							'Ajouter/Modifier un Tarif'
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Ajouter/Modifier un tarif' },
						_react2.default.createElement(
							_rubix.Form,
							{ horizontal: true, onSubmit: this.handleSubmit.bind(this) },
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalEmail' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'Titre du tarif'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 10 },
									_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'title', defaultValue: this.promotion.title })
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalPassword' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'Pourcentage de r\xE9duction'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 10 },
									_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'percentage', defaultValue: this.promotion.percentage })
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalPassword' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'Nombre min. de passagers'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 10 },
									_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'constraintOfUsers', defaultValue: this.promotion.constraintOfUsers })
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalPassword' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'R\xE9f\xE9rence*'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 2 },
									_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'reference', defaultValue: this.promotion.reference })
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 8 },
									_react2.default.createElement(
										'small',
										null,
										'* laisser vide si cette promotion n\'existe pas sur le site.'
									)
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								null,
								_react2.default.createElement(
									_rubix.Col,
									{ smOffset: 2, sm: 10 },
									_react2.default.createElement(
										_rubix.Button,
										{ type: 'submit' },
										'Enregistrer'
									)
								)
							)
						)
					)
				);
			}
		}]);
		return PromotionsFormPage;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = PromotionsFormPage;
	
	
	PromotionsFormPage.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/promotions/PromotionsList.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _promotions = __webpack_require__("./src/universal/collections/flights-type/promotions.js");
	
	var _componentPromotionsList = __webpack_require__("./src/universal/components/promotions/component-promotions-list.js");
	
	var _componentPromotionsList2 = _interopRequireDefault(_componentPromotionsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var PromotionsListPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["flights-type"],
		promotions: _promotions.Promotions.find({})
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(PromotionsListPage, _React$Component);
	
		function PromotionsListPage(props) {
			(0, _classCallCheck3.default)(this, PromotionsListPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (PromotionsListPage.__proto__ || (0, _getPrototypeOf2.default)(PromotionsListPage)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(PromotionsListPage, [{
			key: 'renderPromotions',
			value: function renderPromotions() {
				return this.props.promotions.map(function (promotion) {
					return _react2.default.createElement(_componentPromotionsList2.default, { key: promotion._id, promotion: promotion });
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							'Promotions'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ active: true },
							'Liste des promotions'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/promotions-add' },
								_react2.default.createElement(
									_rubix.Button,
									{ bsStyle: 'success' },
									'Ajouter'
								)
							)
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Liste des tarifs' },
						_react2.default.createElement(
							_rubix.Table,
							{ responsive: true },
							_react2.default.createElement(
								'thead',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'th',
										null,
										'Nom'
									),
									_react2.default.createElement(
										'th',
										null,
										'Date de cr\xE9ation'
									),
									_react2.default.createElement(
										'th',
										null,
										'Derni\xE8re modification'
									),
									_react2.default.createElement(
										'th',
										null,
										'Actions'
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								this.renderPromotions()
							)
						)
					)
				);
			}
		}]);
		return PromotionsListPage;
	}(_react2.default.Component)) || _class);
	exports.default = PromotionsListPage;

/***/ },

/***/ "./src/universal/components/promotions/component-promotions-list.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _reactRouter2 = _interopRequireDefault(_reactRouter);
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var PromotionListComponent = function (_React$Component) {
	  (0, _inherits3.default)(PromotionListComponent, _React$Component);
	
	  function PromotionListComponent() {
	    (0, _classCallCheck3.default)(this, PromotionListComponent);
	    return (0, _possibleConstructorReturn3.default)(this, (PromotionListComponent.__proto__ || (0, _getPrototypeOf2.default)(PromotionListComponent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PromotionListComponent, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          this.props.promotion.title
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _reactMoment2.default,
	            { format: 'DD/MM/YYYY' },
	            this.props.promotion.createdAt
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _reactMoment2.default,
	            { format: 'DD/MM/YYYY' },
	            this.props.promotion.editedAt
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _rubix.Button,
	            { bsStyle: 'warning', onClick: this.goToEditView.bind(this) },
	            'Modifier'
	          ),
	          '\xA0\xA0',
	          _react2.default.createElement(
	            _rubix.Button,
	            { bsStyle: 'danger', onClick: this.deleteThisPrice.bind(this) },
	            'Supprimer'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'deleteThisPrice',
	    value: function deleteThisPrice() {
	      Meteor.call('promotions.remove', this.props.promotion._id);
	    }
	  }, {
	    key: 'goToEditView',
	    value: function goToEditView() {
	      this.context.router.push('/promotions/' + this.props.promotion._id);
	    }
	  }]);
	  return PromotionListComponent;
	}(_react2.default.Component);
	
	exports.default = PromotionListComponent;
	
	
	PromotionListComponent.propTypes = {
	  // This component gets the task to display through a React prop.
	  // We can use propTypes to indicate it is required
	  promotion: _react2.default.PropTypes.object.isRequired
	};
	
	PromotionListComponent.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/reservations/page-reservations-add.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _componentFlightsTypeSelect = __webpack_require__("./src/universal/components/reservations/components/component-flights-type-select.js");
	
	var _componentAddPassengers = __webpack_require__("./src/universal/components/reservations/components/component-add-passengers.js");
	
	var _componentTotalPrice = __webpack_require__("./src/universal/components/reservations/components/component-total-price.js");
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	var _flightsType = __webpack_require__("./src/universal/collections/flights-type/flights-type.js");
	
	var _prices = __webpack_require__("./src/universal/collections/flights-type/prices.js");
	
	var _promotions = __webpack_require__("./src/universal/collections/flights-type/promotions.js");
	
	var _options = __webpack_require__("./src/universal/collections/flights-type/options.js");
	
	var _passengers = __webpack_require__("./src/universal/collections/reservations/passengers.js");
	
	var _addresses = __webpack_require__("./src/universal/collections/reservations/addresses.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Tracker = Package.tracker.Tracker;
	
	var RingLoader = __webpack_require__("./node_modules/halogen/PulseLoader.js");
	var uniqid = __webpack_require__("./node_modules/uniqid/index.js");
	var ReservationsAddPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["reservations", "flights-type", "users", "passengers"]
	}), (0, _reactRouter.withRouter)(_class = _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(ReservationsAddPage, _React$Component);
	
		function ReservationsAddPage(props) {
			(0, _classCallCheck3.default)(this, ReservationsAddPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (ReservationsAddPage.__proto__ || (0, _getPrototypeOf2.default)(ReservationsAddPage)).call(this, props));
	
			_this.state = {};
	
			_this.state.tempID = uniqid.process();
	
			_this.state.passengers = [];
			_this.state.autocompleted = false;
	
			//Manual add :
			_this.state.manualAdd = true;
	
			props.ready.then(function () {
				_this.setState({
					selectedFlight: _flightsType.FlightsType.findOne({}, { sort: { 'title': 1 } }),
					period: 'SEMAINE',
					options: [],
					promotions: null,
					livraisonType: 1,
					place: 'anjou',
					passengers: _passengers.Passengers.find({ tempID: _this.state.tempID }).fetch(),
					maxPassengers: parseInt(_flightsType.FlightsType.findOne({}, { sort: { 'title': 1 } }).constraintPassengerMax),
					autocompleted: false
				});
	
				Tracker.autorun(function () {
					_this.setState({
						'passengers': _passengers.Passengers.find({ tempID: _this.state.tempID }).fetch()
					});
				});
			});
	
			return _this;
		}
	
		(0, _createClass3.default)(ReservationsAddPage, [{
			key: 'selectFlight',
			value: function selectFlight(event) {
				if (event.target.value != '-') {
					var flight = _flightsType.FlightsType.findOne({ _id: event.target.value });
					this.setState({
						maxPassengers: parseInt(flight.constraintPassengerMax),
						selectedFlight: flight,
						prices: flight.prices,
						options: [],
						promotions: null
					});
				}
			}
		}, {
			key: 'selectPeriod',
			value: function selectPeriod(event) {
				this.setState({
					period: event.target.value
				});
			}
		}, {
			key: 'selectPlace',
			value: function selectPlace(event) {
				this.setState({
					place: event.target.value
				});
			}
		}, {
			key: 'selectOptions',
			value: function selectOptions(event) {
	
				console.log('selectOptions', event);
	
				var option = _options.Options.find({ _id: event.target.value }).fetch()[0];
				var options = this.state.options;
	
				if (_.filter(this.state.options, { _id: option._id }).length > 0) {
					options = _.reject(this.state.options, function (item) {
						return item._id == option._id;
					});
				} else {
					options.push(option);
				}
	
				this.setState({
					options: options
				});
			}
		}, {
			key: 'selectPromotions',
			value: function selectPromotions(event) {
				var promotion = _promotions.Promotions.find({ _id: event.target.value }).fetch()[0];
				var promotions = this.state.options;
	
				if (!promotion) {
					this.setState({
						promotions: null
					});
					this.calculPrice();
	
					return;
				}
	
				if (_.filter(this.state.promotions, { _id: promotion._id }).length > 0) {
					promotions = _.reject(this.state.promotions, function (item) {
						return item._id == option._id;
					});
				} else {
					promotions.push(promotion);
				}
	
				this.setState({
					promotions: promotions
				});
	
				this.calculPrice();
			}
		}, {
			key: 'selectFreeFlights',
			value: function selectFreeFlights(value) {
				if (this.state.freeFlights) {
					this.setState({
						freeFlights: false
					});
				} else {
					this.setState({
						freeFlights: true
					});
				}
			}
		}, {
			key: 'addPassenger',
			value: function addPassenger(event) {
				if (this.state.passengers && this.state.passengers.length >= this.state.maxPassengers) {
					Messenger().post({
						message: "Erreur, ce vol est limité à " + this.state.maxPassengers + " passagers",
						type: "error"
					});
					return;
				}
	
				var params = {
					'firstName': _reactDom2.default.findDOMNode(this.refs.passenger_first_name).value.trim(),
					'lastName': _reactDom2.default.findDOMNode(this.refs.passenger_last_name).value.trim(),
					'age': _reactDom2.default.findDOMNode(this.refs.passenger_age).value.trim(),
					'weight': _reactDom2.default.findDOMNode(this.refs.passenger_weight).value.trim(),
					'phone': _reactDom2.default.findDOMNode(this.refs.passenger_phone).value.trim(),
					'email': _reactDom2.default.findDOMNode(this.refs.passenger_email).value.trim(),
					'info': _reactDom2.default.findDOMNode(this.refs.passenger_info).value.trim(),
					'mobility': JSON.parse(_reactDom2.default.findDOMNode(this.refs.passenger_mobility).value),
					'tempID': this.state.tempID
				};
	
				_reactDom2.default.findDOMNode(this.refs.passenger_first_name).value = '';
				_reactDom2.default.findDOMNode(this.refs.passenger_last_name).value = '';
				_reactDom2.default.findDOMNode(this.refs.passenger_age).value = '';
				_reactDom2.default.findDOMNode(this.refs.passenger_weight).value = '';
				_reactDom2.default.findDOMNode(this.refs.passenger_phone).value = '';
				_reactDom2.default.findDOMNode(this.refs.passenger_info).value = '';
	
				Meteor.call('passengers.insert', params, function (err, _id) {
	
					if (err) {
						Messenger().post({
							message: err,
							type: "error"
						});
						return;
					}
	
					Messenger().post({
						message: 'Le passager a bien été ajouté.',
						type: "success"
					});
				});
			}
		}, {
			key: 'calculBetterPrice',
			value: function calculBetterPrice(passenger) {
	
				if (passenger.age <= 12 && this.state.selectedFlight.priceEnfant) return this.hasPromotion(this.state.selectedFlight.priceEnfant);
	
				if (this.state.period == 'SEMAINE' && this.state.selectedFlight.priceSemaine) return this.hasPromotion(this.state.selectedFlight.priceSemaine);
	
				return this.hasPromotion(this.state.selectedFlight.priceLibreDate);
			}
		}, {
			key: 'hasPromotion',
			value: function hasPromotion(price) {
				if (this.state.promotions) {
					return Math.floor(price - price * (this.state.promotions[0].percentage / 100));
				} else {
					return price;
				}
			}
		}, {
			key: 'calculPrice',
			value: function calculPrice() {
				var _this2 = this;
	
				var price = 0;
				_.each(this.state.passengers, function (passenger) {
					price += _this2.calculBetterPrice(passenger);
	
					// Mise à jour du passager :
					_passengers.Passengers.update(passenger._id, { "$set": { price: _this2.calculBetterPrice(passenger) } });
				});
	
				return price;
			}
		}, {
			key: 'handleSubmit',
			value: function handleSubmit(e) {
				e.preventDefault();
				var delivery = {};
	
				var subscriber = {
					civility: _reactDom2.default.findDOMNode(this.refs.subscriber_civility).value.trim(),
					name: _reactDom2.default.findDOMNode(this.refs.subscriber_name).value.trim(),
					street: _reactDom2.default.findDOMNode(this.refs.subscriber_street).value.trim(),
					city: _reactDom2.default.findDOMNode(this.refs.subscriber_city).value.trim(),
					phone: _reactDom2.default.findDOMNode(this.refs.subscriber_phone).value.trim(),
					email: _reactDom2.default.findDOMNode(this.refs.subscriber_email).value.trim()
				};
	
				if (_reactDom2.default.findDOMNode(this.refs.delivery_name).value && _reactDom2.default.findDOMNode(this.refs.delivery_street).value && _reactDom2.default.findDOMNode(this.refs.delivery_city).value) {
					delivery = {
						civility: _reactDom2.default.findDOMNode(this.refs.delivery_civility).value.trim(),
						name: _reactDom2.default.findDOMNode(this.refs.delivery_name).value.trim(),
						street: _reactDom2.default.findDOMNode(this.refs.delivery_street).value.trim(),
						city: _reactDom2.default.findDOMNode(this.refs.delivery_city).value.trim()
					};
				} else {
					delivery = subscriber;
				}
	
				/*
	    * TODO : add livraisonType info and make it required
	    */
				var reservation = {
					'subscriber': subscriber,
					'delivery': delivery,
					'passengers': _.map(this.state.passengers, function (passenger) {
						return passenger._id;
					}),
					'selectedFlight': this.state.selectedFlight._id,
					'place': this.state.place,
					'period': this.state.period,
					//'options': _.map(this.state.options, (option) => { return option._id; }),
					'promotions': _.map(this.state.promotions, function (promotion) {
						return promotion._id;
					}),
					'price': this.calculPrice(),
					'bill': false,
					'payment': 1,
					'state': 2,
					'livraisonType': this.state.livraisonType,
					'searchName': _reactDom2.default.findDOMNode(this.refs.subscriber_name).value.trim(),
					'userId': _.includes(Meteor.user().roles, 'partner') ? Meteor.user()._id : null,
					'freeFlights': this.state.freeFlights ? true : false
				};
	
				if (reservation.freeFlights) reservation.price = 0;
	
				Meteor.call('reservations.insert', reservation, function (err, _id) {
	
					if (err) {
						Messenger().post({
							message: "Erreur...",
							type: "error"
						});
						return;
					}
	
					Messenger().post({
						message: "La réservation a été enregistrée.",
						type: "success"
					});
	
					this.props.router.push('/reservations');
				}.bind(this));
			}
		}, {
			key: 'autocomplete',
			value: function autocomplete() {
				this.setState({ 'autocompleted': !this.state.autocompleted });
				console.log('autocompleted', this.state.autocompleted);
				if (!this.state.autocompleted) {
					_reactDom2.default.findDOMNode(this.refs.subscriber_civility).value = "Société";
					_reactDom2.default.findDOMNode(this.refs.subscriber_name).value = Meteor.user().profile.firstName + ' ' + Meteor.user().profile.lastName;
					_reactDom2.default.findDOMNode(this.refs.subscriber_street).value = Meteor.user().profile.street;
					_reactDom2.default.findDOMNode(this.refs.subscriber_city).value = Meteor.user().profile.city;
					_reactDom2.default.findDOMNode(this.refs.subscriber_phone).value = Meteor.user().profile.phone;
					_reactDom2.default.findDOMNode(this.refs.subscriber_email).value = Meteor.user().profile.email;
				} else {
					_reactDom2.default.findDOMNode(this.refs.subscriber_civility).value = "";
					_reactDom2.default.findDOMNode(this.refs.subscriber_name).value = "";
					_reactDom2.default.findDOMNode(this.refs.subscriber_street).value = "";
					_reactDom2.default.findDOMNode(this.refs.subscriber_city).value = "";
					_reactDom2.default.findDOMNode(this.refs.subscriber_phone).value = "";
					_reactDom2.default.findDOMNode(this.refs.subscriber_email).value = "";
				}
			}
		}, {
			key: 'renderFlights',
			value: function renderFlights() {
				return this.props.flights.map(function (flight) {
					return _react2.default.createElement(
						'option',
						{ value: flight._id },
						flight.title
					);
				});
			}
		}, {
			key: 'renderManuelAdd',
			value: function renderManuelAdd() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Col,
						{ sm: 6 },
						'Prix total ',
						_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'manual_price' }),
						_react2.default.createElement('br', null),
						'N\xB0 Billet ',
						_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'id_billet' }),
						_react2.default.createElement('br', null)
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				if (!this.props.isReady && this.state.selectedFlight) {
					return _react2.default.createElement(RingLoader, null);
				}
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/reservations' },
								'Reservations'
							)
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ active: true },
							'Cr\xE9er une r\xE9servation'
						)
					),
					_react2.default.createElement(
						_rubix.Well,
						null,
						_react2.default.createElement(
							'center',
							null,
							'Pour cr\xE9er une r\xE9servation, merci de compl\xE9ter le formulaire ci-dessous :'
						)
					),
					_react2.default.createElement(
						_rubix.Form,
						{ horizontal: true, onSubmit: this.handleSubmit.bind(this) },
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 6 },
							_react2.default.createElement(
								_rubix.BPanel,
								{ header: 'SOUSCRIPTEUR' },
								_.includes(Meteor.user().roles, 'partner') && _react2.default.createElement(
									'center',
									null,
									_react2.default.createElement(
										_rubix.Checkbox,
										{ inline: true, onChange: function onChange(event) {
												return _this3.autocomplete();
											}, ref: 'autocompleted' },
										' Autocompl\xE9ter avec mes informations'
									),
									_react2.default.createElement('hr', null)
								),
								_react2.default.createElement(
									_rubix.FormGroup,
									null,
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 3 },
										'Civilit\xE9'
									),
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 9 },
										_react2.default.createElement(
											_rubix.FormControl,
											{ componentClass: 'select', type: 'select', ref: 'subscriber_civility' },
											_react2.default.createElement(
												'option',
												{ value: 'M.' },
												'M.'
											),
											_react2.default.createElement(
												'option',
												{ value: 'Mme' },
												'Mme'
											),
											_react2.default.createElement(
												'option',
												{ value: 'Soci\xE9t\xE9' },
												'Soci\xE9t\xE9'
											)
										)
									)
								),
								_react2.default.createElement(
									_rubix.FormGroup,
									null,
									_react2.default.createElement(
										_rubix.Col,
										{ componentClass: _rubix.ControlLabel, sm: 3 },
										'Nom / Pr\xE9nom'
									),
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 9 },
										_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'subscriber_name', required: true })
									)
								),
								_react2.default.createElement(
									_rubix.FormGroup,
									null,
									_react2.default.createElement(
										_rubix.Col,
										{ componentClass: _rubix.ControlLabel, sm: 3 },
										'N\xB0 / Voie'
									),
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 9 },
										_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'subscriber_street', required: true })
									)
								),
								_react2.default.createElement(
									_rubix.FormGroup,
									null,
									_react2.default.createElement(
										_rubix.Col,
										{ componentClass: _rubix.ControlLabel, sm: 3 },
										'Code postal / Ville'
									),
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 9 },
										_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'subscriber_city', required: true })
									)
								),
								_react2.default.createElement(
									_rubix.FormGroup,
									null,
									_react2.default.createElement(
										_rubix.Col,
										{ componentClass: _rubix.ControlLabel, sm: 3 },
										'T\xE9l\xE9phone'
									),
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 9 },
										_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'subscriber_phone', required: true })
									)
								),
								_react2.default.createElement(
									_rubix.FormGroup,
									null,
									_react2.default.createElement(
										_rubix.Col,
										{ componentClass: _rubix.ControlLabel, sm: 3 },
										'Email'
									),
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 9 },
										_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'subscriber_email', required: true })
									)
								)
							)
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 6 },
							_react2.default.createElement(
								_rubix.BPanel,
								{ header: 'LIVRAISON DU BILLET (SI DIFF\xC9RENT)' },
								_react2.default.createElement(
									_rubix.FormGroup,
									null,
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 3 },
										'Civilit\xE9'
									),
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 9 },
										_react2.default.createElement(
											_rubix.FormControl,
											{ componentClass: 'select', type: 'select', ref: 'delivery_civility' },
											_react2.default.createElement(
												'option',
												{ value: 'M.' },
												'M.'
											),
											_react2.default.createElement(
												'option',
												{ value: 'Mme' },
												'Mme'
											),
											_react2.default.createElement(
												'option',
												{ value: 'Soci\xE9t\xE9' },
												'Soci\xE9t\xE9'
											)
										)
									)
								),
								_react2.default.createElement(
									_rubix.FormGroup,
									null,
									_react2.default.createElement(
										_rubix.Col,
										{ componentClass: _rubix.ControlLabel, sm: 3 },
										'Nom / Pr\xE9nom'
									),
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 9 },
										_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'delivery_name' })
									)
								),
								_react2.default.createElement(
									_rubix.FormGroup,
									null,
									_react2.default.createElement(
										_rubix.Col,
										{ componentClass: _rubix.ControlLabel, sm: 3 },
										'N\xB0 / Voie'
									),
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 9 },
										_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'delivery_street' })
									)
								),
								_react2.default.createElement(
									_rubix.FormGroup,
									null,
									_react2.default.createElement(
										_rubix.Col,
										{ componentClass: _rubix.ControlLabel, sm: 3 },
										'Code postal / Ville'
									),
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 9 },
										_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'delivery_city' })
									)
								)
							)
						),
						_react2.default.createElement(_componentFlightsTypeSelect.SelectFlightComponent, {
							selectedFlight: this.state.selectedFlight,
							selectPeriod: this.selectPeriod.bind(this),
							selectPlace: this.selectPlace.bind(this),
							selectOptions: this.selectOptions.bind(this),
							selectPromotions: this.selectPromotions.bind(this),
							onUpdate: this.selectFlight.bind(this) }),
						_react2.default.createElement(_componentAddPassengers.AddPassengersComponent, {
							passengers: this.state.passengers,
							flight: this.state.selectedFlight,
							tempID: this.state.tempID,
							onUpdate: this.addPassenger,
							calculBetterPrice: this.calculBetterPrice.bind(this),
							maxPassengers: this.state.maxPassengers }),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 4 },
							_.includes(Meteor.user().roles, 'partner') && Meteor.user().profile.freeFlights > 0 && Meteor.user().profile.freeFlights >= this.state.passengers.length && _react2.default.createElement(
								_rubix.Well,
								null,
								_react2.default.createElement(
									_rubix.Checkbox,
									{ ref: 'freeFlights', inline: true, onChange: this.selectFreeFlights.bind(this) },
									'Vols offerts '
								),
								'   (',
								Meteor.user().profile.freeFlights,
								' restants)'
							),
							_react2.default.createElement(
								_rubix.BPanel,
								{ header: 'Montant de la r\xE9servation' },
								_react2.default.createElement(_componentTotalPrice.TotalPriceComponent, {
									calculPrice: this.calculPrice.bind(this),
									livraisonType: this.state.livraisonType })
							)
						)
					)
				);
			}
		}]);
		return ReservationsAddPage;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = ReservationsAddPage;
	
	
	ReservationsAddPage.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/reservations/components/component-flights-type-select.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectFlightComponent = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _flightsType = __webpack_require__("./src/universal/collections/flights-type/flights-type.js");
	
	var _prices = __webpack_require__("./src/universal/collections/flights-type/prices.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var RingLoader = __webpack_require__("./node_modules/halogen/PulseLoader.js");
	
	var SelectFlightComponent = exports.SelectFlightComponent = (_dec = (0, _ReactiveMixin.Reactive)({
	  subscriptions: ["flights-type"]
	}), _dec(_class = function (_React$Component) {
	  (0, _inherits3.default)(SelectFlightComponent, _React$Component);
	
	  function SelectFlightComponent(props) {
	    (0, _classCallCheck3.default)(this, SelectFlightComponent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SelectFlightComponent.__proto__ || (0, _getPrototypeOf2.default)(SelectFlightComponent)).call(this, props));
	
	    _this.state = {};
	
	    console.log("constructor");
	
	    props.ready.then(function () {
	      console.log('state', props.selectedFlight);
	      _this.setState({ selectedFlight: props.selectedFlight });
	    });
	
	    _this.onUpdate = props.onUpdate;
	    _this.selectPeriod = props.selectPeriod;
	    _this.selectPlace = props.selectPlace;
	    _this.selectOptions = props.selectOptions;
	    _this.selectPromotions = props.selectPromotions;
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(SelectFlightComponent, [{
	    key: 'renderSelectOptions',
	    value: function renderSelectOptions(data, labelKey, notFoundText) {
	      var needSelectedFlight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	      if (!data || data.length == 0) {
	        return _react2.default.createElement(
	          'option',
	          null,
	          notFoundText
	        );
	      }
	
	      return data.map(function (item) {
	        return _react2.default.createElement(
	          'option',
	          { value: item._id },
	          _.isFunction(item[labelKey]) ? item[labelKey]() : item[labelKey]
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      if (!this.props.isReady && !this.props.selectedFlight) {
	        return _react2.default.createElement(RingLoader, null);
	      }
	
	      return _react2.default.createElement(
	        _rubix.Col,
	        { sm: 12 },
	        _react2.default.createElement(
	          _rubix.BPanel,
	          { header: 'Choix du vol' },
	          _react2.default.createElement(
	            _rubix.Col,
	            { componentClass: _rubix.ControlLabel, sm: 8 },
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              null,
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 3 },
	                'Vol s\xE9l\xE9ctionn\xE9'
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 9 },
	                _react2.default.createElement(
	                  _rubix.FormControl,
	                  { componentClass: 'select', type: 'select', onChange: this.onUpdate.bind(this), ref: 'flight' },
	                  _.includes(Meteor.user().roles, 'partner') && this.renderSelectOptions(_flightsType.FlightsType.find({}, { sort: { 'title': 1 } }).fetch(), 'title', '-', false),
	                  !_.includes(Meteor.user().roles, 'partner') && this.renderSelectOptions(_flightsType.FlightsType.find({ "partnerId": null }, { sort: { 'title': 1 } }).fetch(), 'title', '-', false)
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              null,
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 3 },
	                'P\xE9riode'
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 9 },
	                _react2.default.createElement(
	                  _rubix.FormControl,
	                  { componentClass: 'select', type: 'select', onChange: this.selectPeriod.bind(this), ref: 'constraintPeriod' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'Semaine' },
	                    'SEMAINE'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'Libre date' },
	                    'LIBRE DATE'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              null,
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 3 },
	                'Envol'
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 9 },
	                _react2.default.createElement(
	                  _rubix.FormControl,
	                  { componentClass: 'select', type: 'select', onChange: this.selectPlace.bind(this), ref: 'constraintPlace' },
	                  this.props.selectedFlight && this.renderSelectOptions([{ _id: "anjou", name: "Sites d'envol Anjou" }, { _id: "nantes", name: "Sites d'envol de Nantes" }], 'name', '-')
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _rubix.FormGroup,
	              null,
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 3 },
	                'Promotions s\xE9l\xE9ctionn\xE9es'
	              ),
	              _react2.default.createElement(
	                _rubix.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                  _rubix.FormControl,
	                  { componentClass: 'select', type: 'select', onChange: this.selectPromotions.bind(this), ref: 'promotions' },
	                  _react2.default.createElement(
	                    'option',
	                    null,
	                    '-'
	                  ),
	                  this.props.selectedFlight && this.renderSelectOptions(this.props.selectedFlight.promotions(), "title", "Pas de promotion")
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _rubix.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              _rubix.Well,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  _rubix.Button,
	                  { bsStyle: 'info' },
	                  this.props.selectedFlight && this.props.selectedFlight.constraintPassengerMin,
	                  ' minimum / ',
	                  this.props.selectedFlight && this.props.selectedFlight.constraintPassengerMax,
	                  ' maximum'
	                )
	              ),
	              this.state.selectedFlight && this.state.selectedFlight.description.split("\n").map(function (item) {
	                return _react2.default.createElement(
	                  'p',
	                  null,
	                  item
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return SelectFlightComponent;
	}(_react2.default.Component)) || _class);

/***/ },

/***/ "./node_modules/halogen/PulseLoader.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__("./node_modules/react/react.js");
	var assign = __webpack_require__("./node_modules/domkit/appendVendorPrefix.js");
	var insertKeyframesRule = __webpack_require__("./node_modules/domkit/insertKeyframesRule.js");
	
	/**
	 * @type {Object}
	 */
	var keyframes = {
	    '0%': {
	        transform: 'scale(1)',
	        opacity: 1
	    },
	    '45%': {
	        transform: 'scale(0.1)',
	        opacity: 0.7
	    },
	    '80%': {
	        transform: 'scale(1)',
	        opacity: 1
	    }
	};
	
	/**
	 * @type {String}
	 */
	var animationName = insertKeyframesRule(keyframes);
	
	var Loader = React.createClass({
	    displayName: 'Loader',
	
	    /**
	     * @type {Object}
	     */
	    propTypes: {
	        loading: React.PropTypes.bool,
	        color: React.PropTypes.string,
	        size: React.PropTypes.string,
	        margin: React.PropTypes.string
	    },
	
	    /**
	     * @return {Object}
	     */
	    getDefaultProps: function getDefaultProps() {
	        return {
	            loading: true,
	            color: '#ffffff',
	            size: '15px',
	            margin: '2px'
	        };
	    },
	
	    /**
	     * @return {Object}
	     */
	    getBallStyle: function getBallStyle() {
	        return {
	            backgroundColor: this.props.color,
	            width: this.props.size,
	            height: this.props.size,
	            margin: this.props.margin,
	            borderRadius: '100%',
	            verticalAlign: this.props.verticalAlign
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getAnimationStyle: function getAnimationStyle(i) {
	        var animation = [animationName, '0.75s', i * 0.12 + 's', 'infinite', 'cubic-bezier(.2,.68,.18,1.08)'].join(' ');
	        var animationFillMode = 'both';
	
	        return {
	            animation: animation,
	            animationFillMode: animationFillMode
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getStyle: function getStyle(i) {
	        return assign(this.getBallStyle(i), this.getAnimationStyle(i), {
	            display: 'inline-block'
	        });
	    },
	
	    /**
	     * @param  {Boolean} loading
	     * @return {ReactComponent || null}
	     */
	    renderLoader: function renderLoader(loading) {
	        if (loading) {
	            return React.createElement(
	                'div',
	                { id: this.props.id, className: this.props.className },
	                React.createElement('div', { style: this.getStyle(1) }),
	                React.createElement('div', { style: this.getStyle(2) }),
	                React.createElement('div', { style: this.getStyle(3) })
	            );
	        }
	
	        return null;
	    },
	
	    render: function render() {
	        return this.renderLoader(this.props.loading);
	    }
	});
	
	module.exports = Loader;

/***/ },

/***/ "./node_modules/domkit/appendVendorPrefix.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getVendorPropertyName = __webpack_require__("./node_modules/domkit/getVendorPropertyName.js");
	
	module.exports = function(target, sources) {
	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }
	
	    var from = Object(nextSource);
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }
	
	  var prefixed = {};
	  for (var key in to) {
	    prefixed[getVendorPropertyName(key)] = to[key]
	  }
	
	  return prefixed
	}


/***/ },

/***/ "./node_modules/domkit/getVendorPropertyName.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var builtinStyle = __webpack_require__("./node_modules/domkit/builtinStyle.js");
	var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
	var domVendorPrefix;
	
	// Helper function to get the proper vendor property name. (transition => WebkitTransition)
	module.exports = function(prop, isSupportTest) {
	
	  var vendorProp;
	  if (prop in builtinStyle) return prop;
	
	  var UpperProp = prop.charAt(0).toUpperCase() + prop.substr(1);
	
	  if (domVendorPrefix) {
	
	    vendorProp = domVendorPrefix + UpperProp;
	    if (vendorProp in builtinStyle) {
	      return vendorProp;
	    }
	  } else {
	
	    for (var i = 0; i < prefixes.length; ++i) {
	      vendorProp = prefixes[i] + UpperProp;
	      if (vendorProp in builtinStyle) {
	        domVendorPrefix = prefixes[i];
	        return vendorProp;
	      }
	    }
	  }
	
	  // if support test, not fallback to origin prop name
	  if (!isSupportTest) {
	    return prop;
	  }
	
	}


/***/ },

/***/ "./node_modules/domkit/builtinStyle.js":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = document.createElement('div').style;


/***/ },

/***/ "./node_modules/domkit/insertKeyframesRule.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var insertRule = __webpack_require__("./node_modules/domkit/insertRule.js");
	var vendorPrefix = __webpack_require__("./node_modules/domkit/getVendorPrefix.js")();
	var index = 0;
	
	module.exports = function(keyframes) {
	  // random name
	  var name = 'anim_' + (++index) + (+new Date);
	  var css = "@" + vendorPrefix + "keyframes " + name + " {";
	
	  for (var key in keyframes) {
	    css += key + " {";
	
	    for (var property in keyframes[key]) {
	      var part = ":" + keyframes[key][property] + ";";
	      // We do vendor prefix for every property
	      css += vendorPrefix + property + part;
	      css += property + part;
	    }
	
	    css += "}";
	  }
	
	  css += "}";
	
	  insertRule(css);
	
	  return name
	}


/***/ },

/***/ "./node_modules/domkit/insertRule.js":
/***/ function(module, exports) {

	'use strict';
	
	var extraSheet;
	
	module.exports = function(css) {
	
	  if (!extraSheet) {
	    // First time, create an extra stylesheet for adding rules
	    extraSheet = document.createElement('style');
	    document.getElementsByTagName('head')[0].appendChild(extraSheet);
	    // Keep reference to actual StyleSheet object (`styleSheet` for IE < 9)
	    extraSheet = extraSheet.sheet || extraSheet.styleSheet;
	  }
	
	  var index = (extraSheet.cssRules || extraSheet.rules).length;
	  extraSheet.insertRule(css, index);
	
	  return extraSheet;
	}


/***/ },

/***/ "./node_modules/domkit/getVendorPrefix.js":
/***/ function(module, exports) {

	'use strict';
	
	var cssVendorPrefix;
	
	module.exports = function() {
	
	  if (cssVendorPrefix) return cssVendorPrefix;
	
	  var styles = window.getComputedStyle(document.documentElement, '');
	  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || (styles.OLink === '' && ['', 'o']))[1];
	
	  return cssVendorPrefix = '-' + pre + '-';
	}


/***/ },

/***/ "./src/universal/components/reservations/components/component-add-passengers.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.AddPassengersComponent = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _componentPassengersList = __webpack_require__("./src/universal/components/reservations/components/component-passengers-list.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var AddPassengersComponent = exports.AddPassengersComponent = function (_React$Component) {
		(0, _inherits3.default)(AddPassengersComponent, _React$Component);
	
		function AddPassengersComponent(props) {
			(0, _classCallCheck3.default)(this, AddPassengersComponent);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (AddPassengersComponent.__proto__ || (0, _getPrototypeOf2.default)(AddPassengersComponent)).call(this, props));
	
			_this.state = {};
			_this.state.tempID = props.tempID;
			_this.onUpdate = props.onUpdate;
			_this.calculBetterPrice = props.calculBetterPrice;
			return _this;
		}
	
		(0, _createClass3.default)(AddPassengersComponent, [{
			key: 'renderPassengers',
			value: function renderPassengers() {
				var _this2 = this;
	
				return this.props.passengers && this.props.passengers.map(function (passenger) {
					return _react2.default.createElement(_componentPassengersList.PassengerComponent, { passenger: passenger, flight: _this2.props.flight, calculBetterPrice: _this2.calculBetterPrice.bind(_this2) });
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_rubix.Col,
					{ sm: 12 },
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Ajouter un passager' },
						_react2.default.createElement(
							_rubix.FormGroup,
							{ controlId: 'formHorizontalEmail', ref: 'addPassenger' },
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 12 },
								_react2.default.createElement(
									_rubix.Table,
									{ responsive: true },
									_react2.default.createElement(
										'thead',
										null,
										_react2.default.createElement(
											'tr',
											null,
											_react2.default.createElement(
												'th',
												null,
												'NOM'
											),
											_react2.default.createElement(
												'th',
												null,
												'PR\xC9NOM'
											),
											_react2.default.createElement(
												'th',
												null,
												'AGE'
											),
											_react2.default.createElement(
												'th',
												null,
												'POIDS'
											),
											_react2.default.createElement(
												'th',
												null,
												'PORTABLE / T\xC9L'
											),
											_react2.default.createElement(
												'th',
												null,
												'EMAIL'
											),
											_react2.default.createElement(
												'th',
												null,
												'INFO'
											),
											_react2.default.createElement(
												'th',
												null,
												'M*'
											),
											_react2.default.createElement(
												'th',
												null,
												'\xA0'
											)
										)
									),
									_react2.default.createElement(
										'tbody',
										null,
										_react2.default.createElement(
											'tr',
											null,
											_react2.default.createElement(
												'td',
												null,
												_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'passenger_last_name' })
											),
											_react2.default.createElement(
												'td',
												null,
												_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'passenger_first_name' })
											),
											_react2.default.createElement(
												'td',
												null,
												_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'passenger_age' })
											),
											_react2.default.createElement(
												'td',
												null,
												_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'passenger_weight' })
											),
											_react2.default.createElement(
												'td',
												null,
												_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'passenger_phone' })
											),
											_react2.default.createElement(
												'td',
												null,
												_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'passenger_email' })
											),
											_react2.default.createElement(
												'td',
												null,
												_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'passenger_info' })
											),
											_react2.default.createElement(
												'td',
												null,
												_react2.default.createElement(
													_rubix.FormControl,
													{ componentClass: 'select', type: 'select', ref: 'passenger_mobility' },
													_react2.default.createElement(
														'option',
														{ value: false },
														'Non'
													),
													_react2.default.createElement(
														'option',
														{ value: true },
														'Oui'
													)
												)
											),
											_react2.default.createElement(
												'td',
												null,
												_react2.default.createElement(
													_rubix.Button,
													{ bsStyle: 'success', onClick: this.onUpdate.bind(this) },
													'+ AJOUTER'
												)
											)
										)
									)
								),
								_react2.default.createElement(
									'p',
									null,
									'*M : Mobilit\xE9 r\xE9duite.'
								)
							)
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Liste des passagers' },
						_react2.default.createElement(
							_rubix.FormGroup,
							{ controlId: 'formHorizontalEmail' },
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 12 },
								_react2.default.createElement(
									_rubix.Table,
									{ responsive: true },
									_react2.default.createElement(
										'thead',
										null,
										_react2.default.createElement(
											'tr',
											null,
											_react2.default.createElement(
												'th',
												null,
												'NOM'
											),
											_react2.default.createElement(
												'th',
												null,
												'PR\xC9NOM'
											),
											_react2.default.createElement(
												'th',
												null,
												'AGE'
											),
											_react2.default.createElement(
												'th',
												null,
												'POIDS'
											),
											_react2.default.createElement(
												'th',
												null,
												'PORTABLE / T\xC9L'
											),
											_react2.default.createElement(
												'th',
												null,
												'Email'
											),
											_react2.default.createElement(
												'th',
												null,
												'INFO'
											),
											_react2.default.createElement(
												'th',
												null,
												'Montant'
											),
											_react2.default.createElement(
												'th',
												null,
												'M*'
											),
											_react2.default.createElement(
												'th',
												null,
												'\xA0'
											)
										)
									),
									_react2.default.createElement(
										'tbody',
										null,
										this.renderPassengers()
									)
								),
								_react2.default.createElement(
									'p',
									null,
									'*M : Mobilit\xE9 r\xE9duite.'
								),
								_react2.default.createElement(
									'center',
									null,
									_react2.default.createElement(
										_rubix.Button,
										{ bsStyle: 'primary' },
										this.props.passengers && this.props.passengers.length,
										' / ',
										this.props.maxPassengers,
										' passagers'
									)
								)
							)
						)
					)
				);
			}
		}]);
		return AddPassengersComponent;
	}(_react2.default.Component);

/***/ },

/***/ "./src/universal/components/reservations/components/component-passengers-list.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PassengerComponent = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _passengers = __webpack_require__("./src/universal/collections/reservations/passengers.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var PassengerComponent = exports.PassengerComponent = function (_React$Component) {
	  (0, _inherits3.default)(PassengerComponent, _React$Component);
	
	  function PassengerComponent(props) {
	    (0, _classCallCheck3.default)(this, PassengerComponent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PassengerComponent.__proto__ || (0, _getPrototypeOf2.default)(PassengerComponent)).call(this, props));
	
	    _this.state = {};
	    _this.calculBetterPrice = props.calculBetterPrice;
	    return _this;
	  }
	
	  (0, _createClass3.default)(PassengerComponent, [{
	    key: 'removePassenger',
	    value: function removePassenger() {
	      Meteor.call('passengers.remove', his.props.passenger._id, function (err, _id) {
	
	        if (err) {
	          Messenger().post({
	            message: err,
	            type: "error"
	          });
	          return;
	        }
	
	        Messenger().post({
	          message: 'Le passagé a bien été supprimé.',
	          type: "success"
	        });
	      });
	    }
	  }, {
	    key: 'changePassengerInfos',
	    value: function changePassengerInfos(target, event) {
	      var update = {};
	      update[target] = event.target.value;
	
	      _passengers.Passengers.update(event.target.id, { "$set": update });
	    }
	  }, {
	    key: 'renderPrice',
	    value: function renderPrice() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        this.calculBetterPrice(this.props.passenger),
	        '\u20AC'
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_rubix.FormControl, { type: 'text', id: this.props.passenger._id, ref: 'passenger_lastName', defaultValue: this.props.passenger.lastName, onChange: this.changePassengerInfos.bind(this, 'lastName') })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_rubix.FormControl, { type: 'text', id: this.props.passenger._id, ref: 'passenger_firstName', defaultValue: this.props.passenger.firstName, onChange: this.changePassengerInfos.bind(this, 'firstName') })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_rubix.FormControl, { type: 'text', id: this.props.passenger._id, ref: 'passenger_age', defaultValue: this.props.passenger.age, onChange: this.changePassengerInfos.bind(this, 'age') })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_rubix.FormControl, { type: 'text', id: this.props.passenger._id, ref: 'passenger_weight', defaultValue: this.props.passenger.weight, onChange: this.changePassengerInfos.bind(this, 'weight') })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_rubix.FormControl, { type: 'text', id: this.props.passenger._id, ref: 'passenger_phone', defaultValue: this.props.passenger.phone, onChange: this.changePassengerInfos.bind(this, 'phone') })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_rubix.FormControl, { type: 'text', id: this.props.passenger._id, ref: 'passenger_email', defaultValue: this.props.passenger.email, onChange: this.changePassengerInfos.bind(this, 'email') })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_rubix.FormControl, { type: 'text', id: this.props.passenger._id, ref: 'passenger_info', defaultValue: this.props.passenger.info, onChange: this.changePassengerInfos.bind(this, 'info') })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          this.renderPrice()
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _rubix.FormControl,
	            { id: this.props.passenger._id, defaultValue: this.props.passenger.mobility, onChange: this.changePassengerInfos.bind(this, 'mobility'), componentClass: 'select', type: 'select', ref: 'passenger_mobility' },
	            _react2.default.createElement(
	              'option',
	              { value: false },
	              'Non'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: true },
	              'Oui'
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return PassengerComponent;
	}(_react2.default.Component);
	
	PassengerComponent.propTypes = {
	  passenger: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/reservations/components/component-total-price.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.TotalPriceComponent = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _flightsType = __webpack_require__("./src/universal/collections/flights-type/flights-type.js");
	
	var _prices = __webpack_require__("./src/universal/collections/flights-type/prices.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var TotalPriceComponent = exports.TotalPriceComponent = function (_React$Component) {
		(0, _inherits3.default)(TotalPriceComponent, _React$Component);
	
		function TotalPriceComponent(props) {
			(0, _classCallCheck3.default)(this, TotalPriceComponent);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (TotalPriceComponent.__proto__ || (0, _getPrototypeOf2.default)(TotalPriceComponent)).call(this, props));
	
			_this.state = {};
			_this.calculPrice = _this.props.calculPrice;
			return _this;
		}
	
		(0, _createClass3.default)(TotalPriceComponent, [{
			key: 'renderPrice',
			value: function renderPrice() {
				return _react2.default.createElement(
					_rubix.Button,
					{ bsStyle: 'warning' },
					this.calculPrice(),
					'\u20AC'
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'center',
					null,
					this.renderPrice(),
					_react2.default.createElement('hr', null),
					_react2.default.createElement(
						_rubix.FormControl,
						{ componentClass: 'select', type: 'select', ref: this.props.livraisonType },
						_react2.default.createElement(
							'option',
							{ value: '1' },
							'Billet seul'
						),
						_react2.default.createElement(
							'option',
							{ value: '2' },
							'Billet + Facture'
						)
					),
					_react2.default.createElement('hr', null),
					_react2.default.createElement(
						_rubix.FormGroup,
						null,
						_react2.default.createElement(
							_rubix.Button,
							{ type: 'submit' },
							'Enregistrer'
						)
					)
				);
			}
		}]);
		return TotalPriceComponent;
	}(_react2.default.Component);

/***/ },

/***/ "./node_modules/uniqid/index.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, module) {/* 
	(The MIT License)
	Copyright (c) 2014 Halász Ádám <mail@adamhalasz.com>
	Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
	The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	*/
	
	//  Unique Hexatridecimal ID Generator
	// ================================================
	
	//  Dependencies
	// ================================================
	var pid = process && process.pid ? process.pid.toString(36) : '' ;
	var mac =  false ? require('macaddress').one(macHandler) : null ;
	var address = mac ? parseInt(mac.replace(/\:|\D+/gi, '')).toString(36) : '' ;
	
	//  Exports
	// ================================================
	module.exports         = function(prefix){ return (prefix || '') + address + pid + now().toString(36); }
	module.exports.process = function(prefix){ return (prefix || '')           + pid + now().toString(36); }
	module.exports.time    = function(prefix){ return (prefix || '')                 + now().toString(36); }
	
	//  Helpers
	// ================================================
	function now(){
	    var time = Date.now();
	    var last = now.last || time;
	    return now.last = time > last ? time : last + 1;
	}
	
	function macHandler(error){
	    if(module.parent && module.parent.uniqid_debug){
	        if(error) console.error('Info: No mac address - uniqid() falls back to uniqid.process().', error)
	        if(pid == '') console.error('Info: No process.pid - uniqid.process() falls back to uniqid.time().')
	    }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js"), __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ },

/***/ "./src/universal/components/reservations/page-reservations-list.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	var _flightsType = __webpack_require__("./src/universal/collections/flights-type/flights-type.js");
	
	var _componentReservationsList = __webpack_require__("./src/universal/components/reservations/components/component-reservations-list.js");
	
	var _componentReservationsList2 = _interopRequireDefault(_componentReservationsList);
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tracker = Package.tracker.Tracker;
	var Meteor = Package.meteor.Meteor;
	var ReservationsPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: [{ name: 'reservations', paginate: true }, "users", 'flights-type'],
		partners: Meteor.users.find({ roles: { $in: ['partner'] } })
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(ReservationsPage, _React$Component);
	
		function ReservationsPage(props) {
			(0, _classCallCheck3.default)(this, ReservationsPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (ReservationsPage.__proto__ || (0, _getPrototypeOf2.default)(ReservationsPage)).call(this, props));
	
			_this.state = {
				reservations: [],
				flightsType: []
			};
	
			props.ready.then(function () {
				Tracker.autorun(function () {
					_this.setState({
						'reservations': _reservations.Reservations.find({}, { sort: { id: -1 } }).fetch(),
						'flightsType': _flightsType.FlightsType.find({}).fetch()
					});
				});
			});
			return _this;
		}
	
		(0, _createClass3.default)(ReservationsPage, [{
			key: 'renderSelectOptions',
			value: function renderSelectOptions(data, labelKey, notFoundText) {
				var needSelectedFlight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
				if (!data || data.length == 0) {
					return _react2.default.createElement(
						'option',
						null,
						notFoundText
					);
				}
	
				return data.map(function (item) {
					return _react2.default.createElement(
						'option',
						{ value: item._id },
						_.isFunction(item[labelKey]) ? item[labelKey]() : item[labelKey]
					);
				});
			}
		}, {
			key: 'renderSelectFlight',
			value: function renderSelectFlight(data, labelKey, notFoundText) {
				var needSelectedFlight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
				if (!data || data.length == 0) {
					return _react2.default.createElement(
						'option',
						null,
						notFoundText
					);
				}
	
				return data.map(function (item) {
					return _react2.default.createElement(
						'option',
						{ value: item.title },
						_.isFunction(item[labelKey]) ? item[labelKey]() : item[labelKey]
					);
				});
			}
		}, {
			key: 'reset',
			value: function reset() {
				this.props.subscriptions['reservations'].clear();
	
				this.setState({
					'reservations': _reservations.Reservations.find({}, { sort: { id: -1 } }).fetch()
				});
			}
		}, {
			key: 'searchByID',
			value: function searchByID() {
	
				if (_reactDom2.default.findDOMNode(this.refs.searchByID).value.trim() == '') {
					this.props.subscriptions['reservations'].clear();
					return;
				}
	
				this.props.subscriptions['reservations'].search({ id_internet: _reactDom2.default.findDOMNode(this.refs.searchByID).value.trim() });
	
				this.setState({
					id: _reactDom2.default.findDOMNode(this.refs.searchByID).value.trim()
				});
			}
		}, {
			key: 'searchByBillet',
			value: function searchByBillet() {
	
				if (_reactDom2.default.findDOMNode(this.refs.searchByBillet).value.trim() == '') {
					this.props.subscriptions['reservations'].clear();
					return;
				}
	
				this.props.subscriptions['reservations'].search({ id_billet: { $regex: ".*" + _reactDom2.default.findDOMNode(this.refs.searchByBillet).value.trim() + ".*" } });
			}
		}, {
			key: 'searchByName',
			value: function searchByName() {
	
				if (_reactDom2.default.findDOMNode(this.refs.searchByName).value.trim() == '') {
					this.props.subscriptions['reservations'].clear();
					return;
				}
	
				this.props.subscriptions['reservations'].search({ "searchName": { $regex: ".*" + _reactDom2.default.findDOMNode(this.refs.searchByName).value.trim() + ".*", '$options': 'i' } });
			}
		}, {
			key: 'filterBy',
			value: function filterBy() {
	
				var filter = _reactDom2.default.findDOMNode(this.refs.filter).value.trim();
	
				if (filter == 'all') {
					this.props.subscriptions['reservations'].clear();
					return '';
				}
	
				if (filter == 'partners') {
					this.props.subscriptions['reservations'].search({ userId: { $ne: null } });
					return '';
				}
	
				if (filter == 'interne') {
					this.props.subscriptions['reservations'].search({ userId: null });
					return '';
				}
	
				if (filter == 'interne-anjou') {
					this.props.subscriptions['reservations'].search({ userId: null, place: 'anjou' });
					return '';
				}
	
				if (filter == 'interne-nantes') {
					this.props.subscriptions['reservations'].search({ userId: null, place: 'nantes' });
					return '';
				}
	
				this.props.subscriptions['reservations'].search({ userId: filter });
			}
		}, {
			key: 'filterByPrestation',
			value: function filterByPrestation() {
				var prestation = _reactDom2.default.findDOMNode(this.refs.prestation).value.trim();
	
				if (!prestation) {
					reset();
					return;
				}
	
				console.log('prestation', prestation);
				this.props.subscriptions['reservations'].search({ flightName: prestation });
			}
		}, {
			key: 'showMode',
			value: function showMode() {
	
				var mode = _reactDom2.default.findDOMNode(this.refs.mode).value.trim();
	
				console.log('mode', mode);
	
				if (mode == 'all') {
					this.filterBy();
					return;
				}
	
				if (mode == 'waiting-scheduled') {
					this.props.subscriptions['reservations'].search({ scheduledAt: null, state: { $lte: 5 } });
				}
	
				if (mode == 'scheduled') {
					this.props.subscriptions['reservations'].search({ scheduledAt: { $ne: null }, state: { $lte: 5 } });
				}
	
				if (mode == 'done') {
					this.props.subscriptions['reservations'].search({ state: 6 });
				}
			}
		}, {
			key: 'showPayments',
			value: function showPayments() {
	
				var payments = _reactDom2.default.findDOMNode(this.refs.payments).value.trim();
	
				if (payments == 'all') {
					this.filterBy();
					return;
				}
	
				this.props.subscriptions['reservations'].search({ solde: { $gt: "0" } });
			}
		}, {
			key: 'renderReservations',
			value: function renderReservations() {
				return this.state.reservations.map(function (reservation) {
					return _react2.default.createElement(_componentReservationsList2.default, { key: reservation._id, reservation: reservation });
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _context;
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'G\xE9rer vos r\xE9servations' },
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 6 },
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 9 },
								_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'searchByID', placeholder: 'Rechercher par identifiant internet' })
							),
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 3 },
								_react2.default.createElement(
									_rubix.Button,
									{ onClick: this.searchByID.bind(this) },
									'Recherche'
								)
							),
							_react2.default.createElement('br', null),
							_react2.default.createElement('hr', null),
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 9 },
								_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'searchByName', placeholder: 'Recherche par nom/pr\xE9nom' })
							),
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 3 },
								_react2.default.createElement(
									_rubix.Button,
									{ onClick: this.searchByName.bind(this) },
									'Recherche'
								)
							),
							_react2.default.createElement('br', null),
							_react2.default.createElement('hr', null),
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 9 },
								_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'searchByBillet', placeholder: 'Recherche par n\xB0 de billet' })
							),
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 3 },
								_react2.default.createElement(
									_rubix.Button,
									{ onClick: this.searchByBillet.bind(this) },
									'Recherche'
								)
							),
							_react2.default.createElement('hr', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 9 },
								'Prestation :',
								_react2.default.createElement('br', null),
								_react2.default.createElement(
									_rubix.FormControl,
									{ componentClass: 'select', placeholder: 'select', ref: 'prestation', onChange: this.filterByPrestation.bind(this) },
									_react2.default.createElement(
										'option',
										{ value: '' },
										'Toutes les prestations'
									),
									_.includes(Meteor.user().roles, 'partner') && this.renderSelectFlight(_flightsType.FlightsType.find({}, { sort: { 'title': 1 } }).fetch(), 'title', '-', false),
									!_.includes(Meteor.user().roles, 'partner') && this.renderSelectFlight(_flightsType.FlightsType.find({ "partnerId": null }, { sort: { 'title': 1 } }).fetch(), 'title', '-', false)
								)
							),
							_react2.default.createElement('br', null),
							_react2.default.createElement('hr', null),
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 9 },
								_react2.default.createElement(
									_rubix.Button,
									{ onClick: this.reset.bind(this) },
									'R\xE9initialiser'
								)
							)
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 4 },
							_react2.default.createElement(
								'center',
								null,
								!_.includes(Meteor.user().roles, 'partner') && _react2.default.createElement(
									'div',
									null,
									'Filtrer par :',
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										_rubix.FormControl,
										{ componentClass: 'select', placeholder: 'select', ref: 'filter', onChange: this.filterBy.bind(this) },
										_react2.default.createElement(
											'option',
											{ value: 'all' },
											'Toutes les r\xE9servations'
										),
										_react2.default.createElement(
											'option',
											{ value: 'interne' },
											'Interne uniquement'
										),
										_react2.default.createElement(
											'option',
											{ value: 'interne-anjou' },
											'Interne uniquement (Anjou)'
										),
										_react2.default.createElement(
											'option',
											{ value: 'interne-nantes' },
											'Interne uniquement (Nantes)'
										),
										_react2.default.createElement(
											'option',
											{ value: 'partners' },
											'Partenaires uniquement'
										),
										this.props.partners.map(function (partner) {
											return _react2.default.createElement(
												'option',
												{ value: partner._id },
												partner.displayName()
											);
										})
									),
									_react2.default.createElement('hr', null),
									'Affichage :',
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										_rubix.FormControl,
										{ componentClass: 'select', placeholder: 'select', ref: 'mode', onChange: this.showMode.bind(this) },
										_react2.default.createElement(
											'option',
											{ value: 'all' },
											'Toutes les r\xE9servations'
										),
										_react2.default.createElement(
											'option',
											{ value: 'waiting-scheduled' },
											'Non planifi\xE9es'
										),
										_react2.default.createElement(
											'option',
											{ value: 'scheduled' },
											'Planifi\xE9es et non vol\xE9es'
										),
										_react2.default.createElement(
											'option',
											{ value: 'done' },
											'Vol\xE9es'
										)
									),
									!_.includes(Meteor.user().roles, 'partner') && _react2.default.createElement(
										'div',
										null,
										_react2.default.createElement('hr', null),
										'Paiements :',
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											_rubix.FormControl,
											{ componentClass: 'select', placeholder: 'select', ref: 'payments', onChange: this.showPayments.bind(this) },
											_react2.default.createElement(
												'option',
												{ value: 'all' },
												'Toutes les r\xE9servations'
											),
											_react2.default.createElement(
												'option',
												{ value: 'waiting' },
												'En attente paiement'
											)
										)
									),
									_react2.default.createElement('hr', null)
								),
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: 'reservations-add' },
									_react2.default.createElement(
										_rubix.Button,
										{ bsStyle: 'success' },
										'Cr\xE9er une r\xE9servation'
									)
								),
								_react2.default.createElement('br', null),
								_react2.default.createElement('br', null)
							)
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Liste des r\xE9servations' },
						!this.state.reservations.length && _react2.default.createElement(_rubix.Progress, { active: true, value: 100 }),
						this.state.reservations.length > 0 && _react2.default.createElement(
							_rubix.Table,
							{ striped: true, bordered: true, condensed: true, hover: true, responsive: true, className: 'text-center' },
							_react2.default.createElement(
								'thead',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'th',
										{ className: 'text-center' },
										'Identifiant'
									),
									_react2.default.createElement(
										'th',
										{ className: 'text-center' },
										'Billet'
									),
									_react2.default.createElement(
										'th',
										{ className: 'text-center' },
										'Nom/Pr\xE9nom'
									),
									_react2.default.createElement(
										'th',
										{ className: 'text-center' },
										'Partenaire'
									),
									_react2.default.createElement(
										'th',
										{ className: 'text-center' },
										'Status'
									),
									_react2.default.createElement(
										'th',
										{ className: 'text-center' },
										'Montant'
									),
									_react2.default.createElement(
										'th',
										{ className: 'text-center' },
										'Date'
									),
									!_.includes(Meteor.user().roles, 'partner') && _react2.default.createElement(
										'th',
										{ className: 'text-center' },
										'Factur\xE9 ?'
									),
									_react2.default.createElement(
										'th',
										{ className: 'text-center' },
										'Billet \xE0 envoyer ?'
									),
									_react2.default.createElement(
										'th',
										{ className: 'text-center' },
										'Actions'
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								this.renderReservations()
							)
						),
						this.props.isReady && _react2.default.createElement(
							_rubix.Pager,
							null,
							_react2.default.createElement(
								_rubix.PageItem,
								{ href: '#', onClick: (_context = this.props.subscriptions['reservations']).more.bind(_context) },
								'Voir plus'
							)
						)
					)
				);
			}
		}]);
		return ReservationsPage;
	}(_react2.default.Component)) || _class);
	exports.default = ReservationsPage;

/***/ },

/***/ "./src/universal/components/reservations/components/component-reservations-list.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var ReservationComponent = function (_React$Component) {
	  (0, _inherits3.default)(ReservationComponent, _React$Component);
	
	  function ReservationComponent(props) {
	    (0, _classCallCheck3.default)(this, ReservationComponent);
	    return (0, _possibleConstructorReturn3.default)(this, (ReservationComponent.__proto__ || (0, _getPrototypeOf2.default)(ReservationComponent)).call(this, props));
	  }
	
	  (0, _createClass3.default)(ReservationComponent, [{
	    key: 'goToView',
	    value: function goToView() {
	      this.context.router.push('/reservations/' + this.props.reservation._id);
	    }
	  }, {
	    key: 'renderBillState',
	    value: function renderBillState() {
	      if (this.props.reservation.state < 3) return _react2.default.createElement(
	        _rubix.Button,
	        { bsStyle: 'danger' },
	        this.props.reservation.getSolde(),
	        '\u20AC'
	      );else return _react2.default.createElement(
	        _rubix.Button,
	        { bsStyle: 'success' },
	        this.props.reservation.getSolde(),
	        '\u20AC'
	      );
	    }
	  }, {
	    key: 'renderBilletState',
	    value: function renderBilletState() {
	      if (this.props.reservation.impression && this.props.reservation.state < 5) return _react2.default.createElement(
	        _rubix.Button,
	        { bsStyle: 'danger' },
	        'Mail'
	      );
	
	      if (this.props.reservation.state < 5) return _react2.default.createElement(
	        _rubix.Button,
	        { bsStyle: 'danger' },
	        'Courrier'
	      );else {
	        if (this.props.reservation.impression) return _react2.default.createElement(
	          _rubix.Button,
	          { bsStyle: 'success' },
	          'Mail'
	        );else return _react2.default.createElement(
	          _rubix.Button,
	          { bsStyle: 'success' },
	          'Courrier'
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          this.props.reservation.id
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          this.props.reservation.id_billet,
	          ' ',
	          !this.props.reservation.id_billet && _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          this.props.reservation.searchName
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          this.props.reservation.getAuthor()
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          this.props.reservation.getState()
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          this.props.reservation.getPrice(),
	          '\u20AC'
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _reactMoment2.default,
	            { format: 'DD/MM/YYYY \xE0 kk:mm' },
	            this.props.reservation.createdAt
	          )
	        ),
	        !_.includes(Meteor.user().roles, 'partner') && _react2.default.createElement(
	          'td',
	          null,
	          this.renderBillState()
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          this.renderBilletState()
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/reservations/" + this.props.reservation._id, key: this.props.reservation._id },
	            _react2.default.createElement(
	              _rubix.Button,
	              { bsStyle: 'primary', onClick: this.goToView.bind(this) },
	              'Ouvrir'
	            ),
	            '\xA0\xA0'
	          )
	        )
	      );
	    }
	  }]);
	  return ReservationComponent;
	}(_react2.default.Component);
	
	exports.default = ReservationComponent;
	
	
	ReservationComponent.propTypes = {
	  reservation: _react2.default.PropTypes.object.isRequired
	};
	
	ReservationComponent.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/reservations/page-reservations-view.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__("./node_modules/react-dom/server.js");
	
	var _server2 = _interopRequireDefault(_server);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _componentCreateFlight = __webpack_require__("./src/universal/components/flights/component-create-flight.js");
	
	var _componentHistoryFlight = __webpack_require__("./src/universal/components/flights/component-history-flight.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _componentTunnelPayement = __webpack_require__("./src/universal/components/reservations/components/component-tunnel-payement.js");
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	var _addresses = __webpack_require__("./src/universal/collections/reservations/addresses.js");
	
	var _passengers = __webpack_require__("./src/universal/collections/reservations/passengers.js");
	
	var _payments = __webpack_require__("./src/universal/collections/reservations/payments.js");
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _componentAddPassengers = __webpack_require__("./src/universal/components/reservations/components/component-add-passengers.js");
	
	var _componentBilling = __webpack_require__("./src/universal/components/reservations/components/component-billing.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var HTTP = Package.http.HTTP;
	var Base64 = Package.base64.Base64;
	var Tracker = Package.tracker.Tracker;
	
	var RingLoader = __webpack_require__("./node_modules/halogen/PulseLoader.js");
	
	var DatePicker = __webpack_require__("./node_modules/react-bootstrap-date-picker/lib/index.js");
	var ReservationsViewPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: [{ name: 'reservation', param: 'id' }, "flights-type", "users"]
	}), (0, _reactRouter.withRouter)(_class = _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(ReservationsViewPage, _React$Component);
	
		function ReservationsViewPage(props) {
			(0, _classCallCheck3.default)(this, ReservationsViewPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (ReservationsViewPage.__proto__ || (0, _getPrototypeOf2.default)(ReservationsViewPage)).call(this, props));
	
			_this.state = {};
			_this.state.reservation = null;
			props.ready.then(function () {
				Tracker.autorun(function () {
					_this.setState({
						'reservation': _reservations.Reservations.findOne({ _id: _this.props.params.id }),
						'flight': _flights.Flights.findOne({ reservationIds: { $in: [_this.props.params.id] } }),
						'payments': _payments.Payments.find({ reservation: _this.props.params.id }).fetch(),
						'activeTab': ''
					});
				});
	
				if (_this.state.reservation) {
					_this.state.createdAt = (0, _moment2.default)(_this.state.reservation.createdAt).format();
					if (_this.state.reservation.period == "Tous les jours") {
						_this.state.reservation.period = "Libre date";
					}
				}
	
				_reservations.Reservations.update(_this.state.reservation._id, { "$set": { color: _this.state.reservation.getFlightColor() } });
			});
			return _this;
		}
	
		(0, _createClass3.default)(ReservationsViewPage, [{
			key: 'handleActiveState',
			value: function handleActiveState(eventKey) {
				this.setState({
					activeTab: eventKey
				});
			}
		}, {
			key: 'deleteReservation',
			value: function deleteReservation() {
				if (confirm('Êtes-vous sûr de vouloir supprimer cette réservation ?')) {
					_reservations.Reservations.remove(this.props.params.id);
					this.props.router.push('/reservations');
				}
			}
		}, {
			key: 'cancelProgramme',
			value: function cancelProgramme() {
				if (confirm('Êtes-vous sûr de vouloir annuler cette programmation ?')) {
					if (this.state.flight) this.state.flight.removeReservation(this.state.reservation._id);
	
					_reservations.Reservations.update(this.state.reservation._id, { "$set": { scheduledAt: null } });
				}
			}
		}, {
			key: 'calculBetterPrice',
			value: function calculBetterPrice(passenger) {
	
				if (passenger.age <= 12 && this.state.reservation.getFlightType().priceEnfant) return this.state.reservation.getFlightType().priceEnfant;
	
				if (this.state.reservation.period == 'SEMAINE' && this.state.reservation.getFlightType().priceSemaine) return this.state.reservation.getFlightType().priceSemaine;
	
				if (this.state.reservation.getFlightType()) {
					return this.state.reservation.getFlightType().priceLibreDate;
				}
	
				var price = prompt("Prix pour ce passager", "");
	
				return price;
			}
		}, {
			key: 'addPassenger',
			value: function addPassenger(event) {
				if (this.state.passengers && this.state.passengers.length >= this.state.maxPassengers) {
					Messenger().post({
						message: "Erreur, ce vol est limité à " + this.state.maxPassengers + " passagers",
						type: "error"
					});
					return;
				}
	
				var params = {
					'firstName': _reactDom2.default.findDOMNode(this.refs.passenger_first_name).value.trim(),
					'lastName': _reactDom2.default.findDOMNode(this.refs.passenger_last_name).value.trim(),
					'age': _reactDom2.default.findDOMNode(this.refs.passenger_age).value.trim(),
					'weight': _reactDom2.default.findDOMNode(this.refs.passenger_weight).value.trim(),
					'phone': _reactDom2.default.findDOMNode(this.refs.passenger_phone).value.trim(),
					'email': _reactDom2.default.findDOMNode(this.refs.passenger_email).value.trim(),
					'info': _reactDom2.default.findDOMNode(this.refs.passenger_info).value.trim(),
					'mobility': JSON.parse(_reactDom2.default.findDOMNode(this.refs.passenger_mobility).value)
				};
	
				params.price = this.calculBetterPrice(params) ? this.calculBetterPrice(params) : 0;
	
				_reactDom2.default.findDOMNode(this.refs.passenger_first_name).value = '';
				_reactDom2.default.findDOMNode(this.refs.passenger_last_name).value = '';
				_reactDom2.default.findDOMNode(this.refs.passenger_age).value = '';
				_reactDom2.default.findDOMNode(this.refs.passenger_weight).value = '';
				_reactDom2.default.findDOMNode(this.refs.passenger_phone).value = '';
				_reactDom2.default.findDOMNode(this.refs.passenger_info).value = '';
	
				var _id = _passengers.Passengers.insert(params);
				var passengers = this.state.reservation.passengers;
				passengers.push(_id);
	
				_reservations.Reservations.update(this.state.reservation._id, { "$set": { passengers: passengers } });
				_reservations.Reservations.update(this.state.reservation._id, { "$set": { price: parseFloat(this.state.reservation.price) + parseFloat(params.price) } });
	
				Messenger().post({
					message: 'Le passager a bien été ajouté.',
					type: "success"
				});
	
				this.props.subscriptions['reservation'].clear();
				this.setState({
					'passengersLoading': true
				});
	
				var that = this;
				window.setTimeout(function () {
					that.setState({
						'passengersLoading': false
					});
				}, 2000);
				//this.renderPassengers(true);
			}
		}, {
			key: 'sendBillet',
			value: function sendBillet() {
				if (confirm('Êtes-vous sûr de vouloir envoyer le mail ?')) {
	
					if (!this.state.reservation.getSubscriber().email) {
						Messenger().post({
							message: "Cette réservation n'a pas d'email !",
							type: "error"
						});
	
						return;
					}
	
					var mailSending = 0;
					if (!this.state.reservation.mailSending) mailSending = 1;else mailSending = this.state.reservation.mailSending + 1;
	
					var infoReservation = '';
					if (this.state.reservation.infoReservation) {
						infoReservation = this.state.reservation.infoReservation + ' - Billet envoyé le ' + (0, _moment2.default)().format('DD/MM/YYYY') + ' par ' + Meteor.user().profile.firstName + ' ' + Meteor.user().profile.lastName;
					} else {
						infoReservation = 'Billet envoyé le ' + (0, _moment2.default)().format('DD/MM/YYYY') + ' par ' + Meteor.user().profile.firstName + ' ' + Meteor.user().profile.lastName;
					}
	
					console.log('infoReservation', infoReservation);
	
					_reservations.Reservations.update(this.state.reservation._id, { "$set": {
							mailSending: mailSending,
							state: 5,
							infoReservation: infoReservation
						} });
	
					this.state.reservation.sendBillet();
				};
			}
		}, {
			key: 'openPopUp',
			value: function openPopUp(urlToOpen) {
				var popup_window = window.open(urlToOpen, "myWindow", "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=yes, width=400, height=400");
				try {
					popup_window.focus();
				} catch (e) {
					alert("Les fenêtes Pop-up sont bloquées ! Pour télécharger ce document, merci de les débloquer.");
				}
			}
		}, {
			key: 'downloadBill',
			value: function downloadBill() {
				var _this2 = this;
	
				var data = {
					'reservation': this.state.reservation,
					'flight': this.state.reservation.getFlightType(),
					'passengers': this.state.reservation.getPassengers(),
					'subscriber': this.state.reservation.getSubscriber(),
					'delivery': this.state.reservation.getDelivery(),
					'flighted': this.state.reservation.getFlight(),
					'options': this.state.reservation.getOptions(),
					'payments': this.state.payments
				};
	
				if (this.state.reservation.isPartners()) data.partner = this.state.reservation.getPartner();
	
				console.log('data', data);
	
				HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=facture', {
					data: data
				}, function (error, result) {
					result = JSON.parse(result.content);
					_this2.openPopUp("https://montgolfieres-pdf.amaia.at/" + result.id + ".pdf");
				});
			}
		}, {
			key: 'downloadBillet',
			value: function downloadBillet() {
				var _this3 = this;
	
				var data = {
					'reservation': this.state.reservation,
					'period': this.state.reservation.getPeriod(),
					'place': this.state.reservation.getPlace(),
					'flight': this.state.reservation.getFlightType(),
					'passengers': this.state.reservation.getPassengers(),
					'subscriber': this.state.reservation.getSubscriber(),
					'delivery': this.state.reservation.getDelivery(),
					'password': (0, _moment2.default)(this.state.reservation.createdAt).format('X').slice(-4)
				};
	
				data.reservation.expireAt = (0, _moment2.default)(data.reservation.billAt, 'DD-MM-YYYY').add(2, 'years').format('DD/MM/YYYY');
	
				HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=billet', {
					data: data
				}, function (error, result) {
					result = JSON.parse(result.content);
					_this3.openPopUp("https://montgolfieres-pdf.amaia.at/" + result.id + ".pdf");
				});
			}
		}, {
			key: 'downloadBilletPrint',
			value: function downloadBilletPrint() {
				var _this4 = this;
	
				var data = {
					'reservation': this.state.reservation,
					'period': this.state.reservation.getPeriod(),
					'place': this.state.reservation.getPlace(),
					'flight': this.state.reservation.getFlightType(),
					'passengers': this.state.reservation.getPassengers(),
					'subscriber': this.state.reservation.getSubscriber(),
					'delivery': this.state.reservation.getDelivery(),
					'password': (0, _moment2.default)(this.state.reservation.createdAt).format('X').slice(-4)
				};
	
				data.reservation.expireAt = (0, _moment2.default)(data.reservation.billAt, 'DD-MM-YYYY').add(2, 'years').format('DD/MM/YYYY');
	
				HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=billet-print', {
					data: data
				}, function (error, result) {
					result = JSON.parse(result.content);
					_this4.openPopUp("https://montgolfieres-pdf.amaia.at/" + result.id + ".pdf");
				});
			}
		}, {
			key: 'downloadBDR',
			value: function downloadBDR() {
				var _this5 = this;
	
				var data = {
					'reservation': this.state.reservation,
					'flight': this.state.reservation.getFlightType(),
					'passengers': this.state.reservation.getPassengers(),
					'subscriber': this.state.reservation.getSubscriber(),
					'delivery': this.state.reservation.getDelivery(),
					'payments': this.state.payments,
					'partner': this.state.reservation.getAuthor()
				};
	
				HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=bdr', {
					data: data
				}, function (error, result) {
					result = JSON.parse(result.content);
					_this5.openPopUp("https://montgolfieres-pdf.amaia.at/" + result.id + ".pdf");
				});
			}
		}, {
			key: 'removePassenger',
			value: function removePassenger(event) {
				if (confirm('Êtes-vous sûr de vouloir supprimer ce passager ?')) {
	
					var passenger = _passengers.Passengers.findOne(event.target.value);
	
					_reservations.Reservations.update(this.state.reservation._id, { "$set": { passengers: _.without(this.state.reservation.passengers, event.target.value) } });
					_reservations.Reservations.update(this.state.reservation._id, { "$set": { price: parseFloat(this.state.reservation.price) - parseFloat(passenger.price) } });
	
					Meteor.call('passengers.remove', event.target.value, function (err, _id) {
	
						if (err) {
							Messenger().post({
								message: err,
								type: "error"
							});
							return;
						}
	
						Messenger().post({
							message: 'Le passagé a bien été supprimé.',
							type: "success"
						});
					});
	
					this.props.subscriptions['reservation'].clear();
					this.setState({
						'passengersLoading': true
					});
	
					var that = this;
					window.setTimeout(function () {
						that.setState({
							'passengersLoading': false
						});
					}, 2000);
				}
			}
		}, {
			key: 'changePassengerPrice',
			value: function changePassengerPrice(target, event) {
				var update = {};
				update[target] = event.target.value;
				if (update[target] == '') {
					update[target] = 0;
				}
	
				_passengers.Passengers.update(event.target.id, { "$set": update });
			}
		}, {
			key: 'changePassengerInfos',
			value: function changePassengerInfos(target, event) {
				var update = {};
				update[target] = event.target.value;
				_passengers.Passengers.update(event.target.id, { "$set": update });
			}
		}, {
			key: 'changePaiementInfo',
			value: function changePaiementInfo(event) {
				_reservations.Reservations.update(this.state.reservation._id, { "$set": { infoPayment: event.target.value } }, function (error, nb) {
					if (error) console.error(error);
				});
			}
		}, {
			key: 'changeLinkReservation',
			value: function changeLinkReservation(event) {
				_reservations.Reservations.update(this.state.reservation._id, { "$set": { linkReservation: event.target.value } });
			}
		}, {
			key: 'changeReservationInfo',
			value: function changeReservationInfo(event) {
				console.log('event', event);
				_reservations.Reservations.update(this.state.reservation._id, { "$set": { infoReservation: event.target.value } });
			}
		}, {
			key: 'changeReservationPeriod',
			value: function changeReservationPeriod(event) {
				_reservations.Reservations.update(this.state.reservation._id, { "$set": { period: _reactDom2.default.findDOMNode(this.refs.period).value } });
			}
		}, {
			key: 'changePassengerMobility',
			value: function changePassengerMobility(event) {
				_passengers.Passengers.update(event.target.id, { "$set": { mobility: JSON.parse(event.target.value) } });
			}
		}, {
			key: 'changeSubscriberInfo',
			value: function changeSubscriberInfo(target, event) {
				var update = {};
				update[target] = event.target.value;
				_addresses.Addresses.update(this.state.reservation.getSubscriber()._id, { "$set": update });
			}
		}, {
			key: 'changeDeliveryInfo',
			value: function changeDeliveryInfo(target, event) {
				var update = {};
				update[target] = event.target.value;
				_addresses.Addresses.update(this.state.reservation.getDelivery()._id, { "$set": update });
			}
		}, {
			key: 'selectPayment',
			value: function selectPayment(evt) {
				if (evt) {
					_reservations.Reservations.update(this.state.reservation._id, { "$set": { payment: parseInt(evt.target.value) } });
				}
			}
		}, {
			key: 'allowReservationStatut',
			value: function allowReservationStatut() {
				return !this.state.reservation.isPartners() || this.state.reservation.getPartner() && this.state.reservation.getPartner().profile.billType == 'standard';
			}
		}, {
			key: 'renderDownloadBill',
			value: function renderDownloadBill() {
				if (this.state.reservation.state > 2) {
					return _react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'primary', onClick: this.downloadBill.bind(this) },
						'T\xE9l\xE9charger la facture'
					);
				} else {
					return _react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'primary', disabled: true },
						'T\xE9l\xE9charger la facture'
					);
				}
			}
		}, {
			key: 'renderDownloadBillet',
			value: function renderDownloadBillet() {
				if (this.state.reservation.state > 2) {
					return _react2.default.createElement(
						'span',
						null,
						_react2.default.createElement(
							_rubix.Button,
							{ bsStyle: 'primary', onClick: this.downloadBillet.bind(this) },
							'T\xE9l\xE9charger le billet'
						),
						'\xA0\xA0',
						_react2.default.createElement(
							_rubix.Button,
							{ bsStyle: 'primary', onClick: this.downloadBilletPrint.bind(this) },
							'Billet \xE0 imprimer'
						),
						'\xA0\xA0',
						_react2.default.createElement(
							_rubix.Button,
							{ bsStyle: 'warning', onClick: this.sendBillet.bind(this) },
							'Envoyer le billet ',
							this.state.reservation.mailSending > 0 && _react2.default.createElement(
								'span',
								null,
								'(',
								this.state.reservation.mailSending,
								')'
							)
						)
					);
				} else {
					return _react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'primary', disabled: true },
						'T\xE9l\xE9charger le billet'
					);
				}
			}
		}, {
			key: 'renderPassengers',
			value: function renderPassengers() {
				var _this6 = this;
	
				if (this.state.passengersLoading) {
					return _react2.default.createElement(
						'div',
						null,
						'chargement...'
					);
				}
				return this.state.reservation.getPassengers().map(function (passenger, index) {
					return _react2.default.createElement(
						_rubix.Col,
						{ sm: 6 },
						_react2.default.createElement(
							_rubix.Table,
							{ striped: true, bordered: true, hover: true, responsive: true },
							_react2.default.createElement(
								'tbody',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(_rubix.Icon, { bundle: 'fontello', glyph: 'user' })
									),
									_react2.default.createElement(
										'td',
										null,
										'Passager n\xB0',
										index + 1
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'NOM'
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(_rubix.FormControl, { type: 'text', id: passenger._id, ref: 'passenger_lastName', defaultValue: passenger.lastName, onChange: _this6.changePassengerInfos.bind(_this6, 'lastName') })
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'PR\xC9NOM'
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(_rubix.FormControl, { type: 'text', id: passenger._id, ref: 'passenger_firstName', defaultValue: passenger.firstName, onChange: _this6.changePassengerInfos.bind(_this6, 'firstName') })
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'AGE'
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(_rubix.FormControl, { type: 'text', id: passenger._id, ref: 'passenger_age', defaultValue: passenger.age, onChange: _this6.changePassengerInfos.bind(_this6, 'age') })
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'POIDS'
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(_rubix.FormControl, { type: 'text', id: passenger._id, ref: 'passenger_weight', defaultValue: passenger.weight, onChange: _this6.changePassengerInfos.bind(_this6, 'weight') })
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'PORTABLE / T\xC9L'
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(_rubix.FormControl, { type: 'text', id: passenger._id, ref: 'passenger_phone', defaultValue: passenger.phone, onChange: _this6.changePassengerInfos.bind(_this6, 'phone') })
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'EMAIL'
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(_rubix.FormControl, { type: 'text', id: passenger._id, ref: 'passenger_email', defaultValue: passenger.email, onChange: _this6.changePassengerInfos.bind(_this6, 'email') })
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Info'
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(_rubix.FormControl, { type: 'text', id: passenger._id, ref: 'passenger_info', defaultValue: passenger.info, onChange: _this6.changePassengerInfos.bind(_this6, 'info') })
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Prix (\u20AC)'
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(_rubix.FormControl, { type: 'text', id: passenger._id, ref: 'passenger_price', defaultValue: passenger.price, onChange: _this6.changePassengerPrice.bind(_this6, 'price') })
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Mobilit\xE9 r\xE9duite'
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(
											_rubix.FormControl,
											{ id: passenger._id, defaultValue: passenger.mobility, onChange: _this6.changePassengerInfos.bind(_this6, 'mobility'), componentClass: 'select', type: 'select', ref: 'passenger_mobility' },
											_react2.default.createElement(
												'option',
												{ value: false },
												'Non'
											),
											_react2.default.createElement(
												'option',
												{ value: true },
												'Oui'
											)
										)
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'\xA0'
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(
											_rubix.Button,
											{ bsStyle: 'danger', value: passenger._id, onClick: _this6.removePassenger.bind(_this6) },
											'Supprimer'
										)
									)
								)
							)
						)
					);
				});
			}
		}, {
			key: 'renderOptions',
			value: function renderOptions() {
	
				return _react2.default.createElement(
					'li',
					null,
					'-'
				);
	
				return this.state.reservation.getOptions().map(function (option) {
					return _react2.default.createElement(
						'li',
						null,
						option.title,
						': ',
						option.price,
						'\u20AC/pers'
					);
				});
			}
		}, {
			key: 'renderPromotions',
			value: function renderPromotions() {
	
				return this.state.reservation.getPromotions().map(function (promotion) {
					return _react2.default.createElement(
						'li',
						null,
						promotion.title,
						': ',
						promotion.price,
						'\u20AC/pers'
					);
				});
			}
		}, {
			key: 'render',
			value: function render() {
	
				if (!this.props.isReady || !this.state.reservation) {
					return _react2.default.createElement(RingLoader, null);
				}
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/reservations' },
								'Reservations'
							)
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ active: true },
							this.state.reservation.id_billet && _react2.default.createElement(
								'span',
								null,
								'R\xE9servation n\xB0',
								this.state.reservation.id_billet
							)
						)
					),
					!_.includes(Meteor.user().roles, 'partner') && this.state.reservation.getPartner() && _.includes(this.state.reservation.getPartner().roles, 'partner') && _react2.default.createElement(
						_rubix.Alert,
						{ bsStyle: 'warning' },
						_react2.default.createElement(
							'span',
							null,
							'R\xE9servation du partenaire ',
							this.state.reservation.getAuthor()
						)
					),
					_react2.default.createElement(
						_rubix.PanelTabContainer,
						{ id: 'panel-body-header-tab-footer', defaultActiveKey: 'informations' },
						_react2.default.createElement(
							_rubix.Panel,
							null,
							_react2.default.createElement(
								_rubix.PanelHeader,
								{ className: 'bg-green fg-white', style: { display: 'block' } },
								_react2.default.createElement(
									_rubix.Nav,
									{ bsStyle: 'tabs', className: 'plain', onSelect: this.handleActiveState.bind(this) },
									_react2.default.createElement(
										_rubix.NavItem,
										{ eventKey: 'informations' },
										'Informations'
									),
									_react2.default.createElement(
										_rubix.NavItem,
										{ eventKey: 'commande' },
										'Commande'
									),
									_react2.default.createElement(
										_rubix.NavItem,
										{ eventKey: 'client' },
										'Client'
									),
									_react2.default.createElement(
										_rubix.NavItem,
										{ eventKey: 'passagers' },
										'Passagers'
									),
									!_.includes(Meteor.user().roles, 'partner') && _react2.default.createElement(
										_rubix.NavItem,
										{ eventKey: 'facturation' },
										'Facturation'
									),
									_react2.default.createElement(
										_rubix.NavItem,
										{ eventKey: 'actions' },
										'Actions'
									)
								)
							),
							_react2.default.createElement(
								_rubix.PanelBody,
								null,
								_react2.default.createElement(
									_rubix.Grid,
									null,
									_react2.default.createElement(
										_rubix.Row,
										null,
										_react2.default.createElement(
											_rubix.Col,
											{ xs: 12 },
											_react2.default.createElement(
												_rubix.Tab.Content,
												null,
												_react2.default.createElement(
													_rubix.Tab.Pane,
													{ eventKey: 'informations' },
													_react2.default.createElement(
														_rubix.BPanel,
														{ header: 'Informations' },
														_react2.default.createElement(
															_rubix.Table,
															{ striped: true, bordered: true, condensed: true, hover: true, responsive: true },
															_react2.default.createElement(
																'tbody',
																null,
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'Date de la commande'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		(0, _moment2.default)(this.state.reservation.createdAt).format("DD/MM/Y")
																	)
																),
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'N\xB0 Billet'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		this.state.reservation.id_billet
																	)
																),
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'Mot de passe'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		(0, _moment2.default)(this.state.reservation.createdAt).format('X').slice(-4)
																	)
																),
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'Vol s\xE9l\xE9ctionn\xE9'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		this.state.reservation.getFlightName()
																	)
																),
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'P\xE9riode ',
																		this.state.reservation.getPeriod()
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		_react2.default.createElement(
																			_rubix.FormControl,
																			{ id: 'period', defaultValue: this.state.reservation.getPeriod(), onChange: this.changeReservationPeriod.bind(this, 'period'), componentClass: 'select', type: 'select', ref: 'period' },
																			_react2.default.createElement(
																				'option',
																				{ value: 'Semaine uniquement' },
																				'Semaine uniquement'
																			),
																			_react2.default.createElement(
																				'option',
																				{ value: 'Libre date' },
																				'Libre date'
																			)
																		)
																	)
																),
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'Envol'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		this.state.reservation.getPlace()
																	)
																),
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'Promotions s\xE9l\xE9ctionn\xE9es'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		this.renderPromotions()
																	)
																),
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'Prix'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		this.state.reservation.getPrice(),
																		'\u20AC'
																	)
																),
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'Observation du client'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		this.state.reservation.infoClient && this.state.reservation.infoClient.split("\n").map(function (item) {
																			return _react2.default.createElement(
																				'p',
																				null,
																				item
																			);
																		}),
																		!this.state.reservation.infoClient && _react2.default.createElement(
																			'p',
																			null,
																			'Aucune observation'
																		)
																	)
																)
															)
														),
														this.state.reservation.codePromoReduction && _react2.default.createElement(
															_rubix.Col,
															{ sm: 12 },
															_react2.default.createElement(
																_rubix.BPanel,
																{ header: 'Code de r\xE9duction' },
																_react2.default.createElement(
																	_rubix.Col,
																	{ sm: 4 },
																	_react2.default.createElement(
																		'p',
																		null,
																		'Code : ',
																		this.state.reservation.codePromoName
																	)
																),
																_react2.default.createElement(
																	_rubix.Col,
																	{ sm: 4 },
																	_react2.default.createElement(
																		'p',
																		null,
																		'Valeur : ',
																		this.state.reservation.codePromoReduction
																	)
																),
																_react2.default.createElement(
																	_rubix.Col,
																	{ sm: 4 },
																	this.state.reservation.codePromoType == 'percent' && _react2.default.createElement(
																		'p',
																		null,
																		'Type : Pourcentage'
																	),
																	this.state.reservation.codePromoType == 'euros' && _react2.default.createElement(
																		'p',
																		null,
																		'Type : Euros'
																	)
																)
															)
														)
													)
												),
												_react2.default.createElement(
													_rubix.Tab.Pane,
													{ eventKey: 'client' },
													this.state.reservation.getSubscriber() && _react2.default.createElement(
														_rubix.BPanel,
														{ header: 'SOUSCRIPTEUR' },
														_react2.default.createElement(
															_rubix.Table,
															{ striped: true, bordered: true, condensed: true, hover: true, responsive: true },
															_react2.default.createElement(
																'tbody',
																null,
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'Civilit\xE9'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		this.state.reservation.getSubscriber().civility
																	)
																),
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'Nom / Pr\xE9nom'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'subscriber_name', defaultValue: this.state.reservation.getSubscriber().name, onChange: this.changeSubscriberInfo.bind(this, 'name') })
																	)
																),
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'N\xB0 / Voie'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'subscriber_street', defaultValue: this.state.reservation.getSubscriber().street, onChange: this.changeSubscriberInfo.bind(this, 'street') })
																	)
																),
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'Code postal / Ville'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'subscriber_city', defaultValue: this.state.reservation.getSubscriber().city, onChange: this.changeSubscriberInfo.bind(this, 'city') })
																	)
																),
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'T\xE9l\xE9phone'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'subscriber_phone', defaultValue: this.state.reservation.getSubscriber().phone, onChange: this.changeSubscriberInfo.bind(this, 'phone') })
																	)
																),
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'Email'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'subscriber_email', defaultValue: this.state.reservation.getSubscriber().email, onChange: this.changeSubscriberInfo.bind(this, 'email') })
																	)
																)
															)
														)
													),
													this.state.reservation.getDelivery() && _react2.default.createElement(
														_rubix.BPanel,
														{ header: 'LIVRAISON DU BILLET (SI DIFF\xC9RENT)' },
														_react2.default.createElement(
															_rubix.Table,
															{ striped: true, bordered: true, hover: true, responsive: true },
															_react2.default.createElement(
																'tbody',
																null,
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'Civilit\xE9'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		this.state.reservation.getDelivery().civility
																	)
																),
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'Nom / Pr\xE9nom'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'delivery_name', defaultValue: this.state.reservation.getDelivery().name, onChange: this.changeDeliveryInfo.bind(this, 'name') })
																	)
																),
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'N\xB0 / Voie'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'delivery_street', defaultValue: this.state.reservation.getDelivery().street, onChange: this.changeDeliveryInfo.bind(this, 'street') })
																	)
																),
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'Code postal / Ville'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'delivery_city', defaultValue: this.state.reservation.getDelivery().city, onChange: this.changeDeliveryInfo.bind(this, 'city') })
																	)
																),
																_react2.default.createElement(
																	'tr',
																	null,
																	_react2.default.createElement(
																		'td',
																		null,
																		'T\xE9l\xE9phone'
																	),
																	_react2.default.createElement(
																		'td',
																		null,
																		_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'delivery_phone', defaultValue: this.state.reservation.getDelivery().phone, onChange: this.changeDeliveryInfo.bind(this, 'phone') })
																	)
																)
															)
														)
													)
												),
												_react2.default.createElement(
													_rubix.Tab.Pane,
													{ eventKey: 'commande' },
													_react2.default.createElement(
														_rubix.BPanel,
														{ header: 'Etat de la commande' },
														this.allowReservationStatut() && _react2.default.createElement(
															'div',
															null,
															_react2.default.createElement(
																_rubix.FormGroup,
																{ controlId: 'formHorizontalEmail' },
																_react2.default.createElement(
																	_rubix.Col,
																	{ sm: 4 },
																	'Statut de la commande'
																),
																_react2.default.createElement(
																	_rubix.Col,
																	{ sm: 8 },
																	_react2.default.createElement(_componentTunnelPayement.TunelPayementComponent, { reservation: this.state.reservation })
																)
															),
															_react2.default.createElement('hr', null),
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																_rubix.FormGroup,
																{ controlId: 'formHorizontalEmail' },
																_react2.default.createElement(
																	_rubix.Col,
																	{ sm: 4 },
																	'Type de livraison :'
																),
																_react2.default.createElement(
																	_rubix.Col,
																	{ sm: 8 },
																	this.state.reservation.livraisonType == 0 && _react2.default.createElement(
																		'span',
																		null,
																		'Billet seul'
																	),
																	this.state.reservation.livraisonType == 1 && _react2.default.createElement(
																		'span',
																		null,
																		'Billet + Facture'
																	)
																)
															),
															_react2.default.createElement(
																_rubix.FormGroup,
																{ controlId: 'formHorizontalEmail' },
																_react2.default.createElement(
																	_rubix.Col,
																	{ sm: 4 },
																	'Commande internet :'
																),
																_react2.default.createElement(
																	_rubix.Col,
																	{ sm: 8 },
																	this.state.reservation.id_internet && _react2.default.createElement(
																		'span',
																		null,
																		'Oui - N\xB0',
																		this.state.reservation.id_internet
																	),
																	!this.state.reservation.id_internet && _react2.default.createElement(
																		'span',
																		null,
																		'Non'
																	)
																)
															),
															_react2.default.createElement('br', null),
															_react2.default.createElement('hr', null)
														),
														!_.includes(Meteor.user().roles, 'partner') && _react2.default.createElement(
															'div',
															null,
															_react2.default.createElement(
																_rubix.Col,
																{ sm: 4 },
																'Billets li\xE9s :'
															),
															_react2.default.createElement(
																_rubix.Col,
																{ sm: 8 },
																_react2.default.createElement(
																	_rubix.FormGroup,
																	{ controlId: 'formHorizontalEmail' },
																	_react2.default.createElement(_rubix.FormControl, { id: 'linkReservation', type: 'text', onChange: this.changeLinkReservation.bind(this), defaultValue: this.state.reservation.linkReservation })
																)
															),
															_react2.default.createElement('br', null),
															_react2.default.createElement('hr', null)
														),
														this.allowReservationStatut() && _react2.default.createElement(
															_rubix.Col,
															{ sm: 6 },
															_react2.default.createElement(
																'p',
																null,
																'Information sur le paiement : (visible sur facture)'
															),
															_react2.default.createElement(_rubix.FormControl, { componentClass: 'textarea', rows: '6', onChange: this.changePaiementInfo.bind(this), defaultValue: this.state.reservation.infoPayment })
														),
														_react2.default.createElement(
															_rubix.Col,
															{ sm: 6 },
															_react2.default.createElement(
																'p',
																null,
																'Information sur la r\xE9servation :'
															),
															_react2.default.createElement(_rubix.FormControl, { componentClass: 'textarea', rows: '6', onChange: this.changeReservationInfo.bind(this), defaultValue: this.state.reservation.infoReservation })
														),
														_react2.default.createElement('hr', null),
														_react2.default.createElement(
															_rubix.FormGroup,
															{ controlId: 'formHorizontalEmail' },
															_react2.default.createElement(
																_rubix.Col,
																{ sm: 10 },
																_react2.default.createElement('br', null),
																this.allowReservationStatut() && this.renderDownloadBill(),
																' ',
																_react2.default.createElement('hr', null),
																' ',
																this.renderDownloadBillet(),
																' ',
																_react2.default.createElement('hr', null),
																' ',
																_react2.default.createElement(
																	_rubix.Button,
																	{ bsStyle: 'primary', onClick: this.downloadBDR.bind(this) },
																	'T\xE9l\xE9charger le bon de r\xE9servation'
																)
															)
														),
														_react2.default.createElement('br', null),
														_react2.default.createElement('br', null),
														this.state.reservation.getAuthor() != '-' && _react2.default.createElement(
															_rubix.Col,
															{ sm: 12 },
															_react2.default.createElement('hr', null),
															_react2.default.createElement(
																'p',
																null,
																'R\xE9servation effectu\xE9e par : ',
																this.state.reservation.getAuthor()
															)
														)
													)
												),
												_react2.default.createElement(
													_rubix.Tab.Pane,
													{ eventKey: 'facturation' },
													!_.includes(Meteor.user().roles, 'partner') && _react2.default.createElement(_componentBilling.BillingComponent, { reservation: this.state.reservation, payments: this.state.payments })
												),
												_react2.default.createElement(
													_rubix.Tab.Pane,
													{ eventKey: 'passagers' },
													_react2.default.createElement(
														_rubix.BPanel,
														{ header: 'Passagers' },
														this.renderPassengers()
													),
													_react2.default.createElement(
														_rubix.BPanel,
														{ header: 'Ajouter un passager' },
														_react2.default.createElement(
															_rubix.FormGroup,
															{ controlId: 'formHorizontalEmail', ref: 'addPassenger' },
															_react2.default.createElement(
																_rubix.Col,
																{ sm: 12 },
																_react2.default.createElement(
																	_rubix.Table,
																	{ striped: true, bordered: true, hover: true, responsive: true },
																	_react2.default.createElement(
																		'tbody',
																		null,
																		_react2.default.createElement(
																			'tr',
																			null,
																			_react2.default.createElement(
																				'td',
																				null,
																				'NOM'
																			),
																			_react2.default.createElement(
																				'td',
																				null,
																				_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'passenger_last_name' })
																			)
																		),
																		_react2.default.createElement(
																			'tr',
																			null,
																			_react2.default.createElement(
																				'td',
																				null,
																				'PR\xC9NOM'
																			),
																			_react2.default.createElement(
																				'td',
																				null,
																				_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'passenger_first_name' })
																			)
																		),
																		_react2.default.createElement(
																			'tr',
																			null,
																			_react2.default.createElement(
																				'td',
																				null,
																				'AGE'
																			),
																			_react2.default.createElement(
																				'td',
																				null,
																				_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'passenger_age' })
																			)
																		),
																		_react2.default.createElement(
																			'tr',
																			null,
																			_react2.default.createElement(
																				'td',
																				null,
																				'POIDS'
																			),
																			_react2.default.createElement(
																				'td',
																				null,
																				_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'passenger_weight' })
																			)
																		),
																		_react2.default.createElement(
																			'tr',
																			null,
																			_react2.default.createElement(
																				'td',
																				null,
																				'PORTABLE / T\xC9L'
																			),
																			_react2.default.createElement(
																				'td',
																				null,
																				_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'passenger_phone' })
																			)
																		),
																		_react2.default.createElement(
																			'tr',
																			null,
																			_react2.default.createElement(
																				'td',
																				null,
																				'EMAIL'
																			),
																			_react2.default.createElement(
																				'td',
																				null,
																				_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'passenger_email' })
																			)
																		),
																		_react2.default.createElement(
																			'tr',
																			null,
																			_react2.default.createElement(
																				'td',
																				null,
																				'INFO'
																			),
																			_react2.default.createElement(
																				'td',
																				null,
																				_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'passenger_info' })
																			)
																		),
																		_react2.default.createElement(
																			'tr',
																			null,
																			_react2.default.createElement(
																				'td',
																				null,
																				'Mobilit\xE9 r\xE9duite'
																			),
																			_react2.default.createElement(
																				'td',
																				null,
																				_react2.default.createElement(
																					_rubix.FormControl,
																					{ componentClass: 'select', type: 'select', ref: 'passenger_mobility' },
																					_react2.default.createElement(
																						'option',
																						{ value: false },
																						'Non'
																					),
																					_react2.default.createElement(
																						'option',
																						{ value: true },
																						'Oui'
																					)
																				)
																			)
																		)
																	)
																),
																_react2.default.createElement(
																	_rubix.Button,
																	{ bsStyle: 'success', onClick: this.addPassenger.bind(this) },
																	'+ AJOUTER'
																)
															)
														)
													)
												),
												_react2.default.createElement(
													_rubix.Tab.Pane,
													{ eventKey: 'actions' },
													_.includes(Meteor.user().roles, 'god') && _react2.default.createElement(
														_rubix.Col,
														{ sm: 4, className: 'text-center' },
														_react2.default.createElement(
															_rubix.BPanel,
															{ header: 'Suppression' },
															_react2.default.createElement(
																'center',
																null,
																_.includes(Meteor.user().roles, 'god') && _react2.default.createElement(
																	_rubix.Button,
																	{ bsStyle: 'danger', onClick: this.deleteReservation.bind(this) },
																	'Supprimer'
																)
															)
														)
													),
													_react2.default.createElement(
														_rubix.Col,
														{ sm: 4, className: 'text-center' },
														_react2.default.createElement(
															_rubix.BPanel,
															{ header: 'Historique' },
															_react2.default.createElement(_componentHistoryFlight.HistoryFlightComponent, {
																reservation: this.state.reservation })
														)
													),
													!_.includes(Meteor.user().roles, 'partner') && this.state.reservation.state < 6 && _react2.default.createElement(
														_rubix.Col,
														{ sm: 4, className: 'text-center' },
														_react2.default.createElement(
															_rubix.BPanel,
															{ header: 'Programmation' },
															_react2.default.createElement(
																'center',
																null,
																this.state.reservation.scheduledAt && _react2.default.createElement(
																	'p',
																	null,
																	'La r\xE9servation a \xE9t\xE9 programm\xE9 le ',
																	_react2.default.createElement(
																		_reactMoment2.default,
																		{ format: 'DD/MM/YYYY' },
																		this.state.reservation.scheduledAt
																	),
																	' le ',
																	this.state.reservation.getPeriodTime(),
																	' \xE0 ',
																	this.state.reservation.getPlace(),
																	_react2.default.createElement('br', null),
																	_react2.default.createElement('br', null),
																	_react2.default.createElement(
																		_rubix.Button,
																		{ bsStyle: 'danger', onClick: this.cancelProgramme.bind(this) },
																		'Annuler'
																	)
																),
																this.state.reservation.state < 6 && _react2.default.createElement(_componentCreateFlight.CreateFlightComponent, {
																	reservation: this.state.reservation })
															)
														)
													)
												)
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
		return ReservationsViewPage;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = ReservationsViewPage;
	
	
	ReservationsViewPage.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/flights/component-create-flight.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.CreateFlightComponent = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _flightTypeColorComponent = __webpack_require__("./src/universal/components/reservations/components/flightTypeColorComponent.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	var _users = __webpack_require__("./src/universal/collections/users/users.js");
	
	var _methods = __webpack_require__("./src/universal/collections/reservations/methods.js");
	
	var _availabilities = __webpack_require__("./src/universal/helpers/availabilities.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var DatePicker = __webpack_require__("./node_modules/react-bootstrap-date-picker/lib/index.js");
	
	var CreateFlightComponent = exports.CreateFlightComponent = (0, _reactRouter.withRouter)(_class = function (_React$Component) {
		(0, _inherits3.default)(CreateFlightComponent, _React$Component);
	
		function CreateFlightComponent(props) {
			(0, _classCallCheck3.default)(this, CreateFlightComponent);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (CreateFlightComponent.__proto__ || (0, _getPrototypeOf2.default)(CreateFlightComponent)).call(this, props));
	
			_this.state = {};
			_this.state.availabilities = {
				date: null,
				anjou: {
					morning: 0,
					evening: 0
				},
				nantes: {
					morning: 0,
					evening: 0
				}
			};
			_this.state.subscription = Meteor.subscribe('availableAndScheduledAt', null);
			return _this;
		}
	
		(0, _createClass3.default)(CreateFlightComponent, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.state.subscription.stop();
			}
		}, {
			key: 'closeProgramme',
			value: function closeProgramme() {
				this.setState({ showProgrammeModal: false });
			}
		}, {
			key: 'openProgramme',
			value: function openProgramme() {
				this.setState({ showProgrammeModal: true });
				this.calculateAvailabilities(this.state.availabilities.date);
			}
		}, {
			key: 'getAvailabilityClass',
			value: function getAvailabilityClass(availability) {
				if (availability >= 1) return "success";else return "danger";
			}
		}, {
			key: 'calculateAvailabilities',
			value: function calculateAvailabilities(date) {
				var _this2 = this;
	
				var availabilities = this.state.availabilities;
	
				date = date ? new Date(date) : null;
	
				if ((0, _moment2.default)(date).diff((0, _moment2.default)(), 'days') < 0) {
	
					Messenger().post({
						message: "Il n'est pas possible de programmer dans le passé.",
						type: "error"
					});
	
					return;
				}
	
				if (this.props.reservation.period == "Semaine uniquement" && (date.getDay() == 0 || date.getDay() == 6)) {
	
					/*Messenger().post({
	             	message: "Cette réservation est disponible en semaine uniquement",
	             	type: "error"
	           	});
	    	return ;*/
				}
	
				this.state.subscription = Meteor.subscribe('availableAndScheduledAt', date, function () {
					availabilities.date = date ? date.toISOString() : null;
					availabilities.anjou = {
						morning: (0, _availabilities.getAvailabilityCount)(date, "anjou", "morning"),
						evening: (0, _availabilities.getAvailabilityCount)(date, "anjou", "evening")
					};
					availabilities.nantes = {
						morning: (0, _availabilities.getAvailabilityCount)(date, "nantes", "morning"),
						evening: (0, _availabilities.getAvailabilityCount)(date, "nantes", "evening")
					};
	
					_this2.setState({ availabilities: availabilities });
	
					console.log('availabilities', availabilities);
				});
			}
		}, {
			key: 'scheduleReservation',
			value: function scheduleReservation(place, period) {
				var _this3 = this;
	
				console.log('period', period);
	
				_methods.scheduleReservation.call({
					_id: this.props.reservation._id,
					date: new Date(this.state.availabilities.date),
					place: place,
					period: period
				}, function (err) {
					if (err) return Messenger().post({
						message: err,
						type: "error"
					});
	
					Messenger().post({
						message: "La reservation a été programmé avec succès.",
						type: "success"
					});
	
					_this3.closeProgramme();
					_this3.props.router.push('/planning?date=' + _this3.state.availabilities.date);
				});
			}
		}, {
			key: 'renderProgrammeModal',
			value: function renderProgrammeModal() {
				var _this4 = this;
	
				return _react2.default.createElement(
					_rubix.Modal,
					{ show: this.state.showProgrammeModal, onHide: this.closeProgramme.bind(this) },
					_react2.default.createElement(
						_rubix.Modal.Header,
						{ closeButton: true },
						_react2.default.createElement(
							_rubix.Modal.Title,
							{ style: { 'display': 'flex', 'align-items': 'center' }
							},
							'Programmer la r\xE9servation n\xB0',
							this.props.reservation.id_billet,
							' / ',
							_react2.default.createElement(_flightTypeColorComponent.FlightTypeColor, { flightType: this.props.reservation.getFlightType() }),
							_react2.default.createElement(
								'span',
								null,
								' ',
								this.props.reservation.flightName
							)
						)
					),
					_react2.default.createElement(
						_rubix.Modal.Body,
						null,
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 4 },
							_react2.default.createElement(
								'p',
								null,
								'Choix d\'une date :'
							)
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 8 },
							_react2.default.createElement(DatePicker, {
								dayLabels: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
								monthLabels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
								id: 'date_picker',
								weekStartsOn: '1',
								daysOfWeekDisabled: [0, 5],
								value: this.state.availabilities.date,
								onChange: function onChange(value) {
									return _this4.calculateAvailabilities(value);
								} })
						),
						_react2.default.createElement('hr', null),
						this.state.availabilities.date && _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 6 },
								_react2.default.createElement(
									_rubix.BPanel,
									{ header: 'Sites d\'Anjou' },
									_react2.default.createElement(
										'center',
										null,
										_react2.default.createElement(
											_rubix.Button,
											{ bsStyle: this.getAvailabilityClass(this.state.availabilities.anjou.morning), onClick: function onClick() {
													return _this4.scheduleReservation("anjou", "morning");
												} },
											'Matin : ',
											this.state.availabilities.anjou.morning,
											' places'
										)
									),
									_react2.default.createElement('hr', null),
									_react2.default.createElement(
										'center',
										null,
										_react2.default.createElement(
											_rubix.Button,
											{ bsStyle: this.getAvailabilityClass(this.state.availabilities.anjou.evening), onClick: function onClick() {
													return _this4.scheduleReservation("anjou", "evening");
												} },
											'Soir : ',
											this.state.availabilities.anjou.evening,
											' places'
										)
									)
								)
							),
							_react2.default.createElement(
								_rubix.Col,
								{ sm: 6 },
								_react2.default.createElement(
									_rubix.BPanel,
									{ header: 'Sites de Nantes' },
									_react2.default.createElement(
										'center',
										null,
										_react2.default.createElement(
											_rubix.Button,
											{ bsStyle: this.getAvailabilityClass(this.state.availabilities.nantes.morning), onClick: function onClick() {
													return _this4.scheduleReservation("nantes", "morning");
												} },
											'Matin : ',
											this.state.availabilities.nantes.morning,
											' places'
										)
									),
									_react2.default.createElement('hr', null),
									_react2.default.createElement(
										'center',
										null,
										_react2.default.createElement(
											_rubix.Button,
											{ bsStyle: this.getAvailabilityClass(this.state.availabilities.nantes.evening), onClick: function onClick() {
													return _this4.scheduleReservation("nantes", "evening");
												} },
											'Soir : ',
											this.state.availabilities.nantes.evening,
											' places'
										)
									)
								)
							),
							_react2.default.createElement('hr', null),
							_react2.default.createElement(
								'center',
								null,
								_react2.default.createElement(
									'p',
									null,
									'Merci de s\xE9lectionner la p\xE9riode et le site de votre choix.'
								)
							)
						)
					),
					_react2.default.createElement(
						_rubix.Modal.Footer,
						null,
						_react2.default.createElement(
							_rubix.Button,
							{ onClick: this.closeProgramme.bind(this) },
							'Fermer'
						)
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'primary', onClick: this.openProgramme.bind(this) },
						'Programmer'
					),
					this.renderProgrammeModal()
				);
			}
		}]);
		return CreateFlightComponent;
	}(_react2.default.Component)) || _class;
	
	CreateFlightComponent.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/flights/component-history-flight.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.HistoryFlightComponent = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/montgolfieres/montgolfieres.js");
	
	var _users = __webpack_require__("./src/universal/collections/users/users.js");
	
	var _methods = __webpack_require__("./src/universal/collections/reservations/methods.js");
	
	var _availabilities = __webpack_require__("./src/universal/helpers/availabilities.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var DatePicker = __webpack_require__("./node_modules/react-bootstrap-date-picker/lib/index.js");
	
	var HistoryFlightComponent = exports.HistoryFlightComponent = function (_React$Component) {
		(0, _inherits3.default)(HistoryFlightComponent, _React$Component);
	
		function HistoryFlightComponent(props) {
			(0, _classCallCheck3.default)(this, HistoryFlightComponent);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (HistoryFlightComponent.__proto__ || (0, _getPrototypeOf2.default)(HistoryFlightComponent)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(HistoryFlightComponent, [{
			key: 'closeHistory',
			value: function closeHistory() {
				this.setState({ showHistoryModal: false });
			}
		}, {
			key: 'openHistory',
			value: function openHistory() {
				this.setState({ showHistoryModal: true });
			}
		}, {
			key: 'getType',
			value: function getType(history) {
	
				if (history.type == "scheduled") {
					return "Programmée";
				}
	
				if (history.type == "cancelled") {
					return "Annulée";
				}
	
				if (history.type == "confirmed") {
					return "Confirmée";
				}
	
				if (history.type == "consumed") {
					return "Volée";
				}
			}
		}, {
			key: 'getUser',
			value: function getUser(id) {
				var user = Meteor.users.findOne(id);
				if (user) {
					return user.profile.firstName + ' ' + user.profile.lastName;
				} else {
					return '-';
				}
			}
		}, {
			key: 'renderHistory',
			value: function renderHistory() {
				var _this2 = this;
	
				return this.props.reservation.history.map(function (history) {
					return _react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							null,
							(0, _moment2.default)(history.date).format("DD/MM/YYYY")
						),
						_react2.default.createElement(
							'td',
							null,
							_this2.getType(history)
						),
						_react2.default.createElement(
							'td',
							null,
							(0, _moment2.default)(history.scheduledAt).format("DD/MM/YYYY")
						),
						history.userId && _react2.default.createElement(
							'td',
							null,
							_this2.getUser(history.userId)
						),
						!history.userId && _react2.default.createElement(
							'td',
							null,
							'Client'
						)
					);
				});
			}
		}, {
			key: 'renderHistoryModal',
			value: function renderHistoryModal() {
				return _react2.default.createElement(
					_rubix.Modal,
					{ show: this.state.showHistoryModal, onHide: this.closeHistory.bind(this) },
					_react2.default.createElement(
						_rubix.Modal.Header,
						{ closeButton: true },
						_react2.default.createElement(
							_rubix.Modal.Title,
							null,
							'Historique la r\xE9servation n\xB0',
							this.props.reservation.id
						)
					),
					_react2.default.createElement(
						_rubix.Modal.Body,
						null,
						_react2.default.createElement(
							_rubix.Table,
							{ striped: true, bordered: true, condensed: true, hover: true },
							_react2.default.createElement(
								'thead',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Le'
									),
									_react2.default.createElement(
										'td',
										null,
										'Action'
									),
									_react2.default.createElement(
										'td',
										null,
										'Date'
									),
									_react2.default.createElement(
										'td',
										null,
										'Par'
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								this.renderHistory()
							)
						)
					),
					_react2.default.createElement(
						_rubix.Modal.Footer,
						null,
						_react2.default.createElement(
							_rubix.Button,
							{ onClick: this.closeHistory.bind(this) },
							'Fermer'
						)
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'primary', onClick: this.openHistory.bind(this) },
						'Voir l\'historique'
					),
					this.renderHistoryModal()
				);
			}
		}]);
		return HistoryFlightComponent;
	}(_react2.default.Component);
	
	HistoryFlightComponent.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/reservations/components/component-tunnel-payement.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.TunelPayementComponent = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var TunelPayementComponent = exports.TunelPayementComponent = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["reservations"]
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(TunelPayementComponent, _React$Component);
	
		function TunelPayementComponent(props) {
			(0, _classCallCheck3.default)(this, TunelPayementComponent);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (TunelPayementComponent.__proto__ || (0, _getPrototypeOf2.default)(TunelPayementComponent)).call(this, props));
	
			_this.state = {
				reservation: props.reservation,
				disabled: false
			};
	
			return _this;
		}
	
		(0, _createClass3.default)(TunelPayementComponent, [{
			key: 'changeState',
			value: function changeState(event) {
				var _this2 = this;
	
				this.setState({
					disabled: true
				});
	
				_reservations.Reservations.update(this.state.reservation._id, {
					"$set": {
						state: event.target.value
					}
				}, function (err) {
					if (err) return Messenger().post({
						message: "La modification du statut de la commande a échoué [" + err + "]",
						type: "error"
					});
	
					Messenger().post({
						message: "Le statut de la commande a été modifié",
						type: "success"
					});
					_this2.setState({
						reservation: _reservations.Reservations.findOne(_this2.state.reservation._id),
						disabled: false
					});
				});
			}
		}, {
			key: 'consume',
			value: function consume() {
				if (_.includes(Meteor.user().roles, 'god')) {
	
					if (confirm("Voulez-vous forcer la consommation de cette réservation ?")) {
						var event = {
							target: {
								value: 6
							}
						};
						this.state.reservation.consume();
						this.changeState(event);
					};
				}
			}
		}, {
			key: 'unconsume',
			value: function unconsume() {
				if (_.includes(Meteor.user().roles, 'god')) {
	
					if (confirm("Voulez-vous forcer la de-consommation de cette réservation ?")) {
						var event = {
							target: {
								value: 5
							}
						};
	
						_reservations.Reservations.update(this.state.reservation._id, { "$set": { 'scheduledAt': null } });
						this.changeState(event);
					};
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					this.state.reservation.state < 3 && _react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'primary', value: '3', ref: 'btn', onClick: this.changeState.bind(this), disabled: this.state.disabled },
						'Confirmer le paiement'
					),
					this.state.reservation.state == 3 && _react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'primary', value: '4', ref: 'btn', onClick: this.changeState.bind(this) },
						'Confirmer la commande'
					),
					this.state.reservation.state == 4 && _react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'primary', value: '5', ref: 'btn', onClick: this.changeState.bind(this) },
						'Confirmer l\'exp\xE9dition'
					),
					this.state.reservation.state == 5 && _react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'success', onDoubleClick: this.consume.bind(this) },
						'Commande compl\xE8te'
					),
					this.state.reservation.state == 6 && _react2.default.createElement(
						_rubix.Button,
						{ onDoubleClick: this.unconsume.bind(this) },
						'Commande vol\xE9e'
					)
				);
			}
		}]);
		return TunelPayementComponent;
	}(_react2.default.Component)) || _class);

/***/ },

/***/ "./src/universal/components/reservations/components/component-billing.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.BillingComponent = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _payments = __webpack_require__("./src/universal/collections/reservations/payments.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var BillingComponent = exports.BillingComponent = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["payments"]
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(BillingComponent, _React$Component);
	
		function BillingComponent(props) {
			(0, _classCallCheck3.default)(this, BillingComponent);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (BillingComponent.__proto__ || (0, _getPrototypeOf2.default)(BillingComponent)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(BillingComponent, [{
			key: 'addPayment',
			value: function addPayment() {
	
				var payment = {
					'type': _reactDom2.default.findDOMNode(this.refs.type).value.trim(),
					'montant': _reactDom2.default.findDOMNode(this.refs.montant).value.trim(),
					'informations': _reactDom2.default.findDOMNode(this.refs.informations).value.trim(),
					'reservation': this.props.reservation._id
				};
	
				Meteor.call('payments.insert', payment, function (err, _id) {
	
					if (err) {
						Messenger().post({
							message: "Erreur..." + err,
							type: "error"
						});
						return;
					}
	
					Messenger().post({
						message: "Le paiement a été enregistré.",
						type: "success"
					});
	
					_reactDom2.default.findDOMNode(this.refs.type).value = '';
					_reactDom2.default.findDOMNode(this.refs.montant).value = '';
					_reactDom2.default.findDOMNode(this.refs.informations).value = '';
				});
			}
		}, {
			key: 'removePayment',
			value: function removePayment(event) {
	
				if (confirm('Êtes-vous sûr de vouloir supprimer ce paiement ?')) {
	
					Meteor.call('payments.remove', event.target.value, function (err, _id) {
						if (err) {
							Messenger().post({
								message: "Erreur..." + err,
								type: "error"
							});
							return;
						}
	
						Messenger().post({
							message: "Le paiement a été supprimé.",
							type: "success"
						});
					});
				}
			}
		}, {
			key: 'renderPayments',
			value: function renderPayments() {
				var _this2 = this;
	
				return this.props.payments && this.props.payments.map(function (payment) {
					return _react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							null,
							_react2.default.createElement(
								_reactMoment2.default,
								{ format: 'DD/MM/YYYY \xE0 kk:mm' },
								payment.createdAt
							)
						),
						_react2.default.createElement(
							'td',
							null,
							payment.type
						),
						_react2.default.createElement(
							'td',
							null,
							payment.montant,
							'\u20AC'
						),
						_react2.default.createElement(
							'td',
							null,
							payment.informations
						),
						_react2.default.createElement(
							'td',
							null,
							_react2.default.createElement(
								'center',
								null,
								_react2.default.createElement(
									_rubix.Button,
									{ bsStyle: 'danger', onClick: _this2.removePayment.bind(_this2), value: payment._id },
									'X'
								)
							)
						)
					);
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_rubix.BPanel,
					{ header: 'Etat de la facturation' },
					_react2.default.createElement(
						'strong',
						null,
						'Restant : \xA0'
					),
					this.props.reservation.getSolde() > 0 && _react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'danger' },
						this.props.reservation.getSolde(),
						' \u20AC'
					),
					this.props.reservation.getSolde() <= 0 && _react2.default.createElement(
						_rubix.Button,
						{ bsStyle: 'success' },
						this.props.reservation.getSolde(),
						' \u20AC'
					),
					_react2.default.createElement('br', null),
					_react2.default.createElement('hr', null),
					_react2.default.createElement(
						_rubix.Col,
						{ sm: 3 },
						_react2.default.createElement(
							_rubix.FormControl,
							{ componentClass: 'select', type: 'select', ref: 'type' },
							_react2.default.createElement(
								'option',
								{ value: 'Especes' },
								'Especes'
							),
							_react2.default.createElement(
								'option',
								{ value: 'CB internet' },
								'CB internet'
							),
							_react2.default.createElement(
								'option',
								{ value: 'CB' },
								'CB'
							),
							_react2.default.createElement(
								'option',
								{ value: 'Ch\xE8que' },
								'Ch\xE8que'
							),
							_react2.default.createElement(
								'option',
								{ value: 'Virement' },
								'Virement'
							),
							_react2.default.createElement(
								'option',
								{ value: 'Autre' },
								'Autre'
							)
						)
					),
					_react2.default.createElement(
						_rubix.Col,
						{ sm: 3 },
						_react2.default.createElement(_rubix.FormControl, { placeholder: 'Montant', type: 'text', ref: 'montant' })
					),
					_react2.default.createElement(
						_rubix.Col,
						{ sm: 3 },
						_react2.default.createElement(_rubix.FormControl, { placeholder: 'Informations', type: 'text', ref: 'informations' })
					),
					_react2.default.createElement(
						_rubix.Col,
						{ sm: 3 },
						_react2.default.createElement(
							_rubix.Button,
							{ bsStyle: 'primary', onClick: this.addPayment.bind(this) },
							'Ajouter'
						)
					),
					_react2.default.createElement('br', null),
					_react2.default.createElement('hr', null),
					this.props.payments.length > 0 && _react2.default.createElement(
						_rubix.Table,
						{ striped: true, bordered: true, responsive: true },
						_react2.default.createElement(
							'thead',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'Date'
								),
								_react2.default.createElement(
									'td',
									null,
									'Type'
								),
								_react2.default.createElement(
									'td',
									null,
									'Montant'
								),
								_react2.default.createElement(
									'td',
									null,
									'Informations'
								),
								_react2.default.createElement(
									'td',
									null,
									'-'
								)
							)
						),
						_react2.default.createElement(
							'tbody',
							null,
							this.renderPayments()
						)
					),
					this.props.payments.length == 0 && _react2.default.createElement(
						'p',
						null,
						'Il n\'y a pas encore de paiement'
					)
				);
			}
		}]);
		return BillingComponent;
	}(_react2.default.Component)) || _class);

/***/ },

/***/ "./src/universal/components/layout/sidebar.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _class2;
	
	var _roles = __webpack_require__("./node_modules/roles/lib/index.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var ApplicationSidebar = (0, _reactRouter.withRouter)(_class = function (_React$Component) {
		(0, _inherits3.default)(ApplicationSidebar, _React$Component);
	
		function ApplicationSidebar() {
			(0, _classCallCheck3.default)(this, ApplicationSidebar);
			return (0, _possibleConstructorReturn3.default)(this, (ApplicationSidebar.__proto__ || (0, _getPrototypeOf2.default)(ApplicationSidebar)).apply(this, arguments));
		}
	
		(0, _createClass3.default)(ApplicationSidebar, [{
			key: 'handleChange',
			value: function handleChange(e) {
				this._nav.search(e.target.value);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Grid,
						null,
						_react2.default.createElement(
							_rubix.Row,
							null,
							_react2.default.createElement(
								_rubix.Col,
								{ xs: 12 },
								_react2.default.createElement(
									'div',
									{ className: 'sidebar-nav-container' },
									_react2.default.createElement(
										_rubix.SidebarNav,
										{ style: { marginBottom: 0 }, ref: function ref(c) {
												return _this2._nav = c;
											} },
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-home', name: 'Home', href: '/' }),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-user', name: 'Mon compte', href: '/account' }),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-paper-plane', name: 'Mes vols', href: '/my-flights',
											hidden: !_roles.Roles.userHasPermission(Meteor.userId(), 'my-flights.list')
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-clock', name: 'Planning', href: '/planning',
											hidden: !_roles.Roles.userHasPermission(Meteor.userId(), 'calendar.list')
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-calendar', name: 'Calendrier', href: '/calendrier2',
											hidden: !_roles.Roles.userHasPermission(Meteor.userId(), 'calendar.list')
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-calendar', name: 'Calendrier', href: '/calendrier',
											hidden: !Meteor.user().profile.accessToCalendar
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-ticket', name: 'R\xE9servation', href: '/reservations', aliases: ['/reservations-add', '/reservations/:id'],
											hidden: !_roles.Roles.userHasPermission(Meteor.userId(), 'orders.list')
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-plane', name: 'Vols / Tarifs', href: '/flights', aliases: ['/flights-add', '/flights/:id'],
											hidden: !_roles.Roles.userHasPermission(Meteor.userId(), 'flights.insert')
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-barcode', name: 'Promotions', href: '/promotions', aliases: ['/promotions-add', '/promotions/:id'],
											hidden: !_roles.Roles.userHasPermission(Meteor.userId(), 'promotions.list')
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-cog-alt', name: 'Options', href: '/options', aliases: ['/options-add', '/options/:id'],
											hidden: !_roles.Roles.userHasPermission(Meteor.userId(), 'options.list')
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-users', name: 'Utilisateurs', href: '/users',
											hidden: !_roles.Roles.userHasPermission(Meteor.userId(), 'users.list')
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-smile', name: 'Partenaires', href: '/partners',
											hidden: !_roles.Roles.userHasPermission(Meteor.userId(), 'users.list')
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-money', name: 'Factures group\xE9es', href: '/group-bills',
											hidden: !_roles.Roles.userHasPermission(Meteor.userId(), 'users.list')
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-cloud-sun-inv', name: 'Montgolfieres', href: '/montgolfieres',
											hidden: !_roles.Roles.userHasPermission(Meteor.userId(), 'montgolfieres.insert')
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-location', name: 'Lieux envols', href: '/places',
											hidden: !_roles.Roles.userHasPermission(Meteor.userId(), 'places.list')
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-rss', name: 'Alertes', href: '/alerts',
											hidden: !_roles.Roles.userHasPermission(Meteor.userId(), 'alerts.list')
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-chart-pie', name: 'Statistiques', href: '/statistiques',
											hidden: !_roles.Roles.userHasPermission(Meteor.userId(), 'statistics.list')
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-export', name: 'SMS', href: '/sms',
											hidden: !_roles.Roles.userHasPermission(Meteor.userId(), 'planifications.list')
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-pin', name: 'Planifications', href: '/planifications',
											hidden: !_roles.Roles.userHasPermission(Meteor.userId(), 'planifications.list')
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-export', name: 'Exports', href: '/exports',
											hidden: !_roles.Roles.userHasPermission(Meteor.userId(), 'planifications.list')
										}),
										_react2.default.createElement(_rubix.SidebarNavItem, { glyph: 'icon-fontello-email', name: 'Nous contacter', href: '/contact'
										})
									)
								)
							)
						)
					)
				);
			}
		}]);
		return ApplicationSidebar;
	}(_react2.default.Component)) || _class;
	
	var SidebarContainer = (0, _reactRouter.withRouter)(_class2 = function (_React$Component2) {
		(0, _inherits3.default)(SidebarContainer, _React$Component2);
	
		function SidebarContainer() {
			(0, _classCallCheck3.default)(this, SidebarContainer);
			return (0, _possibleConstructorReturn3.default)(this, (SidebarContainer.__proto__ || (0, _getPrototypeOf2.default)(SidebarContainer)).apply(this, arguments));
		}
	
		(0, _createClass3.default)(SidebarContainer, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ id: 'sidebar' },
					_react2.default.createElement(
						'div',
						{ id: 'avatar' },
						_react2.default.createElement(
							_rubix.Grid,
							null,
							_react2.default.createElement(
								_rubix.Row,
								{ className: 'fg-white' },
								_react2.default.createElement(
									_rubix.Col,
									{ xs: 4, collapseRight: true },
									_react2.default.createElement(_rubix.Icon, { glyph: 'icon-fontello-user', style: { background: '#fff', color: '#FA7252', fontSize: '43px', lineHeight: '100%', width: '40px', height: '40px', display: 'inline-block', textAlign: 'center', marginTop: '17px', borderRadius: '100%' } })
								),
								_react2.default.createElement(
									_rubix.Col,
									{ xs: 8, collapseLeft: true, id: 'avatar-col' },
									_react2.default.createElement(
										'div',
										{ style: { top: 30, left: 3, fontSize: 16, lineHeight: 1, position: 'relative' } },
										Meteor.user().username
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ id: 'sidebar-container' },
						_react2.default.createElement(
							_rubix.Sidebar,
							{ sidebar: 0 },
							_react2.default.createElement(ApplicationSidebar, null)
						)
					)
				);
			}
		}]);
		return SidebarContainer;
	}(_react2.default.Component)) || _class2;
	
	exports.default = SidebarContainer;

/***/ },

/***/ "./src/universal/components/users/UserAdd.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class;
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _users = __webpack_require__("./src/universal/collections/users/users.js");
	
	var _methods = __webpack_require__("./src/universal/collections/users/methods.js");
	
	var _mgfForm = __webpack_require__("./src/universal/components/common/mgfForm.js");
	
	var _mgfForm2 = _interopRequireDefault(_mgfForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	
	var UserAddPage = (0, _reactRouter.withRouter)(_class = function (_React$Component) {
		(0, _inherits3.default)(UserAddPage, _React$Component);
	
		function UserAddPage(props) {
			(0, _classCallCheck3.default)(this, UserAddPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (UserAddPage.__proto__ || (0, _getPrototypeOf2.default)(UserAddPage)).call(this, props));
	
			_this.state = {};
	
			_this.UserAddSchema = new SimpleSchema([_users.UserSchema, {
				"password": {
					type: String,
					label: "Mot de passe",
					min: 8,
					uniforms: {
						type: "password"
					}
				}
			}]);
			return _this;
		}
	
		(0, _createClass3.default)(UserAddPage, [{
			key: 'handleSubmit',
			value: function handleSubmit(doc) {
				var _this2 = this;
	
				return new _promise2.default(function (resolve, reject) {
					_methods.createUser.call({
						username: doc.username,
						email: doc.profile.email,
						password: doc.password,
						profile: doc.profile,
						roles: doc.roles
					}, function (error) {
						if (!error) {
							resolve(doc);
							_this2.props.router.push('/users');
						}
						reject(error);
					});
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/users' },
								'Utilisateurs'
							)
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ href: '#', active: true },
							'Ajouter un utilisateur'
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Ajouter un utilisateur' },
						_react2.default.createElement(_mgfForm2.default, { schema: this.UserAddSchema, collection: Meteor.users, doSave: false, onSubmit: this.handleSubmit.bind(this) })
					)
				);
			}
		}]);
		return UserAddPage;
	}(_react2.default.Component)) || _class;
	
	exports.default = UserAddPage;

/***/ },

/***/ "./src/universal/components/users/UserEdit.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _uniformsBootstrap = __webpack_require__("./node_modules/uniforms-bootstrap3/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Reactive = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _users = __webpack_require__("./src/universal/collections/users/users.js");
	
	var _methods = __webpack_require__("./src/universal/collections/users/methods.js");
	
	var _mgfForm = __webpack_require__("./src/universal/components/common/mgfForm.js");
	
	var _mgfForm2 = _interopRequireDefault(_mgfForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var UserEditPage = (_dec = (0, _Reactive.Reactive)({
		subscriptions: ["users"]
	}), _dec(_class = (0, _reactRouter.withRouter)(_class = function (_React$Component) {
		(0, _inherits3.default)(UserEditPage, _React$Component);
	
		function UserEditPage(props) {
			(0, _classCallCheck3.default)(this, UserEditPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (UserEditPage.__proto__ || (0, _getPrototypeOf2.default)(UserEditPage)).call(this, props));
	
			_this.state = {};
	
			if (!_this.props.params.id) _this.props.router.push('/users');else _this.ChangePasswordSchema = new SimpleSchema({
				"password": {
					type: String,
					label: "Mot de passe",
					min: 8,
					uniforms: {
						type: "password"
					}
				}
			});
			return _this;
		}
	
		(0, _createClass3.default)(UserEditPage, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.isReady && !this.props.isReady) {
					this.setState({
						user: Meteor.users.findOne({ _id: this.props.params.id })
					});
				}
			}
		}, {
			key: 'handleSubmit',
			value: function handleSubmit(doc) {
				this.props.router.push('/users');
			}
		}, {
			key: 'handlePasswordChange',
			value: function handlePasswordChange(doc) {
				var that = this;
				return new _promise2.default(function (resolve, reject) {
					_methods.updatePassword.call(_lodash2.default.pick(doc, '_id', 'password'), function (error, result) {
						console.error(error);
						if (!error) {
							resolve(doc);
							that.props.router.push('/users');
						}
						reject(error);
					});
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/users' },
								'Utilisateurs'
							)
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ href: '#', active: true },
							'Modifier un utilisateur'
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Modifier l\'utilisateur' },
						this.props.isReady && _react2.default.createElement(_mgfForm2.default, { schema: _users.UserSchema, collection: Meteor.users, model: this.state.user, onSubmit: this.handleSubmit.bind(this) })
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Mettre \xE0 jour le mot de passe' },
						_react2.default.createElement(
							_mgfForm2.default,
							{ schema: this.ChangePasswordSchema, collection: { label: "Le mot de passe" }, model: this.state.user, doSave: false, onSubmit: this.handlePasswordChange.bind(this) },
							_react2.default.createElement(_uniformsBootstrap.TextField, { name: 'password' }),
							_react2.default.createElement(_uniformsBootstrap.SubmitField, { value: 'Changer' })
						)
					)
				);
			}
		}]);
		return UserEditPage;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = UserEditPage;

/***/ },

/***/ "./src/universal/components/users/UserList.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _users = __webpack_require__("./src/universal/collections/users/users.js");
	
	var _mgfTable = __webpack_require__("./src/universal/components/common/mgfTable.js");
	
	var _mgfTable2 = _interopRequireDefault(_mgfTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var UserListPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["users"],
		users: Meteor.users.find({})
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(UserListPage, _React$Component);
	
		function UserListPage(props) {
			(0, _classCallCheck3.default)(this, UserListPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (UserListPage.__proto__ || (0, _getPrototypeOf2.default)(UserListPage)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(UserListPage, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							'Utilisateurs'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ active: true },
							'Liste des utilisateurs'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/users/add' },
								_react2.default.createElement(
									_rubix.Button,
									{ bsStyle: 'success' },
									'Ajouter'
								)
							)
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Liste des utilisateurs' },
						this.props.isReady && _react2.default.createElement(_mgfTable2.default, { fields: _users.UserListSchema._schema, list: this.props.users, type: 'users' })
					)
				);
			}
		}]);
		return UserListPage;
	}(_react2.default.Component)) || _class);
	exports.default = UserListPage;
	
	
	UserListPage.propTypes = {
		users: _react2.default.PropTypes.array.isRequired
	};

/***/ },

/***/ "./src/universal/components/statistiques/Statistiques.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactChartjs = __webpack_require__("./node_modules/react-chartjs-2/lib/index.js");
	
	var _statistiquesHelpers = __webpack_require__("./src/universal/helpers/statistiquesHelpers.js");
	
	var _Tableau = __webpack_require__("./src/universal/components/statistiques/Tableau.component.js");
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var DatePicker = __webpack_require__("./node_modules/react-bootstrap-date-picker/lib/index.js");
	
	var Tracker = Package.tracker.Tracker;
	var StatistiquesPage = (_dec = (0, _ReactiveMixin.Reactive)({
	    subscriptions: ["flights", "reservations-all"]
	}), _dec(_class = function (_React$Component) {
	    (0, _inherits3.default)(StatistiquesPage, _React$Component);
	
	    function StatistiquesPage(props) {
	        (0, _classCallCheck3.default)(this, StatistiquesPage);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (StatistiquesPage.__proto__ || (0, _getPrototypeOf2.default)(StatistiquesPage)).call(this, props));
	
	        _this.state = {};
	
	        //set start and ending date :
	        _this.state.startDate = (0, _moment2.default)().startOf('year').format();
	        _this.state.endDate = (0, _moment2.default)().format();
	        return _this;
	    }
	
	    (0, _createClass3.default)(StatistiquesPage, [{
	        key: 'launchStatistiques',
	        value: function launchStatistiques() {
	            var type = _reactDom2.default.findDOMNode(this.refs.statistiques_type).value.trim();
	            var affichage = _reactDom2.default.findDOMNode(this.refs.statistiques_affichage).value.trim();
	
	            var that = this;
	            _statistiquesHelpers.StatistiquesHelpers.launchStatistiques(type, this.state.startDate, this.state.endDate, affichage).then(function (data) {
	                that.setState({
	                    launched: true,
	                    data: data
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _rubix.BPanel,
	                    { header: 'Filtrer les statistiques :' },
	                    _react2.default.createElement(
	                        _rubix.FormGroup,
	                        null,
	                        _react2.default.createElement(
	                            _rubix.Col,
	                            { sm: 3 },
	                            'Statitiques :'
	                        ),
	                        _react2.default.createElement(
	                            _rubix.Col,
	                            { sm: 9 },
	                            _react2.default.createElement(
	                                _rubix.FormControl,
	                                { componentClass: 'select', type: 'select', ref: 'statistiques_type' },
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'reservations' },
	                                    'R\xE9servations'
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'vols' },
	                                    'Vols'
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'pilotes-vols' },
	                                    'Pilotes (vols)'
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'pilotes-heures' },
	                                    'Pilotes (heures)'
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'montgolfieres-vols' },
	                                    'Ballons (vols)'
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'montgolfieres-heures' },
	                                    'Ballons (heures)'
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'vols/nonvols' },
	                                    'Vol\xE9es/Non Vol\xE9es'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('hr', null),
	                    _react2.default.createElement(
	                        _rubix.FormGroup,
	                        null,
	                        _react2.default.createElement(
	                            _rubix.Col,
	                            { sm: 3 },
	                            'Affichage :'
	                        ),
	                        _react2.default.createElement(
	                            _rubix.Col,
	                            { sm: 9 },
	                            _react2.default.createElement(
	                                _rubix.FormControl,
	                                { componentClass: 'select', type: 'select', ref: 'statistiques_affichage' },
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'months' },
	                                    'Par mois'
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'years' },
	                                    'Par ann\xE9e'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('hr', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        _rubix.FormGroup,
	                        null,
	                        _react2.default.createElement(
	                            _rubix.Col,
	                            { sm: 3 },
	                            'Dates :'
	                        ),
	                        _react2.default.createElement(
	                            _rubix.Col,
	                            { sm: 9 },
	                            _react2.default.createElement(
	                                _rubix.Col,
	                                { sm: 2 },
	                                'Du'
	                            ),
	                            _react2.default.createElement(
	                                _rubix.Col,
	                                { sm: 4 },
	                                _react2.default.createElement(DatePicker, {
	                                    dayLabels: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
	                                    monthLabels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
	                                    id: 'start_date', value: this.state.startDate, onChange: function onChange(value) {
	                                        return _this2.setState({ startDate: value });
	                                    } })
	                            ),
	                            _react2.default.createElement(
	                                _rubix.Col,
	                                { sm: 2 },
	                                'Au'
	                            ),
	                            _react2.default.createElement(
	                                _rubix.Col,
	                                { sm: 4 },
	                                _react2.default.createElement(DatePicker, {
	                                    dayLabels: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
	                                    monthLabels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
	                                    id: 'end_date', value: this.state.endDate, onChange: function onChange(value) {
	                                        return _this2.setState({ endDate: value });
	                                    } })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'center',
	                        null,
	                        _react2.default.createElement(
	                            _rubix.Button,
	                            { onClick: this.launchStatistiques.bind(this) },
	                            'Filtrer'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _rubix.BPanel,
	                    { header: 'Donn\xE9es :' },
	                    this.state.launched && _react2.default.createElement(_Tableau.Tableau, { data: this.state.data }),
	                    !this.state.launched && _react2.default.createElement(
	                        'p',
	                        null,
	                        '-'
	                    )
	                ),
	                _react2.default.createElement(
	                    _rubix.BPanel,
	                    { header: 'Graphique :' },
	                    this.state.launched && _react2.default.createElement(_reactChartjs.Line, { data: this.state.data }),
	                    !this.state.launched && _react2.default.createElement(
	                        'p',
	                        null,
	                        'Bienvenue sur votre interface de statisques, merci de s\xE9l\xE9ctionner les statistiques \xE0 afficher.'
	                    )
	                )
	            );
	        }
	    }]);
	    return StatistiquesPage;
	}(_react2.default.Component)) || _class);
	exports.default = StatistiquesPage;

/***/ },

/***/ "./node_modules/react-chartjs-2/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Chart = exports.defaults = exports.Scatter = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _chart = __webpack_require__("./node_modules/chart.js/src/chart.js");
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _isEqual = __webpack_require__("./node_modules/lodash/isEqual.js");
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _find = __webpack_require__("./node_modules/lodash/find.js");
	
	var _find2 = _interopRequireDefault(_find);
	
	var _keyBy = __webpack_require__("./node_modules/lodash/keyBy.js");
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChartComponent = function (_React$Component) {
	  _inherits(ChartComponent, _React$Component);
	
	  function ChartComponent() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChartComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleOnClick = function (event) {
	      var instance = _this.chartInstance;
	
	      var _this$props = _this.props,
	          getDatasetAtEvent = _this$props.getDatasetAtEvent,
	          getElementAtEvent = _this$props.getElementAtEvent,
	          getElementsAtEvent = _this$props.getElementsAtEvent,
	          onElementsClick = _this$props.onElementsClick;
	
	
	      getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
	      getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
	      getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
	      onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
	    }, _this.ref = function (element) {
	      _this.element = element;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ChartComponent.prototype.componentWillMount = function componentWillMount() {
	    this.chartInstance = undefined;
	  };
	
	  ChartComponent.prototype.componentDidMount = function componentDidMount() {
	    this.renderChart();
	  };
	
	  ChartComponent.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this.props.redraw) {
	      this.chartInstance.destroy();
	      this.renderChart();
	      return;
	    }
	
	    this.updateChart();
	  };
	
	  ChartComponent.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var _props = this.props,
	        redraw = _props.redraw,
	        type = _props.type,
	        options = _props.options,
	        plugins = _props.plugins,
	        legend = _props.legend,
	        height = _props.height,
	        width = _props.width;
	
	
	    if (nextProps.redraw === true) {
	      return true;
	    }
	
	    if (height !== nextProps.height || width !== nextProps.width) {
	      return true;
	    }
	
	    if (type !== nextProps.type) {
	      return true;
	    }
	
	    if (!(0, _isEqual2.default)(legend, nextProps.legend)) {
	      return true;
	    }
	
	    if (!(0, _isEqual2.default)(options, nextProps.options)) {
	      return true;
	    }
	
	    var nextData = this.transformDataProp(nextProps);
	
	    if (!(0, _isEqual2.default)(this.shadowDataProp, nextData)) {
	      return true;
	    }
	
	    return !(0, _isEqual2.default)(plugins, nextProps.plugins);
	  };
	
	  ChartComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.chartInstance.destroy();
	  };
	
	  ChartComponent.prototype.transformDataProp = function transformDataProp(props) {
	    var data = props.data;
	
	    if (typeof data == 'function') {
	      var node = this.element;
	      return data(node);
	    } else {
	      return data;
	    }
	  };
	
	  // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
	  // this makes impossible to compare the current and next data changes
	  // therefore we memoize the data prop while sending a fake to Chart.js for mutation.
	  // see https://github.com/chartjs/Chart.js/blob/master/src/core/core.controller.js#L615-L617
	
	
	  ChartComponent.prototype.memoizeDataProps = function memoizeDataProps() {
	    if (!this.props.data) {
	      return;
	    }
	
	    var data = this.transformDataProp(this.props);
	
	    this.shadowDataProp = _extends({}, data, {
	      datasets: data.datasets && data.datasets.map(function (set) {
	        return _extends({}, set);
	      })
	    });
	
	    return data;
	  };
	
	  ChartComponent.prototype.updateChart = function updateChart() {
	    var _this2 = this;
	
	    var options = this.props.options;
	
	
	    var data = this.memoizeDataProps(this.props);
	
	    if (!this.chartInstance) return;
	
	    if (options) {
	      this.chartInstance.options = _chart2.default.helpers.configMerge(this.chartInstance.options, options);
	    }
	
	    // Pipe datasets to chart instance datasets enabling
	    // seamless transitions
	    var currentDatasets = this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
	    var nextDatasets = data.datasets || [];
	
	    var currentDatasetsIndexed = (0, _keyBy2.default)(currentDatasets, this.props.datasetKeyProvider);
	
	    // We can safely replace the dataset array, as long as we retain the _meta property
	    // on each dataset.
	    this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
	      var current = currentDatasetsIndexed[_this2.props.datasetKeyProvider(next)];
	      if (current && current.type === next.type) {
	        // The data array must be edited in place. As chart.js adds listeners to it.
	        current.data.splice(next.data.length);
	        next.data.forEach(function (point, pid) {
	          current.data[pid] = next.data[pid];
	        });
	
	        var _data = next.data,
	            otherProps = _objectWithoutProperties(next, ['data']);
	        // Merge properties. Notice a weakness here. If a property is removed
	        // from next, it will be retained by current and never disappears.
	        // Workaround is to set value to null or undefined in next.
	
	
	        return _extends({}, current, otherProps);
	      } else {
	        return next;
	      }
	    });
	
	    var datasets = data.datasets,
	        rest = _objectWithoutProperties(data, ['datasets']);
	
	    this.chartInstance.config.data = _extends({}, this.chartInstance.config.data, rest);
	
	    this.chartInstance.update();
	  };
	
	  ChartComponent.prototype.renderChart = function renderChart() {
	    var _props2 = this.props,
	        options = _props2.options,
	        legend = _props2.legend,
	        type = _props2.type,
	        redraw = _props2.redraw,
	        plugins = _props2.plugins;
	
	    var node = this.element;
	    var data = this.memoizeDataProps();
	
	    if (typeof legend !== 'undefined' && !(0, _isEqual2.default)(ChartComponent.defaultProps.legend, legend)) {
	      options.legend = legend;
	    }
	
	    this.chartInstance = new _chart2.default(node, {
	      type: type,
	      data: data,
	      options: options,
	      plugins: plugins
	    });
	  };
	
	  ChartComponent.prototype.render = function render() {
	    var _props3 = this.props,
	        height = _props3.height,
	        width = _props3.width,
	        onElementsClick = _props3.onElementsClick;
	
	
	    return _react2.default.createElement('canvas', {
	      ref: this.ref,
	      height: height,
	      width: width,
	      onClick: this.handleOnClick
	    });
	  };
	
	  return ChartComponent;
	}(_react2.default.Component);
	
	ChartComponent.getLabelAsKey = function (d) {
	  return d.label;
	};
	
	ChartComponent.propTypes = {
	  data: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]).isRequired,
	  getDatasetAtEvent: _propTypes2.default.func,
	  getElementAtEvent: _propTypes2.default.func,
	  getElementsAtEvent: _propTypes2.default.func,
	  height: _propTypes2.default.number,
	  legend: _propTypes2.default.object,
	  onElementsClick: _propTypes2.default.func,
	  options: _propTypes2.default.object,
	  plugins: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  redraw: _propTypes2.default.bool,
	  type: function type(props, propName, componentName) {
	    if (!_chart2.default.controllers[props[propName]]) {
	      return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
	    }
	  },
	  width: _propTypes2.default.number,
	  datasetKeyProvider: _propTypes2.default.func
	};
	ChartComponent.defaultProps = {
	  legend: {
	    display: true,
	    position: 'bottom'
	  },
	  type: 'doughnut',
	  height: 150,
	  width: 300,
	  redraw: false,
	  options: {},
	  datasetKeyProvider: ChartComponent.getLabelAsKey
	};
	exports.default = ChartComponent;
	
	var Doughnut = exports.Doughnut = function (_React$Component2) {
	  _inherits(Doughnut, _React$Component2);
	
	  function Doughnut() {
	    _classCallCheck(this, Doughnut);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  Doughnut.prototype.render = function render() {
	    var _this4 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref) {
	        return _this4.chartInstance = _ref && _ref.chartInstance;
	      },
	      type: 'doughnut'
	    }));
	  };
	
	  return Doughnut;
	}(_react2.default.Component);
	
	var Pie = exports.Pie = function (_React$Component3) {
	  _inherits(Pie, _React$Component3);
	
	  function Pie() {
	    _classCallCheck(this, Pie);
	
	    return _possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
	  }
	
	  Pie.prototype.render = function render() {
	    var _this6 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref2) {
	        return _this6.chartInstance = _ref2 && _ref2.chartInstance;
	      },
	      type: 'pie'
	    }));
	  };
	
	  return Pie;
	}(_react2.default.Component);
	
	var Line = exports.Line = function (_React$Component4) {
	  _inherits(Line, _React$Component4);
	
	  function Line() {
	    _classCallCheck(this, Line);
	
	    return _possibleConstructorReturn(this, _React$Component4.apply(this, arguments));
	  }
	
	  Line.prototype.render = function render() {
	    var _this8 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref3) {
	        return _this8.chartInstance = _ref3 && _ref3.chartInstance;
	      },
	      type: 'line'
	    }));
	  };
	
	  return Line;
	}(_react2.default.Component);
	
	var Bar = exports.Bar = function (_React$Component5) {
	  _inherits(Bar, _React$Component5);
	
	  function Bar() {
	    _classCallCheck(this, Bar);
	
	    return _possibleConstructorReturn(this, _React$Component5.apply(this, arguments));
	  }
	
	  Bar.prototype.render = function render() {
	    var _this10 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref4) {
	        return _this10.chartInstance = _ref4 && _ref4.chartInstance;
	      },
	      type: 'bar'
	    }));
	  };
	
	  return Bar;
	}(_react2.default.Component);
	
	var HorizontalBar = exports.HorizontalBar = function (_React$Component6) {
	  _inherits(HorizontalBar, _React$Component6);
	
	  function HorizontalBar() {
	    _classCallCheck(this, HorizontalBar);
	
	    return _possibleConstructorReturn(this, _React$Component6.apply(this, arguments));
	  }
	
	  HorizontalBar.prototype.render = function render() {
	    var _this12 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref5) {
	        return _this12.chartInstance = _ref5 && _ref5.chartInstance;
	      },
	      type: 'horizontalBar'
	    }));
	  };
	
	  return HorizontalBar;
	}(_react2.default.Component);
	
	var Radar = exports.Radar = function (_React$Component7) {
	  _inherits(Radar, _React$Component7);
	
	  function Radar() {
	    _classCallCheck(this, Radar);
	
	    return _possibleConstructorReturn(this, _React$Component7.apply(this, arguments));
	  }
	
	  Radar.prototype.render = function render() {
	    var _this14 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref6) {
	        return _this14.chartInstance = _ref6 && _ref6.chartInstance;
	      },
	      type: 'radar'
	    }));
	  };
	
	  return Radar;
	}(_react2.default.Component);
	
	var Polar = exports.Polar = function (_React$Component8) {
	  _inherits(Polar, _React$Component8);
	
	  function Polar() {
	    _classCallCheck(this, Polar);
	
	    return _possibleConstructorReturn(this, _React$Component8.apply(this, arguments));
	  }
	
	  Polar.prototype.render = function render() {
	    var _this16 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref7) {
	        return _this16.chartInstance = _ref7 && _ref7.chartInstance;
	      },
	      type: 'polarArea'
	    }));
	  };
	
	  return Polar;
	}(_react2.default.Component);
	
	var Bubble = exports.Bubble = function (_React$Component9) {
	  _inherits(Bubble, _React$Component9);
	
	  function Bubble() {
	    _classCallCheck(this, Bubble);
	
	    return _possibleConstructorReturn(this, _React$Component9.apply(this, arguments));
	  }
	
	  Bubble.prototype.render = function render() {
	    var _this18 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref8) {
	        return _this18.chartInstance = _ref8 && _ref8.chartInstance;
	      },
	      type: 'bubble'
	    }));
	  };
	
	  return Bubble;
	}(_react2.default.Component);
	
	var Scatter = exports.Scatter = function (_React$Component10) {
	  _inherits(Scatter, _React$Component10);
	
	  function Scatter() {
	    _classCallCheck(this, Scatter);
	
	    return _possibleConstructorReturn(this, _React$Component10.apply(this, arguments));
	  }
	
	  Scatter.prototype.render = function render() {
	    var _this20 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref9) {
	        return _this20.chartInstance = _ref9 && _ref9.chartInstance;
	      },
	      type: 'scatter'
	    }));
	  };
	
	  return Scatter;
	}(_react2.default.Component);
	
	var defaults = exports.defaults = _chart2.default.defaults;
	exports.Chart = _chart2.default;

/***/ },

/***/ "./node_modules/chart.js/src/chart.js":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @namespace Chart
	 */
	var Chart = __webpack_require__("./node_modules/chart.js/src/core/core.js")();
	
	Chart.helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
	__webpack_require__("./node_modules/chart.js/src/core/core.helpers.js")(Chart);
	
	Chart.defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	Chart.Element = __webpack_require__("./node_modules/chart.js/src/core/core.element.js");
	Chart.elements = __webpack_require__("./node_modules/chart.js/src/elements/index.js");
	Chart.Interaction = __webpack_require__("./node_modules/chart.js/src/core/core.interaction.js");
	Chart.platform = __webpack_require__("./node_modules/chart.js/src/platforms/platform.js");
	
	__webpack_require__("./node_modules/chart.js/src/core/core.plugin.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/core/core.animation.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/core/core.controller.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/core/core.datasetController.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/core/core.layoutService.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/core/core.scaleService.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/core/core.scale.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/core/core.tooltip.js")(Chart);
	
	__webpack_require__("./node_modules/chart.js/src/scales/scale.linearbase.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/scales/scale.category.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/scales/scale.linear.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/scales/scale.logarithmic.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/scales/scale.radialLinear.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/scales/scale.time.js")(Chart);
	
	// Controllers must be loaded after elements
	// See Chart.core.datasetController.dataElementType
	__webpack_require__("./node_modules/chart.js/src/controllers/controller.bar.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/controllers/controller.bubble.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/controllers/controller.doughnut.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/controllers/controller.line.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/controllers/controller.polarArea.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/controllers/controller.radar.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/controllers/controller.scatter.js")(Chart);
	
	__webpack_require__("./node_modules/chart.js/src/charts/Chart.Bar.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/charts/Chart.Bubble.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/charts/Chart.Doughnut.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/charts/Chart.Line.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/charts/Chart.PolarArea.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/charts/Chart.Radar.js")(Chart);
	__webpack_require__("./node_modules/chart.js/src/charts/Chart.Scatter.js")(Chart);
	
	// Loading built-it plugins
	var plugins = [];
	
	plugins.push(
		__webpack_require__("./node_modules/chart.js/src/plugins/plugin.filler.js")(Chart),
		__webpack_require__("./node_modules/chart.js/src/plugins/plugin.legend.js")(Chart),
		__webpack_require__("./node_modules/chart.js/src/plugins/plugin.title.js")(Chart)
	);
	
	Chart.plugins.register(plugins);
	
	Chart.platform.initialize();
	
	module.exports = Chart;
	if (typeof window !== 'undefined') {
		window.Chart = Chart;
	}
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas instead.
	 * @namespace Chart.canvasHelpers
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.canvasHelpers = Chart.helpers.canvas;


/***/ },

/***/ "./node_modules/chart.js/src/core/core.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	
	defaults._set('global', {
		responsive: true,
		responsiveAnimationDuration: 0,
		maintainAspectRatio: true,
		events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
		hover: {
			onHover: null,
			mode: 'nearest',
			intersect: true,
			animationDuration: 400
		},
		onClick: null,
		defaultColor: 'rgba(0,0,0,0.1)',
		defaultFontColor: '#666',
		defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		defaultFontSize: 12,
		defaultFontStyle: 'normal',
		showLines: true,
	
		// Element defaults defined in element extensions
		elements: {},
	
		// Layout options such as padding
		layout: {
			padding: {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			}
		}
	});
	
	module.exports = function() {
	
		// Occupy the global variable of Chart, and create a simple base class
		var Chart = function(item, config) {
			this.construct(item, config);
			return this;
		};
	
		Chart.Chart = Chart;
	
		return Chart;
	};


/***/ },

/***/ "./node_modules/chart.js/src/core/core.defaults.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	module.exports = {
		/**
		 * @private
		 */
		_set: function(scope, values) {
			return helpers.merge(this[scope] || (this[scope] = {}), values);
		}
	};


/***/ },

/***/ "./node_modules/chart.js/src/helpers/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__("./node_modules/chart.js/src/helpers/helpers.core.js");
	module.exports.easing = __webpack_require__("./node_modules/chart.js/src/helpers/helpers.easing.js");
	module.exports.canvas = __webpack_require__("./node_modules/chart.js/src/helpers/helpers.canvas.js");
	module.exports.options = __webpack_require__("./node_modules/chart.js/src/helpers/helpers.options.js");


/***/ },

/***/ "./node_modules/chart.js/src/helpers/helpers.core.js":
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * @namespace Chart.helpers
	 */
	var helpers = {
		/**
		 * An empty function that can be used, for example, for optional callback.
		 */
		noop: function() {},
	
		/**
		 * Returns a unique id, sequentially generated from a global variable.
		 * @returns {Number}
		 * @function
		 */
		uid: (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}()),
	
		/**
		 * Returns true if `value` is neither null nor undefined, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {Boolean}
		 * @since 2.7.0
		 */
		isNullOrUndef: function(value) {
			return value === null || typeof value === 'undefined';
		},
	
		/**
		 * Returns true if `value` is an array, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {Boolean}
		 * @function
		 */
		isArray: Array.isArray ? Array.isArray : function(value) {
			return Object.prototype.toString.call(value) === '[object Array]';
		},
	
		/**
		 * Returns true if `value` is an object (excluding null), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {Boolean}
		 * @since 2.7.0
		 */
		isObject: function(value) {
			return value !== null && Object.prototype.toString.call(value) === '[object Object]';
		},
	
		/**
		 * Returns `value` if defined, else returns `defaultValue`.
		 * @param {*} value - The value to return if defined.
		 * @param {*} defaultValue - The value to return if `value` is undefined.
		 * @returns {*}
		 */
		valueOrDefault: function(value, defaultValue) {
			return typeof value === 'undefined' ? defaultValue : value;
		},
	
		/**
		 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
		 * @param {Array} value - The array to lookup for value at `index`.
		 * @param {Number} index - The index in `value` to lookup for value.
		 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
		 * @returns {*}
		 */
		valueAtIndexOrDefault: function(value, index, defaultValue) {
			return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
		},
	
		/**
		 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
		 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
		 * @param {Function} fn - The function to call.
		 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
		 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @returns {*}
		 */
		callback: function(fn, args, thisArg) {
			if (fn && typeof fn.call === 'function') {
				return fn.apply(thisArg, args);
			}
		},
	
		/**
		 * Note(SB) for performance sake, this method should only be used when loopable type
		 * is unknown or in none intensive code (not called often and small loopable). Else
		 * it's preferable to use a regular for() loop and save extra function calls.
		 * @param {Object|Array} loopable - The object or array to be iterated.
		 * @param {Function} fn - The function to call for each item.
		 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @param {Boolean} [reverse] - If true, iterates backward on the loopable.
		 */
		each: function(loopable, fn, thisArg, reverse) {
			var i, len, keys;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						fn.call(thisArg, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						fn.call(thisArg, loopable[i], i);
					}
				}
			} else if (helpers.isObject(loopable)) {
				keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[keys[i]], keys[i]);
				}
			}
		},
	
		/**
		 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
		 * @see http://stackoverflow.com/a/14853974
		 * @param {Array} a0 - The array to compare
		 * @param {Array} a1 - The array to compare
		 * @returns {Boolean}
		 */
		arrayEquals: function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen = a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		},
	
		/**
		 * Returns a deep copy of `source` without keeping references on objects and arrays.
		 * @param {*} source - The value to clone.
		 * @returns {*}
		 */
		clone: function(source) {
			if (helpers.isArray(source)) {
				return source.map(helpers.clone);
			}
	
			if (helpers.isObject(source)) {
				var target = {};
				var keys = Object.keys(source);
				var klen = keys.length;
				var k = 0;
	
				for (; k < klen; ++k) {
					target[keys[k]] = helpers.clone(source[keys[k]]);
				}
	
				return target;
			}
	
			return source;
		},
	
		/**
		 * The default merger when Chart.helpers.merge is called without merger option.
		 * Note(SB): this method is also used by configMerge and scaleMerge as fallback.
		 * @private
		 */
		_merger: function(key, target, source, options) {
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.merge(tval, sval, options);
			} else {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Merges source[key] in target[key] only if target[key] is undefined.
		 * @private
		 */
		_mergerIf: function(key, target, source) {
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.mergeIf(tval, sval);
			} else if (!target.hasOwnProperty(key)) {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` with the given `options`.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {Object} target - The target object in which all sources are merged into.
		 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
		 * @param {Object} [options] - Merging options:
		 * @param {Function} [options.merger] - The merge method (key, target, source, options)
		 * @returns {Object} The `target` object.
		 */
		merge: function(target, source, options) {
			var sources = helpers.isArray(source) ? source : [source];
			var ilen = sources.length;
			var merge, i, keys, klen, k;
	
			if (!helpers.isObject(target)) {
				return target;
			}
	
			options = options || {};
			merge = options.merger || helpers._merger;
	
			for (i = 0; i < ilen; ++i) {
				source = sources[i];
				if (!helpers.isObject(source)) {
					continue;
				}
	
				keys = Object.keys(source);
				for (k = 0, klen = keys.length; k < klen; ++k) {
					merge(keys[k], target, source, options);
				}
			}
	
			return target;
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {Object} target - The target object in which all sources are merged into.
		 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
		 * @returns {Object} The `target` object.
		 */
		mergeIf: function(target, source) {
			return helpers.merge(target, source, {merger: helpers._mergerIf});
		},
	
		/**
		 * Applies the contents of two or more objects together into the first object.
		 * @param {Object} target - The target object in which all objects are merged into.
		 * @param {Object} arg1 - Object containing additional properties to merge in target.
		 * @param {Object} argN - Additional objects containing properties to merge in target.
		 * @returns {Object} The `target` object.
		 */
		extend: function(target) {
			var setFn = function(value, key) {
				target[key] = value;
			};
			for (var i = 1, ilen = arguments.length; i < ilen; ++i) {
				helpers.each(arguments[i], setFn);
			}
			return target;
		},
	
		/**
		 * Basic javascript inheritance based on the model created in Backbone.js
		 */
		inherits: function(extensions) {
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
	
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
			return ChartElement;
		}
	};
	
	module.exports = helpers;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.callback instead.
	 * @function Chart.helpers.callCallback
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.callCallback = helpers.callback;
	
	/**
	 * Provided for backward compatibility, use Array.prototype.indexOf instead.
	 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
	 * @function Chart.helpers.indexOf
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.indexOf = function(array, item, fromIndex) {
		return Array.prototype.indexOf.call(array, item, fromIndex);
	};
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
	 * @function Chart.helpers.getValueOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueOrDefault = helpers.valueOrDefault;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
	 * @function Chart.helpers.getValueAtIndexOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;


/***/ },

/***/ "./node_modules/chart.js/src/helpers/helpers.easing.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/helpers.core.js");
	
	/**
	 * Easing functions adapted from Robert Penner's easing equations.
	 * @namespace Chart.helpers.easingEffects
	 * @see http://www.robertpenner.com/easing/
	 */
	var effects = {
		linear: function(t) {
			return t;
		},
	
		easeInQuad: function(t) {
			return t * t;
		},
	
		easeOutQuad: function(t) {
			return -t * (t - 2);
		},
	
		easeInOutQuad: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t;
			}
			return -0.5 * ((--t) * (t - 2) - 1);
		},
	
		easeInCubic: function(t) {
			return t * t * t;
		},
	
		easeOutCubic: function(t) {
			return (t = t - 1) * t * t + 1;
		},
	
		easeInOutCubic: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t + 2);
		},
	
		easeInQuart: function(t) {
			return t * t * t * t;
		},
	
		easeOutQuart: function(t) {
			return -((t = t - 1) * t * t * t - 1);
		},
	
		easeInOutQuart: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t;
			}
			return -0.5 * ((t -= 2) * t * t * t - 2);
		},
	
		easeInQuint: function(t) {
			return t * t * t * t * t;
		},
	
		easeOutQuint: function(t) {
			return (t = t - 1) * t * t * t * t + 1;
		},
	
		easeInOutQuint: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t * t * t + 2);
		},
	
		easeInSine: function(t) {
			return -Math.cos(t * (Math.PI / 2)) + 1;
		},
	
		easeOutSine: function(t) {
			return Math.sin(t * (Math.PI / 2));
		},
	
		easeInOutSine: function(t) {
			return -0.5 * (Math.cos(Math.PI * t) - 1);
		},
	
		easeInExpo: function(t) {
			return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
		},
	
		easeOutExpo: function(t) {
			return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
		},
	
		easeInOutExpo: function(t) {
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if ((t /= 0.5) < 1) {
				return 0.5 * Math.pow(2, 10 * (t - 1));
			}
			return 0.5 * (-Math.pow(2, -10 * --t) + 2);
		},
	
		easeInCirc: function(t) {
			if (t >= 1) {
				return t;
			}
			return -(Math.sqrt(1 - t * t) - 1);
		},
	
		easeOutCirc: function(t) {
			return Math.sqrt(1 - (t = t - 1) * t);
		},
	
		easeInOutCirc: function(t) {
			if ((t /= 0.5) < 1) {
				return -0.5 * (Math.sqrt(1 - t * t) - 1);
			}
			return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
		},
	
		easeInElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		},
	
		easeOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
		},
	
		easeInOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 0.5) === 2) {
				return 1;
			}
			if (!p) {
				p = 0.45;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			if (t < 1) {
				return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
			}
			return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
		},
		easeInBack: function(t) {
			var s = 1.70158;
			return t * t * ((s + 1) * t - s);
		},
	
		easeOutBack: function(t) {
			var s = 1.70158;
			return (t = t - 1) * t * ((s + 1) * t + s) + 1;
		},
	
		easeInOutBack: function(t) {
			var s = 1.70158;
			if ((t /= 0.5) < 1) {
				return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
			}
			return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
		},
	
		easeInBounce: function(t) {
			return 1 - effects.easeOutBounce(1 - t);
		},
	
		easeOutBounce: function(t) {
			if (t < (1 / 2.75)) {
				return 7.5625 * t * t;
			}
			if (t < (2 / 2.75)) {
				return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
			}
			if (t < (2.5 / 2.75)) {
				return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
			}
			return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
		},
	
		easeInOutBounce: function(t) {
			if (t < 0.5) {
				return effects.easeInBounce(t * 2) * 0.5;
			}
			return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
		}
	};
	
	module.exports = {
		effects: effects
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
	 * @function Chart.helpers.easingEffects
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.easingEffects = effects;


/***/ },

/***/ "./node_modules/chart.js/src/helpers/helpers.canvas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/helpers.core.js");
	
	/**
	 * @namespace Chart.helpers.canvas
	 */
	var exports = module.exports = {
		/**
		 * Clears the entire canvas associated to the given `chart`.
		 * @param {Chart} chart - The chart for which to clear the canvas.
		 */
		clear: function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		},
	
		/**
		 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
		 * given size (width, height) and the same `radius` for all corners.
		 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
		 * @param {Number} x - The x axis of the coordinate for the rectangle starting point.
		 * @param {Number} y - The y axis of the coordinate for the rectangle starting point.
		 * @param {Number} width - The rectangle's width.
		 * @param {Number} height - The rectangle's height.
		 * @param {Number} radius - The rounded amount (in pixels) for the four corners.
		 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
		 */
		roundedRect: function(ctx, x, y, width, height, radius) {
			if (radius) {
				var rx = Math.min(radius, width / 2);
				var ry = Math.min(radius, height / 2);
	
				ctx.moveTo(x + rx, y);
				ctx.lineTo(x + width - rx, y);
				ctx.quadraticCurveTo(x + width, y, x + width, y + ry);
				ctx.lineTo(x + width, y + height - ry);
				ctx.quadraticCurveTo(x + width, y + height, x + width - rx, y + height);
				ctx.lineTo(x + rx, y + height);
				ctx.quadraticCurveTo(x, y + height, x, y + height - ry);
				ctx.lineTo(x, y + ry);
				ctx.quadraticCurveTo(x, y, x + rx, y);
			} else {
				ctx.rect(x, y, width, height);
			}
		},
	
		drawPoint: function(ctx, style, radius, x, y) {
			var type, edgeLength, xOffset, yOffset, height, size;
	
			if (style && typeof style === 'object') {
				type = style.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.drawImage(style, x - style.width / 2, y - style.height / 2, style.width, style.height);
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			switch (style) {
			// Default includes circle
			default:
				ctx.beginPath();
				ctx.arc(x, y, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.fill();
				break;
			case 'triangle':
				ctx.beginPath();
				edgeLength = 3 * radius / Math.sqrt(3);
				height = edgeLength * Math.sqrt(3) / 2;
				ctx.moveTo(x - edgeLength / 2, y + height / 3);
				ctx.lineTo(x + edgeLength / 2, y + height / 3);
				ctx.lineTo(x, y - 2 * height / 3);
				ctx.closePath();
				ctx.fill();
				break;
			case 'rect':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
				ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
				break;
			case 'rectRounded':
				var offset = radius / Math.SQRT2;
				var leftX = x - offset;
				var topY = y - offset;
				var sideSize = Math.SQRT2 * radius;
				ctx.beginPath();
				this.roundedRect(ctx, leftX, topY, sideSize, sideSize, radius / 2);
				ctx.closePath();
				ctx.fill();
				break;
			case 'rectRot':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.moveTo(x - size, y);
				ctx.lineTo(x, y + size);
				ctx.lineTo(x + size, y);
				ctx.lineTo(x, y - size);
				ctx.closePath();
				ctx.fill();
				break;
			case 'cross':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'crossRot':
				ctx.beginPath();
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'star':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'line':
				ctx.beginPath();
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'dash':
				ctx.beginPath();
				ctx.moveTo(x, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			}
	
			ctx.stroke();
		},
	
		clipArea: function(ctx, area) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
			ctx.clip();
		},
	
		unclipArea: function(ctx) {
			ctx.restore();
		},
	
		lineTo: function(ctx, previous, target, flip) {
			if (target.steppedLine) {
				if ((target.steppedLine === 'after' && !flip) || (target.steppedLine !== 'after' && flip)) {
					ctx.lineTo(previous.x, target.y);
				} else {
					ctx.lineTo(target.x, previous.y);
				}
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			if (!target.tension) {
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			ctx.bezierCurveTo(
				flip ? previous.controlPointPreviousX : previous.controlPointNextX,
				flip ? previous.controlPointPreviousY : previous.controlPointNextY,
				flip ? target.controlPointNextX : target.controlPointPreviousX,
				flip ? target.controlPointNextY : target.controlPointPreviousY,
				target.x,
				target.y);
		}
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
	 * @namespace Chart.helpers.clear
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.clear = exports.clear;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
	 * @namespace Chart.helpers.drawRoundedRectangle
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.drawRoundedRectangle = function(ctx) {
		ctx.beginPath();
		exports.roundedRect.apply(exports, arguments);
		ctx.closePath();
	};


/***/ },

/***/ "./node_modules/chart.js/src/helpers/helpers.options.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/helpers.core.js");
	
	/**
	 * @alias Chart.helpers.options
	 * @namespace
	 */
	module.exports = {
		/**
		 * Converts the given line height `value` in pixels for a specific font `size`.
		 * @param {Number|String} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
		 * @param {Number} size - The font size (in pixels) used to resolve relative `value`.
		 * @returns {Number} The effective line height in pixels (size * 1.2 if value is invalid).
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
		 * @since 2.7.0
		 */
		toLineHeight: function(value, size) {
			var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
			if (!matches || matches[1] === 'normal') {
				return size * 1.2;
			}
	
			value = +matches[2];
	
			switch (matches[3]) {
			case 'px':
				return value;
			case '%':
				value /= 100;
				break;
			default:
				break;
			}
	
			return size * value;
		},
	
		/**
		 * Converts the given value into a padding object with pre-computed width/height.
		 * @param {Number|Object} value - If a number, set the value to all TRBL component,
		 *  else, if and object, use defined properties and sets undefined ones to 0.
		 * @returns {Object} The padding values (top, right, bottom, left, width, height)
		 * @since 2.7.0
		 */
		toPadding: function(value) {
			var t, r, b, l;
	
			if (helpers.isObject(value)) {
				t = +value.top || 0;
				r = +value.right || 0;
				b = +value.bottom || 0;
				l = +value.left || 0;
			} else {
				t = r = b = l = +value || 0;
			}
	
			return {
				top: t,
				right: r,
				bottom: b,
				left: l,
				height: t + b,
				width: l + r
			};
		},
	
		/**
		 * Evaluates the given `inputs` sequentially and returns the first defined value.
		 * @param {Array[]} inputs - An array of values, falling back to the last value.
		 * @param {Object} [context] - If defined and the current value is a function, the value
		 * is called with `context` as first argument and the result becomes the new input.
		 * @param {Number} [index] - If defined and the current value is an array, the value
		 * at `index` become the new input.
		 * @since 2.7.0
		 */
		resolve: function(inputs, context, index) {
			var i, ilen, value;
	
			for (i = 0, ilen = inputs.length; i < ilen; ++i) {
				value = inputs[i];
				if (value === undefined) {
					continue;
				}
				if (context !== undefined && typeof value === 'function') {
					value = value(context);
				}
				if (index !== undefined && helpers.isArray(value)) {
					value = value[index];
				}
				if (value !== undefined) {
					return value;
				}
			}
		}
	};


/***/ },

/***/ "./node_modules/chart.js/src/core/core.helpers.js":
/***/ function(module, exports, __webpack_require__) {

	/* global window: false */
	/* global document: false */
	'use strict';
	
	var color = __webpack_require__("./node_modules/chartjs-color/index.js");
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	module.exports = function(Chart) {
	
		// -- Basic js utility methods
	
		helpers.configMerge = function(/* objects ... */) {
			return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
				merger: function(key, target, source, options) {
					var tval = target[key] || {};
					var sval = source[key];
	
					if (key === 'scales') {
						// scale config merging is complex. Add our own function here for that
						target[key] = helpers.scaleMerge(tval, sval);
					} else if (key === 'scale') {
						// used in polar area & radar charts since there is only one scale
						target[key] = helpers.merge(tval, [Chart.scaleService.getScaleDefaults(sval.type), sval]);
					} else {
						helpers._merger(key, target, source, options);
					}
				}
			});
		};
	
		helpers.scaleMerge = function(/* objects ... */) {
			return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
				merger: function(key, target, source, options) {
					if (key === 'xAxes' || key === 'yAxes') {
						var slen = source[key].length;
						var i, type, scale;
	
						if (!target[key]) {
							target[key] = [];
						}
	
						for (i = 0; i < slen; ++i) {
							scale = source[key][i];
							type = helpers.valueOrDefault(scale.type, key === 'xAxes' ? 'category' : 'linear');
	
							if (i >= target[key].length) {
								target[key].push({});
							}
	
							if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
								// new/untyped scale or type changed: let's apply the new defaults
								// then merge source scale to correctly overwrite the defaults.
								helpers.merge(target[key][i], [Chart.scaleService.getScaleDefaults(type), scale]);
							} else {
								// scales type are the same
								helpers.merge(target[key][i], scale);
							}
						}
					} else {
						helpers._merger(key, target, source, options);
					}
				}
			});
		};
	
		helpers.where = function(collection, filterCallback) {
			if (helpers.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers.findIndex = Array.prototype.findIndex ?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined ? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (helpers.isNullOrUndef(startIndex)) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (helpers.isNullOrUndef(startIndex)) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
	
		// -- Math methods
		helpers.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
		};
		helpers.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers.sign = Math.sign ?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers.log10 = Math.log10 ?
			function(x) {
				return Math.log10(x);
			} :
			function(x) {
				return Math.log(x) / Math.LN10;
			};
		helpers.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
		// Gets the angle from vertical upright to the point about a centre.
		helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x;
			var distanceFromYCenter = anglePoint.y - centrePoint.y;
			var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};
		helpers.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
		helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint;
			var current = middlePoint;
			var next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers.EPSILON = Number.EPSILON || 1e-14;
		helpers.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);
	
					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers.niceNum = function(range, round) {
			var exponent = Math.floor(helpers.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers.requestAnimFrame = (function() {
			if (typeof window === 'undefined') {
				return function(callback) {
					callback();
				};
			}
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt;
			var canvas = evt.currentTarget || evt.srcElement;
			var boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof styleValue === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		// Private helper to get a constraint dimension
		// @param domNode : the node to check the constraint on
		// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
		// @param percentageProperty : property of parent to use when calculating width as a percentage
		// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = domNode.parentNode;
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		helpers.getMaximumWidth = function(domNode) {
			var container = domNode.parentNode;
			if (!container) {
				return domNode.clientWidth;
			}
	
			var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
			var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
			var w = container.clientWidth - paddingLeft - paddingRight;
			var cw = helpers.getConstraintWidth(domNode);
			return isNaN(cw) ? w : Math.min(w, cw);
		};
		helpers.getMaximumHeight = function(domNode) {
			var container = domNode.parentNode;
			if (!container) {
				return domNode.clientHeight;
			}
	
			var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
			var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
			var h = container.clientHeight - paddingTop - paddingBottom;
			var ch = helpers.getConstraintHeight(domNode);
			return isNaN(ch) ? h : Math.min(h, ch);
		};
		helpers.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers.retinaScale = function(chart, forceRatio) {
			var pixelRatio = chart.currentDevicePixelRatio = forceRatio || window.devicePixelRatio || 1;
			if (pixelRatio === 1) {
				return;
			}
	
			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;
	
			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);
	
			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		};
		// -- Canvas methods
		helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			helpers.each(arrayOfThings, function(thing) {
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
					longest = helpers.measureText(ctx, data, gc, longest, thing);
				} else if (helpers.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					helpers.each(thing, function(nestedThing) {
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
							longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
						}
					});
				}
			});
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (var i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
		helpers.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers.each(arrayOfThings, function(thing) {
				if (helpers.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
	
		helpers.color = !color ?
			function(value) {
				console.error('Color.js not found!');
				return value;
			} :
			function(value) {
				/* global CanvasGradient */
				if (value instanceof CanvasGradient) {
					value = defaults.global.defaultColor;
				}
	
				return color(value);
			};
	
		helpers.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern) ?
				colorValue :
				helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};


/***/ },

/***/ "./node_modules/chartjs-color/index.js":
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var convert = __webpack_require__("./node_modules/color-convert/index.js");
	var string = __webpack_require__("./node_modules/chartjs-color-string/color-string.js");
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = string.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = string.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = string.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return string.hexString(this.values.rgb);
		},
		rgbString: function () {
			return string.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return string.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return string.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return string.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return string.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return string.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return string.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = convert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	module.exports = Color;


/***/ },

/***/ "./node_modules/color-convert/index.js":
/***/ function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__("./node_modules/color-convert/conversions.js");
	
	var convert = function() {
	   return new Converter();
	}
	
	for (var func in conversions) {
	  // export Raw versions
	  convert[func + "Raw"] =  (function(func) {
	    // accept array or plain args
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      return conversions[func](arg);
	    }
	  })(func);
	
	  var pair = /(\w+)2(\w+)/.exec(func),
	      from = pair[1],
	      to = pair[2];
	
	  // export rgb2hsl and ["rgb"]["hsl"]
	  convert[from] = convert[from] || {};
	
	  convert[from][to] = convert[func] = (function(func) { 
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      
	      var val = conversions[func](arg);
	      if (typeof val == "string" || val === undefined)
	        return val; // keyword
	
	      for (var i = 0; i < val.length; i++)
	        val[i] = Math.round(val[i]);
	      return val;
	    }
	  })(func);
	}
	
	
	/* Converter does lazy conversion and caching */
	var Converter = function() {
	   this.convs = {};
	};
	
	/* Either get the values for a space or
	  set the values for a space, depending on args */
	Converter.prototype.routeSpace = function(space, args) {
	   var values = args[0];
	   if (values === undefined) {
	      // color.rgb()
	      return this.getValues(space);
	   }
	   // color.rgb(10, 10, 10)
	   if (typeof values == "number") {
	      values = Array.prototype.slice.call(args);        
	   }
	
	   return this.setValues(space, values);
	};
	  
	/* Set the values for a space, invalidating cache */
	Converter.prototype.setValues = function(space, values) {
	   this.space = space;
	   this.convs = {};
	   this.convs[space] = values;
	   return this;
	};
	
	/* Get the values for a space. If there's already
	  a conversion for the space, fetch it, otherwise
	  compute it */
	Converter.prototype.getValues = function(space) {
	   var vals = this.convs[space];
	   if (!vals) {
	      var fspace = this.space,
	          from = this.convs[fspace];
	      vals = convert[fspace][space](from);
	
	      this.convs[space] = vals;
	   }
	  return vals;
	};
	
	["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
	   Converter.prototype[space] = function(vals) {
	      return this.routeSpace(space, arguments);
	   }
	});
	
	module.exports = convert;

/***/ },

/***/ "./node_modules/color-convert/conversions.js":
/***/ function(module, exports) {

	/* MIT license */
	
	module.exports = {
	  rgb2hsl: rgb2hsl,
	  rgb2hsv: rgb2hsv,
	  rgb2hwb: rgb2hwb,
	  rgb2cmyk: rgb2cmyk,
	  rgb2keyword: rgb2keyword,
	  rgb2xyz: rgb2xyz,
	  rgb2lab: rgb2lab,
	  rgb2lch: rgb2lch,
	
	  hsl2rgb: hsl2rgb,
	  hsl2hsv: hsl2hsv,
	  hsl2hwb: hsl2hwb,
	  hsl2cmyk: hsl2cmyk,
	  hsl2keyword: hsl2keyword,
	
	  hsv2rgb: hsv2rgb,
	  hsv2hsl: hsv2hsl,
	  hsv2hwb: hsv2hwb,
	  hsv2cmyk: hsv2cmyk,
	  hsv2keyword: hsv2keyword,
	
	  hwb2rgb: hwb2rgb,
	  hwb2hsl: hwb2hsl,
	  hwb2hsv: hwb2hsv,
	  hwb2cmyk: hwb2cmyk,
	  hwb2keyword: hwb2keyword,
	
	  cmyk2rgb: cmyk2rgb,
	  cmyk2hsl: cmyk2hsl,
	  cmyk2hsv: cmyk2hsv,
	  cmyk2hwb: cmyk2hwb,
	  cmyk2keyword: cmyk2keyword,
	
	  keyword2rgb: keyword2rgb,
	  keyword2hsl: keyword2hsl,
	  keyword2hsv: keyword2hsv,
	  keyword2hwb: keyword2hwb,
	  keyword2cmyk: keyword2cmyk,
	  keyword2lab: keyword2lab,
	  keyword2xyz: keyword2xyz,
	
	  xyz2rgb: xyz2rgb,
	  xyz2lab: xyz2lab,
	  xyz2lch: xyz2lch,
	
	  lab2xyz: lab2xyz,
	  lab2rgb: lab2rgb,
	  lab2lch: lab2lch,
	
	  lch2lab: lch2lab,
	  lch2xyz: lch2xyz,
	  lch2rgb: lch2rgb
	}
	
	
	function rgb2hsl(rgb) {
	  var r = rgb[0]/255,
	      g = rgb[1]/255,
	      b = rgb[2]/255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, l;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g)/ delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  l = (min + max) / 2;
	
	  if (max == min)
	    s = 0;
	  else if (l <= 0.5)
	    s = delta / (max + min);
	  else
	    s = delta / (2 - max - min);
	
	  return [h, s * 100, l * 100];
	}
	
	function rgb2hsv(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, v;
	
	  if (max == 0)
	    s = 0;
	  else
	    s = (delta/max * 1000)/10;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g) / delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  v = ((max / 255) * 1000) / 10;
	
	  return [h, s, v];
	}
	
	function rgb2hwb(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      h = rgb2hsl(rgb)[0],
	      w = 1/255 * Math.min(r, Math.min(g, b)),
	      b = 1 - 1/255 * Math.max(r, Math.max(g, b));
	
	  return [h, w * 100, b * 100];
	}
	
	function rgb2cmyk(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255,
	      c, m, y, k;
	
	  k = Math.min(1 - r, 1 - g, 1 - b);
	  c = (1 - r - k) / (1 - k) || 0;
	  m = (1 - g - k) / (1 - k) || 0;
	  y = (1 - b - k) / (1 - k) || 0;
	  return [c * 100, m * 100, y * 100, k * 100];
	}
	
	function rgb2keyword(rgb) {
	  return reverseKeywords[JSON.stringify(rgb)];
	}
	
	function rgb2xyz(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255;
	
	  // assume sRGB
	  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
	  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
	  return [x * 100, y *100, z * 100];
	}
	
	function rgb2lab(rgb) {
	  var xyz = rgb2xyz(rgb),
	        x = xyz[0],
	        y = xyz[1],
	        z = xyz[2],
	        l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function rgb2lch(args) {
	  return lab2lch(rgb2lab(args));
	}
	
	function hsl2rgb(hsl) {
	  var h = hsl[0] / 360,
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      t1, t2, t3, rgb, val;
	
	  if (s == 0) {
	    val = l * 255;
	    return [val, val, val];
	  }
	
	  if (l < 0.5)
	    t2 = l * (1 + s);
	  else
	    t2 = l + s - l * s;
	  t1 = 2 * l - t2;
	
	  rgb = [0, 0, 0];
	  for (var i = 0; i < 3; i++) {
	    t3 = h + 1 / 3 * - (i - 1);
	    t3 < 0 && t3++;
	    t3 > 1 && t3--;
	
	    if (6 * t3 < 1)
	      val = t1 + (t2 - t1) * 6 * t3;
	    else if (2 * t3 < 1)
	      val = t2;
	    else if (3 * t3 < 2)
	      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
	    else
	      val = t1;
	
	    rgb[i] = val * 255;
	  }
	
	  return rgb;
	}
	
	function hsl2hsv(hsl) {
	  var h = hsl[0],
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      sv, v;
	
	  if(l === 0) {
	      // no need to do calc on black
	      // also avoids divide by 0 error
	      return [0, 0, 0];
	  }
	
	  l *= 2;
	  s *= (l <= 1) ? l : 2 - l;
	  v = (l + s) / 2;
	  sv = (2 * s) / (l + s);
	  return [h, sv * 100, v * 100];
	}
	
	function hsl2hwb(args) {
	  return rgb2hwb(hsl2rgb(args));
	}
	
	function hsl2cmyk(args) {
	  return rgb2cmyk(hsl2rgb(args));
	}
	
	function hsl2keyword(args) {
	  return rgb2keyword(hsl2rgb(args));
	}
	
	
	function hsv2rgb(hsv) {
	  var h = hsv[0] / 60,
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      hi = Math.floor(h) % 6;
	
	  var f = h - Math.floor(h),
	      p = 255 * v * (1 - s),
	      q = 255 * v * (1 - (s * f)),
	      t = 255 * v * (1 - (s * (1 - f))),
	      v = 255 * v;
	
	  switch(hi) {
	    case 0:
	      return [v, t, p];
	    case 1:
	      return [q, v, p];
	    case 2:
	      return [p, v, t];
	    case 3:
	      return [p, q, v];
	    case 4:
	      return [t, p, v];
	    case 5:
	      return [v, p, q];
	  }
	}
	
	function hsv2hsl(hsv) {
	  var h = hsv[0],
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      sl, l;
	
	  l = (2 - s) * v;
	  sl = s * v;
	  sl /= (l <= 1) ? l : 2 - l;
	  sl = sl || 0;
	  l /= 2;
	  return [h, sl * 100, l * 100];
	}
	
	function hsv2hwb(args) {
	  return rgb2hwb(hsv2rgb(args))
	}
	
	function hsv2cmyk(args) {
	  return rgb2cmyk(hsv2rgb(args));
	}
	
	function hsv2keyword(args) {
	  return rgb2keyword(hsv2rgb(args));
	}
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	function hwb2rgb(hwb) {
	  var h = hwb[0] / 360,
	      wh = hwb[1] / 100,
	      bl = hwb[2] / 100,
	      ratio = wh + bl,
	      i, v, f, n;
	
	  // wh + bl cant be > 1
	  if (ratio > 1) {
	    wh /= ratio;
	    bl /= ratio;
	  }
	
	  i = Math.floor(6 * h);
	  v = 1 - bl;
	  f = 6 * h - i;
	  if ((i & 0x01) != 0) {
	    f = 1 - f;
	  }
	  n = wh + f * (v - wh);  // linear interpolation
	
	  switch (i) {
	    default:
	    case 6:
	    case 0: r = v; g = n; b = wh; break;
	    case 1: r = n; g = v; b = wh; break;
	    case 2: r = wh; g = v; b = n; break;
	    case 3: r = wh; g = n; b = v; break;
	    case 4: r = n; g = wh; b = v; break;
	    case 5: r = v; g = wh; b = n; break;
	  }
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function hwb2hsl(args) {
	  return rgb2hsl(hwb2rgb(args));
	}
	
	function hwb2hsv(args) {
	  return rgb2hsv(hwb2rgb(args));
	}
	
	function hwb2cmyk(args) {
	  return rgb2cmyk(hwb2rgb(args));
	}
	
	function hwb2keyword(args) {
	  return rgb2keyword(hwb2rgb(args));
	}
	
	function cmyk2rgb(cmyk) {
	  var c = cmyk[0] / 100,
	      m = cmyk[1] / 100,
	      y = cmyk[2] / 100,
	      k = cmyk[3] / 100,
	      r, g, b;
	
	  r = 1 - Math.min(1, c * (1 - k) + k);
	  g = 1 - Math.min(1, m * (1 - k) + k);
	  b = 1 - Math.min(1, y * (1 - k) + k);
	  return [r * 255, g * 255, b * 255];
	}
	
	function cmyk2hsl(args) {
	  return rgb2hsl(cmyk2rgb(args));
	}
	
	function cmyk2hsv(args) {
	  return rgb2hsv(cmyk2rgb(args));
	}
	
	function cmyk2hwb(args) {
	  return rgb2hwb(cmyk2rgb(args));
	}
	
	function cmyk2keyword(args) {
	  return rgb2keyword(cmyk2rgb(args));
	}
	
	
	function xyz2rgb(xyz) {
	  var x = xyz[0] / 100,
	      y = xyz[1] / 100,
	      z = xyz[2] / 100,
	      r, g, b;
	
	  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
	  // assume sRGB
	  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
	    : r = (r * 12.92);
	
	  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
	    : g = (g * 12.92);
	
	  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
	    : b = (b * 12.92);
	
	  r = Math.min(Math.max(0, r), 1);
	  g = Math.min(Math.max(0, g), 1);
	  b = Math.min(Math.max(0, b), 1);
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function xyz2lab(xyz) {
	  var x = xyz[0],
	      y = xyz[1],
	      z = xyz[2],
	      l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function xyz2lch(args) {
	  return lab2lch(xyz2lab(args));
	}
	
	function lab2xyz(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      x, y, z, y2;
	
	  if (l <= 8) {
	    y = (l * 100) / 903.3;
	    y2 = (7.787 * (y / 100)) + (16 / 116);
	  } else {
	    y = 100 * Math.pow((l + 16) / 116, 3);
	    y2 = Math.pow(y / 100, 1/3);
	  }
	
	  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);
	
	  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);
	
	  return [x, y, z];
	}
	
	function lab2lch(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      hr, h, c;
	
	  hr = Math.atan2(b, a);
	  h = hr * 360 / 2 / Math.PI;
	  if (h < 0) {
	    h += 360;
	  }
	  c = Math.sqrt(a * a + b * b);
	  return [l, c, h];
	}
	
	function lab2rgb(args) {
	  return xyz2rgb(lab2xyz(args));
	}
	
	function lch2lab(lch) {
	  var l = lch[0],
	      c = lch[1],
	      h = lch[2],
	      a, b, hr;
	
	  hr = h / 360 * 2 * Math.PI;
	  a = c * Math.cos(hr);
	  b = c * Math.sin(hr);
	  return [l, a, b];
	}
	
	function lch2xyz(args) {
	  return lab2xyz(lch2lab(args));
	}
	
	function lch2rgb(args) {
	  return lab2rgb(lch2lab(args));
	}
	
	function keyword2rgb(keyword) {
	  return cssKeywords[keyword];
	}
	
	function keyword2hsl(args) {
	  return rgb2hsl(keyword2rgb(args));
	}
	
	function keyword2hsv(args) {
	  return rgb2hsv(keyword2rgb(args));
	}
	
	function keyword2hwb(args) {
	  return rgb2hwb(keyword2rgb(args));
	}
	
	function keyword2cmyk(args) {
	  return rgb2cmyk(keyword2rgb(args));
	}
	
	function keyword2lab(args) {
	  return rgb2lab(keyword2rgb(args));
	}
	
	function keyword2xyz(args) {
	  return rgb2xyz(keyword2rgb(args));
	}
	
	var cssKeywords = {
	  aliceblue:  [240,248,255],
	  antiquewhite: [250,235,215],
	  aqua: [0,255,255],
	  aquamarine: [127,255,212],
	  azure:  [240,255,255],
	  beige:  [245,245,220],
	  bisque: [255,228,196],
	  black:  [0,0,0],
	  blanchedalmond: [255,235,205],
	  blue: [0,0,255],
	  blueviolet: [138,43,226],
	  brown:  [165,42,42],
	  burlywood:  [222,184,135],
	  cadetblue:  [95,158,160],
	  chartreuse: [127,255,0],
	  chocolate:  [210,105,30],
	  coral:  [255,127,80],
	  cornflowerblue: [100,149,237],
	  cornsilk: [255,248,220],
	  crimson:  [220,20,60],
	  cyan: [0,255,255],
	  darkblue: [0,0,139],
	  darkcyan: [0,139,139],
	  darkgoldenrod:  [184,134,11],
	  darkgray: [169,169,169],
	  darkgreen:  [0,100,0],
	  darkgrey: [169,169,169],
	  darkkhaki:  [189,183,107],
	  darkmagenta:  [139,0,139],
	  darkolivegreen: [85,107,47],
	  darkorange: [255,140,0],
	  darkorchid: [153,50,204],
	  darkred:  [139,0,0],
	  darksalmon: [233,150,122],
	  darkseagreen: [143,188,143],
	  darkslateblue:  [72,61,139],
	  darkslategray:  [47,79,79],
	  darkslategrey:  [47,79,79],
	  darkturquoise:  [0,206,209],
	  darkviolet: [148,0,211],
	  deeppink: [255,20,147],
	  deepskyblue:  [0,191,255],
	  dimgray:  [105,105,105],
	  dimgrey:  [105,105,105],
	  dodgerblue: [30,144,255],
	  firebrick:  [178,34,34],
	  floralwhite:  [255,250,240],
	  forestgreen:  [34,139,34],
	  fuchsia:  [255,0,255],
	  gainsboro:  [220,220,220],
	  ghostwhite: [248,248,255],
	  gold: [255,215,0],
	  goldenrod:  [218,165,32],
	  gray: [128,128,128],
	  green:  [0,128,0],
	  greenyellow:  [173,255,47],
	  grey: [128,128,128],
	  honeydew: [240,255,240],
	  hotpink:  [255,105,180],
	  indianred:  [205,92,92],
	  indigo: [75,0,130],
	  ivory:  [255,255,240],
	  khaki:  [240,230,140],
	  lavender: [230,230,250],
	  lavenderblush:  [255,240,245],
	  lawngreen:  [124,252,0],
	  lemonchiffon: [255,250,205],
	  lightblue:  [173,216,230],
	  lightcoral: [240,128,128],
	  lightcyan:  [224,255,255],
	  lightgoldenrodyellow: [250,250,210],
	  lightgray:  [211,211,211],
	  lightgreen: [144,238,144],
	  lightgrey:  [211,211,211],
	  lightpink:  [255,182,193],
	  lightsalmon:  [255,160,122],
	  lightseagreen:  [32,178,170],
	  lightskyblue: [135,206,250],
	  lightslategray: [119,136,153],
	  lightslategrey: [119,136,153],
	  lightsteelblue: [176,196,222],
	  lightyellow:  [255,255,224],
	  lime: [0,255,0],
	  limegreen:  [50,205,50],
	  linen:  [250,240,230],
	  magenta:  [255,0,255],
	  maroon: [128,0,0],
	  mediumaquamarine: [102,205,170],
	  mediumblue: [0,0,205],
	  mediumorchid: [186,85,211],
	  mediumpurple: [147,112,219],
	  mediumseagreen: [60,179,113],
	  mediumslateblue:  [123,104,238],
	  mediumspringgreen:  [0,250,154],
	  mediumturquoise:  [72,209,204],
	  mediumvioletred:  [199,21,133],
	  midnightblue: [25,25,112],
	  mintcream:  [245,255,250],
	  mistyrose:  [255,228,225],
	  moccasin: [255,228,181],
	  navajowhite:  [255,222,173],
	  navy: [0,0,128],
	  oldlace:  [253,245,230],
	  olive:  [128,128,0],
	  olivedrab:  [107,142,35],
	  orange: [255,165,0],
	  orangered:  [255,69,0],
	  orchid: [218,112,214],
	  palegoldenrod:  [238,232,170],
	  palegreen:  [152,251,152],
	  paleturquoise:  [175,238,238],
	  palevioletred:  [219,112,147],
	  papayawhip: [255,239,213],
	  peachpuff:  [255,218,185],
	  peru: [205,133,63],
	  pink: [255,192,203],
	  plum: [221,160,221],
	  powderblue: [176,224,230],
	  purple: [128,0,128],
	  rebeccapurple: [102, 51, 153],
	  red:  [255,0,0],
	  rosybrown:  [188,143,143],
	  royalblue:  [65,105,225],
	  saddlebrown:  [139,69,19],
	  salmon: [250,128,114],
	  sandybrown: [244,164,96],
	  seagreen: [46,139,87],
	  seashell: [255,245,238],
	  sienna: [160,82,45],
	  silver: [192,192,192],
	  skyblue:  [135,206,235],
	  slateblue:  [106,90,205],
	  slategray:  [112,128,144],
	  slategrey:  [112,128,144],
	  snow: [255,250,250],
	  springgreen:  [0,255,127],
	  steelblue:  [70,130,180],
	  tan:  [210,180,140],
	  teal: [0,128,128],
	  thistle:  [216,191,216],
	  tomato: [255,99,71],
	  turquoise:  [64,224,208],
	  violet: [238,130,238],
	  wheat:  [245,222,179],
	  white:  [255,255,255],
	  whitesmoke: [245,245,245],
	  yellow: [255,255,0],
	  yellowgreen:  [154,205,50]
	};
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
	  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
	}


/***/ },

/***/ "./node_modules/chartjs-color-string/color-string.js":
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__("./node_modules/color-name/index.js");
	
	module.exports = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	}
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3})$/i,
	       hex =  /^#([a-fA-F0-9]{6})$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr);
	   if (match) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	   }
	   else if (match = string.match(hex)) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorNames[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgb) {
	   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
	              + hexDouble(rgb[2]);
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorNames) {
	   reverseNames[colorNames[name]] = name;
	}


/***/ },

/***/ "./node_modules/color-name/index.js":
/***/ function(module, exports) {

	'use strict'
	
	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};


/***/ },

/***/ "./node_modules/chart.js/src/core/core.element.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var color = __webpack_require__("./node_modules/chartjs-color/index.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	function interpolate(start, view, model, ease) {
		var keys = Object.keys(model);
		var i, ilen, key, actual, origin, target, type, c0, c1;
	
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
	
			target = model[key];
	
			// if a value is added to the model after pivot() has been called, the view
			// doesn't contain it, so let's initialize the view to the target value.
			if (!view.hasOwnProperty(key)) {
				view[key] = target;
			}
	
			actual = view[key];
	
			if (actual === target || key[0] === '_') {
				continue;
			}
	
			if (!start.hasOwnProperty(key)) {
				start[key] = actual;
			}
	
			origin = start[key];
	
			type = typeof target;
	
			if (type === typeof origin) {
				if (type === 'string') {
					c0 = color(origin);
					if (c0.valid) {
						c1 = color(target);
						if (c1.valid) {
							view[key] = c1.mix(c0, ease).rgbString();
							continue;
						}
					}
				} else if (type === 'number' && isFinite(origin) && isFinite(target)) {
					view[key] = origin + (target - origin) * ease;
					continue;
				}
			}
	
			view[key] = target;
		}
	}
	
	var Element = function(configuration) {
		helpers.extend(this, configuration);
		this.initialize.apply(this, arguments);
	};
	
	helpers.extend(Element.prototype, {
	
		initialize: function() {
			this.hidden = false;
		},
	
		pivot: function() {
			var me = this;
			if (!me._view) {
				me._view = helpers.clone(me._model);
			}
			me._start = {};
			return me;
		},
	
		transition: function(ease) {
			var me = this;
			var model = me._model;
			var start = me._start;
			var view = me._view;
	
			// No animation -> No Transition
			if (!model || ease === 1) {
				me._view = model;
				me._start = null;
				return me;
			}
	
			if (!view) {
				view = me._view = {};
			}
	
			if (!start) {
				start = me._start = {};
			}
	
			interpolate(start, view, model, ease);
	
			return me;
		},
	
		tooltipPosition: function() {
			return {
				x: this._model.x,
				y: this._model.y
			};
		},
	
		hasValue: function() {
			return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
		}
	});
	
	Element.extend = helpers.inherits;
	
	module.exports = Element;


/***/ },

/***/ "./node_modules/chart.js/src/elements/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {};
	module.exports.Arc = __webpack_require__("./node_modules/chart.js/src/elements/element.arc.js");
	module.exports.Line = __webpack_require__("./node_modules/chart.js/src/elements/element.line.js");
	module.exports.Point = __webpack_require__("./node_modules/chart.js/src/elements/element.point.js");
	module.exports.Rectangle = __webpack_require__("./node_modules/chart.js/src/elements/element.rectangle.js");


/***/ },

/***/ "./node_modules/chart.js/src/elements/element.arc.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var Element = __webpack_require__("./node_modules/chart.js/src/core/core.element.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	defaults._set('global', {
		elements: {
			arc: {
				backgroundColor: defaults.global.defaultColor,
				borderColor: '#fff',
				borderWidth: 2
			}
		}
	});
	
	module.exports = Element.extend({
		inLabelRange: function(mouseX) {
			var vm = this._view;
	
			if (vm) {
				return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
			}
			return false;
		},
	
		inRange: function(chartX, chartY) {
			var vm = this._view;
	
			if (vm) {
				var pointRelativePosition = helpers.getAngleFromPoint(vm, {x: chartX, y: chartY});
				var	angle = pointRelativePosition.angle;
				var distance = pointRelativePosition.distance;
	
				// Sanitise angle range
				var startAngle = vm.startAngle;
				var endAngle = vm.endAngle;
				while (endAngle < startAngle) {
					endAngle += 2.0 * Math.PI;
				}
				while (angle > endAngle) {
					angle -= 2.0 * Math.PI;
				}
				while (angle < startAngle) {
					angle += 2.0 * Math.PI;
				}
	
				// Check if within the range of the open/close angle
				var betweenAngles = (angle >= startAngle && angle <= endAngle);
				var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
				return (betweenAngles && withinRadius);
			}
			return false;
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var halfAngle = (vm.startAngle + vm.endAngle) / 2;
			var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
			return {
				x: vm.x + Math.cos(halfAngle) * halfRadius,
				y: vm.y + Math.sin(halfAngle) * halfRadius
			};
		},
	
		getArea: function() {
			var vm = this._view;
			return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
			var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
	
			return {
				x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
				y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
			};
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var sA = vm.startAngle;
			var eA = vm.endAngle;
	
			ctx.beginPath();
	
			ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
			ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
	
			ctx.closePath();
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = vm.borderWidth;
	
			ctx.fillStyle = vm.backgroundColor;
	
			ctx.fill();
			ctx.lineJoin = 'bevel';
	
			if (vm.borderWidth) {
				ctx.stroke();
			}
		}
	});


/***/ },

/***/ "./node_modules/chart.js/src/elements/element.line.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var Element = __webpack_require__("./node_modules/chart.js/src/core/core.element.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	var globalDefaults = defaults.global;
	
	defaults._set('global', {
		elements: {
			line: {
				tension: 0.4,
				backgroundColor: globalDefaults.defaultColor,
				borderWidth: 3,
				borderColor: globalDefaults.defaultColor,
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				capBezierPoints: true,
				fill: true, // do we fill in the area between the line and its base axis
			}
		}
	});
	
	module.exports = Element.extend({
		draw: function() {
			var me = this;
			var vm = me._view;
			var ctx = me._chart.ctx;
			var spanGaps = vm.spanGaps;
			var points = me._children.slice(); // clone array
			var globalOptionLineElements = globalDefaults.elements.line;
			var lastDrawnIndex = -1;
			var index, current, previous, currentVM;
	
			// If we are looping, adding the first point again
			if (me._loop && points.length) {
				points.push(points[0]);
			}
	
			ctx.save();
	
			// Stroke Line Options
			ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
			// IE 9 and 10 do not support line dash
			if (ctx.setLineDash) {
				ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
			}
	
			ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
			ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
			ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
			ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
			// Stroke Line
			ctx.beginPath();
			lastDrawnIndex = -1;
	
			for (index = 0; index < points.length; ++index) {
				current = points[index];
				previous = helpers.previousItem(points, index);
				currentVM = current._view;
	
				// First point moves to it's starting position no matter what
				if (index === 0) {
					if (!currentVM.skip) {
						ctx.moveTo(currentVM.x, currentVM.y);
						lastDrawnIndex = index;
					}
				} else {
					previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
					if (!currentVM.skip) {
						if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
							// There was a gap and this is the first point after the gap
							ctx.moveTo(currentVM.x, currentVM.y);
						} else {
							// Line to next point
							helpers.canvas.lineTo(ctx, previous._view, current._view);
						}
						lastDrawnIndex = index;
					}
				}
			}
	
			ctx.stroke();
			ctx.restore();
		}
	});


/***/ },

/***/ "./node_modules/chart.js/src/elements/element.point.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var Element = __webpack_require__("./node_modules/chart.js/src/core/core.element.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	var defaultColor = defaults.global.defaultColor;
	
	defaults._set('global', {
		elements: {
			point: {
				radius: 3,
				pointStyle: 'circle',
				backgroundColor: defaultColor,
				borderColor: defaultColor,
				borderWidth: 1,
				// Hover
				hitRadius: 1,
				hoverRadius: 4,
				hoverBorderWidth: 1
			}
		}
	});
	
	function xRange(mouseX) {
		var vm = this._view;
		return vm ? (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
	}
	
	function yRange(mouseY) {
		var vm = this._view;
		return vm ? (Math.pow(mouseY - vm.y, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
	}
	
	module.exports = Element.extend({
		inRange: function(mouseX, mouseY) {
			var vm = this._view;
			return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
		},
	
		inLabelRange: xRange,
		inXRange: xRange,
		inYRange: yRange,
	
		getCenterPoint: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		},
	
		getArea: function() {
			return Math.PI * Math.pow(this._view.radius, 2);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y,
				padding: vm.radius + vm.borderWidth
			};
		},
	
		draw: function(chartArea) {
			var vm = this._view;
			var model = this._model;
			var ctx = this._chart.ctx;
			var pointStyle = vm.pointStyle;
			var radius = vm.radius;
			var x = vm.x;
			var y = vm.y;
			var color = helpers.color;
			var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)
			var ratio = 0;
	
			if (vm.skip) {
				return;
			}
	
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = helpers.valueOrDefault(vm.borderWidth, defaults.global.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
	
			// Cliping for Points.
			// going out from inner charArea?
			if ((chartArea !== undefined) && ((model.x < chartArea.left) || (chartArea.right * errMargin < model.x) || (model.y < chartArea.top) || (chartArea.bottom * errMargin < model.y))) {
				// Point fade out
				if (model.x < chartArea.left) {
					ratio = (x - model.x) / (chartArea.left - model.x);
				} else if (chartArea.right * errMargin < model.x) {
					ratio = (model.x - x) / (model.x - chartArea.right);
				} else if (model.y < chartArea.top) {
					ratio = (y - model.y) / (chartArea.top - model.y);
				} else if (chartArea.bottom * errMargin < model.y) {
					ratio = (model.y - y) / (model.y - chartArea.bottom);
				}
				ratio = Math.round(ratio * 100) / 100;
				ctx.strokeStyle = color(ctx.strokeStyle).alpha(ratio).rgbString();
				ctx.fillStyle = color(ctx.fillStyle).alpha(ratio).rgbString();
			}
	
			helpers.canvas.drawPoint(ctx, pointStyle, radius, x, y);
		}
	});


/***/ },

/***/ "./node_modules/chart.js/src/elements/element.rectangle.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var Element = __webpack_require__("./node_modules/chart.js/src/core/core.element.js");
	
	defaults._set('global', {
		elements: {
			rectangle: {
				backgroundColor: defaults.global.defaultColor,
				borderColor: defaults.global.defaultColor,
				borderSkipped: 'bottom',
				borderWidth: 0
			}
		}
	});
	
	function isVertical(bar) {
		return bar._view.width !== undefined;
	}
	
	/**
	 * Helper function to get the bounds of the bar regardless of the orientation
	 * @param bar {Chart.Element.Rectangle} the bar
	 * @return {Bounds} bounds of the bar
	 * @private
	 */
	function getBarBounds(bar) {
		var vm = bar._view;
		var x1, x2, y1, y2;
	
		if (isVertical(bar)) {
			// vertical
			var halfWidth = vm.width / 2;
			x1 = vm.x - halfWidth;
			x2 = vm.x + halfWidth;
			y1 = Math.min(vm.y, vm.base);
			y2 = Math.max(vm.y, vm.base);
		} else {
			// horizontal bar
			var halfHeight = vm.height / 2;
			x1 = Math.min(vm.x, vm.base);
			x2 = Math.max(vm.x, vm.base);
			y1 = vm.y - halfHeight;
			y2 = vm.y + halfHeight;
		}
	
		return {
			left: x1,
			top: y1,
			right: x2,
			bottom: y2
		};
	}
	
	module.exports = Element.extend({
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var left, right, top, bottom, signX, signY, borderSkipped;
			var borderWidth = vm.borderWidth;
	
			if (!vm.horizontal) {
				// bar
				left = vm.x - vm.width / 2;
				right = vm.x + vm.width / 2;
				top = vm.y;
				bottom = vm.base;
				signX = 1;
				signY = bottom > top ? 1 : -1;
				borderSkipped = vm.borderSkipped || 'bottom';
			} else {
				// horizontal bar
				left = vm.base;
				right = vm.x;
				top = vm.y - vm.height / 2;
				bottom = vm.y + vm.height / 2;
				signX = right > left ? 1 : -1;
				signY = 1;
				borderSkipped = vm.borderSkipped || 'left';
			}
	
			// Canvas doesn't allow us to stroke inside the width so we can
			// adjust the sizes to fit if we're setting a stroke on the line
			if (borderWidth) {
				// borderWidth shold be less than bar width and bar height.
				var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
				borderWidth = borderWidth > barSize ? barSize : borderWidth;
				var halfStroke = borderWidth / 2;
				// Adjust borderWidth when bar top position is near vm.base(zero).
				var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
				var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
				var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
				var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
				// not become a vertical line?
				if (borderLeft !== borderRight) {
					top = borderTop;
					bottom = borderBottom;
				}
				// not become a horizontal line?
				if (borderTop !== borderBottom) {
					left = borderLeft;
					right = borderRight;
				}
			}
	
			ctx.beginPath();
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = borderWidth;
	
			// Corner points, from bottom-left to bottom-right clockwise
			// | 1 2 |
			// | 0 3 |
			var corners = [
				[left, bottom],
				[left, top],
				[right, top],
				[right, bottom]
			];
	
			// Find first (starting) corner with fallback to 'bottom'
			var borders = ['bottom', 'left', 'top', 'right'];
			var startCorner = borders.indexOf(borderSkipped, 0);
			if (startCorner === -1) {
				startCorner = 0;
			}
	
			function cornerAt(index) {
				return corners[(startCorner + index) % 4];
			}
	
			// Draw rectangle from 'startCorner'
			var corner = cornerAt(0);
			ctx.moveTo(corner[0], corner[1]);
	
			for (var i = 1; i < 4; i++) {
				corner = cornerAt(i);
				ctx.lineTo(corner[0], corner[1]);
			}
	
			ctx.fill();
			if (borderWidth) {
				ctx.stroke();
			}
		},
	
		height: function() {
			var vm = this._view;
			return vm.base - vm.y;
		},
	
		inRange: function(mouseX, mouseY) {
			var inRange = false;
	
			if (this._view) {
				var bounds = getBarBounds(this);
				inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
			}
	
			return inRange;
		},
	
		inLabelRange: function(mouseX, mouseY) {
			var me = this;
			if (!me._view) {
				return false;
			}
	
			var inRange = false;
			var bounds = getBarBounds(me);
	
			if (isVertical(me)) {
				inRange = mouseX >= bounds.left && mouseX <= bounds.right;
			} else {
				inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
			}
	
			return inRange;
		},
	
		inXRange: function(mouseX) {
			var bounds = getBarBounds(this);
			return mouseX >= bounds.left && mouseX <= bounds.right;
		},
	
		inYRange: function(mouseY) {
			var bounds = getBarBounds(this);
			return mouseY >= bounds.top && mouseY <= bounds.bottom;
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var x, y;
			if (isVertical(this)) {
				x = vm.x;
				y = (vm.y + vm.base) / 2;
			} else {
				x = (vm.x + vm.base) / 2;
				y = vm.y;
			}
	
			return {x: x, y: y};
		},
	
		getArea: function() {
			var vm = this._view;
			return vm.width * Math.abs(vm.y - vm.base);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		}
	});


/***/ },

/***/ "./node_modules/chart.js/src/core/core.interaction.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	/**
	 * Helper function to get relative position for an event
	 * @param {Event|IEvent} event - The event to get the position for
	 * @param {Chart} chart - The chart
	 * @returns {Point} the event position
	 */
	function getRelativePosition(e, chart) {
		if (e.native) {
			return {
				x: e.x,
				y: e.y
			};
		}
	
		return helpers.getRelativePosition(e, chart);
	}
	
	/**
	 * Helper function to traverse all of the visible elements in the chart
	 * @param chart {chart} the chart
	 * @param handler {Function} the callback to execute for each visible item
	 */
	function parseVisibleItems(chart, handler) {
		var datasets = chart.data.datasets;
		var meta, i, j, ilen, jlen;
	
		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!chart.isDatasetVisible(i)) {
				continue;
			}
	
			meta = chart.getDatasetMeta(i);
			for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
				var element = meta.data[j];
				if (!element._view.skip) {
					handler(element);
				}
			}
		}
	}
	
	/**
	 * Helper function to get the items that intersect the event position
	 * @param items {ChartElement[]} elements to filter
	 * @param position {Point} the point to be nearest to
	 * @return {ChartElement[]} the nearest items
	 */
	function getIntersectItems(chart, position) {
		var elements = [];
	
		parseVisibleItems(chart, function(element) {
			if (element.inRange(position.x, position.y)) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * Helper function to get the items nearest to the event position considering all visible items in teh chart
	 * @param chart {Chart} the chart to look at elements from
	 * @param position {Point} the point to be nearest to
	 * @param intersect {Boolean} if true, only consider items that intersect the position
	 * @param distanceMetric {Function} function to provide the distance between points
	 * @return {ChartElement[]} the nearest items
	 */
	function getNearestItems(chart, position, intersect, distanceMetric) {
		var minDistance = Number.POSITIVE_INFINITY;
		var nearestItems = [];
	
		parseVisibleItems(chart, function(element) {
			if (intersect && !element.inRange(position.x, position.y)) {
				return;
			}
	
			var center = element.getCenterPoint();
			var distance = distanceMetric(position, center);
	
			if (distance < minDistance) {
				nearestItems = [element];
				minDistance = distance;
			} else if (distance === minDistance) {
				// Can have multiple items at the same distance in which case we sort by size
				nearestItems.push(element);
			}
		});
	
		return nearestItems;
	}
	
	/**
	 * Get a distance metric function for two points based on the
	 * axis mode setting
	 * @param {String} axis the axis mode. x|y|xy
	 */
	function getDistanceMetricForAxis(axis) {
		var useX = axis.indexOf('x') !== -1;
		var useY = axis.indexOf('y') !== -1;
	
		return function(pt1, pt2) {
			var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
			var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
			return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
		};
	}
	
	function indexMode(chart, e, options) {
		var position = getRelativePosition(e, chart);
		// Default axis for index mode is 'x' to match old behaviour
		options.axis = options.axis || 'x';
		var distanceMetric = getDistanceMetricForAxis(options.axis);
		var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
		var elements = [];
	
		if (!items.length) {
			return [];
		}
	
		chart.data.datasets.forEach(function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);
				var element = meta.data[items[0]._index];
	
				// don't count items that are skipped (null data)
				if (element && !element._view.skip) {
					elements.push(element);
				}
			}
		});
	
		return elements;
	}
	
	/**
	 * @interface IInteractionOptions
	 */
	/**
	 * If true, only consider items that intersect the point
	 * @name IInterfaceOptions#boolean
	 * @type Boolean
	 */
	
	/**
	 * Contains interaction related functions
	 * @namespace Chart.Interaction
	 */
	module.exports = {
		// Helper function for different modes
		modes: {
			single: function(chart, e) {
				var position = getRelativePosition(e, chart);
				var elements = [];
	
				parseVisibleItems(chart, function(element) {
					if (element.inRange(position.x, position.y)) {
						elements.push(element);
						return elements;
					}
				});
	
				return elements.slice(0, 1);
			},
	
			/**
			 * @function Chart.Interaction.modes.label
			 * @deprecated since version 2.4.0
			 * @todo remove at version 3
			 * @private
			 */
			label: indexMode,
	
			/**
			 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
			 * @function Chart.Interaction.modes.index
			 * @since v2.4.0
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			index: indexMode,
	
			/**
			 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect is false, we find the nearest item and return the items in that dataset
			 * @function Chart.Interaction.modes.dataset
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			dataset: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	
				if (items.length > 0) {
					items = chart.getDatasetMeta(items[0]._datasetIndex).data;
				}
	
				return items;
			},
	
			/**
			 * @function Chart.Interaction.modes.x-axis
			 * @deprecated since version 2.4.0. Use index mode and intersect == true
			 * @todo remove at version 3
			 * @private
			 */
			'x-axis': function(chart, e) {
				return indexMode(chart, e, {intersect: false});
			},
	
			/**
			 * Point mode returns all elements that hit test based on the event position
			 * of the event
			 * @function Chart.Interaction.modes.intersect
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			point: function(chart, e) {
				var position = getRelativePosition(e, chart);
				return getIntersectItems(chart, position);
			},
	
			/**
			 * nearest mode returns the element closest to the point
			 * @function Chart.Interaction.modes.intersect
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			nearest: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var nearestItems = getNearestItems(chart, position, options.intersect, distanceMetric);
	
				// We have multiple items at the same distance from the event. Now sort by smallest
				if (nearestItems.length > 1) {
					nearestItems.sort(function(a, b) {
						var sizeA = a.getArea();
						var sizeB = b.getArea();
						var ret = sizeA - sizeB;
	
						if (ret === 0) {
							// if equal sort by dataset index
							ret = a._datasetIndex - b._datasetIndex;
						}
	
						return ret;
					});
				}
	
				// Return only 1 item
				return nearestItems.slice(0, 1);
			},
	
			/**
			 * x mode returns the elements that hit-test at the current x coordinate
			 * @function Chart.Interaction.modes.x
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			x: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inXRange(position.x)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			},
	
			/**
			 * y mode returns the elements that hit-test at the current y coordinate
			 * @function Chart.Interaction.modes.y
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			y: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inYRange(position.y)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			}
		}
	};


/***/ },

/***/ "./node_modules/chart.js/src/platforms/platform.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	var basic = __webpack_require__("./node_modules/chart.js/src/platforms/platform.basic.js");
	var dom = __webpack_require__("./node_modules/chart.js/src/platforms/platform.dom.js");
	
	// @TODO Make possible to select another platform at build time.
	var implementation = dom._enabled ? dom : basic;
	
	/**
	 * @namespace Chart.platform
	 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
	 * @since 2.4.0
	 */
	module.exports = helpers.extend({
		/**
		 * @since 2.7.0
		 */
		initialize: function() {},
	
		/**
		 * Called at chart construction time, returns a context2d instance implementing
		 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
		 * @param {*} item - The native item from which to acquire context (platform specific)
		 * @param {Object} options - The chart options
		 * @returns {CanvasRenderingContext2D} context2d instance
		 */
		acquireContext: function() {},
	
		/**
		 * Called at chart destruction time, releases any resources associated to the context
		 * previously returned by the acquireContext() method.
		 * @param {CanvasRenderingContext2D} context - The context2d instance
		 * @returns {Boolean} true if the method succeeded, else false
		 */
		releaseContext: function() {},
	
		/**
		 * Registers the specified listener on the given chart.
		 * @param {Chart} chart - Chart from which to listen for event
		 * @param {String} type - The ({@link IEvent}) type to listen for
		 * @param {Function} listener - Receives a notification (an object that implements
		 * the {@link IEvent} interface) when an event of the specified type occurs.
		 */
		addEventListener: function() {},
	
		/**
		 * Removes the specified listener previously registered with addEventListener.
		 * @param {Chart} chart -Chart from which to remove the listener
		 * @param {String} type - The ({@link IEvent}) type to remove
		 * @param {Function} listener - The listener function to remove from the event target.
		 */
		removeEventListener: function() {}
	
	}, implementation);
	
	/**
	 * @interface IPlatform
	 * Allows abstracting platform dependencies away from the chart
	 * @borrows Chart.platform.acquireContext as acquireContext
	 * @borrows Chart.platform.releaseContext as releaseContext
	 * @borrows Chart.platform.addEventListener as addEventListener
	 * @borrows Chart.platform.removeEventListener as removeEventListener
	 */
	
	/**
	 * @interface IEvent
	 * @prop {String} type - The event type name, possible values are:
	 * 'contextmenu', 'mouseenter', 'mousedown', 'mousemove', 'mouseup', 'mouseout',
	 * 'click', 'dblclick', 'keydown', 'keypress', 'keyup' and 'resize'
	 * @prop {*} native - The original native event (null for emulated events, e.g. 'resize')
	 * @prop {Number} x - The mouse x position, relative to the canvas (null for incompatible events)
	 * @prop {Number} y - The mouse y position, relative to the canvas (null for incompatible events)
	 */


/***/ },

/***/ "./node_modules/chart.js/src/platforms/platform.basic.js":
/***/ function(module, exports) {

	/**
	 * Platform fallback implementation (minimal).
	 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
	 */
	
	module.exports = {
		acquireContext: function(item) {
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			return item && item.getContext('2d') || null;
		}
	};


/***/ },

/***/ "./node_modules/chart.js/src/platforms/platform.dom.js":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Chart.Platform implementation for targeting a web browser
	 */
	
	'use strict';
	
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	var EXPANDO_KEY = '$chartjs';
	var CSS_PREFIX = 'chartjs-';
	var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
	var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
	var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];
	
	/**
	 * DOM event types -> Chart.js event types.
	 * Note: only events with different types are mapped.
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events
	 */
	var EVENT_TYPES = {
		touchstart: 'mousedown',
		touchmove: 'mousemove',
		touchend: 'mouseup',
		pointerenter: 'mouseenter',
		pointerdown: 'mousedown',
		pointermove: 'mousemove',
		pointerup: 'mouseup',
		pointerleave: 'mouseout',
		pointerout: 'mouseout'
	};
	
	/**
	 * The "used" size is the final value of a dimension property after all calculations have
	 * been performed. This method uses the computed style of `element` but returns undefined
	 * if the computed style is not expressed in pixels. That can happen in some cases where
	 * `element` has a size relative to its parent and this last one is not yet displayed,
	 * for example because of `display: none` on a parent node.
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
	 * @returns {Number} Size in pixels or undefined if unknown.
	 */
	function readUsedSize(element, property) {
		var value = helpers.getStyle(element, property);
		var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
		return matches ? Number(matches[1]) : undefined;
	}
	
	/**
	 * Initializes the canvas style and render size without modifying the canvas display size,
	 * since responsiveness is handled by the controller.resize() method. The config is used
	 * to determine the aspect ratio to apply in case no explicit height has been specified.
	 */
	function initCanvas(canvas, config) {
		var style = canvas.style;
	
		// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
		// returns null or '' if no explicit value has been set to the canvas attribute.
		var renderHeight = canvas.getAttribute('height');
		var renderWidth = canvas.getAttribute('width');
	
		// Chart.js modifies some canvas values that we want to restore on destroy
		canvas[EXPANDO_KEY] = {
			initial: {
				height: renderHeight,
				width: renderWidth,
				style: {
					display: style.display,
					height: style.height,
					width: style.width
				}
			}
		};
	
		// Force canvas to display as block to avoid extra space caused by inline
		// elements, which would interfere with the responsive resize process.
		// https://github.com/chartjs/Chart.js/issues/2538
		style.display = style.display || 'block';
	
		if (renderWidth === null || renderWidth === '') {
			var displayWidth = readUsedSize(canvas, 'width');
			if (displayWidth !== undefined) {
				canvas.width = displayWidth;
			}
		}
	
		if (renderHeight === null || renderHeight === '') {
			if (canvas.style.height === '') {
				// If no explicit render height and style height, let's apply the aspect ratio,
				// which one can be specified by the user but also by charts as default option
				// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
				canvas.height = canvas.width / (config.options.aspectRatio || 2);
			} else {
				var displayHeight = readUsedSize(canvas, 'height');
				if (displayWidth !== undefined) {
					canvas.height = displayHeight;
				}
			}
		}
	
		return canvas;
	}
	
	/**
	 * Detects support for options object argument in addEventListener.
	 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
	 * @private
	 */
	var supportsEventListenerOptions = (function() {
		var supports = false;
		try {
			var options = Object.defineProperty({}, 'passive', {
				get: function() {
					supports = true;
				}
			});
			window.addEventListener('e', null, options);
		} catch (e) {
			// continue regardless of error
		}
		return supports;
	}());
	
	// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
	// https://github.com/chartjs/Chart.js/issues/4287
	var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;
	
	function addEventListener(node, type, listener) {
		node.addEventListener(type, listener, eventListenerOptions);
	}
	
	function removeEventListener(node, type, listener) {
		node.removeEventListener(type, listener, eventListenerOptions);
	}
	
	function createEvent(type, chart, x, y, nativeEvent) {
		return {
			type: type,
			chart: chart,
			native: nativeEvent || null,
			x: x !== undefined ? x : null,
			y: y !== undefined ? y : null,
		};
	}
	
	function fromNativeEvent(event, chart) {
		var type = EVENT_TYPES[event.type] || event.type;
		var pos = helpers.getRelativePosition(event, chart);
		return createEvent(type, chart, pos.x, pos.y, event);
	}
	
	function throttled(fn, thisArg) {
		var ticking = false;
		var args = [];
	
		return function() {
			args = Array.prototype.slice.call(arguments);
			thisArg = thisArg || this;
	
			if (!ticking) {
				ticking = true;
				helpers.requestAnimFrame.call(window, function() {
					ticking = false;
					fn.apply(thisArg, args);
				});
			}
		};
	}
	
	// Implementation based on https://github.com/marcj/css-element-queries
	function createResizer(handler) {
		var resizer = document.createElement('div');
		var cls = CSS_PREFIX + 'size-monitor';
		var maxSize = 1000000;
		var style =
			'position:absolute;' +
			'left:0;' +
			'top:0;' +
			'right:0;' +
			'bottom:0;' +
			'overflow:hidden;' +
			'pointer-events:none;' +
			'visibility:hidden;' +
			'z-index:-1;';
	
		resizer.style.cssText = style;
		resizer.className = cls;
		resizer.innerHTML =
			'<div class="' + cls + '-expand" style="' + style + '">' +
				'<div style="' +
					'position:absolute;' +
					'width:' + maxSize + 'px;' +
					'height:' + maxSize + 'px;' +
					'left:0;' +
					'top:0">' +
				'</div>' +
			'</div>' +
			'<div class="' + cls + '-shrink" style="' + style + '">' +
				'<div style="' +
					'position:absolute;' +
					'width:200%;' +
					'height:200%;' +
					'left:0; ' +
					'top:0">' +
				'</div>' +
			'</div>';
	
		var expand = resizer.childNodes[0];
		var shrink = resizer.childNodes[1];
	
		resizer._reset = function() {
			expand.scrollLeft = maxSize;
			expand.scrollTop = maxSize;
			shrink.scrollLeft = maxSize;
			shrink.scrollTop = maxSize;
		};
		var onScroll = function() {
			resizer._reset();
			handler();
		};
	
		addEventListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
		addEventListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
	
		return resizer;
	}
	
	// https://davidwalsh.name/detect-node-insertion
	function watchForRender(node, handler) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
		var proxy = expando.renderProxy = function(e) {
			if (e.animationName === CSS_RENDER_ANIMATION) {
				handler();
			}
		};
	
		helpers.each(ANIMATION_START_EVENTS, function(type) {
			addEventListener(node, type, proxy);
		});
	
		// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
		// is removed then added back immediately (same animation frame?). Accessing the
		// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
		// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
		// https://github.com/chartjs/Chart.js/issues/4737
		expando.reflow = !!node.offsetParent;
	
		node.classList.add(CSS_RENDER_MONITOR);
	}
	
	function unwatchForRender(node) {
		var expando = node[EXPANDO_KEY] || {};
		var proxy = expando.renderProxy;
	
		if (proxy) {
			helpers.each(ANIMATION_START_EVENTS, function(type) {
				removeEventListener(node, type, proxy);
			});
	
			delete expando.renderProxy;
		}
	
		node.classList.remove(CSS_RENDER_MONITOR);
	}
	
	function addResizeListener(node, listener, chart) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	
		// Let's keep track of this added resizer and thus avoid DOM query when removing it.
		var resizer = expando.resizer = createResizer(throttled(function() {
			if (expando.resizer) {
				return listener(createEvent('resize', chart));
			}
		}));
	
		// The resizer needs to be attached to the node parent, so we first need to be
		// sure that `node` is attached to the DOM before injecting the resizer element.
		watchForRender(node, function() {
			if (expando.resizer) {
				var container = node.parentNode;
				if (container && container !== resizer.parentNode) {
					container.insertBefore(resizer, container.firstChild);
				}
	
				// The container size might have changed, let's reset the resizer state.
				resizer._reset();
			}
		});
	}
	
	function removeResizeListener(node) {
		var expando = node[EXPANDO_KEY] || {};
		var resizer = expando.resizer;
	
		delete expando.resizer;
		unwatchForRender(node);
	
		if (resizer && resizer.parentNode) {
			resizer.parentNode.removeChild(resizer);
		}
	}
	
	function injectCSS(platform, css) {
		// http://stackoverflow.com/q/3922139
		var style = platform._style || document.createElement('style');
		if (!platform._style) {
			platform._style = style;
			css = '/* Chart.js */\n' + css;
			style.setAttribute('type', 'text/css');
			document.getElementsByTagName('head')[0].appendChild(style);
		}
	
		style.appendChild(document.createTextNode(css));
	}
	
	module.exports = {
		/**
		 * This property holds whether this platform is enabled for the current environment.
		 * Currently used by platform.js to select the proper implementation.
		 * @private
		 */
		_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
	
		initialize: function() {
			var keyframes = 'from{opacity:0.99}to{opacity:1}';
	
			injectCSS(this,
				// DOM rendering detection
				// https://davidwalsh.name/detect-node-insertion
				'@-webkit-keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
				'@keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
				'.' + CSS_RENDER_MONITOR + '{' +
					'-webkit-animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
					'animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
				'}'
			);
		},
	
		acquireContext: function(item, config) {
			if (typeof item === 'string') {
				item = document.getElementById(item);
			} else if (item.length) {
				// Support for array based queries (such as jQuery)
				item = item[0];
			}
	
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			// To prevent canvas fingerprinting, some add-ons undefine the getContext
			// method, for example: https://github.com/kkapsner/CanvasBlocker
			// https://github.com/chartjs/Chart.js/issues/2807
			var context = item && item.getContext && item.getContext('2d');
	
			// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
			// inside an iframe or when running in a protected environment. We could guess the
			// types from their toString() value but let's keep things flexible and assume it's
			// a sufficient condition if the item has a context2D which has item as `canvas`.
			// https://github.com/chartjs/Chart.js/issues/3887
			// https://github.com/chartjs/Chart.js/issues/4102
			// https://github.com/chartjs/Chart.js/issues/4152
			if (context && context.canvas === item) {
				initCanvas(item, config);
				return context;
			}
	
			return null;
		},
	
		releaseContext: function(context) {
			var canvas = context.canvas;
			if (!canvas[EXPANDO_KEY]) {
				return;
			}
	
			var initial = canvas[EXPANDO_KEY].initial;
			['height', 'width'].forEach(function(prop) {
				var value = initial[prop];
				if (helpers.isNullOrUndef(value)) {
					canvas.removeAttribute(prop);
				} else {
					canvas.setAttribute(prop, value);
				}
			});
	
			helpers.each(initial.style || {}, function(value, key) {
				canvas.style[key] = value;
			});
	
			// The canvas render size might have been changed (and thus the state stack discarded),
			// we can't use save() and restore() to restore the initial state. So make sure that at
			// least the canvas context is reset to the default state by setting the canvas width.
			// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
			canvas.width = canvas.width;
	
			delete canvas[EXPANDO_KEY];
		},
	
		addEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				addResizeListener(canvas, listener, chart);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
			var proxies = expando.proxies || (expando.proxies = {});
			var proxy = proxies[chart.id + '_' + type] = function(event) {
				listener(fromNativeEvent(event, chart));
			};
	
			addEventListener(canvas, type, proxy);
		},
	
		removeEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				removeResizeListener(canvas, listener);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || {};
			var proxies = expando.proxies || {};
			var proxy = proxies[chart.id + '_' + type];
			if (!proxy) {
				return;
			}
	
			removeEventListener(canvas, type, proxy);
		}
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use EventTarget.addEventListener instead.
	 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
	 * @function Chart.helpers.addEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.addEvent = addEventListener;
	
	/**
	 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
	 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
	 * @function Chart.helpers.removeEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.removeEvent = removeEventListener;


/***/ },

/***/ "./node_modules/chart.js/src/core/core.plugin.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var Element = __webpack_require__("./node_modules/chart.js/src/core/core.element.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	defaults._set('global', {
		plugins: {}
	});
	
	module.exports = function(Chart) {
	
		/**
		 * The plugin service singleton
		 * @namespace Chart.plugins
		 * @since 2.1.0
		 */
		Chart.plugins = {
			/**
			 * Globally registered plugins.
			 * @private
			 */
			_plugins: [],
	
			/**
			 * This identifier is used to invalidate the descriptors cache attached to each chart
			 * when a global plugin is registered or unregistered. In this case, the cache ID is
			 * incremented and descriptors are regenerated during following API calls.
			 * @private
			 */
			_cacheId: 0,
	
			/**
			 * Registers the given plugin(s) if not already registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			register: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					if (p.indexOf(plugin) === -1) {
						p.push(plugin);
					}
				});
	
				this._cacheId++;
			},
	
			/**
			 * Unregisters the given plugin(s) only if registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			unregister: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					var idx = p.indexOf(plugin);
					if (idx !== -1) {
						p.splice(idx, 1);
					}
				});
	
				this._cacheId++;
			},
	
			/**
			 * Remove all registered plugins.
			 * @since 2.1.5
			 */
			clear: function() {
				this._plugins = [];
				this._cacheId++;
			},
	
			/**
			 * Returns the number of registered plugins?
			 * @returns {Number}
			 * @since 2.1.5
			 */
			count: function() {
				return this._plugins.length;
			},
	
			/**
			 * Returns all registered plugin instances.
			 * @returns {Array} array of plugin objects.
			 * @since 2.1.5
			 */
			getAll: function() {
				return this._plugins;
			},
	
			/**
			 * Calls enabled plugins for `chart` on the specified hook and with the given args.
			 * This method immediately returns as soon as a plugin explicitly returns false. The
			 * returned value can be used, for instance, to interrupt the current action.
			 * @param {Object} chart - The chart instance for which plugins should be called.
			 * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
			 * @param {Array} [args] - Extra arguments to apply to the hook call.
			 * @returns {Boolean} false if any of the plugins return false, else returns true.
			 */
			notify: function(chart, hook, args) {
				var descriptors = this.descriptors(chart);
				var ilen = descriptors.length;
				var i, descriptor, plugin, params, method;
	
				for (i = 0; i < ilen; ++i) {
					descriptor = descriptors[i];
					plugin = descriptor.plugin;
					method = plugin[hook];
					if (typeof method === 'function') {
						params = [chart].concat(args || []);
						params.push(descriptor.options);
						if (method.apply(plugin, params) === false) {
							return false;
						}
					}
				}
	
				return true;
			},
	
			/**
			 * Returns descriptors of enabled plugins for the given chart.
			 * @returns {Array} [{ plugin, options }]
			 * @private
			 */
			descriptors: function(chart) {
				var cache = chart._plugins || (chart._plugins = {});
				if (cache.id === this._cacheId) {
					return cache.descriptors;
				}
	
				var plugins = [];
				var descriptors = [];
				var config = (chart && chart.config) || {};
				var options = (config.options && config.options.plugins) || {};
	
				this._plugins.concat(config.plugins || []).forEach(function(plugin) {
					var idx = plugins.indexOf(plugin);
					if (idx !== -1) {
						return;
					}
	
					var id = plugin.id;
					var opts = options[id];
					if (opts === false) {
						return;
					}
	
					if (opts === true) {
						opts = helpers.clone(defaults.global.plugins[id]);
					}
	
					plugins.push(plugin);
					descriptors.push({
						plugin: plugin,
						options: opts || {}
					});
				});
	
				cache.descriptors = descriptors;
				cache.id = this._cacheId;
				return descriptors;
			}
		};
	
		/**
		 * Plugin extension hooks.
		 * @interface IPlugin
		 * @since 2.1.0
		 */
		/**
		 * @method IPlugin#beforeInit
		 * @desc Called before initializing `chart`.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#afterInit
		 * @desc Called after `chart` has been initialized and before the first update.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeUpdate
		 * @desc Called before updating `chart`. If any plugin returns `false`, the update
		 * is cancelled (and thus subsequent render(s)) until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart update.
		 */
		/**
		 * @method IPlugin#afterUpdate
		 * @desc Called after `chart` has been updated and before rendering. Note that this
		 * hook will not be called if the chart update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetsUpdate
	 	 * @desc Called before updating the `chart` datasets. If any plugin returns `false`,
		 * the datasets update is cancelled until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} false to cancel the datasets update.
		 * @since version 2.1.5
		 */
		/**
		 * @method IPlugin#afterDatasetsUpdate
		 * @desc Called after the `chart` datasets have been updated. Note that this hook
		 * will not be called if the datasets update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @since version 2.1.5
		 */
		/**
		 * @method IPlugin#beforeDatasetUpdate
	 	 * @desc Called before updating the `chart` dataset at the given `args.index`. If any plugin
		 * returns `false`, the datasets update is cancelled until another `update` is triggered.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Number} args.index - The dataset index.
		 * @param {Object} args.meta - The dataset metadata.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart datasets drawing.
		 */
		/**
		 * @method IPlugin#afterDatasetUpdate
	 	 * @desc Called after the `chart` datasets at the given `args.index` has been updated. Note
		 * that this hook will not be called if the datasets update has been previously cancelled.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Number} args.index - The dataset index.
		 * @param {Object} args.meta - The dataset metadata.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeLayout
		 * @desc Called before laying out `chart`. If any plugin returns `false`,
		 * the layout update is cancelled until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart layout.
		 */
		/**
		 * @method IPlugin#afterLayout
		 * @desc Called after the `chart` has been layed out. Note that this hook will not
		 * be called if the layout update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeRender
		 * @desc Called before rendering `chart`. If any plugin returns `false`,
		 * the rendering is cancelled until another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart rendering.
		 */
		/**
		 * @method IPlugin#afterRender
		 * @desc Called after the `chart` has been fully rendered (and animation completed). Note
		 * that this hook will not be called if the rendering has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDraw
		 * @desc Called before drawing `chart` at every animation frame specified by the given
		 * easing value. If any plugin returns `false`, the frame drawing is cancelled until
		 * another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart drawing.
		 */
		/**
		 * @method IPlugin#afterDraw
		 * @desc Called after the `chart` has been drawn for the specific easing value. Note
		 * that this hook will not be called if the drawing has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetsDraw
	 	 * @desc Called before drawing the `chart` datasets. If any plugin returns `false`,
		 * the datasets drawing is cancelled until another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart datasets drawing.
		 */
		/**
		 * @method IPlugin#afterDatasetsDraw
		 * @desc Called after the `chart` datasets have been drawn. Note that this hook
		 * will not be called if the datasets drawing has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetDraw
	 	 * @desc Called before drawing the `chart` dataset at the given `args.index` (datasets
		 * are drawn in the reverse order). If any plugin returns `false`, the datasets drawing
		 * is cancelled until another `render` is triggered.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Number} args.index - The dataset index.
		 * @param {Object} args.meta - The dataset metadata.
		 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart datasets drawing.
		 */
		/**
		 * @method IPlugin#afterDatasetDraw
	 	 * @desc Called after the `chart` datasets at the given `args.index` have been drawn
		 * (datasets are drawn in the reverse order). Note that this hook will not be called
		 * if the datasets drawing has been previously cancelled.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Number} args.index - The dataset index.
		 * @param {Object} args.meta - The dataset metadata.
		 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
	  	 * @method IPlugin#beforeTooltipDraw
		 * @desc Called before drawing the `tooltip`. If any plugin returns `false`,
		 * the tooltip drawing is cancelled until another `render` is triggered.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Object} args.tooltip - The tooltip.
		 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart tooltip drawing.
	  	 */
		/**
	 	 * @method IPlugin#afterTooltipDraw
	  	 * @desc Called after drawing the `tooltip`. Note that this hook will not
	 	 * be called if the tooltip drawing has been previously cancelled.
	 	 * @param {Chart} chart - The chart instance.
	 	 * @param {Object} args - The call arguments.
	 	 * @param {Object} args.tooltip - The tooltip.
		 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
	 	 * @param {Object} options - The plugin options.
	 	 */
		/**
		 * @method IPlugin#beforeEvent
	 	 * @desc Called before processing the specified `event`. If any plugin returns `false`,
		 * the event will be discarded.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {IEvent} event - The event object.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#afterEvent
		 * @desc Called after the `event` has been consumed. Note that this hook
		 * will not be called if the `event` has been previously discarded.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {IEvent} event - The event object.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#resize
		 * @desc Called after the chart as been resized.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} size - The new canvas display size (eq. canvas.style width & height).
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#destroy
		 * @desc Called after the chart as been destroyed.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
	
		/**
		 * Provided for backward compatibility, use Chart.plugins instead
		 * @namespace Chart.pluginService
		 * @deprecated since version 2.1.5
		 * @todo remove at version 3
		 * @private
		 */
		Chart.pluginService = Chart.plugins;
	
		/**
		 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
		 * effect, instead simply create/register plugins via plain JavaScript objects.
		 * @interface Chart.PluginBase
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		Chart.PluginBase = Element.extend({});
	};


/***/ },

/***/ "./node_modules/chart.js/src/core/core.animation.js":
/***/ function(module, exports, __webpack_require__) {

	/* global window: false */
	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var Element = __webpack_require__("./node_modules/chart.js/src/core/core.element.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	defaults._set('global', {
		animation: {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers.noop,
			onComplete: helpers.noop
		}
	});
	
	module.exports = function(Chart) {
	
		Chart.Animation = Element.extend({
			chart: null, // the animation associated chart instance
			currentStep: 0, // the current animation step
			numSteps: 60, // default number of steps
			easing: '', // the easing to use for this animation
			render: null, // render function used by the animation service
	
			onAnimationProgress: null, // user specified callback to fire on each step of the animation
			onAnimationComplete: null, // user specified callback to fire when the animation finishes
		});
	
		Chart.animationService = {
			frameDuration: 17,
			animations: [],
			dropFrames: 0,
			request: null,
	
			/**
			 * @param {Chart} chart - The chart to animate.
			 * @param {Chart.Animation} animation - The animation that we will animate.
			 * @param {Number} duration - The animation duration in ms.
			 * @param {Boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
			 */
			addAnimation: function(chart, animation, duration, lazy) {
				var animations = this.animations;
				var i, ilen;
	
				animation.chart = chart;
	
				if (!lazy) {
					chart.animating = true;
				}
	
				for (i = 0, ilen = animations.length; i < ilen; ++i) {
					if (animations[i].chart === chart) {
						animations[i] = animation;
						return;
					}
				}
	
				animations.push(animation);
	
				// If there are no animations queued, manually kickstart a digest, for lack of a better word
				if (animations.length === 1) {
					this.requestAnimationFrame();
				}
			},
	
			cancelAnimation: function(chart) {
				var index = helpers.findIndex(this.animations, function(animation) {
					return animation.chart === chart;
				});
	
				if (index !== -1) {
					this.animations.splice(index, 1);
					chart.animating = false;
				}
			},
	
			requestAnimationFrame: function() {
				var me = this;
				if (me.request === null) {
					// Skip animation frame requests until the active one is executed.
					// This can happen when processing mouse events, e.g. 'mousemove'
					// and 'mouseout' events will trigger multiple renders.
					me.request = helpers.requestAnimFrame.call(window, function() {
						me.request = null;
						me.startDigest();
					});
				}
			},
	
			/**
			 * @private
			 */
			startDigest: function() {
				var me = this;
				var startTime = Date.now();
				var framesToDrop = 0;
	
				if (me.dropFrames > 1) {
					framesToDrop = Math.floor(me.dropFrames);
					me.dropFrames = me.dropFrames % 1;
				}
	
				me.advance(1 + framesToDrop);
	
				var endTime = Date.now();
	
				me.dropFrames += (endTime - startTime) / me.frameDuration;
	
				// Do we have more stuff to animate?
				if (me.animations.length > 0) {
					me.requestAnimationFrame();
				}
			},
	
			/**
			 * @private
			 */
			advance: function(count) {
				var animations = this.animations;
				var animation, chart;
				var i = 0;
	
				while (i < animations.length) {
					animation = animations[i];
					chart = animation.chart;
	
					animation.currentStep = (animation.currentStep || 0) + count;
					animation.currentStep = Math.min(animation.currentStep, animation.numSteps);
	
					helpers.callback(animation.render, [chart, animation], chart);
					helpers.callback(animation.onAnimationProgress, [animation], chart);
	
					if (animation.currentStep >= animation.numSteps) {
						helpers.callback(animation.onAnimationComplete, [animation], chart);
						chart.animating = false;
						animations.splice(i, 1);
					} else {
						++i;
					}
				}
			}
		};
	
		/**
		 * Provided for backward compatibility, use Chart.Animation instead
		 * @prop Chart.Animation#animationObject
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 */
		Object.defineProperty(Chart.Animation.prototype, 'animationObject', {
			get: function() {
				return this;
			}
		});
	
		/**
		 * Provided for backward compatibility, use Chart.Animation#chart instead
		 * @prop Chart.Animation#chartInstance
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 */
		Object.defineProperty(Chart.Animation.prototype, 'chartInstance', {
			get: function() {
				return this.chart;
			},
			set: function(value) {
				this.chart = value;
			}
		});
	
	};


/***/ },

/***/ "./node_modules/chart.js/src/core/core.controller.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	var Interaction = __webpack_require__("./node_modules/chart.js/src/core/core.interaction.js");
	var platform = __webpack_require__("./node_modules/chart.js/src/platforms/platform.js");
	
	module.exports = function(Chart) {
		var plugins = Chart.plugins;
	
		// Create a dictionary of chart types, to allow for extension of existing types
		Chart.types = {};
	
		// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
		// Destroy method on the chart will remove the instance of the chart from this reference.
		Chart.instances = {};
	
		// Controllers available for dataset visualization eg. bar, line, slice, etc.
		Chart.controllers = {};
	
		/**
		 * Initializes the given config with global and chart default values.
		 */
		function initConfig(config) {
			config = config || {};
	
			// Do NOT use configMerge() for the data object because this method merges arrays
			// and so would change references to labels and datasets, preventing data updates.
			var data = config.data = config.data || {};
			data.datasets = data.datasets || [];
			data.labels = data.labels || [];
	
			config.options = helpers.configMerge(
				defaults.global,
				defaults[config.type],
				config.options || {});
	
			return config;
		}
	
		/**
		 * Updates the config of the chart
		 * @param chart {Chart} chart to update the options for
		 */
		function updateConfig(chart) {
			var newOptions = chart.options;
	
			// Update Scale(s) with options
			if (newOptions.scale) {
				chart.scale.options = newOptions.scale;
			} else if (newOptions.scales) {
				newOptions.scales.xAxes.concat(newOptions.scales.yAxes).forEach(function(scaleOptions) {
					chart.scales[scaleOptions.id].options = scaleOptions;
				});
			}
	
			// Tooltip
			chart.tooltip._options = newOptions.tooltips;
		}
	
		function positionIsHorizontal(position) {
			return position === 'top' || position === 'bottom';
		}
	
		helpers.extend(Chart.prototype, /** @lends Chart */ {
			/**
			 * @private
			 */
			construct: function(item, config) {
				var me = this;
	
				config = initConfig(config);
	
				var context = platform.acquireContext(item, config);
				var canvas = context && context.canvas;
				var height = canvas && canvas.height;
				var width = canvas && canvas.width;
	
				me.id = helpers.uid();
				me.ctx = context;
				me.canvas = canvas;
				me.config = config;
				me.width = width;
				me.height = height;
				me.aspectRatio = height ? width / height : null;
				me.options = config.options;
				me._bufferedRender = false;
	
				/**
				 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
				 * the "instance" still need to be defined since it might be called from plugins.
				 * @prop Chart#chart
				 * @deprecated since version 2.6.0
				 * @todo remove at version 3
				 * @private
				 */
				me.chart = me;
				me.controller = me; // chart.chart.controller #inception
	
				// Add the chart instance to the global namespace
				Chart.instances[me.id] = me;
	
				// Define alias to the config data: `chart.data === chart.config.data`
				Object.defineProperty(me, 'data', {
					get: function() {
						return me.config.data;
					},
					set: function(value) {
						me.config.data = value;
					}
				});
	
				if (!context || !canvas) {
					// The given item is not a compatible context2d element, let's return before finalizing
					// the chart initialization but after setting basic chart / controller properties that
					// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
					// https://github.com/chartjs/Chart.js/issues/2807
					console.error("Failed to create chart: can't acquire context from the given item");
					return;
				}
	
				me.initialize();
				me.update();
			},
	
			/**
			 * @private
			 */
			initialize: function() {
				var me = this;
	
				// Before init plugin notification
				plugins.notify(me, 'beforeInit');
	
				helpers.retinaScale(me, me.options.devicePixelRatio);
	
				me.bindEvents();
	
				if (me.options.responsive) {
					// Initial resize before chart draws (must be silent to preserve initial animations).
					me.resize(true);
				}
	
				// Make sure scales have IDs and are built before we build any controllers.
				me.ensureScalesHaveIDs();
				me.buildScales();
				me.initToolTip();
	
				// After init plugin notification
				plugins.notify(me, 'afterInit');
	
				return me;
			},
	
			clear: function() {
				helpers.canvas.clear(this);
				return this;
			},
	
			stop: function() {
				// Stops any current animation loop occurring
				Chart.animationService.cancelAnimation(this);
				return this;
			},
	
			resize: function(silent) {
				var me = this;
				var options = me.options;
				var canvas = me.canvas;
				var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;
	
				// the canvas render width and height will be casted to integers so make sure that
				// the canvas display style uses the same integer values to avoid blurring effect.
	
				// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collased
				var newWidth = Math.max(0, Math.floor(helpers.getMaximumWidth(canvas)));
				var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers.getMaximumHeight(canvas)));
	
				if (me.width === newWidth && me.height === newHeight) {
					return;
				}
	
				canvas.width = me.width = newWidth;
				canvas.height = me.height = newHeight;
				canvas.style.width = newWidth + 'px';
				canvas.style.height = newHeight + 'px';
	
				helpers.retinaScale(me, options.devicePixelRatio);
	
				if (!silent) {
					// Notify any plugins about the resize
					var newSize = {width: newWidth, height: newHeight};
					plugins.notify(me, 'resize', [newSize]);
	
					// Notify of resize
					if (me.options.onResize) {
						me.options.onResize(me, newSize);
					}
	
					me.stop();
					me.update(me.options.responsiveAnimationDuration);
				}
			},
	
			ensureScalesHaveIDs: function() {
				var options = this.options;
				var scalesOptions = options.scales || {};
				var scaleOptions = options.scale;
	
				helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
					xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
				});
	
				helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
					yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
				});
	
				if (scaleOptions) {
					scaleOptions.id = scaleOptions.id || 'scale';
				}
			},
	
			/**
			 * Builds a map of scale ID to scale object for future lookup.
			 */
			buildScales: function() {
				var me = this;
				var options = me.options;
				var scales = me.scales = {};
				var items = [];
	
				if (options.scales) {
					items = items.concat(
						(options.scales.xAxes || []).map(function(xAxisOptions) {
							return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
						}),
						(options.scales.yAxes || []).map(function(yAxisOptions) {
							return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
						})
					);
				}
	
				if (options.scale) {
					items.push({
						options: options.scale,
						dtype: 'radialLinear',
						isDefault: true,
						dposition: 'chartArea'
					});
				}
	
				helpers.each(items, function(item) {
					var scaleOptions = item.options;
					var scaleType = helpers.valueOrDefault(scaleOptions.type, item.dtype);
					var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
	
					if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
						scaleOptions.position = item.dposition;
					}
	
					var scale = new scaleClass({
						id: scaleOptions.id,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
	
					scales[scale.id] = scale;
					scale.mergeTicksOptions();
	
					// TODO(SB): I think we should be able to remove this custom case (options.scale)
					// and consider it as a regular scale part of the "scales"" map only! This would
					// make the logic easier and remove some useless? custom code.
					if (item.isDefault) {
						me.scale = scale;
					}
				});
	
				Chart.scaleService.addScalesToLayout(this);
			},
	
			buildOrUpdateControllers: function() {
				var me = this;
				var types = [];
				var newControllers = [];
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					var meta = me.getDatasetMeta(datasetIndex);
					var type = dataset.type || me.config.type;
	
					if (meta.type && meta.type !== type) {
						me.destroyDatasetMeta(datasetIndex);
						meta = me.getDatasetMeta(datasetIndex);
					}
					meta.type = type;
	
					types.push(meta.type);
	
					if (meta.controller) {
						meta.controller.updateIndex(datasetIndex);
					} else {
						var ControllerClass = Chart.controllers[meta.type];
						if (ControllerClass === undefined) {
							throw new Error('"' + meta.type + '" is not a chart type.');
						}
	
						meta.controller = new ControllerClass(me, datasetIndex);
						newControllers.push(meta.controller);
					}
				}, me);
	
				return newControllers;
			},
	
			/**
			 * Reset the elements of all datasets
			 * @private
			 */
			resetElements: function() {
				var me = this;
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.reset();
				}, me);
			},
	
			/**
			* Resets the chart back to it's state before the initial animation
			*/
			reset: function() {
				this.resetElements();
				this.tooltip.initialize();
			},
	
			update: function(config) {
				var me = this;
	
				if (!config || typeof config !== 'object') {
					// backwards compatibility
					config = {
						duration: config,
						lazy: arguments[1]
					};
				}
	
				updateConfig(me);
	
				if (plugins.notify(me, 'beforeUpdate') === false) {
					return;
				}
	
				// In case the entire data object changed
				me.tooltip._data = me.data;
	
				// Make sure dataset controllers are updated and new controllers are reset
				var newControllers = me.buildOrUpdateControllers();
	
				// Make sure all dataset controllers have correct meta data counts
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
				}, me);
	
				me.updateLayout();
	
				// Can only reset the new controllers after the scales have been updated
				helpers.each(newControllers, function(controller) {
					controller.reset();
				});
	
				me.updateDatasets();
	
				// Need to reset tooltip in case it is displayed with elements that are removed
				// after update.
				me.tooltip.initialize();
	
				// Last active contains items that were previously in the tooltip.
				// When we reset the tooltip, we need to clear it
				me.lastActive = [];
	
				// Do this before render so that any plugins that need final scale updates can use it
				plugins.notify(me, 'afterUpdate');
	
				if (me._bufferedRender) {
					me._bufferedRequest = {
						duration: config.duration,
						easing: config.easing,
						lazy: config.lazy
					};
				} else {
					me.render(config);
				}
			},
	
			/**
			 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
			 * hook, in which case, plugins will not be called on `afterLayout`.
			 * @private
			 */
			updateLayout: function() {
				var me = this;
	
				if (plugins.notify(me, 'beforeLayout') === false) {
					return;
				}
	
				Chart.layoutService.update(this, this.width, this.height);
	
				/**
				 * Provided for backward compatibility, use `afterLayout` instead.
				 * @method IPlugin#afterScaleUpdate
				 * @deprecated since version 2.5.0
				 * @todo remove at version 3
				 * @private
				 */
				plugins.notify(me, 'afterScaleUpdate');
				plugins.notify(me, 'afterLayout');
			},
	
			/**
			 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
			 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
			 * @private
			 */
			updateDatasets: function() {
				var me = this;
	
				if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
					return;
				}
	
				for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					me.updateDataset(i);
				}
	
				plugins.notify(me, 'afterDatasetsUpdate');
			},
	
			/**
			 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
			 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
			 * @private
			 */
			updateDataset: function(index) {
				var me = this;
				var meta = me.getDatasetMeta(index);
				var args = {
					meta: meta,
					index: index
				};
	
				if (plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
					return;
				}
	
				meta.controller.update();
	
				plugins.notify(me, 'afterDatasetUpdate', [args]);
			},
	
			render: function(config) {
				var me = this;
	
				if (!config || typeof config !== 'object') {
					// backwards compatibility
					config = {
						duration: config,
						lazy: arguments[1]
					};
				}
	
				var duration = config.duration;
				var lazy = config.lazy;
	
				if (plugins.notify(me, 'beforeRender') === false) {
					return;
				}
	
				var animationOptions = me.options.animation;
				var onComplete = function(animation) {
					plugins.notify(me, 'afterRender');
					helpers.callback(animationOptions && animationOptions.onComplete, [animation], me);
				};
	
				if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
					var animation = new Chart.Animation({
						numSteps: (duration || animationOptions.duration) / 16.66, // 60 fps
						easing: config.easing || animationOptions.easing,
	
						render: function(chart, animationObject) {
							var easingFunction = helpers.easing.effects[animationObject.easing];
							var currentStep = animationObject.currentStep;
							var stepDecimal = currentStep / animationObject.numSteps;
	
							chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
						},
	
						onAnimationProgress: animationOptions.onProgress,
						onAnimationComplete: onComplete
					});
	
					Chart.animationService.addAnimation(me, animation, duration, lazy);
				} else {
					me.draw();
	
					// See https://github.com/chartjs/Chart.js/issues/3781
					onComplete(new Chart.Animation({numSteps: 0, chart: me}));
				}
	
				return me;
			},
	
			draw: function(easingValue) {
				var me = this;
	
				me.clear();
	
				if (helpers.isNullOrUndef(easingValue)) {
					easingValue = 1;
				}
	
				me.transition(easingValue);
	
				if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
					return;
				}
	
				// Draw all the scales
				helpers.each(me.boxes, function(box) {
					box.draw(me.chartArea);
				}, me);
	
				if (me.scale) {
					me.scale.draw();
				}
	
				me.drawDatasets(easingValue);
				me._drawTooltip(easingValue);
	
				plugins.notify(me, 'afterDraw', [easingValue]);
			},
	
			/**
			 * @private
			 */
			transition: function(easingValue) {
				var me = this;
	
				for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
					if (me.isDatasetVisible(i)) {
						me.getDatasetMeta(i).controller.transition(easingValue);
					}
				}
	
				me.tooltip.transition(easingValue);
			},
	
			/**
			 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
			 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
			 * @private
			 */
			drawDatasets: function(easingValue) {
				var me = this;
	
				if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
					return;
				}
	
				// Draw datasets reversed to support proper line stacking
				for (var i = (me.data.datasets || []).length - 1; i >= 0; --i) {
					if (me.isDatasetVisible(i)) {
						me.drawDataset(i, easingValue);
					}
				}
	
				plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
			},
	
			/**
			 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
			 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
			 * @private
			 */
			drawDataset: function(index, easingValue) {
				var me = this;
				var meta = me.getDatasetMeta(index);
				var args = {
					meta: meta,
					index: index,
					easingValue: easingValue
				};
	
				if (plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
					return;
				}
	
				meta.controller.draw(easingValue);
	
				plugins.notify(me, 'afterDatasetDraw', [args]);
			},
	
			/**
			 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
			 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
			 * @private
			 */
			_drawTooltip: function(easingValue) {
				var me = this;
				var tooltip = me.tooltip;
				var args = {
					tooltip: tooltip,
					easingValue: easingValue
				};
	
				if (plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
					return;
				}
	
				tooltip.draw();
	
				plugins.notify(me, 'afterTooltipDraw', [args]);
			},
	
			// Get the single element that was clicked on
			// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
			getElementAtEvent: function(e) {
				return Interaction.modes.single(this, e);
			},
	
			getElementsAtEvent: function(e) {
				return Interaction.modes.label(this, e, {intersect: true});
			},
	
			getElementsAtXAxis: function(e) {
				return Interaction.modes['x-axis'](this, e, {intersect: true});
			},
	
			getElementsAtEventForMode: function(e, mode, options) {
				var method = Interaction.modes[mode];
				if (typeof method === 'function') {
					return method(this, e, options);
				}
	
				return [];
			},
	
			getDatasetAtEvent: function(e) {
				return Interaction.modes.dataset(this, e, {intersect: true});
			},
	
			getDatasetMeta: function(datasetIndex) {
				var me = this;
				var dataset = me.data.datasets[datasetIndex];
				if (!dataset._meta) {
					dataset._meta = {};
				}
	
				var meta = dataset._meta[me.id];
				if (!meta) {
					meta = dataset._meta[me.id] = {
						type: null,
						data: [],
						dataset: null,
						controller: null,
						hidden: null,			// See isDatasetVisible() comment
						xAxisID: null,
						yAxisID: null
					};
				}
	
				return meta;
			},
	
			getVisibleDatasetCount: function() {
				var count = 0;
				for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
					if (this.isDatasetVisible(i)) {
						count++;
					}
				}
				return count;
			},
	
			isDatasetVisible: function(datasetIndex) {
				var meta = this.getDatasetMeta(datasetIndex);
	
				// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
				// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
				return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
			},
	
			generateLegend: function() {
				return this.options.legendCallback(this);
			},
	
			/**
			 * @private
			 */
			destroyDatasetMeta: function(datasetIndex) {
				var id = this.id;
				var dataset = this.data.datasets[datasetIndex];
				var meta = dataset._meta && dataset._meta[id];
	
				if (meta) {
					meta.controller.destroy();
					delete dataset._meta[id];
				}
			},
	
			destroy: function() {
				var me = this;
				var canvas = me.canvas;
				var i, ilen;
	
				me.stop();
	
				// dataset controllers need to cleanup associated data
				for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					me.destroyDatasetMeta(i);
				}
	
				if (canvas) {
					me.unbindEvents();
					helpers.canvas.clear(me);
					platform.releaseContext(me.ctx);
					me.canvas = null;
					me.ctx = null;
				}
	
				plugins.notify(me, 'destroy');
	
				delete Chart.instances[me.id];
			},
	
			toBase64Image: function() {
				return this.canvas.toDataURL.apply(this.canvas, arguments);
			},
	
			initToolTip: function() {
				var me = this;
				me.tooltip = new Chart.Tooltip({
					_chart: me,
					_chartInstance: me, // deprecated, backward compatibility
					_data: me.data,
					_options: me.options.tooltips
				}, me);
			},
	
			/**
			 * @private
			 */
			bindEvents: function() {
				var me = this;
				var listeners = me._listeners = {};
				var listener = function() {
					me.eventHandler.apply(me, arguments);
				};
	
				helpers.each(me.options.events, function(type) {
					platform.addEventListener(me, type, listener);
					listeners[type] = listener;
				});
	
				// Elements used to detect size change should not be injected for non responsive charts.
				// See https://github.com/chartjs/Chart.js/issues/2210
				if (me.options.responsive) {
					listener = function() {
						me.resize();
					};
	
					platform.addEventListener(me, 'resize', listener);
					listeners.resize = listener;
				}
			},
	
			/**
			 * @private
			 */
			unbindEvents: function() {
				var me = this;
				var listeners = me._listeners;
				if (!listeners) {
					return;
				}
	
				delete me._listeners;
				helpers.each(listeners, function(listener, type) {
					platform.removeEventListener(me, type, listener);
				});
			},
	
			updateHoverStyle: function(elements, mode, enabled) {
				var method = enabled ? 'setHoverStyle' : 'removeHoverStyle';
				var element, i, ilen;
	
				for (i = 0, ilen = elements.length; i < ilen; ++i) {
					element = elements[i];
					if (element) {
						this.getDatasetMeta(element._datasetIndex).controller[method](element);
					}
				}
			},
	
			/**
			 * @private
			 */
			eventHandler: function(e) {
				var me = this;
				var tooltip = me.tooltip;
	
				if (plugins.notify(me, 'beforeEvent', [e]) === false) {
					return;
				}
	
				// Buffer any update calls so that renders do not occur
				me._bufferedRender = true;
				me._bufferedRequest = null;
	
				var changed = me.handleEvent(e);
				changed |= tooltip && tooltip.handleEvent(e);
	
				plugins.notify(me, 'afterEvent', [e]);
	
				var bufferedRequest = me._bufferedRequest;
				if (bufferedRequest) {
					// If we have an update that was triggered, we need to do a normal render
					me.render(bufferedRequest);
				} else if (changed && !me.animating) {
					// If entering, leaving, or changing elements, animate the change via pivot
					me.stop();
	
					// We only need to render at this point. Updating will cause scales to be
					// recomputed generating flicker & using more memory than necessary.
					me.render(me.options.hover.animationDuration, true);
				}
	
				me._bufferedRender = false;
				me._bufferedRequest = null;
	
				return me;
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event the event to handle
			 * @return {Boolean} true if the chart needs to re-render
			 */
			handleEvent: function(e) {
				var me = this;
				var options = me.options || {};
				var hoverOptions = options.hover;
				var changed = false;
	
				me.lastActive = me.lastActive || [];
	
				// Find Active Elements for hover and tooltips
				if (e.type === 'mouseout') {
					me.active = [];
				} else {
					me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
				}
	
				// Invoke onHover hook
				// Need to call with native event here to not break backwards compatibility
				helpers.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);
	
				if (e.type === 'mouseup' || e.type === 'click') {
					if (options.onClick) {
						// Use e.native here for backwards compatibility
						options.onClick.call(me, e.native, me.active);
					}
				}
	
				// Remove styling for last active (even if it may still be active)
				if (me.lastActive.length) {
					me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
				}
	
				// Built in hover styling
				if (me.active.length && hoverOptions.mode) {
					me.updateHoverStyle(me.active, hoverOptions.mode, true);
				}
	
				changed = !helpers.arrayEquals(me.active, me.lastActive);
	
				// Remember Last Actives
				me.lastActive = me.active;
	
				return changed;
			}
		});
	
		/**
		 * Provided for backward compatibility, use Chart instead.
		 * @class Chart.Controller
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		Chart.Controller = Chart;
	};


/***/ },

/***/ "./node_modules/chart.js/src/core/core.datasetController.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	module.exports = function(Chart) {
	
		var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
	
		/**
		 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
		 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
		 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
		 */
		function listenArrayEvents(array, listener) {
			if (array._chartjs) {
				array._chartjs.listeners.push(listener);
				return;
			}
	
			Object.defineProperty(array, '_chartjs', {
				configurable: true,
				enumerable: false,
				value: {
					listeners: [listener]
				}
			});
	
			arrayEvents.forEach(function(key) {
				var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
				var base = array[key];
	
				Object.defineProperty(array, key, {
					configurable: true,
					enumerable: false,
					value: function() {
						var args = Array.prototype.slice.call(arguments);
						var res = base.apply(this, args);
	
						helpers.each(array._chartjs.listeners, function(object) {
							if (typeof object[method] === 'function') {
								object[method].apply(object, args);
							}
						});
	
						return res;
					}
				});
			});
		}
	
		/**
		 * Removes the given array event listener and cleanup extra attached properties (such as
		 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
		 */
		function unlistenArrayEvents(array, listener) {
			var stub = array._chartjs;
			if (!stub) {
				return;
			}
	
			var listeners = stub.listeners;
			var index = listeners.indexOf(listener);
			if (index !== -1) {
				listeners.splice(index, 1);
			}
	
			if (listeners.length > 0) {
				return;
			}
	
			arrayEvents.forEach(function(key) {
				delete array[key];
			});
	
			delete array._chartjs;
		}
	
		// Base class for all dataset controllers (line, bar, etc)
		Chart.DatasetController = function(chart, datasetIndex) {
			this.initialize(chart, datasetIndex);
		};
	
		helpers.extend(Chart.DatasetController.prototype, {
	
			/**
			 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
			 * @type {Chart.core.element}
			 */
			datasetElementType: null,
	
			/**
			 * Element type used to generate a meta data (e.g. Chart.element.Point).
			 * @type {Chart.core.element}
			 */
			dataElementType: null,
	
			initialize: function(chart, datasetIndex) {
				var me = this;
				me.chart = chart;
				me.index = datasetIndex;
				me.linkScales();
				me.addElements();
			},
	
			updateIndex: function(datasetIndex) {
				this.index = datasetIndex;
			},
	
			linkScales: function() {
				var me = this;
				var meta = me.getMeta();
				var dataset = me.getDataset();
	
				if (meta.xAxisID === null) {
					meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
				}
				if (meta.yAxisID === null) {
					meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
				}
			},
	
			getDataset: function() {
				return this.chart.data.datasets[this.index];
			},
	
			getMeta: function() {
				return this.chart.getDatasetMeta(this.index);
			},
	
			getScaleForId: function(scaleID) {
				return this.chart.scales[scaleID];
			},
	
			reset: function() {
				this.update(true);
			},
	
			/**
			 * @private
			 */
			destroy: function() {
				if (this._data) {
					unlistenArrayEvents(this._data, this);
				}
			},
	
			createMetaDataset: function() {
				var me = this;
				var type = me.datasetElementType;
				return type && new type({
					_chart: me.chart,
					_datasetIndex: me.index
				});
			},
	
			createMetaData: function(index) {
				var me = this;
				var type = me.dataElementType;
				return type && new type({
					_chart: me.chart,
					_datasetIndex: me.index,
					_index: index
				});
			},
	
			addElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data || [];
				var metaData = meta.data;
				var i, ilen;
	
				for (i = 0, ilen = data.length; i < ilen; ++i) {
					metaData[i] = metaData[i] || me.createMetaData(i);
				}
	
				meta.dataset = meta.dataset || me.createMetaDataset();
			},
	
			addElementAndReset: function(index) {
				var element = this.createMetaData(index);
				this.getMeta().data.splice(index, 0, element);
				this.updateElement(element, index, true);
			},
	
			buildOrUpdateElements: function() {
				var me = this;
				var dataset = me.getDataset();
				var data = dataset.data || (dataset.data = []);
	
				// In order to correctly handle data addition/deletion animation (an thus simulate
				// real-time charts), we need to monitor these data modifications and synchronize
				// the internal meta data accordingly.
				if (me._data !== data) {
					if (me._data) {
						// This case happens when the user replaced the data array instance.
						unlistenArrayEvents(me._data, me);
					}
	
					listenArrayEvents(data, me);
					me._data = data;
				}
	
				// Re-sync meta data in case the user replaced the data array or if we missed
				// any updates and so make sure that we handle number of datapoints changing.
				me.resyncElements();
			},
	
			update: helpers.noop,
	
			transition: function(easingValue) {
				var meta = this.getMeta();
				var elements = meta.data || [];
				var ilen = elements.length;
				var i = 0;
	
				for (; i < ilen; ++i) {
					elements[i].transition(easingValue);
				}
	
				if (meta.dataset) {
					meta.dataset.transition(easingValue);
				}
			},
	
			draw: function() {
				var meta = this.getMeta();
				var elements = meta.data || [];
				var ilen = elements.length;
				var i = 0;
	
				if (meta.dataset) {
					meta.dataset.draw();
				}
	
				for (; i < ilen; ++i) {
					elements[i].draw();
				}
			},
	
			removeHoverStyle: function(element, elementOpts) {
				var dataset = this.chart.data.datasets[element._datasetIndex];
				var index = element._index;
				var custom = element.custom || {};
				var valueOrDefault = helpers.valueAtIndexOrDefault;
				var model = element._model;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
			},
	
			setHoverStyle: function(element) {
				var dataset = this.chart.data.datasets[element._datasetIndex];
				var index = element._index;
				var custom = element.custom || {};
				var valueOrDefault = helpers.valueAtIndexOrDefault;
				var getHoverColor = helpers.getHoverColor;
				var model = element._model;
	
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			/**
			 * @private
			 */
			resyncElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data;
				var numMeta = meta.data.length;
				var numData = data.length;
	
				if (numData < numMeta) {
					meta.data.splice(numData, numMeta - numData);
				} else if (numData > numMeta) {
					me.insertElements(numMeta, numData - numMeta);
				}
			},
	
			/**
			 * @private
			 */
			insertElements: function(start, count) {
				for (var i = 0; i < count; ++i) {
					this.addElementAndReset(start + i);
				}
			},
	
			/**
			 * @private
			 */
			onDataPush: function() {
				this.insertElements(this.getDataset().data.length - 1, arguments.length);
			},
	
			/**
			 * @private
			 */
			onDataPop: function() {
				this.getMeta().data.pop();
			},
	
			/**
			 * @private
			 */
			onDataShift: function() {
				this.getMeta().data.shift();
			},
	
			/**
			 * @private
			 */
			onDataSplice: function(start, count) {
				this.getMeta().data.splice(start, count);
				this.insertElements(start, arguments.length - 2);
			},
	
			/**
			 * @private
			 */
			onDataUnshift: function() {
				this.insertElements(0, arguments.length);
			}
		});
	
		Chart.DatasetController.extend = helpers.inherits;
	};


/***/ },

/***/ "./node_modules/chart.js/src/core/core.layoutService.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	module.exports = function(Chart) {
	
		function filterByPosition(array, position) {
			return helpers.where(array, function(v) {
				return v.position === position;
			});
		}
	
		function sortByWeight(array, reverse) {
			array.forEach(function(v, i) {
				v._tmpIndex_ = i;
				return v;
			});
			array.sort(function(a, b) {
				var v0 = reverse ? b : a;
				var v1 = reverse ? a : b;
				return v0.weight === v1.weight ?
					v0._tmpIndex_ - v1._tmpIndex_ :
					v0.weight - v1.weight;
			});
			array.forEach(function(v) {
				delete v._tmpIndex_;
			});
		}
	
		/**
		 * @interface ILayoutItem
		 * @prop {String} position - The position of the item in the chart layout. Possible values are
		 * 'left', 'top', 'right', 'bottom', and 'chartArea'
		 * @prop {Number} weight - The weight used to sort the item. Higher weights are further away from the chart area
		 * @prop {Boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
		 * @prop {Function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
		 * @prop {Function} update - Takes two parameters: width and height. Returns size of item
		 * @prop {Function} getPadding -  Returns an object with padding on the edges
		 * @prop {Number} width - Width of item. Must be valid after update()
		 * @prop {Number} height - Height of item. Must be valid after update()
		 * @prop {Number} left - Left edge of the item. Set by layout system and cannot be used in update
		 * @prop {Number} top - Top edge of the item. Set by layout system and cannot be used in update
		 * @prop {Number} right - Right edge of the item. Set by layout system and cannot be used in update
		 * @prop {Number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
		 */
	
		// The layout service is very self explanatory.  It's responsible for the layout within a chart.
		// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
		// It is this service's responsibility of carrying out that layout.
		Chart.layoutService = {
			defaults: {},
	
			/**
			 * Register a box to a chart.
			 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
			 * @param {Chart} chart - the chart to use
			 * @param {ILayoutItem} item - the item to add to be layed out
			 */
			addBox: function(chart, item) {
				if (!chart.boxes) {
					chart.boxes = [];
				}
	
				// initialize item with default values
				item.fullWidth = item.fullWidth || false;
				item.position = item.position || 'top';
				item.weight = item.weight || 0;
	
				chart.boxes.push(item);
			},
	
			/**
			 * Remove a layoutItem from a chart
			 * @param {Chart} chart - the chart to remove the box from
			 * @param {Object} layoutItem - the item to remove from the layout
			 */
			removeBox: function(chart, layoutItem) {
				var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
				if (index !== -1) {
					chart.boxes.splice(index, 1);
				}
			},
	
			/**
			 * Sets (or updates) options on the given `item`.
			 * @param {Chart} chart - the chart in which the item lives (or will be added to)
			 * @param {Object} item - the item to configure with the given options
			 * @param {Object} options - the new item options.
			 */
			configure: function(chart, item, options) {
				var props = ['fullWidth', 'position', 'weight'];
				var ilen = props.length;
				var i = 0;
				var prop;
	
				for (; i < ilen; ++i) {
					prop = props[i];
					if (options.hasOwnProperty(prop)) {
						item[prop] = options[prop];
					}
				}
			},
	
			/**
			 * Fits boxes of the given chart into the given size by having each box measure itself
			 * then running a fitting algorithm
			 * @param {Chart} chart - the chart
			 * @param {Number} width - the width to fit into
			 * @param {Number} height - the height to fit into
			 */
			update: function(chart, width, height) {
				if (!chart) {
					return;
				}
	
				var layoutOptions = chart.options.layout || {};
				var padding = helpers.options.toPadding(layoutOptions.padding);
				var leftPadding = padding.left;
				var rightPadding = padding.right;
				var topPadding = padding.top;
				var bottomPadding = padding.bottom;
	
				var leftBoxes = filterByPosition(chart.boxes, 'left');
				var rightBoxes = filterByPosition(chart.boxes, 'right');
				var topBoxes = filterByPosition(chart.boxes, 'top');
				var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
				var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');
	
				// Sort boxes by weight. A higher weight is further away from the chart area
				sortByWeight(leftBoxes, true);
				sortByWeight(rightBoxes, false);
				sortByWeight(topBoxes, true);
				sortByWeight(bottomBoxes, false);
	
				// Essentially we now have any number of boxes on each of the 4 sides.
				// Our canvas looks like the following.
				// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
				// B1 is the bottom axis
				// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
				// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
				// an error will be thrown.
				//
				// |----------------------------------------------------|
				// |                  T1 (Full Width)                   |
				// |----------------------------------------------------|
				// |    |    |                 T2                  |    |
				// |    |----|-------------------------------------|----|
				// |    |    | C1 |                           | C2 |    |
				// |    |    |----|                           |----|    |
				// |    |    |                                     |    |
				// | L1 | L2 |           ChartArea (C0)            | R1 |
				// |    |    |                                     |    |
				// |    |    |----|                           |----|    |
				// |    |    | C3 |                           | C4 |    |
				// |    |----|-------------------------------------|----|
				// |    |    |                 B1                  |    |
				// |----------------------------------------------------|
				// |                  B2 (Full Width)                   |
				// |----------------------------------------------------|
				//
				// What we do to find the best sizing, we do the following
				// 1. Determine the minimum size of the chart area.
				// 2. Split the remaining width equally between each vertical axis
				// 3. Split the remaining height equally between each horizontal axis
				// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
				// 5. Adjust the sizes of each axis based on it's minimum reported size.
				// 6. Refit each axis
				// 7. Position each axis in the final location
				// 8. Tell the chart the final location of the chart area
				// 9. Tell any axes that overlay the chart area the positions of the chart area
	
				// Step 1
				var chartWidth = width - leftPadding - rightPadding;
				var chartHeight = height - topPadding - bottomPadding;
				var chartAreaWidth = chartWidth / 2; // min 50%
				var chartAreaHeight = chartHeight / 2; // min 50%
	
				// Step 2
				var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);
	
				// Step 3
				var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);
	
				// Step 4
				var maxChartAreaWidth = chartWidth;
				var maxChartAreaHeight = chartHeight;
				var minBoxSizes = [];
	
				function getMinimumBoxSize(box) {
					var minSize;
					var isHorizontal = box.isHorizontal();
	
					if (isHorizontal) {
						minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
						maxChartAreaHeight -= minSize.height;
					} else {
						minSize = box.update(verticalBoxWidth, chartAreaHeight);
						maxChartAreaWidth -= minSize.width;
					}
	
					minBoxSizes.push({
						horizontal: isHorizontal,
						minSize: minSize,
						box: box,
					});
				}
	
				helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);
	
				// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
				var maxHorizontalLeftPadding = 0;
				var maxHorizontalRightPadding = 0;
				var maxVerticalTopPadding = 0;
				var maxVerticalBottomPadding = 0;
	
				helpers.each(topBoxes.concat(bottomBoxes), function(horizontalBox) {
					if (horizontalBox.getPadding) {
						var boxPadding = horizontalBox.getPadding();
						maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
						maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
					}
				});
	
				helpers.each(leftBoxes.concat(rightBoxes), function(verticalBox) {
					if (verticalBox.getPadding) {
						var boxPadding = verticalBox.getPadding();
						maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
						maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
					}
				});
	
				// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
				// be if the axes are drawn at their minimum sizes.
				// Steps 5 & 6
				var totalLeftBoxesWidth = leftPadding;
				var totalRightBoxesWidth = rightPadding;
				var totalTopBoxesHeight = topPadding;
				var totalBottomBoxesHeight = bottomPadding;
	
				// Function to fit a box
				function fitBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
						return minBox.box === box;
					});
	
					if (minBoxSize) {
						if (box.isHorizontal()) {
							var scaleMargin = {
								left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
								right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
								top: 0,
								bottom: 0
							};
	
							// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
							// on the margin. Sometimes they need to increase in size slightly
							box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
						} else {
							box.update(minBoxSize.minSize.width, maxChartAreaHeight);
						}
					}
				}
	
				// Update, and calculate the left and right margins for the horizontal boxes
				helpers.each(leftBoxes.concat(rightBoxes), fitBox);
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				// Set the Left and Right margins for the horizontal boxes
				helpers.each(topBoxes.concat(bottomBoxes), fitBox);
	
				// Figure out how much margin is on the top and bottom of the vertical boxes
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
	
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				function finalFitVerticalBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
						return minSize.box === box;
					});
	
					var scaleMargin = {
						left: 0,
						right: 0,
						top: totalTopBoxesHeight,
						bottom: totalBottomBoxesHeight
					};
	
					if (minBoxSize) {
						box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
					}
				}
	
				// Let the left layout know the final margin
				helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);
	
				// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
				totalLeftBoxesWidth = leftPadding;
				totalRightBoxesWidth = rightPadding;
				totalTopBoxesHeight = topPadding;
				totalBottomBoxesHeight = bottomPadding;
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				// We may be adding some padding to account for rotated x axis labels
				var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
				totalLeftBoxesWidth += leftPaddingAddition;
				totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);
	
				var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
				totalTopBoxesHeight += topPaddingAddition;
				totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);
	
				// Figure out if our chart area changed. This would occur if the dataset layout label rotation
				// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
				// without calling `fit` again
				var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
				var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;
	
				if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
					helpers.each(leftBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(rightBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(topBoxes, function(box) {
						if (!box.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					helpers.each(bottomBoxes, function(box) {
						if (!box.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					maxChartAreaHeight = newMaxChartAreaHeight;
					maxChartAreaWidth = newMaxChartAreaWidth;
				}
	
				// Step 7 - Position the boxes
				var left = leftPadding + leftPaddingAddition;
				var top = topPadding + topPaddingAddition;
	
				function placeBox(box) {
					if (box.isHorizontal()) {
						box.left = box.fullWidth ? leftPadding : totalLeftBoxesWidth;
						box.right = box.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
						box.top = top;
						box.bottom = top + box.height;
	
						// Move to next point
						top = box.bottom;
	
					} else {
	
						box.left = left;
						box.right = left + box.width;
						box.top = totalTopBoxesHeight;
						box.bottom = totalTopBoxesHeight + maxChartAreaHeight;
	
						// Move to next point
						left = box.right;
					}
				}
	
				helpers.each(leftBoxes.concat(topBoxes), placeBox);
	
				// Account for chart width and height
				left += maxChartAreaWidth;
				top += maxChartAreaHeight;
	
				helpers.each(rightBoxes, placeBox);
				helpers.each(bottomBoxes, placeBox);
	
				// Step 8
				chart.chartArea = {
					left: totalLeftBoxesWidth,
					top: totalTopBoxesHeight,
					right: totalLeftBoxesWidth + maxChartAreaWidth,
					bottom: totalTopBoxesHeight + maxChartAreaHeight
				};
	
				// Step 9
				helpers.each(chartAreaBoxes, function(box) {
					box.left = chart.chartArea.left;
					box.top = chart.chartArea.top;
					box.right = chart.chartArea.right;
					box.bottom = chart.chartArea.bottom;
	
					box.update(maxChartAreaWidth, maxChartAreaHeight);
				});
			}
		};
	};


/***/ },

/***/ "./node_modules/chart.js/src/core/core.scaleService.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	module.exports = function(Chart) {
	
		Chart.scaleService = {
			// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
			// use the new chart options to grab the correct scale
			constructors: {},
			// Use a registration function so that we can move to an ES6 map when we no longer need to support
			// old browsers
	
			// Scale config defaults
			defaults: {},
			registerScaleType: function(type, scaleConstructor, scaleDefaults) {
				this.constructors[type] = scaleConstructor;
				this.defaults[type] = helpers.clone(scaleDefaults);
			},
			getScaleConstructor: function(type) {
				return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
			},
			getScaleDefaults: function(type) {
				// Return the scale defaults merged with the global settings so that we always use the latest ones
				return this.defaults.hasOwnProperty(type) ? helpers.merge({}, [defaults.scale, this.defaults[type]]) : {};
			},
			updateScaleDefaults: function(type, additions) {
				var me = this;
				if (me.defaults.hasOwnProperty(type)) {
					me.defaults[type] = helpers.extend(me.defaults[type], additions);
				}
			},
			addScalesToLayout: function(chart) {
				// Adds each scale to the chart.boxes array to be sized accordingly
				helpers.each(chart.scales, function(scale) {
					// Set ILayoutItem parameters for backwards compatibility
					scale.fullWidth = scale.options.fullWidth;
					scale.position = scale.options.position;
					scale.weight = scale.options.weight;
					Chart.layoutService.addBox(chart, scale);
				});
			}
		};
	};


/***/ },

/***/ "./node_modules/chart.js/src/core/core.scale.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var Element = __webpack_require__("./node_modules/chart.js/src/core/core.element.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	var Ticks = __webpack_require__("./node_modules/chart.js/src/core/core.ticks.js");
	
	defaults._set('scale', {
		display: true,
		position: 'left',
		offset: false,
	
		// grid line settings
		gridLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1,
			drawBorder: true,
			drawOnChartArea: true,
			drawTicks: true,
			tickMarkLength: 10,
			zeroLineWidth: 1,
			zeroLineColor: 'rgba(0,0,0,0.25)',
			zeroLineBorderDash: [],
			zeroLineBorderDashOffset: 0.0,
			offsetGridLines: false,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		// scale label
		scaleLabel: {
			// display property
			display: false,
	
			// actual label
			labelString: '',
	
			// line height
			lineHeight: 1.2,
	
			// top/bottom padding
			padding: {
				top: 4,
				bottom: 4
			}
		},
	
		// label settings
		ticks: {
			beginAtZero: false,
			minRotation: 0,
			maxRotation: 50,
			mirror: false,
			padding: 0,
			reverse: false,
			display: true,
			autoSkip: true,
			autoSkipPadding: 0,
			labelOffset: 0,
			// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
			callback: Ticks.formatters.values,
			minor: {},
			major: {}
		}
	});
	
	function labelsFromTicks(ticks) {
		var labels = [];
		var i, ilen;
	
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(ticks[i].label);
		}
	
		return labels;
	}
	
	function getLineValue(scale, index, offsetGridLines) {
		var lineValue = scale.getPixelForTick(index);
	
		if (offsetGridLines) {
			if (index === 0) {
				lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
			} else {
				lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
			}
		}
		return lineValue;
	}
	
	module.exports = function(Chart) {
	
		function computeTextSize(context, tick, font) {
			return helpers.isArray(tick) ?
				helpers.longestText(context, font, tick) :
				context.measureText(tick).width;
		}
	
		function parseFontOptions(options) {
			var valueOrDefault = helpers.valueOrDefault;
			var globalDefaults = defaults.global;
			var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var style = valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
			var family = valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);
	
			return {
				size: size,
				style: style,
				family: family,
				font: helpers.fontString(size, style, family)
			};
		}
	
		function parseLineHeight(options) {
			return helpers.options.toLineHeight(
				helpers.valueOrDefault(options.lineHeight, 1.2),
				helpers.valueOrDefault(options.fontSize, defaults.global.defaultFontSize));
		}
	
		Chart.Scale = Element.extend({
			/**
			 * Get the padding needed for the scale
			 * @method getPadding
			 * @private
			 * @returns {Padding} the necessary padding
			 */
			getPadding: function() {
				var me = this;
				return {
					left: me.paddingLeft || 0,
					top: me.paddingTop || 0,
					right: me.paddingRight || 0,
					bottom: me.paddingBottom || 0
				};
			},
	
			/**
			 * Returns the scale tick objects ({label, major})
			 * @since 2.7
			 */
			getTicks: function() {
				return this._ticks;
			},
	
			// These methods are ordered by lifecyle. Utilities then follow.
			// Any function defined here is inherited by all scale types.
			// Any function can be extended by the scale type
	
			mergeTicksOptions: function() {
				var ticks = this.options.ticks;
				if (ticks.minor === false) {
					ticks.minor = {
						display: false
					};
				}
				if (ticks.major === false) {
					ticks.major = {
						display: false
					};
				}
				for (var key in ticks) {
					if (key !== 'major' && key !== 'minor') {
						if (typeof ticks.minor[key] === 'undefined') {
							ticks.minor[key] = ticks[key];
						}
						if (typeof ticks.major[key] === 'undefined') {
							ticks.major[key] = ticks[key];
						}
					}
				}
			},
			beforeUpdate: function() {
				helpers.callback(this.options.beforeUpdate, [this]);
			},
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
				var i, ilen, labels, label, ticks, tick;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = helpers.extend({
					left: 0,
					right: 0,
					top: 0,
					bottom: 0
				}, margins);
				me.longestTextCache = me.longestTextCache || {};
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
	
				// Data min/max
				me.beforeDataLimits();
				me.determineDataLimits();
				me.afterDataLimits();
	
				// Ticks - `this.ticks` is now DEPRECATED!
				// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
				// and must not be accessed directly from outside this class. `this.ticks` being
				// around for long time and not marked as private, we can't change its structure
				// without unexpected breaking changes. If you need to access the scale ticks,
				// use scale.getTicks() instead.
	
				me.beforeBuildTicks();
	
				// New implementations should return an array of objects but for BACKWARD COMPAT,
				// we still support no return (`this.ticks` internally set by calling this method).
				ticks = me.buildTicks() || [];
	
				me.afterBuildTicks();
	
				me.beforeTickToLabelConversion();
	
				// New implementations should return the formatted tick labels but for BACKWARD
				// COMPAT, we still support no return (`this.ticks` internally changed by calling
				// this method and supposed to contain only string values).
				labels = me.convertTicksToLabels(ticks) || me.ticks;
	
				me.afterTickToLabelConversion();
	
				me.ticks = labels;   // BACKWARD COMPATIBILITY
	
				// IMPORTANT: from this point, we consider that `this.ticks` will NEVER change!
	
				// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
				for (i = 0, ilen = labels.length; i < ilen; ++i) {
					label = labels[i];
					tick = ticks[i];
					if (!tick) {
						ticks.push(tick = {
							label: label,
							major: false
						});
					} else {
						tick.label = label;
					}
				}
	
				me._ticks = ticks;
	
				// Tick Rotation
				me.beforeCalculateTickRotation();
				me.calculateTickRotation();
				me.afterCalculateTickRotation();
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: function() {
				helpers.callback(this.options.afterUpdate, [this]);
			},
	
			//
	
			beforeSetDimensions: function() {
				helpers.callback(this.options.beforeSetDimensions, [this]);
			},
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
			},
			afterSetDimensions: function() {
				helpers.callback(this.options.afterSetDimensions, [this]);
			},
	
			// Data limits
			beforeDataLimits: function() {
				helpers.callback(this.options.beforeDataLimits, [this]);
			},
			determineDataLimits: helpers.noop,
			afterDataLimits: function() {
				helpers.callback(this.options.afterDataLimits, [this]);
			},
	
			//
			beforeBuildTicks: function() {
				helpers.callback(this.options.beforeBuildTicks, [this]);
			},
			buildTicks: helpers.noop,
			afterBuildTicks: function() {
				helpers.callback(this.options.afterBuildTicks, [this]);
			},
	
			beforeTickToLabelConversion: function() {
				helpers.callback(this.options.beforeTickToLabelConversion, [this]);
			},
			convertTicksToLabels: function() {
				var me = this;
				// Convert ticks to strings
				var tickOpts = me.options.ticks;
				me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
			},
			afterTickToLabelConversion: function() {
				helpers.callback(this.options.afterTickToLabelConversion, [this]);
			},
	
			//
	
			beforeCalculateTickRotation: function() {
				helpers.callback(this.options.beforeCalculateTickRotation, [this]);
			},
			calculateTickRotation: function() {
				var me = this;
				var context = me.ctx;
				var tickOpts = me.options.ticks;
				var labels = labelsFromTicks(me._ticks);
	
				// Get the width of each grid by calculating the difference
				// between x offsets between 0 and 1.
				var tickFont = parseFontOptions(tickOpts);
				context.font = tickFont.font;
	
				var labelRotation = tickOpts.minRotation || 0;
	
				if (labels.length && me.options.display && me.isHorizontal()) {
					var originalLabelWidth = helpers.longestText(context, tickFont.font, labels, me.longestTextCache);
					var labelWidth = originalLabelWidth;
					var cosRotation, sinRotation;
	
					// Allow 3 pixels x2 padding either side for label readability
					var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;
	
					// Max label rotation can be set or default to 90 - also act as a loop counter
					while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
						var angleRadians = helpers.toRadians(labelRotation);
						cosRotation = Math.cos(angleRadians);
						sinRotation = Math.sin(angleRadians);
	
						if (sinRotation * originalLabelWidth > me.maxHeight) {
							// go back one step
							labelRotation--;
							break;
						}
	
						labelRotation++;
						labelWidth = cosRotation * originalLabelWidth;
					}
				}
	
				me.labelRotation = labelRotation;
			},
			afterCalculateTickRotation: function() {
				helpers.callback(this.options.afterCalculateTickRotation, [this]);
			},
	
			//
	
			beforeFit: function() {
				helpers.callback(this.options.beforeFit, [this]);
			},
			fit: function() {
				var me = this;
				// Reset
				var minSize = me.minSize = {
					width: 0,
					height: 0
				};
	
				var labels = labelsFromTicks(me._ticks);
	
				var opts = me.options;
				var tickOpts = opts.ticks;
				var scaleLabelOpts = opts.scaleLabel;
				var gridLineOpts = opts.gridLines;
				var display = opts.display;
				var isHorizontal = me.isHorizontal();
	
				var tickFont = parseFontOptions(tickOpts);
				var tickMarkLength = opts.gridLines.tickMarkLength;
	
				// Width
				if (isHorizontal) {
					// subtract the margins to line up with the chartArea if we are a full width scale
					minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
				} else {
					minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				}
	
				// height
				if (isHorizontal) {
					minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				} else {
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Are we showing a title for the scale?
				if (scaleLabelOpts.display && display) {
					var scaleLabelLineHeight = parseLineHeight(scaleLabelOpts);
					var scaleLabelPadding = helpers.options.toPadding(scaleLabelOpts.padding);
					var deltaHeight = scaleLabelLineHeight + scaleLabelPadding.height;
	
					if (isHorizontal) {
						minSize.height += deltaHeight;
					} else {
						minSize.width += deltaHeight;
					}
				}
	
				// Don't bother fitting the ticks if we are not showing them
				if (tickOpts.display && display) {
					var largestTextWidth = helpers.longestText(me.ctx, tickFont.font, labels, me.longestTextCache);
					var tallestLabelHeightInLines = helpers.numberOfLabelLines(labels);
					var lineSpace = tickFont.size * 0.5;
					var tickPadding = me.options.ticks.padding;
	
					if (isHorizontal) {
						// A horizontal axis is more constrained by the height.
						me.longestLabelWidth = largestTextWidth;
	
						var angleRadians = helpers.toRadians(me.labelRotation);
						var cosRotation = Math.cos(angleRadians);
						var sinRotation = Math.sin(angleRadians);
	
						// TODO - improve this calculation
						var labelHeight = (sinRotation * largestTextWidth)
							+ (tickFont.size * tallestLabelHeightInLines)
							+ (lineSpace * (tallestLabelHeightInLines - 1))
							+ lineSpace; // padding
	
						minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
	
						me.ctx.font = tickFont.font;
						var firstLabelWidth = computeTextSize(me.ctx, labels[0], tickFont.font);
						var lastLabelWidth = computeTextSize(me.ctx, labels[labels.length - 1], tickFont.font);
	
						// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
						// which means that the right padding is dominated by the font height
						if (me.labelRotation !== 0) {
							me.paddingLeft = opts.position === 'bottom' ? (cosRotation * firstLabelWidth) + 3 : (cosRotation * lineSpace) + 3; // add 3 px to move away from canvas edges
							me.paddingRight = opts.position === 'bottom' ? (cosRotation * lineSpace) + 3 : (cosRotation * lastLabelWidth) + 3;
						} else {
							me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
							me.paddingRight = lastLabelWidth / 2 + 3;
						}
					} else {
						// A vertical axis is more constrained by the width. Labels are the
						// dominant factor here, so get that length first and account for padding
						if (tickOpts.mirror) {
							largestTextWidth = 0;
						} else {
							// use lineSpace for consistency with horizontal axis
							// tickPadding is not implemented for horizontal
							largestTextWidth += tickPadding + lineSpace;
						}
	
						minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);
	
						me.paddingTop = tickFont.size / 2;
						me.paddingBottom = tickFont.size / 2;
					}
				}
	
				me.handleMargins();
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
	
			/**
			 * Handle margins and padding interactions
			 * @private
			 */
			handleMargins: function() {
				var me = this;
				if (me.margins) {
					me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
					me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
					me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
					me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
				}
			},
	
			afterFit: function() {
				helpers.callback(this.options.afterFit, [this]);
			},
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
			isFullWidth: function() {
				return (this.options.fullWidth);
			},
	
			// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
			getRightValue: function(rawValue) {
				// Null and undefined values first
				if (helpers.isNullOrUndef(rawValue)) {
					return NaN;
				}
				// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
				if (typeof rawValue === 'number' && !isFinite(rawValue)) {
					return NaN;
				}
				// If it is in fact an object, dive in one more level
				if (rawValue) {
					if (this.isHorizontal()) {
						if (rawValue.x !== undefined) {
							return this.getRightValue(rawValue.x);
						}
					} else if (rawValue.y !== undefined) {
						return this.getRightValue(rawValue.y);
					}
				}
	
				// Value is good, return it
				return rawValue;
			},
	
			/**
			 * Used to get the value to display in the tooltip for the data at the given index
			 * @param index
			 * @param datasetIndex
			 */
			getLabelForIndex: helpers.noop,
	
			/**
			 * Returns the location of the given data point. Value can either be an index or a numerical value
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 * @param value
			 * @param index
			 * @param datasetIndex
			 */
			getPixelForValue: helpers.noop,
	
			/**
			 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 * @param pixel
			 */
			getValueForPixel: helpers.noop,
	
			/**
			 * Returns the location of the tick at the given index
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 */
			getPixelForTick: function(index) {
				var me = this;
				var offset = me.options.offset;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var tickWidth = innerWidth / Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
					var pixel = (tickWidth * index) + me.paddingLeft;
	
					if (offset) {
						pixel += tickWidth / 2;
					}
	
					var finalVal = me.left + Math.round(pixel);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
				return me.top + (index * (innerHeight / (me._ticks.length - 1)));
			},
	
			/**
			 * Utility for getting the pixel location of a percentage of scale
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 */
			getPixelForDecimal: function(decimal) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var valueOffset = (innerWidth * decimal) + me.paddingLeft;
	
					var finalVal = me.left + Math.round(valueOffset);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				return me.top + (decimal * me.height);
			},
	
			/**
			 * Returns the pixel for the minimum chart value
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 */
			getBasePixel: function() {
				return this.getPixelForValue(this.getBaseValue());
			},
	
			getBaseValue: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.beginAtZero ? 0 :
					min < 0 && max < 0 ? max :
					min > 0 && max > 0 ? min :
					0;
			},
	
			/**
			 * Returns a subset of ticks to be plotted to avoid overlapping labels.
			 * @private
			 */
			_autoSkip: function(ticks) {
				var skipRatio;
				var me = this;
				var isHorizontal = me.isHorizontal();
				var optionTicks = me.options.ticks.minor;
				var tickCount = ticks.length;
				var labelRotationRadians = helpers.toRadians(me.labelRotation);
				var cosRotation = Math.cos(labelRotationRadians);
				var longestRotatedLabel = me.longestLabelWidth * cosRotation;
				var result = [];
				var i, tick, shouldSkip;
	
				// figure out the maximum number of gridlines to show
				var maxTicks;
				if (optionTicks.maxTicksLimit) {
					maxTicks = optionTicks.maxTicksLimit;
				}
	
				if (isHorizontal) {
					skipRatio = false;
	
					if ((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount > (me.width - (me.paddingLeft + me.paddingRight))) {
						skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount) / (me.width - (me.paddingLeft + me.paddingRight)));
					}
	
					// if they defined a max number of optionTicks,
					// increase skipRatio until that number is met
					if (maxTicks && tickCount > maxTicks) {
						skipRatio = Math.max(skipRatio, Math.floor(tickCount / maxTicks));
					}
				}
	
				for (i = 0; i < tickCount; i++) {
					tick = ticks[i];
	
					// Since we always show the last tick,we need may need to hide the last shown one before
					shouldSkip = (skipRatio > 1 && i % skipRatio > 0) || (i % skipRatio === 0 && i + skipRatio >= tickCount);
					if (shouldSkip && i !== tickCount - 1) {
						// leave tick in place but make sure it's not displayed (#4635)
						delete tick.label;
					}
					result.push(tick);
				}
				return result;
			},
	
			// Actually draw the scale on the canvas
			// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
			draw: function(chartArea) {
				var me = this;
				var options = me.options;
				if (!options.display) {
					return;
				}
	
				var context = me.ctx;
				var globalDefaults = defaults.global;
				var optionTicks = options.ticks.minor;
				var optionMajorTicks = options.ticks.major || optionTicks;
				var gridLines = options.gridLines;
				var scaleLabel = options.scaleLabel;
	
				var isRotated = me.labelRotation !== 0;
				var isHorizontal = me.isHorizontal();
	
				var ticks = optionTicks.autoSkip ? me._autoSkip(me.getTicks()) : me.getTicks();
				var tickFontColor = helpers.valueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
				var tickFont = parseFontOptions(optionTicks);
				var majorTickFontColor = helpers.valueOrDefault(optionMajorTicks.fontColor, globalDefaults.defaultFontColor);
				var majorTickFont = parseFontOptions(optionMajorTicks);
	
				var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;
	
				var scaleLabelFontColor = helpers.valueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
				var scaleLabelFont = parseFontOptions(scaleLabel);
				var scaleLabelPadding = helpers.options.toPadding(scaleLabel.padding);
				var labelRotationRadians = helpers.toRadians(me.labelRotation);
	
				var itemsToDraw = [];
	
				var xTickStart = options.position === 'right' ? me.left : me.right - tl;
				var xTickEnd = options.position === 'right' ? me.left + tl : me.right;
				var yTickStart = options.position === 'bottom' ? me.top : me.bottom - tl;
				var yTickEnd = options.position === 'bottom' ? me.top + tl : me.bottom;
	
				helpers.each(ticks, function(tick, index) {
					// autoskipper skipped this tick (#4635)
					if (helpers.isNullOrUndef(tick.label)) {
						return;
					}
	
					var label = tick.label;
					var lineWidth, lineColor, borderDash, borderDashOffset;
					if (index === me.zeroLineIndex && options.offset === gridLines.offsetGridLines) {
						// Draw the first index specially
						lineWidth = gridLines.zeroLineWidth;
						lineColor = gridLines.zeroLineColor;
						borderDash = gridLines.zeroLineBorderDash;
						borderDashOffset = gridLines.zeroLineBorderDashOffset;
					} else {
						lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, index);
						lineColor = helpers.valueAtIndexOrDefault(gridLines.color, index);
						borderDash = helpers.valueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
						borderDashOffset = helpers.valueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
					}
	
					// Common properties
					var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
					var textAlign = 'middle';
					var textBaseline = 'middle';
					var tickPadding = optionTicks.padding;
	
					if (isHorizontal) {
						var labelYOffset = tl + tickPadding;
	
						if (options.position === 'bottom') {
							// bottom
							textBaseline = !isRotated ? 'top' : 'middle';
							textAlign = !isRotated ? 'center' : 'right';
							labelY = me.top + labelYOffset;
						} else {
							// top
							textBaseline = !isRotated ? 'bottom' : 'middle';
							textAlign = !isRotated ? 'center' : 'left';
							labelY = me.bottom - labelYOffset;
						}
	
						var xLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
						if (xLineValue < me.left) {
							lineColor = 'rgba(0,0,0,0)';
						}
						xLineValue += helpers.aliasPixel(lineWidth);
	
						labelX = me.getPixelForTick(index) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)
	
						tx1 = tx2 = x1 = x2 = xLineValue;
						ty1 = yTickStart;
						ty2 = yTickEnd;
						y1 = chartArea.top;
						y2 = chartArea.bottom;
					} else {
						var isLeft = options.position === 'left';
						var labelXOffset;
	
						if (optionTicks.mirror) {
							textAlign = isLeft ? 'left' : 'right';
							labelXOffset = tickPadding;
						} else {
							textAlign = isLeft ? 'right' : 'left';
							labelXOffset = tl + tickPadding;
						}
	
						labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;
	
						var yLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
						if (yLineValue < me.top) {
							lineColor = 'rgba(0,0,0,0)';
						}
						yLineValue += helpers.aliasPixel(lineWidth);
	
						labelY = me.getPixelForTick(index) + optionTicks.labelOffset;
	
						tx1 = xTickStart;
						tx2 = xTickEnd;
						x1 = chartArea.left;
						x2 = chartArea.right;
						ty1 = ty2 = y1 = y2 = yLineValue;
					}
	
					itemsToDraw.push({
						tx1: tx1,
						ty1: ty1,
						tx2: tx2,
						ty2: ty2,
						x1: x1,
						y1: y1,
						x2: x2,
						y2: y2,
						labelX: labelX,
						labelY: labelY,
						glWidth: lineWidth,
						glColor: lineColor,
						glBorderDash: borderDash,
						glBorderDashOffset: borderDashOffset,
						rotation: -1 * labelRotationRadians,
						label: label,
						major: tick.major,
						textBaseline: textBaseline,
						textAlign: textAlign
					});
				});
	
				// Draw all of the tick labels, tick marks, and grid lines at the correct places
				helpers.each(itemsToDraw, function(itemToDraw) {
					if (gridLines.display) {
						context.save();
						context.lineWidth = itemToDraw.glWidth;
						context.strokeStyle = itemToDraw.glColor;
						if (context.setLineDash) {
							context.setLineDash(itemToDraw.glBorderDash);
							context.lineDashOffset = itemToDraw.glBorderDashOffset;
						}
	
						context.beginPath();
	
						if (gridLines.drawTicks) {
							context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
							context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
						}
	
						if (gridLines.drawOnChartArea) {
							context.moveTo(itemToDraw.x1, itemToDraw.y1);
							context.lineTo(itemToDraw.x2, itemToDraw.y2);
						}
	
						context.stroke();
						context.restore();
					}
	
					if (optionTicks.display) {
						// Make sure we draw text in the correct color and font
						context.save();
						context.translate(itemToDraw.labelX, itemToDraw.labelY);
						context.rotate(itemToDraw.rotation);
						context.font = itemToDraw.major ? majorTickFont.font : tickFont.font;
						context.fillStyle = itemToDraw.major ? majorTickFontColor : tickFontColor;
						context.textBaseline = itemToDraw.textBaseline;
						context.textAlign = itemToDraw.textAlign;
	
						var label = itemToDraw.label;
						if (helpers.isArray(label)) {
							for (var i = 0, y = 0; i < label.length; ++i) {
								// We just make sure the multiline element is a string here..
								context.fillText('' + label[i], 0, y);
								// apply same lineSpacing as calculated @ L#320
								y += (tickFont.size * 1.5);
							}
						} else {
							context.fillText(label, 0, 0);
						}
						context.restore();
					}
				});
	
				if (scaleLabel.display) {
					// Draw the scale label
					var scaleLabelX;
					var scaleLabelY;
					var rotation = 0;
					var halfLineHeight = parseLineHeight(scaleLabel) / 2;
	
					if (isHorizontal) {
						scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
						scaleLabelY = options.position === 'bottom'
							? me.bottom - halfLineHeight - scaleLabelPadding.bottom
							: me.top + halfLineHeight + scaleLabelPadding.top;
					} else {
						var isLeft = options.position === 'left';
						scaleLabelX = isLeft
							? me.left + halfLineHeight + scaleLabelPadding.top
							: me.right - halfLineHeight - scaleLabelPadding.top;
						scaleLabelY = me.top + ((me.bottom - me.top) / 2);
						rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
					}
	
					context.save();
					context.translate(scaleLabelX, scaleLabelY);
					context.rotate(rotation);
					context.textAlign = 'center';
					context.textBaseline = 'middle';
					context.fillStyle = scaleLabelFontColor; // render in correct colour
					context.font = scaleLabelFont.font;
					context.fillText(scaleLabel.labelString, 0, 0);
					context.restore();
				}
	
				if (gridLines.drawBorder) {
					// Draw the line at the edge of the axis
					context.lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, 0);
					context.strokeStyle = helpers.valueAtIndexOrDefault(gridLines.color, 0);
					var x1 = me.left;
					var x2 = me.right;
					var y1 = me.top;
					var y2 = me.bottom;
	
					var aliasPixel = helpers.aliasPixel(context.lineWidth);
					if (isHorizontal) {
						y1 = y2 = options.position === 'top' ? me.bottom : me.top;
						y1 += aliasPixel;
						y2 += aliasPixel;
					} else {
						x1 = x2 = options.position === 'left' ? me.right : me.left;
						x1 += aliasPixel;
						x2 += aliasPixel;
					}
	
					context.beginPath();
					context.moveTo(x1, y1);
					context.lineTo(x2, y2);
					context.stroke();
				}
			}
		});
	};


/***/ },

/***/ "./node_modules/chart.js/src/core/core.ticks.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	/**
	 * Namespace to hold static tick generation functions
	 * @namespace Chart.Ticks
	 */
	module.exports = {
		/**
		 * Namespace to hold generators for different types of ticks
		 * @namespace Chart.Ticks.generators
		 */
		generators: {
			/**
			 * Interface for the options provided to the numeric tick generator
			 * @interface INumericTickGenerationOptions
			 */
			/**
			 * The maximum number of ticks to display
			 * @name INumericTickGenerationOptions#maxTicks
			 * @type Number
			 */
			/**
			 * The distance between each tick.
			 * @name INumericTickGenerationOptions#stepSize
			 * @type Number
			 * @optional
			 */
			/**
			 * Forced minimum for the ticks. If not specified, the minimum of the data range is used to calculate the tick minimum
			 * @name INumericTickGenerationOptions#min
			 * @type Number
			 * @optional
			 */
			/**
			 * The maximum value of the ticks. If not specified, the maximum of the data range is used to calculate the tick maximum
			 * @name INumericTickGenerationOptions#max
			 * @type Number
			 * @optional
			 */
	
			/**
			 * Generate a set of linear ticks
			 * @method Chart.Ticks.generators.linear
			 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
			 * @param dataRange {IRange} the range of the data
			 * @returns {Array<Number>} array of tick values
			 */
			linear: function(generationOptions, dataRange) {
				var ticks = [];
				// To get a "nice" value for the tick spacing, we will use the appropriately named
				// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
				// for details.
	
				var spacing;
				if (generationOptions.stepSize && generationOptions.stepSize > 0) {
					spacing = generationOptions.stepSize;
				} else {
					var niceRange = helpers.niceNum(dataRange.max - dataRange.min, false);
					spacing = helpers.niceNum(niceRange / (generationOptions.maxTicks - 1), true);
				}
				var niceMin = Math.floor(dataRange.min / spacing) * spacing;
				var niceMax = Math.ceil(dataRange.max / spacing) * spacing;
	
				// If min, max and stepSize is set and they make an evenly spaced scale use it.
				if (generationOptions.min && generationOptions.max && generationOptions.stepSize) {
					// If very close to our whole number, use it.
					if (helpers.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
						niceMin = generationOptions.min;
						niceMax = generationOptions.max;
					}
				}
	
				var numSpaces = (niceMax - niceMin) / spacing;
				// If very close to our rounded value, use it.
				if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
					numSpaces = Math.round(numSpaces);
				} else {
					numSpaces = Math.ceil(numSpaces);
				}
	
				// Put the values into the ticks array
				ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
				for (var j = 1; j < numSpaces; ++j) {
					ticks.push(niceMin + (j * spacing));
				}
				ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);
	
				return ticks;
			},
	
			/**
			 * Generate a set of logarithmic ticks
			 * @method Chart.Ticks.generators.logarithmic
			 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
			 * @param dataRange {IRange} the range of the data
			 * @returns {Array<Number>} array of tick values
			 */
			logarithmic: function(generationOptions, dataRange) {
				var ticks = [];
				var valueOrDefault = helpers.valueOrDefault;
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph
				var tickVal = valueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers.log10(dataRange.min))));
	
				var endExp = Math.floor(helpers.log10(dataRange.max));
				var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
				var exp, significand;
	
				if (tickVal === 0) {
					exp = Math.floor(helpers.log10(dataRange.minNotZero));
					significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
	
					ticks.push(tickVal);
					tickVal = significand * Math.pow(10, exp);
				} else {
					exp = Math.floor(helpers.log10(tickVal));
					significand = Math.floor(tickVal / Math.pow(10, exp));
				}
	
				do {
					ticks.push(tickVal);
	
					++significand;
					if (significand === 10) {
						significand = 1;
						++exp;
					}
	
					tickVal = significand * Math.pow(10, exp);
				} while (exp < endExp || (exp === endExp && significand < endSignificand));
	
				var lastTick = valueOrDefault(generationOptions.max, tickVal);
				ticks.push(lastTick);
	
				return ticks;
			}
		},
	
		/**
		 * Namespace to hold formatters for different types of ticks
		 * @namespace Chart.Ticks.formatters
		 */
		formatters: {
			/**
			 * Formatter for value labels
			 * @method Chart.Ticks.formatters.values
			 * @param value the value to display
			 * @return {String|Array} the label to display
			 */
			values: function(value) {
				return helpers.isArray(value) ? value : '' + value;
			},
	
			/**
			 * Formatter for linear numeric ticks
			 * @method Chart.Ticks.formatters.linear
			 * @param tickValue {Number} the value to be formatted
			 * @param index {Number} the position of the tickValue parameter in the ticks array
			 * @param ticks {Array<Number>} the list of ticks being converted
			 * @return {String} string representation of the tickValue parameter
			 */
			linear: function(tickValue, index, ticks) {
				// If we have lots of ticks, don't use the ones
				var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
				// If we have a number like 2.5 as the delta, figure out how many decimal places we need
				if (Math.abs(delta) > 1) {
					if (tickValue !== Math.floor(tickValue)) {
						// not an integer
						delta = tickValue - Math.floor(tickValue);
					}
				}
	
				var logDelta = helpers.log10(Math.abs(delta));
				var tickString = '';
	
				if (tickValue !== 0) {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				} else {
					tickString = '0'; // never show decimal places for 0
				}
	
				return tickString;
			},
	
			logarithmic: function(tickValue, index, ticks) {
				var remain = tickValue / (Math.pow(10, Math.floor(helpers.log10(tickValue))));
	
				if (tickValue === 0) {
					return '0';
				} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
					return tickValue.toExponential();
				}
				return '';
			}
		}
	};


/***/ },

/***/ "./node_modules/chart.js/src/core/core.tooltip.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var Element = __webpack_require__("./node_modules/chart.js/src/core/core.element.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	defaults._set('global', {
		tooltips: {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretPadding: 2,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers.noop,
				title: function(tooltipItems, data) {
					// Pick first xLabel for now
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
	
						if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers.noop,
				label: function(tooltipItem, data) {
					var label = data.datasets[tooltipItem.datasetIndex].label || '';
	
					if (label) {
						label += ': ';
					}
					label += tooltipItem.yLabel;
					return label;
				},
				labelColor: function(tooltipItem, chart) {
					var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				labelTextColor: function() {
					return this._options.bodyFontColor;
				},
				afterLabel: helpers.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers.noop,
				footer: helpers.noop,
				afterFooter: helpers.noop
			}
		}
	});
	
	module.exports = function(Chart) {
	
		/**
	 	 * Helper method to merge the opacity into a color
	 	 */
		function mergeOpacity(colorString, opacity) {
			var color = helpers.color(colorString);
			return color.alpha(opacity * color.alpha()).rgbaString();
		}
	
		// Helper to push or concat based on if the 2nd parameter is an array or not
		function pushOrConcat(base, toPush) {
			if (toPush) {
				if (helpers.isArray(toPush)) {
					// base = base.concat(toPush);
					Array.prototype.push.apply(base, toPush);
				} else {
					base.push(toPush);
				}
			}
	
			return base;
		}
	
		// Private helper to create a tooltip item model
		// @param element : the chart element (point, arc, bar) to create the tooltip item for
		// @return : new tooltip item
		function createTooltipItem(element) {
			var xScale = element._xScale;
			var yScale = element._yScale || element._scale; // handle radar || polarArea charts
			var index = element._index;
			var datasetIndex = element._datasetIndex;
	
			return {
				xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
				yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
				index: index,
				datasetIndex: datasetIndex,
				x: element._model.x,
				y: element._model.y
			};
		}
	
		/**
		 * Helper to get the reset model for the tooltip
		 * @param tooltipOpts {Object} the tooltip options
		 */
		function getBaseModel(tooltipOpts) {
			var globalDefaults = defaults.global;
			var valueOrDefault = helpers.valueOrDefault;
	
			return {
				// Positioning
				xPadding: tooltipOpts.xPadding,
				yPadding: tooltipOpts.yPadding,
				xAlign: tooltipOpts.xAlign,
				yAlign: tooltipOpts.yAlign,
	
				// Body
				bodyFontColor: tooltipOpts.bodyFontColor,
				_bodyFontFamily: valueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
				_bodyFontStyle: valueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
				_bodyAlign: tooltipOpts.bodyAlign,
				bodyFontSize: valueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
				bodySpacing: tooltipOpts.bodySpacing,
	
				// Title
				titleFontColor: tooltipOpts.titleFontColor,
				_titleFontFamily: valueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
				_titleFontStyle: valueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
				titleFontSize: valueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
				_titleAlign: tooltipOpts.titleAlign,
				titleSpacing: tooltipOpts.titleSpacing,
				titleMarginBottom: tooltipOpts.titleMarginBottom,
	
				// Footer
				footerFontColor: tooltipOpts.footerFontColor,
				_footerFontFamily: valueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
				_footerFontStyle: valueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
				footerFontSize: valueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
				_footerAlign: tooltipOpts.footerAlign,
				footerSpacing: tooltipOpts.footerSpacing,
				footerMarginTop: tooltipOpts.footerMarginTop,
	
				// Appearance
				caretSize: tooltipOpts.caretSize,
				cornerRadius: tooltipOpts.cornerRadius,
				backgroundColor: tooltipOpts.backgroundColor,
				opacity: 0,
				legendColorBackground: tooltipOpts.multiKeyBackground,
				displayColors: tooltipOpts.displayColors,
				borderColor: tooltipOpts.borderColor,
				borderWidth: tooltipOpts.borderWidth
			};
		}
	
		/**
		 * Get the size of the tooltip
		 */
		function getTooltipSize(tooltip, model) {
			var ctx = tooltip._chart.ctx;
	
			var height = model.yPadding * 2; // Tooltip Padding
			var width = 0;
	
			// Count of all lines in the body
			var body = model.body;
			var combinedBodyLength = body.reduce(function(count, bodyItem) {
				return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
			}, 0);
			combinedBodyLength += model.beforeBody.length + model.afterBody.length;
	
			var titleLineCount = model.title.length;
			var footerLineCount = model.footer.length;
			var titleFontSize = model.titleFontSize;
			var bodyFontSize = model.bodyFontSize;
			var footerFontSize = model.footerFontSize;
	
			height += titleLineCount * titleFontSize; // Title Lines
			height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
			height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
			height += combinedBodyLength * bodyFontSize; // Body Lines
			height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
			height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
			height += footerLineCount * (footerFontSize); // Footer Lines
			height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
	
			// Title width
			var widthPadding = 0;
			var maxLineWidth = function(line) {
				width = Math.max(width, ctx.measureText(line).width + widthPadding);
			};
	
			ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
			helpers.each(model.title, maxLineWidth);
	
			// Body width
			ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
			helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
	
			// Body lines may include some extra width due to the color box
			widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
			helpers.each(body, function(bodyItem) {
				helpers.each(bodyItem.before, maxLineWidth);
				helpers.each(bodyItem.lines, maxLineWidth);
				helpers.each(bodyItem.after, maxLineWidth);
			});
	
			// Reset back to 0
			widthPadding = 0;
	
			// Footer width
			ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
			helpers.each(model.footer, maxLineWidth);
	
			// Add padding
			width += 2 * model.xPadding;
	
			return {
				width: width,
				height: height
			};
		}
	
		/**
		 * Helper to get the alignment of a tooltip given the size
		 */
		function determineAlignment(tooltip, size) {
			var model = tooltip._model;
			var chart = tooltip._chart;
			var chartArea = tooltip._chart.chartArea;
			var xAlign = 'center';
			var yAlign = 'center';
	
			if (model.y < size.height) {
				yAlign = 'top';
			} else if (model.y > (chart.height - size.height)) {
				yAlign = 'bottom';
			}
	
			var lf, rf; // functions to determine left, right alignment
			var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
			var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
			var midX = (chartArea.left + chartArea.right) / 2;
			var midY = (chartArea.top + chartArea.bottom) / 2;
	
			if (yAlign === 'center') {
				lf = function(x) {
					return x <= midX;
				};
				rf = function(x) {
					return x > midX;
				};
			} else {
				lf = function(x) {
					return x <= (size.width / 2);
				};
				rf = function(x) {
					return x >= (chart.width - (size.width / 2));
				};
			}
	
			olf = function(x) {
				return x + size.width > chart.width;
			};
			orf = function(x) {
				return x - size.width < 0;
			};
			yf = function(y) {
				return y <= midY ? 'top' : 'bottom';
			};
	
			if (lf(model.x)) {
				xAlign = 'left';
	
				// Is tooltip too wide and goes over the right side of the chart.?
				if (olf(model.x)) {
					xAlign = 'center';
					yAlign = yf(model.y);
				}
			} else if (rf(model.x)) {
				xAlign = 'right';
	
				// Is tooltip too wide and goes outside left edge of canvas?
				if (orf(model.x)) {
					xAlign = 'center';
					yAlign = yf(model.y);
				}
			}
	
			var opts = tooltip._options;
			return {
				xAlign: opts.xAlign ? opts.xAlign : xAlign,
				yAlign: opts.yAlign ? opts.yAlign : yAlign
			};
		}
	
		/**
		 * @Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
		 */
		function getBackgroundPoint(vm, size, alignment) {
			// Background Position
			var x = vm.x;
			var y = vm.y;
	
			var caretSize = vm.caretSize;
			var caretPadding = vm.caretPadding;
			var cornerRadius = vm.cornerRadius;
			var xAlign = alignment.xAlign;
			var yAlign = alignment.yAlign;
			var paddingAndSize = caretSize + caretPadding;
			var radiusAndPadding = cornerRadius + caretPadding;
	
			if (xAlign === 'right') {
				x -= size.width;
			} else if (xAlign === 'center') {
				x -= (size.width / 2);
			}
	
			if (yAlign === 'top') {
				y += paddingAndSize;
			} else if (yAlign === 'bottom') {
				y -= size.height + paddingAndSize;
			} else {
				y -= (size.height / 2);
			}
	
			if (yAlign === 'center') {
				if (xAlign === 'left') {
					x += paddingAndSize;
				} else if (xAlign === 'right') {
					x -= paddingAndSize;
				}
			} else if (xAlign === 'left') {
				x -= radiusAndPadding;
			} else if (xAlign === 'right') {
				x += radiusAndPadding;
			}
	
			return {
				x: x,
				y: y
			};
		}
	
		Chart.Tooltip = Element.extend({
			initialize: function() {
				this._model = getBaseModel(this._options);
				this._lastActive = [];
			},
	
			// Get the title
			// Args are: (tooltipItem, data)
			getTitle: function() {
				var me = this;
				var opts = me._options;
				var callbacks = opts.callbacks;
	
				var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
				var title = callbacks.title.apply(me, arguments);
				var afterTitle = callbacks.afterTitle.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeTitle);
				lines = pushOrConcat(lines, title);
				lines = pushOrConcat(lines, afterTitle);
	
				return lines;
			},
	
			// Args are: (tooltipItem, data)
			getBeforeBody: function() {
				var lines = this._options.callbacks.beforeBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Args are: (tooltipItem, data)
			getBody: function(tooltipItems, data) {
				var me = this;
				var callbacks = me._options.callbacks;
				var bodyItems = [];
	
				helpers.each(tooltipItems, function(tooltipItem) {
					var bodyItem = {
						before: [],
						lines: [],
						after: []
					};
					pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));
	
					bodyItems.push(bodyItem);
				});
	
				return bodyItems;
			},
	
			// Args are: (tooltipItem, data)
			getAfterBody: function() {
				var lines = this._options.callbacks.afterBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Get the footer and beforeFooter and afterFooter lines
			// Args are: (tooltipItem, data)
			getFooter: function() {
				var me = this;
				var callbacks = me._options.callbacks;
	
				var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
				var footer = callbacks.footer.apply(me, arguments);
				var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeFooter);
				lines = pushOrConcat(lines, footer);
				lines = pushOrConcat(lines, afterFooter);
	
				return lines;
			},
	
			update: function(changed) {
				var me = this;
				var opts = me._options;
	
				// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
				// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
				// which breaks any animations.
				var existingModel = me._model;
				var model = me._model = getBaseModel(opts);
				var active = me._active;
	
				var data = me._data;
	
				// In the case where active.length === 0 we need to keep these at existing values for good animations
				var alignment = {
					xAlign: existingModel.xAlign,
					yAlign: existingModel.yAlign
				};
				var backgroundPoint = {
					x: existingModel.x,
					y: existingModel.y
				};
				var tooltipSize = {
					width: existingModel.width,
					height: existingModel.height
				};
				var tooltipPosition = {
					x: existingModel.caretX,
					y: existingModel.caretY
				};
	
				var i, len;
	
				if (active.length) {
					model.opacity = 1;
	
					var labelColors = [];
					var labelTextColors = [];
					tooltipPosition = Chart.Tooltip.positioners[opts.position].call(me, active, me._eventPosition);
	
					var tooltipItems = [];
					for (i = 0, len = active.length; i < len; ++i) {
						tooltipItems.push(createTooltipItem(active[i]));
					}
	
					// If the user provided a filter function, use it to modify the tooltip items
					if (opts.filter) {
						tooltipItems = tooltipItems.filter(function(a) {
							return opts.filter(a, data);
						});
					}
	
					// If the user provided a sorting function, use it to modify the tooltip items
					if (opts.itemSort) {
						tooltipItems = tooltipItems.sort(function(a, b) {
							return opts.itemSort(a, b, data);
						});
					}
	
					// Determine colors for boxes
					helpers.each(tooltipItems, function(tooltipItem) {
						labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
						labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
					});
	
	
					// Build the Text Lines
					model.title = me.getTitle(tooltipItems, data);
					model.beforeBody = me.getBeforeBody(tooltipItems, data);
					model.body = me.getBody(tooltipItems, data);
					model.afterBody = me.getAfterBody(tooltipItems, data);
					model.footer = me.getFooter(tooltipItems, data);
	
					// Initial positioning and colors
					model.x = Math.round(tooltipPosition.x);
					model.y = Math.round(tooltipPosition.y);
					model.caretPadding = opts.caretPadding;
					model.labelColors = labelColors;
					model.labelTextColors = labelTextColors;
	
					// data points
					model.dataPoints = tooltipItems;
	
					// We need to determine alignment of the tooltip
					tooltipSize = getTooltipSize(this, model);
					alignment = determineAlignment(this, tooltipSize);
					// Final Size and Position
					backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment);
				} else {
					model.opacity = 0;
				}
	
				model.xAlign = alignment.xAlign;
				model.yAlign = alignment.yAlign;
				model.x = backgroundPoint.x;
				model.y = backgroundPoint.y;
				model.width = tooltipSize.width;
				model.height = tooltipSize.height;
	
				// Point where the caret on the tooltip points to
				model.caretX = tooltipPosition.x;
				model.caretY = tooltipPosition.y;
	
				me._model = model;
	
				if (changed && opts.custom) {
					opts.custom.call(me, model);
				}
	
				return me;
			},
			drawCaret: function(tooltipPoint, size) {
				var ctx = this._chart.ctx;
				var vm = this._view;
				var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
	
				ctx.lineTo(caretPosition.x1, caretPosition.y1);
				ctx.lineTo(caretPosition.x2, caretPosition.y2);
				ctx.lineTo(caretPosition.x3, caretPosition.y3);
			},
			getCaretPosition: function(tooltipPoint, size, vm) {
				var x1, x2, x3, y1, y2, y3;
				var caretSize = vm.caretSize;
				var cornerRadius = vm.cornerRadius;
				var xAlign = vm.xAlign;
				var yAlign = vm.yAlign;
				var ptX = tooltipPoint.x;
				var ptY = tooltipPoint.y;
				var width = size.width;
				var height = size.height;
	
				if (yAlign === 'center') {
					y2 = ptY + (height / 2);
	
					if (xAlign === 'left') {
						x1 = ptX;
						x2 = x1 - caretSize;
						x3 = x1;
	
						y1 = y2 + caretSize;
						y3 = y2 - caretSize;
					} else {
						x1 = ptX + width;
						x2 = x1 + caretSize;
						x3 = x1;
	
						y1 = y2 - caretSize;
						y3 = y2 + caretSize;
					}
				} else {
					if (xAlign === 'left') {
						x2 = ptX + cornerRadius + (caretSize);
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					} else if (xAlign === 'right') {
						x2 = ptX + width - cornerRadius - caretSize;
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					} else {
						x2 = ptX + (width / 2);
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					}
					if (yAlign === 'top') {
						y1 = ptY;
						y2 = y1 - caretSize;
						y3 = y1;
					} else {
						y1 = ptY + height;
						y2 = y1 + caretSize;
						y3 = y1;
						// invert drawing order
						var tmp = x3;
						x3 = x1;
						x1 = tmp;
					}
				}
				return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
			},
			drawTitle: function(pt, vm, ctx, opacity) {
				var title = vm.title;
	
				if (title.length) {
					ctx.textAlign = vm._titleAlign;
					ctx.textBaseline = 'top';
	
					var titleFontSize = vm.titleFontSize;
					var titleSpacing = vm.titleSpacing;
	
					ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
					ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
					var i, len;
					for (i = 0, len = title.length; i < len; ++i) {
						ctx.fillText(title[i], pt.x, pt.y);
						pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
						if (i + 1 === title.length) {
							pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
						}
					}
				}
			},
			drawBody: function(pt, vm, ctx, opacity) {
				var bodyFontSize = vm.bodyFontSize;
				var bodySpacing = vm.bodySpacing;
				var body = vm.body;
	
				ctx.textAlign = vm._bodyAlign;
				ctx.textBaseline = 'top';
				ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
				// Before Body
				var xLinePadding = 0;
				var fillLineOfText = function(line) {
					ctx.fillText(line, pt.x + xLinePadding, pt.y);
					pt.y += bodyFontSize + bodySpacing;
				};
	
				// Before body lines
				ctx.fillStyle = mergeOpacity(vm.bodyFontColor, opacity);
				helpers.each(vm.beforeBody, fillLineOfText);
	
				var drawColorBoxes = vm.displayColors;
				xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;
	
				// Draw body lines now
				helpers.each(body, function(bodyItem, i) {
					var textColor = mergeOpacity(vm.labelTextColors[i], opacity);
					ctx.fillStyle = textColor;
					helpers.each(bodyItem.before, fillLineOfText);
	
					helpers.each(bodyItem.lines, function(line) {
						// Draw Legend-like boxes if needed
						if (drawColorBoxes) {
							// Fill a white rect so that colours merge nicely if the opacity is < 1
							ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
							ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Border
							ctx.lineWidth = 1;
							ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
							ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Inner square
							ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
							ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
							ctx.fillStyle = textColor;
						}
	
						fillLineOfText(line);
					});
	
					helpers.each(bodyItem.after, fillLineOfText);
				});
	
				// Reset back to 0 for after body
				xLinePadding = 0;
	
				// After body lines
				helpers.each(vm.afterBody, fillLineOfText);
				pt.y -= bodySpacing; // Remove last body spacing
			},
			drawFooter: function(pt, vm, ctx, opacity) {
				var footer = vm.footer;
	
				if (footer.length) {
					pt.y += vm.footerMarginTop;
	
					ctx.textAlign = vm._footerAlign;
					ctx.textBaseline = 'top';
	
					ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
					ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
					helpers.each(footer, function(line) {
						ctx.fillText(line, pt.x, pt.y);
						pt.y += vm.footerFontSize + vm.footerSpacing;
					});
				}
			},
			drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
				ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
				ctx.strokeStyle = mergeOpacity(vm.borderColor, opacity);
				ctx.lineWidth = vm.borderWidth;
				var xAlign = vm.xAlign;
				var yAlign = vm.yAlign;
				var x = pt.x;
				var y = pt.y;
				var width = tooltipSize.width;
				var height = tooltipSize.height;
				var radius = vm.cornerRadius;
	
				ctx.beginPath();
				ctx.moveTo(x + radius, y);
				if (yAlign === 'top') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x + width - radius, y);
				ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
				if (yAlign === 'center' && xAlign === 'right') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x + width, y + height - radius);
				ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
				if (yAlign === 'bottom') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x + radius, y + height);
				ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
				if (yAlign === 'center' && xAlign === 'left') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x, y + radius);
				ctx.quadraticCurveTo(x, y, x + radius, y);
				ctx.closePath();
	
				ctx.fill();
	
				if (vm.borderWidth > 0) {
					ctx.stroke();
				}
			},
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
	
				if (vm.opacity === 0) {
					return;
				}
	
				var tooltipSize = {
					width: vm.width,
					height: vm.height
				};
				var pt = {
					x: vm.x,
					y: vm.y
				};
	
				// IE11/Edge does not like very small opacities, so snap to 0
				var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
				// Truthy/falsey value for empty tooltip
				var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
	
				if (this._options.enabled && hasTooltipContent) {
					// Draw Background
					this.drawBackground(pt, vm, ctx, tooltipSize, opacity);
	
					// Draw Title, Body, and Footer
					pt.x += vm.xPadding;
					pt.y += vm.yPadding;
	
					// Titles
					this.drawTitle(pt, vm, ctx, opacity);
	
					// Body
					this.drawBody(pt, vm, ctx, opacity);
	
					// Footer
					this.drawFooter(pt, vm, ctx, opacity);
				}
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event - The event to handle
			 * @returns {Boolean} true if the tooltip changed
			 */
			handleEvent: function(e) {
				var me = this;
				var options = me._options;
				var changed = false;
	
				me._lastActive = me._lastActive || [];
	
				// Find Active Elements for tooltips
				if (e.type === 'mouseout') {
					me._active = [];
				} else {
					me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
				}
	
				// Remember Last Actives
				changed = !helpers.arrayEquals(me._active, me._lastActive);
	
				// If tooltip didn't change, do not handle the target event
				if (!changed) {
					return false;
				}
	
				me._lastActive = me._active;
	
				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};
	
					var model = me._model;
					me.update(true);
					me.pivot();
	
					// See if our tooltip position changed
					changed |= (model.x !== me._model.x) || (model.y !== me._model.y);
				}
	
				return changed;
			}
		});
	
		/**
		 * @namespace Chart.Tooltip.positioners
		 */
		Chart.Tooltip.positioners = {
			/**
			 * Average mode places the tooltip at the average position of the elements shown
			 * @function Chart.Tooltip.positioners.average
			 * @param elements {ChartElement[]} the elements being displayed in the tooltip
			 * @returns {Point} tooltip position
			 */
			average: function(elements) {
				if (!elements.length) {
					return false;
				}
	
				var i, len;
				var x = 0;
				var y = 0;
				var count = 0;
	
				for (i = 0, len = elements.length; i < len; ++i) {
					var el = elements[i];
					if (el && el.hasValue()) {
						var pos = el.tooltipPosition();
						x += pos.x;
						y += pos.y;
						++count;
					}
				}
	
				return {
					x: Math.round(x / count),
					y: Math.round(y / count)
				};
			},
	
			/**
			 * Gets the tooltip position nearest of the item nearest to the event position
			 * @function Chart.Tooltip.positioners.nearest
			 * @param elements {Chart.Element[]} the tooltip elements
			 * @param eventPosition {Point} the position of the event in canvas coordinates
			 * @returns {Point} the tooltip position
			 */
			nearest: function(elements, eventPosition) {
				var x = eventPosition.x;
				var y = eventPosition.y;
				var minDistance = Number.POSITIVE_INFINITY;
				var i, len, nearestElement;
	
				for (i = 0, len = elements.length; i < len; ++i) {
					var el = elements[i];
					if (el && el.hasValue()) {
						var center = el.getCenterPoint();
						var d = helpers.distanceBetweenPoints(eventPosition, center);
	
						if (d < minDistance) {
							minDistance = d;
							nearestElement = el;
						}
					}
				}
	
				if (nearestElement) {
					var tp = nearestElement.tooltipPosition();
					x = tp.x;
					y = tp.y;
				}
	
				return {
					x: x,
					y: y
				};
			}
		};
	};


/***/ },

/***/ "./node_modules/chart.js/src/scales/scale.linearbase.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	var Ticks = __webpack_require__("./node_modules/chart.js/src/core/core.ticks.js");
	
	module.exports = function(Chart) {
	
		var noop = helpers.noop;
	
		Chart.LinearScaleBase = Chart.Scale.extend({
			getRightValue: function(value) {
				if (typeof value === 'string') {
					return +value;
				}
				return Chart.Scale.prototype.getRightValue.call(this, value);
			},
	
			handleTickRangeOptions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
				// do nothing since that would make the chart weird. If the user really wants a weird chart
				// axis, they can manually override it
				if (tickOpts.beginAtZero) {
					var minSign = helpers.sign(me.min);
					var maxSign = helpers.sign(me.max);
	
					if (minSign < 0 && maxSign < 0) {
						// move the top up to 0
						me.max = 0;
					} else if (minSign > 0 && maxSign > 0) {
						// move the bottom down to 0
						me.min = 0;
					}
				}
	
				var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
				var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
	
				if (tickOpts.min !== undefined) {
					me.min = tickOpts.min;
				} else if (tickOpts.suggestedMin !== undefined) {
					if (me.min === null) {
						me.min = tickOpts.suggestedMin;
					} else {
						me.min = Math.min(me.min, tickOpts.suggestedMin);
					}
				}
	
				if (tickOpts.max !== undefined) {
					me.max = tickOpts.max;
				} else if (tickOpts.suggestedMax !== undefined) {
					if (me.max === null) {
						me.max = tickOpts.suggestedMax;
					} else {
						me.max = Math.max(me.max, tickOpts.suggestedMax);
					}
				}
	
				if (setMin !== setMax) {
					// We set the min or the max but not both.
					// So ensure that our range is good
					// Inverted or 0 length range can happen when
					// ticks.min is set, and no datasets are visible
					if (me.min >= me.max) {
						if (setMin) {
							me.max = me.min + 1;
						} else {
							me.min = me.max - 1;
						}
					}
				}
	
				if (me.min === me.max) {
					me.max++;
	
					if (!tickOpts.beginAtZero) {
						me.min--;
					}
				}
			},
			getTickLimit: noop,
			handleDirectionalChanges: noop,
	
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph. Make sure we always have at least 2 ticks
				var maxTicks = me.getTickLimit();
				maxTicks = Math.max(2, maxTicks);
	
				var numericGeneratorOptions = {
					maxTicks: maxTicks,
					min: tickOpts.min,
					max: tickOpts.max,
					stepSize: helpers.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
				};
				var ticks = me.ticks = Ticks.generators.linear(numericGeneratorOptions, me);
	
				me.handleDirectionalChanges();
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				var me = this;
				me.ticksAsNumbers = me.ticks.slice();
				me.zeroLineIndex = me.ticks.indexOf(0);
	
				Chart.Scale.prototype.convertTicksToLabels.call(me);
			}
		});
	};


/***/ },

/***/ "./node_modules/chart.js/src/scales/scale.category.js":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		// Default config for a category scale
		var defaultConfig = {
			position: 'bottom'
		};
	
		var DatasetScale = Chart.Scale.extend({
			/**
			* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
			* else fall back to data.labels
			* @private
			*/
			getLabels: function() {
				var data = this.chart.data;
				return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
			},
	
			determineDataLimits: function() {
				var me = this;
				var labels = me.getLabels();
				me.minIndex = 0;
				me.maxIndex = labels.length - 1;
				var findIndex;
	
				if (me.options.ticks.min !== undefined) {
					// user specified min value
					findIndex = labels.indexOf(me.options.ticks.min);
					me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
				}
	
				if (me.options.ticks.max !== undefined) {
					// user specified max value
					findIndex = labels.indexOf(me.options.ticks.max);
					me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
				}
	
				me.min = labels[me.minIndex];
				me.max = labels[me.maxIndex];
			},
	
			buildTicks: function() {
				var me = this;
				var labels = me.getLabels();
				// If we are viewing some subset of labels, slice the original array
				me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
			},
	
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var data = me.chart.data;
				var isHorizontal = me.isHorizontal();
	
				if (data.yLabels && !isHorizontal) {
					return me.getRightValue(data.datasets[datasetIndex].data[index]);
				}
				return me.ticks[index - me.minIndex];
			},
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: function(value, index) {
				var me = this;
				var offset = me.options.offset;
				// 1 is added because we need the length but we have the indexes
				var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - (offset ? 0 : 1)), 1);
	
				// If value is a data object, then index is the index in the data array,
				// not the index of the scale. We need to change that.
				var valueCategory;
				if (value !== undefined && value !== null) {
					valueCategory = me.isHorizontal() ? value.x : value.y;
				}
				if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
					var labels = me.getLabels();
					value = valueCategory || value;
					var idx = labels.indexOf(value);
					index = idx !== -1 ? idx : index;
				}
	
				if (me.isHorizontal()) {
					var valueWidth = me.width / offsetAmt;
					var widthOffset = (valueWidth * (index - me.minIndex));
	
					if (offset) {
						widthOffset += (valueWidth / 2);
					}
	
					return me.left + Math.round(widthOffset);
				}
				var valueHeight = me.height / offsetAmt;
				var heightOffset = (valueHeight * (index - me.minIndex));
	
				if (offset) {
					heightOffset += (valueHeight / 2);
				}
	
				return me.top + Math.round(heightOffset);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.ticks[index], index + this.minIndex, null);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var offset = me.options.offset;
				var value;
				var offsetAmt = Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
				var horz = me.isHorizontal();
				var valueDimension = (horz ? me.width : me.height) / offsetAmt;
	
				pixel -= horz ? me.left : me.top;
	
				if (offset) {
					pixel -= (valueDimension / 2);
				}
	
				if (pixel <= 0) {
					value = 0;
				} else {
					value = Math.round(pixel / valueDimension);
				}
	
				return value + me.minIndex;
			},
			getBasePixel: function() {
				return this.bottom;
			}
		});
	
		Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);
	
	};


/***/ },

/***/ "./node_modules/chart.js/src/scales/scale.linear.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	var Ticks = __webpack_require__("./node_modules/chart.js/src/core/core.ticks.js");
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			position: 'left',
			ticks: {
				callback: Ticks.formatters.linear
			}
		};
	
		var LinearScale = Chart.LinearScaleBase.extend({
	
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var isHorizontal = me.isHorizontal();
				var DEFAULT_MIN = 0;
				var DEFAULT_MAX = 1;
	
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// First Calculate the range
				me.min = null;
				me.max = null;
	
				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}
	
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}
	
				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');
	
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = {
								positiveValues: [],
								negativeValues: []
							};
						}
	
						// Store these per type
						var positiveValues = valuesPerStack[key].positiveValues;
						var negativeValues = valuesPerStack[key].negativeValues;
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								positiveValues[index] = positiveValues[index] || 0;
								negativeValues[index] = negativeValues[index] || 0;
	
								if (opts.relativePoints) {
									positiveValues[index] = 100;
								} else if (value < 0) {
									negativeValues[index] += value;
								} else {
									positiveValues[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerStack, function(valuesForType) {
						var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
						var minVal = helpers.min(values);
						var maxVal = helpers.max(values);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
							});
						}
					});
				}
	
				me.min = isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
				me.max = isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				this.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var maxTicks;
				var me = this;
				var tickOpts = me.options.ticks;
	
				if (me.isHorizontal()) {
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
				} else {
					// The factor of 2 used to scale the font size has been experimentally determined.
					var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, defaults.global.defaultFontSize);
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
				}
	
				return maxTicks;
			},
			// Called after the ticks are built. We need
			handleDirectionalChanges: function() {
				if (!this.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					this.ticks.reverse();
				}
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			// Utils
			getPixelForValue: function(value) {
				// This must be called after fit has been run so that
				// this.left, this.top, this.right, and this.bottom have been defined
				var me = this;
				var start = me.start;
	
				var rightValue = +me.getRightValue(value);
				var pixel;
				var range = me.end - start;
	
				if (me.isHorizontal()) {
					pixel = me.left + (me.width / range * (rightValue - start));
					return Math.round(pixel);
				}
	
				pixel = me.bottom - (me.height / range * (rightValue - start));
				return Math.round(pixel);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var isHorizontal = me.isHorizontal();
				var innerDimension = isHorizontal ? me.width : me.height;
				var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
				return me.start + ((me.end - me.start) * offset);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.ticksAsNumbers[index]);
			}
		});
		Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);
	
	};


/***/ },

/***/ "./node_modules/chart.js/src/scales/scale.logarithmic.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	var Ticks = __webpack_require__("./node_modules/chart.js/src/core/core.ticks.js");
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			position: 'left',
	
			// label settings
			ticks: {
				callback: Ticks.formatters.logarithmic
			}
		};
	
		var LogarithmicScale = Chart.Scale.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var valueOrDefault = helpers.valueOrDefault;
				var isHorizontal = me.isHorizontal();
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// Calculate Range
				me.min = null;
				me.max = null;
				me.minNotZero = null;
	
				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}
	
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}
	
				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							if (valuesPerStack[key] === undefined) {
								valuesPerStack[key] = [];
							}
	
							helpers.each(dataset.data, function(rawValue, index) {
								var values = valuesPerStack[key];
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								values[index] = values[index] || 0;
	
								if (opts.relativePoints) {
									values[index] = 100;
								} else {
									// Don't need to split positive and negative since the log scale can't handle a 0 crossing
									values[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerStack, function(valuesForType) {
						var minVal = helpers.min(valuesForType);
						var maxVal = helpers.max(valuesForType);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
	
								if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
									me.minNotZero = value;
								}
							});
						}
					});
				}
	
				me.min = valueOrDefault(tickOpts.min, me.min);
				me.max = valueOrDefault(tickOpts.max, me.max);
	
				if (me.min === me.max) {
					if (me.min !== 0 && me.min !== null) {
						me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
						me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
					} else {
						me.min = 1;
						me.max = 10;
					}
				}
			},
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				var generationOptions = {
					min: tickOpts.min,
					max: tickOpts.max
				};
				var ticks = me.ticks = Ticks.generators.logarithmic(generationOptions, me);
	
				if (!me.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					ticks.reverse();
				}
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				this.tickValues = this.ticks.slice();
	
				Chart.Scale.prototype.convertTicksToLabels.call(this);
			},
			// Get the correct tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickValues[index]);
			},
			getPixelForValue: function(value) {
				var me = this;
				var start = me.start;
				var newVal = +me.getRightValue(value);
				var opts = me.options;
				var tickOpts = opts.ticks;
				var innerDimension, pixel, range;
	
				if (me.isHorizontal()) {
					range = helpers.log10(me.end) - helpers.log10(start); // todo: if start === 0
					if (newVal === 0) {
						pixel = me.left;
					} else {
						innerDimension = me.width;
						pixel = me.left + (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
					}
				} else {
					// Bottom - top since pixels increase downward on a screen
					innerDimension = me.height;
					if (start === 0 && !tickOpts.reverse) {
						range = helpers.log10(me.end) - helpers.log10(me.minNotZero);
						if (newVal === start) {
							pixel = me.bottom;
						} else if (newVal === me.minNotZero) {
							pixel = me.bottom - innerDimension * 0.02;
						} else {
							pixel = me.bottom - innerDimension * 0.02 - (innerDimension * 0.98 / range * (helpers.log10(newVal) - helpers.log10(me.minNotZero)));
						}
					} else if (me.end === 0 && tickOpts.reverse) {
						range = helpers.log10(me.start) - helpers.log10(me.minNotZero);
						if (newVal === me.end) {
							pixel = me.top;
						} else if (newVal === me.minNotZero) {
							pixel = me.top + innerDimension * 0.02;
						} else {
							pixel = me.top + innerDimension * 0.02 + (innerDimension * 0.98 / range * (helpers.log10(newVal) - helpers.log10(me.minNotZero)));
						}
					} else if (newVal === 0) {
						pixel = tickOpts.reverse ? me.top : me.bottom;
					} else {
						range = helpers.log10(me.end) - helpers.log10(start);
						innerDimension = me.height;
						pixel = me.bottom - (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
					}
				}
				return pixel;
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var range = helpers.log10(me.end) - helpers.log10(me.start);
				var value, innerDimension;
	
				if (me.isHorizontal()) {
					innerDimension = me.width;
					value = me.start * Math.pow(10, (pixel - me.left) * range / innerDimension);
				} else { // todo: if start === 0
					innerDimension = me.height;
					value = Math.pow(10, (me.bottom - pixel) * range / innerDimension) / me.start;
				}
				return value;
			}
		});
		Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);
	
	};


/***/ },

/***/ "./node_modules/chart.js/src/scales/scale.radialLinear.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	var Ticks = __webpack_require__("./node_modules/chart.js/src/core/core.ticks.js");
	
	module.exports = function(Chart) {
	
		var globalDefaults = defaults.global;
	
		var defaultConfig = {
			display: true,
	
			// Boolean - Whether to animate scaling the chart from the centre
			animate: true,
			position: 'chartArea',
	
			angleLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1
			},
	
			gridLines: {
				circular: false
			},
	
			// label settings
			ticks: {
				// Boolean - Show a backdrop to the scale label
				showLabelBackdrop: true,
	
				// String - The colour of the label backdrop
				backdropColor: 'rgba(255,255,255,0.75)',
	
				// Number - The backdrop padding above & below the label in pixels
				backdropPaddingY: 2,
	
				// Number - The backdrop padding to the side of the label in pixels
				backdropPaddingX: 2,
	
				callback: Ticks.formatters.linear
			},
	
			pointLabels: {
				// Boolean - if true, show point labels
				display: true,
	
				// Number - Point label font size in pixels
				fontSize: 10,
	
				// Function - Used to convert point labels
				callback: function(label) {
					return label;
				}
			}
		};
	
		function getValueCount(scale) {
			var opts = scale.options;
			return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
		}
	
		function getPointLabelFontOptions(scale) {
			var pointLabelOptions = scale.options.pointLabels;
			var fontSize = helpers.valueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
			var fontStyle = helpers.valueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
			var fontFamily = helpers.valueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
			var font = helpers.fontString(fontSize, fontStyle, fontFamily);
	
			return {
				size: fontSize,
				style: fontStyle,
				family: fontFamily,
				font: font
			};
		}
	
		function measureLabelSize(ctx, fontSize, label) {
			if (helpers.isArray(label)) {
				return {
					w: helpers.longestText(ctx, ctx.font, label),
					h: (label.length * fontSize) + ((label.length - 1) * 1.5 * fontSize)
				};
			}
	
			return {
				w: ctx.measureText(label).width,
				h: fontSize
			};
		}
	
		function determineLimits(angle, pos, size, min, max) {
			if (angle === min || angle === max) {
				return {
					start: pos - (size / 2),
					end: pos + (size / 2)
				};
			} else if (angle < min || angle > max) {
				return {
					start: pos - size - 5,
					end: pos
				};
			}
	
			return {
				start: pos,
				end: pos + size + 5
			};
		}
	
		/**
		 * Helper function to fit a radial linear scale with point labels
		 */
		function fitWithPointLabels(scale) {
			/*
			 * Right, this is really confusing and there is a lot of maths going on here
			 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
			 *
			 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
			 *
			 * Solution:
			 *
			 * We assume the radius of the polygon is half the size of the canvas at first
			 * at each index we check if the text overlaps.
			 *
			 * Where it does, we store that angle and that index.
			 *
			 * After finding the largest index and angle we calculate how much we need to remove
			 * from the shape radius to move the point inwards by that x.
			 *
			 * We average the left and right distances to get the maximum shape radius that can fit in the box
			 * along with labels.
			 *
			 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
			 * on each side, removing that from the size, halving it and adding the left x protrusion width.
			 *
			 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
			 * and position it in the most space efficient manner
			 *
			 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
			 */
	
			var plFont = getPointLabelFontOptions(scale);
	
			// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
			// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			var furthestLimits = {
				r: scale.width,
				l: 0,
				t: scale.height,
				b: 0
			};
			var furthestAngles = {};
			var i, textSize, pointPosition;
	
			scale.ctx.font = plFont.font;
			scale._pointLabelSizes = [];
	
			var valueCount = getValueCount(scale);
			for (i = 0; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, largestPossibleRadius);
				textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
				scale._pointLabelSizes[i] = textSize;
	
				// Add quarter circle to make degree 0 mean top of circle
				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians) % 360;
				var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
				var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
	
				if (hLimits.start < furthestLimits.l) {
					furthestLimits.l = hLimits.start;
					furthestAngles.l = angleRadians;
				}
	
				if (hLimits.end > furthestLimits.r) {
					furthestLimits.r = hLimits.end;
					furthestAngles.r = angleRadians;
				}
	
				if (vLimits.start < furthestLimits.t) {
					furthestLimits.t = vLimits.start;
					furthestAngles.t = angleRadians;
				}
	
				if (vLimits.end > furthestLimits.b) {
					furthestLimits.b = vLimits.end;
					furthestAngles.b = angleRadians;
				}
			}
	
			scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
		}
	
		/**
		 * Helper function to fit a radial linear scale with no point labels
		 */
		function fit(scale) {
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			scale.drawingArea = Math.round(largestPossibleRadius);
			scale.setCenterPoint(0, 0, 0, 0);
		}
	
		function getTextAlignForAngle(angle) {
			if (angle === 0 || angle === 180) {
				return 'center';
			} else if (angle < 180) {
				return 'left';
			}
	
			return 'right';
		}
	
		function fillText(ctx, text, position, fontSize) {
			if (helpers.isArray(text)) {
				var y = position.y;
				var spacing = 1.5 * fontSize;
	
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], position.x, y);
					y += spacing;
				}
			} else {
				ctx.fillText(text, position.x, position.y);
			}
		}
	
		function adjustPointPositionForLabelHeight(angle, textSize, position) {
			if (angle === 90 || angle === 270) {
				position.y -= (textSize.h / 2);
			} else if (angle > 270 || angle < 90) {
				position.y -= textSize.h;
			}
		}
	
		function drawPointLabels(scale) {
			var ctx = scale.ctx;
			var valueOrDefault = helpers.valueOrDefault;
			var opts = scale.options;
			var angleLineOpts = opts.angleLines;
			var pointLabelOpts = opts.pointLabels;
	
			ctx.lineWidth = angleLineOpts.lineWidth;
			ctx.strokeStyle = angleLineOpts.color;
	
			var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
	
			// Point Label Font
			var plFont = getPointLabelFontOptions(scale);
	
			ctx.textBaseline = 'top';
	
			for (var i = getValueCount(scale) - 1; i >= 0; i--) {
				if (angleLineOpts.display) {
					var outerPosition = scale.getPointPosition(i, outerDistance);
					ctx.beginPath();
					ctx.moveTo(scale.xCenter, scale.yCenter);
					ctx.lineTo(outerPosition.x, outerPosition.y);
					ctx.stroke();
					ctx.closePath();
				}
	
				if (pointLabelOpts.display) {
					// Extra 3px out for some label spacing
					var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);
	
					// Keep this in loop since we may support array properties here
					var pointLabelFontColor = valueOrDefault(pointLabelOpts.fontColor, globalDefaults.defaultFontColor);
					ctx.font = plFont.font;
					ctx.fillStyle = pointLabelFontColor;
	
					var angleRadians = scale.getIndexAngle(i);
					var angle = helpers.toDegrees(angleRadians);
					ctx.textAlign = getTextAlignForAngle(angle);
					adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
					fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
				}
			}
		}
	
		function drawRadiusLine(scale, gridLineOpts, radius, index) {
			var ctx = scale.ctx;
			ctx.strokeStyle = helpers.valueAtIndexOrDefault(gridLineOpts.color, index - 1);
			ctx.lineWidth = helpers.valueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);
	
			if (scale.options.gridLines.circular) {
				// Draw circular arcs between the points
				ctx.beginPath();
				ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.stroke();
			} else {
				// Draw straight lines connecting each index
				var valueCount = getValueCount(scale);
	
				if (valueCount === 0) {
					return;
				}
	
				ctx.beginPath();
				var pointPosition = scale.getPointPosition(0, radius);
				ctx.moveTo(pointPosition.x, pointPosition.y);
	
				for (var i = 1; i < valueCount; i++) {
					pointPosition = scale.getPointPosition(i, radius);
					ctx.lineTo(pointPosition.x, pointPosition.y);
				}
	
				ctx.closePath();
				ctx.stroke();
			}
		}
	
		function numberOrZero(param) {
			return helpers.isNumber(param) ? param : 0;
		}
	
		var LinearRadialScale = Chart.LinearScaleBase.extend({
			setDimensions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				// Set the unconstrained dimension before label rotation
				me.width = me.maxWidth;
				me.height = me.maxHeight;
				me.xCenter = Math.round(me.width / 2);
				me.yCenter = Math.round(me.height / 2);
	
				var minSize = helpers.min([me.height, me.width]);
				var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
			},
			determineDataLimits: function() {
				var me = this;
				var chart = me.chart;
				var min = Number.POSITIVE_INFINITY;
				var max = Number.NEGATIVE_INFINITY;
	
				helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
					if (chart.isDatasetVisible(datasetIndex)) {
						var meta = chart.getDatasetMeta(datasetIndex);
	
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}
	
							min = Math.min(value, min);
							max = Math.max(value, max);
						});
					}
				});
	
				me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
				me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				me.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var tickOpts = this.options.ticks;
				var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
			},
			convertTicksToLabels: function() {
				var me = this;
	
				Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);
	
				// Point labels
				me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			fit: function() {
				if (this.options.pointLabels.display) {
					fitWithPointLabels(this);
				} else {
					fit(this);
				}
			},
			/**
			 * Set radius reductions and determine new radius and center point
			 * @private
			 */
			setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
				var me = this;
				var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
				var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
				var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
				var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);
	
				radiusReductionLeft = numberOrZero(radiusReductionLeft);
				radiusReductionRight = numberOrZero(radiusReductionRight);
				radiusReductionTop = numberOrZero(radiusReductionTop);
				radiusReductionBottom = numberOrZero(radiusReductionBottom);
	
				me.drawingArea = Math.min(
					Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
					Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
				me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
			},
			setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
				var me = this;
				var maxRight = me.width - rightMovement - me.drawingArea;
				var maxLeft = leftMovement + me.drawingArea;
				var maxTop = topMovement + me.drawingArea;
				var maxBottom = me.height - bottomMovement - me.drawingArea;
	
				me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
				me.yCenter = Math.round(((maxTop + maxBottom) / 2) + me.top);
			},
	
			getIndexAngle: function(index) {
				var angleMultiplier = (Math.PI * 2) / getValueCount(this);
				var startAngle = this.chart.options && this.chart.options.startAngle ?
					this.chart.options.startAngle :
					0;
	
				var startAngleRadians = startAngle * Math.PI * 2 / 360;
	
				// Start from the top instead of right, so remove a quarter of the circle
				return index * angleMultiplier + startAngleRadians;
			},
			getDistanceFromCenterForValue: function(value) {
				var me = this;
	
				if (value === null) {
					return 0; // null always in center
				}
	
				// Take into account half font size + the yPadding of the top value
				var scalingFactor = me.drawingArea / (me.max - me.min);
				if (me.options.ticks.reverse) {
					return (me.max - value) * scalingFactor;
				}
				return (value - me.min) * scalingFactor;
			},
			getPointPosition: function(index, distanceFromCenter) {
				var me = this;
				var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
				return {
					x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
					y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
				};
			},
			getPointPositionForValue: function(index, value) {
				return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
			},
	
			getBasePosition: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.getPointPositionForValue(0,
					me.beginAtZero ? 0 :
					min < 0 && max < 0 ? max :
					min > 0 && max > 0 ? min :
					0);
			},
	
			draw: function() {
				var me = this;
				var opts = me.options;
				var gridLineOpts = opts.gridLines;
				var tickOpts = opts.ticks;
				var valueOrDefault = helpers.valueOrDefault;
	
				if (opts.display) {
					var ctx = me.ctx;
					var startAngle = this.getIndexAngle(0);
	
					// Tick Font
					var tickFontSize = valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
					var tickFontStyle = valueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
					var tickFontFamily = valueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
					var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
	
					helpers.each(me.ticks, function(label, index) {
						// Don't draw a centre value (if it is minimum)
						if (index > 0 || tickOpts.reverse) {
							var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
	
							// Draw circular lines around the scale
							if (gridLineOpts.display && index !== 0) {
								drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
							}
	
							if (tickOpts.display) {
								var tickFontColor = valueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
								ctx.font = tickLabelFont;
	
								ctx.save();
								ctx.translate(me.xCenter, me.yCenter);
								ctx.rotate(startAngle);
	
								if (tickOpts.showLabelBackdrop) {
									var labelWidth = ctx.measureText(label).width;
									ctx.fillStyle = tickOpts.backdropColor;
									ctx.fillRect(
										-labelWidth / 2 - tickOpts.backdropPaddingX,
										-yCenterOffset - tickFontSize / 2 - tickOpts.backdropPaddingY,
										labelWidth + tickOpts.backdropPaddingX * 2,
										tickFontSize + tickOpts.backdropPaddingY * 2
									);
								}
	
								ctx.textAlign = 'center';
								ctx.textBaseline = 'middle';
								ctx.fillStyle = tickFontColor;
								ctx.fillText(label, 0, -yCenterOffset);
								ctx.restore();
							}
						}
					});
	
					if (opts.angleLines.display || opts.pointLabels.display) {
						drawPointLabels(me);
					}
				}
			}
		});
		Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);
	
	};


/***/ },

/***/ "./node_modules/chart.js/src/scales/scale.time.js":
/***/ function(module, exports, __webpack_require__) {

	/* global window: false */
	'use strict';
	
	var moment = __webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js");
	moment = typeof moment === 'function' ? moment : window.moment;
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	// Integer constants are from the ES6 spec.
	var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
	var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
	
	var INTERVALS = {
		millisecond: {
			common: true,
			size: 1,
			steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
		},
		second: {
			common: true,
			size: 1000,
			steps: [1, 2, 5, 10, 30]
		},
		minute: {
			common: true,
			size: 60000,
			steps: [1, 2, 5, 10, 30]
		},
		hour: {
			common: true,
			size: 3600000,
			steps: [1, 2, 3, 6, 12]
		},
		day: {
			common: true,
			size: 86400000,
			steps: [1, 2, 5]
		},
		week: {
			common: false,
			size: 604800000,
			steps: [1, 2, 3, 4]
		},
		month: {
			common: true,
			size: 2.628e9,
			steps: [1, 2, 3]
		},
		quarter: {
			common: false,
			size: 7.884e9,
			steps: [1, 2, 3, 4]
		},
		year: {
			common: true,
			size: 3.154e10
		}
	};
	
	var UNITS = Object.keys(INTERVALS);
	
	function sorter(a, b) {
		return a - b;
	}
	
	function arrayUnique(items) {
		var hash = {};
		var out = [];
		var i, ilen, item;
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			if (!hash[item]) {
				hash[item] = true;
				out.push(item);
			}
		}
	
		return out;
	}
	
	/**
	 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
	 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
	 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
	 * extremity (left + width or top + height). Note that it would be more optimized to directly
	 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
	 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
	 *
	 * @param {Number[]} timestamps - timestamps sorted from lowest to highest.
	 * @param {String} distribution - If 'linear', timestamps will be spread linearly along the min
	 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
	 * If 'series', timestamps will be positioned at the same distance from each other. In this
	 * case, only timestamps that break the time linearity are registered, meaning that in the
	 * best case, all timestamps are linear, the table contains only min and max.
	 */
	function buildLookupTable(timestamps, min, max, distribution) {
		if (distribution === 'linear' || !timestamps.length) {
			return [
				{time: min, pos: 0},
				{time: max, pos: 1}
			];
		}
	
		var table = [];
		var items = [min];
		var i, ilen, prev, curr, next;
	
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			curr = timestamps[i];
			if (curr > min && curr < max) {
				items.push(curr);
			}
		}
	
		items.push(max);
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			next = items[i + 1];
			prev = items[i - 1];
			curr = items[i];
	
			// only add points that breaks the scale linearity
			if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
				table.push({time: curr, pos: i / (ilen - 1)});
			}
		}
	
		return table;
	}
	
	// @see adapted from http://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
	function lookup(table, key, value) {
		var lo = 0;
		var hi = table.length - 1;
		var mid, i0, i1;
	
		while (lo >= 0 && lo <= hi) {
			mid = (lo + hi) >> 1;
			i0 = table[mid - 1] || null;
			i1 = table[mid];
	
			if (!i0) {
				// given value is outside table (before first item)
				return {lo: null, hi: i1};
			} else if (i1[key] < value) {
				lo = mid + 1;
			} else if (i0[key] > value) {
				hi = mid - 1;
			} else {
				return {lo: i0, hi: i1};
			}
		}
	
		// given value is outside table (after last item)
		return {lo: i1, hi: null};
	}
	
	/**
	 * Linearly interpolates the given source `value` using the table items `skey` values and
	 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
	 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
	 * index [0, 1] or [n - 1, n] are used for the interpolation.
	 */
	function interpolate(table, skey, sval, tkey) {
		var range = lookup(table, skey, sval);
	
		// Note: the lookup table ALWAYS contains at least 2 items (min and max)
		var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
		var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
	
		var span = next[skey] - prev[skey];
		var ratio = span ? (sval - prev[skey]) / span : 0;
		var offset = (next[tkey] - prev[tkey]) * ratio;
	
		return prev[tkey] + offset;
	}
	
	/**
	 * Convert the given value to a moment object using the given time options.
	 * @see http://momentjs.com/docs/#/parsing/
	 */
	function momentify(value, options) {
		var parser = options.parser;
		var format = options.parser || options.format;
	
		if (typeof parser === 'function') {
			return parser(value);
		}
	
		if (typeof value === 'string' && typeof format === 'string') {
			return moment(value, format);
		}
	
		if (!(value instanceof moment)) {
			value = moment(value);
		}
	
		if (value.isValid()) {
			return value;
		}
	
		// Labels are in an incompatible moment format and no `parser` has been provided.
		// The user might still use the deprecated `format` option to convert his inputs.
		if (typeof format === 'function') {
			return format(value);
		}
	
		return value;
	}
	
	function parse(input, scale) {
		if (helpers.isNullOrUndef(input)) {
			return null;
		}
	
		var options = scale.options.time;
		var value = momentify(scale.getRightValue(input), options);
		if (!value.isValid()) {
			return null;
		}
	
		if (options.round) {
			value.startOf(options.round);
		}
	
		return value.valueOf();
	}
	
	/**
	 * Returns the number of unit to skip to be able to display up to `capacity` number of ticks
	 * in `unit` for the given `min` / `max` range and respecting the interval steps constraints.
	 */
	function determineStepSize(min, max, unit, capacity) {
		var range = max - min;
		var interval = INTERVALS[unit];
		var milliseconds = interval.size;
		var steps = interval.steps;
		var i, ilen, factor;
	
		if (!steps) {
			return Math.ceil(range / ((capacity || 1) * milliseconds));
		}
	
		for (i = 0, ilen = steps.length; i < ilen; ++i) {
			factor = steps[i];
			if (Math.ceil(range / (milliseconds * factor)) <= capacity) {
				break;
			}
		}
	
		return factor;
	}
	
	/**
	 * Figures out what unit results in an appropriate number of auto-generated ticks
	 */
	function determineUnitForAutoTicks(minUnit, min, max, capacity) {
		var ilen = UNITS.length;
		var i, interval, factor;
	
		for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
			interval = INTERVALS[UNITS[i]];
			factor = interval.steps ? interval.steps[interval.steps.length - 1] : MAX_INTEGER;
	
			if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
				return UNITS[i];
			}
		}
	
		return UNITS[ilen - 1];
	}
	
	/**
	 * Figures out what unit to format a set of ticks with
	 */
	function determineUnitForFormatting(ticks, minUnit, min, max) {
		var duration = moment.duration(moment(max).diff(moment(min)));
		var ilen = UNITS.length;
		var i, unit;
	
		for (i = ilen - 1; i >= UNITS.indexOf(minUnit); i--) {
			unit = UNITS[i];
			if (INTERVALS[unit].common && duration.as(unit) >= ticks.length) {
				return unit;
			}
		}
	
		return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
	}
	
	function determineMajorUnit(unit) {
		for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
			if (INTERVALS[UNITS[i]].common) {
				return UNITS[i];
			}
		}
	}
	
	/**
	 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
	 * `minor` unit, aligned on the `major` unit and using the given scale time `options`.
	 * Important: this method can return ticks outside the min and max range, it's the
	 * responsibility of the calling code to clamp values if needed.
	 */
	function generate(min, max, capacity, options) {
		var timeOpts = options.time;
		var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
		var major = determineMajorUnit(minor);
		var stepSize = helpers.valueOrDefault(timeOpts.stepSize, timeOpts.unitStepSize);
		var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
		var majorTicksEnabled = options.ticks.major.enabled;
		var interval = INTERVALS[minor];
		var first = moment(min);
		var last = moment(max);
		var ticks = [];
		var time;
	
		if (!stepSize) {
			stepSize = determineStepSize(min, max, minor, capacity);
		}
	
		// For 'week' unit, handle the first day of week option
		if (weekday) {
			first = first.isoWeekday(weekday);
			last = last.isoWeekday(weekday);
		}
	
		// Align first/last ticks on unit
		first = first.startOf(weekday ? 'day' : minor);
		last = last.startOf(weekday ? 'day' : minor);
	
		// Make sure that the last tick include max
		if (last < max) {
			last.add(1, minor);
		}
	
		time = moment(first);
	
		if (majorTicksEnabled && major && !weekday && !timeOpts.round) {
			// Align the first tick on the previous `minor` unit aligned on the `major` unit:
			// we first aligned time on the previous `major` unit then add the number of full
			// stepSize there is between first and the previous major time.
			time.startOf(major);
			time.add(~~((first - time) / (interval.size * stepSize)) * stepSize, minor);
		}
	
		for (; time < last; time.add(stepSize, minor)) {
			ticks.push(+time);
		}
	
		ticks.push(+time);
	
		return ticks;
	}
	
	/**
	 * Returns the right and left offsets from edges in the form of {left, right}.
	 * Offsets are added when the `offset` option is true.
	 */
	function computeOffsets(table, ticks, min, max, options) {
		var left = 0;
		var right = 0;
		var upper, lower;
	
		if (options.offset && ticks.length) {
			if (!options.time.min) {
				upper = ticks.length > 1 ? ticks[1] : max;
				lower = ticks[0];
				left = (
					interpolate(table, 'time', upper, 'pos') -
					interpolate(table, 'time', lower, 'pos')
				) / 2;
			}
			if (!options.time.max) {
				upper = ticks[ticks.length - 1];
				lower = ticks.length > 1 ? ticks[ticks.length - 2] : min;
				right = (
					interpolate(table, 'time', upper, 'pos') -
					interpolate(table, 'time', lower, 'pos')
				) / 2;
			}
		}
	
		return {left: left, right: right};
	}
	
	function ticksFromTimestamps(values, majorUnit) {
		var ticks = [];
		var i, ilen, value, major;
	
		for (i = 0, ilen = values.length; i < ilen; ++i) {
			value = values[i];
			major = majorUnit ? value === +moment(value).startOf(majorUnit) : false;
	
			ticks.push({
				value: value,
				major: major
			});
		}
	
		return ticks;
	}
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			position: 'bottom',
	
			/**
			 * Data distribution along the scale:
			 * - 'linear': data are spread according to their time (distances can vary),
			 * - 'series': data are spread at the same distance from each other.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			distribution: 'linear',
	
			/**
			 * Scale boundary strategy (bypassed by min/max time options)
			 * - `data`: make sure data are fully visible, ticks outside are removed
			 * - `ticks`: make sure ticks are fully visible, data outside are truncated
			 * @see https://github.com/chartjs/Chart.js/pull/4556
			 * @since 2.7.0
			 */
			bounds: 'data',
	
			time: {
				parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
				format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
				unit: false, // false == automatic or override with week, month, year, etc.
				round: false, // none, or override with week, month, year, etc.
				displayFormat: false, // DEPRECATED
				isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
				minUnit: 'millisecond',
	
				// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
				displayFormats: {
					millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
					second: 'h:mm:ss a', // 11:20:01 AM
					minute: 'h:mm a', // 11:20 AM
					hour: 'hA', // 5PM
					day: 'MMM D', // Sep 4
					week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
					month: 'MMM YYYY', // Sept 2015
					quarter: '[Q]Q - YYYY', // Q3
					year: 'YYYY' // 2015
				},
			},
			ticks: {
				autoSkip: false,
	
				/**
				 * Ticks generation input values:
				 * - 'auto': generates "optimal" ticks based on scale size and time options.
				 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
				 * - 'labels': generates ticks from user given `data.labels` values ONLY.
				 * @see https://github.com/chartjs/Chart.js/pull/4507
				 * @since 2.7.0
				 */
				source: 'auto',
	
				major: {
					enabled: false
				}
			}
		};
	
		var TimeScale = Chart.Scale.extend({
			initialize: function() {
				if (!moment) {
					throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
				}
	
				this.mergeTicksOptions();
	
				Chart.Scale.prototype.initialize.call(this);
			},
	
			update: function() {
				var me = this;
				var options = me.options;
	
				// DEPRECATIONS: output a message only one time per update
				if (options.time && options.time.format) {
					console.warn('options.time.format is deprecated and replaced by options.time.parser.');
				}
	
				return Chart.Scale.prototype.update.apply(me, arguments);
			},
	
			/**
			 * Allows data to be referenced via 't' attribute
			 */
			getRightValue: function(rawValue) {
				if (rawValue && rawValue.t !== undefined) {
					rawValue = rawValue.t;
				}
				return Chart.Scale.prototype.getRightValue.call(this, rawValue);
			},
	
			determineDataLimits: function() {
				var me = this;
				var chart = me.chart;
				var timeOpts = me.options.time;
				var min = MAX_INTEGER;
				var max = MIN_INTEGER;
				var timestamps = [];
				var datasets = [];
				var labels = [];
				var i, j, ilen, jlen, data, timestamp;
	
				// Convert labels to timestamps
				for (i = 0, ilen = chart.data.labels.length; i < ilen; ++i) {
					labels.push(parse(chart.data.labels[i], me));
				}
	
				// Convert data to timestamps
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					if (chart.isDatasetVisible(i)) {
						data = chart.data.datasets[i].data;
	
						// Let's consider that all data have the same format.
						if (helpers.isObject(data[0])) {
							datasets[i] = [];
	
							for (j = 0, jlen = data.length; j < jlen; ++j) {
								timestamp = parse(data[j], me);
								timestamps.push(timestamp);
								datasets[i][j] = timestamp;
							}
						} else {
							timestamps.push.apply(timestamps, labels);
							datasets[i] = labels.slice(0);
						}
					} else {
						datasets[i] = [];
					}
				}
	
				if (labels.length) {
					// Sort labels **after** data have been converted
					labels = arrayUnique(labels).sort(sorter);
					min = Math.min(min, labels[0]);
					max = Math.max(max, labels[labels.length - 1]);
				}
	
				if (timestamps.length) {
					timestamps = arrayUnique(timestamps).sort(sorter);
					min = Math.min(min, timestamps[0]);
					max = Math.max(max, timestamps[timestamps.length - 1]);
				}
	
				min = parse(timeOpts.min, me) || min;
				max = parse(timeOpts.max, me) || max;
	
				// In case there is no valid min/max, let's use today limits
				min = min === MAX_INTEGER ? +moment().startOf('day') : min;
				max = max === MIN_INTEGER ? +moment().endOf('day') + 1 : max;
	
				// Make sure that max is strictly higher than min (required by the lookup table)
				me.min = Math.min(min, max);
				me.max = Math.max(min + 1, max);
	
				// PRIVATE
				me._horizontal = me.isHorizontal();
				me._table = [];
				me._timestamps = {
					data: timestamps,
					datasets: datasets,
					labels: labels
				};
			},
	
			buildTicks: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
				var options = me.options;
				var timeOpts = options.time;
				var timestamps = [];
				var ticks = [];
				var i, ilen, timestamp;
	
				switch (options.ticks.source) {
				case 'data':
					timestamps = me._timestamps.data;
					break;
				case 'labels':
					timestamps = me._timestamps.labels;
					break;
				case 'auto':
				default:
					timestamps = generate(min, max, me.getLabelCapacity(min), options);
				}
	
				if (options.bounds === 'ticks' && timestamps.length) {
					min = timestamps[0];
					max = timestamps[timestamps.length - 1];
				}
	
				// Enforce limits with user min/max options
				min = parse(timeOpts.min, me) || min;
				max = parse(timeOpts.max, me) || max;
	
				// Remove ticks outside the min/max range
				for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
					timestamp = timestamps[i];
					if (timestamp >= min && timestamp <= max) {
						ticks.push(timestamp);
					}
				}
	
				me.min = min;
				me.max = max;
	
				// PRIVATE
				me._unit = timeOpts.unit || determineUnitForFormatting(ticks, timeOpts.minUnit, me.min, me.max);
				me._majorUnit = determineMajorUnit(me._unit);
				me._table = buildLookupTable(me._timestamps.data, min, max, options.distribution);
				me._offsets = computeOffsets(me._table, ticks, min, max, options);
	
				return ticksFromTimestamps(ticks, me._majorUnit);
			},
	
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var data = me.chart.data;
				var timeOpts = me.options.time;
				var label = data.labels && index < data.labels.length ? data.labels[index] : '';
				var value = data.datasets[datasetIndex].data[index];
	
				if (helpers.isObject(value)) {
					label = me.getRightValue(value);
				}
				if (timeOpts.tooltipFormat) {
					label = momentify(label, timeOpts).format(timeOpts.tooltipFormat);
				}
	
				return label;
			},
	
			/**
			 * Function to format an individual tick mark
			 * @private
			 */
			tickFormatFunction: function(tick, index, ticks, formatOverride) {
				var me = this;
				var options = me.options;
				var time = tick.valueOf();
				var formats = options.time.displayFormats;
				var minorFormat = formats[me._unit];
				var majorUnit = me._majorUnit;
				var majorFormat = formats[majorUnit];
				var majorTime = tick.clone().startOf(majorUnit).valueOf();
				var majorTickOpts = options.ticks.major;
				var major = majorTickOpts.enabled && majorUnit && majorFormat && time === majorTime;
				var label = tick.format(formatOverride ? formatOverride : major ? majorFormat : minorFormat);
				var tickOpts = major ? majorTickOpts : options.ticks.minor;
				var formatter = helpers.valueOrDefault(tickOpts.callback, tickOpts.userCallback);
	
				return formatter ? formatter(label, index, ticks) : label;
			},
	
			convertTicksToLabels: function(ticks) {
				var labels = [];
				var i, ilen;
	
				for (i = 0, ilen = ticks.length; i < ilen; ++i) {
					labels.push(this.tickFormatFunction(moment(ticks[i].value), i, ticks));
				}
	
				return labels;
			},
	
			/**
			 * @private
			 */
			getPixelForOffset: function(time) {
				var me = this;
				var size = me._horizontal ? me.width : me.height;
				var start = me._horizontal ? me.left : me.top;
				var pos = interpolate(me._table, 'time', time, 'pos');
	
				return start + size * (me._offsets.left + pos) / (me._offsets.left + 1 + me._offsets.right);
			},
	
			getPixelForValue: function(value, index, datasetIndex) {
				var me = this;
				var time = null;
	
				if (index !== undefined && datasetIndex !== undefined) {
					time = me._timestamps.datasets[datasetIndex][index];
				}
	
				if (time === null) {
					time = parse(value, me);
				}
	
				if (time !== null) {
					return me.getPixelForOffset(time);
				}
			},
	
			getPixelForTick: function(index) {
				var ticks = this.getTicks();
				return index >= 0 && index < ticks.length ?
					this.getPixelForOffset(ticks[index].value) :
					null;
			},
	
			getValueForPixel: function(pixel) {
				var me = this;
				var size = me._horizontal ? me.width : me.height;
				var start = me._horizontal ? me.left : me.top;
				var pos = (size ? (pixel - start) / size : 0) * (me._offsets.left + 1 + me._offsets.left) - me._offsets.right;
				var time = interpolate(me._table, 'pos', pos, 'time');
	
				return moment(time);
			},
	
			/**
			 * Crude approximation of what the label width might be
			 * @private
			 */
			getLabelWidth: function(label) {
				var me = this;
				var ticksOpts = me.options.ticks;
				var tickLabelWidth = me.ctx.measureText(label).width;
				var angle = helpers.toRadians(ticksOpts.maxRotation);
				var cosRotation = Math.cos(angle);
				var sinRotation = Math.sin(angle);
				var tickFontSize = helpers.valueOrDefault(ticksOpts.fontSize, defaults.global.defaultFontSize);
	
				return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
			},
	
			/**
			 * @private
			 */
			getLabelCapacity: function(exampleTime) {
				var me = this;
	
				var formatOverride = me.options.time.displayFormats.millisecond;	// Pick the longest format for guestimation
	
				var exampleLabel = me.tickFormatFunction(moment(exampleTime), 0, [], formatOverride);
				var tickLabelWidth = me.getLabelWidth(exampleLabel);
				var innerWidth = me.isHorizontal() ? me.width : me.height;
	
				return Math.floor(innerWidth / tickLabelWidth);
			}
		});
	
		Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
	};


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/moment.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(4)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ },

/***/ 4:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": "./node_modules/chart.js/node_modules/moment/locale/af.js",
		"./af.js": "./node_modules/chart.js/node_modules/moment/locale/af.js",
		"./ar": "./node_modules/chart.js/node_modules/moment/locale/ar.js",
		"./ar-dz": "./node_modules/chart.js/node_modules/moment/locale/ar-dz.js",
		"./ar-dz.js": "./node_modules/chart.js/node_modules/moment/locale/ar-dz.js",
		"./ar-kw": "./node_modules/chart.js/node_modules/moment/locale/ar-kw.js",
		"./ar-kw.js": "./node_modules/chart.js/node_modules/moment/locale/ar-kw.js",
		"./ar-ly": "./node_modules/chart.js/node_modules/moment/locale/ar-ly.js",
		"./ar-ly.js": "./node_modules/chart.js/node_modules/moment/locale/ar-ly.js",
		"./ar-ma": "./node_modules/chart.js/node_modules/moment/locale/ar-ma.js",
		"./ar-ma.js": "./node_modules/chart.js/node_modules/moment/locale/ar-ma.js",
		"./ar-sa": "./node_modules/chart.js/node_modules/moment/locale/ar-sa.js",
		"./ar-sa.js": "./node_modules/chart.js/node_modules/moment/locale/ar-sa.js",
		"./ar-tn": "./node_modules/chart.js/node_modules/moment/locale/ar-tn.js",
		"./ar-tn.js": "./node_modules/chart.js/node_modules/moment/locale/ar-tn.js",
		"./ar.js": "./node_modules/chart.js/node_modules/moment/locale/ar.js",
		"./az": "./node_modules/chart.js/node_modules/moment/locale/az.js",
		"./az.js": "./node_modules/chart.js/node_modules/moment/locale/az.js",
		"./be": "./node_modules/chart.js/node_modules/moment/locale/be.js",
		"./be.js": "./node_modules/chart.js/node_modules/moment/locale/be.js",
		"./bg": "./node_modules/chart.js/node_modules/moment/locale/bg.js",
		"./bg.js": "./node_modules/chart.js/node_modules/moment/locale/bg.js",
		"./bn": "./node_modules/chart.js/node_modules/moment/locale/bn.js",
		"./bn.js": "./node_modules/chart.js/node_modules/moment/locale/bn.js",
		"./bo": "./node_modules/chart.js/node_modules/moment/locale/bo.js",
		"./bo.js": "./node_modules/chart.js/node_modules/moment/locale/bo.js",
		"./br": "./node_modules/chart.js/node_modules/moment/locale/br.js",
		"./br.js": "./node_modules/chart.js/node_modules/moment/locale/br.js",
		"./bs": "./node_modules/chart.js/node_modules/moment/locale/bs.js",
		"./bs.js": "./node_modules/chart.js/node_modules/moment/locale/bs.js",
		"./ca": "./node_modules/chart.js/node_modules/moment/locale/ca.js",
		"./ca.js": "./node_modules/chart.js/node_modules/moment/locale/ca.js",
		"./cs": "./node_modules/chart.js/node_modules/moment/locale/cs.js",
		"./cs.js": "./node_modules/chart.js/node_modules/moment/locale/cs.js",
		"./cv": "./node_modules/chart.js/node_modules/moment/locale/cv.js",
		"./cv.js": "./node_modules/chart.js/node_modules/moment/locale/cv.js",
		"./cy": "./node_modules/chart.js/node_modules/moment/locale/cy.js",
		"./cy.js": "./node_modules/chart.js/node_modules/moment/locale/cy.js",
		"./da": "./node_modules/chart.js/node_modules/moment/locale/da.js",
		"./da.js": "./node_modules/chart.js/node_modules/moment/locale/da.js",
		"./de": "./node_modules/chart.js/node_modules/moment/locale/de.js",
		"./de-at": "./node_modules/chart.js/node_modules/moment/locale/de-at.js",
		"./de-at.js": "./node_modules/chart.js/node_modules/moment/locale/de-at.js",
		"./de-ch": "./node_modules/chart.js/node_modules/moment/locale/de-ch.js",
		"./de-ch.js": "./node_modules/chart.js/node_modules/moment/locale/de-ch.js",
		"./de.js": "./node_modules/chart.js/node_modules/moment/locale/de.js",
		"./dv": "./node_modules/chart.js/node_modules/moment/locale/dv.js",
		"./dv.js": "./node_modules/chart.js/node_modules/moment/locale/dv.js",
		"./el": "./node_modules/chart.js/node_modules/moment/locale/el.js",
		"./el.js": "./node_modules/chart.js/node_modules/moment/locale/el.js",
		"./en-au": "./node_modules/chart.js/node_modules/moment/locale/en-au.js",
		"./en-au.js": "./node_modules/chart.js/node_modules/moment/locale/en-au.js",
		"./en-ca": "./node_modules/chart.js/node_modules/moment/locale/en-ca.js",
		"./en-ca.js": "./node_modules/chart.js/node_modules/moment/locale/en-ca.js",
		"./en-gb": "./node_modules/chart.js/node_modules/moment/locale/en-gb.js",
		"./en-gb.js": "./node_modules/chart.js/node_modules/moment/locale/en-gb.js",
		"./en-ie": "./node_modules/chart.js/node_modules/moment/locale/en-ie.js",
		"./en-ie.js": "./node_modules/chart.js/node_modules/moment/locale/en-ie.js",
		"./en-nz": "./node_modules/chart.js/node_modules/moment/locale/en-nz.js",
		"./en-nz.js": "./node_modules/chart.js/node_modules/moment/locale/en-nz.js",
		"./eo": "./node_modules/chart.js/node_modules/moment/locale/eo.js",
		"./eo.js": "./node_modules/chart.js/node_modules/moment/locale/eo.js",
		"./es": "./node_modules/chart.js/node_modules/moment/locale/es.js",
		"./es-do": "./node_modules/chart.js/node_modules/moment/locale/es-do.js",
		"./es-do.js": "./node_modules/chart.js/node_modules/moment/locale/es-do.js",
		"./es.js": "./node_modules/chart.js/node_modules/moment/locale/es.js",
		"./et": "./node_modules/chart.js/node_modules/moment/locale/et.js",
		"./et.js": "./node_modules/chart.js/node_modules/moment/locale/et.js",
		"./eu": "./node_modules/chart.js/node_modules/moment/locale/eu.js",
		"./eu.js": "./node_modules/chart.js/node_modules/moment/locale/eu.js",
		"./fa": "./node_modules/chart.js/node_modules/moment/locale/fa.js",
		"./fa.js": "./node_modules/chart.js/node_modules/moment/locale/fa.js",
		"./fi": "./node_modules/chart.js/node_modules/moment/locale/fi.js",
		"./fi.js": "./node_modules/chart.js/node_modules/moment/locale/fi.js",
		"./fo": "./node_modules/chart.js/node_modules/moment/locale/fo.js",
		"./fo.js": "./node_modules/chart.js/node_modules/moment/locale/fo.js",
		"./fr": "./node_modules/chart.js/node_modules/moment/locale/fr.js",
		"./fr-ca": "./node_modules/chart.js/node_modules/moment/locale/fr-ca.js",
		"./fr-ca.js": "./node_modules/chart.js/node_modules/moment/locale/fr-ca.js",
		"./fr-ch": "./node_modules/chart.js/node_modules/moment/locale/fr-ch.js",
		"./fr-ch.js": "./node_modules/chart.js/node_modules/moment/locale/fr-ch.js",
		"./fr.js": "./node_modules/chart.js/node_modules/moment/locale/fr.js",
		"./fy": "./node_modules/chart.js/node_modules/moment/locale/fy.js",
		"./fy.js": "./node_modules/chart.js/node_modules/moment/locale/fy.js",
		"./gd": "./node_modules/chart.js/node_modules/moment/locale/gd.js",
		"./gd.js": "./node_modules/chart.js/node_modules/moment/locale/gd.js",
		"./gl": "./node_modules/chart.js/node_modules/moment/locale/gl.js",
		"./gl.js": "./node_modules/chart.js/node_modules/moment/locale/gl.js",
		"./gom-latn": "./node_modules/chart.js/node_modules/moment/locale/gom-latn.js",
		"./gom-latn.js": "./node_modules/chart.js/node_modules/moment/locale/gom-latn.js",
		"./he": "./node_modules/chart.js/node_modules/moment/locale/he.js",
		"./he.js": "./node_modules/chart.js/node_modules/moment/locale/he.js",
		"./hi": "./node_modules/chart.js/node_modules/moment/locale/hi.js",
		"./hi.js": "./node_modules/chart.js/node_modules/moment/locale/hi.js",
		"./hr": "./node_modules/chart.js/node_modules/moment/locale/hr.js",
		"./hr.js": "./node_modules/chart.js/node_modules/moment/locale/hr.js",
		"./hu": "./node_modules/chart.js/node_modules/moment/locale/hu.js",
		"./hu.js": "./node_modules/chart.js/node_modules/moment/locale/hu.js",
		"./hy-am": "./node_modules/chart.js/node_modules/moment/locale/hy-am.js",
		"./hy-am.js": "./node_modules/chart.js/node_modules/moment/locale/hy-am.js",
		"./id": "./node_modules/chart.js/node_modules/moment/locale/id.js",
		"./id.js": "./node_modules/chart.js/node_modules/moment/locale/id.js",
		"./is": "./node_modules/chart.js/node_modules/moment/locale/is.js",
		"./is.js": "./node_modules/chart.js/node_modules/moment/locale/is.js",
		"./it": "./node_modules/chart.js/node_modules/moment/locale/it.js",
		"./it.js": "./node_modules/chart.js/node_modules/moment/locale/it.js",
		"./ja": "./node_modules/chart.js/node_modules/moment/locale/ja.js",
		"./ja.js": "./node_modules/chart.js/node_modules/moment/locale/ja.js",
		"./jv": "./node_modules/chart.js/node_modules/moment/locale/jv.js",
		"./jv.js": "./node_modules/chart.js/node_modules/moment/locale/jv.js",
		"./ka": "./node_modules/chart.js/node_modules/moment/locale/ka.js",
		"./ka.js": "./node_modules/chart.js/node_modules/moment/locale/ka.js",
		"./kk": "./node_modules/chart.js/node_modules/moment/locale/kk.js",
		"./kk.js": "./node_modules/chart.js/node_modules/moment/locale/kk.js",
		"./km": "./node_modules/chart.js/node_modules/moment/locale/km.js",
		"./km.js": "./node_modules/chart.js/node_modules/moment/locale/km.js",
		"./kn": "./node_modules/chart.js/node_modules/moment/locale/kn.js",
		"./kn.js": "./node_modules/chart.js/node_modules/moment/locale/kn.js",
		"./ko": "./node_modules/chart.js/node_modules/moment/locale/ko.js",
		"./ko.js": "./node_modules/chart.js/node_modules/moment/locale/ko.js",
		"./ky": "./node_modules/chart.js/node_modules/moment/locale/ky.js",
		"./ky.js": "./node_modules/chart.js/node_modules/moment/locale/ky.js",
		"./lb": "./node_modules/chart.js/node_modules/moment/locale/lb.js",
		"./lb.js": "./node_modules/chart.js/node_modules/moment/locale/lb.js",
		"./lo": "./node_modules/chart.js/node_modules/moment/locale/lo.js",
		"./lo.js": "./node_modules/chart.js/node_modules/moment/locale/lo.js",
		"./lt": "./node_modules/chart.js/node_modules/moment/locale/lt.js",
		"./lt.js": "./node_modules/chart.js/node_modules/moment/locale/lt.js",
		"./lv": "./node_modules/chart.js/node_modules/moment/locale/lv.js",
		"./lv.js": "./node_modules/chart.js/node_modules/moment/locale/lv.js",
		"./me": "./node_modules/chart.js/node_modules/moment/locale/me.js",
		"./me.js": "./node_modules/chart.js/node_modules/moment/locale/me.js",
		"./mi": "./node_modules/chart.js/node_modules/moment/locale/mi.js",
		"./mi.js": "./node_modules/chart.js/node_modules/moment/locale/mi.js",
		"./mk": "./node_modules/chart.js/node_modules/moment/locale/mk.js",
		"./mk.js": "./node_modules/chart.js/node_modules/moment/locale/mk.js",
		"./ml": "./node_modules/chart.js/node_modules/moment/locale/ml.js",
		"./ml.js": "./node_modules/chart.js/node_modules/moment/locale/ml.js",
		"./mr": "./node_modules/chart.js/node_modules/moment/locale/mr.js",
		"./mr.js": "./node_modules/chart.js/node_modules/moment/locale/mr.js",
		"./ms": "./node_modules/chart.js/node_modules/moment/locale/ms.js",
		"./ms-my": "./node_modules/chart.js/node_modules/moment/locale/ms-my.js",
		"./ms-my.js": "./node_modules/chart.js/node_modules/moment/locale/ms-my.js",
		"./ms.js": "./node_modules/chart.js/node_modules/moment/locale/ms.js",
		"./my": "./node_modules/chart.js/node_modules/moment/locale/my.js",
		"./my.js": "./node_modules/chart.js/node_modules/moment/locale/my.js",
		"./nb": "./node_modules/chart.js/node_modules/moment/locale/nb.js",
		"./nb.js": "./node_modules/chart.js/node_modules/moment/locale/nb.js",
		"./ne": "./node_modules/chart.js/node_modules/moment/locale/ne.js",
		"./ne.js": "./node_modules/chart.js/node_modules/moment/locale/ne.js",
		"./nl": "./node_modules/chart.js/node_modules/moment/locale/nl.js",
		"./nl-be": "./node_modules/chart.js/node_modules/moment/locale/nl-be.js",
		"./nl-be.js": "./node_modules/chart.js/node_modules/moment/locale/nl-be.js",
		"./nl.js": "./node_modules/chart.js/node_modules/moment/locale/nl.js",
		"./nn": "./node_modules/chart.js/node_modules/moment/locale/nn.js",
		"./nn.js": "./node_modules/chart.js/node_modules/moment/locale/nn.js",
		"./pa-in": "./node_modules/chart.js/node_modules/moment/locale/pa-in.js",
		"./pa-in.js": "./node_modules/chart.js/node_modules/moment/locale/pa-in.js",
		"./pl": "./node_modules/chart.js/node_modules/moment/locale/pl.js",
		"./pl.js": "./node_modules/chart.js/node_modules/moment/locale/pl.js",
		"./pt": "./node_modules/chart.js/node_modules/moment/locale/pt.js",
		"./pt-br": "./node_modules/chart.js/node_modules/moment/locale/pt-br.js",
		"./pt-br.js": "./node_modules/chart.js/node_modules/moment/locale/pt-br.js",
		"./pt.js": "./node_modules/chart.js/node_modules/moment/locale/pt.js",
		"./ro": "./node_modules/chart.js/node_modules/moment/locale/ro.js",
		"./ro.js": "./node_modules/chart.js/node_modules/moment/locale/ro.js",
		"./ru": "./node_modules/chart.js/node_modules/moment/locale/ru.js",
		"./ru.js": "./node_modules/chart.js/node_modules/moment/locale/ru.js",
		"./sd": "./node_modules/chart.js/node_modules/moment/locale/sd.js",
		"./sd.js": "./node_modules/chart.js/node_modules/moment/locale/sd.js",
		"./se": "./node_modules/chart.js/node_modules/moment/locale/se.js",
		"./se.js": "./node_modules/chart.js/node_modules/moment/locale/se.js",
		"./si": "./node_modules/chart.js/node_modules/moment/locale/si.js",
		"./si.js": "./node_modules/chart.js/node_modules/moment/locale/si.js",
		"./sk": "./node_modules/chart.js/node_modules/moment/locale/sk.js",
		"./sk.js": "./node_modules/chart.js/node_modules/moment/locale/sk.js",
		"./sl": "./node_modules/chart.js/node_modules/moment/locale/sl.js",
		"./sl.js": "./node_modules/chart.js/node_modules/moment/locale/sl.js",
		"./sq": "./node_modules/chart.js/node_modules/moment/locale/sq.js",
		"./sq.js": "./node_modules/chart.js/node_modules/moment/locale/sq.js",
		"./sr": "./node_modules/chart.js/node_modules/moment/locale/sr.js",
		"./sr-cyrl": "./node_modules/chart.js/node_modules/moment/locale/sr-cyrl.js",
		"./sr-cyrl.js": "./node_modules/chart.js/node_modules/moment/locale/sr-cyrl.js",
		"./sr.js": "./node_modules/chart.js/node_modules/moment/locale/sr.js",
		"./ss": "./node_modules/chart.js/node_modules/moment/locale/ss.js",
		"./ss.js": "./node_modules/chart.js/node_modules/moment/locale/ss.js",
		"./sv": "./node_modules/chart.js/node_modules/moment/locale/sv.js",
		"./sv.js": "./node_modules/chart.js/node_modules/moment/locale/sv.js",
		"./sw": "./node_modules/chart.js/node_modules/moment/locale/sw.js",
		"./sw.js": "./node_modules/chart.js/node_modules/moment/locale/sw.js",
		"./ta": "./node_modules/chart.js/node_modules/moment/locale/ta.js",
		"./ta.js": "./node_modules/chart.js/node_modules/moment/locale/ta.js",
		"./te": "./node_modules/chart.js/node_modules/moment/locale/te.js",
		"./te.js": "./node_modules/chart.js/node_modules/moment/locale/te.js",
		"./tet": "./node_modules/chart.js/node_modules/moment/locale/tet.js",
		"./tet.js": "./node_modules/chart.js/node_modules/moment/locale/tet.js",
		"./th": "./node_modules/chart.js/node_modules/moment/locale/th.js",
		"./th.js": "./node_modules/chart.js/node_modules/moment/locale/th.js",
		"./tl-ph": "./node_modules/chart.js/node_modules/moment/locale/tl-ph.js",
		"./tl-ph.js": "./node_modules/chart.js/node_modules/moment/locale/tl-ph.js",
		"./tlh": "./node_modules/chart.js/node_modules/moment/locale/tlh.js",
		"./tlh.js": "./node_modules/chart.js/node_modules/moment/locale/tlh.js",
		"./tr": "./node_modules/chart.js/node_modules/moment/locale/tr.js",
		"./tr.js": "./node_modules/chart.js/node_modules/moment/locale/tr.js",
		"./tzl": "./node_modules/chart.js/node_modules/moment/locale/tzl.js",
		"./tzl.js": "./node_modules/chart.js/node_modules/moment/locale/tzl.js",
		"./tzm": "./node_modules/chart.js/node_modules/moment/locale/tzm.js",
		"./tzm-latn": "./node_modules/chart.js/node_modules/moment/locale/tzm-latn.js",
		"./tzm-latn.js": "./node_modules/chart.js/node_modules/moment/locale/tzm-latn.js",
		"./tzm.js": "./node_modules/chart.js/node_modules/moment/locale/tzm.js",
		"./uk": "./node_modules/chart.js/node_modules/moment/locale/uk.js",
		"./uk.js": "./node_modules/chart.js/node_modules/moment/locale/uk.js",
		"./ur": "./node_modules/chart.js/node_modules/moment/locale/ur.js",
		"./ur.js": "./node_modules/chart.js/node_modules/moment/locale/ur.js",
		"./uz": "./node_modules/chart.js/node_modules/moment/locale/uz.js",
		"./uz-latn": "./node_modules/chart.js/node_modules/moment/locale/uz-latn.js",
		"./uz-latn.js": "./node_modules/chart.js/node_modules/moment/locale/uz-latn.js",
		"./uz.js": "./node_modules/chart.js/node_modules/moment/locale/uz.js",
		"./vi": "./node_modules/chart.js/node_modules/moment/locale/vi.js",
		"./vi.js": "./node_modules/chart.js/node_modules/moment/locale/vi.js",
		"./x-pseudo": "./node_modules/chart.js/node_modules/moment/locale/x-pseudo.js",
		"./x-pseudo.js": "./node_modules/chart.js/node_modules/moment/locale/x-pseudo.js",
		"./yo": "./node_modules/chart.js/node_modules/moment/locale/yo.js",
		"./yo.js": "./node_modules/chart.js/node_modules/moment/locale/yo.js",
		"./zh-cn": "./node_modules/chart.js/node_modules/moment/locale/zh-cn.js",
		"./zh-cn.js": "./node_modules/chart.js/node_modules/moment/locale/zh-cn.js",
		"./zh-hk": "./node_modules/chart.js/node_modules/moment/locale/zh-hk.js",
		"./zh-hk.js": "./node_modules/chart.js/node_modules/moment/locale/zh-hk.js",
		"./zh-tw": "./node_modules/chart.js/node_modules/moment/locale/zh-tw.js",
		"./zh-tw.js": "./node_modules/chart.js/node_modules/moment/locale/zh-tw.js"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 4;


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/af.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ar.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ar-dz.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ar-kw.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ar-ly.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ar-ma.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ar-sa.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ar-tn.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/az.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/be.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/bg.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/bn.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/bo.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/br.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/bs.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ca.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : '[el] D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/cs.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/cv.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/cy.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/da.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/de.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/de-at.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/de-ch.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/dv.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/el.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/en-au.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/en-ca.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/en-gb.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/en-ie.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/en-nz.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/eo.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/es.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/es-do.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/et.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/eu.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/fa.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/fi.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/fo.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/fr.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/fr-ca.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/fr-ch.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/fy.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/gd.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/gl.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/gom-latn.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/he.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/hi.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/hr.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/hu.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/hy-am.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/id.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/is.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/it.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ja.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/jv.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ka.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/kk.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/km.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/kn.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ko.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ky.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/lb.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/lo.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/lt.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/lv.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/me.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/mi.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/mk.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ml.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/mr.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ms.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ms-my.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/my.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/nb.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ne.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/nl.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/nl-be.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/nn.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/pa-in.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/pl.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/pt.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/pt-br.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ro.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ru.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/sd.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/se.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/si.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/sk.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/sl.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/sq.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/sr.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/sr-cyrl.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ss.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/sv.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/sw.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ta.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/te.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/tet.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/th.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/tl-ph.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/tlh.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/tr.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/tzl.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/tzm.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/tzm-latn.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/uk.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/ur.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/uz.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/uz-latn.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/vi.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/x-pseudo.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/yo.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/zh-cn.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/zh-hk.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/node_modules/moment/locale/zh-tw.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("./node_modules/chart.js/node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },

/***/ "./node_modules/chart.js/src/controllers/controller.bar.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var elements = __webpack_require__("./node_modules/chart.js/src/elements/index.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	defaults._set('bar', {
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
	
				// Specific to Bar Controller
				categoryPercentage: 0.8,
				barPercentage: 0.9,
	
				// offset settings
				offset: true,
	
				// grid line settings
				gridLines: {
					offsetGridLines: true
				}
			}],
	
			yAxes: [{
				type: 'linear'
			}]
		}
	});
	
	defaults._set('horizontalBar', {
		hover: {
			mode: 'index',
			axis: 'y'
		},
	
		scales: {
			xAxes: [{
				type: 'linear',
				position: 'bottom'
			}],
	
			yAxes: [{
				position: 'left',
				type: 'category',
	
				// Specific to Horizontal Bar Controller
				categoryPercentage: 0.8,
				barPercentage: 0.9,
	
				// offset settings
				offset: true,
	
				// grid line settings
				gridLines: {
					offsetGridLines: true
				}
			}]
		},
	
		elements: {
			rectangle: {
				borderSkipped: 'left'
			}
		},
	
		tooltips: {
			callbacks: {
				title: function(item, data) {
					// Pick first xLabel for now
					var title = '';
	
					if (item.length > 0) {
						if (item[0].yLabel) {
							title = item[0].yLabel;
						} else if (data.labels.length > 0 && item[0].index < data.labels.length) {
							title = data.labels[item[0].index];
						}
					}
	
					return title;
				},
	
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					return datasetLabel + ': ' + item.xLabel;
				}
			},
			mode: 'index',
			axis: 'y'
		}
	});
	
	module.exports = function(Chart) {
	
		Chart.controllers.bar = Chart.DatasetController.extend({
	
			dataElementType: elements.Rectangle,
	
			initialize: function() {
				var me = this;
				var meta;
	
				Chart.DatasetController.prototype.initialize.apply(me, arguments);
	
				meta = me.getMeta();
				meta.stack = me.getDataset().stack;
				meta.bar = true;
			},
	
			update: function(reset) {
				var me = this;
				var rects = me.getMeta().data;
				var i, ilen;
	
				me._ruler = me.getRuler();
	
				for (i = 0, ilen = rects.length; i < ilen; ++i) {
					me.updateElement(rects[i], i, reset);
				}
			},
	
			updateElement: function(rectangle, index, reset) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var dataset = me.getDataset();
				var custom = rectangle.custom || {};
				var rectangleOptions = chart.options.elements.rectangle;
	
				rectangle._xScale = me.getScaleForId(meta.xAxisID);
				rectangle._yScale = me.getScaleForId(meta.yAxisID);
				rectangle._datasetIndex = me.index;
				rectangle._index = index;
	
				rectangle._model = {
					datasetLabel: dataset.label,
					label: chart.data.labels[index],
					borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleOptions.borderSkipped,
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleOptions.backgroundColor),
					borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleOptions.borderWidth)
				};
	
				me.updateElementGeometry(rectangle, index, reset);
	
				rectangle.pivot();
			},
	
			/**
			 * @private
			 */
			updateElementGeometry: function(rectangle, index, reset) {
				var me = this;
				var model = rectangle._model;
				var vscale = me.getValueScale();
				var base = vscale.getBasePixel();
				var horizontal = vscale.isHorizontal();
				var ruler = me._ruler || me.getRuler();
				var vpixels = me.calculateBarValuePixels(me.index, index);
				var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);
	
				model.horizontal = horizontal;
				model.base = reset ? base : vpixels.base;
				model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
				model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
				model.height = horizontal ? ipixels.size : undefined;
				model.width = horizontal ? undefined : ipixels.size;
			},
	
			/**
			 * @private
			 */
			getValueScaleId: function() {
				return this.getMeta().yAxisID;
			},
	
			/**
			 * @private
			 */
			getIndexScaleId: function() {
				return this.getMeta().xAxisID;
			},
	
			/**
			 * @private
			 */
			getValueScale: function() {
				return this.getScaleForId(this.getValueScaleId());
			},
	
			/**
			 * @private
			 */
			getIndexScale: function() {
				return this.getScaleForId(this.getIndexScaleId());
			},
	
			/**
			 * Returns the effective number of stacks based on groups and bar visibility.
			 * @private
			 */
			getStackCount: function(last) {
				var me = this;
				var chart = me.chart;
				var scale = me.getIndexScale();
				var stacked = scale.options.stacked;
				var ilen = last === undefined ? chart.data.datasets.length : last + 1;
				var stacks = [];
				var i, meta;
	
				for (i = 0; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					if (meta.bar && chart.isDatasetVisible(i) &&
						(stacked === false ||
						(stacked === true && stacks.indexOf(meta.stack) === -1) ||
						(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
						stacks.push(meta.stack);
					}
				}
	
				return stacks.length;
			},
	
			/**
			 * Returns the stack index for the given dataset based on groups and bar visibility.
			 * @private
			 */
			getStackIndex: function(datasetIndex) {
				return this.getStackCount(datasetIndex) - 1;
			},
	
			/**
			 * @private
			 */
			getRuler: function() {
				var me = this;
				var scale = me.getIndexScale();
				var stackCount = me.getStackCount();
				var datasetIndex = me.index;
				var pixels = [];
				var isHorizontal = scale.isHorizontal();
				var start = isHorizontal ? scale.left : scale.top;
				var end = start + (isHorizontal ? scale.width : scale.height);
				var i, ilen;
	
				for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
					pixels.push(scale.getPixelForValue(null, i, datasetIndex));
				}
	
				return {
					pixels: pixels,
					start: start,
					end: end,
					stackCount: stackCount,
					scale: scale
				};
			},
	
			/**
			 * Note: pixel values are not clamped to the scale area.
			 * @private
			 */
			calculateBarValuePixels: function(datasetIndex, index) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var scale = me.getValueScale();
				var datasets = chart.data.datasets;
				var value = scale.getRightValue(datasets[datasetIndex].data[index]);
				var stacked = scale.options.stacked;
				var stack = meta.stack;
				var start = 0;
				var i, imeta, ivalue, base, head, size;
	
				if (stacked || (stacked === undefined && stack !== undefined)) {
					for (i = 0; i < datasetIndex; ++i) {
						imeta = chart.getDatasetMeta(i);
	
						if (imeta.bar &&
							imeta.stack === stack &&
							imeta.controller.getValueScaleId() === scale.id &&
							chart.isDatasetVisible(i)) {
	
							ivalue = scale.getRightValue(datasets[i].data[index]);
							if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
								start += ivalue;
							}
						}
					}
				}
	
				base = scale.getPixelForValue(start);
				head = scale.getPixelForValue(start + value);
				size = (head - base) / 2;
	
				return {
					size: size,
					base: base,
					head: head,
					center: head + size / 2
				};
			},
	
			/**
			 * @private
			 */
			calculateBarIndexPixels: function(datasetIndex, index, ruler) {
				var me = this;
				var options = ruler.scale.options;
				var stackIndex = me.getStackIndex(datasetIndex);
				var pixels = ruler.pixels;
				var base = pixels[index];
				var length = pixels.length;
				var start = ruler.start;
				var end = ruler.end;
				var leftSampleSize, rightSampleSize, leftCategorySize, rightCategorySize, fullBarSize, size;
	
				if (length === 1) {
					leftSampleSize = base > start ? base - start : end - base;
					rightSampleSize = base < end ? end - base : base - start;
				} else {
					if (index > 0) {
						leftSampleSize = (base - pixels[index - 1]) / 2;
						if (index === length - 1) {
							rightSampleSize = leftSampleSize;
						}
					}
					if (index < length - 1) {
						rightSampleSize = (pixels[index + 1] - base) / 2;
						if (index === 0) {
							leftSampleSize = rightSampleSize;
						}
					}
				}
	
				leftCategorySize = leftSampleSize * options.categoryPercentage;
				rightCategorySize = rightSampleSize * options.categoryPercentage;
				fullBarSize = (leftCategorySize + rightCategorySize) / ruler.stackCount;
				size = fullBarSize * options.barPercentage;
	
				size = Math.min(
					helpers.valueOrDefault(options.barThickness, size),
					helpers.valueOrDefault(options.maxBarThickness, Infinity));
	
				base -= leftCategorySize;
				base += fullBarSize * stackIndex;
				base += (fullBarSize - size) / 2;
	
				return {
					size: size,
					base: base,
					head: base + size,
					center: base + size / 2
				};
			},
	
			draw: function() {
				var me = this;
				var chart = me.chart;
				var scale = me.getValueScale();
				var rects = me.getMeta().data;
				var dataset = me.getDataset();
				var ilen = rects.length;
				var i = 0;
	
				helpers.canvas.clipArea(chart.ctx, chart.chartArea);
	
				for (; i < ilen; ++i) {
					if (!isNaN(scale.getRightValue(dataset.data[i]))) {
						rects[i].draw();
					}
				}
	
				helpers.canvas.unclipArea(chart.ctx);
			},
	
			setHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
				var custom = rectangle.custom || {};
				var model = rectangle._model;
	
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
				var custom = rectangle.custom || {};
				var model = rectangle._model;
				var rectangleElementOptions = this.chart.options.elements.rectangle;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
			}
		});
	
		Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
			/**
			 * @private
			 */
			getValueScaleId: function() {
				return this.getMeta().xAxisID;
			},
	
			/**
			 * @private
			 */
			getIndexScaleId: function() {
				return this.getMeta().yAxisID;
			}
		});
	};


/***/ },

/***/ "./node_modules/chart.js/src/controllers/controller.bubble.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var elements = __webpack_require__("./node_modules/chart.js/src/elements/index.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	defaults._set('bubble', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				type: 'linear', // bubble should probably use a linear scale by default
				position: 'bottom',
				id: 'x-axis-0' // need an ID so datasets can reference the scale
			}],
			yAxes: [{
				type: 'linear',
				position: 'left',
				id: 'y-axis-0'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					// Title doesn't make sense for scatter since we format the data as a point
					return '';
				},
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					var dataPoint = data.datasets[item.datasetIndex].data[item.index];
					return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
				}
			}
		}
	});
	
	
	module.exports = function(Chart) {
	
		Chart.controllers.bubble = Chart.DatasetController.extend({
			/**
			 * @protected
			 */
			dataElementType: elements.Point,
	
			/**
			 * @protected
			 */
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data;
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				});
			},
	
			/**
			 * @protected
			 */
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var custom = point.custom || {};
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
				var options = me._resolveElementOptions(point, index);
				var data = me.getDataset().data[index];
				var dsIndex = me.index;
	
				var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
				var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
	
				point._xScale = xScale;
				point._yScale = yScale;
				point._options = options;
				point._datasetIndex = dsIndex;
				point._index = index;
				point._model = {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					hitRadius: options.hitRadius,
					pointStyle: options.pointStyle,
					radius: reset ? 0 : options.radius,
					skip: custom.skip || isNaN(x) || isNaN(y),
					x: x,
					y: y,
				};
	
				point.pivot();
			},
	
			/**
			 * @protected
			 */
			setHoverStyle: function(point) {
				var model = point._model;
				var options = point._options;
	
				model.backgroundColor = helpers.valueOrDefault(options.hoverBackgroundColor, helpers.getHoverColor(options.backgroundColor));
				model.borderColor = helpers.valueOrDefault(options.hoverBorderColor, helpers.getHoverColor(options.borderColor));
				model.borderWidth = helpers.valueOrDefault(options.hoverBorderWidth, options.borderWidth);
				model.radius = options.radius + options.hoverRadius;
			},
	
			/**
			 * @protected
			 */
			removeHoverStyle: function(point) {
				var model = point._model;
				var options = point._options;
	
				model.backgroundColor = options.backgroundColor;
				model.borderColor = options.borderColor;
				model.borderWidth = options.borderWidth;
				model.radius = options.radius;
			},
	
			/**
			 * @private
			 */
			_resolveElementOptions: function(point, index) {
				var me = this;
				var chart = me.chart;
				var datasets = chart.data.datasets;
				var dataset = datasets[me.index];
				var custom = point.custom || {};
				var options = chart.options.elements.point;
				var resolve = helpers.options.resolve;
				var data = dataset.data[index];
				var values = {};
				var i, ilen, key;
	
				// Scriptable options
				var context = {
					chart: chart,
					dataIndex: index,
					dataset: dataset,
					datasetIndex: me.index
				};
	
				var keys = [
					'backgroundColor',
					'borderColor',
					'borderWidth',
					'hoverBackgroundColor',
					'hoverBorderColor',
					'hoverBorderWidth',
					'hoverRadius',
					'hitRadius',
					'pointStyle'
				];
	
				for (i = 0, ilen = keys.length; i < ilen; ++i) {
					key = keys[i];
					values[key] = resolve([
						custom[key],
						dataset[key],
						options[key]
					], context, index);
				}
	
				// Custom radius resolution
				values.radius = resolve([
					custom.radius,
					data ? data.r : undefined,
					dataset.radius,
					options.radius
				], context, index);
	
				return values;
			}
		});
	};


/***/ },

/***/ "./node_modules/chart.js/src/controllers/controller.doughnut.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var elements = __webpack_require__("./node_modules/chart.js/src/elements/index.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	defaults._set('doughnut', {
		animation: {
			// Boolean - Whether we animate the rotation of the Doughnut
			animateRotate: true,
			// Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale: false
		},
		hover: {
			mode: 'single'
		},
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');
	
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
	
			if (datasets.length) {
				for (var i = 0; i < datasets[0].data.length; ++i) {
					text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
					if (labels[i]) {
						text.push(labels[i]);
					}
					text.push('</li>');
				}
			}
	
			text.push('</ul>');
			return text.join('');
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var ds = data.datasets[0];
							var arc = meta.data[i];
							var custom = arc && arc.custom || {};
							var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
							var arcOpts = chart.options.elements.arc;
							var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
							var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
							var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
							return {
								text: label,
								fillStyle: fill,
								strokeStyle: stroke,
								lineWidth: bw,
								hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					// toggle visibility of index if exists
					if (meta.data[index]) {
						meta.data[index].hidden = !meta.data[index].hidden;
					}
				}
	
				chart.update();
			}
		},
	
		// The percentage of the chart that we cut out of the middle.
		cutoutPercentage: 50,
	
		// The rotation of the chart, where the first data arc begins.
		rotation: Math.PI * -0.5,
	
		// The total circumference of the chart.
		circumference: Math.PI * 2.0,
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(tooltipItem, data) {
					var dataLabel = data.labels[tooltipItem.index];
					var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	
					if (helpers.isArray(dataLabel)) {
						// show value on first line of multiline label
						// need to clone because we are changing the value
						dataLabel = dataLabel.slice();
						dataLabel[0] += value;
					} else {
						dataLabel += value;
					}
	
					return dataLabel;
				}
			}
		}
	});
	
	defaults._set('pie', helpers.clone(defaults.doughnut));
	defaults._set('pie', {
		cutoutPercentage: 0
	});
	
	module.exports = function(Chart) {
	
		Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({
	
			dataElementType: elements.Arc,
	
			linkScales: helpers.noop,
	
			// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
			getRingIndex: function(datasetIndex) {
				var ringIndex = 0;
	
				for (var j = 0; j < datasetIndex; ++j) {
					if (this.chart.isDatasetVisible(j)) {
						++ringIndex;
					}
				}
	
				return ringIndex;
			},
	
			update: function(reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var opts = chart.options;
				var arcOpts = opts.elements.arc;
				var availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth;
				var availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth;
				var minSize = Math.min(availableWidth, availableHeight);
				var offset = {x: 0, y: 0};
				var meta = me.getMeta();
				var cutoutPercentage = opts.cutoutPercentage;
				var circumference = opts.circumference;
	
				// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
				if (circumference < Math.PI * 2.0) {
					var startAngle = opts.rotation % (Math.PI * 2.0);
					startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
					var endAngle = startAngle + circumference;
					var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
					var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
					var contains0 = (startAngle <= 0 && endAngle >= 0) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
					var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
					var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
					var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
					var cutout = cutoutPercentage / 100.0;
					var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
					var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
					var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
					minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
					offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
				}
	
				chart.borderWidth = me.getMaxBorderWidth(meta.data);
				chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
				chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
				chart.offsetX = offset.x * chart.outerRadius;
				chart.offsetY = offset.y * chart.outerRadius;
	
				meta.total = me.calculateTotal();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
				me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var opts = chart.options;
				var animationOpts = opts.animation;
				var centerX = (chartArea.left + chartArea.right) / 2;
				var centerY = (chartArea.top + chartArea.bottom) / 2;
				var startAngle = opts.rotation; // non reset case handled later
				var endAngle = opts.rotation; // non reset case handled later
				var dataset = me.getDataset();
				var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI));
				var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
				var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
				var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: centerX + chart.offsetX,
						y: centerY + chart.offsetY,
						startAngle: startAngle,
						endAngle: endAngle,
						circumference: circumference,
						outerRadius: outerRadius,
						innerRadius: innerRadius,
						label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
					}
				});
	
				var model = arc._model;
				// Resets the visual styles
				this.removeHoverStyle(arc);
	
				// Set correct angles if not resetting
				if (!reset || !animationOpts.animateRotate) {
					if (index === 0) {
						model.startAngle = opts.rotation;
					} else {
						model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
					}
	
					model.endAngle = model.startAngle + model.circumference;
				}
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			calculateTotal: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var total = 0;
				var value;
	
				helpers.each(meta.data, function(element, index) {
					value = dataset.data[index];
					if (!isNaN(value) && !element.hidden) {
						total += Math.abs(value);
					}
				});
	
				/* if (total === 0) {
					total = NaN;
				}*/
	
				return total;
			},
	
			calculateCircumference: function(value) {
				var total = this.getMeta().total;
				if (total > 0 && !isNaN(value)) {
					return (Math.PI * 2.0) * (value / total);
				}
				return 0;
			},
	
			// gets the max border or hover width to properly scale pie charts
			getMaxBorderWidth: function(arcs) {
				var max = 0;
				var index = this.index;
				var length = arcs.length;
				var borderWidth;
				var hoverWidth;
	
				for (var i = 0; i < length; i++) {
					borderWidth = arcs[i]._model ? arcs[i]._model.borderWidth : 0;
					hoverWidth = arcs[i]._chart ? arcs[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
				return max;
			}
		});
	};


/***/ },

/***/ "./node_modules/chart.js/src/controllers/controller.line.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var elements = __webpack_require__("./node_modules/chart.js/src/elements/index.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	defaults._set('line', {
		showLines: true,
		spanGaps: false,
	
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				id: 'x-axis-0'
			}],
			yAxes: [{
				type: 'linear',
				id: 'y-axis-0'
			}]
		}
	});
	
	module.exports = function(Chart) {
	
		function lineEnabled(dataset, options) {
			return helpers.valueOrDefault(dataset.showLine, options.showLines);
		}
	
		Chart.controllers.line = Chart.DatasetController.extend({
	
			datasetElementType: elements.Line,
	
			dataElementType: elements.Point,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data || [];
				var options = me.chart.options;
				var lineElementOptions = options.elements.line;
				var scale = me.getScaleForId(meta.yAxisID);
				var i, ilen, custom;
				var dataset = me.getDataset();
				var showLine = lineEnabled(dataset, options);
	
				// Update Line
				if (showLine) {
					custom = line.custom || {};
	
					// Compatibility: If the properties are defined with only the old name, use those values
					if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
						dataset.lineTension = dataset.tension;
					}
	
					// Utility
					line._scale = scale;
					line._datasetIndex = me.index;
					// Data
					line._children = points;
					// Model
					line._model = {
						// Appearance
						// The default behavior of lines is to break at null values, according
						// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
						// This option gives lines the ability to span gaps
						spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
						tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						steppedLine: custom.steppedLine ? custom.steppedLine : helpers.valueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
						cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.valueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
					};
	
					line.pivot();
				}
	
				// Update Points
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					me.updateElement(points[i], i, reset);
				}
	
				if (showLine && line._model.tension !== 0) {
					me.updateBezierControlPoints();
				}
	
				// Now pivot the point for animation
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					points[i].pivot();
				}
			},
	
			getPointBackgroundColor: function(point, index) {
				var backgroundColor = this.chart.options.elements.point.backgroundColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.backgroundColor) {
					backgroundColor = custom.backgroundColor;
				} else if (dataset.pointBackgroundColor) {
					backgroundColor = helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
				} else if (dataset.backgroundColor) {
					backgroundColor = dataset.backgroundColor;
				}
	
				return backgroundColor;
			},
	
			getPointBorderColor: function(point, index) {
				var borderColor = this.chart.options.elements.point.borderColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.borderColor) {
					borderColor = custom.borderColor;
				} else if (dataset.pointBorderColor) {
					borderColor = helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
				} else if (dataset.borderColor) {
					borderColor = dataset.borderColor;
				}
	
				return borderColor;
			},
	
			getPointBorderWidth: function(point, index) {
				var borderWidth = this.chart.options.elements.point.borderWidth;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (!isNaN(custom.borderWidth)) {
					borderWidth = custom.borderWidth;
				} else if (!isNaN(dataset.pointBorderWidth) || helpers.isArray(dataset.pointBorderWidth)) {
					borderWidth = helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
				} else if (!isNaN(dataset.borderWidth)) {
					borderWidth = dataset.borderWidth;
				}
	
				return borderWidth;
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var datasetIndex = me.index;
				var value = dataset.data[index];
				var yScale = me.getScaleForId(meta.yAxisID);
				var xScale = me.getScaleForId(meta.xAxisID);
				var pointOptions = me.chart.options.elements.point;
				var x, y;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}
	
				x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
				y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
				// Utility
				point._xScale = xScale;
				point._yScale = yScale;
				point._datasetIndex = datasetIndex;
				point._index = index;
	
				// Desired view properties
				point._model = {
					x: x,
					y: y,
					skip: custom.skip || isNaN(x) || isNaN(y),
					// Appearance
					radius: custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
					pointStyle: custom.pointStyle || helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
					backgroundColor: me.getPointBackgroundColor(point, index),
					borderColor: me.getPointBorderColor(point, index),
					borderWidth: me.getPointBorderWidth(point, index),
					tension: meta.dataset._model ? meta.dataset._model.tension : 0,
					steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
					// Tooltip
					hitRadius: custom.hitRadius || helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
				};
			},
	
			calculatePointY: function(value, index, datasetIndex) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var sumPos = 0;
				var sumNeg = 0;
				var i, ds, dsMeta;
	
				if (yScale.options.stacked) {
					for (i = 0; i < datasetIndex; i++) {
						ds = chart.data.datasets[i];
						dsMeta = chart.getDatasetMeta(i);
						if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
							var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
							if (stackedRightValue < 0) {
								sumNeg += stackedRightValue || 0;
							} else {
								sumPos += stackedRightValue || 0;
							}
						}
					}
	
					var rightValue = Number(yScale.getRightValue(value));
					if (rightValue < 0) {
						return yScale.getPixelForValue(sumNeg + rightValue);
					}
					return yScale.getPixelForValue(sumPos + rightValue);
				}
	
				return yScale.getPixelForValue(value);
			},
	
			updateBezierControlPoints: function() {
				var me = this;
				var meta = me.getMeta();
				var area = me.chart.chartArea;
				var points = (meta.data || []);
				var i, ilen, point, model, controlPoints;
	
				// Only consider points that are drawn in case the spanGaps option is used
				if (meta.dataset._model.spanGaps) {
					points = points.filter(function(pt) {
						return !pt._model.skip;
					});
				}
	
				function capControlPoint(pt, min, max) {
					return Math.max(Math.min(pt, max), min);
				}
	
				if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
					helpers.splineCurveMonotone(points);
				} else {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						point = points[i];
						model = point._model;
						controlPoints = helpers.splineCurve(
							helpers.previousItem(points, i)._model,
							model,
							helpers.nextItem(points, i)._model,
							meta.dataset._model.tension
						);
						model.controlPointPreviousX = controlPoints.previous.x;
						model.controlPointPreviousY = controlPoints.previous.y;
						model.controlPointNextX = controlPoints.next.x;
						model.controlPointNextY = controlPoints.next.y;
					}
				}
	
				if (me.chart.options.elements.line.capBezierPoints) {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						model = points[i]._model;
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			},
	
			draw: function() {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var points = meta.data || [];
				var area = chart.chartArea;
				var ilen = points.length;
				var i = 0;
	
				helpers.canvas.clipArea(chart.ctx, area);
	
				if (lineEnabled(me.getDataset(), chart.options)) {
					meta.dataset.draw();
				}
	
				helpers.canvas.unclipArea(chart.ctx);
	
				// Draw the points
				for (; i < ilen; ++i) {
					points[i].draw(area);
				}
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.hoverRadius || helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
	
				model.radius = custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
				model.backgroundColor = me.getPointBackgroundColor(point, index);
				model.borderColor = me.getPointBorderColor(point, index);
				model.borderWidth = me.getPointBorderWidth(point, index);
			}
		});
	};


/***/ },

/***/ "./node_modules/chart.js/src/controllers/controller.polarArea.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var elements = __webpack_require__("./node_modules/chart.js/src/elements/index.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	defaults._set('polarArea', {
		scale: {
			type: 'radialLinear',
			angleLines: {
				display: false
			},
			gridLines: {
				circular: true
			},
			pointLabels: {
				display: false
			},
			ticks: {
				beginAtZero: true
			}
		},
	
		// Boolean - Whether to animate the rotation of the chart
		animation: {
			animateRotate: true,
			animateScale: true
		},
	
		startAngle: -0.5 * Math.PI,
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');
	
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
	
			if (datasets.length) {
				for (var i = 0; i < datasets[0].data.length; ++i) {
					text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
					if (labels[i]) {
						text.push(labels[i]);
					}
					text.push('</li>');
				}
			}
	
			text.push('</ul>');
			return text.join('');
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var ds = data.datasets[0];
							var arc = meta.data[i];
							var custom = arc.custom || {};
							var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
							var arcOpts = chart.options.elements.arc;
							var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
							var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
							var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
							return {
								text: label,
								fillStyle: fill,
								strokeStyle: stroke,
								lineWidth: bw,
								hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					meta.data[index].hidden = !meta.data[index].hidden;
				}
	
				chart.update();
			}
		},
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(item, data) {
					return data.labels[item.index] + ': ' + item.yLabel;
				}
			}
		}
	});
	
	module.exports = function(Chart) {
	
		Chart.controllers.polarArea = Chart.DatasetController.extend({
	
			dataElementType: elements.Arc,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var meta = me.getMeta();
				var opts = chart.options;
				var arcOpts = opts.elements.arc;
				var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
				chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
				chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
				me.innerRadius = me.outerRadius - chart.radiusLength;
	
				meta.count = me.countVisibleElements();
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart;
				var dataset = me.getDataset();
				var opts = chart.options;
				var animationOpts = opts.animation;
				var scale = chart.scale;
				var labels = chart.data.labels;
	
				var circumference = me.calculateCircumference(dataset.data[index]);
				var centerX = scale.xCenter;
				var centerY = scale.yCenter;
	
				// If there is NaN data before us, we need to calculate the starting angle correctly.
				// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
				var visibleCount = 0;
				var meta = me.getMeta();
				for (var i = 0; i < index; ++i) {
					if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
						++visibleCount;
					}
				}
	
				// var negHalfPI = -0.5 * Math.PI;
				var datasetStartAngle = opts.startAngle;
				var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
				var startAngle = datasetStartAngle + (circumference * visibleCount);
				var endAngle = startAngle + (arc.hidden ? 0 : circumference);
	
				var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: centerX,
						y: centerY,
						innerRadius: 0,
						outerRadius: reset ? resetRadius : distance,
						startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
						endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
						label: helpers.valueAtIndexOrDefault(labels, index, labels[index])
					}
				});
	
				// Apply border and fill style
				me.removeHoverStyle(arc);
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			countVisibleElements: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var count = 0;
	
				helpers.each(meta.data, function(element, index) {
					if (!isNaN(dataset.data[index]) && !element.hidden) {
						count++;
					}
				});
	
				return count;
			},
	
			calculateCircumference: function(value) {
				var count = this.getMeta().count;
				if (count > 0 && !isNaN(value)) {
					return (2 * Math.PI) / count;
				}
				return 0;
			}
		});
	};


/***/ },

/***/ "./node_modules/chart.js/src/controllers/controller.radar.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var elements = __webpack_require__("./node_modules/chart.js/src/elements/index.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	defaults._set('radar', {
		scale: {
			type: 'radialLinear'
		},
		elements: {
			line: {
				tension: 0 // no bezier in radar
			}
		}
	});
	
	module.exports = function(Chart) {
	
		Chart.controllers.radar = Chart.DatasetController.extend({
	
			datasetElementType: elements.Line,
	
			dataElementType: elements.Point,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data;
				var custom = line.custom || {};
				var dataset = me.getDataset();
				var lineElementOptions = me.chart.options.elements.line;
				var scale = me.chart.scale;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}
	
				helpers.extend(meta.dataset, {
					// Utility
					_datasetIndex: me.index,
					_scale: scale,
					// Data
					_children: points,
					_loop: true,
					// Model
					_model: {
						// Appearance
						tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
					}
				});
	
				meta.dataset.pivot();
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				}, me);
	
				// Update bezier control points
				me.updateBezierControlPoints();
			},
			updateElement: function(point, index, reset) {
				var me = this;
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var scale = me.chart.scale;
				var pointElementOptions = me.chart.options.elements.point;
				var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}
	
				helpers.extend(point, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
						y: reset ? scale.yCenter : pointPosition.y,
	
						// Appearance
						tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
						radius: custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
						borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
						pointStyle: custom.pointStyle ? custom.pointStyle : helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
			},
			updateBezierControlPoints: function() {
				var chartArea = this.chart.chartArea;
				var meta = this.getMeta();
	
				helpers.each(meta.data, function(point, index) {
					var model = point._model;
					var controlPoints = helpers.splineCurve(
						helpers.previousItem(meta.data, index, true)._model,
						model,
						helpers.nextItem(meta.data, index, true)._model,
						model.tension
					);
	
					// Prevent the bezier going outside of the bounds of the graph
					model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
					model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);
	
					model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
					model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);
	
					// Now pivot the point for animation
					point.pivot();
				});
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
	
				model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
				var pointElementOptions = this.chart.options.elements.point;
	
				model.radius = custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius);
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
			}
		});
	};


/***/ },

/***/ "./node_modules/chart.js/src/controllers/controller.scatter.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	
	defaults._set('scatter', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				id: 'x-axis-1',    // need an ID so datasets can reference the scale
				type: 'linear',    // scatter should not use a category axis
				position: 'bottom'
			}],
			yAxes: [{
				id: 'y-axis-1',
				type: 'linear',
				position: 'left'
			}]
		},
	
		showLines: false,
	
		tooltips: {
			callbacks: {
				title: function() {
					return '';     // doesn't make sense for scatter since data are formatted as a point
				},
				label: function(item) {
					return '(' + item.xLabel + ', ' + item.yLabel + ')';
				}
			}
		}
	});
	
	module.exports = function(Chart) {
	
		// Scatter charts use line controllers
		Chart.controllers.scatter = Chart.controllers.line;
	
	};


/***/ },

/***/ "./node_modules/chart.js/src/charts/Chart.Bar.js":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bar = function(context, config) {
			config.type = 'bar';
	
			return new Chart(context, config);
		};
	
	};


/***/ },

/***/ "./node_modules/chart.js/src/charts/Chart.Bubble.js":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bubble = function(context, config) {
			config.type = 'bubble';
			return new Chart(context, config);
		};
	
	};


/***/ },

/***/ "./node_modules/chart.js/src/charts/Chart.Doughnut.js":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Doughnut = function(context, config) {
			config.type = 'doughnut';
	
			return new Chart(context, config);
		};
	
	};


/***/ },

/***/ "./node_modules/chart.js/src/charts/Chart.Line.js":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Line = function(context, config) {
			config.type = 'line';
	
			return new Chart(context, config);
		};
	
	};


/***/ },

/***/ "./node_modules/chart.js/src/charts/Chart.PolarArea.js":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.PolarArea = function(context, config) {
			config.type = 'polarArea';
	
			return new Chart(context, config);
		};
	
	};


/***/ },

/***/ "./node_modules/chart.js/src/charts/Chart.Radar.js":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Radar = function(context, config) {
			config.type = 'radar';
	
			return new Chart(context, config);
		};
	
	};


/***/ },

/***/ "./node_modules/chart.js/src/charts/Chart.Scatter.js":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
		Chart.Scatter = function(context, config) {
			config.type = 'scatter';
			return new Chart(context, config);
		};
	};


/***/ },

/***/ "./node_modules/chart.js/src/plugins/plugin.filler.js":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Plugin based on discussion from the following Chart.js issues:
	 * @see https://github.com/chartjs/Chart.js/issues/2380#issuecomment-279961569
	 * @see https://github.com/chartjs/Chart.js/issues/2440#issuecomment-256461897
	 */
	
	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var elements = __webpack_require__("./node_modules/chart.js/src/elements/index.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	defaults._set('global', {
		plugins: {
			filler: {
				propagate: true
			}
		}
	});
	
	module.exports = function() {
	
		var mappers = {
			dataset: function(source) {
				var index = source.fill;
				var chart = source.chart;
				var meta = chart.getDatasetMeta(index);
				var visible = meta && chart.isDatasetVisible(index);
				var points = (visible && meta.dataset._children) || [];
				var length = points.length || 0;
	
				return !length ? null : function(point, i) {
					return (i < length && points[i]._view) || null;
				};
			},
	
			boundary: function(source) {
				var boundary = source.boundary;
				var x = boundary ? boundary.x : null;
				var y = boundary ? boundary.y : null;
	
				return function(point) {
					return {
						x: x === null ? point.x : x,
						y: y === null ? point.y : y,
					};
				};
			}
		};
	
		// @todo if (fill[0] === '#')
		function decodeFill(el, index, count) {
			var model = el._model || {};
			var fill = model.fill;
			var target;
	
			if (fill === undefined) {
				fill = !!model.backgroundColor;
			}
	
			if (fill === false || fill === null) {
				return false;
			}
	
			if (fill === true) {
				return 'origin';
			}
	
			target = parseFloat(fill, 10);
			if (isFinite(target) && Math.floor(target) === target) {
				if (fill[0] === '-' || fill[0] === '+') {
					target = index + target;
				}
	
				if (target === index || target < 0 || target >= count) {
					return false;
				}
	
				return target;
			}
	
			switch (fill) {
			// compatibility
			case 'bottom':
				return 'start';
			case 'top':
				return 'end';
			case 'zero':
				return 'origin';
			// supported boundaries
			case 'origin':
			case 'start':
			case 'end':
				return fill;
			// invalid fill values
			default:
				return false;
			}
		}
	
		function computeBoundary(source) {
			var model = source.el._model || {};
			var scale = source.el._scale || {};
			var fill = source.fill;
			var target = null;
			var horizontal;
	
			if (isFinite(fill)) {
				return null;
			}
	
			// Backward compatibility: until v3, we still need to support boundary values set on
			// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
			// controllers might still use it (e.g. the Smith chart).
	
			if (fill === 'start') {
				target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
			} else if (fill === 'end') {
				target = model.scaleTop === undefined ? scale.top : model.scaleTop;
			} else if (model.scaleZero !== undefined) {
				target = model.scaleZero;
			} else if (scale.getBasePosition) {
				target = scale.getBasePosition();
			} else if (scale.getBasePixel) {
				target = scale.getBasePixel();
			}
	
			if (target !== undefined && target !== null) {
				if (target.x !== undefined && target.y !== undefined) {
					return target;
				}
	
				if (typeof target === 'number' && isFinite(target)) {
					horizontal = scale.isHorizontal();
					return {
						x: horizontal ? target : null,
						y: horizontal ? null : target
					};
				}
			}
	
			return null;
		}
	
		function resolveTarget(sources, index, propagate) {
			var source = sources[index];
			var fill = source.fill;
			var visited = [index];
			var target;
	
			if (!propagate) {
				return fill;
			}
	
			while (fill !== false && visited.indexOf(fill) === -1) {
				if (!isFinite(fill)) {
					return fill;
				}
	
				target = sources[fill];
				if (!target) {
					return false;
				}
	
				if (target.visible) {
					return fill;
				}
	
				visited.push(fill);
				fill = target.fill;
			}
	
			return false;
		}
	
		function createMapper(source) {
			var fill = source.fill;
			var type = 'dataset';
	
			if (fill === false) {
				return null;
			}
	
			if (!isFinite(fill)) {
				type = 'boundary';
			}
	
			return mappers[type](source);
		}
	
		function isDrawable(point) {
			return point && !point.skip;
		}
	
		function drawArea(ctx, curve0, curve1, len0, len1) {
			var i;
	
			if (!len0 || !len1) {
				return;
			}
	
			// building first area curve (normal)
			ctx.moveTo(curve0[0].x, curve0[0].y);
			for (i = 1; i < len0; ++i) {
				helpers.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
			}
	
			// joining the two area curves
			ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
	
			// building opposite area curve (reverse)
			for (i = len1 - 1; i > 0; --i) {
				helpers.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
			}
		}
	
		function doFill(ctx, points, mapper, view, color, loop) {
			var count = points.length;
			var span = view.spanGaps;
			var curve0 = [];
			var curve1 = [];
			var len0 = 0;
			var len1 = 0;
			var i, ilen, index, p0, p1, d0, d1;
	
			ctx.beginPath();
	
			for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
				index = i % count;
				p0 = points[index]._view;
				p1 = mapper(p0, index, view);
				d0 = isDrawable(p0);
				d1 = isDrawable(p1);
	
				if (d0 && d1) {
					len0 = curve0.push(p0);
					len1 = curve1.push(p1);
				} else if (len0 && len1) {
					if (!span) {
						drawArea(ctx, curve0, curve1, len0, len1);
						len0 = len1 = 0;
						curve0 = [];
						curve1 = [];
					} else {
						if (d0) {
							curve0.push(p0);
						}
						if (d1) {
							curve1.push(p1);
						}
					}
				}
			}
	
			drawArea(ctx, curve0, curve1, len0, len1);
	
			ctx.closePath();
			ctx.fillStyle = color;
			ctx.fill();
		}
	
		return {
			id: 'filler',
	
			afterDatasetsUpdate: function(chart, options) {
				var count = (chart.data.datasets || []).length;
				var propagate = options.propagate;
				var sources = [];
				var meta, i, el, source;
	
				for (i = 0; i < count; ++i) {
					meta = chart.getDatasetMeta(i);
					el = meta.dataset;
					source = null;
	
					if (el && el._model && el instanceof elements.Line) {
						source = {
							visible: chart.isDatasetVisible(i),
							fill: decodeFill(el, i, count),
							chart: chart,
							el: el
						};
					}
	
					meta.$filler = source;
					sources.push(source);
				}
	
				for (i = 0; i < count; ++i) {
					source = sources[i];
					if (!source) {
						continue;
					}
	
					source.fill = resolveTarget(sources, i, propagate);
					source.boundary = computeBoundary(source);
					source.mapper = createMapper(source);
				}
			},
	
			beforeDatasetDraw: function(chart, args) {
				var meta = args.meta.$filler;
				if (!meta) {
					return;
				}
	
				var ctx = chart.ctx;
				var el = meta.el;
				var view = el._view;
				var points = el._children || [];
				var mapper = meta.mapper;
				var color = view.backgroundColor || defaults.global.defaultColor;
	
				if (mapper && color && points.length) {
					helpers.canvas.clipArea(ctx, chart.chartArea);
					doFill(ctx, points, mapper, view, color, el._loop);
					helpers.canvas.unclipArea(ctx);
				}
			}
		};
	};


/***/ },

/***/ "./node_modules/chart.js/src/plugins/plugin.legend.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var Element = __webpack_require__("./node_modules/chart.js/src/core/core.element.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	defaults._set('global', {
		legend: {
			display: true,
			position: 'top',
			fullWidth: true,
			reverse: false,
			weight: 1000,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var data = chart.data;
					return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
						return {
							text: dataset.label,
							fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
							hidden: !chart.isDatasetVisible(i),
							lineCap: dataset.borderCapStyle,
							lineDash: dataset.borderDash,
							lineDashOffset: dataset.borderDashOffset,
							lineJoin: dataset.borderJoinStyle,
							lineWidth: dataset.borderWidth,
							strokeStyle: dataset.borderColor,
							pointStyle: dataset.pointStyle,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: i
						};
					}, this) : [];
				}
			}
		},
	
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');
			for (var i = 0; i < chart.data.datasets.length; i++) {
				text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
				if (chart.data.datasets[i].label) {
					text.push(chart.data.datasets[i].label);
				}
				text.push('</li>');
			}
			text.push('</ul>');
			return text.join('');
		}
	});
	
	module.exports = function(Chart) {
	
		var layout = Chart.layoutService;
		var noop = helpers.noop;
	
		/**
		 * Helper function to get the box width based on the usePointStyle option
		 * @param labelopts {Object} the label options on the legend
		 * @param fontSize {Number} the label font size
		 * @return {Number} width of the color box area
		 */
		function getBoxWidth(labelOpts, fontSize) {
			return labelOpts.usePointStyle ?
				fontSize * Math.SQRT2 :
				labelOpts.boxWidth;
		}
	
		Chart.Legend = Element.extend({
	
			initialize: function(config) {
				helpers.extend(this, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				this.legendHitBoxes = [];
	
				// Are we in doughnut mode which has a different data type
				this.doughnutMode = false;
			},
	
			// These methods are ordered by lifecycle. Utilities then follow.
			// Any function defined here is inherited by all legend types.
			// Any function can be extended by the legend type
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: function() {
				var me = this;
				var labelOpts = me.options.labels || {};
				var legendItems = helpers.callback(labelOpts.generateLabels, [me.chart], me) || [];
	
				if (labelOpts.filter) {
					legendItems = legendItems.filter(function(item) {
						return labelOpts.filter(item, me.chart.data);
					});
				}
	
				if (me.options.reverse) {
					legendItems.reverse();
				}
	
				me.legendItems = legendItems;
			},
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var display = opts.display;
	
				var ctx = me.ctx;
	
				var globalDefault = defaults.global;
				var valueOrDefault = helpers.valueOrDefault;
				var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
				var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
				var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
				var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
				// Reset hit boxes
				var hitboxes = me.legendHitBoxes = [];
	
				var minSize = me.minSize;
				var isHorizontal = me.isHorizontal();
	
				if (isHorizontal) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = display ? 10 : 0;
				} else {
					minSize.width = display ? 10 : 0;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Increase sizes here
				if (display) {
					ctx.font = labelFont;
	
					if (isHorizontal) {
						// Labels
	
						// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
						var lineWidths = me.lineWidths = [0];
						var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;
	
						ctx.textAlign = 'left';
						ctx.textBaseline = 'top';
	
						helpers.each(me.legendItems, function(legendItem, i) {
							var boxWidth = getBoxWidth(labelOpts, fontSize);
							var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
							if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
								totalHeight += fontSize + (labelOpts.padding);
								lineWidths[lineWidths.length] = me.left;
							}
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: width,
								height: fontSize
							};
	
							lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
						});
	
						minSize.height += totalHeight;
	
					} else {
						var vPadding = labelOpts.padding;
						var columnWidths = me.columnWidths = [];
						var totalWidth = labelOpts.padding;
						var currentColWidth = 0;
						var currentColHeight = 0;
						var itemHeight = fontSize + vPadding;
	
						helpers.each(me.legendItems, function(legendItem, i) {
							var boxWidth = getBoxWidth(labelOpts, fontSize);
							var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
							// If too tall, go to new column
							if (currentColHeight + itemHeight > minSize.height) {
								totalWidth += currentColWidth + labelOpts.padding;
								columnWidths.push(currentColWidth); // previous column width
	
								currentColWidth = 0;
								currentColHeight = 0;
							}
	
							// Get max width
							currentColWidth = Math.max(currentColWidth, itemWidth);
							currentColHeight += itemHeight;
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: itemWidth,
								height: fontSize
							};
						});
	
						totalWidth += currentColWidth;
						columnWidths.push(currentColWidth);
						minSize.width += totalWidth;
					}
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
	
			// Actually draw the legend on the canvas
			draw: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var globalDefault = defaults.global;
				var lineDefault = globalDefault.elements.line;
				var legendWidth = me.width;
				var lineWidths = me.lineWidths;
	
				if (opts.display) {
					var ctx = me.ctx;
					var valueOrDefault = helpers.valueOrDefault;
					var fontColor = valueOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor);
					var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
					var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
					var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
					var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
					var cursor;
	
					// Canvas setup
					ctx.textAlign = 'left';
					ctx.textBaseline = 'middle';
					ctx.lineWidth = 0.5;
					ctx.strokeStyle = fontColor; // for strikethrough effect
					ctx.fillStyle = fontColor; // render in correct colour
					ctx.font = labelFont;
	
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var hitboxes = me.legendHitBoxes;
	
					// current position
					var drawLegendBox = function(x, y, legendItem) {
						if (isNaN(boxWidth) || boxWidth <= 0) {
							return;
						}
	
						// Set the ctx for the box
						ctx.save();
	
						ctx.fillStyle = valueOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
						ctx.lineCap = valueOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
						ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
						ctx.lineJoin = valueOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
						ctx.lineWidth = valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
						ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
						var isLineWidthZero = (valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);
	
						if (ctx.setLineDash) {
							// IE 9 and 10 do not support line dash
							ctx.setLineDash(valueOrDefault(legendItem.lineDash, lineDefault.borderDash));
						}
	
						if (opts.labels && opts.labels.usePointStyle) {
							// Recalculate x and y for drawPoint() because its expecting
							// x and y to be center of figure (instead of top left)
							var radius = fontSize * Math.SQRT2 / 2;
							var offSet = radius / Math.SQRT2;
							var centerX = x + offSet;
							var centerY = y + offSet;
	
							// Draw pointStyle as legend symbol
							helpers.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
						} else {
							// Draw box as legend symbol
							if (!isLineWidthZero) {
								ctx.strokeRect(x, y, boxWidth, fontSize);
							}
							ctx.fillRect(x, y, boxWidth, fontSize);
						}
	
						ctx.restore();
					};
					var fillText = function(x, y, legendItem, textWidth) {
						var halfFontSize = fontSize / 2;
						var xLeft = boxWidth + halfFontSize + x;
						var yMiddle = y + halfFontSize;
	
						ctx.fillText(legendItem.text, xLeft, yMiddle);
	
						if (legendItem.hidden) {
							// Strikethrough the text if hidden
							ctx.beginPath();
							ctx.lineWidth = 2;
							ctx.moveTo(xLeft, yMiddle);
							ctx.lineTo(xLeft + textWidth, yMiddle);
							ctx.stroke();
						}
					};
	
					// Horizontal
					var isHorizontal = me.isHorizontal();
					if (isHorizontal) {
						cursor = {
							x: me.left + ((legendWidth - lineWidths[0]) / 2),
							y: me.top + labelOpts.padding,
							line: 0
						};
					} else {
						cursor = {
							x: me.left + labelOpts.padding,
							y: me.top + labelOpts.padding,
							line: 0
						};
					}
	
					var itemHeight = fontSize + labelOpts.padding;
					helpers.each(me.legendItems, function(legendItem, i) {
						var textWidth = ctx.measureText(legendItem.text).width;
						var width = boxWidth + (fontSize / 2) + textWidth;
						var x = cursor.x;
						var y = cursor.y;
	
						if (isHorizontal) {
							if (x + width >= legendWidth) {
								y = cursor.y += itemHeight;
								cursor.line++;
								x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
							}
						} else if (y + itemHeight > me.bottom) {
							x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
							y = cursor.y = me.top + labelOpts.padding;
							cursor.line++;
						}
	
						drawLegendBox(x, y, legendItem);
	
						hitboxes[i].left = x;
						hitboxes[i].top = y;
	
						// Fill the actual label
						fillText(x, y, legendItem, textWidth);
	
						if (isHorizontal) {
							cursor.x += width + (labelOpts.padding);
						} else {
							cursor.y += itemHeight;
						}
	
					});
				}
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event - The event to handle
			 * @return {Boolean} true if a change occured
			 */
			handleEvent: function(e) {
				var me = this;
				var opts = me.options;
				var type = e.type === 'mouseup' ? 'click' : e.type;
				var changed = false;
	
				if (type === 'mousemove') {
					if (!opts.onHover) {
						return;
					}
				} else if (type === 'click') {
					if (!opts.onClick) {
						return;
					}
				} else {
					return;
				}
	
				// Chart event already has relative position in it
				var x = e.x;
				var y = e.y;
	
				if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
					// See if we are touching one of the dataset boxes
					var lh = me.legendHitBoxes;
					for (var i = 0; i < lh.length; ++i) {
						var hitBox = lh[i];
	
						if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
							// Touching an element
							if (type === 'click') {
								// use e.native for backwards compatibility
								opts.onClick.call(me, e.native, me.legendItems[i]);
								changed = true;
								break;
							} else if (type === 'mousemove') {
								// use e.native for backwards compatibility
								opts.onHover.call(me, e.native, me.legendItems[i]);
								changed = true;
								break;
							}
						}
					}
				}
	
				return changed;
			}
		});
	
		function createNewLegendAndAttach(chart, legendOpts) {
			var legend = new Chart.Legend({
				ctx: chart.ctx,
				options: legendOpts,
				chart: chart
			});
	
			layout.configure(chart, legend, legendOpts);
			layout.addBox(chart, legend);
			chart.legend = legend;
		}
	
		return {
			id: 'legend',
	
			beforeInit: function(chart) {
				var legendOpts = chart.options.legend;
	
				if (legendOpts) {
					createNewLegendAndAttach(chart, legendOpts);
				}
			},
	
			beforeUpdate: function(chart) {
				var legendOpts = chart.options.legend;
				var legend = chart.legend;
	
				if (legendOpts) {
					helpers.mergeIf(legendOpts, defaults.global.legend);
	
					if (legend) {
						layout.configure(chart, legend, legendOpts);
						legend.options = legendOpts;
					} else {
						createNewLegendAndAttach(chart, legendOpts);
					}
				} else if (legend) {
					layout.removeBox(chart, legend);
					delete chart.legend;
				}
			},
	
			afterEvent: function(chart, e) {
				var legend = chart.legend;
				if (legend) {
					legend.handleEvent(e);
				}
			}
		};
	};


/***/ },

/***/ "./node_modules/chart.js/src/plugins/plugin.title.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__("./node_modules/chart.js/src/core/core.defaults.js");
	var Element = __webpack_require__("./node_modules/chart.js/src/core/core.element.js");
	var helpers = __webpack_require__("./node_modules/chart.js/src/helpers/index.js");
	
	defaults._set('global', {
		title: {
			display: false,
			fontStyle: 'bold',
			fullWidth: true,
			lineHeight: 1.2,
			padding: 10,
			position: 'top',
			text: '',
			weight: 2000         // by default greater than legend (1000) to be above
		}
	});
	
	module.exports = function(Chart) {
	
		var layout = Chart.layoutService;
		var noop = helpers.noop;
	
		Chart.Title = Element.extend({
			initialize: function(config) {
				var me = this;
				helpers.extend(me, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				me.legendHitBoxes = [];
			},
	
			// These methods are ordered by lifecycle. Utilities then follow.
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: noop,
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this;
				var valueOrDefault = helpers.valueOrDefault;
				var opts = me.options;
				var display = opts.display;
				var fontSize = valueOrDefault(opts.fontSize, defaults.global.defaultFontSize);
				var minSize = me.minSize;
				var lineCount = helpers.isArray(opts.text) ? opts.text.length : 1;
				var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
				var textSize = display ? (lineCount * lineHeight) + (opts.padding * 2) : 0;
	
				if (me.isHorizontal()) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = textSize;
				} else {
					minSize.width = textSize;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
	
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				var pos = this.options.position;
				return pos === 'top' || pos === 'bottom';
			},
	
			// Actually draw the title block on the canvas
			draw: function() {
				var me = this;
				var ctx = me.ctx;
				var valueOrDefault = helpers.valueOrDefault;
				var opts = me.options;
				var globalDefaults = defaults.global;
	
				if (opts.display) {
					var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize);
					var fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle);
					var fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily);
					var titleFont = helpers.fontString(fontSize, fontStyle, fontFamily);
					var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
					var offset = lineHeight / 2 + opts.padding;
					var rotation = 0;
					var top = me.top;
					var left = me.left;
					var bottom = me.bottom;
					var right = me.right;
					var maxWidth, titleX, titleY;
	
					ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
					ctx.font = titleFont;
	
					// Horizontal
					if (me.isHorizontal()) {
						titleX = left + ((right - left) / 2); // midpoint of the width
						titleY = top + offset;
						maxWidth = right - left;
					} else {
						titleX = opts.position === 'left' ? left + offset : right - offset;
						titleY = top + ((bottom - top) / 2);
						maxWidth = bottom - top;
						rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
					}
	
					ctx.save();
					ctx.translate(titleX, titleY);
					ctx.rotate(rotation);
					ctx.textAlign = 'center';
					ctx.textBaseline = 'middle';
	
					var text = opts.text;
					if (helpers.isArray(text)) {
						var y = 0;
						for (var i = 0; i < text.length; ++i) {
							ctx.fillText(text[i], 0, y, maxWidth);
							y += lineHeight;
						}
					} else {
						ctx.fillText(text, 0, 0, maxWidth);
					}
	
					ctx.restore();
				}
			}
		});
	
		function createNewTitleBlockAndAttach(chart, titleOpts) {
			var title = new Chart.Title({
				ctx: chart.ctx,
				options: titleOpts,
				chart: chart
			});
	
			layout.configure(chart, title, titleOpts);
			layout.addBox(chart, title);
			chart.titleBlock = title;
		}
	
		return {
			id: 'title',
	
			beforeInit: function(chart) {
				var titleOpts = chart.options.title;
	
				if (titleOpts) {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			},
	
			beforeUpdate: function(chart) {
				var titleOpts = chart.options.title;
				var titleBlock = chart.titleBlock;
	
				if (titleOpts) {
					helpers.mergeIf(titleOpts, defaults.global.title);
	
					if (titleBlock) {
						layout.configure(chart, titleBlock, titleOpts);
						titleBlock.options = titleOpts;
					} else {
						createNewTitleBlockAndAttach(chart, titleOpts);
					}
				} else if (titleBlock) {
					Chart.layoutService.removeBox(chart, titleBlock);
					delete chart.titleBlock;
				}
			}
		};
	};


/***/ },

/***/ "./node_modules/lodash/find.js":
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__("./node_modules/lodash/_createFind.js"),
	    findIndex = __webpack_require__("./node_modules/lodash/findIndex.js");
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },

/***/ "./node_modules/lodash/_createFind.js":
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
	    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js"),
	    keys = __webpack_require__("./node_modules/lodash/keys.js");
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },

/***/ "./node_modules/lodash/findIndex.js":
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__("./node_modules/lodash/_baseFindIndex.js"),
	    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
	    toInteger = __webpack_require__("./node_modules/lodash/toInteger.js");
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },

/***/ "./node_modules/lodash/toInteger.js":
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__("./node_modules/lodash/toFinite.js");
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },

/***/ "./node_modules/lodash/toFinite.js":
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__("./node_modules/lodash/toNumber.js");
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },

/***/ "./node_modules/lodash/keyBy.js":
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__("./node_modules/lodash/_baseAssignValue.js"),
	    createAggregator = __webpack_require__("./node_modules/lodash/_createAggregator.js");
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The corresponding value of
	 * each key is the last element responsible for generating the key. The
	 * iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * var array = [
	 *   { 'dir': 'left', 'code': 97 },
	 *   { 'dir': 'right', 'code': 100 }
	 * ];
	 *
	 * _.keyBy(array, function(o) {
	 *   return String.fromCharCode(o.code);
	 * });
	 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	 *
	 * _.keyBy(array, 'dir');
	 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	 */
	var keyBy = createAggregator(function(result, value, key) {
	  baseAssignValue(result, key, value);
	});
	
	module.exports = keyBy;


/***/ },

/***/ "./node_modules/lodash/_createAggregator.js":
/***/ function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__("./node_modules/lodash/_arrayAggregator.js"),
	    baseAggregator = __webpack_require__("./node_modules/lodash/_baseAggregator.js"),
	    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js");
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ },

/***/ "./node_modules/lodash/_arrayAggregator.js":
/***/ function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ },

/***/ "./node_modules/lodash/_baseAggregator.js":
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__("./node_modules/lodash/_baseEach.js");
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ },

/***/ "./src/universal/helpers/statistiquesHelpers.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.StatistiquesHelpers = undefined;
	
	var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	var _flights = __webpack_require__("./src/universal/collections/flights/flights.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reservations2 = __webpack_require__("./src/universal/collections/statistics/reservations.js");
	
	var _flights2 = __webpack_require__("./src/universal/collections/statistics/flights.js");
	
	var _pilots = __webpack_require__("./src/universal/collections/statistics/pilots.js");
	
	var _montgolfieres = __webpack_require__("./src/universal/collections/statistics/montgolfieres.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var StatistiquesHelpers = exports.StatistiquesHelpers = function () {
		function StatistiquesHelpers(props) {
			(0, _classCallCheck3.default)(this, StatistiquesHelpers);
		}
	
		(0, _createClass3.default)(StatistiquesHelpers, null, [{
			key: 'launchStatistiques',
			value: function launchStatistiques(type, from, to, affichage) {
				var _this = this;
	
				return new _promise2.default(function (resolve, reject) {
	
					if (type == 'reservations') {
						return resolve({
							labels: _this.getLabels(from, to, affichage),
							datasets: [_this.setDataSets('Cumulé', _this.getReservations(from, to, affichage)[0], '74,135,252'), _this.setDataSets('Angers', _this.getReservations(from, to, affichage)[1], '75,192,192'), _this.setDataSets('Nantes', _this.getReservations(from, to, affichage)[2], '250, 114, 82')]
						});
					}
	
					if (type == 'vols') {
						return resolve({
							labels: _this.getLabels(from, to, affichage),
							datasets: [_this.setDataSets('Cumulé', _this.getVols(from, to, affichage)[0], '74,135,252'), _this.setDataSets('Angers', _this.getVols(from, to, affichage)[1], '75,192,192'), _this.setDataSets('Nantes', _this.getVols(from, to, affichage)[2], '250, 114, 82')]
						});
					}
	
					if (type == 'pilotes-vols') {
	
						var that = _this;
						_this.getPilotsVols(from, to, affichage).then(function (results) {
	
							var datasets = [];
	
							_.each(results, function (data) {
								datasets.push(that.setDataSets(data[0], data[1], data[2]));
							});
	
							return resolve({
								labels: that.getLabels(from, to, affichage),
								datasets: datasets
							});
						});
					}
	
					if (type == 'pilotes-heures') {
	
						var _that = _this;
						_this.getPilotsHeures(from, to, affichage).then(function (results) {
	
							var datasets = [];
	
							_.each(results, function (data) {
								datasets.push(_that.setDataSets(data[0], data[1], data[2]));
							});
	
							return resolve({
								labels: _that.getLabels(from, to, affichage),
								datasets: datasets
							});
						});
					}
	
					if (type == 'montgolfieres-vols') {
	
						console.log('montgolfieres-vols');
	
						var _that2 = _this;
						_this.getMontgolfieresVols(from, to, affichage).then(function (results) {
	
							var datasets = [];
	
							_.each(results, function (data) {
								datasets.push(_that2.setDataSets(data[0], data[1], data[2]));
							});
	
							return resolve({
								labels: _that2.getLabels(from, to, affichage),
								datasets: datasets
							});
						});
					}
	
					if (type == 'montgolfieres-heures') {
	
						var _that3 = _this;
						_this.getMontgolfieresHeures(from, to, affichage).then(function (results) {
	
							var datasets = [];
	
							_.each(results, function (data) {
								datasets.push(_that3.setDataSets(data[0], data[1], data[2]));
							});
	
							return resolve({
								labels: _that3.getLabels(from, to, affichage),
								datasets: datasets
							});
						});
					}
				});
			}
		}, {
			key: 'getLabels',
			value: function getLabels(from, to, affichage) {
				var labels = [];
				if (affichage == 'months') {
					for (var i = 0; i <= (0, _moment2.default)(to).diff((0, _moment2.default)(from), 'months'); i++) {
						var month = (0, _moment2.default)(from).add(i, 'months').format('MMMM YYYY');
						labels.push(month.charAt(0).toUpperCase() + month.slice(1));
					}
					return labels;
				} else {
					for (var _i = 0; _i <= (0, _moment2.default)(to).diff((0, _moment2.default)(from), 'years'); _i++) {
						labels.push((0, _moment2.default)(from).add(_i, 'years').format('YYYY'));
					}return labels;
				}
			}
		}, {
			key: 'setDataSets',
			value: function setDataSets(label, data, color) {
				return {
					label: label,
					fill: false,
					lineTension: 0.1,
					backgroundColor: 'rgba(' + color + ',0.4)',
					borderColor: 'rgba(' + color + ',1)',
					borderCapStyle: 'butt',
					borderDash: [],
					borderDashOffset: 0.0,
					borderJoinStyle: 'miter',
					pointBorderColor: 'rgba(' + color + ',1)',
					pointBackgroundColor: '#fff',
					pointBorderWidth: 1,
					pointHoverRadius: 5,
					pointHoverBackgroundColor: 'rgba(' + color + ',1)',
					pointHoverBorderColor: 'rgba(220,220,220,1)',
					pointHoverBorderWidth: 2,
					pointRadius: 1,
					pointHitRadius: 10,
					data: data
				};
			}
		}, {
			key: 'getVols',
			value: function getVols(from, to, affichage) {
				return _flights2.flightsStatistics.call({
					from: from,
					to: to,
					affichage: affichage
				}, function (err, results) {
					return results;
				}.bind(this));
			}
		}, {
			key: 'getReservations',
			value: function getReservations(from, to, affichage) {
				return _reservations2.reservationsStatistics.call({
					from: from,
					to: to,
					affichage: affichage
				}, function (err, results) {
					return results;
				}.bind(this));
			}
		}, {
			key: 'getPilotsVols',
			value: function getPilotsVols(from, to, affichage) {
				var _this2 = this;
	
				return new _promise2.default(function (resolve, reject) {
					return _pilots.pilotsFlightsStatistics.call({
						from: from,
						to: to,
						affichage: affichage
					}, function (err, results) {
						resolve(results);
					}.bind(_this2));
				});
			}
		}, {
			key: 'getPilotsHeures',
			value: function getPilotsHeures(from, to, affichage) {
				var _this3 = this;
	
				return new _promise2.default(function (resolve, reject) {
					return _pilots.pilotsHoursStatistics.call({
						from: from,
						to: to,
						affichage: affichage
					}, function (err, results) {
						resolve(results);
					}.bind(_this3));
				});
			}
		}, {
			key: 'getMontgolfieresVols',
			value: function getMontgolfieresVols(from, to, affichage) {
				var _this4 = this;
	
				return new _promise2.default(function (resolve, reject) {
					return _montgolfieres.montgolfieresFlightsStatistics.call({
						from: from,
						to: to,
						affichage: affichage
					}, function (err, results) {
						resolve(results);
					}.bind(_this4));
				});
			}
		}, {
			key: 'getMontgolfieresHeures',
			value: function getMontgolfieresHeures(from, to, affichage) {
				var _this5 = this;
	
				return new _promise2.default(function (resolve, reject) {
					return _montgolfieres.montgolfieresHoursStatistics.call({
						from: from,
						to: to,
						affichage: affichage
					}, function (err, results) {
						resolve(results);
					}.bind(_this5));
				});
			}
		}]);
		return StatistiquesHelpers;
	}();

/***/ },

/***/ "./src/universal/components/statistiques/Tableau.component.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Tableau = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var Tableau = exports.Tableau = function (_React$Component) {
		(0, _inherits3.default)(Tableau, _React$Component);
	
		function Tableau(props) {
			(0, _classCallCheck3.default)(this, Tableau);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (Tableau.__proto__ || (0, _getPrototypeOf2.default)(Tableau)).call(this, props));
	
			_this.state = {};
			_this.state.data = props.data;
			_this.state.columnCount = props.data.datasets.length;
			return _this;
		}
	
		(0, _createClass3.default)(Tableau, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				this.setState({
					data: nextProps.data,
					columnCount: nextProps.data.datasets.length
				});
			}
		}, {
			key: 'calculTotal',
			value: function calculTotal(index) {
				var total = 0;
				_.each(this.state.data.datasets[index].data, function (data) {
					total += data;
				});
	
				return total;
			}
		}, {
			key: 'renderData',
			value: function renderData(label, index) {
				return this.state.data.datasets.map(function (item) {
					return _react2.default.createElement(
						'td',
						null,
						item.data[index]
					);
				});
			}
		}, {
			key: 'renderRow',
			value: function renderRow() {
				var _this2 = this;
	
				return this.state.data.labels.map(function (label, index) {
					return _react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							null,
							label
						),
						_this2.renderData(label, index)
					);
				});
			}
		}, {
			key: 'renderHead',
			value: function renderHead() {
				return this.state.data.datasets.map(function (item) {
					return _react2.default.createElement(
						'th',
						null,
						item.label
					);
				});
			}
		}, {
			key: 'renderTotal',
			value: function renderTotal() {
				var _this3 = this;
	
				return _react2.default.createElement(
					'tr',
					null,
					_react2.default.createElement(
						'td',
						null,
						'Total'
					),
					this.state.data.datasets.map(function (item, index) {
						return _react2.default.createElement(
							'td',
							null,
							_this3.calculTotal(index)
						);
					})
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Table,
						{ striped: true, bordered: true, condensed: true, hover: true },
						_react2.default.createElement(
							'thead',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									null,
									' - '
								),
								this.renderHead()
							)
						),
						_react2.default.createElement(
							'tbody',
							null,
							this.renderRow()
						),
						_react2.default.createElement(
							'thead',
							{ style: { backgroundColor: '#89949B', color: 'white' } },
							this.renderTotal()
						)
					)
				);
			}
		}]);
		return Tableau;
	}(_react2.default.Component);

/***/ },

/***/ "./src/universal/components/partners/PartnerList.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _users = __webpack_require__("./src/universal/collections/users/users.js");
	
	var _mgfTable = __webpack_require__("./src/universal/components/common/mgfTable.js");
	
	var _mgfTable2 = _interopRequireDefault(_mgfTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var PartnerListPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["users"],
		users: Meteor.users.find({ roles: { $in: ['partner'] } })
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(PartnerListPage, _React$Component);
	
		function PartnerListPage(props) {
			(0, _classCallCheck3.default)(this, PartnerListPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (PartnerListPage.__proto__ || (0, _getPrototypeOf2.default)(PartnerListPage)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(PartnerListPage, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							'Utilisateurs'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ active: true },
							'Liste des utilisateurs'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/users/add' },
								_react2.default.createElement(
									_rubix.Button,
									{ bsStyle: 'success' },
									'Ajouter'
								)
							)
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Liste des utilisateurs' },
						this.props.isReady && _react2.default.createElement(_mgfTable2.default, { fields: _users.UserSchema._schema, list: this.props.users, type: 'partners' })
					)
				);
			}
		}]);
		return PartnerListPage;
	}(_react2.default.Component)) || _class);
	exports.default = PartnerListPage;
	
	
	PartnerListPage.propTypes = {
		users: _react2.default.PropTypes.array.isRequired
	};

/***/ },

/***/ "./src/universal/components/partners/PartnerEdit.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _uniformsBootstrap = __webpack_require__("./node_modules/uniforms-bootstrap3/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Reactive = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _users = __webpack_require__("./src/universal/collections/users/users.js");
	
	var _methods = __webpack_require__("./src/universal/collections/users/methods.js");
	
	var _mgfForm = __webpack_require__("./src/universal/components/common/mgfForm.js");
	
	var _mgfForm2 = _interopRequireDefault(_mgfForm);
	
	var _SpecialPrices = __webpack_require__("./src/universal/components/partners/components/SpecialPrices.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var SimpleSchema = Package['aldeed:simple-schema'].SimpleSchema;
	var PartnerEditPage = (_dec = (0, _Reactive.Reactive)({
		subscriptions: ["users"]
	}), _dec(_class = (0, _reactRouter.withRouter)(_class = function (_React$Component) {
		(0, _inherits3.default)(PartnerEditPage, _React$Component);
	
		function PartnerEditPage(props) {
			(0, _classCallCheck3.default)(this, PartnerEditPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (PartnerEditPage.__proto__ || (0, _getPrototypeOf2.default)(PartnerEditPage)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(PartnerEditPage, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.isReady && !this.props.isReady) {
					this.setState({
						user: Meteor.users.findOne({ _id: this.props.params.id })
					});
				}
			}
		}, {
			key: 'handleSubmit',
			value: function handleSubmit() {
				var params = {};
	
				params.attributes = {};
				_lodash2.default.each(this.refs, function (ref, key) {
					params.attributes[key] = _reactDom2.default.findDOMNode(ref).value.trim();
				});
	
				Meteor.users.update(this.state.user._id, { "$set": params.attributes });
	
				window.location.replace('/partners');
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					this.props.isReady && _react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/partners' },
								'Partenaires'
							)
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							{ href: '#', active: true },
							this.state.user.profile.firstName,
							' ',
							this.state.user.profile.lastName
						)
					),
					this.props.isReady && _react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Modifier le partenaire' },
						_react2.default.createElement(
							_rubix.Form,
							{ horizontal: true, onSubmit: this.handleSubmit.bind(this) },
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalEmail' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'Adresse'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 10 },
									_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'profile.street', defaultValue: this.state.user.profile.street })
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalEmail' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'Code postal et ville'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 10 },
									_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'profile.city', defaultValue: this.state.user.profile.city })
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalEmail' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'T\xE9l\xE9phone'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 10 },
									_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'profile.phone', defaultValue: this.state.user.profile.phone })
								)
							),
							_react2.default.createElement('hr', null),
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalEmail' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'Nombre de commande offerte'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 10 },
									_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'profile.freeFlights', defaultValue: this.state.user.profile.freeFlights })
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalPassword' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'Type de facturation'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 10 },
									_react2.default.createElement(
										_rubix.FormControl,
										{ componentClass: 'select', placeholder: 'select', ref: 'profile.billType', defaultValue: this.state.user.profile.billType },
										_react2.default.createElement(
											'option',
											{ value: 'standard' },
											'Standard'
										),
										_react2.default.createElement(
											'option',
											{ value: 'groupe' },
											'Group\xE9'
										)
									)
								)
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalPassword' },
								_react2.default.createElement(
									_rubix.Col,
									{ componentClass: _rubix.ControlLabel, sm: 2 },
									'Acc\xE8s au calendrier'
								),
								_react2.default.createElement(
									_rubix.Col,
									{ sm: 10 },
									_react2.default.createElement(
										_rubix.FormControl,
										{ componentClass: 'select', placeholder: 'select', ref: 'profile.accessToCalendar', defaultValue: this.state.user.profile.accessToCalendar },
										_react2.default.createElement(
											'option',
											{ value: '' },
											'Non'
										),
										_react2.default.createElement(
											'option',
											{ value: 'true' },
											'Oui'
										)
									)
								)
							),
							_react2.default.createElement('hr', null),
							_react2.default.createElement(
								_rubix.FormGroup,
								{ controlId: 'formHorizontalPassword' },
								_react2.default.createElement(_SpecialPrices.SpecialPricesComponent, { user: this.state.user })
							),
							_react2.default.createElement(
								_rubix.FormGroup,
								null,
								_react2.default.createElement(
									_rubix.Col,
									{ smOffset: 2, sm: 10 },
									_react2.default.createElement(
										_rubix.Button,
										{ onClick: this.handleSubmit.bind(this) },
										'Enregistrer'
									)
								)
							)
						)
					)
				);
			}
		}]);
		return PartnerEditPage;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = PartnerEditPage;

/***/ },

/***/ "./src/universal/components/partners/components/SpecialPrices.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SpecialPricesComponent = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _Reactive = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _flightsType = __webpack_require__("./src/universal/collections/flights-type/flights-type.js");
	
	var _prices = __webpack_require__("./src/universal/collections/flights-type/prices.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var Tracker = Package.tracker.Tracker;
	var SpecialPricesComponent = exports.SpecialPricesComponent = (_dec = (0, _Reactive.Reactive)({
		subscriptions: ["flights-type"]
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(SpecialPricesComponent, _React$Component);
	
		function SpecialPricesComponent(props) {
			(0, _classCallCheck3.default)(this, SpecialPricesComponent);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (SpecialPricesComponent.__proto__ || (0, _getPrototypeOf2.default)(SpecialPricesComponent)).call(this, props));
	
			_this.state = {};
			_this.state.user = props.user;
			_this.state.prices = [];
			props.ready.then(function () {
				Tracker.nonreactive(function () {
					_this.setState({
						flights: _flightsType.FlightsType.find({ partnerId: null }).fetch(),
						selectedFlight: _flightsType.FlightsType.find({ partnerId: null }).fetch()[0],
						specialFlights: _flightsType.FlightsType.find({ partnerId: props.user._id }).fetch()
					});
				});
			});
			return _this;
		}
	
		(0, _createClass3.default)(SpecialPricesComponent, [{
			key: 'renderFlights',
			value: function renderFlights() {
				var _this2 = this;
	
				return this.state.specialFlights.map(function (flight) {
					return _react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							null,
							flight.title
						),
						_react2.default.createElement(
							'td',
							null,
							flight.prices()[0].title
						),
						_react2.default.createElement(
							'td',
							null,
							flight.prices()[0].price,
							'\u20AC'
						),
						_react2.default.createElement(
							'td',
							{ className: 'text-center' },
							_react2.default.createElement(
								_rubix.Button,
								{ bsStyle: 'danger', onClick: _this2.onDelete.bind(_this2, flight._id) },
								'Supprimer'
							)
						)
					);
				});
			}
		}, {
			key: 'selectFlight',
			value: function selectFlight() {
				var id = _reactDom2.default.findDOMNode(this.refs.flight).value;
	
				this.setState({
					selectedFlight: _flightsType.FlightsType.findOne(id)
				});
			}
		}, {
			key: 'onDelete',
			value: function onDelete(value) {
	
				Meteor.call('flightsType.remove', value, function (err, _id) {
	
					if (err) {
						Messenger().post({
							message: "Erreur lors de la suppression.",
							type: "error"
						});
						return;
					}
	
					Messenger().post({
						message: "Le vol a bien été supprimé.",
						type: "success"
					});
	
					this.setState({
						flights: _flightsType.FlightsType.find({ partnerId: null }),
						specialFlights: _flightsType.FlightsType.find({ partnerId: this.state.user._id }).fetch()
					});
				}.bind(this));
			}
		}, {
			key: 'onAdd',
			value: function onAdd() {
				var params = {};
				var message = null;
				var method = null;
	
				params.attributes = {};
				_.each(this.refs, function (ref, key) {
					params.attributes[key] = _reactDom2.default.findDOMNode(ref).value.trim();
				});
	
				message = "Le vol a été ajouté avec succès.";
				method = "flightsType.insertPartner";
	
				var clone = _flightsType.FlightsType.findOne(params.attributes['flight']);
				clone.partnerId = this.state.user._id;
				clone.quantity = params.attributes['quantity'];
	
				clone.priceSemaine = _reactDom2.default.findDOMNode(this.refs.priceSemaine).value.trim();
				clone.priceLibreDate = _reactDom2.default.findDOMNode(this.refs.priceLibreDate).value.trim();
				clone.priceEnfant = _reactDom2.default.findDOMNode(this.refs.priceEnfant).value.trim();
	
				params.attributes = clone;
	
				Meteor.call(method, params, function (err, _id) {
	
					if (err) {
						Messenger().post({
							message: err,
							type: "error"
						});
						return;
					}
	
					Messenger().post({
						message: message,
						type: "success"
					});
	
					this.setState({
						specialFlights: _flightsType.FlightsType.find({ partnerId: this.state.user._id })
					});
				}.bind(this));
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				if (!this.props.isReady || !this.state.specialFlights || !this.state.selectedFlight) {
					return _react2.default.createElement(
						'div',
						null,
						'Chargement...'
					);
				}
	
				return _react2.default.createElement(
					_rubix.Col,
					{ sm: 12 },
					_react2.default.createElement(
						_rubix.Col,
						{ sm: 12 },
						_react2.default.createElement(
							_rubix.Table,
							{ striped: true, bordered: true, condensed: true, hover: true, responsive: true },
							_react2.default.createElement(
								'thead',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'th',
										null,
										'Type'
									),
									_react2.default.createElement(
										'th',
										null,
										'Tarifs sp\xE9ciaux'
									),
									_react2.default.createElement(
										'th',
										null,
										'\xA0'
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(
											_rubix.FormControl,
											{ componentClass: 'select', placeholder: 'select', ref: 'flight', onChange: this.selectFlight.bind(this) },
											this.state.flights.map(function (flight) {
												return _react2.default.createElement(
													'option',
													{ value: flight._id },
													flight.title
												);
											})
										)
									),
									_react2.default.createElement(
										'td',
										null,
										'SEMAINE : ',
										_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'priceSemaine' }),
										'LIBRE DATE : ',
										_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'priceLibreDate' }),
										'ENFANT : ',
										_react2.default.createElement(_rubix.FormControl, { type: 'text', ref: 'priceEnfant' })
									),
									_react2.default.createElement(
										'td',
										{ className: 'text-center' },
										_react2.default.createElement(
											_rubix.Button,
											{ bsStyle: 'success', onClick: this.onAdd.bind(this) },
											'+ AJOUTER'
										)
									)
								),
								this.state.specialFlights.map(function (flight) {
									return _react2.default.createElement(
										'tr',
										null,
										_react2.default.createElement(
											'td',
											null,
											flight.title
										),
										_react2.default.createElement(
											'td',
											null,
											'SEMAINE : ',
											flight.priceSemaine,
											'\u20AC',
											_react2.default.createElement('br', null),
											'LIBRE DATE : ',
											flight.priceLibreDate,
											'\u20AC',
											_react2.default.createElement('br', null),
											'ENFANT : ',
											flight.priceEnfant,
											'\u20AC'
										),
										_react2.default.createElement(
											'td',
											{ className: 'text-center' },
											_react2.default.createElement(
												_rubix.Button,
												{ bsStyle: 'danger', onClick: _this3.onDelete.bind(_this3, flight._id) },
												'Supprimer'
											)
										)
									);
								})
							)
						)
					)
				);
			}
		}]);
		return SpecialPricesComponent;
	}(_react2.default.Component)) || _class);

/***/ },

/***/ "./src/universal/components/partners/GroupBillList.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _groupBillsPayments = __webpack_require__("./src/universal/collections/partners/group-bills-payments.js");
	
	var _users = __webpack_require__("./src/universal/collections/users/users.js");
	
	var _mgfTable = __webpack_require__("./src/universal/components/common/mgfTable.js");
	
	var _mgfTable2 = _interopRequireDefault(_mgfTable);
	
	var _GroupBillModal = __webpack_require__("./src/universal/components/partners/components/GroupBillModal.js");
	
	var _groupBills = __webpack_require__("./src/universal/collections/partners/group-bills.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tracker = Package.tracker.Tracker;
	var Base64 = Package.base64.Base64;
	var HTTP = Package.http.HTTP;
	var Meteor = Package.meteor.Meteor;
	var GroupBillListPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["reservations-groupBills", "flights-type", "users", "group-bills"]
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(GroupBillListPage, _React$Component);
	
		function GroupBillListPage(props) {
			(0, _classCallCheck3.default)(this, GroupBillListPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (GroupBillListPage.__proto__ || (0, _getPrototypeOf2.default)(GroupBillListPage)).call(this, props));
	
			_this.state = {
				modal: {
					visible: false
				}
			};
	
			props.ready.then(function () {
				Tracker.nonreactive(function () {
					_this.setState({
						groupBills: _groupBills.GroupBills.find({}, { sort: { 'id_facture': -1 } }).fetch()
					});
				});
			});
			return _this;
		}
	
		(0, _createClass3.default)(GroupBillListPage, [{
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (this.state.visible != prevState.visible) {
					this.setState({
						groupBills: _groupBills.GroupBills.find({}, { sort: { 'id_facture': -1 } }).fetch()
					});
				}
			}
		}, {
			key: 'openModal',
			value: function openModal(event) {
				this.setState({
					visible: true,
					bill: _groupBills.GroupBills.findOne(event.target.id),
					payments: _groupBillsPayments.GroupBillsPayments.find({ bill: event.target.id }).fetch()
				});
			}
		}, {
			key: 'addPayment',
			value: function addPayment() {
	
				var payment = {
					'type': _reactDom2.default.findDOMNode(this.refs.type).value.trim(),
					'montant': _reactDom2.default.findDOMNode(this.refs.montant).value.trim(),
					'informations': _reactDom2.default.findDOMNode(this.refs.informations).value.trim(),
					'bill': this.props.bill._id
				};
	
				var that = this;
				Meteor.call('groupbills.payments.insert', payment, function (err, _id) {
					if (err) {
						Messenger().post({
							message: "Erreur, " + err,
							type: "error"
						});
						return;
					}
	
					Messenger().post({
						message: "Le paiement a été enregistré.",
						type: "success"
					});
	
					that.props.onHide();
				});
			}
		}, {
			key: 'removePayment',
			value: function removePayment(event) {
	
				if (confirm('Êtes-vous sûr de vouloir supprimer ce paiement ?')) {
	
					var that = this;
					Meteor.call('groupbills.payments.remove', event.target.value, function (err, _id) {
						if (err) {
							Messenger().post({
								message: "Erreur..." + err,
								type: "error"
							});
							return;
						}
	
						Messenger().post({
							message: "Le paiement a été supprimé.",
							type: "success"
						});
	
						that.props.onHide();
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				if (!this.state.groupBills) {
					return _react2.default.createElement(_rubix.Progress, { active: true, value: 100 });
				}
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							'Factures group\xE9es'
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/group-bills/add' },
								_react2.default.createElement(
									_rubix.Button,
									{ bsStyle: 'success' },
									'Cr\xE9er'
								)
							)
						)
					),
					this.state.bill && _react2.default.createElement(_GroupBillModal.GroupBillModal, { visible: this.state.visible, bill: this.state.bill, payments: this.state.payments, addPayment: this.addPayment, removePayment: this.removePayment, onHide: function onHide() {
							return _this2.setState({ visible: false });
						} }),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Factures group\xE9es' },
						_react2.default.createElement(
							_rubix.Table,
							{ striped: true, bordered: true, condensed: true, hover: true, responsive: true },
							_react2.default.createElement(
								'thead',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'th',
										null,
										'#ID'
									),
									_react2.default.createElement(
										'th',
										null,
										'Partenaire'
									),
									_react2.default.createElement(
										'th',
										null,
										'Mois'
									),
									_react2.default.createElement(
										'th',
										null,
										'Montant'
									),
									_react2.default.createElement(
										'th',
										null,
										'Solde'
									),
									_react2.default.createElement(
										'th',
										null,
										'\xA0'
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								this.state.groupBills && this.state.groupBills.map(function (bill) {
									return _react2.default.createElement(
										'tr',
										null,
										_react2.default.createElement(
											'td',
											null,
											bill.id_facture,
											' (',
											bill.reservations.length,
											')'
										),
										_react2.default.createElement(
											'td',
											null,
											bill.getPartner() && bill.getPartner().displayName() || 'N/C'
										),
										_react2.default.createElement(
											'td',
											null,
											_react2.default.createElement(
												_reactMoment2.default,
												{ format: 'MM/YYYY' },
												bill.month
											)
										),
										_react2.default.createElement(
											'td',
											null,
											bill.price,
											'\u20AC'
										),
										_react2.default.createElement(
											'td',
											null,
											bill.solde > 0 && _react2.default.createElement(
												_rubix.Button,
												{ block: true, bsStyle: 'warning' },
												bill.solde,
												'\u20AC'
											),
											bill.solde == 0 && _react2.default.createElement(
												_rubix.Button,
												{ block: true, bsStyle: 'success' },
												bill.solde,
												'\u20AC'
											)
										),
										_react2.default.createElement(
											'td',
											{ className: 'text-center' },
											_react2.default.createElement(
												_rubix.Button,
												{ bsStyle: 'primary', id: bill._id, onClick: _this2.openModal.bind(_this2) },
												'Ouvrir'
											),
											'\xA0'
										)
									);
								})
							)
						)
					)
				);
			}
		}]);
		return GroupBillListPage;
	}(_react2.default.Component)) || _class);
	exports.default = GroupBillListPage;
	
	
	GroupBillListPage.propTypes = {
		groupBills: _react2.default.PropTypes.array.isRequired
	};

/***/ },

/***/ "./src/universal/components/partners/components/GroupBillModal.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GroupBillModal = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _groupBills = __webpack_require__("./src/universal/collections/partners/group-bills.js");
	
	var _groupBillsPayments = __webpack_require__("./src/universal/collections/partners/group-bills-payments.js");
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var HTTP = Package.http.HTTP;
	var Tracker = Package.tracker.Tracker;
	var GroupBillModal = exports.GroupBillModal = (_dec = (0, _ReactiveMixin.Reactive)({
	  subscriptions: ["group-bills"]
	}), _dec(_class = function (_React$Component) {
	  (0, _inherits3.default)(GroupBillModal, _React$Component);
	
	  function GroupBillModal(props) {
	    (0, _classCallCheck3.default)(this, GroupBillModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (GroupBillModal.__proto__ || (0, _getPrototypeOf2.default)(GroupBillModal)).call(this, props));
	
	    _this.state = {
	      visible: _this.props.visible,
	      payments: _this.props.payments
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(GroupBillModal, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var visible = _ref.visible;
	
	      this.setState({
	        visible: visible
	      });
	    }
	  }, {
	    key: 'goToView',
	    value: function goToView(event) {
	      this.context.router.push('/reservations/' + event.target.id);
	    }
	  }, {
	    key: 'openPopUp',
	    value: function openPopUp(urlToOpen) {
	      var popup_window = window.open(urlToOpen, "myWindow", "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=yes, width=400, height=400");
	      try {
	        popup_window.focus();
	      } catch (e) {
	        alert("Les fenêtes Pop-up sont bloquées ! Pour télécharger ce document, merci de les débloquer.");
	      }
	    }
	  }, {
	    key: 'download',
	    value: function download(ref) {
	      var _this2 = this;
	
	      var groupBill = _groupBills.GroupBills.findOne(ref.target.id);
	
	      var reservations = groupBill.getReservations().map(function (reservation) {
	        return {
	          'flight': reservation.flight,
	          'place': reservation.place,
	          'createdAd': reservation.createdAd,
	          'id_billet': reservation.id_billet,
	          'price': reservation.price
	        };
	      });
	
	      var data = {
	        'groupBill': groupBill,
	        'reservations': reservations,
	        'partner': groupBill.getPartner()
	      };
	
	      //data.groupBill.month = moment(data.groupBill.month).format('MMM YYYY');
	
	      HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=groupFacture', {
	        data: data
	      }, function (error, result) {
	        result = JSON.parse(result.content);
	        _this2.openPopUp("https://montgolfieres-pdf.amaia.at/" + result.id + ".pdf");
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context,
	          _this3 = this;
	
	      return _react2.default.createElement(
	        _rubix.Modal,
	        { show: this.state.visible, lg: true, 'aria-labelledby': 'contained-modal-title-lg', onHide: (_context = this.props).onHide.bind(_context) },
	        _react2.default.createElement(
	          _rubix.Modal.Header,
	          { closeButton: true },
	          _react2.default.createElement(
	            _rubix.Modal.Title,
	            { id: 'contained-modal-title-lg' },
	            'Facture n\xB0',
	            this.props.bill.id_facture
	          )
	        ),
	        _react2.default.createElement(
	          _rubix.Modal.Body,
	          null,
	          _react2.default.createElement(
	            _rubix.BPanel,
	            { header: 'R\xE9servations associ\xE9es' },
	            _react2.default.createElement(
	              _rubix.Table,
	              { striped: true, bordered: true, condensed: true, hover: true, responsive: true, className: 'text-center' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Billet'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Nom/Pr\xE9nom'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Date'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Montant'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                this.props.bill.getReservations().map(function (reservation) {
	                  return _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      reservation.id_billet
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      reservation.searchName
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement(
	                        _reactMoment2.default,
	                        { format: 'DD/MM/YYYY \xE0 kk:mm' },
	                        reservation.createdAt
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      reservation.getPrice(),
	                      '\u20AC'
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _rubix.BPanel,
	            { header: 'Etat de la facturation' },
	            _react2.default.createElement(
	              _rubix.Table,
	              { striped: true, bordered: true, responsive: true },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.bill.getSolde() > 0 && _react2.default.createElement(
	                      _rubix.Button,
	                      { block: true, bsStyle: 'danger' },
	                      this.props.bill.getSolde(),
	                      ' \u20AC restant'
	                    ),
	                    this.props.bill.getSolde() <= 0 && _react2.default.createElement(
	                      _rubix.Button,
	                      { block: true, bsStyle: 'success' },
	                      this.props.bill.getSolde(),
	                      ' \u20AC restant'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      _rubix.FormControl,
	                      { componentClass: 'select', type: 'select', ref: 'type' },
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Especes' },
	                        'Especes'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'CB internet' },
	                        'CB internet'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'CB' },
	                        'CB'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Ch\xE8que' },
	                        'Ch\xE8que'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Virement' },
	                        'Virement'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Autre' },
	                        'Autre'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(_rubix.FormControl, { placeholder: 'Montant', type: 'text', ref: 'montant' })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(_rubix.FormControl, { placeholder: 'Informations', type: 'text', ref: 'informations' })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      _rubix.Button,
	                      { bsStyle: 'primary', onClick: this.props.addPayment.bind(this) },
	                      'Ajouter'
	                    )
	                  )
	                )
	              )
	            ),
	            this.props.payments && this.props.payments.length > 0 && _react2.default.createElement(
	              _rubix.Table,
	              { striped: true, bordered: true, responsive: true },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Date'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Type'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Montant'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Informations'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '-'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                this.props.payments.map(function (payment) {
	                  return _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement(
	                        _reactMoment2.default,
	                        { format: 'DD/MM/YYYY \xE0 kk:mm' },
	                        payment.createdAt
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      payment.type
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      payment.montant,
	                      '\u20AC'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      payment.informations
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement(
	                        'center',
	                        null,
	                        _react2.default.createElement(
	                          _rubix.Button,
	                          { bsStyle: 'danger', onClick: _this3.props.removePayment.bind(_this3), value: payment._id },
	                          'X'
	                        )
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            !this.props.payments && _react2.default.createElement(_rubix.Progress, { active: true, value: 100 }),
	            this.props.payments && this.props.payments.length == 0 && _react2.default.createElement(
	              _rubix.Well,
	              null,
	              'Il n\'y a pas encore de paiement'
	            )
	          ),
	          _react2.default.createElement(
	            _rubix.Button,
	            { lg: true, bsStyle: 'success', block: true, id: this.props.bill._id, onClick: this.download.bind(this) },
	            'T\xE9l\xE9charger la facture'
	          )
	        ),
	        _react2.default.createElement(
	          _rubix.Modal.Footer,
	          null,
	          _react2.default.createElement(
	            _rubix.Button,
	            { bsStyle: 'primary', onClick: (_context = this.props).onHide.bind(_context) },
	            'Fermer'
	          )
	        )
	      );
	    }
	  }]);
	  return GroupBillModal;
	}(_react2.default.Component)) || _class);
	
	
	GroupBillModal.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/partners/GroupBillAdd.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	var _groupBills = __webpack_require__("./src/universal/collections/partners/group-bills.js");
	
	var _users = __webpack_require__("./src/universal/collections/users/users.js");
	
	var _mgfTable = __webpack_require__("./src/universal/components/common/mgfTable.js");
	
	var _mgfTable2 = _interopRequireDefault(_mgfTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	var GroupBillAddPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ["users", "reservations-all", "group-bills"],
		partners: Meteor.users.find({ roles: { $in: ['partner'] }, 'profile.billType': 'groupe' })
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(GroupBillAddPage, _React$Component);
	
		function GroupBillAddPage(props) {
			(0, _classCallCheck3.default)(this, GroupBillAddPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (GroupBillAddPage.__proto__ || (0, _getPrototypeOf2.default)(GroupBillAddPage)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(GroupBillAddPage, [{
			key: 'selectPartner',
			value: function selectPartner(ref) {
				var partnerId = ref.target.value;
	
				this.setState({
					//totalBills: Reservations.find({userId: partnerId, groupBill: null}).count(),
					partnerId: partnerId,
					month: ''
				});
	
				_reactDom2.default.findDOMNode(this.refs.month).value = '';
			}
		}, {
			key: 'selectMonth',
			value: function selectMonth(ref) {
				var month = ref.target.value;
	
				this.setState({
					month: (0, _moment2.default)(month).toDate()
				});
	
				var startDate = (0, _moment2.default)(month).startOf('month').toDate();
				var endDate = (0, _moment2.default)(month).endOf('month').toDate();
	
				console.log(_reservations.Reservations.find({ userId: this.state.partnerId, groupBill: null, createdAt: { $gte: startDate, $lte: endDate } }).count());
	
				this.setState({
					totalBills: _reservations.Reservations.find({ userId: this.state.partnerId, groupBill: null, createdAt: { $gte: startDate, $lte: endDate } }).count()
				});
			}
		}, {
			key: 'bill',
			value: function bill(partnerId, month) {
				var that = this;
				this.setState({
					totalBills: 0
				});
	
				Meteor.call('groupBills.insert', { partnerId: partnerId, month: month }, function (err, _id) {
					if (err) {
						Messenger().post({
							message: "Erreur...",
							type: "error"
						});
						return;
					}
	
					Messenger().post({
						message: "Facture enregistrée !",
						type: "success"
					});
				});
			}
		}, {
			key: 'render',
			value: function render() {
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.Breadcrumb,
						null,
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/group-bills' },
								'Factures group\xE9es'
							)
						),
						_react2.default.createElement(
							_rubix.Breadcrumb.Item,
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/group-bills/add' },
								_react2.default.createElement(
									_rubix.Button,
									{ bsStyle: 'success' },
									'Cr\xE9er'
								)
							)
						)
					),
					_react2.default.createElement(
						_rubix.BPanel,
						{ header: 'Factures group\xE9es' },
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 6 },
							this.props.isReady && _react2.default.createElement(
								_rubix.FormControl,
								{ componentClass: 'select', placeholder: 'select', ref: 'partner', onChange: this.selectPartner.bind(this) },
								_react2.default.createElement(
									'option',
									null,
									'-'
								),
								this.props.partners.map(function (partner) {
									return _react2.default.createElement(
										'option',
										{ value: partner._id },
										partner && partner.displayName() || 'N/C'
									);
								})
							)
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 3 },
							_react2.default.createElement(
								_rubix.FormControl,
								{ componentClass: 'select', placeholder: 'select', ref: 'month', onChange: this.selectMonth.bind(this) },
								_react2.default.createElement(
									'option',
									null,
									'-'
								),
								_react2.default.createElement(
									'option',
									{ value: (0, _moment2.default)().subtract(6, 'months').toDate() },
									(0, _moment2.default)().subtract(6, 'months').format('MMM YYYY')
								),
								_react2.default.createElement(
									'option',
									{ value: (0, _moment2.default)().subtract(5, 'months').toDate() },
									(0, _moment2.default)().subtract(5, 'months').format('MMM YYYY')
								),
								_react2.default.createElement(
									'option',
									{ value: (0, _moment2.default)().subtract(4, 'months').toDate() },
									(0, _moment2.default)().subtract(4, 'months').format('MMM YYYY')
								),
								_react2.default.createElement(
									'option',
									{ value: (0, _moment2.default)().subtract(3, 'months').toDate() },
									(0, _moment2.default)().subtract(3, 'months').format('MMM YYYY')
								),
								_react2.default.createElement(
									'option',
									{ value: (0, _moment2.default)().subtract(2, 'months').toDate() },
									(0, _moment2.default)().subtract(2, 'months').format('MMM YYYY')
								),
								_react2.default.createElement(
									'option',
									{ value: (0, _moment2.default)().subtract(1, 'months').toDate() },
									(0, _moment2.default)().subtract(1, 'months').format('MMM YYYY')
								),
								_react2.default.createElement(
									'option',
									{ value: (0, _moment2.default)().toDate() },
									(0, _moment2.default)().format('MMM YYYY')
								),
								_react2.default.createElement(
									'option',
									{ value: (0, _moment2.default)().add(1, 'months').toDate() },
									(0, _moment2.default)().add(1, 'months').format('MMM YYYY')
								),
								_react2.default.createElement(
									'option',
									{ value: (0, _moment2.default)().add(2, 'months').toDate() },
									(0, _moment2.default)().add(2, 'months').format('MMM YYYY')
								),
								_react2.default.createElement(
									'option',
									{ value: (0, _moment2.default)().add(3, 'months').toDate() },
									(0, _moment2.default)().add(3, 'months').format('MMM YYYY')
								),
								_react2.default.createElement(
									'option',
									{ value: (0, _moment2.default)().add(4, 'months').toDate() },
									(0, _moment2.default)().add(4, 'months').format('MMM YYYY')
								),
								_react2.default.createElement(
									'option',
									{ value: (0, _moment2.default)().add(5, 'months').toDate() },
									(0, _moment2.default)().add(5, 'months').format('MMM YYYY')
								),
								_react2.default.createElement(
									'option',
									{ value: (0, _moment2.default)().add(6, 'months').toDate() },
									(0, _moment2.default)().add(6, 'months').format('MMM YYYY')
								)
							)
						),
						_react2.default.createElement(
							_rubix.Col,
							{ sm: 3 },
							this.state.totalBills > 0 && this.state.month && _react2.default.createElement(
								_rubix.Button,
								{ bsStyle: 'success', onClick: this.bill.bind(this, this.state.partnerId, this.state.month) },
								'Facturer (',
								this.state.totalBills,
								')'
							),
							this.state.totalBills == 0 && this.state.month && _react2.default.createElement(
								_rubix.Button,
								null,
								'Rien \xE0 facturer'
							),
							this.state.month == null && _react2.default.createElement(
								_rubix.Button,
								null,
								'Aucun mois s\xE9l\xE9ctionn\xE9 !'
							)
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							'center',
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/group-bills' },
								'Retour aux factures group\xE9es'
							)
						)
					)
				);
			}
		}]);
		return GroupBillAddPage;
	}(_react2.default.Component)) || _class);
	exports.default = GroupBillAddPage;

/***/ },

/***/ "./src/universal/components/partners/GroupBillView.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactMoment = __webpack_require__("./node_modules/react-moment/dist/index.js");
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _groupBillsPayments = __webpack_require__("./src/universal/collections/partners/group-bills-payments.js");
	
	var _users = __webpack_require__("./src/universal/collections/users/users.js");
	
	var _mgfTable = __webpack_require__("./src/universal/components/common/mgfTable.js");
	
	var _mgfTable2 = _interopRequireDefault(_mgfTable);
	
	var _GroupBillModal = __webpack_require__("./src/universal/components/partners/components/GroupBillModal.js");
	
	var _groupBills = __webpack_require__("./src/universal/collections/partners/group-bills.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tracker = Package.tracker.Tracker;
	var Base64 = Package.base64.Base64;
	var HTTP = Package.http.HTTP;
	var Meteor = Package.meteor.Meteor;
	var GroupBillViewPage = (_dec = (0, _ReactiveMixin.Reactive)({
	  subscriptions: ["group-bills"]
	}), (0, _reactRouter.withRouter)(_class = _dec(_class = function (_React$Component) {
	  (0, _inherits3.default)(GroupBillViewPage, _React$Component);
	
	  function GroupBillViewPage(props) {
	    (0, _classCallCheck3.default)(this, GroupBillViewPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (GroupBillViewPage.__proto__ || (0, _getPrototypeOf2.default)(GroupBillViewPage)).call(this, props));
	
	    console.log('props', _groupBills.GroupBills.find({ _id: _this.props.params.id }).fetch());
	
	    props.ready.then(function () {
	      Tracker.autorun(function () {
	        _this.setState({
	          'bill': _groupBills.GroupBills.find({ _id: _this.props.params.id }).fetch()[0],
	          'payments': _groupBillsPayments.GroupBillsPayments.find({ bill: _this.props.params.id }).fetch()
	        });
	      });
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(GroupBillViewPage, [{
	    key: 'addPayment',
	    value: function addPayment() {
	
	      var payment = {
	        'type': _reactDom2.default.findDOMNode(this.refs.type).value.trim(),
	        'montant': _reactDom2.default.findDOMNode(this.refs.montant).value.trim(),
	        'informations': _reactDom2.default.findDOMNode(this.refs.informations).value.trim(),
	        'bill': this.state.bill._id
	      };
	
	      Meteor.call('groupbills.payments.insert', payment, function (err, _id) {
	        if (err) {
	          Messenger().post({
	            message: "Erreur, " + err,
	            type: "error"
	          });
	          return;
	        }
	
	        Messenger().post({
	          message: "Le paiement a été enregistré.",
	          type: "success"
	        });
	      });
	    }
	  }, {
	    key: 'removePayment',
	    value: function removePayment(event) {
	
	      if (confirm('Êtes-vous sûr de vouloir supprimer ce paiement ?')) {
	
	        var that = this;
	        Meteor.call('groupbills.payments.remove', event.target.value, function (err, _id) {
	          if (err) {
	            Messenger().post({
	              message: "Erreur..." + err,
	              type: "error"
	            });
	            return;
	          }
	
	          Messenger().post({
	            message: "Le paiement a été supprimé.",
	            type: "success"
	          });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (!this.props.isReady && !this.state.bill) {
	        return _react2.default.createElement(_rubix.Progress, { active: true, value: 100 });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _rubix.BPanel,
	          { header: 'R\xE9servations associ\xE9es' },
	          _react2.default.createElement(
	            _rubix.Table,
	            { striped: true, bordered: true, condensed: true, hover: true, responsive: true, className: 'text-center' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Billet'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Nom/Pr\xE9nom'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Date'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Montant'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              this.state.bill.getReservations().map(function (reservation) {
	                return _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    reservation.id_billet
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    reservation.searchName
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      _reactMoment2.default,
	                      { format: 'DD/MM/YYYY \xE0 kk:mm' },
	                      reservation.createdAt
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    reservation.getPrice(),
	                    '\u20AC'
	                  )
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _rubix.BPanel,
	          { header: 'Etat de la facturation' },
	          _react2.default.createElement(
	            _rubix.Table,
	            { striped: true, bordered: true, responsive: true },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  this.state.bill.getSolde() > 0 && _react2.default.createElement(
	                    _rubix.Button,
	                    { block: true, bsStyle: 'danger' },
	                    this.state.bill.getSolde(),
	                    ' \u20AC restant'
	                  ),
	                  this.state.bill.getSolde() <= 0 && _react2.default.createElement(
	                    _rubix.Button,
	                    { block: true, bsStyle: 'success' },
	                    this.state.bill.getSolde(),
	                    ' \u20AC restant'
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    FormControl,
	                    { componentClass: 'select', type: 'select', ref: 'type' },
	                    _react2.default.createElement(
	                      'option',
	                      { value: 'Especes' },
	                      'Especes'
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { value: 'CB internet' },
	                      'CB internet'
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { value: 'CB' },
	                      'CB'
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { value: 'Ch\xE8que' },
	                      'Ch\xE8que'
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { value: 'Virement' },
	                      'Virement'
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { value: 'Autre' },
	                      'Autre'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(FormControl, { placeholder: 'Montant', type: 'text', ref: 'montant' })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(FormControl, { placeholder: 'Informations', type: 'text', ref: 'informations' })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    _rubix.Button,
	                    { bsStyle: 'primary', onClick: this.addPayment.bind(this) },
	                    'Ajouter'
	                  )
	                )
	              )
	            )
	          ),
	          this.state.payments && this.state.payments.length > 0 && _react2.default.createElement(
	            _rubix.Table,
	            { striped: true, bordered: true, responsive: true },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  'Date'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  'Type'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  'Montant'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  'Informations'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  '-'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              this.state.payments.map(function (payment) {
	                return _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      _reactMoment2.default,
	                      { format: 'DD/MM/YYYY \xE0 kk:mm' },
	                      payment.createdAt
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    payment.type
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    payment.montant,
	                    '\u20AC'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    payment.informations
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'center',
	                      null,
	                      _react2.default.createElement(
	                        _rubix.Button,
	                        { bsStyle: 'danger', onClick: _this2.removePayment.bind(_this2), value: payment._id },
	                        'X'
	                      )
	                    )
	                  )
	                );
	              })
	            )
	          ),
	          !this.state.payments && _react2.default.createElement(_rubix.Progress, { active: true, value: 100 }),
	          this.state.payments && this.state.payments.length == 0 && _react2.default.createElement(
	            Well,
	            null,
	            'Il n\'y a pas encore de paiement'
	          )
	        ),
	        _react2.default.createElement(
	          _rubix.Button,
	          { lg: true, bsStyle: 'success', block: true, id: this.state.bill._id, onClick: this.download.bind(this) },
	          'T\xE9l\xE9charger la facture'
	        )
	      );
	    }
	  }]);
	  return GroupBillViewPage;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = GroupBillViewPage;
	
	
	GroupBillViewPage.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};

/***/ },

/***/ "./src/universal/components/exports/Exports.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reservations2 = __webpack_require__("./src/universal/collections/statistics/reservations.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _Panel = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Panel.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	
	var Papa = __webpack_require__("./node_modules/papaparse/papaparse.js");
	var FileSaver = __webpack_require__("./node_modules/file-saver/FileSaver.js");
	var utf8 = __webpack_require__("./node_modules/utf8/utf8.js");
	
	var ExportsPage = (_dec = (0, _ReactiveMixin.Reactive)({
		subscriptions: ['users']
	}), _dec(_class = function (_React$Component) {
		(0, _inherits3.default)(ExportsPage, _React$Component);
	
		function ExportsPage(props) {
			(0, _classCallCheck3.default)(this, ExportsPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (ExportsPage.__proto__ || (0, _getPrototypeOf2.default)(ExportsPage)).call(this, props));
	
			_this.state = {
				'nbYears': (0, _moment2.default)().diff((0, _moment2.default)().year(2016), 'years') + 1,
				'selectedYear': '2016'
			};
	
			return _this;
		}
	
		(0, _createClass3.default)(ExportsPage, [{
			key: 'selectYear',
			value: function selectYear(ref) {
				var year = ref.target.value;
				this.setState({
					'selectedYear': year
				});
			}
		}, {
			key: 'downloadFile',
			value: function downloadFile(file, name) {
	
				var csvData = new Blob(['\uFEFF' + file], {
					type: 'text/csv; charset=utf-18'
				});
				var csvURL = window.URL.createObjectURL(csvData);
				var tempLink = document.createElement('a');
				tempLink.href = csvURL;
				tempLink.setAttribute('download', name + '.csv');
				tempLink.click();
			}
		}, {
			key: 'exportAll',
			value: function exportAll() {
				var _this2 = this;
	
				this.setState({ 'pendingAll': true });
				_reservations2.reservationsExport.call({ 'selectedYear': this.state.selectedYear
				}, function (err, results) {
					_this2.setState({ 'pendingAll': false });
					var file = Papa.unparse(results, { delimiter: ";" });
					_this2.downloadFile(file, 'reservations.csv');
				}.bind(this));
			}
		}, {
			key: 'exportCancelAll',
			value: function exportCancelAll() {
				var _this3 = this;
	
				this.setState({ 'pendingCancelAll': true });
				_reservations2.reservationsCancelExport.call({ 'selectedYear': this.state.selectedYear
				}, function (err, results) {
					_this3.setState({ 'pendingCancelAll': false });
					var file = Papa.unparse(results, { delimiter: ";" });
					_this3.downloadFile(file, 'reservations-annulee.csv');
				}.bind(this));
			}
		}, {
			key: 'createOptions',
			value: function createOptions() {
				var options = [];
	
				// Outer loop to create parent
				for (var i = 0; i <= this.state.nbYears; i++) {
	
					//Create the parent and add the children
					options.push(_react2.default.createElement(
						'option',
						{ value: 2016 + i },
						2016 + i
					));
				}
				return options;
			}
		}, {
			key: 'getPartners',
			value: function getPartners() {
				var partners = [];
	
				Meteor.users.find({ roles: { $in: ['partner'] } }).map(function (partner) {
					partners.push(_react2.default.createElement(
						'option',
						{ value: partner._id },
						partner.profile.firstName,
						' ',
						partner.profile.lastName
					));
				});
	
				return partners;
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_rubix.PanelContainer,
						null,
						_react2.default.createElement(
							_rubix.Panel,
							null,
							_react2.default.createElement(
								_Panel.PanelHeader,
								{ className: 'bg-blue' },
								_react2.default.createElement(
									_rubix.Grid,
									null,
									_react2.default.createElement(
										_rubix.Row,
										null,
										_react2.default.createElement(
											_rubix.Col,
											{ xs: 12, className: 'fg-white' },
											_react2.default.createElement(
												'h3',
												null,
												'R\xE9servations'
											)
										)
									)
								)
							),
							_react2.default.createElement(
								_rubix.PanelBody,
								{ style: { padding: 20, paddingBottom: 25 } },
								'Ann\xE9e s\xE9l\xE9ctionn\xE9e :',
								_react2.default.createElement(
									_rubix.FormControl,
									{ componentClass: 'select', placeholder: 'select', ref: 'year', onChange: this.selectYear.bind(this) },
									this.createOptions()
								),
								_react2.default.createElement('hr', null),
								!this.state.pendingAll && _react2.default.createElement(
									_rubix.Button,
									{ bsStyle: 'primary', onClick: this.exportAll.bind(this) },
									'R\xE9servations'
								),
								this.state.pendingAll && _react2.default.createElement(
									_rubix.Button,
									{ bsStyle: 'disabled' },
									'En cours...'
								),
								_react2.default.createElement('br', null),
								_react2.default.createElement(
									'small',
									null,
									'Retourne un fichier csv contenant les r\xE9servations'
								),
								_react2.default.createElement('hr', null),
								!this.state.pendingCancelAll && _react2.default.createElement(
									_rubix.Button,
									{ bsStyle: 'primary', onClick: this.exportCancelAll.bind(this) },
									'R\xE9servations annul\xE9e'
								),
								this.state.pendingCancelAll && _react2.default.createElement(
									_rubix.Button,
									{ bsStyle: 'disabled' },
									'En cours...'
								),
								_react2.default.createElement('br', null),
								_react2.default.createElement(
									'small',
									null,
									'Retourne un fichier csv contenant les r\xE9servations annul\xE9e'
								),
								_react2.default.createElement('hr', null)
							)
						)
					)
				);
			}
		}]);
		return ExportsPage;
	}(_react2.default.Component)) || _class);
	exports.default = ExportsPage;

/***/ },

/***/ "./node_modules/papaparse/papaparse.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Papa Parse
		v4.3.7
		https://github.com/mholt/PapaParse
		License: MIT
	*/
	(function(root, factory)
	{
		if (true)
		{
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else if (typeof module === 'object' && typeof exports !== 'undefined')
		{
			// Node. Does not work with strict CommonJS, but
			// only CommonJS-like environments that support module.exports,
			// like Node.
			module.exports = factory();
		}
		else
		{
			// Browser globals (root is window)
			root.Papa = factory();
		}
	}(this, function()
	{
		'use strict';
	
		var global = (function () {
			// alternative method, similar to `Function('return this')()`
			// but without using `eval` (which is disabled when
			// using Content Security Policy).
	
			if (typeof self !== 'undefined') { return self; }
			if (typeof window !== 'undefined') { return window; }
			if (typeof global !== 'undefined') { return global; }
	
			// When running tests none of the above have been defined
			return {};
		})();
	
	
		var IS_WORKER = !global.document && !!global.postMessage,
			IS_PAPA_WORKER = IS_WORKER && /(\?|&)papaworker(=|&|$)/.test(global.location.search),
			LOADED_SYNC = false, AUTO_SCRIPT_PATH;
		var workers = {}, workerIdCounter = 0;
	
		var Papa = {};
	
		Papa.parse = CsvToJson;
		Papa.unparse = JsonToCsv;
	
		Papa.RECORD_SEP = String.fromCharCode(30);
		Papa.UNIT_SEP = String.fromCharCode(31);
		Papa.BYTE_ORDER_MARK = '\ufeff';
		Papa.BAD_DELIMITERS = ['\r', '\n', '"', Papa.BYTE_ORDER_MARK];
		Papa.WORKERS_SUPPORTED = !IS_WORKER && !!global.Worker;
		Papa.SCRIPT_PATH = null;	// Must be set by your code if you use workers and this lib is loaded asynchronously
	
		// Configurable chunk sizes for local and remote files, respectively
		Papa.LocalChunkSize = 1024 * 1024 * 10;	// 10 MB
		Papa.RemoteChunkSize = 1024 * 1024 * 5;	// 5 MB
		Papa.DefaultDelimiter = ',';			// Used if not specified and detection fails
	
		// Exposed for testing and development only
		Papa.Parser = Parser;
		Papa.ParserHandle = ParserHandle;
		Papa.NetworkStreamer = NetworkStreamer;
		Papa.FileStreamer = FileStreamer;
		Papa.StringStreamer = StringStreamer;
		Papa.ReadableStreamStreamer = ReadableStreamStreamer;
	
		if (global.jQuery)
		{
			var $ = global.jQuery;
			$.fn.parse = function(options)
			{
				var config = options.config || {};
				var queue = [];
	
				this.each(function(idx)
				{
					var supported = $(this).prop('tagName').toUpperCase() === 'INPUT'
									&& $(this).attr('type').toLowerCase() === 'file'
									&& global.FileReader;
	
					if (!supported || !this.files || this.files.length === 0)
						return true;	// continue to next input element
	
					for (var i = 0; i < this.files.length; i++)
					{
						queue.push({
							file: this.files[i],
							inputElem: this,
							instanceConfig: $.extend({}, config)
						});
					}
				});
	
				parseNextFile();	// begin parsing
				return this;		// maintains chainability
	
	
				function parseNextFile()
				{
					if (queue.length === 0)
					{
						if (isFunction(options.complete))
							options.complete();
						return;
					}
	
					var f = queue[0];
	
					if (isFunction(options.before))
					{
						var returned = options.before(f.file, f.inputElem);
	
						if (typeof returned === 'object')
						{
							if (returned.action === 'abort')
							{
								error('AbortError', f.file, f.inputElem, returned.reason);
								return;	// Aborts all queued files immediately
							}
							else if (returned.action === 'skip')
							{
								fileComplete();	// parse the next file in the queue, if any
								return;
							}
							else if (typeof returned.config === 'object')
								f.instanceConfig = $.extend(f.instanceConfig, returned.config);
						}
						else if (returned === 'skip')
						{
							fileComplete();	// parse the next file in the queue, if any
							return;
						}
					}
	
					// Wrap up the user's complete callback, if any, so that ours also gets executed
					var userCompleteFunc = f.instanceConfig.complete;
					f.instanceConfig.complete = function(results)
					{
						if (isFunction(userCompleteFunc))
							userCompleteFunc(results, f.file, f.inputElem);
						fileComplete();
					};
	
					Papa.parse(f.file, f.instanceConfig);
				}
	
				function error(name, file, elem, reason)
				{
					if (isFunction(options.error))
						options.error({name: name}, file, elem, reason);
				}
	
				function fileComplete()
				{
					queue.splice(0, 1);
					parseNextFile();
				}
			}
		}
	
	
		if (IS_PAPA_WORKER)
		{
			global.onmessage = workerThreadReceivedMessage;
		}
		else if (Papa.WORKERS_SUPPORTED)
		{
			AUTO_SCRIPT_PATH = getScriptPath();
	
			// Check if the script was loaded synchronously
			if (!document.body)
			{
				// Body doesn't exist yet, must be synchronous
				LOADED_SYNC = true;
			}
			else
			{
				document.addEventListener('DOMContentLoaded', function () {
					LOADED_SYNC = true;
				}, true);
			}
		}
	
	
	
	
		function CsvToJson(_input, _config)
		{
			_config = _config || {};
			var dynamicTyping = _config.dynamicTyping || false;
			if (isFunction(dynamicTyping)) {
				_config.dynamicTypingFunction = dynamicTyping;
				// Will be filled on first row call
				dynamicTyping = {};
			}
			_config.dynamicTyping = dynamicTyping;
	
			if (_config.worker && Papa.WORKERS_SUPPORTED)
			{
				var w = newWorker();
	
				w.userStep = _config.step;
				w.userChunk = _config.chunk;
				w.userComplete = _config.complete;
				w.userError = _config.error;
	
				_config.step = isFunction(_config.step);
				_config.chunk = isFunction(_config.chunk);
				_config.complete = isFunction(_config.complete);
				_config.error = isFunction(_config.error);
				delete _config.worker;	// prevent infinite loop
	
				w.postMessage({
					input: _input,
					config: _config,
					workerId: w.id
				});
	
				return;
			}
	
			var streamer = null;
			if (typeof _input === 'string')
			{
				if (_config.download)
					streamer = new NetworkStreamer(_config);
				else
					streamer = new StringStreamer(_config);
			}
			else if (_input.readable === true && isFunction(_input.read) && isFunction(_input.on))
			{
				streamer = new ReadableStreamStreamer(_config);
			}
			else if ((global.File && _input instanceof File) || _input instanceof Object)	// ...Safari. (see issue #106)
				streamer = new FileStreamer(_config);
	
			return streamer.stream(_input);
		}
	
	
	
	
	
	
		function JsonToCsv(_input, _config)
		{
			var _output = '';
			var _fields = [];
	
			// Default configuration
	
			/** whether to surround every datum with quotes */
			var _quotes = false;
	
			/** whether to write headers */
			var _writeHeader = true;
	
			/** delimiting character */
			var _delimiter = ',';
	
			/** newline character(s) */
			var _newline = '\r\n';
	
			/** quote character */
			var _quoteChar = '"';
	
			unpackConfig();
	
			var quoteCharRegex = new RegExp(_quoteChar, 'g');
	
			if (typeof _input === 'string')
				_input = JSON.parse(_input);
	
			if (_input instanceof Array)
			{
				if (!_input.length || _input[0] instanceof Array)
					return serialize(null, _input);
				else if (typeof _input[0] === 'object')
					return serialize(objectKeys(_input[0]), _input);
			}
			else if (typeof _input === 'object')
			{
				if (typeof _input.data === 'string')
					_input.data = JSON.parse(_input.data);
	
				if (_input.data instanceof Array)
				{
					if (!_input.fields)
						_input.fields =  _input.meta && _input.meta.fields;
	
					if (!_input.fields)
						_input.fields =  _input.data[0] instanceof Array
										? _input.fields
										: objectKeys(_input.data[0]);
	
					if (!(_input.data[0] instanceof Array) && typeof _input.data[0] !== 'object')
						_input.data = [_input.data];	// handles input like [1,2,3] or ['asdf']
				}
	
				return serialize(_input.fields || [], _input.data || []);
			}
	
			// Default (any valid paths should return before this)
			throw 'exception: Unable to serialize unrecognized input';
	
	
			function unpackConfig()
			{
				if (typeof _config !== 'object')
					return;
	
				if (typeof _config.delimiter === 'string'
					&& _config.delimiter.length === 1
					&& Papa.BAD_DELIMITERS.indexOf(_config.delimiter) === -1)
				{
					_delimiter = _config.delimiter;
				}
	
				if (typeof _config.quotes === 'boolean'
					|| _config.quotes instanceof Array)
					_quotes = _config.quotes;
	
				if (typeof _config.newline === 'string')
					_newline = _config.newline;
	
				if (typeof _config.quoteChar === 'string')
					_quoteChar = _config.quoteChar;
	
				if (typeof _config.header === 'boolean')
					_writeHeader = _config.header;
			}
	
	
			/** Turns an object's keys into an array */
			function objectKeys(obj)
			{
				if (typeof obj !== 'object')
					return [];
				var keys = [];
				for (var key in obj)
					keys.push(key);
				return keys;
			}
	
			/** The double for loop that iterates the data and writes out a CSV string including header row */
			function serialize(fields, data)
			{
				var csv = '';
	
				if (typeof fields === 'string')
					fields = JSON.parse(fields);
				if (typeof data === 'string')
					data = JSON.parse(data);
	
				var hasHeader = fields instanceof Array && fields.length > 0;
				var dataKeyedByField = !(data[0] instanceof Array);
	
				// If there a header row, write it first
				if (hasHeader && _writeHeader)
				{
					for (var i = 0; i < fields.length; i++)
					{
						if (i > 0)
							csv += _delimiter;
						csv += safe(fields[i], i);
					}
					if (data.length > 0)
						csv += _newline;
				}
	
				// Then write out the data
				for (var row = 0; row < data.length; row++)
				{
					var maxCol = hasHeader ? fields.length : data[row].length;
	
					for (var col = 0; col < maxCol; col++)
					{
						if (col > 0)
							csv += _delimiter;
						var colIdx = hasHeader && dataKeyedByField ? fields[col] : col;
						csv += safe(data[row][colIdx], col);
					}
	
					if (row < data.length - 1)
						csv += _newline;
				}
	
				return csv;
			}
	
			/** Encloses a value around quotes if needed (makes a value safe for CSV insertion) */
			function safe(str, col)
			{
				if (typeof str === 'undefined' || str === null)
					return '';
	
				str = str.toString().replace(quoteCharRegex, _quoteChar+_quoteChar);
	
				var needsQuotes = (typeof _quotes === 'boolean' && _quotes)
								|| (_quotes instanceof Array && _quotes[col])
								|| hasAny(str, Papa.BAD_DELIMITERS)
								|| str.indexOf(_delimiter) > -1
								|| str.charAt(0) === ' '
								|| str.charAt(str.length - 1) === ' ';
	
				return needsQuotes ? _quoteChar + str + _quoteChar : str;
			}
	
			function hasAny(str, substrings)
			{
				for (var i = 0; i < substrings.length; i++)
					if (str.indexOf(substrings[i]) > -1)
						return true;
				return false;
			}
		}
	
		/** ChunkStreamer is the base prototype for various streamer implementations. */
		function ChunkStreamer(config)
		{
			this._handle = null;
			this._paused = false;
			this._finished = false;
			this._input = null;
			this._baseIndex = 0;
			this._partialLine = '';
			this._rowCount = 0;
			this._start = 0;
			this._nextChunk = null;
			this.isFirstChunk = true;
			this._completeResults = {
				data: [],
				errors: [],
				meta: {}
			};
			replaceConfig.call(this, config);
	
			this.parseChunk = function(chunk)
			{
				// First chunk pre-processing
				if (this.isFirstChunk && isFunction(this._config.beforeFirstChunk))
				{
					var modifiedChunk = this._config.beforeFirstChunk(chunk);
					if (modifiedChunk !== undefined)
						chunk = modifiedChunk;
				}
				this.isFirstChunk = false;
	
				// Rejoin the line we likely just split in two by chunking the file
				var aggregate = this._partialLine + chunk;
				this._partialLine = '';
	
				var results = this._handle.parse(aggregate, this._baseIndex, !this._finished);
	
				if (this._handle.paused() || this._handle.aborted())
					return;
	
				var lastIndex = results.meta.cursor;
	
				if (!this._finished)
				{
					this._partialLine = aggregate.substring(lastIndex - this._baseIndex);
					this._baseIndex = lastIndex;
				}
	
				if (results && results.data)
					this._rowCount += results.data.length;
	
				var finishedIncludingPreview = this._finished || (this._config.preview && this._rowCount >= this._config.preview);
	
				if (IS_PAPA_WORKER)
				{
					global.postMessage({
						results: results,
						workerId: Papa.WORKER_ID,
						finished: finishedIncludingPreview
					});
				}
				else if (isFunction(this._config.chunk))
				{
					this._config.chunk(results, this._handle);
					if (this._paused)
						return;
					results = undefined;
					this._completeResults = undefined;
				}
	
				if (!this._config.step && !this._config.chunk) {
					this._completeResults.data = this._completeResults.data.concat(results.data);
					this._completeResults.errors = this._completeResults.errors.concat(results.errors);
					this._completeResults.meta = results.meta;
				}
	
				if (finishedIncludingPreview && isFunction(this._config.complete) && (!results || !results.meta.aborted))
					this._config.complete(this._completeResults, this._input);
	
				if (!finishedIncludingPreview && (!results || !results.meta.paused))
					this._nextChunk();
	
				return results;
			};
	
			this._sendError = function(error)
			{
				if (isFunction(this._config.error))
					this._config.error(error);
				else if (IS_PAPA_WORKER && this._config.error)
				{
					global.postMessage({
						workerId: Papa.WORKER_ID,
						error: error,
						finished: false
					});
				}
			};
	
			function replaceConfig(config)
			{
				// Deep-copy the config so we can edit it
				var configCopy = copy(config);
				configCopy.chunkSize = parseInt(configCopy.chunkSize);	// parseInt VERY important so we don't concatenate strings!
				if (!config.step && !config.chunk)
					configCopy.chunkSize = null;  // disable Range header if not streaming; bad values break IIS - see issue #196
				this._handle = new ParserHandle(configCopy);
				this._handle.streamer = this;
				this._config = configCopy;	// persist the copy to the caller
			}
		}
	
	
		function NetworkStreamer(config)
		{
			config = config || {};
			if (!config.chunkSize)
				config.chunkSize = Papa.RemoteChunkSize;
			ChunkStreamer.call(this, config);
	
			var xhr;
	
			if (IS_WORKER)
			{
				this._nextChunk = function()
				{
					this._readChunk();
					this._chunkLoaded();
				};
			}
			else
			{
				this._nextChunk = function()
				{
					this._readChunk();
				};
			}
	
			this.stream = function(url)
			{
				this._input = url;
				this._nextChunk();	// Starts streaming
			};
	
			this._readChunk = function()
			{
				if (this._finished)
				{
					this._chunkLoaded();
					return;
				}
	
				xhr = new XMLHttpRequest();
	
				if (this._config.withCredentials)
				{
					xhr.withCredentials = this._config.withCredentials;
				}
	
				if (!IS_WORKER)
				{
					xhr.onload = bindFunction(this._chunkLoaded, this);
					xhr.onerror = bindFunction(this._chunkError, this);
				}
	
				xhr.open('GET', this._input, !IS_WORKER);
				// Headers can only be set when once the request state is OPENED
				if (this._config.downloadRequestHeaders)
				{
					var headers = this._config.downloadRequestHeaders;
	
					for (var headerName in headers)
					{
						xhr.setRequestHeader(headerName, headers[headerName]);
					}
				}
	
				if (this._config.chunkSize)
				{
					var end = this._start + this._config.chunkSize - 1;	// minus one because byte range is inclusive
					xhr.setRequestHeader('Range', 'bytes='+this._start+'-'+end);
					xhr.setRequestHeader('If-None-Match', 'webkit-no-cache'); // https://bugs.webkit.org/show_bug.cgi?id=82672
				}
	
				try {
					xhr.send();
				}
				catch (err) {
					this._chunkError(err.message);
				}
	
				if (IS_WORKER && xhr.status === 0)
					this._chunkError();
				else
					this._start += this._config.chunkSize;
			}
	
			this._chunkLoaded = function()
			{
				if (xhr.readyState != 4)
					return;
	
				if (xhr.status < 200 || xhr.status >= 400)
				{
					this._chunkError();
					return;
				}
	
				this._finished = !this._config.chunkSize || this._start > getFileSize(xhr);
				this.parseChunk(xhr.responseText);
			}
	
			this._chunkError = function(errorMessage)
			{
				var errorText = xhr.statusText || errorMessage;
				this._sendError(errorText);
			}
	
			function getFileSize(xhr)
			{
				var contentRange = xhr.getResponseHeader('Content-Range');
				if (contentRange === null) { // no content range, then finish!
						return -1;
						}
				return parseInt(contentRange.substr(contentRange.lastIndexOf('/') + 1));
			}
		}
		NetworkStreamer.prototype = Object.create(ChunkStreamer.prototype);
		NetworkStreamer.prototype.constructor = NetworkStreamer;
	
	
		function FileStreamer(config)
		{
			config = config || {};
			if (!config.chunkSize)
				config.chunkSize = Papa.LocalChunkSize;
			ChunkStreamer.call(this, config);
	
			var reader, slice;
	
			// FileReader is better than FileReaderSync (even in worker) - see http://stackoverflow.com/q/24708649/1048862
			// But Firefox is a pill, too - see issue #76: https://github.com/mholt/PapaParse/issues/76
			var usingAsyncReader = typeof FileReader !== 'undefined';	// Safari doesn't consider it a function - see issue #105
	
			this.stream = function(file)
			{
				this._input = file;
				slice = file.slice || file.webkitSlice || file.mozSlice;
	
				if (usingAsyncReader)
				{
					reader = new FileReader();		// Preferred method of reading files, even in workers
					reader.onload = bindFunction(this._chunkLoaded, this);
					reader.onerror = bindFunction(this._chunkError, this);
				}
				else
					reader = new FileReaderSync();	// Hack for running in a web worker in Firefox
	
				this._nextChunk();	// Starts streaming
			};
	
			this._nextChunk = function()
			{
				if (!this._finished && (!this._config.preview || this._rowCount < this._config.preview))
					this._readChunk();
			}
	
			this._readChunk = function()
			{
				var input = this._input;
				if (this._config.chunkSize)
				{
					var end = Math.min(this._start + this._config.chunkSize, this._input.size);
					input = slice.call(input, this._start, end);
				}
				var txt = reader.readAsText(input, this._config.encoding);
				if (!usingAsyncReader)
					this._chunkLoaded({ target: { result: txt } });	// mimic the async signature
			}
	
			this._chunkLoaded = function(event)
			{
				// Very important to increment start each time before handling results
				this._start += this._config.chunkSize;
				this._finished = !this._config.chunkSize || this._start >= this._input.size;
				this.parseChunk(event.target.result);
			}
	
			this._chunkError = function()
			{
				this._sendError(reader.error.message);
			}
	
		}
		FileStreamer.prototype = Object.create(ChunkStreamer.prototype);
		FileStreamer.prototype.constructor = FileStreamer;
	
	
		function StringStreamer(config)
		{
			config = config || {};
			ChunkStreamer.call(this, config);
	
			var string;
			var remaining;
			this.stream = function(s)
			{
				string = s;
				remaining = s;
				return this._nextChunk();
			}
			this._nextChunk = function()
			{
				if (this._finished) return;
				var size = this._config.chunkSize;
				var chunk = size ? remaining.substr(0, size) : remaining;
				remaining = size ? remaining.substr(size) : '';
				this._finished = !remaining;
				return this.parseChunk(chunk);
			}
		}
		StringStreamer.prototype = Object.create(StringStreamer.prototype);
		StringStreamer.prototype.constructor = StringStreamer;
	
	
		function ReadableStreamStreamer(config)
		{
			config = config || {};
	
			ChunkStreamer.call(this, config);
	
			var queue = [];
			var parseOnData = true;
	
			this.stream = function(stream)
			{
				this._input = stream;
	
				this._input.on('data', this._streamData);
				this._input.on('end', this._streamEnd);
				this._input.on('error', this._streamError);
			}
	
			this._nextChunk = function()
			{
				if (queue.length)
				{
					this.parseChunk(queue.shift());
				}
				else
				{
					parseOnData = true;
				}
			}
	
			this._streamData = bindFunction(function(chunk)
			{
				try
				{
					queue.push(typeof chunk === 'string' ? chunk : chunk.toString(this._config.encoding));
	
					if (parseOnData)
					{
						parseOnData = false;
						this.parseChunk(queue.shift());
					}
				}
				catch (error)
				{
					this._streamError(error);
				}
			}, this);
	
			this._streamError = bindFunction(function(error)
			{
				this._streamCleanUp();
				this._sendError(error.message);
			}, this);
	
			this._streamEnd = bindFunction(function()
			{
				this._streamCleanUp();
				this._finished = true;
				this._streamData('');
			}, this);
	
			this._streamCleanUp = bindFunction(function()
			{
				this._input.removeListener('data', this._streamData);
				this._input.removeListener('end', this._streamEnd);
				this._input.removeListener('error', this._streamError);
			}, this);
		}
		ReadableStreamStreamer.prototype = Object.create(ChunkStreamer.prototype);
		ReadableStreamStreamer.prototype.constructor = ReadableStreamStreamer;
	
	
		// Use one ParserHandle per entire CSV file or string
		function ParserHandle(_config)
		{
			// One goal is to minimize the use of regular expressions...
			var FLOAT = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i;
	
			var self = this;
			var _stepCounter = 0;	// Number of times step was called (number of rows parsed)
			var _input;				// The input being parsed
			var _parser;			// The core parser being used
			var _paused = false;	// Whether we are paused or not
			var _aborted = false;	// Whether the parser has aborted or not
			var _delimiterError;	// Temporary state between delimiter detection and processing results
			var _fields = [];		// Fields are from the header row of the input, if there is one
			var _results = {		// The last results returned from the parser
				data: [],
				errors: [],
				meta: {}
			};
	
			if (isFunction(_config.step))
			{
				var userStep = _config.step;
				_config.step = function(results)
				{
					_results = results;
	
					if (needsHeaderRow())
						processResults();
					else	// only call user's step function after header row
					{
						processResults();
	
						// It's possbile that this line was empty and there's no row here after all
						if (_results.data.length === 0)
							return;
	
						_stepCounter += results.data.length;
						if (_config.preview && _stepCounter > _config.preview)
							_parser.abort();
						else
							userStep(_results, self);
					}
				};
			}
	
			/**
			 * Parses input. Most users won't need, and shouldn't mess with, the baseIndex
			 * and ignoreLastRow parameters. They are used by streamers (wrapper functions)
			 * when an input comes in multiple chunks, like from a file.
			 */
			this.parse = function(input, baseIndex, ignoreLastRow)
			{
				if (!_config.newline)
					_config.newline = guessLineEndings(input);
	
				_delimiterError = false;
				if (!_config.delimiter)
				{
					var delimGuess = guessDelimiter(input, _config.newline, _config.skipEmptyLines);
					if (delimGuess.successful)
						_config.delimiter = delimGuess.bestDelimiter;
					else
					{
						_delimiterError = true;	// add error after parsing (otherwise it would be overwritten)
						_config.delimiter = Papa.DefaultDelimiter;
					}
					_results.meta.delimiter = _config.delimiter;
				}
				else if(isFunction(_config.delimiter))
				{
					_config.delimiter = _config.delimiter(input);
					_results.meta.delimiter = _config.delimiter;
				}
	
				var parserConfig = copy(_config);
				if (_config.preview && _config.header)
					parserConfig.preview++;	// to compensate for header row
	
				_input = input;
				_parser = new Parser(parserConfig);
				_results = _parser.parse(_input, baseIndex, ignoreLastRow);
				processResults();
				return _paused ? { meta: { paused: true } } : (_results || { meta: { paused: false } });
			};
	
			this.paused = function()
			{
				return _paused;
			};
	
			this.pause = function()
			{
				_paused = true;
				_parser.abort();
				_input = _input.substr(_parser.getCharIndex());
			};
	
			this.resume = function()
			{
				_paused = false;
				self.streamer.parseChunk(_input);
			};
	
			this.aborted = function ()
			{
				return _aborted;
			};
	
			this.abort = function()
			{
				_aborted = true;
				_parser.abort();
				_results.meta.aborted = true;
				if (isFunction(_config.complete))
					_config.complete(_results);
				_input = '';
			};
	
			function processResults()
			{
				if (_results && _delimiterError)
				{
					addError('Delimiter', 'UndetectableDelimiter', 'Unable to auto-detect delimiting character; defaulted to \''+Papa.DefaultDelimiter+'\'');
					_delimiterError = false;
				}
	
				if (_config.skipEmptyLines)
				{
					for (var i = 0; i < _results.data.length; i++)
						if (_results.data[i].length === 1 && _results.data[i][0] === '')
							_results.data.splice(i--, 1);
				}
	
				if (needsHeaderRow())
					fillHeaderFields();
	
				return applyHeaderAndDynamicTyping();
			}
	
			function needsHeaderRow()
			{
				return _config.header && _fields.length === 0;
			}
	
			function fillHeaderFields()
			{
				if (!_results)
					return;
				for (var i = 0; needsHeaderRow() && i < _results.data.length; i++)
					for (var j = 0; j < _results.data[i].length; j++)
						_fields.push(_results.data[i][j]);
				_results.data.splice(0, 1);
			}
	
			function shouldApplyDynamicTyping(field) {
				// Cache function values to avoid calling it for each row
				if (_config.dynamicTypingFunction && _config.dynamicTyping[field] === undefined) {
					_config.dynamicTyping[field] = _config.dynamicTypingFunction(field);
				}
				return (_config.dynamicTyping[field] || _config.dynamicTyping) === true
			}
	
			function parseDynamic(field, value)
			{
				if (shouldApplyDynamicTyping(field))
				{
					if (value === 'true' || value === 'TRUE')
						return true;
					else if (value === 'false' || value === 'FALSE')
						return false;
					else
						return tryParseFloat(value);
				}
				return value;
			}
	
			function applyHeaderAndDynamicTyping()
			{
				if (!_results || (!_config.header && !_config.dynamicTyping))
					return _results;
	
				for (var i = 0; i < _results.data.length; i++)
				{
					var row = _config.header ? {} : [];
	
					for (var j = 0; j < _results.data[i].length; j++)
					{
						var field = j;
						var value = _results.data[i][j];
	
						if (_config.header)
							field = j >= _fields.length ? '__parsed_extra' : _fields[j];
	
						value = parseDynamic(field, value);
	
						if (field === '__parsed_extra')
						{
							row[field] = row[field] || [];
							row[field].push(value);
						}
						else
							row[field] = value;
					}
	
					_results.data[i] = row;
	
					if (_config.header)
					{
						if (j > _fields.length)
							addError('FieldMismatch', 'TooManyFields', 'Too many fields: expected ' + _fields.length + ' fields but parsed ' + j, i);
						else if (j < _fields.length)
							addError('FieldMismatch', 'TooFewFields', 'Too few fields: expected ' + _fields.length + ' fields but parsed ' + j, i);
					}
				}
	
				if (_config.header && _results.meta)
					_results.meta.fields = _fields;
				return _results;
			}
	
			function guessDelimiter(input, newline, skipEmptyLines)
			{
				var delimChoices = [',', '\t', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP];
				var bestDelim, bestDelta, fieldCountPrevRow;
	
				for (var i = 0; i < delimChoices.length; i++)
				{
					var delim = delimChoices[i];
					var delta = 0, avgFieldCount = 0, emptyLinesCount = 0;
					fieldCountPrevRow = undefined;
	
					var preview = new Parser({
						delimiter: delim,
						newline: newline,
						preview: 10
					}).parse(input);
	
					for (var j = 0; j < preview.data.length; j++)
					{
						if (skipEmptyLines && preview.data[j].length === 1 && preview.data[j][0].length === 0) {
							emptyLinesCount++
							continue
						}
						var fieldCount = preview.data[j].length;
						avgFieldCount += fieldCount;
	
						if (typeof fieldCountPrevRow === 'undefined')
						{
							fieldCountPrevRow = fieldCount;
							continue;
						}
						else if (fieldCount > 1)
						{
							delta += Math.abs(fieldCount - fieldCountPrevRow);
							fieldCountPrevRow = fieldCount;
						}
					}
	
					if (preview.data.length > 0)
						avgFieldCount /= (preview.data.length - emptyLinesCount);
	
					if ((typeof bestDelta === 'undefined' || delta < bestDelta)
						&& avgFieldCount > 1.99)
					{
						bestDelta = delta;
						bestDelim = delim;
					}
				}
	
				_config.delimiter = bestDelim;
	
				return {
					successful: !!bestDelim,
					bestDelimiter: bestDelim
				}
			}
	
			function guessLineEndings(input)
			{
				input = input.substr(0, 1024*1024);	// max length 1 MB
	
				var r = input.split('\r');
	
				var n = input.split('\n');
	
				var nAppearsFirst = (n.length > 1 && n[0].length < r[0].length);
	
				if (r.length === 1 || nAppearsFirst)
					return '\n';
	
				var numWithN = 0;
				for (var i = 0; i < r.length; i++)
				{
					if (r[i][0] === '\n')
						numWithN++;
				}
	
				return numWithN >= r.length / 2 ? '\r\n' : '\r';
			}
	
			function tryParseFloat(val)
			{
				var isNumber = FLOAT.test(val);
				return isNumber ? parseFloat(val) : val;
			}
	
			function addError(type, code, msg, row)
			{
				_results.errors.push({
					type: type,
					code: code,
					message: msg,
					row: row
				});
			}
		}
	
	
	
	
	
		/** The core parser implements speedy and correct CSV parsing */
		function Parser(config)
		{
			// Unpack the config object
			config = config || {};
			var delim = config.delimiter;
			var newline = config.newline;
			var comments = config.comments;
			var step = config.step;
			var preview = config.preview;
			var fastMode = config.fastMode;
			/** Allows for no quoteChar by setting quoteChar to undefined in config */
			if (config.quoteChar === undefined){
				var quoteChar = '"';
			} else {
				var quoteChar = config.quoteChar;
			}
	
			// Delimiter must be valid
			if (typeof delim !== 'string'
				|| Papa.BAD_DELIMITERS.indexOf(delim) > -1)
				delim = ',';
	
			// Comment character must be valid
			if (comments === delim)
				throw 'Comment character same as delimiter';
			else if (comments === true)
				comments = '#';
			else if (typeof comments !== 'string'
				|| Papa.BAD_DELIMITERS.indexOf(comments) > -1)
				comments = false;
	
			// Newline must be valid: \r, \n, or \r\n
			if (newline != '\n' && newline != '\r' && newline != '\r\n')
				newline = '\n';
	
			// We're gonna need these at the Parser scope
			var cursor = 0;
			var aborted = false;
	
			this.parse = function(input, baseIndex, ignoreLastRow)
			{
				// For some reason, in Chrome, this speeds things up (!?)
				if (typeof input !== 'string')
					throw 'Input must be a string';
	
				// We don't need to compute some of these every time parse() is called,
				// but having them in a more local scope seems to perform better
				var inputLen = input.length,
					delimLen = delim.length,
					newlineLen = newline.length,
					commentsLen = comments.length;
				var stepIsFunction = isFunction(step);
	
				// Establish starting state
				cursor = 0;
				var data = [], errors = [], row = [], lastCursor = 0;
	
				if (!input)
					return returnable();
	
				if (fastMode || (fastMode !== false && input.indexOf(quoteChar) === -1))
				{
					var rows = input.split(newline);
					for (var i = 0; i < rows.length; i++)
					{
						var row = rows[i];
						cursor += row.length;
						if (i !== rows.length - 1)
							cursor += newline.length;
						else if (ignoreLastRow)
							return returnable();
						if (comments && row.substr(0, commentsLen) === comments)
							continue;
						if (stepIsFunction)
						{
							data = [];
							pushRow(row.split(delim));
							doStep();
							if (aborted)
								return returnable();
						}
						else
							pushRow(row.split(delim));
						if (preview && i >= preview)
						{
							data = data.slice(0, preview);
							return returnable(true);
						}
					}
					return returnable();
				}
	
				var nextDelim = input.indexOf(delim, cursor);
				var nextNewline = input.indexOf(newline, cursor);
				var quoteCharRegex = new RegExp(quoteChar+quoteChar, 'g');
	
				// Parser loop
				for (;;)
				{
					// Field has opening quote
					if (input[cursor] === quoteChar)
					{
						// Start our search for the closing quote where the cursor is
						var quoteSearch = cursor;
	
						// Skip the opening quote
						cursor++;
	
						for (;;)
						{
							// Find closing quote
							var quoteSearch = input.indexOf(quoteChar, quoteSearch+1);
	
							//No other quotes are found - no other delimiters
							if (quoteSearch === -1)
							{
								if (!ignoreLastRow) {
									// No closing quote... what a pity
									errors.push({
										type: 'Quotes',
										code: 'MissingQuotes',
										message: 'Quoted field unterminated',
										row: data.length,	// row has yet to be inserted
										index: cursor
									});
								}
								return finish();
							}
	
							// Closing quote at EOF
							if (quoteSearch === inputLen-1)
							{
								var value = input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar);
								return finish(value);
							}
	
							// If this quote is escaped, it's part of the data; skip it
							if (input[quoteSearch+1] === quoteChar)
							{
								quoteSearch++;
								continue;
							}
	
							// Closing quote followed by delimiter
							if (input[quoteSearch+1] === delim)
							{
								row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
								cursor = quoteSearch + 1 + delimLen;
								nextDelim = input.indexOf(delim, cursor);
								nextNewline = input.indexOf(newline, cursor);
								break;
							}
	
							// Closing quote followed by newline
							if (input.substr(quoteSearch+1, newlineLen) === newline)
							{
								row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
								saveRow(quoteSearch + 1 + newlineLen);
								nextDelim = input.indexOf(delim, cursor);	// because we may have skipped the nextDelim in the quoted field
	
								if (stepIsFunction)
								{
									doStep();
									if (aborted)
										return returnable();
								}
	
								if (preview && data.length >= preview)
									return returnable(true);
	
								break;
							}
	
	
							// Checks for valid closing quotes are complete (escaped quotes or quote followed by EOF/delimiter/newline) -- assume these quotes are part of an invalid text string
							errors.push({
								type: 'Quotes',
								code: 'InvalidQuotes',
								message: 'Trailing quote on quoted field is malformed',
								row: data.length,	// row has yet to be inserted
								index: cursor
							});
	
							quoteSearch++;
							continue;
	
						}
	
						continue;
					}
	
					// Comment found at start of new line
					if (comments && row.length === 0 && input.substr(cursor, commentsLen) === comments)
					{
						if (nextNewline === -1)	// Comment ends at EOF
							return returnable();
						cursor = nextNewline + newlineLen;
						nextNewline = input.indexOf(newline, cursor);
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}
	
					// Next delimiter comes before next newline, so we've reached end of field
					if (nextDelim !== -1 && (nextDelim < nextNewline || nextNewline === -1))
					{
						row.push(input.substring(cursor, nextDelim));
						cursor = nextDelim + delimLen;
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}
	
					// End of row
					if (nextNewline !== -1)
					{
						row.push(input.substring(cursor, nextNewline));
						saveRow(nextNewline + newlineLen);
	
						if (stepIsFunction)
						{
							doStep();
							if (aborted)
								return returnable();
						}
	
						if (preview && data.length >= preview)
							return returnable(true);
	
						continue;
					}
	
					break;
				}
	
	
				return finish();
	
	
				function pushRow(row)
				{
					data.push(row);
					lastCursor = cursor;
				}
	
				/**
				 * Appends the remaining input from cursor to the end into
				 * row, saves the row, calls step, and returns the results.
				 */
				function finish(value)
				{
					if (ignoreLastRow)
						return returnable();
					if (typeof value === 'undefined')
						value = input.substr(cursor);
					row.push(value);
					cursor = inputLen;	// important in case parsing is paused
					pushRow(row);
					if (stepIsFunction)
						doStep();
					return returnable();
				}
	
				/**
				 * Appends the current row to the results. It sets the cursor
				 * to newCursor and finds the nextNewline. The caller should
				 * take care to execute user's step function and check for
				 * preview and end parsing if necessary.
				 */
				function saveRow(newCursor)
				{
					cursor = newCursor;
					pushRow(row);
					row = [];
					nextNewline = input.indexOf(newline, cursor);
				}
	
				/** Returns an object with the results, errors, and meta. */
				function returnable(stopped)
				{
					return {
						data: data,
						errors: errors,
						meta: {
							delimiter: delim,
							linebreak: newline,
							aborted: aborted,
							truncated: !!stopped,
							cursor: lastCursor + (baseIndex || 0)
						}
					};
				}
	
				/** Executes the user's step function and resets data & errors. */
				function doStep()
				{
					step(returnable());
					data = [], errors = [];
				}
			};
	
			/** Sets the abort flag */
			this.abort = function()
			{
				aborted = true;
			};
	
			/** Gets the cursor position */
			this.getCharIndex = function()
			{
				return cursor;
			};
		}
	
	
		// If you need to load Papa Parse asynchronously and you also need worker threads, hard-code
		// the script path here. See: https://github.com/mholt/PapaParse/issues/87#issuecomment-57885358
		function getScriptPath()
		{
			var scripts = document.getElementsByTagName('script');
			return scripts.length ? scripts[scripts.length - 1].src : '';
		}
	
		function newWorker()
		{
			if (!Papa.WORKERS_SUPPORTED)
				return false;
			if (!LOADED_SYNC && Papa.SCRIPT_PATH === null)
				throw new Error(
					'Script path cannot be determined automatically when Papa Parse is loaded asynchronously. ' +
					'You need to set Papa.SCRIPT_PATH manually.'
				);
			var workerUrl = Papa.SCRIPT_PATH || AUTO_SCRIPT_PATH;
			// Append 'papaworker' to the search string to tell papaparse that this is our worker.
			workerUrl += (workerUrl.indexOf('?') !== -1 ? '&' : '?') + 'papaworker';
			var w = new global.Worker(workerUrl);
			w.onmessage = mainThreadReceivedMessage;
			w.id = workerIdCounter++;
			workers[w.id] = w;
			return w;
		}
	
		/** Callback when main thread receives a message */
		function mainThreadReceivedMessage(e)
		{
			var msg = e.data;
			var worker = workers[msg.workerId];
			var aborted = false;
	
			if (msg.error)
				worker.userError(msg.error, msg.file);
			else if (msg.results && msg.results.data)
			{
				var abort = function() {
					aborted = true;
					completeWorker(msg.workerId, { data: [], errors: [], meta: { aborted: true } });
				};
	
				var handle = {
					abort: abort,
					pause: notImplemented,
					resume: notImplemented
				};
	
				if (isFunction(worker.userStep))
				{
					for (var i = 0; i < msg.results.data.length; i++)
					{
						worker.userStep({
							data: [msg.results.data[i]],
							errors: msg.results.errors,
							meta: msg.results.meta
						}, handle);
						if (aborted)
							break;
					}
					delete msg.results;	// free memory ASAP
				}
				else if (isFunction(worker.userChunk))
				{
					worker.userChunk(msg.results, handle, msg.file);
					delete msg.results;
				}
			}
	
			if (msg.finished && !aborted)
				completeWorker(msg.workerId, msg.results);
		}
	
		function completeWorker(workerId, results) {
			var worker = workers[workerId];
			if (isFunction(worker.userComplete))
				worker.userComplete(results);
			worker.terminate();
			delete workers[workerId];
		}
	
		function notImplemented() {
			throw 'Not implemented.';
		}
	
		/** Callback when worker thread receives a message */
		function workerThreadReceivedMessage(e)
		{
			var msg = e.data;
	
			if (typeof Papa.WORKER_ID === 'undefined' && msg)
				Papa.WORKER_ID = msg.workerId;
	
			if (typeof msg.input === 'string')
			{
				global.postMessage({
					workerId: Papa.WORKER_ID,
					results: Papa.parse(msg.input, msg.config),
					finished: true
				});
			}
			else if ((global.File && msg.input instanceof File) || msg.input instanceof Object)	// thank you, Safari (see issue #106)
			{
				var results = Papa.parse(msg.input, msg.config);
				if (results)
					global.postMessage({
						workerId: Papa.WORKER_ID,
						results: results,
						finished: true
					});
			}
		}
	
		/** Makes a deep copy of an array or object (mostly) */
		function copy(obj)
		{
			if (typeof obj !== 'object')
				return obj;
			var cpy = obj instanceof Array ? [] : {};
			for (var key in obj)
				cpy[key] = copy(obj[key]);
			return cpy;
		}
	
		function bindFunction(f, self)
		{
			return function() { f.apply(self, arguments); };
		}
	
		function isFunction(func)
		{
			return typeof func === 'function';
		}
	
		return Papa;
	}));


/***/ },

/***/ "./node_modules/file-saver/FileSaver.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */
	
	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
	
	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;
	
				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}
	
				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";
	
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}
	
		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;
	
		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;
	
		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window
	
	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if (("function" !== "undefined" && __webpack_require__("./node_modules/webpack/buildin/amd-define.js") !== null) && (__webpack_require__("./node_modules/webpack/buildin/amd-options.js") !== null)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return saveAs;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ },

/***/ "./node_modules/webpack/buildin/amd-define.js":
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },

/***/ "./node_modules/webpack/buildin/amd-options.js":
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },

/***/ "./node_modules/utf8/utf8.js":
/***/ function(module, exports, __webpack_require__) {

	/*! https://mths.be/utf8js v3.0.0 by @mathias */
	;(function(root) {
	
		var stringFromCharCode = String.fromCharCode;
	
		// Taken from https://mths.be/punycode
		function ucs2decode(string) {
			var output = [];
			var counter = 0;
			var length = string.length;
			var value;
			var extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		// Taken from https://mths.be/punycode
		function ucs2encode(array) {
			var length = array.length;
			var index = -1;
			var value;
			var output = '';
			while (++index < length) {
				value = array[index];
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
			}
			return output;
		}
	
		function checkScalarValue(codePoint) {
			if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
				throw Error(
					'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
					' is not a scalar value'
				);
			}
		}
		/*--------------------------------------------------------------------------*/
	
		function createByte(codePoint, shift) {
			return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
		}
	
		function encodeCodePoint(codePoint) {
			if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
				return stringFromCharCode(codePoint);
			}
			var symbol = '';
			if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
				symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
			}
			else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
				checkScalarValue(codePoint);
				symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
				symbol += createByte(codePoint, 6);
			}
			else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
				symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
				symbol += createByte(codePoint, 12);
				symbol += createByte(codePoint, 6);
			}
			symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
			return symbol;
		}
	
		function utf8encode(string) {
			var codePoints = ucs2decode(string);
			var length = codePoints.length;
			var index = -1;
			var codePoint;
			var byteString = '';
			while (++index < length) {
				codePoint = codePoints[index];
				byteString += encodeCodePoint(codePoint);
			}
			return byteString;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function readContinuationByte() {
			if (byteIndex >= byteCount) {
				throw Error('Invalid byte index');
			}
	
			var continuationByte = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			if ((continuationByte & 0xC0) == 0x80) {
				return continuationByte & 0x3F;
			}
	
			// If we end up here, it’s not a continuation byte
			throw Error('Invalid continuation byte');
		}
	
		function decodeSymbol() {
			var byte1;
			var byte2;
			var byte3;
			var byte4;
			var codePoint;
	
			if (byteIndex > byteCount) {
				throw Error('Invalid byte index');
			}
	
			if (byteIndex == byteCount) {
				return false;
			}
	
			// Read first byte
			byte1 = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			// 1-byte sequence (no continuation bytes)
			if ((byte1 & 0x80) == 0) {
				return byte1;
			}
	
			// 2-byte sequence
			if ((byte1 & 0xE0) == 0xC0) {
				byte2 = readContinuationByte();
				codePoint = ((byte1 & 0x1F) << 6) | byte2;
				if (codePoint >= 0x80) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 3-byte sequence (may include unpaired surrogates)
			if ((byte1 & 0xF0) == 0xE0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
				if (codePoint >= 0x0800) {
					checkScalarValue(codePoint);
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 4-byte sequence
			if ((byte1 & 0xF8) == 0xF0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				byte4 = readContinuationByte();
				codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
					(byte3 << 0x06) | byte4;
				if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
					return codePoint;
				}
			}
	
			throw Error('Invalid UTF-8 detected');
		}
	
		var byteArray;
		var byteCount;
		var byteIndex;
		function utf8decode(byteString) {
			byteArray = ucs2decode(byteString);
			byteCount = byteArray.length;
			byteIndex = 0;
			var codePoints = [];
			var tmp;
			while ((tmp = decodeSymbol()) !== false) {
				codePoints.push(tmp);
			}
			return ucs2encode(codePoints);
		}
	
		/*--------------------------------------------------------------------------*/
	
		root.version = '3.0.0';
		root.encode = utf8encode;
		root.decode = utf8decode;
	
	}( false ? this.utf8 = {} : exports));


/***/ },

/***/ "./src/universal/components/sms/Sms.page.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reservations = __webpack_require__("./src/universal/collections/reservations/reservations.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reservations2 = __webpack_require__("./src/universal/collections/statistics/reservations.js");
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	var _ReactiveMixin = __webpack_require__("./src/universal/components/common/Reactive.mixin.js");
	
	var _Panel = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/Panel.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	
	var Papa = __webpack_require__("./node_modules/papaparse/papaparse.js");
	var FileSaver = __webpack_require__("./node_modules/file-saver/FileSaver.js");
	var utf8 = __webpack_require__("./node_modules/utf8/utf8.js");
	var Tracker = Package.tracker.Tracker;
	
	var DatePicker = __webpack_require__("./node_modules/react-bootstrap-date-picker/lib/index.js");
	
	var SMSPage = (_dec = (0, _ReactiveMixin.Reactive)({
	  subscriptions: [{ name: 'reservations', paginate: true }]
	}), _dec(_class = function (_React$Component) {
	  (0, _inherits3.default)(SMSPage, _React$Component);
	
	  function SMSPage(props) {
	    (0, _classCallCheck3.default)(this, SMSPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SMSPage.__proto__ || (0, _getPrototypeOf2.default)(SMSPage)).call(this, props));
	
	    _this.state = {};
	
	    _this.state.startDate = (0, _moment2.default)().subtract(15, 'days').toDate();
	    _this.state.selectedDate = (0, _moment2.default)().format();
	    _this.state.selectPeriod = 'Matin';
	    _this.state.passengers = [];
	    _this.state.reservations = [];
	    _this.state.selectedReservations = [];
	
	    // props.ready.then(() => {
	    // 	Tracker.autorun(() => {
	    // 		this.setState({
	    // 			'reservations' : Reservations.find({
	    //         updatedAt: {
	    //             $gte: this.state.startDate
	    //           },
	    //       }).fetch(),
	    // 		});
	
	    //     //count number of sms :
	    //     let selectedPassengers = [];
	    //     let selectedReservations = [];
	    //     this.state.reservations.forEach(reservation => {
	    //       if(reservation.history) {
	
	    //         let history = reservation.history.slice(-1).pop();
	    //         if(history) {
	    //           if(history.type == 'cancelled') {
	    //           const passengers = reservation.getPassengers();
	    //           passengers.forEach(passenger => {
	    //             if(passenger.phone) {
	    //               selectedPassengers.push(passenger);
	    //             }
	    //           });
	    //           selectedReservations.push(reservation);
	    //         }}
	
	
	    //       }
	
	    //     });
	
	    //     this.setState({'passengers': selectedPassengers});
	    //     this.setState({'selectedReservations': selectedReservations});
	
	    // 	});
	    // });
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(SMSPage, [{
	    key: 'loadCancelReservations',
	    value: function loadCancelReservations() {
	      var _this2 = this;
	
	      this.setState({ 'pendingCancelAll': true });
	      _reservations2.reservationsCancelSMS.call(function (err, results) {
	        _this2.setState({ 'pendingCancelAll': false });
	        _this2.setState({ reservations: results });
	
	        var selectedPassengers = [];
	        _this2.state.reservations.forEach(function (reservation) {
	          reservation.passengers.forEach(function (passenger) {
	            if (passenger.phone) {
	              selectedPassengers.push(passenger);
	            }
	          });
	        });
	
	        _this2.setState({ 'passengers': selectedPassengers });
	      }.bind(this));
	    }
	  }, {
	    key: 'downloadFile',
	    value: function downloadFile(file, name) {
	
	      var csvData = new Blob(['\uFEFF' + file], {
	        type: 'text/csv; charset=utf-18'
	      });
	      var csvURL = window.URL.createObjectURL(csvData);
	      var tempLink = document.createElement('a');
	      tempLink.href = csvURL;
	      tempLink.setAttribute('download', name + '.csv');
	      tempLink.click();
	    }
	  }, {
	    key: 'selectPeriod',
	    value: function selectPeriod(ref) {
	      this.setState({
	        selectPeriod: ref.target.value
	      });
	    }
	  }, {
	    key: 'sendNexmoSMS',
	    value: function sendNexmoSMS(message, phone) {
	
	      phone = phone.slice(1);;
	      phone = phone.replace(' ', '');
	      phone = phone.replace('.', '');
	      phone = '33' + phone;
	
	      console.log('phone', phone);
	
	      if (phone[2] == '6' || phone[2] == '7') {
	        Meteor.call('send.sms', {
	          'to': phone,
	          'message': message
	        });
	      }
	    }
	  }, {
	    key: 'sendSMS',
	    value: function sendSMS() {
	      var _this3 = this;
	
	      var message = 'Bonjour,\n    Un nouveau cr\xE9neau de vol est disponible le ' + (0, _moment2.default)(this.state.selectedDate).format('DD/MM/YYYY') + ' - ' + this.state.selectPeriod + '.\n    Si vous souhaitez r\xE9server ce cr\xE9neau, merci de nous appeler rapidement au 02 41 404 804.\n    ';
	
	      if (confirm('Êtes-vous sûr de vouloir envoyer ces sms ?')) {
	        this.state.passengers.forEach(function (passenger) {
	          _this3.sendNexmoSMS(message, passenger.phone, 'TEST1234');
	        });
	
	        alert('SMS envoyés !');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _rubix.PanelContainer,
	          null,
	          _react2.default.createElement(
	            _rubix.Panel,
	            null,
	            _react2.default.createElement(
	              _Panel.PanelHeader,
	              { className: 'bg-blue' },
	              _react2.default.createElement(
	                _rubix.Grid,
	                null,
	                _react2.default.createElement(
	                  _rubix.Row,
	                  null,
	                  _react2.default.createElement(
	                    _rubix.Col,
	                    { xs: 12, className: 'fg-white' },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Notifier par SMS'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Envoyer un SMS aux passagers dont la r\xE9servation a \xE9t\xE9 annul\xE9e sur les 15 derniers jours afin de les notifier qu\'une date est disponible.'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _rubix.PanelBody,
	              { style: { padding: 20 } },
	              _react2.default.createElement(
	                _rubix.Button,
	                { bsStyle: 'primary', onClick: this.loadCancelReservations.bind(this) },
	                'Charger les r\xE9servations'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              this.state.reservations && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Date propos\xE9e :'
	                ),
	                _react2.default.createElement(DatePicker, {
	                  dayLabels: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
	                  monthLabels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
	                  id: 'start_date', value: this.state.selectedDate, onChange: function onChange(value) {
	                    return _this4.setState({ selectedDate: value });
	                  } }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'P\xE9riode propos\xE9e :'
	                ),
	                _react2.default.createElement(
	                  _rubix.FormControl,
	                  { componentClass: 'select', placeholder: 'select', ref: 'year', onChange: this.selectPeriod.bind(this) },
	                  _react2.default.createElement(
	                    'option',
	                    null,
	                    'Matin'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    null,
	                    'Soir'
	                  )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  _rubix.Button,
	                  { bsStyle: 'primary', onClick: this.sendSMS.bind(this) },
	                  'Envoyer les SMS'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  'Infos :'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Nombre de r\xE9servation : ',
	                  this.state.reservations.length,
	                  ' r\xE9servations'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Nombre de SMS : ',
	                  this.state.passengers.length,
	                  ' sms'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  this.state.reservations.map(function (reservation) {
	                    return _react2.default.createElement(
	                      'span',
	                      null,
	                      reservation.id_billet,
	                      _react2.default.createElement('br', null)
	                    );
	                  })
	                )
	              ),
	              !this.state.reservations && _react2.default.createElement(
	                'div',
	                null,
	                'Chargement...'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return SMSPage;
	}(_react2.default.Component)) || _class);
	exports.default = SMSPage;

/***/ },

/***/ "./src/universal/components/layout/contact.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var ContactPage = function (_React$Component) {
		(0, _inherits3.default)(ContactPage, _React$Component);
	
		function ContactPage(props) {
			(0, _classCallCheck3.default)(this, ContactPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (ContactPage.__proto__ || (0, _getPrototypeOf2.default)(ContactPage)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(ContactPage, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_rubix.PanelContainer,
					null,
					_react2.default.createElement(
						_rubix.Panel,
						null,
						_react2.default.createElement(
							_rubix.PanelBody,
							{ style: { padding: 20, paddingBottom: 25 } },
							_react2.default.createElement(
								_rubix.Grid,
								null,
								_react2.default.createElement(
									_rubix.Row,
									null,
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 6, className: 'col-welcome' },
										_react2.default.createElement(
											'h4',
											null,
											'Vous souhaitez nous contacter ?'
										),
										_react2.default.createElement('hr', null),
										_react2.default.createElement(
											'p',
											null,
											'MONTGOLFI\xC8RES D\u2019ANJOU',
											_react2.default.createElement('br', null),
											'T\xE9l. 02 41 404 804',
											_react2.default.createElement('br', null),
											'Email: manue@montgolfieres.fr'
										)
									),
									_react2.default.createElement(
										_rubix.Col,
										{ sm: 6, className: 'col-welcome' },
										_react2.default.createElement(
											'h4',
											null,
											'Un probl\xE8me technique, une question sur le fonctionnement ?'
										),
										_react2.default.createElement('hr', null),
										_react2.default.createElement(
											'p',
											null,
											'SARL 2PULSE',
											_react2.default.createElement('br', null),
											'T\xE9l. 02 53 68 12 52 (du lundi au vendredi de 10h \xE0 18h).',
											_react2.default.createElement('br', null),
											'Email : contact@2pulse.com',
											_react2.default.createElement('br', null),
											_react2.default.createElement(
												'a',
												{ href: 'http://aerostack.fr' },
												'aerostack.fr'
											),
											' (en construction)'
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
		return ContactPage;
	}(_react2.default.Component);
	
	exports.default = ContactPage;

/***/ },

/***/ "./src/universal/components/layout/404.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rubix = __webpack_require__("./node_modules/@sketchpixy/rubix/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meteor = Package.meteor.Meteor;
	
	var NotFoundPage = function (_React$Component) {
		(0, _inherits3.default)(NotFoundPage, _React$Component);
	
		function NotFoundPage(props) {
			(0, _classCallCheck3.default)(this, NotFoundPage);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (NotFoundPage.__proto__ || (0, _getPrototypeOf2.default)(NotFoundPage)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		(0, _createClass3.default)(NotFoundPage, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_rubix.PanelContainer,
					null,
					_react2.default.createElement(
						_rubix.Panel,
						null,
						_react2.default.createElement(
							_rubix.PanelBody,
							{ style: { padding: 20, paddingBottom: 25 } },
							_react2.default.createElement(
								'h1',
								null,
								'Erreur 404 : Page inexistante.'
							)
						)
					)
				);
			}
		}]);
		return NotFoundPage;
	}(_react2.default.Component);
	
	exports.default = NotFoundPage;

/***/ },

/***/ "./src/client/userback.js":
/***/ function(module, exports) {

	'use strict';
	
	window.Userback = window.Userback || {};
	window.Userback.access_token = '660|1280|RoWgSVvNwNblWVHoZhAKGEY1FW8sEq9vP6MI1hvy4GU0BBpBS0';
	
	(function (id) {
	   if (document.getElementById(id)) {
	      return;
	   }
	   var s = document.createElement('script');
	   s.id = id;
	   s.src = 'https://static.userback.io/widget/v1.js';
	   var parent_node = document.head || document.body;
	   parent_node.appendChild(s);
	})('userback-sdk');

/***/ },

/***/ "./node_modules/messenger/build/js/messenger.min.js":
/***/ function(module, exports) {

	/*! messenger 1.5.0 */
	(function(){var e,t=window.Messenger;e=window.Messenger=function(){return e._call.apply(this,arguments)},window.Messenger.noConflict=function(){return window.Messenger=t,e}})(),window.Messenger._=function(){if(window._)return window._;var e=Array.prototype,t=Object.prototype,n=Function.prototype,s=(e.push,e.slice),r=(e.concat,t.toString);t.hasOwnProperty;var o=e.forEach,i=(e.map,e.reduce,e.reduceRight,e.filter),a=(e.every,e.some,e.indexOf,e.lastIndexOf,Array.isArray,Object.keys),l=n.bind,u={},c={},h=u.each=u.forEach=function(e,t,n){if(null!=e)if(o&&e.forEach===o)e.forEach(t,n);else if(e.length===+e.length){for(var s=0,r=e.length;r>s;s++)if(t.call(n,e[s],s,e)===c)return}else for(var i in e)if(u.has(e,i)&&t.call(n,e[i],i,e)===c)return};u.result=function(e,t){if(null==e)return null;var n=e[t];return u.isFunction(n)?n.call(e):n},u.once=function(e){var t,n=!1;return function(){return n?t:(n=!0,t=e.apply(this,arguments),e=null,t)}};var p=0;return u.uniqueId=function(e){var t=++p+"";return e?e+t:t},u.filter=u.select=function(e,t,n){var s=[];return null==e?s:i&&e.filter===i?e.filter(t,n):(h(e,function(e,r,o){t.call(n,e,r,o)&&(s[s.length]=e)}),s)},h(["Arguments","Function","String","Number","Date","RegExp"],function(e){u["is"+e]=function(t){return r.call(t)=="[object "+e+"]"}}),u.defaults=function(e){return h(s.call(arguments,1),function(t){if(t)for(var n in t)null==e[n]&&(e[n]=t[n])}),e},u.extend=function(e){return h(s.call(arguments,1),function(t){if(t)for(var n in t)e[n]=t[n]}),e},u.keys=a||function(e){if(e!==Object(e))throw new TypeError("Invalid object");var t=[];for(var n in e)u.has(e,n)&&(t[t.length]=n);return t},u.bind=function(e,t){if(e.bind===l&&l)return l.apply(e,s.call(arguments,1));var n=s.call(arguments,2);return function(){return e.apply(t,n.concat(s.call(arguments)))}},u.isObject=function(e){return e===Object(e)},u}(),window.Messenger.Events=function(){if(window.Backbone&&Backbone.Events)return Backbone.Events;var e=function(){var e=/\s+/,t=function(t,n,s,r){if(!s)return!0;if("object"==typeof s)for(var o in s)t[n].apply(t,[o,s[o]].concat(r));else{if(!e.test(s))return!0;for(var i=s.split(e),a=0,l=i.length;l>a;a++)t[n].apply(t,[i[a]].concat(r))}},n=function(e,t){var n,s=-1,r=e.length;switch(t.length){case 0:for(;r>++s;)(n=e[s]).callback.call(n.ctx);return;case 1:for(;r>++s;)(n=e[s]).callback.call(n.ctx,t[0]);return;case 2:for(;r>++s;)(n=e[s]).callback.call(n.ctx,t[0],t[1]);return;case 3:for(;r>++s;)(n=e[s]).callback.call(n.ctx,t[0],t[1],t[2]);return;default:for(;r>++s;)(n=e[s]).callback.apply(n.ctx,t)}},s={on:function(e,n,s){if(!t(this,"on",e,[n,s])||!n)return this;this._events||(this._events={});var r=this._events[e]||(this._events[e]=[]);return r.push({callback:n,context:s,ctx:s||this}),this},once:function(e,n,s){if(!t(this,"once",e,[n,s])||!n)return this;var r=this,o=_.once(function(){r.off(e,o),n.apply(this,arguments)});return o._callback=n,this.on(e,o,s),this},off:function(e,n,s){var r,o,i,a,l,u,c,h;if(!this._events||!t(this,"off",e,[n,s]))return this;if(!e&&!n&&!s)return this._events={},this;for(a=e?[e]:_.keys(this._events),l=0,u=a.length;u>l;l++)if(e=a[l],r=this._events[e]){if(i=[],n||s)for(c=0,h=r.length;h>c;c++)o=r[c],(n&&n!==o.callback&&n!==o.callback._callback||s&&s!==o.context)&&i.push(o);this._events[e]=i}return this},trigger:function(e){if(!this._events)return this;var s=Array.prototype.slice.call(arguments,1);if(!t(this,"trigger",e,s))return this;var r=this._events[e],o=this._events.all;return r&&n(r,s),o&&n(o,arguments),this},listenTo:function(e,t,n){var s=this._listeners||(this._listeners={}),r=e._listenerId||(e._listenerId=_.uniqueId("l"));return s[r]=e,e.on(t,"object"==typeof t?this:n,this),this},stopListening:function(e,t,n){var s=this._listeners;if(s){if(e)e.off(t,"object"==typeof t?this:n,this),t||n||delete s[e._listenerId];else{"object"==typeof t&&(n=this);for(var r in s)s[r].off(t,n,this);this._listeners={}}return this}}};return s.bind=s.on,s.unbind=s.off,s};return e()}(),function(){var e,t,n,s,r,o,i,a,l,u,c,h={}.hasOwnProperty,p=function(e,t){function n(){this.constructor=e}for(var s in t)h.call(t,s)&&(e[s]=t[s]);return n.prototype=t.prototype,e.prototype=new n,e.__super__=t.prototype,e},d=[].slice,f=[].indexOf||function(e){for(var t=0,n=this.length;n>t;t++)if(t in this&&this[t]===e)return t;return-1};e=jQuery,o=null!=(l=window._)?l:window.Messenger._,s=null!=(u="undefined"!=typeof Backbone&&null!==Backbone?Backbone.Events:void 0)?u:window.Messenger.Events,n=function(){function t(t){e.extend(this,s),o.isObject(t)&&(t.el&&this.setElement(t.el),this.model=t.model),this.initialize.apply(this,arguments)}return t.prototype.setElement=function(t){return this.$el=e(t),this.el=this.$el[0]},t.prototype.delegateEvents=function(e){var t,n,s,r,i,a,l;if(e||(e=o.result(this,"events"))){this.undelegateEvents(),t=/^(\S+)\s*(.*)$/,l=[];for(s in e){if(i=e[s],o.isFunction(i)||(i=this[e[s]]),!i)throw Error('Method "'+e[s]+'" does not exist');r=s.match(t),n=r[1],a=r[2],i=o.bind(i,this),n+=".delegateEvents"+this.cid,""===a?l.push(this.jqon(n,i)):l.push(this.jqon(n,a,i))}return l}},t.prototype.jqon=function(e,t,n){var s;return null!=this.$el.on?(s=this.$el).on.apply(s,arguments):(null==n&&(n=t,t=void 0),null!=t?this.$el.delegate(t,e,n):this.$el.bind(e,n))},t.prototype.jqoff=function(e){var t;return null!=this.$el.off?(t=this.$el).off.apply(t,arguments):(this.$el.undelegate(),this.$el.unbind(e))},t.prototype.undelegateEvents=function(){return this.jqoff(".delegateEvents"+this.cid)},t.prototype.remove=function(){return this.undelegateEvents(),this.$el.remove()},t}(),i=function(t){function n(){return n.__super__.constructor.apply(this,arguments)}return p(n,t),n.prototype.defaults={hideAfter:10,scroll:!0,closeButtonText:"&times;",escapeText:!1},n.prototype.initialize=function(t){return null==t&&(t={}),this.shown=!1,this.rendered=!1,this.messenger=t.messenger,this.options=e.extend({},this.options,t,this.defaults)},n.prototype.show=function(){var e;return this.rendered||this.render(),this.$message.removeClass("messenger-hidden"),e=this.shown,this.shown=!0,e?void 0:this.trigger("show")},n.prototype.hide=function(){var e;if(this.rendered)return this.$message.addClass("messenger-hidden"),e=this.shown,this.shown=!1,e?this.trigger("hide"):void 0},n.prototype.cancel=function(){return this.hide()},n.prototype.update=function(t){var n,s=this;return o.isString(t)&&(t={message:t}),e.extend(this.options,t),this.lastUpdate=new Date,this.rendered=!1,this.events=null!=(n=this.options.events)?n:{},this.render(),this.actionsToEvents(),this.delegateEvents(),this.checkClickable(),this.options.hideAfter?(this.$message.addClass("messenger-will-hide-after"),null!=this._hideTimeout&&clearTimeout(this._hideTimeout),this._hideTimeout=setTimeout(function(){return s.hide()},1e3*this.options.hideAfter)):this.$message.removeClass("messenger-will-hide-after"),this.options.hideOnNavigate?(this.$message.addClass("messenger-will-hide-on-navigate"),null!=("undefined"!=typeof Backbone&&null!==Backbone?Backbone.history:void 0)&&Backbone.history.on("route",function(){return s.hide()})):this.$message.removeClass("messenger-will-hide-on-navigate"),this.trigger("update",this)},n.prototype.scrollTo=function(){return this.options.scroll?e.scrollTo(this.$el,{duration:400,offset:{left:0,top:-20}}):void 0},n.prototype.timeSinceUpdate=function(){return this.lastUpdate?new Date-this.lastUpdate:null},n.prototype.actionsToEvents=function(){var e,t,n,s,r=this;n=this.options.actions,s=[];for(t in n)e=n[t],s.push(this.events['click [data-action="'+t+'"] a']=function(e){return function(n){return n.preventDefault(),n.stopPropagation(),r.trigger("action:"+t,e,n),e.action.call(r,n,r)}}(e));return s},n.prototype.checkClickable=function(){var e,t,n,s;n=this.events,s=[];for(t in n)e=n[t],"click"===t?s.push(this.$message.addClass("messenger-clickable")):s.push(void 0);return s},n.prototype.undelegateEvents=function(){var e;return n.__super__.undelegateEvents.apply(this,arguments),null!=(e=this.$message)?e.removeClass("messenger-clickable"):void 0},n.prototype.parseActions=function(){var t,n,s,r,o,i;n=[],o=this.options.actions;for(r in o)t=o[r],s=e.extend({},t),s.name=r,null==(i=s.label)&&(s.label=r),n.push(s);return n},n.prototype.template=function(t){var n,s,r,o,i,a,l,u,c,h,p=this;for(i=e("<div class='messenger-message message alert "+t.type+" message-"+t.type+" alert-"+t.type+"'>"),t.showCloseButton&&(r=e('<button type="button" class="messenger-close" data-dismiss="alert">'),r.html(t.closeButtonText),r.click(function(){var e;return p.cancel(),"function"==typeof(e=p.options).onClickClose&&e.onClickClose(),!0}),i.append(r)),a=t.escapeText?e('<div class="messenger-message-inner"></div>').text(t.message):e('<div class="messenger-message-inner">'+t.message+"</div>"),i.append(a),t.actions.length&&(s=e('<div class="messenger-actions">')),h=t.actions,u=0,c=h.length;c>u;u++)l=h[u],n=e("<span>"),n.attr("data-action",""+l.name),o=e("<a>"),o.html(l.label),n.append(e('<span class="messenger-phrase">')),n.append(o),s.append(n);return i.append(s),i},n.prototype.render=function(){var t;if(!this.rendered)return this._hasSlot||(this.setElement(this.messenger._reserveMessageSlot(this)),this._hasSlot=!0),t=e.extend({},this.options,{actions:this.parseActions()}),this.$message=e(this.template(t)),this.$el.html(this.$message),this.shown=!0,this.rendered=!0,this.trigger("render")},n}(n),r=function(e){function t(){return t.__super__.constructor.apply(this,arguments)}return p(t,e),t.prototype.initialize=function(){return t.__super__.initialize.apply(this,arguments),this._timers={}},t.prototype.cancel=function(){return this.clearTimers(),this.hide(),null!=this._actionInstance&&null!=this._actionInstance.abort?this._actionInstance.abort():void 0},t.prototype.clearTimers=function(){var e,t,n,s;n=this._timers;for(e in n)t=n[e],clearTimeout(t);return this._timers={},null!=(s=this.$message)?s.removeClass("messenger-retry-soon messenger-retry-later"):void 0},t.prototype.render=function(){var e,n,s,r;t.__super__.render.apply(this,arguments),this.clearTimers(),s=this.options.actions,r=[];for(n in s)e=s[n],e.auto?r.push(this.startCountdown(n,e)):r.push(void 0);return r},t.prototype.renderPhrase=function(e,t){var n;return n=e.phrase.replace("TIME",this.formatTime(t))},t.prototype.formatTime=function(e){var t;return t=function(e,t){return e=Math.floor(e),1!==e&&(t+="s"),"in "+e+" "+t},0===Math.floor(e)?"now...":60>e?t(e,"second"):(e/=60,60>e?t(e,"minute"):(e/=60,t(e,"hour")))},t.prototype.startCountdown=function(e,t){var n,s,r,o,i=this;if(null==this._timers[e])return n=this.$message.find("[data-action='"+e+"'] .messenger-phrase"),s=null!=(o=t.delay)?o:3,10>=s?(this.$message.removeClass("messenger-retry-later"),this.$message.addClass("messenger-retry-soon")):(this.$message.removeClass("messenger-retry-soon"),this.$message.addClass("messenger-retry-later")),r=function(){var o;return n.text(i.renderPhrase(t,s)),s>0?(o=Math.min(s,1),s-=o,i._timers[e]=setTimeout(r,1e3*o)):(i.$message.removeClass("messenger-retry-soon messenger-retry-later"),delete i._timers[e],t.action())},r()},t}(i),a=function(t){function n(){return n.__super__.constructor.apply(this,arguments)}return p(n,t),n.prototype.tagName="ul",n.prototype.className="messenger",n.prototype.messageDefaults={type:"info"},n.prototype.initialize=function(t){return this.options=null!=t?t:{},this.history=[],this.messageDefaults=e.extend({},this.messageDefaults,this.options.messageDefaults)},n.prototype.render=function(){return this.updateMessageSlotClasses()},n.prototype.findById=function(e){return o.filter(this.history,function(t){return t.msg.options.id===e})},n.prototype._reserveMessageSlot=function(t){var n,s,r=this;for(n=e("<li>"),n.addClass("messenger-message-slot"),this.$el.prepend(n),this.history.push({msg:t,$slot:n}),this._enforceIdConstraint(t),t.on("update",function(){return r._enforceIdConstraint(t)});this.options.maxMessages&&this.history.length>this.options.maxMessages;)s=this.history.shift(),s.msg.remove(),s.$slot.remove();return n},n.prototype._enforceIdConstraint=function(e){var t,n,s,r,o;if(null!=e.options.id)for(o=this.history,n=0,s=o.length;s>n;n++)if(t=o[n],r=t.msg,null!=r.options.id&&r.options.id===e.options.id&&e!==r){if(e.options.singleton)return e.hide(),void 0;r.hide()}},n.prototype.newMessage=function(e){var t,n,s,o,a=this;return null==e&&(e={}),e.messenger=this,i=null!=(n=null!=(s=Messenger.themes[null!=(o=e.theme)?o:this.options.theme])?s.Message:void 0)?n:r,t=new i(e),t.on("show",function(){return e.scrollTo&&"fixed"!==a.$el.css("position")?t.scrollTo():void 0}),t.on("hide show render",this.updateMessageSlotClasses,this),t},n.prototype.updateMessageSlotClasses=function(){var e,t,n,s,r,o,i;for(s=!0,t=null,e=!1,i=this.history,r=0,o=i.length;o>r;r++)n=i[r],n.$slot.removeClass("messenger-first messenger-last messenger-shown"),n.msg.shown&&n.msg.rendered&&(n.$slot.addClass("messenger-shown"),e=!0,t=n,s&&(s=!1,n.$slot.addClass("messenger-first")));return null!=t&&t.$slot.addClass("messenger-last"),this.$el[""+(e?"remove":"add")+"Class"]("messenger-empty")},n.prototype.hideAll=function(){var e,t,n,s,r;for(s=this.history,r=[],t=0,n=s.length;n>t;t++)e=s[t],r.push(e.msg.hide());return r},n.prototype.post=function(t){var n;return o.isString(t)&&(t={message:t}),t=e.extend(!0,{},this.messageDefaults,t),n=this.newMessage(t),n.update(t),n},n}(n),t=function(t){function n(){return n.__super__.constructor.apply(this,arguments)}return p(n,t),n.prototype.doDefaults={progressMessage:null,successMessage:null,errorMessage:"Error connecting to the server.",showSuccessWithoutError:!0,retry:{auto:!0,allow:!0},action:e.ajax},n.prototype.hookBackboneAjax=function(t){var n,s=this;if(null==t&&(t={}),null==window.Backbone)throw"Expected Backbone to be defined";return t=o.defaults(t,{id:"BACKBONE_ACTION",errorMessage:!1,successMessage:"Request completed successfully.",showSuccessWithoutError:!1}),n=function(e){var n;return n=o.extend({},t,e.messenger),s["do"](n,e)},null!=Backbone.ajax?(Backbone.ajax._withoutMessenger&&(Backbone.ajax=Backbone.ajax._withoutMessenger),(null==t.action||t.action===this.doDefaults.action)&&(t.action=Backbone.ajax),n._withoutMessenger=Backbone.ajax,Backbone.ajax=n):Backbone.sync=o.wrap(Backbone.sync,function(){var t,s,r;return r=arguments[0],t=arguments.length>=2?d.call(arguments,1):[],s=e.ajax,e.ajax=n,r.call.apply(r,[this].concat(d.call(t))),e.ajax=s})},n.prototype._getHandlerResponse=function(e){return e===!1?!1:e===!0||null==e?!0:e},n.prototype._parseEvents=function(e){var t,n,s,r,o,i,a;null==e&&(e={}),o={};for(r in e)s=e[r],n=r.indexOf(" "),i=r.substring(0,n),t=r.substring(n+1),null==(a=o[i])&&(o[i]={}),o[i][t]=s;return o},n.prototype._normalizeResponse=function(){var e,t,n,s,r,i,a;for(n=arguments.length>=1?d.call(arguments,0):[],s=null,r=null,e=null,i=0,a=n.length;a>i;i++)t=n[i],"success"===t||"timeout"===t||"abort"===t?s=t:null!=(null!=t?t.readyState:void 0)&&null!=(null!=t?t.responseText:void 0)?r=t:o.isObject(t)&&(e=t);return[s,e,r]},n.prototype.run=function(){var t,n,s,r,i,a,l,u,c,h,p,g=this;if(a=arguments[0],c=arguments[1],t=arguments.length>=3?d.call(arguments,2):[],null==c&&(c={}),a=e.extend(!0,{},this.messageDefaults,this.doDefaults,null!=a?a:{}),n=this._parseEvents(a.events),s=function(e,t){var n;return n=a[e+"Message"],o.isFunction(n)?n.call(g,e,t):n},l=null!=(p=a.messageInstance)?p:this.newMessage(a),null!=a.id&&(l.options.id=a.id),null!=a.progressMessage&&l.update(e.extend({},a,{message:s("progress",null),type:"info"})),i={},o.each(["error","success"],function(r){var u;return u=c[r],i[r]=function(){var i,h,p,m,y,v,_,w,b,x,C,M,k,$,E;return v=arguments.length>=1?d.call(arguments,0):[],b=g._normalizeResponse.apply(g,v),y=b[0],i=b[1],w=b[2],"success"===r&&null==l.errorCount&&a.showSuccessWithoutError===!1&&(a.successMessage=null),"error"===r&&(null==(x=a.errorCount)&&(a.errorCount=0),a.errorCount+=1),p=a.returnsPromise?v[0]:"function"==typeof u?u.apply(null,v):void 0,_=g._getHandlerResponse(p),o.isString(_)&&(_={message:_}),"error"!==r||0!==(null!=w?w.status:void 0)&&"abort"!==y?"error"===r&&null!=a.ignoredErrorCodes&&(C=null!=w?w.status:void 0,f.call(a.ignoredErrorCodes,C)>=0)?(l.hide(),void 0):(h={message:s(r,w),type:r,events:null!=(M=n[r])?M:{},hideOnNavigate:"success"===r},m=e.extend({},a,h,_),"number"==typeof(null!=(k=m.retry)?k.allow:void 0)&&m.retry.allow--,"error"===r&&(null!=w?w.status:void 0)>=500&&(null!=($=m.retry)?$.allow:void 0)?(null==m.retry.delay&&(m.retry.delay=4>m.errorCount?10:300),m.hideAfter&&(null==(E=m._hideAfter)&&(m._hideAfter=m.hideAfter),m.hideAfter=m._hideAfter+m.retry.delay),m._retryActions=!0,m.actions={retry:{label:"retry now",phrase:"Retrying TIME",auto:m.retry.auto,delay:m.retry.delay,action:function(){return m.messageInstance=l,setTimeout(function(){return g["do"].apply(g,[m,c].concat(d.call(t)))},0)}},cancel:{action:function(){return l.cancel()}}}):m._retryActions&&(delete m.actions.retry,delete m.actions.cancel,delete a._retryActions),l.update(m),_&&m.message?(Messenger(o.extend({},g.options,{instance:g})),l.show()):l.hide()):(l.hide(),void 0)}}),!a.returnsPromise)for(h in i)r=i[h],u=c[h],c[h]=r;return l._actionInstance=a.action.apply(a,[c].concat(d.call(t))),a.returnsPromise&&l._actionInstance.then(i.success,i.error),l},n.prototype["do"]=n.prototype.run,n.prototype.ajax=function(){var t,n;return n=arguments[0],t=arguments.length>=2?d.call(arguments,1):[],n.action=e.ajax,this.run.apply(this,[n].concat(d.call(t)))},n.prototype.expectPromise=function(e,t){return t=o.extend({},t,{action:e,returnsPromise:!0}),this.run(t)},n.prototype.error=function(e){return null==e&&(e={}),"string"==typeof e&&(e={message:e}),e.type="error",this.post(e)},n.prototype.info=function(e){return null==e&&(e={}),"string"==typeof e&&(e={message:e}),e.type="info",this.post(e)},n.prototype.success=function(e){return null==e&&(e={}),"string"==typeof e&&(e={message:e}),e.type="success",this.post(e)},n}(a),e.fn.messenger=function(){var n,s,r,i,l,u,c,h;return r=arguments[0],s=arguments.length>=2?d.call(arguments,1):[],null==r&&(r={}),n=this,null!=r&&o.isString(r)?(h=n.data("messenger"))[r].apply(h,s):(l=r,null==n.data("messenger")&&(a=null!=(u=null!=(c=Messenger.themes[l.theme])?c.Messenger:void 0)?u:t,n.data("messenger",i=new a(e.extend({el:n},l))),i.render()),n.data("messenger"))},window.Messenger._call=function(t){var n,s,r,o,i,a,l,u,c,h,p;if(a={extraClasses:"messenger-fixed messenger-on-bottom messenger-on-right",theme:"future",maxMessages:9,parentLocations:["body"]},t=e.extend(a,e._messengerDefaults,Messenger.options,t),null!=t.theme&&(t.extraClasses+=" messenger-theme-"+t.theme),l=t.instance||Messenger.instance,null==t.instance){for(c=t.parentLocations,s=null,r=null,h=0,p=c.length;p>h;h++)if(u=c[h],s=e(u),s.length){o=u;break}l?e(l._location).is(e(o))||(l.$el.detach(),s.prepend(l.$el)):(n=e("<ul>"),s.prepend(n),l=n.messenger(t),l._location=o,Messenger.instance=l)}return null!=l._addedClasses&&l.$el.removeClass(l._addedClasses),l.$el.addClass(i=""+l.className+" "+t.extraClasses),l._addedClasses=i,l},e.extend(Messenger,{Message:r,Messenger:t,themes:null!=(c=Messenger.themes)?c:{}}),e.globalMessenger=window.Messenger=Messenger}.call(this);

/***/ },

/***/ "./node_modules/messenger/build/js/messenger-theme-future.js":
/***/ function(module, exports) {

	(function() {
	  var $, FutureMessage, spinner_template,
	    __hasProp = {}.hasOwnProperty,
	    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };
	
	  $ = jQuery;
	
	  spinner_template = '<div class="messenger-spinner">\n    <span class="messenger-spinner-side messenger-spinner-side-left">\n        <span class="messenger-spinner-fill"></span>\n    </span>\n    <span class="messenger-spinner-side messenger-spinner-side-right">\n        <span class="messenger-spinner-fill"></span>\n    </span>\n</div>';
	
	  FutureMessage = (function(_super) {
	
	    __extends(FutureMessage, _super);
	
	    function FutureMessage() {
	      return FutureMessage.__super__.constructor.apply(this, arguments);
	    }
	
	    FutureMessage.prototype.template = function(opts) {
	      var $message;
	      $message = FutureMessage.__super__.template.apply(this, arguments);
	      $message.append($(spinner_template));
	      return $message;
	    };
	
	    return FutureMessage;
	
	  })(window.Messenger.Message);
	
	  window.Messenger.themes.future = {
	    Message: FutureMessage
	  };
	
	}).call(this);


/***/ },

/***/ "./node_modules/jquery.kinetic/jquery.kinetic.js":
/***/ function(module, exports) {

	/**
	 jQuery.kinetic v2.2.4
	 Dave Taylor http://davetayls.me
	
	 @license The MIT License (MIT)
	 @preserve Copyright (c) 2012 Dave Taylor http://davetayls.me
	 */
	(function ($){
	  'use strict';
	
	  var ACTIVE_CLASS = 'kinetic-active';
	
	  /**
	   * Provides requestAnimationFrame in a cross browser way.
	   * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	   */
	  if (!window.requestAnimationFrame){
	
	    window.requestAnimationFrame = ( function (){
	
	      return window.webkitRequestAnimationFrame ||
	        window.mozRequestAnimationFrame ||
	        window.oRequestAnimationFrame ||
	        window.msRequestAnimationFrame ||
	        function (/* function FrameRequestCallback */ callback, /* DOMElement Element */ element){
	          window.setTimeout(callback, 1000 / 60);
	        };
	
	    }());
	
	  }
	
	  // add touch checker to jQuery.support
	  $.support = $.support || {};
	  $.extend($.support, {
	    touch: 'ontouchend' in document
	  });
	
	
	  // KINETIC CLASS DEFINITION
	  // ======================
	
	  var Kinetic = function (element, settings) {
	    this.settings = settings;
	    this.el       = element;
	    this.$el      = $(element);
	
	    this._initElements();
	
	    return this;
	  };
	
	  Kinetic.DATA_KEY = 'kinetic';
	  Kinetic.DEFAULTS = {
	    cursor: 'move',
	    decelerate: true,
	    triggerHardware: false,
	    threshold: 0,
	    y: true,
	    x: true,
	    slowdown: 0.9,
	    maxvelocity: 40,
	    throttleFPS: 60,
	    invert: false,
	    movingClass: {
	      up: 'kinetic-moving-up',
	      down: 'kinetic-moving-down',
	      left: 'kinetic-moving-left',
	      right: 'kinetic-moving-right'
	    },
	    deceleratingClass: {
	      up: 'kinetic-decelerating-up',
	      down: 'kinetic-decelerating-down',
	      left: 'kinetic-decelerating-left',
	      right: 'kinetic-decelerating-right'
	    }
	  };
	
	
	  // Public functions
	
	  Kinetic.prototype.start = function (options){
	    this.settings = $.extend(this.settings, options);
	    this.velocity = options.velocity || this.velocity;
	    this.velocityY = options.velocityY || this.velocityY;
	    this.settings.decelerate = false;
	    this._move();
	  };
	
	  Kinetic.prototype.end = function (){
	    this.settings.decelerate = true;
	  };
	
	  Kinetic.prototype.stop = function (){
	    this.velocity = 0;
	    this.velocityY = 0;
	    this.settings.decelerate = true;
	    if ($.isFunction(this.settings.stopped)){
	      this.settings.stopped.call(this);
	    }
	  };
	
	  Kinetic.prototype.detach = function (){
	    this._detachListeners();
	    this.$el
	      .removeClass(ACTIVE_CLASS)
	      .css('cursor', '');
	  };
	
	
	  Kinetic.prototype.attach = function (){
	    if (this.$el.hasClass(ACTIVE_CLASS)) {
	      return;
	    }
	    this._attachListeners(this.$el);
	    this.$el
	      .addClass(ACTIVE_CLASS)
	      .css('cursor', this.settings.cursor);
	  };
	
	
	  Kinetic.prototype.destroy = function (){
	    this.detach();
	    this.$el=null;
	    this.el=null;
	    this.settings=null;
	  };
	
	
	  // Internal functions
	
	  Kinetic.prototype._initElements = function (){
	    this.$el.addClass(ACTIVE_CLASS);
	
	    $.extend(this, {
	      xpos: null,
	      prevXPos: false,
	      ypos: null,
	      prevYPos: false,
	      mouseDown: false,
	      throttleTimeout: 1000 / this.settings.throttleFPS,
	      lastMove: null,
	      elementFocused: null
	    });
	
	    this.velocity = 0;
	    this.velocityY = 0;
	
	    // make sure we reset everything when mouse up
	    $(document)
	      .mouseup($.proxy(this._resetMouse, this))
	      .click($.proxy(this._resetMouse, this));
	
	    this._initEvents();
	
	    this.$el.css('cursor', this.settings.cursor);
	
	    if (this.settings.triggerHardware){
	      this.$el.css({
	        '-webkit-transform': 'translate3d(0,0,0)',
	        '-webkit-perspective': '1000',
	        '-webkit-backface-visibility': 'hidden'
	      });
	    }
	  };
	
	  Kinetic.prototype._initEvents = function(){
	    var self = this;
	    this.settings.events = {
	      touchStart: function (e){
	        var touch;
	        if (self._useTarget(e.target, e)){
	          touch = e.originalEvent.touches[0];
	          self.threshold = self._threshold(e.target, e);
	          self._start(touch.clientX, touch.clientY);
	          e.stopPropagation();
	        }
	      },
	      touchMove: function (e){
	        var touch;
	        if (self.mouseDown){
	          touch = e.originalEvent.touches[0];
	          self._inputmove(touch.clientX, touch.clientY);
	          if (e.preventDefault){
	            e.preventDefault();
	          }
	        }
	      },
	      inputDown: function (e){
	        if (self._useTarget(e.target, e)){
	          self.threshold = self._threshold(e.target, e);
	          self._start(e.clientX, e.clientY);
	          self.elementFocused = e.target;
	          if (e.target.nodeName === 'IMG'){
	            e.preventDefault();
	          }
	          e.stopPropagation();
	        }
	      },
	      inputEnd: function (e){
	        if (self._useTarget(e.target, e)){
	          self._end();
	          self.elementFocused = null;
	          if (e.preventDefault){
	            e.preventDefault();
	          }
	        }
	      },
	      inputMove: function (e){
	        if (self.mouseDown){
	          self._inputmove(e.clientX, e.clientY);
	          if (e.preventDefault){
	            e.preventDefault();
	          }
	        }
	      },
	      scroll: function (e){
	        if ($.isFunction(self.settings.moved)){
	          self.settings.moved.call(self, self.settings);
	        }
	        if (e.preventDefault){
	          e.preventDefault();
	        }
	      },
	      inputClick: function (e){
	        if (Math.abs(self.velocity) > 0){
	          e.preventDefault();
	          return false;
	        }
	      },
	      // prevent drag and drop images in ie
	      dragStart: function (e){
	        if (self._useTarget(e.target, e) && self.elementFocused){
	          return false;
	        }
	      },
	      // prevent selection when dragging
	      selectStart: function (e){
	        if ($.isFunction(self.settings.selectStart)){
	          return self.settings.selectStart.apply(self, arguments);
	        } else if (self._useTarget(e.target, e)) {
	          return false;
	        }
	      }
	    };
	
	    this._attachListeners(this.$el, this.settings);
	
	  };
	
	  Kinetic.prototype._inputmove = function (clientX, clientY){
	    var $this = this.$el;
	    var el = this.el;
	
	    if (!this.lastMove || new Date() > new Date(this.lastMove.getTime() + this.throttleTimeout)){
	      this.lastMove = new Date();
	
	      if (this.mouseDown && (this.xpos || this.ypos)){
	        var movedX = (clientX - this.xpos);
	        var movedY = (clientY - this.ypos);
	        if (this.settings.invert) {
	          movedX *= -1;
	          movedY *= -1;
	        }
	        if(this.threshold > 0){
	          var moved = Math.sqrt(movedX * movedX + movedY * movedY);
	          if(this.threshold > moved){
	            return;
	          } else {
	            this.threshold = 0;
	          }
	        }
	        if (this.elementFocused){
	          $(this.elementFocused).blur();
	          this.elementFocused = null;
	          $this.focus();
	        }
	
	        this.settings.decelerate = false;
	        this.velocity = this.velocityY = 0;
	
	        var scrollLeft = this.scrollLeft();
	        var scrollTop = this.scrollTop();
	
	        this.scrollLeft(this.settings.x ? scrollLeft - movedX : scrollLeft);
	        this.scrollTop(this.settings.y ? scrollTop - movedY : scrollTop);
	
	        this.prevXPos = this.xpos;
	        this.prevYPos = this.ypos;
	        this.xpos = clientX;
	        this.ypos = clientY;
	
	        this._calculateVelocities();
	        this._setMoveClasses(this.settings.movingClass);
	
	        if ($.isFunction(this.settings.moved)){
	          this.settings.moved.call(this, this.settings);
	        }
	      }
	    }
	  };
	
	  Kinetic.prototype._calculateVelocities = function (){
	    this.velocity = this._capVelocity(this.prevXPos - this.xpos, this.settings.maxvelocity);
	    this.velocityY = this._capVelocity(this.prevYPos - this.ypos, this.settings.maxvelocity);
	    if (this.settings.invert) {
	      this.velocity *= -1;
	      this.velocityY *= -1;
	    }
	  };
	
	  Kinetic.prototype._end = function (){
	    if (this.xpos && this.prevXPos && this.settings.decelerate === false){
	      this.settings.decelerate = true;
	      this._calculateVelocities();
	      this.xpos = this.prevXPos = this.mouseDown = false;
	      this._move();
	    }
	  };
	
	  Kinetic.prototype._useTarget = function (target, event){
	    if ($.isFunction(this.settings.filterTarget)){
	      return this.settings.filterTarget.call(this, target, event) !== false;
	    }
	    return true;
	  };
	
	  Kinetic.prototype._threshold = function (target, event){
	    if ($.isFunction(this.settings.threshold)){
	      return this.settings.threshold.call(this, target, event);
	    }
	    return this.settings.threshold;
	  };
	
	  Kinetic.prototype._start = function (clientX, clientY){
	    this.mouseDown = true;
	    this.velocity = this.prevXPos = 0;
	    this.velocityY = this.prevYPos = 0;
	    this.xpos = clientX;
	    this.ypos = clientY;
	  };
	
	  Kinetic.prototype._resetMouse = function (){
	    this.xpos = false;
	    this.ypos = false;
	    this.mouseDown = false;
	  };
	
	  Kinetic.prototype._decelerateVelocity = function (velocity, slowdown){
	    return Math.floor(Math.abs(velocity)) === 0 ? 0 // is velocity less than 1?
	      : velocity * slowdown; // reduce slowdown
	  };
	
	  Kinetic.prototype._capVelocity = function (velocity, max){
	    var newVelocity = velocity;
	    if (velocity > 0){
	      if (velocity > max){
	        newVelocity = max;
	      }
	    } else {
	      if (velocity < (0 - max)){
	        newVelocity = (0 - max);
	      }
	    }
	    return newVelocity;
	  };
	
	  Kinetic.prototype._setMoveClasses = function (classes){
	    // FIXME: consider if we want to apply PL #44, this should not remove
	    // classes we have not defined on the element!
	    var settings = this.settings;
	    var $this = this.$el;
	
	    $this.removeClass(settings.movingClass.up)
	      .removeClass(settings.movingClass.down)
	      .removeClass(settings.movingClass.left)
	      .removeClass(settings.movingClass.right)
	      .removeClass(settings.deceleratingClass.up)
	      .removeClass(settings.deceleratingClass.down)
	      .removeClass(settings.deceleratingClass.left)
	      .removeClass(settings.deceleratingClass.right);
	
	    if (this.velocity > 0){
	      $this.addClass(classes.right);
	    }
	    if (this.velocity < 0){
	      $this.addClass(classes.left);
	    }
	    if (this.velocityY > 0){
	      $this.addClass(classes.down);
	    }
	    if (this.velocityY < 0){
	      $this.addClass(classes.up);
	    }
	
	  };
	
	
	  // do the actual kinetic movement
	  Kinetic.prototype._move = function (){
	    var $scroller = this._getScroller();
	    var scroller = $scroller[0];
	    var self = this;
	    var settings = self.settings;
	
	    // set scrollLeft
	    if (settings.x && scroller.scrollWidth > 0){
	      this.scrollLeft(this.scrollLeft() + this.velocity);
	      if (Math.abs(this.velocity) > 0){
	        this.velocity = settings.decelerate ?
	          self._decelerateVelocity(this.velocity, settings.slowdown) : this.velocity;
	      }
	    } else {
	      this.velocity = 0;
	    }
	
	    // set scrollTop
	    if (settings.y && scroller.scrollHeight > 0){
	      this.scrollTop(this.scrollTop() + this.velocityY);
	      if (Math.abs(this.velocityY) > 0){
	        this.velocityY = settings.decelerate ?
	          self._decelerateVelocity(this.velocityY, settings.slowdown) : this.velocityY;
	      }
	    } else {
	      this.velocityY = 0;
	    }
	
	    self._setMoveClasses(settings.deceleratingClass);
	
	    if ($.isFunction(settings.moved)){
	      settings.moved.call(this, settings);
	    }
	
	    if (Math.abs(this.velocity) > 0 || Math.abs(this.velocityY) > 0){
	      if (!this.moving) {
	        this.moving = true;
	        // tick for next movement
	        window.requestAnimationFrame(function (){
	          self.moving = false;
	          self._move();
	        });
	      }
	    } else {
	      self.stop();
	    }
	  };
	
	  // get current scroller to apply positioning to
	  Kinetic.prototype._getScroller = function(){
	    var $scroller = this.$el;
	    if (this.$el.is('body') || this.$el.is('html')){
	      $scroller = $(window);
	    }
	    return $scroller;
	  };
	
	  // set the scroll position
	  Kinetic.prototype.scrollLeft = function(left){
	    var $scroller = this._getScroller();
	    if (typeof left === 'number'){
	      $scroller.scrollLeft(left);
	      this.settings.scrollLeft = left;
	    } else {
	      return $scroller.scrollLeft();
	    }
	  };
	  Kinetic.prototype.scrollTop = function(top){
	    var $scroller = this._getScroller();
	    if (typeof top === 'number'){
	      $scroller.scrollTop(top);
	      this.settings.scrollTop = top;
	    } else {
	      return $scroller.scrollTop();
	    }
	  };
	
	  Kinetic.prototype._attachListeners = function (){
	    var $this = this.$el;
	    var settings = this.settings;
	
	    if ($.support.touch){
	      $this
	        .bind('touchstart', settings.events.touchStart)
	        .bind('touchend', settings.events.inputEnd)
	        .bind('touchmove', settings.events.touchMove);
	    }
	    
	    $this
	      .mousedown(settings.events.inputDown)
	      .mouseup(settings.events.inputEnd)
	      .mousemove(settings.events.inputMove);
	
	    $this
	      .click(settings.events.inputClick)
	      .scroll(settings.events.scroll)
	      .bind('selectstart', settings.events.selectStart)
	      .bind('dragstart', settings.events.dragStart);
	  };
	
	  Kinetic.prototype._detachListeners = function (){
	    var $this = this.$el;
	    var settings = this.settings;
	    if ($.support.touch){
	      $this
	        .unbind('touchstart', settings.events.touchStart)
	        .unbind('touchend', settings.events.inputEnd)
	        .unbind('touchmove', settings.events.touchMove);
	    }
	
	    $this
	      .unbind('mousedown', settings.events.inputDown)
	      .unbind('mouseup', settings.events.inputEnd)
	      .unbind('mousemove', settings.events.inputMove);
	
	    $this
	      .unbind('click', settings.events.inputClick)
	      .unbind('scroll', settings.events.scroll)
	      .unbind('selectstart', settings.events.selectStart)
	      .unbind('dragstart', settings.events.dragStart);
	  };
	
	
	  // EXPOSE KINETIC CONSTRUCTOR
	  // ==========================
	  $.Kinetic = Kinetic;
	
	  // KINETIC PLUGIN DEFINITION
	  // =======================
	
	  $.fn.kinetic = function (option, callOptions) {
	    return this.each(function () {
	      var $this    = $(this);
	      var instance = $this.data(Kinetic.DATA_KEY);
	      var options  = $.extend({}, Kinetic.DEFAULTS, $this.data(), typeof option === 'object' && option);
	
	      if (!instance) {
	        $this.data(Kinetic.DATA_KEY, (instance = new Kinetic(this, options)));
	      }
	
	      if (typeof option === 'string') {
	        instance[option](callOptions);
	      }
	
	    });
	  };
	
	}(window.jQuery || window.Zepto));
	


/***/ },

/***/ "./node_modules/lodash/_arrayIncludesWith.js":
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }

});


/** WEBPACK FOOTER **
 ** app_92345c50a32afe8bfef9.js
 **/